import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends " $fragmentName" | "__typename"
              ? T[P]
              : never;
      };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** AppStoredEntityFieldValue */
    AppStoredCustomEntityFieldValue: { input: any; output: any };
    /** AppStoredEntityFieldValue */
    AppStoredEntityFieldValue: { input: any; output: any };
    /** A scalar that can represent arbitrary-precision signed decimal numbers based on the JVMs [BigDecimal](https://docs.oracle.com/javase/8/docs/api/java/math/BigDecimal.html) */
    BigDecimal: { input: any; output: any };
    /** Supported colors in the Palette */
    CardPaletteColor: { input: any; output: any };
    /** CardTypeHierarchyLevelType */
    CardTypeHierarchyLevelType: { input: any; output: any };
    /** A date scalar that accepts string values that are in yyyy-mm-dd format */
    Date: { input: any; output: any };
    /** A scalar representing a specific point in time. */
    DateTime: { input: any; output: any };
    /**
     * A scalar that enables us to spike [3D](https://relay.dev/docs/glossary/#3d) aka data-driven dependencies
     * This scalar is a requirement for using @match and @module directive supported by Relay GraphQL client
     * Please talk to #uip-app-framework before using this.
     * The definition of the scalar is yet to be decided based on spike insights.
     * To learn about current state see https://go.atlassian.com/JSDependency
     * DO NOT USE: Platform teams are iterating on the final shape of data returned
     */
    JSDependency: { input: any; output: any };
    /**
     * The `JSON` scalar type represents JSON values as specified
     * by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf).
     *
     * Note to schema designers - use this scalar with caution as the resultant data becomes untyped
     * from a consumers point of view.  There are legitimate use cases for this scalar type
     * but it SHOULD not be a common scalar.
     */
    JSON: { input: any; output: any };
    /** A scalar that is a 64-bit signed Java primitive data type. Its range is -2^63 to 2^63 – 1 */
    Long: { input: any; output: any };
    /** MercuryJSONString */
    MercuryJSONString: { input: any; output: any };
    /** SoftwareBoardFeatureKey */
    SoftwareBoardFeatureKey: { input: any; output: any };
    /** SoftwareBoardPermission */
    SoftwareBoardPermission: { input: any; output: any };
    /** SprintScopeChangeEventType */
    SprintScopeChangeEventType: { input: any; output: any };
    /**
     * A unique short string that can be used to fetch a board, card, etc. It's
     * usually used as a part of the entity URL. In some cases can be used as
     * as the ID.
     */
    TrelloShortLink: { input: any; output: any };
    /** An URL scalar that accepts string values like [https://www.w3.org/Addressing/URL/url-spec.txt]( https://www.w3.org/Addressing/URL/url-spec.txt) */
    URL: { input: any; output: any };
    /** UUID */
    UUID: { input: any; output: any };
};

export type AiConfigResponse = {
    __typename?: "AIConfigResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isRovoEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum AcceptableResponse {
    False = "FALSE",
    NotApplicable = "NOT_APPLICABLE",
    True = "TRUE"
}

export enum AccessStatus {
    AnonymousAccess = "ANONYMOUS_ACCESS",
    ExternalCollaboratorAccess = "EXTERNAL_COLLABORATOR_ACCESS",
    ExternalShareAccess = "EXTERNAL_SHARE_ACCESS",
    LicensedAdminAccess = "LICENSED_ADMIN_ACCESS",
    LicensedUseAccess = "LICENSED_USE_ACCESS",
    NotPermitted = "NOT_PERMITTED",
    UnlicensedAuthenticatedAccess = "UNLICENSED_AUTHENTICATED_ACCESS"
}

export enum AccessType {
    Edit = "EDIT",
    View = "VIEW"
}

/**
 * "
 * The lifecycle status of the account
 */
export enum AccountStatus {
    /** The account is an active account */
    Active = "active",
    /** The account has been closed */
    Closed = "closed",
    /** The account is no longer an active account */
    Inactive = "inactive"
}

export enum AccountType {
    App = "APP",
    Atlassian = "ATLASSIAN",
    Customer = "CUSTOMER",
    Unknown = "UNKNOWN"
}

export type Actions = {
    __typename?: "Actions";
    /**
     * Fetch a list of actions grouped by the apps that implement them
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    actionableApps?: Maybe<ActionsActionableAppConnection>;
};

export type ActionsActionableAppsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<ActionsActionableAppsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    workspace?: InputMaybe<Scalars["String"]["input"]>;
};

/** An action that an app implements */
export type ActionsAction = {
    __typename?: "ActionsAction";
    /** The key of the action type */
    actionType: Scalars["String"]["output"];
    /** What kind of CRUD operation this action is doing */
    actionVerb?: Maybe<Scalars["String"]["output"]>;
    /** The version of the action */
    actionVersion?: Maybe<Scalars["String"]["output"]>;
    /** Authentication types supported for an action */
    auth: Array<ActionsAuthType>;
    /** A description of what the action does. Is split to contain a default human readable message and an AI prompt. */
    description?: Maybe<ActionsDescription>;
    /** Capabilities the action is enabled for (e.g. AI, automation) */
    enabledCapabilities?: Maybe<Array<Maybe<ActionsCapabilityType>>>;
    /** The extension ARI used to identify a Forge action */
    extensionAri?: Maybe<Scalars["String"]["output"]>;
    /** Icon url for action to be used in UI */
    icon?: Maybe<Scalars["String"]["output"]>;
    /** The identifier of an action */
    id?: Maybe<Scalars["String"]["output"]>;
    /** Inputs required to execute this action */
    inputs?: Maybe<Array<ActionsActionInputTuple>>;
    /** Set when an action has destructive or consequential side effects */
    isConsequential: Scalars["Boolean"]["output"];
    /** The name of the Action */
    name?: Maybe<Scalars["String"]["output"]>;
    /** outputs returned by this action */
    outputs?: Maybe<Array<ActionsActionTypeOutputTuple>>;
    /**
     * Defines what parameters are required & validation rules
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ActionsScalingActionsSchema")' query directive to the 'schema' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    schema?: Maybe<ActionsActionConfiguration>;
    /** The inputs which are required to identify the resource */
    target?: Maybe<ActionsTargetInputs>;
    /**
     * Defines the order that parameters should be presented in
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ActionsScalingActionsUiSchema")' query directive to the 'uiSchema' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    uiSchema?: Maybe<ActionsConfigurationUiSchema>;
};

export type ActionsActionConfiguration = {
    __typename?: "ActionsActionConfiguration";
    properties?: Maybe<Array<ActionsActionConfigurationKeyValuePair>>;
    type: Scalars["String"]["output"];
};

export type ActionsActionConfigurationKeyValuePair = {
    __typename?: "ActionsActionConfigurationKeyValuePair";
    key: Scalars["String"]["output"];
    value: ActionsActionConfigurationParameter;
};

/** Defines validation for action parameters */
export type ActionsActionConfigurationParameter = {
    __typename?: "ActionsActionConfigurationParameter";
    default?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    format?: Maybe<Scalars["String"]["output"]>;
    maximum?: Maybe<Scalars["Int"]["output"]>;
    minimum?: Maybe<Scalars["Int"]["output"]>;
    required: Scalars["Boolean"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
    type: Scalars["String"]["output"];
};

export type ActionsActionInput = {
    __typename?: "ActionsActionInput";
    default?: Maybe<Scalars["JSON"]["output"]>;
    description?: Maybe<ActionsDescription>;
    fetchAction?: Maybe<ActionsAction>;
    items?: Maybe<ActionsActionInputItems>;
    pattern?: Maybe<Scalars["String"]["output"]>;
    required: Scalars["Boolean"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
    type: Scalars["String"]["output"];
};

export type ActionsActionInputItems = {
    __typename?: "ActionsActionInputItems";
    type: Scalars["String"]["output"];
};

export type ActionsActionInputTuple = {
    __typename?: "ActionsActionInputTuple";
    key: Scalars["String"]["output"];
    value: ActionsActionInput;
};

/** A type of action that an app can implement */
export type ActionsActionType = {
    __typename?: "ActionsActionType";
    /** The type of entity this action operates on */
    contextEntityType?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Description of the action */
    description?: Maybe<ActionsDescription>;
    /** A user friendly name that can be displayed on the UI for this action */
    displayName: Scalars["String"]["output"];
    /** Capabilities the action is enabled for (e.g. AI, automation) */
    enabledCapabilities?: Maybe<Array<Maybe<ActionsCapabilityType>>>;
    /** The property of the main entity that has been updated as a result of the action */
    entityProperty?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** The type of entities that this action can be executed on */
    entityType?: Maybe<Scalars["String"]["output"]>;
    /** Inputs required to execute this action */
    inputs?: Maybe<Array<ActionsActionInputTuple>>;
    key: Scalars["String"]["output"];
    /** outputs returned by this action */
    outputs?: Maybe<Array<ActionsActionTypeOutputTuple>>;
};

export type ActionsActionTypeOutput = {
    __typename?: "ActionsActionTypeOutput";
    description?: Maybe<Scalars["String"]["output"]>;
    nullable: Scalars["Boolean"]["output"];
    type: Scalars["String"]["output"];
};

export type ActionsActionTypeOutputTuple = {
    __typename?: "ActionsActionTypeOutputTuple";
    key: Scalars["String"]["output"];
    value: ActionsActionTypeOutput;
};

/** An app and the actions it supports */
export type ActionsActionableApp = {
    __typename?: "ActionsActionableApp";
    /** The actions supported by this app */
    actions?: Maybe<Array<Maybe<ActionsAction>>>;
    /** Definition ID of the app */
    appDefinitionId?: Maybe<Scalars["String"]["output"]>;
    /** External identifier of the app */
    appId?: Maybe<Scalars["String"]["output"]>;
    /** The integration key for first-party integrations, e.g. Confluence, Bitbucket */
    integrationKey?: Maybe<Scalars["String"]["output"]>;
    /** Name of the app */
    name: Scalars["String"]["output"];
    /** ClientID this app uses on its requests */
    oauthClientId?: Maybe<Scalars["String"]["output"]>;
};

export type ActionsActionableAppConnection = {
    __typename?: "ActionsActionableAppConnection";
    /** The action types implemented by the apps in this page */
    actionTypes?: Maybe<Array<ActionsActionType>>;
    edges?: Maybe<Array<Maybe<ActionsActionableAppEdge>>>;
    pageInfo: PageInfo;
};

export type ActionsActionableAppEdge = {
    __typename?: "ActionsActionableAppEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ActionsActionableApp>;
};

export type ActionsActionableAppsFilter = {
    /** Only an action that match this actionId will be returned */
    byActionId?: InputMaybe<Scalars["String"]["input"]>;
    /** Types of actions to be returned. Any action that matches types in this list will be returned. */
    byActionType?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only actions for the given actionVerb will be returned. */
    byActionVerb?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only an action that match this actionVersion will be returned */
    byActionVersion?: InputMaybe<Scalars["String"]["input"]>;
    /** Only actions with the given capability will be returned. */
    byCapability?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only actions with the context entity will be returned. */
    byContextEntityType?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only actions acting on the entity property will be returned. */
    byEntityProperty?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only actions for the given entity types will be returned. */
    byEntityType?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only actions for the given forge environment ID will be returned. Actions without an extension ARI will not be returned */
    byEnvironmentId?: InputMaybe<Scalars["String"]["input"]>;
    /** Only actions for the given extensionAri will be returned. */
    byExtensionAri?: InputMaybe<Scalars["String"]["input"]>;
    /** Only actions for the specified integrations will be returned. */
    byIntegrationKey?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only actions for the given providers will be returned. */
    byProviderID?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum ActionsAuthType {
    /** actions that support THREE_LEGGED authentication can be executed with a user in context */
    ThreeLegged = "THREE_LEGGED",
    /** actions that support TWO_LEGGED authentication can be executed without user in context */
    TwoLegged = "TWO_LEGGED"
}

export enum ActionsCapabilityType {
    /** Actions Enabled for Automation */
    Automation = "AUTOMATION"
}

export enum ActionsConfigurationLayout {
    VerticalLayout = "VerticalLayout"
}

export type ActionsConfigurationLayoutItem = {
    __typename?: "ActionsConfigurationLayoutItem";
    /** JSON string that contains a dictionary of additional presentation properties. Key=string, value=boolean. */
    options?: Maybe<Scalars["String"]["output"]>;
    scope: Scalars["String"]["output"];
    type: Scalars["String"]["output"];
};

export type ActionsConfigurationUiSchema = {
    __typename?: "ActionsConfigurationUiSchema";
    /** Defines order of parameters for the presentation layer */
    elements?: Maybe<Array<Maybe<ActionsConfigurationLayoutItem>>>;
    type: ActionsConfigurationLayout;
};

/** Description for the action or action input */
export type ActionsDescription = {
    __typename?: "ActionsDescription";
    /** A description overriding the default when used in context of AI */
    ai?: Maybe<Scalars["String"]["output"]>;
    /** The default description */
    default: Scalars["String"]["output"];
};

export type ActionsExecuteActionFilter = {
    /** Only execute actions for given actionId */
    actionId?: InputMaybe<Scalars["String"]["input"]>;
    /** Only execute action that matches the given ari */
    extensionAri?: InputMaybe<Scalars["String"]["input"]>;
    /** Only execute actions for the given first-party integration */
    integrationKey?: InputMaybe<Scalars["String"]["input"]>;
    /** Only execute actions for the given clients */
    oauthClientId?: InputMaybe<Scalars["String"]["input"]>;
    /** Only execute actions for the given providers */
    providerAri?: InputMaybe<Scalars["String"]["input"]>;
    /** Only execute actions for the given providerId */
    providerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActionsExecuteActionInput = {
    /** Cloud ID of the site to execute action on */
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    /** Inputs required to execute the action */
    inputs?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Target inputs required to identify the resource */
    target?: InputMaybe<ActionsExecuteTargetInput>;
};

export type ActionsExecuteResponse = {
    __typename?: "ActionsExecuteResponse";
    /** Outputs from the app that executed the action */
    outputs?: Maybe<Scalars["JSON"]["output"]>;
    status?: Maybe<Scalars["Int"]["output"]>;
};

export type ActionsExecuteResponseBulk = {
    __typename?: "ActionsExecuteResponseBulk";
    /** List of responses for each action executed in bulk */
    outputsList?: Maybe<Scalars["JSON"]["output"]>;
    /** Overall status of the bulk execution */
    status?: Maybe<Scalars["Int"]["output"]>;
};

export type ActionsExecuteTargetInput = {
    ari?: InputMaybe<Scalars["String"]["input"]>;
    ids?: InputMaybe<Scalars["JSON"]["input"]>;
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActionsMutation = {
    __typename?: "ActionsMutation";
    /**
     * Execute an action given the action type and return the execution status
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    execute?: Maybe<ActionsExecuteResponse>;
    /**
     * Execute multiple actions in bulk given a list of action inputs and return the execution statuses
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    executeBulk?: Maybe<ActionsExecuteResponseBulk>;
};

export type ActionsMutationExecuteArgs = {
    actionInput: ActionsExecuteActionInput;
    actionTypeKey?: InputMaybe<Scalars["String"]["input"]>;
    filter: ActionsExecuteActionFilter;
    workspace?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActionsMutationExecuteBulkArgs = {
    actionInputsList: Array<ActionsExecuteActionInput>;
    actionTypeKey?: InputMaybe<Scalars["String"]["input"]>;
    filter: ActionsExecuteActionFilter;
    workspace?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActionsTargetAri = {
    __typename?: "ActionsTargetAri";
    ati?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<ActionsDescription>;
};

export type ActionsTargetAriInput = {
    __typename?: "ActionsTargetAriInput";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<ActionsTargetAri>;
};

export type ActionsTargetId = {
    __typename?: "ActionsTargetId";
    description?: Maybe<ActionsDescription>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ActionsTargetIdInput = {
    __typename?: "ActionsTargetIdInput";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<ActionsTargetId>;
};

export type ActionsTargetInputs = {
    __typename?: "ActionsTargetInputs";
    ari?: Maybe<Array<Maybe<ActionsTargetAriInput>>>;
    id?: Maybe<Array<Maybe<ActionsTargetIdInput>>>;
};

export type ActivatePaywallContentInput = {
    contentIdToActivate: Scalars["ID"]["input"];
    deactivationIdentifier?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActivatePaywallContentPayload = Payload & {
    __typename?: "ActivatePaywallContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<MutationError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** --------------------------------------- activity_api_v2.graphqls */
export type Activities = {
    __typename?: "Activities";
    /**
     * get all activity
     * - filters - query filters for the activity stream
     * - first - show 1st <N> items of the response
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    all: ActivitiesConnection;
    /**
     * get activity for the currently logged in user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    myActivities?: Maybe<MyActivities>;
    /**
     * get "Worked on" activity
     * - filters - query filters for the activity stream
     * - first - show 1st <N> items of the response
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workedOn: ActivitiesConnection;
};

/** --------------------------------------- activity_api_v2.graphqls */
export type ActivitiesAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filters?: InputMaybe<Array<ActivitiesFilter>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** --------------------------------------- activity_api_v2.graphqls */
export type ActivitiesWorkedOnArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filters?: InputMaybe<Array<ActivitiesFilter>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActivitiesArguments = {
    /** set of Atlassian account IDs */
    accountIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** set of Cloud IDs */
    cloudIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** set of Container IDs */
    containerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The creation time of the earliest events to be included in the result */
    earliestStart?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** set of Event Types */
    eventTypes?: InputMaybe<Array<ActivityEventType>>;
    /** The creation time of the latest events to be included in the result */
    latestStart?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** set of Object Types */
    objectTypes?: InputMaybe<Array<ActivitiesObjectType>>;
    /** set of products */
    products?: InputMaybe<Array<ActivityProduct>>;
    /** arbitrary transition filters */
    transitions?: InputMaybe<Array<ActivityTransition>>;
};

/** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */
export type ActivitiesCommentedEvent = {
    __typename?: "ActivitiesCommentedEvent";
    commentId: Scalars["ID"]["output"];
};

export type ActivitiesConnection = {
    __typename?: "ActivitiesConnection";
    edges?: Maybe<Array<Maybe<ActivityEdge>>>;
    nodes: Array<ActivitiesItem>;
    pageInfo: ActivityPageInfo;
};

export type ActivitiesContainer = {
    __typename?: "ActivitiesContainer";
    cloudId?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Base64 encoded ARI of container. */
    id: Scalars["ID"]["output"];
    /** Local (in product) object ID of the corresponding object. */
    localResourceId?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    product?: Maybe<ActivityProduct>;
    type?: Maybe<ActivitiesContainerType>;
    url?: Maybe<Scalars["URL"]["output"]>;
};

export enum ActivitiesContainerType {
    Project = "PROJECT",
    Site = "SITE",
    Space = "SPACE",
    Workspace = "WORKSPACE"
}

export type ActivitiesContributor = {
    __typename?: "ActivitiesContributor";
    /**
     * count of contributions for sorting by frequency,
     * all event types that is being ingested, except VIEWED and VIEWED_CONTENT
     * is considered to be a contribution
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    lastAccessedDate?: Maybe<Scalars["DateTime"]["output"]>;
    profile?: Maybe<User>;
};

export type ActivitiesEvent = Node & {
    __typename?: "ActivitiesEvent";
    eventType?: Maybe<ActivityEventType>;
    extension?: Maybe<ActivitiesEventExtension>;
    /** Unique event ID */
    id: Scalars["ID"]["output"];
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
    user?: Maybe<ActivitiesUser>;
};

export type ActivitiesEventExtension =
    | ActivitiesCommentedEvent
    | ActivitiesTransitionedEvent;

export type ActivitiesFilter = {
    arguments?: InputMaybe<ActivitiesArguments>;
    /** Defines relationship in-between filter arguments (AND/OR) */
    type?: InputMaybe<ActivitiesFilterType>;
};

export enum ActivitiesFilterType {
    And = "AND",
    Or = "OR"
}

export type ActivitiesItem = Node & {
    __typename?: "ActivitiesItem";
    /** Base64 encoded ARI of the activity. */
    id: Scalars["ID"]["output"];
    object?: Maybe<ActivitiesObject>;
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Extension of ActivitiesObject, is a part of ActivitiesObjectExtension union */
export type ActivitiesJiraIssue = {
    __typename?: "ActivitiesJiraIssue";
    issueKey?: Maybe<Scalars["String"]["output"]>;
};

export type ActivitiesObject = Node & {
    __typename?: "ActivitiesObject";
    cloudId?: Maybe<Scalars["String"]["output"]>;
    /** Hierarchy of the containers, top container comes first */
    containers?: Maybe<Array<ActivitiesContainer>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    contributors?: Maybe<Array<ActivitiesContributor>>;
    events?: Maybe<Array<ActivitiesEvent>>;
    extension?: Maybe<ActivitiesObjectExtension>;
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Base64 encoded ARI of the object. */
    id: Scalars["ID"]["output"];
    /** Local (in product) object ID of the corresponding object. */
    localResourceId?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    parent?: Maybe<ActivitiesObjectParent>;
    product?: Maybe<ActivityProduct>;
    type?: Maybe<ActivityObjectType>;
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type ActivitiesObjectEventsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActivitiesObjectExtension = ActivitiesJiraIssue;

export type ActivitiesObjectParent = {
    __typename?: "ActivitiesObjectParent";
    /** Base64 encoded ARI of the object. */
    id: Scalars["ID"]["output"];
    type?: Maybe<ActivityObjectType>;
};

export enum ActivitiesObjectType {
    Blogpost = "BLOGPOST",
    Database = "DATABASE",
    Embed = "EMBED",
    Goal = "GOAL",
    Issue = "ISSUE",
    Page = "PAGE",
    /** Refers to a townsquare project (not to be confused with a jira project) */
    Project = "PROJECT",
    Whiteboard = "WHITEBOARD"
}

/** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */
export type ActivitiesTransitionedEvent = {
    __typename?: "ActivitiesTransitionedEvent";
    from?: Maybe<Scalars["String"]["output"]>;
    to?: Maybe<Scalars["String"]["output"]>;
};

export type ActivitiesUser = {
    __typename?: "ActivitiesUser";
    profile?: Maybe<User>;
};

/** --------------------------------------- activity_api_v3 */
export type Activity = {
    __typename?: "Activity";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    all: ActivityConnection;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    myActivity?: Maybe<MyActivity>;
    /**
     * Worked On: includes actions like CREATED, UPDATED, etc.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workedOn: ActivityConnection;
};

/** --------------------------------------- activity_api_v3 */
export type ActivityAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<ActivityFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** --------------------------------------- activity_api_v3 */
export type ActivityWorkedOnArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<ActivityFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ActivityConnection = {
    __typename?: "ActivityConnection";
    edges: Array<ActivityItemEdge>;
    pageInfo: ActivityPageInfo;
};

export type ActivityContributor = {
    __typename?: "ActivityContributor";
    /**
     * count of contributions for sorting by frequency,
     * all event types that is being ingested, except VIEWED and VIEWED_CONTENT
     * is considered to be a contribution
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    lastAccessedDate: Scalars["DateTime"]["output"];
    profile?: Maybe<User>;
};

export type ActivityEdge = {
    __typename?: "ActivityEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ActivitiesItem>;
};

export type ActivityEvent = {
    __typename?: "ActivityEvent";
    actor?: Maybe<User>;
    eventType: Scalars["String"]["output"];
    extension?: Maybe<ActivitiesEventExtension>;
    /** Unique event ID */
    id: Scalars["ID"]["output"];
    timestamp: Scalars["DateTime"]["output"];
};

export enum ActivityEventType {
    Assigned = "ASSIGNED",
    Commented = "COMMENTED",
    Created = "CREATED",
    Edited = "EDITED",
    Liked = "LIKED",
    Published = "PUBLISHED",
    Transitioned = "TRANSITIONED",
    Unassigned = "UNASSIGNED",
    Updated = "UPDATED",
    Viewed = "VIEWED"
}

export type ActivityFilter = {
    /** Set of actor ARIs whose activity should be searched. A maximum of 5 values may be provided. (ex: AAIDs) */
    actors?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** These are always AND-ed with accountIds */
    arguments?: InputMaybe<ActivityFilterArgs>;
    /** set of top-level container ARIs (ex: Cloud ID, workspace ID) */
    rootContainerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Defines relationship between the filter arguments. Default: AND */
    type?: InputMaybe<ActivitiesFilterType>;
};

export type ActivityFilterArgs = {
    /** set of Container IDs (ex: Jira project ID, Space ID, etc) */
    containerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * The creation time of the earliest events to be included in the result
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated No longer be supported.
     */
    earliestStart?: InputMaybe<Scalars["DateTime"]["input"]>;
    /**
     * set of Event Types ex:
     * assigned
     * unassigned
     * viewed
     * updated
     * created
     * liked
     * transitioned
     * published
     * edited
     */
    eventTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * The creation time of the latest events to be included in the result
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated No longer be supported.
     */
    latestStart?: InputMaybe<Scalars["DateTime"]["input"]>;
    /**
     * set of Object Types (derived from the AVI) ex:
     * issue
     * page
     * blogpost
     * whiteboard
     * database
     * embed
     * project (townsquare)
     * goal
     */
    objectTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * set of products (derived from the AVI) ex:
     * jira
     * confluence
     * townsquare
     */
    products?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * arbitrary transition filters
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated No longer be supported.
     */
    transitions?: InputMaybe<Array<TransitionFilter>>;
};

export type ActivityItemEdge = {
    __typename?: "ActivityItemEdge";
    cursor: Scalars["String"]["output"];
    node: ActivityNode;
};

export type ActivityNode = Node & {
    __typename?: "ActivityNode";
    event: ActivityEvent;
    /** ARI of the activity */
    id: Scalars["ID"]["output"];
    object: ActivityObject;
};

export type ActivityObject = {
    __typename?: "ActivityObject";
    contributors?: Maybe<Array<ActivityContributor>>;
    data?: Maybe<ActivityObjectData>;
    /** ARI of the object. */
    id: Scalars["ID"]["output"];
    product: Scalars["String"]["output"];
    /** ARI of the top most container (ex: Site/Workspace) */
    rootContainerId: Scalars["ID"]["output"];
    subProduct?: Maybe<Scalars["String"]["output"]>;
    /** Type of the object: ex: Issue, Blog, etc */
    type: Scalars["String"]["output"];
};

export type ActivityObjectData =
    | BitbucketPullRequest
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluenceDatabase
    | ConfluenceEmbed
    | ConfluenceFooterComment
    | ConfluenceInlineComment
    | ConfluencePage
    | ConfluenceWhiteboard
    | DevOpsDesign
    | DevOpsDocument
    | DevOpsPullRequestDetails
    | ExternalDocument
    | JiraIssue
    | JiraPlatformComment
    | JiraServiceManagementComment
    | LoomVideo
    | MercuryFocusArea
    | MercuryPortfolio
    | TownsquareComment
    | TownsquareGoal
    | TownsquareProject
    | TrelloAttachment
    | TrelloBoard
    | TrelloCard
    | TrelloLabel
    | TrelloList
    | TrelloMember;

export enum ActivityObjectType {
    Blogpost = "BLOGPOST",
    Comment = "COMMENT",
    Database = "DATABASE",
    Embed = "EMBED",
    Goal = "GOAL",
    Issue = "ISSUE",
    Page = "PAGE",
    Project = "PROJECT",
    Site = "SITE",
    Space = "SPACE",
    Task = "TASK",
    Whiteboard = "WHITEBOARD"
}

export type ActivityPageInfo = {
    __typename?: "ActivityPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export enum ActivityProduct {
    Confluence = "CONFLUENCE",
    Jira = "JIRA",
    JiraBusiness = "JIRA_BUSINESS",
    JiraOps = "JIRA_OPS",
    JiraServiceDesk = "JIRA_SERVICE_DESK",
    JiraSoftware = "JIRA_SOFTWARE",
    Townsquare = "TOWNSQUARE"
}

/**
 *  Represents arbitrary transition,
 *  e.g. in case of TRANSITIONED event type it could be `from: "inprogress" to: "done"`.
 */
export type ActivityTransition = {
    from?: InputMaybe<Scalars["String"]["input"]>;
    to?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActivityUser = {
    __typename?: "ActivityUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    accountId: Scalars["ID"]["output"];
};

export type AddAppContributorInput = {
    appId: Scalars["ID"]["input"];
    newContributorEmail: Scalars["String"]["input"];
    role: AppContributorRole;
};

export type AddAppContributorResponsePayload = Payload & {
    __typename?: "AddAppContributorResponsePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type AddBetaUserAsSiteCreatorInput = {
    cloudID: Scalars["String"]["input"];
};

export type AddBetaUserAsSiteCreatorPayload = Payload & {
    __typename?: "AddBetaUserAsSiteCreatorPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for adding labels to a component. */
export type AddCompassComponentLabelsInput = {
    /** The ID of the component to add the labels to. */
    componentId: Scalars["ID"]["input"];
    /** The collection of labels to add to the component. */
    labelNames: Array<Scalars["String"]["input"]>;
};

/** The payload returned after adding labels to a component. */
export type AddCompassComponentLabelsPayload = Payload & {
    __typename?: "AddCompassComponentLabelsPayload";
    /** The collection of labels that were added to the component. */
    addedLabels?: Maybe<Array<CompassComponentLabel>>;
    /** The details of the component that was mutated. */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type AddDefaultExCoSpacePermissionsInput = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groupNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    spaceKeys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type AddDefaultExCoSpacePermissionsPayload = {
    __typename?: "AddDefaultExCoSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type AddLabelsInput = {
    contentId: Scalars["ID"]["input"];
    labels: Array<LabelInput>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type AddLabelsPayload = {
    __typename?: "AddLabelsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labels: PaginatedLabelList;
};

export type AddMultipleAppContributorInput = {
    appId: Scalars["ID"]["input"];
    newContributorEmails: Array<Scalars["String"]["input"]>;
    roles: Array<AppContributorRole>;
};

export type AddMultipleAppContributorResponsePayload = Payload & {
    __typename?: "AddMultipleAppContributorResponsePayload";
    contributorsFailed?: Maybe<Array<ContributorFailed>>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type AddPublicLinkPermissionsInput = {
    objectId: Scalars["ID"]["input"];
    objectType: PublicLinkPermissionsObjectType;
    permissions: Array<PublicLinkPermissionsType>;
};

export type AddPublicLinkPermissionsPayload = Payload & {
    __typename?: "AddPublicLinkPermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    data?: Maybe<PublicLinkPermissions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type Admin = JiraUser | JiraUserGroup;

export type AdminAnnouncementBannerFeature = {
    __typename?: "AdminAnnouncementBannerFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type AdminAnnouncementBannerPageInfo = {
    __typename?: "AdminAnnouncementBannerPageInfo";
    endPage?: Maybe<Scalars["String"]["output"]>;
    hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
    startPage?: Maybe<Scalars["String"]["output"]>;
};

export type AdminAnnouncementBannerSettingConnection = {
    __typename?: "AdminAnnouncementBannerSettingConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<ConfluenceAdminAnnouncementBannerSetting>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: AdminAnnouncementBannerPageInfo;
};

export enum AdminAnnouncementBannerSettingsByCriteriaOrder {
    Default = "DEFAULT",
    ScheduledEndDate = "SCHEDULED_END_DATE",
    ScheduledStartDate = "SCHEDULED_START_DATE",
    Visibility = "VISIBILITY"
}

export type AgentAiContextPanelResponse = {
    __typename?: "AgentAIContextPanelResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nextSteps?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    reporterDetails?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    suggestedActions?: Maybe<Array<Maybe<AgentAiSuggestAction>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    suggestedEscalation?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    summary?: Maybe<Scalars["String"]["output"]>;
};

export type AgentAiContextPanelResult =
    | AgentAiContextPanelResponse
    | QueryError;

export type AgentAiIssueSummary = {
    __typename?: "AgentAIIssueSummary";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    summary?: Maybe<AgentAiSummary>;
};

export type AgentAiIssueSummaryResult = AgentAiIssueSummary | QueryError;

export type AgentAiSuggestAction = {
    __typename?: "AgentAISuggestAction";
    content?: Maybe<AgentAiSuggestedActionContent>;
    context?: Maybe<AgentAiSuggestedActionContext>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type AgentAiSuggestedActionContent = {
    __typename?: "AgentAISuggestedActionContent";
    description?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export type AgentAiSuggestedActionContext = {
    __typename?: "AgentAISuggestedActionContext";
    fieldId?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    suggestion?: Maybe<Scalars["JSON"]["output"]>;
};

export type AgentAiSummary = {
    __typename?: "AgentAISummary";
    adf?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type AgentStudioAction = {
    __typename?: "AgentStudioAction";
    /** Action identifier */
    actionKey: Scalars["String"]["output"];
    /** Action description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Action name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** List of tags providing additional information about the action */
    tags?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type AgentStudioActionConfiguration = {
    __typename?: "AgentStudioActionConfiguration";
    /** List of actions configured for the agent perform */
    actions?: Maybe<Array<AgentStudioAction>>;
};

export type AgentStudioActionConfigurationInput = {
    /** List of actions configured for the agent perform */
    actions?: InputMaybe<Array<AgentStudioActionInput>>;
};

export type AgentStudioActionInput = {
    /** Action identifier */
    actionKey: Scalars["String"]["input"];
};

export type AgentStudioAgent = {
    /** Description of the agent */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Unique identifier for the agent. */
    id: Scalars["ID"]["output"];
    /** Name of the agent */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type AgentStudioAgentResult = AgentStudioAssistant | QueryError;

export enum AgentStudioAgentType {
    /** Rovo agent type */
    Assistant = "ASSISTANT"
}

export type AgentStudioAssistant = AgentStudioAgent &
    Node & {
        __typename?: "AgentStudioAssistant";
        /**
         * List of actions configured for the agent perform
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        actions?: Maybe<AgentStudioActionConfiguration>;
        /**
         * Conversation starters configured to help getting a chat going
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        conversationStarters?: Maybe<Array<Scalars["String"]["output"]>>;
        /**
         * Current owner
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        creator?: Maybe<User>;
        /**
         * Description of the agent
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Unique identifier for the agent.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * System prompt to configure Rovo agent behaviour
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        instructions?: Maybe<Scalars["String"]["output"]>;
        /**
         * List of knowledge sources configured for the agent to utilize
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        knowledgeSources?: Maybe<AgentStudioKnowledgeConfiguration>;
        /**
         * Name of the agent
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
    };

export type AgentStudioConfluenceKnowledgeFilter = {
    __typename?: "AgentStudioConfluenceKnowledgeFilter";
    /** A list of Confluence pages ARIs */
    parentFilter?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** A list of Confluence space ARIs */
    spaceFilter?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export type AgentStudioConfluenceKnowledgeFilterInput = {
    /** A list of Confluence pages ARIs */
    parentFilter?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** A list of Confluence space ARIs */
    spaceFilter?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AgentStudioConversationStarterSuggestions = {
    __typename?: "AgentStudioConversationStarterSuggestions";
    /**
     * The conversation starter suggestions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    suggestions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type AgentStudioCreateAgentInput = {
    /** Configure a list of actions for the agent perform */
    actions?: InputMaybe<AgentStudioActionConfigurationInput>;
    /** Type of the agent to create */
    agentType: AgentStudioAgentType;
    /** Configure conversation starters to help getting a chat going */
    conversationStarters?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Description of the agent */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** System prompt to configure Rovo agent behaviour */
    instructions?: InputMaybe<Scalars["String"]["input"]>;
    /** Configure a list of knowledge sources for the agent to utilize */
    knowledgeSources?: InputMaybe<AgentStudioKnowledgeConfigurationInput>;
    /** Name of the agent */
    name: Scalars["String"]["input"];
};

export type AgentStudioCreateAgentPayload = Payload & {
    __typename?: "AgentStudioCreateAgentPayload";
    /**
     * The newly created agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    agent?: Maybe<AgentStudioAgent>;
    /**
     * A list of errors that occurred during the mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Whether the mutation was successful or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type AgentStudioJiraKnowledgeFilter = {
    __typename?: "AgentStudioJiraKnowledgeFilter";
    /** A list of jira project ARIs */
    projectFilter?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export type AgentStudioJiraKnowledgeFilterInput = {
    /** A list of jira project ARIs */
    projectFilter?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type AgentStudioKnowledgeConfiguration = {
    __typename?: "AgentStudioKnowledgeConfiguration";
    /** Top level toggle indicating if all knowledge sources are enabled */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** A list of configured knowledge sources */
    sources?: Maybe<Array<AgentStudioKnowledgeSource>>;
};

export type AgentStudioKnowledgeConfigurationInput = {
    /** Top level toggle to enable all knowledge sources */
    enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A list of knowledge sources */
    sources?: InputMaybe<Array<AgentStudioKnowledgeSourceInput>>;
};

export type AgentStudioKnowledgeFilter =
    | AgentStudioConfluenceKnowledgeFilter
    | AgentStudioJiraKnowledgeFilter;

export type AgentStudioKnowledgeFiltersInput = {
    /** Specific filter applicable to confluence knowledge source only */
    confluenceFilter?: InputMaybe<AgentStudioConfluenceKnowledgeFilterInput>;
    /** Specific filter applicable to jira knowledge source only */
    jiraFilter?: InputMaybe<AgentStudioJiraKnowledgeFilterInput>;
};

export type AgentStudioKnowledgeSource = {
    __typename?: "AgentStudioKnowledgeSource";
    /** Indicate if a knowledge source is enabled */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Optional filters applicable to certain knowledge types */
    filters?: Maybe<AgentStudioKnowledgeFilter>;
    /** The type of knowledge source */
    source: Scalars["String"]["output"];
};

export type AgentStudioKnowledgeSourceInput = {
    /** Enable individual knowledge source */
    enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Optional filters applicable to certain knowledge types */
    filters?: InputMaybe<AgentStudioKnowledgeFiltersInput>;
    /** The type of knowledge source */
    source: Scalars["String"]["input"];
};

export type AgentStudioSuggestConversationStartersInput = {
    /** Description of agent to suggest conversation starters for */
    agentDescription?: InputMaybe<Scalars["String"]["input"]>;
    /** Instructions of agent to suggest conversation starters for */
    agentInstructions?: InputMaybe<Scalars["String"]["input"]>;
    /** Name of agent to suggest conversation starters for */
    agentName?: InputMaybe<Scalars["String"]["input"]>;
};

export type AgentStudioSuggestConversationStartersResult =
    | AgentStudioConversationStarterSuggestions
    | QueryError;

export type AgentStudioUpdateAgentActionsPayload = Payload & {
    __typename?: "AgentStudioUpdateAgentActionsPayload";
    /**
     * The updated agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    agent?: Maybe<AgentStudioAgent>;
    /**
     * A list of errors that occurred during the mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Whether the mutation was successful or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type AgentStudioUpdateAgentDetailsInput = {
    /** Change the owner id */
    creatorId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Description of the agent */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** System prompt to configure Rovo agent behaviour */
    instructions?: InputMaybe<Scalars["String"]["input"]>;
    /** Name of the agent */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type AgentStudioUpdateAgentDetailsPayload = Payload & {
    __typename?: "AgentStudioUpdateAgentDetailsPayload";
    /**
     * The updated agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    agent?: Maybe<AgentStudioAgent>;
    /**
     * A list of errors that occurred during the mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Whether the mutation was successful or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type AgentStudioUpdateAgentKnowledgeSourcesPayload = Payload & {
    __typename?: "AgentStudioUpdateAgentKnowledgeSourcesPayload";
    /**
     * The updated agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    agent?: Maybe<AgentStudioAgent>;
    /**
     * A list of errors that occurred during the mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Whether the mutation was successful or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type AgentStudioUpdateConversationStartersInput = {
    /** Configure conversation starters */
    conversationStarters?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AgentStudioUpdateConversationStartersPayload = Payload & {
    __typename?: "AgentStudioUpdateConversationStartersPayload";
    /**
     * The updated agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    agent?: Maybe<AgentStudioAgent>;
    /**
     * A list of errors that occurred during the mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Whether the mutation was successful or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type AiCoreApiVsaReporting = {
    __typename?: "AiCoreApiVSAReporting";
    /**
     *  Project Id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    projectAri: Scalars["ID"]["output"];
    /**
     *  List of all unassisted conversation stats for Reporting
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    unassistedConversationStatsWithMetaData?: Maybe<AiCoreApiVsaUnassistedConversationStatsWithMetaData>;
};

export type AiCoreApiVsaReportingResult = AiCoreApiVsaReporting | QueryError;

export type AiCoreApiVsaUnassistedConversationStats = {
    __typename?: "AiCoreApiVSAUnassistedConversationStats";
    /** Content gap cluster Id */
    clusterId: Scalars["ID"]["output"];
    /** Conversation Ids for the unassisted conversations in the cluster */
    conversationIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** Number of unassisted conversations in the cluster */
    conversationsCount: Scalars["Int"]["output"];
    /** Consolidated title of all relevant unassisted conversation in the cluster */
    title: Scalars["String"]["output"];
};

export type AiCoreApiVsaUnassistedConversationStatsWithMetaData = {
    __typename?: "AiCoreApiVSAUnassistedConversationStatsWithMetaData";
    /** Time at which the reporting was last refreshed */
    refreshedUntil?: Maybe<Scalars["DateTime"]["output"]>;
    /** List of all unassisted conversation stats for Reporting */
    unassistedConversationStats?: Maybe<
        Array<AiCoreApiVsaUnassistedConversationStats>
    >;
};

/**
 * ###################################################################################################################
 *  COMPASS ALERT EVENT
 * ###################################################################################################################
 */
export enum AlertEventStatus {
    Acknowledged = "ACKNOWLEDGED",
    Closed = "CLOSED",
    Opened = "OPENED",
    Snoozed = "SNOOZED"
}

export enum AlertPriority {
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5"
}

export type AllUpdatesFeedEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: AllUpdatesFeedEventType;
};

export enum AllUpdatesFeedEventType {
    Comment = "COMMENT",
    Create = "CREATE",
    Edit = "EDIT"
}

export type AllUpdatesFeedItem = {
    __typename?: "AllUpdatesFeedItem";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
    lastUpdate: AllUpdatesFeedEvent;
};

export enum AnalyticsClickEventName {
    CompanyHubLinkClicked = "companyHubLink_clicked"
}

export enum AnalyticsCommentType {
    Inline = "inline",
    Page = "page"
}

export enum AnalyticsContentType {
    Blogpost = "blogpost",
    Page = "page"
}

export enum AnalyticsDiscoverEventName {
    CompanyHubLinkViewed = "companyHubLink_viewed"
}

/** Events to gather analytics for */
export enum AnalyticsEventName {
    AnalyticsPageModalViewed = "analyticsPageModal_viewed",
    AutomationRuleTrackCreated = "automationRuleTrack_created",
    CalendarCreated = "calendar_created",
    CommentCreated = "comment_created",
    CompanyHubLinkClicked = "companyHubLink_clicked",
    CompanyHubLinkViewed = "companyHubLink_viewed",
    DatabaseCreated = "database_created",
    DatabaseViewed = "database_viewed",
    InspectPermissionsDialogViewed = "inspectPermissionsDialog_viewed",
    InstanceAnalyticsViewed = "instanceAnalytics_viewed",
    PageAnalyticsViewed = "pageAnalytics_viewed",
    PageCreated = "page_created",
    PageUpdated = "page_updated",
    PageViewed = "page_viewed",
    PubliclinkPageViewed = "publiclink_page_viewed",
    SpaceAnalyticsViewed = "spaceAnalytics_viewed",
    TeamCalendarsViewed = "teamCalendars_viewed",
    WhiteboardCreated = "whiteboard_created",
    WhiteboardViewed = "whiteboard_viewed"
}

/** Events to gather measure analytics for */
export enum AnalyticsMeasuresEventName {
    CurrentBlogpostCountSpacestateMeasured = "currentBlogpostCount_spacestate_measured",
    CurrentDatabaseCountSpacestateMeasured = "currentDatabaseCount_spacestate_measured",
    CurrentLivedocsCountSpacestateMeasured = "currentLivedocsCount_spacestate_measured",
    CurrentPageCountSpacestateMeasured = "currentPageCount_spacestate_measured",
    CurrentWhiteboardCountSpacestateMeasured = "currentWhiteboardCount_spacestate_measured",
    InactivePageCountSitestateMeasured = "inactivePageCount_sitestate_measured",
    InactivePageCountSpacestateMeasured = "inactivePageCount_spacestate_measured",
    TotalActiveCommunalSpacesSitestateMeasured = "totalActiveCommunalSpaces_sitestate_measured",
    TotalActivePersonalSpacesSitestateMeasured = "totalActivePersonalSpaces_sitestate_measured",
    TotalActivePublicLinksSitestateMeasured = "totalActivePublicLinks_sitestate_measured",
    TotalActivePublicLinksSpacestateMeasured = "totalActivePublicLinks_spacestate_measured",
    TotalActiveSpacesSitestateMeasured = "totalActiveSpaces_sitestate_measured",
    TotalCurrentBlogpostCountSitestateMeasured = "totalCurrentBlogpostCount_sitestate_measured",
    TotalCurrentDatabaseCountSitestateMeasured = "totalCurrentDatabaseCount_sitestate_measured",
    TotalCurrentLivedocsCountSitestateMeasured = "totalCurrentLivedocsCount_sitestate_measured",
    TotalCurrentPageCountSitestateMeasured = "totalCurrentPageCount_sitestate_measured",
    TotalCurrentWhiteboardCountSitestateMeasured = "totalCurrentWhiteboardCount_sitestate_measured",
    TotalPagesDeactivatedOwnerSitestateMeasured = "totalPagesDeactivatedOwner_sitestate_measured",
    TotalPagesDeactivatedOwnerSpacestateMeasured = "totalPagesDeactivatedOwner_spacestate_measured"
}

/** Events to gather measure analytics space state */
export enum AnalyticsMeasuresSpaceEventName {
    CurrentBlogpostCountSpacestateMeasured = "currentBlogpostCount_spacestate_measured",
    CurrentDatabaseCountSpacestateMeasured = "currentDatabaseCount_spacestate_measured",
    CurrentLivedocsCountSpacestateMeasured = "currentLivedocsCount_spacestate_measured",
    CurrentPageCountSpacestateMeasured = "currentPageCount_spacestate_measured",
    CurrentWhiteboardCountSpacestateMeasured = "currentWhiteboardCount_spacestate_measured",
    InactivePageCountSpacestateMeasured = "inactivePageCount_spacestate_measured",
    TotalActivePublicLinksSpacestateMeasured = "totalActivePublicLinks_spacestate_measured",
    TotalPagesDeactivatedOwnerSpacestateMeasured = "totalPagesDeactivatedOwner_spacestate_measured"
}

/** Events to gather search analytics for */
export enum AnalyticsSearchEventName {
    AdvancedSearchResultLinkClicked = "advancedSearchResultLink_clicked",
    AdvancedSearchResultsShown = "advancedSearchResults_shown",
    QuickSearchRequestCompleted = "quickSearchRequest_completed",
    QuickSearchResultSelected = "quickSearchResult_selected"
}

/** Granularity to group events by */
export enum AnalyticsTimeseriesGranularity {
    Day = "DAY",
    Hour = "HOUR",
    Month = "MONTH",
    Week = "WEEK"
}

export type Anonymous = Person & {
    __typename?: "Anonymous";
    displayName?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    permissionType?: Maybe<SitePermissionType>;
    profilePicture?: Maybe<Icon>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type AnonymousWithPermissionsInput = {
    operations: Array<InputMaybe<OperationCheckResultInput>>;
};

/** Only used for inside the schema to mark the context for generic types */
export enum ApiContext {
    Devops = "DEVOPS"
}

/**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */
export enum ApiGroup {
    Actions = "ACTIONS",
    AgentStudio = "AGENT_STUDIO",
    AppRecommendations = "APP_RECOMMENDATIONS",
    AtlassianStudio = "ATLASSIAN_STUDIO",
    Caas = "CAAS",
    CloudAdmin = "CLOUD_ADMIN",
    CollaborationGraph = "COLLABORATION_GRAPH",
    CommerceCcp = "COMMERCE_CCP",
    CommerceHams = "COMMERCE_HAMS",
    CommerceSharedApi = "COMMERCE_SHARED_API",
    Compass = "COMPASS",
    Confluence = "CONFLUENCE",
    ConfluenceAnalytics = "CONFLUENCE_ANALYTICS",
    ConfluenceLegacy = "CONFLUENCE_LEGACY",
    ConfluenceMutations = "CONFLUENCE_MUTATIONS",
    ConfluencePages = "CONFLUENCE_PAGES",
    ConfluencePageTree = "CONFLUENCE_PAGE_TREE",
    ConfluenceSmarts = "CONFLUENCE_SMARTS",
    ConfluenceTenant = "CONFLUENCE_TENANT",
    ConfluenceUser = "CONFLUENCE_USER",
    ConfluenceV2 = "CONFLUENCE_V2",
    ContentPlatformApi = "CONTENT_PLATFORM_API",
    CustomerService = "CUSTOMER_SERVICE",
    DevopsAriGraph = "DEVOPS_ARI_GRAPH",
    DevopsContainerRelationship = "DEVOPS_CONTAINER_RELATIONSHIP",
    DevopsService = "DEVOPS_SERVICE",
    DevopsThirdParty = "DEVOPS_THIRD_PARTY",
    DevopsToolchain = "DEVOPS_TOOLCHAIN",
    FeatureReleaseQuery = "FEATURE_RELEASE_QUERY",
    Forge = "FORGE",
    Help = "HELP",
    Identity = "IDENTITY",
    InsightsXperienceService = "INSIGHTS_XPERIENCE_SERVICE",
    Jira = "JIRA",
    Papi = "PAPI",
    Polaris = "POLARIS",
    ServiceHubAgentConfiguration = "SERVICE_HUB_AGENT_CONFIGURATION",
    SurfacePlatform = "SURFACE_PLATFORM",
    Teams = "TEAMS",
    VirtualAgent = "VIRTUAL_AGENT",
    WebTriggers = "WEB_TRIGGERS",
    XenInvocationService = "XEN_INVOCATION_SERVICE",
    XenLogsApi = "XEN_LOGS_API"
}

export type App = {
    __typename?: "App";
    avatarFileId?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    contactLink?: Maybe<Scalars["String"]["output"]>;
    createdAt: Scalars["String"]["output"];
    createdBy?: Maybe<User>;
    /**
     * This field is currently in BETA - opt in xls-deployments-by-interval to call it.
     * Filter deployments for time range
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "xls-deployments-by-interval")' query directive to the 'deployments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deployments?: Maybe<AppDeploymentConnection>;
    description: Scalars["String"]["output"];
    distributionStatus: Scalars["String"]["output"];
    ensureCollaborator: Scalars["Boolean"]["output"];
    environmentByKey?: Maybe<AppEnvironment>;
    environmentByOauthClient?: Maybe<AppEnvironment>;
    environments: Array<AppEnvironment>;
    hasPDReportingApiImplemented?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    /** installationsByContexts is sorted by descending updatedAt by default */
    installationsByContexts?: Maybe<AppInstallationByIndexConnection>;
    marketplaceApp?: Maybe<MarketplaceApp>;
    name: Scalars["String"]["output"];
    privacyPolicy?: Maybe<Scalars["String"]["output"]>;
    storesPersonalData: Scalars["Boolean"]["output"];
    /**
     * A list of app tags.
     * This is a beta field and can be changes without a notice.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: AppTags` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    tags?: Maybe<Array<Scalars["String"]["output"]>>;
    termsOfService?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    vendorName?: Maybe<Scalars["String"]["output"]>;
    vendorType?: Maybe<Scalars["String"]["output"]>;
};

export type AppDeploymentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    interval: IntervalInput;
};

export type AppEnvironmentByKeyArgs = {
    key: Scalars["String"]["input"];
};

export type AppEnvironmentByOauthClientArgs = {
    oauthClientId: Scalars["ID"]["input"];
};

export type AppInstallationsByContextsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    contextIds: Array<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AppAdminQuery = {
    __typename?: "AppAdminQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     * Get quota info for a given installation covering both encrypted and unencrypted storage
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getQuotaInfo?: Maybe<Array<QuotaInfo>>;
    /**
     * List items stored for the given context
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    listStorage?: Maybe<AppStoredEntityConnection>;
};

export type AppAdminQueryGetQuotaInfoArgs = {
    contextAri: Scalars["ID"]["input"];
    environmentId: Scalars["ID"]["input"];
};

export type AppAdminQueryListStorageArgs = {
    input: ListStorageInput;
};

export type AppAuditConnection = {
    __typename?: "AppAuditConnection";
    edges?: Maybe<Array<Maybe<AuditEventEdge>>>;
    /** nodes field allows easy access for the first N data items */
    nodes?: Maybe<Array<Maybe<AuditEvent>>>;
    /** pageInfo determines whether there are more entries to query. */
    pageInfo?: Maybe<AuditsPageInfo>;
};

export type AppConnection = {
    __typename?: "AppConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<AppEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<App>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AppContributor = {
    __typename?: "AppContributor";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isOwner?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    roles?: Maybe<Array<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["String"]["output"];
};

export enum AppContributorRole {
    Admin = "ADMIN",
    Deployer = "DEPLOYER",
    Developer = "DEVELOPER",
    Viewer = "VIEWER",
    ViewerAdvanced = "VIEWER_ADVANCED"
}

export type AppDeployment = {
    __typename?: "AppDeployment";
    appId: Scalars["ID"]["output"];
    createdAt: Scalars["String"]["output"];
    createdBy?: Maybe<User>;
    environmentKey: Scalars["String"]["output"];
    errorDetails?: Maybe<ErrorDetails>;
    id: Scalars["ID"]["output"];
    /**
     * This field is currently in experimental - opt in xls-deployments-major-version to call it.
     * Filter successful deployments for app environment and time range
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "xls-deployments-major-version")' query directive to the 'majorVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    majorVersion?: Maybe<AppEnvironmentVersion>;
    stages?: Maybe<Array<AppDeploymentStage>>;
    status: AppDeploymentStatus;
};

export type AppDeploymentConnection = {
    __typename?: "AppDeploymentConnection";
    /** The AppDeploymentConnection is a paginated list of AppDeployment */
    edges?: Maybe<Array<Maybe<AppDeploymentEdge>>>;
    /** nodes field allows easy access for the first N data items */
    nodes: Array<Maybe<AppDeployment>>;
    /** pageInfo determines whether there are more entries to query. */
    pageInfo?: Maybe<PageInfo>;
};

export type AppDeploymentEdge = {
    __typename?: "AppDeploymentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<AppDeployment>;
};

export type AppDeploymentEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    stepName: Scalars["String"]["output"];
};

export enum AppDeploymentEventLogLevel {
    Error = "ERROR",
    Info = "INFO",
    Warning = "WARNING"
}

export type AppDeploymentLogEvent = AppDeploymentEvent & {
    __typename?: "AppDeploymentLogEvent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    level?: Maybe<AppDeploymentEventLogLevel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    stepName: Scalars["String"]["output"];
};

export type AppDeploymentSnapshotLogEvent = AppDeploymentEvent & {
    __typename?: "AppDeploymentSnapshotLogEvent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    level?: Maybe<AppDeploymentEventLogLevel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    stepName: Scalars["String"]["output"];
};

export type AppDeploymentStage = {
    __typename?: "AppDeploymentStage";
    description: Scalars["String"]["output"];
    events?: Maybe<Array<AppDeploymentEvent>>;
    key: Scalars["String"]["output"];
    progress: AppDeploymentStageProgress;
};

export type AppDeploymentStageProgress = {
    __typename?: "AppDeploymentStageProgress";
    doneSteps: Scalars["Int"]["output"];
    totalSteps: Scalars["Int"]["output"];
};

export enum AppDeploymentStatus {
    Done = "DONE",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS"
}

export enum AppDeploymentStepStatus {
    Done = "DONE",
    Failed = "FAILED",
    Started = "STARTED"
}

export type AppDeploymentTransitionEvent = AppDeploymentEvent & {
    __typename?: "AppDeploymentTransitionEvent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    newStatus?: Maybe<AppDeploymentStepStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    stepName: Scalars["String"]["output"];
};

export type AppEdge = {
    __typename?: "AppEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<App>;
};

export type AppEnvironment = {
    __typename?: "AppEnvironment";
    app?: Maybe<App>;
    appId: Scalars["ID"]["output"];
    createdAt: Scalars["String"]["output"];
    createdBy?: Maybe<User>;
    /**
     * This field is currently in BETA - set X-ExperimentalApi-xls-last-deployments-v0 to call it.
     * A list of deployments for app environment
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: xls-last-deployments-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    deployments?: Maybe<Array<AppDeployment>>;
    id: Scalars["ID"]["output"];
    /**
     * A list of installations of the app
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use `appInstallationsByApp` or `appInstallationsByContext` queries instead
     */
    installations?: Maybe<Array<AppInstallation>>;
    key: Scalars["String"]["output"];
    /** Primary oauth client for the App to interact with Atlassian Authorisation server */
    oauthClient: AtlassianOAuthClient;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This has been superseeded by having scopes per version
     */
    scopes?: Maybe<Array<Scalars["String"]["output"]>>;
    type: AppEnvironmentType;
    variables?: Maybe<Array<AppEnvironmentVariable>>;
    /** The list of major versions for this environment in reverse chronological order (i.e. latest versions first) */
    versions?: Maybe<AppEnvironmentVersionConnection>;
};

export type AppEnvironmentVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    interval?: InputMaybe<IntervalFilter>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    majorVersion?: InputMaybe<Scalars["Int"]["input"]>;
    versionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Used to uniquely identify an environment, when being used as an input. */
export type AppEnvironmentInput = {
    appId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

export enum AppEnvironmentType {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING"
}

export type AppEnvironmentVariable = {
    __typename?: "AppEnvironmentVariable";
    /** Whether or not to encrypt */
    encrypt: Scalars["Boolean"]["output"];
    /** The key of the environment variable */
    key: Scalars["String"]["output"];
    /** The value of the environment variable */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** The input needed to create or update an environment variable. */
export type AppEnvironmentVariableInput = {
    /** Whether or not to encrypt (default=false) */
    encrypt?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The key of the environment variable */
    key: Scalars["String"]["input"];
    /** The value of the environment variable */
    value: Scalars["String"]["input"];
};

/**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */
export type AppEnvironmentVersion = {
    __typename?: "AppEnvironmentVersion";
    /** The creation time of this version as a UNIX timestamp in milliseconds */
    createdAt: Scalars["String"]["output"];
    /** Retrieve an extension by key */
    extensionByKey?: Maybe<AppVersionExtension>;
    /** A list of extensions for the app version. Note: the Forge manifest imposes a 100-extension limit per app. */
    extensions?: Maybe<AppVersionExtensions>;
    id: Scalars["ID"]["output"];
    installations?: Maybe<AppInstallationByIndexConnection>;
    /** a flag which if true indicates this version is the latest major version for this environment */
    isLatest: Scalars["Boolean"]["output"];
    /** A set of migrationKeys for each product corresponding to the Connect App Key */
    migrationKeys?: Maybe<MigrationKeys>;
    /** The permissions that this app requires on installation. These must be consented to by the installer */
    permissions: Array<AppPermission>;
    /**
     * Deprecated, to be removed in favour of `requiredProducts`
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use requiredProducts
     */
    primaryProduct?: Maybe<EcosystemRequiredProduct>;
    /** The required products, if this is a cross-product app */
    requiredProducts?: Maybe<Array<EcosystemRequiredProduct>>;
    /** A flag which indicates if this version requires a license */
    requiresLicense: Scalars["Boolean"]["output"];
    /** Information about the types of storage being used by the app */
    storage: Storage;
    /**
     * Information about the app's trust posture in order to serve take-rate calculations and if an app runs on Atlassian
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AppEnvironmentVersionTrustSignal")' query directive to the 'trustSignal' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    trustSignal: TrustSignal;
    /** The updated time of this version as a UNIX timestamp in milliseconds */
    updatedAt: Scalars["String"]["output"];
    /** The semver for this version (e.g. 2.4.0) */
    version: Scalars["String"]["output"];
};

/**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */
export type AppEnvironmentVersionExtensionByKeyArgs = {
    key: Scalars["String"]["input"];
};

/**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */
export type AppEnvironmentVersionInstallationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */
export type AppEnvironmentVersionTrustSignalArgs = {
    key: Scalars["ID"]["input"];
};

export type AppEnvironmentVersionConnection = {
    __typename?: "AppEnvironmentVersionConnection";
    /** A paginated list of AppEnvironmentVersions */
    edges?: Maybe<Array<Maybe<AppEnvironmentVersionEdge>>>;
    /** nodes field allows easy access for the first N data items */
    nodes?: Maybe<Array<Maybe<AppEnvironmentVersion>>>;
    /** pageInfo determines whether there are more entries to query */
    pageInfo: PageInfo;
    /** totalCount is the number of records retrieved on a query */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AppEnvironmentVersionEdge = {
    __typename?: "AppEnvironmentVersionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<AppEnvironmentVersion>;
};

export type AppFeaturesExposedCredentialsInput = {
    contactLink?: InputMaybe<Scalars["String"]["input"]>;
    defaultAuthClientType?: InputMaybe<AuthClientType>;
    distributionStatus?: InputMaybe<DistributionStatus>;
    hasPDReportingApiImplemented?: InputMaybe<Scalars["Boolean"]["input"]>;
    privacyPolicy?: InputMaybe<Scalars["String"]["input"]>;
    refreshTokenRotation?: InputMaybe<Scalars["Boolean"]["input"]>;
    storesPersonalData?: InputMaybe<Scalars["Boolean"]["input"]>;
    termsOfService?: InputMaybe<Scalars["String"]["input"]>;
    vendorName?: InputMaybe<Scalars["String"]["input"]>;
    vendorType?: InputMaybe<VendorType>;
};

export type AppFeaturesInput = {
    hasCustomLifecycle?: InputMaybe<Scalars["Boolean"]["input"]>;
    hasExposedCredentials?: InputMaybe<AppFeaturesExposedCredentialsInput>;
};

export type AppHostService = {
    __typename?: "AppHostService";
    description: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    scopes?: Maybe<Array<AppHostServiceScope>>;
    serviceId: Scalars["ID"]["output"];
};

export type AppHostServiceScope = {
    __typename?: "AppHostServiceScope";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    service: AppHostService;
};

export type AppInstallation = {
    __typename?: "AppInstallation";
    /** An object that refers to the installed app */
    app?: Maybe<App>;
    /** An object that refers to the installed app environment */
    appEnvironment?: Maybe<AppEnvironment>;
    /** An object that refers to the installed app environment version */
    appEnvironmentVersion?: Maybe<AppEnvironmentVersion>;
    /** Installation-specific config. Example: site-administrator defined blocking of analytics egress for the installation */
    config?: Maybe<Array<Maybe<AppInstallationConfig>>>;
    /** Time when the app was installed */
    createdAt: Scalars["DateTime"]["output"];
    /** An object that refers to the account that installed the app */
    createdBy?: Maybe<User>;
    dataClassifications?: Maybe<EcosystemDataClassificationsContext>;
    /** A unique Id representing installation the app into a context in the environment */
    id: Scalars["ID"]["output"];
    /** A unique Id representing the context into which the app is being installed */
    installationContext: Scalars["ID"]["output"];
    license?: Maybe<AppInstallationLicense>;
    /** ARIs representing the secondary installation contexts, for cross-product app installations */
    secondaryInstallationContexts?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** An object that refers to the version of the installation */
    version?: Maybe<AppVersion>;
};

export type AppInstallationByIndexConnection = {
    __typename?: "AppInstallationByIndexConnection";
    edges?: Maybe<Array<Maybe<AppInstallationByIndexEdge>>>;
    nodes?: Maybe<Array<Maybe<AppInstallation>>>;
    pageInfo: AppInstallationPageInfo;
    /** The number of installations matching the filter, regardless of pagination */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AppInstallationByIndexEdge = {
    __typename?: "AppInstallationByIndexEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<AppInstallation>;
};

export type AppInstallationConfig = {
    __typename?: "AppInstallationConfig";
    key: EcosystemInstallationOverrideKeys;
    value: Scalars["Boolean"]["output"];
};

export type AppInstallationConnection = {
    __typename?: "AppInstallationConnection";
    edges?: Maybe<Array<Maybe<AppInstallationEdge>>>;
    nodes?: Maybe<Array<Maybe<AppInstallation>>>;
    pageInfo: PageInfo;
};

export type AppInstallationContext = {
    __typename?: "AppInstallationContext";
    id: Scalars["ID"]["output"];
};

export type AppInstallationCreationTask = AppInstallationTask & {
    __typename?: "AppInstallationCreationTask";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appVersionId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    state: AppTaskState;
};

export type AppInstallationDeletionTask = AppInstallationTask & {
    __typename?: "AppInstallationDeletionTask";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    state: AppTaskState;
};

export type AppInstallationEdge = {
    __typename?: "AppInstallationEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<AppInstallation>;
};

/** Input payload for the app environment install mutation */
export type AppInstallationInput = {
    /** A unique Id representing the app */
    appId: Scalars["ID"]["input"];
    /**
     * Whether the installation will be done asynchronously
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This field is no longer supported and should not be used.
     * All installations will be done asynchronously.
     */
    async?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The key of the app's environment to be used for installation */
    environmentKey: Scalars["String"]["input"];
    /** A unique Id representing the context into which the app is being installed */
    installationContext: Scalars["ID"]["input"];
    /** Bypass licensing flow if licenseOverride is set */
    licenseOverride?: InputMaybe<LicenseOverrideState>;
    /** An object to override the app installation settings. */
    overrides?: InputMaybe<EcosystemAppInstallationOverridesInput>;
    /** An ID for checking whether an app license has been activated via POA, providing this will bypass the COFS activation flow */
    provisionRequestId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The recovery mode that the customer selected on app installation.
     * NOTE: The functionality associated with installation recovery is currently under development.
     */
    recoveryMode?: InputMaybe<EcosystemInstallationRecoveryMode>;
    /** A unique Id representing a specific version of an app */
    versionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AppInstallationLicense = {
    __typename?: "AppInstallationLicense";
    active: Scalars["Boolean"]["output"];
    billingPeriod?: Maybe<Scalars["String"]["output"]>;
    capabilitySet?: Maybe<CapabilitySet>;
    ccpEntitlementId?: Maybe<Scalars["String"]["output"]>;
    ccpEntitlementSlug?: Maybe<Scalars["String"]["output"]>;
    isEvaluation?: Maybe<Scalars["Boolean"]["output"]>;
    modes?: Maybe<Array<EcosystemLicenseMode>>;
    subscriptionEndDate?: Maybe<Scalars["DateTime"]["output"]>;
    supportEntitlementNumber?: Maybe<Scalars["String"]["output"]>;
    trialEndDate?: Maybe<Scalars["DateTime"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type AppInstallationPageInfo = {
    __typename?: "AppInstallationPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** The response from the installation of an app environment */
export type AppInstallationResponse = Payload & {
    __typename?: "AppInstallationResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    installationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export type AppInstallationSubscribeTask = AppInstallationTask & {
    __typename?: "AppInstallationSubscribeTask";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    state: AppTaskState;
};

export type AppInstallationSummary = {
    __typename?: "AppInstallationSummary";
    id: Scalars["ID"]["output"];
    /** Site ARI, for backwards compatibilty */
    installationContext: Scalars["ID"]["output"];
    /** Workspace ARIs */
    primaryInstallationContext: Scalars["ID"]["output"];
    secondaryInstallationContexts?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export type AppInstallationTask = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    state: AppTaskState;
};

export type AppInstallationUnsubscribeTask = AppInstallationTask & {
    __typename?: "AppInstallationUnsubscribeTask";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    state: AppTaskState;
};

/** Input payload for the app environment upgrade mutation */
export type AppInstallationUpgradeInput = {
    /** A unique Id representing the app */
    appId: Scalars["ID"]["input"];
    /**
     * Whether the installation upgrade will be done asynchronously
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This field is no longer supported and should not be used.
     * All installation upgrades will be done asynchronously.
     */
    async?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The key of the app's environment to be used for installation upgrade */
    environmentKey: Scalars["String"]["input"];
    /** A unique Id representing the context into which the app is being upgraded */
    installationContext: Scalars["ID"]["input"];
    /**
     * Determines whether the original billing type is HAMS or CCP. Will be treated as HAMS if not provided.
     * Providing CCP will skip deactivation via COFS
     */
    sourceBillingType?: InputMaybe<SourceBillingType>;
    /** A unique Id representing a specific major version of the app */
    versionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The response from the installation upgrade of an app environment */
export type AppInstallationUpgradeResponse = Payload & {
    __typename?: "AppInstallationUpgradeResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    installationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export type AppInstallationUpgradeTask = AppInstallationTask & {
    __typename?: "AppInstallationUpgradeTask";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appVersionId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    state: AppTaskState;
};

export type AppInstallationsByAppFilter = {
    appEnvironments?: InputMaybe<InstallationsListFilterByAppEnvironments>;
    appInstallations?: InputMaybe<InstallationsListFilterByAppInstallations>;
    apps: InstallationsListFilterByApps;
    includeSystemApps?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AppInstallationsByContextFilter = {
    appInstallations: InstallationsListFilterByAppInstallationsWithCompulsoryContexts;
    apps?: InputMaybe<InstallationsListFilterByApps>;
    /**
     * A flag to retrieve installations that have been uninstalled but are recoverable
     * NOTE: The functionality associated with installation recovery is currently under development.
     */
    includeRecoverable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AppInstallationsFilter = {
    appId: Scalars["ID"]["input"];
    environmentType?: InputMaybe<AppEnvironmentType>;
};

export type AppLog = FunctionInvocationMetadata &
    Node & {
        __typename?: "AppLog";
        /**
         * Gets up to 200 earliest log lines for this invocation.
         * For getting more log lines use appLogLines field in Query type.
         */
        appLogLines?: Maybe<AppLogLineConnection>;
        appVersion: Scalars["String"]["output"];
        function?: Maybe<FunctionDescription>;
        id: Scalars["ID"]["output"];
        installationContext?: Maybe<AppInstallationContext>;
        moduleType?: Maybe<Scalars["String"]["output"]>;
        /**
         * The start time of the invocation
         *
         * RFC-3339 formatted timestamp.
         */
        startTime?: Maybe<Scalars["String"]["output"]>;
        traceId?: Maybe<Scalars["ID"]["output"]>;
        trigger?: Maybe<FunctionTrigger>;
    };

export type AppLogAppLogLinesArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<LogQueryInput>;
};

/** Relay-style Connection to `AppLog` objects. */
export type AppLogConnection = {
    __typename?: "AppLogConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<AppLogEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<Maybe<AppLog>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

/** Relay-style Edge to an `AppLog` object. */
export type AppLogEdge = {
    __typename?: "AppLogEdge";
    cursor: Scalars["String"]["output"];
    node: AppLog;
};

export type AppLogLine = {
    __typename?: "AppLogLine";
    /**
     * Log level of log line.  Typically one of:
     * TRACE, DEBUG, INFO, WARN, ERROR, FATAL
     */
    level?: Maybe<Scalars["String"]["output"]>;
    /** The free-form textual message from the log statement. */
    message?: Maybe<Scalars["String"]["output"]>;
    /**
     * We really don't know what other fields may be in the logs.
     *
     * This field may be an array or an object.
     *
     * If it's an object, it will include only fields in `includeFields`,
     * unless `includeFields` is null, in which case it will include
     * all fields that are not in `excludeFields`.
     *
     * If it's an array it will include the entire array.
     */
    other?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * Time the log line was issued
     *
     * RFC-3339 formatted timestamp
     */
    timestamp: Scalars["String"]["output"];
};

/** Relay-style Connection to `AppLogLine` objects. */
export type AppLogLineConnection = {
    __typename?: "AppLogLineConnection";
    edges?: Maybe<Array<Maybe<AppLogLineEdge>>>;
    /** Metadata about the function invocation (applies to all log lines of invocation) */
    metadata: FunctionInvocationMetadata;
    nodes?: Maybe<Array<Maybe<AppLogLine>>>;
    pageInfo: PageInfo;
};

/** Relay-style Edge to an `AppLogLine` object. */
export type AppLogLineEdge = {
    __typename?: "AppLogLineEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node: AppLogLine;
};

/**
 * AppLogLines returned from AppLog query.
 *
 * Not quite a Relay-style Connection since you can't page from this query.
 */
export type AppLogLines = {
    __typename?: "AppLogLines";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<AppLogLineEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<Maybe<AppLogLine>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type AppLogsWithMetaData = {
    __typename?: "AppLogsWithMetaData";
    /** Unique Id assign to each app */
    appId: Scalars["String"]["output"];
    /** Defines the current version of your app in particular context. */
    appVersion: Scalars["String"]["output"];
    cloudwatchId?: Maybe<Scalars["String"]["output"]>;
    /** Specify which environment to search. */
    environmentId: Scalars["String"]["output"];
    /** error occurs during invocation */
    error?: Maybe<Scalars["String"]["output"]>;
    /** function name gets triggered during invocation */
    functionKey?: Maybe<Scalars["String"]["output"]>;
    /** The context in which the app is installed */
    installationContext: Scalars["String"]["output"];
    /** Id uniquely identifies each invocation. */
    invocationId: Scalars["String"]["output"];
    /** Log level of log line.  Typically one of: TRACE, DEBUG, INFO, WARN, ERROR, FATAL */
    lvl?: Maybe<Scalars["String"]["output"]>;
    /** The textual message from the log statement. */
    message?: Maybe<Scalars["String"]["output"]>;
    /** module key of your app invoked */
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    /** Metadata about module type */
    moduleType?: Maybe<Scalars["String"]["output"]>;
    /** other field that contains any additional JSON fields included in the log line */
    other?: Maybe<Scalars["String"]["output"]>;
    /** Defines the priority of log line */
    p?: Maybe<Scalars["String"]["output"]>;
    /** traceId of an invocation */
    traceId?: Maybe<Scalars["String"]["output"]>;
    /** Time the log line was issued */
    ts: Scalars["String"]["output"];
};

export type AppLogsWithMetaDataResponse = {
    __typename?: "AppLogsWithMetaDataResponse";
    /**
     * Contains all informations related to logs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appLogs: Array<AppLogsWithMetaData>;
    /**
     * if we have next page to query logs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasNextPage: Scalars["Boolean"]["output"];
    /**
     * Offset for pagination, can be null if not applicable.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    offset?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Total count of logs as per filters selected.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalLogs: Scalars["Int"]["output"];
};

export enum AppNetworkEgressCategory {
    Analytics = "ANALYTICS"
}

export enum AppNetworkEgressCategoryExtension {
    Analytics = "ANALYTICS"
}

export type AppNetworkEgressPermission = {
    __typename?: "AppNetworkEgressPermission";
    addresses?: Maybe<Array<Scalars["String"]["output"]>>;
    category?: Maybe<AppNetworkEgressCategory>;
    inScopeEUD?: Maybe<Scalars["Boolean"]["output"]>;
    type?: Maybe<AppNetworkPermissionType>;
};

export type AppNetworkEgressPermissionExtension = {
    __typename?: "AppNetworkEgressPermissionExtension";
    addresses?: Maybe<Array<Scalars["String"]["output"]>>;
    category?: Maybe<AppNetworkEgressCategoryExtension>;
    /** Determines if the egress contains end-user-data (EUD) */
    inScopeEUD?: Maybe<Scalars["Boolean"]["output"]>;
    type?: Maybe<AppNetworkPermissionTypeExtension>;
};

export enum AppNetworkPermissionType {
    FetchBackendSide = "FETCH_BACKEND_SIDE",
    FetchClientSide = "FETCH_CLIENT_SIDE",
    Fonts = "FONTS",
    Frames = "FRAMES",
    Images = "IMAGES",
    Media = "MEDIA",
    Navigation = "NAVIGATION",
    Scripts = "SCRIPTS",
    Styles = "STYLES"
}

export enum AppNetworkPermissionTypeExtension {
    FetchBackendSide = "FETCH_BACKEND_SIDE",
    FetchClientSide = "FETCH_CLIENT_SIDE",
    Fonts = "FONTS",
    Frames = "FRAMES",
    Images = "IMAGES",
    Media = "MEDIA",
    Navigation = "NAVIGATION",
    Scripts = "SCRIPTS",
    Styles = "STYLES"
}

/** Permissions that relate to the App's interaction with supported APIs and supported network egress */
export type AppPermission = {
    __typename?: "AppPermission";
    egress?: Maybe<Array<AppNetworkEgressPermission>>;
    scopes: Array<AppHostServiceScope>;
    securityPolicies?: Maybe<Array<AppSecurityPoliciesPermission>>;
};

export type AppPrincipal = {
    __typename?: "AppPrincipal";
    id?: Maybe<Scalars["ID"]["output"]>;
};

export type AppSecurityPoliciesPermission = {
    __typename?: "AppSecurityPoliciesPermission";
    policies?: Maybe<Array<Scalars["String"]["output"]>>;
    type?: Maybe<AppSecurityPoliciesPermissionType>;
};

export type AppSecurityPoliciesPermissionExtension = {
    __typename?: "AppSecurityPoliciesPermissionExtension";
    policies?: Maybe<Array<Scalars["String"]["output"]>>;
    type?: Maybe<AppSecurityPoliciesPermissionTypeExtension>;
};

export enum AppSecurityPoliciesPermissionType {
    Scripts = "SCRIPTS",
    Styles = "STYLES"
}

export enum AppSecurityPoliciesPermissionTypeExtension {
    Scripts = "SCRIPTS",
    Styles = "STYLES"
}

export type AppServicesFilter = {
    name: Scalars["String"]["input"];
};

export type AppStorageCustomEntityMutation = {
    __typename?: "AppStorageCustomEntityMutation";
    /**
     * Delete a custom entity in a specific context given an entity name and entity key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteAppStoredCustomEntity?: Maybe<DeleteAppStoredCustomEntityPayload>;
    /**
     * Set a custom entity in a specific context given an entity name and entity key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    setAppStoredCustomEntity?: Maybe<SetAppStoredCustomEntityPayload>;
};

export type AppStorageCustomEntityMutationDeleteAppStoredCustomEntityArgs = {
    input: DeleteAppStoredCustomEntityMutationInput;
};

export type AppStorageCustomEntityMutationSetAppStoredCustomEntityArgs = {
    input: SetAppStoredCustomEntityMutationInput;
};

export type AppStorageMutation = {
    __typename?: "AppStorageMutation";
    /**
     * Delete an untyped entity in a specific context given a key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteAppStoredEntity?: Maybe<DeleteAppStoredEntityPayload>;
    /**
     * Set an untyped entity in a specific context given a key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    setAppStoredEntity?: Maybe<SetAppStoredEntityPayload>;
};

export type AppStorageMutationDeleteAppStoredEntityArgs = {
    input: DeleteAppStoredEntityMutationInput;
};

export type AppStorageMutationSetAppStoredEntityArgs = {
    input: SetAppStoredEntityMutationInput;
};

/**
 * This type represents a column in a SQL database table
 * For description of each attribute, see https://dev.mysql.com/doc/refman/8.0/en/columns-table.html
 */
export type AppStorageSqlDatabaseColumn = {
    __typename?: "AppStorageSqlDatabaseColumn";
    default: Scalars["String"]["output"];
    extra: Scalars["String"]["output"];
    field: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    null: Scalars["String"]["output"];
    type: Scalars["String"]["output"];
};

export type AppStorageSqlDatabaseInput = {
    appId: Scalars["ID"]["input"];
    installationId: Scalars["ID"]["input"];
};

export type AppStorageSqlDatabaseMigration = {
    __typename?: "AppStorageSqlDatabaseMigration";
    /** The auto-incremented ID of the migration step */
    id: Scalars["Int"]["output"];
    /** The date and time when the migration was applied */
    migratedAt: Scalars["String"]["output"];
    /** The name of the migration step */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type AppStorageSqlDatabasePayload = {
    __typename?: "AppStorageSqlDatabasePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    migrations: Array<AppStorageSqlDatabaseMigration>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    tables: Array<AppStorageSqlDatabaseTable>;
};

export type AppStorageSqlDatabaseTable = {
    __typename?: "AppStorageSqlDatabaseTable";
    columns: Array<AppStorageSqlDatabaseColumn>;
    name: Scalars["String"]["output"];
};

export type AppStoredCustomEntity = {
    __typename?: "AppStoredCustomEntity";
    /**
     * The name of custom entity this entity belong to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    entityName: Scalars["String"]["output"];
    /**
     * The identifier for this entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["ID"]["output"];
    /**
     * Entities may be up to ${maxValidContentLength} bytes long. Note that size within ESS may differ from
     * the size of the entity sent to this service. The entity size is counted within this service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["JSON"]["output"]>;
};

export type AppStoredCustomEntityConnection = {
    __typename?: "AppStoredCustomEntityConnection";
    /**
     * cursor for next page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /**
     * The AppStoredEntityConnection is a paginated list of Entities from storage service
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<AppStoredCustomEntityEdge>>>;
    /**
     * nodes field allows easy access for the first N data items
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<Maybe<AppStoredEntity>>>;
    /**
     * pageInfo determines whether there are more entries to query.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo?: Maybe<AppStoredEntityPageInfo>;
    /**
     * totalCount is the number of records retrieved on a query.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AppStoredCustomEntityEdge = {
    __typename?: "AppStoredCustomEntityEdge";
    /**
     * Edge is a combination of node and cursor and follows the relay specs.
     *
     * Cursor returns the key of the last record that was queried and
     * should be used as input to after when querying for paginated entities
     */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<AppStoredEntity>;
};

export type AppStoredCustomEntityFilter = {
    condition: AppStoredCustomEntityFilterCondition;
    property: Scalars["String"]["input"];
    values: Array<Scalars["AppStoredCustomEntityFieldValue"]["input"]>;
};

export enum AppStoredCustomEntityFilterCondition {
    BeginsWith = "BEGINS_WITH",
    Between = "BETWEEN",
    Contains = "CONTAINS",
    EqualTo = "EQUAL_TO",
    Exists = "EXISTS",
    GreaterThan = "GREATER_THAN",
    GreaterThanEqualTo = "GREATER_THAN_EQUAL_TO",
    LessThan = "LESS_THAN",
    LessThanEqualTo = "LESS_THAN_EQUAL_TO",
    NotContains = "NOT_CONTAINS",
    NotEqualTo = "NOT_EQUAL_TO",
    NotExists = "NOT_EXISTS"
}

export type AppStoredCustomEntityFilters = {
    and?: InputMaybe<Array<AppStoredCustomEntityFilter>>;
    or?: InputMaybe<Array<AppStoredCustomEntityFilter>>;
};

export type AppStoredCustomEntityRange = {
    condition: AppStoredCustomEntityRangeCondition;
    values: Array<Scalars["AppStoredCustomEntityFieldValue"]["input"]>;
};

export enum AppStoredCustomEntityRangeCondition {
    BeginsWith = "BEGINS_WITH",
    Between = "BETWEEN",
    EqualTo = "EQUAL_TO",
    GreaterThan = "GREATER_THAN",
    GreaterThanEqualTo = "GREATER_THAN_EQUAL_TO",
    LessThan = "LESS_THAN",
    LessThanEqualTo = "LESS_THAN_EQUAL_TO"
}

export type AppStoredEntity = {
    __typename?: "AppStoredEntity";
    /**
     * The identifier for this entity
     *
     * Keys must be between 1-100 characters long and must match the following pattern /^[a-zA-Z0-9:._\s-]+$/
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["ID"]["output"];
    /**
     * Entities may be up to 2000 bytes long. Note that size within ESS may differ from
     * the size of the entity sent to this service. The entity size is counted within this service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["JSON"]["output"]>;
};

export enum AppStoredEntityCondition {
    In = "IN",
    NotEqualTo = "NOT_EQUAL_TO",
    StartsWith = "STARTS_WITH"
}

export type AppStoredEntityConnection = {
    __typename?: "AppStoredEntityConnection";
    /**
     * The AppStoredEntityConnection is a paginated list of Entities from storage service
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<AppStoredEntityEdge>>>;
    /**
     * nodes field allows easy access for the first N data items
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<Maybe<AppStoredEntity>>>;
    /**
     * pageInfo determines whether there are more entries to query.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo?: Maybe<AppStoredEntityPageInfo>;
    /**
     * totalCount is the number of records retrived on a query.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type AppStoredEntityEdge = {
    __typename?: "AppStoredEntityEdge";
    /**
     * Edge is a combination of node and cursor and follows the relay specs.
     *
     * Cursor returns the key of the last record that was queried and
     * should be used as input to after when querying for paginated entities
     */
    cursor: Scalars["String"]["output"];
    node?: Maybe<AppStoredEntity>;
};

/**
 * The identifier for this entity
 *
 * where condition to filter
 */
export type AppStoredEntityFilter = {
    condition: AppStoredEntityCondition;
    /** Condition filter to be provided when querying for Entities. */
    field: Scalars["String"]["input"];
    value: Scalars["AppStoredEntityFieldValue"]["input"];
};

export type AppStoredEntityPageInfo = {
    __typename?: "AppStoredEntityPageInfo";
    /** The pageInfo is the place to allow code to navigate the paginated list. */
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
};

export type AppSubscribeInput = {
    appId: Scalars["ID"]["input"];
    envKey: Scalars["String"]["input"];
    installationContext: Scalars["ID"]["input"];
};

export type AppSubscribePayload = Payload & {
    __typename?: "AppSubscribePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    installation?: Maybe<AppInstallation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export enum AppTaskState {
    Complete = "COMPLETE",
    Failed = "FAILED",
    Pending = "PENDING",
    Running = "RUNNING"
}

/** App trust information state */
export enum AppTrustInformationState {
    Draft = "DRAFT",
    Live = "LIVE"
}

export type AppTunnelDefinitions = {
    __typename?: "AppTunnelDefinitions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customUI?: Maybe<Array<Maybe<CustomUiTunnelDefinition>>>;
    /**
     * The URL to tunnel FaaS calls to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    faasTunnelUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** Input payload for the app environment uninstall mutation */
export type AppUninstallationInput = {
    /** A unique Id representing the app */
    appId: Scalars["ID"]["input"];
    /**
     * Whether the uninstallation will be done asynchronously
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This field is no longer supported and should not be used.
     * All uninstallations will be done asynchronously.
     */
    async?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The key of the app's environment to be used for uninstallation */
    environmentKey: Scalars["String"]["input"];
    /** A unique Id representing the context into which the app is being uninstalled */
    installationContext?: InputMaybe<Scalars["ID"]["input"]>;
    /** A unique Id representing the installationId */
    installationId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Bypass licensing flow if licenseOverride is set */
    licenseOverride?: InputMaybe<LicenseOverrideState>;
    /**
     * Determines whether the original billing type is HAMS or CCP. Will be treated as HAMS if not provided.
     * Providing CCP will skip deactivation via COFS
     */
    sourceBillingType?: InputMaybe<SourceBillingType>;
};

/** The response from the uninstallation of an app environment */
export type AppUninstallationResponse = Payload & {
    __typename?: "AppUninstallationResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export type AppUnsubscribeInput = {
    appId: Scalars["ID"]["input"];
    envKey: Scalars["String"]["input"];
    installationContext: Scalars["ID"]["input"];
};

export type AppUnsubscribePayload = Payload & {
    __typename?: "AppUnsubscribePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    installation?: Maybe<AppInstallation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

/**
 * This does not represent a real person but rather the identity that backs an installed application
 *
 * See the documentation on the `User` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 *
 *
 */
export type AppUser = User & {
    __typename?: "AppUser";
    accountId: Scalars["ID"]["output"];
    accountStatus: AccountStatus;
    appType?: Maybe<Scalars["String"]["output"]>;
    canonicalAccountId: Scalars["ID"]["output"];
    characteristics?: Maybe<Scalars["JSON"]["output"]>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    picture: Scalars["URL"]["output"];
};

export type AppVersion = {
    __typename?: "AppVersion";
    isLatest: Scalars["Boolean"]["output"];
};

export type AppVersionExtension = {
    __typename?: "AppVersionExtension";
    extensionData: Scalars["JSON"]["output"];
    extensionGroupId: Scalars["ID"]["output"];
    extensionTypeKey: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
};

export type AppVersionExtensions = {
    __typename?: "AppVersionExtensions";
    nodes?: Maybe<Array<Maybe<AppVersionExtension>>>;
};

/** The payload returned from applying a scorecard to a component. */
export type ApplyCompassScorecardToComponentPayload = Payload & {
    __typename?: "ApplyCompassScorecardToComponentPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type ApplyPolarisProjectTemplateInput = {
    ideaType: Scalars["ID"]["input"];
    project: Scalars["ID"]["input"];
    template: Scalars["ID"]["input"];
};

export type ApplyPolarisProjectTemplatePayload = Payload & {
    __typename?: "ApplyPolarisProjectTemplatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type AppsFilter = {
    isPublishable?: InputMaybe<Scalars["Boolean"]["input"]>;
    migrationKey?: InputMaybe<Scalars["String"]["input"]>;
    storesPersonalData?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AquaIssueContext = {
    __typename?: "AquaIssueContext";
    commentId?: Maybe<Scalars["Long"]["output"]>;
    issue?: Maybe<JiraIssue>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use hydrated issue field instead
     */
    issueARI?: Maybe<Scalars["ID"]["output"]>;
};

export type AquaNotificationDetails = {
    __typename?: "AquaNotificationDetails";
    errorKey?: Maybe<Scalars["String"]["output"]>;
    hasRecipientJoined?: Maybe<Scalars["Boolean"]["output"]>;
    mailboxMessage?: Maybe<Scalars["String"]["output"]>;
    suppressionManaged?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AquaNotificationLogsFilter = {
    filterActionable?: InputMaybe<Scalars["Boolean"]["input"]>;
    selectedFilters?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type AquaOutgoingEmailLog = Node & {
    __typename?: "AquaOutgoingEmailLog";
    id: Scalars["ID"]["output"];
    logs?: Maybe<AquaOutgoingEmailLogConnection>;
};

export type AquaOutgoingEmailLogLogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AquaOutgoingEmailLogConnection = {
    __typename?: "AquaOutgoingEmailLogConnection";
    edges?: Maybe<Array<Maybe<AquaOutgoingEmailLogItemEdge>>>;
    pageInfo: PageInfo;
};

/** Outgoing Email Log entity created against a project with defined scope. */
export type AquaOutgoingEmailLogItem = {
    __typename?: "AquaOutgoingEmailLogItem";
    actionTimestamp: Scalars["DateTime"]["output"];
    author?: Maybe<User>;
    deliveryType?: Maybe<Scalars["String"]["output"]>;
    issueContext?: Maybe<AquaIssueContext>;
    notificationActionSubType?: Maybe<Scalars["String"]["output"]>;
    notificationActionType?: Maybe<Scalars["String"]["output"]>;
    notificationDetails?: Maybe<AquaNotificationDetails>;
    notificationType?: Maybe<Scalars["String"]["output"]>;
    projectContext?: Maybe<AquaProjectContext>;
    recipient?: Maybe<User>;
};

export type AquaOutgoingEmailLogItemEdge = {
    __typename?: "AquaOutgoingEmailLogItemEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<AquaOutgoingEmailLogItem>;
};

/** The top level wrapper for the Outgoing Email Logs Query API. */
export type AquaOutgoingEmailLogsQueryApi = {
    __typename?: "AquaOutgoingEmailLogsQueryApi";
    /**
     * Fetches outgoing email logs based on the filters. Details: https://hello.atlassian.net/wiki/spaces/ITSOL/pages/2315587289/Customer+Notification+Logs+Access+Patterns
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    GetNotificationLogs?: Maybe<AquaOutgoingEmailLogsQueryResult>;
};

/** The top level wrapper for the Outgoing Email Logs Query API. */
export type AquaOutgoingEmailLogsQueryApiGetNotificationLogsArgs = {
    filterActionable?: InputMaybe<Scalars["Boolean"]["input"]>;
    filters?: InputMaybe<AquaNotificationLogsFilter>;
    fromTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
    notificationActionType?: InputMaybe<Scalars["String"]["input"]>;
    notificationType?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["Long"]["input"]>;
    recipientId?: InputMaybe<Scalars["String"]["input"]>;
    toTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AquaOutgoingEmailLogsQueryResult =
    | AquaOutgoingEmailLog
    | QueryError;

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type AquaProjectContext = {
    __typename?: "AquaProjectContext";
    id?: Maybe<Scalars["Long"]["output"]>;
};

export type ArchiveFeature = {
    __typename?: "ArchiveFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ArchivePolarisInsightsPayload = Payload & {
    __typename?: "ArchivePolarisInsightsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ArchiveSpaceInput = {
    /** The alias of the archived space */
    alias: Scalars["String"]["input"];
};

export type ArchiveSpacePayload = Payload & {
    __typename?: "ArchiveSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ArchivedContentMetadata = {
    __typename?: "ArchivedContentMetadata";
    archiveNote?: Maybe<Scalars["String"]["output"]>;
    restoreParent?: Maybe<Content>;
};

export enum ArchivedMode {
    ActiveOnly = "ACTIVE_ONLY",
    All = "ALL",
    ArchivedOnly = "ARCHIVED_ONLY"
}

export type AriGraph = {
    __typename?: "AriGraph";
    /**
     * Returns true if at least one relationship of the specified type exists
     *
     * Type must always be specified alongside 'to' or 'from' or both
     *
     * E.g:
     *   - from + type
     *   - to + type
     *   - from + to + type
     */
    hasRelationship?: Maybe<Scalars["Boolean"]["output"]>;
    /** Fetch one relationship directly, if it exists */
    relationship?: Maybe<AriGraphRelationship>;
    /**
     * Returns relationships of the specified type going from or to a node
     *
     * At least one of `from` or `to` must be specified
     */
    relationships?: Maybe<AriGraphRelationshipConnection>;
};

export type AriGraphHasRelationshipArgs = {
    from?: InputMaybe<Scalars["ID"]["input"]>;
    to?: InputMaybe<Scalars["ID"]["input"]>;
    type: Scalars["ID"]["input"];
};

export type AriGraphRelationshipArgs = {
    from: Scalars["ID"]["input"];
    to: Scalars["ID"]["input"];
    type: Scalars["ID"]["input"];
};

export type AriGraphRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<AriGraphRelationshipsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from?: InputMaybe<Scalars["ID"]["input"]>;
    sort?: InputMaybe<AriGraphRelationshipsSort>;
    to?: InputMaybe<Scalars["ID"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type AriGraphCreateRelationshipsInput = {
    relationships: Array<AriGraphCreateRelationshipsInputRelationship>;
};

export type AriGraphCreateRelationshipsInputRelationship = {
    /** ARI of the subject */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. `updateTime` as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** ARI of the object */
    to: Scalars["ID"]["input"];
    /** Type of the relationship */
    type: Scalars["ID"]["input"];
    /** Time at which this relationship was last observed. `updateTime` at the request level will be used if this is omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AriGraphCreateRelationshipsPayload = Payload & {
    __typename?: "AriGraphCreateRelationshipsPayload";
    /** A list of successfully created relationships */
    createdRelationships?: Maybe<Array<AriGraphRelationship>>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/**
 * At least 'from' or 'to' must be specified. If both are specified, then 'type' is required.
 *
 * If only one side of the relationship is provided, and no type is provided,
 * then every relationship (where that side of the relationship equals the provided ARI)
 * for every applicable relationship type will be deleted.
 */
export type AriGraphDeleteRelationshipsInput = {
    /** ARI of the subject */
    from?: InputMaybe<Scalars["ID"]["input"]>;
    /** ARI of the object */
    to?: InputMaybe<Scalars["ID"]["input"]>;
    /** Type of the relationship */
    type?: InputMaybe<Scalars["ID"]["input"]>;
};

export type AriGraphDeleteRelationshipsPayload = Payload & {
    __typename?: "AriGraphDeleteRelationshipsPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type AriGraphMutation = {
    __typename?: "AriGraphMutation";
    /** Creates new relationships between two nodes */
    createRelationships?: Maybe<AriGraphCreateRelationshipsPayload>;
    /** Deletes relationships between two nodes */
    deleteRelationships?: Maybe<AriGraphDeleteRelationshipsPayload>;
    /** Replaces all relationships for the given type and nodes with those supplied */
    replaceRelationships?: Maybe<AriGraphReplaceRelationshipsPayload>;
};

export type AriGraphMutationCreateRelationshipsArgs = {
    input: AriGraphCreateRelationshipsInput;
};

export type AriGraphMutationDeleteRelationshipsArgs = {
    input: AriGraphDeleteRelationshipsInput;
};

export type AriGraphMutationReplaceRelationshipsArgs = {
    input: AriGraphReplaceRelationshipsInput;
};

export type AriGraphRelationship = {
    __typename?: "AriGraphRelationship";
    /** Node that starts the relationship (the subject) */
    from: AriGraphRelationshipNode;
    /** Timestamp representing the last time this relationship was updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Node that ends the relationship (the object) */
    to: AriGraphRelationshipNode;
    /** Type of the relationship */
    type: Scalars["ID"]["output"];
};

export type AriGraphRelationshipConnection = {
    __typename?: "AriGraphRelationshipConnection";
    edges?: Maybe<Array<Maybe<AriGraphRelationshipEdge>>>;
    nodes?: Maybe<Array<Maybe<AriGraphRelationship>>>;
    pageInfo: PageInfo;
};

export type AriGraphRelationshipEdge = {
    __typename?: "AriGraphRelationshipEdge";
    /** Cursor to be used when querying relationships starting from this one */
    cursor: Scalars["String"]["output"];
    /** The relationship */
    node: AriGraphRelationship;
};

export type AriGraphRelationshipNode = {
    __typename?: "AriGraphRelationshipNode";
    data?: Maybe<AriGraphRelationshipNodeData>;
    id: Scalars["ID"]["output"];
};

export type AriGraphRelationshipNodeData =
    | ConfluencePage
    | ConfluenceSpace
    | DeploymentSummary
    | DevOpsDesign
    | DevOpsDocument
    | DevOpsFeatureFlag
    | DevOpsOperationsComponentDetails
    | DevOpsOperationsIncidentDetails
    | DevOpsOperationsPostIncidentReviewDetails
    | DevOpsPullRequestDetails
    | DevOpsRepository
    | DevOpsSecurityVulnerabilityDetails
    | DevOpsService
    | ExternalCommit
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssue
    | JiraIssueRemoteIssueLink
    | JiraProject
    | JiraVersion
    | JiraWebRemoteIssueLink
    | OpsgenieTeam
    | ThirdPartySecurityContainer
    | ThirdPartySecurityWorkspace
    | TownsquareComment
    | TownsquareGoal
    | TownsquareProject;

export type AriGraphRelationshipsErrorReference = {
    __typename?: "AriGraphRelationshipsErrorReference";
    /**
     * ARI of the subject
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    from?: Maybe<Scalars["ID"]["output"]>;
    /**
     * ARI of the object
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    to?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Type of the relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: Scalars["ID"]["output"];
};

/** At least one of `from` or `to` must be specified */
export type AriGraphRelationshipsFilter = {
    /**
     * @deprecated(reason: "Use variable [from] at the root of the query instead")
     * Kept for backwards compatibility only.
     */
    from?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * @deprecated(reason: "Use variable [to] at the root of the query instead")
     * Kept for backwards compatibility only.
     */
    to?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * @deprecated(reason: "Use variable [type] at the root of the query instead")
     * Kept for backwards compatibility only.
     */
    type?: InputMaybe<Scalars["ID"]["input"]>;
    /** Only include relationships updated after the given DateTime */
    updatedFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Only include relationships updated before the given DateTime */
    updatedTo?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AriGraphRelationshipsMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "AriGraphRelationshipsMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * A reference to which relationship(s) were unsuccessfully mutated
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        reference: AriGraphRelationshipsErrorReference;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type AriGraphRelationshipsSort = {
    /** The direction of results based on the lastUpdated time of the relationships. Default is ascending (ASC). */
    lastUpdatedSortDirection?: InputMaybe<AriGraphRelationshipsSortDirection>;
};

export enum AriGraphRelationshipsSortDirection {
    /** Sort in ascending order */
    Asc = "ASC",
    /** Sort in descending order */
    Desc = "DESC"
}

export type AriGraphReplaceRelationshipsInput = {
    /** Relationships that replace any existing for the given type and from/to depending on cardinality. */
    relationships: Array<AriGraphReplaceRelationshipsInputRelationship>;
    /** Sequence number of this relationship, used for versioning. `updateTime` as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** Type of the relationship */
    type: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type AriGraphReplaceRelationshipsInputRelationship = {
    /** ARI of the subject */
    from: Scalars["ID"]["input"];
    /** ARI of the object */
    to: Scalars["ID"]["input"];
};

export type AriGraphReplaceRelationshipsPayload = Payload & {
    __typename?: "AriGraphReplaceRelationshipsPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type AriGraphSubscriptions = {
    __typename?: "AriGraphSubscriptions";
    /**
     * This is a subscriptions use case for OTC - solaris
     * subscriber will listen to devops relationship created/updated events satisfying below criteria
     * 1 relationship with `from.id` specified by subscription argument 'projectId'
     * 2 relationship with `relationshipType` value `project-associated-deployment` (hardcode)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AriGraphOtcSubscriptions")' query directive to the 'onDeploymentCreatedOrUpdatedForProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onDeploymentCreatedOrUpdatedForProject?: Maybe<AriGraphRelationship>;
    /**
     * This is a subscriptions use case for isotopes
     * subscriber will listen to devops relationship created/updated events satisfying below criteria
     * 1 relationship with `from.id` specified by subscription argument 'projectId'
     * 2 relationship with `relationshipType` value `pr_associated_project` (hardcode)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onPullRequestCreatedOrUpdatedForProject?: Maybe<AriGraphRelationshipConnection>;
    /**
     * Subscription for the version-deployment relationship materialisation update. The returned AriGraphRelationshipNode type should be DeploymentSummary.
     * subscriber will listen to devops relationship created/updated events satisfying below criteria
     * 1 relationship with `from.id` specified by subscription argument 'versionId' that is version ARI
     * 2 relationship with `relationshipType` value `version-associated-deployment` (hardcode)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onVersionDeploymentCreatedOrUpdated?: Maybe<AriGraphRelationship>;
    /**
     * This is a subscriptions use case for isotopes
     * subscriber will listen to devops relationship created/updated events satisfying below criteria
     * 1 relationship with `from.id` specified by subscription argument 'projectId'
     * 2 relationship with `relationshipType` value `project-associated-vulnerability` (hardcode)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AriGraphOtcSubscriptions")' query directive to the 'onVulnerabilityCreatedOrUpdatedForProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onVulnerabilityCreatedOrUpdatedForProject?: Maybe<AriGraphRelationship>;
};

export type AriGraphSubscriptionsOnDeploymentCreatedOrUpdatedForProjectArgs = {
    projectId: Scalars["ID"]["input"];
    type?: Scalars["String"]["input"];
};

export type AriGraphSubscriptionsOnPullRequestCreatedOrUpdatedForProjectArgs = {
    projectId: Scalars["ID"]["input"];
    type?: Scalars["String"]["input"];
};

export type AriGraphSubscriptionsOnVersionDeploymentCreatedOrUpdatedArgs = {
    type?: Scalars["String"]["input"];
    versionId: Scalars["ID"]["input"];
};

export type AriGraphSubscriptionsOnVulnerabilityCreatedOrUpdatedForProjectArgs =
    {
        projectId: Scalars["ID"]["input"];
        type?: Scalars["String"]["input"];
    };

export type AriRoutingFilter = {
    owner: Scalars["String"]["input"];
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ArjConfiguration = {
    __typename?: "ArjConfiguration";
    epicLinkCustomFieldId?: Maybe<Scalars["String"]["output"]>;
    parentCustomFieldId?: Maybe<Scalars["String"]["output"]>;
    storyPointEstimateCustomFieldId?: Maybe<Scalars["String"]["output"]>;
    storyPointsCustomFieldId?: Maybe<Scalars["String"]["output"]>;
};

export type ArjHierarchyConfigurationLevel = {
    __typename?: "ArjHierarchyConfigurationLevel";
    issueTypes?: Maybe<Array<Scalars["String"]["output"]>>;
    title: Scalars["String"]["output"];
};

export type AssignIssueParentInput = {
    boardId: Scalars["ID"]["input"];
    issueIds: Array<Scalars["ID"]["input"]>;
    issueParentId: Scalars["ID"]["input"];
};

export type AssignIssueParentOutput = MutationResponse & {
    __typename?: "AssignIssueParentOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * This represents a real person that has an account in a wide range of Atlassian products
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 *
 *
 */
export type AtlassianAccountUser = LocalizationContext &
    User & {
        __typename?: "AtlassianAccountUser";
        accountId: Scalars["ID"]["output"];
        accountStatus: AccountStatus;
        canonicalAccountId: Scalars["ID"]["output"];
        characteristics?: Maybe<Scalars["JSON"]["output"]>;
        email?: Maybe<Scalars["String"]["output"]>;
        /**
         * A user may restrict the visibility of their profile information and hence
         * this information may not be available for all callers.
         */
        extendedProfile?: Maybe<AtlassianAccountUserExtendedProfile>;
        id: Scalars["ID"]["output"];
        locale?: Maybe<Scalars["String"]["output"]>;
        name: Scalars["String"]["output"];
        nickname?: Maybe<Scalars["String"]["output"]>;
        orgId?: Maybe<Scalars["ID"]["output"]>;
        picture: Scalars["URL"]["output"];
        zoneinfo?: Maybe<Scalars["String"]["output"]>;
    };

/**
 * A user may restrict the visibility of their profile information and hence
 * this information may not be available for all callers.
 */
export type AtlassianAccountUserExtendedProfile = {
    __typename?: "AtlassianAccountUserExtendedProfile";
    closedDate?: Maybe<Scalars["DateTime"]["output"]>;
    department?: Maybe<Scalars["String"]["output"]>;
    inactiveDate?: Maybe<Scalars["DateTime"]["output"]>;
    jobTitle?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<Scalars["String"]["output"]>;
    organization?: Maybe<Scalars["String"]["output"]>;
    phoneNumbers?: Maybe<Array<Maybe<AtlassianAccountUserPhoneNumber>>>;
};

export type AtlassianAccountUserPhoneNumber = {
    __typename?: "AtlassianAccountUserPhoneNumber";
    type?: Maybe<Scalars["String"]["output"]>;
    value: Scalars["String"]["output"];
};

export type AtlassianOAuthClient = {
    __typename?: "AtlassianOAuthClient";
    /** Callback url where the users are redirected once the authentication is complete */
    callbacks?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Identifier of the client for authentication in ARI format */
    clientARI: Scalars["ID"]["output"];
    /** Identifier of the client for authentication */
    clientID: Scalars["ID"]["output"];
    /** Rotating refresh token status for the auth client */
    refreshToken?: Maybe<RefreshToken>;
    systemUser?: Maybe<SystemUser>;
};

/** Hosting type where Atlassian product instance is installed. */
export enum AtlassianProductHostingType {
    Cloud = "CLOUD",
    DataCenter = "DATA_CENTER",
    Server = "SERVER"
}

export type AtlassianUser = {
    __typename?: "AtlassianUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    companyName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    confluence?: Maybe<ConfluenceUser>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    emails?: Maybe<Array<Maybe<AtlassianUserEmail>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActive?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    locale?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    location?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    photos?: Maybe<Array<Maybe<AtlassianUserPhoto>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    team?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timeZone?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type AtlassianUserEmail = {
    __typename?: "AtlassianUserEmail";
    isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type AtlassianUserPhoto = {
    __typename?: "AtlassianUserPhoto";
    isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Accepts input to attach a data manager to a component. */
export type AttachCompassComponentDataManagerInput = {
    /** The ID of the component to attach a data manager to. */
    componentId: Scalars["ID"]["input"];
    /** An URL of the external source of the component's data. */
    externalSourceURL?: InputMaybe<Scalars["URL"]["input"]>;
};

/** The payload returned from attaching a data manager to a component. */
export type AttachCompassComponentDataManagerPayload = Payload & {
    __typename?: "AttachCompassComponentDataManagerPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type AttachEventSourceInput = {
    /** The ID of the component to attach the event source to. */
    componentId: Scalars["ID"]["input"];
    /** The ID of the event source. */
    eventSourceId: Scalars["ID"]["input"];
};

export type AttachEventSourcePayload = Payload & {
    __typename?: "AttachEventSourcePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type AuditEvent = {
    __typename?: "AuditEvent";
    /** The attributes of an audit event */
    attributes: AuditEventAttributes;
    /** Audit Event Id */
    id: Scalars["ID"]["output"];
    /** Message with content and format to be displayed */
    message?: Maybe<AuditMessageObject>;
};

export type AuditEventAttributes = {
    __typename?: "AuditEventAttributes";
    /** The action for audit log event */
    action: Scalars["String"]["output"];
    /** The Actor who created the event */
    actor?: Maybe<User>;
    /** The Container EventObjects for this event */
    container: Array<Maybe<ContainerEventObject>>;
    /** The Context EventObjects for this event */
    context: Array<Maybe<ContextEventObject>>;
    /** The time when the event occurred */
    time: Scalars["String"]["output"];
};

export type AuditEventEdge = {
    __typename?: "AuditEventEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<AuditEvent>;
};

export type AuditMessageObject = {
    __typename?: "AuditMessageObject";
    content?: Maybe<Scalars["String"]["output"]>;
    format?: Maybe<Scalars["String"]["output"]>;
};

export type AuditsPageInfo = {
    __typename?: "AuditsPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export enum AuthClientType {
    AtlassianMobile = "ATLASSIAN_MOBILE",
    ThirdParty = "THIRD_PARTY",
    ThirdPartyNative = "THIRD_PARTY_NATIVE"
}

export type AuthToken = {
    __typename?: "AuthToken";
    token: Scalars["String"]["output"];
    ttl: Scalars["Int"]["output"];
};

/** This type contains information about the currently logged in user */
export type AuthenticationContext = {
    __typename?: "AuthenticationContext";
    /**
     * Information about the currently logged in user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    user?: Maybe<User>;
};

/** Entry point for auto-suggestion search */
export type AutoSuggestionApi = {
    __typename?: "AutoSuggestionAPI";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suggest?: Maybe<AutoSuggestionNodes>;
};

/** Entry point for auto-suggestion search */
export type AutoSuggestionApiSuggestArgs = {
    filters: AutoSuggestionFilters;
    limit: Scalars["Int"]["input"];
    query?: InputMaybe<Scalars["String"]["input"]>;
};

export type AutoSuggestionFilters = {
    contextType: Scalars["String"]["input"];
    organizationId: Scalars["String"]["input"];
    principalId: Scalars["String"]["input"];
    productKey: Scalars["String"]["input"];
    siteId: Scalars["String"]["input"];
};

export type AutoSuggestionNodes = {
    __typename?: "AutoSuggestionNodes";
    nodes: Array<AutoSuggestionResult>;
    totalCount: Scalars["Int"]["output"];
};

export type AutoSuggestionResult = {
    __typename?: "AutoSuggestionResult";
    title: Scalars["String"]["output"];
    type: Scalars["String"]["output"];
};

/** Payload to invoke an AUX Effect */
export type AuxEffectsInvocationPayload = {
    /** Configuration arguments for the instance of the AUX extension */
    config?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Environment information about where the effects are dispatched from */
    context: Scalars["JSON"]["input"];
    /** A signed token representing the context information of the extension */
    contextToken?: InputMaybe<Scalars["String"]["input"]>;
    /** The effects to action inside the function */
    effects: Array<Scalars["JSON"]["input"]>;
    /** Dynamic data from the extension point */
    extensionPayload?: InputMaybe<Scalars["JSON"]["input"]>;
    /** The current state of the AUX extension */
    state: Scalars["JSON"]["input"];
};

/** A response to an aux invocation */
export type AuxEffectsResult = {
    __typename?: "AuxEffectsResult";
    /** JWT containing verified context data about the invocation */
    contextToken?: Maybe<ForgeContextToken>;
    /**
     * The list of effects in response to an aux effects invocation.
     *
     * Render effects should return valid rendering effects to the invoker,
     * to allow the front-end to render the required content. These are kept as
     * generic JSON blobs since consumers of this API are responsible for defining
     * what these effects look like.
     */
    effects: Array<Scalars["JSON"]["output"]>;
    /** Metrics related to the invocation */
    metrics?: Maybe<InvocationMetrics>;
};

export type AvailableColumnConstraintStatistics = {
    __typename?: "AvailableColumnConstraintStatistics";
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type AvailableContentStates = {
    __typename?: "AvailableContentStates";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customContentStates?: Maybe<Array<Maybe<ContentState>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceContentStates?: Maybe<Array<Maybe<ContentState>>>;
};

export type AvailableEstimations = {
    __typename?: "AvailableEstimations";
    /** Name of the estimation. */
    name: Scalars["String"]["output"];
    /** Unique identifier of the estimation. Temporary naming until we remove "statistic" from Jira. */
    statisticFieldId: Scalars["String"]["output"];
};

/** The input for a Avatar for a Third Party Repository */
export type AvatarInput = {
    /** The description of the avatar. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The URL of the avatar. */
    webUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export enum BackendExperiment {
    Einstein = "EINSTEIN"
}

export type Backlog = {
    __typename?: "Backlog";
    /** List of the assignees of all cards currently displayed on the backlog */
    assignees?: Maybe<Array<Maybe<User>>>;
    /**
     * Temporarily needed to support legacy write API_.  the issue list key to use when creating issue's on the board.
     * Required when creating issues on a board with backlogs
     */
    boardIssueListKey?: Maybe<Scalars["String"]["output"]>;
    /** All issue children which are linked to the cards on the backlog */
    cardChildren: Array<SoftwareCard>;
    /** List of card types which can be created directly on the backlog or sprints */
    cardTypes: Array<Maybe<CardType>>;
    cards: Array<Maybe<SoftwareCard>>;
    /** connect add-ons information */
    extension?: Maybe<BacklogExtension>;
    /** Labels for filtering and adding to cards */
    labels: Array<Maybe<Scalars["String"]["output"]>>;
    /** Whether or not to show the 'migrate this column to your backlog' prompt (set when first enabling backlogs) */
    requestColumnMigration: Scalars["Boolean"]["output"];
};

export type BacklogCardsArgs = {
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type BacklogExtension = {
    __typename?: "BacklogExtension";
    /** list of operations that add-on can perform */
    operations?: Maybe<Array<Maybe<SoftwareOperation>>>;
};

export type BaseSprint = {
    goal?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    sprintMetadata?: Maybe<SoftwareSprintMetadata>;
    sprintState: SprintState;
};

export type BasicBoardFeatureView = Node & {
    __typename?: "BasicBoardFeatureView";
    canEnable?: Maybe<Scalars["Boolean"]["output"]>;
    dependents?: Maybe<Array<Maybe<BoardFeatureView>>>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    imageUri?: Maybe<Scalars["String"]["output"]>;
    learnMoreArticleId?: Maybe<Scalars["String"]["output"]>;
    learnMoreLink?: Maybe<Scalars["String"]["output"]>;
    prerequisites?: Maybe<Array<Maybe<BoardFeatureView>>>;
    /** Possible states: ENABLED, DISABLED, COMING_SOON */
    status?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export type BatchedInlineTasksInput = {
    contentId: Scalars["ID"]["input"];
    tasks: Array<InputMaybe<InlineTask>>;
    trigger?: InputMaybe<PageUpdateTrigger>;
};

export enum BillingSourceSystem {
    Ccp = "CCP",
    Hams = "HAMS"
}

/** Bitbucket Permission Enum */
export enum BitbucketPermission {
    /** Bitbucket admin permission */
    Admin = "ADMIN"
}

export type BitbucketPullRequest = Node & {
    __typename?: "BitbucketPullRequest";
    /** The author of the Bitbucket pull request. */
    author?: Maybe<User>;
    /** The created date of the Bitbucket pull request. */
    createdDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** URL for accessing Bitbucket pull request. */
    href?: Maybe<Scalars["URL"]["output"]>;
    /** The ARI of the Bitbucket pull request. */
    id: Scalars["ID"]["output"];
    /** The state of the Bitbucket pull request. */
    state?: Maybe<Scalars["String"]["output"]>;
    /** The title of the Bitbucket pull request. */
    title: Scalars["String"]["output"];
};

export type BitbucketQuery = {
    __typename?: "BitbucketQuery";
    /**
     * Look up the Bitbucket pull-requests by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    bitbucketPullRequests?: Maybe<Array<Maybe<BitbucketPullRequest>>>;
    /**
     * Look up the Bitbucket repositories by ARIs.
     * The maximum number of ids rest bridge will accept is 50, if this is exceeded null will be returned and an error received
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    bitbucketRepositories?: Maybe<Array<Maybe<BitbucketRepository>>>;
    /**
     * Look up the Bitbucket repository by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    bitbucketRepository?: Maybe<BitbucketRepository>;
    /**
     * Look up the Bitbucket workspace by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    bitbucketWorkspace?: Maybe<BitbucketWorkspace>;
};

export type BitbucketQueryBitbucketPullRequestsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type BitbucketQueryBitbucketRepositoriesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type BitbucketQueryBitbucketRepositoryArgs = {
    id: Scalars["ID"]["input"];
};

export type BitbucketQueryBitbucketWorkspaceArgs = {
    id: Scalars["ID"]["input"];
};

export type BitbucketRepository = CodeRepository &
    Node & {
        __typename?: "BitbucketRepository";
        /** The Bitbucket avatar. */
        avatar?: Maybe<BitbucketRepositoryAvatar>;
        /**
         * The connection entity for DevOps Service relationships for this Bitbucket repository, according to the specified
         * pagination, filtering and sorting.
         */
        devOpsServiceRelationships?: Maybe<DevOpsServiceAndRepositoryRelationshipConnection>;
        /** URL for accessing Bitbucket repository. */
        href?: Maybe<Scalars["URL"]["output"]>;
        /** The ARI of the Bitbucket repository. */
        id: Scalars["ID"]["output"];
        /** Name of Bitbucket repository. */
        name: Scalars["String"]["output"];
        /**
         * URI for accessing Bitbucket repository.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use `href` instead
         */
        webUrl?: Maybe<Scalars["URL"]["output"]>;
        /** Bitbucket workspace the repository is part of. */
        workspace?: Maybe<BitbucketWorkspace>;
    };

export type BitbucketRepositoryDevOpsServiceRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndRepositoryRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<DevOpsServiceAndRepositoryRelationshipSort>;
};

export type BitbucketRepositoryAvatar = {
    __typename?: "BitbucketRepositoryAvatar";
    /** URI for retrieving Bitbucket avatar. */
    url: Scalars["URL"]["output"];
};

export type BitbucketRepositoryConnection = {
    __typename?: "BitbucketRepositoryConnection";
    edges?: Maybe<Array<Maybe<BitbucketRepositoryEdge>>>;
    nodes?: Maybe<Array<Maybe<BitbucketRepository>>>;
    pageInfo: PageInfo;
};

export type BitbucketRepositoryEdge = {
    __typename?: "BitbucketRepositoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<BitbucketRepository>;
};

export type BitbucketRepositoryIdConnection = {
    __typename?: "BitbucketRepositoryIdConnection";
    edges?: Maybe<Array<Maybe<BitbucketRepositoryIdEdge>>>;
    pageInfo: PageInfo;
};

export type BitbucketRepositoryIdEdge = {
    __typename?: "BitbucketRepositoryIdEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<BitbucketRepository>;
};

export type BitbucketWorkspace = Node & {
    __typename?: "BitbucketWorkspace";
    /** The ARI of the Bitbucket workspace. */
    id: Scalars["ID"]["output"];
    /** Name of the Bitbucket workspace. */
    name: Scalars["String"]["output"];
    /**
     * List of Bitbucket Repositories belong to the Bitbucket Workspace
     * The returned repositories are filtered based on user permission and role-value specified by permissionFilter argument.
     * If no permissionFilter specified, the list contains all repositories that user can access.
     */
    repositories?: Maybe<BitbucketRepositoryConnection>;
};

export type BitbucketWorkspaceRepositoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    permissionFilter?: InputMaybe<BitbucketPermission>;
};

/** Represents a block-rendered smart-link on a page */
export type BlockSmartLink = SmartLink & {
    __typename?: "BlockSmartLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type BlockedAccessEmpowerment = {
    __typename?: "BlockedAccessEmpowerment";
    isCurrentUserEmpowered: Scalars["Boolean"]["output"];
    subjectId: Scalars["String"]["output"];
};

export type BlockedAccessRestrictions = {
    __typename?: "BlockedAccessRestrictions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    blockedAccessEmpowerment: Array<Maybe<BlockedAccessEmpowerment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    blockedAccessRestrictionSummary: Array<
        Maybe<SubjectRestrictionHierarchySummary>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canFixRestrictionsForAllSubjects: Scalars["Boolean"]["output"];
};

export type BlockedAccessSubject = {
    __typename?: "BlockedAccessSubject";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectType: BlockedAccessSubjectType;
};

export type BlockedAccessSubjectInput = {
    subjectId: Scalars["ID"]["input"];
    subjectType: BlockedAccessSubjectType;
};

export enum BlockedAccessSubjectType {
    Group = "GROUP",
    User = "USER"
}

export type BoardCardMoveInput = {
    /** the ID of a board */
    boardId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The IDs of cards to move */
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    /** Card information on where card should be positioned */
    rank?: InputMaybe<CardRank>;
    /** The swimlane position, which might set additional fields */
    swimlaneId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the transition */
    transition?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BoardEditConfig = {
    __typename?: "BoardEditConfig";
    /** Configuration for showing inline card create */
    inlineCardCreate?: Maybe<InlineCardCreateConfig>;
    /** Configuration for showing inline column mutations */
    inlineColumnEdit?: Maybe<InlineColumnEditConfig>;
};

export type BoardFeature = {
    __typename?: "BoardFeature";
    category: Scalars["String"]["output"];
    key?: Maybe<Scalars["SoftwareBoardFeatureKey"]["output"]>;
    prerequisites?: Maybe<Array<Maybe<BoardFeature>>>;
    status?: Maybe<BoardFeatureStatus>;
    toggle?: Maybe<BoardFeatureToggleStatus>;
};

/** Relay connection definition for a list of board features */
export type BoardFeatureConnection = {
    __typename?: "BoardFeatureConnection";
    edges?: Maybe<Array<Maybe<BoardFeatureEdge>>>;
    pageInfo?: Maybe<PageInfo>;
};

/** Relay edge definition for a board feature */
export type BoardFeatureEdge = {
    __typename?: "BoardFeatureEdge";
    /** The cursor position of this edge. Used for pagination */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The feature group of the edge */
    node?: Maybe<BoardFeatureView>;
};

export type BoardFeatureGroup = Node & {
    __typename?: "BoardFeatureGroup";
    /** The board features in this group */
    features?: Maybe<BoardFeatureConnection>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type BoardFeatureGroupFeaturesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Relay connection definition for a list of board feature groups */
export type BoardFeatureGroupConnection = {
    __typename?: "BoardFeatureGroupConnection";
    /** The list of edges of this connection */
    edges?: Maybe<Array<Maybe<BoardFeatureGroupEdge>>>;
    /** Page detail for pagination */
    pageInfo?: Maybe<PageInfo>;
};

/** Relay edge definition for a board feature group */
export type BoardFeatureGroupEdge = {
    __typename?: "BoardFeatureGroupEdge";
    /** The cursor position of this edge. Used for pagination */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The board feature group of the edge */
    node?: Maybe<BoardFeatureGroup>;
};

export enum BoardFeatureStatus {
    ComingSoon = "COMING_SOON",
    Disabled = "DISABLED",
    Enabled = "ENABLED"
}

export enum BoardFeatureToggleStatus {
    Disabled = "DISABLED",
    Enabled = "ENABLED"
}

export type BoardFeatureView =
    | BasicBoardFeatureView
    | EstimationBoardFeatureView;

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScope = Node & {
    __typename?: "BoardScope";
    /**
     *  Admins for the board
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: admins` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    admins?: Maybe<Array<Maybe<Admin>>>;
    /** Null if there's no backlog */
    backlog?: Maybe<Backlog>;
    board?: Maybe<SoftwareBoard>;
    /**
     * Board admins details, only support CMP boards for now
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'boardAdmins' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    boardAdmins?: Maybe<JswBoardAdmins>;
    /**
     * Board location details
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'boardLocationModel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    boardLocationModel?: Maybe<JswBoardLocationModel>;
    /**
     *  Board administration permission for multiple board support
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: canAdministerBoard` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    canAdministerBoard?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Card color configuration
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'cardColorConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    cardColorConfig?: Maybe<JswCardColorConfig>;
    /**
     * Card layout configuration
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'cardLayoutConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    cardLayoutConfig?: Maybe<JswCardLayoutConfig>;
    /** Card parents (AKA Epics) for filtering and adding to cards */
    cardParents: Array<Maybe<CardParent>>;
    /** Cards in the board scope with given card IDs */
    cards: Array<Maybe<SoftwareCard>>;
    /**
     *  Columns configuration for the board settings page
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'columnsConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    columnsConfig?: Maybe<ColumnsConfigPage>;
    /** Information about the user making this request. */
    currentUser: CurrentUser;
    /** Custom filters for this board scope */
    customFilters?: Maybe<Array<Maybe<CustomFilter>>>;
    /**
     *  Custom Filters configuration for the board settings page
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'customFiltersConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    customFiltersConfig?: Maybe<CustomFiltersConfig>;
    /** Estimation type currently configured for the board. */
    estimation?: Maybe<EstimationConfig>;
    /**
     * List of all feature groups on the board. This is similar to the list of features, but support groupings for the frontend to render
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: featureGroups` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    featureGroups?: Maybe<BoardFeatureGroupConnection>;
    /** List of all features on the board, and their state. */
    features: Array<Maybe<BoardFeature>>;
    /** Return filtered card Ids on applying custom filters or filterJql or both */
    filteredCardIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /**
     * Additional fields required for card creation when GIC is triggered on board or backlog
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: globalCardCreateAdditionalFields` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    globalCardCreateAdditionalFields?: Maybe<GlobalCardCreateAdditionalFields>;
    /** Id of the board. Maps to the boardId in Jira. */
    id: Scalars["ID"]["output"];
    /**
     * Whether the board JQL contains more than one project
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'isCrossProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isCrossProject?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *  Jql for the board
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: jql` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    jql?: Maybe<Scalars["String"]["output"]>;
    /**
     *  -- FIELDS BELOW ONLY SUPPORTED WITH softwareBoards QUERY -- DO NOT USE OTHERWISE --
     *  Name of the board.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: name` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Old done issue cut off configuration
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'oldDoneIssuesCutOffConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    oldDoneIssuesCutOffConfig?: Maybe<JswOldDoneIssuesCutOffConfig>;
    /** The project location for this board scope */
    projectLocation: SoftwareProject;
    /** List of reports on this board.  null if reports are not enabled on this board. */
    reports?: Maybe<SoftwareReports>;
    /**
     * Roadmap configuration for the board settings page
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'roadmapConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    roadmapConfig?: Maybe<JswBoardScopeRoadmapConfig>;
    /**
     * Saved filter configuration, only support CMP for now
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'savedFilterConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    savedFilterConfig?: Maybe<JswSavedFilterConfig>;
    /**
     * Epic panel configuration for CMP boards
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'showEpicAsPanel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    showEpicAsPanel?: Maybe<Scalars["Boolean"]["output"]>;
    /** Request sprint by Id. */
    sprint?: Maybe<Sprint>;
    /**
     *  Sprint with statistics
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "sprintWithStatistics")' query directive to the 'sprintWithStatistics' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintWithStatistics?: Maybe<Array<Maybe<SprintWithStatistics>>>;
    /** Null if sprints are disabled (empty if there are no sprints) */
    sprints?: Maybe<Array<Maybe<Sprint>>>;
    /**
     * Request sprint prototype by Id to be used with start sprint modal.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: startSprintPrototype` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    startSprintPrototype?: Maybe<Sprint>;
    /**
     * Board subquery configuration
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'subqueryConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    subqueryConfig?: Maybe<JswSubqueryConfig>;
    /**
     * Time tracking config, current only support CMP boards
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'trackingStatistic' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    trackingStatistic?: Maybe<JswTrackingStatistic>;
    /** Current user's swimlane-strategy, NONE if SWAG was unable to retrieve it */
    userSwimlaneStrategy?: Maybe<SwimlaneStrategy>;
    /**
     * Working days configuration
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'workingDaysConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    workingDaysConfig?: Maybe<JswWorkingDaysConfig>;
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeCardsArgs = {
    cardIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeFilteredCardIdsArgs = {
    customFilterIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    filterJql?: InputMaybe<Scalars["String"]["input"]>;
    issueIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeSprintArgs = {
    sprintId: Scalars["ID"]["input"];
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeSprintWithStatisticsArgs = {
    sprintIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeSprintsArgs = {
    state?: InputMaybe<Array<InputMaybe<SprintState>>>;
};

/** Root node for queries about simple / agility / nextgen boards. */
export type BoardScopeStartSprintPrototypeArgs = {
    sprintId: Scalars["ID"]["input"];
};

export type BoardScopeConnection = {
    __typename?: "BoardScopeConnection";
    edges?: Maybe<Array<Maybe<BoardScopeEdge>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type BoardScopeEdge = {
    __typename?: "BoardScopeEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<BoardScope>;
};

/** Available strategies for grouping issues into swimlanes for a classic board */
export enum BoardSwimlaneStrategy {
    AssigneeUnassignedFirst = "ASSIGNEE_UNASSIGNED_FIRST",
    AssigneeUnassignedLast = "ASSIGNEE_UNASSIGNED_LAST",
    Custom = "CUSTOM",
    Epic = "EPIC",
    IssueChildren = "ISSUE_CHILDREN",
    IssueParent = "ISSUE_PARENT",
    None = "NONE",
    ParentChild = "PARENT_CHILD",
    Project = "PROJECT",
    RequestType = "REQUEST_TYPE"
}

export enum BodyFormatType {
    AnonymousExportView = "ANONYMOUS_EXPORT_VIEW",
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Editor = "EDITOR",
    Editor2 = "EDITOR2",
    ExportView = "EXPORT_VIEW",
    Storage = "STORAGE",
    StyledView = "STYLED_VIEW",
    View = "VIEW"
}

export type BooleanUserInput = {
    type: BooleanUserInputType;
    value?: InputMaybe<Scalars["Boolean"]["input"]>;
    variableName: Scalars["String"]["input"];
};

export enum BooleanUserInputType {
    Boolean = "BOOLEAN"
}

export type BordersAndDividersLookAndFeel = {
    __typename?: "BordersAndDividersLookAndFeel";
    color?: Maybe<Scalars["String"]["output"]>;
};

export type Breadcrumb = {
    __typename?: "Breadcrumb";
    label?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
    separator?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum BuiltinPolarisIdeaField {
    /** Jira Product Discovery fields */
    Archived = "ARCHIVED",
    ArchivedBy = "ARCHIVED_BY",
    ArchivedOn = "ARCHIVED_ON",
    /** Jira fields */
    Assignee = "ASSIGNEE",
    AtlasGoal = "ATLAS_GOAL",
    AtlasProject = "ATLAS_PROJECT",
    AtlasProjectStatus = "ATLAS_PROJECT_STATUS",
    AtlasProjectTarget = "ATLAS_PROJECT_TARGET",
    Created = "CREATED",
    Creator = "CREATOR",
    DeliveryProgress = "DELIVERY_PROGRESS",
    DeliveryStatus = "DELIVERY_STATUS",
    Description = "DESCRIPTION",
    IssueComments = "ISSUE_COMMENTS",
    IssueId = "ISSUE_ID",
    IssueType = "ISSUE_TYPE",
    Key = "KEY",
    Labels = "LABELS",
    LinkedIssues = "LINKED_ISSUES",
    NumDataPoints = "NUM_DATA_POINTS",
    Reporter = "REPORTER",
    Status = "STATUS",
    Summary = "SUMMARY",
    Updated = "UPDATED",
    Votes = "VOTES"
}

export type BulkActionsFeature = {
    __typename?: "BulkActionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type BulkArchivePagePayload = {
    __typename?: "BulkArchivePagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type BulkArchivePagesInput = {
    archiveNote?: InputMaybe<Scalars["String"]["input"]>;
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    descendantsNoteApplicationOption?: InputMaybe<DescendantsNoteApplicationOption>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

/** Accepts input for deleting multiple existing components. */
export type BulkDeleteCompassComponentsInput = {
    /** A list of IDs of components being deleted. All IDs must belong in the same workspace. */
    ids: Array<Scalars["ID"]["input"]>;
};

/** The payload returned from deleting existing components. */
export type BulkDeleteCompassComponentsPayload = Payload & {
    __typename?: "BulkDeleteCompassComponentsPayload";
    /** The ID of the components that were deleted. */
    deletedComponentIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** A list of errors that occurred during all delete mutations. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the entire mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type BulkDeleteContentDataClassificationLevelInput = {
    contentStatuses: Array<
        InputMaybe<ContentDataClassificationMutationContentStatus>
    >;
    id: Scalars["Long"]["input"];
};

export type BulkDeleteContentDataClassificationLevelPayload = Payload & {
    __typename?: "BulkDeleteContentDataClassificationLevelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * ###################################################################################################################
 *  COMPASS MUTATION RESPONSES
 * ###################################################################################################################
 */
export type BulkMutationErrorExtension = MutationErrorExtension & {
    __typename?: "BulkMutationErrorExtension";
    /**
     * A code representing the type of error. See the CompassErrorType enum for possible values
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the entity in the input list that caused the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * A numerical code (such as an HTTP status code) representing the error category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** This type contains information about the resource and the permission */
export type BulkPermittedResponse = {
    __typename?: "BulkPermittedResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissionId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permitted?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceId?: Maybe<Scalars["String"]["output"]>;
};

export type BulkRemoveRoleAssignmentFromSpacesInput = {
    principal: RoleAssignmentPrincipalInput;
    spaceTypes: Array<InputMaybe<BulkRoleAssignmentSpaceType>>;
};

export type BulkRemoveRoleAssignmentFromSpacesPayload = Payload & {
    __typename?: "BulkRemoveRoleAssignmentFromSpacesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export enum BulkRoleAssignmentSpaceType {
    Collaboration = "COLLABORATION",
    Global = "GLOBAL",
    KnowledgeBase = "KNOWLEDGE_BASE",
    Personal = "PERSONAL"
}

export type BulkSetRoleAssignmentToSpacesInput = {
    roleAssignment: RoleAssignment;
    spaceTypes: Array<InputMaybe<BulkRoleAssignmentSpaceType>>;
};

export type BulkSetRoleAssignmentToSpacesPayload = Payload & {
    __typename?: "BulkSetRoleAssignmentToSpacesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export type BulkSetSpacePermissionAsyncPayload = Payload & {
    __typename?: "BulkSetSpacePermissionAsyncPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export type BulkSetSpacePermissionInput = {
    spacePermissions: Array<InputMaybe<SpacePermissionType>>;
    spaceTypes: Array<InputMaybe<BulkSetSpacePermissionSpaceType>>;
    subjectId: Scalars["ID"]["input"];
    subjectType: BulkSetSpacePermissionSubjectType;
};

export type BulkSetSpacePermissionPayload = Payload & {
    __typename?: "BulkSetSpacePermissionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spacesUpdatedCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum BulkSetSpacePermissionSpaceType {
    Collaboration = "COLLABORATION",
    Global = "GLOBAL",
    KnowledgeBase = "KNOWLEDGE_BASE",
    Personal = "PERSONAL"
}

export enum BulkSetSpacePermissionSubjectType {
    Group = "GROUP",
    User = "USER"
}

/** Accepts input for updating multiple existing components. */
export type BulkUpdateCompassComponentsInput = {
    /** A list of IDs of components being updated. All IDs must belong in the same workspace. */
    ids: Array<Scalars["ID"]["input"]>;
    /** The updated state of the components. */
    state?: InputMaybe<Scalars["String"]["input"]>;
};

/** The payload returned from updating multiple existing components. */
export type BulkUpdateCompassComponentsPayload = Payload & {
    __typename?: "BulkUpdateCompassComponentsPayload";
    /**
     * The details of the components that were successfully updated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<Array<CompassComponent>>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful for ALL components or not. */
    success: Scalars["Boolean"]["output"];
};

export type BulkUpdateContentDataClassificationLevelInput = {
    classificationLevelId: Scalars["ID"]["input"];
    contentStatuses: Array<
        InputMaybe<ContentDataClassificationMutationContentStatus>
    >;
    id: Scalars["Long"]["input"];
};

export type BulkUpdateContentDataClassificationLevelPayload = Payload & {
    __typename?: "BulkUpdateContentDataClassificationLevelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type BulkUpdateMainSpaceSidebarLinksInput = {
    hidden: Scalars["Boolean"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    linkIdentifier?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<SpaceSidebarLinkType>;
};

/** Burndown chart focuses on remaining scope over time */
export type BurndownChart = {
    __typename?: "BurndownChart";
    /** Burndown charts are graphing the remaining over time */
    chart: BurndownChartData;
    /** Filters for the report */
    filters: SprintReportsFilters;
};

/** Burndown chart focuses on remaining scope over time */
export type BurndownChartChartArgs = {
    estimation?: InputMaybe<SprintReportsEstimationStatisticType>;
    sprintId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type BurndownChartData = {
    __typename?: "BurndownChartData";
    /** the set end time of the sprint, not when the sprint completed */
    endTime?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * data for a sprint scope change
     * each point are assumed to be scope change during a sprint
     */
    scopeChangeEvents: Array<Maybe<SprintScopeChangeData>>;
    /**
     * data for sprint end event
     * can be null if sprint has not been completed yet
     */
    sprintEndEvent?: Maybe<SprintEndData>;
    /** data for sprint start event */
    sprintStartEvent: SprintStartData;
    /** the start time of the sprint */
    startTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** data for the table */
    table?: Maybe<BurndownChartDataTable>;
    /** the current user's timezone */
    timeZone?: Maybe<Scalars["String"]["output"]>;
};

export type BurndownChartDataTable = {
    __typename?: "BurndownChartDataTable";
    completedIssues: Array<Maybe<BurndownChartDataTableIssueRow>>;
    completedIssuesOutsideOfSprint: Array<
        Maybe<BurndownChartDataTableIssueRow>
    >;
    incompleteIssues: Array<Maybe<BurndownChartDataTableIssueRow>>;
    issuesRemovedFromSprint: Array<Maybe<BurndownChartDataTableIssueRow>>;
    scopeChanges: Array<Maybe<BurndownChartDataTableScopeChangeRow>>;
};

export type BurndownChartDataTableIssueRow = {
    __typename?: "BurndownChartDataTableIssueRow";
    assignee?: Maybe<User>;
    cardParent?: Maybe<CardParent>;
    cardStatus?: Maybe<CardStatus>;
    cardType?: Maybe<CardType>;
    estimate?: Maybe<Scalars["Float"]["output"]>;
    issueKey: Scalars["String"]["output"];
    issueSummary: Scalars["String"]["output"];
};

export type BurndownChartDataTableScopeChangeRow = {
    __typename?: "BurndownChartDataTableScopeChangeRow";
    cardParent?: Maybe<CardParent>;
    cardType?: Maybe<CardType>;
    sprintScopeChange: SprintScopeChangeData;
    timestamp: Scalars["DateTime"]["output"];
};

export type Business = {
    __typename?: "Business";
    /** List of End-User Data type with respect to which the app is a "business" */
    endUserDataTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Is the app a "business" under the California Consumer Privacy Act of 2018 (CCPA)? */
    isAppBusiness: AcceptableResponse;
};

export type ButtonLookAndFeel = {
    __typename?: "ButtonLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    color?: Maybe<Scalars["String"]["output"]>;
};

export type Caiq = {
    __typename?: "CAIQ";
    /** Link for CAIQ Lite Questionnaire responses */
    CAIQLiteLink?: Maybe<Scalars["String"]["output"]>;
    /** Has the CAIQ Lite Questionnaire that covers this app been completed? */
    isCAIQCompleted: Scalars["Boolean"]["output"];
};

export type CcpaDetails = {
    __typename?: "CCPADetails";
    business?: Maybe<Business>;
    serviceProvider?: Maybe<ServiceProvider>;
};

/**
 * Report pagination
 * -----------------
 */
export type CfdChartConnection = {
    __typename?: "CFDChartConnection";
    edges: Array<Maybe<CfdChartEdge>>;
    pageInfo: PageInfo;
};

/**
 * Report data
 * -----------------
 */
export type CfdChartData = {
    __typename?: "CFDChartData";
    changes: Array<Maybe<CfdIssueColumnChangeEntry>>;
    columnCounts: Array<Maybe<CfdColumnCount>>;
    timestamp: Scalars["DateTime"]["output"];
};

export type CfdChartEdge = {
    __typename?: "CFDChartEdge";
    cursor: Scalars["String"]["output"];
    node: CfdChartData;
};

export type CfdColumn = {
    __typename?: "CFDColumn";
    name: Scalars["String"]["output"];
};

export type CfdColumnCount = {
    __typename?: "CFDColumnCount";
    columnIndex: Scalars["Int"]["output"];
    count: Scalars["Int"]["output"];
};

/**
 * Report filters
 * --------------
 */
export type CfdFilters = {
    __typename?: "CFDFilters";
    columns: Array<Maybe<CfdColumn>>;
};

export type CfdIssueColumnChangeEntry = {
    __typename?: "CFDIssueColumnChangeEntry";
    columnFrom?: Maybe<Scalars["Int"]["output"]>;
    columnTo?: Maybe<Scalars["Int"]["output"]>;
    key?: Maybe<Scalars["ID"]["output"]>;
    point?: Maybe<TimeSeriesPoint>;
    statusTo?: Maybe<Scalars["ID"]["output"]>;
    /** in ISO 8601 format */
    timestamp: Scalars["String"]["output"];
};

export type CqlDisplayableType = {
    __typename?: "CQLDisplayableType";
    i18nKey?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type CanvasToken = {
    __typename?: "CanvasToken";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    expiryDateTime: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    token: Scalars["String"]["output"];
};

export enum CapabilitySet {
    CapabilityAdvanced = "capabilityAdvanced",
    CapabilityStandard = "capabilityStandard"
}

export type CardCoverMedia = {
    __typename?: "CardCoverMedia";
    attachmentId?: Maybe<Scalars["Long"]["output"]>;
    attachmentMediaApiId?: Maybe<Scalars["ID"]["output"]>;
    clientId?: Maybe<Scalars["String"]["output"]>;
    /** endpoint to retrieve the media from */
    endpointUrl?: Maybe<Scalars["String"]["output"]>;
    /** true if this card has media, but it's explicity been hidden by the user */
    hiddenByUser: Scalars["Boolean"]["output"];
    token?: Maybe<Scalars["String"]["output"]>;
};

export enum CardHierarchyLevelEnumType {
    Base = "BASE",
    Child = "CHILD",
    Parent = "PARENT"
}

export type CardMediaConfig = {
    __typename?: "CardMediaConfig";
    /** Whether or not to show card media on this board */
    enabled: Scalars["Boolean"]["output"];
};

export type CardParent = {
    __typename?: "CardParent";
    /** Card type */
    cardType?: Maybe<CardType>;
    /** Some info about its children */
    childrenInfo?: Maybe<SoftwareCardChildrenInfo>;
    /** The card color */
    color?: Maybe<Scalars["CardPaletteColor"]["output"]>;
    /** The due date set on the issue parent */
    dueDate?: Maybe<Scalars["String"]["output"]>;
    /** Card id */
    id: Scalars["ID"]["output"];
    /** Card key */
    key: Scalars["String"]["output"];
    /** The start date set on the issue parent */
    startDate?: Maybe<Scalars["String"]["output"]>;
    /** Card status */
    status?: Maybe<CardStatus>;
    /** Card summary */
    summary: Scalars["String"]["output"];
};

export type CardParentCreateInput = {
    boardId: Scalars["ID"]["input"];
    newIssueParents: Array<NewCardParent>;
};

export type CardParentCreateOutput = MutationResponse & {
    __typename?: "CardParentCreateOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    newCardParents?: Maybe<Array<Maybe<CardParent>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CardParentRankInput = {
    boardId: Scalars["ID"]["input"];
    issueParentIds: Array<Scalars["ID"]["input"]>;
    rankAfterIssueParentId?: InputMaybe<Scalars["Long"]["input"]>;
    rankBeforeIssueParentId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type CardPriority = {
    __typename?: "CardPriority";
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type CardRank = {
    /** The card that is after this card */
    afterCardId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The card that is before this card */
    beforeCardId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CardStatus = {
    __typename?: "CardStatus";
    /** Which status category this statue belongs to.  Values:  "undefined" | "new" (ie todo) | "indeterminate" (aka "in progress") | "done" */
    category?: Maybe<Scalars["String"]["output"]>;
    /** Card status id */
    id?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'isPresentInWorkflow' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isPresentInWorkflow?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'isResolutionDone' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isResolutionDone?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Issue meta data associated with this status
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'issueMetaData' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMetaData?: Maybe<JswCardStatusIssueMetaData>;
    /** Card status name */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type CardType = {
    __typename?: "CardType";
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: SoftwareCardTypeExternalId` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    externalId?: Maybe<Scalars["ID"]["output"]>;
    /** Whether the Card type has required fields aside from the default ones */
    hasRequiredFields?: Maybe<Scalars["Boolean"]["output"]>;
    /** The type of hierarchy level that card type belongs to */
    hierarchyLevelType?: Maybe<Scalars["CardTypeHierarchyLevelType"]["output"]>;
    /** URL to the icon to show for this card type */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The configuration for creating cards with this type inline. */
    inlineCardCreate?: Maybe<InlineCardCreateConfig>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export enum CatchupContentType {
    Blogpost = "BLOGPOST",
    Page = "PAGE"
}

export type CatchupEditMetadataForContent = {
    __typename?: "CatchupEditMetadataForContent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collaborators?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasVersionChangedSinceLastVisit?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastVisitTimeISO?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    users?: Maybe<Array<Maybe<Person>>>;
};

export type CatchupLastViewedTimeResponse = {
    __typename?: "CatchupLastViewedTimeResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastViewedTimeISO?: Maybe<Scalars["String"]["output"]>;
};

export enum CatchupOverviewUpdateType {
    SinceLastViewed = "SINCE_LAST_VIEWED",
    SinceLastViewedMarkdown = "SINCE_LAST_VIEWED_MARKDOWN"
}

export type CatchupVersionDiffMetadataResponse = {
    __typename?: "CatchupVersionDiffMetadataResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collaborators?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDiffEmpty?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CcpAccountDetails = CommerceAccountDetails & {
    __typename?: "CcpAccountDetails";
    invoiceGroup?: Maybe<CcpInvoiceGroup>;
    invoiceGroupId?: Maybe<Scalars["ID"]["output"]>;
    transactionAccountId?: Maybe<Scalars["ID"]["output"]>;
};

export enum CcpActivationReason {
    AdvantagePricing = "ADVANTAGE_PRICING",
    DefaultPricing = "DEFAULT_PRICING",
    ExperimentalPricing = "EXPERIMENTAL_PRICING"
}

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpAddPaymentMethodExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpAddPaymentMethodExperienceCapability";
        /**
         * The URL of the experience. It will be null if the experience is not available to the user.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

export type CcpApplicationReason = {
    __typename?: "CcpApplicationReason";
    id?: Maybe<Scalars["ID"]["output"]>;
};

export enum CcpBehaviourAtEndOfTrial {
    /** Cancels the entitlement after trial ends */
    Cancel = "CANCEL",
    /** Converts the trial to paid after trial ends */
    ConvertToPaid = "CONVERT_TO_PAID",
    /** Reverts to previous offering after trial ends */
    RevertTrial = "REVERT_TRIAL"
}

export type CcpBenefit = {
    __typename?: "CcpBenefit";
    duration?: Maybe<CcpDuration>;
    iterations?: Maybe<Scalars["Int"]["output"]>;
    value?: Maybe<Scalars["Float"]["output"]>;
};

export enum CcpBillingInterval {
    Day = "DAY",
    Month = "MONTH",
    Week = "WEEK",
    Year = "YEAR"
}

export type CcpBillingPeriodDetails = {
    __typename?: "CcpBillingPeriodDetails";
    billingAnchorTimestamp?: Maybe<Scalars["Float"]["output"]>;
    nextBillingTimestamp?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can cancel entitlement.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpCancelEntitlementExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpCancelEntitlementExperienceCapability";
        /** The URL to access the experience. */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
        /** Reason code for why entitlement can not be cancelled. Null if entitlement can be cancelled */
        reasonCode?: Maybe<CcpCancelEntitlementExperienceCapabilityReasonCode>;
    };

export enum CcpCancelEntitlementExperienceCapabilityReasonCode {
    EntitlementIsCollectionInstance = "ENTITLEMENT_IS_COLLECTION_INSTANCE"
}

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpChangeOfferingExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpChangeOfferingExperienceCapability";
        /**
         * The URL of the experience. It will be null if the experience is not available to the user.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

/**
 * ChargeDetails are details for the current offering customer is being billed for, so if customer is trialing
 * Premium from Standard offering, the charge details will reflect existing Standard offering. If customer is trialing
 * a paid offering (Standard/Premium) from the Free one, the charge details will reflect the current paid trialing offering.
 */
export type CcpChargeDetails = CommerceChargeDetails & {
    __typename?: "CcpChargeDetails";
    chargeQuantities?: Maybe<Array<Maybe<CcpChargeQuantity>>>;
    /**
     * The list price estimates (also known as "gross list price”, or “GLP) is a standard price without GST, any discounts or
     * promotions applied as opposed to the billing-estimate API. Purpose of such estimate is mainly to show customer
     * the standard price for the offering without being specific to the current customer.
     */
    listPriceEstimates?: Maybe<Array<Maybe<CcpListPriceEstimate>>>;
    offeringId?: Maybe<Scalars["ID"]["output"]>;
    pricingPlanId?: Maybe<Scalars["ID"]["output"]>;
    promotionInstances?: Maybe<Array<Maybe<CcpPromotionInstance>>>;
};

export type CcpChargeElement = CommerceChargeElement & {
    __typename?: "CcpChargeElement";
    ceiling?: Maybe<Scalars["Int"]["output"]>;
    unit?: Maybe<Scalars["String"]["output"]>;
};

export type CcpChargeQuantity = CommerceChargeQuantity & {
    __typename?: "CcpChargeQuantity";
    chargeElement?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedAt?: Maybe<Scalars["Float"]["output"]>;
    quantity?: Maybe<Scalars["Float"]["output"]>;
};

export enum CcpChargeType {
    AutoScaling = "AUTO_SCALING",
    Licensed = "LICENSED",
    Metered = "METERED"
}

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpConfigurePaymentMethodExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpConfigurePaymentMethodExperienceCapability";
        /**
         * The URL of the experience. It will be null if the experience is not available to the user.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

export type CcpContext = {
    __typename?: "CcpContext";
    authMechanism?: Maybe<Scalars["String"]["output"]>;
    clientAsapIssuer?: Maybe<Scalars["String"]["output"]>;
    subject?: Maybe<Scalars["String"]["output"]>;
    subjectType?: Maybe<Scalars["String"]["output"]>;
};

export type CcpCreateEntitlementExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpCreateEntitlementExperienceCapability";
        /** A message to explain why the entitlement can not be created. Null if entitlement can be created with request parameters. */
        errorDescription?: Maybe<Scalars["String"]["output"]>;
        /** Reason code for why entitlement can not be created. Null if entitlement can be created with request parameters. */
        errorReasonCode?: Maybe<CcpCreateEntitlementExperienceCapabilityErrorReasonCode>;
        /**
         * The URL of the experience. It will be returned even if the experience is not available to the user.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

export enum CcpCreateEntitlementExperienceCapabilityErrorReasonCode {
    MultipleTransactionAccount = "MULTIPLE_TRANSACTION_ACCOUNT",
    UsecaseNotImplemented = "USECASE_NOT_IMPLEMENTED"
}

export type CcpCreateEntitlementExperienceOptions = {
    /** Configures what is displayed on confirmation screen */
    confirmationScreen?: InputMaybe<CcpCreateEntitlementExperienceOptionsConfirmationScreen>;
};

export enum CcpCreateEntitlementExperienceOptionsConfirmationScreen {
    /** Show comparison screen for confirmation screen */
    Comparison = "COMPARISON",
    /** Show default screen for confirmation screen */
    Default = "DEFAULT"
}

export type CcpCreateEntitlementInput = {
    /** Options to modify experience screens in creation order flow */
    experienceOptions?: InputMaybe<CcpCreateEntitlementExperienceOptions>;
    /** The offering ID to create entitlement for */
    offeringKey: Scalars["ID"]["input"];
    /** Options for the order to create the entitlement */
    orderOptions?: InputMaybe<CcpCreateEntitlementOrderOptions>;
    /**
     * Relates to entitlement for the created entitlement. Used to pull in
     * existing entitlements to the order i.e. used to add existing entitlements
     * to the collection entitlement being created
     */
    relatesToEntitlements?: InputMaybe<Array<CcpCreateEntitlementRelatesTo>>;
};

export type CcpCreateEntitlementOrderOptions = {
    /** Which billing cycle to create the entitlement for, only MONTH and YEAR is supported at the moment. Defaults to MONTH if not provided */
    billingCycle?: InputMaybe<CcpBillingInterval>;
    /** The provisioning request identifier */
    provisioningRequestId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Trial intent */
    trial?: InputMaybe<CcpCreateEntitlementTrialIntent>;
};

export type CcpCreateEntitlementRelatesTo = {
    entitlement?: InputMaybe<CcpEntitlementDetailsForCreateEntitlement>;
};

export type CcpCreateEntitlementTrialIntent = {
    /**
     * Configures behavior at end of trial to support auto/non-auto converting trials
     * https://hello.atlassian.net/wiki/spaces/tintin/pages/4544550787/Offering+Types+and+Valid+Trial+Intent+Behaviours
     */
    behaviourAtEndOfTrial?: InputMaybe<CcpBehaviourAtEndOfTrial>;
    /** Should entitlement be created without trial */
    skipTrial?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum CcpCurrency {
    Jpy = "JPY",
    Usd = "USD"
}

export type CcpCustomisedValues = {
    __typename?: "CcpCustomisedValues";
    applicationReason?: Maybe<CcpApplicationReason>;
    benefits?: Maybe<Array<Maybe<CcpBenefit>>>;
};

export type CcpCycle = CommercePrimaryCycle & {
    __typename?: "CcpCycle";
    count?: Maybe<Scalars["Int"]["output"]>;
    interval?: Maybe<CcpBillingInterval>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type CcpDerivedFromOffering = {
    __typename?: "CcpDerivedFromOffering";
    originalOfferingKey?: Maybe<Scalars["ID"]["output"]>;
    templateId?: Maybe<Scalars["ID"]["output"]>;
    templateVersion?: Maybe<Scalars["Int"]["output"]>;
};

export type CcpDerivedOffering = {
    __typename?: "CcpDerivedOffering";
    generatedOfferingKey?: Maybe<Scalars["ID"]["output"]>;
    templateId?: Maybe<Scalars["ID"]["output"]>;
    templateVersion?: Maybe<Scalars["Int"]["output"]>;
};

export enum CcpDuration {
    Forever = "FOREVER",
    Once = "ONCE",
    Repeating = "REPEATING"
}

/**
 * An effective uncollectible action represents the action that an offering will
 * undergo in the event of non-payment
 */
export type CcpEffectiveUncollectibleAction = {
    __typename?: "CcpEffectiveUncollectibleAction";
    /**
     * The offering which an entitlement will transition to in the event that a DOWNGRADE action occurs.
     * If the uncollectibleActionType is not DOWNGRADE, this will be null.
     */
    destinationOffering?: Maybe<CcpOffering>;
    uncollectibleActionType?: Maybe<CcpOfferingUncollectibleActionType>;
};

/** An entitlement represents the right of a transaction account to use an offering. */
export type CcpEntitlement = CommerceEntitlement &
    Node & {
        __typename?: "CcpEntitlement";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        changeReason?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        childrenIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        context?: Maybe<CcpContext>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        createdAt?: Maybe<Scalars["Float"]["output"]>;
        /**
         * Default offering transitions where current entitlement can transition into
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        defaultOfferingTransitions?: Maybe<
            Array<Maybe<CcpEntitlementOfferingTransition>>
        >;
        /**
         * Default standalone offering transitions where current entitlement can transition into
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        defaultStandaloneOfferingTransitions?: Maybe<
            Array<Maybe<CcpEntitlementOfferingTransition>>
        >;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        enableAbuseProneFeatures?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entitlementId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entitlementTemplate?: Maybe<CcpEntitlementTemplate>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        experienceCapabilities?: Maybe<CcpEntitlementExperienceCapabilities>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        featureOverrides?: Maybe<Array<Maybe<CcpMapEntry>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        featureVariables?: Maybe<Array<Maybe<CcpMapEntry>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Get the latest usage count for the chosen charge element, e.g. user,
         * if it exists. Note that there is no guarantee that the latest value
         * of any charge element is relevant for billing or for usage limitation
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        latestUsageForChargeElement?: Maybe<Scalars["Int"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        metadata?: Maybe<Array<Maybe<CcpMapEntry>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        offering?: Maybe<CcpOffering>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        offeringKey?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        order?: Maybe<CcpOrder>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        parentId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        preDunning?: Maybe<CcpEntitlementPreDunning>;
        /**
         * Relationships are defined between entitlements and encode relationships between the billing behaviour of those entitlements.
         * They instantiate the offering relationships configured on the offerings of the relevant entitlements.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        relatesFromEntitlements?: Maybe<
            Array<Maybe<CcpEntitlementRelationship>>
        >;
        /**
         * Relationships are defined between entitlements and encode relationships between the billing behaviour of those entitlements.
         * They instantiate the offering relationships configured on the offerings of the relevant entitlements.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        relatesToEntitlements?: Maybe<Array<Maybe<CcpEntitlementRelationship>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        slug?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        status?: Maybe<CcpEntitlementStatus>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        subscription?: Maybe<CcpSubscription>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        transactionAccount?: Maybe<CcpTransactionAccount>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        transactionAccountId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        updatedAt?: Maybe<Scalars["Float"]["output"]>;
        /**
         * The product usage associated with the entitlement
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        usage?: Maybe<Array<Maybe<CcpEntitlementUsage>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        version?: Maybe<Scalars["Int"]["output"]>;
    };

/** An entitlement represents the right of a transaction account to use an offering. */
export type CcpEntitlementDefaultOfferingTransitionsArgs = {
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

/** An entitlement represents the right of a transaction account to use an offering. */
export type CcpEntitlementDefaultStandaloneOfferingTransitionsArgs = {
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

/** An entitlement represents the right of a transaction account to use an offering. */
export type CcpEntitlementLatestUsageForChargeElementArgs = {
    chargeElement?: InputMaybe<Scalars["String"]["input"]>;
};

export type CcpEntitlementDetailsForCreateEntitlement = {
    entitlementId: Scalars["ID"]["input"];
};

export type CcpEntitlementExperienceCapabilities =
    CommerceEntitlementExperienceCapabilities & {
        __typename?: "CcpEntitlementExperienceCapabilities";
        /** Experience for user to cancel entitlement in entitlement details page. */
        cancelEntitlement?: Maybe<CcpCancelEntitlementExperienceCapability>;
        /**
         * Experience for user to change their current offering to the target offeringKey or offeringName (both offeringKey and offeringName args are optional). Only one of offeringKey or offeringName can be provided.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Replaced with changeOfferingV2 due to not supporting users that are not billing admins
         */
        changeOffering?: Maybe<CcpExperienceCapability>;
        /** Experience for user to change their current offering to the target offeringKey with or without skipping the trial (offeringKey and skipTrial args are optional). */
        changeOfferingV2?: Maybe<CcpChangeOfferingExperienceCapability>;
        /** Experience for user to manage entitlement in entitlement details page. */
        manageEntitlement?: Maybe<CcpManageEntitlementExperienceCapability>;
    };

export type CcpEntitlementExperienceCapabilitiesChangeOfferingArgs = {
    offeringKey?: InputMaybe<Scalars["ID"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

export type CcpEntitlementExperienceCapabilitiesChangeOfferingV2Args = {
    offeringKey?: InputMaybe<Scalars["ID"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
    skipTrial?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * Entitlement transition represents offering where current entitlement offering can transition into, but it does not
 * necessary guarantee that current entitlement can transition into it
 */
export type CcpEntitlementOfferingTransition = {
    __typename?: "CcpEntitlementOfferingTransition";
    id: Scalars["ID"]["output"];
    listPriceForOrderWithDefaults?: Maybe<Array<Maybe<CcpListPriceEstimate>>>;
    name?: Maybe<Scalars["String"]["output"]>;
    offering?: Maybe<CcpOffering>;
    offeringKey?: Maybe<Scalars["ID"]["output"]>;
};

/**
 * Entitlement transition represents offering where current entitlement offering can transition into, but it does not
 * necessary guarantee that current entitlement can transition into it
 */
export type CcpEntitlementOfferingTransitionListPriceForOrderWithDefaultsArgs =
    {
        filter?: InputMaybe<CcpOrderDefaultsInput>;
    };

/**
 * Returns status IN_PRE_DUNNING if at least one pre-dunning exists for the entitlement,
 * irrespective of the state of the entitlement before pre-dunning (paid offering or trial)
 * firstPreDunningEndTimestamp is the end time of the earliest pre-dunning of the entitlement, if there are more than one instance.
 */
export type CcpEntitlementPreDunning = CommerceEntitlementPreDunning & {
    __typename?: "CcpEntitlementPreDunning";
    /**
     * First preDunning end date in microseconds fetched from TCS
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with firstPreDunningEndTimestampV2 due to returning the timestamp in microseconds instead of milliseconds
     */
    firstPreDunningEndTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /** First preDunning end date in milliseconds fetched from TCS */
    firstPreDunningEndTimestampV2?: Maybe<Scalars["Float"]["output"]>;
    status?: Maybe<CcpEntitlementPreDunningStatus>;
};

export enum CcpEntitlementPreDunningStatus {
    InPreDunning = "IN_PRE_DUNNING",
    NotInPreDunning = "NOT_IN_PRE_DUNNING"
}

export type CcpEntitlementRelationship = CommerceEntitlementRelationship & {
    __typename?: "CcpEntitlementRelationship";
    entitlementId?: Maybe<Scalars["ID"]["output"]>;
    relationshipId?: Maybe<Scalars["ID"]["output"]>;
    relationshipType?: Maybe<Scalars["String"]["output"]>;
};

export enum CcpEntitlementStatus {
    Active = "ACTIVE",
    Inactive = "INACTIVE"
}

export type CcpEntitlementTemplate = {
    __typename?: "CcpEntitlementTemplate";
    /** Map<String,Object> using a json representation */
    data?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<Scalars["ID"]["output"]>;
    provisionedBy?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<Scalars["Int"]["output"]>;
};

/** A type of product usage as it relates to an entitlement */
export type CcpEntitlementUsage = {
    __typename?: "CcpEntitlementUsage";
    /** The charge element configuration from the offering */
    offeringChargeElement?: Maybe<CcpOfferingChargeElement>;
    /** The usage amount for this charge element from usage tracking service (UTS) */
    usageAmount?: Maybe<Scalars["Float"]["output"]>;
    /** The usage identifier in usage tracking service (UTS), e.g.: ari:cloud:platform::usage/ccp-object:entitlement:c29aa373-5feb-3686-a610-695b3c9321e8 */
    usageIdentifier?: Maybe<Scalars["String"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpExperienceCapability = CommerceExperienceCapability & {
    __typename?: "CcpExperienceCapability";
    /**
     * The URL of the experience. It will be null if the experience is not available to the user.
     * The client MUST add an `atlOrigin` query parameter to the URL as per
     * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
     */
    experienceUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the current user has sufficient permissions in order to complete the flow and
     * the action is permitted with regard to the business rules.
     */
    isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CcpInvoiceGroup = CommerceInvoiceGroup & {
    __typename?: "CcpInvoiceGroup";
    experienceCapabilities?: Maybe<CcpInvoiceGroupExperienceCapabilities>;
    id: Scalars["ID"]["output"];
    invoiceable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CcpInvoiceGroupExperienceCapabilities =
    CommerceInvoiceGroupExperienceCapabilities & {
        __typename?: "CcpInvoiceGroupExperienceCapabilities";
        /**
         * Experience for user to configure their payment details for a particular invoice group.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Replaced with configurePaymentV2 due to not supporting users that are not billing admins
         */
        configurePayment?: Maybe<CcpExperienceCapability>;
        /** Experience for user to configure their payment details for a particular invoice group. */
        configurePaymentV2?: Maybe<CcpConfigurePaymentMethodExperienceCapability>;
    };

export type CcpListPriceEstimate = {
    __typename?: "CcpListPriceEstimate";
    /**
     * Thw average price per user the customer is going to pay. It is not necessary price of adding an extra user, it is
     * the price customer is going to pay per user for the current quantity and pricing plan.
     */
    averageAmountPerUnit?: Maybe<Scalars["Float"]["output"]>;
    item?: Maybe<CcpPricingPlanItem>;
    quantity?: Maybe<Scalars["Float"]["output"]>;
    totalPrice?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can manage entitlement.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpManageEntitlementExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpManageEntitlementExperienceCapability";
        /** The URL of the experience. */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

export type CcpMapEntry = {
    __typename?: "CcpMapEntry";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CcpMultipleProductUpgradesExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "CcpMultipleProductUpgradesExperienceCapability";
        /**
         * The URL of the experience. It will be returned even if the experience is not available to the user.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

/** An offering represents a packaging of the product that combines a set of features and the way to charge for them. */
export type CcpOffering = CommerceOffering &
    Node & {
        __typename?: "CcpOffering";
        allowReactivationOnDifferentOffering?: Maybe<
            Scalars["Boolean"]["output"]
        >;
        catalogAccountId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The charge elements that have a special configuration in this offering.
         * NOTE: it does not include all the charge elements that are tracked
         * in this offering, or that can be charged for. It only includes those
         * with a ceiling configured in the offering. See `offeringChargeElements`
         * to find all the relevant usages.
         */
        chargeElements?: Maybe<Array<Maybe<CcpChargeElement>>>;
        /** Possible standalone transitions (not requiring changes to other entitlements) that should be advertised to customers. */
        defaultTransitions?: Maybe<Array<Maybe<CcpOffering>>>;
        dependsOnOfferingKeys?: Maybe<
            Array<Maybe<Scalars["String"]["output"]>>
        >;
        derivedFromOffering?: Maybe<CcpDerivedFromOffering>;
        derivedOfferings?: Maybe<Array<Maybe<CcpDerivedOffering>>>;
        effectiveUncollectibleAction?: Maybe<CcpEffectiveUncollectibleAction>;
        entitlementTemplateId?: Maybe<Scalars["ID"]["output"]>;
        expiryDate?: Maybe<Scalars["Float"]["output"]>;
        hostingType?: Maybe<CcpOfferingHostingType>;
        id: Scalars["ID"]["output"];
        key?: Maybe<Scalars["ID"]["output"]>;
        level?: Maybe<Scalars["Int"]["output"]>;
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The charge elements that are relevant to the offering. There are charge elements
         * for all types of usage which are relevant/defined for the offering.
         */
        offeringChargeElements?: Maybe<Array<Maybe<CcpOfferingChargeElement>>>;
        offeringGroup?: Maybe<CcpOfferingGroup>;
        pricingType?: Maybe<CcpPricingType>;
        product?: Maybe<CcpProduct>;
        productKey?: Maybe<Scalars["ID"]["output"]>;
        /** Customer facing product content from App Listing Catalog */
        productListing?: Maybe<ProductListingResult>;
        /**
         * For an offering, required relationships gives us the
         * dependencies which need to exist in entitlement graph for the order to be successful.
         */
        requiredRelationships?: Maybe<Array<Maybe<CcpOfferingRelationship>>>;
        sku?: Maybe<Scalars["String"]["output"]>;
        slugs?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
        status?: Maybe<CcpOfferingStatus>;
        supportedBillingSystems?: Maybe<
            Array<Maybe<CcpSupportedBillingSystems>>
        >;
        syntheticTemplates?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
        /** Possible offering transitions */
        transitions?: Maybe<Array<Maybe<CcpOffering>>>;
        trial?: Maybe<CcpOfferingTrial>;
        type?: Maybe<CcpOfferingType>;
        updatedAt?: Maybe<Scalars["Float"]["output"]>;
        version?: Maybe<Scalars["Int"]["output"]>;
    };

/** An offering represents a packaging of the product that combines a set of features and the way to charge for them. */
export type CcpOfferingDefaultTransitionsArgs = {
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

/** An offering represents a packaging of the product that combines a set of features and the way to charge for them. */
export type CcpOfferingTransitionsArgs = {
    offeringGroupSlug?: InputMaybe<Scalars["String"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<CcpOfferingStatus>;
};

/** How a certain type of usage is tracked and optionally limited for an offering */
export type CcpOfferingChargeElement = {
    __typename?: "CcpOfferingChargeElement";
    /** This id uniquely identifies the catalog account which this charge element belongs to */
    catalogAccountId?: Maybe<Scalars["ID"]["output"]>;
    /** The name of the charge element in CCP, as in the pricing plan. e.g. user, agent, etc. */
    chargeElement?: Maybe<Scalars["String"]["output"]>;
    /** The time when this charge element configuration was created */
    createdAt?: Maybe<Scalars["Float"]["output"]>;
    /** The offering which this charge element belongs to */
    offering?: Maybe<CcpOffering>;
    /** The time when this charge element configuration was last updated */
    updatedAt?: Maybe<Scalars["Float"]["output"]>;
    /** How the relevant usage can be queried for entitlements of this offering */
    usageConfig?: Maybe<CcpOfferingChargeElementUsageConfig>;
    /** The version of this charge element configuration, which is incremented each time it is updated. */
    version?: Maybe<Scalars["Int"]["output"]>;
};

/** The configuration for what usage is referred to by a charge element in an offering */
export type CcpOfferingChargeElementUsageConfig = {
    __typename?: "CcpOfferingChargeElementUsageConfig";
    /** The usage key in usage tracking service (UTS), e.g.: users-site/ enterprise_user/ jsm-virtual-agent */
    usageKey?: Maybe<Scalars["String"]["output"]>;
};

export type CcpOfferingGroup = {
    __typename?: "CcpOfferingGroup";
    catalogAccountId?: Maybe<Scalars["ID"]["output"]>;
    key?: Maybe<Scalars["ID"]["output"]>;
    level?: Maybe<Scalars["Int"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    product?: Maybe<CcpProduct>;
    productKey?: Maybe<Scalars["ID"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
};

export enum CcpOfferingHostingType {
    Cloud = "CLOUD"
}

/**
 * There are dependencies between different offerings that determine what is sold, what is provisioned,
 * how they are sold or how they are charged. Such dependencies between Offerings have been solved with
 * the concept of relationships in the Offering Catalogue.
 * More on https://developer.atlassian.com/platform/commerce-cloud-platform/ccp-offering-catalogue/OfferingRelationships/
 */
export type CcpOfferingRelationship = {
    __typename?: "CcpOfferingRelationship";
    /** The account id of the catalog account which this relationship belongs to. */
    catalogAccountId?: Maybe<Scalars["String"]["output"]>;
    /** describes the dependencies between offerings */
    description?: Maybe<Scalars["String"]["output"]>;
    /** from side of the dependency */
    from?: Maybe<CcpRelationshipNode>;
    /** This id uniquely identifies a relationship */
    id?: Maybe<Scalars["String"]["output"]>;
    /**
     * RelationshipTemplates are created first and the configuration is reviewed. If approved, relationship template
     * becomes active and relationships are created based on the template in ACTIVE state. This id uniquely identifies the
     * source template of relationship configuration.
     */
    relationshipTemplateId?: Maybe<Scalars["String"]["output"]>;
    /**
     * There are different types of dependencies such as apps, sandboxes, jira containers, addons to name a few.
     * This type of relationship determines the type of dependency between offerings.
     */
    relationshipType?: Maybe<CcpRelationshipType>;
    /**
     * Defines the lifecycle of the relationship. Only active relationships should be considered to figure out
     * the dependencies.
     */
    status?: Maybe<CcpRelationshipStatus>;
    /** to side of the dependency */
    to?: Maybe<CcpRelationshipNode>;
    /** The time when this relationship was last updated */
    updatedAt?: Maybe<Scalars["Float"]["output"]>;
    /** The version of this relationship, which is incremented each time it is updated. */
    version?: Maybe<Scalars["Int"]["output"]>;
};

export enum CcpOfferingStatus {
    Active = "ACTIVE",
    AtNotice = "AT_NOTICE",
    Draft = "DRAFT",
    Expired = "EXPIRED"
}

export type CcpOfferingTrial = CommerceOfferingTrial & {
    __typename?: "CcpOfferingTrial";
    lengthDays?: Maybe<Scalars["Int"]["output"]>;
};

export enum CcpOfferingType {
    Child = "CHILD",
    Parent = "PARENT"
}

export enum CcpOfferingUncollectibleActionType {
    Cancel = "CANCEL",
    Downgrade = "DOWNGRADE",
    NoAction = "NO_ACTION"
}

/** An order from a transaction account. */
export type CcpOrder = Node & {
    __typename?: "CcpOrder";
    id: Scalars["ID"]["output"];
    itemId?: Maybe<Scalars["ID"]["output"]>;
};

/** Arguments for order-defaults */
export type CcpOrderDefaultsInput = {
    country?: InputMaybe<Scalars["String"]["input"]>;
    currentEntitlementId?: InputMaybe<Scalars["String"]["input"]>;
    offeringId?: InputMaybe<Scalars["String"]["input"]>;
};

/** A pricing plan represents the way to charge for a subscription. */
export type CcpPricingPlan = CommercePricingPlan &
    Node & {
        __typename?: "CcpPricingPlan";
        activatedWithReason?: Maybe<CcpActivationReason>;
        catalogAccountId?: Maybe<Scalars["ID"]["output"]>;
        currency?: Maybe<CcpCurrency>;
        description?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        items?: Maybe<Array<Maybe<CcpPricingPlanItem>>>;
        key?: Maybe<Scalars["ID"]["output"]>;
        maxNewQuoteDate?: Maybe<Scalars["Float"]["output"]>;
        offering?: Maybe<CcpOffering>;
        offeringKey?: Maybe<Scalars["ID"]["output"]>;
        primaryCycle?: Maybe<CcpCycle>;
        product?: Maybe<CcpProduct>;
        productKey?: Maybe<Scalars["ID"]["output"]>;
        relationships?: Maybe<Array<Maybe<CcpPricingPlanRelationship>>>;
        sku?: Maybe<Scalars["String"]["output"]>;
        status?: Maybe<CcpPricingPlanStatus>;
        supportedBillingSystems?: Maybe<
            Array<Maybe<CcpSupportedBillingSystems>>
        >;
        type?: Maybe<Scalars["String"]["output"]>;
        updatedAt?: Maybe<Scalars["Float"]["output"]>;
        version?: Maybe<Scalars["Float"]["output"]>;
    };

export type CcpPricingPlanItem = {
    __typename?: "CcpPricingPlanItem";
    chargeElement?: Maybe<Scalars["String"]["output"]>;
    chargeType?: Maybe<CcpChargeType>;
    cycle?: Maybe<CcpCycle>;
    /** The corresponding charge element configuration on the offering which this pricing plan belongs to */
    offeringChargeElement?: Maybe<CcpOfferingChargeElement>;
    prorateOnUsageChange?: Maybe<CcpProrateOnUsageChange>;
    tiers?: Maybe<Array<Maybe<CcpPricingPlanTier>>>;
    tiersMode?: Maybe<CcpTiersMode>;
    usageUpdateCadence?: Maybe<CcpUsageUpdateCadence>;
};

export type CcpPricingPlanRelationship = {
    __typename?: "CcpPricingPlanRelationship";
    fromPricingPlanKey?: Maybe<Scalars["ID"]["output"]>;
    metadata?: Maybe<Scalars["String"]["output"]>;
    toPricingPlanKey?: Maybe<Scalars["ID"]["output"]>;
    type?: Maybe<CcpRelationshipPricingType>;
};

export enum CcpPricingPlanStatus {
    Active = "ACTIVE",
    AtNotice = "AT_NOTICE",
    Draft = "DRAFT",
    Expired = "EXPIRED"
}

export type CcpPricingPlanTier = {
    __typename?: "CcpPricingPlanTier";
    ceiling?: Maybe<Scalars["Int"]["output"]>;
    flatAmount?: Maybe<Scalars["Int"]["output"]>;
    floor?: Maybe<Scalars["Int"]["output"]>;
    unitAmount?: Maybe<Scalars["Int"]["output"]>;
};

export enum CcpPricingType {
    External = "EXTERNAL",
    Free = "FREE",
    LimitedFree = "LIMITED_FREE",
    Paid = "PAID"
}

/**
 * A Product is a container for all catalogue definitions of a product Atlassian is selling.
 * Its Offerings are interchangeable and intend to deliver the same product but with possibly different versions or features.
 */
export type CcpProduct = Node & {
    __typename?: "CcpProduct";
    /** This id uniquely identifies the catalog account which this product belongs to */
    catalogAccountId?: Maybe<Scalars["ID"]["output"]>;
    /** This id uniquely identifies a product in CCP. */
    id: Scalars["ID"]["output"];
    /** Label to identify a Product. Currently, this label is displayed to customers in Atlassian billing experiences, quotes and invoices. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Offerings that belong to this product */
    offerings?: Maybe<Array<Maybe<CcpOffering>>>;
    /** Products have a lifecycle that is controlled by the status attribute where each status will define specific rules and behaviors. */
    status?: Maybe<CcpProductStatus>;
    /** It is the list of billing systems supported by the product */
    supportedBillingSystems?: Maybe<Array<Maybe<CcpSupportedBillingSystems>>>;
    /** The version of this product, which is incremented each time it is updated. */
    version?: Maybe<Scalars["Int"]["output"]>;
};

export enum CcpProductStatus {
    Active = "ACTIVE",
    AtNotice = "AT_NOTICE",
    Draft = "DRAFT",
    Expired = "EXPIRED"
}

export type CcpPromotionDefinition = {
    __typename?: "CcpPromotionDefinition";
    customisedValues?: Maybe<CcpCustomisedValues>;
    promotionCode?: Maybe<Scalars["String"]["output"]>;
    promotionId?: Maybe<Scalars["ID"]["output"]>;
};

export type CcpPromotionInstance = {
    __typename?: "CcpPromotionInstance";
    promotionDefinition?: Maybe<CcpPromotionDefinition>;
    promotionInstanceId?: Maybe<Scalars["ID"]["output"]>;
};

export enum CcpProrateOnUsageChange {
    AlwaysInvoice = "ALWAYS_INVOICE",
    CreateProrations = "CREATE_PRORATIONS",
    None = "NONE"
}

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApi = {
    __typename?: "CcpQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    entitlement?: Maybe<CcpEntitlement>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    entitlements?: Maybe<Array<Maybe<CcpEntitlement>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    experienceCapabilities?: Maybe<CcpRootExperienceCapabilities>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    offering?: Maybe<CcpOffering>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    pricingPlan?: Maybe<CcpPricingPlan>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    product?: Maybe<CcpProduct>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    transactionAccount?: Maybe<CcpTransactionAccount>;
};

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApiEntitlementArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApiEntitlementsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApiOfferingArgs = {
    key: Scalars["ID"]["input"];
};

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApiPricingPlanArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApiProductArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */
export type CcpQueryApiTransactionAccountArgs = {
    id: Scalars["ID"]["input"];
};

export type CcpRelationshipCardinality = {
    __typename?: "CcpRelationshipCardinality";
    max?: Maybe<Scalars["Int"]["output"]>;
    min?: Maybe<Scalars["Int"]["output"]>;
};

export type CcpRelationshipGroup = {
    __typename?: "CcpRelationshipGroup";
    groupCardinality?: Maybe<CcpRelationshipGroupCardinality>;
    groupName?: Maybe<Scalars["String"]["output"]>;
    offerings?: Maybe<Array<Maybe<CcpOffering>>>;
};

export type CcpRelationshipGroupCardinality = {
    __typename?: "CcpRelationshipGroupCardinality";
    max?: Maybe<Scalars["Int"]["output"]>;
};

export type CcpRelationshipNode = {
    __typename?: "CcpRelationshipNode";
    cardinality?: Maybe<CcpRelationshipCardinality>;
    groups?: Maybe<Array<Maybe<CcpRelationshipGroup>>>;
    selector?: Maybe<Scalars["String"]["output"]>;
};

export enum CcpRelationshipPricingType {
    AdvantagePricing = "ADVANTAGE_PRICING",
    CurrencyGenerated = "CURRENCY_GENERATED",
    NextPricing = "NEXT_PRICING",
    SyntheticGenerated = "SYNTHETIC_GENERATED"
}

export enum CcpRelationshipStatus {
    Active = "ACTIVE",
    Deprecated = "DEPRECATED"
}

export enum CcpRelationshipType {
    AddonDependence = "ADDON_DEPENDENCE",
    AppCompatibility = "APP_COMPATIBILITY",
    Collection = "COLLECTION",
    CollectionTrial = "COLLECTION_TRIAL",
    Enterprise = "ENTERPRISE",
    EnterpriseSandboxGrant = "ENTERPRISE_SANDBOX_GRANT",
    FamilyContainer = "FAMILY_CONTAINER",
    MultiInstance = "MULTI_INSTANCE",
    SandboxDependence = "SANDBOX_DEPENDENCE",
    SandboxGrant = "SANDBOX_GRANT"
}

export type CcpRootExperienceCapabilities = {
    __typename?: "CcpRootExperienceCapabilities";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CcpEntitlementCreationExperienceCapability")' query directive to the 'createEntitlement' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createEntitlement?: Maybe<CcpCreateEntitlementExperienceCapability>;
};

export type CcpRootExperienceCapabilitiesCreateEntitlementArgs = {
    input: CcpCreateEntitlementInput;
};

export type CcpSubscription = CommerceSubscription & {
    __typename?: "CcpSubscription";
    accountDetails?: Maybe<CcpAccountDetails>;
    billingPeriodDetails?: Maybe<CcpBillingPeriodDetails>;
    chargeDetails?: Maybe<CcpChargeDetails>;
    endTimestamp?: Maybe<Scalars["Float"]["output"]>;
    entitlementId?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    metadata?: Maybe<Array<Maybe<CcpMapEntry>>>;
    orderItemId?: Maybe<Scalars["ID"]["output"]>;
    pricingPlan?: Maybe<CcpPricingPlan>;
    startTimestamp?: Maybe<Scalars["Float"]["output"]>;
    status?: Maybe<CcpSubscriptionStatus>;
    subscriptionSchedule?: Maybe<CcpSubscriptionSchedule>;
    trial?: Maybe<CcpTrial>;
    version?: Maybe<Scalars["Int"]["output"]>;
};

export type CcpSubscriptionSchedule = {
    __typename?: "CcpSubscriptionSchedule";
    chargeQuantities?: Maybe<Array<Maybe<CcpChargeQuantity>>>;
    invoiceGroupId?: Maybe<Scalars["ID"]["output"]>;
    nextChangeTimestamp?: Maybe<Scalars["Float"]["output"]>;
    offeringId?: Maybe<Scalars["ID"]["output"]>;
    orderItemId?: Maybe<Scalars["ID"]["output"]>;
    pricingPlanId?: Maybe<Scalars["ID"]["output"]>;
    promotionIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    promotionInstances?: Maybe<Array<Maybe<CcpPromotionInstance>>>;
    subscriptionScheduleAction?: Maybe<CcpSubscriptionScheduleAction>;
    transactionAccountId?: Maybe<Scalars["ID"]["output"]>;
    trial?: Maybe<CcpTrial>;
};

export enum CcpSubscriptionScheduleAction {
    Cancel = "CANCEL",
    Update = "UPDATE"
}

export enum CcpSubscriptionStatus {
    Active = "ACTIVE",
    Cancelled = "CANCELLED",
    Processing = "PROCESSING"
}

export enum CcpSupportedBillingSystems {
    BackOffice = "BACK_OFFICE",
    Ccp = "CCP",
    Hams = "HAMS",
    Opsgenie = "OPSGENIE"
}

export enum CcpTiersMode {
    Graduated = "GRADUATED",
    Volume = "VOLUME"
}

/**
 * A CCP transaction account represents a customer,
 * i.e. the legal entity with which Atlassian is doing business.
 * It may be an individual, a business, etc.
 */
export type CcpTransactionAccount = CommerceTransactionAccount & {
    __typename?: "CcpTransactionAccount";
    experienceCapabilities?: Maybe<CcpTransactionAccountExperienceCapabilities>;
    /** The transaction account ARI */
    id: Scalars["ID"]["output"];
    /** Whether bill to address is present */
    isBillToPresent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the current user is a billing admin for the transaction account */
    isCurrentUserBillingAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this transaction account is managed by a partner */
    isManagedByPartner?: Maybe<Scalars["Boolean"]["output"]>;
    /** The transaction account id */
    key?: Maybe<Scalars["String"]["output"]>;
};

export type CcpTransactionAccountExperienceCapabilities =
    CommerceTransactionAccountExperienceCapabilities & {
        __typename?: "CcpTransactionAccountExperienceCapabilities";
        /**
         * An experience flow where a customer may enter a payment method.
         * This payment method will be used to collect for all entitlements on the transaction account, unless they are in an invoice
         * group configured to use a different payment method.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Replaced with addPaymentMethodV2 due to not supporting users that are not billing admins
         */
        addPaymentMethod?: Maybe<CcpExperienceCapability>;
        /**
         * An experience flow where a customer may enter a payment method.
         * This payment method will be used to collect for all entitlements on the transaction account, unless they are in an invoice
         * group configured to use a different payment method.
         */
        addPaymentMethodV2?: Maybe<CcpAddPaymentMethodExperienceCapability>;
        /** An experience flow where a customer may amend more than one entitlement's offerings from Free to Paid. */
        multipleProductUpgrades?: Maybe<CcpMultipleProductUpgradesExperienceCapability>;
    };

export type CcpTrial = CommerceTrial & {
    __typename?: "CcpTrial";
    endTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /**
     * The list price estimates (also known as "gross list price”, or “GLP) is a standard price without GST, any discounts or
     * promotions applied as opposed to the billing-estimate API. Purpose of such estimate is mainly to show customer
     * the standard price for the offering without being specific to the current customer.
     */
    listPriceEstimates?: Maybe<Array<Maybe<CcpListPriceEstimate>>>;
    offeringId?: Maybe<Scalars["ID"]["output"]>;
    pricingPlanId?: Maybe<Scalars["ID"]["output"]>;
    startTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /** Number of milliseconds left on the trial. */
    timeLeft?: Maybe<Scalars["Float"]["output"]>;
};

export type CcpUsageUpdateCadence = {
    __typename?: "CcpUsageUpdateCadence";
    cadenceIntervalMinutes?: Maybe<Scalars["Int"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ChangeOwnerWarning = {
    __typename?: "ChangeOwnerWarning";
    contentId?: Maybe<Scalars["Long"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
};

/** The input arguments for checking if a user can authorise an app by OauthID */
export type CheckConsentPermissionByOAuthClientIdInput = {
    /** Cloud id where app is trying to be installed */
    cloudId: Scalars["ID"]["input"];
    /** App's oauthClientId which will be checked against the DB if it's valid */
    oauthClientId: Scalars["ID"]["input"];
    /** The requested scopes of the app connection. */
    scopes: Array<Scalars["String"]["input"]>;
    /** The User's Atlassian account ID to verify their permissions on the target site */
    userId: Scalars["ID"]["input"];
};

/** Children metadata for cards */
export type ChildCardsMetadata = {
    __typename?: "ChildCardsMetadata";
    complete?: Maybe<Scalars["Int"]["output"]>;
    total?: Maybe<Scalars["Int"]["output"]>;
};

export type ChildContentTypesAvailable = {
    __typename?: "ChildContentTypesAvailable";
    attachment?: Maybe<Scalars["Boolean"]["output"]>;
    blogpost?: Maybe<Scalars["Boolean"]["output"]>;
    comment?: Maybe<Scalars["Boolean"]["output"]>;
    page?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum Classification {
    Other = "other",
    Pii = "pii",
    Ugc = "ugc"
}

export type ClassificationLevelDetails = {
    __typename?: "ClassificationLevelDetails";
    classificationLevelId?: Maybe<Scalars["ID"]["output"]>;
    source?: Maybe<ClassificationLevelSource>;
};

export enum ClassificationLevelSource {
    Content = "CONTENT",
    Organization = "ORGANIZATION",
    Space = "SPACE"
}

/** Level of access to an Atlassian product that a cloud app can request */
export type CloudAppScope = {
    __typename?: "CloudAppScope";
    /**
     * Description of the level of access to an Atlassian product that an app can request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    capability: Scalars["String"]["output"];
    /**
     * Unique id of the scope
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Name of the scope
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
};

export type CodeInJira = {
    __typename?: "CodeInJira";
    /**
     * Site specific configuration required to build the 'Code in Jira' page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    siteConfiguration?: Maybe<CodeInJiraSiteConfiguration>;
    /**
     * User specific configuration required to build the 'Code in Jira' page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userConfiguration?: Maybe<CodeInJiraUserConfiguration>;
};

export type CodeInJiraBitbucketWorkspace = {
    __typename?: "CodeInJiraBitbucketWorkspace";
    /** Workspace name (eg. Fusion) */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * URL slug (eg. fusion). Used to differentiate multiple workspaces
     * to the user when the names are same
     */
    slug?: Maybe<Scalars["String"]["output"]>;
    /** Unique ID of the Bitbucket workspace in UUID format */
    uuid: Scalars["ID"]["output"];
};

export type CodeInJiraSiteConfiguration = {
    __typename?: "CodeInJiraSiteConfiguration";
    /**
     * A list of providers that are already connected to the site
     * Eg. Bitbucket, Github, Gitlab etc.
     */
    connectedVcsProviders?: Maybe<Array<Maybe<CodeInJiraVcsProvider>>>;
};

export type CodeInJiraUserConfiguration = {
    __typename?: "CodeInJiraUserConfiguration";
    /**
     * A list of Bitbucket workspaces that the current user has admin access too
     * The user can connect Jira to one these Workspaces
     */
    ownedBitbucketWorkspaces?: Maybe<
        Array<Maybe<CodeInJiraBitbucketWorkspace>>
    >;
};

/**
 * A Version Control System object
 * Eg. Bitbucket, GitHub, GitLab
 */
export type CodeInJiraVcsProvider = {
    __typename?: "CodeInJiraVcsProvider";
    baseUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    providerId?: Maybe<Scalars["String"]["output"]>;
    providerNamespace?: Maybe<Scalars["String"]["output"]>;
};

/** =========================== */
export type CodeRepository = {
    /** URL for the code repository. */
    href?: Maybe<Scalars["URL"]["output"]>;
    /** Name of code repository. */
    name: Scalars["String"]["output"];
};

export type CollabDraft = {
    __typename?: "CollabDraft";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    document?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    metadata?: Maybe<CollabDraftMetadata>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version?: Maybe<Scalars["Int"]["output"]>;
};

export type CollabDraftMetadata = {
    __typename?: "CollabDraftMetadata";
    title?: Maybe<Scalars["String"]["output"]>;
};

export enum CollabFormat {
    Adf = "ADF",
    Pm = "PM"
}

export type CollabTokenResponse = {
    __typename?: "CollabTokenResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    token: Scalars["String"]["output"];
};

/** A column on the board */
export type Column = {
    __typename?: "Column";
    /** The cards contained in the column */
    cards: Array<Maybe<SoftwareCard>>;
    /** The statuses mapped to this column */
    columnStatus: Array<ColumnStatus>;
    /** Column's id */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Whether this column is the done column.  Each board has exactly one done column. */
    isDone: Scalars["Boolean"]["output"];
    /** Whether this column is the inital column.  Each board has exactly one initial column. */
    isInitial: Scalars["Boolean"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'isKanPlanColumn' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isKanPlanColumn?: Maybe<Scalars["Boolean"]["output"]>;
    /** Number of cards allowed in this column before displaying a warning,  null if no limit */
    maxCardCount?: Maybe<Scalars["Int"]["output"]>;
    /** Minimum number of cards needed in the column. Null if no minimum */
    minCardCount?: Maybe<Scalars["Int"]["output"]>;
    /** Column's name */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** A column on the board */
export type ColumnCardsArgs = {
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ColumnConfigSwimlane = {
    __typename?: "ColumnConfigSwimlane";
    /** UUID to identify the swimlane */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** All issue types belong to the swimlane */
    issueTypes?: Maybe<Array<Maybe<CardType>>>;
    /** Ghost statuses belong to the swimlane */
    sharedStatuses?: Maybe<Array<Maybe<RawStatus>>>;
    /** Original statuses belong to the swimlane */
    uniqueStatuses?: Maybe<Array<Maybe<RawStatus>>>;
};

export type ColumnConstraintStatisticConfig = {
    __typename?: "ColumnConstraintStatisticConfig";
    availableConstraints?: Maybe<
        Array<Maybe<AvailableColumnConstraintStatistics>>
    >;
    currentId?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a column inside a swimlane.  Each swimlane gets a ColumnInSwimlane for each column. */
export type ColumnInSwimlane = {
    __typename?: "ColumnInSwimlane";
    /** The cards contained in this column in the given swimlane */
    cards: Array<Maybe<SoftwareCard>>;
    /** The details of the column */
    columnDetails?: Maybe<Column>;
};

/** Represents a column inside a swimlane.  Each swimlane gets a ColumnInSwimlane for each column. */
export type ColumnInSwimlaneCardsArgs = {
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** A status associated with a column, along with its transitions */
export type ColumnStatus = {
    __typename?: "ColumnStatus";
    /**
     * Possible card transitions with a certain card type into this status
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: SoftwareCardTypeTransitions` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    cardTypeTransitions?: Maybe<Array<SoftwareCardTypeTransition>>;
    /** The status */
    status: CardStatus;
    /** Possible transitions into this status */
    transitions: Array<SoftwareCardTransition>;
};

export type ColumnStatusV2 = {
    __typename?: "ColumnStatusV2";
    status: StatusV2;
};

/** Columns data for CMP board settings */
export type ColumnV2 = {
    __typename?: "ColumnV2";
    /** The statuses mapped to this column */
    columnStatus: Array<ColumnStatusV2>;
    id?: Maybe<Scalars["ID"]["output"]>;
    isKanPlanColumn?: Maybe<Scalars["Boolean"]["output"]>;
    /** Number of cards allowed in this column before displaying a warning,  null if no limit */
    maxCardCount?: Maybe<Scalars["Int"]["output"]>;
    /** Minimum number of cards needed in the column. Null if no minimum */
    minCardCount?: Maybe<Scalars["Int"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ColumnWorkflowConfig = {
    __typename?: "ColumnWorkflowConfig";
    canSimplifyWorkflow?: Maybe<Scalars["Boolean"]["output"]>;
    isProjectAdminOfSimplifiedWorkflow?: Maybe<Scalars["Boolean"]["output"]>;
    userCanSimplifyWorkflow?: Maybe<Scalars["Boolean"]["output"]>;
    usingSimplifiedWorkflow?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ColumnsConfig = {
    __typename?: "ColumnsConfig";
    columnConfigSwimlanes?: Maybe<Array<Maybe<ColumnConfigSwimlane>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'constraintsStatisticsField' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    constraintsStatisticsField?: Maybe<ColumnConstraintStatisticConfig>;
    isUpdating?: Maybe<Scalars["Boolean"]["output"]>;
    unmappedStatuses?: Maybe<Array<Maybe<RawStatus>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'workflow' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    workflow?: Maybe<ColumnWorkflowConfig>;
};

/** Board columns status mapping config data */
export type ColumnsConfigPage = {
    __typename?: "ColumnsConfigPage";
    columns?: Maybe<Array<Maybe<ColumnV2>>>;
    constraintsStatisticsField?: Maybe<ColumnConstraintStatisticConfig>;
    isSprintSupportEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    showEpicAsPanel?: Maybe<Scalars["Boolean"]["output"]>;
    unmappedStatuses?: Maybe<Array<Maybe<StatusV2>>>;
    workflow?: Maybe<ColumnWorkflowConfig>;
};

export type Comment = {
    __typename?: "Comment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ancestors: Array<Maybe<Comment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    author: Person;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    body: DocumentBody;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentSource?: Maybe<Platform>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    container: Content;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdAtNonLocalized: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    excerpt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isInlineComment: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isLikedByCurrentUser: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likeCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links: Map_LinkType_String;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    location: CommentLocation;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissions: CommentPermissions;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'reactionsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    reactionsSummary?: Maybe<ReactionsSummaryResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    replies: Array<Maybe<Comment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Version;
};

export type CommentBodyArgs = {
    representation?: InputMaybe<DocumentRepresentation>;
};

export type CommentReactionsSummaryArgs = {
    childType: Scalars["String"]["input"];
    contentType?: InputMaybe<Scalars["String"]["input"]>;
    pageId: Scalars["ID"]["input"];
};

export type CommentRepliesArgs = {
    depth?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CommentBody = {
    representationFormat: ContentRepresentation;
    value: Scalars["String"]["input"];
};

export enum CommentCreationLocation {
    Database = "DATABASE",
    Editor = "EDITOR",
    Live = "LIVE",
    Renderer = "RENDERER",
    Whiteboard = "WHITEBOARD"
}

export enum CommentDeletionLocation {
    Editor = "EDITOR",
    Live = "LIVE"
}

export type CommentEdge = {
    __typename?: "CommentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Comment>;
};

/** --------------------------------------------------------------------------------------------- */
export type CommentLocation = {
    type: Scalars["String"]["output"];
};

export type CommentPermissions = {
    __typename?: "CommentPermissions";
    isEditable: Scalars["Boolean"]["output"];
    isRemovable: Scalars["Boolean"]["output"];
    isResolvable: Scalars["Boolean"]["output"];
    isViewable: Scalars["Boolean"]["output"];
};

export type CommentReplySuggestion = {
    __typename?: "CommentReplySuggestion";
    commentReplyType: CommentReplyType;
    emojiId?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type CommentReplySuggestions = {
    __typename?: "CommentReplySuggestions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentSuggestions: Array<Maybe<CommentReplySuggestion>>;
};

export enum CommentReplyType {
    Emoji = "EMOJI",
    Prompt = "PROMPT",
    QuickReply = "QUICK_REPLY"
}

export enum CommentType {
    Footer = "FOOTER",
    Inline = "INLINE",
    Resolved = "RESOLVED",
    Unresolved = "UNRESOLVED"
}

export type CommentUpdate = AllUpdatesFeedEvent & {
    __typename?: "CommentUpdate";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'comment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    comment?: Maybe<Comment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: AllUpdatesFeedEventType;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    user?: Maybe<Person>;
};

export type CommentUserAction = {
    __typename?: "CommentUserAction";
    id?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    style?: Maybe<Scalars["String"]["output"]>;
    tooltip?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type CommentsDigestResponse = {
    __typename?: "CommentsDigestResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: CommentsDigestSummaryResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["ID"]["output"];
};

export enum CommentsDigestResponseType {
    Json = "JSON",
    PlainText = "PLAIN_TEXT"
}

export type CommentsDigestSummaryResponse = {
    __typename?: "CommentsDigestSummaryResponse";
    introduction: Scalars["String"]["output"];
    prioritizedOpenComments: Array<PrioritizedOpenComments>;
};

export enum CommentsType {
    Footer = "FOOTER",
    Inline = "INLINE"
}

export type CommerceAccountDetails = {
    invoiceGroup?: Maybe<CommerceInvoiceGroup>;
};

export type CommerceChargeDetails = {
    chargeQuantities?: Maybe<Array<Maybe<CommerceChargeQuantity>>>;
};

export type CommerceChargeElement = {
    ceiling?: Maybe<Scalars["Int"]["output"]>;
    unit?: Maybe<Scalars["String"]["output"]>;
};

export type CommerceChargeQuantity = {
    chargeElement?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedAt?: Maybe<Scalars["Float"]["output"]>;
    quantity?: Maybe<Scalars["Float"]["output"]>;
};

export type CommerceEntitlement = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experienceCapabilities?: Maybe<CommerceEntitlementExperienceCapabilities>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Get the latest usage count for the chosen charge element, e.g. user, if it exists. Note that there is no guarantee that the latest value of any charge element is relevant for billing or for usage limitation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    latestUsageForChargeElement?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    offering?: Maybe<CommerceOffering>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    preDunning?: Maybe<CommerceEntitlementPreDunning>;
    /**
     * Relationships are defined between entitlements and encode relationships between the billing behaviour of those entitlements.
     * They instantiate the offering relationships configured on the offerings of the relevant entitlements.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatesFromEntitlements?: Maybe<
        Array<Maybe<CommerceEntitlementRelationship>>
    >;
    /**
     * Relationships are defined between entitlements and encode relationships between the billing behaviour of those entitlements.
     * They instantiate the offering relationships configured on the offerings of the relevant entitlements.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatesToEntitlements?: Maybe<
        Array<Maybe<CommerceEntitlementRelationship>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subscription?: Maybe<CommerceSubscription>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    transactionAccount?: Maybe<CommerceTransactionAccount>;
};

export type CommerceEntitlementLatestUsageForChargeElementArgs = {
    chargeElement?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommerceEntitlementExperienceCapabilities = {
    /** Experience for user to change their current offering to the target offeringKey. */
    changeOffering?: Maybe<CommerceExperienceCapability>;
    /** Experience for user to change their current offering to the target offeringKey. */
    changeOfferingV2?: Maybe<CommerceExperienceCapability>;
};

export type CommerceEntitlementExperienceCapabilitiesChangeOfferingArgs = {
    offeringKey?: InputMaybe<Scalars["ID"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommerceEntitlementExperienceCapabilitiesChangeOfferingV2Args = {
    offeringKey?: InputMaybe<Scalars["ID"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Entitlement filter returns entitlement only if filter conditions have been met
 *
 * There can be only one condition or operand present at the time (similar to @oneOf directive)
 */
export type CommerceEntitlementFilter = {
    AND?: InputMaybe<Array<InputMaybe<CommerceEntitlementFilter>>>;
    OR?: InputMaybe<Array<InputMaybe<CommerceEntitlementFilter>>>;
    inPreDunning?: InputMaybe<Scalars["Boolean"]["input"]>;
    inTrialOrPreDunning?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CommerceEntitlementInfo = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlement?: Maybe<CommerceEntitlement>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementId: Scalars["ID"]["output"];
};

export type CommerceEntitlementInfoEntitlementArgs = {
    where?: InputMaybe<CommerceEntitlementFilter>;
};

export type CommerceEntitlementInfoCcp = CommerceEntitlementInfo & {
    __typename?: "CommerceEntitlementInfoCcp";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlement?: Maybe<CcpEntitlement>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementId: Scalars["ID"]["output"];
};

export type CommerceEntitlementInfoCcpEntitlementArgs = {
    where?: InputMaybe<CommerceEntitlementFilter>;
};

export type CommerceEntitlementInfoHams = CommerceEntitlementInfo & {
    __typename?: "CommerceEntitlementInfoHams";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlement?: Maybe<HamsEntitlement>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementId: Scalars["ID"]["output"];
};

export type CommerceEntitlementInfoHamsEntitlementArgs = {
    where?: InputMaybe<CommerceEntitlementFilter>;
};

export type CommerceEntitlementPreDunning = {
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with firstPreDunningEndTimestampV2 due to inconsistent return values between HAMS and CCP
     */
    firstPreDunningEndTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /** first pre dunning end time in milliseconds */
    firstPreDunningEndTimestampV2?: Maybe<Scalars["Float"]["output"]>;
    status?: Maybe<CcpEntitlementPreDunningStatus>;
};

export type CommerceEntitlementRelationship = {
    entitlementId?: Maybe<Scalars["ID"]["output"]>;
    relationshipId?: Maybe<Scalars["ID"]["output"]>;
    relationshipType?: Maybe<Scalars["String"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type CommerceExperienceCapability = {
    /**
     * The URL of the experience.
     * The client MUST add an `atlOrigin` query parameter to the URL as per
     * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
     */
    experienceUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the current user has sufficient permissions in order to complete the flow and
     * the action is permitted with regard to the business rules.
     */
    isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CommerceInvoiceGroup = {
    experienceCapabilities?: Maybe<CommerceInvoiceGroupExperienceCapabilities>;
    invoiceable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CommerceInvoiceGroupExperienceCapabilities = {
    /**
     * Experience for user to configure their payment details for a particular invoice group.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with configurePaymentV2 due to not supporting users that are not billing admins
     */
    configurePayment?: Maybe<CommerceExperienceCapability>;
    /** Experience for user to configure their payment details for a particular invoice group. */
    configurePaymentV2?: Maybe<CommerceExperienceCapability>;
};

export type CommerceOffering = {
    chargeElements?: Maybe<Array<Maybe<CommerceChargeElement>>>;
    name?: Maybe<Scalars["String"]["output"]>;
    trial?: Maybe<CommerceOfferingTrial>;
};

export type CommerceOfferingTrial = {
    lengthDays?: Maybe<Scalars["Int"]["output"]>;
};

export type CommercePricingPlan = {
    currency?: Maybe<CcpCurrency>;
    primaryCycle?: Maybe<CommercePrimaryCycle>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type CommercePrimaryCycle = {
    interval?: Maybe<CcpBillingInterval>;
};

export type CommerceSubscription = {
    accountDetails?: Maybe<CommerceAccountDetails>;
    chargeDetails?: Maybe<CommerceChargeDetails>;
    pricingPlan?: Maybe<CommercePricingPlan>;
    trial?: Maybe<CommerceTrial>;
};

/**
 * A transaction account represents a customer,
 * i.e. the legal entity with which Atlassian is doing business.
 * It may be an individual, a business, etc.
 */
export type CommerceTransactionAccount = {
    experienceCapabilities?: Maybe<CommerceTransactionAccountExperienceCapabilities>;
    /** Whether bill to address is present */
    isBillToPresent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the current user is a billing admin for the transaction account */
    isCurrentUserBillingAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this transaction account is managed by a partner */
    isManagedByPartner?: Maybe<Scalars["Boolean"]["output"]>;
    /** The transaction account id */
    key?: Maybe<Scalars["String"]["output"]>;
};

export type CommerceTransactionAccountExperienceCapabilities = {
    /**
     * An experience flow where a customer may enter a payment method.
     * This payment method will be used to collect for all entitlements on the transaction account, unless they are in an invoice
     * group configured to use a different payment method.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with addPaymentMethodV2 due to not supporting users that are not billing admins
     */
    addPaymentMethod?: Maybe<CommerceExperienceCapability>;
    /**
     * An experience flow where a customer may enter a payment method.
     * This payment method will be used to collect for all entitlements on the transaction account, unless they are in an invoice
     * group configured to use a different payment method.
     */
    addPaymentMethodV2?: Maybe<CommerceExperienceCapability>;
};

export type CommerceTrial = {
    endTimestamp?: Maybe<Scalars["Float"]["output"]>;
    startTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /** Number of milliseconds left on the trial. */
    timeLeft?: Maybe<Scalars["Float"]["output"]>;
};

export type CompanyHubFeature = {
    __typename?: "CompanyHubFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

/** Accepts input for acknowledging an announcement. */
export type CompassAcknowledgeAnnouncementInput = {
    /** The ID of the announcement being acknowledged. */
    announcementId: Scalars["ID"]["input"];
    /** The ID of the component that is acknowledging the announcement. */
    componentId: Scalars["ID"]["input"];
};

/** The payload returned after acknowledging an announcement. */
export type CompassAcknowledgeAnnouncementPayload = Payload & {
    __typename?: "CompassAcknowledgeAnnouncementPayload";
    /** The announcement acknowledgement. */
    acknowledgement?: Maybe<CompassAnnouncementAcknowledgement>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The user-provided input to add a new document */
export type CompassAddDocumentInput = {
    /** The ID of the component to add the document to. */
    componentId: Scalars["ID"]["input"];
    /** The ID of the documentation category to add the document to. */
    documentationCategoryId: Scalars["ID"]["input"];
    /** The (optional) display title of the document. */
    title?: InputMaybe<Scalars["String"]["input"]>;
    /** The URL of the document */
    url: Scalars["URL"]["input"];
};

/** The payload returned from document to be added */
export type CompassAddDocumentPayload = Payload & {
    __typename?: "CompassAddDocumentPayload";
    /**
     * The added document.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    documentDetails?: Maybe<CompassDocument>;
    /** A list of errors that occurred during document creation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the document was added successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for adding labels to a team. */
export type CompassAddTeamLabelsInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
    /** A list of labels that should be added to the team. */
    labels: Array<Scalars["String"]["input"]>;
    /** The unique identifier (ID) of the target team. */
    teamId: Scalars["ID"]["input"];
};

/** The payload returned after adding labels to a team. */
export type CompassAddTeamLabelsPayload = Payload & {
    __typename?: "CompassAddTeamLabelsPayload";
    /** A list of labels that were added to the team. */
    addedLabels?: Maybe<Array<CompassTeamLabel>>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** A flag indicating whether the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type CompassAlertEvent = CompassEvent & {
    __typename?: "CompassAlertEvent";
    /**
     * Alert Properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    alertProperties: CompassAlertEventProperties;
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Properties specific to Alert events */
export type CompassAlertEventProperties = {
    __typename?: "CompassAlertEventProperties";
    /**
     * The last time the alert status changed to ACKNOWLEDGED.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    acknowledgedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The last time the alert status changed to CLOSED.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    closedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Timestamp for when the alert was created, when status is set to OPENED.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The ID of the alert.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Priority of the alert. Possible values: P1, P2, P3, P4, P5.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    priority?: Maybe<Scalars["String"]["output"]>;
    /**
     * The last time the alert status changed to SNOOZED.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    snoozedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Status of the alert. Possible values: OPENED, ACKNOWLEDGED, SNOOZED, CLOSED.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<Scalars["String"]["output"]>;
};

/** The list of properties of the alert event. */
export type CompassAlertEventPropertiesInput = {
    /** The last time the alert status changed to ACKNOWLEDGED. */
    acknowledgedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The last time the alert status changed to CLOSED. */
    closedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Timestamp for when the alert was created, when status is set to OPENED. */
    createdAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The ID of the alert. */
    id: Scalars["ID"]["input"];
    /** Priority of the alert. */
    priority?: InputMaybe<AlertPriority>;
    /** The last time the alert status changed to SNOOZED. */
    snoozedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Status of the alert. */
    status?: InputMaybe<AlertEventStatus>;
};

/** An announcement communicates news or updates relating to a component. */
export type CompassAnnouncement = {
    __typename?: "CompassAnnouncement";
    /** The list of acknowledgements that are required for this announcement. */
    acknowledgements?: Maybe<Array<CompassAnnouncementAcknowledgement>>;
    /**
     * The component that posted the announcement.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    component?: Maybe<CompassComponent>;
    /** The description of the announcement. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the announcement. */
    id: Scalars["ID"]["output"];
    /** The date on which the updates in the announcement will take effect. */
    targetDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The title of the announcement. */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Tracks whether or not a component has acknowledged an announcement. */
export type CompassAnnouncementAcknowledgement = {
    __typename?: "CompassAnnouncementAcknowledgement";
    /**
     * The component that needs to acknowledge.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    component?: Maybe<CompassComponent>;
    /** Whether the component has acknowledged the announcement or not. */
    hasAcknowledged?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CompassApplicationManagedComponentsConnection = {
    __typename?: "CompassApplicationManagedComponentsConnection";
    edges?: Maybe<Array<CompassApplicationManagedComponentsEdge>>;
    nodes?: Maybe<Array<CompassComponent>>;
    pageInfo: PageInfo;
};

export type CompassApplicationManagedComponentsEdge = {
    __typename?: "CompassApplicationManagedComponentsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassComponent>;
};

/** The query to get all managed components on a Compass site. */
export type CompassApplicationManagedComponentsQuery = {
    /** Returns results after the specified cursor. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The cloud ID of the site to query for managed components. */
    cloudId: Scalars["ID"]["input"];
    /** The number of results to return in the query. The default is 10. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassApplicationManagedComponentsResult =
    | CompassApplicationManagedComponentsConnection
    | QueryError;

/** Represents a Compass Assistant answer to a user question. */
export type CompassAssistantAnswer = Node & {
    __typename?: "CompassAssistantAnswer";
    /** The unique identifier of this answer */
    id: Scalars["ID"]["output"];
    /** The status of this answer: PENDING, SUCCESS or ERROR */
    status?: Maybe<Scalars["String"]["output"]>;
    /** The text contents of this answer, if already available */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** An attention item represent an issue requiring your attention. */
export type CompassAttentionItem = Node & {
    __typename?: "CompassAttentionItem";
    /** The label for the attention item action */
    actionLabel: Scalars["String"]["output"];
    /** The URI for the attention item action */
    actionUri: Scalars["String"]["output"];
    /** The description of the attention item */
    description: Scalars["String"]["output"];
    /** The unique identifier (ID) of the attention item */
    id: Scalars["ID"]["output"];
    /** The priority of an attention item from 1-3 */
    priority: Scalars["Int"]["output"];
    /** The type of attention item e.g. Scorecard */
    type: Scalars["String"]["output"];
};

export type CompassAttentionItemConnection = {
    __typename?: "CompassAttentionItemConnection";
    edges?: Maybe<Array<Maybe<CompassAttentionItemEdge>>>;
    nodes?: Maybe<Array<CompassAttentionItem>>;
    pageInfo: PageInfo;
};

export type CompassAttentionItemEdge = {
    __typename?: "CompassAttentionItemEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassAttentionItem>;
};

export type CompassAttentionItemQuery = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassAttentionItemQueryResult =
    | CompassAttentionItemConnection
    | QueryError;

export type CompassBooleanField = CompassField & {
    __typename?: "CompassBooleanField";
    /**
     * The boolean value of the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The definition of the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassFieldDefinition>;
};

export type CompassBooleanFieldDefinitionOptions = {
    __typename?: "CompassBooleanFieldDefinitionOptions";
    /** The default option for field definition. */
    booleanDefault: Scalars["Boolean"]["output"];
    /** Possible values of the field definition. */
    booleanValues?: Maybe<Array<Scalars["Boolean"]["output"]>>;
};

export type CompassBooleanFieldValueInput = {
    booleanValue: Scalars["Boolean"]["input"];
};

export type CompassBuildEvent = CompassEvent & {
    __typename?: "CompassBuildEvent";
    /**
     * Build Properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    buildProperties: CompassBuildEventProperties;
    /**
     * The description of the build event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the build event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the build event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type CompassBuildEventPipeline = {
    __typename?: "CompassBuildEventPipeline";
    /**
     * The name of the build event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the build event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pipelineId: Scalars["String"]["output"];
    /**
     * The URL to the build event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** The build event pipeline. */
export type CompassBuildEventPipelineInput = {
    /** The name of the build event pipeline. */
    displayName?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the build event pipeline. */
    pipelineId: Scalars["String"]["input"];
    /** The URL to the build event pipeline. */
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassBuildEventProperties = {
    __typename?: "CompassBuildEventProperties";
    /**
     * Time the build completed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The build event pipeline
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pipeline?: Maybe<CompassBuildEventPipeline>;
    /**
     * Time the build started.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    startedAt: Scalars["DateTime"]["output"];
    /**
     * The state of the build
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    state: CompassBuildEventState;
};

/** The list of properties of the build event. */
export type CompassBuildEventPropertiesInput = {
    /** Time the build completed. */
    completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The build event pipeline. */
    pipeline: CompassBuildEventPipelineInput;
    /** Time the build started. */
    startedAt: Scalars["DateTime"]["input"];
    /** The state of the build. */
    state: CompassBuildEventState;
};

/** Potential states for Build events */
export enum CompassBuildEventState {
    Cancelled = "CANCELLED",
    Error = "ERROR",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Successful = "SUCCESSFUL",
    TimedOut = "TIMED_OUT",
    Unknown = "UNKNOWN"
}

export type CompassCampaign = Node & {
    __typename?: "CompassCampaign";
    /** User who created the campaign */
    createdByUser?: Maybe<User>;
    /** The ADF description of the campaign */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The target end date of the campaign */
    dueDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The unique identifier (ID) of the Campaign */
    id: Scalars["ID"]["output"];
    /** The name of the campaign */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Scorecard for the campaign. */
    scorecard?: Maybe<CompassScorecard>;
    /** The start date of the campaign */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The status of the campaign */
    status?: Maybe<Scalars["String"]["output"]>;
};

export type CompassCampaignConnection = {
    __typename?: "CompassCampaignConnection";
    edges?: Maybe<Array<CompassCampaignEdge>>;
    nodes?: Maybe<Array<Maybe<CompassCampaign>>>;
    pageInfo: PageInfo;
};

export type CompassCampaignEdge = {
    __typename?: "CompassCampaignEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassCampaign>;
};

export type CompassCampaignQuery = {
    /** Returns only campaigns whose attributes match those in the filters specified. */
    filter?: InputMaybe<CompassCampaignQueryFilter>;
    /** Returns campaigns according to the sorting scheme specified. */
    sort?: InputMaybe<CompassCampaignQuerySort>;
};

export type CompassCampaignQueryFilter = {
    /** Filter campaigns by the user who created the campaign */
    createdByUserId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Filter campaigns by status */
    status?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassCampaignQuerySort = {
    /** The name of the field to sort by: due_date */
    name: Scalars["String"]["input"];
    /** The order of the field to sort */
    order?: InputMaybe<CompassCampaignQuerySortOrder>;
};

export enum CompassCampaignQuerySortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type CompassCampaignResult = CompassCampaign | QueryError;

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApi = {
    __typename?: "CompassCatalogMutationApi";
    /**
     * Acknowledges an announcement on behalf of a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    acknowledgeAnnouncement?: Maybe<CompassAcknowledgeAnnouncementPayload>;
    /**
     * Adds a collection of labels to a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    addComponentLabels?: Maybe<AddCompassComponentLabelsPayload>;
    /**
     * Adds a new document
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'addDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addDocument?: Maybe<CompassAddDocumentPayload>;
    /**
     * Adds labels to a team within Compass.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    addTeamLabels?: Maybe<CompassAddTeamLabelsPayload>;
    /**
     * Applies a scorecard to a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    applyScorecardToComponent?: Maybe<ApplyCompassScorecardToComponentPayload>;
    /**
     * Attach a data manager to a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    attachComponentDataManager?: Maybe<AttachCompassComponentDataManagerPayload>;
    /**
     * Attaches an event source to a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    attachEventSource?: Maybe<AttachEventSourcePayload>;
    /**
     * Creates an announcement for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createAnnouncement?: Maybe<CompassCreateAnnouncementPayload>;
    /**
     * Starts the creation of a Compass assistant answer based on the user-provided question
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createAssistantAnswer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createAssistantAnswer?: Maybe<CompassCreateAssistantAnswerPayload>;
    /**
     * Create a campaign
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createCampaign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createCampaign?: Maybe<CompassCreateCampaignPayload>;
    /**
     * Creates a compass event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:event:compass__
     *
     *
     */
    createCompassEvent?: Maybe<CompassCreateEventsPayload>;
    /**
     * Creates a new component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createComponent?: Maybe<CreateCompassComponentPayload>;
    /**
     * Creates a component API upload
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createComponentApiUpload' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createComponentApiUpload?: Maybe<CreateComponentApiUploadPayload>;
    /**
     * Creates an external alias for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createComponentExternalAlias?: Maybe<CreateCompassComponentExternalAliasPayload>;
    /**
     * Creates a new component from a given template.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createComponentFromTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createComponentFromTemplate?: Maybe<CreateCompassComponentFromTemplatePayload>;
    /**
     * Creates a link for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createComponentLink?: Maybe<CreateCompassComponentLinkPayload>;
    /**
     * Creates a Jira issue for a component scorecard relationship.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createComponentScorecardJiraIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createComponentScorecardJiraIssue?: Maybe<CompassCreateComponentScorecardJiraIssuePayload>;
    /**
     * Creates a subscription to a component for current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    createComponentSubscription?: Maybe<CompassCreateComponentSubscriptionPayload>;
    /**
     * Creates a new component type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    createComponentType?: Maybe<CreateCompassComponentTypePayload>;
    /**
     * Creates a custom field definition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createCustomFieldDefinition?: Maybe<CompassCreateCustomFieldDefinitionPayload>;
    /**
     * Creates an event source.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:event:compass__
     *
     *
     */
    createEventSource?: Maybe<CreateEventSourcePayload>;
    /**
     * Creates an incoming webhook that can be invoked to send events to Compass.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createIncomingWebhook' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createIncomingWebhook?: Maybe<CompassCreateIncomingWebhookPayload>;
    /**
     * Creates a token for a Compass incoming webhook
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createIncomingWebhookToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createIncomingWebhookToken?: Maybe<CompassCreateIncomingWebhookTokenPayload>;
    /**
     * Creates a metric definition on a Compass site. A metric definition provides details for a metric source.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    createMetricDefinition?: Maybe<CompassCreateMetricDefinitionPayload>;
    /**
     * Creates a metric source for a component. A metric source contains values providing numerical data about a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    createMetricSource?: Maybe<CompassCreateMetricSourcePayload>;
    /**
     * Creates a new relationship between two components.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createRelationship?: Maybe<CreateCompassRelationshipPayload>;
    /**
     * Creates a scorecard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:scorecard:compass__
     *
     *
     */
    createScorecard?: Maybe<CreateCompassScorecardPayload>;
    /**
     * Creates a starred relationship between a user and a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createStarredComponent?: Maybe<CreateCompassStarredComponentPayload>;
    /**
     * Creates a checkin for a team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    createTeamCheckin?: Maybe<CompassCreateTeamCheckinPayload>;
    /**
     * Creates a webhook to be used after a component is created from a template.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: compass-prototype` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    createWebhook?: Maybe<CompassCreateWebhookPayload>;
    /**
     * Deactivates a scorecard for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'deactivateScorecardForComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deactivateScorecardForComponent?: Maybe<CompassDeactivateScorecardForComponentPayload>;
    /**
     * Deletes an existing announcement from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteAnnouncement?: Maybe<CompassDeleteAnnouncementPayload>;
    /**
     * Delete a campaign
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'deleteCampaign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteCampaign?: Maybe<CompassDeleteCampaignPayload>;
    /**
     * Deletes an existing component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteComponent?: Maybe<DeleteCompassComponentPayload>;
    /**
     * Deletes an existing external alias from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteComponentExternalAlias?: Maybe<DeleteCompassComponentExternalAliasPayload>;
    /**
     * Deletes an existing link from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteComponentLink?: Maybe<DeleteCompassComponentLinkPayload>;
    /**
     * Deletes a subscription to a component for current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    deleteComponentSubscription?: Maybe<CompassDeleteComponentSubscriptionPayload>;
    /**
     * Deletes an existing component type with 0 associated components.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    deleteComponentType?: Maybe<DeleteCompassComponentTypePayload>;
    /**
     * "Deletes existing components."
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteComponents?: Maybe<BulkDeleteCompassComponentsPayload>;
    /**
     * Deletes a custom field definition, along with all values associated with the definition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteCustomFieldDefinition?: Maybe<CompassDeleteCustomFieldDefinitionPayload>;
    /**
     * Deletes a document
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'deleteDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteDocument?: Maybe<CompassDeleteDocumentPayload>;
    /**
     * Deletes an event source and all the corresponding events from that event source.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:event:compass__
     *
     *
     */
    deleteEventSource?: Maybe<DeleteEventSourcePayload>;
    /**
     * Deletes an incoming webhook from Compass.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'deleteIncomingWebhook' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteIncomingWebhook?: Maybe<CompassDeleteIncomingWebhookPayload>;
    /**
     * Deletes a metric definition including the metric sources it defines from a Compass site. Metric sources contain values providing numerical data about a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    deleteMetricDefinition?: Maybe<CompassDeleteMetricDefinitionPayload>;
    /**
     * Deletes a metric source including the metric values it contains.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    deleteMetricSource?: Maybe<CompassDeleteMetricSourcePayload>;
    /**
     * Deletes an existing relationship between two components.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteRelationship?: Maybe<DeleteCompassRelationshipPayload>;
    /**
     * Deletes a scorecard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:scorecard:compass__
     *
     *
     */
    deleteScorecard?: Maybe<DeleteCompassScorecardPayload>;
    /**
     * Deletes a starred relationship between a user and a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    deleteStarredComponent?: Maybe<DeleteCompassStarredComponentPayload>;
    /**
     * Deletes a checkin from a team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    deleteTeamCheckin?: Maybe<CompassDeleteTeamCheckinPayload>;
    /**
     * Detach a data manager from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    detachComponentDataManager?: Maybe<DetachCompassComponentDataManagerPayload>;
    /**
     * Detaches an event source from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    detachEventSource?: Maybe<DetachEventSourcePayload>;
    /**
     * Inserts a metric value in a metric source for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    insertMetricValue?: Maybe<CompassInsertMetricValuePayload>;
    /**
     * Inserts metric values into metric sources using the external ID of the source, except when a Forge app created the metric, and you're not that same Forge app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    insertMetricValueByExternalId?: Maybe<CompassInsertMetricValueByExternalIdPayload>;
    /**
     * Migrate components of a given type to a new type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     * * __write:component:compass__
     *
     *
     */
    migrateComponentType?: Maybe<MigrateComponentTypePayload>;
    /**
     * Reactivates a scorecard for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'reactivateScorecardForComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    reactivateScorecardForComponent?: Maybe<CompassReactivateScorecardForComponentPayload>;
    /**
     * Removes a collection of existing labels from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    removeComponentLabels?: Maybe<RemoveCompassComponentLabelsPayload>;
    /**
     * Removes a scorecard from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    removeScorecardFromComponent?: Maybe<RemoveCompassScorecardFromComponentPayload>;
    /**
     * Removes labels from a team within Compass.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    removeTeamLabels?: Maybe<CompassRemoveTeamLabelsPayload>;
    /**
     * Revokes the user whose credentials are being used to fetch JQL metric values for the given metric source
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'revokeJqlMetricSourceUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    revokeJqlMetricSourceUser?: Maybe<CompassRevokeJqlMetricSourceUserPayload>;
    /**
     * Sets an entity property.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'setEntityProperty' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setEntityProperty?: Maybe<CompassSetEntityPropertyPayload>;
    /**
     * Synchronizes event and metric information for the current set of component links on a Compass site using the provided Forge app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     * * __write:event:compass__
     * * __write:metric:compass__
     *
     *
     */
    synchronizeLinkAssociations?: Maybe<CompassSynchronizeLinkAssociationsPayload>;
    /**
     * Clean external aliases and data managers pertaining to an externalSource
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    unlinkExternalSource?: Maybe<UnlinkExternalSourcePayload>;
    /**
     * Unsets an entity property, reverting it to the property's default value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'unsetEntityProperty' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    unsetEntityProperty?: Maybe<CompassUnsetEntityPropertyPayload>;
    /**
     * Updates an announcement from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateAnnouncement?: Maybe<CompassUpdateAnnouncementPayload>;
    /**
     * Update a campaign
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateCampaign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateCampaign?: Maybe<CompassUpdateCampaignPayload>;
    /**
     * Updates an existing component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateComponent?: Maybe<UpdateCompassComponentPayload>;
    /**
     * Update the API of a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateComponentApi' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateComponentApi?: Maybe<UpdateComponentApiPayload>;
    /**
     * Updates a component API upload
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateComponentApiUpload' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateComponentApiUpload?: Maybe<UpdateComponentApiUploadPayload>;
    /**
     * Update a data manager of a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateComponentDataManagerMetadata?: Maybe<UpdateCompassComponentDataManagerMetadataPayload>;
    /**
     * Updates a link from a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateComponentLink?: Maybe<UpdateCompassComponentLinkPayload>;
    /**
     * Updates a Jira issue for a component scorecard relationship.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateComponentScorecardJiraIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateComponentScorecardJiraIssue?: Maybe<CompassUpdateComponentScorecardJiraIssuePayload>;
    /**
     * Updates a component's type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateComponentType?: Maybe<UpdateCompassComponentTypePayload>;
    /**
     * Updates an existing component type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    updateComponentTypeMetadata?: Maybe<UpdateCompassComponentTypeMetadataPayload>;
    /**
     * Updates multiple existing components.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateComponents?: Maybe<BulkUpdateCompassComponentsPayload>;
    /**
     * Updates a custom field definition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     *
     */
    updateCustomFieldDefinition?: Maybe<CompassUpdateCustomFieldDefinitionPayload>;
    /**
     * Update the custom permission configs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateCustomPermissionConfigs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateCustomPermissionConfigs?: Maybe<CompassUpdatePermissionConfigsPayload>;
    /**
     * Updates a document
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateDocument?: Maybe<CompassUpdateDocumentPayload>;
    /**
     * Sets the current user as the user whose credentials are being used to fetch JQL metric values for the given metric source
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateJqlMetricSourceUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJqlMetricSourceUser?: Maybe<CompassUpdateJqlMetricSourceUserPayload>;
    /**
     * Updates a metric definition on a Compass site.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    updateMetricDefinition?: Maybe<CompassUpdateMetricDefinitionPayload>;
    /**
     * Updates a component metric source.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:metric:compass__
     *
     *
     */
    updateMetricSource?: Maybe<CompassUpdateMetricSourcePayload>;
    /**
     * Updates a scorecard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:scorecard:compass__
     *
     *
     */
    updateScorecard?: Maybe<UpdateCompassScorecardPayload>;
    /**
     * Updates a checkin for a team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    updateTeamCheckin?: Maybe<CompassUpdateTeamCheckinPayload>;
    /**
     * Creates, updates, and deletes parameters from a given component
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'updateUserDefinedParameters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateUserDefinedParameters?: Maybe<UpdateCompassUserDefinedParametersPayload>;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiAcknowledgeAnnouncementArgs = {
    input: CompassAcknowledgeAnnouncementInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiAddComponentLabelsArgs = {
    input: AddCompassComponentLabelsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiAddDocumentArgs = {
    input: CompassAddDocumentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiAddTeamLabelsArgs = {
    input: CompassAddTeamLabelsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiApplyScorecardToComponentArgs = {
    componentId: Scalars["ID"]["input"];
    scorecardId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiAttachComponentDataManagerArgs = {
    input: AttachCompassComponentDataManagerInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiAttachEventSourceArgs = {
    input: AttachEventSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateAnnouncementArgs = {
    input: CompassCreateAnnouncementInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateAssistantAnswerArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CreateCompassAssistantAnswerInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateCampaignArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CompassCreateCampaignInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateCompassEventArgs = {
    input: CompassCreateEventInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CreateCompassComponentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentApiUploadArgs = {
    input: CreateComponentApiUploadInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentExternalAliasArgs = {
    input: CreateCompassComponentExternalAliasInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentFromTemplateArgs = {
    input: CreateCompassComponentFromTemplateInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentLinkArgs = {
    input: CreateCompassComponentLinkInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentScorecardJiraIssueArgs = {
    input: CompassCreateComponentScorecardJiraIssueInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentSubscriptionArgs = {
    input: CompassCreateComponentSubscriptionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateComponentTypeArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CreateCompassComponentTypeInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateCustomFieldDefinitionArgs = {
    input: CompassCreateCustomFieldDefinitionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateEventSourceArgs = {
    input: CreateEventSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateIncomingWebhookArgs = {
    input: CompassCreateIncomingWebhookInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateIncomingWebhookTokenArgs = {
    input: CompassCreateIncomingWebhookTokenInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateMetricDefinitionArgs = {
    input: CompassCreateMetricDefinitionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateMetricSourceArgs = {
    input: CompassCreateMetricSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateRelationshipArgs = {
    input: CreateCompassRelationshipInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateScorecardArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CreateCompassScorecardInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateStarredComponentArgs = {
    input: CreateCompassStarredComponentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateTeamCheckinArgs = {
    input: CompassCreateTeamCheckinInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiCreateWebhookArgs = {
    input: CompassCreateWebhookInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeactivateScorecardForComponentArgs = {
    componentId: Scalars["ID"]["input"];
    scorecardId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteAnnouncementArgs = {
    input: CompassDeleteAnnouncementInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteCampaignArgs = {
    campaignId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteComponentArgs = {
    input: DeleteCompassComponentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteComponentExternalAliasArgs = {
    input: DeleteCompassComponentExternalAliasInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteComponentLinkArgs = {
    input: DeleteCompassComponentLinkInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteComponentSubscriptionArgs = {
    input: CompassDeleteComponentSubscriptionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteComponentTypeArgs = {
    input: DeleteCompassComponentTypeInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteComponentsArgs = {
    input: BulkDeleteCompassComponentsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteCustomFieldDefinitionArgs = {
    input: CompassDeleteCustomFieldDefinitionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteDocumentArgs = {
    input: CompassDeleteDocumentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteEventSourceArgs = {
    input: DeleteEventSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteIncomingWebhookArgs = {
    input: CompassDeleteIncomingWebhookInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteMetricDefinitionArgs = {
    input: CompassDeleteMetricDefinitionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteMetricSourceArgs = {
    input: CompassDeleteMetricSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteRelationshipArgs = {
    input: DeleteCompassRelationshipInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteScorecardArgs = {
    scorecardId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteStarredComponentArgs = {
    input: DeleteCompassStarredComponentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDeleteTeamCheckinArgs = {
    input: CompassDeleteTeamCheckinInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDetachComponentDataManagerArgs = {
    input: DetachCompassComponentDataManagerInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiDetachEventSourceArgs = {
    input: DetachEventSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiInsertMetricValueArgs = {
    input: CompassInsertMetricValueInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiInsertMetricValueByExternalIdArgs = {
    input: CompassInsertMetricValueByExternalIdInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiMigrateComponentTypeArgs = {
    cloudId: Scalars["ID"]["input"];
    input: MigrateComponentTypeInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiReactivateScorecardForComponentArgs = {
    componentId: Scalars["ID"]["input"];
    scorecardId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiRemoveComponentLabelsArgs = {
    input: RemoveCompassComponentLabelsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiRemoveScorecardFromComponentArgs = {
    componentId: Scalars["ID"]["input"];
    scorecardId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiRemoveTeamLabelsArgs = {
    input: CompassRemoveTeamLabelsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiRevokeJqlMetricSourceUserArgs = {
    input: CompassRevokeJqlMetricSourceUserInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiSetEntityPropertyArgs = {
    input: CompassSetEntityPropertyInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiSynchronizeLinkAssociationsArgs = {
    input?: InputMaybe<CompassSynchronizeLinkAssociationsInput>;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUnlinkExternalSourceArgs = {
    input: UnlinkExternalSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUnsetEntityPropertyArgs = {
    input: CompassUnsetEntityPropertyInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateAnnouncementArgs = {
    input: CompassUpdateAnnouncementInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateCampaignArgs = {
    campaignId: Scalars["ID"]["input"];
    input: CompassUpdateCampaignInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentArgs = {
    input: UpdateCompassComponentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentApiArgs = {
    cloudId: Scalars["ID"]["input"];
    input: UpdateComponentApiInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentApiUploadArgs = {
    input: UpdateComponentApiUploadInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentDataManagerMetadataArgs = {
    input: UpdateCompassComponentDataManagerMetadataInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentLinkArgs = {
    input: UpdateCompassComponentLinkInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentScorecardJiraIssueArgs = {
    input: CompassUpdateComponentScorecardJiraIssueInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentTypeArgs = {
    input: UpdateCompassComponentTypeInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentTypeMetadataArgs = {
    input: UpdateCompassComponentTypeMetadataInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateComponentsArgs = {
    input: BulkUpdateCompassComponentsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateCustomFieldDefinitionArgs = {
    input: CompassUpdateCustomFieldDefinitionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateCustomPermissionConfigsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CompassUpdateCustomPermissionConfigsInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateDocumentArgs = {
    input: CompassUpdateDocumentInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateJqlMetricSourceUserArgs = {
    input: CompassUpdateJqlMetricSourceUserInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateMetricDefinitionArgs = {
    input: CompassUpdateMetricDefinitionInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateMetricSourceArgs = {
    input: CompassUpdateMetricSourceInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateScorecardArgs = {
    input: UpdateCompassScorecardInput;
    scorecardId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateTeamCheckinArgs = {
    input: CompassUpdateTeamCheckinInput;
};

/** The top level wrapper for the Compass Mutations API. */
export type CompassCatalogMutationApiUpdateUserDefinedParametersArgs = {
    input: UpdateCompassUserDefinedParametersInput;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApi = {
    __typename?: "CompassCatalogQueryApi";
    /**
     * Retrieve all managed components based on user context
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'applicationManagedComponents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    applicationManagedComponents?: Maybe<CompassApplicationManagedComponentsResult>;
    /**
     * Retrieves a Compass assistant answer by its unique identifier (ID).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'assistantAnswer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    assistantAnswer?: Maybe<CompassAssistantAnswer>;
    /**
     * Retrieves a list of Attention Items
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:attention-item:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'attentionItems' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use 'attentionItemsConnection' instead
     */
    attentionItems?: Maybe<CompassAttentionItemQueryResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:attention-item:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'attentionItemsConnection' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    attentionItemsConnection?: Maybe<CompassAttentionItemConnection>;
    /**
     * Retrieves a campaign by its unique identifier (ID).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'campaign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    campaign?: Maybe<CompassCampaignResult>;
    /**
     * Retrieves available campaigns.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'campaigns' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    campaigns?: Maybe<CompassCampaignConnection>;
    /**
     * Retrieves a single component by its internal ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    component?: Maybe<CompassComponentResult>;
    /**
     * Retrieves a single component by its external alias.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentByExternalAlias?: Maybe<CompassComponentResult>;
    /**
     * Retrieves a single component by any of its reference.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentByReference?: Maybe<CompassComponentResult>;
    /**
     * Retrieves a component scorecard relationship.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'componentScorecardRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentScorecardRelationship?: Maybe<CompassComponentScorecardRelationshipResult>;
    /**
     * Retrieves a single component type by its ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentType?: Maybe<CompassComponentTypeResult>;
    /**
     * Retrieves a list of component types.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentTypes?: Maybe<CompassComponentTypesQueryResult>;
    /**
     * Retrieves multiple components by their internal ID.
     * Duplicate ids will get collapsed into one entry, and the order of the entries returned will not be consistent with the input values.
     * Component IDs must belong to the same tenant. Maximum length of the input array is 30.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    components?: Maybe<Array<CompassComponent>>;
    /**
     * Retrieves multiple components by any of their references.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentsByReferences?: Maybe<Array<CompassComponent>>;
    /**
     * Retrieves a custom field definition by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'customFieldDefinition' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    customFieldDefinition?: Maybe<CompassCustomFieldDefinitionResult>;
    /**
     * Retrieves custom field definitions by component type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    customFieldDefinitions?: Maybe<CompassCustomFieldDefinitionsResult>;
    /**
     * Fetch custom permission configs
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    customPermissionConfigs?: Maybe<CompassCustomPermissionConfigsResult>;
    /**
     * Retrieves documentation categories
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'documentationCategories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    documentationCategories?: Maybe<CompassDocumentationCategoriesConnection>;
    /**
     * Retrieves documents by component ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'documents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    documents?: Maybe<CompassDocumentConnection>;
    /**
     * Retrieves multiple entity properties.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'entityProperties' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    entityProperties?: Maybe<Array<Maybe<CompassEntityPropertyResult>>>;
    /**
     * Retrieves an entity property.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'entityProperty' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    entityProperty?: Maybe<CompassEntityPropertyResult>;
    /**
     * Retrieve a single event source by its external ID and event type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:event:compass__
     *
     *
     */
    eventSource?: Maybe<CompassEventSourceResult>;
    /**
     * Retrieves field definitions by component type.
     * This API is currently in BETA. You must provide "X-ExperimentalApi:compass-beta" in your request header.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: compass-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     * @deprecated Use `fieldDefinitions` on the `componentTypes` query
     */
    fieldDefinitionsByComponentType?: Maybe<CompassFieldDefinitionsResult>;
    /**
     * Fetch a count of Compass Components matching on a set of filters
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'filteredComponentsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    filteredComponentsCount?: Maybe<CompassFilteredComponentsCountResult>;
    /**
     * Retrieves a list of registered incoming webhooks
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'incomingWebhooks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incomingWebhooks?: Maybe<CompassIncomingWebhooksConnection>;
    /**
     * Retrieves a library scorecard by its unique identifier (ID).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'libraryScorecard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    libraryScorecard?: Maybe<CompassLibraryScorecardResult>;
    /**
     * Retrieves available library scorecards.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'libraryScorecards' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    libraryScorecards?: Maybe<CompassLibraryScorecardConnection>;
    /**
     * Retrieves a single metric definition by its internal ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:metric:compass__
     *
     *
     */
    metricDefinition?: Maybe<CompassMetricDefinitionResult>;
    /**
     * A collection of metric definitions on a Compass site. A metric definition provides details for a metric source.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:metric:compass__
     *
     *
     */
    metricDefinitions?: Maybe<CompassMetricDefinitionsQueryResult>;
    /**
     * Retrieve a bucketed time-series of metric values by metricSourceId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:metric:compass__
     *
     *
     */
    metricValuesTimeSeries?: Maybe<CompassMetricValuesTimeseriesResult>;
    /**
     * Retrieves a scorecard by its unique identifier (ID).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    scorecard?: Maybe<CompassScorecardResult>;
    /**
     * Retrieves available scorecards.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    scorecards?: Maybe<CompassScorecardsQueryResult>;
    /**
     * Searches for all component labels within Compass.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    searchComponentLabels?: Maybe<CompassComponentLabelsQueryResult>;
    /**
     * Searches for Compass components.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    searchComponents?: Maybe<CompassComponentQueryResult>;
    /**
     * Search team labels within a target site.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    searchTeamLabels?: Maybe<CompassSearchTeamLabelsConnectionResult>;
    /**
     * Search teams within a target site.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    searchTeams?: Maybe<CompassSearchTeamsConnectionResult>;
    /**
     * Retrieve all starred components based on the user id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    starredComponents?: Maybe<CompassStarredComponentsResult>;
    /**
     * A collection of checkins posted by a team; sorted by most recent.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    teamCheckins?: Maybe<Array<CompassTeamCheckin>>;
    /**
     * Compass-specific data about a team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    teamData?: Maybe<CompassTeamDataResult>;
    /**
     * Retrieves specified number of user defined parameters for a component
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'userDefinedParameters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userDefinedParameters?: Maybe<CompassUserDefinedParametersConnection>;
    /**
     * Fetch viewer global permissions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    viewerGlobalPermissions?: Maybe<CompassGlobalPermissionsResult>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiApplicationManagedComponentsArgs = {
    query: CompassApplicationManagedComponentsQuery;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiAssistantAnswerArgs = {
    answerId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiAttentionItemsArgs = {
    query: CompassAttentionItemQuery;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiAttentionItemsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiCampaignArgs = {
    id: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiCampaignsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassCampaignQuery>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentArgs = {
    id: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentByExternalAliasArgs = {
    cloudId: Scalars["ID"]["input"];
    externalID: Scalars["ID"]["input"];
    externalSource: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentByReferenceArgs = {
    reference: ComponentReferenceInput;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentScorecardRelationshipArgs = {
    cloudId: Scalars["ID"]["input"];
    componentId: Scalars["ID"]["input"];
    scorecardId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentTypeArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentTypesArgs = {
    cloudId: Scalars["ID"]["input"];
    query?: InputMaybe<CompassComponentTypeQueryInput>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiComponentsByReferencesArgs = {
    references: Array<ComponentReferenceInput>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiCustomFieldDefinitionArgs = {
    query: CompassCustomFieldDefinitionQuery;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiCustomFieldDefinitionsArgs = {
    query: CompassCustomFieldDefinitionsQuery;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiCustomPermissionConfigsArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiDocumentationCategoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiDocumentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    componentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiEntityPropertiesArgs = {
    cloudId: Scalars["ID"]["input"];
    keys: Array<Scalars["String"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiEntityPropertyArgs = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiEventSourceArgs = {
    cloudId: Scalars["ID"]["input"];
    eventType: CompassEventType;
    externalEventSourceId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiFieldDefinitionsByComponentTypeArgs = {
    cloudId: Scalars["ID"]["input"];
    input: CompassComponentType;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiFilteredComponentsCountArgs = {
    cloudId: Scalars["ID"]["input"];
    query: CompassFilteredComponentsCountQuery;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiIncomingWebhooksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiLibraryScorecardArgs = {
    cloudId: Scalars["ID"]["input"];
    libraryScorecardId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiLibraryScorecardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiMetricDefinitionArgs = {
    cloudId: Scalars["ID"]["input"];
    metricDefinitionId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiMetricDefinitionsArgs = {
    query: CompassMetricDefinitionsQuery;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiMetricValuesTimeSeriesArgs = {
    cloudId: Scalars["ID"]["input"];
    metricSourceId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiScorecardArgs = {
    id: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiScorecardsArgs = {
    cloudId: Scalars["ID"]["input"];
    query?: InputMaybe<CompassScorecardsQuery>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiSearchComponentLabelsArgs = {
    cloudId: Scalars["String"]["input"];
    query?: InputMaybe<CompassSearchComponentLabelsQuery>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiSearchComponentsArgs = {
    cloudId: Scalars["String"]["input"];
    query?: InputMaybe<CompassSearchComponentQuery>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiSearchTeamLabelsArgs = {
    input: CompassSearchTeamLabelsInput;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiSearchTeamsArgs = {
    input: CompassSearchTeamsInput;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiStarredComponentsArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiTeamCheckinsArgs = {
    input: CompassTeamCheckinsInput;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiTeamDataArgs = {
    input: CompassTeamDataInput;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiUserDefinedParametersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    componentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Top level wrapper for Compass Query API */
export type CompassCatalogQueryApiViewerGlobalPermissionsArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Metadata about who created or updated the object and when. */
export type CompassChangeMetadata = {
    __typename?: "CompassChangeMetadata";
    /** The date and time when the object was created. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The user who created the object. */
    createdBy?: Maybe<User>;
    /** The date and time when the object was last updated. */
    lastUserModificationAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The user who last updated the object. */
    lastUserModificationBy?: Maybe<User>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponent = Node & {
    __typename?: "CompassComponent";
    /** A collection of announcements posted by the component. */
    announcements?: Maybe<Array<CompassAnnouncement>>;
    /**
     * The API spec for the component
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'api' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    api?: Maybe<CompassComponentApi>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'appliedScorecards' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appliedScorecards?: Maybe<CompassComponentHasScorecardsAppliedConnection>;
    /** Metadata about who created the component and when. */
    changeMetadata: CompassChangeMetadata;
    /**
     * The extended description details associated to the component
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'componentDescriptionDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentDescriptionDetails?: Maybe<CompassComponentDescriptionDetails>;
    /** A collection of custom fields for storing data about the component. */
    customFields?: Maybe<Array<CompassCustomField>>;
    /** The external integration that manages data for this component. */
    dataManager?: Maybe<CompassComponentDataManager>;
    /**
     * A collection of deactivated scorecards for this component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'deactivatedScorecards' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deactivatedScorecards?: Maybe<CompassDeactivatedScorecardsConnection>;
    /** The description of the component. */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The event sources associated to the component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:event:compass__
     *
     *
     */
    eventSources?: Maybe<Array<EventSource>>;
    /**
     * The events associated to the component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:event:compass__
     *
     *
     */
    events?: Maybe<CompassEventsQueryResult>;
    /** A collection of aliases that represent the component in external systems. */
    externalAliases?: Maybe<Array<CompassExternalAlias>>;
    /** A collection of fields for storing data about the component. */
    fields?: Maybe<Array<CompassField>>;
    /** The unique identifier (ID) of the component. */
    id: Scalars["ID"]["output"];
    /** A collection of labels that provide additional contextual information about the component. */
    labels?: Maybe<Array<CompassComponentLabel>>;
    /** A collection of links to other entities on the internet. */
    links?: Maybe<Array<CompassLink>>;
    /**
     * A collection of metric sources, which contain values providing numerical data about the component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:metric:compass__
     *
     *
     */
    metricSources?: Maybe<CompassComponentMetricSourcesQueryResult>;
    /** The name of the component. */
    name: Scalars["String"]["output"];
    /** The unique identifier (ID) of the team that owns the component. */
    ownerId?: Maybe<Scalars["ID"]["output"]>;
    /** A collection of relationships between one component with other components in Compass. Only relationships of the same direction will be returned, defaulting to OUTWARD. */
    relationships?: Maybe<CompassRelationshipConnectionResult>;
    /** Returns the calculated total score for a given scorecard applied to this component. */
    scorecardScore?: Maybe<CompassScorecardScore>;
    /**
     * A collection of scorecard scores applied to a component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    scorecardScores?: Maybe<Array<CompassScorecardScore>>;
    /**
     * A collection of scorecards applied to a component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    scorecards?: Maybe<Array<CompassScorecard>>;
    /** A user-defined unique identifier for the component. */
    slug?: Maybe<Scalars["String"]["output"]>;
    /** The state of the component. */
    state?: Maybe<Scalars["String"]["output"]>;
    /**
     * The type of component.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use `typeId` instead
     */
    type: CompassComponentType;
    /** The type of component. */
    typeId: Scalars["ID"]["output"];
    /** The additional metadata about the type of a Component. */
    typeMetadata?: Maybe<CompassComponentTypeObject>;
    /**
     * A collection of scorecards applicable to a component by the current user.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'viewerApplicableScorecards' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    viewerApplicableScorecards?: Maybe<CompassComponentViewerApplicableScorecardsConnection>;
    /**
     * Viewer permissions specific to this component and user context.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'viewerPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    viewerPermissions?: Maybe<CompassComponentInstancePermissions>;
    /** Component viewer subscription. */
    viewerSubscription?: Maybe<CompassViewerSubscription>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentAppliedScorecardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentDeactivatedScorecardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentEventsArgs = {
    query?: InputMaybe<CompassEventsQuery>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentMetricSourcesArgs = {
    query?: InputMaybe<CompassComponentMetricSourcesQuery>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentRelationshipsArgs = {
    query?: InputMaybe<CompassRelationshipQuery>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentScorecardScoreArgs = {
    query?: InputMaybe<CompassComponentScorecardScoreQuery>;
};

/** A component represents a software development artifact tracked in Compass. */
export type CompassComponentViewerApplicableScorecardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentApi = {
    __typename?: "CompassComponentApi";
    changelog: CompassComponentApiChangelogConnection;
    componentId: Scalars["String"]["output"];
    createdAt: Scalars["String"]["output"];
    defaultTag: Scalars["String"]["output"];
    deletedAt?: Maybe<Scalars["String"]["output"]>;
    historicSpecTags: CompassComponentSpecTagConnection;
    id: Scalars["String"]["output"];
    latestDefaultSpec?: Maybe<CompassComponentSpec>;
    latestSpecForTag?: Maybe<CompassComponentSpec>;
    latestSpecWithErrorForTag?: Maybe<CompassComponentSpec>;
    path?: Maybe<Scalars["String"]["output"]>;
    repo?: Maybe<CompassComponentApiRepo>;
    repoId?: Maybe<Scalars["String"]["output"]>;
    spec?: Maybe<CompassComponentSpec>;
    stats: CompassComponentApiStats;
    status: Scalars["String"]["output"];
    tags: CompassComponentSpecTagConnection;
    updatedAt: Scalars["String"]["output"];
};

export type CompassComponentApiChangelogArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentApiHistoricSpecTagsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    query: CompassComponentApiHistoricSpecTagsQuery;
};

export type CompassComponentApiLatestSpecForTagArgs = {
    tagName: Scalars["String"]["input"];
};

export type CompassComponentApiLatestSpecWithErrorForTagArgs = {
    tagName?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassComponentApiSpecArgs = {
    id: Scalars["String"]["input"];
};

export type CompassComponentApiTagsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentApiChangelog = {
    __typename?: "CompassComponentApiChangelog";
    baseSpec?: Maybe<CompassComponentSpec>;
    effectiveAt: Scalars["String"]["output"];
    endpointChanges: Array<CompassComponentApiEndpointChange>;
    headSpec?: Maybe<CompassComponentSpec>;
    markdown: Scalars["String"]["output"];
};

export type CompassComponentApiChangelogConnection = {
    __typename?: "CompassComponentApiChangelogConnection";
    edges: Array<CompassComponentApiChangelogEdge>;
    nodes: Array<CompassComponentApiChangelog>;
    pageInfo: PageInfo;
};

export type CompassComponentApiChangelogEdge = {
    __typename?: "CompassComponentApiChangelogEdge";
    cursor: Scalars["String"]["output"];
    node: CompassComponentApiChangelog;
};

export type CompassComponentApiEndpointChange = {
    __typename?: "CompassComponentApiEndpointChange";
    changeType?: Maybe<Scalars["String"]["output"]>;
    changelog?: Maybe<Array<Scalars["String"]["output"]>>;
    method: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
};

export type CompassComponentApiHistoricSpecTagsQuery = {
    tagName: Scalars["String"]["input"];
};

export type CompassComponentApiRepo = {
    __typename?: "CompassComponentApiRepo";
    provider: Scalars["String"]["output"];
    repoUrl: Scalars["String"]["output"];
};

export type CompassComponentApiRepoUpdate = {
    provider: Scalars["String"]["input"];
    repoUrl: Scalars["String"]["input"];
};

export type CompassComponentApiStats = {
    __typename?: "CompassComponentApiStats";
    endpointChanges: CompassComponentApiStatsEndpointChangesConnection;
};

export type CompassComponentApiStatsEndpointChangesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentApiStatsEndpointChange = {
    __typename?: "CompassComponentApiStatsEndpointChange";
    added: Scalars["Int"]["output"];
    changed: Scalars["Int"]["output"];
    firstWeekDay: Scalars["String"]["output"];
    removed: Scalars["Int"]["output"];
};

export type CompassComponentApiStatsEndpointChangeEdge = {
    __typename?: "CompassComponentApiStatsEndpointChangeEdge";
    cursor: Scalars["String"]["output"];
    node: CompassComponentApiStatsEndpointChange;
};

export type CompassComponentApiStatsEndpointChangesConnection = {
    __typename?: "CompassComponentApiStatsEndpointChangesConnection";
    edges: Array<CompassComponentApiStatsEndpointChangeEdge>;
    nodes: Array<CompassComponentApiStatsEndpointChange>;
    pageInfo: PageInfo;
};

export type CompassComponentCreationTimeFilter = {
    __typename?: "CompassComponentCreationTimeFilter";
    /**
     * The filter date of component creation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Filter before or after the time.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    filter?: Maybe<Scalars["String"]["output"]>;
};

export type CompassComponentCreationTimeFilterInput = {
    /** The filter date of component creation. */
    createdAt: Scalars["DateTime"]["input"];
    /** Filter before or after the time. */
    filter: CompassComponentCreationTimeFilterType;
};

export enum CompassComponentCreationTimeFilterType {
    After = "AFTER",
    Before = "BEFORE"
}

export type CompassComponentCustomBooleanFieldFilterInput = {
    /** The custom field definition ID to apply the filter to */
    customFieldId: Scalars["String"]["input"];
    /** Nullable Boolean value to filter on */
    value?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** An external integration that manages data for a particular component. */
export type CompassComponentDataManager = {
    __typename?: "CompassComponentDataManager";
    /** The unique identifier (ID) of the ecosystem app acting as a component data manager. */
    ecosystemAppId: Scalars["ID"]["output"];
    /** An URL of the external source. */
    externalSourceURL?: Maybe<Scalars["URL"]["output"]>;
    /** Details about the last sync event to this component. */
    lastSyncEvent?: Maybe<ComponentSyncEvent>;
};

export type CompassComponentDeactivatedScorecardsEdge = {
    __typename?: "CompassComponentDeactivatedScorecardsEdge";
    cursor: Scalars["String"]["output"];
    deactivatedBy?: Maybe<User>;
    deactivatedOn?: Maybe<Scalars["DateTime"]["output"]>;
    lastScorecardScore?: Maybe<Scalars["Int"]["output"]>;
    node?: Maybe<CompassDeactivatedScorecard>;
};

export type CompassComponentDescriptionDetails = {
    __typename?: "CompassComponentDescriptionDetails";
    /** The extended description details text body associated with a component. */
    content: Scalars["String"]["output"];
};

export type CompassComponentDescriptionDetailsInput = {
    /** The extended description details text body associated with a component. */
    content: Scalars["String"]["input"];
};

export type CompassComponentEndpoint = {
    __typename?: "CompassComponentEndpoint";
    checksum: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    method: Scalars["String"]["output"];
    originalPath: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
    readUrl: Scalars["String"]["output"];
    summary: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
};

export type CompassComponentEndpointConnection = {
    __typename?: "CompassComponentEndpointConnection";
    edges: Array<CompassComponentEndpointEdge>;
    nodes: Array<CompassComponentEndpoint>;
    pageInfo: PageInfo;
};

export type CompassComponentEndpointEdge = {
    __typename?: "CompassComponentEndpointEdge";
    cursor: Scalars["String"]["output"];
    node: CompassComponentEndpoint;
};

export type CompassComponentHasScorecardsAppliedConnection = {
    __typename?: "CompassComponentHasScorecardsAppliedConnection";
    edges?: Maybe<Array<CompassComponentHasScorecardsAppliedEdge>>;
    nodes?: Maybe<Array<CompassScorecard>>;
    pageInfo: PageInfo;
};

export type CompassComponentHasScorecardsAppliedEdge = {
    __typename?: "CompassComponentHasScorecardsAppliedEdge";
    activeIssues?: Maybe<CompassComponentScorecardJiraIssuesQueryResult>;
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecard>;
    /**
     * Returns the calculated total score for a given component.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scorecardScore' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scorecardScore?: Maybe<CompassScorecardScore>;
};

export type CompassComponentHasScorecardsAppliedEdgeActiveIssuesArgs = {
    query?: InputMaybe<CompassComponentScorecardJiraIssuesQuery>;
};

export type CompassComponentInstancePermissions = {
    __typename?: "CompassComponentInstancePermissions";
    applyScorecard?: Maybe<CompassPermissionResult>;
    archive?: Maybe<CompassPermissionResult>;
    connectEventSource?: Maybe<CompassPermissionResult>;
    connectMetricSource?: Maybe<CompassPermissionResult>;
    createAnnouncement?: Maybe<CompassPermissionResult>;
    delete?: Maybe<CompassPermissionResult>;
    edit?: Maybe<CompassPermissionResult>;
    modifyAnnouncement?: Maybe<CompassPermissionResult>;
    publish?: Maybe<CompassPermissionResult>;
    pushMetricValues?: Maybe<CompassPermissionResult>;
    viewAnnouncement?: Maybe<CompassPermissionResult>;
};

/** A label provides additional contextual information about a component. */
export type CompassComponentLabel = {
    __typename?: "CompassComponentLabel";
    /** The name of the label. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type CompassComponentLabelsQueryResult =
    | CompassSearchComponentLabelsConnection
    | QueryError;

/** A connection that returns a paginated collection of metric sources. */
export type CompassComponentMetricSourcesConnection = {
    __typename?: "CompassComponentMetricSourcesConnection";
    /** A list of edges which contain a metric source and a cursor. */
    edges?: Maybe<Array<CompassMetricSourceEdge>>;
    /** A list of metric sources. */
    nodes?: Maybe<Array<CompassMetricSource>>;
    /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
    pageInfo: PageInfo;
};

/** The query to get the metric sources of a component. */
export type CompassComponentMetricSourcesQuery = {
    /** Returns results after the specified cursor. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The number of results to return in the query. The default is 10. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentMetricSourcesQueryResult =
    | CompassComponentMetricSourcesConnection
    | QueryError;

export type CompassComponentQueryResult =
    | CompassSearchComponentConnection
    | QueryError;

export type CompassComponentResult = CompassComponent | QueryError;

export type CompassComponentScorecardJiraIssueConnection = {
    __typename?: "CompassComponentScorecardJiraIssueConnection";
    edges?: Maybe<Array<Maybe<CompassComponentScorecardJiraIssueEdge>>>;
    nodes?: Maybe<Array<Maybe<CompassJiraIssue>>>;
    pageInfo: PageInfo;
};

export type CompassComponentScorecardJiraIssueEdge = CompassJiraIssueEdge & {
    __typename?: "CompassComponentScorecardJiraIssueEdge";
    cursor: Scalars["String"]["output"];
    isActive?: Maybe<Scalars["Boolean"]["output"]>;
    node?: Maybe<CompassJiraIssue>;
};

export type CompassComponentScorecardJiraIssuesQuery = {
    /** Returns the issues after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The first N number of issues to return in the query. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentScorecardJiraIssuesQueryResult =
    | CompassComponentScorecardJiraIssueConnection
    | QueryError;

/** A component scorecard relationship. */
export type CompassComponentScorecardRelationship = {
    __typename?: "CompassComponentScorecardRelationship";
    /** The active Compass Scorecard Jira issues linked to this component scorecard relationship. */
    activeIssues?: Maybe<CompassComponentScorecardJiraIssuesQueryResult>;
    /** The date time which the component scorecard relationship was created. */
    appliedSince: Scalars["DateTime"]["output"];
    /**
     * The historical criteria score information for a component based on the applied scorecard criteria.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'criteriaScoreHistories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    criteriaScoreHistories?: Maybe<CompassScorecardCriteriaScoreHistoryConnection>;
    /** The score information for a component based on the applied scorecard criteria. */
    score?: Maybe<CompassScorecardScoreResult>;
    /**
     * The historical scorecard score information for a component based on the applied scorecard criteria.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scorecardScoreHistories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scorecardScoreHistories?: Maybe<CompassScorecardScoreHistoryConnection>;
    /** Viewer permissions specific to this component scorecard relationship and user context. */
    viewerPermissions?: Maybe<CompassComponentScorecardRelationshipInstancePermissions>;
};

/** A component scorecard relationship. */
export type CompassComponentScorecardRelationshipActiveIssuesArgs = {
    query?: InputMaybe<CompassComponentScorecardJiraIssuesQuery>;
};

/** A component scorecard relationship. */
export type CompassComponentScorecardRelationshipCriteriaScoreHistoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassScorecardCriteriaScoreHistoryQuery>;
};

/** A component scorecard relationship. */
export type CompassComponentScorecardRelationshipScorecardScoreHistoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassScorecardScoreHistoryQuery>;
};

export type CompassComponentScorecardRelationshipInstancePermissions = {
    __typename?: "CompassComponentScorecardRelationshipInstancePermissions";
    createJiraIssueForAppliedScorecard?: Maybe<CompassPermissionResult>;
    removeScorecard?: Maybe<CompassPermissionResult>;
};

export type CompassComponentScorecardRelationshipResult =
    | CompassComponentScorecardRelationship
    | QueryError;

/** Scorecard score on a component for a scorecard. */
export type CompassComponentScorecardScoreQuery = {
    /** The unique identifier (ID) of the scorecard. */
    scorecardId: Scalars["ID"]["input"];
};

export type CompassComponentSpec = {
    __typename?: "CompassComponentSpec";
    api?: Maybe<CompassComponentApi>;
    checksum: Scalars["String"]["output"];
    componentId: Scalars["String"]["output"];
    createdAt: Scalars["String"]["output"];
    endpoint?: Maybe<CompassComponentEndpoint>;
    endpoints: CompassComponentEndpointConnection;
    id: Scalars["String"]["output"];
    metadataReadUrl?: Maybe<Scalars["String"]["output"]>;
    openapiVersion: Scalars["String"]["output"];
    processingData: CompassComponentSpecProcessingData;
    status: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
};

export type CompassComponentSpecEndpointArgs = {
    method: Scalars["String"]["input"];
    path: Scalars["String"]["input"];
};

export type CompassComponentSpecEndpointsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentSpecProcessingData = {
    __typename?: "CompassComponentSpecProcessingData";
    errors?: Maybe<Array<Scalars["String"]["output"]>>;
    warnings?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type CompassComponentSpecTag = {
    __typename?: "CompassComponentSpecTag";
    api?: Maybe<CompassComponentApi>;
    createdAt: Scalars["String"]["output"];
    effectiveAt: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    overwrittenAt?: Maybe<Scalars["String"]["output"]>;
    overwrittenBy?: Maybe<Scalars["String"]["output"]>;
    spec?: Maybe<CompassComponentSpec>;
    updatedAt: Scalars["String"]["output"];
};

export type CompassComponentSpecTagConnection = {
    __typename?: "CompassComponentSpecTagConnection";
    edges: Array<CompassComponentSpecTagEdge>;
    nodes: Array<CompassComponentSpecTag>;
    pageInfo: PageInfo;
};

export type CompassComponentSpecTagEdge = {
    __typename?: "CompassComponentSpecTagEdge";
    cursor: Scalars["String"]["output"];
    node: CompassComponentSpecTag;
};

/** A tier provides additional contextual information about a component. */
export type CompassComponentTier = {
    __typename?: "CompassComponentTier";
    /** The value of the tier. */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Identifies the type of component. */
export enum CompassComponentType {
    /** A standalone software artifact that is directly consumable by an end-user. */
    Application = "APPLICATION",
    /** A standalone software artifact that provides some functionality for other software via embedding. */
    Library = "LIBRARY",
    /** A software artifact that does not fit into the pre-defined categories. */
    Other = "OTHER",
    /** A software artifact that provides some functionality for other software over the network. */
    Service = "SERVICE"
}

export type CompassComponentTypeConnection = {
    __typename?: "CompassComponentTypeConnection";
    edges?: Maybe<Array<CompassComponentTypeEdge>>;
    nodes?: Maybe<Array<CompassComponentTypeObject>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassComponentTypeEdge = {
    __typename?: "CompassComponentTypeEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassComponentTypeObject>;
};

/** Represents a type of software component that is distinguishable from other types.  Service vs Library, for example */
export type CompassComponentTypeObject = Node & {
    __typename?: "CompassComponentTypeObject";
    /** The number of components of this type. */
    componentCount?: Maybe<Scalars["Int"]["output"]>;
    /** The description of the component type. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The field definitions for the component type. */
    fieldDefinitions?: Maybe<CompassFieldDefinitionsResult>;
    /** Icon URL of the component type. */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier (ID) of the component type. */
    id: Scalars["ID"]["output"];
    /** The name of the component type. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Input for querying Compass component types */
export type CompassComponentTypeQueryInput = {
    /** Returns results after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The number of results to return in the query.  The default number is 25. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassComponentTypeResult =
    | CompassComponentTypeObject
    | QueryError;

export type CompassComponentTypesQueryResult =
    | CompassComponentTypeConnection
    | QueryError;

export type CompassComponentViewerApplicableScorecardEdge = {
    __typename?: "CompassComponentViewerApplicableScorecardEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecard>;
};

export type CompassComponentViewerApplicableScorecardsConnection = {
    __typename?: "CompassComponentViewerApplicableScorecardsConnection";
    edges?: Maybe<Array<CompassComponentViewerApplicableScorecardEdge>>;
    nodes?: Maybe<Array<CompassScorecard>>;
    pageInfo: PageInfo;
};

/** An alert event. */
export type CompassCreateAlertEventInput = {
    /** Alert Properties */
    alertProperties: CompassAlertEventPropertiesInput;
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

/** Accepts input for creating a component announcement. */
export type CompassCreateAnnouncementInput = {
    /** The ID of the component to create an announcement for. */
    componentId: Scalars["ID"]["input"];
    /** The description of the announcement. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The date on which the changes in the announcement will take effect. */
    targetDate: Scalars["DateTime"]["input"];
    /** The title of the announcement. */
    title: Scalars["String"]["input"];
};

/** The payload returned after creating a component announcement. */
export type CompassCreateAnnouncementPayload = Payload & {
    __typename?: "CompassCreateAnnouncementPayload";
    /** The created announcement. */
    createdAnnouncement?: Maybe<CompassAnnouncement>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The payload returned from sending a question to have an answer created. */
export type CompassCreateAssistantAnswerPayload = Payload & {
    __typename?: "CompassCreateAssistantAnswerPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The ID of the answer that would be generated, if successful. */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** A build event. */
export type CompassCreateBuildEventInput = {
    /** Build Properties */
    buildProperties: CompassBuildEventPropertiesInput;
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

export type CompassCreateCampaignInput = {
    description: Scalars["String"]["input"];
    dueDate: Scalars["DateTime"]["input"];
    name: Scalars["String"]["input"];
    scorecardId: Scalars["ID"]["input"];
    startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CompassCreateCampaignPayload = Payload & {
    __typename?: "CompassCreateCampaignPayload";
    campaignDetails?: Maybe<CompassCampaign>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating a component scorecard Jira issue. */
export type CompassCreateComponentScorecardJiraIssueInput = {
    /** The ID of the component associated with the Jira issue. */
    componentId: Scalars["ID"]["input"];
    /** The ID of the Jira issue. */
    issueId: Scalars["ID"]["input"];
    /** The ID of the scorecard associated with the Jira issue. */
    scorecardId: Scalars["ID"]["input"];
    /** The URL of the Jira issue. */
    url: Scalars["URL"]["input"];
};

/** The payload returned from creating a component scorecard Jira issue. */
export type CompassCreateComponentScorecardJiraIssuePayload = Payload & {
    __typename?: "CompassCreateComponentScorecardJiraIssuePayload";
    /** A list of errors that occurred during creating issue. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether user created the component scorecard issue successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Input for creating a component subscription. */
export type CompassCreateComponentSubscriptionInput = {
    /** The ID of the component being subscribed. */
    componentId: Scalars["ID"]["input"];
};

/** The payload returned from creating a component subscription. */
export type CompassCreateComponentSubscriptionPayload = Payload & {
    __typename?: "CompassCreateComponentSubscriptionPayload";
    /** A list of errors that occurred during subscribing. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether user subscribed to the component successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating a custom boolean field definition. */
export type CompassCreateCustomBooleanFieldDefinitionInput = {
    /** The cloud ID of the site to create a custom boolean field definition for. */
    cloudId: Scalars["ID"]["input"];
    /** The component types the custom boolean field appleis to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom boolean field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom boolean field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the custom boolean field. */
    name: Scalars["String"]["input"];
};

/** A custom event. */
export type CompassCreateCustomEventInput = {
    /** Custom Event Properties */
    customEventProperties: CompassCustomEventPropertiesInput;
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

/** Accepts input for creating a custom field definition. You must provide exactly one of the fields in this input type. */
export type CompassCreateCustomFieldDefinitionInput = {
    /** Input for creating a custom boolean field definition. */
    booleanFieldDefinition?: InputMaybe<CompassCreateCustomBooleanFieldDefinitionInput>;
    /** Input for creating a custom multi-select field definition. */
    multiSelectFieldDefinition?: InputMaybe<CompassCreateCustomMultiSelectFieldDefinitionInput>;
    /** Input for creating a custom number field definition. */
    numberFieldDefinition?: InputMaybe<CompassCreateCustomNumberFieldDefinitionInput>;
    /** Input for creating a custom single-select field definition. */
    singleSelectFieldDefinition?: InputMaybe<CompassCreateCustomSingleSelectFieldDefinitionInput>;
    /** Input for creating a custom text field definition. */
    textFieldDefinition?: InputMaybe<CompassCreateCustomTextFieldDefinitionInput>;
    /** Input for creating a custom user field definition. */
    userFieldDefinition?: InputMaybe<CompassCreateCustomUserFieldDefinitionInput>;
};

/** The payload returned from creating a custom field definition. */
export type CompassCreateCustomFieldDefinitionPayload = Payload & {
    __typename?: "CompassCreateCustomFieldDefinitionPayload";
    /** The created custom field definition. */
    customFieldDefinition?: Maybe<CompassCustomFieldDefinition>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating a custom multi select field definition. */
export type CompassCreateCustomMultiSelectFieldDefinitionInput = {
    /** The cloud ID of the site to create a custom multi-select field definition for. */
    cloudId: Scalars["ID"]["input"];
    /** The component types the custom multi-select field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The description of the custom multi-select field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the custom multi-select field. */
    name: Scalars["String"]["input"];
    /** A list of options. */
    options?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Accepts input for creating a custom number field definition. */
export type CompassCreateCustomNumberFieldDefinitionInput = {
    /** The cloud ID of the site to create a custom number field definition for. */
    cloudId: Scalars["ID"]["input"];
    /** The component types the custom number field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom number field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom number field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the custom number field. */
    name: Scalars["String"]["input"];
};

/** Accepts input for creating a custom single select field definition. */
export type CompassCreateCustomSingleSelectFieldDefinitionInput = {
    /** The cloud ID of the site to create a custom single-select field definition for. */
    cloudId: Scalars["ID"]["input"];
    /** The component types the custom single-select field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The description of the custom single-select field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the custom single-select field. */
    name: Scalars["String"]["input"];
    /** A list of options. */
    options?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Accepts input for creating a custom text field definition. */
export type CompassCreateCustomTextFieldDefinitionInput = {
    /** The cloud ID of the site to create a custom text field definition for. */
    cloudId: Scalars["ID"]["input"];
    /** The component types the custom text field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom text field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom text field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the custom text field. */
    name: Scalars["String"]["input"];
};

/** Accepts input for creating a custom user field definition. */
export type CompassCreateCustomUserFieldDefinitionInput = {
    /** The cloud ID of the site to create a custom user field definition for. */
    cloudId: Scalars["ID"]["input"];
    /** The component types the custom user field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom user field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom user field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the custom user field. */
    name: Scalars["String"]["input"];
};

/** A deployment event. */
export type CompassCreateDeploymentEventInput = {
    /** Deployment Properties */
    deploymentProperties: CompassCreateDeploymentEventPropertiesInput;
    /** The description of the deployment event. */
    description: Scalars["String"]["input"];
    /** The name of the deployment event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the deployment event. */
    url: Scalars["URL"]["input"];
};

/** The list of properties of the deployment event. */
export type CompassCreateDeploymentEventPropertiesInput = {
    /** The time this deployment was completed at. */
    completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The environment where the deployment event has occurred. */
    environment: CompassDeploymentEventEnvironmentInput;
    /** The deployment event pipeline. */
    pipeline: CompassDeploymentEventPipelineInput;
    /** The sequence number for the deployment. */
    sequenceNumber: Scalars["Long"]["input"];
    /** The time this deployment was started at. */
    startedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The state of the deployment. */
    state: CompassDeploymentEventState;
};

/** Create Inputs */
export type CompassCreateDynamicScorecardCriteriaInput = {
    expressions: Array<CompassCreateScorecardCriterionExpressionTreeInput>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    weight: Scalars["Int"]["input"];
};

export type CompassCreateEventInput = {
    /** The cloud ID of the site to create the event for. */
    cloudId: Scalars["ID"]["input"];
    componentId?: InputMaybe<Scalars["String"]["input"]>;
    event: CompassEventInput;
};

export type CompassCreateEventsPayload = Payload & {
    __typename?: "CompassCreateEventsPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** A flag event. */
export type CompassCreateFlagEventInput = {
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** Flag Properties */
    flagProperties: CompassCreateFlagEventPropertiesInput;
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

/** The list of properties of the flag event. */
export type CompassCreateFlagEventPropertiesInput = {
    /** The ID of the flag. */
    id: Scalars["ID"]["input"];
    /** The flag's status. The recognized values (case-insensitive) are on, off, created, archived, deleted, and targeting_updated. Any other value, although acceptable, will be displayed as unknown on the activity feed. */
    status?: InputMaybe<Scalars["String"]["input"]>;
};

/** Accepts input to create a scorecard criterion checking the value of a specified custom boolean field. */
export type CompassCreateHasCustomBooleanFieldScorecardCriteriaInput = {
    /** The comparison operation to be performed. */
    booleanComparator: CompassCriteriaBooleanComparatorOptions;
    /** The value that the field is compared to. */
    booleanComparatorValue: Scalars["Boolean"]["input"];
    /** The ID of the component custom boolean field to check the value of. */
    customFieldDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

export type CompassCreateHasCustomMultiSelectFieldScorecardCriteriaInput = {
    /** The comparison operation to be performed between the field and comparator value. */
    collectionComparator: CompassCriteriaCollectionComparatorOptions;
    /** The list of multi select options that the field is compared to. */
    collectionComparatorValue: Array<Scalars["ID"]["input"]>;
    /** The ID of the component custom multi select field to check the value of. */
    customFieldDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts input to create a scorecard criterion checking the value of a specified custom number field. */
export type CompassCreateHasCustomNumberFieldScorecardCriteriaInput = {
    /** The ID of the component custom number field to check the value of. */
    customFieldDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The comparison operation to be performed between the field and comparator value. */
    numberComparator: CompassCriteriaNumberComparatorOptions;
    /** The threshold value that the field is compared to. */
    numberComparatorValue: Scalars["Float"]["input"];
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

export type CompassCreateHasCustomSingleSelectFieldScorecardCriteriaInput = {
    /** The ID of the component custom single select field to check the value of. */
    customFieldDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The comparison operation to be performed between the field and comparator value. */
    membershipComparator: CompassCriteriaMembershipComparatorOptions;
    /** The list of single select options that the field is compared to. */
    membershipComparatorValue: Array<Scalars["ID"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts input to create a scorecard criterion checking the value of a specified custom text field. */
export type CompassCreateHasCustomTextFieldScorecardCriteriaInput = {
    /** The ID of the component custom text field to check the value of. */
    customFieldDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The comparison operation to be performed. */
    textComparator?: InputMaybe<CompassCriteriaTextComparatorOptions>;
    /** The value that the field is compared to. */
    textComparatorValue?: InputMaybe<Scalars["String"]["input"]>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** An incident event. */
export type CompassCreateIncidentEventInput = {
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The list of properties of the incident event. */
    incidentProperties: CompassCreateIncidentEventPropertiesInput;
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

/** The list of properties of the incident event. */
export type CompassCreateIncidentEventPropertiesInput = {
    /** The time when the incident ended */
    endTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The ID of the incident. */
    id: Scalars["ID"]["input"];
    /** The severity of the incident */
    severity?: InputMaybe<CompassIncidentEventSeverityInput>;
    /** The time when the incident started */
    startTime: Scalars["DateTime"]["input"];
    /** The state of the incident. */
    state: CompassIncidentEventState;
};

/** The user-provided input to create an incoming webhook */
export type CompassCreateIncomingWebhookInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
    /** The description of the webhook. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the webhook. */
    name: Scalars["String"]["input"];
    /** The source of the webhook. */
    source: Scalars["String"]["input"];
};

/** The payload returned from sending an incoming webhook to be created */
export type CompassCreateIncomingWebhookPayload = Payload & {
    __typename?: "CompassCreateIncomingWebhookPayload";
    /** A list of errors that occurred during webhook creation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the webhook was created successfully. */
    success: Scalars["Boolean"]["output"];
    /** The created webhook. */
    webhookDetails?: Maybe<CompassIncomingWebhook>;
};

export type CompassCreateIncomingWebhookTokenInput = {
    /** Name of auth token */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** ID of the webhook to associate the token with. */
    webhookId: Scalars["ID"]["input"];
};

export type CompassCreateIncomingWebhookTokenPayload = Payload & {
    __typename?: "CompassCreateIncomingWebhookTokenPayload";
    /** A list of errors that occurred during token creation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the token was created successfully. */
    success: Scalars["Boolean"]["output"];
    /** The token that was created. */
    token?: Maybe<CreateIncomingWebhookToken>;
};

/** A lifecycle event. */
export type CompassCreateLifecycleEventInput = {
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** Lifecycle Properties */
    lifecycleProperties: CompassLifecycleEventInputProperties;
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

/** The input for creating a metric definition. */
export type CompassCreateMetricDefinitionInput = {
    /** The cloud ID of the Compass site to create a metric definition on. */
    cloudId: Scalars["ID"]["input"];
    /** The configuration of the metric definition. */
    configuration?: InputMaybe<CompassMetricDefinitionConfigurationInput>;
    /** The description of the metric definition. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The format option for applying to the display of metric values. */
    format?: InputMaybe<CompassMetricDefinitionFormatInput>;
    /** The name of the metric definition. */
    name: Scalars["String"]["input"];
};

/** The payload returned from creating a metric definition. */
export type CompassCreateMetricDefinitionPayload = Payload & {
    __typename?: "CompassCreateMetricDefinitionPayload";
    /** The created metric definition. */
    createdMetricDefinition?: Maybe<CompassMetricDefinition>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input to create a metric source. */
export type CompassCreateMetricSourceInput = {
    /** The ID of the component to create a metric source on. */
    componentId: Scalars["ID"]["input"];
    /** The configuration of this metric source. */
    configuration?: InputMaybe<CompassMetricSourceConfigurationInput>;
    /** Whether the metric source is derived from Compass events or not. */
    derived?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The external metric source configuration input */
    externalConfiguration?: InputMaybe<CompassExternalMetricSourceConfigurationInput>;
    /** The unique identifier (ID) of the metric source that is external to the Compass site, for example, a Bitbucket repository ID. */
    externalMetricSourceId: Scalars["ID"]["input"];
    /** The ID of the Forge app that sends metric values. */
    forgeAppId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the metric definition which defines the metric source. */
    metricDefinitionId: Scalars["ID"]["input"];
    /** The URL of the metric source. */
    url?: InputMaybe<Scalars["String"]["input"]>;
};

/** The payload returned from creating a metric source. */
export type CompassCreateMetricSourcePayload = Payload & {
    __typename?: "CompassCreateMetricSourcePayload";
    /** The metric source that is created. */
    createdMetricSource?: Maybe<CompassMetricSource>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** A pull request event. */
export type CompassCreatePullRequestEventInput = {
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** The list of properties of the pull request event. */
    pullRequestProperties: CompassPullRequestInputProperties;
};

export enum CompassCreatePullRequestStatus {
    Created = "CREATED",
    InReview = "IN_REVIEW",
    Merged = "MERGED",
    Rejected = "REJECTED"
}

/** A push event. */
export type CompassCreatePushEventInput = {
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** The list of properties of the push event. */
    pushEventProperties: CompassPushEventInputProperties;
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
};

export type CompassCreateScorecardCriteriaScoringStrategyRulesInput = {
    onError?: InputMaybe<CompassScorecardCriteriaScoringStrategyRuleAction>;
    onFalse?: InputMaybe<CompassScorecardCriteriaScoringStrategyRuleAction>;
    onTrue?: InputMaybe<CompassScorecardCriteriaScoringStrategyRuleAction>;
};

export type CompassCreateScorecardCriterionExpressionAndGroupInput = {
    expressions: Array<CompassCreateScorecardCriterionExpressionGroupInput>;
};

export type CompassCreateScorecardCriterionExpressionBooleanInput = {
    booleanComparator: CompassScorecardCriterionExpressionBooleanComparatorOptions;
    booleanComparatorValue: Scalars["Boolean"]["input"];
    requirement: CompassCreateScorecardCriterionExpressionRequirementInput;
};

export type CompassCreateScorecardCriterionExpressionCollectionInput = {
    collectionComparator: CompassScorecardCriterionExpressionCollectionComparatorOptions;
    collectionComparatorValue: Array<Scalars["ID"]["input"]>;
    requirement: CompassCreateScorecardCriterionExpressionRequirementInput;
};

export type CompassCreateScorecardCriterionExpressionEvaluableInput = {
    expression: CompassCreateScorecardCriterionExpressionInput;
};

export type CompassCreateScorecardCriterionExpressionEvaluationRulesInput = {
    onError?: InputMaybe<CompassScorecardCriterionExpressionEvaluationRuleAction>;
    onFalse?: InputMaybe<CompassScorecardCriterionExpressionEvaluationRuleAction>;
    onTrue?: InputMaybe<CompassScorecardCriterionExpressionEvaluationRuleAction>;
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassCreateScorecardCriterionExpressionGroupInput = {
    and?: InputMaybe<CompassCreateScorecardCriterionExpressionAndGroupInput>;
    evaluable?: InputMaybe<CompassCreateScorecardCriterionExpressionEvaluableInput>;
    or?: InputMaybe<CompassCreateScorecardCriterionExpressionOrGroupInput>;
};

export type CompassCreateScorecardCriterionExpressionInput = {
    boolean?: InputMaybe<CompassCreateScorecardCriterionExpressionBooleanInput>;
    collection?: InputMaybe<CompassCreateScorecardCriterionExpressionCollectionInput>;
    membership?: InputMaybe<CompassCreateScorecardCriterionExpressionMembershipInput>;
    number?: InputMaybe<CompassCreateScorecardCriterionExpressionNumberInput>;
    text?: InputMaybe<CompassCreateScorecardCriterionExpressionTextInput>;
};

export type CompassCreateScorecardCriterionExpressionMembershipInput = {
    membershipComparator: CompassScorecardCriterionExpressionMembershipComparatorOptions;
    membershipComparatorValue: Array<Scalars["ID"]["input"]>;
    requirement: CompassCreateScorecardCriterionExpressionRequirementInput;
};

export type CompassCreateScorecardCriterionExpressionNumberInput = {
    numberComparator: CompassScorecardCriterionExpressionNumberComparatorOptions;
    numberComparatorValue: Scalars["Float"]["input"];
    requirement: CompassCreateScorecardCriterionExpressionRequirementInput;
};

export type CompassCreateScorecardCriterionExpressionOrGroupInput = {
    expressions: Array<CompassCreateScorecardCriterionExpressionGroupInput>;
};

export type CompassCreateScorecardCriterionExpressionRequirementCustomFieldInput =
    {
        customFieldDefinitionId: Scalars["ID"]["input"];
    };

export type CompassCreateScorecardCriterionExpressionRequirementDefaultFieldInput =
    {
        fieldName: Scalars["String"]["input"];
    };

export type CompassCreateScorecardCriterionExpressionRequirementInput = {
    customField?: InputMaybe<CompassCreateScorecardCriterionExpressionRequirementCustomFieldInput>;
    defaultField?: InputMaybe<CompassCreateScorecardCriterionExpressionRequirementDefaultFieldInput>;
    metric?: InputMaybe<CompassCreateScorecardCriterionExpressionRequirementMetricInput>;
};

export type CompassCreateScorecardCriterionExpressionRequirementMetricInput = {
    metricDefinitionId: Scalars["ID"]["input"];
};

export type CompassCreateScorecardCriterionExpressionRequirementScorecardInput =
    {
        fieldName: Scalars["String"]["input"];
        scorecardId: Scalars["ID"]["input"];
    };

export type CompassCreateScorecardCriterionExpressionTextInput = {
    requirement: CompassCreateScorecardCriterionExpressionRequirementInput;
    textComparator: CompassScorecardCriterionExpressionTextComparatorOptions;
    textComparatorValue: Scalars["String"]["input"];
};

export type CompassCreateScorecardCriterionExpressionTreeInput = {
    evaluationRules?: InputMaybe<CompassCreateScorecardCriterionExpressionEvaluationRulesInput>;
    root: CompassCreateScorecardCriterionExpressionGroupInput;
};

/** Accepts input for creating team checkin's action item. */
export type CompassCreateTeamCheckinActionInput = {
    /** The text of the team checkin action item. */
    actionText: Scalars["String"]["input"];
    /** Whether the action is completed or not. */
    completed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Accepts input for creating a checkin. */
export type CompassCreateTeamCheckinInput = {
    /** A list of action items to be created with the checkin. */
    actions?: InputMaybe<Array<CompassCreateTeamCheckinActionInput>>;
    /** The cloud ID of the site to update a checkin on. */
    cloudId: Scalars["ID"]["input"];
    /** The mood of the checkin. */
    mood: Scalars["Int"]["input"];
    /** The response to the question 1 of the team checkin. */
    response1?: InputMaybe<Scalars["String"]["input"]>;
    /** The response to the question 1 of the team checkin in a rich text format. */
    response1RichText?: InputMaybe<CompassCreateTeamCheckinResponseRichText>;
    /** The response to the question 2 of the team checkin. */
    response2?: InputMaybe<Scalars["String"]["input"]>;
    /** The response to the question 2 of the team checkin in a rich text format. */
    response2RichText?: InputMaybe<CompassCreateTeamCheckinResponseRichText>;
    /** The response to the question 3 of the team checkin. */
    response3?: InputMaybe<Scalars["String"]["input"]>;
    /** The response to the question 3 of the team checkin in a rich text format. */
    response3RichText?: InputMaybe<CompassCreateTeamCheckinResponseRichText>;
    /** The unique identifier (ID) of the team that did the checkin. */
    teamId: Scalars["ID"]["input"];
};

/** The payload returned after creating a component announcement. */
export type CompassCreateTeamCheckinPayload = Payload & {
    __typename?: "CompassCreateTeamCheckinPayload";
    /** Details of the created team checkin. */
    createdTeamCheckin?: Maybe<CompassTeamCheckin>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating team checkin responses with rich text. */
export type CompassCreateTeamCheckinResponseRichText = {
    /** Input for a team checkin response in Atlassian Document Format. */
    adf?: InputMaybe<Scalars["String"]["input"]>;
};

/** A vulnerability event. */
export type CompassCreateVulnerabilityEventInput = {
    /** The description of the event. */
    description: Scalars["String"]["input"];
    /** The name of the event. */
    displayName: Scalars["String"]["input"];
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["input"];
    /** A number specifying the order of the update to the event. Must be incremented to save new events. Otherwise, the request will be ignored. */
    updateSequenceNumber: Scalars["Long"]["input"];
    /** The URL of the event. */
    url: Scalars["URL"]["input"];
    /** The list of properties of the vulnerability event. */
    vulnerabilityProperties: CompassCreateVulnerabilityEventPropertiesInput;
};

/** The list of properties of the vulnerability event. */
export type CompassCreateVulnerabilityEventPropertiesInput = {
    /** The source or tool that discovered the vulnerability. */
    discoverySource?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the vulnerability. */
    id: Scalars["ID"]["input"];
    /** The time when the vulnerability was remediated. */
    remediationTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The CVSS score of the vulnerability (0-10). */
    score?: InputMaybe<Scalars["Float"]["input"]>;
    /** The severity of the vulnerability */
    severity: CompassVulnerabilityEventSeverityInput;
    /** The state of the vulnerability. */
    state: CompassVulnerabilityEventState;
    /** The time when the vulnerability started. */
    vulnerabilityStartTime: Scalars["DateTime"]["input"];
    /** The target system or component that is vulnerable. */
    vulnerableTarget?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassCreateWebhookInput = {
    /** The template associated with this webhook. */
    componentId: Scalars["ID"]["input"];
    /** The url of the webhook. */
    url: Scalars["String"]["input"];
};

export type CompassCreateWebhookPayload = Payload & {
    __typename?: "CompassCreateWebhookPayload";
    /** A list of errors that occurred during webhook creation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the webhook was created successfully. */
    success: Scalars["Boolean"]["output"];
    /** The created webhook. */
    webhookDetails?: Maybe<CompassWebhook>;
};

export enum CompassCriteriaBooleanComparatorOptions {
    Equals = "EQUALS"
}

export enum CompassCriteriaCollectionComparatorOptions {
    AllOf = "ALL_OF",
    AnyOf = "ANY_OF",
    NoneOf = "NONE_OF"
}

export enum CompassCriteriaMembershipComparatorOptions {
    In = "IN",
    NotIn = "NOT_IN"
}

export enum CompassCriteriaNumberComparatorOptions {
    Equals = "EQUALS",
    GreaterThan = "GREATER_THAN",
    GreaterThanOrEqualTo = "GREATER_THAN_OR_EQUAL_TO",
    LessThan = "LESS_THAN",
    LessThanOrEqualTo = "LESS_THAN_OR_EQUAL_TO"
}

export enum CompassCriteriaTextComparatorOptions {
    IsPresent = "IS_PRESENT",
    MatchesRegex = "MATCHES_REGEX"
}

/** A custom field containing a boolean value. */
export type CompassCustomBooleanField = CompassCustomField & {
    __typename?: "CompassCustomBooleanField";
    /**
     * The annotations attached to a custom field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'annotations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    annotations?: Maybe<Array<CompassCustomFieldAnnotation>>;
    /**
     * The boolean value contained in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The definition of the custom field containing a boolean value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassCustomBooleanFieldDefinition>;
};

/** The definition of a custom field containing a boolean value. */
export type CompassCustomBooleanFieldDefinition = CompassCustomFieldDefinition &
    Node & {
        __typename?: "CompassCustomBooleanFieldDefinition";
        /**
         * The component types the custom boolean field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * The component types the custom boolean field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypes?: Maybe<Array<CompassComponentType>>;
        /**
         * The description of the custom boolean field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The ID of the custom boolean field definition.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The name of the custom boolean field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
    };

export type CompassCustomBooleanFieldFilter = CompassCustomFieldFilter & {
    __typename?: "CompassCustomBooleanFieldFilter";
    /**
     * The external identifier for the field to apply the filter to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
    /**
     * Nullable Boolean value to filter on
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Accepts input for setting a boolean value on a custom field. */
export type CompassCustomBooleanFieldInput = {
    /** The annotations attached to a custom field. */
    annotations?: InputMaybe<Array<CompassCustomFieldAnnotationInput>>;
    /** The boolean value contained in the custom field on a component. */
    booleanValue: Scalars["Boolean"]["input"];
    /** The ID of the custom boolean field definition. */
    definitionId: Scalars["ID"]["input"];
};

export type CompassCustomEvent = CompassEvent & {
    __typename?: "CompassCustomEvent";
    /**
     * Custom Event Properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customEventProperties: CompassCustomEventProperties;
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export enum CompassCustomEventIcon {
    Checkpoint = "CHECKPOINT",
    Info = "INFO",
    Warning = "WARNING"
}

/** Properties specific to Custom events */
export type CompassCustomEventProperties = {
    __typename?: "CompassCustomEventProperties";
    /**
     * The icon for the custom event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    icon?: Maybe<CompassCustomEventIcon>;
    /**
     * The ID of the custom event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
};

/** The list of properties of the custom event. */
export type CompassCustomEventPropertiesInput = {
    /** The icon for the custom event. */
    icon: CompassCustomEventIcon;
    /** The ID of the custom event. */
    id: Scalars["ID"]["input"];
};

/** A custom field contains data about the component. */
export type CompassCustomField = {
    /** The definition of the custom field. */
    definition?: Maybe<CompassCustomFieldDefinition>;
};

/** Annotation for a custom field value */
export type CompassCustomFieldAnnotation = {
    __typename?: "CompassCustomFieldAnnotation";
    /**
     * Description of the annotation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description: Scalars["String"]["output"];
    /**
     * The text to display for a given linkURI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    linkText: Scalars["String"]["output"];
    /**
     * Link to display alongside an annotations description.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    linkUri: Scalars["URL"]["output"];
};

/** Annotatation input for a custom field value */
export type CompassCustomFieldAnnotationInput = {
    /** Description of the annotation. */
    description: Scalars["String"]["input"];
    /** The text to display for a given linkURI. */
    linkText: Scalars["String"]["input"];
    /** Link to display alongside an annotations description. */
    linkUri: Scalars["URL"]["input"];
};

/** Defines a custom field that may be applied to multiple component types. A custom field must be applied to at least one component type. */
export type CompassCustomFieldDefinition = {
    /** The component types the custom field applies to. */
    componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** The component types the custom field applies to. */
    componentTypes?: Maybe<Array<CompassComponentType>>;
    /** The description of the custom field. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the custom field definition. */
    id: Scalars["ID"]["output"];
    /** The name of the custom field. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** An edge that contains a custom field definition and a cursor. */
export type CompassCustomFieldDefinitionEdge = {
    __typename?: "CompassCustomFieldDefinitionEdge";
    /** The cursor of the custom field definition. */
    cursor: Scalars["String"]["output"];
    /** The custom field definition. */
    node?: Maybe<CompassCustomFieldDefinition>;
};

/** The query for retrieving a custom field definition by id on a Compass site. */
export type CompassCustomFieldDefinitionQuery = {
    /** The cloud ID of the site to retrieve custom field definitions from. */
    cloudId: Scalars["ID"]["input"];
    /** The ID of the custom field definition to retrieve. */
    id: Scalars["ID"]["input"];
};

export type CompassCustomFieldDefinitionResult =
    | CompassCustomBooleanFieldDefinition
    | CompassCustomMultiSelectFieldDefinition
    | CompassCustomNumberFieldDefinition
    | CompassCustomSingleSelectFieldDefinition
    | CompassCustomTextFieldDefinition
    | CompassCustomUserFieldDefinition
    | QueryError;

/** A connection that returns a paginated collection of custom field definitions. */
export type CompassCustomFieldDefinitionsConnection = {
    __typename?: "CompassCustomFieldDefinitionsConnection";
    /** A list of edges which contain a custom field definition and a cursor. */
    edges?: Maybe<Array<CompassCustomFieldDefinitionEdge>>;
    /** A list of custom field definitions. */
    nodes?: Maybe<Array<CompassCustomFieldDefinition>>;
    /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
    pageInfo: PageInfo;
};

/** The query for retrieving custom field definitions on a Compass site. */
export type CompassCustomFieldDefinitionsQuery = {
    /** The cloud ID of the site to retrieve custom field definitions from. */
    cloudId: Scalars["ID"]["input"];
    /**
     * Optional filter to search for custom field definitions applied to any of the specific component types.
     * Returns all custom field definitions by default.
     */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * Optional filter to search for custom field definitions applied to any of the specified component types.
     * Returns all custom field definitions by default.
     */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
};

export type CompassCustomFieldDefinitionsResult =
    | CompassCustomFieldDefinitionsConnection
    | QueryError;

export type CompassCustomFieldFilter = {
    /**
     * The external identifier for the field to apply the filter to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
};

export type CompassCustomFieldFilterInput = {
    /** Input type for boolean custom field filter */
    boolean?: InputMaybe<CompassComponentCustomBooleanFieldFilterInput>;
    /** Input type for multiselect custom field filter */
    multiselect?: InputMaybe<CompassCustomMultiselectFieldFilterInput>;
    /** Input type for number custom field filter */
    number?: InputMaybe<CompassCustomNumberFieldFilterInput>;
    /** Input type for single select custom field filter */
    singleSelect?: InputMaybe<CompassCustomSingleSelectFieldFilterInput>;
    /** Input type for text custom field filter */
    text?: InputMaybe<CompassCustomTextFieldFilterInput>;
    /** Input type for user custom field filter */
    user?: InputMaybe<CompassCustomUserFieldFilterInput>;
};

/** Accepts input for setting a custom field value. You must provide exactly one of the fields in this input type. */
export type CompassCustomFieldInput = {
    /** Input for setting a value on a custom field containing a boolean value. */
    booleanField?: InputMaybe<CompassCustomBooleanFieldInput>;
    /** Input for setting a value on a custom field containing multiple options */
    multiSelectField?: InputMaybe<CompassCustomMultiSelectFieldInput>;
    /** Input for setting a value on a custom field containing a number. */
    numberField?: InputMaybe<CompassCustomNumberFieldInput>;
    /** Input for setting a value on a custom field containing a single option */
    singleSelectField?: InputMaybe<CompassCustomSingleSelectFieldInput>;
    /** Input for setting a value on a custom field containing a text string. */
    textField?: InputMaybe<CompassCustomTextFieldInput>;
    /** Input for setting a value on a custom field containing a user. */
    userField?: InputMaybe<CompassCustomUserFieldInput>;
};

export type CompassCustomFieldScorecardCriteria = {
    /**
     * The optional, user provided description of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the scorecard criterion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The optional, user provided name of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns the calculated score for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
    /**
     * The weight that will be used in determining the aggregate score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    weight: Scalars["Int"]["output"];
};

export type CompassCustomFieldScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** A custom multi-select field. */
export type CompassCustomMultiSelectField = CompassCustomField & {
    __typename?: "CompassCustomMultiSelectField";
    /**
     * The annotations attached to a custom field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'annotations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    annotations?: Maybe<Array<CompassCustomFieldAnnotation>>;
    /**
     * The definition of the custom multi-select field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassCustomMultiSelectFieldDefinition>;
    /**
     * The options selected in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'options' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    options?: Maybe<Array<CompassCustomSelectFieldOption>>;
};

/** The definition of a custom multi-select field. */
export type CompassCustomMultiSelectFieldDefinition =
    CompassCustomFieldDefinition &
        Node & {
            __typename?: "CompassCustomMultiSelectFieldDefinition";
            /**
             * The IDs of component types the custom multi-select field applies to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
            /**
             * The component types the custom multi-select field applies to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            componentTypes?: Maybe<Array<CompassComponentType>>;
            /**
             * The description of the custom multi-select field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the custom multi-select field definition.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The name of the custom multi-select field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * A list of options for the custom multi-select field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            options?: Maybe<Array<CompassCustomSelectFieldOption>>;
        };

/** Accepts input for setting options for a multi-select field. */
export type CompassCustomMultiSelectFieldInput = {
    /** The annotations attached to a custom field. */
    annotations?: InputMaybe<Array<CompassCustomFieldAnnotationInput>>;
    /** The ID of the custom boolean field definition. */
    definitionId: Scalars["ID"]["input"];
    /** The option IDs for the custom field on a component. */
    options?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type CompassCustomMultiselectFieldFilter = CompassCustomFieldFilter & {
    __typename?: "CompassCustomMultiselectFieldFilter";
    /**
     * Logical operator to use with this filter, current possible values are CONTAIN_ALL, CONTAIN_ANY, CONTAIN_NONE, IS_SET or NOT_SET
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    comparator: Scalars["String"]["output"];
    /**
     * The external identifier for the field to apply the filter to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    values: Array<Scalars["String"]["output"]>;
};

export type CompassCustomMultiselectFieldFilterInput = {
    /** Comparator to use with this filter */
    comparator?: InputMaybe<CustomMultiselectFieldInputComparators>;
    /** The custom field definition ID to apply the filter to */
    customFieldId: Scalars["String"]["input"];
    /** Values to use for filtering */
    values: Array<Scalars["String"]["input"]>;
};

/** A custom field containing a number. */
export type CompassCustomNumberField = CompassCustomField & {
    __typename?: "CompassCustomNumberField";
    /**
     * The annotations attached to a custom field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'annotations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    annotations?: Maybe<Array<CompassCustomFieldAnnotation>>;
    /**
     * The definition of the custom field containing a number.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassCustomNumberFieldDefinition>;
    /**
     * The number contained in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    numberValue?: Maybe<Scalars["Float"]["output"]>;
};

/** The definition of a custom field containing a number. */
export type CompassCustomNumberFieldDefinition = CompassCustomFieldDefinition &
    Node & {
        __typename?: "CompassCustomNumberFieldDefinition";
        /**
         * The component types the custom number field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * The component types the custom number field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypes?: Maybe<Array<CompassComponentType>>;
        /**
         * The description of the custom number field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The ID of the custom number field definition.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The name of the custom number field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
    };

export type CompassCustomNumberFieldFilter = CompassCustomFieldFilter & {
    __typename?: "CompassCustomNumberFieldFilter";
    /**
     * The custom field value comparator: IS_SET or NOT_SET
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    comparator: Scalars["String"]["output"];
    /**
     * The custom field definition ID to apply the filter to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
};

export type CompassCustomNumberFieldFilterInput = {
    /** The custom field value comparator */
    comparator?: InputMaybe<CustomNumberFieldInputComparators>;
    /** The custom field definition ID to apply the filter to */
    customFieldId: Scalars["String"]["input"];
};

/** Accepts input for setting a number on a custom field. */
export type CompassCustomNumberFieldInput = {
    /** The annotations attached to a custom field. */
    annotations?: InputMaybe<Array<CompassCustomFieldAnnotationInput>>;
    /** The ID of the custom number field definition. */
    definitionId: Scalars["ID"]["input"];
    /** The number contained in the custom field on a component. */
    numberValue?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CompassCustomPermissionConfig = {
    __typename?: "CompassCustomPermissionConfig";
    /** A list of Compass role ARIs which are permitted. */
    allowedRoles: Array<Scalars["ID"]["output"]>;
    /** A list of team ARIs which are permitted. */
    allowedTeams: Array<Scalars["ID"]["output"]>;
    /** The permission identifier, e.g. MODIFY_SCORECARD. */
    id: Scalars["ID"]["output"];
    /** Whether the owner team is permitted. */
    ownerTeamAllowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CompassCustomPermissionConfigs = {
    __typename?: "CompassCustomPermissionConfigs";
    createCustomFieldDefinitions?: Maybe<CompassCustomPermissionConfig>;
    createScorecards?: Maybe<CompassCustomPermissionConfig>;
    deleteCustomFieldDefinitions?: Maybe<CompassCustomPermissionConfig>;
    editCustomFieldDefinitions?: Maybe<CompassCustomPermissionConfig>;
    modifyScorecard?: Maybe<CompassCustomPermissionConfig>;
    preset?: Maybe<Scalars["String"]["output"]>;
};

export type CompassCustomPermissionConfigsResult =
    | CompassCustomPermissionConfigs
    | QueryError;

/** Preset options to update custom permission configs, either open to all teams/roles or restricted to product admins and owners. */
export enum CompassCustomPermissionPreset {
    /** Restrictive option which only permits product admins and owners to create/edit/delete, which vary depending on entity, i.e. component */
    AdminsAndOwners = "ADMINS_AND_OWNERS",
    /** Default option which permits the owner team, as well as all teams and roles. */
    Default = "DEFAULT"
}

/** The option of a single-select or multi-select custom field. */
export type CompassCustomSelectFieldOption = Node & {
    __typename?: "CompassCustomSelectFieldOption";
    /** The ID of the option for custom field. */
    id: Scalars["ID"]["output"];
    /** The value of the option for custom field. */
    value: Scalars["String"]["output"];
};

/** A custom single-select field. */
export type CompassCustomSingleSelectField = CompassCustomField & {
    __typename?: "CompassCustomSingleSelectField";
    /**
     * The annotations attached to a custom field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'annotations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    annotations?: Maybe<Array<CompassCustomFieldAnnotation>>;
    /**
     * The definition of the custom single-select field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassCustomSingleSelectFieldDefinition>;
    /**
     * The option selected in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'option' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    option?: Maybe<CompassCustomSelectFieldOption>;
};

/** The definition of a custom single-select field. */
export type CompassCustomSingleSelectFieldDefinition =
    CompassCustomFieldDefinition &
        Node & {
            __typename?: "CompassCustomSingleSelectFieldDefinition";
            /**
             * The IDs of component types the custom single-select field applies to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
            /**
             * The component types the custom single-select field applies to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            componentTypes?: Maybe<Array<CompassComponentType>>;
            /**
             * The description of the custom single-select field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the custom single-select field definition.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The name of the custom single-select field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * A list of options for the custom single-select field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            options?: Maybe<Array<CompassCustomSelectFieldOption>>;
        };

export type CompassCustomSingleSelectFieldFilter = CompassCustomFieldFilter & {
    __typename?: "CompassCustomSingleSelectFieldFilter";
    /**
     * The custom field value comparator, current possible values are CONTAIN_ANY, CONTAIN_NONE, IS_SET or NOT_SET
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    comparator: Scalars["String"]["output"];
    /**
     * The custom field definition ID for the field to apply the filter to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
    /**
     * List of option IDs to filter on
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    values: Array<Scalars["String"]["output"]>;
};

export type CompassCustomSingleSelectFieldFilterInput = {
    /** Comparator to use with this filter */
    comparator?: InputMaybe<CustomSingleSelectFieldInputComparators>;
    /** The custom field definition ID for the field to apply the filter to. */
    customFieldId: Scalars["String"]["input"];
    /** List of option IDs to use for filtering. Empty array for NOT_SET and IS_SET */
    values: Array<Scalars["ID"]["input"]>;
};

/** Accepts input for setting an option for single-select field. */
export type CompassCustomSingleSelectFieldInput = {
    /** The annotations attached to a custom field. */
    annotations?: InputMaybe<Array<CompassCustomFieldAnnotationInput>>;
    /** The ID of the custom boolean field definition. */
    definitionId: Scalars["ID"]["input"];
    /** The option ID for the custom field on a component. */
    option?: InputMaybe<Scalars["ID"]["input"]>;
};

/** A custom field containing a text string. */
export type CompassCustomTextField = CompassCustomField & {
    __typename?: "CompassCustomTextField";
    /**
     * The annotations attached to a custom field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'annotations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    annotations?: Maybe<Array<CompassCustomFieldAnnotation>>;
    /**
     * The definition of the custom field containing a text string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassCustomTextFieldDefinition>;
    /**
     * The text string contained in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    textValue?: Maybe<Scalars["String"]["output"]>;
};

/** The definition of a custom field containing a text string. */
export type CompassCustomTextFieldDefinition = CompassCustomFieldDefinition &
    Node & {
        __typename?: "CompassCustomTextFieldDefinition";
        /**
         * The component types the custom text field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * The component types the custom text field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypes?: Maybe<Array<CompassComponentType>>;
        /**
         * The description of the custom text field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The ID of the custom text field definition.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The name of the custom text field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
    };

export type CompassCustomTextFieldFilter = CompassCustomFieldFilter & {
    __typename?: "CompassCustomTextFieldFilter";
    /**
     * The custom field value comparator: IS_SET, NOT_SET
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    comparator: Scalars["String"]["output"];
    /**
     * The custom field definition ID to apply the filter to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
};

export type CompassCustomTextFieldFilterInput = {
    /** The custom field value comparator */
    comparator?: InputMaybe<CustomTextFieldInputComparators>;
    /** The custom field definition ID to apply the filter to */
    customFieldId: Scalars["String"]["input"];
};

/** Accepts input for setting a text string on a custom field. */
export type CompassCustomTextFieldInput = {
    /** The annotations attached to a custom field. */
    annotations?: InputMaybe<Array<CompassCustomFieldAnnotationInput>>;
    /** The ID of the custom text field definition. */
    definitionId: Scalars["ID"]["input"];
    /** The text string contained in the custom field on a component. */
    textValue?: InputMaybe<Scalars["String"]["input"]>;
};

/** A custom field containing a user. */
export type CompassCustomUserField = CompassCustomField & {
    __typename?: "CompassCustomUserField";
    /**
     * The annotations attached to a custom field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'annotations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    annotations?: Maybe<Array<CompassCustomFieldAnnotation>>;
    /**
     * The definition of the custom field containing a user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassCustomUserFieldDefinition>;
    /**
     * The ID of the user contained in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userIdValue?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The user contained in the custom field on a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userValue?: Maybe<User>;
};

/** The definition of a custom field containing a user. */
export type CompassCustomUserFieldDefinition = CompassCustomFieldDefinition &
    Node & {
        __typename?: "CompassCustomUserFieldDefinition";
        /**
         * The component types the custom user field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * The component types the custom user field applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypes?: Maybe<Array<CompassComponentType>>;
        /**
         * The description of the custom user field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The ID of the custom user field definition.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The name of the custom user field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
    };

export type CompassCustomUserFieldFilter = CompassCustomFieldFilter & {
    __typename?: "CompassCustomUserFieldFilter";
    /**
     * The custom field value comparator: IS_SET, NOT_SET or CONTAIN_ANY
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    comparator: Scalars["String"]["output"];
    /**
     * The custom field definition ID to apply the filter to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldId: Scalars["String"]["output"];
    /**
     * User IDs to filter on
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    values: Array<Scalars["String"]["output"]>;
};

export type CompassCustomUserFieldFilterInput = {
    /** The custom field value comparator */
    comparator?: InputMaybe<CustomUserFieldInputComparators>;
    /** The custom field definition ID to apply the filter to */
    customFieldId: Scalars["String"]["input"];
    /** User IDs to filter on or empty array for IS_SET or NOT_SET */
    values: Array<Scalars["ID"]["input"]>;
};

/** Accepts input for setting a user on a custom field. */
export type CompassCustomUserFieldInput = {
    /** The annotations attached to a custom field. */
    annotations?: InputMaybe<Array<CompassCustomFieldAnnotationInput>>;
    /** The ID of the custom user field definition. */
    definitionId: Scalars["ID"]["input"];
    /** The user contained in the custom field on a component. */
    userIdValue?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The payload returned from deactivating a scorecard for a component. */
export type CompassDeactivateScorecardForComponentPayload = Payload & {
    __typename?: "CompassDeactivateScorecardForComponentPayload";
    /** The details of the component. */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CompassDeactivatedScorecard = {
    __typename?: "CompassDeactivatedScorecard";
    /** The active Compass Scorecard Jira issues linked to this component scorecard relationship. */
    activeIssues?: Maybe<CompassComponentScorecardJiraIssuesQueryResult>;
    /** Contains the application rules for how this scorecard will apply to components. */
    applicationModel: CompassScorecardApplicationModel;
    /** The description of the scorecard. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier (ID) of the scorecard. */
    id: Scalars["ID"]["output"];
    /** The name of the scorecard. */
    name: Scalars["String"]["output"];
    /** The unique identifier (ID) of the scorecard's owner. */
    ownerId?: Maybe<Scalars["ID"]["output"]>;
    /** The state of the scorecard. */
    state?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the scorecard is user-generated or pre-installed. */
    type: Scalars["String"]["output"];
};

export type CompassDeactivatedScorecardActiveIssuesArgs = {
    query?: InputMaybe<CompassComponentScorecardJiraIssuesQuery>;
};

export type CompassDeactivatedScorecardsConnection = {
    __typename?: "CompassDeactivatedScorecardsConnection";
    edges?: Maybe<Array<CompassComponentDeactivatedScorecardsEdge>>;
    nodes?: Maybe<Array<CompassDeactivatedScorecard>>;
    pageInfo: PageInfo;
};

/** Accepts input for deleting a component announcement. */
export type CompassDeleteAnnouncementInput = {
    /** The cloud ID of the site to delete an announcement from. */
    cloudId: Scalars["ID"]["input"];
    /** The ID of the announcement to delete. */
    id: Scalars["ID"]["input"];
};

/** The payload returned after deleting a component announcement. */
export type CompassDeleteAnnouncementPayload = Payload & {
    __typename?: "CompassDeleteAnnouncementPayload";
    /** The ID of the announcement that was deleted. */
    deletedAnnouncementId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CompassDeleteCampaignPayload = Payload & {
    __typename?: "CompassDeleteCampaignPayload";
    campaignId: Scalars["ID"]["output"];
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for delete a subscription. */
export type CompassDeleteComponentSubscriptionInput = {
    /** The ID of the component to unsubscribe. */
    componentId: Scalars["ID"]["input"];
};

/** Payload returned from stop watching a component. */
export type CompassDeleteComponentSubscriptionPayload = Payload & {
    __typename?: "CompassDeleteComponentSubscriptionPayload";
    /** A list of errors that occurred during unsubscribing. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether user unsubscribed from the component successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for deleting a custom field definition, along with all values associated with the definition. */
export type CompassDeleteCustomFieldDefinitionInput = {
    /** The ID of the custom field definition to be deleted. */
    id: Scalars["ID"]["input"];
};

/** The payload returned from deleting a custom field definition. */
export type CompassDeleteCustomFieldDefinitionPayload = Payload & {
    __typename?: "CompassDeleteCustomFieldDefinitionPayload";
    /** The ID of the deleted custom field definition. */
    customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CompassDeleteDocumentInput = {
    /** The ARI of the document to delete */
    id: Scalars["ID"]["input"];
};

export type CompassDeleteDocumentPayload = Payload & {
    __typename?: "CompassDeleteDocumentPayload";
    /** The ID of the document that was deleted. */
    deletedDocumentId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CompassDeleteExternalAliasInput = {
    /** The ID of the component in the external source */
    externalId: Scalars["ID"]["input"];
    /** The external system hosting the component */
    externalSource: Scalars["ID"]["input"];
};

/** The user-provided input to delete an incoming webhook */
export type CompassDeleteIncomingWebhookInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
    /** The ARI of the webhook to delete */
    id: Scalars["ID"]["input"];
};

/** The payload returned from deleting an incoming webhook */
export type CompassDeleteIncomingWebhookPayload = Payload & {
    __typename?: "CompassDeleteIncomingWebhookPayload";
    /** The ID of the webhook that was deleted. */
    deletedIncomingWebhookId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input to delete a metric definition. */
export type CompassDeleteMetricDefinitionInput = {
    /** The ID of the metric definition to be deleted. */
    id: Scalars["ID"]["input"];
};

/** The payload returned from updating a metric definition. */
export type CompassDeleteMetricDefinitionPayload = Payload & {
    __typename?: "CompassDeleteMetricDefinitionPayload";
    /** The ID of the deleted metric definition. */
    deletedMetricDefinitionId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input to delete a metric source. */
export type CompassDeleteMetricSourceInput = {
    /** The ID of the metric source to be deleted. */
    id: Scalars["ID"]["input"];
};

/** The payload returned from deleting a metric source. */
export type CompassDeleteMetricSourcePayload = Payload & {
    __typename?: "CompassDeleteMetricSourcePayload";
    /** The ID of the metric source that is deleted. */
    deletedMetricSourceId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for deleting a team checkin. */
export type CompassDeleteTeamCheckinActionInput = {
    /** The ID of the team checkin item to delete. */
    id: Scalars["ID"]["input"];
};

/** Accepts input for deleting a team checkin. */
export type CompassDeleteTeamCheckinInput = {
    /** The cloud ID of the site to update a checkin on. */
    cloudId: Scalars["ID"]["input"];
    /** The ID of the team checkin to delete. */
    id: Scalars["ID"]["input"];
};

/** The payload returned after deleting a team checkin. */
export type CompassDeleteTeamCheckinPayload = Payload & {
    __typename?: "CompassDeleteTeamCheckinPayload";
    /** ID of the checkin that was deleted. */
    deletedTeamCheckinId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CompassDeploymentEvent = CompassEvent & {
    __typename?: "CompassDeploymentEvent";
    /**
     * Deployment Properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deploymentProperties: CompassDeploymentEventProperties;
    /**
     * The sequence number for the deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Please use the properties in deploymentEventProperties instead
     */
    deploymentSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The description of the deployment event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the deployment event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The environment where the deployment event has occurred.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Please use the properties in deploymentEventProperties instead
     */
    environment?: Maybe<CompassDeploymentEventEnvironment>;
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * The deployment event pipeline.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Please use the properties in deploymentEventProperties instead
     */
    pipeline?: Maybe<CompassDeploymentEventPipeline>;
    /**
     * The state of the deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Please use the properties in deploymentEventProperties instead
     */
    state?: Maybe<CompassDeploymentEventState>;
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the deployment event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type CompassDeploymentEventEnvironment = {
    __typename?: "CompassDeploymentEventEnvironment";
    /**
     * The type of environment where the deployment event occurred.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    category?: Maybe<CompassDeploymentEventEnvironmentCategory>;
    /**
     * The display name of the environment where the deployment event occurred.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the environment where the deployment event occurred.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    environmentId?: Maybe<Scalars["String"]["output"]>;
};

export enum CompassDeploymentEventEnvironmentCategory {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

/** The environment where the deployment event has occurred. */
export type CompassDeploymentEventEnvironmentInput = {
    /** The type of environment where the deployment event occurred. */
    category: CompassDeploymentEventEnvironmentCategory;
    /** The display name of the environment where the deployment event occurred. */
    displayName: Scalars["String"]["input"];
    /** The ID of the environment where the deployment event occurred. */
    environmentId: Scalars["String"]["input"];
};

/** Filters for deployment events. */
export type CompassDeploymentEventFilters = {
    /** A list of environments to filter deployment events by. */
    environments?: InputMaybe<Array<CompassDeploymentEventEnvironmentCategory>>;
};

export type CompassDeploymentEventPipeline = {
    __typename?: "CompassDeploymentEventPipeline";
    /**
     * The name of the deployment event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the deployment event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pipelineId?: Maybe<Scalars["String"]["output"]>;
    /**
     * The URL of the deployment event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** The deployment event pipeline. */
export type CompassDeploymentEventPipelineInput = {
    /** The name of the deployment event pipeline. */
    displayName: Scalars["String"]["input"];
    /** The ID of the deployment event pipeline. */
    pipelineId: Scalars["String"]["input"];
    /** The URL of the deployment event pipeline. */
    url: Scalars["String"]["input"];
};

export type CompassDeploymentEventProperties = {
    __typename?: "CompassDeploymentEventProperties";
    /**
     * The time this deployment was completed at.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The environment where the deployment event has occurred.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    environment?: Maybe<CompassDeploymentEventEnvironment>;
    /**
     * The deployment event pipeline.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pipeline?: Maybe<CompassDeploymentEventPipeline>;
    /**
     * The sequence number for the deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    sequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The time this deployment was started at.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    startedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The state of the deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    state?: Maybe<CompassDeploymentEventState>;
};

/** Compass Deployment Event */
export enum CompassDeploymentEventState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type CompassDocument = Node & {
    __typename?: "CompassDocument";
    /** Contains change metadata for the document. */
    changeMetadata: CompassChangeMetadata;
    /** The ID of the component the document was added to. */
    componentId: Scalars["ID"]["output"];
    /** The ID of the documentation category the document was added to. */
    documentationCategoryId: Scalars["ID"]["output"];
    /** The ARI of the document. */
    id: Scalars["ID"]["output"];
    /** The (optional) display title of the document. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** The url of the document. */
    url: Scalars["URL"]["output"];
};

export type CompassDocumentConnection = {
    __typename?: "CompassDocumentConnection";
    edges?: Maybe<Array<CompassDocumentEdge>>;
    nodes?: Maybe<Array<CompassDocument>>;
    pageInfo?: Maybe<PageInfo>;
};

export type CompassDocumentEdge = {
    __typename?: "CompassDocumentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassDocument>;
};

export type CompassDocumentationCategoriesConnection = {
    __typename?: "CompassDocumentationCategoriesConnection";
    edges?: Maybe<Array<CompassDocumentationCategoryEdge>>;
    nodes?: Maybe<Array<CompassDocumentationCategory>>;
    pageInfo?: Maybe<PageInfo>;
};

/** Stores the categories that various pieces of documentation will be grouped under */
export type CompassDocumentationCategory = Node & {
    __typename?: "CompassDocumentationCategory";
    /** The (optional) description of the documentation category. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the documentation category. */
    id: Scalars["ID"]["output"];
    /** The name of the documentation category. */
    name: Scalars["String"]["output"];
};

export type CompassDocumentationCategoryEdge = {
    __typename?: "CompassDocumentationCategoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassDocumentationCategory>;
};

/** The configuration for a scorecard criterion which uses criterion expressions. */
export type CompassDynamicScorecardCriteria = CompassScorecardCriteria & {
    __typename?: "CompassDynamicScorecardCriteria";
    /**
     * The optional, user provided description of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * Expressions evaluated in order, PASS/SKIP will end execution, FAIL will continue onto the next expression, analogous to if/else if/else
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    expressions?: Maybe<Array<CompassScorecardCriterionExpressionTree>>;
    /**
     * The ID of the scorecard criterion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The optional, user provided name of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns the calculated score for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
    /**
     * The weight that will be used in determining the aggregate score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    weight: Scalars["Int"]["output"];
};

/** The configuration for a scorecard criterion which uses criterion expressions. */
export type CompassDynamicScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/**
 * ###################################################################################################################
 *  COMPASS ENTITY PROPERTIES
 * ###################################################################################################################
 */
export type CompassEntityProperty = {
    __typename?: "CompassEntityProperty";
    changeMetadata?: Maybe<CompassChangeMetadata>;
    key: Scalars["String"]["output"];
    scope: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type CompassEntityPropertyResult = CompassEntityProperty | QueryError;

export type CompassEnumField = CompassField & {
    __typename?: "CompassEnumField";
    /**
     * The definition of the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    definition?: Maybe<CompassFieldDefinition>;
    /**
     * The value of the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type CompassEnumFieldDefinitionOptions = {
    __typename?: "CompassEnumFieldDefinitionOptions";
    /** The default option for field definition. If null, the field is not required. */
    default?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Possible values of the field definition. */
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type CompassEnumFieldValueInput = {
    value?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CompassEvent = {
    /** The description of the event. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The name of the event. */
    displayName: Scalars["String"]["output"];
    /** The type of the event. */
    eventType: CompassEventType;
    /** The last time this event was updated. */
    lastUpdated: Scalars["DateTime"]["output"];
    /** A number specifying the order of the update to the event. */
    updateSequenceNumber: Scalars["Long"]["output"];
    /** The URL of the event. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type CompassEventConnection = {
    __typename?: "CompassEventConnection";
    edges?: Maybe<Array<Maybe<CompassEventEdge>>>;
    nodes?: Maybe<Array<CompassEvent>>;
    pageInfo: PageInfo;
};

export type CompassEventEdge = {
    __typename?: "CompassEventEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassEvent>;
};

/** Filters for events sent to Compass. */
export type CompassEventFilters = {
    /** Filters for deployment events. */
    deployments?: InputMaybe<CompassDeploymentEventFilters>;
};

/** The type of event. One and only one of the fields in this input type must be provided. */
export type CompassEventInput = {
    alert?: InputMaybe<CompassCreateAlertEventInput>;
    build?: InputMaybe<CompassCreateBuildEventInput>;
    custom?: InputMaybe<CompassCreateCustomEventInput>;
    deployment?: InputMaybe<CompassCreateDeploymentEventInput>;
    flag?: InputMaybe<CompassCreateFlagEventInput>;
    incident?: InputMaybe<CompassCreateIncidentEventInput>;
    lifecycle?: InputMaybe<CompassCreateLifecycleEventInput>;
    pullRequest?: InputMaybe<CompassCreatePullRequestEventInput>;
    push?: InputMaybe<CompassCreatePushEventInput>;
    vulnerability?: InputMaybe<CompassCreateVulnerabilityEventInput>;
};

export type CompassEventSourceResult = EventSource | QueryError;

export type CompassEventTimeParameters = {
    /** The time to end querying for event data. */
    endAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The time to begin querying for event data. */
    startFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export enum CompassEventType {
    Alert = "ALERT",
    Build = "BUILD",
    Custom = "CUSTOM",
    Deployment = "DEPLOYMENT",
    Flag = "FLAG",
    Incident = "INCIDENT",
    Lifecycle = "LIFECYCLE",
    PullRequest = "PULL_REQUEST",
    Push = "PUSH",
    Vulnerability = "VULNERABILITY"
}

export type CompassEventsInEventSourceQuery = {
    /** Returns the events after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Filter events based on CompassEventFilters. */
    eventFilters?: InputMaybe<CompassEventFilters>;
    /** The first N number of events to return in the query. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Returns the events after that match the CompassEventTimeParameters. */
    timeParameters?: InputMaybe<CompassEventTimeParameters>;
};

export type CompassEventsQuery = {
    /** Returns the events after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Filter events based on CompassEventFilters */
    eventFilters?: InputMaybe<CompassEventFilters>;
    /** The list of event types. */
    eventTypes?: InputMaybe<Array<CompassEventType>>;
    /** The first N number of events to return in the query. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Returns the events after that match the CompassEventTimeParameters. */
    timeParameters?: InputMaybe<CompassEventTimeParameters>;
};

export type CompassEventsQueryResult = CompassEventConnection | QueryError;

/** An alias of the component in an external system. */
export type CompassExternalAlias = {
    __typename?: "CompassExternalAlias";
    /** The ID of the component in an external system. */
    externalAliasId: Scalars["ID"]["output"];
    /** The external system hosting the component. */
    externalSource: Scalars["ID"]["output"];
    /** The url of the component in an external system. */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type CompassExternalAliasInput = {
    /** The ID of the component in the external source */
    externalId: Scalars["ID"]["input"];
    /** The external system hosting the component */
    externalSource: Scalars["ID"]["input"];
    /** The url of the component in an external system. */
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassExternalMetricSourceConfigurationInput = {
    /** Plain external metric source configuration input */
    plain?: InputMaybe<CompassPlainMetricSourceConfigurationInput>;
    /** SLO external metric source configuration input */
    slo?: InputMaybe<CompassSloMetricSourceConfigurationInput>;
};

/** A field represents data about a component. */
export type CompassField = {
    /** The definition of the field. */
    definition?: Maybe<CompassFieldDefinition>;
};

/** The schema of a field. */
export type CompassFieldDefinition = {
    __typename?: "CompassFieldDefinition";
    /** The description of the field. */
    description: Scalars["String"]["output"];
    /** The unique identifier (ID) of the field definition. */
    id: Scalars["ID"]["output"];
    /** The name of the field. */
    name: Scalars["String"]["output"];
    /** The options for the field definition. */
    options: CompassFieldDefinitionOptions;
    /** The type of field. */
    type: CompassFieldType;
};

export type CompassFieldDefinitionOptions =
    | CompassBooleanFieldDefinitionOptions
    | CompassEnumFieldDefinitionOptions;

export type CompassFieldDefinitions = {
    __typename?: "CompassFieldDefinitions";
    definitions: Array<CompassFieldDefinition>;
};

export type CompassFieldDefinitionsResult =
    | CompassFieldDefinitions
    | QueryError;

/** Specifies the type of value for a field. */
export enum CompassFieldType {
    Boolean = "BOOLEAN",
    Date = "DATE",
    Enum = "ENUM",
    Number = "NUMBER",
    Text = "TEXT"
}

export type CompassFieldValueInput = {
    boolean?: InputMaybe<CompassBooleanFieldValueInput>;
    enum?: InputMaybe<CompassEnumFieldValueInput>;
};

export type CompassFilteredComponentsCount = {
    __typename?: "CompassFilteredComponentsCount";
    /** The count of components */
    count: Scalars["Int"]["output"];
};

/** Accepts input to find filtered components count */
export type CompassFilteredComponentsCountQuery = {
    componentCreationTimeFilter?: InputMaybe<CompassComponentCreationTimeFilterInput>;
    componentCustomFieldFilters?: InputMaybe<
        Array<CompassCustomFieldFilterInput>
    >;
    fields?: InputMaybe<Array<CompassScorecardAppliedToComponentsFieldFilter>>;
    labels?: InputMaybe<CompassScorecardAppliedToComponentsLabelsFilter>;
    lifecycleFilter?: InputMaybe<CompassLifecycleFilterInput>;
    ownerIds?: InputMaybe<CompassScorecardAppliedToComponentsOwnerFilter>;
    repositoryLinkFilter?: InputMaybe<CompassRepositoryValueInput>;
    types?: InputMaybe<CompassScorecardAppliedToComponentsTypesFilter>;
};

export type CompassFilteredComponentsCountResult =
    | CompassFilteredComponentsCount
    | QueryError;

export type CompassFlagEvent = CompassEvent & {
    __typename?: "CompassFlagEvent";
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * Flag Properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    flagProperties: CompassFlagEventProperties;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Properties specific to Flag events */
export type CompassFlagEventProperties = {
    __typename?: "CompassFlagEventProperties";
    /**
     * The ID of the flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The flag's status. The recognized values (case-insensitive) are on, off, created, archived, deleted, and targeting_updated. Any other value, although acceptable, will be displayed as unknown on the activity feed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<Scalars["String"]["output"]>;
};

/** A user-defined parameter containing a string value. */
export type CompassFreeformUserDefinedParameter = CompassUserDefinedParameter &
    Node & {
        __typename?: "CompassFreeformUserDefinedParameter";
        /**
         * The value that will be used if the user does not provide a value
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        defaultValue?: Maybe<Scalars["String"]["output"]>;
        /**
         * The description of the parameter
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The id of the parameter
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The name of the parameter
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The type of the parameter
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        type: Scalars["String"]["output"];
    };

export type CompassGlobalPermissions = {
    __typename?: "CompassGlobalPermissions";
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'createComponents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createComponents?: Maybe<CompassPermissionResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    createIncomingWebhooks?: Maybe<CompassPermissionResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    createMetricDefinitions?: Maybe<CompassPermissionResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    createScorecards?: Maybe<CompassPermissionResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    deleteIncomingWebhooks?: Maybe<CompassPermissionResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    editCustomFieldDefinitions?: Maybe<CompassPermissionResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    viewMetricDefinitions?: Maybe<CompassPermissionResult>;
};

export type CompassGlobalPermissionsResult =
    | CompassGlobalPermissions
    | QueryError;

/** The configuration for a library scorecard criterion checking the value of a specified custom boolean field. */
export type CompassHasCustomBooleanFieldLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasCustomBooleanFieldLibraryScorecardCriterion";
        /**
         * The comparison operation to be performed between the field and comparator value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        booleanComparator?: Maybe<CompassCriteriaBooleanComparatorOptions>;
        /**
         * The value that the field is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        booleanComparatorValue?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The ID of the custom field definition to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */
export type CompassHasCustomBooleanFieldScorecardCriteria =
    CompassCustomFieldScorecardCriteria &
        CompassScorecardCriteria & {
            __typename?: "CompassHasCustomBooleanFieldScorecardCriteria";
            /**
             * The comparison operation to be performed between the field and comparator value.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            booleanComparator?: Maybe<CompassCriteriaBooleanComparatorOptions>;
            /**
             * The value that the field is compared to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            booleanComparatorValue?: Maybe<Scalars["Boolean"]["output"]>;
            /**
             * The definition of the custom boolean field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinition?: Maybe<CompassCustomBooleanFieldDefinition>;
            /**
             * The optional, user provided description of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the scorecard criterion.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The optional, user provided name of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * Returns the calculated score for a component.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
            /**
             * The weight that will be used in determining the aggregate score.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            weight: Scalars["Int"]["output"];
        };

/** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */
export type CompassHasCustomBooleanFieldScorecardCriteriaScorecardCriteriaScoreArgs =
    {
        query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
    };

/** The configuration for a library scorecard criterion checking the value of a specified custom multi select field. */
export type CompassHasCustomMultiSelectFieldLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasCustomMultiSelectFieldLibraryScorecardCriterion";
        /**
         * The comparison operation to be performed between the field and comparator value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        collectionComparator?: Maybe<CompassCriteriaCollectionComparatorOptions>;
        /**
         * The list of multi select options that the field is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        collectionComparatorValue?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * The definition of the custom multi select field to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

export type CompassHasCustomMultiSelectFieldScorecardCriteria =
    CompassCustomFieldScorecardCriteria &
        CompassScorecardCriteria & {
            __typename?: "CompassHasCustomMultiSelectFieldScorecardCriteria";
            /**
             * The comparison operation to be performed between the field and comparator value.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            collectionComparator?: Maybe<CompassCriteriaCollectionComparatorOptions>;
            /**
             * The list of multi select options that the field is compared to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            collectionComparatorValue: Array<Scalars["ID"]["output"]>;
            /**
             * The definition of the custom multi select field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinition?: Maybe<CompassCustomMultiSelectFieldDefinition>;
            /**
             * The definition of the custom multi select field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinitionId: Scalars["ID"]["output"];
            /**
             * The optional, user provided description of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the scorecard criterion.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The optional, user provided name of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * Returns the calculated score for a component.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
            /**
             * The weight that will be used in determining the aggregate score.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            weight: Scalars["Int"]["output"];
        };

export type CompassHasCustomMultiSelectFieldScorecardCriteriaScorecardCriteriaScoreArgs =
    {
        query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
    };

/** The configuration for a library scorecard criterion checking the value of a specified custom number field. */
export type CompassHasCustomNumberFieldLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasCustomNumberFieldLibraryScorecardCriterion";
        /**
         * The ID of the custom field definition to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The comparison operation to be performed between the field and comparator value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        numberComparator?: Maybe<CompassCriteriaNumberComparatorOptions>;
        /**
         * The threshold value that the field is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        numberComparatorValue?: Maybe<Scalars["Float"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** The configuration for a scorecard criterion checking the value of a specified custom number field. */
export type CompassHasCustomNumberFieldScorecardCriteria =
    CompassCustomFieldScorecardCriteria &
        CompassScorecardCriteria & {
            __typename?: "CompassHasCustomNumberFieldScorecardCriteria";
            /**
             * The definition of the custom number field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinition?: Maybe<CompassCustomNumberFieldDefinition>;
            /**
             * The optional, user provided description of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the scorecard criterion.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The optional, user provided name of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * The comparison operation to be performed between the field and comparator value.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            numberComparator?: Maybe<CompassCriteriaNumberComparatorOptions>;
            /**
             * The threshold value that the field is compared to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            numberComparatorValue?: Maybe<Scalars["Float"]["output"]>;
            /**
             * Returns the calculated score for a component.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
            /**
             * The weight that will be used in determining the aggregate score.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            weight: Scalars["Int"]["output"];
        };

/** The configuration for a scorecard criterion checking the value of a specified custom number field. */
export type CompassHasCustomNumberFieldScorecardCriteriaScorecardCriteriaScoreArgs =
    {
        query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
    };

/** The configuration for a library scorecard criterion checking the value of a specified custom single select field. */
export type CompassHasCustomSingleSelectFieldLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasCustomSingleSelectFieldLibraryScorecardCriterion";
        /**
         * The definition of the custom single select field to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The comparison operation to be performed between the field and comparator value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        membershipComparator?: Maybe<CompassCriteriaMembershipComparatorOptions>;
        /**
         * The list of single select options that the field is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        membershipComparatorValue?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

export type CompassHasCustomSingleSelectFieldScorecardCriteria =
    CompassCustomFieldScorecardCriteria &
        CompassScorecardCriteria & {
            __typename?: "CompassHasCustomSingleSelectFieldScorecardCriteria";
            /**
             * The definition of the custom single select field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinition?: Maybe<CompassCustomSingleSelectFieldDefinition>;
            /**
             * The definition of the custom single select field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinitionId: Scalars["ID"]["output"];
            /**
             * The optional, user provided description of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the scorecard criterion.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The comparison operation to be performed between the field and comparator value.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            membershipComparator?: Maybe<CompassCriteriaMembershipComparatorOptions>;
            /**
             * The list of single select options that the field is compared to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            membershipComparatorValue: Array<Scalars["ID"]["output"]>;
            /**
             * The optional, user provided name of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * Returns the calculated score for a component.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
            /**
             * The weight that will be used in determining the aggregate score.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            weight: Scalars["Int"]["output"];
        };

export type CompassHasCustomSingleSelectFieldScorecardCriteriaScorecardCriteriaScoreArgs =
    {
        query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
    };

/** The configuration for a library scorecard criterion checking the value of a specified custom text field. */
export type CompassHasCustomTextFieldLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasCustomTextFieldLibraryScorecardCriterion";
        /**
         * The ID of the custom field definition to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** The configuration for a scorecard criterion checking the value of a specified custom text field. */
export type CompassHasCustomTextFieldScorecardCriteria =
    CompassCustomFieldScorecardCriteria &
        CompassScorecardCriteria & {
            __typename?: "CompassHasCustomTextFieldScorecardCriteria";
            /**
             * The definition of the custom text field to check the value of.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            customFieldDefinition?: Maybe<CompassCustomTextFieldDefinition>;
            /**
             * The optional, user provided description of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * The ID of the scorecard criterion.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * The optional, user provided name of the scorecard criterion
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            name?: Maybe<Scalars["String"]["output"]>;
            /**
             * Returns the calculated score for a component.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
            /**
             * The comparison operation to be performed.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'textComparator' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            textComparator?: Maybe<CompassCriteriaTextComparatorOptions>;
            /**
             * The value that the field is compared to.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             * ### Field lifecycle
             *
             * This field is in the 'EXPERIMENTAL' lifecycle stage
             *
             * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'textComparatorValue' field, or to any of its parents.
             *
             * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
             *
             */
            textComparatorValue?: Maybe<Scalars["String"]["output"]>;
            /**
             * The weight that will be used in determining the aggregate score.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ✅ Yes |
             * | UNAUTHENTICATED | ❌ No |
             *
             */
            weight: Scalars["Int"]["output"];
        };

/** The configuration for a scorecard criterion checking the value of a specified custom text field. */
export type CompassHasCustomTextFieldScorecardCriteriaScorecardCriteriaScoreArgs =
    {
        query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
    };

/** The configuration for a library scorecard criterion representing the presence of a description. */
export type CompassHasDescriptionLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasDescriptionLibraryScorecardCriterion";
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** The configuration for a scorecard criterion representing the presence of a description. */
export type CompassHasDescriptionScorecardCriteria =
    CompassScorecardCriteria & {
        __typename?: "CompassHasDescriptionScorecardCriteria";
        /**
         * The optional, user provided description of the scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The optional, user provided name of the scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * Returns the calculated score for a given component
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight: Scalars["Int"]["output"];
    };

/** The configuration for a scorecard criterion representing the presence of a description. */
export type CompassHasDescriptionScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */
export type CompassHasFieldScorecardCriteria = CompassScorecardCriteria & {
    __typename?: "CompassHasFieldScorecardCriteria";
    /**
     * The optional, user provided description of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The target of a relationship, for example, 'Owner' if 'Has Owner'.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fieldDefinition: CompassFieldDefinition;
    /**
     * The ID of the scorecard criterion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The optional, user provided name of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns the calculated score for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
    /**
     * The weight that will be used in determining the aggregate score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    weight: Scalars["Int"]["output"];
};

/** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */
export type CompassHasFieldScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a library scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */
export type CompassHasLinkLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasLinkLibraryScorecardCriterion";
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The type of link, for example 'Repository' if 'Has Repository'.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        linkType?: Maybe<CompassLinkType>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The comparison operation to be performed.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        textComparator?: Maybe<CompassCriteriaTextComparatorOptions>;
        /**
         * The value that the field is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        textComparatorValue?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */
export type CompassHasLinkScorecardCriteria = CompassScorecardCriteria & {
    __typename?: "CompassHasLinkScorecardCriteria";
    /**
     * The optional, user provided description of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the scorecard criterion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The type of link, for example 'Repository' if 'Has Repository'.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    linkType: CompassLinkType;
    /**
     * The optional, user provided name of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns the calculated score for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
    /**
     * The comparison operation to be performed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    textComparator?: Maybe<CompassCriteriaTextComparatorOptions>;
    /**
     * The value that the field is compared to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    textComparatorValue?: Maybe<Scalars["String"]["output"]>;
    /**
     * The weight that will be used in determining the aggregate score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    weight: Scalars["Int"]["output"];
};

/** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */
export type CompassHasLinkScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a library scorecard criterion checking the value of a specified metric name. */
export type CompassHasMetricValueLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasMetricValueLibraryScorecardCriterion";
        /**
         * The comparison operation to be performed between the metric and comparator value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        comparator?: Maybe<CompassCriteriaNumberComparatorOptions>;
        /**
         * The threshold value that the metric is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        comparatorValue?: Maybe<Scalars["Float"]["output"]>;
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The ID of the component metric to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        metricDefinitionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** The configuration for a scorecard criterion checking the value of a specified metric name. */
export type CompassHasMetricValueScorecardCriteria =
    CompassScorecardCriteria & {
        __typename?: "CompassHasMetricValueScorecardCriteria";
        /**
         * Automatically create metric sources for the custom metric definition associated with this criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        automaticallyCreateMetricSources?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The comparison operation to be performed between the metric and comparator value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        comparator: CompassCriteriaNumberComparatorOptions;
        /**
         * The threshold value that the metric is compared to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        comparatorValue: Scalars["Float"]["output"];
        /**
         * The optional, user provided description of the scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The ID of the scorecard criterion.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The definition of the component metric to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        metricDefinition?: Maybe<CompassMetricDefinition>;
        /**
         * The ID of the component metric to check the value of.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        metricDefinitionId: Scalars["ID"]["output"];
        /**
         * The optional, user provided name of the scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * Returns the calculated score for a component.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight: Scalars["Int"]["output"];
    };

/** The configuration for a scorecard criterion checking the value of a specified metric name. */
export type CompassHasMetricValueScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** The configuration for a library scorecard criterion representing the presence of an owner. */
export type CompassHasOwnerLibraryScorecardCriterion =
    CompassLibraryScorecardCriterion & {
        __typename?: "CompassHasOwnerLibraryScorecardCriterion";
        /**
         * Custom description of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Custom name of the library scorecard criterion
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The weight that will be used in determining the aggregate score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        weight?: Maybe<Scalars["Int"]["output"]>;
    };

/** Configuration for a scorecard criteria representing the presence of an owner */
export type CompassHasOwnerScorecardCriteria = CompassScorecardCriteria & {
    __typename?: "CompassHasOwnerScorecardCriteria";
    /**
     * The optional, user provided description of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the scorecard criterion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The optional, user provided name of the scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns the calculated score for a component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
    /**
     * The weight that will be used in determining the aggregate score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    weight: Scalars["Int"]["output"];
};

/** Configuration for a scorecard criteria representing the presence of an owner */
export type CompassHasOwnerScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

export type CompassIncidentEvent = CompassEvent & {
    __typename?: "CompassIncidentEvent";
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The list of properties of the incident event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    incidentProperties: CompassIncidentEventProperties;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Properties specific to Incident events */
export type CompassIncidentEventProperties = {
    __typename?: "CompassIncidentEventProperties";
    /**
     * The time when the incident ended
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    endTime?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The ID of the incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The severity of the incident
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    severity?: Maybe<CompassIncidentEventSeverity>;
    /**
     * The time when the incident started
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    startTime?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The state of the incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    state?: Maybe<CompassIncidentEventState>;
};

/** The severity of an incident */
export type CompassIncidentEventSeverity = {
    __typename?: "CompassIncidentEventSeverity";
    /**
     * The label to use for displaying the severity of the incident
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /**
     * The severity level. A severity level of 'ONE' is the most severe, and a level of 'FIVE' is the least severe.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    level?: Maybe<CompassIncidentEventSeverityLevel>;
};

/** The severity of an incident */
export type CompassIncidentEventSeverityInput = {
    /** The label to use for displaying the severity of the incident */
    label?: InputMaybe<Scalars["String"]["input"]>;
    /** The severity level. A severity level of 'ONE' is the most severe, and a level of 'FIVE' is the least severe. */
    level?: InputMaybe<CompassIncidentEventSeverityLevel>;
};

export enum CompassIncidentEventSeverityLevel {
    Five = "FIVE",
    Four = "FOUR",
    One = "ONE",
    Three = "THREE",
    Two = "TWO"
}

export enum CompassIncidentEventState {
    Deleted = "DELETED",
    Open = "OPEN",
    Resolved = "RESOLVED"
}

/** Represents a user-defined incoming webhook for creating events in Compass */
export type CompassIncomingWebhook = Node & {
    __typename?: "CompassIncomingWebhook";
    /** Contains change metadata for the incoming webhook. */
    changeMetadata: CompassChangeMetadata;
    /** The description of the webhook. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the webhook. */
    id: Scalars["ID"]["output"];
    /** The name of the webhook. */
    name: Scalars["String"]["output"];
    /** The source of the webhook. */
    source: Scalars["String"]["output"];
};

/**
 * ###################################################################################################################
 *  COMPASS INCOMING WEBHOOKS
 * ###################################################################################################################
 */
export type CompassIncomingWebhookEdge = {
    __typename?: "CompassIncomingWebhookEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassIncomingWebhook>;
};

export type CompassIncomingWebhooksConnection = {
    __typename?: "CompassIncomingWebhooksConnection";
    edges?: Maybe<Array<CompassIncomingWebhookEdge>>;
    nodes?: Maybe<Array<CompassIncomingWebhook>>;
    pageInfo?: Maybe<PageInfo>;
};

/** The input to insert a metric value in all metric sources that match a specific combination of metricDefinitionId and externalMetricSourceId. */
export type CompassInsertMetricValueByExternalIdInput = {
    /** The cloud ID of the site to insert a metric value for. */
    cloudId: Scalars["ID"]["input"];
    /** The ID of the metric source that is external to the Compass site, for example, a Bitbucket repository ID. */
    externalMetricSourceId: Scalars["ID"]["input"];
    /** The ID of the metric definition for which the value applies. */
    metricDefinitionId: Scalars["ID"]["input"];
    /** The metric value to be inserted. */
    value: CompassMetricValueInput;
};

/** The payload returned from inserting a metric value by external ID. */
export type CompassInsertMetricValueByExternalIdPayload = Payload & {
    __typename?: "CompassInsertMetricValueByExternalIdPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input to insert a metric value into a metric source. */
export type CompassInsertMetricValueInput = {
    /** The ID of the metric source to insert the value into. */
    metricSourceId: Scalars["ID"]["input"];
    /** The metric value to insert. */
    value: CompassMetricValueInput;
};

/** The payload returned from inserting a metric value. */
export type CompassInsertMetricValuePayload = Payload & {
    __typename?: "CompassInsertMetricValuePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The metric source that the value was inserted into. */
    metricSource?: Maybe<CompassMetricSource>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The JQL configuration, if any, for this metric definition. */
export type CompassJqlMetricDefinitionConfiguration = {
    __typename?: "CompassJQLMetricDefinitionConfiguration";
    /** Whether the default JQL string can be overridden by individual metric sources. */
    customizable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Additional JQL formatting that wraps around the default JQL string. Used to construct the final JQL string that is executed. */
    format?: Maybe<Scalars["String"]["output"]>;
    /** The default JQL string used to fetch the metric values for any given metric source from this metric definition. */
    jql: Scalars["String"]["output"];
};

export type CompassJqlMetricDefinitionConfigurationInput = {
    /** Whether or not the JQL of this metric definition is customizable. */
    customizable: Scalars["Boolean"]["input"];
    /** The format used to scope the JQL of this metric definition. */
    format?: InputMaybe<Scalars["String"]["input"]>;
    /** The JQL of this metric definition. */
    jql: Scalars["String"]["input"];
};

export type CompassJqlMetricSourceConfiguration = {
    __typename?: "CompassJQLMetricSourceConfiguration";
    /** The exact JQL query that is being executed to fetch the metric values. */
    executingJql?: Maybe<Scalars["String"]["output"]>;
    /** The JQL string, if any, that overrides the metric definition's JQL. */
    jql?: Maybe<Scalars["String"]["output"]>;
    /**
     * Any potential errors that may affect fetching JQL metric values for this metric source.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'potentialErrors' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    potentialErrors?: Maybe<CompassJqlMetricSourceConfigurationPotentialErrorsResult>;
    userContext?: Maybe<User>;
    viewerPermissions?: Maybe<CompassJqlMetricSourceInstancePermissions>;
};

export type CompassJqlMetricSourceConfigurationInput = {
    /** The custom JQL for the respective JQL metric definition */
    jql: Scalars["String"]["input"];
};

export type CompassJqlMetricSourceConfigurationPotentialErrors = {
    __typename?: "CompassJQLMetricSourceConfigurationPotentialErrors";
    configErrors?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type CompassJqlMetricSourceConfigurationPotentialErrorsResult =
    | CompassJqlMetricSourceConfigurationPotentialErrors
    | QueryError;

export type CompassJqlMetricSourceInstancePermissions = {
    __typename?: "CompassJQLMetricSourceInstancePermissions";
    revokePollingUser?: Maybe<CompassPermissionResult>;
    updatePollingUser?: Maybe<CompassPermissionResult>;
};

/** The details of a Compass Jira issue. */
export type CompassJiraIssue = Node & {
    __typename?: "CompassJiraIssue";
    /** Contains change metadata for the issue. */
    changeMetadata: CompassChangeMetadata;
    /** The unique identifier (ID) of the issue. */
    id: Scalars["ID"]["output"];
    /** The external identifier (ID) of the issue. */
    issueId?: Maybe<Scalars["ID"]["output"]>;
    /** The URL of the issue. */
    url: Scalars["URL"]["output"];
};

export type CompassJiraIssueEdge = {
    cursor: Scalars["String"]["output"];
    isActive?: Maybe<Scalars["Boolean"]["output"]>;
    node?: Maybe<CompassJiraIssue>;
};

export type CompassLibraryScorecard = Node & {
    __typename?: "CompassLibraryScorecard";
    /** Contains the application rules for how this library scorecard will apply to components. */
    applicationModel?: Maybe<CompassScorecardApplicationModel>;
    /** The criteria used for calculating the score. */
    criteria?: Maybe<Array<CompassLibraryScorecardCriterion>>;
    /** The description of the library scorecard. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier (ID) of the library scorecard. */
    id: Scalars["ID"]["output"];
    /** Number of scorecards created from this library scorecard. */
    installs?: Maybe<Scalars["Int"]["output"]>;
    /** Whether or not components can deactivate this scorecard, if it's a REQUIRED scorecard. */
    isDeactivationEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The name of the library scorecard. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Whether a scorecard already exists with the same name as this library scorecard. */
    nameAlreadyExists?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CompassLibraryScorecardConnection = {
    __typename?: "CompassLibraryScorecardConnection";
    edges?: Maybe<Array<CompassLibraryScorecardEdge>>;
    nodes?: Maybe<Array<Maybe<CompassLibraryScorecard>>>;
    pageInfo?: Maybe<PageInfo>;
};

/** The configuration for a library scorecard criterion that can be shared across components. */
export type CompassLibraryScorecardCriterion = {
    /**
     * Custom description of the library scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * Custom name of the library scorecard criterion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The weight that will be used in determining the aggregate score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassLibraryScorecardEdge = {
    __typename?: "CompassLibraryScorecardEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<CompassLibraryScorecard>;
};

export type CompassLibraryScorecardResult =
    | CompassLibraryScorecard
    | QueryError;

export type CompassLifecycleEvent = CompassEvent & {
    __typename?: "CompassLifecycleEvent";
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * The lifecycle properties.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lifecycleProperties: CompassLifecycleEventProperties;
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** The list of properties of the lifecycle event. */
export type CompassLifecycleEventInputProperties = {
    /** The ID of the lifecycle. */
    id: Scalars["ID"]["input"];
    /** The stage of the lifecycle event. */
    stage: CompassLifecycleEventStage;
};

/** Properties specific to Lifecycle events */
export type CompassLifecycleEventProperties = {
    __typename?: "CompassLifecycleEventProperties";
    /**
     * The ID of the lifecycle.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The stage of the lifecycle event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    stage?: Maybe<CompassLifecycleEventStage>;
};

export enum CompassLifecycleEventStage {
    Deprecation = "DEPRECATION",
    EndOfLife = "END_OF_LIFE",
    PreRelease = "PRE_RELEASE",
    Production = "PRODUCTION"
}

export type CompassLifecycleFilter = {
    __typename?: "CompassLifecycleFilter";
    /**
     * logical operator to use for values in the list
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    operator: Scalars["String"]["output"];
    /**
     * stages to consider when filtering components for application of scorecards
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type CompassLifecycleFilterInput = {
    /** logical operator to use for values in the list */
    operator: CompassLifecycleFilterOperator;
    /** stages to consider when filtering components for application of scorecards */
    values: Array<Scalars["String"]["input"]>;
};

/** MUTATION INPUTS/PAYLOAD TYPES */
export enum CompassLifecycleFilterOperator {
    Nor = "NOR",
    Or = "OR"
}

/** A link to an entity or resource on the internet. */
export type CompassLink = {
    __typename?: "CompassLink";
    /** Event sources that power this link */
    eventSources?: Maybe<Array<EventSource>>;
    /** The unique identifier (ID) of the link. */
    id: Scalars["ID"]["output"];
    /** An user-provided name of the link. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The type of link. */
    type: CompassLinkType;
    /** An URL to the entity or resource on the internet. */
    url: Scalars["URL"]["output"];
};

/** The types used to identify the intent of the link. */
export enum CompassLinkType {
    /** Chat Channels for contacting the owners/support of the component */
    ChatChannel = "CHAT_CHANNEL",
    /** A link to the dashboard of the component. */
    Dashboard = "DASHBOARD",
    /**
     * A link to the documentation of the component.
     * @deprecated Documents should be created with the documentation API
     */
    Document = "DOCUMENT",
    /** A link to the on-call schedule of the component. */
    OnCall = "ON_CALL",
    /** Other link for a Component. */
    OtherLink = "OTHER_LINK",
    /** A link to the Jira or third-party project of the component. */
    Project = "PROJECT",
    /** A link to the source code repository of the component. */
    Repository = "REPOSITORY"
}

/** A metric definition defines a metric across multiple components. */
export type CompassMetricDefinition = Node & {
    __typename?: "CompassMetricDefinition";
    /** The event types this metric can be derived from. If undefined, this metric cannot be derived. */
    derivedEventTypes?: Maybe<Array<CompassEventType>>;
    /** The description of the metric definition. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The format option for applying to the display of metric values. */
    format?: Maybe<CompassMetricDefinitionFormat>;
    /** The unique identifier (ID) of the metric definition. */
    id: Scalars["ID"]["output"];
    isPinned?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The JQL configuration, if any, for this metric definition.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'jqlConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jqlConfiguration?: Maybe<CompassJqlMetricDefinitionConfiguration>;
    /** A collection of metrics which contain values that provide numerical data. */
    metricSources?: Maybe<CompassMetricSourcesQueryResult>;
    /** The name of the metric definition. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The type of the metric definition based on where the definition originated */
    type: CompassMetricDefinitionType;
    /**
     * Viewer permissions specific to this metric definition and user context.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'viewerPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    viewerPermissions?: Maybe<CompassMetricDefinitionInstancePermissions>;
};

/** A metric definition defines a metric across multiple components. */
export type CompassMetricDefinitionMetricSourcesArgs = {
    query?: InputMaybe<CompassMetricSourcesQuery>;
};

export type CompassMetricDefinitionConfigurationInput = {
    /** The JQL configuration of the metric definition. */
    jql?: InputMaybe<CompassJqlMetricDefinitionConfigurationInput>;
};

/** An edge that contains a metric definition and a cursor. */
export type CompassMetricDefinitionEdge = {
    __typename?: "CompassMetricDefinitionEdge";
    /** The cursor of the metric definition. */
    cursor: Scalars["String"]["output"];
    /** The metric definition. */
    node?: Maybe<CompassMetricDefinition>;
};

export type CompassMetricDefinitionFormat = CompassMetricDefinitionFormatSuffix;

export type CompassMetricDefinitionFormatInput = {
    /** A plain-text suffix appended to the metric value when displayed, for example, 'MB/s'. */
    suffix?: InputMaybe<CompassMetricDefinitionFormatSuffixInput>;
};

/** The format option to append a plain-text suffix to metric values. */
export type CompassMetricDefinitionFormatSuffix = {
    __typename?: "CompassMetricDefinitionFormatSuffix";
    /** A plain-text suffix appended to the metric value when displayed, for example, 'MB/s'. */
    suffix?: Maybe<Scalars["String"]["output"]>;
};

/** The format option to append a plain-text suffix to metric values. */
export type CompassMetricDefinitionFormatSuffixInput = {
    /** A plain-text suffix appended to the metric value when displayed, for example, 'MB/s'. */
    suffix: Scalars["String"]["input"];
};

export type CompassMetricDefinitionInstancePermissions = {
    __typename?: "CompassMetricDefinitionInstancePermissions";
    canDelete?: Maybe<CompassPermissionResult>;
    canEdit?: Maybe<CompassPermissionResult>;
};

export type CompassMetricDefinitionResult =
    | CompassMetricDefinition
    | QueryError;

/** Used to identify the type for the metric */
export enum CompassMetricDefinitionType {
    /** Predefined metrics built in to Compass */
    BuiltIn = "BUILT_IN",
    /** Metrics defined by the individual user */
    Custom = "CUSTOM"
}

/** A connection that returns a paginated collection of metric definitions. */
export type CompassMetricDefinitionsConnection = {
    __typename?: "CompassMetricDefinitionsConnection";
    /** A list of edges which contain a metric definition and a cursor. */
    edges?: Maybe<Array<CompassMetricDefinitionEdge>>;
    /** A list of metric definitions. */
    nodes?: Maybe<Array<CompassMetricDefinition>>;
    /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
    pageInfo: PageInfo;
};

/** The query to get the metric definitions on a Compass site. */
export type CompassMetricDefinitionsQuery = {
    /** Returns results after the specified cursor. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The cloud ID of the site to query for metric definitions on. */
    cloudId: Scalars["ID"]["input"];
    /** The number of results to return in the query. The default is 10. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassMetricDefinitionsQueryResult =
    | CompassMetricDefinitionsConnection
    | QueryError;

/** A metric source contains values that provide numerical data about the component. */
export type CompassMetricSource = Node & {
    __typename?: "CompassMetricSource";
    /** Compass component associated with this metric source. */
    component?: Maybe<CompassComponent>;
    /** Which event sources this metric source is derived from. */
    derivedFrom?: Maybe<Array<EventSource>>;
    /** The unique identifier (ID) of the metric source that is external to the Compass site, for example, a Bitbucket repository ID. */
    externalMetricSourceId?: Maybe<Scalars["ID"]["output"]>;
    /** The ID of the Forge app used to construct the metric source. The Forge app ID will be null if the metric source was not created from a Forge app. */
    forgeAppId?: Maybe<Scalars["ID"]["output"]>;
    /** The unique identifier (ID) of the metric source on the Compass site. */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'jqlConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jqlConfiguration?: Maybe<CompassJqlMetricSourceConfiguration>;
    /** The metric definition that defines the metric source. */
    metricDefinition?: Maybe<CompassMetricDefinition>;
    /** The title of the metric source. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the metric source. */
    url?: Maybe<Scalars["String"]["output"]>;
    /** A collection of values which store historical data points about the component. */
    values?: Maybe<CompassMetricSourceValuesQueryResult>;
};

/** A metric source contains values that provide numerical data about the component. */
export type CompassMetricSourceValuesArgs = {
    query?: InputMaybe<CompassMetricSourceValuesQuery>;
};

export type CompassMetricSourceConfigurationInput = {
    /** The custom JQL for the respective JQL metric definition */
    jql?: InputMaybe<CompassJqlMetricSourceConfigurationInput>;
};

/** An edge that contains a metric source and a cursor. */
export type CompassMetricSourceEdge = {
    __typename?: "CompassMetricSourceEdge";
    /** The cursor of the metric source. */
    cursor: Scalars["String"]["output"];
    /** The metric source. */
    node?: Maybe<CompassMetricSource>;
};

export type CompassMetricSourceFilter = {
    metricDefinition?: InputMaybe<CompassMetricSourceMetricDefinitionFilter>;
};

export type CompassMetricSourceMetricDefinitionFilter = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CompassMetricSourceQuery = {
    matchAnyFilter?: InputMaybe<Array<CompassMetricSourceFilter>>;
};

/** A base for different scopes of metrics. Future metric sources can implement this and add their scope specific fields */
export type CompassMetricSourceV2 = {
    externalMetricSourceId?: Maybe<Scalars["ID"]["output"]>;
    forgeAppId?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    metricDefinition?: Maybe<CompassMetricDefinition>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** A connection that returns a paginated collection of metric values. */
export type CompassMetricSourceValuesConnection = {
    __typename?: "CompassMetricSourceValuesConnection";
    /** A list of edges which contain a metric values and a cursor. */
    edges?: Maybe<Array<CompassMetricValueEdge>>;
    /** A list of metric values. */
    nodes?: Maybe<Array<CompassMetricValue>>;
    /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
    pageInfo: PageInfo;
};

/** The query to get the metric values from a component's metric source. */
export type CompassMetricSourceValuesQuery = {
    /** Returns the values after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The number of results to return in the query. The default is 10. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassMetricSourceValuesQueryResult =
    | CompassMetricSourceValuesConnection
    | QueryError;

export type CompassMetricSourcesConnection = {
    __typename?: "CompassMetricSourcesConnection";
    edges?: Maybe<Array<CompassMetricSourceEdge>>;
    nodes?: Maybe<Array<CompassMetricSource>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassMetricSourcesQuery = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassMetricSourcesQueryResult =
    | CompassMetricSourcesConnection
    | QueryError;

/** A metric value stores the numerical data relating to the component. */
export type CompassMetricValue = {
    __typename?: "CompassMetricValue";
    /** The time the metric value was collected. */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
    /** The value of the metric. */
    value?: Maybe<Scalars["Float"]["output"]>;
};

/** An edge that contains a metric value and a cursor. */
export type CompassMetricValueEdge = {
    __typename?: "CompassMetricValueEdge";
    /** The cursor of the metric value. */
    cursor: Scalars["String"]["output"];
    /** The metric value. */
    node?: Maybe<CompassMetricValue>;
};

/** A metric value to be inserted. */
export type CompassMetricValueInput = {
    /** The time the metric value was collected. */
    timestamp: Scalars["DateTime"]["input"];
    /** The value of the metric. */
    value: Scalars["Float"]["input"];
};

export type CompassMetricValuesFilter = {
    timeRange?: InputMaybe<CompassMetricValuesTimeRangeFilter>;
};

export type CompassMetricValuesQuery = {
    matchAnyFilter?: InputMaybe<Array<CompassMetricValuesFilter>>;
};

export type CompassMetricValuesTimeRangeFilter = {
    endDate: Scalars["DateTime"]["input"];
    startDate: Scalars["DateTime"]["input"];
};

/** A list of bucketed, ordered, metric values */
export type CompassMetricValuesTimeseries = {
    __typename?: "CompassMetricValuesTimeseries";
    values?: Maybe<Array<Maybe<CompassMetricValue>>>;
};

export type CompassMetricValuesTimeseriesResult =
    | CompassMetricValuesTimeseries
    | QueryError;

export type CompassPermissionResult = {
    __typename?: "CompassPermissionResult";
    allowed: Scalars["Boolean"]["output"];
    denialReasons: Array<Scalars["String"]["output"]>;
    limit?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassPlainMetricSourceConfigurationInput = {
    /** External configuration query */
    query: Scalars["String"]["input"];
};

/** The details of a Compass pull request. */
export type CompassPullRequest = Node & {
    __typename?: "CompassPullRequest";
    /** Contains change metadata for the pull request in Compass. */
    changeMetadata: CompassChangeMetadata;
    /** Contains change metadata for the pull request in its source of truth. */
    externalChangeMetadata?: Maybe<CompassChangeMetadata>;
    /** The external identifier of the pull request provided by the SCM app. */
    externalId: Scalars["ID"]["output"];
    /** The external source identifier. */
    externalSourceId?: Maybe<Scalars["ID"]["output"]>;
    /** The unique identifier (ID) of the pull request. */
    id: Scalars["ID"]["output"];
    /** The Pull request URL. */
    pullRequestUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The Repository URL. */
    repositoryUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Status timestamps. */
    statusTimestamps?: Maybe<CompassStatusTimeStamps>;
};

export type CompassPullRequestConnection = {
    __typename?: "CompassPullRequestConnection";
    edges?: Maybe<Array<Maybe<CompassPullRequestConnectionEdge>>>;
    nodes?: Maybe<Array<Maybe<CompassPullRequest>>>;
    pageInfo: PageInfo;
    stats?: Maybe<CompassPullRequestStats>;
};

export type CompassPullRequestConnectionEdge = {
    __typename?: "CompassPullRequestConnectionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassPullRequest>;
};

/** A pull request event. */
export type CompassPullRequestEvent = CompassEvent & {
    __typename?: "CompassPullRequestEvent";
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * The list of properties of the pull request event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pullRequestEventProperties: CompassPullRequestEventProperties;
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** The list of properties of the pull request event. */
export type CompassPullRequestEventProperties = {
    __typename?: "CompassPullRequestEventProperties";
    /**
     * The ID of the pull request event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The URL of the pull request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pullRequestUrl: Scalars["String"]["output"];
    /**
     * The URL of the repository of the pull request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    repoUrl: Scalars["String"]["output"];
    /**
     * The status of the pull request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status: CompassCreatePullRequestStatus;
};

/** The list of properties of the pull event. */
export type CompassPullRequestInputProperties = {
    /** The ID of the pull request event. */
    id: Scalars["String"]["input"];
    /** The URL of the pull request. */
    pullRequestUrl: Scalars["String"]["input"];
    /** The URL of the repository of the pull request. */
    repoUrl: Scalars["String"]["input"];
    /** The status of the pull request. */
    status: CompassCreatePullRequestStatus;
};

export enum CompassPullRequestQuerySortName {
    /** The time between a PR's created and merged or rejected state. */
    CycleTime = "CYCLE_TIME",
    OpenToFirstReview = "OPEN_TO_FIRST_REVIEW",
    PrClosedTime = "PR_CLOSED_TIME",
    PrCreatedTime = "PR_CREATED_TIME",
    /** The time between a PR's first reviewed and last reviewed timestamps. */
    ReviewTime = "REVIEW_TIME"
}

export type CompassPullRequestStats = {
    __typename?: "CompassPullRequestStats";
    closed?: Maybe<Scalars["Int"]["output"]>;
    firstReviewed?: Maybe<Scalars["Int"]["output"]>;
    open?: Maybe<Scalars["Int"]["output"]>;
    overdue?: Maybe<Scalars["Int"]["output"]>;
};

export enum CompassPullRequestStatus {
    Created = "CREATED",
    FirstReviewed = "FIRST_REVIEWED",
    Merged = "MERGED",
    Overdue = "OVERDUE",
    Rejected = "REJECTED"
}

/** The pull request status used in the StatusInTimeRangeFilter query. */
export enum CompassPullRequestStatusForStatusInTimeRangeFilter {
    Created = "CREATED",
    FirstReviewed = "FIRST_REVIEWED",
    Merged = "MERGED",
    Rejected = "REJECTED"
}

/** Accepts input to find pull requests. */
export type CompassPullRequestsQuery = {
    /** Returns the pull requests which matches one of the current status. */
    matchAnyCurrentStatus?: InputMaybe<Array<CompassPullRequestStatus>>;
    /** The filters used in the query. The relationship of filters is OR. */
    matchAnyFilters?: InputMaybe<Array<CompassPullRequestsQueryFilter>>;
    /** The sorting mechanism used in the query. */
    sort?: InputMaybe<CompassPullRequestsQuerySort>;
};

/** Accepts input for querying pull requests. */
export type CompassPullRequestsQueryFilter = {
    /** Input for querying pull request based on status and time range. */
    statusInTimeRange?: InputMaybe<PullRequestStatusInTimeRangeQueryFilter>;
};

export type CompassPullRequestsQuerySort = {
    /** The name of the field to sort by. */
    name: CompassPullRequestQuerySortName;
    /** The order to sort by. */
    order: CompassQuerySortOrder;
};

/** A push event. */
export type CompassPushEvent = CompassEvent & {
    __typename?: "CompassPushEvent";
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * The list of properties of the push event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pushEventProperties: CompassPushEventProperties;
    /**
     * A number specifying the order of the update to the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** The author who made the push */
export type CompassPushEventAuthorInput = {
    /** The email of the author. */
    email?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the author. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The list of properties of the push event. */
export type CompassPushEventInputProperties = {
    /** The author who made the push. */
    author?: InputMaybe<CompassPushEventAuthorInput>;
    /** The name of the branch being pushed to. */
    branchName: Scalars["String"]["input"];
    /** The ID of the push to event. */
    id: Scalars["ID"]["input"];
};

/** The list of properties of the push event. */
export type CompassPushEventProperties = {
    __typename?: "CompassPushEventProperties";
    /**
     * The name of the branch being pushed to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    branchName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the push to event
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
};

/** A filter to apply to the search results. */
export type CompassQueryFieldFilter = {
    filter?: InputMaybe<CompassQueryFilter>;
    /** The name of the field to apply the filter. The valid field names are compass:tier, labels, ownerId, score, type, links, linkTypes, state, and eventSourceCount. */
    name: Scalars["String"]["input"];
};

export type CompassQueryFilter = {
    eq?: InputMaybe<Scalars["String"]["input"]>;
    gt?: InputMaybe<Scalars["String"]["input"]>;
    /** Greater than or equal to */
    gte?: InputMaybe<Scalars["String"]["input"]>;
    in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    lt?: InputMaybe<Scalars["String"]["input"]>;
    /** Less than or equal to */
    lte?: InputMaybe<Scalars["String"]["input"]>;
    neq?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassQuerySort = {
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** name of field to sort results by */
    order?: InputMaybe<CompassQuerySortOrder>;
};

export enum CompassQuerySortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type CompassQueryTimeRange = {
    /** End date for query, exclusive. */
    endDate: Scalars["DateTime"]["input"];
    /** Start date for query, inclusive. */
    startDate: Scalars["DateTime"]["input"];
};

/** The payload returned from reactivating a scorecard for a component. */
export type CompassReactivateScorecardForComponentPayload = Payload & {
    __typename?: "CompassReactivateScorecardForComponentPayload";
    /** The details of the component. */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** A relationship between two components. The startNode and endNode depends on the direction of the relationship. */
export type CompassRelationship = {
    __typename?: "CompassRelationship";
    changeMetadata?: Maybe<CompassChangeMetadata>;
    /**
     * The ending node of the relationship. This will be the other component if the direction is OUTWARD.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    endNode?: Maybe<CompassComponent>;
    /**
     * The starting node of the relationship. This will be the current component if the direction is OUTWARD.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    startNode?: Maybe<CompassComponent>;
    /** The type of relationship. */
    type: CompassRelationshipType;
};

export type CompassRelationshipConnection = {
    __typename?: "CompassRelationshipConnection";
    edges?: Maybe<Array<CompassRelationshipEdge>>;
    nodes?: Maybe<Array<CompassRelationship>>;
    pageInfo: PageInfo;
};

export type CompassRelationshipConnectionResult =
    | CompassRelationshipConnection
    | QueryError;

/** Defines the possible relationship directions between components. */
export enum CompassRelationshipDirection {
    /** Going from the other component to this component. */
    Inward = "INWARD",
    /** Going from this component to the other component. */
    Outward = "OUTWARD"
}

export type CompassRelationshipEdge = {
    __typename?: "CompassRelationshipEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassRelationship>;
};

/** Accepts input for finding component relationships. */
export type CompassRelationshipQuery = {
    /** The relationships to be returned after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The direction of relationships to be searched for. */
    direction?: CompassRelationshipDirection;
    /** The filters for the relationships to be searched for. */
    filters?: InputMaybe<CompassRelationshipQueryFilters>;
    /** The number of relationships to return in the query. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassRelationshipQueryFilters = {
    /** OR'd set of relationship types. */
    types?: InputMaybe<Array<CompassRelationshipType>>;
};

/** Defines the relationship types. A relationship must be one of these types. */
export enum CompassRelationshipType {
    DependsOn = "DEPENDS_ON"
}

/** Accepts input for removing labels from a team. */
export type CompassRemoveTeamLabelsInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
    /** A list of labels that should be removed from the team. */
    labels: Array<Scalars["String"]["input"]>;
    /** The unique identifier (ID) of the target team. */
    teamId: Scalars["ID"]["input"];
};

/** The payload returned after removing labels from a team. */
export type CompassRemoveTeamLabelsPayload = Payload & {
    __typename?: "CompassRemoveTeamLabelsPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** A list of labels that were removed from the team. */
    removedLabels?: Maybe<Array<CompassTeamLabel>>;
    /** A flag indicating whether the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type CompassRepositoryValue = {
    __typename?: "CompassRepositoryValue";
    /**
     * Repository link exists or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    exists: Scalars["Boolean"]["output"];
};

export type CompassRepositoryValueInput = {
    /** The repository link exists or not */
    exists: Scalars["Boolean"]["input"];
};

export type CompassRevokeJqlMetricSourceUserInput = {
    metricSourceId: Scalars["ID"]["input"];
};

export type CompassRevokeJqlMetricSourceUserPayload = Payload & {
    __typename?: "CompassRevokeJQLMetricSourceUserPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedMetricSource?: Maybe<CompassMetricSource>;
};

/** An object containing rich text versions of a string. */
export type CompassRichTextObject = {
    __typename?: "CompassRichTextObject";
    /** The rich text string in Atlassian Document Format. */
    adf?: Maybe<Scalars["String"]["output"]>;
};

export type CompassScoreStatisticsHistoryComponentTypesFilter = {
    /** The types of components to filter on, for example SERVICE. */
    in: Array<Scalars["ID"]["input"]>;
};

export type CompassScoreStatisticsHistoryDateFilter = {
    /** The date to start filtering score statistics history. */
    startFrom: Scalars["DateTime"]["input"];
};

export type CompassScoreStatisticsHistoryOwnersFilter = {
    /** The team owners to filter on. */
    in: Array<Scalars["ID"]["input"]>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecard = Node & {
    __typename?: "CompassScorecard";
    /** Contains the application rules for how this scorecard will apply to components. */
    applicationModel: CompassScorecardApplicationModel;
    /** Returns a list of components to which this scorecard is applied. */
    appliedToComponents?: Maybe<CompassScorecardAppliedToComponentsQueryResult>;
    /**
     * Returns campaigns for the scorecard
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'campaigns' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    campaigns?: Maybe<CompassCampaignConnection>;
    /** Contains change metadata for the scorecard. */
    changeMetadata: CompassChangeMetadata;
    /** A collection of component labels used to filter what components the scorecard applies to. */
    componentLabels?: Maybe<Array<CompassComponentLabel>>;
    /** A collection of component tiers used to filter what components the scorecard applies to. */
    componentTiers?: Maybe<Array<CompassComponentTier>>;
    /** The types of components to which this scorecard is restricted to. */
    componentTypeIds: Array<Scalars["ID"]["output"]>;
    /**
     * The historical score status information for scorecard criteria.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'criteriaScoreStatisticsHistories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    criteriaScoreStatisticsHistories?: Maybe<CompassScorecardCriteriaScoreStatisticsHistoryConnection>;
    /** The criteria used for calculating the score. */
    criterias?: Maybe<Array<CompassScorecardCriteria>>;
    /**
     * A collection of components that deactivated this scorecard, if deactivation is enabled.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'deactivatedComponents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deactivatedComponents?: Maybe<CompassScorecardDeactivatedComponentsConnection>;
    /** The description of the scorecard. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier (ID) of the scorecard. */
    id: Scalars["ID"]["output"];
    /** Determines how the scorecard will be applied by default. */
    importance: CompassScorecardImportance;
    /** Whether or not components can deactivate this scorecard. */
    isDeactivationEnabled: Scalars["Boolean"]["output"];
    /**
     * The unique identifier (ID) of the library scorecard this scorecard was created from.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'libraryScorecardId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    libraryScorecardId?: Maybe<Scalars["ID"]["output"]>;
    /** The name of the scorecard. */
    name: Scalars["String"]["output"];
    /** The unique identifier (ID) of the scorecard's owner. */
    owner?: Maybe<User>;
    /** Returns the calculated total score for a given component. */
    scorecardScore?: Maybe<CompassScorecardScore>;
    /**
     * Score status information grouped by the number of days the status has remained unchanged.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scorecardScoreDurationStatistics' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scorecardScoreDurationStatistics?: Maybe<CompassScorecardScoreDurationStatisticsResult>;
    /**
     * The historical score status information for a scorecard.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scorecardScoreStatisticsHistories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scorecardScoreStatisticsHistories?: Maybe<CompassScorecardScoreStatisticsHistoryConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyType' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scoringStrategyType?: Maybe<Scalars["String"]["output"]>;
    /** The state of the scorecard. */
    state?: Maybe<Scalars["String"]["output"]>;
    /**
     * Threshold config to calculate status for scorecard score
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'statusConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    statusConfig?: Maybe<CompassScorecardStatusConfig>;
    /**
     * Indicates whether the scorecard is user-generated or pre-installed.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'type' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    type: Scalars["String"]["output"];
    /**
     * Viewer permissions specific to this scorecard and user context.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'viewerPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    viewerPermissions?: Maybe<CompassScorecardInstancePermissions>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardAppliedToComponentsArgs = {
    query?: InputMaybe<CompassScorecardAppliedToComponentsQuery>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardCampaignsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassCampaignQuery>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardCriteriaScoreStatisticsHistoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassScorecardCriteriaScoreStatisticsHistoryQuery>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardDeactivatedComponentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassScorecardDeactivatedComponentsQuery>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardScorecardScoreArgs = {
    query?: InputMaybe<CompassScorecardScoreQuery>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardScorecardScoreDurationStatisticsArgs = {
    query?: InputMaybe<CompassScorecardScoreDurationStatisticsQuery>;
};

/** The configuration for a scorecard that can be used by components. */
export type CompassScorecardScorecardScoreStatisticsHistoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassScorecardScoreStatisticsHistoryQuery>;
};

/** Contains the application rules for how a scorecard will apply to components. */
export type CompassScorecardApplicationModel = {
    /** The application type for the scorecard. */
    applicationType: Scalars["String"]["output"];
};

export type CompassScorecardAppliedToComponentsConnection = {
    __typename?: "CompassScorecardAppliedToComponentsConnection";
    edges?: Maybe<Array<CompassScorecardAppliedToComponentsEdge>>;
    nodes?: Maybe<Array<CompassComponent>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassScorecardAppliedToComponentsCriteriaFilter = {
    /** The ID of the scorecard criterion. */
    id: Scalars["ID"]["input"];
    /** The statuses of the criterion to filter on, for example FAILING. */
    statuses: Array<Scalars["ID"]["input"]>;
};

export type CompassScorecardAppliedToComponentsEdge = {
    __typename?: "CompassScorecardAppliedToComponentsEdge";
    activeIssues?: Maybe<CompassComponentScorecardJiraIssuesQueryResult>;
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassComponent>;
    /** Viewer permissions specific to this scorecard applied to components and user context. */
    viewerPermissions?: Maybe<CompassComponentScorecardRelationshipInstancePermissions>;
};

export type CompassScorecardAppliedToComponentsEdgeActiveIssuesArgs = {
    query?: InputMaybe<CompassComponentScorecardJiraIssuesQuery>;
};

export type CompassScorecardAppliedToComponentsFieldFilter = {
    /** The ID of the field definition, for example 'compass:tier'. */
    definition: Scalars["ID"]["input"];
    /** The values of the field to filter on. */
    in: Array<CompassFieldValueInput>;
};

export type CompassScorecardAppliedToComponentsLabelsFilter = {
    /** The labels of components to filter on. */
    in: Array<Scalars["String"]["input"]>;
};

export type CompassScorecardAppliedToComponentsOwnerFilter = {
    /** The team owners to filter on. */
    in: Array<Scalars["ID"]["input"]>;
};

/** Accepts input to find components a scorecard is applied to and their scores */
export type CompassScorecardAppliedToComponentsQuery = {
    /** Returns the components after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Returns only components whose attributes match those in the filters specified */
    filter?: InputMaybe<CompassScorecardAppliedToComponentsQueryFilter>;
    /** The first N number of components to return in the query. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Returns components according to the sorting scheme specified. */
    sort?: InputMaybe<CompassScorecardAppliedToComponentsQuerySort>;
};

export type CompassScorecardAppliedToComponentsQueryFilter = {
    fields?: InputMaybe<Array<CompassScorecardAppliedToComponentsFieldFilter>>;
    owners?: InputMaybe<CompassScorecardAppliedToComponentsOwnerFilter>;
    score?: InputMaybe<CompassScorecardAppliedToComponentsThresholdFilter>;
    scoreRanges?: InputMaybe<CompassScorecardAppliedToComponentsScoreRangeFilter>;
    scorecardCriteria?: InputMaybe<
        Array<CompassScorecardAppliedToComponentsCriteriaFilter>
    >;
    types?: InputMaybe<CompassScorecardAppliedToComponentsTypesFilter>;
};

export type CompassScorecardAppliedToComponentsQueryResult =
    | CompassScorecardAppliedToComponentsConnection
    | QueryError;

/** Accepts input to sort the applied components by. */
export type CompassScorecardAppliedToComponentsQuerySort = {
    /** The name of the field to sort by. Supports `SCORE` for scorecard score. */
    name: Scalars["String"]["input"];
    /** The order to sort the applied components by. */
    order: CompassScorecardQuerySortOrder;
};

export type CompassScorecardAppliedToComponentsScoreRange = {
    from: Scalars["Int"]["input"];
    to: Scalars["Int"]["input"];
};

export type CompassScorecardAppliedToComponentsScoreRangeFilter = {
    in: Array<CompassScorecardAppliedToComponentsScoreRange>;
};

export type CompassScorecardAppliedToComponentsThresholdFilter = {
    lt: Scalars["Int"]["input"];
};

export type CompassScorecardAppliedToComponentsTypesFilter = {
    /** The types of components to filter on, for example SERVICE. */
    in: Array<Scalars["ID"]["input"]>;
};

export type CompassScorecardAutomaticApplicationModel =
    CompassScorecardApplicationModel & {
        __typename?: "CompassScorecardAutomaticApplicationModel";
        /**
         * The application type for the scorecard.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        applicationType: Scalars["String"]["output"];
        /**
         * Component creation time used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'componentCreationTimeFilter' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        componentCreationTimeFilter?: Maybe<CompassComponentCreationTimeFilter>;
        /**
         * Component custom field filters used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'componentCustomFieldFilters' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        componentCustomFieldFilters?: Maybe<Array<CompassCustomFieldFilter>>;
        /**
         * A collection of component labels used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentLabels?: Maybe<Array<CompassComponentLabel>>;
        /**
         * A collection of component lifecycle stages used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'componentLifecycleStages' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        componentLifecycleStages?: Maybe<CompassLifecycleFilter>;
        /**
         * A collection of component owners used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentOwnerIds?: Maybe<Array<Scalars["ID"]["output"]>>;
        /**
         * A collection of component tiers used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTiers?: Maybe<Array<CompassComponentTier>>;
        /**
         * A collection of component types used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentTypeIds: Array<Scalars["ID"]["output"]>;
        /**
         * Component repository link value used to filter what components the scorecard applies to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'repositoryValues' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        repositoryValues?: Maybe<CompassRepositoryValue>;
    };

export type CompassScorecardConnection = {
    __typename?: "CompassScorecardConnection";
    edges?: Maybe<Array<CompassScorecardEdge>>;
    nodes?: Maybe<Array<CompassScorecard>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The configuration for a scorecard criterion that can be shared across components. */
export type CompassScorecardCriteria = {
    /**
     * The optional, user provided description of the scorecard criterion
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'description' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the scorecard criterion. */
    id: Scalars["ID"]["output"];
    /** The optional, user provided name of the scorecard criterion */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Returns the calculated score for a component. */
    scorecardCriteriaScore?: Maybe<CompassScorecardCriteriaScore>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'scoringStrategyRules' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scoringStrategyRules?: Maybe<CompassScorecardCriteriaScoringStrategyRules>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["output"];
};

/** The configuration for a scorecard criterion that can be shared across components. */
export type CompassScorecardCriteriaScorecardCriteriaScoreArgs = {
    query?: InputMaybe<CompassScorecardCriteriaScoreQuery>;
};

/** Contains the calculated score for each scorecard criteria that is associated with a specific component. */
export type CompassScorecardCriteriaScore = {
    __typename?: "CompassScorecardCriteriaScore";
    /** The timestamp of when the criteria value was last updated. */
    dataSourceLastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Description of whether the criterion passed or failed, and explanation for the failure condition. */
    explanation?: Maybe<Scalars["String"]["output"]>;
    /** The maximum score value for the criterion. The value is used in calculating the aggregate score as a percentage. */
    maxScore: Scalars["Int"]["output"];
    /** The calculated score value for the criterion. */
    score: Scalars["Int"]["output"];
    /** The status of whether the score is passing, failing, or in an error state. */
    status?: Maybe<Scalars["String"]["output"]>;
    /**
     * Scoring strategy used when calculating the score and max score.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'type' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Historical criteria scores. */
export type CompassScorecardCriteriaScoreHistory = {
    __typename?: "CompassScorecardCriteriaScoreHistory";
    /** Individual scorecard criteria scores. */
    criteriaScores?: Maybe<Array<CompassScorecardCriterionScore>>;
    /** The time the criteria score was recorded. */
    date: Scalars["DateTime"]["output"];
};

export type CompassScorecardCriteriaScoreHistoryConnection = {
    __typename?: "CompassScorecardCriteriaScoreHistoryConnection";
    edges?: Maybe<Array<CompassScorecardCriteriaScoreHistoryEdge>>;
    nodes?: Maybe<Array<CompassScorecardCriteriaScoreHistory>>;
    pageInfo: PageInfo;
};

export type CompassScorecardCriteriaScoreHistoryEdge = {
    __typename?: "CompassScorecardCriteriaScoreHistoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecardCriteriaScoreHistory>;
};

/** Specifies the periodicity (regular repetition at fixed intervals) of the criteria score history data. */
export enum CompassScorecardCriteriaScoreHistoryPeriodicity {
    Daily = "DAILY",
    Weekly = "WEEKLY"
}

/** Accepts input for querying criteria score history. */
export type CompassScorecardCriteriaScoreHistoryQuery = {
    /** A filter which refines the criteria score history query. */
    filter?: InputMaybe<CompassScorecardCriteriaScoreHistoryQueryFilter>;
};

/** Accepts input for filtering when querying criteria score history. */
export type CompassScorecardCriteriaScoreHistoryQueryFilter = {
    /** The periodicity (regular repetition at fixed intervals) of the criteria score history data. */
    periodicity?: InputMaybe<CompassScorecardCriteriaScoreHistoryPeriodicity>;
    /** The date (midnight UTC) which the queried criteria score history data will start, which cannot be in the future. */
    startFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CompassScorecardCriteriaScoreQuery = {
    /** The unique identifier (ID) of the component. */
    componentId: Scalars["ID"]["input"];
};

/** Represents a historical breakdown of scorecard criteria score. */
export type CompassScorecardCriteriaScoreStatisticsHistory = {
    __typename?: "CompassScorecardCriteriaScoreStatisticsHistory";
    /** The criteria score statistics for the scorecard. */
    criteriaStatistics?: Maybe<Array<CompassScorecardCriterionScoreStatistic>>;
    /** The date the statistical data was recorded. */
    date: Scalars["DateTime"]["output"];
    /** The number of components with a status for any criterion for the given date. */
    totalCount: Scalars["Int"]["output"];
};

export type CompassScorecardCriteriaScoreStatisticsHistoryConnection = {
    __typename?: "CompassScorecardCriteriaScoreStatisticsHistoryConnection";
    edges?: Maybe<Array<CompassScorecardCriteriaScoreStatisticsHistoryEdge>>;
    nodes?: Maybe<Array<CompassScorecardCriteriaScoreStatisticsHistory>>;
    pageInfo: PageInfo;
};

export type CompassScorecardCriteriaScoreStatisticsHistoryEdge = {
    __typename?: "CompassScorecardCriteriaScoreStatisticsHistoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecardCriteriaScoreStatisticsHistory>;
};

export type CompassScorecardCriteriaScoreStatisticsHistoryQuery = {
    filter?: InputMaybe<CompassScorecardCriteriaScoreStatisticsHistoryQueryFilter>;
};

/** Accepts input to filter the scorecard criteria statistics history. */
export type CompassScorecardCriteriaScoreStatisticsHistoryQueryFilter = {
    /** The types of components to filter by. */
    componentTypes?: InputMaybe<CompassScoreStatisticsHistoryComponentTypesFilter>;
    /** The date at which to start filtering. */
    date?: InputMaybe<CompassScoreStatisticsHistoryDateFilter>;
    /** The team owners to filter by. */
    owners?: InputMaybe<CompassScoreStatisticsHistoryOwnersFilter>;
};

export enum CompassScorecardCriteriaScoringStrategyRuleAction {
    MarkAsError = "MARK_AS_ERROR",
    MarkAsFailed = "MARK_AS_FAILED",
    MarkAsPassed = "MARK_AS_PASSED",
    MarkAsSkipped = "MARK_AS_SKIPPED"
}

export type CompassScorecardCriteriaScoringStrategyRules = {
    __typename?: "CompassScorecardCriteriaScoringStrategyRules";
    onError?: Maybe<Scalars["String"]["output"]>;
    onFalse?: Maybe<Scalars["String"]["output"]>;
    onTrue?: Maybe<Scalars["String"]["output"]>;
};

export type CompassScorecardCriterionExpression =
    | CompassScorecardCriterionExpressionBoolean
    | CompassScorecardCriterionExpressionCollection
    | CompassScorecardCriterionExpressionMembership
    | CompassScorecardCriterionExpressionNumber
    | CompassScorecardCriterionExpressionText;

export type CompassScorecardCriterionExpressionAndGroup = {
    __typename?: "CompassScorecardCriterionExpressionAndGroup";
    and?: Maybe<Array<CompassScorecardCriterionExpressionGroup>>;
};

export type CompassScorecardCriterionExpressionBoolean = {
    __typename?: "CompassScorecardCriterionExpressionBoolean";
    booleanComparator?: Maybe<Scalars["String"]["output"]>;
    booleanComparatorValue?: Maybe<Scalars["Boolean"]["output"]>;
    requirement?: Maybe<CompassScorecardCriterionExpressionRequirement>;
};

export enum CompassScorecardCriterionExpressionBooleanComparatorOptions {
    EqualTo = "EQUAL_TO",
    NotEqualTo = "NOT_EQUAL_TO"
}

export type CompassScorecardCriterionExpressionCapability = {
    __typename?: "CompassScorecardCriterionExpressionCapability";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFields?: Maybe<
        Array<CompassScorecardCriterionExpressionCapabilityCustomField>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    defaultFields?: Maybe<
        Array<CompassScorecardCriterionExpressionCapabilityDefaultField>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    metrics?: Maybe<Array<CompassScorecardCriterionExpressionCapabilityMetric>>;
};

export type CompassScorecardCriterionExpressionCapabilityCustomField = {
    __typename?: "CompassScorecardCriterionExpressionCapabilityCustomField";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
};

export type CompassScorecardCriterionExpressionCapabilityDefaultField = {
    __typename?: "CompassScorecardCriterionExpressionCapabilityDefaultField";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fieldName?: Maybe<Scalars["String"]["output"]>;
};

export type CompassScorecardCriterionExpressionCapabilityMetric = {
    __typename?: "CompassScorecardCriterionExpressionCapabilityMetric";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    metricDefinitionId?: Maybe<Scalars["ID"]["output"]>;
};

export type CompassScorecardCriterionExpressionCollection = {
    __typename?: "CompassScorecardCriterionExpressionCollection";
    collectionComparator?: Maybe<Scalars["String"]["output"]>;
    collectionComparatorValue?: Maybe<Array<Scalars["String"]["output"]>>;
    requirement?: Maybe<CompassScorecardCriterionExpressionRequirement>;
};

export enum CompassScorecardCriterionExpressionCollectionComparatorOptions {
    AllOf = "ALL_OF",
    AnyOf = "ANY_OF",
    NoneOf = "NONE_OF"
}

export type CompassScorecardCriterionExpressionEvaluable = {
    __typename?: "CompassScorecardCriterionExpressionEvaluable";
    expression?: Maybe<CompassScorecardCriterionExpression>;
};

export enum CompassScorecardCriterionExpressionEvaluationRuleAction {
    Continue = "CONTINUE",
    ReturnError = "RETURN_ERROR",
    ReturnFailed = "RETURN_FAILED",
    ReturnPassed = "RETURN_PASSED",
    ReturnSkipped = "RETURN_SKIPPED"
}

export type CompassScorecardCriterionExpressionEvaluationRules = {
    __typename?: "CompassScorecardCriterionExpressionEvaluationRules";
    onError?: Maybe<Scalars["String"]["output"]>;
    onFalse?: Maybe<Scalars["String"]["output"]>;
    onTrue?: Maybe<Scalars["String"]["output"]>;
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassScorecardCriterionExpressionGroup =
    | CompassScorecardCriterionExpressionAndGroup
    | CompassScorecardCriterionExpressionEvaluable
    | CompassScorecardCriterionExpressionOrGroup;

export type CompassScorecardCriterionExpressionMembership = {
    __typename?: "CompassScorecardCriterionExpressionMembership";
    membershipComparator?: Maybe<Scalars["String"]["output"]>;
    membershipComparatorValue?: Maybe<Array<Scalars["String"]["output"]>>;
    requirement?: Maybe<CompassScorecardCriterionExpressionRequirement>;
};

export enum CompassScorecardCriterionExpressionMembershipComparatorOptions {
    In = "IN",
    NotIn = "NOT_IN"
}

export type CompassScorecardCriterionExpressionNumber = {
    __typename?: "CompassScorecardCriterionExpressionNumber";
    numberComparator?: Maybe<Scalars["String"]["output"]>;
    numberComparatorValue?: Maybe<Scalars["Float"]["output"]>;
    requirement?: Maybe<CompassScorecardCriterionExpressionRequirement>;
};

export enum CompassScorecardCriterionExpressionNumberComparatorOptions {
    EqualTo = "EQUAL_TO",
    GreaterThan = "GREATER_THAN",
    GreaterThanOrEqualTo = "GREATER_THAN_OR_EQUAL_TO",
    LessThan = "LESS_THAN",
    LessThanOrEqualTo = "LESS_THAN_OR_EQUAL_TO",
    NotEqualTo = "NOT_EQUAL_TO"
}

export type CompassScorecardCriterionExpressionOrGroup = {
    __typename?: "CompassScorecardCriterionExpressionOrGroup";
    or?: Maybe<Array<CompassScorecardCriterionExpressionGroup>>;
};

export type CompassScorecardCriterionExpressionRequirement =
    | CompassScorecardCriterionExpressionRequirementCustomField
    | CompassScorecardCriterionExpressionRequirementDefaultField
    | CompassScorecardCriterionExpressionRequirementMetric
    | CompassScorecardCriterionExpressionRequirementScorecard;

export type CompassScorecardCriterionExpressionRequirementCustomField = {
    __typename?: "CompassScorecardCriterionExpressionRequirementCustomField";
    customFieldDefinitionId?: Maybe<Scalars["ID"]["output"]>;
};

export type CompassScorecardCriterionExpressionRequirementDefaultField = {
    __typename?: "CompassScorecardCriterionExpressionRequirementDefaultField";
    fieldName?: Maybe<Scalars["String"]["output"]>;
};

export type CompassScorecardCriterionExpressionRequirementMetric = {
    __typename?: "CompassScorecardCriterionExpressionRequirementMetric";
    metricDefinitionId?: Maybe<Scalars["ID"]["output"]>;
};

export type CompassScorecardCriterionExpressionRequirementScorecard = {
    __typename?: "CompassScorecardCriterionExpressionRequirementScorecard";
    fieldName?: Maybe<Scalars["String"]["output"]>;
    scorecardId?: Maybe<Scalars["ID"]["output"]>;
};

export type CompassScorecardCriterionExpressionText = {
    __typename?: "CompassScorecardCriterionExpressionText";
    requirement?: Maybe<CompassScorecardCriterionExpressionRequirement>;
    textComparator?: Maybe<Scalars["String"]["output"]>;
    textComparatorValue?: Maybe<Scalars["String"]["output"]>;
};

/** Create/Update Inputs */
export enum CompassScorecardCriterionExpressionTextComparatorOptions {
    EqualTo = "EQUAL_TO",
    NotEqualTo = "NOT_EQUAL_TO",
    Regex = "REGEX"
}

export type CompassScorecardCriterionExpressionTree = {
    __typename?: "CompassScorecardCriterionExpressionTree";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    evaluationRules?: Maybe<CompassScorecardCriterionExpressionEvaluationRules>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    root?: Maybe<CompassScorecardCriterionExpressionGroup>;
};

export type CompassScorecardCriterionScore = {
    /**
     * The scorecard criterion unique identifier (ID).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    criterionId: Scalars["ID"]["output"];
    /**
     * The explanation for the score.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    explanation: Scalars["String"]["output"];
    /**
     * The score status of the scorecard criterion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scoreStatus: CompassScorecardCriterionScoreStatus;
};

/** Represents a statistical breakdown of scorecard criteria. */
export type CompassScorecardCriterionScoreStatistic = {
    __typename?: "CompassScorecardCriterionScoreStatistic";
    /** The scorecard criterion unique identifier (ID). */
    criterionId: Scalars["ID"]["output"];
    /** The score status statistics for the scorecard criterion. */
    scoreStatusStatistics?: Maybe<
        Array<CompassScorecardCriterionScoreStatusStatistic>
    >;
    /** The number of components with this criterion scored for the given date. */
    totalCount: Scalars["Int"]["output"];
};

export type CompassScorecardCriterionScoreStatus = {
    __typename?: "CompassScorecardCriterionScoreStatus";
    /** The name of the score status, e.g. PASSING. */
    name: Scalars["String"]["output"];
};

/** Represents a count of components with the given score status for a scorecard criterion. */
export type CompassScorecardCriterionScoreStatusStatistic = {
    __typename?: "CompassScorecardCriterionScoreStatusStatistic";
    /** The count of components. */
    count: Scalars["Int"]["output"];
    /** The score status of the scorecard criterion. */
    scoreStatus: CompassScorecardCriterionScoreStatus;
};

export type CompassScorecardDeactivatedComponentsConnection = {
    __typename?: "CompassScorecardDeactivatedComponentsConnection";
    edges?: Maybe<Array<CompassScorecardDeactivatedComponentsEdge>>;
    nodes?: Maybe<Array<CompassComponent>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassScorecardDeactivatedComponentsEdge = {
    __typename?: "CompassScorecardDeactivatedComponentsEdge";
    /** The active Compass Scorecard Jira issues linked to this deactivated component scorecard relationship. */
    activeIssues?: Maybe<CompassComponentScorecardJiraIssuesQueryResult>;
    cursor: Scalars["String"]["output"];
    deactivatedBy?: Maybe<User>;
    deactivatedOn?: Maybe<Scalars["DateTime"]["output"]>;
    lastScorecardScore?: Maybe<Scalars["Int"]["output"]>;
    node?: Maybe<CompassComponent>;
};

export type CompassScorecardDeactivatedComponentsEdgeActiveIssuesArgs = {
    query?: InputMaybe<CompassComponentScorecardJiraIssuesQuery>;
};

/** COMPASS SCORECARD DEACTIVATION TYPES */
export type CompassScorecardDeactivatedComponentsQuery = {
    filter?: InputMaybe<CompassScorecardDeactivatedComponentsQueryFilter>;
    sort?: InputMaybe<CompassScorecardDeactivatedComponentsQuerySort>;
};

export type CompassScorecardDeactivatedComponentsQueryFilter = {
    fields?: InputMaybe<Array<CompassScorecardAppliedToComponentsFieldFilter>>;
    owners?: InputMaybe<CompassScorecardAppliedToComponentsOwnerFilter>;
    types?: InputMaybe<CompassScorecardAppliedToComponentsTypesFilter>;
};

/** Accepts input to sort the deactivated components by. */
export type CompassScorecardDeactivatedComponentsQuerySort = {
    /** The name of the field to sort by. */
    name: Scalars["String"]["input"];
    /** The order to sort the deactivated components by. */
    order: CompassScorecardQuerySortOrder;
};

export type CompassScorecardEdge = {
    __typename?: "CompassScorecardEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecard>;
};

export type CompassScorecardFieldCriterionScore =
    CompassScorecardCriterionScore & {
        __typename?: "CompassScorecardFieldCriterionScore";
        /**
         * The scorecard criterion unique identifier (ID).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        criterionId: Scalars["ID"]["output"];
        /**
         * The date and time when the source of the score was last updated.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        dataSourceLastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The explanation for the score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        explanation: Scalars["String"]["output"];
        /**
         * The score status of the scorecard criterion.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        scoreStatus: CompassScorecardCriterionScoreStatus;
    };

/** The types used to identify the importance of the scorecard. */
export enum CompassScorecardImportance {
    /** Recommended to the component's owner when they select a scorecard to apply to their component. */
    Recommended = "RECOMMENDED",
    /** Automatically applied to all components of the specified type or types and cannot be removed. */
    Required = "REQUIRED",
    /** Custom scorecard, focused on specific use cases within teams or departments. */
    UserDefined = "USER_DEFINED"
}

export type CompassScorecardInstancePermissions = {
    __typename?: "CompassScorecardInstancePermissions";
    /** Includes edits and deletes */
    canModify?: Maybe<CompassPermissionResult>;
};

export type CompassScorecardManualApplicationModel =
    CompassScorecardApplicationModel & {
        __typename?: "CompassScorecardManualApplicationModel";
        /**
         * The application type for the scorecard.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        applicationType: Scalars["String"]["output"];
    };

export type CompassScorecardMetricCriterionScore =
    CompassScorecardCriterionScore & {
        __typename?: "CompassScorecardMetricCriterionScore";
        /**
         * The scorecard criterion unique identifier (ID).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        criterionId: Scalars["ID"]["output"];
        /**
         * The explanation for the score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        explanation: Scalars["String"]["output"];
        /**
         * Metric value used when evaluating this criterion score.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        metricValue?: Maybe<CompassMetricValue>;
        /**
         * The score status of the scorecard criterion.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        scoreStatus: CompassScorecardCriterionScoreStatus;
    };

/** Accepts input to filter the scorecards by. */
export type CompassScorecardQueryFilter = {
    /** Filter by the collection of component types matching that of the scorecards. */
    componentTypeIds?: InputMaybe<CompassScorecardAppliedToComponentsTypesFilter>;
    /** Text input used to find matching scorecards by name. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Filter by the state of the scorecard. */
    state?: InputMaybe<Scalars["String"]["input"]>;
    /** Filter by the type of the scorecard. */
    type?: InputMaybe<CompassScorecardTypesFilter>;
};

/** Accepts input to sort the scorecards by. */
export type CompassScorecardQuerySort = {
    /** Sort by the specified field. Supports `NAME` for scorecard name and `COMPONENT_COUNT` for associated component count. */
    name: Scalars["String"]["input"];
    /** The order to sort the scorecards by. */
    order: CompassScorecardQuerySortOrder;
};

/** Sort scorecards in ascending or descending order of specified field. */
export enum CompassScorecardQuerySortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type CompassScorecardResult = CompassScorecard | QueryError;

/** Contains the calculated score for a component. Each component has one calculated score per scorecard. */
export type CompassScorecardScore = {
    __typename?: "CompassScorecardScore";
    /** Returns the scores for individual criterion. */
    criteriaScores?: Maybe<Array<CompassScorecardCriteriaScore>>;
    /** The maximum possible total score value. */
    maxTotalScore: Scalars["Int"]["output"];
    /**
     * The point totals when using the point-based scoring strategy.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'points' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    points?: Maybe<CompassScorecardScorePoints>;
    /**
     * Returns status of scorecard based on score and threshold config
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'status' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    status?: Maybe<CompassScorecardScoreStatus>;
    /** Returns the date time the current status was updated. */
    statusDuration?: Maybe<CompassScorecardScoreStatusDuration>;
    /** The total calculated score value. */
    totalScore: Scalars["Int"]["output"];
    /**
     * Scoring strategy used when calculating the total score and max total score.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'type' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

export type CompassScorecardScoreDurationRange = {
    __typename?: "CompassScorecardScoreDurationRange";
    /** Inclusive lower bound in days for a score duration range. */
    lowerBound: Scalars["Int"]["output"];
    /** Inclusive upper bound in days for a score duration range where a null value indicates unbounded. */
    upperBound?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassScorecardScoreDurationStatistic = {
    __typename?: "CompassScorecardScoreDurationStatistic";
    /** Range in days. */
    durationRange: CompassScorecardScoreDurationRange;
    /** The score statistics for the scorecard. */
    statistics?: Maybe<Array<CompassScorecardScoreStatistic>>;
    /** The total count of components where the status has remained unchanged within the duration range. */
    totalCount: Scalars["Int"]["output"];
};

export type CompassScorecardScoreDurationStatistics = {
    __typename?: "CompassScorecardScoreDurationStatistics";
    /** The score duration statistics for the scorecard. */
    durationStatistics?: Maybe<Array<CompassScorecardScoreDurationStatistic>>;
};

export type CompassScorecardScoreDurationStatisticsQuery = {
    filter?: InputMaybe<CompassScorecardScoreDurationStatisticsQueryFilter>;
};

/** Accepts input to filter the scorecard score durations statistics. */
export type CompassScorecardScoreDurationStatisticsQueryFilter = {
    /** The types of components to filter by. */
    componentTypes?: InputMaybe<CompassScoreStatisticsHistoryComponentTypesFilter>;
    /** The team owners to filter by. */
    owners?: InputMaybe<CompassScoreStatisticsHistoryOwnersFilter>;
};

export type CompassScorecardScoreDurationStatisticsResult =
    | CompassScorecardScoreDurationStatistics
    | QueryError;

/** A historical scorecard score. */
export type CompassScorecardScoreHistory = {
    __typename?: "CompassScorecardScoreHistory";
    /** The time the scorecard score was recorded. */
    date: Scalars["DateTime"]["output"];
    /** The total combined score of the scorecard criteria scores. */
    totalScore?: Maybe<Scalars["Int"]["output"]>;
};

/** SCORE HISTORY */
export type CompassScorecardScoreHistoryConnection = {
    __typename?: "CompassScorecardScoreHistoryConnection";
    edges?: Maybe<Array<CompassScorecardScoreHistoryEdge>>;
    nodes?: Maybe<Array<CompassScorecardScoreHistory>>;
    pageInfo: PageInfo;
};

export type CompassScorecardScoreHistoryEdge = {
    __typename?: "CompassScorecardScoreHistoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecardScoreHistory>;
};

/** Specifies the periodicity (regular repetition at fixed intervals) of the scorecard score history data. */
export enum CompassScorecardScoreHistoryPeriodicity {
    Daily = "DAILY",
    Weekly = "WEEKLY"
}

/** Accepts input for querying scorecard score history. */
export type CompassScorecardScoreHistoryQuery = {
    /** A filter which refines the scorecard score history query. */
    filter?: InputMaybe<CompassScorecardScoreHistoryQueryFilter>;
};

/** Accepts input for filtering when querying scorecard score history. */
export type CompassScorecardScoreHistoryQueryFilter = {
    /** The periodicity (regular repetition at fixed intervals) of the scorecard score history data. */
    periodicity?: InputMaybe<CompassScorecardScoreHistoryPeriodicity>;
    /** The date (midnight UTC) which the queried scorecard score history data will start, which cannot be in the future. */
    startFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** The point total when using the point-based scoring strategy. */
export type CompassScorecardScorePoints = {
    __typename?: "CompassScorecardScorePoints";
    /** The maximum possible total point value. */
    maxTotalPoints?: Maybe<Scalars["Int"]["output"]>;
    /** The total calculated point value. */
    totalPoints?: Maybe<Scalars["Int"]["output"]>;
};

/** Scorecard score on a scorecard for a component. */
export type CompassScorecardScoreQuery = {
    /** The unique identifier (ID) of the component. */
    componentId: Scalars["ID"]["input"];
};

export type CompassScorecardScoreResult = CompassScorecardScore | QueryError;

/** Represents a count of components with the given score status for a scorecard. */
export type CompassScorecardScoreStatistic = {
    __typename?: "CompassScorecardScoreStatistic";
    /** The count of components. */
    count: Scalars["Int"]["output"];
    /** The score status of the scorecard. */
    scoreStatus: CompassScorecardScoreStatus;
};

/** Represents a historical breakdown of scorecard score. */
export type CompassScorecardScoreStatisticsHistory = {
    __typename?: "CompassScorecardScoreStatisticsHistory";
    /** The date the statistical data was recorded. */
    date: Scalars["DateTime"]["output"];
    /** The score statistics for the scorecard. */
    statistics?: Maybe<Array<CompassScorecardScoreStatistic>>;
    /** The total count of components with this scorecard applied. */
    totalCount: Scalars["Int"]["output"];
};

/** SCORE STATISTICS HISTORY */
export type CompassScorecardScoreStatisticsHistoryConnection = {
    __typename?: "CompassScorecardScoreStatisticsHistoryConnection";
    edges?: Maybe<Array<CompassScorecardScoreStatisticsHistoryEdge>>;
    nodes?: Maybe<Array<CompassScorecardScoreStatisticsHistory>>;
    pageInfo: PageInfo;
};

export type CompassScorecardScoreStatisticsHistoryEdge = {
    __typename?: "CompassScorecardScoreStatisticsHistoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassScorecardScoreStatisticsHistory>;
};

export type CompassScorecardScoreStatisticsHistoryQuery = {
    filter?: InputMaybe<CompassScorecardScoreStatisticsHistoryQueryFilter>;
};

/** Accepts input to filter the scorecard score statistics history. */
export type CompassScorecardScoreStatisticsHistoryQueryFilter = {
    /** The types of components to filter by. */
    componentTypes?: InputMaybe<CompassScoreStatisticsHistoryComponentTypesFilter>;
    /** The date at which to start filtering. */
    date?: InputMaybe<CompassScoreStatisticsHistoryDateFilter>;
    /** The team owners to filter by. */
    owners?: InputMaybe<CompassScoreStatisticsHistoryOwnersFilter>;
};

/** Represents a scorecard score status. */
export type CompassScorecardScoreStatus = {
    __typename?: "CompassScorecardScoreStatus";
    /** The lower bound score for the score status. */
    lowerBound: Scalars["Int"]["output"];
    /** The name of the score status, e.g. PASSING. */
    name: Scalars["String"]["output"];
    /** The upper bound score for the score status. */
    upperBound: Scalars["Int"]["output"];
};

export type CompassScorecardScoreStatusDuration = {
    __typename?: "CompassScorecardScoreStatusDuration";
    since: Scalars["DateTime"]["output"];
};

export enum CompassScorecardScoringStrategyType {
    PercentageBased = "PERCENTAGE_BASED",
    PointBased = "POINT_BASED",
    WeightBased = "WEIGHT_BASED"
}

export type CompassScorecardStatusConfig = {
    __typename?: "CompassScorecardStatusConfig";
    /** Threshold score for failing status */
    failing: CompassScorecardStatusThreshold;
    /** Threshold score for needs-attention status */
    needsAttention: CompassScorecardStatusThreshold;
    /** Threshold score for passing status */
    passing: CompassScorecardStatusThreshold;
};

export type CompassScorecardStatusConfigInput = {
    /** Input for threshold for a failing status. */
    failing: CompassScorecardStatusThresholdInput;
    /** Input for threshold for a needs-attention status. */
    needsAttention: CompassScorecardStatusThresholdInput;
    /** Input for threshold for a passing status. */
    passing: CompassScorecardStatusThresholdInput;
};

export type CompassScorecardStatusThreshold = {
    __typename?: "CompassScorecardStatusThreshold";
    /** Lower threshold value for particular status. */
    lowerBound: Scalars["Int"]["output"];
    /** Upper threshold value for particular status. */
    upperBound: Scalars["Int"]["output"];
};

export type CompassScorecardStatusThresholdInput = {
    /** Input for lower threshold value for particular status. */
    lowerBound: Scalars["Int"]["input"];
    /** Input for upper threshold value for particular status. */
    upperBound: Scalars["Int"]["input"];
};

export type CompassScorecardTypesFilter = {
    /** The types of scorecards to filter on, for example CUSTOM. */
    in: Array<Scalars["String"]["input"]>;
};

/** Accepts input to find available scorecards, optionally filtered and/or sorted. */
export type CompassScorecardsQuery = {
    /** Returns the scorecards after the specified cursor position. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Returns only scorecards whose attributes match those in the filters specified. */
    filter?: InputMaybe<CompassScorecardQueryFilter>;
    /** The first N number of scorecards to return in the query. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Returns scorecards according to the sorting scheme specified. */
    sort?: InputMaybe<CompassScorecardQuerySort>;
};

export type CompassScorecardsQueryResult =
    | CompassScorecardConnection
    | QueryError;

export type CompassSearchComponentConnection = {
    __typename?: "CompassSearchComponentConnection";
    edges?: Maybe<Array<CompassSearchComponentEdge>>;
    nodes?: Maybe<Array<CompassSearchComponentResult>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CompassSearchComponentEdge = {
    __typename?: "CompassSearchComponentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassSearchComponentResult>;
};

export type CompassSearchComponentLabelsConnection = {
    __typename?: "CompassSearchComponentLabelsConnection";
    edges?: Maybe<Array<CompassSearchComponentLabelsEdge>>;
    nodes?: Maybe<Array<CompassComponentLabel>>;
    pageInfo: PageInfo;
};

export type CompassSearchComponentLabelsEdge = {
    __typename?: "CompassSearchComponentLabelsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassComponentLabel>;
};

/** The query to find component labels within Compass. */
export type CompassSearchComponentLabelsQuery = {
    /** Returns results after the specified cursor. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Number of results to return in the query. The default is 25. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Text query to search against. */
    query?: InputMaybe<Scalars["String"]["input"]>;
    /** Sorting parameters for the results to be searched for. The default is by ranked results. */
    sort?: InputMaybe<Array<InputMaybe<CompassQuerySort>>>;
};

/** The query to find components. */
export type CompassSearchComponentQuery = {
    /** Returns results after the specified cursor. */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Filters on component fields to be searched against. */
    fieldFilters?: InputMaybe<Array<InputMaybe<CompassQueryFieldFilter>>>;
    /** Number of results to return in the query. The default is 25. */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Text query to search against. */
    query?: InputMaybe<Scalars["String"]["input"]>;
    /** How the query results will be sorted. This is essential for proper pagination of results. */
    sort?: InputMaybe<Array<InputMaybe<CompassQuerySort>>>;
};

export type CompassSearchComponentResult = {
    __typename?: "CompassSearchComponentResult";
    /**
     * The Compass component.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    component?: Maybe<CompassComponent>;
    /** Link to the component. Search UI can use this link to direct the user to the component page on click. */
    link: Scalars["URL"]["output"];
};

/** A connection that returns a paginated collection of team labels. */
export type CompassSearchTeamLabelsConnection = {
    __typename?: "CompassSearchTeamLabelsConnection";
    /** A list of edges which contain a team label and a cursor. */
    edges?: Maybe<Array<CompassSearchTeamLabelsEdge>>;
    /** A list of team labels. */
    nodes?: Maybe<Array<CompassTeamLabel>>;
    /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
    pageInfo: PageInfo;
};

export type CompassSearchTeamLabelsConnectionResult =
    | CompassSearchTeamLabelsConnection
    | QueryError;

/** An edge that contains a team label and a cursor. */
export type CompassSearchTeamLabelsEdge = {
    __typename?: "CompassSearchTeamLabelsEdge";
    /** The cursor of the team label. */
    cursor: Scalars["String"]["output"];
    /** The team label. */
    node?: Maybe<CompassTeamLabel>;
};

/** Accepts input for searching team labels. */
export type CompassSearchTeamLabelsInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
};

/** A connection that returns a paginated collection of teams */
export type CompassSearchTeamsConnection = {
    __typename?: "CompassSearchTeamsConnection";
    edges?: Maybe<Array<CompassSearchTeamsEdge>>;
    nodes?: Maybe<Array<CompassTeamData>>;
    pageInfo: PageInfo;
};

export type CompassSearchTeamsConnectionResult =
    | CompassSearchTeamsConnection
    | QueryError;

export type CompassSearchTeamsEdge = {
    __typename?: "CompassSearchTeamsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassTeamData>;
};

export type CompassSearchTeamsInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
    /** A list of possible labels to filter by. */
    labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The possible term to search teams by. */
    term?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassSetEntityPropertyInput = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

/** The payload returned from setting an Entity Property. */
export type CompassSetEntityPropertyPayload = Payload & {
    __typename?: "CompassSetEntityPropertyPayload";
    /**
     * The entity property that was set.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    entityProperty?: Maybe<CompassEntityProperty>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CompassSloMetricSourceConfigurationInput = {
    /** External configuration bad metrics query */
    badQuery: Scalars["String"]["input"];
    /** External configuration good metrics query */
    goodQuery: Scalars["String"]["input"];
};

export type CompassStarredComponentConnection = {
    __typename?: "CompassStarredComponentConnection";
    edges?: Maybe<Array<CompassStarredComponentEdge>>;
    nodes?: Maybe<Array<CompassComponent>>;
    pageInfo: PageInfo;
};

export type CompassStarredComponentEdge = {
    __typename?: "CompassStarredComponentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassComponent>;
};

export type CompassStarredComponentsResult =
    | CompassStarredComponentConnection
    | QueryError;

/** The details of a Pull request's timestamps. */
export type CompassStatusTimeStamps = {
    __typename?: "CompassStatusTimeStamps";
    /** The date and time when the PR was first reviewed. */
    firstReviewedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The date and time when the PR was last reviewed. */
    lastReviewedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The date and time when the PR was merged. */
    mergedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The date and time when the PR was rejected. */
    rejectedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CompassSynchronizeLinkAssociationsInput = {
    /** The cloud ID of the site to synchronize link associations on. */
    cloudId: Scalars["ID"]["input"];
    /** The ID of the Forge app to query for link association information */
    forgeAppId: Scalars["ID"]["input"];
    /** The parameters to synchronize link associations on. */
    options?: InputMaybe<CompassSynchronizeLinkAssociationsOptions>;
};

export type CompassSynchronizeLinkAssociationsOptions = {
    /** The event types to synchronize link associations on. */
    eventTypes?: InputMaybe<Array<InputMaybe<CompassEventType>>>;
};

export type CompassSynchronizeLinkAssociationsPayload = Payload & {
    __typename?: "CompassSynchronizeLinkAssociationsPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the job to synchronize link associations was successfully enqueued. */
    success: Scalars["Boolean"]["output"];
};

/** A team checkin communicates checkin for a team. */
export type CompassTeamCheckin = {
    __typename?: "CompassTeamCheckin";
    /** A list of actions that are part of the team checkin. */
    actions?: Maybe<Array<CompassTeamCheckinAction>>;
    /** Contains change metadata for the team checkin. */
    changeMetadata: CompassChangeMetadata;
    /** The ID of the team checkin. */
    id: Scalars["ID"]["output"];
    /** The mood of the team checkin. */
    mood?: Maybe<Scalars["Int"]["output"]>;
    /** The response to the question 1 of the team checkin. */
    response1?: Maybe<Scalars["String"]["output"]>;
    /** The response to the question 1 of the team checkin in a rich text format. */
    response1RichText?: Maybe<CompassRichTextObject>;
    /** The response to the question 2 of the team checkin. */
    response2?: Maybe<Scalars["String"]["output"]>;
    /** The response to the question 2 of the team checkin in a rich text format. */
    response2RichText?: Maybe<CompassRichTextObject>;
    /** The response to the question 3 of the team checkin. */
    response3?: Maybe<Scalars["String"]["output"]>;
    /** The response to the question 3 of the team checkin in a rich text format. */
    response3RichText?: Maybe<CompassRichTextObject>;
    /** The unique identifier (ID) of the team that did the checkin. */
    teamId?: Maybe<Scalars["ID"]["output"]>;
};

/** An action item of a team checkin. */
export type CompassTeamCheckinAction = {
    __typename?: "CompassTeamCheckinAction";
    /** The text of the team checkin action item. */
    actionText?: Maybe<Scalars["String"]["output"]>;
    /** Contains change metadata for the team checkin action item. */
    changeMetadata: CompassChangeMetadata;
    /** Whether the action item is completed or not. */
    completed?: Maybe<Scalars["Boolean"]["output"]>;
    /** The date and time when the action item got completed. */
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The user who completed this action item. */
    completedBy?: Maybe<User>;
    /** The unique identifier (ID) of the team checkin action item. */
    id: Scalars["ID"]["output"];
};

/** Accepts input for creating/updating/deleting team checkin's action item. */
export type CompassTeamCheckinActionInput = {
    create?: InputMaybe<CompassCreateTeamCheckinActionInput>;
    delete?: InputMaybe<CompassDeleteTeamCheckinActionInput>;
    update?: InputMaybe<CompassUpdateTeamCheckinActionInput>;
};

/** Accepts input for deleting a team checkin. */
export type CompassTeamCheckinsInput = {
    /** The cloud ID of the site to update a checkin on. */
    cloudId: Scalars["ID"]["input"];
    /** The unique identifier (ID) of the team that did the checkin. */
    teamId: Scalars["ID"]["input"];
};

/** The payload returned when querying for Compass-specific team data. */
export type CompassTeamData = {
    __typename?: "CompassTeamData";
    /** The current checkin of the team. */
    currentCheckin?: Maybe<CompassTeamCheckin>;
    /** A unique identifier (ID) of the team. */
    id: Scalars["ID"]["output"];
    /** A list of labels applied to the team within Compass. */
    labels?: Maybe<Array<CompassTeamLabel>>;
    /**
     * Fetch metric sources that belong to a team
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'metricSources' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    metricSources?: Maybe<CompassTeamMetricSourceConnection>;
    /**
     * Returns pull requests for a team.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "compass-beta")' query directive to the 'pullRequests' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    pullRequests?: Maybe<CompassPullRequestConnection>;
    /** A unique identifier (ID) of the team. */
    teamId?: Maybe<Scalars["ID"]["output"]>;
};

/** The payload returned when querying for Compass-specific team data. */
export type CompassTeamDataMetricSourcesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassMetricSourceQuery>;
};

/** The payload returned when querying for Compass-specific team data. */
export type CompassTeamDataPullRequestsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassPullRequestsQuery>;
};

/** Accepts input for viewing Compass-specific data about a team. */
export type CompassTeamDataInput = {
    /** The cloud ID of the target site. */
    cloudId: Scalars["ID"]["input"];
    /** The unique identifier (ID) of the target team. */
    teamId: Scalars["ID"]["input"];
};

export type CompassTeamDataResult = CompassTeamData | QueryError;

/** A label provides additional contextual information about a team. */
export type CompassTeamLabel = {
    __typename?: "CompassTeamLabel";
    name: Scalars["String"]["output"];
};

/** A metric source scoped to a Team */
export type CompassTeamMetricSource = CompassMetricSourceV2 & {
    __typename?: "CompassTeamMetricSource";
    externalMetricSourceId?: Maybe<Scalars["ID"]["output"]>;
    forgeAppId?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    metricDefinition?: Maybe<CompassMetricDefinition>;
    /** the team this metric instance belongs to */
    team?: Maybe<CompassTeamData>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    values?: Maybe<CompassMetricSourceValuesConnection>;
};

/** A metric source scoped to a Team */
export type CompassTeamMetricSourceValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<CompassMetricValuesQuery>;
};

export type CompassTeamMetricSourceConnection = {
    __typename?: "CompassTeamMetricSourceConnection";
    edges?: Maybe<Array<Maybe<CompassTeamMetricSourceEdge>>>;
    nodes?: Maybe<Array<Maybe<CompassTeamMetricSource>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type CompassTeamMetricSourceEdge = {
    __typename?: "CompassTeamMetricSourceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassTeamMetricSource>;
};

export type CompassUnsetEntityPropertyInput = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

/** The payload returned from unsetting an Entity Property. */
export type CompassUnsetEntityPropertyPayload = Payload & {
    __typename?: "CompassUnsetEntityPropertyPayload";
    /**
     * The entity property that was unset.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    entityProperty?: Maybe<CompassEntityProperty>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating a component announcement. */
export type CompassUpdateAnnouncementInput = {
    /** Whether the existing acknowledgements should be reset or not. */
    clearAcknowledgements?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The cloud ID of the site to update an announcement on. */
    cloudId: Scalars["ID"]["input"];
    /** The description of the announcement. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the announcement being updated. */
    id: Scalars["ID"]["input"];
    /** The date on which the changes in the announcement will take effect. */
    targetDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The title of the announcement. */
    title?: InputMaybe<Scalars["String"]["input"]>;
};

/** The payload returned after updating a component announcement. */
export type CompassUpdateAnnouncementPayload = Payload & {
    __typename?: "CompassUpdateAnnouncementPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated announcement. */
    updatedAnnouncement?: Maybe<CompassAnnouncement>;
};

export type CompassUpdateCampaignInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    dueDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    status?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassUpdateCampaignPayload = Payload & {
    __typename?: "CompassUpdateCampaignPayload";
    campaignDetails?: Maybe<CompassCampaign>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating a Component Scorecard Jira issue. */
export type CompassUpdateComponentScorecardJiraIssueInput = {
    /** The ID of the component. */
    componentId: Scalars["ID"]["input"];
    /** Whether a Component scorecard issue is active or not. */
    isActive: Scalars["Boolean"]["input"];
    /** The ID of the Jira issue. */
    issueId: Scalars["ID"]["input"];
    /** The ID of the scorecard. */
    scorecardId: Scalars["ID"]["input"];
};

/** The payload returned after updating a Compass Component Scorecard Jira issue. */
export type CompassUpdateComponentScorecardJiraIssuePayload = Payload & {
    __typename?: "CompassUpdateComponentScorecardJiraIssuePayload";
    /** A list of errors that occurred when trying to update the issue. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the issue was updated successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating a custom boolean field definition. */
export type CompassUpdateCustomBooleanFieldDefinitionInput = {
    /** The component types the custom boolean field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom boolean field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom boolean field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the custom boolean field definition. */
    id: Scalars["ID"]["input"];
    /** The name of the custom boolean field. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Accepts input for updating a custom field definition. You must provide exactly one of the fields in this input type. */
export type CompassUpdateCustomFieldDefinitionInput = {
    /** Input for updating a custom boolean field definition. */
    booleanFieldDefinition?: InputMaybe<CompassUpdateCustomBooleanFieldDefinitionInput>;
    /** Input for updating a custom multi-select field definition. */
    multiSelectFieldDefinition?: InputMaybe<CompassUpdateCustomMultiSelectFieldDefinitionInput>;
    /** Input for updating a custom number field definition. */
    numberFieldDefinition?: InputMaybe<CompassUpdateCustomNumberFieldDefinitionInput>;
    /** Input for updating a custom single-select field definition. */
    singleSelectFieldDefinition?: InputMaybe<CompassUpdateCustomSingleSelectFieldDefinitionInput>;
    /** Input for updating a custom text field definition. */
    textFieldDefinition?: InputMaybe<CompassUpdateCustomTextFieldDefinitionInput>;
    /** Input for updating a custom user field definition. */
    userFieldDefinition?: InputMaybe<CompassUpdateCustomUserFieldDefinitionInput>;
};

/** The payload returned from updating a custom field definition. */
export type CompassUpdateCustomFieldDefinitionPayload = Payload & {
    __typename?: "CompassUpdateCustomFieldDefinitionPayload";
    /** The updated custom field definition. */
    customFieldDefinition?: Maybe<CompassCustomFieldDefinition>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating a custom multi select field definition. */
export type CompassUpdateCustomMultiSelectFieldDefinitionInput = {
    /** The component types the custom multi-select field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** A list of options to create. */
    createOptions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A list of options to delete. */
    deleteOptions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The description of the custom multi-select field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the custom multi-select field definition. */
    id: Scalars["ID"]["input"];
    /** The name of the custom multi-select field. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Accepts input for updating a custom number field definition. */
export type CompassUpdateCustomNumberFieldDefinitionInput = {
    /** The component types the custom number field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom number field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom number field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the custom number field definition. */
    id: Scalars["ID"]["input"];
    /** The name of the custom number field. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassUpdateCustomPermissionConfigsInput = {
    preset?: InputMaybe<CompassCustomPermissionPreset>;
};

/** Accepts input for updating a custom single select field definition. */
export type CompassUpdateCustomSingleSelectFieldDefinitionInput = {
    /** The component types the custom single-select field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** A list of options to create. */
    createOptions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A list of options to delete. */
    deleteOptions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The description of the custom single-select field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the custom single-select field definition. */
    id: Scalars["ID"]["input"];
    /** The name of the custom single-select field. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Accepts input for updating a custom text field definition. */
export type CompassUpdateCustomTextFieldDefinitionInput = {
    /** The component types the custom text field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom text field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom text field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the custom text field definition. */
    id: Scalars["ID"]["input"];
    /** The name of the custom text field. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Accepts input for updating a custom user field definition. */
export type CompassUpdateCustomUserFieldDefinitionInput = {
    /** The component types the custom user field applies to. */
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The component types the custom user field applies to. */
    componentTypes?: InputMaybe<Array<CompassComponentType>>;
    /** The description of the custom user field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the custom user field definition. */
    id: Scalars["ID"]["input"];
    /** The name of the custom user field. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type CompassUpdateDocumentInput = {
    /** The ID of the documentation category the document was added to. */
    documentationCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ARI of the document to update. */
    id: Scalars["ID"]["input"];
    /** The (optional) display title of the document. */
    title?: InputMaybe<Scalars["String"]["input"]>;
    /** The URL of the document. */
    url?: InputMaybe<Scalars["URL"]["input"]>;
};

export type CompassUpdateDocumentPayload = Payload & {
    __typename?: "CompassUpdateDocumentPayload";
    /**
     * The updated document
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    documentDetails?: Maybe<CompassDocument>;
    /** A list of errors that occurred during document update. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the document was updated successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Update Inputs */
export type CompassUpdateDynamicScorecardCriteriaInput = {
    expressions?: InputMaybe<
        Array<CompassUpdateScorecardCriterionExpressionTreeInput>
    >;
    id: Scalars["ID"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a scorecard criterion checking the value of a specified custom boolean field. */
export type CompassUpdateHasCustomBooleanFieldScorecardCriteriaInput = {
    /** The comparison operation to be performed. */
    booleanComparator?: InputMaybe<CompassCriteriaBooleanComparatorOptions>;
    /** The value that the field is compared to. */
    booleanComparatorValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The ID of the component custom boolean field to check the value of. */
    customFieldDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassUpdateHasCustomMultiSelectFieldScorecardCriteriaInput = {
    /** The comparison operation to be performed between the field and comparator value. */
    collectionComparator?: InputMaybe<CompassCriteriaCollectionComparatorOptions>;
    /** The list of multi select options that the field is compared to. */
    collectionComparatorValue?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The ID of the component custom multi select field to check the value of. */
    customFieldDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a scorecard criterion checking the value of a specified custom number field. */
export type CompassUpdateHasCustomNumberFieldScorecardCriteriaInput = {
    /** The ID of the component custom number field to check the value of. */
    customFieldDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The comparison operation to be performed between the field and comparator value. */
    numberComparator?: InputMaybe<CompassCriteriaNumberComparatorOptions>;
    /** The threshold value that the field is compared to. */
    numberComparatorValue?: InputMaybe<Scalars["Float"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassUpdateHasCustomSingleSelectFieldScorecardCriteriaInput = {
    /** The ID of the component custom single select field to check the value of. */
    customFieldDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The comparison operation to be performed between the field and comparator value. */
    membershipComparator?: InputMaybe<CompassCriteriaMembershipComparatorOptions>;
    /** The list of single select options that the field is compared to. */
    membershipComparatorValue?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a scorecard criterion checking the value of a specified custom text field. */
export type CompassUpdateHasCustomTextFieldScorecardCriteriaInput = {
    /** The ID of the component custom text field to check the value of. */
    customFieldDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The comparison operation to be performed. */
    textComparator?: InputMaybe<CompassCriteriaTextComparatorOptions>;
    /** The value that the field is compared to. */
    textComparatorValue?: InputMaybe<Scalars["String"]["input"]>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassUpdateJqlMetricSourceUserInput = {
    metricSourceId: Scalars["ID"]["input"];
};

export type CompassUpdateJqlMetricSourceUserPayload = Payload & {
    __typename?: "CompassUpdateJQLMetricSourceUserPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedMetricSource?: Maybe<CompassMetricSource>;
};

/** The input to update a metric definition. */
export type CompassUpdateMetricDefinitionInput = {
    /** The cloud ID of the built in metric definition being updated */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The configuration of the metric definition. */
    configuration?: InputMaybe<CompassMetricDefinitionConfigurationInput>;
    /** The updated description of the metric definition. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The updated format option of the metric definition. */
    format?: InputMaybe<CompassMetricDefinitionFormatInput>;
    /** The ID of the metric definition being updated. */
    id: Scalars["ID"]["input"];
    isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The updated name of the metric definition. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The payload returned from updating a metric definition. */
export type CompassUpdateMetricDefinitionPayload = Payload & {
    __typename?: "CompassUpdateMetricDefinitionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated metric definition. */
    updatedMetricDefinition?: Maybe<CompassMetricDefinition>;
};

/** The input for updating a metric source. */
export type CompassUpdateMetricSourceInput = {
    /** The configuration input used to update the metric source. */
    configuration?: InputMaybe<CompassMetricSourceConfigurationInput>;
    /** The metric source ID. */
    id: Scalars["ID"]["input"];
};

export type CompassUpdateMetricSourcePayload = Payload & {
    __typename?: "CompassUpdateMetricSourcePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedMetricSource?: Maybe<CompassMetricSource>;
};

/** The payload returned after updating the custom permission configs. */
export type CompassUpdatePermissionConfigsPayload = Payload & {
    __typename?: "CompassUpdatePermissionConfigsPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated custom permission configs. */
    updatedCustomPermissionConfigs?: Maybe<CompassCustomPermissionConfigs>;
};

export type CompassUpdateScorecardCriteriaScoringStrategyRulesInput = {
    onError?: InputMaybe<CompassScorecardCriteriaScoringStrategyRuleAction>;
    onFalse?: InputMaybe<CompassScorecardCriteriaScoringStrategyRuleAction>;
    onTrue?: InputMaybe<CompassScorecardCriteriaScoringStrategyRuleAction>;
};

export type CompassUpdateScorecardCriterionExpressionAndGroupInput = {
    expressions: Array<CompassUpdateScorecardCriterionExpressionGroupInput>;
};

export type CompassUpdateScorecardCriterionExpressionBooleanInput = {
    booleanComparator: CompassScorecardCriterionExpressionBooleanComparatorOptions;
    booleanComparatorValue: Scalars["Boolean"]["input"];
    requirement: CompassUpdateScorecardCriterionExpressionRequirementInput;
};

export type CompassUpdateScorecardCriterionExpressionCollectionInput = {
    collectionComparator: CompassScorecardCriterionExpressionCollectionComparatorOptions;
    collectionComparatorValue: Array<Scalars["ID"]["input"]>;
    requirement: CompassUpdateScorecardCriterionExpressionRequirementInput;
};

export type CompassUpdateScorecardCriterionExpressionEvaluableInput = {
    expression: CompassUpdateScorecardCriterionExpressionInput;
};

export type CompassUpdateScorecardCriterionExpressionEvaluationRulesInput = {
    onError?: InputMaybe<CompassScorecardCriterionExpressionEvaluationRuleAction>;
    onFalse?: InputMaybe<CompassScorecardCriterionExpressionEvaluationRuleAction>;
    onTrue?: InputMaybe<CompassScorecardCriterionExpressionEvaluationRuleAction>;
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CompassUpdateScorecardCriterionExpressionGroupInput = {
    and?: InputMaybe<CompassUpdateScorecardCriterionExpressionAndGroupInput>;
    evaluable?: InputMaybe<CompassUpdateScorecardCriterionExpressionEvaluableInput>;
    or?: InputMaybe<CompassUpdateScorecardCriterionExpressionOrGroupInput>;
};

export type CompassUpdateScorecardCriterionExpressionInput = {
    boolean?: InputMaybe<CompassUpdateScorecardCriterionExpressionBooleanInput>;
    collection?: InputMaybe<CompassUpdateScorecardCriterionExpressionCollectionInput>;
    membership?: InputMaybe<CompassUpdateScorecardCriterionExpressionMembershipInput>;
    number?: InputMaybe<CompassUpdateScorecardCriterionExpressionNumberInput>;
    text?: InputMaybe<CompassUpdateScorecardCriterionExpressionTextInput>;
};

export type CompassUpdateScorecardCriterionExpressionMembershipInput = {
    membershipComparator: CompassScorecardCriterionExpressionMembershipComparatorOptions;
    membershipComparatorValue: Array<Scalars["ID"]["input"]>;
    requirement: CompassUpdateScorecardCriterionExpressionRequirementInput;
};

export type CompassUpdateScorecardCriterionExpressionNumberInput = {
    numberComparator: CompassScorecardCriterionExpressionNumberComparatorOptions;
    numberComparatorValue: Scalars["Float"]["input"];
    requirement: CompassUpdateScorecardCriterionExpressionRequirementInput;
};

export type CompassUpdateScorecardCriterionExpressionOrGroupInput = {
    expressions: Array<CompassUpdateScorecardCriterionExpressionGroupInput>;
};

export type CompassUpdateScorecardCriterionExpressionRequirementCustomFieldInput =
    {
        customFieldDefinitionId: Scalars["ID"]["input"];
    };

export type CompassUpdateScorecardCriterionExpressionRequirementDefaultFieldInput =
    {
        fieldName: Scalars["String"]["input"];
    };

export type CompassUpdateScorecardCriterionExpressionRequirementInput = {
    customField?: InputMaybe<CompassUpdateScorecardCriterionExpressionRequirementCustomFieldInput>;
    defaultField?: InputMaybe<CompassUpdateScorecardCriterionExpressionRequirementDefaultFieldInput>;
    metric?: InputMaybe<CompassUpdateScorecardCriterionExpressionRequirementMetricInput>;
};

export type CompassUpdateScorecardCriterionExpressionRequirementMetricInput = {
    metricDefinitionId: Scalars["ID"]["input"];
};

export type CompassUpdateScorecardCriterionExpressionRequirementScorecardInput =
    {
        fieldName: Scalars["String"]["input"];
        scorecardId: Scalars["ID"]["input"];
    };

export type CompassUpdateScorecardCriterionExpressionTextInput = {
    requirement: CompassUpdateScorecardCriterionExpressionRequirementInput;
    textComparator: CompassScorecardCriterionExpressionTextComparatorOptions;
    textComparatorValue: Scalars["String"]["input"];
};

export type CompassUpdateScorecardCriterionExpressionTreeInput = {
    evaluationRules?: InputMaybe<CompassUpdateScorecardCriterionExpressionEvaluationRulesInput>;
    root: CompassUpdateScorecardCriterionExpressionGroupInput;
};

/** Accepts input for updating a team checkin action. */
export type CompassUpdateTeamCheckinActionInput = {
    /** The text of the team checkin action item. */
    actionText?: InputMaybe<Scalars["String"]["input"]>;
    /** Whether the action is completed or not. */
    completed?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The ID of the team checkin action item. */
    id: Scalars["ID"]["input"];
};

/** Accepts input for updating a team checkin. */
export type CompassUpdateTeamCheckinInput = {
    /** A list of action items belong to the checkin. */
    actions?: InputMaybe<Array<CompassTeamCheckinActionInput>>;
    /** The cloud ID of the site to update a checkin on. */
    cloudId: Scalars["ID"]["input"];
    /** The ID of the team checkin being updated. */
    id: Scalars["ID"]["input"];
    /** The mood of the team checkin. */
    mood: Scalars["Int"]["input"];
    /** The response to the question 1 of the team checkin. */
    response1?: InputMaybe<Scalars["String"]["input"]>;
    /** The response to the question 1 of the team checkin in a rich text format. */
    response1RichText?: InputMaybe<CompassUpdateTeamCheckinResponseRichText>;
    /** The response to the question 2 of the team checkin. */
    response2?: InputMaybe<Scalars["String"]["input"]>;
    /** The response to the question 2 of the team checkin in a rich text format. */
    response2RichText?: InputMaybe<CompassUpdateTeamCheckinResponseRichText>;
    /** The response to the question 3 of the team checkin. */
    response3?: InputMaybe<Scalars["String"]["input"]>;
    /** The response to the question 3 of the team checkin in a rich text format. */
    response3RichText?: InputMaybe<CompassUpdateTeamCheckinResponseRichText>;
};

/** The payload returned after updating a team checkin. */
export type CompassUpdateTeamCheckinPayload = Payload & {
    __typename?: "CompassUpdateTeamCheckinPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** Details of the updated checkin. */
    updatedTeamCheckin?: Maybe<CompassTeamCheckin>;
};

/** Accepts input for updating team checkin responses with rich text. */
export type CompassUpdateTeamCheckinResponseRichText = {
    /** Input for a team checkin response in Atlassian Document Format. */
    adf?: InputMaybe<Scalars["String"]["input"]>;
};

/** Definition of a parameter that enables users to input data */
export type CompassUserDefinedParameter = {
    /**
     * The description of the parameter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The id of the parameter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The name of the parameter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
    /**
     * The type of the parameter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: Scalars["String"]["output"];
};

export type CompassUserDefinedParameters = {
    __typename?: "CompassUserDefinedParameters";
    /** The component id associated with the parameters. */
    componentId: Scalars["ID"]["output"];
    /** The parameters associated with the component. */
    parameters?: Maybe<Array<CompassUserDefinedParameter>>;
};

export type CompassUserDefinedParametersConnection = {
    __typename?: "CompassUserDefinedParametersConnection";
    edges?: Maybe<Array<CompassUserDefinedParametersEdge>>;
    nodes?: Maybe<Array<CompassUserDefinedParameter>>;
    pageInfo?: Maybe<PageInfo>;
};

export type CompassUserDefinedParametersEdge = {
    __typename?: "CompassUserDefinedParametersEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<CompassUserDefinedParameter>;
};

/** Viewer's subscription. */
export type CompassViewerSubscription = {
    __typename?: "CompassViewerSubscription";
    /** Whether current user is subscribed to a component. */
    subscribed: Scalars["Boolean"]["output"];
};

export type CompassVulnerabilityEvent = CompassEvent & {
    __typename?: "CompassVulnerabilityEvent";
    /**
     * The description of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The type of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: CompassEventType;
    /**
     * The last time this event was updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     * A number specifying the order of the update to the event. Must be incremented to save new events. Otherwise, the request will be ignored.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSequenceNumber: Scalars["Long"]["output"];
    /**
     * The URL of the event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The list of properties of the vulnerability event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    vulnerabilityProperties: CompassVulnerabilityEventProperties;
};

/** Compass Vulnerability Event */
export type CompassVulnerabilityEventProperties = {
    __typename?: "CompassVulnerabilityEventProperties";
    /**
     * The source or tool that discovered the vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    discoverySource?: Maybe<Scalars["String"]["output"]>;
    /**
     * The time when the vulnerability was discovered.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    discoveryTime?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The ID of the vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The time when the vulnerability was remediated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    remediationTime?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The CVSS score of the vulnerability (0-10).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    score?: Maybe<Scalars["Float"]["output"]>;
    /**
     * The severity of the vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    severity?: Maybe<CompassVulnerabilityEventSeverity>;
    /**
     * The state of the vulnerability. Supported values are: OPEN | REMEDIATED | DECLINED
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    state: Scalars["String"]["output"];
    /**
     * The time when the vulnerability started.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    vulnerabilityStartTime?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The target system or component that is vulnerable.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    vulnerableTarget?: Maybe<Scalars["String"]["output"]>;
};

/** The severity of a vulnerability */
export type CompassVulnerabilityEventSeverity = {
    __typename?: "CompassVulnerabilityEventSeverity";
    /**
     * The label to use for displaying the severity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /**
     * The severity level of the vulnerability. . Supported values are: LOW | MEDIUM | HIGH | CRITICAL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    level: Scalars["String"]["output"];
};

/** The severity of a vulnerability */
export type CompassVulnerabilityEventSeverityInput = {
    /** The label to use for displaying the severity */
    label?: InputMaybe<Scalars["String"]["input"]>;
    /** The severity level of the vulnerability */
    level: CompassVulnerabilityEventSeverityLevel;
};

export enum CompassVulnerabilityEventSeverityLevel {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM"
}

export enum CompassVulnerabilityEventState {
    Declined = "DECLINED",
    Open = "OPEN",
    Remediated = "REMEDIATED"
}

/** A webhook that is invoked after a component is created from a template. */
export type CompassWebhook = {
    __typename?: "CompassWebhook";
    /** The ID of the webhook. */
    id: Scalars["ID"]["output"];
    /** The url of the webhook. */
    url: Scalars["String"]["output"];
};

/** All Atlassian Cloud Products an app version is compatible with */
export type CompatibleAtlassianCloudProduct = CompatibleAtlassianProduct & {
    __typename?: "CompatibleAtlassianCloudProduct";
    /**
     * Atlassian product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    atlassianProduct?: Maybe<MarketplaceSupportedAtlassianProduct>;
    /**
     * Unique id for this Atlassian product in Marketplace system
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field `atlassianProduct.id`
     */
    id: Scalars["ID"]["output"];
    /**
     * Name of Atlassian product
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field `atlassianProduct.name`
     */
    name: Scalars["String"]["output"];
};

/** All Atlassian DataCenter Products an app version is compatible with */
export type CompatibleAtlassianDataCenterProduct =
    CompatibleAtlassianProduct & {
        __typename?: "CompatibleAtlassianDataCenterProduct";
        /**
         * Atlassian product
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        atlassianProduct?: Maybe<MarketplaceSupportedAtlassianProduct>;
        /**
         * Unique id for this Atlassian product in Marketplace system
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use field `atlassianProduct.id`
         */
        id: Scalars["ID"]["output"];
        /**
         * Maximum version number of Atlassian Product
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        maximumVersion: Scalars["String"]["output"];
        /**
         * Minimum version number of Atlassian Product
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        minimumVersion: Scalars["String"]["output"];
        /**
         * Name of Atlassian product
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use field `atlassianProduct.name`
         */
        name: Scalars["String"]["output"];
    };

/** All Atlassian Products an app version is compatible with */
export type CompatibleAtlassianProduct = {
    /** Atlassian product */
    atlassianProduct?: Maybe<MarketplaceSupportedAtlassianProduct>;
    /**
     * Unique id for this Atlassian product in Marketplace system
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use field `atlassianProduct.id`
     */
    id: Scalars["ID"]["output"];
    /**
     * Name of Atlassian product
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use field `atlassianProduct.name`
     */
    name: Scalars["String"]["output"];
};

/** All Atlassian Server Products an app version is compatible with */
export type CompatibleAtlassianServerProduct = CompatibleAtlassianProduct & {
    __typename?: "CompatibleAtlassianServerProduct";
    /**
     * Atlassian product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    atlassianProduct?: Maybe<MarketplaceSupportedAtlassianProduct>;
    /**
     * Unique id for this Atlassian product in Marketplace system
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field `atlassianProduct.id`
     */
    id: Scalars["ID"]["output"];
    /**
     * Maximum version number of Atlassian Product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    maximumVersion: Scalars["String"]["output"];
    /**
     * Minimum version number of Atlassian Product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    minimumVersion: Scalars["String"]["output"];
    /**
     * Name of Atlassian product
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field `atlassianProduct.name`
     */
    name: Scalars["String"]["output"];
};

/** Complete sprint */
export type CompleteSprintInput = {
    boardId: Scalars["ID"]["input"];
    incompleteCardsDestination: SoftwareCardsDestination;
    sprintId: Scalars["ID"]["input"];
};

export type CompleteSprintResponse = MutationResponse & {
    __typename?: "CompleteSprintResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type ComponentApiUpload = {
    __typename?: "ComponentApiUpload";
    specUrl: Scalars["String"]["output"];
    uploadId: Scalars["ID"]["output"];
};

/** Input for querying a component by one of it's unique identifiers. */
export type ComponentReferenceInput = {
    /** Input for querying a component by its ARI. */
    ari?: InputMaybe<Scalars["ID"]["input"]>;
    /** Input for querying a component by its slug. */
    slug?: InputMaybe<ComponentSlugReferenceInput>;
};

/** The component's identifier slug and cloud ID. */
export type ComponentSlugReferenceInput = {
    cloudId: Scalars["ID"]["input"];
    slug: Scalars["String"]["input"];
};

/** Event data corresponding to a dataManager updating a component. */
export type ComponentSyncEvent = {
    __typename?: "ComponentSyncEvent";
    /** Error messages explaining why the last sync event may have failed. */
    lastSyncErrors?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Status of the last sync event. */
    status: ComponentSyncEventStatus;
    /** Timestamp when the last sync event occurred. */
    time: Scalars["DateTime"]["output"];
};

/** Details on the result of the last component sync. */
export type ComponentSyncEventInput = {
    /** Error messages explaining why last sync event failed. */
    lastSyncErrors?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Status of the last sync event. */
    status: ComponentSyncEventStatus;
};

/** Status types of a data manager sync event. */
export enum ComponentSyncEventStatus {
    /** A Compass internal server issue prevented the sync from occurring. */
    ServerError = "SERVER_ERROR",
    /** The component updates were successfully synced to Compass. */
    Success = "SUCCESS",
    /** An issue with the calling app or user input prevented the component from syncing to Compass. */
    UserError = "USER_ERROR"
}

export type ConfigurePolarisRefreshInput = {
    autoRefreshTimeSeconds?: InputMaybe<Scalars["Int"]["input"]>;
    clearError?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** either an issue, an insight, or a snippet */
    disable?: InputMaybe<Scalars["Boolean"]["input"]>;
    project: Scalars["ID"]["input"];
    setError?: InputMaybe<PolarisRefreshError>;
    subject?: InputMaybe<Scalars["ID"]["input"]>;
    timeToLiveSeconds?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfigurePolarisRefreshPayload = Payload & {
    __typename?: "ConfigurePolarisRefreshPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceAdminAnnouncementBanner = {
    __typename?: "ConfluenceAdminAnnouncementBanner";
    /**
     * Appearance of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appearance: Scalars["String"]["output"];
    /**
     * Content of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Scalars["String"]["output"];
    /**
     * ARI of the announcement banner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Indicates whether the banner is dismissible
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDismissible: Scalars["Boolean"]["output"];
    /**
     * Title of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * The datetime that the banner last updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updatedAt: Scalars["String"]["output"];
};

export type ConfluenceAdminAnnouncementBannerPayload = {
    __typename?: "ConfluenceAdminAnnouncementBannerPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    adminAnnouncementBannerSetting?: Maybe<ConfluenceAdminAnnouncementBannerSetting>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Announcement banner version shown to admins */
export type ConfluenceAdminAnnouncementBannerSetting = {
    __typename?: "ConfluenceAdminAnnouncementBannerSetting";
    /** Appearance of the banner */
    appearance: Scalars["String"]["output"];
    /** Content of the banner */
    content: Scalars["String"]["output"];
    /** ARI of the announcement banner. */
    id: Scalars["ID"]["output"];
    /** Indicates whether the banner is dismissible */
    isDismissible: Scalars["Boolean"]["output"];
    /** Scheduled end time of the banner */
    scheduledEndTime?: Maybe<Scalars["String"]["output"]>;
    /** Scheduled start time of the banner */
    scheduledStartTime?: Maybe<Scalars["String"]["output"]>;
    /** Scheduled time zone of the banner */
    scheduledTimeZone?: Maybe<Scalars["String"]["output"]>;
    /** Status of the banner */
    status: ConfluenceAdminAnnouncementBannerStatusType;
    /** Title of the banner */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Visibility of the banner */
    visibility: ConfluenceAdminAnnouncementBannerVisibilityType;
};

export enum ConfluenceAdminAnnouncementBannerStatusType {
    Published = "PUBLISHED",
    Saved = "SAVED",
    Scheduled = "SCHEDULED"
}

export enum ConfluenceAdminAnnouncementBannerVisibilityType {
    All = "ALL",
    Authorized = "AUTHORIZED"
}

export type ConfluenceAdminReport = {
    __typename?: "ConfluenceAdminReport";
    date?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<Scalars["String"]["output"]>;
    reportId?: Maybe<Scalars["ID"]["output"]>;
    requesterId?: Maybe<Scalars["ID"]["output"]>;
};

export type ConfluenceAdminReportPayload = {
    __typename?: "ConfluenceAdminReportPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reportId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceAdminReportStatus = {
    __typename?: "ConfluenceAdminReportStatus";
    /**
     * A list of the current generated admin reports.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reports?: Maybe<Array<Maybe<ConfluenceAdminReport>>>;
};

export type ConfluenceAncestor =
    | ConfluenceDatabase
    | ConfluenceEmbed
    | ConfluenceFolder
    | ConfluencePage
    | ConfluenceWhiteboard;

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceBlogPost = {
    __typename?: "ConfluenceBlogPost";
    /** Original User who authored the BlogPost. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Content ID of the BlogPost. */
    blogPostId: Scalars["ID"]["output"];
    /** Body of the BlogPost. */
    body?: Maybe<ConfluenceBodies>;
    /**
     * Comments on the BlogPost. If no commentType is passed, all comment types are returned.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: confluence-agg-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    comments?: Maybe<Array<Maybe<ConfluenceComment>>>;
    /** Date and time the BlogPost was created. */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ARI of the BlogPost, ConfluencePageARI format. */
    id: Scalars["ID"]["output"];
    /** Labels for the BlogPost. */
    labels?: Maybe<Array<Maybe<ConfluenceLabel>>>;
    /** Latest Version of the BlogPost. */
    latestVersion?: Maybe<ConfluenceBlogPostVersion>;
    /** Links associated with the BlogPost. */
    links?: Maybe<ConfluenceBlogPostLinks>;
    /** Metadata of the BlogPost. */
    metadata?: Maybe<ConfluenceContentMetadata>;
    /** Native Properties of the BlogPost. */
    nativeProperties?: Maybe<ConfluenceContentNativeProperties>;
    /** The owner of the BlogPost. */
    owner?: Maybe<ConfluenceUserInfo>;
    /** Properties of the BlogPost, specified by property key. */
    properties?: Maybe<Array<Maybe<ConfluenceBlogPostProperty>>>;
    /** Space that contains the BlogPost. */
    space?: Maybe<ConfluenceSpace>;
    /** Content status of the BlogPost. */
    status?: Maybe<ConfluenceBlogPostStatus>;
    /** Title of the BlogPost. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Content type of the page. Will always be \"BLOG_POST\". */
    type?: Maybe<ConfluenceContentType>;
    /** Summary of viewer-related fields for the BlogPost. */
    viewer?: Maybe<ConfluenceBlogPostViewerSummary>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceBlogPostCommentsArgs = {
    commentType?: InputMaybe<ConfluenceCommentType>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceBlogPostPropertiesArgs = {
    keys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ConfluenceBlogPostLinks = {
    __typename?: "ConfluenceBlogPostLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL associated with the BlogPost. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.property:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceBlogPostProperty = {
    __typename?: "ConfluenceBlogPostProperty";
    /** Key of the BlogPost property. */
    key: Scalars["String"]["output"];
    /** Value of the BlogPost property. */
    value: Scalars["String"]["output"];
};

export enum ConfluenceBlogPostStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Deleted = "DELETED",
    Draft = "DRAFT",
    Historical = "HISTORICAL",
    Trashed = "TRASHED"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceBlogPostVersion = {
    __typename?: "ConfluenceBlogPostVersion";
    /** User who authored the Version. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Date and time the Version was created. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Number of the Version. */
    number?: Maybe<Scalars["Int"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceBlogPostViewerSummary = {
    __typename?: "ConfluenceBlogPostViewerSummary";
    /** Favorited summary of the blog post. */
    favoritedSummary?: Maybe<ConfluenceFavoritedSummary>;
    /** Viewer's last Contribution to the BlogPost. */
    lastContribution?: Maybe<ConfluenceContribution>;
    /** Date and time viewer most recently visited the BlogPost. */
    lastSeenAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ConfluenceBodies = {
    __typename?: "ConfluenceBodies";
    /** Body content in ANONYMOUS_EXPORT_VIEW format. */
    anonymousExportView?: Maybe<ConfluenceBody>;
    /** Body content in ATLAS_DOC_FORMAT format. */
    atlasDocFormat?: Maybe<ConfluenceBody>;
    /** Body content in DYNAMIC format. */
    dynamic?: Maybe<ConfluenceBody>;
    /** Body content in EDITOR format. */
    editor?: Maybe<ConfluenceBody>;
    /** Body content in EDITOR_2 format. */
    editor2?: Maybe<ConfluenceBody>;
    /** Short excerpt of body content. */
    excerpt?: Maybe<Scalars["String"]["output"]>;
    /** Body content in EXPORT_VIEW format. */
    exportView?: Maybe<ConfluenceBody>;
    /** Body content in STORAGE format. */
    storage?: Maybe<ConfluenceBody>;
    /** Body content in STYLED_VIEW format. */
    styledView?: Maybe<ConfluenceBody>;
    /** Body content in VIEW format. */
    view?: Maybe<ConfluenceBody>;
};

export type ConfluenceBodiesExcerptArgs = {
    length?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceBody = {
    __typename?: "ConfluenceBody";
    representation?: Maybe<ConfluenceBodyRepresentation>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceBodyRepresentation {
    AnonymousExportView = "ANONYMOUS_EXPORT_VIEW",
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Dynamic = "DYNAMIC",
    Editor = "EDITOR",
    Editor2 = "EDITOR2",
    ExportView = "EXPORT_VIEW",
    Storage = "STORAGE",
    StyledView = "STYLED_VIEW",
    View = "VIEW",
    WhiteboardDocFormat = "WHITEBOARD_DOC_FORMAT"
}

export type ConfluenceCalendarJqlValidationResult = {
    __typename?: "ConfluenceCalendarJqlValidationResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorMessages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    valid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    warningMessages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ConfluenceCalendarPreference = {
    __typename?: "ConfluenceCalendarPreference";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    disabledMessageKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    disabledSubCalendars?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subCalendarsInView?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    view: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    watchedSubCalendars?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
};

export type ConfluenceCalendarTimeZone = {
    __typename?: "ConfluenceCalendarTimeZone";
    /** Name of the timezone */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Offset based on user location */
    offset?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceCalendarTimezones = {
    __typename?: "ConfluenceCalendarTimezones";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timezones?: Maybe<Array<Maybe<ConfluenceCalendarTimeZone>>>;
};

export type ConfluenceChildContent = {
    __typename?: "ConfluenceChildContent";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use content.[nodes|edges].attachments
     */
    attachment: PaginatedContentList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Query content by type='blogpost' and then use content.[nodes|edges]
     */
    blogpost: PaginatedContentList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use content.[nodes|edges].comments or the top level comments query
     */
    comment: PaginatedContentList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use content.[nodes|edges]
     */
    page: PaginatedContentList;
};

export type ConfluenceChildContentAttachmentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceChildContentBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceChildContentCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    depth?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    location?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceChildContentPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConfluenceCollaborativeEditingService {
    Ncs = "NCS",
    Synchrony = "SYNCHRONY"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceComment = {
    /** UserInfo of the author of the Comment. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Body of the Comment. */
    body?: Maybe<ConfluenceBodies>;
    /** Content ID of the Comment. */
    commentId?: Maybe<Scalars["ID"]["output"]>;
    /** Entity that contains Comment. */
    container?: Maybe<ConfluenceCommentContainer>;
    /** ARI of the Comment, ConfluenceCommentARI format. */
    id: Scalars["ID"]["output"];
    /** Links associated with the Comment. */
    links?: Maybe<ConfluenceCommentLinks>;
    /** Title of the Comment. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Status of the Comment. */
    status?: Maybe<ConfluenceCommentStatus>;
};

export type ConfluenceCommentContainer =
    | ConfluenceBlogPost
    | ConfluencePage
    | ConfluenceWhiteboard;

export type ConfluenceCommentCountSummary = {
    __typename?: "ConfluenceCommentCountSummary";
    total?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceCommentFilter = {
    commentState?: InputMaybe<Array<InputMaybe<ConfluenceCommentState>>>;
    commentType?: InputMaybe<Array<InputMaybe<CommentType>>>;
};

export type ConfluenceCommentLinks = {
    __typename?: "ConfluenceCommentLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL associated with the Comment. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

/** The resolution state of the comment. */
export type ConfluenceCommentResolutionState = {
    __typename?: "ConfluenceCommentResolutionState";
    commentId: Scalars["ID"]["output"];
    resolveProperties?: Maybe<InlineCommentResolveProperties>;
    status?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ConfluenceCommentState {
    Resolved = "RESOLVED",
    Unresolved = "UNRESOLVED"
}

export enum ConfluenceCommentStatus {
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ConfluenceCommentType {
    Footer = "FOOTER",
    Inline = "INLINE"
}

/** Payload for Confluence subscription */
export type ConfluenceContent = {
    __typename?: "ConfluenceContent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    contentTitleUpdate?: Maybe<ConfluenceContentTitleUpdate>;
    /**
     *  Type of content being subscribed page, db, wb, etc.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    contentType: ConfluenceSubscriptionContentType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    eventType: Scalars["String"]["output"];
};

export type ConfluenceContentBody = {
    __typename?: "ConfluenceContentBody";
    /** Body content in ADF format. */
    adf?: Maybe<Scalars["String"]["output"]>;
    /** Body content in editor format. */
    editor?: Maybe<Scalars["String"]["output"]>;
    /** Body content in editor_2 format. */
    editor2?: Maybe<Scalars["String"]["output"]>;
    /** Body content in export view format. */
    exportView?: Maybe<Scalars["String"]["output"]>;
    /** Body content in storage format. */
    storage?: Maybe<Scalars["String"]["output"]>;
    /** Body content in styled view format. */
    styledView?: Maybe<Scalars["String"]["output"]>;
    /** Body content in view format. */
    view?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceContentBodyInput = {
    representation: ConfluenceContentRepresentation;
    value: Scalars["String"]["input"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceContentMetadata = {
    __typename?: "ConfluenceContentMetadata";
    /** Collaborative editing service type associated with Content. */
    collaborativeEditingService?: Maybe<ConfluenceCollaborativeEditingService>;
    /** Emoji metadata associated with draft Content. */
    titleEmojiDraft?: Maybe<ConfluenceContentTitleEmoji>;
    /** Emoji metadata associated with published Content. */
    titleEmojiPublished?: Maybe<ConfluenceContentTitleEmoji>;
};

export type ConfluenceContentNativeProperties = {
    __typename?: "ConfluenceContentNativeProperties";
    /** Properties of the content's current version. */
    current?: Maybe<ConfluenceCurrentContentNativeProperties>;
    /** Properties of the content's draft. */
    draft?: Maybe<ConfluenceDraftContentNativeProperties>;
};

export enum ConfluenceContentRepresentation {
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Editor = "EDITOR",
    Editor2 = "EDITOR2",
    ExportView = "EXPORT_VIEW",
    Plain = "PLAIN",
    Raw = "RAW",
    Storage = "STORAGE",
    StyledView = "STYLED_VIEW",
    View = "VIEW",
    Wiki = "WIKI"
}

export type ConfluenceContentState = {
    __typename?: "ConfluenceContentState";
    /** Color of the Content State. */
    color?: Maybe<Scalars["String"]["output"]>;
    /** ID of the Content State. */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Name of the Content State. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceContentTitleEmoji = {
    __typename?: "ConfluenceContentTitleEmoji";
    /** It is ID of the emoji property. */
    id?: Maybe<Scalars["String"]["output"]>;
    /** It is Key of the emoji property. */
    key?: Maybe<Scalars["String"]["output"]>;
    /** It is Value of the emoji property. */
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceContentTitleUpdate = {
    __typename?: "ConfluenceContentTitleUpdate";
    contentTitle: Scalars["String"]["output"];
};

export enum ConfluenceContentType {
    Attachment = "ATTACHMENT",
    BlogPost = "BLOG_POST",
    Comment = "COMMENT",
    Page = "PAGE",
    Whiteboard = "WHITEBOARD"
}

export type ConfluenceContentVersion = {
    __typename?: "ConfluenceContentVersion";
    /** User who authored the Version. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Date and time the Version was created. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Number of the Version. */
    number?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceContribution = {
    __typename?: "ConfluenceContribution";
    /** Status of the Contribution */
    status: ConfluenceContributionStatus;
};

export enum ConfluenceContributionStatus {
    Current = "CURRENT",
    Draft = "DRAFT",
    Unknown = "UNKNOWN",
    Unpublished = "UNPUBLISHED"
}

export type ConfluenceConvertContentToFolderPayload = {
    __typename?: "ConfluenceConvertContentToFolderPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content?: Maybe<Content>;
};

/** The result of a successful copy page Long Task. */
export type ConfluenceCopyPageTaskResult = {
    __typename?: "ConfluenceCopyPageTaskResult";
    /**
     * The copied page from the Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    page?: Maybe<ConfluencePage>;
};

export type ConfluenceCreateAdminAnnouncementBannerInput = {
    appearance: Scalars["String"]["input"];
    content: Scalars["String"]["input"];
    isDismissible: Scalars["Boolean"]["input"];
    scheduledEndTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledStartTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledTimeZone?: InputMaybe<Scalars["String"]["input"]>;
    status: ConfluenceAdminAnnouncementBannerStatusType;
    title?: InputMaybe<Scalars["String"]["input"]>;
    visibility: ConfluenceAdminAnnouncementBannerVisibilityType;
};

export type ConfluenceCreateBlogPostInput = {
    body?: InputMaybe<ConfluenceContentBodyInput>;
    spaceId: Scalars["ID"]["input"];
    /** Status with which the BlogPost will be created. Defaults to CURRENT status. */
    status?: InputMaybe<ConfluenceMutationContentStatus>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceCreateBlogPostPayload = Payload & {
    __typename?: "ConfluenceCreateBlogPostPayload";
    blogPost?: Maybe<ConfluenceBlogPost>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCreateBlogPostPropertyInput = {
    blogPostId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceCreateBlogPostPropertyPayload = Payload & {
    __typename?: "ConfluenceCreateBlogPostPropertyPayload";
    blogPostProperty?: Maybe<ConfluenceBlogPostProperty>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCreateFooterCommentOnBlogPostInput = {
    blogPostId: Scalars["ID"]["input"];
    body: ConfluenceContentBodyInput;
};

export type ConfluenceCreateFooterCommentOnBlogPostPayload = Payload & {
    __typename?: "ConfluenceCreateFooterCommentOnBlogPostPayload";
    comment?: Maybe<ConfluenceFooterComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCreateFooterCommentOnPageInput = {
    body: ConfluenceContentBodyInput;
    pageId: Scalars["ID"]["input"];
};

export type ConfluenceCreateFooterCommentOnPagePayload = Payload & {
    __typename?: "ConfluenceCreateFooterCommentOnPagePayload";
    comment?: Maybe<ConfluenceFooterComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCreatePageInput = {
    body?: InputMaybe<ConfluenceContentBodyInput>;
    spaceId: Scalars["ID"]["input"];
    /** Status with which the Page will be created. Defaults to CURRENT status. */
    status?: InputMaybe<ConfluenceMutationContentStatus>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceCreatePagePayload = Payload & {
    __typename?: "ConfluenceCreatePagePayload";
    errors?: Maybe<Array<MutationError>>;
    page?: Maybe<ConfluencePage>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCreatePagePropertyInput = {
    key: Scalars["String"]["input"];
    pageId: Scalars["ID"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceCreatePagePropertyPayload = Payload & {
    __typename?: "ConfluenceCreatePagePropertyPayload";
    errors?: Maybe<Array<MutationError>>;
    pageProperty?: Maybe<ConfluencePageProperty>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCreateSpaceInput = {
    key: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    type?: InputMaybe<ConfluenceSpaceType>;
};

export type ConfluenceCreateSpacePayload = Payload & {
    __typename?: "ConfluenceCreateSpacePayload";
    errors?: Maybe<Array<MutationError>>;
    space?: Maybe<ConfluenceSpace>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceCurrentContentNativeProperties = {
    __typename?: "ConfluenceCurrentContentNativeProperties";
    /** Content State Property. */
    contentState?: Maybe<ConfluenceContentState>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceDatabase = {
    __typename?: "ConfluenceDatabase";
    /** Ancestors of the Database, of all types. */
    allAncestors?: Maybe<Array<Maybe<ConfluenceAncestor>>>;
    /** Original User who authored the Database. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Content ID of the Database. */
    databaseId: Scalars["ID"]["output"];
    /** ARI of the Database, ConfluenceDatabaseARI format. */
    id: Scalars["ID"]["output"];
    /** Latest Version of the Database. */
    latestVersion?: Maybe<ConfluenceContentVersion>;
    /** Links associated with the Database. */
    links?: Maybe<ConfluenceDatabaseLinks>;
    /** The owner of the Database. */
    owner?: Maybe<ConfluenceUserInfo>;
    /** Space that contains the Database. */
    space?: Maybe<ConfluenceSpace>;
    /** Title of the Database. */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceDatabaseLinks = {
    __typename?: "ConfluenceDatabaseLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL path associated with the Database. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceDeleteBlogPostPropertyInput = {
    blogPostId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

export type ConfluenceDeleteBlogPostPropertyPayload = Payload & {
    __typename?: "ConfluenceDeleteBlogPostPropertyPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteCalendarCustomEventTypeInput = {
    id: Scalars["ID"]["input"];
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceDeleteCalendarCustomEventTypePayload = Payload & {
    __typename?: "ConfluenceDeleteCalendarCustomEventTypePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteCommentInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceDeleteCommentPayload = {
    __typename?: "ConfluenceDeleteCommentPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteDraftBlogPostInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceDeleteDraftBlogPostPayload = Payload & {
    __typename?: "ConfluenceDeleteDraftBlogPostPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteDraftPageInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceDeleteDraftPagePayload = Payload & {
    __typename?: "ConfluenceDeleteDraftPagePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeletePagePropertyInput = {
    key: Scalars["String"]["input"];
    pageId: Scalars["ID"]["input"];
};

export type ConfluenceDeletePagePropertyPayload = Payload & {
    __typename?: "ConfluenceDeletePagePropertyPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteSubCalendarAllFutureEventsInput = {
    recurUntil?: InputMaybe<Scalars["String"]["input"]>;
    subCalendarId: Scalars["ID"]["input"];
    uid: Scalars["ID"]["input"];
};

export type ConfluenceDeleteSubCalendarAllFutureEventsPayload = Payload & {
    __typename?: "ConfluenceDeleteSubCalendarAllFutureEventsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteSubCalendarEventInput = {
    subCalendarId: Scalars["ID"]["input"];
    uid: Scalars["ID"]["input"];
};

export type ConfluenceDeleteSubCalendarEventPayload = Payload & {
    __typename?: "ConfluenceDeleteSubCalendarEventPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteSubCalendarHiddenEventsInput = {
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceDeleteSubCalendarHiddenEventsPayload = Payload & {
    __typename?: "ConfluenceDeleteSubCalendarHiddenEventsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subCalendarIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteSubCalendarPrivateUrlInput = {
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceDeleteSubCalendarPrivateUrlPayload = {
    __typename?: "ConfluenceDeleteSubCalendarPrivateUrlPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDeleteSubCalendarSingleEventInput = {
    originalStart?: InputMaybe<Scalars["String"]["input"]>;
    recurrenceId?: InputMaybe<Scalars["ID"]["input"]>;
    subCalendarId: Scalars["ID"]["input"];
    uid: Scalars["ID"]["input"];
};

export type ConfluenceDeleteSubCalendarSingleEventPayload = Payload & {
    __typename?: "ConfluenceDeleteSubCalendarSingleEventPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceDraftContentNativeProperties = {
    __typename?: "ConfluenceDraftContentNativeProperties";
    /** Content State Property. */
    contentState?: Maybe<ConfluenceContentState>;
};

export enum ConfluenceEdition {
    Free = "FREE",
    Premium = "PREMIUM",
    Standard = "STANDARD"
}

export type ConfluenceEditions = {
    __typename?: "ConfluenceEditions";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use tenantContext.editions.confluence
     */
    edition: ConfluenceEdition;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceEmbed = {
    __typename?: "ConfluenceEmbed";
    /** Ancestors of the Smart Link in the content tree, of all types. */
    allAncestors?: Maybe<Array<Maybe<ConfluenceAncestor>>>;
    /** Original User who authored the Smart Link in the content tree. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Content ID of the Smart Link in the content tree. */
    embedId: Scalars["ID"]["output"];
    /** ARI of the Smart Link in the content tree, ConfluenceEmbedARI format. */
    id: Scalars["ID"]["output"];
    /** Latest Version of the Smart Link in the content tree. */
    latestVersion?: Maybe<ConfluenceContentVersion>;
    /** Links associated with the Smart Link in the content tree. */
    links?: Maybe<ConfluenceEmbedLinks>;
    /** Metadata of the Smart Link in the content tree. */
    metadata?: Maybe<ConfluenceContentMetadata>;
    /** The owner of the Smart Link in the content tree. */
    owner?: Maybe<ConfluenceUserInfo>;
    /** Space that contains the Smart Link in the content tree. */
    space?: Maybe<ConfluenceSpace>;
    /** Title of the Smart Link in the content tree. */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceEmbedLinks = {
    __typename?: "ConfluenceEmbedLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL path associated with the Smart Link in the content tree. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceFavoritedSummary = {
    __typename?: "ConfluenceFavoritedSummary";
    /** Date and time the viewer favorited the entry. */
    favoritedAt?: Maybe<Scalars["String"]["output"]>;
    /** Whether the entry is favorited. */
    isFavorite: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceFolder = {
    __typename?: "ConfluenceFolder";
    /** Ancestors of the Folder, of all types. */
    allAncestors?: Maybe<Array<Maybe<ConfluenceAncestor>>>;
    /** Original User who authored the Folder. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Content ID of the Folder. */
    folderId: Scalars["ID"]["output"];
    /** ARI of the Folder, ConfluenceFolderARI format. */
    id: Scalars["ID"]["output"];
    /** Latest Version of the Folder. */
    latestVersion?: Maybe<ConfluenceContentVersion>;
    /** Links associated with the Folder. */
    links?: Maybe<ConfluenceFolderLinks>;
    /** Metadata of the Folder. */
    metadata?: Maybe<ConfluenceContentMetadata>;
    /** The owner of the Folder. */
    owner?: Maybe<ConfluenceUserInfo>;
    /** Space that contains the Folder. */
    space?: Maybe<ConfluenceSpace>;
    /** Title of the Folder. */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceFolderLinks = {
    __typename?: "ConfluenceFolderLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL path associated with the Folder. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceFooterComment = ConfluenceComment & {
    __typename?: "ConfluenceFooterComment";
    /** UserInfo of the author of the Footer Comment. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Body of the Footer Comment. */
    body?: Maybe<ConfluenceBodies>;
    /** Content ID of the Footer Comment. */
    commentId?: Maybe<Scalars["ID"]["output"]>;
    /** Entity that contains Footer Comment. */
    container?: Maybe<ConfluenceCommentContainer>;
    /** ARI of the Footer Comment, ConfluenceCommentARI format. */
    id: Scalars["ID"]["output"];
    /** Links associated with the Footer Comment. */
    links?: Maybe<ConfluenceCommentLinks>;
    /** Title of the Footer Comment. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Status of the Footer Comment. */
    status?: Maybe<ConfluenceCommentStatus>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceInlineComment = ConfluenceComment & {
    __typename?: "ConfluenceInlineComment";
    /** UserInfo of the author of the Inline Comment. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Body of the Inline Comment. */
    body?: Maybe<ConfluenceBodies>;
    /** Content ID of the Inline Comment. */
    commentId?: Maybe<Scalars["ID"]["output"]>;
    /** Entity that contains Inline Comment. */
    container?: Maybe<ConfluenceCommentContainer>;
    /** ARI of the Inline Comment, ConfluenceCommentARI format. */
    id: Scalars["ID"]["output"];
    /** Links associated with the Inline Comment. */
    links?: Maybe<ConfluenceCommentLinks>;
    /** Title of the Inline Comment. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Resolution Status of the Inline Comment. */
    resolutionStatus?: Maybe<ConfluenceInlineCommentResolutionStatus>;
    /** Status of the Inline Comment. */
    status?: Maybe<ConfluenceCommentStatus>;
};

export enum ConfluenceInlineCommentResolutionStatus {
    Resolved = "RESOLVED",
    Unresolved = "UNRESOLVED"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:inlinetask:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceInlineTask = {
    __typename?: "ConfluenceInlineTask";
    /** UserInfo of the user who has been assigned the Task. */
    assignedTo?: Maybe<ConfluenceUserInfo>;
    /** Body of the Task. */
    body?: Maybe<ConfluenceContentBody>;
    /** UserInfo of the user who has completed the Task. */
    completedBy?: Maybe<ConfluenceUserInfo>;
    /** Entity that contains Task. */
    container?: Maybe<ConfluenceInlineTaskContainer>;
    /** Created date of the Task. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** UserInfo of the user who created the Task. */
    createdBy?: Maybe<ConfluenceUserInfo>;
    /** Due date of the Task. */
    dueAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Global ID of the Task. */
    globalId?: Maybe<Scalars["ID"]["output"]>;
    /** The ARI of the Task, ConfluenceTaskARI format. */
    id: Scalars["ID"]["output"];
    /** Status of the Task. */
    status?: Maybe<ConfluenceInlineTaskStatus>;
    /** ID of the Task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
    /** Update date of the Task. */
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ConfluenceInlineTaskContainer = ConfluenceBlogPost | ConfluencePage;

export enum ConfluenceInlineTaskStatus {
    Complete = "COMPLETE",
    Incomplete = "INCOMPLETE"
}

export type ConfluenceInviteUserInput = {
    inviteeIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceInviteUserPayload = {
    __typename?: "ConfluenceInviteUserPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:label:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLabel = {
    __typename?: "ConfluenceLabel";
    /** ID of the Label */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Name of the Label */
    label?: Maybe<Scalars["String"]["output"]>;
    /** Prefix of the Label */
    prefix?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLabelSearchResults = {
    __typename?: "ConfluenceLabelSearchResults";
    otherLabels?: Maybe<Array<Maybe<ConfluenceLabel>>>;
    suggestedLabels?: Maybe<Array<Maybe<ConfluenceLabel>>>;
};

/** --------------------------------------------------------------------------------------------- */
export type ConfluenceLegacyAiConfigResponse = {
    __typename?: "ConfluenceLegacyAIConfigResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isRovoEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** --------------------------------------------------------------------------------------------- */
export enum ConfluenceLegacyAccessStatus {
    AnonymousAccess = "ANONYMOUS_ACCESS",
    ExternalCollaboratorAccess = "EXTERNAL_COLLABORATOR_ACCESS",
    ExternalShareAccess = "EXTERNAL_SHARE_ACCESS",
    LicensedAdminAccess = "LICENSED_ADMIN_ACCESS",
    LicensedUseAccess = "LICENSED_USE_ACCESS",
    NotPermitted = "NOT_PERMITTED",
    UnlicensedAuthenticatedAccess = "UNLICENSED_AUTHENTICATED_ACCESS"
}

export enum ConfluenceLegacyAccessType {
    Edit = "EDIT",
    View = "VIEW"
}

export enum ConfluenceLegacyAccountType {
    App = "APP",
    Atlassian = "ATLASSIAN",
    Customer = "CUSTOMER",
    Unknown = "UNKNOWN"
}

export type ConfluenceLegacyActivatePaywallContentInput = {
    contentIdToActivate: Scalars["ID"]["input"];
    deactivationIdentifier?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyActivatePaywallContentPayload = Payload & {
    __typename?: "ConfluenceLegacyActivatePaywallContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<MutationError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyAddDefaultExCoSpacePermissionsInput = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groupNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    spaceKeys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ConfluenceLegacyAddDefaultExCoSpacePermissionsPayload = {
    __typename?: "ConfluenceLegacyAddDefaultExCoSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type ConfluenceLegacyAddLabelsInput = {
    contentId: Scalars["ID"]["input"];
    labels: Array<ConfluenceLegacyLabelInput>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyAddLabelsPayload = {
    __typename?: "ConfluenceLegacyAddLabelsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labels: ConfluenceLegacyMutationsPaginatedLabelList;
};

export type ConfluenceLegacyAddPublicLinkPermissionsInput = {
    objectId: Scalars["ID"]["input"];
    objectType: ConfluenceLegacyPublicLinkPermissionsObjectType;
    permissions: Array<ConfluenceLegacyPublicLinkPermissionsType>;
};

export type ConfluenceLegacyAddPublicLinkPermissionsPayload = Payload & {
    __typename?: "ConfluenceLegacyAddPublicLinkPermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    data?: Maybe<ConfluenceLegacyPublicLinkPermissions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyAdminAnnouncementBanner = {
    __typename?: "ConfluenceLegacyAdminAnnouncementBanner";
    /**
     * Appearance of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appearance: Scalars["String"]["output"];
    /**
     * Content of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Scalars["String"]["output"];
    /**
     * ARI of the announcement banner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Indicates whether the banner is dismissible
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDismissible: Scalars["Boolean"]["output"];
    /**
     * Title of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * The datetime that the banner last updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updatedAt: Scalars["String"]["output"];
};

export type ConfluenceLegacyAdminAnnouncementBannerFeature = {
    __typename?: "ConfluenceLegacyAdminAnnouncementBannerFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyAdminAnnouncementBannerMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "ConfluenceLegacyAdminAnnouncementBannerMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        adminAnnouncementBannerList: Array<
            Maybe<ConfluenceLegacyAdminAnnouncementBannerSetting>
        >;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type ConfluenceLegacyAdminAnnouncementBannerPageInfo = {
    __typename?: "ConfluenceLegacyAdminAnnouncementBannerPageInfo";
    endPage?: Maybe<Scalars["String"]["output"]>;
    hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
    startPage?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyAdminAnnouncementBannerPayload = {
    __typename?: "ConfluenceLegacyAdminAnnouncementBannerPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    adminAnnouncementBannerSetting?: Maybe<ConfluenceLegacyAdminAnnouncementBannerSetting>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Announcement banner version shown to admins */
export type ConfluenceLegacyAdminAnnouncementBannerSetting = {
    __typename?: "ConfluenceLegacyAdminAnnouncementBannerSetting";
    /**
     * Appearance of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appearance: Scalars["String"]["output"];
    /**
     * Content of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Scalars["String"]["output"];
    /**
     * ARI of the announcement banner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Indicates whether the banner is dismissible
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDismissible: Scalars["Boolean"]["output"];
    /**
     * Scheduled end time of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scheduledEndTime?: Maybe<Scalars["String"]["output"]>;
    /**
     * Scheduled start time of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scheduledStartTime?: Maybe<Scalars["String"]["output"]>;
    /**
     * Scheduled time zone of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scheduledTimeZone?: Maybe<Scalars["String"]["output"]>;
    /**
     * Status of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: ConfluenceLegacyAdminAnnouncementBannerStatusType;
    /**
     * Title of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * Visibility of the banner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    visibility: ConfluenceLegacyAdminAnnouncementBannerVisibilityType;
};

export type ConfluenceLegacyAdminAnnouncementBannerSettingConnection = {
    __typename?: "ConfluenceLegacyAdminAnnouncementBannerSettingConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<ConfluenceLegacyAdminAnnouncementBannerSetting>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyAdminAnnouncementBannerPageInfo;
};

export enum ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder {
    Default = "DEFAULT",
    ScheduledEndDate = "SCHEDULED_END_DATE",
    ScheduledStartDate = "SCHEDULED_START_DATE",
    Visibility = "VISIBILITY"
}

export enum ConfluenceLegacyAdminAnnouncementBannerStatusType {
    Published = "PUBLISHED",
    Saved = "SAVED",
    Scheduled = "SCHEDULED"
}

export enum ConfluenceLegacyAdminAnnouncementBannerVisibilityType {
    All = "ALL",
    Authorized = "AUTHORIZED"
}

export type ConfluenceLegacyAdminReport = {
    __typename?: "ConfluenceLegacyAdminReport";
    date?: Maybe<Scalars["String"]["output"]>;
    link?: Maybe<Scalars["String"]["output"]>;
    reportId?: Maybe<Scalars["ID"]["output"]>;
    requesterId?: Maybe<Scalars["ID"]["output"]>;
};

export type ConfluenceLegacyAdminReportPayload = {
    __typename?: "ConfluenceLegacyAdminReportPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reportId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyAdminReportStatus = {
    __typename?: "ConfluenceLegacyAdminReportStatus";
    /**
     * A list of the current generated admin reports.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reports?: Maybe<Array<Maybe<ConfluenceLegacyAdminReport>>>;
};

/** --------------------------------------------------------------------------------------------- */
export type ConfluenceLegacyAllUpdatesFeedEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacyAllUpdatesFeedEventType;
};

export enum ConfluenceLegacyAllUpdatesFeedEventType {
    Comment = "COMMENT",
    Create = "CREATE",
    Edit = "EDIT"
}

export type ConfluenceLegacyAllUpdatesFeedItem = {
    __typename?: "ConfluenceLegacyAllUpdatesFeedItem";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    lastUpdate: ConfluenceLegacyAllUpdatesFeedEvent;
};

export enum ConfluenceLegacyAnalyticsCommentType {
    Inline = "inline",
    Page = "page"
}

export enum ConfluenceLegacyAnalyticsContentType {
    Blogpost = "blogpost",
    Page = "page"
}

/** Events to gather analytics for */
export enum ConfluenceLegacyAnalyticsEventName {
    AnalyticsPageModalViewed = "analyticsPageModal_viewed",
    AutomationRuleTrackCreated = "automationRuleTrack_created",
    CalendarCreated = "calendar_created",
    CommentCreated = "comment_created",
    DatabaseCreated = "database_created",
    DatabaseViewed = "database_viewed",
    InspectPermissionsDialogViewed = "inspectPermissionsDialog_viewed",
    InstanceAnalyticsViewed = "instanceAnalytics_viewed",
    PageAnalyticsViewed = "pageAnalytics_viewed",
    PageCreated = "page_created",
    PageUpdated = "page_updated",
    PageViewed = "page_viewed",
    PubliclinkPageViewed = "publiclink_page_viewed",
    SpaceAnalyticsViewed = "spaceAnalytics_viewed",
    TeamCalendarsViewed = "teamCalendars_viewed",
    WhiteboardCreated = "whiteboard_created",
    WhiteboardViewed = "whiteboard_viewed"
}

/** Events to gather measure analytics for */
export enum ConfluenceLegacyAnalyticsMeasuresEventName {
    CurrentBlogpostCountSitestateMeasured = "currentBlogpostCount_sitestate_measured",
    CurrentBlogpostCountSpacestateMeasured = "currentBlogpostCount_spacestate_measured",
    CurrentDatabaseCountSitestateMeasured = "currentDatabaseCount_sitestate_measured",
    CurrentDatabaseCountSpacestateMeasured = "currentDatabaseCount_spacestate_measured",
    CurrentPageCountSitestateMeasured = "currentPageCount_sitestate_measured",
    CurrentPageCountSpacestateMeasured = "currentPageCount_spacestate_measured",
    CurrentWhiteboardCountSitestateMeasured = "currentWhiteboardCount_sitestate_measured",
    CurrentWhiteboardCountSpacestateMeasured = "currentWhiteboardCount_spacestate_measured",
    InactivePageCountSitestateMeasured = "inactivePageCount_sitestate_measured",
    InactivePageCountSpacestateMeasured = "inactivePageCount_spacestate_measured",
    TotalActiveCommunalSpacesSitestateMeasured = "totalActiveCommunalSpaces_sitestate_measured",
    TotalActivePersonalSpacesSitestateMeasured = "totalActivePersonalSpaces_sitestate_measured",
    TotalActivePublicLinksSitestateMeasured = "totalActivePublicLinks_sitestate_measured",
    TotalActivePublicLinksSpacestateMeasured = "totalActivePublicLinks_spacestate_measured",
    TotalActiveSpacesSitestateMeasured = "totalActiveSpaces_sitestate_measured",
    TotalCurrentBlogpostCountSitestateMeasured = "totalCurrentBlogpostCount_sitestate_measured",
    TotalCurrentDatabaseCountSitestateMeasured = "totalCurrentDatabaseCount_sitestate_measured",
    TotalCurrentPageCountSitestateMeasured = "totalCurrentPageCount_sitestate_measured",
    TotalCurrentWhiteboardCountSitestateMeasured = "totalCurrentWhiteboardCount_sitestate_measured",
    TotalPagesDeactivatedOwnerSitestateMeasured = "totalPagesDeactivatedOwner_sitestate_measured",
    TotalPagesDeactivatedOwnerSpacestateMeasured = "totalPagesDeactivatedOwner_spacestate_measured"
}

/** Events to gather measure analytics space state */
export enum ConfluenceLegacyAnalyticsMeasuresSpaceEventName {
    CurrentBlogpostCountSpacestateMeasured = "currentBlogpostCount_spacestate_measured",
    CurrentDatabaseCountSpacestateMeasured = "currentDatabaseCount_spacestate_measured",
    CurrentPageCountSpacestateMeasured = "currentPageCount_spacestate_measured",
    CurrentWhiteboardCountSpacestateMeasured = "currentWhiteboardCount_spacestate_measured",
    InactivePageCountSpacestateMeasured = "inactivePageCount_spacestate_measured",
    TotalActivePublicLinksSpacestateMeasured = "totalActivePublicLinks_spacestate_measured",
    TotalPagesDeactivatedOwnerSpacestateMeasured = "totalPagesDeactivatedOwner_spacestate_measured"
}

/** Events to gather search analytics for */
export enum ConfluenceLegacyAnalyticsSearchEventName {
    AdvancedSearchResultLinkClicked = "advancedSearchResultLink_clicked",
    AdvancedSearchResultsShown = "advancedSearchResults_shown",
    QuickSearchRequestCompleted = "quickSearchRequest_completed",
    QuickSearchResultSelected = "quickSearchResult_selected"
}

/** Granularity to group events by */
export enum ConfluenceLegacyAnalyticsTimeseriesGranularity {
    Day = "DAY",
    Hour = "HOUR",
    Month = "MONTH",
    Week = "WEEK"
}

export type ConfluenceLegacyAnonymous = ConfluenceLegacyPerson & {
    __typename?: "ConfluenceLegacyAnonymous";
    displayName?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyAnonymousWithPermissionsInput = {
    operations: Array<InputMaybe<ConfluenceLegacyOperationCheckResultInput>>;
};

export type ConfluenceLegacyArchiveFeature = {
    __typename?: "ConfluenceLegacyArchiveFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyArchivedContentMetadata = {
    __typename?: "ConfluenceLegacyArchivedContentMetadata";
    archiveNote?: Maybe<Scalars["String"]["output"]>;
    restoreParent?: Maybe<ConfluenceLegacyContent>;
};

/** --------------------------------------------------------------------------------------------- */
export type ConfluenceLegacyAtlassianUser = {
    __typename?: "ConfluenceLegacyAtlassianUser";
    companyName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluence' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluence?: Maybe<ConfluenceLegacyConfluenceUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    emails?: Maybe<Array<Maybe<ConfluenceLegacyAtlassianUserEmail>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This will always be empty, use confluence.groups
     */
    groups?: Maybe<Array<Maybe<ConfluenceLegacyAtlassianUserGroup>>>;
    id?: Maybe<Scalars["ID"]["output"]>;
    isActive?: Maybe<Scalars["Boolean"]["output"]>;
    locale?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<Scalars["String"]["output"]>;
    photos?: Maybe<Array<Maybe<ConfluenceLegacyAtlassianUserPhoto>>>;
    team?: Maybe<Scalars["String"]["output"]>;
    timeZone?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is not being used in FE and it will not work as we have switched to Identity DataFetcher
     */
    userName?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyAtlassianUserEmail = {
    __typename?: "ConfluenceLegacyAtlassianUserEmail";
    isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyAtlassianUserGroup = {
    __typename?: "ConfluenceLegacyAtlassianUserGroup";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This type is no longer used
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This type is no longer used
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyAtlassianUserPhoto = {
    __typename?: "ConfluenceLegacyAtlassianUserPhoto";
    isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyAvailableContentStates = {
    __typename?: "ConfluenceLegacyAvailableContentStates";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customContentStates?: Maybe<Array<Maybe<ConfluenceLegacyContentState>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceContentStates?: Maybe<Array<Maybe<ConfluenceLegacyContentState>>>;
};

export enum ConfluenceLegacyBackendExperiment {
    Einstein = "EINSTEIN"
}

export type ConfluenceLegacyBatchedInlineTasksInput = {
    contentId: Scalars["ID"]["input"];
    tasks: Array<InputMaybe<ConfluenceLegacyInlineTaskInput>>;
    trigger?: InputMaybe<ConfluenceLegacyPageUpdateTrigger>;
};

export enum ConfluenceLegacyBillingSourceSystem {
    Ccp = "CCP",
    Hams = "HAMS"
}

/** Represents a block-rendered smart-link on a page */
export type ConfluenceLegacyBlockSmartLink = ConfluenceLegacySmartLink & {
    __typename?: "ConfluenceLegacyBlockSmartLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export enum ConfluenceLegacyBodyFormatType {
    AnonymousExportView = "ANONYMOUS_EXPORT_VIEW",
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Editor = "EDITOR",
    Editor2 = "EDITOR2",
    ExportView = "EXPORT_VIEW",
    Storage = "STORAGE",
    StyledView = "STYLED_VIEW",
    View = "VIEW"
}

export type ConfluenceLegacyBordersAndDividersLookAndFeel = {
    __typename?: "ConfluenceLegacyBordersAndDividersLookAndFeel";
    color?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyBreadcrumb = {
    __typename?: "ConfluenceLegacyBreadcrumb";
    label?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    separator?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyBulkActionsFeature = {
    __typename?: "ConfluenceLegacyBulkActionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyBulkArchivePagePayload = {
    __typename?: "ConfluenceLegacyBulkArchivePagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyBulkArchivePagesInput = {
    archiveNote?: InputMaybe<Scalars["String"]["input"]>;
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    descendantsNoteApplicationOption?: InputMaybe<ConfluenceLegacyDescendantsNoteApplicationOption>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

export type ConfluenceLegacyBulkDeleteContentDataClassificationLevelInput = {
    contentStatuses: Array<
        InputMaybe<ConfluenceLegacyContentDataClassificationMutationContentStatus>
    >;
    id: Scalars["Long"]["input"];
};

export type ConfluenceLegacyBulkDeleteContentDataClassificationLevelPayload =
    Payload & {
        __typename?: "ConfluenceLegacyBulkDeleteContentDataClassificationLevelPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyBulkSetSpacePermissionAsyncPayload = Payload & {
    __typename?: "ConfluenceLegacyBulkSetSpacePermissionAsyncPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

export type ConfluenceLegacyBulkSetSpacePermissionInput = {
    spacePermissions: Array<InputMaybe<ConfluenceLegacySpacePermissionType>>;
    spaceTypes: Array<
        InputMaybe<ConfluenceLegacyBulkSetSpacePermissionSpaceType>
    >;
    subjectId: Scalars["ID"]["input"];
    subjectType: ConfluenceLegacyBulkSetSpacePermissionSubjectType;
};

export type ConfluenceLegacyBulkSetSpacePermissionPayload = Payload & {
    __typename?: "ConfluenceLegacyBulkSetSpacePermissionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spacesUpdatedCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyBulkSetSpacePermissionSpaceType {
    Collaboration = "COLLABORATION",
    Global = "GLOBAL",
    KnowledgeBase = "KNOWLEDGE_BASE",
    Personal = "PERSONAL"
}

export enum ConfluenceLegacyBulkSetSpacePermissionSubjectType {
    Group = "GROUP",
    User = "USER"
}

export type ConfluenceLegacyBulkUpdateContentDataClassificationLevelInput = {
    classificationLevelId: Scalars["ID"]["input"];
    contentStatuses: Array<
        InputMaybe<ConfluenceLegacyContentDataClassificationMutationContentStatus>
    >;
    id: Scalars["Long"]["input"];
};

export type ConfluenceLegacyBulkUpdateContentDataClassificationLevelPayload =
    Payload & {
        __typename?: "ConfluenceLegacyBulkUpdateContentDataClassificationLevelPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyBulkUpdateMainSpaceSidebarLinksInput = {
    hidden: Scalars["Boolean"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    linkIdentifier?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<ConfluenceLegacySpaceSidebarLinkType>;
};

export type ConfluenceLegacyButtonLookAndFeel = {
    __typename?: "ConfluenceLegacyButtonLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    color?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyCqlDisplayableType = {
    __typename?: "ConfluenceLegacyCQLDisplayableType";
    i18nKey?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyCanvasToken = {
    __typename?: "ConfluenceLegacyCanvasToken";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    expiryDateTime: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    token: Scalars["String"]["output"];
};

export enum ConfluenceLegacyCatchupContentType {
    Blogpost = "BLOGPOST",
    Page = "PAGE"
}

export type ConfluenceLegacyCatchupEditMetadataForContent = {
    __typename?: "ConfluenceLegacyCatchupEditMetadataForContent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collaborators?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastVisitTimeISO?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export enum ConfluenceLegacyCatchupUpdateType {
    TopN = "TOP_N"
}

export type ConfluenceLegacyCatchupVersionSummaryMetadataForContent = {
    __typename?: "ConfluenceLegacyCatchupVersionSummaryMetadataForContent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    versionSummaryMetadata?: Maybe<
        Array<ConfluenceLegacyVersionSummaryMetaDataItem>
    >;
};

export type ConfluenceLegacyChangeOwnerWarning = {
    __typename?: "ConfluenceLegacyChangeOwnerWarning";
    contentId?: Maybe<Scalars["Long"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyChildContent = {
    __typename?: "ConfluenceLegacyChildContent";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use content.[nodes|edges].attachments
     */
    attachment: ConfluenceLegacyPaginatedContentList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Query content by type='blogpost' and then use content.[nodes|edges]
     */
    blogpost: ConfluenceLegacyPaginatedContentList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use content.[nodes|edges].comments or the top level comments query
     */
    comment: ConfluenceLegacyPaginatedContentList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use content.[nodes|edges]
     */
    page: ConfluenceLegacyPaginatedContentList;
};

export type ConfluenceLegacyChildContentAttachmentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyChildContentBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyChildContentCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    depth?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    location?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyChildContentPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyChildContentTypesAvailable = {
    __typename?: "ConfluenceLegacyChildContentTypesAvailable";
    attachment?: Maybe<Scalars["Boolean"]["output"]>;
    blogpost?: Maybe<Scalars["Boolean"]["output"]>;
    comment?: Maybe<Scalars["Boolean"]["output"]>;
    page?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyCollabTokenResponse = {
    __typename?: "ConfluenceLegacyCollabTokenResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    token: Scalars["String"]["output"];
};

export type ConfluenceLegacyComment = {
    __typename?: "ConfluenceLegacyComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ancestors: Array<Maybe<ConfluenceLegacyComment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    author?: Maybe<ConfluenceLegacyPerson>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    body: ConfluenceLegacyDocumentBody;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentSource?: Maybe<ConfluenceLegacyPlatform>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    container: ConfluenceLegacyContent;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdAt: ConfluenceLegacyDate;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdAtNonLocalized: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    excerpt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isInlineComment: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isLikedByCurrentUser: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likeCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links: ConfluenceLegacyMapLinkTypeString;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    location: ConfluenceLegacyCommentLocation;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissions: ConfluenceLegacyCommentPermissions;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'reactionsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    reactionsSummary?: Maybe<ConfluenceLegacyReactionsSummaryResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    replies: Array<Maybe<ConfluenceLegacyComment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: ConfluenceLegacyVersion;
};

export type ConfluenceLegacyCommentBodyArgs = {
    representation?: InputMaybe<ConfluenceLegacyDocumentRepresentation>;
};

export type ConfluenceLegacyCommentReactionsSummaryArgs = {
    childType: Scalars["String"]["input"];
    contentType?: InputMaybe<Scalars["String"]["input"]>;
    pageId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyCommentRepliesArgs = {
    depth?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyCommentBody = {
    representationFormat: ConfluenceLegacyContentRepresentation;
    value: Scalars["String"]["input"];
};

export enum ConfluenceLegacyCommentCreationLocation {
    Editor = "EDITOR",
    Live = "LIVE",
    Renderer = "RENDERER",
    Whiteboard = "WHITEBOARD"
}

export enum ConfluenceLegacyCommentDeletionLocation {
    Live = "LIVE"
}

export type ConfluenceLegacyCommentEdge = {
    __typename?: "ConfluenceLegacyCommentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyComment>;
};

export type ConfluenceLegacyCommentLocation = {
    type: Scalars["String"]["output"];
};

export type ConfluenceLegacyCommentPermissions = {
    __typename?: "ConfluenceLegacyCommentPermissions";
    isEditable: Scalars["Boolean"]["output"];
    isRemovable: Scalars["Boolean"]["output"];
    isResolvable: Scalars["Boolean"]["output"];
    isViewable: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyCommentReplySuggestion = {
    __typename?: "ConfluenceLegacyCommentReplySuggestion";
    commentReplyType: ConfluenceLegacyCommentReplyType;
    emojiId?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyCommentReplySuggestions = {
    __typename?: "ConfluenceLegacyCommentReplySuggestions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentSuggestions: Array<Maybe<ConfluenceLegacyCommentReplySuggestion>>;
};

export enum ConfluenceLegacyCommentReplyType {
    Emoji = "EMOJI",
    Prompt = "PROMPT",
    QuickReply = "QUICK_REPLY"
}

export enum ConfluenceLegacyCommentType {
    Footer = "FOOTER",
    Inline = "INLINE",
    Resolved = "RESOLVED",
    Unresolved = "UNRESOLVED"
}

export type ConfluenceLegacyCommentUpdate =
    ConfluenceLegacyAllUpdatesFeedEvent & {
        __typename?: "ConfluenceLegacyCommentUpdate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'comment' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        comment?: Maybe<ConfluenceLegacyComment>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        datetime: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: ConfluenceLegacyAllUpdatesFeedEventType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        user?: Maybe<ConfluenceLegacyPerson>;
    };

export type ConfluenceLegacyCommentUserAction = {
    __typename?: "ConfluenceLegacyCommentUserAction";
    id?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    style?: Maybe<Scalars["String"]["output"]>;
    tooltip?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyCommentsType {
    Footer = "FOOTER",
    Inline = "INLINE"
}

export type ConfluenceLegacyCompanyHubFeature = {
    __typename?: "ConfluenceLegacyCompanyHubFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyConfluenceUser = {
    __typename?: "ConfluenceLegacyConfluenceUser";
    accessStatus: ConfluenceLegacyAccessStatus;
    accountId?: Maybe<Scalars["String"]["output"]>;
    currentUser?: Maybe<ConfluenceLegacyCurrentUserOperations>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use groupWithId instead
     */
    groups: Array<Maybe<Scalars["String"]["output"]>>;
    groupsWithId: Array<Maybe<ConfluenceLegacyGroup>>;
    hasBlog?: Maybe<Scalars["Boolean"]["output"]>;
    hasPersonalSpace?: Maybe<Scalars["Boolean"]["output"]>;
    locale: Scalars["String"]["output"];
    operations: Array<Maybe<ConfluenceLegacyOperationCheckResult>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Consider using accessStatus as an alternative
     */
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    roles?: Maybe<ConfluenceLegacyUserRoles>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'space' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    space?: Maybe<ConfluenceLegacySpace>;
    userKey?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyContactAdminMutationInput = {
    content: ConfluenceLegacyContactAdminMutationInputContent;
    recaptchaResponseToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyContactAdminMutationInputContent = {
    from: Scalars["String"]["input"];
    requestDetails: Scalars["String"]["input"];
    subject: Scalars["String"]["input"];
};

export enum ConfluenceLegacyContactAdminPageDisabledReason {
    ConfigOff = "CONFIG_OFF",
    NoAdminEmails = "NO_ADMIN_EMAILS",
    NoMailServer = "NO_MAIL_SERVER",
    NoRecaptcha = "NO_RECAPTCHA"
}

export type ConfluenceLegacyContactAdminStatus = {
    __typename?: "ConfluenceLegacyContactAdminStatus";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyContainerLookAndFeel = {
    __typename?: "ConfluenceLegacyContainerLookAndFeel";
    background?: Maybe<Scalars["String"]["output"]>;
    backgroundAttachment?: Maybe<Scalars["String"]["output"]>;
    backgroundBlendMode?: Maybe<Scalars["String"]["output"]>;
    backgroundClip?: Maybe<Scalars["String"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<Scalars["String"]["output"]>;
    backgroundOrigin?: Maybe<Scalars["String"]["output"]>;
    backgroundPosition?: Maybe<Scalars["String"]["output"]>;
    backgroundRepeat?: Maybe<Scalars["String"]["output"]>;
    backgroundSize?: Maybe<Scalars["String"]["output"]>;
    borderRadius?: Maybe<Scalars["String"]["output"]>;
    padding?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyContainerSummary = {
    __typename?: "ConfluenceLegacyContainerSummary";
    displayUrl?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    title?: Maybe<Scalars["String"]["output"]>;
};

/** --------------------------------------------------------------------------------------------- */
export enum ConfluenceLegacyContainerType {
    Blogpost = "BLOGPOST",
    Page = "PAGE",
    Space = "SPACE",
    Whiteboard = "WHITEBOARD"
}

export type ConfluenceLegacyContent = {
    __typename?: "ConfluenceLegacyContent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ancestors?: Maybe<Array<Maybe<ConfluenceLegacyContent>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    archivableDescendantsCount: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    archiveNote?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    archivedContentMetadata?: Maybe<ConfluenceLegacyArchivedContentMetadata>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    attachments?: Maybe<ConfluenceLegacyPaginatedContentList>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    blank: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    body?: Maybe<ConfluenceLegacyContentBodyPerRepresentation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    childTypes?: Maybe<ConfluenceLegacyChildContentTypesAvailable>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    children?: Maybe<ConfluenceLegacyPaginatedContentList>;
    /**
     * GraphQL query to get classification level for content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    classificationLevelId?: Maybe<Scalars["String"]["output"]>;
    /**
     * GraphQL query to get classification level override for content.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    classificationLevelOverrideId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    comments?: Maybe<ConfluenceLegacyPaginatedContentList>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    container?: Maybe<ConfluenceLegacySpaceOrContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'contentAnalyticsViewers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentAnalyticsViewers?: Maybe<ConfluenceLegacyContentAnalyticsViewers>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'contentAnalyticsViews' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentAnalyticsViews?: Maybe<ConfluenceLegacyContentAnalyticsViews>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'contentAnalyticsViewsByUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentAnalyticsViewsByUser?: Maybe<ConfluenceLegacyContentAnalyticsViewsByUser>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'contentReactionsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentReactionsSummary?: Maybe<ConfluenceLegacyReactionsSummaryResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentState?: Maybe<ConfluenceLegacyContentState>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentStateLastUpdated?: Maybe<ConfluenceLegacyDate>;
    /**
     * Atlassian Account ID of the content creator. Internal only, clients should use history.createdBy field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    creatorId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserIsWatching: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deletableDescendantsCount: Scalars["Long"]["output"];
    /**
     * This is an experimental api created for connie mobile. It is bound to break, only use it if you know what you are doing.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dynamicMobileBody?: Maybe<ConfluenceLegacyContentBody>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    embeddedProduct?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    excerpt: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensions?: Maybe<Array<Maybe<ConfluenceLegacyKeyValueHierarchyMap>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasInheritedRestriction: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasInheritedRestrictions: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasRestriction: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasRestrictions: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasViewRestrictions: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasVisibleChildPages: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    history?: Maybe<ConfluenceLegacyHistory>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inContentTree: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    incomingLinks?: Maybe<ConfluenceLegacyPaginatedContentList>;
    /**
     * GraphQL query to determine whether export is enabled for content.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isExportEnabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labels?: Maybe<ConfluenceLegacyPaginatedLabelList>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likes?: Maybe<ConfluenceLegacyLikesResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    macroRenderedOutput?: Maybe<
        Array<Maybe<ConfluenceLegacyMapOfStringToFormattedBody>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaSession: ConfluenceLegacyContentMediaSession;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    metadata: ConfluenceLegacyContentMetadata;
    /**
     * Returns the body of the content that is rendered for mobile devices. Uses this query only if you know body is of legacy format
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mobileContentBody?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    outgoingLinks?: Maybe<ConfluenceLegacyOutgoingLinks>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    properties?: Maybe<ConfluenceLegacyPaginatedJsonContentPropertyList>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    referenceId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictions?: Maybe<ConfluenceLegacyContentRestrictions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    schedulePublishDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    schedulePublishInfo?: Maybe<ConfluenceLegacySchedulePublishInfo>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'smartFeatures' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    smartFeatures?: Maybe<ConfluenceLegacySmartPageFeatures>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version?: Maybe<ConfluenceLegacyVersion>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    visibleDescendantsCount: Scalars["Long"]["output"];
};

export type ConfluenceLegacyContentAttachmentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyContentChildrenArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyContentClassificationLevelIdArgs = {
    contentStatus: ConfluenceLegacyContentDataClassificationQueryContentStatus;
};

export type ConfluenceLegacyContentCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    depth?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    location?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    recentFirst?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyContentContentAnalyticsViewsByUserArgs = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyContentContentStateArgs = {
    isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyContentContentStateLastUpdatedArgs = {
    format?: InputMaybe<ConfluenceLegacyDateFormat>;
};

export type ConfluenceLegacyContentDynamicMobileBodyArgs = {
    imageLazyLoading?: Scalars["Boolean"]["input"];
    pagePropertiesReportMacroRenderAtServer?: Scalars["Boolean"]["input"];
};

export type ConfluenceLegacyContentExcerptArgs = {
    length?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyContentHasInheritedRestrictionArgs = {
    accountID: Scalars["String"]["input"];
    permission: ConfluenceLegacyInspectPermissions;
};

export type ConfluenceLegacyContentHasRestrictionArgs = {
    accountID: Scalars["String"]["input"];
    permission: ConfluenceLegacyInspectPermissions;
};

export type ConfluenceLegacyContentIncomingLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyContentLabelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<ConfluenceLegacyLabelSort>;
    prefix?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ConfluenceLegacyContentLikesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Long"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyContentMobileContentBodyArgs = {
    imageLazyLoading?: Scalars["Boolean"]["input"];
    pagePropertiesReportMacroRenderAtServer?: Scalars["Boolean"]["input"];
};

export type ConfluenceLegacyContentPropertiesArgs = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConfluenceLegacyContentAccessInputType {
    EveryoneCanEdit = "EVERYONE_CAN_EDIT",
    EveryoneCanView = "EVERYONE_CAN_VIEW",
    EveryoneNoAccess = "EVERYONE_NO_ACCESS",
    Private = "PRIVATE"
}

export enum ConfluenceLegacyContentAccessType {
    EveryoneCanEdit = "EVERYONE_CAN_EDIT",
    EveryoneCanView = "EVERYONE_CAN_VIEW",
    EveryoneNoAccess = "EVERYONE_NO_ACCESS"
}

export enum ConfluenceLegacyContentAction {
    Created = "created",
    Updated = "updated",
    Viewed = "viewed"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyContentAnalyticsLastViewedAtByPage = {
    __typename?: "ConfluenceLegacyContentAnalyticsLastViewedAtByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<
        Array<Maybe<ConfluenceLegacyContentAnalyticsLastViewedAtByPageItem>>
    >;
};

export type ConfluenceLegacyContentAnalyticsLastViewedAtByPageItem = {
    __typename?: "ConfluenceLegacyContentAnalyticsLastViewedAtByPageItem";
    contentId: Scalars["ID"]["output"];
    lastViewedAt: Scalars["String"]["output"];
};

export type ConfluenceLegacyContentAnalyticsPageViewInfo = {
    __typename?: "ConfluenceLegacyContentAnalyticsPageViewInfo";
    lastVersionViewed: Scalars["Int"]["output"];
    lastVersionViewedUrl?: Maybe<Scalars["String"]["output"]>;
    lastViewedAt: Scalars["String"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyAtlassianUser>;
    userId: Scalars["ID"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'userProfile' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userProfile?: Maybe<ConfluenceLegacyAtlassianUser>;
    views: Scalars["Int"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyContentAnalyticsTotalViewsByPage = {
    __typename?: "ConfluenceLegacyContentAnalyticsTotalViewsByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<
        Array<Maybe<ConfluenceLegacyContentAnalyticsTotalViewsByPageItem>>
    >;
};

export type ConfluenceLegacyContentAnalyticsTotalViewsByPageItem = {
    __typename?: "ConfluenceLegacyContentAnalyticsTotalViewsByPageItem";
    contentId: Scalars["ID"]["output"];
    totalViews: Scalars["Int"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyContentAnalyticsViewers = {
    __typename?: "ConfluenceLegacyContentAnalyticsViewers";
    count: Scalars["Int"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyContentAnalyticsViews = {
    __typename?: "ConfluenceLegacyContentAnalyticsViews";
    count: Scalars["Int"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyContentAnalyticsViewsByUser = {
    __typename?: "ConfluenceLegacyContentAnalyticsViewsByUser";
    id: Scalars["ID"]["output"];
    pageViews: Array<ConfluenceLegacyContentAnalyticsPageViewInfo>;
};

export type ConfluenceLegacyContentBody = {
    __typename?: "ConfluenceLegacyContentBody";
    content?: Maybe<ConfluenceLegacyContent>;
    embeddedContent: Array<Maybe<ConfluenceLegacyEmbeddedContent>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    macroRenderedOutput?: Maybe<ConfluenceLegacyFormattedBody>;
    macroRenderedRepresentation?: Maybe<Scalars["String"]["output"]>;
    mediaToken?: Maybe<ConfluenceLegacyEmbeddedMediaToken>;
    representation?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
    webresource?: Maybe<ConfluenceLegacyWebResourceDependencies>;
};

export type ConfluenceLegacyContentBodyInput = {
    representation: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceLegacyContentBodyPerRepresentation = {
    __typename?: "ConfluenceLegacyContentBodyPerRepresentation";
    atlasDocFormat?: Maybe<ConfluenceLegacyContentBody>;
    dynamic?: Maybe<ConfluenceLegacyContentBody>;
    editor?: Maybe<ConfluenceLegacyContentBody>;
    editor2?: Maybe<ConfluenceLegacyContentBody>;
    exportView?: Maybe<ConfluenceLegacyContentBody>;
    plain?: Maybe<ConfluenceLegacyContentBody>;
    raw?: Maybe<ConfluenceLegacyContentBody>;
    storage?: Maybe<ConfluenceLegacyContentBody>;
    styledView?: Maybe<ConfluenceLegacyContentBody>;
    view?: Maybe<ConfluenceLegacyContentBody>;
    wiki?: Maybe<ConfluenceLegacyContentBody>;
};

export type ConfluenceLegacyContentContributors = {
    __typename?: "ConfluenceLegacyContentContributors";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyPersonEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isCurrentUserContributor?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyContentCreationMetadata = {
    __typename?: "ConfluenceLegacyContentCreationMetadata";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserPermissions: ConfluenceLegacyPermissionMetadata;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    parent?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<ConfluenceLegacySpace>;
};

export type ConfluenceLegacyContentDataClassificationLevel = {
    __typename?: "ConfluenceLegacyContentDataClassificationLevel";
    color?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    guideline?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    order?: Maybe<Scalars["Int"]["output"]>;
    status: Scalars["String"]["output"];
};

export enum ConfluenceLegacyContentDataClassificationMutationContentStatus {
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ConfluenceLegacyContentDataClassificationQueryContentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ConfluenceLegacyContentDeleteActionType {
    DeleteDraft = "DELETE_DRAFT",
    DeleteDraftIfBlank = "DELETE_DRAFT_IF_BLANK",
    MoveToTrash = "MOVE_TO_TRASH",
    PurgeFromTrash = "PURGE_FROM_TRASH"
}

export type ConfluenceLegacyContentEdge = {
    __typename?: "ConfluenceLegacyContentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyContent>;
};

export type ConfluenceLegacyContentHistory = {
    __typename?: "ConfluenceLegacyContentHistory";
    by?: Maybe<ConfluenceLegacyPerson>;
    collaborators?: Maybe<ConfluenceLegacyContributorUsers>;
    friendlyWhen: Scalars["String"]["output"];
    message: Scalars["String"]["output"];
    minorEdit: Scalars["Boolean"]["output"];
    number: Scalars["Int"]["output"];
    state?: Maybe<ConfluenceLegacyContentState>;
    when: Scalars["String"]["output"];
};

export type ConfluenceLegacyContentHistoryEdge = {
    __typename?: "ConfluenceLegacyContentHistoryEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyContentHistory>;
};

export type ConfluenceLegacyContentLookAndFeel = {
    __typename?: "ConfluenceLegacyContentLookAndFeel";
    body?: Maybe<ConfluenceLegacyContainerLookAndFeel>;
    container?: Maybe<ConfluenceLegacyContainerLookAndFeel>;
    header?: Maybe<ConfluenceLegacyContainerLookAndFeel>;
    screen?: Maybe<ConfluenceLegacyScreenLookAndFeel>;
};

export type ConfluenceLegacyContentMediaSession = {
    __typename?: "ConfluenceLegacyContentMediaSession";
    /** Encapsulated access tokens for the media session. If the client does not have access to a given token, null will be returned, rather than an error being thrown */
    accessTokens: ConfluenceLegacyMediaAccessTokens;
    collection: Scalars["String"]["output"];
    configuration: ConfluenceLegacyMediaConfiguration;
    /** Returns a read-only token. Error will be thrown if user does not have appropriate permissions */
    downloadToken: ConfluenceLegacyMediaToken;
    mediaPickerUserToken?: Maybe<ConfluenceLegacyMediaPickerUserToken>;
    /** Returns a read+write token. Error will be thrown if user does not have appropriate permissions */
    token: ConfluenceLegacyMediaToken;
};

export type ConfluenceLegacyContentMetadata = {
    __typename?: "ConfluenceLegacyContentMetadata";
    comments?: Maybe<ConfluenceLegacyContentMetadataCommentsMetadataProviderComments>;
    createdDate?: Maybe<Scalars["String"]["output"]>;
    currentuser?: Maybe<ConfluenceLegacyContentMetadataCurrentUserMetadataProviderCurrentuser>;
    frontend?: Maybe<ConfluenceLegacyContentMetadataSpaFriendlyMetadataProviderFrontend>;
    labels?: Maybe<Array<Maybe<ConfluenceLegacyLabel>>>;
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    likes?: Maybe<ConfluenceLegacyLikesModelMetadataDto>;
    simple?: Maybe<ConfluenceLegacyContentMetadataSimpleContentMetadataProviderSimple>;
    sourceTemplateEntityId?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyContentMetadataCommentsMetadataProviderComments = {
    __typename?: "ConfluenceLegacyContentMetadataCommentsMetadataProviderComments";
    commentsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyContentMetadataCurrentUserMetadataProviderCurrentuser =
    {
        __typename?: "ConfluenceLegacyContentMetadataCurrentUserMetadataProviderCurrentuser";
        favourited?: Maybe<ConfluenceLegacyFavouritedSummary>;
        lastcontributed?: Maybe<ConfluenceLegacyContributionStatusSummary>;
        lastmodified?: Maybe<ConfluenceLegacyLastModifiedSummary>;
        scheduled?: Maybe<ConfluenceLegacyScheduledPublishSummary>;
        viewed?: Maybe<ConfluenceLegacyRecentlyViewedSummary>;
    };

export type ConfluenceLegacyContentMetadataSimpleContentMetadataProviderSimple =
    {
        __typename?: "ConfluenceLegacyContentMetadataSimpleContentMetadataProviderSimple";
        adfExtensions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
        hasComment?: Maybe<Scalars["Boolean"]["output"]>;
        hasInlineComment?: Maybe<Scalars["Boolean"]["output"]>;
        isFabric?: Maybe<Scalars["Boolean"]["output"]>;
    };

export type ConfluenceLegacyContentMetadataSpaFriendlyMetadataProviderFrontend =
    {
        __typename?: "ConfluenceLegacyContentMetadataSpaFriendlyMetadataProviderFrontend";
        collabService?: Maybe<Scalars["String"]["output"]>;
        collabServiceWithMigration?: Maybe<Scalars["String"]["output"]>;
        commentMacroNamesNotSpaFriendly?: Maybe<
            Array<Maybe<Scalars["String"]["output"]>>
        >;
        commentsSpaFriendly?: Maybe<Scalars["Boolean"]["output"]>;
        contentHash?: Maybe<Scalars["String"]["output"]>;
        coverPictureWidth?: Maybe<Scalars["String"]["output"]>;
        embedUrl?: Maybe<Scalars["String"]["output"]>;
        embedded: Scalars["Boolean"]["output"];
        embeddedWithMigration: Scalars["Boolean"]["output"];
        fabricEditorEligibility?: Maybe<Scalars["String"]["output"]>;
        fabricEditorSupported?: Maybe<Scalars["Boolean"]["output"]>;
        macroNamesNotSpaFriendly?: Maybe<
            Array<Maybe<Scalars["String"]["output"]>>
        >;
        migratedRecently?: Maybe<Scalars["Boolean"]["output"]>;
        spaFriendly?: Maybe<Scalars["Boolean"]["output"]>;
    };

export enum ConfluenceLegacyContentPermissionType {
    Edit = "EDIT",
    View = "VIEW"
}

export type ConfluenceLegacyContentPermissions = {
    __typename?: "ConfluenceLegacyContentPermissions";
    /**
     * GraphQL query to get content access level on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentAccess: ConfluenceLegacyContentAccessType;
    /**
     * Content permissions hash used by UI to figure out whether permissions were changed
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentPermissionsHash: Scalars["String"]["output"];
    /**
     * GraphQL query to get content permissions for current user on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUser?: Maybe<ConfluenceLegacySubjectUserOrGroup>;
    /**
     * GraphQL query to get effective content permissions for current user on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserWithEffectivePermissions: ConfluenceLegacyUsersWithEffectiveRestrictions;
    /**
     * GraphQL query to get a paged list of subjects which have actual content permissions on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithEffectiveContentPermissions: ConfluenceLegacyPaginatedSubjectUserOrGroupList;
    /**
     * GraphQL query to get a paged list of subjects which have explicit content permissions on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithPermissions: ConfluenceLegacyPaginatedSubjectUserOrGroupList;
};

export type ConfluenceLegacyContentPermissionsSubjectsWithEffectiveContentPermissionsArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        filterText?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type ConfluenceLegacyContentPermissionsSubjectsWithPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyContentPermissionsPayload = {
    __typename?: "ConfluenceLegacyContentPermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyContentRendererMode {
    Editor = "EDITOR",
    Pdf = "PDF",
    Renderer = "RENDERER"
}

export enum ConfluenceLegacyContentRepresentation {
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Editor = "EDITOR",
    Editor2 = "EDITOR2",
    ExportView = "EXPORT_VIEW",
    Plain = "PLAIN",
    Raw = "RAW",
    Storage = "STORAGE",
    StyledView = "STYLED_VIEW",
    View = "VIEW",
    Wiki = "WIKI"
}

export type ConfluenceLegacyContentRestriction = {
    __typename?: "ConfluenceLegacyContentRestriction";
    content?: Maybe<ConfluenceLegacyContent>;
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    operation?: Maybe<Scalars["String"]["output"]>;
    restrictions?: Maybe<ConfluenceLegacySubjectsByType>;
};

export type ConfluenceLegacyContentRestrictions = {
    __typename?: "ConfluenceLegacyContentRestrictions";
    administer?: Maybe<ConfluenceLegacyContentRestriction>;
    archive?: Maybe<ConfluenceLegacyContentRestriction>;
    copy?: Maybe<ConfluenceLegacyContentRestriction>;
    create?: Maybe<ConfluenceLegacyContentRestriction>;
    createSpace?: Maybe<ConfluenceLegacyContentRestriction>;
    delete?: Maybe<ConfluenceLegacyContentRestriction>;
    export?: Maybe<ConfluenceLegacyContentRestriction>;
    move?: Maybe<ConfluenceLegacyContentRestriction>;
    purge?: Maybe<ConfluenceLegacyContentRestriction>;
    purgeVersion?: Maybe<ConfluenceLegacyContentRestriction>;
    read?: Maybe<ConfluenceLegacyContentRestriction>;
    restore?: Maybe<ConfluenceLegacyContentRestriction>;
    restrictContent?: Maybe<ConfluenceLegacyContentRestriction>;
    update?: Maybe<ConfluenceLegacyContentRestriction>;
    use?: Maybe<ConfluenceLegacyContentRestriction>;
};

export type ConfluenceLegacyContentRestrictionsPageResponse = {
    __typename?: "ConfluenceLegacyContentRestrictionsPageResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictionsHash?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyContentRole {
    Default = "DEFAULT",
    Editor = "EDITOR",
    Viewer = "VIEWER"
}

export type ConfluenceLegacyContentSpecificCreateInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceLegacyContentState = {
    __typename?: "ConfluenceLegacyContentState";
    color: Scalars["String"]["output"];
    id?: Maybe<Scalars["ID"]["output"]>;
    isCallerPermitted?: Maybe<Scalars["Boolean"]["output"]>;
    name: Scalars["String"]["output"];
    restrictionLevel: ConfluenceLegacyContentStateRestrictionLevel;
};

export type ConfluenceLegacyContentStateInput = {
    color?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Long"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ConfluenceLegacyContentStateRestrictionLevel {
    None = "NONE",
    PageOwner = "PAGE_OWNER"
}

export type ConfluenceLegacyContentStateSettings = {
    __typename?: "ConfluenceLegacyContentStateSettings";
    contentStatesAllowed?: Maybe<Scalars["Boolean"]["output"]>;
    customContentStatesAllowed?: Maybe<Scalars["Boolean"]["output"]>;
    spaceContentStates?: Maybe<Array<Maybe<ConfluenceLegacyContentState>>>;
    spaceContentStatesAllowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ConfluenceLegacyContentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Deleted = "DELETED",
    Draft = "DRAFT"
}

export type ConfluenceLegacyContentTemplate = {
    __typename?: "ConfluenceLegacyContentTemplate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    body?: Maybe<ConfluenceLegacyEnrichableMapContentRepresentationContentBody>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editorVersion?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labels: Array<Maybe<ConfluenceLegacyLabel>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    originalTemplate?: Maybe<ConfluenceLegacyModuleCompleteKey>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    referencingBlueprint?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templateId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templateType?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyContentTemplateBodyInput = {
    atlasDocFormat: ConfluenceLegacyContentBodyInput;
};

export type ConfluenceLegacyContentTemplateEdge = {
    __typename?: "ConfluenceLegacyContentTemplateEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyContentTemplate>;
};

export type ConfluenceLegacyContentTemplateLabelInput = {
    id: Scalars["ID"]["input"];
    label?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    prefix?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyContentTemplateSpaceInput = {
    key: Scalars["String"]["input"];
};

export enum ConfluenceLegacyContentTemplateType {
    Blueprint = "BLUEPRINT",
    Page = "PAGE"
}

export type ConfluenceLegacyContributionStatusSummary = {
    __typename?: "ConfluenceLegacyContributionStatusSummary";
    status?: Maybe<Scalars["String"]["output"]>;
    when?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyContributorUsers = {
    __typename?: "ConfluenceLegacyContributorUsers";
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    userAccountIds: Array<Maybe<Scalars["String"]["output"]>>;
    userKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export type ConfluenceLegacyContributors = {
    __typename?: "ConfluenceLegacyContributors";
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    publishers?: Maybe<ConfluenceLegacyContributorUsers>;
};

export type ConfluenceLegacyConvertPageToLiveEditActionInput = {
    contentId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyConvertPageToLiveEditActionPayload = Payload & {
    __typename?: "ConfluenceLegacyConvertPageToLiveEditActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyConvertPageToLiveEditValidationResult = {
    __typename?: "ConfluenceLegacyConvertPageToLiveEditValidationResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasFooterComments?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasReactions?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasUnsupportedMacros?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyCopySpacePermissionsPayload = {
    __typename?: "ConfluenceLegacyCopySpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyCountGroupByEventName = {
    __typename?: "ConfluenceLegacyCountGroupByEventName";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyCountGroupByEventNameItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyGroupByPageInfo;
};

export type ConfluenceLegacyCountGroupByEventNameItem = {
    __typename?: "ConfluenceLegacyCountGroupByEventNameItem";
    count: Scalars["Int"]["output"];
    eventName: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyCountGroupByPage = {
    __typename?: "ConfluenceLegacyCountGroupByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyCountGroupByPageItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyGroupByPageInfo;
};

export type ConfluenceLegacyCountGroupByPageItem = {
    __typename?: "ConfluenceLegacyCountGroupByPageItem";
    count: Scalars["Int"]["output"];
    page: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyCountGroupBySpace = {
    __typename?: "ConfluenceLegacyCountGroupBySpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyCountGroupBySpaceItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyGroupByPageInfo;
};

export type ConfluenceLegacyCountGroupBySpaceItem = {
    __typename?: "ConfluenceLegacyCountGroupBySpaceItem";
    count: Scalars["Int"]["output"];
    space: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyCountGroupByUser = {
    __typename?: "ConfluenceLegacyCountGroupByUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyCountGroupByUserItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyGroupByPageInfo;
};

export type ConfluenceLegacyCountGroupByUserItem = {
    __typename?: "ConfluenceLegacyCountGroupByUserItem";
    count: Scalars["Int"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyAtlassianUser>;
    userId: Scalars["String"]["output"];
};

export type ConfluenceLegacyCqlMetaData = {
    __typename?: "ConfluenceLegacyCqlMetaData";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cqlContentTypes: Array<Maybe<ConfluenceLegacyCqlDisplayableType>>;
};

export type ConfluenceLegacyCqlMetaDataCqlContentTypesArgs = {
    category?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyCreateAdminAnnouncementBannerInput = {
    appearance: Scalars["String"]["input"];
    content: Scalars["String"]["input"];
    isDismissible: Scalars["Boolean"]["input"];
    scheduledEndTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledStartTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledTimeZone?: InputMaybe<Scalars["String"]["input"]>;
    status: ConfluenceLegacyAdminAnnouncementBannerStatusType;
    title?: InputMaybe<Scalars["String"]["input"]>;
    visibility: ConfluenceLegacyAdminAnnouncementBannerVisibilityType;
};

export type ConfluenceLegacyCreateCommentInput = {
    commentBody: ConfluenceLegacyCommentBody;
    commentSource?: InputMaybe<ConfluenceLegacyPlatform>;
    containerId: Scalars["ID"]["input"];
    parentCommentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ConfluenceLegacyCreateContentInput = {
    contentSpecificCreateInput?: InputMaybe<
        Array<ConfluenceLegacyContentSpecificCreateInput>
    >;
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    status: ConfluenceLegacyContentStatus;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type: Scalars["String"]["input"];
};

export type ConfluenceLegacyCreateContentTemplateInput = {
    body: ConfluenceLegacyContentTemplateBodyInput;
    description?: InputMaybe<Scalars["String"]["input"]>;
    labels?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyContentTemplateLabelInput>>
    >;
    name: Scalars["String"]["input"];
    space?: InputMaybe<ConfluenceLegacyContentTemplateSpaceInput>;
    templateType: ConfluenceLegacyContentTemplateType;
};

export type ConfluenceLegacyCreateContentTemplateLabelsInput = {
    contentTemplateId: Scalars["ID"]["input"];
    labels: Array<InputMaybe<ConfluenceLegacyContentTemplateLabelInput>>;
};

export type ConfluenceLegacyCreateFaviconFilesInput = {
    fileStoreId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyCreateFaviconFilesPayload = Payload & {
    __typename?: "ConfluenceLegacyCreateFaviconFilesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    faviconFiles?: Maybe<Array<ConfluenceLegacyFaviconFile>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyCreateInlineCommentInput = {
    commentBody: ConfluenceLegacyCommentBody;
    commentSource?: InputMaybe<ConfluenceLegacyPlatform>;
    containerId: Scalars["ID"]["input"];
    createdFrom: ConfluenceLegacyCommentCreationLocation;
    lastFetchTimeMillis: Scalars["Long"]["input"];
    /** matchIndex must be greater than or equal to 0. */
    matchIndex: Scalars["Int"]["input"];
    /** numMatches must be positive and greater than matchIndex. */
    numMatches: Scalars["Int"]["input"];
    originalSelection: Scalars["String"]["input"];
    parentCommentId?: InputMaybe<Scalars["ID"]["input"]>;
    publishedVersion?: InputMaybe<Scalars["Int"]["input"]>;
    step?: InputMaybe<ConfluenceLegacyStep>;
};

export type ConfluenceLegacyCreateInlineContentInput = {
    contentSpecificCreateInput?: InputMaybe<
        Array<ConfluenceLegacyContentSpecificCreateInput>
    >;
    createdInContentId: Scalars["ID"]["input"];
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type: Scalars["String"]["input"];
};

export type ConfluenceLegacyCreateInlineTaskNotificationInput = {
    contentId: Scalars["ID"]["input"];
    tasks: Array<
        InputMaybe<ConfluenceLegacyIndividualInlineTaskNotificationInput>
    >;
};

export type ConfluenceLegacyCreateInlineTaskNotificationPayload = Payload & {
    __typename?: "ConfluenceLegacyCreateInlineTaskNotificationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tasks: Array<Maybe<ConfluenceLegacyIndividualInlineTaskNotification>>;
};

export type ConfluenceLegacyCreateLivePageInput = {
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyCreateMentionNotificationInput = {
    contentId: Scalars["ID"]["input"];
    mentionLocalId?: InputMaybe<Scalars["ID"]["input"]>;
    mentionedUserAccountId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyCreateMentionNotificationPayload = Payload & {
    __typename?: "ConfluenceLegacyCreateMentionNotificationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyCreateMentionReminderNotificationInput = {
    contentId: Scalars["ID"]["input"];
    mentionData: Array<ConfluenceLegacyMentionData>;
};

export type ConfluenceLegacyCreateMentionReminderNotificationPayload =
    Payload & {
        __typename?: "ConfluenceLegacyCreateMentionReminderNotificationPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        contentId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        failedAccountIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyCreatePersonalSpaceInput = {
    /** Fetches the Space Permissions from the given space key and copies them to the new space. If this field is set, it must be accompanied with field initialPermissionOption: COPY_FROM_SPACE. */
    copySpacePermissionsFromSpaceKey?: InputMaybe<Scalars["String"]["input"]>;
    /** if this enum is set to PRIVATE, it will take precedence over copySpacePermissionsFromSpaceKey. */
    initialPermissionOption?: InputMaybe<ConfluenceLegacyInitialPermissionOptions>;
    spaceName: Scalars["String"]["input"];
};

export type ConfluenceLegacyCreateSpaceAdditionalSettingsInput = {
    jiraProject?: InputMaybe<ConfluenceLegacyCreateSpaceJiraProjectInput>;
    spaceTypeSettings?: InputMaybe<ConfluenceLegacySpaceTypeSettingsInput>;
};

export type ConfluenceLegacyCreateSpaceInput = {
    additionalSettings?: InputMaybe<ConfluenceLegacyCreateSpaceAdditionalSettingsInput>;
    /** if this field is set, it must be accompanied with field initialPermissionOption: COPY_FROM_SPACE. */
    copySpacePermissionsFromSpaceKey?: InputMaybe<Scalars["String"]["input"]>;
    /** if this enum is set to PRIVATE, it will take precedence over copySpacePermissionsFromSpaceKey. */
    initialPermissionOption?: InputMaybe<ConfluenceLegacyInitialPermissionOptions>;
    spaceKey: Scalars["String"]["input"];
    spaceLogoDataURI?: InputMaybe<Scalars["String"]["input"]>;
    spaceName: Scalars["String"]["input"];
    spaceTemplateKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyCreateSpaceJiraProjectInput = {
    jiraProjectKey: Scalars["String"]["input"];
    jiraProjectName?: InputMaybe<Scalars["String"]["input"]>;
    jiraServerId: Scalars["String"]["input"];
};

export type ConfluenceLegacyCreateUpdate =
    ConfluenceLegacyAllUpdatesFeedEvent & {
        __typename?: "ConfluenceLegacyCreateUpdate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        datetime: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: ConfluenceLegacyAllUpdatesFeedEventType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        user?: Maybe<ConfluenceLegacyPerson>;
    };

export type ConfluenceLegacyCurrentUserOperations = {
    __typename?: "ConfluenceLegacyCurrentUserOperations";
    canFollow?: Maybe<Scalars["Boolean"]["output"]>;
    followed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyDataSecurityPolicy = {
    __typename?: "ConfluenceLegacyDataSecurityPolicy";
    /**
     * Returns the set of Classification Level ARIs (aka User tags) for which the given Data Security Policy action is blocked as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    getClassificationLevelArisBlockingAction: Array<
        Maybe<Scalars["String"]["output"]>
    >;
    /**
     * Given a set of Content IDs and the ID of the Space they belong to, returns the subset which are blocked from the given Data Security Policy action as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    getContentIdsBlockedForAction: Array<Maybe<Scalars["Long"]["output"]>>;
    /**
     * Determines whether the given Data Security Policy action is enabled for the target Content as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActionEnabledForContent: ConfluenceLegacyDataSecurityPolicyDecision;
    /**
     * Determines whether the given Data Security Policy action is enabled for the given Space ID as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActionEnabledForSpace: ConfluenceLegacyDataSecurityPolicyDecision;
    /**
     * Determines whether the given Data Security Policy action is enabled for the containing Workspace as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActionEnabledForWorkspace: ConfluenceLegacyDataSecurityPolicyDecision;
};

export type ConfluenceLegacyDataSecurityPolicyGetClassificationLevelArisBlockingActionArgs =
    {
        action: ConfluenceLegacyDataSecurityPolicyAction;
    };

export type ConfluenceLegacyDataSecurityPolicyGetContentIdsBlockedForActionArgs =
    {
        action: ConfluenceLegacyDataSecurityPolicyAction;
        contentIds: Array<InputMaybe<Scalars["Long"]["input"]>>;
        spaceId: Scalars["Long"]["input"];
    };

export type ConfluenceLegacyDataSecurityPolicyIsActionEnabledForContentArgs = {
    action: ConfluenceLegacyDataSecurityPolicyAction;
    contentId: Scalars["Long"]["input"];
    contentStatus: ConfluenceLegacyDataSecurityPolicyDecidableContentStatus;
    contentVersion: Scalars["Int"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyDataSecurityPolicyIsActionEnabledForSpaceArgs = {
    action: ConfluenceLegacyDataSecurityPolicyAction;
    spaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyDataSecurityPolicyIsActionEnabledForWorkspaceArgs =
    {
        action: ConfluenceLegacyDataSecurityPolicyAction;
    };

export enum ConfluenceLegacyDataSecurityPolicyAction {
    AppAccess = "APP_ACCESS",
    PageExport = "PAGE_EXPORT",
    PublicLinks = "PUBLIC_LINKS"
}

export enum ConfluenceLegacyDataSecurityPolicyCoverageType {
    ClassificationLevel = "CLASSIFICATION_LEVEL",
    Container = "CONTAINER",
    None = "NONE",
    Workspace = "WORKSPACE"
}

export enum ConfluenceLegacyDataSecurityPolicyDecidableContentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export type ConfluenceLegacyDataSecurityPolicyDecision = {
    __typename?: "ConfluenceLegacyDataSecurityPolicyDecision";
    action?: Maybe<ConfluenceLegacyDataSecurityPolicyAction>;
    allowed?: Maybe<Scalars["Boolean"]["output"]>;
    appliedCoverage?: Maybe<ConfluenceLegacyDataSecurityPolicyCoverageType>;
};

export type ConfluenceLegacyDate = {
    __typename?: "ConfluenceLegacyDate";
    value: Scalars["String"]["output"];
};

export enum ConfluenceLegacyDateFormat {
    Global = "GLOBAL",
    Millis = "MILLIS",
    User = "USER",
    UserFriendly = "USER_FRIENDLY"
}

export type ConfluenceLegacyDeactivatePaywallContentInput = {
    deactivationIdentifier: Scalars["ID"]["input"];
};

export type ConfluenceLegacyDeactivatePaywallContentPayload = Payload & {
    __typename?: "ConfluenceLegacyDeactivatePaywallContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<MutationError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyDeactivatedPageOwnerUserType {
    FormerUsers = "FORMER_USERS",
    NonFormerUsers = "NON_FORMER_USERS"
}

export type ConfluenceLegacyDeactivatedUserPageCountEntity = {
    __typename?: "ConfluenceLegacyDeactivatedUserPageCountEntity";
    accountId?: Maybe<Scalars["ID"]["output"]>;
    pageCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyDeactivatedUserPageCountEntityEdge = {
    __typename?: "ConfluenceLegacyDeactivatedUserPageCountEntityEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyDeactivatedUserPageCountEntity>;
};

export type ConfluenceLegacyDeleteContentDataClassificationLevelInput = {
    contentStatus: ConfluenceLegacyContentDataClassificationMutationContentStatus;
    id: Scalars["Long"]["input"];
};

export type ConfluenceLegacyDeleteContentDataClassificationLevelPayload =
    Payload & {
        __typename?: "ConfluenceLegacyDeleteContentDataClassificationLevelPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyDeleteContentResponsePayload = {
    __typename?: "ConfluenceLegacyDeleteContentResponsePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    wasDeleted: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyDeleteContentTemplateLabelInput = {
    contentTemplateId: Scalars["ID"]["input"];
    labelId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyDeleteContentTemplateLabelPayload = {
    __typename?: "ConfluenceLegacyDeleteContentTemplateLabelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentTemplateId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labelId: Scalars["ID"]["output"];
};

export type ConfluenceLegacyDeleteDefaultSpaceRolesInput = {
    principalsList: Array<ConfluenceLegacyRoleAssignmentPrincipalInput>;
};

export type ConfluenceLegacyDeleteDefaultSpaceRolesPayload = Payload & {
    __typename?: "ConfluenceLegacyDeleteDefaultSpaceRolesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyDeleteExCoSpacePermissionsInput = {
    accountId: Scalars["String"]["input"];
};

export type ConfluenceLegacyDeleteExCoSpacePermissionsPayload = Payload & {
    __typename?: "ConfluenceLegacyDeleteExCoSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyDeleteExternalCollaboratorDefaultSpacePayload =
    Payload & {
        __typename?: "ConfluenceLegacyDeleteExternalCollaboratorDefaultSpacePayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyDeleteInlineCommentInput = {
    commentId: Scalars["ID"]["input"];
    step?: InputMaybe<ConfluenceLegacyStep>;
};

export type ConfluenceLegacyDeleteLabelInput = {
    contentId: Scalars["ID"]["input"];
    label: Scalars["String"]["input"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyDeleteLabelPayload = {
    __typename?: "ConfluenceLegacyDeleteLabelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    label: Scalars["String"]["output"];
};

export type ConfluenceLegacyDeletePagesInput = {
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

export type ConfluenceLegacyDeletePagesPayload = {
    __typename?: "ConfluenceLegacyDeletePagesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyDeleteRelationInput = {
    relationName: ConfluenceLegacyRelationType;
    sourceKey: Scalars["String"]["input"];
    sourceType: ConfluenceLegacyRelationSourceType;
    targetKey: Scalars["String"]["input"];
    targetType: ConfluenceLegacyRelationTargetType;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyDeleteRelationPayload = {
    __typename?: "ConfluenceLegacyDeleteRelationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relationName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sourceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    targetKey: Scalars["String"]["output"];
};

export type ConfluenceLegacyDeleteSpaceDefaultClassificationLevelInput = {
    id: Scalars["Long"]["input"];
};

export type ConfluenceLegacyDeleteSpaceDefaultClassificationLevelPayload =
    Payload & {
        __typename?: "ConfluenceLegacyDeleteSpaceDefaultClassificationLevelPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyDeleteSpaceRolesInput = {
    principalList: Array<ConfluenceLegacyRoleAssignmentPrincipalInput>;
    spaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyDeleteSpaceRolesPayload = Payload & {
    __typename?: "ConfluenceLegacyDeleteSpaceRolesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyDepth {
    All = "ALL",
    Root = "ROOT"
}

export enum ConfluenceLegacyDescendantsNoteApplicationOption {
    All = "ALL",
    None = "NONE",
    Roots = "ROOTS"
}

export type ConfluenceLegacyDetailCreator = {
    __typename?: "ConfluenceLegacyDetailCreator";
    accountId: Scalars["String"]["output"];
    canView: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
};

export type ConfluenceLegacyDetailLabels = {
    __typename?: "ConfluenceLegacyDetailLabels";
    displayTitle: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    urlPath: Scalars["String"]["output"];
};

export type ConfluenceLegacyDetailLastModified = {
    __typename?: "ConfluenceLegacyDetailLastModified";
    friendlyModificationDate: Scalars["String"]["output"];
    sortableDate: Scalars["String"]["output"];
};

export type ConfluenceLegacyDetailLine = {
    __typename?: "ConfluenceLegacyDetailLine";
    commentsCount: Scalars["Int"]["output"];
    creator?: Maybe<ConfluenceLegacyDetailCreator>;
    details: Array<Maybe<Scalars["String"]["output"]>>;
    id: Scalars["Long"]["output"];
    labels: Array<Maybe<ConfluenceLegacyDetailLabels>>;
    lastModified?: Maybe<ConfluenceLegacyDetailLastModified>;
    likesCount: Scalars["Int"]["output"];
    macroId?: Maybe<Scalars["String"]["output"]>;
    reactionsCount: Scalars["Int"]["output"];
    relativeLink: Scalars["String"]["output"];
    rowId: Scalars["Int"]["output"];
    subRelativeLink: Scalars["String"]["output"];
    subTitle: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    unresolvedCommentsCount: Scalars["Int"]["output"];
};

export type ConfluenceLegacyDetailsSummaryLines = {
    __typename?: "ConfluenceLegacyDetailsSummaryLines";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    asyncRenderSafe: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentPage: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    detailLines: Array<Maybe<ConfluenceLegacyDetailLine>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    macroId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    renderedHeadings: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalPages: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webResources: Array<Maybe<Scalars["String"]["output"]>>;
};

export type ConfluenceLegacyDisablePublicLinkForPagePayload = {
    __typename?: "ConfluenceLegacyDisablePublicLinkForPagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
};

export type ConfluenceLegacyDiscoveredFeature = {
    __typename?: "ConfluenceLegacyDiscoveredFeature";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    date?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featureKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pluginKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyDocumentBody = {
    __typename?: "ConfluenceLegacyDocumentBody";
    representation: ConfluenceLegacyDocumentRepresentation;
    value: Scalars["String"]["output"];
};

export enum ConfluenceLegacyDocumentRepresentation {
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Html = "HTML",
    Storage = "STORAGE",
    View = "VIEW"
}

export type ConfluenceLegacyEditUpdate = ConfluenceLegacyAllUpdatesFeedEvent & {
    __typename?: "ConfluenceLegacyEditUpdate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacyAllUpdatesFeedEventType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyPerson>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Scalars["Int"]["output"];
};

export enum ConfluenceLegacyEdition {
    Free = "FREE",
    Premium = "PREMIUM",
    Standard = "STANDARD"
}

export type ConfluenceLegacyEditions = {
    __typename?: "ConfluenceLegacyEditions";
    edition: ConfluenceLegacyEdition;
};

export enum ConfluenceLegacyEditorConversionSetting {
    None = "NONE",
    Supported = "SUPPORTED"
}

export type ConfluenceLegacyEditorVersionsMetadataDto = {
    __typename?: "ConfluenceLegacyEditorVersionsMetadataDto";
    blogpost?: Maybe<Scalars["String"]["output"]>;
    default?: Maybe<Scalars["String"]["output"]>;
    page?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyEmbeddedContent = {
    __typename?: "ConfluenceLegacyEmbeddedContent";
    entity?: Maybe<ConfluenceLegacyContent>;
    entityId?: Maybe<Scalars["Long"]["output"]>;
    entityType?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
};

export type ConfluenceLegacyEmbeddedMediaToken = {
    __typename?: "ConfluenceLegacyEmbeddedMediaToken";
    collectionIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    contentId?: Maybe<Scalars["ID"]["output"]>;
    expiryDateTime?: Maybe<Scalars["String"]["output"]>;
    fileIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    token?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a smart-link rendered as embedded on a page */
export type ConfluenceLegacyEmbeddedSmartLink = ConfluenceLegacySmartLink & {
    __typename?: "ConfluenceLegacyEmbeddedSmartLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    layout: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    width: Scalars["Float"]["output"];
};

export type ConfluenceLegacyEnablePublicLinkForPagePayload = {
    __typename?: "ConfluenceLegacyEnablePublicLinkForPagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkUrlPath: Scalars["String"]["output"];
};

export type ConfluenceLegacyEnabledContentTypes = {
    __typename?: "ConfluenceLegacyEnabledContentTypes";
    isBlogsEnabled: Scalars["Boolean"]["output"];
    isDatabasesEnabled: Scalars["Boolean"]["output"];
    isEmbedsEnabled: Scalars["Boolean"]["output"];
    isFoldersEnabled: Scalars["Boolean"]["output"];
    isLivePagesEnabled: Scalars["Boolean"]["output"];
    isWhiteboardsEnabled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyEnabledContentTypesInput = {
    isBlogsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isDatabasesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isEmbedsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isFoldersEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isLivePagesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isWhiteboardsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyEnabledFeatures = {
    __typename?: "ConfluenceLegacyEnabledFeatures";
    isAnalyticsEnabled: Scalars["Boolean"]["output"];
    isAppsEnabled: Scalars["Boolean"]["output"];
    isAutomationEnabled: Scalars["Boolean"]["output"];
    isCalendarsEnabled: Scalars["Boolean"]["output"];
    isContentManagerEnabled: Scalars["Boolean"]["output"];
    isQuestionsEnabled: Scalars["Boolean"]["output"];
    isShortcutsEnabled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyEnabledFeaturesInput = {
    isAnalyticsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isAppsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isAutomationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isCalendarsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isContentManagerEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isQuestionsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isShortcutsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyEnrichableMapContentRepresentationContentBody = {
    __typename?: "ConfluenceLegacyEnrichableMapContentRepresentationContentBody";
    atlasDocFormat?: Maybe<ConfluenceLegacyContentBody>;
    dynamic?: Maybe<ConfluenceLegacyContentBody>;
    editor?: Maybe<ConfluenceLegacyContentBody>;
    editor2?: Maybe<ConfluenceLegacyContentBody>;
    exportView?: Maybe<ConfluenceLegacyContentBody>;
    plain?: Maybe<ConfluenceLegacyContentBody>;
    raw?: Maybe<ConfluenceLegacyContentBody>;
    storage?: Maybe<ConfluenceLegacyContentBody>;
    styledView?: Maybe<ConfluenceLegacyContentBody>;
    view?: Maybe<ConfluenceLegacyContentBody>;
    wiki?: Maybe<ConfluenceLegacyContentBody>;
};

export type ConfluenceLegacyEntitlements = {
    __typename?: "ConfluenceLegacyEntitlements";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    adminAnnouncementBanner: ConfluenceLegacyAdminAnnouncementBannerFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    archive: ConfluenceLegacyArchiveFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bulkActions: ConfluenceLegacyBulkActionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    companyHub: ConfluenceLegacyCompanyHubFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    externalCollaborator: ConfluenceLegacyExternalCollaboratorFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nestedActions: ConfluenceLegacyNestedActionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    premiumExtensions: ConfluenceLegacyPremiumExtensionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    teamCalendar: ConfluenceLegacyTeamCalendarFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    whiteboardFeatures?: Maybe<ConfluenceLegacyWhiteboardFeatures>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyEntityCountBySpace = {
    __typename?: "ConfluenceLegacyEntityCountBySpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyEntityCountBySpaceItem>;
};

export type ConfluenceLegacyEntityCountBySpaceItem = {
    __typename?: "ConfluenceLegacyEntityCountBySpaceItem";
    count: Scalars["Int"]["output"];
    space: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyEntityTimeseriesCount = {
    __typename?: "ConfluenceLegacyEntityTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyEntityTimeseriesCountItem>;
};

export type ConfluenceLegacyEntityTimeseriesCountItem = {
    __typename?: "ConfluenceLegacyEntityTimeseriesCountItem";
    /** Analytics count */
    count: Scalars["Int"]["output"];
    /** Grouping date in ISO format */
    date: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export enum ConfluenceLegacyEnvironment {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING"
}

export type ConfluenceLegacyError = {
    __typename?: "ConfluenceLegacyError";
    message: Scalars["String"]["output"];
    status: Scalars["Int"]["output"];
};

/** The default space assigned to new Confluence Guests on role assignment. */
export type ConfluenceLegacyExternalCollaboratorDefaultSpace = {
    __typename?: "ConfluenceLegacyExternalCollaboratorDefaultSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    enabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["Long"]["output"];
};

export type ConfluenceLegacyExternalCollaboratorFeature = {
    __typename?: "ConfluenceLegacyExternalCollaboratorFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyExternalCollaboratorsSortField {
    Name = "NAME"
}

export type ConfluenceLegacyExternalCollaboratorsSortType = {
    field?: InputMaybe<ConfluenceLegacyExternalCollaboratorsSortField>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyFaviconFile = {
    __typename?: "ConfluenceLegacyFaviconFile";
    fileStoreId: Scalars["ID"]["output"];
    filename: Scalars["String"]["output"];
};

export type ConfluenceLegacyFaviconFileInput = {
    fileStoreId: Scalars["ID"]["input"];
    filename: Scalars["String"]["input"];
};

export type ConfluenceLegacyFavouritePageInput = {
    pageId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyFavouritePagePayload = {
    __typename?: "ConfluenceLegacyFavouritePagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: ConfluenceLegacyContent;
};

export type ConfluenceLegacyFavouriteSpacePayload = {
    __typename?: "ConfluenceLegacyFavouriteSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSpaceFavourited?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyFavouritedSummary = {
    __typename?: "ConfluenceLegacyFavouritedSummary";
    favouritedDate?: Maybe<Scalars["String"]["output"]>;
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyFeatureDiscoveryPayload = {
    __typename?: "ConfluenceLegacyFeatureDiscoveryPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    date?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featureKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pluginKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyFeedEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacyFeedEventType;
};

export type ConfluenceLegacyFeedEventComment = ConfluenceLegacyFeedEvent & {
    __typename?: "ConfluenceLegacyFeedEventComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'comment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    comment?: Maybe<ConfluenceLegacyComment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacyFeedEventType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyPerson>;
};

export type ConfluenceLegacyFeedEventCreate = ConfluenceLegacyFeedEvent & {
    __typename?: "ConfluenceLegacyFeedEventCreate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacyFeedEventType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyPerson>;
};

export type ConfluenceLegacyFeedEventEdit = ConfluenceLegacyFeedEvent & {
    __typename?: "ConfluenceLegacyFeedEventEdit";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacyFeedEventType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyPerson>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Scalars["Int"]["output"];
};

export enum ConfluenceLegacyFeedEventType {
    Comment = "COMMENT",
    Create = "CREATE",
    Edit = "EDIT"
}

export type ConfluenceLegacyFeedItem = {
    __typename?: "ConfluenceLegacyFeedItem";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    id: Scalars["String"]["output"];
    mostRelevantUpdate: Scalars["Int"]["output"];
    recentActionsCount: Scalars["Int"]["output"];
    source: Array<ConfluenceLegacyFeedItemSourceType>;
    summaryLineUpdate: ConfluenceLegacyFeedEvent;
};

export type ConfluenceLegacyFeedItemEdge = {
    __typename?: "ConfluenceLegacyFeedItemEdge";
    /** Edge cursor pagination is not supported. This will always be null! Use the endCursor in pageInfo for forward pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: ConfluenceLegacyFeedItem;
};

export enum ConfluenceLegacyFeedItemSourceType {
    Person = "PERSON",
    Space = "SPACE"
}

export type ConfluenceLegacyFeedPageInfo = {
    __typename?: "ConfluenceLegacyFeedPageInfo";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be false. */
    hasPreviousPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be null. */
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyFeedPageInformation = {
    __typename?: "ConfluenceLegacyFeedPageInformation";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be false. */
    hasPreviousPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be null. */
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyFeedType {
    Direct = "DIRECT",
    Following = "FOLLOWING",
    Popular = "POPULAR"
}

export type ConfluenceLegacyFilteredPrincipalSubjectKey = {
    __typename?: "ConfluenceLegacyFilteredPrincipalSubjectKey";
    /** User display name for a user, or group name for a group */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** If subject type is not GROUP, then this query will return null */
    group?: Maybe<ConfluenceLegacyGroup>;
    /** User account id for a user, or group external id for a group */
    id?: Maybe<Scalars["String"]["output"]>;
    /** Subject Permission Display Type--to filter principals by their role (see PermissionDisplayType.java */
    permissionDisplayType: ConfluenceLegacyPermissionDisplayType;
    /** If subject type is not USER, then this query will return null */
    user?: Maybe<ConfluenceLegacyUser>;
};

export type ConfluenceLegacyFollowUserInput = {
    accountId: Scalars["String"]["input"];
};

export type ConfluenceLegacyFollowUserPayload = {
    __typename?: "ConfluenceLegacyFollowUserPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserFollowing: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyFollowingFeedGetUserConfig = {
    __typename?: "ConfluenceLegacyFollowingFeedGetUserConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountIds: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    servingRecommendations: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceIds: Array<Maybe<Scalars["Long"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'spaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    spaces?: Maybe<Array<Maybe<ConfluenceLegacySpace>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export type ConfluenceLegacyFooterComment = ConfluenceLegacyCommentLocation & {
    __typename?: "ConfluenceLegacyFooterComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: Scalars["String"]["output"];
};

export type ConfluenceLegacyFormattedBody = {
    __typename?: "ConfluenceLegacyFormattedBody";
    embeddedContent: Array<Maybe<ConfluenceLegacyEmbeddedContent>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    macroRenderedOutput?: Maybe<ConfluenceLegacyFormattedBody>;
    macroRenderedRepresentation?: Maybe<Scalars["String"]["output"]>;
    representation?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
    webresource?: Maybe<ConfluenceLegacyWebResourceDependencies>;
};

export enum ConfluenceLegacyFrontCoverState {
    Hidden = "HIDDEN",
    Shown = "SHOWN",
    Transition = "TRANSITION",
    Unset = "UNSET"
}

export type ConfluenceLegacyFrontendResource = {
    __typename?: "ConfluenceLegacyFrontendResource";
    attributes: Array<Maybe<ConfluenceLegacyMapOfStringToString>>;
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyFrontendResourceRenderResponse = {
    __typename?: "ConfluenceLegacyFrontendResourceRenderResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceList: Array<ConfluenceLegacyFrontendResource>;
};

export type ConfluenceLegacyFutureContentTypeMobileSupport = {
    __typename?: "ConfluenceLegacyFutureContentTypeMobileSupport";
    /**
     * Localized body text
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bodyText?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     * Content type name, e.g., whiteboard
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentType: Scalars["String"]["output"];
    /**
     * Localized heading
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    heading: Scalars["String"]["output"];
    /**
     * A link to the image, e.g., /sample/whiteboards.png
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    imageLink?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the content type is supported now by the latest mobile app of the specified platform
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSupportedNow: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyGlobalDescription = {
    __typename?: "ConfluenceLegacyGlobalDescription";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type ConfluenceLegacyGlobalSpaceConfiguration = {
    __typename?: "ConfluenceLegacyGlobalSpaceConfiguration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkDefaultSpaceStatus?: Maybe<ConfluenceLegacyPublicLinkDefaultSpaceStatus>;
};

export type ConfluenceLegacyGlobalSpaceIdentifier = {
    __typename?: "ConfluenceLegacyGlobalSpaceIdentifier";
    spaceIdentifier?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyGrantContentAccessInput = {
    accessType: ConfluenceLegacyAccessType;
    accountIdOrUsername: Scalars["String"]["input"];
    contentId: Scalars["String"]["input"];
};

export type ConfluenceLegacyGrantContentAccessPayload = {
    __typename?: "ConfluenceLegacyGrantContentAccessPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyGroup = {
    __typename?: "ConfluenceLegacyGroup";
    id?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    name?: Maybe<Scalars["String"]["output"]>;
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
};

export type ConfluenceLegacyGroupByPageInfo = {
    __typename?: "ConfluenceLegacyGroupByPageInfo";
    next?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyGroupCountsResult = {
    __typename?: "ConfluenceLegacyGroupCountsResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupCounts: Array<Maybe<ConfluenceLegacyMapOfStringToInteger>>;
};

export type ConfluenceLegacyGroupEdge = {
    __typename?: "ConfluenceLegacyGroupEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyGroup>;
};

export type ConfluenceLegacyGroupWithPermissions = {
    __typename?: "ConfluenceLegacyGroupWithPermissions";
    currentUserCanEdit?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksSelf>;
    name?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
};

export type ConfluenceLegacyGroupWithPermissionsEdge = {
    __typename?: "ConfluenceLegacyGroupWithPermissionsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyGroupWithPermissions>;
};

export type ConfluenceLegacyGroupWithPermissionsInput = {
    id: Scalars["ID"]["input"];
    operations: Array<InputMaybe<ConfluenceLegacyOperationCheckResultInput>>;
};

export type ConfluenceLegacyGroupWithRestrictions = {
    __typename?: "ConfluenceLegacyGroupWithRestrictions";
    group?: Maybe<ConfluenceLegacyGroup>;
    hasSpaceEditPermission?: Maybe<Scalars["Boolean"]["output"]>;
    hasSpaceViewPermission?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksSelf>;
    name?: Maybe<Scalars["String"]["output"]>;
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    restrictingContent?: Maybe<ConfluenceLegacyContent>;
};

export type ConfluenceLegacyGroupWithRestrictionsEdge = {
    __typename?: "ConfluenceLegacyGroupWithRestrictionsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyGroupWithRestrictions>;
};

export type ConfluenceLegacyHardDeleteSpacePayload = {
    __typename?: "ConfluenceLegacyHardDeleteSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyHeaderLookAndFeel = {
    __typename?: "ConfluenceLegacyHeaderLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    button?: Maybe<ConfluenceLegacyButtonLookAndFeel>;
    primaryNavigation?: Maybe<ConfluenceLegacyNavigationLookAndFeel>;
    search?: Maybe<ConfluenceLegacySearchFieldLookAndFeel>;
    secondaryNavigation?: Maybe<ConfluenceLegacyNavigationLookAndFeel>;
};

export type ConfluenceLegacyHistory = {
    __typename?: "ConfluenceLegacyHistory";
    contributors?: Maybe<ConfluenceLegacyContributors>;
    createdBy?: Maybe<ConfluenceLegacyPerson>;
    createdDate?: Maybe<Scalars["String"]["output"]>;
    lastOwnedBy?: Maybe<ConfluenceLegacyPerson>;
    lastUpdated?: Maybe<ConfluenceLegacyVersion>;
    latest?: Maybe<Scalars["Boolean"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    nextVersion?: Maybe<ConfluenceLegacyVersion>;
    ownedBy?: Maybe<ConfluenceLegacyPerson>;
    previousVersion?: Maybe<ConfluenceLegacyVersion>;
};

export type ConfluenceLegacyHomeUserSettings = {
    __typename?: "ConfluenceLegacyHomeUserSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relevantFeedFilters: ConfluenceLegacyRelevantFeedFilters;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shouldShowActivityFeed: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shouldShowSpaces: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyHomeUserSettingsInput = {
    shouldShowActivityFeed?: InputMaybe<Scalars["Boolean"]["input"]>;
    shouldShowSpaces?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyHomeWidget = {
    __typename?: "ConfluenceLegacyHomeWidget";
    id: Scalars["ID"]["output"];
    state: ConfluenceLegacyHomeWidgetState;
};

export type ConfluenceLegacyHomeWidgetInput = {
    id: Scalars["ID"]["input"];
    state: ConfluenceLegacyHomeWidgetState;
};

export enum ConfluenceLegacyHomeWidgetState {
    Collapsed = "COLLAPSED",
    Expanded = "EXPANDED"
}

export type ConfluenceLegacyHtmlDocument = {
    __typename?: "ConfluenceLegacyHtmlDocument";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    html?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webResourceDependencies?: Maybe<ConfluenceLegacyWebResourceDependencies>;
};

export type ConfluenceLegacyHtmlMeta = {
    __typename?: "ConfluenceLegacyHtmlMeta";
    css: Scalars["String"]["output"];
    html: Scalars["String"]["output"];
    js: Array<Maybe<Scalars["String"]["output"]>>;
    spaUnfriendlyMacros: Array<ConfluenceLegacySpaUnfriendlyMacro>;
};

export type ConfluenceLegacyIcon = {
    __typename?: "ConfluenceLegacyIcon";
    height?: Maybe<Scalars["Int"]["output"]>;
    isDefault?: Maybe<Scalars["Boolean"]["output"]>;
    path: Scalars["String"]["output"];
    width?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyIconPathArgs = {
    type?: InputMaybe<ConfluenceLegacyPathType>;
};

export type ConfluenceLegacyIncomingLinksCount = {
    __typename?: "ConfluenceLegacyIncomingLinksCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyIndividualInlineTaskNotification = {
    __typename?: "ConfluenceLegacyIndividualInlineTaskNotification";
    operation: ConfluenceLegacyOperation;
    recipientAccountId: Scalars["ID"]["output"];
    taskId: Scalars["ID"]["output"];
};

export type ConfluenceLegacyIndividualInlineTaskNotificationInput = {
    operation: ConfluenceLegacyOperation;
    recipientAccountId: Scalars["ID"]["input"];
    taskId: Scalars["ID"]["input"];
};

export enum ConfluenceLegacyInitialPermissionOptions {
    CopyFromSpace = "COPY_FROM_SPACE",
    Default = "DEFAULT",
    Private = "PRIVATE"
}

export type ConfluenceLegacyInlineComment = ConfluenceLegacyCommentLocation & {
    __typename?: "ConfluenceLegacyInlineComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineCommentRepliesCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineMarkerRef?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineResolveProperties?: Maybe<ConfluenceLegacyInlineCommentResolveProperties>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineText?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: Scalars["String"]["output"];
};

export type ConfluenceLegacyInlineCommentResolveProperties = {
    __typename?: "ConfluenceLegacyInlineCommentResolveProperties";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolved: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedByDangling: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedFriendlyDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedTime?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedUser?: Maybe<Scalars["String"]["output"]>;
};

/** Represents an inline-rendered smart-link on a page */
export type ConfluenceLegacyInlineSmartLink = ConfluenceLegacySmartLink & {
    __typename?: "ConfluenceLegacyInlineSmartLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type ConfluenceLegacyInlineTask = {
    __typename?: "ConfluenceLegacyInlineTask";
    /** UserInfo of the user who has been assigned the Task. */
    assignedTo?: Maybe<ConfluenceLegacyUserInfo>;
    /** Body of the Task. */
    body?: Maybe<ConfluenceContentBody>;
    /** UserInfo of the user who has completed the Task. */
    completedBy?: Maybe<ConfluenceLegacyUserInfo>;
    /** Entity that contains Task. */
    container?: Maybe<ConfluenceInlineTaskContainer>;
    /** Date and time the Task was created. */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** UserInfo of the user who created the Task. */
    createdBy?: Maybe<ConfluenceLegacyUserInfo>;
    /** Date and time the Task is due. */
    dueAt?: Maybe<Scalars["String"]["output"]>;
    /** Global ID of the Task. */
    globalId?: Maybe<Scalars["ID"]["output"]>;
    /** The ARI of the Task, ConfluenceTaskARI format. */
    id: Scalars["ID"]["output"];
    /** Status of the Task. */
    status?: Maybe<ConfluenceInlineTaskStatus>;
    /** ID of the Task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
    /** Date and time the Task was updated. */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyInlineTaskInput = {
    status: ConfluenceLegacyTaskStatus;
    taskId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyInlineTasksByMetadata = {
    accountIds?: InputMaybe<ConfluenceLegacyInlineTasksQueryAccountIds>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The date range for an Inline Tasks' Completed Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
    completedDateRange?: InputMaybe<ConfluenceLegacyInlineTasksQueryDateRange>;
    /** The date range for an Inline Tasks' Created Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
    createdDateRange?: InputMaybe<ConfluenceLegacyInlineTasksQueryDateRange>;
    /** The date range for an Inline Tasks' Due Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
    dueDate?: InputMaybe<ConfluenceLegacyInlineTasksQueryDateRange>;
    first: Scalars["Int"]["input"];
    /** A boolean value representing whether to return task on current page or on child pages as well */
    forCurrentPageOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A boolean value representing whether or not a Task has a set due date. False indicates no due date set for a given task. */
    isNoDueDate?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    /** Supported sort columns for a Task query are: `due date`, `assignee`, and `page title`. Supported sort columns are `ASC` or `DESC`. */
    sortParameters?: InputMaybe<ConfluenceLegacyInlineTasksQuerySortParameters>;
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    status?: InputMaybe<ConfluenceLegacyTaskStatus>;
};

export type ConfluenceLegacyInlineTasksInput = {
    cid: Scalars["ID"]["input"];
    status: ConfluenceLegacyTaskStatus;
    taskId: Scalars["ID"]["input"];
    trigger?: InputMaybe<ConfluenceLegacyPageUpdateTrigger>;
};

export type ConfluenceLegacyInlineTasksQueryAccountIds = {
    assigneeAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    completedByAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    creatorAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
};

/** The date range for an Inline Tasks Query Date. Start dates and end dates can be null-able to represent no specified boundary. */
export type ConfluenceLegacyInlineTasksQueryDateRange = {
    endDate?: InputMaybe<Scalars["Long"]["input"]>;
    startDate?: InputMaybe<Scalars["Long"]["input"]>;
};

export type ConfluenceLegacyInlineTasksQueryResult = {
    __typename?: "ConfluenceLegacyInlineTasksQueryResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    endCursor?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineTasks?: Maybe<Array<Maybe<ConfluenceLegacyInlineTask>>>;
};

export enum ConfluenceLegacyInlineTasksQuerySortColumn {
    Assignee = "ASSIGNEE",
    DueDate = "DUE_DATE",
    PageTitle = "PAGE_TITLE"
}

export enum ConfluenceLegacyInlineTasksQuerySortOrder {
    Ascending = "ASCENDING",
    Descending = "DESCENDING"
}

export type ConfluenceLegacyInlineTasksQuerySortParameters = {
    sortColumn: ConfluenceLegacyInlineTasksQuerySortColumn;
    sortOrder: ConfluenceLegacyInlineTasksQuerySortOrder;
};

export enum ConfluenceLegacyInspectPermissions {
    Comment = "COMMENT",
    Edit = "EDIT",
    View = "VIEW"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyInstanceAnalyticsCount = {
    __typename?: "ConfluenceLegacyInstanceAnalyticsCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    user: Scalars["Int"]["output"];
};

export type ConfluenceLegacyJiraProject = {
    __typename?: "ConfluenceLegacyJiraProject";
    icons?: Maybe<Array<Maybe<ConfluenceLegacyIcon>>>;
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type ConfluenceLegacyJiraProjectsResult = {
    __typename?: "ConfluenceLegacyJiraProjectsResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyJiraProject>;
};

export type ConfluenceLegacyJiraServer = {
    __typename?: "ConfluenceLegacyJiraServer";
    authUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isCurrentUserAuthenticated: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export type ConfluenceLegacyJiraServersResult = {
    __typename?: "ConfluenceLegacyJiraServersResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyJiraServer>;
};

export type ConfluenceLegacyJsonContentProperty = {
    __typename?: "ConfluenceLegacyJsonContentProperty";
    content?: Maybe<ConfluenceLegacyContent>;
    id?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    value?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<ConfluenceLegacyVersion>;
};

export type ConfluenceLegacyJsonContentPropertyEdge = {
    __typename?: "ConfluenceLegacyJsonContentPropertyEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyJsonContentProperty>;
};

export type ConfluenceLegacyKeyValueHierarchyMap = {
    __typename?: "ConfluenceLegacyKeyValueHierarchyMap";
    fields?: Maybe<Array<Maybe<ConfluenceLegacyKeyValueHierarchyMap>>>;
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyKnownUser = ConfluenceLegacyPerson & {
    __typename?: "ConfluenceLegacyKnownUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    personalSpace?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timeZone?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    username?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLabel = {
    __typename?: "ConfluenceLegacyLabel";
    id?: Maybe<Scalars["ID"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    prefix?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLabelEdge = {
    __typename?: "ConfluenceLegacyLabelEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyLabel>;
};

export type ConfluenceLegacyLabelInput = {
    name: Scalars["String"]["input"];
    prefix: Scalars["String"]["input"];
};

export type ConfluenceLegacyLabelSearchResults = {
    __typename?: "ConfluenceLegacyLabelSearchResults";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    otherLabels: Array<Maybe<ConfluenceLegacyLabel>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suggestedLabels: Array<Maybe<ConfluenceLegacyLabel>>;
};

export type ConfluenceLegacyLabelSort = {
    direction: ConfluenceLegacyLabelSortDirection;
    sortField: ConfluenceLegacyLabelSortField;
};

export enum ConfluenceLegacyLabelSortDirection {
    Ascending = "ASCENDING",
    Descending = "DESCENDING"
}

export enum ConfluenceLegacyLabelSortField {
    LabellingCreationdate = "LABELLING_CREATIONDATE",
    LabellingId = "LABELLING_ID"
}

export type ConfluenceLegacyLastModifiedSummary = {
    __typename?: "ConfluenceLegacyLastModifiedSummary";
    friendlyLastModified?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<ConfluenceLegacyVersion>;
};

export type ConfluenceLegacyLayerScreenLookAndFeel = {
    __typename?: "ConfluenceLegacyLayerScreenLookAndFeel";
    background?: Maybe<Scalars["String"]["output"]>;
    backgroundAttachment?: Maybe<Scalars["String"]["output"]>;
    backgroundBlendMode?: Maybe<Scalars["String"]["output"]>;
    backgroundClip?: Maybe<Scalars["String"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<Scalars["String"]["output"]>;
    backgroundOrigin?: Maybe<Scalars["String"]["output"]>;
    backgroundPosition?: Maybe<Scalars["String"]["output"]>;
    backgroundRepeat?: Maybe<Scalars["String"]["output"]>;
    backgroundSize?: Maybe<Scalars["String"]["output"]>;
    height?: Maybe<Scalars["String"]["output"]>;
    width?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLicense = {
    __typename?: "ConfluenceLegacyLicense";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    billingPeriod?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    billingSourceSystem?: Maybe<ConfluenceLegacyBillingSourceSystem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licenseConsumingUserCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licenseStatus: ConfluenceLegacyLicenseStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trialEndDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userLimit?: Maybe<Scalars["Long"]["output"]>;
};

export enum ConfluenceLegacyLicenseStatus {
    Active = "ACTIVE",
    Suspended = "SUSPENDED",
    Unlicensed = "UNLICENSED"
}

export type ConfluenceLegacyLicensedProduct = {
    __typename?: "ConfluenceLegacyLicensedProduct";
    licenseStatus: ConfluenceLegacyLicenseStatus;
    productKey: Scalars["String"]["output"];
};

export type ConfluenceLegacyLikeContentInput = {
    contentId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyLikeContentPayload = {
    __typename?: "ConfluenceLegacyLikeContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: ConfluenceLegacyContent;
};

export type ConfluenceLegacyLikeEntity = {
    __typename?: "ConfluenceLegacyLikeEntity";
    creationDate?: Maybe<Scalars["String"]["output"]>;
    currentUserIsFollowing?: Maybe<Scalars["Boolean"]["output"]>;
    user?: Maybe<ConfluenceLegacyUser>;
};

export type ConfluenceLegacyLikeEntityEdge = {
    __typename?: "ConfluenceLegacyLikeEntityEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyLikeEntity>;
};

export type ConfluenceLegacyLikesModelMetadataDto = {
    __typename?: "ConfluenceLegacyLikesModelMetadataDto";
    count: Scalars["Int"]["output"];
    currentUser: Scalars["Boolean"]["output"];
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    summary?: Maybe<Scalars["String"]["output"]>;
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export type ConfluenceLegacyLikesResponse = {
    __typename?: "ConfluenceLegacyLikesResponse";
    count?: Maybe<Scalars["Int"]["output"]>;
    currentUserLikes?: Maybe<Scalars["Boolean"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyLikeEntityEdge>>>;
    /** The current user's followees who like the content. Only the first ones up to the limit are returned. */
    followees?: Maybe<Array<Maybe<ConfluenceLegacyUser>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyLikeEntity>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyLikesResponseFolloweesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyLinksContextBase = {
    __typename?: "ConfluenceLegacyLinksContextBase";
    base?: Maybe<Scalars["String"]["output"]>;
    context?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLinksContextSelfBase = {
    __typename?: "ConfluenceLegacyLinksContextSelfBase";
    base?: Maybe<Scalars["String"]["output"]>;
    context?: Maybe<Scalars["String"]["output"]>;
    self?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
    {
        __typename?: "ConfluenceLegacyLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
        base?: Maybe<Scalars["String"]["output"]>;
        collection?: Maybe<Scalars["String"]["output"]>;
        context?: Maybe<Scalars["String"]["output"]>;
        download?: Maybe<Scalars["String"]["output"]>;
        editui?: Maybe<Scalars["String"]["output"]>;
        self?: Maybe<Scalars["String"]["output"]>;
        tinyui?: Maybe<Scalars["String"]["output"]>;
        webui?: Maybe<Scalars["String"]["output"]>;
    };

export type ConfluenceLegacyLinksSelf = {
    __typename?: "ConfluenceLegacyLinksSelf";
    self?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLocalStorage = {
    __typename?: "ConfluenceLegacyLocalStorage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    booleanValues: Array<Maybe<ConfluenceLegacyLocalStorageBooleanPair>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    stringValues: Array<Maybe<ConfluenceLegacyLocalStorageStringPair>>;
};

export type ConfluenceLegacyLocalStorageBooleanValuesArgs = {
    keys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ConfluenceLegacyLocalStorageStringValuesArgs = {
    keys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ConfluenceLegacyLocalStorageBooleanPair = {
    __typename?: "ConfluenceLegacyLocalStorageBooleanPair";
    key: Scalars["String"]["output"];
    value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyLocalStorageBooleanPairInput = {
    key: Scalars["String"]["input"];
    value?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyLocalStorageInput = {
    booleanValues?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyLocalStorageBooleanPairInput>>
    >;
    stringValues?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyLocalStorageStringPairInput>>
    >;
};

export type ConfluenceLegacyLocalStorageStringPair = {
    __typename?: "ConfluenceLegacyLocalStorageStringPair";
    key: Scalars["String"]["output"];
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyLocalStorageStringPairInput = {
    key: Scalars["String"]["input"];
    value?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyLookAndFeel = {
    __typename?: "ConfluenceLegacyLookAndFeel";
    bordersAndDividers?: Maybe<ConfluenceLegacyBordersAndDividersLookAndFeel>;
    content?: Maybe<ConfluenceLegacyContentLookAndFeel>;
    header?: Maybe<ConfluenceLegacyHeaderLookAndFeel>;
    headings: Array<Maybe<ConfluenceLegacyMapOfStringToString>>;
    horizontalHeader?: Maybe<ConfluenceLegacyHeaderLookAndFeel>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    menus?: Maybe<ConfluenceLegacyMenusLookAndFeel>;
};

export type ConfluenceLegacyLookAndFeelSettings = {
    __typename?: "ConfluenceLegacyLookAndFeelSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    custom?: Maybe<ConfluenceLegacyLookAndFeel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    global?: Maybe<ConfluenceLegacyLookAndFeel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    selected?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    theme?: Maybe<ConfluenceLegacyLookAndFeel>;
};

export type ConfluenceLegacyLoomToken = {
    __typename?: "ConfluenceLegacyLoomToken";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    token: Scalars["String"]["output"];
};

export enum ConfluenceLegacyLoomUserStatus {
    Linked = "LINKED",
    Mastered = "MASTERED",
    NotFound = "NOT_FOUND"
}

export type ConfluenceLegacyMacroBody = {
    __typename?: "ConfluenceLegacyMacroBody";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaToken?: Maybe<ConfluenceLegacyEmbeddedMediaToken>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    representation?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webResourceDependencies?: Maybe<ConfluenceLegacyWebResourceDependencies>;
};

export type ConfluenceLegacyMapLinkTypeString = {
    __typename?: "ConfluenceLegacyMapLinkTypeString";
    download?: Maybe<Scalars["String"]["output"]>;
    editui?: Maybe<Scalars["String"]["output"]>;
    tinyui?: Maybe<Scalars["String"]["output"]>;
    webui?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyMapOfStringToFormattedBody = {
    __typename?: "ConfluenceLegacyMapOfStringToFormattedBody";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<ConfluenceLegacyFormattedBody>;
};

export type ConfluenceLegacyMapOfStringToInteger = {
    __typename?: "ConfluenceLegacyMapOfStringToInteger";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyMapOfStringToString = {
    __typename?: "ConfluenceLegacyMapOfStringToString";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyMark = {
    attrs?: InputMaybe<ConfluenceLegacyMarkAttribute>;
    type: Scalars["String"]["input"];
};

export type ConfluenceLegacyMarkAttribute = {
    annotationType: Scalars["String"]["input"];
    id: Scalars["String"]["input"];
};

export type ConfluenceLegacyMarkCommentsAsReadInput = {
    commentIds: Array<Scalars["ID"]["input"]>;
};

export type ConfluenceLegacyMarkCommentsAsReadPayload = {
    __typename?: "ConfluenceLegacyMarkCommentsAsReadPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyMediaAccessTokens = {
    __typename?: "ConfluenceLegacyMediaAccessTokens";
    /** Returns a read only token. `null` will be returned if user does not have appropriate permissions */
    readOnlyToken?: Maybe<ConfluenceLegacyMediaToken>;
    /** Returns a read+write token. `null` will be returned if user does not have appropriate permissions */
    readWriteToken?: Maybe<ConfluenceLegacyMediaToken>;
};

export type ConfluenceLegacyMediaAttachment = {
    __typename?: "ConfluenceLegacyMediaAttachment";
    html: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
};

export type ConfluenceLegacyMediaAttachmentError = {
    __typename?: "ConfluenceLegacyMediaAttachmentError";
    error: ConfluenceLegacyError;
};

export type ConfluenceLegacyMediaAttachmentInput = {
    file: ConfluenceLegacyMediaFile;
    minorEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyMediaAttachmentOrError =
    | ConfluenceLegacyMediaAttachment
    | ConfluenceLegacyMediaAttachmentError;

export type ConfluenceLegacyMediaConfiguration = {
    __typename?: "ConfluenceLegacyMediaConfiguration";
    clientId: Scalars["String"]["output"];
    fileStoreUrl: Scalars["String"]["output"];
    maxFileSize?: Maybe<Scalars["Long"]["output"]>;
};

export type ConfluenceLegacyMediaFile = {
    /** this is the media store ID */
    id: Scalars["ID"]["input"];
    /** optional mime type of the file */
    mimeType?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    /** size of the file in bytes */
    size: Scalars["Int"]["input"];
};

export type ConfluenceLegacyMediaPickerUserToken = {
    __typename?: "ConfluenceLegacyMediaPickerUserToken";
    id?: Maybe<Scalars["String"]["output"]>;
    token?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyMediaToken = {
    __typename?: "ConfluenceLegacyMediaToken";
    duration: Scalars["Int"]["output"];
    expiryDateTime: Scalars["Long"]["output"];
    value: Scalars["String"]["output"];
};

export type ConfluenceLegacyMentionData = {
    mentionLocalIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    mentionedUserAccountId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyMenusLookAndFeel = {
    __typename?: "ConfluenceLegacyMenusLookAndFeel";
    color?: Maybe<Scalars["String"]["output"]>;
    hoverOrFocus?: Maybe<Array<Maybe<ConfluenceLegacyMapOfStringToString>>>;
};

export type ConfluenceLegacyMigrateSpaceShortcutsPayload = {
    __typename?: "ConfluenceLegacyMigrateSpaceShortcutsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    parentPageId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    smartLinksContentList: Array<Maybe<ConfluenceLegacySmartLinkContent>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyMissionControlOverview = {
    metricOrder: Array<InputMaybe<Scalars["String"]["input"]>>;
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
};

export enum ConfluenceLegacyMobilePlatform {
    Android = "ANDROID",
    Ios = "IOS"
}

export type ConfluenceLegacyModuleCompleteKey = {
    __typename?: "ConfluenceLegacyModuleCompleteKey";
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    pluginKey?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyMoveBlogInput = {
    blogPostId: Scalars["Long"]["input"];
    targetSpaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyMoveBlogPayload = {
    __typename?: "ConfluenceLegacyMoveBlogPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
};

export type ConfluenceLegacyMovePageAsChildInput = {
    pageId: Scalars["ID"]["input"];
    parentId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyMovePageAsSiblingInput = {
    pageId: Scalars["ID"]["input"];
    siblingId: Scalars["ID"]["input"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyMovePagePayload = {
    __typename?: "ConfluenceLegacyMovePagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    movedPage: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    page?: Maybe<ConfluenceLegacyPage>;
};

export type ConfluenceLegacyMovePageTopLevelInput = {
    pageId: Scalars["ID"]["input"];
    targetSpaceKey: Scalars["String"]["input"];
};

export type ConfluenceLegacyMutationResponse = {
    __typename?: "ConfluenceLegacyMutationResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyMutationsLabel = {
    __typename?: "ConfluenceLegacyMutationsLabel";
    id?: Maybe<Scalars["ID"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    prefix?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyMutationsLabelEdge = {
    __typename?: "ConfluenceLegacyMutationsLabelEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyMutationsLabel>;
};

export type ConfluenceLegacyMutationsLinksContextBase = {
    __typename?: "ConfluenceLegacyMutationsLinksContextBase";
    base?: Maybe<Scalars["String"]["output"]>;
    context?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyMutationsPaginatedLabelList = {
    __typename?: "ConfluenceLegacyMutationsPaginatedLabelList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyMutationsLabelEdge>>>;
    links?: Maybe<ConfluenceLegacyMutationsLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyMutationsLabel>>>;
    pageInfo?: Maybe<PageInfo>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyMyVisitedPages = {
    __typename?: "ConfluenceLegacyMyVisitedPages";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: ConfluenceLegacyMyVisitedPagesItems;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyMyVisitedPagesInfo;
};

export type ConfluenceLegacyMyVisitedPagesInfo = {
    __typename?: "ConfluenceLegacyMyVisitedPagesInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyMyVisitedPagesItems = {
    __typename?: "ConfluenceLegacyMyVisitedPagesItems";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<Array<Maybe<ConfluenceLegacyContent>>>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyMyVisitedSpaces = {
    __typename?: "ConfluenceLegacyMyVisitedSpaces";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: ConfluenceLegacyMyVisitedSpacesItems;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyMyVisitedSpacesInfo;
};

export type ConfluenceLegacyMyVisitedSpacesInfo = {
    __typename?: "ConfluenceLegacyMyVisitedSpacesInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyMyVisitedSpacesItems = {
    __typename?: "ConfluenceLegacyMyVisitedSpacesItems";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'spaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    spaces?: Maybe<Array<Maybe<ConfluenceLegacySpace>>>;
};

export type ConfluenceLegacyNavigationLookAndFeel = {
    __typename?: "ConfluenceLegacyNavigationLookAndFeel";
    color?: Maybe<Scalars["String"]["output"]>;
    highlightColor?: Maybe<Scalars["String"]["output"]>;
    hoverOrFocus?: Maybe<Array<Maybe<ConfluenceLegacyMapOfStringToString>>>;
};

export type ConfluenceLegacyNestedActionsFeature = {
    __typename?: "ConfluenceLegacyNestedActionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyNestedPageInput = {
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

export type ConfluenceLegacyNewPageInput = {
    page: ConfluenceLegacyPageInput;
    space: ConfluenceLegacySpaceInput;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyNewPagePayload = {
    __typename?: "ConfluenceLegacyNewPagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    page?: Maybe<ConfluenceLegacyPage>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictions?: Maybe<ConfluenceLegacyPageRestrictions>;
};

export type ConfluenceLegacyNotificationResponsePayload = Payload & {
    __typename?: "ConfluenceLegacyNotificationResponsePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyOnboardingState = {
    __typename?: "ConfluenceLegacyOnboardingState";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyOnboardingStateInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export enum ConfluenceLegacyOperation {
    Assigned = "ASSIGNED",
    Complete = "COMPLETE",
    Deleted = "DELETED",
    InComplete = "IN_COMPLETE",
    Reworded = "REWORDED",
    Unassigned = "UNASSIGNED"
}

export type ConfluenceLegacyOperationCheckResult = {
    __typename?: "ConfluenceLegacyOperationCheckResult";
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    operation?: Maybe<Scalars["String"]["output"]>;
    targetType?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyOperationCheckResultInput = {
    operation: Scalars["String"]["input"];
    targetType: Scalars["String"]["input"];
};

export type ConfluenceLegacyOrganizationContext = {
    __typename?: "ConfluenceLegacyOrganizationContext";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasPaidProduct?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyOutgoingLinks = {
    __typename?: "ConfluenceLegacyOutgoingLinks";
    internalOutgoingLinks?: Maybe<ConfluenceLegacyPaginatedContentList>;
};

export type ConfluenceLegacyOutgoingLinksInternalOutgoingLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConfluenceLegacyOutputDeviceType {
    Desktop = "DESKTOP",
    Email = "EMAIL",
    Mobile = "MOBILE"
}

/** --------------------------------------------------------------------------------------------- */
export enum ConfluenceLegacyPtGraphQlPageStatus {
    Current = "CURRENT",
    Draft = "DRAFT",
    Historical = "HISTORICAL",
    Trashed = "TRASHED"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPtPage = {
    __typename?: "ConfluenceLegacyPTPage";
    ancestors?: Maybe<Array<Maybe<ConfluenceLegacyPtPage>>>;
    children?: Maybe<ConfluenceLegacyPtPaginatedPageList>;
    followingSiblings?: Maybe<ConfluenceLegacyPtPaginatedPageList>;
    hasChildren: Scalars["Boolean"]["output"];
    hasInheritedRestrictions: Scalars["Boolean"]["output"];
    hasRestrictions: Scalars["Boolean"]["output"];
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'mediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mediaSession?: Maybe<ConfluenceLegacyContentMediaSession>;
    nearestAncestors?: Maybe<ConfluenceLegacyPtPaginatedPageList>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    page?: Maybe<ConfluenceLegacyPage>;
    previousSiblings?: Maybe<ConfluenceLegacyPtPaginatedPageList>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPtPageChildrenArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPtPageFollowingSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPtPageNearestAncestorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPtPagePreviousSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyPtPageEdge = {
    __typename?: "ConfluenceLegacyPTPageEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ConfluenceLegacyPtPage>;
};

export type ConfluenceLegacyPtPageInfo = {
    __typename?: "ConfluenceLegacyPTPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    /** This will be false at all times until backwards pagination is supported */
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyPtPaginatedPageList = {
    __typename?: "ConfluenceLegacyPTPaginatedPageList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyPtPageEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyPtPage>>>;
    pageInfo?: Maybe<ConfluenceLegacyPtPageInfo>;
};

export type ConfluenceLegacyPage = {
    __typename?: "ConfluenceLegacyPage";
    ancestors: Array<Maybe<ConfluenceLegacyPage>>;
    blank?: Maybe<Scalars["Boolean"]["output"]>;
    children?: Maybe<ConfluenceLegacyPaginatedPageList>;
    createdDate?: Maybe<ConfluenceLegacyDate>;
    emojiTitleDraft?: Maybe<Scalars["String"]["output"]>;
    emojiTitlePublished?: Maybe<Scalars["String"]["output"]>;
    followingSiblings?: Maybe<ConfluenceLegacyPaginatedPageList>;
    hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
    hasInheritedRestrictions: Scalars["Boolean"]["output"];
    hasRestrictions: Scalars["Boolean"]["output"];
    id?: Maybe<Scalars["ID"]["output"]>;
    lastUpdatedDate?: Maybe<ConfluenceLegacyDate>;
    links?: Maybe<ConfluenceLegacyMapLinkTypeString>;
    nearestAncestors?: Maybe<ConfluenceLegacyPaginatedPageList>;
    previousSiblings?: Maybe<ConfluenceLegacyPaginatedPageList>;
    properties?: Maybe<ConfluenceLegacyPaginatedJsonContentPropertyList>;
    status?: Maybe<ConfluenceLegacyPageStatus>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyPageChildrenArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyPageCreatedDateArgs = {
    format?: InputMaybe<ConfluenceLegacyDateFormat>;
};

export type ConfluenceLegacyPageFollowingSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyPageLastUpdatedDateArgs = {
    format?: InputMaybe<ConfluenceLegacyDateFormat>;
};

export type ConfluenceLegacyPageNearestAncestorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyPagePreviousSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyPagePropertiesArgs = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConfluenceLegacyPageActivityAction {
    Created = "created",
    Updated = "updated"
}

export enum ConfluenceLegacyPageActivityActionSubject {
    Comment = "comment",
    Page = "page"
}

export type ConfluenceLegacyPageActivityEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: ConfluenceLegacyPageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: ConfluenceLegacyPageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type ConfluenceLegacyPageActivityEventCreatedComment =
    ConfluenceLegacyPageActivityEvent & {
        __typename?: "ConfluenceLegacyPageActivityEventCreatedComment";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        accountId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        action: ConfluenceLegacyPageActivityAction;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        actionSubject: ConfluenceLegacyPageActivityActionSubject;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'comment' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        comment?: Maybe<ConfluenceLegacyComment>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        commentType: ConfluenceLegacyAnalyticsCommentType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        groupSize: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        timestamp: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        user?: Maybe<ConfluenceLegacyAtlassianUser>;
    };

export type ConfluenceLegacyPageActivityEventCreatedPage =
    ConfluenceLegacyPageActivityEvent & {
        __typename?: "ConfluenceLegacyPageActivityEventCreatedPage";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        accountId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        action: ConfluenceLegacyPageActivityAction;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        actionSubject: ConfluenceLegacyPageActivityActionSubject;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        groupSize: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        pageVersion: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        timestamp: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        user?: Maybe<ConfluenceLegacyAtlassianUser>;
    };

export type ConfluenceLegacyPageActivityEventUpdatedPage =
    ConfluenceLegacyPageActivityEvent & {
        __typename?: "ConfluenceLegacyPageActivityEventUpdatedPage";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        accountId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        action: ConfluenceLegacyPageActivityAction;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        actionSubject: ConfluenceLegacyPageActivityActionSubject;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        groupSize: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        pageVersion: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        timestamp: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        user?: Maybe<ConfluenceLegacyAtlassianUser>;
    };

export type ConfluenceLegacyPageActivityPageInfo = {
    __typename?: "ConfluenceLegacyPageActivityPageInfo";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPageAnalyticsCount = {
    __typename?: "ConfluenceLegacyPageAnalyticsCount";
    /**
     * Analytics count
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count: Scalars["Int"]["output"];
};

/** Type of metric to group by */
export enum ConfluenceLegacyPageAnalyticsCountType {
    All = "ALL",
    User = "USER"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPageAnalyticsTimeseriesCount = {
    __typename?: "ConfluenceLegacyPageAnalyticsTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyPageAnalyticsTimeseriesCountItem>;
};

export type ConfluenceLegacyPageAnalyticsTimeseriesCountItem = {
    __typename?: "ConfluenceLegacyPageAnalyticsTimeseriesCountItem";
    /** Analytics count */
    count: Scalars["Int"]["output"];
    /** Grouping date in ISO format */
    date: Scalars["String"]["output"];
};

/** Type of metric to group by */
export enum ConfluenceLegacyPageAnalyticsTimeseriesCountType {
    All = "ALL"
}

export type ConfluenceLegacyPageBodyInput = {
    representation?: InputMaybe<ConfluenceLegacyBodyFormatType>;
    value: Scalars["String"]["input"];
};

export enum ConfluenceLegacyPageCardInPageTreeHoverPreference {
    NoOptionSelected = "NO_OPTION_SELECTED",
    NoShowPagecard = "NO_SHOW_PAGECARD",
    ShowPagecard = "SHOW_PAGECARD"
}

export enum ConfluenceLegacyPageCopyRestrictionValidationStatus {
    InvalidMultiple = "INVALID_MULTIPLE",
    InvalidSingle = "INVALID_SINGLE",
    Valid = "VALID"
}

export type ConfluenceLegacyPageEdge = {
    __typename?: "ConfluenceLegacyPageEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyPage>;
};

export type ConfluenceLegacyPageGroupRestriction = {
    __typename?: "ConfluenceLegacyPageGroupRestriction";
    name: Scalars["String"]["output"];
};

export type ConfluenceLegacyPageGroupRestrictionInput = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    name: Scalars["String"]["input"];
};

export type ConfluenceLegacyPageInput = {
    /** the parent page ID, default is no parent page (i.e. root page in the space) */
    body?: InputMaybe<ConfluenceLegacyPageBodyInput>;
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    restrictions?: InputMaybe<ConfluenceLegacyPageRestrictionsInput>;
    status?: InputMaybe<ConfluenceLegacyPageStatusInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyPageRestriction = {
    __typename?: "ConfluenceLegacyPageRestriction";
    group?: Maybe<Array<ConfluenceLegacyPageGroupRestriction>>;
    user?: Maybe<Array<ConfluenceLegacyPageUserRestriction>>;
};

export type ConfluenceLegacyPageRestrictionInput = {
    group?: InputMaybe<Array<ConfluenceLegacyPageGroupRestrictionInput>>;
    user?: InputMaybe<Array<ConfluenceLegacyPageUserRestrictionInput>>;
};

export type ConfluenceLegacyPageRestrictions = {
    __typename?: "ConfluenceLegacyPageRestrictions";
    read?: Maybe<ConfluenceLegacyPageRestriction>;
    update?: Maybe<ConfluenceLegacyPageRestriction>;
};

export type ConfluenceLegacyPageRestrictionsInput = {
    read?: InputMaybe<ConfluenceLegacyPageRestrictionInput>;
    update?: InputMaybe<ConfluenceLegacyPageRestrictionInput>;
};

export enum ConfluenceLegacyPageStatus {
    Current = "CURRENT",
    Draft = "DRAFT",
    Historical = "HISTORICAL",
    Trashed = "TRASHED"
}

export enum ConfluenceLegacyPageStatusInput {
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ConfluenceLegacyPageUpdateTrigger {
    CreatePage = "CREATE_PAGE",
    DiscardChanges = "DISCARD_CHANGES",
    EditPage = "EDIT_PAGE",
    LinkRefactoring = "LINK_REFACTORING",
    MigratePageCollab = "MIGRATE_PAGE_COLLAB",
    OwnerChange = "OWNER_CHANGE",
    PageRename = "PAGE_RENAME",
    PersonalTasklist = "PERSONAL_TASKLIST",
    Revert = "REVERT",
    SpaceCreate = "SPACE_CREATE",
    Unknown = "UNKNOWN",
    ViewPage = "VIEW_PAGE"
}

export type ConfluenceLegacyPageUserRestriction = {
    __typename?: "ConfluenceLegacyPageUserRestriction";
    id: Scalars["ID"]["output"];
};

export type ConfluenceLegacyPageUserRestrictionInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceLegacyPageValidationResult = {
    __typename?: "ConfluenceLegacyPageValidationResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyPagesDisplayPersistenceOption {
    Cards = "CARDS",
    CompactList = "COMPACT_LIST",
    List = "LIST"
}

export enum ConfluenceLegacyPagesSortField {
    LastModifiedDate = "LAST_MODIFIED_DATE",
    Relevant = "RELEVANT",
    Title = "TITLE"
}

export enum ConfluenceLegacyPagesSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type ConfluenceLegacyPagesSortPersistenceOption = {
    __typename?: "ConfluenceLegacyPagesSortPersistenceOption";
    field: ConfluenceLegacyPagesSortField;
    order: ConfluenceLegacyPagesSortOrder;
};

export type ConfluenceLegacyPagesSortPersistenceOptionInput = {
    field: ConfluenceLegacyPagesSortField;
    order: ConfluenceLegacyPagesSortOrder;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPaginatedAllUpdatesFeed = {
    __typename?: "ConfluenceLegacyPaginatedAllUpdatesFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyAllUpdatesFeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyFeedPageInfo;
};

export type ConfluenceLegacyPaginatedCommentList = {
    __typename?: "ConfluenceLegacyPaginatedCommentList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyCommentEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyComment>>>;
    pageInfo?: Maybe<PageInfo>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyPaginatedContentHistoryList = {
    __typename?: "ConfluenceLegacyPaginatedContentHistoryList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyContentHistoryEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyContentHistory>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedContentList = {
    __typename?: "ConfluenceLegacyPaginatedContentList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyContentEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyContent>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedContentListWithChild = {
    __typename?: "ConfluenceLegacyPaginatedContentListWithChild";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    child?: Maybe<ConfluenceLegacyChildContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyContentEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyContent>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedContentTemplateList = {
    __typename?: "ConfluenceLegacyPaginatedContentTemplateList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyContentTemplateEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyContentTemplate>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedDeactivatedUserPageCountEntityList = {
    __typename?: "ConfluenceLegacyPaginatedDeactivatedUserPageCountEntityList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<
        Array<Maybe<ConfluenceLegacyDeactivatedUserPageCountEntityEdge>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyDeactivatedUserPageCountEntity>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedFeed = {
    __typename?: "ConfluenceLegacyPaginatedFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ConfluenceLegacyFeedItemEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyFeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyFeedPageInformation;
};

export type ConfluenceLegacyPaginatedGroupList = {
    __typename?: "ConfluenceLegacyPaginatedGroupList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyGroupEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyGroup>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedGroupWithPermissions = {
    __typename?: "ConfluenceLegacyPaginatedGroupWithPermissions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyGroupWithPermissionsEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyGroupWithPermissions>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedGroupWithRestrictions = {
    __typename?: "ConfluenceLegacyPaginatedGroupWithRestrictions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyGroupWithRestrictionsEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyGroupWithRestrictions>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedJsonContentPropertyList = {
    __typename?: "ConfluenceLegacyPaginatedJsonContentPropertyList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyJsonContentPropertyEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyJsonContentProperty>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedLabelList = {
    __typename?: "ConfluenceLegacyPaginatedLabelList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyLabelEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyLabel>>>;
    pageInfo?: Maybe<PageInfo>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPaginatedPageActivity = {
    __typename?: "ConfluenceLegacyPaginatedPageActivity";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<ConfluenceLegacyPageActivityEvent>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyPageActivityPageInfo;
};

export type ConfluenceLegacyPaginatedPageList = {
    __typename?: "ConfluenceLegacyPaginatedPageList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyPageEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyPage>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedPersonList = {
    __typename?: "ConfluenceLegacyPaginatedPersonList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyPersonEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
    pageInfo?: Maybe<PageInfo>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPaginatedPopularFeed = {
    __typename?: "ConfluenceLegacyPaginatedPopularFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ConfluenceLegacyPopularFeedItemEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyPopularFeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyFeedPageInfo;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyPaginatedPopularSpaceFeed = {
    __typename?: "ConfluenceLegacyPaginatedPopularSpaceFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    data: ConfluenceLegacyPopularSpaceFeedPage;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyFeedPageInfo;
};

export type ConfluenceLegacyPaginatedSearchResultList = {
    __typename?: "ConfluenceLegacyPaginatedSearchResultList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacySearchResultEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacySearchResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedSmartLinkList = {
    __typename?: "ConfluenceLegacyPaginatedSmartLinkList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacySmartLinkEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacySmartLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedSnippetList = {
    __typename?: "ConfluenceLegacyPaginatedSnippetList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacySnippetEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacySnippet>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedSpaceList = {
    __typename?: "ConfluenceLegacyPaginatedSpaceList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacySpaceEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacySpace>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedSpacePermissionSubjectList = {
    __typename?: "ConfluenceLegacyPaginatedSpacePermissionSubjectList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacySpacePermissionSubjectEdge>>>;
    /** GraphQL query to get total number of groups which have space permissions */
    groupCount: Scalars["Int"]["output"];
    nodes?: Maybe<Array<Maybe<ConfluenceLegacySpacePermissionSubject>>>;
    pageInfo?: Maybe<PageInfo>;
    /** GraphQL query to get total number of users and groups which have space permissions */
    totalCount: Scalars["Int"]["output"];
    /** GraphQL query to get total number of users which have space permissions */
    userCount: Scalars["Int"]["output"];
};

export type ConfluenceLegacyPaginatedStalePagePayloadList = {
    __typename?: "ConfluenceLegacyPaginatedStalePagePayloadList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyStalePagePayloadEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyStalePagePayload>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedSubjectUserOrGroupList = {
    __typename?: "ConfluenceLegacyPaginatedSubjectUserOrGroupList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacySubjectUserOrGroupEdge>>>;
    /** GraphQL query to get total number of groups which have content permissions */
    groupCount: Scalars["Int"]["output"];
    nodes?: Maybe<Array<Maybe<ConfluenceLegacySubjectUserOrGroup>>>;
    pageInfo?: Maybe<PageInfo>;
    /** GraphQL query to get total number of users and groups which have content permissions */
    totalCount: Scalars["Int"]["output"];
    /** GraphQL query to get total number of users which have content permissions */
    userCount: Scalars["Int"]["output"];
};

export type ConfluenceLegacyPaginatedTemplateBodyList = {
    __typename?: "ConfluenceLegacyPaginatedTemplateBodyList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyTemplateBodyEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyTemplateBody>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedTemplateCategoryList = {
    __typename?: "ConfluenceLegacyPaginatedTemplateCategoryList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyTemplateCategoryEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyTemplateCategory>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedTemplateInfoList = {
    __typename?: "ConfluenceLegacyPaginatedTemplateInfoList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacyTemplateInfoEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyTemplateInfo>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedUserList = {
    __typename?: "ConfluenceLegacyPaginatedUserList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyUserEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyUser>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedUserWithPermissions = {
    __typename?: "ConfluenceLegacyPaginatedUserWithPermissions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyUserEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyUser>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPaginatedUserWithRestrictions = {
    __typename?: "ConfluenceLegacyPaginatedUserWithRestrictions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluenceLegacyUserWithRestrictionsEdge>>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyUserWithRestrictions>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceLegacyPatchCommentsSummaryInput = {
    commentsType: ConfluenceLegacyCommentsType;
    contentId: Scalars["ID"]["input"];
    contentType: ConfluenceLegacySummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyPatchCommentsSummaryMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "ConfluenceLegacyPatchCommentsSummaryMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type ConfluenceLegacyPatchCommentsSummaryPayload = {
    __typename?: "ConfluenceLegacyPatchCommentsSummaryPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["ID"]["output"];
};

export enum ConfluenceLegacyPathType {
    Absolute = "ABSOLUTE",
    Relative = "RELATIVE",
    RelativeNoContext = "RELATIVE_NO_CONTEXT"
}

export type ConfluenceLegacyPaywallContentSingle = {
    __typename?: "ConfluenceLegacyPaywallContentSingle";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deactivationIdentifier: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    link?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyPaywallStatus {
    Active = "ACTIVE",
    Deactivated = "DEACTIVATED",
    Unset = "UNSET"
}

export enum ConfluenceLegacyPermissionDisplayType {
    Anonymous = "ANONYMOUS",
    Group = "GROUP",
    GuestUser = "GUEST_USER",
    LicensedUser = "LICENSED_USER"
}

export type ConfluenceLegacyPermissionMetadata = {
    __typename?: "ConfluenceLegacyPermissionMetadata";
    setPermission: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyPermissionsViaGroups = {
    __typename?: "ConfluenceLegacyPermissionsViaGroups";
    edit: Array<Maybe<ConfluenceLegacyGroup>>;
    view: Array<Maybe<ConfluenceLegacyGroup>>;
};

export type ConfluenceLegacyPerson = {
    displayName?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyPersonEdge = {
    __typename?: "ConfluenceLegacyPersonEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyPerson>;
};

export enum ConfluenceLegacyPlatform {
    Android = "ANDROID",
    Ios = "IOS",
    Web = "WEB"
}

export type ConfluenceLegacyPopularFeedItem = {
    __typename?: "ConfluenceLegacyPopularFeedItem";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
};

export type ConfluenceLegacyPopularFeedItemEdge = {
    __typename?: "ConfluenceLegacyPopularFeedItemEdge";
    /** Edge cursor pagination is not supported. This will always be null! Use the endCursor in pageInfo for forward pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: ConfluenceLegacyPopularFeedItem;
};

export type ConfluenceLegacyPopularSpaceFeedPage = {
    __typename?: "ConfluenceLegacyPopularSpaceFeedPage";
    page: Array<ConfluenceLegacyPopularFeedItem>;
};

export type ConfluenceLegacyPremiumExtensionsFeature = {
    __typename?: "ConfluenceLegacyPremiumExtensionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyPremiumToolsDropdownPersistence = {
    premiumToolsDropdownStatus: ConfluenceLegacyPremiumToolsDropdownStatus;
    spaceKey: Scalars["String"]["input"];
};

export enum ConfluenceLegacyPremiumToolsDropdownStatus {
    Collapsed = "COLLAPSED",
    Expanded = "EXPANDED",
    Unset = "UNSET"
}

export enum ConfluenceLegacyPrincipalType {
    Group = "GROUP",
    User = "USER"
}

export enum ConfluenceLegacyProduct {
    Confluence = "CONFLUENCE"
}

export type ConfluenceLegacyPublicLink = {
    __typename?: "ConfluenceLegacyPublicLink";
    id: Scalars["ID"]["output"];
    lastEnabledBy?: Maybe<Scalars["String"]["output"]>;
    lastEnabledDate?: Maybe<Scalars["String"]["output"]>;
    publicLinkUrlPath?: Maybe<Scalars["String"]["output"]>;
    status: ConfluenceLegacyPublicLinkStatus;
    title?: Maybe<Scalars["String"]["output"]>;
    type: Scalars["String"]["output"];
};

export enum ConfluenceLegacyPublicLinkAdminAction {
    Block = "BLOCK",
    Off = "OFF",
    On = "ON",
    Unblock = "UNBLOCK"
}

export type ConfluenceLegacyPublicLinkConnection = {
    __typename?: "ConfluenceLegacyPublicLinkConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<ConfluenceLegacyPublicLink>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyPublicLinkPageInfo;
};

export enum ConfluenceLegacyPublicLinkDefaultSpaceStatus {
    Off = "OFF",
    On = "ON"
}

export type ConfluenceLegacyPublicLinkOnboardingReference = {
    __typename?: "ConfluenceLegacyPublicLinkOnboardingReference";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkId?: Maybe<Scalars["ID"]["output"]>;
};

export type ConfluenceLegacyPublicLinkPage = {
    __typename?: "ConfluenceLegacyPublicLinkPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastEnabledBy?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastEnabledDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageStatus: ConfluenceLegacyPublicLinkPageStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkUrlPath?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyPublicLinkPageConnection = {
    __typename?: "ConfluenceLegacyPublicLinkPageConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<ConfluenceLegacyPublicLinkPage>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyPublicLinkPageInfo;
};

export type ConfluenceLegacyPublicLinkPageInfo = {
    __typename?: "ConfluenceLegacyPublicLinkPageInfo";
    endPage?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    startPage?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyPublicLinkPageStatus {
    BlockedByClassificationLevel = "BLOCKED_BY_CLASSIFICATION_LEVEL",
    BlockedByOrg = "BLOCKED_BY_ORG",
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    BlockedBySpace = "BLOCKED_BY_SPACE",
    Off = "OFF",
    On = "ON",
    SiteBlocked = "SITE_BLOCKED",
    SiteDisabled = "SITE_DISABLED",
    SpaceBlocked = "SPACE_BLOCKED",
    SpaceDisabled = "SPACE_DISABLED"
}

export enum ConfluenceLegacyPublicLinkPageStatusFilter {
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    BlockedBySpace = "BLOCKED_BY_SPACE",
    Off = "OFF",
    On = "ON"
}

export type ConfluenceLegacyPublicLinkPagesAdminActionPayload = {
    __typename?: "ConfluenceLegacyPublicLinkPagesAdminActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyPublicLinkPagesByCriteriaOrder {
    DateEnabled = "DATE_ENABLED",
    Status = "STATUS",
    Title = "TITLE"
}

export type ConfluenceLegacyPublicLinkPermissions = {
    __typename?: "ConfluenceLegacyPublicLinkPermissions";
    permissions: Array<ConfluenceLegacyPublicLinkPermissionsType>;
};

export enum ConfluenceLegacyPublicLinkPermissionsObjectType {
    Content = "CONTENT"
}

export enum ConfluenceLegacyPublicLinkPermissionsType {
    Edit = "EDIT"
}

export type ConfluenceLegacyPublicLinkSitePayload = {
    __typename?: "ConfluenceLegacyPublicLinkSitePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: ConfluenceLegacyPublicLinkSiteStatus;
};

export enum ConfluenceLegacyPublicLinkSiteStatus {
    BlockedByOrg = "BLOCKED_BY_ORG",
    Off = "OFF",
    On = "ON"
}

export type ConfluenceLegacyPublicLinkSpace = {
    __typename?: "ConfluenceLegacyPublicLinkSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<ConfluenceSpaceIcon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isPolicySetForClassificationLevel?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    previousStatus?: Maybe<ConfluenceLegacyPublicLinkSpaceStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    stats: ConfluenceLegacyPublicLinkSpaceStats;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: ConfluenceLegacyPublicLinkSpaceStatus;
};

export type ConfluenceLegacyPublicLinkSpaceConnection = {
    __typename?: "ConfluenceLegacyPublicLinkSpaceConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<ConfluenceLegacyPublicLinkSpace>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacyPublicLinkPageInfo;
};

export type ConfluenceLegacyPublicLinkSpaceStats = {
    __typename?: "ConfluenceLegacyPublicLinkSpaceStats";
    publicLinks: ConfluenceLegacyPublicLinkStats;
};

export enum ConfluenceLegacyPublicLinkSpaceStatus {
    BlockedByOrg = "BLOCKED_BY_ORG",
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    Off = "OFF",
    On = "ON"
}

export type ConfluenceLegacyPublicLinkSpacesActionPayload = {
    __typename?: "ConfluenceLegacyPublicLinkSpacesActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    newStatus: ConfluenceLegacyPublicLinkSpaceStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updatedSpaceIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export enum ConfluenceLegacyPublicLinkSpacesByCriteriaOrder {
    ActiveLinks = "ACTIVE_LINKS",
    Name = "NAME",
    Status = "STATUS"
}

export type ConfluenceLegacyPublicLinkStats = {
    __typename?: "ConfluenceLegacyPublicLinkStats";
    active?: Maybe<Scalars["Int"]["output"]>;
};

export enum ConfluenceLegacyPublicLinkStatus {
    BlockedByClassificationLevel = "BLOCKED_BY_CLASSIFICATION_LEVEL",
    BlockedByOrg = "BLOCKED_BY_ORG",
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    BlockedBySpace = "BLOCKED_BY_SPACE",
    Off = "OFF",
    On = "ON",
    SiteBlocked = "SITE_BLOCKED",
    SiteDisabled = "SITE_DISABLED",
    SpaceBlocked = "SPACE_BLOCKED",
    SpaceDisabled = "SPACE_DISABLED"
}

export enum ConfluenceLegacyPublicLinksByCriteriaOrder {
    DateEnabled = "DATE_ENABLED",
    Status = "STATUS",
    Title = "TITLE"
}

export type ConfluenceLegacyPublishConditions = {
    __typename?: "ConfluenceLegacyPublishConditions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addonKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dialog?: Maybe<ConfluenceLegacyPublishConditionsDialog>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorMessage: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    moduleKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
};

export type ConfluenceLegacyPublishConditionsDialog = {
    __typename?: "ConfluenceLegacyPublishConditionsDialog";
    header?: Maybe<Scalars["String"]["output"]>;
    height?: Maybe<Scalars["String"]["output"]>;
    url: Scalars["String"]["output"];
    width?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyPushNotificationCustomSettings = {
    __typename?: "ConfluenceLegacyPushNotificationCustomSettings";
    comment: Scalars["Boolean"]["output"];
    commentContentCreator: Scalars["Boolean"]["output"];
    commentReply: Scalars["Boolean"]["output"];
    createBlogPost: Scalars["Boolean"]["output"];
    createPage: Scalars["Boolean"]["output"];
    editBlogPost: Scalars["Boolean"]["output"];
    editPage: Scalars["Boolean"]["output"];
    grantContentAccessEdit?: Maybe<Scalars["Boolean"]["output"]>;
    grantContentAccessView?: Maybe<Scalars["Boolean"]["output"]>;
    likeBlogPost: Scalars["Boolean"]["output"];
    likeComment: Scalars["Boolean"]["output"];
    likePage: Scalars["Boolean"]["output"];
    mentionBlogPost: Scalars["Boolean"]["output"];
    mentionComment: Scalars["Boolean"]["output"];
    mentionPage: Scalars["Boolean"]["output"];
    reactionBlogPost?: Maybe<Scalars["Boolean"]["output"]>;
    reactionComment?: Maybe<Scalars["Boolean"]["output"]>;
    reactionPage?: Maybe<Scalars["Boolean"]["output"]>;
    requestContentAccess?: Maybe<Scalars["Boolean"]["output"]>;
    share: Scalars["Boolean"]["output"];
    shareGroup: Scalars["Boolean"]["output"];
    taskAssign: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyPushNotificationCustomSettingsInput = {
    comment: Scalars["Boolean"]["input"];
    commentContentCreator: Scalars["Boolean"]["input"];
    commentReply: Scalars["Boolean"]["input"];
    createBlogPost: Scalars["Boolean"]["input"];
    createPage: Scalars["Boolean"]["input"];
    editBlogPost: Scalars["Boolean"]["input"];
    editPage: Scalars["Boolean"]["input"];
    grantContentAccessEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
    grantContentAccessView?: InputMaybe<Scalars["Boolean"]["input"]>;
    likeBlogPost: Scalars["Boolean"]["input"];
    likeComment: Scalars["Boolean"]["input"];
    likePage: Scalars["Boolean"]["input"];
    mentionBlogPost: Scalars["Boolean"]["input"];
    mentionComment: Scalars["Boolean"]["input"];
    mentionPage: Scalars["Boolean"]["input"];
    reactionBlogPost?: InputMaybe<Scalars["Boolean"]["input"]>;
    reactionComment?: InputMaybe<Scalars["Boolean"]["input"]>;
    reactionPage?: InputMaybe<Scalars["Boolean"]["input"]>;
    requestContentAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
    share: Scalars["Boolean"]["input"];
    shareGroup: Scalars["Boolean"]["input"];
    taskAssign: Scalars["Boolean"]["input"];
};

export enum ConfluenceLegacyPushNotificationGroupInputType {
    None = "NONE",
    Quiet = "QUIET",
    Standard = "STANDARD"
}

export enum ConfluenceLegacyPushNotificationSettingGroup {
    Custom = "CUSTOM",
    None = "NONE",
    Quiet = "QUIET",
    Standard = "STANDARD"
}

export type ConfluenceLegacyPushNotificationSettings = {
    __typename?: "ConfluenceLegacyPushNotificationSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customSettings: ConfluenceLegacyPushNotificationCustomSettings;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    group: ConfluenceLegacyPushNotificationSettingGroup;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type ConfluenceLegacyQuickReload = {
    __typename?: "ConfluenceLegacyQuickReload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    comments: Array<ConfluenceLegacyQuickReloadComment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editorForPage?: Maybe<ConfluenceLegacyUser>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    time: Scalars["Long"]["output"];
};

export type ConfluenceLegacyQuickReloadComment = {
    __typename?: "ConfluenceLegacyQuickReloadComment";
    asyncRenderSafe: Scalars["Boolean"]["output"];
    comment: ConfluenceLegacyComment;
    primaryActions: Array<Maybe<ConfluenceLegacyCommentUserAction>>;
    secondaryActions: Array<Maybe<ConfluenceLegacyCommentUserAction>>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyReactedUsersResponse = {
    __typename?: "ConfluenceLegacyReactedUsersResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    containerAri: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    emojiId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reacted: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyUser>>>;
};

export enum ConfluenceLegacyReactionContentType {
    Blogpost = "BLOGPOST",
    Comment = "COMMENT",
    Page = "PAGE"
}

export type ConfluenceLegacyReactionsId = {
    containerId: Scalars["ID"]["input"];
    containerType: Scalars["String"]["input"];
    contentId: Scalars["ID"]["input"];
    contentType: Scalars["String"]["input"];
};

export type ConfluenceLegacyReactionsSummaryForEmoji = {
    __typename?: "ConfluenceLegacyReactionsSummaryForEmoji";
    count: Scalars["Int"]["output"];
    emojiId: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    reacted: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyReactionsSummaryResponse = {
    __typename?: "ConfluenceLegacyReactionsSummaryResponse";
    ari: Scalars["String"]["output"];
    containerAri: Scalars["String"]["output"];
    reactionsCount: Scalars["Int"]["output"];
    reactionsSummaryForEmoji: Array<
        Maybe<ConfluenceLegacyReactionsSummaryForEmoji>
    >;
};

export type ConfluenceLegacyReattachInlineCommentInput = {
    commentId: Scalars["ID"]["input"];
    containerId: Scalars["ID"]["input"];
    lastFetchTimeMillis: Scalars["Long"]["input"];
    /** matchIndex must be greater than or equal to 0. */
    matchIndex: Scalars["Int"]["input"];
    /** numMatches must be positive and greater than matchIndex. */
    numMatches: Scalars["Int"]["input"];
    originalSelection: Scalars["String"]["input"];
    publishedVersion?: InputMaybe<Scalars["Int"]["input"]>;
    step?: InputMaybe<ConfluenceLegacyStep>;
};

export enum ConfluenceLegacyRecentFilter {
    All = "ALL",
    Created = "CREATED",
    WorkedOn = "WORKED_ON"
}

export type ConfluenceLegacyRecentlyViewedSummary = {
    __typename?: "ConfluenceLegacyRecentlyViewedSummary";
    friendlyLastSeen?: Maybe<Scalars["String"]["output"]>;
    lastSeen?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyRecommendedFeedUserConfig = {
    __typename?: "ConfluenceLegacyRecommendedFeedUserConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPeople: Array<ConfluenceLegacyRecommendedPeopleItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedSpaces: Array<ConfluenceLegacyRecommendedSpaceItem>;
};

export type ConfluenceLegacyRecommendedLabelItem = {
    __typename?: "ConfluenceLegacyRecommendedLabelItem";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    namespace: Scalars["String"]["output"];
    strategy: Array<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyRecommendedLabels = {
    __typename?: "ConfluenceLegacyRecommendedLabels";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedLabels: Array<Maybe<ConfluenceLegacyRecommendedLabelItem>>;
};

export type ConfluenceLegacyRecommendedPages = {
    __typename?: "ConfluenceLegacyRecommendedPages";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPages: Array<ConfluenceLegacyRecommendedPagesItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: ConfluenceLegacyRecommendedPagesStatus;
};

export type ConfluenceLegacyRecommendedPagesItem = {
    __typename?: "ConfluenceLegacyRecommendedPagesItem";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    contentId: Scalars["ID"]["output"];
    strategy: Array<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacyRecommendedPagesSpaceBehavior {
    Hidden = "HIDDEN",
    Shown = "SHOWN"
}

export type ConfluenceLegacyRecommendedPagesSpaceStatus = {
    __typename?: "ConfluenceLegacyRecommendedPagesSpaceStatus";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    defaultBehavior: ConfluenceLegacyRecommendedPagesSpaceBehavior;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSpaceAdmin: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPagesEnabled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyRecommendedPagesStatus = {
    __typename?: "ConfluenceLegacyRecommendedPagesStatus";
    isEnabled: Scalars["Boolean"]["output"];
    userCanToggle: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyRecommendedPeopleItem = {
    __typename?: "ConfluenceLegacyRecommendedPeopleItem";
    accountId: Scalars["String"]["output"];
    score: Scalars["Float"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    user?: Maybe<ConfluenceLegacyAtlassianUser>;
};

export type ConfluenceLegacyRecommendedSpaceItem = {
    __typename?: "ConfluenceLegacyRecommendedSpaceItem";
    score: Scalars["Float"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'space' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    space?: Maybe<ConfluenceLegacySpace>;
    spaceId: Scalars["Long"]["output"];
};

export enum ConfluenceLegacyRelationSourceType {
    User = "user"
}

export enum ConfluenceLegacyRelationTargetType {
    Content = "content",
    Space = "space"
}

export enum ConfluenceLegacyRelationType {
    Collaborator = "collaborator",
    Favourite = "favourite",
    Touched = "touched"
}

export type ConfluenceLegacyRelevantFeedFilters = {
    __typename?: "ConfluenceLegacyRelevantFeedFilters";
    relevantFeedSpacesFilter: Array<Maybe<Scalars["Long"]["output"]>>;
    relevantFeedUsersFilter: Array<Maybe<Scalars["String"]["output"]>>;
};

export type ConfluenceLegacyRelevantSpaceUsersWrapper = {
    __typename?: "ConfluenceLegacyRelevantSpaceUsersWrapper";
    id?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export type ConfluenceLegacyRelevantSpacesWrapper = {
    __typename?: "ConfluenceLegacyRelevantSpacesWrapper";
    space?: Maybe<ConfluenceLegacyRelevantSpaceUsersWrapper>;
};

export enum ConfluenceLegacyRelevantUserFilter {
    Collaborators = "collaborators"
}

export enum ConfluenceLegacyRelevantUsersSortOrder {
    Asc = "asc",
    Desc = "desc"
}

export type ConfluenceLegacyRemoveGroupSpacePermissionsInput = {
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groupNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    spaceKey: Scalars["String"]["input"];
};

export type ConfluenceLegacyRemovePublicLinkPermissionsInput = {
    objectId: Scalars["ID"]["input"];
    objectType: ConfluenceLegacyPublicLinkPermissionsObjectType;
    permissions: Array<ConfluenceLegacyPublicLinkPermissionsType>;
};

export type ConfluenceLegacyRemovePublicLinkPermissionsPayload = Payload & {
    __typename?: "ConfluenceLegacyRemovePublicLinkPermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyRemoveSpacePermissionsPayload = {
    __typename?: "ConfluenceLegacyRemoveSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyRemoveUserSpacePermissionsInput = {
    accountId: Scalars["String"]["input"];
    spaceKey: Scalars["String"]["input"];
};

export type ConfluenceLegacyReplyInlineCommentInput = {
    commentBody: ConfluenceLegacyCommentBody;
    commentSource?: InputMaybe<ConfluenceLegacyPlatform>;
    containerId: Scalars["ID"]["input"];
    createdFrom?: InputMaybe<ConfluenceLegacyCommentCreationLocation>;
    parentCommentId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyRequestPageAccessInput = {
    accessType: ConfluenceLegacyAccessType;
    pageId: Scalars["String"]["input"];
};

export type ConfluenceLegacyRequestPageAccessPayload = {
    __typename?: "ConfluenceLegacyRequestPageAccessPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
};

export type ConfluenceLegacyResetExCoSpacePermissionsInput = {
    accountId: Scalars["String"]["input"];
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyResetExCoSpacePermissionsPayload = {
    __typename?: "ConfluenceLegacyResetExCoSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyResetSpaceRolesFromAnotherSpaceInput = {
    sourceSpaceId: Scalars["Long"]["input"];
    targetSpaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyResetSpaceRolesFromAnotherSpacePayload = Payload & {
    __typename?: "ConfluenceLegacyResetSpaceRolesFromAnotherSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyResolveInlineCommentPayload = {
    __typename?: "ConfluenceLegacyResolveInlineCommentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolveProperties?: Maybe<ConfluenceLegacyInlineCommentResolveProperties>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyResponseType {
    BulletListAdf = "BULLET_LIST_ADF",
    BulletListMarkdown = "BULLET_LIST_MARKDOWN",
    ParagraphPlaintext = "PARAGRAPH_PLAINTEXT"
}

export type ConfluenceLegacyRestoreSpacePayload = Payload & {
    __typename?: "ConfluenceLegacyRestoreSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyReverseTrialCohort {
    Control = "CONTROL",
    Enrolled = "ENROLLED",
    NotEnrolled = "NOT_ENROLLED",
    Unassigned = "UNASSIGNED",
    Unknown = "UNKNOWN",
    Variant = "VARIANT"
}

export enum ConfluenceLegacyRevertToLegacyEditorResult {
    NotReverted = "NOT_REVERTED",
    Reverted = "REVERTED"
}

export type ConfluenceLegacyRoleAssignment = {
    principal: ConfluenceLegacyRoleAssignmentPrincipalInput;
    roleId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyRoleAssignmentPrincipalInput = {
    principalId: Scalars["ID"]["input"];
    principalType: ConfluenceLegacyRoleAssignmentPrincipalType;
};

export enum ConfluenceLegacyRoleAssignmentPrincipalType {
    AccessClass = "ACCESS_CLASS",
    Group = "GROUP",
    Team = "TEAM",
    User = "USER"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacySaveReactionResponse = {
    __typename?: "ConfluenceLegacySaveReactionResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    containerAri: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    emojiId: Scalars["String"]["output"];
};

export type ConfluenceLegacySchedulePublishInfo = {
    __typename?: "ConfluenceLegacySchedulePublishInfo";
    date?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    minorEdit?: Maybe<Scalars["Boolean"]["output"]>;
    restrictions?: Maybe<ConfluenceLegacyScheduledRestrictions>;
    targetLocation?: Maybe<ConfluenceLegacyTargetLocation>;
    targetType?: Maybe<Scalars["String"]["output"]>;
    versionComment?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyScheduledPublishSummary = {
    __typename?: "ConfluenceLegacyScheduledPublishSummary";
    isScheduled?: Maybe<Scalars["Boolean"]["output"]>;
    when?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyScheduledRestriction = {
    __typename?: "ConfluenceLegacyScheduledRestriction";
    group?: Maybe<ConfluenceLegacyPaginatedGroupList>;
    user?: Maybe<ConfluenceLegacyPaginatedUserList>;
};

export type ConfluenceLegacyScheduledRestrictions = {
    __typename?: "ConfluenceLegacyScheduledRestrictions";
    read?: Maybe<ConfluenceLegacyScheduledRestriction>;
    update?: Maybe<ConfluenceLegacyScheduledRestriction>;
};

export type ConfluenceLegacyScreenLookAndFeel = {
    __typename?: "ConfluenceLegacyScreenLookAndFeel";
    background?: Maybe<Scalars["String"]["output"]>;
    backgroundAttachment?: Maybe<Scalars["String"]["output"]>;
    backgroundBlendMode?: Maybe<Scalars["String"]["output"]>;
    backgroundClip?: Maybe<Scalars["String"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<Scalars["String"]["output"]>;
    backgroundOrigin?: Maybe<Scalars["String"]["output"]>;
    backgroundPosition?: Maybe<Scalars["String"]["output"]>;
    backgroundRepeat?: Maybe<Scalars["String"]["output"]>;
    backgroundSize?: Maybe<Scalars["String"]["output"]>;
    gutterBottom?: Maybe<Scalars["String"]["output"]>;
    gutterLeft?: Maybe<Scalars["String"]["output"]>;
    gutterRight?: Maybe<Scalars["String"]["output"]>;
    gutterTop?: Maybe<Scalars["String"]["output"]>;
    layer?: Maybe<ConfluenceLegacyLayerScreenLookAndFeel>;
};

export type ConfluenceLegacySearchFieldLookAndFeel = {
    __typename?: "ConfluenceLegacySearchFieldLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    color?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySearchResult = {
    __typename?: "ConfluenceLegacySearchResult";
    breadcrumbs: Array<Maybe<ConfluenceLegacyBreadcrumb>>;
    content?: Maybe<ConfluenceLegacyContent>;
    entityType?: Maybe<Scalars["String"]["output"]>;
    excerpt?: Maybe<Scalars["String"]["output"]>;
    friendlyLastModified?: Maybe<Scalars["String"]["output"]>;
    iconCssClass?: Maybe<Scalars["String"]["output"]>;
    lastModified?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    resultGlobalContainer?: Maybe<ConfluenceLegacyContainerSummary>;
    resultParentContainer?: Maybe<ConfluenceLegacyContainerSummary>;
    score?: Maybe<Scalars["Float"]["output"]>;
    space?: Maybe<ConfluenceLegacySpace>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<ConfluenceLegacyUser>;
};

export type ConfluenceLegacySearchResultEdge = {
    __typename?: "ConfluenceLegacySearchResultEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacySearchResult>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacySearchTimeseriesCtr = {
    __typename?: "ConfluenceLegacySearchTimeseriesCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacySearchTimeseriesCtrItem>;
};

export type ConfluenceLegacySearchTimeseriesCtrItem = {
    __typename?: "ConfluenceLegacySearchTimeseriesCTRItem";
    ctr: Scalars["Float"]["output"];
    /** Grouping date in ISO format */
    timestamp: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacySearchTimeseriesCount = {
    __typename?: "ConfluenceLegacySearchTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyTimeseriesCountItem>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacySearchesByTerm = {
    __typename?: "ConfluenceLegacySearchesByTerm";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacySearchesByTermItems>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacySearchesPageInfo;
};

export enum ConfluenceLegacySearchesByTermColumns {
    PageViewedPercentage = "pageViewedPercentage",
    SearchClickCount = "searchClickCount",
    SearchSessionCount = "searchSessionCount",
    SearchTerm = "searchTerm",
    Total = "total",
    UniqueUsers = "uniqueUsers"
}

export type ConfluenceLegacySearchesByTermItems = {
    __typename?: "ConfluenceLegacySearchesByTermItems";
    pageViewedPercentage: Scalars["Float"]["output"];
    searchClickCount: Scalars["Int"]["output"];
    searchSessionCount: Scalars["Int"]["output"];
    searchTerm: Scalars["String"]["output"];
    total: Scalars["Int"]["output"];
    uniqueUsers: Scalars["Int"]["output"];
};

export enum ConfluenceLegacySearchesByTermPeriod {
    Day = "day",
    Month = "month",
    Week = "week"
}

export type ConfluenceLegacySearchesPageInfo = {
    __typename?: "ConfluenceLegacySearchesPageInfo";
    next?: Maybe<Scalars["String"]["output"]>;
    prev?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacySearchesWithZeroCtr = {
    __typename?: "ConfluenceLegacySearchesWithZeroCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<ConfluenceLegacySearchesWithZeroCtrItem>>;
};

export type ConfluenceLegacySearchesWithZeroCtrItem = {
    __typename?: "ConfluenceLegacySearchesWithZeroCTRItem";
    count: Scalars["Int"]["output"];
    searchTerm: Scalars["String"]["output"];
};

export type ConfluenceLegacySetDefaultSpaceRolesInput = {
    spaceRoleAssignmentList: Array<ConfluenceLegacyRoleAssignment>;
};

export type ConfluenceLegacySetDefaultSpaceRolesPayload = Payload & {
    __typename?: "ConfluenceLegacySetDefaultSpaceRolesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacySetFeedUserConfigInput = {
    followSpaces?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    followUsers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    unfollowSpaces?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    unfollowUsers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type ConfluenceLegacySetFeedUserConfigPayload = {
    __typename?: "ConfluenceLegacySetFeedUserConfigPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountIds: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<ConfluenceLegacySetFeedUserConfigPayloadError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceIds: Array<Maybe<Scalars["Long"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'spaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    spaces?: Maybe<Array<Maybe<ConfluenceLegacySpace>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export type ConfluenceLegacySetFeedUserConfigPayloadError = {
    __typename?: "ConfluenceLegacySetFeedUserConfigPayloadError";
    extensions?: Maybe<ConfluenceLegacySetFeedUserConfigPayloadErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySetFeedUserConfigPayloadErrorExtension = {
    __typename?: "ConfluenceLegacySetFeedUserConfigPayloadErrorExtension";
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacySetRecommendedPagesSpaceStatusInput = {
    defaultBehavior?: InputMaybe<ConfluenceLegacyRecommendedPagesSpaceBehavior>;
    enableRecommendedPages?: InputMaybe<Scalars["Boolean"]["input"]>;
    entityId: Scalars["ID"]["input"];
};

export type ConfluenceLegacySetRecommendedPagesSpaceStatusPayload = {
    __typename?: "ConfluenceLegacySetRecommendedPagesSpaceStatusPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<
        Array<ConfluenceLegacySetRecommendedPagesSpaceStatusPayloadError>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacySetRecommendedPagesSpaceStatusPayloadError = {
    __typename?: "ConfluenceLegacySetRecommendedPagesSpaceStatusPayloadError";
    extensions?: Maybe<ConfluenceLegacySetRecommendedPagesStatusPayloadErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySetRecommendedPagesStatusInput = {
    enableRecommendedPages: Scalars["Boolean"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: Scalars["String"]["input"];
};

export type ConfluenceLegacySetRecommendedPagesStatusPayload = {
    __typename?: "ConfluenceLegacySetRecommendedPagesStatusPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<
        Array<ConfluenceLegacySetRecommendedPagesStatusPayloadError>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacySetRecommendedPagesStatusPayloadError = {
    __typename?: "ConfluenceLegacySetRecommendedPagesStatusPayloadError";
    extensions?: Maybe<ConfluenceLegacySetRecommendedPagesStatusPayloadErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySetRecommendedPagesStatusPayloadErrorExtension = {
    __typename?: "ConfluenceLegacySetRecommendedPagesStatusPayloadErrorExtension";
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacySetSpaceRolesInput = {
    spaceId: Scalars["Long"]["input"];
    spaceRoleAssignmentList: Array<ConfluenceLegacyRoleAssignment>;
};

export type ConfluenceLegacySetSpaceRolesPayload = Payload & {
    __typename?: "ConfluenceLegacySetSpaceRolesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyShareResourceInput = {
    atlOrigin: Scalars["String"]["input"];
    contextualPageId: Scalars["String"]["input"];
    emails: Array<InputMaybe<Scalars["String"]["input"]>>;
    entityId: Scalars["String"]["input"];
    entityType: Scalars["String"]["input"];
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groups: Array<InputMaybe<Scalars["String"]["input"]>>;
    isShareEmailExperiment: Scalars["Boolean"]["input"];
    note: Scalars["String"]["input"];
    shareType: ConfluenceLegacyShareType;
    users: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ConfluenceLegacyShareResourcePayload = {
    __typename?: "ConfluenceLegacyShareResourcePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ConfluenceLegacyShareType {
    InviteToEdit = "INVITE_TO_EDIT",
    SharePage = "SHARE_PAGE"
}

export type ConfluenceLegacySignUpProperties = {
    __typename?: "ConfluenceLegacySignUpProperties";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reverseTrial?: Maybe<ConfluenceLegacyReverseTrialCohort>;
};

export type ConfluenceLegacySiteConfiguration = {
    __typename?: "ConfluenceLegacySiteConfiguration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ccpEntitlementId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    companyHubName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customSiteLogo: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    frontCoverState: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    newCustomer: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    productAdmins: ConfluenceLegacyPaginatedPersonList;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showFrontCover: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showSiteTitle: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteFaviconUrl: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteLogoUrl: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteTitle: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tenantId?: Maybe<Scalars["ID"]["output"]>;
};

export type ConfluenceLegacySiteConfigurationProductAdminsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    excludeAddOns?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySiteLookAndFeel = {
    __typename?: "ConfluenceLegacySiteLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    faviconFiles: Array<ConfluenceLegacyFaviconFile>;
    frontCoverState?: Maybe<Scalars["String"]["output"]>;
    highlightColor?: Maybe<Scalars["String"]["output"]>;
    showFrontCover?: Maybe<Scalars["Boolean"]["output"]>;
    showSiteName?: Maybe<Scalars["Boolean"]["output"]>;
    siteLogoFileStoreId?: Maybe<Scalars["ID"]["output"]>;
    siteName?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySitePermission = {
    __typename?: "ConfluenceLegacySitePermission";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    anonymous?: Maybe<ConfluenceLegacyAnonymous>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    anonymousAccessDSPBlocked?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groups?: Maybe<ConfluenceLegacyPaginatedGroupWithPermissions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unlicensedUserWithPermissions?: Maybe<ConfluenceLegacyUnlicensedUserWithPermissions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    users?: Maybe<ConfluenceLegacyPaginatedUserWithPermissions>;
};

export type ConfluenceLegacySitePermissionGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySitePermissionUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySitePermissionInput = {
    permissionsToAdd?: InputMaybe<ConfluenceLegacyUpdateSitePermissionInput>;
    permissionsToRemove?: InputMaybe<ConfluenceLegacyUpdateSitePermissionInput>;
};

export enum ConfluenceLegacySitePermissionOperationType {
    AdministerConfluence = "ADMINISTER_CONFLUENCE",
    AdministerSystem = "ADMINISTER_SYSTEM",
    CreateProfileattachment = "CREATE_PROFILEATTACHMENT",
    CreateSpace = "CREATE_SPACE",
    ExternalCollaborator = "EXTERNAL_COLLABORATOR",
    LimitedUseConfluence = "LIMITED_USE_CONFLUENCE",
    ReadUserprofile = "READ_USERPROFILE",
    UpdateUserstatus = "UPDATE_USERSTATUS",
    UseConfluence = "USE_CONFLUENCE",
    UsePersonalspace = "USE_PERSONALSPACE"
}

export enum ConfluenceLegacySitePermissionType {
    Anonymous = "ANONYMOUS",
    App = "APP",
    External = "EXTERNAL",
    Internal = "INTERNAL",
    Jsd = "JSD"
}

export enum ConfluenceLegacySitePermissionTypeFilter {
    All = "ALL",
    Externalcollaborator = "EXTERNALCOLLABORATOR",
    None = "NONE"
}

export type ConfluenceLegacySmartConnectorsFeature = {
    __typename?: "ConfluenceLegacySmartConnectorsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacySmartFeaturesCommentsSummary = {
    __typename?: "ConfluenceLegacySmartFeaturesCommentsSummary";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["ID"]["output"];
};

export type ConfluenceLegacySmartFeaturesContentSummary = {
    __typename?: "ConfluenceLegacySmartFeaturesContentSummary";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastUpdatedTimeSeconds: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartFeaturesError = {
    __typename?: "ConfluenceLegacySmartFeaturesError";
    errorCode: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    message: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartFeaturesErrorResponse = {
    __typename?: "ConfluenceLegacySmartFeaturesErrorResponse";
    entityType: Scalars["String"]["output"];
    error?: Maybe<Array<Maybe<ConfluenceLegacySmartFeaturesError>>>;
};

export type ConfluenceLegacySmartFeaturesInput = {
    entityIds: Array<Scalars["String"]["input"]>;
    entityType: Scalars["String"]["input"];
    features?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ConfluenceLegacySmartFeaturesPageResult = {
    __typename?: "ConfluenceLegacySmartFeaturesPageResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    features: ConfluenceLegacySmartPageFeatures;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartFeaturesPageResultResponse =
    ConfluenceLegacySmartFeaturesResultResponse & {
        __typename?: "ConfluenceLegacySmartFeaturesPageResultResponse";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityType: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        result?: Maybe<Array<Maybe<ConfluenceLegacySmartFeaturesPageResult>>>;
    };

export type ConfluenceLegacySmartFeaturesResponse = {
    __typename?: "ConfluenceLegacySmartFeaturesResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<Maybe<ConfluenceLegacySmartFeaturesErrorResponse>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    results?: Maybe<Array<Maybe<ConfluenceLegacySmartFeaturesResultResponse>>>;
};

export type ConfluenceLegacySmartFeaturesResultResponse = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityType: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartFeaturesSpaceResult = {
    __typename?: "ConfluenceLegacySmartFeaturesSpaceResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    features: ConfluenceLegacySmartSpaceFeatures;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartFeaturesSpaceResultResponse =
    ConfluenceLegacySmartFeaturesResultResponse & {
        __typename?: "ConfluenceLegacySmartFeaturesSpaceResultResponse";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityType: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        result?: Maybe<Array<Maybe<ConfluenceLegacySmartFeaturesSpaceResult>>>;
    };

export type ConfluenceLegacySmartFeaturesUserResult = {
    __typename?: "ConfluenceLegacySmartFeaturesUserResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    features: ConfluenceLegacySmartUserFeatures;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartFeaturesUserResultResponse =
    ConfluenceLegacySmartFeaturesResultResponse & {
        __typename?: "ConfluenceLegacySmartFeaturesUserResultResponse";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityType: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        result?: Maybe<Array<Maybe<ConfluenceLegacySmartFeaturesUserResult>>>;
    };

/** Represents a smart-link on a page */
export type ConfluenceLegacySmartLink = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type ConfluenceLegacySmartLinkContent = {
    __typename?: "ConfluenceLegacySmartLinkContent";
    contentId: Scalars["ID"]["output"];
    contentType?: Maybe<Scalars["String"]["output"]>;
    embedURL: Scalars["String"]["output"];
    iconURL?: Maybe<Scalars["String"]["output"]>;
    parentPageId: Scalars["String"]["output"];
    spaceId: Scalars["String"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySmartLinkEdge = {
    __typename?: "ConfluenceLegacySmartLinkEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacySmartLink>;
};

export type ConfluenceLegacySmartPageFeatures = {
    __typename?: "ConfluenceLegacySmartPageFeatures";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentsDaily?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentsMonthly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentsWeekly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentsYearly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likesDaily?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likesMonthly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likesWeekly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likesYearly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    readTime?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewsDaily?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewsMonthly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewsWeekly?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewsYearly?: Maybe<Scalars["Float"]["output"]>;
};

export type ConfluenceLegacySmartSectionsFeature = {
    __typename?: "ConfluenceLegacySmartSectionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacySmartSpaceFeatures = {
    __typename?: "ConfluenceLegacySmartSpaceFeatures";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    topTemplates?: Maybe<Array<Maybe<ConfluenceLegacyTopTemplateItem>>>;
};

export type ConfluenceLegacySmartUserFeatures = {
    __typename?: "ConfluenceLegacySmartUserFeatures";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPeople?: Maybe<
        Array<Maybe<ConfluenceLegacyRecommendedPeopleItem>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedSpaces?: Maybe<
        Array<Maybe<ConfluenceLegacyRecommendedSpaceItem>>
    >;
};

export type ConfluenceLegacySnippet = {
    __typename?: "ConfluenceLegacySnippet";
    body?: Maybe<Scalars["String"]["output"]>;
    creationDate?: Maybe<ConfluenceLegacyDate>;
    creator?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    position?: Maybe<Scalars["Float"]["output"]>;
    scope?: Maybe<Scalars["String"]["output"]>;
    spaceKey?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySnippetEdge = {
    __typename?: "ConfluenceLegacySnippetEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacySnippet>;
};

export type ConfluenceLegacySoftDeleteSpacePayload = Payload & {
    __typename?: "ConfluenceLegacySoftDeleteSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacySpaUnfriendlyMacro = {
    __typename?: "ConfluenceLegacySpaUnfriendlyMacro";
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySpaViewModel = {
    __typename?: "ConfluenceLegacySpaViewModel";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use abTestCohorts top level query
     */
    abTestCohorts?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use experimentFeatures top level query
     */
    experimentFeatures?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homepageTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homepageUri?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isAnonymous?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use Onboarding.isNewUser
     */
    isNewUser?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use isSiteAdmin top level query
     */
    isSiteAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceContexts?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showEditButton?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.showSiteTitle
     */
    showSiteTitle?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showWelcomeMessageEditHint?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.siteLogoUrl
     */
    siteLogoUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.siteTitle
     */
    siteTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.tenantId
     */
    tenantId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userCanCreateContent?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    welcomeMessageEditUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    welcomeMessageHtml?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySpace = {
    __typename?: "ConfluenceLegacySpace";
    admins?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use contentRoots
     */
    archivedContentRoots: ConfluenceLegacyPaginatedContentList;
    containsExternalCollaborators: Scalars["Boolean"]["output"];
    contentRoots: ConfluenceLegacyPaginatedContentList;
    creatorAccountId?: Maybe<Scalars["String"]["output"]>;
    currentUser: ConfluenceLegacySpaceUserMetadata;
    dataClassificationTags: Array<Maybe<Scalars["String"]["output"]>>;
    /** GraphQL query to get default classification level ID for content in a space. */
    defaultClassificationLevelId?: Maybe<Scalars["ID"]["output"]>;
    description?: Maybe<ConfluenceLegacySpaceDescriptions>;
    directAccessExternalCollaborators?: Maybe<ConfluenceLegacyPaginatedPersonList>;
    externalCollaboratorAndGroupCount: Scalars["Int"]["output"];
    externalCollaboratorCount: Scalars["Int"]["output"];
    externalGroupsWithAccess?: Maybe<ConfluenceLegacyPaginatedGroupList>;
    /** GraphQL query to check whether space has default classification level set. */
    hasDefaultClassificationLevel: Scalars["Boolean"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated hasGroupRestriction Query is not in use
     */
    hasGroupRestriction: Scalars["Boolean"]["output"];
    hasRestriction: Scalars["Boolean"]["output"];
    history?: Maybe<ConfluenceLegacySpaceHistory>;
    homepage?: Maybe<ConfluenceLegacyContent>;
    homepageId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'homepageV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    homepageV2?: Maybe<ConfluenceLegacyContent>;
    icon?: Maybe<ConfluenceLegacyIcon>;
    id?: Maybe<Scalars["ID"]["output"]>;
    identifiers?: Maybe<ConfluenceLegacyGlobalSpaceIdentifier>;
    /** GraphQL query to determine whether export is enabled for space. */
    isExportEnabled: Scalars["Boolean"]["output"];
    key?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
    lookAndFeel?: Maybe<ConfluenceLegacyLookAndFeel>;
    metadata: ConfluenceLegacySpaceMetadata;
    name?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    permissions?: Maybe<Array<Maybe<ConfluenceLegacySpacePermission>>>;
    settings?: Maybe<ConfluenceLegacySpaceSettings>;
    spaceAdmins: ConfluenceLegacyPaginatedPersonList;
    spaceTypeSettings: ConfluenceLegacySpaceTypeSettings;
    status?: Maybe<Scalars["String"]["output"]>;
    theme?: Maybe<ConfluenceLegacyTheme>;
    /** Get total count of blogposts without override classifications */
    totalBlogpostsWithoutClassificationLevelOverride: Scalars["Long"]["output"];
    /** Get total count of content items without classification level overrides */
    totalContentWithoutClassificationLevelOverride: Scalars["Int"]["output"];
    /** Get total count of pages without override classifications */
    totalPagesWithoutClassificationLevelOverride: Scalars["Long"]["output"];
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySpaceAdminsArgs = {
    accountType?: InputMaybe<ConfluenceLegacyAccountType>;
};

export type ConfluenceLegacySpaceArchivedContentRootsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacySpaceContentRootsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacySpaceDirectAccessExternalCollaboratorsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySpaceExternalGroupsWithAccessArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySpaceHasGroupRestrictionArgs = {
    groupName: Scalars["String"]["input"];
    groupPermission: Scalars["String"]["input"];
};

export type ConfluenceLegacySpaceHasRestrictionArgs = {
    accountID: Scalars["String"]["input"];
    permission: ConfluenceLegacyInspectPermissions;
};

export type ConfluenceLegacySpaceSpaceAdminsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    excludeAddOns?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConfluenceLegacySpaceAssignmentType {
    Assigned = "ASSIGNED",
    Unassigned = "UNASSIGNED"
}

export type ConfluenceLegacySpaceDescriptions = {
    __typename?: "ConfluenceLegacySpaceDescriptions";
    atlasDocFormat?: Maybe<ConfluenceLegacyFormattedBody>;
    dynamic?: Maybe<ConfluenceLegacyFormattedBody>;
    editor?: Maybe<ConfluenceLegacyFormattedBody>;
    editor2?: Maybe<ConfluenceLegacyFormattedBody>;
    exportView?: Maybe<ConfluenceLegacyFormattedBody>;
    plain?: Maybe<ConfluenceLegacyFormattedBody>;
    raw?: Maybe<ConfluenceLegacyFormattedBody>;
    storage?: Maybe<ConfluenceLegacyFormattedBody>;
    styledView?: Maybe<ConfluenceLegacyFormattedBody>;
    view?: Maybe<ConfluenceLegacyFormattedBody>;
    wiki?: Maybe<ConfluenceLegacyFormattedBody>;
};

export type ConfluenceLegacySpaceEdge = {
    __typename?: "ConfluenceLegacySpaceEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacySpace>;
};

export type ConfluenceLegacySpaceHistory = {
    __typename?: "ConfluenceLegacySpaceHistory";
    createdBy?: Maybe<ConfluenceLegacyPerson>;
    createdDate?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
};

export type ConfluenceLegacySpaceInput = {
    key: Scalars["ID"]["input"];
};

export type ConfluenceLegacySpaceMetadata = {
    __typename?: "ConfluenceLegacySpaceMetadata";
    labels?: Maybe<ConfluenceLegacyPaginatedLabelList>;
    recentCommenters?: Maybe<ConfluenceLegacyPaginatedUserList>;
    recentWatchers?: Maybe<ConfluenceLegacyPaginatedUserList>;
    totalCommenters: Scalars["Long"]["output"];
    totalCurrentBlogPosts: Scalars["Long"]["output"];
    totalCurrentPages: Scalars["Long"]["output"];
    totalPageUpdatesSinceLast7Days: Scalars["Long"]["output"];
    totalWatchers: Scalars["Long"]["output"];
};

export type ConfluenceLegacySpaceOrContent = {
    __typename?: "ConfluenceLegacySpaceOrContent";
    ancestors?: Maybe<Array<Maybe<ConfluenceLegacyContent>>>;
    body?: Maybe<ConfluenceLegacyContentBodyPerRepresentation>;
    childTypes?: Maybe<ConfluenceLegacyChildContentTypesAvailable>;
    container?: Maybe<ConfluenceLegacySpaceOrContent>;
    creatorAccountId?: Maybe<Scalars["String"]["output"]>;
    dataClassificationTags: Array<Maybe<Scalars["String"]["output"]>>;
    description?: Maybe<ConfluenceLegacySpaceDescriptions>;
    extensions?: Maybe<Array<Maybe<ConfluenceLegacyKeyValueHierarchyMap>>>;
    history?: Maybe<ConfluenceLegacyHistory>;
    homepage?: Maybe<ConfluenceLegacyContent>;
    homepageId?: Maybe<Scalars["ID"]["output"]>;
    icon?: Maybe<ConfluenceLegacyIcon>;
    id?: Maybe<Scalars["ID"]["output"]>;
    identifiers?: Maybe<ConfluenceLegacyGlobalSpaceIdentifier>;
    key?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
    lookAndFeel?: Maybe<ConfluenceLegacyLookAndFeel>;
    macroRenderedOutput?: Maybe<
        Array<Maybe<ConfluenceLegacyMapOfStringToFormattedBody>>
    >;
    metadata: ConfluenceLegacyContentMetadata;
    name?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    permissions?: Maybe<Array<Maybe<ConfluenceLegacySpacePermission>>>;
    referenceId?: Maybe<Scalars["String"]["output"]>;
    restrictions?: Maybe<ConfluenceLegacyContentRestrictions>;
    schedulePublishDate?: Maybe<Scalars["String"]["output"]>;
    schedulePublishInfo?: Maybe<ConfluenceLegacySchedulePublishInfo>;
    settings?: Maybe<ConfluenceLegacySpaceSettings>;
    space?: Maybe<ConfluenceLegacySpace>;
    status?: Maybe<Scalars["String"]["output"]>;
    subType?: Maybe<Scalars["String"]["output"]>;
    theme?: Maybe<ConfluenceLegacyTheme>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<ConfluenceLegacyVersion>;
};

export type ConfluenceLegacySpacePagesDisplayView = {
    spaceKey: Scalars["String"]["input"];
    spacePagesPersistenceOption: ConfluenceLegacyPagesDisplayPersistenceOption;
};

export type ConfluenceLegacySpacePagesSortView = {
    spaceKey: Scalars["String"]["input"];
    spacePagesSortPersistenceOption: ConfluenceLegacyPagesSortPersistenceOptionInput;
};

export type ConfluenceLegacySpacePermission = {
    __typename?: "ConfluenceLegacySpacePermission";
    anonymousAccess?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    operation?: Maybe<ConfluenceLegacyOperationCheckResult>;
    subjects?: Maybe<ConfluenceLegacySubjectsByType>;
    unlicensedAccess?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacySpacePermissionConnection = {
    __typename?: "ConfluenceLegacySpacePermissionConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacySpacePermissionEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacySpacePermissionInfo>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacySpacePermissionPageInfo;
};

export type ConfluenceLegacySpacePermissionEdge = {
    __typename?: "ConfluenceLegacySpacePermissionEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: ConfluenceLegacySpacePermissionInfo;
};

export type ConfluenceLegacySpacePermissionGroup = {
    __typename?: "ConfluenceLegacySpacePermissionGroup";
    displayName: Scalars["String"]["output"];
    priority: Scalars["Int"]["output"];
};

export type ConfluenceLegacySpacePermissionInfo = {
    __typename?: "ConfluenceLegacySpacePermissionInfo";
    description?: Maybe<Scalars["String"]["output"]>;
    displayName: Scalars["String"]["output"];
    group: ConfluenceLegacySpacePermissionGroup;
    id: Scalars["String"]["output"];
    priority: Scalars["Int"]["output"];
    requiredSpacePermissions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ConfluenceLegacySpacePermissionPageInfo = {
    __typename?: "ConfluenceLegacySpacePermissionPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacySpacePermissionSubject = {
    __typename?: "ConfluenceLegacySpacePermissionSubject";
    filteredPrincipalSubjectKey?: Maybe<ConfluenceLegacyFilteredPrincipalSubjectKey>;
    permissions?: Maybe<Array<Maybe<ConfluenceLegacySpacePermissionType>>>;
    subjectKey?: Maybe<ConfluenceLegacySubjectKey>;
};

export type ConfluenceLegacySpacePermissionSubjectEdge = {
    __typename?: "ConfluenceLegacySpacePermissionSubjectEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacySpacePermissionSubject>;
};

export enum ConfluenceLegacySpacePermissionType {
    AdministerSpace = "ADMINISTER_SPACE",
    ArchivePage = "ARCHIVE_PAGE",
    Comment = "COMMENT",
    CreateAttachment = "CREATE_ATTACHMENT",
    CreateEditPage = "CREATE_EDIT_PAGE",
    EditBlog = "EDIT_BLOG",
    ExportPage = "EXPORT_PAGE",
    ExportSpace = "EXPORT_SPACE",
    RemoveAttachment = "REMOVE_ATTACHMENT",
    RemoveBlog = "REMOVE_BLOG",
    RemoveComment = "REMOVE_COMMENT",
    RemoveMail = "REMOVE_MAIL",
    RemoveOwnContent = "REMOVE_OWN_CONTENT",
    RemovePage = "REMOVE_PAGE",
    SetPagePermissions = "SET_PAGE_PERMISSIONS",
    ViewSpace = "VIEW_SPACE"
}

export type ConfluenceLegacySpacePermissions = {
    __typename?: "ConfluenceLegacySpacePermissions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editable: Scalars["Boolean"]["output"];
    /**
     * GraphQL query to get a paged list of subjects which have space permissions on given space, excluding single space guest groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filteredSubjectsWithPermissions: ConfluenceLegacyPaginatedSpacePermissionSubjectList;
    /**
     * GraphQL query to get a paged list of groups with default space permissions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupsWithDefaultSpacePermissions: ConfluenceLegacyPaginatedSpacePermissionSubjectList;
    /**
     * GraphQL query to get a paged list of subjects with default space permissions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithDefaultSpacePermissions: ConfluenceLegacyPaginatedSpacePermissionSubjectList;
    /**
     * GraphQL query to get a paged list of subjects which have space permissions on given space, excluding single space guest groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithPermissions: ConfluenceLegacyPaginatedSpacePermissionSubjectList;
};

export type ConfluenceLegacySpacePermissionsFilteredSubjectsWithPermissionsArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        filterText?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        permissionDisplayType?: InputMaybe<ConfluenceLegacyPermissionDisplayType>;
    };

export type ConfluenceLegacySpacePermissionsGroupsWithDefaultSpacePermissionsArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        filterText?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type ConfluenceLegacySpacePermissionsSubjectsWithDefaultSpacePermissionsArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        filterText?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type ConfluenceLegacySpacePermissionsSubjectsWithPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySpaceRole = {
    __typename?: "ConfluenceLegacySpaceRole";
    roleDisplayName: Scalars["String"]["output"];
    roleId: Scalars["ID"]["output"];
    roleType: ConfluenceLegacySpaceRoleType;
    spacePermissionList: Array<ConfluenceLegacySpacePermissionInfo>;
};

export type ConfluenceLegacySpaceRoleAssignment = {
    __typename?: "ConfluenceLegacySpaceRoleAssignment";
    permissions?: Maybe<Array<ConfluenceLegacySpacePermissionInfo>>;
    principal: ConfluenceLegacySpaceRolePrincipal;
    role?: Maybe<ConfluenceLegacySpaceRole>;
    spaceId: Scalars["Long"]["output"];
};

export type ConfluenceLegacySpaceRoleAssignmentConnection = {
    __typename?: "ConfluenceLegacySpaceRoleAssignmentConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceLegacySpaceRoleAssignmentEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<ConfluenceLegacySpaceRoleAssignment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ConfluenceLegacySpacePermissionPageInfo;
};

export type ConfluenceLegacySpaceRoleAssignmentEdge = {
    __typename?: "ConfluenceLegacySpaceRoleAssignmentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: ConfluenceLegacySpaceRoleAssignment;
};

export type ConfluenceLegacySpaceRoleGroupPrincipal =
    ConfluenceLegacySpaceRolePrincipal & {
        __typename?: "ConfluenceLegacySpaceRoleGroupPrincipal";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        displayName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        principalId: Scalars["ID"]["output"];
    };

export type ConfluenceLegacySpaceRoleGuestPrincipal =
    ConfluenceLegacySpaceRolePrincipal & {
        __typename?: "ConfluenceLegacySpaceRoleGuestPrincipal";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        displayName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        email?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        principalId: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        profilePicture?: Maybe<ConfluenceLegacyIcon>;
    };

export type ConfluenceLegacySpaceRolePrincipal = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId: Scalars["ID"]["output"];
};

export enum ConfluenceLegacySpaceRoleType {
    Custom = "CUSTOM",
    System = "SYSTEM"
}

export type ConfluenceLegacySpaceRoleUserPrincipal =
    ConfluenceLegacySpaceRolePrincipal & {
        __typename?: "ConfluenceLegacySpaceRoleUserPrincipal";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        displayName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        email?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        principalId: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        profilePicture?: Maybe<ConfluenceLegacyIcon>;
    };

export type ConfluenceLegacySpaceSettings = {
    __typename?: "ConfluenceLegacySpaceSettings";
    contentStateSettings: ConfluenceLegacyContentStateSettings;
    customHeaderAndFooter: ConfluenceLegacySpaceSettingsMetadata;
    editor?: Maybe<ConfluenceLegacyEditorVersionsMetadataDto>;
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    routeOverrideEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacySpaceSettingsMetadata = {
    __typename?: "ConfluenceLegacySpaceSettingsMetadata";
    footer: ConfluenceLegacyHtmlMeta;
    header: ConfluenceLegacyHtmlMeta;
};

export type ConfluenceLegacySpaceShortcutsInput = {
    iconUrl?: InputMaybe<Scalars["String"]["input"]>;
    isPinnedPage: Scalars["Boolean"]["input"];
    shortcutId: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacySpaceSidebarLink = {
    __typename?: "ConfluenceLegacySpaceSidebarLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canHide?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hidden: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<ConfluenceLegacyIcon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconClass?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    linkIdentifier?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    position: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    styleClass?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tooltip?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: ConfluenceLegacySpaceSidebarLinkType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    urlWithoutContextPath?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webItemCompleteKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webItemKey?: Maybe<Scalars["String"]["output"]>;
};

export enum ConfluenceLegacySpaceSidebarLinkType {
    ExternalLink = "EXTERNAL_LINK",
    Forge = "FORGE",
    PinnedAttachment = "PINNED_ATTACHMENT",
    PinnedBlogPost = "PINNED_BLOG_POST",
    PinnedPage = "PINNED_PAGE",
    PinnedSpace = "PINNED_SPACE",
    PinnedUserInfo = "PINNED_USER_INFO",
    WebItem = "WEB_ITEM"
}

export type ConfluenceLegacySpaceSidebarLinks = {
    __typename?: "ConfluenceLegacySpaceSidebarLinks";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    advanced?: Maybe<Array<Maybe<ConfluenceLegacySpaceSidebarLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    main?: Maybe<Array<Maybe<ConfluenceLegacySpaceSidebarLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    quick?: Maybe<Array<Maybe<ConfluenceLegacySpaceSidebarLink>>>;
};

export type ConfluenceLegacySpaceSidebarLinksMainArgs = {
    includeHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacySpaceTypeSettings = {
    __typename?: "ConfluenceLegacySpaceTypeSettings";
    enabledContentTypes: ConfluenceLegacyEnabledContentTypes;
    enabledFeatures: ConfluenceLegacyEnabledFeatures;
};

export type ConfluenceLegacySpaceTypeSettingsInput = {
    enabledContentTypes?: InputMaybe<ConfluenceLegacyEnabledContentTypesInput>;
    enabledFeatures?: InputMaybe<ConfluenceLegacyEnabledFeaturesInput>;
};

export type ConfluenceLegacySpaceUserMetadata = {
    __typename?: "ConfluenceLegacySpaceUserMetadata";
    isAdmin: Scalars["Boolean"]["output"];
    isFavourited: Scalars["Boolean"]["output"];
    isWatched: Scalars["Boolean"]["output"];
    isWatchingBlogs: Scalars["Boolean"]["output"];
    lastVisitedDate?: Maybe<ConfluenceLegacyDate>;
};

export type ConfluenceLegacySpaceUserMetadataLastVisitedDateArgs = {
    format?: InputMaybe<ConfluenceLegacyDateFormat>;
};

export type ConfluenceLegacySpaceViewsPersistence = {
    persistenceOption: ConfluenceLegacySpaceViewsPersistenceOption;
    spaceKey: Scalars["String"]["input"];
};

export enum ConfluenceLegacySpaceViewsPersistenceOption {
    Popularity = "POPULARITY",
    RecentlyModified = "RECENTLY_MODIFIED",
    RecentlyViewed = "RECENTLY_VIEWED",
    TitleAz = "TITLE_AZ",
    Tree = "TREE"
}

export type ConfluenceLegacySpaceWithExemption = {
    __typename?: "ConfluenceLegacySpaceWithExemption";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<ConfluenceLegacyIcon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyStalePagePayload = {
    __typename?: "ConfluenceLegacyStalePagePayload";
    lastActivityDate: Scalars["String"]["output"];
    lastViewedDate?: Maybe<Scalars["String"]["output"]>;
    pageId: Scalars["String"]["output"];
    pageStatus: ConfluenceLegacyStalePageStatus;
    spaceId: Scalars["String"]["output"];
};

export type ConfluenceLegacyStalePagePayloadEdge = {
    __typename?: "ConfluenceLegacyStalePagePayloadEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyStalePagePayload>;
};

export enum ConfluenceLegacyStalePageStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ConfluenceLegacyStalePagesSortingType {
    Asc = "ASC",
    Desc = "DESC"
}

export type ConfluenceLegacyStep = {
    from?: InputMaybe<Scalars["Long"]["input"]>;
    mark: ConfluenceLegacyMark;
    pos?: InputMaybe<Scalars["Long"]["input"]>;
    to?: InputMaybe<Scalars["Long"]["input"]>;
};

export type ConfluenceLegacyStorage = {
    __typename?: "ConfluenceLegacyStorage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bytesUsed: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    gracePeriodEndDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isStorageEnforcementGracePeriodComplete?: Maybe<
        Scalars["Boolean"]["output"]
    >;
};

export type ConfluenceLegacySubjectKey = {
    __typename?: "ConfluenceLegacySubjectKey";
    /** User display name for a user, or group name for a group */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** If subject type is not GROUP, then this query will return null */
    group?: Maybe<ConfluenceLegacyGroup>;
    /** User account id for a user, or group external id for a group */
    id?: Maybe<Scalars["String"]["output"]>;
    /** Subject type */
    principalType: ConfluenceLegacyPrincipalType;
    /** If subject type is not USER, then this query will return null */
    user?: Maybe<ConfluenceLegacyUser>;
};

export type ConfluenceLegacySubjectPermissionDeltas = {
    permissionsToAdd: Array<InputMaybe<ConfluenceLegacySpacePermissionType>>;
    permissionsToRemove: Array<InputMaybe<ConfluenceLegacySpacePermissionType>>;
    subjectKeyInput: ConfluenceLegacyUpdatePermissionSubjectKeyInput;
};

export type ConfluenceLegacySubjectUserOrGroup = {
    __typename?: "ConfluenceLegacySubjectUserOrGroup";
    displayName?: Maybe<Scalars["String"]["output"]>;
    group?: Maybe<ConfluenceLegacyGroupWithRestrictions>;
    id?: Maybe<Scalars["String"]["output"]>;
    permissions: Array<Maybe<ConfluenceLegacyContentPermissionType>>;
    type?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<ConfluenceLegacyUserWithRestrictions>;
};

export type ConfluenceLegacySubjectUserOrGroupEdge = {
    __typename?: "ConfluenceLegacySubjectUserOrGroupEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacySubjectUserOrGroup>;
};

export type ConfluenceLegacySubjectsByType = {
    __typename?: "ConfluenceLegacySubjectsByType";
    group?: Maybe<ConfluenceLegacyPaginatedGroupList>;
    groupWithRestrictions?: Maybe<ConfluenceLegacyPaginatedGroupWithRestrictions>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    user?: Maybe<ConfluenceLegacyPaginatedUserList>;
    userWithRestrictions?: Maybe<ConfluenceLegacyPaginatedUserWithRestrictions>;
};

export type ConfluenceLegacySubjectsByTypeGroupArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySubjectsByTypeGroupWithRestrictionsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySubjectsByTypeUserArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacySubjectsByTypeUserWithRestrictionsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ConfluenceLegacySummaryType {
    Blogpost = "BLOGPOST",
    Page = "PAGE"
}

export type ConfluenceLegacySuperAdminPayload = {
    __typename?: "ConfluenceLegacySuperAdminPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["ID"]["output"]>;
};

export type ConfluenceLegacySuperBatchWebResources = {
    __typename?: "ConfluenceLegacySuperBatchWebResources";
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    metatags?: Maybe<Scalars["String"]["output"]>;
    tags?: Maybe<ConfluenceLegacyWebResourceTags>;
    uris?: Maybe<ConfluenceLegacyWebResourceUris>;
};

export type ConfluenceLegacySystemSpaceHomepageInput = {
    systemSpaceHomepageTemplate: ConfluenceLegacySystemSpaceHomepageTemplate;
};

export enum ConfluenceLegacySystemSpaceHomepageTemplate {
    Eap = "EAP",
    Minimal = "MINIMAL",
    Visual = "VISUAL"
}

export type ConfluenceLegacyTapExperiment = {
    __typename?: "ConfluenceLegacyTapExperiment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experimentKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experimentValue: Scalars["String"]["output"];
};

export type ConfluenceLegacyTargetLocation = {
    __typename?: "ConfluenceLegacyTargetLocation";
    destinationSpace?: Maybe<ConfluenceLegacySpace>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
};

export enum ConfluenceLegacyTaskStatus {
    Checked = "CHECKED",
    Unchecked = "UNCHECKED"
}

export enum ConfluenceLegacyTeamCalendarDayOfWeek {
    Friday = "FRIDAY",
    Monday = "MONDAY",
    Saturday = "SATURDAY",
    Sunday = "SUNDAY",
    Thursday = "THURSDAY",
    Tuesday = "TUESDAY",
    Wednesday = "WEDNESDAY"
}

export type ConfluenceLegacyTeamCalendarFeature = {
    __typename?: "ConfluenceLegacyTeamCalendarFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyTeamCalendarSettings = {
    __typename?: "ConfluenceLegacyTeamCalendarSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    startDayOfWeek: ConfluenceLegacyTeamCalendarDayOfWeek;
};

export type ConfluenceLegacyTemplateBody = {
    __typename?: "ConfluenceLegacyTemplateBody";
    body: ConfluenceLegacyContentBody;
    id: Scalars["String"]["output"];
};

export type ConfluenceLegacyTemplateBodyEdge = {
    __typename?: "ConfluenceLegacyTemplateBodyEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyTemplateBody>;
};

export type ConfluenceLegacyTemplateCategory = {
    __typename?: "ConfluenceLegacyTemplateCategory";
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyTemplateCategoryEdge = {
    __typename?: "ConfluenceLegacyTemplateCategoryEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyTemplateCategory>;
};

export enum ConfluenceLegacyTemplateContentAppearance {
    Default = "DEFAULT",
    FullWidth = "FULL_WIDTH"
}

export type ConfluenceLegacyTemplateEntityFavouriteStatus = {
    isFavourite: Scalars["Boolean"]["input"];
    templateEntityId: Scalars["String"]["input"];
};

/** Provides template information. Useful for in - editor template gallery and more in the future. */
export type ConfluenceLegacyTemplateInfo = {
    __typename?: "ConfluenceLegacyTemplateInfo";
    author?: Maybe<Scalars["String"]["output"]>;
    blueprintModuleCompleteKey?: Maybe<Scalars["String"]["output"]>;
    categoryIds: Array<Maybe<Scalars["String"]["output"]>>;
    contentBlueprintId?: Maybe<Scalars["String"]["output"]>;
    darkModeIconURL?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    hasGlobalBlueprintContent: Scalars["Boolean"]["output"];
    hasWizard?: Maybe<Scalars["Boolean"]["output"]>;
    iconURL?: Maybe<Scalars["String"]["output"]>;
    isConvertible?: Maybe<Scalars["Boolean"]["output"]>;
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
    isLegacyTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    isNew?: Maybe<Scalars["Boolean"]["output"]>;
    isPromoted?: Maybe<Scalars["Boolean"]["output"]>;
    itemModuleCompleteKey?: Maybe<Scalars["String"]["output"]>;
    keywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    link?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    name?: Maybe<Scalars["String"]["output"]>;
    recommendationRank?: Maybe<Scalars["Int"]["output"]>;
    spaceKey?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
    templateId?: Maybe<Scalars["String"]["output"]>;
    templateType?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyTemplateInfoEdge = {
    __typename?: "ConfluenceLegacyTemplateInfoEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyTemplateInfo>;
};

export type ConfluenceLegacyTemplateMediaSession = {
    __typename?: "ConfluenceLegacyTemplateMediaSession";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collections: Array<Maybe<ConfluenceLegacyMapOfStringToString>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    configuration: ConfluenceLegacyMediaConfiguration;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    downloadToken: ConfluenceLegacyTemplateMediaToken;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    uploadToken: ConfluenceLegacyTemplateMediaToken;
};

export type ConfluenceLegacyTemplateMediaToken = {
    __typename?: "ConfluenceLegacyTemplateMediaToken";
    duration?: Maybe<Scalars["Int"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyTemplateMigration = {
    __typename?: "ConfluenceLegacyTemplateMigration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unsupportedTemplatesNames: Array<Maybe<Scalars["String"]["output"]>>;
};

export type ConfluenceLegacyTemplatePropertySetInput = {
    /** appearance of the template */
    contentAppearance?: InputMaybe<ConfluenceLegacyTemplateContentAppearance>;
};

export type ConfluenceLegacyTemplatePropertySetPayload = {
    __typename?: "ConfluenceLegacyTemplatePropertySetPayload";
    /** appearance of the template */
    contentAppearance?: Maybe<ConfluenceLegacyTemplateContentAppearance>;
};

export type ConfluenceLegacyTemplatizeInput = {
    contentId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyTenant = {
    __typename?: "ConfluenceLegacyTenant";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    activationId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cloudId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editions?: Maybe<ConfluenceLegacyEditions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    environment: ConfluenceLegacyEnvironment;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shard: Scalars["String"]["output"];
};

export type ConfluenceLegacyTenantContext = {
    __typename?: "ConfluenceLegacyTenantContext";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    baseUrl: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customDomainUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    initialProductList?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licensedProducts: Array<ConfluenceLegacyLicensedProduct>;
};

export type ConfluenceLegacyTheme = {
    __typename?: "ConfluenceLegacyTheme";
    description?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<ConfluenceLegacyIcon>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    name?: Maybe<Scalars["String"]["output"]>;
    themeKey?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyTimeseriesCount = {
    __typename?: "ConfluenceLegacyTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyTimeseriesCountItem>;
};

export type ConfluenceLegacyTimeseriesCountItem = {
    __typename?: "ConfluenceLegacyTimeseriesCountItem";
    /** Analytics count */
    count: Scalars["Int"]["output"];
    /** Grouping date in ISO format */
    date: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyTimeseriesPageBlogCount = {
    __typename?: "ConfluenceLegacyTimeseriesPageBlogCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyTimeseriesCountItem>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyTopRelevantUsers = {
    __typename?: "ConfluenceLegacyTopRelevantUsers";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceLegacyRelevantSpacesWrapper>>>;
};

export type ConfluenceLegacyTopTemplateItem = {
    __typename?: "ConfluenceLegacyTopTemplateItem";
    rank: Scalars["Int"]["output"];
    templateId: Scalars["String"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyTotalSearchCtr = {
    __typename?: "ConfluenceLegacyTotalSearchCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ConfluenceLegacyTotalSearchCtrItems>;
};

export type ConfluenceLegacyTotalSearchCtrItems = {
    __typename?: "ConfluenceLegacyTotalSearchCTRItems";
    clicks: Scalars["Long"]["output"];
    ctr: Scalars["Float"]["output"];
    searches: Scalars["Long"]["output"];
};

/** Start and end time of this request on the server */
export type ConfluenceLegacyTraceTiming = {
    __typename?: "ConfluenceLegacyTraceTiming";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    end?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    start?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyUnknownUser = ConfluenceLegacyPerson & {
    __typename?: "ConfluenceLegacyUnknownUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timeZone?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    username?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyUnlicensedUserWithPermissions = {
    __typename?: "ConfluenceLegacyUnlicensedUserWithPermissions";
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
};

export type ConfluenceLegacyUnlicensedUserWithPermissionsInput = {
    operations: Array<InputMaybe<ConfluenceLegacyOperationCheckResultInput>>;
};

export type ConfluenceLegacyUpdateAdminAnnouncementBannerInput = {
    appearance?: InputMaybe<Scalars["String"]["input"]>;
    content?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    isDismissible?: InputMaybe<Scalars["Boolean"]["input"]>;
    scheduledEndTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledStartTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledTimeZone?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<ConfluenceLegacyAdminAnnouncementBannerStatusType>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<ConfluenceLegacyAdminAnnouncementBannerVisibilityType>;
};

export type ConfluenceLegacyUpdateArchiveNotesInput = {
    archiveNote?: InputMaybe<Scalars["String"]["input"]>;
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

export type ConfluenceLegacyUpdateArchiveNotesPayload = {
    __typename?: "ConfluenceLegacyUpdateArchiveNotesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyUpdateCommentInput = {
    commentBody: ConfluenceLegacyCommentBody;
    commentId: Scalars["ID"]["input"];
    /** This field is being deprecated, you do not need to provide this value if the update.comment.mutations.optional.version FF is on */
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceLegacyUpdateContentDataClassificationLevelInput = {
    classificationLevelId: Scalars["ID"]["input"];
    contentStatus: ConfluenceLegacyContentDataClassificationMutationContentStatus;
    id: Scalars["Long"]["input"];
};

export type ConfluenceLegacyUpdateContentDataClassificationLevelPayload =
    Payload & {
        __typename?: "ConfluenceLegacyUpdateContentDataClassificationLevelPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyUpdateContentPermissionsInput = {
    contentRole: ConfluenceLegacyContentRole;
    principalId: Scalars["ID"]["input"];
    principalType: ConfluenceLegacyPrincipalType;
};

export type ConfluenceLegacyUpdateContentTemplateInput = {
    body: ConfluenceLegacyContentTemplateBodyInput;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    labels?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyContentTemplateLabelInput>>
    >;
    name: Scalars["String"]["input"];
    space?: InputMaybe<ConfluenceLegacyContentTemplateSpaceInput>;
    templateId: Scalars["ID"]["input"];
    templateType: ConfluenceLegacyContentTemplateType;
};

export type ConfluenceLegacyUpdateDefaultSpacePermissionsInput = {
    permissionsToAdd: Array<InputMaybe<ConfluenceLegacySpacePermissionType>>;
    permissionsToRemove: Array<InputMaybe<ConfluenceLegacySpacePermissionType>>;
    subjectKeyInput: ConfluenceLegacyUpdatePermissionSubjectKeyInput;
};

export type ConfluenceLegacyUpdateDefaultSpacePermissionsPayload = {
    __typename?: "ConfluenceLegacyUpdateDefaultSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyUpdateEmbedInput = {
    embedIconUrl?: InputMaybe<Scalars["String"]["input"]>;
    embedUrl?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    product?: InputMaybe<Scalars["String"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyUpdateExCoSpacePermissionsInput = {
    accountId: Scalars["String"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyUpdateExCoSpacePermissionsMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "ConfluenceLegacyUpdateExCoSpacePermissionsMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        accountId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        spaceId?: Maybe<Scalars["Long"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type ConfluenceLegacyUpdateExCoSpacePermissionsPayload = Payload & {
    __typename?: "ConfluenceLegacyUpdateExCoSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyUpdateExternalCollaboratorDefaultSpaceInput = {
    enabled: Scalars["Boolean"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type ConfluenceLegacyUpdateExternalCollaboratorDefaultSpacePayload =
    Payload & {
        __typename?: "ConfluenceLegacyUpdateExternalCollaboratorDefaultSpacePayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyUpdateNestedPageOwnersPayload = Payload & {
    __typename?: "ConfluenceLegacyUpdateNestedPageOwnersPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    warnings?: Maybe<Array<Maybe<ConfluenceLegacyChangeOwnerWarning>>>;
};

export type ConfluenceLegacyUpdateOwnerInput = {
    contentId: Scalars["ID"]["input"];
    ownerId: Scalars["String"]["input"];
};

export type ConfluenceLegacyUpdateOwnerPayload = {
    __typename?: "ConfluenceLegacyUpdateOwnerPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: ConfluenceLegacyContent;
};

export type ConfluenceLegacyUpdatePageExtensionInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceLegacyUpdatePageInput = {
    body?: InputMaybe<ConfluenceLegacyPageBodyInput>;
    extensions?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyUpdatePageExtensionInput>>
    >;
    mediaAttachments?: InputMaybe<Array<ConfluenceLegacyMediaAttachmentInput>>;
    minorEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageId: Scalars["ID"]["input"];
    restrictions?: InputMaybe<ConfluenceLegacyPageRestrictionsInput>;
    status?: InputMaybe<ConfluenceLegacyPageStatusInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyUpdatePageOwnersInput = {
    ownerId: Scalars["ID"]["input"];
    pageIDs: Array<InputMaybe<Scalars["Long"]["input"]>>;
};

export type ConfluenceLegacyUpdatePageOwnersPayload = Payload & {
    __typename?: "ConfluenceLegacyUpdatePageOwnersPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId: Scalars["ID"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyUpdatePagePayload = {
    __typename?: "ConfluenceLegacyUpdatePagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    content?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaAttached: Array<ConfluenceLegacyMediaAttachmentOrError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    page?: Maybe<ConfluenceLegacyPage>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictions?: Maybe<ConfluenceLegacyPageRestrictions>;
};

export type ConfluenceLegacyUpdatePageStatusesInput = {
    pages: Array<InputMaybe<ConfluenceLegacyNestedPageInput>>;
    spaceKey: Scalars["String"]["input"];
    targetContentState: ConfluenceLegacyContentStateInput;
};

export type ConfluenceLegacyUpdatePageStatusesPayload = Payload & {
    __typename?: "ConfluenceLegacyUpdatePageStatusesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId: Scalars["ID"]["output"];
};

export type ConfluenceLegacyUpdatePermissionSubjectKeyInput = {
    permissionDisplayType: ConfluenceLegacyPermissionDisplayType;
    subjectId: Scalars["String"]["input"];
};

export type ConfluenceLegacyUpdateRelationInput = {
    relationName: ConfluenceLegacyRelationType;
    sourceKey: Scalars["String"]["input"];
    sourceStatus?: InputMaybe<Scalars["String"]["input"]>;
    sourceType: ConfluenceLegacyRelationSourceType;
    sourceVersion?: InputMaybe<Scalars["Int"]["input"]>;
    targetKey: Scalars["String"]["input"];
    targetStatus?: InputMaybe<Scalars["String"]["input"]>;
    targetType: ConfluenceLegacyRelationTargetType;
    targetVersion?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyUpdateRelationPayload = {
    __typename?: "ConfluenceLegacyUpdateRelationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relationName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sourceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    targetKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type ConfluenceLegacyUpdateSiteLookAndFeelInput = {
    backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
    faviconFiles: Array<ConfluenceLegacyFaviconFileInput>;
    frontCoverState?: InputMaybe<ConfluenceLegacyFrontCoverState>;
    highlightColor?: InputMaybe<Scalars["String"]["input"]>;
    resetFavicon?: InputMaybe<Scalars["Boolean"]["input"]>;
    resetSiteLogo?: InputMaybe<Scalars["Boolean"]["input"]>;
    showFrontCover?: InputMaybe<Scalars["Boolean"]["input"]>;
    showSiteName?: InputMaybe<Scalars["Boolean"]["input"]>;
    siteLogoFileStoreId?: InputMaybe<Scalars["ID"]["input"]>;
    siteName?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyUpdateSiteLookAndFeelPayload = Payload & {
    __typename?: "ConfluenceLegacyUpdateSiteLookAndFeelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteLookAndFeel?: Maybe<ConfluenceLegacySiteLookAndFeel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyUpdateSitePermissionInput = {
    anonymous?: InputMaybe<ConfluenceLegacyAnonymousWithPermissionsInput>;
    groups?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyGroupWithPermissionsInput>>
    >;
    unlicensedUser?: InputMaybe<ConfluenceLegacyUnlicensedUserWithPermissionsInput>;
    users?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyUserWithPermissionsInput>>
    >;
};

export type ConfluenceLegacyUpdateSpaceDefaultClassificationLevelInput = {
    classificationLevelId: Scalars["ID"]["input"];
    id: Scalars["Long"]["input"];
};

export type ConfluenceLegacyUpdateSpaceDefaultClassificationLevelPayload =
    Payload & {
        __typename?: "ConfluenceLegacyUpdateSpaceDefaultClassificationLevelPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConfluenceLegacyUpdateSpacePermissionsInput = {
    spaceKey: Scalars["String"]["input"];
    subjectPermissionDeltasList: Array<ConfluenceLegacySubjectPermissionDeltas>;
};

export type ConfluenceLegacyUpdateSpacePermissionsMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "ConfluenceLegacyUpdateSpacePermissionsMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        spaceId?: Maybe<Scalars["Long"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        spacePermissionType?: Maybe<ConfluenceLegacySpacePermissionType>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        subjectId?: Maybe<Scalars["String"]["output"]>;
    };

export type ConfluenceLegacyUpdateSpacePermissionsPayload = {
    __typename?: "ConfluenceLegacyUpdateSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyUpdateSpaceTypeSettingsInput = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    spaceTypeSettings?: InputMaybe<ConfluenceLegacySpaceTypeSettingsInput>;
};

export type ConfluenceLegacyUpdateSpaceTypeSettingsPayload = Payload & {
    __typename?: "ConfluenceLegacyUpdateSpaceTypeSettingsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceTypeSettings?: Maybe<ConfluenceLegacySpaceTypeSettings>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyUpdateTemplatePropertySetInput = {
    /** ID of template to create property for */
    templateId: Scalars["Long"]["input"];
    /** Template properties */
    templatePropertySet: ConfluenceLegacyTemplatePropertySetInput;
};

export type ConfluenceLegacyUpdateTemplatePropertySetPayload = {
    __typename?: "ConfluenceLegacyUpdateTemplatePropertySetPayload";
    /**
     * ID of template to create property for
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templateId: Scalars["ID"]["output"];
    /**
     * Template properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templatePropertySet: ConfluenceLegacyTemplatePropertySetPayload;
};

export type ConfluenceLegacyUpdatedNestedPageOwnersInput = {
    ownerId: Scalars["ID"]["input"];
    pages: Array<InputMaybe<ConfluenceLegacyNestedPageInput>>;
};

export type ConfluenceLegacyUser = ConfluenceLegacyPerson & {
    __typename?: "ConfluenceLegacyUser";
    accountId?: Maybe<Scalars["String"]["output"]>;
    accountType?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    publicName?: Maybe<Scalars["String"]["output"]>;
    timeZone?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    userKey?: Maybe<Scalars["String"]["output"]>;
    username?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyUserAndGroupSearchResults = {
    __typename?: "ConfluenceLegacyUserAndGroupSearchResults";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groups?: Maybe<Array<Maybe<ConfluenceLegacyGroup>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
};

export type ConfluenceLegacyUserEdge = {
    __typename?: "ConfluenceLegacyUserEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyUser>;
};

export type ConfluenceLegacyUserInfo = {
    __typename?: "ConfluenceLegacyUserInfo";
    /** accountId of the user. */
    accountId: Scalars["String"]["output"];
    /** Display Name of User. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** Profile picture of the user */
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    /** Type of User. */
    type: ConfluenceUserType;
};

export type ConfluenceLegacyUserPreferences = {
    __typename?: "ConfluenceLegacyUserPreferences";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    endOfPageRecommendationsOptInStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favouriteTemplateEntityIds: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    feedRecommendedUserSettingsDismissTimestamp: Scalars["String"]["output"];
    /**
     * The user's AI-generated feed tab preference. Returns null if a preference hasn't been set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    feedTab?: Maybe<Scalars["String"]["output"]>;
    /**
     * The user's feed type (feed tab) preference. Returns null if a preference hasn't been set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    feedType?: Maybe<ConfluenceLegacyFeedType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    globalPageCardAppearancePreference: ConfluenceLegacyPagesDisplayPersistenceOption;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homePagesDisplayView: ConfluenceLegacyPagesDisplayPersistenceOption;
    /**
     * The user's preference for whether Home right panel widgets are collapsed/expanded. Returns empty list if user hasn't collapsed/expanded a widget yet.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homeWidgets: Array<ConfluenceLegacyHomeWidget>;
    /**
     * The user's preference for whether the home onboarding banner is dismissed or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isHomeOnboardingDismissed: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    keyboardShortcutDisabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    missionControlOverview: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nextGenFeedOptInStatus: Scalars["String"]["output"];
    /**
     * The user's preference for whether the premium tools dropdown is collapsed/expanded. Set to UNSET by default.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    premiumToolsDropdownPersistence: ConfluenceLegacyPremiumToolsDropdownStatus;
    /**
     * The user's preference for filtering Recent pages. Set to ALL by default.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recentFilter: ConfluenceLegacyRecentFilter;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    searchExperimentOptInStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shouldShowCardOnPageTreeHover: ConfluenceLegacyPageCardInPageTreeHoverPreference;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spacePagesDisplayView: ConfluenceLegacyPagesDisplayPersistenceOption;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spacePagesSortView: ConfluenceLegacyPagesSortPersistenceOption;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceViewsPersistence: ConfluenceLegacySpaceViewsPersistenceOption;
    /**
     * The user's theme preference (color mode). Returns null if a preference hasn't been set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    theme: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    topNavigationOptedOut?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userSpacesNotifiedChangeBoardingOfExternalCollab: Array<
        Maybe<Scalars["String"]["output"]>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userSpacesNotifiedOfExternalCollab: Array<
        Maybe<Scalars["String"]["output"]>
    >;
    /**
     * User's email preferences for content they created themselves
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    watchMyOwnContent?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceLegacyUserPreferencesMissionControlOverviewArgs = {
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type ConfluenceLegacyUserPreferencesPremiumToolsDropdownPersistenceArgs =
    {
        spaceKey: Scalars["String"]["input"];
    };

export type ConfluenceLegacyUserPreferencesSpacePagesDisplayViewArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type ConfluenceLegacyUserPreferencesSpacePagesSortViewArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type ConfluenceLegacyUserPreferencesSpaceViewsPersistenceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type ConfluenceLegacyUserPreferencesInput = {
    addUserSpaceNotifiedChangeBoardingOfExternalCollab?: InputMaybe<
        Scalars["String"]["input"]
    >;
    addUserSpaceNotifiedOfExternalCollab?: InputMaybe<
        Scalars["String"]["input"]
    >;
    endOfPageRecommendationsOptInStatus?: InputMaybe<
        Scalars["String"]["input"]
    >;
    feedRecommendedUserSettingsDismissTimestamp?: InputMaybe<
        Scalars["String"]["input"]
    >;
    feedTab?: InputMaybe<Scalars["String"]["input"]>;
    feedType?: InputMaybe<ConfluenceLegacyFeedType>;
    globalPageCardAppearancePreference?: InputMaybe<ConfluenceLegacyPagesDisplayPersistenceOption>;
    homePagesDisplayView?: InputMaybe<ConfluenceLegacyPagesDisplayPersistenceOption>;
    homeWidget?: InputMaybe<ConfluenceLegacyHomeWidgetInput>;
    isHomeOnboardingDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
    keyboardShortcutDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    missionControlOverview?: InputMaybe<ConfluenceLegacyMissionControlOverview>;
    nextGenFeedOptInStatus?: InputMaybe<Scalars["String"]["input"]>;
    premiumToolsDropdownPersistence?: InputMaybe<ConfluenceLegacyPremiumToolsDropdownPersistence>;
    recentFilter?: InputMaybe<ConfluenceLegacyRecentFilter>;
    searchExperimentOptInStatus?: InputMaybe<Scalars["String"]["input"]>;
    shouldShowCardOnPageTreeHover?: InputMaybe<ConfluenceLegacyPageCardInPageTreeHoverPreference>;
    spacePagesDisplayView?: InputMaybe<ConfluenceLegacySpacePagesDisplayView>;
    spacePagesSortView?: InputMaybe<ConfluenceLegacySpacePagesSortView>;
    spaceViewsPersistence?: InputMaybe<ConfluenceLegacySpaceViewsPersistence>;
    templateEntityFavouriteStatus?: InputMaybe<ConfluenceLegacyTemplateEntityFavouriteStatus>;
    theme?: InputMaybe<Scalars["String"]["input"]>;
    topNavigationOptedOut?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyUserRoles = {
    __typename?: "ConfluenceLegacyUserRoles";
    canBeSuperAdmin: Scalars["Boolean"]["output"];
    canUseConfluence: Scalars["Boolean"]["output"];
    isSuperAdmin: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyUserWithPermissionsInput = {
    accountId: Scalars["ID"]["input"];
    operations: Array<InputMaybe<ConfluenceLegacyOperationCheckResultInput>>;
};

export type ConfluenceLegacyUserWithRestrictions = {
    __typename?: "ConfluenceLegacyUserWithRestrictions";
    accountId?: Maybe<Scalars["String"]["output"]>;
    accountType?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    hasSpaceEditPermission?: Maybe<Scalars["Boolean"]["output"]>;
    hasSpaceViewPermission?: Maybe<Scalars["Boolean"]["output"]>;
    operations?: Maybe<Array<Maybe<ConfluenceLegacyOperationCheckResult>>>;
    permissionType?: Maybe<ConfluenceLegacySitePermissionType>;
    profilePicture?: Maybe<ConfluenceLegacyIcon>;
    publicName?: Maybe<Scalars["String"]["output"]>;
    restrictingContent?: Maybe<ConfluenceLegacyContent>;
    timeZone?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    userKey?: Maybe<Scalars["String"]["output"]>;
    username?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyUserWithRestrictionsEdge = {
    __typename?: "ConfluenceLegacyUserWithRestrictionsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceLegacyUserWithRestrictions>;
};

export type ConfluenceLegacyUsersWithEffectiveRestrictions = {
    __typename?: "ConfluenceLegacyUsersWithEffectiveRestrictions";
    directPermissions: Array<Maybe<ConfluenceLegacyContentPermissionType>>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    permissionsViaGroups: ConfluenceLegacyPermissionsViaGroups;
    user?: Maybe<ConfluenceLegacyUserWithRestrictions>;
};

export type ConfluenceLegacyValidateConvertPageToLiveEditInput = {
    adf: Scalars["String"]["input"];
    contentId: Scalars["ID"]["input"];
};

export type ConfluenceLegacyValidatePageCopyInput = {
    /** ID of destination space */
    destinationSpaceId: Scalars["ID"]["input"];
    /** ID of page being copied */
    pageId: Scalars["ID"]["input"];
    /** Input params for validation of copying page restrictions */
    validatePageRestrictionsCopyInput?: InputMaybe<ConfluenceLegacyValidatePageRestrictionsCopyInput>;
};

export type ConfluenceLegacyValidatePageCopyPayload = {
    __typename?: "ConfluenceLegacyValidatePageCopyPayload";
    /**
     * Validation result for copying of page restrictions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    validatePageRestrictionsCopyPayload?: Maybe<ConfluenceLegacyValidatePageRestrictionsCopyPayload>;
};

export type ConfluenceLegacyValidatePageRestrictionsCopyInput = {
    includeChildren: Scalars["Boolean"]["input"];
};

export type ConfluenceLegacyValidatePageRestrictionsCopyPayload = {
    __typename?: "ConfluenceLegacyValidatePageRestrictionsCopyPayload";
    isValid: Scalars["Boolean"]["output"];
    message: ConfluenceLegacyPageCopyRestrictionValidationStatus;
};

export type ConfluenceLegacyValidateSpaceKeyResponse = {
    __typename?: "ConfluenceLegacyValidateSpaceKeyResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    generatedUniqueKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
};

export type ConfluenceLegacyValidateTitleForCreatePayload = {
    __typename?: "ConfluenceLegacyValidateTitleForCreatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyVersion = {
    __typename?: "ConfluenceLegacyVersion";
    by?: Maybe<ConfluenceLegacyPerson>;
    collaborators?: Maybe<ConfluenceLegacyContributorUsers>;
    confRev?: Maybe<Scalars["String"]["output"]>;
    content?: Maybe<ConfluenceLegacyContent>;
    contentTypeModified?: Maybe<Scalars["Boolean"]["output"]>;
    friendlyWhen?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<ConfluenceLegacyLinksContextSelfBase>;
    message?: Maybe<Scalars["String"]["output"]>;
    minorEdit?: Maybe<Scalars["Boolean"]["output"]>;
    ncsStepVersion?: Maybe<Scalars["String"]["output"]>;
    ncsStepVersionSource?: Maybe<Scalars["String"]["output"]>;
    number?: Maybe<Scalars["Int"]["output"]>;
    syncRev?: Maybe<Scalars["String"]["output"]>;
    syncRevSource?: Maybe<Scalars["String"]["output"]>;
    when?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyVersionSummaryMetaDataItem = {
    __typename?: "ConfluenceLegacyVersionSummaryMetaDataItem";
    collaborators?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    creationDate: Scalars["String"]["output"];
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    users?: Maybe<Array<Maybe<ConfluenceLegacyPerson>>>;
    versionNumber: Scalars["Int"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLegacyViewedComments = {
    __typename?: "ConfluenceLegacyViewedComments";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentIds: Array<Maybe<Scalars["ID"]["output"]>>;
};

export type ConfluenceLegacyWatchContentInput = {
    accountId?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    currentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceLegacyWatchContentPayload = {
    __typename?: "ConfluenceLegacyWatchContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: ConfluenceLegacyContent;
};

export type ConfluenceLegacyWatchSpaceInput = {
    accountId?: InputMaybe<Scalars["String"]["input"]>;
    currentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceLegacyWatchSpacePayload = {
    __typename?: "ConfluenceLegacyWatchSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<ConfluenceLegacySpace>;
};

export type ConfluenceLegacyWebItem = {
    __typename?: "ConfluenceLegacyWebItem";
    accessKey?: Maybe<Scalars["String"]["output"]>;
    completeKey?: Maybe<Scalars["String"]["output"]>;
    hasCondition?: Maybe<Scalars["Boolean"]["output"]>;
    icon?: Maybe<ConfluenceLegacyIcon>;
    id?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    params?: Maybe<Array<Maybe<ConfluenceLegacyMapOfStringToString>>>;
    section?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
    tooltip?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    urlWithoutContextPath?: Maybe<Scalars["String"]["output"]>;
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyWebPanel = {
    __typename?: "ConfluenceLegacyWebPanel";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    completeKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    html?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    location?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceLegacyWebResourceDependencies = {
    __typename?: "ConfluenceLegacyWebResourceDependencies";
    contexts: Array<Maybe<Scalars["String"]["output"]>>;
    keys: Array<Maybe<Scalars["String"]["output"]>>;
    links?: Maybe<ConfluenceLegacyLinksContextBase>;
    superbatch?: Maybe<ConfluenceLegacySuperBatchWebResources>;
    tags?: Maybe<ConfluenceLegacyWebResourceTags>;
    uris?: Maybe<ConfluenceLegacyWebResourceUris>;
};

export type ConfluenceLegacyWebResourceTags = {
    __typename?: "ConfluenceLegacyWebResourceTags";
    css?: Maybe<Scalars["String"]["output"]>;
    data?: Maybe<Scalars["String"]["output"]>;
    js?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyWebResourceUris = {
    __typename?: "ConfluenceLegacyWebResourceUris";
    css?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    data?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    js?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ConfluenceLegacyWebSection = {
    __typename?: "ConfluenceLegacyWebSection";
    cacheKey?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    items: Array<Maybe<ConfluenceLegacyWebItem>>;
    label?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLegacyWhiteboardFeatures = {
    __typename?: "ConfluenceLegacyWhiteboardFeatures";
    smartConnectors?: Maybe<ConfluenceLegacySmartConnectorsFeature>;
    smartSections?: Maybe<ConfluenceLegacySmartSectionsFeature>;
};

export type ConfluenceLegacycontactAdminPageConfig = {
    __typename?: "ConfluenceLegacycontactAdminPageConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contactAdministratorsMessage?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    disabledReason?: Maybe<ConfluenceLegacyContactAdminPageDisabledReason>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recaptchaSharedKey?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceLike = {
    __typename?: "ConfluenceLike";
    likedAt?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<ConfluenceUserInfo>;
};

export type ConfluenceLikesSummary = {
    __typename?: "ConfluenceLikesSummary";
    count?: Maybe<Scalars["Int"]["output"]>;
    likes?: Maybe<Array<Maybe<ConfluenceLike>>>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceLongTask = {
    __typename?: "ConfluenceLongTask";
    /** The ARI of the Long Task, ConfluenceLongRunningTaskARI format. */
    id: Scalars["ID"]["output"];
    /** The current state of the Long Task. */
    state?: Maybe<ConfluenceLongTaskState>;
    /** ID of the Long Task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
};

/** A Long Task that has failed. */
export type ConfluenceLongTaskFailed = ConfluenceLongTaskState & {
    __typename?: "ConfluenceLongTaskFailed";
    /**
     * The elapsed time of the Long Task in milliseconds.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    elapsedTime?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The error messages associated with the failed Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorMessages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     * The name of the Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** A Long Task that is in progress. */
export type ConfluenceLongTaskInProgress = ConfluenceLongTaskState & {
    __typename?: "ConfluenceLongTaskInProgress";
    /**
     * The elapsed time of the Long Task in milliseconds.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    elapsedTime?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The name of the Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The percentage completed for the Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    percentageComplete?: Maybe<Scalars["Int"]["output"]>;
};

/** The result of a successful Long Task. */
export type ConfluenceLongTaskResult = ConfluenceCopyPageTaskResult;

export type ConfluenceLongTaskState = {
    /**
     * The elapsed time of the Long Task in milliseconds.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    elapsedTime?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The name of the Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** A Long Task that is finished and successful. */
export type ConfluenceLongTaskSuccess = ConfluenceLongTaskState & {
    __typename?: "ConfluenceLongTaskSuccess";
    /**
     * The elapsed time of the Long Task in milliseconds.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    elapsedTime?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The name of the Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The result of the successful Long Task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    result?: Maybe<ConfluenceLongTaskResult>;
};

export type ConfluenceMakeSubCalendarPrivateUrlInput = {
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceMakeSubCalendarPrivateUrlPayload = {
    __typename?: "ConfluenceMakeSubCalendarPrivateUrlPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    privateUrl: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceMutationApi = {
    __typename?: "ConfluenceMutationApi";
    /**
     * Create a BlogPost in given status.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createBlogPost?: Maybe<ConfluenceCreateBlogPostPayload>;
    /**
     * Create a Property on a BlogPost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:content.property:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createBlogPostProperty?: Maybe<ConfluenceCreateBlogPostPropertyPayload>;
    /**
     * Create a Footer Comment on a BlogPost. Can only add Footer Comments to a published BlogPost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createFooterCommentOnBlogPost?: Maybe<ConfluenceCreateFooterCommentOnBlogPostPayload>;
    /**
     * Create a Footer Comment on a Page. Can only add Footer Comments to a published Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createFooterCommentOnPage?: Maybe<ConfluenceCreateFooterCommentOnPagePayload>;
    /**
     * Create a Page in a given status.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createPage?: Maybe<ConfluenceCreatePagePayload>;
    /**
     * Create a Property on a Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:content.property:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createPageProperty?: Maybe<ConfluenceCreatePagePropertyPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:space:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    createSpace?: Maybe<ConfluenceCreateSpacePayload>;
    /**
     * Delete a Property on a BlogPost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:content.property:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    deleteBlogPostProperty?: Maybe<ConfluenceDeleteBlogPostPropertyPayload>;
    /**
     * Delete a comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __delete:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    deleteComment?: Maybe<ConfluenceDeleteCommentPayload>;
    /**
     * Delete a BlogPost that's currently a draft. This deletes the draft for good!
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __delete:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    deleteDraftBlogPost?: Maybe<ConfluenceDeleteDraftBlogPostPayload>;
    /**
     * Delete a Page that's currently a draft. This deletes the draft for good!
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    deleteDraftPage?: Maybe<ConfluenceDeleteDraftPagePayload>;
    /**
     * Delete a Property on a Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:content.property:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    deletePageProperty?: Maybe<ConfluenceDeletePagePropertyPayload>;
    /**
     * Publish a BlogPost that's currently a draft.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    publishBlogPost?: Maybe<ConfluencePublishBlogPostPayload>;
    /**
     * Publish a Page that's currently a draft.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    publishPage?: Maybe<ConfluencePublishPagePayload>;
    /**
     * Purge a BlogPost that's in the trash. This deletes the BlogPost for good!
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __delete:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    purgeBlogPost?: Maybe<ConfluencePurgeBlogPostPayload>;
    /**
     * Purge a Page that's in the trash. This deletes the Page for good!
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __delete:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    purgePage?: Maybe<ConfluencePurgePagePayload>;
    /**
     * Reopen an inline comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    reopenInlineComment?: Maybe<ConfluenceReopenInlineCommentPayload>;
    /**
     * Create a Comment as a reply to a Comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    replyToComment?: Maybe<ConfluenceReplyToCommentPayload>;
    /**
     * Resolve an inline comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    resolveInlineComment?: Maybe<ConfluenceResolveInlineCommentPayload>;
    /**
     * Move a BlogPost to the trash. Only CURRENT BlogPosts can be trashed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __delete:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    trashBlogPost?: Maybe<ConfluenceTrashBlogPostPayload>;
    /**
     * Move a Page to the trash. Only CURRENT Pages can be trashed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __delete:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    trashPage?: Maybe<ConfluenceTrashPagePayload>;
    /**
     * Update the body of a comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:comment:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateComment?: Maybe<ConfluenceUpdateCommentPayload>;
    /**
     * Update a published BlogPost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateCurrentBlogPost?: Maybe<ConfluenceUpdateCurrentBlogPostPayload>;
    /**
     * Update a published Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateCurrentPage?: Maybe<ConfluenceUpdateCurrentPagePayload>;
    /**
     * Update the draft of a BlogPost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:blogpost:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateDraftBlogPost?: Maybe<ConfluenceUpdateDraftBlogPostPayload>;
    /**
     * Update the draft of a Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:page:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateDraftPage?: Maybe<ConfluenceUpdateDraftPagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:space:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateSpace?: Maybe<ConfluenceUpdateSpacePayload>;
    /**
     * Updates the settings for a given Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:space.setting:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateSpaceSettings?: Maybe<ConfluenceUpdateSpaceSettingsPayload>;
    /**
     * Update a Property's value on a BlogPost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:content.property:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateValueBlogPostProperty?: Maybe<ConfluenceUpdateValueBlogPostPropertyPayload>;
    /**
     * Update a Property's value on a Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:content.property:confluence__
     * * __confluence:atlassian-external__
     *
     *
     */
    updateValuePageProperty?: Maybe<ConfluenceUpdateValuePagePropertyPayload>;
};

export type ConfluenceMutationApiCreateBlogPostArgs = {
    input: ConfluenceCreateBlogPostInput;
};

export type ConfluenceMutationApiCreateBlogPostPropertyArgs = {
    input: ConfluenceCreateBlogPostPropertyInput;
};

export type ConfluenceMutationApiCreateFooterCommentOnBlogPostArgs = {
    input: ConfluenceCreateFooterCommentOnBlogPostInput;
};

export type ConfluenceMutationApiCreateFooterCommentOnPageArgs = {
    input: ConfluenceCreateFooterCommentOnPageInput;
};

export type ConfluenceMutationApiCreatePageArgs = {
    input: ConfluenceCreatePageInput;
};

export type ConfluenceMutationApiCreatePagePropertyArgs = {
    input: ConfluenceCreatePagePropertyInput;
};

export type ConfluenceMutationApiCreateSpaceArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceCreateSpaceInput;
};

export type ConfluenceMutationApiDeleteBlogPostPropertyArgs = {
    input: ConfluenceDeleteBlogPostPropertyInput;
};

export type ConfluenceMutationApiDeleteCommentArgs = {
    input: ConfluenceDeleteCommentInput;
};

export type ConfluenceMutationApiDeleteDraftBlogPostArgs = {
    input: ConfluenceDeleteDraftBlogPostInput;
};

export type ConfluenceMutationApiDeleteDraftPageArgs = {
    input: ConfluenceDeleteDraftPageInput;
};

export type ConfluenceMutationApiDeletePagePropertyArgs = {
    input: ConfluenceDeletePagePropertyInput;
};

export type ConfluenceMutationApiPublishBlogPostArgs = {
    input: ConfluencePublishBlogPostInput;
};

export type ConfluenceMutationApiPublishPageArgs = {
    input: ConfluencePublishPageInput;
};

export type ConfluenceMutationApiPurgeBlogPostArgs = {
    input: ConfluencePurgeBlogPostInput;
};

export type ConfluenceMutationApiPurgePageArgs = {
    input: ConfluencePurgePageInput;
};

export type ConfluenceMutationApiReopenInlineCommentArgs = {
    input: ConfluenceReopenInlineCommentInput;
};

export type ConfluenceMutationApiReplyToCommentArgs = {
    input: ConfluenceReplyToCommentInput;
};

export type ConfluenceMutationApiResolveInlineCommentArgs = {
    input: ConfluenceResolveInlineCommentInput;
};

export type ConfluenceMutationApiTrashBlogPostArgs = {
    input: ConfluenceTrashBlogPostInput;
};

export type ConfluenceMutationApiTrashPageArgs = {
    input: ConfluenceTrashPageInput;
};

export type ConfluenceMutationApiUpdateCommentArgs = {
    input: ConfluenceUpdateCommentInput;
};

export type ConfluenceMutationApiUpdateCurrentBlogPostArgs = {
    input: ConfluenceUpdateCurrentBlogPostInput;
};

export type ConfluenceMutationApiUpdateCurrentPageArgs = {
    input: ConfluenceUpdateCurrentPageInput;
};

export type ConfluenceMutationApiUpdateDraftBlogPostArgs = {
    input: ConfluenceUpdateDraftBlogPostInput;
};

export type ConfluenceMutationApiUpdateDraftPageArgs = {
    input: ConfluenceUpdateDraftPageInput;
};

export type ConfluenceMutationApiUpdateSpaceArgs = {
    input: ConfluenceUpdateSpaceInput;
};

export type ConfluenceMutationApiUpdateSpaceSettingsArgs = {
    input: ConfluenceUpdateSpaceSettingsInput;
};

export type ConfluenceMutationApiUpdateValueBlogPostPropertyArgs = {
    input: ConfluenceUpdateValueBlogPostPropertyInput;
};

export type ConfluenceMutationApiUpdateValuePagePropertyArgs = {
    input: ConfluenceUpdateValuePagePropertyInput;
};

export enum ConfluenceMutationContentStatus {
    Current = "CURRENT",
    Draft = "DRAFT"
}

export type ConfluenceOperationCheck = {
    __typename?: "ConfluenceOperationCheck";
    operation?: Maybe<ConfluenceOperationName>;
    target?: Maybe<ConfluenceOperationTarget>;
};

export enum ConfluenceOperationName {
    Administer = "ADMINISTER",
    Archive = "ARCHIVE",
    Copy = "COPY",
    Create = "CREATE",
    CreateSpace = "CREATE_SPACE",
    Delete = "DELETE",
    Export = "EXPORT",
    Move = "MOVE",
    Purge = "PURGE",
    PurgeVersion = "PURGE_VERSION",
    Read = "READ",
    Restore = "RESTORE",
    RestrictContent = "RESTRICT_CONTENT",
    Update = "UPDATE",
    Use = "USE"
}

export enum ConfluenceOperationTarget {
    Application = "APPLICATION",
    Attachment = "ATTACHMENT",
    BlogPost = "BLOG_POST",
    Comment = "COMMENT",
    Page = "PAGE",
    Space = "SPACE",
    UserProfile = "USER_PROFILE"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluencePage = {
    __typename?: "ConfluencePage";
    /**
     * Ancestors of the Page, of all types.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    allAncestors?: Maybe<Array<Maybe<ConfluenceAncestor>>>;
    /**
     * Ancestors of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ancestors?: Maybe<Array<Maybe<ConfluencePage>>>;
    /**
     * Original User who authored the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    author?: Maybe<ConfluenceUserInfo>;
    /**
     * Body of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    body?: Maybe<ConfluenceBodies>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentCountSummary?: Maybe<ConfluenceCommentCountSummary>;
    /**
     * Comments on the Page. If no commentType is passed, all comment types are returned.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: confluence-agg-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    comments?: Maybe<Array<Maybe<ConfluenceComment>>>;
    /**
     * Date and time the Page was created.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /**
     * ARI of the Page, ConfluencePageARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Labels for the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labels?: Maybe<Array<Maybe<ConfluenceLabel>>>;
    /**
     * Latest Version of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    latestVersion?: Maybe<ConfluencePageVersion>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    likesSummary?: Maybe<ConfluenceLikesSummary>;
    /**
     * Links associated with the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluencePageLinks>;
    /**
     * Metadata of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    metadata?: Maybe<ConfluenceContentMetadata>;
    /**
     * Native Properties of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nativeProperties?: Maybe<ConfluenceContentNativeProperties>;
    /**
     * The owner of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    owner?: Maybe<ConfluenceUserInfo>;
    /**
     * Content ID of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     * Properties of the Page, specified by property key.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    properties?: Maybe<Array<Maybe<ConfluencePageProperty>>>;
    /**
     * Space that contains the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<ConfluenceSpace>;
    /**
     * Content status of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<ConfluencePageStatus>;
    /**
     * Subtype of the Page. Null for regular/classic pages, Live for live pages.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subtype?: Maybe<ConfluencePageSubType>;
    /**
     * Title of the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * Content type of the page. Will always be \"PAGE\".
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<ConfluenceContentType>;
    /**
     * Summary of viewer-related fields for the Page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewer?: Maybe<ConfluencePageViewerSummary>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluencePageCommentsArgs = {
    commentType?: InputMaybe<ConfluenceCommentType>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluencePagePropertiesArgs = {
    keys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ConfluencePageInfo = {
    __typename?: "ConfluencePageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
};

export type ConfluencePageLinks = {
    __typename?: "ConfluencePageLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL path associated with the Page. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.property:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluencePageProperty = {
    __typename?: "ConfluencePageProperty";
    /** Key of the Page property. */
    key: Scalars["String"]["output"];
    /** Value of the Page property. */
    value: Scalars["String"]["output"];
};

export enum ConfluencePageStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Deleted = "DELETED",
    Draft = "DRAFT",
    Historical = "HISTORICAL",
    Trashed = "TRASHED"
}

export enum ConfluencePageSubType {
    Live = "LIVE"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluencePageVersion = {
    __typename?: "ConfluencePageVersion";
    /** User who authored the Version. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Date and time the Version was created. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Number of the Version. */
    number?: Maybe<Scalars["Int"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluencePageViewerSummary = {
    __typename?: "ConfluencePageViewerSummary";
    /** Favorited summary of the page. */
    favoritedSummary?: Maybe<ConfluenceFavoritedSummary>;
    /** Viewer's last Contribution to the Page. */
    lastContribution?: Maybe<ConfluenceContribution>;
    /** Date and time viewer most recently visited the Page. */
    lastSeenAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ConfluencePerson = Person & {
    __typename?: "ConfluencePerson";
    accountId?: Maybe<Scalars["String"]["output"]>;
    accountType?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    permissionType?: Maybe<SitePermissionType>;
    profilePicture?: Maybe<Icon>;
    publicName?: Maybe<Scalars["String"]["output"]>;
    timeZone?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    userKey?: Maybe<Scalars["String"]["output"]>;
    username?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluencePersonConnection = {
    __typename?: "ConfluencePersonConnection";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluencePersonEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluencePerson>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluencePersonEdge = {
    __typename?: "ConfluencePersonEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluencePerson>;
};

export type ConfluencePersonWithPermissionsConnection = {
    __typename?: "ConfluencePersonWithPermissionsConnection";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ConfluencePersonEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<ConfluencePerson>>>;
    pageInfo?: Maybe<PageInfo>;
};

export enum ConfluencePrincipalType {
    Group = "GROUP",
    User = "USER"
}

export type ConfluencePublishBlogPostInput = {
    /** ID of draft BlogPost. */
    id: Scalars["ID"]["input"];
    /** Title of the published BlogPost. If it is EMPTY, it will be same as draft BlogPost title. */
    publishTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluencePublishBlogPostPayload = Payload & {
    __typename?: "ConfluencePublishBlogPostPayload";
    blogPost?: Maybe<ConfluenceBlogPost>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluencePublishPageInput = {
    /** ID of draft Page. */
    id: Scalars["ID"]["input"];
    /** Title of the published Page. If it is EMPTY, it will be same as draft Page title. */
    publishTitle?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluencePublishPagePayload = Payload & {
    __typename?: "ConfluencePublishPagePayload";
    errors?: Maybe<Array<MutationError>>;
    page?: Maybe<ConfluencePage>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluencePurgeBlogPostInput = {
    /** ID of TRASHED BlogPost. */
    id: Scalars["ID"]["input"];
};

export type ConfluencePurgeBlogPostPayload = Payload & {
    __typename?: "ConfluencePurgeBlogPostPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluencePurgePageInput = {
    /** ID of TRASHED Page. */
    id: Scalars["ID"]["input"];
};

export type ConfluencePurgePagePayload = Payload & {
    __typename?: "ConfluencePurgePagePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluencePushNotificationSettings = {
    __typename?: "ConfluencePushNotificationSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customSettings: PushNotificationCustomSettings;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    group: PushNotificationSettingGroup;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type ConfluenceQueryApi = {
    __typename?: "ConfluenceQueryApi";
    /**
     * Fetch a Confluence BlogPost its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    blogPost?: Maybe<ConfluenceBlogPost>;
    /**
     * Fetch Confluence BlogPosts by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    blogPosts?: Maybe<Array<Maybe<ConfluenceBlogPost>>>;
    /**
     * Fetch a Confluence Comment by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    comment?: Maybe<ConfluenceComment>;
    /**
     * Fetch Confluence Comments by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    comments?: Maybe<Array<Maybe<ConfluenceComment>>>;
    /**
     * Fetch a Confluence Database by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceDatabasesRelease")' query directive to the 'database' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    database?: Maybe<ConfluenceDatabase>;
    /**
     * Fetch Confluence Databases by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceDatabasesRelease")' query directive to the 'databases' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    databases?: Maybe<Array<Maybe<ConfluenceDatabase>>>;
    /**
     * Fetch a Smart Link in the content tree by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceEmbedsRelease")' query directive to the 'embed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    embed?: Maybe<ConfluenceEmbed>;
    /**
     * Fetch Smart Links in the content tree by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceEmbedsRelease")' query directive to the 'embeds' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    embeds?: Maybe<Array<Maybe<ConfluenceEmbed>>>;
    /**
     * Fetch all the Confluence Spaces for the tenant. Result is paginated.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: confluence-agg-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    findSpaces?: Maybe<ConfluenceSpaceConnection>;
    /**
     * Fetch a Confluence Folder by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceFoldersRelease")' query directive to the 'folder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    folder?: Maybe<ConfluenceFolder>;
    /**
     * Fetch Confluence Folders by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceFoldersRelease")' query directive to the 'folders' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    folders?: Maybe<Array<Maybe<ConfluenceFolder>>>;
    /**
     * Fetch a task by its global Id.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: confluence-agg-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineTask?: Maybe<ConfluenceInlineTask>;
    /**
     * Fetch information about an active Long Task by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    longTask?: Maybe<ConfluenceLongTask>;
    /**
     * Fetch a Confluence Page its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    page?: Maybe<ConfluencePage>;
    /**
     * Fetch Confluence Pages by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pages?: Maybe<Array<Maybe<ConfluencePage>>>;
    /**
     * Search for labels based on search text.
     *
     * This experimental query is currently not available to OAuth clients.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceExperimentalSearchLabels")' query directive to the 'searchLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    searchLabels?: Maybe<ConfluenceLabelSearchResults>;
    /**
     * Fetch a Confluence Space by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<ConfluenceSpace>;
    /**
     * Fetch Confluence Spaces by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaces?: Maybe<Array<Maybe<ConfluenceSpace>>>;
    /**
     * Checks a space key for valid characters and optionally uniqueness. Optionally also returns a unique key.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    validateSpaceKey?: Maybe<ConfluenceValidateSpaceKeyResponse>;
    /**
     * Fetch a Confluence Whiteboard by its ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceWhiteboardsRelease")' query directive to the 'whiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    whiteboard?: Maybe<ConfluenceWhiteboard>;
    /**
     * Fetch Confluence Whiteboards by their ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceWhiteboardsRelease")' query directive to the 'whiteboards' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    whiteboards?: Maybe<Array<Maybe<ConfluenceWhiteboard>>>;
};

export type ConfluenceQueryApiBlogPostArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiBlogPostsArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceQueryApiCommentArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiCommentsArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceQueryApiDatabaseArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiDatabasesArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceQueryApiEmbedArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiEmbedsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type ConfluenceQueryApiFindSpacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filters?: InputMaybe<ConfluenceSpaceFilters>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ConfluenceQueryApiFolderArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiFoldersArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type ConfluenceQueryApiInlineTaskArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiLongTaskArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiPageArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiPagesArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceQueryApiSearchLabelsArgs = {
    cloudId: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    searchText: Scalars["String"]["input"];
};

export type ConfluenceQueryApiSpaceArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiSpacesArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceQueryApiValidateSpaceKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    generateUniqueKey?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    validateUniqueness?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ConfluenceQueryApiWhiteboardArgs = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceQueryApiWhiteboardsArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type ConfluenceRedactionMetadata = {
    __typename?: "ConfluenceRedactionMetadata";
    creationDate?: Maybe<Scalars["String"]["output"]>;
    creatorAccountId?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    redactionReason?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceRedactionMetadataConnection = {
    __typename?: "ConfluenceRedactionMetadataConnection";
    edges?: Maybe<Array<Maybe<ConfluenceRedactionMetadataEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceRedactionMetadata>>>;
    pageInfo: PageInfo;
};

export type ConfluenceRedactionMetadataEdge = {
    __typename?: "ConfluenceRedactionMetadataEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceRedactionMetadata>;
};

export type ConfluenceReopenCommentPayload = Payload & {
    __typename?: "ConfluenceReopenCommentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentResolutionStates?: Maybe<ConfluenceCommentResolutionState>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceReopenInlineCommentInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceReopenInlineCommentPayload = {
    __typename?: "ConfluenceReopenInlineCommentPayload";
    comment?: Maybe<ConfluenceInlineComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceReplyToCommentInput = {
    body: ConfluenceContentBodyInput;
    parentCommentId: Scalars["ID"]["input"];
};

export type ConfluenceReplyToCommentPayload = {
    __typename?: "ConfluenceReplyToCommentPayload";
    comment?: Maybe<ConfluenceComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** The payload used for either resolving or reopening a comment. */
export type ConfluenceResolveCommentsPayload = Payload & {
    __typename?: "ConfluenceResolveCommentsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentResolutionStates?: Maybe<
        Array<Maybe<ConfluenceCommentResolutionState>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceResolveInlineCommentInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceResolveInlineCommentPayload = {
    __typename?: "ConfluenceResolveInlineCommentPayload";
    comment?: Maybe<ConfluenceInlineComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceSearchConnection = {
    __typename?: "ConfluenceSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ConfluenceSearchResponseEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ConfluenceSearchResponse>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ConfluenceSearchResponse = {
    __typename?: "ConfluenceSearchResponse";
    breadcrumbs: Array<Maybe<Breadcrumb>>;
    confluencePerson?: Maybe<ConfluencePerson>;
    content?: Maybe<Content>;
    entityType?: Maybe<Scalars["String"]["output"]>;
    excerpt?: Maybe<Scalars["String"]["output"]>;
    friendlyLastModified?: Maybe<Scalars["String"]["output"]>;
    iconCssClass?: Maybe<Scalars["String"]["output"]>;
    lastModified?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
    resultGlobalContainer?: Maybe<ContainerSummary>;
    resultParentContainer?: Maybe<ContainerSummary>;
    score?: Maybe<Scalars["Float"]["output"]>;
    space?: Maybe<Space>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceSearchResponseEdge = {
    __typename?: "ConfluenceSearchResponseEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ConfluenceSearchResponse>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceSpace = {
    __typename?: "ConfluenceSpace";
    /**
     * The creator of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdBy?: Maybe<ConfluenceUserInfo>;
    /**
     * The date on which Space was created.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * The description of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<ConfluenceSpaceDescription>;
    /**
     * The homepage of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homepage?: Maybe<ConfluencePage>;
    /**
     * The icon associated with the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<ConfluenceSpaceIcon>;
    /**
     * The ARI of the Space, ConfluenceSpaceARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Key of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     * Links associated with the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<ConfluenceSpaceLinks>;
    /**
     * The metadata of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    metadata?: Maybe<ConfluenceSpaceMetadata>;
    /**
     * Name of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The operations allowed on the Space.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: confluence-agg-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operations?: Maybe<Array<Maybe<ConfluenceOperationCheck>>>;
    /**
     * Settings associated with the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    settings?: Maybe<ConfluenceSpaceSettings>;
    /**
     * ID of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["ID"]["output"];
    /**
     * Status of the Space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<ConfluenceSpaceStatus>;
    /**
     * Type of the Space. Can be \"GLOBAL\" or \"PERSONAL\".
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<ConfluenceSpaceType>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceSpaceConnection = {
    __typename?: "ConfluenceSpaceConnection";
    edges?: Maybe<Array<Maybe<ConfluenceSpaceEdge>>>;
    nodes?: Maybe<Array<Maybe<ConfluenceSpace>>>;
    pageInfo: ConfluencePageInfo;
};

export type ConfluenceSpaceDescription = {
    __typename?: "ConfluenceSpaceDescription";
    plain?: Maybe<Scalars["String"]["output"]>;
    view?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceSpaceDetailsSpaceOwner = {
    __typename?: "ConfluenceSpaceDetailsSpaceOwner";
    displayName?: Maybe<Scalars["String"]["output"]>;
    ownerId?: Maybe<Scalars["String"]["output"]>;
    ownerType?: Maybe<ConfluenceSpaceOwnerType>;
};

export type ConfluenceSpaceDetailsSpaceOwnerInput = {
    ownerId?: InputMaybe<Scalars["String"]["input"]>;
    ownerType?: InputMaybe<ConfluenceSpaceOwnerType>;
};

export type ConfluenceSpaceEdge = {
    __typename?: "ConfluenceSpaceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ConfluenceSpace>;
};

export type ConfluenceSpaceFilters = {
    /** It is used to filter Space by it type. */
    type?: InputMaybe<ConfluenceSpaceType>;
};

export type ConfluenceSpaceIcon = {
    __typename?: "ConfluenceSpaceIcon";
    height?: Maybe<Scalars["Int"]["output"]>;
    isDefault?: Maybe<Scalars["Boolean"]["output"]>;
    path?: Maybe<Scalars["String"]["output"]>;
    width?: Maybe<Scalars["Int"]["output"]>;
};

export type ConfluenceSpaceLinks = {
    __typename?: "ConfluenceSpaceLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL associated with the Space. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceSpaceMetadata = {
    __typename?: "ConfluenceSpaceMetadata";
    /** A collection of Labels on the Space. */
    labels?: Maybe<Array<Maybe<ConfluenceLabel>>>;
    /** A collection of the recent commenters within the Space. */
    recentCommenters?: Maybe<Array<Maybe<ConfluenceUserInfo>>>;
    /** A collection of the recent watchers of the Space. */
    recentWatchers?: Maybe<Array<Maybe<ConfluenceUserInfo>>>;
    /** The total number of commenters in the Space. */
    totalCommenters?: Maybe<Scalars["Int"]["output"]>;
    /** The total number of current blog posts in the Space. */
    totalCurrentBlogPosts?: Maybe<Scalars["Int"]["output"]>;
    /** The total number of current pages in the Space. */
    totalCurrentPages?: Maybe<Scalars["Int"]["output"]>;
    /** The total number of watchers of the Space. */
    totalWatchers?: Maybe<Scalars["Int"]["output"]>;
};

export enum ConfluenceSpaceOwnerType {
    Group = "GROUP",
    User = "USER"
}

export enum ConfluenceSpaceSettingEditorVersion {
    V1 = "V1",
    V2 = "V2"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space.setting:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceSpaceSettings = {
    __typename?: "ConfluenceSpaceSettings";
    /** Specifies editor versions for different types of content */
    editorVersions?: Maybe<ConfluenceSpaceSettingsEditorVersions>;
    /** Defines whether an override for the space home should be used. This is used in conjunction with a space theme provided by an app. For example, if this property is set to true, a theme can display a page other than the space homepage when users visit the root URL for a space. This property allows apps to provide content-only theming without overriding the space home. */
    routeOverrideEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceSpaceSettingsEditorVersions = {
    __typename?: "ConfluenceSpaceSettingsEditorVersions";
    /** Editor version for blog posts. */
    blogPost?: Maybe<ConfluenceSpaceSettingEditorVersion>;
    /** Default editor version for content. */
    default?: Maybe<ConfluenceSpaceSettingEditorVersion>;
    /** Editor version for pages. */
    page?: Maybe<ConfluenceSpaceSettingEditorVersion>;
};

export enum ConfluenceSpaceStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT"
}

export enum ConfluenceSpaceType {
    Global = "GLOBAL",
    Personal = "PERSONAL"
}

export type ConfluenceStorage = {
    __typename?: "ConfluenceStorage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bytesLimit?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bytesUsed: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    gracePeriodEndDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isStorageEnforcementGracePeriodComplete?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isUnlimited?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ConfluenceSubCalendarSubscribersCount = {
    __typename?: "ConfluenceSubCalendarSubscribersCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
};

export enum ConfluenceSubscriptionContentType {
    Blogpost = "BLOGPOST",
    Comment = "COMMENT",
    Database = "DATABASE",
    Embed = "EMBED",
    Folder = "FOLDER",
    Page = "PAGE",
    Whiteboard = "WHITEBOARD"
}

export type ConfluenceTeamPresence = {
    __typename?: "ConfluenceTeamPresence";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabledOnContentView: Scalars["Boolean"]["output"];
};

export type ConfluenceTeamPresenceSpaceSettings = {
    __typename?: "ConfluenceTeamPresenceSpaceSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabledOnContentView: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabledOnContentViewForSite: Scalars["Boolean"]["output"];
};

export type ConfluenceTenantContext = {
    __typename?: "ConfluenceTenantContext";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    baseUrl: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customDomainUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editions: Editions;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    initialProductList?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licenseStates?: Maybe<LicenseStates>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licensedProducts: Array<LicensedProduct>;
};

export type ConfluenceTrashBlogPostInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceTrashBlogPostPayload = Payload & {
    __typename?: "ConfluenceTrashBlogPostPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceTrashPageInput = {
    id: Scalars["ID"]["input"];
};

export type ConfluenceTrashPagePayload = Payload & {
    __typename?: "ConfluenceTrashPagePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUnwatchSubCalendarInput = {
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceUnwatchSubCalendarPayload = {
    __typename?: "ConfluenceUnwatchSubCalendarPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateAdminAnnouncementBannerInput = {
    appearance?: InputMaybe<Scalars["String"]["input"]>;
    content?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    isDismissible?: InputMaybe<Scalars["Boolean"]["input"]>;
    scheduledEndTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledStartTime?: InputMaybe<Scalars["String"]["input"]>;
    scheduledTimeZone?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<ConfluenceAdminAnnouncementBannerStatusType>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<ConfluenceAdminAnnouncementBannerVisibilityType>;
};

export type ConfluenceUpdateCommentInput = {
    body: ConfluenceContentBodyInput;
    id: Scalars["ID"]["input"];
};

export type ConfluenceUpdateCommentPayload = {
    __typename?: "ConfluenceUpdateCommentPayload";
    comment?: Maybe<ConfluenceComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateCurrentBlogPostInput = {
    body?: InputMaybe<ConfluenceContentBodyInput>;
    id: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceUpdateCurrentBlogPostPayload = Payload & {
    __typename?: "ConfluenceUpdateCurrentBlogPostPayload";
    blogPost?: Maybe<ConfluenceBlogPost>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateCurrentPageInput = {
    body?: InputMaybe<ConfluenceContentBodyInput>;
    id: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceUpdateCurrentPagePayload = Payload & {
    __typename?: "ConfluenceUpdateCurrentPagePayload";
    errors?: Maybe<Array<MutationError>>;
    page?: Maybe<ConfluencePage>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateDraftBlogPostInput = {
    body?: InputMaybe<ConfluenceContentBodyInput>;
    id: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceUpdateDraftBlogPostPayload = Payload & {
    __typename?: "ConfluenceUpdateDraftBlogPostPayload";
    blogPost?: Maybe<ConfluenceBlogPost>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateDraftPageInput = {
    body?: InputMaybe<ConfluenceContentBodyInput>;
    id: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceUpdateDraftPagePayload = Payload & {
    __typename?: "ConfluenceUpdateDraftPagePayload";
    errors?: Maybe<Array<MutationError>>;
    page?: Maybe<ConfluencePage>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateSpaceInput = {
    id: Scalars["ID"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfluenceUpdateSpacePayload = Payload & {
    __typename?: "ConfluenceUpdateSpacePayload";
    errors?: Maybe<Array<MutationError>>;
    space?: Maybe<ConfluenceSpace>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateSpaceSettingsInput = {
    /** ARI for the Space. */
    id: Scalars["String"]["input"];
    /** Defines whether an override for the space home should be used. This is used in conjunction with a space theme provided by an app. For example, if this property is set to true, a theme can display a page other than the space homepage when users visit the root URL for a space. This property allows apps to provide content-only theming without overriding the space home. */
    routeOverrideEnabled: Scalars["Boolean"]["input"];
};

export type ConfluenceUpdateSpaceSettingsPayload = Payload & {
    __typename?: "ConfluenceUpdateSpaceSettingsPayload";
    confluenceSpaceSettings?: Maybe<ConfluenceSpaceSettings>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateSubCalendarHiddenEventsInput = {
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceUpdateSubCalendarHiddenEventsPayload = Payload & {
    __typename?: "ConfluenceUpdateSubCalendarHiddenEventsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subCalendarIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateTeamPresenceSpaceSettingsInput = {
    isEnabledOnContentView: Scalars["Boolean"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type ConfluenceUpdateTeamPresenceSpaceSettingsPayload = {
    __typename?: "ConfluenceUpdateTeamPresenceSpaceSettingsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabledOnContentView: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateValueBlogPostPropertyInput = {
    blogPostId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceUpdateValueBlogPostPropertyPayload = Payload & {
    __typename?: "ConfluenceUpdateValueBlogPostPropertyPayload";
    blogPostProperty?: Maybe<ConfluenceBlogPostProperty>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUpdateValuePagePropertyInput = {
    key: Scalars["String"]["input"];
    pageId: Scalars["ID"]["input"];
    value: Scalars["String"]["input"];
};

export type ConfluenceUpdateValuePagePropertyPayload = Payload & {
    __typename?: "ConfluenceUpdateValuePagePropertyPayload";
    errors?: Maybe<Array<MutationError>>;
    pageProperty?: Maybe<ConfluencePageProperty>;
    success: Scalars["Boolean"]["output"];
};

export type ConfluenceUser = {
    __typename?: "ConfluenceUser";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use userAccessStatus top level query
     */
    accessStatus: AccessStatus;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use user.id
     */
    accountId?: Maybe<Scalars["String"]["output"]>;
    currentUser?: Maybe<CurrentUserOperations>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use groupWithId instead
     */
    groups: Array<Maybe<Scalars["String"]["output"]>>;
    groupsWithId: Array<Maybe<Group>>;
    hasBlog?: Maybe<Scalars["Boolean"]["output"]>;
    hasPersonalSpace?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use userLocale top level query
     */
    locale: Scalars["String"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use siteOperations.application
     */
    operations: Array<Maybe<OperationCheckResult>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Consider using accessStatus as an alternative
     */
    permissionType?: Maybe<SitePermissionType>;
    roles?: Maybe<GraphQlConfluenceUserRoles>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'space' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    space?: Maybe<Space>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use currentConfluenceUser.key
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
};

export type ConfluenceUserContentAccessResult = {
    __typename?: "ConfluenceUserContentAccessResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canAccessList: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cannotAccessList: Array<Maybe<Scalars["String"]["output"]>>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:user:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceUserInfo = {
    __typename?: "ConfluenceUserInfo";
    /** Type of User. */
    type: ConfluenceUserType;
    /** ARI of the User, IdentityUserARI format. */
    user?: Maybe<User>;
};

export enum ConfluenceUserType {
    Anonymous = "ANONYMOUS",
    Known = "KNOWN"
}

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceValidateSpaceKeyResponse = {
    __typename?: "ConfluenceValidateSpaceKeyResponse";
    /** Unique space key, if requested by client. */
    generatedUniqueKey?: Maybe<Scalars["String"]["output"]>;
    /** True if provided space key is valid, false otherwise. */
    isValid: Scalars["Boolean"]["output"];
};

export type ConfluenceWatchSubCalendarInput = {
    subCalendarId: Scalars["ID"]["input"];
};

export type ConfluenceWatchSubCalendarPayload = {
    __typename?: "ConfluenceWatchSubCalendarPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceWhiteboard = {
    __typename?: "ConfluenceWhiteboard";
    /** Ancestors of the Whiteboard, of all types. */
    allAncestors?: Maybe<Array<Maybe<ConfluenceAncestor>>>;
    /** Original User who authored the Whiteboard. */
    author?: Maybe<ConfluenceUserInfo>;
    /** Body of the Whiteboard. */
    body?: Maybe<ConfluenceWhiteboardBody>;
    /** Comments on the Whiteboard. If no commentType is passed, all comment types are returned. */
    comments?: Maybe<Array<Maybe<ConfluenceComment>>>;
    /** ARI of the Whiteboard, ConfluenceWhiteboardARI format. */
    id: Scalars["ID"]["output"];
    /** Latest Version of the Whiteboard. */
    latestVersion?: Maybe<ConfluenceContentVersion>;
    /** Links associated with the Whiteboard. */
    links?: Maybe<ConfluenceWhiteboardLinks>;
    /** The owner of the Whiteboard. */
    owner?: Maybe<ConfluenceUserInfo>;
    /** Space that contains the Whiteboard. */
    space?: Maybe<ConfluenceSpace>;
    /** Title of the Whiteboard. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Content type of the Whiteboard. Will always be \"WHITEBOARD\". */
    type?: Maybe<ConfluenceContentType>;
    /** Content ID of the Whiteboard. */
    whiteboardId: Scalars["ID"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ConfluenceWhiteboardCommentsArgs = {
    commentType?: InputMaybe<ConfluenceCommentType>;
};

export type ConfluenceWhiteboardBody = {
    __typename?: "ConfluenceWhiteboardBody";
    /** Body content in WHITEBOARD_DOC_FORMAT format. */
    whiteboardDocFormat?: Maybe<ConfluenceBody>;
};

export type ConfluenceWhiteboardLinks = {
    __typename?: "ConfluenceWhiteboardLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    /** The web UI URL path associated with the Whiteboard. */
    webUi?: Maybe<Scalars["String"]["output"]>;
};

export type Confluence_CqlMetaData = {
    __typename?: "Confluence_cqlMetaData";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cqlContentTypes: Array<Maybe<CqlDisplayableType>>;
};

export type Confluence_CqlMetaDataCqlContentTypesArgs = {
    category?: InputMaybe<Scalars["String"]["input"]>;
};

export type Confluence_DataSecurityPolicy = {
    __typename?: "Confluence_dataSecurityPolicy";
    /**
     * Returns the set of Classification Level ARIs (aka User tags) for which the given Data Security Policy action is blocked as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    getClassificationLevelArisBlockingAction: Array<
        Maybe<Scalars["String"]["output"]>
    >;
    /**
     * Given a set of Content IDs and the ID of the Space they belong to, returns the subset which are blocked from the given Data Security Policy action as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    getContentIdsBlockedForAction: Array<Maybe<Scalars["Long"]["output"]>>;
    /**
     * Determines whether the given Data Security Policy action is enabled for the target Content as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActionEnabledForContent: DataSecurityPolicyDecision;
    /**
     * Determines whether the given Data Security Policy action is enabled for the given Space ID or Space Key as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActionEnabledForSpace: DataSecurityPolicyDecision;
    /**
     * Determines whether the given Data Security Policy action is enabled for the containing Workspace as a result of Org Data Security Policies.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isActionEnabledForWorkspace: DataSecurityPolicyDecision;
};

export type Confluence_DataSecurityPolicyGetClassificationLevelArisBlockingActionArgs =
    {
        action: DataSecurityPolicyAction;
    };

export type Confluence_DataSecurityPolicyGetContentIdsBlockedForActionArgs = {
    action: DataSecurityPolicyAction;
    contentIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
    spaceId: Scalars["Long"]["input"];
};

export type Confluence_DataSecurityPolicyIsActionEnabledForContentArgs = {
    action: DataSecurityPolicyAction;
    contentId: Scalars["ID"]["input"];
    contentStatus: DataSecurityPolicyDecidableContentStatus;
    contentVersion: Scalars["Int"]["input"];
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type Confluence_DataSecurityPolicyIsActionEnabledForSpaceArgs = {
    action: DataSecurityPolicyAction;
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type Confluence_DataSecurityPolicyIsActionEnabledForWorkspaceArgs = {
    action: DataSecurityPolicyAction;
};

/** Level of access to an Atlassian product that an app can request */
export type ConnectAppScope = {
    __typename?: "ConnectAppScope";
    /**
     * Name of Atlassian product to which this scope applies
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    atlassianProductName: Scalars["String"]["output"];
    /**
     * Description of the level of access to an Atlassian product that an app can request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    capability: Scalars["String"]["output"];
    /**
     * Unique id of the scope
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Name of the scope
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
    /**
     * Unique id of the scope (Deprecated field: Use field `id`)
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field `id`
     */
    scopeId: Scalars["ID"]["output"];
};

export type ConnectionManagerConfiguration = {
    __typename?: "ConnectionManagerConfiguration";
    parameters?: Maybe<Scalars["String"]["output"]>;
};

export type ConnectionManagerConfigurationInput = {
    parameters?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConnectionManagerConnection = {
    __typename?: "ConnectionManagerConnection";
    configuration?: Maybe<ConnectionManagerConfiguration>;
    connectionId?: Maybe<Scalars["String"]["output"]>;
    integrationKey?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ConnectionManagerConnections = {
    __typename?: "ConnectionManagerConnections";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    connections?: Maybe<Array<Maybe<ConnectionManagerConnection>>>;
};

/** Results Union */
export type ConnectionManagerConnectionsByJiraProjectResult =
    | ConnectionManagerConnections
    | QueryError;

export type ConnectionManagerConnectionsFilter = {
    integrationKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConnectionManagerCreateApiTokenConnectionForJiraProjectPayload =
    Payload & {
        __typename?: "ConnectionManagerCreateApiTokenConnectionForJiraProjectPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        createdConnectionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConnectionManagerCreateApiTokenConnectionInput = {
    configuration?: InputMaybe<ConnectionManagerConfigurationInput>;
    integrationKey?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    tokens?: InputMaybe<Array<InputMaybe<ConnectionManagerTokenInput>>>;
};

export type ConnectionManagerCreateOAuthConnectionForJiraProjectPayload =
    Payload & {
        __typename?: "ConnectionManagerCreateOAuthConnectionForJiraProjectPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        authorizationUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        createdConnectionId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConnectionManagerCreateOAuthConnectionInput = {
    configuration?: InputMaybe<ConnectionManagerConfigurationInput>;
    credentials?: InputMaybe<ConnectionManagerOAuthCredentialsInput>;
    integrationKey?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    providerDetails?: InputMaybe<ConnectionManagerOAuthProviderDetailsInput>;
};

export type ConnectionManagerDeleteApiTokenConnectionForJiraProjectPayload =
    Payload & {
        __typename?: "ConnectionManagerDeleteApiTokenConnectionForJiraProjectPayload";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type ConnectionManagerDeleteConnectionForJiraProjectPayload = Payload & {
    __typename?: "ConnectionManagerDeleteConnectionForJiraProjectPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConnectionManagerOAuthCredentialsInput = {
    clientId?: InputMaybe<Scalars["String"]["input"]>;
    clientSecret?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConnectionManagerOAuthProviderDetailsInput = {
    authorizationUrl?: InputMaybe<Scalars["String"]["input"]>;
    exchangeUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConnectionManagerTokenInput = {
    token?: InputMaybe<Scalars["String"]["input"]>;
    tokenId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContactAdminMutationInput = {
    content: ContactAdminMutationInputContent;
    recaptchaResponseToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContactAdminMutationInputContent = {
    from: Scalars["String"]["input"];
    requestDetails: Scalars["String"]["input"];
    subject: Scalars["String"]["input"];
};

export enum ContactAdminPageDisabledReason {
    ConfigOff = "CONFIG_OFF",
    NoAdminEmails = "NO_ADMIN_EMAILS",
    NoMailServer = "NO_MAIL_SERVER",
    NoRecaptcha = "NO_RECAPTCHA"
}

export type ContainerEventObject = {
    __typename?: "ContainerEventObject";
    attributes: Scalars["JSON"]["output"];
    id: Scalars["ID"]["output"];
    type: Scalars["String"]["output"];
};

export type ContainerLookAndFeel = {
    __typename?: "ContainerLookAndFeel";
    background?: Maybe<Scalars["String"]["output"]>;
    backgroundAttachment?: Maybe<Scalars["String"]["output"]>;
    backgroundBlendMode?: Maybe<Scalars["String"]["output"]>;
    backgroundClip?: Maybe<Scalars["String"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<Scalars["String"]["output"]>;
    backgroundOrigin?: Maybe<Scalars["String"]["output"]>;
    backgroundPosition?: Maybe<Scalars["String"]["output"]>;
    backgroundRepeat?: Maybe<Scalars["String"]["output"]>;
    backgroundSize?: Maybe<Scalars["String"]["output"]>;
    borderRadius?: Maybe<Scalars["String"]["output"]>;
    padding?: Maybe<Scalars["String"]["output"]>;
};

export type ContainerSummary = {
    __typename?: "ContainerSummary";
    displayUrl?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export enum ContainerType {
    Blogpost = "BLOGPOST",
    Database = "DATABASE",
    Page = "PAGE",
    Space = "SPACE",
    Whiteboard = "WHITEBOARD"
}

export type Content = {
    __typename?: "Content";
    ancestors?: Maybe<Array<Maybe<Content>>>;
    archivableDescendantsCount: Scalars["Long"]["output"];
    archiveNote?: Maybe<Scalars["String"]["output"]>;
    archivedContentMetadata?: Maybe<ArchivedContentMetadata>;
    attachments?: Maybe<PaginatedContentList>;
    blank: Scalars["Boolean"]["output"];
    body?: Maybe<ContentBodyPerRepresentation>;
    childTypes?: Maybe<ChildContentTypesAvailable>;
    children?: Maybe<PaginatedContentList>;
    /** GraphQL query to get effective classification level along with its source for content */
    classificationLevelDetails?: Maybe<ClassificationLevelDetails>;
    /** GraphQL query to get classification level for content */
    classificationLevelId?: Maybe<Scalars["String"]["output"]>;
    /** GraphQL query to get classification level override for content. */
    classificationLevelOverrideId?: Maybe<Scalars["String"]["output"]>;
    comments?: Maybe<PaginatedContentList>;
    container?: Maybe<SpaceOrContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViewers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViewers?: Maybe<ContentAnalyticsViewers>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViews' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViews?: Maybe<ContentAnalyticsViews>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViewsByUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViewsByUser?: Maybe<ContentAnalyticsViewsByUser>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentProperties' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentProperties?: Maybe<ContentProperties>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentReactionsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentReactionsSummary?: Maybe<ReactionsSummaryResponse>;
    contentState?: Maybe<ContentState>;
    /** Atlassian Account ID of the content creator. Internal only, clients should use history.createdBy field */
    creatorId?: Maybe<Scalars["String"]["output"]>;
    currentUserHasAncestorWatchingChildren?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    currentUserIsWatching: Scalars["Boolean"]["output"];
    currentUserIsWatchingChildren?: Maybe<Scalars["Boolean"]["output"]>;
    deletableDescendantsCount: Scalars["Long"]["output"];
    /** This is an experimental api created for connie mobile. It is bound to break, only use it if you know what you are doing. */
    dynamicMobileBody?: Maybe<ContentBody>;
    embeddedProduct?: Maybe<Scalars["String"]["output"]>;
    excerpt: Scalars["String"]["output"];
    extensions?: Maybe<Array<Maybe<KeyValueHierarchyMap>>>;
    hasGroupRestriction: Scalars["Boolean"]["output"];
    hasInheritedGroupRestriction: Scalars["Boolean"]["output"];
    hasInheritedRestriction: Scalars["Boolean"]["output"];
    hasInheritedRestrictions: Scalars["Boolean"]["output"];
    hasRestriction: Scalars["Boolean"]["output"];
    hasRestrictions: Scalars["Boolean"]["output"];
    hasViewRestrictions: Scalars["Boolean"]["output"];
    hasVisibleChildPages: Scalars["Boolean"]["output"];
    history?: Maybe<History>;
    id?: Maybe<Scalars["ID"]["output"]>;
    inContentTree: Scalars["Boolean"]["output"];
    incomingLinks?: Maybe<PaginatedContentList>;
    /** GraphQL query to determine whether export is enabled for content. */
    isExportEnabled: Scalars["Boolean"]["output"];
    labels?: Maybe<PaginatedLabelList>;
    likes?: Maybe<LikesResponse>;
    links?: Maybe<LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
    macroRenderedOutput?: Maybe<Array<Maybe<MapOfStringToFormattedBody>>>;
    mediaSession: ContentMediaSession;
    metadata: ContentMetadata;
    /** Returns the body of the content that is rendered for mobile devices. Uses this query only if you know body is of legacy format */
    mobileContentBody?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    outgoingLinks?: Maybe<OutgoingLinks>;
    properties?: Maybe<PaginatedJsonContentPropertyList>;
    /** Paginated list of redaction metadata for this content. */
    redactionMetadata?: Maybe<ConfluenceRedactionMetadataConnection>;
    /** Count of redactions for this content */
    redactionMetadataCount?: Maybe<Scalars["Int"]["output"]>;
    referenceId?: Maybe<Scalars["String"]["output"]>;
    restrictions?: Maybe<ContentRestrictions>;
    schedulePublishDate?: Maybe<Scalars["String"]["output"]>;
    schedulePublishInfo?: Maybe<SchedulePublishInfo>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'smartFeatures' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    smartFeatures?: Maybe<SmartPageFeatures>;
    space?: Maybe<Space>;
    status?: Maybe<Scalars["String"]["output"]>;
    subType?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<Version>;
    visibleDescendantsCount: Scalars["Long"]["output"];
};

export type ContentAttachmentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentChildrenArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContentClassificationLevelIdArgs = {
    contentStatus: ContentDataClassificationQueryContentStatus;
};

export type ContentCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    depth?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    location?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    recentFirst?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentContentAnalyticsViewsByUserArgs = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentContentStateArgs = {
    isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContentDynamicMobileBodyArgs = {
    imageLazyLoading?: Scalars["Boolean"]["input"];
    pagePropertiesReportMacroRenderAtServer?: Scalars["Boolean"]["input"];
};

export type ContentExcerptArgs = {
    length?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentHasGroupRestrictionArgs = {
    groupID: Scalars["String"]["input"];
    permission: InspectPermissions;
};

export type ContentHasInheritedGroupRestrictionArgs = {
    groupID: Scalars["String"]["input"];
    permission: InspectPermissions;
};

export type ContentHasInheritedRestrictionArgs = {
    accountID: Scalars["String"]["input"];
    permission: InspectPermissions;
};

export type ContentHasRestrictionArgs = {
    accountID: Scalars["String"]["input"];
    permission: InspectPermissions;
};

export type ContentIncomingLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentLabelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<LabelSort>;
    prefix?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type ContentLikesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Long"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentMobileContentBodyArgs = {
    imageLazyLoading?: Scalars["Boolean"]["input"];
    pagePropertiesReportMacroRenderAtServer?: Scalars["Boolean"]["input"];
};

export type ContentPropertiesArgs = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentRedactionMetadataArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum ContentAccessInputType {
    EveryoneCanEdit = "EVERYONE_CAN_EDIT",
    EveryoneCanView = "EVERYONE_CAN_VIEW",
    EveryoneNoAccess = "EVERYONE_NO_ACCESS",
    Private = "PRIVATE"
}

export enum ContentAccessType {
    EveryoneCanEdit = "EVERYONE_CAN_EDIT",
    EveryoneCanView = "EVERYONE_CAN_VIEW",
    EveryoneNoAccess = "EVERYONE_NO_ACCESS"
}

export enum ContentAction {
    Created = "created",
    Updated = "updated",
    Viewed = "viewed"
}

export type ContentAnalyticsLastViewedAtByPage = {
    __typename?: "ContentAnalyticsLastViewedAtByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ContentAnalyticsLastViewedAtByPageItem>>>;
};

export type ContentAnalyticsLastViewedAtByPageItem = {
    __typename?: "ContentAnalyticsLastViewedAtByPageItem";
    contentId: Scalars["ID"]["output"];
    lastViewedAt: Scalars["String"]["output"];
};

export type ContentAnalyticsPageViewInfo = {
    __typename?: "ContentAnalyticsPageViewInfo";
    isEngaged?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use lastVersionViewedNumber instead
     */
    lastVersionViewed: Scalars["Int"]["output"];
    lastVersionViewedNumber?: Maybe<Scalars["Int"]["output"]>;
    lastVersionViewedUrl?: Maybe<Scalars["String"]["output"]>;
    lastViewedAt: Scalars["String"]["output"];
    userId: Scalars["ID"]["output"];
    views: Scalars["Int"]["output"];
};

export type ContentAnalyticsTotalViewsByPage = {
    __typename?: "ContentAnalyticsTotalViewsByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ContentAnalyticsTotalViewsByPageItem>>>;
};

export type ContentAnalyticsTotalViewsByPageItem = {
    __typename?: "ContentAnalyticsTotalViewsByPageItem";
    contentId: Scalars["ID"]["output"];
    totalViews: Scalars["Int"]["output"];
};

export type ContentAnalyticsUnreadComments = {
    __typename?: "ContentAnalyticsUnreadComments";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentIds: Array<Scalars["ID"]["output"]>;
};

export type ContentAnalyticsViewers = {
    __typename?: "ContentAnalyticsViewers";
    count: Scalars["Int"]["output"];
};

export type ContentAnalyticsViews = {
    __typename?: "ContentAnalyticsViews";
    count: Scalars["Int"]["output"];
};

export type ContentAnalyticsViewsByDate = {
    __typename?: "ContentAnalyticsViewsByDate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ContentAnalyticsViewsByDateItem>>>;
};

export type ContentAnalyticsViewsByDateItem = {
    __typename?: "ContentAnalyticsViewsByDateItem";
    date: Scalars["String"]["output"];
    total: Scalars["Int"]["output"];
};

export type ContentAnalyticsViewsByUser = {
    __typename?: "ContentAnalyticsViewsByUser";
    id: Scalars["ID"]["output"];
    pageViews: Array<ContentAnalyticsPageViewInfo>;
};

export type ContentBody = {
    __typename?: "ContentBody";
    content?: Maybe<Content>;
    embeddedContent: Array<Maybe<EmbeddedContent>>;
    links?: Maybe<LinksContextBase>;
    macroRenderedOutput?: Maybe<FormattedBody>;
    macroRenderedRepresentation?: Maybe<Scalars["String"]["output"]>;
    mediaToken?: Maybe<EmbeddedMediaToken>;
    representation?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
    webresource?: Maybe<WebResourceDependencies>;
};

export type ContentBodyInput = {
    representation: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ContentBodyPerRepresentation = {
    __typename?: "ContentBodyPerRepresentation";
    atlas_doc_format?: Maybe<ContentBody>;
    dynamic?: Maybe<ContentBody>;
    editor?: Maybe<ContentBody>;
    editor2?: Maybe<ContentBody>;
    export_view?: Maybe<ContentBody>;
    plain?: Maybe<ContentBody>;
    raw?: Maybe<ContentBody>;
    storage?: Maybe<ContentBody>;
    styled_view?: Maybe<ContentBody>;
    view?: Maybe<ContentBody>;
    wiki?: Maybe<ContentBody>;
};

export type ContentContributors = {
    __typename?: "ContentContributors";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<PersonEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isCurrentUserContributor?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<Person>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type ContentCreationMetadata = {
    __typename?: "ContentCreationMetadata";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserPermissions: PermissionMetadata;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    parent?: Maybe<Content>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space: Space;
};

export type ContentDataClassificationLevel = {
    __typename?: "ContentDataClassificationLevel";
    color?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    guideline?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    order?: Maybe<Scalars["Int"]["output"]>;
    status: Scalars["String"]["output"];
};

export enum ContentDataClassificationMutationContentStatus {
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ContentDataClassificationQueryContentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum ContentDeleteActionType {
    DeleteDraft = "DELETE_DRAFT",
    DeleteDraftIfBlank = "DELETE_DRAFT_IF_BLANK",
    MoveToTrash = "MOVE_TO_TRASH",
    PurgeFromTrash = "PURGE_FROM_TRASH"
}

export type ContentEdge = {
    __typename?: "ContentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Content>;
};

export type ContentHistory = {
    __typename?: "ContentHistory";
    by: Person;
    collaborators?: Maybe<ContributorUsers>;
    friendlyWhen: Scalars["String"]["output"];
    message: Scalars["String"]["output"];
    minorEdit: Scalars["Boolean"]["output"];
    number: Scalars["Int"]["output"];
    state?: Maybe<ContentState>;
    when: Scalars["String"]["output"];
};

export type ContentHistoryEdge = {
    __typename?: "ContentHistoryEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ContentHistory>;
};

export type ContentLookAndFeel = {
    __typename?: "ContentLookAndFeel";
    body?: Maybe<ContainerLookAndFeel>;
    container?: Maybe<ContainerLookAndFeel>;
    header?: Maybe<ContainerLookAndFeel>;
    screen?: Maybe<ScreenLookAndFeel>;
};

export type ContentMediaSession = {
    __typename?: "ContentMediaSession";
    /** Encapsulated access tokens for the media session. If the client does not have access to a given token, null will be returned, rather than an error being thrown */
    accessTokens: MediaAccessTokens;
    collection: Scalars["String"]["output"];
    configuration: MediaConfiguration;
    /** Returns a read-only token. Error will be thrown if user does not have appropriate permissions */
    downloadToken: MediaToken;
    mediaPickerUserToken?: Maybe<MediaPickerUserToken>;
    /** Returns a read+write token. Error will be thrown if user does not have appropriate permissions */
    token: MediaToken;
};

export type ContentMention = {
    mentionLocalId?: InputMaybe<Scalars["ID"]["input"]>;
    mentionedUserAccountId: Scalars["ID"]["input"];
    notificationAction: NotificationAction;
};

export type ContentMetadata = {
    __typename?: "ContentMetadata";
    comments?: Maybe<ContentMetadata_CommentsMetadataProvider_Comments>;
    createdDate?: Maybe<Scalars["String"]["output"]>;
    currentuser?: Maybe<ContentMetadata_CurrentUserMetadataProvider_Currentuser>;
    frontend?: Maybe<ContentMetadata_SpaFriendlyMetadataProvider_Frontend>;
    isActiveLiveEditSession?: Maybe<Scalars["Boolean"]["output"]>;
    labels?: Maybe<Array<Maybe<Label>>>;
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    likes?: Maybe<LikesModelMetadataDto>;
    simple?: Maybe<ContentMetadata_SimpleContentMetadataProvider_Simple>;
    sourceTemplateEntityId?: Maybe<Scalars["String"]["output"]>;
};

export type ContentMetadata_CommentsMetadataProvider_Comments = {
    __typename?: "ContentMetadata_CommentsMetadataProvider_comments";
    commentsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ContentMetadata_CurrentUserMetadataProvider_Currentuser = {
    __typename?: "ContentMetadata_CurrentUserMetadataProvider_currentuser";
    favourited?: Maybe<FavouritedSummary>;
    lastcontributed?: Maybe<ContributionStatusSummary>;
    lastmodified?: Maybe<LastModifiedSummary>;
    scheduled?: Maybe<ScheduledPublishSummary>;
    viewed?: Maybe<RecentlyViewedSummary>;
};

export type ContentMetadata_SimpleContentMetadataProvider_Simple = {
    __typename?: "ContentMetadata_SimpleContentMetadataProvider_simple";
    adfExtensions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    hasComment?: Maybe<Scalars["Boolean"]["output"]>;
    hasInlineComment?: Maybe<Scalars["Boolean"]["output"]>;
    isFabric?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ContentMetadata_SpaFriendlyMetadataProvider_Frontend = {
    __typename?: "ContentMetadata_SpaFriendlyMetadataProvider_frontend";
    collabService?: Maybe<Scalars["String"]["output"]>;
    collabServiceWithMigration?: Maybe<Scalars["String"]["output"]>;
    commentMacroNamesNotSpaFriendly?: Maybe<
        Array<Maybe<Scalars["String"]["output"]>>
    >;
    commentsSpaFriendly?: Maybe<Scalars["Boolean"]["output"]>;
    contentHash?: Maybe<Scalars["String"]["output"]>;
    coverPictureWidth?: Maybe<Scalars["String"]["output"]>;
    embedUrl?: Maybe<Scalars["String"]["output"]>;
    embedded: Scalars["Boolean"]["output"];
    embeddedWithMigration: Scalars["Boolean"]["output"];
    fabricEditorEligibility?: Maybe<Scalars["String"]["output"]>;
    fabricEditorSupported?: Maybe<Scalars["Boolean"]["output"]>;
    macroNamesNotSpaFriendly?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    migratedRecently?: Maybe<Scalars["Boolean"]["output"]>;
    spaFriendly?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ContentPermissionType {
    Edit = "EDIT",
    View = "VIEW"
}

export type ContentPermissions = {
    __typename?: "ContentPermissions";
    /**
     * GraphQL query to get content access level on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentAccess: ContentAccessType;
    /**
     * Content permissions hash used by UI to figure out whether permissions were changed
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentPermissionsHash: Scalars["String"]["output"];
    /**
     * GraphQL query to get content permissions for current user on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUser?: Maybe<SubjectUserOrGroup>;
    /**
     * GraphQL query to get effective content permissions for current user on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserWithEffectivePermissions: UsersWithEffectiveRestrictions;
    /**
     * GraphQL query to get a paged list of subjects which have actual content permissions on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithEffectiveContentPermissions: PaginatedSubjectUserOrGroupList;
    /**
     * GraphQL query to get a paged list of subjects which have explicit content permissions on given content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithPermissions: PaginatedSubjectUserOrGroupList;
};

export type ContentPermissionsSubjectsWithEffectiveContentPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentPermissionsSubjectsWithPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ContentPermissionsPayload = {
    __typename?: "ContentPermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type ContentPlatformAdvocateQuote = {
    __typename?: "ContentPlatformAdvocateQuote";
    /** Photo of the advocate */
    advocateHeadshot?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Job Title of the advocate */
    advocateJobTitle?: Maybe<Scalars["String"]["output"]>;
    /** Name of the advocate */
    advocateName?: Maybe<Scalars["String"]["output"]>;
    /** Quote given by the advocate */
    advocateQuote?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Advocate Quote */
    advocateQuoteId: Scalars["String"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Hero Quote */
    heroQuote?: Maybe<Scalars["Boolean"]["output"]>;
    /** Public-facing name for this Quote */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Organization of the advocate */
    organization?: Maybe<ContentPlatformOrganization>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnchor = {
    __typename?: "ContentPlatformAnchor";
    /** ID for this Anchor */
    anchorId: Scalars["String"]["output"];
    /** Anchor Topic for this Anchor */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Banner for this Anchor */
    banner?: Maybe<Array<ContentPlatformAnchorBanner>>;
    /** Call to Action for this Anchor */
    callToAction?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Headline for this Anchor */
    headline?: Maybe<Array<ContentPlatformAnchorHeadline>>;
    /** Public-facing name for Anchor */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Page Variant Value for this Anchor */
    pageVariant: Scalars["String"]["output"];
    /** Persona Value for this Anchor */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Primary Message for this Anchor */
    primaryMessage?: Maybe<Array<ContentPlatformAnchorPrimaryMessage>>;
    /** Related Product for this Anchor */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** Results Message for this Anchor */
    results?: Maybe<Array<ContentPlatformAnchorResult>>;
    /** Social Proof for this Anchor */
    socialProof?: Maybe<Array<ContentPlatformAnchorSocialProof>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnchorBanner = {
    __typename?: "ContentPlatformAnchorBanner";
    /** Anchor Topic for this Banner */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Background Media Asset for this banner */
    backgroundImage?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Media Asset for this banner */
    bannerImage?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Product related to this banner */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** Banner text */
    text?: Maybe<Scalars["String"]["output"]>;
    /** Banner title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** Banner URL */
    url?: Maybe<Scalars["String"]["output"]>;
    /** Banner URL text */
    urlText?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnchorContentSearchConnection = {
    __typename?: "ContentPlatformAnchorContentSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformAnchorResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformAnchorHeadline = {
    __typename?: "ContentPlatformAnchorHeadline";
    /** Topic for this Anchor Headline */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Animated Tour for this Anchor Headline */
    animatedTour?: Maybe<ContentPlatformAnimatedTour>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Anchor Headline */
    id: Scalars["String"]["output"];
    /** Title for this Anchor Headline */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Persona for this Anchor Headline */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Plan Benefits for this Anchor Headline */
    planBenefits?: Maybe<Array<ContentPlatformPlanBenefits>>;
    /** Product for this Anchor Headline */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** Subheading for this Anchor Headline */
    subheading?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnchorPrimaryMessage = {
    __typename?: "ContentPlatformAnchorPrimaryMessage";
    /** Anchor Topic for this Anchor Primary Message */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Anchor Primary Message */
    id: Scalars["String"]["output"];
    /** Public-facing name for Anchor Primary Message */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Persona for this Anchor Primary Message */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Product for this Anchor Primary Message */
    product?: Maybe<ContentPlatformProduct>;
    /** Supporting Example for this Anchor Primary Message */
    supportingExample?: Maybe<Array<ContentPlatformSupportingExample>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnchorResult = {
    __typename?: "ContentPlatformAnchorResult";
    /** Anchor Topic for this Result */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Media Asset for this Result */
    asset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Result */
    id: Scalars["String"]["output"];
    /** Lozenge for this Result */
    lozenge?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for this Result */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Persona for this Result */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Product for this Result */
    product?: Maybe<ContentPlatformProduct>;
    /** Subheading for this Result */
    subheading?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnchorResultEdge = {
    __typename?: "ContentPlatformAnchorResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformAnchor;
};

export type ContentPlatformAnchorSocialProof = {
    __typename?: "ContentPlatformAnchorSocialProof";
    /** Anchor Topic for this Social Proof */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Customers for this Social Proof */
    customers?: Maybe<Array<ContentPlatformOrganization>>;
    /** ID for this Social Proof */
    id: Scalars["String"]["output"];
    /** Public-facing name for this Social Proof */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Persona Value for this Social Proof */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Product for this Social Proof */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnimatedTour = {
    __typename?: "ContentPlatformAnimatedTour";
    /** Card Override for this Animated Tour */
    cardOverride?: Maybe<ContentPlatformAnimatedTourCard>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Done Cards Override for this Animated Tour */
    doneCardsOverride?: Maybe<Array<ContentPlatformAnimatedTourCard>>;
    /** In-Progress Cards Override for this Animated Tour */
    inProgressCardsOverride?: Maybe<Array<ContentPlatformAnimatedTourCard>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnimatedTourCard = {
    __typename?: "ContentPlatformAnimatedTourCard";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Epic name for this Animated Tour Card */
    epicName?: Maybe<Scalars["String"]["output"]>;
    /** Issue type */
    issueTypeName?: Maybe<Scalars["String"]["output"]>;
    /** Priority for this Animated Tour Card */
    priority?: Maybe<Scalars["String"]["output"]>;
    /** Summary for this Animated Tour Card */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAnyContext =
    | ContentPlatformContextApp
    | ContentPlatformContextProduct
    | ContentPlatformContextTheme;

export type ContentPlatformArticleIntroduction = {
    __typename?: "ContentPlatformArticleIntroduction";
    /** Article introduction asset */
    articleIntroductionAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Article introduction details */
    articleIntroductionDetails?: Maybe<Scalars["String"]["output"]>;
    /** Article Introduction name */
    articleIntroductionName?: Maybe<Scalars["String"]["output"]>;
    /** Componentized Introduction */
    componentizedIntroduction?: Maybe<
        Array<ContentPlatformAssetComponentAndProTipComponentAndTextComponentAndCallToActionAndQuestionComponentAndTwitterComponentAndCallOutComponentUnion>
    >;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Embed link */
    embedLink?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAssetComponent = {
    __typename?: "ContentPlatformAssetComponent";
    /** Asset */
    asset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Asset related text, this field can contain rich text and give a more detailed description of the asset */
    assetRelatedText?: Maybe<Scalars["String"]["output"]>;
    /** Asset caption */
    caption?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformAssetComponentAndProTipComponentAndTextComponentAndCallToActionAndQuestionComponentAndTwitterComponentAndCallOutComponentUnion =

        | ContentPlatformAssetComponent
        | ContentPlatformCallOutComponent
        | ContentPlatformCallToAction
        | ContentPlatformProTipComponent
        | ContentPlatformQuestionComponent
        | ContentPlatformTextComponent
        | ContentPlatformTwitterComponent;

export type ContentPlatformAuthor = {
    __typename?: "ContentPlatformAuthor";
    /** Picture of this Author */
    authorPicture?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Is this user generated content by an individual outside of Atlassian? */
    externalContributor?: Maybe<Scalars["Boolean"]["output"]>;
    /** Job title for this Author */
    jobTitle?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for this Author */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Organization the author belongs to */
    organization?: Maybe<ContentPlatformOrganization>;
    /** Short biography about the Author */
    shortBiography?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformBeforeYouBeginComponent = {
    __typename?: "ContentPlatformBeforeYouBeginComponent";
    /** Audience */
    audience?: Maybe<Scalars["String"]["output"]>;
    /** Before You Begin title */
    beforeYouBeginTitle?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** CTA Microcopy */
    ctaMicrocopy?: Maybe<ContentPlatformCallToActionMicrocopy>;
    /** Prerequisite */
    prerequisite?: Maybe<Scalars["String"]["output"]>;
    /** Related Asset */
    relatedAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Related questions */
    relatedQuestions?: Maybe<ContentPlatformQuestionComponent>;
    /** Time */
    time?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export enum ContentPlatformBooleanOperators {
    And = "AND",
    Or = "OR"
}

export type ContentPlatformCallOutComponent = {
    __typename?: "ContentPlatformCallOutComponent";
    /** Asset */
    asset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Call out text */
    callOutText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Call out component icon */
    icon?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Call out component title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformCallToAction = {
    __typename?: "ContentPlatformCallToAction";
    asset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Blueprint Plugin Id this Call to Action */
    dataBlueprintModule?: Maybe<Scalars["String"]["output"]>;
    /** Product related to this CTA */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** Product logo */
    productLogo?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Product name */
    productName?: Maybe<Scalars["String"]["output"]>;
    /** CTA Text */
    text?: Maybe<Scalars["String"]["output"]>;
    /** CTA title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** CTA URL */
    url?: Maybe<Scalars["String"]["output"]>;
    /** Value proposition */
    valueProposition?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformCallToActionAndCallToActionMicrocopyUnion =
    | ContentPlatformCallToAction
    | ContentPlatformCallToActionMicrocopy;

export type ContentPlatformCallToActionMicrocopy = {
    __typename?: "ContentPlatformCallToActionMicrocopy";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** CTA Button Text */
    ctaButtonText?: Maybe<Scalars["String"]["output"]>;
    /** CTA Microcopy Title */
    ctaMicrocopyTitle?: Maybe<Scalars["String"]["output"]>;
    /** CTA URL */
    ctaUrl?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformCategory = {
    __typename?: "ContentPlatformCategory";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Long description of this Template Category */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Flag for experiment Template category */
    experiment?: Maybe<Scalars["Boolean"]["output"]>;
    /** ID for this Template Category */
    id: Scalars["String"]["output"];
    /** Title for this Template Category */
    name?: Maybe<Scalars["String"]["output"]>;
    /** One-line plaintext description of this Template Category */
    shortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** URL slug for this Template Category */
    urlSlug?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformContentClause = {
    /** Logical AND operator that expects all expressions within operator to be true */
    and?: InputMaybe<Array<ContentPlatformContentClause>>;
    /** Field name selector */
    fieldNamed?: InputMaybe<Scalars["String"]["input"]>;
    /** Greater than or equal to operator, currently used for date comparisons */
    gte?: InputMaybe<ContentPlatformDateCondition>;
    /** Existence selector */
    hasAnyValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Values selector */
    havingValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Less than or equal to operator, currently used for date comparisons */
    lte?: InputMaybe<ContentPlatformDateCondition>;
    /** Logical OR operator that expects at least one expression within operator to be true */
    or?: InputMaybe<Array<ContentPlatformContentClause>>;
    /** Object that allows users to search content for text snippets */
    searchText?: InputMaybe<ContentPlatformSearchTextClause>;
};

export type ContentPlatformContentEdge = {
    __typename?: "ContentPlatformContentEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformContentFacet;
};

export type ContentPlatformContentFacet = {
    __typename?: "ContentPlatformContentFacet";
    /** Type of content */
    contentType: Scalars["String"]["output"];
    /** Fields present in the specific facet */
    context: Scalars["JSON"]["output"];
    /** Field of the content primitive */
    field: Scalars["String"]["output"];
    /** Total count of hits */
    totalCount: Scalars["Float"]["output"];
};

export type ContentPlatformContentFacetConnection = {
    __typename?: "ContentPlatformContentFacetConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformContentEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformContentQueryInput = {
    /** This is a cursor after which (exclusive) the data should be fetched */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Number of content results to fetch */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** This is how the entries returned will be sorted */
    sortBy?: InputMaybe<ContentPlatformSortClause>;
    /** Object used to filter and search text */
    where?: InputMaybe<ContentPlatformContentClause>;
    /** Fallback locale to use when no content is found in the requested locale */
    withFallback?: InputMaybe<Scalars["String"]["input"]>;
    /** Locales to return content in */
    withLocales?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Object containing the product Feature Flags associated with the Atlassian Product Instance */
    withProductFeatureFlags?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type ContentPlatformContextApp = {
    __typename?: "ContentPlatformContextApp";
    appName: Scalars["String"]["output"];
    /** Contentful ID for this Context: App */
    contextId: Scalars["String"]["output"];
    icon?: Maybe<ContentPlatformImageAsset>;
    /** Products that this App can be classified for */
    parentProductContext: Array<ContentPlatformContextProduct>;
    preventProdPublishing?: Maybe<Scalars["Boolean"]["output"]>;
    /** Internal title of this App Context. For public-facing name, get appNameReference.appName */
    title: Scalars["String"]["output"];
    /** This app's url slug. Used primarily for SAC */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformContextProduct = {
    __typename?: "ContentPlatformContextProduct";
    /** Contentful ID for this Context: Product */
    contextId: Scalars["String"]["output"];
    customSupportFormAuthenticated?: Maybe<Scalars["String"]["output"]>;
    customSupportFormUnauthenticated?: Maybe<Scalars["String"]["output"]>;
    /** What platform this Product is for. Cloud, Server, or N/A */
    deployment: Scalars["String"]["output"];
    icon?: Maybe<ContentPlatformImageAsset>;
    preventProdPublishing?: Maybe<Scalars["Boolean"]["output"]>;
    productBlurb?: Maybe<Scalars["String"]["output"]>;
    productName: Scalars["String"]["output"];
    /** The full support title of this Product, e.g. "Bitbucket Support" */
    supportTitle?: Maybe<Scalars["String"]["output"]>;
    /** Internal title of this Product. For public-facing title, use productName */
    title: Scalars["String"]["output"];
    /** A url slug for this Product. Used primarily for SAC */
    url?: Maybe<Scalars["String"]["output"]>;
    /** Versioning info for this Product */
    version?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformContextProductEntry = {
    __typename?: "ContentPlatformContextProductEntry";
    /**
     * Contentful ID for this Context: Product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contextId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customSupportFormAuthenticated?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customSupportFormUnauthenticated?: Maybe<Scalars["String"]["output"]>;
    /**
     * What platform this Product is for. Cloud, Server, or N/A
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deployment: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<ContentPlatformImageAssetEntry>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    preventProdPublishing?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    productBlurb?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    productName: Scalars["String"]["output"];
    /**
     * The full support title of this Product, e.g. "Bitbucket Support"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    supportTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     * Internal title of this Product. For public-facing title, use productName
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * A url slug for this Product. Used primarily for SAC
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
    /**
     * Versioning info for this Product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformContextTheme = {
    __typename?: "ContentPlatformContextTheme";
    /** Contentful ID for this Context: Theme */
    contextId: Scalars["String"]["output"];
    /** Public-facing title for this Theme */
    hubName: Scalars["String"]["output"];
    icon?: Maybe<ContentPlatformImageAsset>;
    preventProdPublishing: Scalars["Boolean"]["output"];
    /** Internal title of this Theme. For public-facing title, use hubName */
    title: Scalars["String"]["output"];
    /** A url slug for this Theme. Used primarily for SAC */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformCustomerStory = {
    __typename?: "ContentPlatformCustomerStory";
    /** Advocate Quote for Customer Story */
    advocateQuotes?: Maybe<Array<ContentPlatformAdvocateQuote>>;
    /** Call to action */
    callToAction?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Company of the Customer Story */
    customerCompany?: Maybe<ContentPlatformOrganization>;
    /** ID for this Customer Story */
    customerStoryId: Scalars["String"]["output"];
    /** Asset in Hero */
    heroAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Location of product users */
    location?: Maybe<Scalars["String"]["output"]>;
    /** Referenced Marketplace apps */
    marketplaceApps?: Maybe<Array<ContentPlatformMarketplaceApp>>;
    /** Number of product users */
    numberOfUsers?: Maybe<Scalars["String"]["output"]>;
    /** Referenced Atlassian products */
    products?: Maybe<Array<ContentPlatformProduct>>;
    /** List of related Customer Stories */
    relatedCustomerStories?: Maybe<Array<ContentPlatformCustomerStory>>;
    /** Related PDF */
    relatedPdf?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Related Video */
    relatedVideo?: Maybe<Scalars["String"]["output"]>;
    /** Short title for Customer Story */
    shortTitle?: Maybe<Scalars["String"]["output"]>;
    /** Solutions */
    solution?: Maybe<Array<ContentPlatformSolution>>;
    /** Company of solution partner */
    solutionPartners?: Maybe<Array<ContentPlatformOrganization>>;
    /** Stat for Customer Story */
    stats?: Maybe<Array<ContentPlatformStat>>;
    /** Story container */
    story?: Maybe<Array<ContentPlatformStoryComponent>>;
    /** Description of the story */
    storyDescription?: Maybe<Scalars["String"]["output"]>;
    /** Icon for Customer Story */
    storyIcon?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Subtitle for Customer Story */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for Customer Story */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** URL slug for this Customer Story */
    urlSlug?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformCustomerStoryResultEdge = {
    __typename?: "ContentPlatformCustomerStoryResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformCustomerStory;
};

export type ContentPlatformCustomerStorySearchConnection = {
    __typename?: "ContentPlatformCustomerStorySearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformCustomerStoryResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformDateCondition = {
    /**
     * Determines which date field to compare this operation to. One of:
     * * "createdAt"
     * * "publishDate"
     * * "updatedAt"
     * * "featureRolloutDate"
     * * "featureRolloutEndDate"
     */
    dateFieldNamed?: Scalars["String"]["input"];
    /** An ISO date string that is used to filter items before or after a given date */
    havingDate: Scalars["DateTime"]["input"];
};

export type ContentPlatformDateRangeFilter = {
    /** An ISO date string that is used to filter items after given date */
    after: Scalars["DateTime"]["input"];
    /** An ISO date string that is used to filter items before given date */
    before: Scalars["DateTime"]["input"];
};

export type ContentPlatformEmbeddedVideoAsset = {
    __typename?: "ContentPlatformEmbeddedVideoAsset";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Embed Asset Overlay */
    embedAssetOverlay?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Embedded Link */
    embedded?: Maybe<Scalars["String"]["output"]>;
    /** Embedded Video Asset Name */
    embeddedVideoAssetName?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformFeature = {
    __typename?: "ContentPlatformFeature";
    callOut?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    featureAdditionalInformation?: Maybe<
        Array<ContentPlatformFeatureAdditionalInformation>
    >;
    featureNameExternal?: Maybe<Scalars["String"]["output"]>;
    product?: Maybe<Array<ContentPlatformPricingProductName>>;
    relevantPlan?: Maybe<Array<ContentPlatformPlan>>;
    relevantUrl?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformFeatureAdditionalInformation = {
    __typename?: "ContentPlatformFeatureAdditionalInformation";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    featureAdditionalInformation?: Maybe<Scalars["String"]["output"]>;
    relevantPlan?: Maybe<Array<ContentPlatformPlan>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformFeatureGroup = {
    __typename?: "ContentPlatformFeatureGroup";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    featureGroupOneLiner?: Maybe<Scalars["String"]["output"]>;
    featureGroupTitleExternal?: Maybe<Scalars["String"]["output"]>;
    features?: Maybe<Array<ContentPlatformFeature>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformFeaturedVideo = {
    __typename?: "ContentPlatformFeaturedVideo";
    /** Call to action text */
    callToActionText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Video description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Video link */
    link?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** Featured video name */
    videoName?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformField = {
    /** Name of field to be searched. One of TITLE or DESCRIPTION */
    field: ContentPlatformFieldNames;
};

export enum ContentPlatformFieldNames {
    Description = "DESCRIPTION",
    Title = "TITLE"
}

export type ContentPlatformFieldType = {
    __typename?: "ContentPlatformFieldType";
    /**
     * Name of field to be searched. One of TITLE or DESCRIPTION
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    field: ContentPlatformFieldNames;
};

export type ContentPlatformFullHubArticle = {
    __typename?: "ContentPlatformFullHubArticle";
    /** Article introduction */
    articleIntroduction?: Maybe<Array<ContentPlatformArticleIntroduction>>;
    /** Article Reference */
    articleRef?: Maybe<ContentPlatformHubArticle>;
    /** Article Summary */
    articleSummary?: Maybe<Scalars["String"]["output"]>;
    /** Author */
    author?: Maybe<ContentPlatformAuthor>;
    /** Body text container */
    bodyTextContainer?: Maybe<Array<ContentPlatformSupportingConceptWrapper>>;
    /** Content Hub Subscribe */
    contentHubSubscribe?: Maybe<Array<ContentPlatformSubscribeComponent>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Next best action */
    nextBestAction?: Maybe<Array<ContentPlatformHubArticleAndTutorialUnion>>;
    /** Product Discussed CTA */
    productDiscussedCta?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Related Hub for Hub Article */
    relatedHub?: Maybe<Array<ContentPlatformTaxonomyContentHub>>;
    /** Related Product Features */
    relatedProductFeatures?: Maybe<Array<ContentPlatformTaxonomyFeature>>;
    /** Related tutorial CTA */
    relatedTutorialCta?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Share this article */
    shareThisArticle?: Maybe<Array<ContentPlatformSocialMediaLink>>;
    /** Article Subtitle */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** Up next */
    upNext?: Maybe<ContentPlatformHubArticleAndTutorialAndTopicOverviewUnion>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** White Paper CTA */
    whitePaperCta?: Maybe<Array<ContentPlatformCallToAction>>;
};

export type ContentPlatformFullTutorial = {
    __typename?: "ContentPlatformFullTutorial";
    /** Tutorial author */
    author?: Maybe<ContentPlatformAuthor>;
    /** Before you begin component */
    beforeYouBegin?: Maybe<Array<ContentPlatformBeforeYouBeginComponent>>;
    /** Content Hub Subscribe */
    contentHubSubscribe?: Maybe<Array<ContentPlatformSubscribeComponent>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Next Best Action */
    nextBestAction?: Maybe<Array<ContentPlatformHubArticleAndTutorialUnion>>;
    /** Product Discussed CTA */
    productDiscussedCta?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Related Hub */
    relatedHub?: Maybe<Array<ContentPlatformTaxonomyContentHub>>;
    /** Related Product Features */
    relatedProductFeatures?: Maybe<Array<ContentPlatformTaxonomyFeature>>;
    /** Related Template CTA */
    relatedTemplateCta?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Share This Tutorial */
    shareThisTutorial?: Maybe<Array<ContentPlatformSocialMediaLink>>;
    /** Tutorial subtitle */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial instructions */
    tutorialInstructions?: Maybe<
        Array<ContentPlatformTutorialInstructionsWrapper>
    >;
    /** Tutorial introduction */
    tutorialIntroduction?: Maybe<Array<ContentPlatformTutorialIntroduction>>;
    /** Reference to the core tutorial content */
    tutorialRef: ContentPlatformTutorial;
    /** Tutorial summary */
    tutorialSummary?: Maybe<Scalars["String"]["output"]>;
    /** Up Next */
    upNext?: Maybe<ContentPlatformHubArticleAndTutorialAndTopicOverviewUnion>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** White Paper CTA */
    whitePaperCta?: Maybe<Array<ContentPlatformCallToAction>>;
};

export type ContentPlatformHighlightedFeature = {
    __typename?: "ContentPlatformHighlightedFeature";
    callOut?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    highlightedFeatureDetails?: Maybe<Scalars["String"]["output"]>;
    highlightedFeatureTitleExternal?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformHubArticle = {
    __typename?: "ContentPlatformHubArticle";
    /** Article banner */
    articleBanner?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Article name */
    articleName?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Article title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** url Slug for HubArticle */
    urlSlug: Scalars["String"]["output"];
};

export type ContentPlatformHubArticleAndTutorialAndProductFeatureAndFeaturedVideoUnion =

        | ContentPlatformFeaturedVideo
        | ContentPlatformHubArticle
        | ContentPlatformProductFeature
        | ContentPlatformTutorial;

export type ContentPlatformHubArticleAndTutorialAndTopicOverviewUnion =
    | ContentPlatformHubArticle
    | ContentPlatformTopicOverview
    | ContentPlatformTutorial;

export type ContentPlatformHubArticleAndTutorialUnion =
    | ContentPlatformHubArticle
    | ContentPlatformTutorial;

export type ContentPlatformHubArticleResultEdge = {
    __typename?: "ContentPlatformHubArticleResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformFullHubArticle;
};

export type ContentPlatformHubArticleSearchConnection = {
    __typename?: "ContentPlatformHubArticleSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformHubArticleResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformImageAsset = {
    __typename?: "ContentPlatformImageAsset";
    /** The MIME type of the image */
    contentType: Scalars["String"]["output"];
    description?: Maybe<Scalars["String"]["output"]>;
    /** Additional information about the image */
    details: Scalars["JSON"]["output"];
    fileName: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    /** The CDN-hosted URL for the Image */
    url: Scalars["String"]["output"];
};

export type ContentPlatformImageAssetEntry = {
    __typename?: "ContentPlatformImageAssetEntry";
    /**
     * The MIME type of the image
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentType: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * Additional information about the image
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    details: Scalars["JSON"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fileName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The CDN-hosted URL for the Image
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type ContentPlatformImageComponent = {
    __typename?: "ContentPlatformImageComponent";
    altTag: Scalars["String"]["output"];
    /** What contexts this Image Component is used for */
    contextReference: Array<ContentPlatformAnyContext>;
    image: ContentPlatformImageAsset;
    name: Scalars["String"]["output"];
};

export type ContentPlatformIpmAnchored = {
    __typename?: "ContentPlatformIpmAnchored";
    anchoredElement?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Anchor */
    id: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmAnchoredAndIpmPositionUnion =
    | ContentPlatformIpmAnchored
    | ContentPlatformIpmPosition;

export type ContentPlatformIpmCompImage = {
    __typename?: "ContentPlatformIpmCompImage";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Image Component */
    id: Scalars["String"]["output"];
    image?: Maybe<Scalars["JSON"]["output"]>;
    imageAltText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmCompImageAndIpmComponentEmbeddedVideoUnion =
    | ContentPlatformIpmCompImage
    | ContentPlatformIpmComponentEmbeddedVideo;

export type ContentPlatformIpmComponentBackButton = {
    __typename?: "ContentPlatformIpmComponentBackButton";
    buttonAltText?: Maybe<Scalars["String"]["output"]>;
    buttonText: Scalars["String"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmComponentEmbeddedVideo = {
    __typename?: "ContentPlatformIpmComponentEmbeddedVideo";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Embedded Video Component */
    id: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    videoAltText?: Maybe<Scalars["String"]["output"]>;
    videoProvider?: Maybe<Scalars["String"]["output"]>;
    videoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmComponentEmbeddedVideoAndIpmCompImageUnion =
    | ContentPlatformIpmCompImage
    | ContentPlatformIpmComponentEmbeddedVideo;

export type ContentPlatformIpmComponentGsacButton = {
    __typename?: "ContentPlatformIpmComponentGsacButton";
    buttonAltText?: Maybe<Scalars["String"]["output"]>;
    buttonText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this GSAC Button */
    id: Scalars["String"]["output"];
    requestTypeId?: Maybe<Scalars["String"]["output"]>;
    serviceDeskId?: Maybe<Scalars["String"]["output"]>;
    ticketSummary?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmComponentGsacButtonAndIpmComponentLinkButtonUnion =

        | ContentPlatformIpmComponentGsacButton
        | ContentPlatformIpmComponentLinkButton;

export type ContentPlatformIpmComponentGsacButtonAndIpmComponentRemindMeLaterUnion =

        | ContentPlatformIpmComponentGsacButton
        | ContentPlatformIpmComponentRemindMeLater;

export type ContentPlatformIpmComponentLinkButton = {
    __typename?: "ContentPlatformIpmComponentLinkButton";
    buttonAltText?: Maybe<Scalars["String"]["output"]>;
    buttonText?: Maybe<Scalars["String"]["output"]>;
    buttonUrl?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Link Button */
    id: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmComponentLinkButtonAndIpmComponentGsacButtonUnion =

        | ContentPlatformIpmComponentGsacButton
        | ContentPlatformIpmComponentLinkButton;

export type ContentPlatformIpmComponentNextButton = {
    __typename?: "ContentPlatformIpmComponentNextButton";
    buttonAltText?: Maybe<Scalars["String"]["output"]>;
    buttonText: Scalars["String"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmComponentRemindMeLater = {
    __typename?: "ContentPlatformIpmComponentRemindMeLater";
    buttonAltText?: Maybe<Scalars["String"]["output"]>;
    buttonSnoozeDays: Scalars["Int"]["output"];
    buttonText: Scalars["String"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmFlag = {
    __typename?: "ContentPlatformIpmFlag";
    body?: Maybe<Scalars["JSON"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    featuredDigitalAsset?: Maybe<ContentPlatformIpmComponentEmbeddedVideoAndIpmCompImageUnion>;
    /** ID for this IPM Flag */
    id: Scalars["String"]["output"];
    ipmNumber?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<ContentPlatformIpmPositionAndIpmAnchoredUnion>;
    primaryButton?: Maybe<ContentPlatformIpmComponentGsacButtonAndIpmComponentLinkButtonUnion>;
    secondaryButton?: Maybe<ContentPlatformIpmComponentGsacButtonAndIpmComponentRemindMeLaterUnion>;
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    variant?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmFlagResultEdge = {
    __typename?: "ContentPlatformIpmFlagResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformIpmFlag;
};

export type ContentPlatformIpmFlagSearchConnection = {
    __typename?: "ContentPlatformIpmFlagSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformIpmFlagResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformIpmImageModal = {
    __typename?: "ContentPlatformIpmImageModal";
    /** Body text for this IPM */
    body?: Maybe<Scalars["JSON"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** CTA Button Text */
    ctaButtonText?: Maybe<Scalars["String"]["output"]>;
    /** CTA Button Link */
    ctaButtonUrl?: Maybe<Scalars["String"]["output"]>;
    /** ID for this IPM */
    id: Scalars["String"]["output"];
    /** Brandfolder Image for this IPM */
    image?: Maybe<Scalars["JSON"]["output"]>;
    /** IPM ticket number */
    ipmNumber: Scalars["String"]["output"];
    /** Title for IPM */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** Variant for the given IPM */
    variant?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmImageModalResultEdge = {
    __typename?: "ContentPlatformIpmImageModalResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformIpmImageModal;
};

export type ContentPlatformIpmImageModalSearchConnection = {
    __typename?: "ContentPlatformIpmImageModalSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformIpmImageModalResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformIpmInlineDialog = {
    __typename?: "ContentPlatformIpmInlineDialog";
    anchored: ContentPlatformIpmAnchored;
    body: Scalars["JSON"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    featuredImage?: Maybe<ContentPlatformIpmCompImage>;
    id: Scalars["String"]["output"];
    ipmNumber: Scalars["String"]["output"];
    primaryButton: ContentPlatformIpmComponentLinkButtonAndIpmComponentGsacButtonUnion;
    secondaryButton?: Maybe<ContentPlatformIpmComponentRemindMeLater>;
    title: Scalars["String"]["output"];
    trigger: ContentPlatformIpmTrigger;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    variant: Scalars["String"]["output"];
};

export type ContentPlatformIpmInlineDialogResultEdge = {
    __typename?: "ContentPlatformIpmInlineDialogResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformIpmInlineDialog;
};

export type ContentPlatformIpmInlineDialogSearchConnection = {
    __typename?: "ContentPlatformIpmInlineDialogSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformIpmInlineDialogResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformIpmMultiStep = {
    __typename?: "ContentPlatformIpmMultiStep";
    body: Scalars["JSON"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    featuredDigitalAsset?: Maybe<ContentPlatformIpmCompImageAndIpmComponentEmbeddedVideoUnion>;
    id: Scalars["String"]["output"];
    ipmNumber: Scalars["String"]["output"];
    location?: Maybe<ContentPlatformIpmAnchoredAndIpmPositionUnion>;
    primaryButton: ContentPlatformIpmComponentNextButton;
    secondaryButton?: Maybe<ContentPlatformIpmComponentRemindMeLater>;
    steps: Array<ContentPlatformIpmSingleStep>;
    title: Scalars["String"]["output"];
    trigger?: Maybe<ContentPlatformIpmTrigger>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    variant: Scalars["String"]["output"];
};

export type ContentPlatformIpmMultiStepResultEdge = {
    __typename?: "ContentPlatformIpmMultiStepResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformIpmMultiStep;
};

export type ContentPlatformIpmMultiStepSearchConnection = {
    __typename?: "ContentPlatformIpmMultiStepSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformIpmMultiStepResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformIpmPosition = {
    __typename?: "ContentPlatformIpmPosition";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this IPM Positioning */
    id: Scalars["String"]["output"];
    positionOnPage?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmPositionAndIpmAnchoredUnion =
    | ContentPlatformIpmAnchored
    | ContentPlatformIpmPosition;

export type ContentPlatformIpmSingleStep = {
    __typename?: "ContentPlatformIpmSingleStep";
    anchored?: Maybe<ContentPlatformIpmAnchored>;
    body: Scalars["JSON"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    featuredDigitalAsset?: Maybe<ContentPlatformIpmCompImageAndIpmComponentEmbeddedVideoUnion>;
    id: Scalars["String"]["output"];
    primaryButton: ContentPlatformIpmComponentNextButton;
    secondaryButton?: Maybe<ContentPlatformIpmComponentBackButton>;
    title: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformIpmTrigger = {
    __typename?: "ContentPlatformIpmTrigger";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    triggeringElementId: Scalars["String"]["output"];
    triggeringEvent?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformMarketplaceApp = {
    __typename?: "ContentPlatformMarketplaceApp";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<ContentPlatformTemplateImageAsset>;
    /** App name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** URL path to product homepage */
    url: Scalars["String"]["output"];
};

export enum ContentPlatformOperators {
    All = "ALL",
    Any = "ANY"
}

export type ContentPlatformOrganization = {
    __typename?: "ContentPlatformOrganization";
    /** Darker Logo for this Organization */
    altDarkLogo?: Maybe<Array<ContentPlatformTemplateImageAsset>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Industry to which this Organization belongs */
    industry?: Maybe<Array<ContentPlatformTaxonomyIndustry>>;
    /** Logo for this Organization */
    logo?: Maybe<Array<ContentPlatformTemplateImageAsset>>;
    /** Public-facing name for this Organization */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Company Size category */
    organizationSize?: Maybe<ContentPlatformTaxonomyCompanySize>;
    /** Region to which this Organization belongs */
    region?: Maybe<ContentPlatformTaxonomyRegion>;
    /** Brief description about the Organization */
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Tagline for this Organization */
    tagline?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformOrganizationAndAuthorUnion =
    | ContentPlatformAuthor
    | ContentPlatformOrganization;

export type ContentPlatformPlan = {
    __typename?: "ContentPlatformPlan";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    errors?: Maybe<Array<ContentPlatformPricingErrors>>;
    highlightedFeaturesContainer?: Maybe<
        Array<ContentPlatformHighlightedFeature>
    >;
    highlightedFeaturesTitle?: Maybe<Scalars["String"]["output"]>;
    microCta?: Maybe<
        Array<ContentPlatformCallToActionAndCallToActionMicrocopyUnion>
    >;
    planOneLiner?: Maybe<Scalars["String"]["output"]>;
    planTitleExternal?: Maybe<Scalars["String"]["output"]>;
    relatedProduct?: Maybe<Array<ContentPlatformPricingProductName>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformPlanBenefits = {
    __typename?: "ContentPlatformPlanBenefits";
    /** Topic for this Anchor Plan Benefits entry */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Benefits richtext for this Anchor Plan Benefits entry */
    description?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Anchor Plan Benefits entry */
    id: Scalars["String"]["output"];
    /** Title for this Anchor Plan Benefits entry */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Persona for this Anchor Plan Benefits entry */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Plan for this Anchor Plan Benefits entry */
    plan?: Maybe<ContentPlatformTaxonomyPlan>;
    /** Plan Features for this Anchor */
    planFeatures?: Maybe<Array<ContentPlatformTaxonomyFeature>>;
    /** Product for this Anchor Plan Benefits entry */
    product?: Maybe<ContentPlatformProduct>;
    /** Supporting Image Asset for this Anchor Plan Benefits entry */
    supportingAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformPlanDetails = {
    __typename?: "ContentPlatformPlanDetails";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    planAdditionalDetails?: Maybe<Scalars["String"]["output"]>;
    planAdditionalDetailsTitleExternal?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformPricing = {
    __typename?: "ContentPlatformPricing";
    additionalDetails?: Maybe<Array<ContentPlatformPlanDetails>>;
    callToActionContainer?: Maybe<
        Array<ContentPlatformCallToActionAndCallToActionMicrocopyUnion>
    >;
    compareFeatures?: Maybe<Array<ContentPlatformFeatureGroup>>;
    compareFeaturesTitle?: Maybe<Scalars["String"]["output"]>;
    comparePlans?: Maybe<Array<ContentPlatformPlan>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    datacenterPlans?: Maybe<Array<ContentPlatformPlan>>;
    getMoreDetailsTitle?: Maybe<Scalars["String"]["output"]>;
    headline?: Maybe<Scalars["String"]["output"]>;
    pageDescription?: Maybe<Scalars["String"]["output"]>;
    pricingTitleExternal?: Maybe<Scalars["String"]["output"]>;
    pricingTitleInternal: Scalars["String"]["output"];
    relatedProduct?: Maybe<Array<ContentPlatformPricingProductName>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformPricingErrors = {
    __typename?: "ContentPlatformPricingErrors";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    errorText?: Maybe<Scalars["String"]["output"]>;
    errorTrigger?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformPricingProductName = {
    __typename?: "ContentPlatformPricingProductName";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    productName: Scalars["String"]["output"];
    productNameId: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformPricingResultEdge = {
    __typename?: "ContentPlatformPricingResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformPricing;
};

export type ContentPlatformPricingSearchConnection = {
    __typename?: "ContentPlatformPricingSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformPricingResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformProTipComponent = {
    __typename?: "ContentPlatformProTipComponent";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Pro tip name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Pro tip rich text */
    proTipRichText?: Maybe<Scalars["String"]["output"]>;
    /** Pro tip text */
    proTipText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformProduct = {
    __typename?: "ContentPlatformProduct";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Deployment description */
    deployment?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Product name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Brief product description */
    productBlurb?: Maybe<Scalars["String"]["output"]>;
    /** Product Name ID */
    productNameId?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** URL path to product homepage */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformProductFeature = {
    __typename?: "ContentPlatformProductFeature";
    /** Call to action */
    callToAction?: Maybe<Array<ContentPlatformCallToAction>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Feature name */
    featureName?: Maybe<Scalars["String"]["output"]>;
    /** Slogan */
    slogan?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformQuestionComponent = {
    __typename?: "ContentPlatformQuestionComponent";
    /** Answer */
    answer?: Maybe<Scalars["String"]["output"]>;
    /** Answer Asset */
    answerAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Question title */
    questionTitle?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformReleaseNote = {
    __typename?: "ContentPlatformReleaseNote";
    /**
     * References to the affected users
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    affectedUsers?: Maybe<Array<ContentPlatformTaxonomyUserRole>>;
    /**
     * Announcement Plan, one of
     *   * "Show when launching"
     *   * "Hide"
     *   * "Always show"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    announcementPlan?: Maybe<ContentPlatformTaxonomyAnnouncementPlan>;
    /**
     * Benefits list
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    benefitsList?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * Category of the change, one of
     *   * "C1" (Sunsetting a product)
     *   * "C2" (Widespread change requiring high customer effort)
     *   * "C3" (Localised change requiring high customer/ecosystem effort)
     *   * "C4" (Change requiring low customer ecosystem effort)
     *   * "C5" (Change requiring no customer/ecosystem effort)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    changeCategory?: Maybe<ContentPlatformTaxonomyChangeCategory>;
    /**
     * Change status, one of
     *   * "Coming soon"
     *   * "Generally available"
     *   * "Planned"
     *   * "Rolled back"
     *   * "Rolling out"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    changeStatus?: Maybe<ContentPlatformStatusOfChange>;
    /**
     * When the change is expected to happen
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    changeTargetSchedule?: Maybe<Scalars["String"]["output"]>;
    /**
     * A reference to the change type. One of
     *   * "Experiment"
     *   * "Improvement"
     *   * "Removed"
     *   * "Announcement"
     *   * "Fix"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    changeType?: Maybe<ContentPlatformTypeOfChange>;
    /**
     * Date and time the Release Note was created
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /**
     * Short description
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The related Feature Delivery Jira Issue Key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fdIssueKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * The related Feature Delivery Jira Ticket URL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fdIssueLink?: Maybe<Scalars["String"]["output"]>;
    /**
     * Feature rollout date
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featureRolloutDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * Feature rollout end date
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featureRolloutEndDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * A reference to the featured image
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featuredImage?: Maybe<ContentPlatformImageComponent>;
    /**
     * FedRAMP production release date
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fedRAMPProductionReleaseDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * FedRAMP staging release date
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fedRAMPStagingReleaseDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * Information on how to get started with this release
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    getStarted?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * An ADF document of the key change(s) being made
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    keyChanges?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * A Rich Text document of how users can prepare for this change
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    prepareForChange?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * Publish status of the Release Note, one of
     *   * "Published"
     *   * "Changed"
     *   * "Draft"
     *   * "Archived"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publishStatus?: Maybe<Scalars["String"]["output"]>;
    /**
     * A Rich Text document of the reason for the changes
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reasonForChange?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * References to related Contentful entries
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatedContentLinks?: Maybe<Array<Scalars["String"]["output"]>>;
    /**
     * References to the products and apps this change affects
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatedContexts?: Maybe<Array<ContentPlatformAnyContext>>;
    /**
     * Feature flag
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    releaseNoteFlag?: Maybe<Scalars["String"]["output"]>;
    /**
     * Environment associated with feature flag
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    releaseNoteFlagEnvironment?: Maybe<Scalars["String"]["output"]>;
    /**
     * Feature flag off value
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    releaseNoteFlagOffValue?: Maybe<Scalars["String"]["output"]>;
    /**
     * LaunchDarkly project associated with feature flag
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    releaseNoteFlagProject?: Maybe<Scalars["String"]["output"]>;
    /**
     * ID of the Release Note
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    releaseNoteId: Scalars["String"]["output"];
    /**
     * A list of references to additional imagery
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    supportingVisuals?: Maybe<Array<ContentPlatformImageComponent>>;
    /**
     * The title of the Release Note
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * Date and time of the most recently published update to a Release Note
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /**
     * dash-deliminated version of the title using only lowercase letters and excluding punctuation (ex. A Release Note titled: "Test: Release Note" has url "test-release-note")
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
    /**
     * References to the users needing informed
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    usersNeedingInformed?: Maybe<Array<ContentPlatformTaxonomyUserRole>>;
    /**
     * Is visible in FedRAMP
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    visibleInFedRAMP: Scalars["Boolean"]["output"];
};

export type ContentPlatformReleaseNoteContentSearchConnection = {
    __typename?: "ContentPlatformReleaseNoteContentSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformReleaseNoteResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformReleaseNoteFilterOptions = {
    /**
     * A list of change statuses on which to match release notes. Options:
     *   * "Coming soon"
     *   * "Generally available"
     *   * "Planned"
     *   * "Rolled back"
     *   * "Rolling out"
     */
    changeStatus?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * A list of Change Types on which to match release notes. Options:
     *   * "Experiment"
     *   * "Improvement"
     *   * "Removed"
     *   * "Announcement"
     *   * "Fix"
     */
    changeTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The Contentful ID of a product on which to match release notes */
    contextId?: InputMaybe<Scalars["String"]["input"]>;
    /** A list of Feature Delivery Jira issue keys on which to match release notes */
    fdIssueKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A list of Feature Delivery Jira ticket urls on which to match release notes */
    fdIssueLinks?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** This field will be removed in the next version of the service. Please use the `featureFlagEnvironment` filter at the parent level. */
    featureFlagEnvironment?: InputMaybe<Scalars["String"]["input"]>;
    /** This field will be removed in the next version of the service. Please use the `featureFlagProject` filter at the parent level. */
    featureFlagProject?: InputMaybe<Scalars["String"]["input"]>;
    /** Rollout dates on which to match release notes */
    featureRolloutDates?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** JSON passed in as a query variable corresponding to product feature flags defined in LaunchDarkly. The API will filter Release Notes based on the feature flag OFF value. */
    productFeatureFlags?: InputMaybe<Scalars["JSON"]["input"]>;
    /**
     * A list of product/app names on which to match release notes. Options:
     *   * "Advanced Roadmaps for Jira"
     *   * "Atlas"
     *   * "Atlassian Analytics"
     *   * "Atlassian Cloud"
     *   * "Bitbucket"
     *   * "Compass"
     *   * "Confluence"
     *   * "Halp"
     *   * "Jira Align"
     *   * "Jira Product Discovery"
     *   * "Jira Service Management"
     *   * "Jira Software"
     *   * "Jira Work Management"
     *   * "Opsgenie"
     *   * "Questions for Confluence"
     *   * "Statuspage"
     *   * "Team Calendars for Confluence"
     *   * "Trello"
     *   * "Cloud automation"
     *   * "Jira cloud app for Android"
     *   * "Jira cloud app for iOS"
     *   * "Jira cloud app for macOS"
     *   * "Opsgenie app for Android"
     *   * "Opsgenie app for BlackBerry Dynamics"
     *   * "Opsgenie app for iOS"
     */
    productNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A list of feature flag off values on which to match release notes */
    releaseNoteFlagOffValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A list of feature flags on which to match release notes */
    releaseNoteFlags?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A date range where you can filter release notes within a specific date range on the updatedAt field */
    updatedAt?: InputMaybe<ContentPlatformDateRangeFilter>;
};

export type ContentPlatformReleaseNoteResultEdge = {
    __typename?: "ContentPlatformReleaseNoteResultEdge";
    /**
     * Used in `before` and `after` args
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node: ContentPlatformReleaseNote;
};

export type ContentPlatformReleaseNotesConnection = {
    __typename?: "ContentPlatformReleaseNotesConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformReleaseNotesEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformReleaseNotesEdge = {
    __typename?: "ContentPlatformReleaseNotesEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformReleaseNote;
};

export type ContentPlatformSearchApIv2Query = {
    /** Queries to be sent to the search API */
    queries: Array<ContentPlatformContentQueryInput>;
};

export type ContentPlatformSearchOptions = {
    /** Boolean AND/OR for combining search queries in the query list */
    operator?: InputMaybe<ContentPlatformBooleanOperators>;
    /** Search query defining the search type, terms, term operators, fields, and field operators */
    queries: Array<ContentPlatformSearchQuery>;
};

export type ContentPlatformSearchQuery = {
    /** One of ANY or ALL. Defines whether search needs to match any of the fields queried (boolean OR) or of all of them (boolean AND) */
    fieldOperator?: InputMaybe<ContentPlatformOperators>;
    /** Fields to be searched */
    fields?: InputMaybe<Array<ContentPlatformField>>;
    /** Type of search to be executed. One of CONTAINS or EXACT_MATCH */
    searchType: ContentPlatformSearchTypes;
    /** One of ANY or ALL. Defines whether search needs to match any of the terms queried (boolean OR) or of all of them (boolean AND) */
    termOperator?: InputMaybe<ContentPlatformOperators>;
    /** The terms to be searched within fields of the Release Notes */
    terms: Array<Scalars["String"]["input"]>;
};

export type ContentPlatformSearchQueryType = {
    __typename?: "ContentPlatformSearchQueryType";
    /**
     * One of ANY or ALL. Defines whether search needs to match any of the fields queried (boolean OR) or of all of them (boolean AND)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fieldOperator?: Maybe<ContentPlatformOperators>;
    /**
     * Fields to be searched
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fields?: Maybe<Array<ContentPlatformFieldType>>;
    /**
     * Type of search to be executed. One of CONTAINS or EXACT_MATCH
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    searchType: ContentPlatformSearchTypes;
    /**
     * One of ANY or ALL. Defines whether search needs to match any of the terms queried (boolean OR) or of all of them (boolean AND)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    termOperator?: Maybe<ContentPlatformOperators>;
    /**
     * The terms to be searched within fields of the Release Notes
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    terms: Array<Scalars["String"]["output"]>;
};

export type ContentPlatformSearchTextClause = {
    /** Logical AND operator that expects all expressions within operator to be true */
    and?: InputMaybe<Array<ContentPlatformSearchTextClause>>;
    /** Object used to search text using fuzzy matching */
    exactlyMatching?: InputMaybe<ContentPlatformSearchTextMatchingClause>;
    /** Logical OR operator that expects at least one expression within operator to be true */
    or?: InputMaybe<Array<ContentPlatformSearchTextClause>>;
    /** Object used to search text using exact matching */
    partiallyMatching?: InputMaybe<ContentPlatformSearchTextMatchingClause>;
};

export type ContentPlatformSearchTextMatchingClause = {
    /** Logical AND operator that expects all expressions within operator to be true */
    and?: InputMaybe<Array<ContentPlatformSearchTextMatchingClause>>;
    /** Field name selector */
    fieldNamed?: InputMaybe<Scalars["String"]["input"]>;
    /** Values selector */
    havingValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Values selector */
    matchingAllValues?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Logical OR operator that expects at least one expression within operator to be true */
    or?: InputMaybe<Array<ContentPlatformSearchTextMatchingClause>>;
};

export enum ContentPlatformSearchTypes {
    Contains = "CONTAINS",
    ExactMatch = "EXACT_MATCH"
}

export type ContentPlatformSocialMediaChannel = {
    __typename?: "ContentPlatformSocialMediaChannel";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Logo */
    logo?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Social Media Channel */
    socialMediaChannel?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformSocialMediaLink = {
    __typename?: "ContentPlatformSocialMediaLink";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Social Media Channel */
    socialMediaChannel?: Maybe<ContentPlatformSocialMediaChannel>;
    /** Social Media Handle */
    socialMediaHandle?: Maybe<Scalars["String"]["output"]>;
    /** Social Media URL */
    socialMediaUrl?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformSolution = {
    __typename?: "ContentPlatformSolution";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Solution */
    id: Scalars["String"]["output"];
    /** Solution name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Short Description */
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformSortClause = {
    /**
     * This is how the data returned will be sorted, one of
     * * "relevancy" <- if searchText is used, this is the default, and no other sort order is specified
     * * "createdAt" <- DEFAULT
     * * "updatedAt"
     * * "featureRolloutDate"
     * * "featureRolloutEndDate"
     */
    fieldNamed?: Scalars["String"]["input"];
    /** Options are DESC (DEFAULT) or ASC */
    havingOrder?: Scalars["String"]["input"];
};

export type ContentPlatformStat = {
    __typename?: "ContentPlatformStat";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for this Stat */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The stat */
    stat?: Maybe<Scalars["String"]["output"]>;
    /** Brief description about the Stat */
    statDescription?: Maybe<Scalars["String"]["output"]>;
    /** ID for this stat */
    statId: Scalars["String"]["output"];
    /** Resource for the Stat */
    statResource?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformStatusOfChange = {
    __typename?: "ContentPlatformStatusOfChange";
    /** Short description of the change status */
    description: Scalars["String"]["output"];
    /**
     * Label for the status of the change, one of
     *   * "Coming soon"
     *   * "Generally available"
     *   * "Planned"
     *   * "Rolled back"
     *   * "Rolling out"
     */
    label: Scalars["String"]["output"];
};

export type ContentPlatformStoryComponent = {
    __typename?: "ContentPlatformStoryComponent";
    /** Asset in body */
    bodyAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Caption for asset in body */
    bodyAssetCaption?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Video Link */
    embeddedVideoLink?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for this Quote */
    quote?: Maybe<ContentPlatformAdvocateQuote>;
    /** ID for this Product */
    storyComponentId: Scalars["String"]["output"];
    /** Rich Text for Story */
    storyText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformSubscribeComponent = {
    __typename?: "ContentPlatformSubscribeComponent";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** CTA Button Text */
    ctaButtonText?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial name */
    subscribeComponentName?: Maybe<Scalars["String"]["output"]>;
    /** Success message */
    successMessage?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** Value Proposition */
    valueProposition?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformSupportingConceptWrapper = {
    __typename?: "ContentPlatformSupportingConceptWrapper";
    /** Content components */
    contentComponents?: Maybe<
        Array<ContentPlatformTextComponentAndAssetComponentAndProTipComponentAndTwitterComponentAndEmbeddedVideoAssetAndCallToActionAndCallOutComponentAndQuestionComponentUnion>
    >;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Supporting concept name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformSupportingExample = {
    __typename?: "ContentPlatformSupportingExample";
    /** Advocate quote for this Supporting Example */
    advocateQuote?: Maybe<ContentPlatformAdvocateQuote>;
    /** Anchor Topic for this Supporting Example */
    anchorTopic?: Maybe<Array<ContentPlatformTaxonomyAnchorTopic>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Heading for this Supporting Example */
    heading?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Supporting Example */
    id: Scalars["String"]["output"];
    /** Public-facing name for this Supporting Example */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Persona Value for this Supporting Example */
    persona?: Maybe<Array<ContentPlatformTaxonomyPersona>>;
    /** Related Product for this Supporting Example */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** Proof point for this Supporting Example */
    proofpoint?: Maybe<Scalars["String"]["output"]>;
    /** Supporting asset for this Supporting Example */
    supportingAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyAnchorTopic = {
    __typename?: "ContentPlatformTaxonomyAnchorTopic";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description richtext for this Anchor Topic Taxonomy */
    description?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Anchor Topic Taxonomy */
    id: Scalars["String"]["output"];
    /** Title for this Anchor Topic Taxonomy */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Short description (one-liner) for this Anchor Topic Taxonomy */
    shortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyAnnouncementPlan = {
    __typename?: "ContentPlatformTaxonomyAnnouncementPlan";
    /** Description of the label */
    description: Scalars["String"]["output"];
    /**
     * Announcement plan label, one of
     *   * "Show when launching"
     *   * "Hide"
     *   * "Always show"
     */
    title: Scalars["String"]["output"];
};

export type ContentPlatformTaxonomyAnnouncementPlanEntry = {
    __typename?: "ContentPlatformTaxonomyAnnouncementPlanEntry";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     * Announcement plan label
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
};

export type ContentPlatformTaxonomyChangeCategory = {
    __typename?: "ContentPlatformTaxonomyChangeCategory";
    /**
     * Description of the change category, one of
     *   * "Sunsetting a product"
     *   * "Widespread change requiring high customer effort",
     *   * "Localised change requiring high customer/ecosystem effort",
     *   * "Change requiring low customer/ecosystem effort",
     *   * "Change requiring no customer/ecosystem effort"
     */
    description: Scalars["String"]["output"];
    /** Title of the Change Category, one of "C1", "C2", "C3", "C4", "C5" */
    title: Scalars["String"]["output"];
};

export type ContentPlatformTaxonomyCompanySize = {
    __typename?: "ContentPlatformTaxonomyCompanySize";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Title for this Company Size */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Plaintext description of this Company Size */
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyContentHub = {
    __typename?: "ContentPlatformTaxonomyContentHub";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Content Hub description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Content Hub description */
    shortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    /** contentHubTitleExternal */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyFeature = {
    __typename?: "ContentPlatformTaxonomyFeature";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description richtext for this Feature Taxonomy */
    description?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Feature Taxonomy */
    id: Scalars["String"]["output"];
    /** Title for this Feature Taxonomy */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Short description (one-liner) for this Feature Taxonomy */
    shortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyIndustry = {
    __typename?: "ContentPlatformTaxonomyIndustry";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing title for this Industry */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Plaintext description of this Industry */
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyPersona = {
    __typename?: "ContentPlatformTaxonomyPersona";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Persona */
    id: Scalars["String"]["output"];
    /** Name for this Persona */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Description for this Persona */
    personaDescription?: Maybe<Scalars["String"]["output"]>;
    /** Short Description (one-liner) for this Persona */
    personaShortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyPlan = {
    __typename?: "ContentPlatformTaxonomyPlan";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description richtext for this Plan Taxonomy */
    description?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Plan Taxonomy */
    id: Scalars["String"]["output"];
    /** Title for this Plan Taxonomy */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Short description (one-liner) for this Plan Taxonomy */
    shortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyRegion = {
    __typename?: "ContentPlatformTaxonomyRegion";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing title for this Region */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Plaintext description of this Region */
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyTemplateType = {
    __typename?: "ContentPlatformTaxonomyTemplateType";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["JSON"]["output"]>;
    icon?: Maybe<ContentPlatformTemplateImageAsset>;
    id: Scalars["String"]["output"];
    shortDescriptionOneLiner?: Maybe<Scalars["String"]["output"]>;
    templateTypeName?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTaxonomyUserRole = {
    __typename?: "ContentPlatformTaxonomyUserRole";
    /** Role description */
    description: Scalars["String"]["output"];
    /** Role title */
    title: Scalars["String"]["output"];
};

export type ContentPlatformTaxonomyUserRoleNew = {
    __typename?: "ContentPlatformTaxonomyUserRoleNew";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Plaintext description of this User Role */
    roleDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name of this User Role */
    userRole?: Maybe<Scalars["String"]["output"]>;
    /** Identifier for this User Role */
    userRoleId: Scalars["String"]["output"];
};

export type ContentPlatformTemplate = {
    __typename?: "ContentPlatformTemplate";
    /** Rich Text body about this Template */
    aboutThisTemplate?: Maybe<Scalars["String"]["output"]>;
    /** Category for this Template */
    category?: Maybe<Array<ContentPlatformCategory>>;
    /** Vendor that provides this Template */
    contributor?: Maybe<ContentPlatformOrganizationAndAuthorUnion>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Reference to a guide on how to use this Template */
    howToUseThisTemplate?: Maybe<Array<ContentPlatformTemplateGuide>>;
    /** Key features of this Template */
    keyFeatures?: Maybe<Array<ContentPlatformTaxonomyFeature>>;
    /** Public-facing name for Template */
    name?: Maybe<Scalars["String"]["output"]>;
    /** One-line plaintext description of this Template */
    oneLinerHeadline?: Maybe<Scalars["String"]["output"]>;
    /** Blueprint Plugin Id this Template */
    pluginModuleKey: Scalars["String"]["output"];
    /** Brief blurb about this Template */
    previewBlurb?: Maybe<Scalars["String"]["output"]>;
    /** Applicable Atlassian products */
    product?: Maybe<Array<ContentPlatformProduct>>;
    /** List of related Templates */
    relatedTemplates?: Maybe<Array<ContentPlatformTemplate>>;
    /** Team Functions to which this Template applies */
    targetAudience?: Maybe<Array<ContentPlatformTaxonomyUserRoleNew>>;
    /** Target Company Sizes for this Template */
    targetOrganizationSize?: Maybe<Array<ContentPlatformTaxonomyCompanySize>>;
    /** benefits of this template */
    templateBenefits?: Maybe<Array<ContentPlatformTemplateBenefitContainer>>;
    /** Icon for this Template */
    templateIcon?: Maybe<ContentPlatformTemplateImageAsset>;
    /** ID for this Template */
    templateId: Scalars["String"]["output"];
    /** benefits of this template */
    templateOverview?: Maybe<Array<ContentPlatformTemplateOverview>>;
    /** Preview image of this Template */
    templatePreview?: Maybe<Array<ContentPlatformTemplateImageAsset>>;
    /** benefits of this template */
    templateProductRationale?: Maybe<
        Array<ContentPlatformTemplateProductRationale>
    >;
    /** which Confluence entity is this a template for? */
    templateType?: Maybe<Array<ContentPlatformTaxonomyTemplateType>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** urlSlug for Template */
    urlSlug?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateBenefit = {
    __typename?: "ContentPlatformTemplateBenefit";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateBenefitContainer = {
    __typename?: "ContentPlatformTemplateBenefitContainer";
    benefitsTitle?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    templateBenefitContainer?: Maybe<Array<ContentPlatformTemplateBenefit>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateCollection = {
    __typename?: "ContentPlatformTemplateCollection";
    /** Description of the Collection */
    aboutThisCollection?: Maybe<Scalars["String"]["output"]>;
    /** Header for the About This Collection content */
    aboutThisCollectionHeader?: Maybe<Scalars["String"]["output"]>;
    /** Accompanying Image for the About This Collection content */
    aboutThisCollectionImage?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Icon for this Collection */
    collectionIcon?: Maybe<ContentPlatformTemplateImageAsset>;
    /** ID for this Collection */
    collectionId: Scalars["String"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Guide on how to use this Collection */
    howToUseThisCollection?: Maybe<ContentPlatformTemplateCollectionGuide>;
    /** Public-facing name for Collection */
    name?: Maybe<Scalars["String"]["output"]>;
    /** One-line plaintext description of this Collection */
    oneLinerHeadline?: Maybe<Scalars["String"]["output"]>;
    /** Team Functions to which this Template applies */
    targetAudience?: Maybe<Array<ContentPlatformTaxonomyUserRoleNew>>;
    /** Target Company Sizes for this Template */
    targetOrganizationSize?: Maybe<Array<ContentPlatformTaxonomyCompanySize>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** URL for this Collection */
    urlSlug?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateCollectionContentSearchConnection = {
    __typename?: "ContentPlatformTemplateCollectionContentSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformTemplateCollectionResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformTemplateCollectionGuide = {
    __typename?: "ContentPlatformTemplateCollectionGuide";
    /** Steps for this Collection Guide */
    collectionSteps?: Maybe<Array<ContentPlatformTemplateCollectionStep>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Template Collection Guide */
    id: Scalars["String"]["output"];
    /** Public-facing name for Template Collection Guide */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateCollectionResultEdge = {
    __typename?: "ContentPlatformTemplateCollectionResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformTemplateCollection;
};

export type ContentPlatformTemplateCollectionStep = {
    __typename?: "ContentPlatformTemplateCollectionStep";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** ID for this Template Collection Step */
    id: Scalars["String"]["output"];
    /** Public-facing name for Template Collection Step */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Related Template for this Template Collection Step */
    relatedTemplate?: Maybe<ContentPlatformTemplate>;
    /** Subheading for Template Collection Step */
    stepDescription?: Maybe<Scalars["String"]["output"]>;
    /** Subheading for Template Collection Step */
    stepSubheading?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateContentSearchConnection = {
    __typename?: "ContentPlatformTemplateContentSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformTemplateResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformTemplateGuide = {
    __typename?: "ContentPlatformTemplateGuide";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for this Template Guide */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Steps for this Template Guide */
    steps?: Maybe<Array<ContentPlatformTemplateUseStep>>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateImageAsset = {
    __typename?: "ContentPlatformTemplateImageAsset";
    /** The MIME type of the Image */
    contentType: Scalars["String"]["output"];
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description of the Image */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Additional information about the Image */
    details: Scalars["JSON"]["output"];
    /** File name of the Image */
    fileName: Scalars["String"]["output"];
    /** Title of the Image */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** The CDN-hosted URL for the Image */
    url: Scalars["String"]["output"];
};

export type ContentPlatformTemplateOverview = {
    __typename?: "ContentPlatformTemplateOverview";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    overviewDescription?: Maybe<Scalars["String"]["output"]>;
    overviewTitle?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateProductRationale = {
    __typename?: "ContentPlatformTemplateProductRationale";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    rationaleTitle?: Maybe<Scalars["String"]["output"]>;
    templateProductRationaleDescription?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTemplateResultEdge = {
    __typename?: "ContentPlatformTemplateResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformTemplate;
};

export type ContentPlatformTemplateUseStep = {
    __typename?: "ContentPlatformTemplateUseStep";
    /** Related image for this Template Use Step */
    asset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Body text for this Template Use Step */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Public-facing name for this Template Use Step */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTextComponent = {
    __typename?: "ContentPlatformTextComponent";
    /** Text */
    bodyText?: Maybe<Scalars["String"]["output"]>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Text component name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTextComponentAndAssetComponentAndProTipComponentAndTwitterComponentAndEmbeddedVideoAssetAndCallToActionAndCallOutComponentAndQuestionComponentUnion =

        | ContentPlatformAssetComponent
        | ContentPlatformCallOutComponent
        | ContentPlatformCallToAction
        | ContentPlatformEmbeddedVideoAsset
        | ContentPlatformProTipComponent
        | ContentPlatformQuestionComponent
        | ContentPlatformTextComponent
        | ContentPlatformTwitterComponent;

export type ContentPlatformTopicIntroduction = {
    __typename?: "ContentPlatformTopicIntroduction";
    /** Topic Introduction Asset */
    asset?: Maybe<Array<ContentPlatformTemplateImageAsset>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Topic introduction details */
    details?: Maybe<Scalars["String"]["output"]>;
    /** Embed Link */
    embedLink?: Maybe<Scalars["String"]["output"]>;
    /** Topic introduction title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTopicOverview = {
    __typename?: "ContentPlatformTopicOverview";
    /** Author */
    author?: Maybe<ContentPlatformAuthor>;
    /** Banner Image */
    bannerImage?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Body text container */
    bodyTextContainer?: Maybe<Array<ContentPlatformSupportingConceptWrapper>>;
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Featured Content Container */
    featuredContentContainer?: Maybe<
        Array<ContentPlatformHubArticleAndTutorialAndProductFeatureAndFeaturedVideoUnion>
    >;
    /** Main call to action */
    mainCallToAction?: Maybe<ContentPlatformCallToAction>;
    /** Public-facing name for Topic Overviews */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Next best action */
    nextBestAction?: Maybe<Array<ContentPlatformHubArticleAndTutorialUnion>>;
    /** Related Hub for the Topic Overview */
    relatedHub?: Maybe<Array<ContentPlatformTaxonomyContentHub>>;
    /** Topic Subtitle */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    /** Topic Title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Topic Introduction */
    topicIntroduction?: Maybe<Array<ContentPlatformTopicIntroduction>>;
    /** ID for this Topic Overview */
    topicOverviewId: Scalars["String"]["output"];
    /** Up next */
    upNextFooter?: Maybe<ContentPlatformHubArticle>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** url Slug */
    urlSlug: Scalars["String"]["output"];
};

export type ContentPlatformTopicOverviewContentSearchConnection = {
    __typename?: "ContentPlatformTopicOverviewContentSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformTopicOverviewResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformTopicOverviewResultEdge = {
    __typename?: "ContentPlatformTopicOverviewResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformTopicOverview;
};

export type ContentPlatformTutorial = {
    __typename?: "ContentPlatformTutorial";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial title */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial banner */
    tutorialBanner?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Tutorial name */
    tutorialName?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** url Slug for Tutorial */
    urlSlug: Scalars["String"]["output"];
};

export type ContentPlatformTutorialInstructionsWrapper = {
    __typename?: "ContentPlatformTutorialInstructionsWrapper";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial Instruction steps */
    tutorialInstructionSteps?: Maybe<Array<ContentPlatformTutorialUseStep>>;
    /** Tutorial Instructions title */
    tutorialInstructionsTitle?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTutorialIntroduction = {
    __typename?: "ContentPlatformTutorialIntroduction";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Embed link */
    embedLink?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial introduction asset */
    tutorialIntroductionAsset?: Maybe<ContentPlatformTemplateImageAsset>;
    /** Tutorial introduction details */
    tutorialIntroductionDetails?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial Introduction name */
    tutorialIntroductionName?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTutorialResultEdge = {
    __typename?: "ContentPlatformTutorialResultEdge";
    /** Used in `before` and `after` args */
    cursor: Scalars["String"]["output"];
    node: ContentPlatformFullTutorial;
};

export type ContentPlatformTutorialSearchConnection = {
    __typename?: "ContentPlatformTutorialSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ContentPlatformTutorialResultEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type ContentPlatformTutorialUseStep = {
    __typename?: "ContentPlatformTutorialUseStep";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Tutorial body text container */
    tutorialBodyTextContainer?: Maybe<
        Array<ContentPlatformAssetComponentAndProTipComponentAndTextComponentAndCallToActionAndQuestionComponentAndTwitterComponentAndCallOutComponentUnion>
    >;
    /** Tutorial Use Step title */
    tutorialUseStepTitle?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTwitterComponent = {
    __typename?: "ContentPlatformTwitterComponent";
    /** Date and time the record was created */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Tweet text */
    tweetText?: Maybe<Scalars["String"]["output"]>;
    /** Twitter component name */
    twitterComponentName?: Maybe<Scalars["String"]["output"]>;
    /** Twitter Url */
    twitterUrl?: Maybe<Scalars["String"]["output"]>;
    /** Date and time of the most recently published update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type ContentPlatformTypeOfChange = {
    __typename?: "ContentPlatformTypeOfChange";
    /** The icon of this change type */
    icon: ContentPlatformImageAsset;
    /**
     * One of
     *   * "Experiment"
     *   * "Improvement"
     *   * "Removed"
     *   * "Announcement"
     *   * "Fix"
     */
    label: Scalars["String"]["output"];
};

export type ContentProperties = {
    __typename?: "ContentProperties";
    draft?: Maybe<DraftContentProperties>;
    latest?: Maybe<PublishedContentProperties>;
};

export enum ContentRendererMode {
    Editor = "EDITOR",
    Pdf = "PDF",
    Renderer = "RENDERER"
}

export enum ContentRepresentation {
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Editor = "EDITOR",
    Editor2 = "EDITOR2",
    ExportView = "EXPORT_VIEW",
    Plain = "PLAIN",
    Raw = "RAW",
    Storage = "STORAGE",
    StyledView = "STYLED_VIEW",
    View = "VIEW",
    Wiki = "WIKI"
}

export type ContentRestriction = {
    __typename?: "ContentRestriction";
    content?: Maybe<Content>;
    links?: Maybe<LinksContextSelfBase>;
    operation?: Maybe<Scalars["String"]["output"]>;
    restrictions?: Maybe<SubjectsByType>;
};

export type ContentRestrictions = {
    __typename?: "ContentRestrictions";
    administer?: Maybe<ContentRestriction>;
    archive?: Maybe<ContentRestriction>;
    copy?: Maybe<ContentRestriction>;
    create?: Maybe<ContentRestriction>;
    create_space?: Maybe<ContentRestriction>;
    delete?: Maybe<ContentRestriction>;
    export?: Maybe<ContentRestriction>;
    move?: Maybe<ContentRestriction>;
    purge?: Maybe<ContentRestriction>;
    purge_version?: Maybe<ContentRestriction>;
    read?: Maybe<ContentRestriction>;
    restore?: Maybe<ContentRestriction>;
    restrict_content?: Maybe<ContentRestriction>;
    update?: Maybe<ContentRestriction>;
    use?: Maybe<ContentRestriction>;
};

export type ContentRestrictionsPageResponse = {
    __typename?: "ContentRestrictionsPageResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextSelfBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictionsHash?: Maybe<Scalars["String"]["output"]>;
};

export enum ContentRole {
    Default = "DEFAULT",
    Editor = "EDITOR",
    Viewer = "VIEWER"
}

export type ContentSpecificCreateInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type ContentState = {
    __typename?: "ContentState";
    color: Scalars["String"]["output"];
    id?: Maybe<Scalars["ID"]["output"]>;
    isCallerPermitted?: Maybe<Scalars["Boolean"]["output"]>;
    name: Scalars["String"]["output"];
    restrictionLevel: ContentStateRestrictionLevel;
    unlocalizedName?: Maybe<Scalars["String"]["output"]>;
};

export type ContentStateInput = {
    color?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["Long"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ContentStateRestrictionLevel {
    None = "NONE",
    PageOwner = "PAGE_OWNER"
}

export type ContentStateSettings = {
    __typename?: "ContentStateSettings";
    contentStatesAllowed?: Maybe<Scalars["Boolean"]["output"]>;
    customContentStatesAllowed?: Maybe<Scalars["Boolean"]["output"]>;
    spaceContentStates?: Maybe<Array<Maybe<ContentState>>>;
    spaceContentStatesAllowed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ContentTemplate = {
    __typename?: "ContentTemplate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    body?: Maybe<EnrichableMap_ContentRepresentation_ContentBody>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editorVersion?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labels: Array<Maybe<Label>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextSelfBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    originalTemplate?: Maybe<ModuleCompleteKey>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    referencingBlueprint?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space?: Maybe<Space>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templateId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templateType?: Maybe<Scalars["String"]["output"]>;
};

export type ContentTemplateBodyInput = {
    atlasDocFormat: ContentBodyInput;
};

export type ContentTemplateLabelInput = {
    id: Scalars["ID"]["input"];
    label?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    prefix?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContentTemplateSpaceInput = {
    key: Scalars["String"]["input"];
};

export type ContentVersion = {
    __typename?: "ContentVersion";
    authorId?: Maybe<Scalars["ID"]["output"]>;
    contentId: Scalars["ID"]["output"];
    contentProperties?: Maybe<ContentProperties>;
    number: Scalars["Int"]["output"];
    updatedTime: Scalars["String"]["output"];
};

export type ContentVersionEdge = {
    __typename?: "ContentVersionEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: ContentVersion;
};

export type ContentVersionHistoryConnection = {
    __typename?: "ContentVersionHistoryConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ContentVersionEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ContentVersion>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: ContentVersionHistoryPageInfo;
};

export type ContentVersionHistoryFilter = {
    contentType: Scalars["String"]["input"];
};

export type ContentVersionHistoryPageInfo = {
    __typename?: "ContentVersionHistoryPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type ContextEventObject = {
    __typename?: "ContextEventObject";
    attributes: Scalars["JSON"]["output"];
    id: Scalars["ID"]["output"];
    type: Scalars["String"]["output"];
};

export type ContributionStatusSummary = {
    __typename?: "ContributionStatusSummary";
    status?: Maybe<Scalars["String"]["output"]>;
    when?: Maybe<Scalars["String"]["output"]>;
};

export type ContributorFailed = {
    __typename?: "ContributorFailed";
    email: Scalars["String"]["output"];
    reason: Scalars["String"]["output"];
};

export type ContributorRolesFailed = {
    __typename?: "ContributorRolesFailed";
    accountId: Scalars["ID"]["output"];
    failed: Array<FailedRoles>;
};

export type ContributorUsers = {
    __typename?: "ContributorUsers";
    links?: Maybe<LinksContextBase>;
    userAccountIds: Array<Maybe<Scalars["String"]["output"]>>;
    userKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    users: Array<Maybe<Person>>;
};

export type Contributors = {
    __typename?: "Contributors";
    links?: Maybe<LinksContextBase>;
    publishers?: Maybe<ContributorUsers>;
};

export type ConvertPageToLiveEditActionInput = {
    contentId: Scalars["ID"]["input"];
};

export type ConvertPageToLiveEditActionPayload = Payload & {
    __typename?: "ConvertPageToLiveEditActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ConvertPageToLiveEditValidationResult = {
    __typename?: "ConvertPageToLiveEditValidationResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasFooterComments?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasReactions?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasUnsupportedMacros?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type CopyPolarisInsightsContainerInput = {
    /** The container ARI which contains insights */
    container?: InputMaybe<Scalars["ID"]["input"]>;
    /** The project ARI which contains container */
    project: Scalars["ID"]["input"];
};

export type CopyPolarisInsightsInput = {
    /** Destination container to copy insgihts */
    destination: CopyPolarisInsightsContainerInput;
    /** Insight ARI's list that should be copied. Leave it empty to copy all insights from source to destination */
    insights?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Source container to copy insgihts */
    source: CopyPolarisInsightsContainerInput;
};

export type CopyPolarisInsightsPayload = Payload & {
    __typename?: "CopyPolarisInsightsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    copiedInsights?: Maybe<Array<PolarisInsight>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CopySpacePermissionsPayload = {
    __typename?: "CopySpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type CountGroupByEventName = {
    __typename?: "CountGroupByEventName";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<CountGroupByEventNameItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: GroupByPageInfo;
};

export type CountGroupByEventNameItem = {
    __typename?: "CountGroupByEventNameItem";
    count: Scalars["Int"]["output"];
    eventName: Scalars["String"]["output"];
};

export type CountGroupByPage = {
    __typename?: "CountGroupByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<CountGroupByPageItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: GroupByPageInfo;
};

export type CountGroupByPageItem = {
    __typename?: "CountGroupByPageItem";
    count: Scalars["Int"]["output"];
    page: Scalars["String"]["output"];
};

export type CountGroupBySpace = {
    __typename?: "CountGroupBySpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<CountGroupBySpaceItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: GroupByPageInfo;
};

export type CountGroupBySpaceItem = {
    __typename?: "CountGroupBySpaceItem";
    count: Scalars["Int"]["output"];
    space: Scalars["String"]["output"];
};

export type CountGroupByUser = {
    __typename?: "CountGroupByUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<CountGroupByUserItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: GroupByPageInfo;
};

export type CountGroupByUserItem = {
    __typename?: "CountGroupByUserItem";
    count: Scalars["Int"]["output"];
    userId: Scalars["String"]["output"];
};

export type CountUsersGroupByPage = {
    __typename?: "CountUsersGroupByPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<CountUsersGroupByPageItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: GroupByPageInfo;
};

export type CountUsersGroupByPageItem = {
    __typename?: "CountUsersGroupByPageItem";
    page: Scalars["String"]["output"];
    user: Scalars["Int"]["output"];
};

export type CreateAppDeploymentInput = {
    appId: Scalars["ID"]["input"];
    artifactUrl: Scalars["URL"]["input"];
    environmentKey: Scalars["String"]["input"];
    hostedResourceUploadId?: InputMaybe<Scalars["ID"]["input"]>;
    majorVersion?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Response from creating a deployment */
export type CreateAppDeploymentResponse = Payload & {
    __typename?: "CreateAppDeploymentResponse";
    /**
     * Details about the created deployment
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deployment?: Maybe<AppDeployment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateAppDeploymentUrlInput = {
    appId: Scalars["ID"]["input"];
};

/** Response from creating an app deployment url */
export type CreateAppDeploymentUrlResponse = Payload & {
    __typename?: "CreateAppDeploymentUrlResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deploymentUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateAppEnvironmentInput = {
    appAri: Scalars["String"]["input"];
    environmentKey: Scalars["String"]["input"];
    environmentType: AppEnvironmentType;
};

/** Response from creating an app environment */
export type CreateAppEnvironmentResponse = Payload & {
    __typename?: "CreateAppEnvironmentResponse";
    /** Details about the created app environment */
    environment?: Maybe<AppEnvironment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type CreateAppInput = {
    appFeatures?: InputMaybe<AppFeaturesInput>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
};

/** Response from creating an app */
export type CreateAppResponse = Payload & {
    __typename?: "CreateAppResponse";
    /**
     * Details about the created app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    app?: Maybe<App>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** A response to a tunnel creation request */
export type CreateAppTunnelResponse = Payload & {
    __typename?: "CreateAppTunnelResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The actual expiry time (in milliseconds) of the created forge tunnel. Once the
     * tunnel expires, Forge apps will display the deployed version even
     * if the local development server is still active.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    expiry?: Maybe<Scalars["String"]["output"]>;
    /**
     * The recommended keep-alive time (in milliseconds) by which the forge CLI (or
     * other clients) should re-establish the forge tunnel.
     * This is guaranteed to be less than the expiry of the forge tunnel.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    keepAlive?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * Establish tunnels for a specific environment of an app.
 *
 * This will redirect all function calls to the provided faas url. This URL must implement the same
 * invocation contract that is used elsewhere in Xen.
 *
 * This will also be used to redirect Custom UI product rendering to the custom ui urls. We separate
 * them by extension key.
 */
export type CreateAppTunnelsInput = {
    /** The app to setup a tunnel for */
    appId: Scalars["ID"]["input"];
    /** The environment key */
    environmentKey: Scalars["String"]["input"];
    /** Should existing tunnels be overwritten */
    force?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The tunnel definitions */
    tunnelDefinitions: TunnelDefinitionsInput;
};

export type CreateCardsOutput = {
    __typename?: "CreateCardsOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    newCards?: Maybe<Array<Maybe<SoftwareCard>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * ## Mutations
 * ## Column Mutations ###
 */
export type CreateColumnInput = {
    boardId: Scalars["ID"]["input"];
    columnName: Scalars["String"]["input"];
};

export type CreateColumnOutput = MutationResponse & {
    __typename?: "CreateColumnOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    columns?: Maybe<Array<Maybe<Column>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    newColumn?: Maybe<Column>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateCommentInput = {
    commentBody: CommentBody;
    commentSource?: InputMaybe<Platform>;
    containerId: Scalars["ID"]["input"];
    parentCommentId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The user-provided input to eventually get an answer to a given question */
export type CreateCompassAssistantAnswerInput = {
    /** User-provided prompt with the question to be answered */
    question: Scalars["String"]["input"];
};

/** Accepts input to create an external alias of a component. */
export type CreateCompassComponentExternalAliasInput = {
    /** The ID of the component to which you add the alias. */
    componentId: Scalars["ID"]["input"];
    /** An alias of the component identifier in external sources. */
    externalAlias: CompassExternalAliasInput;
};

/** The payload returned from creating an external alias of a component. */
export type CreateCompassComponentExternalAliasPayload = Payload & {
    __typename?: "CreateCompassComponentExternalAliasPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** Created Compass External Alias */
    createdCompassExternalAlias?: Maybe<CompassExternalAlias>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CreateCompassComponentFromTemplateArgumentInput = {
    key: Scalars["String"]["input"];
    value?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * ###################################################################################################################
 *  COMPASS COMPONENT TEMPLATE
 * ###################################################################################################################
 */
export type CreateCompassComponentFromTemplateInput = {
    /** The details of the component to create. */
    createComponentDetails: CreateCompassComponentInput;
    /** The optional parameter indicating the key of the project to fork into. Currently only implemented for Bitbucket repositories. */
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
    /** Arguments to pass into your template as parameters. Note: This field is not in use currently. */
    templateArguments?: InputMaybe<
        Array<CreateCompassComponentFromTemplateArgumentInput>
    >;
    /** The unique identifier (ID) of the template component. */
    templateComponentId: Scalars["ID"]["input"];
};

export type CreateCompassComponentFromTemplatePayload = Payload & {
    __typename?: "CreateCompassComponentFromTemplatePayload";
    /** The details of the component that was mutated. */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating a new component. */
export type CreateCompassComponentInput = {
    /** A collection of custom fields for storing data about the component. */
    customFields?: InputMaybe<Array<CompassCustomFieldInput>>;
    /** The description of the component. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** A collection of fields for storing data about the component. */
    fields?: InputMaybe<Array<CreateCompassFieldInput>>;
    /** A list of labels to add to the component */
    labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** A list of links to associate with the component */
    links?: InputMaybe<Array<CreateCompassLinkInput>>;
    /** The name of the component. */
    name: Scalars["String"]["input"];
    /** The unique identifier (ID) of the team that owns the component. */
    ownerId?: InputMaybe<Scalars["ID"]["input"]>;
    /** A unique identifier for the component. */
    slug?: InputMaybe<Scalars["String"]["input"]>;
    /** The state of the component. */
    state?: InputMaybe<Scalars["String"]["input"]>;
    /** The type of the component. */
    type?: InputMaybe<CompassComponentType>;
    /** The type of the component. */
    typeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Accepts input to add links for a component. */
export type CreateCompassComponentLinkInput = {
    /** The ID of the component to add the link. */
    componentId: Scalars["ID"]["input"];
    /** The link to be added for the component. */
    link: CreateCompassLinkInput;
};

/** The payload returned after adding a link for a component. */
export type CreateCompassComponentLinkPayload = Payload & {
    __typename?: "CreateCompassComponentLinkPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** The newly created component link. */
    createdComponentLink?: Maybe<CompassLink>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The payload returned from creating a new component. */
export type CreateCompassComponentPayload = Payload & {
    __typename?: "CreateCompassComponentPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CreateCompassComponentTypeInput = {
    /** The description of the component type. */
    description: Scalars["String"]["input"];
    /** The icon key of the component type. */
    iconKey: Scalars["String"]["input"];
    /** The name of the component type. */
    name: Scalars["String"]["input"];
};

export type CreateCompassComponentTypePayload = {
    __typename?: "CreateCompassComponentTypePayload";
    /** The created component type. */
    createdComponentType?: Maybe<CompassComponentTypeObject>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input to create a field. */
export type CreateCompassFieldInput = {
    /** The ID of the field definition. */
    definition: Scalars["ID"]["input"];
    /** The value of the field. */
    value: CompassFieldValueInput;
};

/** Input to create a freeform user defined parameter. */
export type CreateCompassFreeformUserDefinedParameterInput = {
    /** The value that will be used if the user does not provide a value. */
    defaultValue?: InputMaybe<Scalars["String"]["input"]>;
    /** The description of the parameter. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the parameter. */
    name: Scalars["String"]["input"];
};

/** Accepts input to a create a scorecard criterion representing the presence of a description. */
export type CreateCompassHasDescriptionScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts input to create a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */
export type CreateCompassHasFieldScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID for the field definition that is the target of a relationship. */
    fieldDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts input to create a scorecard criterion representing the presence of a link, for example, 'Has Repository' or 'Has Documentation'. */
export type CreateCompassHasLinkScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The type of link, for example, 'Repository' if 'Has Repository'. */
    linkType: CompassLinkType;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The comparison operation to be performed. */
    textComparator?: InputMaybe<CompassCriteriaTextComparatorOptions>;
    /** The value that the field is compared to. */
    textComparatorValue?: InputMaybe<Scalars["String"]["input"]>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts input to create a scorecard criterion checking the value of a specified metric ID. */
export type CreateCompassHasMetricValueCriteriaInput = {
    /** Automatically create metric sources for the custom metric definition associated with this criterion */
    automaticallyCreateMetricSources?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The comparison operation to be performed between the metric and comparator value. */
    comparator: CompassCriteriaNumberComparatorOptions;
    /** The threshold value that the metric is compared to. */
    comparatorValue: Scalars["Float"]["input"];
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the component metric to check the value of. */
    metricDefinitionId: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts input to a create a scorecard criterion representing the presence of an owner. */
export type CreateCompassHasOwnerScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassCreateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight: Scalars["Int"]["input"];
};

/** Accepts details of the link to add to a component. */
export type CreateCompassLinkInput = {
    /** The name of the link. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The type of the link. */
    type: CompassLinkType;
    /** The URL of the link. */
    url: Scalars["URL"]["input"];
};

/** Accepts input for creating a new relationship. */
export type CreateCompassRelationshipInput = {
    /** The unique identifier (ID) of the component at the ending node. */
    endNodeId: Scalars["ID"]["input"];
    /** The unique identifier (ID) of the component at the starting node. */
    startNodeId: Scalars["ID"]["input"];
    /** The type of the relationship. */
    type: CompassRelationshipType;
};

/** The payload returned from creating a new relationship. */
export type CreateCompassRelationshipPayload = Payload & {
    __typename?: "CreateCompassRelationshipPayload";
    /** The newly created relationship between two components. */
    createdCompassRelationship?: Maybe<CompassRelationship>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input to create a scorecard criterion. */
export type CreateCompassScorecardCriteriaInput = {
    dynamic?: InputMaybe<CompassCreateDynamicScorecardCriteriaInput>;
    hasCustomBooleanValue?: InputMaybe<CompassCreateHasCustomBooleanFieldScorecardCriteriaInput>;
    hasCustomMultiSelectValue?: InputMaybe<CompassCreateHasCustomMultiSelectFieldScorecardCriteriaInput>;
    hasCustomNumberValue?: InputMaybe<CompassCreateHasCustomNumberFieldScorecardCriteriaInput>;
    hasCustomSingleSelectValue?: InputMaybe<CompassCreateHasCustomSingleSelectFieldScorecardCriteriaInput>;
    hasCustomTextValue?: InputMaybe<CompassCreateHasCustomTextFieldScorecardCriteriaInput>;
    hasDescription?: InputMaybe<CreateCompassHasDescriptionScorecardCriteriaInput>;
    hasField?: InputMaybe<CreateCompassHasFieldScorecardCriteriaInput>;
    hasLink?: InputMaybe<CreateCompassHasLinkScorecardCriteriaInput>;
    hasMetricValue?: InputMaybe<CreateCompassHasMetricValueCriteriaInput>;
    hasOwner?: InputMaybe<CreateCompassHasOwnerScorecardCriteriaInput>;
};

export type CreateCompassScorecardInput = {
    componentCreationTimeFilter?: InputMaybe<CompassComponentCreationTimeFilterInput>;
    componentCustomFieldFilters?: InputMaybe<
        Array<CompassCustomFieldFilterInput>
    >;
    componentLabelNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    componentLifecycleStages?: InputMaybe<CompassLifecycleFilterInput>;
    componentOwnerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    componentTierValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    criterias?: InputMaybe<Array<CreateCompassScorecardCriteriaInput>>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    importance: CompassScorecardImportance;
    isDeactivationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    libraryScorecardId?: InputMaybe<Scalars["ID"]["input"]>;
    name: Scalars["String"]["input"];
    ownerId?: InputMaybe<Scalars["ID"]["input"]>;
    repositoryValues?: InputMaybe<CompassRepositoryValueInput>;
    scoringStrategyType?: InputMaybe<CompassScorecardScoringStrategyType>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    statusConfig?: InputMaybe<CompassScorecardStatusConfigInput>;
};

/** The payload returned from creating a scorecard criterion. */
export type CreateCompassScorecardPayload = Payload & {
    __typename?: "CreateCompassScorecardPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The scorecard that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    scorecardDetails?: Maybe<CompassScorecard>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating a starred component. */
export type CreateCompassStarredComponentInput = {
    /** The ID of the component to be starred. */
    componentId: Scalars["ID"]["input"];
};

/** The payload returned from creating a starred component. */
export type CreateCompassStarredComponentPayload = Payload & {
    __typename?: "CreateCompassStarredComponentPayload";
    /** A list of errors that occurred during mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the relationship is created successfully. */
    success: Scalars["Boolean"]["output"];
};

export type CreateCompassUserDefinedParameterInput = {
    freeformField?: InputMaybe<CreateCompassFreeformUserDefinedParameterInput>;
};

export type CreateComponentApiUploadInput = {
    componentId: Scalars["ID"]["input"];
};

export type CreateComponentApiUploadPayload = {
    __typename?: "CreateComponentApiUploadPayload";
    errors?: Maybe<Array<Scalars["String"]["output"]>>;
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    upload?: Maybe<ComponentApiUpload>;
};

export type CreateContentInput = {
    contentSpecificCreateInput?: InputMaybe<Array<ContentSpecificCreateInput>>;
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    status: GraphQlContentStatus;
    subType?: InputMaybe<ConfluencePageSubType>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type: Scalars["String"]["input"];
};

export type CreateContentMentionNotificationActionInput = {
    contentId: Scalars["ID"]["input"];
    mentions: Array<InputMaybe<ContentMention>>;
};

export type CreateContentMentionNotificationActionPayload = Payload & {
    __typename?: "CreateContentMentionNotificationActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateContentTemplateInput = {
    body: ContentTemplateBodyInput;
    description?: InputMaybe<Scalars["String"]["input"]>;
    labels?: InputMaybe<Array<InputMaybe<ContentTemplateLabelInput>>>;
    name: Scalars["String"]["input"];
    space?: InputMaybe<ContentTemplateSpaceInput>;
    templateType: GraphQlContentTemplateType;
};

export type CreateContentTemplateLabelsInput = {
    contentTemplateId: Scalars["ID"]["input"];
    labels: Array<InputMaybe<ContentTemplateLabelInput>>;
};

/** CustomFilters Mutation */
export type CreateCustomFilterInput = {
    boardId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    jql: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
};

/** The request input for creating a relationship between a DevOps Service and an Jira Project. */
export type CreateDevOpsServiceAndJiraProjectRelationshipInput = {
    /** The ID of the site of the service and the Jira project. */
    cloudId: Scalars["ID"]["input"];
    /** An optional description of the relationship. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The Jira project ARI */
    jiraProjectId: Scalars["ID"]["input"];
    /** Optional properties of the relationship. */
    properties?: InputMaybe<
        Array<DevOpsContainerRelationshipEntityPropertyInput>
    >;
    /** The type of the relationship. */
    relationshipType: DevOpsServiceAndJiraProjectRelationshipType;
    /** The ARI of the DevOps Service. */
    serviceId: Scalars["ID"]["input"];
};

/** #################### Mutation Payloads - Service and Jira Project Relationship ##################### */
export type CreateDevOpsServiceAndJiraProjectRelationshipPayload = Payload & {
    __typename?: "CreateDevOpsServiceAndJiraProjectRelationshipPayload";
    /**
     * The list of errors occurred during create relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The created relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceAndJiraProjectRelationship?: Maybe<DevOpsServiceAndJiraProjectRelationship>;
    /**
     * The result of whether the relationship is created successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for creating a relationship between a DevOps Service and an Opsgenie Team */
export type CreateDevOpsServiceAndOpsgenieTeamRelationshipInput = {
    /**
     * We can't infer this from the service ARI since the container association registry doesn't own the service ARI -
     * therefore we have to treat it as opaque.
     */
    cloudId: Scalars["ID"]["input"];
    /** An optional description of the relationship. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The ARI of the Opsgenie Team
     *
     * The Opsgenie team must exist on the same site as the service. If it doesn't, the create will fail
     * with a OPSGENIE_TEAM_ID_INVALID error.
     */
    opsgenieTeamId: Scalars["ID"]["input"];
    /** Optional properties of the relationship. */
    properties?: InputMaybe<
        Array<DevOpsContainerRelationshipEntityPropertyInput>
    >;
    /** The ARI of the DevOps Service. */
    serviceId: Scalars["ID"]["input"];
};

/** The response payload of creating a relationship between a DevOps Service and an Opsgenie Team */
export type CreateDevOpsServiceAndOpsgenieTeamRelationshipPayload = Payload & {
    __typename?: "CreateDevOpsServiceAndOpsgenieTeamRelationshipPayload";
    /**
     * The list of errors occurred during update relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The created relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceAndOpsgenieTeamRelationship?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
    /**
     * The result of whether the relationship is created successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for creating a relationship between a DevOps Service and a Repository */
export type CreateDevOpsServiceAndRepositoryRelationshipInput = {
    /** The Bitbucket Repository ARI */
    bitbucketRepositoryId?: InputMaybe<Scalars["ID"]["input"]>;
    /** An optional description of the relationship. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** Optional properties of the relationship. */
    properties?: InputMaybe<
        Array<DevOpsContainerRelationshipEntityPropertyInput>
    >;
    /** The ARI of the DevOps Service. */
    serviceId: Scalars["ID"]["input"];
    /** The Third Party Repository. It should be null when repositoryId is a Bitbucket Repository ARI */
    thirdPartyRepository?: InputMaybe<ThirdPartyRepositoryInput>;
};

/** #################### Mutation Payloads - DevOps Service and Repository Relationship ##################### */
export type CreateDevOpsServiceAndRepositoryRelationshipPayload = Payload & {
    __typename?: "CreateDevOpsServiceAndRepositoryRelationshipPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The created relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceAndRepositoryRelationship?: Maybe<DevOpsServiceAndRepositoryRelationship>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for creating a new DevOps Service */
export type CreateDevOpsServiceInput = {
    cloudId: Scalars["String"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    properties?: InputMaybe<Array<DevOpsServiceEntityPropertyInput>>;
    /** Tier assigned to the DevOps Service */
    serviceTier: DevOpsServiceTierInput;
    /** Service Type asigned to the DevOps Service */
    serviceType?: InputMaybe<DevOpsServiceTypeInput>;
};

/** The response payload of creating a new DevOps Service */
export type CreateDevOpsServicePayload = Payload & {
    __typename?: "CreateDevOpsServicePayload";
    /**
     * The list of errors occurred during the DevOps Service creation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The created DevOps Service
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    service?: Maybe<DevOpsService>;
    /**
     * The result of whether a new DevOps Service is created successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for creating a new DevOps Service Relationship */
export type CreateDevOpsServiceRelationshipInput = {
    /** The description of the relationship */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The Service ARI of the end node of the relationship */
    endId: Scalars["ID"]["input"];
    /** The properties of the relationship */
    properties?: InputMaybe<Array<DevOpsServiceEntityPropertyInput>>;
    /** The Service ARI of the start node of the relationship */
    startId: Scalars["ID"]["input"];
    /** The inter-service relationship type */
    type: DevOpsServiceRelationshipType;
};

export type CreateDevOpsServiceRelationshipPayload = Payload & {
    __typename?: "CreateDevOpsServiceRelationshipPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The created inter-service relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceRelationship?: Maybe<DevOpsServiceRelationship>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateEventSourceInput = {
    /** The cloud ID of the site to create an event source for. */
    cloudId: Scalars["ID"]["input"];
    /** The type of the event that the event source can accept. */
    eventType: CompassEventType;
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
};

export type CreateEventSourcePayload = Payload & {
    __typename?: "CreateEventSourcePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The source of event data.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:event:compass__
     *
     *
     */
    eventSource?: Maybe<EventSource>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type CreateFaviconFilesInput = {
    fileStoreId: Scalars["ID"]["input"];
};

export type CreateFaviconFilesPayload = Payload & {
    __typename?: "CreateFaviconFilesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    faviconFiles?: Maybe<Array<FaviconFile>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateHostedResourceUploadUrlInput = {
    appId: Scalars["ID"]["input"];
    environmentKey: Scalars["String"]["input"];
    resourceKeys: Array<Scalars["String"]["input"]>;
};

/** Response from creating a hosted resource upload url */
export type CreateHostedResourceUploadUrlPayload = Payload & {
    __typename?: "CreateHostedResourceUploadUrlPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    preSignedUrls?: Maybe<Array<HostedResourcePreSignedUrl>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    uploadId: Scalars["ID"]["output"];
};

export type CreateIncomingWebhookToken = {
    __typename?: "CreateIncomingWebhookToken";
    /** Id of auth token. */
    id: Scalars["ID"]["output"];
    /** Name of auth token. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Value of the token. This value will only be returned here, you will not be able to requery this value. */
    value: Scalars["String"]["output"];
};

export type CreateInlineCommentInput = {
    commentBody: CommentBody;
    commentSource?: InputMaybe<Platform>;
    containerId: Scalars["ID"]["input"];
    createdFrom: CommentCreationLocation;
    lastFetchTimeMillis: Scalars["Long"]["input"];
    /** matchIndex must be greater than or equal to 0. */
    matchIndex: Scalars["Int"]["input"];
    /** numMatches must be positive and greater than matchIndex. */
    numMatches: Scalars["Int"]["input"];
    originalSelection: Scalars["String"]["input"];
    parentCommentId?: InputMaybe<Scalars["ID"]["input"]>;
    publishedVersion?: InputMaybe<Scalars["Int"]["input"]>;
    step?: InputMaybe<Step>;
};

export type CreateInlineContentInput = {
    contentSpecificCreateInput?: InputMaybe<Array<ContentSpecificCreateInput>>;
    createdInContentId: Scalars["ID"]["input"];
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type: Scalars["String"]["input"];
};

export type CreateInlineTaskNotificationInput = {
    contentId: Scalars["ID"]["input"];
    tasks: Array<InputMaybe<IndividualInlineTaskNotificationInput>>;
};

export type CreateInlineTaskNotificationPayload = Payload & {
    __typename?: "CreateInlineTaskNotificationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tasks: Array<Maybe<IndividualInlineTaskNotification>>;
};

/** Create: Mutation (POST) */
export type CreateJiraPlaybookInput = {
    cloudId: Scalars["ID"]["input"];
    filters?: InputMaybe<Array<JiraPlaybookIssueFilterInput>>;
    name: Scalars["String"]["input"];
    /** scopeId is projectId */
    scopeId?: InputMaybe<Scalars["String"]["input"]>;
    scopeType: JiraPlaybookScopeType;
    state?: InputMaybe<JiraPlaybookStateField>;
    steps: Array<CreateJiraPlaybookStepInput>;
};

/** Create: Mutation Response */
export type CreateJiraPlaybookPayload = Payload & {
    __typename?: "CreateJiraPlaybookPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    playbook?: Maybe<JiraPlaybook>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Create: Mutation (POST) */
export type CreateJiraPlaybookStepInput = {
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    name: Scalars["String"]["input"];
    ruleId?: InputMaybe<Scalars["String"]["input"]>;
    type: JiraPlaybookStepType;
};

export type CreateJiraPlaybookStepRunInput = {
    playbookInstanceStepAri: Scalars["ID"]["input"];
    userInputs?: InputMaybe<Array<UserInput>>;
};

/** Create: Mutation Response */
export type CreateJiraPlaybookStepRunPayload = Payload & {
    __typename?: "CreateJiraPlaybookStepRunPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    playbookInstanceStep?: Maybe<JiraPlaybookInstanceStep>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateLivePageInput = {
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateMentionNotificationInput = {
    contentId: Scalars["ID"]["input"];
    mentionLocalId?: InputMaybe<Scalars["ID"]["input"]>;
    mentionedUserAccountId: Scalars["ID"]["input"];
};

export type CreateMentionNotificationPayload = Payload & {
    __typename?: "CreateMentionNotificationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateMentionReminderNotificationInput = {
    contentId: Scalars["ID"]["input"];
    mentionData: Array<MentionData>;
};

export type CreateMentionReminderNotificationPayload = Payload & {
    __typename?: "CreateMentionReminderNotificationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    failedAccountIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreatePersonalSpaceInput = {
    /** Fetches the Space Permissions from the given space key and copies them to the new space. If this field is set, it must be accompanied with field initialPermissionOption: COPY_FROM_SPACE. */
    copySpacePermissionsFromSpaceKey?: InputMaybe<Scalars["String"]["input"]>;
    /** if this enum is set to PRIVATE, it will take precedence over copySpacePermissionsFromSpaceKey. */
    initialPermissionOption?: InputMaybe<InitialPermissionOptions>;
    spaceName: Scalars["String"]["input"];
};

export type CreatePolarisCommentInput = {
    content?: InputMaybe<Scalars["JSON"]["input"]>;
    kind?: InputMaybe<PolarisCommentKind>;
    subject?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreatePolarisCommentPayload = Payload & {
    __typename?: "CreatePolarisCommentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisComment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreatePolarisIdeaTemplateInput = {
    color?: InputMaybe<Scalars["String"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    emoji?: InputMaybe<Scalars["String"]["input"]>;
    project: Scalars["ID"]["input"];
    /**
     * Template in ADF format.  See
     * https://developer.atlassian.com/platform/atlassian-document-format/
     */
    template?: InputMaybe<Scalars["JSON"]["input"]>;
    title: Scalars["String"]["input"];
};

export type CreatePolarisIdeaTemplatePayload = {
    __typename?: "CreatePolarisIdeaTemplatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisIdeaTemplate>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreatePolarisInsightInput = {
    /** The cloudID in which we are adding insight */
    cloudID: Scalars["String"]["input"];
    /**
     * DEPRECATED, DO NOT USE
     * Array of datas in JSON format. It will be validated with JSON schema of Polaris Insights Data format.
     */
    data?: InputMaybe<Array<Scalars["JSON"]["input"]>>;
    /** Description in ADF format https://developer.atlassian.com/platform/atlassian-document-format/ */
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    /** The issueID in which we are adding insight, cloud be empty for adding insight on project level */
    issueID?: InputMaybe<Scalars["Int"]["input"]>;
    /** The projectID in which we are adding insight */
    projectID: Scalars["Int"]["input"];
    /** Array of snippets */
    snippets?: InputMaybe<Array<CreatePolarisSnippetInput>>;
};

export type CreatePolarisInsightPayload = Payload & {
    __typename?: "CreatePolarisInsightPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisInsight>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreatePolarisPlayContribution = {
    /** the issue (idea) to which this contribution is being made */
    amount?: InputMaybe<Scalars["Int"]["input"]>;
    /** the extent of the contribution (null=drop value) */
    comment?: InputMaybe<Scalars["JSON"]["input"]>;
    play: Scalars["ID"]["input"];
    /** the play being contributed to */
    subject: Scalars["ID"]["input"];
};

export type CreatePolarisPlayContributionPayload = {
    __typename?: "CreatePolarisPlayContributionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisPlayContribution>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreatePolarisPlayInput = {
    /** the view from which the play is created */
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    fromView?: InputMaybe<Scalars["ID"]["input"]>;
    kind: PolarisPlayKind;
    label: Scalars["String"]["input"];
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
    project: Scalars["ID"]["input"];
    /** the label for the play field, and the "short" name of the play */
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePolarisPlayPayload = {
    __typename?: "CreatePolarisPlayPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisPlay>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** # Types */
export type CreatePolarisProjectInput = {
    key: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    tenant: Scalars["ID"]["input"];
};

export type CreatePolarisSnippetInput = {
    /** Data in JSON format. It will be validated with JSON schema of Polaris Insights Data format. */
    data?: InputMaybe<Scalars["JSON"]["input"]>;
    /** OauthClientId of CaaS app */
    oauthClientId: Scalars["String"]["input"];
    /**
     * DEPRECATED, DO NOT USE
     * Snippet-level properties in JSON format.
     */
    properties?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Snippet url that is source of data */
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePolarisViewInput = {
    container: Scalars["ID"]["input"];
    /** the type of viz to create */
    copyView?: InputMaybe<Scalars["ID"]["input"]>;
    /** view to copy configuration from */
    update?: InputMaybe<UpdatePolarisViewInput>;
    visualizationType?: InputMaybe<PolarisVisualizationType>;
};

export type CreatePolarisViewPayload = Payload & {
    __typename?: "CreatePolarisViewPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisView>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreatePolarisViewSetInput = {
    container: Scalars["ID"]["input"];
    name: Scalars["String"]["input"];
};

export type CreatePolarisViewSetPayload = Payload & {
    __typename?: "CreatePolarisViewSetPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisViewSet>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Types */
export type CreateRankingListInput = {
    items?: InputMaybe<Array<Scalars["String"]["input"]>>;
    listId: Scalars["ID"]["input"];
};

export type CreateSpaceAdditionalSettingsInput = {
    jiraProject?: InputMaybe<CreateSpaceJiraProjectInput>;
    spaceTypeSettings?: InputMaybe<SpaceTypeSettingsInput>;
};

export type CreateSpaceInput = {
    additionalSettings?: InputMaybe<CreateSpaceAdditionalSettingsInput>;
    /** if this field is set, it must be accompanied with field initialPermissionOption: COPY_FROM_SPACE. */
    copySpacePermissionsFromSpaceKey?: InputMaybe<Scalars["String"]["input"]>;
    /** if this enum is set to PRIVATE, it will take precedence over copySpacePermissionsFromSpaceKey. */
    initialPermissionOption?: InputMaybe<InitialPermissionOptions>;
    spaceKey: Scalars["String"]["input"];
    spaceLogoDataURI?: InputMaybe<Scalars["String"]["input"]>;
    spaceName: Scalars["String"]["input"];
    spaceTemplateKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateSpaceJiraProjectInput = {
    jiraProjectKey: Scalars["String"]["input"];
    jiraProjectName?: InputMaybe<Scalars["String"]["input"]>;
    jiraServerId: Scalars["String"]["input"];
};

/** Create sprint */
export type CreateSprintInput = {
    boardId: Scalars["ID"]["input"];
};

export type CreateSprintResponse = MutationResponse & {
    __typename?: "CreateSprintResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    sprint?: Maybe<CreatedSprint>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type CreateUpdate = AllUpdatesFeedEvent & {
    __typename?: "CreateUpdate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: AllUpdatesFeedEventType;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    user?: Maybe<Person>;
};

/** Response from creating an webtrigger url */
export type CreateWebTriggerUrlResponse = MutationResponse & {
    __typename?: "CreateWebTriggerUrlResponse";
    /**
     * Id of the webtrigger. Populated only if success is true.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     * Url of the webtrigger. Populated only if success is true.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type CreatedSprint = {
    __typename?: "CreatedSprint";
    /** Can this sprint be update by the current user */
    canUpdateSprint?: Maybe<Scalars["Boolean"]["output"]>;
    /** The number of days remaining */
    daysRemaining?: Maybe<Scalars["Int"]["output"]>;
    /** The end date of the sprint, in ISO 8601 format */
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The ID of the sprint */
    id: Scalars["ID"]["output"];
    /** The sprint's name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The state of the sprint, can be one of the following (FUTURE, ACTIVE, CLOSED) */
    sprintState?: Maybe<SprintState>;
    /** The start date of the sprint, in ISO 8601 format */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Node for querying the Cumulative Flow Diagram report */
export type CumulativeFlowDiagram = {
    __typename?: "CumulativeFlowDiagram";
    chart: CfdChartConnection;
    filters: CfdFilters;
};

/** Node for querying the Cumulative Flow Diagram report */
export type CumulativeFlowDiagramChartArgs = {
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CurrentConfluenceUser = {
    __typename?: "CurrentConfluenceUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isAnonymous: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
};

export type CurrentEstimation = {
    __typename?: "CurrentEstimation";
    /** Custom field configured as the estimation type. Null when estimation feature is disabled. */
    customFieldId?: Maybe<Scalars["String"]["output"]>;
    /** Type of the estimation */
    estimationType?: Maybe<EstimationType>;
    /** Name of the custom field. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Unique identifier of the estimation */
    statisticFieldId?: Maybe<Scalars["String"]["output"]>;
};

/** Information about the current user. Different users will see different results. */
export type CurrentUser = {
    __typename?: "CurrentUser";
    /** List of permissions the *user making the request* has for this board. */
    permissions: Array<Maybe<Scalars["SoftwareBoardPermission"]["output"]>>;
};

export type CurrentUserOperations = {
    __typename?: "CurrentUserOperations";
    canFollow?: Maybe<Scalars["Boolean"]["output"]>;
    followed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CustomEntity = {
    attributes: Array<CustomEntityAttribute>;
    indexes?: InputMaybe<Array<CustomEntityIndex>>;
    name: Scalars["String"]["input"];
};

export type CustomEntityAttribute = {
    name: Scalars["String"]["input"];
    required?: InputMaybe<Scalars["Boolean"]["input"]>;
    type: CustomEntityAttributeType;
};

export enum CustomEntityAttributeType {
    Any = "any",
    Boolean = "boolean",
    Float = "float",
    Integer = "integer",
    String = "string"
}

/** Definition of an existing custom entity when queried */
export type CustomEntityDefinition = {
    __typename?: "CustomEntityDefinition";
    attributes: Scalars["JSON"]["output"];
    indexes?: Maybe<Array<Maybe<CustomEntityIndexDefinition>>>;
    name: Scalars["String"]["output"];
    status: CustomEntityStatus;
    version: Scalars["Int"]["output"];
};

export type CustomEntityIndex = {
    name: Scalars["String"]["input"];
    partition?: InputMaybe<Array<Scalars["String"]["input"]>>;
    range: Array<Scalars["String"]["input"]>;
};

/** Definition of an existing custom entity index when queried */
export type CustomEntityIndexDefinition = {
    __typename?: "CustomEntityIndexDefinition";
    name: Scalars["String"]["output"];
    partition?: Maybe<Array<Scalars["String"]["output"]>>;
    range: Array<Scalars["String"]["output"]>;
    status: CustomEntityIndexStatus;
};

export enum CustomEntityIndexStatus {
    Active = "ACTIVE",
    Creating = "CREATING",
    Inactive = "INACTIVE",
    Pending = "PENDING"
}

export type CustomEntityMutation = {
    __typename?: "CustomEntityMutation";
    /** Create custom entities */
    createCustomEntities?: Maybe<CustomEntityPayload>;
    /** Validate custom entities */
    validateCustomEntities?: Maybe<CustomEntityPayload>;
};

export type CustomEntityMutationCreateCustomEntitiesArgs = {
    input: CustomEntityMutationInput;
};

export type CustomEntityMutationValidateCustomEntitiesArgs = {
    input: CustomEntityMutationInput;
};

export type CustomEntityMutationInput = {
    entities: Array<CustomEntity>;
    oauthClientId: Scalars["String"]["input"];
};

/** Generic implementation of MutationResponse for responses that don't need any extra data */
export type CustomEntityPayload = Payload & {
    __typename?: "CustomEntityPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum CustomEntityStatus {
    Active = "ACTIVE",
    Inactive = "INACTIVE"
}

export type CustomFilter = Node & {
    __typename?: "CustomFilter";
    description?: Maybe<Scalars["String"]["output"]>;
    filterQuery?: Maybe<FilterQuery>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

export type CustomFilterCreateOutput = MutationResponse & {
    __typename?: "CustomFilterCreateOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFilter?: Maybe<CustomFilter>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    validationErrors: Array<CustomFiltersValidationError>;
};

export type CustomFilterCreateOutputV2 = MutationResponse & {
    __typename?: "CustomFilterCreateOutputV2";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customFilter?: Maybe<CustomFilterV2>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    validationErrors: Array<CustomFiltersValidationError>;
};

/** Custom filter data */
export type CustomFilterV2 = {
    __typename?: "CustomFilterV2";
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    jql: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

/** Board custom filter config data */
export type CustomFiltersConfig = {
    __typename?: "CustomFiltersConfig";
    customFilters?: Maybe<Array<Maybe<CustomFilterV2>>>;
};

export type CustomFiltersValidationError = {
    __typename?: "CustomFiltersValidationError";
    errorKey: Scalars["String"]["output"];
    errorMessage: Scalars["String"]["output"];
    fieldName: Scalars["String"]["output"];
};

export enum CustomMultiselectFieldInputComparators {
    ContainAll = "CONTAIN_ALL",
    ContainAny = "CONTAIN_ANY",
    ContainNone = "CONTAIN_NONE",
    IsSet = "IS_SET",
    NotSet = "NOT_SET"
}

export enum CustomNumberFieldInputComparators {
    IsSet = "IS_SET",
    NotSet = "NOT_SET"
}

export type CustomPermissionsFeature = {
    __typename?: "CustomPermissionsFeature";
    customRoleCountLimit: Scalars["Int"]["output"];
    isEntitled: Scalars["Boolean"]["output"];
};

export enum CustomSingleSelectFieldInputComparators {
    ContainAny = "CONTAIN_ANY",
    ContainNone = "CONTAIN_NONE",
    IsSet = "IS_SET",
    NotSet = "NOT_SET"
}

export enum CustomTextFieldInputComparators {
    IsSet = "IS_SET",
    NotSet = "NOT_SET"
}

export type CustomUiTunnelDefinition = {
    __typename?: "CustomUITunnelDefinition";
    resourceKey?: Maybe<Scalars["String"]["output"]>;
    tunnelUrl?: Maybe<Scalars["URL"]["output"]>;
};

export type CustomUiTunnelDefinitionInput = {
    resourceKey?: InputMaybe<Scalars["String"]["input"]>;
    tunnelUrl?: InputMaybe<Scalars["URL"]["input"]>;
};

export enum CustomUserFieldInputComparators {
    ContainAny = "CONTAIN_ANY",
    IsSet = "IS_SET",
    NotSet = "NOT_SET"
}

/**
 * The customer service organization attribute
 * DEPRECATED: use CustomerServiceCustomDetail instead.
 */
export type CustomerServiceAttribute = Node & {
    __typename?: "CustomerServiceAttribute";
    /** The config metadata for this attribute */
    config?: Maybe<CustomerServiceAttributeConfigMetadata>;
    /** The ID of the attribute */
    id: Scalars["ID"]["output"];
    /** The name of the attribute */
    name: Scalars["String"]["output"];
    /** The type of the attribute */
    type: CustomerServiceAttributeType;
};

/**
 * Config metadata for an attribute
 * DEPRECATED: use CustomerServiceCustomDetailConfigMetadata instead
 */
export type CustomerServiceAttributeConfigMetadata = {
    __typename?: "CustomerServiceAttributeConfigMetadata";
    contextConfigurations?: Maybe<Array<CustomerServiceContextConfiguration>>;
    position?: Maybe<Scalars["Int"]["output"]>;
};

/** DEPRECATED: Use CustomerServiceCustomDetailConfigMetadataUpdateInput instead. */
export type CustomerServiceAttributeConfigMetadataUpdateInput = {
    /** Context configuration */
    contextConfigurations?: InputMaybe<
        Array<InputMaybe<CustomerServiceContextConfigurationInput>>
    >;
    /** ID of the custom attribute */
    id: Scalars["ID"]["input"];
    /** position of the attribute */
    position?: InputMaybe<Scalars["Int"]["input"]>;
    /** Styles configuration */
    styleConfiguration?: InputMaybe<CustomerServiceCustomAttributeStyleConfigurationInput>;
};

/** DEPRECATED: use CustomerServiceCustomDetailConfigMetadataUpdatePayload instead. */
export type CustomerServiceAttributeConfigMetadataUpdatePayload = Payload & {
    __typename?: "CustomerServiceAttributeConfigMetadataUpdatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** DEPRECATED: use CustomerServiceCustomDetailCreateInput instead. */
export type CustomerServiceAttributeCreateInput = {
    /** Context configuration */
    contextConfigurations?: InputMaybe<
        Array<InputMaybe<CustomerServiceContextConfigurationInput>>
    >;
    /** The name of the attribute to create */
    name: Scalars["String"]["input"];
    /** The type of the attribute to create */
    type?: InputMaybe<CustomerServiceAttributeCreateTypeInput>;
};

/** DEPRECATED: use CustomerServiceCustomDetailCreatePayload instead. */
export type CustomerServiceAttributeCreatePayload = Payload & {
    __typename?: "CustomerServiceAttributeCreatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Then name of the attribute created */
    successfullyCreatedAttribute?: Maybe<CustomerServiceAttribute>;
};

/** DEPRECATED: use CustomerServiceCustomDetailCreateTypeInput instead. */
export type CustomerServiceAttributeCreateTypeInput = {
    /** The type of the attribute to be created */
    name?: InputMaybe<CustomerServiceAttributeTypeName>;
    /** Options for this type, only valid if the provided type is SELECT/MULTI-SELECT. Empty otherwise. */
    options?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** DEPRECATED: Use CustomerServiceCustomDetailDeleteInput instead. */
export type CustomerServiceAttributeDeleteInput = {
    /** ID of the custom attribute */
    id: Scalars["ID"]["input"];
};

/** DEPRECATED: use CustomerServiceCustomDetailDeletePayload instead. */
export type CustomerServiceAttributeDeletePayload = Payload & {
    __typename?: "CustomerServiceAttributeDeletePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** DEPRECATED: use CustomerServiceCustomDetailType instead. */
export type CustomerServiceAttributeType = {
    __typename?: "CustomerServiceAttributeType";
    /** The type name for this attribute */
    name: CustomerServiceAttributeTypeName;
    /** The options for selection available on this attribute (only valid for select type) */
    options?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * The types of attributes that can exist
 * DEPRECATED: use CustomerServiceCustomDetailTypeName instead.
 * NOTE: Please do not modify enums without first notifying the FE team.
 */
export enum CustomerServiceAttributeTypeName {
    Boolean = "BOOLEAN",
    Date = "DATE",
    Email = "EMAIL",
    Multiselect = "MULTISELECT",
    Number = "NUMBER",
    Phone = "PHONE",
    Select = "SELECT",
    Text = "TEXT",
    Url = "URL",
    User = "USER"
}

/** DEPRECATED: use CustomerServiceCustomDetailUpdateInput instead. */
export type CustomerServiceAttributeUpdateInput = {
    /** ID of the custom attribute */
    id: Scalars["ID"]["input"];
    /** The updated name for the attribute to update */
    name: Scalars["String"]["input"];
    /** The type of the attribute to update */
    type?: InputMaybe<CustomerServiceAttributeUpdateTypeInput>;
};

/** DEPRECATED: use CustomerServiceCustomDetailUpdatePayload instead. */
export type CustomerServiceAttributeUpdatePayload = Payload & {
    __typename?: "CustomerServiceAttributeUpdatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Then name of the attribute updated */
    successfullyUpdatedAttribute?: Maybe<CustomerServiceAttribute>;
};

/** DEPRECATED: use CustomerServiceCustomDetailUpdateTypeInput instead. */
export type CustomerServiceAttributeUpdateTypeInput = {
    /** The type of the attribute to be updated */
    name?: InputMaybe<CustomerServiceAttributeTypeName>;
    /** Options for this type, only valid if the provided type is SELECT/MULTI-SELECT. Empty Otherwise. */
    options?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/**
 * The customer service organization attribute with a value
 * DEPRECATED: use CustomerServiceCustomDetailValue instead.
 */
export type CustomerServiceAttributeValue = Node & {
    __typename?: "CustomerServiceAttributeValue";
    /** The config metadata for this attribute */
    config?: Maybe<CustomerServiceAttributeConfigMetadata>;
    /** The ID of the attribute */
    id: Scalars["ID"]["output"];
    /** The name of the attribute */
    name: Scalars["String"]["output"];
    /**
     * The platform value of the custom detail, if it is a single value
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceUserCustomDetailType")' query directive to the 'platformValue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    platformValue?: Maybe<CustomerServicePlatformDetailValue>;
    /** The type of the attribute */
    type: CustomerServiceAttributeType;
    /** The value of the attribute, if it is a single value */
    value?: Maybe<Scalars["String"]["output"]>;
    /** The values of the attribute, if it is multi value */
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * The customer service attributes defines on an entity
 * DEPRECATED: use CustomerServiceCustomDetails instead.
 */
export type CustomerServiceAttributes = {
    __typename?: "CustomerServiceAttributes";
    /** The list of all attributes defined on an entity */
    attributes?: Maybe<Array<CustomerServiceAttribute>>;
    /** The maximum number of attributes that can be created for this entity */
    maxAllowedAttributes?: Maybe<Scalars["Int"]["output"]>;
};

/** DEPRECATED: use CustomerServiceCustomDetailsQueryResult instead. */
export type CustomerServiceAttributesQueryResult =
    | CustomerServiceAttributes
    | QueryError;

export type CustomerServiceContext = {
    issueId?: InputMaybe<Scalars["String"]["input"]>;
    type: CustomerServiceContextType;
};

/** Context configuration for an attribute */
export type CustomerServiceContextConfiguration = {
    __typename?: "CustomerServiceContextConfiguration";
    context: CustomerServiceContextType;
    enabled: Scalars["Boolean"]["output"];
};

export type CustomerServiceContextConfigurationInput = {
    context: CustomerServiceContextType;
    enabled: Scalars["Boolean"]["input"];
};

/** Context is the place where detail fields are being requested. The Context determines which configurations to use. Configurations determines settings like: the max number of fields allowed and if a field is enabled for displayed or not */
export enum CustomerServiceContextType {
    /** Organization/Customer Details View */
    Default = "DEFAULT",
    /** Jira Issue View */
    Issue = "ISSUE"
}

export type CustomerServiceCustomAttributeOptionStyle = {
    __typename?: "CustomerServiceCustomAttributeOptionStyle";
    /** Background color for this option style */
    backgroundColour: Scalars["String"]["output"];
};

export type CustomerServiceCustomAttributeOptionStyleInput = {
    backgroundColour: Scalars["String"]["input"];
};

export type CustomerServiceCustomAttributeOptionsStyleConfiguration = {
    __typename?: "CustomerServiceCustomAttributeOptionsStyleConfiguration";
    /** Option value for which the style needs to be applied */
    optionValue: Scalars["String"]["output"];
    /** Style for the option value */
    style: CustomerServiceCustomAttributeOptionStyle;
};

export type CustomerServiceCustomAttributeOptionsStyleConfigurationInput = {
    optionValue: Scalars["String"]["input"];
    style: CustomerServiceCustomAttributeOptionStyleInput;
};

export type CustomerServiceCustomAttributeStyleConfiguration = {
    __typename?: "CustomerServiceCustomAttributeStyleConfiguration";
    /** Individual style for each valid option (only for types that have options like SELECT) */
    options?: Maybe<
        Array<CustomerServiceCustomAttributeOptionsStyleConfiguration>
    >;
};

export type CustomerServiceCustomAttributeStyleConfigurationInput = {
    options?: InputMaybe<
        Array<CustomerServiceCustomAttributeOptionsStyleConfigurationInput>
    >;
};

/** The customer service entity custom detail */
export type CustomerServiceCustomDetail = Node & {
    __typename?: "CustomerServiceCustomDetail";
    /** The config metadata for this custom detail */
    config?: Maybe<CustomerServiceCustomDetailConfigMetadata>;
    /** The user roles that are able to edit this detail */
    editPermissions?: Maybe<CustomerServicePermissionGroupConnection>;
    /** The ID of the custom detail */
    id: Scalars["ID"]["output"];
    /** The name of the custom detail */
    name: Scalars["String"]["output"];
    /** The user roles that are able to view this detail */
    readPermissions?: Maybe<CustomerServicePermissionGroupConnection>;
    /** The type of the custom detail */
    type: CustomerServiceCustomDetailType;
};

/** Config metadata for a custom detail */
export type CustomerServiceCustomDetailConfigMetadata = {
    __typename?: "CustomerServiceCustomDetailConfigMetadata";
    contextConfigurations?: Maybe<Array<CustomerServiceContextConfiguration>>;
    position?: Maybe<Scalars["Int"]["output"]>;
    styleConfiguration?: Maybe<CustomerServiceCustomAttributeStyleConfiguration>;
};

export type CustomerServiceCustomDetailConfigMetadataUpdateInput = {
    /** Context configuration */
    contextConfigurations?: InputMaybe<
        Array<CustomerServiceContextConfigurationInput>
    >;
    /** The ID of the custom detail */
    id: Scalars["ID"]["input"];
    /** The position of the custom detail */
    position?: InputMaybe<Scalars["Int"]["input"]>;
    /** Styles configuration */
    styleConfiguration?: InputMaybe<CustomerServiceCustomAttributeStyleConfigurationInput>;
};

export type CustomerServiceCustomDetailConfigMetadataUpdatePayload = Payload & {
    __typename?: "CustomerServiceCustomDetailConfigMetadataUpdatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    successfullyUpdatedCustomDetailConfig?: Maybe<CustomerServiceCustomDetailConfigMetadata>;
};

export type CustomerServiceCustomDetailContextInput = {
    /** Context configuration */
    contextConfigurations?: InputMaybe<
        Array<CustomerServiceContextConfigurationInput>
    >;
    /** The ID of the custom detail */
    id: Scalars["ID"]["input"];
};

export enum CustomerServiceCustomDetailCreateErrorCode {
    ColorNotSaved = "COLOR_NOT_SAVED",
    PermissionsNotSaved = "PERMISSIONS_NOT_SAVED"
}

/**
 * #########################
 *  Error extensions
 * #########################
 */
export type CustomerServiceCustomDetailCreateErrorExtension =
    MutationErrorExtension & {
        __typename?: "CustomerServiceCustomDetailCreateErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorCode?: Maybe<CustomerServiceCustomDetailCreateErrorCode>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * The error extensions returned by CustomerServiceCustomDetailCreatePayload
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type CustomerServiceCustomDetailCreateInput = {
    /** Context configuration */
    contextConfigurations?: InputMaybe<
        Array<CustomerServiceContextConfigurationInput>
    >;
    /** The entity type to create a custom detail for */
    customDetailEntityType: CustomerServiceCustomDetailsEntityType;
    /** The PermissionGroup IDs of the user roles that are able to edit this detail */
    editPermissions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The name of the custom detail to create */
    name: Scalars["String"]["input"];
    /** The PermissionGroup IDs of the user roles that are able to view this detail */
    readPermissions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Styles configuration */
    styleConfiguration?: InputMaybe<CustomerServiceCustomAttributeStyleConfigurationInput>;
    /** The type of the custom detail to create */
    type?: InputMaybe<CustomerServiceCustomDetailCreateTypeInput>;
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceCustomDetailCreatePayload = Payload & {
    __typename?: "CustomerServiceCustomDetailCreatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Then name of the custom detail created */
    successfullyCreatedCustomDetail?: Maybe<CustomerServiceCustomDetail>;
};

/**
 * ########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceCustomDetailCreateTypeInput = {
    /** The type of the custom detail to be created */
    name?: InputMaybe<CustomerServiceCustomDetailTypeName>;
    /** Options for this type, only valid if the provided type is SELECT/MULTI-SELECT. Empty otherwise. */
    options?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CustomerServiceCustomDetailDeleteInput = {
    /** ID of the custom detail */
    id: Scalars["ID"]["input"];
};

export type CustomerServiceCustomDetailDeletePayload = Payload & {
    __typename?: "CustomerServiceCustomDetailDeletePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceCustomDetailEntityTypeId = {
    /** The ID of the individual that the custom detail is for */
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the entitlement that the custom detail is for */
    entitlementId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the organization that the custom detail is for */
    organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * ########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceCustomDetailPermissionsUpdateInput = {
    /** The CustomerServicePermissionGroup IDs that are able to edit this detail. */
    editPermissions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The ID of the detail */
    id: Scalars["ID"]["input"];
    /** The CustomerServicePermissionGroup IDs that are able to view this detail */
    readPermissions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceCustomDetailPermissionsUpdatePayload = Payload & {
    __typename?: "CustomerServiceCustomDetailPermissionsUpdatePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    successfullyUpdatedCustomDetail?: Maybe<CustomerServiceCustomDetail>;
};

export type CustomerServiceCustomDetailType = {
    __typename?: "CustomerServiceCustomDetailType";
    /** The type name for this custom detail */
    name: CustomerServiceCustomDetailTypeName;
    /** The options for selection available on this custom detail (only valid for select type) */
    options?: Maybe<Array<Scalars["String"]["output"]>>;
};

/**
 * The types of custom details that can exist
 * NOTE: Please do not modify enums without first notifying the FE team.
 */
export enum CustomerServiceCustomDetailTypeName {
    Boolean = "BOOLEAN",
    Date = "DATE",
    Email = "EMAIL",
    Multiselect = "MULTISELECT",
    Number = "NUMBER",
    Phone = "PHONE",
    Select = "SELECT",
    Text = "TEXT",
    Url = "URL",
    User = "USER"
}

export type CustomerServiceCustomDetailUpdateInput = {
    /** ID of the custom detail */
    id: Scalars["ID"]["input"];
    /** The updated name for the custom detail to update */
    name: Scalars["String"]["input"];
    /** The type of the custom detail to update */
    type?: InputMaybe<CustomerServiceCustomDetailUpdateTypeInput>;
};

export type CustomerServiceCustomDetailUpdatePayload = Payload & {
    __typename?: "CustomerServiceCustomDetailUpdatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Then name of the custom detail updated */
    successfullyUpdatedCustomDetail?: Maybe<CustomerServiceCustomDetail>;
};

export type CustomerServiceCustomDetailUpdateTypeInput = {
    /** The type of the custom detail to be updated */
    name?: InputMaybe<CustomerServiceCustomDetailTypeName>;
    /** Options for this type, only valid if the provided type is SELECT/MULTI-SELECT. Empty Otherwise. */
    options?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** The customer service organization attribute with a value */
export type CustomerServiceCustomDetailValue = Node & {
    __typename?: "CustomerServiceCustomDetailValue";
    /** Whether the viewer has permissions to edit this custom detail */
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    /** The config metadata for this custom detail */
    config?: Maybe<CustomerServiceCustomDetailConfigMetadata>;
    /** The ID of the custom detail */
    id: Scalars["ID"]["output"];
    /** The name of the custom detail */
    name: Scalars["String"]["output"];
    /** The platform value of the custom detail, if it is a single value */
    platformValue?: Maybe<CustomerServicePlatformDetailValue>;
    /** The type of the custom detail */
    type: CustomerServiceCustomDetailType;
    /** The value of the custom detail, if it is a single value */
    value?: Maybe<Scalars["String"]["output"]>;
    /** The values of the custom detail, if it is multi value */
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type CustomerServiceCustomDetailValues = {
    __typename?: "CustomerServiceCustomDetailValues";
    results: Array<CustomerServiceCustomDetailValue>;
};

export type CustomerServiceCustomDetailValuesQueryResult =
    | CustomerServiceCustomDetailValues
    | QueryError;

/** The customer service custom details defined on an entity */
export type CustomerServiceCustomDetails = {
    __typename?: "CustomerServiceCustomDetails";
    /** The list of all custom details defined on an entity */
    customDetails: Array<CustomerServiceCustomDetail>;
    /** The maximum number of custom details that can be created for this entity */
    maxAllowedCustomDetails?: Maybe<Scalars["Int"]["output"]>;
};

/** The available entities */
export enum CustomerServiceCustomDetailsEntityType {
    Customer = "CUSTOMER",
    Entitlement = "ENTITLEMENT",
    Organization = "ORGANIZATION"
}

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceCustomDetailsQueryResult =
    | CustomerServiceCustomDetails
    | QueryError;

/**
 * ########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceDefaultRoutingRuleInput = {
    /** ID of the issue type associated with the routing rule. */
    issueTypeId: Scalars["String"]["input"];
    /** ID of the project associated with the routing rule. */
    projectId: Scalars["ID"]["input"];
};

export type CustomerServiceEntitledEntity =
    | CustomerServiceIndividual
    | CustomerServiceOrganization;

export type CustomerServiceEntitlement = Node & {
    __typename?: "CustomerServiceEntitlement";
    /**
     * The custom details for the entitlement
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use details instead
     */
    customDetails: Array<CustomerServiceCustomDetailValue>;
    /** The custom detail values for the entitlement */
    details: CustomerServiceCustomDetailValuesQueryResult;
    /** The entity that this entitlement is for */
    entity: CustomerServiceEntitledEntity;
    /** The ID of the entitlement */
    id: Scalars["ID"]["output"];
    /** The product that the entitlement is for */
    product: CustomerServiceProduct;
};

/**
 * #########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceEntitlementAddInput = {
    /** The ID of the entity that the entitlement is for (customer or organization) */
    entitlementEntityId: CustomerServiceEntitlementEntityId;
    /** The ID of the product that the entitlement is for */
    productId: Scalars["ID"]["input"];
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceEntitlementAddPayload = {
    __typename?: "CustomerServiceEntitlementAddPayload";
    /** The added entitlement */
    addedEntitlement?: Maybe<CustomerServiceEntitlement>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceEntitlementConnection = {
    __typename?: "CustomerServiceEntitlementConnection";
    /** The list of entitlements with a cursor */
    edges: Array<CustomerServiceEntitlementEdge>;
    /** Pagination metadata */
    pageInfo: PageInfo;
};

export type CustomerServiceEntitlementEdge = {
    __typename?: "CustomerServiceEntitlementEdge";
    /** The pointer to the entitlement node */
    cursor: Scalars["String"]["output"];
    /** The entitlement node */
    node?: Maybe<CustomerServiceEntitlement>;
};

export type CustomerServiceEntitlementEntityId = {
    /** The ID of the customer that the entitlement is for */
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the organization that the entitlement is for */
    organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * ###############################
 *  Base objects for entitlements
 * ###############################
 */
export type CustomerServiceEntitlementFilterInput = {
    /** The product ID to filter entitlements results by */
    productId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceEntitlementQueryResult =
    | CustomerServiceEntitlement
    | QueryError;

export type CustomerServiceEntitlementRemoveInput = {
    /** The ID of the entitlement */
    entitlementId: Scalars["ID"]["input"];
};

export type CustomerServiceEntitlementRemovePayload = {
    __typename?: "CustomerServiceEntitlementRemovePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceFilterInput = {
    context: CustomerServiceContext;
};

/** The Individual entity represents an individual Atlassian Account or Customer Account */
export type CustomerServiceIndividual = Node & {
    __typename?: "CustomerServiceIndividual";
    /**
     * Custom attribute values
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use details instead
     */
    attributes: Array<CustomerServiceAttributeValue>;
    /** Custom detail values */
    details: CustomerServiceCustomDetailValuesQueryResult;
    /**
     * Entitlement entities associated with the customer
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'entitlementList' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    entitlementList: Array<CustomerServiceEntitlement>;
    /**
     * Entitlements associated with the customer
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'entitlements' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated use entitlementList instead
     */
    entitlements?: Maybe<CustomerServiceEntitlementConnection>;
    /** The ID of the individual - may be Atlassian Account ID or Customer Account ID */
    id: Scalars["ID"]["output"];
    /** Name of the individual */
    name: Scalars["String"]["output"];
    /** Notes */
    notes: CustomerServiceNotes;
    /** Organization list associated with the customer */
    organizations: Array<CustomerServiceOrganization>;
};

/** The Individual entity represents an individual Atlassian Account or Customer Account */
export type CustomerServiceIndividualEntitlementListArgs = {
    filter?: InputMaybe<CustomerServiceEntitlementFilterInput>;
};

/** The Individual entity represents an individual Atlassian Account or Customer Account */
export type CustomerServiceIndividualEntitlementsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<CustomerServiceEntitlementFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The Individual entity represents an individual Atlassian Account or Customer Account */
export type CustomerServiceIndividualNotesArgs = {
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    startAt?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CustomerServiceIndividualDeletePayload = Payload & {
    __typename?: "CustomerServiceIndividualDeletePayload";
    /**
     * The list of errors occurred during deleting the attribute
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The result whether the request is executed successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceIndividualQueryResult =
    | CustomerServiceIndividual
    | QueryError;

export type CustomerServiceIndividualUpdateAttributeByNameInput = {
    /** Account ID of the individual whose attribute you wish to update */
    accountId: Scalars["String"]["input"];
    /** The name of the attribute whose value should be updated */
    attributeName: Scalars["String"]["input"];
    /** The new value for the attribute */
    attributeValue: Scalars["String"]["input"];
};

/**
 * ########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceIndividualUpdateAttributeInput = {
    /** Account ID of the individual whose attribute you wish to update */
    accountId: Scalars["String"]["input"];
    /** The ID of the attribute whose value should be updated */
    attributeId: Scalars["String"]["input"];
    /** The new value for the attribute */
    attributeValue: Scalars["String"]["input"];
};

export type CustomerServiceIndividualUpdateAttributeMultiValueByNameInput = {
    /** Account ID of the individual whose attribute you wish to update */
    accountId: Scalars["String"]["input"];
    /** The name of the attribute whose value should be updated */
    attributeName: Scalars["String"]["input"];
    /** The new value for the attribute */
    attributeValues: Array<Scalars["String"]["input"]>;
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceIndividualUpdateAttributeValuePayload = Payload & {
    __typename?: "CustomerServiceIndividualUpdateAttributeValuePayload";
    /** The details of the updated attribute */
    attribute?: Maybe<CustomerServiceAttributeValue>;
    /** The list of errors occurred during updating the attribute */
    errors?: Maybe<Array<MutationError>>;
    /** The result whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceMutationApi = {
    __typename?: "CustomerServiceMutationApi";
    /**
     * This is to add an entitlement to an organization or customer for a product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'addEntitlement' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addEntitlement?: Maybe<CustomerServiceEntitlementAddPayload>;
    /**
     * This is to create a custom detail for an entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'createCustomDetail' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createCustomDetail?: Maybe<CustomerServiceCustomDetailCreatePayload>;
    /**
     * This to create a new Individual attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use createCustomDetail instead
     */
    createIndividualAttribute?: Maybe<CustomerServiceAttributeCreatePayload>;
    /**
     * ####################################
     *  Notes
     * ####################################
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createNote?: Maybe<CustomerServiceNoteCreatePayload>;
    /**
     * This to create a new organization in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createOrganization?: Maybe<CustomerServiceOrganizationCreatePayload>;
    /**
     * This to create a new organization attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use createCustomDetail instead
     */
    createOrganizationAttribute?: Maybe<CustomerServiceAttributeCreatePayload>;
    /**
     * This is to create a new product in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'createProduct' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProduct?: Maybe<CustomerServiceProductCreatePayload>;
    /**
     * This is to create a new template form against a help center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createTemplateForm?: Maybe<CustomerServiceTemplateFormCreatePayload>;
    /**
     * This is to delete an existing custom detail for an entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'deleteCustomDetail' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteCustomDetail?: Maybe<CustomerServiceCustomDetailDeletePayload>;
    /**
     * This is to delete an existing Individual attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use deleteCustomDetail instead
     */
    deleteIndividualAttribute?: Maybe<CustomerServiceAttributeDeletePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteNote?: Maybe<CustomerServiceNoteDeletePayload>;
    /**
     * This is to delete an existing organization in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteOrganization?: Maybe<CustomerServiceOrganizationDeletePayload>;
    /**
     * This is to delete an existing organization attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use deleteCustomDetail instead
     */
    deleteOrganizationAttribute?: Maybe<CustomerServiceAttributeDeletePayload>;
    /**
     * This is to delete an existing product in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'deleteProduct' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProduct?: Maybe<CustomerServiceProductDeletePayload>;
    /**
     * This is to delete an existing template form
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteTemplateForm?: Maybe<CustomerServiceTemplateFormDeletePayload>;
    /**
     * This is to remove an entitlement to an organization or customer for a product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'removeEntitlement' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeEntitlement?: Maybe<CustomerServiceEntitlementRemovePayload>;
    /**
     * This is to update an existing custom detail for an entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'updateCustomDetail' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateCustomDetail?: Maybe<CustomerServiceCustomDetailUpdatePayload>;
    /**
     * This is to update the custom detail config for an existing custom detail
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'updateCustomDetailConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateCustomDetailConfig?: Maybe<CustomerServiceCustomDetailConfigMetadataUpdatePayload>;
    /**
     * This is to update the custom detail config for an existing custom detail in bulk
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateCustomDetailContextConfigs?: Maybe<CustomerServiceUpdateCustomDetailContextConfigsPayload>;
    /**
     * Updates who can view and edit a given custom detail
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateCustomDetailPermissions?: Maybe<CustomerServiceCustomDetailPermissionsUpdatePayload>;
    /**
     * This is to update the value of a custom detail for a given entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'updateCustomDetailValue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateCustomDetailValue?: Maybe<CustomerServiceUpdateCustomDetailValuePayload>;
    /**
     * This is to update an existing Individual attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetail instead
     */
    updateIndividualAttribute?: Maybe<CustomerServiceAttributeUpdatePayload>;
    /**
     * This is to update the attribute config for an existing individual attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetailConfig instead
     */
    updateIndividualAttributeConfig?: Maybe<CustomerServiceAttributeConfigMetadataUpdatePayload>;
    /**
     * This is to update the value of an attribute, for a given individual, by the attribute name, where the attribute accepts multiple values (eg a multiselect field)
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetailValue instead
     */
    updateIndividualAttributeMultiValueByName?: Maybe<CustomerServiceIndividualUpdateAttributeValuePayload>;
    /**
     * This is to update the value of an attribute, for a given individual, by the attribute name, where the attribute accepts a single value
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetailValue instead
     */
    updateIndividualAttributeValueByName?: Maybe<CustomerServiceIndividualUpdateAttributeValuePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateNote?: Maybe<CustomerServiceNoteUpdatePayload>;
    /**
     * This is to update an existing organization in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateOrganization?: Maybe<CustomerServiceOrganizationUpdatePayload>;
    /**
     * This is to update an existing organization attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetail instead
     */
    updateOrganizationAttribute?: Maybe<CustomerServiceAttributeUpdatePayload>;
    /**
     * This is to update the attribute config for an existing organization attribute
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetailConfig instead
     */
    updateOrganizationAttributeConfig?: Maybe<CustomerServiceAttributeConfigMetadataUpdatePayload>;
    /**
     * This is to update the value of an attribute, for a given organization, by the attribute name, where the attribute accepts multiple values (eg a multiselect field)
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetailValue instead
     */
    updateOrganizationAttributeMultiValueByName?: Maybe<CustomerServiceOrganizationUpdateAttributeValuePayload>;
    /**
     * This is to update the value of an attribute, for a given organization
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateOrganizationAttributeValue?: Maybe<CustomerServiceOrganizationUpdateAttributeValuePayload>;
    /**
     * This is to update the value of an attribute, for a given organization, by the attribute name, where the attribute accepts a single value
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use updateCustomDetailValue instead
     */
    updateOrganizationAttributeValueByName?: Maybe<CustomerServiceOrganizationUpdateAttributeValuePayload>;
    /**
     * This is to update an existing product in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'updateProduct' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateProduct?: Maybe<CustomerServiceProductUpdatePayload>;
    /**
     * This is to update an existing template form stored against a help center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateTemplateForm?: Maybe<CustomerServiceTemplateFormUpdatePayload>;
};

export type CustomerServiceMutationApiAddEntitlementArgs = {
    input: CustomerServiceEntitlementAddInput;
};

export type CustomerServiceMutationApiCreateCustomDetailArgs = {
    input: CustomerServiceCustomDetailCreateInput;
};

export type CustomerServiceMutationApiCreateIndividualAttributeArgs = {
    input: CustomerServiceAttributeCreateInput;
};

export type CustomerServiceMutationApiCreateNoteArgs = {
    input?: InputMaybe<CustomerServiceNoteCreateInput>;
};

export type CustomerServiceMutationApiCreateOrganizationArgs = {
    input: CustomerServiceOrganizationCreateInput;
};

export type CustomerServiceMutationApiCreateOrganizationAttributeArgs = {
    input: CustomerServiceAttributeCreateInput;
};

export type CustomerServiceMutationApiCreateProductArgs = {
    input: CustomerServiceProductCreateInput;
};

export type CustomerServiceMutationApiCreateTemplateFormArgs = {
    input: CustomerServiceTemplateFormCreateInput;
};

export type CustomerServiceMutationApiDeleteCustomDetailArgs = {
    input: CustomerServiceCustomDetailDeleteInput;
};

export type CustomerServiceMutationApiDeleteIndividualAttributeArgs = {
    input: CustomerServiceAttributeDeleteInput;
};

export type CustomerServiceMutationApiDeleteNoteArgs = {
    input?: InputMaybe<CustomerServiceNoteDeleteInput>;
};

export type CustomerServiceMutationApiDeleteOrganizationArgs = {
    input: CustomerServiceOrganizationDeleteInput;
};

export type CustomerServiceMutationApiDeleteOrganizationAttributeArgs = {
    input: CustomerServiceAttributeDeleteInput;
};

export type CustomerServiceMutationApiDeleteProductArgs = {
    input: CustomerServiceProductDeleteInput;
};

export type CustomerServiceMutationApiDeleteTemplateFormArgs = {
    input: CustomerServiceTemplateFormDeleteInput;
};

export type CustomerServiceMutationApiRemoveEntitlementArgs = {
    input: CustomerServiceEntitlementRemoveInput;
};

export type CustomerServiceMutationApiUpdateCustomDetailArgs = {
    input: CustomerServiceCustomDetailUpdateInput;
};

export type CustomerServiceMutationApiUpdateCustomDetailConfigArgs = {
    input: CustomerServiceCustomDetailConfigMetadataUpdateInput;
};

export type CustomerServiceMutationApiUpdateCustomDetailContextConfigsArgs = {
    input: Array<CustomerServiceCustomDetailContextInput>;
};

export type CustomerServiceMutationApiUpdateCustomDetailPermissionsArgs = {
    input: CustomerServiceCustomDetailPermissionsUpdateInput;
};

export type CustomerServiceMutationApiUpdateCustomDetailValueArgs = {
    input: CustomerServiceUpdateCustomDetailValueInput;
};

export type CustomerServiceMutationApiUpdateIndividualAttributeArgs = {
    input: CustomerServiceAttributeUpdateInput;
};

export type CustomerServiceMutationApiUpdateIndividualAttributeConfigArgs = {
    input: CustomerServiceAttributeConfigMetadataUpdateInput;
};

export type CustomerServiceMutationApiUpdateIndividualAttributeMultiValueByNameArgs =
    {
        input: CustomerServiceIndividualUpdateAttributeMultiValueByNameInput;
    };

export type CustomerServiceMutationApiUpdateIndividualAttributeValueByNameArgs =
    {
        input: CustomerServiceIndividualUpdateAttributeByNameInput;
    };

export type CustomerServiceMutationApiUpdateNoteArgs = {
    input?: InputMaybe<CustomerServiceNoteUpdateInput>;
};

export type CustomerServiceMutationApiUpdateOrganizationArgs = {
    input: CustomerServiceOrganizationUpdateInput;
};

export type CustomerServiceMutationApiUpdateOrganizationAttributeArgs = {
    input: CustomerServiceAttributeUpdateInput;
};

export type CustomerServiceMutationApiUpdateOrganizationAttributeConfigArgs = {
    input: CustomerServiceAttributeConfigMetadataUpdateInput;
};

export type CustomerServiceMutationApiUpdateOrganizationAttributeMultiValueByNameArgs =
    {
        input: CustomerServiceOrganizationUpdateAttributeMultiValueByNameInput;
    };

export type CustomerServiceMutationApiUpdateOrganizationAttributeValueArgs = {
    input: CustomerServiceOrganizationUpdateAttributeInput;
};

export type CustomerServiceMutationApiUpdateOrganizationAttributeValueByNameArgs =
    {
        input: CustomerServiceOrganizationUpdateAttributeByNameInput;
    };

export type CustomerServiceMutationApiUpdateProductArgs = {
    input: CustomerServiceProductUpdateInput;
};

export type CustomerServiceMutationApiUpdateTemplateFormArgs = {
    helpCenterId: Scalars["ID"]["input"];
    input: CustomerServiceTemplateFormUpdateInput;
    templateFormId: Scalars["ID"]["input"];
};

export type CustomerServiceNote = {
    __typename?: "CustomerServiceNote";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    author: CustomerServiceNoteAuthor;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    body: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canDelete: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canEdit: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    created: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updated: Scalars["String"]["output"];
};

export type CustomerServiceNoteAuthor = {
    __typename?: "CustomerServiceNoteAuthor";
    avatarUrl: Scalars["String"]["output"];
    displayName: Scalars["String"]["output"];
    emailAddress?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    isDeleted: Scalars["Boolean"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type CustomerServiceNoteCreateInput = {
    body: Scalars["String"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: CustomerServiceNoteEntity;
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceNoteCreatePayload = Payload & {
    __typename?: "CustomerServiceNoteCreatePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    successfullyCreatedNote?: Maybe<CustomerServiceNote>;
};

export type CustomerServiceNoteDeleteInput = {
    entityId: Scalars["ID"]["input"];
    entityType: CustomerServiceNoteEntity;
    noteId: Scalars["ID"]["input"];
};

export type CustomerServiceNoteDeletePayload = Payload & {
    __typename?: "CustomerServiceNoteDeletePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 * ########################
 *  Mutation Inputs
 * #########################
 */
export enum CustomerServiceNoteEntity {
    Customer = "CUSTOMER",
    Organization = "ORGANIZATION"
}

export type CustomerServiceNoteUpdateInput = {
    body: Scalars["String"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: CustomerServiceNoteEntity;
    noteId: Scalars["ID"]["input"];
};

export type CustomerServiceNoteUpdatePayload = Payload & {
    __typename?: "CustomerServiceNoteUpdatePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    successfullyUpdatedNote?: Maybe<CustomerServiceNote>;
};

/**
 * ###############################
 *  Base objects for notes
 * ###############################
 */
export type CustomerServiceNotes = {
    __typename?: "CustomerServiceNotes";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    results: Array<CustomerServiceNote>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    total: Scalars["Int"]["output"];
};

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceNotesQueryResult = CustomerServiceNotes | QueryError;

/** The CustomerOrganization entity represents the organization against which the tickets are created. */
export type CustomerServiceOrganization = Node & {
    __typename?: "CustomerServiceOrganization";
    /**
     * Custom attribute values
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use details instead
     */
    attributes: Array<CustomerServiceAttributeValue>;
    /** Custom detail values */
    details: CustomerServiceCustomDetailValuesQueryResult;
    /**
     * Entitlement entities associated with the organization
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'entitlementList' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    entitlementList: Array<CustomerServiceEntitlement>;
    /**
     * Entitlements associated with the organization
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'entitlements' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated use entitlementList instead
     */
    entitlements?: Maybe<CustomerServiceEntitlementConnection>;
    /** The ID of the CustomerService Organization */
    id: Scalars["ID"]["output"];
    /** Name of the organization */
    name: Scalars["String"]["output"];
    /** Notes */
    notes: CustomerServiceNotes;
};

/** The CustomerOrganization entity represents the organization against which the tickets are created. */
export type CustomerServiceOrganizationEntitlementListArgs = {
    filter?: InputMaybe<CustomerServiceEntitlementFilterInput>;
};

/** The CustomerOrganization entity represents the organization against which the tickets are created. */
export type CustomerServiceOrganizationEntitlementsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<CustomerServiceEntitlementFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The CustomerOrganization entity represents the organization against which the tickets are created. */
export type CustomerServiceOrganizationNotesArgs = {
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    startAt?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * ########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceOrganizationCreateInput = {
    /** The ID of the organization to create */
    id: Scalars["ID"]["input"];
    /** Organization name to be created */
    name: Scalars["String"]["input"];
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceOrganizationCreatePayload = Payload & {
    __typename?: "CustomerServiceOrganizationCreatePayload";
    /** The list of errors occurred during creating the organization */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
    /** Organization Id for the organization that was stored in Assets. Would be empty if the operation was not successful */
    successfullyCreatedOrganizationId?: Maybe<Scalars["ID"]["output"]>;
};

export type CustomerServiceOrganizationDeleteInput = {
    /** The ID of the organization to delete */
    id: Scalars["ID"]["input"];
};

export type CustomerServiceOrganizationDeletePayload = Payload & {
    __typename?: "CustomerServiceOrganizationDeletePayload";
    /** The list of errors occurred during deleted the organization */
    errors?: Maybe<Array<MutationError>>;
    /** The result whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceOrganizationQueryResult =
    | CustomerServiceOrganization
    | QueryError;

export type CustomerServiceOrganizationUpdateAttributeByNameInput = {
    /** The name of the attribute whose value should be updated */
    attributeName: Scalars["String"]["input"];
    /** The new value for the attribute */
    attributeValue: Scalars["String"]["input"];
    /** ID of the organisation whose attribute you wish to update */
    organizationId: Scalars["String"]["input"];
};

export type CustomerServiceOrganizationUpdateAttributeInput = {
    /** The ID of the attribute whose value should be updated */
    attributeId: Scalars["String"]["input"];
    /** The new value for the attribute */
    attributeValue: Scalars["String"]["input"];
    /** ID of the organisation whose attribute you wish to update */
    organizationId: Scalars["String"]["input"];
};

export type CustomerServiceOrganizationUpdateAttributeMultiValueByNameInput = {
    /** The name of the attribute whose value should be updated */
    attributeName: Scalars["String"]["input"];
    /** The new values for the attribute */
    attributeValues: Array<Scalars["String"]["input"]>;
    /** ID of the organisation whose attribute you wish to update */
    organizationId: Scalars["String"]["input"];
};

export type CustomerServiceOrganizationUpdateAttributeValuePayload = Payload & {
    __typename?: "CustomerServiceOrganizationUpdateAttributeValuePayload";
    /** The details of the updated attribute */
    attribute?: Maybe<CustomerServiceAttributeValue>;
    /** The list of errors occurred during updating the organization */
    errors?: Maybe<Array<MutationError>>;
    /** The result whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceOrganizationUpdateInput = {
    /** The ID of the organization to update */
    id: Scalars["ID"]["input"];
    /** Organization name to be updated */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type CustomerServiceOrganizationUpdatePayload = Payload & {
    __typename?: "CustomerServiceOrganizationUpdatePayload";
    /** The list of errors occurred during updating the organization */
    errors?: Maybe<Array<MutationError>>;
    /** The result whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
    /** Organization Id for the organization that were updated in Assets. Would be empty if the operation was not successful */
    successfullyUpdatedOrganizationId?: Maybe<Scalars["ID"]["output"]>;
};

export type CustomerServicePermissionGroup = {
    __typename?: "CustomerServicePermissionGroup";
    /** The ID is currently hard-coded to be the same as the type enum, but can be swapped out for real IDs in the future. */
    id: Scalars["ID"]["output"];
    type?: Maybe<CustomerServicePermissionGroupType>;
};

export type CustomerServicePermissionGroupConnection = {
    __typename?: "CustomerServicePermissionGroupConnection";
    edges?: Maybe<Array<CustomerServicePermissionGroupEdge>>;
};

export type CustomerServicePermissionGroupEdge = {
    __typename?: "CustomerServicePermissionGroupEdge";
    node?: Maybe<CustomerServicePermissionGroup>;
};

export enum CustomerServicePermissionGroupType {
    Admins = "ADMINS",
    AdminsAgents = "ADMINS_AGENTS",
    AdminsAgentsSiteAccess = "ADMINS_AGENTS_SITE_ACCESS"
}

/**
 * ###############################
 *  Base objects for platform values
 * ###############################
 *  Note: Add any additional platform values to this union
 */
export type CustomerServicePlatformDetailValue = CustomerServiceUserDetailValue;

export type CustomerServiceProduct = Node & {
    __typename?: "CustomerServiceProduct";
    /** The number of entitlements associated with the product */
    entitlementsCount?: Maybe<Scalars["Int"]["output"]>;
    /** The ID of the product */
    id: Scalars["ID"]["output"];
    /** The name of the product */
    name: Scalars["String"]["output"];
};

/**
 * ###############################
 *  Base objects for products
 * ###############################
 */
export type CustomerServiceProductConnection = {
    __typename?: "CustomerServiceProductConnection";
    /** The list of products with a cursor */
    edges: Array<CustomerServiceProductEdge>;
    /** Pagination metadata */
    pageInfo: PageInfo;
};

/**
 * #########################
 *  Mutation Inputs
 * #########################
 */
export type CustomerServiceProductCreateInput = {
    /** The name of the new product */
    name: Scalars["String"]["input"];
};

/**
 * ########################
 *  Mutation Responses
 * ########################
 */
export type CustomerServiceProductCreatePayload = Payload & {
    __typename?: "CustomerServiceProductCreatePayload";
    /** The new product */
    createdProduct?: Maybe<CustomerServiceProduct>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceProductDeleteInput = {
    /** The ID of the product to be deleted */
    id: Scalars["ID"]["input"];
};

export type CustomerServiceProductDeletePayload = Payload & {
    __typename?: "CustomerServiceProductDeletePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceProductEdge = {
    __typename?: "CustomerServiceProductEdge";
    /** The pointer to the product node */
    cursor: Scalars["String"]["output"];
    /** The product node */
    node?: Maybe<CustomerServiceProduct>;
};

export type CustomerServiceProductFilterInput = {
    /** Case insensitive string to filter products by names they begin with */
    nameBeginsWith?: InputMaybe<Scalars["String"]["input"]>;
    /** Case insensitive string to filter product names with */
    nameContains?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceProductQueryResult =
    | CustomerServiceProductConnection
    | QueryError;

export type CustomerServiceProductUpdateInput = {
    /** The ID of the product to be updated */
    id: Scalars["ID"]["input"];
    /** The updated name of the product */
    name: Scalars["String"]["input"];
};

export type CustomerServiceProductUpdatePayload = Payload & {
    __typename?: "CustomerServiceProductUpdatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** The updated product */
    updatedProduct?: Maybe<CustomerServiceProduct>;
};

export type CustomerServiceQueryApi = {
    __typename?: "CustomerServiceQueryApi";
    /**
     * This is to query all the attributes by attribute entity type (organization, customer, or entitlement)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'customDetailsByEntityType' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    customDetailsByEntityType?: Maybe<CustomerServiceCustomDetailsQueryResult>;
    /**
     * This is to query an entitlement by its id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'entitlementById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    entitlementById?: Maybe<CustomerServiceEntitlementQueryResult>;
    /**
     * This is to query all the attributes defined on individuals
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use customDetailsByEntityType instead
     */
    individualAttributes?: Maybe<CustomerServiceAttributesQueryResult>;
    /**
     * This is to query individuals by the accountId in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    individualByAccountId?: Maybe<CustomerServiceIndividualQueryResult>;
    /**
     * This is to query all the attributes defined on organizations
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use customDetailsByEntityType instead
     */
    organizationAttributes?: Maybe<CustomerServiceAttributesQueryResult>;
    /**
     * This is to query organizations by the organizationId in JCS
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    organizationByOrganizationId?: Maybe<CustomerServiceOrganizationQueryResult>;
    /**
     * This is to query all the products for a site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'productConnections' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    productConnections?: Maybe<CustomerServiceProductConnection>;
    /**
     * This is to query all the products for a site
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CustomerServiceProductsAndEntitlementsM1")' query directive to the 'products' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use productConnections instead
     */
    products?: Maybe<CustomerServiceProductQueryResult>;
    /**
     * This is to query a help center template form
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    templateFormById?: Maybe<CustomerServiceTemplateFormQueryResult>;
    /**
     * This is to query all template forms for a help center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    templateForms?: Maybe<CustomerServiceTemplateFormConnection>;
};

export type CustomerServiceQueryApiCustomDetailsByEntityTypeArgs = {
    customDetailsEntityType: CustomerServiceCustomDetailsEntityType;
};

export type CustomerServiceQueryApiEntitlementByIdArgs = {
    entitlementId: Scalars["ID"]["input"];
    filter?: InputMaybe<CustomerServiceFilterInput>;
};

export type CustomerServiceQueryApiIndividualByAccountIdArgs = {
    accountId: Scalars["ID"]["input"];
    filter?: InputMaybe<CustomerServiceFilterInput>;
};

export type CustomerServiceQueryApiOrganizationByOrganizationIdArgs = {
    filter?: InputMaybe<CustomerServiceFilterInput>;
    organizationId: Scalars["ID"]["input"];
};

export type CustomerServiceQueryApiProductConnectionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<CustomerServiceProductFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CustomerServiceQueryApiProductsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<CustomerServiceProductFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CustomerServiceQueryApiTemplateFormByIdArgs = {
    helpCenterId: Scalars["ID"]["input"];
    templateFormId: Scalars["ID"]["input"];
};

export type CustomerServiceQueryApiTemplateFormsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    helpCenterId: Scalars["ID"]["input"];
};

export type CustomerServiceRoutingRule = {
    __typename?: "CustomerServiceRoutingRule";
    /** ID of the routing rule. */
    id: Scalars["ID"]["output"];
    /** URL for the icon issue type associated with the routing rule. */
    issueTypeIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** ID of the issue type associated with the routing rule. */
    issueTypeId?: Maybe<Scalars["ID"]["output"]>;
    /** Name of the issue type associated with the routing rule. */
    issueTypeName?: Maybe<Scalars["String"]["output"]>;
    /** Details of the project type. */
    project?: Maybe<JiraProject>;
    /** ID of the project associated with the routing rule. */
    projectId?: Maybe<Scalars["ID"]["output"]>;
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type CustomerServiceStatusPayload = Payload & {
    __typename?: "CustomerServiceStatusPayload";
    /**
     * The list of errors occurred during update request type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The result of whether the request is created/updated successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * ###############################
 *  Base objects for form request intake
 * ###############################
 */
export type CustomerServiceTemplateForm = Node & {
    __typename?: "CustomerServiceTemplateForm";
    /** The default routing rule for the template. Will have a project and issue type associated with it. */
    defaultRouteRule?: Maybe<CustomerServiceRoutingRule>;
    /**
     *  Details of the help center.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterAggBeta")' query directive to the 'helpCenter' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpCenter?: Maybe<HelpCenterQueryResult>;
    /** ID of the help centre associated with the form, as an ARI. */
    helpCenterId: Scalars["ID"]["output"];
    /** ID of the form, as an ARI. */
    id: Scalars["ID"]["output"];
    /** Name of the form. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/**
 * ########################
 *  Pagination and Edges
 * #########################
 */
export type CustomerServiceTemplateFormConnection = {
    __typename?: "CustomerServiceTemplateFormConnection";
    /** The list of template forms with a cursor */
    edges: Array<CustomerServiceTemplateFormEdge>;
    /** Pagination metadata */
    pageInfo: PageInfo;
};

export type CustomerServiceTemplateFormCreateInput = {
    /** The default routing rule */
    defaultRoutingRule?: InputMaybe<CustomerServiceDefaultRoutingRuleInput>;
    /** The ID of the help center to configure the form against */
    helpCenterId: Scalars["ID"]["input"];
    /** The name of the new template form */
    name: Scalars["String"]["input"];
};

/**
 * ########################
 *  Mutation Payloads
 * #########################
 */
export type CustomerServiceTemplateFormCreatePayload = Payload & {
    __typename?: "CustomerServiceTemplateFormCreatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** The newly created template form */
    successfullyCreatedTemplateForm?: Maybe<CustomerServiceTemplateFormEdge>;
};

export type CustomerServiceTemplateFormDeleteInput = {
    /** ID of the help center the template form is associated with, as an ARI */
    helpCenterId: Scalars["ID"]["input"];
    /** ID of the template form to be deleted, as an ARI */
    templateFormId: Scalars["ID"]["input"];
};

export type CustomerServiceTemplateFormDeletePayload = Payload & {
    __typename?: "CustomerServiceTemplateFormDeletePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceTemplateFormEdge = {
    __typename?: "CustomerServiceTemplateFormEdge";
    /** The pointed to a template form node */
    cursor: Scalars["String"]["output"];
    /** The template form node */
    node?: Maybe<CustomerServiceTemplateForm>;
};

/**
 * #########################
 *  Query Responses
 * #########################
 */
export type CustomerServiceTemplateFormQueryResult =
    | CustomerServiceTemplateForm
    | QueryError;

export type CustomerServiceTemplateFormUpdateInput = {
    /** The update default routing rule for the form */
    defaultRoutingRule?: InputMaybe<CustomerServiceDefaultRoutingRuleInput>;
};

export type CustomerServiceTemplateFormUpdatePayload = Payload & {
    __typename?: "CustomerServiceTemplateFormUpdatePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** The newly created template form */
    successfullyCreatedTemplateForm?: Maybe<CustomerServiceTemplateFormEdge>;
};

export type CustomerServiceUpdateCustomDetailContextConfigsPayload = Payload & {
    __typename?: "CustomerServiceUpdateCustomDetailContextConfigsPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** A list of the successfully updated custom details */
    successfullyUpdatedCustomDetails: Array<CustomerServiceCustomDetail>;
};

export type CustomerServiceUpdateCustomDetailValueInput = {
    /** ID of the entity whose custom detail you wish to update */
    id: CustomerServiceCustomDetailEntityTypeId;
    /** The name of the custom detail whose value should be updated */
    name: Scalars["String"]["input"];
    /** The new value for the custom detail, for a single value field */
    value?: InputMaybe<Scalars["String"]["input"]>;
    /** The new value for the custom detail, for a multi-value field */
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type CustomerServiceUpdateCustomDetailValuePayload = Payload & {
    __typename?: "CustomerServiceUpdateCustomDetailValuePayload";
    /** The updated custom detail */
    customDetail?: Maybe<CustomerServiceCustomDetailValue>;
    /** The list of errors occurred during updating the custom detail */
    errors?: Maybe<Array<MutationError>>;
    /** The result whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type CustomerServiceUserDetailValue = {
    __typename?: "CustomerServiceUserDetailValue";
    accountId?: Maybe<Scalars["ID"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

/**
 * This represents a real person that has an free account within the Jira Service Desk product
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 *
 *
 */
export type CustomerUser = LocalizationContext &
    User & {
        __typename?: "CustomerUser";
        accountId: Scalars["ID"]["output"];
        accountStatus: AccountStatus;
        canonicalAccountId: Scalars["ID"]["output"];
        email?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        locale?: Maybe<Scalars["String"]["output"]>;
        name: Scalars["String"]["output"];
        picture: Scalars["URL"]["output"];
        zoneinfo?: Maybe<Scalars["String"]["output"]>;
    };

export type DataAccessAndStorage = {
    __typename?: "DataAccessAndStorage";
    /** Does the app process End-User Data outside of Atlassian products and services? */
    appProcessEUDOutsideAtlassian?: Maybe<Scalars["Boolean"]["output"]>;
    /** Does the app store End-User Data outside of Atlassian products and services? */
    appStoresEUDOutsideAtlassian?: Maybe<Scalars["Boolean"]["output"]>;
    /** Does the app process and/or store End-User Data? */
    isSameDataProcessedAndStored?: Maybe<Scalars["Boolean"]["output"]>;
    /** List of End-User Data types the app processes */
    typesOfDataAccessed?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** List of End-User Data types the app stores */
    typesOfDataStored?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type DataClassificationPolicyDecision = {
    __typename?: "DataClassificationPolicyDecision";
    status: DataClassificationPolicyDecisionStatus;
};

export type DataClassificationPolicyDecisionInput = {
    dataClassificationTags: Array<Scalars["ID"]["input"]>;
};

export enum DataClassificationPolicyDecisionStatus {
    Allowed = "ALLOWED",
    Blocked = "BLOCKED"
}

export type DataController = {
    __typename?: "DataController";
    /** If the app is a "data controller" under the General Data Protection Regulation (GDPR), List of End-User Data with respect to which the app is a "data controller" */
    endUserDataTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Is the app a "data controller" under the General Data Protection Regulation (GDPR)? */
    isAppDataController: AcceptableResponse;
};

export type DataProcessingAgreement = {
    __typename?: "DataProcessingAgreement";
    /** Does the app have a Data Processing Agreement (DPA) for customers? */
    isDPASupported: AcceptableResponse;
    /** Link to the Data Processing Agreement (DPA) for customers. */
    link: Scalars["String"]["output"];
};

export type DataProcessor = {
    __typename?: "DataProcessor";
    /** If the app is a "data processor" under the General Data Protection Regulation (GDPR), List of End-User Data with respect to which the app is a "data processor" */
    endUserDataTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Is the app a "data processor" under the General Data Protection Regulation (GDPR)? */
    isAppDataProcessor: AcceptableResponse;
};

export type DataResidency = {
    __typename?: "DataResidency";
    /** List of locations indicated by partner where data residency is supported */
    countriesWhereEndUserDataStored?: Maybe<
        Array<Maybe<Scalars["String"]["output"]>>
    >;
    /** List of in-scope End-User Data type */
    inScopeDataTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Does the App support data residency? */
    isDataResidencySupported: DataResidencyResponse;
    /** Does the app support migration of in-scope End User Data between the data residency supported locations? */
    realmMigrationSupported?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum DataResidencyResponse {
    AppDoesNotSupportDr = "APP_DOES_NOT_SUPPORT_DR",
    NotApplicable = "NOT_APPLICABLE",
    StoredExternalToAtlassian = "STORED_EXTERNAL_TO_ATLASSIAN",
    StoredInAtlassianAndDrNotSupported = "STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED",
    StoredInAtlassianAndDrSupported = "STORED_IN_ATLASSIAN_AND_DR_SUPPORTED"
}

export type DataRetention = {
    __typename?: "DataRetention";
    /** Does the app allow customers to request a custom End-User Data retention period? */
    isCustomRetentionPeriodAllowed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is end-user data stored? */
    isDataRetentionSupported: Scalars["Boolean"]["output"];
    /** Does the app store End-User Data indefinitely? */
    isRetentionDurationIndefinite?: Maybe<Scalars["Boolean"]["output"]>;
    retentionDurationInDays?: Maybe<RetentionDurationInDays>;
};

export enum DataSecurityPolicyAction {
    AiAccess = "AI_ACCESS",
    AppAccess = "APP_ACCESS",
    PageExport = "PAGE_EXPORT",
    PublicLinks = "PUBLIC_LINKS"
}

export enum DataSecurityPolicyCoverageType {
    ClassificationLevel = "CLASSIFICATION_LEVEL",
    Container = "CONTAINER",
    None = "NONE",
    Workspace = "WORKSPACE"
}

export enum DataSecurityPolicyDecidableContentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export type DataSecurityPolicyDecision = {
    __typename?: "DataSecurityPolicyDecision";
    action?: Maybe<DataSecurityPolicyAction>;
    allowed?: Maybe<Scalars["Boolean"]["output"]>;
    appliedCoverage?: Maybe<DataSecurityPolicyCoverageType>;
};

export type DataTransfer = {
    __typename?: "DataTransfer";
    /** Does the app transfer European Economic Area (EEA) residents’s End-User Data outside of the EEA? */
    isEndUserDataTransferredOutsideEEA: Scalars["Boolean"]["output"];
    /** Does the app have a General Data Protection Regulation (GDPR) approved transfer mechanism in place to govern those transfers? */
    isTransferComplianceMechanismsAdhered?: Maybe<Scalars["Boolean"]["output"]>;
    /** Transfer mechanism adhered. */
    transferComplianceMechanismsAdheredDetails?: Maybe<
        Scalars["String"]["output"]
    >;
};

/** Time ranges of invocation date. */
export type DateSearchInput = {
    /**
     * The start time of the earliest invocation to include in the results.
     * If null, search results will only be limited by retention limits.
     *
     * RFC-3339 formatted timestamp.
     */
    earliestStart?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The start time of the latest invocation to include in the results.
     * If null, will include most recent invocations.
     *
     * RFC-3339 formatted timestamp.
     */
    latestStart?: InputMaybe<Scalars["String"]["input"]>;
};

export type DeactivatePaywallContentInput = {
    deactivationIdentifier: Scalars["ID"]["input"];
};

export type DeactivatePaywallContentPayload = Payload & {
    __typename?: "DeactivatePaywallContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<MutationError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum DeactivatedPageOwnerUserType {
    FormerUsers = "FORMER_USERS",
    NonFormerUsers = "NON_FORMER_USERS"
}

export type DeactivatedUserPageCountEntity = {
    __typename?: "DeactivatedUserPageCountEntity";
    accountId?: Maybe<Scalars["ID"]["output"]>;
    pageCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DeactivatedUserPageCountEntityEdge = {
    __typename?: "DeactivatedUserPageCountEntityEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<DeactivatedUserPageCountEntity>;
};

export type DefaultSpaceRoleAssignmentsConnection = {
    __typename?: "DefaultSpaceRoleAssignmentsConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SpaceRoleAssignmentEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<SpaceRoleAssignment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SpacePermissionPageInfo;
};

export type DeleteAppEnvironmentInput = {
    appAri: Scalars["ID"]["input"];
    environmentKey: Scalars["String"]["input"];
};

export type DeleteAppEnvironmentResponse = Payload & {
    __typename?: "DeleteAppEnvironmentResponse";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type DeleteAppEnvironmentVariableInput = {
    environment: AppEnvironmentInput;
    /** The key of the environment variable to delete */
    key: Scalars["String"]["input"];
};

export type DeleteAppEnvironmentVariablePayload = Payload & {
    __typename?: "DeleteAppEnvironmentVariablePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteAppInput = {
    appId: Scalars["ID"]["input"];
};

/** Response from deleting an app */
export type DeleteAppResponse = Payload & {
    __typename?: "DeleteAppResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteAppStoredCustomEntityMutationInput = {
    /** The ARI to store this entity within */
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    /** Specify entity name for custom schema */
    entityName: Scalars["String"]["input"];
    /** The identifier for the entity */
    key: Scalars["ID"]["input"];
};

export type DeleteAppStoredCustomEntityPayload = Payload & {
    __typename?: "DeleteAppStoredCustomEntityPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type DeleteAppStoredEntityMutationInput = {
    /** The ARI to store this entity within */
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    /** Specify whether the encrypted value should be deleted */
    encrypted?: InputMaybe<Scalars["Boolean"]["input"]>;
    /**
     * The identifier for the entity
     *
     * Keys must be between 1-100 characters long and must match the following pattern /^[a-zA-Z0-9:._\s-]+$/
     */
    key: Scalars["ID"]["input"];
};

/** Generic implementation of MutationResponse for responses that don't need any extra data */
export type DeleteAppStoredEntityPayload = Payload & {
    __typename?: "DeleteAppStoredEntityPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type DeleteAppTunnelInput = {
    /** The app to setup a tunnel for */
    appId: Scalars["ID"]["input"];
    /** The environment key */
    environmentKey: Scalars["String"]["input"];
};

export type DeleteCardInput = {
    cardId: Scalars["ID"]["input"];
};

export type DeleteCardOutput = {
    __typename?: "DeleteCardOutput";
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    message: Scalars["String"]["output"];
    statusCode: Scalars["Int"]["output"];
    success: Scalars["Boolean"]["output"];
};

export type DeleteColumnInput = {
    boardId: Scalars["ID"]["input"];
    columnId: Scalars["ID"]["input"];
};

export type DeleteColumnOutput = MutationResponse & {
    __typename?: "DeleteColumnOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    columns?: Maybe<Array<Maybe<Column>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input to delete an external alias. */
export type DeleteCompassComponentExternalAliasInput = {
    /** The ID of the component to which you add the external alias. */
    componentId: Scalars["ID"]["input"];
    /** The alias of the component identifier in external sources. */
    externalAlias: CompassDeleteExternalAliasInput;
};

/** The payload returned from deleting the external alias of a component. */
export type DeleteCompassComponentExternalAliasPayload = Payload & {
    __typename?: "DeleteCompassComponentExternalAliasPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** Deleted Compass External Alias */
    deletedCompassExternalAlias?: Maybe<CompassExternalAlias>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for deleting an existing component. */
export type DeleteCompassComponentInput = {
    /** The ID of the component to be deleted. */
    id: Scalars["ID"]["input"];
};

/** Accepts input to delete a component link. */
export type DeleteCompassComponentLinkInput = {
    /** The ID for the component to delete a link. */
    componentId: Scalars["ID"]["input"];
    /** The component link to be deleted. */
    link: Scalars["ID"]["input"];
};

/** The payload retuned after deleting a component link. */
export type DeleteCompassComponentLinkPayload = Payload & {
    __typename?: "DeleteCompassComponentLinkPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** The ID of the deleted component link. */
    deletedCompassLinkId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The payload returned from deleting an existing component. */
export type DeleteCompassComponentPayload = Payload & {
    __typename?: "DeleteCompassComponentPayload";
    /** The ID of the component that was deleted. */
    deletedComponentId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input to delete a component type. */
export type DeleteCompassComponentTypeInput = {
    /** The ARI of the component type to be deleted. */
    id: Scalars["ID"]["input"];
};

/** The payload returned after deleting the component type. */
export type DeleteCompassComponentTypePayload = Payload & {
    __typename?: "DeleteCompassComponentTypePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for deleting an existing relationship between two components. */
export type DeleteCompassRelationshipInput = {
    /** The unique identifier (ID) of the component at the ending node. */
    endNodeId: Scalars["ID"]["input"];
    /** The unique identifier (ID) of the component at the starting node. */
    startNodeId: Scalars["ID"]["input"];
    /** The type of the relationship. */
    type: CompassRelationshipType;
};

/** The payload returned from deleting an existing component. */
export type DeleteCompassRelationshipPayload = Payload & {
    __typename?: "DeleteCompassRelationshipPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type DeleteCompassScorecardCriteriaInput = {
    /** ID of the scorecard criterion for deletion. The criteria is already applied to a scorecard. */
    id: Scalars["ID"]["input"];
};

/** The payload returned from deleting a scorecard criterion. */
export type DeleteCompassScorecardPayload = Payload & {
    __typename?: "DeleteCompassScorecardPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The scorecard that was mutated. */
    scorecardId: Scalars["ID"]["output"];
    /** Whether the mutation was successful or not */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for deleting a starred component. */
export type DeleteCompassStarredComponentInput = {
    /** The ID of the component to be un-starred. */
    componentId: Scalars["ID"]["input"];
};

/** Payload returned from deleting a starred component. */
export type DeleteCompassStarredComponentPayload = Payload & {
    __typename?: "DeleteCompassStarredComponentPayload";
    /** A list of errors that occurred during mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the relationship is deleted successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Input to delete an individual user defined parameter. */
export type DeleteCompassUserDefinedParameterInput = {
    /** The id of the parameter to delete */
    id: Scalars["ID"]["input"];
};

export type DeleteContentDataClassificationLevelInput = {
    contentStatus: ContentDataClassificationMutationContentStatus;
    id: Scalars["Long"]["input"];
};

export type DeleteContentDataClassificationLevelPayload = Payload & {
    __typename?: "DeleteContentDataClassificationLevelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteContentResponsePayload = {
    __typename?: "DeleteContentResponsePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    wasDeleted: Scalars["Boolean"]["output"];
};

export type DeleteContentTemplateLabelInput = {
    contentTemplateId: Scalars["ID"]["input"];
    labelId: Scalars["ID"]["input"];
};

export type DeleteContentTemplateLabelPayload = {
    __typename?: "DeleteContentTemplateLabelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentTemplateId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labelId: Scalars["ID"]["output"];
};

export type DeleteCustomFilterInput = {
    boardId: Scalars["ID"]["input"];
    customFilterId: Scalars["String"]["input"];
};

export type DeleteDefaultSpaceRoleAssignmentsInput = {
    principalsList: Array<RoleAssignmentPrincipalInput>;
};

export type DeleteDefaultSpaceRoleAssignmentsPayload = Payload & {
    __typename?: "DeleteDefaultSpaceRoleAssignmentsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for deleting relationship properties */
export type DeleteDevOpsContainerRelationshipEntityPropertiesInput = {
    /** The ARI of the any of the relationship entity */
    id: Scalars["ID"]["input"];
    /** The properties with the given keys in the list will be removed from the relationship */
    keys: Array<Scalars["String"]["input"]>;
};

/** The response payload of deleting DevOps Service Entity Properties */
export type DeleteDevOpsContainerRelationshipEntityPropertiesPayload =
    Payload & {
        __typename?: "DeleteDevOpsContainerRelationshipEntityPropertiesPayload";
        /**
         * The errors occurred during relationship properties delete
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         * The result of whether relationship properties have been successfully deleted or not
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

/** The request input for deleting a relationship between a DevOps Service and a Jira Project */
export type DeleteDevOpsServiceAndJiraProjectRelationshipInput = {
    /** The DevOps Graph Service_And_Jira_Project relationship ARI */
    id: Scalars["ID"]["input"];
};

export type DeleteDevOpsServiceAndJiraProjectRelationshipPayload = Payload & {
    __typename?: "DeleteDevOpsServiceAndJiraProjectRelationshipPayload";
    /**
     * The list of errors occurred during delete relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The result of whether the relationship is deleted successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for deleting a relationship between a DevOps Service and an Opsgenie Team */
export type DeleteDevOpsServiceAndOpsgenieTeamRelationshipInput = {
    id: Scalars["ID"]["input"];
};

/** The response payload of deleting a relationship between a DevOps Service and an Opsgenie Team */
export type DeleteDevOpsServiceAndOpsgenieTeamRelationshipPayload = Payload & {
    __typename?: "DeleteDevOpsServiceAndOpsgenieTeamRelationshipPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for deleting a relationship between a DevOps Service and a Repository */
export type DeleteDevOpsServiceAndRepositoryRelationshipInput = {
    /** The ARI of the relationship */
    id: Scalars["ID"]["input"];
};

export type DeleteDevOpsServiceAndRepositoryRelationshipPayload = Payload & {
    __typename?: "DeleteDevOpsServiceAndRepositoryRelationshipPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for deleting DevOps Service Entity Properties */
export type DeleteDevOpsServiceEntityPropertiesInput = {
    /** The ARI of the DevOps Service */
    id: Scalars["ID"]["input"];
    /** The properties with the given keys in the list will be removed from the DevOps Service */
    keys: Array<Scalars["String"]["input"]>;
};

/** The response payload of deleting DevOps Service Entity Properties */
export type DeleteDevOpsServiceEntityPropertiesPayload = Payload & {
    __typename?: "DeleteDevOpsServiceEntityPropertiesPayload";
    /**
     * The errors occurred during DevOps Service Entity Properties delete
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The result of whether DevOps Service Entity Properties have been successfully deleted or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for deleting a DevOps Service */
export type DeleteDevOpsServiceInput = {
    id: Scalars["ID"]["input"];
};

/** The response payload of deleting a DevOps Service */
export type DeleteDevOpsServicePayload = Payload & {
    __typename?: "DeleteDevOpsServicePayload";
    /**
     * The list of errors occurred during DevOps Service deletion
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The result of whether the DevOps Service is deleted successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for deleting a DevOps Service Relationship */
export type DeleteDevOpsServiceRelationshipInput = {
    /** The ARI of the DevOps Service Relationship */
    id: Scalars["ID"]["input"];
};

export type DeleteDevOpsServiceRelationshipPayload = Payload & {
    __typename?: "DeleteDevOpsServiceRelationshipPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteEventSourceInput = {
    /** The cloud ID of the site to delete an event source for. */
    cloudId: Scalars["ID"]["input"];
    /**
     * Boolean to override the default validation and make sure that the event source is not attached to any component.
     * If true, this mutation will detach all components linked to the event source before deleting the event source.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Redundant check, no validation is needed when deleting event sources. The default behavior is to detach components and delete the event source.
     */
    deleteIfAttachedToComponents?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The type of event to be deleted. */
    eventType: CompassEventType;
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["input"];
};

export type DeleteEventSourcePayload = Payload & {
    __typename?: "DeleteEventSourcePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type DeleteInlineCommentInput = {
    commentId: Scalars["ID"]["input"];
    step?: InputMaybe<Step>;
};

/** Delete: Mutation (Delete) */
export type DeleteJiraPlaybookInput = {
    id: Scalars["ID"]["input"];
};

/** Delete by Id: Mutation (DELETE) */
export type DeleteJiraPlaybookPayload = Payload & {
    __typename?: "DeleteJiraPlaybookPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteLabelInput = {
    contentId: Scalars["ID"]["input"];
    label: Scalars["String"]["input"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type DeleteLabelPayload = {
    __typename?: "DeleteLabelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    label: Scalars["String"]["output"];
};

export type DeletePagesInput = {
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

export type DeletePagesPayload = {
    __typename?: "DeletePagesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

export type DeletePolarisIdeaTemplateInput = {
    id: Scalars["ID"]["input"];
    project: Scalars["ID"]["input"];
};

export type DeletePolarisIdeaTemplatePayload = Payload & {
    __typename?: "DeletePolarisIdeaTemplatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeletePolarisInsightPayload = Payload & {
    __typename?: "DeletePolarisInsightPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeletePolarisPlayContributionPayload = {
    __typename?: "DeletePolarisPlayContributionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeletePolarisViewPayload = Payload & {
    __typename?: "DeletePolarisViewPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeletePolarisViewSetPayload = Payload & {
    __typename?: "DeletePolarisViewSetPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteRelationInput = {
    relationName: RelationType;
    sourceKey: Scalars["String"]["input"];
    sourceType: RelationSourceType;
    targetKey: Scalars["String"]["input"];
    targetType: RelationTargetType;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type DeleteRelationPayload = {
    __typename?: "DeleteRelationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relationName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sourceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    targetKey: Scalars["String"]["output"];
};

export type DeleteSpaceDefaultClassificationLevelInput = {
    id: Scalars["Long"]["input"];
};

export type DeleteSpaceDefaultClassificationLevelPayload = Payload & {
    __typename?: "DeleteSpaceDefaultClassificationLevelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DeleteSpaceRoleAssignmentsInput = {
    principalList: Array<RoleAssignmentPrincipalInput>;
    spaceId: Scalars["Long"]["input"];
};

export type DeleteSpaceRoleAssignmentsPayload = Payload & {
    __typename?: "DeleteSpaceRoleAssignmentsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Delete sprint */
export type DeleteSprintInput = {
    boardId: Scalars["ID"]["input"];
    sprintId: Scalars["ID"]["input"];
};

export type DeleteUserGrantInput = {
    oauthClientId: Scalars["ID"]["input"];
};

export type DeleteUserGrantPayload = Payload & {
    __typename?: "DeleteUserGrantPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Response from creating an webtrigger url */
export type DeleteWebTriggerUrlResponse = MutationResponse & {
    __typename?: "DeleteWebTriggerUrlResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * This object models the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of multiple stages)
 * for getting software from version control right through to the production environment.
 */
export type DeploymentPipeline = {
    __typename?: "DeploymentPipeline";
    /** The name of the pipeline to present to the user. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the pipeline */
    id?: Maybe<Scalars["String"]["output"]>;
    /** A URL users can use to link to this deployment pipeline. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** The state that a code deployment can be in (think of a deployment in Bitbucket Pipelines, CircleCI, etc). */
export enum DeploymentState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

/**
 * This object models a deployment in the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of
 * multiple stages) for getting software from version control right through to the production environment.
 */
export type DeploymentSummary = Node & {
    __typename?: "DeploymentSummary";
    /**
     * This is the identifier for the deployment.
     *
     * It must be unique for the specified pipeline and environment. It must be a monotonically
     * increasing number, as this is used to sequence the deployments.
     */
    deploymentSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    /** A short description of the deployment. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The human-readable name for the deployment. Will be shown in the UI. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The environment that the deployment is present in. */
    environment?: Maybe<DevOpsEnvironment>;
    id: Scalars["ID"]["output"];
    /**
     * IDs of the issues that are included in the deployment.
     *
     * At least one of the commits in the deployment must be associated with an issue for it
     * to appear here (meaning the issue key is mentioned in the commit message).
     *
     * You can pass a `projectId` filter if you're only interested in issues that are within
     * a specific project (some deployments include issues from many projects).
     */
    issueIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** The last-updated timestamp to present to the user as a summary of the state of the deployment. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * This object models the Continuous Delivery (CD) Pipeline concept, an automated process
     * (usually comprised of multiple stages) for getting software from version control right through
     * to the production environment.
     */
    pipeline?: Maybe<DeploymentPipeline>;
    /**
     * This is the DevOps provider for the deployment.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: DevOpsProvider` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    provider?: Maybe<DevOpsProvider>;
    /**
     * Services associated with the deployment.
     *
     * At least one of the commits in the deployment must be associated with a service ID for it
     * to appear here.
     */
    serviceAssociations?: Maybe<Array<Maybe<DevOpsService>>>;
    /** The state of the deployment. */
    state?: Maybe<DeploymentState>;
    /**
     * A number used to apply an order to the updates to the deployment, as identified by the
     * `deploymentSequenceNumber`, in the case of out-of-order receipt of update requests.
     *
     * It must be a monotonically increasing number. For example, epoch time could be one
     * way to generate the `updateSequenceNumber`.
     */
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    /** A URL users can use to link to this deployment, in this environment. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/**
 * This object models a deployment in the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of
 * multiple stages) for getting software from version control right through to the production environment.
 */
export type DeploymentSummaryIssueIdsArgs = {
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum Depth {
    All = "ALL",
    Root = "ROOT"
}

export enum DescendantsNoteApplicationOption {
    All = "ALL",
    None = "NONE",
    Roots = "ROOTS"
}

/** Accepts input to detach a data manager from a component. */
export type DetachCompassComponentDataManagerInput = {
    /** The ID of the component to detach a data manager from. */
    componentId: Scalars["ID"]["input"];
};

/** The payload returned from detaching a data manager from a component. */
export type DetachCompassComponentDataManagerPayload = Payload & {
    __typename?: "DetachCompassComponentDataManagerPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type DetachEventSourceInput = {
    /** The ID of the component to detach the event source from. */
    componentId: Scalars["ID"]["input"];
    /** The ID of the event source. */
    eventSourceId: Scalars["ID"]["input"];
};

export type DetachEventSourcePayload = Payload & {
    __typename?: "DetachEventSourcePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type DetailCreator = {
    __typename?: "DetailCreator";
    accountId: Scalars["String"]["output"];
    canView: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
};

export type DetailLabels = {
    __typename?: "DetailLabels";
    displayTitle: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    urlPath: Scalars["String"]["output"];
};

export type DetailLastModified = {
    __typename?: "DetailLastModified";
    friendlyModificationDate: Scalars["String"]["output"];
    sortableDate: Scalars["String"]["output"];
};

export type DetailLine = {
    __typename?: "DetailLine";
    commentsCount: Scalars["Int"]["output"];
    creator?: Maybe<DetailCreator>;
    details: Array<Maybe<Scalars["String"]["output"]>>;
    id: Scalars["Long"]["output"];
    labels: Array<Maybe<DetailLabels>>;
    lastModified?: Maybe<DetailLastModified>;
    likesCount: Scalars["Int"]["output"];
    macroId?: Maybe<Scalars["String"]["output"]>;
    reactionsCount: Scalars["Int"]["output"];
    relativeLink: Scalars["String"]["output"];
    rowId: Scalars["Int"]["output"];
    subRelativeLink: Scalars["String"]["output"];
    subTitle: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    unresolvedCommentsCount: Scalars["Int"]["output"];
};

export type DetailsSummaryLines = {
    __typename?: "DetailsSummaryLines";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    asyncRenderSafe: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentPage: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    detailLines: Array<Maybe<DetailLine>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    macroId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    renderedHeadings: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalPages: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webResources: Array<Maybe<Scalars["String"]["output"]>>;
};

export type DevAi = {
    __typename?: "DevAi";
    /**
     * Fetch the autofix configuration status for a list of repositories
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    autofixConfigurations?: Maybe<DevAiAutofixConfigurationConnection>;
    /**
     * For the given repo URLs, filter unsupported repos. This is a temp query for early milestone of Autofix
     * Without FilterOption given, it will return ALL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getSupportedRepos?: Maybe<Array<Maybe<Scalars["URL"]["output"]>>>;
};

export type DevAiAutofixConfigurationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    repositoryUrls: Array<Scalars["URL"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

export type DevAiGetSupportedReposArgs = {
    filterOption?: InputMaybe<DevAiSupportedRepoFilterOption>;
    repoUrls?: InputMaybe<Array<Scalars["URL"]["input"]>>;
    workspaceId: Scalars["ID"]["input"];
};

export type DevAiAutodevContinueJobWithPromptPayload = Payload & {
    __typename?: "DevAiAutodevContinueJobWithPromptPayload";
    /**
     * The errors field represents additional mutation error information if exists.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The ID of the job that was operated on.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jobId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The success indicator saying whether mutation operation was successful as a whole or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * Interface representing an individual log item. Implementations may provide additional
 * fields that are relevant to them, e.g. a "running tests" log item might include
 * `totalTestCount` and `executedTestCount` fields.
 */
export type DevAiAutodevLog = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    phase?: Maybe<DevAiAutodevLogPhase>;
    /**
     * Priority of the log item. The frontend may emphasise, de-emphasise, or filter/hide
     * logs based on this value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    priority?: Maybe<DevAiAutodevLogPriority>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<DevAiAutodevLogStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DevAiAutodevLogConnection = {
    __typename?: "DevAiAutodevLogConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<DevAiAutodevLogEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type DevAiAutodevLogEdge = {
    __typename?: "DevAiAutodevLogEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiAutodevLog>;
};

/**
 * Contains a list of closely related log items, along with some group-level attributes
 * (e.g. the status of the group as a whole).
 */
export type DevAiAutodevLogGroup = {
    __typename?: "DevAiAutodevLogGroup";
    id: Scalars["ID"]["output"];
    logs?: Maybe<DevAiAutodevLogConnection>;
    phase?: Maybe<DevAiAutodevLogGroupPhase>;
    startTime?: Maybe<Scalars["DateTime"]["output"]>;
    status?: Maybe<DevAiAutodevLogGroupStatus>;
};

/**
 * Contains a list of closely related log items, along with some group-level attributes
 * (e.g. the status of the group as a whole).
 */
export type DevAiAutodevLogGroupLogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection of "log groups", each of which contains a list of closely related log items. */
export type DevAiAutodevLogGroupConnection = {
    __typename?: "DevAiAutodevLogGroupConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<DevAiAutodevLogGroupEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type DevAiAutodevLogGroupEdge = {
    __typename?: "DevAiAutodevLogGroupEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiAutodevLogGroup>;
};

/** The "phase" of the job the group of logs is associated with. Coding, planning, etc. */
export enum DevAiAutodevLogGroupPhase {
    CodeGenerating = "CODE_GENERATING",
    CodeReview = "CODE_REVIEW",
    CodeReGenerating = "CODE_RE_GENERATING",
    PlanGenerating = "PLAN_GENERATING",
    PlanReview = "PLAN_REVIEW",
    PlanReGenerating = "PLAN_RE_GENERATING"
}

/** Overall status of the group of logs. */
export enum DevAiAutodevLogGroupStatus {
    Completed = "COMPLETED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS"
}

/** The "phase" of the job the log is associated with. Coding, planning, etc. */
export enum DevAiAutodevLogPhase {
    CodeGenerating = "CODE_GENERATING",
    CodeReview = "CODE_REVIEW",
    CodeReGenerating = "CODE_RE_GENERATING",
    PlanGenerating = "PLAN_GENERATING",
    PlanReview = "PLAN_REVIEW",
    PlanReGenerating = "PLAN_RE_GENERATING"
}

/** Priority of the log item. */
export enum DevAiAutodevLogPriority {
    Lowest = "LOWEST",
    Medium = "MEDIUM"
}

/** Status of the log item. */
export enum DevAiAutodevLogStatus {
    Completed = "COMPLETED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS"
}

/** Represents the configuration status of a given repositoru */
export type DevAiAutofixConfiguration = {
    __typename?: "DevAiAutofixConfiguration";
    autofixScans?: Maybe<DevAiAutofixScansConnection>;
    autofixTasks?: Maybe<DevAiAutofixTasksConnection>;
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    codeCoverageCommand?: Maybe<Scalars["String"]["output"]>;
    codeCoverageReportPath?: Maybe<Scalars["String"]["output"]>;
    currentCoveragePercentage?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["ID"]["output"];
    isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    isScanning?: Maybe<Scalars["Boolean"]["output"]>;
    lastScan?: Maybe<Scalars["DateTime"]["output"]>;
    maxPrOpenCount?: Maybe<Scalars["Int"]["output"]>;
    nextScan?: Maybe<Scalars["DateTime"]["output"]>;
    openPullRequestsCount?: Maybe<Scalars["Int"]["output"]>;
    openPullRequestsUrl?: Maybe<Scalars["URL"]["output"]>;
    primaryLanguage?: Maybe<Scalars["String"]["output"]>;
    repoUrl?: Maybe<Scalars["URL"]["output"]>;
    scanIntervalFrequency?: Maybe<Scalars["Int"]["output"]>;
    scanIntervalUnit?: Maybe<DevAiScanIntervalUnit>;
    scanStartDate?: Maybe<Scalars["Date"]["output"]>;
    targetCoveragePercentage?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents the configuration status of a given repositoru */
export type DevAiAutofixConfigurationAutofixScansArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<DevAiAutofixScanOrderInput>;
};

/** Represents the configuration status of a given repositoru */
export type DevAiAutofixConfigurationAutofixTasksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevAiAutofixTaskFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<DevAiAutofixTaskOrderInput>;
};

export type DevAiAutofixConfigurationConnection = {
    __typename?: "DevAiAutofixConfigurationConnection";
    edges?: Maybe<Array<Maybe<DevAiAutofixConfigurationEdge>>>;
    pageInfo: PageInfo;
};

export type DevAiAutofixConfigurationEdge = {
    __typename?: "DevAiAutofixConfigurationEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiAutofixConfiguration>;
};

export type DevAiAutofixScan = {
    __typename?: "DevAiAutofixScan";
    id: Scalars["ID"]["output"];
    progressPercentage?: Maybe<Scalars["Int"]["output"]>;
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    status?: Maybe<DevAiAutofixScanStatus>;
};

export type DevAiAutofixScanEdge = {
    __typename?: "DevAiAutofixScanEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiAutofixScan>;
};

export type DevAiAutofixScanOrderInput = {
    order: SortDirection;
    sortByField: DevAiAutofixScanSortField;
};

export enum DevAiAutofixScanSortField {
    StartDate = "START_DATE"
}

export enum DevAiAutofixScanStatus {
    Completed = "COMPLETED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS"
}

export type DevAiAutofixScansConnection = {
    __typename?: "DevAiAutofixScansConnection";
    edges?: Maybe<Array<Maybe<DevAiAutofixScanEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevAiAutofixTask = {
    __typename?: "DevAiAutofixTask";
    associatedPullRequest?: Maybe<Scalars["URL"]["output"]>;
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    id: Scalars["ID"]["output"];
    newCodeCoveragePercentage?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use 'newCodeCoveragePercentage' instead - it supports float values
     */
    newCoveragePercentage?: Maybe<Scalars["Int"]["output"]>;
    parentWorkflowRunDateTime?: Maybe<Scalars["DateTime"]["output"]>;
    parentWorkflowRunId?: Maybe<Scalars["ID"]["output"]>;
    previousCodeCoveragePercentage?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use 'previousCodeCoveragePercentage' instead - it supports float values
     */
    previousCoveragePercentage?: Maybe<Scalars["Int"]["output"]>;
    primaryLanguage?: Maybe<Scalars["String"]["output"]>;
    sourceFilePath?: Maybe<Scalars["String"]["output"]>;
    /** leaving this as a string for now, until we have a unified status model. */
    taskStatusTemporary?: Maybe<Scalars["String"]["output"]>;
    testFilePath?: Maybe<Scalars["String"]["output"]>;
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DevAiAutofixTaskEdge = {
    __typename?: "DevAiAutofixTaskEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiAutofixTask>;
};

export type DevAiAutofixTaskFilterInput = {
    primaryLanguage?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<DevAiAutofixTaskStatus>>;
};

export type DevAiAutofixTaskOrderInput = {
    order: SortDirection;
    sortByField: DevAiAutofixTaskSortField;
};

export enum DevAiAutofixTaskSortField {
    CreatedAt = "CREATED_AT",
    Filename = "FILENAME",
    NewCoveragePercentage = "NEW_COVERAGE_PERCENTAGE",
    PreviousCoveragePercentage = "PREVIOUS_COVERAGE_PERCENTAGE",
    PrimaryLanguage = "PRIMARY_LANGUAGE",
    Status = "STATUS",
    UpdatedAt = "UPDATED_AT"
}

export enum DevAiAutofixTaskStatus {
    PrDeclined = "PR_DECLINED",
    PrMerged = "PR_MERGED",
    PrOpened = "PR_OPENED",
    WorkflowCancelled = "WORKFLOW_CANCELLED",
    WorkflowCompleted = "WORKFLOW_COMPLETED",
    WorkflowInprogress = "WORKFLOW_INPROGRESS",
    WorkflowPending = "WORKFLOW_PENDING"
}

export type DevAiAutofixTasksConnection = {
    __typename?: "DevAiAutofixTasksConnection";
    edges?: Maybe<Array<Maybe<DevAiAutofixTaskEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevAiCancelAutofixScanPayload = Payload & {
    __typename?: "DevAiCancelAutofixScanPayload";
    errors?: Maybe<Array<MutationError>>;
    scan?: Maybe<DevAiAutofixConfiguration>;
    success: Scalars["Boolean"]["output"];
};

export type DevAiCancelRunningAutofixScanInput = {
    repoUrl: Scalars["URL"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

export type DevAiCreateTechnicalPlannerJobPayload = Payload & {
    __typename?: "DevAiCreateTechnicalPlannerJobPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    job?: Maybe<DevAiTechnicalPlannerJob>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * A generic log message that can contain arbitrary JSON attributes.
 *
 * This type is intended to allow for quick iteration. Creating a more specific
 * `DevAiAutodevLog` implementation should be prefered if designs have settled
 * and the log type is likely to be stable.
 */
export type DevAiGenericAutodevLog = DevAiAutodevLog & {
    __typename?: "DevAiGenericAutodevLog";
    /**
     * Should be interpreted based on the value of `kind`, and knowledge of the backend implementation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    attributes?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The type of error that occurred if the log is in a failed state.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * An enum-like field that will determine how the frontend interprets `attributes`.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    kind?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    phase?: Maybe<DevAiAutodevLogPhase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    priority?: Maybe<DevAiAutodevLogPriority>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<DevAiAutodevLogStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DevAiGenericMutationErrorExtension = MutationErrorExtension & {
    __typename?: "DevAiGenericMutationErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type DevAiInvokeAutodevRovoAgentInBulkIssueResult = {
    __typename?: "DevAiInvokeAutodevRovoAgentInBulkIssueResult";
    /** The Rovo conversation in which the agent was invoked. */
    conversationId?: Maybe<Scalars["ID"]["output"]>;
    /** The issue the agent was invoked on. */
    issueId?: Maybe<Scalars["ID"]["output"]>;
};

export type DevAiInvokeAutodevRovoAgentInBulkPayload = Payload & {
    __typename?: "DevAiInvokeAutodevRovoAgentInBulkPayload";
    /**
     * The errors field represents additional mutation error information if exists.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Results for agent invocations that failed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    failedIssues?: Maybe<
        Array<Maybe<DevAiInvokeAutodevRovoAgentInBulkIssueResult>>
    >;
    /**
     * Results for agent invocations that succeeded.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    succeededIssues?: Maybe<
        Array<Maybe<DevAiInvokeAutodevRovoAgentInBulkIssueResult>>
    >;
    /**
     * The success indicator saying whether mutation operation was successful as a whole or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type DevAiInvokeAutodevRovoAgentPayload = Payload & {
    __typename?: "DevAiInvokeAutodevRovoAgentPayload";
    /**
     * The conversation id of the invoked agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    conversationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The errors field represents additional mutation error information if exists.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The ID of the job that was created.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jobId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The success indicator saying whether mutation operation was successful as a whole or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * Represents the issue suitability label for using Autodev to solve the task.
 *
 * - A value of UNSOLVABLE represents issues that we cannot use Autodev to solve
 * - A value of IN_SCOPE represents issues that are good candidates for Autodev
 * - A value of RECOVERABLE represents issues that require additional context for Autodev to succeed
 * - A value of COMPLEX represents issues that should be broken down into sub-tasks or smaller issues
 */
export enum DevAiIssueScopingLabel {
    Complex = "COMPLEX",
    InScope = "IN_SCOPE",
    Optimal = "OPTIMAL",
    Recoverable = "RECOVERABLE",
    Unsolvable = "UNSOLVABLE"
}

export type DevAiIssueScopingResult = {
    __typename?: "DevAiIssueScopingResult";
    /** Suggestion as to whether or not issue suitability can be improved by including file path references. */
    isAddingCodeFilePathSuggested?: Maybe<Scalars["Boolean"]["output"]>;
    /** Suggestion as to whether or not issue suitability can be improved by including code snippets. */
    isAddingCodeSnippetSuggested?: Maybe<Scalars["Boolean"]["output"]>;
    /** Suggestion as to whether or not issue suitability can be improved by including code terms. */
    isAddingCodingTermsSuggested?: Maybe<Scalars["Boolean"]["output"]>;
    /** The Jira issue ARI. */
    issueId: Scalars["ID"]["output"];
    /** The issue suitability label for using Autodev to solve the task. */
    label?: Maybe<DevAiIssueScopingLabel>;
    /**
     * Human readable message
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'message' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type DevAiMutations = {
    __typename?: "DevAiMutations";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cancelAutofixScan?: Maybe<DevAiCancelAutofixScanPayload>;
    /**
     * Initiates an Autofix scan for a repository.
     * Note that only a single scan can be running at a time for a given repository.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    runAutofixScan?: Maybe<DevAiTriggerAutofixScanPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    setAutofixConfigurationForRepository?: Maybe<DevAiSetAutofixConfigurationForRepositoryPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    setAutofixEnabledStateForRepository?: Maybe<DevAiSetIsAutofixEnabledForRepositoryPayload>;
    /**
     * Temporary M0.5 mutation to trigger a scan for a specific AutofixConfiguration
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use 'runAutofixScan' instead - it uses the persisted configuration
     */
    triggerAutofixScan?: Maybe<DevAiTriggerAutofixScanPayload>;
};

export type DevAiMutationsCancelAutofixScanArgs = {
    input: DevAiCancelRunningAutofixScanInput;
};

export type DevAiMutationsRunAutofixScanArgs = {
    input: DevAiRunAutofixScanInput;
};

export type DevAiMutationsSetAutofixConfigurationForRepositoryArgs = {
    input: DevAiSetAutofixConfigurationForRepositoryInput;
};

export type DevAiMutationsSetAutofixEnabledStateForRepositoryArgs = {
    input: DevAiSetAutofixEnabledStateForRepositoryInput;
};

export type DevAiMutationsTriggerAutofixScanArgs = {
    input: DevAiTriggerAutofixScanInput;
};

/** Represents the end of a phase of the job, e.g. the completion of a code generation phase. */
export type DevAiPhaseEndedAutodevLog = DevAiAutodevLog & {
    __typename?: "DevAiPhaseEndedAutodevLog";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Phase that just ended.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    phase?: Maybe<DevAiAutodevLogPhase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    priority?: Maybe<DevAiAutodevLogPriority>;
    /**
     * Will always be `COMPLETED` as this log represents a point-in-time action.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<DevAiAutodevLogStatus>;
    /**
     * Time at which the phase ended.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
};

/**
 * Represents the start of a new phase of the job, which will correspond to a user interaction of some
 * kind (e.g. regenerating the plan).
 */
export type DevAiPhaseStartedAutodevLog = DevAiAutodevLog & {
    __typename?: "DevAiPhaseStartedAutodevLog";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Phase that just started.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    phase?: Maybe<DevAiAutodevLogPhase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    priority?: Maybe<DevAiAutodevLogPriority>;
    /**
     * Will always be `COMPLETED` as this log represents a point-in-time action.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<DevAiAutodevLogStatus>;
    /**
     * Time at which the phase started.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * User input for commandGen feature.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userCommand?: Maybe<Scalars["String"]["output"]>;
};

/** A simple plaintext log. */
export type DevAiPlaintextAutodevLog = DevAiAutodevLog & {
    __typename?: "DevAiPlaintextAutodevLog";
    /**
     * The type of error that occurred if the log is in a failed state.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Text that will be displayed as-is to the user. May not be internationalized.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    phase?: Maybe<DevAiAutodevLogPhase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    priority?: Maybe<DevAiAutodevLogPriority>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<DevAiAutodevLogStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
};

/**
 * A Rovo agent that can execute Autodev.
 * Not yet supported: knowledge_sources TODO: ISOC-6530
 */
export type DevAiRovoAgent = {
    __typename?: "DevAiRovoAgent";
    actionConfig?: Maybe<Array<Maybe<DevAiRovoAgentActionConfig>>>;
    description?: Maybe<Scalars["String"]["output"]>;
    externalConfigReference?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    systemPromptTemplate?: Maybe<Scalars["String"]["output"]>;
    userDefinedConversationStarters?: Maybe<
        Array<Maybe<Scalars["String"]["output"]>>
    >;
};

export type DevAiRovoAgentActionConfig = {
    __typename?: "DevAiRovoAgentActionConfig";
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type DevAiRovoAgentConnection = {
    __typename?: "DevAiRovoAgentConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<DevAiRovoAgentEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type DevAiRovoAgentEdge = {
    __typename?: "DevAiRovoAgentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiRovoAgent>;
};

/** Whether the query should include, exclude, or only have agent templates in the results. */
export enum DevAiRovoAgentTemplateFilter {
    Exclude = "EXCLUDE",
    Include = "INCLUDE",
    Only = "ONLY"
}

export type DevAiRunAutofixScanInput = {
    repoUrl: Scalars["URL"]["input"];
    /**
     * If a scan is currently running, this determines whether the mutation (a) does nothing
     * or (b) cancels the current scan and initiates another.
     */
    restartIfCurrentlyRunning?: InputMaybe<Scalars["Boolean"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

export enum DevAiScanIntervalUnit {
    Days = "DAYS",
    Months = "MONTHS",
    Weeks = "WEEKS"
}

export type DevAiSetAutofixConfigurationForRepositoryInput = {
    codeCoverageCommand: Scalars["String"]["input"];
    codeCoverageReportPath: Scalars["String"]["input"];
    coveragePercentage: Scalars["Int"]["input"];
    isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    maxPrOpenCount?: InputMaybe<Scalars["Int"]["input"]>;
    primaryLanguage: Scalars["String"]["input"];
    repoUrl: Scalars["URL"]["input"];
    runInitialScan?: InputMaybe<Scalars["Boolean"]["input"]>;
    scanIntervalFrequency?: InputMaybe<Scalars["Int"]["input"]>;
    scanIntervalUnit?: InputMaybe<DevAiScanIntervalUnit>;
    scanStartDate?: InputMaybe<Scalars["Date"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

export type DevAiSetAutofixConfigurationForRepositoryPayload = Payload & {
    __typename?: "DevAiSetAutofixConfigurationForRepositoryPayload";
    configuration?: Maybe<DevAiAutofixConfiguration>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Input to enable/disable Autofix for a repository. */
export type DevAiSetAutofixEnabledStateForRepositoryInput = {
    isEnabled: Scalars["Boolean"]["input"];
    repoUrl: Scalars["URL"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

export type DevAiSetIsAutofixEnabledForRepositoryPayload = Payload & {
    __typename?: "DevAiSetIsAutofixEnabledForRepositoryPayload";
    configuration?: Maybe<DevAiAutofixConfiguration>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum DevAiSupportedRepoFilterOption {
    All = "ALL",
    DisabledOnly = "DISABLED_ONLY",
    EnabledOnly = "ENABLED_ONLY"
}

export type DevAiTechnicalPlannerJob = {
    __typename?: "DevAiTechnicalPlannerJob";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    error?: Maybe<DevAiWorkflowRunError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueAri?: Maybe<Scalars["ID"]["output"]>;
    /**
     * JSON using Atlassian Document Format to represent the plan.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    planAdf?: Maybe<Scalars["JSON"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    repoUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<DevAiWorkflowRunStatus>;
};

export type DevAiTechnicalPlannerJobConnection = {
    __typename?: "DevAiTechnicalPlannerJobConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<DevAiTechnicalPlannerJobEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type DevAiTechnicalPlannerJobEdge = {
    __typename?: "DevAiTechnicalPlannerJobEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevAiTechnicalPlannerJob>;
};

/** Input to trigger an autofix scan of a repository */
export type DevAiTriggerAutofixScanInput = {
    /** Command to run code coverage tool in this repository */
    codeCoverageCommand: Scalars["String"]["input"];
    /** Directory where code coverage report is generated */
    codeCoverageReportPath: Scalars["String"]["input"];
    /** Target code coverage percentage for the scan */
    coveragePercentage: Scalars["Int"]["input"];
    /** Primary language */
    primaryLanguage: Scalars["String"]["input"];
    repoUrl: Scalars["URL"]["input"];
    /** User to add as a PR reviewer */
    reviewerUserId?: InputMaybe<Scalars["ID"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

/** The return payload for triggering an Autofix repository Scan */
export type DevAiTriggerAutofixScanPayload = Payload & {
    __typename?: "DevAiTriggerAutofixScanPayload";
    configuration?: Maybe<DevAiAutofixConfiguration>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type DevAiUser = {
    __typename?: "DevAiUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    atlassianAccountId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasProductAccess?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isAdmin?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DevAiWorkflowRunError = {
    __typename?: "DevAiWorkflowRunError";
    errorType?: Maybe<Scalars["String"]["output"]>;
    httpStatus?: Maybe<Scalars["Int"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export enum DevAiWorkflowRunStatus {
    Cancelled = "CANCELLED",
    Completed = "COMPLETED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING"
}

export type DevOps = {
    __typename?: "DevOps";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ariGraph?: Maybe<AriGraph>;
    /**
     * Returns the design details from data-depot based on ids in the design ARI format
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsDesignsInJiraProjects")' query directive to the 'designEntityDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    designEntityDetails?: Maybe<Array<Maybe<DevOpsDesign>>>;
    /**
     * Given an array of generic ARIs, return their associated entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitiesByAssociations?: Maybe<DevOpsEntities>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Graph")' query directive to the 'graph' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use `graphStore` field on root instead
     */
    graph?: Maybe<Graph>;
    /**
     * Returns the operations Incident details from data-depot based on ARIs.
     * It is used for hydrating incident details (from Incident ARIs returned by AGS). Supports a maximum of 100 ids in input array.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operationsIncidentEntityDetails?: Maybe<
        Array<Maybe<DevOpsOperationsIncidentDetails>>
    >;
    /**
     * Returns the operations PIR details from data-depot based on ARIs.
     * It is used for hydrating PIR details (from ARIs returned by AGS). Supports a maximum of 100 ids in input array.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operationsPostIncidentReviewEntityDetails?: Maybe<
        Array<Maybe<DevOpsOperationsPostIncidentReviewDetails>>
    >;
    /**
     * Retrieve data providers managed by Data-depot for a Jira site, Jira workspace or graph workspace identified by `id`, filtered by `providerTypes`.
     * If `providerTypes` is not set or an empty-list, all data providers will be returned.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'providers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    providers?: Maybe<DevOpsProviders>;
    /**
     * Retrieve data providers matching a given domain (e.g. "atlassian.com"), managed by Data-depot belong to a Jira site and filtered by `providerTypes`.
     * If `providerTypes` is not specified or empty, all data providers matching the given domain will be returned.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'providersByDomain' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    providersByDomain?: Maybe<Array<Maybe<DevOpsDataProvider>>>;
    /**
     * Retrieve data providers matching given IDs, managed by Data-depot belong to a Jira site identified by `id` and filtered by `providerTypes`.
     * If `providerTypes` is not specified or empty, all data providers matching given IDs will be returned.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'providersByIds' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    providersByIds?: Maybe<Array<Maybe<DevOpsDataProvider>>>;
    /**
     * Returns the summaries for builds associated in ARI Graph Store with the specified Jira issues.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summarisedBuildsByAgsIssues?: Maybe<Array<Maybe<DevOpsSummarisedBuilds>>>;
    /**
     * Given an array of generic ARIs, return their most relevant deployment summaries
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use summarisedEntities's summarisedDeployments whose result is identical.
     */
    summarisedDeployments?: Maybe<Array<Maybe<DevOpsSummarisedDeployments>>>;
    /**
     * Returns the summaries for deployments associated in ARI Graph Store with the specified Jira issues.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summarisedDeploymentsByAgsIssues?: Maybe<
        Array<Maybe<DevOpsSummarisedDeployments>>
    >;
    /**
     * Given an array of generic ARIs, return their most relevant entity summaries
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summarisedEntities?: Maybe<Array<Maybe<DevOpsSummarisedEntities>>>;
    /**
     * Returns the summaries for feature flags associated in ARI Graph Store with the specified Jira issues.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summarisedFeatureFlagsByAgsIssues?: Maybe<
        Array<Maybe<DevOpsSummarisedFeatureFlags>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    toolchain?: Maybe<Toolchain>;
};

export type DevOpsDesignEntityDetailsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsEntitiesByAssociationsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsOperationsIncidentEntityDetailsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsOperationsPostIncidentReviewEntityDetailsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsProvidersArgs = {
    id: Scalars["ID"]["input"];
    providerTypes?: InputMaybe<Array<DevOpsProviderType>>;
};

export type DevOpsProvidersByDomainArgs = {
    id: Scalars["ID"]["input"];
    providerDomain: Scalars["String"]["input"];
    providerTypes?: InputMaybe<Array<DevOpsProviderType>>;
};

export type DevOpsProvidersByIdsArgs = {
    id: Scalars["ID"]["input"];
    providerIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    providerTypes?: InputMaybe<Array<DevOpsProviderType>>;
};

export type DevOpsSummarisedBuildsByAgsIssuesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsSummarisedDeploymentsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsSummarisedDeploymentsByAgsIssuesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsSummarisedEntitiesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsSummarisedFeatureFlagsByAgsIssuesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type DevOpsAvatar = {
    __typename?: "DevOpsAvatar";
    /** The description of the avatar. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the avatar. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type DevOpsBranchInfo = {
    __typename?: "DevOpsBranchInfo";
    name?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsBuildDetails = {
    __typename?: "DevOpsBuildDetails";
    /** Any Ari that associated with this build. */
    associatedAris?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** Identifies a Build within the sequence of Builds. */
    buildNumber?: Maybe<Scalars["Long"]["output"]>;
    /** An optional description to attach to this Build. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The human-readable name for the Build. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The build id in ari format */
    id: Scalars["ID"]["output"];
    /** The last-updated timestamp of the Build. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** An ID that relates a sequence of Builds. Whatever logical unit that groups a sequence of builds. */
    pipelineId?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the Connect as a Service (CaaS) Provider which submitted the Entity. */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The state of a Build. */
    state?: Maybe<DevOpsBuildState>;
    /** Information about tests that were executed during a Build. */
    testInfo?: Maybe<DevOpsBuildTestInfo>;
    /** The URL to this Build on the provider's system. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Data-Depot Build Provider details. */
export type DevOpsBuildProvider = DevOpsDataProvider & {
    __typename?: "DevOpsBuildProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Build Provider details. */
export type DevOpsBuildProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** The state of a build. */
export enum DevOpsBuildState {
    /** The build has been cancelled or stopped. */
    Cancelled = "CANCELLED",
    /** The build failed. */
    Failed = "FAILED",
    /** The build is currently running. */
    InProgress = "IN_PROGRESS",
    /** The build is queued, or some manual action is required. */
    Pending = "PENDING",
    /** The build completed successfully. */
    Successful = "SUCCESSFUL",
    /** The build is in an unknown state. */
    Unknown = "UNKNOWN"
}

export type DevOpsBuildTestInfo = {
    __typename?: "DevOpsBuildTestInfo";
    /** The number of tests that failed during a Build. */
    numberFailed?: Maybe<Scalars["Int"]["output"]>;
    /** The number of tests that passed during a Build. */
    numberPassed?: Maybe<Scalars["Int"]["output"]>;
    /** The number of tests that were skipped during a Build */
    numberSkipped?: Maybe<Scalars["Int"]["output"]>;
    /** The total number of tests considered during a Build. */
    totalNumber?: Maybe<Scalars["Int"]["output"]>;
};

export enum DevOpsComponentTier {
    Tier_1 = "TIER_1",
    Tier_2 = "TIER_2",
    Tier_3 = "TIER_3",
    Tier_4 = "TIER_4"
}

export enum DevOpsComponentType {
    Application = "APPLICATION",
    Capability = "CAPABILITY",
    CloudResource = "CLOUD_RESOURCE",
    DataPipeline = "DATA_PIPELINE",
    Library = "LIBRARY",
    MachineLearningModel = "MACHINE_LEARNING_MODEL",
    Other = "OTHER",
    Service = "SERVICE",
    UiElement = "UI_ELEMENT",
    Website = "WEBSITE"
}

/** Data-Depot Component Provider details. */
export type DevOpsComponentsProvider = DevOpsDataProvider & {
    __typename?: "DevOpsComponentsProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** Returns operations-containers owned by this operations-provider. */
    linkedContainers?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentConnection>;
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Component Provider details. */
export type DevOpsComponentsProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Data-Depot Component Provider details. */
export type DevOpsComponentsProviderLinkedContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type DevOpsContainerRelationshipEntityPropertyInput = {
    /**
     * Keys must:
     * * Contain only the characters a-z, A-Z, 0-9, _ and -.
     * * Be no greater than 80 characters long.
     * * Not begin with an underscore.
     */
    key: Scalars["String"]["input"];
    /**
     * * Can be no larger than 5KB for all properties for an entity.
     * * Can not be `null`.
     */
    value: Scalars["JSON"]["input"];
};

export type DevOpsDataProvider = {
    /** ID (in ARI format) of specific instance of app's installation into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

export type DevOpsDataProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Data-Depot Deployment Provider details. */
export type DevOpsDeploymentProvider = DevOpsDataProvider & {
    __typename?: "DevOpsDeploymentProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Deployment Provider details. */
export type DevOpsDeploymentProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** ## Data Depot Designs ### */
export type DevOpsDesign = Node & {
    __typename?: "DevOpsDesign";
    associatedIssues?: Maybe<GraphStoreSimplifiedIssueAssociatedDesignInverseConnection>;
    /** Time the design was created. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** User who created this design. */
    createdByUser?: Maybe<DevOpsUser>;
    /** Description of the design. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The human-readable title of the design entity. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the Design. */
    id: Scalars["ID"]["output"];
    /** URI to view design resource in "inspect mode" in the source system. */
    inspectUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The most recent datetime when the design artefact was modified in the source system. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** User who updated this design. */
    lastUpdatedByUser?: Maybe<DevOpsUser>;
    /** URI for a resource that will display a live embed of that resource in an iFrame. */
    liveEmbedUrl?: Maybe<Scalars["URL"]["output"]>;
    /** List of users who own this design. */
    owners?: Maybe<Array<Maybe<DevOpsUser>>>;
    /** The provider which submitted the entity */
    provider?: Maybe<DevOpsDataProvider>;
    /** The ID of the provider which submitted the entity */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The workflow status of the design. */
    status?: Maybe<DevOpsDesignStatus>;
    /** The thumbnail details of the design. */
    thumbnail?: Maybe<DevOpsThumbnail>;
    /** The type of the design resource. */
    type?: Maybe<DevOpsDesignType>;
    /** URI for the underlying design resource in the source system. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** ## Data Depot Designs ### */
export type DevOpsDesignAssociatedIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** ## Data Depot Designs ### */
export type DevOpsDesignProviderArgs = {
    id: Scalars["ID"]["input"];
    providerTypes?: InputMaybe<Array<DevOpsProviderType>>;
};

/** Data-Depot Design Provider details. */
export type DevOpsDesignProvider = DevOpsDataProvider & {
    __typename?: "DevOpsDesignProvider";
    /** ID (in ARI format) of specific instance of app's installation into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The url domains which this provider supports. */
    handledDomainName?: Maybe<Scalars["String"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Design Provider details. */
export type DevOpsDesignProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

export enum DevOpsDesignStatus {
    None = "NONE",
    ReadyForDevelopment = "READY_FOR_DEVELOPMENT",
    Unknown = "UNKNOWN"
}

export enum DevOpsDesignType {
    Canvas = "CANVAS",
    File = "FILE",
    Group = "GROUP",
    Node = "NODE",
    Other = "OTHER",
    Prototype = "PROTOTYPE"
}

/** Data-Depot Dev Info Provider details. */
export type DevOpsDevInfoProvider = DevOpsDataProvider & {
    __typename?: "DevOpsDevInfoProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
    /** The workspaces associated with this provider */
    workspaces?: Maybe<ToolchainWorkspaceConnection>;
};

/** Data-Depot Dev Info Provider details. */
export type DevOpsDevInfoProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Data-Depot Dev Info Provider details. */
export type DevOpsDevInfoProviderWorkspacesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type DevOpsDocument = Node & {
    __typename?: "DevOpsDocument";
    /** Optional size of the document in bytes. */
    byteSize?: Maybe<Scalars["Long"]["output"]>;
    /** Optional list of users who have collaborated on the document. */
    collaboratorUsers?: Maybe<Array<Maybe<DevOpsUser>>>;
    /**
     * Optional list of collaborators who worked on this document.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use `collaboratorUsers` instead
     */
    collaborators?: Maybe<Array<Maybe<User>>>;
    /** The full content of the document */
    content?: Maybe<DevOpsDocumentContent>;
    /** The created-at timestamp of the document. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Optional user who created this document.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use `createdByUser` instead
     */
    createdBy?: Maybe<User>;
    /** Optional user who created this document. */
    createdByUser?: Maybe<DevOpsUser>;
    /** The human-readable name for the document. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** Optional Export links for the document in different mimeTypes */
    exportLinks?: Maybe<Array<Maybe<DevOpsDocumentExportLink>>>;
    /** The document id given by the external provider */
    externalId?: Maybe<Scalars["String"]["output"]>;
    /** Whether this document entity has any child entities related to it. */
    hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
    /** The document id in ARI format. */
    id: Scalars["ID"]["output"];
    /** The last-updated timestamp of the document. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The user who last updated this document.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use `lastUpdatedByUser` instead
     */
    lastUpdatedBy?: Maybe<User>;
    /** Optional user who last updated this document. */
    lastUpdatedByUser?: Maybe<DevOpsUser>;
    /** The parent entity id in ARI format. */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /** The id of the provider which submitted the entity */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The type information of this document. */
    type?: Maybe<DevOpsDocumentType>;
    /** Document Url */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Document Category */
export enum DevOpsDocumentCategory {
    Archive = "ARCHIVE",
    Audio = "AUDIO",
    Code = "CODE",
    Document = "DOCUMENT",
    Folder = "FOLDER",
    Form = "FORM",
    Image = "IMAGE",
    Other = "OTHER",
    Pdf = "PDF",
    Presentation = "PRESENTATION",
    Shortcut = "SHORTCUT",
    Spreadsheet = "SPREADSHEET",
    Video = "VIDEO"
}

export type DevOpsDocumentContent = {
    __typename?: "DevOpsDocumentContent";
    /** The mimeType of the Document's content */
    mimeType?: Maybe<Scalars["String"]["output"]>;
    /** The full content of the Document */
    text?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsDocumentExportLink = {
    __typename?: "DevOpsDocumentExportLink";
    /** The mimeType of the exportLink. */
    mimeType?: Maybe<Scalars["String"]["output"]>;
    /** The url of the exportLink. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type DevOpsDocumentType = {
    __typename?: "DevOpsDocumentType";
    /** The category which the document type belongs to. */
    category?: Maybe<DevOpsDocumentCategory>;
    /** The file extension of the document. */
    fileExtension?: Maybe<Scalars["String"]["output"]>;
    /** The icon url corresponding to the document type. */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The mimeType of the document. */
    mimeType?: Maybe<Scalars["String"]["output"]>;
};

/** Data-Depot Documentation Provider details. */
export type DevOpsDocumentationProvider = DevOpsDataProvider & {
    __typename?: "DevOpsDocumentationProvider";
    /** ID (in ARI format) of specific instance of app's installation into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /**
     * Returns documentation-containers owned by this documentation-provider.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsDocumentationInJira")' query directive to the 'linkedContainers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedContainers?: Maybe<AriGraphRelationshipConnection>;
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Documentation Provider details. */
export type DevOpsDocumentationProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Data-Depot Documentation Provider details. */
export type DevOpsDocumentationProviderLinkedContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jiraProjectId: Scalars["ID"]["input"];
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type DevOpsEntities = {
    __typename?: "DevOpsEntities";
    /** A connection containing feature flag entities for ARIs provided to the `DevOps.entities` field. */
    featureFlagEntities?: Maybe<DevOpsFeatureFlagConnection>;
};

export type DevOpsEntitiesFeatureFlagEntitiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * An environment that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */
export type DevOpsEnvironment = {
    __typename?: "DevOpsEnvironment";
    /** The type of the environment. */
    category?: Maybe<DevOpsEnvironmentCategory>;
    /** The name of the environment to present to the user. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the environment */
    id?: Maybe<Scalars["String"]["output"]>;
};

/**
 * The types of environments that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */
export enum DevOpsEnvironmentCategory {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type DevOpsFeatureFlag = {
    __typename?: "DevOpsFeatureFlag";
    /** A connection containing detail information for this feature flag. */
    details?: Maybe<DevOpsFeatureFlagDetailsConnection>;
    /** The human-readable name for the feature flag */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The unique provider-assigned identifier for the feature flag */
    flagId?: Maybe<Scalars["String"]["output"]>;
    /** The feature flag entity ARI */
    id: Scalars["ID"]["output"];
    /** The identifier a user would use to reference the key in the source code */
    key?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the provider which submitted the entity */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** Summary information for a single feature flag */
    summary?: Maybe<DevOpsFeatureFlagSummary>;
};

export type DevOpsFeatureFlagDetailsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsFeatureFlagConnection = {
    __typename?: "DevOpsFeatureFlagConnection";
    /** A list of edges in the current page */
    edges?: Maybe<Array<Maybe<DevOpsFeatureFlagEdge>>>;
    /** Information about the current page; used to aid in pagination */
    pageInfo: PageInfo;
    /** The total count of edges in the connection */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsFeatureFlagDetailEdge = {
    __typename?: "DevOpsFeatureFlagDetailEdge";
    /** The cursor to this edge */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at this edge */
    node?: Maybe<DevOpsFeatureFlagDetails>;
};

export type DevOpsFeatureFlagDetails = {
    __typename?: "DevOpsFeatureFlagDetails";
    /** The value served by this feature flag when it is disabled */
    defaultValue?: Maybe<Scalars["String"]["output"]>;
    /** Whether the feature flag is enabled in the given environment (or in summary) */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The category this environment belongs to e.g. "production" */
    environmentCategory?: Maybe<DevOpsEnvironmentCategory>;
    /** The name of the environment */
    environmentName?: Maybe<Scalars["String"]["output"]>;
    /** The last-updated timestamp for this feature flag in this environment */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Present if the feature flag rollout is a simple percentage rollout */
    rolloutPercentage?: Maybe<Scalars["Float"]["output"]>;
    /** A count of the number of rules active for this feature flag in this environment */
    rolloutRules?: Maybe<Scalars["Int"]["output"]>;
    /** A text status to display that represents the rollout; this could be e.g. a named cohort */
    rolloutText?: Maybe<Scalars["String"]["output"]>;
    /** A URL users can use to link to this feature flag in this environment */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type DevOpsFeatureFlagDetailsConnection = {
    __typename?: "DevOpsFeatureFlagDetailsConnection";
    /** A list of edges in the current page */
    edges?: Maybe<Array<Maybe<DevOpsFeatureFlagDetailEdge>>>;
    /** Information about the current page; used to aid in pagination */
    pageInfo: PageInfo;
    /** The total count of edges in the connection */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsFeatureFlagEdge = {
    __typename?: "DevOpsFeatureFlagEdge";
    /** The cursor to this edge */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at this edge */
    node?: Maybe<DevOpsFeatureFlag>;
};

export type DevOpsFeatureFlagProvider = DevOpsDataProvider & {
    __typename?: "DevOpsFeatureFlagProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /**
     * The template url for connecting a feature flag to an issue via the provider
     *
     * The url may contain a template such as `issue.key` or `issue.summary` which will need to be replaced
     * with actual issue data
     */
    connectFeatureFlagTemplateUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The template url for creating a feature flag for an issue via the provider
     *
     * The url may contain a template such as `issue.key` or `issue.summary` which will need to be replaced
     * with actual issue data
     */
    createFeatureFlagTemplateUrl?: Maybe<Scalars["String"]["output"]>;
    /** The documentation URL of the provider */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The home URL of the provider */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The id of the provider */
    id: Scalars["ID"]["output"];
    /** The logo URL of the provider */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The display name of the provider */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

export type DevOpsFeatureFlagProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type DevOpsFeatureFlagSummary = {
    __typename?: "DevOpsFeatureFlagSummary";
    /** The value served by this feature flag when it is disabled */
    defaultValue?: Maybe<Scalars["String"]["output"]>;
    /** Whether the feature flag is enabled in the given environment (or in summary) */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The last-updated timestamp for the summary of the state of the feature flag */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Present if the feature flag rollout is a simple percentage rollout */
    rolloutPercentage?: Maybe<Scalars["Float"]["output"]>;
    /** A count of the number of rules active for this feature flag */
    rolloutRules?: Maybe<Scalars["Int"]["output"]>;
    /** A text status to display that represents the rollout; this could be e.g. a named cohort */
    rolloutText?: Maybe<Scalars["String"]["output"]>;
    /** A URL users can use to link to a summary view of this flag */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type DevOpsMetrics = {
    __typename?: "DevOpsMetrics";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cycleTime?: Maybe<DevOpsMetricsCycleTime>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deploymentFrequency?: Maybe<DevOpsMetricsDeploymentFrequency>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deploymentSize?: Maybe<DevOpsMetricsDeploymentSize>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    perDeploymentMetrics?: Maybe<DevOpsMetricsPerDeploymentMetricsConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    perIssueMetrics?: Maybe<DevOpsMetricsPerIssueMetricsConnection>;
};

export type DevOpsMetricsCycleTimeArgs = {
    cycleTimePercentiles?: InputMaybe<Array<Scalars["Int"]["input"]>>;
    filter: DevOpsMetricsFilterInput;
    isIncludeCycleTimeMean?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DevOpsMetricsDeploymentFrequencyArgs = {
    environmentCategory?: DevOpsEnvironmentCategory;
    filter: DevOpsMetricsFilterInput;
    rollupType?: DevOpsMetricsRollupType;
};

export type DevOpsMetricsDeploymentSizeArgs = {
    environmentCategory?: DevOpsEnvironmentCategory;
    filter: DevOpsMetricsFilterInput;
    rollupType?: DevOpsMetricsRollupType;
};

export type DevOpsMetricsPerDeploymentMetricsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: DevOpsMetricsPerDeploymentMetricsFilter;
    first: Scalars["Int"]["input"];
};

export type DevOpsMetricsPerIssueMetricsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: DevOpsMetricsPerIssueMetricsFilter;
    first: Scalars["Int"]["input"];
};

export type DevOpsMetricsCycleTime = {
    __typename?: "DevOpsMetricsCycleTime";
    /** List of cycle time metrics for each requested roll up metric type. */
    cycleTimeMetrics?: Maybe<Array<Maybe<DevOpsMetricsCycleTimeMetrics>>>;
    /** Indicates whether user requesting metrics has permission */
    hasPermission?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether user requesting metrics has permission to all contributing issues. */
    hasPermissionForAllContributingIssues?: Maybe<Scalars["Boolean"]["output"]>;
    /** The development phase which the cycle time is calculated for. */
    phase?: Maybe<DevOpsMetricsCycleTimePhase>;
    /**
     * The size of time interval in which data points are rolled up in.
     * E.g. Count of data over 2 weeks with 1 day resolution means rollup is number of datapoints per day over 2 weeks.
     */
    resolution?: Maybe<DevOpsMetricsResolution>;
};

export type DevOpsMetricsCycleTimeData = {
    __typename?: "DevOpsMetricsCycleTimeData";
    /** Rolled up cycle time data (in seconds) between ('dateTime') and ('dateTime' + 'resolution'). Roll up method specified by 'metric'. */
    cycleTimeSeconds?: Maybe<Scalars["Long"]["output"]>;
    /** dataTime of data point. Each data point is separated by size of time resolution specified. */
    dateTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** Number of issues shipped between ('dateTime') and ('dateTime' + 'resolution'). */
    issuesShippedCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsMetricsCycleTimeMean = DevOpsMetricsCycleTimeMetrics & {
    __typename?: "DevOpsMetricsCycleTimeMean";
    /**
     * Mean of data points in 'data' array. Rounded to the nearest second.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    aggregateData?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    data?: Maybe<Array<Maybe<DevOpsMetricsCycleTimeData>>>;
};

export type DevOpsMetricsCycleTimeMetrics = {
    /**
     * Data aggregated according to the rollup type specified. Rounded to the nearest second.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    aggregateData?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The cycle time data points, computed using roll up of the type specified in 'metric'. Rolled up by specified resolution.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    data?: Maybe<Array<Maybe<DevOpsMetricsCycleTimeData>>>;
};

export type DevOpsMetricsCycleTimePercentile = DevOpsMetricsCycleTimeMetrics & {
    __typename?: "DevOpsMetricsCycleTimePercentile";
    /**
     * The percentile value across all cycle-times in the database between dateTimeFrom and dateTimeTo
     * (not across the datapoints in 'data' array). Rounded to the nearest second.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    aggregateData?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    data?: Maybe<Array<Maybe<DevOpsMetricsCycleTimeData>>>;
    /**
     * Percentile metric of returned values. Will be between 0 and 100.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    percentile?: Maybe<Scalars["Int"]["output"]>;
};

export enum DevOpsMetricsCycleTimePhase {
    /** Development phase from initial code commit to deployed code. */
    CommitToDeployment = "COMMIT_TO_DEPLOYMENT",
    /** Development phase from initial code commit to opened pull request. */
    CommitToPr = "COMMIT_TO_PR"
}

export type DevOpsMetricsDeploymentFrequency = {
    __typename?: "DevOpsMetricsDeploymentFrequency";
    /**
     * Deployment frequency aggregated according to the time resolution and rollup type specified.
     *
     * E.g. if the resolution were one week and the rollup type median, this value would be the median weekly
     * deployment count.
     */
    aggregateData?: Maybe<Scalars["Float"]["output"]>;
    /** The deployment frequency data points rolled up by specified resolution. */
    data?: Maybe<Array<Maybe<DevOpsMetricsDeploymentFrequencyData>>>;
    /** Deployment environment type. */
    environmentType?: Maybe<DevOpsEnvironmentCategory>;
    /** Indicates whether user requesting deployment frequency has permission */
    hasPermission?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The size of time interval in which data points are rolled up in.
     * E.g. Count of data over 2 weeks with 1 day resolution means rollup is number of datapoints per day over 2 weeks.
     */
    resolution?: Maybe<DevOpsMetricsResolution>;
    /** Deployment state. Currently will only return for SUCCESSFUL, no State filter/input supported yet. */
    state?: Maybe<DeploymentState>;
};

/** #### Response ##### */
export type DevOpsMetricsDeploymentFrequencyData = {
    __typename?: "DevOpsMetricsDeploymentFrequencyData";
    /** Number of deployments between ('dateTime') and ('dateTime' + 'resolution') */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** dataTime of data point. Each data point is separated by size of time resolution specified. */
    dateTime?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DevOpsMetricsDeploymentMetrics = {
    __typename?: "DevOpsMetricsDeploymentMetrics";
    deployment?: Maybe<DeploymentSummary>;
    /**
     * Currently the only size metric supported is "number of issues per deployment".
     *
     * Note: The issues per deployment count will ignore Jira permissions, meaning the user may not have permission to view all of the issues.
     * The list of `issueIds` contained in the `DeploymentSummary` will however respect Jira permissions.
     */
    deploymentSize?: Maybe<Scalars["Long"]["output"]>;
};

export type DevOpsMetricsDeploymentMetricsEdge = {
    __typename?: "DevOpsMetricsDeploymentMetricsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsMetricsDeploymentMetrics>;
};

export type DevOpsMetricsDeploymentSize = {
    __typename?: "DevOpsMetricsDeploymentSize";
    /**
     * Deployment size aggregated according to the rollup type specified.
     *
     * E.g. if the rollup type were median, this will be the median number of issues per deployment
     * over the whole time period.
     */
    aggregateData?: Maybe<Scalars["Float"]["output"]>;
    /** The deployment size data points rolled up by specified resolution. */
    data?: Maybe<Array<Maybe<DevOpsMetricsDeploymentSizeData>>>;
};

export type DevOpsMetricsDeploymentSizeData = {
    __typename?: "DevOpsMetricsDeploymentSizeData";
    /** dataTime of data point. Each data point is separated by size of time resolution specified. */
    dateTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** Aggregated number of issues per deployment between ('dateTime') and ('dateTime' + 'resolution') */
    deploymentSize?: Maybe<Scalars["Float"]["output"]>;
};

/** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */
export type DevOpsMetricsFilterInput = {
    /** The identifier that indicates which cloud instance this data is to be fetched for. */
    cloudId: Scalars["ID"]["input"];
    /** The end dateTime for overall time interval to return results for. The interval is exclusive of this value. */
    endAtExclusive: Scalars["DateTime"]["input"];
    /** Issue level filters. Currently, in order to apply this filter, jiraProjectIds must also be provided */
    issueFilters?: InputMaybe<DevOpsMetricsIssueFilters>;
    /** List of Jira projectIds in the given 'cloudId' to fetch metrics for. Max limit of 10. */
    jiraProjectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * The size of time interval in which to rollup data points in. Default is 1 day.
     * E.g. Count of data over 2 weeks with 1 day resolution means rollup is number of datapoints per day over 2 weeks.
     */
    resolution?: InputMaybe<DevOpsMetricsResolutionInput>;
    /** The start dateTime for overall time interval to return results for. The interval is inclusive of this value. */
    startFromInclusive: Scalars["DateTime"]["input"];
    /**
     * The Olson Timezone ID. E.g. 'Australia/Sydney'.
     * Specifies which timezone to aggregate data in so that daylight savings is taken into account if it occurred between request time range.
     */
    timezoneId?: InputMaybe<Scalars["String"]["input"]>;
};

export type DevOpsMetricsIssueFilters = {
    /**
     * Only issues in these epics will be returned.
     *
     * Note:
     * * If a null ID is included in the list, issues not in epics will be included in the results.
     * * If a subtask's parent issue is in one of the epics, the subtask will also be returned.
     */
    epicIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    /** Only issues of these types will be returned. */
    issueTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type DevOpsMetricsIssueMetrics = {
    __typename?: "DevOpsMetricsIssueMetrics";
    commitsCount?: Maybe<Scalars["Int"]["output"]>;
    /** Issue ARI */
    id: Scalars["ID"]["output"];
    /** DateTime of the most recent successful deployment to production. */
    lastSuccessfulProductionDeployment?: Maybe<Scalars["DateTime"]["output"]>;
    /** Average of review times of all pull requests associated with the issueId. */
    meanReviewTimeSeconds?: Maybe<Scalars["Long"]["output"]>;
    pullRequestsCount?: Maybe<Scalars["Int"]["output"]>;
    /** Development time from initial code commit to deployed code in production environment. */
    totalCycleTimeSeconds?: Maybe<Scalars["Long"]["output"]>;
};

export type DevOpsMetricsIssueMetricsEdge = {
    __typename?: "DevOpsMetricsIssueMetricsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsMetricsIssueMetrics>;
};

export type DevOpsMetricsPerDeploymentMetricsConnection = {
    __typename?: "DevOpsMetricsPerDeploymentMetricsConnection";
    edges?: Maybe<Array<Maybe<DevOpsMetricsDeploymentMetricsEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsMetricsDeploymentMetrics>>>;
    pageInfo: PageInfo;
};

/** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */
export type DevOpsMetricsPerDeploymentMetricsFilter = {
    /** The identifier that indicates which cloud instance this data is to be fetched for. */
    cloudId: Scalars["ID"]["input"];
    /** The end dateTime for overall time interval to return results for. The interval is exclusive of this value. */
    endAtExclusive: Scalars["DateTime"]["input"];
    /** List of environment categories to filter for - only deployments in these categories will be returned. */
    environmentCategories?: Array<DevOpsEnvironmentCategory>;
    /** List of Jira projectIds in the given 'cloudId' to fetch metrics for. Max limit of 10. */
    jiraProjectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The start dateTime for overall time interval to return results for. The interval is inclusive of this value. */
    startFromInclusive: Scalars["DateTime"]["input"];
};

export type DevOpsMetricsPerIssueMetricsConnection = {
    __typename?: "DevOpsMetricsPerIssueMetricsConnection";
    edges?: Maybe<Array<Maybe<DevOpsMetricsIssueMetricsEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsMetricsIssueMetrics>>>;
    pageInfo: PageInfo;
};

/** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */
export type DevOpsMetricsPerIssueMetricsFilter = {
    /** The identifier that indicates which cloud instance this data is to be fetched for. */
    cloudId: Scalars["ID"]["input"];
    /** The end dateTime for overall time interval to return results for. The interval is exclusive of this value. */
    endAtExclusive: Scalars["DateTime"]["input"];
    /** Issue level filters. Currently, in order to apply this filter, jiraProjectIds must also be provided */
    issueFilters?: InputMaybe<DevOpsMetricsIssueFilters>;
    /** List of Jira projectIds in the given 'cloudId' to fetch metrics for. Max limit of 10. */
    jiraProjectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The start dateTime for overall time interval to return results for. The interval is inclusive of this value. */
    startFromInclusive: Scalars["DateTime"]["input"];
};

export type DevOpsMetricsResolution = {
    __typename?: "DevOpsMetricsResolution";
    /** Unit for specified resolution value. */
    unit?: Maybe<DevOpsMetricsResolutionUnit>;
    /** Value for resolution specified. */
    value?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsMetricsResolutionInput = {
    /** Input unit for specified resolution value. */
    unit: DevOpsMetricsResolutionUnit;
    /** Input value for resolution specified. */
    value: Scalars["Int"]["input"];
};

/** Unit for specified resolution value. */
export enum DevOpsMetricsResolutionUnit {
    Day = "DAY",
    Hour = "HOUR",
    Week = "WEEK"
}

export enum DevOpsMetricsRollupOption {
    Mean = "MEAN",
    Percentile = "PERCENTILE"
}

export type DevOpsMetricsRollupType = {
    /** Must only be specified if the rollup kind is PERCENTILE */
    percentile?: InputMaybe<Scalars["Int"]["input"]>;
    type: DevOpsMetricsRollupOption;
};

export type DevOpsMutation = {
    __typename?: "DevOpsMutation";
    /**
     * Empty types are not allowed in schema language, even if they are later extended
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    _empty?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ariGraph?: Maybe<AriGraphMutation>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Graph")' query directive to the 'graph' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use `graphStore` field on root instead
     */
    graph?: Maybe<GraphMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Toolchain")' query directive to the 'toolchain' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    toolchain?: Maybe<ToolchainMutation>;
};

export type DevOpsMutation_EmptyArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DevOpsOperationsComponentDetails = {
    __typename?: "DevOpsOperationsComponentDetails";
    /** Dev ops component avatar. */
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    /** Dev ops component type. */
    componentType?: Maybe<DevOpsComponentType>;
    /** Dev ops component description. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The component id in ARI format. */
    id: Scalars["ID"]["output"];
    /** The date and time the devops component was last updated. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The name of the devops component. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The component id as sent by the provider. */
    providerComponentId?: Maybe<Scalars["String"]["output"]>;
    /** The id of the provider hosting the devops component */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** Dev ops component tier. */
    tier?: Maybe<DevOpsComponentTier>;
    /** Dev ops component url. */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsOperationsIncidentDetails = {
    __typename?: "DevOpsOperationsIncidentDetails";
    actionItems?: Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueConnection>;
    /** The incident affected components ids. */
    affectedComponentIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Returns components associated with this incident. */
    affectedComponents?: Maybe<GraphStoreSimplifiedComponentImpactedByIncidentInverseConnection>;
    /** The date and time the incident was created. */
    createdDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The incident description. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The incident id in ARI format. */
    id: Scalars["ID"]["output"];
    /** Returns connection entities for PIR relationships associated with this incident. */
    linkedPostIncidentReviews?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkConnection>;
    /** Id of the provider which created the incident */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The incident severity. */
    severity?: Maybe<DevOpsOperationsIncidentSeverity>;
    /** The incident status. */
    status?: Maybe<DevOpsOperationsIncidentStatus>;
    /** The incident summary. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The incident url sent by the provider */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsOperationsIncidentDetailsActionItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsOperationsIncidentDetailsAffectedComponentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsOperationsIncidentDetailsLinkedPostIncidentReviewsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum DevOpsOperationsIncidentSeverity {
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5",
    Pending = "PENDING",
    Unknown = "UNKNOWN"
}

export enum DevOpsOperationsIncidentStatus {
    Open = "OPEN",
    Resolved = "RESOLVED",
    Unknown = "UNKNOWN"
}

export type DevOpsOperationsPostIncidentReviewDetails = {
    __typename?: "DevOpsOperationsPostIncidentReviewDetails";
    /** The date and time the PIR was created. */
    createdDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** Post incident review description. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The post incident review id in ARI format. */
    id: Scalars["ID"]["output"];
    /** The date and time the PIR was last updated. */
    lastUpdatedDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The id of the provider hosting the post incident review in ARI format */
    providerAri?: Maybe<Scalars["String"]["output"]>;
    /** The post incident review id as sent by the provider. */
    providerPostIncidentReviewId?: Maybe<Scalars["String"]["output"]>;
    /** Ids of linked incidents. */
    reviewsIncidentIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Post incident review component type. */
    status?: Maybe<DevOpsPostIncidentReviewStatus>;
    /** The name of the post incident review. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** Post incident review url. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Data-Depot Operations Provider details. */
export type DevOpsOperationsProvider = DevOpsDataProvider & {
    __typename?: "DevOpsOperationsProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** Returns operations-containers owned by this operations-provider. */
    linkedContainers?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentConnection>;
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Operations Provider details. */
export type DevOpsOperationsProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Data-Depot Operations Provider details. */
export type DevOpsOperationsProviderLinkedContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export enum DevOpsPostIncidentReviewStatus {
    Completed = "COMPLETED",
    InProgress = "IN_PROGRESS",
    Todo = "TODO"
}

export type DevOpsProjectDetails = {
    __typename?: "DevOpsProjectDetails";
    /** The resource icon for the project. */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Global identifier for the Project. */
    id: Scalars["ID"]["output"];
    /** Unique human-readable value representing the project identifier. */
    key?: Maybe<Scalars["String"]["output"]>;
    /** The most recent datetime when the project artifact was modified in the source system. */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The name of the project entity. */
    name: Scalars["String"]["output"];
    /** The object of the user owning this project. */
    owner?: Maybe<DevOpsProjectOwner>;
    /** The target date object of the project resource. */
    projectTargetDate?: Maybe<DevOpsProjectTargetDate>;
    /** The ID of the provider which submitted the entity */
    providerId: Scalars["String"]["output"];
    /** The status of the project. */
    status?: Maybe<DevOpsProjectStatus>;
    /** URL for the underlying project resource in the source system. */
    url: Scalars["URL"]["output"];
};

export type DevOpsProjectOwner = {
    __typename?: "DevOpsProjectOwner";
    /** The atlassian user account id of the owner of the project. */
    atlassianUserId?: Maybe<Scalars["String"]["output"]>;
};

export enum DevOpsProjectStatus {
    Cancelled = "CANCELLED",
    Completed = "COMPLETED",
    InProgress = "IN_PROGRESS",
    Paused = "PAUSED",
    Pending = "PENDING",
    Unknown = "UNKNOWN"
}

export type DevOpsProjectTargetDate = {
    __typename?: "DevOpsProjectTargetDate";
    /** The estimated target completion date of the source project. */
    targetDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The time period accompanying the target date. */
    targetDateType?: Maybe<DevOpsProjectTargetDateType>;
};

export enum DevOpsProjectTargetDateType {
    Day = "DAY",
    Month = "MONTH",
    Quarter = "QUARTER",
    Unknown = "UNKNOWN"
}

/** A provider that a deployment has been done with. */
export type DevOpsProvider = {
    __typename?: "DevOpsProvider";
    /** Links associated with the DevOpsProvider. Currently contains documentation, home and listDeploymentsTemplate URLs. */
    links?: Maybe<DevOpsProviderLinks>;
    /**
     * The logo to display for the Provider within the UI. This should be a 32x32 (or similar) favicon style image.
     * In the future this may be extended to support multi-resolution logos.
     */
    logo?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The display name to use for the Provider. May be rendered in the UI. Example: 'Github'.
     * In the future this may be extended to support an I18nString for localized names.
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** A type to group various URLs of Provider */
export type DevOpsProviderLinks = {
    __typename?: "DevOpsProviderLinks";
    /** Documentation URL of the provider */
    documentation?: Maybe<Scalars["URL"]["output"]>;
    /** Home URL of the provider */
    home?: Maybe<Scalars["URL"]["output"]>;
    /** List deployments URL for the provider */
    listDeploymentsTemplate?: Maybe<Scalars["URL"]["output"]>;
};

export enum DevOpsProviderNamespace {
    Asap = "ASAP",
    Classic = "CLASSIC",
    Forge = "FORGE",
    Oauth = "OAUTH"
}

/**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */
export enum DevOpsProviderType {
    Build = "BUILD",
    Deployment = "DEPLOYMENT",
    Design = "DESIGN",
    DevopsComponents = "DEVOPS_COMPONENTS",
    DevInfo = "DEV_INFO",
    Documentation = "DOCUMENTATION",
    FeatureFlag = "FEATURE_FLAG",
    Operations = "OPERATIONS",
    Project = "PROJECT",
    RemoteLinks = "REMOTE_LINKS",
    Security = "SECURITY"
}

export type DevOpsProviders = {
    __typename?: "DevOpsProviders";
    /** The list of build providers for a site */
    buildProviders?: Maybe<Array<Maybe<DevOpsBuildProvider>>>;
    /** The list of deployment providers for a site */
    deploymentProviders?: Maybe<Array<Maybe<DevOpsDeploymentProvider>>>;
    /** The list of design providers for a site */
    designProviders?: Maybe<Array<Maybe<DevOpsDesignProvider>>>;
    /** The list of dev info providers for a site */
    devInfoProviders?: Maybe<Array<Maybe<DevOpsDevInfoProvider>>>;
    /** The list of component providers for a site */
    devopsComponentsProviders?: Maybe<Array<Maybe<DevOpsComponentsProvider>>>;
    /** The list of documentation providers for a site */
    documentationProviders?: Maybe<Array<Maybe<DevOpsDocumentationProvider>>>;
    /** The list of feature flag providers for a site */
    featureFlagProviders?: Maybe<Array<Maybe<DevOpsFeatureFlagProvider>>>;
    /** The list of operations providers for a site */
    operationsProviders?: Maybe<Array<Maybe<DevOpsOperationsProvider>>>;
    /** The list of remote links providers for a site */
    remoteLinksProviders?: Maybe<Array<Maybe<DevOpsRemoteLinksProvider>>>;
    /** The list of security providers for a site */
    securityProviders?: Maybe<Array<Maybe<DevOpsSecurityProvider>>>;
};

export enum DevOpsPullRequestApprovalStatus {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    Unapproved = "UNAPPROVED"
}

export type DevOpsPullRequestDetails = {
    __typename?: "DevOpsPullRequestDetails";
    /** The author of this PR. */
    author?: Maybe<User>;
    /**
     * DO NOT USE THIS as it will be removed later.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsPullRequestInCode")' query directive to the 'authorId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    authorId?: Maybe<Scalars["ID"]["output"]>;
    /** The number of comments on the PR. */
    commentCount?: Maybe<Scalars["Int"]["output"]>;
    /** The destination branch of this PR. */
    destinationBranch?: Maybe<DevOpsBranchInfo>;
    /** The pull-request id in ARI format. */
    id: Scalars["ID"]["output"];
    /** The last-updated timestamp of the PR. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The provider icon URL for the PR */
    providerIcon?: Maybe<Scalars["URL"]["output"]>;
    /** The provider ID for the PR */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The provider name for the PR */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The identifier for the PR. Must be unique for a given Provider and Repository. */
    pullRequestInternalId?: Maybe<Scalars["String"]["output"]>;
    /** The ID (in ARI format) of the Repository that the PR belongs to. */
    repositoryId?: Maybe<Scalars["ID"]["output"]>;
    /** The internal ID of the Repository that the PR belongs to. */
    repositoryInternalId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the Repository that the PR belongs to. */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /** The Url of the Repository that the PR belongs to. */
    repositoryUrl?: Maybe<Scalars["String"]["output"]>;
    /** The list of reviewers of this PR. */
    reviewers?: Maybe<Array<Maybe<DevOpsReviewer>>>;
    /**
     * Sanitized id value of the author.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsPullRequestInCode")' query directive to the 'sanitizedAuthorId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sanitizedAuthorId?: Maybe<Scalars["String"]["output"]>;
    /** The source branch of this PR. */
    sourceBranch?: Maybe<DevOpsBranchInfo>;
    /** The status of the PR - OPEN, MERGED, DECLINED, UNKNOWN */
    status?: Maybe<DevOpsPullRequestStatus>;
    /** The list of supported actions for this PR */
    supportedActions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Pull request title. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Pull Request URL */
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum DevOpsPullRequestStatus {
    Declined = "DECLINED",
    Draft = "DRAFT",
    Merged = "MERGED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum DevOpsRelationshipCertainty {
    /** The relationship was created by a user. */
    Explicit = "EXPLICIT",
    /** The relationship was inferred by a system. */
    Implicit = "IMPLICIT"
}

export enum DevOpsRelationshipCertaintyFilter {
    /** Return all relationships. */
    All = "ALL",
    /** Return only relationships created by a user. */
    Explicit = "EXPLICIT",
    /** Return only relationships inferred by a system. */
    Implicit = "IMPLICIT"
}

/** Data-Depot Remote Links Provider details. */
export type DevOpsRemoteLinksProvider = DevOpsDataProvider & {
    __typename?: "DevOpsRemoteLinksProvider";
    /** ID (in ARI format) of specific instance of installation an app into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
};

/** Data-Depot Remote Links Provider details. */
export type DevOpsRemoteLinksProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type DevOpsRepository = {
    __typename?: "DevOpsRepository";
    /** Repository avatar Url */
    avatarUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The repo id from the external system */
    externalId?: Maybe<Scalars["String"]["output"]>;
    /** The repository id in ARI format. */
    id: Scalars["ID"]["output"];
    /** The name of the repository. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The id of the provider which submitted the entity */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** Repository Url */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** #################### Enums ##################### */
export enum DevOpsRepositoryHostingProviderFilter {
    All = "ALL",
    BitbucketCloud = "BITBUCKET_CLOUD",
    ThirdParty = "THIRD_PARTY"
}

export type DevOpsReviewer = {
    __typename?: "DevOpsReviewer";
    /** Approval status from this reviewer */
    approvalStatus?: Maybe<DevOpsPullRequestApprovalStatus>;
    /**
     * Sanitized id value of the reviewer.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsPullRequestInCode")' query directive to the 'sanitizedUserId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sanitizedUserId?: Maybe<Scalars["String"]["output"]>;
    /** User details for this reviewer */
    user?: Maybe<User>;
    /**
     * DO NOT USE THIS as it will be removed later.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsPullRequestInCode")' query directive to the 'userId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userId?: Maybe<Scalars["ID"]["output"]>;
};

/** Data-Depot Security Provider details. */
export type DevOpsSecurityProvider = DevOpsDataProvider & {
    __typename?: "DevOpsSecurityProvider";
    /** ID (in ARI format) of specific instance of app's installation into a Jira site. */
    appInstallationId?: Maybe<Scalars["ID"]["output"]>;
    /** Config state on a specified site for this provider */
    configState?: Maybe<JiraAppConfigState>;
    /** URL navigates to application's documentation site. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** URL navigates to application's home page. */
    homeUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique id for the application, not ARI format */
    id: Scalars["ID"]["output"];
    /**
     * Returns security-containers owned by this security-provider.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'linkedContainers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedContainers?: Maybe<AriGraphRelationshipConnection>;
    /**
     * Returns security-workspaces linked to this security-provider installation.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'linkedWorkspaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedWorkspaces?: Maybe<AriGraphRelationshipConnection>;
    /** URL for loading application logo. */
    logoUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Application name in human-readable format. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The provider's namespace */
    namespace?: Maybe<DevOpsProviderNamespace>;
    /** The provider type specified as a field for ease of use as an input by the client. */
    providerType?: Maybe<DevOpsProviderType>;
    /** The generic containers actions which this data provider implements. */
    supportedActions?: Maybe<DevOpsSupportedActions>;
    /**
     * The workspaces associated with this provider
     * Differs from `linkedWorkspaces` above as it uses the generic Toolchain API
     */
    workspaces?: Maybe<ToolchainWorkspaceConnection>;
};

/** Data-Depot Security Provider details. */
export type DevOpsSecurityProviderConfigStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Data-Depot Security Provider details. */
export type DevOpsSecurityProviderLinkedContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jiraProjectId: Scalars["ID"]["input"];
    type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Data-Depot Security Provider details. */
export type DevOpsSecurityProviderLinkedWorkspacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Data-Depot Security Provider details. */
export type DevOpsSecurityProviderWorkspacesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type DevOpsSecurityVulnerabilityAdditionalInfo = {
    __typename?: "DevOpsSecurityVulnerabilityAdditionalInfo";
    /** The text content of the additional info. */
    content?: Maybe<Scalars["String"]["output"]>;
    /** The URL allowing Jira to link directly to relevant additional info. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** ## Data Depot Security Vulnerabilities ### */
export type DevOpsSecurityVulnerabilityDetails = {
    __typename?: "DevOpsSecurityVulnerabilityDetails";
    /** The additional info set by security provider */
    additionalInfo?: Maybe<DevOpsSecurityVulnerabilityAdditionalInfo>;
    /** The vulnerability's description. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The vulnerability id in ARI format. */
    id: Scalars["ID"]["output"];
    /** Public or private identifiers for this vulnerability. */
    identifiers: Array<DevOpsSecurityVulnerabilityIdentifier>;
    /** The date and time the object was introduced. */
    introducedDate?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Returns connection entities for Jira issue relationships associated with this vulnerability.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'linkedJiraIssues' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedJiraIssues?: Maybe<AriGraphRelationshipConnection>;
    /** The vulnerability id sent by the provider */
    providerVulnerabilityId?: Maybe<Scalars["ID"]["output"]>;
    /** The details of container containing this vulnerability. */
    securityContainer?: Maybe<ThirdPartySecurityContainer>;
    /** The ID (in ARI format) of the associated security container */
    securityContainerId?: Maybe<Scalars["ID"]["output"]>;
    /** The severity level of the vulnerability set by provider. */
    severity?: Maybe<DevOpsSecurityVulnerabilitySeverity>;
    /** The current state of this vulnerability. */
    status?: Maybe<DevOpsSecurityVulnerabilityStatus>;
    /** The vulnerability title. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** The URL for navigating to vulnerability details in security-provider */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** ## Data Depot Security Vulnerabilities ### */
export type DevOpsSecurityVulnerabilityDetailsLinkedJiraIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type DevOpsSecurityVulnerabilityIdentifier = {
    __typename?: "DevOpsSecurityVulnerabilityIdentifier";
    /** A string value identify the vulnerability, e.g CVE identifier. */
    displayName: Scalars["String"]["output"];
    /** The URL navigates to vulnerability details. */
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum DevOpsSecurityVulnerabilitySeverity {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    Unknown = "UNKNOWN"
}

export enum DevOpsSecurityVulnerabilityStatus {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type DevOpsService = Node & {
    __typename?: "DevOpsService";
    /**
     * Bitbucket repositories that are available to be linked with via createDevOpsServiceAndRepositoryRelationship
     * If nameFilter is provided, only repositories with names containing this case-insensitive string will be returned.
     * For case of creating a new service (that has not been created), consumer can use `bitbucketRepositoriesAvailableToLinkWithNewDevOpsService` query
     */
    bitbucketRepositoriesAvailableToLinkWith?: Maybe<BitbucketRepositoryIdConnection>;
    /** The cloud ID of the DevOps Service */
    cloudId: Scalars["String"]["output"];
    /** The ID of the DevOps Service in Compass */
    compassId?: Maybe<Scalars["ID"]["output"]>;
    /** The revision of the DevOps Service in Compass */
    compassRevision?: Maybe<Scalars["Int"]["output"]>;
    /** Relationship with a DevOps Service that contains this DevOps service */
    containedByDevOpsServiceRelationship?: Maybe<DevOpsServiceRelationship>;
    /** Relationships with DevOps Services that this DevOps Service contains */
    containsDevOpsServiceRelationships?: Maybe<DevOpsServiceRelationshipConnection>;
    /** The datetime when the DevOps Service was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The user who created the DevOps Service */
    createdBy: Scalars["String"]["output"];
    /** Relationships with DevOps Services that are depend on this DevOps Service */
    dependedOnByDevOpsServiceRelationships?: Maybe<DevOpsServiceRelationshipConnection>;
    /** Relationships with DevOps Services that this DevOps Service depends on */
    dependsOnDevOpsServiceRelationships?: Maybe<DevOpsServiceRelationshipConnection>;
    /** The description of the DevOps Service */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The DevOps Service ARI */
    id: Scalars["ID"]["output"];
    /** Flag indicating if component is synced with Compass */
    isCompassSynchronised: Scalars["Boolean"]["output"];
    /** Flag indicating if service edit is disabled by Compass */
    isEditDisabledByCompass: Scalars["Boolean"]["output"];
    /** Relationships with Jira projects associated to this DevOps Service. */
    jiraProjects?: Maybe<DevOpsServiceAndJiraProjectRelationshipConnection>;
    /** The most recent datetime when the DevOps Service was updated */
    lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The last user who updated the DevOps Service */
    lastUpdatedBy?: Maybe<Scalars["String"]["output"]>;
    /** Returns Incident entities associated with this JSM Service. */
    linkedIncidents?: Maybe<GraphJiraIssueConnection>;
    /** The name of the DevOps Service */
    name: Scalars["String"]["output"];
    /** The relationship between this Service and an Opsgenie team */
    opsgenieTeamRelationship?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
    /** Opsgenie teams that are available to be linked with via createDevOpsServiceAndOpsgenieTeamRelationship */
    opsgenieTeamsAvailableToLinkWith?: Maybe<OpsgenieTeamConnection>;
    /** The organisation ID of the DevOps Service */
    organizationId: Scalars["String"]["output"];
    /** Look up JSON properties of the DevOps Service by keys */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /** Relationships with VCS repositories associated to this DevOps Service */
    repositoryRelationships?: Maybe<DevOpsServiceAndRepositoryRelationshipConnection>;
    /**
     * The revision that must be provided when updating a DevOps Service to prevent
     * simultaneous updates from overwriting each other
     */
    revision: Scalars["ID"]["output"];
    /** Tier assigned to the DevOps Service */
    serviceTier?: Maybe<DevOpsServiceTier>;
    /** Type assigned to the DevOps Service */
    serviceType?: Maybe<DevOpsServiceType>;
    /** Services that are available to be linked with via createDevOpsServiceRelationship */
    servicesAvailableToLinkWith?: Maybe<DevOpsServiceConnection>;
};

export type DevOpsServiceBitbucketRepositoriesAvailableToLinkWithArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    nameFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type DevOpsServiceContainsDevOpsServiceRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsServiceDependedOnByDevOpsServiceRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsServiceDependsOnDevOpsServiceRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsServiceJiraProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndJiraProjectRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsServiceOpsgenieTeamsAvailableToLinkWithArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsServicePropertiesArgs = {
    keys: Array<Scalars["String"]["input"]>;
};

export type DevOpsServiceRepositoryRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndRepositoryRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<DevOpsServiceAndRepositoryRelationshipSort>;
};

export type DevOpsServiceServicesAvailableToLinkWithArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServicesFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A relationship between DevOps Service and Jira Project Team */
export type DevOpsServiceAndJiraProjectRelationship = Node & {
    __typename?: "DevOpsServiceAndJiraProjectRelationship";
    /** When the relationship was created. */
    createdAt: Scalars["DateTime"]["output"];
    /** Who created the relationship. */
    createdBy: Scalars["String"]["output"];
    /** An optional description of the relationship. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The details of DevOps Service in the relationship. */
    devOpsService?: Maybe<DevOpsService>;
    /** The ARI of this relationship. */
    id: Scalars["ID"]["output"];
    /** The Jira project related to the repository. */
    jiraProject?: Maybe<JiraProject>;
    /** When the relationship was updated last.  Only present for relationships that have been updated. */
    lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Who updated the relationship last. Only present for relationships that have been updated. */
    lastUpdatedBy?: Maybe<Scalars["String"]["output"]>;
    /** Look up JSON properties of the relationship by keys. */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /** The type of the relationship. */
    relationshipType: DevOpsServiceAndJiraProjectRelationshipType;
    /**
     * The revision must be provided when updating a relationship to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["output"];
};

/** A relationship between DevOps Service and Jira Project Team */
export type DevOpsServiceAndJiraProjectRelationshipPropertiesArgs = {
    keys: Array<Scalars["String"]["input"]>;
};

export type DevOpsServiceAndJiraProjectRelationshipConnection = {
    __typename?: "DevOpsServiceAndJiraProjectRelationshipConnection";
    edges?: Maybe<Array<Maybe<DevOpsServiceAndJiraProjectRelationshipEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsServiceAndJiraProjectRelationship>>>;
    pageInfo: PageInfo;
};

export type DevOpsServiceAndJiraProjectRelationshipEdge = {
    __typename?: "DevOpsServiceAndJiraProjectRelationshipEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsServiceAndJiraProjectRelationship>;
};

/** #################### Filtering and Sorting Inputs ##################### */
export type DevOpsServiceAndJiraProjectRelationshipFilter = {
    /** Include only relationships with the specified certainty */
    certainty?: InputMaybe<DevOpsRelationshipCertaintyFilter>;
    /** Include only relationships with the specified relationship type */
    relationshipTypeIn?: InputMaybe<
        Array<DevOpsServiceAndJiraProjectRelationshipType>
    >;
};

export enum DevOpsServiceAndJiraProjectRelationshipType {
    /** A relationship created for the change management feature */
    ChangeManagement = "CHANGE_MANAGEMENT",
    /** A standard relationship */
    Default = "DEFAULT"
}

/** A relationship between DevOps Service and Opsgenie Team */
export type DevOpsServiceAndOpsgenieTeamRelationship = Node & {
    __typename?: "DevOpsServiceAndOpsgenieTeamRelationship";
    /** The datetime when the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The user who created the relationship */
    createdBy: Scalars["String"]["output"];
    /** An optional description of the relationship. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The details of DevOps Service in the relationship. */
    devOpsService?: Maybe<DevOpsService>;
    /** The ARI of this relationship. */
    id: Scalars["ID"]["output"];
    /** The most recent datetime when the relationship was updated */
    lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The last user who updated the relationship */
    lastUpdatedBy?: Maybe<Scalars["String"]["output"]>;
    /** The Opsgenie team details related to the service. */
    opsgenieTeam?: Maybe<OpsgenieTeam>;
    /**
     * The id (Opsgenie team ARI) of the Opsgenie team related to the service.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use field opsgenieTeam to retrieve team details
     */
    opsgenieTeamId: Scalars["ID"]["output"];
    /** Look up JSON properties of the relationship by keys. */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The revision must be provided when updating a relationship to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["output"];
};

/** A relationship between DevOps Service and Opsgenie Team */
export type DevOpsServiceAndOpsgenieTeamRelationshipPropertiesArgs = {
    keys: Array<Scalars["String"]["input"]>;
};

/** #################### Pagination ##################### */
export type DevOpsServiceAndOpsgenieTeamRelationshipConnection = {
    __typename?: "DevOpsServiceAndOpsgenieTeamRelationshipConnection";
    edges?: Maybe<Array<Maybe<DevOpsServiceAndOpsgenieTeamRelationshipEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsServiceAndOpsgenieTeamRelationship>>>;
    pageInfo: PageInfo;
};

export type DevOpsServiceAndOpsgenieTeamRelationshipEdge = {
    __typename?: "DevOpsServiceAndOpsgenieTeamRelationshipEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
};

/** A relationship between a DevOps Service and a Repository */
export type DevOpsServiceAndRepositoryRelationship = Node & {
    __typename?: "DevOpsServiceAndRepositoryRelationship";
    /**
     * If the repository provider is Bitbucket, this will contain the Bitbucket repository details,
     * otherwise null.
     */
    bitbucketRepository?: Maybe<BitbucketRepository>;
    /** The time when the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The user who created the relationship */
    createdBy: Scalars["String"]["output"];
    /** An optional description of the relationship. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The details of DevOps Service in the relationship. */
    devOpsService?: Maybe<DevOpsService>;
    /** The ARI of this Relationship. */
    id: Scalars["ID"]["output"];
    /** The latest time when the relationship was updated */
    lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The latest user who updated the relationship */
    lastUpdatedBy?: Maybe<Scalars["String"]["output"]>;
    /** Look up JSON properties of the relationship by keys. */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The revision must be provided when updating a relationship to prevent
     * multiple simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["output"];
    /** If the repository provider is a third party, this will contain the repository details, otherwise null. */
    thirdPartyRepository?: Maybe<DevOpsThirdPartyRepository>;
};

/** A relationship between a DevOps Service and a Repository */
export type DevOpsServiceAndRepositoryRelationshipPropertiesArgs = {
    keys: Array<Scalars["String"]["input"]>;
};

export type DevOpsServiceAndRepositoryRelationshipConnection = {
    __typename?: "DevOpsServiceAndRepositoryRelationshipConnection";
    edges?: Maybe<Array<Maybe<DevOpsServiceAndRepositoryRelationshipEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsServiceAndRepositoryRelationship>>>;
    pageInfo: PageInfo;
};

export type DevOpsServiceAndRepositoryRelationshipEdge = {
    __typename?: "DevOpsServiceAndRepositoryRelationshipEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsServiceAndRepositoryRelationship>;
};

export type DevOpsServiceAndRepositoryRelationshipFilter = {
    /** Include only relationships with the specified certainty */
    certainty?: InputMaybe<DevOpsRelationshipCertaintyFilter>;
    /** Include only relationships with the specified repository hosting provider type */
    hostingProvider?: InputMaybe<DevOpsRepositoryHostingProviderFilter>;
    /**
     * Include only relationships with all of the specified property keys.
     * If this is omitted, no filtering by 'all property keys' is applied.
     */
    withAllPropertyKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type DevOpsServiceAndRepositoryRelationshipSort = {
    /** The field to apply sorting on */
    by: DevOpsServiceAndRepositoryRelationshipSortBy;
    /** The direction of sorting */
    order?: SortDirection;
};

export enum DevOpsServiceAndRepositoryRelationshipSortBy {
    LastInferredAt = "LAST_INFERRED_AT"
}

/** The connection object for a collection of Services. */
export type DevOpsServiceConnection = {
    __typename?: "DevOpsServiceConnection";
    edges?: Maybe<Array<Maybe<DevOpsServiceEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsService>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsServiceEdge = {
    __typename?: "DevOpsServiceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsService>;
};

/** The request input for DevOps Service Entity Property */
export type DevOpsServiceEntityPropertyInput = {
    /**
     * Keys must:
     * * Contain only the characters a-z, A-Z, 0-9, _ and -
     * * Be no greater than 80 characters long
     * * Not begin with an underscore
     */
    key: Scalars["String"]["input"];
    /**
     * * Can be no larger than 5KB for all properties for an entity
     * * Can not be `null`
     */
    value: Scalars["JSON"]["input"];
};

export type DevOpsServiceRelationship = Node & {
    __typename?: "DevOpsServiceRelationship";
    /** The cloud ID of the DevOps Service Relationship */
    cloudId: Scalars["String"]["output"];
    /** The datetime when the DevOps Service Relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The user who created the DevOps Service Relationship */
    createdBy: Scalars["String"]["output"];
    /** The description of the DevOps Service Relationship */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The end service of the DevOps Service Relationship */
    endService?: Maybe<DevOpsService>;
    /** The DevOps Service Relationship ARI */
    id: Scalars["ID"]["output"];
    /** The most recent datetime when the DevOps Service Relationship was updated */
    lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The last user who updated the DevOps Service Relationship */
    lastUpdatedBy?: Maybe<Scalars["String"]["output"]>;
    /** The organization ID of the DevOps Service Relationship */
    organizationId: Scalars["String"]["output"];
    /** Look up JSON properties of the DevOps Service by keys */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The revision that must be provided when updating a DevOps Service relationship to prevent
     * simultaneous updates from overwriting each other
     */
    revision: Scalars["ID"]["output"];
    /** The start service of the DevOps Service Relationship */
    startService?: Maybe<DevOpsService>;
    /** The inter-service relationship type of the DevOps Service Relationship */
    type: DevOpsServiceRelationshipType;
};

export type DevOpsServiceRelationshipPropertiesArgs = {
    keys: Array<Scalars["String"]["input"]>;
};

/** The connection object for a collection of DevOps Service relationships. */
export type DevOpsServiceRelationshipConnection = {
    __typename?: "DevOpsServiceRelationshipConnection";
    edges?: Maybe<Array<Maybe<DevOpsServiceRelationshipEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsServiceRelationship>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsServiceRelationshipEdge = {
    __typename?: "DevOpsServiceRelationshipEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsServiceRelationship>;
};

/** #################### Enums ##################### */
export enum DevOpsServiceRelationshipType {
    Contains = "CONTAINS",
    DependsOn = "DEPENDS_ON"
}

export type DevOpsServiceTier = {
    __typename?: "DevOpsServiceTier";
    /** Description of the tier level and the standards that a DevOps Service at this tier should meet */
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    /** The level of the tier. Lower numbers are more important */
    level: Scalars["Int"]["output"];
    /** The name of the tier, if set by the user */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The translation key for the name. Only present when name is null */
    nameKey?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsServiceTierInput = {
    level: Scalars["Int"]["input"];
};

export type DevOpsServiceType = {
    __typename?: "DevOpsServiceType";
    id: Scalars["ID"]["output"];
    /** The key of the service type. This is the upper snake case of the service type name. ie: BUSINESS_SERVICES */
    key: Scalars["String"]["output"];
    /** The name of the service type */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsServiceTypeInput = {
    key: Scalars["String"]["input"];
};

/** The filtering input for retrieving services. tierLevelIn must not be empty if provided. */
export type DevOpsServicesFilterInput = {
    /** Case insensitive string to filter service names with */
    nameContains?: InputMaybe<Scalars["String"]["input"]>;
    /** Integer numbers to filter service tier levels with */
    tierLevelIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type DevOpsSummarisedBuildState = {
    __typename?: "DevOpsSummarisedBuildState";
    /** The number of entities with that build state. */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** The last-updated timestamp of any build with this state. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The build state this summary is for. */
    state?: Maybe<DevOpsBuildState>;
    /** A URL to access the entity, will only be provided when there is a single entity in the summary for the given state. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Summary of the builds associated with an entity. */
export type DevOpsSummarisedBuilds = {
    __typename?: "DevOpsSummarisedBuilds";
    /** Summaries of each build state (this can tell you, for example, that there were X successful builds and Y failed ones). */
    buildStates?: Maybe<Array<Maybe<DevOpsSummarisedBuildState>>>;
    /** The total number of builds associated with the entity. */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** The ARI of the Atlassian entity which is associated with the deployment summary */
    id: Scalars["ID"]["output"];
    /** The last-updated timestamp of any build that is part of the summary. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The number of builds in the most relevant state (see the `state` field). */
    mostRelevantCount?: Maybe<Scalars["Int"]["output"]>;
    /** A URL to access the most relevant entity, will only be provided when there is a single entity in the summary. */
    singleClickUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The state of the most relevant build. From highest to lowest priority is 'FAILED', 'SUCCESSFUL'
     * then all the other states.
     */
    state?: Maybe<DevOpsBuildState>;
};

export type DevOpsSummarisedDeployments = {
    __typename?: "DevOpsSummarisedDeployments";
    /** The total count of deployments from all providers */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** The most relevant deployment environment for this entity as there could be multiple deployments */
    deploymentEnvironment?: Maybe<DevOpsEnvironment>;
    /** The most relevant deployment state for this entity as there could be multiple deployments */
    deploymentState?: Maybe<DeploymentState>;
    /** The ARI of the Atlassian entity which is associated with the deployment summary */
    entityId: Scalars["ID"]["output"];
    /** The ARI of the Atlassian entity which is associated with the deployment summary */
    id: Scalars["ID"]["output"];
    /** The last-updated timestamp of any deployment that is part of the summary item. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The total number of most relevant deployments. Count of deployments that could be appeared on deploymentState field. (Priority order is based on deployment environment comparison followed by deployment state) */
    mostRelevantCount?: Maybe<Scalars["Int"]["output"]>;
    /** The last-updated timestamp of the most relevant deployment summary. Use this for the last-updated timestamp of the deployment for the deploymentState field (Priority order is based on deployment environment comparison followed by deployment state) */
    mostRelevantLastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DevOpsSummarisedEntities = {
    __typename?: "DevOpsSummarisedEntities";
    /** The id of the Atlassian entity which is associated with the entity associations summary */
    entityId: Scalars["ID"]["output"];
    /** The installed providers for the site which the entity summary belongs to */
    providers?: Maybe<DevOpsProviders>;
    /** Summary of the most relevant builds */
    summarisedBuilds?: Maybe<DevOpsSummarisedBuilds>;
    /** Summary of the most relevant deployments */
    summarisedDeployments?: Maybe<DevOpsSummarisedDeployments>;
    /** Summary of the most relevant feature flag entities */
    summarisedFeatureFlags?: Maybe<DevOpsSummarisedFeatureFlags>;
};

export type DevOpsSummarisedFeatureFlags = {
    __typename?: "DevOpsSummarisedFeatureFlags";
    /** The URL for the most relevant feature flag. Will be null if total count is greater than one */
    entityUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The provider timestamp of the most relevant feature flag */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The human-readable name for the most relevant feature flag */
    mostRelevantDisplayName?: Maybe<Scalars["String"]["output"]>;
    /** Whether the most relevant feature flag is enabled, which may also imply a partial rollout */
    mostRelevantEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The rollout percentage for the most relevant feature flag; will be null if the flag does not use a percentage-based rollout */
    mostRelevantRolloutPercentage?: Maybe<Scalars["Float"]["output"]>;
    /** Total count of feature flags for the given entity */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
    /** Total count of disabled flags */
    totalDisabledCount?: Maybe<Scalars["Int"]["output"]>;
    /** Total count of enabled flags */
    totalEnabledCount?: Maybe<Scalars["Int"]["output"]>;
    /** Total count of enabled flags rolled out to 100% */
    totalRolledOutCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DevOpsSupportedActions = {
    __typename?: "DevOpsSupportedActions";
    associate?: Maybe<Scalars["Boolean"]["output"]>;
    checkAuth?: Maybe<Scalars["Boolean"]["output"]>;
    createContainer?: Maybe<Scalars["Boolean"]["output"]>;
    disassociate?: Maybe<Scalars["Boolean"]["output"]>;
    getEntityByUrl?: Maybe<Scalars["Boolean"]["output"]>;
    listContainers?: Maybe<Scalars["Boolean"]["output"]>;
    onEntityAssociated?: Maybe<Scalars["Boolean"]["output"]>;
    onEntityDisassociated?: Maybe<Scalars["Boolean"]["output"]>;
    searchConnectedWorkspaces?: Maybe<Scalars["Boolean"]["output"]>;
    searchContainers?: Maybe<Scalars["Boolean"]["output"]>;
    syncStatus?: Maybe<Scalars["Boolean"]["output"]>;
};

/** #################### Supporting Types ##################### */
export type DevOpsThirdPartyRepository = CodeRepository & {
    __typename?: "DevOpsThirdPartyRepository";
    /** Avatar details for the third party repository. */
    avatar?: Maybe<DevOpsAvatar>;
    /** URL for the third party repository. */
    href?: Maybe<Scalars["URL"]["output"]>;
    /** The ID of the third party repository. */
    id: Scalars["ID"]["output"];
    /** The name of the third party repository. */
    name: Scalars["String"]["output"];
    /** The URL of the third party repository. */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

export type DevOpsThumbnail = {
    __typename?: "DevOpsThumbnail";
    externalUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** Represents a product or tool in a DevOps suite */
export type DevOpsTool = Node & {
    __typename?: "DevOpsTool";
    /** Authentication status of the tool */
    auth?: Maybe<DevOpsToolAuth>;
    /** The tool icon */
    avatar?: Maybe<DevOpsToolAvatar>;
    /** The SDLC category associated with the tool */
    category: DevOpsToolCategory;
    /** The type of container relationship */
    containerRelationshipType?: Maybe<Scalars["ID"]["output"]>;
    containerRelationships?: Maybe<AriGraphRelationshipConnection>;
    /** The SDLC group associated with the tool */
    group: DevOpsToolGroup;
    /** The tool ARI */
    id: Scalars["ID"]["output"];
    /** Installed status for the DevOpsTool */
    installed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Integration details for the DevOps tool */
    integration?: Maybe<DevOpsToolIntegration>;
    /** The tool name */
    name: Scalars["String"]["output"];
    /** Fetch namespaces defined by the tool e.g. Bitbucket workspaces */
    namespaces?: Maybe<DevOpsToolNamespaceConnection>;
    /** The tool key */
    productKey: Scalars["String"]["output"];
    provider?: Maybe<DevOpsDataProvider>;
    /** True if the tool is featured/recommended by Atlassian */
    recommended: Scalars["Boolean"]["output"];
    /** True if the tool supports connecting containers (e.g. Bitbucket repositories) to Jira projects */
    supportsContainers: Scalars["Boolean"]["output"];
};

/** Represents a product or tool in a DevOps suite */
export type DevOpsToolContainerRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<AriGraphRelationshipsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jiraProjectId: Scalars["ID"]["input"];
    sort?: InputMaybe<AriGraphRelationshipsSort>;
};

/** Represents a product or tool in a DevOps suite */
export type DevOpsToolNamespacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a product or tool in a DevOps suite */
export type DevOpsToolProviderArgs = {
    id: Scalars["ID"]["input"];
    providerTypes?: InputMaybe<Array<DevOpsProviderType>>;
};

export type DevOpsToolAppLinks = {
    __typename?: "DevOpsToolAppLinks";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    configure?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getStarted?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    manage?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    self?: Maybe<Scalars["String"]["output"]>;
    /**
     * The link to the support page of the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    support?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsToolAuth = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    authenticated: Scalars["Boolean"]["output"];
};

export type DevOpsToolAvatar = {
    __typename?: "DevOpsToolAvatar";
    url: Scalars["URL"]["output"];
};

export type DevOpsToolBitbucketCreate =
    DevOpsToolContainerCreationSpecification & {
        __typename?: "DevOpsToolBitbucketCreate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        requestId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        slug?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        workspace: Scalars["String"]["output"];
    };

export type DevOpsToolCanContainerBeCreated =
    | DevOpsToolContainerCanBeCreated
    | DevOpsToolContainerKeyCannotBeGenerated
    | DevOpsToolContainerKeyConflict
    | DevOpsToolContainerNameConflict
    | DevOpsToolUnknownTool;

export type DevOpsToolCategory = {
    __typename?: "DevOpsToolCategory";
    groupId: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type DevOpsToolCategoryConnection = {
    __typename?: "DevOpsToolCategoryConnection";
    edges?: Maybe<Array<Maybe<DevOpsToolCategoryEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsToolCategory>>>;
    pageInfo: PageInfo;
};

export type DevOpsToolCategoryEdge = {
    __typename?: "DevOpsToolCategoryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsToolCategory>;
};

export type DevOpsToolConfluenceCreate =
    DevOpsToolContainerCreationSpecification & {
        __typename?: "DevOpsToolConfluenceCreate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        key: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        requestId: Scalars["String"]["output"];
    };

export type DevOpsToolConnection = {
    __typename?: "DevOpsToolConnection";
    edges?: Maybe<Array<Maybe<DevOpsToolEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsTool>>>;
    pageInfo: PageInfo;
};

export type DevOpsToolContainer = Node & {
    __typename?: "DevOpsToolContainer";
    displayName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    productKey: Scalars["String"]["output"];
    underlyingId: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export type DevOpsToolContainerCanBeCreated = {
    __typename?: "DevOpsToolContainerCanBeCreated";
    containerCreationSpecification?: Maybe<DevOpsToolContainerCreationSpecification>;
};

export type DevOpsToolContainerConnection = {
    __typename?: "DevOpsToolContainerConnection";
    edges?: Maybe<Array<Maybe<DevOpsToolContainerEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsToolContainer>>>;
    pageInfo: PageInfo;
};

/** ######################################### Mutations ########################################## */
export type DevOpsToolContainerCreationSpecification = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    requestId: Scalars["String"]["output"];
};

export type DevOpsToolContainerEdge = {
    __typename?: "DevOpsToolContainerEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsToolContainer>;
};

export type DevOpsToolContainerKeyCannotBeGenerated = {
    __typename?: "DevOpsToolContainerKeyCannotBeGenerated";
    name?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsToolContainerKeyConflict = {
    __typename?: "DevOpsToolContainerKeyConflict";
    key?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsToolContainerNameConflict = {
    __typename?: "DevOpsToolContainerNameConflict";
    name?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsToolDefaultAuth = DevOpsToolAuth & {
    __typename?: "DevOpsToolDefaultAuth";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    authenticated: Scalars["Boolean"]["output"];
};

export type DevOpsToolEdge = {
    __typename?: "DevOpsToolEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsTool>;
};

export type DevOpsToolGitHubCreate =
    DevOpsToolContainerCreationSpecification & {
        __typename?: "DevOpsToolGitHubCreate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        organizationName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        repositoryName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        requestId: Scalars["String"]["output"];
    };

export type DevOpsToolGitLabCreate =
    DevOpsToolContainerCreationSpecification & {
        __typename?: "DevOpsToolGitLabCreate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        organizationName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        repositoryName: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        requestId: Scalars["String"]["output"];
    };

export type DevOpsToolGroup = {
    __typename?: "DevOpsToolGroup";
    categories?: Maybe<DevOpsToolCategoryConnection>;
    groupId: Scalars["String"]["output"];
    groupName: Scalars["String"]["output"];
};

export type DevOpsToolGroupCategoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsToolGroupConnection = {
    __typename?: "DevOpsToolGroupConnection";
    edges?: Maybe<Array<Maybe<DevOpsToolGroupEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsToolGroup>>>;
    pageInfo: PageInfo;
};

export type DevOpsToolGroupEdge = {
    __typename?: "DevOpsToolGroupEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsToolGroup>;
};

/** The integration details for the DevOps tool */
export type DevOpsToolIntegration = {
    /**
     * The integration icon URL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The integration key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
    /**
     * The integration name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

/** A marketplace app integration */
export type DevOpsToolIntegrationApp = DevOpsToolIntegration & {
    __typename?: "DevOpsToolIntegrationApp";
    /**
     * The app key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appKey: Scalars["String"]["output"];
    /**
     * The app name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appName: Scalars["String"]["output"];
    /**
     * The app icon URL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The app key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
    /**
     * Links defined by the app (e.g. configuration links)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    links?: Maybe<DevOpsToolAppLinks>;
    /**
     * The app type (FREE, PAID_VIA_ATLASSIAN)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    marketplaceType: Scalars["String"]["output"];
    /**
     * The app name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

/** An Atlassian product integration */
export type DevOpsToolIntegrationProduct = DevOpsToolIntegration & {
    __typename?: "DevOpsToolIntegrationProduct";
    /**
     * The product icon URL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The product key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
    /**
     * The product name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
    /**
     * The product key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    productKey: Scalars["String"]["output"];
    /**
     * The product name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    productName: Scalars["String"]["output"];
};

export enum DevOpsToolIntegrationType {
    Any = "ANY",
    App = "APP",
    Exists = "EXISTS",
    None = "NONE",
    Product = "PRODUCT"
}

export type DevOpsToolNamespace = Node & {
    __typename?: "DevOpsToolNamespace";
    canCreateContainer: Scalars["Boolean"]["output"];
    containers?: Maybe<DevOpsToolContainerConnection>;
    displayName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    productKey: Scalars["String"]["output"];
    underlyingId: Scalars["String"]["output"];
};

export type DevOpsToolNamespaceContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectAri?: InputMaybe<Scalars["String"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
};

export type DevOpsToolNamespaceConnection = {
    __typename?: "DevOpsToolNamespaceConnection";
    edges?: Maybe<Array<Maybe<DevOpsToolNamespaceEdge>>>;
    nodes?: Maybe<Array<Maybe<DevOpsToolNamespace>>>;
    pageInfo: PageInfo;
};

export type DevOpsToolNamespaceEdge = {
    __typename?: "DevOpsToolNamespaceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DevOpsToolNamespace>;
};

export type DevOpsToolOAuth = DevOpsToolAuth & {
    __typename?: "DevOpsToolOAuth";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    authenticated: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    oauthUrl: Scalars["String"]["output"];
};

export type DevOpsToolOpsgenieCreate =
    DevOpsToolContainerCreationSpecification & {
        __typename?: "DevOpsToolOpsgenieCreate";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        name: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        requestId: Scalars["String"]["output"];
    };

export type DevOpsToolSort = {
    integration?: InputMaybe<DevOpsToolSortOrder>;
    name?: InputMaybe<DevOpsToolSortOrder>;
    recommended?: InputMaybe<DevOpsToolSortOrder>;
    supportsContainers?: InputMaybe<DevOpsToolSortOrder>;
};

export enum DevOpsToolSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type DevOpsToolUnknownTool = {
    __typename?: "DevOpsToolUnknownTool";
    toolId?: Maybe<Scalars["String"]["output"]>;
};

export type DevOpsTools = {
    __typename?: "DevOpsTools";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canContainerBeCreated?: Maybe<DevOpsToolCanContainerBeCreated>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    container?: Maybe<DevOpsToolContainer>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    groups?: Maybe<DevOpsToolGroupConnection>;
    /**
     * The id is the ARI of a DevOpsTool
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    integration?: Maybe<DevOpsToolIntegration>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isInstalled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    namespace?: Maybe<DevOpsToolNamespace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    tool?: Maybe<DevOpsTool>;
    /**
     * Returns all tools (e.g. Bitbucket, Confluence) for the Jira site that matches the params sent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    tools?: Maybe<DevOpsToolConnection>;
};

export type DevOpsToolsCanContainerBeCreatedArgs = {
    cloudId: Scalars["ID"]["input"];
    containerName: Scalars["String"]["input"];
    namespaceId: Scalars["String"]["input"];
    toolId: Scalars["String"]["input"];
};

export type DevOpsToolsContainerArgs = {
    id: Scalars["ID"]["input"];
};

export type DevOpsToolsGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type DevOpsToolsIntegrationArgs = {
    id: Scalars["ID"]["input"];
};

export type DevOpsToolsIsInstalledArgs = {
    id: Scalars["ID"]["input"];
};

export type DevOpsToolsNamespaceArgs = {
    id: Scalars["ID"]["input"];
};

export type DevOpsToolsToolArgs = {
    id: Scalars["ID"]["input"];
};

export type DevOpsToolsToolsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    categoryId?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupId?: InputMaybe<Scalars["String"]["input"]>;
    integrationType?: InputMaybe<DevOpsToolIntegrationType>;
    recommended?: InputMaybe<Scalars["Boolean"]["input"]>;
    search?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<DevOpsToolSort>>>;
    supportsContainers?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * A user that could tie to a first-party user and/or a third-party user.
 *
 * - "user" is supplied if it is a first-party user
 * - "thirdPartyUser" is supplied if it is a third-party user
 * - Both "user" and "thirdPartyUser" could be supplied if a user matches both a first-party user and a third-party user
 * - Neither "user" nor "thirdPartyUser" is supplied if the user is not found, but they exist. For example, a Pull Request might have a user, but we just don't know who that user is.
 */
export type DevOpsUser = {
    __typename?: "DevOpsUser";
    /** Third party user details */
    thirdPartyUser?: Maybe<ThirdPartyUser>;
    /** First party user details */
    user?: Maybe<User>;
};

/** Dev status context */
export type DevStatus = {
    __typename?: "DevStatus";
    activity: DevStatusActivity;
    count?: Maybe<Scalars["Int"]["output"]>;
};

export enum DevStatusActivity {
    BranchOpen = "BRANCH_OPEN",
    Commit = "COMMIT",
    Deployment = "DEPLOYMENT",
    Design = "DESIGN",
    PrDeclined = "PR_DECLINED",
    PrMerged = "PR_MERGED",
    PrOpen = "PR_OPEN"
}

export type DeveloperLogAccessResult = {
    __typename?: "DeveloperLogAccessResult";
    /**
     * Site ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    contextId: Scalars["ID"]["output"];
    /**
     * Indicates whether developer has access to logs
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    developerHasAccess: Scalars["Boolean"]["output"];
};

export type DisablePublicLinkForPagePayload = {
    __typename?: "DisablePublicLinkForPagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
};

export type DiscoveredFeature = {
    __typename?: "DiscoveredFeature";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    date?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featureKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pluginKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
};

export enum DistributionStatus {
    Development = "DEVELOPMENT",
    Public = "PUBLIC"
}

export type DocumentBody = {
    __typename?: "DocumentBody";
    representation: DocumentRepresentation;
    value: Scalars["String"]["output"];
};

export enum DocumentRepresentation {
    AtlasDocFormat = "ATLAS_DOC_FORMAT",
    Html = "HTML",
    Storage = "STORAGE",
    View = "VIEW"
}

export type DraftContentProperties = {
    __typename?: "DraftContentProperties";
    coverPictureWidth?: Maybe<Scalars["String"]["output"]>;
};

export type DvcsBitbucketWorkspaceConnection = {
    __typename?: "DvcsBitbucketWorkspaceConnection";
    edges?: Maybe<Array<Maybe<DvcsBitbucketWorkspaceEdge>>>;
    nodes?: Maybe<Array<Maybe<BitbucketWorkspace>>>;
    pageInfo: PageInfo;
};

export type DvcsBitbucketWorkspaceEdge = {
    __typename?: "DvcsBitbucketWorkspaceEdge";
    cursor: Scalars["String"]["output"];
    /** The Bitbucket workspace. */
    node?: Maybe<BitbucketWorkspace>;
};

export type DvcsQuery = {
    __typename?: "DvcsQuery";
    /**
     * Return the Bitbucket workspaces linked to this site.  User must
     * have access to Jira on this site.
     * *** This function will be deprecated in the near future. ***
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    bitbucketWorkspacesLinkedToSite?: Maybe<DvcsBitbucketWorkspaceConnection>;
};

export type DvcsQueryBitbucketWorkspacesLinkedToSiteArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EarliestOnboardedProjectForCloudId = {
    __typename?: "EarliestOnboardedProjectForCloudId";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    datetime?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    template?: Maybe<Scalars["String"]["output"]>;
};

export type EarliestViewViewedForUser = {
    __typename?: "EarliestViewViewedForUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    datetime?: Maybe<Scalars["String"]["output"]>;
};

export type EcosystemApp = App | EcosystemConnectApp;

export type EcosystemAppInstallationConfigExtension = {
    __typename?: "EcosystemAppInstallationConfigExtension";
    key: Scalars["String"]["output"];
    value: Scalars["Boolean"]["output"];
};

export enum EcosystemAppInstallationConfigIdType {
    Cloud = "CLOUD",
    /** Config applies to all installations belonging to a specific site (cloud ID) */
    Installation = "INSTALLATION"
}

export type EcosystemAppInstallationOverridesInput = {
    /**
     * Override the license mode for the installation.
     * This is used for app developers to test the app behaviour in different license modes.
     * This field is only allowed by Forge CLI for non-production environments.
     * This field will only be accepted when the user agent is Forge CLI
     */
    licenseModes?: InputMaybe<Array<EcosystemLicenseMode>>;
    /**
     * Set the user with access when the license mode is 'USER_ACCESS'.
     * This field is only allowed when licenseMode='USER_ACCESS'.
     * This is a temporary field to support the license mode 'USER_ACCESS'. It will be removed
     * after user access configuration is supported in Admin Hub.
     * See https://hello.atlassian.net/wiki/spaces/ECON/pages/4352978134/RFC+How+will+developers+test+license+de-coupling+in+their+apps?focusedCommentId=4365058508
     * We can clean up once https://hello.jira.atlassian.cloud/browse/COMMIT-12345 is delivered and the 6-month deprecation period is over.
     */
    usersWithAccess?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type EcosystemAppNetworkEgressPermission = {
    __typename?: "EcosystemAppNetworkEgressPermission";
    /** Will always be ["*"] for Connect */
    addresses: Array<Scalars["String"]["output"]>;
    /** Will be "CONNECT" for Connect */
    type?: Maybe<EcosystemAppNetworkPermissionType>;
};

export enum EcosystemAppNetworkPermissionType {
    Connect = "CONNECT"
}

export type EcosystemAppPermission = {
    __typename?: "EcosystemAppPermission";
    egress: Array<EcosystemAppNetworkEgressPermission>;
    scopes: Array<EcosystemConnectScope>;
};

export type EcosystemAppPolicies = {
    __typename?: "EcosystemAppPolicies";
    dataClassifications?: Maybe<EcosystemDataClassificationsContext>;
};

export type EcosystemAppPoliciesDataClassificationsArgs = {
    id: Scalars["ID"]["input"];
};

export type EcosystemAppPoliciesByAppId = {
    __typename?: "EcosystemAppPoliciesByAppId";
    appId: Scalars["ID"]["output"];
    appPolicies?: Maybe<EcosystemAppPolicies>;
};

export type EcosystemAppsInstalledInContextsConnection = {
    __typename?: "EcosystemAppsInstalledInContextsConnection";
    edges: Array<EcosystemAppsInstalledInContextsEdge>;
    /** pageInfo determines whether there are more entries to query */
    pageInfo: PageInfo;
    /** Total number of apps for the current query */
    totalCount: Scalars["Int"]["output"];
};

export type EcosystemAppsInstalledInContextsEdge = {
    __typename?: "EcosystemAppsInstalledInContextsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<EcosystemApp>;
};

export type EcosystemAppsInstalledInContextsEdgeNodeArgs = {
    contextIds: Array<Scalars["ID"]["input"]>;
    options?: InputMaybe<EcosystemAppsInstalledInContextsOptions>;
};

export type EcosystemAppsInstalledInContextsFilter = {
    type: EcosystemAppsInstalledInContextsFilterType;
    values: Array<Scalars["String"]["input"]>;
};

export enum EcosystemAppsInstalledInContextsFilterType {
    /**
     * Only supports one name in the values list for now, otherwise will fail
     * validation.
     */
    Name = "NAME",
    /**
     * Returns apps filtered by the ARIs passed in the values list, as an exact match with its id
     * or the ARI generated from its latest migration keys for harmonised apps
     */
    OnlyAppIds = "ONLY_APP_IDS"
}

export type EcosystemAppsInstalledInContextsOptions = {
    groupByBaseApp?: InputMaybe<Scalars["Boolean"]["input"]>;
    shouldExcludeFirstPartyApps?: InputMaybe<Scalars["Boolean"]["input"]>;
    shouldIncludePrivateApps?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EcosystemAppsInstalledInContextsOrderBy = {
    direction: SortDirection;
    sortKey: EcosystemAppsInstalledInContextsSortKey;
};

export enum EcosystemAppsInstalledInContextsSortKey {
    Name = "NAME",
    RelatedApps = "RELATED_APPS"
}

export type EcosystemConnectApp = {
    __typename?: "EcosystemConnectApp";
    description: Scalars["String"]["output"];
    distributionStatus: Scalars["String"]["output"];
    /** Connect App ARI */
    id: Scalars["ID"]["output"];
    installations: Array<EcosystemConnectInstallation>;
    marketplaceApp?: Maybe<MarketplaceApp>;
    name: Scalars["String"]["output"];
    vendorName?: Maybe<Scalars["String"]["output"]>;
};

export type EcosystemConnectAppRelation = {
    __typename?: "EcosystemConnectAppRelation";
    app?: Maybe<EcosystemApp>;
    appId: Scalars["ID"]["output"];
    isDependency: Scalars["Boolean"]["output"];
};

export type EcosystemConnectAppRelationAppArgs = {
    contextIds: Array<Scalars["ID"]["input"]>;
};

export type EcosystemConnectAppVersion = {
    __typename?: "EcosystemConnectAppVersion";
    isSystemApp: Scalars["Boolean"]["output"];
    permissions: Array<EcosystemAppPermission>;
    relatedApps?: Maybe<Array<EcosystemConnectAppRelation>>;
    version: Scalars["String"]["output"];
};

export type EcosystemConnectInstallation = {
    __typename?: "EcosystemConnectInstallation";
    appVersion: EcosystemConnectAppVersion;
    dataClassifications?: Maybe<EcosystemDataClassificationsContext>;
    installationContext?: Maybe<Scalars["String"]["output"]>;
    license?: Maybe<EcosystemConnectInstallationLicense>;
};

export type EcosystemConnectInstallationLicense = {
    __typename?: "EcosystemConnectInstallationLicense";
    active?: Maybe<Scalars["Boolean"]["output"]>;
    capabilitySet?: Maybe<CapabilitySet>;
    ccpEntitlementId?: Maybe<Scalars["String"]["output"]>;
    ccpEntitlementSlug?: Maybe<Scalars["String"]["output"]>;
    isEvaluation?: Maybe<Scalars["Boolean"]["output"]>;
    supportEntitlementNumber?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type EcosystemConnectScope = {
    __typename?: "EcosystemConnectScope";
    description: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type EcosystemDataClassificationsContext = {
    __typename?: "EcosystemDataClassificationsContext";
    hasConstraints?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
};

/** Input payload to set global controls for installations. Multiple controls can be set at a given time. */
export type EcosystemGlobalInstallationConfigInput = {
    cloudId: Scalars["ID"]["input"];
    config: Array<EcosystemGlobalInstallationOverrideInput>;
};

/** Response payload for setting global controls for installations. Config returned will be the current state of the global controls. */
export type EcosystemGlobalInstallationConfigResponse = Payload & {
    __typename?: "EcosystemGlobalInstallationConfigResponse";
    config?: Maybe<Array<EcosystemGlobalInstallationOverride>>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type EcosystemGlobalInstallationOverride = {
    __typename?: "EcosystemGlobalInstallationOverride";
    key: EcosystemGlobalInstallationOverrideKeys;
    value: Scalars["Boolean"]["output"];
};

export type EcosystemGlobalInstallationOverrideInput = {
    key: EcosystemGlobalInstallationOverrideKeys;
    value: Scalars["Boolean"]["input"];
};

export enum EcosystemGlobalInstallationOverrideKeys {
    AllowEgressAnalytics = "ALLOW_EGRESS_ANALYTICS",
    AllowLogsAccess = "ALLOW_LOGS_ACCESS"
}

/** this can be extended to support non-boolean config in future */
export type EcosystemInstallationConfigInput = {
    overrides: Array<EcosystemInstallationOverrides>;
};

export enum EcosystemInstallationOverrideKeys {
    AllowEgressAnalytics = "ALLOW_EGRESS_ANALYTICS"
}

export type EcosystemInstallationOverrides = {
    key: EcosystemInstallationOverrideKeys;
    value: Scalars["Boolean"]["input"];
};

export enum EcosystemInstallationRecoveryMode {
    FreshInstall = "FRESH_INSTALL",
    RecoverPreviousInstall = "RECOVER_PREVIOUS_INSTALL"
}

export enum EcosystemLicenseMode {
    Agent = "AGENT",
    UserAccess = "USER_ACCESS"
}

export type EcosystemMutation = {
    __typename?: "EcosystemMutation";
    /**
     * Add a contributor to an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addAppContributor?: Maybe<AddAppContributorResponsePayload>;
    /**
     * Add multiple contributor to an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addMultipleAppContributor?: Maybe<AddMultipleAppContributorResponsePayload>;
    /**
     * Create App Environment
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createAppEnvironment?: Maybe<CreateAppEnvironmentResponse>;
    /**
     * Delete App Environment
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteAppEnvironment?: Maybe<DeleteAppEnvironmentResponse>;
    /**
     *  cs-installations EcosystemMutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteUserGrant?: Maybe<DeleteUserGrantPayload>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: ForgeAlertsQuery` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    forgeAlerts?: Maybe<ForgeAlertsMutation>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: ForgeMetricsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    forgeMetrics?: Maybe<ForgeMetricsMutation>;
    /**
     * Remove a contributor from an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    removeAppContributors?: Maybe<RemoveAppContributorsResponsePayload>;
    /**
     * Update the role of the contributors of an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateAppContributorRole?: Maybe<UpdateAppContributorRoleResponsePayload>;
    /**
     * Update an app environment and enrol to new scopes
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateAppHostServiceScopes?: Maybe<UpdateAppHostServiceScopesResponsePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateAppOAuthClient: EcosystemUpdateAppOAuthClientResult;
    /**
     * Update ownership of an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateAppOwnership?: Maybe<UpdateAppOwnershipResponsePayload>;
    /**
     * Update global config for installations at a site level. This will only be used for new installations
     * and have no impact on existing installations.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateGlobalInstallationConfig?: Maybe<EcosystemGlobalInstallationConfigResponse>;
    /**
     * Update installation with installation-specific configuration.
     * Example: add config to block analytics-egress for a specific installation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateInstallationDetails?: Maybe<UpdateInstallationDetailsResponse>;
    /**
     * Update a remote installation region for a given installationId
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateInstallationRemoteRegion?: Maybe<EcosystemUpdateInstallationRemoteRegionResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateUserInstallationRules?: Maybe<UserInstallationRulesPayload>;
};

export type EcosystemMutationAddAppContributorArgs = {
    input: AddAppContributorInput;
};

export type EcosystemMutationAddMultipleAppContributorArgs = {
    input: AddMultipleAppContributorInput;
};

export type EcosystemMutationCreateAppEnvironmentArgs = {
    input: CreateAppEnvironmentInput;
};

export type EcosystemMutationDeleteAppEnvironmentArgs = {
    input: DeleteAppEnvironmentInput;
};

export type EcosystemMutationDeleteUserGrantArgs = {
    input: DeleteUserGrantInput;
};

export type EcosystemMutationForgeAlertsArgs = {
    appId: Scalars["ID"]["input"];
};

export type EcosystemMutationForgeMetricsArgs = {
    appId: Scalars["ID"]["input"];
};

export type EcosystemMutationRemoveAppContributorsArgs = {
    input: RemoveAppContributorsInput;
};

export type EcosystemMutationUpdateAppContributorRoleArgs = {
    input: UpdateAppContributorRoleInput;
};

export type EcosystemMutationUpdateAppHostServiceScopesArgs = {
    input: UpdateAppHostServiceScopesInput;
};

export type EcosystemMutationUpdateAppOAuthClientArgs = {
    appId: Scalars["ID"]["input"];
    connectAppKey: Scalars["String"]["input"];
    environment: Scalars["String"]["input"];
};

export type EcosystemMutationUpdateAppOwnershipArgs = {
    input: UpdateAppOwnershipInput;
};

export type EcosystemMutationUpdateGlobalInstallationConfigArgs = {
    input: EcosystemGlobalInstallationConfigInput;
};

export type EcosystemMutationUpdateInstallationDetailsArgs = {
    input: EcosystemUpdateInstallationDetailsInput;
};

export type EcosystemMutationUpdateInstallationRemoteRegionArgs = {
    input: EcosystemUpdateInstallationRemoteRegionInput;
};

export type EcosystemMutationUpdateUserInstallationRulesArgs = {
    input: UpdateUserInstallationRulesInput;
};

export type EcosystemQuery = {
    __typename?: "EcosystemQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appByOauthClient?: Maybe<App>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appEnvironmentsByOAuthClientIds?: Maybe<Array<AppEnvironment>>;
    /**
     * Returns all installations for the given app(s). Caller must be the owner of each app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appInstallationsByApp?: Maybe<AppInstallationByIndexConnection>;
    /**
     * Returns all installations for apps in the given context(s). Caller must have read permissions for each context.
     * This query does not return installations for apps where customLifecycleManagement is true (i.e. Hudson apps).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appInstallationsByContext?: Maybe<AppInstallationByIndexConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appPoliciesByAppIds?: Maybe<Array<EcosystemAppPoliciesByAppId>>;
    /**
     * This query returns apps (Forge/3LO/Connect) installed in a given list of contexts.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appsInstalledInContexts: EcosystemAppsInstalledInContextsConnection;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    checkConsentPermissionByOAuthClientId?: Maybe<PermissionToConsentByOauthId>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dataClassifications?: Maybe<EcosystemDataClassificationsContext>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: ForgeAlertsQuery` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    forgeAlerts?: Maybe<ForgeAlertsQuery>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ForgeAuditLogsQuery")' query directive to the 'forgeAuditLogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    forgeAuditLogs?: Maybe<ForgeAuditLogsQuery>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ForgeAuditLogsQuery")' query directive to the 'forgeContributors' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    forgeContributors?: Maybe<ForgeAuditLogsContributorsActivityResult>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: ForgeMetricsQuery` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    forgeMetrics?: Maybe<ForgeMetricsQuery>;
    /**
     * Returns the metrics available in the Cloud Fortified program.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: FortifiedMetrics` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fortifiedMetrics?: Maybe<FortifiedMetricsQuery>;
    /**
     * Returns all the configurations that have been set by an admin at a site level for installations.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    globalInstallationConfig?: Maybe<
        Array<Maybe<EcosystemGlobalInstallationOverride>>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userAccess?: Maybe<UserAccess>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userGrants?: Maybe<UserGrantConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userInstallationRules?: Maybe<UserInstallationRules>;
};

export type EcosystemQueryAppByOauthClientArgs = {
    oauthClientId: Scalars["ID"]["input"];
};

export type EcosystemQueryAppEnvironmentsByOAuthClientIdsArgs = {
    oauthClientIds: Array<Scalars["ID"]["input"]>;
};

export type EcosystemQueryAppInstallationsByAppArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter: AppInstallationsByAppFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EcosystemQueryAppInstallationsByContextArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter: AppInstallationsByContextFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EcosystemQueryAppPoliciesByAppIdsArgs = {
    appIds: Array<Scalars["ID"]["input"]>;
};

export type EcosystemQueryAppsInstalledInContextsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    contextIds: Array<Scalars["ID"]["input"]>;
    filters?: InputMaybe<Array<EcosystemAppsInstalledInContextsFilter>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    options?: InputMaybe<EcosystemAppsInstalledInContextsOptions>;
    orderBy?: InputMaybe<Array<EcosystemAppsInstalledInContextsOrderBy>>;
};

export type EcosystemQueryCheckConsentPermissionByOAuthClientIdArgs = {
    input: CheckConsentPermissionByOAuthClientIdInput;
};

export type EcosystemQueryDataClassificationsArgs = {
    appId: Scalars["ID"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

export type EcosystemQueryForgeAlertsArgs = {
    appId: Scalars["ID"]["input"];
};

export type EcosystemQueryForgeAuditLogsArgs = {
    appId: Scalars["ID"]["input"];
};

export type EcosystemQueryForgeContributorsArgs = {
    appAri: Scalars["ID"]["input"];
};

export type EcosystemQueryForgeMetricsArgs = {
    appId: Scalars["ID"]["input"];
};

export type EcosystemQueryFortifiedMetricsArgs = {
    appKey: Scalars["ID"]["input"];
};

export type EcosystemQueryGlobalInstallationConfigArgs = {
    cloudId: Scalars["ID"]["input"];
    filter?: InputMaybe<GlobalInstallationConfigFilter>;
};

export type EcosystemQueryUserAccessArgs = {
    contextId: Scalars["ID"]["input"];
    definitionId: Scalars["ID"]["input"];
    userAaid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type EcosystemQueryUserGrantsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EcosystemQueryUserInstallationRulesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export enum EcosystemRequiredProduct {
    Compass = "COMPASS",
    Confluence = "CONFLUENCE",
    Jira = "JIRA"
}

export type EcosystemUpdateAppOAuthClientResult = Payload & {
    __typename?: "EcosystemUpdateAppOAuthClientResult";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type EcosystemUpdateInstallationDetailsInput = {
    config: EcosystemInstallationConfigInput;
    id: Scalars["ID"]["input"];
};

export type EcosystemUpdateInstallationRemoteRegionInput = {
    /** A flag to enable the cleaning of a region. If remoteInstallationRegion needs to be cleaned up by an undefined value, set allowCleanRegion to true */
    allowCleanRegion?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A unique Id representing the installationId */
    installationId: Scalars["ID"]["input"];
    /** A new remoteInstallationRegion to be updated. If remoteInstallationRegion is not provided, it will be removed for an installation */
    remoteInstallationRegion?: InputMaybe<Scalars["String"]["input"]>;
};

export type EcosystemUpdateInstallationRemoteRegionResponse = Payload & {
    __typename?: "EcosystemUpdateInstallationRemoteRegionResponse";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Edit sprint */
export type EditSprintInput = {
    boardId: Scalars["ID"]["input"];
    endDate?: InputMaybe<Scalars["String"]["input"]>;
    goal?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    sprintId: Scalars["ID"]["input"];
    startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type EditUpdate = AllUpdatesFeedEvent & {
    __typename?: "EditUpdate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: AllUpdatesFeedEventType;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    user?: Maybe<Person>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Scalars["Int"]["output"];
};

export type Editions = {
    __typename?: "Editions";
    confluence: ConfluenceEdition;
};

export enum EditorConversionSetting {
    None = "NONE",
    Supported = "SUPPORTED"
}

export type EditorDraftSyncInput = {
    contentId: Scalars["ID"]["input"];
    doSetRelations?: InputMaybe<Scalars["Boolean"]["input"]>;
    latestAdf?: InputMaybe<Scalars["String"]["input"]>;
    ncsStepVersion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EditorDraftSyncPayload = Payload & {
    __typename?: "EditorDraftSyncPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type EditorVersionsMetadataDto = {
    __typename?: "EditorVersionsMetadataDto";
    blogpost?: Maybe<Scalars["String"]["output"]>;
    default?: Maybe<Scalars["String"]["output"]>;
    page?: Maybe<Scalars["String"]["output"]>;
};

export type EmbeddedContent = {
    __typename?: "EmbeddedContent";
    entity?: Maybe<Content>;
    entityId?: Maybe<Scalars["Long"]["output"]>;
    entityType?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
};

export type EmbeddedMediaToken = {
    __typename?: "EmbeddedMediaToken";
    collectionIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    contentId?: Maybe<Scalars["ID"]["output"]>;
    expiryDateTime?: Maybe<Scalars["String"]["output"]>;
    fileIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    links?: Maybe<LinksContextBase>;
    token?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a smart-link rendered as embedded on a page */
export type EmbeddedSmartLink = SmartLink & {
    __typename?: "EmbeddedSmartLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    layout: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    width: Scalars["Float"]["output"];
};

export type EnablePublicLinkForPagePayload = {
    __typename?: "EnablePublicLinkForPagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkUrlPath: Scalars["String"]["output"];
};

export type EnabledContentTypes = {
    __typename?: "EnabledContentTypes";
    isBlogsEnabled: Scalars["Boolean"]["output"];
    isDatabasesEnabled: Scalars["Boolean"]["output"];
    isEmbedsEnabled: Scalars["Boolean"]["output"];
    isFoldersEnabled: Scalars["Boolean"]["output"];
    isLivePagesEnabled: Scalars["Boolean"]["output"];
    isWhiteboardsEnabled: Scalars["Boolean"]["output"];
};

export type EnabledContentTypesInput = {
    isBlogsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isDatabasesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isEmbedsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isFoldersEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isLivePagesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isWhiteboardsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EnabledFeatures = {
    __typename?: "EnabledFeatures";
    isAnalyticsEnabled: Scalars["Boolean"]["output"];
    isAppsEnabled: Scalars["Boolean"]["output"];
    isAutomationEnabled: Scalars["Boolean"]["output"];
    isCalendarsEnabled: Scalars["Boolean"]["output"];
    isContentManagerEnabled: Scalars["Boolean"]["output"];
    isQuestionsEnabled: Scalars["Boolean"]["output"];
    isShortcutsEnabled: Scalars["Boolean"]["output"];
};

export type EnabledFeaturesInput = {
    isAnalyticsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isAppsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isAutomationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isCalendarsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isContentManagerEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isQuestionsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isShortcutsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EnrichableMap_ContentRepresentation_ContentBody = {
    __typename?: "EnrichableMap_ContentRepresentation_ContentBody";
    atlas_doc_format?: Maybe<ContentBody>;
    dynamic?: Maybe<ContentBody>;
    editor?: Maybe<ContentBody>;
    editor2?: Maybe<ContentBody>;
    export_view?: Maybe<ContentBody>;
    plain?: Maybe<ContentBody>;
    raw?: Maybe<ContentBody>;
    storage?: Maybe<ContentBody>;
    styled_view?: Maybe<ContentBody>;
    view?: Maybe<ContentBody>;
    wiki?: Maybe<ContentBody>;
};

export type Entitlements = {
    __typename?: "Entitlements";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    adminAnnouncementBanner: AdminAnnouncementBannerFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    archive: ArchiveFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bulkActions: BulkActionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    companyHub: CompanyHubFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customPermissions: CustomPermissionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    externalCollaborator: ExternalCollaboratorFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nestedActions: NestedActionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    premiumExtensions: PremiumExtensionsFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    teamCalendar: TeamCalendarFeature;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    whiteboardFeatures?: Maybe<WhiteboardFeatures>;
};

export type EntityCountBySpace = {
    __typename?: "EntityCountBySpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<EntityCountBySpaceItem>;
};

export type EntityCountBySpaceItem = {
    __typename?: "EntityCountBySpaceItem";
    count: Scalars["Int"]["output"];
    space: Scalars["String"]["output"];
};

export type EntityTimeseriesCount = {
    __typename?: "EntityTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<EntityTimeseriesCountItem>;
};

export type EntityTimeseriesCountItem = {
    __typename?: "EntityTimeseriesCountItem";
    /** Analytics count */
    count: Scalars["Int"]["output"];
    /** Grouping date in ISO format */
    date: Scalars["String"]["output"];
};

export enum Environment {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING"
}

export type Error = {
    __typename?: "Error";
    message: Scalars["String"]["output"];
    status: Scalars["Int"]["output"];
};

export type ErrorDetails = {
    __typename?: "ErrorDetails";
    /** Specific code used to make difference between errors to handle them differently */
    code: Scalars["String"]["output"];
    /** Addition error data */
    fields?: Maybe<Scalars["JSON"]["output"]>;
    /** Copy of top-level message */
    message: Scalars["String"]["output"];
};

export type ErsLifecycleMutation = {
    __typename?: "ErsLifecycleMutation";
    /**
     * Admin mutations for custom entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customEntities?: Maybe<CustomEntityMutation>;
};

export type ErsLifecycleQuery = {
    __typename?: "ErsLifecycleQuery";
    /**
     * Get entity definitions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    customEntityDefinitions?: Maybe<Array<Maybe<CustomEntityDefinition>>>;
    /**
     * Get updated definitions of entities stored in ddb
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    doneEntitiesFromERS?: Maybe<Array<Maybe<CustomEntityDefinition>>>;
};

export type ErsLifecycleQueryCustomEntityDefinitionsArgs = {
    entities: Array<Scalars["String"]["input"]>;
    oauthClientId: Scalars["String"]["input"];
};

export type ErsLifecycleQueryDoneEntitiesFromErsArgs = {
    oauthClientId: Scalars["String"]["input"];
};

/** Estimate object which contains an estimate for a card when it exists */
export type Estimate = {
    __typename?: "Estimate";
    originalEstimate?: Maybe<OriginalEstimate>;
    storyPoints?: Maybe<Scalars["Float"]["output"]>;
};

export type EstimationBoardFeatureView = Node & {
    __typename?: "EstimationBoardFeatureView";
    canEnable?: Maybe<Scalars["Boolean"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    imageUri?: Maybe<Scalars["String"]["output"]>;
    learnMoreArticleId?: Maybe<Scalars["String"]["output"]>;
    learnMoreLink?: Maybe<Scalars["String"]["output"]>;
    permissibleEstimationTypes?: Maybe<Array<Maybe<PermissibleEstimationType>>>;
    selectedEstimationType?: Maybe<PermissibleEstimationType>;
    /** Possible states: ENABLED, DISABLED, COMING_SOON */
    status?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export type EstimationConfig = {
    __typename?: "EstimationConfig";
    /** All available estimation types that can be used in the project. */
    available: Array<AvailableEstimations>;
    /** Currently configured estimation. */
    current: CurrentEstimation;
};

export enum EstimationType {
    CustomNumberField = "CUSTOM_NUMBER_FIELD",
    IssueCount = "ISSUE_COUNT",
    OriginalEstimate = "ORIGINAL_ESTIMATE",
    StoryPoints = "STORY_POINTS"
}

export type EventCtr = {
    __typename?: "EventCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<EventCtrItems>;
};

export type EventCtrItems = {
    __typename?: "EventCTRItems";
    clicks: Scalars["Long"]["output"];
    ctr: Scalars["Float"]["output"];
    discoveries: Scalars["Long"]["output"];
};

/** Compass Events */
export type EventSource = Node & {
    __typename?: "EventSource";
    /** The type of the event. */
    eventType: CompassEventType;
    /** The events stored on the event source */
    events?: Maybe<CompassEventsQueryResult>;
    /** The ID of the external event source. */
    externalEventSourceId: Scalars["ID"]["output"];
    /**
     * The Forge App Id used to construct event sources.
     * This is automatically inferred from the HTTP Header of the requesting Forge App.
     */
    forgeAppId?: Maybe<Scalars["ID"]["output"]>;
    /** The ID of the event source. */
    id: Scalars["ID"]["output"];
};

/** Compass Events */
export type EventSourceEventsArgs = {
    query?: InputMaybe<CompassEventsInEventSourceQuery>;
};

export type EventTimeseriesCtr = {
    __typename?: "EventTimeseriesCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<EventTimeseriesCtrItems>;
};

export type EventTimeseriesCtrItems = {
    __typename?: "EventTimeseriesCTRItems";
    ctr: Scalars["Float"]["output"];
    /** Grouping date in ISO format */
    timestamp: Scalars["String"]["output"];
};

/** An arbitrary extension definition as defined by the Ecosystem */
export type Extension = {
    __typename?: "Extension";
    appId: Scalars["ID"]["output"];
    appOwner?: Maybe<User>;
    appVersion?: Maybe<Scalars["String"]["output"]>;
    consentUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Consent is checked upon invocation
     */
    currentUserConsent?: Maybe<UserConsentExtension>;
    dataClassificationPolicyDecision: DataClassificationPolicyDecision;
    definitionId: Scalars["ID"]["output"];
    egress?: Maybe<Array<AppNetworkEgressPermissionExtension>>;
    environmentId: Scalars["ID"]["output"];
    environmentKey: Scalars["String"]["output"];
    environmentType: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    installation?: Maybe<AppInstallationSummary>;
    installationConfig?: Maybe<Array<EcosystemAppInstallationConfigExtension>>;
    installationId: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    license?: Maybe<AppInstallationLicense>;
    manuallyAddedReadMeScope?: Maybe<Scalars["Boolean"]["output"]>;
    migrationKey?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    oauthClientId: Scalars["ID"]["output"];
    /**
     * Please use installationConfig field instead as that provides all possible configs for an installation
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use installationConfig field
     */
    overrides?: Maybe<Scalars["JSON"]["output"]>;
    principal?: Maybe<AppPrincipal>;
    properties: Scalars["JSON"]["output"];
    remoteInstallationRegion?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Consent is checked upon invocation
     */
    requiresAutoConsent?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Consent is checked upon invocation
     */
    requiresUserConsent?: Maybe<Scalars["Boolean"]["output"]>;
    scopes: Array<Scalars["String"]["output"]>;
    securityPolicies?: Maybe<Array<AppSecurityPoliciesPermissionExtension>>;
    type: Scalars["String"]["output"];
    userAccess?: Maybe<UserAccess>;
    versionId: Scalars["ID"]["output"];
};

/** An arbitrary extension definition as defined by the Ecosystem */
export type ExtensionDataClassificationPolicyDecisionArgs = {
    input: DataClassificationPolicyDecisionInput;
};

/** An arbitrary extension definition as defined by the Ecosystem */
export type ExtensionUserAccessArgs = {
    userAaid?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The context in which an extension exists */
export type ExtensionContext = {
    __typename?: "ExtensionContext";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appAuditLogs: AppAuditConnection;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensions: Array<Extension>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensionsByType: Array<Extension>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use `appInstallationsByApp` or `appInstallationsByContext` queries instead
     */
    installations?: Maybe<AppInstallationConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    installationsSummary?: Maybe<Array<InstallationSummary>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userConsentByAaid?: Maybe<Array<UserConsent>>;
};

/** The context in which an extension exists */
export type ExtensionContextAppAuditLogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The context in which an extension exists */
export type ExtensionContextExtensionsArgs = {
    filter: Array<ExtensionContextsFilter>;
    locale?: InputMaybe<Scalars["String"]["input"]>;
};

/** The context in which an extension exists */
export type ExtensionContextExtensionsByTypeArgs = {
    locale?: InputMaybe<Scalars["String"]["input"]>;
    principalType?: InputMaybe<PrincipalType>;
    type: Scalars["String"]["input"];
};

/** The context in which an extension exists */
export type ExtensionContextInstallationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<AppInstallationsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The context in which an extension exists */
export type ExtensionContextUserConsentByAaidArgs = {
    userAaid: Scalars["ID"]["input"];
};

export type ExtensionContextsFilter = {
    type: ExtensionContextsFilterType;
    value: Array<Scalars["String"]["input"]>;
};

export enum ExtensionContextsFilterType {
    /** Filters extensions by App ID and Environment ID. Format is 'appId:environmentId'. */
    AppIdEnvironmentId = "APP_ID_ENVIRONMENT_ID",
    DataClassificationTag = "DATA_CLASSIFICATION_TAG",
    /** Filters extensions by Definition ID. */
    DefinitionId = "DEFINITION_ID",
    ExtensionType = "EXTENSION_TYPE",
    /** Filters extensions by principal type. Supported values are: 'unlicensed', 'customer', 'anonymous'. */
    PrincipalType = "PRINCIPAL_TYPE"
}

/**
 * Details about an extension.
 *
 * This information is used to look up the extension within CaaS so that the
 * correct function can be resolved.
 *
 * This will eventually be superseded by an Id.
 */
export type ExtensionDetailsInput = {
    /** The definition identifier as provided by CaaS */
    definitionId: Scalars["ID"]["input"];
    /** The extension key as provided by CaaS */
    extensionKey: Scalars["String"]["input"];
};

export enum ExternalApprovalStatus {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    Unapproved = "UNAPPROVED"
}

/**
 * Supported associations ATIs in Data Depot
 *   Implemented for hydration
 *     * GRAPH_SERVICE
 *     * JIRA_ISSUE
 *     * JIRA_DOCUMENT
 *     * JIRA_PROJECT
 *     * JIRA_VERSION
 *     * THIRD_PARTY_USER
 *   To be implemented
 *     * COMPASS_EVENT_SOURCE
 *     * COMPASS_COMPONENT
 *     * MERCURY_FOCUS_AREA
 *     * THIRD_PARTY_GROUP
 */
export type ExternalAssociation = {
    __typename?: "ExternalAssociation";
    createdBy?: Maybe<ExternalUser>;
    entity?: Maybe<ExternalAssociationEntity>;
    id: Scalars["ID"]["output"];
};

export type ExternalAssociationConnection = {
    __typename?: "ExternalAssociationConnection";
    edges?: Maybe<Array<Maybe<ExternalAssociationEdge>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type ExternalAssociationEdge = {
    __typename?: "ExternalAssociationEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ExternalAssociation>;
};

export type ExternalAssociationEntity =
    | DevOpsService
    | ExternalBranch
    | ExternalBuildInfo
    | ExternalCalendarEvent
    | ExternalComment
    | ExternalCommit
    | ExternalConversation
    | ExternalDeployment
    | ExternalDesign
    | ExternalDocument
    | ExternalFeatureFlag
    | ExternalMessage
    | ExternalOrganisation
    | ExternalPosition
    | ExternalPullRequest
    | ExternalRemoteLink
    | ExternalRepository
    | ExternalSpace
    | ExternalVideo
    | ExternalVulnerability
    | ExternalWorkItem
    | ExternalWorker
    | JiraIssue
    | JiraProject
    | JiraVersion
    | ThirdPartyUser;

export type ExternalAttachment = {
    __typename?: "ExternalAttachment";
    byteSize?: Maybe<Scalars["Long"]["output"]>;
    mimeType?: Maybe<Scalars["String"]["output"]>;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalAttendee = {
    __typename?: "ExternalAttendee";
    isOptional?: Maybe<Scalars["Boolean"]["output"]>;
    rsvpStatus?: Maybe<ExternalAttendeeRsvpStatus>;
    user?: Maybe<ExternalUser>;
};

export enum ExternalAttendeeRsvpStatus {
    Accepted = "ACCEPTED",
    Declined = "DECLINED",
    NotResponded = "NOT_RESPONDED",
    Other = "OTHER",
    TenativelyAccepted = "TENATIVELY_ACCEPTED"
}

export type ExternalAuthCredentialsInput = {
    /** The oAuth Client Id */
    clientId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The shared secret */
    clientSecret?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExternalAuthProvider = {
    __typename?: "ExternalAuthProvider";
    displayName: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    url: Scalars["URL"]["output"];
};

export type ExternalBranch = Node & {
    __typename?: "ExternalBranch";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    branchId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createPullRequestUrl?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdatedBy?: Maybe<ExternalUser>;
    name?: Maybe<Scalars["String"]["output"]>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    repositoryId?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalBranchReference = {
    __typename?: "ExternalBranchReference";
    name?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalBuildCommitReference = {
    __typename?: "ExternalBuildCommitReference";
    id?: Maybe<Scalars["String"]["output"]>;
    repositoryUri?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalBuildInfo = Node & {
    __typename?: "ExternalBuildInfo";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    buildNumber?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    duration?: Maybe<Scalars["Long"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    pipelineId?: Maybe<Scalars["String"]["output"]>;
    references?: Maybe<Array<Maybe<ExternalBuildReferences>>>;
    state?: Maybe<ExternalBuildState>;
    testInfo?: Maybe<ExternalTestInfo>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalBuildRefReference = {
    __typename?: "ExternalBuildRefReference";
    name?: Maybe<Scalars["String"]["output"]>;
    uri?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalBuildReferences = {
    __typename?: "ExternalBuildReferences";
    commit?: Maybe<ExternalBuildCommitReference>;
    ref?: Maybe<ExternalBuildRefReference>;
};

export enum ExternalBuildState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type ExternalCalendarEvent = Node & {
    __typename?: "ExternalCalendarEvent";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    attachments?: Maybe<Array<Maybe<ExternalCalendarEventAttachment>>>;
    attendees?: Maybe<Array<Maybe<ExternalAttendee>>>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    eventEndTime?: Maybe<Scalars["String"]["output"]>;
    eventStartTime?: Maybe<Scalars["String"]["output"]>;
    eventType?: Maybe<ExternalEventType>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    location?: Maybe<ExternalLocation>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    recurringEventId?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    videoMeetingUrl?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalCalendarEventAttachment = {
    __typename?: "ExternalCalendarEventAttachment";
    byteSize?: Maybe<Scalars["Long"]["output"]>;
    mimeType?: Maybe<Scalars["String"]["output"]>;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalChangeType {
    Added = "ADDED",
    Copied = "COPIED",
    Deleted = "DELETED",
    Modified = "MODIFIED",
    Moved = "MOVED",
    Unknown = "UNKNOWN"
}

export type ExternalChapter = {
    __typename?: "ExternalChapter";
    startTimeInSeconds?: Maybe<Scalars["Long"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

/** The default space assigned to new Confluence Guests on role assignment. */
export type ExternalCollaboratorDefaultSpace = {
    __typename?: "ExternalCollaboratorDefaultSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    enabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["Long"]["output"];
};

export type ExternalCollaboratorFeature = {
    __typename?: "ExternalCollaboratorFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export enum ExternalCollaboratorsSortField {
    Name = "NAME"
}

export type ExternalCollaboratorsSortType = {
    field?: InputMaybe<ExternalCollaboratorsSortField>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ExternalComment = Node & {
    __typename?: "ExternalComment";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    largeText?: Maybe<ExternalLargeContent>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    reactions?: Maybe<Array<Maybe<ExternalReactions>>>;
    text?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalCommentReactionType {
    Like = "LIKE"
}

export type ExternalCommit = Node & {
    __typename?: "ExternalCommit";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    author?: Maybe<ExternalUser>;
    commitId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayId?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    fileInfo?: Maybe<ExternalFileInfo>;
    flags?: Maybe<Array<Maybe<ExternalCommitFlags>>>;
    hash?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdatedBy?: Maybe<ExternalUser>;
    message?: Maybe<Scalars["String"]["output"]>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    repositoryId?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalCommitFlags {
    MergeCommit = "MERGE_COMMIT"
}

export type ExternalContributor = {
    __typename?: "ExternalContributor";
    interactionCount?: Maybe<Scalars["Long"]["output"]>;
    user?: Maybe<ExternalUser>;
};

export type ExternalConversation = Node & {
    __typename?: "ExternalConversation";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isArchived?: Maybe<Scalars["Boolean"]["output"]>;
    lastActive?: Maybe<Scalars["String"]["output"]>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    memberCount?: Maybe<Scalars["Long"]["output"]>;
    members?: Maybe<Array<Maybe<ExternalUser>>>;
    membershipType?: Maybe<ExternalMembershipType>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    topic?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<ExternalConversationType>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    workspace?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalConversationType {
    Channel = "CHANNEL",
    DirectMessage = "DIRECT_MESSAGE",
    GroupDirectMessage = "GROUP_DIRECT_MESSAGE"
}

export type ExternalCue = {
    __typename?: "ExternalCue";
    endTimeInSeconds?: Maybe<Scalars["Float"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    startTimeInSeconds?: Maybe<Scalars["Float"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalDeployment = Node & {
    __typename?: "ExternalDeployment";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    deploymentSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    duration?: Maybe<Scalars["Long"]["output"]>;
    environment?: Maybe<ExternalEnvironment>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    label?: Maybe<Scalars["String"]["output"]>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    pipeline?: Maybe<ExternalPipeline>;
    region?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<ExternalDeploymentState>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    triggeredBy?: Maybe<ExternalUser>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalDeploymentState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type ExternalDesign = Node & {
    __typename?: "ExternalDesign";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    inspectUrl?: Maybe<Scalars["String"]["output"]>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    liveEmbedUrl?: Maybe<Scalars["String"]["output"]>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    status?: Maybe<ExternalDesignStatus>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    type?: Maybe<ExternalDesignType>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalDesignStatus {
    None = "NONE",
    ReadyForDevelopment = "READY_FOR_DEVELOPMENT",
    Unknown = "UNKNOWN"
}

export enum ExternalDesignType {
    Canvas = "CANVAS",
    File = "FILE",
    Group = "GROUP",
    Node = "NODE",
    Other = "OTHER",
    Prototype = "PROTOTYPE"
}

export type ExternalDocument = Node & {
    __typename?: "ExternalDocument";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    byteSize?: Maybe<Scalars["Long"]["output"]>;
    collaborators?: Maybe<Array<Maybe<ExternalUser>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    content?: Maybe<ExternalLargeContent>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    exportLinks?: Maybe<Array<Maybe<ExternalExportLink>>>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Feature supported Open Toolchain GDrive app only which is now deprecated
     */
    hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    truncatedDisplayName?: Maybe<Scalars["Boolean"]["output"]>;
    type?: Maybe<ExternalDocumentType>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalDocumentCategory {
    Archive = "ARCHIVE",
    Audio = "AUDIO",
    Blogpost = "BLOGPOST",
    Code = "CODE",
    Comment = "COMMENT",
    Document = "DOCUMENT",
    Folder = "FOLDER",
    Form = "FORM",
    Image = "IMAGE",
    Other = "OTHER",
    Page = "PAGE",
    Pdf = "PDF",
    Presentation = "PRESENTATION",
    Shortcut = "SHORTCUT",
    Space = "SPACE",
    Spreadsheet = "SPREADSHEET",
    Video = "VIDEO",
    WebPage = "WEB_PAGE"
}

export type ExternalDocumentType = {
    __typename?: "ExternalDocumentType";
    category?: Maybe<ExternalDocumentCategory>;
    fileExtension?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    mimeType?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalEntities = {
    __typename?: "ExternalEntities";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    branch?: Maybe<Array<Maybe<ExternalBranch>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    buildInfo?: Maybe<Array<Maybe<ExternalBuildInfo>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    calendarEvent?: Maybe<Array<Maybe<ExternalCalendarEvent>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    comment?: Maybe<Array<Maybe<ExternalComment>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    commit?: Maybe<Array<Maybe<ExternalCommit>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    conversation?: Maybe<Array<Maybe<ExternalConversation>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deployment?: Maybe<Array<Maybe<ExternalDeployment>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    design?: Maybe<Array<Maybe<ExternalDesign>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    document?: Maybe<Array<Maybe<ExternalDocument>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    featureFlag?: Maybe<Array<Maybe<ExternalFeatureFlag>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message?: Maybe<Array<Maybe<ExternalMessage>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    organisation?: Maybe<Array<Maybe<ExternalOrganisation>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    position?: Maybe<Array<Maybe<ExternalPosition>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pullRequest?: Maybe<Array<Maybe<ExternalPullRequest>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    remoteLink?: Maybe<Array<Maybe<ExternalRemoteLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    repository?: Maybe<Array<Maybe<ExternalRepository>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    space?: Maybe<Array<Maybe<ExternalSpace>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    video?: Maybe<Array<Maybe<ExternalVideo>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    vulnerability?: Maybe<Array<Maybe<ExternalVulnerability>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workItem?: Maybe<Array<Maybe<ExternalWorkItem>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    worker?: Maybe<Array<Maybe<ExternalWorker>>>;
};

/** Return one or the supported model */
export type ExternalEntity =
    | ExternalBranch
    | ExternalBuildInfo
    | ExternalCalendarEvent
    | ExternalComment
    | ExternalCommit
    | ExternalConversation
    | ExternalDeployment
    | ExternalDesign
    | ExternalDocument
    | ExternalFeatureFlag
    | ExternalMessage
    | ExternalOrganisation
    | ExternalPosition
    | ExternalPullRequest
    | ExternalRemoteLink
    | ExternalRepository
    | ExternalSpace
    | ExternalVideo
    | ExternalVulnerability
    | ExternalWorkItem
    | ExternalWorker;

export type ExternalEnvironment = {
    __typename?: "ExternalEnvironment";
    displayName?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<ExternalEnvironmentType>;
};

export enum ExternalEnvironmentType {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export enum ExternalEventType {
    Appointment = "APPOINTMENT",
    Birthday = "BIRTHDAY",
    Default = "DEFAULT",
    Event = "EVENT",
    FocusTime = "FOCUS_TIME",
    OutOfOffice = "OUT_OF_OFFICE",
    Reminder = "REMINDER",
    Task = "TASK",
    WorkingLocation = "WORKING_LOCATION"
}

export type ExternalExportLink = {
    __typename?: "ExternalExportLink";
    mimeType?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFeatureFlag = Node & {
    __typename?: "ExternalFeatureFlag";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    details?: Maybe<Array<Maybe<ExternalFeatureFlagDetail>>>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    key?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<ExternalFeatureFlagSummary>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFeatureFlagDetail = {
    __typename?: "ExternalFeatureFlagDetail";
    environment?: Maybe<ExternalFeatureFlagEnvironment>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<ExternalFeatureFlagStatus>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFeatureFlagEnvironment = {
    __typename?: "ExternalFeatureFlagEnvironment";
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFeatureFlagRollout = {
    __typename?: "ExternalFeatureFlagRollout";
    percentage?: Maybe<Scalars["Float"]["output"]>;
    rules?: Maybe<Scalars["Int"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFeatureFlagStatus = {
    __typename?: "ExternalFeatureFlagStatus";
    defaultValue?: Maybe<Scalars["String"]["output"]>;
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    rollout?: Maybe<ExternalFeatureFlagRollout>;
};

export type ExternalFeatureFlagSummary = {
    __typename?: "ExternalFeatureFlagSummary";
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<ExternalFeatureFlagStatus>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFile = {
    __typename?: "ExternalFile";
    changeType?: Maybe<ExternalChangeType>;
    linesAdded?: Maybe<Scalars["Int"]["output"]>;
    linesRemoved?: Maybe<Scalars["Int"]["output"]>;
    path?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalFileInfo = {
    __typename?: "ExternalFileInfo";
    fileCount?: Maybe<Scalars["Int"]["output"]>;
    files?: Maybe<Array<Maybe<ExternalFile>>>;
};

export type ExternalIcon = {
    __typename?: "ExternalIcon";
    height?: Maybe<Scalars["Int"]["output"]>;
    isDefault?: Maybe<Scalars["Boolean"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    width?: Maybe<Scalars["Int"]["output"]>;
};

export type ExternalLargeContent = {
    __typename?: "ExternalLargeContent";
    asText?: Maybe<Scalars["String"]["output"]>;
    mimeType?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalLocation = {
    __typename?: "ExternalLocation";
    address?: Maybe<Scalars["String"]["output"]>;
    coordinates?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalMembershipType {
    Private = "PRIVATE",
    Public = "PUBLIC",
    Shared = "SHARED"
}

export type ExternalMessage = Node & {
    __typename?: "ExternalMessage";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    attachments?: Maybe<Array<Maybe<ExternalAttachment>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    hidden?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    isPinned?: Maybe<Scalars["Boolean"]["output"]>;
    largeContentDescription?: Maybe<ExternalLargeContent>;
    lastActive?: Maybe<Scalars["String"]["output"]>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalOrganisation = Node & {
    __typename?: "ExternalOrganisation";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalPipeline = {
    __typename?: "ExternalPipeline";
    displayName?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalPosition = Node & {
    __typename?: "ExternalPosition";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalProject = {
    __typename?: "ExternalProject";
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalPullRequest = Node & {
    __typename?: "ExternalPullRequest";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    author?: Maybe<ExternalUser>;
    commentCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'container' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    container?: Maybe<ExternalEntity>;
    containerId?: Maybe<Scalars["ID"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    destinationBranch?: Maybe<ExternalBranchReference>;
    displayId?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdate?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    pullRequestId?: Maybe<Scalars["String"]["output"]>;
    repositoryId?: Maybe<Scalars["String"]["output"]>;
    reviewers?: Maybe<Array<Maybe<ExternalReviewer>>>;
    sourceBranch?: Maybe<ExternalBranchReference>;
    status?: Maybe<ExternalPullRequestStatus>;
    supportedActions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    tasksCount?: Maybe<Scalars["Int"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalPullRequestStatus {
    Declined = "DECLINED",
    Draft = "DRAFT",
    Merged = "MERGED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type ExternalReactions = {
    __typename?: "ExternalReactions";
    total?: Maybe<Scalars["Int"]["output"]>;
    type?: Maybe<ExternalCommentReactionType>;
};

export type ExternalRemoteLink = Node & {
    __typename?: "ExternalRemoteLink";
    actionIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    assignee?: Maybe<ExternalUser>;
    associatedWith?: Maybe<ExternalAssociationConnection>;
    attributeMap?: Maybe<Array<Maybe<ExternalRemoteLinkAttributeTuple>>>;
    author?: Maybe<ExternalUser>;
    category?: Maybe<Scalars["String"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    remoteLinkId?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<ExternalRemoteLinkStatus>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    type?: Maybe<Scalars["String"]["output"]>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalRemoteLinkAttributeTuple = {
    __typename?: "ExternalRemoteLinkAttributeTuple";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalRemoteLinkStatus = {
    __typename?: "ExternalRemoteLinkStatus";
    appearance?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalRepository = Node & {
    __typename?: "ExternalRepository";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    avatarDescription?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    forkOfId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdatedBy?: Maybe<ExternalUser>;
    name?: Maybe<Scalars["String"]["output"]>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    repositoryId?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalReviewer = {
    __typename?: "ExternalReviewer";
    approvalStatus?: Maybe<ExternalApprovalStatus>;
    user?: Maybe<ExternalUser>;
};

export type ExternalSpace = Node & {
    __typename?: "ExternalSpace";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<ExternalIcon>;
    id: Scalars["ID"]["output"];
    key?: Maybe<Scalars["String"]["output"]>;
    labels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    spaceType?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalTestInfo = {
    __typename?: "ExternalTestInfo";
    numberFailed?: Maybe<Scalars["Int"]["output"]>;
    numberPassed?: Maybe<Scalars["Int"]["output"]>;
    numberSkipped?: Maybe<Scalars["Int"]["output"]>;
    totalNumber?: Maybe<Scalars["Int"]["output"]>;
};

export type ExternalThumbnail = {
    __typename?: "ExternalThumbnail";
    externalUrl?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalTrack = {
    __typename?: "ExternalTrack";
    cues?: Maybe<Array<Maybe<ExternalCue>>>;
    locale?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalUser = {
    __typename?: "ExternalUser";
    thirdPartyUser?: Maybe<ThirdPartyUser>;
    user?: Maybe<User>;
};

export type ExternalVideo = Node & {
    __typename?: "ExternalVideo";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    chapters?: Maybe<Array<Maybe<ExternalChapter>>>;
    commentCount?: Maybe<Scalars["Long"]["output"]>;
    contributors?: Maybe<Array<Maybe<ExternalContributor>>>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    durationInSeconds?: Maybe<Scalars["Long"]["output"]>;
    embedUrl?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    height?: Maybe<Scalars["Long"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    textTracks?: Maybe<Array<Maybe<ExternalTrack>>>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    width?: Maybe<Scalars["Long"]["output"]>;
};

export type ExternalVulnerability = Node & {
    __typename?: "ExternalVulnerability";
    additionalInfo?: Maybe<ExternalVulnerabilityAdditionalInfo>;
    associatedWith?: Maybe<ExternalAssociationConnection>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    identifiers?: Maybe<Array<Maybe<ExternalVulnerabilityIdentifier>>>;
    introducedDate?: Maybe<Scalars["String"]["output"]>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    severity?: Maybe<ExternalVulnerabilitySeverity>;
    status?: Maybe<ExternalVulnerabilityStatus>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<ExternalVulnerabilityType>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalVulnerabilityAdditionalInfo = {
    __typename?: "ExternalVulnerabilityAdditionalInfo";
    content?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalVulnerabilityIdentifier = {
    __typename?: "ExternalVulnerabilityIdentifier";
    displayName?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalVulnerabilitySeverity = {
    __typename?: "ExternalVulnerabilitySeverity";
    level?: Maybe<ExternalVulnerabilitySeverityLevel>;
};

export enum ExternalVulnerabilitySeverityLevel {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    Unknown = "UNKNOWN"
}

export enum ExternalVulnerabilityStatus {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum ExternalVulnerabilityType {
    Dast = "DAST",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type ExternalWorkItem = Node & {
    __typename?: "ExternalWorkItem";
    assignee?: Maybe<ExternalUser>;
    associatedWith?: Maybe<ExternalAssociationConnection>;
    attachments?: Maybe<Array<Maybe<ExternalWorkItemAttachment>>>;
    collaborators?: Maybe<Array<Maybe<ExternalUser>>>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    dueDate?: Maybe<Scalars["String"]["output"]>;
    exceedsMaxCollaborators?: Maybe<Scalars["Boolean"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'parent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parent?: Maybe<ExternalEntity>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
    project?: Maybe<ExternalProject>;
    status?: Maybe<Scalars["String"]["output"]>;
    subtype?: Maybe<ExternalWorkItemSubtype>;
    team?: Maybe<Scalars["String"]["output"]>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    workItemProject?: Maybe<ExternalWorkItemProject>;
};

export type ExternalWorkItemAttachment = {
    __typename?: "ExternalWorkItemAttachment";
    byteSize?: Maybe<Scalars["Long"]["output"]>;
    mimeType?: Maybe<Scalars["String"]["output"]>;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ExternalWorkItemProject = {
    __typename?: "ExternalWorkItemProject";
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export enum ExternalWorkItemSubtype {
    Approval = "APPROVAL",
    Bug = "BUG",
    DefaultTask = "DEFAULT_TASK",
    Epic = "EPIC",
    Incident = "INCIDENT",
    Issue = "ISSUE",
    Milestone = "MILESTONE",
    Other = "OTHER",
    Problem = "PROBLEM",
    Question = "QUESTION",
    Section = "SECTION",
    Story = "STORY",
    Task = "TASK",
    WorkItem = "WORK_ITEM"
}

export type ExternalWorker = Node & {
    __typename?: "ExternalWorker";
    associatedWith?: Maybe<ExternalAssociationConnection>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<ExternalUser>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    hiredAt?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedBy?: Maybe<ExternalUser>;
    owners?: Maybe<Array<Maybe<ExternalUser>>>;
    thirdPartyId?: Maybe<Scalars["String"]["output"]>;
    thumbnail?: Maybe<ExternalThumbnail>;
    updateSequenceNumber?: Maybe<Scalars["Long"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    workerUser?: Maybe<ExternalUser>;
};

export type FailedRoles = {
    __typename?: "FailedRoles";
    reason: Scalars["String"]["output"];
    role?: Maybe<AppContributorRole>;
};

export type FaviconFile = {
    __typename?: "FaviconFile";
    fileStoreId: Scalars["ID"]["output"];
    filename: Scalars["String"]["output"];
};

export type FaviconFileInput = {
    fileStoreId: Scalars["ID"]["input"];
    filename: Scalars["String"]["input"];
};

export type FavouritePageInput = {
    pageId: Scalars["ID"]["input"];
};

export type FavouritePagePayload = {
    __typename?: "FavouritePagePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Content;
};

export type FavouriteSpaceBulkPayload = Payload & {
    __typename?: "FavouriteSpaceBulkPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    failedSpaceKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spacesFavouritedMap?: Maybe<Array<Maybe<MapOfStringToBoolean>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type FavouriteSpacePayload = {
    __typename?: "FavouriteSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSpaceFavourited?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FavouritedSummary = {
    __typename?: "FavouritedSummary";
    favouritedDate?: Maybe<Scalars["String"]["output"]>;
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
};

export type FeatureDiscoveryPayload = {
    __typename?: "FeatureDiscoveryPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    date?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    featureKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pluginKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
};

export type FeedEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: FeedEventType;
};

export type FeedEventComment = FeedEvent & {
    __typename?: "FeedEventComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'comment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    comment?: Maybe<Comment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: FeedEventType;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    user?: Maybe<Person>;
};

export type FeedEventCreate = FeedEvent & {
    __typename?: "FeedEventCreate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: FeedEventType;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    user?: Maybe<Person>;
};

export type FeedEventEdit = FeedEvent & {
    __typename?: "FeedEventEdit";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: FeedEventType;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'user' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    user?: Maybe<Person>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Scalars["Int"]["output"];
};

export type FeedEventEditLive = FeedEvent & {
    __typename?: "FeedEventEditLive";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: FeedEventType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Scalars["Int"]["output"];
};

export type FeedEventPublishLive = FeedEvent & {
    __typename?: "FeedEventPublishLive";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    datetime: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: FeedEventType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    version: Scalars["Int"]["output"];
};

export enum FeedEventType {
    Comment = "COMMENT",
    Create = "CREATE",
    Edit = "EDIT",
    Editlive = "EDITLIVE",
    Publishlive = "PUBLISHLIVE"
}

export type FeedItem = {
    __typename?: "FeedItem";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
    id: Scalars["String"]["output"];
    mostRelevantUpdate: Scalars["Int"]["output"];
    recentActionsCount: Scalars["Int"]["output"];
    source: Array<FeedItemSourceType>;
    summaryLineUpdate: FeedEvent;
};

export type FeedItemEdge = {
    __typename?: "FeedItemEdge";
    /** Edge cursor pagination is not supported. This will always be null! Use the endCursor in pageInfo for forward pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: FeedItem;
};

export enum FeedItemSourceType {
    Person = "PERSON",
    Space = "SPACE"
}

export type FeedPageInfo = {
    __typename?: "FeedPageInfo";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be false. */
    hasPreviousPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be null. */
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type FeedPageInformation = {
    __typename?: "FeedPageInformation";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be false. */
    hasPreviousPage: Scalars["Boolean"]["output"];
    /** Backwards pagination is not yet supported. This will always be null. */
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export enum FeedType {
    Direct = "DIRECT",
    Following = "FOLLOWING",
    Popular = "POPULAR"
}

export type FilterQuery = {
    __typename?: "FilterQuery";
    errors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    sanitisedJql: Scalars["String"]["output"];
};

export type FilteredPrincipalSubjectKey = {
    __typename?: "FilteredPrincipalSubjectKey";
    /** If subject type is not USER, then this query will return null */
    confluencePerson?: Maybe<ConfluencePerson>;
    /** User display name for a user, or group name for a group */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** If subject type is not GROUP, then this query will return null */
    group?: Maybe<Group>;
    /** User account id for a user, or group external id for a group */
    id?: Maybe<Scalars["String"]["output"]>;
    /** Subject Permission Display Type--to filter principals by their role (see PermissionDisplayType.java */
    permissionDisplayType: PermissionDisplayType;
};

export type FollowUserInput = {
    accountId: Scalars["String"]["input"];
};

export type FollowUserPayload = {
    __typename?: "FollowUserPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentUserFollowing: Scalars["Boolean"]["output"];
};

export type FollowingFeedGetUserConfig = {
    __typename?: "FollowingFeedGetUserConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountIds: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    servingRecommendations: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceIds: Array<Maybe<Scalars["Long"]["output"]>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaces?: Maybe<Array<Maybe<Space>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    users?: Maybe<Array<Maybe<Person>>>;
};

export type FooterComment = CommentLocation & {
    __typename?: "FooterComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentRepliesCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentResolveProperties?: Maybe<InlineCommentResolveProperties>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: Scalars["String"]["output"];
};

export type ForYouFeedItem = {
    __typename?: "ForYouFeedItem";
    id: Scalars["String"]["output"];
    mostRelevantUpdate?: Maybe<Scalars["Int"]["output"]>;
    recentActionsCount?: Maybe<Scalars["Int"]["output"]>;
    source?: Maybe<Array<Maybe<FeedItemSourceType>>>;
    summaryLineUpdate?: Maybe<FeedEvent>;
    type: Scalars["String"]["output"];
};

export type ForYouFeedItemEdge = {
    __typename?: "ForYouFeedItemEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: ForYouFeedItem;
};

export type ForYouPaginatedFeed = {
    __typename?: "ForYouPaginatedFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<ForYouFeedItemEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<ForYouFeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: FeedPageInformation;
};

export type ForgeAlertsActivityLog = {
    __typename?: "ForgeAlertsActivityLog";
    context?: Maybe<ForgeAlertsActivityLogContext>;
    type: ForgeAlertsAlertActivityType;
};

export type ForgeAlertsActivityLogContext = {
    __typename?: "ForgeAlertsActivityLogContext";
    actor?: Maybe<ForgeAlertsUserInfo>;
    at?: Maybe<Scalars["String"]["output"]>;
    severity?: Maybe<ForgeAlertsActivityLogSeverity>;
    to?: Maybe<Array<Maybe<ForgeAlertsEmailMeta>>>;
};

export type ForgeAlertsActivityLogSeverity = {
    __typename?: "ForgeAlertsActivityLogSeverity";
    current?: Maybe<Scalars["String"]["output"]>;
    previous?: Maybe<Scalars["String"]["output"]>;
};

export type ForgeAlertsActivityLogsInput = {
    alertId: Scalars["Int"]["input"];
};

export type ForgeAlertsActivityLogsResult =
    | ForgeAlertsActivityLogsSuccess
    | QueryError;

export type ForgeAlertsActivityLogsSuccess = {
    __typename?: "ForgeAlertsActivityLogsSuccess";
    activities?: Maybe<Array<Maybe<ForgeAlertsActivityLog>>>;
};

export enum ForgeAlertsAlertActivityType {
    AlertClosed = "ALERT_CLOSED",
    AlertOpen = "ALERT_OPEN",
    EmailSent = "EMAIL_SENT",
    SeverityUpdated = "SEVERITY_UPDATED"
}

export type ForgeAlertsChartDetailsData = {
    __typename?: "ForgeAlertsChartDetailsData";
    interval: ForgeAlertsMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeAlertsMetricsResolution;
    series: Array<ForgeAlertsMetricsSeries>;
    type: ForgeAlertsMetricsDataType;
};

export type ForgeAlertsChartDetailsInput = {
    environment: Scalars["String"]["input"];
    filters?: InputMaybe<Array<ForgeAlertsRuleFilters>>;
    interval?: InputMaybe<ForgeAlertsQueryIntervalInput>;
    metric: ForgeAlertsRuleMetricType;
    period?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ForgeAlertsChartDetailsResult =
    | ForgeAlertsChartDetailsData
    | QueryError;

export type ForgeAlertsClosed = {
    __typename?: "ForgeAlertsClosed";
    success: Scalars["Boolean"]["output"];
};

export type ForgeAlertsClosedResponse = ForgeAlertsClosed | QueryError;

export type ForgeAlertsCreateRuleInput = {
    conditions: Array<ForgeAlertsRuleConditions>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    envId: Scalars["String"]["input"];
    filters?: InputMaybe<Array<ForgeAlertsRuleFilters>>;
    metric: ForgeAlertsRuleMetricType;
    name: Scalars["String"]["input"];
    period: Scalars["Int"]["input"];
    responders: Array<Scalars["String"]["input"]>;
    runbook?: InputMaybe<Scalars["String"]["input"]>;
    tolerance?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ForgeAlertsCreateRulePayload = Payload & {
    __typename?: "ForgeAlertsCreateRulePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type ForgeAlertsData = {
    __typename?: "ForgeAlertsData";
    alertId: Scalars["Int"]["output"];
    closedAt?: Maybe<Scalars["String"]["output"]>;
    closedBy?: Maybe<Scalars["String"]["output"]>;
    closedByResponder?: Maybe<ForgeAlertsUserInfo>;
    createdAt: Scalars["String"]["output"];
    duration?: Maybe<Scalars["Int"]["output"]>;
    envId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    modifiedAt: Scalars["String"]["output"];
    ruleConditions: Array<ForgeAlertsRuleConditionsResponse>;
    ruleDescription?: Maybe<Scalars["String"]["output"]>;
    ruleFilters?: Maybe<Array<ForgeAlertsRuleFiltersResponse>>;
    ruleId: Scalars["ID"]["output"];
    ruleMetric: ForgeAlertsRuleMetricType;
    ruleName: Scalars["String"]["output"];
    rulePeriod: Scalars["Int"]["output"];
    ruleResponders: Array<ForgeAlertsUserInfo>;
    ruleRunbook?: Maybe<Scalars["String"]["output"]>;
    ruleTolerance: Scalars["Int"]["output"];
    severity: ForgeAlertsRuleSeverity;
    status: ForgeAlertsStatus;
};

export type ForgeAlertsDeleteRuleInput = {
    ruleId: Scalars["ID"]["input"];
};

export type ForgeAlertsDeleteRulePayload = Payload & {
    __typename?: "ForgeAlertsDeleteRulePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type ForgeAlertsEmailMeta = {
    __typename?: "ForgeAlertsEmailMeta";
    address?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ForgeAlertsIsAlertOpenForRuleResponse =
    | ForgeAlertsOpen
    | QueryError;

export enum ForgeAlertsListOrderByColumns {
    AlertId = "alertId",
    ClosedAt = "closedAt",
    CreatedAt = "createdAt",
    Duration = "duration",
    Severity = "severity"
}

export enum ForgeAlertsListOrderOptions {
    Asc = "ASC",
    Desc = "DESC"
}

export type ForgeAlertsListQueryInput = {
    closedAtEndDate?: InputMaybe<Scalars["String"]["input"]>;
    closedAtStartDate?: InputMaybe<Scalars["String"]["input"]>;
    createdAtEndDate?: InputMaybe<Scalars["String"]["input"]>;
    createdAtStartDate?: InputMaybe<Scalars["String"]["input"]>;
    limit: Scalars["Int"]["input"];
    order: ForgeAlertsListOrderOptions;
    orderBy: ForgeAlertsListOrderByColumns;
    page: Scalars["Int"]["input"];
    responders?: InputMaybe<Array<Scalars["String"]["input"]>>;
    ruleId?: InputMaybe<Scalars["ID"]["input"]>;
    searchTerm?: InputMaybe<Scalars["String"]["input"]>;
    severities?: InputMaybe<Array<ForgeAlertsRuleSeverity>>;
    status?: InputMaybe<ForgeAlertsStatus>;
};

export type ForgeAlertsListResult = ForgeAlertsListSuccess | QueryError;

export type ForgeAlertsListSuccess = {
    __typename?: "ForgeAlertsListSuccess";
    alerts: Array<ForgeAlertsData>;
    count: Scalars["Int"]["output"];
};

export type ForgeAlertsMetricsDataPoint = {
    __typename?: "ForgeAlertsMetricsDataPoint";
    timestamp: Scalars["String"]["output"];
    value: Scalars["Float"]["output"];
};

export enum ForgeAlertsMetricsDataType {
    DateTime = "DATE_TIME"
}

export type ForgeAlertsMetricsIntervalRange = {
    __typename?: "ForgeAlertsMetricsIntervalRange";
    end: Scalars["String"]["output"];
    start: Scalars["String"]["output"];
};

export type ForgeAlertsMetricsLabelGroup = {
    __typename?: "ForgeAlertsMetricsLabelGroup";
    key: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type ForgeAlertsMetricsResolution = {
    __typename?: "ForgeAlertsMetricsResolution";
    size: Scalars["Int"]["output"];
    units: ForgeAlertsMetricsResolutionUnit;
};

export enum ForgeAlertsMetricsResolutionUnit {
    Day = "DAY",
    Hours = "HOURS",
    Minutes = "MINUTES"
}

export type ForgeAlertsMetricsSeries = {
    __typename?: "ForgeAlertsMetricsSeries";
    data: Array<ForgeAlertsMetricsDataPoint>;
    groups: Array<ForgeAlertsMetricsLabelGroup>;
};

export type ForgeAlertsMutation = {
    __typename?: "ForgeAlertsMutation";
    appId: Scalars["ID"]["output"];
    createRule?: Maybe<ForgeAlertsCreateRulePayload>;
    deleteRule?: Maybe<ForgeAlertsDeleteRulePayload>;
    updateRule?: Maybe<ForgeAlertsUpdateRulePayload>;
};

export type ForgeAlertsMutationCreateRuleArgs = {
    input: ForgeAlertsCreateRuleInput;
};

export type ForgeAlertsMutationDeleteRuleArgs = {
    input: ForgeAlertsDeleteRuleInput;
};

export type ForgeAlertsMutationUpdateRuleArgs = {
    input: ForgeAlertsUpdateRuleInput;
};

export type ForgeAlertsOpen = {
    __typename?: "ForgeAlertsOpen";
    success: Scalars["Boolean"]["output"];
};

export type ForgeAlertsQuery = {
    __typename?: "ForgeAlertsQuery";
    alert?: Maybe<ForgeAlertsSingleResult>;
    alertActivityLogs?: Maybe<ForgeAlertsActivityLogsResult>;
    alerts?: Maybe<ForgeAlertsListResult>;
    appId: Scalars["ID"]["output"];
    chartDetails?: Maybe<ForgeAlertsChartDetailsResult>;
    closeAlert?: Maybe<ForgeAlertsClosedResponse>;
    isAlertOpenForRule?: Maybe<ForgeAlertsIsAlertOpenForRuleResponse>;
    rule?: Maybe<ForgeAlertsRuleResult>;
    ruleActivityLogs?: Maybe<ForgeAlertsRuleActivityLogsResult>;
    ruleFilters?: Maybe<ForgeAlertsRuleFiltersResult>;
    rules?: Maybe<ForgeAlertsRulesResult>;
};

export type ForgeAlertsQueryAlertArgs = {
    alertId: Scalars["ID"]["input"];
};

export type ForgeAlertsQueryAlertActivityLogsArgs = {
    query: ForgeAlertsActivityLogsInput;
};

export type ForgeAlertsQueryAlertsArgs = {
    query: ForgeAlertsListQueryInput;
};

export type ForgeAlertsQueryChartDetailsArgs = {
    input: ForgeAlertsChartDetailsInput;
};

export type ForgeAlertsQueryCloseAlertArgs = {
    ruleId: Scalars["ID"]["input"];
};

export type ForgeAlertsQueryIsAlertOpenForRuleArgs = {
    ruleId: Scalars["ID"]["input"];
};

export type ForgeAlertsQueryRuleArgs = {
    ruleId: Scalars["ID"]["input"];
};

export type ForgeAlertsQueryRuleActivityLogsArgs = {
    query: ForgeAlertsRuleActivityLogsInput;
};

export type ForgeAlertsQueryRuleFiltersArgs = {
    input: ForgeAlertsRuleFiltersInput;
};

export type ForgeAlertsQueryIntervalInput = {
    end: Scalars["String"]["input"];
    start: Scalars["String"]["input"];
};

export enum ForgeAlertsRuleActivityAction {
    Created = "CREATED",
    Deleted = "DELETED",
    Disabled = "DISABLED",
    Enabled = "ENABLED",
    Updated = "UPDATED"
}

export type ForgeAlertsRuleActivityLogContext = {
    __typename?: "ForgeAlertsRuleActivityLogContext";
    ruleName?: Maybe<Scalars["String"]["output"]>;
    updates?: Maybe<Array<Maybe<ForgeAlertsRuleActivityLogContextUpdates>>>;
};

export type ForgeAlertsRuleActivityLogContextUpdates = {
    __typename?: "ForgeAlertsRuleActivityLogContextUpdates";
    current?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    previous?: Maybe<Scalars["String"]["output"]>;
};

export type ForgeAlertsRuleActivityLogs = {
    __typename?: "ForgeAlertsRuleActivityLogs";
    action?: Maybe<ForgeAlertsRuleActivityAction>;
    actor?: Maybe<ForgeAlertsUserInfo>;
    context?: Maybe<ForgeAlertsRuleActivityLogContext>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    ruleId?: Maybe<Scalars["String"]["output"]>;
};

export type ForgeAlertsRuleActivityLogsInput = {
    action?: InputMaybe<Array<InputMaybe<ForgeAlertsRuleActivityAction>>>;
    actor?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    endTime: Scalars["String"]["input"];
    limit: Scalars["Int"]["input"];
    page: Scalars["Int"]["input"];
    ruleIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    startTime: Scalars["String"]["input"];
};

export type ForgeAlertsRuleActivityLogsResult =
    | ForgeAlertsRuleActivityLogsSuccess
    | QueryError;

export type ForgeAlertsRuleActivityLogsSuccess = {
    __typename?: "ForgeAlertsRuleActivityLogsSuccess";
    activities?: Maybe<Array<Maybe<ForgeAlertsRuleActivityLogs>>>;
    count?: Maybe<Scalars["Int"]["output"]>;
};

export type ForgeAlertsRuleConditions = {
    severity: ForgeAlertsRuleSeverity;
    threshold: Scalars["String"]["input"];
    when: ForgeAlertsRuleWhenConditions;
};

export type ForgeAlertsRuleConditionsResponse = {
    __typename?: "ForgeAlertsRuleConditionsResponse";
    severity: ForgeAlertsRuleSeverity;
    threshold: Scalars["String"]["output"];
    when: ForgeAlertsRuleWhenConditions;
};

export type ForgeAlertsRuleData = {
    __typename?: "ForgeAlertsRuleData";
    appId?: Maybe<Scalars["String"]["output"]>;
    conditions?: Maybe<Array<ForgeAlertsRuleConditionsResponse>>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    createdBy: ForgeAlertsUserInfo;
    description?: Maybe<Scalars["String"]["output"]>;
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    envId?: Maybe<Scalars["String"]["output"]>;
    filters?: Maybe<Array<ForgeAlertsRuleFiltersResponse>>;
    id: Scalars["ID"]["output"];
    jobId?: Maybe<Scalars["String"]["output"]>;
    lastTriggeredAt?: Maybe<Scalars["String"]["output"]>;
    metric?: Maybe<Scalars["String"]["output"]>;
    modifiedAt?: Maybe<Scalars["String"]["output"]>;
    modifiedBy: ForgeAlertsUserInfo;
    name?: Maybe<Scalars["String"]["output"]>;
    period?: Maybe<Scalars["Int"]["output"]>;
    responders: Array<ForgeAlertsUserInfo>;
    runbook?: Maybe<Scalars["String"]["output"]>;
    tolerance?: Maybe<Scalars["Int"]["output"]>;
};

export enum ForgeAlertsRuleFilterActions {
    Exclude = "EXCLUDE",
    Include = "INCLUDE"
}

export enum ForgeAlertsRuleFilterDimensions {
    ErrorTypes = "ERROR_TYPES",
    Functions = "FUNCTIONS",
    Sites = "SITES",
    Versions = "VERSIONS"
}

export type ForgeAlertsRuleFilters = {
    action: ForgeAlertsRuleFilterActions;
    dimension: ForgeAlertsRuleFilterDimensions;
    value: Array<Scalars["String"]["input"]>;
};

export type ForgeAlertsRuleFiltersData = {
    __typename?: "ForgeAlertsRuleFiltersData";
    filters: Array<ForgeAlertsMetricsLabelGroup>;
};

export type ForgeAlertsRuleFiltersInput = {
    environment: Scalars["String"]["input"];
};

export type ForgeAlertsRuleFiltersResponse = {
    __typename?: "ForgeAlertsRuleFiltersResponse";
    action: ForgeAlertsRuleFilterActions;
    dimension: ForgeAlertsRuleFilterDimensions;
    value: Array<Scalars["String"]["output"]>;
};

export type ForgeAlertsRuleFiltersResult =
    | ForgeAlertsRuleFiltersData
    | QueryError;

export enum ForgeAlertsRuleMetricType {
    InvocationCount = "INVOCATION_COUNT",
    InvocationErrors = "INVOCATION_ERRORS",
    InvocationLatency = "INVOCATION_LATENCY",
    InvocationSuccessRate = "INVOCATION_SUCCESS_RATE"
}

export type ForgeAlertsRuleResult = ForgeAlertsRuleData | QueryError;

export enum ForgeAlertsRuleSeverity {
    Critical = "CRITICAL",
    Major = "MAJOR",
    Minor = "MINOR"
}

export enum ForgeAlertsRuleWhenConditions {
    Above = "ABOVE",
    AboveOrEqualTo = "ABOVE_OR_EQUAL_TO",
    Below = "BELOW",
    BelowOrEqualTo = "BELOW_OR_EQUAL_TO"
}

export type ForgeAlertsRulesData = {
    __typename?: "ForgeAlertsRulesData";
    createdAt: Scalars["String"]["output"];
    enabled: Scalars["Boolean"]["output"];
    id: Scalars["ID"]["output"];
    lastTriggeredAt?: Maybe<Scalars["String"]["output"]>;
    modifiedAt: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    responders: Array<ForgeAlertsUserInfo>;
};

export type ForgeAlertsRulesResult = ForgeAlertsRulesSuccess | QueryError;

export type ForgeAlertsRulesSuccess = {
    __typename?: "ForgeAlertsRulesSuccess";
    rules: Array<ForgeAlertsRulesData>;
};

export type ForgeAlertsSingleResult = ForgeAlertsSingleSuccess | QueryError;

export type ForgeAlertsSingleSuccess = {
    __typename?: "ForgeAlertsSingleSuccess";
    alert: ForgeAlertsData;
};

export enum ForgeAlertsStatus {
    Closed = "CLOSED",
    Open = "OPEN"
}

export type ForgeAlertsUpdateRuleInput = {
    input: ForgeAlertsUpdateRuleInputType;
    ruleId: Scalars["ID"]["input"];
};

export type ForgeAlertsUpdateRuleInputType = {
    conditions?: InputMaybe<Array<ForgeAlertsRuleConditions>>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    filters?: InputMaybe<Array<ForgeAlertsRuleFilters>>;
    metric?: InputMaybe<ForgeAlertsRuleMetricType>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    period?: InputMaybe<Scalars["Int"]["input"]>;
    responders?: InputMaybe<Array<Scalars["String"]["input"]>>;
    runbook?: InputMaybe<Scalars["String"]["input"]>;
    tolerance?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ForgeAlertsUpdateRulePayload = Payload & {
    __typename?: "ForgeAlertsUpdateRulePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type ForgeAlertsUserInfo = {
    __typename?: "ForgeAlertsUserInfo";
    accountId: Scalars["String"]["output"];
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    isOwner?: Maybe<Scalars["Boolean"]["output"]>;
    publicName: Scalars["String"]["output"];
    status: Scalars["String"]["output"];
};

export type ForgeAuditLog = {
    __typename?: "ForgeAuditLog";
    action: ForgeAuditLogsActionType;
    actorId: Scalars["ID"]["output"];
    actorName: Scalars["String"]["output"];
    contributor?: Maybe<User>;
    role?: Maybe<Scalars["String"]["output"]>;
    timestamp: Scalars["String"]["output"];
};

export type ForgeAuditLogEdge = {
    __typename?: "ForgeAuditLogEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ForgeAuditLog>;
};

export enum ForgeAuditLogsActionType {
    ContributorAdded = "CONTRIBUTOR_ADDED",
    ContributorRemoved = "CONTRIBUTOR_REMOVED",
    ContributorRoleUpdated = "CONTRIBUTOR_ROLE_UPDATED",
    OwnershipTransferred = "OWNERSHIP_TRANSFERRED"
}

export type ForgeAuditLogsAppContributor = {
    __typename?: "ForgeAuditLogsAppContributor";
    contributor?: Maybe<User>;
};

export type ForgeAuditLogsAppContributorResult =
    | ForgeAuditLogsAppContributorsData
    | QueryError;

export type ForgeAuditLogsAppContributorsData = {
    __typename?: "ForgeAuditLogsAppContributorsData";
    appContributors?: Maybe<Array<Maybe<ForgeAuditLogsAppContributor>>>;
};

export type ForgeAuditLogsConnection = {
    __typename?: "ForgeAuditLogsConnection";
    edges: Array<ForgeAuditLogEdge>;
    nodes: Array<ForgeAuditLog>;
    pageInfo: PageInfo;
};

export type ForgeAuditLogsContributorActivity = {
    __typename?: "ForgeAuditLogsContributorActivity";
    accountId: Scalars["String"]["output"];
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    isOwner?: Maybe<Scalars["Boolean"]["output"]>;
    lastActive?: Maybe<Scalars["String"]["output"]>;
    publicName: Scalars["String"]["output"];
    roles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    status: Scalars["String"]["output"];
};

export type ForgeAuditLogsContributorsActivityData = {
    __typename?: "ForgeAuditLogsContributorsActivityData";
    contributors: Array<ForgeAuditLogsContributorActivity>;
};

export type ForgeAuditLogsContributorsActivityResult =
    | ForgeAuditLogsContributorsActivityData
    | QueryError;

export type ForgeAuditLogsDaResAppData = {
    __typename?: "ForgeAuditLogsDaResAppData";
    appId?: Maybe<Scalars["String"]["output"]>;
    appInstalledVersion?: Maybe<Scalars["String"]["output"]>;
    appName?: Maybe<Scalars["String"]["output"]>;
    cloudId?: Maybe<Scalars["String"]["output"]>;
    createdAt?: Maybe<Scalars["String"]["output"]>;
    destinationLocation?: Maybe<Scalars["String"]["output"]>;
    environment?: Maybe<Scalars["String"]["output"]>;
    environmentId?: Maybe<Scalars["String"]["output"]>;
    eventId?: Maybe<Scalars["String"]["output"]>;
    migrationStartTime?: Maybe<Scalars["String"]["output"]>;
    product?: Maybe<Scalars["String"]["output"]>;
    sourceLocation?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
};

export type ForgeAuditLogsDaResQueryInput = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type ForgeAuditLogsDaResResponse = {
    __typename?: "ForgeAuditLogsDaResResponse";
    data?: Maybe<Array<Maybe<ForgeAuditLogsDaResAppData>>>;
};

export type ForgeAuditLogsDaResResult =
    | ForgeAuditLogsDaResResponse
    | QueryError;

export type ForgeAuditLogsQuery = {
    __typename?: "ForgeAuditLogsQuery";
    appId: Scalars["ID"]["output"];
    auditLogs?: Maybe<ForgeAuditLogsResult>;
    contributors?: Maybe<ForgeAuditLogsAppContributorResult>;
    daResAuditLogs?: Maybe<ForgeAuditLogsDaResResult>;
};

export type ForgeAuditLogsQueryAuditLogsArgs = {
    input: ForgeAuditLogsQueryInput;
};

export type ForgeAuditLogsQueryDaResAuditLogsArgs = {
    input: ForgeAuditLogsDaResQueryInput;
};

export type ForgeAuditLogsQueryInput = {
    actions?: InputMaybe<Array<ForgeAuditLogsActionType>>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    contributorIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    startTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type ForgeAuditLogsResult = ForgeAuditLogsConnection | QueryError;

export type ForgeContextToken = {
    __typename?: "ForgeContextToken";
    /** Time when token will expire, given in number of milliseconds elapsed since the UNIX epoch */
    expiresAt: Scalars["String"]["output"];
    jwt: Scalars["String"]["output"];
};

export type ForgeMetricsApiRequestCountData = ForgeMetricsData & {
    __typename?: "ForgeMetricsApiRequestCountData";
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeMetricsResolution;
    series: Array<ForgeMetricsApiRequestCountSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsApiRequestCountDataPoint = {
    __typename?: "ForgeMetricsApiRequestCountDataPoint";
    count: Scalars["Int"]["output"];
    timestamp: Scalars["DateTime"]["output"];
};

export type ForgeMetricsApiRequestCountDrilldownData = ForgeMetricsData & {
    __typename?: "ForgeMetricsApiRequestCountDrilldownData";
    name: Scalars["String"]["output"];
    series: Array<ForgeMetricsApiRequestCountSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsApiRequestCountDrilldownResult =
    | ForgeMetricsApiRequestCountDrilldownData
    | QueryError;

export type ForgeMetricsApiRequestCountResult =
    | ForgeMetricsApiRequestCountData
    | QueryError;

export type ForgeMetricsApiRequestCountSeries = ForgeMetricsSeries & {
    __typename?: "ForgeMetricsApiRequestCountSeries";
    data: Array<ForgeMetricsApiRequestCountDataPoint>;
    groups: Array<ForgeMetricsLabelGroup>;
};

export enum ForgeMetricsApiRequestGroupByDimensions {
    ContextAri = "CONTEXT_ARI",
    Status = "STATUS",
    Url = "URL"
}

export type ForgeMetricsApiRequestLatencyData = ForgeMetricsData & {
    __typename?: "ForgeMetricsApiRequestLatencyData";
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeMetricsResolution;
    series: Array<ForgeMetricsApiRequestLatencySeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsApiRequestLatencyDataPoint = {
    __typename?: "ForgeMetricsApiRequestLatencyDataPoint";
    timestamp: Scalars["DateTime"]["output"];
    value: Scalars["String"]["output"];
};

export type ForgeMetricsApiRequestLatencyDrilldownData = ForgeMetricsData & {
    __typename?: "ForgeMetricsApiRequestLatencyDrilldownData";
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeMetricsResolution;
    series: Array<ForgeMetricsApiRequestLatencyDrilldownSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsApiRequestLatencyDrilldownResult =
    | ForgeMetricsApiRequestLatencyDrilldownData
    | QueryError;

export type ForgeMetricsApiRequestLatencyDrilldownSeries =
    ForgeMetricsSeries & {
        __typename?: "ForgeMetricsApiRequestLatencyDrilldownSeries";
        groups: Array<ForgeMetricsLabelGroup>;
        percentiles: Array<ForgeMetricsLatenciesPercentile>;
    };

export type ForgeMetricsApiRequestLatencyResult =
    | ForgeMetricsApiRequestLatencyData
    | QueryError;

export type ForgeMetricsApiRequestLatencySeries = ForgeMetricsSeries & {
    __typename?: "ForgeMetricsApiRequestLatencySeries";
    data: Array<ForgeMetricsApiRequestLatencyDataPoint>;
    groups: Array<ForgeMetricsLabelGroup>;
};

export type ForgeMetricsApiRequestLatencyValueData = {
    __typename?: "ForgeMetricsApiRequestLatencyValueData";
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    series: Array<ForgeMetricsApiRequestLatencyValueSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsApiRequestLatencyValueResult =
    | ForgeMetricsApiRequestLatencyValueData
    | QueryError;

export type ForgeMetricsApiRequestLatencyValueSeries = {
    __typename?: "ForgeMetricsApiRequestLatencyValueSeries";
    percentiles: Array<ForgeMetricsLatenciesPercentile>;
};

export type ForgeMetricsApiRequestQueryFilters = {
    apiRequestType?: InputMaybe<ForgeMetricsApiRequestType>;
    contextAris?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    environment: Scalars["ID"]["input"];
    interval: ForgeMetricsIntervalInput;
    status?: InputMaybe<ForgeMetricsApiRequestStatus>;
    urls?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ForgeMetricsApiRequestQueryInput = {
    filters: ForgeMetricsApiRequestQueryFilters;
    groupBy?: InputMaybe<Array<ForgeMetricsApiRequestGroupByDimensions>>;
};

export enum ForgeMetricsApiRequestStatus {
    "2Xx" = "_2XX",
    "4Xx" = "_4XX",
    "5Xx" = "_5XX"
}

export enum ForgeMetricsApiRequestType {
    Cache = "CACHE",
    External = "EXTERNAL",
    Product = "PRODUCT",
    Sql = "SQL"
}

export type ForgeMetricsChartInsightChoiceData = {
    __typename?: "ForgeMetricsChartInsightChoiceData";
    finishReason: Scalars["String"]["output"];
    index: Scalars["Int"]["output"];
    message: ForgeMetricsChartInsightChoiceMessageData;
};

export type ForgeMetricsChartInsightChoiceMessageData = {
    __typename?: "ForgeMetricsChartInsightChoiceMessageData";
    content: Scalars["String"]["output"];
    role: Scalars["String"]["output"];
};

export type ForgeMetricsChartInsightData = {
    __typename?: "ForgeMetricsChartInsightData";
    choices: Array<ForgeMetricsChartInsightChoiceData>;
    created: Scalars["Int"]["output"];
    id: Scalars["ID"]["output"];
    model: Scalars["String"]["output"];
    object: Scalars["String"]["output"];
    usage: ForgeMetricsChartInsightUsage;
};

export type ForgeMetricsChartInsightQueryInput = {
    apiRequestChartFilters?: InputMaybe<ForgeMetricsApiRequestQueryFilters>;
    apiRequestGroupBy?: InputMaybe<
        Array<ForgeMetricsApiRequestGroupByDimensions>
    >;
    chartName?: InputMaybe<ForgeMetricsChartName>;
    invocationChartFilters?: InputMaybe<ForgeMetricsQueryFilters>;
    invocationGroupBy?: InputMaybe<Array<ForgeMetricsGroupByDimensions>>;
    latencyBucketsChartFilters?: InputMaybe<ForgeMetricsLatencyBucketsQueryFilters>;
};

export type ForgeMetricsChartInsightResult =
    | ForgeMetricsChartInsightData
    | QueryError;

export type ForgeMetricsChartInsightUsage = {
    __typename?: "ForgeMetricsChartInsightUsage";
    completionTokens: Scalars["Int"]["output"];
    promptTokens: Scalars["Int"]["output"];
    totalTokens: Scalars["Int"]["output"];
};

export enum ForgeMetricsChartName {
    ApiRequestCount_2Xx = "API_REQUEST_COUNT_2XX",
    ApiRequestCount_4Xx = "API_REQUEST_COUNT_4XX",
    ApiRequestCount_5Xx = "API_REQUEST_COUNT_5XX",
    ApiRequestLatency = "API_REQUEST_LATENCY",
    InvocationCount = "INVOCATION_COUNT",
    InvocationError = "INVOCATION_ERROR",
    InvocationLatency = "INVOCATION_LATENCY",
    InvocationSuccessRate = "INVOCATION_SUCCESS_RATE"
}

export type ForgeMetricsCustomCreateQueryInput = {
    customMetricName: Scalars["String"]["input"];
    description: Scalars["String"]["input"];
};

export type ForgeMetricsCustomData = {
    __typename?: "ForgeMetricsCustomData";
    appId: Scalars["ID"]["output"];
    createdAt: Scalars["String"]["output"];
    createdBy?: Maybe<User>;
    creatorId: Scalars["String"]["output"];
    customMetricName: Scalars["String"]["output"];
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    type: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
};

export type ForgeMetricsCustomDeleteQueryInput = {
    nodeId: Scalars["ID"]["input"];
};

export enum ForgeMetricsCustomGroupByDimensions {
    CustomMetricName = "CUSTOM_METRIC_NAME"
}

export type ForgeMetricsCustomMetaData = {
    __typename?: "ForgeMetricsCustomMetaData";
    customMetricNames: Array<ForgeMetricsCustomData>;
};

export type ForgeMetricsCustomQueryFilters = {
    /**
     * List of appVersions to be filtered by.
     * E.g.: ["8.1.0", "2.7.0"]
     * If the appVersions is omitted or provided as an empty list, no filtering on app versions will be applied.
     */
    appVersions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * List of ARIs to filter metrics by
     * E.g.: ["ari:cloud:jira::site/{siteId}", ...]
     */
    contextAris?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    environment?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * List of function names to be filtered by.
     * E.g.: ["functionA", "functionB"]
     * If the functionNames is omitted or provided as an empty list, no filtering on function names will be applied.
     */
    functionNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    interval: ForgeMetricsIntervalInput;
};

export type ForgeMetricsCustomQueryInput = {
    filters: ForgeMetricsCustomQueryFilters;
    groupBy?: InputMaybe<Array<ForgeMetricsCustomGroupByDimensions>>;
};

export type ForgeMetricsCustomResult = ForgeMetricsCustomMetaData | QueryError;

export type ForgeMetricsCustomSuccessStatus = {
    __typename?: "ForgeMetricsCustomSuccessStatus";
    error?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type ForgeMetricsCustomUpdateQueryInput = {
    customMetricName?: InputMaybe<Scalars["String"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    nodeId: Scalars["ID"]["input"];
};

export type ForgeMetricsData = {
    name: Scalars["String"]["output"];
    series?: Maybe<Array<ForgeMetricsSeries>>;
    type: ForgeMetricsDataType;
};

export enum ForgeMetricsDataType {
    Category = "CATEGORY",
    DateTime = "DATE_TIME",
    Numeric = "NUMERIC"
}

export type ForgeMetricsErrorsData = ForgeMetricsData & {
    __typename?: "ForgeMetricsErrorsData";
    /** The actual query interval used to fetch data */
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeMetricsResolution;
    series: Array<ForgeMetricsErrorsSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsErrorsDataPoint = {
    __typename?: "ForgeMetricsErrorsDataPoint";
    count: Scalars["Int"]["output"];
    timestamp: Scalars["DateTime"]["output"];
};

export type ForgeMetricsErrorsResult = ForgeMetricsErrorsData | QueryError;

export type ForgeMetricsErrorsSeries = ForgeMetricsSeries & {
    __typename?: "ForgeMetricsErrorsSeries";
    data: Array<ForgeMetricsErrorsDataPoint>;
    groups: Array<ForgeMetricsLabelGroup>;
};

export type ForgeMetricsErrorsValueData = ForgeMetricsData & {
    __typename?: "ForgeMetricsErrorsValueData";
    name: Scalars["String"]["output"];
    series: Array<ForgeMetricsErrorsSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsErrorsValueResult =
    | ForgeMetricsErrorsValueData
    | QueryError;

export enum ForgeMetricsGroupByDimensions {
    ContextAri = "CONTEXT_ARI",
    EnvironmentId = "ENVIRONMENT_ID",
    ErrorType = "ERROR_TYPE",
    Function = "FUNCTION",
    UserTier = "USER_TIER",
    Version = "VERSION"
}

export type ForgeMetricsInstallationContext = {
    __typename?: "ForgeMetricsInstallationContext";
    contextAri: Scalars["ID"]["output"];
    /** The batch size can only be a maximum can 20. Do not change it to any higher. */
    tenantContext?: Maybe<TenantContext>;
};

export type ForgeMetricsIntervalInput = {
    end: Scalars["DateTime"]["input"];
    /** "start" and "end" are ISO-8601 formatted timestamps */
    start: Scalars["DateTime"]["input"];
};

export type ForgeMetricsIntervalRange = {
    __typename?: "ForgeMetricsIntervalRange";
    end: Scalars["DateTime"]["output"];
    start: Scalars["DateTime"]["output"];
};

export type ForgeMetricsInvocationData = ForgeMetricsData & {
    __typename?: "ForgeMetricsInvocationData";
    /** The actual query interval used to fetch data */
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeMetricsResolution;
    series: Array<ForgeMetricsInvocationSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsInvocationDataPoint = {
    __typename?: "ForgeMetricsInvocationDataPoint";
    count: Scalars["Int"]["output"];
    timestamp: Scalars["DateTime"]["output"];
};

export type ForgeMetricsInvocationSeries = ForgeMetricsSeries & {
    __typename?: "ForgeMetricsInvocationSeries";
    data: Array<ForgeMetricsInvocationDataPoint>;
    groups: Array<ForgeMetricsLabelGroup>;
};

export type ForgeMetricsInvocationsResult =
    | ForgeMetricsInvocationData
    | QueryError;

export type ForgeMetricsInvocationsValueData = ForgeMetricsData & {
    __typename?: "ForgeMetricsInvocationsValueData";
    name: Scalars["String"]["output"];
    series: Array<ForgeMetricsInvocationSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsInvocationsValueResult =
    | ForgeMetricsInvocationsValueData
    | QueryError;

export type ForgeMetricsLabelGroup = {
    __typename?: "ForgeMetricsLabelGroup";
    key: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export enum ForgeMetricsLabels {
    ForgeApiRequestCount = "FORGE_API_REQUEST_COUNT",
    ForgeApiRequestLatency = "FORGE_API_REQUEST_LATENCY",
    ForgeBackendInvocationCount = "FORGE_BACKEND_INVOCATION_COUNT",
    ForgeBackendInvocationErrors = "FORGE_BACKEND_INVOCATION_ERRORS",
    ForgeBackendInvocationLatency = "FORGE_BACKEND_INVOCATION_LATENCY"
}

export type ForgeMetricsLatenciesData = ForgeMetricsData & {
    __typename?: "ForgeMetricsLatenciesData";
    /** The actual query interval used to fetch data */
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    series: Array<ForgeMetricsLatenciesSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsLatenciesDataPoint = {
    __typename?: "ForgeMetricsLatenciesDataPoint";
    bucket: Scalars["String"]["output"];
    count: Scalars["Int"]["output"];
};

export type ForgeMetricsLatenciesPercentile = {
    __typename?: "ForgeMetricsLatenciesPercentile";
    percentile: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type ForgeMetricsLatenciesResult =
    | ForgeMetricsLatenciesData
    | QueryError;

export type ForgeMetricsLatenciesSeries = ForgeMetricsSeries & {
    __typename?: "ForgeMetricsLatenciesSeries";
    data: Array<ForgeMetricsLatenciesDataPoint>;
    groups: Array<ForgeMetricsLabelGroup>;
    percentiles?: Maybe<Array<ForgeMetricsLatenciesPercentile>>;
};

export type ForgeMetricsLatencyBucketsQueryFilters = {
    /**
     * List of ARIs to filter metrics by
     * E.g.: ["ari:cloud:jira::site/{siteId}", ...]
     */
    contextAris?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    environment?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * List of function names to be filtered by.
     * E.g.: ["functionA", "functionB"]
     * If the functionNames is omitted or provided as an empty list, no filtering on function names will be applied.
     */
    functionNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    interval: ForgeMetricsIntervalInput;
};

export type ForgeMetricsLatencyBucketsQueryInput = {
    filters: ForgeMetricsLatencyBucketsQueryFilters;
    groupBy?: InputMaybe<Array<ForgeMetricsGroupByDimensions>>;
};

export type ForgeMetricsMutation = {
    __typename?: "ForgeMetricsMutation";
    appId: Scalars["ID"]["output"];
    createCustomMetric: ForgeMetricsCustomSuccessStatus;
    deleteCustomMetric: ForgeMetricsCustomSuccessStatus;
    updateCustomMetric: ForgeMetricsCustomSuccessStatus;
};

export type ForgeMetricsMutationCreateCustomMetricArgs = {
    query: ForgeMetricsCustomCreateQueryInput;
};

export type ForgeMetricsMutationDeleteCustomMetricArgs = {
    query: ForgeMetricsCustomDeleteQueryInput;
};

export type ForgeMetricsMutationUpdateCustomMetricArgs = {
    query: ForgeMetricsCustomUpdateQueryInput;
};

export type ForgeMetricsOtlpData = {
    __typename?: "ForgeMetricsOtlpData";
    resourceMetrics: Scalars["JSON"]["output"];
};

export type ForgeMetricsOtlpQueryFilters = {
    environments: Array<Scalars["ID"]["input"]>;
    interval: ForgeMetricsIntervalInput;
    metrics: Array<ForgeMetricsLabels>;
};

export type ForgeMetricsOtlpQueryInput = {
    filters: ForgeMetricsOtlpQueryFilters;
};

export type ForgeMetricsOtlpResult = ForgeMetricsOtlpData | QueryError;

export type ForgeMetricsQuery = {
    __typename?: "ForgeMetricsQuery";
    apiRequestCount: ForgeMetricsApiRequestCountResult;
    apiRequestCountDrilldown: ForgeMetricsApiRequestCountDrilldownResult;
    apiRequestLatency: ForgeMetricsApiRequestLatencyResult;
    apiRequestLatencyDrilldown: ForgeMetricsApiRequestLatencyDrilldownResult;
    apiRequestLatencyValue: ForgeMetricsApiRequestLatencyValueResult;
    appId: Scalars["ID"]["output"];
    appMetrics: ForgeMetricsOtlpResult;
    cacheHitRate: ForgeMetricsSuccessRateResult;
    chartInsight: ForgeMetricsChartInsightResult;
    customMetrics: ForgeMetricsInvocationsResult;
    customMetricsMetaData: ForgeMetricsCustomResult;
    errors: ForgeMetricsErrorsResult;
    errorsValue: ForgeMetricsErrorsValueResult;
    invocations: ForgeMetricsInvocationsResult;
    invocationsValue: ForgeMetricsInvocationsValueResult;
    latencies: ForgeMetricsLatenciesResult;
    latencyBuckets: ForgeMetricsLatenciesResult;
    requestUrls: ForgeMetricsRequestUrlsResult;
    sites: ForgeMetricsSitesResult;
    successRate: ForgeMetricsSuccessRateResult;
    successRateValue: ForgeMetricsSuccessRateValueResult;
};

export type ForgeMetricsQueryApiRequestCountArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQueryApiRequestCountDrilldownArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQueryApiRequestLatencyArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQueryApiRequestLatencyDrilldownArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQueryApiRequestLatencyValueArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQueryAppMetricsArgs = {
    query: ForgeMetricsOtlpQueryInput;
};

export type ForgeMetricsQueryCacheHitRateArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQueryChartInsightArgs = {
    query: ForgeMetricsChartInsightQueryInput;
};

export type ForgeMetricsQueryCustomMetricsArgs = {
    query: ForgeMetricsCustomQueryInput;
};

export type ForgeMetricsQueryErrorsArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQueryErrorsValueArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQueryInvocationsArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQueryInvocationsValueArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQueryLatenciesArgs = {
    percentiles?: InputMaybe<Array<Scalars["Float"]["input"]>>;
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQueryLatencyBucketsArgs = {
    percentiles?: InputMaybe<Array<Scalars["Float"]["input"]>>;
    query: ForgeMetricsLatencyBucketsQueryInput;
};

export type ForgeMetricsQueryRequestUrlsArgs = {
    query: ForgeMetricsApiRequestQueryInput;
};

export type ForgeMetricsQuerySitesArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQuerySuccessRateArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQuerySuccessRateValueArgs = {
    query: ForgeMetricsQueryInput;
};

export type ForgeMetricsQueryFilters = {
    /**
     * List of ARIs to filter metrics by
     * E.g.: ["ari:cloud:jira::site/{siteId}", ...]
     */
    contextAris?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    environment?: InputMaybe<Scalars["ID"]["input"]>;
    interval: ForgeMetricsIntervalInput;
};

export type ForgeMetricsQueryInput = {
    filters: ForgeMetricsQueryFilters;
    groupBy?: InputMaybe<Array<ForgeMetricsGroupByDimensions>>;
};

export type ForgeMetricsRequestUrlsData = {
    __typename?: "ForgeMetricsRequestUrlsData";
    data: Array<Scalars["String"]["output"]>;
};

export type ForgeMetricsRequestUrlsResult =
    | ForgeMetricsRequestUrlsData
    | QueryError;

export type ForgeMetricsResolution = {
    __typename?: "ForgeMetricsResolution";
    size: Scalars["Int"]["output"];
    units: ForgeMetricsResolutionUnit;
};

export enum ForgeMetricsResolutionUnit {
    Hours = "HOURS",
    Minutes = "MINUTES"
}

export type ForgeMetricsSeries = {
    groups: Array<ForgeMetricsLabelGroup>;
};

export enum ForgeMetricsSiteFilterCategory {
    All = "ALL",
    HighestInvocationCount = "HIGHEST_INVOCATION_COUNT",
    HighestNumberOfErrors = "HIGHEST_NUMBER_OF_ERRORS",
    HighestNumberOfUsers = "HIGHEST_NUMBER_OF_USERS",
    LowestSuccessRate = "LOWEST_SUCCESS_RATE"
}

export type ForgeMetricsSitesByCategory = {
    __typename?: "ForgeMetricsSitesByCategory";
    category: ForgeMetricsSiteFilterCategory;
    installationContexts: Array<ForgeMetricsInstallationContext>;
};

export type ForgeMetricsSitesData = {
    __typename?: "ForgeMetricsSitesData";
    data: Array<ForgeMetricsSitesByCategory>;
};

export type ForgeMetricsSitesResult = ForgeMetricsSitesData | QueryError;

export type ForgeMetricsSuccessRateData = ForgeMetricsData & {
    __typename?: "ForgeMetricsSuccessRateData";
    /** The actual query interval used to fetch data */
    interval: ForgeMetricsIntervalRange;
    name: Scalars["String"]["output"];
    resolution: ForgeMetricsResolution;
    series: Array<ForgeMetricsSuccessRateSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsSuccessRateDataPoint = {
    __typename?: "ForgeMetricsSuccessRateDataPoint";
    timestamp: Scalars["DateTime"]["output"];
    value: Scalars["Float"]["output"];
};

export type ForgeMetricsSuccessRateResult =
    | ForgeMetricsSuccessRateData
    | QueryError;

export type ForgeMetricsSuccessRateSeries = ForgeMetricsSeries & {
    __typename?: "ForgeMetricsSuccessRateSeries";
    data: Array<ForgeMetricsSuccessRateDataPoint>;
    groups: Array<ForgeMetricsLabelGroup>;
};

export type ForgeMetricsSuccessRateValueData = ForgeMetricsData & {
    __typename?: "ForgeMetricsSuccessRateValueData";
    name: Scalars["String"]["output"];
    series: Array<ForgeMetricsSuccessRateSeries>;
    type: ForgeMetricsDataType;
};

export type ForgeMetricsSuccessRateValueResult =
    | ForgeMetricsSuccessRateValueData
    | QueryError;

export enum FormStatus {
    Approved = "APPROVED",
    Rejected = "REJECTED",
    Saved = "SAVED",
    Submitted = "SUBMITTED"
}

export type FormattedBody = {
    __typename?: "FormattedBody";
    embeddedContent: Array<Maybe<EmbeddedContent>>;
    links?: Maybe<LinksContextBase>;
    macroRenderedOutput?: Maybe<FormattedBody>;
    macroRenderedRepresentation?: Maybe<Scalars["String"]["output"]>;
    representation?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
    webresource?: Maybe<WebResourceDependencies>;
};

export type FortifiedMetricsIntervalInput = {
    /** The end of the interval. Inclusive. */
    end: Scalars["DateTime"]["input"];
    /** The start of the interval. Inclusive. */
    start: Scalars["DateTime"]["input"];
};

export type FortifiedMetricsIntervalRange = {
    __typename?: "FortifiedMetricsIntervalRange";
    /** The end of the interval. Inclusive. */
    end: Scalars["DateTime"]["output"];
    /** The start of the interval. Inclusive. */
    start: Scalars["DateTime"]["output"];
};

export type FortifiedMetricsQuery = {
    __typename?: "FortifiedMetricsQuery";
    /** App Availability metrics. */
    appAvailability?: Maybe<FortifiedSuccessRateMetricQuery>;
    /** The app key to return metrics for. */
    appKey: Scalars["ID"]["output"];
    /** Installation Callback Reliability metrics. */
    installationCallbacks?: Maybe<FortifiedSuccessRateMetricQuery>;
    /** Webhook Reliability metrics. */
    webhooks?: Maybe<FortifiedSuccessRateMetricQuery>;
};

export type FortifiedMetricsQueryFilters = {
    /** The interval to query metrics for. */
    interval: FortifiedMetricsIntervalInput;
};

export type FortifiedMetricsQueryInput = {
    filters: FortifiedMetricsQueryFilters;
};

export type FortifiedMetricsResolution = {
    __typename?: "FortifiedMetricsResolution";
    /** The resolution period size. */
    size: Scalars["Int"]["output"];
    /** The resolution period unit. */
    units: FortifiedMetricsResolutionUnit;
};

export enum FortifiedMetricsResolutionUnit {
    Hours = "HOURS",
    Minutes = "MINUTES"
}

export type FortifiedMetricsSuccessRateData = {
    __typename?: "FortifiedMetricsSuccessRateData";
    /** The time period of the data series. */
    interval: FortifiedMetricsIntervalRange;
    /** The name of the metric. */
    name: Scalars["String"]["output"];
    /** The resolution of the data series. */
    resolution: FortifiedMetricsResolution;
    /** The data series for the metric. */
    series: Array<FortifiedMetricsSuccessRateSeries>;
};

export type FortifiedMetricsSuccessRateDataPoint = {
    __typename?: "FortifiedMetricsSuccessRateDataPoint";
    /** The timestamp of the data point. */
    timestamp: Scalars["DateTime"]["output"];
    /** The value of the data point. */
    value: Scalars["Float"]["output"];
};

export type FortifiedMetricsSuccessRateResult =
    | FortifiedMetricsSuccessRateData
    | QueryError;

export type FortifiedMetricsSuccessRateSeries = {
    __typename?: "FortifiedMetricsSuccessRateSeries";
    data: Array<FortifiedMetricsSuccessRateDataPoint>;
};

export type FortifiedSuccessRateMetricQuery = {
    __typename?: "FortifiedSuccessRateMetricQuery";
    /** Alert Condition metrics. */
    alertConditionSuccessRate?: Maybe<FortifiedMetricsSuccessRateResult>;
    /** SLO metrics. */
    serviceLevelObjectiveSuccessRate?: Maybe<FortifiedMetricsSuccessRateResult>;
    /** Success Rate metrics. */
    successRate?: Maybe<FortifiedMetricsSuccessRateResult>;
};

export type FortifiedSuccessRateMetricQueryAlertConditionSuccessRateArgs = {
    query: FortifiedMetricsQueryInput;
};

export type FortifiedSuccessRateMetricQueryServiceLevelObjectiveSuccessRateArgs =
    {
        query: FortifiedMetricsQueryInput;
    };

export type FortifiedSuccessRateMetricQuerySuccessRateArgs = {
    query: FortifiedMetricsQueryInput;
};

export type FrontCover = {
    __typename?: "FrontCover";
    frontCoverState?: Maybe<Scalars["String"]["output"]>;
    showFrontCover: Scalars["Boolean"]["output"];
};

export type FrontendResource = {
    __typename?: "FrontendResource";
    attributes: Array<Maybe<MapOfStringToString>>;
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type FrontendResourceRenderResponse = {
    __typename?: "FrontendResourceRenderResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceList: Array<FrontendResource>;
};

export type FunctionDescription = {
    __typename?: "FunctionDescription";
    key: Scalars["String"]["output"];
};

/** The data describing a function invocation. */
export type FunctionInvocationMetadata = {
    appVersion: Scalars["String"]["output"];
    /** Metadata about the function of the app that was called */
    function?: Maybe<FunctionDescription>;
    /** The invocation ID */
    id: Scalars["ID"]["output"];
    /** The context in which the app is installed */
    installationContext?: Maybe<AppInstallationContext>;
    /** Metadata about module type */
    moduleType?: Maybe<Scalars["String"]["output"]>;
    /** Metadata about what caused the function to run */
    trigger?: Maybe<FunctionTrigger>;
};

export type FunctionTrigger = {
    __typename?: "FunctionTrigger";
    key?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<FunctionTriggerType>;
};

/** Which type of trigger */
export enum FunctionTriggerType {
    Frontend = "FRONTEND",
    Manual = "MANUAL",
    Product = "PRODUCT",
    Web = "WEB"
}

export type FutureContentTypeMobileSupport = {
    __typename?: "FutureContentTypeMobileSupport";
    /**
     * Localized body text
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    bodyText?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     * Content type name, e.g., whiteboard
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentType: Scalars["String"]["output"];
    /**
     * Localized heading
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    heading: Scalars["String"]["output"];
    /**
     * A link to the image, e.g., /sample/whiteboards.png
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    imageLink?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the content type is supported now by the latest mobile app of the specified platform
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSupportedNow: Scalars["Boolean"]["output"];
};

export type GdprDetails = {
    __typename?: "GDPRDetails";
    dataController?: Maybe<DataController>;
    dataProcessor?: Maybe<DataProcessor>;
    dataTransfer?: Maybe<DataTransfer>;
};

/** Concrete version of MutationErrorExtension that does not include any extra fields */
export type GenericMutationErrorExtension = MutationErrorExtension & {
    __typename?: "GenericMutationErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Generic implementation of MutationResponse for responses that don't need any extra data */
export type GenericMutationResponse = Payload & {
    __typename?: "GenericMutationResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Concrete version of QueryErrorExtension that does not include any extra fields */
export type GenericQueryErrorExtension = QueryErrorExtension & {
    __typename?: "GenericQueryErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Card Creation fields.
 * Only getting used by "jsw-adapted-issue-create-trigger" package
 */
export type GlobalCardCreateAdditionalFields = {
    __typename?: "GlobalCardCreateAdditionalFields";
    /** Required when creating issues on a kanban board with backlog enabled. Will be null if the backlog is disabled. */
    boardIssueListKey?: Maybe<Scalars["String"]["output"]>;
    /** Rank Custom ID currently needed to support GIC trigger through Board And Backlog ICC */
    rankCustomFieldId?: Maybe<Scalars["String"]["output"]>;
    /** Sprint Custom ID currently needed to support GIC trigger through Board And Backlog ICC */
    sprintCustomFieldId?: Maybe<Scalars["String"]["output"]>;
};

export type GlobalInstallationConfigFilter = {
    keys: Array<EcosystemGlobalInstallationOverrideKeys>;
};

export type GlobalSpaceConfiguration = {
    __typename?: "GlobalSpaceConfiguration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkDefaultSpaceStatus?: Maybe<PublicLinkDefaultSpaceStatus>;
};

export type GlobalSpaceIdentifier = {
    __typename?: "GlobalSpaceIdentifier";
    spaceIdentifier?: Maybe<Scalars["String"]["output"]>;
};

export enum GrantCheckProduct {
    Compass = "COMPASS",
    Confluence = "CONFLUENCE",
    Jira = "JIRA",
    JiraServicedesk = "JIRA_SERVICEDESK",
    Mercury = "MERCURY",
    /** Don't check whether a user has been granted access to a specific site(cloudId) */
    NoGrantChecks = "NO_GRANT_CHECKS",
    Townsquare = "TOWNSQUARE"
}

export type GrantContentAccessInput = {
    accessType: AccessType;
    accountIdOrUsername: Scalars["String"]["input"];
    contentId: Scalars["String"]["input"];
};

export type GrantContentAccessPayload = {
    __typename?: "GrantContentAccessPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type Graph = {
    __typename?: "Graph";
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    fetchAllRelationships?: Maybe<GraphSimpleRelationshipConnection>;
    incidentAssociatedPostIncidentReview?: Maybe<GraphJiraIssueConnection>;
    incidentAssociatedPostIncidentReviewInverse?: Maybe<GraphJiraIssueConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLinkRelationship?: Maybe<GraphIncidentAssociatedPostIncidentReviewLinkRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkRelationshipBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLinkRelationshipBatch?: Maybe<
        Array<
            Maybe<GraphIncidentAssociatedPostIncidentReviewLinkRelationshipConnection>
        >
    >;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkRelationshipInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLinkRelationshipInverse?: Maybe<GraphIncidentAssociatedPostIncidentReviewLinkRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIncidentHasActionItem")' query directive to the 'incidentHasActionItemRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItemRelationship?: Maybe<GraphIncidentHasActionItemRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIncidentHasActionItem")' query directive to the 'incidentHasActionItemRelationshipBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItemRelationshipBatch?: Maybe<
        Array<Maybe<GraphIncidentHasActionItemRelationshipConnection>>
    >;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIncidentHasActionItem")' query directive to the 'incidentHasActionItemRelationshipInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItemRelationshipInverse?: Maybe<GraphIncidentHasActionItemRelationshipConnection>;
    incidentLinkedJswIssueRelationshipBatch?: Maybe<
        Array<Maybe<GraphIncidentLinkedJswIssueRelationshipConnection>>
    >;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:design:jira__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIssueAssociatedDesign")' query directive to the 'issueAssociatedDesign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDesign?: Maybe<GraphJiraDesignConnection>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:design:jira__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIssueAssociatedDesign")' query directive to the 'issueAssociatedDesignInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDesignInverse?: Maybe<GraphJiraIssueConnection>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:design:jira__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIssueAssociatedDesign")' query directive to the 'issueAssociatedDesignRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDesignRelationship?: Maybe<GraphIssueAssociatedDesignRelationshipConnection>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:design:jira__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphIssueAssociatedDesign")' query directive to the 'issueAssociatedDesignRelationshipInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDesignRelationshipInverse?: Maybe<GraphIssueAssociatedDesignRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    issueAssociatedPr?: Maybe<GraphJiraPullRequestConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    issueAssociatedPrInverse?: Maybe<GraphJiraIssueConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    issueAssociatedPrRelationship?: Maybe<GraphIssueAssociatedPrRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    issueAssociatedPrRelationshipInverse?: Maybe<GraphIssueAssociatedPrRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jswProjectAssociatedComponent?: Maybe<GraphGenericConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jswProjectSharesComponentWithJsmProject?: Maybe<GraphJiraProjectConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    parentDocumentHasChildDocument?: Maybe<GraphJiraDocumentConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    parentDocumentHasChildDocumentInverse?: Maybe<GraphJiraDocumentConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    parentDocumentHasChildDocumentRelationship?: Maybe<GraphParentDocumentHasChildDocumentRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    parentDocumentHasChildDocumentRelationshipInverse?: Maybe<GraphParentDocumentHasChildDocumentRelationshipConnection>;
    projectAssociatedBuild?: Maybe<GraphJiraBuildConnection>;
    projectAssociatedBuildInverse?: Maybe<GraphJiraProjectConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedBuildRelationship?: Maybe<GraphProjectAssociatedBuildRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedBuildRelationshipInverse?: Maybe<GraphProjectAssociatedBuildRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedDeployment?: Maybe<GraphJiraDeploymentConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedDeploymentInverse?: Maybe<GraphJiraProjectConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedDeploymentRelationship?: Maybe<GraphProjectAssociatedDeploymentRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedDeploymentRelationshipInverse?: Maybe<GraphProjectAssociatedDeploymentRelationshipConnection>;
    projectAssociatedIncident?: Maybe<GraphJiraIssueConnection>;
    projectAssociatedIncidentInverse?: Maybe<GraphJiraProjectConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedPr?: Maybe<GraphJiraPullRequestConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedPrInverse?: Maybe<GraphJiraProjectConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedPrRelationship?: Maybe<GraphProjectAssociatedPrRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedPrRelationshipInverse?: Maybe<GraphProjectAssociatedPrRelationshipConnection>;
    projectAssociatedService?: Maybe<GraphProjectServiceConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedVulnerability?: Maybe<GraphJiraVulnerabilityConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedVulnerabilityInverse?: Maybe<GraphJiraProjectConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedVulnerabilityRelationship?: Maybe<GraphProjectAssociatedVulnerabilityRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    projectAssociatedVulnerabilityRelationshipInverse?: Maybe<GraphProjectAssociatedVulnerabilityRelationshipConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphProjectHasIssue")' query directive to the 'projectHasIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasIssueRelationship?: Maybe<GraphProjectHasIssueRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerabilityRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    securityContainerAssociatedToVulnerabilityRelationship?: Maybe<GraphSecurityContainerAssociatedToVulnerabilityRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerabilityRelationshipBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    securityContainerAssociatedToVulnerabilityRelationshipBatch?: Maybe<
        Array<
            Maybe<GraphSecurityContainerAssociatedToVulnerabilityRelationshipConnection>
        >
    >;
    serviceLinkedIncident?: Maybe<GraphJiraIssueConnection>;
    serviceLinkedIncidentInverse?: Maybe<GraphProjectServiceConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedBuild?: Maybe<GraphJiraBuildConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedBuildInverse?: Maybe<GraphJiraSprintConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedBuildRelationship?: Maybe<GraphSprintAssociatedBuildRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedBuildRelationshipInverse?: Maybe<GraphSprintAssociatedBuildRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedDeployment?: Maybe<GraphJiraDeploymentConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedDeploymentInverse?: Maybe<GraphJiraSprintConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedDeploymentRelationship?: Maybe<GraphSprintAssociatedDeploymentRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedDeploymentRelationshipInverse?: Maybe<GraphSprintAssociatedDeploymentRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedPr?: Maybe<GraphJiraPullRequestConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedPrInverse?: Maybe<GraphJiraSprintConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedPrRelationship?: Maybe<GraphSprintAssociatedPrRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedPrRelationshipInverse?: Maybe<GraphSprintAssociatedPrRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedVulnerability?: Maybe<GraphJiraVulnerabilityConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedVulnerabilityInverse?: Maybe<GraphJiraSprintConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedVulnerabilityRelationship?: Maybe<GraphSprintAssociatedVulnerabilityRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintAssociatedVulnerabilityRelationshipInverse?: Maybe<GraphSprintAssociatedVulnerabilityRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintContainsIssue?: Maybe<GraphJiraIssueConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintContainsIssueInverse?: Maybe<GraphJiraSprintConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintContainsIssueRelationship?: Maybe<GraphSprintContainsIssueRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintContainsIssueRelationshipInverse?: Maybe<GraphSprintContainsIssueRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintRetrospectivePage?: Maybe<GraphConfluencePageConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintRetrospectivePageInverse?: Maybe<GraphJiraSprintConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintRetrospectivePageRelationship?: Maybe<GraphSprintRetrospectivePageRelationshipConnection>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sprintRetrospectivePageRelationshipInverse?: Maybe<GraphSprintRetrospectivePageRelationshipConnection>;
};

export type GraphFetchAllRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
    ignoredRelationshipTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    updatedFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
    updatedTo?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphIncidentAssociatedPostIncidentReviewArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIncidentAssociatedPostIncidentReviewInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphIncidentAssociatedPostIncidentReviewLinkRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIncidentAssociatedPostIncidentReviewLinkRelationshipBatchArgs =
    {
        from: Array<Scalars["ID"]["input"]>;
    };

export type GraphIncidentAssociatedPostIncidentReviewLinkRelationshipInverseArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        to: Scalars["ID"]["input"];
    };

export type GraphIncidentHasActionItemRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIncidentHasActionItemRelationshipBatchArgs = {
    from: Array<Scalars["ID"]["input"]>;
};

export type GraphIncidentHasActionItemRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphIncidentLinkedJswIssueRelationshipBatchArgs = {
    from: Array<Scalars["ID"]["input"]>;
};

export type GraphIssueAssociatedDesignArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedDesignInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedDesignRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedDesignRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphIssueAssociatedPrRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphJswProjectAssociatedComponentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphJswProjectSharesComponentWithJsmProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphParentDocumentHasChildDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphParentDocumentHasChildDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphParentDocumentHasChildDocumentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphParentDocumentHasChildDocumentRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedBuildArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedBuildInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedBuildRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedBuildRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedDeploymentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedDeploymentRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedPrRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedServiceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedVulnerabilityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedVulnerabilityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedVulnerabilityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphProjectAssociatedVulnerabilityRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphProjectHasIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectHasIssueInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSecurityContainerAssociatedToVulnerabilityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSecurityContainerAssociatedToVulnerabilityRelationshipBatchArgs =
    {
        from: Array<Scalars["ID"]["input"]>;
    };

export type GraphServiceLinkedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphServiceLinkedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedBuildArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedBuildInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedBuildRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedBuildRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedDeploymentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedDeploymentRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedPrRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedVulnerabilityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedVulnerabilityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedVulnerabilityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintAssociatedVulnerabilityRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintContainsIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintContainsIssueInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintContainsIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintContainsIssueInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintContainsIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintContainsIssueInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintContainsIssueRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataSprintContainsIssueInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintRetrospectivePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintRetrospectivePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

export type GraphSprintRetrospectivePageRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    from: Scalars["ID"]["input"];
};

export type GraphSprintRetrospectivePageRelationshipInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    to: Scalars["ID"]["input"];
};

/** Represents an ati:cloud:confluence:page. Returned by relationship queries */
export type GraphConfluencePage = Node & {
    __typename?: "GraphConfluencePage";
    id: Scalars["ID"]["output"];
    page?: Maybe<ConfluencePage>;
};

export type GraphConfluencePageConnection = {
    __typename?: "GraphConfluencePageConnection";
    edges: Array<Maybe<GraphConfluencePageEdge>>;
    pageInfo: PageInfo;
};

export type GraphConfluencePageEdge = {
    __typename?: "GraphConfluencePageEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphConfluencePage;
};

export type GraphCreateIncidentAssociatedPostIncidentReviewLinkInput = {
    /** An ARI of any of the following: [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of any of the following: [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link] */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateIncidentHasActionItemInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateIncidentLinkedJswIssueInput = {
    /** An ARI of any of the following: [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateIssueAssociatedDesignInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:design */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateIssueAssociatedPrInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:pull-request */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateMetadataProjectAssociatedBuildJiraBuildOutput = {
    __typename?: "GraphCreateMetadataProjectAssociatedBuildJiraBuildOutput";
    state?: Maybe<GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum>;
    testInfo?: Maybe<GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputTestInfo>;
};

export enum GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputTestInfo = {
    __typename?: "GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputTestInfo";
    numberFailed?: Maybe<Scalars["Long"]["output"]>;
    numberPassed?: Maybe<Scalars["Long"]["output"]>;
    numberSkipped?: Maybe<Scalars["Long"]["output"]>;
    totalNumber?: Maybe<Scalars["Long"]["output"]>;
};

export type GraphCreateMetadataProjectAssociatedBuildOutput = {
    __typename?: "GraphCreateMetadataProjectAssociatedBuildOutput";
    assigneeAri?: Maybe<GraphCreateMetadataProjectAssociatedBuildOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataProjectAssociatedBuildOutputAri>;
    issueAri?: Maybe<GraphCreateMetadataProjectAssociatedBuildOutputAri>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<GraphCreateMetadataProjectAssociatedBuildOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataProjectAssociatedBuildOutputAri>;
};

export type GraphCreateMetadataProjectAssociatedBuildOutputAri = {
    __typename?: "GraphCreateMetadataProjectAssociatedBuildOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutput =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutput";
        author?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputAuthor>;
        environmentType?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum>;
        state?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum>;
    };

export type GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputAuthor =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputAuthor";
        authorAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputAuthorAri>;
    };

export type GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputAuthorAri =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputAuthorAri";
        value?: Maybe<Scalars["String"]["output"]>;
    };

export enum GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export enum GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type GraphCreateMetadataProjectAssociatedDeploymentOutput = {
    __typename?: "GraphCreateMetadataProjectAssociatedDeploymentOutput";
    assigneeAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutputAri>;
    fixVersionIds?: Maybe<Array<Maybe<Scalars["Long"]["output"]>>>;
    issueAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutputAri>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    issueTypeAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutputAri>;
    reporterAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutputAri>;
};

export type GraphCreateMetadataProjectAssociatedDeploymentOutputAri = {
    __typename?: "GraphCreateMetadataProjectAssociatedDeploymentOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutput = {
    __typename?: "GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutput";
    author?: Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputAuthor>;
    reviewers?: Maybe<
        Array<
            Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewer>
        >
    >;
    status?: Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum>;
    taskCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputAuthor =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputAuthor";
        authorAri?: Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputAuthorAri>;
    };

export type GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputAuthorAri =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputAuthorAri";
        value?: Maybe<Scalars["String"]["output"]>;
    };

export enum GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewer =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewer";
        approvalStatus?: Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum>;
        reviewerAri?: Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerAri>;
    };

export type GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerAri =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerAri";
        value?: Maybe<Scalars["String"]["output"]>;
    };

export enum GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphCreateMetadataProjectAssociatedPrOutput = {
    __typename?: "GraphCreateMetadataProjectAssociatedPrOutput";
    assigneeAri?: Maybe<GraphCreateMetadataProjectAssociatedPrOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataProjectAssociatedPrOutputAri>;
    issueAri?: Maybe<GraphCreateMetadataProjectAssociatedPrOutputAri>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<GraphCreateMetadataProjectAssociatedPrOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataProjectAssociatedPrOutputAri>;
};

export type GraphCreateMetadataProjectAssociatedPrOutputAri = {
    __typename?: "GraphCreateMetadataProjectAssociatedPrOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutput =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutput";
        container?: Maybe<GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputContainer>;
        severity?: Maybe<GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum>;
        status?: Maybe<GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum>;
        type?: Maybe<GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum>;
    };

export type GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputContainer =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputContainer";
        containerAri?: Maybe<GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputContainerAri>;
    };

export type GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputContainerAri =
    {
        __typename?: "GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputContainerAri";
        value?: Maybe<Scalars["String"]["output"]>;
    };

export enum GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    Unknown = "UNKNOWN"
}

export enum GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum {
    Dast = "DAST",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataProjectHasIssueJiraIssueOutput = {
    __typename?: "GraphCreateMetadataProjectHasIssueJiraIssueOutput";
    assigneeAri?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutputAri>;
    fixVersionIds?: Maybe<Array<Maybe<Scalars["Long"]["output"]>>>;
    issueAri?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutputAri>;
    issueTypeAri?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutputAri>;
    reporterAri?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutputAri>;
};

export type GraphCreateMetadataProjectHasIssueJiraIssueOutputAri = {
    __typename?: "GraphCreateMetadataProjectHasIssueJiraIssueOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataProjectHasIssueOutput = {
    __typename?: "GraphCreateMetadataProjectHasIssueOutput";
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    sprintAris?: Maybe<
        Array<Maybe<GraphCreateMetadataProjectHasIssueOutputAri>>
    >;
};

export type GraphCreateMetadataProjectHasIssueOutputAri = {
    __typename?: "GraphCreateMetadataProjectHasIssueOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataSprintAssociatedBuildJiraBuildOutput = {
    __typename?: "GraphCreateMetadataSprintAssociatedBuildJiraBuildOutput";
    state?: Maybe<GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum>;
};

export enum GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataSprintAssociatedBuildOutput = {
    __typename?: "GraphCreateMetadataSprintAssociatedBuildOutput";
    assigneeAri?: Maybe<GraphCreateMetadataSprintAssociatedBuildOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataSprintAssociatedBuildOutputAri>;
    issueAri?: Maybe<GraphCreateMetadataSprintAssociatedBuildOutputAri>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<GraphCreateMetadataSprintAssociatedBuildOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataSprintAssociatedBuildOutputAri>;
};

export type GraphCreateMetadataSprintAssociatedBuildOutputAri = {
    __typename?: "GraphCreateMetadataSprintAssociatedBuildOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutput =
    {
        __typename?: "GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutput";
        state?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum>;
    };

export enum GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataSprintAssociatedDeploymentOutput = {
    __typename?: "GraphCreateMetadataSprintAssociatedDeploymentOutput";
    assigneeAri?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentOutputAri>;
    issueAri?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentOutputAri>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentOutputAri>;
};

export type GraphCreateMetadataSprintAssociatedDeploymentOutputAri = {
    __typename?: "GraphCreateMetadataSprintAssociatedDeploymentOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutput = {
    __typename?: "GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutput";
    author?: Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputAuthor>;
    reviewers?: Maybe<
        Array<
            Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewer>
        >
    >;
    status?: Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum>;
    taskCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputAuthor = {
    __typename?: "GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputAuthor";
    authorAri?: Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputAuthorAri>;
};

export type GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputAuthorAri =
    {
        __typename?: "GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputAuthorAri";
        value?: Maybe<Scalars["String"]["output"]>;
    };

export enum GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewer =
    {
        __typename?: "GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewer";
        approvalStatus?: Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum>;
        reviewerAri?: Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerAri>;
    };

export type GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerAri =
    {
        __typename?: "GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerAri";
        value?: Maybe<Scalars["String"]["output"]>;
    };

export enum GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphCreateMetadataSprintAssociatedPrOutput = {
    __typename?: "GraphCreateMetadataSprintAssociatedPrOutput";
    assigneeAri?: Maybe<GraphCreateMetadataSprintAssociatedPrOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataSprintAssociatedPrOutputAri>;
    issueAri?: Maybe<GraphCreateMetadataSprintAssociatedPrOutputAri>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<GraphCreateMetadataSprintAssociatedPrOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataSprintAssociatedPrOutputAri>;
};

export type GraphCreateMetadataSprintAssociatedPrOutputAri = {
    __typename?: "GraphCreateMetadataSprintAssociatedPrOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutput =
    {
        __typename?: "GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutput";
        introducedDate?: Maybe<Scalars["Long"]["output"]>;
        severity?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum>;
        status?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum>;
    };

export enum GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphCreateMetadataSprintAssociatedVulnerabilityOutput = {
    __typename?: "GraphCreateMetadataSprintAssociatedVulnerabilityOutput";
    assigneeAri?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityOutputAri>;
    statusCategory?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum>;
};

export type GraphCreateMetadataSprintAssociatedVulnerabilityOutputAri = {
    __typename?: "GraphCreateMetadataSprintAssociatedVulnerabilityOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export enum GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphCreateMetadataSprintContainsIssueInput = {
    issueLastUpdatedOn?: InputMaybe<Scalars["Long"]["input"]>;
};

export type GraphCreateMetadataSprintContainsIssueJiraIssueInput = {
    assigneeAri?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInputAri>;
    creatorAri?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInputAri>;
    issueAri?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInputAri>;
    reporterAri?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInputAri>;
    statusAri?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInputAri>;
    statusCategory?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum>;
};

export type GraphCreateMetadataSprintContainsIssueJiraIssueInputAri = {
    value?: InputMaybe<Scalars["String"]["input"]>;
};

export enum GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphCreateMetadataSprintContainsIssueJiraIssueOutput = {
    __typename?: "GraphCreateMetadataSprintContainsIssueJiraIssueOutput";
    assigneeAri?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri>;
    creatorAri?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri>;
    issueAri?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri>;
    reporterAri?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri>;
    statusAri?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri>;
    statusCategory?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum>;
};

export type GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri = {
    __typename?: "GraphCreateMetadataSprintContainsIssueJiraIssueOutputAri";
    value?: Maybe<Scalars["String"]["output"]>;
};

export enum GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphCreateMetadataSprintContainsIssueOutput = {
    __typename?: "GraphCreateMetadataSprintContainsIssueOutput";
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
};

export type GraphCreateParentDocumentHasChildDocumentInput = {
    /** An ARI of type ati:cloud:jira:document */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:document */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateSprintContainsIssueInput = {
    /** An ARI of type ati:cloud:jira:sprint */
    from: Scalars["ID"]["input"];
    relationshipMetadata?: InputMaybe<GraphCreateMetadataSprintContainsIssueInput>;
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
    toMetadata?: InputMaybe<GraphCreateMetadataSprintContainsIssueJiraIssueInput>;
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphCreateSprintRetrospectivePageInput = {
    /** An ARI of type ati:cloud:jira:sprint */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:confluence:page */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** Represents an Generic implementing the Node interface. */
export type GraphGeneric = Node & {
    __typename?: "GraphGeneric";
    data?: Maybe<GraphRelationshipNodeData>;
    fetchAllRelationships?: Maybe<GraphSimpleRelationshipConnection>;
    id: Scalars["ID"]["output"];
};

/** Represents an Generic implementing the Node interface. */
export type GraphGenericFetchAllRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
    updatedTo?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphGenericConnection = {
    __typename?: "GraphGenericConnection";
    edges: Array<Maybe<GraphGenericEdge>>;
    pageInfo: PageInfo;
};

export type GraphGenericEdge = {
    __typename?: "GraphGenericEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    node: GraphGeneric;
};

export type GraphIncidentAssociatedPostIncidentReviewLinkPayload = Payload & {
    __typename?: "GraphIncidentAssociatedPostIncidentReviewLinkPayload";
    errors?: Maybe<Array<MutationError>>;
    incidentAssociatedPostIncidentReviewLinkRelationship: Array<
        Maybe<GraphIncidentAssociatedPostIncidentReviewLinkRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphIncidentAssociatedPostIncidentReviewLinkRelationship = Node & {
    __typename?: "GraphIncidentAssociatedPostIncidentReviewLinkRelationship";
    from: GraphGeneric;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphGeneric;
};

export type GraphIncidentAssociatedPostIncidentReviewLinkRelationshipConnection =
    {
        __typename?: "GraphIncidentAssociatedPostIncidentReviewLinkRelationshipConnection";
        edges: Array<
            Maybe<GraphIncidentAssociatedPostIncidentReviewLinkRelationshipEdge>
        >;
        pageInfo: PageInfo;
    };

export type GraphIncidentAssociatedPostIncidentReviewLinkRelationshipEdge = {
    __typename?: "GraphIncidentAssociatedPostIncidentReviewLinkRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphIncidentAssociatedPostIncidentReviewLinkRelationship;
};

export type GraphIncidentHasActionItemPayload = Payload & {
    __typename?: "GraphIncidentHasActionItemPayload";
    errors?: Maybe<Array<MutationError>>;
    incidentHasActionItemRelationship: Array<
        Maybe<GraphIncidentHasActionItemRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphIncidentHasActionItemRelationship = Node & {
    __typename?: "GraphIncidentHasActionItemRelationship";
    from: GraphGeneric;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphJiraIssue;
};

export type GraphIncidentHasActionItemRelationshipConnection = {
    __typename?: "GraphIncidentHasActionItemRelationshipConnection";
    edges: Array<Maybe<GraphIncidentHasActionItemRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphIncidentHasActionItemRelationshipEdge = {
    __typename?: "GraphIncidentHasActionItemRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphIncidentHasActionItemRelationship;
};

export type GraphIncidentLinkedJswIssuePayload = Payload & {
    __typename?: "GraphIncidentLinkedJswIssuePayload";
    errors?: Maybe<Array<MutationError>>;
    incidentLinkedJswIssueRelationship: Array<
        Maybe<GraphIncidentLinkedJswIssueRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphIncidentLinkedJswIssueRelationship = Node & {
    __typename?: "GraphIncidentLinkedJswIssueRelationship";
    from: GraphGeneric;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphJiraIssue;
};

export type GraphIncidentLinkedJswIssueRelationshipConnection = {
    __typename?: "GraphIncidentLinkedJswIssueRelationshipConnection";
    edges: Array<Maybe<GraphIncidentLinkedJswIssueRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphIncidentLinkedJswIssueRelationshipEdge = {
    __typename?: "GraphIncidentLinkedJswIssueRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphIncidentLinkedJswIssueRelationship;
};

export type GraphIssueAssociatedDesignPayload = Payload & {
    __typename?: "GraphIssueAssociatedDesignPayload";
    errors?: Maybe<Array<MutationError>>;
    issueAssociatedDesignRelationship: Array<
        Maybe<GraphIssueAssociatedDesignRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphIssueAssociatedDesignRelationship = Node & {
    __typename?: "GraphIssueAssociatedDesignRelationship";
    from: GraphJiraIssue;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphJiraDesign;
};

export type GraphIssueAssociatedDesignRelationshipConnection = {
    __typename?: "GraphIssueAssociatedDesignRelationshipConnection";
    edges: Array<Maybe<GraphIssueAssociatedDesignRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphIssueAssociatedDesignRelationshipEdge = {
    __typename?: "GraphIssueAssociatedDesignRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphIssueAssociatedDesignRelationship;
};

export type GraphIssueAssociatedPrPayload = Payload & {
    __typename?: "GraphIssueAssociatedPrPayload";
    errors?: Maybe<Array<MutationError>>;
    issueAssociatedPrRelationship: Array<
        Maybe<GraphIssueAssociatedPrRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphIssueAssociatedPrRelationship = Node & {
    __typename?: "GraphIssueAssociatedPrRelationship";
    from: GraphJiraIssue;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphJiraPullRequest;
};

export type GraphIssueAssociatedPrRelationshipConnection = {
    __typename?: "GraphIssueAssociatedPrRelationshipConnection";
    edges: Array<Maybe<GraphIssueAssociatedPrRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphIssueAssociatedPrRelationshipEdge = {
    __typename?: "GraphIssueAssociatedPrRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphIssueAssociatedPrRelationship;
};

export type GraphJiraBuild = Node & {
    __typename?: "GraphJiraBuild";
    build?: Maybe<DevOpsBuildDetails>;
    id: Scalars["ID"]["output"];
};

export type GraphJiraBuildConnection = {
    __typename?: "GraphJiraBuildConnection";
    edges: Array<Maybe<GraphJiraBuildEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraBuildEdge = {
    __typename?: "GraphJiraBuildEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraBuild;
};

export type GraphJiraDeployment = Node & {
    __typename?: "GraphJiraDeployment";
    deployment?: Maybe<DeploymentSummary>;
    id: Scalars["ID"]["output"];
};

export type GraphJiraDeploymentConnection = {
    __typename?: "GraphJiraDeploymentConnection";
    edges: Array<Maybe<GraphJiraDeploymentEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraDeploymentEdge = {
    __typename?: "GraphJiraDeploymentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraDeployment;
};

export type GraphJiraDesign = Node & {
    __typename?: "GraphJiraDesign";
    design?: Maybe<DevOpsDesign>;
    id: Scalars["ID"]["output"];
};

export type GraphJiraDesignConnection = {
    __typename?: "GraphJiraDesignConnection";
    edges: Array<Maybe<GraphJiraDesignEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraDesignEdge = {
    __typename?: "GraphJiraDesignEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraDesign;
};

export type GraphJiraDocument = Node & {
    __typename?: "GraphJiraDocument";
    document?: Maybe<DevOpsDocument>;
    id: Scalars["ID"]["output"];
};

export type GraphJiraDocumentConnection = {
    __typename?: "GraphJiraDocumentConnection";
    edges: Array<Maybe<GraphJiraDocumentEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraDocumentEdge = {
    __typename?: "GraphJiraDocumentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraDocument;
};

/** Represents an ati:cloud:jira:issue. Returned by relationship queries */
export type GraphJiraIssue = Node & {
    __typename?: "GraphJiraIssue";
    data?: Maybe<JiraIssue>;
    id: Scalars["ID"]["output"];
};

export type GraphJiraIssueConnection = {
    __typename?: "GraphJiraIssueConnection";
    edges: Array<Maybe<GraphJiraIssueEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraIssueEdge = {
    __typename?: "GraphJiraIssueEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraIssue;
};

/** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */
export type GraphJiraPostIncidentReviewLink = Node & {
    __typename?: "GraphJiraPostIncidentReviewLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fetchAllRelationships?: Maybe<GraphSimpleRelationshipConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    postIncidentReviewLink?: Maybe<JiraPostIncidentReviewLink>;
};

/** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */
export type GraphJiraPostIncidentReviewLinkFetchAllRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    ascending?: InputMaybe<Scalars["Boolean"]["input"]>;
    updatedFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
    updatedTo?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** Represents an ati:cloud:jira:project implementing the Node interface. */
export type GraphJiraProject = Node & {
    __typename?: "GraphJiraProject";
    id: Scalars["ID"]["output"];
};

export type GraphJiraProjectConnection = {
    __typename?: "GraphJiraProjectConnection";
    edges: Array<Maybe<GraphJiraProjectEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraProjectEdge = {
    __typename?: "GraphJiraProjectEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraProject;
};

export type GraphJiraPullRequest = Node & {
    __typename?: "GraphJiraPullRequest";
    id: Scalars["ID"]["output"];
    pullRequest?: Maybe<DevOpsPullRequestDetails>;
};

export type GraphJiraPullRequestConnection = {
    __typename?: "GraphJiraPullRequestConnection";
    edges: Array<Maybe<GraphJiraPullRequestEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraPullRequestEdge = {
    __typename?: "GraphJiraPullRequestEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraPullRequest;
};

/** Represents an ati:cloud:jira:security-container implementing the Node interface. */
export type GraphJiraSecurityContainer = Node & {
    __typename?: "GraphJiraSecurityContainer";
    id: Scalars["ID"]["output"];
};

export type GraphJiraSecurityContainerConnection = {
    __typename?: "GraphJiraSecurityContainerConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges: Array<Maybe<GraphJiraSecurityContainerEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type GraphJiraSecurityContainerEdge = {
    __typename?: "GraphJiraSecurityContainerEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node: GraphJiraSecurityContainer;
};

/** Represents an ati:cloud:jira:sprint. Returned by relationship queries */
export type GraphJiraSprint = Node & {
    __typename?: "GraphJiraSprint";
    id: Scalars["ID"]["output"];
};

export type GraphJiraSprintConnection = {
    __typename?: "GraphJiraSprintConnection";
    edges: Array<Maybe<GraphJiraSprintEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraSprintEdge = {
    __typename?: "GraphJiraSprintEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraSprint;
};

/** Represents an ati:cloud:jira:vulnerability implementing the Node interface. */
export type GraphJiraVulnerability = Node & {
    __typename?: "GraphJiraVulnerability";
    id: Scalars["ID"]["output"];
    vulnerability?: Maybe<DevOpsSecurityVulnerabilityDetails>;
};

export type GraphJiraVulnerabilityConnection = {
    __typename?: "GraphJiraVulnerabilityConnection";
    edges: Array<Maybe<GraphJiraVulnerabilityEdge>>;
    pageInfo: PageInfo;
};

export type GraphJiraVulnerabilityEdge = {
    __typename?: "GraphJiraVulnerabilityEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphJiraVulnerability;
};

export type GraphMutation = {
    __typename?: "GraphMutation";
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createIncidentAssociatedPostIncidentReviewLink?: Maybe<GraphIncidentAssociatedPostIncidentReviewLinkPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createIncidentHasActionItem?: Maybe<GraphIncidentHasActionItemPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createIncidentLinkedJswIssue?: Maybe<GraphIncidentLinkedJswIssuePayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createIssueAssociatedDesign?: Maybe<GraphIssueAssociatedDesignPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createIssueAssociatedPr?: Maybe<GraphIssueAssociatedPrPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createSprintContainsIssue?: Maybe<GraphSprintContainsIssuePayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createSprintRetrospectivePage?: Maybe<GraphSprintRetrospectivePagePayload>;
};

export type GraphMutationCreateIncidentAssociatedPostIncidentReviewLinkArgs = {
    input: GraphCreateIncidentAssociatedPostIncidentReviewLinkInput;
};

export type GraphMutationCreateIncidentHasActionItemArgs = {
    input: GraphCreateIncidentHasActionItemInput;
};

export type GraphMutationCreateIncidentLinkedJswIssueArgs = {
    input: GraphCreateIncidentLinkedJswIssueInput;
};

export type GraphMutationCreateIssueAssociatedDesignArgs = {
    input: GraphCreateIssueAssociatedDesignInput;
};

export type GraphMutationCreateIssueAssociatedPrArgs = {
    input: GraphCreateIssueAssociatedPrInput;
};

export type GraphMutationCreateSprintContainsIssueArgs = {
    input: GraphCreateSprintContainsIssueInput;
};

export type GraphMutationCreateSprintRetrospectivePageArgs = {
    input: GraphCreateSprintRetrospectivePageInput;
};

export type GraphParentDocumentHasChildDocumentPayload = Payload & {
    __typename?: "GraphParentDocumentHasChildDocumentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    parentDocumentHasChildDocumentRelationship: Array<
        Maybe<GraphParentDocumentHasChildDocumentRelationship>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type GraphParentDocumentHasChildDocumentRelationship = Node & {
    __typename?: "GraphParentDocumentHasChildDocumentRelationship";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    from: GraphJiraDocument;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    to: GraphJiraDocument;
};

export type GraphParentDocumentHasChildDocumentRelationshipConnection = {
    __typename?: "GraphParentDocumentHasChildDocumentRelationshipConnection";
    edges: Array<Maybe<GraphParentDocumentHasChildDocumentRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphParentDocumentHasChildDocumentRelationshipEdge = {
    __typename?: "GraphParentDocumentHasChildDocumentRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphParentDocumentHasChildDocumentRelationship;
};

export type GraphProjectAssociatedBuildRelationship = Node & {
    __typename?: "GraphProjectAssociatedBuildRelationship";
    from: GraphJiraProject;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataProjectAssociatedBuildOutput>;
    to: GraphJiraBuild;
    toMetadata?: Maybe<GraphCreateMetadataProjectAssociatedBuildJiraBuildOutput>;
};

export type GraphProjectAssociatedBuildRelationshipConnection = {
    __typename?: "GraphProjectAssociatedBuildRelationshipConnection";
    edges: Array<Maybe<GraphProjectAssociatedBuildRelationshipEdge>>;
    fromId?: Maybe<Scalars["ID"]["output"]>;
    pageInfo: PageInfo;
    toId?: Maybe<Scalars["ID"]["output"]>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphProjectAssociatedBuildRelationshipEdge = {
    __typename?: "GraphProjectAssociatedBuildRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphProjectAssociatedBuildRelationship;
};

export type GraphProjectAssociatedDeploymentRelationship = Node & {
    __typename?: "GraphProjectAssociatedDeploymentRelationship";
    from: GraphJiraProject;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentOutput>;
    to: GraphJiraDeployment;
    toMetadata?: Maybe<GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutput>;
};

export type GraphProjectAssociatedDeploymentRelationshipConnection = {
    __typename?: "GraphProjectAssociatedDeploymentRelationshipConnection";
    edges: Array<Maybe<GraphProjectAssociatedDeploymentRelationshipEdge>>;
    fromId?: Maybe<Scalars["ID"]["output"]>;
    pageInfo: PageInfo;
    toId?: Maybe<Scalars["ID"]["output"]>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphProjectAssociatedDeploymentRelationshipEdge = {
    __typename?: "GraphProjectAssociatedDeploymentRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphProjectAssociatedDeploymentRelationship;
};

export type GraphProjectAssociatedPrRelationship = Node & {
    __typename?: "GraphProjectAssociatedPrRelationship";
    from: GraphJiraProject;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataProjectAssociatedPrOutput>;
    to: GraphJiraPullRequest;
    toMetadata?: Maybe<GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutput>;
};

export type GraphProjectAssociatedPrRelationshipConnection = {
    __typename?: "GraphProjectAssociatedPrRelationshipConnection";
    edges: Array<Maybe<GraphProjectAssociatedPrRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphProjectAssociatedPrRelationshipEdge = {
    __typename?: "GraphProjectAssociatedPrRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphProjectAssociatedPrRelationship;
};

export type GraphProjectAssociatedVulnerabilityRelationship = Node & {
    __typename?: "GraphProjectAssociatedVulnerabilityRelationship";
    from: GraphJiraProject;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphJiraVulnerability;
    toMetadata?: Maybe<GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutput>;
};

export type GraphProjectAssociatedVulnerabilityRelationshipConnection = {
    __typename?: "GraphProjectAssociatedVulnerabilityRelationshipConnection";
    edges: Array<Maybe<GraphProjectAssociatedVulnerabilityRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphProjectAssociatedVulnerabilityRelationshipEdge = {
    __typename?: "GraphProjectAssociatedVulnerabilityRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphProjectAssociatedVulnerabilityRelationship;
};

export type GraphProjectHasIssuePayload = Payload & {
    __typename?: "GraphProjectHasIssuePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    projectHasIssueRelationship: Array<Maybe<GraphProjectHasIssueRelationship>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type GraphProjectHasIssueRelationship = Node & {
    __typename?: "GraphProjectHasIssueRelationship";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    from: GraphJiraProject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["DateTime"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    relationshipMetadata?: Maybe<GraphCreateMetadataProjectHasIssueOutput>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    to: GraphJiraIssue;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    toMetadata?: Maybe<GraphCreateMetadataProjectHasIssueJiraIssueOutput>;
};

export type GraphProjectHasIssueRelationshipConnection = {
    __typename?: "GraphProjectHasIssueRelationshipConnection";
    edges: Array<Maybe<GraphProjectHasIssueRelationshipEdge>>;
    fromId?: Maybe<Scalars["ID"]["output"]>;
    pageInfo: PageInfo;
    toId?: Maybe<Scalars["ID"]["output"]>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphProjectHasIssueRelationshipEdge = {
    __typename?: "GraphProjectHasIssueRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphProjectHasIssueRelationship;
};

export type GraphProjectService = Node & {
    __typename?: "GraphProjectService";
    id: Scalars["ID"]["output"];
    service?: Maybe<DevOpsService>;
};

export type GraphProjectServiceConnection = {
    __typename?: "GraphProjectServiceConnection";
    edges: Array<Maybe<GraphProjectServiceEdge>>;
    pageInfo: PageInfo;
};

export type GraphProjectServiceEdge = {
    __typename?: "GraphProjectServiceEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphProjectService;
};

export type GraphQlConfluenceUserRoles = {
    __typename?: "GraphQLConfluenceUserRoles";
    canBeSuperAdmin: Scalars["Boolean"]["output"];
    canUseConfluence: Scalars["Boolean"]["output"];
    isSuperAdmin: Scalars["Boolean"]["output"];
};

export type GraphQlContactAdminStatus = {
    __typename?: "GraphQLContactAdminStatus";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum GraphQlContentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Deleted = "DELETED",
    Draft = "DRAFT"
}

export enum GraphQlContentTemplateType {
    Blueprint = "BLUEPRINT",
    Page = "PAGE"
}

export enum GraphQlCoverPictureWidth {
    Fixed = "FIXED",
    Full = "FULL"
}

export enum GraphQlFrontCoverState {
    Hidden = "HIDDEN",
    Shown = "SHOWN",
    Transition = "TRANSITION",
    Unset = "UNSET"
}

export type GraphQlGlobalDescription = {
    __typename?: "GraphQLGlobalDescription";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type GraphQlGroupCountsResult = {
    __typename?: "GraphQLGroupCountsResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupCounts: Array<Maybe<MapOfStringToInteger>>;
};

export type GraphQlInlineTask = {
    __typename?: "GraphQLInlineTask";
    /** UserInfo of the user who has been assigned the Task. */
    assignedTo?: Maybe<GraphQlUserInfo>;
    /** Body of the Task. */
    body?: Maybe<ConfluenceContentBody>;
    /** UserInfo of the user who has completed the Task. */
    completedBy?: Maybe<GraphQlUserInfo>;
    /** Entity that contains Task. */
    container?: Maybe<ConfluenceInlineTaskContainer>;
    /** Date and time the Task was created. */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** UserInfo of the user who created the Task. */
    createdBy?: Maybe<GraphQlUserInfo>;
    /** Date and time the Task is due. */
    dueAt?: Maybe<Scalars["String"]["output"]>;
    /** Global ID of the Task. */
    globalId?: Maybe<Scalars["ID"]["output"]>;
    /** The ARI of the Task, ConfluenceTaskARI format. */
    id: Scalars["ID"]["output"];
    /** Status of the Task. */
    status?: Maybe<ConfluenceInlineTaskStatus>;
    /** ID of the Task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
    /** Date and time the Task was updated. */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export enum GraphQlLabelSortDirection {
    Ascending = "ASCENDING",
    Descending = "DESCENDING"
}

export enum GraphQlLabelSortField {
    LabellingCreationdate = "LABELLING_CREATIONDATE",
    LabellingId = "LABELLING_ID"
}

export type GraphQlMutationResponse = {
    __typename?: "GraphQLMutationResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum GraphQlPageStatus {
    Current = "CURRENT",
    Draft = "DRAFT",
    Historical = "HISTORICAL",
    Trashed = "TRASHED"
}

export enum GraphQlReactionContentType {
    Blogpost = "BLOGPOST",
    Comment = "COMMENT",
    Page = "PAGE"
}

export type GraphQlRelevantFeedFilters = {
    __typename?: "GraphQLRelevantFeedFilters";
    relevantFeedSpacesFilter: Array<Maybe<Scalars["Long"]["output"]>>;
    relevantFeedUsersFilter: Array<Maybe<Scalars["String"]["output"]>>;
};

export type GraphQlSmartLinkContent = {
    __typename?: "GraphQLSmartLinkContent";
    contentId: Scalars["ID"]["output"];
    contentType?: Maybe<Scalars["String"]["output"]>;
    embedURL: Scalars["String"]["output"];
    iconURL?: Maybe<Scalars["String"]["output"]>;
    parentPageId: Scalars["String"]["output"];
    spaceId: Scalars["String"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
};

export type GraphQlSpaceShortcutsInput = {
    iconUrl?: InputMaybe<Scalars["String"]["input"]>;
    isPinnedPage: Scalars["Boolean"]["input"];
    shortcutId: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export enum GraphQlTemplateContentAppearance {
    Default = "DEFAULT",
    FullWidth = "FULL_WIDTH"
}

export type GraphQlUserAndGroupSearchResults = {
    __typename?: "GraphQLUserAndGroupSearchResults";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groups: Array<Maybe<Group>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    users: Array<Maybe<Person>>;
};

export type GraphQlUserInfo = {
    __typename?: "GraphQLUserInfo";
    /** accountId of the user. */
    accountId: Scalars["String"]["output"];
    /** Display Name of User. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** Profile picture of the user */
    profilePicture?: Maybe<Icon>;
    /** Type of User. */
    type: ConfluenceUserType;
};

export type GraphQueryMetadataProjectAssociatedBuildInput = {
    and?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedBuildInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedBuildInputOr>>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputLastUpdated>;
    or?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedBuildInputOrInner>
    >;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToState>;
    to_testInfo?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfo>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToState>;
    to_testInfo?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfo>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputCreatedAt = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputCreatedAtMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputLastUpdated = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputLastUpdatedMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedBuildInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToState>;
    to_testInfo?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfo>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToState>;
    to_testInfo?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfo>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputRelationshipAri = {
    value?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAriValue>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputRelationshipAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToAti = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToAtiMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputToAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataProjectAssociatedBuildInputToState = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToStateMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum>
    >;
};

export type GraphQueryMetadataProjectAssociatedBuildInputToStateMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfo = {
    numberFailed?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberFailed>;
    numberPassed?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberPassed>;
    numberSkipped?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberSkipped>;
    totalNumber?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoTotalNumber>;
};

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberFailed =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberFailedRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberFailedMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberFailedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberFailedRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberPassed =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberPassedRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberPassedMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberPassedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberPassedRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberSkipped =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberSkippedRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberSkippedMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberSkippedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoNumberSkippedRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoTotalNumber =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoTotalNumberRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedBuildInputToTestInfoTotalNumberMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoTotalNumberMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedBuildInputToTestInfoTotalNumberRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInput = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedDeploymentInputAnd>
    >;
    or?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedDeploymentInputOr>
    >;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdated>;
    or?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedDeploymentInputOrInner>
    >;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIds>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIds>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAt = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAtMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAtRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdated = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdatedMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedDeploymentInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIds>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIds>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAri =
    {
        value?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAriValue>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIds =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIdsRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIdsMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIdsMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipFixVersionIdsRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputToAti = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAtiMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputToAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputToAuthor = {
    authorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthorAri>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputToAuthorAri = {
    value?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthorAriValue>;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputToAuthorAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToAuthorAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputToAuthorAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentType =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum>
        >;
    };

export enum GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedDeploymentInputToState = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedDeploymentInputToStateMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum>
    >;
};

export type GraphQueryMetadataProjectAssociatedDeploymentInputToStateMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedIncidentInput = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedIncidentInputAnd>
    >;
    or?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedIncidentInputOr>>;
};

export type GraphQueryMetadataProjectAssociatedIncidentInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputLastUpdated>;
    or?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedIncidentInputOrInner>
    >;
};

export type GraphQueryMetadataProjectAssociatedIncidentInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputLastUpdated>;
};

export type GraphQueryMetadataProjectAssociatedIncidentInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataProjectAssociatedIncidentInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedIncidentInputCreatedAtRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedIncidentInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataProjectAssociatedIncidentInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedIncidentInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedIncidentInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedIncidentInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputLastUpdated>;
};

export type GraphQueryMetadataProjectAssociatedIncidentInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedIncidentInputLastUpdated>;
};

export type GraphQueryMetadataProjectAssociatedPrInput = {
    and?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedPrInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedPrInputOr>>;
};

export type GraphQueryMetadataProjectAssociatedPrInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputLastUpdated>;
    or?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedPrInputOrInner>>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataProjectAssociatedPrInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataProjectAssociatedPrInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataProjectAssociatedPrInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataProjectAssociatedPrInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataProjectAssociatedPrInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputLastUpdatedRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataProjectAssociatedPrInputOr = {
    and?: InputMaybe<Array<GraphQueryMetadataProjectAssociatedPrInputAndInner>>;
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataProjectAssociatedPrInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAri>;
    to_author?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataProjectAssociatedPrInputRelationshipAri = {
    value?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAriValue>;
};

export type GraphQueryMetadataProjectAssociatedPrInputRelationshipAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedPrInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputToAuthor = {
    authorAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthorAri>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToAuthorAri = {
    value?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthorAriValue>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToAuthorAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToAuthorAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToAuthorAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataProjectAssociatedPrInputToReviewer = {
    approvalStatus?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewerApprovalStatus>;
    matchType?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum>;
    reviewerAri?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewerAri>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToReviewerApprovalStatus =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewerApprovalStatusMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum>
        >;
    };

export type GraphQueryMetadataProjectAssociatedPrInputToReviewerApprovalStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputToReviewerAri = {
    value?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewerAriValue>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToReviewerAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToReviewerAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToReviewerAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export enum GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum {
    All = "ALL",
    Any = "ANY",
    None = "NONE"
}

export type GraphQueryMetadataProjectAssociatedPrInputToStatus = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToStatusMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum>
    >;
};

export type GraphQueryMetadataProjectAssociatedPrInputToStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputToTaskCount = {
    notValues?: InputMaybe<Array<Scalars["Int"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToTaskCountRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedPrInputToTaskCountMetadataSortField>;
    values?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type GraphQueryMetadataProjectAssociatedPrInputToTaskCountMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedPrInputToTaskCountRangeField = {
    gt?: InputMaybe<Scalars["Int"]["input"]>;
    gte?: InputMaybe<Scalars["Int"]["input"]>;
    lt?: InputMaybe<Scalars["Int"]["input"]>;
    lte?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInput = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputAnd>
    >;
    or?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputOr>
    >;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated>;
    or?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputOrInner>
    >;
    to_container?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer>;
    to_severity?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus>;
    to_type?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToType>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated>;
    to_container?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer>;
    to_severity?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus>;
    to_type?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToType>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated>;
    to_container?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer>;
    to_severity?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus>;
    to_type?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToType>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated>;
    to_container?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer>;
    to_severity?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus>;
    to_type?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToType>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer = {
    containerAri?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAri>;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAri =
    {
        value?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValue>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverityMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum>
    >;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverityMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatusMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum>
    >;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToType = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInputToTypeMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum>
    >;
};

export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToTypeMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    Unknown = "UNKNOWN"
}

export enum GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum {
    Dast = "DAST",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataProjectHasIssueInput = {
    and?: InputMaybe<Array<GraphQueryMetadataProjectHasIssueInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataProjectHasIssueInputOr>>;
};

export type GraphQueryMetadataProjectHasIssueInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectHasIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectHasIssueInputLastUpdated>;
    or?: InputMaybe<Array<GraphQueryMetadataProjectHasIssueInputOrInner>>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOn>;
    relationship_sprintAris?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipAri>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToFixVersionIds>;
    to_issueAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
};

export type GraphQueryMetadataProjectHasIssueInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectHasIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectHasIssueInputLastUpdated>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOn>;
    relationship_sprintAris?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipAri>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToFixVersionIds>;
    to_issueAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
};

export type GraphQueryMetadataProjectHasIssueInputCreatedAt = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectHasIssueInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectHasIssueInputCreatedAtMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataProjectHasIssueInputCreatedAtMetadataSortField = {
    order?: InputMaybe<GraphQueryMetadataSortEnum>;
    priority?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GraphQueryMetadataProjectHasIssueInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataProjectHasIssueInputLastUpdated = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectHasIssueInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectHasIssueInputLastUpdatedMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataProjectHasIssueInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectHasIssueInputLastUpdatedRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataProjectHasIssueInputOr = {
    and?: InputMaybe<Array<GraphQueryMetadataProjectHasIssueInputAndInner>>;
    createdAt?: InputMaybe<GraphQueryMetadataProjectHasIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectHasIssueInputLastUpdated>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOn>;
    relationship_sprintAris?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipAri>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToFixVersionIds>;
    to_issueAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
};

export type GraphQueryMetadataProjectHasIssueInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataProjectHasIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataProjectHasIssueInputLastUpdated>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOn>;
    relationship_sprintAris?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipAri>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_fixVersionIds?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToFixVersionIds>;
    to_issueAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_issueTypeAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAri>;
};

export type GraphQueryMetadataProjectHasIssueInputRelationshipAri = {
    matchType?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum>;
    value?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipAriValue>;
};

export type GraphQueryMetadataProjectHasIssueInputRelationshipAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectHasIssueInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum {
    All = "ALL",
    Any = "ANY",
    None = "NONE"
}

export type GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectHasIssueInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataProjectHasIssueInputToAri = {
    value?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAriValue>;
};

export type GraphQueryMetadataProjectHasIssueInputToAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataProjectHasIssueInputToAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectHasIssueInputToFixVersionIds = {
    notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToFixVersionIdsRangeField>;
    sort?: InputMaybe<GraphQueryMetadataProjectHasIssueInputToFixVersionIdsMetadataSortField>;
    values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
};

export type GraphQueryMetadataProjectHasIssueInputToFixVersionIdsMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataProjectHasIssueInputToFixVersionIdsRangeField = {
    gt?: InputMaybe<Scalars["Long"]["input"]>;
    gte?: InputMaybe<Scalars["Long"]["input"]>;
    lt?: InputMaybe<Scalars["Long"]["input"]>;
    lte?: InputMaybe<Scalars["Long"]["input"]>;
};

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInput =
    {
        and?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputAnd>
        >;
        or?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputOr>
        >;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputAnd =
    {
        createdAt?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAt>;
        fromAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAti>;
        lastUpdated?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdated>;
        or?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputOrInner>
        >;
        toAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAti>;
        to_container?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainer>;
        to_severity?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverity>;
        to_status?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatus>;
        to_type?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToType>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputAndInner =
    {
        createdAt?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAt>;
        fromAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAti>;
        lastUpdated?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdated>;
        toAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAti>;
        to_container?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainer>;
        to_severity?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverity>;
        to_status?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatus>;
        to_type?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToType>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAt =
    {
        notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAtRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAtMetadataSortField>;
        values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAtRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAti =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAtiMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdated =
    {
        notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdatedRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdatedMetadataSortField>;
        values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputOr =
    {
        and?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputAndInner>
        >;
        createdAt?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAt>;
        fromAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAti>;
        lastUpdated?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdated>;
        toAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAti>;
        to_container?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainer>;
        to_severity?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverity>;
        to_status?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatus>;
        to_type?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToType>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputOrInner =
    {
        createdAt?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputCreatedAt>;
        fromAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputFromAti>;
        lastUpdated?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputLastUpdated>;
        toAti?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAti>;
        to_container?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainer>;
        to_severity?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverity>;
        to_status?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatus>;
        to_type?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToType>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAti =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAtiMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainer =
    {
        containerAri?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainerAri>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainerAri =
    {
        value?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainerAriValue>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainerAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainerAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToContainerAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverity =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverityMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum>
        >;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToSeverityMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatus =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatusMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum>
        >;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToType =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToTypeMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum>
        >;
    };

export type GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToTypeMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum {
    Dast = "DAST",
    NotSet = "NOT_SET",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataServiceLinkedIncidentInput = {
    and?: InputMaybe<Array<GraphQueryMetadataServiceLinkedIncidentInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataServiceLinkedIncidentInputOr>>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputLastUpdated>;
    or?: InputMaybe<Array<GraphQueryMetadataServiceLinkedIncidentInputOrInner>>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputLastUpdated>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataServiceLinkedIncidentInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataServiceLinkedIncidentInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataServiceLinkedIncidentInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataServiceLinkedIncidentInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputLastUpdated>;
};

export type GraphQueryMetadataServiceLinkedIncidentInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataServiceLinkedIncidentInputLastUpdated>;
};

export enum GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5"
}

export enum GraphQueryMetadataSortEnum {
    Asc = "ASC",
    Desc = "DESC"
}

export type GraphQueryMetadataSprintAssociatedBuildInput = {
    and?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedBuildInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedBuildInputOr>>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputLastUpdated>;
    or?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedBuildInputOrInner>>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToState>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToState>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedBuildInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToState>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToAti>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToState>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputRelationshipAri = {
    value?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAriValue>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputRelationshipAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedBuildInputToAti = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToAtiMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedBuildInputToAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataSprintAssociatedBuildInputToState = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedBuildInputToStateMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum>
    >;
};

export type GraphQueryMetadataSprintAssociatedBuildInputToStateMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInput = {
    and?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedDeploymentInputAnd>
    >;
    or?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedDeploymentInputOr>>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdated>;
    or?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedDeploymentInputOrInner>
    >;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAtRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedDeploymentInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthor>;
    to_environmentType?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentType>;
    to_state?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToState>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAri = {
    value?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAriValue>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputToAti = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAtiMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputToAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputToAuthor = {
    authorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthorAri>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputToAuthorAri = {
    value?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthorAriValue>;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputToAuthorAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToAuthorAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputToAuthorAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentType =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum>
        >;
    };

export enum GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedDeploymentInputToState = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedDeploymentInputToStateMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum>
    >;
};

export type GraphQueryMetadataSprintAssociatedDeploymentInputToStateMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInput = {
    and?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedPrInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedPrInputOr>>;
};

export type GraphQueryMetadataSprintAssociatedPrInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputLastUpdated>;
    or?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedPrInputOrInner>>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataSprintAssociatedPrInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataSprintAssociatedPrInputCreatedAt = {
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputCreatedAtMetadataSortField>;
};

export type GraphQueryMetadataSprintAssociatedPrInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataSprintAssociatedPrInputLastUpdated = {
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputLastUpdatedMetadataSortField>;
};

export type GraphQueryMetadataSprintAssociatedPrInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputLastUpdatedRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataSprintAssociatedPrInputOr = {
    and?: InputMaybe<Array<GraphQueryMetadataSprintAssociatedPrInputAndInner>>;
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataSprintAssociatedPrInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_creatorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOn>;
    relationship_reporterAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAri>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAti>;
    to_author?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthor>;
    to_reviewers?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewer>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToStatus>;
    to_taskCount?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToTaskCount>;
};

export type GraphQueryMetadataSprintAssociatedPrInputRelationshipAri = {
    value?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAriValue>;
};

export type GraphQueryMetadataSprintAssociatedPrInputRelationshipAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedPrInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputToAti = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAtiMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToAtiMetadataSortField = {
    order?: InputMaybe<GraphQueryMetadataSortEnum>;
    priority?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToAuthor = {
    authorAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthorAri>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToAuthorAri = {
    value?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthorAriValue>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToAuthorAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToAuthorAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToAuthorAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataSprintAssociatedPrInputToReviewer = {
    approvalStatus?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewerApprovalStatus>;
    matchType?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum>;
    reviewerAri?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewerAri>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToReviewerApprovalStatus =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewerApprovalStatusMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum>
        >;
    };

export type GraphQueryMetadataSprintAssociatedPrInputToReviewerApprovalStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputToReviewerAri = {
    value?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewerAriValue>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToReviewerAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToReviewerAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToReviewerAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export enum GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum {
    All = "ALL",
    Any = "ANY",
    None = "NONE"
}

export type GraphQueryMetadataSprintAssociatedPrInputToStatus = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToStatusMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum>
    >;
};

export type GraphQueryMetadataSprintAssociatedPrInputToStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputToTaskCount = {
    notValues?: InputMaybe<Array<Scalars["Int"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToTaskCountRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedPrInputToTaskCountMetadataSortField>;
    values?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedPrInputToTaskCountMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedPrInputToTaskCountRangeField = {
    gt?: InputMaybe<Scalars["Int"]["input"]>;
    gte?: InputMaybe<Scalars["Int"]["input"]>;
    lt?: InputMaybe<Scalars["Int"]["input"]>;
    lte?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInput = {
    and?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputAnd>
    >;
    or?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputOr>
    >;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdated>;
    or?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputOrInner>
    >;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusCategory?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategory>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToAti>;
    to_introducedDate?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDate>;
    to_severity?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatus>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusCategory?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategory>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToAti>;
    to_introducedDate?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDate>;
    to_severity?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatus>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAt = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAtMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAtRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdated = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdatedMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdatedRangeField =
    {
        gt?: InputMaybe<Scalars["DateTime"]["input"]>;
        gte?: InputMaybe<Scalars["DateTime"]["input"]>;
        lt?: InputMaybe<Scalars["DateTime"]["input"]>;
        lte?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputOr = {
    and?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputAndInner>
    >;
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusCategory?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategory>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToAti>;
    to_introducedDate?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDate>;
    to_severity?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatus>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputLastUpdated>;
    relationship_assigneeAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusAri?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri>;
    relationship_statusCategory?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategory>;
    toAti?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToAti>;
    to_introducedDate?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDate>;
    to_severity?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverity>;
    to_status?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatus>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAri =
    {
        value?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAriValue>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAriValue =
    {
        notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAriValueMetadataSortField>;
        values?: InputMaybe<Array<Scalars["String"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategory =
    {
        notValues?: InputMaybe<
            Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum>
        >;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryMetadataSortField>;
        values?: InputMaybe<
            Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum>
        >;
    };

export enum GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToAti = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToAtiMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToAtiMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDate =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDateRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDateMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDateMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToIntroducedDateRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverity = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverityMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum>
    >;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToSeverityMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatus = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatusMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum>
    >;
};

export type GraphQueryMetadataSprintAssociatedVulnerabilityInputToStatusMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export enum GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphQueryMetadataSprintContainsIssueInput = {
    and?: InputMaybe<Array<GraphQueryMetadataSprintContainsIssueInputAnd>>;
    or?: InputMaybe<Array<GraphQueryMetadataSprintContainsIssueInputOr>>;
};

export type GraphQueryMetadataSprintContainsIssueInputAnd = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputLastUpdated>;
    or?: InputMaybe<Array<GraphQueryMetadataSprintContainsIssueInputOrInner>>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOn>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_issueAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusCategory?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToStatusCategory>;
};

export type GraphQueryMetadataSprintContainsIssueInputAndInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputLastUpdated>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOn>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_issueAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusCategory?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToStatusCategory>;
};

export type GraphQueryMetadataSprintContainsIssueInputCreatedAt = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputCreatedAtRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputCreatedAtMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataSprintContainsIssueInputCreatedAtMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintContainsIssueInputCreatedAtRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataSprintContainsIssueInputLastUpdated = {
    notValues?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
    range?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputLastUpdatedRangeField>;
    sort?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputLastUpdatedMetadataSortField>;
    values?: InputMaybe<Array<Scalars["DateTime"]["input"]>>;
};

export type GraphQueryMetadataSprintContainsIssueInputLastUpdatedMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintContainsIssueInputLastUpdatedRangeField = {
    gt?: InputMaybe<Scalars["DateTime"]["input"]>;
    gte?: InputMaybe<Scalars["DateTime"]["input"]>;
    lt?: InputMaybe<Scalars["DateTime"]["input"]>;
    lte?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphQueryMetadataSprintContainsIssueInputOr = {
    and?: InputMaybe<Array<GraphQueryMetadataSprintContainsIssueInputAndInner>>;
    createdAt?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputLastUpdated>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOn>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_issueAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusCategory?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToStatusCategory>;
};

export type GraphQueryMetadataSprintContainsIssueInputOrInner = {
    createdAt?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputCreatedAt>;
    lastUpdated?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputLastUpdated>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOn>;
    to_assigneeAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_creatorAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_issueAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_reporterAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusAri?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAri>;
    to_statusCategory?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToStatusCategory>;
};

export type GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOn =
    {
        notValues?: InputMaybe<Array<Scalars["Long"]["input"]>>;
        range?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOnRangeField>;
        sort?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOnMetadataSortField>;
        values?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    };

export type GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOnMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintContainsIssueInputRelationshipIssueLastUpdatedOnRangeField =
    {
        gt?: InputMaybe<Scalars["Long"]["input"]>;
        gte?: InputMaybe<Scalars["Long"]["input"]>;
        lt?: InputMaybe<Scalars["Long"]["input"]>;
        lte?: InputMaybe<Scalars["Long"]["input"]>;
    };

export type GraphQueryMetadataSprintContainsIssueInputToAri = {
    value?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAriValue>;
};

export type GraphQueryMetadataSprintContainsIssueInputToAriValue = {
    notValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sort?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToAriValueMetadataSortField>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphQueryMetadataSprintContainsIssueInputToAriValueMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphQueryMetadataSprintContainsIssueInputToStatusCategory = {
    notValues?: InputMaybe<
        Array<GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum>
    >;
    sort?: InputMaybe<GraphQueryMetadataSprintContainsIssueInputToStatusCategoryMetadataSortField>;
    values?: InputMaybe<
        Array<GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum>
    >;
};

export enum GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphQueryMetadataSprintContainsIssueInputToStatusCategoryMetadataSortField =
    {
        order?: InputMaybe<GraphQueryMetadataSortEnum>;
        priority?: InputMaybe<Scalars["Int"]["input"]>;
    };

export type GraphRelationshipNodeData =
    | ConfluencePage
    | ConfluenceSpace
    | DeploymentSummary
    | DevOpsDocument
    | DevOpsFeatureFlag
    | DevOpsOperationsComponentDetails
    | DevOpsOperationsIncidentDetails
    | DevOpsOperationsPostIncidentReviewDetails
    | DevOpsPullRequestDetails
    | DevOpsRepository
    | DevOpsSecurityVulnerabilityDetails
    | DevOpsService
    | JiraIssue
    | JiraPostIncidentReviewLink
    | JiraProject
    | JiraVersion
    | OpsgenieTeam
    | ThirdPartySecurityContainer
    | ThirdPartySecurityWorkspace
    | TownsquareComment
    | TownsquareGoal
    | TownsquareProject;

export type GraphSecurityContainerAssociatedToVulnerabilityRelationship =
    Node & {
        __typename?: "GraphSecurityContainerAssociatedToVulnerabilityRelationship";
        from: GraphJiraSecurityContainer;
        id: Scalars["ID"]["output"];
        lastUpdated: Scalars["DateTime"]["output"];
        to: GraphJiraVulnerability;
    };

export type GraphSecurityContainerAssociatedToVulnerabilityRelationshipConnection =
    {
        __typename?: "GraphSecurityContainerAssociatedToVulnerabilityRelationshipConnection";
        edges: Array<
            Maybe<GraphSecurityContainerAssociatedToVulnerabilityRelationshipEdge>
        >;
        fromId?: Maybe<Scalars["ID"]["output"]>;
        pageInfo: PageInfo;
        toId?: Maybe<Scalars["ID"]["output"]>;
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

export type GraphSecurityContainerAssociatedToVulnerabilityRelationshipEdge = {
    __typename?: "GraphSecurityContainerAssociatedToVulnerabilityRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSecurityContainerAssociatedToVulnerabilityRelationship;
};

export type GraphSimpleRelationship = {
    __typename?: "GraphSimpleRelationship";
    from: GraphGeneric;
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphGeneric;
    type: Scalars["String"]["output"];
};

export type GraphSimpleRelationshipConnection = {
    __typename?: "GraphSimpleRelationshipConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    relationships: Array<Maybe<GraphSimpleRelationship>>;
};

export type GraphSprintAssociatedBuildRelationship = Node & {
    __typename?: "GraphSprintAssociatedBuildRelationship";
    from: GraphJiraSprint;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataSprintAssociatedBuildOutput>;
    to: GraphJiraBuild;
    toMetadata?: Maybe<GraphCreateMetadataSprintAssociatedBuildJiraBuildOutput>;
};

export type GraphSprintAssociatedBuildRelationshipConnection = {
    __typename?: "GraphSprintAssociatedBuildRelationshipConnection";
    edges: Array<Maybe<GraphSprintAssociatedBuildRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphSprintAssociatedBuildRelationshipEdge = {
    __typename?: "GraphSprintAssociatedBuildRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSprintAssociatedBuildRelationship;
};

export type GraphSprintAssociatedDeploymentRelationship = Node & {
    __typename?: "GraphSprintAssociatedDeploymentRelationship";
    from: GraphJiraSprint;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentOutput>;
    to: GraphJiraDeployment;
    toMetadata?: Maybe<GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutput>;
};

export type GraphSprintAssociatedDeploymentRelationshipConnection = {
    __typename?: "GraphSprintAssociatedDeploymentRelationshipConnection";
    edges: Array<Maybe<GraphSprintAssociatedDeploymentRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphSprintAssociatedDeploymentRelationshipEdge = {
    __typename?: "GraphSprintAssociatedDeploymentRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSprintAssociatedDeploymentRelationship;
};

export type GraphSprintAssociatedPrRelationship = Node & {
    __typename?: "GraphSprintAssociatedPrRelationship";
    from: GraphJiraSprint;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataSprintAssociatedPrOutput>;
    to: GraphJiraPullRequest;
    toMetadata?: Maybe<GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutput>;
};

export type GraphSprintAssociatedPrRelationshipConnection = {
    __typename?: "GraphSprintAssociatedPrRelationshipConnection";
    edges: Array<Maybe<GraphSprintAssociatedPrRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphSprintAssociatedPrRelationshipEdge = {
    __typename?: "GraphSprintAssociatedPrRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSprintAssociatedPrRelationship;
};

export type GraphSprintAssociatedVulnerabilityRelationship = Node & {
    __typename?: "GraphSprintAssociatedVulnerabilityRelationship";
    from: GraphJiraSprint;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityOutput>;
    to: GraphJiraVulnerability;
    toMetadata?: Maybe<GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutput>;
};

export type GraphSprintAssociatedVulnerabilityRelationshipConnection = {
    __typename?: "GraphSprintAssociatedVulnerabilityRelationshipConnection";
    edges: Array<Maybe<GraphSprintAssociatedVulnerabilityRelationshipEdge>>;
    fromId?: Maybe<Scalars["ID"]["output"]>;
    pageInfo: PageInfo;
    toId?: Maybe<Scalars["ID"]["output"]>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphSprintAssociatedVulnerabilityRelationshipEdge = {
    __typename?: "GraphSprintAssociatedVulnerabilityRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSprintAssociatedVulnerabilityRelationship;
};

export type GraphSprintContainsIssuePayload = Payload & {
    __typename?: "GraphSprintContainsIssuePayload";
    errors?: Maybe<Array<MutationError>>;
    sprintContainsIssueRelationship: Array<
        Maybe<GraphSprintContainsIssueRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphSprintContainsIssueRelationship = Node & {
    __typename?: "GraphSprintContainsIssueRelationship";
    from: GraphJiraSprint;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    relationshipMetadata?: Maybe<GraphCreateMetadataSprintContainsIssueOutput>;
    to: GraphJiraIssue;
    toMetadata?: Maybe<GraphCreateMetadataSprintContainsIssueJiraIssueOutput>;
};

export type GraphSprintContainsIssueRelationshipConnection = {
    __typename?: "GraphSprintContainsIssueRelationshipConnection";
    edges?: Maybe<Array<Maybe<GraphSprintContainsIssueRelationshipEdge>>>;
    fromId?: Maybe<Scalars["ID"]["output"]>;
    pageInfo: PageInfo;
    toId?: Maybe<Scalars["ID"]["output"]>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphSprintContainsIssueRelationshipEdge = {
    __typename?: "GraphSprintContainsIssueRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSprintContainsIssueRelationship;
};

export type GraphSprintRetrospectivePagePayload = Payload & {
    __typename?: "GraphSprintRetrospectivePagePayload";
    errors?: Maybe<Array<MutationError>>;
    sprintRetrospectivePageRelationship: Array<
        Maybe<GraphSprintRetrospectivePageRelationship>
    >;
    success: Scalars["Boolean"]["output"];
};

export type GraphSprintRetrospectivePageRelationship = Node & {
    __typename?: "GraphSprintRetrospectivePageRelationship";
    from: GraphJiraSprint;
    id: Scalars["ID"]["output"];
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphConfluencePage;
};

export type GraphSprintRetrospectivePageRelationshipConnection = {
    __typename?: "GraphSprintRetrospectivePageRelationshipConnection";
    edges: Array<Maybe<GraphSprintRetrospectivePageRelationshipEdge>>;
    pageInfo: PageInfo;
};

export type GraphSprintRetrospectivePageRelationshipEdge = {
    __typename?: "GraphSprintRetrospectivePageRelationshipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphSprintRetrospectivePageRelationship;
};

export type GraphStore = {
    __typename?: "GraphStore";
    /**
     * Given an id of type(s) [ati:cloud:jira:operations-workspace, ati:cloud:graph:operations-workspace], fetches type(s) [ati:cloud:jira:connect-app] as defined by app-installation-associated-to-operations-workspace.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAppInstallationAssociatedToOperationsWorkspace")' query directive to the 'appInstallationAssociatedToOperationsWorkspaceInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use appInstallationAssociatedToOperationsWorkspaceInverse
     */
    appInstallationAssociatedToOperationsWorkspaceInverseRelationship?: Maybe<GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:connect-app], fetches type(s) [ati:cloud:jira:operations-workspace, ati:cloud:graph:operations-workspace] as defined by app-installation-associated-to-operations-workspace.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAppInstallationAssociatedToOperationsWorkspace")' query directive to the 'appInstallationAssociatedToOperationsWorkspaceRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use appInstallationAssociatedToOperationsWorkspace
     */
    appInstallationAssociatedToOperationsWorkspaceRelationship?: Maybe<GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:security-workspace, ati:cloud:graph:security-workspace], fetches type(s) [ati:cloud:jira:connect-app] as defined by app-installation-associated-to-security-workspace.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAppInstallationAssociatedToSecurityWorkspace")' query directive to the 'appInstallationAssociatedToSecurityWorkspaceInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use appInstallationAssociatedToSecurityWorkspaceInverse
     */
    appInstallationAssociatedToSecurityWorkspaceInverseRelationship?: Maybe<GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:connect-app], fetches type(s) [ati:cloud:jira:security-workspace, ati:cloud:graph:security-workspace] as defined by app-installation-associated-to-security-workspace.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAppInstallationAssociatedToSecurityWorkspace")' query directive to the 'appInstallationAssociatedToSecurityWorkspaceRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use appInstallationAssociatedToSecurityWorkspace
     */
    appInstallationAssociatedToSecurityWorkspaceRelationship?: Maybe<GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:identity:team] as defined by atlas-goal-has-contributor.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasContributor")' query directive to the 'atlasGoalHasContributor' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasContributor?: Maybe<GraphStoreSimplifiedAtlasGoalHasContributorConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:team], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-contributor.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasContributor")' query directive to the 'atlasGoalHasContributorInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasContributorInverse?: Maybe<GraphStoreSimplifiedAtlasGoalHasContributorInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:identity:user] as defined by atlas-goal-has-follower.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasFollower")' query directive to the 'atlasGoalHasFollower' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasFollower?: Maybe<GraphStoreSimplifiedAtlasGoalHasFollowerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-follower.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasFollower")' query directive to the 'atlasGoalHasFollowerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasFollowerInverse?: Maybe<GraphStoreSimplifiedAtlasGoalHasFollowerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:townsquare:goal-update] as defined by atlas-goal-has-goal-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasGoalUpdate")' query directive to the 'atlasGoalHasGoalUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasGoalUpdate?: Maybe<GraphStoreSimplifiedAtlasGoalHasGoalUpdateConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal-update], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-goal-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasGoalUpdate")' query directive to the 'atlasGoalHasGoalUpdateInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasGoalUpdateInverse?: Maybe<GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:identity:user] as defined by atlas-goal-has-owner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasOwner")' query directive to the 'atlasGoalHasOwner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasOwner?: Maybe<GraphStoreSimplifiedAtlasGoalHasOwnerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-owner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasOwner")' query directive to the 'atlasGoalHasOwnerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasOwnerInverse?: Maybe<GraphStoreSimplifiedAtlasGoalHasOwnerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-sub-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasSubAtlasGoal")' query directive to the 'atlasGoalHasSubAtlasGoal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasSubAtlasGoal?: Maybe<GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-sub-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasSubAtlasGoal")' query directive to the 'atlasGoalHasSubAtlasGoalInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasSubAtlasGoalInverse?: Maybe<GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:townsquare:goal-update] as defined by atlas-goal-has-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasUpdate")' query directive to the 'atlasGoalHasUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasUpdate?: Maybe<GraphStoreSimplifiedAtlasGoalHasUpdateConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal-update], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-goal-has-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasGoalHasUpdate")' query directive to the 'atlasGoalHasUpdateInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasGoalHasUpdateInverse?: Maybe<GraphStoreSimplifiedAtlasGoalHasUpdateInverseConnection>;
    /**
     * Return Atlas home feed for a given user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasHomeFeed")' query directive to the 'atlasHomeFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasHomeFeed: GraphStoreAtlasHomeQueryConnection;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-project-contributes-to-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectContributesToAtlasGoal")' query directive to the 'atlasProjectContributesToAtlasGoal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectContributesToAtlasGoal?: Maybe<GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-contributes-to-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectContributesToAtlasGoal")' query directive to the 'atlasProjectContributesToAtlasGoalInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectContributesToAtlasGoalInverse?: Maybe<GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-contributes-to-atlas-goal.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectContributesToAtlasGoal")' query directive to the 'atlasProjectContributesToAtlasGoalInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use atlasProjectContributesToAtlasGoalInverse
     */
    atlasProjectContributesToAtlasGoalInverseRelationship?: Maybe<GraphStoreFullAtlasProjectContributesToAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:goal] as defined by atlas-project-contributes-to-atlas-goal.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectContributesToAtlasGoal")' query directive to the 'atlasProjectContributesToAtlasGoalRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use atlasProjectContributesToAtlasGoal
     */
    atlasProjectContributesToAtlasGoalRelationship?: Maybe<GraphStoreFullAtlasProjectContributesToAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-depends-on-atlas-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectDependsOnAtlasProject")' query directive to the 'atlasProjectDependsOnAtlasProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectDependsOnAtlasProject?: Maybe<GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-depends-on-atlas-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectDependsOnAtlasProject")' query directive to the 'atlasProjectDependsOnAtlasProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectDependsOnAtlasProjectInverse?: Maybe<GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:team] as defined by atlas-project-has-contributor.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasContributor")' query directive to the 'atlasProjectHasContributor' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasContributor?: Maybe<GraphStoreSimplifiedAtlasProjectHasContributorConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:team], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-has-contributor.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasContributor")' query directive to the 'atlasProjectHasContributorInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasContributorInverse?: Maybe<GraphStoreSimplifiedAtlasProjectHasContributorInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:identity:user] as defined by atlas-project-has-follower.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasFollower")' query directive to the 'atlasProjectHasFollower' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasFollower?: Maybe<GraphStoreSimplifiedAtlasProjectHasFollowerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-has-follower.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasFollower")' query directive to the 'atlasProjectHasFollowerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasFollowerInverse?: Maybe<GraphStoreSimplifiedAtlasProjectHasFollowerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:identity:user] as defined by atlas-project-has-owner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasOwner")' query directive to the 'atlasProjectHasOwner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasOwner?: Maybe<GraphStoreSimplifiedAtlasProjectHasOwnerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-has-owner.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasOwner")' query directive to the 'atlasProjectHasOwnerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasOwnerInverse?: Maybe<GraphStoreSimplifiedAtlasProjectHasOwnerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:project-update] as defined by atlas-project-has-project-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasProjectUpdate")' query directive to the 'atlasProjectHasProjectUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasProjectUpdate?: Maybe<GraphStoreSimplifiedAtlasProjectHasProjectUpdateConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project-update], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-has-project-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasProjectUpdate")' query directive to the 'atlasProjectHasProjectUpdateInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasProjectUpdateInverse?: Maybe<GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:project-update] as defined by atlas-project-has-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasUpdate")' query directive to the 'atlasProjectHasUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasUpdate?: Maybe<GraphStoreSimplifiedAtlasProjectHasUpdateConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project-update], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-has-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectHasUpdate")' query directive to the 'atlasProjectHasUpdateInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectHasUpdateInverse?: Maybe<GraphStoreSimplifiedAtlasProjectHasUpdateInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-is-related-to-atlas-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectIsRelatedToAtlasProject")' query directive to the 'atlasProjectIsRelatedToAtlasProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectIsRelatedToAtlasProject?: Maybe<GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-is-related-to-atlas-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectIsRelatedToAtlasProject")' query directive to the 'atlasProjectIsRelatedToAtlasProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectIsRelatedToAtlasProjectInverse?: Maybe<GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:jira:issue] as defined by atlas-project-is-tracked-on-jira-epic.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectIsTrackedOnJiraEpic")' query directive to the 'atlasProjectIsTrackedOnJiraEpic' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectIsTrackedOnJiraEpic?: Maybe<GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-is-tracked-on-jira-epic.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectIsTrackedOnJiraEpic")' query directive to the 'atlasProjectIsTrackedOnJiraEpicInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlasProjectIsTrackedOnJiraEpicInverse?: Maybe<GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:townsquare:project] as defined by atlas-project-is-tracked-on-jira-epic.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectIsTrackedOnJiraEpic")' query directive to the 'atlasProjectIsTrackedOnJiraEpicInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use atlasProjectIsTrackedOnJiraEpicInverse
     */
    atlasProjectIsTrackedOnJiraEpicInverseRelationship?: Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:jira:issue] as defined by atlas-project-is-tracked-on-jira-epic.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreAtlasProjectIsTrackedOnJiraEpic")' query directive to the 'atlasProjectIsTrackedOnJiraEpicRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use atlasProjectIsTrackedOnJiraEpic
     */
    atlasProjectIsTrackedOnJiraEpicRelationship?: Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira-software:board], fetches type(s) [ati:cloud:jira:project] as defined by board-belongs-to-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreBoardBelongsToProject")' query directive to the 'boardBelongsToProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    boardBelongsToProject?: Maybe<GraphStoreSimplifiedBoardBelongsToProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira-software:board] as defined by board-belongs-to-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreBoardBelongsToProject")' query directive to the 'boardBelongsToProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    boardBelongsToProjectInverse?: Maybe<GraphStoreSimplifiedBoardBelongsToProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:calendar-event], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by calendar-has-linked-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreCalendarHasLinkedDocument")' query directive to the 'calendarHasLinkedDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    calendarHasLinkedDocument?: Maybe<GraphStoreSimplifiedCalendarHasLinkedDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:graph:calendar-event] as defined by calendar-has-linked-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreCalendarHasLinkedDocument")' query directive to the 'calendarHasLinkedDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    calendarHasLinkedDocumentInverse?: Maybe<GraphStoreSimplifiedCalendarHasLinkedDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by component-impacted-by-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentImpactedByIncident")' query directive to the 'componentImpactedByIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentImpactedByIncident?: Maybe<GraphStoreSimplifiedComponentImpactedByIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] as defined by component-impacted-by-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentImpactedByIncident")' query directive to the 'componentImpactedByIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentImpactedByIncidentInverse?: Maybe<GraphStoreSimplifiedComponentImpactedByIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] as defined by component-impacted-by-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentImpactedByIncident")' query directive to the 'componentImpactedByIncidentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use componentImpactedByIncidentInverse
     */
    componentImpactedByIncidentInverseRelationship?: Maybe<GraphStoreFullComponentImpactedByIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by component-impacted-by-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentImpactedByIncident")' query directive to the 'componentImpactedByIncidentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use componentImpactedByIncident
     */
    componentImpactedByIncidentRelationship?: Maybe<GraphStoreFullComponentImpactedByIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component-link], fetches type(s) [ati:cloud:jira:project] as defined by component-link-is-jira-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentLinkIsJiraProject")' query directive to the 'componentLinkIsJiraProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentLinkIsJiraProject?: Maybe<GraphStoreSimplifiedComponentLinkIsJiraProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component, ati:cloud:graph:service, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component], fetches type(s) [ati:cloud:jira:issue] as defined by component-linked-jsw-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentLinkedJswIssue")' query directive to the 'componentLinkedJswIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentLinkedJswIssue?: Maybe<GraphStoreSimplifiedComponentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:compass:component, ati:cloud:graph:service, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] as defined by component-linked-jsw-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentLinkedJswIssue")' query directive to the 'componentLinkedJswIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    componentLinkedJswIssueInverse?: Maybe<GraphStoreSimplifiedComponentLinkedJswIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:compass:component, ati:cloud:graph:service, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] as defined by component-linked-jsw-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentLinkedJswIssue")' query directive to the 'componentLinkedJswIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use componentLinkedJswIssueInverse
     */
    componentLinkedJswIssueInverseRelationship?: Maybe<GraphStoreFullComponentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component, ati:cloud:graph:service, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component], fetches type(s) [ati:cloud:jira:issue] as defined by component-linked-jsw-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentLinkedJswIssue")' query directive to the 'componentLinkedJswIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use componentLinkedJswIssue
     */
    componentLinkedJswIssueRelationship?: Maybe<GraphStoreFullComponentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:confluence:comment] as defined by confluence-blogpost-has-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceBlogpostHasComment")' query directive to the 'confluenceBlogpostHasComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceBlogpostHasComment?: Maybe<GraphStoreSimplifiedConfluenceBlogpostHasCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:confluence:blogpost] as defined by confluence-blogpost-has-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceBlogpostHasComment")' query directive to the 'confluenceBlogpostHasCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceBlogpostHasCommentInverse?: Maybe<GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by confluence-blogpost-shared-with-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceBlogpostSharedWithUser")' query directive to the 'confluenceBlogpostSharedWithUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceBlogpostSharedWithUser?: Maybe<GraphStoreSimplifiedConfluenceBlogpostSharedWithUserConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by confluence-blogpost-shared-with-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceBlogpostSharedWithUser")' query directive to the 'confluenceBlogpostSharedWithUserInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceBlogpostSharedWithUserInverse?: Maybe<GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:confluence:comment] as defined by confluence-page-has-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasComment")' query directive to the 'confluencePageHasComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasComment?: Maybe<GraphStoreSimplifiedConfluencePageHasCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:confluence:page] as defined by confluence-page-has-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasComment")' query directive to the 'confluencePageHasCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasCommentInverse?: Maybe<GraphStoreSimplifiedConfluencePageHasCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page, ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:confluence:comment] as defined by confluence-page-has-confluence-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasConfluenceComment")' query directive to the 'confluencePageHasConfluenceComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasConfluenceComment?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:confluence:page, ati:cloud:confluence:blogpost] as defined by confluence-page-has-confluence-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasConfluenceComment")' query directive to the 'confluencePageHasConfluenceCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasConfluenceCommentInverse?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:confluence:database] as defined by confluence-page-has-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasConfluenceDatabase")' query directive to the 'confluencePageHasConfluenceDatabase' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasConfluenceDatabase?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:database], fetches type(s) [ati:cloud:confluence:page] as defined by confluence-page-has-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasConfluenceDatabase")' query directive to the 'confluencePageHasConfluenceDatabaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasConfluenceDatabaseInverse?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:confluence:page] as defined by confluence-page-has-parent-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasParentPage")' query directive to the 'confluencePageHasParentPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasParentPage?: Maybe<GraphStoreSimplifiedConfluencePageHasParentPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:confluence:page] as defined by confluence-page-has-parent-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageHasParentPage")' query directive to the 'confluencePageHasParentPageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageHasParentPageInverse?: Maybe<GraphStoreSimplifiedConfluencePageHasParentPageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:group], fetches type(s) [ati:cloud:confluence:page] as defined by confluence-page-shared-with-group.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageSharedWithGroup")' query directive to the 'confluencePageSharedWithGroupInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageSharedWithGroupInverse?: Maybe<GraphStoreSimplifiedConfluencePageSharedWithGroupInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by confluence-page-shared-with-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageSharedWithUser")' query directive to the 'confluencePageSharedWithUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageSharedWithUser?: Maybe<GraphStoreSimplifiedConfluencePageSharedWithUserConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by confluence-page-shared-with-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluencePageSharedWithUser")' query directive to the 'confluencePageSharedWithUserInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluencePageSharedWithUserInverse?: Maybe<GraphStoreSimplifiedConfluencePageSharedWithUserInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:confluence:blogpost] as defined by confluence-space-has-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceBlogpost")' query directive to the 'confluenceSpaceHasConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceBlogpost?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:confluence:space] as defined by confluence-space-has-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceBlogpost")' query directive to the 'confluenceSpaceHasConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:confluence:database] as defined by confluence-space-has-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceDatabase")' query directive to the 'confluenceSpaceHasConfluenceDatabase' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceDatabase?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:database], fetches type(s) [ati:cloud:confluence:space] as defined by confluence-space-has-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceDatabase")' query directive to the 'confluenceSpaceHasConfluenceDatabaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceDatabaseInverse?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:confluence:folder] as defined by confluence-space-has-confluence-folder.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceFolder")' query directive to the 'confluenceSpaceHasConfluenceFolder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceFolder?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:folder], fetches type(s) [ati:cloud:confluence:space] as defined by confluence-space-has-confluence-folder.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceFolder")' query directive to the 'confluenceSpaceHasConfluenceFolderInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceFolderInverse?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by confluence-space-has-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceWhiteboard")' query directive to the 'confluenceSpaceHasConfluenceWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceWhiteboard?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:confluence:space] as defined by confluence-space-has-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConfluenceSpaceHasConfluenceWhiteboard")' query directive to the 'confluenceSpaceHasConfluenceWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    confluenceSpaceHasConfluenceWhiteboardInverse?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file] as defined by content-referenced-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreContentReferencedEntity")' query directive to the 'contentReferencedEntity' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentReferencedEntity?: Maybe<GraphStoreSimplifiedContentReferencedEntityConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file] as defined by content-referenced-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreContentReferencedEntity")' query directive to the 'contentReferencedEntityBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentReferencedEntityBatch?: Maybe<GraphStoreBatchContentReferencedEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] as defined by content-referenced-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreContentReferencedEntity")' query directive to the 'contentReferencedEntityInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentReferencedEntityInverse?: Maybe<GraphStoreSimplifiedContentReferencedEntityInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] as defined by content-referenced-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreContentReferencedEntity")' query directive to the 'contentReferencedEntityInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    contentReferencedEntityInverseBatch?: Maybe<GraphStoreBatchContentReferencedEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] as defined by content-referenced-entity.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreContentReferencedEntity")' query directive to the 'contentReferencedEntityInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use contentReferencedEntityInverse
     */
    contentReferencedEntityInverseRelationship?: Maybe<GraphStoreFullContentReferencedEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file] as defined by content-referenced-entity.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreContentReferencedEntity")' query directive to the 'contentReferencedEntityRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use contentReferencedEntity
     */
    contentReferencedEntityRelationship?: Maybe<GraphStoreFullContentReferencedEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:conversation], fetches type(s) [ati:cloud:graph:message] as defined by conversation-has-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConversationHasMessage")' query directive to the 'conversationHasMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    conversationHasMessage?: Maybe<GraphStoreSimplifiedConversationHasMessageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:message], fetches type(s) [ati:cloud:graph:conversation] as defined by conversation-has-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreConversationHasMessage")' query directive to the 'conversationHasMessageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    conversationHasMessageInverse?: Maybe<GraphStoreSimplifiedConversationHasMessageInverseConnection>;
    /**
     * Given any CypherQuery, parse and return resources asked in the query.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreCypherQuery")' query directive to the 'cypherQuery' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    cypherQuery: GraphStoreCypherQueryConnection;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] as defined by deployment-contains-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreDeploymentContainsCommit")' query directive to the 'deploymentContainsCommit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deploymentContainsCommit?: Maybe<GraphStoreSimplifiedDeploymentContainsCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by deployment-contains-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreDeploymentContainsCommit")' query directive to the 'deploymentContainsCommitInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deploymentContainsCommitInverse?: Maybe<GraphStoreSimplifiedDeploymentContainsCommitInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:worker], fetches type(s) [ati:cloud:identity:third-party-user] as defined by external-worker-conflates-to-identity-3p-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreExternalWorkerConflatesToIdentity3pUser")' query directive to the 'externalWorkerConflatesToIdentity3pUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    externalWorkerConflatesToIdentity3pUser?: Maybe<GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserConnection>;
    /**
     * Given any ARI, fetch all ARIs associated to that ARI via any relationship.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFetchAllRelationships")' query directive to the 'fetchAllRelationships' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    fetchAllRelationships: GraphStoreAllRelationshipsConnection;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:graph:project] as defined by focus-area-associated-to-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaAssociatedToProject")' query directive to the 'focusAreaAssociatedToProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaAssociatedToProject?: Maybe<GraphStoreSimplifiedFocusAreaAssociatedToProjectConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:graph:project] as defined by focus-area-associated-to-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaAssociatedToProject")' query directive to the 'focusAreaAssociatedToProjectBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaAssociatedToProjectBatch?: Maybe<GraphStoreBatchFocusAreaAssociatedToProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:project], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-associated-to-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaAssociatedToProject")' query directive to the 'focusAreaAssociatedToProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaAssociatedToProjectInverse?: Maybe<GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:graph:project], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-associated-to-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaAssociatedToProject")' query directive to the 'focusAreaAssociatedToProjectInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaAssociatedToProjectInverseBatch?: Maybe<GraphStoreBatchFocusAreaAssociatedToProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:townsquare:goal] as defined by focus-area-has-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasAtlasGoal")' query directive to the 'focusAreaHasAtlasGoal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasAtlasGoal?: Maybe<GraphStoreSimplifiedFocusAreaHasAtlasGoalConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:townsquare:goal] as defined by focus-area-has-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasAtlasGoal")' query directive to the 'focusAreaHasAtlasGoalBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasAtlasGoalBatch?: Maybe<GraphStoreBatchFocusAreaHasAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasAtlasGoal")' query directive to the 'focusAreaHasAtlasGoalInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasAtlasGoalInverse?: Maybe<GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasAtlasGoal")' query directive to the 'focusAreaHasAtlasGoalInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasAtlasGoalInverseBatch?: Maybe<GraphStoreBatchFocusAreaHasAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasFocusArea")' query directive to the 'focusAreaHasFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasFocusArea?: Maybe<GraphStoreSimplifiedFocusAreaHasFocusAreaConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasFocusArea")' query directive to the 'focusAreaHasFocusAreaBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasFocusAreaBatch?: Maybe<GraphStoreBatchFocusAreaHasFocusAreaConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasFocusArea")' query directive to the 'focusAreaHasFocusAreaInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasFocusAreaInverse?: Maybe<GraphStoreSimplifiedFocusAreaHasFocusAreaInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasFocusArea")' query directive to the 'focusAreaHasFocusAreaInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasFocusAreaInverseBatch?: Maybe<GraphStoreBatchFocusAreaHasFocusAreaConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:confluence:page] as defined by focus-area-has-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasPage")' query directive to the 'focusAreaHasPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasPage?: Maybe<GraphStoreSimplifiedFocusAreaHasPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasPage")' query directive to the 'focusAreaHasPageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasPageInverse?: Maybe<GraphStoreSimplifiedFocusAreaHasPageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:townsquare:project, ati:cloud:jira:issue, ati:cloud:jira-align:project] as defined by focus-area-has-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasProject")' query directive to the 'focusAreaHasProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasProject?: Maybe<GraphStoreSimplifiedFocusAreaHasProjectConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:townsquare:project, ati:cloud:jira:issue, ati:cloud:jira-align:project] as defined by focus-area-has-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasProject")' query directive to the 'focusAreaHasProjectBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasProjectBatch?: Maybe<GraphStoreBatchFocusAreaHasProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project, ati:cloud:jira:issue, ati:cloud:jira-align:project], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasProject")' query directive to the 'focusAreaHasProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasProjectInverse?: Maybe<GraphStoreSimplifiedFocusAreaHasProjectInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:townsquare:project, ati:cloud:jira:issue, ati:cloud:jira-align:project], fetches type(s) [ati:cloud:mercury:focus-area] as defined by focus-area-has-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFocusAreaHasProject")' query directive to the 'focusAreaHasProjectInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHasProjectInverseBatch?: Maybe<GraphStoreBatchFocusAreaHasProjectConnection>;
    /**
     * Given an id of type(s) [ati:third-party:google.google-drive:document, ati:third-party:notion.notion:document], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by graph-document-3p-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreGraphDocument3pDocument")' query directive to the 'graphDocument3pDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    graphDocument3pDocumentInverse?: Maybe<GraphStoreSimplifiedGraphDocument3pDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:third-party:google.google-drive:document, ati:third-party:notion.notion:document, ati:third-party:zeplin.zeplin:remote-link, ati:third-party:adobe.adobexd:remote-link, ati:third-party:amplitude.amplitude:remote-link, ati:third-party:clickup.clickup:remote-link, ati:third-party:dovetail.dovetail:remote-link, ati:third-party:stripe.stripe:remote-link, ati:third-party:microsoft.power-bi:remote-link, ati:third-party:pipedrive.pipedrive:remote-link, ati:third-party:mural.mural:remote-link, ati:third-party:cisco.webex:remote-link, ati:third-party:pagerduty.pagerduty:remote-link, ati:third-party:todoist.todoist:remote-link, ati:third-party:google.google-drive:remote-link, ati:third-party:github.github:remote-link], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document, ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by graph-entity-replicates-3p-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreGraphEntityReplicates3pEntity")' query directive to the 'graphEntityReplicates3pEntityInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    graphEntityReplicates3pEntityInverse?: Maybe<GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:group], fetches type(s) [ati:cloud:confluence:space] as defined by group-can-view-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreGroupCanViewConfluenceSpace")' query directive to the 'groupCanViewConfluenceSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    groupCanViewConfluenceSpace?: Maybe<GraphStoreSimplifiedGroupCanViewConfluenceSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by incident-associated-post-incident-review.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReview")' query directive to the 'incidentAssociatedPostIncidentReview' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReview?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by incident-associated-post-incident-review.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReview")' query directive to the 'incidentAssociatedPostIncidentReviewBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewBatch?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by incident-associated-post-incident-review.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReview")' query directive to the 'incidentAssociatedPostIncidentReviewInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewInverse?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by incident-associated-post-incident-review.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReview")' query directive to the 'incidentAssociatedPostIncidentReviewInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewInverseBatch?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by incident-associated-post-incident-review.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReview")' query directive to the 'incidentAssociatedPostIncidentReviewInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentAssociatedPostIncidentReviewInverse
     */
    incidentAssociatedPostIncidentReviewInverseRelationship?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] as defined by incident-associated-post-incident-review-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLink?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] as defined by incident-associated-post-incident-review-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLinkBatch?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-associated-post-incident-review-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLinkInverse?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-associated-post-incident-review-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentAssociatedPostIncidentReviewLinkInverseBatch?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-associated-post-incident-review-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentAssociatedPostIncidentReviewLinkInverse
     */
    incidentAssociatedPostIncidentReviewLinkInverseRelationship?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] as defined by incident-associated-post-incident-review-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'incidentAssociatedPostIncidentReviewLinkRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentAssociatedPostIncidentReviewLink
     */
    incidentAssociatedPostIncidentReviewLinkRelationship?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by incident-associated-post-incident-review.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReview")' query directive to the 'incidentAssociatedPostIncidentReviewRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentAssociatedPostIncidentReview
     */
    incidentAssociatedPostIncidentReviewRelationship?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue] as defined by incident-has-action-item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'incidentHasActionItem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItem?: Maybe<GraphStoreSimplifiedIncidentHasActionItemConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue] as defined by incident-has-action-item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'incidentHasActionItemBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItemBatch?: Maybe<GraphStoreBatchIncidentHasActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-has-action-item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'incidentHasActionItemInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItemInverse?: Maybe<GraphStoreSimplifiedIncidentHasActionItemInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-has-action-item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'incidentHasActionItemInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentHasActionItemInverseBatch?: Maybe<GraphStoreBatchIncidentHasActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-has-action-item.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'incidentHasActionItemInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentHasActionItemInverse
     */
    incidentHasActionItemInverseRelationship?: Maybe<GraphStoreFullIncidentHasActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue] as defined by incident-has-action-item.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'incidentHasActionItemRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentHasActionItem
     */
    incidentHasActionItemRelationship?: Maybe<GraphStoreFullIncidentHasActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue] as defined by incident-linked-jsw-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'incidentLinkedJswIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentLinkedJswIssue?: Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue] as defined by incident-linked-jsw-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'incidentLinkedJswIssueBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentLinkedJswIssueBatch?: Maybe<GraphStoreBatchIncidentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-linked-jsw-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'incidentLinkedJswIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentLinkedJswIssueInverse?: Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-linked-jsw-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'incidentLinkedJswIssueInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    incidentLinkedJswIssueInverseBatch?: Maybe<GraphStoreBatchIncidentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by incident-linked-jsw-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'incidentLinkedJswIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentLinkedJswIssueInverse
     */
    incidentLinkedJswIssueInverseRelationship?: Maybe<GraphStoreFullIncidentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:issue] as defined by incident-linked-jsw-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'incidentLinkedJswIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use incidentLinkedJswIssue
     */
    incidentLinkedJswIssueRelationship?: Maybe<GraphStoreFullIncidentLinkedJswIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by issue-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBranch")' query directive to the 'issueAssociatedBranch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedBranch?: Maybe<GraphStoreSimplifiedIssueAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBranch")' query directive to the 'issueAssociatedBranchInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedBranchInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedBranchInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-branch.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBranch")' query directive to the 'issueAssociatedBranchInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedBranchInverse
     */
    issueAssociatedBranchInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by issue-associated-branch.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBranch")' query directive to the 'issueAssociatedBranchRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedBranch
     */
    issueAssociatedBranchRelationship?: Maybe<GraphStoreFullIssueAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by issue-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBuild")' query directive to the 'issueAssociatedBuild' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedBuild?: Maybe<GraphStoreSimplifiedIssueAssociatedBuildConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by issue-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBuild")' query directive to the 'issueAssociatedBuildBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedBuildBatch?: Maybe<GraphStoreBatchIssueAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBuild")' query directive to the 'issueAssociatedBuildInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedBuildInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedBuildInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBuild")' query directive to the 'issueAssociatedBuildInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedBuildInverseBatch?: Maybe<GraphStoreBatchIssueAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBuild")' query directive to the 'issueAssociatedBuildInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedBuildInverse
     */
    issueAssociatedBuildInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by issue-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedBuild")' query directive to the 'issueAssociatedBuildRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedBuild
     */
    issueAssociatedBuildRelationship?: Maybe<GraphStoreFullIssueAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] as defined by issue-associated-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedCommit")' query directive to the 'issueAssociatedCommit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedCommit?: Maybe<GraphStoreSimplifiedIssueAssociatedCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedCommit")' query directive to the 'issueAssociatedCommitInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedCommitInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedCommitInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-commit.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedCommit")' query directive to the 'issueAssociatedCommitInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedCommitInverse
     */
    issueAssociatedCommitInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] as defined by issue-associated-commit.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedCommit")' query directive to the 'issueAssociatedCommitRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedCommit
     */
    issueAssociatedCommitRelationship?: Maybe<GraphStoreFullIssueAssociatedCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by issue-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDeployment")' query directive to the 'issueAssociatedDeployment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDeployment?: Maybe<GraphStoreSimplifiedIssueAssociatedDeploymentConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by issue-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDeployment")' query directive to the 'issueAssociatedDeploymentBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDeploymentBatch?: Maybe<GraphStoreBatchIssueAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDeployment")' query directive to the 'issueAssociatedDeploymentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDeploymentInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedDeploymentInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDeployment")' query directive to the 'issueAssociatedDeploymentInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDeploymentInverseBatch?: Maybe<GraphStoreBatchIssueAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDeployment")' query directive to the 'issueAssociatedDeploymentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedDeploymentInverse
     */
    issueAssociatedDeploymentInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by issue-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDeployment")' query directive to the 'issueAssociatedDeploymentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedDeployment
     */
    issueAssociatedDeploymentRelationship?: Maybe<GraphStoreFullIssueAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:design, ati:cloud:graph:design] as defined by issue-associated-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDesign")' query directive to the 'issueAssociatedDesign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDesign?: Maybe<GraphStoreSimplifiedIssueAssociatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:design, ati:cloud:graph:design], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDesign")' query directive to the 'issueAssociatedDesignInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedDesignInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedDesignInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:design, ati:cloud:graph:design], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-design.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDesign")' query directive to the 'issueAssociatedDesignInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedDesignInverse
     */
    issueAssociatedDesignInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:design, ati:cloud:graph:design] as defined by issue-associated-design.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDesign")' query directive to the 'issueAssociatedDesignRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedDesign
     */
    issueAssociatedDesignRelationship?: Maybe<GraphStoreFullIssueAssociatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by issue-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedFeatureFlag")' query directive to the 'issueAssociatedFeatureFlag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedFeatureFlag?: Maybe<GraphStoreSimplifiedIssueAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedFeatureFlag")' query directive to the 'issueAssociatedFeatureFlagInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedFeatureFlagInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedFeatureFlag")' query directive to the 'issueAssociatedFeatureFlagInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedFeatureFlagInverse
     */
    issueAssociatedFeatureFlagInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by issue-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedFeatureFlag")' query directive to the 'issueAssociatedFeatureFlagRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedFeatureFlag
     */
    issueAssociatedFeatureFlagRelationship?: Maybe<GraphStoreFullIssueAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue-remote-link] as defined by issue-associated-issue-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedIssueRemoteLink")' query directive to the 'issueAssociatedIssueRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedIssueRemoteLink?: Maybe<GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue-remote-link] as defined by issue-associated-issue-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedIssueRemoteLink")' query directive to the 'issueAssociatedIssueRemoteLinkBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedIssueRemoteLinkBatch?: Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue-remote-link], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-issue-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedIssueRemoteLink")' query directive to the 'issueAssociatedIssueRemoteLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedIssueRemoteLinkInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue-remote-link], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-issue-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedIssueRemoteLink")' query directive to the 'issueAssociatedIssueRemoteLinkInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedIssueRemoteLinkInverseBatch?: Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue-remote-link], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-issue-remote-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedIssueRemoteLink")' query directive to the 'issueAssociatedIssueRemoteLinkInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedIssueRemoteLinkInverse
     */
    issueAssociatedIssueRemoteLinkInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue-remote-link] as defined by issue-associated-issue-remote-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedIssueRemoteLink")' query directive to the 'issueAssociatedIssueRemoteLinkRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedIssueRemoteLink
     */
    issueAssociatedIssueRemoteLinkRelationship?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by issue-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedPr")' query directive to the 'issueAssociatedPr' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedPr?: Maybe<GraphStoreSimplifiedIssueAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedPr")' query directive to the 'issueAssociatedPrInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedPrInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedPrInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedPr")' query directive to the 'issueAssociatedPrInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedPrInverse
     */
    issueAssociatedPrInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by issue-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedPr")' query directive to the 'issueAssociatedPrRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedPr
     */
    issueAssociatedPrRelationship?: Maybe<GraphStoreFullIssueAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by issue-associated-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedRemoteLink")' query directive to the 'issueAssociatedRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedRemoteLink?: Maybe<GraphStoreSimplifiedIssueAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedRemoteLink")' query directive to the 'issueAssociatedRemoteLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueAssociatedRemoteLinkInverse?: Maybe<GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:jira:issue] as defined by issue-associated-remote-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedRemoteLink")' query directive to the 'issueAssociatedRemoteLinkInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedRemoteLinkInverse
     */
    issueAssociatedRemoteLinkInverseRelationship?: Maybe<GraphStoreFullIssueAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by issue-associated-remote-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedRemoteLink")' query directive to the 'issueAssociatedRemoteLinkRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueAssociatedRemoteLink
     */
    issueAssociatedRemoteLinkRelationship?: Maybe<GraphStoreFullIssueAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:compass:component] as defined by issue-changes-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueChangesComponent")' query directive to the 'issueChangesComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueChangesComponent?: Maybe<GraphStoreSimplifiedIssueChangesComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component], fetches type(s) [ati:cloud:jira:issue] as defined by issue-changes-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueChangesComponent")' query directive to the 'issueChangesComponentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueChangesComponentInverse?: Maybe<GraphStoreSimplifiedIssueChangesComponentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component], fetches type(s) [ati:cloud:jira:issue] as defined by issue-changes-component.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueChangesComponent")' query directive to the 'issueChangesComponentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueChangesComponentInverse
     */
    issueChangesComponentInverseRelationship?: Maybe<GraphStoreFullIssueChangesComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:compass:component] as defined by issue-changes-component.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueChangesComponent")' query directive to the 'issueChangesComponentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueChangesComponent
     */
    issueChangesComponentRelationship?: Maybe<GraphStoreFullIssueChangesComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by issue-has-assignee.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueHasAssignee")' query directive to the 'issueHasAssignee' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueHasAssignee?: Maybe<GraphStoreSimplifiedIssueHasAssigneeConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by issue-has-assignee.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueHasAssignee")' query directive to the 'issueHasAssigneeInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueHasAssigneeInverse?: Maybe<GraphStoreSimplifiedIssueHasAssigneeInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:devai:autodev-job], fetches type(s) [ati:cloud:jira:issue] as defined by issue-has-autodev-job.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueHasAutodevJob")' query directive to the 'issueHasAutodevJobInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueHasAutodevJobInverse?: Maybe<GraphStoreSimplifiedIssueHasAutodevJobInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:graph:conversation] as defined by issue-mentioned-in-conversation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueMentionedInConversation")' query directive to the 'issueMentionedInConversation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMentionedInConversation?: Maybe<GraphStoreSimplifiedIssueMentionedInConversationConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:conversation], fetches type(s) [ati:cloud:jira:issue] as defined by issue-mentioned-in-conversation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueMentionedInConversation")' query directive to the 'issueMentionedInConversationInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMentionedInConversationInverse?: Maybe<GraphStoreSimplifiedIssueMentionedInConversationInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:graph:message] as defined by issue-mentioned-in-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueMentionedInMessage")' query directive to the 'issueMentionedInMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMentionedInMessage?: Maybe<GraphStoreSimplifiedIssueMentionedInMessageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:message], fetches type(s) [ati:cloud:jira:issue] as defined by issue-mentioned-in-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueMentionedInMessage")' query directive to the 'issueMentionedInMessageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMentionedInMessageInverse?: Maybe<GraphStoreSimplifiedIssueMentionedInMessageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by issue-recursive-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueRecursiveAssociatedPr")' query directive to the 'issueRecursiveAssociatedPr' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueRecursiveAssociatedPr?: Maybe<GraphStoreSimplifiedIssueRecursiveAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:issue] as defined by issue-recursive-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueRecursiveAssociatedPr")' query directive to the 'issueRecursiveAssociatedPrInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueRecursiveAssociatedPrInverse?: Maybe<GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:issue] as defined by issue-recursive-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueRecursiveAssociatedPr")' query directive to the 'issueRecursiveAssociatedPrInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueRecursiveAssociatedPrInverse
     */
    issueRecursiveAssociatedPrInverseRelationship?: Maybe<GraphStoreFullIssueRecursiveAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by issue-recursive-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueRecursiveAssociatedPr")' query directive to the 'issueRecursiveAssociatedPrRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueRecursiveAssociatedPr
     */
    issueRecursiveAssociatedPrRelationship?: Maybe<GraphStoreFullIssueRecursiveAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by issue-to-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueToWhiteboard")' query directive to the 'issueToWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueToWhiteboard?: Maybe<GraphStoreSimplifiedIssueToWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:jira:issue] as defined by issue-to-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueToWhiteboard")' query directive to the 'issueToWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueToWhiteboardInverse?: Maybe<GraphStoreSimplifiedIssueToWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:jira:issue] as defined by issue-to-whiteboard.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueToWhiteboard")' query directive to the 'issueToWhiteboardInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueToWhiteboardInverse
     */
    issueToWhiteboardInverseRelationship?: Maybe<GraphStoreFullIssueToWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by issue-to-whiteboard.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueToWhiteboard")' query directive to the 'issueToWhiteboardRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use issueToWhiteboard
     */
    issueToWhiteboardRelationship?: Maybe<GraphStoreFullIssueToWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:townsquare:goal] as defined by jira-epic-contributes-to-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraEpicContributesToAtlasGoal")' query directive to the 'jiraEpicContributesToAtlasGoal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraEpicContributesToAtlasGoal?: Maybe<GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:jira:issue] as defined by jira-epic-contributes-to-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraEpicContributesToAtlasGoal")' query directive to the 'jiraEpicContributesToAtlasGoalInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraEpicContributesToAtlasGoalInverse?: Maybe<GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:jira:issue] as defined by jira-epic-contributes-to-atlas-goal.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraEpicContributesToAtlasGoal")' query directive to the 'jiraEpicContributesToAtlasGoalInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jiraEpicContributesToAtlasGoalInverse
     */
    jiraEpicContributesToAtlasGoalInverseRelationship?: Maybe<GraphStoreFullJiraEpicContributesToAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:townsquare:goal] as defined by jira-epic-contributes-to-atlas-goal.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraEpicContributesToAtlasGoal")' query directive to the 'jiraEpicContributesToAtlasGoalRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jiraEpicContributesToAtlasGoal
     */
    jiraEpicContributesToAtlasGoalRelationship?: Maybe<GraphStoreFullJiraEpicContributesToAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by jira-issue-blocked-by-jira-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraIssueBlockedByJiraIssue")' query directive to the 'jiraIssueBlockedByJiraIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraIssueBlockedByJiraIssue?: Maybe<GraphStoreSimplifiedJiraIssueBlockedByJiraIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by jira-issue-blocked-by-jira-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraIssueBlockedByJiraIssue")' query directive to the 'jiraIssueBlockedByJiraIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraIssueBlockedByJiraIssueInverse?: Maybe<GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:priority], fetches type(s) [ati:cloud:jira:issue] as defined by jira-issue-to-jira-priority.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraIssueToJiraPriority")' query directive to the 'jiraIssueToJiraPriorityInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraIssueToJiraPriorityInverse?: Maybe<GraphStoreSimplifiedJiraIssueToJiraPriorityInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:townsquare:goal] as defined by jira-project-associated-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraProjectAssociatedAtlasGoal")' query directive to the 'jiraProjectAssociatedAtlasGoal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraProjectAssociatedAtlasGoal?: Maybe<GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:jira:project] as defined by jira-project-associated-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraProjectAssociatedAtlasGoal")' query directive to the 'jiraProjectAssociatedAtlasGoalInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraProjectAssociatedAtlasGoalInverse?: Maybe<GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:jira:project] as defined by jira-project-associated-atlas-goal.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraProjectAssociatedAtlasGoal")' query directive to the 'jiraProjectAssociatedAtlasGoalInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jiraProjectAssociatedAtlasGoalInverse
     */
    jiraProjectAssociatedAtlasGoalInverseRelationship?: Maybe<GraphStoreFullJiraProjectAssociatedAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:townsquare:goal] as defined by jira-project-associated-atlas-goal.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJiraProjectAssociatedAtlasGoal")' query directive to the 'jiraProjectAssociatedAtlasGoalRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jiraProjectAssociatedAtlasGoal
     */
    jiraProjectAssociatedAtlasGoalRelationship?: Maybe<GraphStoreFullJiraProjectAssociatedAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by jsm-project-associated-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJsmProjectAssociatedService")' query directive to the 'jsmProjectAssociatedService' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmProjectAssociatedService?: Maybe<GraphStoreSimplifiedJsmProjectAssociatedServiceConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by jsm-project-associated-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJsmProjectAssociatedService")' query directive to the 'jsmProjectAssociatedServiceBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmProjectAssociatedServiceBatch?: Maybe<GraphStoreBatchJsmProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by jsm-project-associated-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJsmProjectAssociatedService")' query directive to the 'jsmProjectAssociatedServiceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmProjectAssociatedServiceInverse?: Maybe<GraphStoreSimplifiedJsmProjectAssociatedServiceInverseConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by jsm-project-associated-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJsmProjectAssociatedService")' query directive to the 'jsmProjectAssociatedServiceInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmProjectAssociatedServiceInverseBatch?: Maybe<GraphStoreBatchJsmProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by jsm-project-associated-service.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJsmProjectAssociatedService")' query directive to the 'jsmProjectAssociatedServiceInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jsmProjectAssociatedServiceInverse
     */
    jsmProjectAssociatedServiceInverseRelationship?: Maybe<GraphStoreFullJsmProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by jsm-project-associated-service.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJsmProjectAssociatedService")' query directive to the 'jsmProjectAssociatedServiceRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jsmProjectAssociatedService
     */
    jsmProjectAssociatedServiceRelationship?: Maybe<GraphStoreFullJsmProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] as defined by jsw-project-associated-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedComponent")' query directive to the 'jswProjectAssociatedComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jswProjectAssociatedComponent?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-associated-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedComponent")' query directive to the 'jswProjectAssociatedComponentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jswProjectAssociatedComponentInverse?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-associated-component.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedComponent")' query directive to the 'jswProjectAssociatedComponentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jswProjectAssociatedComponentInverse
     */
    jswProjectAssociatedComponentInverseRelationship?: Maybe<GraphStoreFullJswProjectAssociatedComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] as defined by jsw-project-associated-component.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedComponent")' query directive to the 'jswProjectAssociatedComponentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jswProjectAssociatedComponent
     */
    jswProjectAssociatedComponentRelationship?: Maybe<GraphStoreFullJswProjectAssociatedComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by jsw-project-associated-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedIncident")' query directive to the 'jswProjectAssociatedIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jswProjectAssociatedIncident?: Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-associated-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedIncident")' query directive to the 'jswProjectAssociatedIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jswProjectAssociatedIncidentInverse?: Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-associated-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedIncident")' query directive to the 'jswProjectAssociatedIncidentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jswProjectAssociatedIncidentInverse
     */
    jswProjectAssociatedIncidentInverseRelationship?: Maybe<GraphStoreFullJswProjectAssociatedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by jsw-project-associated-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedIncident")' query directive to the 'jswProjectAssociatedIncidentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jswProjectAssociatedIncident
     */
    jswProjectAssociatedIncidentRelationship?: Maybe<GraphStoreFullJswProjectAssociatedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-shares-component-with-jsm-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectSharesComponentWithJsmProject")' query directive to the 'jswProjectSharesComponentWithJsmProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jswProjectSharesComponentWithJsmProject?: Maybe<GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-shares-component-with-jsm-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectSharesComponentWithJsmProject")' query directive to the 'jswProjectSharesComponentWithJsmProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jswProjectSharesComponentWithJsmProjectInverse?: Maybe<GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-shares-component-with-jsm-project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectSharesComponentWithJsmProject")' query directive to the 'jswProjectSharesComponentWithJsmProjectInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jswProjectSharesComponentWithJsmProjectInverse
     */
    jswProjectSharesComponentWithJsmProjectInverseRelationship?: Maybe<GraphStoreFullJswProjectSharesComponentWithJsmProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by jsw-project-shares-component-with-jsm-project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectSharesComponentWithJsmProject")' query directive to the 'jswProjectSharesComponentWithJsmProjectRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use jswProjectSharesComponentWithJsmProject
     */
    jswProjectSharesComponentWithJsmProjectRelationship?: Maybe<GraphStoreFullJswProjectSharesComponentWithJsmProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:version] as defined by linked-project-has-version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreLinkedProjectHasVersion")' query directive to the 'linkedProjectHasVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedProjectHasVersion?: Maybe<GraphStoreSimplifiedLinkedProjectHasVersionConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:project] as defined by linked-project-has-version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreLinkedProjectHasVersion")' query directive to the 'linkedProjectHasVersionInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedProjectHasVersionInverse?: Maybe<GraphStoreSimplifiedLinkedProjectHasVersionInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:project] as defined by linked-project-has-version.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreLinkedProjectHasVersion")' query directive to the 'linkedProjectHasVersionInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use linkedProjectHasVersionInverse
     */
    linkedProjectHasVersionInverseRelationship?: Maybe<GraphStoreFullLinkedProjectHasVersionConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:version] as defined by linked-project-has-version.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreLinkedProjectHasVersion")' query directive to the 'linkedProjectHasVersionRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use linkedProjectHasVersion
     */
    linkedProjectHasVersionRelationship?: Maybe<GraphStoreFullLinkedProjectHasVersionConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:video], fetches type(s) [ati:cloud:identity:user] as defined by loom-video-shared-with-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreLoomVideoSharedWithUser")' query directive to the 'loomVideoSharedWithUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    loomVideoSharedWithUser?: Maybe<GraphStoreSimplifiedLoomVideoSharedWithUserConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:loom:video] as defined by loom-video-shared-with-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreLoomVideoSharedWithUser")' query directive to the 'loomVideoSharedWithUserInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    loomVideoSharedWithUserInverse?: Maybe<GraphStoreSimplifiedLoomVideoSharedWithUserInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:media:file], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] as defined by media-attached-to-content.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMediaAttachedToContent")' query directive to the 'mediaAttachedToContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mediaAttachedToContent?: Maybe<GraphStoreSimplifiedMediaAttachedToContentConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:media:file], fetches type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] as defined by media-attached-to-content.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMediaAttachedToContent")' query directive to the 'mediaAttachedToContentBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mediaAttachedToContentBatch?: Maybe<GraphStoreBatchMediaAttachedToContentConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:media:file] as defined by media-attached-to-content.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMediaAttachedToContent")' query directive to the 'mediaAttachedToContentInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mediaAttachedToContentInverseBatch?: Maybe<GraphStoreBatchMediaAttachedToContentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:meeting], fetches type(s) [ati:cloud:confluence:page] as defined by meeting-has-meeting-notes-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMeetingHasMeetingNotesPage")' query directive to the 'meetingHasMeetingNotesPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    meetingHasMeetingNotesPage?: Maybe<GraphStoreSimplifiedMeetingHasMeetingNotesPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:folder] as defined by meeting-recording-owner-has-meeting-notes-folder.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMeetingRecordingOwnerHasMeetingNotesFolder")' query directive to the 'meetingRecordingOwnerHasMeetingNotesFolder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    meetingRecordingOwnerHasMeetingNotesFolder?: Maybe<GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:folder], fetches type(s) [ati:cloud:identity:user] as defined by meeting-recording-owner-has-meeting-notes-folder.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMeetingRecordingOwnerHasMeetingNotesFolder")' query directive to the 'meetingRecordingOwnerHasMeetingNotesFolderInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    meetingRecordingOwnerHasMeetingNotesFolderInverse?: Maybe<GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:meeting-recurrence], fetches type(s) [ati:cloud:confluence:page] as defined by meeting-recurrence-has-meeting-recurrence-notes-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMeetingRecurrenceHasMeetingRecurrenceNotesPage")' query directive to the 'meetingRecurrenceHasMeetingRecurrenceNotesPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    meetingRecurrenceHasMeetingRecurrenceNotesPage?: Maybe<GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by operations-container-impacted-by-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImpactedByIncident")' query directive to the 'operationsContainerImpactedByIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    operationsContainerImpactedByIncident?: Maybe<GraphStoreSimplifiedOperationsContainerImpactedByIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:graph:service] as defined by operations-container-impacted-by-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImpactedByIncident")' query directive to the 'operationsContainerImpactedByIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    operationsContainerImpactedByIncidentInverse?: Maybe<GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:graph:service] as defined by operations-container-impacted-by-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImpactedByIncident")' query directive to the 'operationsContainerImpactedByIncidentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use operationsContainerImpactedByIncidentInverse
     */
    operationsContainerImpactedByIncidentInverseRelationship?: Maybe<GraphStoreFullOperationsContainerImpactedByIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by operations-container-impacted-by-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImpactedByIncident")' query directive to the 'operationsContainerImpactedByIncidentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use operationsContainerImpactedByIncident
     */
    operationsContainerImpactedByIncidentRelationship?: Maybe<GraphStoreFullOperationsContainerImpactedByIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:issue] as defined by operations-container-improved-by-action-item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImprovedByActionItem")' query directive to the 'operationsContainerImprovedByActionItem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    operationsContainerImprovedByActionItem?: Maybe<GraphStoreSimplifiedOperationsContainerImprovedByActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:graph:service] as defined by operations-container-improved-by-action-item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImprovedByActionItem")' query directive to the 'operationsContainerImprovedByActionItemInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    operationsContainerImprovedByActionItemInverse?: Maybe<GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:graph:service] as defined by operations-container-improved-by-action-item.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImprovedByActionItem")' query directive to the 'operationsContainerImprovedByActionItemInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use operationsContainerImprovedByActionItemInverse
     */
    operationsContainerImprovedByActionItemInverseRelationship?: Maybe<GraphStoreFullOperationsContainerImprovedByActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:issue] as defined by operations-container-improved-by-action-item.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreOperationsContainerImprovedByActionItem")' query directive to the 'operationsContainerImprovedByActionItemRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use operationsContainerImprovedByActionItem
     */
    operationsContainerImprovedByActionItemRelationship?: Maybe<GraphStoreFullOperationsContainerImprovedByActionItemConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:confluence:comment] as defined by parent-comment-has-child-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentCommentHasChildComment")' query directive to the 'parentCommentHasChildComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentCommentHasChildComment?: Maybe<GraphStoreSimplifiedParentCommentHasChildCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:confluence:comment] as defined by parent-comment-has-child-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentCommentHasChildComment")' query directive to the 'parentCommentHasChildCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentCommentHasChildCommentInverse?: Maybe<GraphStoreSimplifiedParentCommentHasChildCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by parent-document-has-child-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentDocumentHasChildDocument")' query directive to the 'parentDocumentHasChildDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentDocumentHasChildDocument?: Maybe<GraphStoreSimplifiedParentDocumentHasChildDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by parent-document-has-child-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentDocumentHasChildDocument")' query directive to the 'parentDocumentHasChildDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentDocumentHasChildDocumentInverse?: Maybe<GraphStoreSimplifiedParentDocumentHasChildDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by parent-document-has-child-document.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentDocumentHasChildDocument")' query directive to the 'parentDocumentHasChildDocumentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use parentDocumentHasChildDocumentInverse
     */
    parentDocumentHasChildDocumentInverseRelationship?: Maybe<GraphStoreFullParentDocumentHasChildDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by parent-document-has-child-document.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentDocumentHasChildDocument")' query directive to the 'parentDocumentHasChildDocumentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use parentDocumentHasChildDocument
     */
    parentDocumentHasChildDocumentRelationship?: Maybe<GraphStoreFullParentDocumentHasChildDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by parent-issue-has-child-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentIssueHasChildIssue")' query directive to the 'parentIssueHasChildIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentIssueHasChildIssue?: Maybe<GraphStoreSimplifiedParentIssueHasChildIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by parent-issue-has-child-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentIssueHasChildIssue")' query directive to the 'parentIssueHasChildIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentIssueHasChildIssueInverse?: Maybe<GraphStoreSimplifiedParentIssueHasChildIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by parent-issue-has-child-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentIssueHasChildIssue")' query directive to the 'parentIssueHasChildIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use parentIssueHasChildIssueInverse
     */
    parentIssueHasChildIssueInverseRelationship?: Maybe<GraphStoreFullParentIssueHasChildIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:issue] as defined by parent-issue-has-child-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentIssueHasChildIssue")' query directive to the 'parentIssueHasChildIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use parentIssueHasChildIssue
     */
    parentIssueHasChildIssueRelationship?: Maybe<GraphStoreFullParentIssueHasChildIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:message], fetches type(s) [ati:cloud:graph:message] as defined by parent-message-has-child-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentMessageHasChildMessage")' query directive to the 'parentMessageHasChildMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentMessageHasChildMessage?: Maybe<GraphStoreSimplifiedParentMessageHasChildMessageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:message], fetches type(s) [ati:cloud:graph:message] as defined by parent-message-has-child-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreParentMessageHasChildMessage")' query directive to the 'parentMessageHasChildMessageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentMessageHasChildMessageInverse?: Maybe<GraphStoreSimplifiedParentMessageHasChildMessageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:radar:position], fetches type(s) [ati:cloud:mercury:focus-area] as defined by position-allocated-to-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePositionAllocatedToFocusArea")' query directive to the 'positionAllocatedToFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    positionAllocatedToFocusArea?: Maybe<GraphStoreSimplifiedPositionAllocatedToFocusAreaConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:radar:position] as defined by position-allocated-to-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePositionAllocatedToFocusArea")' query directive to the 'positionAllocatedToFocusAreaInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    positionAllocatedToFocusAreaInverse?: Maybe<GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by pr-in-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePrInRepo")' query directive to the 'prInRepo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    prInRepo?: Maybe<GraphStoreSimplifiedPrInRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by pr-in-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePrInRepo")' query directive to the 'prInRepoInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    prInRepoInverse?: Maybe<GraphStoreSimplifiedPrInRepoInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by pr-in-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePrInRepo")' query directive to the 'prInRepoInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use prInRepoInverse
     */
    prInRepoInverseRelationship?: Maybe<GraphStoreFullPrInRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by pr-in-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePrInRepo")' query directive to the 'prInRepoRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use prInRepo
     */
    prInRepoRelationship?: Maybe<GraphStoreFullPrInRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by project-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBranch")' query directive to the 'projectAssociatedBranch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedBranch?: Maybe<GraphStoreSimplifiedProjectAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBranch")' query directive to the 'projectAssociatedBranchInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedBranchInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedBranchInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-branch.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBranch")' query directive to the 'projectAssociatedBranchInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedBranchInverse
     */
    projectAssociatedBranchInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by project-associated-branch.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBranch")' query directive to the 'projectAssociatedBranchRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedBranch
     */
    projectAssociatedBranchRelationship?: Maybe<GraphStoreFullProjectAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by project-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBuild")' query directive to the 'projectAssociatedBuild' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedBuild?: Maybe<GraphStoreSimplifiedProjectAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBuild")' query directive to the 'projectAssociatedBuildInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedBuildInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedBuildInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBuild")' query directive to the 'projectAssociatedBuildInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedBuildInverse
     */
    projectAssociatedBuildInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by project-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedBuild")' query directive to the 'projectAssociatedBuildRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedBuild
     */
    projectAssociatedBuildRelationship?: Maybe<GraphStoreFullProjectAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by project-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedDeployment")' query directive to the 'projectAssociatedDeployment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedDeployment?: Maybe<GraphStoreSimplifiedProjectAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedDeployment")' query directive to the 'projectAssociatedDeploymentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedDeploymentInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedDeploymentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedDeployment")' query directive to the 'projectAssociatedDeploymentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedDeploymentInverse
     */
    projectAssociatedDeploymentInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by project-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedDeployment")' query directive to the 'projectAssociatedDeploymentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedDeployment
     */
    projectAssociatedDeploymentRelationship?: Maybe<GraphStoreFullProjectAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by project-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedFeatureFlag")' query directive to the 'projectAssociatedFeatureFlag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedFeatureFlag?: Maybe<GraphStoreSimplifiedProjectAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedFeatureFlag")' query directive to the 'projectAssociatedFeatureFlagInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedFeatureFlagInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedFeatureFlag")' query directive to the 'projectAssociatedFeatureFlagInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedFeatureFlagInverse
     */
    projectAssociatedFeatureFlagInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by project-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedFeatureFlag")' query directive to the 'projectAssociatedFeatureFlagRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedFeatureFlag
     */
    projectAssociatedFeatureFlagRelationship?: Maybe<GraphStoreFullProjectAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue] as defined by project-associated-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedIncident")' query directive to the 'projectAssociatedIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedIncident?: Maybe<GraphStoreSimplifiedProjectAssociatedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedIncident")' query directive to the 'projectAssociatedIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedIncidentInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedIncident")' query directive to the 'projectAssociatedIncidentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedIncidentInverse
     */
    projectAssociatedIncidentInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue] as defined by project-associated-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedIncident")' query directive to the 'projectAssociatedIncidentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedIncident
     */
    projectAssociatedIncidentRelationship?: Maybe<GraphStoreFullProjectAssociatedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:opsgenie:team] as defined by project-associated-opsgenie-team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedOpsgenieTeam")' query directive to the 'projectAssociatedOpsgenieTeam' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedOpsgenieTeam?: Maybe<GraphStoreSimplifiedProjectAssociatedOpsgenieTeamConnection>;
    /**
     * Given an id of type(s) [ati:cloud:opsgenie:team], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-opsgenie-team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedOpsgenieTeam")' query directive to the 'projectAssociatedOpsgenieTeamInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedOpsgenieTeamInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:opsgenie:team], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-opsgenie-team.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedOpsgenieTeam")' query directive to the 'projectAssociatedOpsgenieTeamInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedOpsgenieTeamInverse
     */
    projectAssociatedOpsgenieTeamInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedOpsgenieTeamConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:opsgenie:team] as defined by project-associated-opsgenie-team.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedOpsgenieTeam")' query directive to the 'projectAssociatedOpsgenieTeamRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedOpsgenieTeam
     */
    projectAssociatedOpsgenieTeamRelationship?: Maybe<GraphStoreFullProjectAssociatedOpsgenieTeamConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by project-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedPr")' query directive to the 'projectAssociatedPr' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedPr?: Maybe<GraphStoreSimplifiedProjectAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedPr")' query directive to the 'projectAssociatedPrInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedPrInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedPrInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedPr")' query directive to the 'projectAssociatedPrInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedPrInverse
     */
    projectAssociatedPrInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by project-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedPr")' query directive to the 'projectAssociatedPrRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedPr
     */
    projectAssociatedPrRelationship?: Maybe<GraphStoreFullProjectAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by project-associated-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedRepo")' query directive to the 'projectAssociatedRepo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedRepo?: Maybe<GraphStoreSimplifiedProjectAssociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedRepo")' query directive to the 'projectAssociatedRepoInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedRepoInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedRepoInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedRepo")' query directive to the 'projectAssociatedRepoInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedRepoInverse
     */
    projectAssociatedRepoInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by project-associated-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedRepo")' query directive to the 'projectAssociatedRepoRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedRepo
     */
    projectAssociatedRepoRelationship?: Maybe<GraphStoreFullProjectAssociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by project-associated-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedService")' query directive to the 'projectAssociatedService' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedService?: Maybe<GraphStoreSimplifiedProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedService")' query directive to the 'projectAssociatedServiceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedServiceInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedServiceInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-service.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedService")' query directive to the 'projectAssociatedServiceInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedServiceInverse
     */
    projectAssociatedServiceInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by project-associated-service.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedService")' query directive to the 'projectAssociatedServiceRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedService
     */
    projectAssociatedServiceRelationship?: Maybe<GraphStoreFullProjectAssociatedServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by project-associated-to-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToIncident")' query directive to the 'projectAssociatedToIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedToIncident?: Maybe<GraphStoreSimplifiedProjectAssociatedToIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-to-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToIncident")' query directive to the 'projectAssociatedToIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedToIncidentInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedToIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-to-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToIncident")' query directive to the 'projectAssociatedToIncidentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedToIncidentInverse
     */
    projectAssociatedToIncidentInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedToIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] as defined by project-associated-to-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToIncident")' query directive to the 'projectAssociatedToIncidentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedToIncident
     */
    projectAssociatedToIncidentRelationship?: Maybe<GraphStoreFullProjectAssociatedToIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by project-associated-to-operations-container.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToOperationsContainer")' query directive to the 'projectAssociatedToOperationsContainer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedToOperationsContainer?: Maybe<GraphStoreSimplifiedProjectAssociatedToOperationsContainerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-to-operations-container.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToOperationsContainer")' query directive to the 'projectAssociatedToOperationsContainerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedToOperationsContainerInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-to-operations-container.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToOperationsContainer")' query directive to the 'projectAssociatedToOperationsContainerInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedToOperationsContainerInverse
     */
    projectAssociatedToOperationsContainerInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedToOperationsContainerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:graph:service] as defined by project-associated-to-operations-container.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToOperationsContainer")' query directive to the 'projectAssociatedToOperationsContainerRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedToOperationsContainer
     */
    projectAssociatedToOperationsContainerRelationship?: Maybe<GraphStoreFullProjectAssociatedToOperationsContainerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-to-security-container.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToSecurityContainer")' query directive to the 'projectAssociatedToSecurityContainerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedToSecurityContainerInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-to-security-container.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToSecurityContainer")' query directive to the 'projectAssociatedToSecurityContainerInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedToSecurityContainerInverse
     */
    projectAssociatedToSecurityContainerInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedToSecurityContainerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container] as defined by project-associated-to-security-container.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToSecurityContainer")' query directive to the 'projectAssociatedToSecurityContainerRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedToSecurityContainer
     */
    projectAssociatedToSecurityContainerRelationship?: Maybe<GraphStoreFullProjectAssociatedToSecurityContainerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by project-associated-vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedVulnerability")' query directive to the 'projectAssociatedVulnerability' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedVulnerability?: Maybe<GraphStoreSimplifiedProjectAssociatedVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedVulnerability")' query directive to the 'projectAssociatedVulnerabilityInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectAssociatedVulnerabilityInverse?: Maybe<GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:project] as defined by project-associated-vulnerability.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedVulnerability")' query directive to the 'projectAssociatedVulnerabilityInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedVulnerabilityInverse
     */
    projectAssociatedVulnerabilityInverseRelationship?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by project-associated-vulnerability.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedVulnerability")' query directive to the 'projectAssociatedVulnerabilityRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectAssociatedVulnerability
     */
    projectAssociatedVulnerabilityRelationship?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by project-disassociated-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDisassociatedRepo")' query directive to the 'projectDisassociatedRepo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDisassociatedRepo?: Maybe<GraphStoreSimplifiedProjectDisassociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:project] as defined by project-disassociated-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDisassociatedRepo")' query directive to the 'projectDisassociatedRepoInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDisassociatedRepoInverse?: Maybe<GraphStoreSimplifiedProjectDisassociatedRepoInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:project] as defined by project-disassociated-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDisassociatedRepo")' query directive to the 'projectDisassociatedRepoInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDisassociatedRepoInverse
     */
    projectDisassociatedRepoInverseRelationship?: Maybe<GraphStoreFullProjectDisassociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by project-disassociated-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDisassociatedRepo")' query directive to the 'projectDisassociatedRepoRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDisassociatedRepo
     */
    projectDisassociatedRepoRelationship?: Maybe<GraphStoreFullProjectDisassociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document] as defined by project-documentation-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationEntity")' query directive to the 'projectDocumentationEntity' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDocumentationEntity?: Maybe<GraphStoreSimplifiedProjectDocumentationEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:jira:project] as defined by project-documentation-entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationEntity")' query directive to the 'projectDocumentationEntityInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDocumentationEntityInverse?: Maybe<GraphStoreSimplifiedProjectDocumentationEntityInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:jira:project] as defined by project-documentation-entity.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationEntity")' query directive to the 'projectDocumentationEntityInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDocumentationEntityInverse
     */
    projectDocumentationEntityInverseRelationship?: Maybe<GraphStoreFullProjectDocumentationEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document] as defined by project-documentation-entity.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationEntity")' query directive to the 'projectDocumentationEntityRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDocumentationEntity
     */
    projectDocumentationEntityRelationship?: Maybe<GraphStoreFullProjectDocumentationEntityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:page] as defined by project-documentation-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationPage")' query directive to the 'projectDocumentationPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDocumentationPage?: Maybe<GraphStoreSimplifiedProjectDocumentationPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:jira:project] as defined by project-documentation-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationPage")' query directive to the 'projectDocumentationPageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDocumentationPageInverse?: Maybe<GraphStoreSimplifiedProjectDocumentationPageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:jira:project] as defined by project-documentation-page.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationPage")' query directive to the 'projectDocumentationPageInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDocumentationPageInverse
     */
    projectDocumentationPageInverseRelationship?: Maybe<GraphStoreFullProjectDocumentationPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:page] as defined by project-documentation-page.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationPage")' query directive to the 'projectDocumentationPageRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDocumentationPage
     */
    projectDocumentationPageRelationship?: Maybe<GraphStoreFullProjectDocumentationPageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:space] as defined by project-documentation-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationSpace")' query directive to the 'projectDocumentationSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDocumentationSpace?: Maybe<GraphStoreSimplifiedProjectDocumentationSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:jira:project] as defined by project-documentation-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationSpace")' query directive to the 'projectDocumentationSpaceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectDocumentationSpaceInverse?: Maybe<GraphStoreSimplifiedProjectDocumentationSpaceInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:jira:project] as defined by project-documentation-space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationSpace")' query directive to the 'projectDocumentationSpaceInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDocumentationSpaceInverse
     */
    projectDocumentationSpaceInverseRelationship?: Maybe<GraphStoreFullProjectDocumentationSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:space] as defined by project-documentation-space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationSpace")' query directive to the 'projectDocumentationSpaceRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectDocumentationSpace
     */
    projectDocumentationSpaceRelationship?: Maybe<GraphStoreFullProjectDocumentationSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by project-explicitly-associated-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectExplicitlyAssociatedRepo")' query directive to the 'projectExplicitlyAssociatedRepo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectExplicitlyAssociatedRepo?: Maybe<GraphStoreSimplifiedProjectExplicitlyAssociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:project] as defined by project-explicitly-associated-repo.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectExplicitlyAssociatedRepo")' query directive to the 'projectExplicitlyAssociatedRepoInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectExplicitlyAssociatedRepoInverse?: Maybe<GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository], fetches type(s) [ati:cloud:jira:project] as defined by project-explicitly-associated-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectExplicitlyAssociatedRepo")' query directive to the 'projectExplicitlyAssociatedRepoInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectExplicitlyAssociatedRepoInverse
     */
    projectExplicitlyAssociatedRepoInverseRelationship?: Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] as defined by project-explicitly-associated-repo.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectExplicitlyAssociatedRepo")' query directive to the 'projectExplicitlyAssociatedRepoRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectExplicitlyAssociatedRepo
     */
    projectExplicitlyAssociatedRepoRelationship?: Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue] as defined by project-has-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasIssue")' query directive to the 'projectHasIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasIssue?: Maybe<GraphStoreSimplifiedProjectHasIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:project] as defined by project-has-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasIssue")' query directive to the 'projectHasIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasIssueInverse?: Maybe<GraphStoreSimplifiedProjectHasIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:project] as defined by project-has-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasIssue")' query directive to the 'projectHasIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectHasIssueInverse
     */
    projectHasIssueInverseRelationship?: Maybe<GraphStoreFullProjectHasIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:issue] as defined by project-has-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasIssue")' query directive to the 'projectHasIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectHasIssue
     */
    projectHasIssueRelationship?: Maybe<GraphStoreFullProjectHasIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by project-has-related-work-with-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasRelatedWorkWithProject")' query directive to the 'projectHasRelatedWorkWithProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasRelatedWorkWithProject?: Maybe<GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by project-has-related-work-with-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasRelatedWorkWithProject")' query directive to the 'projectHasRelatedWorkWithProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasRelatedWorkWithProjectInverse?: Maybe<GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by project-has-shared-version-with.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasSharedVersionWith")' query directive to the 'projectHasSharedVersionWith' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasSharedVersionWith?: Maybe<GraphStoreSimplifiedProjectHasSharedVersionWithConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by project-has-shared-version-with.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasSharedVersionWith")' query directive to the 'projectHasSharedVersionWithInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasSharedVersionWithInverse?: Maybe<GraphStoreSimplifiedProjectHasSharedVersionWithInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by project-has-shared-version-with.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasSharedVersionWith")' query directive to the 'projectHasSharedVersionWithInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectHasSharedVersionWithInverse
     */
    projectHasSharedVersionWithInverseRelationship?: Maybe<GraphStoreFullProjectHasSharedVersionWithConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:project] as defined by project-has-shared-version-with.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasSharedVersionWith")' query directive to the 'projectHasSharedVersionWithRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectHasSharedVersionWith
     */
    projectHasSharedVersionWithRelationship?: Maybe<GraphStoreFullProjectHasSharedVersionWithConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:version] as defined by project-has-version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasVersion")' query directive to the 'projectHasVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasVersion?: Maybe<GraphStoreSimplifiedProjectHasVersionConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:project] as defined by project-has-version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasVersion")' query directive to the 'projectHasVersionInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectHasVersionInverse?: Maybe<GraphStoreSimplifiedProjectHasVersionInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:project] as defined by project-has-version.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasVersion")' query directive to the 'projectHasVersionInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectHasVersionInverse
     */
    projectHasVersionInverseRelationship?: Maybe<GraphStoreFullProjectHasVersionConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:jira:version] as defined by project-has-version.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasVersion")' query directive to the 'projectHasVersionRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use projectHasVersion
     */
    projectHasVersionRelationship?: Maybe<GraphStoreFullProjectHasVersionConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:compass:component] as defined by project-linked-to-compass-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectLinkedToCompassComponent")' query directive to the 'projectLinkedToCompassComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectLinkedToCompassComponent?: Maybe<GraphStoreSimplifiedProjectLinkedToCompassComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component], fetches type(s) [ati:cloud:jira:project] as defined by project-linked-to-compass-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectLinkedToCompassComponent")' query directive to the 'projectLinkedToCompassComponentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectLinkedToCompassComponentInverse?: Maybe<GraphStoreSimplifiedProjectLinkedToCompassComponentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:graph:service] as defined by pull-request-links-to-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePullRequestLinksToService")' query directive to the 'pullRequestLinksToService' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    pullRequestLinksToService?: Maybe<GraphStoreSimplifiedPullRequestLinksToServiceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by pull-request-links-to-service.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStorePullRequestLinksToService")' query directive to the 'pullRequestLinksToServiceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    pullRequestLinksToServiceInverse?: Maybe<GraphStoreSimplifiedPullRequestLinksToServiceInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by security-container-associated-to-vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerability' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    securityContainerAssociatedToVulnerability?: Maybe<GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by security-container-associated-to-vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerabilityBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    securityContainerAssociatedToVulnerabilityBatch?: Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityConnection>;
    /**
     * Given a list of ids of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container] as defined by security-container-associated-to-vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerabilityInverseBatch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    securityContainerAssociatedToVulnerabilityInverseBatch?: Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container] as defined by security-container-associated-to-vulnerability.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerabilityInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use securityContainerAssociatedToVulnerabilityInverse
     */
    securityContainerAssociatedToVulnerabilityInverseRelationship?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by security-container-associated-to-vulnerability.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSecurityContainerAssociatedToVulnerability")' query directive to the 'securityContainerAssociatedToVulnerabilityRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use securityContainerAssociatedToVulnerability
     */
    securityContainerAssociatedToVulnerabilityRelationship?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by service-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedBranch")' query directive to the 'serviceAssociatedBranch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedBranch?: Maybe<GraphStoreSimplifiedServiceAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:graph:service] as defined by service-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedBranch")' query directive to the 'serviceAssociatedBranchInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedBranchInverse?: Maybe<GraphStoreSimplifiedServiceAssociatedBranchInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by service-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedDeployment")' query directive to the 'serviceAssociatedDeployment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedDeployment?: Maybe<GraphStoreSimplifiedServiceAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:graph:service] as defined by service-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedDeployment")' query directive to the 'serviceAssociatedDeploymentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedDeploymentInverse?: Maybe<GraphStoreSimplifiedServiceAssociatedDeploymentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by service-associated-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedRemoteLink")' query directive to the 'serviceAssociatedRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedRemoteLink?: Maybe<GraphStoreSimplifiedServiceAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:graph:service] as defined by service-associated-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedRemoteLink")' query directive to the 'serviceAssociatedRemoteLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedRemoteLinkInverse?: Maybe<GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:opsgenie:team] as defined by service-associated-team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedTeam")' query directive to the 'serviceAssociatedTeam' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedTeam?: Maybe<GraphStoreSimplifiedServiceAssociatedTeamConnection>;
    /**
     * Given an id of type(s) [ati:cloud:opsgenie:team], fetches type(s) [ati:cloud:graph:service] as defined by service-associated-team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceAssociatedTeam")' query directive to the 'serviceAssociatedTeamInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceAssociatedTeamInverse?: Maybe<GraphStoreSimplifiedServiceAssociatedTeamInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:issue] as defined by service-linked-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceLinkedIncident")' query directive to the 'serviceLinkedIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceLinkedIncident?: Maybe<GraphStoreSimplifiedServiceLinkedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:graph:service] as defined by service-linked-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceLinkedIncident")' query directive to the 'serviceLinkedIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    serviceLinkedIncidentInverse?: Maybe<GraphStoreSimplifiedServiceLinkedIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:graph:service] as defined by service-linked-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceLinkedIncident")' query directive to the 'serviceLinkedIncidentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use serviceLinkedIncidentInverse
     */
    serviceLinkedIncidentInverseRelationship?: Maybe<GraphStoreFullServiceLinkedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:service], fetches type(s) [ati:cloud:jira:issue] as defined by service-linked-incident.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreServiceLinkedIncident")' query directive to the 'serviceLinkedIncidentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use serviceLinkedIncident
     */
    serviceLinkedIncidentRelationship?: Maybe<GraphStoreFullServiceLinkedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:jira:project] as defined by space-associated-with-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSpaceAssociatedWithProject")' query directive to the 'spaceAssociatedWithProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    spaceAssociatedWithProject?: Maybe<GraphStoreSimplifiedSpaceAssociatedWithProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:confluence:space] as defined by space-associated-with-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSpaceAssociatedWithProject")' query directive to the 'spaceAssociatedWithProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    spaceAssociatedWithProjectInverse?: Maybe<GraphStoreSimplifiedSpaceAssociatedWithProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by sprint-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedBuild")' query directive to the 'sprintAssociatedBuild' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintAssociatedBuild?: Maybe<GraphStoreSimplifiedSprintAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedBuild")' query directive to the 'sprintAssociatedBuildInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedBuildInverse
     */
    sprintAssociatedBuildInverseRelationship?: Maybe<GraphStoreFullSprintAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by sprint-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedBuild")' query directive to the 'sprintAssociatedBuildRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedBuild
     */
    sprintAssociatedBuildRelationship?: Maybe<GraphStoreFullSprintAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by sprint-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedDeployment")' query directive to the 'sprintAssociatedDeployment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintAssociatedDeployment?: Maybe<GraphStoreSimplifiedSprintAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedDeployment")' query directive to the 'sprintAssociatedDeploymentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedDeploymentInverse
     */
    sprintAssociatedDeploymentInverseRelationship?: Maybe<GraphStoreFullSprintAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by sprint-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedDeployment")' query directive to the 'sprintAssociatedDeploymentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedDeployment
     */
    sprintAssociatedDeploymentRelationship?: Maybe<GraphStoreFullSprintAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by sprint-associated-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedPr")' query directive to the 'sprintAssociatedPr' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintAssociatedPr?: Maybe<GraphStoreSimplifiedSprintAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedPr")' query directive to the 'sprintAssociatedPrInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedPrInverse
     */
    sprintAssociatedPrInverseRelationship?: Maybe<GraphStoreFullSprintAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by sprint-associated-pr.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedPr")' query directive to the 'sprintAssociatedPrRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedPr
     */
    sprintAssociatedPrRelationship?: Maybe<GraphStoreFullSprintAssociatedPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by sprint-associated-vulnerability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedVulnerability")' query directive to the 'sprintAssociatedVulnerability' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintAssociatedVulnerability?: Maybe<GraphStoreSimplifiedSprintAssociatedVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-associated-vulnerability.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedVulnerability")' query directive to the 'sprintAssociatedVulnerabilityInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedVulnerabilityInverse
     */
    sprintAssociatedVulnerabilityInverseRelationship?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by sprint-associated-vulnerability.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintAssociatedVulnerability")' query directive to the 'sprintAssociatedVulnerabilityRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintAssociatedVulnerability
     */
    sprintAssociatedVulnerabilityRelationship?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:issue] as defined by sprint-contains-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintContainsIssue")' query directive to the 'sprintContainsIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintContainsIssue?: Maybe<GraphStoreSimplifiedSprintContainsIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-contains-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintContainsIssue")' query directive to the 'sprintContainsIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintContainsIssueInverse
     */
    sprintContainsIssueInverseRelationship?: Maybe<GraphStoreFullSprintContainsIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:jira:issue] as defined by sprint-contains-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintContainsIssue")' query directive to the 'sprintContainsIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintContainsIssue
     */
    sprintContainsIssueRelationship?: Maybe<GraphStoreFullSprintContainsIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:confluence:page] as defined by sprint-retrospective-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectivePage")' query directive to the 'sprintRetrospectivePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintRetrospectivePage?: Maybe<GraphStoreSimplifiedSprintRetrospectivePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-retrospective-page.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectivePage")' query directive to the 'sprintRetrospectivePageInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintRetrospectivePageInverse
     */
    sprintRetrospectivePageInverseRelationship?: Maybe<GraphStoreFullSprintRetrospectivePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:confluence:page] as defined by sprint-retrospective-page.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectivePage")' query directive to the 'sprintRetrospectivePageRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintRetrospectivePage
     */
    sprintRetrospectivePageRelationship?: Maybe<GraphStoreFullSprintRetrospectivePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by sprint-retrospective-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectiveWhiteboard")' query directive to the 'sprintRetrospectiveWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintRetrospectiveWhiteboard?: Maybe<GraphStoreSimplifiedSprintRetrospectiveWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:jira:sprint] as defined by sprint-retrospective-whiteboard.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectiveWhiteboard")' query directive to the 'sprintRetrospectiveWhiteboardInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintRetrospectiveWhiteboardInverse
     */
    sprintRetrospectiveWhiteboardInverseRelationship?: Maybe<GraphStoreFullSprintRetrospectiveWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:sprint], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by sprint-retrospective-whiteboard.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectiveWhiteboard")' query directive to the 'sprintRetrospectiveWhiteboardRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use sprintRetrospectiveWhiteboard
     */
    sprintRetrospectiveWhiteboardRelationship?: Maybe<GraphStoreFullSprintRetrospectiveWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:team], fetches type(s) [ati:cloud:jira:project, ati:cloud:confluence:space] as defined by team-connected-to-container.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamConnectedToContainer")' query directive to the 'teamConnectedToContainer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teamConnectedToContainer?: Maybe<GraphStoreSimplifiedTeamConnectedToContainerConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project, ati:cloud:confluence:space], fetches type(s) [ati:cloud:identity:team] as defined by team-connected-to-container.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamConnectedToContainer")' query directive to the 'teamConnectedToContainerInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teamConnectedToContainerInverse?: Maybe<GraphStoreSimplifiedTeamConnectedToContainerInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:teams:team, ati:cloud:identity:team], fetches type(s) [ati:cloud:compass:component] as defined by team-owns-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamOwnsComponent")' query directive to the 'teamOwnsComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teamOwnsComponent?: Maybe<GraphStoreSimplifiedTeamOwnsComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component], fetches type(s) [ati:cloud:teams:team, ati:cloud:identity:team] as defined by team-owns-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamOwnsComponent")' query directive to the 'teamOwnsComponentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teamOwnsComponentInverse?: Maybe<GraphStoreSimplifiedTeamOwnsComponentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:team], fetches type(s) [ati:cloud:jira:project] as defined by team-works-on-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamWorksOnProject")' query directive to the 'teamWorksOnProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teamWorksOnProject?: Maybe<GraphStoreSimplifiedTeamWorksOnProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:identity:team] as defined by team-works-on-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamWorksOnProject")' query directive to the 'teamWorksOnProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teamWorksOnProjectInverse?: Maybe<GraphStoreSimplifiedTeamWorksOnProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:identity:team] as defined by team-works-on-project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamWorksOnProject")' query directive to the 'teamWorksOnProjectInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use teamWorksOnProjectInverse
     */
    teamWorksOnProjectInverseRelationship?: Maybe<GraphStoreFullTeamWorksOnProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:team], fetches type(s) [ati:cloud:jira:project] as defined by team-works-on-project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamWorksOnProject")' query directive to the 'teamWorksOnProjectRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use teamWorksOnProject
     */
    teamWorksOnProjectRelationship?: Maybe<GraphStoreFullTeamWorksOnProjectConnection>;
    /**
     * Given an id of type(s) [ati:third-party:zeplin.zeplin:remote-link, ati:third-party:adobe.adobexd:remote-link, ati:third-party:amplitude.amplitude:remote-link, ati:third-party:clickup.clickup:remote-link, ati:third-party:dovetail.dovetail:remote-link, ati:third-party:stripe.stripe:remote-link, ati:third-party:microsoft.power-bi:remote-link, ati:third-party:pipedrive.pipedrive:remote-link, ati:third-party:mural.mural:remote-link, ati:third-party:cisco.webex:remote-link, ati:third-party:pagerduty.pagerduty:remote-link, ati:third-party:todoist.todoist:remote-link, ati:third-party:google.google-drive:remote-link, ati:third-party:github.github:remote-link], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by third-party-to-graph-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreThirdPartyToGraphRemoteLink")' query directive to the 'thirdPartyToGraphRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    thirdPartyToGraphRemoteLink?: Maybe<GraphStoreSimplifiedThirdPartyToGraphRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-assigned-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAssignedIncident")' query directive to the 'userAssignedIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAssignedIncident?: Maybe<GraphStoreSimplifiedUserAssignedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-assigned-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAssignedIncident")' query directive to the 'userAssignedIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAssignedIncidentInverse?: Maybe<GraphStoreSimplifiedUserAssignedIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-assigned-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAssignedIssue")' query directive to the 'userAssignedIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAssignedIssue?: Maybe<GraphStoreSimplifiedUserAssignedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-assigned-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAssignedIssue")' query directive to the 'userAssignedIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAssignedIssueInverse?: Maybe<GraphStoreSimplifiedUserAssignedIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-assigned-pir.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAssignedPir")' query directive to the 'userAssignedPir' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAssignedPir?: Maybe<GraphStoreSimplifiedUserAssignedPirConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-assigned-pir.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAssignedPir")' query directive to the 'userAssignedPirInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAssignedPirInverse?: Maybe<GraphStoreSimplifiedUserAssignedPirInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:calendar-event] as defined by user-attended-calendar-event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAttendedCalendarEvent")' query directive to the 'userAttendedCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAttendedCalendarEvent?: Maybe<GraphStoreSimplifiedUserAttendedCalendarEventConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:calendar-event], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-attended-calendar-event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAttendedCalendarEvent")' query directive to the 'userAttendedCalendarEventInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAttendedCalendarEventInverse?: Maybe<GraphStoreSimplifiedUserAttendedCalendarEventInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] as defined by user-authored-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAuthoredCommit")' query directive to the 'userAuthoredCommit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAuthoredCommit?: Maybe<GraphStoreSimplifiedUserAuthoredCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit], fetches type(s) [ati:cloud:identity:user] as defined by user-authored-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAuthoredCommit")' query directive to the 'userAuthoredCommitInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAuthoredCommitInverse?: Maybe<GraphStoreSimplifiedUserAuthoredCommitInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by user-authored-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAuthoredPr")' query directive to the 'userAuthoredPr' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAuthoredPr?: Maybe<GraphStoreSimplifiedUserAuthoredPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:identity:user] as defined by user-authored-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAuthoredPr")' query directive to the 'userAuthoredPrInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAuthoredPrInverse?: Maybe<GraphStoreSimplifiedUserAuthoredPrInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:identity:third-party-user] as defined by user-authoritatively-linked-third-party-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAuthoritativelyLinkedThirdPartyUser")' query directive to the 'userAuthoritativelyLinkedThirdPartyUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAuthoritativelyLinkedThirdPartyUser?: Maybe<GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:identity:user] as defined by user-authoritatively-linked-third-party-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserAuthoritativelyLinkedThirdPartyUser")' query directive to the 'userAuthoritativelyLinkedThirdPartyUserInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userAuthoritativelyLinkedThirdPartyUserInverse?: Maybe<GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:space] as defined by user-can-view-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCanViewConfluenceSpace")' query directive to the 'userCanViewConfluenceSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCanViewConfluenceSpace?: Maybe<GraphStoreSimplifiedUserCanViewConfluenceSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:identity:user] as defined by user-can-view-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCanViewConfluenceSpace")' query directive to the 'userCanViewConfluenceSpaceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCanViewConfluenceSpaceInverse?: Maybe<GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by user-collaborated-on-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCollaboratedOnDocument")' query directive to the 'userCollaboratedOnDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCollaboratedOnDocument?: Maybe<GraphStoreSimplifiedUserCollaboratedOnDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-collaborated-on-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCollaboratedOnDocument")' query directive to the 'userCollaboratedOnDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCollaboratedOnDocumentInverse?: Maybe<GraphStoreSimplifiedUserCollaboratedOnDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by user-contributed-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluenceBlogpost")' query directive to the 'userContributedConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluenceBlogpost?: Maybe<GraphStoreSimplifiedUserContributedConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by user-contributed-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluenceBlogpost")' query directive to the 'userContributedConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:database] as defined by user-contributed-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluenceDatabase")' query directive to the 'userContributedConfluenceDatabase' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluenceDatabase?: Maybe<GraphStoreSimplifiedUserContributedConfluenceDatabaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:database], fetches type(s) [ati:cloud:identity:user] as defined by user-contributed-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluenceDatabase")' query directive to the 'userContributedConfluenceDatabaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluenceDatabaseInverse?: Maybe<GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-contributed-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluencePage")' query directive to the 'userContributedConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluencePage?: Maybe<GraphStoreSimplifiedUserContributedConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-contributed-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluencePage")' query directive to the 'userContributedConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserContributedConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by user-contributed-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluenceWhiteboard")' query directive to the 'userContributedConfluenceWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluenceWhiteboard?: Maybe<GraphStoreSimplifiedUserContributedConfluenceWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:identity:user] as defined by user-contributed-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserContributedConfluenceWhiteboard")' query directive to the 'userContributedConfluenceWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userContributedConfluenceWhiteboardInverse?: Maybe<GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by user-created-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedBranch")' query directive to the 'userCreatedBranch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedBranch?: Maybe<GraphStoreSimplifiedUserCreatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-created-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedBranch")' query directive to the 'userCreatedBranchInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedBranchInverse?: Maybe<GraphStoreSimplifiedUserCreatedBranchInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:calendar-event] as defined by user-created-calendar-event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedCalendarEvent")' query directive to the 'userCreatedCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedCalendarEvent?: Maybe<GraphStoreSimplifiedUserCreatedCalendarEventConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:calendar-event], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-created-calendar-event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedCalendarEvent")' query directive to the 'userCreatedCalendarEventInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedCalendarEventInverse?: Maybe<GraphStoreSimplifiedUserCreatedCalendarEventInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by user-created-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceBlogpost")' query directive to the 'userCreatedConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceBlogpost?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by user-created-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceBlogpost")' query directive to the 'userCreatedConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:comment] as defined by user-created-confluence-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceComment")' query directive to the 'userCreatedConfluenceComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceComment?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:identity:user] as defined by user-created-confluence-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceComment")' query directive to the 'userCreatedConfluenceCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceCommentInverse?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:database] as defined by user-created-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceDatabase")' query directive to the 'userCreatedConfluenceDatabase' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceDatabase?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceDatabaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:database], fetches type(s) [ati:cloud:identity:user] as defined by user-created-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceDatabase")' query directive to the 'userCreatedConfluenceDatabaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceDatabaseInverse?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-created-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluencePage")' query directive to the 'userCreatedConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluencePage?: Maybe<GraphStoreSimplifiedUserCreatedConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-created-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluencePage")' query directive to the 'userCreatedConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserCreatedConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:space] as defined by user-created-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceSpace")' query directive to the 'userCreatedConfluenceSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceSpace?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:identity:user] as defined by user-created-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceSpace")' query directive to the 'userCreatedConfluenceSpaceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceSpaceInverse?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by user-created-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceWhiteboard")' query directive to the 'userCreatedConfluenceWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceWhiteboard?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:identity:user] as defined by user-created-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedConfluenceWhiteboard")' query directive to the 'userCreatedConfluenceWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedConfluenceWhiteboardInverse?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:design, ati:cloud:graph:design] as defined by user-created-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedDesign")' query directive to the 'userCreatedDesign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedDesign?: Maybe<GraphStoreSimplifiedUserCreatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:design, ati:cloud:graph:design], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-created-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedDesign")' query directive to the 'userCreatedDesignInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedDesignInverse?: Maybe<GraphStoreSimplifiedUserCreatedDesignInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by user-created-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedDocument")' query directive to the 'userCreatedDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedDocument?: Maybe<GraphStoreSimplifiedUserCreatedDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-created-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedDocument")' query directive to the 'userCreatedDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedDocumentInverse?: Maybe<GraphStoreSimplifiedUserCreatedDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue-comment] as defined by user-created-issue-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedIssueComment")' query directive to the 'userCreatedIssueComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedIssueComment?: Maybe<GraphStoreSimplifiedUserCreatedIssueCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue-comment], fetches type(s) [ati:cloud:identity:user] as defined by user-created-issue-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedIssueComment")' query directive to the 'userCreatedIssueCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedIssueCommentInverse?: Maybe<GraphStoreSimplifiedUserCreatedIssueCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue-worklog] as defined by user-created-issue-worklog.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedIssueWorklog")' query directive to the 'userCreatedIssueWorklog' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedIssueWorklog?: Maybe<GraphStoreSimplifiedUserCreatedIssueWorklogConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue-worklog], fetches type(s) [ati:cloud:identity:user] as defined by user-created-issue-worklog.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedIssueWorklog")' query directive to the 'userCreatedIssueWorklogInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedIssueWorklogInverse?: Maybe<GraphStoreSimplifiedUserCreatedIssueWorklogInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:graph:video] as defined by user-created-loom-video.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedLoomVideo")' query directive to the 'userCreatedLoomVideo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedLoomVideo?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:loom:comment] as defined by user-created-loom-video-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedLoomVideoComment")' query directive to the 'userCreatedLoomVideoComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedLoomVideoComment?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:comment], fetches type(s) [ati:cloud:identity:user] as defined by user-created-loom-video-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedLoomVideoComment")' query directive to the 'userCreatedLoomVideoCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedLoomVideoCommentInverse?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:video], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-created-loom-video.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedLoomVideo")' query directive to the 'userCreatedLoomVideoInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedLoomVideoInverse?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:message] as defined by user-created-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedMessage")' query directive to the 'userCreatedMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedMessage?: Maybe<GraphStoreSimplifiedUserCreatedMessageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:message], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-created-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedMessage")' query directive to the 'userCreatedMessageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedMessageInverse?: Maybe<GraphStoreSimplifiedUserCreatedMessageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:version] as defined by user-created-release.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedRelease")' query directive to the 'userCreatedRelease' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedRelease?: Maybe<GraphStoreSimplifiedUserCreatedReleaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:identity:user] as defined by user-created-release.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedRelease")' query directive to the 'userCreatedReleaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedReleaseInverse?: Maybe<GraphStoreSimplifiedUserCreatedReleaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by user-created-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedRemoteLink")' query directive to the 'userCreatedRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedRemoteLink?: Maybe<GraphStoreSimplifiedUserCreatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-created-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedRemoteLink")' query directive to the 'userCreatedRemoteLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedRemoteLinkInverse?: Maybe<GraphStoreSimplifiedUserCreatedRemoteLinkInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:graph:repository] as defined by user-created-repository.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedRepository")' query directive to the 'userCreatedRepository' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedRepository?: Maybe<GraphStoreSimplifiedUserCreatedRepositoryConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:repository], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-created-repository.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserCreatedRepository")' query directive to the 'userCreatedRepositoryInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userCreatedRepositoryInverse?: Maybe<GraphStoreSimplifiedUserCreatedRepositoryInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by user-favorited-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluenceBlogpost")' query directive to the 'userFavoritedConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluenceBlogpost?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by user-favorited-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluenceBlogpost")' query directive to the 'userFavoritedConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:database] as defined by user-favorited-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluenceDatabase")' query directive to the 'userFavoritedConfluenceDatabase' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluenceDatabase?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceDatabaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:database], fetches type(s) [ati:cloud:identity:user] as defined by user-favorited-confluence-database.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluenceDatabase")' query directive to the 'userFavoritedConfluenceDatabaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluenceDatabaseInverse?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-favorited-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluencePage")' query directive to the 'userFavoritedConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluencePage?: Maybe<GraphStoreSimplifiedUserFavoritedConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-favorited-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluencePage")' query directive to the 'userFavoritedConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserFavoritedConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by user-favorited-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluenceWhiteboard")' query directive to the 'userFavoritedConfluenceWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluenceWhiteboard?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:identity:user] as defined by user-favorited-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserFavoritedConfluenceWhiteboard")' query directive to the 'userFavoritedConfluenceWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userFavoritedConfluenceWhiteboardInverse?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:identity:user] as defined by user-has-collaborators.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasCollaborators")' query directive to the 'userHasCollaborators' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHasCollaborators?: Maybe<GraphStoreSimplifiedUserHasCollaboratorsConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:identity:user] as defined by user-has-collaborators.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasCollaborators")' query directive to the 'userHasCollaboratorsInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHasCollaboratorsInverse?: Maybe<GraphStoreSimplifiedUserHasCollaboratorsInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:project] as defined by user-has-relevant-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasRelevantProject")' query directive to the 'userHasRelevantProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHasRelevantProject?: Maybe<GraphStoreSimplifiedUserHasRelevantProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:identity:user] as defined by user-has-relevant-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasRelevantProject")' query directive to the 'userHasRelevantProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHasRelevantProjectInverse?: Maybe<GraphStoreSimplifiedUserHasRelevantProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:project] as defined by user-has-top-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasTopProject")' query directive to the 'userHasTopProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHasTopProject?: Maybe<GraphStoreSimplifiedUserHasTopProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:project], fetches type(s) [ati:cloud:identity:user] as defined by user-has-top-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasTopProject")' query directive to the 'userHasTopProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHasTopProjectInverse?: Maybe<GraphStoreSimplifiedUserHasTopProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:identity:team] as defined by user-is-in-team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserIsInTeam")' query directive to the 'userIsInTeam' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userIsInTeam?: Maybe<GraphStoreSimplifiedUserIsInTeamConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:team], fetches type(s) [ati:cloud:identity:user] as defined by user-is-in-team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserIsInTeam")' query directive to the 'userIsInTeamInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userIsInTeamInverse?: Maybe<GraphStoreSimplifiedUserIsInTeamInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:design, ati:cloud:graph:design] as defined by user-last-updated-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserLastUpdatedDesign")' query directive to the 'userLastUpdatedDesign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userLastUpdatedDesign?: Maybe<GraphStoreSimplifiedUserLastUpdatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:design, ati:cloud:graph:design], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-last-updated-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserLastUpdatedDesign")' query directive to the 'userLastUpdatedDesignInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userLastUpdatedDesignInverse?: Maybe<GraphStoreSimplifiedUserLastUpdatedDesignInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:version] as defined by user-launched-release.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserLaunchedRelease")' query directive to the 'userLaunchedRelease' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userLaunchedRelease?: Maybe<GraphStoreSimplifiedUserLaunchedReleaseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:identity:user] as defined by user-launched-release.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserLaunchedRelease")' query directive to the 'userLaunchedReleaseInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userLaunchedReleaseInverse?: Maybe<GraphStoreSimplifiedUserLaunchedReleaseInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:identity:third-party-user] as defined by user-linked-third-party-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserLinkedThirdPartyUser")' query directive to the 'userLinkedThirdPartyUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userLinkedThirdPartyUser?: Maybe<GraphStoreSimplifiedUserLinkedThirdPartyUserConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:identity:user] as defined by user-linked-third-party-user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserLinkedThirdPartyUser")' query directive to the 'userLinkedThirdPartyUserInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userLinkedThirdPartyUserInverse?: Maybe<GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:conversation] as defined by user-member-of-conversation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMemberOfConversation")' query directive to the 'userMemberOfConversation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMemberOfConversation?: Maybe<GraphStoreSimplifiedUserMemberOfConversationConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:conversation], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-member-of-conversation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMemberOfConversation")' query directive to the 'userMemberOfConversationInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMemberOfConversationInverse?: Maybe<GraphStoreSimplifiedUserMemberOfConversationInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:conversation] as defined by user-mentioned-in-conversation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMentionedInConversation")' query directive to the 'userMentionedInConversation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMentionedInConversation?: Maybe<GraphStoreSimplifiedUserMentionedInConversationConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:conversation], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-mentioned-in-conversation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMentionedInConversation")' query directive to the 'userMentionedInConversationInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMentionedInConversationInverse?: Maybe<GraphStoreSimplifiedUserMentionedInConversationInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:message] as defined by user-mentioned-in-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMentionedInMessage")' query directive to the 'userMentionedInMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMentionedInMessage?: Maybe<GraphStoreSimplifiedUserMentionedInMessageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:message], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-mentioned-in-message.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMentionedInMessage")' query directive to the 'userMentionedInMessageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMentionedInMessageInverse?: Maybe<GraphStoreSimplifiedUserMentionedInMessageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by user-merged-pull-request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMergedPullRequest")' query directive to the 'userMergedPullRequest' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMergedPullRequest?: Maybe<GraphStoreSimplifiedUserMergedPullRequestConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:identity:user] as defined by user-merged-pull-request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserMergedPullRequest")' query directive to the 'userMergedPullRequestInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userMergedPullRequestInverse?: Maybe<GraphStoreSimplifiedUserMergedPullRequestInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by user-owned-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedBranch")' query directive to the 'userOwnedBranch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedBranch?: Maybe<GraphStoreSimplifiedUserOwnedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-owned-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedBranch")' query directive to the 'userOwnedBranchInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedBranchInverse?: Maybe<GraphStoreSimplifiedUserOwnedBranchInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:calendar-event] as defined by user-owned-calendar-event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedCalendarEvent")' query directive to the 'userOwnedCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedCalendarEvent?: Maybe<GraphStoreSimplifiedUserOwnedCalendarEventConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:calendar-event], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-owned-calendar-event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedCalendarEvent")' query directive to the 'userOwnedCalendarEventInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedCalendarEventInverse?: Maybe<GraphStoreSimplifiedUserOwnedCalendarEventInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document] as defined by user-owned-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedDocument")' query directive to the 'userOwnedDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedDocument?: Maybe<GraphStoreSimplifiedUserOwnedDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-owned-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedDocument")' query directive to the 'userOwnedDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedDocumentInverse?: Maybe<GraphStoreSimplifiedUserOwnedDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by user-owned-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedRemoteLink")' query directive to the 'userOwnedRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedRemoteLink?: Maybe<GraphStoreSimplifiedUserOwnedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-owned-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedRemoteLink")' query directive to the 'userOwnedRemoteLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedRemoteLinkInverse?: Maybe<GraphStoreSimplifiedUserOwnedRemoteLinkInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user], fetches type(s) [ati:cloud:graph:repository] as defined by user-owned-repository.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedRepository")' query directive to the 'userOwnedRepository' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedRepository?: Maybe<GraphStoreSimplifiedUserOwnedRepositoryConnection>;
    /**
     * Given an id of type(s) [ati:cloud:graph:repository], fetches type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user] as defined by user-owned-repository.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnedRepository")' query directive to the 'userOwnedRepositoryInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnedRepositoryInverse?: Maybe<GraphStoreSimplifiedUserOwnedRepositoryInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:compass:component] as defined by user-owns-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnsComponent")' query directive to the 'userOwnsComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnsComponent?: Maybe<GraphStoreSimplifiedUserOwnsComponentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:compass:component], fetches type(s) [ati:cloud:identity:user] as defined by user-owns-component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnsComponent")' query directive to the 'userOwnsComponentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnsComponentInverse?: Maybe<GraphStoreSimplifiedUserOwnsComponentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:mercury:focus-area] as defined by user-owns-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnsFocusArea")' query directive to the 'userOwnsFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnsFocusArea?: Maybe<GraphStoreSimplifiedUserOwnsFocusAreaConnection>;
    /**
     * Given an id of type(s) [ati:cloud:mercury:focus-area], fetches type(s) [ati:cloud:identity:user] as defined by user-owns-focus-area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserOwnsFocusArea")' query directive to the 'userOwnsFocusAreaInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userOwnsFocusAreaInverse?: Maybe<GraphStoreSimplifiedUserOwnsFocusAreaInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-reported-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserReportedIncident")' query directive to the 'userReportedIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userReportedIncident?: Maybe<GraphStoreSimplifiedUserReportedIncidentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-reported-incident.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserReportedIncident")' query directive to the 'userReportedIncidentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userReportedIncidentInverse?: Maybe<GraphStoreSimplifiedUserReportedIncidentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-reports-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserReportsIssue")' query directive to the 'userReportsIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userReportsIssue?: Maybe<GraphStoreSimplifiedUserReportsIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-reports-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserReportsIssue")' query directive to the 'userReportsIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userReportsIssueInverse?: Maybe<GraphStoreSimplifiedUserReportsIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by user-reviews-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserReviewsPr")' query directive to the 'userReviewsPr' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userReviewsPr?: Maybe<GraphStoreSimplifiedUserReviewsPrConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:identity:user] as defined by user-reviews-pr.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserReviewsPr")' query directive to the 'userReviewsPrInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userReviewsPrInverse?: Maybe<GraphStoreSimplifiedUserReviewsPrInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:comment] as defined by user-tagged-in-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInComment")' query directive to the 'userTaggedInComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInComment?: Maybe<GraphStoreSimplifiedUserTaggedInCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:comment], fetches type(s) [ati:cloud:identity:user] as defined by user-tagged-in-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInComment")' query directive to the 'userTaggedInCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInCommentInverse?: Maybe<GraphStoreSimplifiedUserTaggedInCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-tagged-in-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInConfluencePage")' query directive to the 'userTaggedInConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInConfluencePage?: Maybe<GraphStoreSimplifiedUserTaggedInConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-tagged-in-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInConfluencePage")' query directive to the 'userTaggedInConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserTaggedInConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue-comment] as defined by user-tagged-in-issue-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInIssueComment")' query directive to the 'userTaggedInIssueComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInIssueComment?: Maybe<GraphStoreSimplifiedUserTaggedInIssueCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue-comment], fetches type(s) [ati:cloud:identity:user] as defined by user-tagged-in-issue-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInIssueComment")' query directive to the 'userTaggedInIssueCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInIssueCommentInverse?: Maybe<GraphStoreSimplifiedUserTaggedInIssueCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:loom:comment] as defined by user-tagged-in-loom-video-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInLoomVideoComment")' query directive to the 'userTaggedInLoomVideoComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInLoomVideoComment?: Maybe<GraphStoreSimplifiedUserTaggedInLoomVideoCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:comment], fetches type(s) [ati:cloud:identity:user] as defined by user-tagged-in-loom-video-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTaggedInLoomVideoComment")' query directive to the 'userTaggedInLoomVideoCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTaggedInLoomVideoCommentInverse?: Maybe<GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by user-triggered-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTriggeredDeployment")' query directive to the 'userTriggeredDeployment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTriggeredDeployment?: Maybe<GraphStoreSimplifiedUserTriggeredDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:identity:user] as defined by user-triggered-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserTriggeredDeployment")' query directive to the 'userTriggeredDeploymentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userTriggeredDeploymentInverse?: Maybe<GraphStoreSimplifiedUserTriggeredDeploymentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by user-updated-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluenceBlogpost")' query directive to the 'userUpdatedConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluenceBlogpost?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by user-updated-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluenceBlogpost")' query directive to the 'userUpdatedConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-updated-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluencePage")' query directive to the 'userUpdatedConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluencePage?: Maybe<GraphStoreSimplifiedUserUpdatedConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-updated-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluencePage")' query directive to the 'userUpdatedConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserUpdatedConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:space] as defined by user-updated-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluenceSpace")' query directive to the 'userUpdatedConfluenceSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluenceSpace?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceSpaceConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:space], fetches type(s) [ati:cloud:identity:user] as defined by user-updated-confluence-space.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluenceSpace")' query directive to the 'userUpdatedConfluenceSpaceInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluenceSpaceInverse?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by user-updated-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluenceWhiteboard")' query directive to the 'userUpdatedConfluenceWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluenceWhiteboard?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:identity:user] as defined by user-updated-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedConfluenceWhiteboard")' query directive to the 'userUpdatedConfluenceWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedConfluenceWhiteboardInverse?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user], fetches type(s) [ati:cloud:jira:document, ati:cloud:graph:document, ati:third-party:google.google-drive:document, ati:third-party:notion.notion:document] as defined by user-updated-graph-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedGraphDocument")' query directive to the 'userUpdatedGraphDocument' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedGraphDocument?: Maybe<GraphStoreSimplifiedUserUpdatedGraphDocumentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:document, ati:cloud:graph:document, ati:third-party:google.google-drive:document, ati:third-party:notion.notion:document], fetches type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user] as defined by user-updated-graph-document.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedGraphDocument")' query directive to the 'userUpdatedGraphDocumentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedGraphDocumentInverse?: Maybe<GraphStoreSimplifiedUserUpdatedGraphDocumentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-updated-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedIssue")' query directive to the 'userUpdatedIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedIssue?: Maybe<GraphStoreSimplifiedUserUpdatedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-updated-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedIssue")' query directive to the 'userUpdatedIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedIssueInverse?: Maybe<GraphStoreSimplifiedUserUpdatedIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue-status], fetches type(s) [ati:cloud:identity:user] as defined by user-updated-issue-status.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserUpdatedIssueStatus")' query directive to the 'userUpdatedIssueStatusInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userUpdatedIssueStatusInverse?: Maybe<GraphStoreSimplifiedUserUpdatedIssueStatusInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:goal] as defined by user-viewed-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedAtlasGoal")' query directive to the 'userViewedAtlasGoal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedAtlasGoal?: Maybe<GraphStoreSimplifiedUserViewedAtlasGoalConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-atlas-goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedAtlasGoal")' query directive to the 'userViewedAtlasGoalInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedAtlasGoalInverse?: Maybe<GraphStoreSimplifiedUserViewedAtlasGoalInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:project] as defined by user-viewed-atlas-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedAtlasProject")' query directive to the 'userViewedAtlasProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedAtlasProject?: Maybe<GraphStoreSimplifiedUserViewedAtlasProjectConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-atlas-project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedAtlasProject")' query directive to the 'userViewedAtlasProjectInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedAtlasProjectInverse?: Maybe<GraphStoreSimplifiedUserViewedAtlasProjectInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by user-viewed-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedConfluenceBlogpost")' query directive to the 'userViewedConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedConfluenceBlogpost?: Maybe<GraphStoreSimplifiedUserViewedConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedConfluenceBlogpost")' query directive to the 'userViewedConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-viewed-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedConfluencePage")' query directive to the 'userViewedConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedConfluencePage?: Maybe<GraphStoreSimplifiedUserViewedConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedConfluencePage")' query directive to the 'userViewedConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserViewedConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:goal-update] as defined by user-viewed-goal-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedGoalUpdate")' query directive to the 'userViewedGoalUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedGoalUpdate?: Maybe<GraphStoreSimplifiedUserViewedGoalUpdateConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:goal-update], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-goal-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedGoalUpdate")' query directive to the 'userViewedGoalUpdateInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedGoalUpdateInverse?: Maybe<GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:jira:issue] as defined by user-viewed-jira-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedJiraIssue")' query directive to the 'userViewedJiraIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedJiraIssue?: Maybe<GraphStoreSimplifiedUserViewedJiraIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-jira-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedJiraIssue")' query directive to the 'userViewedJiraIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedJiraIssueInverse?: Maybe<GraphStoreSimplifiedUserViewedJiraIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:loom:video] as defined by user-viewed-loom-video.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedLoomVideo")' query directive to the 'userViewedLoomVideo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedLoomVideo?: Maybe<GraphStoreSimplifiedUserViewedLoomVideoConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:video], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-loom-video.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedLoomVideo")' query directive to the 'userViewedLoomVideoInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedLoomVideoInverse?: Maybe<GraphStoreSimplifiedUserViewedLoomVideoInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:townsquare:project-update] as defined by user-viewed-project-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedProjectUpdate")' query directive to the 'userViewedProjectUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedProjectUpdate?: Maybe<GraphStoreSimplifiedUserViewedProjectUpdateConnection>;
    /**
     * Given an id of type(s) [ati:cloud:townsquare:project-update], fetches type(s) [ati:cloud:identity:user] as defined by user-viewed-project-update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserViewedProjectUpdate")' query directive to the 'userViewedProjectUpdateInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userViewedProjectUpdateInverse?: Maybe<GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:blogpost] as defined by user-watches-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserWatchesConfluenceBlogpost")' query directive to the 'userWatchesConfluenceBlogpost' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userWatchesConfluenceBlogpost?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceBlogpostConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:blogpost], fetches type(s) [ati:cloud:identity:user] as defined by user-watches-confluence-blogpost.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserWatchesConfluenceBlogpost")' query directive to the 'userWatchesConfluenceBlogpostInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userWatchesConfluenceBlogpostInverse?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:page] as defined by user-watches-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserWatchesConfluencePage")' query directive to the 'userWatchesConfluencePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userWatchesConfluencePage?: Maybe<GraphStoreSimplifiedUserWatchesConfluencePageConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:page], fetches type(s) [ati:cloud:identity:user] as defined by user-watches-confluence-page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserWatchesConfluencePage")' query directive to the 'userWatchesConfluencePageInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userWatchesConfluencePageInverse?: Maybe<GraphStoreSimplifiedUserWatchesConfluencePageInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:identity:user], fetches type(s) [ati:cloud:confluence:whiteboard] as defined by user-watches-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserWatchesConfluenceWhiteboard")' query directive to the 'userWatchesConfluenceWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userWatchesConfluenceWhiteboard?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceWhiteboardConnection>;
    /**
     * Given an id of type(s) [ati:cloud:confluence:whiteboard], fetches type(s) [ati:cloud:identity:user] as defined by user-watches-confluence-whiteboard.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserWatchesConfluenceWhiteboard")' query directive to the 'userWatchesConfluenceWhiteboardInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userWatchesConfluenceWhiteboardInverse?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by version-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBranch")' query directive to the 'versionAssociatedBranch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedBranch?: Maybe<GraphStoreSimplifiedVersionAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-branch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBranch")' query directive to the 'versionAssociatedBranchInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedBranchInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedBranchInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-branch.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBranch")' query directive to the 'versionAssociatedBranchInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedBranchInverse
     */
    versionAssociatedBranchInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] as defined by version-associated-branch.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBranch")' query directive to the 'versionAssociatedBranchRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedBranch
     */
    versionAssociatedBranchRelationship?: Maybe<GraphStoreFullVersionAssociatedBranchConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by version-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBuild")' query directive to the 'versionAssociatedBuild' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedBuild?: Maybe<GraphStoreSimplifiedVersionAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBuild")' query directive to the 'versionAssociatedBuildInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedBuildInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedBuildInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:build, ati:cloud:graph:build], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBuild")' query directive to the 'versionAssociatedBuildInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedBuildInverse
     */
    versionAssociatedBuildInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:build, ati:cloud:graph:build] as defined by version-associated-build.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedBuild")' query directive to the 'versionAssociatedBuildRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedBuild
     */
    versionAssociatedBuildRelationship?: Maybe<GraphStoreFullVersionAssociatedBuildConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] as defined by version-associated-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedCommit")' query directive to the 'versionAssociatedCommit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedCommit?: Maybe<GraphStoreSimplifiedVersionAssociatedCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-commit.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedCommit")' query directive to the 'versionAssociatedCommitInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedCommitInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedCommitInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-commit.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedCommit")' query directive to the 'versionAssociatedCommitInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedCommitInverse
     */
    versionAssociatedCommitInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] as defined by version-associated-commit.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedCommit")' query directive to the 'versionAssociatedCommitRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedCommit
     */
    versionAssociatedCommitRelationship?: Maybe<GraphStoreFullVersionAssociatedCommitConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by version-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDeployment")' query directive to the 'versionAssociatedDeployment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedDeployment?: Maybe<GraphStoreSimplifiedVersionAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-deployment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDeployment")' query directive to the 'versionAssociatedDeploymentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedDeploymentInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedDeploymentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDeployment")' query directive to the 'versionAssociatedDeploymentInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedDeploymentInverse
     */
    versionAssociatedDeploymentInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] as defined by version-associated-deployment.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDeployment")' query directive to the 'versionAssociatedDeploymentRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedDeployment
     */
    versionAssociatedDeploymentRelationship?: Maybe<GraphStoreFullVersionAssociatedDeploymentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:design, ati:cloud:graph:design] as defined by version-associated-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDesign")' query directive to the 'versionAssociatedDesign' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedDesign?: Maybe<GraphStoreSimplifiedVersionAssociatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:design, ati:cloud:graph:design], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-design.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDesign")' query directive to the 'versionAssociatedDesignInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedDesignInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedDesignInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:design, ati:cloud:graph:design], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-design.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDesign")' query directive to the 'versionAssociatedDesignInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedDesignInverse
     */
    versionAssociatedDesignInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:design, ati:cloud:graph:design] as defined by version-associated-design.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedDesign")' query directive to the 'versionAssociatedDesignRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedDesign
     */
    versionAssociatedDesignRelationship?: Maybe<GraphStoreFullVersionAssociatedDesignConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by version-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedFeatureFlag")' query directive to the 'versionAssociatedFeatureFlag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedFeatureFlag?: Maybe<GraphStoreSimplifiedVersionAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedFeatureFlag")' query directive to the 'versionAssociatedFeatureFlagInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedFeatureFlagInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedFeatureFlag")' query directive to the 'versionAssociatedFeatureFlagInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedFeatureFlagInverse
     */
    versionAssociatedFeatureFlagInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by version-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedFeatureFlag")' query directive to the 'versionAssociatedFeatureFlagRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedFeatureFlag
     */
    versionAssociatedFeatureFlagRelationship?: Maybe<GraphStoreFullVersionAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:issue] as defined by version-associated-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedIssue")' query directive to the 'versionAssociatedIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedIssue?: Maybe<GraphStoreSimplifiedVersionAssociatedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedIssue")' query directive to the 'versionAssociatedIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedIssueInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedIssue")' query directive to the 'versionAssociatedIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedIssueInverse
     */
    versionAssociatedIssueInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:issue] as defined by version-associated-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedIssue")' query directive to the 'versionAssociatedIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedIssue
     */
    versionAssociatedIssueRelationship?: Maybe<GraphStoreFullVersionAssociatedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by version-associated-pull-request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedPullRequest")' query directive to the 'versionAssociatedPullRequest' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedPullRequest?: Maybe<GraphStoreSimplifiedVersionAssociatedPullRequestConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-pull-request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedPullRequest")' query directive to the 'versionAssociatedPullRequestInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedPullRequestInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedPullRequestInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-pull-request.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedPullRequest")' query directive to the 'versionAssociatedPullRequestInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedPullRequestInverse
     */
    versionAssociatedPullRequestInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedPullRequestConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] as defined by version-associated-pull-request.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedPullRequest")' query directive to the 'versionAssociatedPullRequestRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedPullRequest
     */
    versionAssociatedPullRequestRelationship?: Maybe<GraphStoreFullVersionAssociatedPullRequestConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by version-associated-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedRemoteLink")' query directive to the 'versionAssociatedRemoteLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedRemoteLink?: Maybe<GraphStoreSimplifiedVersionAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-remote-link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedRemoteLink")' query directive to the 'versionAssociatedRemoteLinkInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionAssociatedRemoteLinkInverse?: Maybe<GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link], fetches type(s) [ati:cloud:jira:version] as defined by version-associated-remote-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedRemoteLink")' query directive to the 'versionAssociatedRemoteLinkInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedRemoteLinkInverse
     */
    versionAssociatedRemoteLinkInverseRelationship?: Maybe<GraphStoreFullVersionAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] as defined by version-associated-remote-link.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionAssociatedRemoteLink")' query directive to the 'versionAssociatedRemoteLinkRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionAssociatedRemoteLink
     */
    versionAssociatedRemoteLinkRelationship?: Maybe<GraphStoreFullVersionAssociatedRemoteLinkConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by version-user-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionUserAssociatedFeatureFlag")' query directive to the 'versionUserAssociatedFeatureFlag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionUserAssociatedFeatureFlag?: Maybe<GraphStoreSimplifiedVersionUserAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:version] as defined by version-user-associated-feature-flag.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionUserAssociatedFeatureFlag")' query directive to the 'versionUserAssociatedFeatureFlagInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionUserAssociatedFeatureFlagInverse?: Maybe<GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag], fetches type(s) [ati:cloud:jira:version] as defined by version-user-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionUserAssociatedFeatureFlag")' query directive to the 'versionUserAssociatedFeatureFlagInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionUserAssociatedFeatureFlagInverse
     */
    versionUserAssociatedFeatureFlagInverseRelationship?: Maybe<GraphStoreFullVersionUserAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:version], fetches type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] as defined by version-user-associated-feature-flag.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionUserAssociatedFeatureFlag")' query directive to the 'versionUserAssociatedFeatureFlagRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use versionUserAssociatedFeatureFlag
     */
    versionUserAssociatedFeatureFlagRelationship?: Maybe<GraphStoreFullVersionUserAssociatedFeatureFlagConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:video], fetches type(s) [ati:cloud:loom:comment] as defined by video-has-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVideoHasComment")' query directive to the 'videoHasComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    videoHasComment?: Maybe<GraphStoreSimplifiedVideoHasCommentConnection>;
    /**
     * Given an id of type(s) [ati:cloud:loom:comment], fetches type(s) [ati:cloud:loom:video] as defined by video-has-comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVideoHasComment")' query directive to the 'videoHasCommentInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    videoHasCommentInverse?: Maybe<GraphStoreSimplifiedVideoHasCommentInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:issue] as defined by vulnerability-associated-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVulnerabilityAssociatedIssue")' query directive to the 'vulnerabilityAssociatedIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    vulnerabilityAssociatedIssue?: Maybe<GraphStoreSimplifiedVulnerabilityAssociatedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by vulnerability-associated-issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVulnerabilityAssociatedIssue")' query directive to the 'vulnerabilityAssociatedIssueInverse' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    vulnerabilityAssociatedIssueInverse?: Maybe<GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:issue], fetches type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] as defined by vulnerability-associated-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVulnerabilityAssociatedIssue")' query directive to the 'vulnerabilityAssociatedIssueInverseRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use vulnerabilityAssociatedIssueInverse
     */
    vulnerabilityAssociatedIssueInverseRelationship?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueConnection>;
    /**
     * Given an id of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability], fetches type(s) [ati:cloud:jira:issue] as defined by vulnerability-associated-issue.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVulnerabilityAssociatedIssue")' query directive to the 'vulnerabilityAssociatedIssueRelationship' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use vulnerabilityAssociatedIssue
     */
    vulnerabilityAssociatedIssueRelationship?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueConnection>;
};

export type GraphStoreAppInstallationAssociatedToOperationsWorkspaceInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreAppInstallationAssociatedToOperationsWorkspaceRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreAppInstallationAssociatedToSecurityWorkspaceInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreAppInstallationAssociatedToSecurityWorkspaceRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreAtlasGoalHasContributorArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasContributorSortInput>;
};

export type GraphStoreAtlasGoalHasContributorInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasContributorSortInput>;
};

export type GraphStoreAtlasGoalHasFollowerArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasFollowerSortInput>;
};

export type GraphStoreAtlasGoalHasFollowerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasFollowerSortInput>;
};

export type GraphStoreAtlasGoalHasGoalUpdateArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasGoalUpdateSortInput>;
};

export type GraphStoreAtlasGoalHasGoalUpdateInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasGoalUpdateSortInput>;
};

export type GraphStoreAtlasGoalHasOwnerArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasOwnerSortInput>;
};

export type GraphStoreAtlasGoalHasOwnerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasOwnerSortInput>;
};

export type GraphStoreAtlasGoalHasSubAtlasGoalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasSubAtlasGoalSortInput>;
};

export type GraphStoreAtlasGoalHasSubAtlasGoalInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasSubAtlasGoalSortInput>;
};

export type GraphStoreAtlasGoalHasUpdateArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreAtlasGoalHasUpdateFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasUpdateSortInput>;
};

export type GraphStoreAtlasGoalHasUpdateInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreAtlasGoalHasUpdateFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasGoalHasUpdateSortInput>;
};

export type GraphStoreAtlasHomeFeedArgs = {
    container_ids: Array<Scalars["ID"]["input"]>;
    ranking_criteria?: InputMaybe<GraphStoreAtlasHomeRankingCriteria>;
};

export type GraphStoreAtlasProjectContributesToAtlasGoalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectContributesToAtlasGoalSortInput>;
};

export type GraphStoreAtlasProjectContributesToAtlasGoalInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectContributesToAtlasGoalSortInput>;
};

export type GraphStoreAtlasProjectContributesToAtlasGoalInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreAtlasProjectContributesToAtlasGoalRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreAtlasProjectDependsOnAtlasProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectDependsOnAtlasProjectSortInput>;
};

export type GraphStoreAtlasProjectDependsOnAtlasProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectDependsOnAtlasProjectSortInput>;
};

export type GraphStoreAtlasProjectHasContributorArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasContributorSortInput>;
};

export type GraphStoreAtlasProjectHasContributorInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasContributorSortInput>;
};

export type GraphStoreAtlasProjectHasFollowerArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasFollowerSortInput>;
};

export type GraphStoreAtlasProjectHasFollowerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasFollowerSortInput>;
};

export type GraphStoreAtlasProjectHasOwnerArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasOwnerSortInput>;
};

export type GraphStoreAtlasProjectHasOwnerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasOwnerSortInput>;
};

export type GraphStoreAtlasProjectHasProjectUpdateArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasProjectUpdateSortInput>;
};

export type GraphStoreAtlasProjectHasProjectUpdateInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasProjectUpdateSortInput>;
};

export type GraphStoreAtlasProjectHasUpdateArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreAtlasProjectHasUpdateFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasUpdateSortInput>;
};

export type GraphStoreAtlasProjectHasUpdateInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreAtlasProjectHasUpdateFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectHasUpdateSortInput>;
};

export type GraphStoreAtlasProjectIsRelatedToAtlasProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectIsRelatedToAtlasProjectSortInput>;
};

export type GraphStoreAtlasProjectIsRelatedToAtlasProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectIsRelatedToAtlasProjectSortInput>;
};

export type GraphStoreAtlasProjectIsTrackedOnJiraEpicArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectIsTrackedOnJiraEpicSortInput>;
};

export type GraphStoreAtlasProjectIsTrackedOnJiraEpicInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreAtlasProjectIsTrackedOnJiraEpicSortInput>;
};

export type GraphStoreAtlasProjectIsTrackedOnJiraEpicInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreAtlasProjectIsTrackedOnJiraEpicRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreBoardBelongsToProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreBoardBelongsToProjectSortInput>;
};

export type GraphStoreBoardBelongsToProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreBoardBelongsToProjectSortInput>;
};

export type GraphStoreCalendarHasLinkedDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreCalendarHasLinkedDocumentSortInput>;
};

export type GraphStoreCalendarHasLinkedDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreCalendarHasLinkedDocumentSortInput>;
};

export type GraphStoreComponentImpactedByIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreComponentImpactedByIncidentSortInput>;
};

export type GraphStoreComponentImpactedByIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreComponentImpactedByIncidentSortInput>;
};

export type GraphStoreComponentImpactedByIncidentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreComponentImpactedByIncidentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreComponentLinkIsJiraProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreComponentLinkIsJiraProjectSortInput>;
};

export type GraphStoreComponentLinkedJswIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreComponentLinkedJswIssueSortInput>;
};

export type GraphStoreComponentLinkedJswIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreComponentLinkedJswIssueSortInput>;
};

export type GraphStoreComponentLinkedJswIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreComponentLinkedJswIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreConfluenceBlogpostHasCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceBlogpostHasCommentSortInput>;
};

export type GraphStoreConfluenceBlogpostHasCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceBlogpostHasCommentSortInput>;
};

export type GraphStoreConfluenceBlogpostSharedWithUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceBlogpostSharedWithUserSortInput>;
};

export type GraphStoreConfluenceBlogpostSharedWithUserInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceBlogpostSharedWithUserSortInput>;
};

export type GraphStoreConfluencePageHasCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasCommentSortInput>;
};

export type GraphStoreConfluencePageHasCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasCommentSortInput>;
};

export type GraphStoreConfluencePageHasConfluenceCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasConfluenceCommentSortInput>;
};

export type GraphStoreConfluencePageHasConfluenceCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasConfluenceCommentSortInput>;
};

export type GraphStoreConfluencePageHasConfluenceDatabaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasConfluenceDatabaseSortInput>;
};

export type GraphStoreConfluencePageHasConfluenceDatabaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasConfluenceDatabaseSortInput>;
};

export type GraphStoreConfluencePageHasParentPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasParentPageSortInput>;
};

export type GraphStoreConfluencePageHasParentPageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageHasParentPageSortInput>;
};

export type GraphStoreConfluencePageSharedWithGroupInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageSharedWithGroupSortInput>;
};

export type GraphStoreConfluencePageSharedWithUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageSharedWithUserSortInput>;
};

export type GraphStoreConfluencePageSharedWithUserInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluencePageSharedWithUserSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceBlogpostSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceBlogpostSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceDatabaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceDatabaseSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceDatabaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceDatabaseSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceFolderArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceFolderSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceFolderInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceFolderSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceWhiteboardSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConfluenceSpaceHasConfluenceWhiteboardSortInput>;
};

export type GraphStoreContentReferencedEntityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreContentReferencedEntitySortInput>;
};

export type GraphStoreContentReferencedEntityBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreContentReferencedEntitySortInput>;
};

export type GraphStoreContentReferencedEntityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreContentReferencedEntitySortInput>;
};

export type GraphStoreContentReferencedEntityInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreContentReferencedEntitySortInput>;
};

export type GraphStoreContentReferencedEntityInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreContentReferencedEntityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreConversationHasMessageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConversationHasMessageSortInput>;
};

export type GraphStoreConversationHasMessageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreConversationHasMessageSortInput>;
};

export type GraphStoreCypherQueryArgs = {
    additionalInputs?: InputMaybe<Scalars["JSON"]["input"]>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query: Scalars["String"]["input"];
};

export type GraphStoreDeploymentContainsCommitArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreDeploymentContainsCommitSortInput>;
};

export type GraphStoreDeploymentContainsCommitInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreDeploymentContainsCommitSortInput>;
};

export type GraphStoreExternalWorkerConflatesToIdentity3pUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreExternalWorkerConflatesToIdentity3pUserSortInput>;
};

export type GraphStoreFetchAllRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    ignoredRelationshipTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphStoreFocusAreaAssociatedToProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaAssociatedToProjectSortInput>;
};

export type GraphStoreFocusAreaAssociatedToProjectBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaAssociatedToProjectSortInput>;
};

export type GraphStoreFocusAreaAssociatedToProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaAssociatedToProjectSortInput>;
};

export type GraphStoreFocusAreaAssociatedToProjectInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaAssociatedToProjectSortInput>;
};

export type GraphStoreFocusAreaHasAtlasGoalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasAtlasGoalSortInput>;
};

export type GraphStoreFocusAreaHasAtlasGoalBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaHasAtlasGoalSortInput>;
};

export type GraphStoreFocusAreaHasAtlasGoalInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasAtlasGoalSortInput>;
};

export type GraphStoreFocusAreaHasAtlasGoalInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaHasAtlasGoalSortInput>;
};

export type GraphStoreFocusAreaHasFocusAreaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasFocusAreaSortInput>;
};

export type GraphStoreFocusAreaHasFocusAreaBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaHasFocusAreaSortInput>;
};

export type GraphStoreFocusAreaHasFocusAreaInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasFocusAreaSortInput>;
};

export type GraphStoreFocusAreaHasFocusAreaInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaHasFocusAreaSortInput>;
};

export type GraphStoreFocusAreaHasPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasPageSortInput>;
};

export type GraphStoreFocusAreaHasPageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasPageSortInput>;
};

export type GraphStoreFocusAreaHasProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasProjectSortInput>;
};

export type GraphStoreFocusAreaHasProjectBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaHasProjectSortInput>;
};

export type GraphStoreFocusAreaHasProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreFocusAreaHasProjectSortInput>;
};

export type GraphStoreFocusAreaHasProjectInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreFocusAreaHasProjectSortInput>;
};

export type GraphStoreGraphDocument3pDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreGraphDocument3pDocumentSortInput>;
};

export type GraphStoreGraphEntityReplicates3pEntityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreGraphEntityReplicates3pEntitySortInput>;
};

export type GraphStoreGroupCanViewConfluenceSpaceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreGroupCanViewConfluenceSpaceSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewLinkSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewLinkSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewLinkSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkInverseBatchArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        ids: Array<Scalars["ID"]["input"]>;
        sort?: InputMaybe<GraphStoreIncidentAssociatedPostIncidentReviewLinkSortInput>;
    };

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreIncidentAssociatedPostIncidentReviewRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIncidentHasActionItemArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentHasActionItemSortInput>;
};

export type GraphStoreIncidentHasActionItemBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentHasActionItemSortInput>;
};

export type GraphStoreIncidentHasActionItemInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentHasActionItemSortInput>;
};

export type GraphStoreIncidentHasActionItemInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentHasActionItemSortInput>;
};

export type GraphStoreIncidentHasActionItemInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIncidentHasActionItemRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIncidentLinkedJswIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentLinkedJswIssueSortInput>;
};

export type GraphStoreIncidentLinkedJswIssueBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentLinkedJswIssueSortInput>;
};

export type GraphStoreIncidentLinkedJswIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIncidentLinkedJswIssueSortInput>;
};

export type GraphStoreIncidentLinkedJswIssueInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIncidentLinkedJswIssueSortInput>;
};

export type GraphStoreIncidentLinkedJswIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIncidentLinkedJswIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedBranchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedBranchSortInput>;
};

export type GraphStoreIssueAssociatedBranchInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedBranchSortInput>;
};

export type GraphStoreIssueAssociatedBranchInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedBranchRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedBuildArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedBuildSortInput>;
};

export type GraphStoreIssueAssociatedBuildBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIssueAssociatedBuildSortInput>;
};

export type GraphStoreIssueAssociatedBuildInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedBuildSortInput>;
};

export type GraphStoreIssueAssociatedBuildInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIssueAssociatedBuildSortInput>;
};

export type GraphStoreIssueAssociatedBuildInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedBuildRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedCommitArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedCommitSortInput>;
};

export type GraphStoreIssueAssociatedCommitInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedCommitSortInput>;
};

export type GraphStoreIssueAssociatedCommitInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedCommitRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreIssueAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedDeploymentSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreIssueAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIssueAssociatedDeploymentSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreIssueAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedDeploymentSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreIssueAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIssueAssociatedDeploymentSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreIssueAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedDeploymentSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreIssueAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedDeploymentSortInput>;
};

export type GraphStoreIssueAssociatedDesignArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedDesignSortInput>;
};

export type GraphStoreIssueAssociatedDesignInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedDesignSortInput>;
};

export type GraphStoreIssueAssociatedDesignInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedDesignRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedFeatureFlagArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedFeatureFlagSortInput>;
};

export type GraphStoreIssueAssociatedFeatureFlagInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedFeatureFlagSortInput>;
};

export type GraphStoreIssueAssociatedFeatureFlagInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedFeatureFlagRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedIssueRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedIssueRemoteLinkSortInput>;
};

export type GraphStoreIssueAssociatedIssueRemoteLinkBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIssueAssociatedIssueRemoteLinkSortInput>;
};

export type GraphStoreIssueAssociatedIssueRemoteLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedIssueRemoteLinkSortInput>;
};

export type GraphStoreIssueAssociatedIssueRemoteLinkInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreIssueAssociatedIssueRemoteLinkSortInput>;
};

export type GraphStoreIssueAssociatedIssueRemoteLinkInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedIssueRemoteLinkRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedPrSortInput>;
};

export type GraphStoreIssueAssociatedPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedPrSortInput>;
};

export type GraphStoreIssueAssociatedPrInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedRemoteLinkSortInput>;
};

export type GraphStoreIssueAssociatedRemoteLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueAssociatedRemoteLinkSortInput>;
};

export type GraphStoreIssueAssociatedRemoteLinkInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueAssociatedRemoteLinkRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueChangesComponentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueChangesComponentSortInput>;
};

export type GraphStoreIssueChangesComponentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueChangesComponentSortInput>;
};

export type GraphStoreIssueChangesComponentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueChangesComponentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueHasAssigneeArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueHasAssigneeSortInput>;
};

export type GraphStoreIssueHasAssigneeInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueHasAssigneeSortInput>;
};

export type GraphStoreIssueHasAutodevJobInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueHasAutodevJobSortInput>;
};

export type GraphStoreIssueMentionedInConversationArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueMentionedInConversationSortInput>;
};

export type GraphStoreIssueMentionedInConversationInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueMentionedInConversationSortInput>;
};

export type GraphStoreIssueMentionedInMessageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueMentionedInMessageSortInput>;
};

export type GraphStoreIssueMentionedInMessageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueMentionedInMessageSortInput>;
};

export type GraphStoreIssueRecursiveAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueRecursiveAssociatedPrSortInput>;
};

export type GraphStoreIssueRecursiveAssociatedPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueRecursiveAssociatedPrSortInput>;
};

export type GraphStoreIssueRecursiveAssociatedPrInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueRecursiveAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueToWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueToWhiteboardSortInput>;
};

export type GraphStoreIssueToWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreIssueToWhiteboardSortInput>;
};

export type GraphStoreIssueToWhiteboardInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreIssueToWhiteboardRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJiraEpicContributesToAtlasGoalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraEpicContributesToAtlasGoalSortInput>;
};

export type GraphStoreJiraEpicContributesToAtlasGoalInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraEpicContributesToAtlasGoalSortInput>;
};

export type GraphStoreJiraEpicContributesToAtlasGoalInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJiraEpicContributesToAtlasGoalRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJiraIssueBlockedByJiraIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraIssueBlockedByJiraIssueSortInput>;
};

export type GraphStoreJiraIssueBlockedByJiraIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraIssueBlockedByJiraIssueSortInput>;
};

export type GraphStoreJiraIssueToJiraPriorityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraIssueToJiraPrioritySortInput>;
};

export type GraphStoreJiraProjectAssociatedAtlasGoalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraProjectAssociatedAtlasGoalSortInput>;
};

export type GraphStoreJiraProjectAssociatedAtlasGoalInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJiraProjectAssociatedAtlasGoalSortInput>;
};

export type GraphStoreJiraProjectAssociatedAtlasGoalInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJiraProjectAssociatedAtlasGoalRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJsmProjectAssociatedServiceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJsmProjectAssociatedServiceSortInput>;
};

export type GraphStoreJsmProjectAssociatedServiceBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreJsmProjectAssociatedServiceSortInput>;
};

export type GraphStoreJsmProjectAssociatedServiceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJsmProjectAssociatedServiceSortInput>;
};

export type GraphStoreJsmProjectAssociatedServiceInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreJsmProjectAssociatedServiceSortInput>;
};

export type GraphStoreJsmProjectAssociatedServiceInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJsmProjectAssociatedServiceRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJswProjectAssociatedComponentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectAssociatedComponentSortInput>;
};

export type GraphStoreJswProjectAssociatedComponentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectAssociatedComponentSortInput>;
};

export type GraphStoreJswProjectAssociatedComponentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJswProjectAssociatedComponentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreJswProjectAssociatedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreJswProjectAssociatedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectAssociatedIncidentSortInput>;
};

export type GraphStoreJswProjectAssociatedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreJswProjectAssociatedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectAssociatedIncidentSortInput>;
};

export type GraphStoreJswProjectAssociatedIncidentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreJswProjectAssociatedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectAssociatedIncidentSortInput>;
};

export type GraphStoreJswProjectAssociatedIncidentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreJswProjectAssociatedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectAssociatedIncidentSortInput>;
};

export type GraphStoreJswProjectSharesComponentWithJsmProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectSharesComponentWithJsmProjectSortInput>;
};

export type GraphStoreJswProjectSharesComponentWithJsmProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreJswProjectSharesComponentWithJsmProjectSortInput>;
};

export type GraphStoreJswProjectSharesComponentWithJsmProjectInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreJswProjectSharesComponentWithJsmProjectRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreLinkedProjectHasVersionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreLinkedProjectHasVersionSortInput>;
};

export type GraphStoreLinkedProjectHasVersionInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreLinkedProjectHasVersionSortInput>;
};

export type GraphStoreLinkedProjectHasVersionInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreLinkedProjectHasVersionRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreLoomVideoSharedWithUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreLoomVideoSharedWithUserSortInput>;
};

export type GraphStoreLoomVideoSharedWithUserInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreLoomVideoSharedWithUserSortInput>;
};

export type GraphStoreMediaAttachedToContentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreMediaAttachedToContentSortInput>;
};

export type GraphStoreMediaAttachedToContentBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreMediaAttachedToContentSortInput>;
};

export type GraphStoreMediaAttachedToContentInverseBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreMediaAttachedToContentSortInput>;
};

export type GraphStoreMeetingHasMeetingNotesPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreMeetingHasMeetingNotesPageSortInput>;
};

export type GraphStoreMeetingRecordingOwnerHasMeetingNotesFolderArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreMeetingRecordingOwnerHasMeetingNotesFolderSortInput>;
};

export type GraphStoreMeetingRecordingOwnerHasMeetingNotesFolderInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreMeetingRecordingOwnerHasMeetingNotesFolderSortInput>;
};

export type GraphStoreMeetingRecurrenceHasMeetingRecurrenceNotesPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreMeetingRecurrenceHasMeetingRecurrenceNotesPageSortInput>;
};

export type GraphStoreOperationsContainerImpactedByIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreOperationsContainerImpactedByIncidentSortInput>;
};

export type GraphStoreOperationsContainerImpactedByIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreOperationsContainerImpactedByIncidentSortInput>;
};

export type GraphStoreOperationsContainerImpactedByIncidentInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreOperationsContainerImpactedByIncidentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreOperationsContainerImprovedByActionItemArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreOperationsContainerImprovedByActionItemSortInput>;
};

export type GraphStoreOperationsContainerImprovedByActionItemInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreOperationsContainerImprovedByActionItemSortInput>;
};

export type GraphStoreOperationsContainerImprovedByActionItemInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreOperationsContainerImprovedByActionItemRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreParentCommentHasChildCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentCommentHasChildCommentSortInput>;
};

export type GraphStoreParentCommentHasChildCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentCommentHasChildCommentSortInput>;
};

export type GraphStoreParentDocumentHasChildDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentDocumentHasChildDocumentSortInput>;
};

export type GraphStoreParentDocumentHasChildDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentDocumentHasChildDocumentSortInput>;
};

export type GraphStoreParentDocumentHasChildDocumentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreParentDocumentHasChildDocumentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreParentIssueHasChildIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentIssueHasChildIssueSortInput>;
};

export type GraphStoreParentIssueHasChildIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentIssueHasChildIssueSortInput>;
};

export type GraphStoreParentIssueHasChildIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreParentIssueHasChildIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreParentMessageHasChildMessageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentMessageHasChildMessageSortInput>;
};

export type GraphStoreParentMessageHasChildMessageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreParentMessageHasChildMessageSortInput>;
};

export type GraphStorePositionAllocatedToFocusAreaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStorePositionAllocatedToFocusAreaSortInput>;
};

export type GraphStorePositionAllocatedToFocusAreaInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStorePositionAllocatedToFocusAreaSortInput>;
};

export type GraphStorePrInRepoArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStorePrInRepoSortInput>;
};

export type GraphStorePrInRepoInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStorePrInRepoSortInput>;
};

export type GraphStorePrInRepoInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStorePrInRepoRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedBranchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedBranchSortInput>;
};

export type GraphStoreProjectAssociatedBranchInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedBranchSortInput>;
};

export type GraphStoreProjectAssociatedBranchInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedBranchRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedBuildArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedBuildSortInput>;
};

export type GraphStoreProjectAssociatedBuildInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedBuildSortInput>;
};

export type GraphStoreProjectAssociatedBuildInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedBuildSortInput>;
};

export type GraphStoreProjectAssociatedBuildRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedBuildSortInput>;
};

export type GraphStoreProjectAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedDeploymentSortInput>;
};

export type GraphStoreProjectAssociatedDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedDeploymentSortInput>;
};

export type GraphStoreProjectAssociatedDeploymentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedDeploymentSortInput>;
};

export type GraphStoreProjectAssociatedDeploymentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedDeploymentSortInput>;
};

export type GraphStoreProjectAssociatedFeatureFlagArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedFeatureFlagSortInput>;
};

export type GraphStoreProjectAssociatedFeatureFlagInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedFeatureFlagSortInput>;
};

export type GraphStoreProjectAssociatedFeatureFlagInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedFeatureFlagRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedIncidentSortInput>;
};

export type GraphStoreProjectAssociatedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedIncidentSortInput>;
};

export type GraphStoreProjectAssociatedIncidentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedIncidentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedOpsgenieTeamArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedOpsgenieTeamSortInput>;
};

export type GraphStoreProjectAssociatedOpsgenieTeamInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedOpsgenieTeamSortInput>;
};

export type GraphStoreProjectAssociatedOpsgenieTeamInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedOpsgenieTeamRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedPrSortInput>;
};

export type GraphStoreProjectAssociatedPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedPrSortInput>;
};

export type GraphStoreProjectAssociatedPrInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedPrSortInput>;
};

export type GraphStoreProjectAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedPrSortInput>;
};

export type GraphStoreProjectAssociatedRepoArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedRepoFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedRepoSortInput>;
};

export type GraphStoreProjectAssociatedRepoInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedRepoFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedRepoSortInput>;
};

export type GraphStoreProjectAssociatedRepoInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedRepoFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedRepoSortInput>;
};

export type GraphStoreProjectAssociatedRepoRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedRepoFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedRepoSortInput>;
};

export type GraphStoreProjectAssociatedServiceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedServiceSortInput>;
};

export type GraphStoreProjectAssociatedServiceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedServiceSortInput>;
};

export type GraphStoreProjectAssociatedServiceInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedServiceRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedToIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedToIncidentSortInput>;
};

export type GraphStoreProjectAssociatedToIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedToIncidentSortInput>;
};

export type GraphStoreProjectAssociatedToIncidentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedToIncidentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedToOperationsContainerArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedToOperationsContainerSortInput>;
};

export type GraphStoreProjectAssociatedToOperationsContainerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedToOperationsContainerSortInput>;
};

export type GraphStoreProjectAssociatedToOperationsContainerInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreProjectAssociatedToOperationsContainerRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedToSecurityContainerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedToSecurityContainerSortInput>;
};

export type GraphStoreProjectAssociatedToSecurityContainerInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreProjectAssociatedToSecurityContainerRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectAssociatedVulnerabilityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedVulnerabilitySortInput>;
};

export type GraphStoreProjectAssociatedVulnerabilityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedVulnerabilitySortInput>;
};

export type GraphStoreProjectAssociatedVulnerabilityInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedVulnerabilitySortInput>;
};

export type GraphStoreProjectAssociatedVulnerabilityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectAssociatedVulnerabilitySortInput>;
};

export type GraphStoreProjectDisassociatedRepoArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDisassociatedRepoSortInput>;
};

export type GraphStoreProjectDisassociatedRepoInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDisassociatedRepoSortInput>;
};

export type GraphStoreProjectDisassociatedRepoInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDisassociatedRepoRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDocumentationEntityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDocumentationEntitySortInput>;
};

export type GraphStoreProjectDocumentationEntityInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDocumentationEntitySortInput>;
};

export type GraphStoreProjectDocumentationEntityInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDocumentationEntityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDocumentationPageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDocumentationPageSortInput>;
};

export type GraphStoreProjectDocumentationPageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDocumentationPageSortInput>;
};

export type GraphStoreProjectDocumentationPageInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDocumentationPageRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDocumentationSpaceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDocumentationSpaceSortInput>;
};

export type GraphStoreProjectDocumentationSpaceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectDocumentationSpaceSortInput>;
};

export type GraphStoreProjectDocumentationSpaceInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectDocumentationSpaceRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectExplicitlyAssociatedRepoArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectExplicitlyAssociatedRepoSortInput>;
};

export type GraphStoreProjectExplicitlyAssociatedRepoInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectExplicitlyAssociatedRepoSortInput>;
};

export type GraphStoreProjectExplicitlyAssociatedRepoInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectExplicitlyAssociatedRepoRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectHasIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectHasIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasIssueSortInput>;
};

export type GraphStoreProjectHasIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectHasIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasIssueSortInput>;
};

export type GraphStoreProjectHasIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectHasIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasIssueSortInput>;
};

export type GraphStoreProjectHasIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectHasIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasIssueSortInput>;
};

export type GraphStoreProjectHasRelatedWorkWithProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasRelatedWorkWithProjectSortInput>;
};

export type GraphStoreProjectHasRelatedWorkWithProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasRelatedWorkWithProjectSortInput>;
};

export type GraphStoreProjectHasSharedVersionWithArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasSharedVersionWithSortInput>;
};

export type GraphStoreProjectHasSharedVersionWithInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasSharedVersionWithSortInput>;
};

export type GraphStoreProjectHasSharedVersionWithInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectHasSharedVersionWithRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectHasVersionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasVersionSortInput>;
};

export type GraphStoreProjectHasVersionInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectHasVersionSortInput>;
};

export type GraphStoreProjectHasVersionInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectHasVersionRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreProjectLinkedToCompassComponentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectLinkedToCompassComponentSortInput>;
};

export type GraphStoreProjectLinkedToCompassComponentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreProjectLinkedToCompassComponentSortInput>;
};

export type GraphStorePullRequestLinksToServiceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStorePullRequestLinksToServiceSortInput>;
};

export type GraphStorePullRequestLinksToServiceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStorePullRequestLinksToServiceSortInput>;
};

export type GraphStoreSecurityContainerAssociatedToVulnerabilityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSecurityContainerAssociatedToVulnerabilitySortInput>;
};

export type GraphStoreSecurityContainerAssociatedToVulnerabilityBatchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    sort?: InputMaybe<GraphStoreSecurityContainerAssociatedToVulnerabilitySortInput>;
};

export type GraphStoreSecurityContainerAssociatedToVulnerabilityInverseBatchArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        ids: Array<Scalars["ID"]["input"]>;
        sort?: InputMaybe<GraphStoreSecurityContainerAssociatedToVulnerabilitySortInput>;
    };

export type GraphStoreSecurityContainerAssociatedToVulnerabilityInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreSecurityContainerAssociatedToVulnerabilityRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreServiceAssociatedBranchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedBranchSortInput>;
};

export type GraphStoreServiceAssociatedBranchInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedBranchSortInput>;
};

export type GraphStoreServiceAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedDeploymentSortInput>;
};

export type GraphStoreServiceAssociatedDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedDeploymentSortInput>;
};

export type GraphStoreServiceAssociatedRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedRemoteLinkSortInput>;
};

export type GraphStoreServiceAssociatedRemoteLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedRemoteLinkSortInput>;
};

export type GraphStoreServiceAssociatedTeamArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedTeamSortInput>;
};

export type GraphStoreServiceAssociatedTeamInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceAssociatedTeamSortInput>;
};

export type GraphStoreServiceLinkedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreServiceLinkedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceLinkedIncidentSortInput>;
};

export type GraphStoreServiceLinkedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreServiceLinkedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceLinkedIncidentSortInput>;
};

export type GraphStoreServiceLinkedIncidentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreServiceLinkedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceLinkedIncidentSortInput>;
};

export type GraphStoreServiceLinkedIncidentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreServiceLinkedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreServiceLinkedIncidentSortInput>;
};

export type GraphStoreSpaceAssociatedWithProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSpaceAssociatedWithProjectSortInput>;
};

export type GraphStoreSpaceAssociatedWithProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSpaceAssociatedWithProjectSortInput>;
};

export type GraphStoreSprintAssociatedBuildArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedBuildSortInput>;
};

export type GraphStoreSprintAssociatedBuildInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedBuildSortInput>;
};

export type GraphStoreSprintAssociatedBuildRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedBuildFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedBuildSortInput>;
};

export type GraphStoreSprintAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedDeploymentSortInput>;
};

export type GraphStoreSprintAssociatedDeploymentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedDeploymentSortInput>;
};

export type GraphStoreSprintAssociatedDeploymentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedDeploymentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedDeploymentSortInput>;
};

export type GraphStoreSprintAssociatedPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedPrSortInput>;
};

export type GraphStoreSprintAssociatedPrInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedPrSortInput>;
};

export type GraphStoreSprintAssociatedPrRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedPrFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedPrSortInput>;
};

export type GraphStoreSprintAssociatedVulnerabilityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedVulnerabilitySortInput>;
};

export type GraphStoreSprintAssociatedVulnerabilityInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedVulnerabilitySortInput>;
};

export type GraphStoreSprintAssociatedVulnerabilityRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintAssociatedVulnerabilityFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintAssociatedVulnerabilitySortInput>;
};

export type GraphStoreSprintContainsIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintContainsIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintContainsIssueSortInput>;
};

export type GraphStoreSprintContainsIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintContainsIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintContainsIssueSortInput>;
};

export type GraphStoreSprintContainsIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreSprintContainsIssueFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintContainsIssueSortInput>;
};

export type GraphStoreSprintRetrospectivePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintRetrospectivePageSortInput>;
};

export type GraphStoreSprintRetrospectivePageInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreSprintRetrospectivePageRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreSprintRetrospectiveWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreSprintRetrospectiveWhiteboardSortInput>;
};

export type GraphStoreSprintRetrospectiveWhiteboardInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreSprintRetrospectiveWhiteboardRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreTeamConnectedToContainerArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreTeamConnectedToContainerSortInput>;
};

export type GraphStoreTeamConnectedToContainerInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreTeamConnectedToContainerSortInput>;
};

export type GraphStoreTeamOwnsComponentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreTeamOwnsComponentSortInput>;
};

export type GraphStoreTeamOwnsComponentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreTeamOwnsComponentSortInput>;
};

export type GraphStoreTeamWorksOnProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreTeamWorksOnProjectSortInput>;
};

export type GraphStoreTeamWorksOnProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreTeamWorksOnProjectSortInput>;
};

export type GraphStoreTeamWorksOnProjectInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreTeamWorksOnProjectRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreThirdPartyToGraphRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreThirdPartyToGraphRemoteLinkSortInput>;
};

export type GraphStoreUserAssignedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAssignedIncidentSortInput>;
};

export type GraphStoreUserAssignedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAssignedIncidentSortInput>;
};

export type GraphStoreUserAssignedIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAssignedIssueSortInput>;
};

export type GraphStoreUserAssignedIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAssignedIssueSortInput>;
};

export type GraphStoreUserAssignedPirArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAssignedPirSortInput>;
};

export type GraphStoreUserAssignedPirInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAssignedPirSortInput>;
};

export type GraphStoreUserAttendedCalendarEventArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAttendedCalendarEventSortInput>;
};

export type GraphStoreUserAttendedCalendarEventInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAttendedCalendarEventSortInput>;
};

export type GraphStoreUserAuthoredCommitArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAuthoredCommitSortInput>;
};

export type GraphStoreUserAuthoredCommitInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAuthoredCommitSortInput>;
};

export type GraphStoreUserAuthoredPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAuthoredPrSortInput>;
};

export type GraphStoreUserAuthoredPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAuthoredPrSortInput>;
};

export type GraphStoreUserAuthoritativelyLinkedThirdPartyUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreUserAuthoritativelyLinkedThirdPartyUserFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAuthoritativelyLinkedThirdPartyUserSortInput>;
};

export type GraphStoreUserAuthoritativelyLinkedThirdPartyUserInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreUserAuthoritativelyLinkedThirdPartyUserFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserAuthoritativelyLinkedThirdPartyUserSortInput>;
};

export type GraphStoreUserCanViewConfluenceSpaceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCanViewConfluenceSpaceSortInput>;
};

export type GraphStoreUserCanViewConfluenceSpaceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCanViewConfluenceSpaceSortInput>;
};

export type GraphStoreUserCollaboratedOnDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCollaboratedOnDocumentSortInput>;
};

export type GraphStoreUserCollaboratedOnDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCollaboratedOnDocumentSortInput>;
};

export type GraphStoreUserContributedConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserContributedConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserContributedConfluenceDatabaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluenceDatabaseSortInput>;
};

export type GraphStoreUserContributedConfluenceDatabaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluenceDatabaseSortInput>;
};

export type GraphStoreUserContributedConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluencePageSortInput>;
};

export type GraphStoreUserContributedConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluencePageSortInput>;
};

export type GraphStoreUserContributedConfluenceWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserContributedConfluenceWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserContributedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserCreatedBranchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedBranchSortInput>;
};

export type GraphStoreUserCreatedBranchInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedBranchSortInput>;
};

export type GraphStoreUserCreatedCalendarEventArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedCalendarEventSortInput>;
};

export type GraphStoreUserCreatedCalendarEventInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedCalendarEventSortInput>;
};

export type GraphStoreUserCreatedConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserCreatedConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserCreatedConfluenceCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceCommentSortInput>;
};

export type GraphStoreUserCreatedConfluenceCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceCommentSortInput>;
};

export type GraphStoreUserCreatedConfluenceDatabaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceDatabaseSortInput>;
};

export type GraphStoreUserCreatedConfluenceDatabaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceDatabaseSortInput>;
};

export type GraphStoreUserCreatedConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluencePageSortInput>;
};

export type GraphStoreUserCreatedConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluencePageSortInput>;
};

export type GraphStoreUserCreatedConfluenceSpaceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceSpaceSortInput>;
};

export type GraphStoreUserCreatedConfluenceSpaceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceSpaceSortInput>;
};

export type GraphStoreUserCreatedConfluenceWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserCreatedConfluenceWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserCreatedDesignArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedDesignSortInput>;
};

export type GraphStoreUserCreatedDesignInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedDesignSortInput>;
};

export type GraphStoreUserCreatedDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedDocumentSortInput>;
};

export type GraphStoreUserCreatedDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedDocumentSortInput>;
};

export type GraphStoreUserCreatedIssueCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedIssueCommentSortInput>;
};

export type GraphStoreUserCreatedIssueCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedIssueCommentSortInput>;
};

export type GraphStoreUserCreatedIssueWorklogArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedIssueWorklogSortInput>;
};

export type GraphStoreUserCreatedIssueWorklogInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedIssueWorklogSortInput>;
};

export type GraphStoreUserCreatedLoomVideoArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedLoomVideoSortInput>;
};

export type GraphStoreUserCreatedLoomVideoCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedLoomVideoCommentSortInput>;
};

export type GraphStoreUserCreatedLoomVideoCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedLoomVideoCommentSortInput>;
};

export type GraphStoreUserCreatedLoomVideoInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedLoomVideoSortInput>;
};

export type GraphStoreUserCreatedMessageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedMessageSortInput>;
};

export type GraphStoreUserCreatedMessageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedMessageSortInput>;
};

export type GraphStoreUserCreatedReleaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedReleaseSortInput>;
};

export type GraphStoreUserCreatedReleaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedReleaseSortInput>;
};

export type GraphStoreUserCreatedRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedRemoteLinkSortInput>;
};

export type GraphStoreUserCreatedRemoteLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedRemoteLinkSortInput>;
};

export type GraphStoreUserCreatedRepositoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedRepositorySortInput>;
};

export type GraphStoreUserCreatedRepositoryInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserCreatedRepositorySortInput>;
};

export type GraphStoreUserFavoritedConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserFavoritedConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserFavoritedConfluenceDatabaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluenceDatabaseSortInput>;
};

export type GraphStoreUserFavoritedConfluenceDatabaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluenceDatabaseSortInput>;
};

export type GraphStoreUserFavoritedConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluencePageSortInput>;
};

export type GraphStoreUserFavoritedConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluencePageSortInput>;
};

export type GraphStoreUserFavoritedConfluenceWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserFavoritedConfluenceWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserFavoritedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserHasCollaboratorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserHasCollaboratorsSortInput>;
};

export type GraphStoreUserHasCollaboratorsInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserHasCollaboratorsSortInput>;
};

export type GraphStoreUserHasRelevantProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserHasRelevantProjectSortInput>;
};

export type GraphStoreUserHasRelevantProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserHasRelevantProjectSortInput>;
};

export type GraphStoreUserHasTopProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserHasTopProjectSortInput>;
};

export type GraphStoreUserHasTopProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserHasTopProjectSortInput>;
};

export type GraphStoreUserIsInTeamArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserIsInTeamSortInput>;
};

export type GraphStoreUserIsInTeamInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserIsInTeamSortInput>;
};

export type GraphStoreUserLastUpdatedDesignArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserLastUpdatedDesignSortInput>;
};

export type GraphStoreUserLastUpdatedDesignInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserLastUpdatedDesignSortInput>;
};

export type GraphStoreUserLaunchedReleaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserLaunchedReleaseSortInput>;
};

export type GraphStoreUserLaunchedReleaseInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserLaunchedReleaseSortInput>;
};

export type GraphStoreUserLinkedThirdPartyUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreUserLinkedThirdPartyUserFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserLinkedThirdPartyUserSortInput>;
};

export type GraphStoreUserLinkedThirdPartyUserInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreUserLinkedThirdPartyUserFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserLinkedThirdPartyUserSortInput>;
};

export type GraphStoreUserMemberOfConversationArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMemberOfConversationSortInput>;
};

export type GraphStoreUserMemberOfConversationInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMemberOfConversationSortInput>;
};

export type GraphStoreUserMentionedInConversationArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMentionedInConversationSortInput>;
};

export type GraphStoreUserMentionedInConversationInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMentionedInConversationSortInput>;
};

export type GraphStoreUserMentionedInMessageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMentionedInMessageSortInput>;
};

export type GraphStoreUserMentionedInMessageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMentionedInMessageSortInput>;
};

export type GraphStoreUserMergedPullRequestArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMergedPullRequestSortInput>;
};

export type GraphStoreUserMergedPullRequestInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserMergedPullRequestSortInput>;
};

export type GraphStoreUserOwnedBranchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedBranchSortInput>;
};

export type GraphStoreUserOwnedBranchInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedBranchSortInput>;
};

export type GraphStoreUserOwnedCalendarEventArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedCalendarEventSortInput>;
};

export type GraphStoreUserOwnedCalendarEventInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedCalendarEventSortInput>;
};

export type GraphStoreUserOwnedDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedDocumentSortInput>;
};

export type GraphStoreUserOwnedDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedDocumentSortInput>;
};

export type GraphStoreUserOwnedRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedRemoteLinkSortInput>;
};

export type GraphStoreUserOwnedRemoteLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedRemoteLinkSortInput>;
};

export type GraphStoreUserOwnedRepositoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedRepositorySortInput>;
};

export type GraphStoreUserOwnedRepositoryInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnedRepositorySortInput>;
};

export type GraphStoreUserOwnsComponentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnsComponentSortInput>;
};

export type GraphStoreUserOwnsComponentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnsComponentSortInput>;
};

export type GraphStoreUserOwnsFocusAreaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnsFocusAreaSortInput>;
};

export type GraphStoreUserOwnsFocusAreaInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserOwnsFocusAreaSortInput>;
};

export type GraphStoreUserReportedIncidentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserReportedIncidentSortInput>;
};

export type GraphStoreUserReportedIncidentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserReportedIncidentSortInput>;
};

export type GraphStoreUserReportsIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserReportsIssueSortInput>;
};

export type GraphStoreUserReportsIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserReportsIssueSortInput>;
};

export type GraphStoreUserReviewsPrArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserReviewsPrSortInput>;
};

export type GraphStoreUserReviewsPrInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserReviewsPrSortInput>;
};

export type GraphStoreUserTaggedInCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInCommentSortInput>;
};

export type GraphStoreUserTaggedInCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInCommentSortInput>;
};

export type GraphStoreUserTaggedInConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInConfluencePageSortInput>;
};

export type GraphStoreUserTaggedInConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInConfluencePageSortInput>;
};

export type GraphStoreUserTaggedInIssueCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInIssueCommentSortInput>;
};

export type GraphStoreUserTaggedInIssueCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInIssueCommentSortInput>;
};

export type GraphStoreUserTaggedInLoomVideoCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInLoomVideoCommentSortInput>;
};

export type GraphStoreUserTaggedInLoomVideoCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTaggedInLoomVideoCommentSortInput>;
};

export type GraphStoreUserTriggeredDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTriggeredDeploymentSortInput>;
};

export type GraphStoreUserTriggeredDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserTriggeredDeploymentSortInput>;
};

export type GraphStoreUserUpdatedConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserUpdatedConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserUpdatedConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluencePageSortInput>;
};

export type GraphStoreUserUpdatedConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluencePageSortInput>;
};

export type GraphStoreUserUpdatedConfluenceSpaceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluenceSpaceSortInput>;
};

export type GraphStoreUserUpdatedConfluenceSpaceInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluenceSpaceSortInput>;
};

export type GraphStoreUserUpdatedConfluenceWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserUpdatedConfluenceWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserUpdatedGraphDocumentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedGraphDocumentSortInput>;
};

export type GraphStoreUserUpdatedGraphDocumentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedGraphDocumentSortInput>;
};

export type GraphStoreUserUpdatedIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedIssueSortInput>;
};

export type GraphStoreUserUpdatedIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedIssueSortInput>;
};

export type GraphStoreUserUpdatedIssueStatusInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserUpdatedIssueStatusSortInput>;
};

export type GraphStoreUserViewedAtlasGoalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedAtlasGoalSortInput>;
};

export type GraphStoreUserViewedAtlasGoalInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedAtlasGoalSortInput>;
};

export type GraphStoreUserViewedAtlasProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedAtlasProjectSortInput>;
};

export type GraphStoreUserViewedAtlasProjectInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedAtlasProjectSortInput>;
};

export type GraphStoreUserViewedConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserViewedConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedConfluenceBlogpostSortInput>;
};

export type GraphStoreUserViewedConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedConfluencePageSortInput>;
};

export type GraphStoreUserViewedConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedConfluencePageSortInput>;
};

export type GraphStoreUserViewedGoalUpdateArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedGoalUpdateSortInput>;
};

export type GraphStoreUserViewedGoalUpdateInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedGoalUpdateSortInput>;
};

export type GraphStoreUserViewedJiraIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedJiraIssueSortInput>;
};

export type GraphStoreUserViewedJiraIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedJiraIssueSortInput>;
};

export type GraphStoreUserViewedLoomVideoArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedLoomVideoSortInput>;
};

export type GraphStoreUserViewedLoomVideoInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedLoomVideoSortInput>;
};

export type GraphStoreUserViewedProjectUpdateArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedProjectUpdateSortInput>;
};

export type GraphStoreUserViewedProjectUpdateInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserViewedProjectUpdateSortInput>;
};

export type GraphStoreUserWatchesConfluenceBlogpostArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserWatchesConfluenceBlogpostSortInput>;
};

export type GraphStoreUserWatchesConfluenceBlogpostInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserWatchesConfluenceBlogpostSortInput>;
};

export type GraphStoreUserWatchesConfluencePageArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserWatchesConfluencePageSortInput>;
};

export type GraphStoreUserWatchesConfluencePageInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserWatchesConfluencePageSortInput>;
};

export type GraphStoreUserWatchesConfluenceWhiteboardArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserWatchesConfluenceWhiteboardSortInput>;
};

export type GraphStoreUserWatchesConfluenceWhiteboardInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreUserWatchesConfluenceWhiteboardSortInput>;
};

export type GraphStoreVersionAssociatedBranchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedBranchSortInput>;
};

export type GraphStoreVersionAssociatedBranchInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedBranchSortInput>;
};

export type GraphStoreVersionAssociatedBranchInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedBranchRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedBuildArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedBuildSortInput>;
};

export type GraphStoreVersionAssociatedBuildInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedBuildSortInput>;
};

export type GraphStoreVersionAssociatedBuildInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedBuildRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedCommitArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedCommitSortInput>;
};

export type GraphStoreVersionAssociatedCommitInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedCommitSortInput>;
};

export type GraphStoreVersionAssociatedCommitInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedCommitRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedDeploymentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedDeploymentSortInput>;
};

export type GraphStoreVersionAssociatedDeploymentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedDeploymentSortInput>;
};

export type GraphStoreVersionAssociatedDeploymentInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedDeploymentRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedDesignArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreVersionAssociatedDesignFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedDesignSortInput>;
};

export type GraphStoreVersionAssociatedDesignInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    filter?: InputMaybe<GraphStoreVersionAssociatedDesignFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedDesignSortInput>;
};

export type GraphStoreVersionAssociatedDesignInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreVersionAssociatedDesignFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedDesignSortInput>;
};

export type GraphStoreVersionAssociatedDesignRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreVersionAssociatedDesignFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedDesignSortInput>;
};

export type GraphStoreVersionAssociatedFeatureFlagArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedFeatureFlagSortInput>;
};

export type GraphStoreVersionAssociatedFeatureFlagInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedFeatureFlagSortInput>;
};

export type GraphStoreVersionAssociatedFeatureFlagInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedFeatureFlagRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedIssueSortInput>;
};

export type GraphStoreVersionAssociatedIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedIssueSortInput>;
};

export type GraphStoreVersionAssociatedIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedPullRequestArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedPullRequestSortInput>;
};

export type GraphStoreVersionAssociatedPullRequestInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedPullRequestSortInput>;
};

export type GraphStoreVersionAssociatedPullRequestInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedPullRequestRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedRemoteLinkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedRemoteLinkSortInput>;
};

export type GraphStoreVersionAssociatedRemoteLinkInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionAssociatedRemoteLinkSortInput>;
};

export type GraphStoreVersionAssociatedRemoteLinkInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionAssociatedRemoteLinkRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVersionUserAssociatedFeatureFlagArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionUserAssociatedFeatureFlagSortInput>;
};

export type GraphStoreVersionUserAssociatedFeatureFlagInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVersionUserAssociatedFeatureFlagSortInput>;
};

export type GraphStoreVersionUserAssociatedFeatureFlagInverseRelationshipArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        id: Scalars["ID"]["input"];
    };

export type GraphStoreVersionUserAssociatedFeatureFlagRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVideoHasCommentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVideoHasCommentSortInput>;
};

export type GraphStoreVideoHasCommentInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVideoHasCommentSortInput>;
};

export type GraphStoreVulnerabilityAssociatedIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVulnerabilityAssociatedIssueSortInput>;
};

export type GraphStoreVulnerabilityAssociatedIssueInverseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    consistentRead?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<GraphStoreVulnerabilityAssociatedIssueSortInput>;
};

export type GraphStoreVulnerabilityAssociatedIssueInverseRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreVulnerabilityAssociatedIssueRelationshipArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type GraphStoreAllRelationshipsConnection = {
    __typename?: "GraphStoreAllRelationshipsConnection";
    edges: Array<GraphStoreAllRelationshipsEdge>;
    pageInfo: PageInfo;
};

export type GraphStoreAllRelationshipsEdge = {
    __typename?: "GraphStoreAllRelationshipsEdge";
    from: GraphStoreAllRelationshipsNode;
    lastUpdated: Scalars["DateTime"]["output"];
    to: GraphStoreAllRelationshipsNode;
    type: Scalars["String"]["output"];
};

export type GraphStoreAllRelationshipsNode = {
    __typename?: "GraphStoreAllRelationshipsNode";
    /**
     * Fetch all ARIs associated to the parent ARI via any relationship.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreFetchAllRelationships")' query directive to the 'fetchAllRelationships' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    fetchAllRelationships: GraphStoreAllRelationshipsConnection;
    id: Scalars["ID"]["output"];
};

export type GraphStoreAllRelationshipsNodeFetchAllRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ignoredRelationshipTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphStoreAriFilterInput = {
    is?: InputMaybe<Array<Scalars["String"]["input"]>>;
    isNot?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphStoreAtiFilterInput = {
    is?: InputMaybe<Array<Scalars["String"]["input"]>>;
    isNot?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type GraphStoreAtlasGoalHasContributorSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasGoalHasFollowerSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasGoalHasGoalUpdateSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasGoalHasOwnerSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasGoalHasSubAtlasGoalSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasGoalHasUpdateConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_createdBy?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creationDate?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_lastEditedBy?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_lastUpdated?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_newConfidence?: InputMaybe<GraphStoreAtlasGoalHasUpdateNewConfidenceFilterInput>;
    relationship_newScore?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_newStatus?: InputMaybe<GraphStoreAtlasGoalHasUpdateNewStatusFilterInput>;
    relationship_newTargetDate?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_oldConfidence?: InputMaybe<GraphStoreAtlasGoalHasUpdateOldConfidenceFilterInput>;
    relationship_oldScore?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_oldStatus?: InputMaybe<GraphStoreAtlasGoalHasUpdateOldStatusFilterInput>;
    relationship_oldTargetDate?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_updateType?: InputMaybe<GraphStoreAtlasGoalHasUpdateUpdateTypeFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
};

/** Conditional selection for filter field of atlas-goal-has-update relationship queries */
export type GraphStoreAtlasGoalHasUpdateFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreAtlasGoalHasUpdateConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreAtlasGoalHasUpdateConditionalFilterInput>>
    >;
};

export enum GraphStoreAtlasGoalHasUpdateNewConfidence {
    Day = "DAY",
    Month = "MONTH",
    NotSet = "NOT_SET",
    Quarter = "QUARTER"
}

export type GraphStoreAtlasGoalHasUpdateNewConfidenceFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateNewConfidence>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateNewConfidence>>;
};

export enum GraphStoreAtlasGoalHasUpdateNewStatus {
    AtRisk = "AT_RISK",
    Cancelled = "CANCELLED",
    Done = "DONE",
    NotSet = "NOT_SET",
    OffTrack = "OFF_TRACK",
    OnTrack = "ON_TRACK",
    Paused = "PAUSED",
    Pending = "PENDING"
}

export type GraphStoreAtlasGoalHasUpdateNewStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateNewStatus>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateNewStatus>>;
};

export enum GraphStoreAtlasGoalHasUpdateOldConfidence {
    Day = "DAY",
    Month = "MONTH",
    NotSet = "NOT_SET",
    Null = "NULL",
    Quarter = "QUARTER"
}

export type GraphStoreAtlasGoalHasUpdateOldConfidenceFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateOldConfidence>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateOldConfidence>>;
};

export enum GraphStoreAtlasGoalHasUpdateOldStatus {
    AtRisk = "AT_RISK",
    Cancelled = "CANCELLED",
    Done = "DONE",
    NotSet = "NOT_SET",
    Null = "NULL",
    OffTrack = "OFF_TRACK",
    OnTrack = "ON_TRACK",
    Paused = "PAUSED",
    Pending = "PENDING"
}

export type GraphStoreAtlasGoalHasUpdateOldStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateOldStatus>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateOldStatus>>;
};

export type GraphStoreAtlasGoalHasUpdateSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_createdBy?: InputMaybe<GraphStoreSortInput>;
    relationship_creationDate?: InputMaybe<GraphStoreSortInput>;
    relationship_lastEditedBy?: InputMaybe<GraphStoreSortInput>;
    relationship_lastUpdated?: InputMaybe<GraphStoreSortInput>;
    relationship_newConfidence?: InputMaybe<GraphStoreSortInput>;
    relationship_newScore?: InputMaybe<GraphStoreSortInput>;
    relationship_newStatus?: InputMaybe<GraphStoreSortInput>;
    relationship_newTargetDate?: InputMaybe<GraphStoreSortInput>;
    relationship_oldConfidence?: InputMaybe<GraphStoreSortInput>;
    relationship_oldScore?: InputMaybe<GraphStoreSortInput>;
    relationship_oldStatus?: InputMaybe<GraphStoreSortInput>;
    relationship_oldTargetDate?: InputMaybe<GraphStoreSortInput>;
    relationship_updateType?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreAtlasGoalHasUpdateUpdateType {
    NotSet = "NOT_SET",
    System = "SYSTEM",
    User = "USER"
}

export type GraphStoreAtlasGoalHasUpdateUpdateTypeFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateUpdateType>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasGoalHasUpdateUpdateType>>;
};

/** A union of the possible hydration types for altasHomeFeedQuery: [TeamV2, JiraIssue, TownsquareGoal, TownsquareProject, ConfluencePage] */
export type GraphStoreAtlasHomeFeedQueryToMetadataNodeUnion =
    | ConfluencePage
    | JiraIssue
    | TeamV2
    | TownsquareGoal
    | TownsquareProject;

/** A union of the possible hydration types for altasHomeFeedQuery: [TeamV2, JiraIssue, TownsquareGoal, TownsquareProject, ConfluencePage] */
export type GraphStoreAtlasHomeFeedQueryToNodeUnion =
    | ConfluencePage
    | JiraIssue
    | TeamV2
    | TownsquareGoal
    | TownsquareProject;

export type GraphStoreAtlasHomeQueryConnection = {
    __typename?: "GraphStoreAtlasHomeQueryConnection";
    nodes: Array<GraphStoreAtlasHomeQueryNode>;
    pageInfo: PageInfo;
};

export type GraphStoreAtlasHomeQueryItem = {
    __typename?: "GraphStoreAtlasHomeQueryItem";
    /** The data for the node, can be hydrated */
    data?: Maybe<GraphStoreAtlasHomeFeedQueryToNodeUnion>;
    /** ARI of the node */
    id: Scalars["ID"]["output"];
};

export type GraphStoreAtlasHomeQueryMetadata = {
    __typename?: "GraphStoreAtlasHomeQueryMetadata";
    /** The data for the metadata node, can be hydrated */
    data?: Maybe<GraphStoreAtlasHomeFeedQueryToMetadataNodeUnion>;
    /** ARI of the metadata node */
    id: Scalars["ID"]["output"];
};

export type GraphStoreAtlasHomeQueryNode = {
    __typename?: "GraphStoreAtlasHomeQueryNode";
    /** the feed item */
    item?: Maybe<GraphStoreAtlasHomeQueryItem>;
    /** metadata for the item returned by the query */
    metadata?: Maybe<GraphStoreAtlasHomeQueryMetadata>;
    /** the query that resulted in this item */
    source: Scalars["String"]["output"];
};

export type GraphStoreAtlasHomeRankingCriteria = {
    /** An enum representing the ranking criteria used to pick `limit` feed items among all the sources */
    criteria: GraphStoreAtlasHomeRankingCriteriaEnum;
    /** The maximum number of feed items to return after ranking; defaults to 5 */
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum GraphStoreAtlasHomeRankingCriteriaEnum {
    /** From the prioritized list of sources pick one item (at random from each source) at a time until we reach the target / limit */
    RoundRobinRandom = "ROUND_ROBIN_RANDOM"
}

export type GraphStoreAtlasProjectContributesToAtlasGoalSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectDependsOnAtlasProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectHasContributorSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectHasFollowerSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectHasOwnerSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectHasProjectUpdateSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectHasUpdateConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_createdBy?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creationDate?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_lastEditedBy?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_lastUpdated?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_newConfidence?: InputMaybe<GraphStoreAtlasProjectHasUpdateNewConfidenceFilterInput>;
    relationship_newStatus?: InputMaybe<GraphStoreAtlasProjectHasUpdateNewStatusFilterInput>;
    relationship_newTargetDate?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_oldConfidence?: InputMaybe<GraphStoreAtlasProjectHasUpdateOldConfidenceFilterInput>;
    relationship_oldStatus?: InputMaybe<GraphStoreAtlasProjectHasUpdateOldStatusFilterInput>;
    relationship_oldTargetDate?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_updateType?: InputMaybe<GraphStoreAtlasProjectHasUpdateUpdateTypeFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
};

/** Conditional selection for filter field of atlas-project-has-update relationship queries */
export type GraphStoreAtlasProjectHasUpdateFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreAtlasProjectHasUpdateConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreAtlasProjectHasUpdateConditionalFilterInput>>
    >;
};

export enum GraphStoreAtlasProjectHasUpdateNewConfidence {
    Day = "DAY",
    Month = "MONTH",
    NotSet = "NOT_SET",
    Quarter = "QUARTER"
}

export type GraphStoreAtlasProjectHasUpdateNewConfidenceFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateNewConfidence>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateNewConfidence>>;
};

export enum GraphStoreAtlasProjectHasUpdateNewStatus {
    AtRisk = "AT_RISK",
    Cancelled = "CANCELLED",
    Done = "DONE",
    NotSet = "NOT_SET",
    OffTrack = "OFF_TRACK",
    OnTrack = "ON_TRACK",
    Paused = "PAUSED",
    Pending = "PENDING"
}

export type GraphStoreAtlasProjectHasUpdateNewStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateNewStatus>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateNewStatus>>;
};

export enum GraphStoreAtlasProjectHasUpdateOldConfidence {
    Day = "DAY",
    Month = "MONTH",
    NotSet = "NOT_SET",
    Null = "NULL",
    Quarter = "QUARTER"
}

export type GraphStoreAtlasProjectHasUpdateOldConfidenceFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateOldConfidence>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateOldConfidence>>;
};

export enum GraphStoreAtlasProjectHasUpdateOldStatus {
    AtRisk = "AT_RISK",
    Cancelled = "CANCELLED",
    Done = "DONE",
    NotSet = "NOT_SET",
    Null = "NULL",
    OffTrack = "OFF_TRACK",
    OnTrack = "ON_TRACK",
    Paused = "PAUSED",
    Pending = "PENDING"
}

export type GraphStoreAtlasProjectHasUpdateOldStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateOldStatus>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateOldStatus>>;
};

export type GraphStoreAtlasProjectHasUpdateSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_createdBy?: InputMaybe<GraphStoreSortInput>;
    relationship_creationDate?: InputMaybe<GraphStoreSortInput>;
    relationship_lastEditedBy?: InputMaybe<GraphStoreSortInput>;
    relationship_lastUpdated?: InputMaybe<GraphStoreSortInput>;
    relationship_newConfidence?: InputMaybe<GraphStoreSortInput>;
    relationship_newStatus?: InputMaybe<GraphStoreSortInput>;
    relationship_newTargetDate?: InputMaybe<GraphStoreSortInput>;
    relationship_oldConfidence?: InputMaybe<GraphStoreSortInput>;
    relationship_oldStatus?: InputMaybe<GraphStoreSortInput>;
    relationship_oldTargetDate?: InputMaybe<GraphStoreSortInput>;
    relationship_updateType?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreAtlasProjectHasUpdateUpdateType {
    NotSet = "NOT_SET",
    System = "SYSTEM",
    User = "USER"
}

export type GraphStoreAtlasProjectHasUpdateUpdateTypeFilterInput = {
    is?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateUpdateType>>;
    isNot?: InputMaybe<Array<GraphStoreAtlasProjectHasUpdateUpdateType>>;
};

export type GraphStoreAtlasProjectIsRelatedToAtlasProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreAtlasProjectIsTrackedOnJiraEpicSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreBatchContentReferencedEntityConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchContentReferencedEntityConnection";
    edges: Array<Maybe<GraphStoreBatchContentReferencedEntityEdge>>;
    nodes: Array<Maybe<GraphStoreBatchContentReferencedEntityNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type content-referenced-entity */
export type GraphStoreBatchContentReferencedEntityEdge = {
    __typename?: "GraphStoreBatchContentReferencedEntityEdge";
    node: GraphStoreBatchContentReferencedEntityInnerConnection;
};

export type GraphStoreBatchContentReferencedEntityEndNode = {
    __typename?: "GraphStoreBatchContentReferencedEntityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchContentReferencedEntityEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, ConfluenceBlogPost, CompassComponent] */
export type GraphStoreBatchContentReferencedEntityEndUnion =
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

export type GraphStoreBatchContentReferencedEntityInnerConnection = {
    __typename?: "GraphStoreBatchContentReferencedEntityInnerConnection";
    edges: Array<Maybe<GraphStoreBatchContentReferencedEntityInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchContentReferencedEntityNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type content-referenced-entity */
export type GraphStoreBatchContentReferencedEntityInnerEdge = {
    __typename?: "GraphStoreBatchContentReferencedEntityInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchContentReferencedEntityNode;
};

/** A node representing a content-referenced-entity relationship, with all metadata (if available) */
export type GraphStoreBatchContentReferencedEntityNode = Node & {
    __typename?: "GraphStoreBatchContentReferencedEntityNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchContentReferencedEntityStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchContentReferencedEntityEndNode;
};

export type GraphStoreBatchContentReferencedEntityStartNode = {
    __typename?: "GraphStoreBatchContentReferencedEntityStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchContentReferencedEntityStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, ConfluenceBlogPost] */
export type GraphStoreBatchContentReferencedEntityStartUnion =
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

export type GraphStoreBatchFocusAreaAssociatedToProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectConnection";
        edges: Array<Maybe<GraphStoreBatchFocusAreaAssociatedToProjectEdge>>;
        nodes: Array<Maybe<GraphStoreBatchFocusAreaAssociatedToProjectNode>>;
        pageInfo: PageInfo;
    };

/** A relationship edge for the relationship type focus-area-associated-to-project */
export type GraphStoreBatchFocusAreaAssociatedToProjectEdge = {
    __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectEdge";
    node: GraphStoreBatchFocusAreaAssociatedToProjectInnerConnection;
};

export type GraphStoreBatchFocusAreaAssociatedToProjectEndNode = {
    __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaAssociatedToProjectEndUnion>;
    /** An ARI of type(s) [ati:cloud:graph:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */
export type GraphStoreBatchFocusAreaAssociatedToProjectEndUnion =
    DevOpsProjectDetails;

export type GraphStoreBatchFocusAreaAssociatedToProjectInnerConnection = {
    __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectInnerConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaAssociatedToProjectInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaAssociatedToProjectNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type focus-area-associated-to-project */
export type GraphStoreBatchFocusAreaAssociatedToProjectInnerEdge = {
    __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchFocusAreaAssociatedToProjectNode;
};

/** A node representing a focus-area-associated-to-project relationship, with all metadata (if available) */
export type GraphStoreBatchFocusAreaAssociatedToProjectNode = Node & {
    __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchFocusAreaAssociatedToProjectStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchFocusAreaAssociatedToProjectEndNode;
};

export type GraphStoreBatchFocusAreaAssociatedToProjectStartNode = {
    __typename?: "GraphStoreBatchFocusAreaAssociatedToProjectStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaAssociatedToProjectStartUnion>;
    /** An ARI of type(s) [ati:cloud:mercury:focus-area] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */
export type GraphStoreBatchFocusAreaAssociatedToProjectStartUnion =
    MercuryFocusArea;

export type GraphStoreBatchFocusAreaHasAtlasGoalConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaHasAtlasGoalEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaHasAtlasGoalNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type focus-area-has-atlas-goal */
export type GraphStoreBatchFocusAreaHasAtlasGoalEdge = {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalEdge";
    node: GraphStoreBatchFocusAreaHasAtlasGoalInnerConnection;
};

export type GraphStoreBatchFocusAreaHasAtlasGoalEndNode = {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaHasAtlasGoalEndUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:goal] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */
export type GraphStoreBatchFocusAreaHasAtlasGoalEndUnion = TownsquareGoal;

export type GraphStoreBatchFocusAreaHasAtlasGoalInnerConnection = {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalInnerConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaHasAtlasGoalInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaHasAtlasGoalNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type focus-area-has-atlas-goal */
export type GraphStoreBatchFocusAreaHasAtlasGoalInnerEdge = {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchFocusAreaHasAtlasGoalNode;
};

/** A node representing a focus-area-has-atlas-goal relationship, with all metadata (if available) */
export type GraphStoreBatchFocusAreaHasAtlasGoalNode = Node & {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchFocusAreaHasAtlasGoalStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchFocusAreaHasAtlasGoalEndNode;
};

export type GraphStoreBatchFocusAreaHasAtlasGoalStartNode = {
    __typename?: "GraphStoreBatchFocusAreaHasAtlasGoalStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaHasAtlasGoalStartUnion>;
    /** An ARI of type(s) [ati:cloud:mercury:focus-area] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */
export type GraphStoreBatchFocusAreaHasAtlasGoalStartUnion = MercuryFocusArea;

export type GraphStoreBatchFocusAreaHasFocusAreaConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaHasFocusAreaEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaHasFocusAreaNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type focus-area-has-focus-area */
export type GraphStoreBatchFocusAreaHasFocusAreaEdge = {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaEdge";
    node: GraphStoreBatchFocusAreaHasFocusAreaInnerConnection;
};

export type GraphStoreBatchFocusAreaHasFocusAreaEndNode = {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaHasFocusAreaEndUnion>;
    /** An ARI of type(s) [ati:cloud:mercury:focus-area] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */
export type GraphStoreBatchFocusAreaHasFocusAreaEndUnion = MercuryFocusArea;

export type GraphStoreBatchFocusAreaHasFocusAreaInnerConnection = {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaInnerConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaHasFocusAreaInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaHasFocusAreaNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type focus-area-has-focus-area */
export type GraphStoreBatchFocusAreaHasFocusAreaInnerEdge = {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchFocusAreaHasFocusAreaNode;
};

/** A node representing a focus-area-has-focus-area relationship, with all metadata (if available) */
export type GraphStoreBatchFocusAreaHasFocusAreaNode = Node & {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchFocusAreaHasFocusAreaStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchFocusAreaHasFocusAreaEndNode;
};

export type GraphStoreBatchFocusAreaHasFocusAreaStartNode = {
    __typename?: "GraphStoreBatchFocusAreaHasFocusAreaStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaHasFocusAreaStartUnion>;
    /** An ARI of type(s) [ati:cloud:mercury:focus-area] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */
export type GraphStoreBatchFocusAreaHasFocusAreaStartUnion = MercuryFocusArea;

export type GraphStoreBatchFocusAreaHasProjectConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchFocusAreaHasProjectConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaHasProjectEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaHasProjectNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type focus-area-has-project */
export type GraphStoreBatchFocusAreaHasProjectEdge = {
    __typename?: "GraphStoreBatchFocusAreaHasProjectEdge";
    node: GraphStoreBatchFocusAreaHasProjectInnerConnection;
};

export type GraphStoreBatchFocusAreaHasProjectEndNode = {
    __typename?: "GraphStoreBatchFocusAreaHasProjectEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaHasProjectEndUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:project, ati:cloud:jira:issue, ati:cloud:jira-align:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue, JiraAlignAggProject] */
export type GraphStoreBatchFocusAreaHasProjectEndUnion =
    | JiraAlignAggProject
    | JiraIssue
    | TownsquareProject;

export type GraphStoreBatchFocusAreaHasProjectInnerConnection = {
    __typename?: "GraphStoreBatchFocusAreaHasProjectInnerConnection";
    edges: Array<Maybe<GraphStoreBatchFocusAreaHasProjectInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchFocusAreaHasProjectNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type focus-area-has-project */
export type GraphStoreBatchFocusAreaHasProjectInnerEdge = {
    __typename?: "GraphStoreBatchFocusAreaHasProjectInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchFocusAreaHasProjectNode;
};

/** A node representing a focus-area-has-project relationship, with all metadata (if available) */
export type GraphStoreBatchFocusAreaHasProjectNode = Node & {
    __typename?: "GraphStoreBatchFocusAreaHasProjectNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchFocusAreaHasProjectStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchFocusAreaHasProjectEndNode;
};

export type GraphStoreBatchFocusAreaHasProjectStartNode = {
    __typename?: "GraphStoreBatchFocusAreaHasProjectStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchFocusAreaHasProjectStartUnion>;
    /** An ARI of type(s) [ati:cloud:mercury:focus-area] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */
export type GraphStoreBatchFocusAreaHasProjectStartUnion = MercuryFocusArea;

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewConnection =
    HasPageInfo & {
        __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewConnection";
        edges: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewNode>
        >;
        pageInfo: PageInfo;
    };

/** A relationship edge for the relationship type incident-associated-post-incident-review */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewEdge = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewEdge";
    node: GraphStoreBatchIncidentAssociatedPostIncidentReviewInnerConnection;
};

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewEndNode = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewEndUnion =
    JiraIssue;

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewInnerConnection =
    {
        __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewInnerConnection";
        edges: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewInnerEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewNode>
        >;
        requestedId: Scalars["ID"]["output"];
    };

/** A relationship inner edge for the relationship type incident-associated-post-incident-review */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewInnerEdge = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIncidentAssociatedPostIncidentReviewNode;
};

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkConnection";
        edges: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkNode>
        >;
        pageInfo: PageInfo;
    };

/** A relationship edge for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEdge = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEdge";
    node: GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkInnerConnection;
};

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEndNode = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEndUnion =
    | DevOpsOperationsPostIncidentReviewDetails
    | JiraIssue
    | JiraPostIncidentReviewLink;

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkInnerConnection =
    {
        __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkInnerConnection";
        edges: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkInnerEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkNode>
        >;
        requestedId: Scalars["ID"]["output"];
    };

/** A relationship inner edge for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkInnerEdge = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkNode;
};

/** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkNode =
    Node & {
        __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkNode";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the from node */
        from: GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkStartNode;
        /** The id of the relationship */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the to node */
        to: GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkEndNode;
    };

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkStartNode = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewLinkStartUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewNode = Node & {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchIncidentAssociatedPostIncidentReviewStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchIncidentAssociatedPostIncidentReviewEndNode;
};

export type GraphStoreBatchIncidentAssociatedPostIncidentReviewStartNode = {
    __typename?: "GraphStoreBatchIncidentAssociatedPostIncidentReviewStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentAssociatedPostIncidentReviewStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */
export type GraphStoreBatchIncidentAssociatedPostIncidentReviewStartUnion =
    JiraIssue;

export type GraphStoreBatchIncidentHasActionItemConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchIncidentHasActionItemConnection";
    edges: Array<Maybe<GraphStoreBatchIncidentHasActionItemEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIncidentHasActionItemNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type incident-has-action-item */
export type GraphStoreBatchIncidentHasActionItemEdge = {
    __typename?: "GraphStoreBatchIncidentHasActionItemEdge";
    node: GraphStoreBatchIncidentHasActionItemInnerConnection;
};

export type GraphStoreBatchIncidentHasActionItemEndNode = {
    __typename?: "GraphStoreBatchIncidentHasActionItemEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentHasActionItemEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */
export type GraphStoreBatchIncidentHasActionItemEndUnion = JiraIssue;

export type GraphStoreBatchIncidentHasActionItemInnerConnection = {
    __typename?: "GraphStoreBatchIncidentHasActionItemInnerConnection";
    edges: Array<Maybe<GraphStoreBatchIncidentHasActionItemInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIncidentHasActionItemNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type incident-has-action-item */
export type GraphStoreBatchIncidentHasActionItemInnerEdge = {
    __typename?: "GraphStoreBatchIncidentHasActionItemInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIncidentHasActionItemNode;
};

/** A node representing a incident-has-action-item relationship, with all metadata (if available) */
export type GraphStoreBatchIncidentHasActionItemNode = Node & {
    __typename?: "GraphStoreBatchIncidentHasActionItemNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchIncidentHasActionItemStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchIncidentHasActionItemEndNode;
};

export type GraphStoreBatchIncidentHasActionItemStartNode = {
    __typename?: "GraphStoreBatchIncidentHasActionItemStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentHasActionItemStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreBatchIncidentHasActionItemStartUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

export type GraphStoreBatchIncidentLinkedJswIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueConnection";
    edges: Array<Maybe<GraphStoreBatchIncidentLinkedJswIssueEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIncidentLinkedJswIssueNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type incident-linked-jsw-issue */
export type GraphStoreBatchIncidentLinkedJswIssueEdge = {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueEdge";
    node: GraphStoreBatchIncidentLinkedJswIssueInnerConnection;
};

export type GraphStoreBatchIncidentLinkedJswIssueEndNode = {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentLinkedJswIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */
export type GraphStoreBatchIncidentLinkedJswIssueEndUnion = JiraIssue;

export type GraphStoreBatchIncidentLinkedJswIssueInnerConnection = {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueInnerConnection";
    edges: Array<Maybe<GraphStoreBatchIncidentLinkedJswIssueInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIncidentLinkedJswIssueNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type incident-linked-jsw-issue */
export type GraphStoreBatchIncidentLinkedJswIssueInnerEdge = {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIncidentLinkedJswIssueNode;
};

/** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */
export type GraphStoreBatchIncidentLinkedJswIssueNode = Node & {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchIncidentLinkedJswIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchIncidentLinkedJswIssueEndNode;
};

export type GraphStoreBatchIncidentLinkedJswIssueStartNode = {
    __typename?: "GraphStoreBatchIncidentLinkedJswIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIncidentLinkedJswIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreBatchIncidentLinkedJswIssueStartUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

export type GraphStoreBatchIssueAssociatedBuildConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchIssueAssociatedBuildConnection";
    edges: Array<Maybe<GraphStoreBatchIssueAssociatedBuildEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIssueAssociatedBuildNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type issue-associated-build */
export type GraphStoreBatchIssueAssociatedBuildEdge = {
    __typename?: "GraphStoreBatchIssueAssociatedBuildEdge";
    node: GraphStoreBatchIssueAssociatedBuildInnerConnection;
};

export type GraphStoreBatchIssueAssociatedBuildEndNode = {
    __typename?: "GraphStoreBatchIssueAssociatedBuildEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIssueAssociatedBuildEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:build, ati:cloud:graph:build] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-build: [ExternalBuildInfo] */
export type GraphStoreBatchIssueAssociatedBuildEndUnion = ExternalBuildInfo;

export type GraphStoreBatchIssueAssociatedBuildInnerConnection = {
    __typename?: "GraphStoreBatchIssueAssociatedBuildInnerConnection";
    edges: Array<Maybe<GraphStoreBatchIssueAssociatedBuildInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIssueAssociatedBuildNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type issue-associated-build */
export type GraphStoreBatchIssueAssociatedBuildInnerEdge = {
    __typename?: "GraphStoreBatchIssueAssociatedBuildInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIssueAssociatedBuildNode;
};

/** A node representing a issue-associated-build relationship, with all metadata (if available) */
export type GraphStoreBatchIssueAssociatedBuildNode = Node & {
    __typename?: "GraphStoreBatchIssueAssociatedBuildNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchIssueAssociatedBuildStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchIssueAssociatedBuildEndNode;
};

export type GraphStoreBatchIssueAssociatedBuildStartNode = {
    __typename?: "GraphStoreBatchIssueAssociatedBuildStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIssueAssociatedBuildStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-build: [JiraIssue] */
export type GraphStoreBatchIssueAssociatedBuildStartUnion = JiraIssue;

export type GraphStoreBatchIssueAssociatedDeploymentConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentConnection";
    edges: Array<Maybe<GraphStoreBatchIssueAssociatedDeploymentEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIssueAssociatedDeploymentNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type issue-associated-deployment */
export type GraphStoreBatchIssueAssociatedDeploymentEdge = {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentEdge";
    node: GraphStoreBatchIssueAssociatedDeploymentInnerConnection;
};

export type GraphStoreBatchIssueAssociatedDeploymentEndNode = {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIssueAssociatedDeploymentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreBatchIssueAssociatedDeploymentEndUnion =
    | DeploymentSummary
    | ExternalDeployment;

export type GraphStoreBatchIssueAssociatedDeploymentInnerConnection = {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentInnerConnection";
    edges: Array<Maybe<GraphStoreBatchIssueAssociatedDeploymentInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIssueAssociatedDeploymentNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type issue-associated-deployment */
export type GraphStoreBatchIssueAssociatedDeploymentInnerEdge = {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIssueAssociatedDeploymentNode;
};

/** A node representing a issue-associated-deployment relationship, with all metadata (if available) */
export type GraphStoreBatchIssueAssociatedDeploymentNode = Node & {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchIssueAssociatedDeploymentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchIssueAssociatedDeploymentEndNode;
};

export type GraphStoreBatchIssueAssociatedDeploymentStartNode = {
    __typename?: "GraphStoreBatchIssueAssociatedDeploymentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIssueAssociatedDeploymentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */
export type GraphStoreBatchIssueAssociatedDeploymentStartUnion = JiraIssue;

export type GraphStoreBatchIssueAssociatedIssueRemoteLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkConnection";
        edges: Array<Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkEdge>>;
        nodes: Array<Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkNode>>;
        pageInfo: PageInfo;
    };

/** A relationship edge for the relationship type issue-associated-issue-remote-link */
export type GraphStoreBatchIssueAssociatedIssueRemoteLinkEdge = {
    __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkEdge";
    node: GraphStoreBatchIssueAssociatedIssueRemoteLinkInnerConnection;
};

export type GraphStoreBatchIssueAssociatedIssueRemoteLinkEndNode = {
    __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue-remote-link] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */
export type GraphStoreBatchIssueAssociatedIssueRemoteLinkEndUnion =
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssueRemoteIssueLink
    | JiraWebRemoteIssueLink;

export type GraphStoreBatchIssueAssociatedIssueRemoteLinkInnerConnection = {
    __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkInnerConnection";
    edges: Array<Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type issue-associated-issue-remote-link */
export type GraphStoreBatchIssueAssociatedIssueRemoteLinkInnerEdge = {
    __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchIssueAssociatedIssueRemoteLinkNode;
};

/** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */
export type GraphStoreBatchIssueAssociatedIssueRemoteLinkNode = Node & {
    __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchIssueAssociatedIssueRemoteLinkStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchIssueAssociatedIssueRemoteLinkEndNode;
};

export type GraphStoreBatchIssueAssociatedIssueRemoteLinkStartNode = {
    __typename?: "GraphStoreBatchIssueAssociatedIssueRemoteLinkStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchIssueAssociatedIssueRemoteLinkStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */
export type GraphStoreBatchIssueAssociatedIssueRemoteLinkStartUnion = JiraIssue;

export type GraphStoreBatchJsmProjectAssociatedServiceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreBatchJsmProjectAssociatedServiceConnection";
        edges: Array<Maybe<GraphStoreBatchJsmProjectAssociatedServiceEdge>>;
        nodes: Array<Maybe<GraphStoreBatchJsmProjectAssociatedServiceNode>>;
        pageInfo: PageInfo;
    };

/** A relationship edge for the relationship type jsm-project-associated-service */
export type GraphStoreBatchJsmProjectAssociatedServiceEdge = {
    __typename?: "GraphStoreBatchJsmProjectAssociatedServiceEdge";
    node: GraphStoreBatchJsmProjectAssociatedServiceInnerConnection;
};

export type GraphStoreBatchJsmProjectAssociatedServiceEndNode = {
    __typename?: "GraphStoreBatchJsmProjectAssociatedServiceEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchJsmProjectAssociatedServiceEndUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */
export type GraphStoreBatchJsmProjectAssociatedServiceEndUnion = DevOpsService;

export type GraphStoreBatchJsmProjectAssociatedServiceInnerConnection = {
    __typename?: "GraphStoreBatchJsmProjectAssociatedServiceInnerConnection";
    edges: Array<Maybe<GraphStoreBatchJsmProjectAssociatedServiceInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchJsmProjectAssociatedServiceNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type jsm-project-associated-service */
export type GraphStoreBatchJsmProjectAssociatedServiceInnerEdge = {
    __typename?: "GraphStoreBatchJsmProjectAssociatedServiceInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchJsmProjectAssociatedServiceNode;
};

/** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */
export type GraphStoreBatchJsmProjectAssociatedServiceNode = Node & {
    __typename?: "GraphStoreBatchJsmProjectAssociatedServiceNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchJsmProjectAssociatedServiceStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchJsmProjectAssociatedServiceEndNode;
};

export type GraphStoreBatchJsmProjectAssociatedServiceStartNode = {
    __typename?: "GraphStoreBatchJsmProjectAssociatedServiceStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchJsmProjectAssociatedServiceStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */
export type GraphStoreBatchJsmProjectAssociatedServiceStartUnion = JiraProject;

export type GraphStoreBatchMediaAttachedToContentConnection = HasPageInfo & {
    __typename?: "GraphStoreBatchMediaAttachedToContentConnection";
    edges: Array<Maybe<GraphStoreBatchMediaAttachedToContentEdge>>;
    nodes: Array<Maybe<GraphStoreBatchMediaAttachedToContentNode>>;
    pageInfo: PageInfo;
};

/** A relationship edge for the relationship type media-attached-to-content */
export type GraphStoreBatchMediaAttachedToContentEdge = {
    __typename?: "GraphStoreBatchMediaAttachedToContentEdge";
    node: GraphStoreBatchMediaAttachedToContentInnerConnection;
};

export type GraphStoreBatchMediaAttachedToContentEndNode = {
    __typename?: "GraphStoreBatchMediaAttachedToContentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchMediaAttachedToContentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage, ConfluenceBlogPost] */
export type GraphStoreBatchMediaAttachedToContentEndUnion =
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

export type GraphStoreBatchMediaAttachedToContentInnerConnection = {
    __typename?: "GraphStoreBatchMediaAttachedToContentInnerConnection";
    edges: Array<Maybe<GraphStoreBatchMediaAttachedToContentInnerEdge>>;
    nodes: Array<Maybe<GraphStoreBatchMediaAttachedToContentNode>>;
    requestedId: Scalars["ID"]["output"];
};

/** A relationship inner edge for the relationship type media-attached-to-content */
export type GraphStoreBatchMediaAttachedToContentInnerEdge = {
    __typename?: "GraphStoreBatchMediaAttachedToContentInnerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreBatchMediaAttachedToContentNode;
};

/** A node representing a media-attached-to-content relationship, with all metadata (if available) */
export type GraphStoreBatchMediaAttachedToContentNode = Node & {
    __typename?: "GraphStoreBatchMediaAttachedToContentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreBatchMediaAttachedToContentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreBatchMediaAttachedToContentEndNode;
};

export type GraphStoreBatchMediaAttachedToContentStartNode = {
    __typename?: "GraphStoreBatchMediaAttachedToContentStartNode";
    /** An ARI of type(s) [ati:cloud:media:file] */
    id: Scalars["ID"]["output"];
};

export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityConnection =
    HasPageInfo & {
        __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityConnection";
        edges: Array<
            Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityNode>
        >;
        pageInfo: PageInfo;
    };

/** A relationship edge for the relationship type security-container-associated-to-vulnerability */
export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEdge = {
    __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEdge";
    node: GraphStoreBatchSecurityContainerAssociatedToVulnerabilityInnerConnection;
};

export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEndNode = {
    __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEndUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityInnerConnection =
    {
        __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityInnerConnection";
        edges: Array<
            Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityInnerEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreBatchSecurityContainerAssociatedToVulnerabilityNode>
        >;
        requestedId: Scalars["ID"]["output"];
    };

/** A relationship inner edge for the relationship type security-container-associated-to-vulnerability */
export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityInnerEdge =
    {
        __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityInnerEdge";
        /** Cursor object not currently implemented per edge. */
        cursor?: Maybe<Scalars["String"]["output"]>;
        node: GraphStoreBatchSecurityContainerAssociatedToVulnerabilityNode;
    };

/** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */
export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityNode =
    Node & {
        __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityNode";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the from node */
        from: GraphStoreBatchSecurityContainerAssociatedToVulnerabilityStartNode;
        /** The id of the relationship */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the to node */
        to: GraphStoreBatchSecurityContainerAssociatedToVulnerabilityEndNode;
    };

export type GraphStoreBatchSecurityContainerAssociatedToVulnerabilityStartNode =
    {
        __typename?: "GraphStoreBatchSecurityContainerAssociatedToVulnerabilityStartNode";
        /** An ARI of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container] */
        id: Scalars["ID"]["output"];
    };

export type GraphStoreBoardBelongsToProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreBooleanFilterInput = {
    is?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreCalendarHasLinkedDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreComponentImpactedByIncidentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreComponentLinkIsJiraProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreComponentLinkedJswIssueSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluenceBlogpostHasCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluenceBlogpostSharedWithUserSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluencePageHasCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluencePageHasConfluenceCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluencePageHasConfluenceDatabaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluencePageHasParentPageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluencePageSharedWithGroupSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluencePageSharedWithUserSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceDatabaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceFolderSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConfluenceSpaceHasConfluenceWhiteboardSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreContentReferencedEntitySortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreConversationHasMessageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreCreateComponentImpactedByIncidentInput = {
    /** The list of relationships of type component-impacted-by-incident to persist */
    relationships: Array<GraphStoreCreateComponentImpactedByIncidentRelationshipInput>;
};

export enum GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5",
    Pending = "PENDING",
    Unknown = "UNKNOWN"
}

export enum GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    NotSet = "NOT_SET",
    Undefined = "UNDEFINED"
}

export type GraphStoreCreateComponentImpactedByIncidentPayload = Payload & {
    __typename?: "GraphStoreCreateComponentImpactedByIncidentPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateComponentImpactedByIncidentRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    from: Scalars["ID"]["input"];
    /** Object metadata for this relationship */
    objectMetadata?: InputMaybe<GraphStoreCreateComponentImpactedByIncidentRelationshipObjectMetadataInput>;
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateComponentImpactedByIncidentRelationshipObjectMetadataInput =
    {
        affectedServiceAris?: InputMaybe<Scalars["String"]["input"]>;
        assigneeAri?: InputMaybe<Scalars["String"]["input"]>;
        majorIncident?: InputMaybe<Scalars["Boolean"]["input"]>;
        priority?: InputMaybe<GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput>;
        reporterAri?: InputMaybe<Scalars["String"]["input"]>;
        status?: InputMaybe<GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput>;
    };

export type GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkInput = {
    /** The list of relationships of type incident-associated-post-incident-review-link to persist */
    relationships: Array<GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkRelationshipInput>;
};

export type GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkPayload =
    Payload & {
        __typename?: "GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkPayload";
        /** If present, represents an error that might have happened with the ingestion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship creation request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkRelationshipInput =
    {
        /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] */
        from: Scalars["ID"]["input"];
        /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
        sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
        /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] */
        to: Scalars["ID"]["input"];
        /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
        updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphStoreCreateIncidentHasActionItemInput = {
    /** The list of relationships of type incident-has-action-item to persist */
    relationships: Array<GraphStoreCreateIncidentHasActionItemRelationshipInput>;
};

export type GraphStoreCreateIncidentHasActionItemPayload = Payload & {
    __typename?: "GraphStoreCreateIncidentHasActionItemPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateIncidentHasActionItemRelationshipInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateIncidentLinkedJswIssueInput = {
    /** The list of relationships of type incident-linked-jsw-issue to persist */
    relationships: Array<GraphStoreCreateIncidentLinkedJswIssueRelationshipInput>;
};

export type GraphStoreCreateIncidentLinkedJswIssuePayload = Payload & {
    __typename?: "GraphStoreCreateIncidentLinkedJswIssuePayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateIncidentLinkedJswIssueRelationshipInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateIssueToWhiteboardInput = {
    /** The list of relationships of type issue-to-whiteboard to persist */
    relationships: Array<GraphStoreCreateIssueToWhiteboardRelationshipInput>;
};

export type GraphStoreCreateIssueToWhiteboardPayload = Payload & {
    __typename?: "GraphStoreCreateIssueToWhiteboardPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateIssueToWhiteboardRelationshipInput = {
    /** An ARI of type ati:cloud:confluence:whiteboard */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:confluence:whiteboard */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateJswProjectAssociatedComponentInput = {
    /** The list of relationships of type jsw-project-associated-component to persist */
    relationships: Array<GraphStoreCreateJswProjectAssociatedComponentRelationshipInput>;
};

export type GraphStoreCreateJswProjectAssociatedComponentPayload = Payload & {
    __typename?: "GraphStoreCreateJswProjectAssociatedComponentPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateJswProjectAssociatedComponentRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of any of the following [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderInput = {
    /** The list of relationships of type meeting-recording-owner-has-meeting-notes-folder to persist */
    relationships: Array<GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderRelationshipInput>;
};

export type GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderPayload =
    Payload & {
        __typename?: "GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderPayload";
        /** If present, represents an error that might have happened with the ingestion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship creation request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderRelationshipInput =
    {
        /** An ARI of type ati:cloud:confluence:folder */
        from: Scalars["ID"]["input"];
        /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
        sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
        /** An ARI of type ati:cloud:confluence:folder */
        to: Scalars["ID"]["input"];
        /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
        updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphStoreCreateProjectAssociatedOpsgenieTeamInput = {
    /** The list of relationships of type project-associated-opsgenie-team to persist */
    relationships: Array<GraphStoreCreateProjectAssociatedOpsgenieTeamRelationshipInput>;
};

export type GraphStoreCreateProjectAssociatedOpsgenieTeamPayload = Payload & {
    __typename?: "GraphStoreCreateProjectAssociatedOpsgenieTeamPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectAssociatedOpsgenieTeamRelationshipInput = {
    /** An ARI of type ati:cloud:opsgenie:team */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:opsgenie:team */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateProjectAssociatedToSecurityContainerInput = {
    /** The list of relationships of type project-associated-to-security-container to persist */
    relationships: Array<GraphStoreCreateProjectAssociatedToSecurityContainerRelationshipInput>;
};

export type GraphStoreCreateProjectAssociatedToSecurityContainerPayload =
    Payload & {
        __typename?: "GraphStoreCreateProjectAssociatedToSecurityContainerPayload";
        /** If present, represents an error that might have happened with the ingestion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship creation request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreCreateProjectAssociatedToSecurityContainerRelationshipInput =
    {
        /** An ARI of any of the following [ati:cloud:jira:security-container, ati:cloud:graph:security-container] */
        from: Scalars["ID"]["input"];
        /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
        sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
        /** An ARI of any of the following [ati:cloud:jira:security-container, ati:cloud:graph:security-container] */
        to: Scalars["ID"]["input"];
        /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
        updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphStoreCreateProjectDisassociatedRepoInput = {
    /** The list of relationships of type project-disassociated-repo to persist */
    relationships: Array<GraphStoreCreateProjectDisassociatedRepoRelationshipInput>;
};

export type GraphStoreCreateProjectDisassociatedRepoPayload = Payload & {
    __typename?: "GraphStoreCreateProjectDisassociatedRepoPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectDisassociatedRepoRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of any of the following [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateProjectDocumentationEntityInput = {
    /** The list of relationships of type project-documentation-entity to persist */
    relationships: Array<GraphStoreCreateProjectDocumentationEntityRelationshipInput>;
};

export type GraphStoreCreateProjectDocumentationEntityPayload = Payload & {
    __typename?: "GraphStoreCreateProjectDocumentationEntityPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectDocumentationEntityRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document] */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of any of the following [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document] */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateProjectDocumentationPageInput = {
    /** The list of relationships of type project-documentation-page to persist */
    relationships: Array<GraphStoreCreateProjectDocumentationPageRelationshipInput>;
};

export type GraphStoreCreateProjectDocumentationPagePayload = Payload & {
    __typename?: "GraphStoreCreateProjectDocumentationPagePayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectDocumentationPageRelationshipInput = {
    /** An ARI of type ati:cloud:confluence:page */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:confluence:page */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateProjectDocumentationSpaceInput = {
    /** The list of relationships of type project-documentation-space to persist */
    relationships: Array<GraphStoreCreateProjectDocumentationSpaceRelationshipInput>;
};

export type GraphStoreCreateProjectDocumentationSpacePayload = Payload & {
    __typename?: "GraphStoreCreateProjectDocumentationSpacePayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectDocumentationSpaceRelationshipInput = {
    /** An ARI of type ati:cloud:confluence:space */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:confluence:space */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateProjectHasRelatedWorkWithProjectInput = {
    /** The list of relationships of type project-has-related-work-with-project to persist */
    relationships: Array<GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput>;
};

export type GraphStoreCreateProjectHasRelatedWorkWithProjectPayload =
    Payload & {
        __typename?: "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload";
        /** If present, represents an error that might have happened with the ingestion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship creation request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput =
    {
        /** An ARI of type ati:cloud:jira:project */
        from: Scalars["ID"]["input"];
        /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
        sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
        /** An ARI of type ati:cloud:jira:project */
        to: Scalars["ID"]["input"];
        /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
        updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphStoreCreateProjectHasSharedVersionWithInput = {
    /** The list of relationships of type project-has-shared-version-with to persist */
    relationships: Array<GraphStoreCreateProjectHasSharedVersionWithRelationshipInput>;
};

export type GraphStoreCreateProjectHasSharedVersionWithPayload = Payload & {
    __typename?: "GraphStoreCreateProjectHasSharedVersionWithPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectHasSharedVersionWithRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:project */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateProjectHasVersionInput = {
    /** The list of relationships of type project-has-version to persist */
    relationships: Array<GraphStoreCreateProjectHasVersionRelationshipInput>;
};

export type GraphStoreCreateProjectHasVersionPayload = Payload & {
    __typename?: "GraphStoreCreateProjectHasVersionPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateProjectHasVersionRelationshipInput = {
    /** An ARI of type ati:cloud:jira:version */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:version */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateSprintRetrospectivePageInput = {
    /** The list of relationships of type sprint-retrospective-page to persist */
    relationships: Array<GraphStoreCreateSprintRetrospectivePageRelationshipInput>;
};

export type GraphStoreCreateSprintRetrospectivePagePayload = Payload & {
    __typename?: "GraphStoreCreateSprintRetrospectivePagePayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateSprintRetrospectivePageRelationshipInput = {
    /** An ARI of type ati:cloud:confluence:page */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:confluence:page */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateSprintRetrospectiveWhiteboardInput = {
    /** The list of relationships of type sprint-retrospective-whiteboard to persist */
    relationships: Array<GraphStoreCreateSprintRetrospectiveWhiteboardRelationshipInput>;
};

export type GraphStoreCreateSprintRetrospectiveWhiteboardPayload = Payload & {
    __typename?: "GraphStoreCreateSprintRetrospectiveWhiteboardPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateSprintRetrospectiveWhiteboardRelationshipInput = {
    /** An ARI of type ati:cloud:confluence:whiteboard */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:confluence:whiteboard */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateTeamConnectedToContainerInput = {
    /** The list of relationships of type team-connected-to-container to persist */
    relationships: Array<GraphStoreCreateTeamConnectedToContainerRelationshipInput>;
};

export type GraphStoreCreateTeamConnectedToContainerPayload = Payload & {
    __typename?: "GraphStoreCreateTeamConnectedToContainerPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateTeamConnectedToContainerRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:jira:project, ati:cloud:confluence:space] */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of any of the following [ati:cloud:jira:project, ati:cloud:confluence:space] */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagInput = {
    /** The list of relationships of type townsquare-tag-is-alias-of-townsquare-tag to persist */
    relationships: Array<GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagRelationshipInput>;
};

export type GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagPayload =
    Payload & {
        __typename?: "GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagPayload";
        /** If present, represents an error that might have happened with the ingestion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship creation request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagRelationshipInput =
    {
        /** An ARI of type ati:cloud:townsquare:tag */
        from: Scalars["ID"]["input"];
        /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
        sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
        /** An ARI of type ati:cloud:townsquare:tag */
        to: Scalars["ID"]["input"];
        /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
        updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphStoreCreateUserHasRelevantProjectInput = {
    /** The list of relationships of type user-has-relevant-project to persist */
    relationships: Array<GraphStoreCreateUserHasRelevantProjectRelationshipInput>;
};

export type GraphStoreCreateUserHasRelevantProjectPayload = Payload & {
    __typename?: "GraphStoreCreateUserHasRelevantProjectPayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateUserHasRelevantProjectRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** An ARI of type ati:cloud:jira:project */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateVersionUserAssociatedFeatureFlagInput = {
    /** The list of relationships of type version-user-associated-feature-flag to persist */
    relationships: Array<GraphStoreCreateVersionUserAssociatedFeatureFlagRelationshipInput>;
};

export type GraphStoreCreateVersionUserAssociatedFeatureFlagPayload =
    Payload & {
        __typename?: "GraphStoreCreateVersionUserAssociatedFeatureFlagPayload";
        /** If present, represents an error that might have happened with the ingestion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship creation request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreCreateVersionUserAssociatedFeatureFlagRelationshipInput =
    {
        /** An ARI of any of the following [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
        from: Scalars["ID"]["input"];
        /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
        sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
        /** An ARI of any of the following [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
        to: Scalars["ID"]["input"];
        /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
        updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    };

export type GraphStoreCreateVulnerabilityAssociatedIssueContainerInput = {
    containerAri?: InputMaybe<Scalars["String"]["input"]>;
};

export type GraphStoreCreateVulnerabilityAssociatedIssueInput = {
    /** The list of relationships of type vulnerability-associated-issue to persist */
    relationships: Array<GraphStoreCreateVulnerabilityAssociatedIssueRelationshipInput>;
};

export type GraphStoreCreateVulnerabilityAssociatedIssuePayload = Payload & {
    __typename?: "GraphStoreCreateVulnerabilityAssociatedIssuePayload";
    /** If present, represents an error that might have happened with the ingestion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship creation request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreCreateVulnerabilityAssociatedIssueRelationshipInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** Sequence number of this relationship, used for versioning. updatedAt as millis will be used if omitted */
    sequenceNumber?: InputMaybe<Scalars["Long"]["input"]>;
    /** Subject metadata for this relationship */
    subjectMetadata?: InputMaybe<GraphStoreCreateVulnerabilityAssociatedIssueRelationshipSubjectMetadataInput>;
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
    /** Time at which these relationships were last observed. Current time will be assumed if omitted. */
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreCreateVulnerabilityAssociatedIssueRelationshipSubjectMetadataInput =
    {
        container?: InputMaybe<GraphStoreCreateVulnerabilityAssociatedIssueContainerInput>;
        introducedDate?: InputMaybe<Scalars["DateTime"]["input"]>;
        severity?: InputMaybe<GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput>;
        status?: InputMaybe<GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput>;
        type?: InputMaybe<GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput>;
    };

export enum GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput {
    Dast = "DAST",
    NotSet = "NOT_SET",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphStoreCypherQueryConnection = {
    __typename?: "GraphStoreCypherQueryConnection";
    edges: Array<GraphStoreCypherQueryEdge>;
    pageInfo: PageInfo;
    queryResult?: Maybe<GraphStoreCypherQueryResult>;
};

export type GraphStoreCypherQueryEdge = {
    __typename?: "GraphStoreCypherQueryEdge";
    /** Node */
    node: GraphStoreCypherQueryNode;
};

export type GraphStoreCypherQueryFromNode = {
    __typename?: "GraphStoreCypherQueryFromNode";
    /** The data for the from node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreCypherQueryFromNodeUnion>;
    /** ARI of subject entity */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for cypherQuery: [ConfluencePage, ExternalVideo, JiraPostIncidentReviewLink, TownsquareProjectUpdate, JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink, DevOpsRepository, ExternalRepository, JiraProject, OpsgenieTeam, JiraAlignAggProject, ExternalCommit, ExternalRemoteLink, JiraIssue, TownsquareGoalUpdate, ExternalMessage, LoomComment, AtlassianAccountUser, CustomerUser, AppUser, ExternalConversation, ConfluenceBlogPost, MercuryFocusArea, DevOpsProjectDetails, ExternalBuildInfo, DevOpsPullRequestDetails, ExternalPullRequest, ConfluenceWhiteboard, DevOpsService, JiraWorklog, DevOpsFeatureFlag, ExternalFeatureFlag, CompassComponent, ConfluenceFolder, ConfluenceSpace, TownsquareProject, ExternalVulnerability, ExternalCalendarEvent, DevOpsDesign, ExternalDesign, DevOpsOperationsPostIncidentReviewDetails, DeploymentSummary, ExternalDeployment, DevOpsOperationsComponentDetails, DevOpsOperationsIncidentDetails, JiraPlatformComment, JiraServiceManagementComment, ConfluenceDatabase, TownsquareGoal, ThirdPartyUser, TeamV2, JiraBoard, RadarPosition, ConfluenceInlineComment, ConfluenceFooterComment, DevOpsSecurityVulnerabilityDetails, JiraVersion, DevOpsDocument, ExternalDocument, ExternalBranch, LoomVideo] */
export type GraphStoreCypherQueryFromNodeUnion =
    | AppUser
    | AtlassianAccountUser
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluenceDatabase
    | ConfluenceFolder
    | ConfluenceFooterComment
    | ConfluenceInlineComment
    | ConfluencePage
    | ConfluenceSpace
    | ConfluenceWhiteboard
    | CustomerUser
    | DeploymentSummary
    | DevOpsDesign
    | DevOpsDocument
    | DevOpsFeatureFlag
    | DevOpsOperationsComponentDetails
    | DevOpsOperationsIncidentDetails
    | DevOpsOperationsPostIncidentReviewDetails
    | DevOpsProjectDetails
    | DevOpsPullRequestDetails
    | DevOpsRepository
    | DevOpsSecurityVulnerabilityDetails
    | DevOpsService
    | ExternalBranch
    | ExternalBuildInfo
    | ExternalCalendarEvent
    | ExternalCommit
    | ExternalConversation
    | ExternalDeployment
    | ExternalDesign
    | ExternalDocument
    | ExternalFeatureFlag
    | ExternalMessage
    | ExternalPullRequest
    | ExternalRemoteLink
    | ExternalRepository
    | ExternalVideo
    | ExternalVulnerability
    | JiraAlignAggProject
    | JiraBoard
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssue
    | JiraIssueRemoteIssueLink
    | JiraPlatformComment
    | JiraPostIncidentReviewLink
    | JiraProject
    | JiraServiceManagementComment
    | JiraVersion
    | JiraWebRemoteIssueLink
    | JiraWorklog
    | LoomComment
    | LoomVideo
    | MercuryFocusArea
    | OpsgenieTeam
    | RadarPosition
    | TeamV2
    | ThirdPartyUser
    | TownsquareGoal
    | TownsquareGoalUpdate
    | TownsquareProject
    | TownsquareProjectUpdate;

export type GraphStoreCypherQueryNode = {
    __typename?: "GraphStoreCypherQueryNode";
    /** Field from where relationship originates */
    from: GraphStoreCypherQueryFromNode;
    /** To with data */
    to: GraphStoreCypherQueryToNode;
};

export type GraphStoreCypherQueryResult = {
    __typename?: "GraphStoreCypherQueryResult";
    /** columns of the query result */
    columns: Array<Scalars["String"]["output"]>;
    /** rows of query result data */
    rows: Array<GraphStoreCypherQueryResultRow>;
};

export type GraphStoreCypherQueryResultRow = {
    __typename?: "GraphStoreCypherQueryResultRow";
    /** query result row */
    rowItems: Array<GraphStoreCypherQueryResultRowItem>;
};

export type GraphStoreCypherQueryResultRowItem = {
    __typename?: "GraphStoreCypherQueryResultRowItem";
    /** Field key in cypher return clause */
    key: Scalars["String"]["output"];
    /** value with data */
    value: Array<GraphStoreCypherQueryValueNode>;
};

export type GraphStoreCypherQueryToNode = {
    __typename?: "GraphStoreCypherQueryToNode";
    /** The data for the to node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreCypherQueryToNodeUnion>;
    /** ARI of object entity */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for cypherQuery: [ConfluencePage, ExternalVideo, JiraPostIncidentReviewLink, TownsquareProjectUpdate, JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink, DevOpsRepository, ExternalRepository, JiraProject, OpsgenieTeam, JiraAlignAggProject, ExternalCommit, ExternalRemoteLink, JiraIssue, TownsquareGoalUpdate, ExternalMessage, LoomComment, AtlassianAccountUser, CustomerUser, AppUser, ExternalConversation, ConfluenceBlogPost, MercuryFocusArea, DevOpsProjectDetails, ExternalBuildInfo, DevOpsPullRequestDetails, ExternalPullRequest, ConfluenceWhiteboard, DevOpsService, JiraWorklog, DevOpsFeatureFlag, ExternalFeatureFlag, CompassComponent, ConfluenceFolder, ConfluenceSpace, TownsquareProject, ExternalVulnerability, ExternalCalendarEvent, DevOpsDesign, ExternalDesign, DevOpsOperationsPostIncidentReviewDetails, DeploymentSummary, ExternalDeployment, DevOpsOperationsComponentDetails, DevOpsOperationsIncidentDetails, JiraPlatformComment, JiraServiceManagementComment, ConfluenceDatabase, TownsquareGoal, ThirdPartyUser, TeamV2, JiraBoard, RadarPosition, ConfluenceInlineComment, ConfluenceFooterComment, DevOpsSecurityVulnerabilityDetails, JiraVersion, DevOpsDocument, ExternalDocument, ExternalBranch, LoomVideo] */
export type GraphStoreCypherQueryToNodeUnion =
    | AppUser
    | AtlassianAccountUser
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluenceDatabase
    | ConfluenceFolder
    | ConfluenceFooterComment
    | ConfluenceInlineComment
    | ConfluencePage
    | ConfluenceSpace
    | ConfluenceWhiteboard
    | CustomerUser
    | DeploymentSummary
    | DevOpsDesign
    | DevOpsDocument
    | DevOpsFeatureFlag
    | DevOpsOperationsComponentDetails
    | DevOpsOperationsIncidentDetails
    | DevOpsOperationsPostIncidentReviewDetails
    | DevOpsProjectDetails
    | DevOpsPullRequestDetails
    | DevOpsRepository
    | DevOpsSecurityVulnerabilityDetails
    | DevOpsService
    | ExternalBranch
    | ExternalBuildInfo
    | ExternalCalendarEvent
    | ExternalCommit
    | ExternalConversation
    | ExternalDeployment
    | ExternalDesign
    | ExternalDocument
    | ExternalFeatureFlag
    | ExternalMessage
    | ExternalPullRequest
    | ExternalRemoteLink
    | ExternalRepository
    | ExternalVideo
    | ExternalVulnerability
    | JiraAlignAggProject
    | JiraBoard
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssue
    | JiraIssueRemoteIssueLink
    | JiraPlatformComment
    | JiraPostIncidentReviewLink
    | JiraProject
    | JiraServiceManagementComment
    | JiraVersion
    | JiraWebRemoteIssueLink
    | JiraWorklog
    | LoomComment
    | LoomVideo
    | MercuryFocusArea
    | OpsgenieTeam
    | RadarPosition
    | TeamV2
    | ThirdPartyUser
    | TownsquareGoal
    | TownsquareGoalUpdate
    | TownsquareProject
    | TownsquareProjectUpdate;

/** A union of the possible hydration types for cypherQuery: [ConfluencePage, ExternalVideo, JiraPostIncidentReviewLink, TownsquareProjectUpdate, JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink, DevOpsRepository, ExternalRepository, JiraProject, OpsgenieTeam, JiraAlignAggProject, ExternalCommit, ExternalRemoteLink, JiraIssue, TownsquareGoalUpdate, ExternalMessage, LoomComment, AtlassianAccountUser, CustomerUser, AppUser, ExternalConversation, ConfluenceBlogPost, MercuryFocusArea, DevOpsProjectDetails, ExternalBuildInfo, DevOpsPullRequestDetails, ExternalPullRequest, ConfluenceWhiteboard, DevOpsService, JiraWorklog, DevOpsFeatureFlag, ExternalFeatureFlag, CompassComponent, ConfluenceFolder, ConfluenceSpace, TownsquareProject, ExternalVulnerability, ExternalCalendarEvent, DevOpsDesign, ExternalDesign, DevOpsOperationsPostIncidentReviewDetails, DeploymentSummary, ExternalDeployment, DevOpsOperationsComponentDetails, DevOpsOperationsIncidentDetails, JiraPlatformComment, JiraServiceManagementComment, ConfluenceDatabase, TownsquareGoal, ThirdPartyUser, TeamV2, JiraBoard, RadarPosition, ConfluenceInlineComment, ConfluenceFooterComment, DevOpsSecurityVulnerabilityDetails, JiraVersion, DevOpsDocument, ExternalDocument, ExternalBranch, LoomVideo] */
export type GraphStoreCypherQueryValueItemUnion =
    | AppUser
    | AtlassianAccountUser
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluenceDatabase
    | ConfluenceFolder
    | ConfluenceFooterComment
    | ConfluenceInlineComment
    | ConfluencePage
    | ConfluenceSpace
    | ConfluenceWhiteboard
    | CustomerUser
    | DeploymentSummary
    | DevOpsDesign
    | DevOpsDocument
    | DevOpsFeatureFlag
    | DevOpsOperationsComponentDetails
    | DevOpsOperationsIncidentDetails
    | DevOpsOperationsPostIncidentReviewDetails
    | DevOpsProjectDetails
    | DevOpsPullRequestDetails
    | DevOpsRepository
    | DevOpsSecurityVulnerabilityDetails
    | DevOpsService
    | ExternalBranch
    | ExternalBuildInfo
    | ExternalCalendarEvent
    | ExternalCommit
    | ExternalConversation
    | ExternalDeployment
    | ExternalDesign
    | ExternalDocument
    | ExternalFeatureFlag
    | ExternalMessage
    | ExternalPullRequest
    | ExternalRemoteLink
    | ExternalRepository
    | ExternalVideo
    | ExternalVulnerability
    | JiraAlignAggProject
    | JiraBoard
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssue
    | JiraIssueRemoteIssueLink
    | JiraPlatformComment
    | JiraPostIncidentReviewLink
    | JiraProject
    | JiraServiceManagementComment
    | JiraVersion
    | JiraWebRemoteIssueLink
    | JiraWorklog
    | LoomComment
    | LoomVideo
    | MercuryFocusArea
    | OpsgenieTeam
    | RadarPosition
    | TeamV2
    | ThirdPartyUser
    | TownsquareGoal
    | TownsquareGoalUpdate
    | TownsquareProject
    | TownsquareProjectUpdate;

export type GraphStoreCypherQueryValueNode = {
    __typename?: "GraphStoreCypherQueryValueNode";
    /** The data for the row value node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreCypherQueryValueItemUnion>;
    /** ARI of subject entity */
    id: Scalars["ID"]["output"];
};

export type GraphStoreDateFilterInput = {
    after?: InputMaybe<Scalars["DateTime"]["input"]>;
    before?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type GraphStoreDeleteComponentImpactedByIncidentInput = {
    /** The list of relationships of type component-impacted-by-incident to delete */
    relationships: Array<GraphStoreDeleteComponentImpactedByIncidentRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteComponentImpactedByIncidentPayload = Payload & {
    __typename?: "GraphStoreDeleteComponentImpactedByIncidentPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteComponentImpactedByIncidentRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    from: Scalars["ID"]["input"];
    /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkInput = {
    /** The list of relationships of type incident-associated-post-incident-review-link to delete */
    relationships: Array<GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkPayload =
    Payload & {
        __typename?: "GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkPayload";
        /** If present, represents an error that might have happened with the deletion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship delete request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkRelationshipInput =
    {
        /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
        from: Scalars["ID"]["input"];
        /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] */
        to: Scalars["ID"]["input"];
    };

export type GraphStoreDeleteIncidentHasActionItemInput = {
    /** The list of relationships of type incident-has-action-item to delete */
    relationships: Array<GraphStoreDeleteIncidentHasActionItemRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteIncidentHasActionItemPayload = Payload & {
    __typename?: "GraphStoreDeleteIncidentHasActionItemPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteIncidentHasActionItemRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteIncidentLinkedJswIssueInput = {
    /** The list of relationships of type incident-linked-jsw-issue to delete */
    relationships: Array<GraphStoreDeleteIncidentLinkedJswIssueRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteIncidentLinkedJswIssuePayload = Payload & {
    __typename?: "GraphStoreDeleteIncidentLinkedJswIssuePayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteIncidentLinkedJswIssueRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteIssueToWhiteboardInput = {
    /** The list of relationships of type issue-to-whiteboard to delete */
    relationships: Array<GraphStoreDeleteIssueToWhiteboardRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteIssueToWhiteboardPayload = Payload & {
    __typename?: "GraphStoreDeleteIssueToWhiteboardPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteIssueToWhiteboardRelationshipInput = {
    /** An ARI of type ati:cloud:jira:issue */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:confluence:whiteboard */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteJswProjectAssociatedComponentInput = {
    /** The list of relationships of type jsw-project-associated-component to delete */
    relationships: Array<GraphStoreDeleteJswProjectAssociatedComponentRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteJswProjectAssociatedComponentPayload = Payload & {
    __typename?: "GraphStoreDeleteJswProjectAssociatedComponentPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteJswProjectAssociatedComponentRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of any of the following [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderInput = {
    /** The list of relationships of type meeting-recording-owner-has-meeting-notes-folder to delete */
    relationships: Array<GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderPayload =
    Payload & {
        __typename?: "GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderPayload";
        /** If present, represents an error that might have happened with the deletion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship delete request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderRelationshipInput =
    {
        /** An ARI of type ati:cloud:identity:user */
        from: Scalars["ID"]["input"];
        /** An ARI of type ati:cloud:confluence:folder */
        to: Scalars["ID"]["input"];
    };

export type GraphStoreDeleteProjectAssociatedOpsgenieTeamInput = {
    /** The list of relationships of type project-associated-opsgenie-team to delete */
    relationships: Array<GraphStoreDeleteProjectAssociatedOpsgenieTeamRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectAssociatedOpsgenieTeamPayload = Payload & {
    __typename?: "GraphStoreDeleteProjectAssociatedOpsgenieTeamPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectAssociatedOpsgenieTeamRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:opsgenie:team */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteProjectAssociatedToSecurityContainerInput = {
    /** The list of relationships of type project-associated-to-security-container to delete */
    relationships: Array<GraphStoreDeleteProjectAssociatedToSecurityContainerRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectAssociatedToSecurityContainerPayload =
    Payload & {
        __typename?: "GraphStoreDeleteProjectAssociatedToSecurityContainerPayload";
        /** If present, represents an error that might have happened with the deletion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship delete request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreDeleteProjectAssociatedToSecurityContainerRelationshipInput =
    {
        /** An ARI of type ati:cloud:jira:project */
        from: Scalars["ID"]["input"];
        /** An ARI of any of the following [ati:cloud:jira:security-container, ati:cloud:graph:security-container] */
        to: Scalars["ID"]["input"];
    };

export type GraphStoreDeleteProjectDisassociatedRepoInput = {
    /** The list of relationships of type project-disassociated-repo to delete */
    relationships: Array<GraphStoreDeleteProjectDisassociatedRepoRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectDisassociatedRepoPayload = Payload & {
    __typename?: "GraphStoreDeleteProjectDisassociatedRepoPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectDisassociatedRepoRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of any of the following [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteProjectDocumentationEntityInput = {
    /** The list of relationships of type project-documentation-entity to delete */
    relationships: Array<GraphStoreDeleteProjectDocumentationEntityRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectDocumentationEntityPayload = Payload & {
    __typename?: "GraphStoreDeleteProjectDocumentationEntityPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectDocumentationEntityRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of any of the following [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document] */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteProjectDocumentationPageInput = {
    /** The list of relationships of type project-documentation-page to delete */
    relationships: Array<GraphStoreDeleteProjectDocumentationPageRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectDocumentationPagePayload = Payload & {
    __typename?: "GraphStoreDeleteProjectDocumentationPagePayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectDocumentationPageRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:confluence:page */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteProjectDocumentationSpaceInput = {
    /** The list of relationships of type project-documentation-space to delete */
    relationships: Array<GraphStoreDeleteProjectDocumentationSpaceRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectDocumentationSpacePayload = Payload & {
    __typename?: "GraphStoreDeleteProjectDocumentationSpacePayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectDocumentationSpaceRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:confluence:space */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteProjectHasRelatedWorkWithProjectInput = {
    /** The list of relationships of type project-has-related-work-with-project to delete */
    relationships: Array<GraphStoreDeleteProjectHasRelatedWorkWithProjectRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload =
    Payload & {
        __typename?: "GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload";
        /** If present, represents an error that might have happened with the deletion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship delete request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreDeleteProjectHasRelatedWorkWithProjectRelationshipInput =
    {
        /** An ARI of type ati:cloud:jira:project */
        from: Scalars["ID"]["input"];
        /** An ARI of type ati:cloud:jira:project */
        to: Scalars["ID"]["input"];
    };

export type GraphStoreDeleteProjectHasSharedVersionWithInput = {
    /** The list of relationships of type project-has-shared-version-with to delete */
    relationships: Array<GraphStoreDeleteProjectHasSharedVersionWithRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectHasSharedVersionWithPayload = Payload & {
    __typename?: "GraphStoreDeleteProjectHasSharedVersionWithPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectHasSharedVersionWithRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:jira:project */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteProjectHasVersionInput = {
    /** The list of relationships of type project-has-version to delete */
    relationships: Array<GraphStoreDeleteProjectHasVersionRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteProjectHasVersionPayload = Payload & {
    __typename?: "GraphStoreDeleteProjectHasVersionPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteProjectHasVersionRelationshipInput = {
    /** An ARI of type ati:cloud:jira:project */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:jira:version */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteSprintRetrospectivePageInput = {
    /** The list of relationships of type sprint-retrospective-page to delete */
    relationships: Array<GraphStoreDeleteSprintRetrospectivePageRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteSprintRetrospectivePagePayload = Payload & {
    __typename?: "GraphStoreDeleteSprintRetrospectivePagePayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteSprintRetrospectivePageRelationshipInput = {
    /** An ARI of type ati:cloud:jira:sprint */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:confluence:page */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteSprintRetrospectiveWhiteboardInput = {
    /** The list of relationships of type sprint-retrospective-whiteboard to delete */
    relationships: Array<GraphStoreDeleteSprintRetrospectiveWhiteboardRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteSprintRetrospectiveWhiteboardPayload = Payload & {
    __typename?: "GraphStoreDeleteSprintRetrospectiveWhiteboardPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteSprintRetrospectiveWhiteboardRelationshipInput = {
    /** An ARI of type ati:cloud:jira:sprint */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:confluence:whiteboard */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteTeamConnectedToContainerInput = {
    /** The list of relationships of type team-connected-to-container to delete */
    relationships: Array<GraphStoreDeleteTeamConnectedToContainerRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteTeamConnectedToContainerPayload = Payload & {
    __typename?: "GraphStoreDeleteTeamConnectedToContainerPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteTeamConnectedToContainerRelationshipInput = {
    /** An ARI of type ati:cloud:identity:team */
    from: Scalars["ID"]["input"];
    /** An ARI of any of the following [ati:cloud:jira:project, ati:cloud:confluence:space] */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagInput = {
    /** The list of relationships of type townsquare-tag-is-alias-of-townsquare-tag to delete */
    relationships: Array<GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagPayload =
    Payload & {
        __typename?: "GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagPayload";
        /** If present, represents an error that might have happened with the deletion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship delete request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagRelationshipInput =
    {
        /** An ARI of type ati:cloud:townsquare:tag */
        from: Scalars["ID"]["input"];
        /** An ARI of type ati:cloud:townsquare:tag */
        to: Scalars["ID"]["input"];
    };

export type GraphStoreDeleteUserHasRelevantProjectInput = {
    /** The list of relationships of type user-has-relevant-project to delete */
    relationships: Array<GraphStoreDeleteUserHasRelevantProjectRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteUserHasRelevantProjectPayload = Payload & {
    __typename?: "GraphStoreDeleteUserHasRelevantProjectPayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteUserHasRelevantProjectRelationshipInput = {
    /** An ARI of type ati:cloud:identity:user */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:jira:project */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeleteVersionUserAssociatedFeatureFlagInput = {
    /** The list of relationships of type version-user-associated-feature-flag to delete */
    relationships: Array<GraphStoreDeleteVersionUserAssociatedFeatureFlagRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteVersionUserAssociatedFeatureFlagPayload =
    Payload & {
        __typename?: "GraphStoreDeleteVersionUserAssociatedFeatureFlagPayload";
        /** If present, represents an error that might have happened with the deletion of this relationship */
        errors?: Maybe<Array<MutationError>>;
        /** Indicates whether the relationship delete request was accepted by the server or not */
        success: Scalars["Boolean"]["output"];
    };

export type GraphStoreDeleteVersionUserAssociatedFeatureFlagRelationshipInput =
    {
        /** An ARI of type ati:cloud:jira:version */
        from: Scalars["ID"]["input"];
        /** An ARI of any of the following [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
        to: Scalars["ID"]["input"];
    };

export type GraphStoreDeleteVulnerabilityAssociatedIssueInput = {
    /** The list of relationships of type vulnerability-associated-issue to delete */
    relationships: Array<GraphStoreDeleteVulnerabilityAssociatedIssueRelationshipInput>;
    /** If true, the request will wait until the relationship is deleted before returning. This will make the request twice as expensive and should not be used unless really needed. */
    synchronousWrite?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GraphStoreDeleteVulnerabilityAssociatedIssuePayload = Payload & {
    __typename?: "GraphStoreDeleteVulnerabilityAssociatedIssuePayload";
    /** If present, represents an error that might have happened with the deletion of this relationship */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates whether the relationship delete request was accepted by the server or not */
    success: Scalars["Boolean"]["output"];
};

export type GraphStoreDeleteVulnerabilityAssociatedIssueRelationshipInput = {
    /** An ARI of any of the following [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] */
    from: Scalars["ID"]["input"];
    /** An ARI of type ati:cloud:jira:issue */
    to: Scalars["ID"]["input"];
};

export type GraphStoreDeploymentContainsCommitSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreExternalWorkerConflatesToIdentity3pUserSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreFloatFilterInput = {
    greaterThan?: InputMaybe<Scalars["Float"]["input"]>;
    greaterThanOrEqual?: InputMaybe<Scalars["Float"]["input"]>;
    is?: InputMaybe<Array<Scalars["Float"]["input"]>>;
    isNot?: InputMaybe<Array<Scalars["Float"]["input"]>>;
    lessThan?: InputMaybe<Scalars["Float"]["input"]>;
    lessThanOrEqual?: InputMaybe<Scalars["Float"]["input"]>;
};

export type GraphStoreFocusAreaAssociatedToProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreFocusAreaHasAtlasGoalSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreFocusAreaHasFocusAreaSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreFocusAreaHasPageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreFocusAreaHasProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceConnection";
        edges: Array<
            Maybe<GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceNode>
        >;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type app-installation-associated-to-operations-workspace */
export type GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceEdge = {
    __typename?: "GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceNode;
};

export type GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceEndNode =
    {
        __typename?: "GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceEndNode";
        /** An ARI of type(s) [ati:cloud:jira:operations-workspace, ati:cloud:graph:operations-workspace] */
        id: Scalars["ID"]["output"];
    };

/** A node representing a app-installation-associated-to-operations-workspace relationship, with all metadata (if available) */
export type GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceNode =
    Node & {
        __typename?: "GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceNode";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the from node */
        from: GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceStartNode;
        /** The id of the relationship */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the to node */
        to: GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceEndNode;
    };

export type GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceStartNode =
    {
        __typename?: "GraphStoreFullAppInstallationAssociatedToOperationsWorkspaceStartNode";
        /** An ARI of type(s) [ati:cloud:jira:connect-app] */
        id: Scalars["ID"]["output"];
    };

export type GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceConnection";
        edges: Array<
            Maybe<GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceNode>
        >;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type app-installation-associated-to-security-workspace */
export type GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceEdge = {
    __typename?: "GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceNode;
};

export type GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceEndNode =
    {
        __typename?: "GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceEndNode";
        /** An ARI of type(s) [ati:cloud:jira:security-workspace, ati:cloud:graph:security-workspace] */
        id: Scalars["ID"]["output"];
    };

/** A node representing a app-installation-associated-to-security-workspace relationship, with all metadata (if available) */
export type GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceNode =
    Node & {
        __typename?: "GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceNode";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the from node */
        from: GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceStartNode;
        /** The id of the relationship */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the to node */
        to: GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceEndNode;
    };

export type GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceStartNode =
    {
        __typename?: "GraphStoreFullAppInstallationAssociatedToSecurityWorkspaceStartNode";
        /** An ARI of type(s) [ati:cloud:jira:connect-app] */
        id: Scalars["ID"]["output"];
    };

export type GraphStoreFullAtlasProjectContributesToAtlasGoalConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullAtlasProjectContributesToAtlasGoalConnection";
        edges: Array<
            Maybe<GraphStoreFullAtlasProjectContributesToAtlasGoalEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreFullAtlasProjectContributesToAtlasGoalNode>
        >;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type atlas-project-contributes-to-atlas-goal */
export type GraphStoreFullAtlasProjectContributesToAtlasGoalEdge = {
    __typename?: "GraphStoreFullAtlasProjectContributesToAtlasGoalEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullAtlasProjectContributesToAtlasGoalNode;
};

export type GraphStoreFullAtlasProjectContributesToAtlasGoalEndNode = {
    __typename?: "GraphStoreFullAtlasProjectContributesToAtlasGoalEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullAtlasProjectContributesToAtlasGoalEndUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:goal] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */
export type GraphStoreFullAtlasProjectContributesToAtlasGoalEndUnion =
    TownsquareGoal;

/** A node representing a atlas-project-contributes-to-atlas-goal relationship, with all metadata (if available) */
export type GraphStoreFullAtlasProjectContributesToAtlasGoalNode = Node & {
    __typename?: "GraphStoreFullAtlasProjectContributesToAtlasGoalNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullAtlasProjectContributesToAtlasGoalStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullAtlasProjectContributesToAtlasGoalEndNode;
};

export type GraphStoreFullAtlasProjectContributesToAtlasGoalStartNode = {
    __typename?: "GraphStoreFullAtlasProjectContributesToAtlasGoalStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullAtlasProjectContributesToAtlasGoalStartUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */
export type GraphStoreFullAtlasProjectContributesToAtlasGoalStartUnion =
    TownsquareProject;

export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullAtlasProjectIsTrackedOnJiraEpicConnection";
        edges: Array<Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEdge>>;
        nodes: Array<Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicNode>>;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type atlas-project-is-tracked-on-jira-epic */
export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEdge = {
    __typename?: "GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullAtlasProjectIsTrackedOnJiraEpicNode;
};

export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEndNode = {
    __typename?: "GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */
export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEndUnion = JiraIssue;

/** A node representing a atlas-project-is-tracked-on-jira-epic relationship, with all metadata (if available) */
export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicNode = Node & {
    __typename?: "GraphStoreFullAtlasProjectIsTrackedOnJiraEpicNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullAtlasProjectIsTrackedOnJiraEpicStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullAtlasProjectIsTrackedOnJiraEpicEndNode;
};

export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicRelationshipMetadataOutput =
    {
        __typename?: "GraphStoreFullAtlasProjectIsTrackedOnJiraEpicRelationshipMetadataOutput";
        syncLabels?: Maybe<Scalars["Boolean"]["output"]>;
        synced?: Maybe<Scalars["Boolean"]["output"]>;
    };

export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicStartNode = {
    __typename?: "GraphStoreFullAtlasProjectIsTrackedOnJiraEpicStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullAtlasProjectIsTrackedOnJiraEpicStartUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */
export type GraphStoreFullAtlasProjectIsTrackedOnJiraEpicStartUnion =
    TownsquareProject;

export type GraphStoreFullComponentImpactedByIncidentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullComponentImpactedByIncidentConnection";
        edges: Array<Maybe<GraphStoreFullComponentImpactedByIncidentEdge>>;
        nodes: Array<Maybe<GraphStoreFullComponentImpactedByIncidentNode>>;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type component-impacted-by-incident */
export type GraphStoreFullComponentImpactedByIncidentEdge = {
    __typename?: "GraphStoreFullComponentImpactedByIncidentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullComponentImpactedByIncidentNode;
};

export type GraphStoreFullComponentImpactedByIncidentEndNode = {
    __typename?: "GraphStoreFullComponentImpactedByIncidentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullComponentImpactedByIncidentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullComponentImpactedByIncidentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullComponentImpactedByIncidentEndUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

export enum GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5",
    Pending = "PENDING",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    NotSet = "NOT_SET",
    Undefined = "UNDEFINED"
}

/** A node representing a component-impacted-by-incident relationship, with all metadata (if available) */
export type GraphStoreFullComponentImpactedByIncidentNode = Node & {
    __typename?: "GraphStoreFullComponentImpactedByIncidentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullComponentImpactedByIncidentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullComponentImpactedByIncidentEndNode;
};

export type GraphStoreFullComponentImpactedByIncidentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullComponentImpactedByIncidentRelationshipObjectMetadataOutput";
        affectedServiceAris?: Maybe<Scalars["String"]["output"]>;
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        majorIncident?: Maybe<Scalars["Boolean"]["output"]>;
        priority?: Maybe<GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput>;
        reporterAri?: Maybe<Scalars["String"]["output"]>;
        status?: Maybe<GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput>;
    };

export type GraphStoreFullComponentImpactedByIncidentStartNode = {
    __typename?: "GraphStoreFullComponentImpactedByIncidentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullComponentImpactedByIncidentStartUnion>;
    /** An ARI of type(s) [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */
export type GraphStoreFullComponentImpactedByIncidentStartUnion =
    | CompassComponent
    | DevOpsOperationsComponentDetails;

export type GraphStoreFullComponentLinkedJswIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullComponentLinkedJswIssueConnection";
        edges: Array<Maybe<GraphStoreFullComponentLinkedJswIssueEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullComponentLinkedJswIssueNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type component-linked-jsw-issue */
export type GraphStoreFullComponentLinkedJswIssueEdge = {
    __typename?: "GraphStoreFullComponentLinkedJswIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullComponentLinkedJswIssueNode;
};

export type GraphStoreFullComponentLinkedJswIssueEndNode = {
    __typename?: "GraphStoreFullComponentLinkedJswIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullComponentLinkedJswIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */
export type GraphStoreFullComponentLinkedJswIssueEndUnion = JiraIssue;

/** A node representing a component-linked-jsw-issue relationship, with all metadata (if available) */
export type GraphStoreFullComponentLinkedJswIssueNode = Node & {
    __typename?: "GraphStoreFullComponentLinkedJswIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullComponentLinkedJswIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullComponentLinkedJswIssueEndNode;
};

export type GraphStoreFullComponentLinkedJswIssueStartNode = {
    __typename?: "GraphStoreFullComponentLinkedJswIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullComponentLinkedJswIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:compass:component, ati:cloud:graph:service, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */
export type GraphStoreFullComponentLinkedJswIssueStartUnion =
    | CompassComponent
    | DevOpsOperationsComponentDetails
    | DevOpsService;

export type GraphStoreFullContentReferencedEntityConnection = HasPageInfo & {
    __typename?: "GraphStoreFullContentReferencedEntityConnection";
    edges: Array<Maybe<GraphStoreFullContentReferencedEntityEdge>>;
    nodes: Array<Maybe<GraphStoreFullContentReferencedEntityNode>>;
    pageInfo: PageInfo;
};

/** A full relationship edge for the relationship type content-referenced-entity */
export type GraphStoreFullContentReferencedEntityEdge = {
    __typename?: "GraphStoreFullContentReferencedEntityEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullContentReferencedEntityNode;
};

export type GraphStoreFullContentReferencedEntityEndNode = {
    __typename?: "GraphStoreFullContentReferencedEntityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullContentReferencedEntityEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, ConfluenceBlogPost, CompassComponent] */
export type GraphStoreFullContentReferencedEntityEndUnion =
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

/** A node representing a content-referenced-entity relationship, with all metadata (if available) */
export type GraphStoreFullContentReferencedEntityNode = Node & {
    __typename?: "GraphStoreFullContentReferencedEntityNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullContentReferencedEntityStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullContentReferencedEntityEndNode;
};

export type GraphStoreFullContentReferencedEntityStartNode = {
    __typename?: "GraphStoreFullContentReferencedEntityStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullContentReferencedEntityStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, ConfluenceBlogPost] */
export type GraphStoreFullContentReferencedEntityStartUnion =
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

export type GraphStoreFullIncidentAssociatedPostIncidentReviewConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewConnection";
            edges: Array<
                Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type incident-associated-post-incident-review */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewEdge = {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIncidentAssociatedPostIncidentReviewNode;
};

export type GraphStoreFullIncidentAssociatedPostIncidentReviewEndNode = {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewEndUnion =
    JiraIssue;

export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewLinkConnection";
            edges: Array<
                Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewLinkNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEdge = {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIncidentAssociatedPostIncidentReviewLinkNode;
};

export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEndNode = {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEndUnion =
    | DevOpsOperationsPostIncidentReviewDetails
    | JiraIssue
    | JiraPostIncidentReviewLink;

/** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkNode =
    Node & {
        __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewLinkNode";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the from node */
        from: GraphStoreFullIncidentAssociatedPostIncidentReviewLinkStartNode;
        /** The id of the relationship */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the to node */
        to: GraphStoreFullIncidentAssociatedPostIncidentReviewLinkEndNode;
    };

export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkStartNode = {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewLinkStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewLinkStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewLinkStartUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewNode = Node & {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIncidentAssociatedPostIncidentReviewStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIncidentAssociatedPostIncidentReviewEndNode;
};

export type GraphStoreFullIncidentAssociatedPostIncidentReviewStartNode = {
    __typename?: "GraphStoreFullIncidentAssociatedPostIncidentReviewStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentAssociatedPostIncidentReviewStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */
export type GraphStoreFullIncidentAssociatedPostIncidentReviewStartUnion =
    JiraIssue;

export type GraphStoreFullIncidentHasActionItemConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIncidentHasActionItemConnection";
        edges: Array<Maybe<GraphStoreFullIncidentHasActionItemEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIncidentHasActionItemNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type incident-has-action-item */
export type GraphStoreFullIncidentHasActionItemEdge = {
    __typename?: "GraphStoreFullIncidentHasActionItemEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIncidentHasActionItemNode;
};

export type GraphStoreFullIncidentHasActionItemEndNode = {
    __typename?: "GraphStoreFullIncidentHasActionItemEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentHasActionItemEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */
export type GraphStoreFullIncidentHasActionItemEndUnion = JiraIssue;

/** A node representing a incident-has-action-item relationship, with all metadata (if available) */
export type GraphStoreFullIncidentHasActionItemNode = Node & {
    __typename?: "GraphStoreFullIncidentHasActionItemNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIncidentHasActionItemStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIncidentHasActionItemEndNode;
};

export type GraphStoreFullIncidentHasActionItemStartNode = {
    __typename?: "GraphStoreFullIncidentHasActionItemStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentHasActionItemStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullIncidentHasActionItemStartUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

export type GraphStoreFullIncidentLinkedJswIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIncidentLinkedJswIssueConnection";
        edges: Array<Maybe<GraphStoreFullIncidentLinkedJswIssueEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIncidentLinkedJswIssueNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type incident-linked-jsw-issue */
export type GraphStoreFullIncidentLinkedJswIssueEdge = {
    __typename?: "GraphStoreFullIncidentLinkedJswIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIncidentLinkedJswIssueNode;
};

export type GraphStoreFullIncidentLinkedJswIssueEndNode = {
    __typename?: "GraphStoreFullIncidentLinkedJswIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentLinkedJswIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */
export type GraphStoreFullIncidentLinkedJswIssueEndUnion = JiraIssue;

/** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */
export type GraphStoreFullIncidentLinkedJswIssueNode = Node & {
    __typename?: "GraphStoreFullIncidentLinkedJswIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIncidentLinkedJswIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIncidentLinkedJswIssueEndNode;
};

export type GraphStoreFullIncidentLinkedJswIssueStartNode = {
    __typename?: "GraphStoreFullIncidentLinkedJswIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIncidentLinkedJswIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullIncidentLinkedJswIssueStartUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

export type GraphStoreFullIssueAssociatedBranchConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueAssociatedBranchConnection";
        edges: Array<Maybe<GraphStoreFullIssueAssociatedBranchEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueAssociatedBranchNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-associated-branch */
export type GraphStoreFullIssueAssociatedBranchEdge = {
    __typename?: "GraphStoreFullIssueAssociatedBranchEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedBranchNode;
};

export type GraphStoreFullIssueAssociatedBranchEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedBranchEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedBranchEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-branch: [ExternalBranch] */
export type GraphStoreFullIssueAssociatedBranchEndUnion = ExternalBranch;

/** A node representing a issue-associated-branch relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedBranchNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedBranchNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedBranchStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedBranchEndNode;
};

export type GraphStoreFullIssueAssociatedBranchStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedBranchStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedBranchStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */
export type GraphStoreFullIssueAssociatedBranchStartUnion = JiraIssue;

export enum GraphStoreFullIssueAssociatedBuildBuildStateOutput {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullIssueAssociatedBuildConnection = HasPageInfo & {
    __typename?: "GraphStoreFullIssueAssociatedBuildConnection";
    edges: Array<Maybe<GraphStoreFullIssueAssociatedBuildEdge>>;
    nodes: Array<Maybe<GraphStoreFullIssueAssociatedBuildNode>>;
    pageInfo: PageInfo;
};

/** A full relationship edge for the relationship type issue-associated-build */
export type GraphStoreFullIssueAssociatedBuildEdge = {
    __typename?: "GraphStoreFullIssueAssociatedBuildEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedBuildNode;
};

export type GraphStoreFullIssueAssociatedBuildEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedBuildEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedBuildEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:build, ati:cloud:graph:build] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullIssueAssociatedBuildRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for issue-associated-build: [ExternalBuildInfo] */
export type GraphStoreFullIssueAssociatedBuildEndUnion = ExternalBuildInfo;

/** A node representing a issue-associated-build relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedBuildNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedBuildNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedBuildStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedBuildEndNode;
};

export type GraphStoreFullIssueAssociatedBuildRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullIssueAssociatedBuildRelationshipObjectMetadataOutput";
        state?: Maybe<GraphStoreFullIssueAssociatedBuildBuildStateOutput>;
        testInfo?: Maybe<GraphStoreFullIssueAssociatedBuildTestInfoOutput>;
    };

export type GraphStoreFullIssueAssociatedBuildStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedBuildStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedBuildStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-build: [JiraIssue] */
export type GraphStoreFullIssueAssociatedBuildStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedBuildTestInfoOutput = {
    __typename?: "GraphStoreFullIssueAssociatedBuildTestInfoOutput";
    numberFailed?: Maybe<Scalars["Long"]["output"]>;
    numberPassed?: Maybe<Scalars["Long"]["output"]>;
    numberSkipped?: Maybe<Scalars["Long"]["output"]>;
    totalNumber?: Maybe<Scalars["Long"]["output"]>;
};

export type GraphStoreFullIssueAssociatedCommitConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueAssociatedCommitConnection";
        edges: Array<Maybe<GraphStoreFullIssueAssociatedCommitEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueAssociatedCommitNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-associated-commit */
export type GraphStoreFullIssueAssociatedCommitEdge = {
    __typename?: "GraphStoreFullIssueAssociatedCommitEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedCommitNode;
};

export type GraphStoreFullIssueAssociatedCommitEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedCommitEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedCommitEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-commit: [ExternalCommit] */
export type GraphStoreFullIssueAssociatedCommitEndUnion = ExternalCommit;

/** A node representing a issue-associated-commit relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedCommitNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedCommitNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedCommitStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedCommitEndNode;
};

export type GraphStoreFullIssueAssociatedCommitStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedCommitStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedCommitStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */
export type GraphStoreFullIssueAssociatedCommitStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedDeploymentAuthorOutput = {
    __typename?: "GraphStoreFullIssueAssociatedDeploymentAuthorOutput";
    authorAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullIssueAssociatedDeploymentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueAssociatedDeploymentConnection";
        edges: Array<Maybe<GraphStoreFullIssueAssociatedDeploymentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueAssociatedDeploymentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

export enum GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

/** A full relationship edge for the relationship type issue-associated-deployment */
export type GraphStoreFullIssueAssociatedDeploymentEdge = {
    __typename?: "GraphStoreFullIssueAssociatedDeploymentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedDeploymentNode;
};

export type GraphStoreFullIssueAssociatedDeploymentEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedDeploymentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedDeploymentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullIssueAssociatedDeploymentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreFullIssueAssociatedDeploymentEndUnion =
    | DeploymentSummary
    | ExternalDeployment;

export enum GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

/** A node representing a issue-associated-deployment relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedDeploymentNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedDeploymentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedDeploymentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedDeploymentEndNode;
};

export type GraphStoreFullIssueAssociatedDeploymentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullIssueAssociatedDeploymentRelationshipObjectMetadataOutput";
        author?: Maybe<GraphStoreFullIssueAssociatedDeploymentAuthorOutput>;
        environmentType?: Maybe<GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput>;
        state?: Maybe<GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput>;
    };

export type GraphStoreFullIssueAssociatedDeploymentStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedDeploymentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedDeploymentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */
export type GraphStoreFullIssueAssociatedDeploymentStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedDesignConnection = HasPageInfo & {
    __typename?: "GraphStoreFullIssueAssociatedDesignConnection";
    edges: Array<Maybe<GraphStoreFullIssueAssociatedDesignEdge>>;
    nodes: Array<Maybe<GraphStoreFullIssueAssociatedDesignNode>>;
    pageInfo: PageInfo;
};

export enum GraphStoreFullIssueAssociatedDesignDesignStatusOutput {
    None = "NONE",
    NotSet = "NOT_SET",
    ReadyForDevelopment = "READY_FOR_DEVELOPMENT",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullIssueAssociatedDesignDesignTypeOutput {
    Canvas = "CANVAS",
    File = "FILE",
    Group = "GROUP",
    Node = "NODE",
    NotSet = "NOT_SET",
    Other = "OTHER",
    Prototype = "PROTOTYPE"
}

/** A full relationship edge for the relationship type issue-associated-design */
export type GraphStoreFullIssueAssociatedDesignEdge = {
    __typename?: "GraphStoreFullIssueAssociatedDesignEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedDesignNode;
};

export type GraphStoreFullIssueAssociatedDesignEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedDesignEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedDesignEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:design, ati:cloud:graph:design] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullIssueAssociatedDesignRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for issue-associated-design: [DevOpsDesign, ExternalDesign] */
export type GraphStoreFullIssueAssociatedDesignEndUnion =
    | DevOpsDesign
    | ExternalDesign;

/** A node representing a issue-associated-design relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedDesignNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedDesignNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedDesignStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedDesignEndNode;
};

export type GraphStoreFullIssueAssociatedDesignRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullIssueAssociatedDesignRelationshipObjectMetadataOutput";
        status?: Maybe<GraphStoreFullIssueAssociatedDesignDesignStatusOutput>;
        type?: Maybe<GraphStoreFullIssueAssociatedDesignDesignTypeOutput>;
    };

export type GraphStoreFullIssueAssociatedDesignStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedDesignStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedDesignStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-design: [JiraIssue] */
export type GraphStoreFullIssueAssociatedDesignStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedFeatureFlagConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueAssociatedFeatureFlagConnection";
        edges: Array<Maybe<GraphStoreFullIssueAssociatedFeatureFlagEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueAssociatedFeatureFlagNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-associated-feature-flag */
export type GraphStoreFullIssueAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreFullIssueAssociatedFeatureFlagEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedFeatureFlagNode;
};

export type GraphStoreFullIssueAssociatedFeatureFlagEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedFeatureFlagEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedFeatureFlagEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreFullIssueAssociatedFeatureFlagEndUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A node representing a issue-associated-feature-flag relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedFeatureFlagNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedFeatureFlagNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedFeatureFlagStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedFeatureFlagEndNode;
};

export type GraphStoreFullIssueAssociatedFeatureFlagStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedFeatureFlagStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedFeatureFlagStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */
export type GraphStoreFullIssueAssociatedFeatureFlagStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedIssueRemoteLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullIssueAssociatedIssueRemoteLinkConnection";
        edges: Array<Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkEdge>>;
        nodes: Array<Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkNode>>;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type issue-associated-issue-remote-link */
export type GraphStoreFullIssueAssociatedIssueRemoteLinkEdge = {
    __typename?: "GraphStoreFullIssueAssociatedIssueRemoteLinkEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedIssueRemoteLinkNode;
};

export type GraphStoreFullIssueAssociatedIssueRemoteLinkEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedIssueRemoteLinkEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue-remote-link] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */
export type GraphStoreFullIssueAssociatedIssueRemoteLinkEndUnion =
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssueRemoteIssueLink
    | JiraWebRemoteIssueLink;

export enum GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput {
    Bamboo = "BAMBOO",
    BbPrComment = "BB_PR_COMMENT",
    ConfluencePage = "CONFLUENCE_PAGE",
    Jira = "JIRA",
    NotSet = "NOT_SET",
    Snyk = "SNYK",
    Trello = "TRELLO",
    WebLink = "WEB_LINK"
}

export enum GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput {
    AddedToIdea = "ADDED_TO_IDEA",
    Blocks = "BLOCKS",
    Causes = "CAUSES",
    Clones = "CLONES",
    CreatedFrom = "CREATED_FROM",
    Duplicates = "DUPLICATES",
    Implements = "IMPLEMENTS",
    IsBlockedBy = "IS_BLOCKED_BY",
    IsCausedBy = "IS_CAUSED_BY",
    IsClonedBy = "IS_CLONED_BY",
    IsDuplicatedBy = "IS_DUPLICATED_BY",
    IsIdeaFor = "IS_IDEA_FOR",
    IsImplementedBy = "IS_IMPLEMENTED_BY",
    IsReviewedBy = "IS_REVIEWED_BY",
    MentionedIn = "MENTIONED_IN",
    MergedFrom = "MERGED_FROM",
    MergedInto = "MERGED_INTO",
    NotSet = "NOT_SET",
    RelatesTo = "RELATES_TO",
    Reviews = "REVIEWS",
    SplitFrom = "SPLIT_FROM",
    SplitTo = "SPLIT_TO",
    WikiPage = "WIKI_PAGE"
}

/** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedIssueRemoteLinkNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedIssueRemoteLinkNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedIssueRemoteLinkStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedIssueRemoteLinkEndNode;
};

export type GraphStoreFullIssueAssociatedIssueRemoteLinkRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullIssueAssociatedIssueRemoteLinkRelationshipObjectMetadataOutput";
        applicationType?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput>;
        relationship?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput>;
    };

export type GraphStoreFullIssueAssociatedIssueRemoteLinkStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedIssueRemoteLinkStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedIssueRemoteLinkStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */
export type GraphStoreFullIssueAssociatedIssueRemoteLinkStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedPrAuthorOutput = {
    __typename?: "GraphStoreFullIssueAssociatedPrAuthorOutput";
    authorAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullIssueAssociatedPrConnection = HasPageInfo & {
    __typename?: "GraphStoreFullIssueAssociatedPrConnection";
    edges: Array<Maybe<GraphStoreFullIssueAssociatedPrEdge>>;
    nodes: Array<Maybe<GraphStoreFullIssueAssociatedPrNode>>;
    pageInfo: PageInfo;
};

/** A full relationship edge for the relationship type issue-associated-pr */
export type GraphStoreFullIssueAssociatedPrEdge = {
    __typename?: "GraphStoreFullIssueAssociatedPrEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedPrNode;
};

export type GraphStoreFullIssueAssociatedPrEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedPrEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedPrEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullIssueAssociatedPrRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreFullIssueAssociatedPrEndUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A node representing a issue-associated-pr relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedPrNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedPrNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedPrStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedPrEndNode;
};

export enum GraphStoreFullIssueAssociatedPrPullRequestStatusOutput {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullIssueAssociatedPrRelationshipObjectMetadataOutput = {
    __typename?: "GraphStoreFullIssueAssociatedPrRelationshipObjectMetadataOutput";
    author?: Maybe<GraphStoreFullIssueAssociatedPrAuthorOutput>;
    reviewers?: Maybe<GraphStoreFullIssueAssociatedPrReviewerOutput>;
    status?: Maybe<GraphStoreFullIssueAssociatedPrPullRequestStatusOutput>;
    taskCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphStoreFullIssueAssociatedPrReviewerOutput = {
    __typename?: "GraphStoreFullIssueAssociatedPrReviewerOutput";
    approvalStatus?: Maybe<GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput>;
    reviewerAri?: Maybe<Scalars["String"]["output"]>;
};

export enum GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphStoreFullIssueAssociatedPrStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedPrStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedPrStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */
export type GraphStoreFullIssueAssociatedPrStartUnion = JiraIssue;

export type GraphStoreFullIssueAssociatedRemoteLinkConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueAssociatedRemoteLinkConnection";
        edges: Array<Maybe<GraphStoreFullIssueAssociatedRemoteLinkEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueAssociatedRemoteLinkNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-associated-remote-link */
export type GraphStoreFullIssueAssociatedRemoteLinkEdge = {
    __typename?: "GraphStoreFullIssueAssociatedRemoteLinkEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueAssociatedRemoteLinkNode;
};

export type GraphStoreFullIssueAssociatedRemoteLinkEndNode = {
    __typename?: "GraphStoreFullIssueAssociatedRemoteLinkEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedRemoteLinkEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-remote-link: [ExternalRemoteLink] */
export type GraphStoreFullIssueAssociatedRemoteLinkEndUnion =
    ExternalRemoteLink;

/** A node representing a issue-associated-remote-link relationship, with all metadata (if available) */
export type GraphStoreFullIssueAssociatedRemoteLinkNode = Node & {
    __typename?: "GraphStoreFullIssueAssociatedRemoteLinkNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueAssociatedRemoteLinkStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueAssociatedRemoteLinkEndNode;
};

export type GraphStoreFullIssueAssociatedRemoteLinkStartNode = {
    __typename?: "GraphStoreFullIssueAssociatedRemoteLinkStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueAssociatedRemoteLinkStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */
export type GraphStoreFullIssueAssociatedRemoteLinkStartUnion = JiraIssue;

export type GraphStoreFullIssueChangesComponentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueChangesComponentConnection";
        edges: Array<Maybe<GraphStoreFullIssueChangesComponentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueChangesComponentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-changes-component */
export type GraphStoreFullIssueChangesComponentEdge = {
    __typename?: "GraphStoreFullIssueChangesComponentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueChangesComponentNode;
};

export type GraphStoreFullIssueChangesComponentEndNode = {
    __typename?: "GraphStoreFullIssueChangesComponentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueChangesComponentEndUnion>;
    /** An ARI of type(s) [ati:cloud:compass:component] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-changes-component: [CompassComponent] */
export type GraphStoreFullIssueChangesComponentEndUnion = CompassComponent;

/** A node representing a issue-changes-component relationship, with all metadata (if available) */
export type GraphStoreFullIssueChangesComponentNode = Node & {
    __typename?: "GraphStoreFullIssueChangesComponentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueChangesComponentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueChangesComponentEndNode;
};

export type GraphStoreFullIssueChangesComponentStartNode = {
    __typename?: "GraphStoreFullIssueChangesComponentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueChangesComponentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-changes-component: [JiraIssue] */
export type GraphStoreFullIssueChangesComponentStartUnion = JiraIssue;

export type GraphStoreFullIssueRecursiveAssociatedPrConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueRecursiveAssociatedPrConnection";
        edges: Array<Maybe<GraphStoreFullIssueRecursiveAssociatedPrEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueRecursiveAssociatedPrNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-recursive-associated-pr */
export type GraphStoreFullIssueRecursiveAssociatedPrEdge = {
    __typename?: "GraphStoreFullIssueRecursiveAssociatedPrEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueRecursiveAssociatedPrNode;
};

export type GraphStoreFullIssueRecursiveAssociatedPrEndNode = {
    __typename?: "GraphStoreFullIssueRecursiveAssociatedPrEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueRecursiveAssociatedPrEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreFullIssueRecursiveAssociatedPrEndUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A node representing a issue-recursive-associated-pr relationship, with all metadata (if available) */
export type GraphStoreFullIssueRecursiveAssociatedPrNode = Node & {
    __typename?: "GraphStoreFullIssueRecursiveAssociatedPrNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueRecursiveAssociatedPrStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueRecursiveAssociatedPrEndNode;
};

export type GraphStoreFullIssueRecursiveAssociatedPrStartNode = {
    __typename?: "GraphStoreFullIssueRecursiveAssociatedPrStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueRecursiveAssociatedPrStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */
export type GraphStoreFullIssueRecursiveAssociatedPrStartUnion = JiraIssue;

export type GraphStoreFullIssueToWhiteboardConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullIssueToWhiteboardConnection";
        edges: Array<Maybe<GraphStoreFullIssueToWhiteboardEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullIssueToWhiteboardNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type issue-to-whiteboard */
export type GraphStoreFullIssueToWhiteboardEdge = {
    __typename?: "GraphStoreFullIssueToWhiteboardEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullIssueToWhiteboardNode;
};

export type GraphStoreFullIssueToWhiteboardEndNode = {
    __typename?: "GraphStoreFullIssueToWhiteboardEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueToWhiteboardEndUnion>;
    /** An ARI of type(s) [ati:cloud:confluence:whiteboard] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreFullIssueToWhiteboardEndUnion = ConfluenceWhiteboard;

/** A node representing a issue-to-whiteboard relationship, with all metadata (if available) */
export type GraphStoreFullIssueToWhiteboardNode = Node & {
    __typename?: "GraphStoreFullIssueToWhiteboardNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullIssueToWhiteboardStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullIssueToWhiteboardEndNode;
};

export type GraphStoreFullIssueToWhiteboardStartNode = {
    __typename?: "GraphStoreFullIssueToWhiteboardStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullIssueToWhiteboardStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */
export type GraphStoreFullIssueToWhiteboardStartUnion = JiraIssue;

export type GraphStoreFullJiraEpicContributesToAtlasGoalConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullJiraEpicContributesToAtlasGoalConnection";
        edges: Array<Maybe<GraphStoreFullJiraEpicContributesToAtlasGoalEdge>>;
        nodes: Array<Maybe<GraphStoreFullJiraEpicContributesToAtlasGoalNode>>;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type jira-epic-contributes-to-atlas-goal */
export type GraphStoreFullJiraEpicContributesToAtlasGoalEdge = {
    __typename?: "GraphStoreFullJiraEpicContributesToAtlasGoalEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullJiraEpicContributesToAtlasGoalNode;
};

export type GraphStoreFullJiraEpicContributesToAtlasGoalEndNode = {
    __typename?: "GraphStoreFullJiraEpicContributesToAtlasGoalEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJiraEpicContributesToAtlasGoalEndUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:goal] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */
export type GraphStoreFullJiraEpicContributesToAtlasGoalEndUnion =
    TownsquareGoal;

/** A node representing a jira-epic-contributes-to-atlas-goal relationship, with all metadata (if available) */
export type GraphStoreFullJiraEpicContributesToAtlasGoalNode = Node & {
    __typename?: "GraphStoreFullJiraEpicContributesToAtlasGoalNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullJiraEpicContributesToAtlasGoalStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullJiraEpicContributesToAtlasGoalEndNode;
};

export type GraphStoreFullJiraEpicContributesToAtlasGoalStartNode = {
    __typename?: "GraphStoreFullJiraEpicContributesToAtlasGoalStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJiraEpicContributesToAtlasGoalStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */
export type GraphStoreFullJiraEpicContributesToAtlasGoalStartUnion = JiraIssue;

export type GraphStoreFullJiraProjectAssociatedAtlasGoalConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullJiraProjectAssociatedAtlasGoalConnection";
            edges: Array<
                Maybe<GraphStoreFullJiraProjectAssociatedAtlasGoalEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullJiraProjectAssociatedAtlasGoalNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type jira-project-associated-atlas-goal */
export type GraphStoreFullJiraProjectAssociatedAtlasGoalEdge = {
    __typename?: "GraphStoreFullJiraProjectAssociatedAtlasGoalEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullJiraProjectAssociatedAtlasGoalNode;
};

export type GraphStoreFullJiraProjectAssociatedAtlasGoalEndNode = {
    __typename?: "GraphStoreFullJiraProjectAssociatedAtlasGoalEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJiraProjectAssociatedAtlasGoalEndUnion>;
    /** An ARI of type(s) [ati:cloud:townsquare:goal] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */
export type GraphStoreFullJiraProjectAssociatedAtlasGoalEndUnion =
    TownsquareGoal;

/** A node representing a jira-project-associated-atlas-goal relationship, with all metadata (if available) */
export type GraphStoreFullJiraProjectAssociatedAtlasGoalNode = Node & {
    __typename?: "GraphStoreFullJiraProjectAssociatedAtlasGoalNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullJiraProjectAssociatedAtlasGoalStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullJiraProjectAssociatedAtlasGoalEndNode;
};

export type GraphStoreFullJiraProjectAssociatedAtlasGoalStartNode = {
    __typename?: "GraphStoreFullJiraProjectAssociatedAtlasGoalStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJiraProjectAssociatedAtlasGoalStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */
export type GraphStoreFullJiraProjectAssociatedAtlasGoalStartUnion =
    JiraProject;

export type GraphStoreFullJsmProjectAssociatedServiceConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullJsmProjectAssociatedServiceConnection";
        edges: Array<Maybe<GraphStoreFullJsmProjectAssociatedServiceEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullJsmProjectAssociatedServiceNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type jsm-project-associated-service */
export type GraphStoreFullJsmProjectAssociatedServiceEdge = {
    __typename?: "GraphStoreFullJsmProjectAssociatedServiceEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullJsmProjectAssociatedServiceNode;
};

export type GraphStoreFullJsmProjectAssociatedServiceEndNode = {
    __typename?: "GraphStoreFullJsmProjectAssociatedServiceEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJsmProjectAssociatedServiceEndUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */
export type GraphStoreFullJsmProjectAssociatedServiceEndUnion = DevOpsService;

/** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */
export type GraphStoreFullJsmProjectAssociatedServiceNode = Node & {
    __typename?: "GraphStoreFullJsmProjectAssociatedServiceNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullJsmProjectAssociatedServiceStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullJsmProjectAssociatedServiceEndNode;
};

export type GraphStoreFullJsmProjectAssociatedServiceStartNode = {
    __typename?: "GraphStoreFullJsmProjectAssociatedServiceStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJsmProjectAssociatedServiceStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */
export type GraphStoreFullJsmProjectAssociatedServiceStartUnion = JiraProject;

export type GraphStoreFullJswProjectAssociatedComponentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullJswProjectAssociatedComponentConnection";
            edges: Array<
                Maybe<GraphStoreFullJswProjectAssociatedComponentEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullJswProjectAssociatedComponentNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type jsw-project-associated-component */
export type GraphStoreFullJswProjectAssociatedComponentEdge = {
    __typename?: "GraphStoreFullJswProjectAssociatedComponentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullJswProjectAssociatedComponentNode;
};

export type GraphStoreFullJswProjectAssociatedComponentEndNode = {
    __typename?: "GraphStoreFullJswProjectAssociatedComponentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJswProjectAssociatedComponentEndUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */
export type GraphStoreFullJswProjectAssociatedComponentEndUnion =
    | CompassComponent
    | DevOpsOperationsComponentDetails
    | DevOpsService;

/** A node representing a jsw-project-associated-component relationship, with all metadata (if available) */
export type GraphStoreFullJswProjectAssociatedComponentNode = Node & {
    __typename?: "GraphStoreFullJswProjectAssociatedComponentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullJswProjectAssociatedComponentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullJswProjectAssociatedComponentEndNode;
};

export type GraphStoreFullJswProjectAssociatedComponentStartNode = {
    __typename?: "GraphStoreFullJswProjectAssociatedComponentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJswProjectAssociatedComponentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */
export type GraphStoreFullJswProjectAssociatedComponentStartUnion = JiraProject;

export type GraphStoreFullJswProjectAssociatedIncidentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullJswProjectAssociatedIncidentConnection";
        edges: Array<Maybe<GraphStoreFullJswProjectAssociatedIncidentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullJswProjectAssociatedIncidentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type jsw-project-associated-incident */
export type GraphStoreFullJswProjectAssociatedIncidentEdge = {
    __typename?: "GraphStoreFullJswProjectAssociatedIncidentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullJswProjectAssociatedIncidentNode;
};

export type GraphStoreFullJswProjectAssociatedIncidentEndNode = {
    __typename?: "GraphStoreFullJswProjectAssociatedIncidentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJswProjectAssociatedIncidentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullJswProjectAssociatedIncidentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullJswProjectAssociatedIncidentEndUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

export enum GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5",
    Pending = "PENDING",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    NotSet = "NOT_SET",
    Undefined = "UNDEFINED"
}

/** A node representing a jsw-project-associated-incident relationship, with all metadata (if available) */
export type GraphStoreFullJswProjectAssociatedIncidentNode = Node & {
    __typename?: "GraphStoreFullJswProjectAssociatedIncidentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullJswProjectAssociatedIncidentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullJswProjectAssociatedIncidentEndNode;
};

export type GraphStoreFullJswProjectAssociatedIncidentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullJswProjectAssociatedIncidentRelationshipObjectMetadataOutput";
        affectedServiceAris?: Maybe<Scalars["String"]["output"]>;
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        majorIncident?: Maybe<Scalars["Boolean"]["output"]>;
        priority?: Maybe<GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput>;
        reporterAri?: Maybe<Scalars["String"]["output"]>;
        status?: Maybe<GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput>;
    };

export type GraphStoreFullJswProjectAssociatedIncidentStartNode = {
    __typename?: "GraphStoreFullJswProjectAssociatedIncidentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJswProjectAssociatedIncidentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */
export type GraphStoreFullJswProjectAssociatedIncidentStartUnion = JiraProject;

export type GraphStoreFullJswProjectSharesComponentWithJsmProjectConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullJswProjectSharesComponentWithJsmProjectConnection";
            edges: Array<
                Maybe<GraphStoreFullJswProjectSharesComponentWithJsmProjectEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullJswProjectSharesComponentWithJsmProjectNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type jsw-project-shares-component-with-jsm-project */
export type GraphStoreFullJswProjectSharesComponentWithJsmProjectEdge = {
    __typename?: "GraphStoreFullJswProjectSharesComponentWithJsmProjectEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullJswProjectSharesComponentWithJsmProjectNode;
};

export type GraphStoreFullJswProjectSharesComponentWithJsmProjectEndNode = {
    __typename?: "GraphStoreFullJswProjectSharesComponentWithJsmProjectEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJswProjectSharesComponentWithJsmProjectEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */
export type GraphStoreFullJswProjectSharesComponentWithJsmProjectEndUnion =
    JiraProject;

/** A node representing a jsw-project-shares-component-with-jsm-project relationship, with all metadata (if available) */
export type GraphStoreFullJswProjectSharesComponentWithJsmProjectNode = Node & {
    __typename?: "GraphStoreFullJswProjectSharesComponentWithJsmProjectNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullJswProjectSharesComponentWithJsmProjectStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullJswProjectSharesComponentWithJsmProjectEndNode;
};

export type GraphStoreFullJswProjectSharesComponentWithJsmProjectStartNode = {
    __typename?: "GraphStoreFullJswProjectSharesComponentWithJsmProjectStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullJswProjectSharesComponentWithJsmProjectStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */
export type GraphStoreFullJswProjectSharesComponentWithJsmProjectStartUnion =
    JiraProject;

export type GraphStoreFullLinkedProjectHasVersionConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullLinkedProjectHasVersionConnection";
        edges: Array<Maybe<GraphStoreFullLinkedProjectHasVersionEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullLinkedProjectHasVersionNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type linked-project-has-version */
export type GraphStoreFullLinkedProjectHasVersionEdge = {
    __typename?: "GraphStoreFullLinkedProjectHasVersionEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullLinkedProjectHasVersionNode;
};

export type GraphStoreFullLinkedProjectHasVersionEndNode = {
    __typename?: "GraphStoreFullLinkedProjectHasVersionEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullLinkedProjectHasVersionEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */
export type GraphStoreFullLinkedProjectHasVersionEndUnion = JiraVersion;

/** A node representing a linked-project-has-version relationship, with all metadata (if available) */
export type GraphStoreFullLinkedProjectHasVersionNode = Node & {
    __typename?: "GraphStoreFullLinkedProjectHasVersionNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullLinkedProjectHasVersionStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullLinkedProjectHasVersionEndNode;
};

export type GraphStoreFullLinkedProjectHasVersionStartNode = {
    __typename?: "GraphStoreFullLinkedProjectHasVersionStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullLinkedProjectHasVersionStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for linked-project-has-version: [JiraProject] */
export type GraphStoreFullLinkedProjectHasVersionStartUnion = JiraProject;

export type GraphStoreFullOperationsContainerImpactedByIncidentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullOperationsContainerImpactedByIncidentConnection";
        edges: Array<
            Maybe<GraphStoreFullOperationsContainerImpactedByIncidentEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreFullOperationsContainerImpactedByIncidentNode>
        >;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type operations-container-impacted-by-incident */
export type GraphStoreFullOperationsContainerImpactedByIncidentEdge = {
    __typename?: "GraphStoreFullOperationsContainerImpactedByIncidentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullOperationsContainerImpactedByIncidentNode;
};

export type GraphStoreFullOperationsContainerImpactedByIncidentEndNode = {
    __typename?: "GraphStoreFullOperationsContainerImpactedByIncidentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullOperationsContainerImpactedByIncidentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullOperationsContainerImpactedByIncidentEndUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A node representing a operations-container-impacted-by-incident relationship, with all metadata (if available) */
export type GraphStoreFullOperationsContainerImpactedByIncidentNode = Node & {
    __typename?: "GraphStoreFullOperationsContainerImpactedByIncidentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullOperationsContainerImpactedByIncidentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullOperationsContainerImpactedByIncidentEndNode;
};

export type GraphStoreFullOperationsContainerImpactedByIncidentStartNode = {
    __typename?: "GraphStoreFullOperationsContainerImpactedByIncidentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullOperationsContainerImpactedByIncidentStartUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */
export type GraphStoreFullOperationsContainerImpactedByIncidentStartUnion =
    DevOpsService;

export type GraphStoreFullOperationsContainerImprovedByActionItemConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullOperationsContainerImprovedByActionItemConnection";
        edges: Array<
            Maybe<GraphStoreFullOperationsContainerImprovedByActionItemEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreFullOperationsContainerImprovedByActionItemNode>
        >;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type operations-container-improved-by-action-item */
export type GraphStoreFullOperationsContainerImprovedByActionItemEdge = {
    __typename?: "GraphStoreFullOperationsContainerImprovedByActionItemEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullOperationsContainerImprovedByActionItemNode;
};

export type GraphStoreFullOperationsContainerImprovedByActionItemEndNode = {
    __typename?: "GraphStoreFullOperationsContainerImprovedByActionItemEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullOperationsContainerImprovedByActionItemEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */
export type GraphStoreFullOperationsContainerImprovedByActionItemEndUnion =
    JiraIssue;

/** A node representing a operations-container-improved-by-action-item relationship, with all metadata (if available) */
export type GraphStoreFullOperationsContainerImprovedByActionItemNode = Node & {
    __typename?: "GraphStoreFullOperationsContainerImprovedByActionItemNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullOperationsContainerImprovedByActionItemStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullOperationsContainerImprovedByActionItemEndNode;
};

export type GraphStoreFullOperationsContainerImprovedByActionItemStartNode = {
    __typename?: "GraphStoreFullOperationsContainerImprovedByActionItemStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullOperationsContainerImprovedByActionItemStartUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */
export type GraphStoreFullOperationsContainerImprovedByActionItemStartUnion =
    DevOpsService;

export enum GraphStoreFullParentDocumentHasChildDocumentCategoryOutput {
    Archive = "ARCHIVE",
    Audio = "AUDIO",
    Code = "CODE",
    Document = "DOCUMENT",
    Folder = "FOLDER",
    Form = "FORM",
    Image = "IMAGE",
    NotSet = "NOT_SET",
    Other = "OTHER",
    Pdf = "PDF",
    Presentation = "PRESENTATION",
    Shortcut = "SHORTCUT",
    Spreadsheet = "SPREADSHEET",
    Video = "VIDEO"
}

export type GraphStoreFullParentDocumentHasChildDocumentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullParentDocumentHasChildDocumentConnection";
        edges: Array<Maybe<GraphStoreFullParentDocumentHasChildDocumentEdge>>;
        nodes: Array<Maybe<GraphStoreFullParentDocumentHasChildDocumentNode>>;
        pageInfo: PageInfo;
    };

/** A full relationship edge for the relationship type parent-document-has-child-document */
export type GraphStoreFullParentDocumentHasChildDocumentEdge = {
    __typename?: "GraphStoreFullParentDocumentHasChildDocumentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullParentDocumentHasChildDocumentNode;
};

export type GraphStoreFullParentDocumentHasChildDocumentEndNode = {
    __typename?: "GraphStoreFullParentDocumentHasChildDocumentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullParentDocumentHasChildDocumentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:document, ati:cloud:graph:document] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullParentDocumentHasChildDocumentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreFullParentDocumentHasChildDocumentEndUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A node representing a parent-document-has-child-document relationship, with all metadata (if available) */
export type GraphStoreFullParentDocumentHasChildDocumentNode = Node & {
    __typename?: "GraphStoreFullParentDocumentHasChildDocumentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullParentDocumentHasChildDocumentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullParentDocumentHasChildDocumentEndNode;
};

export type GraphStoreFullParentDocumentHasChildDocumentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullParentDocumentHasChildDocumentRelationshipObjectMetadataOutput";
        byteSize?: Maybe<Scalars["Long"]["output"]>;
        category?: Maybe<GraphStoreFullParentDocumentHasChildDocumentCategoryOutput>;
    };

export type GraphStoreFullParentDocumentHasChildDocumentRelationshipSubjectMetadataOutput =
    {
        __typename?: "GraphStoreFullParentDocumentHasChildDocumentRelationshipSubjectMetadataOutput";
        byteSize?: Maybe<Scalars["Long"]["output"]>;
        category?: Maybe<GraphStoreFullParentDocumentHasChildDocumentCategoryOutput>;
    };

export type GraphStoreFullParentDocumentHasChildDocumentStartNode = {
    __typename?: "GraphStoreFullParentDocumentHasChildDocumentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullParentDocumentHasChildDocumentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:document, ati:cloud:graph:document] */
    id: Scalars["ID"]["output"];
    /** The metadata for FROM field */
    metadata?: Maybe<GraphStoreFullParentDocumentHasChildDocumentRelationshipSubjectMetadataOutput>;
};

/** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreFullParentDocumentHasChildDocumentStartUnion =
    | DevOpsDocument
    | ExternalDocument;

export type GraphStoreFullParentIssueHasChildIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreFullParentIssueHasChildIssueConnection";
    edges: Array<Maybe<GraphStoreFullParentIssueHasChildIssueEdge>>;
    nodes: Array<Maybe<GraphStoreFullParentIssueHasChildIssueNode>>;
    pageInfo: PageInfo;
};

/** A full relationship edge for the relationship type parent-issue-has-child-issue */
export type GraphStoreFullParentIssueHasChildIssueEdge = {
    __typename?: "GraphStoreFullParentIssueHasChildIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullParentIssueHasChildIssueNode;
};

export type GraphStoreFullParentIssueHasChildIssueEndNode = {
    __typename?: "GraphStoreFullParentIssueHasChildIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullParentIssueHasChildIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */
export type GraphStoreFullParentIssueHasChildIssueEndUnion = JiraIssue;

/** A node representing a parent-issue-has-child-issue relationship, with all metadata (if available) */
export type GraphStoreFullParentIssueHasChildIssueNode = Node & {
    __typename?: "GraphStoreFullParentIssueHasChildIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullParentIssueHasChildIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullParentIssueHasChildIssueEndNode;
};

export type GraphStoreFullParentIssueHasChildIssueStartNode = {
    __typename?: "GraphStoreFullParentIssueHasChildIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullParentIssueHasChildIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */
export type GraphStoreFullParentIssueHasChildIssueStartUnion = JiraIssue;

export type GraphStoreFullPrInRepoConnection = HasPageInfo & {
    __typename?: "GraphStoreFullPrInRepoConnection";
    edges: Array<Maybe<GraphStoreFullPrInRepoEdge>>;
    nodes: Array<Maybe<GraphStoreFullPrInRepoNode>>;
    pageInfo: PageInfo;
};

/** A full relationship edge for the relationship type pr-in-repo */
export type GraphStoreFullPrInRepoEdge = {
    __typename?: "GraphStoreFullPrInRepoEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullPrInRepoNode;
};

export type GraphStoreFullPrInRepoEndNode = {
    __typename?: "GraphStoreFullPrInRepoEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullPrInRepoEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullPrInRepoRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for pr-in-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreFullPrInRepoEndUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A node representing a pr-in-repo relationship, with all metadata (if available) */
export type GraphStoreFullPrInRepoNode = Node & {
    __typename?: "GraphStoreFullPrInRepoNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullPrInRepoStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullPrInRepoEndNode;
};

export type GraphStoreFullPrInRepoRelationshipObjectMetadataOutput = {
    __typename?: "GraphStoreFullPrInRepoRelationshipObjectMetadataOutput";
    providerAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullPrInRepoStartNode = {
    __typename?: "GraphStoreFullPrInRepoStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullPrInRepoStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreFullPrInRepoStartUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

export type GraphStoreFullProjectAssociatedBranchConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedBranchConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedBranchEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedBranchNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-branch */
export type GraphStoreFullProjectAssociatedBranchEdge = {
    __typename?: "GraphStoreFullProjectAssociatedBranchEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedBranchNode;
};

export type GraphStoreFullProjectAssociatedBranchEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedBranchEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedBranchEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-branch: [ExternalBranch] */
export type GraphStoreFullProjectAssociatedBranchEndUnion = ExternalBranch;

/** A node representing a project-associated-branch relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedBranchNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedBranchNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedBranchStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedBranchEndNode;
};

export type GraphStoreFullProjectAssociatedBranchStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedBranchStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedBranchStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-branch: [JiraProject] */
export type GraphStoreFullProjectAssociatedBranchStartUnion = JiraProject;

export enum GraphStoreFullProjectAssociatedBuildBuildStateOutput {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullProjectAssociatedBuildConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedBuildConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedBuildEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedBuildNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-build */
export type GraphStoreFullProjectAssociatedBuildEdge = {
    __typename?: "GraphStoreFullProjectAssociatedBuildEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedBuildNode;
};

export type GraphStoreFullProjectAssociatedBuildEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedBuildEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedBuildEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:build, ati:cloud:graph:build] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectAssociatedBuildRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-associated-build: [ExternalBuildInfo] */
export type GraphStoreFullProjectAssociatedBuildEndUnion = ExternalBuildInfo;

/** A node representing a project-associated-build relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedBuildNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedBuildNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedBuildStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullProjectAssociatedBuildRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedBuildEndNode;
};

export type GraphStoreFullProjectAssociatedBuildRelationshipMetadataOutput = {
    __typename?: "GraphStoreFullProjectAssociatedBuildRelationshipMetadataOutput";
    assigneeAri?: Maybe<Scalars["String"]["output"]>;
    creatorAri?: Maybe<Scalars["String"]["output"]>;
    issueAri?: Maybe<Scalars["String"]["output"]>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<Scalars["String"]["output"]>;
    sprintAris?: Maybe<Scalars["String"]["output"]>;
    statusAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullProjectAssociatedBuildRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectAssociatedBuildRelationshipObjectMetadataOutput";
        state?: Maybe<GraphStoreFullProjectAssociatedBuildBuildStateOutput>;
        testInfo?: Maybe<GraphStoreFullProjectAssociatedBuildTestInfoOutput>;
    };

export type GraphStoreFullProjectAssociatedBuildStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedBuildStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedBuildStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-build: [JiraProject] */
export type GraphStoreFullProjectAssociatedBuildStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedBuildTestInfoOutput = {
    __typename?: "GraphStoreFullProjectAssociatedBuildTestInfoOutput";
    numberFailed?: Maybe<Scalars["Long"]["output"]>;
    numberPassed?: Maybe<Scalars["Long"]["output"]>;
    numberSkipped?: Maybe<Scalars["Long"]["output"]>;
    totalNumber?: Maybe<Scalars["Long"]["output"]>;
};

export type GraphStoreFullProjectAssociatedDeploymentAuthorOutput = {
    __typename?: "GraphStoreFullProjectAssociatedDeploymentAuthorOutput";
    authorAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullProjectAssociatedDeploymentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedDeploymentConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedDeploymentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedDeploymentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

export enum GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

/** A full relationship edge for the relationship type project-associated-deployment */
export type GraphStoreFullProjectAssociatedDeploymentEdge = {
    __typename?: "GraphStoreFullProjectAssociatedDeploymentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedDeploymentNode;
};

export type GraphStoreFullProjectAssociatedDeploymentEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedDeploymentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedDeploymentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectAssociatedDeploymentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreFullProjectAssociatedDeploymentEndUnion =
    | DeploymentSummary
    | ExternalDeployment;

export enum GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

/** A node representing a project-associated-deployment relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedDeploymentNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedDeploymentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedDeploymentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullProjectAssociatedDeploymentRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedDeploymentEndNode;
};

export type GraphStoreFullProjectAssociatedDeploymentRelationshipMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectAssociatedDeploymentRelationshipMetadataOutput";
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        creatorAri?: Maybe<Scalars["String"]["output"]>;
        fixVersionIds?: Maybe<Scalars["Long"]["output"]>;
        issueAri?: Maybe<Scalars["String"]["output"]>;
        issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
        issueTypeAri?: Maybe<Scalars["String"]["output"]>;
        reporterAri?: Maybe<Scalars["String"]["output"]>;
        sprintAris?: Maybe<Scalars["String"]["output"]>;
        statusAri?: Maybe<Scalars["String"]["output"]>;
    };

export type GraphStoreFullProjectAssociatedDeploymentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectAssociatedDeploymentRelationshipObjectMetadataOutput";
        author?: Maybe<GraphStoreFullProjectAssociatedDeploymentAuthorOutput>;
        deploymentLastUpdated?: Maybe<Scalars["Long"]["output"]>;
        environmentType?: Maybe<GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput>;
        state?: Maybe<GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput>;
    };

export type GraphStoreFullProjectAssociatedDeploymentStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedDeploymentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedDeploymentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-deployment: [JiraProject] */
export type GraphStoreFullProjectAssociatedDeploymentStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedFeatureFlagConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedFeatureFlagConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedFeatureFlagEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedFeatureFlagNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-feature-flag */
export type GraphStoreFullProjectAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreFullProjectAssociatedFeatureFlagEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedFeatureFlagNode;
};

export type GraphStoreFullProjectAssociatedFeatureFlagEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedFeatureFlagEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedFeatureFlagEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreFullProjectAssociatedFeatureFlagEndUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A node representing a project-associated-feature-flag relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedFeatureFlagNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedFeatureFlagNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedFeatureFlagStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedFeatureFlagEndNode;
};

export type GraphStoreFullProjectAssociatedFeatureFlagStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedFeatureFlagStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedFeatureFlagStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */
export type GraphStoreFullProjectAssociatedFeatureFlagStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedIncidentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedIncidentConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedIncidentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedIncidentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-incident */
export type GraphStoreFullProjectAssociatedIncidentEdge = {
    __typename?: "GraphStoreFullProjectAssociatedIncidentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedIncidentNode;
};

export type GraphStoreFullProjectAssociatedIncidentEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedIncidentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedIncidentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-incident: [JiraIssue] */
export type GraphStoreFullProjectAssociatedIncidentEndUnion = JiraIssue;

/** A node representing a project-associated-incident relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedIncidentNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedIncidentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedIncidentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedIncidentEndNode;
};

export type GraphStoreFullProjectAssociatedIncidentStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedIncidentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedIncidentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-incident: [JiraProject] */
export type GraphStoreFullProjectAssociatedIncidentStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedOpsgenieTeamConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullProjectAssociatedOpsgenieTeamConnection";
            edges: Array<
                Maybe<GraphStoreFullProjectAssociatedOpsgenieTeamEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullProjectAssociatedOpsgenieTeamNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type project-associated-opsgenie-team */
export type GraphStoreFullProjectAssociatedOpsgenieTeamEdge = {
    __typename?: "GraphStoreFullProjectAssociatedOpsgenieTeamEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedOpsgenieTeamNode;
};

export type GraphStoreFullProjectAssociatedOpsgenieTeamEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedOpsgenieTeamEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedOpsgenieTeamEndUnion>;
    /** An ARI of type(s) [ati:cloud:opsgenie:team] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */
export type GraphStoreFullProjectAssociatedOpsgenieTeamEndUnion = OpsgenieTeam;

/** A node representing a project-associated-opsgenie-team relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedOpsgenieTeamNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedOpsgenieTeamNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedOpsgenieTeamStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedOpsgenieTeamEndNode;
};

export type GraphStoreFullProjectAssociatedOpsgenieTeamStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedOpsgenieTeamStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedOpsgenieTeamStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */
export type GraphStoreFullProjectAssociatedOpsgenieTeamStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedPrAuthorOutput = {
    __typename?: "GraphStoreFullProjectAssociatedPrAuthorOutput";
    authorAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullProjectAssociatedPrConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedPrConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedPrEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedPrNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-pr */
export type GraphStoreFullProjectAssociatedPrEdge = {
    __typename?: "GraphStoreFullProjectAssociatedPrEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedPrNode;
};

export type GraphStoreFullProjectAssociatedPrEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedPrEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedPrEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectAssociatedPrRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreFullProjectAssociatedPrEndUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A node representing a project-associated-pr relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedPrNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedPrNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedPrStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullProjectAssociatedPrRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedPrEndNode;
};

export enum GraphStoreFullProjectAssociatedPrPullRequestStatusOutput {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullProjectAssociatedPrRelationshipMetadataOutput = {
    __typename?: "GraphStoreFullProjectAssociatedPrRelationshipMetadataOutput";
    assigneeAri?: Maybe<Scalars["String"]["output"]>;
    creatorAri?: Maybe<Scalars["String"]["output"]>;
    issueAri?: Maybe<Scalars["String"]["output"]>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<Scalars["String"]["output"]>;
    sprintAris?: Maybe<Scalars["String"]["output"]>;
    statusAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullProjectAssociatedPrRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectAssociatedPrRelationshipObjectMetadataOutput";
        author?: Maybe<GraphStoreFullProjectAssociatedPrAuthorOutput>;
        reviewers?: Maybe<GraphStoreFullProjectAssociatedPrReviewerOutput>;
        status?: Maybe<GraphStoreFullProjectAssociatedPrPullRequestStatusOutput>;
        taskCount?: Maybe<Scalars["Int"]["output"]>;
    };

export type GraphStoreFullProjectAssociatedPrReviewerOutput = {
    __typename?: "GraphStoreFullProjectAssociatedPrReviewerOutput";
    approvalStatus?: Maybe<GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput>;
    reviewerAri?: Maybe<Scalars["String"]["output"]>;
};

export enum GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphStoreFullProjectAssociatedPrStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedPrStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedPrStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-pr: [JiraProject] */
export type GraphStoreFullProjectAssociatedPrStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedRepoConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedRepoConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedRepoEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedRepoNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-repo */
export type GraphStoreFullProjectAssociatedRepoEdge = {
    __typename?: "GraphStoreFullProjectAssociatedRepoEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedRepoNode;
};

export type GraphStoreFullProjectAssociatedRepoEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedRepoEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedRepoEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectAssociatedRepoRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-associated-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreFullProjectAssociatedRepoEndUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A node representing a project-associated-repo relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedRepoNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedRepoNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedRepoStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedRepoEndNode;
};

export type GraphStoreFullProjectAssociatedRepoRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectAssociatedRepoRelationshipObjectMetadataOutput";
        providerAri?: Maybe<Scalars["String"]["output"]>;
    };

export type GraphStoreFullProjectAssociatedRepoStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedRepoStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedRepoStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-repo: [JiraProject] */
export type GraphStoreFullProjectAssociatedRepoStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedServiceConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedServiceConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedServiceEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedServiceNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-service */
export type GraphStoreFullProjectAssociatedServiceEdge = {
    __typename?: "GraphStoreFullProjectAssociatedServiceEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedServiceNode;
};

export type GraphStoreFullProjectAssociatedServiceEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedServiceEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedServiceEndUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-service: [DevOpsService] */
export type GraphStoreFullProjectAssociatedServiceEndUnion = DevOpsService;

/** A node representing a project-associated-service relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedServiceNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedServiceNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedServiceStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedServiceEndNode;
};

export type GraphStoreFullProjectAssociatedServiceStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedServiceStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedServiceStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-service: [JiraProject] */
export type GraphStoreFullProjectAssociatedServiceStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedToIncidentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectAssociatedToIncidentConnection";
        edges: Array<Maybe<GraphStoreFullProjectAssociatedToIncidentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectAssociatedToIncidentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-associated-to-incident */
export type GraphStoreFullProjectAssociatedToIncidentEdge = {
    __typename?: "GraphStoreFullProjectAssociatedToIncidentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedToIncidentNode;
};

export type GraphStoreFullProjectAssociatedToIncidentEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedToIncidentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedToIncidentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreFullProjectAssociatedToIncidentEndUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A node representing a project-associated-to-incident relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedToIncidentNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedToIncidentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedToIncidentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedToIncidentEndNode;
};

export type GraphStoreFullProjectAssociatedToIncidentStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedToIncidentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedToIncidentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */
export type GraphStoreFullProjectAssociatedToIncidentStartUnion = JiraProject;

export type GraphStoreFullProjectAssociatedToOperationsContainerConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullProjectAssociatedToOperationsContainerConnection";
            edges: Array<
                Maybe<GraphStoreFullProjectAssociatedToOperationsContainerEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullProjectAssociatedToOperationsContainerNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type project-associated-to-operations-container */
export type GraphStoreFullProjectAssociatedToOperationsContainerEdge = {
    __typename?: "GraphStoreFullProjectAssociatedToOperationsContainerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedToOperationsContainerNode;
};

export type GraphStoreFullProjectAssociatedToOperationsContainerEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedToOperationsContainerEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedToOperationsContainerEndUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */
export type GraphStoreFullProjectAssociatedToOperationsContainerEndUnion =
    DevOpsService;

/** A node representing a project-associated-to-operations-container relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedToOperationsContainerNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedToOperationsContainerNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedToOperationsContainerStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedToOperationsContainerEndNode;
};

export type GraphStoreFullProjectAssociatedToOperationsContainerStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedToOperationsContainerStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedToOperationsContainerStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */
export type GraphStoreFullProjectAssociatedToOperationsContainerStartUnion =
    JiraProject;

export type GraphStoreFullProjectAssociatedToSecurityContainerConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullProjectAssociatedToSecurityContainerConnection";
            edges: Array<
                Maybe<GraphStoreFullProjectAssociatedToSecurityContainerEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullProjectAssociatedToSecurityContainerNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type project-associated-to-security-container */
export type GraphStoreFullProjectAssociatedToSecurityContainerEdge = {
    __typename?: "GraphStoreFullProjectAssociatedToSecurityContainerEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedToSecurityContainerNode;
};

export type GraphStoreFullProjectAssociatedToSecurityContainerEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedToSecurityContainerEndNode";
    /** An ARI of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container] */
    id: Scalars["ID"]["output"];
};

/** A node representing a project-associated-to-security-container relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedToSecurityContainerNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedToSecurityContainerNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedToSecurityContainerStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedToSecurityContainerEndNode;
};

export type GraphStoreFullProjectAssociatedToSecurityContainerStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedToSecurityContainerStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedToSecurityContainerStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */
export type GraphStoreFullProjectAssociatedToSecurityContainerStartUnion =
    JiraProject;

export type GraphStoreFullProjectAssociatedVulnerabilityConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullProjectAssociatedVulnerabilityConnection";
            edges: Array<
                Maybe<GraphStoreFullProjectAssociatedVulnerabilityEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullProjectAssociatedVulnerabilityNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

export type GraphStoreFullProjectAssociatedVulnerabilityContainerOutput = {
    __typename?: "GraphStoreFullProjectAssociatedVulnerabilityContainerOutput";
    containerAri?: Maybe<Scalars["String"]["output"]>;
};

/** A full relationship edge for the relationship type project-associated-vulnerability */
export type GraphStoreFullProjectAssociatedVulnerabilityEdge = {
    __typename?: "GraphStoreFullProjectAssociatedVulnerabilityEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectAssociatedVulnerabilityNode;
};

export type GraphStoreFullProjectAssociatedVulnerabilityEndNode = {
    __typename?: "GraphStoreFullProjectAssociatedVulnerabilityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreFullProjectAssociatedVulnerabilityEndUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

/** A node representing a project-associated-vulnerability relationship, with all metadata (if available) */
export type GraphStoreFullProjectAssociatedVulnerabilityNode = Node & {
    __typename?: "GraphStoreFullProjectAssociatedVulnerabilityNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectAssociatedVulnerabilityStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectAssociatedVulnerabilityEndNode;
};

export type GraphStoreFullProjectAssociatedVulnerabilityRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectAssociatedVulnerabilityRelationshipObjectMetadataOutput";
        container?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityContainerOutput>;
        severity?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput>;
        status?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput>;
        type?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput>;
    };

export type GraphStoreFullProjectAssociatedVulnerabilityStartNode = {
    __typename?: "GraphStoreFullProjectAssociatedVulnerabilityStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectAssociatedVulnerabilityStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */
export type GraphStoreFullProjectAssociatedVulnerabilityStartUnion =
    JiraProject;

export enum GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput {
    Dast = "DAST",
    NotSet = "NOT_SET",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullProjectDisassociatedRepoConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectDisassociatedRepoConnection";
        edges: Array<Maybe<GraphStoreFullProjectDisassociatedRepoEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectDisassociatedRepoNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-disassociated-repo */
export type GraphStoreFullProjectDisassociatedRepoEdge = {
    __typename?: "GraphStoreFullProjectDisassociatedRepoEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectDisassociatedRepoNode;
};

export type GraphStoreFullProjectDisassociatedRepoEndNode = {
    __typename?: "GraphStoreFullProjectDisassociatedRepoEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDisassociatedRepoEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreFullProjectDisassociatedRepoEndUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A node representing a project-disassociated-repo relationship, with all metadata (if available) */
export type GraphStoreFullProjectDisassociatedRepoNode = Node & {
    __typename?: "GraphStoreFullProjectDisassociatedRepoNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectDisassociatedRepoStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectDisassociatedRepoEndNode;
};

export type GraphStoreFullProjectDisassociatedRepoStartNode = {
    __typename?: "GraphStoreFullProjectDisassociatedRepoStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDisassociatedRepoStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */
export type GraphStoreFullProjectDisassociatedRepoStartUnion = JiraProject;

export type GraphStoreFullProjectDocumentationEntityConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectDocumentationEntityConnection";
        edges: Array<Maybe<GraphStoreFullProjectDocumentationEntityEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectDocumentationEntityNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-documentation-entity */
export type GraphStoreFullProjectDocumentationEntityEdge = {
    __typename?: "GraphStoreFullProjectDocumentationEntityEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectDocumentationEntityNode;
};

export type GraphStoreFullProjectDocumentationEntityEndNode = {
    __typename?: "GraphStoreFullProjectDocumentationEntityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDocumentationEntityEndUnion>;
    /** An ARI of type(s) [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument, ExternalDocument] */
export type GraphStoreFullProjectDocumentationEntityEndUnion =
    | ConfluencePage
    | ConfluenceSpace
    | DevOpsDocument
    | ExternalDocument;

/** A node representing a project-documentation-entity relationship, with all metadata (if available) */
export type GraphStoreFullProjectDocumentationEntityNode = Node & {
    __typename?: "GraphStoreFullProjectDocumentationEntityNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectDocumentationEntityStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectDocumentationEntityEndNode;
};

export type GraphStoreFullProjectDocumentationEntityStartNode = {
    __typename?: "GraphStoreFullProjectDocumentationEntityStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDocumentationEntityStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-documentation-entity: [JiraProject] */
export type GraphStoreFullProjectDocumentationEntityStartUnion = JiraProject;

export type GraphStoreFullProjectDocumentationPageConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectDocumentationPageConnection";
        edges: Array<Maybe<GraphStoreFullProjectDocumentationPageEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectDocumentationPageNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-documentation-page */
export type GraphStoreFullProjectDocumentationPageEdge = {
    __typename?: "GraphStoreFullProjectDocumentationPageEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectDocumentationPageNode;
};

export type GraphStoreFullProjectDocumentationPageEndNode = {
    __typename?: "GraphStoreFullProjectDocumentationPageEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDocumentationPageEndUnion>;
    /** An ARI of type(s) [ati:cloud:confluence:page] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */
export type GraphStoreFullProjectDocumentationPageEndUnion = ConfluencePage;

/** A node representing a project-documentation-page relationship, with all metadata (if available) */
export type GraphStoreFullProjectDocumentationPageNode = Node & {
    __typename?: "GraphStoreFullProjectDocumentationPageNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectDocumentationPageStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectDocumentationPageEndNode;
};

export type GraphStoreFullProjectDocumentationPageStartNode = {
    __typename?: "GraphStoreFullProjectDocumentationPageStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDocumentationPageStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-documentation-page: [JiraProject] */
export type GraphStoreFullProjectDocumentationPageStartUnion = JiraProject;

export type GraphStoreFullProjectDocumentationSpaceConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectDocumentationSpaceConnection";
        edges: Array<Maybe<GraphStoreFullProjectDocumentationSpaceEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectDocumentationSpaceNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-documentation-space */
export type GraphStoreFullProjectDocumentationSpaceEdge = {
    __typename?: "GraphStoreFullProjectDocumentationSpaceEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectDocumentationSpaceNode;
};

export type GraphStoreFullProjectDocumentationSpaceEndNode = {
    __typename?: "GraphStoreFullProjectDocumentationSpaceEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDocumentationSpaceEndUnion>;
    /** An ARI of type(s) [ati:cloud:confluence:space] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */
export type GraphStoreFullProjectDocumentationSpaceEndUnion = ConfluenceSpace;

/** A node representing a project-documentation-space relationship, with all metadata (if available) */
export type GraphStoreFullProjectDocumentationSpaceNode = Node & {
    __typename?: "GraphStoreFullProjectDocumentationSpaceNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectDocumentationSpaceStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectDocumentationSpaceEndNode;
};

export type GraphStoreFullProjectDocumentationSpaceStartNode = {
    __typename?: "GraphStoreFullProjectDocumentationSpaceStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectDocumentationSpaceStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-documentation-space: [JiraProject] */
export type GraphStoreFullProjectDocumentationSpaceStartUnion = JiraProject;

export type GraphStoreFullProjectExplicitlyAssociatedRepoConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullProjectExplicitlyAssociatedRepoConnection";
            edges: Array<
                Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type project-explicitly-associated-repo */
export type GraphStoreFullProjectExplicitlyAssociatedRepoEdge = {
    __typename?: "GraphStoreFullProjectExplicitlyAssociatedRepoEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectExplicitlyAssociatedRepoNode;
};

export type GraphStoreFullProjectExplicitlyAssociatedRepoEndNode = {
    __typename?: "GraphStoreFullProjectExplicitlyAssociatedRepoEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreFullProjectExplicitlyAssociatedRepoEndUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A node representing a project-explicitly-associated-repo relationship, with all metadata (if available) */
export type GraphStoreFullProjectExplicitlyAssociatedRepoNode = Node & {
    __typename?: "GraphStoreFullProjectExplicitlyAssociatedRepoNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectExplicitlyAssociatedRepoStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectExplicitlyAssociatedRepoEndNode;
};

export type GraphStoreFullProjectExplicitlyAssociatedRepoRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullProjectExplicitlyAssociatedRepoRelationshipObjectMetadataOutput";
        providerAri?: Maybe<Scalars["String"]["output"]>;
    };

export type GraphStoreFullProjectExplicitlyAssociatedRepoStartNode = {
    __typename?: "GraphStoreFullProjectExplicitlyAssociatedRepoStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectExplicitlyAssociatedRepoStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */
export type GraphStoreFullProjectExplicitlyAssociatedRepoStartUnion =
    JiraProject;

export type GraphStoreFullProjectHasIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectHasIssueConnection";
        edges: Array<Maybe<GraphStoreFullProjectHasIssueEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectHasIssueNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-has-issue */
export type GraphStoreFullProjectHasIssueEdge = {
    __typename?: "GraphStoreFullProjectHasIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectHasIssueNode;
};

export type GraphStoreFullProjectHasIssueEndNode = {
    __typename?: "GraphStoreFullProjectHasIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectHasIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullProjectHasIssueRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for project-has-issue: [JiraIssue] */
export type GraphStoreFullProjectHasIssueEndUnion = JiraIssue;

/** A node representing a project-has-issue relationship, with all metadata (if available) */
export type GraphStoreFullProjectHasIssueNode = Node & {
    __typename?: "GraphStoreFullProjectHasIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectHasIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullProjectHasIssueRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectHasIssueEndNode;
};

export type GraphStoreFullProjectHasIssueRelationshipMetadataOutput = {
    __typename?: "GraphStoreFullProjectHasIssueRelationshipMetadataOutput";
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    sprintAris?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullProjectHasIssueRelationshipObjectMetadataOutput = {
    __typename?: "GraphStoreFullProjectHasIssueRelationshipObjectMetadataOutput";
    assigneeAri?: Maybe<Scalars["String"]["output"]>;
    creatorAri?: Maybe<Scalars["String"]["output"]>;
    fixVersionIds?: Maybe<Scalars["Long"]["output"]>;
    issueAri?: Maybe<Scalars["String"]["output"]>;
    issueTypeAri?: Maybe<Scalars["String"]["output"]>;
    reporterAri?: Maybe<Scalars["String"]["output"]>;
    statusAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullProjectHasIssueStartNode = {
    __typename?: "GraphStoreFullProjectHasIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectHasIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-has-issue: [JiraProject] */
export type GraphStoreFullProjectHasIssueStartUnion = JiraProject;

export type GraphStoreFullProjectHasSharedVersionWithConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectHasSharedVersionWithConnection";
        edges: Array<Maybe<GraphStoreFullProjectHasSharedVersionWithEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectHasSharedVersionWithNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-has-shared-version-with */
export type GraphStoreFullProjectHasSharedVersionWithEdge = {
    __typename?: "GraphStoreFullProjectHasSharedVersionWithEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectHasSharedVersionWithNode;
};

export type GraphStoreFullProjectHasSharedVersionWithEndNode = {
    __typename?: "GraphStoreFullProjectHasSharedVersionWithEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectHasSharedVersionWithEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */
export type GraphStoreFullProjectHasSharedVersionWithEndUnion = JiraProject;

/** A node representing a project-has-shared-version-with relationship, with all metadata (if available) */
export type GraphStoreFullProjectHasSharedVersionWithNode = Node & {
    __typename?: "GraphStoreFullProjectHasSharedVersionWithNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectHasSharedVersionWithStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectHasSharedVersionWithEndNode;
};

export type GraphStoreFullProjectHasSharedVersionWithStartNode = {
    __typename?: "GraphStoreFullProjectHasSharedVersionWithStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectHasSharedVersionWithStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */
export type GraphStoreFullProjectHasSharedVersionWithStartUnion = JiraProject;

export type GraphStoreFullProjectHasVersionConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullProjectHasVersionConnection";
        edges: Array<Maybe<GraphStoreFullProjectHasVersionEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullProjectHasVersionNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type project-has-version */
export type GraphStoreFullProjectHasVersionEdge = {
    __typename?: "GraphStoreFullProjectHasVersionEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullProjectHasVersionNode;
};

export type GraphStoreFullProjectHasVersionEndNode = {
    __typename?: "GraphStoreFullProjectHasVersionEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectHasVersionEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-has-version: [JiraVersion] */
export type GraphStoreFullProjectHasVersionEndUnion = JiraVersion;

/** A node representing a project-has-version relationship, with all metadata (if available) */
export type GraphStoreFullProjectHasVersionNode = Node & {
    __typename?: "GraphStoreFullProjectHasVersionNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullProjectHasVersionStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullProjectHasVersionEndNode;
};

export type GraphStoreFullProjectHasVersionStartNode = {
    __typename?: "GraphStoreFullProjectHasVersionStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullProjectHasVersionStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for project-has-version: [JiraProject] */
export type GraphStoreFullProjectHasVersionStartUnion = JiraProject;

export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityConnection =
    HasPageInfo & {
        __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityConnection";
        edges: Array<
            Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityEdge>
        >;
        nodes: Array<
            Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityNode>
        >;
        pageInfo: PageInfo;
    };

export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityContainerOutput =
    {
        __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityContainerOutput";
        containerAri?: Maybe<Scalars["String"]["output"]>;
    };

/** A full relationship edge for the relationship type security-container-associated-to-vulnerability */
export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityEdge = {
    __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSecurityContainerAssociatedToVulnerabilityNode;
};

export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityEndNode = {
    __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityEndUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

/** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */
export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityNode =
    Node & {
        __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityNode";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the from node */
        from: GraphStoreFullSecurityContainerAssociatedToVulnerabilityStartNode;
        /** The id of the relationship */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The ari and metadata corresponding to the to node */
        to: GraphStoreFullSecurityContainerAssociatedToVulnerabilityEndNode;
    };

export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityRelationshipObjectMetadataOutput";
        container?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityContainerOutput>;
        severity?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput>;
        status?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput>;
        type?: Maybe<GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput>;
    };

export type GraphStoreFullSecurityContainerAssociatedToVulnerabilityStartNode =
    {
        __typename?: "GraphStoreFullSecurityContainerAssociatedToVulnerabilityStartNode";
        /** An ARI of type(s) [ati:cloud:jira:security-container, ati:cloud:graph:security-container] */
        id: Scalars["ID"]["output"];
    };

export enum GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput {
    Dast = "DAST",
    NotSet = "NOT_SET",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullServiceLinkedIncidentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullServiceLinkedIncidentConnection";
        edges: Array<Maybe<GraphStoreFullServiceLinkedIncidentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullServiceLinkedIncidentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type service-linked-incident */
export type GraphStoreFullServiceLinkedIncidentEdge = {
    __typename?: "GraphStoreFullServiceLinkedIncidentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullServiceLinkedIncidentNode;
};

export type GraphStoreFullServiceLinkedIncidentEndNode = {
    __typename?: "GraphStoreFullServiceLinkedIncidentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullServiceLinkedIncidentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullServiceLinkedIncidentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for service-linked-incident: [JiraIssue] */
export type GraphStoreFullServiceLinkedIncidentEndUnion = JiraIssue;

export enum GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5"
}

export enum GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    NotSet = "NOT_SET",
    Undefined = "UNDEFINED"
}

/** A node representing a service-linked-incident relationship, with all metadata (if available) */
export type GraphStoreFullServiceLinkedIncidentNode = Node & {
    __typename?: "GraphStoreFullServiceLinkedIncidentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullServiceLinkedIncidentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullServiceLinkedIncidentEndNode;
};

export type GraphStoreFullServiceLinkedIncidentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullServiceLinkedIncidentRelationshipObjectMetadataOutput";
        affectedServiceAris?: Maybe<Scalars["String"]["output"]>;
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        majorIncident?: Maybe<Scalars["Boolean"]["output"]>;
        priority?: Maybe<GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput>;
        reporterAri?: Maybe<Scalars["String"]["output"]>;
        status?: Maybe<GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput>;
    };

export type GraphStoreFullServiceLinkedIncidentStartNode = {
    __typename?: "GraphStoreFullServiceLinkedIncidentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullServiceLinkedIncidentStartUnion>;
    /** An ARI of type(s) [ati:cloud:graph:service] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for service-linked-incident: [DevOpsService] */
export type GraphStoreFullServiceLinkedIncidentStartUnion = DevOpsService;

export enum GraphStoreFullSprintAssociatedBuildBuildStateOutput {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullSprintAssociatedBuildConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullSprintAssociatedBuildConnection";
        edges: Array<Maybe<GraphStoreFullSprintAssociatedBuildEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullSprintAssociatedBuildNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type sprint-associated-build */
export type GraphStoreFullSprintAssociatedBuildEdge = {
    __typename?: "GraphStoreFullSprintAssociatedBuildEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintAssociatedBuildNode;
};

export type GraphStoreFullSprintAssociatedBuildEndNode = {
    __typename?: "GraphStoreFullSprintAssociatedBuildEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintAssociatedBuildEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:build, ati:cloud:graph:build] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullSprintAssociatedBuildRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for sprint-associated-build: [ExternalBuildInfo] */
export type GraphStoreFullSprintAssociatedBuildEndUnion = ExternalBuildInfo;

/** A node representing a sprint-associated-build relationship, with all metadata (if available) */
export type GraphStoreFullSprintAssociatedBuildNode = Node & {
    __typename?: "GraphStoreFullSprintAssociatedBuildNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintAssociatedBuildStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullSprintAssociatedBuildRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintAssociatedBuildEndNode;
};

export type GraphStoreFullSprintAssociatedBuildRelationshipMetadataOutput = {
    __typename?: "GraphStoreFullSprintAssociatedBuildRelationshipMetadataOutput";
    assigneeAri?: Maybe<Scalars["String"]["output"]>;
    creatorAri?: Maybe<Scalars["String"]["output"]>;
    issueAri?: Maybe<Scalars["String"]["output"]>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<Scalars["String"]["output"]>;
    statusAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullSprintAssociatedBuildRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullSprintAssociatedBuildRelationshipObjectMetadataOutput";
        state?: Maybe<GraphStoreFullSprintAssociatedBuildBuildStateOutput>;
        testInfo?: Maybe<GraphStoreFullSprintAssociatedBuildTestInfoOutput>;
    };

export type GraphStoreFullSprintAssociatedBuildStartNode = {
    __typename?: "GraphStoreFullSprintAssociatedBuildStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export type GraphStoreFullSprintAssociatedBuildTestInfoOutput = {
    __typename?: "GraphStoreFullSprintAssociatedBuildTestInfoOutput";
    numberFailed?: Maybe<Scalars["Long"]["output"]>;
    numberPassed?: Maybe<Scalars["Long"]["output"]>;
    numberSkipped?: Maybe<Scalars["Long"]["output"]>;
    totalNumber?: Maybe<Scalars["Long"]["output"]>;
};

export type GraphStoreFullSprintAssociatedDeploymentAuthorOutput = {
    __typename?: "GraphStoreFullSprintAssociatedDeploymentAuthorOutput";
    authorAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullSprintAssociatedDeploymentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullSprintAssociatedDeploymentConnection";
        edges: Array<Maybe<GraphStoreFullSprintAssociatedDeploymentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullSprintAssociatedDeploymentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

export enum GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

/** A full relationship edge for the relationship type sprint-associated-deployment */
export type GraphStoreFullSprintAssociatedDeploymentEdge = {
    __typename?: "GraphStoreFullSprintAssociatedDeploymentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintAssociatedDeploymentNode;
};

export type GraphStoreFullSprintAssociatedDeploymentEndNode = {
    __typename?: "GraphStoreFullSprintAssociatedDeploymentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintAssociatedDeploymentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullSprintAssociatedDeploymentRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreFullSprintAssociatedDeploymentEndUnion =
    | DeploymentSummary
    | ExternalDeployment;

export enum GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

/** A node representing a sprint-associated-deployment relationship, with all metadata (if available) */
export type GraphStoreFullSprintAssociatedDeploymentNode = Node & {
    __typename?: "GraphStoreFullSprintAssociatedDeploymentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintAssociatedDeploymentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullSprintAssociatedDeploymentRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintAssociatedDeploymentEndNode;
};

export type GraphStoreFullSprintAssociatedDeploymentRelationshipMetadataOutput =
    {
        __typename?: "GraphStoreFullSprintAssociatedDeploymentRelationshipMetadataOutput";
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        creatorAri?: Maybe<Scalars["String"]["output"]>;
        issueAri?: Maybe<Scalars["String"]["output"]>;
        issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
        reporterAri?: Maybe<Scalars["String"]["output"]>;
        statusAri?: Maybe<Scalars["String"]["output"]>;
    };

export type GraphStoreFullSprintAssociatedDeploymentRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullSprintAssociatedDeploymentRelationshipObjectMetadataOutput";
        author?: Maybe<GraphStoreFullSprintAssociatedDeploymentAuthorOutput>;
        environmentType?: Maybe<GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput>;
        state?: Maybe<GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput>;
    };

export type GraphStoreFullSprintAssociatedDeploymentStartNode = {
    __typename?: "GraphStoreFullSprintAssociatedDeploymentStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export type GraphStoreFullSprintAssociatedPrAuthorOutput = {
    __typename?: "GraphStoreFullSprintAssociatedPrAuthorOutput";
    authorAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullSprintAssociatedPrConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullSprintAssociatedPrConnection";
        edges: Array<Maybe<GraphStoreFullSprintAssociatedPrEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullSprintAssociatedPrNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type sprint-associated-pr */
export type GraphStoreFullSprintAssociatedPrEdge = {
    __typename?: "GraphStoreFullSprintAssociatedPrEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintAssociatedPrNode;
};

export type GraphStoreFullSprintAssociatedPrEndNode = {
    __typename?: "GraphStoreFullSprintAssociatedPrEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintAssociatedPrEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullSprintAssociatedPrRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreFullSprintAssociatedPrEndUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A node representing a sprint-associated-pr relationship, with all metadata (if available) */
export type GraphStoreFullSprintAssociatedPrNode = Node & {
    __typename?: "GraphStoreFullSprintAssociatedPrNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintAssociatedPrStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullSprintAssociatedPrRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintAssociatedPrEndNode;
};

export enum GraphStoreFullSprintAssociatedPrPullRequestStatusOutput {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullSprintAssociatedPrRelationshipMetadataOutput = {
    __typename?: "GraphStoreFullSprintAssociatedPrRelationshipMetadataOutput";
    assigneeAri?: Maybe<Scalars["String"]["output"]>;
    creatorAri?: Maybe<Scalars["String"]["output"]>;
    issueAri?: Maybe<Scalars["String"]["output"]>;
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
    reporterAri?: Maybe<Scalars["String"]["output"]>;
    statusAri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphStoreFullSprintAssociatedPrRelationshipObjectMetadataOutput = {
    __typename?: "GraphStoreFullSprintAssociatedPrRelationshipObjectMetadataOutput";
    author?: Maybe<GraphStoreFullSprintAssociatedPrAuthorOutput>;
    reviewers?: Maybe<GraphStoreFullSprintAssociatedPrReviewerOutput>;
    status?: Maybe<GraphStoreFullSprintAssociatedPrPullRequestStatusOutput>;
    taskCount?: Maybe<Scalars["Int"]["output"]>;
};

export type GraphStoreFullSprintAssociatedPrReviewerOutput = {
    __typename?: "GraphStoreFullSprintAssociatedPrReviewerOutput";
    approvalStatus?: Maybe<GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput>;
    reviewerAri?: Maybe<Scalars["String"]["output"]>;
};

export enum GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphStoreFullSprintAssociatedPrStartNode = {
    __typename?: "GraphStoreFullSprintAssociatedPrStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export type GraphStoreFullSprintAssociatedVulnerabilityConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullSprintAssociatedVulnerabilityConnection";
            edges: Array<
                Maybe<GraphStoreFullSprintAssociatedVulnerabilityEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullSprintAssociatedVulnerabilityNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type sprint-associated-vulnerability */
export type GraphStoreFullSprintAssociatedVulnerabilityEdge = {
    __typename?: "GraphStoreFullSprintAssociatedVulnerabilityEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintAssociatedVulnerabilityNode;
};

export type GraphStoreFullSprintAssociatedVulnerabilityEndNode = {
    __typename?: "GraphStoreFullSprintAssociatedVulnerabilityEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreFullSprintAssociatedVulnerabilityEndUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

/** A node representing a sprint-associated-vulnerability relationship, with all metadata (if available) */
export type GraphStoreFullSprintAssociatedVulnerabilityNode = Node & {
    __typename?: "GraphStoreFullSprintAssociatedVulnerabilityNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintAssociatedVulnerabilityStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintAssociatedVulnerabilityEndNode;
};

export type GraphStoreFullSprintAssociatedVulnerabilityRelationshipMetadataOutput =
    {
        __typename?: "GraphStoreFullSprintAssociatedVulnerabilityRelationshipMetadataOutput";
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        statusAri?: Maybe<Scalars["String"]["output"]>;
        statusCategory?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput>;
    };

export type GraphStoreFullSprintAssociatedVulnerabilityRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullSprintAssociatedVulnerabilityRelationshipObjectMetadataOutput";
        introducedDate?: Maybe<Scalars["Long"]["output"]>;
        severity?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput>;
        status?: Maybe<GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput>;
    };

export type GraphStoreFullSprintAssociatedVulnerabilityStartNode = {
    __typename?: "GraphStoreFullSprintAssociatedVulnerabilityStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export enum GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export enum GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreFullSprintContainsIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullSprintContainsIssueConnection";
        edges: Array<Maybe<GraphStoreFullSprintContainsIssueEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullSprintContainsIssueNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type sprint-contains-issue */
export type GraphStoreFullSprintContainsIssueEdge = {
    __typename?: "GraphStoreFullSprintContainsIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintContainsIssueNode;
};

export type GraphStoreFullSprintContainsIssueEndNode = {
    __typename?: "GraphStoreFullSprintContainsIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintContainsIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullSprintContainsIssueRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */
export type GraphStoreFullSprintContainsIssueEndUnion = JiraIssue;

/** A node representing a sprint-contains-issue relationship, with all metadata (if available) */
export type GraphStoreFullSprintContainsIssueNode = Node & {
    __typename?: "GraphStoreFullSprintContainsIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintContainsIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** Metadata for the relationship */
    metadata?: Maybe<GraphStoreFullSprintContainsIssueRelationshipMetadataOutput>;
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintContainsIssueEndNode;
};

export type GraphStoreFullSprintContainsIssueRelationshipMetadataOutput = {
    __typename?: "GraphStoreFullSprintContainsIssueRelationshipMetadataOutput";
    issueLastUpdatedOn?: Maybe<Scalars["Long"]["output"]>;
};

export type GraphStoreFullSprintContainsIssueRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullSprintContainsIssueRelationshipObjectMetadataOutput";
        assigneeAri?: Maybe<Scalars["String"]["output"]>;
        creatorAri?: Maybe<Scalars["String"]["output"]>;
        issueAri?: Maybe<Scalars["String"]["output"]>;
        reporterAri?: Maybe<Scalars["String"]["output"]>;
        statusAri?: Maybe<Scalars["String"]["output"]>;
        statusCategory?: Maybe<GraphStoreFullSprintContainsIssueStatusCategoryOutput>;
    };

export type GraphStoreFullSprintContainsIssueStartNode = {
    __typename?: "GraphStoreFullSprintContainsIssueStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export enum GraphStoreFullSprintContainsIssueStatusCategoryOutput {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphStoreFullSprintRetrospectivePageConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullSprintRetrospectivePageConnection";
        edges: Array<Maybe<GraphStoreFullSprintRetrospectivePageEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullSprintRetrospectivePageNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type sprint-retrospective-page */
export type GraphStoreFullSprintRetrospectivePageEdge = {
    __typename?: "GraphStoreFullSprintRetrospectivePageEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintRetrospectivePageNode;
};

export type GraphStoreFullSprintRetrospectivePageEndNode = {
    __typename?: "GraphStoreFullSprintRetrospectivePageEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintRetrospectivePageEndUnion>;
    /** An ARI of type(s) [ati:cloud:confluence:page] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */
export type GraphStoreFullSprintRetrospectivePageEndUnion = ConfluencePage;

/** A node representing a sprint-retrospective-page relationship, with all metadata (if available) */
export type GraphStoreFullSprintRetrospectivePageNode = Node & {
    __typename?: "GraphStoreFullSprintRetrospectivePageNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintRetrospectivePageStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintRetrospectivePageEndNode;
};

export type GraphStoreFullSprintRetrospectivePageStartNode = {
    __typename?: "GraphStoreFullSprintRetrospectivePageStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export type GraphStoreFullSprintRetrospectiveWhiteboardConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullSprintRetrospectiveWhiteboardConnection";
            edges: Array<
                Maybe<GraphStoreFullSprintRetrospectiveWhiteboardEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullSprintRetrospectiveWhiteboardNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type sprint-retrospective-whiteboard */
export type GraphStoreFullSprintRetrospectiveWhiteboardEdge = {
    __typename?: "GraphStoreFullSprintRetrospectiveWhiteboardEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullSprintRetrospectiveWhiteboardNode;
};

export type GraphStoreFullSprintRetrospectiveWhiteboardEndNode = {
    __typename?: "GraphStoreFullSprintRetrospectiveWhiteboardEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullSprintRetrospectiveWhiteboardEndUnion>;
    /** An ARI of type(s) [ati:cloud:confluence:whiteboard] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreFullSprintRetrospectiveWhiteboardEndUnion =
    ConfluenceWhiteboard;

/** A node representing a sprint-retrospective-whiteboard relationship, with all metadata (if available) */
export type GraphStoreFullSprintRetrospectiveWhiteboardNode = Node & {
    __typename?: "GraphStoreFullSprintRetrospectiveWhiteboardNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullSprintRetrospectiveWhiteboardStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullSprintRetrospectiveWhiteboardEndNode;
};

export type GraphStoreFullSprintRetrospectiveWhiteboardStartNode = {
    __typename?: "GraphStoreFullSprintRetrospectiveWhiteboardStartNode";
    /** An ARI of type(s) [ati:cloud:jira:sprint] */
    id: Scalars["ID"]["output"];
};

export type GraphStoreFullTeamWorksOnProjectConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullTeamWorksOnProjectConnection";
        edges: Array<Maybe<GraphStoreFullTeamWorksOnProjectEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullTeamWorksOnProjectNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type team-works-on-project */
export type GraphStoreFullTeamWorksOnProjectEdge = {
    __typename?: "GraphStoreFullTeamWorksOnProjectEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullTeamWorksOnProjectNode;
};

export type GraphStoreFullTeamWorksOnProjectEndNode = {
    __typename?: "GraphStoreFullTeamWorksOnProjectEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullTeamWorksOnProjectEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:project] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for team-works-on-project: [JiraProject] */
export type GraphStoreFullTeamWorksOnProjectEndUnion = JiraProject;

/** A node representing a team-works-on-project relationship, with all metadata (if available) */
export type GraphStoreFullTeamWorksOnProjectNode = Node & {
    __typename?: "GraphStoreFullTeamWorksOnProjectNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullTeamWorksOnProjectStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullTeamWorksOnProjectEndNode;
};

export type GraphStoreFullTeamWorksOnProjectStartNode = {
    __typename?: "GraphStoreFullTeamWorksOnProjectStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullTeamWorksOnProjectStartUnion>;
    /** An ARI of type(s) [ati:cloud:identity:team] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for team-works-on-project: [TeamV2] */
export type GraphStoreFullTeamWorksOnProjectStartUnion = TeamV2;

export type GraphStoreFullVersionAssociatedBranchConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedBranchConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedBranchEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedBranchNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-branch */
export type GraphStoreFullVersionAssociatedBranchEdge = {
    __typename?: "GraphStoreFullVersionAssociatedBranchEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedBranchNode;
};

export type GraphStoreFullVersionAssociatedBranchEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedBranchEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedBranchEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-branch: [ExternalBranch] */
export type GraphStoreFullVersionAssociatedBranchEndUnion = ExternalBranch;

/** A node representing a version-associated-branch relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedBranchNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedBranchNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedBranchStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedBranchEndNode;
};

export type GraphStoreFullVersionAssociatedBranchStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedBranchStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedBranchStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-branch: [JiraVersion] */
export type GraphStoreFullVersionAssociatedBranchStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedBuildConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedBuildConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedBuildEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedBuildNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-build */
export type GraphStoreFullVersionAssociatedBuildEdge = {
    __typename?: "GraphStoreFullVersionAssociatedBuildEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedBuildNode;
};

export type GraphStoreFullVersionAssociatedBuildEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedBuildEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedBuildEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:build, ati:cloud:graph:build] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-build: [ExternalBuildInfo] */
export type GraphStoreFullVersionAssociatedBuildEndUnion = ExternalBuildInfo;

/** A node representing a version-associated-build relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedBuildNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedBuildNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedBuildStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedBuildEndNode;
};

export type GraphStoreFullVersionAssociatedBuildStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedBuildStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedBuildStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-build: [JiraVersion] */
export type GraphStoreFullVersionAssociatedBuildStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedCommitConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedCommitConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedCommitEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedCommitNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-commit */
export type GraphStoreFullVersionAssociatedCommitEdge = {
    __typename?: "GraphStoreFullVersionAssociatedCommitEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedCommitNode;
};

export type GraphStoreFullVersionAssociatedCommitEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedCommitEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedCommitEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-commit: [ExternalCommit] */
export type GraphStoreFullVersionAssociatedCommitEndUnion = ExternalCommit;

/** A node representing a version-associated-commit relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedCommitNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedCommitNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedCommitStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedCommitEndNode;
};

export type GraphStoreFullVersionAssociatedCommitStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedCommitStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedCommitStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-commit: [JiraVersion] */
export type GraphStoreFullVersionAssociatedCommitStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedDeploymentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedDeploymentConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedDeploymentEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedDeploymentNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-deployment */
export type GraphStoreFullVersionAssociatedDeploymentEdge = {
    __typename?: "GraphStoreFullVersionAssociatedDeploymentEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedDeploymentNode;
};

export type GraphStoreFullVersionAssociatedDeploymentEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedDeploymentEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedDeploymentEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreFullVersionAssociatedDeploymentEndUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A node representing a version-associated-deployment relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedDeploymentNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedDeploymentNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedDeploymentStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedDeploymentEndNode;
};

export type GraphStoreFullVersionAssociatedDeploymentStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedDeploymentStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedDeploymentStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */
export type GraphStoreFullVersionAssociatedDeploymentStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedDesignConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedDesignConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedDesignEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedDesignNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

export enum GraphStoreFullVersionAssociatedDesignDesignStatusOutput {
    None = "NONE",
    NotSet = "NOT_SET",
    ReadyForDevelopment = "READY_FOR_DEVELOPMENT",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullVersionAssociatedDesignDesignTypeOutput {
    Canvas = "CANVAS",
    File = "FILE",
    Group = "GROUP",
    Node = "NODE",
    NotSet = "NOT_SET",
    Other = "OTHER",
    Prototype = "PROTOTYPE"
}

/** A full relationship edge for the relationship type version-associated-design */
export type GraphStoreFullVersionAssociatedDesignEdge = {
    __typename?: "GraphStoreFullVersionAssociatedDesignEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedDesignNode;
};

export type GraphStoreFullVersionAssociatedDesignEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedDesignEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedDesignEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:design, ati:cloud:graph:design] */
    id: Scalars["ID"]["output"];
    /** The metadata for TO field */
    metadata?: Maybe<GraphStoreFullVersionAssociatedDesignRelationshipObjectMetadataOutput>;
};

/** A union of the possible hydration types for version-associated-design: [DevOpsDesign, ExternalDesign] */
export type GraphStoreFullVersionAssociatedDesignEndUnion =
    | DevOpsDesign
    | ExternalDesign;

/** A node representing a version-associated-design relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedDesignNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedDesignNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedDesignStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedDesignEndNode;
};

export type GraphStoreFullVersionAssociatedDesignRelationshipObjectMetadataOutput =
    {
        __typename?: "GraphStoreFullVersionAssociatedDesignRelationshipObjectMetadataOutput";
        designLastUpdated?: Maybe<Scalars["Long"]["output"]>;
        status?: Maybe<GraphStoreFullVersionAssociatedDesignDesignStatusOutput>;
        type?: Maybe<GraphStoreFullVersionAssociatedDesignDesignTypeOutput>;
    };

export type GraphStoreFullVersionAssociatedDesignStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedDesignStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedDesignStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-design: [JiraVersion] */
export type GraphStoreFullVersionAssociatedDesignStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedFeatureFlagConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedFeatureFlagConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedFeatureFlagEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedFeatureFlagNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-feature-flag */
export type GraphStoreFullVersionAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreFullVersionAssociatedFeatureFlagEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedFeatureFlagNode;
};

export type GraphStoreFullVersionAssociatedFeatureFlagEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedFeatureFlagEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedFeatureFlagEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreFullVersionAssociatedFeatureFlagEndUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A node representing a version-associated-feature-flag relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedFeatureFlagNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedFeatureFlagNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedFeatureFlagStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedFeatureFlagEndNode;
};

export type GraphStoreFullVersionAssociatedFeatureFlagStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedFeatureFlagStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedFeatureFlagStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */
export type GraphStoreFullVersionAssociatedFeatureFlagStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreFullVersionAssociatedIssueConnection";
    edges: Array<Maybe<GraphStoreFullVersionAssociatedIssueEdge>>;
    nodes: Array<Maybe<GraphStoreFullVersionAssociatedIssueNode>>;
    pageInfo: PageInfo;
};

/** A full relationship edge for the relationship type version-associated-issue */
export type GraphStoreFullVersionAssociatedIssueEdge = {
    __typename?: "GraphStoreFullVersionAssociatedIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedIssueNode;
};

export type GraphStoreFullVersionAssociatedIssueEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-issue: [JiraIssue] */
export type GraphStoreFullVersionAssociatedIssueEndUnion = JiraIssue;

/** A node representing a version-associated-issue relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedIssueNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedIssueEndNode;
};

export type GraphStoreFullVersionAssociatedIssueStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-issue: [JiraVersion] */
export type GraphStoreFullVersionAssociatedIssueStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedPullRequestConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedPullRequestConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedPullRequestEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedPullRequestNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-pull-request */
export type GraphStoreFullVersionAssociatedPullRequestEdge = {
    __typename?: "GraphStoreFullVersionAssociatedPullRequestEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedPullRequestNode;
};

export type GraphStoreFullVersionAssociatedPullRequestEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedPullRequestEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedPullRequestEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreFullVersionAssociatedPullRequestEndUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A node representing a version-associated-pull-request relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedPullRequestNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedPullRequestNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedPullRequestStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedPullRequestEndNode;
};

export type GraphStoreFullVersionAssociatedPullRequestStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedPullRequestStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedPullRequestStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */
export type GraphStoreFullVersionAssociatedPullRequestStartUnion = JiraVersion;

export type GraphStoreFullVersionAssociatedRemoteLinkConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVersionAssociatedRemoteLinkConnection";
        edges: Array<Maybe<GraphStoreFullVersionAssociatedRemoteLinkEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVersionAssociatedRemoteLinkNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A full relationship edge for the relationship type version-associated-remote-link */
export type GraphStoreFullVersionAssociatedRemoteLinkEdge = {
    __typename?: "GraphStoreFullVersionAssociatedRemoteLinkEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionAssociatedRemoteLinkNode;
};

export type GraphStoreFullVersionAssociatedRemoteLinkEndNode = {
    __typename?: "GraphStoreFullVersionAssociatedRemoteLinkEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedRemoteLinkEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-remote-link: [ExternalRemoteLink] */
export type GraphStoreFullVersionAssociatedRemoteLinkEndUnion =
    ExternalRemoteLink;

/** A node representing a version-associated-remote-link relationship, with all metadata (if available) */
export type GraphStoreFullVersionAssociatedRemoteLinkNode = Node & {
    __typename?: "GraphStoreFullVersionAssociatedRemoteLinkNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionAssociatedRemoteLinkStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionAssociatedRemoteLinkEndNode;
};

export type GraphStoreFullVersionAssociatedRemoteLinkStartNode = {
    __typename?: "GraphStoreFullVersionAssociatedRemoteLinkStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionAssociatedRemoteLinkStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */
export type GraphStoreFullVersionAssociatedRemoteLinkStartUnion = JiraVersion;

export type GraphStoreFullVersionUserAssociatedFeatureFlagConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreFullVersionUserAssociatedFeatureFlagConnection";
            edges: Array<
                Maybe<GraphStoreFullVersionUserAssociatedFeatureFlagEdge>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            nodes: Array<
                Maybe<GraphStoreFullVersionUserAssociatedFeatureFlagNode>
            >;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A full relationship edge for the relationship type version-user-associated-feature-flag */
export type GraphStoreFullVersionUserAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreFullVersionUserAssociatedFeatureFlagEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVersionUserAssociatedFeatureFlagNode;
};

export type GraphStoreFullVersionUserAssociatedFeatureFlagEndNode = {
    __typename?: "GraphStoreFullVersionUserAssociatedFeatureFlagEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionUserAssociatedFeatureFlagEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreFullVersionUserAssociatedFeatureFlagEndUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A node representing a version-user-associated-feature-flag relationship, with all metadata (if available) */
export type GraphStoreFullVersionUserAssociatedFeatureFlagNode = Node & {
    __typename?: "GraphStoreFullVersionUserAssociatedFeatureFlagNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVersionUserAssociatedFeatureFlagStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVersionUserAssociatedFeatureFlagEndNode;
};

export type GraphStoreFullVersionUserAssociatedFeatureFlagStartNode = {
    __typename?: "GraphStoreFullVersionUserAssociatedFeatureFlagStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVersionUserAssociatedFeatureFlagStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:version] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */
export type GraphStoreFullVersionUserAssociatedFeatureFlagStartUnion =
    JiraVersion;

export type GraphStoreFullVulnerabilityAssociatedIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreFullVulnerabilityAssociatedIssueConnection";
        edges: Array<Maybe<GraphStoreFullVulnerabilityAssociatedIssueEdge>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        nodes: Array<Maybe<GraphStoreFullVulnerabilityAssociatedIssueNode>>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

export type GraphStoreFullVulnerabilityAssociatedIssueContainerOutput = {
    __typename?: "GraphStoreFullVulnerabilityAssociatedIssueContainerOutput";
    containerAri?: Maybe<Scalars["String"]["output"]>;
};

/** A full relationship edge for the relationship type vulnerability-associated-issue */
export type GraphStoreFullVulnerabilityAssociatedIssueEdge = {
    __typename?: "GraphStoreFullVulnerabilityAssociatedIssueEdge";
    /** Cursor object not currently implemented per edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: GraphStoreFullVulnerabilityAssociatedIssueNode;
};

export type GraphStoreFullVulnerabilityAssociatedIssueEndNode = {
    __typename?: "GraphStoreFullVulnerabilityAssociatedIssueEndNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueEndUnion>;
    /** An ARI of type(s) [ati:cloud:jira:issue] */
    id: Scalars["ID"]["output"];
};

/** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */
export type GraphStoreFullVulnerabilityAssociatedIssueEndUnion = JiraIssue;

/** A node representing a vulnerability-associated-issue relationship, with all metadata (if available) */
export type GraphStoreFullVulnerabilityAssociatedIssueNode = Node & {
    __typename?: "GraphStoreFullVulnerabilityAssociatedIssueNode";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the from node */
    from: GraphStoreFullVulnerabilityAssociatedIssueStartNode;
    /** The id of the relationship */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The ari and metadata corresponding to the to node */
    to: GraphStoreFullVulnerabilityAssociatedIssueEndNode;
};

export type GraphStoreFullVulnerabilityAssociatedIssueRelationshipSubjectMetadataOutput =
    {
        __typename?: "GraphStoreFullVulnerabilityAssociatedIssueRelationshipSubjectMetadataOutput";
        container?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueContainerOutput>;
        introducedDate?: Maybe<Scalars["Long"]["output"]>;
        severity?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput>;
        status?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput>;
        type?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput>;
    };

export type GraphStoreFullVulnerabilityAssociatedIssueStartNode = {
    __typename?: "GraphStoreFullVulnerabilityAssociatedIssueStartNode";
    /** The data for the node, hydrated by a call to another service. */
    data?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueStartUnion>;
    /** An ARI of type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability] */
    id: Scalars["ID"]["output"];
    /** The metadata for FROM field */
    metadata?: Maybe<GraphStoreFullVulnerabilityAssociatedIssueRelationshipSubjectMetadataOutput>;
};

/** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreFullVulnerabilityAssociatedIssueStartUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

export enum GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export enum GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput {
    Dast = "DAST",
    NotSet = "NOT_SET",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphStoreGraphDocument3pDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreGraphEntityReplicates3pEntitySortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreGroupCanViewConfluenceSpaceSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewLinkSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIncidentAssociatedPostIncidentReviewSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIncidentHasActionItemSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIncidentLinkedJswIssueSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIntFilterInput = {
    greaterThan?: InputMaybe<Scalars["Int"]["input"]>;
    greaterThanOrEqual?: InputMaybe<Scalars["Int"]["input"]>;
    is?: InputMaybe<Array<Scalars["Int"]["input"]>>;
    isNot?: InputMaybe<Array<Scalars["Int"]["input"]>>;
    lessThan?: InputMaybe<Scalars["Int"]["input"]>;
    lessThanOrEqual?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GraphStoreIssueAssociatedBranchSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedBuildSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedCommitSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentAuthorFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreIssueAssociatedDeploymentAuthorFilterInput>>
    >;
    authorAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreIssueAssociatedDeploymentAuthorFilterInput>>
    >;
};

export type GraphStoreIssueAssociatedDeploymentAuthorSortInput = {
    authorAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedDeploymentConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_author?: InputMaybe<GraphStoreIssueAssociatedDeploymentAuthorFilterInput>;
    to_environmentType?: InputMaybe<GraphStoreIssueAssociatedDeploymentEnvironmentTypeFilterInput>;
    to_state?: InputMaybe<GraphStoreIssueAssociatedDeploymentDeploymentStateFilterInput>;
};

export enum GraphStoreIssueAssociatedDeploymentDeploymentState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreIssueAssociatedDeploymentDeploymentStateFilterInput = {
    is?: InputMaybe<Array<GraphStoreIssueAssociatedDeploymentDeploymentState>>;
    isNot?: InputMaybe<
        Array<GraphStoreIssueAssociatedDeploymentDeploymentState>
    >;
};

export enum GraphStoreIssueAssociatedDeploymentEnvironmentType {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type GraphStoreIssueAssociatedDeploymentEnvironmentTypeFilterInput = {
    is?: InputMaybe<Array<GraphStoreIssueAssociatedDeploymentEnvironmentType>>;
    isNot?: InputMaybe<
        Array<GraphStoreIssueAssociatedDeploymentEnvironmentType>
    >;
};

/** Conditional selection for filter field of issue-associated-deployment relationship queries */
export type GraphStoreIssueAssociatedDeploymentFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreIssueAssociatedDeploymentConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreIssueAssociatedDeploymentConditionalFilterInput>
        >
    >;
};

export type GraphStoreIssueAssociatedDeploymentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_author?: InputMaybe<GraphStoreIssueAssociatedDeploymentAuthorSortInput>;
    to_environmentType?: InputMaybe<GraphStoreSortInput>;
    to_state?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedDesignSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedFeatureFlagSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedIssueRemoteLinkSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedPrSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueAssociatedRemoteLinkSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueChangesComponentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueHasAssigneeSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueHasAutodevJobSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueMentionedInConversationSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueMentionedInMessageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueRecursiveAssociatedPrSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreIssueToWhiteboardSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJiraEpicContributesToAtlasGoalSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJiraIssueBlockedByJiraIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJiraIssueToJiraPrioritySortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJiraProjectAssociatedAtlasGoalSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJsmProjectAssociatedServiceSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJswProjectAssociatedComponentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJswProjectAssociatedIncidentConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_affectedServiceAris?: InputMaybe<GraphStoreAriFilterInput>;
    to_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_majorIncident?: InputMaybe<GraphStoreBooleanFilterInput>;
    to_priority?: InputMaybe<GraphStoreJswProjectAssociatedIncidentJiraIncidentPriorityFilterInput>;
    to_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_status?: InputMaybe<GraphStoreJswProjectAssociatedIncidentJiraIncidentStatusFilterInput>;
};

/** Conditional selection for filter field of jsw-project-associated-incident relationship queries */
export type GraphStoreJswProjectAssociatedIncidentFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreJswProjectAssociatedIncidentConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreJswProjectAssociatedIncidentConditionalFilterInput>
        >
    >;
};

export enum GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5",
    Pending = "PENDING",
    Unknown = "UNKNOWN"
}

export type GraphStoreJswProjectAssociatedIncidentJiraIncidentPriorityFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority>
        >;
    };

export enum GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    NotSet = "NOT_SET",
    Undefined = "UNDEFINED"
}

export type GraphStoreJswProjectAssociatedIncidentJiraIncidentStatusFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus>
        >;
    };

export type GraphStoreJswProjectAssociatedIncidentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_affectedServiceAris?: InputMaybe<GraphStoreSortInput>;
    to_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    to_majorIncident?: InputMaybe<GraphStoreSortInput>;
    to_priority?: InputMaybe<GraphStoreSortInput>;
    to_reporterAri?: InputMaybe<GraphStoreSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreJswProjectSharesComponentWithJsmProjectSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreLinkedProjectHasVersionSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreLongFilterInput = {
    greaterThan?: InputMaybe<Scalars["Long"]["input"]>;
    greaterThanOrEqual?: InputMaybe<Scalars["Long"]["input"]>;
    is?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    isNot?: InputMaybe<Array<Scalars["Long"]["input"]>>;
    lessThan?: InputMaybe<Scalars["Long"]["input"]>;
    lessThanOrEqual?: InputMaybe<Scalars["Long"]["input"]>;
};

export type GraphStoreLoomVideoSharedWithUserSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreMediaAttachedToContentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreMeetingHasMeetingNotesPageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreMeetingRecordingOwnerHasMeetingNotesFolderSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreMeetingRecurrenceHasMeetingRecurrenceNotesPageSortInput =
    {
        /** Sort by the date the relationship was last changed */
        lastModified?: InputMaybe<GraphStoreSortInput>;
    };

export type GraphStoreMutation = {
    __typename?: "GraphStoreMutation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentImpactedByIncident")' query directive to the 'createComponentImpactedByIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createComponentImpactedByIncident?: Maybe<GraphStoreCreateComponentImpactedByIncidentPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'createIncidentAssociatedPostIncidentReviewLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createIncidentAssociatedPostIncidentReviewLink?: Maybe<GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'createIncidentHasActionItem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createIncidentHasActionItem?: Maybe<GraphStoreCreateIncidentHasActionItemPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'createIncidentLinkedJswIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createIncidentLinkedJswIssue?: Maybe<GraphStoreCreateIncidentLinkedJswIssuePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueToWhiteboard")' query directive to the 'createIssueToWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createIssueToWhiteboard?: Maybe<GraphStoreCreateIssueToWhiteboardPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedComponent")' query directive to the 'createJswProjectAssociatedComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createJswProjectAssociatedComponent?: Maybe<GraphStoreCreateJswProjectAssociatedComponentPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMeetingRecordingOwnerHasMeetingNotesFolder")' query directive to the 'createMeetingRecordingOwnerHasMeetingNotesFolder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createMeetingRecordingOwnerHasMeetingNotesFolder?: Maybe<GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedOpsgenieTeam")' query directive to the 'createProjectAssociatedOpsgenieTeam' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectAssociatedOpsgenieTeam?: Maybe<GraphStoreCreateProjectAssociatedOpsgenieTeamPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToSecurityContainer")' query directive to the 'createProjectAssociatedToSecurityContainer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectAssociatedToSecurityContainer?: Maybe<GraphStoreCreateProjectAssociatedToSecurityContainerPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDisassociatedRepo")' query directive to the 'createProjectDisassociatedRepo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectDisassociatedRepo?: Maybe<GraphStoreCreateProjectDisassociatedRepoPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationEntity")' query directive to the 'createProjectDocumentationEntity' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectDocumentationEntity?: Maybe<GraphStoreCreateProjectDocumentationEntityPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationPage")' query directive to the 'createProjectDocumentationPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectDocumentationPage?: Maybe<GraphStoreCreateProjectDocumentationPagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationSpace")' query directive to the 'createProjectDocumentationSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectDocumentationSpace?: Maybe<GraphStoreCreateProjectDocumentationSpacePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasRelatedWorkWithProject")' query directive to the 'createProjectHasRelatedWorkWithProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectHasRelatedWorkWithProject?: Maybe<GraphStoreCreateProjectHasRelatedWorkWithProjectPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasSharedVersionWith")' query directive to the 'createProjectHasSharedVersionWith' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectHasSharedVersionWith?: Maybe<GraphStoreCreateProjectHasSharedVersionWithPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasVersion")' query directive to the 'createProjectHasVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectHasVersion?: Maybe<GraphStoreCreateProjectHasVersionPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectivePage")' query directive to the 'createSprintRetrospectivePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createSprintRetrospectivePage?: Maybe<GraphStoreCreateSprintRetrospectivePagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectiveWhiteboard")' query directive to the 'createSprintRetrospectiveWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createSprintRetrospectiveWhiteboard?: Maybe<GraphStoreCreateSprintRetrospectiveWhiteboardPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamConnectedToContainer")' query directive to the 'createTeamConnectedToContainer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createTeamConnectedToContainer?: Maybe<GraphStoreCreateTeamConnectedToContainerPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTownsquareTagIsAliasOfTownsquareTag")' query directive to the 'createTownsquareTagIsAliasOfTownsquareTag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createTownsquareTagIsAliasOfTownsquareTag?: Maybe<GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasRelevantProject")' query directive to the 'createUserHasRelevantProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createUserHasRelevantProject?: Maybe<GraphStoreCreateUserHasRelevantProjectPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionUserAssociatedFeatureFlag")' query directive to the 'createVersionUserAssociatedFeatureFlag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createVersionUserAssociatedFeatureFlag?: Maybe<GraphStoreCreateVersionUserAssociatedFeatureFlagPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVulnerabilityAssociatedIssue")' query directive to the 'createVulnerabilityAssociatedIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createVulnerabilityAssociatedIssue?: Maybe<GraphStoreCreateVulnerabilityAssociatedIssuePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreComponentImpactedByIncident")' query directive to the 'deleteComponentImpactedByIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteComponentImpactedByIncident?: Maybe<GraphStoreDeleteComponentImpactedByIncidentPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentAssociatedPostIncidentReviewLink")' query directive to the 'deleteIncidentAssociatedPostIncidentReviewLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteIncidentAssociatedPostIncidentReviewLink?: Maybe<GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentHasActionItem")' query directive to the 'deleteIncidentHasActionItem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteIncidentHasActionItem?: Maybe<GraphStoreDeleteIncidentHasActionItemPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIncidentLinkedJswIssue")' query directive to the 'deleteIncidentLinkedJswIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteIncidentLinkedJswIssue?: Maybe<GraphStoreDeleteIncidentLinkedJswIssuePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueToWhiteboard")' query directive to the 'deleteIssueToWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteIssueToWhiteboard?: Maybe<GraphStoreDeleteIssueToWhiteboardPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreJswProjectAssociatedComponent")' query directive to the 'deleteJswProjectAssociatedComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteJswProjectAssociatedComponent?: Maybe<GraphStoreDeleteJswProjectAssociatedComponentPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMeetingRecordingOwnerHasMeetingNotesFolder")' query directive to the 'deleteMeetingRecordingOwnerHasMeetingNotesFolder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteMeetingRecordingOwnerHasMeetingNotesFolder?: Maybe<GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedOpsgenieTeam")' query directive to the 'deleteProjectAssociatedOpsgenieTeam' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectAssociatedOpsgenieTeam?: Maybe<GraphStoreDeleteProjectAssociatedOpsgenieTeamPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedToSecurityContainer")' query directive to the 'deleteProjectAssociatedToSecurityContainer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectAssociatedToSecurityContainer?: Maybe<GraphStoreDeleteProjectAssociatedToSecurityContainerPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDisassociatedRepo")' query directive to the 'deleteProjectDisassociatedRepo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectDisassociatedRepo?: Maybe<GraphStoreDeleteProjectDisassociatedRepoPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationEntity")' query directive to the 'deleteProjectDocumentationEntity' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectDocumentationEntity?: Maybe<GraphStoreDeleteProjectDocumentationEntityPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationPage")' query directive to the 'deleteProjectDocumentationPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectDocumentationPage?: Maybe<GraphStoreDeleteProjectDocumentationPagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectDocumentationSpace")' query directive to the 'deleteProjectDocumentationSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectDocumentationSpace?: Maybe<GraphStoreDeleteProjectDocumentationSpacePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasRelatedWorkWithProject")' query directive to the 'deleteProjectHasRelatedWorkWithProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectHasRelatedWorkWithProject?: Maybe<GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasSharedVersionWith")' query directive to the 'deleteProjectHasSharedVersionWith' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectHasSharedVersionWith?: Maybe<GraphStoreDeleteProjectHasSharedVersionWithPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectHasVersion")' query directive to the 'deleteProjectHasVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectHasVersion?: Maybe<GraphStoreDeleteProjectHasVersionPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectivePage")' query directive to the 'deleteSprintRetrospectivePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteSprintRetrospectivePage?: Maybe<GraphStoreDeleteSprintRetrospectivePagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreSprintRetrospectiveWhiteboard")' query directive to the 'deleteSprintRetrospectiveWhiteboard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteSprintRetrospectiveWhiteboard?: Maybe<GraphStoreDeleteSprintRetrospectiveWhiteboardPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTeamConnectedToContainer")' query directive to the 'deleteTeamConnectedToContainer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteTeamConnectedToContainer?: Maybe<GraphStoreDeleteTeamConnectedToContainerPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreTownsquareTagIsAliasOfTownsquareTag")' query directive to the 'deleteTownsquareTagIsAliasOfTownsquareTag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteTownsquareTagIsAliasOfTownsquareTag?: Maybe<GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreUserHasRelevantProject")' query directive to the 'deleteUserHasRelevantProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteUserHasRelevantProject?: Maybe<GraphStoreDeleteUserHasRelevantProjectPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVersionUserAssociatedFeatureFlag")' query directive to the 'deleteVersionUserAssociatedFeatureFlag' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteVersionUserAssociatedFeatureFlag?: Maybe<GraphStoreDeleteVersionUserAssociatedFeatureFlagPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreVulnerabilityAssociatedIssue")' query directive to the 'deleteVulnerabilityAssociatedIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteVulnerabilityAssociatedIssue?: Maybe<GraphStoreDeleteVulnerabilityAssociatedIssuePayload>;
};

export type GraphStoreMutationCreateComponentImpactedByIncidentArgs = {
    input?: InputMaybe<GraphStoreCreateComponentImpactedByIncidentInput>;
};

export type GraphStoreMutationCreateIncidentAssociatedPostIncidentReviewLinkArgs =
    {
        input?: InputMaybe<GraphStoreCreateIncidentAssociatedPostIncidentReviewLinkInput>;
    };

export type GraphStoreMutationCreateIncidentHasActionItemArgs = {
    input?: InputMaybe<GraphStoreCreateIncidentHasActionItemInput>;
};

export type GraphStoreMutationCreateIncidentLinkedJswIssueArgs = {
    input?: InputMaybe<GraphStoreCreateIncidentLinkedJswIssueInput>;
};

export type GraphStoreMutationCreateIssueToWhiteboardArgs = {
    input?: InputMaybe<GraphStoreCreateIssueToWhiteboardInput>;
};

export type GraphStoreMutationCreateJswProjectAssociatedComponentArgs = {
    input?: InputMaybe<GraphStoreCreateJswProjectAssociatedComponentInput>;
};

export type GraphStoreMutationCreateMeetingRecordingOwnerHasMeetingNotesFolderArgs =
    {
        input?: InputMaybe<GraphStoreCreateMeetingRecordingOwnerHasMeetingNotesFolderInput>;
    };

export type GraphStoreMutationCreateProjectAssociatedOpsgenieTeamArgs = {
    input?: InputMaybe<GraphStoreCreateProjectAssociatedOpsgenieTeamInput>;
};

export type GraphStoreMutationCreateProjectAssociatedToSecurityContainerArgs = {
    input?: InputMaybe<GraphStoreCreateProjectAssociatedToSecurityContainerInput>;
};

export type GraphStoreMutationCreateProjectDisassociatedRepoArgs = {
    input?: InputMaybe<GraphStoreCreateProjectDisassociatedRepoInput>;
};

export type GraphStoreMutationCreateProjectDocumentationEntityArgs = {
    input?: InputMaybe<GraphStoreCreateProjectDocumentationEntityInput>;
};

export type GraphStoreMutationCreateProjectDocumentationPageArgs = {
    input?: InputMaybe<GraphStoreCreateProjectDocumentationPageInput>;
};

export type GraphStoreMutationCreateProjectDocumentationSpaceArgs = {
    input?: InputMaybe<GraphStoreCreateProjectDocumentationSpaceInput>;
};

export type GraphStoreMutationCreateProjectHasRelatedWorkWithProjectArgs = {
    input?: InputMaybe<GraphStoreCreateProjectHasRelatedWorkWithProjectInput>;
};

export type GraphStoreMutationCreateProjectHasSharedVersionWithArgs = {
    input?: InputMaybe<GraphStoreCreateProjectHasSharedVersionWithInput>;
};

export type GraphStoreMutationCreateProjectHasVersionArgs = {
    input?: InputMaybe<GraphStoreCreateProjectHasVersionInput>;
};

export type GraphStoreMutationCreateSprintRetrospectivePageArgs = {
    input?: InputMaybe<GraphStoreCreateSprintRetrospectivePageInput>;
};

export type GraphStoreMutationCreateSprintRetrospectiveWhiteboardArgs = {
    input?: InputMaybe<GraphStoreCreateSprintRetrospectiveWhiteboardInput>;
};

export type GraphStoreMutationCreateTeamConnectedToContainerArgs = {
    input?: InputMaybe<GraphStoreCreateTeamConnectedToContainerInput>;
};

export type GraphStoreMutationCreateTownsquareTagIsAliasOfTownsquareTagArgs = {
    input?: InputMaybe<GraphStoreCreateTownsquareTagIsAliasOfTownsquareTagInput>;
};

export type GraphStoreMutationCreateUserHasRelevantProjectArgs = {
    input?: InputMaybe<GraphStoreCreateUserHasRelevantProjectInput>;
};

export type GraphStoreMutationCreateVersionUserAssociatedFeatureFlagArgs = {
    input?: InputMaybe<GraphStoreCreateVersionUserAssociatedFeatureFlagInput>;
};

export type GraphStoreMutationCreateVulnerabilityAssociatedIssueArgs = {
    input?: InputMaybe<GraphStoreCreateVulnerabilityAssociatedIssueInput>;
};

export type GraphStoreMutationDeleteComponentImpactedByIncidentArgs = {
    input?: InputMaybe<GraphStoreDeleteComponentImpactedByIncidentInput>;
};

export type GraphStoreMutationDeleteIncidentAssociatedPostIncidentReviewLinkArgs =
    {
        input?: InputMaybe<GraphStoreDeleteIncidentAssociatedPostIncidentReviewLinkInput>;
    };

export type GraphStoreMutationDeleteIncidentHasActionItemArgs = {
    input?: InputMaybe<GraphStoreDeleteIncidentHasActionItemInput>;
};

export type GraphStoreMutationDeleteIncidentLinkedJswIssueArgs = {
    input?: InputMaybe<GraphStoreDeleteIncidentLinkedJswIssueInput>;
};

export type GraphStoreMutationDeleteIssueToWhiteboardArgs = {
    input?: InputMaybe<GraphStoreDeleteIssueToWhiteboardInput>;
};

export type GraphStoreMutationDeleteJswProjectAssociatedComponentArgs = {
    input?: InputMaybe<GraphStoreDeleteJswProjectAssociatedComponentInput>;
};

export type GraphStoreMutationDeleteMeetingRecordingOwnerHasMeetingNotesFolderArgs =
    {
        input?: InputMaybe<GraphStoreDeleteMeetingRecordingOwnerHasMeetingNotesFolderInput>;
    };

export type GraphStoreMutationDeleteProjectAssociatedOpsgenieTeamArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectAssociatedOpsgenieTeamInput>;
};

export type GraphStoreMutationDeleteProjectAssociatedToSecurityContainerArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectAssociatedToSecurityContainerInput>;
};

export type GraphStoreMutationDeleteProjectDisassociatedRepoArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectDisassociatedRepoInput>;
};

export type GraphStoreMutationDeleteProjectDocumentationEntityArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectDocumentationEntityInput>;
};

export type GraphStoreMutationDeleteProjectDocumentationPageArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectDocumentationPageInput>;
};

export type GraphStoreMutationDeleteProjectDocumentationSpaceArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectDocumentationSpaceInput>;
};

export type GraphStoreMutationDeleteProjectHasRelatedWorkWithProjectArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectHasRelatedWorkWithProjectInput>;
};

export type GraphStoreMutationDeleteProjectHasSharedVersionWithArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectHasSharedVersionWithInput>;
};

export type GraphStoreMutationDeleteProjectHasVersionArgs = {
    input?: InputMaybe<GraphStoreDeleteProjectHasVersionInput>;
};

export type GraphStoreMutationDeleteSprintRetrospectivePageArgs = {
    input?: InputMaybe<GraphStoreDeleteSprintRetrospectivePageInput>;
};

export type GraphStoreMutationDeleteSprintRetrospectiveWhiteboardArgs = {
    input?: InputMaybe<GraphStoreDeleteSprintRetrospectiveWhiteboardInput>;
};

export type GraphStoreMutationDeleteTeamConnectedToContainerArgs = {
    input?: InputMaybe<GraphStoreDeleteTeamConnectedToContainerInput>;
};

export type GraphStoreMutationDeleteTownsquareTagIsAliasOfTownsquareTagArgs = {
    input?: InputMaybe<GraphStoreDeleteTownsquareTagIsAliasOfTownsquareTagInput>;
};

export type GraphStoreMutationDeleteUserHasRelevantProjectArgs = {
    input?: InputMaybe<GraphStoreDeleteUserHasRelevantProjectInput>;
};

export type GraphStoreMutationDeleteVersionUserAssociatedFeatureFlagArgs = {
    input?: InputMaybe<GraphStoreDeleteVersionUserAssociatedFeatureFlagInput>;
};

export type GraphStoreMutationDeleteVulnerabilityAssociatedIssueArgs = {
    input?: InputMaybe<GraphStoreDeleteVulnerabilityAssociatedIssueInput>;
};

export type GraphStoreOperationsContainerImpactedByIncidentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreOperationsContainerImprovedByActionItemSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreParentCommentHasChildCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreParentDocumentHasChildDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreParentIssueHasChildIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreParentMessageHasChildMessageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStorePositionAllocatedToFocusAreaSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStorePrInRepoSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedBranchSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreProjectAssociatedBuildBuildState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreProjectAssociatedBuildBuildStateFilterInput = {
    is?: InputMaybe<Array<GraphStoreProjectAssociatedBuildBuildState>>;
    isNot?: InputMaybe<Array<GraphStoreProjectAssociatedBuildBuildState>>;
};

export type GraphStoreProjectAssociatedBuildConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_state?: InputMaybe<GraphStoreProjectAssociatedBuildBuildStateFilterInput>;
    to_testInfo?: InputMaybe<GraphStoreProjectAssociatedBuildTestInfoFilterInput>;
};

/** Conditional selection for filter field of project-associated-build relationship queries */
export type GraphStoreProjectAssociatedBuildFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedBuildConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedBuildConditionalFilterInput>
        >
    >;
};

export type GraphStoreProjectAssociatedBuildSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreSortInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_state?: InputMaybe<GraphStoreSortInput>;
    to_testInfo?: InputMaybe<GraphStoreProjectAssociatedBuildTestInfoSortInput>;
};

export type GraphStoreProjectAssociatedBuildTestInfoFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedBuildTestInfoFilterInput>>
    >;
    numberFailed?: InputMaybe<GraphStoreLongFilterInput>;
    numberPassed?: InputMaybe<GraphStoreLongFilterInput>;
    numberSkipped?: InputMaybe<GraphStoreLongFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedBuildTestInfoFilterInput>>
    >;
    totalNumber?: InputMaybe<GraphStoreLongFilterInput>;
};

export type GraphStoreProjectAssociatedBuildTestInfoSortInput = {
    numberFailed?: InputMaybe<GraphStoreSortInput>;
    numberPassed?: InputMaybe<GraphStoreSortInput>;
    numberSkipped?: InputMaybe<GraphStoreSortInput>;
    totalNumber?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedDeploymentAuthorFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedDeploymentAuthorFilterInput>
        >
    >;
    authorAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedDeploymentAuthorFilterInput>
        >
    >;
};

export type GraphStoreProjectAssociatedDeploymentAuthorSortInput = {
    authorAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedDeploymentConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_fixVersionIds?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_issueTypeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_author?: InputMaybe<GraphStoreProjectAssociatedDeploymentAuthorFilterInput>;
    to_deploymentLastUpdated?: InputMaybe<GraphStoreLongFilterInput>;
    to_environmentType?: InputMaybe<GraphStoreProjectAssociatedDeploymentEnvironmentTypeFilterInput>;
    to_state?: InputMaybe<GraphStoreProjectAssociatedDeploymentDeploymentStateFilterInput>;
};

export enum GraphStoreProjectAssociatedDeploymentDeploymentState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreProjectAssociatedDeploymentDeploymentStateFilterInput = {
    is?: InputMaybe<
        Array<GraphStoreProjectAssociatedDeploymentDeploymentState>
    >;
    isNot?: InputMaybe<
        Array<GraphStoreProjectAssociatedDeploymentDeploymentState>
    >;
};

export enum GraphStoreProjectAssociatedDeploymentEnvironmentType {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type GraphStoreProjectAssociatedDeploymentEnvironmentTypeFilterInput = {
    is?: InputMaybe<
        Array<GraphStoreProjectAssociatedDeploymentEnvironmentType>
    >;
    isNot?: InputMaybe<
        Array<GraphStoreProjectAssociatedDeploymentEnvironmentType>
    >;
};

/** Conditional selection for filter field of project-associated-deployment relationship queries */
export type GraphStoreProjectAssociatedDeploymentFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedDeploymentConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedDeploymentConditionalFilterInput>
        >
    >;
};

export type GraphStoreProjectAssociatedDeploymentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreSortInput>;
    relationship_fixVersionIds?: InputMaybe<GraphStoreSortInput>;
    relationship_issueAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_issueTypeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreSortInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_author?: InputMaybe<GraphStoreProjectAssociatedDeploymentAuthorSortInput>;
    to_deploymentLastUpdated?: InputMaybe<GraphStoreSortInput>;
    to_environmentType?: InputMaybe<GraphStoreSortInput>;
    to_state?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedFeatureFlagSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedIncidentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedOpsgenieTeamSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedPrAuthorFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedPrAuthorFilterInput>>
    >;
    authorAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedPrAuthorFilterInput>>
    >;
};

export type GraphStoreProjectAssociatedPrAuthorSortInput = {
    authorAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedPrConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_author?: InputMaybe<GraphStoreProjectAssociatedPrAuthorFilterInput>;
    to_reviewers?: InputMaybe<GraphStoreProjectAssociatedPrReviewerFilterInput>;
    to_status?: InputMaybe<GraphStoreProjectAssociatedPrPullRequestStatusFilterInput>;
    to_taskCount?: InputMaybe<GraphStoreFloatFilterInput>;
};

/** Conditional selection for filter field of project-associated-pr relationship queries */
export type GraphStoreProjectAssociatedPrFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedPrConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedPrConditionalFilterInput>>
    >;
};

export enum GraphStoreProjectAssociatedPrPullRequestStatus {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreProjectAssociatedPrPullRequestStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreProjectAssociatedPrPullRequestStatus>>;
    isNot?: InputMaybe<Array<GraphStoreProjectAssociatedPrPullRequestStatus>>;
};

export type GraphStoreProjectAssociatedPrReviewerFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedPrReviewerFilterInput>>
    >;
    approvalStatus?: InputMaybe<GraphStoreProjectAssociatedPrReviewerReviewerStatusFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedPrReviewerFilterInput>>
    >;
    reviewerAri?: InputMaybe<GraphStoreAriFilterInput>;
};

export enum GraphStoreProjectAssociatedPrReviewerReviewerStatus {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphStoreProjectAssociatedPrReviewerReviewerStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreProjectAssociatedPrReviewerReviewerStatus>>;
    isNot?: InputMaybe<
        Array<GraphStoreProjectAssociatedPrReviewerReviewerStatus>
    >;
};

export type GraphStoreProjectAssociatedPrReviewerSortInput = {
    approvalStatus?: InputMaybe<GraphStoreSortInput>;
    reviewerAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedPrSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreSortInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_author?: InputMaybe<GraphStoreProjectAssociatedPrAuthorSortInput>;
    to_reviewers?: InputMaybe<GraphStoreProjectAssociatedPrReviewerSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
    to_taskCount?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedRepoConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_providerAri?: InputMaybe<GraphStoreAriFilterInput>;
};

/** Conditional selection for filter field of project-associated-repo relationship queries */
export type GraphStoreProjectAssociatedRepoFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedRepoConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectAssociatedRepoConditionalFilterInput>>
    >;
};

export type GraphStoreProjectAssociatedRepoSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_providerAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedServiceSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedToIncidentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedToOperationsContainerSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedToSecurityContainerSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectAssociatedVulnerabilityConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_container?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityContainerFilterInput>;
    to_severity?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverityFilterInput>;
    to_status?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatusFilterInput>;
    to_type?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityVulnerabilityTypeFilterInput>;
};

export type GraphStoreProjectAssociatedVulnerabilityContainerFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedVulnerabilityContainerFilterInput>
        >
    >;
    containerAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedVulnerabilityContainerFilterInput>
        >
    >;
};

export type GraphStoreProjectAssociatedVulnerabilityContainerSortInput = {
    containerAri?: InputMaybe<GraphStoreSortInput>;
};

/** Conditional selection for filter field of project-associated-vulnerability relationship queries */
export type GraphStoreProjectAssociatedVulnerabilityFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedVulnerabilityConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreProjectAssociatedVulnerabilityConditionalFilterInput>
        >
    >;
};

export type GraphStoreProjectAssociatedVulnerabilitySortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_container?: InputMaybe<GraphStoreProjectAssociatedVulnerabilityContainerSortInput>;
    to_severity?: InputMaybe<GraphStoreSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
    to_type?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export type GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverityFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity>
        >;
    };

export enum GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatusFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus>
        >;
    };

export enum GraphStoreProjectAssociatedVulnerabilityVulnerabilityType {
    Dast = "DAST",
    NotSet = "NOT_SET",
    Sast = "SAST",
    Sca = "SCA",
    Unknown = "UNKNOWN"
}

export type GraphStoreProjectAssociatedVulnerabilityVulnerabilityTypeFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreProjectAssociatedVulnerabilityVulnerabilityType>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreProjectAssociatedVulnerabilityVulnerabilityType>
        >;
    };

export type GraphStoreProjectDisassociatedRepoSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectDocumentationEntitySortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectDocumentationPageSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectDocumentationSpaceSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectExplicitlyAssociatedRepoSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_providerAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectHasIssueConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_fixVersionIds?: InputMaybe<GraphStoreLongFilterInput>;
    to_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_issueTypeAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
};

/** Conditional selection for filter field of project-has-issue relationship queries */
export type GraphStoreProjectHasIssueFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectHasIssueConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreProjectHasIssueConditionalFilterInput>>
    >;
};

export type GraphStoreProjectHasIssueSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_sprintAris?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    to_creatorAri?: InputMaybe<GraphStoreSortInput>;
    to_fixVersionIds?: InputMaybe<GraphStoreSortInput>;
    to_issueAri?: InputMaybe<GraphStoreSortInput>;
    to_issueTypeAri?: InputMaybe<GraphStoreSortInput>;
    to_reporterAri?: InputMaybe<GraphStoreSortInput>;
    to_statusAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectHasRelatedWorkWithProjectSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectHasSharedVersionWithSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectHasVersionSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreProjectLinkedToCompassComponentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStorePullRequestLinksToServiceSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSecurityContainerAssociatedToVulnerabilitySortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreServiceAssociatedBranchSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreServiceAssociatedDeploymentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreServiceAssociatedRemoteLinkSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreServiceAssociatedTeamSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreServiceLinkedIncidentConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_affectedServiceAris?: InputMaybe<GraphStoreAriFilterInput>;
    to_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_majorIncident?: InputMaybe<GraphStoreBooleanFilterInput>;
    to_priority?: InputMaybe<GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriorityFilterInput>;
    to_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_status?: InputMaybe<GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatusFilterInput>;
};

/** Conditional selection for filter field of service-linked-incident relationship queries */
export type GraphStoreServiceLinkedIncidentFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreServiceLinkedIncidentConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreServiceLinkedIncidentConditionalFilterInput>>
    >;
};

export enum GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority {
    NotSet = "NOT_SET",
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5"
}

export type GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriorityFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority>
        >;
    };

export enum GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    NotSet = "NOT_SET",
    Undefined = "UNDEFINED"
}

export type GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatusFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus>
        >;
    };

export type GraphStoreServiceLinkedIncidentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_affectedServiceAris?: InputMaybe<GraphStoreSortInput>;
    to_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    to_majorIncident?: InputMaybe<GraphStoreSortInput>;
    to_priority?: InputMaybe<GraphStoreSortInput>;
    to_reporterAri?: InputMaybe<GraphStoreSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
};

/** A simplified connection for the relationship type atlas-goal-has-contributor */
export type GraphStoreSimplifiedAtlasGoalHasContributorConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasContributorConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasContributorEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-contributor */
export type GraphStoreSimplifiedAtlasGoalHasContributorEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasContributorEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasContributorUnion>;
};

/** A simplified connection for the relationship type atlas-goal-has-contributor */
export type GraphStoreSimplifiedAtlasGoalHasContributorInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasContributorInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasContributorInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-contributor */
export type GraphStoreSimplifiedAtlasGoalHasContributorInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasContributorInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasContributorInverseUnion>;
};

/** A union of the possible hydration types for atlas-goal-has-contributor: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasContributorInverseUnion =
    TownsquareGoal;

/** A union of the possible hydration types for atlas-goal-has-contributor: [TeamV2] */
export type GraphStoreSimplifiedAtlasGoalHasContributorUnion = TeamV2;

/** A simplified connection for the relationship type atlas-goal-has-follower */
export type GraphStoreSimplifiedAtlasGoalHasFollowerConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasFollowerConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedAtlasGoalHasFollowerEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type atlas-goal-has-follower */
export type GraphStoreSimplifiedAtlasGoalHasFollowerEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasFollowerEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasFollowerUnion>;
};

/** A simplified connection for the relationship type atlas-goal-has-follower */
export type GraphStoreSimplifiedAtlasGoalHasFollowerInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasFollowerInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasFollowerInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-follower */
export type GraphStoreSimplifiedAtlasGoalHasFollowerInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasFollowerInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasFollowerInverseUnion>;
};

/** A union of the possible hydration types for atlas-goal-has-follower: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasFollowerInverseUnion =
    TownsquareGoal;

/** A union of the possible hydration types for atlas-goal-has-follower: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedAtlasGoalHasFollowerUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type atlas-goal-has-goal-update */
export type GraphStoreSimplifiedAtlasGoalHasGoalUpdateConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasGoalUpdateConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasGoalUpdateEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-goal-update */
export type GraphStoreSimplifiedAtlasGoalHasGoalUpdateEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasGoalUpdateEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal-update]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasGoalUpdateUnion>;
};

/** A simplified connection for the relationship type atlas-goal-has-goal-update */
export type GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-goal-update */
export type GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseUnion>;
};

/** A union of the possible hydration types for atlas-goal-has-goal-update: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasGoalUpdateInverseUnion =
    TownsquareGoal;

/** A union of the possible hydration types for atlas-goal-has-goal-update: [TownsquareGoalUpdate] */
export type GraphStoreSimplifiedAtlasGoalHasGoalUpdateUnion =
    TownsquareGoalUpdate;

/** A simplified connection for the relationship type atlas-goal-has-owner */
export type GraphStoreSimplifiedAtlasGoalHasOwnerConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasOwnerConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedAtlasGoalHasOwnerEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type atlas-goal-has-owner */
export type GraphStoreSimplifiedAtlasGoalHasOwnerEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasOwnerEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasOwnerUnion>;
};

/** A simplified connection for the relationship type atlas-goal-has-owner */
export type GraphStoreSimplifiedAtlasGoalHasOwnerInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasOwnerInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasOwnerInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-owner */
export type GraphStoreSimplifiedAtlasGoalHasOwnerInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasOwnerInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasOwnerInverseUnion>;
};

/** A union of the possible hydration types for atlas-goal-has-owner: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasOwnerInverseUnion = TownsquareGoal;

/** A union of the possible hydration types for atlas-goal-has-owner: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedAtlasGoalHasOwnerUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type atlas-goal-has-sub-atlas-goal */
export type GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-sub-atlas-goal */
export type GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalUnion>;
};

/** A simplified connection for the relationship type atlas-goal-has-sub-atlas-goal */
export type GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-goal-has-sub-atlas-goal */
export type GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseUnion>;
};

/** A union of the possible hydration types for atlas-goal-has-sub-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalInverseUnion =
    TownsquareGoal;

/** A union of the possible hydration types for atlas-goal-has-sub-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasSubAtlasGoalUnion = TownsquareGoal;

/** A simplified connection for the relationship type atlas-goal-has-update */
export type GraphStoreSimplifiedAtlasGoalHasUpdateConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedAtlasGoalHasUpdateConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedAtlasGoalHasUpdateEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type atlas-goal-has-update */
export type GraphStoreSimplifiedAtlasGoalHasUpdateEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasUpdateEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal-update]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasUpdateUnion>;
};

/** A simplified connection for the relationship type atlas-goal-has-update */
export type GraphStoreSimplifiedAtlasGoalHasUpdateInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedAtlasGoalHasUpdateInverseConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedAtlasGoalHasUpdateInverseEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type atlas-goal-has-update */
export type GraphStoreSimplifiedAtlasGoalHasUpdateInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasGoalHasUpdateInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasGoalHasUpdateInverseUnion>;
};

/** A union of the possible hydration types for atlas-goal-has-update: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasGoalHasUpdateInverseUnion = TownsquareGoal;

/** A union of the possible hydration types for atlas-goal-has-update: [TownsquareGoalUpdate] */
export type GraphStoreSimplifiedAtlasGoalHasUpdateUnion = TownsquareGoalUpdate;

/** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */
export type GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */
export type GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalUnion>;
};

/** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */
export type GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */
export type GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseUnion>;
    };

/** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedAtlasProjectContributesToAtlasGoalUnion =
    TownsquareGoal;

/** A simplified connection for the relationship type atlas-project-depends-on-atlas-project */
export type GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-depends-on-atlas-project */
export type GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectUnion>;
};

/** A simplified connection for the relationship type atlas-project-depends-on-atlas-project */
export type GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-depends-on-atlas-project */
export type GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-depends-on-atlas-project: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-depends-on-atlas-project: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectDependsOnAtlasProjectUnion =
    TownsquareProject;

/** A simplified connection for the relationship type atlas-project-has-contributor */
export type GraphStoreSimplifiedAtlasProjectHasContributorConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasContributorConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasProjectHasContributorEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-contributor */
export type GraphStoreSimplifiedAtlasProjectHasContributorEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasContributorEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasContributorUnion>;
};

/** A simplified connection for the relationship type atlas-project-has-contributor */
export type GraphStoreSimplifiedAtlasProjectHasContributorInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasContributorInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectHasContributorInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-contributor */
export type GraphStoreSimplifiedAtlasProjectHasContributorInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasContributorInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasContributorInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-has-contributor: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectHasContributorInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-has-contributor: [AtlassianAccountUser, CustomerUser, AppUser, TeamV2] */
export type GraphStoreSimplifiedAtlasProjectHasContributorUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | TeamV2;

/** A simplified connection for the relationship type atlas-project-has-follower */
export type GraphStoreSimplifiedAtlasProjectHasFollowerConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasFollowerConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasProjectHasFollowerEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-follower */
export type GraphStoreSimplifiedAtlasProjectHasFollowerEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasFollowerEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasFollowerUnion>;
};

/** A simplified connection for the relationship type atlas-project-has-follower */
export type GraphStoreSimplifiedAtlasProjectHasFollowerInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasFollowerInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasProjectHasFollowerInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-follower */
export type GraphStoreSimplifiedAtlasProjectHasFollowerInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasFollowerInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasFollowerInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-has-follower: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectHasFollowerInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-has-follower: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedAtlasProjectHasFollowerUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type atlas-project-has-owner */
export type GraphStoreSimplifiedAtlasProjectHasOwnerConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasOwnerConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedAtlasProjectHasOwnerEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type atlas-project-has-owner */
export type GraphStoreSimplifiedAtlasProjectHasOwnerEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasOwnerEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasOwnerUnion>;
};

/** A simplified connection for the relationship type atlas-project-has-owner */
export type GraphStoreSimplifiedAtlasProjectHasOwnerInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasOwnerInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasProjectHasOwnerInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-owner */
export type GraphStoreSimplifiedAtlasProjectHasOwnerInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasOwnerInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasOwnerInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-has-owner: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectHasOwnerInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-has-owner: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedAtlasProjectHasOwnerUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type atlas-project-has-project-update */
export type GraphStoreSimplifiedAtlasProjectHasProjectUpdateConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasProjectUpdateConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasProjectHasProjectUpdateEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-project-update */
export type GraphStoreSimplifiedAtlasProjectHasProjectUpdateEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasProjectUpdateEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project-update]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasProjectUpdateUnion>;
};

/** A simplified connection for the relationship type atlas-project-has-project-update */
export type GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-has-project-update */
export type GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-has-project-update: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectHasProjectUpdateInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-has-project-update: [TownsquareProjectUpdate] */
export type GraphStoreSimplifiedAtlasProjectHasProjectUpdateUnion =
    TownsquareProjectUpdate;

/** A simplified connection for the relationship type atlas-project-has-update */
export type GraphStoreSimplifiedAtlasProjectHasUpdateConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedAtlasProjectHasUpdateConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedAtlasProjectHasUpdateEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type atlas-project-has-update */
export type GraphStoreSimplifiedAtlasProjectHasUpdateEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasUpdateEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project-update]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasUpdateUnion>;
};

/** A simplified connection for the relationship type atlas-project-has-update */
export type GraphStoreSimplifiedAtlasProjectHasUpdateInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedAtlasProjectHasUpdateInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedAtlasProjectHasUpdateInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type atlas-project-has-update */
export type GraphStoreSimplifiedAtlasProjectHasUpdateInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectHasUpdateInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectHasUpdateInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-has-update: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectHasUpdateInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-has-update: [TownsquareProjectUpdate] */
export type GraphStoreSimplifiedAtlasProjectHasUpdateUnion =
    TownsquareProjectUpdate;

/** A simplified connection for the relationship type atlas-project-is-related-to-atlas-project */
export type GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-is-related-to-atlas-project */
export type GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectUnion>;
};

/** A simplified connection for the relationship type atlas-project-is-related-to-atlas-project */
export type GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-is-related-to-atlas-project */
export type GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseUnion>;
    };

/** A union of the possible hydration types for atlas-project-is-related-to-atlas-project: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-is-related-to-atlas-project: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectIsRelatedToAtlasProjectUnion =
    TownsquareProject;

/** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */
export type GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */
export type GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicUnion>;
};

/** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */
export type GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */
export type GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseEdge = {
    __typename?: "GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseUnion>;
};

/** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */
export type GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicInverseUnion =
    TownsquareProject;

/** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */
export type GraphStoreSimplifiedAtlasProjectIsTrackedOnJiraEpicUnion =
    JiraIssue;

/** A simplified connection for the relationship type board-belongs-to-project */
export type GraphStoreSimplifiedBoardBelongsToProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedBoardBelongsToProjectConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedBoardBelongsToProjectEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type board-belongs-to-project */
export type GraphStoreSimplifiedBoardBelongsToProjectEdge = {
    __typename?: "GraphStoreSimplifiedBoardBelongsToProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedBoardBelongsToProjectUnion>;
};

/** A simplified connection for the relationship type board-belongs-to-project */
export type GraphStoreSimplifiedBoardBelongsToProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedBoardBelongsToProjectInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedBoardBelongsToProjectInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type board-belongs-to-project */
export type GraphStoreSimplifiedBoardBelongsToProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedBoardBelongsToProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira-software:board]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedBoardBelongsToProjectInverseUnion>;
};

/** A union of the possible hydration types for board-belongs-to-project: [JiraBoard] */
export type GraphStoreSimplifiedBoardBelongsToProjectInverseUnion = JiraBoard;

/** A union of the possible hydration types for board-belongs-to-project: [JiraProject] */
export type GraphStoreSimplifiedBoardBelongsToProjectUnion = JiraProject;

/** A simplified connection for the relationship type calendar-has-linked-document */
export type GraphStoreSimplifiedCalendarHasLinkedDocumentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedCalendarHasLinkedDocumentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedCalendarHasLinkedDocumentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type calendar-has-linked-document */
export type GraphStoreSimplifiedCalendarHasLinkedDocumentEdge = {
    __typename?: "GraphStoreSimplifiedCalendarHasLinkedDocumentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedCalendarHasLinkedDocumentUnion>;
};

/** A simplified connection for the relationship type calendar-has-linked-document */
export type GraphStoreSimplifiedCalendarHasLinkedDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedCalendarHasLinkedDocumentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedCalendarHasLinkedDocumentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type calendar-has-linked-document */
export type GraphStoreSimplifiedCalendarHasLinkedDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedCalendarHasLinkedDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:calendar-event]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedCalendarHasLinkedDocumentInverseUnion>;
};

/** A union of the possible hydration types for calendar-has-linked-document: [ExternalCalendarEvent] */
export type GraphStoreSimplifiedCalendarHasLinkedDocumentInverseUnion =
    ExternalCalendarEvent;

/** A union of the possible hydration types for calendar-has-linked-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedCalendarHasLinkedDocumentUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type component-impacted-by-incident */
export type GraphStoreSimplifiedComponentImpactedByIncidentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedComponentImpactedByIncidentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedComponentImpactedByIncidentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type component-impacted-by-incident */
export type GraphStoreSimplifiedComponentImpactedByIncidentEdge = {
    __typename?: "GraphStoreSimplifiedComponentImpactedByIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedComponentImpactedByIncidentUnion>;
};

/** A simplified connection for the relationship type component-impacted-by-incident */
export type GraphStoreSimplifiedComponentImpactedByIncidentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedComponentImpactedByIncidentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedComponentImpactedByIncidentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type component-impacted-by-incident */
export type GraphStoreSimplifiedComponentImpactedByIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedComponentImpactedByIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedComponentImpactedByIncidentInverseUnion>;
};

/** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */
export type GraphStoreSimplifiedComponentImpactedByIncidentInverseUnion =
    | CompassComponent
    | DevOpsOperationsComponentDetails;

/** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedComponentImpactedByIncidentUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A simplified connection for the relationship type component-link-is-jira-project */
export type GraphStoreSimplifiedComponentLinkIsJiraProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedComponentLinkIsJiraProjectConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedComponentLinkIsJiraProjectEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type component-link-is-jira-project */
export type GraphStoreSimplifiedComponentLinkIsJiraProjectEdge = {
    __typename?: "GraphStoreSimplifiedComponentLinkIsJiraProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedComponentLinkIsJiraProjectUnion>;
};

/** A union of the possible hydration types for component-link-is-jira-project: [JiraProject] */
export type GraphStoreSimplifiedComponentLinkIsJiraProjectUnion = JiraProject;

/** A simplified connection for the relationship type component-linked-jsw-issue */
export type GraphStoreSimplifiedComponentLinkedJswIssueConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedComponentLinkedJswIssueConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedComponentLinkedJswIssueEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type component-linked-jsw-issue */
export type GraphStoreSimplifiedComponentLinkedJswIssueEdge = {
    __typename?: "GraphStoreSimplifiedComponentLinkedJswIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedComponentLinkedJswIssueUnion>;
};

/** A simplified connection for the relationship type component-linked-jsw-issue */
export type GraphStoreSimplifiedComponentLinkedJswIssueInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedComponentLinkedJswIssueInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedComponentLinkedJswIssueInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type component-linked-jsw-issue */
export type GraphStoreSimplifiedComponentLinkedJswIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedComponentLinkedJswIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:compass:component, ati:cloud:graph:service, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedComponentLinkedJswIssueInverseUnion>;
};

/** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */
export type GraphStoreSimplifiedComponentLinkedJswIssueInverseUnion =
    | CompassComponent
    | DevOpsOperationsComponentDetails
    | DevOpsService;

/** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */
export type GraphStoreSimplifiedComponentLinkedJswIssueUnion = JiraIssue;

/** A simplified connection for the relationship type confluence-blogpost-has-comment */
export type GraphStoreSimplifiedConfluenceBlogpostHasCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceBlogpostHasCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedConfluenceBlogpostHasCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-blogpost-has-comment */
export type GraphStoreSimplifiedConfluenceBlogpostHasCommentEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceBlogpostHasCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceBlogpostHasCommentUnion>;
};

/** A simplified connection for the relationship type confluence-blogpost-has-comment */
export type GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-blogpost-has-comment */
export type GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseUnion>;
};

/** A union of the possible hydration types for confluence-blogpost-has-comment: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedConfluenceBlogpostHasCommentInverseUnion =
    ConfluenceBlogPost;

/** A union of the possible hydration types for confluence-blogpost-has-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedConfluenceBlogpostHasCommentUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A simplified connection for the relationship type confluence-blogpost-shared-with-user */
export type GraphStoreSimplifiedConfluenceBlogpostSharedWithUserConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceBlogpostSharedWithUserConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceBlogpostSharedWithUserEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-blogpost-shared-with-user */
export type GraphStoreSimplifiedConfluenceBlogpostSharedWithUserEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceBlogpostSharedWithUserEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceBlogpostSharedWithUserUnion>;
};

/** A simplified connection for the relationship type confluence-blogpost-shared-with-user */
export type GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-blogpost-shared-with-user */
export type GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseUnion>;
};

/** A union of the possible hydration types for confluence-blogpost-shared-with-user: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedConfluenceBlogpostSharedWithUserInverseUnion =
    ConfluenceBlogPost;

/** A union of the possible hydration types for confluence-blogpost-shared-with-user: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedConfluenceBlogpostSharedWithUserUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type confluence-page-has-comment */
export type GraphStoreSimplifiedConfluencePageHasCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedConfluencePageHasCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-comment */
export type GraphStoreSimplifiedConfluencePageHasCommentEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageHasCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageHasCommentUnion>;
};

/** A simplified connection for the relationship type confluence-page-has-comment */
export type GraphStoreSimplifiedConfluencePageHasCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageHasCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-comment */
export type GraphStoreSimplifiedConfluencePageHasCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageHasCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageHasCommentInverseUnion>;
};

/** A union of the possible hydration types for confluence-page-has-comment: [ConfluencePage] */
export type GraphStoreSimplifiedConfluencePageHasCommentInverseUnion =
    ConfluencePage;

/** A union of the possible hydration types for confluence-page-has-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedConfluencePageHasCommentUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A simplified connection for the relationship type confluence-page-has-confluence-comment */
export type GraphStoreSimplifiedConfluencePageHasConfluenceCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceCommentConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceCommentEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-confluence-comment */
export type GraphStoreSimplifiedConfluencePageHasConfluenceCommentEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceCommentUnion>;
};

/** A simplified connection for the relationship type confluence-page-has-confluence-comment */
export type GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-confluence-comment */
export type GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:page, ati:cloud:confluence:blogpost]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseUnion>;
    };

/** A union of the possible hydration types for confluence-page-has-confluence-comment: [ConfluencePage, ConfluenceBlogPost] */
export type GraphStoreSimplifiedConfluencePageHasConfluenceCommentInverseUnion =
    ConfluenceBlogPost | ConfluencePage;

/** A union of the possible hydration types for confluence-page-has-confluence-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedConfluencePageHasConfluenceCommentUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A simplified connection for the relationship type confluence-page-has-confluence-database */
export type GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-confluence-database */
export type GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:database]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseUnion>;
};

/** A simplified connection for the relationship type confluence-page-has-confluence-database */
export type GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-confluence-database */
export type GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:page]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseUnion>;
    };

/** A union of the possible hydration types for confluence-page-has-confluence-database: [ConfluencePage] */
export type GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseInverseUnion =
    ConfluencePage;

/** A union of the possible hydration types for confluence-page-has-confluence-database: [ConfluenceDatabase] */
export type GraphStoreSimplifiedConfluencePageHasConfluenceDatabaseUnion =
    ConfluenceDatabase;

/** A simplified connection for the relationship type confluence-page-has-parent-page */
export type GraphStoreSimplifiedConfluencePageHasParentPageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasParentPageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedConfluencePageHasParentPageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-parent-page */
export type GraphStoreSimplifiedConfluencePageHasParentPageEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageHasParentPageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageHasParentPageUnion>;
};

/** A simplified connection for the relationship type confluence-page-has-parent-page */
export type GraphStoreSimplifiedConfluencePageHasParentPageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageHasParentPageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageHasParentPageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-has-parent-page */
export type GraphStoreSimplifiedConfluencePageHasParentPageInverseEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageHasParentPageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageHasParentPageInverseUnion>;
};

/** A union of the possible hydration types for confluence-page-has-parent-page: [ConfluencePage] */
export type GraphStoreSimplifiedConfluencePageHasParentPageInverseUnion =
    ConfluencePage;

/** A union of the possible hydration types for confluence-page-has-parent-page: [ConfluencePage] */
export type GraphStoreSimplifiedConfluencePageHasParentPageUnion =
    ConfluencePage;

/** A simplified connection for the relationship type confluence-page-shared-with-group */
export type GraphStoreSimplifiedConfluencePageSharedWithGroupInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageSharedWithGroupInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageSharedWithGroupInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-shared-with-group */
export type GraphStoreSimplifiedConfluencePageSharedWithGroupInverseEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageSharedWithGroupInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageSharedWithGroupInverseUnion>;
};

/** A union of the possible hydration types for confluence-page-shared-with-group: [ConfluencePage] */
export type GraphStoreSimplifiedConfluencePageSharedWithGroupInverseUnion =
    ConfluencePage;

/** A simplified connection for the relationship type confluence-page-shared-with-user */
export type GraphStoreSimplifiedConfluencePageSharedWithUserConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageSharedWithUserConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedConfluencePageSharedWithUserEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-shared-with-user */
export type GraphStoreSimplifiedConfluencePageSharedWithUserEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageSharedWithUserEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageSharedWithUserUnion>;
};

/** A simplified connection for the relationship type confluence-page-shared-with-user */
export type GraphStoreSimplifiedConfluencePageSharedWithUserInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluencePageSharedWithUserInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluencePageSharedWithUserInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-page-shared-with-user */
export type GraphStoreSimplifiedConfluencePageSharedWithUserInverseEdge = {
    __typename?: "GraphStoreSimplifiedConfluencePageSharedWithUserInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluencePageSharedWithUserInverseUnion>;
};

/** A union of the possible hydration types for confluence-page-shared-with-user: [ConfluencePage] */
export type GraphStoreSimplifiedConfluencePageSharedWithUserInverseUnion =
    ConfluencePage;

/** A union of the possible hydration types for confluence-page-shared-with-user: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedConfluencePageSharedWithUserUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type confluence-space-has-confluence-blogpost */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-blogpost */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type confluence-space-has-confluence-blogpost */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-blogpost */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:space]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseUnion>;
    };

/** A union of the possible hydration types for confluence-space-has-confluence-blogpost: [ConfluenceSpace] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostInverseUnion =
    ConfluenceSpace;

/** A union of the possible hydration types for confluence-space-has-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type confluence-space-has-confluence-database */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-database */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:database]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseUnion>;
};

/** A simplified connection for the relationship type confluence-space-has-confluence-database */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-database */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:space]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseUnion>;
    };

/** A union of the possible hydration types for confluence-space-has-confluence-database: [ConfluenceSpace] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseInverseUnion =
    ConfluenceSpace;

/** A union of the possible hydration types for confluence-space-has-confluence-database: [ConfluenceDatabase] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceDatabaseUnion =
    ConfluenceDatabase;

/** A simplified connection for the relationship type confluence-space-has-confluence-folder */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-folder */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:folder]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderUnion>;
};

/** A simplified connection for the relationship type confluence-space-has-confluence-folder */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-folder */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:space]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseUnion>;
    };

/** A union of the possible hydration types for confluence-space-has-confluence-folder: [ConfluenceSpace] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderInverseUnion =
    ConfluenceSpace;

/** A union of the possible hydration types for confluence-space-has-confluence-folder: [ConfluenceFolder] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceFolderUnion =
    ConfluenceFolder;

/** A simplified connection for the relationship type confluence-space-has-confluence-whiteboard */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-whiteboard */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardUnion>;
};

/** A simplified connection for the relationship type confluence-space-has-confluence-whiteboard */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type confluence-space-has-confluence-whiteboard */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:space]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseUnion>;
    };

/** A union of the possible hydration types for confluence-space-has-confluence-whiteboard: [ConfluenceSpace] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardInverseUnion =
    ConfluenceSpace;

/** A union of the possible hydration types for confluence-space-has-confluence-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedConfluenceSpaceHasConfluenceWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type content-referenced-entity */
export type GraphStoreSimplifiedContentReferencedEntityConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedContentReferencedEntityConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedContentReferencedEntityEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type content-referenced-entity */
export type GraphStoreSimplifiedContentReferencedEntityEdge = {
    __typename?: "GraphStoreSimplifiedContentReferencedEntityEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost, ati:cloud:compass:component, ati:cloud:google:document, ati:third-party:google:document, ati:cloud:google:spreadsheet, ati:third-party:google:spreadsheet, ati:cloud:google:form, ati:third-party:google:form, ati:cloud:google:presentation, ati:third-party:google:presentation, ati:cloud:figma:file, ati:third-party:figma:file]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedContentReferencedEntityUnion>;
};

/** A simplified connection for the relationship type content-referenced-entity */
export type GraphStoreSimplifiedContentReferencedEntityInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedContentReferencedEntityInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedContentReferencedEntityInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type content-referenced-entity */
export type GraphStoreSimplifiedContentReferencedEntityInverseEdge = {
    __typename?: "GraphStoreSimplifiedContentReferencedEntityInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedContentReferencedEntityInverseUnion>;
};

/** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, ConfluenceBlogPost] */
export type GraphStoreSimplifiedContentReferencedEntityInverseUnion =
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

/** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, ConfluenceBlogPost, CompassComponent] */
export type GraphStoreSimplifiedContentReferencedEntityUnion =
    | CompassComponent
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

/** A simplified connection for the relationship type conversation-has-message */
export type GraphStoreSimplifiedConversationHasMessageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConversationHasMessageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedConversationHasMessageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type conversation-has-message */
export type GraphStoreSimplifiedConversationHasMessageEdge = {
    __typename?: "GraphStoreSimplifiedConversationHasMessageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:message]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConversationHasMessageUnion>;
};

/** A simplified connection for the relationship type conversation-has-message */
export type GraphStoreSimplifiedConversationHasMessageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedConversationHasMessageInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedConversationHasMessageInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type conversation-has-message */
export type GraphStoreSimplifiedConversationHasMessageInverseEdge = {
    __typename?: "GraphStoreSimplifiedConversationHasMessageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:conversation]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedConversationHasMessageInverseUnion>;
};

/** A union of the possible hydration types for conversation-has-message: [ExternalConversation] */
export type GraphStoreSimplifiedConversationHasMessageInverseUnion =
    ExternalConversation;

/** A union of the possible hydration types for conversation-has-message: [ExternalMessage] */
export type GraphStoreSimplifiedConversationHasMessageUnion = ExternalMessage;

/** A simplified connection for the relationship type deployment-contains-commit */
export type GraphStoreSimplifiedDeploymentContainsCommitConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedDeploymentContainsCommitConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedDeploymentContainsCommitEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type deployment-contains-commit */
export type GraphStoreSimplifiedDeploymentContainsCommitEdge = {
    __typename?: "GraphStoreSimplifiedDeploymentContainsCommitEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedDeploymentContainsCommitUnion>;
};

/** A simplified connection for the relationship type deployment-contains-commit */
export type GraphStoreSimplifiedDeploymentContainsCommitInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedDeploymentContainsCommitInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedDeploymentContainsCommitInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type deployment-contains-commit */
export type GraphStoreSimplifiedDeploymentContainsCommitInverseEdge = {
    __typename?: "GraphStoreSimplifiedDeploymentContainsCommitInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedDeploymentContainsCommitInverseUnion>;
};

/** A union of the possible hydration types for deployment-contains-commit: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedDeploymentContainsCommitInverseUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A union of the possible hydration types for deployment-contains-commit: [ExternalCommit] */
export type GraphStoreSimplifiedDeploymentContainsCommitUnion = ExternalCommit;

/** A simplified connection for the relationship type external-worker-conflates-to-identity-3p-user */
export type GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type external-worker-conflates-to-identity-3p-user */
export type GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserEdge = {
    __typename?: "GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserUnion>;
};

/** A union of the possible hydration types for external-worker-conflates-to-identity-3p-user: [ThirdPartyUser] */
export type GraphStoreSimplifiedExternalWorkerConflatesToIdentity3pUserUnion =
    ThirdPartyUser;

/** A simplified connection for the relationship type focus-area-associated-to-project */
export type GraphStoreSimplifiedFocusAreaAssociatedToProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaAssociatedToProjectConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaAssociatedToProjectEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-associated-to-project */
export type GraphStoreSimplifiedFocusAreaAssociatedToProjectEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaAssociatedToProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaAssociatedToProjectUnion>;
};

/** A simplified connection for the relationship type focus-area-associated-to-project */
export type GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-associated-to-project */
export type GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseUnion>;
};

/** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */
export type GraphStoreSimplifiedFocusAreaAssociatedToProjectInverseUnion =
    MercuryFocusArea;

/** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */
export type GraphStoreSimplifiedFocusAreaAssociatedToProjectUnion =
    DevOpsProjectDetails;

/** A simplified connection for the relationship type focus-area-has-atlas-goal */
export type GraphStoreSimplifiedFocusAreaHasAtlasGoalConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaHasAtlasGoalConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaHasAtlasGoalEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-has-atlas-goal */
export type GraphStoreSimplifiedFocusAreaHasAtlasGoalEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasAtlasGoalEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasAtlasGoalUnion>;
};

/** A simplified connection for the relationship type focus-area-has-atlas-goal */
export type GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-has-atlas-goal */
export type GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseUnion>;
};

/** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */
export type GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseUnion =
    MercuryFocusArea;

/** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedFocusAreaHasAtlasGoalUnion = TownsquareGoal;

/** A simplified connection for the relationship type focus-area-has-focus-area */
export type GraphStoreSimplifiedFocusAreaHasFocusAreaConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaHasFocusAreaConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaHasFocusAreaEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-has-focus-area */
export type GraphStoreSimplifiedFocusAreaHasFocusAreaEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasFocusAreaEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasFocusAreaUnion>;
};

/** A simplified connection for the relationship type focus-area-has-focus-area */
export type GraphStoreSimplifiedFocusAreaHasFocusAreaInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaHasFocusAreaInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaHasFocusAreaInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-has-focus-area */
export type GraphStoreSimplifiedFocusAreaHasFocusAreaInverseEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasFocusAreaInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasFocusAreaInverseUnion>;
};

/** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */
export type GraphStoreSimplifiedFocusAreaHasFocusAreaInverseUnion =
    MercuryFocusArea;

/** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */
export type GraphStoreSimplifiedFocusAreaHasFocusAreaUnion = MercuryFocusArea;

/** A simplified connection for the relationship type focus-area-has-page */
export type GraphStoreSimplifiedFocusAreaHasPageConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedFocusAreaHasPageConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedFocusAreaHasPageEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type focus-area-has-page */
export type GraphStoreSimplifiedFocusAreaHasPageEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasPageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasPageUnion>;
};

/** A simplified connection for the relationship type focus-area-has-page */
export type GraphStoreSimplifiedFocusAreaHasPageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaHasPageInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaHasPageInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-has-page */
export type GraphStoreSimplifiedFocusAreaHasPageInverseEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasPageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasPageInverseUnion>;
};

/** A union of the possible hydration types for focus-area-has-page: [MercuryFocusArea] */
export type GraphStoreSimplifiedFocusAreaHasPageInverseUnion = MercuryFocusArea;

/** A union of the possible hydration types for focus-area-has-page: [ConfluencePage] */
export type GraphStoreSimplifiedFocusAreaHasPageUnion = ConfluencePage;

/** A simplified connection for the relationship type focus-area-has-project */
export type GraphStoreSimplifiedFocusAreaHasProjectConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedFocusAreaHasProjectConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedFocusAreaHasProjectEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type focus-area-has-project */
export type GraphStoreSimplifiedFocusAreaHasProjectEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project, ati:cloud:jira:issue, ati:cloud:jira-align:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasProjectUnion>;
};

/** A simplified connection for the relationship type focus-area-has-project */
export type GraphStoreSimplifiedFocusAreaHasProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedFocusAreaHasProjectInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type focus-area-has-project */
export type GraphStoreSimplifiedFocusAreaHasProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedFocusAreaHasProjectInverseUnion>;
};

/** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */
export type GraphStoreSimplifiedFocusAreaHasProjectInverseUnion =
    MercuryFocusArea;

/** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue, JiraAlignAggProject] */
export type GraphStoreSimplifiedFocusAreaHasProjectUnion =
    | JiraAlignAggProject
    | JiraIssue
    | TownsquareProject;

/** A simplified connection for the relationship type graph-document-3p-document */
export type GraphStoreSimplifiedGraphDocument3pDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedGraphDocument3pDocumentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedGraphDocument3pDocumentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type graph-document-3p-document */
export type GraphStoreSimplifiedGraphDocument3pDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedGraphDocument3pDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedGraphDocument3pDocumentInverseUnion>;
};

/** A union of the possible hydration types for graph-document-3p-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedGraphDocument3pDocumentInverseUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type graph-entity-replicates-3p-entity */
export type GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type graph-entity-replicates-3p-entity */
export type GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseEdge = {
    __typename?: "GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document, ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseUnion>;
};

/** A union of the possible hydration types for graph-entity-replicates-3p-entity: [DevOpsDocument, ExternalDocument, ExternalRemoteLink] */
export type GraphStoreSimplifiedGraphEntityReplicates3pEntityInverseUnion =
    | DevOpsDocument
    | ExternalDocument
    | ExternalRemoteLink;

/** A simplified connection for the relationship type group-can-view-confluence-space */
export type GraphStoreSimplifiedGroupCanViewConfluenceSpaceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedGroupCanViewConfluenceSpaceConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedGroupCanViewConfluenceSpaceEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type group-can-view-confluence-space */
export type GraphStoreSimplifiedGroupCanViewConfluenceSpaceEdge = {
    __typename?: "GraphStoreSimplifiedGroupCanViewConfluenceSpaceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedGroupCanViewConfluenceSpaceUnion>;
};

/** A union of the possible hydration types for group-can-view-confluence-space: [ConfluenceSpace] */
export type GraphStoreSimplifiedGroupCanViewConfluenceSpaceUnion =
    ConfluenceSpace;

/** A simplified connection for the relationship type incident-associated-post-incident-review */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type incident-associated-post-incident-review */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewEdge = {
    __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewUnion>;
};

/** A simplified connection for the relationship type incident-associated-post-incident-review */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type incident-associated-post-incident-review */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:jira:issue]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseUnion>;
    };

/** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewInverseUnion =
    JiraIssue;

/** A simplified connection for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkEdge = {
    __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:post-incident-review-link, ati:cloud:jira:post-incident-review, ati:cloud:graph:post-incident-review]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkUnion>;
};

/** A simplified connection for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type incident-associated-post-incident-review-link */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseUnion>;
    };

/** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkInverseUnion =
    DevOpsOperationsIncidentDetails | JiraIssue;

/** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewLinkUnion =
    | DevOpsOperationsPostIncidentReviewDetails
    | JiraIssue
    | JiraPostIncidentReviewLink;

/** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */
export type GraphStoreSimplifiedIncidentAssociatedPostIncidentReviewUnion =
    JiraIssue;

/** A simplified connection for the relationship type incident-has-action-item */
export type GraphStoreSimplifiedIncidentHasActionItemConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedIncidentHasActionItemConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIncidentHasActionItemEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type incident-has-action-item */
export type GraphStoreSimplifiedIncidentHasActionItemEdge = {
    __typename?: "GraphStoreSimplifiedIncidentHasActionItemEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIncidentHasActionItemUnion>;
};

/** A simplified connection for the relationship type incident-has-action-item */
export type GraphStoreSimplifiedIncidentHasActionItemInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIncidentHasActionItemInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIncidentHasActionItemInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type incident-has-action-item */
export type GraphStoreSimplifiedIncidentHasActionItemInverseEdge = {
    __typename?: "GraphStoreSimplifiedIncidentHasActionItemInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIncidentHasActionItemInverseUnion>;
};

/** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedIncidentHasActionItemInverseUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */
export type GraphStoreSimplifiedIncidentHasActionItemUnion = JiraIssue;

/** A simplified connection for the relationship type incident-linked-jsw-issue */
export type GraphStoreSimplifiedIncidentLinkedJswIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedIncidentLinkedJswIssueConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type incident-linked-jsw-issue */
export type GraphStoreSimplifiedIncidentLinkedJswIssueEdge = {
    __typename?: "GraphStoreSimplifiedIncidentLinkedJswIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueUnion>;
};

/** A simplified connection for the relationship type incident-linked-jsw-issue */
export type GraphStoreSimplifiedIncidentLinkedJswIssueInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIncidentLinkedJswIssueInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type incident-linked-jsw-issue */
export type GraphStoreSimplifiedIncidentLinkedJswIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedIncidentLinkedJswIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIncidentLinkedJswIssueInverseUnion>;
};

/** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedIncidentLinkedJswIssueInverseUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */
export type GraphStoreSimplifiedIncidentLinkedJswIssueUnion = JiraIssue;

/** A simplified connection for the relationship type issue-associated-branch */
export type GraphStoreSimplifiedIssueAssociatedBranchConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedBranchConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedBranchEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type issue-associated-branch */
export type GraphStoreSimplifiedIssueAssociatedBranchEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedBranchEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedBranchUnion>;
};

/** A simplified connection for the relationship type issue-associated-branch */
export type GraphStoreSimplifiedIssueAssociatedBranchInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedBranchInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueAssociatedBranchInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-branch */
export type GraphStoreSimplifiedIssueAssociatedBranchInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedBranchInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedBranchInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedBranchInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-associated-branch: [ExternalBranch] */
export type GraphStoreSimplifiedIssueAssociatedBranchUnion = ExternalBranch;

/** A simplified connection for the relationship type issue-associated-build */
export type GraphStoreSimplifiedIssueAssociatedBuildConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedIssueAssociatedBuildConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedIssueAssociatedBuildEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type issue-associated-build */
export type GraphStoreSimplifiedIssueAssociatedBuildEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedBuildEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:build, ati:cloud:graph:build]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedBuildUnion>;
};

/** A simplified connection for the relationship type issue-associated-build */
export type GraphStoreSimplifiedIssueAssociatedBuildInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedBuildInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedBuildInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-associated-build */
export type GraphStoreSimplifiedIssueAssociatedBuildInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedBuildInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedBuildInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-build: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedBuildInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-associated-build: [ExternalBuildInfo] */
export type GraphStoreSimplifiedIssueAssociatedBuildUnion = ExternalBuildInfo;

/** A simplified connection for the relationship type issue-associated-commit */
export type GraphStoreSimplifiedIssueAssociatedCommitConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedCommitConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedCommitEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type issue-associated-commit */
export type GraphStoreSimplifiedIssueAssociatedCommitEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedCommitEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedCommitUnion>;
};

/** A simplified connection for the relationship type issue-associated-commit */
export type GraphStoreSimplifiedIssueAssociatedCommitInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedCommitInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueAssociatedCommitInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-commit */
export type GraphStoreSimplifiedIssueAssociatedCommitInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedCommitInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedCommitInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedCommitInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-associated-commit: [ExternalCommit] */
export type GraphStoreSimplifiedIssueAssociatedCommitUnion = ExternalCommit;

/** A simplified connection for the relationship type issue-associated-deployment */
export type GraphStoreSimplifiedIssueAssociatedDeploymentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedDeploymentConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedIssueAssociatedDeploymentEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-deployment */
export type GraphStoreSimplifiedIssueAssociatedDeploymentEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedDeploymentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedDeploymentUnion>;
};

/** A simplified connection for the relationship type issue-associated-deployment */
export type GraphStoreSimplifiedIssueAssociatedDeploymentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedDeploymentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueAssociatedDeploymentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-deployment */
export type GraphStoreSimplifiedIssueAssociatedDeploymentInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedDeploymentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedDeploymentInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedDeploymentInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedIssueAssociatedDeploymentUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A simplified connection for the relationship type issue-associated-design */
export type GraphStoreSimplifiedIssueAssociatedDesignConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedDesignConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedDesignEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-associated-design */
export type GraphStoreSimplifiedIssueAssociatedDesignEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedDesignEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:design, ati:cloud:graph:design]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedDesignUnion>;
};

/** A simplified connection for the relationship type issue-associated-design */
export type GraphStoreSimplifiedIssueAssociatedDesignInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedDesignInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedDesignInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-associated-design */
export type GraphStoreSimplifiedIssueAssociatedDesignInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedDesignInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedDesignInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-design: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedDesignInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-associated-design: [DevOpsDesign, ExternalDesign] */
export type GraphStoreSimplifiedIssueAssociatedDesignUnion =
    | DevOpsDesign
    | ExternalDesign;

/** A simplified connection for the relationship type issue-associated-feature-flag */
export type GraphStoreSimplifiedIssueAssociatedFeatureFlagConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedFeatureFlagConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedIssueAssociatedFeatureFlagEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-feature-flag */
export type GraphStoreSimplifiedIssueAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedFeatureFlagEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedFeatureFlagUnion>;
};

/** A simplified connection for the relationship type issue-associated-feature-flag */
export type GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-feature-flag */
export type GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedFeatureFlagInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreSimplifiedIssueAssociatedFeatureFlagUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A simplified connection for the relationship type issue-associated-issue-remote-link */
export type GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-associated-issue-remote-link */
export type GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue-remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkUnion>;
};

/** A simplified connection for the relationship type issue-associated-issue-remote-link */
export type GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-associated-issue-remote-link */
export type GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */
export type GraphStoreSimplifiedIssueAssociatedIssueRemoteLinkUnion =
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssueRemoteIssueLink
    | JiraWebRemoteIssueLink;

/** A simplified connection for the relationship type issue-associated-pr */
export type GraphStoreSimplifiedIssueAssociatedPrConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedIssueAssociatedPrConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedIssueAssociatedPrEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type issue-associated-pr */
export type GraphStoreSimplifiedIssueAssociatedPrEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedPrEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedPrUnion>;
};

/** A simplified connection for the relationship type issue-associated-pr */
export type GraphStoreSimplifiedIssueAssociatedPrInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueAssociatedPrInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueAssociatedPrInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-associated-pr */
export type GraphStoreSimplifiedIssueAssociatedPrInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedPrInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedPrInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedPrInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedIssueAssociatedPrUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type issue-associated-remote-link */
export type GraphStoreSimplifiedIssueAssociatedRemoteLinkConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedRemoteLinkConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedIssueAssociatedRemoteLinkEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-remote-link */
export type GraphStoreSimplifiedIssueAssociatedRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedRemoteLinkUnion>;
};

/** A simplified connection for the relationship type issue-associated-remote-link */
export type GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-associated-remote-link */
export type GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseUnion>;
};

/** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */
export type GraphStoreSimplifiedIssueAssociatedRemoteLinkInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for issue-associated-remote-link: [ExternalRemoteLink] */
export type GraphStoreSimplifiedIssueAssociatedRemoteLinkUnion =
    ExternalRemoteLink;

/** A simplified connection for the relationship type issue-changes-component */
export type GraphStoreSimplifiedIssueChangesComponentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedIssueChangesComponentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueChangesComponentEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type issue-changes-component */
export type GraphStoreSimplifiedIssueChangesComponentEdge = {
    __typename?: "GraphStoreSimplifiedIssueChangesComponentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:compass:component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueChangesComponentUnion>;
};

/** A simplified connection for the relationship type issue-changes-component */
export type GraphStoreSimplifiedIssueChangesComponentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueChangesComponentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueChangesComponentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-changes-component */
export type GraphStoreSimplifiedIssueChangesComponentInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueChangesComponentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueChangesComponentInverseUnion>;
};

/** A union of the possible hydration types for issue-changes-component: [JiraIssue] */
export type GraphStoreSimplifiedIssueChangesComponentInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-changes-component: [CompassComponent] */
export type GraphStoreSimplifiedIssueChangesComponentUnion = CompassComponent;

/** A simplified connection for the relationship type issue-has-assignee */
export type GraphStoreSimplifiedIssueHasAssigneeConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedIssueHasAssigneeConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedIssueHasAssigneeEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type issue-has-assignee */
export type GraphStoreSimplifiedIssueHasAssigneeEdge = {
    __typename?: "GraphStoreSimplifiedIssueHasAssigneeEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueHasAssigneeUnion>;
};

/** A simplified connection for the relationship type issue-has-assignee */
export type GraphStoreSimplifiedIssueHasAssigneeInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueHasAssigneeInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueHasAssigneeInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-has-assignee */
export type GraphStoreSimplifiedIssueHasAssigneeInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueHasAssigneeInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueHasAssigneeInverseUnion>;
};

/** A union of the possible hydration types for issue-has-assignee: [JiraIssue] */
export type GraphStoreSimplifiedIssueHasAssigneeInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-has-assignee: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedIssueHasAssigneeUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type issue-has-autodev-job */
export type GraphStoreSimplifiedIssueHasAutodevJobInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueHasAutodevJobInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueHasAutodevJobInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-has-autodev-job */
export type GraphStoreSimplifiedIssueHasAutodevJobInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueHasAutodevJobInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueHasAutodevJobInverseUnion>;
};

/** A union of the possible hydration types for issue-has-autodev-job: [JiraIssue] */
export type GraphStoreSimplifiedIssueHasAutodevJobInverseUnion = JiraIssue;

/** A simplified connection for the relationship type issue-mentioned-in-conversation */
export type GraphStoreSimplifiedIssueMentionedInConversationConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueMentionedInConversationConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueMentionedInConversationEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-mentioned-in-conversation */
export type GraphStoreSimplifiedIssueMentionedInConversationEdge = {
    __typename?: "GraphStoreSimplifiedIssueMentionedInConversationEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:conversation]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueMentionedInConversationUnion>;
};

/** A simplified connection for the relationship type issue-mentioned-in-conversation */
export type GraphStoreSimplifiedIssueMentionedInConversationInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueMentionedInConversationInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedIssueMentionedInConversationInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-mentioned-in-conversation */
export type GraphStoreSimplifiedIssueMentionedInConversationInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueMentionedInConversationInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueMentionedInConversationInverseUnion>;
};

/** A union of the possible hydration types for issue-mentioned-in-conversation: [JiraIssue] */
export type GraphStoreSimplifiedIssueMentionedInConversationInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for issue-mentioned-in-conversation: [ExternalConversation] */
export type GraphStoreSimplifiedIssueMentionedInConversationUnion =
    ExternalConversation;

/** A simplified connection for the relationship type issue-mentioned-in-message */
export type GraphStoreSimplifiedIssueMentionedInMessageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueMentionedInMessageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueMentionedInMessageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-mentioned-in-message */
export type GraphStoreSimplifiedIssueMentionedInMessageEdge = {
    __typename?: "GraphStoreSimplifiedIssueMentionedInMessageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:message]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueMentionedInMessageUnion>;
};

/** A simplified connection for the relationship type issue-mentioned-in-message */
export type GraphStoreSimplifiedIssueMentionedInMessageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedIssueMentionedInMessageInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedIssueMentionedInMessageInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type issue-mentioned-in-message */
export type GraphStoreSimplifiedIssueMentionedInMessageInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueMentionedInMessageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueMentionedInMessageInverseUnion>;
};

/** A union of the possible hydration types for issue-mentioned-in-message: [JiraIssue] */
export type GraphStoreSimplifiedIssueMentionedInMessageInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-mentioned-in-message: [ExternalMessage] */
export type GraphStoreSimplifiedIssueMentionedInMessageUnion = ExternalMessage;

/** A simplified connection for the relationship type issue-recursive-associated-pr */
export type GraphStoreSimplifiedIssueRecursiveAssociatedPrConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueRecursiveAssociatedPrConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedIssueRecursiveAssociatedPrEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-recursive-associated-pr */
export type GraphStoreSimplifiedIssueRecursiveAssociatedPrEdge = {
    __typename?: "GraphStoreSimplifiedIssueRecursiveAssociatedPrEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueRecursiveAssociatedPrUnion>;
};

/** A simplified connection for the relationship type issue-recursive-associated-pr */
export type GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-recursive-associated-pr */
export type GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseUnion>;
};

/** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */
export type GraphStoreSimplifiedIssueRecursiveAssociatedPrInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedIssueRecursiveAssociatedPrUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type issue-to-whiteboard */
export type GraphStoreSimplifiedIssueToWhiteboardConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedIssueToWhiteboardConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedIssueToWhiteboardEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type issue-to-whiteboard */
export type GraphStoreSimplifiedIssueToWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedIssueToWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueToWhiteboardUnion>;
};

/** A simplified connection for the relationship type issue-to-whiteboard */
export type GraphStoreSimplifiedIssueToWhiteboardInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedIssueToWhiteboardInverseConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedIssueToWhiteboardInverseEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type issue-to-whiteboard */
export type GraphStoreSimplifiedIssueToWhiteboardInverseEdge = {
    __typename?: "GraphStoreSimplifiedIssueToWhiteboardInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedIssueToWhiteboardInverseUnion>;
};

/** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */
export type GraphStoreSimplifiedIssueToWhiteboardInverseUnion = JiraIssue;

/** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedIssueToWhiteboardUnion = ConfluenceWhiteboard;

/** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */
export type GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */
export type GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge = {
    __typename?: "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraEpicContributesToAtlasGoalUnion>;
};

/** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */
export type GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */
export type GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge = {
    __typename?: "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseUnion>;
};

/** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */
export type GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedJiraEpicContributesToAtlasGoalUnion =
    TownsquareGoal;

/** A simplified connection for the relationship type jira-issue-blocked-by-jira-issue */
export type GraphStoreSimplifiedJiraIssueBlockedByJiraIssueConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedJiraIssueBlockedByJiraIssueConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedJiraIssueBlockedByJiraIssueEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type jira-issue-blocked-by-jira-issue */
export type GraphStoreSimplifiedJiraIssueBlockedByJiraIssueEdge = {
    __typename?: "GraphStoreSimplifiedJiraIssueBlockedByJiraIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraIssueBlockedByJiraIssueUnion>;
};

/** A simplified connection for the relationship type jira-issue-blocked-by-jira-issue */
export type GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type jira-issue-blocked-by-jira-issue */
export type GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseUnion>;
};

/** A union of the possible hydration types for jira-issue-blocked-by-jira-issue: [JiraIssue] */
export type GraphStoreSimplifiedJiraIssueBlockedByJiraIssueInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for jira-issue-blocked-by-jira-issue: [JiraIssue] */
export type GraphStoreSimplifiedJiraIssueBlockedByJiraIssueUnion = JiraIssue;

/** A simplified connection for the relationship type jira-issue-to-jira-priority */
export type GraphStoreSimplifiedJiraIssueToJiraPriorityInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedJiraIssueToJiraPriorityInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedJiraIssueToJiraPriorityInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type jira-issue-to-jira-priority */
export type GraphStoreSimplifiedJiraIssueToJiraPriorityInverseEdge = {
    __typename?: "GraphStoreSimplifiedJiraIssueToJiraPriorityInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraIssueToJiraPriorityInverseUnion>;
};

/** A union of the possible hydration types for jira-issue-to-jira-priority: [JiraIssue] */
export type GraphStoreSimplifiedJiraIssueToJiraPriorityInverseUnion = JiraIssue;

/** A simplified connection for the relationship type jira-project-associated-atlas-goal */
export type GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jira-project-associated-atlas-goal */
export type GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalEdge = {
    __typename?: "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalUnion>;
};

/** A simplified connection for the relationship type jira-project-associated-atlas-goal */
export type GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jira-project-associated-atlas-goal */
export type GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseEdge = {
    __typename?: "GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseUnion>;
};

/** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */
export type GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalInverseUnion =
    JiraProject;

/** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedJiraProjectAssociatedAtlasGoalUnion =
    TownsquareGoal;

/** A simplified connection for the relationship type jsm-project-associated-service */
export type GraphStoreSimplifiedJsmProjectAssociatedServiceConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJsmProjectAssociatedServiceConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJsmProjectAssociatedServiceEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsm-project-associated-service */
export type GraphStoreSimplifiedJsmProjectAssociatedServiceEdge = {
    __typename?: "GraphStoreSimplifiedJsmProjectAssociatedServiceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJsmProjectAssociatedServiceUnion>;
};

/** A simplified connection for the relationship type jsm-project-associated-service */
export type GraphStoreSimplifiedJsmProjectAssociatedServiceInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJsmProjectAssociatedServiceInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJsmProjectAssociatedServiceInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsm-project-associated-service */
export type GraphStoreSimplifiedJsmProjectAssociatedServiceInverseEdge = {
    __typename?: "GraphStoreSimplifiedJsmProjectAssociatedServiceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJsmProjectAssociatedServiceInverseUnion>;
};

/** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */
export type GraphStoreSimplifiedJsmProjectAssociatedServiceInverseUnion =
    JiraProject;

/** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */
export type GraphStoreSimplifiedJsmProjectAssociatedServiceUnion =
    DevOpsService;

/** A simplified connection for the relationship type jsw-project-associated-component */
export type GraphStoreSimplifiedJswProjectAssociatedComponentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJswProjectAssociatedComponentConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsw-project-associated-component */
export type GraphStoreSimplifiedJswProjectAssociatedComponentEdge = {
    __typename?: "GraphStoreSimplifiedJswProjectAssociatedComponentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service, ati:cloud:compass:component, ati:cloud:jira:devops-component, ati:cloud:graph:devops-component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentUnion>;
};

/** A simplified connection for the relationship type jsw-project-associated-component */
export type GraphStoreSimplifiedJswProjectAssociatedComponentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJswProjectAssociatedComponentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsw-project-associated-component */
export type GraphStoreSimplifiedJswProjectAssociatedComponentInverseEdge = {
    __typename?: "GraphStoreSimplifiedJswProjectAssociatedComponentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentInverseUnion>;
};

/** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */
export type GraphStoreSimplifiedJswProjectAssociatedComponentInverseUnion =
    JiraProject;

/** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */
export type GraphStoreSimplifiedJswProjectAssociatedComponentUnion =
    | CompassComponent
    | DevOpsOperationsComponentDetails
    | DevOpsService;

/** A simplified connection for the relationship type jsw-project-associated-incident */
export type GraphStoreSimplifiedJswProjectAssociatedIncidentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJswProjectAssociatedIncidentConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsw-project-associated-incident */
export type GraphStoreSimplifiedJswProjectAssociatedIncidentEdge = {
    __typename?: "GraphStoreSimplifiedJswProjectAssociatedIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentUnion>;
};

/** A simplified connection for the relationship type jsw-project-associated-incident */
export type GraphStoreSimplifiedJswProjectAssociatedIncidentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJswProjectAssociatedIncidentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsw-project-associated-incident */
export type GraphStoreSimplifiedJswProjectAssociatedIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedJswProjectAssociatedIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentInverseUnion>;
};

/** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */
export type GraphStoreSimplifiedJswProjectAssociatedIncidentInverseUnion =
    JiraProject;

/** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedJswProjectAssociatedIncidentUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */
export type GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */
export type GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectEdge = {
    __typename?: "GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectUnion>;
};

/** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */
export type GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */
export type GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:jira:project]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseUnion>;
    };

/** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */
export type GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectInverseUnion =
    JiraProject;

/** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */
export type GraphStoreSimplifiedJswProjectSharesComponentWithJsmProjectUnion =
    JiraProject;

/** A simplified connection for the relationship type linked-project-has-version */
export type GraphStoreSimplifiedLinkedProjectHasVersionConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedLinkedProjectHasVersionConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedLinkedProjectHasVersionEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type linked-project-has-version */
export type GraphStoreSimplifiedLinkedProjectHasVersionEdge = {
    __typename?: "GraphStoreSimplifiedLinkedProjectHasVersionEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedLinkedProjectHasVersionUnion>;
};

/** A simplified connection for the relationship type linked-project-has-version */
export type GraphStoreSimplifiedLinkedProjectHasVersionInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedLinkedProjectHasVersionInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedLinkedProjectHasVersionInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type linked-project-has-version */
export type GraphStoreSimplifiedLinkedProjectHasVersionInverseEdge = {
    __typename?: "GraphStoreSimplifiedLinkedProjectHasVersionInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedLinkedProjectHasVersionInverseUnion>;
};

/** A union of the possible hydration types for linked-project-has-version: [JiraProject] */
export type GraphStoreSimplifiedLinkedProjectHasVersionInverseUnion =
    JiraProject;

/** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */
export type GraphStoreSimplifiedLinkedProjectHasVersionUnion = JiraVersion;

/** A simplified connection for the relationship type loom-video-shared-with-user */
export type GraphStoreSimplifiedLoomVideoSharedWithUserConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedLoomVideoSharedWithUserConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedLoomVideoSharedWithUserEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type loom-video-shared-with-user */
export type GraphStoreSimplifiedLoomVideoSharedWithUserEdge = {
    __typename?: "GraphStoreSimplifiedLoomVideoSharedWithUserEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedLoomVideoSharedWithUserUnion>;
};

/** A simplified connection for the relationship type loom-video-shared-with-user */
export type GraphStoreSimplifiedLoomVideoSharedWithUserInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedLoomVideoSharedWithUserInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedLoomVideoSharedWithUserInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type loom-video-shared-with-user */
export type GraphStoreSimplifiedLoomVideoSharedWithUserInverseEdge = {
    __typename?: "GraphStoreSimplifiedLoomVideoSharedWithUserInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:loom:video]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedLoomVideoSharedWithUserInverseUnion>;
};

/** A union of the possible hydration types for loom-video-shared-with-user: [LoomVideo] */
export type GraphStoreSimplifiedLoomVideoSharedWithUserInverseUnion = LoomVideo;

/** A union of the possible hydration types for loom-video-shared-with-user: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedLoomVideoSharedWithUserUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type media-attached-to-content */
export type GraphStoreSimplifiedMediaAttachedToContentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedMediaAttachedToContentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedMediaAttachedToContentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type media-attached-to-content */
export type GraphStoreSimplifiedMediaAttachedToContentEdge = {
    __typename?: "GraphStoreSimplifiedMediaAttachedToContentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:confluence:page, ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedMediaAttachedToContentUnion>;
};

/** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage, ConfluenceBlogPost] */
export type GraphStoreSimplifiedMediaAttachedToContentUnion =
    | ConfluenceBlogPost
    | ConfluencePage
    | JiraIssue;

/** A simplified connection for the relationship type meeting-has-meeting-notes-page */
export type GraphStoreSimplifiedMeetingHasMeetingNotesPageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedMeetingHasMeetingNotesPageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedMeetingHasMeetingNotesPageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type meeting-has-meeting-notes-page */
export type GraphStoreSimplifiedMeetingHasMeetingNotesPageEdge = {
    __typename?: "GraphStoreSimplifiedMeetingHasMeetingNotesPageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedMeetingHasMeetingNotesPageUnion>;
};

/** A union of the possible hydration types for meeting-has-meeting-notes-page: [ConfluencePage] */
export type GraphStoreSimplifiedMeetingHasMeetingNotesPageUnion =
    ConfluencePage;

/** A simplified connection for the relationship type meeting-recording-owner-has-meeting-notes-folder */
export type GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type meeting-recording-owner-has-meeting-notes-folder */
export type GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderEdge =
    {
        __typename?: "GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:folder]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderUnion>;
    };

/** A simplified connection for the relationship type meeting-recording-owner-has-meeting-notes-folder */
export type GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type meeting-recording-owner-has-meeting-notes-folder */
export type GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:identity:user]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseUnion>;
    };

/** A union of the possible hydration types for meeting-recording-owner-has-meeting-notes-folder: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderInverseUnion =
    AppUser | AtlassianAccountUser | CustomerUser;

/** A union of the possible hydration types for meeting-recording-owner-has-meeting-notes-folder: [ConfluenceFolder] */
export type GraphStoreSimplifiedMeetingRecordingOwnerHasMeetingNotesFolderUnion =
    ConfluenceFolder;

/** A simplified connection for the relationship type meeting-recurrence-has-meeting-recurrence-notes-page */
export type GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type meeting-recurrence-has-meeting-recurrence-notes-page */
export type GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageEdge =
    {
        __typename?: "GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:confluence:page]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageUnion>;
    };

/** A union of the possible hydration types for meeting-recurrence-has-meeting-recurrence-notes-page: [ConfluencePage] */
export type GraphStoreSimplifiedMeetingRecurrenceHasMeetingRecurrenceNotesPageUnion =
    ConfluencePage;

/** A simplified connection for the relationship type operations-container-impacted-by-incident */
export type GraphStoreSimplifiedOperationsContainerImpactedByIncidentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedOperationsContainerImpactedByIncidentConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedOperationsContainerImpactedByIncidentEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type operations-container-impacted-by-incident */
export type GraphStoreSimplifiedOperationsContainerImpactedByIncidentEdge = {
    __typename?: "GraphStoreSimplifiedOperationsContainerImpactedByIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedOperationsContainerImpactedByIncidentUnion>;
};

/** A simplified connection for the relationship type operations-container-impacted-by-incident */
export type GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type operations-container-impacted-by-incident */
export type GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:graph:service]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseUnion>;
    };

/** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */
export type GraphStoreSimplifiedOperationsContainerImpactedByIncidentInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedOperationsContainerImpactedByIncidentUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A simplified connection for the relationship type operations-container-improved-by-action-item */
export type GraphStoreSimplifiedOperationsContainerImprovedByActionItemConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedOperationsContainerImprovedByActionItemConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedOperationsContainerImprovedByActionItemEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type operations-container-improved-by-action-item */
export type GraphStoreSimplifiedOperationsContainerImprovedByActionItemEdge = {
    __typename?: "GraphStoreSimplifiedOperationsContainerImprovedByActionItemEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedOperationsContainerImprovedByActionItemUnion>;
};

/** A simplified connection for the relationship type operations-container-improved-by-action-item */
export type GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type operations-container-improved-by-action-item */
export type GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:graph:service]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseUnion>;
    };

/** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */
export type GraphStoreSimplifiedOperationsContainerImprovedByActionItemInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */
export type GraphStoreSimplifiedOperationsContainerImprovedByActionItemUnion =
    JiraIssue;

/** A simplified connection for the relationship type parent-comment-has-child-comment */
export type GraphStoreSimplifiedParentCommentHasChildCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentCommentHasChildCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedParentCommentHasChildCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-comment-has-child-comment */
export type GraphStoreSimplifiedParentCommentHasChildCommentEdge = {
    __typename?: "GraphStoreSimplifiedParentCommentHasChildCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentCommentHasChildCommentUnion>;
};

/** A simplified connection for the relationship type parent-comment-has-child-comment */
export type GraphStoreSimplifiedParentCommentHasChildCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentCommentHasChildCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedParentCommentHasChildCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-comment-has-child-comment */
export type GraphStoreSimplifiedParentCommentHasChildCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedParentCommentHasChildCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentCommentHasChildCommentInverseUnion>;
};

/** A union of the possible hydration types for parent-comment-has-child-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedParentCommentHasChildCommentInverseUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A union of the possible hydration types for parent-comment-has-child-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedParentCommentHasChildCommentUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A simplified connection for the relationship type parent-document-has-child-document */
export type GraphStoreSimplifiedParentDocumentHasChildDocumentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentDocumentHasChildDocumentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedParentDocumentHasChildDocumentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-document-has-child-document */
export type GraphStoreSimplifiedParentDocumentHasChildDocumentEdge = {
    __typename?: "GraphStoreSimplifiedParentDocumentHasChildDocumentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentDocumentHasChildDocumentUnion>;
};

/** A simplified connection for the relationship type parent-document-has-child-document */
export type GraphStoreSimplifiedParentDocumentHasChildDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentDocumentHasChildDocumentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedParentDocumentHasChildDocumentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-document-has-child-document */
export type GraphStoreSimplifiedParentDocumentHasChildDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedParentDocumentHasChildDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentDocumentHasChildDocumentInverseUnion>;
};

/** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedParentDocumentHasChildDocumentInverseUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedParentDocumentHasChildDocumentUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type parent-issue-has-child-issue */
export type GraphStoreSimplifiedParentIssueHasChildIssueConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentIssueHasChildIssueConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedParentIssueHasChildIssueEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-issue-has-child-issue */
export type GraphStoreSimplifiedParentIssueHasChildIssueEdge = {
    __typename?: "GraphStoreSimplifiedParentIssueHasChildIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentIssueHasChildIssueUnion>;
};

/** A simplified connection for the relationship type parent-issue-has-child-issue */
export type GraphStoreSimplifiedParentIssueHasChildIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentIssueHasChildIssueInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedParentIssueHasChildIssueInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-issue-has-child-issue */
export type GraphStoreSimplifiedParentIssueHasChildIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedParentIssueHasChildIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentIssueHasChildIssueInverseUnion>;
};

/** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */
export type GraphStoreSimplifiedParentIssueHasChildIssueInverseUnion =
    JiraIssue;

/** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */
export type GraphStoreSimplifiedParentIssueHasChildIssueUnion = JiraIssue;

/** A simplified connection for the relationship type parent-message-has-child-message */
export type GraphStoreSimplifiedParentMessageHasChildMessageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentMessageHasChildMessageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedParentMessageHasChildMessageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-message-has-child-message */
export type GraphStoreSimplifiedParentMessageHasChildMessageEdge = {
    __typename?: "GraphStoreSimplifiedParentMessageHasChildMessageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:message]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentMessageHasChildMessageUnion>;
};

/** A simplified connection for the relationship type parent-message-has-child-message */
export type GraphStoreSimplifiedParentMessageHasChildMessageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedParentMessageHasChildMessageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedParentMessageHasChildMessageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type parent-message-has-child-message */
export type GraphStoreSimplifiedParentMessageHasChildMessageInverseEdge = {
    __typename?: "GraphStoreSimplifiedParentMessageHasChildMessageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:message]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedParentMessageHasChildMessageInverseUnion>;
};

/** A union of the possible hydration types for parent-message-has-child-message: [ExternalMessage] */
export type GraphStoreSimplifiedParentMessageHasChildMessageInverseUnion =
    ExternalMessage;

/** A union of the possible hydration types for parent-message-has-child-message: [ExternalMessage] */
export type GraphStoreSimplifiedParentMessageHasChildMessageUnion =
    ExternalMessage;

/** A simplified connection for the relationship type position-allocated-to-focus-area */
export type GraphStoreSimplifiedPositionAllocatedToFocusAreaConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedPositionAllocatedToFocusAreaConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedPositionAllocatedToFocusAreaEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type position-allocated-to-focus-area */
export type GraphStoreSimplifiedPositionAllocatedToFocusAreaEdge = {
    __typename?: "GraphStoreSimplifiedPositionAllocatedToFocusAreaEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedPositionAllocatedToFocusAreaUnion>;
};

/** A simplified connection for the relationship type position-allocated-to-focus-area */
export type GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type position-allocated-to-focus-area */
export type GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseEdge = {
    __typename?: "GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:radar:position]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseUnion>;
};

/** A union of the possible hydration types for position-allocated-to-focus-area: [RadarPosition] */
export type GraphStoreSimplifiedPositionAllocatedToFocusAreaInverseUnion =
    RadarPosition;

/** A union of the possible hydration types for position-allocated-to-focus-area: [MercuryFocusArea] */
export type GraphStoreSimplifiedPositionAllocatedToFocusAreaUnion =
    MercuryFocusArea;

/** A simplified connection for the relationship type pr-in-repo */
export type GraphStoreSimplifiedPrInRepoConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedPrInRepoConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedPrInRepoEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type pr-in-repo */
export type GraphStoreSimplifiedPrInRepoEdge = {
    __typename?: "GraphStoreSimplifiedPrInRepoEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedPrInRepoUnion>;
};

/** A simplified connection for the relationship type pr-in-repo */
export type GraphStoreSimplifiedPrInRepoInverseConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedPrInRepoInverseConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedPrInRepoInverseEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type pr-in-repo */
export type GraphStoreSimplifiedPrInRepoInverseEdge = {
    __typename?: "GraphStoreSimplifiedPrInRepoInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedPrInRepoInverseUnion>;
};

/** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedPrInRepoInverseUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A union of the possible hydration types for pr-in-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreSimplifiedPrInRepoUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A simplified connection for the relationship type project-associated-branch */
export type GraphStoreSimplifiedProjectAssociatedBranchConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedBranchConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectAssociatedBranchEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-branch */
export type GraphStoreSimplifiedProjectAssociatedBranchEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedBranchEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedBranchUnion>;
};

/** A simplified connection for the relationship type project-associated-branch */
export type GraphStoreSimplifiedProjectAssociatedBranchInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedBranchInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedBranchInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-branch */
export type GraphStoreSimplifiedProjectAssociatedBranchInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedBranchInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedBranchInverseUnion>;
};

/** A union of the possible hydration types for project-associated-branch: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedBranchInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-branch: [ExternalBranch] */
export type GraphStoreSimplifiedProjectAssociatedBranchUnion = ExternalBranch;

/** A simplified connection for the relationship type project-associated-build */
export type GraphStoreSimplifiedProjectAssociatedBuildConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedProjectAssociatedBuildConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedProjectAssociatedBuildEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type project-associated-build */
export type GraphStoreSimplifiedProjectAssociatedBuildEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedBuildEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:build, ati:cloud:graph:build]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedBuildUnion>;
};

/** A simplified connection for the relationship type project-associated-build */
export type GraphStoreSimplifiedProjectAssociatedBuildInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedBuildInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedBuildInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-build */
export type GraphStoreSimplifiedProjectAssociatedBuildInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedBuildInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedBuildInverseUnion>;
};

/** A union of the possible hydration types for project-associated-build: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedBuildInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-build: [ExternalBuildInfo] */
export type GraphStoreSimplifiedProjectAssociatedBuildUnion = ExternalBuildInfo;

/** A simplified connection for the relationship type project-associated-deployment */
export type GraphStoreSimplifiedProjectAssociatedDeploymentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedDeploymentConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedDeploymentEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-deployment */
export type GraphStoreSimplifiedProjectAssociatedDeploymentEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedDeploymentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedDeploymentUnion>;
};

/** A simplified connection for the relationship type project-associated-deployment */
export type GraphStoreSimplifiedProjectAssociatedDeploymentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedDeploymentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedDeploymentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-deployment */
export type GraphStoreSimplifiedProjectAssociatedDeploymentInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedDeploymentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedDeploymentInverseUnion>;
};

/** A union of the possible hydration types for project-associated-deployment: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedDeploymentInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedProjectAssociatedDeploymentUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A simplified connection for the relationship type project-associated-feature-flag */
export type GraphStoreSimplifiedProjectAssociatedFeatureFlagConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedFeatureFlagConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedFeatureFlagEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-feature-flag */
export type GraphStoreSimplifiedProjectAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedFeatureFlagEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedFeatureFlagUnion>;
};

/** A simplified connection for the relationship type project-associated-feature-flag */
export type GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-feature-flag */
export type GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseUnion>;
};

/** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedFeatureFlagInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreSimplifiedProjectAssociatedFeatureFlagUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A simplified connection for the relationship type project-associated-incident */
export type GraphStoreSimplifiedProjectAssociatedIncidentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedIncidentConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectAssociatedIncidentEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-incident */
export type GraphStoreSimplifiedProjectAssociatedIncidentEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedIncidentUnion>;
};

/** A simplified connection for the relationship type project-associated-incident */
export type GraphStoreSimplifiedProjectAssociatedIncidentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedIncidentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedIncidentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-incident */
export type GraphStoreSimplifiedProjectAssociatedIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedIncidentInverseUnion>;
};

/** A union of the possible hydration types for project-associated-incident: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedIncidentInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-incident: [JiraIssue] */
export type GraphStoreSimplifiedProjectAssociatedIncidentUnion = JiraIssue;

/** A simplified connection for the relationship type project-associated-opsgenie-team */
export type GraphStoreSimplifiedProjectAssociatedOpsgenieTeamConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedOpsgenieTeamConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedOpsgenieTeamEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-opsgenie-team */
export type GraphStoreSimplifiedProjectAssociatedOpsgenieTeamEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedOpsgenieTeamEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:opsgenie:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedOpsgenieTeamUnion>;
};

/** A simplified connection for the relationship type project-associated-opsgenie-team */
export type GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-opsgenie-team */
export type GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseUnion>;
};

/** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedOpsgenieTeamInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */
export type GraphStoreSimplifiedProjectAssociatedOpsgenieTeamUnion =
    OpsgenieTeam;

/** A simplified connection for the relationship type project-associated-pr */
export type GraphStoreSimplifiedProjectAssociatedPrConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedProjectAssociatedPrConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedProjectAssociatedPrEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type project-associated-pr */
export type GraphStoreSimplifiedProjectAssociatedPrEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedPrEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedPrUnion>;
};

/** A simplified connection for the relationship type project-associated-pr */
export type GraphStoreSimplifiedProjectAssociatedPrInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedPrInverseConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectAssociatedPrInverseEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-pr */
export type GraphStoreSimplifiedProjectAssociatedPrInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedPrInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedPrInverseUnion>;
};

/** A union of the possible hydration types for project-associated-pr: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedPrInverseUnion = JiraProject;

/** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedProjectAssociatedPrUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type project-associated-repo */
export type GraphStoreSimplifiedProjectAssociatedRepoConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedProjectAssociatedRepoConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedProjectAssociatedRepoEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type project-associated-repo */
export type GraphStoreSimplifiedProjectAssociatedRepoEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedRepoEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedRepoUnion>;
};

/** A simplified connection for the relationship type project-associated-repo */
export type GraphStoreSimplifiedProjectAssociatedRepoInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedRepoInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedRepoInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-repo */
export type GraphStoreSimplifiedProjectAssociatedRepoInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedRepoInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedRepoInverseUnion>;
};

/** A union of the possible hydration types for project-associated-repo: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedRepoInverseUnion = JiraProject;

/** A union of the possible hydration types for project-associated-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreSimplifiedProjectAssociatedRepoUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A simplified connection for the relationship type project-associated-service */
export type GraphStoreSimplifiedProjectAssociatedServiceConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedServiceConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectAssociatedServiceEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-service */
export type GraphStoreSimplifiedProjectAssociatedServiceEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedServiceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedServiceUnion>;
};

/** A simplified connection for the relationship type project-associated-service */
export type GraphStoreSimplifiedProjectAssociatedServiceInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedServiceInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedServiceInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-service */
export type GraphStoreSimplifiedProjectAssociatedServiceInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedServiceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedServiceInverseUnion>;
};

/** A union of the possible hydration types for project-associated-service: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedServiceInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-service: [DevOpsService] */
export type GraphStoreSimplifiedProjectAssociatedServiceUnion = DevOpsService;

/** A simplified connection for the relationship type project-associated-to-incident */
export type GraphStoreSimplifiedProjectAssociatedToIncidentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedToIncidentConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedToIncidentEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-to-incident */
export type GraphStoreSimplifiedProjectAssociatedToIncidentEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedToIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue, ati:cloud:jira:incident, ati:cloud:graph:incident]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedToIncidentUnion>;
};

/** A simplified connection for the relationship type project-associated-to-incident */
export type GraphStoreSimplifiedProjectAssociatedToIncidentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedToIncidentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedToIncidentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-to-incident */
export type GraphStoreSimplifiedProjectAssociatedToIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedToIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedToIncidentInverseUnion>;
};

/** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedToIncidentInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */
export type GraphStoreSimplifiedProjectAssociatedToIncidentUnion =
    | DevOpsOperationsIncidentDetails
    | JiraIssue;

/** A simplified connection for the relationship type project-associated-to-operations-container */
export type GraphStoreSimplifiedProjectAssociatedToOperationsContainerConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedToOperationsContainerConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedToOperationsContainerEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-to-operations-container */
export type GraphStoreSimplifiedProjectAssociatedToOperationsContainerEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedToOperationsContainerEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedToOperationsContainerUnion>;
};

/** A simplified connection for the relationship type project-associated-to-operations-container */
export type GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-to-operations-container */
export type GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:jira:project]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseUnion>;
    };

/** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedToOperationsContainerInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */
export type GraphStoreSimplifiedProjectAssociatedToOperationsContainerUnion =
    DevOpsService;

/** A simplified connection for the relationship type project-associated-to-security-container */
export type GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-to-security-container */
export type GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:jira:project]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseUnion>;
    };

/** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedToSecurityContainerInverseUnion =
    JiraProject;

/** A simplified connection for the relationship type project-associated-vulnerability */
export type GraphStoreSimplifiedProjectAssociatedVulnerabilityConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedVulnerabilityConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedVulnerabilityEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-vulnerability */
export type GraphStoreSimplifiedProjectAssociatedVulnerabilityEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedVulnerabilityEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedVulnerabilityUnion>;
};

/** A simplified connection for the relationship type project-associated-vulnerability */
export type GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-associated-vulnerability */
export type GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseUnion>;
};

/** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */
export type GraphStoreSimplifiedProjectAssociatedVulnerabilityInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreSimplifiedProjectAssociatedVulnerabilityUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

/** A simplified connection for the relationship type project-disassociated-repo */
export type GraphStoreSimplifiedProjectDisassociatedRepoConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDisassociatedRepoConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectDisassociatedRepoEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-disassociated-repo */
export type GraphStoreSimplifiedProjectDisassociatedRepoEdge = {
    __typename?: "GraphStoreSimplifiedProjectDisassociatedRepoEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDisassociatedRepoUnion>;
};

/** A simplified connection for the relationship type project-disassociated-repo */
export type GraphStoreSimplifiedProjectDisassociatedRepoInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDisassociatedRepoInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectDisassociatedRepoInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-disassociated-repo */
export type GraphStoreSimplifiedProjectDisassociatedRepoInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectDisassociatedRepoInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDisassociatedRepoInverseUnion>;
};

/** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */
export type GraphStoreSimplifiedProjectDisassociatedRepoInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreSimplifiedProjectDisassociatedRepoUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A simplified connection for the relationship type project-documentation-entity */
export type GraphStoreSimplifiedProjectDocumentationEntityConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDocumentationEntityConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectDocumentationEntityEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-documentation-entity */
export type GraphStoreSimplifiedProjectDocumentationEntityEdge = {
    __typename?: "GraphStoreSimplifiedProjectDocumentationEntityEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space, ati:cloud:confluence:page, ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDocumentationEntityUnion>;
};

/** A simplified connection for the relationship type project-documentation-entity */
export type GraphStoreSimplifiedProjectDocumentationEntityInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDocumentationEntityInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectDocumentationEntityInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-documentation-entity */
export type GraphStoreSimplifiedProjectDocumentationEntityInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectDocumentationEntityInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDocumentationEntityInverseUnion>;
};

/** A union of the possible hydration types for project-documentation-entity: [JiraProject] */
export type GraphStoreSimplifiedProjectDocumentationEntityInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedProjectDocumentationEntityUnion =
    | ConfluencePage
    | ConfluenceSpace
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type project-documentation-page */
export type GraphStoreSimplifiedProjectDocumentationPageConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDocumentationPageConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectDocumentationPageEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-documentation-page */
export type GraphStoreSimplifiedProjectDocumentationPageEdge = {
    __typename?: "GraphStoreSimplifiedProjectDocumentationPageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDocumentationPageUnion>;
};

/** A simplified connection for the relationship type project-documentation-page */
export type GraphStoreSimplifiedProjectDocumentationPageInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDocumentationPageInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectDocumentationPageInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-documentation-page */
export type GraphStoreSimplifiedProjectDocumentationPageInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectDocumentationPageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDocumentationPageInverseUnion>;
};

/** A union of the possible hydration types for project-documentation-page: [JiraProject] */
export type GraphStoreSimplifiedProjectDocumentationPageInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */
export type GraphStoreSimplifiedProjectDocumentationPageUnion = ConfluencePage;

/** A simplified connection for the relationship type project-documentation-space */
export type GraphStoreSimplifiedProjectDocumentationSpaceConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDocumentationSpaceConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectDocumentationSpaceEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-documentation-space */
export type GraphStoreSimplifiedProjectDocumentationSpaceEdge = {
    __typename?: "GraphStoreSimplifiedProjectDocumentationSpaceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDocumentationSpaceUnion>;
};

/** A simplified connection for the relationship type project-documentation-space */
export type GraphStoreSimplifiedProjectDocumentationSpaceInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectDocumentationSpaceInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectDocumentationSpaceInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-documentation-space */
export type GraphStoreSimplifiedProjectDocumentationSpaceInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectDocumentationSpaceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectDocumentationSpaceInverseUnion>;
};

/** A union of the possible hydration types for project-documentation-space: [JiraProject] */
export type GraphStoreSimplifiedProjectDocumentationSpaceInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */
export type GraphStoreSimplifiedProjectDocumentationSpaceUnion =
    ConfluenceSpace;

/** A simplified connection for the relationship type project-explicitly-associated-repo */
export type GraphStoreSimplifiedProjectExplicitlyAssociatedRepoConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectExplicitlyAssociatedRepoConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectExplicitlyAssociatedRepoEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-explicitly-associated-repo */
export type GraphStoreSimplifiedProjectExplicitlyAssociatedRepoEdge = {
    __typename?: "GraphStoreSimplifiedProjectExplicitlyAssociatedRepoEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:repository, ati:cloud:graph:repository]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectExplicitlyAssociatedRepoUnion>;
};

/** A simplified connection for the relationship type project-explicitly-associated-repo */
export type GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-explicitly-associated-repo */
export type GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseUnion>;
};

/** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */
export type GraphStoreSimplifiedProjectExplicitlyAssociatedRepoInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository, ExternalRepository] */
export type GraphStoreSimplifiedProjectExplicitlyAssociatedRepoUnion =
    | DevOpsRepository
    | ExternalRepository;

/** A simplified connection for the relationship type project-has-issue */
export type GraphStoreSimplifiedProjectHasIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedProjectHasIssueConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedProjectHasIssueEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type project-has-issue */
export type GraphStoreSimplifiedProjectHasIssueEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasIssueUnion>;
};

/** A simplified connection for the relationship type project-has-issue */
export type GraphStoreSimplifiedProjectHasIssueInverseConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedProjectHasIssueInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedProjectHasIssueInverseEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type project-has-issue */
export type GraphStoreSimplifiedProjectHasIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasIssueInverseUnion>;
};

/** A union of the possible hydration types for project-has-issue: [JiraProject] */
export type GraphStoreSimplifiedProjectHasIssueInverseUnion = JiraProject;

/** A union of the possible hydration types for project-has-issue: [JiraIssue] */
export type GraphStoreSimplifiedProjectHasIssueUnion = JiraIssue;

/** A simplified connection for the relationship type project-has-related-work-with-project */
export type GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-has-related-work-with-project */
export type GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasRelatedWorkWithProjectUnion>;
};

/** A simplified connection for the relationship type project-has-related-work-with-project */
export type GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-has-related-work-with-project */
export type GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseUnion>;
};

/** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */
export type GraphStoreSimplifiedProjectHasRelatedWorkWithProjectInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */
export type GraphStoreSimplifiedProjectHasRelatedWorkWithProjectUnion =
    JiraProject;

/** A simplified connection for the relationship type project-has-shared-version-with */
export type GraphStoreSimplifiedProjectHasSharedVersionWithConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectHasSharedVersionWithConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectHasSharedVersionWithEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-has-shared-version-with */
export type GraphStoreSimplifiedProjectHasSharedVersionWithEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasSharedVersionWithEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasSharedVersionWithUnion>;
};

/** A simplified connection for the relationship type project-has-shared-version-with */
export type GraphStoreSimplifiedProjectHasSharedVersionWithInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectHasSharedVersionWithInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectHasSharedVersionWithInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-has-shared-version-with */
export type GraphStoreSimplifiedProjectHasSharedVersionWithInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasSharedVersionWithInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasSharedVersionWithInverseUnion>;
};

/** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */
export type GraphStoreSimplifiedProjectHasSharedVersionWithInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */
export type GraphStoreSimplifiedProjectHasSharedVersionWithUnion = JiraProject;

/** A simplified connection for the relationship type project-has-version */
export type GraphStoreSimplifiedProjectHasVersionConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedProjectHasVersionConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedProjectHasVersionEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type project-has-version */
export type GraphStoreSimplifiedProjectHasVersionEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasVersionEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasVersionUnion>;
};

/** A simplified connection for the relationship type project-has-version */
export type GraphStoreSimplifiedProjectHasVersionInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectHasVersionInverseConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedProjectHasVersionInverseEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-has-version */
export type GraphStoreSimplifiedProjectHasVersionInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectHasVersionInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectHasVersionInverseUnion>;
};

/** A union of the possible hydration types for project-has-version: [JiraProject] */
export type GraphStoreSimplifiedProjectHasVersionInverseUnion = JiraProject;

/** A union of the possible hydration types for project-has-version: [JiraVersion] */
export type GraphStoreSimplifiedProjectHasVersionUnion = JiraVersion;

/** A simplified connection for the relationship type project-linked-to-compass-component */
export type GraphStoreSimplifiedProjectLinkedToCompassComponentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectLinkedToCompassComponentConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectLinkedToCompassComponentEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-linked-to-compass-component */
export type GraphStoreSimplifiedProjectLinkedToCompassComponentEdge = {
    __typename?: "GraphStoreSimplifiedProjectLinkedToCompassComponentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:compass:component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectLinkedToCompassComponentUnion>;
};

/** A simplified connection for the relationship type project-linked-to-compass-component */
export type GraphStoreSimplifiedProjectLinkedToCompassComponentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedProjectLinkedToCompassComponentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedProjectLinkedToCompassComponentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type project-linked-to-compass-component */
export type GraphStoreSimplifiedProjectLinkedToCompassComponentInverseEdge = {
    __typename?: "GraphStoreSimplifiedProjectLinkedToCompassComponentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedProjectLinkedToCompassComponentInverseUnion>;
};

/** A union of the possible hydration types for project-linked-to-compass-component: [JiraProject] */
export type GraphStoreSimplifiedProjectLinkedToCompassComponentInverseUnion =
    JiraProject;

/** A union of the possible hydration types for project-linked-to-compass-component: [CompassComponent] */
export type GraphStoreSimplifiedProjectLinkedToCompassComponentUnion =
    CompassComponent;

/** A simplified connection for the relationship type pull-request-links-to-service */
export type GraphStoreSimplifiedPullRequestLinksToServiceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedPullRequestLinksToServiceConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedPullRequestLinksToServiceEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type pull-request-links-to-service */
export type GraphStoreSimplifiedPullRequestLinksToServiceEdge = {
    __typename?: "GraphStoreSimplifiedPullRequestLinksToServiceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedPullRequestLinksToServiceUnion>;
};

/** A simplified connection for the relationship type pull-request-links-to-service */
export type GraphStoreSimplifiedPullRequestLinksToServiceInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedPullRequestLinksToServiceInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedPullRequestLinksToServiceInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type pull-request-links-to-service */
export type GraphStoreSimplifiedPullRequestLinksToServiceInverseEdge = {
    __typename?: "GraphStoreSimplifiedPullRequestLinksToServiceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedPullRequestLinksToServiceInverseUnion>;
};

/** A union of the possible hydration types for pull-request-links-to-service: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedPullRequestLinksToServiceInverseUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A union of the possible hydration types for pull-request-links-to-service: [DevOpsService] */
export type GraphStoreSimplifiedPullRequestLinksToServiceUnion = DevOpsService;

/** A simplified connection for the relationship type security-container-associated-to-vulnerability */
export type GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type security-container-associated-to-vulnerability */
export type GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityEdge =
    {
        __typename?: "GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityUnion>;
    };

/** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreSimplifiedSecurityContainerAssociatedToVulnerabilityUnion =
    DevOpsSecurityVulnerabilityDetails | ExternalVulnerability;

/** A simplified connection for the relationship type service-associated-branch */
export type GraphStoreSimplifiedServiceAssociatedBranchConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedBranchConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceAssociatedBranchEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-branch */
export type GraphStoreSimplifiedServiceAssociatedBranchEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedBranchEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedBranchUnion>;
};

/** A simplified connection for the relationship type service-associated-branch */
export type GraphStoreSimplifiedServiceAssociatedBranchInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedBranchInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceAssociatedBranchInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-branch */
export type GraphStoreSimplifiedServiceAssociatedBranchInverseEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedBranchInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedBranchInverseUnion>;
};

/** A union of the possible hydration types for service-associated-branch: [DevOpsService] */
export type GraphStoreSimplifiedServiceAssociatedBranchInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for service-associated-branch: [ExternalBranch] */
export type GraphStoreSimplifiedServiceAssociatedBranchUnion = ExternalBranch;

/** A simplified connection for the relationship type service-associated-deployment */
export type GraphStoreSimplifiedServiceAssociatedDeploymentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedDeploymentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceAssociatedDeploymentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-deployment */
export type GraphStoreSimplifiedServiceAssociatedDeploymentEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedDeploymentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedDeploymentUnion>;
};

/** A simplified connection for the relationship type service-associated-deployment */
export type GraphStoreSimplifiedServiceAssociatedDeploymentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedDeploymentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedServiceAssociatedDeploymentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-deployment */
export type GraphStoreSimplifiedServiceAssociatedDeploymentInverseEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedDeploymentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedDeploymentInverseUnion>;
};

/** A union of the possible hydration types for service-associated-deployment: [DevOpsService] */
export type GraphStoreSimplifiedServiceAssociatedDeploymentInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for service-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedServiceAssociatedDeploymentUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A simplified connection for the relationship type service-associated-remote-link */
export type GraphStoreSimplifiedServiceAssociatedRemoteLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedRemoteLinkConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceAssociatedRemoteLinkEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-remote-link */
export type GraphStoreSimplifiedServiceAssociatedRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedRemoteLinkUnion>;
};

/** A simplified connection for the relationship type service-associated-remote-link */
export type GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-remote-link */
export type GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseUnion>;
};

/** A union of the possible hydration types for service-associated-remote-link: [DevOpsService] */
export type GraphStoreSimplifiedServiceAssociatedRemoteLinkInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for service-associated-remote-link: [ExternalRemoteLink] */
export type GraphStoreSimplifiedServiceAssociatedRemoteLinkUnion =
    ExternalRemoteLink;

/** A simplified connection for the relationship type service-associated-team */
export type GraphStoreSimplifiedServiceAssociatedTeamConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedTeamConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceAssociatedTeamEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-team */
export type GraphStoreSimplifiedServiceAssociatedTeamEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedTeamEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:opsgenie:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedTeamUnion>;
};

/** A simplified connection for the relationship type service-associated-team */
export type GraphStoreSimplifiedServiceAssociatedTeamInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedServiceAssociatedTeamInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceAssociatedTeamInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type service-associated-team */
export type GraphStoreSimplifiedServiceAssociatedTeamInverseEdge = {
    __typename?: "GraphStoreSimplifiedServiceAssociatedTeamInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceAssociatedTeamInverseUnion>;
};

/** A union of the possible hydration types for service-associated-team: [DevOpsService] */
export type GraphStoreSimplifiedServiceAssociatedTeamInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for service-associated-team: [OpsgenieTeam] */
export type GraphStoreSimplifiedServiceAssociatedTeamUnion = OpsgenieTeam;

/** A simplified connection for the relationship type service-linked-incident */
export type GraphStoreSimplifiedServiceLinkedIncidentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedServiceLinkedIncidentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedServiceLinkedIncidentEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type service-linked-incident */
export type GraphStoreSimplifiedServiceLinkedIncidentEdge = {
    __typename?: "GraphStoreSimplifiedServiceLinkedIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceLinkedIncidentUnion>;
};

/** A simplified connection for the relationship type service-linked-incident */
export type GraphStoreSimplifiedServiceLinkedIncidentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedServiceLinkedIncidentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedServiceLinkedIncidentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type service-linked-incident */
export type GraphStoreSimplifiedServiceLinkedIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedServiceLinkedIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:service]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedServiceLinkedIncidentInverseUnion>;
};

/** A union of the possible hydration types for service-linked-incident: [DevOpsService] */
export type GraphStoreSimplifiedServiceLinkedIncidentInverseUnion =
    DevOpsService;

/** A union of the possible hydration types for service-linked-incident: [JiraIssue] */
export type GraphStoreSimplifiedServiceLinkedIncidentUnion = JiraIssue;

/** A simplified connection for the relationship type space-associated-with-project */
export type GraphStoreSimplifiedSpaceAssociatedWithProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedSpaceAssociatedWithProjectConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedSpaceAssociatedWithProjectEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type space-associated-with-project */
export type GraphStoreSimplifiedSpaceAssociatedWithProjectEdge = {
    __typename?: "GraphStoreSimplifiedSpaceAssociatedWithProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSpaceAssociatedWithProjectUnion>;
};

/** A simplified connection for the relationship type space-associated-with-project */
export type GraphStoreSimplifiedSpaceAssociatedWithProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedSpaceAssociatedWithProjectInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedSpaceAssociatedWithProjectInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type space-associated-with-project */
export type GraphStoreSimplifiedSpaceAssociatedWithProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedSpaceAssociatedWithProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSpaceAssociatedWithProjectInverseUnion>;
};

/** A union of the possible hydration types for space-associated-with-project: [ConfluenceSpace] */
export type GraphStoreSimplifiedSpaceAssociatedWithProjectInverseUnion =
    ConfluenceSpace;

/** A union of the possible hydration types for space-associated-with-project: [JiraProject] */
export type GraphStoreSimplifiedSpaceAssociatedWithProjectUnion = JiraProject;

/** A simplified connection for the relationship type sprint-associated-build */
export type GraphStoreSimplifiedSprintAssociatedBuildConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedSprintAssociatedBuildConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedSprintAssociatedBuildEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type sprint-associated-build */
export type GraphStoreSimplifiedSprintAssociatedBuildEdge = {
    __typename?: "GraphStoreSimplifiedSprintAssociatedBuildEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:build, ati:cloud:graph:build]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintAssociatedBuildUnion>;
};

/** A union of the possible hydration types for sprint-associated-build: [ExternalBuildInfo] */
export type GraphStoreSimplifiedSprintAssociatedBuildUnion = ExternalBuildInfo;

/** A simplified connection for the relationship type sprint-associated-deployment */
export type GraphStoreSimplifiedSprintAssociatedDeploymentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedSprintAssociatedDeploymentConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedSprintAssociatedDeploymentEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type sprint-associated-deployment */
export type GraphStoreSimplifiedSprintAssociatedDeploymentEdge = {
    __typename?: "GraphStoreSimplifiedSprintAssociatedDeploymentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintAssociatedDeploymentUnion>;
};

/** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedSprintAssociatedDeploymentUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A simplified connection for the relationship type sprint-associated-pr */
export type GraphStoreSimplifiedSprintAssociatedPrConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedSprintAssociatedPrConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedSprintAssociatedPrEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type sprint-associated-pr */
export type GraphStoreSimplifiedSprintAssociatedPrEdge = {
    __typename?: "GraphStoreSimplifiedSprintAssociatedPrEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintAssociatedPrUnion>;
};

/** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedSprintAssociatedPrUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type sprint-associated-vulnerability */
export type GraphStoreSimplifiedSprintAssociatedVulnerabilityConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedSprintAssociatedVulnerabilityConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedSprintAssociatedVulnerabilityEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type sprint-associated-vulnerability */
export type GraphStoreSimplifiedSprintAssociatedVulnerabilityEdge = {
    __typename?: "GraphStoreSimplifiedSprintAssociatedVulnerabilityEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintAssociatedVulnerabilityUnion>;
};

/** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreSimplifiedSprintAssociatedVulnerabilityUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

/** A simplified connection for the relationship type sprint-contains-issue */
export type GraphStoreSimplifiedSprintContainsIssueConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedSprintContainsIssueConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedSprintContainsIssueEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type sprint-contains-issue */
export type GraphStoreSimplifiedSprintContainsIssueEdge = {
    __typename?: "GraphStoreSimplifiedSprintContainsIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintContainsIssueUnion>;
};

/** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */
export type GraphStoreSimplifiedSprintContainsIssueUnion = JiraIssue;

/** A simplified connection for the relationship type sprint-retrospective-page */
export type GraphStoreSimplifiedSprintRetrospectivePageConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedSprintRetrospectivePageConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedSprintRetrospectivePageEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type sprint-retrospective-page */
export type GraphStoreSimplifiedSprintRetrospectivePageEdge = {
    __typename?: "GraphStoreSimplifiedSprintRetrospectivePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintRetrospectivePageUnion>;
};

/** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */
export type GraphStoreSimplifiedSprintRetrospectivePageUnion = ConfluencePage;

/** A simplified connection for the relationship type sprint-retrospective-whiteboard */
export type GraphStoreSimplifiedSprintRetrospectiveWhiteboardConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedSprintRetrospectiveWhiteboardConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedSprintRetrospectiveWhiteboardEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type sprint-retrospective-whiteboard */
export type GraphStoreSimplifiedSprintRetrospectiveWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedSprintRetrospectiveWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedSprintRetrospectiveWhiteboardUnion>;
};

/** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedSprintRetrospectiveWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type team-connected-to-container */
export type GraphStoreSimplifiedTeamConnectedToContainerConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedTeamConnectedToContainerConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedTeamConnectedToContainerEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type team-connected-to-container */
export type GraphStoreSimplifiedTeamConnectedToContainerEdge = {
    __typename?: "GraphStoreSimplifiedTeamConnectedToContainerEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project, ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedTeamConnectedToContainerUnion>;
};

/** A simplified connection for the relationship type team-connected-to-container */
export type GraphStoreSimplifiedTeamConnectedToContainerInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedTeamConnectedToContainerInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedTeamConnectedToContainerInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type team-connected-to-container */
export type GraphStoreSimplifiedTeamConnectedToContainerInverseEdge = {
    __typename?: "GraphStoreSimplifiedTeamConnectedToContainerInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedTeamConnectedToContainerInverseUnion>;
};

/** A union of the possible hydration types for team-connected-to-container: [TeamV2] */
export type GraphStoreSimplifiedTeamConnectedToContainerInverseUnion = TeamV2;

/** A union of the possible hydration types for team-connected-to-container: [JiraProject, ConfluenceSpace] */
export type GraphStoreSimplifiedTeamConnectedToContainerUnion =
    | ConfluenceSpace
    | JiraProject;

/** A simplified connection for the relationship type team-owns-component */
export type GraphStoreSimplifiedTeamOwnsComponentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedTeamOwnsComponentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedTeamOwnsComponentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type team-owns-component */
export type GraphStoreSimplifiedTeamOwnsComponentEdge = {
    __typename?: "GraphStoreSimplifiedTeamOwnsComponentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:compass:component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedTeamOwnsComponentUnion>;
};

/** A simplified connection for the relationship type team-owns-component */
export type GraphStoreSimplifiedTeamOwnsComponentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedTeamOwnsComponentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedTeamOwnsComponentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type team-owns-component */
export type GraphStoreSimplifiedTeamOwnsComponentInverseEdge = {
    __typename?: "GraphStoreSimplifiedTeamOwnsComponentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:teams:team, ati:cloud:identity:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedTeamOwnsComponentInverseUnion>;
};

/** A union of the possible hydration types for team-owns-component: [TeamV2] */
export type GraphStoreSimplifiedTeamOwnsComponentInverseUnion = TeamV2;

/** A union of the possible hydration types for team-owns-component: [CompassComponent] */
export type GraphStoreSimplifiedTeamOwnsComponentUnion = CompassComponent;

/** A simplified connection for the relationship type team-works-on-project */
export type GraphStoreSimplifiedTeamWorksOnProjectConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedTeamWorksOnProjectConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedTeamWorksOnProjectEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type team-works-on-project */
export type GraphStoreSimplifiedTeamWorksOnProjectEdge = {
    __typename?: "GraphStoreSimplifiedTeamWorksOnProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedTeamWorksOnProjectUnion>;
};

/** A simplified connection for the relationship type team-works-on-project */
export type GraphStoreSimplifiedTeamWorksOnProjectInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedTeamWorksOnProjectInverseConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedTeamWorksOnProjectInverseEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type team-works-on-project */
export type GraphStoreSimplifiedTeamWorksOnProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedTeamWorksOnProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedTeamWorksOnProjectInverseUnion>;
};

/** A union of the possible hydration types for team-works-on-project: [TeamV2] */
export type GraphStoreSimplifiedTeamWorksOnProjectInverseUnion = TeamV2;

/** A union of the possible hydration types for team-works-on-project: [JiraProject] */
export type GraphStoreSimplifiedTeamWorksOnProjectUnion = JiraProject;

/** A simplified connection for the relationship type third-party-to-graph-remote-link */
export type GraphStoreSimplifiedThirdPartyToGraphRemoteLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedThirdPartyToGraphRemoteLinkConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedThirdPartyToGraphRemoteLinkEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type third-party-to-graph-remote-link */
export type GraphStoreSimplifiedThirdPartyToGraphRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedThirdPartyToGraphRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedThirdPartyToGraphRemoteLinkUnion>;
};

/** A union of the possible hydration types for third-party-to-graph-remote-link: [ExternalRemoteLink] */
export type GraphStoreSimplifiedThirdPartyToGraphRemoteLinkUnion =
    ExternalRemoteLink;

/** A simplified connection for the relationship type user-assigned-incident */
export type GraphStoreSimplifiedUserAssignedIncidentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserAssignedIncidentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserAssignedIncidentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-assigned-incident */
export type GraphStoreSimplifiedUserAssignedIncidentEdge = {
    __typename?: "GraphStoreSimplifiedUserAssignedIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAssignedIncidentUnion>;
};

/** A simplified connection for the relationship type user-assigned-incident */
export type GraphStoreSimplifiedUserAssignedIncidentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAssignedIncidentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserAssignedIncidentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-assigned-incident */
export type GraphStoreSimplifiedUserAssignedIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserAssignedIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAssignedIncidentInverseUnion>;
};

/** A union of the possible hydration types for user-assigned-incident: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAssignedIncidentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-assigned-incident: [JiraIssue] */
export type GraphStoreSimplifiedUserAssignedIncidentUnion = JiraIssue;

/** A simplified connection for the relationship type user-assigned-issue */
export type GraphStoreSimplifiedUserAssignedIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserAssignedIssueConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserAssignedIssueEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-assigned-issue */
export type GraphStoreSimplifiedUserAssignedIssueEdge = {
    __typename?: "GraphStoreSimplifiedUserAssignedIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAssignedIssueUnion>;
};

/** A simplified connection for the relationship type user-assigned-issue */
export type GraphStoreSimplifiedUserAssignedIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAssignedIssueInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserAssignedIssueInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-assigned-issue */
export type GraphStoreSimplifiedUserAssignedIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserAssignedIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAssignedIssueInverseUnion>;
};

/** A union of the possible hydration types for user-assigned-issue: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAssignedIssueInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-assigned-issue: [JiraIssue] */
export type GraphStoreSimplifiedUserAssignedIssueUnion = JiraIssue;

/** A simplified connection for the relationship type user-assigned-pir */
export type GraphStoreSimplifiedUserAssignedPirConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserAssignedPirConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserAssignedPirEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-assigned-pir */
export type GraphStoreSimplifiedUserAssignedPirEdge = {
    __typename?: "GraphStoreSimplifiedUserAssignedPirEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAssignedPirUnion>;
};

/** A simplified connection for the relationship type user-assigned-pir */
export type GraphStoreSimplifiedUserAssignedPirInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAssignedPirInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserAssignedPirInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-assigned-pir */
export type GraphStoreSimplifiedUserAssignedPirInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserAssignedPirInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAssignedPirInverseUnion>;
};

/** A union of the possible hydration types for user-assigned-pir: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAssignedPirInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-assigned-pir: [JiraIssue] */
export type GraphStoreSimplifiedUserAssignedPirUnion = JiraIssue;

/** A simplified connection for the relationship type user-attended-calendar-event */
export type GraphStoreSimplifiedUserAttendedCalendarEventConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAttendedCalendarEventConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserAttendedCalendarEventEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-attended-calendar-event */
export type GraphStoreSimplifiedUserAttendedCalendarEventEdge = {
    __typename?: "GraphStoreSimplifiedUserAttendedCalendarEventEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:calendar-event]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAttendedCalendarEventUnion>;
};

/** A simplified connection for the relationship type user-attended-calendar-event */
export type GraphStoreSimplifiedUserAttendedCalendarEventInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAttendedCalendarEventInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserAttendedCalendarEventInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-attended-calendar-event */
export type GraphStoreSimplifiedUserAttendedCalendarEventInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserAttendedCalendarEventInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAttendedCalendarEventInverseUnion>;
};

/** A union of the possible hydration types for user-attended-calendar-event: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAttendedCalendarEventInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-attended-calendar-event: [ExternalCalendarEvent] */
export type GraphStoreSimplifiedUserAttendedCalendarEventUnion =
    ExternalCalendarEvent;

/** A simplified connection for the relationship type user-authored-commit */
export type GraphStoreSimplifiedUserAuthoredCommitConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserAuthoredCommitConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserAuthoredCommitEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-authored-commit */
export type GraphStoreSimplifiedUserAuthoredCommitEdge = {
    __typename?: "GraphStoreSimplifiedUserAuthoredCommitEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAuthoredCommitUnion>;
};

/** A simplified connection for the relationship type user-authored-commit */
export type GraphStoreSimplifiedUserAuthoredCommitInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAuthoredCommitInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserAuthoredCommitInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-authored-commit */
export type GraphStoreSimplifiedUserAuthoredCommitInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserAuthoredCommitInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAuthoredCommitInverseUnion>;
};

/** A union of the possible hydration types for user-authored-commit: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAuthoredCommitInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-authored-commit: [ExternalCommit] */
export type GraphStoreSimplifiedUserAuthoredCommitUnion = ExternalCommit;

/** A simplified connection for the relationship type user-authored-pr */
export type GraphStoreSimplifiedUserAuthoredPrConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserAuthoredPrConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserAuthoredPrEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-authored-pr */
export type GraphStoreSimplifiedUserAuthoredPrEdge = {
    __typename?: "GraphStoreSimplifiedUserAuthoredPrEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAuthoredPrUnion>;
};

/** A simplified connection for the relationship type user-authored-pr */
export type GraphStoreSimplifiedUserAuthoredPrInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserAuthoredPrInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserAuthoredPrInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-authored-pr */
export type GraphStoreSimplifiedUserAuthoredPrInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserAuthoredPrInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAuthoredPrInverseUnion>;
};

/** A union of the possible hydration types for user-authored-pr: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAuthoredPrInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-authored-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedUserAuthoredPrUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type user-authoritatively-linked-third-party-user */
export type GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type user-authoritatively-linked-third-party-user */
export type GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserEdge = {
    __typename?: "GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserUnion>;
};

/** A simplified connection for the relationship type user-authoritatively-linked-third-party-user */
export type GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type user-authoritatively-linked-third-party-user */
export type GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:identity:user]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseUnion>;
    };

/** A union of the possible hydration types for user-authoritatively-linked-third-party-user: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserInverseUnion =
    AppUser | AtlassianAccountUser | CustomerUser;

/** A union of the possible hydration types for user-authoritatively-linked-third-party-user: [ThirdPartyUser] */
export type GraphStoreSimplifiedUserAuthoritativelyLinkedThirdPartyUserUnion =
    ThirdPartyUser;

/** A simplified connection for the relationship type user-can-view-confluence-space */
export type GraphStoreSimplifiedUserCanViewConfluenceSpaceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCanViewConfluenceSpaceConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCanViewConfluenceSpaceEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-can-view-confluence-space */
export type GraphStoreSimplifiedUserCanViewConfluenceSpaceEdge = {
    __typename?: "GraphStoreSimplifiedUserCanViewConfluenceSpaceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCanViewConfluenceSpaceUnion>;
};

/** A simplified connection for the relationship type user-can-view-confluence-space */
export type GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-can-view-confluence-space */
export type GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseUnion>;
};

/** A union of the possible hydration types for user-can-view-confluence-space: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCanViewConfluenceSpaceInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-can-view-confluence-space: [ConfluenceSpace] */
export type GraphStoreSimplifiedUserCanViewConfluenceSpaceUnion =
    ConfluenceSpace;

/** A simplified connection for the relationship type user-collaborated-on-document */
export type GraphStoreSimplifiedUserCollaboratedOnDocumentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCollaboratedOnDocumentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCollaboratedOnDocumentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-collaborated-on-document */
export type GraphStoreSimplifiedUserCollaboratedOnDocumentEdge = {
    __typename?: "GraphStoreSimplifiedUserCollaboratedOnDocumentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCollaboratedOnDocumentUnion>;
};

/** A simplified connection for the relationship type user-collaborated-on-document */
export type GraphStoreSimplifiedUserCollaboratedOnDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCollaboratedOnDocumentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCollaboratedOnDocumentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-collaborated-on-document */
export type GraphStoreSimplifiedUserCollaboratedOnDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCollaboratedOnDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCollaboratedOnDocumentInverseUnion>;
};

/** A union of the possible hydration types for user-collaborated-on-document: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserCollaboratedOnDocumentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-collaborated-on-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedUserCollaboratedOnDocumentUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type user-contributed-confluence-blogpost */
export type GraphStoreSimplifiedUserContributedConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluenceBlogpostEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-blogpost */
export type GraphStoreSimplifiedUserContributedConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type user-contributed-confluence-blogpost */
export type GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-blogpost */
export type GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseUnion>;
};

/** A union of the possible hydration types for user-contributed-confluence-blogpost: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserContributedConfluenceBlogpostInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-contributed-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedUserContributedConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type user-contributed-confluence-database */
export type GraphStoreSimplifiedUserContributedConfluenceDatabaseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceDatabaseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluenceDatabaseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-database */
export type GraphStoreSimplifiedUserContributedConfluenceDatabaseEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluenceDatabaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:database]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluenceDatabaseUnion>;
};

/** A simplified connection for the relationship type user-contributed-confluence-database */
export type GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-database */
export type GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseUnion>;
};

/** A union of the possible hydration types for user-contributed-confluence-database: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserContributedConfluenceDatabaseInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-contributed-confluence-database: [ConfluenceDatabase] */
export type GraphStoreSimplifiedUserContributedConfluenceDatabaseUnion =
    ConfluenceDatabase;

/** A simplified connection for the relationship type user-contributed-confluence-page */
export type GraphStoreSimplifiedUserContributedConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserContributedConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-page */
export type GraphStoreSimplifiedUserContributedConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-contributed-confluence-page */
export type GraphStoreSimplifiedUserContributedConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-page */
export type GraphStoreSimplifiedUserContributedConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-contributed-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserContributedConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-contributed-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserContributedConfluencePageUnion =
    ConfluencePage;

/** A simplified connection for the relationship type user-contributed-confluence-whiteboard */
export type GraphStoreSimplifiedUserContributedConfluenceWhiteboardConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceWhiteboardConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluenceWhiteboardEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-whiteboard */
export type GraphStoreSimplifiedUserContributedConfluenceWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedUserContributedConfluenceWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserContributedConfluenceWhiteboardUnion>;
};

/** A simplified connection for the relationship type user-contributed-confluence-whiteboard */
export type GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-contributed-confluence-whiteboard */
export type GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseEdge =
    {
        __typename?: "GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseEdge";
        /** The date and time the relationship was created */
        createdAt: Scalars["DateTime"]["output"];
        cursor?: Maybe<Scalars["String"]["output"]>;
        /** An ARI of the type(s) [ati:cloud:identity:user]. */
        id: Scalars["ID"]["output"];
        /** The date and time the relationship was last updated */
        lastUpdated: Scalars["DateTime"]["output"];
        /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
        node?: Maybe<GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseUnion>;
    };

/** A union of the possible hydration types for user-contributed-confluence-whiteboard: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserContributedConfluenceWhiteboardInverseUnion =
    AppUser | AtlassianAccountUser | CustomerUser;

/** A union of the possible hydration types for user-contributed-confluence-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedUserContributedConfluenceWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type user-created-branch */
export type GraphStoreSimplifiedUserCreatedBranchConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserCreatedBranchConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserCreatedBranchEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-created-branch */
export type GraphStoreSimplifiedUserCreatedBranchEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedBranchEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedBranchUnion>;
};

/** A simplified connection for the relationship type user-created-branch */
export type GraphStoreSimplifiedUserCreatedBranchInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedBranchInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedBranchInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-branch */
export type GraphStoreSimplifiedUserCreatedBranchInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedBranchInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedBranchInverseUnion>;
};

/** A union of the possible hydration types for user-created-branch: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserCreatedBranchInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-branch: [ExternalBranch] */
export type GraphStoreSimplifiedUserCreatedBranchUnion = ExternalBranch;

/** A simplified connection for the relationship type user-created-calendar-event */
export type GraphStoreSimplifiedUserCreatedCalendarEventConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedCalendarEventConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedCalendarEventEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-calendar-event */
export type GraphStoreSimplifiedUserCreatedCalendarEventEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedCalendarEventEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:calendar-event]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedCalendarEventUnion>;
};

/** A simplified connection for the relationship type user-created-calendar-event */
export type GraphStoreSimplifiedUserCreatedCalendarEventInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedCalendarEventInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedCalendarEventInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-calendar-event */
export type GraphStoreSimplifiedUserCreatedCalendarEventInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedCalendarEventInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedCalendarEventInverseUnion>;
};

/** A union of the possible hydration types for user-created-calendar-event: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedCalendarEventInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-calendar-event: [ExternalCalendarEvent] */
export type GraphStoreSimplifiedUserCreatedCalendarEventUnion =
    ExternalCalendarEvent;

/** A simplified connection for the relationship type user-created-confluence-blogpost */
export type GraphStoreSimplifiedUserCreatedConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedConfluenceBlogpostEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-blogpost */
export type GraphStoreSimplifiedUserCreatedConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type user-created-confluence-blogpost */
export type GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-blogpost */
export type GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseUnion>;
};

/** A union of the possible hydration types for user-created-confluence-blogpost: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedConfluenceBlogpostInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedUserCreatedConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type user-created-confluence-comment */
export type GraphStoreSimplifiedUserCreatedConfluenceCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedConfluenceCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-comment */
export type GraphStoreSimplifiedUserCreatedConfluenceCommentEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceCommentUnion>;
};

/** A simplified connection for the relationship type user-created-confluence-comment */
export type GraphStoreSimplifiedUserCreatedConfluenceCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluenceCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-comment */
export type GraphStoreSimplifiedUserCreatedConfluenceCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceCommentInverseUnion>;
};

/** A union of the possible hydration types for user-created-confluence-comment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedConfluenceCommentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-confluence-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedUserCreatedConfluenceCommentUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A simplified connection for the relationship type user-created-confluence-database */
export type GraphStoreSimplifiedUserCreatedConfluenceDatabaseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceDatabaseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedConfluenceDatabaseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-database */
export type GraphStoreSimplifiedUserCreatedConfluenceDatabaseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceDatabaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:database]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceDatabaseUnion>;
};

/** A simplified connection for the relationship type user-created-confluence-database */
export type GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-database */
export type GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseUnion>;
};

/** A union of the possible hydration types for user-created-confluence-database: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedConfluenceDatabaseInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-confluence-database: [ConfluenceDatabase] */
export type GraphStoreSimplifiedUserCreatedConfluenceDatabaseUnion =
    ConfluenceDatabase;

/** A simplified connection for the relationship type user-created-confluence-page */
export type GraphStoreSimplifiedUserCreatedConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-page */
export type GraphStoreSimplifiedUserCreatedConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-created-confluence-page */
export type GraphStoreSimplifiedUserCreatedConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-page */
export type GraphStoreSimplifiedUserCreatedConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-created-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserCreatedConfluencePageUnion = ConfluencePage;

/** A simplified connection for the relationship type user-created-confluence-space */
export type GraphStoreSimplifiedUserCreatedConfluenceSpaceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceSpaceConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedConfluenceSpaceEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-space */
export type GraphStoreSimplifiedUserCreatedConfluenceSpaceEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceSpaceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceSpaceUnion>;
};

/** A simplified connection for the relationship type user-created-confluence-space */
export type GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-space */
export type GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseUnion>;
};

/** A union of the possible hydration types for user-created-confluence-space: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedConfluenceSpaceInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-confluence-space: [ConfluenceSpace] */
export type GraphStoreSimplifiedUserCreatedConfluenceSpaceUnion =
    ConfluenceSpace;

/** A simplified connection for the relationship type user-created-confluence-whiteboard */
export type GraphStoreSimplifiedUserCreatedConfluenceWhiteboardConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceWhiteboardConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluenceWhiteboardEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-whiteboard */
export type GraphStoreSimplifiedUserCreatedConfluenceWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceWhiteboardUnion>;
};

/** A simplified connection for the relationship type user-created-confluence-whiteboard */
export type GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-confluence-whiteboard */
export type GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseUnion>;
};

/** A union of the possible hydration types for user-created-confluence-whiteboard: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedConfluenceWhiteboardInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-confluence-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedUserCreatedConfluenceWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type user-created-design */
export type GraphStoreSimplifiedUserCreatedDesignConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserCreatedDesignConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserCreatedDesignEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-created-design */
export type GraphStoreSimplifiedUserCreatedDesignEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedDesignEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:design, ati:cloud:graph:design]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedDesignUnion>;
};

/** A simplified connection for the relationship type user-created-design */
export type GraphStoreSimplifiedUserCreatedDesignInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedDesignInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedDesignInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-design */
export type GraphStoreSimplifiedUserCreatedDesignInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedDesignInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedDesignInverseUnion>;
};

/** A union of the possible hydration types for user-created-design: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserCreatedDesignInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-design: [DevOpsDesign, ExternalDesign] */
export type GraphStoreSimplifiedUserCreatedDesignUnion =
    | DevOpsDesign
    | ExternalDesign;

/** A simplified connection for the relationship type user-created-document */
export type GraphStoreSimplifiedUserCreatedDocumentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserCreatedDocumentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserCreatedDocumentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-created-document */
export type GraphStoreSimplifiedUserCreatedDocumentEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedDocumentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedDocumentUnion>;
};

/** A simplified connection for the relationship type user-created-document */
export type GraphStoreSimplifiedUserCreatedDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedDocumentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedDocumentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-document */
export type GraphStoreSimplifiedUserCreatedDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedDocumentInverseUnion>;
};

/** A union of the possible hydration types for user-created-document: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserCreatedDocumentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedUserCreatedDocumentUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type user-created-issue-comment */
export type GraphStoreSimplifiedUserCreatedIssueCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedIssueCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedIssueCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-issue-comment */
export type GraphStoreSimplifiedUserCreatedIssueCommentEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedIssueCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue-comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedIssueCommentUnion>;
};

/** A simplified connection for the relationship type user-created-issue-comment */
export type GraphStoreSimplifiedUserCreatedIssueCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedIssueCommentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedIssueCommentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-issue-comment */
export type GraphStoreSimplifiedUserCreatedIssueCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedIssueCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedIssueCommentInverseUnion>;
};

/** A union of the possible hydration types for user-created-issue-comment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedIssueCommentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-issue-comment: [JiraPlatformComment, JiraServiceManagementComment] */
export type GraphStoreSimplifiedUserCreatedIssueCommentUnion =
    | JiraPlatformComment
    | JiraServiceManagementComment;

/** A simplified connection for the relationship type user-created-issue-worklog */
export type GraphStoreSimplifiedUserCreatedIssueWorklogConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedIssueWorklogConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedIssueWorklogEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-issue-worklog */
export type GraphStoreSimplifiedUserCreatedIssueWorklogEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedIssueWorklogEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue-worklog]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedIssueWorklogUnion>;
};

/** A simplified connection for the relationship type user-created-issue-worklog */
export type GraphStoreSimplifiedUserCreatedIssueWorklogInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedIssueWorklogInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedIssueWorklogInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-issue-worklog */
export type GraphStoreSimplifiedUserCreatedIssueWorklogInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedIssueWorklogInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedIssueWorklogInverseUnion>;
};

/** A union of the possible hydration types for user-created-issue-worklog: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedIssueWorklogInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-issue-worklog: [JiraWorklog] */
export type GraphStoreSimplifiedUserCreatedIssueWorklogUnion = JiraWorklog;

/** A simplified connection for the relationship type user-created-loom-video-comment */
export type GraphStoreSimplifiedUserCreatedLoomVideoCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedLoomVideoCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-loom-video-comment */
export type GraphStoreSimplifiedUserCreatedLoomVideoCommentEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:loom:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoCommentUnion>;
};

/** A simplified connection for the relationship type user-created-loom-video-comment */
export type GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-loom-video-comment */
export type GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseUnion>;
};

/** A union of the possible hydration types for user-created-loom-video-comment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedLoomVideoCommentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-loom-video-comment: [LoomComment] */
export type GraphStoreSimplifiedUserCreatedLoomVideoCommentUnion = LoomComment;

/** A simplified connection for the relationship type user-created-loom-video */
export type GraphStoreSimplifiedUserCreatedLoomVideoConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserCreatedLoomVideoEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-created-loom-video */
export type GraphStoreSimplifiedUserCreatedLoomVideoEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:video]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoUnion>;
};

/** A simplified connection for the relationship type user-created-loom-video */
export type GraphStoreSimplifiedUserCreatedLoomVideoInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedLoomVideoInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-loom-video */
export type GraphStoreSimplifiedUserCreatedLoomVideoInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedLoomVideoInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedLoomVideoInverseUnion>;
};

/** A union of the possible hydration types for user-created-loom-video: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserCreatedLoomVideoInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-loom-video: [ExternalVideo] */
export type GraphStoreSimplifiedUserCreatedLoomVideoUnion = ExternalVideo;

/** A simplified connection for the relationship type user-created-message */
export type GraphStoreSimplifiedUserCreatedMessageConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserCreatedMessageConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserCreatedMessageEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-created-message */
export type GraphStoreSimplifiedUserCreatedMessageEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedMessageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:message]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedMessageUnion>;
};

/** A simplified connection for the relationship type user-created-message */
export type GraphStoreSimplifiedUserCreatedMessageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedMessageInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedMessageInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-message */
export type GraphStoreSimplifiedUserCreatedMessageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedMessageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedMessageInverseUnion>;
};

/** A union of the possible hydration types for user-created-message: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedMessageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-message: [ExternalMessage] */
export type GraphStoreSimplifiedUserCreatedMessageUnion = ExternalMessage;

/** A simplified connection for the relationship type user-created-release */
export type GraphStoreSimplifiedUserCreatedReleaseConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserCreatedReleaseConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserCreatedReleaseEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-created-release */
export type GraphStoreSimplifiedUserCreatedReleaseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedReleaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedReleaseUnion>;
};

/** A simplified connection for the relationship type user-created-release */
export type GraphStoreSimplifiedUserCreatedReleaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedReleaseInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedReleaseInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-release */
export type GraphStoreSimplifiedUserCreatedReleaseInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedReleaseInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedReleaseInverseUnion>;
};

/** A union of the possible hydration types for user-created-release: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedReleaseInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-created-release: [JiraVersion] */
export type GraphStoreSimplifiedUserCreatedReleaseUnion = JiraVersion;

/** A simplified connection for the relationship type user-created-remote-link */
export type GraphStoreSimplifiedUserCreatedRemoteLinkConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedRemoteLinkConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedRemoteLinkEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-remote-link */
export type GraphStoreSimplifiedUserCreatedRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedRemoteLinkUnion>;
};

/** A simplified connection for the relationship type user-created-remote-link */
export type GraphStoreSimplifiedUserCreatedRemoteLinkInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedRemoteLinkInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedRemoteLinkInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-remote-link */
export type GraphStoreSimplifiedUserCreatedRemoteLinkInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedRemoteLinkInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedRemoteLinkInverseUnion>;
};

/** A union of the possible hydration types for user-created-remote-link: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserCreatedRemoteLinkInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-remote-link: [ExternalRemoteLink] */
export type GraphStoreSimplifiedUserCreatedRemoteLinkUnion = ExternalRemoteLink;

/** A simplified connection for the relationship type user-created-repository */
export type GraphStoreSimplifiedUserCreatedRepositoryConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedRepositoryConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedRepositoryEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-repository */
export type GraphStoreSimplifiedUserCreatedRepositoryEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedRepositoryEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:repository]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedRepositoryUnion>;
};

/** A simplified connection for the relationship type user-created-repository */
export type GraphStoreSimplifiedUserCreatedRepositoryInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserCreatedRepositoryInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserCreatedRepositoryInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-created-repository */
export type GraphStoreSimplifiedUserCreatedRepositoryInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserCreatedRepositoryInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserCreatedRepositoryInverseUnion>;
};

/** A union of the possible hydration types for user-created-repository: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserCreatedRepositoryInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-created-repository: [ExternalRepository] */
export type GraphStoreSimplifiedUserCreatedRepositoryUnion = ExternalRepository;

/** A simplified connection for the relationship type user-favorited-confluence-blogpost */
export type GraphStoreSimplifiedUserFavoritedConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluenceBlogpostEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-blogpost */
export type GraphStoreSimplifiedUserFavoritedConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type user-favorited-confluence-blogpost */
export type GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-blogpost */
export type GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseUnion>;
};

/** A union of the possible hydration types for user-favorited-confluence-blogpost: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserFavoritedConfluenceBlogpostInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-favorited-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedUserFavoritedConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type user-favorited-confluence-database */
export type GraphStoreSimplifiedUserFavoritedConfluenceDatabaseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceDatabaseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluenceDatabaseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-database */
export type GraphStoreSimplifiedUserFavoritedConfluenceDatabaseEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceDatabaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:database]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceDatabaseUnion>;
};

/** A simplified connection for the relationship type user-favorited-confluence-database */
export type GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-database */
export type GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseUnion>;
};

/** A union of the possible hydration types for user-favorited-confluence-database: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserFavoritedConfluenceDatabaseInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-favorited-confluence-database: [ConfluenceDatabase] */
export type GraphStoreSimplifiedUserFavoritedConfluenceDatabaseUnion =
    ConfluenceDatabase;

/** A simplified connection for the relationship type user-favorited-confluence-page */
export type GraphStoreSimplifiedUserFavoritedConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserFavoritedConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-page */
export type GraphStoreSimplifiedUserFavoritedConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-favorited-confluence-page */
export type GraphStoreSimplifiedUserFavoritedConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-page */
export type GraphStoreSimplifiedUserFavoritedConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-favorited-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserFavoritedConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-favorited-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserFavoritedConfluencePageUnion =
    ConfluencePage;

/** A simplified connection for the relationship type user-favorited-confluence-whiteboard */
export type GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-whiteboard */
export type GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardUnion>;
};

/** A simplified connection for the relationship type user-favorited-confluence-whiteboard */
export type GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-favorited-confluence-whiteboard */
export type GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseUnion>;
};

/** A union of the possible hydration types for user-favorited-confluence-whiteboard: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-favorited-confluence-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedUserFavoritedConfluenceWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type user-has-collaborators */
export type GraphStoreSimplifiedUserHasCollaboratorsConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserHasCollaboratorsConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserHasCollaboratorsEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-has-collaborators */
export type GraphStoreSimplifiedUserHasCollaboratorsEdge = {
    __typename?: "GraphStoreSimplifiedUserHasCollaboratorsEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserHasCollaboratorsUnion>;
};

/** A simplified connection for the relationship type user-has-collaborators */
export type GraphStoreSimplifiedUserHasCollaboratorsInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserHasCollaboratorsInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserHasCollaboratorsInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-has-collaborators */
export type GraphStoreSimplifiedUserHasCollaboratorsInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserHasCollaboratorsInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserHasCollaboratorsInverseUnion>;
};

/** A union of the possible hydration types for user-has-collaborators: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserHasCollaboratorsInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-has-collaborators: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserHasCollaboratorsUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type user-has-relevant-project */
export type GraphStoreSimplifiedUserHasRelevantProjectConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedUserHasRelevantProjectConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserHasRelevantProjectEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type user-has-relevant-project */
export type GraphStoreSimplifiedUserHasRelevantProjectEdge = {
    __typename?: "GraphStoreSimplifiedUserHasRelevantProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserHasRelevantProjectUnion>;
};

/** A simplified connection for the relationship type user-has-relevant-project */
export type GraphStoreSimplifiedUserHasRelevantProjectInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedUserHasRelevantProjectInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedUserHasRelevantProjectInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type user-has-relevant-project */
export type GraphStoreSimplifiedUserHasRelevantProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserHasRelevantProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserHasRelevantProjectInverseUnion>;
};

/** A union of the possible hydration types for user-has-relevant-project: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserHasRelevantProjectInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-has-relevant-project: [JiraProject] */
export type GraphStoreSimplifiedUserHasRelevantProjectUnion = JiraProject;

/** A simplified connection for the relationship type user-has-top-project */
export type GraphStoreSimplifiedUserHasTopProjectConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserHasTopProjectConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserHasTopProjectEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-has-top-project */
export type GraphStoreSimplifiedUserHasTopProjectEdge = {
    __typename?: "GraphStoreSimplifiedUserHasTopProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserHasTopProjectUnion>;
};

/** A simplified connection for the relationship type user-has-top-project */
export type GraphStoreSimplifiedUserHasTopProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserHasTopProjectInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserHasTopProjectInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-has-top-project */
export type GraphStoreSimplifiedUserHasTopProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserHasTopProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserHasTopProjectInverseUnion>;
};

/** A union of the possible hydration types for user-has-top-project: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserHasTopProjectInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-has-top-project: [JiraProject] */
export type GraphStoreSimplifiedUserHasTopProjectUnion = JiraProject;

/** A simplified connection for the relationship type user-is-in-team */
export type GraphStoreSimplifiedUserIsInTeamConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserIsInTeamConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserIsInTeamEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-is-in-team */
export type GraphStoreSimplifiedUserIsInTeamEdge = {
    __typename?: "GraphStoreSimplifiedUserIsInTeamEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:team]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserIsInTeamUnion>;
};

/** A simplified connection for the relationship type user-is-in-team */
export type GraphStoreSimplifiedUserIsInTeamInverseConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserIsInTeamInverseConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserIsInTeamInverseEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-is-in-team */
export type GraphStoreSimplifiedUserIsInTeamInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserIsInTeamInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserIsInTeamInverseUnion>;
};

/** A union of the possible hydration types for user-is-in-team: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserIsInTeamInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-is-in-team: [TeamV2] */
export type GraphStoreSimplifiedUserIsInTeamUnion = TeamV2;

/** A simplified connection for the relationship type user-last-updated-design */
export type GraphStoreSimplifiedUserLastUpdatedDesignConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserLastUpdatedDesignConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserLastUpdatedDesignEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-last-updated-design */
export type GraphStoreSimplifiedUserLastUpdatedDesignEdge = {
    __typename?: "GraphStoreSimplifiedUserLastUpdatedDesignEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:design, ati:cloud:graph:design]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserLastUpdatedDesignUnion>;
};

/** A simplified connection for the relationship type user-last-updated-design */
export type GraphStoreSimplifiedUserLastUpdatedDesignInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserLastUpdatedDesignInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserLastUpdatedDesignInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-last-updated-design */
export type GraphStoreSimplifiedUserLastUpdatedDesignInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserLastUpdatedDesignInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserLastUpdatedDesignInverseUnion>;
};

/** A union of the possible hydration types for user-last-updated-design: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserLastUpdatedDesignInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-last-updated-design: [DevOpsDesign, ExternalDesign] */
export type GraphStoreSimplifiedUserLastUpdatedDesignUnion =
    | DevOpsDesign
    | ExternalDesign;

/** A simplified connection for the relationship type user-launched-release */
export type GraphStoreSimplifiedUserLaunchedReleaseConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserLaunchedReleaseConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserLaunchedReleaseEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-launched-release */
export type GraphStoreSimplifiedUserLaunchedReleaseEdge = {
    __typename?: "GraphStoreSimplifiedUserLaunchedReleaseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserLaunchedReleaseUnion>;
};

/** A simplified connection for the relationship type user-launched-release */
export type GraphStoreSimplifiedUserLaunchedReleaseInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserLaunchedReleaseInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserLaunchedReleaseInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-launched-release */
export type GraphStoreSimplifiedUserLaunchedReleaseInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserLaunchedReleaseInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserLaunchedReleaseInverseUnion>;
};

/** A union of the possible hydration types for user-launched-release: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserLaunchedReleaseInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-launched-release: [JiraVersion] */
export type GraphStoreSimplifiedUserLaunchedReleaseUnion = JiraVersion;

/** A simplified connection for the relationship type user-linked-third-party-user */
export type GraphStoreSimplifiedUserLinkedThirdPartyUserConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedUserLinkedThirdPartyUserConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedUserLinkedThirdPartyUserEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type user-linked-third-party-user */
export type GraphStoreSimplifiedUserLinkedThirdPartyUserEdge = {
    __typename?: "GraphStoreSimplifiedUserLinkedThirdPartyUserEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserLinkedThirdPartyUserUnion>;
};

/** A simplified connection for the relationship type user-linked-third-party-user */
export type GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type user-linked-third-party-user */
export type GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserLinkedThirdPartyUserInverseUnion>;
};

/** A union of the possible hydration types for user-linked-third-party-user: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserLinkedThirdPartyUserInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-linked-third-party-user: [ThirdPartyUser] */
export type GraphStoreSimplifiedUserLinkedThirdPartyUserUnion = ThirdPartyUser;

/** A simplified connection for the relationship type user-member-of-conversation */
export type GraphStoreSimplifiedUserMemberOfConversationConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMemberOfConversationConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserMemberOfConversationEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-member-of-conversation */
export type GraphStoreSimplifiedUserMemberOfConversationEdge = {
    __typename?: "GraphStoreSimplifiedUserMemberOfConversationEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:conversation]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMemberOfConversationUnion>;
};

/** A simplified connection for the relationship type user-member-of-conversation */
export type GraphStoreSimplifiedUserMemberOfConversationInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMemberOfConversationInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserMemberOfConversationInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-member-of-conversation */
export type GraphStoreSimplifiedUserMemberOfConversationInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserMemberOfConversationInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMemberOfConversationInverseUnion>;
};

/** A union of the possible hydration types for user-member-of-conversation: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserMemberOfConversationInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-member-of-conversation: [ExternalConversation] */
export type GraphStoreSimplifiedUserMemberOfConversationUnion =
    ExternalConversation;

/** A simplified connection for the relationship type user-mentioned-in-conversation */
export type GraphStoreSimplifiedUserMentionedInConversationConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMentionedInConversationConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserMentionedInConversationEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-mentioned-in-conversation */
export type GraphStoreSimplifiedUserMentionedInConversationEdge = {
    __typename?: "GraphStoreSimplifiedUserMentionedInConversationEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:conversation]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMentionedInConversationUnion>;
};

/** A simplified connection for the relationship type user-mentioned-in-conversation */
export type GraphStoreSimplifiedUserMentionedInConversationInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMentionedInConversationInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserMentionedInConversationInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-mentioned-in-conversation */
export type GraphStoreSimplifiedUserMentionedInConversationInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserMentionedInConversationInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMentionedInConversationInverseUnion>;
};

/** A union of the possible hydration types for user-mentioned-in-conversation: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserMentionedInConversationInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-mentioned-in-conversation: [ExternalConversation] */
export type GraphStoreSimplifiedUserMentionedInConversationUnion =
    ExternalConversation;

/** A simplified connection for the relationship type user-mentioned-in-message */
export type GraphStoreSimplifiedUserMentionedInMessageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMentionedInMessageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserMentionedInMessageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-mentioned-in-message */
export type GraphStoreSimplifiedUserMentionedInMessageEdge = {
    __typename?: "GraphStoreSimplifiedUserMentionedInMessageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:message]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMentionedInMessageUnion>;
};

/** A simplified connection for the relationship type user-mentioned-in-message */
export type GraphStoreSimplifiedUserMentionedInMessageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMentionedInMessageInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserMentionedInMessageInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-mentioned-in-message */
export type GraphStoreSimplifiedUserMentionedInMessageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserMentionedInMessageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMentionedInMessageInverseUnion>;
};

/** A union of the possible hydration types for user-mentioned-in-message: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserMentionedInMessageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-mentioned-in-message: [ExternalMessage] */
export type GraphStoreSimplifiedUserMentionedInMessageUnion = ExternalMessage;

/** A simplified connection for the relationship type user-merged-pull-request */
export type GraphStoreSimplifiedUserMergedPullRequestConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMergedPullRequestConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserMergedPullRequestEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-merged-pull-request */
export type GraphStoreSimplifiedUserMergedPullRequestEdge = {
    __typename?: "GraphStoreSimplifiedUserMergedPullRequestEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMergedPullRequestUnion>;
};

/** A simplified connection for the relationship type user-merged-pull-request */
export type GraphStoreSimplifiedUserMergedPullRequestInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserMergedPullRequestInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserMergedPullRequestInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-merged-pull-request */
export type GraphStoreSimplifiedUserMergedPullRequestInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserMergedPullRequestInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserMergedPullRequestInverseUnion>;
};

/** A union of the possible hydration types for user-merged-pull-request: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserMergedPullRequestInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-merged-pull-request: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedUserMergedPullRequestUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type user-owned-branch */
export type GraphStoreSimplifiedUserOwnedBranchConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserOwnedBranchConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserOwnedBranchEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-owned-branch */
export type GraphStoreSimplifiedUserOwnedBranchEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedBranchEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedBranchUnion>;
};

/** A simplified connection for the relationship type user-owned-branch */
export type GraphStoreSimplifiedUserOwnedBranchInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnedBranchInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnedBranchInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owned-branch */
export type GraphStoreSimplifiedUserOwnedBranchInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedBranchInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedBranchInverseUnion>;
};

/** A union of the possible hydration types for user-owned-branch: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserOwnedBranchInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-owned-branch: [ExternalBranch] */
export type GraphStoreSimplifiedUserOwnedBranchUnion = ExternalBranch;

/** A simplified connection for the relationship type user-owned-calendar-event */
export type GraphStoreSimplifiedUserOwnedCalendarEventConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnedCalendarEventConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnedCalendarEventEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owned-calendar-event */
export type GraphStoreSimplifiedUserOwnedCalendarEventEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedCalendarEventEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:calendar-event]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedCalendarEventUnion>;
};

/** A simplified connection for the relationship type user-owned-calendar-event */
export type GraphStoreSimplifiedUserOwnedCalendarEventInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnedCalendarEventInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnedCalendarEventInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owned-calendar-event */
export type GraphStoreSimplifiedUserOwnedCalendarEventInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedCalendarEventInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedCalendarEventInverseUnion>;
};

/** A union of the possible hydration types for user-owned-calendar-event: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserOwnedCalendarEventInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-owned-calendar-event: [ExternalCalendarEvent] */
export type GraphStoreSimplifiedUserOwnedCalendarEventUnion =
    ExternalCalendarEvent;

/** A simplified connection for the relationship type user-owned-document */
export type GraphStoreSimplifiedUserOwnedDocumentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserOwnedDocumentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserOwnedDocumentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-owned-document */
export type GraphStoreSimplifiedUserOwnedDocumentEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedDocumentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedDocumentUnion>;
};

/** A simplified connection for the relationship type user-owned-document */
export type GraphStoreSimplifiedUserOwnedDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnedDocumentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnedDocumentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owned-document */
export type GraphStoreSimplifiedUserOwnedDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedDocumentInverseUnion>;
};

/** A union of the possible hydration types for user-owned-document: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserOwnedDocumentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-owned-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedUserOwnedDocumentUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type user-owned-remote-link */
export type GraphStoreSimplifiedUserOwnedRemoteLinkConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserOwnedRemoteLinkConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserOwnedRemoteLinkEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-owned-remote-link */
export type GraphStoreSimplifiedUserOwnedRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedRemoteLinkUnion>;
};

/** A simplified connection for the relationship type user-owned-remote-link */
export type GraphStoreSimplifiedUserOwnedRemoteLinkInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnedRemoteLinkInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnedRemoteLinkInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owned-remote-link */
export type GraphStoreSimplifiedUserOwnedRemoteLinkInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedRemoteLinkInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedRemoteLinkInverseUnion>;
};

/** A union of the possible hydration types for user-owned-remote-link: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserOwnedRemoteLinkInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-owned-remote-link: [ExternalRemoteLink] */
export type GraphStoreSimplifiedUserOwnedRemoteLinkUnion = ExternalRemoteLink;

/** A simplified connection for the relationship type user-owned-repository */
export type GraphStoreSimplifiedUserOwnedRepositoryConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserOwnedRepositoryConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserOwnedRepositoryEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-owned-repository */
export type GraphStoreSimplifiedUserOwnedRepositoryEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedRepositoryEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:graph:repository]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedRepositoryUnion>;
};

/** A simplified connection for the relationship type user-owned-repository */
export type GraphStoreSimplifiedUserOwnedRepositoryInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnedRepositoryInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnedRepositoryInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owned-repository */
export type GraphStoreSimplifiedUserOwnedRepositoryInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnedRepositoryInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:third-party-user, ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnedRepositoryInverseUnion>;
};

/** A union of the possible hydration types for user-owned-repository: [ThirdPartyUser, AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserOwnedRepositoryInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-owned-repository: [ExternalRepository] */
export type GraphStoreSimplifiedUserOwnedRepositoryUnion = ExternalRepository;

/** A simplified connection for the relationship type user-owns-component */
export type GraphStoreSimplifiedUserOwnsComponentConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedUserOwnsComponentConnection";
        edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserOwnsComponentEdge>>>;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type user-owns-component */
export type GraphStoreSimplifiedUserOwnsComponentEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnsComponentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:compass:component]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnsComponentUnion>;
};

/** A simplified connection for the relationship type user-owns-component */
export type GraphStoreSimplifiedUserOwnsComponentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedUserOwnsComponentInverseConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedUserOwnsComponentInverseEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type user-owns-component */
export type GraphStoreSimplifiedUserOwnsComponentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnsComponentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnsComponentInverseUnion>;
};

/** A union of the possible hydration types for user-owns-component: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserOwnsComponentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-owns-component: [CompassComponent] */
export type GraphStoreSimplifiedUserOwnsComponentUnion = CompassComponent;

/** A simplified connection for the relationship type user-owns-focus-area */
export type GraphStoreSimplifiedUserOwnsFocusAreaConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserOwnsFocusAreaConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserOwnsFocusAreaEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-owns-focus-area */
export type GraphStoreSimplifiedUserOwnsFocusAreaEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnsFocusAreaEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:mercury:focus-area]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnsFocusAreaUnion>;
};

/** A simplified connection for the relationship type user-owns-focus-area */
export type GraphStoreSimplifiedUserOwnsFocusAreaInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserOwnsFocusAreaInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserOwnsFocusAreaInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-owns-focus-area */
export type GraphStoreSimplifiedUserOwnsFocusAreaInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserOwnsFocusAreaInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserOwnsFocusAreaInverseUnion>;
};

/** A union of the possible hydration types for user-owns-focus-area: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserOwnsFocusAreaInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-owns-focus-area: [MercuryFocusArea] */
export type GraphStoreSimplifiedUserOwnsFocusAreaUnion = MercuryFocusArea;

/** A simplified connection for the relationship type user-reported-incident */
export type GraphStoreSimplifiedUserReportedIncidentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserReportedIncidentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserReportedIncidentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-reported-incident */
export type GraphStoreSimplifiedUserReportedIncidentEdge = {
    __typename?: "GraphStoreSimplifiedUserReportedIncidentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserReportedIncidentUnion>;
};

/** A simplified connection for the relationship type user-reported-incident */
export type GraphStoreSimplifiedUserReportedIncidentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserReportedIncidentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserReportedIncidentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-reported-incident */
export type GraphStoreSimplifiedUserReportedIncidentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserReportedIncidentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserReportedIncidentInverseUnion>;
};

/** A union of the possible hydration types for user-reported-incident: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserReportedIncidentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-reported-incident: [JiraIssue] */
export type GraphStoreSimplifiedUserReportedIncidentUnion = JiraIssue;

/** A simplified connection for the relationship type user-reports-issue */
export type GraphStoreSimplifiedUserReportsIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserReportsIssueConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserReportsIssueEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-reports-issue */
export type GraphStoreSimplifiedUserReportsIssueEdge = {
    __typename?: "GraphStoreSimplifiedUserReportsIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserReportsIssueUnion>;
};

/** A simplified connection for the relationship type user-reports-issue */
export type GraphStoreSimplifiedUserReportsIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserReportsIssueInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserReportsIssueInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-reports-issue */
export type GraphStoreSimplifiedUserReportsIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserReportsIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserReportsIssueInverseUnion>;
};

/** A union of the possible hydration types for user-reports-issue: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserReportsIssueInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-reports-issue: [JiraIssue] */
export type GraphStoreSimplifiedUserReportsIssueUnion = JiraIssue;

/** A simplified connection for the relationship type user-reviews-pr */
export type GraphStoreSimplifiedUserReviewsPrConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserReviewsPrConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserReviewsPrEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-reviews-pr */
export type GraphStoreSimplifiedUserReviewsPrEdge = {
    __typename?: "GraphStoreSimplifiedUserReviewsPrEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserReviewsPrUnion>;
};

/** A simplified connection for the relationship type user-reviews-pr */
export type GraphStoreSimplifiedUserReviewsPrInverseConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserReviewsPrInverseConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserReviewsPrInverseEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-reviews-pr */
export type GraphStoreSimplifiedUserReviewsPrInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserReviewsPrInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserReviewsPrInverseUnion>;
};

/** A union of the possible hydration types for user-reviews-pr: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserReviewsPrInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-reviews-pr: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedUserReviewsPrUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type user-tagged-in-comment */
export type GraphStoreSimplifiedUserTaggedInCommentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserTaggedInCommentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserTaggedInCommentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-tagged-in-comment */
export type GraphStoreSimplifiedUserTaggedInCommentEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInCommentUnion>;
};

/** A simplified connection for the relationship type user-tagged-in-comment */
export type GraphStoreSimplifiedUserTaggedInCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInCommentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserTaggedInCommentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-comment */
export type GraphStoreSimplifiedUserTaggedInCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInCommentInverseUnion>;
};

/** A union of the possible hydration types for user-tagged-in-comment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserTaggedInCommentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-tagged-in-comment: [ConfluenceInlineComment, ConfluenceFooterComment] */
export type GraphStoreSimplifiedUserTaggedInCommentUnion =
    | ConfluenceFooterComment
    | ConfluenceInlineComment;

/** A simplified connection for the relationship type user-tagged-in-confluence-page */
export type GraphStoreSimplifiedUserTaggedInConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserTaggedInConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-confluence-page */
export type GraphStoreSimplifiedUserTaggedInConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-tagged-in-confluence-page */
export type GraphStoreSimplifiedUserTaggedInConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserTaggedInConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-confluence-page */
export type GraphStoreSimplifiedUserTaggedInConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-tagged-in-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserTaggedInConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-tagged-in-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserTaggedInConfluencePageUnion =
    ConfluencePage;

/** A simplified connection for the relationship type user-tagged-in-issue-comment */
export type GraphStoreSimplifiedUserTaggedInIssueCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInIssueCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserTaggedInIssueCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-issue-comment */
export type GraphStoreSimplifiedUserTaggedInIssueCommentEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInIssueCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue-comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInIssueCommentUnion>;
};

/** A simplified connection for the relationship type user-tagged-in-issue-comment */
export type GraphStoreSimplifiedUserTaggedInIssueCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInIssueCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserTaggedInIssueCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-issue-comment */
export type GraphStoreSimplifiedUserTaggedInIssueCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInIssueCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInIssueCommentInverseUnion>;
};

/** A union of the possible hydration types for user-tagged-in-issue-comment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserTaggedInIssueCommentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-tagged-in-issue-comment: [JiraPlatformComment, JiraServiceManagementComment] */
export type GraphStoreSimplifiedUserTaggedInIssueCommentUnion =
    | JiraPlatformComment
    | JiraServiceManagementComment;

/** A simplified connection for the relationship type user-tagged-in-loom-video-comment */
export type GraphStoreSimplifiedUserTaggedInLoomVideoCommentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInLoomVideoCommentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserTaggedInLoomVideoCommentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-loom-video-comment */
export type GraphStoreSimplifiedUserTaggedInLoomVideoCommentEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInLoomVideoCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:loom:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInLoomVideoCommentUnion>;
};

/** A simplified connection for the relationship type user-tagged-in-loom-video-comment */
export type GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-tagged-in-loom-video-comment */
export type GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseUnion>;
};

/** A union of the possible hydration types for user-tagged-in-loom-video-comment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserTaggedInLoomVideoCommentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-tagged-in-loom-video-comment: [LoomComment] */
export type GraphStoreSimplifiedUserTaggedInLoomVideoCommentUnion = LoomComment;

/** A simplified connection for the relationship type user-triggered-deployment */
export type GraphStoreSimplifiedUserTriggeredDeploymentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTriggeredDeploymentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserTriggeredDeploymentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-triggered-deployment */
export type GraphStoreSimplifiedUserTriggeredDeploymentEdge = {
    __typename?: "GraphStoreSimplifiedUserTriggeredDeploymentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTriggeredDeploymentUnion>;
};

/** A simplified connection for the relationship type user-triggered-deployment */
export type GraphStoreSimplifiedUserTriggeredDeploymentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserTriggeredDeploymentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserTriggeredDeploymentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-triggered-deployment */
export type GraphStoreSimplifiedUserTriggeredDeploymentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserTriggeredDeploymentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserTriggeredDeploymentInverseUnion>;
};

/** A union of the possible hydration types for user-triggered-deployment: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserTriggeredDeploymentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-triggered-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedUserTriggeredDeploymentUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A simplified connection for the relationship type user-updated-confluence-blogpost */
export type GraphStoreSimplifiedUserUpdatedConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserUpdatedConfluenceBlogpostEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-blogpost */
export type GraphStoreSimplifiedUserUpdatedConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type user-updated-confluence-blogpost */
export type GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-blogpost */
export type GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseUnion>;
};

/** A union of the possible hydration types for user-updated-confluence-blogpost: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserUpdatedConfluenceBlogpostInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-updated-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedUserUpdatedConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type user-updated-confluence-page */
export type GraphStoreSimplifiedUserUpdatedConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserUpdatedConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-page */
export type GraphStoreSimplifiedUserUpdatedConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-updated-confluence-page */
export type GraphStoreSimplifiedUserUpdatedConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserUpdatedConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-page */
export type GraphStoreSimplifiedUserUpdatedConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-updated-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserUpdatedConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-updated-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserUpdatedConfluencePageUnion = ConfluencePage;

/** A simplified connection for the relationship type user-updated-confluence-space */
export type GraphStoreSimplifiedUserUpdatedConfluenceSpaceConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceSpaceConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserUpdatedConfluenceSpaceEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-space */
export type GraphStoreSimplifiedUserUpdatedConfluenceSpaceEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceSpaceEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:space]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceSpaceUnion>;
};

/** A simplified connection for the relationship type user-updated-confluence-space */
export type GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-space */
export type GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseUnion>;
};

/** A union of the possible hydration types for user-updated-confluence-space: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserUpdatedConfluenceSpaceInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-updated-confluence-space: [ConfluenceSpace] */
export type GraphStoreSimplifiedUserUpdatedConfluenceSpaceUnion =
    ConfluenceSpace;

/** A simplified connection for the relationship type user-updated-confluence-whiteboard */
export type GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-whiteboard */
export type GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardUnion>;
};

/** A simplified connection for the relationship type user-updated-confluence-whiteboard */
export type GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-confluence-whiteboard */
export type GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseUnion>;
};

/** A union of the possible hydration types for user-updated-confluence-whiteboard: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-updated-confluence-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedUserUpdatedConfluenceWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type user-updated-graph-document */
export type GraphStoreSimplifiedUserUpdatedGraphDocumentConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedGraphDocumentConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserUpdatedGraphDocumentEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-graph-document */
export type GraphStoreSimplifiedUserUpdatedGraphDocumentEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedGraphDocumentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:document, ati:cloud:graph:document, ati:third-party:google.google-drive:document, ati:third-party:notion.notion:document]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedGraphDocumentUnion>;
};

/** A simplified connection for the relationship type user-updated-graph-document */
export type GraphStoreSimplifiedUserUpdatedGraphDocumentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedGraphDocumentInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserUpdatedGraphDocumentInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-graph-document */
export type GraphStoreSimplifiedUserUpdatedGraphDocumentInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedGraphDocumentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user, ati:cloud:identity:third-party-user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedGraphDocumentInverseUnion>;
};

/** A union of the possible hydration types for user-updated-graph-document: [AtlassianAccountUser, CustomerUser, AppUser, ThirdPartyUser] */
export type GraphStoreSimplifiedUserUpdatedGraphDocumentInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | ThirdPartyUser;

/** A union of the possible hydration types for user-updated-graph-document: [DevOpsDocument, ExternalDocument] */
export type GraphStoreSimplifiedUserUpdatedGraphDocumentUnion =
    | DevOpsDocument
    | ExternalDocument;

/** A simplified connection for the relationship type user-updated-issue */
export type GraphStoreSimplifiedUserUpdatedIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserUpdatedIssueConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserUpdatedIssueEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-updated-issue */
export type GraphStoreSimplifiedUserUpdatedIssueEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedIssueUnion>;
};

/** A simplified connection for the relationship type user-updated-issue */
export type GraphStoreSimplifiedUserUpdatedIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedIssueInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserUpdatedIssueInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-issue */
export type GraphStoreSimplifiedUserUpdatedIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedIssueInverseUnion>;
};

/** A union of the possible hydration types for user-updated-issue: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserUpdatedIssueInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A simplified connection for the relationship type user-updated-issue-status */
export type GraphStoreSimplifiedUserUpdatedIssueStatusInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserUpdatedIssueStatusInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserUpdatedIssueStatusInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-updated-issue-status */
export type GraphStoreSimplifiedUserUpdatedIssueStatusInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserUpdatedIssueStatusInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserUpdatedIssueStatusInverseUnion>;
};

/** A union of the possible hydration types for user-updated-issue-status: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserUpdatedIssueStatusInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-updated-issue: [JiraIssue] */
export type GraphStoreSimplifiedUserUpdatedIssueUnion = JiraIssue;

/** A simplified connection for the relationship type user-viewed-atlas-goal */
export type GraphStoreSimplifiedUserViewedAtlasGoalConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserViewedAtlasGoalConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserViewedAtlasGoalEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-viewed-atlas-goal */
export type GraphStoreSimplifiedUserViewedAtlasGoalEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedAtlasGoalEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedAtlasGoalUnion>;
};

/** A simplified connection for the relationship type user-viewed-atlas-goal */
export type GraphStoreSimplifiedUserViewedAtlasGoalInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedAtlasGoalInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedAtlasGoalInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-atlas-goal */
export type GraphStoreSimplifiedUserViewedAtlasGoalInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedAtlasGoalInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedAtlasGoalInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-atlas-goal: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedAtlasGoalInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-atlas-goal: [TownsquareGoal] */
export type GraphStoreSimplifiedUserViewedAtlasGoalUnion = TownsquareGoal;

/** A simplified connection for the relationship type user-viewed-atlas-project */
export type GraphStoreSimplifiedUserViewedAtlasProjectConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedAtlasProjectConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedAtlasProjectEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-atlas-project */
export type GraphStoreSimplifiedUserViewedAtlasProjectEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedAtlasProjectEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedAtlasProjectUnion>;
};

/** A simplified connection for the relationship type user-viewed-atlas-project */
export type GraphStoreSimplifiedUserViewedAtlasProjectInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedAtlasProjectInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedAtlasProjectInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-atlas-project */
export type GraphStoreSimplifiedUserViewedAtlasProjectInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedAtlasProjectInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedAtlasProjectInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-atlas-project: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedAtlasProjectInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-atlas-project: [TownsquareProject] */
export type GraphStoreSimplifiedUserViewedAtlasProjectUnion = TownsquareProject;

/** A simplified connection for the relationship type user-viewed-confluence-blogpost */
export type GraphStoreSimplifiedUserViewedConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedConfluenceBlogpostEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-confluence-blogpost */
export type GraphStoreSimplifiedUserViewedConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type user-viewed-confluence-blogpost */
export type GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-confluence-blogpost */
export type GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-confluence-blogpost: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedConfluenceBlogpostInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedUserViewedConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type user-viewed-confluence-page */
export type GraphStoreSimplifiedUserViewedConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-confluence-page */
export type GraphStoreSimplifiedUserViewedConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-viewed-confluence-page */
export type GraphStoreSimplifiedUserViewedConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserViewedConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-confluence-page */
export type GraphStoreSimplifiedUserViewedConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserViewedConfluencePageUnion = ConfluencePage;

/** A simplified connection for the relationship type user-viewed-goal-update */
export type GraphStoreSimplifiedUserViewedGoalUpdateConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserViewedGoalUpdateConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserViewedGoalUpdateEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-viewed-goal-update */
export type GraphStoreSimplifiedUserViewedGoalUpdateEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedGoalUpdateEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:goal-update]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedGoalUpdateUnion>;
};

/** A simplified connection for the relationship type user-viewed-goal-update */
export type GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-goal-update */
export type GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedGoalUpdateInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-goal-update: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedGoalUpdateInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-goal-update: [TownsquareGoalUpdate] */
export type GraphStoreSimplifiedUserViewedGoalUpdateUnion =
    TownsquareGoalUpdate;

/** A simplified connection for the relationship type user-viewed-jira-issue */
export type GraphStoreSimplifiedUserViewedJiraIssueConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserViewedJiraIssueConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserViewedJiraIssueEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-viewed-jira-issue */
export type GraphStoreSimplifiedUserViewedJiraIssueEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedJiraIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedJiraIssueUnion>;
};

/** A simplified connection for the relationship type user-viewed-jira-issue */
export type GraphStoreSimplifiedUserViewedJiraIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedJiraIssueInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedJiraIssueInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-jira-issue */
export type GraphStoreSimplifiedUserViewedJiraIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedJiraIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedJiraIssueInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-jira-issue: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedJiraIssueInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-jira-issue: [JiraIssue] */
export type GraphStoreSimplifiedUserViewedJiraIssueUnion = JiraIssue;

/** A simplified connection for the relationship type user-viewed-loom-video */
export type GraphStoreSimplifiedUserViewedLoomVideoConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedUserViewedLoomVideoConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedUserViewedLoomVideoEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type user-viewed-loom-video */
export type GraphStoreSimplifiedUserViewedLoomVideoEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedLoomVideoEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:loom:video]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedLoomVideoUnion>;
};

/** A simplified connection for the relationship type user-viewed-loom-video */
export type GraphStoreSimplifiedUserViewedLoomVideoInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedLoomVideoInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedLoomVideoInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-loom-video */
export type GraphStoreSimplifiedUserViewedLoomVideoInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedLoomVideoInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedLoomVideoInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-loom-video: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedLoomVideoInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-loom-video: [LoomVideo] */
export type GraphStoreSimplifiedUserViewedLoomVideoUnion = LoomVideo;

/** A simplified connection for the relationship type user-viewed-project-update */
export type GraphStoreSimplifiedUserViewedProjectUpdateConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedProjectUpdateConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedProjectUpdateEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-project-update */
export type GraphStoreSimplifiedUserViewedProjectUpdateEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedProjectUpdateEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:townsquare:project-update]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedProjectUpdateUnion>;
};

/** A simplified connection for the relationship type user-viewed-project-update */
export type GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-viewed-project-update */
export type GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserViewedProjectUpdateInverseUnion>;
};

/** A union of the possible hydration types for user-viewed-project-update: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserViewedProjectUpdateInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-viewed-project-update: [TownsquareProjectUpdate] */
export type GraphStoreSimplifiedUserViewedProjectUpdateUnion =
    TownsquareProjectUpdate;

/** A simplified connection for the relationship type user-watches-confluence-blogpost */
export type GraphStoreSimplifiedUserWatchesConfluenceBlogpostConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserWatchesConfluenceBlogpostConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserWatchesConfluenceBlogpostEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-watches-confluence-blogpost */
export type GraphStoreSimplifiedUserWatchesConfluenceBlogpostEdge = {
    __typename?: "GraphStoreSimplifiedUserWatchesConfluenceBlogpostEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:blogpost]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceBlogpostUnion>;
};

/** A simplified connection for the relationship type user-watches-confluence-blogpost */
export type GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-watches-confluence-blogpost */
export type GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseUnion>;
};

/** A union of the possible hydration types for user-watches-confluence-blogpost: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserWatchesConfluenceBlogpostInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-watches-confluence-blogpost: [ConfluenceBlogPost] */
export type GraphStoreSimplifiedUserWatchesConfluenceBlogpostUnion =
    ConfluenceBlogPost;

/** A simplified connection for the relationship type user-watches-confluence-page */
export type GraphStoreSimplifiedUserWatchesConfluencePageConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserWatchesConfluencePageConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedUserWatchesConfluencePageEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-watches-confluence-page */
export type GraphStoreSimplifiedUserWatchesConfluencePageEdge = {
    __typename?: "GraphStoreSimplifiedUserWatchesConfluencePageEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:page]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserWatchesConfluencePageUnion>;
};

/** A simplified connection for the relationship type user-watches-confluence-page */
export type GraphStoreSimplifiedUserWatchesConfluencePageInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserWatchesConfluencePageInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserWatchesConfluencePageInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-watches-confluence-page */
export type GraphStoreSimplifiedUserWatchesConfluencePageInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserWatchesConfluencePageInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserWatchesConfluencePageInverseUnion>;
};

/** A union of the possible hydration types for user-watches-confluence-page: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserWatchesConfluencePageInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-watches-confluence-page: [ConfluencePage] */
export type GraphStoreSimplifiedUserWatchesConfluencePageUnion = ConfluencePage;

/** A simplified connection for the relationship type user-watches-confluence-whiteboard */
export type GraphStoreSimplifiedUserWatchesConfluenceWhiteboardConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserWatchesConfluenceWhiteboardConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserWatchesConfluenceWhiteboardEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-watches-confluence-whiteboard */
export type GraphStoreSimplifiedUserWatchesConfluenceWhiteboardEdge = {
    __typename?: "GraphStoreSimplifiedUserWatchesConfluenceWhiteboardEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:confluence:whiteboard]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceWhiteboardUnion>;
};

/** A simplified connection for the relationship type user-watches-confluence-whiteboard */
export type GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseConnection";
        edges?: Maybe<
            Array<
                Maybe<GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseEdge>
            >
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type user-watches-confluence-whiteboard */
export type GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseEdge = {
    __typename?: "GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:identity:user]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseUnion>;
};

/** A union of the possible hydration types for user-watches-confluence-whiteboard: [AtlassianAccountUser, CustomerUser, AppUser] */
export type GraphStoreSimplifiedUserWatchesConfluenceWhiteboardInverseUnion =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser;

/** A union of the possible hydration types for user-watches-confluence-whiteboard: [ConfluenceWhiteboard] */
export type GraphStoreSimplifiedUserWatchesConfluenceWhiteboardUnion =
    ConfluenceWhiteboard;

/** A simplified connection for the relationship type version-associated-branch */
export type GraphStoreSimplifiedVersionAssociatedBranchConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedBranchConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedVersionAssociatedBranchEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-branch */
export type GraphStoreSimplifiedVersionAssociatedBranchEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedBranchEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:branch, ati:cloud:graph:branch]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedBranchUnion>;
};

/** A simplified connection for the relationship type version-associated-branch */
export type GraphStoreSimplifiedVersionAssociatedBranchInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedBranchInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedBranchInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-branch */
export type GraphStoreSimplifiedVersionAssociatedBranchInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedBranchInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedBranchInverseUnion>;
};

/** A union of the possible hydration types for version-associated-branch: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedBranchInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-branch: [ExternalBranch] */
export type GraphStoreSimplifiedVersionAssociatedBranchUnion = ExternalBranch;

/** A simplified connection for the relationship type version-associated-build */
export type GraphStoreSimplifiedVersionAssociatedBuildConnection = HasPageInfo &
    HasTotal & {
        __typename?: "GraphStoreSimplifiedVersionAssociatedBuildConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedVersionAssociatedBuildEdge>>
        >;
        /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
        isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
        pageInfo: PageInfo;
        /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** A simplified edge for the relationship type version-associated-build */
export type GraphStoreSimplifiedVersionAssociatedBuildEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedBuildEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:build, ati:cloud:graph:build]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedBuildUnion>;
};

/** A simplified connection for the relationship type version-associated-build */
export type GraphStoreSimplifiedVersionAssociatedBuildInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedBuildInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedBuildInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-build */
export type GraphStoreSimplifiedVersionAssociatedBuildInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedBuildInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedBuildInverseUnion>;
};

/** A union of the possible hydration types for version-associated-build: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedBuildInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-build: [ExternalBuildInfo] */
export type GraphStoreSimplifiedVersionAssociatedBuildUnion = ExternalBuildInfo;

/** A simplified connection for the relationship type version-associated-commit */
export type GraphStoreSimplifiedVersionAssociatedCommitConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedCommitConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedVersionAssociatedCommitEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-commit */
export type GraphStoreSimplifiedVersionAssociatedCommitEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedCommitEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:commit, ati:cloud:graph:commit]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedCommitUnion>;
};

/** A simplified connection for the relationship type version-associated-commit */
export type GraphStoreSimplifiedVersionAssociatedCommitInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedCommitInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedCommitInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-commit */
export type GraphStoreSimplifiedVersionAssociatedCommitInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedCommitInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedCommitInverseUnion>;
};

/** A union of the possible hydration types for version-associated-commit: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedCommitInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-commit: [ExternalCommit] */
export type GraphStoreSimplifiedVersionAssociatedCommitUnion = ExternalCommit;

/** A simplified connection for the relationship type version-associated-deployment */
export type GraphStoreSimplifiedVersionAssociatedDeploymentConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedDeploymentConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedDeploymentEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-deployment */
export type GraphStoreSimplifiedVersionAssociatedDeploymentEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedDeploymentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:deployment, ati:cloud:graph:deployment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedDeploymentUnion>;
};

/** A simplified connection for the relationship type version-associated-deployment */
export type GraphStoreSimplifiedVersionAssociatedDeploymentInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedDeploymentInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedDeploymentInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-deployment */
export type GraphStoreSimplifiedVersionAssociatedDeploymentInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedDeploymentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedDeploymentInverseUnion>;
};

/** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedDeploymentInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary, ExternalDeployment] */
export type GraphStoreSimplifiedVersionAssociatedDeploymentUnion =
    | DeploymentSummary
    | ExternalDeployment;

/** A simplified connection for the relationship type version-associated-design */
export type GraphStoreSimplifiedVersionAssociatedDesignConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedDesignConnection";
            edges?: Maybe<
                Array<Maybe<GraphStoreSimplifiedVersionAssociatedDesignEdge>>
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-design */
export type GraphStoreSimplifiedVersionAssociatedDesignEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedDesignEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:design, ati:cloud:graph:design]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedDesignUnion>;
};

/** A simplified connection for the relationship type version-associated-design */
export type GraphStoreSimplifiedVersionAssociatedDesignInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedDesignInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedDesignInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-design */
export type GraphStoreSimplifiedVersionAssociatedDesignInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedDesignInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedDesignInverseUnion>;
};

/** A union of the possible hydration types for version-associated-design: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedDesignInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-design: [DevOpsDesign, ExternalDesign] */
export type GraphStoreSimplifiedVersionAssociatedDesignUnion =
    | DevOpsDesign
    | ExternalDesign;

/** A simplified connection for the relationship type version-associated-feature-flag */
export type GraphStoreSimplifiedVersionAssociatedFeatureFlagConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedFeatureFlagConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedFeatureFlagEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-feature-flag */
export type GraphStoreSimplifiedVersionAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedFeatureFlagEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedFeatureFlagUnion>;
};

/** A simplified connection for the relationship type version-associated-feature-flag */
export type GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-feature-flag */
export type GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseUnion>;
};

/** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedFeatureFlagInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreSimplifiedVersionAssociatedFeatureFlagUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A simplified connection for the relationship type version-associated-issue */
export type GraphStoreSimplifiedVersionAssociatedIssueConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedVersionAssociatedIssueConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedVersionAssociatedIssueEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type version-associated-issue */
export type GraphStoreSimplifiedVersionAssociatedIssueEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedIssueUnion>;
};

/** A simplified connection for the relationship type version-associated-issue */
export type GraphStoreSimplifiedVersionAssociatedIssueInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedVersionAssociatedIssueInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedVersionAssociatedIssueInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type version-associated-issue */
export type GraphStoreSimplifiedVersionAssociatedIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedIssueInverseUnion>;
};

/** A union of the possible hydration types for version-associated-issue: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedIssueInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-issue: [JiraIssue] */
export type GraphStoreSimplifiedVersionAssociatedIssueUnion = JiraIssue;

/** A simplified connection for the relationship type version-associated-pull-request */
export type GraphStoreSimplifiedVersionAssociatedPullRequestConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedPullRequestConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedPullRequestEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-pull-request */
export type GraphStoreSimplifiedVersionAssociatedPullRequestEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedPullRequestEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:pull-request, ati:cloud:graph:pull-request]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedPullRequestUnion>;
};

/** A simplified connection for the relationship type version-associated-pull-request */
export type GraphStoreSimplifiedVersionAssociatedPullRequestInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedPullRequestInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedPullRequestInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-pull-request */
export type GraphStoreSimplifiedVersionAssociatedPullRequestInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedPullRequestInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedPullRequestInverseUnion>;
};

/** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedPullRequestInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails, ExternalPullRequest] */
export type GraphStoreSimplifiedVersionAssociatedPullRequestUnion =
    | DevOpsPullRequestDetails
    | ExternalPullRequest;

/** A simplified connection for the relationship type version-associated-remote-link */
export type GraphStoreSimplifiedVersionAssociatedRemoteLinkConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedRemoteLinkConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedRemoteLinkEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-remote-link */
export type GraphStoreSimplifiedVersionAssociatedRemoteLinkEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedRemoteLinkEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:remote-link, ati:cloud:graph:remote-link]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedRemoteLinkUnion>;
};

/** A simplified connection for the relationship type version-associated-remote-link */
export type GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-associated-remote-link */
export type GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseUnion>;
};

/** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */
export type GraphStoreSimplifiedVersionAssociatedRemoteLinkInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-associated-remote-link: [ExternalRemoteLink] */
export type GraphStoreSimplifiedVersionAssociatedRemoteLinkUnion =
    ExternalRemoteLink;

/** A simplified connection for the relationship type version-user-associated-feature-flag */
export type GraphStoreSimplifiedVersionUserAssociatedFeatureFlagConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionUserAssociatedFeatureFlagConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionUserAssociatedFeatureFlagEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-user-associated-feature-flag */
export type GraphStoreSimplifiedVersionUserAssociatedFeatureFlagEdge = {
    __typename?: "GraphStoreSimplifiedVersionUserAssociatedFeatureFlagEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:feature-flag, ati:cloud:graph:feature-flag]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionUserAssociatedFeatureFlagUnion>;
};

/** A simplified connection for the relationship type version-user-associated-feature-flag */
export type GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type version-user-associated-feature-flag */
export type GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseEdge = {
    __typename?: "GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:version]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseUnion>;
};

/** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */
export type GraphStoreSimplifiedVersionUserAssociatedFeatureFlagInverseUnion =
    JiraVersion;

/** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag, ExternalFeatureFlag] */
export type GraphStoreSimplifiedVersionUserAssociatedFeatureFlagUnion =
    | DevOpsFeatureFlag
    | ExternalFeatureFlag;

/** A simplified connection for the relationship type video-has-comment */
export type GraphStoreSimplifiedVideoHasCommentConnection = HasPageInfo & {
    __typename?: "GraphStoreSimplifiedVideoHasCommentConnection";
    edges?: Maybe<Array<Maybe<GraphStoreSimplifiedVideoHasCommentEdge>>>;
    pageInfo: PageInfo;
};

/** A simplified edge for the relationship type video-has-comment */
export type GraphStoreSimplifiedVideoHasCommentEdge = {
    __typename?: "GraphStoreSimplifiedVideoHasCommentEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:loom:comment]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVideoHasCommentUnion>;
};

/** A simplified connection for the relationship type video-has-comment */
export type GraphStoreSimplifiedVideoHasCommentInverseConnection =
    HasPageInfo & {
        __typename?: "GraphStoreSimplifiedVideoHasCommentInverseConnection";
        edges?: Maybe<
            Array<Maybe<GraphStoreSimplifiedVideoHasCommentInverseEdge>>
        >;
        pageInfo: PageInfo;
    };

/** A simplified edge for the relationship type video-has-comment */
export type GraphStoreSimplifiedVideoHasCommentInverseEdge = {
    __typename?: "GraphStoreSimplifiedVideoHasCommentInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:loom:video]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVideoHasCommentInverseUnion>;
};

/** A union of the possible hydration types for video-has-comment: [LoomVideo] */
export type GraphStoreSimplifiedVideoHasCommentInverseUnion = LoomVideo;

/** A union of the possible hydration types for video-has-comment: [LoomComment] */
export type GraphStoreSimplifiedVideoHasCommentUnion = LoomComment;

/** A simplified connection for the relationship type vulnerability-associated-issue */
export type GraphStoreSimplifiedVulnerabilityAssociatedIssueConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVulnerabilityAssociatedIssueConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVulnerabilityAssociatedIssueEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type vulnerability-associated-issue */
export type GraphStoreSimplifiedVulnerabilityAssociatedIssueEdge = {
    __typename?: "GraphStoreSimplifiedVulnerabilityAssociatedIssueEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:issue]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVulnerabilityAssociatedIssueUnion>;
};

/** A simplified connection for the relationship type vulnerability-associated-issue */
export type GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseConnection =
    HasPageInfo &
        HasTotal & {
            __typename?: "GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseConnection";
            edges?: Maybe<
                Array<
                    Maybe<GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseEdge>
                >
            >;
            /** True if totalCount is an exact count of the relationships, false if it is an approximation. */
            isExactCount?: Maybe<Scalars["Boolean"]["output"]>;
            pageInfo: PageInfo;
            /** Only defined on indexed types. Only exact if isExactCount is true, otherwise approximate. */
            totalCount?: Maybe<Scalars["Int"]["output"]>;
        };

/** A simplified edge for the relationship type vulnerability-associated-issue */
export type GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseEdge = {
    __typename?: "GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseEdge";
    /** The date and time the relationship was created */
    createdAt: Scalars["DateTime"]["output"];
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** An ARI of the type(s) [ati:cloud:jira:vulnerability, ati:cloud:graph:vulnerability]. */
    id: Scalars["ID"]["output"];
    /** The date and time the relationship was last updated */
    lastUpdated: Scalars["DateTime"]["output"];
    /** The node field, hydrated by a call to another service. If there are issues with this hydration it's likely not Ari Graph Store's fault */
    node?: Maybe<GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseUnion>;
};

/** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails, ExternalVulnerability] */
export type GraphStoreSimplifiedVulnerabilityAssociatedIssueInverseUnion =
    | DevOpsSecurityVulnerabilityDetails
    | ExternalVulnerability;

/** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */
export type GraphStoreSimplifiedVulnerabilityAssociatedIssueUnion = JiraIssue;

export type GraphStoreSortInput = {
    /** The direction of the sort. For enums the order is determined by the order of enum values in the protobuf schema. */
    direction: SortDirection;
    /** The priority of the field. Higher keys are used to resolve ties when lower keys have the same value. If there is only one sorting option, the priority value becomes irrelevant. */
    priority: Scalars["Int"]["input"];
};

export type GraphStoreSpaceAssociatedWithProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreSprintAssociatedBuildBuildState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreSprintAssociatedBuildBuildStateFilterInput = {
    is?: InputMaybe<Array<GraphStoreSprintAssociatedBuildBuildState>>;
    isNot?: InputMaybe<Array<GraphStoreSprintAssociatedBuildBuildState>>;
};

export type GraphStoreSprintAssociatedBuildConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_state?: InputMaybe<GraphStoreSprintAssociatedBuildBuildStateFilterInput>;
    to_testInfo?: InputMaybe<GraphStoreSprintAssociatedBuildTestInfoFilterInput>;
};

/** Conditional selection for filter field of sprint-associated-build relationship queries */
export type GraphStoreSprintAssociatedBuildFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedBuildConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedBuildConditionalFilterInput>>
    >;
};

export type GraphStoreSprintAssociatedBuildSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_state?: InputMaybe<GraphStoreSortInput>;
    to_testInfo?: InputMaybe<GraphStoreSprintAssociatedBuildTestInfoSortInput>;
};

export type GraphStoreSprintAssociatedBuildTestInfoFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedBuildTestInfoFilterInput>>
    >;
    numberFailed?: InputMaybe<GraphStoreLongFilterInput>;
    numberPassed?: InputMaybe<GraphStoreLongFilterInput>;
    numberSkipped?: InputMaybe<GraphStoreLongFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedBuildTestInfoFilterInput>>
    >;
    totalNumber?: InputMaybe<GraphStoreLongFilterInput>;
};

export type GraphStoreSprintAssociatedBuildTestInfoSortInput = {
    numberFailed?: InputMaybe<GraphStoreSortInput>;
    numberPassed?: InputMaybe<GraphStoreSortInput>;
    numberSkipped?: InputMaybe<GraphStoreSortInput>;
    totalNumber?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintAssociatedDeploymentAuthorFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedDeploymentAuthorFilterInput>>
    >;
    authorAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedDeploymentAuthorFilterInput>>
    >;
};

export type GraphStoreSprintAssociatedDeploymentAuthorSortInput = {
    authorAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintAssociatedDeploymentConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_author?: InputMaybe<GraphStoreSprintAssociatedDeploymentAuthorFilterInput>;
    to_environmentType?: InputMaybe<GraphStoreSprintAssociatedDeploymentEnvironmentTypeFilterInput>;
    to_state?: InputMaybe<GraphStoreSprintAssociatedDeploymentDeploymentStateFilterInput>;
};

export enum GraphStoreSprintAssociatedDeploymentDeploymentState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    NotSet = "NOT_SET",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

export type GraphStoreSprintAssociatedDeploymentDeploymentStateFilterInput = {
    is?: InputMaybe<Array<GraphStoreSprintAssociatedDeploymentDeploymentState>>;
    isNot?: InputMaybe<
        Array<GraphStoreSprintAssociatedDeploymentDeploymentState>
    >;
};

export enum GraphStoreSprintAssociatedDeploymentEnvironmentType {
    Development = "DEVELOPMENT",
    NotSet = "NOT_SET",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type GraphStoreSprintAssociatedDeploymentEnvironmentTypeFilterInput = {
    is?: InputMaybe<Array<GraphStoreSprintAssociatedDeploymentEnvironmentType>>;
    isNot?: InputMaybe<
        Array<GraphStoreSprintAssociatedDeploymentEnvironmentType>
    >;
};

/** Conditional selection for filter field of sprint-associated-deployment relationship queries */
export type GraphStoreSprintAssociatedDeploymentFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreSprintAssociatedDeploymentConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreSprintAssociatedDeploymentConditionalFilterInput>
        >
    >;
};

export type GraphStoreSprintAssociatedDeploymentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_author?: InputMaybe<GraphStoreSprintAssociatedDeploymentAuthorSortInput>;
    to_environmentType?: InputMaybe<GraphStoreSortInput>;
    to_state?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintAssociatedPrAuthorFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedPrAuthorFilterInput>>
    >;
    authorAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedPrAuthorFilterInput>>
    >;
};

export type GraphStoreSprintAssociatedPrAuthorSortInput = {
    authorAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintAssociatedPrConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_author?: InputMaybe<GraphStoreSprintAssociatedPrAuthorFilterInput>;
    to_reviewers?: InputMaybe<GraphStoreSprintAssociatedPrReviewerFilterInput>;
    to_status?: InputMaybe<GraphStoreSprintAssociatedPrPullRequestStatusFilterInput>;
    to_taskCount?: InputMaybe<GraphStoreFloatFilterInput>;
};

/** Conditional selection for filter field of sprint-associated-pr relationship queries */
export type GraphStoreSprintAssociatedPrFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedPrConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedPrConditionalFilterInput>>
    >;
};

export enum GraphStoreSprintAssociatedPrPullRequestStatus {
    Declined = "DECLINED",
    Merged = "MERGED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreSprintAssociatedPrPullRequestStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreSprintAssociatedPrPullRequestStatus>>;
    isNot?: InputMaybe<Array<GraphStoreSprintAssociatedPrPullRequestStatus>>;
};

export type GraphStoreSprintAssociatedPrReviewerFilterInput = {
    /** Logical AND of all children of this field */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedPrReviewerFilterInput>>
    >;
    approvalStatus?: InputMaybe<GraphStoreSprintAssociatedPrReviewerReviewerStatusFilterInput>;
    /** Logical OR of all children of this field */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintAssociatedPrReviewerFilterInput>>
    >;
    reviewerAri?: InputMaybe<GraphStoreAriFilterInput>;
};

export enum GraphStoreSprintAssociatedPrReviewerReviewerStatus {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    NotSet = "NOT_SET",
    Unapproved = "UNAPPROVED"
}

export type GraphStoreSprintAssociatedPrReviewerReviewerStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreSprintAssociatedPrReviewerReviewerStatus>>;
    isNot?: InputMaybe<
        Array<GraphStoreSprintAssociatedPrReviewerReviewerStatus>
    >;
};

export type GraphStoreSprintAssociatedPrReviewerSortInput = {
    approvalStatus?: InputMaybe<GraphStoreSortInput>;
    reviewerAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintAssociatedPrSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_creatorAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueAri?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    relationship_reporterAri?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_author?: InputMaybe<GraphStoreSprintAssociatedPrAuthorSortInput>;
    to_reviewers?: InputMaybe<GraphStoreSprintAssociatedPrReviewerSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
    to_taskCount?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintAssociatedVulnerabilityConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_statusCategory?: InputMaybe<GraphStoreSprintAssociatedVulnerabilityStatusCategoryFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_introducedDate?: InputMaybe<GraphStoreLongFilterInput>;
    to_severity?: InputMaybe<GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverityFilterInput>;
    to_status?: InputMaybe<GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatusFilterInput>;
};

/** Conditional selection for filter field of sprint-associated-vulnerability relationship queries */
export type GraphStoreSprintAssociatedVulnerabilityFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreSprintAssociatedVulnerabilityConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreSprintAssociatedVulnerabilityConditionalFilterInput>
        >
    >;
};

export type GraphStoreSprintAssociatedVulnerabilitySortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    relationship_statusAri?: InputMaybe<GraphStoreSortInput>;
    relationship_statusCategory?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_introducedDate?: InputMaybe<GraphStoreSortInput>;
    to_severity?: InputMaybe<GraphStoreSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreSprintAssociatedVulnerabilityStatusCategory {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphStoreSprintAssociatedVulnerabilityStatusCategoryFilterInput = {
    is?: InputMaybe<
        Array<GraphStoreSprintAssociatedVulnerabilityStatusCategory>
    >;
    isNot?: InputMaybe<
        Array<GraphStoreSprintAssociatedVulnerabilityStatusCategory>
    >;
};

export enum GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity {
    Critical = "CRITICAL",
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM",
    NotSet = "NOT_SET",
    Unknown = "UNKNOWN"
}

export type GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverityFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity>
        >;
    };

export enum GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    NotSet = "NOT_SET",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatusFilterInput =
    {
        is?: InputMaybe<
            Array<GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus>
        >;
        isNot?: InputMaybe<
            Array<GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus>
        >;
    };

export type GraphStoreSprintContainsIssueConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreLongFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_assigneeAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_creatorAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_issueAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_reporterAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_statusAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_statusCategory?: InputMaybe<GraphStoreSprintContainsIssueStatusCategoryFilterInput>;
};

/** Conditional selection for filter field of sprint-contains-issue relationship queries */
export type GraphStoreSprintContainsIssueFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintContainsIssueConditionalFilterInput>>
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<InputMaybe<GraphStoreSprintContainsIssueConditionalFilterInput>>
    >;
};

export type GraphStoreSprintContainsIssueSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_issueLastUpdatedOn?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_assigneeAri?: InputMaybe<GraphStoreSortInput>;
    to_creatorAri?: InputMaybe<GraphStoreSortInput>;
    to_issueAri?: InputMaybe<GraphStoreSortInput>;
    to_reporterAri?: InputMaybe<GraphStoreSortInput>;
    to_statusAri?: InputMaybe<GraphStoreSortInput>;
    to_statusCategory?: InputMaybe<GraphStoreSortInput>;
};

export enum GraphStoreSprintContainsIssueStatusCategory {
    Done = "DONE",
    Indeterminate = "INDETERMINATE",
    New = "NEW",
    Undefined = "UNDEFINED"
}

export type GraphStoreSprintContainsIssueStatusCategoryFilterInput = {
    is?: InputMaybe<Array<GraphStoreSprintContainsIssueStatusCategory>>;
    isNot?: InputMaybe<Array<GraphStoreSprintContainsIssueStatusCategory>>;
};

export type GraphStoreSprintRetrospectivePageSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreSprintRetrospectiveWhiteboardSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreTeamConnectedToContainerSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreTeamOwnsComponentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreTeamWorksOnProjectSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreThirdPartyToGraphRemoteLinkSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAssignedIncidentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAssignedIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAssignedPirSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAttendedCalendarEventSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAuthoredCommitSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAuthoredPrSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserAuthoritativelyLinkedThirdPartyUserConditionalFilterInput =
    {
        /** Filter by the creation date of the relationship */
        createdAt?: InputMaybe<GraphStoreDateFilterInput>;
        /** Filter by the ATI of the from node */
        fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
        /** Filter by the date the relationship was last changed */
        lastModified?: InputMaybe<GraphStoreDateFilterInput>;
        relationship_graphworkspaceAri?: InputMaybe<GraphStoreAriFilterInput>;
        relationship_integrationAri?: InputMaybe<GraphStoreAriFilterInput>;
        /** Filter by the ATI of the to node */
        toAti?: InputMaybe<GraphStoreAtiFilterInput>;
        to_graphworkspaceAri?: InputMaybe<GraphStoreAriFilterInput>;
        to_integrationAri?: InputMaybe<GraphStoreAriFilterInput>;
    };

/** Conditional selection for filter field of user-authoritatively-linked-third-party-user relationship queries */
export type GraphStoreUserAuthoritativelyLinkedThirdPartyUserFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreUserAuthoritativelyLinkedThirdPartyUserConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreUserAuthoritativelyLinkedThirdPartyUserConditionalFilterInput>
        >
    >;
};

export type GraphStoreUserAuthoritativelyLinkedThirdPartyUserSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_graphworkspaceAri?: InputMaybe<GraphStoreSortInput>;
    relationship_integrationAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_graphworkspaceAri?: InputMaybe<GraphStoreSortInput>;
    to_integrationAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCanViewConfluenceSpaceSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCollaboratedOnDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserContributedConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserContributedConfluenceDatabaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserContributedConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserContributedConfluenceWhiteboardSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedBranchSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedCalendarEventSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedConfluenceCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedConfluenceDatabaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedConfluenceSpaceSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedConfluenceWhiteboardSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedDesignSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedIssueCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedIssueWorklogSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedLoomVideoCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedLoomVideoSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedMessageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedReleaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedRemoteLinkSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserCreatedRepositorySortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserFavoritedConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserFavoritedConfluenceDatabaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserFavoritedConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserFavoritedConfluenceWhiteboardSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserHasCollaboratorsSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserHasRelevantProjectSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserHasTopProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserIsInTeamSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserLastUpdatedDesignSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserLaunchedReleaseSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserLinkedThirdPartyUserConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    relationship_graphworkspaceAri?: InputMaybe<GraphStoreAriFilterInput>;
    relationship_integrationAri?: InputMaybe<GraphStoreAriFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_graphworkspaceAri?: InputMaybe<GraphStoreAriFilterInput>;
    to_integrationAri?: InputMaybe<GraphStoreAriFilterInput>;
};

/** Conditional selection for filter field of user-linked-third-party-user relationship queries */
export type GraphStoreUserLinkedThirdPartyUserFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreUserLinkedThirdPartyUserConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreUserLinkedThirdPartyUserConditionalFilterInput>
        >
    >;
};

export type GraphStoreUserLinkedThirdPartyUserSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    relationship_graphworkspaceAri?: InputMaybe<GraphStoreSortInput>;
    relationship_integrationAri?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_graphworkspaceAri?: InputMaybe<GraphStoreSortInput>;
    to_integrationAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserMemberOfConversationSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserMentionedInConversationSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserMentionedInMessageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserMergedPullRequestSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnedBranchSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnedCalendarEventSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnedDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnedRemoteLinkSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnedRepositorySortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnsComponentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserOwnsFocusAreaSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserReportedIncidentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserReportsIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserReviewsPrSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserTaggedInCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserTaggedInConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserTaggedInIssueCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserTaggedInLoomVideoCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserTriggeredDeploymentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedConfluenceSpaceSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedConfluenceWhiteboardSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedGraphDocumentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserUpdatedIssueStatusSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedAtlasGoalSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedAtlasProjectSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedGoalUpdateSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedJiraIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedLoomVideoSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserViewedProjectUpdateSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserWatchesConfluenceBlogpostSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserWatchesConfluencePageSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreUserWatchesConfluenceWhiteboardSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedBranchSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedBuildSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedCommitSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedDeploymentSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedDesignConditionalFilterInput = {
    /** Filter by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreAtiFilterInput>;
    /** Filter by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreDateFilterInput>;
    /** Filter by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreAtiFilterInput>;
    to_designLastUpdated?: InputMaybe<GraphStoreLongFilterInput>;
    to_status?: InputMaybe<GraphStoreVersionAssociatedDesignDesignStatusFilterInput>;
    to_type?: InputMaybe<GraphStoreVersionAssociatedDesignDesignTypeFilterInput>;
};

export enum GraphStoreVersionAssociatedDesignDesignStatus {
    None = "NONE",
    NotSet = "NOT_SET",
    ReadyForDevelopment = "READY_FOR_DEVELOPMENT",
    Unknown = "UNKNOWN"
}

export type GraphStoreVersionAssociatedDesignDesignStatusFilterInput = {
    is?: InputMaybe<Array<GraphStoreVersionAssociatedDesignDesignStatus>>;
    isNot?: InputMaybe<Array<GraphStoreVersionAssociatedDesignDesignStatus>>;
};

export enum GraphStoreVersionAssociatedDesignDesignType {
    Canvas = "CANVAS",
    File = "FILE",
    Group = "GROUP",
    Node = "NODE",
    NotSet = "NOT_SET",
    Other = "OTHER",
    Prototype = "PROTOTYPE"
}

export type GraphStoreVersionAssociatedDesignDesignTypeFilterInput = {
    is?: InputMaybe<Array<GraphStoreVersionAssociatedDesignDesignType>>;
    isNot?: InputMaybe<Array<GraphStoreVersionAssociatedDesignDesignType>>;
};

/** Conditional selection for filter field of version-associated-design relationship queries */
export type GraphStoreVersionAssociatedDesignFilterInput = {
    /** Logical AND of the filter */
    and?: InputMaybe<
        Array<
            InputMaybe<GraphStoreVersionAssociatedDesignConditionalFilterInput>
        >
    >;
    /** Logical OR of the filter */
    or?: InputMaybe<
        Array<
            InputMaybe<GraphStoreVersionAssociatedDesignConditionalFilterInput>
        >
    >;
};

export type GraphStoreVersionAssociatedDesignSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
    to_designLastUpdated?: InputMaybe<GraphStoreSortInput>;
    to_status?: InputMaybe<GraphStoreSortInput>;
    to_type?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedFeatureFlagSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedIssueSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedPullRequestSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionAssociatedRemoteLinkSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVersionUserAssociatedFeatureFlagSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVideoHasCommentSortInput = {
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVulnerabilityAssociatedIssueContainerSortInput = {
    containerAri?: InputMaybe<GraphStoreSortInput>;
};

export type GraphStoreVulnerabilityAssociatedIssueSortInput = {
    /** Sort by the creation date of the relationship */
    createdAt?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the from node */
    fromAti?: InputMaybe<GraphStoreSortInput>;
    from_container?: InputMaybe<GraphStoreVulnerabilityAssociatedIssueContainerSortInput>;
    from_introducedDate?: InputMaybe<GraphStoreSortInput>;
    from_severity?: InputMaybe<GraphStoreSortInput>;
    from_status?: InputMaybe<GraphStoreSortInput>;
    from_type?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the date the relationship was last changed */
    lastModified?: InputMaybe<GraphStoreSortInput>;
    /** Sort by the ATI of the to node */
    toAti?: InputMaybe<GraphStoreSortInput>;
};

export type Group = {
    __typename?: "Group";
    id?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextSelfBase>;
    name?: Maybe<Scalars["String"]["output"]>;
    permissionType?: Maybe<SitePermissionType>;
};

export type GroupByPageInfo = {
    __typename?: "GroupByPageInfo";
    next?: Maybe<Scalars["String"]["output"]>;
};

export type GroupEdge = {
    __typename?: "GroupEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Group>;
};

export type GroupWithPermissions = {
    __typename?: "GroupWithPermissions";
    currentUserCanEdit?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksSelf>;
    name?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
};

export type GroupWithPermissionsEdge = {
    __typename?: "GroupWithPermissionsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<GroupWithPermissions>;
};

export type GroupWithPermissionsInput = {
    id: Scalars["ID"]["input"];
    operations: Array<InputMaybe<OperationCheckResultInput>>;
};

export type GroupWithRestrictions = {
    __typename?: "GroupWithRestrictions";
    group?: Maybe<Group>;
    hasSpaceEditPermission?: Maybe<Scalars["Boolean"]["output"]>;
    hasSpaceViewPermission?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksSelf>;
    name?: Maybe<Scalars["String"]["output"]>;
    permissionType?: Maybe<SitePermissionType>;
    restrictingContent?: Maybe<Content>;
};

export type GroupWithRestrictionsEdge = {
    __typename?: "GroupWithRestrictionsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<GroupWithRestrictions>;
};

/**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */
export type GrowthRecContext = {
    anonymousId?: InputMaybe<Scalars["ID"]["input"]>;
    containers?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Any custom context associated with this request */
    custom?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Language-Sub language identifier format (ISO 639-1 and ISO 639-2) */
    locale?: InputMaybe<Scalars["String"]["input"]>;
    orgId?: InputMaybe<Scalars["ID"]["input"]>;
    product?: InputMaybe<Scalars["String"]["input"]>;
    /** This is an identifier for tagging analytics events, useful for correlating across frontend and backend */
    sessionId?: InputMaybe<Scalars["ID"]["input"]>;
    subproduct?: InputMaybe<Scalars["String"]["input"]>;
    /** The tenant id is also well known as the cloud id */
    tenantId?: InputMaybe<Scalars["ID"]["input"]>;
    useCase?: InputMaybe<Scalars["String"]["input"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated user id is retrieved from the user context token, if you need to provide and unverified user id use the custom field instead
     */
    userId?: InputMaybe<Scalars["ID"]["input"]>;
    workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GrowthRecJiraTemplateRecommendation = GrowthRecRecommendation & {
    __typename?: "GrowthRecJiraTemplateRecommendation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reasons?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type GrowthRecNonHydratedRecommendation = GrowthRecRecommendation & {
    __typename?: "GrowthRecNonHydratedRecommendation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reasons?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type GrowthRecProductRecommendation = GrowthRecRecommendation & {
    __typename?: "GrowthRecProductRecommendation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reasons?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type GrowthRecQuery = {
    __typename?: "GrowthRecQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendations?: Maybe<GrowthRecRecommendationsResult>;
};

export type GrowthRecQueryRecommendationsArgs = {
    context?: InputMaybe<GrowthRecContext>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    rerank?: InputMaybe<Array<GrowthRecRerankCandidate>>;
};

export type GrowthRecRecommendation = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reasons?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type GrowthRecRecommendations = {
    __typename?: "GrowthRecRecommendations";
    data?: Maybe<Array<GrowthRecRecommendation>>;
};

export type GrowthRecRecommendationsResult =
    | GrowthRecRecommendations
    | QueryError;

export type GrowthRecRerankCandidate = {
    context?: InputMaybe<Scalars["JSON"]["input"]>;
    entityId: Scalars["String"]["input"];
};

export type GrowthUnifiedProfileAnchor = {
    __typename?: "GrowthUnifiedProfileAnchor";
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<GrowthUnifiedProfileAnchorType>;
};

export enum GrowthUnifiedProfileAnchorType {
    Pfm = "PFM",
    Seo = "SEO"
}

export enum GrowthUnifiedProfileChannel {
    PaidContent = "PAID_CONTENT",
    PaidDisplay = "PAID_DISPLAY",
    PaidReviewSites = "PAID_REVIEW_SITES",
    PaidSearch = "PAID_SEARCH",
    PaidSocial = "PAID_SOCIAL"
}

export type GrowthUnifiedProfileCompany = {
    __typename?: "GrowthUnifiedProfileCompany";
    accountStatus?: Maybe<GrowthUnifiedProfileEnterpriseAccountStatus>;
    annualRevenue?: Maybe<Scalars["Int"]["output"]>;
    businessName?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    domain?: Maybe<Scalars["String"]["output"]>;
    employeeStrength?: Maybe<Scalars["Int"]["output"]>;
    enterpriseSized?: Maybe<Scalars["Boolean"]["output"]>;
    marketCap?: Maybe<Scalars["String"]["output"]>;
    revenueCurrency?: Maybe<Scalars["String"]["output"]>;
    sector?: Maybe<Scalars["String"]["output"]>;
    size?: Maybe<GrowthUnifiedProfileCompanySize>;
    type?: Maybe<GrowthUnifiedProfileCompanyType>;
};

export type GrowthUnifiedProfileCompanyProfile = {
    __typename?: "GrowthUnifiedProfileCompanyProfile";
    /** Existing or a New Company */
    companyType?: Maybe<GrowthUnifiedProfileEntryType>;
};

export enum GrowthUnifiedProfileCompanySize {
    Large = "LARGE",
    Medium = "MEDIUM",
    Small = "SMALL",
    Unknown = "UNKNOWN"
}

export enum GrowthUnifiedProfileCompanyType {
    Private = "PRIVATE",
    Public = "PUBLIC"
}

export type GrowthUnifiedProfileConfluenceOnboardingContext = {
    __typename?: "GrowthUnifiedProfileConfluenceOnboardingContext";
    jobsToBeDone?: Maybe<Array<Maybe<GrowthUnifiedProfileJtbd>>>;
    template?: Maybe<Scalars["String"]["output"]>;
};

export type GrowthUnifiedProfileConfluenceOnboardingContextInput = {
    jobsToBeDone?: InputMaybe<Array<InputMaybe<GrowthUnifiedProfileJtbd>>>;
    template?: InputMaybe<Scalars["String"]["input"]>;
};

export type GrowthUnifiedProfileCreateProfileInput = {
    /** The account ID for the user. */
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The anonymous ID for the user. */
    anonymousId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The tenant ID for the user. */
    tenantId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Unified profile which needs to be created for the user. */
    unifiedProfile: GrowthUnifiedProfileInput;
};

export enum GrowthUnifiedProfileDomainType {
    Business = "BUSINESS",
    Personal = "PERSONAL"
}

export enum GrowthUnifiedProfileEnrichmentStatus {
    Complete = "COMPLETE",
    Error = "ERROR",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING"
}

export enum GrowthUnifiedProfileEnterpriseAccountStatus {
    Bronze = "BRONZE",
    Gam = "GAM",
    Gold = "GOLD",
    Platimun = "PLATIMUN",
    Silver = "SILVER"
}

export enum GrowthUnifiedProfileEntityType {
    /** anonymous entity type */
    AjsAnonymousUser = "AJS_ANONYMOUS_USER",
    /** atlassian account entity type */
    AtlassianAccount = "ATLASSIAN_ACCOUNT",
    /** organization entity type */
    Org = "ORG",
    /** site of tenant entity type */
    Site = "SITE"
}

export enum GrowthUnifiedProfileEntryType {
    Existing = "EXISTING",
    New = "NEW"
}

export type GrowthUnifiedProfileInput = {
    /** onboardingContext for jira or confluence */
    onboardingContext?: InputMaybe<GrowthUnifiedProfileOnboardingContextInput>;
};

/** Issue type to be used for the first onboarding Jira project */
export type GrowthUnifiedProfileIssueType = {
    __typename?: "GrowthUnifiedProfileIssueType";
    /** Issue type avatar */
    avatarId?: Maybe<Scalars["String"]["output"]>;
    /** Issue type name */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Issue type input to be used for the first onboarding Jira project */
export type GrowthUnifiedProfileIssueTypeInput = {
    /** Issue type avatar */
    avatarId?: InputMaybe<Scalars["String"]["input"]>;
    /** Issue type name */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export enum GrowthUnifiedProfileJtbd {
    AdHocTaskAndIncidentManagement = "AD_HOC_TASK_AND_INCIDENT_MANAGEMENT",
    Budgets = "BUDGETS",
    CdWrtng = "CD_WRTNG",
    CentralizedDocumentation = "CENTRALIZED_DOCUMENTATION",
    ComplianceAndRiskManagement = "COMPLIANCE_AND_RISK_MANAGEMENT",
    EstimateTimeAndEffort = "ESTIMATE_TIME_AND_EFFORT",
    ImproveTeamProcesses = "IMPROVE_TEAM_PROCESSES",
    ImproveWorkflow = "IMPROVE_WORKFLOW",
    LaunchCampaigns = "LAUNCH_CAMPAIGNS",
    ManageTasks = "MANAGE_TASKS",
    ManagingClientAndVendorRelationships = "MANAGING_CLIENT_AND_VENDOR_RELATIONSHIPS",
    MapWorkDependencies = "MAP_WORK_DEPENDENCIES",
    MarketingContent = "MARKETING_CONTENT",
    PlanAndManage = "PLAN_AND_MANAGE",
    PrioritizeWork = "PRIORITIZE_WORK",
    ProjectPlanning = "PROJECT_PLANNING",
    ProjectPlanningAndCoordination = "PROJECT_PLANNING_AND_COORDINATION",
    ProjectProgress = "PROJECT_PROGRESS",
    RunSprints = "RUN_SPRINTS",
    Stakeholders = "STAKEHOLDERS",
    StrategiesAndGoals = "STRATEGIES_AND_GOALS",
    SystemAndToolEvaluations = "SYSTEM_AND_TOOL_EVALUATIONS",
    TrackingRprtng = "TRACKING_RPRTNG",
    TrackBugs = "TRACK_BUGS",
    UseKanbanBoard = "USE_KANBAN_BOARD",
    WorkInScrum = "WORK_IN_SCRUM"
}

export enum GrowthUnifiedProfileJiraFamiliarity {
    Experience = "EXPERIENCE",
    Middle = "MIDDLE",
    New = "NEW"
}

export type GrowthUnifiedProfileJiraOnboardingContext = {
    __typename?: "GrowthUnifiedProfileJiraOnboardingContext";
    experienceLevel?: Maybe<Scalars["String"]["output"]>;
    /** Issue types to be used for the first onboarding Jira project */
    issueTypes?: Maybe<Array<Maybe<GrowthUnifiedProfileIssueType>>>;
    jiraFamiliarity?: Maybe<GrowthUnifiedProfileJiraFamiliarity>;
    jobsToBeDone?: Maybe<Array<Maybe<GrowthUnifiedProfileJtbd>>>;
    persona?: Maybe<Scalars["String"]["output"]>;
    /** Project landing selection */
    projectLandingSelection?: Maybe<GrowthUnifiedProfileOnboardingContextProjectLandingSelection>;
    projectName?: Maybe<Scalars["String"]["output"]>;
    /** Status names to be used for the first onboarding Jira project */
    statusNames?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    teamType?: Maybe<GrowthUnifiedProfileTeamType>;
    template?: Maybe<Scalars["String"]["output"]>;
};

/** onboarding context input for jira */
export type GrowthUnifiedProfileJiraOnboardingContextInput = {
    experienceLevel?: InputMaybe<Scalars["String"]["input"]>;
    /** Issue types to be used for the first onboarding Jira project */
    issueTypes?: InputMaybe<
        Array<InputMaybe<GrowthUnifiedProfileIssueTypeInput>>
    >;
    jiraFamiliarity?: InputMaybe<GrowthUnifiedProfileJiraFamiliarity>;
    /** jobs to be done */
    jobsToBeDone?: InputMaybe<Array<InputMaybe<GrowthUnifiedProfileJtbd>>>;
    persona?: InputMaybe<Scalars["String"]["input"]>;
    /** Project landing selection */
    projectLandingSelection?: InputMaybe<GrowthUnifiedProfileOnboardingContextProjectLandingSelection>;
    /** name of the jira project */
    projectName?: InputMaybe<Scalars["String"]["input"]>;
    /** Status names to be used for the first onboarding Jira project */
    statusNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /** team type of the team */
    teamType?: InputMaybe<GrowthUnifiedProfileTeamType>;
    template?: InputMaybe<Scalars["String"]["input"]>;
};

export type GrowthUnifiedProfileLinkedEntities = {
    __typename?: "GrowthUnifiedProfileLinkedEntities";
    entityType?: Maybe<GrowthUnifiedProfileEntityType>;
    linkedId?: Maybe<Scalars["String"]["output"]>;
};

/** onboarding context type for jira or confluence */
export type GrowthUnifiedProfileOnboardingContext = {
    __typename?: "GrowthUnifiedProfileOnboardingContext";
    confluence?: Maybe<GrowthUnifiedProfileConfluenceOnboardingContext>;
    jira?: Maybe<GrowthUnifiedProfileJiraOnboardingContext>;
};

/** onboarding context input for jira or confluence */
export type GrowthUnifiedProfileOnboardingContextInput = {
    confluence?: InputMaybe<GrowthUnifiedProfileConfluenceOnboardingContextInput>;
    jira?: InputMaybe<GrowthUnifiedProfileJiraOnboardingContextInput>;
};

export enum GrowthUnifiedProfileOnboardingContextProjectLandingSelection {
    CreateProject = "CREATE_PROJECT",
    SampleProject = "SAMPLE_PROJECT"
}

/**
 * Channel type, this information will be extracted from the query parameters and other sources, such as ML
 * mapping file
 */
export type GrowthUnifiedProfilePaidChannelContext = {
    __typename?: "GrowthUnifiedProfilePaidChannelContext";
    anchor?: Maybe<GrowthUnifiedProfileAnchor>;
    persona?: Maybe<Scalars["String"]["output"]>;
    subAnchor?: Maybe<Scalars["String"]["output"]>;
    teamType?: Maybe<GrowthUnifiedProfileTeamType>;
    templates?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    utm?: Maybe<GrowthUnifiedProfileUtm>;
};

/** Paid channel context organized by product */
export type GrowthUnifiedProfilePaidChannelContextByProduct = {
    __typename?: "GrowthUnifiedProfilePaidChannelContextByProduct";
    confluence?: Maybe<GrowthUnifiedProfilePaidChannelContext>;
    jira?: Maybe<GrowthUnifiedProfilePaidChannelContext>;
    jsm?: Maybe<GrowthUnifiedProfilePaidChannelContext>;
    jwm?: Maybe<GrowthUnifiedProfilePaidChannelContext>;
    trello?: Maybe<GrowthUnifiedProfilePaidChannelContext>;
};

export enum GrowthUnifiedProfileProduct {
    Compass = "compass",
    Confluence = "confluence",
    Jira = "jira",
    Jpd = "jpd",
    Jsm = "jsm",
    Jwm = "jwm",
    Trello = "trello"
}

export type GrowthUnifiedProfileProductDetails = {
    __typename?: "GrowthUnifiedProfileProductDetails";
    /** Indicate if the user was active on the site on D0 */
    d0Active?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is the request time (current time) within the D0 window */
    d0Eligible?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicate if the user was active on the site on D1to6 */
    d1to6Active?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is the request time (current time) within the D1to6 window */
    d1to6Eligible?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is the product in trial */
    isTrial?: Maybe<Scalars["Boolean"]["output"]>;
    /** product edition free, premium */
    productEdition?: Maybe<Scalars["String"]["output"]>;
    /** product key */
    productKey?: Maybe<Scalars["String"]["output"]>;
    /** Name of the product */
    productName?: Maybe<Scalars["String"]["output"]>;
    /** Date on which the product was provisioned */
    provisionedAt?: Maybe<Scalars["String"]["output"]>;
};

export type GrowthUnifiedProfileResult = {
    __typename?: "GrowthUnifiedProfileResult";
    /**
     * Company information for the unified profile
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    company?: Maybe<GrowthUnifiedProfileCompany>;
    /**
     * Properties of logged in user's company
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    companyProfile?: Maybe<GrowthUnifiedProfileCompanyProfile>;
    /**
     * Current enrichment status for the unified profile, the profile will be enriched from multiple sources
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    enrichmentStatus?: Maybe<GrowthUnifiedProfileEnrichmentStatus>;
    /**
     * Entity type of the unified profile
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityType?: Maybe<GrowthUnifiedProfileEntityType>;
    /**
     * Array of additional IDs and their corresponding entityTypes
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    linkedEntities?: Maybe<Array<Maybe<GrowthUnifiedProfileLinkedEntities>>>;
    /**
     * onboardingContext for jira or confluence
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onboardingContext?: Maybe<GrowthUnifiedProfileOnboardingContext>;
    /**
     * paid channel information for the profile
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    paidChannelContext?: Maybe<GrowthUnifiedProfilePaidChannelContextByProduct>;
    /**
     * SEO context for the profile
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    seoContext?: Maybe<GrowthUnifiedProfileSeoContext>;
    /**
     * Array of site-specific properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sites?: Maybe<Array<Maybe<GrowthUnifiedProfileSiteDetails>>>;
    /**
     * A map of main products and boolean value indicating if the anonymous user has signed up for that product in the past
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userFootprints?: Maybe<GrowthUnifiedProfileUserFootprints>;
    /**
     * Properties of logged in user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userProfile?: Maybe<GrowthUnifiedProfileUserProfile>;
};

export type GrowthUnifiedProfileSeoContext = {
    __typename?: "GrowthUnifiedProfileSeoContext";
    anchor?: Maybe<GrowthUnifiedProfileAnchor>;
};

export type GrowthUnifiedProfileSiteDetails = {
    __typename?: "GrowthUnifiedProfileSiteDetails";
    /** cloudId of the site */
    cloudId?: Maybe<Scalars["String"]["output"]>;
    /** displayName of the site */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** If the user has admin access to the site */
    hasAdminAccess?: Maybe<Scalars["Boolean"]["output"]>;
    /** List of products for the sites */
    products?: Maybe<Array<Maybe<GrowthUnifiedProfileProductDetails>>>;
    /** Date on which the site was created */
    siteCreatedAt?: Maybe<Scalars["String"]["output"]>;
    /** url of the site */
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum GrowthUnifiedProfileTeamType {
    CustomerService = "CUSTOMER_SERVICE",
    DataScience = "DATA_SCIENCE",
    Design = "DESIGN",
    Finance = "FINANCE",
    HumanResources = "HUMAN_RESOURCES",
    ItSupport = "IT_SUPPORT",
    Legal = "LEGAL",
    Marketing = "MARKETING",
    Operations = "OPERATIONS",
    Other = "OTHER",
    ProductManagement = "PRODUCT_MANAGEMENT",
    ProgramManagement = "PROGRAM_MANAGEMENT",
    ProjectManagement = "PROJECT_MANAGEMENT",
    Sales = "SALES",
    SoftwareDevelopment = "SOFTWARE_DEVELOPMENT",
    SoftwareEngineering = "SOFTWARE_ENGINEERING"
}

export type GrowthUnifiedProfileUserFootprints = {
    __typename?: "GrowthUnifiedProfileUserFootprints";
    /** Boolean value indicating if the user has an Atlassian account */
    hasAtlassianAccount?: Maybe<Scalars["Boolean"]["output"]>;
    /** List of products the user has used in the past */
    products?: Maybe<Array<Maybe<GrowthUnifiedProfileProduct>>>;
};

export type GrowthUnifiedProfileUserProfile = {
    __typename?: "GrowthUnifiedProfileUserProfile";
    /** List of products the user has used in the past */
    domainType?: Maybe<GrowthUnifiedProfileDomainType>;
    /** Existing or a New user */
    userType?: Maybe<GrowthUnifiedProfileEntryType>;
};

/** Utm type will be extracted from the url query parameters */
export type GrowthUnifiedProfileUtm = {
    __typename?: "GrowthUnifiedProfileUtm";
    /** utm channel */
    channel?: Maybe<GrowthUnifiedProfileChannel>;
    /** user's search keywords */
    keyword?: Maybe<Scalars["String"]["output"]>;
    /** utm source */
    source?: Maybe<Scalars["String"]["output"]>;
};

export type HamsAccountDetails = CommerceAccountDetails & {
    __typename?: "HamsAccountDetails";
    invoiceGroup?: Maybe<HamsInvoiceGroup>;
};

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type HamsAddPaymentMethodExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "HamsAddPaymentMethodExperienceCapability";
        /**
         * The URL of the experience.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type HamsChangeOfferingExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "HamsChangeOfferingExperienceCapability";
        /**
         * The URL of the experience.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

export type HamsChargeDetails = CommerceChargeDetails & {
    __typename?: "HamsChargeDetails";
    chargeQuantities?: Maybe<Array<Maybe<HamsChargeQuantity>>>;
};

export type HamsChargeElement = CommerceChargeElement & {
    __typename?: "HamsChargeElement";
    ceiling?: Maybe<Scalars["Int"]["output"]>;
    unit?: Maybe<Scalars["String"]["output"]>;
};

export type HamsChargeQuantity = CommerceChargeQuantity & {
    __typename?: "HamsChargeQuantity";
    chargeElement?: Maybe<Scalars["String"]["output"]>;
    lastUpdatedAt?: Maybe<Scalars["Float"]["output"]>;
    quantity?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type HamsConfigurePaymentMethodExperienceCapability =
    CommerceExperienceCapability & {
        __typename?: "HamsConfigurePaymentMethodExperienceCapability";
        /**
         * The URL of the experience.
         * The client MUST add an `atlOrigin` query parameter to the URL as per
         * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
         */
        experienceUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Whether the current user has sufficient permissions in order to complete the flow and
         * the action is permitted with regard to the business rules.
         */
        isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
    };

/** Hams types for common commerce API, implementing types in commerce_schema. */
export type HamsEntitlement = CommerceEntitlement & {
    __typename?: "HamsEntitlement";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addon?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    creationDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currentEdition?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editionTransitions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    endDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementGroupId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementMigrationEvaluation?: Maybe<HamsEntitlementMigrationEvaluation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementSource?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experienceCapabilities?: Maybe<HamsEntitlementExperienceCapabilities>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    futureEdition?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    futureEditionTransition?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Get the latest usage count for the chosen charge element, e.g. user, if it exists. Note that there is no guarantee that the latest value of any charge element is relevant for billing or for usage limitation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    latestUsageForChargeElement?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    offering?: Maybe<HamsOffering>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    overriddenEdition?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    preDunning?: Maybe<HamsEntitlementPreDunning>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    productKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * In HAMS there are actually no relationships and that is why this is always going to be an empty list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatesFromEntitlements?: Maybe<Array<Maybe<HamsEntitlementRelationship>>>;
    /**
     * In HAMS there are actually no relationships and that is why this is always going to be an empty list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatesToEntitlements?: Maybe<Array<Maybe<HamsEntitlementRelationship>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sen?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shortTrial?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    slug?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    startDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subscription?: Maybe<HamsSubscription>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suspended?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    transactionAccount?: Maybe<HamsTransactionAccount>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trialEdition?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trialEditionEndDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trialEndDate?: Maybe<Scalars["String"]["output"]>;
};

/** Hams types for common commerce API, implementing types in commerce_schema. */
export type HamsEntitlementLatestUsageForChargeElementArgs = {
    chargeElement?: InputMaybe<Scalars["String"]["input"]>;
};

export type HamsEntitlementExperienceCapabilities =
    CommerceEntitlementExperienceCapabilities & {
        __typename?: "HamsEntitlementExperienceCapabilities";
        /**
         * Experience for user to change their current offering to the target offeringKey (offeringKey arg is optional).
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Replaced with changeOfferingV2
         */
        changeOffering?: Maybe<HamsExperienceCapability>;
        /**
         * Experience for user to change their current offering to the target offeringKey (offeringKey arg is optional).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        changeOfferingV2?: Maybe<HamsChangeOfferingExperienceCapability>;
    };

export type HamsEntitlementExperienceCapabilitiesChangeOfferingArgs = {
    offeringKey?: InputMaybe<Scalars["ID"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

export type HamsEntitlementExperienceCapabilitiesChangeOfferingV2Args = {
    offeringKey?: InputMaybe<Scalars["ID"]["input"]>;
    offeringName?: InputMaybe<Scalars["String"]["input"]>;
};

export type HamsEntitlementMigrationEvaluation = {
    __typename?: "HamsEntitlementMigrationEvaluation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    btfSourceAccountId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    usageLimit?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    usageType?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Entitlements with annual plans are not supported and an error will be returned.
 * Returns status IN_PRE_DUNNING if a trial has ended and billing details are not added for the entitlement.
 * firstPreDunningEndTimestamp is the end time of the earliest pre-dunning of the entitlement, if there are more than one instance.
 */
export type HamsEntitlementPreDunning = CommerceEntitlementPreDunning & {
    __typename?: "HamsEntitlementPreDunning";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Replaced with firstPreDunningEndTimestampV2 due to inconsistent behaviour with CCP firstPreDunningEndTimestamp
     */
    firstPreDunningEndTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /**
     * First pre dunning end time in milliseconds
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    firstPreDunningEndTimestampV2?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<CcpEntitlementPreDunningStatus>;
};

export type HamsEntitlementRelationship = CommerceEntitlementRelationship & {
    __typename?: "HamsEntitlementRelationship";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entitlementId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relationshipId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relationshipType?: Maybe<Scalars["String"]["output"]>;
};

/**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */
export type HamsExperienceCapability = CommerceExperienceCapability & {
    __typename?: "HamsExperienceCapability";
    /**
     * The URL of the experience.
     * The client MUST add an `atlOrigin` query parameter to the URL as per
     * https://hello.atlassian.net/wiki/spaces/PGT/pages/197457957/How+to+use+Origin+Tracing#Journey-begins%3A-a-share%2Finvite-action-happens
     */
    experienceUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether the current user has sufficient permissions in order to complete the flow and
     * the action is permitted with regard to the business rules.
     */
    isAvailableToUser?: Maybe<Scalars["Boolean"]["output"]>;
};

export type HamsInvoiceGroup = CommerceInvoiceGroup & {
    __typename?: "HamsInvoiceGroup";
    experienceCapabilities?: Maybe<HamsInvoiceGroupExperienceCapabilities>;
    invoiceable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type HamsInvoiceGroupExperienceCapabilities =
    CommerceInvoiceGroupExperienceCapabilities & {
        __typename?: "HamsInvoiceGroupExperienceCapabilities";
        /**
         * Experience for user to configure their payment details for a particular invoice group.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Replaced with configurePaymentV2
         */
        configurePayment?: Maybe<HamsExperienceCapability>;
        /** Experience for user to configure their payment details for a particular invoice group. */
        configurePaymentV2?: Maybe<HamsConfigurePaymentMethodExperienceCapability>;
    };

export type HamsOffering = CommerceOffering & {
    __typename?: "HamsOffering";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    chargeElements?: Maybe<Array<Maybe<HamsChargeElement>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trial?: Maybe<HamsOfferingTrial>;
};

export type HamsOfferingTrial = CommerceOfferingTrial & {
    __typename?: "HamsOfferingTrial";
    lengthDays?: Maybe<Scalars["Int"]["output"]>;
};

export type HamsPricingPlan = CommercePricingPlan & {
    __typename?: "HamsPricingPlan";
    currency?: Maybe<CcpCurrency>;
    primaryCycle?: Maybe<HamsPrimaryCycle>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type HamsPrimaryCycle = CommercePrimaryCycle & {
    __typename?: "HamsPrimaryCycle";
    interval?: Maybe<CcpBillingInterval>;
};

export type HamsSubscription = CommerceSubscription & {
    __typename?: "HamsSubscription";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountDetails?: Maybe<HamsAccountDetails>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    chargeDetails?: Maybe<HamsChargeDetails>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pricingPlan?: Maybe<HamsPricingPlan>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trial?: Maybe<HamsTrial>;
};

/**
 * A transaction account represents a customer,
 * i.e. the legal entity with which Atlassian is doing business.
 * It may be an individual, a business, etc.
 */
export type HamsTransactionAccount = CommerceTransactionAccount & {
    __typename?: "HamsTransactionAccount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experienceCapabilities?: Maybe<HamsTransactionAccountExperienceCapabilities>;
    /**
     * Whether bill to address is present
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isBillToPresent?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the current user is a billing admin for the transaction account
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isCurrentUserBillingAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether this transaction account is managed by a partner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isManagedByPartner?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The transaction account id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
};

export type HamsTransactionAccountExperienceCapabilities =
    CommerceTransactionAccountExperienceCapabilities & {
        __typename?: "HamsTransactionAccountExperienceCapabilities";
        /**
         * An experience flow where a customer may enter a payment method.
         * This payment method will be used to collect for all entitlements on the transaction account, unless they are in an invoice
         * group configured to use a different payment method.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Replaced with addPaymentMethodV2
         */
        addPaymentMethod?: Maybe<HamsExperienceCapability>;
        /**
         * An experience flow where a customer may enter a payment method.
         * This payment method will be used to collect for all entitlements on the transaction account, unless they are in an invoice
         * group configured to use a different payment method.
         */
        addPaymentMethodV2?: Maybe<HamsAddPaymentMethodExperienceCapability>;
    };

export type HamsTrial = CommerceTrial & {
    __typename?: "HamsTrial";
    endTimestamp?: Maybe<Scalars["Float"]["output"]>;
    startTimestamp?: Maybe<Scalars["Float"]["output"]>;
    /** Number of milliseconds left on the trial. */
    timeLeft?: Maybe<Scalars["Float"]["output"]>;
};

export type HardDeleteSpacePayload = {
    __typename?: "HardDeleteSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the fields that Mercury requires. */
export type HasMercuryProjectFields = {
    /** The avatar url for the type of Mercury Project. */
    mercuryProjectIcon?: Maybe<Scalars["URL"]["output"]>;
    /** An optional displayable key or ID of the item in the remote system, e.g. for Jira this will be the issue key. */
    mercuryProjectKey?: Maybe<Scalars["String"]["output"]>;
    /** The name of the Mercury Project which is either an Atlas Project or Jira Issue. */
    mercuryProjectName?: Maybe<Scalars["String"]["output"]>;
    /** The owner of the Mercury Project. */
    mercuryProjectOwner?: Maybe<User>;
    /** The product name providing the information for the Mercury Project - JIRA. */
    mercuryProjectProviderName?: Maybe<Scalars["String"]["output"]>;
    /** The status of the Mercury Project. */
    mercuryProjectStatus?: Maybe<MercuryProjectStatus>;
    /** The browser clickable link of the Mercury Project. */
    mercuryProjectUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The target date set for a Mercury Project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use mercuryTargetDateStart and mercuryTargetDateEnd instead
     */
    mercuryTargetDate?: Maybe<Scalars["String"]["output"]>;
    /** The target date end set for a Mercury Project. */
    mercuryTargetDateEnd?: Maybe<Scalars["DateTime"]["output"]>;
    /** The target date start set for a Mercury Project. */
    mercuryTargetDateStart?: Maybe<Scalars["DateTime"]["output"]>;
    /** The type of date set for the Mercury Project. */
    mercuryTargetDateType?: Maybe<MercuryProjectTargetDateType>;
};

/**
 * GraphQL connections that implement this interface denote support for fetching PageInfo.
 * Reusable components that render various forms of pagination controls can depend on the
 * interface than the concrete types.
 */
export type HasPageInfo = {
    /** Information about the current page */
    pageInfo: PageInfo;
};

/**
 * GraphQL connections that implement this interface denote support for fetching totalCount.
 * Reusable components that render various forms of pagination controls can depend on the
 * interface than the concrete types.
 */
export type HasTotal = {
    /** Total count of items to be returned. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type HeaderLookAndFeel = {
    __typename?: "HeaderLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    button?: Maybe<ButtonLookAndFeel>;
    primaryNavigation?: Maybe<NavigationLookAndFeel>;
    search?: Maybe<SearchFieldLookAndFeel>;
    secondaryNavigation?: Maybe<NavigationLookAndFeel>;
};

export type HelpCenter = Node & {
    __typename?: "HelpCenter";
    /** Announcement of the HelpCenter */
    announcements?: Maybe<HelpCenterAnnouncements>;
    /**
     *  Branding associated with the Help Center (would be null for Basic)
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterBrandingTest")' query directive to the 'helpCenterBranding' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpCenterBranding?: Maybe<HelpCenterBranding>;
    /** Hoisted project ID. This is exclusive to HelpCenter of type CUSTOMER_SERVICE */
    hoistedProjectId?: Maybe<Scalars["ID"]["output"]>;
    /** Hoisted project key. This is exclusive to HelpCenter of type CUSTOMER_SERVICE */
    hoistedProjectKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *  Layout associated with the Help center Home page
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterLayoutTest")' query directive to the 'homePageLayout' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    homePageLayout?: Maybe<HelpCenterHomePageLayout>;
    id: Scalars["ID"]["output"];
    /** Timestamp of latest update */
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    /** Count of mapped projects */
    mappedProjectsCount?: Maybe<Scalars["Int"]["output"]>;
    /** Name of the helpcenter. This may be null for the basic Help Center. */
    name?: Maybe<HelpCenterName>;
    /** Permission setting of a help center */
    permissionSettings?: Maybe<HelpCenterPermissionSettingsResult>;
    /** Portals of the HelpCenter */
    portals?: Maybe<HelpCenterPortals>;
    /** Project mapping Data. */
    projectMappingData?: Maybe<HelpCenterProjectMappingData>;
    /** Site default locale */
    siteDefaultLanguageTag?: Maybe<Scalars["String"]["output"]>;
    /**
     *  Slug(identifier in the url) of the helpcenter. This may be null for the basic Help Center.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterSlugTest")' query directive to the 'slug' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    slug?: Maybe<Scalars["String"]["output"]>;
    topics?: Maybe<Array<HelpCenterTopic>>;
    /**
     *  Represent type of help center (null means Basic/default)
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterTypeTest")' query directive to the 'type' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    type?: Maybe<HelpCenterType>;
    /** User locale */
    userLanguageTag?: Maybe<Scalars["String"]["output"]>;
    /** Virtual Service Agent features configured/available, and thus can be toggled on */
    virtualAgentAvailable?: Maybe<Scalars["Boolean"]["output"]>;
    /** whether Virtual Agent is enabled for HelpCenter */
    virtualAgentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type HelpCenterPortalsArgs = {
    portalsFilter?: InputMaybe<HelpCenterPortalFilter>;
    sortOrder?: InputMaybe<HelpCenterPortalsSortOrder>;
};

export enum HelpCenterAccessControlType {
    /** Help center is accessible to external customers */
    External = "EXTERNAL",
    /** Help center is accessible to specific groups */
    GroupBased = "GROUP_BASED",
    /** Help center is accessible to internal customers */
    Internal = "INTERNAL",
    /** Help center is accessible to all */
    Public = "PUBLIC"
}

export type HelpCenterAnnouncement = {
    __typename?: "HelpCenterAnnouncement";
    /** Description of HelpCenter announcement in converted format */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Translation of HelpCenter announcement description */
    descriptionTranslationsRaw?: Maybe<Array<HelpCenterTranslation>>;
    /** Type in which HelpCenter announcement is stored */
    descriptionType?: Maybe<HelpCenterDescriptionType>;
    /** Name of HelpCenter announcement in converted format */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Translation of HelpCenter announcement name */
    nameTranslationsRaw?: Maybe<Array<HelpCenterTranslation>>;
};

export type HelpCenterAnnouncementInput = {
    /** Description and its all translations in raw format */
    descriptionTranslations?: InputMaybe<Array<HelpCenterTranslationInput>>;
    /** Type in which announcements are stored */
    descriptionType: HelpCenterDescriptionType;
    /** HelpCenterARI can be used to get the correct help center node */
    helpCenterAri: Scalars["String"]["input"];
    /** Name and its all translations in raw format */
    nameTranslations?: InputMaybe<Array<HelpCenterTranslationInput>>;
};

export type HelpCenterAnnouncementResult = {
    __typename?: "HelpCenterAnnouncementResult";
    /** Description of HelpCenter announcement in converted format */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Name of HelpCenter announcement in converted format */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterAnnouncementUpdatePayload = Payload & {
    __typename?: "HelpCenterAnnouncementUpdatePayload";
    /** Announcement details for user default language in case of successful mutation */
    announcementResult?: Maybe<HelpCenterAnnouncementResult>;
    /** The list of errors occurred during updating the Portals Configuration */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterAnnouncements = {
    __typename?: "HelpCenterAnnouncements";
    /** Whether user can edit announcement */
    canEditHomePageAnnouncement?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether user can edit announcement */
    canEditLoginAnnouncement?: Maybe<Scalars["Boolean"]["output"]>;
    /** Home page Announcement of the help center */
    homePageAnnouncements?: Maybe<Array<HelpCenterAnnouncement>>;
    /** Login Announcement of the help center */
    loginAnnouncements?: Maybe<Array<HelpCenterAnnouncement>>;
};

export type HelpCenterBanner = {
    __typename?: "HelpCenterBanner";
    fileId?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterBannerInput = {
    filedId?: InputMaybe<Scalars["String"]["input"]>;
    useDefaultBanner?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HelpCenterBranding = {
    __typename?: "HelpCenterBranding";
    /** Banner of the Help Center */
    banner?: Maybe<HelpCenterBanner>;
    /** Brand colors of the Help Center */
    colors?: Maybe<HelpCenterBrandingColors>;
    /** Is the top bar been split or not */
    hasTopBarBeenSplit?: Maybe<Scalars["Boolean"]["output"]>;
    /** Title of the Help Center */
    homePageTitle?: Maybe<HelpCenterHomePageTitle>;
    /** Whether banner is available for the Help Center */
    isBannerAvailable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether logo is available for the Help Center */
    isLogoAvailable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Logo of Help Center */
    logo?: Maybe<HelpCenterLogo>;
    /** Whether to use the default banner or not */
    useDefaultBanner?: Maybe<Scalars["Boolean"]["output"]>;
};

export type HelpCenterBrandingColors = {
    __typename?: "HelpCenterBrandingColors";
    /** Banner text color of the Help Center */
    bannerTextColor?: Maybe<Scalars["String"]["output"]>;
    /** Is the top bar been split or not */
    hasTopBarBeenSplit: Scalars["Boolean"]["output"];
    /** primary brand color of the Help Center */
    primary?: Maybe<Scalars["String"]["output"]>;
    /** primary color of the Top Bar */
    topBarColor?: Maybe<Scalars["String"]["output"]>;
    /** Top bar text color */
    topBarTextColor?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterBrandingColorsInput = {
    /** Banner text color of the Help Center */
    bannerTextColor?: InputMaybe<Scalars["String"]["input"]>;
    /** primary brand color of the Help Center */
    primary?: InputMaybe<Scalars["String"]["input"]>;
    /** primary color of the Top Bar */
    topBarColor?: InputMaybe<Scalars["String"]["input"]>;
    /** Top bar text color */
    topBarTextColor?: InputMaybe<Scalars["String"]["input"]>;
};

export type HelpCenterBrandingInput = {
    banner?: InputMaybe<HelpCenterBannerInput>;
    /** Brand colors of the Help Center */
    colors?: InputMaybe<HelpCenterBrandingColorsInput>;
    /** Title of the Help Center */
    homePageTitle?: InputMaybe<HelpCenterHomePageTitleInput>;
    /** Logo of Help Center */
    logo?: InputMaybe<HelpCenterLogoInput>;
};

export type HelpCenterBulkCreateTopicsInput = {
    /** Actual set of topics to be created in the given help center */
    helpCenterCreateTopicInputItem: Array<HelpCenterCreateTopicInput>;
};

export type HelpCenterBulkDeleteTopicInput = {
    helpCenterTopicDeleteInput: Array<HelpCenterTopicDeleteInput>;
};

export type HelpCenterBulkUpdateTopicInput = {
    /** The new updated topic for the given help center */
    helpCenterUpdateTopicInputItem: Array<HelpCenterUpdateTopicInput>;
};

export type HelpCenterContentGapIndicator = {
    __typename?: "HelpCenterContentGapIndicator";
    /** Content gap cluster Id */
    clusterId: Scalars["ID"]["output"];
    /** List of all relevant content gap keywords clustered together */
    keywords: Scalars["String"]["output"];
    /** Number of questions that are relevant to the content gap keywords */
    questionsCount: Scalars["Int"]["output"];
};

export type HelpCenterContentGapIndicatorsWithMetaData = {
    __typename?: "HelpCenterContentGapIndicatorsWithMetaData";
    /** List of all content gap indicators for Reporting */
    contentGapIndicators?: Maybe<Array<HelpCenterContentGapIndicator>>;
};

/**
 * #########################
 *  Mutation Inputs
 * #########################
 */
export type HelpCenterCreateInput = {
    /** Name of the help center. */
    name: HelpCenterNameInput;
    /** Slug of the help center. */
    slug: Scalars["String"]["input"];
    /** workspaceARI can be used to get the correct help center node */
    workspaceARI: Scalars["String"]["input"];
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type HelpCenterCreatePayload = Payload & {
    __typename?: "HelpCenterCreatePayload";
    /** The list of errors occurred during creating the helpCenter */
    errors?: Maybe<Array<MutationError>>;
    /** Ari of the help center to be created in async */
    helpCenterAri?: Maybe<Scalars["String"]["output"]>;
    /** The result of whether helpCenter is created successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterCreateTopicInput = {
    /** Description about the topic as visible on help center page */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** HelpCenterARI can be used to retrieve helpCenterId */
    helpCenterAri?: InputMaybe<Scalars["String"]["input"]>;
    /** The help objects ARI which this topic contains */
    items: Array<HelpCenterTopicItemInput>;
    /** Name about the topic as visible on the help center page */
    name: Scalars["String"]["input"];
    /** The id of help center where the topics needs to be created */
    productName?: InputMaybe<Scalars["String"]["input"]>;
    /**
     *  This includes additional properties to the topics.
     * Such as whether the topic is visible to the helpseekers on help center or not etc.
     */
    properties?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type HelpCenterCreateTopicPayload = Payload & {
    __typename?: "HelpCenterCreateTopicPayload";
    /** The list of errors occurred during creating the topics */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
    /** Help center Ids along with their topic ids saved in store. Would be empty if the operation was not successful */
    successfullyCreatedTopicIds: Array<
        Maybe<HelpCenterSuccessfullyCreatedTopicIds>
    >;
};

export type HelpCenterDeleteInput = {
    /** HelpCenterARI can be used to get the correct help center node */
    helpCenterAri: Scalars["String"]["input"];
};

export type HelpCenterDeletePayload = Payload & {
    __typename?: "HelpCenterDeletePayload";
    /** The list of errors occurred during deleting the help center */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterDeleteUpdateTopicPayload = Payload & {
    __typename?: "HelpCenterDeleteUpdateTopicPayload";
    /** The list of errors occurred during deleting or updating the topics */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
    /** Help center Ids along with their topic properties deleted or updated in store. Would be empty if the operation was not successful */
    topicIds: Array<Maybe<HelpCenterSuccessfullyDeletedUpdatedTopicIds>>;
};

export enum HelpCenterDescriptionType {
    PlainText = "PLAIN_TEXT",
    RichText = "RICH_TEXT",
    WikiMarkup = "WIKI_MARKUP"
}

export type HelpCenterHelpObject =
    | HelpObjectStoreArticle
    | HelpObjectStoreChannel
    | HelpObjectStoreQueryError
    | HelpObjectStoreRequestForm;

export type HelpCenterHomePageLayout = {
    __typename?: "HelpCenterHomePageLayout";
    data?: Maybe<HelpLayoutResult>;
    layoutId: Scalars["ID"]["output"];
};

export type HelpCenterHomePageTitle = {
    __typename?: "HelpCenterHomePageTitle";
    /** Default name of the helpcenter. */
    default: Scalars["String"]["output"];
    /** Translations of title of the helpcenter. */
    translations?: Maybe<Array<Maybe<HelpCenterTranslation>>>;
};

export type HelpCenterHomePageTitleInput = {
    /** Default name of the helpcenter. */
    default: Scalars["String"]["input"];
    /** Translations of title the helpcenter. */
    translations?: InputMaybe<Array<InputMaybe<HelpCenterTranslationInput>>>;
};

export type HelpCenterLogo = {
    __typename?: "HelpCenterLogo";
    fileId?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterLogoInput = {
    fileId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Media config provides auth credentials and relevant information to upload images for media related elements. */
export type HelpCenterMediaConfig = {
    __typename?: "HelpCenterMediaConfig";
    asapIssuer?: Maybe<Scalars["String"]["output"]>;
    mediaCollectionName?: Maybe<Scalars["String"]["output"]>;
    mediaToken?: Maybe<Scalars["String"]["output"]>;
    mediaUrl?: Maybe<Scalars["String"]["output"]>;
};

/** This describes the type of operation for which mediaConfig needs to be generated */
export enum HelpCenterMediaConfigOperationType {
    /** indicates banner upload */
    BannerUpload = "BANNER_UPLOAD",
    /** indicates logo upload */
    LogoUpload = "LOGO_UPLOAD"
}

export type HelpCenterMutationApi = {
    __typename?: "HelpCenterMutationApi";
    /**
     * This is to create a multi HC
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createHelpCenter?: Maybe<HelpCenterCreatePayload>;
    /**
     * This is to create or clone a Help center page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createHelpCenterPage?: Maybe<HelpCenterPageCreatePayload>;
    /**
     * This is to create new topics to the help center. Can create multiple topics to multiple help centers using this mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createTopic?: Maybe<HelpCenterCreateTopicPayload>;
    /**
     * This is to delete a multi help center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteHelpCenter?: Maybe<HelpCenterDeletePayload>;
    /**
     * This is to delete a help center page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteHelpCenterPage?: Maybe<HelpCenterPageDeletePayload>;
    /**
     * This is to delete existing topics to the help centers. Can delete multiple topics to multiple help centers using this mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteTopic?: Maybe<HelpCenterDeleteUpdateTopicPayload>;
    /**
     * This is to update help center. Can update few properties in help center using this mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateHelpCenter?: Maybe<HelpCenterUpdatePayload>;
    /**
     * This is to update a Help center page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateHelpCenterPage?: Maybe<HelpCenterPageUpdatePayload>;
    /**
     * This is to update the permissions of a help center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateHelpCenterPermissionSettings?: Maybe<HelpCenterPermissionSettingsPayload>;
    /**
     * This is to update home page announcement for the helpcenter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateHomePageAnnouncement?: Maybe<HelpCenterAnnouncementUpdatePayload>;
    /**
     * This is to update login announcement for the helpcenter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateLoginAnnouncement?: Maybe<HelpCenterAnnouncementUpdatePayload>;
    /**
     * This is to update portals related configs such as hidden/featured etc
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updatePortalsConfiguration?: Maybe<HelpCenterPortalsConfigurationUpdatePayload>;
    /**
     * This is to update project mapping for Help centre - will also sync all Help centre data to the mapped projects
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateProjectMapping?: Maybe<HelpCenterProjectMappingUpdatePayload>;
    /**
     * This is to update topics to the help centers. Can update multiple topics to multiple help centers using this mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateTopic?: Maybe<HelpCenterDeleteUpdateTopicPayload>;
    /**
     * This is to sort the existing topics in the custom order. Input contains the topic ids in the order you want to sort the topics
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: HelpCenterReorderTopics` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateTopicsOrder?: Maybe<HelpCenterUpdateTopicsOrderPayload>;
};

export type HelpCenterMutationApiCreateHelpCenterArgs = {
    input: HelpCenterCreateInput;
};

export type HelpCenterMutationApiCreateHelpCenterPageArgs = {
    input: HelpCenterPageCreateInput;
};

export type HelpCenterMutationApiCreateTopicArgs = {
    input: HelpCenterBulkCreateTopicsInput;
};

export type HelpCenterMutationApiDeleteHelpCenterArgs = {
    input: HelpCenterDeleteInput;
};

export type HelpCenterMutationApiDeleteHelpCenterPageArgs = {
    input: HelpCenterPageDeleteInput;
};

export type HelpCenterMutationApiDeleteTopicArgs = {
    input: HelpCenterBulkDeleteTopicInput;
};

export type HelpCenterMutationApiUpdateHelpCenterArgs = {
    input: HelpCenterUpdateInput;
};

export type HelpCenterMutationApiUpdateHelpCenterPageArgs = {
    input: HelpCenterPageUpdateInput;
};

export type HelpCenterMutationApiUpdateHelpCenterPermissionSettingsArgs = {
    input: HelpCenterPermissionSettingsInput;
};

export type HelpCenterMutationApiUpdateHomePageAnnouncementArgs = {
    input: HelpCenterAnnouncementInput;
};

export type HelpCenterMutationApiUpdateLoginAnnouncementArgs = {
    input: HelpCenterAnnouncementInput;
};

export type HelpCenterMutationApiUpdatePortalsConfigurationArgs = {
    input: HelpCenterPortalsConfigurationUpdateInput;
};

export type HelpCenterMutationApiUpdateProjectMappingArgs = {
    input: HelpCenterProjectMappingUpdateInput;
};

export type HelpCenterMutationApiUpdateTopicArgs = {
    input: HelpCenterBulkUpdateTopicInput;
};

export type HelpCenterMutationApiUpdateTopicsOrderArgs = {
    input: HelpCenterUpdateTopicsOrderInput;
};

export type HelpCenterName = {
    __typename?: "HelpCenterName";
    /** Default name of the helpcenter. */
    default: Scalars["String"]["output"];
    /** Translations of name of the helpcenter. */
    translations?: Maybe<Array<Maybe<HelpCenterTranslation>>>;
};

export type HelpCenterNameInput = {
    /** Default name of the helpcenter to be updated */
    default: Scalars["String"]["input"];
    /** Translations of description the helpcenter. */
    translations?: InputMaybe<Array<InputMaybe<HelpCenterTranslationInput>>>;
};

export type HelpCenterPage = Node & {
    __typename?: "HelpCenterPage";
    /** Timestamp of page creation */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /** Description of the helpcenter page. */
    description?: Maybe<HelpCenterPageDescription>;
    /** ARI of the Help center, this page belong to */
    helpCenterAri: Scalars["ID"]["output"];
    id: Scalars["ID"]["output"];
    /** Name of the helpcenter page. */
    name?: Maybe<HelpCenterPageName>;
    /** Layout associated with the Help center page */
    pageLayout?: Maybe<HelpCenterPageLayout>;
    /** Timestamp of latest update */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterPageCreateInput = {
    /** Ari of existing page, if page is being cloned */
    clonePageAri?: InputMaybe<Scalars["String"]["input"]>;
    /** Description of the help center page. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** helpCenterAri for the Help center under which page is being created */
    helpCenterAri: Scalars["String"]["input"];
    /** Name of the help center page. */
    name: Scalars["String"]["input"];
};

export type HelpCenterPageCreatePayload = Payload & {
    __typename?: "HelpCenterPageCreatePayload";
    /** The list of errors occurred during creating the helpCenter page */
    errors?: Maybe<Array<MutationError>>;
    /** created help center page */
    helpCenterPage?: Maybe<HelpCenterPage>;
    /** The result of whether helpCenter page is created successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterPageDeleteInput = {
    /** HelpCenterARI can be used to get the correct help center node */
    helpCenterPageAri: Scalars["String"]["input"];
};

export type HelpCenterPageDeletePayload = Payload & {
    __typename?: "HelpCenterPageDeletePayload";
    /** The list of errors occurred during deleting the help center page */
    errors?: Maybe<Array<MutationError>>;
    /** ari for the deleted help center page */
    helpCenterPageAri?: Maybe<Scalars["ID"]["output"]>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterPageDescription = {
    __typename?: "HelpCenterPageDescription";
    /** Default description of the help center page. */
    default?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterPageLayout = {
    __typename?: "HelpCenterPageLayout";
    layoutAri: Scalars["ID"]["output"];
};

export type HelpCenterPageName = {
    __typename?: "HelpCenterPageName";
    /** Default Name of the helpcenter page. */
    default: Scalars["String"]["output"];
};

export type HelpCenterPageQueryResult = HelpCenterPage | QueryError;

export type HelpCenterPageQueryResultConnection = {
    __typename?: "HelpCenterPageQueryResultConnection";
    edges?: Maybe<Array<HelpCenterPageQueryResultEdge>>;
    nodes?: Maybe<Array<HelpCenterPageQueryResult>>;
    pageInfo?: Maybe<PageInfo>;
};

export type HelpCenterPageQueryResultEdge = {
    __typename?: "HelpCenterPageQueryResultEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<HelpCenterPageQueryResult>;
};

export enum HelpCenterPageType {
    /** indicates Custom help center page */
    Custom = "CUSTOM"
}

export type HelpCenterPageUpdateInput = {
    /** Description of the help center page. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** helpCenterPageAri for the Help center page being updated */
    helpCenterPageAri: Scalars["String"]["input"];
    /** Name of the help center page. */
    name: Scalars["String"]["input"];
};

export type HelpCenterPageUpdatePayload = Payload & {
    __typename?: "HelpCenterPageUpdatePayload";
    /** The list of errors occurred during updating the helpcenter page */
    errors?: Maybe<Array<MutationError>>;
    /** updated help center page */
    helpCenterPage?: Maybe<HelpCenterPage>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterPermissionSettings = {
    __typename?: "HelpCenterPermissionSettings";
    /** Type of access control for Help Center */
    accessControlType: HelpCenterAccessControlType;
    /** List of groups that have access to Help Center */
    allowedAccessGroups?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Hydrated list of groups that have access to Help Center */
    hydratedAllowedAccessGroups?: Maybe<JiraServiceManagementOrganizationConnection>;
};

export type HelpCenterPermissionSettingsInput = {
    /** Type of access control for Help Center */
    accessControlType: HelpCenterAccessControlType;
    /** List of groups that needs to be added for Help Center access */
    addedAllowedAccessGroups?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** List of groups whose access to Help Center needs to be deleted */
    deletedAllowedAccessGroups?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** HelpCenterARI can be used to get the correct help center node */
    helpCenterAri: Scalars["String"]["input"];
};

export type HelpCenterPermissionSettingsPayload = Payload & {
    __typename?: "HelpCenterPermissionSettingsPayload";
    /** The list of errors occurred during updating the help center permissions */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterPermissionSettingsResult =
    | HelpCenterPermissionSettings
    | QueryError;

export type HelpCenterPortal = {
    __typename?: "HelpCenterPortal";
    /** Description of Help Center Portals */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Id of Help Center Portals */
    id: Scalars["String"]["output"];
    /** Tells whether the portals is featured or not */
    isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
    /** Tells whether the portals is hidden or not */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /** Key of Help Center Portals */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Logo URL of Help Center Portals */
    logoUrl?: Maybe<Scalars["String"]["output"]>;
    /** Name of Help Center Portals */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Base URL of Help Center Portals */
    portalBaseUrl?: Maybe<Scalars["String"]["output"]>;
    /** Project type of the parent Jira project */
    projectType?: Maybe<HelpCenterProjectType>;
    /** Tells the rank of portal if it is featured. The value will be -1 for non-featured portals */
    rank?: Maybe<Scalars["Int"]["output"]>;
};

export type HelpCenterPortalFilter = {
    /** Give a list of type of portals to be given */
    typeFilter?: InputMaybe<Array<HelpCenterPortalsType>>;
};

export type HelpCenterPortalMetaData = {
    __typename?: "HelpCenterPortalMetaData";
    /** Portal Id. */
    portalId: Scalars["String"]["output"];
};

export type HelpCenterPortals = {
    __typename?: "HelpCenterPortals";
    /** List of Help Center Portals */
    portalsList?: Maybe<Array<HelpCenterPortal>>;
    /** Sort order of Help Center Portals */
    sortOrder?: Maybe<HelpCenterPortalsSortOrder>;
};

export type HelpCenterPortalsConfigurationUpdateInput = {
    /** List of final featured portals. Max limit is 15 */
    featuredPortals: Array<Scalars["String"]["input"]>;
    /** HelpCenterARI can be used to get the correct help center node */
    helpCenterAri: Scalars["String"]["input"];
    /** List of hidden portals. */
    hiddenPortals: Array<Scalars["String"]["input"]>;
    /** Sorting order of portals */
    sortOrder: HelpCenterPortalsSortOrder;
};

export type HelpCenterPortalsConfigurationUpdatePayload = Payload & {
    __typename?: "HelpCenterPortalsConfigurationUpdatePayload";
    /** The list of errors occurred during updating the Portals Configuration */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export enum HelpCenterPortalsSortOrder {
    NameAscending = "NAME_ASCENDING",
    Popularity = "POPULARITY"
}

export enum HelpCenterPortalsType {
    /** Featured Portals */
    Featured = "FEATURED",
    /** Hidden Portals */
    Hidden = "HIDDEN",
    /** Visible Portals */
    Visible = "VISIBLE"
}

export type HelpCenterProjectMappingData = {
    __typename?: "HelpCenterProjectMappingData";
    /** Mapping of project IDs to their associated portal metadata. */
    projectMapping?: Maybe<Array<HelpCenterProjectMappingEntry>>;
    /** A newly created project is automatically mapped to this helpCenter if turned on. */
    syncNewProjects?: Maybe<Scalars["Boolean"]["output"]>;
};

export type HelpCenterProjectMappingEntry = {
    __typename?: "HelpCenterProjectMappingEntry";
    /** Corresponding Portal Metadata. */
    portalMetadata: HelpCenterPortalMetaData;
    /** Project Id. */
    projectId: Scalars["String"]["output"];
};

export enum HelpCenterProjectMappingOperationType {
    /** Indicates the mapping of projects to Help Center */
    MapProjects = "MAP_PROJECTS",
    /** Indicates the un-mapping of projects to a Help Center */
    UnmapProjects = "UNMAP_PROJECTS"
}

export type HelpCenterProjectMappingUpdateInput = {
    /** HelpCenterARI can be used to get the correct help center node */
    helpCenterAri: Scalars["String"]["input"];
    /** Operation to be performed on provided projectsIds */
    operationType?: InputMaybe<HelpCenterProjectMappingOperationType>;
    /** List of project Ids to be linked or un-linked based on the operationType */
    projectIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Automatically map newly created projects to this Help center */
    syncNewProjects?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HelpCenterProjectMappingUpdatePayload = Payload & {
    __typename?: "HelpCenterProjectMappingUpdatePayload";
    /** The list of errors occurred during updating the Portals Configuration */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export enum HelpCenterProjectType {
    CustomerService = "CUSTOMER_SERVICE",
    ServiceDesk = "SERVICE_DESK"
}

/** All available queries on help center service */
export type HelpCenterQueryApi = {
    __typename?: "HelpCenterQueryApi";
    /**
     *  Retrieve a help center for a given project ID (DEPRECATED)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterAggBeta")' query directive to the 'helpCenterByHoistedProjectId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpCenterByHoistedProjectId?: Maybe<HelpCenterQueryResult>;
    /**
     *  Retrieve a help center for a given project ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterAggBeta")' query directive to the 'helpCenterByHoistedProjectIdRouted' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpCenterByHoistedProjectIdRouted?: Maybe<HelpCenterQueryResult>;
    /**
     *  Retrieve all data for help center for given help center ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterAggBeta")' query directive to the 'helpCenterById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpCenterById?: Maybe<HelpCenterQueryResult>;
    /**
     *  Retrieve page of a help centers by Id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCenterPageById?: Maybe<HelpCenterPageQueryResult>;
    /**
     *  Retrieve paginated list of help centers for a given Cloud ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCenterPages?: Maybe<HelpCenterPageQueryResultConnection>;
    /**
     *  Retrieve permissions for a given help center ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCenterPermissionSettings?: Maybe<HelpCenterPermissionSettingsResult>;
    /**
     *  Retrieves all help center reporting metrics for a given help center ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCenterReportingById?: Maybe<HelpCenterReportingResult>;
    /**
     *  Retrieve a particular topic given it's ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpCenterAggBeta")' query directive to the 'helpCenterTopicById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpCenterTopicById?: Maybe<HelpCenterTopicResult>;
    /**
     *  Retrieve paginated list of help centers for a given Cloud ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCenters?: Maybe<HelpCenterQueryResultConnection>;
    /**
     *  Retrieve list of help centers associated with a projectId
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCentersByProjectId?: Maybe<HelpCenterQueryResultConnection>;
    /**
     *  Retrieves all the configs related to multi help center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCentersConfig?: Maybe<HelpCentersConfigResult>;
    /**
     *  Retrieve list of help centers for a given Cloud ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    helpCentersList?: Maybe<HelpCentersListQueryResult>;
    /**
     *  Retrieves media token and other auth details for a given help center ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaConfig?: Maybe<HelpCenterMediaConfig>;
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterByHoistedProjectIdArgs = {
    projectAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterByHoistedProjectIdRoutedArgs = {
    projectAri: Scalars["ID"]["input"];
    workspaceAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterByIdArgs = {
    helpCenterAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterPageByIdArgs = {
    helpCenterPageAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterPagesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    helpCenterAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterPermissionSettingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    helpCenterAri: Scalars["ID"]["input"];
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterReportingByIdArgs = {
    helpCenterAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCenterTopicByIdArgs = {
    helpCenterAri: Scalars["ID"]["input"];
    topicId: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCentersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder: HelpCenterSortOrder;
    workspaceAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCentersByProjectIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectId: Scalars["String"]["input"];
    sortOrder: HelpCenterSortOrder;
    workspaceAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCentersConfigArgs = {
    workspaceAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiHelpCentersListArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder: HelpCenterSortOrder;
    workspaceAri: Scalars["ID"]["input"];
};

/** All available queries on help center service */
export type HelpCenterQueryApiMediaConfigArgs = {
    helpCenterAri: Scalars["ID"]["input"];
    operationType?: InputMaybe<HelpCenterMediaConfigOperationType>;
};

export type HelpCenterQueryResult = HelpCenter | QueryError;

/**
 * #########################
 *  Base objects for help-center
 * #########################
 */
export type HelpCenterQueryResultConnection = {
    __typename?: "HelpCenterQueryResultConnection";
    edges?: Maybe<Array<HelpCenterQueryResultEdge>>;
    nodes?: Maybe<Array<HelpCenterQueryResult>>;
    pageInfo: PageInfo;
};

export type HelpCenterQueryResultEdge = {
    __typename?: "HelpCenterQueryResultEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<HelpCenterQueryResult>;
};

export type HelpCenterReporting = {
    __typename?: "HelpCenterReporting";
    /** List of all content gap indicators with metadata for Reporting */
    contentGapIndicatorsWithMetaData?: Maybe<HelpCenterContentGapIndicatorsWithMetaData>;
    /** Help Center Id */
    helpCenterId: Scalars["ID"]["output"];
    /** List of all performance indicators with metadata for Reporting */
    performanceIndicatorsWithMetaData?: Maybe<HelpCenterReportingPerformanceIndicatorsWithMetaData>;
};

export type HelpCenterReportingPerformanceIndicator = {
    __typename?: "HelpCenterReportingPerformanceIndicator";
    /** Current value of the performance indicator */
    currentValue: Scalars["String"]["output"];
    /** Name of the performance indicator */
    name: Scalars["String"]["output"];
    /** Previous value of the performance indicator past the time window */
    previousValue?: Maybe<Scalars["String"]["output"]>;
    /** Time window for the performance indicator */
    timeWindow?: Maybe<Scalars["String"]["output"]>;
};

export type HelpCenterReportingPerformanceIndicatorsWithMetaData = {
    __typename?: "HelpCenterReportingPerformanceIndicatorsWithMetaData";
    /** List of all performance indicators for Reporting */
    performanceIndicators?: Maybe<
        Array<HelpCenterReportingPerformanceIndicator>
    >;
    /** Time at which the help center reporting was last updated */
    refreshedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type HelpCenterReportingResult = HelpCenterReporting | QueryError;

export enum HelpCenterSortOrder {
    CreatedDateAscending = "CREATED_DATE_ASCENDING",
    CreatedDateDescending = "CREATED_DATE_DESCENDING"
}

export type HelpCenterSuccessfullyCreatedTopicIds = {
    __typename?: "HelpCenterSuccessfullyCreatedTopicIds";
    helpCenterId: Scalars["ID"]["output"];
    topicIds: Scalars["ID"]["output"];
};

export type HelpCenterSuccessfullyDeletedUpdatedTopicIds = {
    __typename?: "HelpCenterSuccessfullyDeletedUpdatedTopicIds";
    helpCenterId: Scalars["ID"]["output"];
    topicIds: Scalars["ID"]["output"];
};

export type HelpCenterTopic = {
    __typename?: "HelpCenterTopic";
    /** Description of topic */
    description?: Maybe<Scalars["String"]["output"]>;
    /** This contains all help objects of the topic. */
    items?: Maybe<HelpCenterTopicItemConnection>;
    /** Name of topic */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *  This includes additional properties to the topics.
     * Such as whether the topic is visible to the helpseekers on help center or not etc.
     */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    topicId: Scalars["ID"]["output"];
};

export type HelpCenterTopicItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type HelpCenterTopicDeleteInput = {
    /** HelpCenterARI can be used to retrieve helpCenterId */
    helpCenterAri?: InputMaybe<Scalars["String"]["input"]>;
    /** The id of help center where the topic that needs to be deleted is part of */
    productName?: InputMaybe<Scalars["String"]["input"]>;
    /** The id of the topic which needs to be deleted */
    topicId: Scalars["ID"]["input"];
};

export type HelpCenterTopicItem = {
    __typename?: "HelpCenterTopicItem";
    /** ARI of help object */
    ari: Scalars["ID"]["output"];
    data?: Maybe<HelpCenterHelpObject>;
};

export type HelpCenterTopicItemConnection = {
    __typename?: "HelpCenterTopicItemConnection";
    edges?: Maybe<Array<Maybe<HelpCenterTopicItemEdge>>>;
    nodes?: Maybe<Array<Maybe<HelpCenterTopicItem>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type HelpCenterTopicItemEdge = {
    __typename?: "HelpCenterTopicItemEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<HelpCenterTopicItem>;
};

export type HelpCenterTopicItemInput = {
    /** ARI of the help object which is included in this topic */
    ari: Scalars["ID"]["input"];
};

export type HelpCenterTopicResult = HelpCenterTopic | QueryError;

export type HelpCenterTranslation = {
    __typename?: "HelpCenterTranslation";
    /** Locale key of the Translation */
    locale: Scalars["String"]["output"];
    /** Locale display Name of the Translation */
    localeDisplayName: Scalars["String"]["output"];
    /** Value of the Translation */
    value: Scalars["String"]["output"];
};

export type HelpCenterTranslationInput = {
    locale: Scalars["String"]["input"];
    localeDisplayName?: InputMaybe<Scalars["String"]["input"]>;
    value: Scalars["String"]["input"];
};

export enum HelpCenterType {
    /** indicates Advanced help center */
    Advanced = "ADVANCED",
    /** indicates Basic help center */
    Basic = "BASIC",
    /** indicates Customer Service help center */
    CustomerService = "CUSTOMER_SERVICE",
    /** indicates Unified help center */
    Unified = "UNIFIED"
}

export type HelpCenterUpdateInput = {
    /** HelpCenterARI can be used to get the correct helpCenter node */
    helpCenterAri: Scalars["String"]["input"];
    /** Branding of the help center */
    helpCenterBranding?: InputMaybe<HelpCenterBrandingInput>;
    /** Name of the helpcenter */
    name?: InputMaybe<HelpCenterNameInput>;
    /** Slug(identifier in the url) of the helpcenter. */
    slug?: InputMaybe<Scalars["String"]["input"]>;
    /** whether Virtual Agent is enabled for HelpCenter */
    virtualAgentEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HelpCenterUpdatePayload = Payload & {
    __typename?: "HelpCenterUpdatePayload";
    /** The list of errors occurred during updating the helpcenter */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCenterUpdateTopicInput = {
    /** Description of the topic */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** HelpCenterARI can be used to retrieve helpCenterId */
    helpCenterAri?: InputMaybe<Scalars["String"]["input"]>;
    /** The set of ARIs which this topic contains. */
    items: Array<HelpCenterTopicItemInput>;
    /** Name of the topic */
    name: Scalars["String"]["input"];
    /** The id of help center where the topic that needs to be update is part of */
    productName?: InputMaybe<Scalars["String"]["input"]>;
    /** Additional properties of topics. Such as whether the topic is visible to the helpseekers on help center or not etc. */
    properties?: InputMaybe<Scalars["JSON"]["input"]>;
    /** The id of the already created topic */
    topicId: Scalars["ID"]["input"];
};

export type HelpCenterUpdateTopicsOrderInput = {
    /** HelpCenterARI can be used to retrieve helpCenterId */
    helpCenterAri?: InputMaybe<Scalars["String"]["input"]>;
    /** The id of help center where the topic that needs to be reordered is part of */
    productName?: InputMaybe<Scalars["String"]["input"]>;
    /** The set of ids in the order you want them to be sorted */
    topicIds: Array<Scalars["ID"]["input"]>;
};

export type HelpCenterUpdateTopicsOrderPayload = Payload & {
    __typename?: "HelpCenterUpdateTopicsOrderPayload";
    /** The list of errors occurred during updating the topics */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not */
    success: Scalars["Boolean"]["output"];
};

export type HelpCentersConfig = {
    __typename?: "HelpCentersConfig";
    /** Multi Help center is enabled on a tenant or not */
    isEnabled: Scalars["Boolean"]["output"];
};

export type HelpCentersConfigResult = HelpCentersConfig | QueryError;

export type HelpCentersListQueryResult =
    | HelpCenterQueryResultConnection
    | QueryError;

export type HelpExternalResource = Node & {
    __typename?: "HelpExternalResource";
    /** The container ATI */
    containerAti: Scalars["String"]["output"];
    /** The containerId */
    containerId: Scalars["String"]["output"];
    /** Created At */
    created: Scalars["String"]["output"];
    /** The description */
    description: Scalars["String"]["output"];
    /** The external resource ID */
    id: Scalars["ID"]["output"];
    /** The external resource link */
    link: Scalars["String"]["output"];
    /** The resource type of the external resource */
    resourceType: HelpExternalResourceLinkResourceType;
    /** The external resource title */
    title: Scalars["String"]["output"];
    /** Updated At */
    updated: Scalars["String"]["output"];
};

export type HelpExternalResourceCreateInput = {
    /** The container ATI */
    containerAti: Scalars["String"]["input"];
    /** The containerId */
    containerId: Scalars["String"]["input"];
    /** The description */
    description: Scalars["String"]["input"];
    /** The external resource link */
    link: Scalars["String"]["input"];
    /** The resource type of the external resource */
    resourceType: HelpExternalResourceLinkResourceType;
    /** The external resource title */
    title: Scalars["String"]["input"];
};

export type HelpExternalResourceEdge = {
    __typename?: "HelpExternalResourceEdge";
    /** The cursor of the current edge */
    cursor: Scalars["String"]["output"];
    /** The external resource */
    node?: Maybe<HelpExternalResource>;
};

export enum HelpExternalResourceLinkResourceType {
    Channel = "CHANNEL",
    Knowledge = "KNOWLEDGE",
    RequestForm = "REQUEST_FORM"
}

/** Mutation */
export type HelpExternalResourceMutationApi = {
    __typename?: "HelpExternalResourceMutationApi";
    /**
     *  Create external resource
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createExternalResource?: Maybe<HelpExternalResourcePayload>;
    /**
     *  Delete external resource
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteExternalResource?: Maybe<HelpExternalResourcePayload>;
    /**
     *  Update external resource
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateExternalResource?: Maybe<HelpExternalResourcePayload>;
};

/** Mutation */
export type HelpExternalResourceMutationApiCreateExternalResourceArgs = {
    input: HelpExternalResourceCreateInput;
};

/** Mutation */
export type HelpExternalResourceMutationApiDeleteExternalResourceArgs = {
    id: Scalars["ID"]["input"];
};

/** Mutation */
export type HelpExternalResourceMutationApiUpdateExternalResourceArgs = {
    input: HelpExternalResourceUpdateInput;
};

export type HelpExternalResourcePayload = Payload & {
    __typename?: "HelpExternalResourcePayload";
    /** error */
    errors?: Maybe<Array<MutationError>>;
    /** The External Resource */
    externalResource?: Maybe<HelpExternalResource>;
    /** True if success */
    success: Scalars["Boolean"]["output"];
};

/** Query Types */
export type HelpExternalResourceQueryApi = {
    __typename?: "HelpExternalResourceQueryApi";
    /**
     *  To fetch External Resources by containerKey and containerAti
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    getExternalResources?: Maybe<HelpExternalResourcesResult>;
};

/** Query Types */
export type HelpExternalResourceQueryApiGetExternalResourcesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    containerAti: Scalars["String"]["input"];
    containerId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type HelpExternalResourceQueryError = {
    __typename?: "HelpExternalResourceQueryError";
    /** Use this to put extra data on the error if required */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /** A message describing the error */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type HelpExternalResourceUpdateInput = {
    /** The description */
    description: Scalars["String"]["input"];
    /** The external resource id */
    id: Scalars["ID"]["input"];
    /** The external resource link */
    link: Scalars["String"]["input"];
    /** The external resource title */
    title: Scalars["String"]["input"];
};

export type HelpExternalResources = {
    __typename?: "HelpExternalResources";
    /** The external resources */
    edges: Array<Maybe<HelpExternalResourceEdge>>;
    /** The page info */
    pageInfo: PageInfo;
    /** Total count */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type HelpExternalResourcesResult =
    | HelpExternalResourceQueryError
    | HelpExternalResources;

/** Represents a layout in the system. */
export type HelpLayout = Node & {
    __typename?: "HelpLayout";
    id: Scalars["ID"]["output"];
    reloadOnPublish?: Maybe<Scalars["Boolean"]["output"]>;
    sections?: Maybe<HelpLayoutSectionConnection>;
    type?: Maybe<HelpLayoutType>;
    visualConfig?: Maybe<HelpLayoutVisualConfig>;
};

/** Represents a layout in the system. */
export type HelpLayoutSectionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type HelpLayoutAlignmentSettings = {
    __typename?: "HelpLayoutAlignmentSettings";
    horizontalAlignment?: Maybe<HelpLayoutHorizontalAlignment>;
    verticalAlignment?: Maybe<HelpLayoutVerticalAlignment>;
};

export type HelpLayoutAlignmentSettingsInput = {
    horizontalAlignment?: InputMaybe<HelpLayoutHorizontalAlignment>;
    verticalAlignment?: InputMaybe<HelpLayoutVerticalAlignment>;
};

/** Announcement Atomic Element */
export type HelpLayoutAnnouncementElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutAnnouncementElement";
        data?: Maybe<HelpLayoutAnnouncementElementData>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        header?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        message?: Maybe<Scalars["String"]["output"]>;
        useGlobalSettings?: Maybe<Scalars["Boolean"]["output"]>;
        userLanguageTag?: Maybe<Scalars["String"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutAnnouncementElementData = {
    __typename?: "HelpLayoutAnnouncementElementData";
    header?: Maybe<Scalars["String"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
    userLanguageTag?: Maybe<Scalars["String"]["output"]>;
};

/** Portals List Input */
export type HelpLayoutAnnouncementInput = {
    useGlobalSettings?: InputMaybe<Scalars["Boolean"]["input"]>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** This union represents all the atomic elements. */
export type HelpLayoutAtomicElement =
    | HelpLayoutAnnouncementElement
    | HelpLayoutBreadcrumbElement
    | HelpLayoutConnectElement
    | HelpLayoutEditorElement
    | HelpLayoutForgeElement
    | HelpLayoutHeadingAtomicElement
    | HelpLayoutHeroElement
    | HelpLayoutImageAtomicElement
    | HelpLayoutNoContentElement
    | HelpLayoutParagraphAtomicElement
    | HelpLayoutPortalsListElement
    | HelpLayoutSearchAtomicElement
    | HelpLayoutSuggestedRequestFormsListElement
    | HelpLayoutTopicsListElement;

/**
 * This input type will be used to mutate Atomic Elements inside Composite Elements.
 * This type is used only inside a Composite Element
 */
export type HelpLayoutAtomicElementInput = {
    announcementInput?: InputMaybe<HelpLayoutAnnouncementInput>;
    breadcrumbInput?: InputMaybe<HelpLayoutBreadcrumbElementInput>;
    connectInput?: InputMaybe<HelpLayoutConnectInput>;
    editorInput?: InputMaybe<HelpLayoutEditorInput>;
    elementTypeKey: HelpLayoutAtomicElementKey;
    forgeInput?: InputMaybe<HelpLayoutForgeInput>;
    headingConfigInput?: InputMaybe<HelpLayoutHeadingConfigInput>;
    heroElementInput?: InputMaybe<HelpLayoutHeroElementInput>;
    imageConfigInput?: InputMaybe<HelpLayoutImageConfigInput>;
    noContentElementInput?: InputMaybe<HelpLayoutNoContentElementInput>;
    paragraphConfigInput?: InputMaybe<HelpLayoutParagraphConfigInput>;
    portalsListInput?: InputMaybe<HelpLayoutPortalsListInput>;
    searchConfigInput?: InputMaybe<HelpLayoutSearchConfigInput>;
    suggestedRequestFormsListInput?: InputMaybe<HelpLayoutSuggestedRequestFormsListInput>;
    topicListInput?: InputMaybe<HelpLayoutTopicsListInput>;
};

/** This enum represents all the atomic element keys. */
export enum HelpLayoutAtomicElementKey {
    Announcement = "ANNOUNCEMENT",
    Breadcrumb = "BREADCRUMB",
    Connect = "CONNECT",
    Editor = "EDITOR",
    Forge = "FORGE",
    Heading = "HEADING",
    Hero = "HERO",
    Image = "IMAGE",
    NoContent = "NO_CONTENT",
    Paragraph = "PARAGRAPH",
    PortalsList = "PORTALS_LIST",
    Search = "SEARCH",
    SuggestedRequestFormsList = "SUGGESTED_REQUEST_FORMS_LIST",
    TopicsList = "TOPICS_LIST"
}

/** Represents Atomic Element Types. They are fetched while rendering the catalogue. */
export type HelpLayoutAtomicElementType = HelpLayoutElementType & {
    __typename?: "HelpLayoutAtomicElementType";
    category?: Maybe<HelpLayoutElementCategory>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<HelpLayoutAtomicElementKey>;
    mediaConfig?: Maybe<HelpLayoutMediaConfig>;
};

/** Represents Atomic Element Types. They are fetched while rendering the catalogue. */
export type HelpLayoutAtomicElementTypeMediaConfigArgs = {
    parentAri: Scalars["ID"]["input"];
};

export type HelpLayoutBackgroundImage = {
    __typename?: "HelpLayoutBackgroundImage";
    fileId?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type HelpLayoutBackgroundImageInput = {
    fileId?: InputMaybe<Scalars["String"]["input"]>;
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export enum HelpLayoutBackgroundImageObjectFit {
    Contain = "CONTAIN",
    Cover = "COVER",
    Fill = "FILL"
}

export enum HelpLayoutBackgroundType {
    Color = "COLOR",
    Image = "IMAGE",
    Transparent = "TRANSPARENT"
}

export type HelpLayoutBreadcrumb = {
    __typename?: "HelpLayoutBreadcrumb";
    name: Scalars["String"]["output"];
    relativeUrl: Scalars["String"]["output"];
};

/** Breadcrumb Element */
export type HelpLayoutBreadcrumbElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutBreadcrumbElement";
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        id: Scalars["ID"]["output"];
        items?: Maybe<Array<HelpLayoutBreadcrumb>>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** Breadcrumb Input */
export type HelpLayoutBreadcrumbElementInput = {
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** This interface is implemented by all composite elements. */
export type HelpLayoutCompositeElement = {
    children?: Maybe<Array<Maybe<HelpLayoutAtomicElement>>>;
    elementType?: Maybe<HelpLayoutCompositeElementType>;
    id: Scalars["ID"]["output"];
    visualConfig?: Maybe<HelpLayoutVisualConfig>;
};

/** This enum represents all the composite element keys. */
export enum HelpLayoutCompositeElementKey {
    LinkCard = "LINK_CARD"
}

/** Represents Composite Element Types. They are fetched while rendering the catalogue. */
export type HelpLayoutCompositeElementType = HelpLayoutElementType & {
    __typename?: "HelpLayoutCompositeElementType";
    allowedElements?: Maybe<Array<Maybe<HelpLayoutAtomicElementKey>>>;
    category?: Maybe<HelpLayoutElementCategory>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<HelpLayoutCompositeElementKey>;
};

export type HelpLayoutConnectElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutConnectElement";
        connectElementPage: HelpLayoutConnectElementPages;
        connectElementType: HelpLayoutConnectElementType;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        id: Scalars["ID"]["output"];
        isInstalled?: Maybe<Scalars["Boolean"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** Connect App Element */
export enum HelpLayoutConnectElementPages {
    Approvals = "APPROVALS",
    CreateRequest = "CREATE_REQUEST",
    HelpCenter = "HELP_CENTER",
    MyRequest = "MY_REQUEST",
    Portal = "PORTAL",
    Profile = "PROFILE",
    ViewRequest = "VIEW_REQUEST"
}

export enum HelpLayoutConnectElementType {
    DetailsPanels = "detailsPanels",
    FooterPanels = "footerPanels",
    HeaderAndSubheaderPanels = "headerAndSubheaderPanels",
    HeaderPanels = "headerPanels",
    OptionPanels = "optionPanels",
    ProfilePagePanel = "profilePagePanel",
    PropertyPanels = "propertyPanels",
    RequestCreatePanel = "requestCreatePanel",
    SubheaderPanels = "subheaderPanels"
}

/** Connect App Input */
export type HelpLayoutConnectInput = {
    pages: HelpLayoutConnectElementPages;
    type: HelpLayoutConnectElementType;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export type HelpLayoutCreatePayload = Payload & {
    __typename?: "HelpLayoutCreatePayload";
    errors?: Maybe<Array<MutationError>>;
    layoutId?: Maybe<Scalars["ID"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type HelpLayoutCreationInput = {
    parentAri: Scalars["ID"]["input"];
    sections: Array<HelpLayoutSectionInput>;
    type?: InputMaybe<HelpLayoutType>;
};

/** Editor Element */
export type HelpLayoutEditorElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutEditorElement";
        adf?: Maybe<Scalars["String"]["output"]>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        id: Scalars["ID"]["output"];
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** Editor Input */
export type HelpLayoutEditorInput = {
    adf: Scalars["String"]["input"];
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** This union represents all elements, atomic and composite. */
export type HelpLayoutElement =
    | HelpLayoutAnnouncementElement
    | HelpLayoutBreadcrumbElement
    | HelpLayoutConnectElement
    | HelpLayoutEditorElement
    | HelpLayoutForgeElement
    | HelpLayoutHeadingAtomicElement
    | HelpLayoutHeroElement
    | HelpLayoutImageAtomicElement
    | HelpLayoutLinkCardCompositeElement
    | HelpLayoutNoContentElement
    | HelpLayoutParagraphAtomicElement
    | HelpLayoutPortalsListElement
    | HelpLayoutSearchAtomicElement
    | HelpLayoutSuggestedRequestFormsListElement
    | HelpLayoutTopicsListElement
    | QueryError;

/** This enum represents all the element category. */
export enum HelpLayoutElementCategory {
    Basic = "BASIC",
    Navigation = "NAVIGATION"
}

/**
 * This input type can mutate both atomic and composite elements. Since there is no polymorphism in input types in graphql.
 * Client will have to send the Key to the element they are mutating and respective config.
 * Only one of the config fields will be specified. "elementTypeKey" should match the config provided.
 */
export type HelpLayoutElementInput = {
    announcementInput?: InputMaybe<HelpLayoutAnnouncementInput>;
    breadcrumbInput?: InputMaybe<HelpLayoutBreadcrumbElementInput>;
    connectInput?: InputMaybe<HelpLayoutConnectInput>;
    editorInput?: InputMaybe<HelpLayoutEditorInput>;
    elementTypeKey: HelpLayoutElementKey;
    forgeInput?: InputMaybe<HelpLayoutForgeInput>;
    headingConfigInput?: InputMaybe<HelpLayoutHeadingConfigInput>;
    heroElementInput?: InputMaybe<HelpLayoutHeroElementInput>;
    imageConfigInput?: InputMaybe<HelpLayoutImageConfigInput>;
    linkCardInput?: InputMaybe<HelpLayoutLinkCardInput>;
    noContentElementInput?: InputMaybe<HelpLayoutNoContentElementInput>;
    paragraphConfigInput?: InputMaybe<HelpLayoutParagraphConfigInput>;
    portalsListInput?: InputMaybe<HelpLayoutPortalsListInput>;
    searchConfigInput?: InputMaybe<HelpLayoutSearchConfigInput>;
    suggestedRequestFormsListInput?: InputMaybe<HelpLayoutSuggestedRequestFormsListInput>;
    topicListInput?: InputMaybe<HelpLayoutTopicsListInput>;
};

/** Enum of all the supported element types, atomic and composite. */
export enum HelpLayoutElementKey {
    Announcement = "ANNOUNCEMENT",
    Breadcrumb = "BREADCRUMB",
    Connect = "CONNECT",
    Editor = "EDITOR",
    Forge = "FORGE",
    Heading = "HEADING",
    Hero = "HERO",
    Image = "IMAGE",
    LinkCard = "LINK_CARD",
    NoContent = "NO_CONTENT",
    Paragraph = "PARAGRAPH",
    PortalsList = "PORTALS_LIST",
    Search = "SEARCH",
    SuggestedRequestFormsList = "SUGGESTED_REQUEST_FORMS_LIST",
    TopicsList = "TOPICS_LIST"
}

/** This interface represents all the element types which are supported by this schema. */
export type HelpLayoutElementType = {
    category?: Maybe<HelpLayoutElementCategory>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
};

export type HelpLayoutFilter = {
    isEditMode?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HelpLayoutForgeElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutForgeElement";
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        forgeElementPage: HelpLayoutForgeElementPages;
        forgeElementType: HelpLayoutForgeElementType;
        id: Scalars["ID"]["output"];
        isInstalled?: Maybe<Scalars["Boolean"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** Forge App Element */
export enum HelpLayoutForgeElementPages {
    Approvals = "approvals",
    CreateRequest = "create_request",
    HelpCenter = "help_center",
    MyRequests = "my_requests",
    Portal = "portal",
    Profile = "profile",
    ViewRequest = "view_request"
}

export enum HelpLayoutForgeElementType {
    Footer = "FOOTER",
    HeaderAndSubheader = "HEADER_AND_SUBHEADER"
}

/** Forge App Input */
export type HelpLayoutForgeInput = {
    pages: HelpLayoutForgeElementPages;
    type: HelpLayoutForgeElementType;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** Heading Atomic Element */
export type HelpLayoutHeadingAtomicElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutHeadingAtomicElement";
        config?: Maybe<HelpLayoutHeadingAtomicElementConfig>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        headingType?: Maybe<HelpLayoutHeadingType>;
        id: Scalars["ID"]["output"];
        text?: Maybe<Scalars["String"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutHeadingAtomicElementConfig = {
    __typename?: "HelpLayoutHeadingAtomicElementConfig";
    headingType?: Maybe<HelpLayoutHeadingType>;
    text?: Maybe<Scalars["String"]["output"]>;
};

/** Heading Input */
export type HelpLayoutHeadingConfigInput = {
    headingType: HelpLayoutHeadingType;
    text: Scalars["String"]["input"];
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export enum HelpLayoutHeadingType {
    H1 = "h1",
    H2 = "h2",
    H3 = "h3",
    H4 = "h4",
    H5 = "h5",
    H6 = "h6"
}

/** Hero Element */
export type HelpLayoutHeroElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutHeroElement";
        data?: Maybe<HelpLayoutHeroElementData>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        hideSearchBar?: Maybe<Scalars["Boolean"]["output"]>;
        hideTitle?: Maybe<Scalars["Boolean"]["output"]>;
        homePageTitle?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        useGlobalSettings?: Maybe<Scalars["Boolean"]["output"]>;
        userLanguageTag?: Maybe<Scalars["String"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutHeroElementData = {
    __typename?: "HelpLayoutHeroElementData";
    homePageTitle?: Maybe<Scalars["String"]["output"]>;
    userLanguageTag?: Maybe<Scalars["String"]["output"]>;
};

/** Hero Element Input */
export type HelpLayoutHeroElementInput = {
    hideSearchBar?: InputMaybe<Scalars["Boolean"]["input"]>;
    hideTitle?: InputMaybe<Scalars["Boolean"]["input"]>;
    useGlobalSettings?: InputMaybe<Scalars["Boolean"]["input"]>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export enum HelpLayoutHorizontalAlignment {
    Center = "CENTER",
    Left = "LEFT",
    Right = "RIGHT"
}

/** Image Atomic Element */
export type HelpLayoutImageAtomicElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutImageAtomicElement";
        altText?: Maybe<Scalars["String"]["output"]>;
        config?: Maybe<HelpLayoutImageAtomicElementConfig>;
        data?: Maybe<HelpLayoutImageAtomicElementData>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        fileId?: Maybe<Scalars["String"]["output"]>;
        fit?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        imageUrl?: Maybe<Scalars["String"]["output"]>;
        position?: Maybe<Scalars["String"]["output"]>;
        scale?: Maybe<Scalars["Int"]["output"]>;
        size?: Maybe<Scalars["String"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutImageAtomicElementConfig = {
    __typename?: "HelpLayoutImageAtomicElementConfig";
    altText?: Maybe<Scalars["String"]["output"]>;
    fileId?: Maybe<Scalars["String"]["output"]>;
    fit?: Maybe<Scalars["String"]["output"]>;
    position?: Maybe<Scalars["String"]["output"]>;
    scale?: Maybe<Scalars["Int"]["output"]>;
    size?: Maybe<Scalars["String"]["output"]>;
};

export type HelpLayoutImageAtomicElementData = {
    __typename?: "HelpLayoutImageAtomicElementData";
    imageUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Image Input */
export type HelpLayoutImageConfigInput = {
    altText?: InputMaybe<Scalars["String"]["input"]>;
    fileId?: InputMaybe<Scalars["String"]["input"]>;
    fit?: InputMaybe<Scalars["String"]["input"]>;
    position?: InputMaybe<Scalars["String"]["input"]>;
    scale?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["String"]["input"]>;
    url?: InputMaybe<Scalars["String"]["input"]>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** Link card Composite Element */
export type HelpLayoutLinkCardCompositeElement = HelpLayoutCompositeElement &
    HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutLinkCardCompositeElement";
        children?: Maybe<Array<Maybe<HelpLayoutAtomicElement>>>;
        config?: Maybe<Scalars["String"]["output"]>;
        elementType?: Maybe<HelpLayoutCompositeElementType>;
        id: Scalars["ID"]["output"];
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** Link card input */
export type HelpLayoutLinkCardInput = {
    children: Array<HelpLayoutAtomicElementInput>;
    config: Scalars["String"]["input"];
    type: HelpLayoutCompositeElementKey;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** Media config provides auth credentials and relevant information to upload images for media related elements. */
export type HelpLayoutMediaConfig = {
    __typename?: "HelpLayoutMediaConfig";
    asapIssuer?: Maybe<Scalars["String"]["output"]>;
    mediaCollectionName?: Maybe<Scalars["String"]["output"]>;
    mediaToken?: Maybe<Scalars["String"]["output"]>;
    mediaUrl?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutMutationApi = {
    __typename?: "HelpLayoutMutationApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createLayout: HelpLayoutCreatePayload;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deleteLayout?: Maybe<Payload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateLayout: HelpLayoutUpdatePayload;
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutMutationApiCreateLayoutArgs = {
    input: HelpLayoutCreationInput;
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutMutationApiDeleteLayoutArgs = {
    layoutId: Scalars["ID"]["input"];
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutMutationApiUpdateLayoutArgs = {
    input: HelpLayoutUpdateInput;
};

export type HelpLayoutMutationErrorExtension = MutationErrorExtension & {
    __typename?: "HelpLayoutMutationErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** No Content Element */
export type HelpLayoutNoContentElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutNoContentElement";
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        header?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        message?: Maybe<Scalars["String"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** No Content Element Input */
export type HelpLayoutNoContentElementInput = {
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** Paragraph Atomic Element */
export type HelpLayoutParagraphAtomicElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutParagraphAtomicElement";
        adf?: Maybe<Scalars["String"]["output"]>;
        config?: Maybe<HelpLayoutParagraphAtomicElementConfig>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        id: Scalars["ID"]["output"];
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutParagraphAtomicElementConfig = {
    __typename?: "HelpLayoutParagraphAtomicElementConfig";
    adf?: Maybe<Scalars["String"]["output"]>;
};

/** Paragraph Input */
export type HelpLayoutParagraphConfigInput = {
    adf: Scalars["String"]["input"];
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export type HelpLayoutPortalCard = {
    __typename?: "HelpLayoutPortalCard";
    description?: Maybe<Scalars["String"]["output"]>;
    isFeatured?: Maybe<Scalars["Boolean"]["output"]>;
    logo?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    portalBaseUrl?: Maybe<Scalars["String"]["output"]>;
    portalId?: Maybe<Scalars["String"]["output"]>;
    projectType?: Maybe<HelpLayoutProjectType>;
};

export type HelpLayoutPortalsListData = {
    __typename?: "HelpLayoutPortalsListData";
    portals?: Maybe<Array<Maybe<HelpLayoutPortalCard>>>;
};

/** List of Portals Atomic Element */
export type HelpLayoutPortalsListElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutPortalsListElement";
        data?: Maybe<HelpLayoutPortalsListData>;
        elementTitle?: Maybe<Scalars["String"]["output"]>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        expandButtonTextColor?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        portals?: Maybe<Array<Maybe<HelpLayoutPortalCard>>>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/** Announcement Input */
export type HelpLayoutPortalsListInput = {
    elementTitle?: InputMaybe<Scalars["String"]["input"]>;
    expandButtonTextColor?: InputMaybe<Scalars["String"]["input"]>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export enum HelpLayoutProjectType {
    CustomerService = "CUSTOMER_SERVICE",
    ServiceDesk = "SERVICE_DESK"
}

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutQueryApi = {
    __typename?: "HelpLayoutQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    elementTypes?: Maybe<Array<HelpLayoutElementType>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    elements?: Maybe<Array<HelpLayoutElement>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    layout?: Maybe<HelpLayoutResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    layoutByParentId?: Maybe<HelpLayoutResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaConfig?: Maybe<HelpLayoutMediaConfig>;
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutQueryApiElementsArgs = {
    filter?: InputMaybe<HelpLayoutFilter>;
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutQueryApiLayoutArgs = {
    filter?: InputMaybe<HelpLayoutFilter>;
    id: Scalars["ID"]["input"];
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutQueryApiLayoutByParentIdArgs = {
    filter?: InputMaybe<HelpLayoutFilter>;
    helpCenterAri?: InputMaybe<Scalars["ID"]["input"]>;
    parentAri: Scalars["ID"]["input"];
};

/**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */
export type HelpLayoutQueryApiMediaConfigArgs = {
    filter?: InputMaybe<HelpLayoutFilter>;
    parentAri: Scalars["ID"]["input"];
};

/** --------------------------------------------------------------------------------------------- */
export type HelpLayoutQueryErrorExtension = QueryErrorExtension & {
    __typename?: "HelpLayoutQueryErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type HelpLayoutRequestForm = {
    __typename?: "HelpLayoutRequestForm";
    descriptionHtml?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    portalId?: Maybe<Scalars["String"]["output"]>;
    portalName?: Maybe<Scalars["String"]["output"]>;
};

/** This union represents the result provided by the layout query. */
export type HelpLayoutResult = HelpLayout | QueryError;

/** Search Atomic Element */
export type HelpLayoutSearchAtomicElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutSearchAtomicElement";
        config?: Maybe<HelpLayoutSearchAtomicElementConfig>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        id: Scalars["ID"]["output"];
        placeHolderText?: Maybe<Scalars["String"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutSearchAtomicElementConfig = {
    __typename?: "HelpLayoutSearchAtomicElementConfig";
    placeHolderText?: Maybe<Scalars["String"]["output"]>;
};

/** Search Input */
export type HelpLayoutSearchConfigInput = {
    placeHolderText: Scalars["String"]["input"];
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** A layout consists of rows called sections. */
export type HelpLayoutSection = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutSection";
        id: Scalars["ID"]["output"];
        subsections?: Maybe<Array<Maybe<HelpLayoutSubsection>>>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

/**
 * Required for pagination as per relay specs
 * https://relay.dev/graphql/connections.htm
 */
export type HelpLayoutSectionConnection = {
    __typename?: "HelpLayoutSectionConnection";
    edges?: Maybe<Array<Maybe<HelpLayoutSectionEdge>>>;
    pageInfo: PageInfo;
};

/**
 * Required for pagination as per relay specs
 * https://relay.dev/graphql/connections.htm
 */
export type HelpLayoutSectionEdge = {
    __typename?: "HelpLayoutSectionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<HelpLayoutSection>;
};

export type HelpLayoutSectionInput = {
    subsections: Array<HelpLayoutSubsectionInput>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** Subsection represents a draggable place in the layout where elements (composite or atomic) can be dropped. */
export type HelpLayoutSubsection = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutSubsection";
        config?: Maybe<HelpLayoutSubsectionConfig>;
        elements?: Maybe<Array<Maybe<HelpLayoutElement>>>;
        id: Scalars["ID"]["output"];
        span?: Maybe<Scalars["Int"]["output"]>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutSubsectionConfig = {
    __typename?: "HelpLayoutSubsectionConfig";
    span?: Maybe<Scalars["Int"]["output"]>;
};

export type HelpLayoutSubsectionConfigInput = {
    span: Scalars["Int"]["input"];
};

export type HelpLayoutSubsectionInput = {
    config: HelpLayoutSubsectionConfigInput;
    elements: Array<HelpLayoutElementInput>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** List of Suggested Request Forms Atomic Element */
export type HelpLayoutSuggestedRequestFormsListElement =
    HelpLayoutVisualEntity &
        Node & {
            __typename?: "HelpLayoutSuggestedRequestFormsListElement";
            config?: Maybe<Scalars["String"]["output"]>;
            data?: Maybe<HelpLayoutSuggestedRequestFormsListElementData>;
            elementTitle?: Maybe<Scalars["String"]["output"]>;
            elementType?: Maybe<HelpLayoutAtomicElementType>;
            id: Scalars["ID"]["output"];
            suggestedRequestTypes?: Maybe<Array<HelpLayoutRequestForm>>;
            visualConfig?: Maybe<HelpLayoutVisualConfig>;
        };

export type HelpLayoutSuggestedRequestFormsListElementData = {
    __typename?: "HelpLayoutSuggestedRequestFormsListElementData";
    suggestedRequestTypes?: Maybe<Array<HelpLayoutRequestForm>>;
};

/** Suggested Request Forms List Input */
export type HelpLayoutSuggestedRequestFormsListInput = {
    elementTitle?: InputMaybe<Scalars["String"]["input"]>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export type HelpLayoutTopic = {
    __typename?: "HelpLayoutTopic";
    hidden?: Maybe<Scalars["Boolean"]["output"]>;
    items?: Maybe<Array<HelpLayoutTopicItem>>;
    properties?: Maybe<Scalars["String"]["output"]>;
    topicId?: Maybe<Scalars["String"]["output"]>;
    topicName?: Maybe<Scalars["String"]["output"]>;
};

export type HelpLayoutTopicItem = {
    __typename?: "HelpLayoutTopicItem";
    displayLink?: Maybe<Scalars["String"]["output"]>;
    entityKey?: Maybe<Scalars["String"]["output"]>;
    helpObjectType?: Maybe<Scalars["String"]["output"]>;
    logo?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Topics Atomic Element */
export type HelpLayoutTopicsListElement = HelpLayoutVisualEntity &
    Node & {
        __typename?: "HelpLayoutTopicsListElement";
        data?: Maybe<HelpLayoutTopicsListElementData>;
        elementTitle?: Maybe<Scalars["String"]["output"]>;
        elementType?: Maybe<HelpLayoutAtomicElementType>;
        id: Scalars["ID"]["output"];
        topics?: Maybe<Array<HelpLayoutTopic>>;
        visualConfig?: Maybe<HelpLayoutVisualConfig>;
    };

export type HelpLayoutTopicsListElementData = {
    __typename?: "HelpLayoutTopicsListElementData";
    topics?: Maybe<Array<HelpLayoutTopic>>;
};

/** Topics List Input */
export type HelpLayoutTopicsListInput = {
    elementTitle?: InputMaybe<Scalars["String"]["input"]>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

/** This enum represents the type of layout available. */
export enum HelpLayoutType {
    CustomPage = "CUSTOM_PAGE",
    HomePage = "HOME_PAGE"
}

export type HelpLayoutUpdateInput = {
    layoutId: Scalars["ID"]["input"];
    sections: Array<HelpLayoutSectionInput>;
    visualConfig?: InputMaybe<HelpLayoutVisualConfigInput>;
};

export type HelpLayoutUpdatePayload = Payload & {
    __typename?: "HelpLayoutUpdatePayload";
    errors?: Maybe<Array<MutationError>>;
    layoutId?: Maybe<Scalars["ID"]["output"]>;
    reloadOnPublish?: Maybe<Scalars["Boolean"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export enum HelpLayoutVerticalAlignment {
    Bottom = "BOTTOM",
    Middle = "MIDDLE",
    Top = "TOP"
}

/** This represents the visual properties */
export type HelpLayoutVisualConfig = {
    __typename?: "HelpLayoutVisualConfig";
    alignment?: Maybe<HelpLayoutAlignmentSettings>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<HelpLayoutBackgroundImage>;
    backgroundType?: Maybe<HelpLayoutBackgroundType>;
    foregroundColor?: Maybe<Scalars["String"]["output"]>;
    hidden?: Maybe<Scalars["Boolean"]["output"]>;
    objectFit?: Maybe<HelpLayoutBackgroundImageObjectFit>;
    themeTemplateId?: Maybe<Scalars["String"]["output"]>;
    titleColor?: Maybe<Scalars["String"]["output"]>;
};

/** This represents the visual config input required during mutation */
export type HelpLayoutVisualConfigInput = {
    alignment?: InputMaybe<HelpLayoutAlignmentSettingsInput>;
    backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
    backgroundImage?: InputMaybe<HelpLayoutBackgroundImageInput>;
    backgroundType?: InputMaybe<HelpLayoutBackgroundType>;
    foregroundColor?: InputMaybe<Scalars["String"]["input"]>;
    hidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    objectFit?: InputMaybe<HelpLayoutBackgroundImageObjectFit>;
    themeTemplateId?: InputMaybe<Scalars["String"]["input"]>;
    titleColor?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Any element or type that implements visualEntity will get visual config as a field which contains visual properties.
 * Think of this as visual config provider used to provide config such as border, bg-color and so on.
 */
export type HelpLayoutVisualEntity = {
    visualConfig?: Maybe<HelpLayoutVisualConfig>;
};

export type HelpObjectStoreArticle = HelpObjectStoreHelpObject &
    Node & {
        __typename?: "HelpObjectStoreArticle";
        /** Copy of ID */
        ari: Scalars["ID"]["output"];
        /** Container Id of request form. */
        containerId?: Maybe<Scalars["String"]["output"]>;
        /** Container Key which identifies the type of the container. ex- jira:project / external:forge */
        containerKey?: Maybe<Scalars["String"]["output"]>;
        /** Description of the Article */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Clickable Link of the Article */
        displayLink?: Maybe<Scalars["String"]["output"]>;
        /** Article Id / External link Id in jira */
        entityId?: Maybe<Scalars["String"]["output"]>;
        /** Namespace of the entity in product. Like jira:article, notion:article, jira:external-resource */
        entityKey?: Maybe<Scalars["String"]["output"]>;
        /** Flag to control the visibility */
        hidden?: Maybe<Scalars["Boolean"]["output"]>;
        /** Icon of the Article */
        icon?: Maybe<HelpObjectStoreIcon>;
        /** ARI of the Article */
        id: Scalars["ID"]["output"];
        /** Title of the Article */
        title?: Maybe<Scalars["String"]["output"]>;
    };

export type HelpObjectStoreArticleMetadata = {
    __typename?: "HelpObjectStoreArticleMetadata";
    /** If the searchResult is an external link */
    isExternal: Scalars["Boolean"]["output"];
    /** Search Strategy through which the search result was obtained */
    searchStrategy: HelpObjectStoreArticleSearchStrategy;
};

export type HelpObjectStoreArticleResult =
    | HelpObjectStoreArticle
    | HelpObjectStoreQueryError;

export type HelpObjectStoreArticleSearchResponse =
    | HelpObjectStoreArticleSearchResults
    | HelpObjectStoreSearchError;

export type HelpObjectStoreArticleSearchResult = {
    __typename?: "HelpObjectStoreArticleSearchResult";
    /** Absolute URL based on default HC URL */
    absoluteUrl: Scalars["String"]["output"];
    /** The ARI of the article */
    ari: Scalars["ID"]["output"];
    /** The container ARI of the article. eg: Jira Project ARI */
    containerAri: Scalars["ID"]["output"];
    /** The container name of the article. eg: JSM Portal Name */
    containerName: Scalars["ID"]["output"];
    /** The display link of the article */
    displayLink: Scalars["String"]["output"];
    /** The excerpt of the article */
    excerpt: Scalars["String"]["output"];
    /** The search result meta-data */
    metadata: HelpObjectStoreArticleMetadata;
    /** The source system of the article like Confluence, Google Drive, etc */
    sourceSystem?: Maybe<HelpObjectStoreArticleSourceSystem>;
    /** The title of the article */
    title: Scalars["String"]["output"];
};

export type HelpObjectStoreArticleSearchResults = {
    __typename?: "HelpObjectStoreArticleSearchResults";
    /**
     *  The search results
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    results: Array<HelpObjectStoreArticleSearchResult>;
};

export enum HelpObjectStoreArticleSearchStrategy {
    ContentSearch = "CONTENT_SEARCH",
    /** Search Strategy used to obtain the search result */
    Cql = "CQL",
    Proxy = "PROXY"
}

export enum HelpObjectStoreArticleSourceSystem {
    Confluence = "CONFLUENCE",
    External = "EXTERNAL",
    GoogleDrive = "GOOGLE_DRIVE",
    Sharepoint = "SHAREPOINT"
}

export type HelpObjectStoreBulkCreateEntityMappingInput = {
    helpObjectStoreCreateEntityMappingInputItems: Array<HelpObjectStoreCreateEntityMappingInput>;
};

export type HelpObjectStoreChannel = HelpObjectStoreHelpObject &
    Node & {
        __typename?: "HelpObjectStoreChannel";
        /** Copy of ID */
        ari: Scalars["ID"]["output"];
        /** Container Id of Channel / External Resource. */
        containerId?: Maybe<Scalars["String"]["output"]>;
        /** Container Key which identifies the type of the container. ex- jira:project / external:forge */
        containerKey?: Maybe<Scalars["String"]["output"]>;
        /** Description of the Channel */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Clickable Link of the Channel */
        displayLink?: Maybe<Scalars["String"]["output"]>;
        /** Channel Id / External Resource Id */
        entityId?: Maybe<Scalars["String"]["output"]>;
        /** Namespace of the entity in product. Like slack:slack-channel, jira:external-resource, google:gmail */
        entityKey?: Maybe<Scalars["String"]["output"]>;
        /** Flag to control the visibility */
        hidden?: Maybe<Scalars["Boolean"]["output"]>;
        /** Icon of the Channel */
        icon?: Maybe<HelpObjectStoreIcon>;
        /** ARI of the Channel */
        id: Scalars["ID"]["output"];
        /** Title of the Channel */
        title?: Maybe<Scalars["String"]["output"]>;
    };

export type HelpObjectStoreChannelResult =
    | HelpObjectStoreChannel
    | HelpObjectStoreQueryError;

export type HelpObjectStoreCreateEntityMappingInput = {
    /** Id of the container through which help object is associated. Could be projectId / Help Center Id etc. */
    containerId?: InputMaybe<Scalars["String"]["input"]>;
    /** Container Key which identifies the type of the container. ex- jira:project / external:forge */
    containerKey?: InputMaybe<Scalars["String"]["input"]>;
    /** Id of the Request Type / Article / Channel / External Link in jira */
    entityId: Scalars["String"]["input"];
    /** Namespace of the entity in product. Like jira:request-form, notion:article, jira:external-resource */
    entityKey?: InputMaybe<Scalars["String"]["input"]>;
    /** Type of entity */
    type: HelpObjectStoreJsmEntityType;
};

export type HelpObjectStoreCreateEntityMappingPayload = Payload & {
    __typename?: "HelpObjectStoreCreateEntityMappingPayload";
    /** The details of the entities that was mutated. */
    entityMappingDetails?: Maybe<
        Array<HelpObjectStoreSuccessfullyCreatedEntityMappingDetail>
    >;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type HelpObjectStoreHelpCenterSearchResult =
    | HelpObjectStoreQueryError
    | HelpObjectStoreSearchResult;

export type HelpObjectStoreHelpObject = {
    /**
     *  Copy of ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari: Scalars["ID"]["output"];
    /**
     *  Description of the Help Object
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *  Clickable Link of the Help Object
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayLink?: Maybe<Scalars["String"]["output"]>;
    /**
     *  Flag to control the visibility
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hidden?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *  Icon of the Help Object
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<HelpObjectStoreIcon>;
    /**
     *  ARI of the help object
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *  Title of the Help Object
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
};

export enum HelpObjectStoreHelpObjectType {
    Article = "ARTICLE",
    Channel = "CHANNEL",
    Portal = "PORTAL",
    RequestForm = "REQUEST_FORM"
}

export type HelpObjectStoreIcon = {
    __typename?: "HelpObjectStoreIcon";
    /** Icon Absolute URL(always with Atlassian baseUrl) */
    iconUrl: Scalars["URL"]["output"];
    /** Icon Relative URL String */
    iconUrlV2: Scalars["String"]["output"];
};

export enum HelpObjectStoreJsmEntityType {
    Article = "ARTICLE",
    Channel = "CHANNEL",
    Portal = "PORTAL",
    RequestForm = "REQUEST_FORM"
}

export type HelpObjectStoreMutationApi = {
    __typename?: "HelpObjectStoreMutationApi";
    /**
     *  To create mapping of jira entity into help object store
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createEntityMapping?: Maybe<HelpObjectStoreCreateEntityMappingPayload>;
};

export type HelpObjectStoreMutationApiCreateEntityMappingArgs = {
    input: HelpObjectStoreBulkCreateEntityMappingInput;
};

export type HelpObjectStorePortal = HelpObjectStoreHelpObject &
    Node & {
        __typename?: "HelpObjectStorePortal";
        /**
         *  Copy of ID
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        ari: Scalars["ID"]["output"];
        /**
         *  Container Id of Portal.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        containerId?: Maybe<Scalars["String"]["output"]>;
        /**
         *  Container Key which identifies the type of the container. ex- jira:project / external:forge
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        containerKey?: Maybe<Scalars["String"]["output"]>;
        /**
         *  Description of the Portal
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         *  Clickable Link of the Portal
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        displayLink?: Maybe<Scalars["String"]["output"]>;
        /**
         *   Portal Id
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityId?: Maybe<Scalars["String"]["output"]>;
        /**
         *  Namespace of the entity in product. Like slack:slack-channel, jira:external-resource, google:gmail
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityKey?: Maybe<Scalars["String"]["output"]>;
        /**
         *  Flag to control the visibility
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hidden?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         *  Icon of the Portal
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        icon?: Maybe<HelpObjectStoreIcon>;
        /**
         *  ARI of the Portal
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *  Title of the Portal
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title?: Maybe<Scalars["String"]["output"]>;
    };

export type HelpObjectStorePortalMetadata = {
    __typename?: "HelpObjectStorePortalMetadata";
    /** Search Strategy through which the search result was obtained */
    searchStrategy: HelpObjectStorePortalSearchStrategy;
};

export type HelpObjectStorePortalResult =
    | HelpObjectStorePortal
    | HelpObjectStoreQueryError;

export type HelpObjectStorePortalSearchResponse =
    | HelpObjectStorePortalSearchResults
    | HelpObjectStoreSearchError;

export type HelpObjectStorePortalSearchResult = {
    __typename?: "HelpObjectStorePortalSearchResult";
    /** Absolute URL based on default HC URL */
    absoluteUrl: Scalars["String"]["output"];
    /** The excerpt of the portal */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The display link of the portal */
    displayLink: Scalars["String"]["output"];
    /** The icon URL */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the portal */
    id: Scalars["ID"]["output"];
    /** The search result meta-data */
    metadata: HelpObjectStorePortalMetadata;
    /** The title of the portal */
    title: Scalars["String"]["output"];
};

export type HelpObjectStorePortalSearchResults = {
    __typename?: "HelpObjectStorePortalSearchResults";
    /**
     *  The search results
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    results: Array<HelpObjectStorePortalSearchResult>;
};

export enum HelpObjectStorePortalSearchStrategy {
    /** Search Strategy used to obtain the search result */
    Jira = "JIRA",
    SearchPlatform = "SEARCH_PLATFORM"
}

export type HelpObjectStoreQueryApi = {
    __typename?: "HelpObjectStoreQueryApi";
    /**
     *  To fetch the Articles in bulk
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    articles?: Maybe<Array<Maybe<HelpObjectStoreArticleResult>>>;
    /**
     *  To fetch the channels in bulk
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    channels?: Maybe<Array<Maybe<HelpObjectStoreChannelResult>>>;
    /**
     *  To fetch the Request Forms in bulk
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    requestForms?: Maybe<Array<Maybe<HelpObjectStoreRequestFormResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    searchHelpObjects?: Maybe<
        Array<Maybe<HelpObjectStoreHelpCenterSearchResult>>
    >;
};

export type HelpObjectStoreQueryApiArticlesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type HelpObjectStoreQueryApiChannelsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type HelpObjectStoreQueryApiRequestFormsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type HelpObjectStoreQueryApiSearchHelpObjectsArgs = {
    searchInput: HelpObjectStoreSearchInput;
};

export type HelpObjectStoreQueryError = {
    __typename?: "HelpObjectStoreQueryError";
    /**
     * The ID of the requested object, or null when the ID is not available.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari: Scalars["ID"]["output"];
    /**
     * Contains extra data describing the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /**
     * A message describing the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type HelpObjectStoreRequestForm = HelpObjectStoreHelpObject &
    Node & {
        __typename?: "HelpObjectStoreRequestForm";
        /** Copy of ID */
        ari: Scalars["ID"]["output"];
        /** Container Id of request form/ external resource container Id. */
        containerId?: Maybe<Scalars["String"]["output"]>;
        /** Container Key which identifies the type of the container. ex- jira:project / external:forge */
        containerKey?: Maybe<Scalars["String"]["output"]>;
        /** Description of the Request Form */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Clickable Link of the Request Form */
        displayLink?: Maybe<Scalars["String"]["output"]>;
        /** Request Form Id / External link Id in jira */
        entityId?: Maybe<Scalars["String"]["output"]>;
        /** Namespace of the entity in product. Like jira:request-form, google:request-form, jira:external-resource */
        entityKey?: Maybe<Scalars["String"]["output"]>;
        /** Flag to control the visibility */
        hidden?: Maybe<Scalars["Boolean"]["output"]>;
        /** Icon of the Request Form */
        icon?: Maybe<HelpObjectStoreIcon>;
        /** ARI of the Request Form */
        id: Scalars["ID"]["output"];
        /** Title of the Request Form */
        title?: Maybe<Scalars["String"]["output"]>;
    };

export type HelpObjectStoreRequestFormResult =
    | HelpObjectStoreQueryError
    | HelpObjectStoreRequestForm;

export type HelpObjectStoreRequestTypeMetadata = {
    __typename?: "HelpObjectStoreRequestTypeMetadata";
    /** If the search result is an external link */
    isExternal: Scalars["Boolean"]["output"];
    /** Search Strategy through which the search result was obtained */
    searchStrategy: HelpObjectStoreRequestTypeSearchStrategy;
};

export type HelpObjectStoreRequestTypeSearchResponse =
    | HelpObjectStoreRequestTypeSearchResults
    | HelpObjectStoreSearchError;

export type HelpObjectStoreRequestTypeSearchResult = {
    __typename?: "HelpObjectStoreRequestTypeSearchResult";
    /** Absolute URL based on default HC URL */
    absoluteUrl: Scalars["String"]["output"];
    /** The container ARI of the request type. eg: Jira Project ARI */
    containerAri: Scalars["ID"]["output"];
    /** The container name of the request type. eg: JSM Portal Name */
    containerName: Scalars["ID"]["output"];
    /** The excerpt of the request type */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The display link of the request type */
    displayLink: Scalars["String"]["output"];
    /** The icon URL */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the request type */
    id: Scalars["ID"]["output"];
    /** The search result meta-data */
    metadata: HelpObjectStoreRequestTypeMetadata;
    /** The title of the request type */
    title: Scalars["String"]["output"];
};

export type HelpObjectStoreRequestTypeSearchResults = {
    __typename?: "HelpObjectStoreRequestTypeSearchResults";
    /**
     *  The search results
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    results: Array<HelpObjectStoreRequestTypeSearchResult>;
};

export enum HelpObjectStoreRequestTypeSearchStrategy {
    JiraIssueBasedSearch = "JIRA_ISSUE_BASED_SEARCH",
    /** Search Strategy used to obtain the search result */
    JiraKeywordBased = "JIRA_KEYWORD_BASED",
    SearchPlatformKeywordBased = "SEARCH_PLATFORM_KEYWORD_BASED",
    SearchPlatformKeywordBasedEr = "SEARCH_PLATFORM_KEYWORD_BASED_ER"
}

export enum HelpObjectStoreSearchAlgorithm {
    KeywordSearchOnIssues = "KEYWORD_SEARCH_ON_ISSUES",
    KeywordSearchOnPortalsBm25 = "KEYWORD_SEARCH_ON_PORTALS_BM25",
    KeywordSearchOnPortalsExactMatch = "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH",
    KeywordSearchOnRequestTypesBm25 = "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25",
    KeywordSearchOnRequestTypesExactMatch = "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH"
}

export enum HelpObjectStoreSearchBackend {
    Jira = "JIRA",
    SearchPlatform = "SEARCH_PLATFORM"
}

export enum HelpObjectStoreSearchEntityType {
    Article = "ARTICLE",
    Channel = "CHANNEL",
    Portal = "PORTAL",
    RequestForm = "REQUEST_FORM"
}

export type HelpObjectStoreSearchError = {
    __typename?: "HelpObjectStoreSearchError";
    /**
     *  The error extensions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensions: Array<QueryErrorExtension>;
    /**
     *  The error message
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message: Scalars["String"]["output"];
};

export type HelpObjectStoreSearchInput = {
    categoryIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    cloudId: Scalars["ID"]["input"];
    entityType: HelpObjectStoreSearchEntityType;
    helpCenterAri?: InputMaybe<Scalars["String"]["input"]>;
    highlightArticles?: InputMaybe<Scalars["Boolean"]["input"]>;
    portalIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    queryTerm: Scalars["String"]["input"];
    resultLimit?: InputMaybe<Scalars["Int"]["input"]>;
    skipSearchingRestrictedPages?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HelpObjectStoreSearchMetaData = {
    __typename?: "HelpObjectStoreSearchMetaData";
    searchScore: Scalars["Float"]["output"];
};

export type HelpObjectStoreSearchResult = Node & {
    __typename?: "HelpObjectStoreSearchResult";
    containerDisplayName?: Maybe<Scalars["String"]["output"]>;
    containerId: Scalars["String"]["output"];
    description: Scalars["String"]["output"];
    displayLink: Scalars["String"]["output"];
    entityId: Scalars["String"]["output"];
    entityType: Scalars["String"]["output"];
    iconUrl: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    isExternal: Scalars["Boolean"]["output"];
    metaData?: Maybe<HelpObjectStoreSearchMetaData>;
    searchAlgorithm?: Maybe<HelpObjectStoreSearchAlgorithm>;
    searchBackend?: Maybe<HelpObjectStoreSearchBackend>;
    title: Scalars["String"]["output"];
};

export enum HelpObjectStoreSearchableEntityType {
    Article = "ARTICLE",
    RequestForm = "REQUEST_FORM"
}

export type HelpObjectStoreSuccessfullyCreatedEntityMappingDetail = {
    __typename?: "HelpObjectStoreSuccessfullyCreatedEntityMappingDetail";
    /** The unique identifier (ARI) of the Entity. */
    ari: Scalars["ID"]["output"];
    /** Id of the container through which help object is associated. Could be projectId/ Help Center Id etc. */
    containerId?: Maybe<Scalars["String"]["output"]>;
    /** Container Key which identifies the type of the container. ex- jira:project / external:forge */
    containerKey?: Maybe<Scalars["String"]["output"]>;
    /** Id of the Request Type / Article in jira / Channel Id / External link Id */
    entityId: Scalars["String"]["output"];
    /** Namespace of the entity in product. Like jira:request-form, notion:article, jira:external-resource */
    entityKey?: Maybe<Scalars["String"]["output"]>;
};

export type History = {
    __typename?: "History";
    contributors?: Maybe<Contributors>;
    createdBy?: Maybe<Person>;
    createdDate?: Maybe<Scalars["String"]["output"]>;
    lastOwnedBy?: Maybe<Person>;
    lastUpdated?: Maybe<Version>;
    latest?: Maybe<Scalars["Boolean"]["output"]>;
    links?: Maybe<LinksContextSelfBase>;
    nextVersion?: Maybe<Version>;
    ownedBy?: Maybe<Person>;
    previousVersion?: Maybe<Version>;
};

export type HomeUserSettings = {
    __typename?: "HomeUserSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relevantFeedFilters: GraphQlRelevantFeedFilters;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shouldShowActivityFeed: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shouldShowSpaces: Scalars["Boolean"]["output"];
};

export type HomeUserSettingsInput = {
    shouldShowActivityFeed?: InputMaybe<Scalars["Boolean"]["input"]>;
    shouldShowSpaces?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HomeWidget = {
    __typename?: "HomeWidget";
    id: Scalars["ID"]["output"];
    state: HomeWidgetState;
};

export type HomeWidgetInput = {
    id: Scalars["ID"]["input"];
    state: HomeWidgetState;
};

export enum HomeWidgetState {
    Collapsed = "COLLAPSED",
    Expanded = "EXPANDED"
}

export type Homepage = {
    __typename?: "Homepage";
    title?: Maybe<Scalars["String"]["output"]>;
    uri?: Maybe<Scalars["String"]["output"]>;
};

export type HostedResourcePreSignedUrl = {
    __typename?: "HostedResourcePreSignedUrl";
    uploadFormData: Scalars["JSON"]["output"];
    uploadUrl: Scalars["String"]["output"];
};

export type HostedStorage = {
    __typename?: "HostedStorage";
    classifications?: Maybe<Array<Classification>>;
    locations?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type HtmlDocument = {
    __typename?: "HtmlDocument";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    html?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webResourceDependencies?: Maybe<WebResourceDependencies>;
};

export type HtmlMeta = {
    __typename?: "HtmlMeta";
    css: Scalars["String"]["output"];
    html: Scalars["String"]["output"];
    js: Array<Maybe<Scalars["String"]["output"]>>;
    spaUnfriendlyMacros: Array<SpaUnfriendlyMacro>;
};

export type Icon = {
    __typename?: "Icon";
    height?: Maybe<Scalars["Int"]["output"]>;
    isDefault?: Maybe<Scalars["Boolean"]["output"]>;
    path: Scalars["String"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
    width?: Maybe<Scalars["Int"]["output"]>;
};

export type IconPathArgs = {
    type?: InputMaybe<PathType>;
};

export type InCompleteCardsDestination = {
    __typename?: "InCompleteCardsDestination";
    destination?: Maybe<SoftwareCardsDestinationEnum>;
    sprintId?: Maybe<Scalars["ID"]["output"]>;
    sprintName?: Maybe<Scalars["String"]["output"]>;
};

export type IncomingLinksCount = {
    __typename?: "IncomingLinksCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
};

export type IndividualInlineTaskNotification = {
    __typename?: "IndividualInlineTaskNotification";
    notificationAction?: Maybe<NotificationAction>;
    operation: Operation;
    recipientAccountId: Scalars["ID"]["output"];
    recipientMentionLocalId?: Maybe<Scalars["ID"]["output"]>;
    taskId: Scalars["ID"]["output"];
};

export type IndividualInlineTaskNotificationInput = {
    notificationAction?: InputMaybe<NotificationAction>;
    operation: Operation;
    recipientAccountId: Scalars["ID"]["input"];
    recipientMentionLocalId?: InputMaybe<Scalars["ID"]["input"]>;
    taskId: Scalars["ID"]["input"];
};

/** Call-to-action link where the notification is directed to. */
export type InfluentsNotificationAction = {
    __typename?: "InfluentsNotificationAction";
    appearance: InfluentsNotificationAppearance;
    title: Scalars["String"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
};

export type InfluentsNotificationActor = {
    __typename?: "InfluentsNotificationActor";
    actorType?: Maybe<InfluentsNotificationActorType>;
    ari?: Maybe<Scalars["String"]["output"]>;
    avatarURL?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
};

export enum InfluentsNotificationActorType {
    Animated = "animated",
    Url = "url"
}

export type InfluentsNotificationAnalyticsAttribute = {
    __typename?: "InfluentsNotificationAnalyticsAttribute";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export enum InfluentsNotificationAppearance {
    Danger = "DANGER",
    Default = "DEFAULT",
    Link = "LINK",
    Primary = "PRIMARY",
    Subtle = "SUBTLE",
    Warning = "WARNING"
}

/**
 * A body item can be sent with two types of appearances, PRIMARY and QUOTED.
 * The latter can be used to for sending comment reply style notifications.
 */
export type InfluentsNotificationBodyItem = {
    __typename?: "InfluentsNotificationBodyItem";
    appearance?: Maybe<Scalars["String"]["output"]>;
    author?: Maybe<InfluentsNotificationActor>;
    document?: Maybe<InfluentsNotificationDocument>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export enum InfluentsNotificationCategory {
    Direct = "direct",
    Watching = "watching"
}

export type InfluentsNotificationContent = {
    __typename?: "InfluentsNotificationContent";
    actions?: Maybe<Array<InfluentsNotificationAction>>;
    actor: InfluentsNotificationActor;
    bodyItems?: Maybe<Array<InfluentsNotificationBodyItem>>;
    entity?: Maybe<InfluentsNotificationEntity>;
    message: Scalars["String"]["output"];
    path?: Maybe<Array<InfluentsNotificationPath>>;
    templateVariables?: Maybe<Array<InfluentsNotificationTemplateVariable>>;
    type: Scalars["String"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
};

export type InfluentsNotificationDocument = {
    __typename?: "InfluentsNotificationDocument";
    data?: Maybe<Scalars["String"]["output"]>;
    format?: Maybe<Scalars["String"]["output"]>;
};

/**
 * The Entity is what the notification relates to –
 * in most cases it’s the object (page, issue, pull request) that has been interacted with.
 * Clicking the title takes the user to the entity.
 * An entity can have a related icon.
 */
export type InfluentsNotificationEntity = {
    __typename?: "InfluentsNotificationEntity";
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type InfluentsNotificationEntityModel = {
    __typename?: "InfluentsNotificationEntityModel";
    cloudId?: Maybe<Scalars["String"]["output"]>;
    containerId?: Maybe<Scalars["String"]["output"]>;
    objectId: Scalars["String"]["output"];
    workspaceId?: Maybe<Scalars["String"]["output"]>;
};

/** Notification Feed with pagination cursor */
export type InfluentsNotificationFeedConnection = {
    __typename?: "InfluentsNotificationFeedConnection";
    edges: Array<InfluentsNotificationFeedEdge>;
    nodes: Array<InfluentsNotificationHeadItem>;
    pageInfo: InfluentsNotificationPageInfo;
};

export type InfluentsNotificationFeedEdge = {
    __typename?: "InfluentsNotificationFeedEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: InfluentsNotificationHeadItem;
};

export type InfluentsNotificationFilter = {
    categoryFilter?: InputMaybe<InfluentsNotificationCategory>;
    productFilter?: InputMaybe<Scalars["String"]["input"]>;
    readStateFilter?: InputMaybe<InfluentsNotificationReadState>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Notification Group connection with pagination cursor */
export type InfluentsNotificationGroupConnection = {
    __typename?: "InfluentsNotificationGroupConnection";
    edges: Array<InfluentsNotificationGroupEdge>;
    nodes: Array<InfluentsNotificationItem>;
    pageInfo: InfluentsNotificationPageInfo;
};

export type InfluentsNotificationGroupEdge = {
    __typename?: "InfluentsNotificationGroupEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: InfluentsNotificationItem;
};

/**
 * A grouped notification item containing the head notification item from each group
 * along with the count of items grouped/collapsed.
 */
export type InfluentsNotificationHeadItem = {
    __typename?: "InfluentsNotificationHeadItem";
    additionalActors: Array<InfluentsNotificationActor>;
    additionalTypes: Array<Scalars["String"]["output"]>;
    /** Pagination cursor for excluding the current item from subsequent requests. */
    endCursor?: Maybe<Scalars["String"]["output"]>;
    groupId: Scalars["ID"]["output"];
    groupSize: Scalars["Int"]["output"];
    headNotification: InfluentsNotificationItem;
    readStates: Array<Maybe<Scalars["String"]["output"]>>;
};

/** A single user notification item. */
export type InfluentsNotificationItem = {
    __typename?: "InfluentsNotificationItem";
    analyticsAttributes?: Maybe<Array<InfluentsNotificationAnalyticsAttribute>>;
    category: InfluentsNotificationCategory;
    content: InfluentsNotificationContent;
    /**
     * An optional field that contains Atlassian Entity details
     * associated with the Notification event.
     */
    entityModel?: Maybe<InfluentsNotificationEntityModel>;
    /** Unique identity of the notification */
    notificationId: Scalars["ID"]["output"];
    readState: InfluentsNotificationReadState;
    timestamp: Scalars["DateTime"]["output"];
    workspaceId?: Maybe<Scalars["String"]["output"]>;
};

export type InfluentsNotificationMutation = {
    __typename?: "InfluentsNotificationMutation";
    /**
     * API for archiving all of a users notifications
     * Note: Notifications will be removed from the datastore.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    archiveAllNotifications?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for archiving the notifications specified by ids.
     * Note: Notifications will be removed from the datastore.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    archiveNotifications?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for archiving the notifications specified by group id.
     * Note: Notifications will be removed from the datastore.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    archiveNotificationsByGroupId?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for clearning unseen notification count for a user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clearUnseenCount?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for marking the state of notifications(that belong to a particular product and category) as Read.
     *
     * With this endpoint clients can implement 'markAllAsRead' functionality.
     * Only one before query parameter (beforeInclusive or beforeInclusiveTimestamp) .
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    markNotificationsAsRead?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for marking grouped notifications as read.
     * With this endpoint clients can implement 'markAllAsRead' functionality for grouped notifications.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    markNotificationsByGroupIdAsRead?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for marking grouped notifications as unread.
     * With this endpoint clients can implement 'markAllAsUnRead' functionality for grouped notifications.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    markNotificationsByGroupIdAsUnread?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for marking the notifications specified by ids as read.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    markNotificationsByIdsAsRead?: Maybe<Scalars["String"]["output"]>;
    /**
     * API for marking the state of notifications specified by ids as unread
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    markNotificationsByIdsAsUnread?: Maybe<Scalars["String"]["output"]>;
};

export type InfluentsNotificationMutationArchiveAllNotificationsArgs = {
    beforeInclusive?: InputMaybe<Scalars["String"]["input"]>;
    beforeInclusiveTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    category?: InputMaybe<InfluentsNotificationCategory>;
    product?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InfluentsNotificationMutationArchiveNotificationsArgs = {
    ids: Array<Scalars["String"]["input"]>;
};

export type InfluentsNotificationMutationArchiveNotificationsByGroupIdArgs = {
    beforeInclusive?: InputMaybe<Scalars["String"]["input"]>;
    category?: InputMaybe<InfluentsNotificationCategory>;
    groupId: Scalars["String"]["input"];
};

export type InfluentsNotificationMutationClearUnseenCountArgs = {
    product?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InfluentsNotificationMutationMarkNotificationsAsReadArgs = {
    beforeInclusive?: InputMaybe<Scalars["String"]["input"]>;
    beforeInclusiveTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    category?: InputMaybe<InfluentsNotificationCategory>;
    product?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InfluentsNotificationMutationMarkNotificationsByGroupIdAsReadArgs =
    {
        beforeInclusive?: InputMaybe<Scalars["String"]["input"]>;
        category?: InputMaybe<InfluentsNotificationCategory>;
        groupId: Scalars["String"]["input"];
    };

export type InfluentsNotificationMutationMarkNotificationsByGroupIdAsUnreadArgs =
    {
        beforeInclusive?: InputMaybe<Scalars["String"]["input"]>;
        category?: InputMaybe<InfluentsNotificationCategory>;
        groupId: Scalars["String"]["input"];
    };

export type InfluentsNotificationMutationMarkNotificationsByIdsAsReadArgs = {
    ids: Array<Scalars["String"]["input"]>;
};

export type InfluentsNotificationMutationMarkNotificationsByIdsAsUnreadArgs = {
    ids: Array<Scalars["String"]["input"]>;
};

export type InfluentsNotificationPageInfo = {
    __typename?: "InfluentsNotificationPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

/**
 * A path provides context for the entity.
 * This is particularly important if this is the first time the recipient has been made aware of the resource, or if multiple entities use the same or similar titles. The contents of the path are user defined, you may choose to end with the entity or not to.
 */
export type InfluentsNotificationPath = {
    __typename?: "InfluentsNotificationPath";
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type InfluentsNotificationQuery = {
    __typename?: "InfluentsNotificationQuery";
    /**
     * API for fetching user's notifications.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    notificationFeed: InfluentsNotificationFeedConnection;
    /**
     * API for fetching all notifications(not just the head notification) that belongs to a specific group.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    notificationGroup: InfluentsNotificationGroupConnection;
    /**
     * API for fetching user's un-read direct notification count.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    unseenNotificationCount: Scalars["Int"]["output"];
};

export type InfluentsNotificationQueryNotificationFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<InfluentsNotificationFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    flat?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InfluentsNotificationQueryNotificationGroupArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<InfluentsNotificationFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupId: Scalars["String"]["input"];
};

export type InfluentsNotificationQueryUnseenNotificationCountArgs = {
    product?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export enum InfluentsNotificationReadState {
    Read = "read",
    Unread = "unread"
}

export type InfluentsNotificationTemplateVariable = {
    __typename?: "InfluentsNotificationTemplateVariable";
    fallback: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    type: Scalars["String"]["output"];
};

export enum InitialPermissionOptions {
    CopyFromSpace = "COPY_FROM_SPACE",
    Default = "DEFAULT",
    Private = "PRIVATE"
}

export type InlineCardCreateConfig = {
    __typename?: "InlineCardCreateConfig";
    /** Whether inline create is enabled */
    enabled: Scalars["Boolean"]["output"];
    /** Whether the global create should be used when creating */
    useGlobalCreate?: Maybe<Scalars["Boolean"]["output"]>;
};

export type InlineColumnEditConfig = {
    __typename?: "InlineColumnEditConfig";
    enabled: Scalars["Boolean"]["output"];
};

export type InlineComment = CommentLocation & {
    __typename?: "InlineComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineCommentRepliesCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineMarkerRef?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineResolveProperties?: Maybe<InlineCommentResolveProperties>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineText?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: Scalars["String"]["output"];
};

export type InlineCommentResolveProperties = {
    __typename?: "InlineCommentResolveProperties";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolved: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedByDangling: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedFriendlyDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedTime?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolvedUser?: Maybe<Scalars["String"]["output"]>;
};

/** Represents an inline-rendered smart-link on a page */
export type InlineSmartLink = SmartLink & {
    __typename?: "InlineSmartLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type InlineTask = {
    status: TaskStatus;
    taskId: Scalars["ID"]["input"];
};

export type InlineTasksByMetadata = {
    accountIds?: InputMaybe<InlineTasksQueryAccountIds>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** The date range for an Inline Tasks' Completed Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
    completedDateRange?: InputMaybe<InlineTasksQueryDateRange>;
    /** The date range for an Inline Tasks' Created Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
    createdDateRange?: InputMaybe<InlineTasksQueryDateRange>;
    /** The date range for an Inline Tasks' Due Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
    dueDate?: InputMaybe<InlineTasksQueryDateRange>;
    first: Scalars["Int"]["input"];
    /** A boolean value representing whether to return task on current page or on child pages as well */
    forCurrentPageOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A boolean value representing whether or not a Task has a set due date. False indicates no due date set for a given task. */
    isNoDueDate?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    /** Supported sort columns for a Task query are: `due date`, `assignee`, and `page title`. Supported sort columns are `ASC` or `DESC`. */
    sortParameters?: InputMaybe<InlineTasksQuerySortParameters>;
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    status?: InputMaybe<TaskStatus>;
};

export type InlineTasksInput = {
    cid: Scalars["ID"]["input"];
    status: TaskStatus;
    taskId: Scalars["ID"]["input"];
    trigger?: InputMaybe<PageUpdateTrigger>;
};

export type InlineTasksQueryAccountIds = {
    assigneeAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    completedByAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    creatorAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
};

/** The date range for an Inline Tasks Query Date. Start dates and end dates can be null-able to represent no specified boundary. */
export type InlineTasksQueryDateRange = {
    endDate?: InputMaybe<Scalars["Long"]["input"]>;
    startDate?: InputMaybe<Scalars["Long"]["input"]>;
};

export type InlineTasksQueryResult = {
    __typename?: "InlineTasksQueryResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    endCursor?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inlineTasks?: Maybe<Array<Maybe<GraphQlInlineTask>>>;
};

export enum InlineTasksQuerySortColumn {
    Assignee = "ASSIGNEE",
    DueDate = "DUE_DATE",
    PageTitle = "PAGE_TITLE"
}

export enum InlineTasksQuerySortOrder {
    Ascending = "ASCENDING",
    Descending = "DESCENDING"
}

export type InlineTasksQuerySortParameters = {
    sortColumn: InlineTasksQuerySortColumn;
    sortOrder: InlineTasksQuerySortOrder;
};

export type Insights = {
    __typename?: "Insights";
    /**
     * GitHub onboarding information for the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "InsightsGithubOnboarding")' query directive to the 'githubOnboardingDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    githubOnboardingDetails: InsightsGithubOnboardingDetails;
};

export type InsightsGithubOnboardingDetailsArgs = {
    cloudId: Scalars["ID"]["input"];
    projectAri?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input for the mutation operations (snooze and remove). */
export type InsightsActionNextBestTaskInput = {
    /** Next best task id */
    taskId: Scalars["String"]["input"];
};

export type InsightsActionNextBestTaskPayload = Payload & {
    __typename?: "InsightsActionNextBestTaskPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Action object stored in the database */
    userActionState?: Maybe<InsightsUserActionState>;
};

/** Input for the onboarding mutation operations (purge / snooze / remove). */
export type InsightsGithubOnboardingActionInput = {
    /** Cloud id */
    cloudId: Scalars["ID"]["input"];
};

export type InsightsGithubOnboardingActionResponse = Payload & {
    __typename?: "InsightsGithubOnboardingActionResponse";
    /** The Github display name for the user if it's available */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type InsightsGithubOnboardingDetails = {
    __typename?: "InsightsGithubOnboardingDetails";
    outboundAuthUrl: Scalars["String"]["output"];
    recommendationVisibility: InsightsRecommendationVisibility;
};

export type InsightsMutation = {
    __typename?: "InsightsMutation";
    /**
     * Execute action to complete the github onboarding after successful authentication from nbt panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "InsightsCompleteOnboarding")' query directive to the 'completeOnboarding' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    completeOnboarding?: Maybe<InsightsGithubOnboardingActionResponse>;
    /**
     * Execute action to remove the github onboarding message from the next best task panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "InsightsRemoveOnboarding")' query directive to the 'removeOnboarding' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeOnboarding?: Maybe<InsightsGithubOnboardingActionResponse>;
    /**
     * Execute action to remove a task from the next best task panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    removeTask?: Maybe<InsightsActionNextBestTaskPayload>;
    /**
     * Execute action to snooze the github onboarding message from the next best task panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "InsightsSnoozeOnboarding")' query directive to the 'snoozeOnboarding' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    snoozeOnboarding?: Maybe<InsightsGithubOnboardingActionResponse>;
    /**
     * Execute action to snooze a task from the next best task panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    snoozeTask?: Maybe<InsightsActionNextBestTaskPayload>;
};

export type InsightsMutationCompleteOnboardingArgs = {
    input: InsightsGithubOnboardingActionInput;
};

export type InsightsMutationRemoveOnboardingArgs = {
    input: InsightsGithubOnboardingActionInput;
};

export type InsightsMutationRemoveTaskArgs = {
    cloudId: Scalars["ID"]["input"];
    input: InsightsActionNextBestTaskInput;
};

export type InsightsMutationSnoozeOnboardingArgs = {
    input: InsightsGithubOnboardingActionInput;
};

export type InsightsMutationSnoozeTaskArgs = {
    cloudId: Scalars["ID"]["input"];
    input: InsightsActionNextBestTaskInput;
};

export type InsightsMutationErrorExtension = MutationErrorExtension & {
    __typename?: "InsightsMutationErrorExtension";
    /**
     * Application specific error type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (such as a HTTP status code) representing the error category
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export enum InsightsNextBestTaskAction {
    Remove = "REMOVE",
    Snooze = "SNOOZE"
}

/**
 * Defines whether we show the github onboarding UX
 * VISIBLE means JFE should render the onboarding UX
 * HIDDEN means user is already onboarded, do not show UX
 * SNOOZED means user snoozed the recommendation
 * REMOVED means user explicitly hid the recommendation
 */
export enum InsightsRecommendationVisibility {
    Hidden = "HIDDEN",
    Removed = "REMOVED",
    Snoozed = "SNOOZED",
    Visible = "VISIBLE"
}

/** Action object stored in the database for the actions snooze/remove task. */
export type InsightsUserActionState = {
    __typename?: "InsightsUserActionState";
    /** Date when the action expires */
    expireAt: Scalars["String"]["output"];
    /** Reason for the action (snooze or remove) */
    reason: InsightsNextBestTaskAction;
    /** Next best task id */
    taskId: Scalars["String"]["output"];
};

export enum InspectPermissions {
    Comment = "COMMENT",
    Edit = "EDIT",
    View = "VIEW"
}

export type InstallationContext = {
    __typename?: "InstallationContext";
    /**
     * Environment Id of the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    environmentId: Scalars["ID"]["output"];
    /**
     * Indicates whether the installation context has log access
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasLogAccess: Scalars["Boolean"]["output"];
    /**
     * Installation context as an ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    installationContext: Scalars["ID"]["output"];
    /**
     * The tenant context for the cloud id. Only populated if context id is a valid cloud context. The batch size can only be a maximum can 20. Do not change it to any higher.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    tenantContext?: Maybe<TenantContext>;
};

export type InstallationContextWithLogAccess = {
    __typename?: "InstallationContextWithLogAccess";
    /**
     * Installation context as an ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    installationContext: Scalars["ID"]["output"];
    /**
     * The tenant context for the cloud id. Only populated if context id is a valid cloud context. The batch size can only be a maximum can 20. Do not change it to any higher.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    tenantContext?: Maybe<TenantContext>;
};

export type InstallationSummary = {
    __typename?: "InstallationSummary";
    app: InstallationSummaryApp;
    licenseId?: Maybe<Scalars["String"]["output"]>;
};

export type InstallationSummaryApp = {
    __typename?: "InstallationSummaryApp";
    definitionId?: Maybe<Scalars["ID"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    environment: InstallationSummaryAppEnvironment;
    id?: Maybe<Scalars["ID"]["output"]>;
    installationId?: Maybe<Scalars["ID"]["output"]>;
    isSystemApp?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    oauthClientId?: Maybe<Scalars["String"]["output"]>;
};

export type InstallationSummaryAppEnvironment = {
    __typename?: "InstallationSummaryAppEnvironment";
    id?: Maybe<Scalars["ID"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    version: InstallationSummaryAppEnvironmentVersion;
};

export type InstallationSummaryAppEnvironmentVersion = {
    __typename?: "InstallationSummaryAppEnvironmentVersion";
    id?: Maybe<Scalars["ID"]["output"]>;
    version?: Maybe<Scalars["String"]["output"]>;
};

export type InstallationsListFilterByAppEnvironments = {
    types: Array<AppEnvironmentType>;
};

export type InstallationsListFilterByAppInstallations = {
    /** An array of unique ARI's representing app installation contexts */
    contexts?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** An array of unique ARI's representing apps */
    ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type InstallationsListFilterByAppInstallationsWithCompulsoryContexts = {
    /** An array of unique ARI's representing app installation contexts */
    contexts: Array<Scalars["ID"]["input"]>;
    /** An array of unique environment identifiers */
    environmentIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** An array of unique installation identifiers */
    ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type InstallationsListFilterByApps = {
    /** An array of unique ARI's representing apps */
    ids: Array<Scalars["ID"]["input"]>;
};

export type InstanceAnalyticsCount = {
    __typename?: "InstanceAnalyticsCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    user: Scalars["Int"]["output"];
};

export type IntervalFilter = {
    /**
     * Query end time as an ISO-8601 timestamp e.g. "2022-11-24T15:00:00.000Z"
     * See https://date-fns.org/v2.29.3/docs/parseISO
     */
    end: Scalars["String"]["input"];
    /**
     * Query start time as an ISO-8601 timestamp e.g. "2022-11-24T15:00:00.000Z"
     * See https://date-fns.org/v2.29.3/docs/parseISO
     */
    start: Scalars["String"]["input"];
};

export type IntervalInput = {
    endTime: Scalars["DateTime"]["input"];
    startTime: Scalars["DateTime"]["input"];
};

/** The metrics returned on each invocation */
export type InvocationMetrics = {
    __typename?: "InvocationMetrics";
    /** App execution region, as reported by XIS */
    appExecutionRegion?: Maybe<Scalars["String"]["output"]>;
    /** App execution time, as measured by XIS */
    appTimeMs?: Maybe<Scalars["Float"]["output"]>;
};

/** The data returned from a function invocation */
export type InvocationResponsePayload = {
    __typename?: "InvocationResponsePayload";
    /** Whether the function was invoked asynchronously */
    async: Scalars["Boolean"]["output"];
    /** The body of the function response */
    body: Scalars["JSON"]["output"];
};

/** Input payload for the invoke aux mutation */
export type InvokeAuxEffectsInput = {
    /**
     * The list of applicable context Ids
     * Context Ids are used within the ecosystem platform to identify product
     * controlled areas into which apps can be installed. Host products should
     * determine how this list of contexts is constructed.
     *
     * *Important:* this should start with the most specific context as the
     * most specific extension will be the selected extension.
     */
    contextIds: Array<Scalars["ID"]["input"]>;
    /** An identifier for an alternative entry point function to invoke */
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Information needed to look up an extension
     *
     * Note: Either `extensionDetails` or `extensionId` must be provided
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use extensionId instead.
     */
    extensionDetails?: InputMaybe<ExtensionDetailsInput>;
    /**
     * An identifier for the extension to invoke
     *
     * Note: Either `extensionDetails` or `extensionId` must be provided
     */
    extensionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The payload to invoke an AUX Effect */
    payload: AuxEffectsInvocationPayload;
};

/** The response from an AUX effects invocation */
export type InvokeAuxEffectsResponse = Payload & {
    __typename?: "InvokeAuxEffectsResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    result?: Maybe<AuxEffectsResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input payload for the invoke mutation */
export type InvokeExtensionInput = {
    /** Whether to invoke the function asynchronously if possible */
    async?: InputMaybe<Scalars["Boolean"]["input"]>;
    /**
     * The list of applicable context Ids
     * Context Ids are used within the ecosystem platform to identify product
     * controlled areas into which apps can be installed. Host products should
     * determine how this list of contexts is constructed.
     *
     * *Important:* this should start with the most specific context as the
     * most specific extension will be the selected extension.
     */
    contextIds: Array<Scalars["ID"]["input"]>;
    /** An identifier for an alternative entry point function to invoke */
    entryPoint?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Information needed to look up an extension
     *
     * Note: Either `extensionDetails` or `extensionId` must be provided
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use extensionId instead.
     */
    extensionDetails?: InputMaybe<ExtensionDetailsInput>;
    /**
     * An identifier for the extension to invoke
     *
     * Note: Either `extensionDetails` or `extensionId` must be provided
     */
    extensionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The payload to send as part of the invocation */
    payload: Scalars["JSON"]["input"];
};

export type InvokeExtensionPayloadErrorExtension = MutationErrorExtension & {
    __typename?: "InvokeExtensionPayloadErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fields?: Maybe<InvokeExtensionPayloadErrorExtensionFields>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type InvokeExtensionPayloadErrorExtensionFields = {
    __typename?: "InvokeExtensionPayloadErrorExtensionFields";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    authInfo?: Maybe<ExternalAuthProvider>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    authInfoUrl?: Maybe<Scalars["String"]["output"]>;
};

/** The response from a function invocation */
export type InvokeExtensionResponse = Payload & {
    __typename?: "InvokeExtensionResponse";
    /**
     * JWT containing verified context data about the invocation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contextToken?: Maybe<ForgeContextToken>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Details about the external auth for this service, if any exists.
     *
     * This is typically used for directing the user to a consent screen.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    externalAuth?: Maybe<Array<Maybe<ExternalAuthProvider>>>;
    /**
     * Metrics related to the invocation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    metrics?: Maybe<InvocationMetrics>;
    /**
     * The invocation response
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    response?: Maybe<InvocationResponsePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type InvokePolarisObjectInput = {
    /** Snippet action */
    action: Scalars["JSON"]["input"];
    /** Custom auth token that will be used in unfurl request and saved if request was successful */
    authToken?: InputMaybe<Scalars["String"]["input"]>;
    /** Snippet data */
    data: Scalars["JSON"]["input"];
    /** Issue ARI */
    issue: Scalars["ID"]["input"];
    /** OauthClientId of CaaS app */
    oauthClientId: Scalars["String"]["input"];
    /** Project ARI */
    project: Scalars["ID"]["input"];
    /** Resource url that will be used to unfurl data */
    resourceUrl: Scalars["String"]["input"];
};

export type InvokePolarisObjectPayload = Payload & {
    __typename?: "InvokePolarisObjectPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    response?: Maybe<ResolvedPolarisObject>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Detailed information of a repository's branch */
export type IssueDevOpsBranchDetails = {
    __typename?: "IssueDevOpsBranchDetails";
    createPullRequestUrl?: Maybe<Scalars["String"]["output"]>;
    createReviewUrl?: Maybe<Scalars["String"]["output"]>;
    lastCommit?: Maybe<IssueDevOpsHeadCommit>;
    name: Scalars["String"]["output"];
    pullRequests?: Maybe<Array<IssueDevOpsBranchPullRequestStatesSummary>>;
    reviews?: Maybe<Array<IssueDevOpsReview>>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Short description of a pull request associated with a branch */
export type IssueDevOpsBranchPullRequestStatesSummary = {
    __typename?: "IssueDevOpsBranchPullRequestStatesSummary";
    /** Time of the last update in ISO 8601 format */
    lastUpdate?: Maybe<Scalars["DateTime"]["output"]>;
    name: Scalars["String"]["output"];
    status?: Maybe<IssueDevOpsPullRequestStatus>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Detailed information about a build tied to a provider */
export type IssueDevOpsBuildDetail = {
    __typename?: "IssueDevOpsBuildDetail";
    buildNumber?: Maybe<Scalars["Int"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    references?: Maybe<Array<IssueDevOpsBuildReference>>;
    state?: Maybe<Scalars["String"]["output"]>;
    testSummary?: Maybe<IssueDevOpsTestSummary>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** A build pipeline provider */
export type IssueDevOpsBuildProvider = {
    __typename?: "IssueDevOpsBuildProvider";
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    builds?: Maybe<Array<IssueDevOpsBuildDetail>>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Information that links a build to a version control system (commits, branches, etc.) */
export type IssueDevOpsBuildReference = {
    __typename?: "IssueDevOpsBuildReference";
    name: Scalars["String"]["output"];
    uri?: Maybe<Scalars["String"]["output"]>;
};

export enum IssueDevOpsCommitChangeType {
    Added = "ADDED",
    Copied = "COPIED",
    Deleted = "DELETED",
    Modified = "MODIFIED",
    /** Deprecated - use MODIFIED instead. */
    Modify = "MODIFY",
    Moved = "MOVED",
    Unknown = "UNKNOWN"
}

/** Detailed information of a commit in a repository */
export type IssueDevOpsCommitDetails = {
    __typename?: "IssueDevOpsCommitDetails";
    author?: Maybe<IssueDevOpsPullRequestAuthor>;
    createReviewUrl?: Maybe<Scalars["String"]["output"]>;
    displayId?: Maybe<Scalars["String"]["output"]>;
    files?: Maybe<Array<IssueDevOpsCommitFile>>;
    id: Scalars["String"]["output"];
    isMerge?: Maybe<Scalars["Boolean"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
    reviews?: Maybe<Array<IssueDevOpsReview>>;
    /** Time of the commit update in ISO 8601 format */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Information of a file modified in a commit */
export type IssueDevOpsCommitFile = {
    __typename?: "IssueDevOpsCommitFile";
    changeType?: Maybe<IssueDevOpsCommitChangeType>;
    linesAdded?: Maybe<Scalars["Int"]["output"]>;
    linesRemoved?: Maybe<Scalars["Int"]["output"]>;
    path: Scalars["String"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Detailed information of a deployment */
export type IssueDevOpsDeploymentDetails = {
    __typename?: "IssueDevOpsDeploymentDetails";
    displayName?: Maybe<Scalars["String"]["output"]>;
    environment?: Maybe<IssueDevOpsDeploymentEnvironment>;
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    pipelineDisplayName?: Maybe<Scalars["String"]["output"]>;
    pipelineId: Scalars["String"]["output"];
    pipelineUrl?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<IssueDevOpsDeploymentState>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsDeploymentEnvironment = {
    __typename?: "IssueDevOpsDeploymentEnvironment";
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    type?: Maybe<IssueDevOpsDeploymentEnvironmentType>;
};

export enum IssueDevOpsDeploymentEnvironmentType {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

/**
 * This object witholds deployment providers essential information,
 * as well as its list of latest deployments per pipeline.
 * A provider without deployments related to the asked issueId will not be returned.
 */
export type IssueDevOpsDeploymentProviderDetails = {
    __typename?: "IssueDevOpsDeploymentProviderDetails";
    /** A list of the latest deployments of each pipeline */
    deployments?: Maybe<Array<IssueDevOpsDeploymentDetails>>;
    homeUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    logoUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export enum IssueDevOpsDeploymentState {
    Cancelled = "CANCELLED",
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    RolledBack = "ROLLED_BACK",
    Successful = "SUCCESSFUL",
    Unknown = "UNKNOWN"
}

/** Aggregates all the instance types (bitbucket, stash, github) and its development information */
export type IssueDevOpsDetails = {
    __typename?: "IssueDevOpsDetails";
    deploymentProviders?: Maybe<Array<IssueDevOpsDeploymentProviderDetails>>;
    embeddedMarketplace: IssueDevOpsEmbeddedMarketplace;
    featureFlagProviders?: Maybe<Array<IssueDevOpsFeatureFlagProvider>>;
    instanceTypes: Array<IssueDevOpsProviderInstance>;
    remoteLinksByType?: Maybe<IssueDevOpsRemoteLinksByType>;
};

/** Information related to the development process of an issue */
export type IssueDevOpsDevelopmentInformation = {
    __typename?: "IssueDevOpsDevelopmentInformation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    details?: Maybe<IssueDevOpsDetails>;
};

/** Information related to the development process of an issue */
export type IssueDevOpsDevelopmentInformationDetailsArgs = {
    instanceTypes?: Array<Scalars["String"]["input"]>;
};

/**
 * A set of booleans that indicate if the embedded marketplace
 * should be shown if a user does not have installed providers
 */
export type IssueDevOpsEmbeddedMarketplace = {
    __typename?: "IssueDevOpsEmbeddedMarketplace";
    shouldDisplayForBuilds: Scalars["Boolean"]["output"];
    shouldDisplayForDeployments: Scalars["Boolean"]["output"];
    shouldDisplayForFeatureFlags: Scalars["Boolean"]["output"];
};

export type IssueDevOpsFeatureFlag = {
    __typename?: "IssueDevOpsFeatureFlag";
    details?: Maybe<Array<IssueDevOpsFeatureFlagDetails>>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** the identifier for the feature flag as provided */
    id: Scalars["String"]["output"];
    key?: Maybe<Scalars["String"]["output"]>;
    /** Can be used to link to a provider record if required */
    providerId?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<IssueDevOpsFeatureFlagSummary>;
};

export type IssueDevOpsFeatureFlagDetails = {
    __typename?: "IssueDevOpsFeatureFlagDetails";
    environment?: Maybe<IssueDevOpsFeatureFlagEnvironment>;
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<IssueDevOpsFeatureFlagStatus>;
    url: Scalars["String"]["output"];
};

export type IssueDevOpsFeatureFlagEnvironment = {
    __typename?: "IssueDevOpsFeatureFlagEnvironment";
    name: Scalars["String"]["output"];
    type?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsFeatureFlagProvider = {
    __typename?: "IssueDevOpsFeatureFlagProvider";
    createFlagTemplateUrl?: Maybe<Scalars["String"]["output"]>;
    featureFlags?: Maybe<Array<IssueDevOpsFeatureFlag>>;
    id: Scalars["String"]["output"];
    linkFlagTemplateUrl?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsFeatureFlagRollout = {
    __typename?: "IssueDevOpsFeatureFlagRollout";
    percentage?: Maybe<Scalars["Float"]["output"]>;
    rules?: Maybe<Scalars["Int"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsFeatureFlagStatus = {
    __typename?: "IssueDevOpsFeatureFlagStatus";
    defaultValue?: Maybe<Scalars["String"]["output"]>;
    enabled: Scalars["Boolean"]["output"];
    rollout?: Maybe<IssueDevOpsFeatureFlagRollout>;
};

export type IssueDevOpsFeatureFlagSummary = {
    __typename?: "IssueDevOpsFeatureFlagSummary";
    lastUpdated?: Maybe<Scalars["String"]["output"]>;
    status: IssueDevOpsFeatureFlagStatus;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Latest commit on a branch */
export type IssueDevOpsHeadCommit = {
    __typename?: "IssueDevOpsHeadCommit";
    displayId: Scalars["String"]["output"];
    /** Time of the commit in ISO 8601 format */
    timestamp?: Maybe<Scalars["DateTime"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Detailed information of an instance and its data (source data, build data, deployment data) */
export type IssueDevOpsProviderInstance = {
    __typename?: "IssueDevOpsProviderInstance";
    baseUrl?: Maybe<Scalars["String"]["output"]>;
    buildProviders?: Maybe<Array<IssueDevOpsBuildProvider>>;
    /**
     * There are common cases where a Pull Request is merged and its branch is deleted.
     * The downstream sources do not provide repository information on the PR, only branches information.
     * When the branch is deleted, it's not possible to create the bridge between PRs and Repository.
     * For this reason, any PR that couldn't be assigned to a repository will appear on this list.
     */
    danglingPullRequests?: Maybe<Array<IssueDevOpsPullRequestDetails>>;
    /**
     * An error message related to this instance passed down from DevStatus
     * These are not GraphQL errors. When an instance type is requested,
     * DevStatus may respond with a list instances and strings nested inside the 'errors' field, as follows:
     * `{ 'errors': [{'_instance': { ... }, error: 'unauthorized' }], detail: [ ... ] }`.
     * The status code for this response however is still 200
     * since only part of the instances requested may present these issues.
     * `devStatusErrorMessage` is deprecated. Use `devStatusErrorMessages`.
     */
    devStatusErrorMessage?: Maybe<Scalars["String"]["output"]>;
    devStatusErrorMessages?: Maybe<Array<Scalars["String"]["output"]>>;
    id: Scalars["String"]["output"];
    /** Indicates if it is possible to return more than a single instance per type. Only possible with FeCru */
    isSingleInstance?: Maybe<Scalars["Boolean"]["output"]>;
    /** The name of the instance type */
    name?: Maybe<Scalars["String"]["output"]>;
    repository?: Maybe<Array<IssueDevOpsRepositoryDetails>>;
    /** Raw type of the instance. e.g. bitbucket, stash, github */
    type?: Maybe<Scalars["String"]["output"]>;
    /** The descriptive name of the instance type. e.g. Bitbucket Cloud */
    typeName?: Maybe<Scalars["String"]["output"]>;
};

/** Description of a pull request or commit author */
export type IssueDevOpsPullRequestAuthor = {
    __typename?: "IssueDevOpsPullRequestAuthor";
    /** The avatar URL of the author */
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
};

/** Detailed information of a pull request */
export type IssueDevOpsPullRequestDetails = {
    __typename?: "IssueDevOpsPullRequestDetails";
    author?: Maybe<IssueDevOpsPullRequestAuthor>;
    branchName?: Maybe<Scalars["String"]["output"]>;
    branchUrl?: Maybe<Scalars["String"]["output"]>;
    commentCount?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["String"]["output"];
    /** Time of the last update in ISO 8601 format */
    lastUpdate?: Maybe<Scalars["DateTime"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    reviewers?: Maybe<Array<IssueDevOpsPullRequestReviewer>>;
    status?: Maybe<IssueDevOpsPullRequestStatus>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Description of a pull request reviewer */
export type IssueDevOpsPullRequestReviewer = {
    __typename?: "IssueDevOpsPullRequestReviewer";
    /** The avatar URL of the reviewer */
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    /** Flag representing if the reviewer has already approved the PR */
    isApproved?: Maybe<Scalars["Boolean"]["output"]>;
    name: Scalars["String"]["output"];
};

export enum IssueDevOpsPullRequestStatus {
    Declined = "DECLINED",
    Draft = "DRAFT",
    Merged = "MERGED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

export type IssueDevOpsRemoteLink = {
    __typename?: "IssueDevOpsRemoteLink";
    actionIds?: Maybe<Array<Scalars["String"]["output"]>>;
    attributeMap?: Maybe<Array<IssueDevOpsRemoteLinkAttributeTuple>>;
    description?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    providerId?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<IssueDevOpsRemoteLinkStatus>;
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsRemoteLinkAttributeTuple = {
    __typename?: "IssueDevOpsRemoteLinkAttributeTuple";
    key: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type IssueDevOpsRemoteLinkLabel = {
    __typename?: "IssueDevOpsRemoteLinkLabel";
    value: Scalars["String"]["output"];
};

export type IssueDevOpsRemoteLinkProvider = {
    __typename?: "IssueDevOpsRemoteLinkProvider";
    actions?: Maybe<Array<IssueDevOpsRemoteLinkProviderAction>>;
    documentationUrl?: Maybe<Scalars["String"]["output"]>;
    homeUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    logoUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsRemoteLinkProviderAction = {
    __typename?: "IssueDevOpsRemoteLinkProviderAction";
    id: Scalars["String"]["output"];
    label?: Maybe<IssueDevOpsRemoteLinkLabel>;
    templateUrl?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsRemoteLinkStatus = {
    __typename?: "IssueDevOpsRemoteLinkStatus";
    appearance?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
};

export type IssueDevOpsRemoteLinkType = {
    __typename?: "IssueDevOpsRemoteLinkType";
    remoteLinks?: Maybe<Array<IssueDevOpsRemoteLink>>;
    type: Scalars["String"]["output"];
};

export type IssueDevOpsRemoteLinksByType = {
    __typename?: "IssueDevOpsRemoteLinksByType";
    providers: Array<IssueDevOpsRemoteLinkProvider>;
    types: Array<IssueDevOpsRemoteLinkType>;
};

/** Detailed information of a VCS repository */
export type IssueDevOpsRepositoryDetails = {
    __typename?: "IssueDevOpsRepositoryDetails";
    /** The repository avatar URL */
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    branches?: Maybe<Array<IssueDevOpsBranchDetails>>;
    commits?: Maybe<Array<IssueDevOpsCommitDetails>>;
    description?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
    /** A reference to the parent repository from where this has been forked for */
    parent?: Maybe<IssueDevOpsRepositoryParent>;
    pullRequests?: Maybe<Array<IssueDevOpsPullRequestDetails>>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Short description of the parent repository from which the fork was made */
export type IssueDevOpsRepositoryParent = {
    __typename?: "IssueDevOpsRepositoryParent";
    name: Scalars["String"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Short desciption of a review associated with a branch or commit */
export type IssueDevOpsReview = {
    __typename?: "IssueDevOpsReview";
    id: Scalars["String"]["output"];
    state?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** A summary for the tests results for a particular build */
export type IssueDevOpsTestSummary = {
    __typename?: "IssueDevOpsTestSummary";
    numberFailed?: Maybe<Scalars["Int"]["output"]>;
    numberPassed?: Maybe<Scalars["Int"]["output"]>;
    numberSkipped?: Maybe<Scalars["Int"]["output"]>;
    totalNumber?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents the Atlassian Document Format content in JSON format. */
export type JiraAdf = {
    __typename?: "JiraADF";
    /** The content of ADF converted to plain text(non wiki). The output can be truncated by using firstNCharacters param. */
    convertedPlainText?: Maybe<JiraAdfToConvertedPlainText>;
    /** The content of ADF in JSON. */
    json?: Maybe<Scalars["JSON"]["output"]>;
};

/** Represents the Atlassian Document Format content in JSON format. */
export type JiraAdfConvertedPlainTextArgs = {
    firstNCharacters?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for ADF values on fields */
export type JiraAdfInput = {
    /** ADF based input for rich text field */
    jsonValue?: InputMaybe<Scalars["JSON"]["input"]>;
    /** A numeric id for the version */
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Shows the Atlassian Intelligence feature to the end user. */
export type JiraAccessAtlassianIntelligenceFeature = {
    __typename?: "JiraAccessAtlassianIntelligenceFeature";
    /** Boolean indicating if the Atlassian Intelligence feature is accessible. */
    isAccessible?: Maybe<Scalars["Boolean"]["output"]>;
};

/** The different action types that a user can perform on a global level */
export enum JiraActionType {
    /** Can current user create a Company Managed project */
    CreateCompanyManagedProject = "CREATE_COMPANY_MANAGED_PROJECT",
    /** Can current user create any project */
    CreateProject = "CREATE_PROJECT",
    /** Can current user create a Team Managed project */
    CreateTeamManagedProject = "CREATE_TEAM_MANAGED_PROJECT"
}

export type JiraActiveBackgroundDetailsResult =
    | JiraAttachmentBackground
    | JiraColorBackground
    | JiraGradientBackground
    | JiraMediaBackground
    | QueryError;

export type JiraActivityConfiguration = {
    __typename?: "JiraActivityConfiguration";
    /** Field value mapping. It contains list of object which is like a map entry including a string key and array of string value */
    fieldValues?: Maybe<Array<Maybe<JiraActivityFieldValueKeyValuePair>>>;
    /** Id of the activity configuration */
    id: Scalars["ID"]["output"];
    /** Name of the activity */
    issueType?: Maybe<JiraIssueType>;
    /** Name of the activity configuration */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Name of the activity */
    project?: Maybe<JiraProject>;
    /** Name of the activity */
    requestType?: Maybe<JiraServiceManagementRequestType>;
};

export type JiraActivityFieldValueKeyValuePair = {
    __typename?: "JiraActivityFieldValueKeyValuePair";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type JiraActivityFieldValueKeyValuePairInput = {
    key: Scalars["String"]["input"];
    value: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type JiraAddFieldsToProjectInput = {
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId: Scalars["ID"]["input"];
    /** Unique identifiers of the fields to be added. */
    fieldIds: Array<Scalars["ID"]["input"]>;
    /** Unique identifier of the project. */
    projectId: Scalars["ID"]["input"];
};

export type JiraAddFieldsToProjectPayload = Payload & {
    __typename?: "JiraAddFieldsToProjectPayload";
    /** Return newly added field associations */
    addedFieldAssociations?: Maybe<JiraFieldAssociationWithIssueTypesConnection>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** The input to associate issues with a fix version. */
export type JiraAddIssuesToFixVersionInput = {
    /** The IDs of the issues to be associated with the fix version. */
    issueIds: Array<Scalars["ID"]["input"]>;
    /** The ID of the version to be associated with the issues. */
    versionId: Scalars["ID"]["input"];
};

/** The return payload of associating issues with a fix version. */
export type JiraAddIssuesToFixVersionPayload = Payload & {
    __typename?: "JiraAddIssuesToFixVersionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** A list of issue keys that the user has selected but does not have the permission to edit */
    issuesWithMissingEditPermission?: Maybe<Array<Scalars["String"]["output"]>>;
    /** A list of issue keys that the user has selected but does not have the permission to resolve */
    issuesWithMissingResolvePermission?: Maybe<
        Array<Scalars["String"]["output"]>
    >;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated version. */
    version?: Maybe<JiraVersion>;
};

export type JiraAddPostIncidentReviewLinkMutationInput = {
    /**
     * The ID of the incident the PIR link will be added to. Initially only Jira Service Management
     * incidents are supported, but eventually 3rd party / Data Depot incidents will follow.
     */
    incidentId: Scalars["ID"]["input"];
    /**
     * The title of the post-incident review. May be null, in which case the frontend can use either
     * a generic title or a smart link for display purposes.
     */
    postIncidentReviewTitle?: InputMaybe<Scalars["String"]["input"]>;
    /** The URL of the post-incident review (e.g. a Confluence page or Google Doc URL). */
    postIncidentReviewUrl: Scalars["URL"]["input"];
    /**
     * Project whose permissions the PIR link will be tied to. Users with access to this project
     * will be able to view/edit/remove this PIR link.
     */
    projectId: Scalars["ID"]["input"];
};

export type JiraAddPostIncidentReviewLinkMutationPayload = Payload & {
    __typename?: "JiraAddPostIncidentReviewLinkMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    /** The created PIR link entity. */
    postIncidentReviewLink?: Maybe<JiraPostIncidentReviewLink>;
    success: Scalars["Boolean"]["output"];
};

/** Input to create a new related work item and associated with a version. */
export type JiraAddRelatedWorkToVersionInput = {
    /** Category for the related work item. */
    category: Scalars["String"]["input"];
    /** Client-generated ID for the related work item. */
    relatedWorkId: Scalars["ID"]["input"];
    /** Related work title; can be null if a `url` was given. */
    title?: InputMaybe<Scalars["String"]["input"]>;
    /** Related work URL. Pass null to create a placeholder work item (a non-null `title` must be given in this case). */
    url?: InputMaybe<Scalars["URL"]["input"]>;
    /** The identifier of the Jira version. */
    versionId: Scalars["ID"]["input"];
};

/** The return payload of creating a new related work item and associating it with a version. */
export type JiraAddRelatedWorkToVersionPayload = Payload & {
    __typename?: "JiraAddRelatedWorkToVersionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The newly added edge and associated data.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use relatedWorkV2Edge instead
     */
    relatedWorkEdge?: Maybe<JiraVersionRelatedWorkEdge>;
    /** The newly added edge and associated data. */
    relatedWorkV2Edge?: Maybe<JiraVersionRelatedWorkV2Edge>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Operations that can be performed on fields like attachments and issuelinks etc. */
export enum JiraAddValueFieldOperations {
    /** Overrides single value field. */
    Add = "ADD"
}

/** The list of values for supported fields for the issue */
export type JiraAdditionalIssueFields = {
    __typename?: "JiraAdditionalIssueFields";
    /** Jira issue field details. */
    field?: Maybe<Array<Maybe<JiraIssueField>>>;
    /** missing fields that need to be provided in order to move the issue */
    missingFieldsForTriage?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

/** The connection type for JiraAdditionalIssueFields including the pagination information */
export type JiraAdditionalIssueFieldsConnection = {
    __typename?: "JiraAdditionalIssueFieldsConnection";
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<JiraAdditionalIssueFieldsEdge>>>;
    /** Errors encountered during execution. Only present in error case */
    errors?: Maybe<Array<QueryError>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    /** Total count of the fields returned. */
    totalCount: Scalars["Int"]["output"];
};

export type JiraAdditionalIssueFieldsEdge = {
    __typename?: "JiraAdditionalIssueFieldsEdge";
    /** A cursor for use in pagination. */
    cursor: Scalars["String"]["output"];
    /** The item at the end of the edge. */
    node?: Maybe<JiraAdditionalIssueFields>;
};

/** Represents ADF converted to plain text. */
export type JiraAdfToConvertedPlainText = {
    __typename?: "JiraAdfToConvertedPlainText";
    /** Indicate whether the text is truncated or not. */
    isTruncated?: Maybe<Scalars["Boolean"]["output"]>;
    /** The content of ADF converted to plain text. */
    plainText?: Maybe<Scalars["String"]["output"]>;
};

export type JiraAdjustmentEstimate = {
    adjustEstimateType: JiraWorklogAdjustmentEstimateOperation;
    /** this field will be ignored for auto and leave adjustEstimate. */
    adjustTimeInMinutes?: InputMaybe<Scalars["Long"]["input"]>;
};

/** Attributes of user configurations specific to richText field */
export type JiraAdminRichTextFieldConfig = {
    __typename?: "JiraAdminRichTextFieldConfig";
    /** Defines if a RichText Editor field supports Atlassian Intelligence option for the respective project and product type. */
    aiEnabledByProject?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Attributes of user configurations specific to richText field */
export type JiraAdminRichTextFieldConfigAiEnabledByProjectArgs = {
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Navigation information for the currently logged in user regarding Advanced Roadmaps for Jira */
export type JiraAdvancedRoadmapsNavigation = {
    __typename?: "JiraAdvancedRoadmapsNavigation";
    /** Flag indicating if the user has Create Sample Plans permissions */
    hasCreateSamplePlanPermissions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if user can browse and view plans. */
    hasEditOrViewPermissions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if currently logged in user can create and edit plans. */
    hasEditPermissions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if the user has global Plans administration permissions. */
    hasGlobalPlansAdminPermissions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if the user is licensed to use Advanced Roadmaps through a Software Trial. */
    isAdvancedRoadmapsTrial?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Represents an affected service entity for a Jira Issue.
 * AffectedService provides context on what has been changed.
 */
export type JiraAffectedService = JiraSelectableValue & {
    __typename?: "JiraAffectedService";
    /**
     * Unique identifier for the Affected Service.
     * ARI: service (GraphServiceARI)
     */
    id: Scalars["ID"]["output"];
    /** The name of the affected service. E.g. Jira. */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represents a group key where the option belongs to.
     * This will return null because the option does not belong to any group.
     */
    selectableGroupKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represent a url of the icon for the option.
     * This will return null because the option does not have an icon associated with it.
     */
    selectableIconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * Textual description of the value.
     * Renders either in dropdowns so users can discern between options
     * or in a form field when used as an active value for a field.
     */
    selectableLabel?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represents a url to make the option clickable.
     * This will return null since the option does not contain a URL.
     */
    selectableUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The ID of the affected service. E.g. ari:cloud:graph::service/<UUID>/<UUID>.
     * ARI: service (GraphServiceARI)
     */
    serviceId: Scalars["ID"]["output"];
};

/** The connection type for JiraAffectedService. */
export type JiraAffectedServiceConnection = {
    __typename?: "JiraAffectedServiceConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraAffectedServiceEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraAffectedService connection. */
export type JiraAffectedServiceEdge = {
    __typename?: "JiraAffectedServiceEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraAffectedService>;
};

/** Represents Affected Services field. */
export type JiraAffectedServicesField = JiraHasMultipleSelectedValues &
    JiraHasSelectableValueOptions &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraAffectedServicesField";
        /**
         * Paginated list of affected services available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        affectedServices?: Maybe<JiraAffectedServiceConnection>;
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to query for all Affected Services when user interact with field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Paginated list of JiraConnectMultipleSelectField options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /**
         * The affected services selected on the Issue or default affected services configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedAffectedServicesConnection instead.
         */
        selectedAffectedServices?: Maybe<Array<Maybe<JiraAffectedService>>>;
        /** The affected services selected on the Issue or default affected services configured for the field. */
        selectedAffectedServicesConnection?: Maybe<JiraAffectedServiceConnection>;
        /** The JiraAffectedServicesField selected options on the Issue or default option configured for the field. */
        selectedValues?: Maybe<JiraSelectableValueConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents Affected Services field. */
export type JiraAffectedServicesFieldAffectedServicesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents Affected Services field. */
export type JiraAffectedServicesFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents Affected Services field. */
export type JiraAffectedServicesFieldSelectedAffectedServicesConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents Affected Services field. */
export type JiraAffectedServicesFieldSelectedValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for affected services field */
export type JiraAffectedServicesFieldInput = {
    /** List of affected services */
    affectedServices: Array<JiraAffectedServicesInput>;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

/** Input type for defining the operation on Affected Services(Service Entity) field of a Jira issue. */
export type JiraAffectedServicesFieldOperationInput = {
    /** Accept ARI(s): service */
    ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * The operations to perform on Affected Services field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating Affected Services(Service Entity) field of a Jira issue. */
export type JiraAffectedServicesFieldPayload = Payload & {
    __typename?: "JiraAffectedServicesFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Affected Services field. */
    field?: Maybe<JiraAffectedServicesField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input type representing a single affected service */
export type JiraAffectedServicesInput = {
    /** An identifier for the affected service */
    serviceId: Scalars["ID"]["input"];
};

/** An input representing an issue */
export type JiraAiEnablementIssueInput = {
    /** The ID of the issue */
    issueId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The key of the issue */
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraAlignAggMercuryProjectStatusDto = MercuryProjectStatus & {
    __typename?: "JiraAlignAggMercuryProjectStatusDto";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    mercuryColor?: Maybe<MercuryProjectStatusColor>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    mercuryName?: Maybe<Scalars["String"]["output"]>;
};

export type JiraAlignAggProject = HasMercuryProjectFields &
    Node & {
        __typename?: "JiraAlignAggProject";
        id: Scalars["ID"]["output"];
        mercuryProjectIcon?: Maybe<Scalars["URL"]["output"]>;
        mercuryProjectKey?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectName?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectOwner?: Maybe<User>;
        mercuryProjectOwnerId?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectProviderName?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectStatus?: Maybe<MercuryProjectStatus>;
        mercuryProjectUrl?: Maybe<Scalars["URL"]["output"]>;
        mercuryTargetDate?: Maybe<Scalars["String"]["output"]>;
        mercuryTargetDateEnd?: Maybe<Scalars["DateTime"]["output"]>;
        mercuryTargetDateStart?: Maybe<Scalars["DateTime"]["output"]>;
        mercuryTargetDateType?: Maybe<MercuryProjectTargetDateType>;
    };

/** Announcement banner data for the currently logged in user. */
export type JiraAnnouncementBanner = Node & {
    __typename?: "JiraAnnouncementBanner";
    /** ARI of the announcement banner for the currently logged in user. */
    id: Scalars["ID"]["output"];
    /** Flag indicating if the announcement banner has been dismissed by the currently logged in user. */
    isDismissed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if the announcement banner can be dismissed by the user. */
    isDismissible?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if the announcement banner should be displayed for the currently logged in user. */
    isDisplayed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag indicating if the announcement banner is enabled or not. */
    isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The text on the announcement banner. */
    message?: Maybe<Scalars["String"]["output"]>;
    /** Visibility of the announcement banner. */
    visibility?: Maybe<JiraAnnouncementBannerVisibility>;
};

/** Visibility settings for an announcement banner. */
export enum JiraAnnouncementBannerVisibility {
    /** The announcement banner is shown to logged in users only. */
    Private = "PRIVATE",
    /** The announcement banner is shown to anyone on the internet. */
    Public = "PUBLIC"
}

/** The approval decision input */
export type JiraAnswerApprovalDecisionInput = {
    approvalId: Scalars["Int"]["input"];
    decision: JiraApprovalDecision;
};

export type JiraAnswerApprovalDecisionPayload = Payload & {
    __typename?: "JiraAnswerApprovalDecisionPayload";
    /** epoch time in milliseconds when the approval decision was completed */
    completedDate?: Maybe<Scalars["Long"]["output"]>;
    /** A list of errors which encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /**
     * True if the mutation was successfully applied. False if the mutation was either partially successful or if the
     * mutation failed completely.
     */
    success: Scalars["Boolean"]["output"];
};

/** Config states for an app with a specific id */
export type JiraAppConfigState = Node & {
    __typename?: "JiraAppConfigState";
    /** App name if available */
    appDisplayName?: Maybe<Scalars["String"]["output"]>;
    /** App icon of app if available */
    appIconLink?: Maybe<Scalars["String"]["output"]>;
    /** Config states for the workspaces of the app */
    config?: Maybe<JiraConfigStateConnection>;
    /** App Id of app */
    id: Scalars["ID"]["output"];
};

/** Config states for an app with a specific id */
export type JiraAppConfigStateConfigArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Connection object representing config state for a set of jira apps */
export type JiraAppConfigStateConnection = {
    __typename?: "JiraAppConfigStateConnection";
    /** Edges for JiraAppConfigStateEdge */
    edges?: Maybe<Array<JiraAppConfigStateEdge>>;
    /** Nodes for JiraConfigState */
    nodes?: Maybe<Array<JiraAppConfigState>>;
    /** PageInfo for JiraConfigState */
    pageInfo: PageInfo;
};

/** Connection edge representing config state for one jira app */
export type JiraAppConfigStateEdge = {
    __typename?: "JiraAppConfigStateEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** JiraConfigState node */
    node?: Maybe<JiraAppConfigState>;
};

/** Represent the config information required for a connect/forge app navigation item or nested link */
export type JiraAppNavigationConfig = {
    /** The URL for the icon of the connect/forge app */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The label for this item, for display purposes. This can either be the default label based on the
     * item type, or a user-provided value.
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /** The style class for the navigation item */
    styleClass?: Maybe<Scalars["String"]["output"]>;
    /** The URL for the connect/forge app */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a connect/forge app top-level navigation item */
export type JiraAppNavigationItem = JiraAppNavigationConfig &
    JiraNavigationItem &
    Node & {
        __typename?: "JiraAppNavigationItem";
        /**
         * The app id for this app as an ARI. Supported ARIs:
         * - [Forge app ARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Aecosystem%3Aapp)
         * - [Connect app ARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Aecosystem%3Aconnect-app)
         */
        appId?: Maybe<Scalars["ID"]["output"]>;
        /** The app type for this app - can be forge or connect */
        appType?: Maybe<JiraAppType>;
        /** Whether this item can be removed from its scope, based on the authenticated user. */
        canRemove?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be renamed to have a custom user-provided label. */
        canRename?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be set as the default within its scope, based on the authenticated user. */
        canSetAsDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /** Environment label to be displayed next to the navigation item */
        envLabel?: Maybe<Scalars["String"]["output"]>;
        /** The URL for the icon of the connect/forge app */
        iconUrl?: Maybe<Scalars["String"]["output"]>;
        /** Global identifier (ARI) for the navigation item. */
        id: Scalars["ID"]["output"];
        /** Whether this is the default navigation item within the requested scope. Only one may be the default. */
        isDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The label for this item, for display purposes. This can either be the default label based on the
         * item type, or a user-provided value.
         */
        label?: Maybe<Scalars["String"]["output"]>;
        /** Sections are collection of links with or without a header for the connect/forge app */
        sections?: Maybe<Array<Maybe<JiraAppSection>>>;
        /** The URL leading to the app's settings page */
        settingsUrl?: Maybe<Scalars["String"]["output"]>;
        /** The style class for the navigation item */
        styleClass?: Maybe<Scalars["String"]["output"]>;
        /** Identifies the type of this navigation item. */
        typeKey?: Maybe<JiraNavigationItemTypeKey>;
        /** The URL for the connect/forge app */
        url?: Maybe<Scalars["String"]["output"]>;
    };

/** Represents a connect/forge app nested navigation item */
export type JiraAppNavigationItemNestedLink = JiraAppNavigationConfig & {
    __typename?: "JiraAppNavigationItemNestedLink";
    /** The URL for the icon of the connect/forge app */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The label for this item, for display purposes. This can either be the default label based on the
     * item type, or a user-provided value.
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /** The style class for the navigation item */
    styleClass?: Maybe<Scalars["String"]["output"]>;
    /** The URL for the connect/forge app */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the navigation item type for a specific Connect or Forge app. */
export type JiraAppNavigationItemType = JiraNavigationItemType &
    Node & {
        __typename?: "JiraAppNavigationItemType";
        /**
         * The id of the app as an ARI. Supported ARIs:
         * - [Forge app ARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Aecosystem%3Aapp)
         * - [Connect app ARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Aecosystem%3Aconnect-app)
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        appId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The URL for the app icon.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Opaque ID uniquely identifying this app type node.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The label of the app, for display purposes. This is the app name.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        label?: Maybe<Scalars["String"]["output"]>;
        /**
         * The key identifying this item type, represented as an enum.
         * This is always set to `JiraNavigationItemTypeKey.APP`.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        typeKey?: Maybe<JiraNavigationItemTypeKey>;
    };

/**
 * Represents a nested section for connect/forge apps
 * A collection of orphan/non-sectioned links will also be grouped as a section without a label
 */
export type JiraAppSection = {
    __typename?: "JiraAppSection";
    /** has separator */
    hasSeparator?: Maybe<Scalars["Boolean"]["output"]>;
    /** The label for this section */
    label?: Maybe<Scalars["String"]["output"]>;
    /** List of nested links in this section */
    links?: Maybe<Array<Maybe<JiraAppNavigationItemNestedLink>>>;
};

/** List of values identifying the different app types */
export enum JiraAppType {
    Connect = "CONNECT",
    Forge = "FORGE"
}

/** A list of all UI modifications for an app and environment */
export type JiraAppUiModifications = {
    __typename?: "JiraAppUiModifications";
    appEnvId: Scalars["String"]["output"];
    uiModifications: Array<JiraUiModification>;
};

/** Representation of each Jira application/sub-product. */
export enum JiraApplicationKey {
    /** Jira Work Management application key */
    JiraCore = "JIRA_CORE",
    /** Jira Product Discovery application key */
    JiraProductDiscovery = "JIRA_PRODUCT_DISCOVERY",
    /** Jira Service Management application key */
    JiraServiceDesk = "JIRA_SERVICE_DESK",
    /** Jira Software application key */
    JiraSoftware = "JIRA_SOFTWARE"
}

/**
 * Jira application properties is effectively a key/value store scoped to a Jira instance. A JiraApplicationProperty
 * represents one of these key/value pairs, along with associated metadata about the property.
 */
export type JiraApplicationProperty = Node & {
    __typename?: "JiraApplicationProperty";
    /**
     * If the type is 'enum', then allowedValues may optionally contain a list of values which are valid for this property.
     * Otherwise the value will be null.
     */
    allowedValues?: Maybe<Array<Scalars["String"]["output"]>>;
    /**
     * The default value which will be returned if there is no value stored. This might be useful for UIs which allow a
     * user to 'reset' an application property to the default value.
     */
    defaultValue: Scalars["String"]["output"];
    /** The human readable description for the application property */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * Example is mostly used for application properties which store some sort of format pattern (e.g. date formats).
     * Example will contain an example string formatted according to the format stored in the property.
     */
    example?: Maybe<Scalars["String"]["output"]>;
    /** Globally unique identifier */
    id: Scalars["ID"]["output"];
    /** True if the user is allowed to edit the property, false otherwise */
    isEditable: Scalars["Boolean"]["output"];
    /** The unique key of the application property */
    key: Scalars["String"]["output"];
    /**
     * The human readable name for the application property. If no human readable name has been defined then the key will
     * be returned.
     */
    name: Scalars["String"]["output"];
    /**
     * Although all application properties are stored as strings, they notionally have a type (e.g. boolean, int, enum,
     * string). The type can be anything (for example, there is even a colour type), and there may be associated validation
     * on the server based on the property's type.
     */
    type: Scalars["String"]["output"];
    /**
     * The value of the application property, encoded as a string. If no value is stored the default value will
     * be returned.
     */
    value: Scalars["String"]["output"];
};

export enum JiraApprovalDecision {
    Approved = "APPROVED",
    Rejected = "REJECTED"
}

/** The input type to approve access request of connected workspace(organization in Jira term) */
export type JiraApproveJiraBitbucketWorkspaceAccessRequestInput = {
    /** The approval location for the analytics and Jira's organization approval event. If not given, it will default to UNKNOWN */
    approvalLocation?: InputMaybe<JiraOrganizationApprovalLocation>;
    /** The workspace id(organization in Jira term) to approve the access request */
    workspaceId: Scalars["ID"]["input"];
};

/** The response payload to approve access request of connected workspace(organization in Jira term) */
export type JiraApproveJiraBitbucketWorkspaceAccessRequestPayload = Payload & {
    __typename?: "JiraApproveJiraBitbucketWorkspaceAccessRequestPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraArchiveJourneyConfigurationInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

export type JiraArchivedIssue = {
    __typename?: "JiraArchivedIssue";
    /** The user who archived the issue. */
    archivedBy?: Maybe<User>;
    /** Archival date of the issue. */
    archivedDate?: Maybe<Scalars["Date"]["output"]>;
    /** Fields of the archived issue. */
    fields?: Maybe<JiraIssueFieldConnection>;
    id: Scalars["ID"]["output"];
    /** Issue ID in numeric format. E.g. 10000 */
    issueId: Scalars["String"]["output"];
    /** The {projectKey}-{issueNumber} associated with this Issue. */
    key: Scalars["String"]["output"];
};

export type JiraArchivedIssueConnection = {
    __typename?: "JiraArchivedIssueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraArchivedIssueEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraArchivedIssueEdge = {
    __typename?: "JiraArchivedIssueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraArchivedIssue>;
};

/** Input type to filter archived issues */
export type JiraArchivedIssuesFilterInput = {
    /** Filter By archival date range. */
    byArchivalDateRange?: InputMaybe<JiraArchivedOnDateRange>;
    /** Filter by the user who archived the issue. */
    byArchivedBy?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Filter by the assignee of the issue. */
    byAssignee?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Filter by the create date of the issue. */
    byCreatedOn?: InputMaybe<Scalars["Date"]["input"]>;
    /** Filter by the issue type. */
    byIssueType?: InputMaybe<Array<JiraIssueTypeInput>>;
    /** Filter by the name of the project. */
    byProject?: InputMaybe<Scalars["String"]["input"]>;
    /** Filter by the reporter of the issue. */
    byReporter?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Field Options for filter by fields for getting archived issues */
export type JiraArchivedIssuesFilterOptions = {
    __typename?: "JiraArchivedIssuesFilterOptions";
    /**
     * Paginated list of users who archived the issues.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    archivedBy?: Maybe<JiraUserConnection>;
    /**
     * Paginated list of issue type options available.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    issueTypes?: Maybe<JiraIssueTypeConnection>;
    /** Unique identifier of the project */
    projectId: Scalars["ID"]["output"];
    /**
     * Paginated list of reporter options available.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    reporters?: Maybe<JiraUserConnection>;
};

/** Field Options for filter by fields for getting archived issues */
export type JiraArchivedIssuesFilterOptionsArchivedByArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Field Options for filter by fields for getting archived issues */
export type JiraArchivedIssuesFilterOptionsIssueTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Field Options for filter by fields for getting archived issues */
export type JiraArchivedIssuesFilterOptionsReportersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for archival date range */
export type JiraArchivedOnDateRange = {
    /** The date from which archived issues are to be fetched. */
    from?: InputMaybe<Scalars["Date"]["input"]>;
    /** The date till which archived issues are to be fetched. */
    to?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Represents a single option value for an asset field. */
export type JiraAsset = {
    __typename?: "JiraAsset";
    /**
     * The app key, which should be the Connect app key.
     * This parameter is used to scope the originId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * The identifier of an asset.
     * This is the same identifier for the asset in its origin (external) system.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    originId?: Maybe<Scalars["String"]["output"]>;
    /**
     * The appKey + originId separated by a forward slash.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    serializedOrigin?: Maybe<Scalars["String"]["output"]>;
    /**
     * The appKey + originId separated by a forward slash.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraAsset. */
export type JiraAssetConnection = {
    __typename?: "JiraAssetConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraAssetEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraAsset connection. */
export type JiraAssetEdge = {
    __typename?: "JiraAssetEdge";
    /**
     * The cursor to this edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     * The node at the edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<JiraAsset>;
};

/** Represents the Asset field on a Jira Issue. */
export type JiraAssetField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraAssetField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch all the assets for the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The assets selected on the Issue or default assets configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use selectedAssetsConnection instead.
         */
        selectedAssets?: Maybe<Array<Maybe<JiraAsset>>>;
        /**
         * The assets selected on the Issue or default assets configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedAssetsConnection?: Maybe<JiraAssetConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the Asset field on a Jira Issue. */
export type JiraAssetFieldSelectedAssetsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for asset field */
export type JiraAssetFieldInput = {
    /** List of jira assets on which the operation will be performed */
    assets: Array<JiraAssetInput>;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

/** Input type for asset value */
export type JiraAssetInput = {
    /** String representing application key */
    appKey: Scalars["String"]["input"];
    /** An identifier for the origin */
    originId: Scalars["String"]["input"];
    /** Serialized value of origin */
    serializedOrigin: Scalars["String"]["input"];
    /** Value of the asset field */
    value: Scalars["String"]["input"];
};

/**
 * DEPRECATED: Superseded by issue linking
 *
 * Input to assign/unassign a related work item to a user.
 */
export type JiraAssignRelatedWorkInput = {
    /**
     * The account ID of the user the related work item is being assigned to. Pass `null` to unassign the
     * item from its current assignee.
     */
    assigneeId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The related work item's ID (not applicable for the NATIVE_RELEASE_NOTES type - pass `null` in that case). */
    relatedWorkId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The type of related work item being assigned. If the type is not NATIVE_RELEASE_NOTES, the work
     * item's ID must also be passed in via `relatedWorkId`.
     */
    relatedWorkType: JiraVersionRelatedWorkType;
    /** The ARI of the version the related work lives in. */
    versionId: Scalars["ID"]["input"];
};

/**
 * DEPRECATED: Superseded by issue linking
 *
 * The return payload of (un)assigning a related work item to a user.
 */
export type JiraAssignRelatedWorkPayload = Payload & {
    __typename?: "JiraAssignRelatedWorkPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The related work item that was assigned/unassigned. */
    relatedWork?: Maybe<JiraVersionRelatedWorkV2>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The connection type for AssignableUsers. */
export type JiraAssignableUsersConnection = HasPageInfo &
    HasTotal & {
        __typename?: "JiraAssignableUsersConnection";
        /** A list of edges in the current page. */
        edges?: Maybe<Array<Maybe<JiraAssignableUsersEdge>>>;
        /** Information about the current page. Used to aid in pagination. */
        pageInfo: PageInfo;
        /** The total count of items in the connection. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** An edge in a AssignableUsers connection. */
export type JiraAssignableUsersEdge = {
    __typename?: "JiraAssignableUsersEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<User>;
};

/** Action the frontend should take given the client's current state. */
export type JiraAtlassianIntelligenceAction =
    | JiraAccessAtlassianIntelligenceFeature
    | JiraContactOrgAdminToEnableAtlassianIntelligence
    | JiraEnableAtlassianIntelligenceDeepLink;

/** Features that Atlassian Intelligence can be enabled for. */
export enum JiraAtlassianIntelligenceFeatureEnum {
    AiMate = "AI_MATE",
    NaturalLanguageToJql = "NATURAL_LANGUAGE_TO_JQL"
}

/** Input used to specify which product or feature to check for Atlassian Intelligence. */
export type JiraAtlassianIntelligenceProductFeatureInput = {
    /** The feature for Atlassian Intelligence. */
    feature?: InputMaybe<JiraAtlassianIntelligenceFeatureEnum>;
    /** The product for Atlassian Intelligence. */
    product?: InputMaybe<JiraProductEnum>;
};

/** Deprecated type. Please use `JiraTeamView` instead. */
export type JiraAtlassianTeam = {
    __typename?: "JiraAtlassianTeam";
    /**
     * The avatar of the team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    avatar?: Maybe<JiraAvatar>;
    /**
     * The name of the team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The UUID of team.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    teamId?: Maybe<Scalars["String"]["output"]>;
};

/** Deprecated type. */
export type JiraAtlassianTeamConnection = {
    __typename?: "JiraAtlassianTeamConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraAtlassianTeamEdge>>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Deprecated type. */
export type JiraAtlassianTeamEdge = {
    __typename?: "JiraAtlassianTeamEdge";
    /**
     * The cursor to this edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     * The node at the edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<JiraAtlassianTeam>;
};

/** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */
export type JiraAtlassianTeamField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraAtlassianTeamField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch all the teams options for the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The team selected on the Issue or default team configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedTeam?: Maybe<JiraAtlassianTeam>;
        /**
         * Paginated list of team options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        teams?: Maybe<JiraAtlassianTeamConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */
export type JiraAtlassianTeamFieldTeamsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for Atlassian team field */
export type JiraAtlassianTeamFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Represents an Atlassian team field's data */
    team: JiraAtlassianTeamInput;
};

/** Input type for Atlassian team data */
export type JiraAtlassianTeamInput = {
    /** An identifier for the team */
    teamId: Scalars["String"]["input"];
};

/** An interface shared across all attachment types. */
export type JiraAttachment = {
    /** Identifier for the attachment. */
    attachmentId: Scalars["String"]["output"];
    /** User profile of the attachment author. */
    author?: Maybe<User>;
    /** Date the attachment was created in seconds since the epoch. */
    created: Scalars["DateTime"]["output"];
    /** Filename of the attachment. */
    fileName?: Maybe<Scalars["String"]["output"]>;
    /** Size of the attachment in bytes. */
    fileSize?: Maybe<Scalars["Long"]["output"]>;
    /** Indicates if an attachment is within a restricted parent comment. */
    hasRestrictedParent?: Maybe<Scalars["Boolean"]["output"]>;
    /** Enclosing issue object of the current attachment. */
    issue?: Maybe<JiraIssue>;
    /** Media Services file id of this Attachment, May be absent if the attachment has not yet been migrated to Media Services. */
    mediaApiFileId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Contains the information needed for reading uploaded media content in jira.
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAttachmentMediaReadToken")' query directive to the 'mediaReadToken' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    mediaReadToken?: Maybe<Scalars["String"]["output"]>;
    /** The mimetype (also called content type) of the attachment. This may be {@code null}. */
    mimeType?: Maybe<Scalars["String"]["output"]>;
    /** Parent name that this attachment is contained in either issue, environment, description, comment, worklog or form */
    parent?: Maybe<JiraAttachmentParentName>;
    /** Parent id that this attachment is contained in. */
    parentId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Parent name that this attachment is contained in e.g Issue, Field, Comment, Worklog.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use parent instead
     */
    parentName?: Maybe<Scalars["String"]["output"]>;
};

/** An interface shared across all attachment types. */
export type JiraAttachmentMediaReadTokenArgs = {
    durationInSeconds: Scalars["Int"]["input"];
    maxTokenLength: Scalars["Int"]["input"];
};

/** A Jira Attachment Background, used only when the entity is of Issue type */
export type JiraAttachmentBackground = JiraBackground & {
    __typename?: "JiraAttachmentBackground";
    /** the attachment if the background is an attachment (issue) type */
    attachment?: Maybe<JiraAttachment>;
    /** The entityId (ARI) of the issue the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

export type JiraAttachmentByAriResult = {
    __typename?: "JiraAttachmentByAriResult";
    attachment?: Maybe<JiraPlatformAttachment>;
    error?: Maybe<QueryError>;
};

/** The connection type for JiraAttachment. */
export type JiraAttachmentConnection = {
    __typename?: "JiraAttachmentConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraAttachmentEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The approximate count of items in the connection. */
    indicativeCount?: Maybe<Scalars["Int"]["output"]>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
};

export type JiraAttachmentDeletedStreamHubPayload = {
    __typename?: "JiraAttachmentDeletedStreamHubPayload";
    /** The deleted attachment's ARI. */
    attachmentId?: Maybe<Scalars["ID"]["output"]>;
};

/** An edge in a JiraAttachment connection. */
export type JiraAttachmentEdge = {
    __typename?: "JiraAttachmentEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraAttachment>;
};

/** Input type for defining the operation on the Attachment field of a Jira issue. */
export type JiraAttachmentFieldOperationInput = {
    /** Only ADD operation is supported for attachments field in purview of Issue Transition Modernisation flow. */
    operation: JiraAddValueFieldOperations;
    /** Accepts : Temporary Attachment UUIDs */
    temporaryAttachmentIds: Array<Scalars["String"]["input"]>;
};

/** The payload type returned after updating the IssueType field of a Jira issue. */
export type JiraAttachmentFieldPayload = Payload & {
    __typename?: "JiraAttachmentFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated attachment field. */
    field?: Maybe<JiraAttachmentsField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraAttachmentFilterInput = {
    /** Filters attachments based on the author's AAID. */
    authorIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Defines the date range for the attachment's upload date to be included in the response. */
    dateRange?: InputMaybe<JiraDateTimeRange>;
    /** Filters attachments based on matching filename (case-insensitive). */
    fileName?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * List of mime types to be used as filters. Attachments matching these types will be included in the response.
     * eg. ["JPEG", "PNG", "GIF"]
     */
    mimeTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Represents a fixed set of attachments' parents */
export enum JiraAttachmentParentName {
    Comment = "COMMENT",
    Customfield = "CUSTOMFIELD",
    Description = "DESCRIPTION",
    Environment = "ENVIRONMENT",
    Form = "FORM",
    Issue = "ISSUE",
    Worklog = "WORKLOG"
}

export type JiraAttachmentSearchViewContext = {
    __typename?: "JiraAttachmentSearchViewContext";
    /** Whether this attachment exists in the connection or not */
    matchesSearch: Scalars["Boolean"]["output"];
    /** ID of the next attachment in the current connection */
    nextAttachmentId?: Maybe<Scalars["ID"]["output"]>;
    /** Attachment's position in the connection */
    position?: Maybe<Scalars["Int"]["output"]>;
    /** ID of the previous attachment in the current connection */
    previousAttachmentId?: Maybe<Scalars["ID"]["output"]>;
};

export type JiraAttachmentSearchViewContextInput = {
    /** A list of user AAIDs to limit searched attachments. */
    authorIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only returns attachments created after this date (exclusive) */
    createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Only returns attachments created before this date (exclusive) */
    createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Filters attachments by file name (case-insensitive) */
    fileName?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * A list of mime types to filter attachments
     * e.g. text/plain, image/jpeg
     */
    mimeTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Project keys to search for attachments in */
    projectKeys: Array<Scalars["String"]["input"]>;
};

/** The field for sorting attachments. */
export enum JiraAttachmentSortField {
    /** sorts by the created date */
    Created = "CREATED"
}

export type JiraAttachmentSortInput = {
    /** The field to sort on. */
    field: JiraAttachmentSortField;
    /** The sort direction. */
    order?: SortDirection;
};

/** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */
export type JiraAttachmentsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraAttachmentsField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Paginated list of attachments available for the field or the Issue. */
        attachments?: Maybe<JiraAttachmentConnection>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Defines the maximum size limit (in bytes) of the total of all the attachments which can be associated with this field. */
        maxAllowedTotalAttachmentsSize?: Maybe<Scalars["Long"]["output"]>;
        /** Contains the information needed to add a media content to this field. */
        mediaContext?: Maybe<JiraMediaContext>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Defines the permissions of the attachment collection. */
        permissions?: Maybe<Array<Maybe<JiraAttachmentsPermissions>>>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */
export type JiraAttachmentsFieldAttachmentsArgs = {
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    orderDirection?: InputMaybe<JiraOrderDirection>;
    orderField?: InputMaybe<JiraAttachmentsOrderField>;
    startAt?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraAttachmentsOrderField = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum JiraAttachmentsPermissions {
    /** Allows the user to create atachments on the correspondig Issue. */
    CreateAttachments = "CREATE_ATTACHMENTS",
    /** Allows the user to delete attachments on the corresponding Issue. */
    DeleteOwnAttachments = "DELETE_OWN_ATTACHMENTS"
}

/** The payload response for basic autodev mutations */
export type JiraAutodevBasicPayload = Payload & {
    __typename?: "JiraAutodevBasicPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The job associated to autodev action */
    job?: Maybe<JiraAutodevJob>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** JiraAutodevCodeChange represents a code change associated with the Autodev Job */
export type JiraAutodevCodeChange = {
    __typename?: "JiraAutodevCodeChange";
    /** diff represents the diff of the code change */
    diff: Scalars["String"]["output"];
    /** filePath represents the file path of the code change relative to the repo root */
    filePath: Scalars["String"]["output"];
};

/** JiraAutodevCodeChangeConnection represents the connection object for Code changes associated with the Autodev Job */
export type JiraAutodevCodeChangeConnection = {
    __typename?: "JiraAutodevCodeChangeConnection";
    /** Edges for JiraAutodevCodeChangeConnection */
    edges?: Maybe<Array<Maybe<JiraAutodevCodeChangeEdge>>>;
    /** Nodes for JiraAutodevCodeChangeConnection */
    nodes?: Maybe<Array<Maybe<JiraAutodevCodeChange>>>;
    /** PageInfo for JiraAutodevCodeChangeConnection */
    pageInfo: PageInfo;
};

/** JiraAutodevCodeChangeEdge represents the code change edge object associated with the Autodev Job */
export type JiraAutodevCodeChangeEdge = {
    __typename?: "JiraAutodevCodeChangeEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** JiraAutodevCodeChangeEdge node */
    node?: Maybe<JiraAutodevCodeChange>;
};

/** Renamed to JiraAutodevCodeChangeEnumType to be compatible with jira/gira prefix validation */
export enum JiraAutodevCodeChangeEnumType {
    Add = "ADD",
    Delete = "DELETE",
    Edit = "EDIT",
    Other = "OTHER"
}

/** The payload response for the create an autofix job mutation */
export type JiraAutodevCreateJobPayload = Payload & {
    __typename?: "JiraAutodevCreateJobPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The autodev job if created */
    job?: Maybe<JiraAutodevJob>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraAutodevDeletedPayload = Payload & {
    __typename?: "JiraAutodevDeletedPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The deleted field id */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The job associated to autodev action */
    job?: Maybe<JiraAutodevJob>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** Autodev job response */
export type JiraAutodevJob = {
    __typename?: "JiraAutodevJob";
    /**
     * Agent that creates the autodev job
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'agent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agent?: Maybe<DevAiRovoAgent>;
    /** Branch Name once a branch has been created for the job */
    branchName?: Maybe<Scalars["String"]["output"]>;
    /** Branch URL once a branch has been created for the job */
    branchUrl?: Maybe<Scalars["String"]["output"]>;
    /** Code changes related to the autodev job (deprecated) */
    codeChanges?: Maybe<JiraAutodevCodeChangeConnection>;
    /** Current workflow of autodev job */
    currentWorkflow?: Maybe<Scalars["String"]["output"]>;
    /** Authentication error associated to reading a job */
    error?: Maybe<JiraAutodevJobPermissionError>;
    /** Diff for any code changes */
    gitDiff?: Maybe<Scalars["String"]["output"]>;
    /** JobId of autodev job */
    id: Scalars["ID"]["output"];
    /** Issue ari of autodev job */
    issueAri?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Score of the prompt quality
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'issueScopingScore' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueScopingScore?: Maybe<DevAiIssueScopingResult>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogs")' query directive to the 'jobLogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jobLogs?: Maybe<DevAiAutodevLogConnection>;
    /**
     * These are user-facing logs that show the history of the job (generating plan, coding, etc).
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogGroups")' query directive to the 'logGroups' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use the 'jobLogs' field instead
     */
    logGroups?: Maybe<DevAiAutodevLogGroupConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogs")' query directive to the 'logs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use the 'jobLogs' field instead
     */
    logs?: Maybe<DevAiAutodevLogConnection>;
    /** Phase of autodev job */
    phase?: Maybe<JiraAutodevPhase>;
    /** Plan related to the autodev job */
    plan?: Maybe<JiraAutodevPlan>;
    /** Text used for UX purposes so user will be aware of what is going on. */
    progressText?: Maybe<Scalars["String"]["output"]>;
    /** Pull requests related to the autodev job */
    pullRequests?: Maybe<JiraAutodevPullRequestConnection>;
    /** repoUrl of autodev job */
    repoUrl?: Maybe<Scalars["String"]["output"]>;
    /** state of autodev job */
    state?: Maybe<JiraAutodevState>;
    /** Status of autodev job */
    status?: Maybe<JiraAutodevStatus>;
    /** Status history of the autodev job */
    statusHistory?: Maybe<JiraAutodevStatusHistoryItemConnection>;
};

/** Autodev job response */
export type JiraAutodevJobAgentArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Autodev job response */
export type JiraAutodevJobIssueScopingScoreArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Autodev job response */
export type JiraAutodevJobJobLogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    excludePriorities?: InputMaybe<Array<InputMaybe<DevAiAutodevLogPriority>>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    minPriority?: InputMaybe<DevAiAutodevLogPriority>;
};

/** Autodev/acra job connection */
export type JiraAutodevJobConnection = {
    __typename?: "JiraAutodevJobConnection";
    /** Edges for JiraAutodevJobEdge */
    edges?: Maybe<Array<Maybe<JiraAutodevJobEdge>>>;
    /** Nodes for JiraAutodevJob */
    nodes?: Maybe<Array<Maybe<JiraAutodevJob>>>;
    /** PageInfo for JiraAutodevJobConnection */
    pageInfo: PageInfo;
};

/** Connection edge representing autodev job */
export type JiraAutodevJobEdge = {
    __typename?: "JiraAutodevJobEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** AutodevJob node */
    node?: Maybe<JiraAutodevJob>;
};

/** Autodev Job auth error */
export type JiraAutodevJobPermissionError = {
    __typename?: "JiraAutodevJobPermissionError";
    errorType?: Maybe<Scalars["String"]["output"]>;
    httpStatus?: Maybe<Scalars["Int"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
};

/** Autodev job state */
export enum JiraAutodevPhase {
    /** transitions to CODE_REVIEW upon success */
    CodeGenerating = "CODE_GENERATING",
    /** When code is generated successfully --> CODE_RE_GENERATING */
    CodeReview = "CODE_REVIEW",
    /** When user press regenerate code button --> CODE_REVIEW */
    CodeReGenerating = "CODE_RE_GENERATING",
    /** When job is created --> PLAN_REVIEW */
    PlanGenerating = "PLAN_GENERATING",
    /** When plan is generated successfully --> PLAN_RE_GENERATING || CODE_GENERATING */
    PlanReview = "PLAN_REVIEW",
    /** When user press button to regenerate plan --> PLAN_REVIEW */
    PlanReGenerating = "PLAN_RE_GENERATING"
}

/** Autodev Job Plan */
export type JiraAutodevPlan = {
    __typename?: "JiraAutodevPlan";
    /** (DEPRECATED) acceptanceCriteria represents what checks need to pass to deem the task as successful */
    acceptanceCriteria: Scalars["String"]["output"];
    /** (DEPRECATED) currentState represents current behaviour of the code */
    currentState: Scalars["String"]["output"];
    /** (DEPRECATED) desiredState represents how the code should look like */
    desiredState: Scalars["String"]["output"];
    /** suggested changes for the code */
    plannedChanges?: Maybe<JiraAutodevPlannedChangeConnection>;
    /** prompt for generating the plan */
    prompt: Scalars["String"]["output"];
};

/** JiraAutodevPlannedChange represents a planned code change associated with the Autodev Job */
export type JiraAutodevPlannedChange = {
    __typename?: "JiraAutodevPlannedChange";
    /** type of change needing to be done to the file. Add, edit, delete */
    changetype?: Maybe<JiraAutodevCodeChangeEnumType>;
    /** filename represents the file path of the code change relative to the repo root */
    fileName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    /** Relevant file paths */
    referenceFiles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** connection of individual tasks needing to be done on the file */
    task?: Maybe<JiraAutodevTaskConnection>;
};

export type JiraAutodevPlannedChangeConnection = {
    __typename?: "JiraAutodevPlannedChangeConnection";
    /** Edges for JiraAutodevPlannedChangeConnection */
    edges?: Maybe<Array<Maybe<JiraAutodevPlannedChangeEdge>>>;
    /** Nodes for JiraAutodevPlannedChangeConnection */
    nodes?: Maybe<Array<Maybe<JiraAutodevPlannedChange>>>;
    /** PageInfo for JiraAutodevPlannedChangeConnection */
    pageInfo: PageInfo;
};

export type JiraAutodevPlannedChangeEdge = {
    __typename?: "JiraAutodevPlannedChangeEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** JiraAutodevPlannedChangeEdge node */
    node?: Maybe<JiraAutodevPlannedChange>;
};

export type JiraAutodevPlannedChangePayload = Payload & {
    __typename?: "JiraAutodevPlannedChangePayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The job associated to autodev action */
    job?: Maybe<JiraAutodevJob>;
    /** The job created or updated code change */
    plannedChange?: Maybe<JiraAutodevPlannedChange>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** JiraAutodevPullRequest represents one pull request associated with the Autodev Job */
export type JiraAutodevPullRequest = {
    __typename?: "JiraAutodevPullRequest";
    url: Scalars["String"]["output"];
};

/** JiraAutodevPullRequestConnection represents the connection object for Pull requests associated with the Autodev Job */
export type JiraAutodevPullRequestConnection = {
    __typename?: "JiraAutodevPullRequestConnection";
    /** Edges for JiraAutodevPullRequestConnection */
    edges?: Maybe<Array<Maybe<JiraAutodevPullRequestEdge>>>;
    /** Nodes for JiraAutodevPullRequestConnection */
    nodes?: Maybe<Array<Maybe<JiraAutodevPullRequest>>>;
    /** PageInfo for JiraAutodevPullRequestConnection */
    pageInfo: PageInfo;
};

/** JiraAutodevPullRequestEdge represents the pull request edge object associated with the Autodev Job */
export type JiraAutodevPullRequestEdge = {
    __typename?: "JiraAutodevPullRequestEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** JiraAutodevPullRequest node */
    node?: Maybe<JiraAutodevPullRequest>;
};

/** Autodev job state */
export enum JiraAutodevState {
    /** When an autodev job is cancelled by the user. */
    Cancelled = "CANCELLED",
    /** This state is entered when the code is being generated */
    CodeGenerating = "CODE_GENERATING",
    /** This state is entered when the code generation fails */
    CodeGenerationFail = "CODE_GENERATION_FAIL",
    /** This state is entered when user confirm to say that “plan looks okay, now generate code”. */
    CodeGenerationReady = "CODE_GENERATION_READY",
    /** This state is entered when the code generation is successful */
    CodeGenerationSuccess = "CODE_GENERATION_SUCCESS",
    /** When an autodev job is first created, it will enter this state. */
    Created = "CREATED",
    /** This state will be automatically enter when backend service started work on the job id. */
    PlanGenerating = "PLAN_GENERATING",
    /** This state will be be entered when the plan generation fails */
    PlanGenerationFail = "PLAN_GENERATION_FAIL",
    /** This state will be be entered when the plan generation succeeds */
    PlanGenerationSuccess = "PLAN_GENERATION_SUCCESS",
    /** This state should be automatically enter when backend service pick up the CODE_GENERATION_SUCCESS state. */
    PullrequestCreating = "PULLREQUEST_CREATING",
    /** This state should be entered when pull request fails to be created */
    PullrequestCreationFail = "PULLREQUEST_CREATION_FAIL",
    /** This state should be entered when pull request creation has succeeded */
    PullrequestCreationSuccess = "PULLREQUEST_CREATION_SUCCESS",
    /** Fallback state for any unexpected error */
    Unknown = "UNKNOWN"
}

/** Autodev job status */
export enum JiraAutodevStatus {
    /** The autodev job was cancelled */
    Cancelled = "CANCELLED",
    /** The autodev job completed successfully */
    Completed = "COMPLETED",
    /** The autodev job stopped running because of an error */
    Failed = "FAILED",
    /** The autodev job is currently running */
    InProgress = "IN_PROGRESS",
    /** The autodev job hasn't started yet */
    Pending = "PENDING"
}

/** JiraAutodevStatusHistoryItem represents one status history item associated with the Autodev Job */
export type JiraAutodevStatusHistoryItem = {
    __typename?: "JiraAutodevStatusHistoryItem";
    /** Status of workflow */
    status?: Maybe<JiraAutodevStatus>;
    /** Timestamp of history item */
    timestamp?: Maybe<Scalars["String"]["output"]>;
    /** Name of workflow */
    workflowName?: Maybe<Scalars["String"]["output"]>;
};

/** JiraAutodevStatusHistoryItemConnection represents the connection object for status history items associated with the Autodev Job */
export type JiraAutodevStatusHistoryItemConnection = {
    __typename?: "JiraAutodevStatusHistoryItemConnection";
    /** Edges for JiraAutodevStatusHistoryItemConnection */
    edges?: Maybe<Array<Maybe<JiraAutodevStatusHistoryItemEdge>>>;
    /** Nodes for JiraAutodevStatusHistoryItemConnection */
    nodes?: Maybe<Array<Maybe<JiraAutodevStatusHistoryItem>>>;
    /** PageInfo for JiraAutodevStatusHistoryItemConnection */
    pageInfo: PageInfo;
};

/** JiraAutodevStatusHistoryItemEdge represents the status history item edge object associated with the Autodev Job */
export type JiraAutodevStatusHistoryItemEdge = {
    __typename?: "JiraAutodevStatusHistoryItemEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** JiraAutodevStatusHistoryItem node */
    node?: Maybe<JiraAutodevStatusHistoryItem>;
};

export type JiraAutodevTask = {
    __typename?: "JiraAutodevTask";
    id: Scalars["ID"]["output"];
    /** Task needing to be done on a file change */
    task?: Maybe<Scalars["String"]["output"]>;
};

/** JiraAutodevTaskConnection represents the connection object for individual tasks in the plan for the Autodev Job */
export type JiraAutodevTaskConnection = {
    __typename?: "JiraAutodevTaskConnection";
    /** Edges for JiraAutodevTaskConnection */
    edges?: Maybe<Array<Maybe<JiraAutodevTaskEdge>>>;
    /** Nodes for JiraAutodevTaskConnection */
    nodes?: Maybe<Array<Maybe<JiraAutodevTask>>>;
    /** PageInfo for JiraAutodevTaskConnection */
    pageInfo: PageInfo;
};

export type JiraAutodevTaskEdge = {
    __typename?: "JiraAutodevTaskEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraAutodevTask>;
};

export type JiraAutodevTaskPayload = Payload & {
    __typename?: "JiraAutodevTaskPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The job associated to autodev action */
    job?: Maybe<JiraAutodevJob>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
    /** The job created or updated task */
    task?: Maybe<JiraAutodevTask>;
};

/** Response from creating an autofix job */
export type JiraAutofixCreateJobPayload = Payload & {
    __typename?: "JiraAutofixCreateJobPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The id of the job created */
    job?: Maybe<JiraAutofixJob>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input type to create an autofix job */
export type JiraAutofixInput = {
    /** The issue ari */
    issueAri: Scalars["ID"]["input"];
    /** The type of job to create */
    jobType: JiraAutofixJobType;
};

/** Autofix job response */
export type JiraAutofixJob = {
    __typename?: "JiraAutofixJob";
    /** Message describing the error encountered during the autofix job, if any */
    errorMessage?: Maybe<Scalars["String"]["output"]>;
    /** Type of error encountered during the autofix job, if any */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /** JobId of autofix job */
    jobId: Scalars["ID"]["output"];
    /** Status of autofix job */
    status: JiraAutofixStatus;
};

/** Autofix job connection */
export type JiraAutofixJobConnection = {
    __typename?: "JiraAutofixJobConnection";
    /** Edges for JiraAutofixJobEdge */
    edges?: Maybe<Array<Maybe<JiraAutofixJobEdge>>>;
    /** Nodes for AutofixJob */
    nodes?: Maybe<Array<Maybe<JiraAutofixJob>>>;
    /** PageInfo for AutofixJob */
    pageInfo: PageInfo;
};

/** Connection edge representing autofix job */
export type JiraAutofixJobEdge = {
    __typename?: "JiraAutofixJobEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** AutofixJob node */
    node?: Maybe<JiraAutofixJob>;
};

/** Type of autofix job */
export enum JiraAutofixJobType {
    /** Autofix job to remove feature flags */
    InternalRemoveFeatureFlag = "INTERNAL_REMOVE_FEATURE_FLAG"
}

/** Autofix job status */
export enum JiraAutofixStatus {
    /** Job successfully completed */
    Completed = "COMPLETED",
    /** Job failed */
    Failed = "FAILED",
    /** Job in progress */
    InProgress = "IN_PROGRESS",
    /** Job not started */
    Pending = "PENDING"
}

/** Represents a field that can be added to a project */
export type JiraAvailableField = JiraProjectFieldAssociationInterface & {
    __typename?: "JiraAvailableField";
    field?: Maybe<JiraField>;
    fieldOperation?: Maybe<JiraFieldOperation>;
    id: Scalars["ID"]["output"];
};

/** The connection type for JiraAvailableField. */
export type JiraAvailableFieldsConnection = {
    __typename?: "JiraAvailableFieldsConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraAvailableFieldsEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraAvailableField connection. */
export type JiraAvailableFieldsEdge = {
    __typename?: "JiraAvailableFieldsEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraAvailableField>;
};

/** Represents the four avatar sizes' url. */
export type JiraAvatar = {
    __typename?: "JiraAvatar";
    /** A large avatar (48x48 pixels). */
    large?: Maybe<Scalars["String"]["output"]>;
    /** A medium avatar (32x32 pixels). */
    medium?: Maybe<Scalars["String"]["output"]>;
    /** A small avatar (24x24 pixels). */
    small?: Maybe<Scalars["String"]["output"]>;
    /** An extra-small avatar (16x16 pixels). */
    xsmall?: Maybe<Scalars["String"]["output"]>;
};

/** Interface for backgrounds */
export type JiraBackground = {
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

/** The supported background types */
export enum JiraBackgroundType {
    Attachment = "ATTACHMENT",
    Color = "COLOR",
    Custom = "CUSTOM",
    Gradient = "GRADIENT",
    Unsplash = "UNSPLASH"
}

/** Type to hold Jira Background upload token auth details */
export type JiraBackgroundUploadToken = {
    __typename?: "JiraBackgroundUploadToken";
    /** The target collection the token grants access to */
    targetCollection?: Maybe<Scalars["String"]["output"]>;
    /** The token to access the MediaAPI */
    token?: Maybe<Scalars["String"]["output"]>;
    /** The duration the token is valid */
    tokenDurationInSeconds?: Maybe<Scalars["Long"]["output"]>;
};

export type JiraBackgroundUploadTokenResult =
    | JiraBackgroundUploadToken
    | QueryError;

export enum JiraBatchWindowPreference {
    DefaultBatching = "DEFAULT_BATCHING",
    FifteenMinutes = "FIFTEEN_MINUTES",
    FiveMinutes = "FIVE_MINUTES",
    NoBatching = "NO_BATCHING",
    OncePerDay = "ONCE_PER_DAY",
    OneDay = "ONE_DAY",
    OneHour = "ONE_HOUR",
    TenMinutes = "TEN_MINUTES",
    ThirtyMinutes = "THIRTY_MINUTES"
}

/**
 * The internal BB app which provides devOps capabilities
 * This provider will be filtered out from the list of providers if BB SCM is not installed
 */
export type JiraBitbucketDevOpsProvider = JiraDevOpsProvider & {
    __typename?: "JiraBitbucketDevOpsProvider";
    /**
     * The list of capabilities the devOps provider supports
     *
     * This max size of the list is bounded by the total number of enum states
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    capabilities?: Maybe<Array<Maybe<JiraDevOpsCapability>>>;
    /**
     * The human-readable display name of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The link to the web URL of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

export type JiraBitbucketIntegration = {
    __typename?: "JiraBitbucketIntegration";
    /**
     * Bitbucket workspaces(organization in Jira term) that are connected to Jira
     * null is returned if the current user is not Jira admin
     */
    connectedBitbucketWorkspaces?: Maybe<Array<Maybe<JiraBitbucketWorkspace>>>;
    /** If the user dismissed the banner that displays workspaces that are pending acceptance of access requests */
    isPendingAccessRequestBannerDismissed?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * true if the current user is Jira admin and there are workspaces that the user is admin as well(connectable), but Jira is not connected to BBC at all
     * If countPendingApprovalConnection true, it will consider pending approval state connection as connected. True if not given.
     */
    isUserNotConnectedToBitbucketButHasConnectableWorkspace?: Maybe<
        Scalars["Boolean"]["output"]
    >;
};

export type JiraBitbucketIntegrationIsUserNotConnectedToBitbucketButHasConnectableWorkspaceArgs =
    {
        countPendingApprovalConnection?: InputMaybe<
            Scalars["Boolean"]["input"]
        >;
    };

/** Bitbucket workspace (organization in Jira term) that is connected to JSW */
export type JiraBitbucketWorkspace = {
    __typename?: "JiraBitbucketWorkspace";
    /** approval state. If PENDING_APPROVAL, it needs granting access request from Bitbucket workspace to Jira by a Jira admin */
    approvalState?: Maybe<JiraBitbucketWorkspaceApprovalState>;
    /** Bitbucket workspace name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** id of the Jira organization(bitbucket workspace). This is not bitbucket workspace ARI that could be hydrated, but an unique id in Jira */
    workspaceId?: Maybe<Scalars["ID"]["output"]>;
    /** Bitbucket workspace URL */
    workspaceUrl?: Maybe<Scalars["URL"]["output"]>;
};

export enum JiraBitbucketWorkspaceApprovalState {
    Approved = "APPROVED",
    PendingApproval = "PENDING_APPROVAL"
}

/** Represents a Jira Board */
export type JiraBoard = Node & {
    __typename?: "JiraBoard";
    /** Id of the board. e.g. 10000. Temporarily needed to support interoperability with REST. */
    boardId?: Maybe<Scalars["Long"]["output"]>;
    /** Type of the board */
    boardType?: Maybe<JiraBoardType>;
    /** The URL string associated with a board in Jira. */
    boardUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Whether a user has permission to edit the board settings */
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns the default navigation item for this board, represented by `JiraNavigationItem`.
     * Currently only supports software project boards and user boards. Will return `null` otherwise.
     */
    defaultNavigationItem?: Maybe<JiraNavigationItemResult>;
    /** A favourite value which contains the boolean of if it is favourited and a unique ID */
    favouriteValue?: Maybe<JiraFavouriteValue>;
    /** Global identifier for the board */
    id: Scalars["ID"]["output"];
    /** The timestamp of this board was last viewed by the current user (reference to Unix Epoch time in ms). */
    lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
    /** The title/name of the board */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Retrieves a list of available report categories and reports for a Jira board.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraReportCategories")' query directive to the 'reportCategories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    reportCategories?: Maybe<JiraReportCategoryConnection>;
};

/** Represents a Jira Board */
export type JiraBoardReportCategoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for JiraBoard */
export type JiraBoardConnection = {
    __typename?: "JiraBoardConnection";
    /** A list of edges in the current page */
    edges?: Maybe<Array<Maybe<JiraBoardEdge>>>;
    /** Information about the current page. Used to aid in pagination */
    pageInfo: PageInfo;
    /** The total count of items in the connection */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraBoard connection */
export type JiraBoardEdge = {
    __typename?: "JiraBoardEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the edge */
    node?: Maybe<JiraBoard>;
};

export type JiraBoardLocation = {
    /** Id of the project on which the board located in. Applicable for PROJECT location type only. Null otherwise. */
    locationId?: InputMaybe<Scalars["String"]["input"]>;
    /** Location type of the board */
    locationType: JiraBoardLocationType;
};

/** Types of containers that boards can be located in */
export enum JiraBoardLocationType {
    /** Boards located in a project */
    Project = "PROJECT",
    /** Boards located under a user */
    User = "USER"
}

/** A union type representing Jira boards within a Jira project */
export type JiraBoardResult = JiraBoard | QueryError;

/** Strategies for grouping issues into swimlanes on a board */
export enum JiraBoardSwimlaneStrategy {
    AssigneeUnassignedFirst = "ASSIGNEE_UNASSIGNED_FIRST",
    AssigneeUnassignedLast = "ASSIGNEE_UNASSIGNED_LAST",
    Custom = "CUSTOM",
    Epic = "EPIC",
    IssueChildren = "ISSUE_CHILDREN",
    IssueParent = "ISSUE_PARENT",
    None = "NONE",
    ParentChild = "PARENT_CHILD",
    Project = "PROJECT",
    RequestType = "REQUEST_TYPE"
}

/** Types of Jira boards */
export enum JiraBoardType {
    /** The board type without sprints */
    Kanban = "KANBAN",
    /** The board type with sprints */
    Scrum = "SCRUM"
}

/** Represents the data required to render a Jira board view. */
export type JiraBoardView = {
    __typename?: "JiraBoardView";
    /** Whether the current user has permission to publish their customized config of the board view for all users. */
    canPublishViewConfig?: Maybe<Scalars["Boolean"]["output"]>;
    /** A list of options dictating the appearance of board cards. */
    cardOptions?: Maybe<JiraBoardViewCardOptionConnection>;
    /**
     * A list of columns for the board view. The columns rendered are dependent on the groupByConfig, however all possible
     * columns are returned here (status, assignee, category and priority columns).
     */
    columns?: Maybe<JiraBoardViewColumnConnection>;
    /** The number of days after which completed issues are removed from the board view. */
    completedIssueSearchCutOffInDays?: Maybe<Scalars["Int"]["output"]>;
    /** Error which were encountered while fetching the board view. */
    error?: Maybe<QueryError>;
    /** Configuration regarding the filter being applied on the board view. */
    filterConfig?: Maybe<JiraViewFilterConfig>;
    /** Configuration regarding the field to group the board view by. */
    groupByConfig?: Maybe<JiraViewGroupByConfig>;
    /** List of all available fields to group issues on the board view by. */
    groupByOptions?: Maybe<Array<JiraViewGroupByConfig>>;
    /** Opaque ID uniquely identifying this board view. */
    id: Scalars["ID"]["output"];
    /** Whether the user's config of the board view differs from that of the globally published or default settings of the board view. */
    isViewConfigModified?: Maybe<Scalars["Boolean"]["output"]>;
    /** The selected workflow id for the board view. */
    selectedWorkflowId?: Maybe<Scalars["ID"]["output"]>;
};

/** Represents the data required to render a Jira board view. */
export type JiraBoardViewCardOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    enabledOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the data required to render a Jira board view. */
export type JiraBoardViewColumnsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents an assignee column in a Jira board view. */
export type JiraBoardViewAssigneeColumn = JiraBoardViewColumn & {
    __typename?: "JiraBoardViewAssigneeColumn";
    /**
     * Whether the column is collapsed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collapsed?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this column node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Assignee the column contains work items for.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    user?: Maybe<User>;
};

export type JiraBoardViewCardOption = {
    /**
     * Whether the option can be toggled.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canToggle?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the option is enabled.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this card option node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type JiraBoardViewCardOptionConnection = {
    __typename?: "JiraBoardViewCardOptionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraBoardViewCardOptionEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
};

export type JiraBoardViewCardOptionEdge = {
    __typename?: "JiraBoardViewCardOptionEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraBoardViewCardOption>;
};

/** Represents a category column in a Jira board view. */
export type JiraBoardViewCategoryColumn = JiraBoardViewColumn & {
    __typename?: "JiraBoardViewCategoryColumn";
    /**
     * The category option this column represents.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    category?: Maybe<JiraOption>;
    /**
     * Whether the column is collapsed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collapsed?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this column node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type JiraBoardViewColumn = {
    /**
     * Whether the column is collapsed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collapsed?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this column node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type JiraBoardViewColumnConnection = {
    __typename?: "JiraBoardViewColumnConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraBoardViewColumnEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraBoardViewColumnEdge = {
    __typename?: "JiraBoardViewColumnEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraBoardViewColumn>;
};

/** Represents options relating to a field on a Jira board view card. */
export type JiraBoardViewFieldCardOption = JiraBoardViewCardOption & {
    __typename?: "JiraBoardViewFieldCardOption";
    /**
     * Whether the field can be toggled on or off.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canToggle?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the field is to show on cards.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The field this option relates to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    field?: Maybe<JiraField>;
    /**
     * Opaque ID uniquely identifying this card option node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

/** Input to retrieve a Jira board view. */
export type JiraBoardViewInput = {
    /**
     * Input to retrieve a Jira board view. As per the oneOf directive, the board can either be fetched by its navigation
     * item ARI, or by its project key and item id.
     */
    jiraBoardViewQueryInput: JiraBoardViewQueryInput;
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
};

/** Represents a priority column in a Jira board view. */
export type JiraBoardViewPriorityColumn = JiraBoardViewColumn & {
    __typename?: "JiraBoardViewPriorityColumn";
    /**
     * Whether the column is collapsed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collapsed?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this column node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Priority which the column contains work items for.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    priority?: Maybe<JiraPriority>;
};

/** Input to query a Jira board view by its project key and item id. */
export type JiraBoardViewProjectKeyAndItemIdQuery = {
    /** The identifier which indicates the cloud instance this data is to be fetched for, required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /**
     * Item ID of the view in the project. This is the identifier following the `/board/` view type path prefix in the url.
     * The value should not include the path prefix so it must be an empty string if the view path is simply `/board`.
     */
    itemId: Scalars["String"]["input"];
    /** Key of the project which the board view is associated with. */
    projectKey: Scalars["String"]["input"];
};

/**
 * Input to retrieve a Jira board view. As per the oneOf directive, the board can either be fetched by its ARI,
 * or by its project key and item id.
 */
export type JiraBoardViewQueryInput = {
    /** Input to retrieve a Jira board view by its project key and item id. */
    projectKeyAndItemIdQuery?: InputMaybe<JiraBoardViewProjectKeyAndItemIdQuery>;
    /** ARI of the board view to query. */
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input for settings applied to the board view. */
export type JiraBoardViewSettings = {
    /** JQL of the filter applied to the board view. Null when no filter is explicitly applied. */
    filterJql?: InputMaybe<Scalars["String"]["input"]>;
    /** The fieldId of the field to group the board view by. Null when no grouping is explicitly applied. */
    groupBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a status column in a Jira board view. */
export type JiraBoardViewStatusColumn = JiraBoardViewColumn & {
    __typename?: "JiraBoardViewStatusColumn";
    /**
     * Whether the column is collapsed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collapsed?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this column node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * An array of statuses in the column.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statuses?: Maybe<Array<Maybe<JiraStatus>>>;
};

/** Represents options relating to a synthetic field on a Jira board view card. */
export type JiraBoardViewSyntheticFieldCardOption = JiraBoardViewCardOption & {
    __typename?: "JiraBoardViewSyntheticFieldCardOption";
    /**
     * Whether the synthetic field can be toggled.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canToggle?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the synthetic field is enabled.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Opaque ID uniquely identifying this card option node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The name of the synthetic field this option relates to.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The type of the synthetic field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<JiraSyntheticFieldCardOptionType>;
};

/** Represents a generic boolean field for an Issue. E.g. JSM alert linking. */
export type JiraBooleanField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraBooleanField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * The value selected on the Issue or default value configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        value?: Maybe<Scalars["Boolean"]["output"]>;
    };

/** The input type for scheduling the execution of project cleanup recommendations */
export type JiraBulkCleanupProjectsInput = {
    /** Recommendation action for the stale project. */
    projectCleanupAction?: InputMaybe<JiraProjectCleanupRecommendationAction>;
    /** List of recommendation identifiers to be archived */
    recommendationIds?: InputMaybe<Array<Scalars["Long"]["input"]>>;
};

/** The payload type for bulk project archiving and trashing */
export type JiraBulkCleanupProjectsPayload = Payload & {
    __typename?: "JiraBulkCleanupProjectsPayload";
    /** A list of errors which encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /**
     * True if the mutation was successfully applied. False if the mutation was either partially successful or if the
     * mutation failed completely.
     */
    success: Scalars["Boolean"]["output"];
};

export type JiraBulkCreateIssueLinksInput = {
    /** The ID of the type of issue link being created. */
    issueLinkTypeId: Scalars["ID"]["input"];
    /** The ID of the source issue. */
    sourceIssueId: Scalars["ID"]["input"];
    /** The IDs of the target issues. */
    targetIssueIds: Array<Scalars["ID"]["input"]>;
};

export type JiraBulkCreateIssueLinksPayload = Payload & {
    __typename?: "JiraBulkCreateIssueLinksPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Issue links that were created */
    issueLinkEdges?: Maybe<Array<JiraIssueLinkEdge>>;
    /** Were ALL the issue link creations successful */
    success: Scalars["Boolean"]["output"];
};

/** Input type for bulk delete */
export type JiraBulkDeleteInput = {
    /** Refers to issue IDs selected by user for bulk delete */
    selectedIssueIds: Array<Scalars["ID"]["input"]>;
};

/** Retrieves a field which can be bulk edited */
export type JiraBulkEditField = Node & {
    __typename?: "JiraBulkEditField";
    /** Returns options required for fields with multi select options */
    bulkEditMultiSelectFieldOptions?: Maybe<
        Array<Maybe<JiraBulkEditMultiSelectFieldOptions>>
    >;
    /** Field details of the field to be bulk edited */
    field?: Maybe<JiraIssueField>;
    /** Unique identifier for the entity. */
    id: Scalars["ID"]["output"];
    /** Boolean value representing if the field is a default field or not */
    isDefault: Scalars["Boolean"]["output"];
    /** Message indicating why the field is not available for bulk editing */
    unavailableMessage?: Maybe<Scalars["String"]["output"]>;
};

/** Retrieves a connection of fields which can be bulk edited */
export type JiraBulkEditFieldsConnection = HasPageInfo &
    HasTotal & {
        __typename?: "JiraBulkEditFieldsConnection";
        /** The data for Edges in the current page */
        edges?: Maybe<Array<Maybe<JiraBulkEditFieldsEdge>>>;
        /** Information about the current page. Used to aid in pagination. */
        pageInfo: PageInfo;
        /** The total count of items in the connection. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** An edge in a BulkEditFields connection. */
export type JiraBulkEditFieldsEdge = {
    __typename?: "JiraBulkEditFieldsEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraBulkEditField>;
};

/** Specifies inputs for search on fields and a boolean to override them */
export type JiraBulkEditFieldsSearch = {
    /** Specifies the search text for fields */
    searchByText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Specified bulk edit operation input */
export type JiraBulkEditInput = {
    /** Info of the fields edited by user. It will contain the values of edited field */
    editedFieldsInput: JiraIssueFieldsInput;
    /** Refers to the fields selected by user to bulk edit */
    selectedActions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /** Refers to issue IDs selected by user for bulk edit */
    selectedIssueIds: Array<Scalars["ID"]["input"]>;
    /**
     * Refers to whether to send bulk change notification or not
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Abstracting out sendBulkNotification to JiraBulkOperationInput
     */
    sendBulkNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * Contains all options available for fields with multi select options available
 * This field is required only for 4 system field: Fix Versions, Affects Versions, Label and Component
 */
export enum JiraBulkEditMultiSelectFieldOptions {
    /** Represents the Bulk Edit multi select field option for which the field values provided in Bulk Edit will be added to the already set field values */
    Add = "ADD",
    /** Represents the Bulk Edit multi select field option for which the field values provided in Bulk Edit will be removed from the already set field values (if they exist) */
    Remove = "REMOVE",
    /** Represents Bulk Edit multi select field option for which the already set field values will be all removed */
    RemoveAll = "REMOVE_ALL",
    /** Represents the Bulk Edit multi select field option for which the field values provided in Bulk Edit will replace the already set field values */
    Replace = "REPLACE"
}

/** Specified bulk operation input */
export type JiraBulkOperationInput = {
    /** Specifies bulk delete payload. Payload which comes as an input for bulk delete */
    bulkDeleteInput?: InputMaybe<JiraBulkDeleteInput>;
    /** Specifies bulk edit input. Payload which comes as an input for bulk edit */
    bulkEditInput?: InputMaybe<JiraBulkEditInput>;
    /** Specifies bulk transitions payload. Payload which comes as an input for bulk transition */
    bulkTransitionsInput?: InputMaybe<Array<JiraBulkTransitionsInput>>;
    /** Specifies bulk watch or unwatch payload. Payload which comes as an input for bulk watch or unwatch operations */
    bulkWatchOrUnwatchInput?: InputMaybe<JiraBulkWatchOrUnwatchInput>;
    /** Refers to whether to send bulk change notification or not */
    sendBulkNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Specified the type of bulk operation */
export enum JiraBulkOperationType {
    /** Specified bulk delete operation type */
    BulkDelete = "BULK_DELETE",
    /** Specified bulk edit operation type */
    BulkEdit = "BULK_EDIT",
    /** Specified bulk transition operation type */
    BulkTransition = "BULK_TRANSITION",
    /** Specified bulk unwatch operation type */
    BulkUnwatch = "BULK_UNWATCH",
    /** Specified bulk watch operation type */
    BulkWatch = "BULK_WATCH"
}

/** Input to bulk set the collapsed/expanded state of all columns within the board view. */
export type JiraBulkSetBoardViewColumnStateInput = {
    /** Whether all the columns on the board view are to be collapsed or expanded. */
    collapsed: Scalars["Boolean"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to manipulate. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the bulk set board view column state mutation. */
export type JiraBulkSetBoardViewColumnStatePayload = Payload & {
    __typename?: "JiraBulkSetBoardViewColumnStatePayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while expanding or collapsing the board view columns.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Retrives a list of transitions for given issues */
export type JiraBulkTransition = Node & {
    __typename?: "JiraBulkTransition";
    /** Unique identifier for the entity. */
    id: Scalars["ID"]["output"];
    /** Indicated whether some transitions where filtered out due to not being available for all selected issues. */
    isTransitionsFiltered?: Maybe<Scalars["Boolean"]["output"]>;
    /** Issues which are part of that transition. */
    issues?: Maybe<JiraIssueConnection>;
    /** All transitions that are available for the given issues. */
    transitions?: Maybe<JiraTransitionConnection>;
};

/** Retrives a list of transitions for given issues */
export type JiraBulkTransitionIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Retrives a list of transitions for given issues */
export type JiraBulkTransitionTransitionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Retrieves a connection of transitions applicable for a given list of issues */
export type JiraBulkTransitionConnection = {
    __typename?: "JiraBulkTransitionConnection";
    /** The data for Edges in the current page */
    edges?: Maybe<Array<Maybe<JiraBulkTransitionEdge>>>;
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a bulk transition connection. */
export type JiraBulkTransitionEdge = {
    __typename?: "JiraBulkTransitionEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraBulkTransition>;
};

/** Represents the screen layout for a transition and set of issues. */
export type JiraBulkTransitionScreenLayout = Node & {
    __typename?: "JiraBulkTransitionScreenLayout";
    /** Represents the comment field for a transition and set of issues. */
    comment?: Maybe<JiraRichTextField>;
    /** Represents the screen layout for a transition and set of issues. */
    content?: Maybe<JiraScreenTabLayout>;
    /** Unique identifier for the entity. */
    id: Scalars["ID"]["output"];
    /**
     * Represents the issues for which the screen is being fetched.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use issuesToBeEdited field in JiraBulkTransitionScreenLayout instead.
     */
    issues: Array<JiraIssue>;
    /** Represents the issues for which the screen is being fetched and will be edited. */
    issuesToBeEdited?: Maybe<JiraIssueConnection>;
    /** Represents the transition for which the screen is being fetched. */
    transition: JiraTransition;
};

/** Represents the screen layout for a transition and set of issues. */
export type JiraBulkTransitionScreenLayoutIssuesToBeEditedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for bulk transition */
export type JiraBulkTransitionsInput = {
    /** Refers to issue IDs selected by user for bulk transition */
    selectedIssueIds: Array<Scalars["ID"]["input"]>;
    /**
     * Refers to whether to send bulk change notification or not
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Abstracting out sendBulkNotification to JiraBulkOperationInput
     */
    sendBulkNotification?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Refers to a unique transition */
    transitionId: Scalars["String"]["input"];
    /** Refers to any fields which need to be edited due to the transition */
    transitionScreenInput?: InputMaybe<JiraTransitionScreenInput>;
};

/** Input type for bulk watch or unwatch */
export type JiraBulkWatchOrUnwatchInput = {
    /** Refers to issue IDs selected by user for bulk watch or unwatch */
    selectedIssueIds: Array<Scalars["ID"]["input"]>;
};

/** Represents CMDB (Configuration Management Database) field on a Jira Issue. */
export type JiraCmdbField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraCMDBField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Attributes that are configured for autocomplete search.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use `attributesIncludedInAutoCompleteSearch` defined in `JiraCmdbFieldConfig`.
         */
        attributesIncludedInAutoCompleteSearch?: Maybe<
            Array<Maybe<Scalars["String"]["output"]>>
        >;
        /** Attributes of a CMDB field’s configuration info. */
        cmdbFieldConfig?: Maybe<JiraCmdbFieldConfig>;
        /** Fetch CMDB objects within the field */
        cmdbObjects?: Maybe<JiraCmdbObjectConnection>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Indicates whether the current site has sufficient licence for the Insight feature, allowing Jira to show correct error states. */
        isInsightAvailable?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Whether the field is configured to act as single/multi select CMDB(s) field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use `multiple` defined in `JiraCmdbFieldConfig`.
         */
        isMulti?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available cmdb options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The CMDB objects selected on the Issue or default CMDB objects configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedCmdbObjectsConnection instead.
         */
        selectedCmdbObjects?: Maybe<Array<Maybe<JiraCmdbObject>>>;
        /** The CMDB objects selected on the Issue or default CMDB objects configured for the field. */
        selectedCmdbObjectsConnection?: Maybe<JiraCmdbObjectConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /** Indicates whether the field has been enriched with data from Insight, allowing Jira to show correct error states. */
        wasInsightRequestSuccessful?: Maybe<Scalars["Boolean"]["output"]>;
    };

/** Represents CMDB (Configuration Management Database) field on a Jira Issue. */
export type JiraCmdbFieldCmdbObjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    fieldValues?: InputMaybe<Array<InputMaybe<JiraFieldKeyValueInput>>>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents CMDB (Configuration Management Database) field on a Jira Issue. */
export type JiraCmdbFieldSelectedCmdbObjectsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendar = {
    __typename?: "JiraCalendar";
    /**
     * Paginated query to fetch cross versions fitting in the scope and configuration provided in the calendar query.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'crossProjectVersions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    crossProjectVersions?: Maybe<JiraCrossProjectVersionConnection>;
    /** The actual issue field for the endDateField in the input */
    endDateField?: Maybe<JiraIssueField>;
    /** Fetch an issue fitting in the scope and configuration provided in the calendar query. */
    issue?: Maybe<JiraIssueWithScenario>;
    /** Paginated query to fetch issues fitting in the scope and configuration provided in the calendar query. */
    issues?: Maybe<JiraIssueConnection>;
    /**
     * Paginated query to fetch issues fitting in the scope and configuration provided in the calendar query.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'issuesV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issuesV2?: Maybe<JiraScenarioIssueLikeConnection>;
    permissions?: Maybe<JiraCalendarPermissionConnection>;
    /** Return the projects that fall within the scope of the calendar (e.g., board, project, plan, etc.). */
    projects?: Maybe<JiraProjectConnection>;
    /** Paginated query to fetch sprints fitting in the scope and configuration provided in the calendar query. */
    sprints?: Maybe<JiraSprintConnection>;
    /** the actual issue field for the startDateField in the input. */
    startDateField?: Maybe<JiraIssueField>;
    /** Paginated query to fetch unscheduled issues fitting in the scope and configuration provided in the calendar query. */
    unscheduledIssues?: Maybe<JiraIssueConnection>;
    /** Paginated query to fetch versions fitting in the scope and configuration provided in the calendar query. */
    versions?: Maybe<JiraVersionConnection>;
    /** Paginated query to fetch versionsV2 fitting in the scope and configuration provided in the calendar query. */
    versionsV2?: Maybe<JiraScenarioVersionLikeConnection>;
};

export type JiraCalendarCrossProjectVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarCrossProjectVersionsInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarIssueArgs = {
    id: Scalars["ID"]["input"];
    issuesInput?: InputMaybe<JiraCalendarIssuesInput>;
    unscheduledIssuesInput?: InputMaybe<JiraCalendarIssuesInput>;
};

export type JiraCalendarIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarIssuesInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarIssuesV2Args = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarIssuesInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarPermissionsArgs = {
    keys?: InputMaybe<Array<JiraCalendarPermissionKey>>;
};

export type JiraCalendarProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarSprintsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarSprintsInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarUnscheduledIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarIssuesInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarVersionsInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarVersionsV2Args = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraCalendarVersionsInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraCalendarCrossProjectVersionsInput = {
    /**
     * The active window to filter the Versions to.
     * The window bounds are equivalent to filtering Versions where (startDate > start AND startDate < end)
     * OR (releasedate > start AND releasedate < end)
     * If no start or end is provided, the window is considered unbounded in that direction.
     */
    activeWithin?: InputMaybe<JiraDateTimeWindow>;
    /** Versions that have name match this search string will be returned. */
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    /** The status of the Versions to filter to. */
    statuses?: InputMaybe<Array<InputMaybe<JiraVersionStatus>>>;
};

export type JiraCalendarIssuesInput = {
    /** Additional JQL to adjust the search for */
    additionalFilterQuery?: InputMaybe<Scalars["String"]["input"]>;
};

export enum JiraCalendarMode {
    Day = "DAY",
    Month = "MONTH",
    Week = "WEEK"
}

export type JiraCalendarPermission = {
    __typename?: "JiraCalendarPermission";
    aris?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** The key of the permission. */
    permissionKey: Scalars["String"]["output"];
};

export type JiraCalendarPermissionConnection = {
    __typename?: "JiraCalendarPermissionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCalendarPermissionEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraProjectPermission connection. */
export type JiraCalendarPermissionEdge = {
    __typename?: "JiraCalendarPermissionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraCalendarPermission>;
};

export enum JiraCalendarPermissionKey {
    ManageSprintsPermission = "MANAGE_SPRINTS_PERMISSION"
}

export type JiraCalendarSprintsInput = {
    /** Additional filtering on sprint states within the calendar date range. */
    sprintStates?: InputMaybe<Array<JiraSprintState>>;
};

export type JiraCalendarVersionsInput = {
    /**
     * Queries for additional software release versions from projects identified by the ARIs below.
     * This is used for subsequent software release version loading after a project is connected or disconnected on the calendar.
     * Note that this parameter cannot be used in conjunction with includeSharedReleases.
     */
    additionalProjectAris?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * Queries for additional software release versions based on project relationships from AGS.
     * Note that this parameter cannot be used in conjunction with additionalProjectAris.
     */
    includeSharedReleases?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Additional filtering on version statuses within the calendar date range. */
    versionStatuses?: InputMaybe<Array<JiraVersionStatus>>;
};

/** View settings for Jira Calendar */
export type JiraCalendarViewConfigurationInput = {
    /** The date in which the fetched calendar view will be based. Default is the current date. */
    date?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The alias of the custom field that will be used as the end date of the query */
    endDateField?: InputMaybe<Scalars["String"]["input"]>;
    /** The view mode of the calendar, used to determine date ranges to search for issues, sprints, versions, etc. Default is MONTH. */
    mode?: InputMaybe<JiraCalendarMode>;
    /** The alias of the custom field that will be used as the start date of the query */
    startDateField?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The id to derive view configuration from this is most likely the location of the calendar.
     * When a plan ARI is passed in this determines which startDate & endDate fields are used by the calendar.
     */
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The week start day of the calendar, used to determine the first day of the week in the calendar. Default is SUNDAY. */
    weekStart?: InputMaybe<JiraCalendarWeekStart>;
};

export enum JiraCalendarWeekStart {
    Monday = "MONDAY",
    Saturday = "SATURDAY",
    Sunday = "SUNDAY"
}

/** Canned response entity created against a project with defined scope. */
export type JiraCannedResponse = Node & {
    __typename?: "JiraCannedResponse";
    content: Scalars["String"]["output"];
    createdBy?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    isSignature?: Maybe<Scalars["Boolean"]["output"]>;
    lastUpdatedAt?: Maybe<Scalars["Long"]["output"]>;
    projectAri: Scalars["ID"]["output"];
    scope: JiraCannedResponseScope;
    title: Scalars["String"]["output"];
};

export type JiraCannedResponseConnection = {
    __typename?: "JiraCannedResponseConnection";
    edges?: Maybe<Array<JiraCannedResponseEdge>>;
    errors?: Maybe<Array<QueryError>>;
    nodes?: Maybe<Array<Maybe<JiraCannedResponse>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * #########################
 *  Mutation Inputs
 * #########################
 */
export type JiraCannedResponseCreateInput = {
    content: Scalars["String"]["input"];
    isSignature?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectAri: Scalars["ID"]["input"];
    scope: JiraCannedResponseScope;
    title: Scalars["String"]["input"];
};

/**
 * #########################
 *  Mutation Responses
 * #########################
 */
export type JiraCannedResponseCreatePayload = Payload & {
    __typename?: "JiraCannedResponseCreatePayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** The created canned response. */
    jiraCannedResponse?: Maybe<JiraCannedResponse>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraCannedResponseDeletePayload = Payload & {
    __typename?: "JiraCannedResponseDeletePayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** ID of the deleted canned response */
    id: Scalars["ID"]["output"];
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraCannedResponseEdge = {
    __typename?: "JiraCannedResponseEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraCannedResponse>;
};

/**
 * #########################
 *  Query Inputs
 * #########################
 */
export type JiraCannedResponseFilter = {
    /** The project under which canned response should be searched */
    projectAri: Scalars["ID"]["input"];
    /** Query text to search for in title/name */
    query?: InputMaybe<Scalars["String"]["input"]>;
    /** The scopes that should be used to filter canned responses */
    scopes?: InputMaybe<Array<JiraCannedResponseScope>>;
    /** Whether to search only signature canned response */
    signature?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The top level wrapper for the Canned Response Mutation API. */
export type JiraCannedResponseMutationApi = {
    __typename?: "JiraCannedResponseMutationApi";
    /**
     * Create the canned response
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createCannedResponse?: Maybe<JiraCannedResponseCreatePayload>;
    /**
     * Delete the canned response
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteCannedResponse?: Maybe<JiraCannedResponseDeletePayload>;
    /**
     * Update the canned response
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateCannedResponse?: Maybe<JiraCannedResponseUpdatePayload>;
};

/** The top level wrapper for the Canned Response Mutation API. */
export type JiraCannedResponseMutationApiCreateCannedResponseArgs = {
    input: JiraCannedResponseCreateInput;
};

/** The top level wrapper for the Canned Response Mutation API. */
export type JiraCannedResponseMutationApiDeleteCannedResponseArgs = {
    id: Scalars["ID"]["input"];
};

/** The top level wrapper for the Canned Response Mutation API. */
export type JiraCannedResponseMutationApiUpdateCannedResponseArgs = {
    input: JiraCannedResponseUpdateInput;
};

/** The top level wrapper for the Canned Response Query API. */
export type JiraCannedResponseQueryApi = {
    __typename?: "JiraCannedResponseQueryApi";
    /**
     * Fetches canned response by ID. ID represents an ARI of canned response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cannedResponseById?: Maybe<JiraCannedResponseQueryResult>;
    /**
     * Search canned responses in project by applying filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    searchCannedResponses?: Maybe<JiraCannedResponseConnection>;
};

/** The top level wrapper for the Canned Response Query API. */
export type JiraCannedResponseQueryApiCannedResponseByIdArgs = {
    id: Scalars["ID"]["input"];
};

/** The top level wrapper for the Canned Response Query API. */
export type JiraCannedResponseQueryApiSearchCannedResponsesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraCannedResponseFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<JiraCannedResponseSort>;
};

export type JiraCannedResponseQueryResult = JiraCannedResponse | QueryError;

export enum JiraCannedResponseScope {
    Personal = "PERSONAL",
    Project = "PROJECT"
}

export type JiraCannedResponseSort = {
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<JiraCannedResponseSortOrder>;
};

export enum JiraCannedResponseSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type JiraCannedResponseUpdateInput = {
    content: Scalars["String"]["input"];
    /** ID represents a canned response ARI */
    id: Scalars["ID"]["input"];
    isSignature?: InputMaybe<Scalars["Boolean"]["input"]>;
    scope: JiraCannedResponseScope;
    title: Scalars["String"]["input"];
};

export type JiraCannedResponseUpdatePayload = Payload & {
    __typename?: "JiraCannedResponseUpdatePayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated canned response. */
    jiraCannedResponse?: Maybe<JiraCannedResponse>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

/**
 * Represents the pair of values (parent & child combination) in a cascading select.
 * This type is used to represent a selected cascading field value on a Jira Issue.
 * Since this is 2 level hierarchy, it is not possible to represent the same underlying
 * type for both single cascadingOption and list of cascadingOptions. Thus, we have created different types.
 */
export type JiraCascadingOption = {
    __typename?: "JiraCascadingOption";
    /** Defines the selected single child option value for the parent. */
    childOptionValue?: Maybe<JiraOption>;
    /**
     * Defines the parent option value.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use parentOption instead.
     */
    parentOptionValue?: Maybe<JiraOption>;
    /** Defines the parent option value. */
    parentValue?: Maybe<JiraParentOption>;
};

/**
 * Deprecated type. Please use `JiraCascadingParentOption` instead.
 * Represents the childs options allowed values for a parent option in cascading select operation.
 */
export type JiraCascadingOptions = {
    __typename?: "JiraCascadingOptions";
    /** Defines all the list of child options available for the parent option. */
    childOptionValues?: Maybe<Array<Maybe<JiraOption>>>;
    /** Defines the parent option value. */
    parentOptionValue?: Maybe<JiraOption>;
};

/** The connection type for JiraCascadingOptions. */
export type JiraCascadingOptionsConnection = {
    __typename?: "JiraCascadingOptionsConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCascadingOptionsEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraCascadingOptions connection. */
export type JiraCascadingOptionsEdge = {
    __typename?: "JiraCascadingOptionsEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraCascadingOptions>;
};

/** Represents cascading select field. Currently only handles 2 level hierarchy. */
export type JiraCascadingSelectField = JiraHasSelectableValueOptions &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraCascadingSelectField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** The cascading option selected on the Issue or default cascading option configured for the field. */
        cascadingOption?: Maybe<JiraCascadingOption>;
        /**
         * Paginated list of cascading options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use cascadingParentOptions instead.
         */
        cascadingOptions?: Maybe<JiraCascadingOptionsConnection>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Paginated list of cascading parent options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraCascadingParentOptions")' query directive to the 'parentOptions' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        parentOptions?: Maybe<JiraParentOptionConnection>;
        /**
         * Paginated list of JiraCascadingSelectField parent options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents cascading select field. Currently only handles 2 level hierarchy. */
export type JiraCascadingSelectFieldCascadingOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents cascading select field. Currently only handles 2 level hierarchy. */
export type JiraCascadingSelectFieldParentOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents cascading select field. Currently only handles 2 level hierarchy. */
export type JiraCascadingSelectFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type representing cascading field inputs */
export type JiraCascadingSelectFieldInput = {
    /** Value of the child option selected for a cascading select field */
    childOptionValue?: InputMaybe<JiraSelectedOptionInput>;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Value of the parent option selected for a cascading select field */
    parentOptionValue: JiraSelectedOptionInput;
};

export type JiraCascadingSelectFieldOperationInput = {
    /** Accept ARI(s): issue-field-option */
    childOption?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
    /** Accept ARI(s): issue-field-option */
    parentOption?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraCascadingSelectFieldPayload = Payload & {
    __typename?: "JiraCascadingSelectFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraCascadingSelectField>;
    success: Scalars["Boolean"]["output"];
};

/**
 * Cascading options can either be a parent or a child - this enum captures this characteristic.
 *
 * E.g. If there is a parent cascading option named `P1`, it may or may not have
 * child cascading options named `C1` and `C2`.
 * - `P1` would be a `PARENT` enum
 * - `C1` and `C2` would be `CHILD` enums
 */
export enum JiraCascadingSelectOptionType {
    /** All options, regardless of whether they're a parent or child. */
    All = "ALL",
    /** Child option only */
    Child = "CHILD",
    /** Parent option only */
    Parent = "PARENT"
}

/** An input filter used to specify the cascading options returned. */
export type JiraCascadingSelectOptionsFilter = {
    /** The type of cascading option to be returned. */
    optionType: JiraCascadingSelectOptionType;
    /** Used for retrieving CHILD cascading options by specifying the PARENT cascading option's id. */
    parentOptionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Used for retrieving CHILD cascading options by specifying the PARENT cascading option's name. */
    parentOptionName?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the check boxes field on a Jira Issue. */
export type JiraCheckboxesField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraCheckboxesField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        fieldOptions?: Maybe<JiraOptionConnection>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * The options selected on the Issue or default options configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedOptions instead.
         */
        selectedFieldOptions?: Maybe<Array<Maybe<JiraOption>>>;
        /** The options selected on the Issue or default options configured for the field. */
        selectedOptions?: Maybe<JiraOptionConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the check boxes field on a Jira Issue. */
export type JiraCheckboxesFieldFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the check boxes field on a Jira Issue. */
export type JiraCheckboxesFieldSelectedOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for defining the operation on the Checkboxes field of a Jira issue. */
export type JiraCheckboxesFieldOperationInput = {
    /** Accepts ARI(s): issue-field-option */
    ids: Array<Scalars["ID"]["input"]>;
    /**
     * The operation to perform on the Checkboxes field.
     * SET, ADD, REMOVE operations are supported.
     */
    operation: JiraMultiValueFieldOperations;
};

/** The payload type returned after updating the Checkboxes field of a Jira issue. */
export type JiraCheckboxesFieldPayload = Payload & {
    __typename?: "JiraCheckboxesFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Checkboxes field. */
    field?: Maybe<JiraCheckboxesField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/**
 * A union type representing childIssues available within a Jira Issue.
 * The *WithinLimit type is used for childIssues with a count that is within a limit specified by the server.
 * The *ExceedsLimit type is used for childIssues with a count that exceeds a limit specified by the server.
 */
export type JiraChildIssues =
    | JiraChildIssuesExceedingLimit
    | JiraChildIssuesWithinLimit;

/** Represents childIssues with a count that exceeds a limit set by the server. */
export type JiraChildIssuesExceedingLimit = {
    __typename?: "JiraChildIssuesExceedingLimit";
    /** Search string to query childIssues when limit is exceeded. */
    search?: Maybe<Scalars["String"]["output"]>;
};

/** Represents childIssues with a count that is within the count limit set by the server. */
export type JiraChildIssuesWithinLimit = {
    __typename?: "JiraChildIssuesWithinLimit";
    /**
     * Paginated list of childIssues within this Issue.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    issues?: Maybe<JiraIssueConnection>;
};

/** Represents childIssues with a count that is within the count limit set by the server. */
export type JiraChildIssuesWithinLimitIssuesArgs = {
    activeProjectsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connect app which provides devOps capabilities. */
export type JiraClassicConnectDevOpsProvider = JiraDevOpsProvider & {
    __typename?: "JiraClassicConnectDevOpsProvider";
    /**
     * The list of capabilities the devOps provider supports
     *
     * This max size of the list is bounded by the total number of enum states
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    capabilities?: Maybe<Array<Maybe<JiraDevOpsCapability>>>;
    /**
     * The connect app ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    connectAppId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The human-readable display name of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The link to the icon of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The corresponding marketplace app for the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    marketplaceApp?: Maybe<MarketplaceApp>;
    /**
     * The link to the web URL of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

/**
 * Represents aggregated ClassificationLevel for an issue. ClassificationLevel for Jira provides Jira users and admins with
 * the capability to assign pre-existing classification tags to all Content levels.
 */
export type JiraClassificationLevel = {
    __typename?: "JiraClassificationLevel";
    /** The data classification level color. */
    color?: Maybe<JiraColor>;
    /** The definition provided for data classification level. */
    definition?: Maybe<Scalars["String"]["output"]>;
    /** The guideline provided for data classification level. */
    guidelines?: Maybe<Scalars["String"]["output"]>;
    /** Unique identifier referencing the data classification ID. */
    id: Scalars["ID"]["output"];
    /** The data classification level display name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The data classification status. */
    status?: Maybe<JiraClassificationLevelStatus>;
};

export type JiraClassificationLevelConnection = {
    __typename?: "JiraClassificationLevelConnection";
    /** The data for Edges in the current page */
    edges?: Maybe<Array<Maybe<JiraClassificationLevelEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The page info of the current page of results */
    pageInfo?: Maybe<PageInfo>;
    /** The total number of JiraClassificationLevel matching the criteria */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraClassificationLevel connection. */
export type JiraClassificationLevelEdge = {
    __typename?: "JiraClassificationLevelEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraClassificationLevel>;
};

export type JiraClassificationLevelFilterInput = {
    /** Filter the available classification levels by JiraClassificationLevelStatus. */
    filterByStatus: Array<JiraClassificationLevelStatus>;
    /** Filter the available classification levels by JiraClassificationLevelType. */
    filterByType: Array<JiraClassificationLevelType>;
};

/** Enum to define the classification level source. */
export enum JiraClassificationLevelSource {
    Issue = "ISSUE",
    Project = "PROJECT"
}

/** Enum to define the classification level status. */
export enum JiraClassificationLevelStatus {
    Archived = "ARCHIVED",
    Draft = "DRAFT",
    Published = "PUBLISHED"
}

/** Enum to define the classification level type. */
export enum JiraClassificationLevelType {
    System = "SYSTEM",
    User = "USER"
}

/** Input type for a clearable number field */
export type JiraClearableNumberFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    value?: InputMaybe<Scalars["Float"]["input"]>;
};

/** Input type for performing a clone operation for the issue */
export type JiraCloneIssueInput = {
    /** Input for assignee of cloned issue. If omitted, the original issue's assignee will be used. */
    assignee?: InputMaybe<JiraUserInfoInput>;
    /** Whether attachments are to be cloned. */
    includeAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether comments are also cloned. */
    includeComments?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether issue links are cloned. */
    includeLinks?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether subtasks or child issues are to be cloned. */
    includeSubtasksOrChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** ARI of the issue to be cloned */
    issueId: Scalars["ID"]["input"];
    /** A map of custom field IDs, for example customfield_10044, indicating whether custom fields should cloned or not. Fields are cloned by default. */
    optionalFields?: InputMaybe<Array<JiraOptionalFieldInput>>;
    /** Input for reporter of cloned issue. If omitted, the original issue's reporter will be used. */
    reporter?: InputMaybe<JiraUserInfoInput>;
    /** The summary for the cloned issue. If omitted, the original issue's summary will be used. */
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response type for the clone issue mutation */
export type JiraCloneIssueResponse = Payload & {
    __typename?: "JiraCloneIssueResponse";
    /** List of errors encountered while attempting the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates the success status of the mutation */
    success: Scalars["Boolean"]["output"];
    /** Description of the state of the clone task. */
    taskDescription?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the issue clone task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
    /** The status of the clone task. */
    taskStatus?: Maybe<JiraLongRunningTaskStatus>;
};

/** Represents the attribute associated with the CMDB object. */
export type JiraCmdbAttribute = {
    __typename?: "JiraCmdbAttribute";
    /**
     * Deprecated: The attribute ID will be removed. Use the combination of objectTypeAttributeId and objectId instead.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated attributeId will be removed in the future. Use the combination of objectTypeAttributeId and objectId instead.
     */
    attributeId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Paginated list of attribute values present on the CMDB object.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    objectAttributeValues?: Maybe<JiraCmdbObjectAttributeValueConnection>;
    /** The object type attribute. */
    objectTypeAttribute?: Maybe<JiraCmdbObjectTypeAttribute>;
    /** The object type attribute ID. */
    objectTypeAttributeId?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the attribute associated with the CMDB object. */
export type JiraCmdbAttributeObjectAttributeValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for JiraCmdbAttribute. */
export type JiraCmdbAttributeConnection = {
    __typename?: "JiraCmdbAttributeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCmdbAttributeEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraCmdbAttribute connection. */
export type JiraCmdbAttributeEdge = {
    __typename?: "JiraCmdbAttributeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraCmdbAttribute>;
};

/** The category of the CMDB attribute that can be created. */
export enum JiraCmdbAttributeType {
    /** Bitbucket repository attribute. */
    BitbucketRepo = "BITBUCKET_REPO",
    /** Confluence attribute. */
    Confluence = "CONFLUENCE",
    /** Default attributes, e.g. text, boolean, integer, date. */
    Default = "DEFAULT",
    /** Group attribute. */
    Group = "GROUP",
    /** Opsgenie team attribute. */
    OpsgenieTeam = "OPSGENIE_TEAM",
    /** Project attribute. */
    Project = "PROJECT",
    /** Reference object attribute. */
    ReferencedObject = "REFERENCED_OBJECT",
    /** Status attribute. */
    Status = "STATUS",
    /** User attribute. */
    User = "USER",
    /** Version attribute. */
    Version = "VERSION"
}

/** Represents a CMDB avatar. */
export type JiraCmdbAvatar = {
    __typename?: "JiraCmdbAvatar";
    /** The UUID of the CMDB avatar. */
    avatarUUID?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the CMDB avatar. */
    id?: Maybe<Scalars["String"]["output"]>;
    /** The media client config used for retrieving the CMDB Avatar. */
    mediaClientConfig?: Maybe<JiraCmdbMediaClientConfig>;
    /** The 16x16 pixel CMDB avatar. */
    url16?: Maybe<Scalars["String"]["output"]>;
    /** The 48x48 pixel CMDB avatar. */
    url48?: Maybe<Scalars["String"]["output"]>;
    /** The 72x72 pixel CMDB avatar. */
    url72?: Maybe<Scalars["String"]["output"]>;
    /** The 144x144 pixel CMDB avatar. */
    url144?: Maybe<Scalars["String"]["output"]>;
    /** The 288x288 pixel CMDB avatar. */
    url288?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the CMDB Bitbucket Repository. */
export type JiraCmdbBitbucketRepository = {
    __typename?: "JiraCmdbBitbucketRepository";
    /** The url of the avatar for the CMDB Bitbucket Repository. */
    avatarUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The ID of the Bitbucket Workspace of the CMDB Bitbucket Repository. */
    bitbucketWorkspaceId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the CMDB Bitbucket Repository. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The url of the CMDB Bitbucket Repository. */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** The UUID of the CMDB Bitbucket . */
    uuid?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for CMDB config attributes. */
export type JiraCmdbConfigAttributeConnection = {
    __typename?: "JiraCmdbConfigAttributeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCmdbConfigAttributeEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraCmdbConfigAttributeConnection. */
export type JiraCmdbConfigAttributeEdge = {
    __typename?: "JiraCmdbConfigAttributeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Represents the CMDB default type.
 * This contains information about what type of default attribute this is.
 * The possible id: name values are as follows:
 *     0: Text
 *     1: Integer
 *     2: Boolean
 *     3: Float
 *     4: Date
 *     6: DateTime
 *     7: URL
 *     8: Email
 *     9: Textarea
 *     10: Select
 *     11: IP Address
 */
export type JiraCmdbDefaultType = {
    __typename?: "JiraCmdbDefaultType";
    /** The ID of the CMDB default type. */
    id?: Maybe<Scalars["String"]["output"]>;
    /** The name of the CMDB default type. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Attributes of CMDB field configuration. */
export type JiraCmdbFieldConfig = {
    __typename?: "JiraCmdbFieldConfig";
    /**
     * Paginated list of CMDB attributes displayed on issue.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    attributesDisplayedOnIssue?: Maybe<JiraCmdbConfigAttributeConnection>;
    /**
     * Paginated list of CMDB attributes included in autocomplete search.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    attributesIncludedInAutoCompleteSearch?: Maybe<JiraCmdbConfigAttributeConnection>;
    /** The issue scope filter query. */
    issueScopeFilterQuery?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether this CMDB field should contain multiple CMDB objects or not. */
    multiple?: Maybe<Scalars["Boolean"]["output"]>;
    /** The object filter query. */
    objectFilterQuery?: Maybe<Scalars["String"]["output"]>;
    /** The object schema ID associated with the CMDB object. */
    objectSchemaId: Scalars["String"]["output"];
};

/** Attributes of CMDB field configuration. */
export type JiraCmdbFieldConfigAttributesDisplayedOnIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Attributes of CMDB field configuration. */
export type JiraCmdbFieldConfigAttributesIncludedInAutoCompleteSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for defining the operation on Cmdb field of a Jira issue. */
export type JiraCmdbFieldOperationInput = {
    /** Accept IDs: Cmdb objects */
    ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * The operations to perform on Cmdb field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating Cmdb field of a Jira issue. */
export type JiraCmdbFieldPayload = Payload & {
    __typename?: "JiraCmdbFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Cmdb field. */
    field?: Maybe<JiraCmdbField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents a CMDB icon. */
export type JiraCmdbIcon = {
    __typename?: "JiraCmdbIcon";
    /** The ID of the CMDB icon. */
    id: Scalars["String"]["output"];
    /** The name of the CMDB icon. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the small CMDB icon. */
    url16?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the large CMDB icon. */
    url48?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the media client config used for retrieving the CMDB Avatar. */
export type JiraCmdbMediaClientConfig = {
    __typename?: "JiraCmdbMediaClientConfig";
    /** The media client ID for the CMDB avatar. */
    clientId?: Maybe<Scalars["String"]["output"]>;
    /** The media file ID for the CMDB avatar. */
    fileId?: Maybe<Scalars["String"]["output"]>;
    /** The ASAP issuer of the media token. */
    issuer?: Maybe<Scalars["String"]["output"]>;
    /** The media base URL for the CMDB avatar. */
    mediaBaseUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The media JWT token for the CMDB avatar. */
    mediaJwtToken?: Maybe<Scalars["String"]["output"]>;
};

/** Jira Configuration Management Database. */
export type JiraCmdbObject = {
    __typename?: "JiraCmdbObject";
    /**
     * Paginated list of attributes present on the CMDB object.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    attributes?: Maybe<JiraCmdbAttributeConnection>;
    /** The avatar associated with this CMDB object. */
    avatar?: Maybe<JiraCmdbAvatar>;
    /**
     * DEPRECATED: JiraCmdbObject is not considered as a Node and so id will not be populated. This will be removed in the future.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated JiraCmdbObject is not considered as a Node and so id will not be populated. This will be removed in the future.
     */
    id?: Maybe<Scalars["String"]["output"]>;
    /** Label of the CMDB object. */
    label?: Maybe<Scalars["String"]["output"]>;
    /** Unique object id formed with `workspaceId`:`objectId`. */
    objectGlobalId?: Maybe<Scalars["String"]["output"]>;
    /** Unique id in the workspace of the CMDB object. */
    objectId?: Maybe<Scalars["String"]["output"]>;
    /** The key associated with the CMDB object. */
    objectKey?: Maybe<Scalars["String"]["output"]>;
    /** The CMDB object type. */
    objectType?: Maybe<JiraCmdbObjectType>;
    /** The URL link for this CMDB object. */
    webUrl?: Maybe<Scalars["String"]["output"]>;
    /** Workspace id of the CMDB object. */
    workspaceId?: Maybe<Scalars["String"]["output"]>;
};

/** Jira Configuration Management Database. */
export type JiraCmdbObjectAttributesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Represents the CMDB object attribute value.
 * The property values in this type will be defined depending on the attribute type.
 * E.g. the `referenceObject` property value will only be defined if the attribute type is a reference object type.
 */
export type JiraCmdbObjectAttributeValue = {
    __typename?: "JiraCmdbObjectAttributeValue";
    /** The additional value of this CMDB object attribute value. */
    additionalValue?: Maybe<Scalars["String"]["output"]>;
    /** The Bitbucket Repository associated with this CMDB object attribute value. */
    bitbucketRepo?: Maybe<JiraCmdbBitbucketRepository>;
    /** The display value of this CMDB object attribute value. */
    displayValue?: Maybe<Scalars["String"]["output"]>;
    /** The group associated with this CMDB object attribute value. */
    group?: Maybe<JiraGroup>;
    /** The Opsgenie team associated with this CMDB object attribute value. */
    opsgenieTeam?: Maybe<JiraOpsgenieTeam>;
    /** The Jira Project associated with this CMDB object attribute value. */
    project?: Maybe<JiraProject>;
    /** The referenced CMDB object. */
    referencedObject?: Maybe<JiraCmdbObject>;
    /** The search value of this CMDB object attribute value. */
    searchValue?: Maybe<Scalars["String"]["output"]>;
    /** The status of this CMDB object attribute value. */
    status?: Maybe<JiraCmdbStatusType>;
    /** The user associated with this CMDB object attribute value. */
    user?: Maybe<User>;
    /** The value of this CMDB object attribute value. */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraCmdbObjectAttributeValue. */
export type JiraCmdbObjectAttributeValueConnection = {
    __typename?: "JiraCmdbObjectAttributeValueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCmdbObjectAttributeValueEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraCmdbObjectAttributeValue connection. */
export type JiraCmdbObjectAttributeValueEdge = {
    __typename?: "JiraCmdbObjectAttributeValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraCmdbObjectAttributeValue>;
};

/** The connection type for JiraCmdbObject. */
export type JiraCmdbObjectConnection = {
    __typename?: "JiraCmdbObjectConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCmdbObjectEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraCmdbObject connection. */
export type JiraCmdbObjectEdge = {
    __typename?: "JiraCmdbObjectEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraCmdbObject>;
};

/** Represents the CMDB object type. */
export type JiraCmdbObjectType = {
    __typename?: "JiraCmdbObjectType";
    /** The description of the CMDB object type. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The icon of the CMDB object type. */
    icon?: Maybe<JiraCmdbIcon>;
    /** The name of the CMDB object type. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The object schema id of the CMDB object type. */
    objectSchemaId?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the CMDB object type. */
    objectTypeId: Scalars["String"]["output"];
};

/** Represents the CMDB object type attribute. */
export type JiraCmdbObjectTypeAttribute = {
    __typename?: "JiraCmdbObjectTypeAttribute";
    /** The additional value of the CMDB object type attribute. */
    additionalValue?: Maybe<Scalars["String"]["output"]>;
    /**
     * The default type of the CMDB object type attribute.
     * This property will be present if the `type` of the attribute is `DEFAULT`.
     */
    defaultType?: Maybe<JiraCmdbDefaultType>;
    /** The description of the CMDB object type attribute. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** A boolean representing whether this attribute is set as the label attribute or not. */
    label?: Maybe<Scalars["Boolean"]["output"]>;
    /** The name of the CMDB object type attribute. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The object type of the CMDB object type attribute. */
    objectType?: Maybe<JiraCmdbObjectType>;
    /**
     * The reference object type of the CMDB object type attribute.
     * This property will be present if the `type` of the attribute is `REFERENCED_OBJECT`.
     */
    referenceObjectType?: Maybe<JiraCmdbObjectType>;
    /**
     * The reference object type ID of the CMDB object type attribute.
     * This property will be present if the `type` of the attribute is `REFERENCED_OBJECT`.
     */
    referenceObjectTypeId?: Maybe<Scalars["String"]["output"]>;
    /**
     * The reference type of the CMDB object type attribute.
     * This property will be present if the `type` of the attribute is `REFERENCED_OBJECT`.
     */
    referenceType?: Maybe<JiraCmdbReferenceType>;
    /** The suffix associated with the CMDB object type attribute. */
    suffix?: Maybe<Scalars["String"]["output"]>;
    /** The category of the CMDB attribute that can be created. */
    type?: Maybe<JiraCmdbAttributeType>;
};

/**
 * Represents the CMDB reference type.
 * This describes the type of connection between one object and another.
 */
export type JiraCmdbReferenceType = {
    __typename?: "JiraCmdbReferenceType";
    /** The color of the CMDB reference type. */
    color?: Maybe<Scalars["String"]["output"]>;
    /** The description of the CMDB reference type. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the CMDB reference type. */
    id?: Maybe<Scalars["String"]["output"]>;
    /** The name of the CMDB reference type. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The object schema ID of the CMDB reference type. */
    objectSchemaId?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the icon of the CMDB reference type. */
    webUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the CMDB status type. */
export type JiraCmdbStatusType = {
    __typename?: "JiraCmdbStatusType";
    /** The category of the CMDB status type. */
    category?: Maybe<Scalars["Int"]["output"]>;
    /** The description of the CMDB status type. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the CMDB status type. */
    id?: Maybe<Scalars["String"]["output"]>;
    /** The name of the CMDB status type. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The object schema ID associated with the CMDB status type. */
    objectSchemaId?: Maybe<Scalars["String"]["output"]>;
};

/** Jira color that displays on a field. */
export type JiraColor = {
    __typename?: "JiraColor";
    /** The key associated with the color based on the field type (issue color, epic color). */
    colorKey?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the color. */
    id?: Maybe<Scalars["ID"]["output"]>;
};

/** A Jira Background which is a solid color type */
export type JiraColorBackground = JiraBackground & {
    __typename?: "JiraColorBackground";
    /** The color if the background is a color type */
    colorValue?: Maybe<Scalars["String"]["output"]>;
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

/** Represents color field on a Jira Issue. E.g. issue color, epic color. */
export type JiraColorField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraColorField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** The color selected on the Issue or default color configured for the field. */
        color?: Maybe<JiraColor>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input type for a color field */
export type JiraColorFieldInput = {
    /** Represents a single color */
    color: JiraColorInput;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

export type JiraColorFieldOperationInput = {
    color: Scalars["String"]["input"];
    operation: JiraSingleValueFieldOperations;
};

export type JiraColorFieldPayload = Payload & {
    __typename?: "JiraColorFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraColorField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type representing a single colour */
export type JiraColorInput = {
    /** Name/Value of the color */
    name: Scalars["String"]["input"];
};

/** The options for the Jira color scheme theme preference. */
export enum JiraColorSchemeThemeSetting {
    /** Theme matches the user browser settings */
    Automatic = "AUTOMATIC",
    /** Dark mode theme */
    Dark = "DARK",
    /** Light mode theme */
    Light = "LIGHT"
}

/** An interface shared across all comment types. */
export type JiraComment = {
    /** User profile of the original comment author. */
    author?: Maybe<User>;
    /**
     * Paginated list of child comments on this comment.
     * Order will always be based on creation time (ascending).
     * Note - No support for focused child comments or sorting order on child comments is provided.
     */
    childComments?: Maybe<JiraCommentConnection>;
    /** Identifier for the comment. */
    commentId: Scalars["ID"]["output"];
    /** Time of comment creation. */
    created: Scalars["DateTime"]["output"];
    /**
     * Property to denote if the comment is a deleted root comment. Default value is False.
     * When true, all other attributes will be null except for id, commentId, childComments and created.
     */
    isDeleted?: Maybe<Scalars["Boolean"]["output"]>;
    /** The issue to which this comment is belonged. */
    issue?: Maybe<JiraIssue>;
    /**
     * Either the group or the project role associated with this comment, but not both.
     * Null means the permission level is unspecified, i.e. the comment is public.
     */
    permissionLevel?: Maybe<JiraPermissionLevel>;
    /** Comment body rich text. */
    richText?: Maybe<JiraRichText>;
    /**
     * Parent ID of the child for which data is requested. This should be non-null if a child comment is requested and
     * null if a root comment is requested.
     */
    threadParentId?: Maybe<Scalars["ID"]["output"]>;
    /** User profile of the author performing the comment update. */
    updateAuthor?: Maybe<User>;
    /** Time of last comment update. */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The browser clickable link of this comment. */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** An interface shared across all comment types. */
export type JiraCommentChildCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    afterTarget?: InputMaybe<Scalars["Int"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    beforeTarget?: InputMaybe<Scalars["Int"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    targetId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The connection type for JiraComment. */
export type JiraCommentConnection = {
    __typename?: "JiraCommentConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCommentEdge>>>;
    /** The approximate count of items in the connection. */
    indicativeCount?: Maybe<Scalars["Int"]["output"]>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    /**
     * The amount of comments in the current page.
     * This is an inefficient way of retrieving the comment count as we need to load all comments to do so.
     * We will be replacing this with something more efficient in future, this is just temporary.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssue")' query directive to the 'pageItemCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    pageItemCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraComment connection. */
export type JiraCommentEdge = {
    __typename?: "JiraCommentEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraComment>;
};

/** The field for sorting comments. */
export enum JiraCommentSortField {
    /** sorts by the created date */
    Created = "CREATED"
}

export type JiraCommentSortInput = {
    /** The field to sort on. */
    field: JiraCommentSortField;
    /** The sort direction. */
    order: SortDirection;
};

export type JiraCommentSummary = {
    __typename?: "JiraCommentSummary";
    /**
     * Indicates whether the current user has a permission to add comments. This drives the visibility of the 'Add comment' button
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canAddComment?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Number of comments on this work item
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Represents a virtual field that summarises information about comments on an issue
 * Virtual fields are only returned from fieldSetsById and fieldSetsForIssueSearchView on the JiraIssue
 */
export type JiraCommentSummaryField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraCommentSummaryField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The comment summary value
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        commentSummary?: Maybe<JiraCommentSummary>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

/**
 * Jira component defines two kinds of Components:
 *     1. Project Components, sub-selection of a project.
 *     2. Global Components, which span across multiple projects.
 * One of the Global Components type is Compass Components.
 */
export type JiraComponent = Node & {
    __typename?: "JiraComponent";
    /**
     * ARI of the Compass Component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari?: Maybe<Scalars["String"]["output"]>;
    /**
     * Component id in digital format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    componentId: Scalars["String"]["output"];
    /**
     * Component description.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * Global identifier for the color.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Metadata for a Compass Component.
     * Map<String,String> using a json representation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    metadata?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The name of the component.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraComponent. */
export type JiraComponentConnection = {
    __typename?: "JiraComponentConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraComponentEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total number of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraComponent connection. */
export type JiraComponentEdge = {
    __typename?: "JiraComponentEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraComponent>;
};

export type JiraComponentFieldOperationInput = {
    /** Accept ARI(s): component */
    ids: Array<Scalars["ID"]["input"]>;
    operation: JiraMultiValueFieldOperations;
};

/** Input type for component field */
export type JiraComponentInput = {
    /** An identifier representing a component */
    componentId: Scalars["ID"]["input"];
};

/** Represents components field on a Jira Issue. */
export type JiraComponentsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraComponentsField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Paginated list of component options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        components?: Maybe<JiraComponentConnection>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * The component selected on the Issue or default component configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedComponentsConnection instead.
         */
        selectedComponents?: Maybe<Array<Maybe<JiraComponent>>>;
        /** The component selected on the Issue or default component configured for the field. */
        selectedComponentsConnection?: Maybe<JiraComponentConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents components field on a Jira Issue. */
export type JiraComponentsFieldComponentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents components field on a Jira Issue. */
export type JiraComponentsFieldSelectedComponentsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraComponentsFieldPayload = Payload & {
    __typename?: "JiraComponentsFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraComponentsField>;
    success: Scalars["Boolean"]["output"];
};

/** Represent the types of fields that can be configured for an Issue type in a Jira */
export enum JiraConfigFieldType {
    /** Allows multiple values to be selected using two select lists */
    CustomCascadingSelect = "CUSTOM_CASCADING_SELECT",
    /** Stores a date with a time component */
    CustomDatetime = "CUSTOM_DATETIME",
    /** Stores a date using a picker control */
    CustomDatePicker = "CUSTOM_DATE_PICKER",
    /** Stores and validates a numeric (floating point) input */
    CustomFloat = "CUSTOM_FLOAT",
    /** Stores a user group using a picker control */
    CustomGroupPicker = "CUSTOM_GROUP_PICKER",
    /** A read-only field that stores the previous ID of the issue from the system that it was imported from */
    CustomImportId = "CUSTOM_IMPORT_ID",
    /** Stores labels */
    CustomLabels = "CUSTOM_LABELS",
    /** Stores multiple values using checkboxes */
    CustomMultiCheckboxes = "CUSTOM_MULTI_CHECKBOXES",
    /** Stores multiple user groups using a picker control */
    CustomMultiGroupPicker = "CUSTOM_MULTI_GROUP_PICKER",
    /** Stores multiple values using a select list */
    CustomMultiSelect = "CUSTOM_MULTI_SELECT",
    /** Stores multiple users using a picker control */
    CustomMultiUserPicker = "CUSTOM_MULTI_USER_PICKER",
    /** Stores multiple versions from the versions available in a project using a picker control */
    CustomMultiVersion = "CUSTOM_MULTI_VERSION",
    /** Stores a project from a list of projects that the user is permitted to view */
    CustomProject = "CUSTOM_PROJECT",
    /** Stores a value using radio buttons */
    CustomRadioButtons = "CUSTOM_RADIO_BUTTONS",
    /** Stores a read-only text value, which can only be populated via the API */
    CustomReadonlyField = "CUSTOM_READONLY_FIELD",
    /** Stores a value from a configurable list of options */
    CustomSelect = "CUSTOM_SELECT",
    /** Stores a long text string using a multiline text area */
    CustomTextarea = "CUSTOM_TEXTAREA",
    /** Stores a text string using a single-line text box */
    CustomTextField = "CUSTOM_TEXT_FIELD",
    /** Stores a URL */
    CustomUrl = "CUSTOM_URL",
    /** Stores a user using a picker control */
    CustomUserPicker = "CUSTOM_USER_PICKER",
    /** Stores a version using a picker control */
    CustomVersion = "CUSTOM_VERSION",
    /** Servicedesk approvals field */
    ServicedeskApprovals = "SERVICEDESK_APPROVALS",
    /** Servicedesk cmdb field */
    ServicedeskCmdbField = "SERVICEDESK_CMDB_FIELD",
    /** Servicedesk customer organizations field */
    ServicedeskCustomerOrganizations = "SERVICEDESK_CUSTOMER_ORGANIZATIONS",
    /** Servicedesk request feedback field */
    ServicedeskRequestFeedback = "SERVICEDESK_REQUEST_FEEDBACK",
    /** Servicedesk feedback date field */
    ServicedeskRequestFeedbackDate = "SERVICEDESK_REQUEST_FEEDBACK_DATE",
    /** Servicedesk request language field */
    ServicedeskRequestLanguage = "SERVICEDESK_REQUEST_LANGUAGE",
    /** Servicedesk request participants field */
    ServicedeskRequestParticipants = "SERVICEDESK_REQUEST_PARTICIPANTS",
    /** Servicedesk sla field */
    ServicedeskSlaField = "SERVICEDESK_SLA_FIELD",
    /** Servicedesk vp origin field */
    ServicedeskVpOrigin = "SERVICEDESK_VP_ORIGIN",
    /** Software epic color field */
    SoftwareEpicColor = "SOFTWARE_EPIC_COLOR",
    /** Software epic issue color field */
    SoftwareEpicIssueColor = "SOFTWARE_EPIC_ISSUE_COLOR",
    /** Software epic label field */
    SoftwareEpicLabel = "SOFTWARE_EPIC_LABEL",
    /** Software epic lexo rank field */
    SoftwareEpicLexoRank = "SOFTWARE_EPIC_LEXO_RANK",
    /** Software epic link field */
    SoftwareEpicLink = "SOFTWARE_EPIC_LINK",
    /** Software epic sprint field */
    SoftwareEpicSprint = "SOFTWARE_EPIC_SPRINT",
    /** Software epic status field */
    SoftwareEpicStatus = "SOFTWARE_EPIC_STATUS",
    /** Standard affected versions issue field */
    StandardAffectedVersions = "STANDARD_AFFECTED_VERSIONS",
    /** Standard aggregate progress issue field */
    StandardAggregateProgress = "STANDARD_AGGREGATE_PROGRESS",
    /** Standard aggregate time estimate issue field */
    StandardAggregateTimeEstimate = "STANDARD_AGGREGATE_TIME_ESTIMATE",
    /** Standard aggregate time original estimate issue field */
    StandardAggregateTimeOriginalEstimate = "STANDARD_AGGREGATE_TIME_ORIGINAL_ESTIMATE",
    /** Standard aggregate time spent issue field */
    StandardAggregateTimeSpent = "STANDARD_AGGREGATE_TIME_SPENT",
    /** Standard assignee issue field */
    StandardAssignee = "STANDARD_ASSIGNEE",
    /** Standard attachment issue field */
    StandardAttachment = "STANDARD_ATTACHMENT",
    /** Standard comment issue field */
    StandardComment = "STANDARD_COMMENT",
    /** Standard components issue field */
    StandardComponents = "STANDARD_COMPONENTS",
    /** Standard created issue field */
    StandardCreated = "STANDARD_CREATED",
    /** Standard creator issue field */
    StandardCreator = "STANDARD_CREATOR",
    /** Standard description issue field */
    StandardDescription = "STANDARD_DESCRIPTION",
    /** Standard due date issue field */
    StandardDueDate = "STANDARD_DUE_DATE",
    /** Standard environment issue field */
    StandardEnvironment = "STANDARD_ENVIRONMENT",
    /** Standard fix for versions issue field */
    StandardFixForVersions = "STANDARD_FIX_FOR_VERSIONS",
    /** Standard form token issue field */
    StandardFormToken = "STANDARD_FORM_TOKEN",
    /** Standard issue key issue field */
    StandardIssueKey = "STANDARD_ISSUE_KEY",
    /** Standard issue links issue field */
    StandardIssueLinks = "STANDARD_ISSUE_LINKS",
    /** Standard issue number issue field */
    StandardIssueNumber = "STANDARD_ISSUE_NUMBER",
    /** Standard issue type issue field */
    StandardIssueType = "STANDARD_ISSUE_TYPE",
    /** Standard labels issue field */
    StandardLabels = "STANDARD_LABELS",
    /** Standard last viewed issue field */
    StandardLastViewed = "STANDARD_LAST_VIEWED",
    /** Standard parent issue field */
    StandardParent = "STANDARD_PARENT",
    /** Standard priority issue field */
    StandardPriority = "STANDARD_PRIORITY",
    /** Standard progress issue field */
    StandardProgress = "STANDARD_PROGRESS",
    /** Standard project issue field */
    StandardProject = "STANDARD_PROJECT",
    /** Standard project key issue field */
    StandardProjectKey = "STANDARD_PROJECT_KEY",
    /** Standard reporter issue field */
    StandardReporter = "STANDARD_REPORTER",
    /** Standard resolution issue field */
    StandardResolution = "STANDARD_RESOLUTION",
    /** Standard resolution date issue field */
    StandardResolutionDate = "STANDARD_RESOLUTION_DATE",
    /** Standard security issue field */
    StandardSecurity = "STANDARD_SECURITY",
    /** Standard status issue field */
    StandardStatus = "STANDARD_STATUS",
    /** Standard subtasks issue field */
    StandardSubtasks = "STANDARD_SUBTASKS",
    /** Standard summary issue field */
    StandardSummary = "STANDARD_SUMMARY",
    /** Standard thumbnail issue field */
    StandardThumbnail = "STANDARD_THUMBNAIL",
    /** Standard time tracking issue field */
    StandardTimetracking = "STANDARD_TIMETRACKING",
    /** Standard time estimate issue field */
    StandardTimeEstimate = "STANDARD_TIME_ESTIMATE",
    /** Standard original estimate issue field */
    StandardTimeOriginalEstimate = "STANDARD_TIME_ORIGINAL_ESTIMATE",
    /** Standard time spent issue field */
    StandardTimeSpent = "STANDARD_TIME_SPENT",
    /** Standard updated issue field */
    StandardUpdated = "STANDARD_UPDATED",
    /** Standard voters issue field */
    StandardVoters = "STANDARD_VOTERS",
    /** Standard votes issue field */
    StandardVotes = "STANDARD_VOTES",
    /** Standard watchers issue field */
    StandardWatchers = "STANDARD_WATCHERS",
    /** Standard watches issue field */
    StandardWatches = "STANDARD_WATCHES",
    /** Standard worklog issue field */
    StandardWorklog = "STANDARD_WORKLOG",
    /** Standard work ratio issue field */
    StandardWorkratio = "STANDARD_WORKRATIO",
    /** Used to represent a Field type that is currently not handled */
    Unsupported = "UNSUPPORTED"
}

/** JiraConfigState represents the configured status for a workspace for a jira app */
export type JiraConfigState = {
    __typename?: "JiraConfigState";
    /** App Id of app */
    appId: Scalars["ID"]["output"];
    /** Configure link of app if available */
    configureLink?: Maybe<Scalars["String"]["output"]>;
    /** Configure text of app if available */
    configureText?: Maybe<Scalars["String"]["output"]>;
    /** Configure status of app */
    status?: Maybe<JiraConfigStateConfigurationStatus>;
    /** workspace id of app */
    workspaceId: Scalars["ID"]["output"];
};

/** Enum representing the configured status for a jira app/workspace */
export enum JiraConfigStateConfigurationStatus {
    /** App is in configured state */
    Configured = "CONFIGURED",
    /** App is not in configured state */
    NotConfigured = "NOT_CONFIGURED",
    /** App is not installed */
    NotInstalled = "NOT_INSTALLED",
    /** Configured state not set */
    NotSet = "NOT_SET",
    /** App is in partially configured state */
    PartiallyConfigured = "PARTIALLY_CONFIGURED",
    /** Provider action is in configured state */
    ProviderActionConfigured = "PROVIDER_ACTION_CONFIGURED",
    /** Provider action is not in configured state */
    ProviderActionNotConfigured = "PROVIDER_ACTION_NOT_CONFIGURED"
}

/** Connection object representing config state for a set of jira app workspaces */
export type JiraConfigStateConnection = {
    __typename?: "JiraConfigStateConnection";
    /** Edges for JiraConfigState */
    edges?: Maybe<Array<JiraConfigStateEdge>>;
    /** Nodes for JiraConfigState */
    nodes?: Maybe<Array<JiraConfigState>>;
    /** PageInfo for JiraConfigState */
    pageInfo: PageInfo;
};

/** Connection edge representing config state for one jira app workspace */
export type JiraConfigStateEdge = {
    __typename?: "JiraConfigStateEdge";
    /** Edge cursor */
    cursor: Scalars["String"]["output"];
    /** JiraConfigState node */
    node?: Maybe<JiraConfigState>;
};

/** Enum representing Provider Type of App for Config State Service */
export enum JiraConfigStateProviderType {
    /** Represents a provider type of an app which providers build service */
    Builds = "BUILDS",
    /** Represents a provider type of an app which providers deployments service */
    Deployments = "DEPLOYMENTS",
    /** Represents a provider type of an app which providers designs service */
    Designs = "DESIGNS",
    /** Represents a provider type of an app which providers dev Info service */
    DevelopmentInfo = "DEVELOPMENT_INFO",
    /** Represents a provider type of an app which providers feature flag service */
    FeatureFlags = "FEATURE_FLAGS",
    /** Represents a provider type of an app which providers remote links service */
    RemoteLinks = "REMOTE_LINKS",
    /** Represents a provider type of an app which providers security service */
    Security = "SECURITY",
    /** Represents a provider type of an app which does not fit in above categories */
    Unknown = "UNKNOWN"
}

/** Each individual nav item that is configurable by the user. */
export type JiraConfigurableNavigationItem = {
    __typename?: "JiraConfigurableNavigationItem";
    /** The visibility of the navigation item. */
    isVisible: Scalars["Boolean"]["output"];
    /** The menuID for the navigation item. */
    menuId: Scalars["String"]["output"];
};

/** Each individual nav item that is configurable by the user. */
export type JiraConfigurableNavigationItemInput = {
    /** The visibility of the navigation item. */
    isVisible: Scalars["Boolean"]["input"];
    /** The menuID for the navigation item. */
    menuId: Scalars["String"]["input"];
};

export type JiraConfluenceRemoteIssueLink = {
    __typename?: "JiraConfluenceRemoteIssueLink";
    /** The URL of the item. */
    href?: Maybe<Scalars["String"]["output"]>;
    /** The Remote Link ARI. */
    id: Scalars["ID"]["output"];
    /** Description of the relationship between the issue and the linked item. */
    relationship?: Maybe<Scalars["String"]["output"]>;
    /** The title of the item. */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraConfluenceRemoteIssueLink */
export type JiraConfluenceRemoteIssueLinkConnection = {
    __typename?: "JiraConfluenceRemoteIssueLinkConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraConfluenceRemoteIssueLinkEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraConfluenceRemoteIssueLink connection. */
export type JiraConfluenceRemoteIssueLinkEdge = {
    __typename?: "JiraConfluenceRemoteIssueLinkEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraConfluenceRemoteIssueLink>;
};

/**
 * Represents a virtual field that contains a set of links to confluence pages
 * Virtual fields are only returned from fieldSetsById and fieldSetsForIssueSearchView on the JiraIssue
 */
export type JiraConfluenceRemoteIssueLinksField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConfluenceRemoteIssueLinksField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * A list of confluence pages linked to this issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraConfluenceRemoteIssueLinksField")' query directive to the 'confluenceRemoteIssueLinks' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        confluenceRemoteIssueLinks?: Maybe<JiraConfluenceRemoteIssueLinkConnection>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

/**
 * Represents a virtual field that contains a set of links to confluence pages
 * Virtual fields are only returned from fieldSetsById and fieldSetsForIssueSearchView on the JiraIssue
 */
export type JiraConfluenceRemoteIssueLinksFieldConfluenceRemoteIssueLinksArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
    };

/** Represents a datetime field created by Connect App. Note that a connect field's type dynamic. Consumers can use the schema type to determine this is a connect field */
export type JiraConnectDateTimeField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectDateTimeField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Content of the connect read only date time field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        dateTime?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectField = JiraHasMultipleSelectedValues &
    JiraHasSelectableValueOptions &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectMultipleSelectField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOptions?: Maybe<JiraOptionConnection>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Paginated list of JiraConnectMultipleSelectField options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /**
         * The options selected on the Issue or default options configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use selectedOptions instead.
         */
        selectedFieldOptions?: Maybe<Array<Maybe<JiraOption>>>;
        /**
         * The options selected on the Issue or default options configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedOptions?: Maybe<JiraOptionConnection>;
        /**
         * The JiraConnectMultipleSelectField selected options on the Issue or default option configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedValues?: Maybe<JiraSelectableValueConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectFieldFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectFieldSelectedOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a multi-select field created by Connect App. */
export type JiraConnectMultipleSelectFieldSelectedValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a number field created by Connect App. */
export type JiraConnectNumberField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectNumberField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Connected number.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        number?: Maybe<Scalars["Float"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/**
 * Deprecated. Use JiraConnectTextField | JiraConnectNumberField | JiraConnectDateTimeField + isEditable instead
 * Represents a read only field created by Connect App.
 */
export type JiraConnectReadOnlyField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectReadOnlyField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Content of the connect read only field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        text?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents rich text field on a Jira Issue. E.g. description, environment. */
export type JiraConnectRichTextField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectRichTextField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Contains the information needed to add a media content to this field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mediaContext?: Maybe<JiraMediaContext>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Determines what editor to render.
         * E.g. default text rendering or wiki text rendering.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * The rich text selected on the Issue or default rich text configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        richText?: Maybe<JiraRichText>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a single select field created by Connect App. */
export type JiraConnectSingleSelectField = JiraHasSelectableValueOptions &
    JiraHasSingleSelectedValue &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectSingleSelectField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * The option selected on the Issue or default option configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOption?: Maybe<JiraOption>;
        /**
         * Paginated list of options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOptions?: Maybe<JiraOptionConnection>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Paginated list of JiraConnectSingleSelectField options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /**
         * The JiraConnectSingleSelectField selected option on the Issue or default option configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedValue?: Maybe<JiraSelectableValue>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a single select field created by Connect App. */
export type JiraConnectSingleSelectFieldFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a single select field created by Connect App. */
export type JiraConnectSingleSelectFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a text field created by Connect App. */
export type JiraConnectTextField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraConnectTextField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Content of the connect text field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        text?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Information presented to end-users to contact their organisation admins to enable Atlassian Intelligence. */
export type JiraContactOrgAdminToEnableAtlassianIntelligence = {
    __typename?: "JiraContactOrgAdminToEnableAtlassianIntelligence";
    /** State of the modal for contacting a user's org admin to enable Atlassian Intelligence. */
    contactOrgAdminState?: Maybe<JiraContactOrgAdminToEnableAtlassianIntelligenceState>;
};

/** State of the modal for contacting the org admin to enable Atlassian Intelligence. */
export enum JiraContactOrgAdminToEnableAtlassianIntelligenceState {
    /** The modal is available to be shown. */
    Available = "AVAILABLE",
    /** The modal is not available to be shown. */
    Unavailable = "UNAVAILABLE"
}

/** Represents the details of a navigation for a specific container. */
export type JiraContainerNavigation = Node & {
    __typename?: "JiraContainerNavigation";
    /** Returns a connection of navigation item types that can be added to this navigation. */
    addableNavigationItemTypes?: Maybe<JiraNavigationItemTypeConnection>;
    /**
     * Indicate if the current user is allowed to make changes to this navigation.
     * (i.e. add, remove, set as default and rank items)
     */
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    /** Global opaque ID uniquely identifying this navigation. */
    id: Scalars["ID"]["output"];
    /** Returns a navigation item by its item id */
    navigationItemByItemId?: Maybe<JiraNavigationItemResult>;
    /** Returns a connection of navigation items visible in this navigation. */
    navigationItems?: Maybe<JiraNavigationItemConnection>;
    /** ARI of the scope identifying the container this navigation is scoped to. */
    scopeId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Relative url of the scope. For example:
     * - project: `/jira/core/projects/PROJ`, `/jira/software/projects/PROJ`
     * - project board: `/jira/software/projects/PROJ`
     * - user board: `/jira/people/12324`
     * - plan: `/jira/plans/1`
     */
    scopeUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the details of a navigation for a specific container. */
export type JiraContainerNavigationAddableNavigationItemTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the details of a navigation for a specific container. */
export type JiraContainerNavigationNavigationItemByItemIdArgs = {
    itemId: Scalars["String"]["input"];
};

/** Represents the details of a navigation for a specific container. */
export type JiraContainerNavigationNavigationItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input to query the navigation of a container scoped to a project by its key. */
export type JiraContainerNavigationByProjectKeyQueryInput = {
    /** The identifier which indicates the cloud instance this data is to be fetched for, required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** Key of the project to retrieve the navigation for. */
    projectKey: Scalars["String"]["input"];
};

/**
 * Input to retrieve the navigation details of a container. As per the `@oneOf` directive, Only one of the fields
 * `byScopeId` or `byProjectKey` must be provided.
 */
export type JiraContainerNavigationQueryInput = {
    /**
     * Input to retrieve the navigation for a project by key. Clients can use this when they don't have access to
     * the project ID or the default Board ID.
     */
    projectKeyQuery?: InputMaybe<JiraContainerNavigationByProjectKeyQueryInput>;
    /** ARI of the container scope to retrieve the navigation for. Supports project ARI and Board ARI. */
    scopeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraContainerNavigationResult =
    | JiraContainerNavigation
    | QueryError;

export type JiraCreateActivityConfigurationInput = {
    /** Field value mapping. It contains list of object which is like a map entry including a string key and array of string value */
    fieldValues?: InputMaybe<
        Array<InputMaybe<JiraActivityFieldValueKeyValuePairInput>>
    >;
    /** Id of the activity configuration */
    id: Scalars["ID"]["input"];
    /** Name of the activity */
    issueTypeId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Name of the activity */
    name: Scalars["String"]["input"];
    /** Name of the activity */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Name of the activity */
    requestTypeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * Input for creating a navigation item of type `JiraNavigationItemTypeKey.APP`. The related app is identified by
 * the `appId` input field.
 */
export type JiraCreateAppNavigationItemInput = {
    /**
     * The app id for the app to add. Supported ARIs:
     * - [Forge app ARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Aecosystem%3Aapp)
     * - [Connect app ARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Aecosystem%3Aconnect-app)
     */
    appId: Scalars["ID"]["input"];
    /** ARI of the scope to add the navigation item for. */
    scopeId: Scalars["ID"]["input"];
};

/** The field name of the new approver list field and its associated project and issue type */
export type JiraCreateApproverListFieldInput = {
    fieldName: Scalars["String"]["input"];
    issueTypeId?: InputMaybe<Scalars["Int"]["input"]>;
    projectId: Scalars["Int"]["input"];
};

export type JiraCreateApproverListFieldPayload = Payload & {
    __typename?: "JiraCreateApproverListFieldPayload";
    /** A list of errors which encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** The custom field Id of the newly created field */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /**
     * True if the mutation was successfully applied. False if the mutation was either partially successful or if the
     * mutation failed completely.
     */
    success: Scalars["Boolean"]["output"];
};

/** The input for creating an attachment background */
export type JiraCreateAttachmentBackgroundInput = {
    /** The entityId (ARI) of the entity to be updated */
    entityId: Scalars["ID"]["input"];
    /** The Media API File ID of the background */
    mediaApiFileId: Scalars["String"]["input"];
};

/** The response for the JiraCreateAttachmentBackground mutation */
export type JiraCreateAttachmentBackgroundPayload = Payload & {
    __typename?: "JiraCreateAttachmentBackgroundPayload";
    /** Background updated by the mutation */
    background?: Maybe<JiraBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraCreateBoardFieldInput = {
    /** Issue types to be included in the new board */
    issueTypes?: InputMaybe<Array<JiraIssueTypeInput>>;
    /** Labels to be included in the new board */
    labels?: InputMaybe<Array<JiraLabelsInput>>;
    /** Projects to be included in the new board */
    projects: Array<JiraProjectInput>;
    /** Teams to be included in the new board */
    teams?: InputMaybe<Array<JiraAtlassianTeamInput>>;
};

export type JiraCreateBoardInput = {
    /** Source from which the board to be created - either projectIds or savedFilterId */
    createBoardSource: JiraCreateBoardSource;
    /** Location of the board */
    location: JiraBoardLocation;
    /** Name of board to create */
    name: Scalars["String"]["input"];
    /** Preset of the board */
    preset: JiraBoardType;
};

/** Payload returned when creating a board */
export type JiraCreateBoardPayload = Payload & {
    __typename?: "JiraCreateBoardPayload";
    /** The new jira board created. Null if mutation was not successful. */
    board?: Maybe<JiraBoard>;
    /** List of errors while performing the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraCreateBoardSource = {
    /** Fields with values that can be used to create a filter for the board. */
    fieldInput?: InputMaybe<JiraCreateBoardFieldInput>;
    /** Saved filter id that can be used to create the board. */
    savedFilterId?: InputMaybe<Scalars["Long"]["input"]>;
};

/** Response for createCalendarIssue mutation. */
export type JiraCreateCalendarIssuePayload = Payload & {
    __typename?: "JiraCreateCalendarIssuePayload";
    /** A list of errors that occurred during the creation. */
    errors?: Maybe<Array<MutationError>>;
    /** The created issue */
    issue?: Maybe<JiraIssue>;
    /** Whether the creation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input for creating a Jira Custom Background */
export type JiraCreateCustomBackgroundInput = {
    /** The alt text associated with the custom background */
    altText: Scalars["String"]["input"];
    /** The entityId (ARI) of the entity to be updated with the created background */
    entityId: Scalars["ID"]["input"];
    /** The created mediaApiFileId of the background to create */
    mediaApiFileId: Scalars["String"]["input"];
};

/** The response for the jwmCreateCustomBackground mutation */
export type JiraCreateCustomBackgroundPayload = Payload & {
    __typename?: "JiraCreateCustomBackgroundPayload";
    /** Custom background created by the mutation */
    background?: Maybe<JiraMediaBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraCreateCustomFieldInput = {
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId: Scalars["ID"]["input"];
    /** The description of the field. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the field. */
    name: Scalars["String"]["input"];
    /** The field options. */
    options?: InputMaybe<Array<JiraCustomFieldOptionInput>>;
    /** Unique identifier of the project. */
    projectId: Scalars["String"]["input"];
    /** The type of the field. */
    type: Scalars["String"]["input"];
};

export type JiraCreateCustomFieldPayload = Payload & {
    __typename?: "JiraCreateCustomFieldPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** This is to fetch the field association based on the given field */
    fieldAssociationWithIssueTypes?: Maybe<JiraFieldAssociationWithIssueTypes>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input for creating a JiraCustomFilter. */
export type JiraCreateCustomFilterInput = {
    /** A string containing filter description */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The list of edit grants for the filter. Edit Grants represent different ways that users have been granted access to edit the filter.
     * Empty array represents private edit grant.
     */
    editGrants: Array<InputMaybe<JiraShareableEntityEditGrantInput>>;
    /** If present, column configuration will be copied from Filter represented by this filterId to the newly created filter */
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    /** Determines whether the filter is currently starred by the user viewing the filter */
    isFavourite: Scalars["Boolean"]["input"];
    /** JQL associated with the filter */
    jql: Scalars["String"]["input"];
    /** A string representing the name of the filter */
    name: Scalars["String"]["input"];
    /** A string representing namespace of the issue search view */
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The list of share grants for the filter. Share Grants represent different ways that users have been granted access to the filter.
     * Empty array represents private and null represents default share grant.
     */
    shareGrants: Array<InputMaybe<JiraShareableEntityShareGrantInput>>;
};

/** The payload returned after creating a JiraCustomFilter. */
export type JiraCreateCustomFilterPayload = Payload & {
    __typename?: "JiraCreateCustomFilterPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** JiraFilter created or updated by the mutation */
    filter?: Maybe<JiraCustomFilter>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraCreateEmptyActivityConfigurationInput = {
    /** Id of the journey configuration */
    journeyId: Scalars["ID"]["input"];
    /** The version number of the journey configuration. */
    journeyVersion: Scalars["Long"]["input"];
    /** Name of the activity */
    name: Scalars["String"]["input"];
};

/** Input for creating a formatting rule. */
export type JiraCreateFormattingRuleInput = {
    /**
     * The id based cursor of a rule where the new rule should be created after.
     * If not specified, the new rule will be created on top of the rule list.
     */
    afterRuleId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Color to be applied if condition matches.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use formattingColor instead
     */
    color?: InputMaybe<JiraFormattingColor>;
    /** Content of this rule. */
    expression: JiraFormattingRuleExpressionInput;
    /** Formatting area of this rule (row or cell). */
    formattingArea: JiraFormattingArea;
    /** Color to be applied if condition matches. */
    formattingColor?: InputMaybe<JiraColorInput>;
    /** Id of the project to create a formatting rule for. Must provide either project key or id. */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Key of the project to create a formatting rule for. Must provide either project key or id. */
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response for the create formatting rule mutation. */
export type JiraCreateFormattingRulePayload = Payload & {
    __typename?: "JiraCreateFormattingRulePayload";
    /** The newly created rule. Null if creation fails. */
    createdRule?: Maybe<JiraFormattingRule>;
    /** List of errors while performing the create formatting rule mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the create formatting rule mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraCreateJourneyConfigurationInput = {
    /** List of new activity configuration */
    createActivityConfigurations?: InputMaybe<
        Array<InputMaybe<JiraCreateActivityConfigurationInput>>
    >;
    /** Name of the journey */
    name: Scalars["String"]["input"];
    /** Parent issue of the journey configuration */
    parentIssue: JiraJourneyParentIssueInput;
    /** The trigger of this journey */
    trigger: JiraJourneyTriggerInput;
};

export type JiraCreateJourneyConfigurationPayload = Payload & {
    __typename?: "JiraCreateJourneyConfigurationPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The created/updated journey configuration */
    jiraJourneyConfigurationEdge?: Maybe<JiraJourneyConfigurationEdge>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraCreateJourneyItemInput = {
    /** Journey item configuration */
    configuration?: InputMaybe<JiraJourneyItemConfigurationInput>;
    /** Id of the journey item which this item should be inserted after, null indicates insert at the front */
    insertAfterItemId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Id of the journey configuration */
    journeyId: Scalars["ID"]["input"];
    /** The version number of the journey configuration. */
    journeyVersion: Scalars["Long"]["input"];
};

/** Payload returned when creating a navigation item. */
export type JiraCreateNavigationItemPayload = Payload & {
    __typename?: "JiraCreateNavigationItemPayload";
    /** List of errors while performing the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The navigation item added to the scope. Null if mutation was not successful. */
    navigationItem?: Maybe<JiraNavigationItem>;
    /** Denotes whether the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** The payload type for creating project cleanup recommendations */
export type JiraCreateProjectCleanupRecommendationsPayload = Payload & {
    __typename?: "JiraCreateProjectCleanupRecommendationsPayload";
    /** A list of errors which encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** The number of created recommendations */
    recommendationsCreated?: Maybe<Scalars["Long"]["output"]>;
    /**
     * True if the mutation was successfully applied. False if the mutation was either partially successful or if the
     * mutation failed completely.
     */
    success: Scalars["Boolean"]["output"];
};

/** The input for creating the release notes in Confluence for the given version */
export type JiraCreateReleaseNoteConfluencePageInput = {
    /** The app link id that will correspond to the target confluence instance */
    appLinkId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Exclude the issue key from the generated report */
    excludeIssueKey?: InputMaybe<Scalars["Boolean"]["input"]>;
    /**
     * The ARIs of issue fields(issue-field-meta ARI) to include when generating the release note
     *
     * Note: An empty array indicates no issue properties should be included in the release notes generation. Only summary will be included as the summary is included by default.
     */
    issueFieldIds: Array<Scalars["ID"]["input"]>;
    /**
     * The ARIs of issue types(issue-type ARI) to include when generating release notes
     *
     * Note: An empty array indicates all the issue types should be included in the release notes generation
     */
    issueTypeIds: Array<Scalars["ID"]["input"]>;
    /** The ARI of the confluence page under which the release note will be created */
    parentPageId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The Confluence space ARI under which the release note will be created */
    spaceId: Scalars["ID"]["input"];
    /** The ARI of the version to create a release note in Confluence */
    versionId: Scalars["ID"]["input"];
};

/** The return payload of updating the release notes configuration options for a version */
export type JiraCreateReleaseNoteConfluencePagePayload = Payload & {
    __typename?: "JiraCreateReleaseNoteConfluencePagePayload";
    /**
     * A Boolean flag that indicates the success status of adding the the new confluence page
     * to related work section of the version.
     */
    addToRelatedWorkSuccess?: Maybe<Scalars["Boolean"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Thew Related Work edge, associated to the Release Notes page */
    relatedWorkV2Edge?: Maybe<JiraVersionRelatedWorkV2Edge>;
    /** The URL to edit the release note Confluence page that has just been created */
    releaseNotePageEditUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The subType of the release note Confluence page that has just been created. Value will be "live" for live pages, and null otherwise. */
    releaseNotePageSubType?: Maybe<Scalars["String"]["output"]>;
    /** The URL to view the release note Confluence page that has just been created */
    releaseNotePageViewUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The jira version with the related work node that contains the created release note confluence */
    version?: Maybe<JiraVersion>;
};

export type JiraCreateShortcutInput = {
    /** ARI of the project the shortcut is being added to. */
    projectId: Scalars["ID"]["input"];
    /** Data of shortcut being added */
    shortcutData: JiraShortcutDataInput;
    /** The type of the shortcut to be added. */
    type: JiraProjectShortcutType;
};

/** Input for creating a simple navigation item which doesn't require any additional data other than its `typeKey`. */
export type JiraCreateSimpleNavigationItemInput = {
    /** ARI of the scope to add the navigation item for. */
    scopeId: Scalars["ID"]["input"];
    /** The key of the type of navigation item to add. */
    typeKey: JiraNavigationItemTypeKey;
};

export type JiraCrossProjectVersion = Node & {
    __typename?: "JiraCrossProjectVersion";
    /** Scenario values that override base values when in the Plan scenario */
    crossProjectVersionScenarioValues?: Maybe<JiraCrossProjectVersionPlanScenarioValues>;
    /** The Atlassian Resource Identifier for Jira cross project version. */
    id: Scalars["ID"]["output"];
    /** The name of cross project version */
    name: Scalars["String"]["output"];
    /** Indicates if the release is overdue */
    overdue?: Maybe<Scalars["Boolean"]["output"]>;
    /** A collection of its mapped projects */
    projects?: Maybe<Array<Maybe<JiraProject>>>;
    /** The date at which the version was released to customers. Must occur after startDate. */
    releaseDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The date at which work on the version began. */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The status of the Versions to filter to. */
    status: JiraVersionStatus;
    /** The assiociated cross project version ID */
    versionId: Scalars["ID"]["output"];
};

/** The connection type for JiraCrossProjectVersion. */
export type JiraCrossProjectVersionConnection = {
    __typename?: "JiraCrossProjectVersionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraCrossProjectVersionEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraCrossProjectVersionEdge = {
    __typename?: "JiraCrossProjectVersionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraCrossProjectVersion>;
};

export type JiraCrossProjectVersionPlanScenarioValues = {
    __typename?: "JiraCrossProjectVersionPlanScenarioValues";
    /** Cross Project Version name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The type of the scenario, a cross project version may be added, updated or deleted. */
    scenarioType?: Maybe<JiraScenarioType>;
};

/** The type for a Jira Custom Background, which is associated with a Media API file */
export type JiraCustomBackground = {
    __typename?: "JiraCustomBackground";
    /** Number of entities for which this background is currently active */
    activeCount?: Maybe<Scalars["Long"]["output"]>;
    /** The alt text associated with the custom background */
    altText?: Maybe<Scalars["String"]["output"]>;
    /** The id of the custom background */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The mediaApiFileId of the custom background */
    mediaApiFileId?: Maybe<Scalars["String"]["output"]>;
    /** Contains the information needed for reading uploaded media content in jira. */
    mediaReadToken?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier of the image in the external source, if applicable */
    sourceIdentifier?: Maybe<Scalars["String"]["output"]>;
    /** The external source of the image, if applicable. ex. Unsplash */
    sourceType?: Maybe<Scalars["String"]["output"]>;
};

/** The type for a Jira Custom Background, which is associated with a Media API file */
export type JiraCustomBackgroundMediaReadTokenArgs = {
    durationInSeconds: Scalars["Int"]["input"];
};

/** The connection type for Jira Custom Background. */
export type JiraCustomBackgroundConnection = {
    __typename?: "JiraCustomBackgroundConnection";
    /** A list of nodes in the current page. */
    edges?: Maybe<Array<Maybe<JiraCustomBackgroundEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The edge type for Jira Custom Background. */
export type JiraCustomBackgroundEdge = {
    __typename?: "JiraCustomBackgroundEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraCustomBackground>;
};

export type JiraCustomFieldOptionInput = {
    /**
     * The identifier of the option set externally.
     * Set this field when creating a new parent option that has child (cascaded) options during create or edit Field operation.
     */
    externalUuid?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The identifier of the option that exists in the system.
     * Do not set this field when creating the option.
     */
    optionId?: InputMaybe<Scalars["Long"]["input"]>;
    /**
     * The external identifier of the parent of this option.
     * Set this only on child (cascaded) options when creating a new parent option during create or edit Field operation.
     */
    parentExternalUuid?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The identifier of the parent option that exists in the system.
     * Do not set this field if this option does not have a parent option or if the parent option has not been created yet.
     * Set this field only on child (cascaded) options during edit.
     */
    parentOptionId?: InputMaybe<Scalars["Long"]["input"]>;
    /** The value of the field option. */
    value: Scalars["String"]["input"];
};

/** Represents a user generated custom filter. */
export type JiraCustomFilter = JiraFilter &
    Node & {
        __typename?: "JiraCustomFilter";
        /**
         * A string containing filter description.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Retrieves a connection of edit grants for the filter. Edit grants represent collections of users who can edit the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        editGrants?: Maybe<JiraShareableEntityEditGrantConnection>;
        /**
         * Retrieves a connection of email subscriptions for the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        emailSubscriptions?: Maybe<JiraFilterEmailSubscriptionConnection>;
        /**
         * A tenant local filterId. This value is used for interoperability with REST APIs (eg vendors).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterId: Scalars["String"]["output"];
        /**
         * The URL string associated with a specific user filter in Jira.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * An ARI value in the format `ari:cloud:jira:{siteId}:filter/activation/{activationId}/{filterId}`that encodes the filterId.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Determines whether the user has permissions to edit the filter
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditable?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Determines whether the filter is currently starred by the user viewing the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * JQL associated with the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        jql: Scalars["String"]["output"];
        /**
         * The timestamp of this filter was last viewed by the current user (reference to Unix Epoch time in ms).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
        /**
         * A string representing the filter name.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The user that owns the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        owner?: Maybe<User>;
        /**
         * Retrieves a connection of share grants for the filter. Share grants represent collections of users who can access the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        shareGrants?: Maybe<JiraShareableEntityShareGrantConnection>;
    };

/** Represents a user generated custom filter. */
export type JiraCustomFilterEditGrantsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a user generated custom filter. */
export type JiraCustomFilterEmailSubscriptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a user generated custom filter. */
export type JiraCustomFilterShareGrantsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The representation of an error from a custom search implementation */
export type JiraCustomIssueSearchError = {
    __typename?: "JiraCustomIssueSearchError";
    /** The error type of this particular syntax error. */
    errorType?: Maybe<JiraCustomIssueSearchErrorType>;
    /** A list of error messages. */
    messages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

/** The type of error returned from a custom search implementation */
export enum JiraCustomIssueSearchErrorType {
    /** A specific, internal error was generated by the custom search implementation */
    CustomImplementationError = "CUSTOM_IMPLEMENTATION_ERROR",
    /** The requested custom search implementation is not enabled for this request */
    CustomSearchDisabled = "CUSTOM_SEARCH_DISABLED",
    /** An ARI used as input to a custom search implementation was invalid */
    InvalidAri = "INVALID_ARI",
    /** An ARI used as input to a custom search implementation is not supported by the implementation */
    UnsupportedAri = "UNSUPPORTED_ARI"
}

export type JiraCustomRemoteIssueLink = {
    __typename?: "JiraCustomRemoteIssueLink";
    /** Name of the JiraIssueRemoteLink application. */
    applicationName?: Maybe<Scalars["String"]["output"]>;
    /** Type of the JiraIssueRemoteLink application. */
    applicationType?: Maybe<Scalars["String"]["output"]>;
    /** The global ID of the link, such as the ID of the item on the remote system. */
    globalId?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the item. */
    href?: Maybe<Scalars["String"]["output"]>;
    /**
     * The icon tooltip suffix used in conjunction with the application name to display a tooltip for the link's icon. The tooltip takes the format
     * "[application name] icon title". Blank items are excluded from the tooltip title. If both items are blank, the icon tooltip displays as "Web Link".
     */
    iconTooltipSuffix?: Maybe<Scalars["String"]["output"]>;
    /** The URL of an icon. */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The Remote Link ARI. */
    id: Scalars["ID"]["output"];
    /** Description of the relationship between the issue and the linked item. */
    relationship?: Maybe<Scalars["String"]["output"]>;
    /** Whether the item is resolved. If set to "true", the link to the issue is displayed in a strikethrough font, otherwise the link displays in normal font. */
    resolved?: Maybe<Scalars["Boolean"]["output"]>;
    /** The status icon tooltip text. */
    statusIconTooltip?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the status icon tooltip link. */
    statusIconTooltipLink?: Maybe<Scalars["String"]["output"]>;
    /** The URL of the status icon. */
    statusIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The summary details of the item. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The title of the item. */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type JiraCustomerOrganizationsBulkFetchInput = {
    /** The UUIDs of the customer organizations to fetch. */
    customerOrganizationUUIDs: Array<Scalars["String"]["input"]>;
};

/** Represents the Customer Organization field on an Issue in a JCS project. This differs from JiraServiceManagementOrganizationField in that it only stores one value */
export type JiraCustomerServiceOrganizationField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraCustomerServiceOrganizationField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to query for all Customer orgs when user interact with field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** The organization selected on the Issue */
        selectedOrganization?: Maybe<JiraServiceManagementOrganization>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** The payload type returned after updating the Organization field of a Jira issue. */
export type JiraCustomerServiceOrganizationFieldPayload = Payload & {
    __typename?: "JiraCustomerServiceOrganizationFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Entitlement field. */
    field?: Maybe<JiraCustomerServiceOrganizationField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input type for updating the Organization field of the Jira issue. */
export type JiraCustomerServiceUpdateOrganizationFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Organization field. */
    operation?: InputMaybe<JiraCustomerServiceUpdateOrganizationOperationInput>;
};

/** Input type for defining the operation on the Organization field of a Jira issue. */
export type JiraCustomerServiceUpdateOrganizationOperationInput = {
    /** Only SET operation is supported. */
    operation: JiraSingleValueFieldOperations;
    /** ARI of the selected organization. */
    organizationId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Represents a Jira dashboard */
export type JiraDashboard = Node & {
    __typename?: "JiraDashboard";
    /** The dashboard id of the dashboard. e.g. 10000. Temporarily needed to support interoperability with REST. */
    dashboardId?: Maybe<Scalars["Long"]["output"]>;
    /** The URL string associated with a user's dashboard in Jira. */
    dashboardUrl?: Maybe<Scalars["URL"]["output"]>;
    /** A favourite value which contains the boolean of if it is favourited and a unique ID */
    favouriteValue?: Maybe<JiraFavouriteValue>;
    /** Global identifier for the dashboard */
    id: Scalars["ID"]["output"];
    /** The timestamp of this dashboard was last viewed by the current user (reference to Unix Epoch time in ms). */
    lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
    /** The title of the dashboard */
    title?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Represents aggregated DataClassification for an issue. Data Classification for Jira provides Jira users and admins with
 * the capability to assign pre-existing classification tags to all Content levels.
 */
export type JiraDataClassification = {
    __typename?: "JiraDataClassification";
    /** The data classification color. */
    color?: Maybe<JiraColor>;
    /** The guideline provided for data classification. */
    guideline?: Maybe<Scalars["String"]["output"]>;
    /** Unique identifier referencing the data classification ID. */
    id: Scalars["ID"]["output"];
    /** The data classification display name. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a data classification field on a Jira Issue. */
export type JiraDataClassificationField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraDataClassificationField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The issue classification.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use classificationLevel instead.
         */
        classification?: Maybe<JiraDataClassification>;
        /** The issue classification level. */
        classificationLevel?: Maybe<JiraClassificationLevel>;
        /** The source of classification level. Currently, it can be either ISSUE level or PROJECT level. */
        classificationLevelSource?: Maybe<JiraClassificationLevelSource>;
        /**
         * Paginated list of classification levels available.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraDataClassificationFieldOptions")' query directive to the 'classificationLevels' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        classificationLevels?: Maybe<JiraClassificationLevelConnection>;
        /** The default classification level, i.e. classification level assigned at project level. */
        defaultClassificationLevel?: Maybe<JiraClassificationLevel>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a data classification field on a Jira Issue. */
export type JiraDataClassificationFieldClassificationLevelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterByCriteria?: InputMaybe<JiraClassificationLevelFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JiraDataClassificationFieldOperationInput = {
    /** The new classification level to set. */
    classificationLevel?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The operation to perform on the Data Classification field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
};

export type JiraDataClassificationFieldPayload = Payload & {
    __typename?: "JiraDataClassificationFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Data Classification field. */
    field?: Maybe<JiraDataClassificationField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraDateFieldAssociationMessageMutationPayload = Payload & {
    __typename?: "JiraDateFieldAssociationMessageMutationPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input type for date field */
export type JiraDateFieldInput = {
    /** A date input on which the action will be performed */
    date: JiraDateInput;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

export type JiraDateFieldOperationInput = {
    date?: InputMaybe<Scalars["Date"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraDateFieldPayload = Payload & {
    __typename?: "JiraDateFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraDatePickerField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type for date */
export type JiraDateInput = {
    /** Formatted date string value in format DD/MMM/YY */
    formattedDate: Scalars["String"]["input"];
};

/** Represents a date picker field on an issue. E.g. due date, custom date picker, baseline start, baseline end. */
export type JiraDatePickerField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraDatePickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** The date selected on the Issue or default date configured for the field. */
        date?: Maybe<Scalars["Date"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Type for the date scenario value field */
export type JiraDateScenarioValueField = {
    __typename?: "JiraDateScenarioValueField";
    /** Date value */
    date?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Input type for date time field */
export type JiraDateTimeFieldInput = {
    dateTime: JiraDateTimeInput;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

export type JiraDateTimeFieldOperationInput = {
    datetime?: InputMaybe<Scalars["DateTime"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraDateTimeFieldPayload = Payload & {
    __typename?: "JiraDateTimeFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraDateTimePickerField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type for date time */
export type JiraDateTimeInput = {
    /** Formatted date time string value in format DD/MMM/YY hh:mm A */
    formattedDateTime: Scalars["String"]["input"];
};

/** Represents a date time picker field on a Jira Issue. E.g. created, resolution date, custom date time, request-feedback-date. */
export type JiraDateTimePickerField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraDateTimePickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** The datetime selected on the Issue or default datetime configured for the field. */
        dateTime?: Maybe<Scalars["DateTime"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

export type JiraDateTimeRange = {
    /** Specifies the start date (exclusive) for filtering attachments by upload date. */
    after?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Specifies the end date (exclusive) for filtering attachments by upload date. */
    before?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type JiraDateTimeWindow = {
    /** The end date time of the window. */
    end?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The start date time of the window. */
    start?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** Default implementation of JiraEmptyConnectionReason. */
export type JiraDefaultEmptyConnectionReason = JiraEmptyConnectionReason & {
    __typename?: "JiraDefaultEmptyConnectionReason";
    /**
     * Returns the reason why the connection is empty as an empty connection is not always an error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

/**
 * The default grant type with only id and name to return data for grant types such as PROJECT_LEAD, APPLICATION_ROLE,
 * ANY_LOGGEDIN_USER_APPLICATION_ROLE, ANONYMOUS_ACCESS, SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS
 */
export type JiraDefaultGrantTypeValue = Node & {
    __typename?: "JiraDefaultGrantTypeValue";
    /**
     * The ARI to represent the default grant type value.
     * For example:
     * PROJECT_LEAD ari - ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:role/project-lead/activation/bd0c43a9-a23a-4302-8ffa-ca04bde7c747/project/f67c73a8-545e-455b-a6bd-3d53cb7e0524
     * APPLICATION_ROLE ari for JSM - ari:cloud:jira-servicedesk::role/123
     * ANY_LOGGEDIN_USER_APPLICATION_ROLE ari - ari:cloud:jira::role/product/member
     * ANONYMOUS_ACCESS ari - ari:cloud:identity::user/unidentified
     */
    id: Scalars["ID"]["output"];
    /** The display name of the grant type value such as GROUP. */
    name: Scalars["String"]["output"];
};

/**
 * The input for searching an Unsplash Collection. Can only be used to retrieve photos from the "Unsplash Editorial".
 * Uses Unsplash's API definition for pagination https://unsplash.com/documentation#parameters-16
 */
export type JiraDefaultUnsplashImagesInput = {
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** The page number, defaults to 1 */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /** The page size, defaults to 10 */
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
    /** The requested width in pixels of the thumbnail image, default is 200px */
    width?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A page of images from the "Unsplash Editorial" collection */
export type JiraDefaultUnsplashImagesPage = {
    __typename?: "JiraDefaultUnsplashImagesPage";
    /** The list of images returned from the collection */
    results?: Maybe<Array<Maybe<JiraUnsplashImage>>>;
};

export type JiraDefaultUnsplashImagesPageResult =
    | JiraDefaultUnsplashImagesPage
    | QueryError;

export type JiraDeleteActivityConfigurationInput = {
    /** Id of the activity configuration */
    activityId: Scalars["ID"]["input"];
    /** Id of the journey configuration */
    journeyId: Scalars["ID"]["input"];
    /** The version number of the journey configuration. */
    journeyVersion: Scalars["Long"]["input"];
};

/** The input for deleting a custom background */
export type JiraDeleteCustomBackgroundInput = {
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** The customBackgroundId of the custom background to delete */
    customBackgroundId: Scalars["ID"]["input"];
};

/** The response for the jwmDeleteCustomBackground mutation */
export type JiraDeleteCustomBackgroundPayload = Payload & {
    __typename?: "JiraDeleteCustomBackgroundPayload";
    /** The customBackgroundId of the deleted custom background */
    customBackgroundId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraDeleteCustomFieldInput = {
    /**
     * The cloudId indicates the cloud instance this mutation will be executed against.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId: Scalars["ID"]["input"];
    fieldId: Scalars["String"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraDeleteCustomFieldPayload = Payload & {
    __typename?: "JiraDeleteCustomFieldPayload";
    affectedFieldAssociationWithIssueTypesId?: Maybe<Scalars["ID"]["output"]>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type JiraDeleteCustomFilterPayload = Payload & {
    __typename?: "JiraDeleteCustomFilterPayload";
    /** The ID of the deleted custom filter or null if the custom filter was not deleted. */
    deletedCustomFilterId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraDeleteFormattingRuleInput = {
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Deprecated, this field will be ignored.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Deprecated, this field will be ignored
     */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The rule to delete. */
    ruleId: Scalars["ID"]["input"];
};

/** Response for the delete formatting rule mutation. */
export type JiraDeleteFormattingRulePayload = Payload & {
    __typename?: "JiraDeleteFormattingRulePayload";
    /** ID of the deleted rule. */
    deletedRuleId: Scalars["ID"]["output"];
    /** List of errors while performing the delete formatting rule mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the delete formatting rule mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraDeleteIssueLinkPayload = Payload & {
    __typename?: "JiraDeleteIssueLinkPayload";
    /** The node IDs of the deleted issueLink or empty if the issueLink was not deleted. */
    deletedIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The node ID of the deleted issueLink or null if the issueLink was not deleted.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Instead use deletedIds
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The issueLink ID of the deleted issueLink or null if the issueLink was not deleted. */
    issueLinkId?: Maybe<Scalars["ID"]["output"]>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input for deleting a navigation item. */
export type JiraDeleteNavigationItemInput = {
    /** Global identifier (ARI) for the navigation item to delete. */
    id: Scalars["ID"]["input"];
};

/** Response for the delete jira navigation item mutation. */
export type JiraDeleteNavigationItemPayload = Payload & {
    __typename?: "JiraDeleteNavigationItemPayload";
    /** List of errors while performing the delete mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Global identifier (ARI) for the deleted navigation item. Null if the mutation was not successful. */
    navigationItem?: Maybe<Scalars["ID"]["output"]>;
    /** Denotes whether the delete mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** This is an input argument for deleting project notification preferences. */
export type JiraDeleteProjectNotificationPreferencesInput = {
    /** The ARI of the project for which the notification preferences are to be deleted. */
    projectId: Scalars["ID"]["input"];
};

/** The response for the mutation to delete the project notification preferences. */
export type JiraDeleteProjectNotificationPreferencesPayload = Payload & {
    __typename?: "JiraDeleteProjectNotificationPreferencesPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The default project preferences. These are not persisted.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Will be removed while API is in experimental phase for next iteration of project preferences
     */
    projectPreferences?: Maybe<JiraNotificationProjectPreferences>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraDeleteShortcutInput = {
    /** ARI of the project the shortcut is belongs to. */
    projectId: Scalars["ID"]["input"];
    /** ARI of the shortcut */
    shortcutId: Scalars["ID"]["input"];
};

/** The input to delete a version with no issues. */
export type JiraDeleteVersionWithNoIssuesInput = {
    /** The ID of the version to delete. */
    id: Scalars["ID"]["input"];
};

/** The details of a deployment app. */
export type JiraDeploymentApp = {
    __typename?: "JiraDeploymentApp";
    /** Key name of the deployment app */
    appKey: Scalars["String"]["output"];
};

/** The input contain details of a deployment app. */
export type JiraDeploymentAppInput = {
    /** Key name of the deployment app */
    appKey: Scalars["String"]["input"];
};

/** The precondition state of the deployments JSW feature for a particular project and user. */
export enum JiraDeploymentsFeaturePrecondition {
    /** The deployments feature is available as the project has satisfied all precondition checks. */
    AllSatisfied = "ALL_SATISFIED",
    /** The deployments feature is available and will show the empty-state page as no CI/CD provider is sending deployment data. */
    DeploymentsEmptyState = "DEPLOYMENTS_EMPTY_STATE",
    /** The deployments feature is not available as the precondition checks have not been satisfied. */
    NotAvailable = "NOT_AVAILABLE"
}

/** JiraIssueSearchViewType type that represents a Detailed view in NIN */
export type JiraDetailedView = JiraIssueSearchViewMetadata &
    JiraIssueSearchViewType &
    JiraView &
    Node & {
        __typename?: "JiraDetailedView";
        /**
         * Errors which were encountered while fetching the connection.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        error?: Maybe<QueryError>;
        /**
         * A connection of included fields' configurations, grouped where logical (e.g. collapsed fields).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
        /**
         * The tenant specific id of the filter that will be used to get the JiraIssueSearchView
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterId?: Maybe<Scalars["String"]["output"]>;
        /**
         * A nullable boolean indicating if the IssueSearchView is using default fieldSets
         * true -> Issue search view is using default fieldSets
         * false -> Issue search view has custom fieldSets
         * null -> Not applicable for requested issue search view
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * An ARI-format value that encodes both namespace and viewId.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * A nullable boolean indicating if the Issue Hierarchy is enabled
         * true -> Issue Hierarchy is enabled
         * false -> Issue Hierarchy is disabled
         * null -> If any error has occured in fetching the preference. The hierarchy will be disabled.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Retrieves a connection of JiraIssues for the current JiraIssueSearchInput.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issues?: Maybe<JiraIssueConnection>;
        /**
         * A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        namespace?: Maybe<Scalars["String"]["output"]>;
        /**
         * A unique identifier for this view within its namespace, or the global namespace if no namespace is defined.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        viewId?: Maybe<Scalars["String"]["output"]>;
    };

/** JiraIssueSearchViewType type that represents a Detailed view in NIN */
export type JiraDetailedViewFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** JiraIssueSearchViewType type that represents a Detailed view in NIN */
export type JiraDetailedViewIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    fieldSetsInput?: InputMaybe<JiraIssueSearchFieldSetsInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    options?: InputMaybe<JiraIssueSearchOptions>;
    saveJQLToUserHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
    scope?: InputMaybe<JiraIssueSearchScope>;
    viewConfigInput?: InputMaybe<JiraIssueSearchViewConfigInput>;
};

/** User actionable error details. */
export type JiraDevInfoConfigError = {
    __typename?: "JiraDevInfoConfigError";
    /** id of the data provider associated with this error */
    dataProviderId?: Maybe<Scalars["String"]["output"]>;
    /** Type of the error */
    errorType?: Maybe<JiraDevInfoConfigErrorType>;
};

/** The possible config error type with a provider that feed devinfo details. */
export enum JiraDevInfoConfigErrorType {
    Incapable = "INCAPABLE",
    NotConfigured = "NOT_CONFIGURED",
    Unauthorized = "UNAUTHORIZED",
    UnknownConfigError = "UNKNOWN_CONFIG_ERROR"
}

/** The input type for a devOps association */
export type JiraDevOpsAssociationInput = {
    /** The association type */
    associationType: Scalars["String"]["input"];
    /** List of associations */
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** The payload type for a devOps association */
export type JiraDevOpsAssociationPayload = {
    __typename?: "JiraDevOpsAssociationPayload";
    /** The entity Id the associations belong to */
    entityId: Scalars["String"]["output"];
    /** The list of associations */
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** Details of a created SCM branch associated with a Jira issue. */
export type JiraDevOpsBranchDetails = {
    __typename?: "JiraDevOpsBranchDetails";
    /** Entity URL link to branch in its original provider */
    entityUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Branch name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Value uniquely identify the scm branch scoped to its original provider, not ARI format */
    providerBranchId?: Maybe<Scalars["String"]["output"]>;
    /** The scm repository contains the branch. */
    scmRepository?: Maybe<JiraScmRepository>;
};

/** The types of capabilities a devOps provider can support */
export enum JiraDevOpsCapability {
    Branch = "BRANCH",
    Build = "BUILD",
    Commit = "COMMIT",
    Deployment = "DEPLOYMENT",
    FeatureFlag = "FEATURE_FLAG",
    PullRequest = "PULL_REQUEST",
    Review = "REVIEW"
}

/** Details of a SCM commit associated with a Jira issue. */
export type JiraDevOpsCommitDetails = {
    __typename?: "JiraDevOpsCommitDetails";
    /** Details of author who created the commit. */
    author?: Maybe<JiraDevOpsEntityAuthor>;
    /** The commit date in ISO 8601 format. */
    created?: Maybe<Scalars["DateTime"]["output"]>;
    /** Shorten value of the commit-hash, used for display. */
    displayCommitId?: Maybe<Scalars["String"]["output"]>;
    /** Entity URL link to commit in its original provider */
    entityUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Flag represents if the commit is a merge commit. */
    isMergeCommit?: Maybe<Scalars["Boolean"]["output"]>;
    /** The commit message. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Value uniquely identify the commit (commit-hash), not ARI format. */
    providerCommitId?: Maybe<Scalars["String"]["output"]>;
    /** The scm repository contains the commit. */
    scmRepository?: Maybe<JiraScmRepository>;
};

/** The input type for devOps entity associations */
export type JiraDevOpsEntityAssociationsInput = {
    /** The associations to add to the entity ID */
    addAssociations?: InputMaybe<Array<JiraDevOpsAssociationInput>>;
    /** The entity ID to update the associations on */
    entityId: Scalars["ID"]["input"];
    /** The associations to remove from the entity ID */
    removeAssociations?: InputMaybe<Array<JiraDevOpsAssociationInput>>;
};

/** Basic person information who created a SCM entity (Pull-request, Branches, or Commit) */
export type JiraDevOpsEntityAuthor = {
    __typename?: "JiraDevOpsEntityAuthor";
    /** The author's avatar. */
    avatar?: Maybe<JiraAvatar>;
    /** Author name. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export enum JiraDevOpsInContextConfigPromptLocation {
    DevelopmentPanel = "DEVELOPMENT_PANEL",
    ReleasesPanel = "RELEASES_PANEL",
    SecurityPanel = "SECURITY_PANEL"
}

/** Container for all DevOps data for an issue, to be displayed in the DevOps Panel of an issue */
export type JiraDevOpsIssuePanel = {
    __typename?: "JiraDevOpsIssuePanel";
    /** Specify a banner to show on top of the dev panel. `null` means that no banner should be displayed. */
    devOpsIssuePanelBanner?: Maybe<JiraDevOpsIssuePanelBannerType>;
    /** Container for the Dev Summary of this issue */
    devSummaryResult?: Maybe<JiraIssueDevSummaryResult>;
    /** Specify if tenant which hosts the project of this issue has installed SCM providers supporting Branch capabilities. */
    hasBranchCapabilities?: Maybe<Scalars["Boolean"]["output"]>;
    /** Specifies the state the DevOps panel in the issue view should be in */
    panelState?: Maybe<JiraDevOpsIssuePanelState>;
};

export enum JiraDevOpsIssuePanelBannerType {
    /** Banner that explains how to add issue keys in your commits, branches and PRs */
    IssueKeyOnboarding = "ISSUE_KEY_ONBOARDING"
}

/** The possible States the DevOps Issue Panel can be in */
export enum JiraDevOpsIssuePanelState {
    /** Panel should show the available Dev Summary */
    DevSummary = "DEV_SUMMARY",
    /** Panel should be hidden */
    Hidden = "HIDDEN",
    /** Panel should show the "not connected" state to prompt user to integrate tools */
    NotConnected = "NOT_CONNECTED"
}

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutation = {
    __typename?: "JiraDevOpsMutation";
    /** Adds an autodev planned change */
    addAutodevPlannedChange?: Maybe<JiraAutodevPlannedChangePayload>;
    /** Adds an Autodev task */
    addAutodevTask?: Maybe<JiraAutodevTaskPayload>;
    /**
     * Approve access request from BBC workspace(organization in Jira term) to JSW.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDevOpsApproveJiraBitbucketWorkspaceAccessRequest")' query directive to the 'approveJiraBitbucketWorkspaceAccessRequest' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    approveJiraBitbucketWorkspaceAccessRequest?: Maybe<JiraApproveJiraBitbucketWorkspaceAccessRequestPayload>;
    /** Creates autodev job */
    createAutodevJob?: Maybe<JiraAutodevCreateJobPayload>;
    /**
     * Creates the autodev pull request
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs")' query directive to the 'createAutodevPullRequest' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createAutodevPullRequest?: Maybe<JiraAutodevBasicPayload>;
    /**
     * Creates autofix job
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autofix-jobs")' query directive to the 'createAutofixJob' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createAutofixJob?: Maybe<JiraAutofixCreateJobPayload>;
    /** Deletes autodev job */
    deleteAutodevJob?: Maybe<JiraAutodevBasicPayload>;
    /** Deletes an autodev planned change */
    deleteAutodevPlannedChange?: Maybe<JiraAutodevDeletedPayload>;
    /** Deletes an autodev task */
    deleteAutodevTask?: Maybe<JiraAutodevDeletedPayload>;
    /** Remove a connection between BBC workspace(organization in Jira term) and JSW. */
    dismissBitbucketPendingAccessRequestBanner?: Maybe<JiraDismissBitbucketPendingAccessRequestBannerPayload>;
    /**
     * Lets a user dismiss a banner shown in the DevOps Issue Panel
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraDevOps` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    dismissDevOpsIssuePanelBanner?: Maybe<JiraDismissDevOpsIssuePanelBannerPayload>;
    /** Dismiss in-context prompt that helps customer to configure not configured apps in a dropdown */
    dismissInContextConfigPrompt?: Maybe<JiraDismissInContextConfigPromptPayload>;
    /** Modify code for autodev job based on a prompt */
    modifyAutodevCode?: Maybe<JiraAutodevBasicPayload>;
    /**
     * Lets a user opt-out of the "not-connected" state in the DevOps Issue Panel
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraDevOps` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    optoutOfDevOpsIssuePanelNotConnectedState?: Maybe<JiraOptoutDevOpsIssuePanelNotConnectedPayload>;
    /**
     * Pauses code generation for an autodev job generating code. Job will cancel and eventually return to pending
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs")' query directive to the 'pauseAutodevCodeGeneration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    pauseAutodevCodeGeneration?: Maybe<JiraAutodevBasicPayload>;
    /** Regenerate plan for autodev job */
    regenerateAutodevPlan?: Maybe<JiraAutodevBasicPayload>;
    /**
     * Remove a connection between BBC workspace(organization in Jira term) and JSW.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDevOpsRemoveJiraBitbucketWorkspaceConnection")' query directive to the 'removeJiraBitbucketWorkspaceConnection' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeJiraBitbucketWorkspaceConnection?: Maybe<JiraRemoveJiraBitbucketWorkspaceConnectionPayload>;
    /**
     * Resumes autodev job
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs")' query directive to the 'resumeAutodevJob' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    resumeAutodevJob?: Maybe<JiraAutodevBasicPayload>;
    /** Retries autodev job */
    retryAutodevJob?: Maybe<JiraAutodevBasicPayload>;
    /** Save plan for autodev job */
    saveAutodevPlan?: Maybe<JiraAutodevBasicPayload>;
    /**
     * Set deployment-apps in used for a JSW project.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDeploymentAppsEmptyState")' query directive to the 'setProjectSelectedDeploymentAppsProperty' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setProjectSelectedDeploymentAppsProperty?: Maybe<JiraSetProjectSelectedDeploymentAppsPropertyPayload>;
    /** Start autodev job for coding task */
    startAutodev?: Maybe<JiraAutodevBasicPayload>;
    /**
     * Stops autodev job
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs")' query directive to the 'stopAutodevJob' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    stopAutodevJob?: Maybe<JiraAutodevBasicPayload>;
    /** Updates associations for devOps entities */
    updateAssociations?: Maybe<JiraDevOpsUpdateAssociationsPayload>;
    /** Updates an autodev planned change */
    updateAutodevPlannedChange?: Maybe<JiraAutodevPlannedChangePayload>;
    /** Updates an autodev task */
    updateAutodevTask?: Maybe<JiraAutodevTaskPayload>;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationAddAutodevPlannedChangeArgs = {
    changeType: JiraAutodevCodeChangeEnumType;
    fileName: Scalars["String"]["input"];
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationAddAutodevTaskArgs = {
    fileId: Scalars["ID"]["input"];
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
    task: Scalars["String"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationApproveJiraBitbucketWorkspaceAccessRequestArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraApproveJiraBitbucketWorkspaceAccessRequestInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationCreateAutodevJobArgs = {
    issueAri: Scalars["ID"]["input"];
    prompt?: InputMaybe<Scalars["String"]["input"]>;
    repoUrl: Scalars["String"]["input"];
    sourceBranch?: InputMaybe<Scalars["String"]["input"]>;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationCreateAutodevPullRequestArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationCreateAutofixJobArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraAutofixInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationDeleteAutodevJobArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationDeleteAutodevPlannedChangeArgs = {
    fileId: Scalars["ID"]["input"];
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationDeleteAutodevTaskArgs = {
    fileId: Scalars["ID"]["input"];
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
    taskId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationDismissBitbucketPendingAccessRequestBannerArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDismissBitbucketPendingAccessRequestBannerInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationDismissDevOpsIssuePanelBannerArgs = {
    input: JiraDismissDevOpsIssuePanelBannerInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationDismissInContextConfigPromptArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDismissInContextConfigPromptInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationModifyAutodevCodeArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
    prompt: Scalars["String"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationOptoutOfDevOpsIssuePanelNotConnectedStateArgs = {
    input: JiraOptoutDevOpsIssuePanelNotConnectedInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationPauseAutodevCodeGenerationArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationRegenerateAutodevPlanArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
    prompt: Scalars["String"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationRemoveJiraBitbucketWorkspaceConnectionArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraRemoveJiraBitbucketWorkspaceConnectionInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationResumeAutodevJobArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationRetryAutodevJobArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationSaveAutodevPlanArgs = {
    acceptanceCriteria?: InputMaybe<Scalars["String"]["input"]>;
    currentState?: InputMaybe<Scalars["String"]["input"]>;
    desiredState?: InputMaybe<Scalars["String"]["input"]>;
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationSetProjectSelectedDeploymentAppsPropertyArgs = {
    input: JiraSetProjectSelectedDeploymentAppsPropertyInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationStartAutodevArgs = {
    acceptanceCriteria?: InputMaybe<Scalars["String"]["input"]>;
    createPr?: InputMaybe<Scalars["Boolean"]["input"]>;
    currentState?: InputMaybe<Scalars["String"]["input"]>;
    desiredState?: InputMaybe<Scalars["String"]["input"]>;
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationStopAutodevJobArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationUpdateAssociationsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDevOpsUpdateAssociationsInput;
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationUpdateAutodevPlannedChangeArgs = {
    changeType?: InputMaybe<JiraAutodevCodeChangeEnumType>;
    fileId: Scalars["ID"]["input"];
    fileName?: InputMaybe<Scalars["String"]["input"]>;
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related mutations in Jira */
export type JiraDevOpsMutationUpdateAutodevTaskArgs = {
    fileId: Scalars["ID"]["input"];
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
    task?: InputMaybe<Scalars["String"]["input"]>;
    taskId: Scalars["ID"]["input"];
};

export type JiraDevOpsProvider = {
    /**
     * The list of capabilities the devOps provider supports
     *
     * This max size of the list is bounded by the total number of enum states
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    capabilities?: Maybe<Array<Maybe<JiraDevOpsCapability>>>;
    /**
     * The human-readable display name of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The link to the web URL of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** Details of a SCM Pull-request associated with a Jira issue */
export type JiraDevOpsPullRequestDetails = {
    __typename?: "JiraDevOpsPullRequestDetails";
    /** Details of author who created the Pull Request. */
    author?: Maybe<JiraDevOpsEntityAuthor>;
    /** The name of the source branch of the PR. */
    branchName?: Maybe<Scalars["String"]["output"]>;
    /** Entity URL link to pull request in its original provider */
    entityUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The timestamp of when the PR last updated in ISO 8601 format. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Pull request title */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Value uniquely identify a pull request scoped to its original scm provider, not ARI format */
    providerPullRequestId?: Maybe<Scalars["String"]["output"]>;
    /**
     * List of the reviewers for this pull request and their approval status.
     * Maximum of 50 reviewers will be returned.
     */
    reviewers?: Maybe<Array<JiraPullRequestReviewer>>;
    /** Possible states for Pull Requests. */
    status?: Maybe<JiraPullRequestState>;
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQuery = {
    __typename?: "JiraDevOpsQuery";
    /** Get an Autodev job by ID. */
    autodevJobById?: Maybe<JiraAutodevJob>;
    /**
     * Autodev/Acra jobs created based on issueAri (and optionally jobIds)
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs")' query directive to the 'autodevJobs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    autodevJobs?: Maybe<JiraAutodevJobConnection>;
    /**
     * Autodev/Acra jobs created based on issueAris
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs-by-issues")' query directive to the 'autodevJobsByIssues' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    autodevJobsByIssues?: Maybe<JiraAutodevJobConnection>;
    /**
     * Autofix jobs created based on issueId
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autofix-jobs")' query directive to the 'autofixJobs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    autofixJobs?: Maybe<JiraAutofixJobConnection>;
    /**
     * The information related to Bitbucket integration with Jira
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDevOpsBitbucketIntegration")' query directive to the 'bitbucketIntegration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    bitbucketIntegration?: Maybe<JiraBitbucketIntegration>;
    /**
     * Jira devops config state related fields
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-config-state")' query directive to the 'configState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    configState?: Maybe<JiraAppConfigState>;
    /**
     * Jira config state for all apps filtered by providerType (Response of JiraConfigStateProvider should be bounded by values in the JiraConfigStateProviderType enum)
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-config-states-by-provider")' query directive to the 'configStates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    configStates?: Maybe<JiraAppConfigStateConnection>;
    /**
     * Returns the JiraDevOpsIssuePanel for an issue
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraDevOps` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    devOpsIssuePanel?: Maybe<JiraDevOpsIssuePanel>;
    /** If in-context configuration prompt is dismissed. This is per user setting, and irreversible once dismissed */
    isInContextConfigPromptDismissed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Jira devops toolchain related fields */
    toolchain?: Maybe<JiraToolchain>;
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryAutodevJobByIdArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryAutodevJobsArgs = {
    issueAri: Scalars["ID"]["input"];
    jobIdFilter?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryAutodevJobsByIssuesArgs = {
    issueAris: Array<Scalars["ID"]["input"]>;
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryAutofixJobsArgs = {
    issueAri: Scalars["ID"]["input"];
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryBitbucketIntegrationArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryConfigStateArgs = {
    appId: Scalars["ID"]["input"];
    cloudId: Scalars["ID"]["input"];
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryConfigStatesArgs = {
    cloudId: Scalars["ID"]["input"];
    providerTypeFilter?: InputMaybe<Array<JiraConfigStateProviderType>>;
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryDevOpsIssuePanelArgs = {
    issueId: Scalars["ID"]["input"];
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryIsInContextConfigPromptDismissedArgs = {
    cloudId: Scalars["ID"]["input"];
    location: JiraDevOpsInContextConfigPromptLocation;
};

/** Container for all DevOps related queries in Jira */
export type JiraDevOpsQueryToolchainArgs = {
    cloudId: Scalars["ID"]["input"];
};

export enum JiraDevOpsUpdateAssociationsEntityType {
    Vulnerability = "VULNERABILITY"
}

/** The input type for updating devOps associations */
export type JiraDevOpsUpdateAssociationsInput = {
    /** List of entities with associations to add or remove */
    entityAssociations: Array<JiraDevOpsEntityAssociationsInput>;
    /** The type of the entities */
    entityType: JiraDevOpsUpdateAssociationsEntityType;
    /** The provider ID that the entities being associated belong to */
    providerId: Scalars["String"]["input"];
};

/** The payload type for updating devOps associations */
export type JiraDevOpsUpdateAssociationsPayload = Payload & {
    __typename?: "JiraDevOpsUpdateAssociationsPayload";
    /** The associations that have been accepted */
    acceptedAssociations?: Maybe<Array<Maybe<JiraDevOpsAssociationPayload>>>;
    /**
     * "
     * Mutation errors if any exist.
     */
    errors?: Maybe<Array<MutationError>>;
    /** The associations that have been rejected */
    rejectedAssociations?: Maybe<Array<Maybe<JiraDevOpsAssociationPayload>>>;
    /** The success indicator saying whether the mutation operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents dev summary for an issue. The identifier for this field is devSummary */
export type JiraDevSummaryField = JiraIssueField &
    Node & {
        __typename?: "JiraDevSummaryField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * A summary of the development information (e.g. pull requests, commits) associated with
         * this issue.
         *
         * WARNING: The data returned by this field may be stale/outdated. This field is temporary and
         * will be replaced by a `devSummary` field that returns up-to-date information.
         *
         * In the meantime, if you only need data for a single issue you can use the `JiraDevOpsQuery.devOpsIssuePanel`
         * field to get up-to-date dev summary data.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: JiraDevSummaryIssueField` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        devSummaryCache?: Maybe<JiraIssueDevSummaryResult>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

export type JiraDisableJourneyConfigurationInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

/** Input to revert the config of a board view to its globally published or default settings, discarding any user-specific settings. */
export type JiraDiscardUserBoardViewConfigInput = {
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view whose config is being reverted to its globally published or default settings. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the discard user board view config mutation. */
export type JiraDiscardUserBoardViewConfigPayload = Payload & {
    __typename?: "JiraDiscardUserBoardViewConfigPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while discarding the board view config.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */
export type JiraDismissBitbucketPendingAccessRequestBannerInput = {
    /** if the banner should be dismissed. The default is true, if not given */
    isDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */
export type JiraDismissBitbucketPendingAccessRequestBannerPayload = Payload & {
    __typename?: "JiraDismissBitbucketPendingAccessRequestBannerPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input type for devops panel banner dismissal */
export type JiraDismissDevOpsIssuePanelBannerInput = {
    /**
     * Only "issue-key-onboarding" is supported currently as this is the only banner
     * that can be displayed in the panel for now
     */
    bannerType: JiraDevOpsIssuePanelBannerType;
    /** ID of the issue this banner was dismissed on */
    issueId: Scalars["ID"]["input"];
};

/** The response payload for devops panel banner dismissal */
export type JiraDismissDevOpsIssuePanelBannerPayload = Payload & {
    __typename?: "JiraDismissDevOpsIssuePanelBannerPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** The response payload to dismiss in-context configuration prompt that is per user setting */
export type JiraDismissInContextConfigPromptInput = {
    /** if the prompt should be dismissed. The default is true, if not given */
    isDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The location of the dismissed prompt. If array is empty, it won't do anything. */
    locations: Array<JiraDevOpsInContextConfigPromptLocation>;
};

/** The response payload to dismiss in-context configuration prompt that is per user setting */
export type JiraDismissInContextConfigPromptPayload = Payload & {
    __typename?: "JiraDismissInContextConfigPromptPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraDuplicateJourneyConfigurationInput = {
    /** Id of the existing journey configuration to be duplicated */
    id: Scalars["ID"]["input"];
};

/** Represents a duration. Typically used for time tracking fields. */
export type JiraDurationField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraDurationField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Displays the duration.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        durationInSeconds?: Maybe<Scalars["Long"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input for OriginalEstimate field */
export type JiraDurationFieldInput = {
    /** Represents the time original estimate */
    originalEstimateField?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraEditCustomFieldInput = {
    cloudId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    fieldId: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    options?: InputMaybe<Array<JiraCustomFieldOptionInput>>;
    projectId: Scalars["String"]["input"];
};

export type JiraEditCustomFieldPayload = Payload & {
    __typename?: "JiraEditCustomFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    fieldAssociationWithIssueTypes?: Maybe<JiraFieldAssociationWithIssueTypes>;
    success: Scalars["Boolean"]["output"];
};

/** Represents the possible email MIME types. */
export enum JiraEmailMimeType {
    Html = "HTML",
    Text = "TEXT"
}

/** Represents the reason why a connection is empty. */
export type JiraEmptyConnectionReason = {
    /** Returns the reason why the connection is empty as an empty connection is not always an error. */
    message?: Maybe<Scalars["String"]["output"]>;
};

/** Link to send org admins to enable Atlassian Intelligence. */
export type JiraEnableAtlassianIntelligenceDeepLink = {
    __typename?: "JiraEnableAtlassianIntelligenceDeepLink";
    /** Link to send org admins to enable Atlassian Intelligence. */
    link?: Maybe<Scalars["String"]["output"]>;
};

export type JiraEnablePlanFeaturePayloadGraphQl = Payload & {
    __typename?: "JiraEnablePlanFeaturePayloadGraphQL";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** A plan that was updated */
    plan?: Maybe<JiraPlan>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input type for Entitlement field */
export type JiraEntitlementFieldInput = {
    /** Represents entitlement field data */
    entitlement: JiraEntitlementInput;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

/** Input type representing a single entitlement */
export type JiraEntitlementInput = {
    /** An identifier for the entitlement */
    entitlementId: Scalars["ID"]["input"];
};

/** An interface for the return type of any Entity Property */
export type JiraEntityProperty = {
    /** The ARI unique to the entity property */
    id: Scalars["ID"]["output"];
    /** The key of the entity property */
    propertyKey?: Maybe<Scalars["String"]["output"]>;
};

/** The generic Boolean type for any entity property */
export type JiraEntityPropertyBoolean = JiraEntityProperty &
    Node & {
        __typename?: "JiraEntityPropertyBoolean";
        /** The value of this property in Boolean format */
        booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
        /** The ARI unique to the entity property */
        id: Scalars["ID"]["output"];
        /** The key of the entity property */
        propertyKey?: Maybe<Scalars["String"]["output"]>;
    };

/** The generic integer type for any entity property */
export type JiraEntityPropertyInt = JiraEntityProperty &
    Node & {
        __typename?: "JiraEntityPropertyInt";
        /** The ARI unique to the entity property */
        id: Scalars["ID"]["output"];
        /** The value of this property in integer format */
        intValue?: Maybe<Scalars["Int"]["output"]>;
        /** The key of the entity property */
        propertyKey?: Maybe<Scalars["String"]["output"]>;
    };

/** The generic JSON type for any entity property, use of this interface is NOT recommended as per https://hello.atlassian.net/wiki/spaces/GT3/pages/2567211252/Avoid+using+JSON+as+a+field+type */
export type JiraEntityPropertyJson = JiraEntityProperty &
    Node & {
        __typename?: "JiraEntityPropertyJSON";
        /** The ARI unique to the entity property */
        id: Scalars["ID"]["output"];
        /**
         * The value of this property in JSON format
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated use of raw JSON is NOT recommended as per https://hello.atlassian.net/wiki/spaces/GT3/pages/2567211252/Avoid+using+JSON+as+a+field+type.
         */
        jsonValue?: Maybe<Scalars["JSON"]["output"]>;
        /** The key of the entity property */
        propertyKey?: Maybe<Scalars["String"]["output"]>;
    };

/** The generic String type for any entity property */
export type JiraEntityPropertyString = JiraEntityProperty &
    Node & {
        __typename?: "JiraEntityPropertyString";
        /** The ARI unique to the entity property */
        id: Scalars["ID"]["output"];
        /** The key of the entity property */
        propertyKey?: Maybe<Scalars["String"]["output"]>;
        /** The value of this property in String format */
        stringValue?: Maybe<Scalars["String"]["output"]>;
    };

/** Scope of values for the Entity (Ex: Field) */
export enum JiraEntityScope {
    Global = "GLOBAL",
    Project = "PROJECT"
}

/** Represents an epic. */
export type JiraEpic = {
    __typename?: "JiraEpic";
    /**
     * Color string for the epic.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    color?: Maybe<Scalars["String"]["output"]>;
    /**
     * Status of the epic, whether its completed or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    done?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Global identifier for the epic/issue Id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Issue Id for the epic.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issueId: Scalars["String"]["output"];
    /**
     * Key identifier for the Issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     * Name of the epic.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Summary of the epic.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraEpic. */
export type JiraEpicConnection = {
    __typename?: "JiraEpicConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraEpicEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraEpic connection. */
export type JiraEpicEdge = {
    __typename?: "JiraEpicEdge";
    /**
     * The cursor to this edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     * The node at the edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<JiraEpic>;
};

/** Represents epic link field on a Jira Issue. */
export type JiraEpicLinkField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraEpicLinkField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * The epic selected on the Issue or default epic configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        epic?: Maybe<JiraEpic>;
        /**
         * Paginated list of epic options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        epics?: Maybe<JiraEpicConnection>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available epics options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents epic link field on a Jira Issue. */
export type JiraEpicLinkFieldEpicsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    done?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for epic link field */
export type JiraEpicLinkFieldInput = {
    /** Represents an epic link field */
    epicLink: JiraEpicLinkInput;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

/** Input type for epic link field */
export type JiraEpicLinkInput = {
    /** Issue key for epic */
    issueKey: Scalars["String"]["input"];
};

/** Represents the Jira time tracking estimate type. */
export type JiraEstimate = {
    __typename?: "JiraEstimate";
    /** The estimated time in seconds. */
    timeInSeconds?: Maybe<Scalars["Long"]["output"]>;
};

export type JiraEstimateInput = {
    /** Does not currently support null. Use 0 to get a similar effect. */
    timeInSeconds: Scalars["Long"]["input"];
};

/**
 * Input for Jira export issue details
 * Takes in issueId, along with options to include fields, comments, history and worklog
 */
export type JiraExportIssueDetailsInput = {
    /** Whether to include the issue comments in the export */
    includeComments?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether to include the issue fields in the export */
    includeFields?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether to include the issue history in the export */
    includeHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether to include the issue worklogs in the export */
    includeWorklogs?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** ARI of the issue to be exported */
    issueId: Scalars["ID"]["input"];
};

/**
 * Output for Jira export issue details
 * Provides with the details of the issue being exported, if it is present along with errors if any
 */
export type JiraExportIssueDetailsResponse = {
    __typename?: "JiraExportIssueDetailsResponse";
    /** Errors which were encountered while fetching. */
    errors?: Maybe<Array<QueryError>>;
    /** The task response for the export issue details operation. */
    taskResponse?: Maybe<JiraExportIssueDetailsTaskResponse>;
};

/**
 * Contains details about the Jira issue being exported
 * Provides with a task id, task status and task description if present
 */
export type JiraExportIssueDetailsTaskResponse = {
    __typename?: "JiraExportIssueDetailsTaskResponse";
    /** Description of the state of the clone task. */
    taskDescription?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the issue clone task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
    /** The status of the clone task. */
    taskStatus?: Maybe<JiraLongRunningTaskStatus>;
};

/**
 * Context where the extensions are supposed to be shown.
 *
 * Provide only the most specific entity. For example, there is no need to provide the project if an issue is given; the project will be inferred from the issue automatically.
 */
export type JiraExtensionRenderingContextInput = {
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
    portalId?: InputMaybe<Scalars["ID"]["input"]>;
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Represents a field not yet fully supported on a Jira Issue, but can be displayed in the UI via the fallback value.
 * WARNING: This type is deprecated. PLEASE DO NOT USE.
 */
export type JiraFallbackField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraFallbackField";
        /**
         * The field ID alias (if applicable).
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        name: Scalars["String"]["output"];
        /**
         * The displayed html representation of the field value.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        renderedFieldHtml?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        type: Scalars["String"]["output"];
    };

export type JiraFavourite =
    | JiraBoard
    | JiraCustomFilter
    | JiraDashboard
    | JiraPlan
    | JiraProject
    | JiraServiceManagementQueue
    | JiraSystemFilter;

export type JiraFavouriteConnection = {
    __typename?: "JiraFavouriteConnection";
    edges?: Maybe<Array<Maybe<JiraFavouriteEdge>>>;
    pageInfo: PageInfo;
};

export type JiraFavouriteEdge = {
    __typename?: "JiraFavouriteEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraFavourite>;
};

export type JiraFavouriteFilter = {
    /** Include archived projects in the result (applies to projects only, default to true) */
    includeArchivedProjects?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Filter the results by the keyword */
    keyword?: InputMaybe<Scalars["String"]["input"]>;
    /** Sorting the results. If not provided, the oldest favourited entity will be returned first. */
    sort?: InputMaybe<JiraFavouriteSortInput>;
    /** The Jira entity type to get. */
    type?: InputMaybe<JiraFavouriteType>;
    /** List of Jira entity types to get, if both type and types are provided, type will be ignored. */
    types?: InputMaybe<Array<JiraFavouriteType>>;
};

export type JiraFavouriteSortInput = {
    /**
     * The order to sort by.
     * ASC: oldest favourited entity will be returned first.
     * DESC: recent favourited entity will be returned first.
     */
    order: SortDirection;
};

/** Currently supported favouritable entities in Jira. */
export enum JiraFavouriteType {
    Board = "BOARD",
    Dashboard = "DASHBOARD",
    Filter = "FILTER",
    Plan = "PLAN",
    Project = "PROJECT",
    Queue = "QUEUE"
}

/** Favourite Node which is unique to a favouritable entity and a user and returns if the favourite value is true or false. */
export type JiraFavouriteValue = Node & {
    __typename?: "JiraFavouriteValue";
    /** ARI for the Jira Favourite */
    id: Scalars["ID"]["output"];
    /** The value of the favourite, true when the entity is favourited and false if it is unfavourited. */
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JiraFetchBulkOperationDetailsResponse = {
    __typename?: "JiraFetchBulkOperationDetailsResponse";
    /** Retrieves a connection of bulk editable fields for the current user */
    bulkEditFields?: Maybe<JiraBulkEditFieldsConnection>;
    /** Represents a list of all available bulk transitions */
    bulkTransitions?: Maybe<JiraBulkTransitionConnection>;
    /** Whether the user can update email notifications or not */
    mayDisableNotifications?: Maybe<Scalars["Boolean"]["output"]>;
    /** Total number of selected issues for bulk edit */
    totalIssues?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraFetchBulkOperationDetailsResponseBulkEditFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    search?: InputMaybe<JiraBulkEditFieldsSearch>;
};

export type JiraFetchBulkOperationDetailsResponseBulkTransitionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira field which includes system fields and custom fields */
export type JiraField = {
    __typename?: "JiraField";
    /** The description of the field */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The identifier of the field. E.g. summary, customfield_10001, etc. */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /** Unique identifier of the field. */
    id: Scalars["ID"]["output"];
    /** The name of the field. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The scope of the field. */
    scope?: Maybe<JiraEntityScope>;
    /** The type key of the field, e.g. "com.atlassian.jira.plugin.system.customfieldtypes:textfield" */
    typeKey?: Maybe<Scalars["String"]["output"]>;
    /** The name of the field type, e.g. "Short text" */
    typeName?: Maybe<Scalars["String"]["output"]>;
};

/** Represents Association of fields with IssueTypes */
export type JiraFieldAssociationWithIssueTypes =
    JiraProjectFieldAssociationInterface & {
        __typename?: "JiraFieldAssociationWithIssueTypes";
        /** This holds the general attributes of a field */
        field?: Maybe<JiraField>;
        /** This holds operations that can be performed on a field */
        fieldOperation?: Maybe<JiraFieldOperation>;
        /** A list of field options. */
        fieldOptions?: Maybe<JiraFieldOptionConnection>;
        /**
         * Indicates whether the field association contain missing configuration warning when context not found..
         * If true, it means that the field association is not fully compatible, and it is considered as restricted.
         */
        hasMissingConfiguration?: Maybe<Scalars["Boolean"]["output"]>;
        /** Unique identifier of the field association. */
        id: Scalars["ID"]["output"];
        /** Indicates whether the field is marked as locked. */
        isFieldLocked?: Maybe<Scalars["Boolean"]["output"]>;
        /** A list of issue types associated with the field in a project. */
        issueTypes?: Maybe<JiraIssueTypeConnection>;
    };

/** The connection type for JiraFieldAssociationWithIssueTypes. */
export type JiraFieldAssociationWithIssueTypesConnection = {
    __typename?: "JiraFieldAssociationWithIssueTypesConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraFieldAssociationWithIssueTypesEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraFieldAssociationWithIssueTypes connection. */
export type JiraFieldAssociationWithIssueTypesEdge = {
    __typename?: "JiraFieldAssociationWithIssueTypesEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraFieldAssociationWithIssueTypes>;
};

/** Represents an input to fieldAssociationWithIssueTypes query */
export type JiraFieldAssociationWithIssueTypesInput = {
    /** Search fields by list of field type groups. If empty, fields will not be filtered by field type group. */
    fieldTypeGroups?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search fields by field name. If null or empty, fields will not be filtered by field name. */
    filterContains?: InputMaybe<Scalars["String"]["input"]>;
    /** Search fields by list of issue types. If empty, fields will not be filtered by issue type. */
    issueTypeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Attributes of field configuration. */
export type JiraFieldConfig = {
    __typename?: "JiraFieldConfig";
    /** Defines if a field is editable. */
    isEditable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Defines if a field is required on a screen. */
    isRequired?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Explains the reason why a field is not editable on a screen.
     * E.g. cases where a field needs a licensed premium version to be editable.
     */
    nonEditableReason?: Maybe<JiraFieldNonEditableReason>;
};

/** A connection to a list of FieldConfigs. */
export type JiraFieldConfigConnection = {
    __typename?: "JiraFieldConfigConnection";
    /** A list of JiraIssueFieldConfig edges. */
    edges?: Maybe<Array<JiraFieldConfigEdge>>;
    /** A list of JiraIssueFieldConfig. */
    nodes?: Maybe<Array<JiraIssueFieldConfig>>;
    /** Information to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
    /** Count of filtered result set across all pages */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraIssueFieldConfig connection. */
export type JiraFieldConfigEdge = {
    __typename?: "JiraFieldConfigEdge";
    /** A cursor for use in pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The item at the end of the edge. */
    node?: Maybe<JiraIssueFieldConfig>;
};

export type JiraFieldConfigFilterInput = {
    /**
     * The field ID alias.
     * Applies to managed or commonly known custom fields in Jira, which allow lookup without requiring the custom field ID.
     * E.g. rank or startdate.
     * If specified, the result will only contain the fields that matches the provided aliasFieldIds
     */
    aliasFieldIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The cloud id of the tenant. */
    cloudId: Scalars["ID"]["input"];
    /** If specified the result will be filtered by specific fieldIds */
    fieldIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** if not specified the result will include all Field types matched */
    includedFieldTypes?: InputMaybe<Array<JiraConfigFieldType>>;
    /** If not specified all field configs in the system across projects will be returned */
    projectIdOrKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The search string used to perform a contains search on the field name of the Field config */
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

/** The connection type for JiraProjectAssociatedFields. */
export type JiraFieldConnection = {
    __typename?: "JiraFieldConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraFieldEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraProjectAssociatedFields connection. */
export type JiraFieldEdge = {
    __typename?: "JiraFieldEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraField>;
};

export type JiraFieldKeyValueInput = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    value?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the information for a field being non-editable on Issue screens. */
export type JiraFieldNonEditableReason = {
    __typename?: "JiraFieldNonEditableReason";
    /** Message explanining why the field is non-editable (if present). */
    message?: Maybe<Scalars["String"]["output"]>;
};

/** Represents operations allowed on a JiraField */
export type JiraFieldOperation = {
    __typename?: "JiraFieldOperation";
    /** Indicates whether the field can be associated to issuetypes. */
    canAssociateInSettings?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the field can be deleted. */
    canDelete?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the name and description of the field can be edited. */
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the options of the field can be modified. */
    canModifyOptions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the field can be removed (unassociation). */
    canRemove?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents the options of a JiraField. */
export type JiraFieldOption = {
    __typename?: "JiraFieldOption";
    /** The identifier of the field option that exists in the system. */
    optionId?: Maybe<Scalars["Long"]["output"]>;
    /** The identifier of the parent option. */
    parentOptionId?: Maybe<Scalars["Long"]["output"]>;
    /** The value of the field option. */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraFieldOption. */
export type JiraFieldOptionConnection = {
    __typename?: "JiraFieldOptionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraFieldOptionEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraFieldOption connection. */
export type JiraFieldOptionEdge = {
    __typename?: "JiraFieldOptionEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraFieldOption>;
};

/** Represents argument input type for `fieldOptions` query to provide capability to filter field options by list of IDs */
export type JiraFieldOptionIdsFilterInput = {
    /** Filter operation to perform on the list of optionsIds provided in input. */
    operation: JiraFieldOptionIdsFilterOperation;
    /**
     * Filter the available field options with provided option ids by specifying a filter operation.
     * Upto maximum 100 Option Ids are can be provided in the input.
     * Accepts ARI(s): OptionID
     */
    optionIds: Array<Scalars["ID"]["input"]>;
};

/** Enum to define a filter operation on the optionIds in input JiraFieldOptionIdsFilterInput */
export enum JiraFieldOptionIdsFilterOperation {
    /**
     * Allow the optionIds provided in the JiraFieldOptionIdsFilterInput from available options
     * with intersection of result from searchBy query string.
     */
    Allow = "ALLOW",
    /**
     * Exclude the optionIds provided in the JiraFieldOptionIdsFilterInput from available options
     * with intersection of result from searchBy query string.
     */
    Exclude = "EXCLUDE"
}

/** The representation of fieldset preferences. */
export type JiraFieldSetPreferences = {
    __typename?: "JiraFieldSetPreferences";
    width?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraFieldSetPreferencesMutationInput = {
    /** Input object which contains the fieldSets preferences */
    nodes?: InputMaybe<Array<JiraUpdateFieldSetPreferencesInput>>;
};

/** The payload returned when a User fieldset preferences has been updated. */
export type JiraFieldSetPreferencesUpdatePayload = Payload & {
    __typename?: "JiraFieldSetPreferencesUpdatePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type JiraFieldSetView = JiraFieldSetsViewMetadata &
    Node & {
        __typename?: "JiraFieldSetView";
        /** A connection of included fields' configurations, grouped where logical (e.g. collapsed fields). */
        fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
        /**
         * A nullable boolean indicating if the FieldSetView is using default fieldSets
         * true -> Field set view is using default fieldSets
         * false -> Field set view has custom fieldSets
         */
        hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
        /** An ARI-format value that encodes field set view id. Could be default if nothing is saved. */
        id: Scalars["ID"]["output"];
    };

export type JiraFieldSetViewFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraFieldSetViewResult = JiraFieldSetView | QueryError;

export type JiraFieldSetsMutationInput = {
    /** Input object which contains the new fieldSets */
    replaceFieldSetsInput?: InputMaybe<JiraReplaceIssueSearchViewFieldSetsInput>;
    /** Boolean which resets the fieldSets of a view to default fieldSets */
    resetToDefaultFieldSets?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JiraFieldSetsViewMetadata = {
    /** A connection of included fields' configurations, grouped where logical (e.g. collapsed fields). */
    fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
    /**
     * A nullable boolean indicating if the FieldSetView is using default fieldSets
     * true -> Field set view is using default fieldSets
     * false -> Field set view has custom fieldSets
     */
    hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
    /** An ARI-format value that encodes field set view id. Could be default if nothing is saved. */
    id: Scalars["ID"]["output"];
};

export type JiraFieldSetsViewMetadataFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The payload returned when a JiraFieldSetView has been updated. */
export type JiraFieldSetsViewPayload = Payload & {
    __typename?: "JiraFieldSetsViewPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    view?: Maybe<JiraFieldSetsViewMetadata>;
};

/**
 * The representation of a Jira field-type.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 */
export type JiraFieldType = {
    __typename?: "JiraFieldType";
    /** The translated name of the field type. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The non-translated name of the field type. */
    name: Scalars["String"]["output"];
};

/** The connection type for JiraProjectFieldsPageFieldType. */
export type JiraFieldTypeConnection = {
    __typename?: "JiraFieldTypeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraFieldTypeEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraFieldTypeConnection. */
export type JiraFieldTypeEdge = {
    __typename?: "JiraFieldTypeEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraProjectFieldsPageFieldType>;
};

/**
 * Represents a field type group in a Jira Project.
 * Field type group is a way of grouping field types to enable easy filtering of fields by admins on the Project Fields page.
 * It helps with the fact that we have many type of text fields, number fields, date fields, people fields, and so on.
 * The product hypothesis is that it is more intuitive and useful for admins to filter the fields table by a field type group
 * rather than the individual field types.
 * The initial list of groups has been defined [here](https://hello.atlassian.net/wiki/spaces/JU/pages/1550998319/Field+audit)
 */
export type JiraFieldTypeGroup = {
    __typename?: "JiraFieldTypeGroup";
    /** The translated text representation of the field type group. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** Jira field type group key */
    key?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for FieldTypeGroup. */
export type JiraFieldTypeGroupConnection = {
    __typename?: "JiraFieldTypeGroupConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraFieldTypeGroupEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a FieldTypeGroup connection. */
export type JiraFieldTypeGroupEdge = {
    __typename?: "JiraFieldTypeGroupEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraFieldTypeGroup>;
};

/** Represents a field validation error. renamed to FieldValidationMutationErrorExtension to compatible with jira/gira prefix validation */
export type JiraFieldValidationMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "JiraFieldValidationMutationErrorExtension";
        /**
         * Application specific error type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * The id of the field associated with the error.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId?: Maybe<Scalars["String"]["output"]>;
        /**
         * A numerical code (such as a HTTP status code) representing the error category.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

/** A generic interface for Jira Filter. */
export type JiraFilter = {
    /**
     * A tenant local filterId. This value is used for interoperability with REST APIs (eg vendors).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filterId: Scalars["String"]["output"];
    /**
     * The URL string associated with a specific user filter in Jira.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filterUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * An ARI value in the format `ari:cloud:jira:{siteId}:filter/activation/{activationId}/{filterId}`that encodes the filterId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Determines whether the filter is currently starred by the user viewing the filter.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * JQL associated with the filter.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jql: Scalars["String"]["output"];
    /**
     * The timestamp of this filter was last viewed by the current user (reference to Unix Epoch time in ms).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
    /**
     * A string representing the filter name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
};

/** Represents connection of JiraFilters */
export type JiraFilterConnection = {
    __typename?: "JiraFilterConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraFilterEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
};

/** Represents a filter edge */
export type JiraFilterEdge = {
    __typename?: "JiraFilterEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the edge */
    node?: Maybe<JiraFilter>;
};

/** Error extension for filter edit grants validation errors. */
export type JiraFilterEditGrantMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "JiraFilterEditGrantMutationErrorExtension";
        /**
         * Application specific error type in human readable format.
         * For example: FilterNameError
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * A numerical code (example: HTTP status code) representing the error category
         * For example: 412 for operation preconditions failure.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

/** Represents an email subscription to a Jira Filter */
export type JiraFilterEmailSubscription = Node & {
    __typename?: "JiraFilterEmailSubscription";
    /** The group subscribed to the filter. */
    group?: Maybe<JiraGroup>;
    /** ARI of the email subscription. */
    id: Scalars["ID"]["output"];
    /** User that created the subscription. If no group is specified then the subscription is personal for this user. */
    user?: Maybe<User>;
};

/** Represents a connection of JiraFilterEmailSubscriptions. */
export type JiraFilterEmailSubscriptionConnection = {
    __typename?: "JiraFilterEmailSubscriptionConnection";
    /**
     * The data for the edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraFilterEmailSubscriptionEdge>>>;
    /**
     * The page info of the current page of results.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

/** Represents a filter email subscription edge */
export type JiraFilterEmailSubscriptionEdge = {
    __typename?: "JiraFilterEmailSubscriptionEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the edge */
    node?: Maybe<JiraFilterEmailSubscription>;
};

/** Type to group mutations for JiraFilters */
export type JiraFilterMutation = {
    __typename?: "JiraFilterMutation";
    /**
     * Mutation to create JiraCustomFilter
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFilter` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    createJiraCustomFilter?: Maybe<JiraCreateCustomFilterPayload>;
    /** Mutation to delete a JiraCustomFilter. The id is an ARI-format value that encodes the filterId. */
    deleteJiraCustomFilter?: Maybe<JiraDeleteCustomFilterPayload>;
    /**
     * Mutation to update JiraCustomFilter details
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFilter` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    updateJiraCustomFilterDetails?: Maybe<JiraUpdateCustomFilterPayload>;
    /** Mutation to update JiraCustomFilter JQL */
    updateJiraCustomFilterJql?: Maybe<JiraUpdateCustomFilterJqlPayload>;
};

/** Type to group mutations for JiraFilters */
export type JiraFilterMutationCreateJiraCustomFilterArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraCreateCustomFilterInput;
};

/** Type to group mutations for JiraFilters */
export type JiraFilterMutationDeleteJiraCustomFilterArgs = {
    id: Scalars["ID"]["input"];
};

/** Type to group mutations for JiraFilters */
export type JiraFilterMutationUpdateJiraCustomFilterDetailsArgs = {
    input: JiraUpdateCustomFilterDetailsInput;
};

/** Type to group mutations for JiraFilters */
export type JiraFilterMutationUpdateJiraCustomFilterJqlArgs = {
    input: JiraUpdateCustomFilterJqlInput;
};

/** Error extension for filter name validation errors. */
export type JiraFilterNameMutationErrorExtension = MutationErrorExtension & {
    __typename?: "JiraFilterNameMutationErrorExtension";
    /**
     * Application specific error type in human readable format.
     * For example: FilterNameError
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (example: HTTP status code) representing the error category
     * For example: 412 for operation preconditions failure.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Deprecated type. Please use `JiraFilter` instead. */
export type JiraFilterResult = JiraCustomFilter | JiraSystemFilter | QueryError;

/** Error extension for filter share grants validation errors. */
export type JiraFilterShareGrantMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "JiraFilterShareGrantMutationErrorExtension";
        /**
         * Application specific error type in human readable format.
         * For example: FilterNameError
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * A numerical code (example: HTTP status code) representing the error category
         * For example: 412 for operation preconditions failure.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

/** Represents the Jira flag. */
export type JiraFlag = {
    __typename?: "JiraFlag";
    /** Indicates whether the issue is flagged or not. */
    isFlagged?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents a flag field on a Jira Issue. E.g. flagged. */
export type JiraFlagField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraFlagField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** The flag value selected on the Issue. */
        flag?: Maybe<JiraFlag>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

export type JiraForgeAppEgressDeclaration = {
    __typename?: "JiraForgeAppEgressDeclaration";
    /** The list of addresses this egress declaration allows. */
    addresses?: Maybe<Array<Scalars["String"]["output"]>>;
    /**
     * The category of the egress.
     *
     * For now, it can only be:
     * * ANALYTICS
     *
     * More types may be added in the future.
     */
    category?: Maybe<Scalars["String"]["output"]>;
    /** Determines if the egress contains end-user-data (EUD) */
    inScopeEUD?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The type of the allowed egress for the given addresses.
     *
     * Can be one of:
     * * NAVIGATION
     * * IMAGES
     * * MEDIA
     * * SCRIPTS
     * * STYLES
     * * FETCH_BACKEND_SIDE
     * * FETCH_CLIENT_SIDE
     * * FONTS
     * * FRAMES
     *
     * More types may be added in the future.
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a date field created by Forge App. */
export type JiraForgeDateField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeDateField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The date selected on the issue or default datetime configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        date?: Maybe<Scalars["Date"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the
         * app, otherwise returns the one of the predefined custom field renderer type
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a date time field created by Forge App. */
export type JiraForgeDatetimeField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeDatetimeField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The datetime selected on the issue or default datetime configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        dateTime?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** The environment type the extension can be installed into. See [Environments and versions](https://developer.atlassian.com/platform/forge/environments-and-versions/) for more details. */
export enum JiraForgeEnvironmentType {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING"
}

/** The definition of a Forge extension in Jira. */
export type JiraForgeExtension = {
    __typename?: "JiraForgeExtension";
    /** The version of the app the extension is coming from. */
    appVersion: Scalars["String"]["output"];
    /**
     * The URL that frontend needs to use in a consent screen if during rendering XIS returns an error
     * saying that a consent is required (which may happen even with the auto-consent flow).
     *
     * Requesting this field will incur a performance penalty, so avoid it if you can.
     * The field is also cached (10 minutes TTL), so expect only eventual consistency.
     */
    consentUrl?: Maybe<Scalars["String"]["output"]>;
    /** All data egress declarations from the app. */
    egress: Array<Maybe<JiraForgeAppEgressDeclaration>>;
    /** The ID of the environment. Also part of the extension ID. */
    environmentId: Scalars["String"]["output"];
    /**
     * The key of the environment the extension is installed in.
     *
     * Equal to lowercase `environmentType` for `STAGING` and `PRODUCTION`. For `DEVELOPMENT` it can be `default` or any key created by the user (in case of custom development environments).
     */
    environmentKey: Scalars["String"]["output"];
    /** The type of the environment the extension is installed in. */
    environmentType: JiraForgeEnvironmentType;
    /**
     * If the app shouldn't be visible in the given context, this field specifies which mechanism is hiding it.
     *
     * Note that hidden extensions are returned only if the `includeHidden` argument is `true`.
     */
    hiddenBy?: Maybe<JiraVisibilityControlMechanism>;
    /** The ID of the extension in the following format: `ari:cloud:ecosystem::extension/{app-id}/{env-id}/static/{module-key}`. For example, `ari:cloud:ecosystem::extension/e62f20a2-4b61-4dbe-bfb9-9a88b5e3ac84/548c5df1-24aa-4f7c-bbbb-3038d947cb05/static/module-key`. */
    id: Scalars["ID"]["output"];
    /** Provides all possible configs for an app installation. This field will replace overrides. */
    installationConfig?: Maybe<Array<JiraForgeInstallationConfigExtension>>;
    /** The ID of the app installation. Visible in Forge CLI after running `forge install list`. */
    installationId: Scalars["String"]["output"];
    /**
     * All information about the license of the app that provided the extension.
     *
     * Requesting this field will incur a performance penalty, so avoid it if you can.
     * The field is also cached (10 minutes TTL), so expect only eventual consistency.
     */
    license?: Maybe<JiraForgeExtensionLicense>;
    /** A map of toggle values to override egress controls for an app installation. */
    overrides?: Maybe<Scalars["JSON"]["output"]>;
    /** Properties of the extension. Also known as `extensionData`. */
    properties: Scalars["JSON"]["output"];
    /** The list of scopes the app requests in its manifest. */
    scopes: Array<Scalars["String"]["output"]>;
    /** The type of the extension, for example `jira:customField`. */
    type: Scalars["String"]["output"];
    /**
     * Information about app access of the user making the request.
     *
     * Requesting this field will incur a performance penalty, so avoid it if you can.
     * The field is also cached (10 minutes TTL), so expect only eventual consistency.
     */
    userAccess?: Maybe<JiraUserAppAccess>;
};

export type JiraForgeExtensionLicense = {
    __typename?: "JiraForgeExtensionLicense";
    active: Scalars["Boolean"]["output"];
    billingPeriod?: Maybe<Scalars["String"]["output"]>;
    capabilitySet?: Maybe<Scalars["String"]["output"]>;
    ccpEntitlementId?: Maybe<Scalars["String"]["output"]>;
    ccpEntitlementSlug?: Maybe<Scalars["String"]["output"]>;
    isEvaluation?: Maybe<Scalars["Boolean"]["output"]>;
    subscriptionEndDate?: Maybe<Scalars["DateTime"]["output"]>;
    supportEntitlementNumber?: Maybe<Scalars["String"]["output"]>;
    trialEndDate?: Maybe<Scalars["DateTime"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a Group field created by Forge App. */
export type JiraForgeGroupField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeGroupField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of group options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        groups?: Maybe<JiraGroupConnection>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Search url to fetch all available groups for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The group selected on the Issue or default group configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedGroup?: Maybe<JiraGroup>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a Group field created by Forge App. */
export type JiraForgeGroupFieldGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Groups field created by Forge App. */
export type JiraForgeGroupsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeGroupsField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of group options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        groups?: Maybe<JiraGroupConnection>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Search url to fetch all available groups for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The groups selected on the Issue or default group configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use selectedGroupsConnection instead.
         */
        selectedGroups?: Maybe<Array<Maybe<JiraGroup>>>;
        /**
         * The groups selected on the Issue or default group configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedGroupsConnection?: Maybe<JiraGroupConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a Groups field created by Forge App. */
export type JiraForgeGroupsFieldGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Groups field created by Forge App. */
export type JiraForgeGroupsFieldSelectedGroupsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraForgeInstallationConfigExtension = {
    __typename?: "JiraForgeInstallationConfigExtension";
    /**
     * Config key for an app installation.
     *
     * e.g., 'ALLOW_EGRESS_ANALYTICS' for egress controls.
     */
    key: Scalars["String"]["output"];
    value: Scalars["Boolean"]["output"];
};

/** Input type for defining the operation on the ForgeMultipleGroupPicker field of a Jira issue. */
export type JiraForgeMultipleGroupPickerFieldOperationInput = {
    /**
     * Group Id(s) for field update.
     * Accepts ARI(s): group
     */
    ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    /** Group names for field update. */
    names?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /** Operations supported: ADD, REMOVE and SET. */
    operation: JiraMultiValueFieldOperations;
};

/** Represents a number field created by Forge App. */
export type JiraForgeNumberField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeNumberField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The number selected on the Issue or default number configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        number?: Maybe<Scalars["Float"]["output"]>;
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a object field created by Forge App. */
export type JiraForgeObjectField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeObjectField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The object string selected on the issue or default datetime configured for the field. */
        object?: Maybe<Scalars["String"]["output"]>;
        /** The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type. */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

export type JiraForgeObjectFieldOperationInput = {
    object?: InputMaybe<Scalars["String"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraForgeObjectFieldPayload = Payload & {
    __typename?: "JiraForgeObjectFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraForgeObjectField>;
    success: Scalars["Boolean"]["output"];
};

export type JiraForgeQuery = {
    __typename?: "JiraForgeQuery";
    /**
     * Returns extensions of the specified types. \Checks App Access Rules and Display Conditions according to the provided context; returns only extensions that the user is supposed to see.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    extensions?: Maybe<Array<JiraForgeExtension>>;
};

export type JiraForgeQueryExtensionsArgs = {
    cloudId: Scalars["ID"]["input"];
    context?: InputMaybe<JiraExtensionRenderingContextInput>;
    includeHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
    types: Array<Scalars["String"]["input"]>;
};

/** Input type for defining the operation on the ForgeSingleGroupPicker field of a Jira issue. */
export type JiraForgeSingleGroupPickerFieldOperationInput = {
    /**
     * Group Id for field update.
     * Accepts ARI: group
     */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** Group name for field update. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Operation supported: SET. */
    operation: JiraSingleValueFieldOperations;
};

/** Represents a string field created by Forge App. */
export type JiraForgeStringField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeStringField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * The text selected on the Issue or default text configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        text?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a strings field created by Forge App. */
export type JiraForgeStringsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeStringsField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Paginated list of label options for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        labels?: Maybe<JiraLabelConnection>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Search url to fetch all available labels options on the field or an Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The labels selected on the Issue or default labels configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use selectedLabelsConnection instead.
         */
        selectedLabels?: Maybe<Array<Maybe<JiraLabel>>>;
        /**
         * The labels selected on the Issue or default labels configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedLabelsConnection?: Maybe<JiraLabelConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a strings field created by Forge App. */
export type JiraForgeStringsFieldLabelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a strings field created by Forge App. */
export type JiraForgeStringsFieldSelectedLabelsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a User field created by Forge App. */
export type JiraForgeUserField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeUserField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Search url to fetch all available users options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * The user selected on the Issue or default user configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        user?: Maybe<User>;
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of user options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        users?: Maybe<JiraUserConnection>;
    };

/** Represents a User field created by Forge App. */
export type JiraForgeUserFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a Users field created by Forge App. */
export type JiraForgeUsersField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraForgeUsersField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The renderer type of the forge app, returns 'forge' if it's customised in the app, otherwise returns the one of the predefined custom field renderer type.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /**
         * Search url to fetch all available users options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The users selected on the Issue or default users configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use selectedUsersConnection instead.
         */
        selectedUsers?: Maybe<Array<Maybe<User>>>;
        /**
         * The users selected on the Issue or default users configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedUsersConnection?: Maybe<JiraUserConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of user options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        users?: Maybe<JiraUserConnection>;
    };

/** Represents a Users field created by Forge App. */
export type JiraForgeUsersFieldSelectedUsersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Users field created by Forge App. */
export type JiraForgeUsersFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum JiraFormattingArea {
    Cell = "CELL",
    Row = "ROW"
}

export enum JiraFormattingColor {
    /** @deprecated Use JiraColor instead */
    Blue = "BLUE",
    /** @deprecated Use JiraColor instead */
    Green = "GREEN",
    /** @deprecated Use JiraColor instead */
    Red = "RED"
}

export type JiraFormattingExpression =
    | JiraFormattingMultipleValueOperand
    | JiraFormattingNoValueOperand
    | JiraFormattingSingleValueOperand
    | JiraFormattingTwoValueOperand;

/** Rule is evaluated against multiple values. Values order does not matter in this condition. */
export type JiraFormattingMultipleValueOperand = {
    __typename?: "JiraFormattingMultipleValueOperand";
    fieldId: Scalars["String"]["output"];
    operator: JiraFormattingMultipleValueOperator;
    values: Array<Scalars["String"]["output"]>;
};

export type JiraFormattingMultipleValueOperandInput = {
    fieldId: Scalars["String"]["input"];
    operator: JiraFormattingMultipleValueOperator;
    values: Array<Scalars["String"]["input"]>;
};

export enum JiraFormattingMultipleValueOperator {
    Contains = "CONTAINS",
    DoesNotContain = "DOES_NOT_CONTAIN",
    HasAnyOf = "HAS_ANY_OF"
}

/** Rule doesn't require value. */
export type JiraFormattingNoValueOperand = {
    __typename?: "JiraFormattingNoValueOperand";
    fieldId: Scalars["String"]["output"];
    operator: JiraFormattingNoValueOperator;
};

export type JiraFormattingNoValueOperandInput = {
    fieldId: Scalars["String"]["input"];
    operator: JiraFormattingNoValueOperator;
};

export enum JiraFormattingNoValueOperator {
    IsEmpty = "IS_EMPTY",
    IsNotEmpty = "IS_NOT_EMPTY"
}

export type JiraFormattingRule = Node & {
    __typename?: "JiraFormattingRule";
    /**
     * Color to be applied if rule matches.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use formattingColor instead
     */
    color: JiraFormattingColor;
    /** Content of this rule. */
    expression: JiraFormattingExpression;
    /** Formatting area of this rule (row or cell). */
    formattingArea: JiraFormattingArea;
    /** Color to be applied if rule matches. */
    formattingColor: JiraColor;
    /** Opaque ID uniquely identifying this rule. */
    id: Scalars["ID"]["output"];
};

export type JiraFormattingRuleConnection = HasPageInfo & {
    __typename?: "JiraFormattingRuleConnection";
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<JiraFormattingRuleEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used for pagination. */
    pageInfo: PageInfo;
};

export type JiraFormattingRuleEdge = {
    __typename?: "JiraFormattingRuleEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The formatting rule at the edge. */
    node?: Maybe<JiraFormattingRule>;
};

export type JiraFormattingRuleExpressionInput = {
    multipleValueOperand?: InputMaybe<JiraFormattingMultipleValueOperandInput>;
    noValueOperand?: InputMaybe<JiraFormattingNoValueOperandInput>;
    singleValueOperand?: InputMaybe<JiraFormattingSingleValueOperandInput>;
    twoValueOperand?: InputMaybe<JiraFormattingTwoValueOperandInput>;
};

/** Rule is evaluated against one value */
export type JiraFormattingSingleValueOperand = {
    __typename?: "JiraFormattingSingleValueOperand";
    fieldId: Scalars["String"]["output"];
    operator: JiraFormattingSingleValueOperator;
    value: Scalars["String"]["output"];
};

export type JiraFormattingSingleValueOperandInput = {
    fieldId: Scalars["String"]["input"];
    operator: JiraFormattingSingleValueOperator;
    value: Scalars["String"]["input"];
};

export enum JiraFormattingSingleValueOperator {
    Contains = "CONTAINS",
    DoesNotContain = "DOES_NOT_CONTAIN",
    DoesNotEqual = "DOES_NOT_EQUAL",
    Equals = "EQUALS",
    GreaterThan = "GREATER_THAN",
    GreaterThanOrEquals = "GREATER_THAN_OR_EQUALS",
    Is = "IS",
    IsAfter = "IS_AFTER",
    IsBefore = "IS_BEFORE",
    IsNot = "IS_NOT",
    IsOnOrAfter = "IS_ON_OR_AFTER",
    IsOnOrBefore = "IS_ON_OR_BEFORE",
    LessThan = "LESS_THAN",
    LessThanOrEquals = "LESS_THAN_OR_EQUALS"
}

/** Rule is evaluated against two values. Value order does matter in this condition. */
export type JiraFormattingTwoValueOperand = {
    __typename?: "JiraFormattingTwoValueOperand";
    fieldId: Scalars["String"]["output"];
    first: Scalars["String"]["output"];
    operator: JiraFormattingTwoValueOperator;
    second: Scalars["String"]["output"];
};

export type JiraFormattingTwoValueOperandInput = {
    fieldId: Scalars["String"]["input"];
    first: Scalars["String"]["input"];
    operator: JiraFormattingTwoValueOperator;
    second: Scalars["String"]["input"];
};

export enum JiraFormattingTwoValueOperator {
    IsBetween = "IS_BETWEEN",
    IsNotBetween = "IS_NOT_BETWEEN"
}

/** The representation for an generic error when the generated JQL was invalid. */
export type JiraGeneratedJqlInvalidError = {
    __typename?: "JiraGeneratedJqlInvalidError";
    /** Error message. */
    message?: Maybe<Scalars["String"]["output"]>;
};

/** WARNING: This type is deprecated and will be removed in the future. DO NOT USE */
export type JiraGenericIssueField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraGenericIssueField";
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        issue?: Maybe<JiraIssue>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        name: Scalars["String"]["output"];
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This type is deprecated
         */
        type: Scalars["String"]["output"];
    };

/** The global issue create modal view types. */
export enum JiraGlobalIssueCreateView {
    /** The global issue create full modal view. */
    FullModal = "FULL_MODAL",
    /** The global issue create mini modal view. */
    MiniModal = "MINI_MODAL"
}

/** A global permission in Jira */
export type JiraGlobalPermission = {
    __typename?: "JiraGlobalPermission";
    /** The description of the permission. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The unique key of the permission. */
    key?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the permission. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JiraGlobalPermissionAddGroupGrantInput = {
    /** The group ari to be added. */
    groupAri: Scalars["ID"]["input"];
    /** The unique key of the permission. */
    key: Scalars["String"]["input"];
};

export type JiraGlobalPermissionAddGroupGrantPayload = Payload & {
    __typename?: "JiraGlobalPermissionAddGroupGrantPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraGlobalPermissionDeleteGroupGrantInput = {
    /** The group ari to be deleted. */
    groupAri: Scalars["ID"]["input"];
    /** The unique key of the permission. */
    key: Scalars["String"]["input"];
};

export type JiraGlobalPermissionDeleteGroupGrantPayload = Payload & {
    __typename?: "JiraGlobalPermissionDeleteGroupGrantPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** All the grants given to a global permission */
export type JiraGlobalPermissionGrants = {
    __typename?: "JiraGlobalPermissionGrants";
    /** Groups granted this global permission. */
    groups?: Maybe<Array<Maybe<JiraGroup>>>;
    /** Is the permission managed by Jira or adminhub */
    isManagedByJira?: Maybe<Scalars["Boolean"]["output"]>;
    /** A global permission */
    permission?: Maybe<JiraGlobalPermission>;
};

export type JiraGlobalPermissionGrantsList = {
    __typename?: "JiraGlobalPermissionGrantsList";
    globalPermissionGrants?: Maybe<Array<Maybe<JiraGlobalPermissionGrants>>>;
};

export type JiraGlobalPermissionGrantsResult =
    | JiraGlobalPermissionGrantsList
    | QueryError;

/** Different Global permissions that the user can have */
export enum JiraGlobalPermissionType {
    /**
     * Create and administer projects, issue types, fields, workflows, and schemes for all projects.
     * Users with this permission can perform most administration tasks, except: managing users,
     * importing data, and editing system email settings.
     */
    Administer = "ADMINISTER",
    /** Users with this permission can see the names of all users and groups on your site. */
    UserPicker = "USER_PICKER"
}

export type JiraGlobalTimeTrackingSettings = {
    __typename?: "JiraGlobalTimeTrackingSettings";
    /** Number of days in a working week */
    daysPerWeek: Scalars["Float"]["output"];
    /** Default unit for time tracking */
    defaultUnit: JiraTimeUnit;
    /** Format for time tracking */
    format: JiraTimeFormat;
    /** Number of hours in a working day */
    hoursPerDay: Scalars["Float"]["output"];
    /** Returns true when time tracking is provided by Jira */
    isTimeTrackingEnabled: Scalars["Boolean"]["output"];
};

/** Represents a goal in Jira */
export type JiraGoal = Node & {
    __typename?: "JiraGoal";
    /** Goal ARI linked to the external entity */
    id: Scalars["ID"]["output"];
    /** Key of the goal */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Name of the goal */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Score of the goal */
    score?: Maybe<Scalars["Float"]["output"]>;
    /** Status of the goal */
    status?: Maybe<JiraGoalStatus>;
    /** Target date of the goal */
    targetDate?: Maybe<Scalars["Date"]["output"]>;
};

/** The connection type for JiraGoal. */
export type JiraGoalConnection = {
    __typename?: "JiraGoalConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraGoalEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraGoal connection. */
export type JiraGoalEdge = {
    __typename?: "JiraGoalEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraGoal>;
};

export enum JiraGoalStatus {
    Archived = "ARCHIVED",
    AtRisk = "AT_RISK",
    Cancelled = "CANCELLED",
    Completed = "COMPLETED",
    Done = "DONE",
    OffTrack = "OFF_TRACK",
    OnTrack = "ON_TRACK",
    Paused = "PAUSED",
    Pending = "PENDING"
}

/** Represents the Goals field on a Jira Issue. */
export type JiraGoalsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraGoalsField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The goals selected on the Issue. */
        selectedGoals?: Maybe<JiraGoalConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the Goals field on a Jira Issue. */
export type JiraGoalsFieldSelectedGoalsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A Jira Background which is a gradient type */
export type JiraGradientBackground = JiraBackground & {
    __typename?: "JiraGradientBackground";
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
    /** The gradient if the background is a gradient type */
    gradientValue?: Maybe<Scalars["String"]["output"]>;
};

/** The unique key of the grant type such as PROJECT_ROLE. */
export type JiraGrantTypeKey = {
    __typename?: "JiraGrantTypeKey";
    /** The key to identify the grant type such as PROJECT_ROLE. */
    key: JiraGrantTypeKeyEnum;
    /** The display name of the grant type key such as Project Role. */
    name: Scalars["String"]["output"];
};

/**
 * The grant type key enum represents all the possible grant types available in Jira.
 * A grant type may take an optional parameter value.
 * For example: PROJECT_ROLE grant type takes project role id as parameter. And, PROJECT_LEAD grant type do not.
 *
 * The actual ARI formats are documented on the various concrete grant type values.
 */
export enum JiraGrantTypeKeyEnum {
    /**
     * The anonymous access represents the public access without logging in.
     * It takes no parameter.
     */
    AnonymousAccess = "ANONYMOUS_ACCESS",
    /**
     * Any user who has the product access.
     * It takes no parameter.
     */
    AnyLoggedinUserApplicationRole = "ANY_LOGGEDIN_USER_APPLICATION_ROLE",
    /**
     * A application role is used to grant a user/group access to the application group.
     * It takes application role as parameter.
     */
    ApplicationRole = "APPLICATION_ROLE",
    /**
     * The issue assignee role.
     * It takes platform defined 'assignee' as parameter to represent the issue field value.
     */
    Assignee = "ASSIGNEE",
    /**
     * A group is a collection of users who can be given access together.
     * It represents group in the organization's user base.
     * It takes group id as parameter.
     */
    Group = "GROUP",
    /**
     * A multi group picker custom field.
     * It takes multi group picker custom field id as parameter.
     */
    MultiGroupPicker = "MULTI_GROUP_PICKER",
    /**
     * A multi user picker custom field.
     * It takes multi user picker custom field id as parameter.
     */
    MultiUserPicker = "MULTI_USER_PICKER",
    /**
     * The project lead role.
     * It takes no parameter.
     */
    ProjectLead = "PROJECT_LEAD",
    /**
     * A role that user/group can play in a project.
     * It takes project role as parameter.
     */
    ProjectRole = "PROJECT_ROLE",
    /**
     * The issue reporter role.
     * It takes platform defined 'reporter' as parameter to represent the issue field value.
     */
    Reporter = "REPORTER",
    /**
     * The grant type defines what the customers can do from the portal view.
     * It takes no parameter.
     */
    ServiceProjectCustomerPortalAccess = "SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS",
    /**
     * An individual user who can be given the access to work on one or more projects.
     * It takes user account id as parameter.
     */
    User = "USER"
}

/** The JiraGrantTypeValue union resolves to one of the concrete types such as JiraDefaultGrantTypeValue, JiraProjectRoleGrantTypeValue. */
export type JiraGrantTypeValue =
    | JiraDefaultGrantTypeValue
    | JiraGroupGrantTypeValue
    | JiraIssueFieldGrantTypeValue
    | JiraProjectRoleGrantTypeValue
    | JiraUserGrantTypeValue;

/** A type to represent one or more paginated list of one or more permission grant values available for a given grant type. */
export type JiraGrantTypeValueConnection = {
    __typename?: "JiraGrantTypeValueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraGrantTypeValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of items matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge object representing grant type value information used within connection object. */
export type JiraGrantTypeValueEdge = {
    __typename?: "JiraGrantTypeValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. */
    node: JiraGrantTypeValue;
};

/** Represents a Jira Group. */
export type JiraGroup = Node & {
    __typename?: "JiraGroup";
    /** Group Id, can be null on group creation */
    groupId: Scalars["String"]["output"];
    /** The global identifier of the group in ARI format. */
    id: Scalars["ID"]["output"];
    /** Name of the Group */
    name: Scalars["String"]["output"];
};

/** The connection type for JiraGroup. */
export type JiraGroupConnection = {
    __typename?: "JiraGroupConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraGroupEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraGroupConnection connection. */
export type JiraGroupEdge = {
    __typename?: "JiraGroupEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraGroup>;
};

/** The GROUP grant type value where group data is provided by identity service. */
export type JiraGroupGrantTypeValue = Node & {
    __typename?: "JiraGroupGrantTypeValue";
    /** The group information such as name, and description. */
    group: JiraGroup;
    /**
     * The ARI to represent the group grant type value.
     * For example: ari:cloud:identity::group/123
     */
    id: Scalars["ID"]["output"];
};

/** Input for Groups values on fields */
export type JiraGroupInput = {
    /** Unique identifier for group field */
    groupName: Scalars["ID"]["input"];
};

/** JiraIssueSearchViewType type that represents a List view with grouping in NIN */
export type JiraGroupedListView = JiraIssueSearchViewMetadata &
    JiraIssueSearchViewType &
    JiraSpreadsheetView &
    JiraView &
    Node & {
        __typename?: "JiraGroupedListView";
        /**
         * Errors which were encountered while fetching the connection.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        error?: Maybe<QueryError>;
        /**
         * A connection of included fields' configurations, grouped where logical (e.g. collapsed fields).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
        /**
         * The tenant specific id of the filter that will be used to get the JiraIssueSearchView
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterId?: Maybe<Scalars["String"]["output"]>;
        /**
         * Retrieves a connection of JiraGroupFieldValue for the current JiraIssueSearchInput.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        groups?: Maybe<JiraSpreadsheetGroupConnection>;
        /**
         * A nullable boolean indicating if the IssueSearchView is using default fieldSets
         * true -> Issue search view is using default fieldSets
         * false -> Issue search view has custom fieldSets
         * null -> Not applicable for requested issue search view
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * An ARI-format value that encodes both namespace and viewId.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * A nullable boolean indicating if the Issue Hierarchy is enabled
         * true -> Issue Hierarchy is enabled
         * false -> Issue Hierarchy is disabled
         * null -> If any error has occured in fetching the preference. The hierarchy will be disabled.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * JQL built from provided search parameters
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        jql?: Maybe<Scalars["String"]["output"]>;
        /**
         * A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        namespace?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use viewSettings instead
         */
        settings?: Maybe<JiraSpreadsheetViewSettings>;
        /**
         * A unique identifier for this view within its namespace, or the global namespace if no namespace is defined.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        viewId?: Maybe<Scalars["String"]["output"]>;
        /**
         * The settings for the JiraIssueSearchView
         * e.g. if the hierarchy is enabled or not or if the hierarchy can be enabled for the current context
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        viewSettings?: Maybe<JiraIssueSearchViewConfigSettings>;
    };

/** JiraIssueSearchViewType type that represents a List view with grouping in NIN */
export type JiraGroupedListViewFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** JiraIssueSearchViewType type that represents a List view with grouping in NIN */
export type JiraGroupedListViewGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupBy?: InputMaybe<Scalars["String"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    options?: InputMaybe<JiraIssueSearchOptions>;
    saveJQLToUserHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
    scope?: InputMaybe<JiraIssueSearchScope>;
};

/** JiraIssueSearchViewType type that represents a List view with grouping in NIN */
export type JiraGroupedListViewViewSettingsArgs = {
    groupBy?: InputMaybe<Scalars["String"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    staticViewInput?: InputMaybe<JiraIssueSearchStaticViewInput>;
};

/** The types of Contexts supported by Groups field. */
export enum JiraGroupsContext {
    /** This corresponds to fields that accepts only "Group" entities as RHS value. */
    Group = "GROUP",
    /** This corresponds to fields that accepts "User" entities as RHS value. */
    User = "USER"
}

/** Represents a multiple selected value on a field. */
export type JiraHasMultipleSelectedValues = {
    /**
     * Paginated list of selectedValue selected in the field or the default array of selectedValue for the field.
     * The server may throw an error if both a forward page (specified with `first`)
     * and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    selectedValues?: Maybe<JiraSelectableValueConnection>;
};

/** Represents a multiple selected value on a field. */
export type JiraHasMultipleSelectedValuesSelectedValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represent a selectable options that can be selected on an Issue or a field. */
export type JiraHasSelectableValueOptions = {
    /**
     * Paginated list of selectedValue options for the field or on an Issue.
     * The server may throw an error if both a forward page (specified with `first`)
     * and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
};

/** Represent a selectable options that can be selected on an Issue or a field. */
export type JiraHasSelectableValueOptionsSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a single selected value on a field. */
export type JiraHasSingleSelectedValue = {
    /**
     * The selectedValue that is selected on the Issue or default selectedValue configured for the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    selectedValue?: Maybe<JiraSelectableValue>;
};

export type JiraHierarchyConfigError = {
    __typename?: "JiraHierarchyConfigError";
    /** This indicates error code */
    code?: Maybe<Scalars["String"]["output"]>;
    /** This indicates error message */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type JiraHierarchyConfigTask = {
    __typename?: "JiraHierarchyConfigTask";
    /** The errors field represents additional query error information if exists. */
    errors?: Maybe<Array<JiraHierarchyConfigError>>;
    /** The field represents a new hierarchy configuration the task was created update. */
    issueHierarchyConfig?: Maybe<Array<JiraIssueHierarchyConfigData>>;
    /** This represents a task progress */
    taskProgress?: Maybe<JiraLongRunningTaskProgress>;
};

/** The Jira Home Page that a user can be directed to. */
export type JiraHomePage = {
    __typename?: "JiraHomePage";
    /** The url link of the home page */
    link?: Maybe<Scalars["String"]["output"]>;
    /** The type of the Home page. */
    type?: Maybe<JiraHomePageType>;
};

/** The different home page types a user can be directed to. */
export enum JiraHomePageType {
    /** The Dashboards home page */
    Dashboards = "DASHBOARDS",
    /** The login redirect page for some anonymous users */
    LoginRedirect = "LOGIN_REDIRECT",
    /** The Projects directory home page */
    ProjectsDirectory = "PROJECTS_DIRECTORY",
    /** The Your Work home page */
    YourWork = "YOUR_WORK"
}

/** The JSM incident priority values */
export enum JiraIncidentPriority {
    P1 = "P1",
    P2 = "P2",
    P3 = "P3",
    P4 = "P4",
    P5 = "P5"
}

/** This is the input argument for initializing the project notification preferences. */
export type JiraInitializeProjectNotificationPreferencesInput = {
    /** The ARI of the project for which the notification preferences are to be initialized. */
    projectId: Scalars["ID"]["input"];
};

/** The response for the mutation to update the project notification preferences. */
export type JiraInitializeProjectNotificationPreferencesPayload = Payload & {
    __typename?: "JiraInitializeProjectNotificationPreferencesPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The user preferences that have been initialized. */
    projectPreferences?: Maybe<JiraNotificationProjectPreferences>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/**
 * DEPRECATED: Banner experiment is no longer active
 *
 * The precondition state of the install-deployments banner for a particular project and user.
 */
export enum JiraInstallDeploymentsBannerPrecondition {
    /** The deployments banner is available but no CI/CD provider is sending deployment data. */
    DeploymentsEmptyState = "DEPLOYMENTS_EMPTY_STATE",
    /** The deployments banner is available but the feature has not been enabled. */
    FeatureNotEnabled = "FEATURE_NOT_ENABLED",
    /** The deployments banner is not available as the precondition checks have not been satisfied. */
    NotAvailable = "NOT_AVAILABLE"
}

/**
 * The representation for an invalid JQL error.
 * E.g. 'project = TMP' where 'TMP' has been deleted.
 */
export type JiraInvalidJqlError = {
    __typename?: "JiraInvalidJqlError";
    /** A list of JQL validation messages. */
    messages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

/**
 * The representation for JQL syntax error.
 * E.g. 'project asd = TMP'.
 */
export type JiraInvalidSyntaxError = {
    __typename?: "JiraInvalidSyntaxError";
    /** The column of the JQL where the JQL syntax error occurred. */
    column?: Maybe<Scalars["Int"]["output"]>;
    /** The error type of this particular syntax error. */
    errorType?: Maybe<JiraJqlSyntaxError>;
    /** The line of the JQL where the JQL syntax error occurred. */
    line?: Maybe<Scalars["Int"]["output"]>;
    /** The specific error message. */
    message?: Maybe<Scalars["String"]["output"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssue = HasMercuryProjectFields &
    JiraScenarioIssueLike &
    Node & {
        __typename?: "JiraIssue";
        /**
         * The user who archived the issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        archivedBy?: Maybe<User>;
        /**
         * The date when the issue was archived.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        archivedOn?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The assignee for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        assigneeField?: Maybe<JiraSingleSelectUserPickerField>;
        /**
         * Paginated list of attachments available on this issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        attachments?: Maybe<JiraAttachmentConnection>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "DevAiIssueScopingResult")' query directive to the 'autodevIssueScopingResult' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        autodevIssueScopingResult?: Maybe<DevAiIssueScopingResult>;
        /**
         * Boolean value to determine if issue can be exported.
         * An issue can be exported or not depends on its classification.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        canBeExported?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Determines whether this issue can have child issues created, i.e. is it not at the lowest hierarchy level in this project
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use JiraIssueEdge.canHaveChildIssues instead
         */
        canHaveChildIssues?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The childIssues within this issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        childIssues?: Maybe<JiraChildIssues>;
        /**
         * Loads the CommandPaletteActions required to render the Command Palette View. It is not intended for general use.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueCommandPaletteActions")' query directive to the 'commandPaletteActions' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        commandPaletteActions?: Maybe<JiraIssueCommandPaletteActionConnection>;
        /**
         * Loads the fields required to render the Command Palette View. It is not intended for general use.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraCommandPaletteFields")' query directive to the 'commandPaletteFields' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        commandPaletteFields?: Maybe<JiraIssueFieldConnection>;
        /**
         * Paginated list of comments available on this issue ordered by the user's activity feed sort order.
         *
         * Supports:
         * * Relay pagination arguments. See: https://relay.dev/graphql/connections.htm#sec-Arguments
         * * Custom set of arguments for targeted queries. A targeted query returns a page of comments containing:
         *   + 'beforeTarget' comments preceding the comment identified by 'targetId'
         *   + The comment identified by the 'targetId' parameter,
         *   + 'afterTarget' comments following the comment identified by 'targetId'
         * * When both targeted queries and standard Relay pagination arguments are passed in, targeted queries takes priority
         * * If 'targetedId' is empty, it will fallback to the standard relay pagination arguments
         *
         * Will return an error in any of the following cases:
         * * The 'first' and 'last' parameters are both provided.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        comments?: Maybe<JiraCommentConnection>;
        /**
         * Returns the configuration URL for the project the issue resides in, so long as the user has permission to configure it.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        configurationUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * Loads the confluence pages this issue is mentioned on.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueConfluenceMentionedLinks")' query directive to the 'confluenceMentionedLinks' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        confluenceMentionedLinks?: Maybe<JiraConfluenceRemoteIssueLinkConnection>;
        /**
         * Returns content panels for Connect Issue Content module.
         * See https://developer.atlassian.com/cloud/jira/platform/modules/issue-content/
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        contentPanels?: Maybe<JiraIssueContentPanelConnection>;
        /**
         * Card cover media used in Jira Work Management for Issue and Board views of issues.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         *
         * @deprecated Replaced by the generic jiraCoverMedia field
         */
        coverMedia?: Maybe<JiraWorkManagementBackground>;
        /**
         * The creation date and time for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        createdField?: Maybe<JiraDateTimePickerField>;
        /**
         * The deployments summary. Contains summary of all deployment provider data.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Superseded by the devOpsSummarisedEntities field
         */
        deploymentsSummary?: Maybe<DevOpsSummarisedDeployments>;
        /**
         * The description for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        descriptionField?: Maybe<JiraRichTextField>;
        /**
         * Returns UX designs associated to this Jira issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "GraphStoreIssueAssociatedDesign")' query directive to the 'designs' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        designs?: Maybe<GraphStoreSimplifiedIssueAssociatedDesignConnection>;
        /**
         * The SCM development-info entities (pull requests, branches, commits) associated with a Jira issue.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: JiraIssueDevInfoDetails` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        devInfoDetails?: Maybe<JiraIssueDevInfoDetails>;
        /**
         * Contains summary information for DevOps entities. Currently supports deployments and feature flags.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        devOpsSummarisedEntities?: Maybe<DevOpsSummarisedEntities>;
        /**
         * The dev summary cache. This could be stale.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        devSummaryCache?: Maybe<JiraIssueDevSummaryResult>;
        /**
         * The duedate for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        dueDateField?: Maybe<JiraDatePickerField>;
        /**
         * End Date field configured for the view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'endDateViewField' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        endDateViewField?: Maybe<JiraIssueField>;
        /**
         * Indicates that there was at least one error in retrieving data for this Jira issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Intended only for feature parity with legacy experiences.
         */
        errorRetrievingData?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * It is dangerous to request system fields in this manner. It may return a custom field with a name that matches the
         * id of the system field you are requesting. See https://ops.internal.atlassian.com/jira/browse/HOT-114865. Instead,
         * create a dedicated data fetcher under JiraIssue using JiraIssueFieldDataFetcherFactory.
         * Retrieves a single field from JiraIssueFields based on the provided field ID or alias.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldByIdOrAlias")' query directive to the 'fieldByIdOrAlias' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        fieldByIdOrAlias?: Maybe<JiraIssueField>;
        /**
         * Loads all field sets relevant to the current context for the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated New schema in development right now. This is incomplete.
         */
        fieldSets?: Maybe<JiraIssueFieldSetConnection>;
        /**
         * Loads the given field sets for the JiraIssue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldSetsById?: Maybe<JiraIssueFieldSetConnection>;
        /**
         * Loads all field sets for a specified JiraIssueSearchView.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldSetsForIssueSearchView?: Maybe<JiraIssueFieldSetConnection>;
        /**
         * Loads the fields required to render the Issue View. It is not intended for general use.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * **Deprecated**: No replacement as of deprecation - this API contains opaque business logic specific to the issue-view app and is likely to change without notice.
         * It will eventually be replaced with a more declarative layout API for the Issue-View App.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated No replacement as of deprecation - this API contains opaque business logic specific to the issue-view app and is likely to change without notice. It will eventually be replaced with a more declarative layout API for the Issue-View App.
         */
        fields?: Maybe<JiraIssueFieldConnection>;
        /**
         * Paginated list of fields available on this issue. Allows clients to specify fields by their identifier.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldsById?: Maybe<JiraIssueFieldConnection>;
        /**
         * Retrieves a list of JiraIssueFields. Maximum 100 fields can be requested at once.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldsByIdOrAlias")' query directive to the 'fieldsByIdOrAlias' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        fieldsByIdOrAlias?: Maybe<Array<Maybe<JiraIssueField>>>;
        /**
         * Returns the connection of groups that the current issue belongs to.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueGroupsByFieldId")' query directive to the 'groupsByFieldId' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        groupsByFieldId?: Maybe<JiraSpreadsheetGroupConnection>;
        /**
         * Boolean value to determine if an issue in issue search has any children.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use JiraIssueEdge.hasChildren instead
         */
        hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Whether the content panels have been customised on this issue by the user, by hiding/displaying them using actions on
         * the Issue View UI.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasCustomisedContentPanels?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Fetches if the user has the queried project permission for the issue's project
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasProjectPermission?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasRelationshipToVersion?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Returns the hierarchy info that's directly above the current issue's hierarchy.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hierarchyLevelAbove?: Maybe<JiraIssueTypeHierarchyLevel>;
        /**
         * Returns the hierarchy info that's directly below the current issue's hierarchy.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hierarchyLevelBelow?: Maybe<JiraIssueTypeHierarchyLevel>;
        /**
         * Unique identifier associated with this Issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The incident action items associated with this issue (the issue is assumed to be a Jira Service Management incident).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        incidentActionItems?: Maybe<GraphIncidentHasActionItemRelationshipConnection>;
        /**
         * The JSW issues linked with this issue (the issue is assumed to be a Jira Service Management incident).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        incidentLinkedJswIssues?: Maybe<GraphIncidentLinkedJswIssueRelationshipConnection>;
        /**
         * Is the issue active or archived.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isArchived?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Whether this Issue has a value for the Resolution field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isResolved?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The issue color field for the given issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueColorField?: Maybe<JiraColorField>;
        /**
         * Issue ID in numeric format. E.g. 10000
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueId: Scalars["String"]["output"];
        /**
         * Paginated list of issue links available on this issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueLinks?: Maybe<JiraIssueLinkConnection>;
        /**
         * Retrieves an issue property set on this issue.
         *
         * If a matching issue property is not found, then a null value will be returned.
         * Otherwise the issue property value will be returned which can be any valid JSON value.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issuePropertyByKey?: Maybe<Scalars["JSON"]["output"]>;
        /**
         * The issue restriction field for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueRestrictionField?: Maybe<JiraIssueRestrictionField>;
        /**
         * The avatar url for the issue type of issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueTypeAvatarUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * The issueType for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueTypeField?: Maybe<JiraIssueTypeField>;
        /**
         * Returns the issue types within the same project and are directly above the current issue's hierarchy.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueTypesForHierarchyAbove?: Maybe<JiraIssueTypeConnection>;
        /**
         * Returns the issue types within the same project and are directly below the current issue's hierarchy.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueTypesForHierarchyBelow?: Maybe<JiraIssueTypeConnection>;
        /**
         * Returns the issue types within the same project that are at the same level as the current issue's hierarchy.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueTypesForHierarchySame?: Maybe<JiraIssueTypeConnection>;
        /**
         * Card cover media used in Jira for Issue and Board views of issues.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         *
         */
        jiraCoverMedia?: Maybe<JiraBackground>;
        /**
         * The {projectKey}-{issueNumber} associated with this Issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        key: Scalars["String"]["output"];
        /**
         * Time of last redaction
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastRedactionTime?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The timestamp of this issue was last viewed by the current user (reference to Unix Epoch time in ms).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
        /**
         * Returns legacy content panels (defined using the Web Panel module if the location is 'atl.jira.view.issue.left.context').
         * This will return an empty Connection if the app to which these content panels belong has defined an Issue Content module.
         * See https://developer.atlassian.com/cloud/jira/platform/modules/web-panel/
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use contentPanels instead.
         */
        legacyContentPanels?: Maybe<JiraIssueContentPanelConnection>;
        /**
         * The state in which the issue is currently.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated the decision regarding field name and type have been revised for issue archival. isArchived field has been added instead.
         */
        lifecycleState?: Maybe<JiraIssueLifecycleState>;
        /**
         * Contains the token information for reading media content.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraMediaReadTokenInIssue")' query directive to the 'mediaReadToken' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        mediaReadToken?: Maybe<JiraMediaReadToken>;
        /**
         * Contains the token information for uploading media content.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraMediaUploadTokenInIssue")' query directive to the 'mediaUploadToken' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        mediaUploadToken?: Maybe<JiraMediaUploadTokenResult>;
        /**
         * The avatar url for the type of Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectIcon?: Maybe<Scalars["URL"]["output"]>;
        /**
         * An optional displayable key or ID of the item in the remote system, e.g. for Jira this will be the issue key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectKey?: Maybe<Scalars["String"]["output"]>;
        /**
         * The name of the Mercury Project which is either an Atlas Project or Jira Issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectName?: Maybe<Scalars["String"]["output"]>;
        /**
         * The owner of the Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectOwner?: Maybe<User>;
        /**
         * The product name providing the information for the Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectProviderName?: Maybe<Scalars["String"]["output"]>;
        /**
         * The status of the Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectStatus?: Maybe<MercuryProjectStatus>;
        /**
         * The browser clickable link of the Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryProjectUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * The target date set for a Mercury Project.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use mercuryTargetDateStart and mercuryTargetDateEnd instead
         */
        mercuryTargetDate?: Maybe<Scalars["String"]["output"]>;
        /**
         * The target date end set to the very end of the day for a Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryTargetDateEnd?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The target date start set to the very start of the day for a Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryTargetDateStart?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The type of date set for a Mercury Project.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mercuryTargetDateType?: Maybe<MercuryProjectTargetDateType>;
        /**
         * The parent issue (in terms of issue hierarchy) for the given issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        parentIssueField?: Maybe<JiraParentIssueField>;
        /**
         * Plan scenario data for the values
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'planScenarioValues' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        planScenarioValues?: Maybe<JiraScenarioIssueValues>;
        /**
         * The post-incident review links associated with this issue (the issue is assumed to be a Jira Service Management incident).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        postIncidentReviewLinks?: Maybe<GraphIncidentAssociatedPostIncidentReviewLinkRelationshipConnection>;
        /**
         * The priority for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        priorityField?: Maybe<JiraPriorityField>;
        /**
         * The project field for the given issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        projectField?: Maybe<JiraProjectField>;
        /**
         * Returns the type of comment visibility option based on Project Role which the user is part of.
         * Role type for user having RoleId, ARI Id and Role name.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraProjectRoleVisibilities")' query directive to the 'projectRoleCommentVisibilities' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        projectRoleCommentVisibilities?: Maybe<JiraRoleConnection>;
        /**
         * List of distinct issue fields that have been redacted
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        redactedFields?: Maybe<JiraFieldConnection>;
        /**
         * List of redactions on an issue. A field can have multiple redactions.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        redactions?: Maybe<JiraRedactionConnection>;
        /**
         * The reporter for an issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        reporter?: Maybe<User>;
        /**
         * The date and time of resolution for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        resolutionDateField?: Maybe<JiraDateTimePickerField>;
        /**
         * The resolution for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        resolutionField?: Maybe<JiraResolutionField>;
        /**
         * Returns the ID of the screen the issue is on.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated The screen concept has been deprecated, and is only used for legacy reasons.
         */
        screenId?: Maybe<Scalars["Long"]["output"]>;
        /**
         * Contexts that define the relative positions of the current issue within specific search inputs,
         * such as its placement in the results of a particular JQL query or under a specific parent issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraListComponent-M1.2")' query directive to the 'searchViewContext' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        searchViewContext?: Maybe<JiraIssueSearchViewContexts>;
        /**
         * The security level field for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        securityLevelField?: Maybe<JiraSecurityLevelField>;
        /**
         * Returns a JiraADF value of the summarised comments and description of an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        smartSummary?: Maybe<JiraAdf>;
        /**
         * The start date for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        startDateField?: Maybe<JiraDatePickerField>;
        /**
         * Start Date field configured for the view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'startDateViewField' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        startDateViewField?: Maybe<JiraIssueField>;
        /**
         * The status category for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCategory?: Maybe<JiraStatusCategory>;
        /**
         * The status for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusField?: Maybe<JiraStatusField>;
        /**
         * The story point estimate field for the given issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        storyPointEstimateField?: Maybe<JiraNumberField>;
        /**
         * The story points field for the given issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        storyPointsField?: Maybe<JiraNumberField>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldValueSuggestion")' query directive to the 'suggestFieldValues' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        suggestFieldValues?: Maybe<JiraSuggestedIssueFieldValuesResult>;
        /**
         * The summarised build associated with the issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        summarisedBuilds?: Maybe<DevOpsSummarisedBuilds>;
        /**
         * The summarised deployments associated with the issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        summarisedDeployments?: Maybe<DevOpsSummarisedDeployments>;
        /**
         * The summarised feature flags associated with the issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        summarisedFeatureFlags?: Maybe<DevOpsSummarisedFeatureFlags>;
        /**
         * The summary for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        summary?: Maybe<Scalars["String"]["output"]>;
        /**
         * The summary for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        summaryField?: Maybe<JiraSingleLineTextField>;
        /**
         * The timeTracking field for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        timeTrackingField?: Maybe<JiraTimeTrackingField>;
        /**
         * The updated date and time for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        updatedField?: Maybe<JiraDateTimePickerField>;
        /**
         * The votes field for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        votesField?: Maybe<JiraVotesField>;
        /**
         * The watches field for an issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        watchesField?: Maybe<JiraWatchesField>;
        /**
         * The browser clickable link of this Issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        webUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * Paginated list of worklogs available on this issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        worklogs?: Maybe<JiraWorkLogConnection>;
    };

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueAttachmentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    sortBy?: InputMaybe<JiraAttachmentSortInput>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueCanHaveChildIssuesArgs = {
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueCommandPaletteActionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueCommandPaletteFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    afterTarget?: InputMaybe<Scalars["Int"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    beforeTarget?: InputMaybe<Scalars["Int"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    rootCommentsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    sortBy?: InputMaybe<JiraCommentSortInput>;
    targetId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueConfluenceMentionedLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueContentPanelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueDesignsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueEndDateViewFieldArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldByIdOrAliasArgs = {
    idOrAlias?: InputMaybe<Scalars["String"]["input"]>;
    ignoreMissingField?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldSetsByIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    fieldSetIds: Array<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldSetsForIssueSearchViewArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    context?: InputMaybe<JiraIssueSearchViewFieldSetsContext>;
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldsByIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueFieldsByIdOrAliasArgs = {
    idsOrAliases: Array<InputMaybe<Scalars["String"]["input"]>>;
    ignoreMissingFields?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueGroupsByFieldIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    fieldId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    firstNGroupsToSearch?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueHasChildrenArgs = {
    filterByProjectKeys?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    jql?: InputMaybe<Scalars["String"]["input"]>;
    viewConfigInput?: InputMaybe<JiraIssueSearchViewConfigInput>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueHasProjectPermissionArgs = {
    permission: JiraProjectPermissionType;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueHasRelationshipToVersionArgs = {
    versionId: Scalars["ID"]["input"];
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueIssueLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueIssuePropertyByKeyArgs = {
    key: Scalars["String"]["input"];
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueLegacyContentPanelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueMediaReadTokenArgs = {
    maxTokenLength: Scalars["Int"]["input"];
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssuePlanScenarioValuesArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueProjectRoleCommentVisibilitiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueRedactedFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueRedactionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    sortBy?: InputMaybe<JiraRedactionSortInput>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueSearchViewContextArgs = {
    isGroupingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    isHierarchyEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    searchViewContextInput: JiraIssueSearchViewContextInput;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueStartDateViewFieldArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueSuggestFieldValuesArgs = {
    filterProjectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Jira Issue node. Includes the Issue data displayable in the current User context. */
export type JiraIssueWorklogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * This type is a temporary type and will be replaced at some time in the future
 * hen jira.issueById is prod ready
 */
export type JiraIssueAndProject = {
    __typename?: "JiraIssueAndProject";
    /**
     *  this field should be deprecated however its interfering with tooling that
     *  introspects and causes JiraIssueAndProject to become an empty type and hence invalid
     *  so one field has been left in place
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issueId: Scalars["ID"]["output"];
    /**
     * @deprecated(reason: "Will be replaced by jiraQuery.issueById ")
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Will be replaced by jiraQuery.issueById
     */
    projectId: Scalars["ID"]["output"];
};

/** Summary of the Branches attached to the issue */
export type JiraIssueBranchDevSummary = {
    __typename?: "JiraIssueBranchDevSummary";
    /** Total number of Branches for the issue */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Date at which this summary was last updated */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Container for the summary of the Branches attached to the issue */
export type JiraIssueBranchDevSummaryContainer = {
    __typename?: "JiraIssueBranchDevSummaryContainer";
    /** The actual summary of the Branches attached to the issue */
    overall?: Maybe<JiraIssueBranchDevSummary>;
    /** Count of Branches aggregated per provider */
    summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The container of SCM branches info associated with a Jira issue. */
export type JiraIssueBranches = {
    __typename?: "JiraIssueBranches";
    /** A list of config errors of underlined data-providers providing commit details. */
    configErrors?: Maybe<Array<JiraDevInfoConfigError>>;
    /**
     * A list of branches details from the original SCM providers.
     * Maximum of 50 branches will be returned.
     */
    details?: Maybe<Array<JiraDevOpsBranchDetails>>;
};

/** Summary of the Builds attached to the issue */
export type JiraIssueBuildDevSummary = {
    __typename?: "JiraIssueBuildDevSummary";
    /** Total number of Builds for the issue */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Number of failed buids for the issue */
    failedBuildCount?: Maybe<Scalars["Int"]["output"]>;
    /** Date at which this summary was last updated */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Number of successful buids for the issue */
    successfulBuildCount?: Maybe<Scalars["Int"]["output"]>;
    /** Number of buids with unknown result for the issue */
    unknownBuildCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Container for the summary of the Builds attached to the issue */
export type JiraIssueBuildDevSummaryContainer = {
    __typename?: "JiraIssueBuildDevSummaryContainer";
    /** The actual summary of the Builds attached to the issue */
    overall?: Maybe<JiraIssueBuildDevSummary>;
    /** Count of Builds aggregated per provider */
    summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** Represents a failed operation on a Jira Issue as part of a bulk operation. */
export type JiraIssueBulkOperationFailure = {
    __typename?: "JiraIssueBulkOperationFailure";
    /** List of reasons for failure. */
    failureReasons?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Failed Jira Issue. */
    issue?: Maybe<JiraIssue>;
};

/** The connection type for JiraIssueBulkOperationFailure. */
export type JiraIssueBulkOperationFailureConnection = {
    __typename?: "JiraIssueBulkOperationFailureConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueBulkOperationFailureEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraIssueBulkOperationFailure connection. */
export type JiraIssueBulkOperationFailureEdge = {
    __typename?: "JiraIssueBulkOperationFailureEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueBulkOperationFailure>;
};

/** Represents progress of a bulk operation on Jira Issues. */
export type JiraIssueBulkOperationProgress = {
    __typename?: "JiraIssueBulkOperationProgress";
    /**
     * Failures in the bulk operation.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use failedAccessibleIssues instead
     */
    bulkOperationFailures?: Maybe<JiraIssueBulkOperationFailureConnection>;
    /**
     * Successfully updated Jira Issues.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use processedAccessibleIssues instead
     */
    editedAccessibleIssues?: Maybe<JiraIssueConnection>;
    /**
     * Number of successful issues that cannot be mapped due to permission errors or issues do not exist anymore
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use invalidOrInaccessibleIssueCount instead
     */
    editedInaccessibleIssueCount?: Maybe<Scalars["Int"]["output"]>;
    /** Failures in the bulk operation. */
    failedAccessibleIssues?: Maybe<JiraIssueBulkOperationFailureConnection>;
    /** Number of successful issues that cannot be mapped due to permission errors or issues do not exist anymore */
    invalidOrInaccessibleIssueCount?: Maybe<Scalars["Int"]["output"]>;
    /** Successfully updated Jira Issues. */
    processedAccessibleIssues?: Maybe<JiraIssueConnection>;
    /** Percentage of issues completed. */
    progress?: Maybe<Scalars["Long"]["output"]>;
    /** Start time of bulk operation task. */
    startTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** Status of bulk operation task. */
    status?: Maybe<JiraLongRunningTaskStatus>;
    /**
     * Successfully updated Jira Issues.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use editedAccessibleIssues instead
     */
    successfulIssues?: Maybe<JiraIssueConnection>;
    /**
     * Number of successful issues that cannot be mapped due to permission errors or issues do not exist anymore
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use editedInaccessibleIssueCount instead
     */
    successfulUnmappableIssuesCount?: Maybe<Scalars["Int"]["output"]>;
    /** ID of bulk operation task. */
    taskId?: Maybe<Scalars["ID"]["output"]>;
    /** Total number of issues in bulk operation */
    totalIssueCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Number of successfully updated issues (excluding issues the request is unauthorised to view)
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use successfulUnmappableIssuesCount instead
     */
    unauthorisedSuccessfulIssueCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents progress of a bulk operation on Jira Issues. */
export type JiraIssueBulkOperationProgressBulkOperationFailuresArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents progress of a bulk operation on Jira Issues. */
export type JiraIssueBulkOperationProgressEditedAccessibleIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents progress of a bulk operation on Jira Issues. */
export type JiraIssueBulkOperationProgressFailedAccessibleIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents progress of a bulk operation on Jira Issues. */
export type JiraIssueBulkOperationProgressProcessedAccessibleIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents progress of a bulk operation on Jira Issues. */
export type JiraIssueBulkOperationProgressSuccessfulIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Holds additional metadata for Jira Issue bulk operations */
export type JiraIssueBulkOperationsMetadata = {
    __typename?: "JiraIssueBulkOperationsMetadata";
    /** Maximum number of issues a single bulk operation can have */
    maxNumberOfIssues?: Maybe<Scalars["Long"]["output"]>;
};

/**
 * Represents the common structure across Issue Command Palette Actions.
 * This may be converted to an interface when more actions are added
 */
export type JiraIssueCommandPaletteAction = {
    id: Scalars["ID"]["output"];
};

/** The connection type for JiraIssueCommandPaletteAction. */
export type JiraIssueCommandPaletteActionConnection = {
    __typename?: "JiraIssueCommandPaletteActionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueCommandPaletteActionEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraIssueCommandPaletteActionConnectionResult =
    | JiraIssueCommandPaletteActionConnection
    | QueryError;

/** An edge in a JiraIssueCommandPaletteAction connection. */
export type JiraIssueCommandPaletteActionEdge = {
    __typename?: "JiraIssueCommandPaletteActionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueCommandPaletteAction>;
};

/** Error extension which gets thrown when an unsupported CommandPaletteAction is encountered. */
export type JiraIssueCommandPaletteActionUnsupportedErrorExtension =
    QueryErrorExtension & {
        __typename?: "JiraIssueCommandPaletteActionUnsupportedErrorExtension";
        /**
         * Application specific error type
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * A numerical code (such as a HTTP status code) representing the error category
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

/** Represents the Issue Command Palette Action to update a field. */
export type JiraIssueCommandPaletteUpdateFieldAction =
    JiraIssueCommandPaletteAction &
        Node & {
            __typename?: "JiraIssueCommandPaletteUpdateFieldAction";
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            field: JiraIssueField;
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            id: Scalars["ID"]["output"];
        };

/** Summary of the Commits attached to the issue */
export type JiraIssueCommitDevSummary = {
    __typename?: "JiraIssueCommitDevSummary";
    /** Total number of Commits for the issue */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Date at which this summary was last updated */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Container for the summary of the Commits attached to the issue */
export type JiraIssueCommitDevSummaryContainer = {
    __typename?: "JiraIssueCommitDevSummaryContainer";
    /** The actual summary of the Commits attached to the issue */
    overall?: Maybe<JiraIssueCommitDevSummary>;
    /** Count of Commits aggregated per provider */
    summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The container of SCM commits info associated with a Jira issue. */
export type JiraIssueCommits = {
    __typename?: "JiraIssueCommits";
    /** A list of config errors of underlined data-providers providing branches details. */
    configErrors?: Maybe<Array<JiraDevInfoConfigError>>;
    /**
     * A list of commits details from the original SCM providers.
     * Maximum of 50 latest created commits will be returned.
     */
    details?: Maybe<Array<JiraDevOpsCommitDetails>>;
};

/** The connection type for JiraIssue. */
export type JiraIssueConnection = {
    __typename?: "JiraIssueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueEdge>>>;
    /** Returns the reason why the connection is empty. */
    emptyConnectionReason?: Maybe<JiraEmptyConnectionReason>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Returns whether or not there were more issues available for a given issue search.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    isCappingIssueSearchResult?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Extra page information for the issue navigator.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    issueNavigatorPageInfo?: Maybe<JiraIssueNavigatorPageInfo>;
    /**
     * The error that occurred during an issue search.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    issueSearchError?: Maybe<JiraIssueSearchError>;
    /** jql if issues are returned by jql. This field will have value only when the context has jql */
    jql?: Maybe<Scalars["String"]["output"]>;
    /**
     * Cursors to help with random access pagination.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    pageCursors?: Maybe<JiraPageCursors>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The total number of issues for a given JQL search.
     * This number will be capped based on the server's configured limit.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    totalIssueSearchResultCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for JiraIssue. */
export type JiraIssueConnectionPageCursorsArgs = {
    maxCursors: Scalars["Int"]["input"];
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraIssueContentPanel = {
    __typename?: "JiraIssueContentPanel";
    /** The add-on key of the owning connect module. */
    addonKey?: Maybe<Scalars["String"]["output"]>;
    /** The icon to be displayed in quick-add buttons. */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** Whether the panel should be shown by default. */
    isShownByDefault?: Maybe<Scalars["Boolean"]["output"]>;
    /** The add-on key of the owning connect module. */
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    /** The name of the panel. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** An opaque JSON blob containing metadata to be forwarded to the Connect frontend module */
    options?: Maybe<Scalars["JSON"]["output"]>;
    /** Text to be shown when a user mouses over Quick-add buttons. This may be empty. */
    tooltip?: Maybe<Scalars["String"]["output"]>;
    /** Provides differentiation between types of modules. */
    type?: Maybe<JiraIssueModuleType>;
    /** Whether the user manually added the content panel to the issue via the Issue View UI. */
    wasManuallyAddedToIssue?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JiraIssueContentPanelConnection = {
    __typename?: "JiraIssueContentPanelConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueContentPanelEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraIssueBulkOperationFailure connection. */
export type JiraIssueContentPanelEdge = {
    __typename?: "JiraIssueContentPanelEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueContentPanel>;
};

/** Represents the input data required for Jira issue creation. */
export type JiraIssueCreateInput = {
    /** Field data to populate the created issue with. Mandatory due to required fields such as Summary. */
    fields: JiraIssueFieldsInput;
    /** Issue type of issue to create, encoded as an ARI */
    issueTypeId: Scalars["ID"]["input"];
    /** Project to create issue within, encoded as an ARI */
    projectId: Scalars["ID"]["input"];
    /** Rank Issue following creation */
    rank?: InputMaybe<JiraIssueCreateRankInput>;
};

/** Represents the payload of the JWM Create Issue mutation. */
export type JiraIssueCreatePayload = Payload & {
    __typename?: "JiraIssueCreatePayload";
    /** A list of errors that occurred when trying to create the issue. */
    errors?: Maybe<Array<MutationError>>;
    /** The issue after it has been created, this will be null if create failed */
    issue?: Maybe<JiraIssue>;
    /** Whether the issue was updated successfully. */
    success: Scalars["Boolean"]["output"];
};

export type JiraIssueCreateRankInput = {
    /** ID of Issue after which the created issue should be ranked. Encoded as an ARI. Cannot be sent alongside before. */
    afterIssueId?: InputMaybe<Scalars["ID"]["input"]>;
    /** ID of Issue before which the created issue should be ranked. Encoded as an ARI. Cannot be sent alongside after. */
    beforeIssueId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Types shared between IssueSubscriptions and JwmSubscriptions */
export type JiraIssueCreatedStreamHubPayload = {
    __typename?: "JiraIssueCreatedStreamHubPayload";
    /** The created issue's ARI. */
    resource?: Maybe<Scalars["ID"]["output"]>;
};

export type JiraIssueDeletedStreamHubPayload = {
    __typename?: "JiraIssueDeletedStreamHubPayload";
    /** The deleted issue's ARI. */
    resource?: Maybe<Scalars["ID"]["output"]>;
};

export type JiraIssueDeploymentEnvironment = {
    __typename?: "JiraIssueDeploymentEnvironment";
    /** State of the deployment */
    status?: Maybe<JiraIssueDeploymentEnvironmentState>;
    /** Title of the deployment environment */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Summary of the Deployment Environments attached to the issue */
export type JiraIssueDeploymentEnvironmentDevSummary = {
    __typename?: "JiraIssueDeploymentEnvironmentDevSummary";
    /** Total number of Reviews for the issue */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Date at which this summary was last updated */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** A list of the top environment there was a deployment on */
    topEnvironments?: Maybe<Array<JiraIssueDeploymentEnvironment>>;
};

/** Container for the summary of the Deployment Environments attached to the issue */
export type JiraIssueDeploymentEnvironmentDevSummaryContainer = {
    __typename?: "JiraIssueDeploymentEnvironmentDevSummaryContainer";
    /** The actual summary of the Deployment Environments attached to the issue */
    overall?: Maybe<JiraIssueDeploymentEnvironmentDevSummary>;
    /** Count of Deployment Environments aggregated per provider */
    summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** Possible states for a deployment environment */
export enum JiraIssueDeploymentEnvironmentState {
    /** The deployment was deployed successfully */
    Deployed = "DEPLOYED",
    /** The deployment was not deployed successfully */
    NotDeployed = "NOT_DEPLOYED"
}

/** The SCM entities (pullrequest, branches or commits) associated with a Jira issue. */
export type JiraIssueDevInfoDetails = {
    __typename?: "JiraIssueDevInfoDetails";
    /** Created SCM branches associated with a Jira issue. */
    branches?: Maybe<JiraIssueBranches>;
    /** Created SCM commits associated with a Jira issue. */
    commits?: Maybe<JiraIssueCommits>;
    /** Created pull-requests associated with a Jira issue. */
    pullRequests?: Maybe<JiraIssuePullRequests>;
};

/** Lists the summaries available for each type of dev info, for a given issue */
export type JiraIssueDevSummary = {
    __typename?: "JiraIssueDevSummary";
    /** Summary of the Branches attached to the issue */
    branch?: Maybe<JiraIssueBranchDevSummaryContainer>;
    /** Summary of the Builds attached to the issue */
    build?: Maybe<JiraIssueBuildDevSummaryContainer>;
    /** Summary of the Commits attached to the issue */
    commit?: Maybe<JiraIssueCommitDevSummaryContainer>;
    /**
     * Summary of the deployment environments attached to some builds.
     * This is a legacy attribute only used by Bamboo builds
     */
    deploymentEnvironments?: Maybe<JiraIssueDeploymentEnvironmentDevSummaryContainer>;
    /** Summary of the Pull Requests attached to the issue */
    pullrequest?: Maybe<JiraIssuePullRequestDevSummaryContainer>;
    /** Summary of the Reviews attached to the issue */
    review?: Maybe<JiraIssueReviewDevSummaryContainer>;
};

/** Aggregates the `count` of entities for a given provider */
export type JiraIssueDevSummaryByProvider = {
    __typename?: "JiraIssueDevSummaryByProvider";
    /** Number of entities associated with that provider */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Provider name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** UUID for a given provider, to allow aggregation */
    providerId?: Maybe<Scalars["String"]["output"]>;
};

/** Error when querying the JiraIssueDevSummary */
export type JiraIssueDevSummaryError = {
    __typename?: "JiraIssueDevSummaryError";
    /** Information about the provider that triggered the error */
    instance?: Maybe<JiraIssueDevSummaryErrorProviderInstance>;
    /** A message describing the error */
    message?: Maybe<Scalars["String"]["output"]>;
};

/** Basic information on a provider that triggered an error */
export type JiraIssueDevSummaryErrorProviderInstance = {
    __typename?: "JiraIssueDevSummaryErrorProviderInstance";
    /** Base URL of the provider's instance that failed */
    baseUrl?: Maybe<Scalars["String"]["output"]>;
    /** Provider's name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Provider's type */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Container for the Dev Summary of an issue */
export type JiraIssueDevSummaryResult = {
    __typename?: "JiraIssueDevSummaryResult";
    /**
     * Returns "non-transient errors". That is, configuration errors that require admin intervention to be solved.
     * This returns an empty collection when called for users that are not administrators or system administrators.
     */
    configErrors?: Maybe<Array<JiraIssueDevSummaryError>>;
    /** Contains all available summaries for the issue */
    devSummary?: Maybe<JiraIssueDevSummary>;
    /**
     * Returns "transient errors". That is, errors that may be solved by retrying the fetch operation.
     * This excludes configuration errors that require admin intervention to be solved.
     */
    errors?: Maybe<Array<JiraIssueDevSummaryError>>;
};

/** An edge in a JiraIssue connection. */
export type JiraIssueEdge = {
    __typename?: "JiraIssueEdge";
    /**
     * Determines whether this issue can have child issues created, i.e. is it not at the lowest hierarchy level in this project
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSpreadsheetComponent-M2")' query directive to the 'canHaveChildIssues' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    canHaveChildIssues?: Maybe<Scalars["Boolean"]["output"]>;
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /**
     * Loads all field sets for a specified configuration that needs to be specified at the top level query.
     * If no configuration is provided, then this field will return null.
     * The expected configuration input should be of type JiraIssueSearchFieldSetsInput.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSpreadsheetComponent-M1")' query directive to the 'fieldSets' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    fieldSets?: Maybe<JiraIssueFieldSetConnection>;
    /**
     * Boolean value to determine if an issue in issue search has any children. filterByProjectKeys is used to filter resulting list by issues belonging to provided projects. If it's null or empty, no filter is applied
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSpreadsheetComponent-M2")' query directive to the 'hasChildren' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraIssue>;
};

/** An edge in a JiraIssue connection. */
export type JiraIssueEdgeCanHaveChildIssuesArgs = {
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** An edge in a JiraIssue connection. */
export type JiraIssueEdgeFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An edge in a JiraIssue connection. */
export type JiraIssueEdgeHasChildrenArgs = {
    filterByProjectKeys?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
};

export type JiraIssueExpandedGroup = {
    /** The field value used to group issues. */
    fieldValue?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The number of issues to fetch to determine the position of the current issue.
     * If not specified, it is up to the server to determine a default limit.
     */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** The JQL that's used to fetch issues for the group. */
    jql: Scalars["String"]["input"];
};

export type JiraIssueExpandedGroups = {
    /** The ID of the field used to group issues in the current view. */
    groupedByFieldId: Scalars["String"]["input"];
    groups?: InputMaybe<Array<JiraIssueExpandedGroup>>;
};

export type JiraIssueExpandedParent = {
    /**
     * The number of issues to fetch to determine the position of the current issue.
     * If not specified, it is up to the server to determine a default limit.
     */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** The id of the issue that's expanded. */
    parentIssueId: Scalars["String"]["input"];
};

/** Indicates an error occurring during submission or execution of an export task. */
export type JiraIssueExportError = {
    __typename?: "JiraIssueExportError";
    /** Localized message for displaying to the user. */
    displayMessage?: Maybe<Scalars["String"]["output"]>;
    /** Error type from the AggErrorType enum. */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /** Error status code (e.g., 400 for bad request, 404 for not found, 499 for client cancelled request and 500 for internal server error). */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** The types of events published to the onIssueExported subscription. */
export type JiraIssueExportEvent =
    | JiraIssueExportTaskCompleted
    | JiraIssueExportTaskProgress
    | JiraIssueExportTaskSubmitted
    | JiraIssueExportTaskTerminated;

/** Input for the onIssueExported subscription. */
export type JiraIssueExportInput = {
    /** Unique ID for the Jira cloud instance. */
    cloudId: Scalars["ID"]["input"];
    /** Type of export, e.g., CSV_CURRENT_FIELDS or CSV_WITH_BOM_ALL_FIELDS. */
    exportType?: InputMaybe<JiraIssueExportType>;
    /** ID of the Jira filter. Uses filter's JQL if 'modified' is false. */
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    /** JQL query for exporting issues. Used if no filterId or 'modified' is true. */
    jql?: InputMaybe<Scalars["String"]["input"]>;
    /** Maximum number of issues to export. */
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    /** If true, use 'jql' instead of the filter's JQL. */
    modified?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The zero-based index of the first item to return in the current page of results (page offset). */
    pagerStart?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A Jira issue export task */
export type JiraIssueExportTask = {
    __typename?: "JiraIssueExportTask";
    /** Unique ID of the task. */
    id?: Maybe<Scalars["String"]["output"]>;
};

/** Indicates a successful completion of a Jira issue export task. */
export type JiraIssueExportTaskCompleted = {
    __typename?: "JiraIssueExportTaskCompleted";
    /** The GET URL to download the export result */
    downloadResultUrl?: Maybe<Scalars["String"]["output"]>;
    /** The completed export task. */
    task?: Maybe<JiraIssueExportTask>;
};

/** The progress of a Jira issue export task. */
export type JiraIssueExportTaskProgress = {
    __typename?: "JiraIssueExportTaskProgress";
    /** Descriptive message of the task's state. */
    message?: Maybe<Scalars["String"]["output"]>;
    /** Progress percentage (0-100). */
    progress?: Maybe<Scalars["Int"]["output"]>;
    /** Actual start time of the task. */
    startTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** Current status of the task (e.g., ENQUEUED, RUNNING). */
    status?: Maybe<JiraLongRunningTaskStatus>;
    /** The associated export task. */
    task?: Maybe<JiraIssueExportTask>;
};

/** Indicates a successful export task submission. */
export type JiraIssueExportTaskSubmitted = {
    __typename?: "JiraIssueExportTaskSubmitted";
    /** The submitted export task. */
    task?: Maybe<JiraIssueExportTask>;
};

/**
 * Represents an export task that was terminated due to an error, cancellation, or dead state.
 * The export result would not be available.
 */
export type JiraIssueExportTaskTerminated = {
    __typename?: "JiraIssueExportTaskTerminated";
    /** The error that led to the task's termination. */
    error?: Maybe<JiraIssueExportError>;
    /** Task progress at the time of termination. */
    taskProgress?: Maybe<JiraIssueExportTaskProgress>;
};

/** Types of exports available. */
export enum JiraIssueExportType {
    /** Export to CSV with all fields. */
    CsvAllFields = "CSV_ALL_FIELDS",
    /** Export to CSV with current visible fields. */
    CsvCurrentFields = "CSV_CURRENT_FIELDS",
    /** Export to CSV with BOM, all fields. */
    CsvWithBomAllFields = "CSV_WITH_BOM_ALL_FIELDS",
    /** Export to CSV with BOM, current fields. */
    CsvWithBomCurrentFields = "CSV_WITH_BOM_CURRENT_FIELDS"
}

/** Represents the common structure across Issue fields. */
export type JiraIssueField = {
    /**
     * The field ID alias.
     * Applies to managed or commonly known custom fields in Jira, which allow lookup without requiring the custom field ID.
     * E.g. rank or startdate.
     */
    aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
    /** Description for the field (if present). */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The identifier of the field. E.g. summary, customfield_10001, etc. */
    fieldId: Scalars["String"]["output"];
    /** available field operations for the issue field */
    fieldOperations?: Maybe<JiraFieldOperation>;
    /** Unique identifier for the entity. */
    id: Scalars["ID"]["output"];
    /** Whether or not the field is editable in the issue view. */
    isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
    /** Backlink to the parent issue, to aid in simple fragment design */
    issue?: Maybe<JiraIssue>;
    /** Translated name for the field (if applicable). */
    name: Scalars["String"]["output"];
    /** Field type key. E.g. project, issuetype, com.pyxis.greenhopper.Jira:gh-epic-link. */
    type: Scalars["String"]["output"];
};

export type JiraIssueFieldConfig = Node & {
    __typename?: "JiraIssueFieldConfig";
    /** this is the custom field id if the field is a custom field */
    customId?: Maybe<Scalars["Int"]["output"]>;
    /** the clause name that can be used in a Jql query. In case of a custom field this will of the format cf[<custom field id>] Example: cf[123456] */
    defaultJqlClauseName?: Maybe<Scalars["String"]["output"]>;
    /** This is the internal id of the field */
    fieldId: Scalars["String"]["output"];
    /** Globally unique id within this schema */
    id: Scalars["ID"]["output"];
    /** this field will resolve to true if a given field is a custom field */
    isCustom: Scalars["Boolean"]["output"];
    /** to be used jql, this will contain multiple clause names in case of a custom field */
    jqlClauseNames?: Maybe<Array<Scalars["String"]["output"]>>;
    /** used to display to end user */
    name: Scalars["String"]["output"];
    /** used to decide which icon and refinement type to be used */
    type: JiraConfigFieldType;
};

/** Represents the configurations associated with an Issue field. */
export type JiraIssueFieldConfiguration = {
    /** Attributes of an Issue field's configuration info. */
    fieldConfig?: Maybe<JiraFieldConfig>;
};

/** The connection type for JiraIssueField. */
export type JiraIssueFieldConnection = {
    __typename?: "JiraIssueFieldConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueFieldEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraIssueFieldConnectionResult =
    | JiraIssueFieldConnection
    | QueryError;

/** An edge in a JiraIssueField connection. */
export type JiraIssueFieldEdge = {
    __typename?: "JiraIssueFieldEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueField>;
};

/**
 * The issue field grant type used to represent field of an issue.
 * Grant types such as ASSIGNEE, REPORTER, MULTI USER PICKER, and MULTI GROUP PICKER use this grant type value.
 */
export type JiraIssueFieldGrantTypeValue = Node & {
    __typename?: "JiraIssueFieldGrantTypeValue";
    /** The issue field information such as name, description, field id. */
    field: JiraIssueField;
    /**
     * The ARI to represent the issue field grant type value.
     * For example:
     * assignee field ARI is ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:issuefieldvalue/10000/assignee
     * reporter field ARI is ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:issuefieldvalue/10000/reporter
     * multi user picker field ARI is ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:issuefieldvalue/10000/customfield_10126
     */
    id: Scalars["ID"]["output"];
};

/** Represents a field set which contains a set of JiraIssueFields, otherwise commonly referred to as collapsed fields. */
export type JiraIssueFieldSet = {
    __typename?: "JiraIssueFieldSet";
    /** The identifer of the field set e.g. `assignee`, `reporter`, `checkbox_cf[Checkboxes]`. */
    fieldSetId?: Maybe<Scalars["String"]["output"]>;
    /** Retrieves a connection of JiraIssueFields */
    fields?: Maybe<JiraIssueFieldConnection>;
    /** The field type key of the contained fields e.g: `project`, `issuetype`, `com.pyxis.greenhopper.jira:gh-epic-link`. */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a field set which contains a set of JiraIssueFields, otherwise commonly referred to as collapsed fields. */
export type JiraIssueFieldSetFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for JiraIssueFieldSet. */
export type JiraIssueFieldSetConnection = {
    __typename?: "JiraIssueFieldSetConnection";
    /** The data for Edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueFieldSetEdge>>>;
    /** The page info of the current page of results. */
    pageInfo?: Maybe<PageInfo>;
    /** The total number of JiraIssueFields matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraIssueFieldSet connection. */
export type JiraIssueFieldSetEdge = {
    __typename?: "JiraIssueFieldSetEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraIssueFieldSet>;
};

/** Error extension which gets thrown when an unsupported field is encountered. */
export type JiraIssueFieldUnsupportedErrorExtension = QueryErrorExtension & {
    __typename?: "JiraIssueFieldUnsupportedErrorExtension";
    /**
     * Application specific error type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * Field identifier for the unsupported field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Contains the field name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fieldName?: Maybe<Scalars["String"]["output"]>;
    /**
     * Contains the field type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fieldType?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether this is a required field or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isRequiredField?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether this is a user preferred field or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isUserPreferredField?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A numerical code (such as a HTTP status code) representing the error category
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Inputs for adding fields during an issue create or update */
export type JiraIssueFieldsInput = {
    /** Represents the input data for affected services field in jira */
    affectedServicesField?: InputMaybe<JiraAffectedServicesFieldInput>;
    /** Represents the input data for asset field */
    assetsField?: InputMaybe<JiraAssetFieldInput>;
    /** Represents the input data for team field in jira */
    atlassianTeamFields?: InputMaybe<Array<JiraAtlassianTeamFieldInput>>;
    /** Represents the input data for cascading select fields */
    cascadingSelectFields?: InputMaybe<Array<JiraCascadingSelectFieldInput>>;
    /** Represents the input data for clearable number fields */
    clearableNumberFields?: InputMaybe<Array<JiraClearableNumberFieldInput>>;
    /** Represents the input data for color fields */
    colorFields?: InputMaybe<Array<JiraColorFieldInput>>;
    /** Represents the input data for date fields */
    datePickerFields?: InputMaybe<Array<JiraDateFieldInput>>;
    /** Represents the input data for date time fields */
    dateTimePickerFields?: InputMaybe<Array<JiraDateTimeFieldInput>>;
    /** Represents the input data for entitlement field in jsm */
    entitlementField?: InputMaybe<JiraEntitlementFieldInput>;
    /** Represents the input data for epic link field */
    epicLinkField?: InputMaybe<JiraEpicLinkFieldInput>;
    /** Represents the input data for issue type field */
    issueType?: InputMaybe<JiraIssueTypeInput>;
    /** Represents the input data for labels field */
    labelsFields?: InputMaybe<Array<JiraLabelsFieldInput>>;
    /** Represents the input data for multiple group picker fields */
    multipleGroupPickerFields?: InputMaybe<
        Array<JiraMultipleGroupPickerFieldInput>
    >;
    /** Represents the input data for multiple select clearable user picker fields */
    multipleSelectClearableUserPickerFields?: InputMaybe<
        Array<JiraMultipleSelectClearableUserPickerFieldInput>
    >;
    /** Represents the input data for multiple select fields */
    multipleSelectFields?: InputMaybe<Array<JiraMultipleSelectFieldInput>>;
    /** Represents the input data for multiple select user picker fields */
    multipleSelectUserPickerFields?: InputMaybe<
        Array<JiraMultipleSelectUserPickerFieldInput>
    >;
    /** Represents the input data for multiple version picker fields */
    multipleVersionPickerFields?: InputMaybe<
        Array<JiraMultipleVersionPickerFieldInput>
    >;
    /** Represents the input data for multiselect components field used in BulkOps */
    multiselectComponents?: InputMaybe<JiraMultiSelectComponentFieldInput>;
    /** Represents the input data for number fields */
    numberFields?: InputMaybe<Array<JiraNumberFieldInput>>;
    /** Represents the input data for customer organization field in jsm projects */
    organizationField?: InputMaybe<JiraOrganizationFieldInput>;
    /** Represents the input data for Original Estimate field */
    originalEstimateField?: InputMaybe<JiraDurationFieldInput>;
    /** Represents the parent issue */
    parentField?: InputMaybe<JiraParentFieldInput>;
    /** Represents the input data for people field in jira */
    peopleFields?: InputMaybe<Array<JiraPeopleFieldInput>>;
    /** Represents the input data for jira system priority field */
    priority?: InputMaybe<JiraPriorityInput>;
    /** Represents the input data for Project field */
    projectFields?: InputMaybe<Array<JiraProjectFieldInput>>;
    /** Represents the input data for jira system resolution field */
    resolution?: InputMaybe<JiraResolutionInput>;
    /** Represents the input data for rich text fields ex:- description, environment */
    richTextFields?: InputMaybe<Array<JiraRichTextFieldInput>>;
    /** Represents the input data for jira system securityLevel field */
    security?: InputMaybe<JiraSecurityLevelInput>;
    /** Represents the input data for single group picker fields */
    singleGroupPickerFields?: InputMaybe<
        Array<JiraSingleGroupPickerFieldInput>
    >;
    /** Represents the input data for text fields ex:- summary, epicName */
    singleLineTextFields?: InputMaybe<Array<JiraSingleLineTextFieldInput>>;
    /** Represents the input data for organization field in jcs */
    singleOrganizationField?: InputMaybe<JiraSingleOrganizationFieldInput>;
    /** Represents the input data for single select clearable user picker fields */
    singleSelectClearableUserPickerFields?: InputMaybe<
        Array<JiraUserFieldInput>
    >;
    /** Represents the input data for single select fields */
    singleSelectFields?: InputMaybe<Array<JiraSingleSelectFieldInput>>;
    /** Represents the input data for single select user picker fields */
    singleSelectUserPickerFields?: InputMaybe<
        Array<JiraSingleSelectUserPickerFieldInput>
    >;
    /** Represents the input data for single version picker fields */
    singleVersionPickerFields?: InputMaybe<
        Array<JiraSingleVersionPickerFieldInput>
    >;
    /** Represents the input data for sprint field */
    sprintsField?: InputMaybe<JiraSprintFieldInput>;
    /** Represents the input data for team field in jira */
    teamFields?: InputMaybe<Array<JiraTeamFieldInput>>;
    /** Represents the input data for TimeTracking field */
    timeTrackingField?: InputMaybe<JiraTimeTrackingFieldInput>;
    /** Represents the input data for url fields */
    urlFields?: InputMaybe<Array<JiraUrlFieldInput>>;
};

/** Represents the generic Issue Command Palette Action. */
export type JiraIssueGenericCommandPaletteAction =
    JiraIssueCommandPaletteAction &
        Node & {
            __typename?: "JiraIssueGenericCommandPaletteAction";
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            actionName: Scalars["String"]["output"];
            /**
             *
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            id: Scalars["ID"]["output"];
        };

export type JiraIssueHierarchyConfigData = {
    __typename?: "JiraIssueHierarchyConfigData";
    /** Issue types inside the level */
    cmpIssueTypes?: Maybe<JiraIssueTypeConnection>;
    /** Each one of the levels with its basic data */
    hierarchyLevel?: Maybe<JiraIssueTypeHierarchyLevel>;
};

export type JiraIssueHierarchyConfigDataCmpIssueTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraIssueHierarchyConfigInput = {
    /** A list of issue type IDs */
    issueTypeIds: Array<Scalars["ID"]["input"]>;
    /** Level number */
    level: Scalars["Int"]["input"];
    /** Level title */
    title: Scalars["String"]["input"];
};

export type JiraIssueHierarchyConfigurationMutationInput = {
    /** This indicates if the service needs to make a simulation run */
    dryRun: Scalars["Boolean"]["input"];
    /** A list of hierarchy config input objects */
    issueHierarchyConfig: Array<JiraIssueHierarchyConfigInput>;
};

export type JiraIssueHierarchyConfigurationMutationResult = {
    __typename?: "JiraIssueHierarchyConfigurationMutationResult";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<JiraHierarchyConfigError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
    /** The field that indicates if the update action is successfully initiated */
    updateInitiated: Scalars["Boolean"]["output"];
    /** Indicates the number of issues affected by the update. */
    updateIssuesCount?: Maybe<Scalars["Long"]["output"]>;
    /** Where updateIssuesCount > 0, this field would contain a JQL clause to display the top 50 issues. */
    updateIssuesJQL?: Maybe<Scalars["String"]["output"]>;
};

export type JiraIssueHierarchyConfigurationQuery = {
    __typename?: "JiraIssueHierarchyConfigurationQuery";
    /** This indicates data payload */
    data?: Maybe<Array<JiraIssueHierarchyConfigData>>;
    /** The errors field represents additional mutation error information if exists */
    errors?: Maybe<Array<JiraHierarchyConfigError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not */
    success: Scalars["Boolean"]["output"];
};

export type JiraIssueHierarchyLimits = {
    __typename?: "JiraIssueHierarchyLimits";
    /** Max levels that the user can set */
    maxLevels: Scalars["Int"]["output"];
    /** Max name length */
    nameLength: Scalars["Int"]["output"];
};

/** Represents a system container and its items. */
export type JiraIssueItemContainer = {
    __typename?: "JiraIssueItemContainer";
    /** The system container type. */
    containerType?: Maybe<JiraIssueItemSystemContainerType>;
    /** The system container items. */
    items?: Maybe<JiraIssueItemContainerItemConnection>;
};

/** Represents the items that can be placed in any system container. */
export type JiraIssueItemContainerItem =
    | JiraIssueItemFieldItem
    | JiraIssueItemGroupContainer
    | JiraIssueItemPanelItem
    | JiraIssueItemTabContainer;

/** The connection type for `JiraIssueItemContainerItem`. */
export type JiraIssueItemContainerItemConnection = {
    __typename?: "JiraIssueItemContainerItemConnection";
    /** The data for edges in the page. */
    edges?: Maybe<Array<Maybe<JiraIssueItemContainerItemEdge>>>;
    /**
     * Deprecated.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use edges instead.
     */
    nodes?: Maybe<Array<Maybe<JiraIssueItemContainerItem>>>;
    /** Information about the page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a `JiraIssueItemContainerItem` connection. */
export type JiraIssueItemContainerItemEdge = {
    __typename?: "JiraIssueItemContainerItemEdge";
    /** The cursor to the edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueItemContainerItem>;
};

/** Represents a related collection of system containers and their items, and the collection of default item locations. */
export type JiraIssueItemContainers = {
    __typename?: "JiraIssueItemContainers";
    /** The collection of system containers. */
    containers?: Maybe<Array<Maybe<JiraIssueItemContainer>>>;
    /** The collection of default item locations. */
    defaultItemLocations?: Maybe<
        Array<Maybe<JiraIssueItemLayoutDefaultItemLocation>>
    >;
};

/** Contains the fetched containers or an error. */
export type JiraIssueItemContainersResult =
    | JiraIssueItemContainers
    | QueryError;

/** Represents a reference to a field by field ID, used for laying out fields on an issue. */
export type JiraIssueItemFieldItem = {
    __typename?: "JiraIssueItemFieldItem";
    /**
     * Represents the position of the field in the container.
     * Aid to preserve the field position when combining items in `PRIMARY` and `REQUEST` container types before saving in JSM projects.
     */
    containerPosition: Scalars["Int"]["output"];
    /** The field item ID. */
    fieldItemId: Scalars["String"]["output"];
};

/** Represents a collection of items that are held in a group container. */
export type JiraIssueItemGroupContainer = {
    __typename?: "JiraIssueItemGroupContainer";
    /** The group container ID. */
    groupContainerId: Scalars["String"]["output"];
    /** The group container items. */
    items?: Maybe<JiraIssueItemGroupContainerItemConnection>;
    /** Whether a group container is minimized. */
    minimised?: Maybe<Scalars["Boolean"]["output"]>;
    /** The group container name. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the items that can be placed in any group container. */
export type JiraIssueItemGroupContainerItem =
    | JiraIssueItemFieldItem
    | JiraIssueItemPanelItem;

/** The connection type for `JiraIssueItemGroupContainerItem`. */
export type JiraIssueItemGroupContainerItemConnection = {
    __typename?: "JiraIssueItemGroupContainerItemConnection";
    /** The data for edges in the page. */
    edges?: Maybe<Array<Maybe<JiraIssueItemGroupContainerItemEdge>>>;
    /**
     * Deprecated.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use edges instead.
     */
    nodes?: Maybe<Array<Maybe<JiraIssueItemGroupContainerItem>>>;
    /** Information about the page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a `JiraIssueItemGroupContainerItem` connection. */
export type JiraIssueItemGroupContainerItemEdge = {
    __typename?: "JiraIssueItemGroupContainerItemEdge";
    /** The cursor to the edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueItemGroupContainerItem>;
};

/**
 * Represents a default location rule for items that are not configured in a container.
 * Example: A user picker is added to a screen. Until the administrator places it in the layout, the item is placed in
 * the location specified by the 'PEOPLE' category. The categories available may vary based on the project type.
 */
export type JiraIssueItemLayoutDefaultItemLocation = {
    __typename?: "JiraIssueItemLayoutDefaultItemLocation";
    /** A destination container type or the ID of a destination group. */
    containerLocation?: Maybe<Scalars["String"]["output"]>;
    /** The item location rule type. */
    itemLocationRuleType?: Maybe<JiraIssueItemLayoutItemLocationRuleType>;
};

/** Represents the type of items that the default location rule applies to. */
export enum JiraIssueItemLayoutItemLocationRuleType {
    /** Date items. For example: date or time related fields. */
    Dates = "DATES",
    /** Multiline text items. For example: a description field or custom multi-line test fields. */
    MultilineText = "MULTILINE_TEXT",
    /** Any other item types not covered by previous item types. */
    Other = "OTHER",
    /** People items. For example: user pickers, team pickers or group picker. */
    People = "PEOPLE",
    /** Time tracking items. For example: estimate, original estimate or time tracking panels. */
    Timetracking = "TIMETRACKING"
}

/** Represents a reference to a panel by panel ID, used for laying out panels on an issue. */
export type JiraIssueItemPanelItem = {
    __typename?: "JiraIssueItemPanelItem";
    /** The panel item ID. */
    panelItemId: Scalars["String"]["output"];
};

/** The system container types that are available for placing items. */
export enum JiraIssueItemSystemContainerType {
    /** The container type for the issue content. */
    Content = "CONTENT",
    /** The container type for the issue context. */
    Context = "CONTEXT",
    /** The container type for customer context fields in JCS. */
    CustomerContext = "CUSTOMER_CONTEXT",
    /** The container type for the issue hidden items. */
    HiddenItems = "HIDDEN_ITEMS",
    /** The container type for the issue primary context. */
    Primary = "PRIMARY",
    /** The container type for the request in JSM projects. */
    Request = "REQUEST",
    /** The container type for the request portal in JSM projects. */
    RequestPortal = "REQUEST_PORTAL",
    /** The container type for the issue secondary context. */
    Secondary = "SECONDARY"
}

/** Represents a collection of system container types to be fetched by passing in an issue id. */
export type JiraIssueItemSystemContainerTypeWithIdInput = {
    /** ARI of the issue. */
    issueId: Scalars["ID"]["input"];
    /** Whether the default (first) tab should be returned or not (defaults to false). */
    supportDefaultTab?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The collection of system container types. */
    systemContainerTypes: Array<JiraIssueItemSystemContainerType>;
};

/** Represents a collection of system container types to be fetched by passing in an issue key and a cloud id. */
export type JiraIssueItemSystemContainerTypeWithKeyInput = {
    /** The cloudId associated with this Issue. */
    cloudId: Scalars["ID"]["input"];
    /** The {projectKey}-{issueNumber} associated with this Issue. */
    issueKey: Scalars["String"]["input"];
    /** Whether the default (first) tab should be returned or not (defaults to false). */
    supportDefaultTab?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The collection of system container types. */
    systemContainerTypes: Array<JiraIssueItemSystemContainerType>;
};

/** Represents a collection of items that are held in a tab container. */
export type JiraIssueItemTabContainer = {
    __typename?: "JiraIssueItemTabContainer";
    /** The tab container items. */
    items?: Maybe<JiraIssueItemTabContainerItemConnection>;
    /** The tab container name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The tab container ID. */
    tabContainerId: Scalars["String"]["output"];
};

/** Represents the items that can be placed in any tab container. */
export type JiraIssueItemTabContainerItem = JiraIssueItemFieldItem;

/** The connection type for `JiraIssueItemTabContainerItem`. */
export type JiraIssueItemTabContainerItemConnection = {
    __typename?: "JiraIssueItemTabContainerItemConnection";
    /** The data for edges in the page. */
    edges?: Maybe<Array<Maybe<JiraIssueItemTabContainerItemEdge>>>;
    /**
     * Deprecated.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use edges instead.
     */
    nodes?: Maybe<Array<Maybe<JiraIssueItemTabContainerItem>>>;
    /** Information about the page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a `JiraIssueItemTabContainerItem` connection. */
export type JiraIssueItemTabContainerItemEdge = {
    __typename?: "JiraIssueItemTabContainerItemEdge";
    /** The cursor to the edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueItemTabContainerItem>;
};

/** This class contains all the possible states an Issue can be in. */
export enum JiraIssueLifecycleState {
    /** An active issue is present and visible (Default state) */
    Active = "ACTIVE",
    /**
     * An archived issue is present but hidden. It can be retrieved
     * back to active state.
     */
    Archived = "ARCHIVED"
}

/**
 * Represents a single Issue link containing the link id, link type and destination Issue.
 *
 * For Issue create, JiraIssueLink will be populated with
 * the default IssueLink types in the relatedBy field.
 * The issueLinkId and Issue fields will be null.
 *
 * For Issue view, JiraIssueLink will be populated with
 * the Issue link data available on the Issue.
 * The Issue field will contain a nested JiraIssue that is atmost 1 level deep.
 * The nested JiraIssue will not contain fields that can contain further nesting.
 */
export type JiraIssueLink = {
    __typename?: "JiraIssueLink";
    /** Represents the direction of issue link type. can be either INWARD or OUTWARD */
    direction?: Maybe<JiraIssueLinkDirection>;
    /** Global identifier for the Issue Link. */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The destination Issue to which this link is connected. */
    issue?: Maybe<JiraIssue>;
    /** Identifier for the Issue Link. Can be null to represent a link not yet created. */
    issueLinkId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Issue link type relation through which the source issue is connected to the
     * destination issue. Source Issue is the Issue being created/queried.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use type, relationName, direction instead.
     */
    relatedBy?: Maybe<JiraIssueLinkTypeRelation>;
    /** The name of the relation based on the direction. For example: blocked by */
    relationName?: Maybe<Scalars["String"]["output"]>;
    /** Issue link type includes the configured relationship between two issues */
    type?: Maybe<JiraIssueLinkType>;
};

/** The connection type for JiraIssueLink. */
export type JiraIssueLinkConnection = {
    __typename?: "JiraIssueLinkConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueLinkEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraIssueLink matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents the possible linking directions between issues. */
export enum JiraIssueLinkDirection {
    /** Going from the other issue to this issue. */
    Inward = "INWARD",
    /** Going from this issue to the other issue. */
    Outward = "OUTWARD"
}

/** An edge in a JiraIssueLink connection. */
export type JiraIssueLinkEdge = {
    __typename?: "JiraIssueLinkEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraIssueLink>;
};

/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraIssueLinkField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Paginated list of issue links selected on the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueLinkConnection?: Maybe<JiraIssueLinkConnection>;
        /**
         * Represents the different issue link type relations/desc which can be mapped/linked to the issue in context.
         * Issue in context is the one which is being created/ which is being queried.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issueLinkTypeRelations?: Maybe<JiraIssueLinkTypeRelationConnection>;
        /**
         * Represents all the issue links defined on a Jira Issue. Should be deprecated and replaced with issueLinksConnection.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use issueLinkConnection instead.
         */
        issueLinks?: Maybe<Array<Maybe<JiraIssueLink>>>;
        /**
         * Paginated list of issues which can be related/linked with above issueLinkTypeRelations.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issues?: Maybe<JiraIssueConnection>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search url to list all available issues which can be related/linked with above issueLinkTypeRelations.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkFieldIssueLinkConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkFieldIssueLinkTypeRelationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents linked issues field on a Jira Issue. */
export type JiraIssueLinkFieldIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jql?: InputMaybe<Scalars["String"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    showSubTaskParent?: InputMaybe<Scalars["Boolean"]["input"]>;
    showSubTasks?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for defining the operation on the IssueLink field of a Jira issue. */
export type JiraIssueLinkFieldOperationInputForIssueTransitions = {
    /**
     * Accepts ARI(s): issue
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'linkIssues' param
     */
    inwardIssue?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Accepts input for either inward or outward link */
    linkIssues?: InputMaybe<JiraLinkedIssuesInput>;
    /** Accepts ARI(s): issue-link-type */
    linkType: Scalars["ID"]["input"];
    /** Single value ADD operation is supported. */
    operation: JiraAddValueFieldOperations;
};

/**
 * Represents the issue link type which includes both inwards and outwards relation names
 * For example: blocks, is blocked by, duplicates, is duplicated by, clones, is cloned by.
 */
export type JiraIssueLinkType = Node & {
    __typename?: "JiraIssueLinkType";
    /** Global identifier for the Issue Link Type */
    id: Scalars["ID"]["output"];
    /** The value of inwards direction. For example: blocks */
    inwards?: Maybe<Scalars["String"]["output"]>;
    /** Represents the IssueLinkType id to which this type belongs to. */
    linkTypeId?: Maybe<Scalars["ID"]["output"]>;
    /** Display name of IssueLinkType to which this relation belongs to. For example: Blocks, Duplicate, Cloners */
    linkTypeName?: Maybe<Scalars["String"]["output"]>;
    /** The value of outwards direction. For example: is blocked by */
    outwards?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraIssueLinkType. */
export type JiraIssueLinkTypeConnection = {
    __typename?: "JiraIssueLinkTypeConnection";
    /** The data for Edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueLinkTypeEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraIssueLinkType matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraIssueLinkType connection. */
export type JiraIssueLinkTypeEdge = {
    __typename?: "JiraIssueLinkTypeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraIssueLinkType>;
};

/** Deprecated, please use JiraIssueLinkType instead. */
export type JiraIssueLinkTypeRelation = Node & {
    __typename?: "JiraIssueLinkTypeRelation";
    /** Represents the direction of Issue link type. E.g. INWARD, OUTWARD. */
    direction?: Maybe<JiraIssueLinkDirection>;
    /** Global identifier for the Issue Link Type Relation. */
    id: Scalars["ID"]["output"];
    /** Represents the IssueLinkType id to which this type belongs to. */
    linkTypeId: Scalars["String"]["output"];
    /** Display name of IssueLinkType to which this relation belongs to. E.g. Blocks, Duplicate, Cloners. */
    linkTypeName?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represents the description of the relation by which this link is identified.
     * This can be the inward or outward description of an IssueLinkType.
     * E.g. blocks, is blocked by, duplicates, is duplicated by, clones, is cloned by.
     */
    relationName?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraIssueLinkTypeRelation. */
export type JiraIssueLinkTypeRelationConnection = {
    __typename?: "JiraIssueLinkTypeRelationConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraIssueLinkTypeRelationEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * The page info of the current page of results.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total number of JiraIssueLinkTypeRelation matching the criteria.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraIssueLinkType connection. */
export type JiraIssueLinkTypeRelationEdge = {
    __typename?: "JiraIssueLinkTypeRelationEdge";
    /**
     * The cursor to this edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     * The node at the edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<JiraIssueLinkTypeRelation>;
};

/** Types of modules that can provide content for issues. */
export enum JiraIssueModuleType {
    /** A module that provides a content panel for displaying issue data. */
    IssueModule = "ISSUE_MODULE",
    /** A module that provides a legacy web panel. */
    WebPanel = "WEB_PANEL"
}

export type JiraIssueNavigatorJqlHistoryDeletePayload = Payload & {
    __typename?: "JiraIssueNavigatorJQLHistoryDeletePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Extra page information to assist the Issue Navigator UI to display information about the current set of issues. */
export type JiraIssueNavigatorPageInfo = {
    __typename?: "JiraIssueNavigatorPageInfo";
    /** The issue key of the first node from the next page of issues. */
    firstIssueKeyFromNextPage?: Maybe<Scalars["String"]["output"]>;
    /**
     * The position of the first issue in the current page, relative to the entire stable search.
     * The first issue's position will start at 1.
     * If there are no issues, the position returned is 0.
     * You can consider a position to effectively be a traditional index + 1.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    firstIssuePosition?: Maybe<Scalars["Int"]["output"]>;
    /** The issue key of the last node from the previous page of issues. */
    lastIssueKeyFromPreviousPage?: Maybe<Scalars["String"]["output"]>;
    /**
     * The position of the last issue in the current page, relative to the entire stable search.
     * If there is only 1 issue, the last position is 1.
     * If there are no issues, the position returned is 0.
     * You can consider a position to effectively be a traditional index + 1.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    lastIssuePosition?: Maybe<Scalars["Int"]["output"]>;
};

/** The options for issue navigator search layout. */
export enum JiraIssueNavigatorSearchLayout {
    /** Detailed or aka split-view of issues */
    Detail = "DETAIL",
    /** List view of issues */
    List = "LIST"
}

export type JiraIssueNavigatorSearchLayoutMutationPayload = Payload & {
    __typename?: "JiraIssueNavigatorSearchLayoutMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    /** The newly set preferred search layout. */
    issueNavigatorSearchLayout?: Maybe<JiraIssueNavigatorSearchLayout>;
    success: Scalars["Boolean"]["output"];
};

/** Summary of the Pull Requests attached to the issue */
export type JiraIssuePullRequestDevSummary = {
    __typename?: "JiraIssuePullRequestDevSummary";
    /** Total number of Pull Requests for the issue */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Date at which this summary was last updated */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Whether the Pull Requests for the given state are open or not */
    open?: Maybe<Scalars["Boolean"]["output"]>;
    /** State of the Pull Requests in the summary */
    state?: Maybe<JiraPullRequestState>;
    /** Number of Pull Requests for the state */
    stateCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Container for the summary of the Pull Requests attached to the issue */
export type JiraIssuePullRequestDevSummaryContainer = {
    __typename?: "JiraIssuePullRequestDevSummaryContainer";
    /** The actual summary of the Pull Requests attached to the issue */
    overall?: Maybe<JiraIssuePullRequestDevSummary>;
    /** Count of Pull Requests aggregated per provider */
    summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** The container of SCM pull requests info associated with a Jira issue. */
export type JiraIssuePullRequests = {
    __typename?: "JiraIssuePullRequests";
    /** A list of config errors of underlined data-providers providing branches details. */
    configErrors?: Maybe<Array<JiraDevInfoConfigError>>;
    /**
     * A list of pull request details from the original SCM providers.
     * Maximum of 50 latest updated pull-requests will be returned.
     */
    details?: Maybe<Array<JiraDevOpsPullRequestDetails>>;
};

export type JiraIssueRemoteIssueLink = {
    __typename?: "JiraIssueRemoteIssueLink";
    /** The URL of the item. */
    href?: Maybe<Scalars["String"]["output"]>;
    /** The Remote Link ARI. */
    id: Scalars["ID"]["output"];
    /** Description of the relationship between the issue and the linked item. */
    relationship?: Maybe<Scalars["String"]["output"]>;
    /** The title of the item. */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Represents issue restriction field on an issue for next gen projects. */
export type JiraIssueRestrictionField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraIssueRestrictionField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Paginated list of roles available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        roles?: Maybe<JiraRoleConnection>;
        /** Search URL to fetch all the roles options for the fields on an issue. */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The roles selected on the Issue or default roles configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedRolesConnection instead.
         */
        selectedRoles?: Maybe<Array<Maybe<JiraRole>>>;
        /** The roles selected on the Issue or default roles configured for the field. */
        selectedRolesConnection?: Maybe<JiraRoleConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents issue restriction field on an issue for next gen projects. */
export type JiraIssueRestrictionFieldRolesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents issue restriction field on an issue for next gen projects. */
export type JiraIssueRestrictionFieldSelectedRolesConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Summary of the Reviews attached to the issue */
export type JiraIssueReviewDevSummary = {
    __typename?: "JiraIssueReviewDevSummary";
    /** Total number of Reviews for the issue */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Date at which this summary was last updated */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** State of the Reviews in the summary */
    state?: Maybe<JiraReviewState>;
    /** Number of Reviews for the state */
    stateCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Container for the summary of the Reviews attached to the issue */
export type JiraIssueReviewDevSummaryContainer = {
    __typename?: "JiraIssueReviewDevSummaryContainer";
    /** The actual summary of the Reviews attached to the issue */
    overall?: Maybe<JiraIssueReviewDevSummary>;
    /** Count of Reviews aggregated per provider */
    summaryByProvider?: Maybe<Array<JiraIssueDevSummaryByProvider>>;
};

/** Represents an issue search result when querying with a JiraFilter. */
export type JiraIssueSearchByFilter = JiraIssueSearchResult & {
    __typename?: "JiraIssueSearchByFilter";
    /**
     * Retrieves content controlled by the context of a JiraIssueSearchView.
     * To query multiple content views at once, use GraphQL aliases.
     *
     * If a namespace is provided, and a viewId is:
     * - Not provided, then the last used view is returned within this namespace.
     * - Provided, then this view is returned if it exists in this namespace.
     *
     * If a namespace is not provided, and a viewId is:
     * - Not provided, then the last used view across any namespace is returned.
     * - Provided, then this view is returned if it exists in the global namespace.
     */
    content?: Maybe<JiraIssueSearchContextualContent>;
    /**
     * Retrieves content by provided field config set ids, ignoring the active query context.
     * To query multiple content views at once, use GraphQL aliases.
     */
    contentByFieldSetIds?: Maybe<JiraIssueSearchContextlessContent>;
    /** The Jira Filter corresponding to the filter ARI specified in the calling query. */
    filter?: Maybe<JiraFilter>;
};

/** Represents an issue search result when querying with a JiraFilter. */
export type JiraIssueSearchByFilterContentArgs = {
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents an issue search result when querying with a JiraFilter. */
export type JiraIssueSearchByFilterContentByFieldSetIdsArgs = {
    fieldSetIds: Array<Scalars["String"]["input"]>;
};

export type JiraIssueSearchByFilterResult =
    | JiraIssueSearchByFilter
    | QueryError;

/** Represents an issue search result when querying with a set of issue ids. */
export type JiraIssueSearchByHydration = JiraIssueSearchResult & {
    __typename?: "JiraIssueSearchByHydration";
    /**
     * Retrieves content controlled by the context of a JiraIssueSearchView.
     * To query multiple content views at once, use GraphQL aliases.
     *
     * If a namespace is provided, and a viewId is:
     * - Not provided, then the last used view is returned within this namespace.
     * - Provided, then this view is returned if it exists in this namespace.
     *
     * If a namespace is not provided, and a viewId is:
     * - Not provided, then the last used view across any namespace is returned.
     * - Provided, then this view is returned if it exists in the global namespace.
     */
    content?: Maybe<JiraIssueSearchContextualContent>;
    /**
     * Retrieves content by provided field config set ids, ignoring the active query context.
     * To query multiple content views at once, use GraphQL aliases.
     */
    contentByFieldSetIds?: Maybe<JiraIssueSearchContextlessContent>;
};

/** Represents an issue search result when querying with a set of issue ids. */
export type JiraIssueSearchByHydrationContentArgs = {
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents an issue search result when querying with a set of issue ids. */
export type JiraIssueSearchByHydrationContentByFieldSetIdsArgs = {
    fieldSetIds: Array<Scalars["String"]["input"]>;
};

/** Represents an issue search result when querying with a Jira Query Language (JQL) string. */
export type JiraIssueSearchByJql = JiraIssueSearchResult & {
    __typename?: "JiraIssueSearchByJql";
    /**
     * Retrieves content controlled by the context of a JiraIssueSearchView.
     * To query multiple content views at once, use GraphQL aliases.
     *
     * If a namespace is provided, and a viewId is:
     * - Not provided, then the last used view is returned within this namespace.
     * - Provided, then this view is returned if it exists in this namespace.
     *
     * If a namespace is not provided, and a viewId is:
     * - Not provided, then the last used view across any namespace is returned.
     * - Provided, then this view is returned if it exists in the global namespace.
     */
    content?: Maybe<JiraIssueSearchContextualContent>;
    /**
     * Retrieves content by provided field config set ids, ignoring the active query context.
     * To query multiple content views at once, use GraphQL aliases.
     */
    contentByFieldSetIds?: Maybe<JiraIssueSearchContextlessContent>;
    /** The JQL specified in the calling query. */
    jql?: Maybe<Scalars["String"]["output"]>;
};

/** Represents an issue search result when querying with a Jira Query Language (JQL) string. */
export type JiraIssueSearchByJqlContentArgs = {
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents an issue search result when querying with a Jira Query Language (JQL) string. */
export type JiraIssueSearchByJqlContentByFieldSetIdsArgs = {
    fieldSetIds: Array<Scalars["String"]["input"]>;
};

export type JiraIssueSearchByJqlResult = JiraIssueSearchByJql | QueryError;

/**
 * The input used in Issue Search to obtain all children for a given issue.
 * This is used when hierarchy is enabled in Issue Search and user expands children of an issue.
 */
export type JiraIssueSearchChildIssuesInput = {
    /** The list of project keys to filter the children by. If it's null or empty, no filter is applied. */
    filterByProjectKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * Filter used in the main search query. This is used to extract the ORDER BY clause and sort children accordingly.
     * Either this or jql should be provided.
     */
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * JQL used in the main search query. This is used to extract the ORDER BY clause and sort children accordingly.
     * Either this or filterId should be provided.
     */
    jql?: InputMaybe<Scalars["String"]["input"]>;
    /** The key of the parent issue for which children are to be fetched */
    parentIssueKey: Scalars["String"]["input"];
};

/**
 * Represents the contextless content for an issue search result in Jira.
 * There is no JiraIssueSearchView associated with this content and is therefore contextless.
 */
export type JiraIssueSearchContextlessContent = JiraIssueSearchResultContent & {
    __typename?: "JiraIssueSearchContextlessContent";
    /** Retrieves a connection of JiraIssues for the current search context. */
    issues?: Maybe<JiraIssueConnection>;
};

/**
 * Represents the contextless content for an issue search result in Jira.
 * There is no JiraIssueSearchView associated with this content and is therefore contextless.
 */
export type JiraIssueSearchContextlessContentIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Represents the contextual content for an issue search result in Jira.
 * The context here is determined by the JiraIssueSearchView associated with the content.
 */
export type JiraIssueSearchContextualContent = JiraIssueSearchResultContent & {
    __typename?: "JiraIssueSearchContextualContent";
    /** Retrieves a connection of JiraIssues for the current search context. */
    issues?: Maybe<JiraIssueConnection>;
    /** The JiraIssueSearchView that will be used as the context when retrieving JiraIssueField data. */
    view?: Maybe<JiraIssueSearchView>;
};

/**
 * Represents the contextual content for an issue search result in Jira.
 * The context here is determined by the JiraIssueSearchView associated with the content.
 */
export type JiraIssueSearchContextualContentIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Container type for different definitions of custom input definitions. */
export type JiraIssueSearchCustomInput = {
    /** Input type used for Jira Software issue search. */
    jiraSoftwareInput?: InputMaybe<JiraSoftwareIssueSearchCustomInput>;
};

/** The possible errors that can occur during an issue search. */
export type JiraIssueSearchError =
    | JiraCustomIssueSearchError
    | JiraInvalidJqlError
    | JiraInvalidSyntaxError
    | JiraServerError;

export type JiraIssueSearchErrorExtension = QueryErrorExtension & {
    __typename?: "JiraIssueSearchErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Represents a configurable field in Jira issue searches.
 * These fields can be used to update JiraIssueSearchViews or to directly query for issue fields.
 * This mirrors the concept of collapsed fields where all collapsible fields with the same `name` and `type` will be
 * collapsed into a single JiraIssueSearchFieldSet with `fieldSetId = name[type]`.
 * Non-collapsible and system fields cannot be collapsed but can still be represented as this type where `fieldSetId = fieldId`.
 */
export type JiraIssueSearchFieldSet = {
    __typename?: "JiraIssueSearchFieldSet";
    /**
     * List of aliases for this fieldset. Aliases are other names that represent this field.
     * Note that all aliases are lowercased.
     * - Some system fields can have aliases (1 or more) , e.g. `issueKey` -> [`id` , `issue` , `key`]
     * - Custom fields with collapsed fieldsetId have an untranslated name as the alias, e.g. `myField[Number]` -> `myfield`
     * - All other fieldsetId's get empty set back, e.g. `assignee` -> []
     */
    aliases?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The user-friendly name for a JiraIssueSearchFieldSet, to be displayed in the UI. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The encoded jqlTerm for the current field config set. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /** The identifer of the field config set e.g. `assignee`, `reporter`, `checkbox_cf[Checkboxes]`. */
    fieldSetId?: Maybe<Scalars["String"]["output"]>;
    /** Determines FieldSets Preferences for the user */
    fieldSetPreferences?: Maybe<JiraFieldSetPreferences>;
    /**
     * The field-type of the current field.
     * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
     * Important note: This information only exists for collapsed fields.
     */
    fieldType?: Maybe<JiraFieldType>;
    /** Tracks whether or not the current field config set has been selected. */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /** Determines whether or not the current field config set is sortable. */
    isSortable?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The jqlTerm for the current field config set.
     * E.g. `component`, `fixVersion`
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Underlying field type for the given field.
     * This can be used to determine how the field needs to be rendered in UI
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** A Connection of JiraIssueSearchFieldSet. */
export type JiraIssueSearchFieldSetConnection = {
    __typename?: "JiraIssueSearchFieldSetConnection";
    /** The data for Edges in the current page */
    edges?: Maybe<Array<Maybe<JiraIssueSearchFieldSetEdge>>>;
    /**
     * Indicates if any fields in the column configuration cannot be shown as they're currently unsupported
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    isWithholdingUnsupportedSelectedFields?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** The page info of the current page of results */
    pageInfo: PageInfo;
    /** The total number of JiraIssueSearchFieldSet matching the criteria */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JiraIssueSearchFieldSet. */
export type JiraIssueSearchFieldSetEdge = {
    __typename?: "JiraIssueSearchFieldSetEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraIssueSearchFieldSet>;
};

/** Specifies which field config sets should be returned. */
export enum JiraIssueSearchFieldSetSelectedState {
    /** Both selected and non-selected field config sets. */
    All = "ALL",
    /** Only the field config sets that have not been selected in the current view. */
    NonSelected = "NON_SELECTED",
    /** Only the field config sets selected in the current view. */
    Selected = "SELECTED"
}

/**
 * A filter for the JiraIssueSearchFieldSet connections.
 * By default, if no fieldSetSelectedState is specified, only SELECTED fields are returned.
 */
export type JiraIssueSearchFieldSetsFilter = {
    /** An enum specifying which field config sets should be returned based on the selected status. */
    fieldSetSelectedState?: InputMaybe<JiraIssueSearchFieldSetSelectedState>;
    /** Only the fieldSets that case-insensitively, contain this searchString in their displayName will be returned. */
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * The necessary input to return the field sets connection when updating the view/column configuration
 * while paginating the issue search results.
 * There is an undocumented argument when paginating with Relay called UNSTABLE_extraVariables.
 * However, to leverage this we need to expose the field set connection as a field on JiraIssueEdge.
 * This makes it possible to provide all implicit view settings as explicit variables during pagination requests.
 * This will allow us to set all static variables to the top level issueSearch API,
 * without updating variables for any nested fields.
 */
export type JiraIssueSearchFieldSetsInput = {
    fieldSetIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    viewInput?: InputMaybe<JiraIssueSearchViewInput>;
};

export type JiraIssueSearchGroupByFieldMutationPayload = Payload & {
    __typename?: "JiraIssueSearchGroupByFieldMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** The payload returned when a User's issue search Hide Done toggle preference has been updated. */
export type JiraIssueSearchHideDonePreferenceMutationPayload = Payload & {
    __typename?: "JiraIssueSearchHideDonePreferenceMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    /**
     * A nullable boolean indicating if the Hide Done work items toggle is enabled.
     * When the mutation is successful, this field will return the value that was passed as a parameter to the mutation.
     * It's an optimistic update, we are not querying the store to get the latest value.
     * When the mutation fails, this field will be null.
     * true -> Hide done toggle is enabled
     * false -> Hide done toggle is disabled
     * null -> If any error has occured in updating the preference. The hide done toggle will be disabled.
     */
    isHideDoneEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

/** The payload returned when a User fieldset preferences has been updated. */
export type JiraIssueSearchHierarchyPreferenceMutationPayload = Payload & {
    __typename?: "JiraIssueSearchHierarchyPreferenceMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    /**
     * A nullable boolean indicating if the Issue Hierarchy is enabled.
     * When the mutation is successful, this field will return the value that was passed as a parameter to the mutation.
     * It's an optimistic update, we are not querying the store to get the latest value.
     * When the mutation fails, this field will be null.
     * true -> Issue Hierarchy is enabled
     * false -> Issue Hierarchy is disabled
     * null -> If any error has occured in updating the preference. The hierarchy will be disabled.
     */
    isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

/**
 * The input used for an issue search.
 * The issue search will either rely on the specified JQL, the specified filter's underlying JQL,
 * specified custom input, specific to a Jira family product, or child issues input
 */
export type JiraIssueSearchInput = {
    /** Used in issue search hierarchy for retrieving children for a given issue */
    childIssuesInput?: InputMaybe<JiraIssueSearchChildIssuesInput>;
    /** The custom input used for issue search. */
    customInput?: InputMaybe<JiraIssueSearchCustomInput>;
    /** The saved filter used for issue search. */
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    /** The JQL used for issue search. */
    jql?: InputMaybe<Scalars["String"]["input"]>;
};

export enum JiraIssueSearchOperationScope {
    NinGlobal = "NIN_GLOBAL",
    NinGlobalSchemaRefactor = "NIN_GLOBAL_SCHEMA_REFACTOR",
    NinGlobalShadowRequest = "NIN_GLOBAL_SHADOW_REQUEST",
    NinProject = "NIN_PROJECT",
    NinProjectSchemaRefactor = "NIN_PROJECT_SCHEMA_REFACTOR",
    NinProjectShadowRequest = "NIN_PROJECT_SHADOW_REQUEST"
}

/**
 * The options used for an issue search.
 * The issueKey determines the target page for search.
 * Do not provide pagination arguments alongside issueKey.
 */
export type JiraIssueSearchOptions = {
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** A generic interface for issue search results in Jira. */
export type JiraIssueSearchResult = {
    /**
     * Retrieves content controlled by the context of a JiraIssueSearchView.
     * To query multiple content views at once, use GraphQL aliases.
     *
     * If a namespace is provided, and a viewId is:
     * - Not provided, then the last used view is returned within this namespace.
     * - Provided, then this view is returned if it exists in this namespace.
     *
     * If a namespace is not provided, and a viewId is:
     * - Not provided, then the last used view across any namespace is returned.
     * - Provided, then this view is returned if it exists in the global namespace.
     */
    content?: Maybe<JiraIssueSearchContextualContent>;
    /**
     * Retrieves content by provided field config set ids, ignoring the active query context.
     * To query multiple content views at once, use GraphQL aliases.
     */
    contentByFieldSetIds?: Maybe<JiraIssueSearchContextlessContent>;
};

/** A generic interface for issue search results in Jira. */
export type JiraIssueSearchResultContentArgs = {
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

/** A generic interface for issue search results in Jira. */
export type JiraIssueSearchResultContentByFieldSetIdsArgs = {
    fieldSetIds: Array<Scalars["String"]["input"]>;
};

/** A generic interface for the content of an issue search result in Jira. */
export type JiraIssueSearchResultContent = {
    /**
     * Retrieves JiraIssue limited by provided pagination params, or global search limits, whichever is smaller.
     * To retrieve multiple sets of issues, use GraphQL aliases.
     *
     * An optimized search is run when only JiraIssue issue ids are requested.
     */
    issues?: Maybe<JiraIssueConnection>;
};

/** A generic interface for the content of an issue search result in Jira. */
export type JiraIssueSearchResultContentIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The input used for an issue search to identify the scope/context in which the search is being performed (e.g. project or global scope).
 * The plan is to evolve this to also include the namespace/experience for the search (e.g. ISSUE_NAVIGATOR or CHILD_ISSUE_PANEL).
 * For now this is going to be used only for monitoring purposes, allowing us to split the search queries between project and global scope.
 */
export type JiraIssueSearchScope = {
    /** The scope in which a search is being performed in the context of a particular experience (e.g. NIN_Project or NIN_Global). */
    operationScope?: InputMaybe<JiraIssueSearchOperationScope>;
};

/**
 * The input used for an issue search when FE needs to tell the BE the specific view configuration to be used for an issue search query.
 * E.g. this can be used on pagination to make sure that the same view configuration calculated on initial load is used for the subsequent queries.
 * This would prevent scenarios where an user has two tabs open (one with hierarchy enabled and one with hierarchy disabled) and the BE needs to return
 * different results to respect the view configuration used on the initial load of each tab.
 */
export type JiraIssueSearchStaticViewInput = {
    /** A nullable boolean indicating if the Grouping is enabled */
    isGroupingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A nullable boolean indicating if the Hide done work items is enabled */
    isHideDoneEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A nullable boolean indicating if the Issue Hierarchy is enabled */
    isHierarchyEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The representation for JQL issue search processing status. */
export type JiraIssueSearchStatus = {
    __typename?: "JiraIssueSearchStatus";
    /** The list of custom JQL functions processed within the JQL search. */
    functions?: Maybe<Array<Maybe<JiraJqlFunctionProcessingStatus>>>;
};

/**
 * Represents a grouping of search data to a particular UI behaviour.
 * Built-in views are automatically created for certain Jira pages and global Jira system filters.
 */
export type JiraIssueSearchView = JiraIssueSearchViewMetadata &
    Node & {
        __typename?: "JiraIssueSearchView";
        /** A connection of included fields' configurations, grouped where logical (e.g. collapsed fields). */
        fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
        /** The tenant specific id of the filter that will be used to get the JiraIssueSearchView. */
        filterId?: Maybe<Scalars["String"]["output"]>;
        /**
         * A nullable boolean indicating if the IssueSearchView is using default fieldSets
         * true -> Issue search view is using default fieldSets
         * false -> Issue search view has custom fieldSets
         * null -> Not applicable for requested issue search view
         */
        hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
        /** An ARI-format value that encodes both namespace and viewId. */
        id: Scalars["ID"]["output"];
        /**
         * A nullable boolean indicating if the Issue Hierarchy is enabled
         * true -> Issue Hierarchy is enabled
         * false -> Issue Hierarchy is disabled
         * null -> If any error has occured in fetching the preference. The hierarchy will be disabled.
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIsHierarchyEnabled")' query directive to the 'isHierarchyEnabled' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
        /** A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace. */
        namespace?: Maybe<Scalars["String"]["output"]>;
        viewConfigSettings?: Maybe<JiraIssueSearchViewConfigSettings>;
        /** A unique identifier for this view within its namespace, or the global namespace if no namespace is defined. */
        viewId?: Maybe<Scalars["String"]["output"]>;
    };

/**
 * Represents a grouping of search data to a particular UI behaviour.
 * Built-in views are automatically created for certain Jira pages and global Jira system filters.
 */
export type JiraIssueSearchViewFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Represents a grouping of search data to a particular UI behaviour.
 * Built-in views are automatically created for certain Jira pages and global Jira system filters.
 */
export type JiraIssueSearchViewViewConfigSettingsArgs = {
    staticViewInput?: InputMaybe<JiraIssueSearchStaticViewInput>;
};

/**
 * The view config data used for an issue search.
 * E.g. we can load different results depending on the hierarchy toggle value for a specific namespace/experience or view.
 * In NIN, if the hierarchy toggle is enabled, we will return only the top level issues or the issues with no parent satisfying the given JQL/filter.
 */
export type JiraIssueSearchViewConfigInput = {
    staticViewInput?: InputMaybe<JiraIssueSearchStaticViewInput>;
    viewInput?: InputMaybe<JiraIssueSearchViewInput>;
};

/**
 * The representation of the view settings in Issue Table component.
 * Right now these settings are at the user & namespace/experience level.
 */
export type JiraIssueSearchViewConfigSettings = {
    __typename?: "JiraIssueSearchViewConfigSettings";
    /**
     * A nullable boolean indicating if the Grouping can be enabled in the Issue Table component
     * true -> Grouping can be enabled (e.g. in single-project scope)
     * false -> Grouping cannot be enabled (e.g. in multi-project scope)
     * null -> If any error has occured in fetching the preference. It shouldn't be possible to enable grouping when an error happens.
     */
    canEnableGrouping?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A nullable boolean indicating if the Issue Hierarchy can be enabled in the Issue Table component
     * true -> Issue Hierarchy can be enabled (e.g. in single-project scope)
     * false -> Issue Hierarchy cannot be enabled (e.g. in multi-project scope)
     * null -> If any error has occured in fetching the preference. It shouldn't be possible to enable hierarchy when an error happens.
     */
    canEnableHierarchy?: Maybe<Scalars["Boolean"]["output"]>;
    /** The group by field preference for the user and the list of fields available for grouping */
    groupByConfig?: Maybe<JiraSpreadsheetGroupByConfig>;
    /** Boolean indicating whether the completed issues should be hidden from the search result */
    hideDone?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A nullable boolean indicating if the Grouping is enabled
     * true -> Grouping is enabled
     * false -> Grouping is disabled
     * null -> If any error has occured in fetching the preference. The grouping will be disabled.
     */
    isGroupingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A nullable boolean indicating if the Issue Hierarchy is enabled
     * true -> Issue Hierarchy is enabled
     * false -> Issue Hierarchy is disabled
     * null -> If any error has occured in fetching the preference. The hierarchy will be disabled.
     */
    isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JiraIssueSearchViewContextInput = {
    expandedGroups?: InputMaybe<JiraIssueExpandedGroups>;
    expandedParents?: InputMaybe<Array<JiraIssueExpandedParent>>;
};

export type JiraIssueSearchViewContextMapping = {
    afterIssueId?: Maybe<Scalars["String"]["output"]>;
    beforeIssueId?: Maybe<Scalars["String"]["output"]>;
    position?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraIssueSearchViewContextMappingByGroup =
    JiraIssueSearchViewContextMapping & {
        __typename?: "JiraIssueSearchViewContextMappingByGroup";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        afterIssueId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        beforeIssueId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        jql?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        position?: Maybe<Scalars["Int"]["output"]>;
    };

export type JiraIssueSearchViewContextMappingByParent =
    JiraIssueSearchViewContextMapping & {
        __typename?: "JiraIssueSearchViewContextMappingByParent";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        afterIssueId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        beforeIssueId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        parentIssueId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        position?: Maybe<Scalars["Int"]["output"]>;
    };

export type JiraIssueSearchViewContexts = {
    __typename?: "JiraIssueSearchViewContexts";
    contexts?: Maybe<Array<JiraIssueSearchViewContextMapping>>;
    errors?: Maybe<Array<QueryError>>;
};

/** The context can be either project based or issue based, switch to use issue based when project id/issue type id are unknown */
export type JiraIssueSearchViewFieldSetsContext = {
    issueContext?: InputMaybe<JiraIssueSearchViewFieldSetsIssueContext>;
    projectContext?: InputMaybe<JiraIssueSearchViewFieldSetsProjectContext>;
};

export type JiraIssueSearchViewFieldSetsIssueContext = {
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraIssueSearchViewFieldSetsProjectContext = {
    issueType?: InputMaybe<Scalars["ID"]["input"]>;
    project?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * The view details used for an issue search.
 * We can use this input on initial load to avoid waterfall requests on the FE.
 * E.g. FE doesn't know if the hierarchy toggle is enabled or not, so it can pass the view details to the backend
 * to get the flag for the given experience.
 */
export type JiraIssueSearchViewInput = {
    /** The returned field set will belong to the context given, currently only applicable to CHILD_ISSUE_PANEL */
    context?: InputMaybe<JiraIssueSearchViewFieldSetsContext>;
    /** The tenant specific id of the filter that will be used to get the JiraIssueSearchView */
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    /** A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace. */
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    /** A unique identifier for this view within its namespace, or the global namespace if no namespace is defined. */
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraIssueSearchViewMetadata = {
    /**
     * A connection of included fields' configurations, grouped where logical (e.g. collapsed fields).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
    /**
     * The tenant specific id of the filter that will be used to get the JiraIssueSearchView
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filterId?: Maybe<Scalars["String"]["output"]>;
    /**
     * A nullable boolean indicating if the IssueSearchView is using default fieldSets
     * true -> Issue search view is using default fieldSets
     * false -> Issue search view has custom fieldSets
     * null -> Not applicable for requested issue search view
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An ARI-format value that encodes both namespace and viewId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * A nullable boolean indicating if the Issue Hierarchy is enabled
     * true -> Issue Hierarchy is enabled
     * false -> Issue Hierarchy is disabled
     * null -> If any error has occured in fetching the preference. The hierarchy will be disabled.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    namespace?: Maybe<Scalars["String"]["output"]>;
    /**
     * A unique identifier for this view within its namespace, or the global namespace if no namespace is defined.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewId?: Maybe<Scalars["String"]["output"]>;
};

export type JiraIssueSearchViewMetadataFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The payload returned when a JiraIssueSearchView has been updated. */
export type JiraIssueSearchViewPayload = Payload & {
    __typename?: "JiraIssueSearchViewPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    view?: Maybe<JiraIssueSearchView>;
};

export type JiraIssueSearchViewResult = JiraIssueSearchView | QueryError;

export type JiraIssueSearchViewType = {
    /** Errors which were encountered while fetching the connection. */
    error?: Maybe<QueryError>;
    /** The id of the viewType, represented by [JiraIssueSearchViewTypeARI](https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aissue-search-view-type) */
    id: Scalars["ID"]["output"];
};

/** This is the Graphql type for the Comment field in Issue Transition Modal Load */
export type JiraIssueTransitionComment = {
    __typename?: "JiraIssueTransitionComment";
    /** Rich Text Field Config for the Project */
    adminRichTextConfig?: Maybe<JiraAdminRichTextFieldConfig>;
    /** Whether to show canned responses in the comment field. */
    enableCannedResponses?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether to show permission levels to restrict Comment Visibility based on Permission Level. */
    enableCommentVisibility?: Maybe<Scalars["Boolean"]["output"]>;
    /** Media Context for the comment field */
    mediaContext?: Maybe<JiraMediaContext>;
    /** Possible types of the Comment possible like: Internal Note, Share with Customer */
    types?: Maybe<Array<Maybe<JiraIssueTransitionCommentType>>>;
};

/** Input type for Jira comment, which may be optional input to perform a transition for the issue */
export type JiraIssueTransitionCommentInput = {
    /** Accept ADF ( Atlassian Document Format) of paragraph */
    body: JiraAdfInput;
    /** Only ADD operation is supported for comment section in the context of Issue Transition Modernisation experience.. */
    operation: JiraAddValueFieldOperations;
    /** Type of comment to be added while transitioning, possible values are INTERNAL_NOTE, REPLY_TO_CUSTOMER */
    type?: InputMaybe<JiraIssueTransitionCommentType>;
    /** Jira issue transition comment visibility */
    visibility?: InputMaybe<JiraIssueTransitionCommentVisibilityInput>;
};

/** Possible Comment Types that can be made on the Transition screen. */
export enum JiraIssueTransitionCommentType {
    /** Comment has to be shared internally with the team */
    InternalNote = "INTERNAL_NOTE",
    /** Comment has to be shared with the customer */
    ReplyToCustomer = "REPLY_TO_CUSTOMER"
}

export type JiraIssueTransitionCommentVisibilityInput = {
    /**
     * Unique identifier for a group
     * Accepts ARI(s): group
     */
    groupId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Unique identifier for a project role
     * Accepts ARI(s): role
     */
    roleId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input type for field level inputs, which may be required to perform a transition for the issue */
export type JiraIssueTransitionFieldLevelInput = {
    /** An entry corresponding for input for JiraAffectedServicesField */
    JiraAffectedServicesField?: InputMaybe<
        Array<JiraUpdateAffectedServicesFieldInput>
    >;
    /** An entry corresponding for input for JiraAttachmentsField */
    JiraAttachmentsField?: InputMaybe<Array<JiraUpdateAttachmentFieldInput>>;
    /** An entry corresponding for input for JiraCmdbField */
    JiraCMDBField?: InputMaybe<Array<JiraUpdateCmdbFieldInput>>;
    /** An entry corresponding for input for JiraCascadingSelectField */
    JiraCascadingSelectField?: InputMaybe<
        Array<JiraUpdateCascadingSelectFieldInput>
    >;
    /** An entry corresponding for input for JiraCheckboxesField */
    JiraCheckboxesField?: InputMaybe<Array<JiraUpdateCheckboxesFieldInput>>;
    /** An entry corresponding for input for JiraColorField */
    JiraColorField?: InputMaybe<Array<JiraUpdateColorFieldInput>>;
    /** An entry corresponding for input for JirComponentsField */
    JiraComponentsField?: InputMaybe<Array<JiraUpdateComponentsFieldInput>>;
    /** An entry corresponding for input for JiraConnectMultipleSelectField */
    JiraConnectMultipleSelectField?: InputMaybe<
        Array<JiraUpdateMultipleSelectFieldInput>
    >;
    /** An entry corresponding for input for JiraConnectNumberField */
    JiraConnectNumberField?: InputMaybe<Array<JiraUpdateNumberFieldInput>>;
    /** An entry corresponding for input for JiraConnectRichTextField */
    JiraConnectRichTextField?: InputMaybe<Array<JiraUpdateRichTextFieldInput>>;
    /** An entry corresponding for input for JiraConnectSingleSelectField */
    JiraConnectSingleSelectField?: InputMaybe<
        Array<JiraUpdateSingleSelectFieldInput>
    >;
    /** An entry corresponding for input for JiraConnectTextField */
    JiraConnectTextField?: InputMaybe<
        Array<JiraUpdateSingleLineTextFieldInput>
    >;
    /** An entry corresponding for input for JiraDatePickerField */
    JiraDatePickerField?: InputMaybe<Array<JiraUpdateDateFieldInput>>;
    /** An entry corresponding for input for JiraDateTimePickerField */
    JiraDateTimePickerField?: InputMaybe<Array<JiraUpdateDateTimeFieldInput>>;
    /** An entry corresponding for input for JiraForgeDateField */
    JiraForgeDateField?: InputMaybe<Array<JiraUpdateDateFieldInput>>;
    /** An entry corresponding for input for JiraForgeDatetimeField */
    JiraForgeDatetimeField?: InputMaybe<Array<JiraUpdateDateTimeFieldInput>>;
    /** An entry corresponding for input for JiraForgeGroupField */
    JiraForgeGroupField?: InputMaybe<
        Array<JiraUpdateForgeSingleGroupPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraForgeGroupsField */
    JiraForgeGroupsField?: InputMaybe<
        Array<JiraUpdateForgeMultipleGroupPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraForgeNumberField */
    JiraForgeNumberField?: InputMaybe<Array<JiraUpdateNumberFieldInput>>;
    /** An entry corresponding for input for JiraForgeObjectField */
    JiraForgeObjectField?: InputMaybe<Array<JiraUpdateForgeObjectFieldInput>>;
    /** An entry corresponding for input for JiraForgeStringField */
    JiraForgeStringField?: InputMaybe<
        Array<JiraUpdateSingleLineTextFieldInput>
    >;
    /** An entry corresponding for input for JiraForgeStringsField */
    JiraForgeStringsField?: InputMaybe<Array<JiraUpdateLabelsFieldInput>>;
    /** An entry corresponding for input for JiraForgeUserField */
    JiraForgeUserField?: InputMaybe<
        Array<JiraUpdateSingleSelectUserPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraForgeUsersField */
    JiraForgeUsersField?: InputMaybe<
        Array<JiraUpdateMultipleSelectUserPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraIssueLinkField */
    JiraIssueLinkField?: InputMaybe<
        Array<JiraUpdateIssueLinkFieldInputForIssueTransitions>
    >;
    /** An entry corresponding for input for JiraIssueTypeField */
    JiraIssueTypeField?: InputMaybe<Array<JiraUpdateIssueTypeFieldInput>>;
    /** An entry corresponding for input for JiraLabelsField */
    JiraLabelsField?: InputMaybe<Array<JiraUpdateLabelsFieldInput>>;
    /** An entry corresponding for input for JiraMultipleGroupPickerField */
    JiraMultipleGroupPickerField?: InputMaybe<
        Array<JiraUpdateMultipleGroupPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraMultipleSelectField */
    JiraMultipleSelectField?: InputMaybe<
        Array<JiraUpdateMultipleSelectFieldInput>
    >;
    /** An entry corresponding for input for JiraMultipleSelectUserPickerField */
    JiraMultipleSelectUserPickerField?: InputMaybe<
        Array<JiraUpdateMultipleSelectUserPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraMultipleVersionPickerField */
    JiraMultipleVersionPickerField?: InputMaybe<
        Array<JiraUpdateMultipleVersionPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraNumberField */
    JiraNumberField?: InputMaybe<Array<JiraUpdateNumberFieldInput>>;
    /** An entry corresponding for input for JiraParentIssueField */
    JiraParentIssueField?: InputMaybe<Array<JiraUpdateParentFieldInput>>;
    /** An entry corresponding for input for JiraPeopleField */
    JiraPeopleField?: InputMaybe<Array<JiraUpdatePeopleFieldInput>>;
    /** An entry corresponding for input for JiraPriorityField */
    JiraPriorityField?: InputMaybe<Array<JiraUpdatePriorityFieldInput>>;
    /** An entry corresponding for input for JiraProjectField */
    JiraProjectField?: InputMaybe<Array<JiraUpdateProjectFieldInput>>;
    /** An entry corresponding for input for JiraRadioSelectField */
    JiraRadioSelectField?: InputMaybe<Array<JiraUpdateRadioSelectFieldInput>>;
    /** An entry corresponding for input for JiraResolutionField */
    JiraResolutionField?: InputMaybe<Array<JiraUpdateResolutionFieldInput>>;
    /** An entry corresponding for input for JiraRichTextField */
    JiraRichTextField?: InputMaybe<Array<JiraUpdateRichTextFieldInput>>;
    /** An entry corresponding for input for JiraSecurityLevelField */
    JiraSecurityLevelField?: InputMaybe<
        Array<JiraUpdateSecurityLevelFieldInput>
    >;
    /** An entry corresponding for input for JiraServiceManagementOrganizationField */
    JiraServiceManagementOrganizationField?: InputMaybe<
        Array<JiraServiceManagementUpdateOrganizationFieldInput>
    >;
    /** An entry corresponding for input for JiraSingleGroupPickerField */
    JiraSingleGroupPickerField?: InputMaybe<
        Array<JiraUpdateSingleGroupPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraSingleLineTextField */
    JiraSingleLineTextField?: InputMaybe<
        Array<JiraUpdateSingleLineTextFieldInput>
    >;
    /** An entry corresponding for input for JiraSingleSelectField */
    JiraSingleSelectField?: InputMaybe<Array<JiraUpdateSingleSelectFieldInput>>;
    /** An entry corresponding for input for JiraSingleSelectUserPickerField */
    JiraSingleSelectUserPickerField?: InputMaybe<
        Array<JiraUpdateSingleSelectUserPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraSingleVersionPickerField */
    JiraSingleVersionPickerField?: InputMaybe<
        Array<JiraUpdateSingleVersionPickerFieldInput>
    >;
    /** An entry corresponding for input for JiraSprintField */
    JiraSprintField?: InputMaybe<Array<JiraUpdateSprintFieldInput>>;
    /** An entry corresponding for input for JiraTeamViewField */
    JiraTeamViewField?: InputMaybe<Array<JiraUpdateTeamFieldInput>>;
    /** An entry corresponding for input for JiraTimeTrackingField */
    JiraTimeTrackingField?: InputMaybe<Array<JiraUpdateTimeTrackingFieldInput>>;
    /** An entry corresponding for input for JiraURLField */
    JiraUrlField?: InputMaybe<Array<JiraUpdateUrlFieldInput>>;
    /** An entry corresponding for input for JiraWorkLogField */
    JiraWorkLogField?: InputMaybe<
        Array<JiraUpdateWorklogFieldInputForIssueTransitions>
    >;
};

/** Enum representing different types of messages to be shown on modal load screen */
export enum JiraIssueTransitionLayoutMessageType {
    /** An error message type is sent when there is any error while fetching the screen */
    Error = "ERROR",
    /** An info message configured on the transition modal */
    Info = "INFO",
    /** A send a success message during modal load */
    Success = "SUCCESS",
    /** A warning message that might be configured on the BE or shown based on the screen configuration/field support etc. */
    Warn = "WARN"
}

/** Represents the messages to be shown on the Transition Modal Load screen */
export type JiraIssueTransitionMessage = {
    __typename?: "JiraIssueTransitionMessage";
    /** Message to be displayed on the modal load */
    content?: Maybe<JiraRichText>;
    /** Url for the icon of the message */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Title for the message */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Type of message ex: warning, error, etc. */
    type?: Maybe<JiraIssueTransitionLayoutMessageType>;
};

/** Represents the issue transition modal load screen */
export type JiraIssueTransitionModal = {
    __typename?: "JiraIssueTransitionModal";
    /** Represent comments to be showed on transition screen */
    comment?: Maybe<JiraIssueTransitionComment>;
    /** Represents List of tabs on Transition Modal load screen */
    contentSections?: Maybe<JiraScreenTabLayout>;
    /** Description for the transition modal */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Jira Issue. Represents the issue data. */
    issue?: Maybe<JiraIssue>;
    /** Error, warning or info messages to be shown on the modal */
    messages?: Maybe<Array<Maybe<JiraIssueTransitionMessage>>>;
    /** Reminding message for the screen configured by remind people to update field rule used in TMP projects */
    remindingMessage?: Maybe<Scalars["String"]["output"]>;
    /** Title of the Transition modal */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** The type for response payload, to be returned after making a transition for the issue */
export type JiraIssueTransitionResponse = Payload & {
    __typename?: "JiraIssueTransitionResponse";
    /** List of errors encountered while attempting the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** Indicates the success status of the mutation */
    success: Scalars["Boolean"]["output"];
};

/** Represents an Issue type, e.g. story, task, bug. */
export type JiraIssueType = Node & {
    __typename?: "JiraIssueType";
    /** Avatar of the Issue type. */
    avatar?: Maybe<JiraAvatar>;
    /** Description of the Issue type. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The IssueType hierarchy level */
    hierarchy?: Maybe<JiraIssueTypeHierarchyLevel>;
    /** Global identifier of the Issue type. */
    id: Scalars["ID"]["output"];
    /** This is the internal id of the IssueType. */
    issueTypeId?: Maybe<Scalars["String"]["output"]>;
    /** Name of the Issue type. */
    name: Scalars["String"]["output"];
};

/** The connection type for JiraIssueType. */
export type JiraIssueTypeConnection = {
    __typename?: "JiraIssueTypeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraIssueTypeEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraCommentConnection connection. */
export type JiraIssueTypeEdge = {
    __typename?: "JiraIssueTypeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraIssueType>;
};

/** Represents an issue type field on a Jira Issue. */
export type JiraIssueTypeField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraIssueTypeField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /**
         * "
         * The issue type selected on the Issue or default issue type configured for the field.
         */
        issueType?: Maybe<JiraIssueType>;
        /**
         * List of issuetype options available to be selected for the field.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        issueTypes?: Maybe<JiraIssueTypeConnection>;
        /**
         * List of issuetype options available to be selected for the field on Transition screen
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraIssueTypesForTransition")' query directive to the 'issueTypesForTransition' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        issueTypesForTransition?: Maybe<JiraIssueTypeConnection>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
    };

/** Represents an issue type field on a Jira Issue. */
export type JiraIssueTypeFieldIssueTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents an issue type field on a Jira Issue. */
export type JiraIssueTypeFieldIssueTypesForTransitionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for defining the operation on the IssueType field of a Jira issue. */
export type JiraIssueTypeFieldOperationInput = {
    /** Accepts : issue-type */
    id: Scalars["ID"]["input"];
    /** Only SET operation is supported. */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating the IssueType field of a Jira issue. */
export type JiraIssueTypeFieldPayload = Payload & {
    __typename?: "JiraIssueTypeFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated IssueType field. */
    field?: Maybe<JiraIssueTypeField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Return only issue types that match this filter */
export type JiraIssueTypeFilterInput = {
    /** All issue types with a level max or lower will be returned. */
    maxHierarchyLevel?: InputMaybe<Scalars["Int"]["input"]>;
    /** All issue types with a level min or higher will be returned */
    minHierarchyLevel?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * The Jira IssueType hierarchy level.
 * Hierarchy levels represent Issue parent-child relationships using an integer scale.
 */
export type JiraIssueTypeHierarchyLevel = {
    __typename?: "JiraIssueTypeHierarchyLevel";
    /**
     * The global hierarchy level of the IssueType.
     * E.g. -1 for subtask level, 0 for base level, 1 for epic level.
     */
    level?: Maybe<Scalars["Int"]["output"]>;
    /** The name of the IssueType hierarchy level. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Input type for issue type field */
export type JiraIssueTypeInput = {
    /** An identifier for the field */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** An identifier for a issue type value */
    issueTypeId: Scalars["ID"]["input"];
};

export type JiraIssueUpdatedStreamHubPayload = {
    __typename?: "JiraIssueUpdatedStreamHubPayload";
    /** The updated issue's ARI. */
    resource?: Maybe<Scalars["ID"]["output"]>;
};

/** The options for the activity feed sort order. */
export enum JiraIssueViewActivityFeedSortOrder {
    NewestFirst = "NEWEST_FIRST",
    OldestFirst = "OLDEST_FIRST"
}

/** The options for displaying activity layout. */
export enum JiraIssueViewActivityLayout {
    Horizontal = "HORIZONTAL",
    Vertical = "VERTICAL"
}

/** The options for the selected attachment view. */
export enum JiraIssueViewAttachmentPanelViewMode {
    ListView = "LIST_VIEW",
    StripView = "STRIP_VIEW"
}

/** The options for displaying timestamps. */
export enum JiraIssueViewTimestampDisplayMode {
    Absolute = "ABSOLUTE",
    Relative = "RELATIVE"
}

export type JiraIssueWithScenario = {
    __typename?: "JiraIssueWithScenario";
    /** Errors happened during query */
    errors?: Maybe<Array<QueryError>>;
    /** Whether this issue fits in the scope and configuration provided in the calendar query. */
    isInScope?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this issue fits in the scope and configuration provided in the calendar query and it's unscheduled. */
    isUnscheduled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Issue with the ID provided, `null` if issue does not exist. */
    scenarioIssueLike?: Maybe<JiraScenarioIssueLike>;
};

export enum JiraIteration {
    Iteration_1 = "ITERATION_1",
    Iteration_2 = "ITERATION_2",
    IterationDynamic = "ITERATION_DYNAMIC"
}

/** The options for jql builder search mode. */
export enum JiraJqlBuilderSearchMode {
    /** JQL text based builder. */
    Advanced = "ADVANCED",
    /** User friendly JQL Builder. */
    Basic = "BASIC"
}

export type JiraJqlBuilderSearchModeMutationPayload = Payload & {
    __typename?: "JiraJQLBuilderSearchModeMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    /** The newly set jql builder search mode. */
    jqlBuilderSearchMode?: Maybe<JiraJqlBuilderSearchMode>;
    success: Scalars["Boolean"]["output"];
    /**
     * The newly set user search mode.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use jqlBuilderSearchMode
     */
    userSearchMode?: Maybe<JiraJqlBuilderSearchMode>;
};

export type JiraJqlContextFieldsFilter = {
    /**
     * Fields to be excluded from the result.
     * This is an optional parameter that will attempt to exactly match individual field names and filter them from the result.
     */
    excludeJqlTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only the fields that support the provided JqlClauseType will be returned. */
    forClause?: InputMaybe<JiraJqlClauseType>;
    /** Only the jqlTerms requested will be returned. */
    jqlTerms?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only the fields that contain this searchString in their displayName will be returned. */
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * When true only the fields that are shown in JQL context are returned
     * When false only the fields that are not shown in JQL context are returned
     * When null or not specified, all fields are returned
     */
    shouldShowInContext?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The representation for Natural Language to JQL generation response */
export type JiraJqlFromNaturalLanguage = {
    __typename?: "JiraJQLFromNaturalLanguage";
    /** jql generated for the request */
    generatedJQL?: Maybe<Scalars["String"]["output"]>;
    generatedJQLError?: Maybe<JiraJqlGenerationError>;
};

/** The possible errors that can occur during a JQL generation. */
export type JiraJqlGenerationError =
    | JiraGeneratedJqlInvalidError
    | JiraInvalidJqlError
    | JiraInvalidSyntaxError
    | JiraServerError
    | JiraUiExposedError
    | JiraUnsupportedLanguageError
    | JiraUsageLimitExceededError;

/** JQL History Node. Includes the jql. */
export type JiraJqlHistory = Node & {
    __typename?: "JiraJQLHistory";
    /** Unique identifier associated with this History. */
    id: Scalars["ID"]["output"];
    /** JQL Query */
    jql?: Maybe<Scalars["String"]["output"]>;
    /** Time of creation */
    lastViewed?: Maybe<Scalars["DateTime"]["output"]>;
};

/** The connection to a list of JQL History. */
export type JiraJqlHistoryConnection = {
    __typename?: "JiraJQLHistoryConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlHistoryEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JQL History connection. */
export type JiraJqlHistoryEdge = {
    __typename?: "JiraJQLHistoryEdge";
    /** The item at the end of the edge. */
    node?: Maybe<JiraJqlHistory>;
};

export type JiraJourneyBuilderAssociatedAutomationRule = {
    __typename?: "JiraJourneyBuilderAssociatedAutomationRule";
    /** The UUID of the Automation Rule */
    id: Scalars["ID"]["output"];
};

export type JiraJourneyConfiguration = Node & {
    __typename?: "JiraJourneyConfiguration";
    /**
     * List of activity configuration of the journey configuration
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with journeyItems to support different types of configuration like dependency
     */
    activityConfigurations?: Maybe<Array<Maybe<JiraActivityConfiguration>>>;
    /** Created time of the journey configuration */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The user who created the journey configuration */
    createdBy?: Maybe<User>;
    /** Id of the journey configuration */
    id: Scalars["ID"]["output"];
    /** List of journey items of the journey configuration */
    journeyItems?: Maybe<Array<JiraJourneyItem>>;
    /** Name of the journey configuration */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Parent issue of the journey configuration */
    parentIssue?: Maybe<JiraJourneyParentIssue>;
    /** Status of the journey configuration */
    status?: Maybe<JiraJourneyStatus>;
    /**
     * The trigger of this journey
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with triggerConfiguration to support union typing
     */
    trigger?: Maybe<JiraJourneyTrigger>;
    /** The trigger configuration of this journey */
    triggerConfiguration?: Maybe<JiraJourneyTriggerConfiguration>;
    /** Last updated time of the journey configuration */
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The user who last updated the journey configuration */
    updatedBy?: Maybe<User>;
    /** The version number of the entity. */
    version?: Maybe<Scalars["Long"]["output"]>;
};

export type JiraJourneyConfigurationConnection = {
    __typename?: "JiraJourneyConfigurationConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJourneyConfigurationEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraJourneyConfigurationEdge = {
    __typename?: "JiraJourneyConfigurationEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJourneyConfiguration>;
};

export type JiraJourneyItem = JiraJourneyStatusDependency | JiraJourneyWorkItem;

export type JiraJourneyItemCommon = {
    /** Id of the journey item */
    id: Scalars["ID"]["output"];
    /** Name of the journey item */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JiraJourneyItemConfigurationInput = {
    statusDependencyConfiguration?: InputMaybe<JiraJourneyStatusDependencyConfigurationInput>;
    workItemConfiguration?: InputMaybe<JiraJourneyWorkItemConfigurationInput>;
};

export type JiraJourneyParentIssue = {
    __typename?: "JiraJourneyParentIssue";
    /** The id of the project which the parent issue belongs to */
    project?: Maybe<JiraProject>;
    /** The value of the parent issue, the value is determined by the implementation type */
    value?: Maybe<JiraJourneyParentIssueValueType>;
};

export type JiraJourneyParentIssueInput = {
    /** The id of the project which the parent issue belongs to */
    projectId: Scalars["ID"]["input"];
    /** The type of the parent issue, e.g. 'request' */
    type: JiraJourneyParentIssueType;
    /** The value of the parent issue, e.g. '10000' */
    value: Scalars["String"]["input"];
};

export type JiraJourneyParentIssueTriggerConfiguration = {
    __typename?: "JiraJourneyParentIssueTriggerConfiguration";
    /** The type of the trigger, i.e. 'PARENT_ISSUE_CREATED' */
    type?: Maybe<JiraJourneyTriggerType>;
};

export type JiraJourneyParentIssueTriggerConfigurationInput = {
    /** The type of the trigger. should be 'PARENT_ISSUE_CREATED' */
    type?: InputMaybe<JiraJourneyTriggerType>;
};

export enum JiraJourneyParentIssueType {
    /** Jira issue */
    Request = "REQUEST"
}

export type JiraJourneyParentIssueValueType = JiraServiceManagementRequestType;

export enum JiraJourneyStatus {
    /** The journey is archived and can not be triggered or modified */
    Archived = "ARCHIVED",
    /** The journey is disabled and can not be triggered */
    Disabled = "DISABLED",
    /** The journey is in draft status and can not be triggered */
    Draft = "DRAFT",
    /** The journey is enabled and can be triggered */
    Published = "PUBLISHED"
}

export type JiraJourneyStatusDependency = JiraJourneyItemCommon & {
    __typename?: "JiraJourneyStatusDependency";
    /** Id of the journey item */
    id: Scalars["ID"]["output"];
    /** Name of the journey item */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The list of ids for statuses that work items should be in to satisfy this dependency
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with statuses
     */
    statusIds?: Maybe<Array<Scalars["String"]["output"]>>;
    /**
     * The type of work item status stored in statusIds
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with statuses
     */
    statusType?: Maybe<JiraJourneyStatusDependencyType>;
    /** The list of statuses that work items should be in to satisfy this dependency */
    statuses?: Maybe<Array<JiraJourneyStatusDependencyStatus>>;
    /**
     * The list of dependent journey work item ids
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with workItems
     */
    workItemIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** The list of dependent journey work items */
    workItems?: Maybe<Array<JiraJourneyWorkItem>>;
};

export type JiraJourneyStatusDependencyConfigurationInput = {
    /** The list of statuses that work items should be in to satisfy this dependency */
    statuses?: InputMaybe<
        Array<JiraJourneyStatusDependencyConfigurationStatusInput>
    >;
    /** The list of dependent journey work item ids */
    workItemIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type JiraJourneyStatusDependencyConfigurationStatusInput = {
    /** ID of the status */
    id: Scalars["ID"]["input"];
    /** Type of the status */
    type: JiraJourneyStatusDependencyType;
};

export type JiraJourneyStatusDependencyStatus = {
    __typename?: "JiraJourneyStatusDependencyStatus";
    /** ID of the status */
    id: Scalars["ID"]["output"];
    /** Name of the status */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Type of the status */
    type?: Maybe<JiraJourneyStatusDependencyType>;
};

export enum JiraJourneyStatusDependencyType {
    Status = "STATUS",
    StatusCategory = "STATUS_CATEGORY"
}

/** @deprecated(reason : "Replaced with JiraJourneyTriggerConfiguration to support union typing") */
export type JiraJourneyTrigger = {
    __typename?: "JiraJourneyTrigger";
    /** The type of the trigger, e.g. 'JiraJourneyTriggerType.PARENT_ISSUE_CREATED' */
    type: JiraJourneyTriggerType;
};

export type JiraJourneyTriggerConfiguration =
    | JiraJourneyParentIssueTriggerConfiguration
    | JiraJourneyWorkdayIntegrationTriggerConfiguration;

export type JiraJourneyTriggerConfigurationInput = {
    parentIssueTriggerConfiguration?: InputMaybe<JiraJourneyParentIssueTriggerConfigurationInput>;
    workdayIntegrationTriggerConfiguration?: InputMaybe<JiraJourneyWorkdayIntegrationTriggerConfigurationInput>;
};

/** @deprecated(reason : "Replaced with JiraJourneyTriggerConfigurationInput to support @oneOf directive") */
export type JiraJourneyTriggerInput = {
    /** The type of the trigger, e.g. 'parentIssueCreated' */
    type: JiraJourneyTriggerType;
};

export enum JiraJourneyTriggerType {
    /** When a parent issue is created */
    ParentIssueCreated = "PARENT_ISSUE_CREATED",
    /** When workday integration is triggered */
    WorkdayIntegrationTriggered = "WORKDAY_INTEGRATION_TRIGGERED"
}

export type JiraJourneyWorkItem = JiraJourneyItemCommon & {
    __typename?: "JiraJourneyWorkItem";
    /** The Automation rules associated with the Journey Work Item */
    associatedAutomationRules?: Maybe<
        Array<JiraJourneyBuilderAssociatedAutomationRule>
    >;
    /** Field value mapping. It contains list of object which is like a map entry including a string key and array of string value */
    fieldValues?: Maybe<Array<JiraJourneyWorkItemFieldValueKeyValuePair>>;
    /** Id of the journey item */
    id: Scalars["ID"]["output"];
    /** Issue type of the work item */
    issueType?: Maybe<JiraIssueType>;
    /** Name of the journey item */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Project of the work item */
    project?: Maybe<JiraProject>;
    /** Request type of the work item */
    requestType?: Maybe<JiraServiceManagementRequestType>;
};

export type JiraJourneyWorkItemConfigurationInput = {
    /** Field value mapping. It contains list of object which is like a map entry including a string key and array of string value */
    fieldValues?: InputMaybe<
        Array<InputMaybe<JiraJourneyWorkItemFieldValueKeyValuePairInput>>
    >;
    /** Issue type of the work item */
    issueTypeId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Name of the work item */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Project of the work item */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Request type of the work item */
    requestTypeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraJourneyWorkItemFieldValueKeyValuePair = {
    __typename?: "JiraJourneyWorkItemFieldValueKeyValuePair";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type JiraJourneyWorkItemFieldValueKeyValuePairInput = {
    key: Scalars["String"]["input"];
    value: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type JiraJourneyWorkdayIntegrationTriggerConfiguration = {
    __typename?: "JiraJourneyWorkdayIntegrationTriggerConfiguration";
    /** The automation rule id */
    ruleId?: Maybe<Scalars["ID"]["output"]>;
    /** The type of the trigger, i.e. 'WORKDAY_INTEGRATION_TRIGGERED' */
    type?: Maybe<JiraJourneyTriggerType>;
};

export type JiraJourneyWorkdayIntegrationTriggerConfigurationInput = {
    /** The automation rule id */
    ruleId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The type of the trigger. should be 'WORKDAY_INTEGRATION_TRIGGERED' */
    type?: InputMaybe<JiraJourneyTriggerType>;
};

/**
 * The autocomplete types available for Jira fields in the context of the Jira Query Language.
 *
 * This enum also describes which fields have field-value support from this schema.
 */
export enum JiraJqlAutocompleteType {
    /** The Jira basic field JQL autocomplete type. */
    Basic = "BASIC",
    /** The Jira cascadingOption field JQL autocomplete type. */
    Cascadingoption = "CASCADINGOPTION",
    /** The Jira component field JQL autocomplete type. */
    Component = "COMPONENT",
    /** The Jira group field JQL autocomplete type. */
    Group = "GROUP",
    /** The Jira issue field JQL autocomplete type. */
    Issue = "ISSUE",
    /** The Jira issue field type JQL autocomplete type. */
    Issuetype = "ISSUETYPE",
    /** The Jira JWM Category field type JQL autocomplete type. */
    JwmCategory = "JWM_CATEGORY",
    /** The Jira labels field type JQL autocomplete type. */
    Labels = "LABELS",
    /** No autocomplete support. */
    None = "NONE",
    /** The Jira option field type JQL autocomplete type. */
    Option = "OPTION",
    /** The Jira Organization field JQL autocomplete type. */
    Organization = "ORGANIZATION",
    /** The Jira priority field JQL autocomplete type. */
    Priority = "PRIORITY",
    /** The Jira project field JQL autocomplete type. */
    Project = "PROJECT",
    /** The Jira RequestType field JQL autocomplete type. */
    Requesttype = "REQUESTTYPE",
    /** The Jira resolution field JQL autocomplete type. */
    Resolution = "RESOLUTION",
    /** The Jira sprint field JQL autocomplete type. */
    Sprint = "SPRINT",
    /** The Jira status field JQL autocomplete type. */
    Status = "STATUS",
    /** The Jira status category field JQL autocomplete type. */
    Statuscategory = "STATUSCATEGORY",
    /** The Jira TicketCategory field JQL autocomplete type. */
    TicketCategory = "TICKET_CATEGORY",
    /** The Jira user field JQL autocomplete type. */
    User = "USER",
    /** The Jira version field JQL autocomplete type. */
    Version = "VERSION"
}

/** Represents what is needed to define the scope to a Jira board */
export type JiraJqlBoardInput = {
    /** ID of the board */
    boardId: Scalars["Long"]["input"];
    /** Swimlane strategy of the board */
    swimlaneStrategy?: InputMaybe<JiraBoardSwimlaneStrategy>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilder = {
    __typename?: "JiraJqlBuilder";
    /** Retrieves the field-values for the Jira cascading select options field. */
    cascadingSelectValues?: Maybe<JiraJqlCascadingOptionFieldValueConnection>;
    /**
     * Retrieves a connection of field-values for a specified Jira Field.
     *
     * E.g. A given Jira checkbox field may have the following field-values: `Option 1`, `Option 2` and `Option 3`.
     */
    fieldValues?: Maybe<JiraJqlFieldValueConnection>;
    /** This field is the same as `jira.fields` */
    fields?: Maybe<JiraJqlFieldConnectionResult>;
    /** A list of available JQL functions. */
    functions: Array<JiraJqlFunction>;
    /** Hydrates the JQL fields and field-values of a given JQL query. */
    hydrateJqlQuery?: Maybe<JiraJqlHydratedQueryResult>;
    /**
     * Hydrates the JQL fields and field-values of a filter corresponding to the provided filter ID.
     *
     * The id provided MUST be in ARI format.
     *
     * This query will error if the id parameter is not in ARI format, does not pass validation or does not correspond to a JiraFilter.
     */
    hydrateJqlQueryForFilter?: Maybe<JiraJqlHydratedQueryResult>;
    /** Retrieves the field-values for the Jira issueType field. */
    issueTypes?: Maybe<JiraJqlIssueTypes>;
    /** Retrieves a connection of Jira fields recently used in JQL searches. */
    recentFields?: Maybe<JiraJqlFieldConnectionResult>;
    /** Retrieves a connection of projects that have recently been viewed by the current user. */
    recentlyUsedProjects?: Maybe<JiraJqlProjectFieldValueConnection>;
    /** Retrieves a connection of sprints that have recently been viewed by the current user. */
    recentlyUsedSprints?: Maybe<JiraJqlSprintFieldValueConnection>;
    /** Retrieves a connection of users recently used in Jira user fields. */
    recentlyUsedUsers?: Maybe<JiraJqlUserFieldValueConnection>;
    /**
     * Retrieves a connection of suggested groups.
     *
     * Groups are suggested when the current user is a member.
     */
    suggestedGroups?: Maybe<JiraJqlGroupFieldValueConnection>;
    /** Retrieves the field-values for the Jira version field. */
    versions?: Maybe<JiraJqlVersions>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderCascadingSelectValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter: JiraCascadingSelectOptionsFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    jqlTerm: Scalars["String"]["input"];
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderFieldValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    jqlTerm: Scalars["String"]["input"];
    projectOptions?: InputMaybe<JiraProjectOptions>;
    scope?: InputMaybe<JiraJqlScopeInput>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    viewContext?: InputMaybe<JiraJqlViewContext>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    excludeFields?: InputMaybe<Array<Scalars["String"]["input"]>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    forClause?: InputMaybe<JiraJqlClauseType>;
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    jqlContextFieldsFilter?: InputMaybe<JiraJqlContextFieldsFilter>;
    scope?: InputMaybe<JiraJqlScopeInput>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    viewContext?: InputMaybe<JiraJqlViewContext>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderHydrateJqlQueryArgs = {
    query?: InputMaybe<Scalars["String"]["input"]>;
    viewContext?: InputMaybe<JiraJqlViewContext>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderHydrateJqlQueryForFilterArgs = {
    id: Scalars["ID"]["input"];
    viewContext?: InputMaybe<JiraJqlViewContext>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderIssueTypesArgs = {
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderRecentFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    forClause?: InputMaybe<JiraJqlClauseType>;
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderRecentlyUsedProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    projectOptions?: InputMaybe<JiraProjectOptions>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderRecentlyUsedSprintsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderRecentlyUsedUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderSuggestedGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    context?: InputMaybe<JiraGroupsContext>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */
export type JiraJqlBuilderVersionsArgs = {
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    jqlTerm: Scalars["String"]["input"];
};

/** The modes the JQL builder can be displayed and used in. */
export enum JiraJqlBuilderMode {
    /**
     * The basic mode, allows queries to be built and executed via the JQL basic editor.
     *
     * This mode allows users to easily construct JQL queries by interacting with the UI.
     */
    Basic = "BASIC",
    /**
     * The JQL mode, allows queries to be built and executed via the JQL advanced editor.
     *
     * This mode allows users to manually type and construct complex JQL queries.
     */
    Jql = "JQL"
}

/** Represents a field-value for a JQL cascading option field. */
export type JiraJqlCascadingOptionFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlCascadingOptionFieldValue";
    /** The user-friendly name for a cascading option JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira cascading option field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The ID of the option that is being referred. */
    optionId?: Maybe<Scalars["ID"]["output"]>;
    /** The Jira JQL parent option associated with this JQL field value. */
    parentOption?: Maybe<JiraJqlCascadingOptionFieldValue>;
};

/** Represents a connection of field-values for a JQL cascading option field. */
export type JiraJqlCascadingOptionFieldValueConnection = {
    __typename?: "JiraJqlCascadingOptionFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlCascadingOptionFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlCacsdingOptionFieldValues matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL cascading option field. */
export type JiraJqlCascadingOptionFieldValueEdge = {
    __typename?: "JiraJqlCascadingOptionFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraJqlCascadingOptionFieldValue>;
};

/** The types of JQL clauses supported by Jira. */
export enum JiraJqlClauseType {
    /** This denotes both WHERE and ORDER_BY. */
    Any = "ANY",
    /** This corresponds to fields used to sort Jira Issues. */
    OrderBy = "ORDER_BY",
    /** This corresponds to jql fields used as filter criteria of Jira issues. */
    Where = "WHERE"
}

/** Represents a field-value for a JQL component field. */
export type JiraJqlComponentFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlComponentFieldValue";
    /**
     * The Jira Component associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    component?: Maybe<JiraComponent>;
    /**
     * The user-friendly name for a component JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira component field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
};

/** The representation of a Jira field within the context of the Jira Query Language. */
export type JiraJqlField = {
    __typename?: "JiraJqlField";
    /** The JQL clause types that can be used with this field. */
    allowedClauseTypes: Array<JiraJqlClauseType>;
    /** Defines how the field-values should be shown for a field in the JQL-Builder's JQL mode. */
    autoCompleteTemplate?: Maybe<JiraJqlAutocompleteType>;
    /**
     * The data types handled by the current field.
     * These can be used to identify which JQL functions are supported.
     */
    dataTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Description of the current field. This information is only applicable for custom fields. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The user-friendly name for the current field, to be displayed in the UI. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * The ID of the underlying field if applicable (e.g. assignee, customfield_1234). Only set when this JQL field
     * represents a single field. Returns null when this JQL field does not represent an actual field or represents
     * a set of collapsed fields
     */
    fieldId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The field-type of the current field.
     * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
     * Important note: This information only exists for collapsed fields.
     */
    fieldType?: Maybe<JiraFieldType>;
    /**
     * The field-type of the current field.
     * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
     * Important note: This information only exists for collapsed fields.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use fieldType instead
     */
    jqlFieldType?: Maybe<JiraJqlFieldType>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field.
     *
     * Important note: this jqlTerm could require proper escaping before placing it  into a query (e.g. wrap it in "" ).
     */
    jqlTerm: Scalars["ID"]["output"];
    /** The JQL operators that can be used with this field. */
    operators: Array<JiraJqlOperator>;
    /** Defines how a field should be represented in the basic search mode of the JQL builder. */
    searchTemplate?: Maybe<JiraJqlSearchTemplate>;
    /** Determines whether or not the current field should be accessible in the current search context. */
    shouldShowInContext?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Underlying field type for the given field.
     * This can be used to determine how the field needs to be rendered in UI
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a connection of Jira JQL fields. */
export type JiraJqlFieldConnection = {
    __typename?: "JiraJqlFieldConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlFieldEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlFields matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A union of a Jira JQL field connection and a GraphQL query error. */
export type JiraJqlFieldConnectionResult = JiraJqlFieldConnection | QueryError;

/** Represents a Jira JQL field edge. */
export type JiraJqlFieldEdge = {
    __typename?: "JiraJqlFieldEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlField>;
};

/**
 * The representation of a Jira JQL field-type in the context of the Jira Query Language.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 *
 * Important note: This information only exists for collapsed fields.
 */
export type JiraJqlFieldType = {
    __typename?: "JiraJqlFieldType";
    /** The translated name of the field type. */
    displayName: Scalars["String"]["output"];
    /** The non-translated name of the field type. */
    jqlTerm: Scalars["String"]["output"];
};

/** A generic interface for JQL fields in Jira. */
export type JiraJqlFieldValue = {
    /** The user-friendly name for a component JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a connection of field-values for a JQL field. */
export type JiraJqlFieldValueConnection = {
    __typename?: "JiraJqlFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlFieldValues matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL field. */
export type JiraJqlFieldValueEdge = {
    __typename?: "JiraJqlFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlFieldValue>;
};

/** The representation of a Jira field within the context of the Jira Query Language with minimal metadata and its aliases that can be used in JQL query. */
export type JiraJqlFieldWithAliases = {
    __typename?: "JiraJqlFieldWithAliases";
    /** The aliases that can be used in a JQL query to refer to the Jira JQL field. The aliases are case-insensitive. These can include the field name, jqlTerm, untranslated name. */
    aliases?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The ID of the field (e.g. assignee, customfield_1234) */
    fieldId?: Maybe<Scalars["ID"]["output"]>;
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field. */
    jqlTerm: Scalars["ID"]["output"];
};

/**
 * A function in JQL appears as a word followed by parentheses, which may contain one or more explicit values or Jira fields.
 *
 * In a clause, a function is preceded by an operator, which in turn is preceded by a field.
 *
 * A function performs a calculation on either specific Jira data or the function's content in parentheses,
 * such that only true results are retrieved by the function, and then again by the clause in which the function is used.
 *
 * E.g. `approved()`, `currentUser()`, `endOfMonth()` etc.
 */
export type JiraJqlFunction = {
    __typename?: "JiraJqlFunction";
    /**
     * The data types that this function handles and creates values for.
     *
     * This allows consumers to infer information on the JiraJqlField type such as which functions are supported.
     */
    dataTypes: Array<Scalars["String"]["output"]>;
    /** The user-friendly name for the function, to be displayed in the UI. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * Indicates whether or not the function is meant to be used with IN or NOT IN operators, that is,
     * if the function should be viewed as returning a list.
     *
     * The method should return false when it is to be used with the other relational operators (e.g. =, !=, <, >, ...)
     * that only work with single values.
     */
    isList?: Maybe<Scalars["Boolean"]["output"]>;
    /** A JQL-function safe encoded name. This value will not be encoded if the displayName is already safe. */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** The representation of custom JQL function processing status. */
export type JiraJqlFunctionProcessingStatus = {
    __typename?: "JiraJqlFunctionProcessingStatus";
    /** The name of the app implementing JQL function logic. */
    app?: Maybe<Scalars["String"]["output"]>;
    /** The name of the JQL function. */
    function: Scalars["String"]["output"];
    /** The status of the JQL function processing. */
    status: JiraJqlFunctionStatus;
};

export enum JiraJqlFunctionStatus {
    Finished = "FINISHED",
    Processing = "PROCESSING",
    Unknown = "UNKNOWN"
}

/** Represents a field-value for a JQL goals field. */
export type JiraJqlGoalsFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlGoalsFieldValue";
    /**
     * The user-friendly name for a JQL goal field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira group field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * The Jira goal associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    goal: JiraGoal;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira goal field-value.
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a field-value for a JQL group field. */
export type JiraJqlGroupFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlGroupFieldValue";
    /** The user-friendly name for a group JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /** The Jira group associated with this JQL field value. */
    group: JiraGroup;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira group field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a connection of field-values for a JQL group field. */
export type JiraJqlGroupFieldValueConnection = {
    __typename?: "JiraJqlGroupFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlGroupFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlGroupFieldValues matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL group field. */
export type JiraJqlGroupFieldValueEdge = {
    __typename?: "JiraJqlGroupFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlGroupFieldValue>;
};

/** Represents a JQL query with hydrated fields and field-values. */
export type JiraJqlHydratedQuery = {
    __typename?: "JiraJqlHydratedQuery";
    /** A list of hydrated fields from the provided JQL. */
    fields: Array<JiraJqlQueryHydratedFieldResult>;
    /** The JQL query to be hydrated. */
    jql?: Maybe<Scalars["String"]["output"]>;
};

/** A union of a Jira JQL hydrated query and a GraphQL query error. */
export type JiraJqlHydratedQueryResult = JiraJqlHydratedQuery | QueryError;

/** Represents a field-value for a JQL Issue field. */
export type JiraJqlIssueFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlIssueFieldValue";
    /**
     * The user-friendly name for an issue JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The Jira issue associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issue: JiraIssue;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a field-value for a JQL issue type field. */
export type JiraJqlIssueTypeFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlIssueTypeFieldValue";
    /** The user-friendly name for an issue type JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /** The Jira issue types associated with this JQL field value. */
    issueTypes: Array<JiraIssueType>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira issue type field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a connection of field-values for a JQL issue type field. */
export type JiraJqlIssueTypeFieldValueConnection = {
    __typename?: "JiraJqlIssueTypeFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlIssueTypeFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlIssueTypeFieldValues matching the criteria */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL issue type field. */
export type JiraJqlIssueTypeFieldValueEdge = {
    __typename?: "JiraJqlIssueTypeFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlIssueTypeFieldValue>;
};

/** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */
export type JiraJqlIssueTypes = {
    __typename?: "JiraJqlIssueTypes";
    /**
     * Retrieves top-level issue types that encapsulate all others.
     *
     * E.g. The `Epic` issue type in company-managed projects.
     */
    aboveBaseLevel?: Maybe<JiraJqlIssueTypeFieldValueConnection>;
    /**
     * Retrieves mid-level issue types.
     *
     * E.g. The `Bug`, `Story` and `Task` issue type in company-managed projects.
     */
    baseLevel?: Maybe<JiraJqlIssueTypeFieldValueConnection>;
    /**
     * Retrieves the lowest level issue types.
     *
     * E.g. The `Subtask` issue type in company-managed projects.
     */
    belowBaseLevel?: Maybe<JiraJqlIssueTypeFieldValueConnection>;
};

/** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */
export type JiraJqlIssueTypesAboveBaseLevelArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */
export type JiraJqlIssueTypesBaseLevelArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */
export type JiraJqlIssueTypesBelowBaseLevelArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a field-value for a JQL label field. */
export type JiraJqlLabelFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlLabelFieldValue";
    /**
     * The user-friendly name for a label JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira label field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * The Jira label associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    label?: Maybe<JiraLabel>;
};

/** Represents a field-value for a JQL number field. */
export type JiraJqlNumberFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlNumberFieldValue";
    /**
     * The user-friendly name for a JQL goal field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira group field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira goal field-value.
     *
     * Important note: By default, this jqlTerm is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * Number value for this JQL field value
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    number?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * The types of JQL operators supported by Jira.
 *
 * An operator in JQL is one or more symbols or words,which compares the value of a field on its left with one or more values (or functions) on its right,
 * such that only true results are retrieved by the clause.
 *
 * For more information on JQL operators please visit: https://support.atlassian.com/jira-software-cloud/docs/advanced-search-reference-jql-operators.
 */
export enum JiraJqlOperator {
    /** The `CHANGED` operator is used to find issues that have a value that had changed for the specified field. */
    Changed = "CHANGED",
    /** The `CHANGED` operator is used to find issues that have a value that had changed for the specified field. */
    Contains = "CONTAINS",
    /** The `=` operator is used to search for issues where the value of the specified field exactly matches the specified value. */
    Equals = "EQUALS",
    /** The `>` operator is used to search for issues where the value of the specified field is greater than the specified value. */
    GreaterThan = "GREATER_THAN",
    /** The `>=` operator is used to search for issues where the value of the specified field is greater than or equal to the specified value. */
    GreaterThanOrEqual = "GREATER_THAN_OR_EQUAL",
    /** The `IN` operator is used to search for issues where the value of the specified field is one of multiple specified values. */
    In = "IN",
    /** The `IS` operator can only be used with EMPTY or NULL. That is, it is used to search for issues where the specified field has no value. */
    Is = "IS",
    /** The `IS NOT` operator can only be used with EMPTY or NULL. That is, it is used to search for issues where the specified field has a value. */
    IsNot = "IS_NOT",
    /** The `<` operator is used to search for issues where the value of the specified field is less than the specified value. */
    LessThan = "LESS_THAN",
    /** The `<=` operator is used to search for issues where the value of the specified field is less than or equal to than the specified value. */
    LessThanOrEqual = "LESS_THAN_OR_EQUAL",
    /** The `!~` operator is used to search for issues where the value of the specified field is not a "fuzzy" match for the specified value. */
    NotContains = "NOT_CONTAINS",
    /** The `!=` operator is used to search for issues where the value of the specified field does not match the specified value. */
    NotEquals = "NOT_EQUALS",
    /** The `NOT IN` operator is used to search for issues where the value of the specified field is not one of multiple specified values. */
    NotIn = "NOT_IN",
    /** The `WAS` operator is used to find issues that currently have or previously had the specified value for the specified field. */
    Was = "WAS",
    /** The `WAS IN` operator is used to find issues that currently have or previously had any of multiple specified values for the specified field. */
    WasIn = "WAS_IN",
    /** The `WAS NOT` operator is used to find issues that have never had the specified value for the specified field. */
    WasNot = "WAS_NOT",
    /** The `WAS NOT IN` operator is used to search for issues where the value of the specified field has never been one of multiple specified values. */
    WasNotIn = "WAS_NOT_IN"
}

/** Represents a field-value for a JQL option field. */
export type JiraJqlOptionFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlOptionFieldValue";
    /**
     * The user-friendly name for an option JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira option field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * The Jira Option associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    option?: Maybe<JiraOption>;
};

/** Represents a connection of field-values for a JQL option field. */
export type JiraJqlOptionFieldValueConnection = {
    __typename?: "JiraJqlOptionFieldValueConnection";
    /**
     * The data for the edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraJqlOptionFieldValueEdge>>>;
    /**
     * The page info of the current page of results.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total number of JiraJqlOptionFieldValues matching the criteria.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL option field. */
export type JiraJqlOptionFieldValueEdge = {
    __typename?: "JiraJqlOptionFieldValueEdge";
    /**
     * The cursor to this edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     * The node at the edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<JiraJqlOptionFieldValue>;
};

/** Represents a field-value for a JQL plain text field (as opposed to a rich text one) such as summary. */
export type JiraJqlPlainTextFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlPlainTextFieldValue";
    /**
     * The user-friendly name for a label JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira plain text field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a field-value for a JQL priority field. */
export type JiraJqlPriorityFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlPriorityFieldValue";
    /**
     * The user-friendly name for a priority JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira priority field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * The Jira property associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    priority: JiraPriority;
};

/** Represents a field-value for a JQL project field. */
export type JiraJqlProjectFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlProjectFieldValue";
    /** The user-friendly name for a project JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira project field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The Jira project associated with this JQL field value. */
    project: JiraProject;
};

/** Represents a connection of field-values for a JQL project field. */
export type JiraJqlProjectFieldValueConnection = {
    __typename?: "JiraJqlProjectFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlProjectFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlProjectFieldValues matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL project field. */
export type JiraJqlProjectFieldValueEdge = {
    __typename?: "JiraJqlProjectFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlProjectFieldValue>;
};

/** Represents an error for a JQL query hydration. */
export type JiraJqlQueryHydratedError = {
    __typename?: "JiraJqlQueryHydratedError";
    /** The error that occurred whilst hydrating the Jira JQL field. */
    error?: Maybe<QueryError>;
    /** An identifier for the hydrated Jira JQL field where the error occurred. */
    jqlTerm: Scalars["String"]["output"];
};

/** Represents a hydrated field for a JQL query. */
export type JiraJqlQueryHydratedField = {
    __typename?: "JiraJqlQueryHydratedField";
    /** The encoded jqlTerm for the hydrated Jira JQL field. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /** The Jira JQL field associated with the hydrated field. */
    field: JiraJqlField;
    /**
     * An identifier for the hydrated Jira JQL field.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The hydrated value results. */
    values: Array<Maybe<JiraJqlQueryHydratedValueResult>>;
};

/** A union of a JQL query hydrated field and a GraphQL query error. */
export type JiraJqlQueryHydratedFieldResult =
    | JiraJqlQueryHydratedError
    | JiraJqlQueryHydratedField;

/** Represents a hydrated field-value for a given field in the JQL query. */
export type JiraJqlQueryHydratedValue = {
    __typename?: "JiraJqlQueryHydratedValue";
    /** The encoded jqlTerm for the hydrated Jira JQL field value. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * An identifier for the hydrated Jira JQL field value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The hydrated field values. */
    values: Array<Maybe<JiraJqlFieldValue>>;
};

/** A union of a JQL query hydrated field-value and a GraphQL query error. */
export type JiraJqlQueryHydratedValueResult =
    | JiraJqlQueryHydratedError
    | JiraJqlQueryHydratedValue;

/** Represents a field-value for a JQL resolution field. */
export type JiraJqlResolutionFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlResolutionFieldValue";
    /**
     * The user-friendly name for a resolution JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira resolution field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * The Jira resolution associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolution?: Maybe<JiraResolution>;
};

/** Scope to provide specific logic for contexts that require additional inputs */
export type JiraJqlScopeInput = {
    /** When the scope is a Jira board */
    board?: InputMaybe<JiraJqlBoardInput>;
};

/** The representation of a Jira field in the basic search mode of the JQL builder. */
export type JiraJqlSearchTemplate = {
    __typename?: "JiraJqlSearchTemplate";
    key?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a field-value for a JQL sprint field. */
export type JiraJqlSprintFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlSprintFieldValue";
    /** The user-friendly name for a sprint JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira sprint field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The Jira sprint associated with this JQL field value. */
    sprint: JiraSprint;
};

/** Represents a connection of field-values for a JQL sprint field. */
export type JiraJqlSprintFieldValueConnection = {
    __typename?: "JiraJqlSprintFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlSprintFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlSprintFieldValues matching the criteria */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL sprint field. */
export type JiraJqlSprintFieldValueEdge = {
    __typename?: "JiraJqlSprintFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlSprintFieldValue>;
};

/** Represents a field-value for a JQL status category field. */
export type JiraJqlStatusCategoryFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlStatusCategoryFieldValue";
    /**
     * The user-friendly name for a status category JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira status category field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * The Jira status category associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCategory: JiraStatusCategory;
};

/** Represents a field-value for a JQL status field. */
export type JiraJqlStatusFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlStatusFieldValue";
    /**
     * The user-friendly name for a status JQL field value, to be displayed in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira status field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jqlTerm: Scalars["String"]["output"];
    /**
     * The Jira Status associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<JiraStatus>;
    /**
     * The Jira status category associated with this JQL field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCategory: JiraStatusCategory;
};

export enum JiraJqlSyntaxError {
    BadFieldId = "BAD_FIELD_ID",
    BadFunctionArgument = "BAD_FUNCTION_ARGUMENT",
    BadOperator = "BAD_OPERATOR",
    BadPropertyId = "BAD_PROPERTY_ID",
    EmptyField = "EMPTY_FIELD",
    EmptyFunction = "EMPTY_FUNCTION",
    EmptyFunctionArgument = "EMPTY_FUNCTION_ARGUMENT",
    IllegalCharacter = "ILLEGAL_CHARACTER",
    IllegalEscape = "ILLEGAL_ESCAPE",
    IllegalNumber = "ILLEGAL_NUMBER",
    MissingFieldName = "MISSING_FIELD_NAME",
    MissingLogicalOperator = "MISSING_LOGICAL_OPERATOR",
    NoOperator = "NO_OPERATOR",
    NoOrder = "NO_ORDER",
    OperandUnsupported = "OPERAND_UNSUPPORTED",
    PredicateUnsupported = "PREDICATE_UNSUPPORTED",
    ReservedCharacter = "RESERVED_CHARACTER",
    ReservedWord = "RESERVED_WORD",
    UnexpectedText = "UNEXPECTED_TEXT",
    UnfinishedString = "UNFINISHED_STRING",
    Unknown = "UNKNOWN"
}

/** Represents a field-value for a JQL user field. */
export type JiraJqlUserFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlUserFieldValue";
    /** The user-friendly name for a user JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira user field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The user associated with this JQL field value. */
    user?: Maybe<User>;
};

/** Represents a connection of field-values for a JQL user field. */
export type JiraJqlUserFieldValueConnection = {
    __typename?: "JiraJqlUserFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlUserFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlUserFieldValues matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL user field. */
export type JiraJqlUserFieldValueEdge = {
    __typename?: "JiraJqlUserFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlUserFieldValue>;
};

/** Represents a field-value for a JQL version field. */
export type JiraJqlVersionFieldValue = JiraJqlFieldValue & {
    __typename?: "JiraJqlVersionFieldValue";
    /** The user-friendly name for a version JQL field value, to be displayed in the UI. */
    displayName: Scalars["String"]["output"];
    /** An identifier that a client should use in a JQL query when it’s referring to a Jira JQL field-value in encoded form. */
    encodedJqlTerm?: Maybe<Scalars["String"]["output"]>;
    /**
     * Whether or not the field value is selected.
     * Important note: Currently only applicable when request is board scoped. Defaults to null otherwise.
     */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An identifier that a client should use in a JQL query when it’s referring to a Jira version field-value.
     *
     * Important note: If you are expecting to use an encoded jqlTerm, please use `encodedJqlTerm` instead.
     * For now, this `jqlTerm` is returned as an escaped string (wrapped in "") if the value has space or some special characters.
     * This is a temporary solution until the functionality is handled properly by the impacted clients by switching to use `encodedJqlTerm`.
     * Then, we will soon remove the escaping and return the `jqlTerm` as a plain string.
     */
    jqlTerm: Scalars["String"]["output"];
    /** The Jira Version represents this value. */
    version?: Maybe<JiraVersion>;
};

/** Represents a connection of field-values for a JQL version field. */
export type JiraJqlVersionFieldValueConnection = {
    __typename?: "JiraJqlVersionFieldValueConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraJqlVersionFieldValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of JiraJqlVersionFieldValues matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a field-value edge for a JQL version field. */
export type JiraJqlVersionFieldValueEdge = {
    __typename?: "JiraJqlVersionFieldValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraJqlVersionFieldValue>;
};

/**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */
export type JiraJqlVersions = {
    __typename?: "JiraJqlVersions";
    /** Retrieves a connection of archived versions. */
    archived?: Maybe<JiraJqlVersionFieldValueConnection>;
    /** Retrieves a connection of released versions. */
    released?: Maybe<JiraJqlVersionFieldValueConnection>;
    /** Retrieves a connection of unreleased versions. */
    unreleased?: Maybe<JiraJqlVersionFieldValueConnection>;
};

/**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */
export type JiraJqlVersionsArchivedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */
export type JiraJqlVersionsReleasedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */
export type JiraJqlVersionsUnreleasedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The types of view contexts supported by JQL Fields. */
export enum JiraJqlViewContext {
    /** This corresponds to fields requested for Jira Product Discovery Roadmaps. */
    JpdRoadmaps = "JPD_ROADMAPS",
    /** This corresponds to fields requested for Jira Software Plans. */
    JswPlans = "JSW_PLANS",
    /** This corresponds to fields requested for Jira Work Management (JWM). */
    Jwm = "JWM",
    /** This corresponds to the shadow request client. */
    ShadowRequest = "SHADOW_REQUEST"
}

export type JiraJwmField = {
    __typename?: "JiraJwmField";
    /** The encrypted data of the mutated custom field */
    encryptedData?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the label of a custom label field. */
export type JiraLabel = {
    __typename?: "JiraLabel";
    /**
     * The identifier of the label.
     * Can be null when label is not yet created or label was returned without providing an Issue id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    labelId?: Maybe<Scalars["String"]["output"]>;
    /**
     * The name of the label.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraLabel. */
export type JiraLabelConnection = {
    __typename?: "JiraLabelConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraLabelEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a Jiralabel connection. */
export type JiraLabelEdge = {
    __typename?: "JiraLabelEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraLabel>;
};

/** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */
export type JiraLabelsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraLabelsField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /**
         * Paginated list of label options for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        labels?: Maybe<JiraLabelConnection>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available label options on a field or an Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The labels selected on the Issue or default labels configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedLabelsConnection instead.
         */
        selectedLabels?: Maybe<Array<Maybe<JiraLabel>>>;
        /** The labels selected on the Issue or default labels configured for the field. */
        selectedLabelsConnection?: Maybe<JiraLabelConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */
export type JiraLabelsFieldLabelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    currentProjectOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    sessionId?: InputMaybe<Scalars["ID"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */
export type JiraLabelsFieldSelectedLabelsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for labels field */
export type JiraLabelsFieldInput = {
    /** Option selected from the multi select operation */
    bulkEditMultiSelectFieldOption?: InputMaybe<JiraBulkEditMultiSelectFieldOptions>;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** List of labels on which the action will be performed */
    labels?: InputMaybe<Array<JiraLabelsInput>>;
};

export type JiraLabelsFieldOperationInput = {
    labels: Array<Scalars["String"]["input"]>;
    operation: JiraMultiValueFieldOperations;
};

export type JiraLabelsFieldPayload = Payload & {
    __typename?: "JiraLabelsFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraLabelsField>;
    success: Scalars["Boolean"]["output"];
};

/** Represents the data of a single Label */
export type JiraLabelsInput = {
    /** Name of the label selected */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for defining the operation on the Team field of a Jira issue. */
export type JiraLegacyTeamFieldOperationInput = {
    /**
     * The operation to perform on the Team field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
    /** Accepts the team ID */
    teamId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The payload type returned after updating the Team field of a Jira issue. */
export type JiraLegacyTeamFieldPayload = Payload & {
    __typename?: "JiraLegacyTeamFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Team field. */
    field?: Maybe<JiraTeamField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input to link/unlink an issue to/from a related work item. */
export type JiraLinkIssueToVersionRelatedWorkInput = {
    /**
     * The identifier for the Jira issue. To unlink an issue from the related work item, leave this field
     * as null.
     */
    issueId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Client-generated ID for the related work item. */
    relatedWorkId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The type of related work item being assigned. */
    relatedWorkType: JiraVersionRelatedWorkType;
    /** The identifier of the Jira version. */
    versionId: Scalars["ID"]["input"];
};

/** The return payload for linking and unlinking an issue to and from a related work item. */
export type JiraLinkIssueToVersionRelatedWorkPayload = Payload & {
    __typename?: "JiraLinkIssueToVersionRelatedWorkPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The related work item that an issue was linked to or unlinked from. */
    relatedWork?: Maybe<JiraVersionRelatedWorkV2>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export enum JiraLinkIssuesToIncidentIssueLinkTypeName {
    PostIncidentReviews = "POST_INCIDENT_REVIEWS",
    Relates = "RELATES"
}

export type JiraLinkIssuesToIncidentMutationInput = {
    /** The id of the JSM incident to have issues linked to it. */
    incidentId: Scalars["ID"]["input"];
    /**
     * The ids of the issues to link to an incident. This can be a JSW issue as an
     * action item or a JSM issues as a post incident review.
     */
    issueIds: Array<Scalars["ID"]["input"]>;
    /**
     * The issue link type to create. If not provided, will fall back to the first
     * found one. The issue link created will use the outbound issue link name i.e.
     *
     * RELATES -> incident 'relates to' issue
     * POST_INCIDENT_REVIEWS -> incident 'reviewed by' issue
     */
    issueLinkTypeName: JiraLinkIssuesToIncidentIssueLinkTypeName;
};

export type JiraLinkIssuesToIncidentMutationPayload = Payload & {
    __typename?: "JiraLinkIssuesToIncidentMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type JiraLinkedIssuesInput = {
    /** Accepts ARI(s): issue */
    inwardIssues?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Accepts ARI(s): issue */
    outwardIssues?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** JiraIssueSearchViewType type that represents a List view in NIN */
export type JiraListView = JiraIssueSearchViewMetadata &
    JiraIssueSearchViewType &
    JiraSpreadsheetView &
    JiraView &
    Node & {
        __typename?: "JiraListView";
        /**
         * Errors which were encountered while fetching the connection.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        error?: Maybe<QueryError>;
        /**
         * A connection of included fields' configurations, grouped where logical (e.g. collapsed fields).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
        /**
         * The tenant specific id of the filter that will be used to get the JiraIssueSearchView
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterId?: Maybe<Scalars["String"]["output"]>;
        /**
         * A nullable boolean indicating if the IssueSearchView is using default fieldSets
         * true -> Issue search view is using default fieldSets
         * false -> Issue search view has custom fieldSets
         * null -> Not applicable for requested issue search view
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * An ARI-format value that encodes both namespace and viewId.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * A nullable boolean indicating if the Issue Hierarchy is enabled
         * true -> Issue Hierarchy is enabled
         * false -> Issue Hierarchy is disabled
         * null -> If any error has occured in fetching the preference. The hierarchy will be disabled.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Retrieves a connection of JiraIssues for the current JiraIssueSearchInput.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issues?: Maybe<JiraIssueConnection>;
        /**
         * JQL built from provided search parameters
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        jql?: Maybe<Scalars["String"]["output"]>;
        /**
         * A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        namespace?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Use viewSettings instead
         */
        settings?: Maybe<JiraSpreadsheetViewSettings>;
        /**
         * A unique identifier for this view within its namespace, or the global namespace if no namespace is defined.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        viewId?: Maybe<Scalars["String"]["output"]>;
        /**
         * Jira view setting for the user.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        viewSettings?: Maybe<JiraIssueSearchViewConfigSettings>;
    };

/** JiraIssueSearchViewType type that represents a List view in NIN */
export type JiraListViewFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** JiraIssueSearchViewType type that represents a List view in NIN */
export type JiraListViewIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    fieldSetsInput?: InputMaybe<JiraIssueSearchFieldSetsInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    options?: InputMaybe<JiraIssueSearchOptions>;
    saveJQLToUserHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
    scope?: InputMaybe<JiraIssueSearchScope>;
    viewConfigInput?: InputMaybe<JiraIssueSearchViewConfigInput>;
};

/** JiraIssueSearchViewType type that represents a List view in NIN */
export type JiraListViewViewSettingsArgs = {
    groupBy?: InputMaybe<Scalars["String"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    staticViewInput?: InputMaybe<JiraIssueSearchStaticViewInput>;
};

/** Represents the current state of a long running task. */
export type JiraLongRunningTaskProgress = {
    __typename?: "JiraLongRunningTaskProgress";
    /** The description of the overall task such as "Deleting Project: Project Name". */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The current message that describes the current state of the task. */
    message?: Maybe<Scalars["String"]["output"]>;
    /**
     * "
     * The current task progress from 0 to 100%.
     */
    progress: Scalars["Long"]["output"];
    /**
     * An arbitrary string the task runner sets on completion, cancellation or failure of a project.
     * This may never be set if it is never needed. This also may not be a human readable result.
     */
    result?: Maybe<Scalars["String"]["output"]>;
    /** A date/time indicating the actual task start moment. */
    startTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** The current status of the task. */
    status: JiraLongRunningTaskStatus;
};

export enum JiraLongRunningTaskStatus {
    /** Indicates someone has been successfully cancelled */
    Cancelled = "CANCELLED",
    /** Indicates someone has requested the task to be cancelled */
    CancelRequested = "CANCEL_REQUESTED",
    /** Indicates the task has been successfully completed */
    Complete = "COMPLETE",
    /** Indicates the task has been unresponsive for some time and was marked to be dead */
    Dead = "DEAD",
    /** Indicates the task has been created and waiting in the queue */
    Enqueued = "ENQUEUED",
    /** Indicates the task has failed */
    Failed = "FAILED",
    /** Indicates the task is currently running */
    Running = "RUNNING"
}

/** Description of a single file attachment definition. */
export type JiraMediaAttachmentFile = {
    __typename?: "JiraMediaAttachmentFile";
    /** ID of the attachment file. */
    attachmentId?: Maybe<Scalars["String"]["output"]>;
    /** Media API ID of the attachment file. */
    attachmentMediaApiId?: Maybe<Scalars["String"]["output"]>;
    /** Jira Issue ID that the attachment file belong to. */
    issueId?: Maybe<Scalars["String"]["output"]>;
};

/** A connection for JiraMediaAttachmentFile. */
export type JiraMediaAttachmentFileConnection = {
    __typename?: "JiraMediaAttachmentFileConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraMediaAttachmentFileEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraMediaAttachmentFile connection. */
export type JiraMediaAttachmentFileEdge = {
    __typename?: "JiraMediaAttachmentFileEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraMediaAttachmentFile>;
};

/** A Jira Background Media, containing a reference to a custom background */
export type JiraMediaBackground = JiraBackground & {
    __typename?: "JiraMediaBackground";
    /** The customBackground that the background is set to */
    customBackground?: Maybe<JiraCustomBackground>;
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

/** Represents a media context used for file uploads. */
export type JiraMediaContext = {
    __typename?: "JiraMediaContext";
    /** Contains the token information for uploading a media content. */
    uploadToken?: Maybe<JiraMediaUploadTokenResult>;
};

/** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */
export type JiraMediaReadToken = {
    __typename?: "JiraMediaReadToken";
    /** Registered client id of media API. */
    clientId?: Maybe<Scalars["String"]["output"]>;
    /** Endpoint where the media content will be read. */
    endpointUrl?: Maybe<Scalars["String"]["output"]>;
    /** Token lifespan which it can be used to read media content in seconds. */
    tokenLifespanInSeconds?: Maybe<Scalars["Long"]["output"]>;
    /** Connection of the files available to be read for the given jira issue, with their respective read token. */
    tokensWithFiles?: Maybe<JiraMediaTokenWithFilesConnection>;
};

/** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */
export type JiraMediaReadTokenTokensWithFilesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Entry of an attachment read token with its respective files accessible. */
export type JiraMediaTokenWithFiles = {
    __typename?: "JiraMediaTokenWithFiles";
    /** Connection of the files that can be read with the token string. */
    files?: Maybe<JiraMediaAttachmentFileConnection>;
    /** Token string used to read files in the following list. */
    token?: Maybe<Scalars["String"]["output"]>;
};

/** Entry of an attachment read token with its respective files accessible. */
export type JiraMediaTokenWithFilesFilesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A connection for JiraMediaTokenWithFiles. */
export type JiraMediaTokenWithFilesConnection = {
    __typename?: "JiraMediaTokenWithFilesConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraMediaTokenWithFilesEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraMediaTokenWithFiles connection. */
export type JiraMediaTokenWithFilesEdge = {
    __typename?: "JiraMediaTokenWithFilesEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraMediaTokenWithFiles>;
};

/** Contains the information needed for uploading a media content in jira on issue create/view screens. */
export type JiraMediaUploadToken = {
    __typename?: "JiraMediaUploadToken";
    /** Registered client id of media API. */
    clientId?: Maybe<Scalars["String"]["output"]>;
    /** Endpoint where the media content will be uploaded. */
    endpointUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The collection in which to put the new files.
     * It can be user-scoped (such as upload-user-collection-*)
     * or project scoped (such as upload-project-*).
     */
    targetCollection?: Maybe<Scalars["String"]["output"]>;
    /** token string value which can be used with Media API requests. */
    token?: Maybe<Scalars["String"]["output"]>;
    /** Represents the duration (in minutes) for which token will be valid. */
    tokenDurationInMin?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains either the successful fetched media token information or an error. */
export type JiraMediaUploadTokenResult = JiraMediaUploadToken | QueryError;

export type JiraMentionable = {
    __typename?: "JiraMentionable";
    /** Mentionable team with user details */
    team?: Maybe<JiraTeamView>;
    /** Mentionable user with user details */
    user?: Maybe<User>;
};

export type JiraMentionableConnection = {
    __typename?: "JiraMentionableConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraMentionableEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
};

export type JiraMentionableEdge = {
    __typename?: "JiraMentionableEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraMentionable>;
};

/**
 * The input to merge one version with another, which deletes the source version and moves
 * all issues from the source version to the target version.
 */
export type JiraMergeVersionInput = {
    /** The ID of the source version that is being merged. */
    id: Scalars["ID"]["input"];
    /** The ID of the target version for the merge. */
    targetVersionId: Scalars["ID"]["input"];
};

/**
 * The input to merge one version with another, which deletes the source version and moves
 * all issues from the source version to the target version.
 */
export type JiraMergeVersionPayload = Payload & {
    __typename?: "JiraMergeVersionPayload";
    /** The ID of the deleted source version. */
    deletedVersionId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The version where issues from the source version have been merged. */
    targetVersion?: Maybe<JiraVersion>;
};

/** The input to reassign issues from an existing fix version to another fix version. */
export type JiraMoveIssuesToFixVersionInput = {
    /** The IDs of the issues to be reassigned to another fix version. */
    issueIds: Array<Scalars["ID"]["input"]>;
    /** The ID of the version to remove the issues from. */
    originalVersionId: Scalars["ID"]["input"];
    /** The ID of the version to add the issues to. */
    targetVersionId: Scalars["ID"]["input"];
};

/** The return payload of reassigning issues from an existing fix version to another fix version. */
export type JiraMoveIssuesToFixVersionPayload = Payload & {
    __typename?: "JiraMoveIssuesToFixVersionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** A list of issue keys that the user has selected but does not have the permission to edit */
    issuesWithMissingEditPermission?: Maybe<Array<Scalars["String"]["output"]>>;
    /** A list of issue keys that the user has selected but does not have the permission to resolve */
    issuesWithMissingResolvePermission?: Maybe<
        Array<Scalars["String"]["output"]>
    >;
    /** The updated version which has had its issues removed. */
    originalVersion?: Maybe<JiraVersion>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/**
 * Input to update a version's sequence so that it is the latest version ordered
 * relative to other versions in the project.
 */
export type JiraMoveVersionToEndInput = {
    /** The identifier of the Jira version being updated. */
    id: Scalars["ID"]["input"];
};

/**
 * Input to update a version's sequence so that it is the earliest version ordered
 * relative to other versions in the project.
 */
export type JiraMoveVersionToStartInput = {
    /** The identifier of the Jira version being updated. */
    id: Scalars["ID"]["input"];
};

/** Input type for multi select component field */
export type JiraMultiSelectComponentFieldInput = {
    /** Option selected from the multi select operation */
    bulkEditMultiSelectFieldOption?: InputMaybe<JiraBulkEditMultiSelectFieldOptions>;
    /** List of component fields on which the action will be performed */
    components?: InputMaybe<Array<JiraComponentInput>>;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
};

/** Operations that can be performed on multi value fields like labels, components, etc. */
export enum JiraMultiValueFieldOperations {
    /** Adds value to multi value field. */
    Add = "ADD",
    /** Removes value from multi value field. */
    Remove = "REMOVE",
    /** Overrides multi value field. */
    Set = "SET"
}

/** Represents a multiple group picker field on a Jira Issue. */
export type JiraMultipleGroupPickerField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraMultipleGroupPickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of group options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        groups?: Maybe<JiraGroupConnection>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch all group pickers of the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The groups selected on the Issue or default groups configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedGroupsConnection instead.
         */
        selectedGroups?: Maybe<Array<Maybe<JiraGroup>>>;
        /** The groups selected on the Issue or default groups configured for the field. */
        selectedGroupsConnection?: Maybe<JiraGroupConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a multiple group picker field on a Jira Issue. */
export type JiraMultipleGroupPickerFieldGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a multiple group picker field on a Jira Issue. */
export type JiraMultipleGroupPickerFieldSelectedGroupsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for multiple group picker field */
export type JiraMultipleGroupPickerFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** List og groups associated with the field */
    groups: Array<JiraGroupInput>;
};

/** Input type for defining the operation on the MultipleGroupPicker field of a Jira issue. */
export type JiraMultipleGroupPickerFieldOperationInput = {
    /**
     * Group Id(s) for field update.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'ids' param
     */
    groupIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * Group Id(s) for field update.
     * Accepts ARI(s): group
     */
    ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Operations supported: ADD, REMOVE and SET. */
    operation: JiraMultiValueFieldOperations;
};

/** The payload type returned after updating the MultipleGroupPicker field of a Jira issue. */
export type JiraMultipleGroupPickerFieldPayload = Payload & {
    __typename?: "JiraMultipleGroupPickerFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Multiple Group Picker field. */
    field?: Maybe<JiraMultipleGroupPickerField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input type for multiple select clearable user picker fields */
export type JiraMultipleSelectClearableUserPickerFieldInput = {
    fieldId: Scalars["ID"]["input"];
    users?: InputMaybe<Array<JiraUserInput>>;
};

/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectField = JiraHasMultipleSelectedValues &
    JiraHasSelectableValueOptions &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraMultipleSelectField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         * The final list of field options will result from the intersection of filtering from both `searchBy` and `filterById`.
         */
        fieldOptions?: Maybe<JiraOptionConnection>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch all the teams options for the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Paginated list of JiraPriority options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /**
         * The options selected on the Issue or default options configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedOptions instead.
         */
        selectedFieldOptions?: Maybe<Array<Maybe<JiraOption>>>;
        /** The options selected on the Issue or default options configured for the field. */
        selectedOptions?: Maybe<JiraOptionConnection>;
        /** The JiraMultipleSelectField selected options on the Issue or default option configured for the field. */
        selectedValues?: Maybe<JiraSelectableValueConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectFieldFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectFieldSelectedOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the multi-select field on a Jira Issue. */
export type JiraMultipleSelectFieldSelectedValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for multi select field */
export type JiraMultipleSelectFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** List of options on which the action will be performed */
    options: Array<JiraSelectedOptionInput>;
};

export type JiraMultipleSelectFieldOperationInput = {
    /** Accepts ARI(s): issue-field-option */
    ids: Array<Scalars["ID"]["input"]>;
    operation: JiraMultiValueFieldOperations;
};

export type JiraMultipleSelectFieldPayload = Payload & {
    __typename?: "JiraMultipleSelectFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraMultipleSelectField>;
    success: Scalars["Boolean"]["output"];
};

/** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */
export type JiraMultipleSelectUserPickerField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraMultipleSelectUserPickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the entity. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available users options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The users selected on the Issue or default users configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedUsersConnection instead.
         */
        selectedUsers?: Maybe<Array<Maybe<User>>>;
        /** The users selected on the Issue or default users configured for the field. */
        selectedUsersConnection?: Maybe<JiraUserConnection>;
        /** Field type key of the field. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of user options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        users?: Maybe<JiraUserConnection>;
    };

/** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */
export type JiraMultipleSelectUserPickerFieldSelectedUsersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */
export type JiraMultipleSelectUserPickerFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for multiple select user picker fields */
export type JiraMultipleSelectUserPickerFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Input data for users being selected */
    users: Array<JiraUserInput>;
};

/** Input type for defining the operation on MultipleSelectUserPicker field of a Jira issue. */
export type JiraMultipleSelectUserPickerFieldOperationInput = {
    /** Accepts ARI(s): user */
    ids: Array<Scalars["ID"]["input"]>;
    /** The operation to perform on the MultipleSelectUserPicker field. */
    operation: JiraMultiValueFieldOperations;
};

/** The payload type returned after updating MultipleSelectUserPicker field of a Jira issue. */
export type JiraMultipleSelectUserPickerFieldPayload = Payload & {
    __typename?: "JiraMultipleSelectUserPickerFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated MultipleSelectUserPicker field. */
    field?: Maybe<JiraMultipleSelectUserPickerField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerField = JiraHasMultipleSelectedValues &
    JiraHasSelectableValueOptions &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraMultipleVersionPickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Paginated list of JiraMultipleVersionPickerField options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /** The JiraMultipleVersionPickerField selected options on the Issue or default options configured for the field. */
        selectedValues?: Maybe<JiraSelectableValueConnection>;
        /**
         * The versions selected on the Issue or default versions configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedVersionsConnection instead.
         */
        selectedVersions?: Maybe<Array<Maybe<JiraVersion>>>;
        /** The versions selected on the Issue or default versions configured for the field. */
        selectedVersionsConnection?: Maybe<JiraVersionConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of versions options for the field or on a Jira Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        versions?: Maybe<JiraVersionConnection>;
    };

/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerFieldSelectedValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerFieldSelectedVersionsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */
export type JiraMultipleVersionPickerFieldVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for multiple select version picker fields */
export type JiraMultipleVersionPickerFieldInput = {
    /** Option selected from the multi select operation */
    bulkEditMultiSelectFieldOption?: InputMaybe<JiraBulkEditMultiSelectFieldOptions>;
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** List of versions on which the action will be performed */
    versions: Array<JiraVersionInput>;
};

/** Input type for defining the operation on Multiple Version Picker field of a Jira issue. */
export type JiraMultipleVersionPickerFieldOperationInput = {
    /** Accept ARI(s): version */
    ids: Array<Scalars["ID"]["input"]>;
    /**
     * The operations to perform on Multiple Version Picker field.
     * SET, ADD, REMOVE operations are supported.
     */
    operation: JiraMultiValueFieldOperations;
};

/** The payload type returned after updating Multiple Version Picker field of a Jira issue. */
export type JiraMultipleVersionPickerFieldPayload = Payload & {
    __typename?: "JiraMultipleVersionPickerFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Multiple Version Picker field. */
    field?: Maybe<JiraMultipleVersionPickerField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraMutation = {
    __typename?: "JiraMutation";
    /**
     * Bulk add fields to a project by associating to all issue types in the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:jira-project__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsAddFields")' query directive to the 'addFieldsToProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addFieldsToProject?: Maybe<JiraAddFieldsToProjectPayload>;
    /**
     * Associate issues with a fix version.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: AddIssuesToFixVersion` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    addIssuesToFixVersion?: Maybe<JiraAddIssuesToFixVersionPayload>;
    /**
     * Adds an association to the Automation rule to a Journey Work Item
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'addJiraJourneyWorkItemAssociatedAutomationRule' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addJiraJourneyWorkItemAssociatedAutomationRule?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAddVersionApprover")' query directive to the 'addJiraVersionApprover' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addJiraVersionApprover?: Maybe<JiraVersionAddApproverPayload>;
    /**
     * The mutation operation to add one or more new permission grants to the given permission scheme.
     * The operation takes mandatory permission scheme ID.
     * The limit on the new permission grants can be added is set to 50.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    addPermissionSchemeGrants?: Maybe<JiraPermissionSchemeAddGrantPayload>;
    /**
     * Adds a post-incident review link to an incident.
     *
     * To be used by the Incidents in JSW feature.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSoftwarePostIncidentReviews")' query directive to the 'addPostIncidentReviewLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addPostIncidentReviewLink?: Maybe<JiraAddPostIncidentReviewLinkMutationPayload>;
    /**
     * Create a related work item and link it to a version.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: AddRelatedWorkToVersion` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    addRelatedWorkToVersion?: Maybe<JiraAddRelatedWorkToVersionPayload>;
    /**
     * Make a decision on the Jira Approval. Either Approve or Reject
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    answerApprovalDecision?: Maybe<JiraAnswerApprovalDecisionPayload>;
    /**
     * Archive an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'archiveJiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    archiveJiraJourneyConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Assign/unassign a related work item to a user.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAssignVersionRelatedWork")' query directive to the 'assignRelatedWorkToUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated superseded by issue linking
     */
    assignRelatedWorkToUser?: Maybe<JiraAssignRelatedWorkPayload>;
    /**
     * Attribute a list of Unsplash images
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attributeUnsplashImage?: Maybe<JiraUnsplashAttributionPayload>;
    /**
     * Bulk create request types from given input configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraRequestTypeTemplate")' query directive to the 'bulkCreateRequestTypeFromTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    bulkCreateRequestTypeFromTemplate?: Maybe<JiraServiceManagementCreateRequestTypeFromTemplatePayload>;
    /**
     * Performs clone operation on a Jira Issue
     * Takes a input of details for the operation and returns taskId
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueCloneMutation")' query directive to the 'cloneIssue' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    cloneIssue?: Maybe<JiraCloneIssueResponse>;
    /**
     * Creates a new workflow using the given JSM workflow template ID, and a new issue type that the workflow will be associated with.
     * If successful, the response will contain the summary of the newly created workflow and issue type objects; otherwise it will be a list of errors describing what went wrong.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementCreateAndAssociateWorkflowFromTemplate")' query directive to the 'createAndAssociateWorkflowFromJsmTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createAndAssociateWorkflowFromJsmTemplate?: Maybe<JiraServiceManagementCreateAndAssociateWorkflowFromTemplatePayload>;
    /**
     * Create a navigation item of type `JiraAppNavigationItemType` to be added to the navigation of the given
     * scope. The item will be added to the end of the navigation. The item must be referencing a valid installed app
     * and available to the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createAppNavigationItem?: Maybe<JiraCreateNavigationItemPayload>;
    /**
     * Create the approver list field for the TMP project
     *
     * Takes the field name, the TMP project Id and issue type Id, return the created custom field Id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createApproverListField?: Maybe<JiraCreateApproverListFieldPayload>;
    /**
     * Create an attachment given a Media file id and set it as the card cover for an issue
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createAttachmentBackground?: Maybe<JiraCreateAttachmentBackgroundPayload>;
    /**
     * Create a board
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCreateBoard")' query directive to the 'createBoard' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createBoard?: Maybe<JiraCreateBoardPayload>;
    /**
     * Mutation to create an issue on Jira Calendar
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCalendar")' query directive to the 'createCalendarIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createCalendarIssue?: Maybe<JiraCreateCalendarIssuePayload>;
    /**
     * Create a custom background and set it as the current active background for a given entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createCustomBackground?: Maybe<JiraCreateCustomBackgroundPayload>;
    /**
     * Create a custom field in a project that will be added to all issue types in the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsPageCreateCustomField")' query directive to the 'createCustomFieldInProjectAndAddToAllIssueTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createCustomFieldInProjectAndAddToAllIssueTypes?: Maybe<JiraCreateCustomFieldPayload>;
    /**
     * Create a rule. The newly created rule will be on the top of the list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createFormattingRule?: Maybe<JiraCreateFormattingRulePayload>;
    /**
     * Create Jira Issue
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueCreateMutation")' query directive to the 'createIssue' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    createIssue?: Maybe<JiraIssueCreatePayload>;
    /**
     * Mutation to create an issue link(s).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCreateIssueLinks")' query directive to the 'createIssueLinks' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    createIssueLinks?: Maybe<JiraBulkCreateIssueLinksPayload>;
    /**
     * Add new activity configuration to an existing journey configuration
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'createJiraActivityConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Replaced with createJiraJourneyItem
     */
    createJiraActivityConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Create new journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'createJiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createJiraJourneyConfiguration?: Maybe<JiraCreateJourneyConfigurationPayload>;
    /**
     * Add new journey item to an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'createJiraJourneyItem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createJiraJourneyItem?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Mutation to create a new version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCreateVersion")' query directive to the 'createJiraVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createJiraVersion?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Create a custom filter for JWM
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createJwmFilter?: Maybe<JiraWorkManagementCreateFilterPayload>;
    /**
     * Create a JWM issue
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkManagementCreateIssueMutation")' query directive to the 'createJwmIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createJwmIssue?: Maybe<JiraWorkManagementCreateIssuePayload>;
    /**
     * Create a Jira Work Management Overview.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createJwmOverview?: Maybe<JiraWorkManagementGiraCreateOverviewPayload>;
    /**
     * Creates project cleanup recommendations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCreateProjectCleanupRecommendations")' query directive to the 'createProjectCleanupRecommendations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectCleanupRecommendations?: Maybe<JiraCreateProjectCleanupRecommendationsPayload>;
    /**
     * Mutation to create Project Shortcut
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectShortcut")' query directive to the 'createProjectShortcut' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createProjectShortcut?: Maybe<JiraProjectShortcutPayload>;
    /**
     * Create a Release note Confluence page for the given input
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: ReleaseNotes` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createReleaseNoteConfluencePage?: Maybe<JiraCreateReleaseNoteConfluencePagePayload>;
    /**
     * Create a navigation item of type `JiraSimpleNavigationItemType` to be added to the navigation of the given
     * scope. The item will be added to the end of the navigation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createSimpleNavigationItem?: Maybe<JiraCreateNavigationItemPayload>;
    /**
     * Delete a user's custom background
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteCustomBackground?: Maybe<JiraDeleteCustomBackgroundPayload>;
    /**
     * Deletes a Custom Field from the Jira instance.
     * And un-associates it from all field and issue type layouts.
     * Only works for Team Managed Projects.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsPageDeleteCustomField")' query directive to the 'deleteCustomField' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteCustomField?: Maybe<JiraDeleteCustomFieldPayload>;
    /**
     * Delete an existing rule.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteFormattingRule?: Maybe<JiraDeleteFormattingRulePayload>;
    /**
     * Remove a list of groups granted to a global permission.
     * CloudID is required for AGG routing.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGlobalPermissions")' query directive to the 'deleteGlobalPermissionGrant' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    deleteGlobalPermissionGrant?: Maybe<JiraGlobalPermissionDeleteGroupGrantPayload>;
    /**
     * Mutation to delete an issue link. The "issuelinkId" the numerical id stored in the database, and not the ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteIssueLink?: Maybe<JiraDeleteIssueLinkPayload>;
    /**
     * Mutation to delete Issue Navigator JQL History of the User.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDeleteIssueNavigatorJQLHistory")' query directive to the 'deleteIssueNavigatorJQLHistory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteIssueNavigatorJQLHistory?: Maybe<JiraIssueNavigatorJqlHistoryDeletePayload>;
    /**
     * Delete an existing activity configuration from an journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'deleteJiraActivityConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteJiraActivityConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Deletes an approver in a version corresponding to the `id` parameter. `id` must be a version-approver ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDeleteVersionApprover")' query directive to the 'deleteJiraVersionApprover' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteJiraVersionApprover?: Maybe<JiraVersionDeleteApproverPayload>;
    /**
     * Delete a version with no issues.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDeteVersionWithNoIssues")' query directive to the 'deleteJiraVersionWithNoIssues' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteJiraVersionWithNoIssues?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Delete an existing Jira Work Management Overview.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteJwmOverview?: Maybe<JiraWorkManagementGiraDeleteOverviewPayload>;
    /**
     * Delete a navigation item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteNavigationItem?: Maybe<JiraDeleteNavigationItemPayload>;
    /**
     * Deletes the notification preferences for a particular project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteProjectNotificationPreferences?: Maybe<JiraDeleteProjectNotificationPreferencesPayload>;
    /**
     * Mutation to delete a Project Shortcut
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectShortcut")' query directive to the 'deleteProjectShortcut' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteProjectShortcut?: Maybe<JiraProjectShortcutPayload>;
    /**
     * Container for all DevOps related mutations in Jira
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraDevOps` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    devOps?: Maybe<JiraDevOpsMutation>;
    /**
     * Disable an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'disableJiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    disableJiraJourneyConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Make a copy of an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'duplicateJiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    duplicateJiraJourneyConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Edit a custom field in a project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsPageEditCustomField")' query directive to the 'editCustomField' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editCustomField?: Maybe<JiraEditCustomFieldPayload>;
    /**
     * Grant a list of groups a new global permission.
     * CloudID is required for AGG routing.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGlobalPermissions")' query directive to the 'grantGlobalPermission' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    grantGlobalPermission?: Maybe<JiraGlobalPermissionAddGroupGrantPayload>;
    /**
     * Initializes the notification preferences for a particular project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    initializeProjectNotificationPreferences?: Maybe<JiraInitializeProjectNotificationPreferencesPayload>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFilter` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraFilterMutation?: Maybe<JiraFilterMutation>;
    /**
     * Create a new request type category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementRequestTypeCategory")' query directive to the 'jiraServiceManagementCreateRequestTypeCategory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraServiceManagementCreateRequestTypeCategory?: Maybe<JiraServiceManagementRequestTypeCategoryPayload>;
    /**
     * Delete an existing request type category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementRequestTypeCategory")' query directive to the 'jiraServiceManagementDeleteRequestTypeCategory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraServiceManagementDeleteRequestTypeCategory?: Maybe<JiraServiceManagementRequestTypeCategoryDefaultPayload>;
    /**
     * Update an existing request type category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementRequestTypeCategory")' query directive to the 'jiraServiceManagementUpdateRequestTypeCategory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraServiceManagementUpdateRequestTypeCategory?: Maybe<JiraServiceManagementRequestTypeCategoryPayload>;
    /**
     * Associate a Field to Issue Types in JWM. This is only available for TMP Field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkManagementAssociateFieldMutation")' query directive to the 'jwmAssociateField' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jwmAssociateField?: Maybe<JiraWorkManagementAssociateFieldPayload>;
    /**
     * Create a custom background and set it as the current active background for a given entity
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic createCustomBackground field
     */
    jwmCreateCustomBackground?: Maybe<JiraWorkManagementCreateCustomBackgroundPayload>;
    /**
     * Create a saved view for the specified project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced with createSimpleNavigationItem
     */
    jwmCreateSavedView?: Maybe<JiraWorkManagementCreateSavedViewPayload>;
    /**
     * Delete an attachment
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmDeleteAttachment?: Maybe<JiraWorkManagementDeleteAttachmentPayload>;
    /**
     * Delete a user's custom background
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic deleteCustomBackground field
     */
    jwmDeleteCustomBackground?: Maybe<JiraWorkManagementDeleteCustomBackgroundPayload>;
    /**
     * Removes the active background of an entity
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic removeActiveBackground field
     */
    jwmRemoveActiveBackground?: Maybe<JiraWorkManagementRemoveActiveBackgroundPayload>;
    /**
     * Update the active background of an entity
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic updateActiveBackground field
     */
    jwmUpdateActiveBackground?: Maybe<JiraWorkManagementUpdateActiveBackgroundPayload>;
    /**
     * Update a custom background (currently only altText can be updated)
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic updateCustomBackground field
     */
    jwmUpdateCustomBackground?: Maybe<JiraWorkManagementUpdateCustomBackgroundPayload>;
    /**
     * Mutate the changeboarding status relating to the overview-plan migration. This is used to persist
     * the fact that the current user was shown the changeboarding after their overviews were successfully
     * migrated to plans.
     * See https://hello.atlassian.net/wiki/spaces/Spork/pages/3401604606/Migrate+overviews+to+plans
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmUpdateOverviewPlanMigrationChangeboarding?: Maybe<JiraUpdateOverviewPlanMigrationChangeboardingPayload>;
    /**
     * Link/unlink issues to and from a related work item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraLinkIssueToVersionRelatedWork")' query directive to the 'linkIssueToVersionRelatedWork' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkIssueToVersionRelatedWork?: Maybe<JiraLinkIssueToVersionRelatedWorkPayload>;
    /**
     * Links issues to an incident. It is possible to specify whether the issue link
     * should be a 'relates to' or 'reviewed by' link.
     *
     * If no existing issue link is found, then it will fall back to the first issue
     * link type found.
     *
     * If an existing issue link of any type is found, not new issue link will be
     * created and the mutation will succeed.
     *
     * Will return error if user does not have permission to link issues or if issue
     * linking is disabled for the instance.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSoftwarePostIncidentReviews")' query directive to the 'linkIssuesToIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkIssuesToIncident?: Maybe<JiraLinkIssuesToIncidentMutationPayload>;
    /**
     * Makes given transition for an issue
     * Takes a list of field level inputs to perform the mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueTransitionMutation")' query directive to the 'makeTransition' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    makeTransition?: Maybe<JiraIssueTransitionResponse>;
    /**
     * Merge two versions together, deleting the source version and
     * moving all issues from the source version to the target version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraMergeVersion")' query directive to the 'mergeJiraVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mergeJiraVersion?: Maybe<JiraMergeVersionPayload>;
    /**
     * Reassign issues from a fix version to a new fix version.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: MoveOrRemoveIssuesToFixVersion` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    moveIssuesToFixVersion?: Maybe<JiraMoveIssuesToFixVersionPayload>;
    /**
     * Update version to the the latest position relative to other
     * versions in the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraMoveVersionToEnd")' query directive to the 'moveJiraVersionToEnd' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    moveJiraVersionToEnd?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update version to the earliest position relative to other
     * versions in the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraMoveVersionToStart")' query directive to the 'moveJiraVersionToStart' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    moveJiraVersionToStart?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Order an existing rule.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    orderFormatingRule?: Maybe<JiraOrderFormattingRulePayload>;
    /**
     * Publish an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'publishJiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    publishJiraJourneyConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Rank issues against one another using the default rank field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rankIssues?: Maybe<JiraRankMutationPayload>;
    /**
     * Rank a navigation item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rankNavigationItem?: Maybe<JiraRankNavigationItemPayload>;
    /**
     * Removes the active background of an entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    removeActiveBackground?: Maybe<JiraRemoveActiveBackgroundPayload>;
    /**
     * Un-associates a custom field from all field and issue type layouts.
     * Does not delete the field from the Jira instance.
     * Only works for Team Managed Projects.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsPageDeleteCustomField")' query directive to the 'removeCustomField' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeCustomField?: Maybe<JiraRemoveCustomFieldPayload>;
    /**
     * Remove issues from all fix versions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraRemoveIssuesFromAllFixVersions")' query directive to the 'removeIssuesFromAllFixVersions' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    removeIssuesFromAllFixVersions?: Maybe<JiraRemoveIssuesFromAllFixVersionsPayload>;
    /**
     * Remove issues from a fix version.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: MoveOrRemoveIssuesToFixVersion` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    removeIssuesFromFixVersion?: Maybe<JiraRemoveIssuesFromFixVersionPayload>;
    /**
     * Removes an association to the Automation rule to a Journey Work Item
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'removeJiraJourneyWorkItemAssociatedAutomationRule' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeJiraJourneyWorkItemAssociatedAutomationRule?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * The mutation operation to remove one or more existing permission scheme grants in the given permission scheme.
     * The operation takes mandatory permission scheme ID.
     * The limit on the new permission grants can be removed is set to 50.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    removePermissionSchemeGrants?: Maybe<JiraPermissionSchemeRemoveGrantPayload>;
    /**
     * Removes a post-incident review link from an incident.
     *
     * To be used by the Incidents in JSW feature.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSoftwarePostIncidentReviews")' query directive to the 'removePostIncidentReviewLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removePostIncidentReviewLink?: Maybe<JiraRemovePostIncidentReviewLinkMutationPayload>;
    /**
     * Delete a related work item from a version.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RemoveRelatedWorkFromVersion` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    removeRelatedWorkFromVersion?: Maybe<JiraRemoveRelatedWorkFromVersionPayload>;
    /**
     * Rename a navigation item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    renameNavigationItem?: Maybe<JiraRenameNavigationItemPayload>;
    /**
     * Replaces or resets field config sets from the specified JiraIssueSearchView.
     * If replaceFieldSetsInput is specified in fieldSetsInput then the following rules apply:
     * - If the provided nodes contain a node outside the given range of `before` and/or `after`, then those nodes will also be deleted and replaced within the range.
     * - If `before` is provided, then the entire range before that node will be replaced, or error if not found.
     * - If `after` is provided, then the entire range after that node will be replaced, or error if not found.
     * - If `before` and `after` are both provided, then the range between `before` and `after` will be replaced depending on the inclusive value.
     * - If neither `before` or `after` are provided, then the entire range will be replaced.
     *
     * Otherwise, if resetToDefaultFieldSets=true then field config sets for the JiraIssueSearchView will be reset to a default collection determined by the server.
     *
     * The id provided MUST be in ARI format. This mutation will error if the id parameter is not in ARI format, does not pass validation or does not correspond to a JiraIssueSearchView.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    replaceIssueSearchViewFieldSets?: Maybe<JiraIssueSearchViewPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueSearchView")' query directive to the 'replaceSpreadsheetViewFieldSets' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    replaceSpreadsheetViewFieldSets?: Maybe<JiraSpreadsheetViewPayload>;
    /**
     * Save JWM board settings
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use the jira_setBoardViewCompletedIssueSearchCutOff mutation instead
     */
    saveBusinessBoardSettings?: Maybe<JiraWorkManagementBoardSettingsPayload>;
    /**
     * Update version details page's UI collapsed state, that is per user per version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSaveVersionDetailsCollapsedUis")' query directive to the 'saveVersionDetailsCollapsedUis' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    saveVersionDetailsCollapsedUis?: Maybe<JiraVersionDetailsCollapsedUisPayload>;
    /**
     * Update table column hidden state(per user setting) in version details' page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSaveVersionIssueTableColumnHiddenState")' query directive to the 'saveVersionIssueTableColumnHiddenState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    saveVersionIssueTableColumnHiddenState?: Maybe<JiraVersionIssueTableColumnHiddenStatePayload>;
    /**
     * Executes the project cleanup recommendations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraScheduleBulkExecuteProjectCleanupRecommendations")' query directive to the 'scheduleBulkExecuteProjectCleanupRecommendations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scheduleBulkExecuteProjectCleanupRecommendations?: Maybe<JiraBulkCleanupProjectsPayload>;
    /**
     * Mutation to update various fields of a calendar issue
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCalendar")' query directive to the 'scheduleCalendarIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scheduleCalendarIssue?: Maybe<JiraScheduleCalendarIssuePayload>;
    /**
     * Mutation to update various fields of a calendar issue with scenario
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'scheduleCalendarIssueV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    scheduleCalendarIssueV2?: Maybe<JiraScheduleCalendarIssueWithScenarioPayload>;
    /**
     * Sets application properties for the given instance.
     *
     * Takes a list of key/value pairs to be updated, and returns a summary of the mutation result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setApplicationProperties?: Maybe<JiraSetApplicationPropertiesPayload>;
    /**
     * Sets a navigation item as the default view.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setDefaultNavigationItem?: Maybe<JiraSetDefaultNavigationItemPayload>;
    /**
     * Sets isFavourite for the given entityId.
     * Takes an entityId of type entityType to be updated with its desired value, and returns a summary of the mutation result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setEntityIsFavourite?: Maybe<JiraSetIsFavouritePayload>;
    /**
     * Replaces all associations between field and issue types
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:jira-project__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsSetIssueTypes")' query directive to the 'setFieldAssociationWithIssueTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setFieldAssociationWithIssueTypes?: Maybe<JiraSetFieldAssociationWithIssueTypesPayload>;
    /**
     * Update most recently viewed board
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setMostRecentlyViewedBoard?: Maybe<JiraSetMostRecentlyViewedBoardPayload>;
    /**
     * Feature toggle for the auto scheduler feature state
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFeaturesPage")' query directive to the 'setPlanAutoSchedulerEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setPlanAutoSchedulerEnabled?: Maybe<JiraEnablePlanFeaturePayloadGraphQl>;
    /**
     * Feature toggle for the multi-scenarios feature state
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFeaturesPage")' query directive to the 'setPlanMultiScenarioEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setPlanMultiScenarioEnabled?: Maybe<JiraEnablePlanFeaturePayloadGraphQl>;
    /**
     * Mutation for message dismissal state
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraBroadcastMessage")' query directive to the 'setUserBroadcastMessageDismissed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setUserBroadcastMessageDismissed?: Maybe<JiraUserBroadcastMessageActionPayload>;
    /**
     * Updates the Sprint for the given board and sprint id. The id provided must be in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSprintUpdate")' query directive to the 'sprintUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintUpdate?: Maybe<JiraSprintMutationPayload>;
    /**
     * Performs submission of bulk edit operation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraBulkEditSubmitSpike")' query directive to the 'submitBulkOperation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    submitBulkOperation?: Maybe<JiraSubmitBulkOperationPayload>;
    /**
     * Unlinks issues from an incident. Will return error if user does not have permission
     * to perform this action. This action will apply to issue links of any type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSoftwarePostIncidentReviews")' query directive to the 'unlinkIssuesFromIncident' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    unlinkIssuesFromIncident?: Maybe<JiraUnlinkIssuesFromIncidentMutationPayload>;
    /**
     * Update the active background of an entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateActiveBackground?: Maybe<JiraUpdateActiveBackgroundPayload>;
    /**
     * Update AffectedServices field value(s).
     * Accepts SET operation that sets the selected services for a given field ID.
     * The field value can be cleared by sending the set operation with a empty or null ids.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateAffectedServicesField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateAffectedServicesField?: Maybe<JiraAffectedServicesFieldPayload>;
    /**
     * Update Attachment Field value.
     * Accepts an operation that update the Attachment field.
     * Attachments cannot be null
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateAttachmentField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateAttachmentField?: Maybe<JiraAttachmentFieldPayload>;
    /**
     * Update Cascading select field value.
     * Can either submit ID for a new value to set it, or submit a null input to remove the current option.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateCascadingSelectField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateCascadingSelectField?: Maybe<JiraCascadingSelectFieldPayload>;
    /**
     * Update multi-checkbox field value(s).
     * Accepts an ordered array of operations that either
     * add, remove, or set the selected values for a given field ID.
     * The field value can be cleared by sending the set operation with an empty array.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateCheckboxesField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateCheckboxesField?: Maybe<JiraCheckboxesFieldPayload>;
    /**
     * Update Cmdb field value(s).
     * Accepts SET operation that sets the selected Cmdb objects for a given field ID.
     * The field value can be cleared by sending the set operation with a empty or null ids.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateCmdbField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateCmdbField?: Maybe<JiraCmdbFieldPayload>;
    /**
     * Update Color field value.
     * Null values are not allowed with set operation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateColorField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateColorField?: Maybe<JiraColorFieldPayload>;
    /**
     * Update Components field value(s).
     * Accepts an ordered array of operations that either add, remove, or set the selected components for a given field ID.
     * The field value can be cleared by sending the set operation with a empty value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateComponentsField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateComponentsField?: Maybe<JiraComponentsFieldPayload>;
    /**
     * Update a custom background (currently only altText can be updated)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateCustomBackground?: Maybe<JiraUpdateCustomBackgroundPayload>;
    /**
     * Update Data Classification field value.
     * It accepts the issuefieldvalue ID and the operation to perform (which includes the new classification level)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateDataClassificationField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateDataClassificationField?: Maybe<JiraDataClassificationFieldPayload>;
    /**
     * Update date field value(s).
     * Accepts an operation that update the date.
     * The field value can be cleared by sending the set operation with a null value or .
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueFieldMutations` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateDateField?: Maybe<JiraDateFieldPayload>;
    /**
     * Update datetime field value(s).
     * Accepts an operation that update the datetime.
     * The field value can be cleared by sending the set operation with a null value.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueFieldMutations` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateDateTimeField?: Maybe<JiraDateTimeFieldPayload>;
    /**
     * Update Entitlement field value.
     * Accepts an operation that updates the Entitlement.
     * The field value can be cleared by sending the set operation with a null value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateEntitlementField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateEntitlementField?: Maybe<JiraServiceManagementEntitlementFieldPayload>;
    /**
     * Update a field set view with either a selected range of field set ids or reset to default option based on the fieldsetviewARI ID passed in.
     * If id is 0 it will create field set view record based on the project context.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateFieldSetsView?: Maybe<JiraFieldSetsViewPayload>;
    /**
     * Update Forge Object field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateForgeObjectField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateForgeObjectField?: Maybe<JiraForgeObjectFieldPayload>;
    /**
     * Update an existing rule. Can't reorder a rule in this mutation, use reorderFormattingRule instead
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateFormattingRule?: Maybe<JiraUpdateFormattingRulePayload>;
    /**
     * Updates the notification options
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateGlobalNotificationOptions?: Maybe<JiraUpdateNotificationOptionsPayload>;
    /**
     * Updates the global notification preferences.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateGlobalNotificationPreferences?: Maybe<JiraUpdateGlobalPreferencesPayload>;
    /**
     * Used to update the Issue Hierarchy Configuration in Jira
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateIssueHierarchyConfig?: Maybe<JiraIssueHierarchyConfigurationMutationResult>;
    /**
     * Updates group by field preference for the user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateIssueSearchGroupByFieldPreference")' query directive to the 'updateIssueSearchGroupByConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateIssueSearchGroupByConfig?: Maybe<JiraIssueSearchGroupByFieldMutationPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateIssueSearchHideDonePreference")' query directive to the 'updateIssueSearchHideDonePreference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateIssueSearchHideDonePreference?: Maybe<JiraIssueSearchHideDonePreferenceMutationPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateIssueSearchHierarchyPreference")' query directive to the 'updateIssueSearchHierarchyPreference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateIssueSearchHierarchyPreference?: Maybe<JiraIssueSearchHierarchyPreferenceMutationPayload>;
    /**
     * Update Issue Type Field value.
     * Accepts an operation that update the Issue Type field.
     * IssueType cannot be null
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateIssueTypeField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateIssueTypeField?: Maybe<JiraIssueTypeFieldPayload>;
    /**
     * Update an existing activity configuration from an journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'updateJiraActivityConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraActivityConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Update the activity configurations of an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'updateJiraJourneyActivityConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraJourneyActivityConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Update an existing journey configuration
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'updateJiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Replaced with updateJiraJourneyTriggerConfiguration, updateJiraJourneyParentIssueConfiguration, updateJiraJourneyName
     */
    updateJiraJourneyConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Update the name of an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'updateJiraJourneyName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraJourneyName?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Update the parent issue of an journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'updateJiraJourneyParentIssueConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraJourneyParentIssueConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Update the trigger configuration of an existing journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'updateJiraJourneyTriggerConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraJourneyTriggerConfiguration?: Maybe<JiraUpdateJourneyConfigurationPayload>;
    /**
     * Mutation to edit an existing version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersion")' query directive to the 'updateJiraVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersion?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update the given approver's decline reason. Only the approver oneself can perform this.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraVersionUpdateApproverDeclineReason")' query directive to the 'updateJiraVersionApproverDeclineReason' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionApproverDeclineReason?: Maybe<JiraVersionUpdateApproverDeclineReasonPayload>;
    /**
     * Update approval description.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraVersionUpdateApproverDescription")' query directive to the 'updateJiraVersionApproverDescription' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionApproverDescription?: Maybe<JiraVersionUpdateApproverDescriptionPayload>;
    /**
     * Update approval status
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraVersionUpdateApproverStatus")' query directive to the 'updateJiraVersionApproverStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionApproverStatus?: Maybe<JiraVersionUpdateApproverStatusPayload>;
    /**
     * Mutation to update(set/unset) Driver of a version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraVersionUpdateDriver")' query directive to the 'updateJiraVersionDriver' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionDriver?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update version's position relative to other versions in
     * the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersionPosition")' query directive to the 'updateJiraVersionPosition' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionPosition?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Mutation to update version's rich text section content
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersionRichTextSectionContent")' query directive to the 'updateJiraVersionRichTextSectionContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionRichTextSectionContent?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Mutation to update version's rich text section title
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersionRichTextSectionTitle")' query directive to the 'updateJiraVersionRichTextSectionTitle' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraVersionRichTextSectionTitle?: Maybe<JiraUpdateVersionPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraViewConfiguration")' query directive to the 'updateJiraViewConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateJiraViewConfiguration?: Maybe<JiraUpdateViewConfigPayload>;
    /**
     * Update Jira Service Management Organization field value(s).
     * Accepts an ordered array of operations that either
     * add, remove, or set the selected values for a given field ID.
     * The field value can be cleared by sending the set operation by passing an empty array.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateJsmOrganizationField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateJsmOrganizationField?: Maybe<JiraServiceManagementOrganizationFieldPayload>;
    /**
     * Update a custom filter for JWM
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateJwmFilter?: Maybe<JiraWorkManagementUpdateFilterPayload>;
    /**
     * Update a Jira Work Management Overview.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateJwmOverview?: Maybe<JiraWorkManagementGiraUpdateOverviewPayload>;
    /**
     * Update labels field value(s).
     * Accepts an ordered array of operations that either add, remove, or set the selected labels for a given field ID.
     * The field value can be cleared by sending the set operation with a empty value.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueFieldMutations` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateLabelsField?: Maybe<JiraLabelsFieldPayload>;
    /**
     * Update Team field value.
     * Accepts an operation that update the Team field.
     * Use operation set with the value null to clear the field.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateLegacyTeamField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     * @deprecated JiraTeamField is deprecated in favour of JiraTeamViewField, hence updateLegacyTeamField for updating JiraTeamField is also deprecated.
     */
    updateLegacyTeamField?: Maybe<JiraLegacyTeamFieldPayload>;
    /**
     * Update MultipleGroupPicker field value.
     * It accepts an ordered array of operations that either add, remove, or set the selected groups for a given field ID.
     * The field value can be cleared by sending the set operation with an empty value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateMultipleGroupPickerField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateMultipleGroupPickerField?: Maybe<JiraMultipleGroupPickerFieldPayload>;
    /**
     * Update multi-select field value(s).
     * Accepts an ordered array of operations that either
     * add, remove, or set the selected values for a given field ID.
     * The field value can be cleared by sending the set operation with an empty array.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateMultipleSelectField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateMultipleSelectField?: Maybe<JiraMultipleSelectFieldPayload>;
    /**
     * Update MultipleSelectUserPicker field value(s).
     * Accepts an ordered array of operations that either add, remove, or set the selected users for a given field ID.
     * The field value can be cleared by sending the set operation with a empty value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateMultipleSelectUserPickerField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateMultipleSelectUserPickerField?: Maybe<JiraMultipleSelectUserPickerFieldPayload>;
    /**
     * Update MultipleVersionPicker field value(s).
     * Accepts an ordered array of operations that either add, remove, or set the selected versions for a given field ID.
     * The field value can be cleared by sending the set operation with a empty value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateMultipleVersionPickerField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateMultipleVersionPickerField?: Maybe<JiraMultipleVersionPickerFieldPayload>;
    /**
     * Update Number field value(s).
     * use operation set with the value null to clear the field
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueFieldMutations` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateNumberField?: Maybe<JiraNumberFieldPayload>;
    /**
     * Update Organization field value.
     * Accepts an operation that updates the Organization.
     * The field value can be cleared by sending the set operation with a null value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateOrganizationField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateOrganizationField?: Maybe<JiraCustomerServiceOrganizationFieldPayload>;
    /**
     * Update Original Time Estimate field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateOriginalTimeEstimateField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateOriginalTimeEstimateField?: Maybe<JiraOriginalTimeEstimateFieldPayload>;
    /**
     * Update Parent field value.
     * Accepts an operation that update the Parent field.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateParentField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateParentField?: Maybe<JiraParentFieldPayload>;
    /**
     * Update People field value.
     * Accepts an operation that updates the People field.
     * The field value can be cleared by sending the set operation with an empty value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updatePeopleField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updatePeopleField?: Maybe<JiraPeopleFieldPayload>;
    /**
     * Update Priority field value. Accepts an operation that update the priority.
     * The field value cannot be cleared as it is set to default priority value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updatePriorityField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updatePriorityField?: Maybe<JiraPriorityFieldPayload>;
    /**
     * Update the avatar of a project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateProjectAvatar?: Maybe<JiraProjectUpdateAvatarMutationPayload>;
    /**
     * Update Project field value.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateProjectField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateProjectField?: Maybe<JiraProjectFieldPayload>;
    /**
     * Update the name of a project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateProjectName?: Maybe<JiraProjectUpdateNameMutationPayload>;
    /**
     * Updates the notification preferences for a particular project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateProjectNotificationPreferences?: Maybe<JiraUpdateProjectNotificationPreferencesPayload>;
    /**
     * Mutation to update a Project Shortcut
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectShortcut")' query directive to the 'updateProjectShortcut' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateProjectShortcut?: Maybe<JiraProjectShortcutPayload>;
    /**
     * Update Radio select field value.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateRadioSelectField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateRadioSelectField?: Maybe<JiraRadioSelectFieldPayload>;
    /**
     * Update the release notes configuration for a given version
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraUpdateReleaseNotesConfiguration` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateReleaseNotesConfiguration?: Maybe<JiraUpdateReleaseNotesConfigurationPayload>;
    /**
     * Update Remaining Time Estimate field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateRemainingTimeEstimateField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateRemainingTimeEstimateField?: Maybe<JiraRemainingTimeEstimateFieldPayload>;
    /**
     * Update Resolution field value.
     *
     * Accepts an operation that update the Resolution field.
     * Resolution can be null for all non-terminal statuses.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateResolutionField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateResolutionField?: Maybe<JiraResolutionFieldPayload>;
    /**
     * Update Rich Text Field value.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateRichTextField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateRichTextField?: Maybe<JiraRichTextFieldPayload>;
    /**
     * Update SecurityLevel field value.
     * Accepts an operation that update the SecurityLevel field.
     * Using null value sets the security level to 'None'
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSecurityLevelField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSecurityLevelField?: Maybe<JiraSecurityLevelFieldPayload>;
    /**
     * Update Sentiment field value.
     * Accepts an operation that updates the Sentiment.
     * The field value can be cleared by sending the set operation with a null value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSentimentField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSentimentField?: Maybe<JiraServiceManagementSentimentFieldPayload>;
    /**
     * Update SingleGroupPicker field value.
     * Accepts groupId as input to update the field.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSingleGroupPickerField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSingleGroupPickerField?: Maybe<JiraSingleGroupPickerFieldPayload>;
    /**
     * Update Single Line Text field value(s).
     * Accepts an operation that update the Single Line Text.
     * The field value can be cleared by sending the set operation with a null value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSingleLineTextField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSingleLineTextField?: Maybe<JiraSingleLineTextFieldPayload>;
    /**
     * Update single select field value.
     * Can either submit the ID for a new value to set it, or submit a null input to remove it.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSingleSelectField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSingleSelectField?: Maybe<JiraSingleSelectFieldPayload>;
    /**
     * Update Single select user picker field value.
     * Using null value for:
     * 1. assignee field sets the issue to 'Unassigned'
     * 2. reporter field sets the reporter to 'Anonymous'
     * 3. custom single user picker field sets the user to 'None'
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSingleSelectUserPickerField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSingleSelectUserPickerField?: Maybe<JiraSingleSelectUserPickerFieldPayload>;
    /**
     * Update SingleVersionPicker field value.
     * Accepts an operation that updates the SingleVersionPicker field.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSingleVersionPickerField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSingleVersionPickerField?: Maybe<JiraSingleVersionPickerFieldPayload>;
    /**
     * Update Sprint field value.
     * Accepts an operation that updates the Sprint field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateSprintField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateSprintField?: Maybe<JiraSprintFieldPayload>;
    /**
     * Update Status field value.
     * Accepts actionId as input to update the status.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateStatusByQuickTransition' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateStatusByQuickTransition?: Maybe<JiraStatusFieldPayload>;
    /**
     * Update StoryPointEstimate field value.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateStoryPointEstimateField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateStoryPointEstimateField?: Maybe<JiraStoryPointEstimateFieldPayload>;
    /**
     * Update Team field value.
     * Use operation set with the value null to clear the field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateTeamField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateTeamField?: Maybe<JiraTeamFieldPayload>;
    /**
     * Update time tracking field value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateTimeTrackingField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateTimeTrackingField?: Maybe<JiraTimeTrackingFieldPayload>;
    /**
     * Update Url field value. Accepts an operation that update the Url field.
     * The field value can be cleared by sending the set operation with a null value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateUrlField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateUrlField?: Maybe<JiraUrlFieldPayload>;
    /**
     * Updates FieldSets Preferences for the user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateUserFieldSetPreferences")' query directive to the 'updateUserFieldSetPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateUserFieldSetPreferences?: Maybe<JiraFieldSetPreferencesUpdatePayload>;
    /**
     * Updates the user's configuration for the navigation at a specific location.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUserNavConfig")' query directive to the 'updateUserNavigationConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateUserNavigationConfiguration?: Maybe<JiraUserNavigationConfigurationPayload>;
    /**
     * Update whether a version is archived or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersionArchivedStatus")' query directive to the 'updateVersionArchivedStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateVersionArchivedStatus?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update a version's description.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: UpdateVersionDescription` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateVersionDescription?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update a version's name.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: UpdateVersionName` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateVersionName?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update an existing related work item's title/URL/category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersionGenericLinkRelatedWork")' query directive to the 'updateVersionRelatedWorkGenericLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateVersionRelatedWorkGenericLink?: Maybe<JiraUpdateVersionRelatedWorkGenericLinkPayload>;
    /**
     * Update a version's release date.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: UpdateVersionReleaseDate` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateVersionReleaseDate?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update whether a version is released or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUpdateVersionReleasedStatus")' query directive to the 'updateVersionReleasedStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateVersionReleasedStatus?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update a version's start date.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: UpdateVersionStartDate` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateVersionStartDate?: Maybe<JiraUpdateVersionPayload>;
    /**
     * Update version warning configuration by enabling/disabling warnings
     * for specific scenarios.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: UpdateVersionWarningConfig` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateVersionWarningConfig?: Maybe<JiraUpdateVersionWarningConfigPayload>;
    /**
     * Update Votes field value.
     * Accepts an operation that update the Votes.
     * It be null when voting is disabled.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateVotesField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateVotesField?: Maybe<JiraVotesFieldPayload>;
    /**
     * Update Watches field value.
     * Accepts an operation that update the Watchers.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldMutations")' query directive to the 'updateWatchesField' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    updateWatchesField?: Maybe<JiraWatchesFieldPayload>;
    /**
     * Mutations for preferences specific to the logged-in user on Jira
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUserPreferences")' query directive to the 'userPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userPreferences?: Maybe<JiraUserPreferencesMutation>;
};

export type JiraMutationAddFieldsToProjectArgs = {
    input: JiraAddFieldsToProjectInput;
};

export type JiraMutationAddIssuesToFixVersionArgs = {
    input: JiraAddIssuesToFixVersionInput;
};

export type JiraMutationAddJiraJourneyWorkItemAssociatedAutomationRuleArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateJourneyWorkItemAssociatedAutomationRuleInput;
};

export type JiraMutationAddJiraVersionApproverArgs = {
    input: JiraVersionAddApproverInput;
};

export type JiraMutationAddPermissionSchemeGrantsArgs = {
    input: JiraPermissionSchemeAddGrantInput;
};

export type JiraMutationAddPostIncidentReviewLinkArgs = {
    input: JiraAddPostIncidentReviewLinkMutationInput;
};

export type JiraMutationAddRelatedWorkToVersionArgs = {
    input: JiraAddRelatedWorkToVersionInput;
};

export type JiraMutationAnswerApprovalDecisionArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraAnswerApprovalDecisionInput;
};

export type JiraMutationArchiveJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraArchiveJourneyConfigurationInput;
};

export type JiraMutationAssignRelatedWorkToUserArgs = {
    input: JiraAssignRelatedWorkInput;
};

export type JiraMutationAttributeUnsplashImageArgs = {
    input: JiraUnsplashAttributionInput;
};

export type JiraMutationBulkCreateRequestTypeFromTemplateArgs = {
    input: JiraServiceManagementBulkCreateRequestTypeFromTemplateInput;
};

export type JiraMutationCloneIssueArgs = {
    input: JiraCloneIssueInput;
};

export type JiraMutationCreateAndAssociateWorkflowFromJsmTemplateArgs = {
    input: JiraServiceManagementCreateAndAssociateWorkflowFromTemplateInput;
};

export type JiraMutationCreateAppNavigationItemArgs = {
    input: JiraCreateAppNavigationItemInput;
};

export type JiraMutationCreateApproverListFieldArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraCreateApproverListFieldInput;
};

export type JiraMutationCreateAttachmentBackgroundArgs = {
    input: JiraCreateAttachmentBackgroundInput;
};

export type JiraMutationCreateBoardArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraCreateBoardInput;
};

export type JiraMutationCreateCalendarIssueArgs = {
    configuration: JiraCalendarViewConfigurationInput;
    endDateInput?: InputMaybe<Scalars["DateTime"]["input"]>;
    issueTypeId: Scalars["ID"]["input"];
    scope?: InputMaybe<JiraViewScopeInput>;
    startDateInput?: InputMaybe<Scalars["DateTime"]["input"]>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraMutationCreateCustomBackgroundArgs = {
    input: JiraCreateCustomBackgroundInput;
};

export type JiraMutationCreateCustomFieldInProjectAndAddToAllIssueTypesArgs = {
    input: JiraCreateCustomFieldInput;
};

export type JiraMutationCreateFormattingRuleArgs = {
    input: JiraCreateFormattingRuleInput;
};

export type JiraMutationCreateIssueArgs = {
    input: JiraIssueCreateInput;
};

export type JiraMutationCreateIssueLinksArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraBulkCreateIssueLinksInput;
};

export type JiraMutationCreateJiraActivityConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraCreateEmptyActivityConfigurationInput;
};

export type JiraMutationCreateJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraCreateJourneyConfigurationInput;
};

export type JiraMutationCreateJiraJourneyItemArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraCreateJourneyItemInput;
};

export type JiraMutationCreateJiraVersionArgs = {
    input: JiraVersionCreateMutationInput;
};

export type JiraMutationCreateJwmFilterArgs = {
    input: JiraWorkManagementCreateFilterInput;
};

export type JiraMutationCreateJwmIssueArgs = {
    input: JiraWorkManagementCreateIssueInput;
};

export type JiraMutationCreateJwmOverviewArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraWorkManagementCreateOverviewInput;
};

export type JiraMutationCreateProjectCleanupRecommendationsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraMutationCreateProjectShortcutArgs = {
    input: JiraCreateShortcutInput;
};

export type JiraMutationCreateReleaseNoteConfluencePageArgs = {
    input: JiraCreateReleaseNoteConfluencePageInput;
};

export type JiraMutationCreateSimpleNavigationItemArgs = {
    input: JiraCreateSimpleNavigationItemInput;
};

export type JiraMutationDeleteCustomBackgroundArgs = {
    input: JiraDeleteCustomBackgroundInput;
};

export type JiraMutationDeleteCustomFieldArgs = {
    input: JiraDeleteCustomFieldInput;
};

export type JiraMutationDeleteFormattingRuleArgs = {
    input: JiraDeleteFormattingRuleInput;
};

export type JiraMutationDeleteGlobalPermissionGrantArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraGlobalPermissionDeleteGroupGrantInput;
};

export type JiraMutationDeleteIssueLinkArgs = {
    cloudId: Scalars["ID"]["input"];
    issueLinkId: Scalars["ID"]["input"];
};

export type JiraMutationDeleteIssueNavigatorJqlHistoryArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraMutationDeleteJiraActivityConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDeleteActivityConfigurationInput;
};

export type JiraMutationDeleteJiraVersionApproverArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraMutationDeleteJiraVersionWithNoIssuesArgs = {
    input: JiraDeleteVersionWithNoIssuesInput;
};

export type JiraMutationDeleteJwmOverviewArgs = {
    input: JiraWorkManagementDeleteOverviewInput;
};

export type JiraMutationDeleteNavigationItemArgs = {
    input: JiraDeleteNavigationItemInput;
};

export type JiraMutationDeleteProjectNotificationPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDeleteProjectNotificationPreferencesInput;
};

export type JiraMutationDeleteProjectShortcutArgs = {
    input: JiraDeleteShortcutInput;
};

export type JiraMutationDisableJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDisableJourneyConfigurationInput;
};

export type JiraMutationDuplicateJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraDuplicateJourneyConfigurationInput;
};

export type JiraMutationEditCustomFieldArgs = {
    input: JiraEditCustomFieldInput;
};

export type JiraMutationGrantGlobalPermissionArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraGlobalPermissionAddGroupGrantInput;
};

export type JiraMutationInitializeProjectNotificationPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraInitializeProjectNotificationPreferencesInput;
};

export type JiraMutationJiraServiceManagementCreateRequestTypeCategoryArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraServiceManagementCreateRequestTypeCategoryInput;
};

export type JiraMutationJiraServiceManagementDeleteRequestTypeCategoryArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    requestTypeCategoryId: Scalars["ID"]["input"];
};

export type JiraMutationJiraServiceManagementUpdateRequestTypeCategoryArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraServiceManagementUpdateRequestTypeCategoryInput;
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraMutationJwmAssociateFieldArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraWorkManagementAssociateFieldInput;
};

export type JiraMutationJwmCreateCustomBackgroundArgs = {
    input: JiraWorkManagementCreateCustomBackgroundInput;
};

export type JiraMutationJwmCreateSavedViewArgs = {
    input: JiraWorkManagementCreateSavedViewInput;
};

export type JiraMutationJwmDeleteAttachmentArgs = {
    input: JiraWorkManagementDeleteAttachmentInput;
};

export type JiraMutationJwmDeleteCustomBackgroundArgs = {
    input: JiraWorkManagementDeleteCustomBackgroundInput;
};

export type JiraMutationJwmRemoveActiveBackgroundArgs = {
    input: JiraWorkManagementRemoveActiveBackgroundInput;
};

export type JiraMutationJwmUpdateActiveBackgroundArgs = {
    input: JiraWorkManagementUpdateBackgroundInput;
};

export type JiraMutationJwmUpdateCustomBackgroundArgs = {
    input: JiraWorkManagementUpdateCustomBackgroundInput;
};

export type JiraMutationJwmUpdateOverviewPlanMigrationChangeboardingArgs = {
    input: JiraUpdateOverviewPlanMigrationChangeboardingInput;
};

export type JiraMutationLinkIssueToVersionRelatedWorkArgs = {
    input: JiraLinkIssueToVersionRelatedWorkInput;
};

export type JiraMutationLinkIssuesToIncidentArgs = {
    input: JiraLinkIssuesToIncidentMutationInput;
};

export type JiraMutationMakeTransitionArgs = {
    input: JiraUpdateIssueTransitionInput;
};

export type JiraMutationMergeJiraVersionArgs = {
    input: JiraMergeVersionInput;
};

export type JiraMutationMoveIssuesToFixVersionArgs = {
    input: JiraMoveIssuesToFixVersionInput;
};

export type JiraMutationMoveJiraVersionToEndArgs = {
    input: JiraMoveVersionToEndInput;
};

export type JiraMutationMoveJiraVersionToStartArgs = {
    input: JiraMoveVersionToStartInput;
};

export type JiraMutationOrderFormatingRuleArgs = {
    input: JiraOrderFormattingRuleInput;
};

export type JiraMutationPublishJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraPublishJourneyConfigurationInput;
};

export type JiraMutationRankIssuesArgs = {
    rankInput: JiraRankMutationInput;
};

export type JiraMutationRankNavigationItemArgs = {
    input: JiraRankNavigationItemInput;
};

export type JiraMutationRemoveActiveBackgroundArgs = {
    input: JiraRemoveActiveBackgroundInput;
};

export type JiraMutationRemoveCustomFieldArgs = {
    input: JiraRemoveCustomFieldInput;
};

export type JiraMutationRemoveIssuesFromAllFixVersionsArgs = {
    input: JiraRemoveIssuesFromAllFixVersionsInput;
};

export type JiraMutationRemoveIssuesFromFixVersionArgs = {
    input: JiraRemoveIssuesFromFixVersionInput;
};

export type JiraMutationRemoveJiraJourneyWorkItemAssociatedAutomationRuleArgs =
    {
        cloudId: Scalars["ID"]["input"];
        input: JiraUpdateJourneyWorkItemAssociatedAutomationRuleInput;
    };

export type JiraMutationRemovePermissionSchemeGrantsArgs = {
    input: JiraPermissionSchemeRemoveGrantInput;
};

export type JiraMutationRemovePostIncidentReviewLinkArgs = {
    input: JiraRemovePostIncidentReviewLinkMutationInput;
};

export type JiraMutationRemoveRelatedWorkFromVersionArgs = {
    input: JiraRemoveRelatedWorkFromVersionInput;
};

export type JiraMutationRenameNavigationItemArgs = {
    input: JiraRenameNavigationItemInput;
};

export type JiraMutationReplaceIssueSearchViewFieldSetsArgs = {
    fieldSetsInput?: InputMaybe<JiraFieldSetsMutationInput>;
    id: Scalars["ID"]["input"];
    input?: InputMaybe<JiraReplaceIssueSearchViewFieldSetsInput>;
};

export type JiraMutationReplaceSpreadsheetViewFieldSetsArgs = {
    fieldSetsInput?: InputMaybe<JiraFieldSetsMutationInput>;
    id: Scalars["ID"]["input"];
};

export type JiraMutationSaveBusinessBoardSettingsArgs = {
    input: JiraWorkManagementBoardSettingsInput;
};

export type JiraMutationSaveVersionDetailsCollapsedUisArgs = {
    input: JiraVersionDetailsCollapsedUisInput;
};

export type JiraMutationSaveVersionIssueTableColumnHiddenStateArgs = {
    input: JiraVersionIssueTableColumnHiddenStateInput;
};

export type JiraMutationScheduleBulkExecuteProjectCleanupRecommendationsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraBulkCleanupProjectsInput;
};

export type JiraMutationScheduleCalendarIssueArgs = {
    configuration: JiraCalendarViewConfigurationInput;
    endDateInput?: InputMaybe<Scalars["DateTime"]["input"]>;
    issueId: Scalars["ID"]["input"];
    scope?: InputMaybe<JiraViewScopeInput>;
    startDateInput?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type JiraMutationScheduleCalendarIssueV2Args = {
    configuration: JiraCalendarViewConfigurationInput;
    endDateInput?: InputMaybe<Scalars["DateTime"]["input"]>;
    issueId: Scalars["ID"]["input"];
    scope?: InputMaybe<JiraViewScopeInput>;
    startDateInput?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type JiraMutationSetApplicationPropertiesArgs = {
    cloudId: Scalars["ID"]["input"];
    input: Array<JiraSetApplicationPropertyInput>;
};

export type JiraMutationSetDefaultNavigationItemArgs = {
    input: JiraSetDefaultNavigationItemInput;
};

export type JiraMutationSetEntityIsFavouriteArgs = {
    input: JiraSetIsFavouriteInput;
};

export type JiraMutationSetFieldAssociationWithIssueTypesArgs = {
    input: JiraSetFieldAssociationWithIssueTypesInput;
};

export type JiraMutationSetMostRecentlyViewedBoardArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraMutationSetPlanAutoSchedulerEnabledArgs = {
    input?: InputMaybe<JiraPlanFeatureMutationInput>;
};

export type JiraMutationSetPlanMultiScenarioEnabledArgs = {
    input?: InputMaybe<JiraPlanMultiScenarioFeatureMutationInput>;
};

export type JiraMutationSetUserBroadcastMessageDismissedArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type JiraMutationSprintUpdateArgs = {
    sprintUpdateInput: JiraSprintUpdateInput;
};

export type JiraMutationSubmitBulkOperationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraSubmitBulkOperationInput;
};

export type JiraMutationUnlinkIssuesFromIncidentArgs = {
    input: JiraUnlinkIssuesFromIncidentMutationInput;
};

export type JiraMutationUpdateActiveBackgroundArgs = {
    input: JiraUpdateBackgroundInput;
};

export type JiraMutationUpdateAffectedServicesFieldArgs = {
    input: JiraUpdateAffectedServicesFieldInput;
};

export type JiraMutationUpdateAttachmentFieldArgs = {
    input: JiraUpdateAttachmentFieldInput;
};

export type JiraMutationUpdateCascadingSelectFieldArgs = {
    input: JiraUpdateCascadingSelectFieldInput;
};

export type JiraMutationUpdateCheckboxesFieldArgs = {
    input: JiraUpdateCheckboxesFieldInput;
};

export type JiraMutationUpdateCmdbFieldArgs = {
    input: JiraUpdateCmdbFieldInput;
};

export type JiraMutationUpdateColorFieldArgs = {
    input: JiraUpdateColorFieldInput;
};

export type JiraMutationUpdateComponentsFieldArgs = {
    input: JiraUpdateComponentsFieldInput;
};

export type JiraMutationUpdateCustomBackgroundArgs = {
    input: JiraUpdateCustomBackgroundInput;
};

export type JiraMutationUpdateDataClassificationFieldArgs = {
    input: JiraUpdateDataClassificationFieldInput;
};

export type JiraMutationUpdateDateFieldArgs = {
    input: JiraUpdateDateFieldInput;
};

export type JiraMutationUpdateDateTimeFieldArgs = {
    input: JiraUpdateDateTimeFieldInput;
};

export type JiraMutationUpdateEntitlementFieldArgs = {
    input: JiraServiceManagementUpdateEntitlementFieldInput;
};

export type JiraMutationUpdateFieldSetsViewArgs = {
    fieldSetsInput?: InputMaybe<JiraFieldSetsMutationInput>;
    id: Scalars["ID"]["input"];
};

export type JiraMutationUpdateForgeObjectFieldArgs = {
    input: JiraUpdateForgeObjectFieldInput;
};

export type JiraMutationUpdateFormattingRuleArgs = {
    input: JiraUpdateFormattingRuleInput;
};

export type JiraMutationUpdateGlobalNotificationOptionsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateNotificationOptionsInput;
};

export type JiraMutationUpdateGlobalNotificationPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateGlobalNotificationPreferencesInput;
};

export type JiraMutationUpdateIssueHierarchyConfigArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraIssueHierarchyConfigurationMutationInput;
};

export type JiraMutationUpdateIssueSearchGroupByConfigArgs = {
    fieldId?: InputMaybe<Scalars["String"]["input"]>;
    viewId: Scalars["ID"]["input"];
};

export type JiraMutationUpdateIssueSearchHideDonePreferenceArgs = {
    isHideDoneEnabled: Scalars["Boolean"]["input"];
    viewId: Scalars["ID"]["input"];
};

export type JiraMutationUpdateIssueSearchHierarchyPreferenceArgs = {
    isHierarchyEnabled: Scalars["Boolean"]["input"];
    viewId: Scalars["ID"]["input"];
};

export type JiraMutationUpdateIssueTypeFieldArgs = {
    input: JiraUpdateIssueTypeFieldInput;
};

export type JiraMutationUpdateJiraActivityConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateActivityConfigurationInput;
};

export type JiraMutationUpdateJiraJourneyActivityConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateJourneyActivityConfigurationInput;
};

export type JiraMutationUpdateJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateJourneyConfigurationInput;
};

export type JiraMutationUpdateJiraJourneyNameArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateJourneyNameInput;
};

export type JiraMutationUpdateJiraJourneyParentIssueConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateJourneyParentIssueConfigurationInput;
};

export type JiraMutationUpdateJiraJourneyTriggerConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateJourneyTriggerConfigurationInput;
};

export type JiraMutationUpdateJiraVersionArgs = {
    input: JiraVersionUpdateMutationInput;
};

export type JiraMutationUpdateJiraVersionApproverDeclineReasonArgs = {
    input: JiraVersionUpdateApproverDeclineReasonInput;
};

export type JiraMutationUpdateJiraVersionApproverDescriptionArgs = {
    input: JiraVersionUpdateApproverDescriptionInput;
};

export type JiraMutationUpdateJiraVersionApproverStatusArgs = {
    input: JiraVersionUpdateApproverStatusInput;
};

export type JiraMutationUpdateJiraVersionDriverArgs = {
    input: JiraUpdateVersionDriverInput;
};

export type JiraMutationUpdateJiraVersionPositionArgs = {
    input: JiraUpdateVersionPositionInput;
};

export type JiraMutationUpdateJiraVersionRichTextSectionContentArgs = {
    input: JiraUpdateVersionRichTextSectionContentInput;
};

export type JiraMutationUpdateJiraVersionRichTextSectionTitleArgs = {
    input: JiraUpdateVersionRichTextSectionTitleInput;
};

export type JiraMutationUpdateJiraViewConfigurationArgs = {
    input?: InputMaybe<JiraUpdateViewConfigInput>;
};

export type JiraMutationUpdateJsmOrganizationFieldArgs = {
    input: JiraServiceManagementUpdateOrganizationFieldInput;
};

export type JiraMutationUpdateJwmFilterArgs = {
    input: JiraWorkManagementUpdateFilterInput;
};

export type JiraMutationUpdateJwmOverviewArgs = {
    input: JiraWorkManagementUpdateOverviewInput;
};

export type JiraMutationUpdateLabelsFieldArgs = {
    input: JiraUpdateLabelsFieldInput;
};

export type JiraMutationUpdateLegacyTeamFieldArgs = {
    input: JiraUpdateLegacyTeamFieldInput;
};

export type JiraMutationUpdateMultipleGroupPickerFieldArgs = {
    input: JiraUpdateMultipleGroupPickerFieldInput;
};

export type JiraMutationUpdateMultipleSelectFieldArgs = {
    input: JiraUpdateMultipleSelectFieldInput;
};

export type JiraMutationUpdateMultipleSelectUserPickerFieldArgs = {
    input: JiraUpdateMultipleSelectUserPickerFieldInput;
};

export type JiraMutationUpdateMultipleVersionPickerFieldArgs = {
    input: JiraUpdateMultipleVersionPickerFieldInput;
};

export type JiraMutationUpdateNumberFieldArgs = {
    input: JiraUpdateNumberFieldInput;
};

export type JiraMutationUpdateOrganizationFieldArgs = {
    input: JiraCustomerServiceUpdateOrganizationFieldInput;
};

export type JiraMutationUpdateOriginalTimeEstimateFieldArgs = {
    input: JiraOriginalTimeEstimateFieldInput;
};

export type JiraMutationUpdateParentFieldArgs = {
    input: JiraUpdateParentFieldInput;
};

export type JiraMutationUpdatePeopleFieldArgs = {
    input: JiraUpdatePeopleFieldInput;
};

export type JiraMutationUpdatePriorityFieldArgs = {
    input: JiraUpdatePriorityFieldInput;
};

export type JiraMutationUpdateProjectAvatarArgs = {
    input: JiraProjectUpdateAvatarInput;
};

export type JiraMutationUpdateProjectFieldArgs = {
    input: JiraUpdateProjectFieldInput;
};

export type JiraMutationUpdateProjectNameArgs = {
    input: JiraProjectUpdateNameInput;
};

export type JiraMutationUpdateProjectNotificationPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraUpdateProjectNotificationPreferencesInput;
};

export type JiraMutationUpdateProjectShortcutArgs = {
    input: JiraUpdateShortcutInput;
};

export type JiraMutationUpdateRadioSelectFieldArgs = {
    input: JiraUpdateRadioSelectFieldInput;
};

export type JiraMutationUpdateReleaseNotesConfigurationArgs = {
    input: JiraUpdateReleaseNotesConfigurationInput;
};

export type JiraMutationUpdateRemainingTimeEstimateFieldArgs = {
    input: JiraRemainingTimeEstimateFieldInput;
};

export type JiraMutationUpdateResolutionFieldArgs = {
    input: JiraUpdateResolutionFieldInput;
};

export type JiraMutationUpdateRichTextFieldArgs = {
    input: JiraUpdateRichTextFieldInput;
};

export type JiraMutationUpdateSecurityLevelFieldArgs = {
    input: JiraUpdateSecurityLevelFieldInput;
};

export type JiraMutationUpdateSentimentFieldArgs = {
    input: JiraServiceManagementUpdateSentimentFieldInput;
};

export type JiraMutationUpdateSingleGroupPickerFieldArgs = {
    input: JiraUpdateSingleGroupPickerFieldInput;
};

export type JiraMutationUpdateSingleLineTextFieldArgs = {
    input: JiraUpdateSingleLineTextFieldInput;
};

export type JiraMutationUpdateSingleSelectFieldArgs = {
    input: JiraUpdateSingleSelectFieldInput;
};

export type JiraMutationUpdateSingleSelectUserPickerFieldArgs = {
    input: JiraUpdateSingleSelectUserPickerFieldInput;
};

export type JiraMutationUpdateSingleVersionPickerFieldArgs = {
    input: JiraUpdateSingleVersionPickerFieldInput;
};

export type JiraMutationUpdateSprintFieldArgs = {
    input: JiraUpdateSprintFieldInput;
};

export type JiraMutationUpdateStatusByQuickTransitionArgs = {
    input: JiraUpdateStatusFieldInput;
};

export type JiraMutationUpdateStoryPointEstimateFieldArgs = {
    input: JiraUpdateStoryPointEstimateFieldInput;
};

export type JiraMutationUpdateTeamFieldArgs = {
    input: JiraUpdateTeamFieldInput;
};

export type JiraMutationUpdateTimeTrackingFieldArgs = {
    input: JiraUpdateTimeTrackingFieldInput;
};

export type JiraMutationUpdateUrlFieldArgs = {
    input: JiraUpdateUrlFieldInput;
};

export type JiraMutationUpdateUserFieldSetPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
    context?: InputMaybe<JiraIssueSearchViewFieldSetsContext>;
    fieldSetPreferencesInput: JiraFieldSetPreferencesMutationInput;
    namespace?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraMutationUpdateUserNavigationConfigurationArgs = {
    input: JiraUpdateUserNavigationConfigurationInput;
};

export type JiraMutationUpdateVersionArchivedStatusArgs = {
    input: JiraUpdateVersionArchivedStatusInput;
};

export type JiraMutationUpdateVersionDescriptionArgs = {
    input: JiraUpdateVersionDescriptionInput;
};

export type JiraMutationUpdateVersionNameArgs = {
    input: JiraUpdateVersionNameInput;
};

export type JiraMutationUpdateVersionRelatedWorkGenericLinkArgs = {
    input: JiraUpdateVersionRelatedWorkGenericLinkInput;
};

export type JiraMutationUpdateVersionReleaseDateArgs = {
    input: JiraUpdateVersionReleaseDateInput;
};

export type JiraMutationUpdateVersionReleasedStatusArgs = {
    input: JiraUpdateVersionReleasedStatusInput;
};

export type JiraMutationUpdateVersionStartDateArgs = {
    input: JiraUpdateVersionStartDateInput;
};

export type JiraMutationUpdateVersionWarningConfigArgs = {
    input: JiraUpdateVersionWarningConfigInput;
};

export type JiraMutationUpdateVotesFieldArgs = {
    input: JiraUpdateVotesFieldInput;
};

export type JiraMutationUpdateWatchesFieldArgs = {
    input: JiraUpdateWatchesFieldInput;
};

export type JiraMutationUserPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload =
    Payload & {
        __typename?: "JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload";
        errors?: Maybe<Array<MutationError>>;
        success: Scalars["Boolean"]["output"];
    };

/** The input used for an natural language to JQL conversion */
export type JiraNaturalLanguageToJqlInput = {
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Model selection is no longer supported. This field will be removed in future.
     */
    iteration?: InputMaybe<JiraIteration>;
    naturalLanguageInput: Scalars["String"]["input"];
    searchContext?: InputMaybe<JiraSearchContextInput>;
};

/** The most general interface for a navigation item. Represents pages a user can navigate to within a scope. */
export type JiraNavigationItem = {
    /** Whether this item can be removed from its scope, based on the authenticated user. */
    canRemove?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this item can be renamed to have a custom user-provided label. */
    canRename?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this item can be set as the default within its scope, based on the authenticated user. */
    canSetAsDefault?: Maybe<Scalars["Boolean"]["output"]>;
    /** Global identifier (ARI) for the navigation item. */
    id: Scalars["ID"]["output"];
    /** Whether this is the default navigation item within the requested scope. Only one may be the default. */
    isDefault?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The label for this item, for display purposes. This can either be the default label based on the
     * item type, or a user-provided value.
     * Assume that this value contains UGC.
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /** Identifies the type of this navigation item. */
    typeKey?: Maybe<JiraNavigationItemTypeKey>;
    /** The URL for this navigation item. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for navigation items. */
export type JiraNavigationItemConnection = HasPageInfo & {
    __typename?: "JiraNavigationItemConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraNavigationItemEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** The edge type for navigation items. */
export type JiraNavigationItemEdge = {
    __typename?: "JiraNavigationItemEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The navigation item node at the edge. */
    node?: Maybe<JiraNavigationItem>;
};

/** GraphQL does not allow interfaces inside unions, need to list every implementation explicitly. */
export type JiraNavigationItemResult =
    | JiraAppNavigationItem
    | JiraShortcutNavigationItem
    | JiraSoftwareBuiltInNavigationItem
    | JiraWorkManagementSavedView
    | QueryError;

/** General interface to represent a type of navigation item, identified by its `JiraNavigationItemTypeKey`. */
export type JiraNavigationItemType = {
    /**
     * Opaque ID uniquely identifying this item type node.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The localized label for this item type, for display purposes.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /**
     * The key identifying this item type, represented as an enum.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    typeKey?: Maybe<JiraNavigationItemTypeKey>;
};

/** Connection of navigation item types. */
export type JiraNavigationItemTypeConnection = HasPageInfo & {
    __typename?: "JiraNavigationItemTypeConnection";
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<JiraNavigationItemTypeEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used for pagination. */
    pageInfo: PageInfo;
};

/** The edge type for navigation item types. */
export type JiraNavigationItemTypeEdge = {
    __typename?: "JiraNavigationItemTypeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The navigation item type node at the edge. */
    node?: Maybe<JiraNavigationItemType>;
};

/**
 * List of values identifying the known navigation item types. This list is shared between
 * business and software projects but only some are supported by one or the other.
 */
export enum JiraNavigationItemTypeKey {
    App = "APP",
    Approvals = "APPROVALS",
    /** @deprecated Replaced by APP as each app will have its own navigation item */
    Apps = "APPS",
    ArchivedIssues = "ARCHIVED_ISSUES",
    Attachments = "ATTACHMENTS",
    Backlog = "BACKLOG",
    Board = "BOARD",
    Calendar = "CALENDAR",
    Code = "CODE",
    Components = "COMPONENTS",
    CustomerSupport = "CUSTOMER_SUPPORT",
    Dependencies = "DEPENDENCIES",
    Deployments = "DEPLOYMENTS",
    Development = "DEVELOPMENT",
    Forms = "FORMS",
    /** @deprecated Get started item was an experiment which has been cleaned up */
    GetStarted = "GET_STARTED",
    Goals = "GOALS",
    Incidents = "INCIDENTS",
    Issues = "ISSUES",
    List = "LIST",
    OnCall = "ON_CALL",
    Pages = "PAGES",
    PlanCalendar = "PLAN_CALENDAR",
    PlanDependencies = "PLAN_DEPENDENCIES",
    PlanProgram = "PLAN_PROGRAM",
    PlanReleases = "PLAN_RELEASES",
    PlanSummary = "PLAN_SUMMARY",
    PlanTeams = "PLAN_TEAMS",
    PlanTimeline = "PLAN_TIMELINE",
    Program = "PROGRAM",
    Queue = "QUEUE",
    Releases = "RELEASES",
    Reports = "REPORTS",
    Requests = "REQUESTS",
    Security = "SECURITY",
    Shortcuts = "SHORTCUTS",
    Summary = "SUMMARY",
    Teams = "TEAMS",
    Timeline = "TIMELINE"
}

/** The navigation UI state of the left sidebar and right panels user property */
export type JiraNavigationUiStateUserProperty = JiraEntityProperty &
    Node & {
        __typename?: "JiraNavigationUIStateUserProperty";
        /** The id unique to the entity property */
        id: Scalars["ID"]["output"];
        /** A boolean which is true if the left sidebar is collapsed, false otherwise */
        isLeftSidebarCollapsed?: Maybe<Scalars["Boolean"]["output"]>;
        /** The width of the left sidebar */
        leftSidebarWidth?: Maybe<Scalars["Int"]["output"]>;
        /** The key of the entity property */
        propertyKey?: Maybe<Scalars["String"]["output"]>;
        /** The state of the right panels */
        rightPanels?: Maybe<JiraRightPanelStateConnection>;
    };

/** The navigation UI state of the left sidebar and right panels user property */
export type JiraNavigationUiStateUserPropertyRightPanelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the possible notification categories for notification types. */
export enum JiraNotificationCategoryType {
    CommentChanges = "COMMENT_CHANGES",
    IssueAssigned = "ISSUE_ASSIGNED",
    IssueChanges = "ISSUE_CHANGES",
    IssueMentioned = "ISSUE_MENTIONED",
    IssueMiscellaneous = "ISSUE_MISCELLANEOUS",
    IssueWorklogChanges = "ISSUE_WORKLOG_CHANGES",
    Recurring = "RECURRING"
}

/** Represents a preference for a particular notification channel. */
export type JiraNotificationChannel = {
    __typename?: "JiraNotificationChannel";
    /** The channel that this notification preference is for. */
    channel?: Maybe<JiraNotificationChannelType>;
    /** Indicates whether or not this preference is editable. */
    isEditable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether or not the user should receive notifications on this channel. */
    isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents the possible types notification channels. */
export enum JiraNotificationChannelType {
    Email = "EMAIL",
    InProduct = "IN_PRODUCT",
    MobilePush = "MOBILE_PUSH"
}

/** Represents notification preferences across all projects. */
export type JiraNotificationGlobalPreference = {
    __typename?: "JiraNotificationGlobalPreference";
    /** Options which are not directly related to recipient calculation, such as email MIME type. */
    options?: Maybe<JiraNotificationOptions>;
    /** The notification preferences for the various notification types. */
    preferences?: Maybe<JiraNotificationPreferences>;
};

/** Represents options for notifications that don't fit in with the recipient calculation oriented preferences in JiraNotificationPreferences. */
export type JiraNotificationOptions = {
    __typename?: "JiraNotificationOptions";
    /** Indicates the idle time for emails awaiting changes per issue, multiple emails within this time are consolidated and sent together in a single batched email */
    batchWindow?: Maybe<JiraBatchWindowPreference>;
    /** Indicates the local time to receive email notifications if user has chosen once-per-day email batching */
    dailyBatchLocalTime?: Maybe<Scalars["String"]["output"]>;
    /** Indicates whether the user wants to receive HTML or plaintext emails. */
    emailMimeType?: Maybe<JiraEmailMimeType>;
    /** The ID for this set of notification options. */
    id: Scalars["ID"]["output"];
    /** Indicates whether the user is allowed to update the email MIME type preference. */
    isEmailMimeTypeEditable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether email notifications are enabled for this user. */
    isEmailNotificationEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the user wants to receive notifications for their own actions. */
    notifyOwnChangesEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the user wants to receive notifications when a role assignee is enabled. */
    notifyWhenRoleAssigneeEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the user wants to receive notifications when a role reporter is enabled. */
    notifyWhenRoleReporterEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents a notification preference for a particular notification type. */
export type JiraNotificationPreference = {
    __typename?: "JiraNotificationPreference";
    /** The category of this notification type. */
    category?: Maybe<JiraNotificationCategoryType>;
    /** Indicates whether a user has opted into email notifications for this notification type. */
    emailChannel?: Maybe<JiraNotificationChannel>;
    /** The ID of this notification preference. */
    id: Scalars["ID"]["output"];
    /** Indicates whether a user has opted into in-product notifications for this notification type. */
    inProductChannel?: Maybe<JiraNotificationChannel>;
    /** Indicates whether a user has opted into mobile push notifications for this notification type. */
    mobilePushChannel?: Maybe<JiraNotificationChannel>;
    /** The notification type that this notification preference is for. */
    type?: Maybe<JiraNotificationType>;
};

/** Represents a notification preferences to be updated. */
export type JiraNotificationPreferenceInput = {
    /** The channel to enable/disable this preference for */
    channel?: InputMaybe<JiraNotificationChannelType>;
    /**
     * The list of channels to enable this preference for. Channels not present in this list will be disabled.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Will be removed while API is in experimental phase.
     */
    channelsEnabled?: InputMaybe<Array<JiraNotificationChannelType>>;
    /** Whether this channel should be enabled or disabled */
    isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The notification type to be updated */
    type: JiraNotificationType;
};

/** Represents notification preferences by notification type. */
export type JiraNotificationPreferences = {
    __typename?: "JiraNotificationPreferences";
    /** Preference for notifications when a comment is created. */
    commentCreated?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when a comment is deleted. */
    commentDeleted?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when a comment is edited. */
    commentEdited?: Maybe<JiraNotificationPreference>;
    /**
     * Preference for receiving daily due date notifications
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDueDateNotificationsToggle")' query directive to the 'dailyDueDateNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    dailyDueDateNotification?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when issues are assigned. */
    issueAssigned?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when issues are created. */
    issueCreated?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when issues are deleted. */
    issueDeleted?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications a user is mentioned on an issue. */
    issueMentioned?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when issues are moved. */
    issueMoved?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when issues are updated. */
    issueUpdated?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when a user is mentioned in a comment or on an issue description. */
    mentionsCombined?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications for miscellaneous issue events such as generic, custom, transition etc */
    miscellaneousIssueEventCombined?: Maybe<JiraNotificationPreference>;
    /** Preference for notifications when a worklog is created, updated or deleted. */
    worklogCombined?: Maybe<JiraNotificationPreference>;
};

/** The connection type for JiraNotificationProjectPreferences. */
export type JiraNotificationProjectPreferenceConnection = HasPageInfo &
    HasTotal & {
        __typename?: "JiraNotificationProjectPreferenceConnection";
        /** A list of edges in the current page. */
        edges?: Maybe<Array<Maybe<JiraProjectNotificationPreferenceEdge>>>;
        /** Information about the current page. Used to aid in pagination. */
        pageInfo: PageInfo;
        /** The total count of items in the connection. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** Represents a project's notification preferences. */
export type JiraNotificationProjectPreferences = {
    __typename?: "JiraNotificationProjectPreferences";
    /** The ID for this set of project preferences. */
    id: Scalars["ID"]["output"];
    /** The notification preferences for the various notification types. */
    preferences?: Maybe<JiraNotificationPreferences>;
    /** The project for which the notification preferences are set. */
    project?: Maybe<JiraProject>;
};

/** Represents the possible types of notifications. */
export enum JiraNotificationType {
    CommentCreated = "COMMENT_CREATED",
    CommentDeleted = "COMMENT_DELETED",
    CommentEdited = "COMMENT_EDITED",
    DailyDueDateNotification = "DAILY_DUE_DATE_NOTIFICATION",
    IssueAssigned = "ISSUE_ASSIGNED",
    IssueCreated = "ISSUE_CREATED",
    IssueDeleted = "ISSUE_DELETED",
    IssueMoved = "ISSUE_MOVED",
    IssueUpdated = "ISSUE_UPDATED",
    MentionsCombined = "MENTIONS_COMBINED",
    MiscellaneousIssueEventCombined = "MISCELLANEOUS_ISSUE_EVENT_COMBINED",
    WorklogCombined = "WORKLOG_COMBINED"
}

/** Represents a number field on a Jira Issue. E.g. float, story points. */
export type JiraNumberField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraNumberField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Returns if the current number field is a story point field
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Story point field is treated as a special field only on issue view
         */
        isStoryPointField?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The number selected on the Issue or default number configured for the field. */
        number?: Maybe<Scalars["Float"]["output"]>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input type for a number field */
export type JiraNumberFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    value: Scalars["Float"]["input"];
};

export type JiraNumberFieldOperationInput = {
    number?: InputMaybe<Scalars["Float"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraNumberFieldPayload = Payload & {
    __typename?: "JiraNumberFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraNumberField>;
    success: Scalars["Boolean"]["output"];
};

/** An OAuth app which may have permissions to push/read extension data from issues */
export type JiraOAuthAppsApp = {
    __typename?: "JiraOAuthAppsApp";
    /** Module for reading/writing builds data using these credentials */
    buildsModule?: Maybe<JiraOAuthAppsBuildsModule>;
    /** OAuth client id credential for this app */
    clientId: Scalars["String"]["output"];
    /** Module for reading/writing deployments data using these credentials */
    deploymentsModule?: Maybe<JiraOAuthAppsDeploymentsModule>;
    /** Module for reading/writing development information data using these credentials */
    devInfoModule?: Maybe<JiraOAuthAppsDevInfoModule>;
    /** Module for reading/writing feature flags data using these credentials */
    featureFlagsModule?: Maybe<JiraOAuthAppsFeatureFlagsModule>;
    /** Home URL from which this app should be accessible */
    homeUrl: Scalars["String"]["output"];
    /** Id of this app */
    id: Scalars["ID"]["output"];
    /** The state of the apps installation */
    installationStatus?: Maybe<JiraOAuthAppsInstallationStatus>;
    /** Logo of this app which will be shown on the screen */
    logoUrl: Scalars["String"]["output"];
    /** Name of this app */
    name: Scalars["String"]["output"];
    /** Module for reading/writing remoteLinks information data using these credentials */
    remoteLinksModule?: Maybe<JiraOAuthAppsRemoteLinksModule>;
    /** OAuth secret id credential for this app */
    secret: Scalars["String"]["output"];
};

export type JiraOAuthAppsAppInput = {
    /** Module for reading/writing builds data using these credentials */
    buildsModule?: InputMaybe<JiraOAuthAppsBuildsModuleInput>;
    /** Module for reading/writing deployments data using these credentials */
    deploymentsModule?: InputMaybe<JiraOAuthAppsDeploymentsModuleInput>;
    /** Module for reading/writing development information data using these credentials */
    devInfoModule?: InputMaybe<JiraOAuthAppsDevInfoModuleInput>;
    /** Module for reading/writing feature flags data using these credentials */
    featureFlagsModule?: InputMaybe<JiraOAuthAppsFeatureFlagsModuleInput>;
    /** Home URL from which this app should be accessible */
    homeUrl: Scalars["String"]["input"];
    /** Logo of this app which will be shown on the screen */
    logoUrl: Scalars["String"]["input"];
    /** Name of this app */
    name: Scalars["String"]["input"];
    /** Module for reading/writing remoteLinks information data using these credentials */
    remoteLinksModule?: InputMaybe<JiraOAuthAppsRemoteLinksModuleInput>;
};

export type JiraOAuthAppsAppUpdateInput = {
    /** Module for reading/writing builds data using these credentials */
    buildsModule?: InputMaybe<JiraOAuthAppsBuildsModuleInput>;
    /** Module for reading/writing deployments data using these credentials */
    deploymentsModule?: InputMaybe<JiraOAuthAppsDeploymentsModuleInput>;
    /** Module for reading/writing development information data using these credentials */
    devInfoModule?: InputMaybe<JiraOAuthAppsDevInfoModuleInput>;
    /** Module for reading/writing feature flags data using these credentials */
    featureFlagsModule?: InputMaybe<JiraOAuthAppsFeatureFlagsModuleInput>;
    /** Module for reading/writing remoteLinks information data using these credentials */
    remoteLinksModule?: InputMaybe<JiraOAuthAppsRemoteLinksModuleInput>;
};

export type JiraOAuthAppsApps = {
    __typename?: "JiraOAuthAppsApps";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    apps?: Maybe<Array<Maybe<JiraOAuthAppsApp>>>;
};

export type JiraOAuthAppsAppsAppsArgs = {
    cloudId: Scalars["String"]["input"];
};

export type JiraOAuthAppsBuildsModule = {
    __typename?: "JiraOAuthAppsBuildsModule";
    /** True if this app can read/write builds data */
    isEnabled: Scalars["Boolean"]["output"];
};

export type JiraOAuthAppsBuildsModuleInput = {
    /** True if this app can read/write builds data */
    isEnabled: Scalars["Boolean"]["input"];
};

export type JiraOAuthAppsCreateAppInput = {
    /** The app that should be created */
    app: JiraOAuthAppsAppInput;
    /** An id for this mutation */
    clientMutationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraOAuthAppsDeleteAppInput = {
    /** The id of the app which will be deleted */
    clientId: Scalars["ID"]["input"];
    /** An id for this mutation */
    clientMutationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraOAuthAppsDeploymentsModule = {
    __typename?: "JiraOAuthAppsDeploymentsModule";
    /** Actions that this app can invoke on deployments data */
    actions?: Maybe<JiraOAuthAppsDeploymentsModuleActions>;
    /** True if this app can read/write deployments data */
    isEnabled: Scalars["Boolean"]["output"];
};

export type JiraOAuthAppsDeploymentsModuleActions = {
    __typename?: "JiraOAuthAppsDeploymentsModuleActions";
    /** A UrlTemplate which the app can inject a list deployments button on the issue view */
    listDeployments?: Maybe<JiraOAuthAppsUrlTemplate>;
};

export type JiraOAuthAppsDeploymentsModuleActionsInput = {
    /** A UrlTemplate which the app can inject a list deployments button on the issue view */
    listDeployments?: InputMaybe<JiraOAuthAppsUrlTemplateInput>;
};

export type JiraOAuthAppsDeploymentsModuleInput = {
    /** Actions that this app can invoke on deployments data */
    actions?: InputMaybe<JiraOAuthAppsDeploymentsModuleActionsInput>;
    /** True if this app can read/write deployments data */
    isEnabled: Scalars["Boolean"]["input"];
};

export type JiraOAuthAppsDevInfoModule = {
    __typename?: "JiraOAuthAppsDevInfoModule";
    /** Actions that this app can invoke on development information data */
    actions?: Maybe<JiraOAuthAppsDevInfoModuleActions>;
    /** True if this app can read/write development information data */
    isEnabled: Scalars["Boolean"]["output"];
};

export type JiraOAuthAppsDevInfoModuleActions = {
    __typename?: "JiraOAuthAppsDevInfoModuleActions";
    /** A UrlTemplate which the app can inject a create branch button on the issue view */
    createBranch?: Maybe<JiraOAuthAppsUrlTemplate>;
};

export type JiraOAuthAppsDevInfoModuleActionsInput = {
    /** A UrlTemplate which the app can inject a create branch button on the issue view */
    createBranch?: InputMaybe<JiraOAuthAppsUrlTemplateInput>;
};

export type JiraOAuthAppsDevInfoModuleInput = {
    /** Actions that this app can invoke on development information data */
    actions?: InputMaybe<JiraOAuthAppsDevInfoModuleActionsInput>;
    /** True if this app can read/write development information data */
    isEnabled: Scalars["Boolean"]["input"];
};

export type JiraOAuthAppsFeatureFlagsModule = {
    __typename?: "JiraOAuthAppsFeatureFlagsModule";
    /** Actions that this app can invoke on feature flags data */
    actions?: Maybe<JiraOAuthAppsFeatureFlagsModuleActions>;
    /** True if this app can read/write feature flags data */
    isEnabled: Scalars["Boolean"]["output"];
};

export type JiraOAuthAppsFeatureFlagsModuleActions = {
    __typename?: "JiraOAuthAppsFeatureFlagsModuleActions";
    /** A UrlTemplate which the app can inject a create feature flag button on the issue view */
    createFlag?: Maybe<JiraOAuthAppsUrlTemplate>;
    /** A UrlTemplate which the app can inject a link feature flag button on the issue view */
    linkFlag?: Maybe<JiraOAuthAppsUrlTemplate>;
    /** A UrlTemplate which the app can inject a list feature flags button on the issue view */
    listFlag?: Maybe<JiraOAuthAppsUrlTemplate>;
};

export type JiraOAuthAppsFeatureFlagsModuleActionsInput = {
    /** A UrlTemplate which the app can inject a create feature flag button on the issue view */
    createFlag?: InputMaybe<JiraOAuthAppsUrlTemplateInput>;
    /** A UrlTemplate which the app can inject a link feature flag button on the issue view */
    linkFlag?: InputMaybe<JiraOAuthAppsUrlTemplateInput>;
    /** A UrlTemplate which the app can inject a list feature flags button on the issue view */
    listFlag?: InputMaybe<JiraOAuthAppsUrlTemplateInput>;
};

export type JiraOAuthAppsFeatureFlagsModuleInput = {
    /** Actions that this app can invoke on feature flags data */
    actions?: InputMaybe<JiraOAuthAppsFeatureFlagsModuleActionsInput>;
    /** True if this app can read/write feature flags data */
    isEnabled: Scalars["Boolean"]["input"];
};

export type JiraOAuthAppsInstallAppInput = {
    /** The id of the app which will be installed */
    appId: Scalars["ID"]["input"];
    /** An id for this mutation */
    clientMutationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum JiraOAuthAppsInstallationStatus {
    Complete = "COMPLETE",
    Failed = "FAILED",
    /** One of the possible installation statuses: PENDING, RUNNING, COMPLETE, FAILED */
    Pending = "PENDING",
    Running = "RUNNING"
}

export type JiraOAuthAppsMutation = {
    __typename?: "JiraOAuthAppsMutation";
    /**
     * Create a new OAuth app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createJiraOAuthApp?: Maybe<JiraOAuthAppsPayload>;
    /**
     * Delete an existing OAuth app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteJiraOAuthApp?: Maybe<JiraOAuthAppsPayload>;
    /**
     * Install an OAuth app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    installJiraOAuthApp?: Maybe<JiraOAuthAppsPayload>;
    /**
     * Update an existing OAuth app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateJiraOAuthApp?: Maybe<JiraOAuthAppsPayload>;
};

export type JiraOAuthAppsMutationCreateJiraOAuthAppArgs = {
    cloudId: Scalars["String"]["input"];
    input: JiraOAuthAppsCreateAppInput;
};

export type JiraOAuthAppsMutationDeleteJiraOAuthAppArgs = {
    cloudId: Scalars["String"]["input"];
    input: JiraOAuthAppsDeleteAppInput;
};

export type JiraOAuthAppsMutationInstallJiraOAuthAppArgs = {
    cloudId: Scalars["String"]["input"];
    input: JiraOAuthAppsInstallAppInput;
};

export type JiraOAuthAppsMutationUpdateJiraOAuthAppArgs = {
    cloudId: Scalars["String"]["input"];
    input: JiraOAuthAppsUpdateAppInput;
};

/** Mutations */
export type JiraOAuthAppsPayload = Payload & {
    __typename?: "JiraOAuthAppsPayload";
    /** The state of the app after the mutation was applied */
    app?: Maybe<JiraOAuthAppsApp>;
    /** The ClientMutationId sent on the mutation input will be reflected here */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type JiraOAuthAppsRemoteLinksModule = {
    __typename?: "JiraOAuthAppsRemoteLinksModule";
    /** Actions that this app can invoke on remoteLinks information data */
    actions?: Maybe<Array<JiraOAuthAppsRemoteLinksModuleAction>>;
    /** True if this app can read/write remoteLinks information data */
    isEnabled: Scalars["Boolean"]["output"];
};

export type JiraOAuthAppsRemoteLinksModuleAction = {
    __typename?: "JiraOAuthAppsRemoteLinksModuleAction";
    id: Scalars["String"]["output"];
    label: JiraOAuthAppsRemoteLinksModuleActionLabel;
    urlTemplate: Scalars["String"]["output"];
};

export type JiraOAuthAppsRemoteLinksModuleActionInput = {
    id: Scalars["String"]["input"];
    label: JiraOAuthAppsRemoteLinksModuleActionLabelInput;
    urlTemplate: Scalars["String"]["input"];
};

export type JiraOAuthAppsRemoteLinksModuleActionLabel = {
    __typename?: "JiraOAuthAppsRemoteLinksModuleActionLabel";
    value: Scalars["String"]["output"];
};

export type JiraOAuthAppsRemoteLinksModuleActionLabelInput = {
    value: Scalars["String"]["input"];
};

export type JiraOAuthAppsRemoteLinksModuleInput = {
    /** Actions that this app can invoke on remoteLinks information data */
    actions?: InputMaybe<Array<JiraOAuthAppsRemoteLinksModuleActionInput>>;
    /** True if this app can read/write remoteLinks information data */
    isEnabled: Scalars["Boolean"]["input"];
};

export type JiraOAuthAppsUpdateAppInput = {
    /** The state the app should be after updating it */
    app: JiraOAuthAppsAppUpdateInput;
    /** The id of the app which will be changed */
    clientId: Scalars["ID"]["input"];
    /** An id for this mutation */
    clientMutationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraOAuthAppsUrlTemplate = {
    __typename?: "JiraOAuthAppsUrlTemplate";
    urlTemplate: Scalars["String"]["output"];
};

export type JiraOAuthAppsUrlTemplateInput = {
    urlTemplate: Scalars["String"]["input"];
};

/** An oauth app which provides devOps capabilities. */
export type JiraOAuthDevOpsProvider = JiraDevOpsProvider & {
    __typename?: "JiraOAuthDevOpsProvider";
    /**
     * The list of capabilities the devOps provider supports
     *
     * This max size of the list is bounded by the total number of enum states
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    capabilities?: Maybe<Array<Maybe<JiraDevOpsCapability>>>;
    /**
     * The human-readable display name of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The link to the icon of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * The corresponding marketplace app for the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    marketplaceApp?: Maybe<MarketplaceApp>;
    /**
     * The corresponding marketplace app key for the oauth app
     *
     * Note: Use this only if you wish to avoid the overhead of hydrating the marketplace app
     * for performance reasons i.e. you only need the app key and nothing else
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    marketplaceAppKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * The oauth app ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    oauthAppId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The link to the web URL of the devOps provider
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

export type JiraOnIssueCreatedForUserResponseType =
    | JiraIssueAndProject
    | JiraProjectConnection;

/** The types of events published by the onSuggestedChildIssue subscription. */
export type JiraOnSuggestedChildIssueResult =
    | JiraSuggestedChildIssueError
    | JiraSuggestedChildIssueStatus
    | JiraSuggestedIssue;

/** Represents Jira OpsgenieTeam. */
export type JiraOpsgenieTeam = Node & {
    __typename?: "JiraOpsgenieTeam";
    /** ARI of Opsgenie Team. */
    id: Scalars["ID"]["output"];
    /** Name of the Opsgenie Team. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Url of the Opsgenie Team. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a single option value in a select operation. */
export type JiraOption = JiraSelectableValue &
    Node & {
        __typename?: "JiraOption";
        /** Color of the option. */
        color?: Maybe<JiraColor>;
        /** Global Identifier of the option. */
        id: Scalars["ID"]["output"];
        /** Whether or not the option has been disabled by the user. Disabled options are typically not accessible in the UI. */
        isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
        /** Identifier of the option. */
        optionId: Scalars["String"]["output"];
        /**
         * Represents a group key where the option belongs to.
         * This will return null because the option does not belong to any group.
         */
        selectableGroupKey?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represent a url of the icon for the option.
         * This will return null because the option does not have an icon associated with it.
         */
        selectableIconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * Textual description of the value.
         * Renders either in dropdowns so users can discern between options
         * or in a form field when used as an active value for a field.
         */
        selectableLabel?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represents a url to make the option clickable.
         * This will return null since the option does not contain a URL.
         */
        selectableUrl?: Maybe<Scalars["URL"]["output"]>;
        /** Value of the option. */
        value?: Maybe<Scalars["String"]["output"]>;
    };

/** The connection type for JiraOption. */
export type JiraOptionConnection = {
    __typename?: "JiraOptionConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraOptionEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraOption connection. */
export type JiraOptionEdge = {
    __typename?: "JiraOptionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraOption>;
};

/** Input type for optional custom field and whether it should be cloned or not */
export type JiraOptionalFieldInput = {
    /** Custom field ID, for example customfield_10044 */
    fieldId: Scalars["String"]["input"];
    /** Boolean indicating whether custom fields should cloned or not. Fields are cloned by default. */
    shouldClone: Scalars["Boolean"]["input"];
};

/** The input type for opting out of the Not Connected state in the DevOpsPanel */
export type JiraOptoutDevOpsIssuePanelNotConnectedInput = {
    /** Cloud ID of the tenant this change is applied to */
    cloudId: Scalars["ID"]["input"];
};

/** The response payload for opting out of the Not Connected state in the DevOpsPanel */
export type JiraOptoutDevOpsIssuePanelNotConnectedPayload = Payload & {
    __typename?: "JiraOptoutDevOpsIssuePanelNotConnectedPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraOrderDirection = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraOrderFormattingRuleInput = {
    /** Move the current rule after this given rule. If not provided, move the current rule to top of the rule list. */
    afterRuleId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Deprecated, this field will be ignored.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Deprecated, this field will be ignored
     */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The rule to reorder. */
    ruleId: Scalars["ID"]["input"];
};

/** Response for the order formatting rule mutation. */
export type JiraOrderFormattingRulePayload = Payload & {
    __typename?: "JiraOrderFormattingRulePayload";
    /** List of errors while performing the reorder mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rules?: Maybe<JiraFormattingRuleConnection>;
    /** Denotes whether the reorder mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** Response for the order formatting rule mutation. */
export type JiraOrderFormattingRulePayloadRulesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    scope: Scalars["ID"]["input"];
};

export enum JiraOrganizationApprovalLocation {
    /** When the approval is done during the organization installation process */
    DuringInstallationFlow = "DURING_INSTALLATION_FLOW",
    /** When the approval is done during the provisioning the tenant */
    DuringProvisioning = "DURING_PROVISIONING",
    /** When the approval is done via DVCS page in Jira */
    OnAdminScreen = "ON_ADMIN_SCREEN",
    /** When the approval is done during the provisioning the tenant. This should be specific to Bitbucket only. */
    RemindBitbucketApprovalBanner = "REMIND_BITBUCKET_APPROVAL_BANNER",
    /** When the approval is done in unknown UI */
    Unknown = "UNKNOWN"
}

/** Input type for an organization field */
export type JiraOrganizationFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** List of organizations */
    organizations: Array<JiraOrganizationsInput>;
};

/** Input type for an organization value */
export type JiraOrganizationsInput = {
    /** An identifier for the organization */
    organizationId: Scalars["ID"]["input"];
};

/**
 * Represents the original time estimate field on Jira issue screens. Note that this is the same value as the originalEstimate from JiraTimeTrackingField
 * This field should only be used on issue view because issue view hasn't deprecated the original estimation as a standalone field
 */
export type JiraOriginalTimeEstimateField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraOriginalTimeEstimateField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Original Estimate displays the amount of time originally anticipated to resolve the issue. */
        originalEstimate?: Maybe<JiraEstimate>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input type for updating the Original Time Estimate field of a Jira issue. */
export type JiraOriginalTimeEstimateFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The new value to be placed in the Original Time Estimate field */
    originalEstimate: JiraEstimateInput;
};

/** The payload type returned after updating the Original Time Estimate field of a Jira issue. */
export type JiraOriginalTimeEstimateFieldPayload = Payload & {
    __typename?: "JiraOriginalTimeEstimateFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Original Time Estimate field. */
    field?: Maybe<JiraOriginalTimeEstimateField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents outgoing email settings response for banners on notification log page. */
export type JiraOutgoingEmailSettings = {
    __typename?: "JiraOutgoingEmailSettings";
    /**
     * Boolean to check if outgoing emails are disabled due to spam protection based rate limiting (done on free tenants currently)
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNotificationLog")' query directive to the 'emailDisabledDueToSpamProtectionRateLimit' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    emailDisabledDueToSpamProtectionRateLimit: Scalars["Boolean"]["output"];
    /**
     * Boolean to check if outgoing emails are disabled in the system settings.
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNotificationLog")' query directive to the 'emailSystemSettingsDisabled' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    emailSystemSettingsDisabled: Scalars["Boolean"]["output"];
    /**
     * Boolean to check if spam protection based rate limiting should applied to the current tenant.
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNotificationLog")' query directive to the 'spamProtectionOnTenantApplicable' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    spamProtectionOnTenantApplicable: Scalars["Boolean"]["output"];
};

/** Possible changeboarding statuses. */
export enum JiraOverviewPlanMigrationChangeboardingStatus {
    /** Indicate that the user has completed the changeboarding flow. */
    Completed = "COMPLETED",
    /** @deprecated Not used, replaced by COMPLETED status */
    Triggered = "TRIGGERED"
}

/** Describe the state of the overview-plan migration for the calling user. */
export type JiraOverviewPlanMigrationState = {
    __typename?: "JiraOverviewPlanMigrationState";
    /**
     * Indicate if the overview-plan migration changeboarding is active and should be shown to the user.
     * Changeboarding is only active for users who:
     * - have had their overviews successfully migrated to plans for less than 30 days
     * - have not yet gone through the changeboarding flow
     */
    changeboardingActive?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Indicate if the overview-plan migration changeboarding should be triggered and shown to the user.
     * Changeboarding is only shown to eligible users who had their overviews successfully migrated to plans.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Not used and will always return null, replaced by changeboardingActive
     */
    triggerChangeboarding?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Result type for the jwmOverviewPlanMigrationState field */
export type JiraOverviewPlanMigrationStateResult =
    | JiraOverviewPlanMigrationState
    | QueryError;

/** The base type cursor data necessary for random access pagination. */
export type JiraPageCursor = {
    __typename?: "JiraPageCursor";
    /** This is a Base64 encoded value containing the all the necessary data for retrieving the page items. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** Indicates if this page is the current page. Usually the current page is represented differently on the FE. */
    isCurrent?: Maybe<Scalars["Boolean"]["output"]>;
    /** The number of the page it represents. First page is 1. */
    pageNumber?: Maybe<Scalars["Int"]["output"]>;
};

/** This encapsulates all the necessary cursors for random access pagination. */
export type JiraPageCursors = {
    __typename?: "JiraPageCursors";
    /**
     * Represents a list of cursors around the current page.
     * Even if the list is not bounded, there are strict limits set on the server (MAX_SIZE <= 7).
     */
    around?: Maybe<Array<Maybe<JiraPageCursor>>>;
    /** Represents the cursor for the first page. */
    first?: Maybe<JiraPageCursor>;
    /** Represents the cursor for the last page. */
    last?: Maybe<JiraPageCursor>;
    /**
     * Represents the cursor for the previous page.
     * E.g. currentPage=2 => previousPage=1
     */
    previous?: Maybe<JiraPageCursor>;
};

/** Input type for the parent field of an issue */
export type JiraParentFieldInput = {
    /** An identifier for the issue */
    issueId: Scalars["ID"]["input"];
};

/** Input type for defining the operation on the Parent field of a Jira issue. */
export type JiraParentFieldOperationInput = {
    /** Accept ARI(s): issue */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The operation to perform on the Parent field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating the Parent field of a Jira issue. */
export type JiraParentFieldPayload = Payload & {
    __typename?: "JiraParentFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Parent field. */
    field?: Maybe<JiraParentIssueField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */
export type JiraParentIssueField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraParentIssueField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Paginated list of parent options available for the field for an Issue. */
        parentCandidatesForExistingIssue?: Maybe<JiraIssueConnection>;
        /** The parent selected on the Issue or default parent configured for the field. */
        parentIssue?: Maybe<JiraIssue>;
        /** Represents flags required to determine parent field visibility */
        parentVisibility?: Maybe<JiraParentVisibility>;
        /**
         * Search url to fetch all available parents for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */
export type JiraParentIssueFieldParentCandidatesForExistingIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    excludeDone?: InputMaybe<Scalars["Boolean"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraParentOption = JiraHasSelectableValueOptions &
    JiraSelectableValue &
    Node & {
        __typename?: "JiraParentOption";
        /**
         * Paginated list of cascading child options available for the parent option.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        childOptions?: Maybe<JiraOptionConnection>;
        /** ARI: issue-field-option */
        id: Scalars["ID"]["output"];
        /** Whether or not the option has been disabled by the user. Disabled options are typically not accessible in the UI. */
        isDisabled?: Maybe<Scalars["Boolean"]["output"]>;
        /** ARI: issue-id */
        issueId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Represents a group key where the parent option belongs to.
         * This will return null because the parent option does not belong to any group.
         */
        selectableGroupKey?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represent a url of the icon for the parent option.
         * This will return null because the option does not have an icon associated with it.
         */
        selectableIconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * Textual description of the value.
         * Renders either in dropdowns so users can discern between parent options
         * or in a form field when used as an active value for a field.
         */
        selectableLabel?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represents a url to make the parent option clickable.
         * This will return null since the parent option does not contain a URL.
         */
        selectableUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * Paginated list of JiraParentOption options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /** Value of the option */
        value?: Maybe<Scalars["String"]["output"]>;
    };

export type JiraParentOptionChildOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraParentOptionSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** The connection type for JiraParentOption. */
export type JiraParentOptionConnection = {
    __typename?: "JiraParentOptionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraParentOptionEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraParentOption connection. */
export type JiraParentOptionEdge = {
    __typename?: "JiraParentOptionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraParentOption>;
};

/** Represents flags required to determine parent field visibility */
export type JiraParentVisibility = {
    __typename?: "JiraParentVisibility";
    /** Flag which along with hasEpicLinkFieldDependency is used to determine the Parent Link field visiblity. */
    canUseParentLinkField?: Maybe<Scalars["Boolean"]["output"]>;
    /** Flag to disable editing the Parent Link field and showing the error that the issue has an epic link set, and thus cannot use the Parent Link field. */
    hasEpicLinkFieldDependency?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents a people picker field on a Jira Issue. */
export type JiraPeopleField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraPeopleField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether the field is configured to act as single/multi select user(s) field. */
        isMulti?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available users options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The people selected on the Issue or default people configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedUsersConnection instead.
         */
        selectedUsers?: Maybe<Array<Maybe<User>>>;
        /** The users selected on the Issue or default users configured for the field. */
        selectedUsersConnection?: Maybe<JiraUserConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of user options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        users?: Maybe<JiraUserConnection>;
    };

/** Represents a people picker field on a Jira Issue. */
export type JiraPeopleFieldSelectedUsersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a people picker field on a Jira Issue. */
export type JiraPeopleFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for people field */
export type JiraPeopleFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Input data for users being selected */
    users: Array<JiraUserInput>;
};

/** Input type for defining the operation on People field of a Jira issue. */
export type JiraPeopleFieldOperationInput = {
    /** Accepts ARI(s): user */
    ids: Array<Scalars["ID"]["input"]>;
    /** The operation to perform on the People field. */
    operation: JiraMultiValueFieldOperations;
};

/** The payload type returned after updating People field of a Jira issue. */
export type JiraPeopleFieldPayload = Payload & {
    __typename?: "JiraPeopleFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated People field. */
    field?: Maybe<JiraPeopleField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/**
 * This represents Jira Permission with all Permission level details (To be added)
 * and can be used to determine whether a User has certain permissions.
 * Note: This entity only returns `hasPermission`
 * but in future, it should contain more permission level details like ID, description etc.
 */
export type JiraPermission = {
    __typename?: "JiraPermission";
    hasPermission?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * The JiraPermissionConfiguration represents additional configuration information regarding the permission such as
 * deprecation, new addition etc. It contains documentation/notice and/or actionable items for the permission
 * such as deprecation of BROWSE_PROJECTS in favour of VIEW_PROJECTS and VIEW_ISSUES.
 */
export type JiraPermissionConfiguration = {
    __typename?: "JiraPermissionConfiguration";
    /** The documentation for the permission key. */
    documentation?: Maybe<JiraPermissionDocumentationExtension>;
    /** The indicator saying whether a permission is editable or not. */
    isEditable: Scalars["Boolean"]["output"];
    /** The message contains actionable information for the permission key. */
    message?: Maybe<JiraPermissionMessageExtension>;
    /** The tag for the permission key. */
    tag: JiraPermissionTagEnum;
};

/** The JiraPermissionDocumentationExtension contains developer documentation for a permission key. */
export type JiraPermissionDocumentationExtension = {
    __typename?: "JiraPermissionDocumentationExtension";
    /** The display text of the developer documentation. */
    text: Scalars["String"]["output"];
    /** The link to the developer documentation. */
    url: Scalars["String"]["output"];
};

/**
 * The JiraPermissionGrant represents an association between the grant type key and the grant value.
 * Each grant value has grant type specific information.
 * For example, PROJECT_ROLE grant type value contains project role ID in ARI format and role specific details.
 */
export type JiraPermissionGrant = {
    __typename?: "JiraPermissionGrant";
    /** The grant type information includes key and display name. */
    grantType: JiraGrantTypeKey;
    /** The grant value has grant type key specific information. */
    grantValue: JiraPermissionGrantValue;
};

/** The type represents a paginated view of permission grants in the form of connection object. */
export type JiraPermissionGrantConnection = {
    __typename?: "JiraPermissionGrantConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraPermissionGrantEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of items matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The permission grant edge object used in connection object for representing an edge. */
export type JiraPermissionGrantEdge = {
    __typename?: "JiraPermissionGrantEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. */
    node: JiraPermissionGrant;
};

/**
 * The JiraPermissionGrantHolder represents an association between project permission information and
 * a bounded list of one or more permission grant.
 * A permission grant holds association between grant type and a paginated list of grant values.
 */
export type JiraPermissionGrantHolder = {
    __typename?: "JiraPermissionGrantHolder";
    /** The additional configuration information regarding the permission. */
    configuration?: Maybe<JiraPermissionConfiguration>;
    /** A bounded list of jira permission grant. */
    grants?: Maybe<Array<JiraPermissionGrants>>;
    /** The basic information about the project permission. */
    permission: JiraProjectPermission;
};

/**
 * The permission grant value represents the actual permission grant value.
 * The id field represent the grant ID and its not an ARI. The value represents actual value information specific to grant type.
 * For example: PROJECT_ROLE grant type value contains project role ID in ARI format and role specific details
 */
export type JiraPermissionGrantValue = {
    __typename?: "JiraPermissionGrantValue";
    /**
     * The ID of the permission grant.
     * It represents the relationship among permission, grant type and grant type specific value.
     */
    id: Scalars["ID"]["output"];
    /**
     * The optional grant type value is a union type.
     * The value itself may resolve to one of the concrete types such as JiraDefaultGrantTypeValue, JiraProjectRoleGrantTypeValue.
     */
    value?: Maybe<JiraGrantTypeValue>;
};

/** The type represents a paginated view of permission grant values in the form of connection object. */
export type JiraPermissionGrantValueConnection = {
    __typename?: "JiraPermissionGrantValueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraPermissionGrantValueEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** The total number of items matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The permission grant value edge object used in connection object for representing an edge. */
export type JiraPermissionGrantValueEdge = {
    __typename?: "JiraPermissionGrantValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. */
    node: JiraPermissionGrantValue;
};

/**
 * The JiraPermissionGrants represents an association between grant type information and a bounded list of one or more grant
 * values associated with given grant type.
 * Each grant value has grant type specific information.
 * For example, PROJECT_ROLE grant type value contains project role ID in ARI format and role specific details.
 */
export type JiraPermissionGrants = {
    __typename?: "JiraPermissionGrants";
    /** The grant type information includes key and display name. */
    grantType: JiraGrantTypeKey;
    /** A bounded list of grant values. Each grant value has grant type specific information. */
    grantValues?: Maybe<Array<JiraPermissionGrantValue>>;
    /** The total number of items matching the criteria */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * Contains either the group or the projectRole associated with a comment/worklog, but not both.
 * If both are null, then the permission level is unspecified and the comment/worklog is public.
 */
export type JiraPermissionLevel = {
    __typename?: "JiraPermissionLevel";
    /** The Jira Group associated with the comment/worklog. */
    group?: Maybe<JiraGroup>;
    /** The Jira ProjectRole associated with the comment/worklog. */
    role?: Maybe<JiraRole>;
};

/**
 * The JiraPermissionMessageExtension represents actionable information for a permission such as deprecation of
 * BROWSE_PROJECTS in favour of VIEW_PROJECTS and VIEW_ISSUES.
 */
export type JiraPermissionMessageExtension = {
    __typename?: "JiraPermissionMessageExtension";
    /** The display text of the message. */
    text: Scalars["String"]["output"];
    /** The category of the message such as WARNING, INFORMATION etc. */
    type: JiraPermissionMessageTypeEnum;
};

/** The JiraPermissionMessageTypeEnum represents category of the message section. */
export enum JiraPermissionMessageTypeEnum {
    /** Represents a basic message. */
    Information = "INFORMATION",
    /** Represents a warning message. */
    Warning = "WARNING"
}

/** A permission scheme is a collection of permission grants. */
export type JiraPermissionScheme = Node & {
    __typename?: "JiraPermissionScheme";
    /** The description of the permission scheme. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the permission scheme. */
    id: Scalars["ID"]["output"];
    /** The display name of the permission scheme. */
    name: Scalars["String"]["output"];
};

/** The input type to add new permission grants to the given permission scheme. */
export type JiraPermissionSchemeAddGrantInput = {
    /** The list of one or more grants to be added. */
    grants: Array<JiraPermissionSchemeGrantInput>;
    /** The permission scheme ID in ARI format. */
    schemeId: Scalars["ID"]["input"];
};

/** The response payload for add permission grants mutation operation for a given permission scheme. */
export type JiraPermissionSchemeAddGrantPayload = Payload & {
    __typename?: "JiraPermissionSchemeAddGrantPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** The JiraPermissionSchemeConfiguration represents additional configuration information regarding the permission scheme such as its editability. */
export type JiraPermissionSchemeConfiguration = {
    __typename?: "JiraPermissionSchemeConfiguration";
    /** The indicator saying whether a permission scheme is editable or not. */
    isEditable: Scalars["Boolean"]["output"];
};

/**
 * The JiraPermissionSchemeGrantGroup is an association between project permission category information and a bounded list of one or more
 * associated permission grant holder. A grant holder represents project permission information and its associated permission grants.
 */
export type JiraPermissionSchemeGrantGroup = {
    __typename?: "JiraPermissionSchemeGrantGroup";
    /** The basic project permission category information such as key and display name. */
    category: JiraProjectPermissionCategory;
    /** A bounded list of one or more permission grant holders. */
    grantHolders?: Maybe<Array<Maybe<JiraPermissionGrantHolder>>>;
};

/** Specifies permission scheme grant for the combination of permission key, grant type key, and grant type value ARI. */
export type JiraPermissionSchemeGrantInput = {
    /** The grant type key such as USER. */
    grantType: JiraGrantTypeKeyEnum;
    /**
     * The optional grant value in ARI format. Some grantType like PROJECT_LEAD, REPORTER etc. have no grantValue. Any grantValue passed will be silently ignored.
     * For example: project role ID ari is of the format - ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:role/project-role/activation/bd0c43a9-a23a-4302-8ffa-ca04bde7c747/projectrole/b434089d-7f6d-476b-884b-7811661f91d2
     */
    grantValue?: InputMaybe<Scalars["ID"]["input"]>;
    /** the project permission key. */
    permissionKey: Scalars["String"]["input"];
};

/** The input type to remove permission grants from the given permission scheme. */
export type JiraPermissionSchemeRemoveGrantInput = {
    /** The list of permission grant ids. */
    grantIds: Array<Scalars["Long"]["input"]>;
    /**
     * The list of one or more grants to be removed.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Please use grantIds field instead
     */
    grants?: InputMaybe<Array<JiraPermissionSchemeGrantInput>>;
    /** The permission scheme ID in ARI format. */
    schemeId: Scalars["ID"]["input"];
};

/** The response payload for remove existing permission grants mutation operation for a given permission scheme. */
export type JiraPermissionSchemeRemoveGrantPayload = Payload & {
    __typename?: "JiraPermissionSchemeRemoveGrantPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/**
 * The JiraPermissionSchemeView represents the composite view to capture basic information of
 * the permission scheme such as id, name, description and a bounded list of one or more grant groups.
 * A grant group contains existing permission grant information such as permission, permission category, grant type and grant type value.
 */
export type JiraPermissionSchemeView = {
    __typename?: "JiraPermissionSchemeView";
    /** The additional configuration information regarding the permission scheme. */
    configuration: JiraPermissionSchemeConfiguration;
    /** The bounded list of one or more grant groups represent each group of permission grants based on project permission category such as PROJECTS, ISSUES. */
    grantGroups?: Maybe<Array<JiraPermissionSchemeGrantGroup>>;
    /** The basic permission scheme information such as id, name and description. */
    scheme: JiraPermissionScheme;
};

/** The union result representing either the composite view of the permission scheme or the query error information. */
export type JiraPermissionSchemeViewResult =
    | JiraPermissionSchemeView
    | QueryError;

/** The JiraPermissionTagEnum represents additional tags for the permission key. */
export enum JiraPermissionTagEnum {
    /** Represents a permission that is about to be deprecated. */
    Deprecated = "DEPRECATED",
    /** Represents a permission that is only available to enterprise customers. */
    Enterprise = "ENTERPRISE",
    /** Represents a permission that is newly added. */
    New = "NEW"
}

/** The different permission types that a user can perform on a global level */
export enum JiraPermissionType {
    /** user with this permission can browse at least one project */
    BrowseProjects = "BROWSE_PROJECTS",
    /** user with this permission can modify collections of issues at once */
    BulkChange = "BULK_CHANGE"
}

/** Represents a Jira Plan */
export type JiraPlan = Node & {
    __typename?: "JiraPlan";
    /** Returns the default navigation item for this plan, represented by `JiraNavigationItem`. */
    defaultNavigationItem?: Maybe<JiraNavigationItemResult>;
    /** A favourite value which contains the boolean of if it is favourited and a unique ID */
    favouriteValue?: Maybe<JiraFavouriteValue>;
    /** Global identifier for the plan */
    id: Scalars["ID"]["output"];
    /**
     * The feature indicator determines whether the auto scheduler feature is enabled or not
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFeaturesPage")' query directive to the 'isAutoSchedulerEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isAutoSchedulerEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The feature indicator determines whether the multi-scenario feature is enabled or not
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFeaturesPage")' query directive to the 'isMultiScenarioEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isMultiScenarioEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The ability for the user to edit the plan. */
    isReadOnly?: Maybe<Scalars["Boolean"]["output"]>;
    /** The timestamp of this project was last viewed by the current user (reference to Unix Epoch time in ms). */
    lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
    /** The owner of the plan */
    owner?: Maybe<User>;
    /** The plan id of the plan. e.g. 10000. Temporarily needed to support interoperability with REST. */
    planId?: Maybe<Scalars["Long"]["output"]>;
    /**
     * A list of all existing scenarios that belong to the plan
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFeaturesPage")' query directive to the 'planScenarios' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    planScenarios?: Maybe<JiraScenarioConnection>;
    /** The planStatus */
    planStatus?: Maybe<JiraPlanStatus>;
    /** The URL string associated with a user's plan in Jira. */
    planUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The default or most recently visited scenario of the plan. */
    scenario?: Maybe<JiraScenario>;
    /** The title of the plan */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a Jira Plan */
export type JiraPlanPlanScenariosArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraPlanFeatureMutationInput = {
    /** Feature toggle value */
    enabled: Scalars["Boolean"]["input"];
    /** Plan ARI ID */
    planId: Scalars["ID"]["input"];
};

export type JiraPlanMultiScenarioFeatureMutationInput = {
    /** Feature toggle value */
    enabled: Scalars["Boolean"]["input"];
    /** Plan ARI ID */
    planId: Scalars["ID"]["input"];
    /** The scenario ID to keep */
    scenarioId: Scalars["ID"]["input"];
};

/** The status of a Jira Plan */
export enum JiraPlanStatus {
    Active = "ACTIVE",
    Archived = "ARCHIVED",
    Trashed = "TRASHED"
}

/** Represents a Jira platform attachment. */
export type JiraPlatformAttachment = JiraAttachment &
    Node & {
        __typename?: "JiraPlatformAttachment";
        /** Identifier for the attachment. */
        attachmentId: Scalars["String"]["output"];
        /** A property of the attachment held in key/value store backing the object. */
        attachmentProperty?: Maybe<Scalars["JSON"]["output"]>;
        /** User profile of the attachment author. */
        author?: Maybe<User>;
        /** Date the attachment was created in seconds since the epoch. */
        created: Scalars["DateTime"]["output"];
        /** Filename of the attachment. */
        fileName?: Maybe<Scalars["String"]["output"]>;
        /** Size of the attachment in bytes. */
        fileSize?: Maybe<Scalars["Long"]["output"]>;
        /** Indicates if an attachment is within a restricted parent comment. */
        hasRestrictedParent?: Maybe<Scalars["Boolean"]["output"]>;
        /** Global identifier for the attachment */
        id: Scalars["ID"]["output"];
        /** Enclosing issue object of the current attachment. */
        issue?: Maybe<JiraIssue>;
        /** Media Services file id of this Attachment, May be absent if the attachment has not yet been migrated to Media Services. */
        mediaApiFileId?: Maybe<Scalars["String"]["output"]>;
        /**
         * Contains the information needed for reading uploaded media content in jira.
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraAttachmentMediaReadToken")' query directive to the 'mediaReadToken' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        mediaReadToken?: Maybe<Scalars["String"]["output"]>;
        /** The mimetype (also called content type) of the attachment. This may be {@code null}. */
        mimeType?: Maybe<Scalars["String"]["output"]>;
        /** Parent name that this attachment is contained in either issue, environment, description, comment, worklog or form */
        parent?: Maybe<JiraAttachmentParentName>;
        /** Parent id that this attachment is contained in. */
        parentId?: Maybe<Scalars["String"]["output"]>;
        /**
         * Parent name that this attachment is contained in e.g Issue, Field, Comment, Worklog.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use parent instead
         */
        parentName?: Maybe<Scalars["String"]["output"]>;
        /** Contains the information needed to locate this attachment in the attachment connection from search. */
        searchViewContext?: Maybe<JiraAttachmentSearchViewContext>;
    };

/** Represents a Jira platform attachment. */
export type JiraPlatformAttachmentAttachmentPropertyArgs = {
    key: Scalars["String"]["input"];
};

/** Represents a Jira platform attachment. */
export type JiraPlatformAttachmentMediaReadTokenArgs = {
    durationInSeconds: Scalars["Int"]["input"];
    maxTokenLength: Scalars["Int"]["input"];
};

/** Represents a Jira platform attachment. */
export type JiraPlatformAttachmentSearchViewContextArgs = {
    filter: JiraAttachmentSearchViewContextInput;
};

/** Represents a Jira platform comment. */
export type JiraPlatformComment = JiraComment &
    Node & {
        __typename?: "JiraPlatformComment";
        /** User profile of the original comment author. */
        author?: Maybe<User>;
        /**
         * Paginated list of child comments on this comment.
         * Order will always be based on creation time (ascending).
         * Note - No support for focused child comments or sorting order on child comments is provided.
         */
        childComments?: Maybe<JiraCommentConnection>;
        /** Identifier for the comment. */
        commentId: Scalars["ID"]["output"];
        /** Time of comment creation. */
        created: Scalars["DateTime"]["output"];
        /** Global identifier for the comment */
        id: Scalars["ID"]["output"];
        /**
         * Property to denote if the comment is a deleted root comment. Default value is False.
         * When true, all other attributes will be null except for id, commentId, childComments and created.
         */
        isDeleted?: Maybe<Scalars["Boolean"]["output"]>;
        /** The issue to which this comment is belonged. */
        issue?: Maybe<JiraIssue>;
        /**
         * Either the group or the project role associated with this comment, but not both.
         * Null means the permission level is unspecified, i.e. the comment is public.
         */
        permissionLevel?: Maybe<JiraPermissionLevel>;
        /** Comment body rich text. */
        richText?: Maybe<JiraRichText>;
        /**
         * Parent ID of the child for which data is requested. This should be non-null if a child comment is requested and
         * null if a root comment is requested.
         */
        threadParentId?: Maybe<Scalars["ID"]["output"]>;
        /** User profile of the author performing the comment update. */
        updateAuthor?: Maybe<User>;
        /** Time of last comment update. */
        updated?: Maybe<Scalars["DateTime"]["output"]>;
        /** The browser clickable link of this comment. */
        webUrl?: Maybe<Scalars["URL"]["output"]>;
    };

/** Represents a Jira platform comment. */
export type JiraPlatformCommentChildCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    afterTarget?: InputMaybe<Scalars["Int"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    beforeTarget?: InputMaybe<Scalars["Int"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    targetId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Single Playbook entity */
export type JiraPlaybook = Node & {
    __typename?: "JiraPlaybook";
    filters?: Maybe<Array<JiraPlaybookIssueFilter>>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    owner?: Maybe<User>;
    /** scopeId is projectId */
    scopeId?: Maybe<Scalars["String"]["output"]>;
    scopeType?: Maybe<JiraPlaybookScopeType>;
    state?: Maybe<JiraPlaybookStateField>;
    steps?: Maybe<Array<JiraPlaybookStep>>;
};

/** Pagination */
export type JiraPlaybookConnection = HasPageInfo &
    QueryPayload & {
        __typename?: "JiraPlaybookConnection";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        edges?: Maybe<Array<JiraPlaybookEdge>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<QueryError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        nodes?: Maybe<Array<Maybe<JiraPlaybook>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        pageInfo: PageInfo;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

/** Pagination */
export type JiraPlaybookEdge = {
    __typename?: "JiraPlaybookEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraPlaybook>;
};

/** Search by name Filter for Jira Playbook */
export type JiraPlaybookFilter = {
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraPlaybookInstance = Node & {
    __typename?: "JiraPlaybookInstance";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    countOfAllSteps?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    countOfCompletedSteps?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    steps?: Maybe<Array<JiraPlaybookInstanceStep>>;
};

/** Pagination */
export type JiraPlaybookInstanceConnection = HasPageInfo &
    QueryPayload & {
        __typename?: "JiraPlaybookInstanceConnection";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        edges?: Maybe<Array<JiraPlaybookInstanceEdge>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<QueryError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        nodes?: Maybe<Array<Maybe<JiraPlaybookInstance>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        pageInfo: PageInfo;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

export type JiraPlaybookInstanceEdge = {
    __typename?: "JiraPlaybookInstanceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraPlaybookInstance>;
};

export type JiraPlaybookInstanceStep = Node & {
    __typename?: "JiraPlaybookInstanceStep";
    description?: Maybe<Scalars["JSON"]["output"]>;
    id: Scalars["ID"]["output"];
    lastRun?: Maybe<JiraPlaybookStepRun>;
    name?: Maybe<Scalars["String"]["output"]>;
    ruleId?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<JiraPlaybookStepType>;
};

/** Issue filter for Jira Playbook */
export type JiraPlaybookIssueFilter = {
    __typename?: "JiraPlaybookIssueFilter";
    type?: Maybe<JiraPlaybookIssueFilterType>;
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** --------------------------------------------------------------------------------------------- */
export type JiraPlaybookIssueFilterInput = {
    type?: InputMaybe<JiraPlaybookIssueFilterType>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum JiraPlaybookIssueFilterType {
    Groups = "GROUPS",
    IssueTypes = "ISSUE_TYPES",
    RequestTypes = "REQUEST_TYPES"
}

/** Get By playbookId: Query Response (GET) */
export type JiraPlaybookQueryPayload = QueryPayload & {
    __typename?: "JiraPlaybookQueryPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    playbook?: Maybe<JiraPlaybook>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Scopes */
export enum JiraPlaybookScopeType {
    Global = "GLOBAL",
    Project = "PROJECT",
    Team = "TEAM"
}

/** Status of playbook */
export enum JiraPlaybookStateField {
    Disabled = "DISABLED",
    Enabled = "ENABLED"
}

export type JiraPlaybookStep = {
    __typename?: "JiraPlaybookStep";
    description?: Maybe<Scalars["JSON"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    ruleId?: Maybe<Scalars["String"]["output"]>;
    stepId: Scalars["ID"]["output"];
    type?: Maybe<JiraPlaybookStepType>;
};

export type JiraPlaybookStepOutput = {
    __typename?: "JiraPlaybookStepOutput";
    message?: Maybe<Scalars["String"]["output"]>;
    results?: Maybe<Array<JiraPlaybookStepOutputKeyValuePair>>;
};

export type JiraPlaybookStepOutputKeyValuePair = {
    __typename?: "JiraPlaybookStepOutputKeyValuePair";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type JiraPlaybookStepRun = Node & {
    __typename?: "JiraPlaybookStepRun";
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    id: Scalars["ID"]["output"];
    playbookId?: Maybe<Scalars["ID"]["output"]>;
    playbookName?: Maybe<Scalars["String"]["output"]>;
    stepDuration?: Maybe<Scalars["Long"]["output"]>;
    stepId?: Maybe<Scalars["ID"]["output"]>;
    stepName?: Maybe<Scalars["String"]["output"]>;
    stepOutput?: Maybe<Array<JiraPlaybookStepOutput>>;
    stepStatus?: Maybe<JiraPlaybookStepRunStatus>;
    stepType?: Maybe<JiraPlaybookStepType>;
    triggeredAt?: Maybe<Scalars["DateTime"]["output"]>;
    triggeredBy?: Maybe<User>;
};

/** Pagination */
export type JiraPlaybookStepRunConnection = HasPageInfo &
    QueryPayload & {
        __typename?: "JiraPlaybookStepRunConnection";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        edges?: Maybe<Array<JiraPlaybookStepRunEdge>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<QueryError>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        nodes?: Maybe<Array<Maybe<JiraPlaybookStepRun>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        pageInfo: PageInfo;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

/** Pagination */
export type JiraPlaybookStepRunEdge = {
    __typename?: "JiraPlaybookStepRunEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraPlaybookStepRun>;
};

export enum JiraPlaybookStepRunStatus {
    Failed = "FAILED",
    InProgress = "IN_PROGRESS",
    Success = "SUCCESS"
}

/** --------------------------------------------------------------------------------------------- */
export enum JiraPlaybookStepType {
    AutomationRule = "AUTOMATION_RULE",
    InstructionalRule = "INSTRUCTIONAL_RULE"
}

export enum JiraPlaybooksSortBy {
    Name = "NAME"
}

/** --------------------------------------------------------------------------------------------- */
export type JiraPlaybooksSortInput = {
    /** The field to apply sorting on */
    by: JiraPlaybooksSortBy;
    /** The direction of sorting */
    order?: SortDirection;
};

/** A link to a post-incident review (also known as a postmortem). */
export type JiraPostIncidentReviewLink = Node & {
    __typename?: "JiraPostIncidentReviewLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The title of the post-incident review. May be null.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * The URL of the post-incident review (e.g. a Confluence page or Google Doc URL).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Represents an issue's priority field */
export type JiraPriority = Node & {
    __typename?: "JiraPriority";
    /** The priority color. */
    color?: Maybe<Scalars["String"]["output"]>;
    /** The priority icon URL. */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Unique identifier referencing the priority ID. */
    id: Scalars["ID"]["output"];
    /**
     * The corresponding JSM incident priority
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIncidentPriority")' query directive to the 'jsmIncidentPriority' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmIncidentPriority?: Maybe<JiraIncidentPriority>;
    /** The priority name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The priority ID. E.g. 10000. */
    priorityId: Scalars["String"]["output"];
    /** The priority position in the global priority list. */
    sequence?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for JiraPriority. */
export type JiraPriorityConnection = {
    __typename?: "JiraPriorityConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraPriorityEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraPriority connection. */
export type JiraPriorityEdge = {
    __typename?: "JiraPriorityEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraPriority>;
};

/** Represents a priority field on a Jira Issue. */
export type JiraPriorityField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraPriorityField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an Issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Paginated list of priority options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        priorities?: Maybe<JiraPriorityConnection>;
        /** The priority selected on the Issue or default priority configured for the field. */
        priority?: Maybe<JiraPriority>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a priority field on a Jira Issue. */
export type JiraPriorityFieldPrioritiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JiraPriorityFieldOperationInput = {
    /** Accepts ARI(s): priority */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'id' param
     */
    priority?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraPriorityFieldPayload = Payload & {
    __typename?: "JiraPriorityFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraPriorityField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type for priority field */
export type JiraPriorityInput = {
    /** An identifier for a priority value */
    priorityId: Scalars["ID"]["input"];
};

/** Representation of each Jira product offering. */
export enum JiraProductEnum {
    JiraProductDiscovery = "JIRA_PRODUCT_DISCOVERY",
    JiraServiceManagement = "JIRA_SERVICE_MANAGEMENT",
    JiraSoftware = "JIRA_SOFTWARE",
    JiraWorkManagement = "JIRA_WORK_MANAGEMENT"
}

/** Represents proforma-forms. */
export type JiraProformaForms = {
    __typename?: "JiraProformaForms";
    /**
     * Indicates whether the issue has proforma-forms or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasIssueForms?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Indicates whether the project has proforma-forms or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasProjectForms?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Indicates whether the issue has harmonisation enabled or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isHarmonisationEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents the proforma-forms field for an Issue. */
export type JiraProformaFormsField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraProformaFormsField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The proforma-forms selected on the Issue or default major incident configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        proformaForms?: Maybe<JiraProformaForms>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a Jira project. */
export type JiraProject = Node & {
    __typename?: "JiraProject";
    /**
     * Checks whether the requesting user can perform the specific action on the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action?: Maybe<JiraProjectAction>;
    /**
     * The active background of the project.
     * Currently only supported for Software and Business projects.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Replaced by JiraProject.background which includes QueryError in the return type
     */
    activeBackground?: Maybe<JiraBackground>;
    /**
     * Returns a paginated connection of users that are assignable to issues in the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    assignableUsers?: Maybe<JiraAssignableUsersConnection>;
    /**
     * Returns components mapped to the JSW project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphOperationsInJira")' query directive to the 'associatedComponents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    associatedComponents?: Maybe<GraphGenericConnection>;
    /**
     * This is to fetch all the fields associated with the given projects issue layouts
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    associatedIssueLayoutFields?: Maybe<JiraFieldConnection>;
    /**
     * Returns JSM projects that share a component with the given JSW project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphOperationsInJira")' query directive to the 'associatedJsmProjectsByComponent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    associatedJsmProjectsByComponent?: Maybe<GraphJiraProjectConnection>;
    /**
     * Returns Service entities associated with this Jira project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    associatedServices?: Maybe<GraphProjectServiceConnection>;
    /**
     * The avatar of the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    avatar?: Maybe<JiraAvatar>;
    /**
     * The active background of the project.
     * Currently only supported for Software and Business projects.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    background?: Maybe<JiraActiveBackgroundDetailsResult>;
    /**
     * Returns list of boards in the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boards?: Maybe<JiraBoardConnection>;
    /**
     * Returns if the user has the access to set issue restriction with the current project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canSetIssueRestriction?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The category of the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    category?: Maybe<JiraProjectCategory>;
    /**
     * Returns classification tags for this project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    classificationTags: Array<Scalars["String"]["output"]>;
    /**
     * The cloudId associated with the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cloudId: Scalars["ID"]["output"];
    /**
     * Get conditional formatting rules for project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    conditionalFormattingRules?: Maybe<JiraFormattingRuleConnection>;
    /**
     * Returns the date and time the project was created.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    created?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Returns the default navigation item for this project, represented by `JiraNavigationItem`.
     * Currently only business and software projects are supported. Will return `null` for other project types.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    defaultNavigationItem?: Maybe<JiraNavigationItemResult>;
    /**
     * The description of the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The connection entity for DevOps entity relationships for this Jira project, according to the specified
     * pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    devOpsEntityRelationships?: Maybe<AriGraphRelationshipConnection>;
    /**
     * The connection entity for DevOps Service relationships for this Jira project, according to the specified
     * pagination, filtering.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    devOpsServiceRelationships?: Maybe<DevOpsServiceAndJiraProjectRelationshipConnection>;
    /**
     * A unique favourite node that determines if project has been favourited by the user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favouriteValue?: Maybe<JiraFavouriteValue>;
    /**
     * Returns true if at least one relationship of the specified type exists where the project ID is the to in the relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsOperationsInJira")' query directive to the 'hasRelationshipFrom' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    hasRelationshipFrom?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns true if at least one relationship of the specified type exists where the project ID is the from in the relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsOperationsInJira")' query directive to the 'hasRelationshipTo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    hasRelationshipTo?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Global identifier for the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * A list of Intent Templates that are associated with a JSM Project."
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgentIntentTemplate")' query directive to the 'intentTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    intentTemplates?: Maybe<VirtualAgentIntentTemplatesConnection>;
    /**
     * Is Ai enabled for this project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isAIEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the project has explicit field associations (EFA) enabled.
     * This is a temporary field and will be removed in the future when EFA is enabled for all tenants.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFields")' query directive to the 'isExplicitFieldAssociationsEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isExplicitFieldAssociationsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the project has been favourited by the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Specifies if the project is used as a live custom template or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isLiveTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Is Playbooks enabled for this project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isPlaybooksEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether virtual service agent is enabled for this JSM Project"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isVirtualAgentEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Issue types for this project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issueTypes?: Maybe<JiraIssueTypeConnection>;
    /**
     * JSM Chat overall configuration for a JSM Project."
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChat")' query directive to the 'jsmChatInitialNativeConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated jsmChatInitialConfig will be removed soon
     */
    jsmChatInitialNativeConfig?: Maybe<JsmChatInitializeNativeConfigResponse>;
    /**
     * JSM Chat MS-Teams configuration for a JSM Project."
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChat")' query directive to the 'jsmChatMsTeamsConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmChatMsTeamsConfig?: Maybe<JsmChatMsTeamsConfig>;
    /**
     * JSM Chat Slack configuration for a JSM Project."
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChat")' query directive to the 'jsmChatSlackConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmChatSlackConfig?: Maybe<JsmChatSlackConfig>;
    /**
     * Returns the default view, represented by `JiraWorkManagementSavedView`,  for this project.
     * Will return `null` if the project does not support saved views. Only business projects are supported.
     * This may eventually be replaced by a more generic `defaultSavedView` field that will support other
     * type of projects.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Replaced by field `defaultNavigationItem` which works for both business and software projects
     */
    jwmDefaultSavedView?: Maybe<JiraWorkManagementSavedViewResult>;
    /**
     * The key of the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key: Scalars["String"]["output"];
    /**
     * Retrieve the count of Knowledge Base articles associated with the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    knowledgeBaseArticlesCount?: Maybe<KnowledgeBaseArticleCountResponse>;
    /**
     * Returns the last updated date and time of the issues in the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Returns formatted string with specified DateTime format
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastUpdatedFormatted?: Maybe<Scalars["String"]["output"]>;
    /**
     * The timestamp of this project was last viewed by the current user (reference to Unix Epoch time in ms).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The project lead
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lead?: Maybe<User>;
    /**
     * The ID of the project lead.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    leadId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Returns connection entities for Documentation-Container relationships associated with this Jira project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsDocumentationInJira")' query directive to the 'linkedDocumentationContainers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedDocumentationContainers?: Maybe<AriGraphRelationshipConnection>;
    /**
     * Returns connection entities for Operations-Component relationships associated with this Jira project, hydrated
     * using the jswProjectAssociatedComponent field which uses the ARI as an input.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsOperationsInJira")' query directive to the 'linkedOperationsComponentsByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedOperationsComponentsByProject?: Maybe<GraphStoreSimplifiedJswProjectAssociatedComponentConnection>;
    /**
     * Returns connection entities for Operations-Incident relationships associated with this Jira project, hydrated
     * using the projectAssociatedIncident field which uses the ARI as an input, and filtered by the given criteria.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsOperationsInJira")' query directive to the 'linkedOperationsIncidentsByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedOperationsIncidentsByProject?: Maybe<GraphStoreSimplifiedJswProjectAssociatedIncidentConnection>;
    /**
     * Returns connection entities for Security-Container relationships associated with this Jira project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'linkedSecurityContainers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedSecurityContainers?: Maybe<AriGraphRelationshipConnection>;
    /**
     * Returns connection entities for Security-Vulnerability relationships associated with this Jira project, hydrated
     * using the projectAssociatedVulnerability field which uses the ARI as an input, and filtered by the given criteria.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'linkedSecurityVulnerabilitiesByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkedSecurityVulnerabilitiesByProject?: Maybe<GraphJiraVulnerabilityConnection>;
    /**
     * Returns the board that was last viewed by the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    mostRecentlyViewedBoard?: Maybe<JiraBoardResult>;
    /**
     * The name of the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
    /**
     * Returns navigation specific information to aid in transitioning from a project to a landing page eg. board, queue, list, etc
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    navigationMetadata?: Maybe<JiraProjectNavigationMetadata>;
    /**
     * Alias for getting all Opsgenie teams that are available to be linked with the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    opsgenieTeamsAvailableToLinkWith?: Maybe<OpsgenieTeamConnection>;
    /**
     * fetch the list of all field type groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectFieldTypeGroups?: Maybe<JiraFieldTypeGroupConnection>;
    /**
     * The project id of the project. e.g. 10000. Temporarily needed to support interoperability with REST.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectId?: Maybe<Scalars["String"]["output"]>;
    /**
     * This is to fetch the current count of project-scoped fields of a TMP project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectScopedFieldsCount")' query directive to the 'projectScopedFieldsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectScopedFieldsCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * This is to fetch the limit of project-scoped fields allowed per TMP project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectScopedFieldsPerProjectLimit")' query directive to the 'projectScopedFieldsPerProjectLimit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectScopedFieldsPerProjectLimit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Specifies the style of the project.
     * The use of this field is discouraged.
     * This field only exists to support legacy use cases. This field may be deprecated in the future.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectStyle?: Maybe<JiraProjectStyle>;
    /**
     * Specifies the type to which project belongs to ex:- software, service_desk, business etc.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectType?: Maybe<JiraProjectType>;
    /**
     * Specifies the i18n translated text of the field 'projectType'; can be null.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectTypeName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The URL associated with the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * This is to fetch the list of (visible) issue type ids to the given project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectWithVisibleIssueTypeIds?: Maybe<JiraProjectWithIssueTypeIds>;
    /**
     * Retrieves a list of available report categories and reports for a Jira project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraReportCategories")' query directive to the 'reportCategories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    reportCategories?: Maybe<JiraReportCategoryConnection>;
    /**
     * Returns the repositories associated with this Jira project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreProjectAssociatedRepo")' query directive to the 'repositories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    repositories?: Maybe<GraphStoreSimplifiedProjectAssociatedRepoConnection>;
    /**
     * Get request types for a project, could be null for non JSM projects
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementRequestTypeQuery")' query directive to the 'requestTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    requestTypes?: Maybe<JiraServiceManagementRequestTypeConnection>;
    /**
     * Array contains selected deployment apps for the specified project. Empty array if not set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraDeploymentAppsEmptyState")' query directive to the 'selectedDeploymentAppsProperty' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    selectedDeploymentAppsProperty?: Maybe<Array<JiraDeploymentApp>>;
    /**
     * Services that are available to be linked with via createDevOpsServiceAndJiraProjectRelationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    servicesAvailableToLinkWith?: Maybe<DevOpsServiceConnection>;
    /**
     * Represents the SimilarIssues feature associated with this project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    similarIssues?: Maybe<JiraSimilarIssues>;
    /**
     * The count of software boards a project has, for non-software projects this will always be zero
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    softwareBoardCount?: Maybe<Scalars["Long"]["output"]>;
    /**
     * The Boards under the given project.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: softwareBoards` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    softwareBoards?: Maybe<BoardScopeConnection>;
    /**
     * Specifies the status of the project e.g. archived, deleted.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<JiraProjectStatus>;
    /**
     * Returns a connection containing suggestions for the approvers field of the Jira version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suggestedApproversForJiraVersion?: Maybe<JiraVersionSuggestedApproverConnection>;
    /**
     * Returns a connection containing suggestions for the driver field of the Jira version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suggestedDriversForJiraVersion?: Maybe<JiraVersionDriverConnection>;
    /**
     * The board Id if the project is of type SOFTWARE TMP, otherwise returns null.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectSoftwareTmpBoardId")' query directive to the 'tmpBoardId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    tmpBoardId?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Returns the total count of linked security containers for a specific project, identified by its project ID.
     *
     * The maximum number of linked security containers is limit to 5000.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'totalLinkedSecurityContainerCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    totalLinkedSecurityContainerCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Returns the total count of security vulnerabilities matched with filter conditions for a specific project, identified by its project ID.
     *
     * The maximum number of security vulnerabilities is limit to 5000.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevOpsSecurityInJira")' query directive to the 'totalLinkedSecurityVulnerabilityCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    totalLinkedSecurityVulnerabilityCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The UUID of the project.
     * The use of this field is discouraged. Use `id` or `projectId` instead.
     * This field only exists to support legacy use cases and it will be removed in the future.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated The `uuid` is a deprecated field.
     */
    uuid?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The versions defined in the project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    versions?: Maybe<JiraVersionConnection>;
    /**
     * The versions defined in the project. Compared to original versions field, error handling is improved by returning JiraProjectVersionsResult
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use `versions` field and use errors field inside connection object for error handling
     */
    versionsV2?: Maybe<JiraVersionConnectionResult>;
    /**
     * Virtual Agent which is configured against a JSM Project."
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    virtualAgentConfiguration?: Maybe<VirtualAgentConfigurationResult>;
    /**
     * The total number of live intents for the Virtual Agent that configured against a JSM Project."
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'virtualAgentLiveIntentsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    virtualAgentLiveIntentsCount?: Maybe<VirtualAgentLiveIntentCountResponse>;
    /**
     * The browser clickable link of this Project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** Represents a Jira project. */
export type JiraProjectActionArgs = {
    type: JiraProjectActionType;
};

/** Represents a Jira project. */
export type JiraProjectAssignableUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectAssociatedComponentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectAssociatedIssueLayoutFieldsArgs = {
    input?: InputMaybe<JiraProjectAssociatedFieldsInput>;
};

/** Represents a Jira project. */
export type JiraProjectBoardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectConditionalFormattingRulesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectDevOpsEntityRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<AriGraphRelationshipsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<AriGraphRelationshipsSort>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectDevOpsServiceRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndJiraProjectRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectHasRelationshipFromArgs = {
    type: Scalars["ID"]["input"];
};

/** Represents a Jira project. */
export type JiraProjectHasRelationshipToArgs = {
    type: Scalars["ID"]["input"];
};

/** Represents a Jira project. */
export type JiraProjectIntentTemplatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectIssueTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueTypeFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectKnowledgeBaseArticlesCountArgs = {
    cloudId: Scalars["ID"]["input"];
};

/** Represents a Jira project. */
export type JiraProjectLastUpdatedFormattedArgs = {
    format?: InputMaybe<JiraProjectDateTimeFormat>;
};

/** Represents a Jira project. */
export type JiraProjectLinkedDocumentationContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectLinkedOperationsComponentsByProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectLinkedOperationsIncidentsByProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreJswProjectAssociatedIncidentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<GraphStoreJswProjectAssociatedIncidentSortInput>;
};

/** Represents a Jira project. */
export type JiraProjectLinkedSecurityContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<AriGraphRelationshipsSort>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectLinkedSecurityVulnerabilitiesByProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectOpsgenieTeamsAvailableToLinkWithArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectProjectFieldTypeGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectReportCategoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectRepositoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<GraphStoreProjectAssociatedRepoFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<GraphStoreProjectAssociatedRepoSortInput>;
};

/** Represents a Jira project. */
export type JiraProjectRequestTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectServicesAvailableToLinkWithArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServicesFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectSuggestedApproversForJiraVersionArgs = {
    excludedAccountIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectSuggestedDriversForJiraVersionArgs = {
    searchText?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a Jira project. */
export type JiraProjectTotalLinkedSecurityVulnerabilityCountArgs = {
    filter?: InputMaybe<GraphQueryMetadataProjectAssociatedVulnerabilityInput>;
};

/** Represents a Jira project. */
export type JiraProjectVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<Array<InputMaybe<JiraVersionStatus>>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    releaseDateAfter?: InputMaybe<Scalars["Date"]["input"]>;
    releaseDateBefore?: InputMaybe<Scalars["Date"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    sortBy?: InputMaybe<JiraVersionSortInput>;
};

/** Represents a Jira project. */
export type JiraProjectVersionsV2Args = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<Array<InputMaybe<JiraVersionStatus>>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    releaseDateAfter?: InputMaybe<Scalars["Date"]["input"]>;
    releaseDateBefore?: InputMaybe<Scalars["Date"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    sortBy?: InputMaybe<JiraVersionSortInput>;
};

/** Represents whether the user has the specific project permission or not */
export type JiraProjectAction = {
    __typename?: "JiraProjectAction";
    /** Whether the user can perform the action or not */
    canPerform: Scalars["Boolean"]["output"];
    /** The action */
    type: JiraProjectActionType;
};

/** The different action types that a user can perform on a project */
export enum JiraProjectActionType {
    /** Assign issues within the project. */
    AssignIssues = "ASSIGN_ISSUES",
    /** Create issues within the project and fill out their fields upon creation. */
    CreateIssues = "CREATE_ISSUES",
    /** Delete issues within the project. */
    DeleteIssues = "DELETE_ISSUES",
    /** Edit issues within the project. */
    EditIssues = "EDIT_ISSUES",
    /** Edit project configuration such as edit access, manage people and permissions, configure issue types and their fields, and enable project features. */
    EditProjectConfig = "EDIT_PROJECT_CONFIG",
    /** Link issues within the project. */
    LinkIssues = "LINK_ISSUES",
    /** Schedule issues within the project. */
    ScheduleIssues = "SCHEDULE_ISSUES",
    /** Transition issues within the project. */
    TransitionIssues = "TRANSITION_ISSUES",
    /** View issues within the project. */
    ViewIssues = "VIEW_ISSUES",
    /** View some set of project configurations such as edit workflows, edit issue layout, or project details. If EditProjectConfig is true this should be too. */
    ViewProjectConfig = "VIEW_PROJECT_CONFIG"
}

export type JiraProjectAssociatedFieldsInput = {
    /** if not specified the result will include all Field types matched */
    includedFieldTypes?: InputMaybe<Array<JiraConfigFieldType>>;
};

/** Represents an input to available fields query */
export type JiraProjectAvailableFieldsInput = {
    /** Search fields by list of field type groups. If empty, fields will not be filtered by field type group. */
    fieldTypeGroups?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /** Search fields by field name. If null or empty, fields will not be filtered by field name. */
    filterContains?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraProjectCategory = Node & {
    __typename?: "JiraProjectCategory";
    /** Description of the Project category. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Global id of this project category. */
    id: Scalars["ID"]["output"];
    /** Display name of the Project category. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JiraProjectCategoryConnection = {
    __typename?: "JiraProjectCategoryConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraProjectCategoryEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

export type JiraProjectCategoryEdge = {
    __typename?: "JiraProjectCategoryEdge";
    /** A cursor for use in pagination */
    cursor: Scalars["String"]["output"];
    /** The item at the end of the edge */
    node?: Maybe<JiraProjectCategory>;
};

export type JiraProjectCategoryFilterInput = {
    /** Filter the project categories list with these category ids */
    categoryIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

/** An entry in the activity log table for project role actors. */
export type JiraProjectCleanupLogTableEntry = {
    __typename?: "JiraProjectCleanupLogTableEntry";
    /** Admin who executed the recommendation. Will be empty if the recommendation was not executed. */
    executedBy?: Maybe<User>;
    /** Recommendations executed together will have the same executedGroupId. Will be empty if the recommendation was not executed. */
    executedGroupId?: Maybe<Scalars["String"]["output"]>;
    /** Number of affected records in this log table entry. */
    numberOfRecords?: Maybe<Scalars["Int"]["output"]>;
    /** Action taken for this group of records. */
    status?: Maybe<JiraResourceUsageRecommendationStatus>;
    /** DateTime when the recommendation was updated. Will be empty if the recommendation was not updated. */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Connection type for JiraProjectCleanupLogTableEntry. */
export type JiraProjectCleanupLogTableEntryConnection = {
    __typename?: "JiraProjectCleanupLogTableEntryConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraProjectCleanupLogTableEntryEdge>>>;
    /** A list of nodes in the current page. Same as edges but does not have cursors. */
    nodes?: Maybe<Array<Maybe<JiraProjectCleanupLogTableEntry>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraProjectCleanupLogTableEntryConnection. */
export type JiraProjectCleanupLogTableEntryEdge = {
    __typename?: "JiraProjectCleanupLogTableEntryEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraProjectCleanupLogTableEntry>;
};

/** Project cleanup recommendation. */
export type JiraProjectCleanupRecommendation = {
    __typename?: "JiraProjectCleanupRecommendation";
    /** Admin who executed the recommendation. Will be empty if the recommendation was not executed. */
    executedById?: Maybe<User>;
    /** Recommendations executed together will have the same executedGroupId. Will be empty if the recommendation was not executed. */
    executedGroupId?: Maybe<Scalars["String"]["output"]>;
    /** Global unique identifier. ATI: resource-usage-recommendation */
    id: Scalars["ID"]["output"];
    /** Project associated with the recommendation. */
    project?: Maybe<JiraProject>;
    /** Recommendation action for the stale project. */
    projectCleanupAction?: Maybe<JiraProjectCleanupRecommendationAction>;
    /** Id of the recommendation. Only unique per Jira instance. */
    recommendationId?: Maybe<Scalars["Long"]["output"]>;
    /** A datetime value sinde the stale project's issues were last updated. */
    staleSince?: Maybe<Scalars["DateTime"]["output"]>;
    /** Recommendation status. */
    status?: Maybe<JiraResourceUsageRecommendationStatus>;
    /** A total number of issues in the project. */
    totalIssueCount?: Maybe<Scalars["Int"]["output"]>;
    /** DateTime when the recommendation was updated. Will be empty if the recommendation was not updated. */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Recommendation action for a project cleanup. */
export enum JiraProjectCleanupRecommendationAction {
    /** This project can be archived. */
    Archive = "ARCHIVE",
    /** This project can be trashed. */
    Trash = "TRASH"
}

/** Connection type for JiraProjectCleanupRecommendation. */
export type JiraProjectCleanupRecommendationConnection = {
    __typename?: "JiraProjectCleanupRecommendationConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraProjectCleanupRecommendationEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraProjectCleanupRecommendation connection. */
export type JiraProjectCleanupRecommendationEdge = {
    __typename?: "JiraProjectCleanupRecommendationEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraProjectCleanupRecommendation>;
};

/** A period of time since the project was found stale. */
export enum JiraProjectCleanupRecommendationStaleSince {
    OneYear = "ONE_YEAR",
    SixMonths = "SIX_MONTHS",
    TwoYears = "TWO_YEARS"
}

/** The status of the project cleanup task. */
export type JiraProjectCleanupTaskStatus = {
    __typename?: "JiraProjectCleanupTaskStatus";
    progress?: Maybe<Scalars["Int"]["output"]>;
    status?: Maybe<JiraProjectCleanupTaskStatusType>;
};

export enum JiraProjectCleanupTaskStatusType {
    Complete = "COMPLETE",
    Error = "ERROR",
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    TerminalError = "TERMINAL_ERROR"
}

/** The connection type for JiraProject. */
export type JiraProjectConnection = HasPageInfo &
    HasTotal & {
        __typename?: "JiraProjectConnection";
        /** A list of edges in the current page. */
        edges?: Maybe<Array<Maybe<JiraProjectEdge>>>;
        /** Information about the current page. Used to aid in pagination. */
        pageInfo: PageInfo;
        /** The total count of items in the connection. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** Response for the create custom background mutation. */
export type JiraProjectCreateCustomBackgroundMutationPayload = Payload & {
    __typename?: "JiraProjectCreateCustomBackgroundMutationPayload";
    /**
     * List of errors while performing the create custom background mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated project if the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    project?: Maybe<JiraProject>;
    /**
     * Denotes whether the create custom background mutation was successful
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * String formats for DateTime in JiraProject, the format is in the value of the jira.date.time.picker.java.format property
 * Please refer to the "Change date and time formats" section of the "Configure the look and feel of Jira applications" page
 * https://support.atlassian.com/jira-cloud-administration/docs/configure-the-look-and-feel-of-jira-applications/
 */
export enum JiraProjectDateTimeFormat {
    /** dd/MMM/yy h:mm a    E.g. 23/May/07 3:55 AM */
    CompleteDatetimeFormat = "COMPLETE_DATETIME_FORMAT",
    /** EEEE h:mm a     E.g. Wednesday 3:55 AM */
    DayFormat = "DAY_FORMAT",
    /** dd/MMM/yy   E.g. 23/May/07 */
    DayMonthYearFormat = "DAY_MONTH_YEAR_FORMAT",
    /** E.g. 2 days ago */
    Relative = "RELATIVE",
    /** h:mm a  E.g. 3:55 AM */
    TimeFormat = "TIME_FORMAT"
}

/** The input for deleting a custom background */
export type JiraProjectDeleteCustomBackgroundInput = {
    /** The customBackgroundId of the custom background to be deleted */
    customBackgroundId: Scalars["ID"]["input"];
    /** The entityId (ARI) of the entity for which the custom background will be deleted */
    entityId: Scalars["ID"]["input"];
};

/** Response for the delete custom background mutation. */
export type JiraProjectDeleteCustomBackgroundMutationPayload = Payload & {
    __typename?: "JiraProjectDeleteCustomBackgroundMutationPayload";
    /**
     * List of errors while performing the delete custom background mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated project if the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    project?: Maybe<JiraProject>;
    /**
     * Denotes whether the delete custom background mutation was successful
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** An edge in a JiraProject connection. */
export type JiraProjectEdge = {
    __typename?: "JiraProjectEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraProject>;
};

/**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */
export type JiraProjectField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraProjectField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an Issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The ID of the project field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The project selected on the Issue or default project configured for the field. */
        project?: Maybe<JiraProject>;
        /**
         * List of project options available for this field to be selected.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        projects?: Maybe<JiraProjectConnection>;
        /**
         * Search url to fetch all available projects options on the field or an Issue.
         * To be deprecated once project connection is supported for custom project fields.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */
export type JiraProjectFieldProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    recent?: InputMaybe<Scalars["Boolean"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Represents attributes common to fields that either are available to be associated,
 * or are already associated to a project.
 */
export type JiraProjectFieldAssociationInterface = {
    /** This holds the general attributes of a field */
    field?: Maybe<JiraField>;
    /** This holds operations that can be performed on a field */
    fieldOperation?: Maybe<JiraFieldOperation>;
    /** Unique identifier of the field association (Project Id + FieldId). */
    id: Scalars["ID"]["output"];
};

/** Input type for a project field */
export type JiraProjectFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Represents a project field data */
    project: JiraProjectInput;
};

export type JiraProjectFieldOperationInput = {
    /** Accept ARI(s): project */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraProjectFieldPayload = Payload & {
    __typename?: "JiraProjectFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraProjectField>;
    success: Scalars["Boolean"]["output"];
};

/** Represents a field type used by Project Fields Page. */
export type JiraProjectFieldsPageFieldType = {
    __typename?: "JiraProjectFieldsPageFieldType";
    /** Field type key */
    key?: Maybe<Scalars["String"]["output"]>;
    /** The translated text representation of the field type. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JiraProjectFilterInput = {
    /** Filter the results using a literal string. Projects witha matching key or name are returned (case insensitive). */
    keyword?: InputMaybe<Scalars["String"]["input"]>;
    /** Filter the results based on whether the user has configured notification preferences for it. */
    notificationConfigurationState?: InputMaybe<JiraProjectNotificationConfigurationState>;
    /** the project category that can be used to filter list of projects */
    projectCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
    /** the sort criteria that is used while filtering the projects */
    sortBy?: InputMaybe<JiraProjectSortInput>;
    /** the project types that can be used to filter list of projects */
    types?: InputMaybe<Array<JiraProjectType>>;
};

/** Input type for a project */
export type JiraProjectInput = {
    /** An identifier for the field */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** A unique identifier for the project */
    projectId: Scalars["ID"]["input"];
};

export type JiraProjectKeysInput = {
    /** Cloud ID of the Jira instance containing the project keys. Required for routing. */
    cloudId: Scalars["ID"]["input"];
    /** Project keys to fetch data for. */
    keys?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** The options for the project list sidebar state. */
export enum JiraProjectListRightPanelState {
    /** The project list sidebar is closed. */
    Closed = "CLOSED",
    /** The project list sidebar is open. */
    Open = "OPEN"
}

export type JiraProjectListRightPanelStateMutationPayload = Payload & {
    __typename?: "JiraProjectListRightPanelStateMutationPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** The newly set project list sidebar state. */
    projectListRightPanelState?: Maybe<JiraProjectListRightPanelState>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** A connection that returns a paginated collection of project template */
export type JiraProjectListViewTemplateConnection = {
    __typename?: "JiraProjectListViewTemplateConnection";
    /** A list of edges which contain project templates and a cursor. */
    edges?: Maybe<Array<Maybe<JiraProjectListViewTemplateEdge>>>;
    /** A list of project templates */
    nodes?: Maybe<Array<Maybe<JiraProjectListViewTemplateItem>>>;
    /** Pagination information such as the start and end cursor of this page, and whether there is a next and previous page. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge that contains a project template and a cursor. */
export type JiraProjectListViewTemplateEdge = {
    __typename?: "JiraProjectListViewTemplateEdge";
    /** The cursor of the project template list. */
    cursor: Scalars["String"]["output"];
    /** The project template. */
    node?: Maybe<JiraProjectListViewTemplateItem>;
};

/** Simplified version of a project template. */
export type JiraProjectListViewTemplateItem = {
    __typename?: "JiraProjectListViewTemplateItem";
    /** Whether a user can create a template. */
    canCreate?: Maybe<Scalars["Boolean"]["output"]>;
    /** Description of the template. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Dark icon url of the template. */
    iconDarkUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Icon url of the template. */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Is the template the last one created on the instance. */
    isLastUsed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is the template only available on premium instances. */
    isPremiumOnly?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the product is licensed. */
    isProductLicensed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Key of the template (TMP key if present or CMP key if not). */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Url to a dark preview image of the template. */
    previewDarkUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Url to a preview image of the template. */
    previewUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Product key of the template. */
    productKey?: Maybe<Scalars["String"]["output"]>;
    /** Session ID for recommendation modal. */
    recommendationSessionId?: Maybe<Scalars["String"]["output"]>;
    /** Concise description of the template. */
    shortDescription?: Maybe<Scalars["String"]["output"]>;
    /** Type of the template. Also known as shortKey */
    templateType?: Maybe<Scalars["String"]["output"]>;
    /** Title of the template. */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type JiraProjectNavigationMetadata =
    | JiraServiceManagementProjectNavigationMetadata
    | JiraSoftwareProjectNavigationMetadata
    | JiraWorkManagementProjectNavigationMetadata;

/** Whether or not the user has configured notification preferences for the project. */
export enum JiraProjectNotificationConfigurationState {
    /** The user has configured notification preferences for this project */
    Configured = "CONFIGURED",
    /** The user has not configured notification preferences for this project. Computed defaults will be returned. */
    Default = "DEFAULT"
}

/** An edge in a JiraNotificationProjectPreferences connection. */
export type JiraProjectNotificationPreferenceEdge = {
    __typename?: "JiraProjectNotificationPreferenceEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraNotificationProjectPreferences>;
};

/** Options to filter based on project properties */
export type JiraProjectOptions = {
    /** The type of projects we need to filter */
    projectType?: InputMaybe<JiraProjectType>;
};

/** The project permission in Jira and it is scoped to projects. */
export type JiraProjectPermission = {
    __typename?: "JiraProjectPermission";
    /** The description of the permission. */
    description: Scalars["String"]["output"];
    /** The unique key of the permission. */
    key: Scalars["String"]["output"];
    /** The display name of the permission. */
    name: Scalars["String"]["output"];
    /** The category of the permission. */
    type: JiraProjectPermissionCategory;
};

/**
 * The category of the project permission.
 * The category information is typically seen in the permission scheme Admin UI.
 * It is used to group the project permissions in general and available for connect app developers when registering new project permissions.
 */
export type JiraProjectPermissionCategory = {
    __typename?: "JiraProjectPermissionCategory";
    /** The unique key of the permission category. */
    key: JiraProjectPermissionCategoryEnum;
    /** The display name of the permission category. */
    name: Scalars["String"]["output"];
};

/**
 * The category of the project permission.
 * It represents the logical grouping of the project permissions.
 */
export enum JiraProjectPermissionCategoryEnum {
    /** Represents one or more permissions to manage issue attacments such as create and delete. */
    Attachments = "ATTACHMENTS",
    /** Represents one or more permissions to manage issue comments such as add, delete and edit. */
    Comments = "COMMENTS",
    /** Represents one or more permissions applicable at issue level to manage operations such as create, delete, edit, and transition. */
    Issues = "ISSUES",
    /** Represents one or more permissions representing default category if not any other existing category. */
    Other = "OTHER",
    /** Represents one or more permissions applicable at project level such as project administration, view project information, and manage sprints. */
    Projects = "PROJECTS",
    /** Represents one or more permissions to manage worklogs, time tracking for billing purpose in some cases. */
    TimeTracking = "TIME_TRACKING",
    /** Represents one or more permissions to manage watchers and voters of an issue. */
    VotersAndWatchers = "VOTERS_AND_WATCHERS"
}

/** The different permissions that the user can have for a project */
export enum JiraProjectPermissionType {
    /** Ability to comment on issues. */
    AddComments = "ADD_COMMENTS",
    /** Ability to administer a project in Jira. */
    AdministerProjects = "ADMINISTER_PROJECTS",
    /** Ability to archive issues within a project. */
    ArchiveIssues = "ARCHIVE_ISSUES",
    /** Users with this permission may be assigned to issues. */
    AssignableUser = "ASSIGNABLE_USER",
    /** Ability to assign issues to other people. */
    AssignIssues = "ASSIGN_ISSUES",
    /** Ability to browse projects and the issues within them. */
    BrowseProjects = "BROWSE_PROJECTS",
    /** Ability to close issues. Often useful where your developers resolve issues, and a QA department closes them. */
    CloseIssues = "CLOSE_ISSUES",
    /** Users with this permission may create attachments. */
    CreateAttachments = "CREATE_ATTACHMENTS",
    /** Ability to create issues. */
    CreateIssues = "CREATE_ISSUES",
    /** Users with this permission may delete all attachments. */
    DeleteAllAttachments = "DELETE_ALL_ATTACHMENTS",
    /** Ability to delete all comments made on issues. */
    DeleteAllComments = "DELETE_ALL_COMMENTS",
    /** Ability to delete all worklogs made on issues. */
    DeleteAllWorklogs = "DELETE_ALL_WORKLOGS",
    /** Ability to delete issues. */
    DeleteIssues = "DELETE_ISSUES",
    /** Users with this permission may delete own attachments. */
    DeleteOwnAttachments = "DELETE_OWN_ATTACHMENTS",
    /** Ability to delete own comments made on issues. */
    DeleteOwnComments = "DELETE_OWN_COMMENTS",
    /** Ability to delete own worklogs made on issues. */
    DeleteOwnWorklogs = "DELETE_OWN_WORKLOGS",
    /** Ability to edit all comments made on issues. */
    EditAllComments = "EDIT_ALL_COMMENTS",
    /** Ability to edit all worklogs made on issues. */
    EditAllWorklogs = "EDIT_ALL_WORKLOGS",
    /** Ability to edit issues. */
    EditIssues = "EDIT_ISSUES",
    /** Ability to manage issue layout, and add, remove, and search for fields in Jira. */
    EditIssueLayout = "EDIT_ISSUE_LAYOUT",
    /** Ability to edit own comments made on issues. */
    EditOwnComments = "EDIT_OWN_COMMENTS",
    /** Ability to edit own worklogs made on issues. */
    EditOwnWorklogs = "EDIT_OWN_WORKLOGS",
    /** Ability to edit a workflow. */
    EditWorkflow = "EDIT_WORKFLOW",
    /** Ability to link issues together and create linked issues. Only useful if issue linking is turned on. */
    LinkIssues = "LINK_ISSUES",
    /** Ability to manage the watchers of an issue. */
    ManageWatchers = "MANAGE_WATCHERS",
    /** Ability to modify the reporter when creating or editing an issue. */
    ModifyReporter = "MODIFY_REPORTER",
    /** Ability to move issues between projects or between workflows of the same project (if applicable). Note the user can only move issues to a project they have the create permission for. */
    MoveIssues = "MOVE_ISSUES",
    /** Ability to resolve and reopen issues. This includes the ability to set a fix version. */
    ResolveIssues = "RESOLVE_ISSUES",
    /** Ability to view or edit an issue's due date. */
    ScheduleIssues = "SCHEDULE_ISSUES",
    /** Ability to set the level of security on an issue so that only people in that security level can see the issue. */
    SetIssueSecurity = "SET_ISSUE_SECURITY",
    /** Ability to transition issues. */
    TransitionIssues = "TRANSITION_ISSUES",
    /** Ability to unarchive issues within a project. */
    UnarchiveIssues = "UNARCHIVE_ISSUES",
    /** Allows users in a software project to view development-related information on the issue, such as commits, reviews and build information. */
    ViewDevTools = "VIEW_DEV_TOOLS",
    /** Users with this permission may view a read-only version of a workflow. */
    ViewReadonlyWorkflow = "VIEW_READONLY_WORKFLOW",
    /** Ability to view the voters and watchers of an issue. */
    ViewVotersAndWatchers = "VIEW_VOTERS_AND_WATCHERS",
    /** Ability to log work done against an issue. Only useful if Time Tracking is turned on. */
    WorkOnIssues = "WORK_ON_ISSUES"
}

/** An entry in the activity log table for project role actors. */
export type JiraProjectRoleActorLogTableEntry = {
    __typename?: "JiraProjectRoleActorLogTableEntry";
    /** Admin who executed the recommendation. Will be empty if the recommendation was not executed. */
    executedBy?: Maybe<User>;
    /** Recommendations executed together will have the same executedGroupId. Will be empty if the recommendation was not executed. */
    executedGroupId?: Maybe<Scalars["String"]["output"]>;
    /** Number of affected records in this log table entry. */
    numberOfRecords?: Maybe<Scalars["Int"]["output"]>;
    /** DateTime when the recommendation was updated. Will be empty if the recommendation was not updated. */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Connection type for JiraProjectRoleActorLogTableEntry. */
export type JiraProjectRoleActorLogTableEntryConnection = {
    __typename?: "JiraProjectRoleActorLogTableEntryConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraProjectRoleActorLogTableEntryEdge>>>;
    /** A list of nodes in the current page. Same as edges but does not have cursors. */
    nodes?: Maybe<Array<Maybe<JiraProjectRoleActorLogTableEntry>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraProjectRoleActorLogTableEntryConnection. */
export type JiraProjectRoleActorLogTableEntryEdge = {
    __typename?: "JiraProjectRoleActorLogTableEntryEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraProjectRoleActorLogTableEntry>;
};

/** Project role actor recommendation. */
export type JiraProjectRoleActorRecommendation = {
    __typename?: "JiraProjectRoleActorRecommendation";
    /** Admin who executed the recommendation. Will be empty if the recommendation was not executed. */
    executedBy?: Maybe<User>;
    /** Recommendations executed together will have the same executedGroupId. Will be empty if the recommendation was not executed. */
    executedGroupId?: Maybe<Scalars["String"]["output"]>;
    /** Global unique identifier. ATI: resource-usage-recommendation */
    id: Scalars["ID"]["output"];
    /** Project associated with the project role actor entry. Will be empty if no project exists. */
    project?: Maybe<JiraProject>;
    /** Recommendation action for the project role actor. */
    projectRoleActorAction?: Maybe<JiraProjectRoleActorRecommendationAction>;
    /** List of JiraRoles associated with the user. Role name and roleId only. */
    projectRoles?: Maybe<Array<Maybe<JiraRole>>>;
    /** Id of the recommendation. Only unique per Jira instance. */
    recommendationId?: Maybe<Scalars["Long"]["output"]>;
    /** Recommendation status. */
    status?: Maybe<JiraResourceUsageRecommendationStatus>;
    /** DateTime when the recommendation was updated. Will be empty if the recommendation was not updated. */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
    /** User which is associated with the project role actor entry. If the user is deleted, the displayName, avatarUrl and email will be undefined. */
    user?: Maybe<JiraUserMetadata>;
};

/** Recommendation action for a project role actor. */
export enum JiraProjectRoleActorRecommendationAction {
    /** This project role actor can be trashed. */
    Trash = "TRASH"
}

/** Connection type for JiraProjectRoleActorRecommendation. */
export type JiraProjectRoleActorRecommendationConnection = {
    __typename?: "JiraProjectRoleActorRecommendationConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraProjectRoleActorRecommendationEdge>>>;
    /** A list of nodes in the current page. Same as edges but does not have cursors. */
    nodes?: Maybe<Array<Maybe<JiraProjectRoleActorRecommendation>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
    /** Total count of recommendations for deleted users */
    totalDeletedUsersCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraProjectRoleActorRecommendation connection. */
export type JiraProjectRoleActorRecommendationEdge = {
    __typename?: "JiraProjectRoleActorRecommendationEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraProjectRoleActorRecommendation>;
};

/** User status for a project role actor. */
export enum JiraProjectRoleActorUserStatus {
    /** The user associated with this project role actor is deleted. */
    Deleted = "DELETED",
    /** The user associated with this project role actor is not active. */
    Inactive = "INACTIVE"
}

/** The project role grant type value having the project role information. */
export type JiraProjectRoleGrantTypeValue = Node & {
    __typename?: "JiraProjectRoleGrantTypeValue";
    /**
     * The ARI to represent the project role grant type value.
     * For example: ari:cloud:jira:a2520569-493f-45bc-807b-54b02bc724d1:role/project-role/activation/bd0c43a9-a23a-4302-8ffa-ca04bde7c747/projectrole/b434089d-7f6d-476b-884b-7811661f91d2
     */
    id: Scalars["ID"]["output"];
    /** The project role information such as name, description. */
    role: JiraRole;
};

/** The Jira Project Shortcut that can be either a repo or basic shortcut link */
export type JiraProjectShortcut = Node & {
    __typename?: "JiraProjectShortcut";
    /** ARI of the shortcut. */
    id: Scalars["ID"]["output"];
    /** The name given to identify the shortcut. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The type of the shortcut. */
    type?: Maybe<JiraProjectShortcutType>;
    /** The url link of the shortcut. */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type JiraProjectShortcutPayload = Payload & {
    __typename?: "JiraProjectShortcutPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** The shortcut which was mutated */
    shortcut?: Maybe<JiraProjectShortcut>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** The supported different shortcut types */
export enum JiraProjectShortcutType {
    /** A shortcut which links to a repository */
    Repository = "REPOSITORY",
    /** The basic shortcut link */
    ShortcutLink = "SHORTCUT_LINK",
    /** When an unexpected shortcut type is encountered which is not yet supported */
    Unknown = "UNKNOWN"
}

export enum JiraProjectSortField {
    /** sorts by category */
    Category = "CATEGORY",
    /** sorts by favourite value of the project */
    Favourite = "FAVOURITE",
    /** sorts by project key */
    Key = "KEY",
    /** sorts by the time of the last updated issue in the project */
    LastIssueUpdatedTime = "LAST_ISSUE_UPDATED_TIME",
    /** sorts by lead */
    Lead = "LEAD",
    /** sorts by project name */
    Name = "NAME"
}

export type JiraProjectSortInput = {
    order?: InputMaybe<SortDirection>;
    sortBy?: InputMaybe<JiraProjectSortField>;
};

/** Jira Project statuses. */
export enum JiraProjectStatus {
    /** An active project. */
    Active = "ACTIVE",
    /** An archived project. */
    Archived = "ARCHIVED",
    /** A deleted project. */
    Deleted = "DELETED"
}

/** Jira Project Styles. */
export enum JiraProjectStyle {
    /** A company-managed project. */
    CompanyManagedProject = "COMPANY_MANAGED_PROJECT",
    /** A team-managed project. */
    TeamManagedProject = "TEAM_MANAGED_PROJECT"
}

/** Jira Project types. */
export enum JiraProjectType {
    /** A business project. */
    Business = "BUSINESS",
    /** A customer service project. */
    CustomerService = "CUSTOMER_SERVICE",
    /** A product discovery project. */
    ProductDiscovery = "PRODUCT_DISCOVERY",
    /** A service desk project. */
    ServiceDesk = "SERVICE_DESK",
    /** A software project. */
    Software = "SOFTWARE"
}

/**
 * This represents Jira Project Type, for instance, software, business. Details can be
 * found here: https://confluence.atlassian.com/adminjiraserver/jira-applications-and-project-types-overview-938846805.html
 */
export type JiraProjectTypeDetails = Node & {
    __typename?: "JiraProjectTypeDetails";
    /** color for the given project type */
    color: Scalars["String"]["output"];
    /** I18n Description for the given project type */
    description: Scalars["String"]["output"];
    /** Display name for the given project type */
    formattedKey: Scalars["String"]["output"];
    /** icon for the given project type */
    icon: Scalars["String"]["output"];
    /** ARI of this project type. */
    id: Scalars["ID"]["output"];
    /** Jira project type key (should be same as `type`, but keeping it as backup) */
    key: Scalars["String"]["output"];
    /** Jira project type enum */
    type: JiraProjectType;
    /** weight of the type used to sort the list */
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraProjectTypeDetailsConnection = {
    __typename?: "JiraProjectTypeDetailsConnection";
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<JiraProjectTypeDetailsEdge>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type JiraProjectTypeDetailsEdge = {
    __typename?: "JiraProjectTypeDetailsEdge";
    /** A cursor for use in pagination */
    cursor: Scalars["String"]["output"];
    /** The item at the end of the edge */
    node?: Maybe<JiraProjectTypeDetails>;
};

/** Input for updating a project's avatar. */
export type JiraProjectUpdateAvatarInput = {
    /** The new project avatarId. */
    avatarId: Scalars["ID"]["input"];
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** The id or key of the project to update the name for. */
    projectIdOrKey: Scalars["String"]["input"];
};

/** Response for the update project avatar mutation. */
export type JiraProjectUpdateAvatarMutationPayload = Payload & {
    __typename?: "JiraProjectUpdateAvatarMutationPayload";
    /** List of errors while performing the update project name mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated project if the mutation was successful. */
    project?: Maybe<JiraProject>;
    /** Denotes whether the update project name mutation was successful */
    success: Scalars["Boolean"]["output"];
};

/** Response for the update project background mutation. */
export type JiraProjectUpdateBackgroundMutationPayload = Payload & {
    __typename?: "JiraProjectUpdateBackgroundMutationPayload";
    /**
     * List of errors while performing the update project background mutation.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated project if the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    project?: Maybe<JiraProject>;
    /**
     * Denotes whether the update project background mutation was successful
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input for updating a project's name. */
export type JiraProjectUpdateNameInput = {
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** The new project name. */
    name: Scalars["String"]["input"];
    /** The id or key of the project to update the name for. */
    projectIdOrKey: Scalars["String"]["input"];
};

/** Response for the update project name mutation. */
export type JiraProjectUpdateNameMutationPayload = Payload & {
    __typename?: "JiraProjectUpdateNameMutationPayload";
    /** List of errors while performing the update project name mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated project if the mutation was successful. */
    project?: Maybe<JiraProject>;
    /** Denotes whether the update project name mutation was successful */
    success: Scalars["Boolean"]["output"];
};

/** Represents a placeholder (container) for project + issue type ids */
export type JiraProjectWithIssueTypeIds = {
    __typename?: "JiraProjectWithIssueTypeIds";
    /**
     * This is to fetch the list of fields available to be associated to a given project using AI search
     * Added for experiment https://hello.atlassian.net/wiki/spaces/AG/pages/4448817661/Experiment+Design+-+TMP+Fields+-+AI+Recommendations
     * and may be removed in the future.
     * Initial design does not assume support for pagination (showing up to 10 fields) but this may change in the future.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraTMPFieldsAISearch")' query directive to the 'aiSuggestedAvailableFields' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    aiSuggestedAvailableFields?: Maybe<JiraAvailableFieldsConnection>;
    /**
     * Fetch the list of all field types that can be created in a project
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectFieldsPage")' query directive to the 'allowedCustomFieldTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    allowedCustomFieldTypes?: Maybe<JiraFieldTypeConnection>;
    /** This is to fetch the list of fields available to be associated to a given project */
    availableFields?: Maybe<JiraAvailableFieldsConnection>;
    /** This is to fetch the list of associated fields to the given project */
    fieldAssociationWithIssueTypes?: Maybe<JiraFieldAssociationWithIssueTypesConnection>;
};

/** Represents a placeholder (container) for project + issue type ids */
export type JiraProjectWithIssueTypeIdsAiSuggestedAvailableFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraProjectAvailableFieldsInput>;
};

/** Represents a placeholder (container) for project + issue type ids */
export type JiraProjectWithIssueTypeIdsAllowedCustomFieldTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a placeholder (container) for project + issue type ids */
export type JiraProjectWithIssueTypeIdsAvailableFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraProjectAvailableFieldsInput>;
};

/** Represents a placeholder (container) for project + issue type ids */
export type JiraProjectWithIssueTypeIdsFieldAssociationWithIssueTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input?: InputMaybe<JiraFieldAssociationWithIssueTypesInput>;
};

/** Whether or not the user wants linked, unlinked or all the projects. */
export enum JiraProjectsHelpCenterMappingStatus {
    All = "ALL",
    Linked = "LINKED",
    Unlinked = "UNLINKED"
}

export type JiraProjectsMappedToHelpCenterFilterInput = {
    /** help center ARI that can be used to filter the projects mapped to Help Center */
    helpCenterARI?: InputMaybe<Scalars["ID"]["input"]>;
    /** the help center id that can be used to filter the projects mapped to Help Center */
    helpCenterId: Scalars["ID"]["input"];
    /** Filter the results based on whether the user wants linked, unlinked or all the projects. */
    helpCenterMappingStatus?: InputMaybe<JiraProjectsHelpCenterMappingStatus>;
};

export type JiraProjectsSidebarMenu = {
    __typename?: "JiraProjectsSidebarMenu";
    /**
     * The current project that the user is viewing based on the currentURL input.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    current?: Maybe<JiraProject>;
    /**
     * The content to display in the sidebar menu.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayMode?: Maybe<JiraSidebarMenuDisplayMode>;
    /**
     * The upper limit of favourite projects to display.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favouriteLimit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Fetches a list of favourited projects for the current user. If the connection parameters is set, the server will ignore the favouriteLimit and return the projects as directed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favourites?: Maybe<JiraProjectConnection>;
    /**
     * The entity ARI of the projects sidebar menu.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The upper limit of recent projects to display.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recentLimit?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Fetches a list of recent projects for the current user. If the connection parameters is set, the server will ignore the recentLimit and return the projects as directed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recents?: Maybe<JiraProjectConnection>;
};

export type JiraProjectsSidebarMenuFavouritesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraProjectsSidebarMenuRecentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input to publish the customized config of a board view for all users. */
export type JiraPublishBoardViewConfigInput = {
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view whose config is being published for all users. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the publish board view config mutation. */
export type JiraPublishBoardViewConfigPayload = Payload & {
    __typename?: "JiraPublishBoardViewConfigPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while publishing the board view config.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type JiraPublishJourneyConfigurationInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

/** Basic person information who reviews a pull-request. */
export type JiraPullRequestReviewer = {
    __typename?: "JiraPullRequestReviewer";
    /** The reviewer's avatar. */
    avatar?: Maybe<JiraAvatar>;
    /** Represent the approval status from reviewer for the pull request. */
    hasApproved?: Maybe<Scalars["Boolean"]["output"]>;
    /** Reviewer name. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Possible states for Pull Requests */
export enum JiraPullRequestState {
    /** Pull Request is Declined */
    Declined = "DECLINED",
    /** Pull Request is Draft */
    Draft = "DRAFT",
    /** Pull Request is Merged */
    Merged = "MERGED",
    /** Pull Request is Open */
    Open = "OPEN"
}

export type JiraQuery = {
    __typename?: "JiraQuery";
    /**
     * Return the details for the active background of a entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    activeBackgroundDetails?: Maybe<JiraActiveBackgroundDetailsResult>;
    /**
     * Returns navigation information for the currently logged in user regarding Advanced Roadmaps for Jira.
     * Will return null if the navigation plans dropdown should not be visible to the currently logged in user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAdvancedRoadmapsNavigation")' query directive to the 'advancedRoadmapsNavigation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    advancedRoadmapsNavigation?: Maybe<JiraAdvancedRoadmapsNavigation>;
    /**
     * Get all the available grant type keys such as project role, application access, user, group.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    allGrantTypeKeys?: Maybe<Array<JiraGrantTypeKey>>;
    /**
     * Get all jira journey configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'allJiraJourneyConfigurations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    allJiraJourneyConfigurations?: Maybe<JiraJourneyConfigurationConnection>;
    /**
     * Returns a paginated connection of project categories
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    allJiraProjectCategories?: Maybe<JiraProjectCategoryConnection>;
    /**
     * Query to fetch all Jira Project Types, whether or not the instance has a valid license for each type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectTypes")' query directive to the 'allJiraProjectTypes' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    allJiraProjectTypes?: Maybe<JiraProjectTypeDetailsConnection>;
    /**
     * Returns a paginated connection of projects that meet the provided filter criteria
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    allJiraProjects?: Maybe<JiraProjectConnection>;
    /**
     * Query for all JiraUserBroadcastMessage for current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraBroadcastMessage")' query directive to the 'allJiraUserBroadcastMessages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    allJiraUserBroadcastMessages?: Maybe<JiraUserBroadcastMessageConnection>;
    /**
     * A field to get a paginated list of project-specific notification preferences.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Will be removed while API is in experimental phase for next iteration of project preferences
     */
    allNotificationProjectPreferences?: Maybe<JiraNotificationProjectPreferenceConnection>;
    /**
     * Returns the announcement banner data for the currently logged in user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAnnouncementBanner")' query directive to the 'announcementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    announcementBanner?: Maybe<JiraAnnouncementBanner>;
    /**
     * Retrieves application properties for the given instance.
     *
     * Returns an array containing application properties for each of the provided keys. If a matching application property
     * cannot be found, then no entry is added to the array for that key.
     *
     * A maximum of 50 keys can be provided. If the limit is exceeded then then an error may be returned.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraApplicationProperties` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    applicationPropertiesByKey?: Maybe<Array<JiraApplicationProperty>>;
    /**
     * Determines the frontend's behaviour for Atlassian Intelligence given the customer's current state.
     *
     * For example, if the customer has Atlassian Intelligence available but the feature is not enabled for the product,
     * the frontend should show a modal containing a deep-link to org-admins to enable the feature.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNaturalLanguageToJQL")' query directive to the 'atlassianIntelligenceAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    atlassianIntelligenceAction?: Maybe<JiraAtlassianIntelligenceAction>;
    /**
     * Retrieves an attachment by its ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attachmentByAri?: Maybe<JiraPlatformAttachment>;
    /**
     * Retrieves an attachment by its ARI. This is a variant of `attachmentByAri` which returns the errors occurred during
     * the data fetching in the payload.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attachmentByAriV2?: Maybe<JiraAttachmentByAriResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attachmentSearch?: Maybe<JiraAttachmentConnection>;
    /**
     * Returns the allowed storage in bytes. Null if storage is unlimited
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attachmentStorageAllowed?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Returns if the storage allowed is unlimited for the given Jira product
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attachmentStorageIsUnlimited?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns the storage in bytes.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    attachmentStorageUsed?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Return Media API upload token for a user's background Media collection
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    backgroundUploadToken?: Maybe<JiraBackgroundUploadTokenResult>;
    /**
     * Returns a user property for the currently logged in user when the property value has a boolean value.
     * Will return null if the propertyKey does not exist or does not store a boolean value.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use of this generic entity property is not recommended, if your team has capacity it is preferred to add your own user property to the schema
     */
    booleanUserProperty?: Maybe<JiraEntityPropertyBoolean>;
    /**
     * Retrieves progress of a bulk operation on Jira Issues by task ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueBulkOperationProgress")' query directive to the 'bulkOperationProgress' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    bulkOperationProgress?: Maybe<JiraIssueBulkOperationProgress>;
    /**
     * Retrieves additional information on Jira Issue bulk operations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueBulkOperationsMetadata")' query directive to the 'bulkOperationsMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    bulkOperationsMetadata?: Maybe<JiraIssueBulkOperationsMetadata>;
    /**
     * Checks whether the requesting user can perform the specific global jira action
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAction")' query directive to the 'canPerform' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    canPerform?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The Child Issues limit per issue.
     * If the number of child issues exceeds `childIssuesLimit` for an issue,
     * the user will be directed to a search API to retrieve their child issues.
     * Clients can query a maximum of `childIssuesLimit` via JiraIssue.childIssues.
     * We expose this limit via the API so that clients don't have to hardcode it on their end.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    childIssuesLimit?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Return navigation details for a given container.
     * Supports business and software projects as well as software and user Boards.
     *
     * If a software project is specified, the Board scope will be automatically determined based on most recently used,
     * or first in project. For projects without any Boards, uses the project scope. Prefer querying by Board directly.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    containerNavigation?: Maybe<JiraContainerNavigationResult>;
    /**
     * Return custom backgrounds associated with the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    customBackgrounds?: Maybe<JiraCustomBackgroundConnection>;
    /**
     * Get a page of images from the "Unsplash Editorial" using their collection API
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    defaultUnsplashImages?: Maybe<JiraDefaultUnsplashImagesPageResult>;
    /**
     * Returns the precondition state of the deployments JSW feature for a particular project and user.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use deploymentsFeaturePreconditionByProjectKey instead
     */
    deploymentsFeaturePrecondition?: Maybe<JiraDeploymentsFeaturePrecondition>;
    /**
     * Returns the precondition state of the deployments JSW feature for a particular project and user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deploymentsFeaturePreconditionByProjectKey?: Maybe<JiraDeploymentsFeaturePrecondition>;
    /**
     * Container for all DevOps related queries in Jira
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    devOps?: Maybe<JiraDevOpsQuery>;
    /**
     * Retrieves the list of devOps providers filtered by the types of capabilities they should support
     * Note: Bitbucket pipelines will be omitted from the result if Bitbucket SCM is not installed
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    devOpsProviders?: Maybe<Array<Maybe<JiraDevOpsProvider>>>;
    /**
     * The id of the tenant's epic link field.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated A temp attribute before issue creation modal supports unified parent
     */
    epicLinkFieldKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * Performs export operation on a Jira Issue
     * Takes a input of details for the operation and returns task response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraExportIssueDetails")' query directive to the 'exportIssueDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    exportIssueDetails?: Maybe<JiraExportIssueDetailsResponse>;
    /**
     * A field to get a list of favourited filters.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFilter` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    favouriteFilters?: Maybe<JiraFilterConnection>;
    /**
     * Grabs jira entities that have been favourited, filtered by type.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    favourites?: Maybe<JiraFavouriteConnection>;
    /**
     * Retrieves a JiraFieldSetView corresponding to the provided project id and issue type id.
     * Currently it's only applied to configurable child issue
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueSearch")' query directive to the 'fieldSetViewQueryByProject' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    fieldSetViewQueryByProject?: Maybe<JiraFieldSetViewResult>;
    /**
     * Loads the field sets metadata for the given field set ids.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFieldSetsById")' query directive to the 'fieldSetsById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    fieldSetsById?: Maybe<JiraIssueSearchFieldSetConnection>;
    /**
     * Retrieves a connection of searchable Jira JQL fields.
     *
     * In a given JQL, fields will precede operators and operators precede field-values/ functions.
     *
     * E.g. `${FIELD} ${OPERATOR} ${FUNCTION}()` => `Assignee = currentUser()`
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    fields?: Maybe<JiraJqlFieldConnectionResult>;
    /**
     * A parent field to get information about a given Jira filter. The id provided must be in ARI format.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFilter` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    filter?: Maybe<JiraFilter>;
    /**
     * A parent field to get information about given Jira filters. The ids provided must be in ARI format. A maximum of 50 filters can be requested.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFilters")' query directive to the 'filters' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    filters?: Maybe<Array<Maybe<JiraFilter>>>;
    /**
     * Retrieves a list of workflow templates, filtered by project style (TMP vs CMP),
     * keywords and/or tags, on a specific tenant identified with cloudId.
     *
     * The keywords and tags arguments are combined with OR.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkflowTemplate")' query directive to the 'first100JsmWorkflowTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    first100JsmWorkflowTemplates?: Maybe<
        Array<JiraServiceManagementWorkflowTemplateMetadata>
    >;
    /**
     * A namespace for everything related to Forge in Jira.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    forge: JiraForgeQuery;
    /**
     * Get formatting rules by provided project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use JiraProject.conditionalFormattingRules instead
     */
    formattingRulesByProject?: Maybe<JiraFormattingRuleConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGetArchivedIssuesQuery")' query directive to the 'getArchivedIssues' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     * @deprecated Please use getArchivedIssuesForProject instead
     */
    getArchivedIssues?: Maybe<JiraArchivedIssueConnection>;
    /**
     * Get field options for filterBy fields to get archived issues
     * Takes input of projectId to fetch field options
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGetArchivedIssuesFilterOptionsQuery")' query directive to the 'getArchivedIssuesFilterOptions' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    getArchivedIssuesFilterOptions?: Maybe<JiraArchivedIssuesFilterOptions>;
    /**
     * Get archived issues for a project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGetArchivedIssuesForProjectQuery")' query directive to the 'getArchivedIssuesForProject' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    getArchivedIssuesForProject?: Maybe<JiraIssueConnection>;
    /**
     * Fetch global permissions and grants.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGlobalPermissions")' query directive to the 'getGlobalPermissionsAndGrants' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    getGlobalPermissionsAndGrants?: Maybe<JiraGlobalPermissionGrantsResult>;
    /**
     * Fetch the Issue Transition Modal load screen for a given issueId and transitionId
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueTransitionByIssueId")' query directive to the 'getIssueTransitionByIssueId' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    getIssueTransitionByIssueId?: Maybe<JiraIssueTransitionModal>;
    /**
     * Fetch the Issue Transition Modal load screen for a given issueKey, cloudId and transitionId
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueTransitionByIssueKey")' query directive to the 'getIssueTransitionByIssueKey' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    getIssueTransitionByIssueKey?: Maybe<JiraIssueTransitionModal>;
    /**
     * Represents outgoing email settings response for banners on notification log page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    getOutgoingEmailSettings?: Maybe<JiraOutgoingEmailSettings>;
    /**
     * A list of paginated permission scheme grants based on the given permission scheme ID and permission key.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    getPermissionSchemeGrants?: Maybe<JiraPermissionGrantConnection>;
    /**
     * Gets the permission scheme grants hierarchy (by grant type key) based on the given permission scheme ID and permission key.
     * This returns a bounded list of data with limit set to 50. For getting the complete list in paginated manner, use getPermissionSchemeGrants.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    getPermissionSchemeGrantsHierarchy?: Maybe<Array<JiraPermissionGrants>>;
    /**
     * Get the list of paginated projects associated with the given permission scheme ID.
     * The project objects will be returned based on implicit ascending order by project name.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    getProjectsByPermissionScheme?: Maybe<JiraProjectConnection>;
    /**
     * Returns a connection of global navigation items from apps
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    globalAppNavigationItems?: Maybe<JiraNavigationItemConnection>;
    /**
     * Retrieve the global time tracking settings for a Jira instance
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: GlobalTimeTrackingSettings` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    globalTimeTrackingSettings?: Maybe<JiraTimeTrackingSettings>;
    /**
     * Get the grant type values by search term and grant type key.
     * It only supports fetching values for APPLICATION_ROLE, PROJECT_ROLE, MULTI_USER_PICKER and MULTI_GROUP_PICKER grant types.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    grantTypeValues?: Maybe<JiraGrantTypeValueConnection>;
    /**
     * Returns the type of comment visibility option based on groups which the user is part of.
     * Group type for user having groupId, ARI Id and group name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraGroupVisibilities")' query directive to the 'groupCommentVisibilities' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    groupCommentVisibilities?: Maybe<JiraGroupConnection>;
    /**
     * Query to check if a user has the specified global jira permission.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraHasGlobalPermission")' query directive to the 'hasGlobalPermission' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    hasGlobalPermission?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Fetches if the user has given permission for a project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraHasProjectPermissionQuery")' query directive to the 'hasProjectPermission' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    hasProjectPermission?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns the precondition state of the install-deployments banner for a particular project and user.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Banner experiment is no longer active
     */
    installDeploymentsBannerPrecondition?: Maybe<JiraInstallDeploymentsBannerPrecondition>;
    /**
     * Returns a user property for the currently logged in user when the property value has a integer value.
     * Will return null if the propertyKey does not exist or does not store a integer value.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use of this generic entity property is not recommended, if your team has capacity it is preferred to add your own user property to the schema
     */
    integerUserProperty?: Maybe<JiraEntityPropertyInt>;
    /**
     * Returns a boolean attribute if Atlassian AI
     * is enabled within issue in accordance
     * to the admin hub AI value set by site admins.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIsEditorAiEnabledForIssue")' query directive to the 'isAiEnabledForIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isAiEnabledForIssue?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns a boolean attribute if editor
     * is enabled within issue view in accordance
     * to the admin hub AI value set by site admins.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIsIssueViewEditorAiEnabled")' query directive to the 'isIssueViewEditorAiEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isIssueViewEditorAiEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns a boolean value indicating whether Jira Defintions permissions is enabled for the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    isJiraDefinitionsPermissionsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns whether the natural language search feature is enabled for a given tenant.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNaturalLanguageToJQL")' query directive to the 'isNaturalLanguageSearchEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isNaturalLanguageSearchEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether Rovo has been enabled for a Jira site.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAtlassianIntelligence")' query directive to the 'isRovoEnabled' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    isRovoEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether sub-tasks have been enabled for this instance.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIsSubtasksEnabled")' query directive to the 'isSubtasksEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    isSubtasksEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Returns an Issue by the issue ID (ARI).
     * Deprecated: 'issue' is not backed by Issue Service, use 'issueByKey' or 'issueById' instead
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated This field is not backed by Issue Service, use 'issueByKey' or 'issueById' instead.
     */
    issue?: Maybe<JiraIssue>;
    /**
     * Returns an Issue by the Issue ID and Jira instance Cloud ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueById?: Maybe<JiraIssue>;
    /**
     * Returns an Issue by the Issue Key and Jira instance Cloud ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueByKey?: Maybe<JiraIssue>;
    /**
     * Used to retrieve Issue layout information by type by `issueId`.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueContainersByType?: Maybe<JiraIssueItemContainersResult>;
    /**
     * Used to retrieve Issue layout information by `issueKey` and `cloudId`.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueContainersByTypeByKey?: Maybe<JiraIssueItemContainersResult>;
    /**
     * A bulk API that returns a list of JiraIssueFields by ids.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueFieldsByIds")' query directive to the 'issueFieldsByIds' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueFieldsByIds?: Maybe<JiraIssueFieldConnection>;
    /**
     * Container for all Issue Hierarchy Configuration related queries in Jira
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueHierarchyConfig?: Maybe<JiraIssueHierarchyConfigurationQuery>;
    /**
     * A field that represents a long running task to update issue type hierarchy configuration
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueHierarchyConfigUpdateTask?: Maybe<JiraHierarchyConfigTask>;
    /**
     * Container for all Issue Hierarchy Limits related queries in Jira
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueHierarchyLimits?: Maybe<JiraIssueHierarchyLimits>;
    /**
     * Hydrate a list of issue IDs into issue data. The issue data retrieved will depend on
     * the subsequently specified view(s) and/or fields.
     *
     * The ids provided MUST be in ARI format.
     *
     * For each id provided, it will resolve to either a JiraIssue as a leaf node in an subsequent query, or a QueryError if:
     * - The ARI provided did not pass validation.
     * - The ARI did not resolve to an issue.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated New schema in development right now. This is incomplete.
     */
    issueHydrateByIssueIds?: Maybe<JiraIssueSearchByHydration>;
    /**
     * Gets the globally configured issue link types.
     * When issue linking is disabled, this will return null.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueLinkTypes?: Maybe<JiraIssueLinkTypeConnection>;
    /**
     * Retrieves the Issue Navigator JQL History.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUserIssueNavigatorJQLHistory")' query directive to the 'issueNavigatorUserJQLHistory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueNavigatorUserJQLHistory?: Maybe<JiraJqlHistoryConnection>;
    /**
     * Performs an issue search using the issueSearchInput argument.
     * This is different to "issueSearchStable" - as the name suggests, the issue ids from the initial search are not preserved when paginating.
     * Instead, a new JQL search is triggered for every request.
     * An "initial search" is when no cursors are specified.
     * Another difference is the pagination model - this API is not supporting random access pagination anymore, so the "pageCursors" field is not going to be populated.
     * The clients will need to use the "pageInfo" field to determine if there are more pages to fetch.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSpreadsheetComponent-M1")' query directive to the 'issueSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueSearch?: Maybe<JiraIssueConnection>;
    /**
     * Performs an issue search using the underlying JQL saved as a filter.
     *
     * The id provided MUST be in ARI format.
     *
     * This query will error if the id parameter is not in ARI format, does not pass validation or does not correspond to a filter.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated New schema in development right now. This is incomplete.
     */
    issueSearchByFilterId?: Maybe<JiraIssueSearchByFilterResult>;
    /**
     * Performs an issue search using the provided string of JQL.
     * This query will error if the JQL does not pass validation.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated New schema in development right now. This is incomplete.
     */
    issueSearchByJql?: Maybe<JiraIssueSearchByJqlResult>;
    /**
     * Performs an issue search using the issueSearchInput argument.
     * This relies on stable search where the issue ids from the initial search are preserved between pagination.
     * An "initial search" is when no cursors are specified.
     * The server will configure a limit on the maximum issue ids preserved for a given search e.g. 1000.
     * On pagination, we take the next page of issues from this stable set of 1000 ids and return hydrated issue data.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issueSearchStable?: Maybe<JiraIssueConnection>;
    /**
     * Returns the status of the JQL search processing.
     * If JQL clause contains custom JQL function, it returns status for every processed function.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueSearchStatus")' query directive to the 'issueSearchStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueSearchStatus?: Maybe<JiraIssueSearchStatus>;
    /**
     * Performs an issue search using the issueSearchInput argument and returns the total number of issues corresponding to the search input
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraTotalIssueCount")' query directive to the 'issueSearchTotalCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueSearchTotalCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Retrieves data about a JiraIssueSearchView.
     *
     * The id provided MUST be in ARI format.
     *
     * This query will error if the id parameter is not in ARI format, does not pass validation or does not correspond to a JiraIssueSearchView.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated New schema in development right now. This is incomplete.
     */
    issueSearchView?: Maybe<JiraIssueSearchView>;
    /**
     * Retrieves a JiraIssueSearchView corresponding to the provided namespace, viewId and filterId.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraIssueSearch` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated This field will be deprecated in favour of issueSearchViewResult
     */
    issueSearchViewByNamespaceAndViewId?: Maybe<JiraIssueSearchView>;
    /**
     * Retrieves a JiraIssueSearchViewResult corresponding to the provided namespace, viewId and filterId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueSearch")' query directive to the 'issueSearchViewResult' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    issueSearchViewResult?: Maybe<JiraIssueSearchViewResult>;
    /**
     * Returns Issues given a list of Issue Keys (up to 100) and Jira instance Cloud ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    issuesByKey?: Maybe<Array<Maybe<JiraIssue>>>;
    /**
     * Get activity in a journey by both journey id and activity id
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'jiraActivityConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Replaced with jiraJourneyItem
     */
    jiraActivityConfiguration?: Maybe<JiraActivityConfiguration>;
    /**
     * Returns a board by board ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraBoard?: Maybe<JiraBoardResult>;
    /**
     * Retrieves details of the screen layout attached for a transition and set of issues on which
     * respective transition is available.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraBulkTransitionScreenLayout")' query directive to the 'jiraBulkTransitionsScreenDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraBulkTransitionsScreenDetails?: Maybe<JiraBulkTransitionScreenLayout>;
    /**
     * Jira calendar query that should be product-agnostic using the scope argument to determine the context of the calendar.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraCalendar")' query directive to the 'jiraCalendar' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraCalendar?: Maybe<JiraCalendar>;
    /**
     * Query to bulk fetch customer organizations by their UUIDs
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraCustomerOrganizationsByUUIDs?: Maybe<JiraServiceManagementOrganizationConnection>;
    /**
     * Retrieves details on actions which can be performed by the user on a list of issues
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFetchBulkOperationDetailsResponse")' query directive to the 'jiraFetchBulkOperationDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraFetchBulkOperationDetails?: Maybe<JiraFetchBulkOperationDetailsResponse>;
    /**
     * A connection to Field configuration data (this field is in Beta state, performance to be validated)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraFieldConfigs?: Maybe<JiraFieldConfigConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueSearchView")' query directive to the 'jiraIssueSearchView' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraIssueSearchView?: Maybe<JiraView>;
    /**
     * Get jira journey configuration by id which is uuid
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'jiraJourneyConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraJourneyConfiguration?: Maybe<JiraJourneyConfiguration>;
    /**
     * Get journey item by both journey id and item id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraJourneyBuilder")' query directive to the 'jiraJourneyItem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraJourneyItem?: Maybe<JiraJourneyItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraProject?: Maybe<JiraProject>;
    /**
     * Returns a Project by the Project Key and Jira instance Cloud ID.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraProject` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraProjectByKey?: Maybe<JiraProject>;
    /**
     * Query for multiple projects by ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraProjects?: Maybe<Array<Maybe<JiraProject>>>;
    /**
     * Query to get all projects in the project clause of a JQL query
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraProjectsByJql?: Maybe<JiraProjectConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraProjectsMappedToHelpCenter?: Maybe<JiraProjectConnection>;
    /**
     * Get request type categories for a given project as paginated list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementRequestTypeCategory")' query directive to the 'jiraServiceManagementRequestTypeCategoriesByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jiraServiceManagementRequestTypeCategoriesByProject?: Maybe<JiraServiceManagementRequestTypeCategoryConnection>;
    /**
     * Retrieves the id for delivery issue link type in JPD projects
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jpdDeliveryIssueLinkTypeId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * A parent field to get information about jql related aspects from a given jira instance.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraJqlBuilder` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jqlBuilder?: Maybe<JiraJqlBuilder>;
    /**
     * Query the team type of the provided project.
     * Will return null if the team type is not available for the provided project.
     * The team type property is only available for JSM projects created after March 2023.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectTeamType")' query directive to the 'jsmProjectTeamType' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmProjectTeamType?: Maybe<JiraServiceManagementProjectTeamType>;
    /**
     * Retrieves a paginated list of JSM workflow templates, filtered by project style (TMP vs CMP), on a specific tenant identified with cloudId.
     *
     * Note: This query and response uses schema that supports pagination, but the actual pagination logic is still not yet implemented, as we read all the metadata from a single file.
     * As such, currently the inputs `first` and `after` are ignored, and all the metadata are returned in the response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkflowTemplate")' query directive to the 'jsmWorkflowTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jsmWorkflowTemplates?: Maybe<JiraServiceManagementWorkflowTemplatesMetadataConnection>;
    /**
     * Returns a user property for the currently logged in user when the property value has a JSON value.
     * Will return null if the propertyKey does not exist or does not store a JSON value.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use of this generic entity property is not recommended, if your team has capacity it is preferred to add your own user property to the schema
     */
    jsonUserProperty?: Maybe<JiraEntityPropertyJson>;
    /**
     * Return the details for the active background of a entity
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic activeBackgroundDetails field
     */
    jwmActiveBackgroundDetails?: Maybe<JiraWorkManagementActiveBackgroundDetailsResult>;
    /**
     * Returns a connection of addable view types for the specified project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced with containerNavigation.addableNavigationItemTypes
     */
    jwmAddableViewTypes?: Maybe<JiraWorkManagementSavedViewTypeConnection>;
    /**
     * Return Media API upload token for a user's background Media collection
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic backgroundUploadToken field
     */
    jwmBackgroundUploadToken?: Maybe<JiraWorkManagementBackgroundUploadTokenResult>;
    /**
     * Return custom backgrounds associated with the user
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced by the generic customBackgrounds field
     */
    jwmCustomBackgrounds?: Maybe<JiraWorkManagementCustomBackgroundConnection>;
    /**
     * Returns a connection of custom filters associated with a context defined by an ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmFilters?: Maybe<JiraWorkManagementFilterConnectionResult>;
    /**
     * Returns a Jira Work Management form configuration by its ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmForm?: Maybe<JiraWorkManagementFormConfiguration>;
    /**
     * Returns information about the licensing of the requesting user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmLicensing?: Maybe<JiraWorkManagementLicensing>;
    /**
     * Fetch JWM navigations from views other than project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmNavigation?: Maybe<JiraWorkManagementNavigation>;
    /**
     * Fetch JWM navigations from project view
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmNavigationByProjectId?: Maybe<JiraWorkManagementNavigation>;
    /**
     * Fetch JWM navigations from project view
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmNavigationByProjectKey?: Maybe<JiraWorkManagementNavigation>;
    /**
     * Returns a single Jira Work Management overview by ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmOverview?: Maybe<JiraWorkManagementGiraOverviewResult>;
    /**
     * Returns a connection of Jira Work Management overviews that belong to the requesting user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmOverviews?: Maybe<JiraWorkManagementGiraOverviewConnection>;
    /**
     * Returns a saved view by its global identifier (ARI).
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated There is no replacement as there is no use case for it
     */
    jwmSavedViewById?: Maybe<JiraWorkManagementSavedViewResult>;
    /**
     * Returns a saved view by its item ID and project key.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced with containerNavigation.navigationItemByItemId
     */
    jwmSavedViewByProjectKeyAndItemId?: Maybe<JiraWorkManagementSavedViewResult>;
    /**
     * Returns a connection of saved views for the specified project.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced with containerNavigation.navigationItems
     */
    jwmSavedViewsByProject?: Maybe<JiraNavigationItemConnection>;
    /**
     * Returns a connection of items returned by a search by a jql query
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkManagementViews")' query directive to the 'jwmViewItems' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    jwmViewItems?: Maybe<JiraWorkManagementViewItemConnectionResult>;
    /**
     * Fetch possible values for the the labels field
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFieldOptionSearching` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Replaced with 'JiraLabelsField.labels'. In order to access from 'Query' directly, use 'node(id: $id)' passing $id as an 'issuefieldvalue' type ARI
     */
    labelsFieldOptions?: Maybe<JiraLabelConnection>;
    /**
     * A List of JiraIssueType IDs that cannot be moved to a different hierarchy level.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    lockedIssueTypeIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /**
     * Registered client id of media API.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    mediaClientId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Endpoint where the media content will be read.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    mediaExternalEndpointUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNaturalLanguageToJQL")' query directive to the 'naturalLanguageToJql' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    naturalLanguageToJql?: Maybe<JiraJqlFromNaturalLanguage>;
    /**
     * Gets the navigation UI state of the left sidebar and right panels for the currently logged in user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    navigationUIState?: Maybe<JiraNavigationUiStateUserProperty>;
    /**
     * A field that represents notification preferences across all projects.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    notificationGlobalPreference?: Maybe<JiraNotificationGlobalPreference>;
    /**
     * A field to get project-specific notification preferences by project ID.
     * The project ids provided must be in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    notificationProjectPreference?: Maybe<JiraNotificationProjectPreferences>;
    /**
     * A field to get project-specific notification preferences by project IDs.
     * The project ids provided must be in ARI format. Preferences can be requested for a maximum of 50 projects.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Will be removed while API is in experimental phase for next iteration of project preferences
     */
    notificationProjectPreferences?: Maybe<
        Array<Maybe<JiraNotificationProjectPreferences>>
    >;
    /**
     * Query to obtain specific global jira permission details for the current user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    permission?: Maybe<JiraPermission>;
    /**
     * A list of paginated permission scheme grants based on the given permission scheme ID.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Please use getPermissionSchemeGrants instead.
     */
    permissionSchemeGrants?: Maybe<JiraPermissionGrantValueConnection>;
    /**
     * Gets the Advanced Roadmaps plan for the given id. The id provided must be in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraPlan")' query directive to the 'planById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    planById?: Maybe<JiraPlan>;
    /**
     * Fetch a list of post-incident review links by their IDs. Maximum number of IDs is 100.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSoftwarePostIncidentReviews")' query directive to the 'postIncidentReviewLinksByIds' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    postIncidentReviewLinksByIds?: Maybe<
        Array<Maybe<JiraPostIncidentReviewLink>>
    >;
    /**
     * Returns all project cleanup activity log entries.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectCleanupLogTableEntry")' query directive to the 'projectCleanupLogTableEntries' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectCleanupLogTableEntries?: Maybe<JiraProjectCleanupLogTableEntryConnection>;
    /**
     * Returns all project cleanup recommendations by cloud ID and statuses. Can also filter the empty projects or those issues staying unchanged for a certain period of time.
     * The filters are mutually exclusive and therefore when both used they follow the OR logic. That would be for both filters selected the resulting recommendations list will contain recommendations that satisfy either of the filters.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectCleanupRecommendation")' query directive to the 'projectCleanupRecommendations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectCleanupRecommendations?: Maybe<JiraProjectCleanupRecommendationConnection>;
    /**
     * Return a list of Project Templates recommended to users on the project list view
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectListViewTemplate")' query directive to the 'projectListViewTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectListViewTemplates?: Maybe<JiraProjectListViewTemplateConnection>;
    /**
     * List request types for a project that were created from request type template.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraRequestTypeTemplate")' query directive to the 'projectRequestTypesFromTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectRequestTypesFromTemplate?: Maybe<
        Array<JiraServiceManagementRequestTypeFromTemplate>
    >;
    /**
     * Returns all project role actor activity log entries - limited to 1000.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectRoleActorLogTableEntry")' query directive to the 'projectRoleActorLogTableEntries' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectRoleActorLogTableEntries?: Maybe<JiraProjectRoleActorLogTableEntryConnection>;
    /**
     * Returns all project role actor recommendations by cloud ID and statuses. Can also filter by user status and projectId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectRoleActorRecommendation")' query directive to the 'projectRoleActorRecommendations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectRoleActorRecommendations?: Maybe<JiraProjectRoleActorRecommendationConnection>;
    /**
     * Returns the Jira Software 'rank' custom field for use in JQL.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rankField?: Maybe<JiraJqlFieldWithAliases>;
    /**
     * Fetches a list of recent boards for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentBoards?: Maybe<JiraBoardConnection>;
    /**
     * Fetches a list of recent dashboards for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentDashboards?: Maybe<JiraSearchableEntityConnection>;
    /**
     * Fetches a list of recent filters for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentFilters?: Maybe<JiraFilterConnection>;
    /**
     * Fetches a list of recent issues for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentIssues?: Maybe<JiraIssueConnection>;
    /**
     * Fetches a list of recent items of specified entity types for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentItems?: Maybe<JiraSearchableEntityConnection>;
    /**
     * Fetches a list of recent plans for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentPlans?: Maybe<JiraSearchableEntityConnection>;
    /**
     * Fetches a list of recent projects for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentProjects?: Maybe<JiraProjectConnection>;
    /**
     * Fetches a list of recent queues for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    recentQueues?: Maybe<JiraSearchableEntityConnection>;
    /**
     * Returns remote issue links by the remote issue link ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    remoteIssueLinksById?: Maybe<Array<Maybe<JiraRemoteIssueLink>>>;
    /**
     * Retrieves a list of report categories and their associated reports for a given board or project.
     * While both arguments are nullable, at least one must be passed in for this field to function.
     * - Both `boardId` and `projectKey` should be passed in for JSW CMP projects with boards.
     * - `projectKey` alone should be passed in for JSW CMP projects without boards.
     * - `boardId` alone should be passed in for User Boards where a project is not in scope.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraReportsPage")' query directive to the 'reportsPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please use either JiraProject.reportCategories or JiraBoard.reportCategories
     */
    reportsPage?: Maybe<JiraReportsPage>;
    /**
     * Get a single Jira Service Management request type template by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraRequestTypeTemplate")' query directive to the 'requestTypeTemplateById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    requestTypeTemplateById?: Maybe<JiraServiceManagementRequestTypeTemplate>;
    /**
     * Query default configuration dependencies that can be used with request type template.
     * Since request type creation also need workflow, request type group, etc to associate with. This query
     * will provide these dependencies objects as default options for user to create with their chosen template.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraRequestTypeTemplate")' query directive to the 'requestTypeTemplateDefaultConfigurationDependencies' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    requestTypeTemplateDefaultConfigurationDependencies?: Maybe<JiraServiceManagementRequestTypeTemplateDefaultConfigurationDependencies>;
    /**
     * List Jira Service Management request type templates.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraRequestTypeTemplate")' query directive to the 'requestTypeTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    requestTypeTemplates?: Maybe<
        Array<JiraServiceManagementRequestTypeTemplate>
    >;
    /**
     * Get request types for a project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraServiceManagementRequestTypeQuery")' query directive to the 'requestTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    requestTypes?: Maybe<JiraServiceManagementRequestTypeConnection>;
    /**
     * Returns all resource usage custom field recommendations by cloud ID and statuses.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraResourceUsageCustomFieldRecommendation")' query directive to the 'resourceUsageCustomFieldRecommendations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    resourceUsageCustomFieldRecommendations?: Maybe<JiraResourceUsageCustomFieldRecommendationConnection>;
    /**
     * Returns a resource usage metric by cloud ID and metric key.
     *
     * If the resource usage metric does not exists, null will be returned.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraResourceUsageMetric")' query directive to the 'resourceUsageMetric' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    resourceUsageMetric?: Maybe<JiraResourceUsageMetric>;
    /**
     * Returns a resource usage metric using it's ARI ID.
     *
     * If the resource usage metric does not exists, null will be returned.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraResourceUsageMetric")' query directive to the 'resourceUsageMetricById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    resourceUsageMetricById?: Maybe<JiraResourceUsageMetric>;
    /**
     * Returns all resource usage metrics by cloud ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraResourceUsageMetric")' query directive to the 'resourceUsageMetrics' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    resourceUsageMetrics?: Maybe<JiraResourceUsageMetricConnection>;
    /**
     * Return stats on recommendations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraResourceUsageRecommendationStats")' query directive to the 'resourceUsageRecommendationStats' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    resourceUsageRecommendationStats?: Maybe<JiraResourceUsageRecommendationStats>;
    /**
     * Returns a connection of saved filters visible to the user and match the keyword if provided.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraFilter")' query directive to the 'savedFilters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    savedFilters?: Maybe<JiraFilterConnection>;
    /**
     * Returns Screen Id by the Issue ID.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated The screen concept has been deprecated, and is only used for legacy reasons.
     */
    screenIdByIssueId?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Returns Screen Id by the Issue Key.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated The screen concept has been deprecated, and is only used for legacy reasons.
     */
    screenIdByIssueKey?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Search the Unsplash API for images given a query
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    searchUnsplashImages?: Maybe<JiraUnsplashImageSearchPageResult>;
    /**
     * Returns a list of containing users and teams who are relevant to mention and match the query string.
     * The list is sorted by 'relevance' with most relevant appearing first.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    searchUserTeamMention?: Maybe<JiraMentionableConnection>;
    /**
     * Determines whether or not Atlassian Intelligence should be shown for a given product or feature.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraNaturalLanguageToJQL")' query directive to the 'shouldShowAtlassianIntelligence' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    shouldShowAtlassianIntelligence?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Gets the Sprint for the given id. The id provided must be in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    sprintById?: Maybe<JiraSprint>;
    /**
     * Gets the Sprints that match the given search criteria
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSprintSearch")' query directive to the 'sprintSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    sprintSearch?: Maybe<JiraSprintConnection>;
    /**
     * Returns the Jira Software 'startdate' custom field for use in JQL.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    startDateField?: Maybe<JiraJqlField>;
    /**
     * Returns a user property for the currently logged in user when the property value has a string value.
     * Will return null if the propertyKey does not exist or does not store a string value.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use of this generic entity property is not recommended, if your team has capacity it is preferred to add your own user property to the schema
     */
    stringUserProperty?: Maybe<JiraEntityPropertyString>;
    /**
     * A field to get a list of system filters. Accepts `isFavourite` argument to return list of favourited system filters or to exclude favourited
     * filters from the list.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraFilter` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    systemFilters?: Maybe<JiraSystemFilterConnection>;
    /**
     * Retrieve the global time tracking settings for a Jira instance
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: TimeTrackingSettings` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use: globalTimeTrackingSettings
     */
    timeTrackingSettings?: Maybe<JiraGlobalTimeTrackingSettings>;
    /**
     * Fetch UI modifications for the given context.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    uiModifications?: Maybe<Array<JiraAppUiModifications>>;
    /**
     * Returns the Homepage preference of the currently logged in user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraHomePage")' query directive to the 'userHomePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userHomePage?: Maybe<JiraHomePage>;
    /**
     * Fetches the user's configuration for the navigation at a specific location.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUserNavConfig")' query directive to the 'userNavigationConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userNavigationConfiguration?: Maybe<JiraUserNavigationConfiguration>;
    /**
     * Preferences specific to the logged-in user on Jira.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUserPreferences")' query directive to the 'userPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userPreferences?: Maybe<JiraUserPreferences>;
    /**
     * Return the user's role and team's type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraUserSegmentation")' query directive to the 'userSegmentation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userSegmentation?: Maybe<JiraUserSegmentation>;
    /**
     * Get version by ARI
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: JiraVersionResult` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    version?: Maybe<JiraVersionResult>;
    /**
     * Gets the version for the given id. The id provided must be in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    versionById?: Maybe<JiraVersion>;
    /**
     * Get the versions that match the given search criteria
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    versionSearch?: Maybe<JiraVersionConnection>;
    /**
     * This field returns an array of JiraVersion items given an array of ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraVersionsByIds")' query directive to the 'versionsByIds' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    versionsByIds?: Maybe<Array<Maybe<JiraVersion>>>;
    /**
     * This field returns a connection over JiraVersion.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: VersionsForProject` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    versionsForProject?: Maybe<JiraVersionConnection>;
    /**
     * This field returns a connection over JiraVersion.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraVersionsForProjects")' query directive to the 'versionsForProjects' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    versionsForProjects?: Maybe<JiraVersionConnection>;
    /**
     * Get the permission scheme based on scheme id. The scheme ID input represent an ARI.
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: PermissionScheme` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    viewPermissionScheme?: Maybe<JiraPermissionSchemeViewResult>;
};

export type JiraQueryActiveBackgroundDetailsArgs = {
    entityId: Scalars["ID"]["input"];
};

export type JiraQueryAdvancedRoadmapsNavigationArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryAllGrantTypeKeysArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryAllJiraJourneyConfigurationsArgs = {
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryAllJiraProjectCategoriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filter?: InputMaybe<JiraProjectCategoryFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryAllJiraProjectTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryAllJiraProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filter: JiraProjectFilterInput;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryAllJiraUserBroadcastMessagesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryAllNotificationProjectPreferencesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryAnnouncementBannerArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryApplicationPropertiesByKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    keys: Array<Scalars["String"]["input"]>;
};

export type JiraQueryAtlassianIntelligenceActionArgs = {
    atlassianIntelligenceProductFeatureInput: JiraAtlassianIntelligenceProductFeatureInput;
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryAttachmentByAriArgs = {
    attachmentAri: Scalars["ID"]["input"];
};

export type JiraQueryAttachmentByAriV2Args = {
    attachmentAri: Scalars["ID"]["input"];
};

export type JiraQueryAttachmentSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filters?: InputMaybe<JiraAttachmentFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    projectKeys: Array<Scalars["String"]["input"]>;
};

export type JiraQueryAttachmentStorageAllowedArgs = {
    applicationKey: JiraApplicationKey;
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryAttachmentStorageIsUnlimitedArgs = {
    applicationKey: JiraApplicationKey;
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryAttachmentStorageUsedArgs = {
    applicationKey: JiraApplicationKey;
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryBackgroundUploadTokenArgs = {
    cloudId: Scalars["ID"]["input"];
    durationInSeconds: Scalars["Int"]["input"];
};

export type JiraQueryBooleanUserPropertyArgs = {
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    propertyKey: Scalars["String"]["input"];
};

export type JiraQueryBulkOperationProgressArgs = {
    cloudId: Scalars["ID"]["input"];
    taskId: Scalars["ID"]["input"];
};

export type JiraQueryBulkOperationsMetadataArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryCanPerformArgs = {
    cloudId: Scalars["ID"]["input"];
    type: JiraActionType;
};

export type JiraQueryChildIssuesLimitArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryContainerNavigationArgs = {
    input: JiraContainerNavigationQueryInput;
};

export type JiraQueryCustomBackgroundsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryDefaultUnsplashImagesArgs = {
    input: JiraDefaultUnsplashImagesInput;
};

export type JiraQueryDeploymentsFeaturePreconditionArgs = {
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryDeploymentsFeaturePreconditionByProjectKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    projectKey: Scalars["String"]["input"];
};

export type JiraQueryDevOpsProvidersArgs = {
    cloudId: Scalars["ID"]["input"];
    filter?: InputMaybe<Array<JiraDevOpsCapability>>;
};

export type JiraQueryEpicLinkFieldKeyArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraQueryExportIssueDetailsArgs = {
    input: JiraExportIssueDetailsInput;
};

export type JiraQueryFavouriteFiltersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryFavouritesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filter: JiraFavouriteFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryFieldSetViewQueryByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
    issueTypeId?: InputMaybe<Scalars["ID"]["input"]>;
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraQueryFieldSetsByIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    fieldSetIds: Array<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    excludeFields?: InputMaybe<Array<Scalars["String"]["input"]>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    forClause?: InputMaybe<JiraJqlClauseType>;
    jqlContext?: InputMaybe<Scalars["String"]["input"]>;
    jqlContextFieldsFilter?: InputMaybe<JiraJqlContextFieldsFilter>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    viewContext?: InputMaybe<JiraJqlViewContext>;
};

export type JiraQueryFilterArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryFiltersArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryFirst100JsmWorkflowTemplatesArgs = {
    cloudId: Scalars["ID"]["input"];
    keywords?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    projectStyle?: InputMaybe<JiraProjectStyle>;
    tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    templateId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryFormattingRulesByProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryGetArchivedIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterBy?: InputMaybe<JiraArchivedIssuesFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryGetArchivedIssuesFilterOptionsArgs = {
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryGetArchivedIssuesForProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filterBy?: InputMaybe<JiraArchivedIssuesFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryGetGlobalPermissionsAndGrantsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryGetIssueTransitionByIssueIdArgs = {
    issueId: Scalars["ID"]["input"];
    transitionId: Scalars["String"]["input"];
};

export type JiraQueryGetIssueTransitionByIssueKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    issueKey: Scalars["String"]["input"];
    transitionId: Scalars["String"]["input"];
};

export type JiraQueryGetOutgoingEmailSettingsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryGetPermissionSchemeGrantsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    grantTypeKey?: InputMaybe<JiraGrantTypeKeyEnum>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    permissionKey: Scalars["String"]["input"];
    schemeId: Scalars["ID"]["input"];
};

export type JiraQueryGetPermissionSchemeGrantsHierarchyArgs = {
    permissionKey: Scalars["String"]["input"];
    schemeId: Scalars["ID"]["input"];
};

export type JiraQueryGetProjectsByPermissionSchemeArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    schemeId: Scalars["ID"]["input"];
};

export type JiraQueryGlobalAppNavigationItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryGlobalTimeTrackingSettingsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryGrantTypeValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    grantTypeKey: JiraGrantTypeKeyEnum;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchTerm?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryGroupCommentVisibilitiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryHasGlobalPermissionArgs = {
    cloudId: Scalars["ID"]["input"];
    key: JiraGlobalPermissionType;
};

export type JiraQueryHasProjectPermissionArgs = {
    cloudId: Scalars["ID"]["input"];
    permission: JiraProjectPermissionType;
    projectKey: Scalars["String"]["input"];
};

export type JiraQueryInstallDeploymentsBannerPreconditionArgs = {
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryIntegerUserPropertyArgs = {
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    propertyKey: Scalars["String"]["input"];
};

export type JiraQueryIsAiEnabledForIssueArgs = {
    issueInput: JiraAiEnablementIssueInput;
};

export type JiraQueryIsIssueViewEditorAiEnabledArgs = {
    cloudId: Scalars["ID"]["input"];
    jiraProjectType: JiraProjectType;
};

export type JiraQueryIsJiraDefinitionsPermissionsEnabledArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIsNaturalLanguageSearchEnabledArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIsRovoEnabledArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIsSubtasksEnabledArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIssueArgs = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraQueryIssueByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryIssueByKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

export type JiraQueryIssueContainersByTypeArgs = {
    input: JiraIssueItemSystemContainerTypeWithIdInput;
};

export type JiraQueryIssueContainersByTypeByKeyArgs = {
    input: JiraIssueItemSystemContainerTypeWithKeyInput;
};

export type JiraQueryIssueFieldsByIdsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    ids: Array<Scalars["ID"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryIssueHierarchyConfigArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIssueHierarchyConfigUpdateTaskArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIssueHierarchyLimitsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryIssueHydrateByIssueIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryIssueLinkTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryIssueNavigatorUserJqlHistoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryIssueSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    fieldSetsInput?: InputMaybe<JiraIssueSearchFieldSetsInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    options?: InputMaybe<JiraIssueSearchOptions>;
    saveJQLToUserHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
    scope?: InputMaybe<JiraIssueSearchScope>;
    viewConfigInput?: InputMaybe<JiraIssueSearchViewConfigInput>;
};

export type JiraQueryIssueSearchByFilterIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryIssueSearchByJqlArgs = {
    cloudId: Scalars["ID"]["input"];
    jql: Scalars["String"]["input"];
};

export type JiraQueryIssueSearchStableArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    fieldSetsInput?: InputMaybe<JiraIssueSearchFieldSetsInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput: JiraIssueSearchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    options?: InputMaybe<JiraIssueSearchOptions>;
    saveJQLToUserHistory?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JiraQueryIssueSearchStatusArgs = {
    cloudId: Scalars["ID"]["input"];
    jql: Scalars["String"]["input"];
};

export type JiraQueryIssueSearchTotalCountArgs = {
    cloudId: Scalars["ID"]["input"];
    issueSearchInput: JiraIssueSearchInput;
    viewConfigInput?: InputMaybe<JiraIssueSearchViewConfigInput>;
};

export type JiraQueryIssueSearchViewArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryIssueSearchViewByNamespaceAndViewIdArgs = {
    cloudId: Scalars["ID"]["input"];
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryIssueSearchViewResultArgs = {
    cloudId: Scalars["ID"]["input"];
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryIssuesByKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    keys: Array<Scalars["String"]["input"]>;
};

export type JiraQueryJiraActivityConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    journeyId: Scalars["ID"]["input"];
};

export type JiraQueryJiraBoardArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryJiraBulkTransitionsScreenDetailsArgs = {
    issueIds: Array<Scalars["ID"]["input"]>;
    transitionId: Scalars["Int"]["input"];
};

export type JiraQueryJiraCalendarArgs = {
    configuration?: InputMaybe<JiraCalendarViewConfigurationInput>;
    scope?: InputMaybe<JiraViewScopeInput>;
};

export type JiraQueryJiraCustomerOrganizationsByUuiDsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    input: JiraCustomerOrganizationsBulkFetchInput;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryJiraFetchBulkOperationDetailsArgs = {
    issueIds: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryJiraFieldConfigsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraFieldConfigFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryJiraIssueSearchViewArgs = {
    cloudId: Scalars["ID"]["input"];
    filterId?: InputMaybe<Scalars["String"]["input"]>;
    isGroupingEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    namespace?: InputMaybe<Scalars["String"]["input"]>;
    viewConfigInput?: InputMaybe<JiraIssueSearchStaticViewInput>;
    viewId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryJiraJourneyConfigurationArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type JiraQueryJiraJourneyItemArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    journeyId: Scalars["ID"]["input"];
};

export type JiraQueryJiraProjectArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryJiraProjectByKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    ignoreDeleteStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
    key: Scalars["String"]["input"];
};

export type JiraQueryJiraProjectsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryJiraProjectsByJqlArgs = {
    cloudId: Scalars["ID"]["input"];
    query: Scalars["String"]["input"];
};

export type JiraQueryJiraProjectsMappedToHelpCenterArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filter: JiraProjectsMappedToHelpCenterFilterInput;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryJiraServiceManagementRequestTypeCategoriesByProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryJpdDeliveryIssueLinkTypeIdArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryJqlBuilderArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryJsmProjectTeamTypeArgs = {
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryJsmWorkflowTemplatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    projectStyle?: InputMaybe<JiraProjectStyle>;
    templateId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryJsonUserPropertyArgs = {
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    propertyKey: Scalars["String"]["input"];
};

export type JiraQueryJwmActiveBackgroundDetailsArgs = {
    entityId: Scalars["ID"]["input"];
};

export type JiraQueryJwmAddableViewTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryJwmBackgroundUploadTokenArgs = {
    cloudId: Scalars["ID"]["input"];
    durationInSeconds: Scalars["Int"]["input"];
};

export type JiraQueryJwmCustomBackgroundsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryJwmFiltersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchParameters: JiraWorkManagementFilterSearchInput;
};

export type JiraQueryJwmFormArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    formId: Scalars["ID"]["input"];
};

export type JiraQueryJwmLicensingArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryJwmNavigationArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryJwmNavigationByProjectIdArgs = {
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryJwmNavigationByProjectKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    projectKey: Scalars["String"]["input"];
};

export type JiraQueryJwmOverviewArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryJwmOverviewsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryJwmSavedViewByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryJwmSavedViewByProjectKeyAndItemIdArgs = {
    cloudId: Scalars["ID"]["input"];
    itemId: Scalars["ID"]["input"];
    projectKey: Scalars["String"]["input"];
};

export type JiraQueryJwmSavedViewsByProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectIdOrKey: Scalars["String"]["input"];
};

export type JiraQueryJwmViewItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jql: Scalars["String"]["input"];
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryLabelsFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    sessionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraQueryLockedIssueTypeIdsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryMediaClientIdArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryMediaExternalEndpointUrlArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryNaturalLanguageToJqlArgs = {
    cloudId: Scalars["ID"]["input"];
    input: JiraNaturalLanguageToJqlInput;
};

export type JiraQueryNavigationUiStateArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryNotificationGlobalPreferenceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryNotificationProjectPreferenceArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryNotificationProjectPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
    projectIds: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryPermissionArgs = {
    cloudId: Scalars["ID"]["input"];
    type: JiraPermissionType;
};

export type JiraQueryPermissionSchemeGrantsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    permissionKey?: InputMaybe<Scalars["String"]["input"]>;
    schemeId: Scalars["ID"]["input"];
};

export type JiraQueryPlanByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryPostIncidentReviewLinksByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryProjectCleanupLogTableEntriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryProjectCleanupRecommendationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    emptyProjects?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    staleSince?: InputMaybe<JiraProjectCleanupRecommendationStaleSince>;
    statuses?: InputMaybe<
        Array<InputMaybe<JiraResourceUsageRecommendationStatus>>
    >;
};

export type JiraQueryProjectListViewTemplatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    experimentKey?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryProjectRequestTypesFromTemplateArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryProjectRoleActorLogTableEntriesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryProjectRoleActorRecommendationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    projectId?: InputMaybe<Scalars["Long"]["input"]>;
    statuses?: InputMaybe<
        Array<InputMaybe<JiraResourceUsageRecommendationStatus>>
    >;
    userStatus?: InputMaybe<JiraProjectRoleActorUserStatus>;
};

export type JiraQueryRankFieldArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryRecentBoardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRecentDashboardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRecentFiltersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRecentIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRecentItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    filter?: InputMaybe<JiraRecentItemsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    types: Array<JiraSearchableEntityType>;
};

export type JiraQueryRecentPlansArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRecentProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRecentQueuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryRemoteIssueLinksByIdArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryReportsPageArgs = {
    boardId?: InputMaybe<Scalars["ID"]["input"]>;
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryRequestTypeTemplateByIdArgs = {
    cloudId: Scalars["ID"]["input"];
    templateId: Scalars["ID"]["input"];
};

export type JiraQueryRequestTypeTemplateDefaultConfigurationDependenciesArgs = {
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryRequestTypeTemplatesArgs = {
    cloudId: Scalars["ID"]["input"];
    projectStyle?: InputMaybe<JiraProjectStyle>;
};

export type JiraQueryRequestTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectId: Scalars["ID"]["input"];
};

export type JiraQueryResourceUsageCustomFieldRecommendationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    statuses?: InputMaybe<
        Array<InputMaybe<JiraResourceUsageRecommendationStatus>>
    >;
};

export type JiraQueryResourceUsageMetricArgs = {
    cloudId: Scalars["ID"]["input"];
    metricKey: Scalars["String"]["input"];
};

export type JiraQueryResourceUsageMetricByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryResourceUsageMetricsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryResourceUsageRecommendationStatsArgs = {
    category: JiraRecommendationCategory;
    cloudId: Scalars["ID"]["input"];
};

export type JiraQuerySavedFiltersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    keyword?: InputMaybe<Scalars["String"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryScreenIdByIssueIdArgs = {
    issueId: Scalars["ID"]["input"];
};

export type JiraQueryScreenIdByIssueKeyArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    issueKey: Scalars["String"]["input"];
};

export type JiraQuerySearchUnsplashImagesArgs = {
    input: JiraUnsplashSearchInput;
};

export type JiraQuerySearchUserTeamMentionArgs = {
    cloudId: Scalars["ID"]["input"];
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    organizationId?: InputMaybe<Scalars["String"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
    sessionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryShouldShowAtlassianIntelligenceArgs = {
    atlassianIntelligenceProductFeatureInput: JiraAtlassianIntelligenceProductFeatureInput;
    cloudId: Scalars["ID"]["input"];
};

export type JiraQuerySprintByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQuerySprintSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    filter?: InputMaybe<JiraSprintFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryStartDateFieldArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryStringUserPropertyArgs = {
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    propertyKey: Scalars["String"]["input"];
};

export type JiraQuerySystemFiltersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isFavourite?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryTimeTrackingSettingsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryUiModificationsArgs = {
    context: JiraUiModificationsContextInput;
};

export type JiraQueryUserHomePageArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryUserNavigationConfigurationArgs = {
    cloudID: Scalars["ID"]["input"];
    navKey: Scalars["String"]["input"];
};

export type JiraQueryUserPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryUserSegmentationArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraQueryVersionArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryVersionByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraQueryVersionSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    filter?: InputMaybe<JiraVersionFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraQueryVersionsByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type JiraQueryVersionsForProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<Array<InputMaybe<JiraVersionStatus>>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jiraProjectId: Scalars["ID"]["input"];
    last?: InputMaybe<Scalars["Int"]["input"]>;
    releaseDateAfter?: InputMaybe<Scalars["Date"]["input"]>;
    releaseDateBefore?: InputMaybe<Scalars["Date"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    sortBy?: InputMaybe<JiraVersionSortInput>;
};

export type JiraQueryVersionsForProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<Array<InputMaybe<JiraVersionStatus>>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jiraProjectIds: Array<Scalars["ID"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    releaseDateAfter?: InputMaybe<Scalars["Date"]["input"]>;
    releaseDateBefore?: InputMaybe<Scalars["Date"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraQueryViewPermissionSchemeArgs = {
    schemeId: Scalars["ID"]["input"];
};

/** Represents the radio select field on a Jira Issue. */
export type JiraRadioSelectField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraRadioSelectField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        fieldOptions?: Maybe<JiraOptionConnection>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The option selected on the Issue or default option configured for the field. */
        selectedOption?: Maybe<JiraOption>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the radio select field on a Jira Issue. */
export type JiraRadioSelectFieldFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraRadioSelectFieldOperationInput = {
    /** Accept ARI(s): issue-field-option */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraRadioSelectFieldPayload = Payload & {
    __typename?: "JiraRadioSelectFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraRadioSelectField>;
    success: Scalars["Boolean"]["output"];
};

/** Represents a direction in the ranking of two issues. */
export enum JiraRankMutationEdge {
    Bottom = "BOTTOM",
    Top = "TOP"
}

/** Input for ranking issues against one another using a rank field. */
export type JiraRankMutationInput = {
    /** The edge the issues will be ranked in (TOP/BOTTOM) */
    edge: JiraRankMutationEdge;
    /** The list of issue ARIs to be ranked. */
    issues: Array<Scalars["ID"]["input"]>;
    /** The issue ARI of the target issue which the `issues` will be positioned against. */
    relativeToIssue: Scalars["ID"]["input"];
};

/** Payload returned when `rankIssues` responds. */
export type JiraRankMutationPayload = Payload & {
    __typename?: "JiraRankMutationPayload";
    /** All errors in any of the issues' rank operations */
    errors?: Maybe<Array<MutationError>>;
    /** Whether all issues have been successfuly ranked */
    success: Scalars["Boolean"]["output"];
};

/** Input for ranking a navigation item. Only pass one of beforeItemId or afterItemId. */
export type JiraRankNavigationItemInput = {
    /** Global identifier (ARI) of the navigation item that the navigation item being ranked will be placed after. */
    afterItemId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Global identifier (ARI) of the navigation item that the navigation item being ranked will be placed before. */
    beforeItemId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Global identifier (ARI) of the navigation item to rank. */
    id: Scalars["ID"]["input"];
    /** ARI of the scope to rank the navigation items. */
    scopeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Response for the rank navigation item mutation. */
export type JiraRankNavigationItemPayload = Payload & {
    __typename?: "JiraRankNavigationItemPayload";
    /** Current state of the container navigation for which the rank operation was performed. */
    containerNavigation?: Maybe<JiraContainerNavigationResult>;
    /** List of errors while performing the rank mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Connection of navigation items after the rank operation. */
    navigationItems?: Maybe<JiraNavigationItemConnection>;
    /** Denotes whether the rank mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** Response for the rank navigation item mutation. */
export type JiraRankNavigationItemPayloadNavigationItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for the recentItems' filter. */
export type JiraRecentItemsFilter = {
    /** Include archived projects in the result (applies to projects only, default to true) */
    includeArchivedProjects?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Filter the results by the keyword */
    keyword?: InputMaybe<Scalars["String"]["input"]>;
    /** List of Jira entity types to get, */
    types?: InputMaybe<Array<JiraSearchableEntityType>>;
};

/** Category of recommendation */
export enum JiraRecommendationCategory {
    /** Recommendation to delete a custom field */
    CustomField = "CUSTOM_FIELD",
    /** Recommendation to archive issues */
    IssueArchival = "ISSUE_ARCHIVAL",
    /** Recommendation to clean (archive or trash) the project */
    ProjectCleanup = "PROJECT_CLEANUP",
    /** Recommendation to delete a project role actor */
    ProjectRoleActor = "PROJECT_ROLE_ACTOR"
}

/** Represents a redaction in Jira */
export type JiraRedaction = {
    __typename?: "JiraRedaction";
    /** Time when the redaction was created */
    created?: Maybe<Scalars["DateTime"]["output"]>;
    /** External Redaction ID of the redacted entity. */
    externalRedactionId?: Maybe<Scalars["String"]["output"]>;
    /** Redacted field name */
    fieldName?: Maybe<Scalars["String"]["output"]>;
    /** Identifier for the redaction. */
    id: Scalars["ID"]["output"];
    /** Reason for redaction */
    reason?: Maybe<Scalars["String"]["output"]>;
    /** User who redacted the field */
    redactedBy?: Maybe<User>;
    /** Time when the redaction was last updated */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
};

/** A connection type for JiraRedaction */
export type JiraRedactionConnection = {
    __typename?: "JiraRedactionConnection";
    /** The list of edges in the connection */
    edges?: Maybe<Array<Maybe<JiraRedactionEdge>>>;
    /** Information to aid in pagination */
    pageInfo: PageInfo;
    /** Total count of redactions */
    totalCount?: Maybe<Scalars["Long"]["output"]>;
};

/** An edge in a JiraRedaction connection */
export type JiraRedactionEdge = {
    __typename?: "JiraRedactionEdge";
    /** The cursor to this edge */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge */
    node?: Maybe<JiraRedaction>;
};

/** Represents sort fields for JiraRedaction */
export enum JiraRedactionSortField {
    /** Sort by redaction created time */
    Created = "CREATED",
    /** Sort by field name */
    Field = "FIELD",
    /** Sort by redaction reason */
    Reason = "REASON",
    /** Sort by redacted by user */
    RedactedBy = "REDACTED_BY",
    /** Sort by redaction updated time */
    Updated = "UPDATED"
}

export type JiraRedactionSortInput = {
    field: JiraRedactionSortField;
    order?: SortDirection;
};

/**
 * The release notes configuration for a version describing how to display properties,
 * types and keys for an issue
 *
 * This configuration is typically saved whenever a new release note is generated on a
 * per version basis.
 */
export type JiraReleaseNotesConfiguration = {
    __typename?: "JiraReleaseNotesConfiguration";
    /**
     * The ARIs of issue fields(issue-field-meta ARI) to include when generating release notes
     *
     * This field intentionally returns an array instead of a connection as it is not meant to be paginated
     * An upper limit of 500 items can be returned from this array
     *
     * Note: An empty array indicates no issue properties should be included in the release notes generation. Summary is not a part of this as it is included in Release note by default.
     */
    issueFieldIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** The issue key config to include when generating release notes */
    issueKeyConfig?: Maybe<JiraReleaseNotesIssueKeyConfig>;
    /**
     * The ARIs of issue types(issue-type ARI) to include when generating release notes
     *
     * This field intentionally returns an array instead of a connection as it is not meant to be paginated
     * An upper limit of 200 items can be returned from this array
     *
     * Note: An empty array indicates all the issue types should be included in the release notes generation
     */
    issueTypeIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
};

/** Site information of Confluence that are connected to a particular Jira site, aka AvailableSite. */
export type JiraReleaseNotesInConfluenceAvailableSite = {
    __typename?: "JiraReleaseNotesInConfluenceAvailableSite";
    isSystem?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    siteId: Scalars["ID"]["output"];
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** The connection type for JiraReleaseNotesInConfluenceAvailableSite. */
export type JiraReleaseNotesInConfluenceAvailableSitesConnection = {
    __typename?: "JiraReleaseNotesInConfluenceAvailableSitesConnection";
    edges?: Maybe<Array<Maybe<JiraReleaseNotesInConfluenceAvailableSitesEdge>>>;
    pageInfo: PageInfo;
};

/** An edge in a JiraReleaseNotesInConfluenceAvailableSite connection. */
export type JiraReleaseNotesInConfluenceAvailableSitesEdge = {
    __typename?: "JiraReleaseNotesInConfluenceAvailableSitesEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<JiraReleaseNotesInConfluenceAvailableSite>;
};

/** Enum describing the possible states to represent issue keys when generating release notes */
export enum JiraReleaseNotesIssueKeyConfig {
    /** Include issue keys in the generated release notes as hyperlinks to their respective issue view */
    Linked = "LINKED",
    /** Exclude issue keys from the generated release notes */
    None = "NONE",
    /** Include issue keys in the generated release notes as plain text */
    Unlinked = "UNLINKED"
}

export type JiraReleases = {
    __typename?: "JiraReleases";
    /**
     * Deployment summaries that are ordered by the date at which they occured (most recent to least recent).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deployments?: Maybe<JiraReleasesDeploymentSummaryConnection>;
    /**
     * Query deployment summaries by ID.
     *
     * A maximum of 100 `deploymentIds` can be asked for at the one time.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deploymentsById?: Maybe<Array<Maybe<DeploymentSummary>>>;
    /**
     * Epic data that is filtered & ordered based on release-specific information.
     *
     * The returned epics will be ordered by the dates of the most recent deployments for
     * the issues within the epic that match the input filter. An epic containing an issue
     * that was released more recently will appear earlier in the list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    epics?: Maybe<JiraReleasesEpicConnection>;
    /**
     * Issue data that is filtered & ordered based on release-specific information.
     *
     * The returned issues will be ordered by the dates of the most recent deployments that
     * match the input filter. An issue that was released more recently will appear earlier
     * in the list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issues?: Maybe<JiraReleasesIssueConnection>;
};

export type JiraReleasesDeploymentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: JiraReleasesDeploymentFilter;
    first?: Scalars["Int"]["input"];
};

export type JiraReleasesDeploymentsByIdArgs = {
    deploymentIds: Array<Scalars["ID"]["input"]>;
};

export type JiraReleasesEpicsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: JiraReleasesEpicFilter;
    first?: Scalars["Int"]["input"];
};

export type JiraReleasesIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: JiraReleasesIssueFilter;
    first?: Scalars["Int"]["input"];
};

export type JiraReleasesDeploymentFilter = {
    /** Only deployments in these environment types will be returned. */
    environmentCategories?: InputMaybe<Array<DevOpsEnvironmentCategory>>;
    /** Only deployments in these environments will be returned. */
    environmentDisplayNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only deployments associated with these issues will be returned. */
    issueIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Only deployments associated with these services will be returned. */
    serviceIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Only deployments in this time window will be returned. */
    timeWindow: JiraReleasesTimeWindowInput;
};

export type JiraReleasesDeploymentSummaryConnection = {
    __typename?: "JiraReleasesDeploymentSummaryConnection";
    edges?: Maybe<Array<Maybe<JiraReleasesDeploymentSummaryEdge>>>;
    nodes?: Maybe<Array<Maybe<DeploymentSummary>>>;
    pageInfo: PageInfo;
};

export type JiraReleasesDeploymentSummaryEdge = {
    __typename?: "JiraReleasesDeploymentSummaryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<DeploymentSummary>;
};

export type JiraReleasesEpic = {
    __typename?: "JiraReleasesEpic";
    assignee?: Maybe<User>;
    color?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    issueKey?: Maybe<Scalars["String"]["output"]>;
    issueTypeId?: Maybe<Scalars["ID"]["output"]>;
    lastDeployed?: Maybe<Scalars["DateTime"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
};

export type JiraReleasesEpicConnection = {
    __typename?: "JiraReleasesEpicConnection";
    edges?: Maybe<Array<Maybe<JiraReleasesEpicEdge>>>;
    nodes?: Maybe<Array<Maybe<JiraReleasesEpic>>>;
    pageInfo: PageInfo;
};

export type JiraReleasesEpicEdge = {
    __typename?: "JiraReleasesEpicEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraReleasesEpic>;
};

export type JiraReleasesEpicFilter = {
    /** Only epics in this project will be returned. */
    projectId: Scalars["ID"]["input"];
    /** Determines whether epics that haven't been released should be included in the results. */
    releaseStatusFilter?: InputMaybe<JiraReleasesEpicReleaseStatusFilter>;
    /** Only epics matching this text filter will be returned. */
    text?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Used for specifying whether or not epics that haven't been released should be included
 * in the results.
 *
 * For an epic to be considered as released, at least one of the issues or subtasks within
 * it must have been released.
 */
export enum JiraReleasesEpicReleaseStatusFilter {
    /** Only epics that have been released (to any environment) will be included in the results. */
    Released = "RELEASED",
    /**
     * Epics that have been released will be returned first, followed by epics that haven't
     * yet been released.
     */
    ReleasedAndUnreleased = "RELEASED_AND_UNRELEASED"
}

export type JiraReleasesIssue = {
    __typename?: "JiraReleasesIssue";
    assignee?: Maybe<User>;
    /**
     * The epic this issue is contained within (either directly or indirectly).
     *
     * Note: If the issue and its ancestors are not within an epic, the value will be `null`.
     */
    epic?: Maybe<JiraReleasesEpic>;
    id: Scalars["ID"]["output"];
    issueKey?: Maybe<Scalars["String"]["output"]>;
    issueTypeId?: Maybe<Scalars["ID"]["output"]>;
    lastDeployed?: Maybe<Scalars["DateTime"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
};

export type JiraReleasesIssueConnection = {
    __typename?: "JiraReleasesIssueConnection";
    edges?: Maybe<Array<Maybe<JiraReleasesIssueEdge>>>;
    nodes?: Maybe<Array<Maybe<JiraReleasesIssue>>>;
    pageInfo: PageInfo;
};

export type JiraReleasesIssueEdge = {
    __typename?: "JiraReleasesIssueEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraReleasesIssue>;
};

export type JiraReleasesIssueFilter = {
    /** Only issues assigned to these users will be returned. */
    assignees?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Only issues that have been released in these environment *types* will be returned. */
    environmentCategories?: InputMaybe<
        Array<InputMaybe<DevOpsEnvironmentCategory>>
    >;
    /** Only issues that have been released in these environments will be returned. */
    environmentDisplayNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * Only issues in these epics will be returned.
     *
     * Note:
     * * If a null ID is included in the list, issues not in epics will be included in the results.
     * * If a subtask's parent issue is in one of the epics, the subtask will also be returned.
     */
    epicIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    /** Only issues with the supplied fixVersions will be returned. */
    fixVersions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Only issues of these types will be returned. */
    issueTypes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Only issues in this project will be returned. */
    projectId: Scalars["ID"]["input"];
    /** Determines whether issues that haven't been released should be included in the results. */
    releaseStatusFilter?: JiraReleasesIssueReleaseStatusFilter;
    /** Only issues matching this text filter will be returned (will match against all issue fields). */
    text?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Only issues that have been released within this time window will be returned.
     *
     * Note: Issues that have not been released within the time window will still be returned
     * if the `includeIssuesWithoutReleases` argument is `true`.
     */
    timeWindow: JiraReleasesTimeWindowInput;
};

/**
 * Used for specifying whether or not issues that haven't been released should be included
 * in the results.
 */
export enum JiraReleasesIssueReleaseStatusFilter {
    /** Only issues that have been released (to any environment) will be included in the results. */
    Released = "RELEASED",
    /**
     * Issues that have been released will be returned first, followed by issues that haven't
     * yet been released.
     */
    ReleasedAndUnreleased = "RELEASED_AND_UNRELEASED",
    /** Only issues that have *not* been released (to any environment) will be included in the results. */
    Unreleased = "UNRELEASED"
}

export type JiraReleasesTimeWindowInput = {
    after: Scalars["DateTime"]["input"];
    before: Scalars["DateTime"]["input"];
};

/**
 * Represents the remaining time estimate field on Jira issue screens and in the time tracking modal. Note that this is the same value as the remainingEstimate
 * from JiraTimeTrackingField.
 */
export type JiraRemainingTimeEstimateField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraRemainingTimeEstimateField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Original Estimate displays the amount of time originally anticipated to resolve the issue. */
        remainingEstimate?: Maybe<JiraEstimate>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input type for updating the Remaining Time Estimate field of a Jira issue. */
export type JiraRemainingTimeEstimateFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The new value to be placed in the Remaining Time Estimate field */
    remainingEstimate: JiraEstimateInput;
};

/** The payload type returned after updating the Remaining Time Estimate field of a Jira issue. */
export type JiraRemainingTimeEstimateFieldPayload = Payload & {
    __typename?: "JiraRemainingTimeEstimateFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Remaining Time Estimate field. */
    field?: Maybe<JiraRemainingTimeEstimateField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents a single Issue Remote Link containing the remote link id, application and target object. */
export type JiraRemoteIssueLink =
    | JiraConfluenceRemoteIssueLink
    | JiraCustomRemoteIssueLink
    | JiraIssueRemoteIssueLink
    | JiraWebRemoteIssueLink;

/** The input for deleting an active background */
export type JiraRemoveActiveBackgroundInput = {
    /** The entityId (ARI) of the entity to remove the active background for */
    entityId: Scalars["ID"]["input"];
};

/** The response for the jwmRemoveActiveBackground mutation */
export type JiraRemoveActiveBackgroundPayload = Payload & {
    __typename?: "JiraRemoveActiveBackgroundPayload";
    /** List of errors while performing the remove background mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the remove active background mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraRemoveCustomFieldInput = {
    /**
     * The cloudId indicates the cloud instance this mutation will be executed against.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId: Scalars["ID"]["input"];
    fieldId: Scalars["String"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraRemoveCustomFieldPayload = Payload & {
    __typename?: "JiraRemoveCustomFieldPayload";
    affectedFieldAssociationWithIssueTypesId?: Maybe<Scalars["ID"]["output"]>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** The input to remove isses from all versions */
export type JiraRemoveIssuesFromAllFixVersionsInput = {
    /** The IDs of the issues to be removed from all versions. */
    issueIds: Array<Scalars["ID"]["input"]>;
};

/** The return payload for removing a list of issues from all versions. */
export type JiraRemoveIssuesFromAllFixVersionsPayload = Payload & {
    __typename?: "JiraRemoveIssuesFromAllFixVersionsPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Result of the update to each supplied issue */
    issueUpdateResults?: Maybe<Array<JiraVersionIssueUpdateResult>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated versions. */
    versions?: Maybe<Array<JiraVersion>>;
};

/** The input to remove issues from a fix version. */
export type JiraRemoveIssuesFromFixVersionInput = {
    /** The IDs of the issues to be removed from a fix version. */
    issueIds: Array<Scalars["ID"]["input"]>;
    /** The ID of the version to remove the issues from. */
    versionId: Scalars["ID"]["input"];
};

/** The return payload of removing issues from a fix version */
export type JiraRemoveIssuesFromFixVersionPayload = Payload & {
    __typename?: "JiraRemoveIssuesFromFixVersionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** A list of issue keys that the user has selected but does not have the permission to edit */
    issuesWithMissingEditPermission?: Maybe<Array<Scalars["String"]["output"]>>;
    /** A list of issue keys that the user has selected but does not have the permission to resolve */
    issuesWithMissingResolvePermission?: Maybe<
        Array<Scalars["String"]["output"]>
    >;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated version */
    version?: Maybe<JiraVersion>;
};

/** The input type to remove bitbucket workspace(organization in Jira term) connection */
export type JiraRemoveJiraBitbucketWorkspaceConnectionInput = {
    /** The workspace id(organization in Jira term) to remove the connection */
    workspaceId: Scalars["ID"]["input"];
};

/** The response payload to remove bitbucket workspace(organization in Jira term) connection */
export type JiraRemoveJiraBitbucketWorkspaceConnectionPayload = Payload & {
    __typename?: "JiraRemoveJiraBitbucketWorkspaceConnectionPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraRemovePostIncidentReviewLinkMutationInput = {
    /**
     * The ID of the incident the PIR link will be removed from. Initially only Jira Service Management
     * incidents are supported, but eventually 3rd party / Data Depot incidents will follow.
     */
    incidentId: Scalars["ID"]["input"];
    /** The ID of the PIR link that will be removed from the incident. */
    postIncidentReviewLinkId: Scalars["ID"]["input"];
};

export type JiraRemovePostIncidentReviewLinkMutationPayload = Payload & {
    __typename?: "JiraRemovePostIncidentReviewLinkMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Input to delete a related work item and unlink it from a version. */
export type JiraRemoveRelatedWorkFromVersionInput = {
    /**
     * Client-generated ID for the related work item.
     *
     * To delete native release notes, leave this as null and pass `removeNativeReleaseNotes` instead.
     */
    relatedWorkId?: InputMaybe<Scalars["ID"]["input"]>;
    /** If true the "native release notes" related work item will be deleted. */
    removeNativeReleaseNotes?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The identifier of the Jira version. */
    versionId: Scalars["ID"]["input"];
};

/** The return payload of deleting a related work item and unlinking it from a version. */
export type JiraRemoveRelatedWorkFromVersionPayload = Payload & {
    __typename?: "JiraRemoveRelatedWorkFromVersionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input for renaming a navigation item. */
export type JiraRenameNavigationItemInput = {
    /** Global identifier (ARI) for the navigation item to rename. */
    id: Scalars["ID"]["input"];
    /** The new label for the navigation item. */
    label: Scalars["String"]["input"];
    /** ARI of the scope to rename the navigation item. */
    scopeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Response for the rename navigation item mutation. */
export type JiraRenameNavigationItemPayload = Payload & {
    __typename?: "JiraRenameNavigationItemPayload";
    /** List of errors while performing the rename mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The renamed navigation item. Null if the mutation was not successful. */
    navigationItem?: Maybe<JiraNavigationItem>;
    /** Denotes whether the rename mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** Input to reorder a column on the board view. */
export type JiraReorderBoardViewColumnInput = {
    /** Id of the column to be reordered. */
    columnId: Scalars["ID"]["input"];
    /** Position of the column relative to the relative column. */
    position: JiraReorderBoardViewColumnPosition;
    /** Id of the column to position the column relative to. */
    relativeColumnId: Scalars["ID"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to reorder a column for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the reorder column mutation. */
export type JiraReorderBoardViewColumnPayload = Payload & {
    __typename?: "JiraReorderBoardViewColumnPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while reordering a column.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Position relative to the relative column. */
export enum JiraReorderBoardViewColumnPosition {
    After = "AFTER",
    Before = "BEFORE"
}

export type JiraReplaceIssueSearchViewFieldSetsInput = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    context?: InputMaybe<JiraIssueSearchViewFieldSetsContext>;
    /** Denotes whether `before` and/or `after` nodes will be replaced inclusively. If not specified, defaults to false. */
    inclusive?: InputMaybe<Scalars["Boolean"]["input"]>;
    nodes: Array<Scalars["String"]["input"]>;
};

/** Represents a report in Jira, e.g. Burndown Chart. */
export type JiraReport = {
    __typename?: "JiraReport";
    /** Localised description of the report. */
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    /** URL to the report thumbnail image. */
    imageUrl?: Maybe<Scalars["String"]["output"]>;
    /** Key for the report, e.g. "burndown-chart". */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Localised display name of the report, e.g. "Burndown Chart". */
    name?: Maybe<Scalars["String"]["output"]>;
    /** URL to the report. */
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a grouping of reports. */
export type JiraReportCategory = {
    __typename?: "JiraReportCategory";
    id: Scalars["ID"]["output"];
    /** Name of the report category, e.g. "Agile". */
    name?: Maybe<Scalars["String"]["output"]>;
    /** List of reports in the category. */
    reports?: Maybe<Array<Maybe<JiraReport>>>;
};

export type JiraReportCategoryConnection = {
    __typename?: "JiraReportCategoryConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraReportCategoryEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraReportCategoryEdge = {
    __typename?: "JiraReportCategoryEdge";
    /** A cursor for use in pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The item at the end of the edge. */
    node?: Maybe<JiraReportCategoryNode>;
};

export type JiraReportCategoryNode = {
    __typename?: "JiraReportCategoryNode";
    id: Scalars["ID"]["output"];
    /** Name of the report category, e.g. "Agile". */
    name?: Maybe<Scalars["String"]["output"]>;
    /** List of reports in the category. */
    reports?: Maybe<JiraReportConnection>;
};

export type JiraReportCategoryNodeReportsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraReportConnection = {
    __typename?: "JiraReportConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraReportConnectionEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraReportConnectionEdge = {
    __typename?: "JiraReportConnectionEdge";
    /** A cursor for use in pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The item at the end of the edge. */
    node?: Maybe<JiraReport>;
};

/** Represents a reports page in Jira. */
export type JiraReportsPage = {
    __typename?: "JiraReportsPage";
    /** List of report categories. */
    categories?: Maybe<Array<Maybe<JiraReportCategory>>>;
};

/** Represents the resolution field of an issue. */
export type JiraResolution = Node & {
    __typename?: "JiraResolution";
    /** Resolution description. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier representing the resolution id. */
    id: Scalars["ID"]["output"];
    /** Resolution name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Resolution Id in the digital format. */
    resolutionId: Scalars["String"]["output"];
};

/** The connection type for JiraResolution. */
export type JiraResolutionConnection = {
    __typename?: "JiraResolutionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraResolutionEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraResolution connection. */
export type JiraResolutionEdge = {
    __typename?: "JiraResolutionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraResolution>;
};

/** Represents a resolution field on a Jira Issue. */
export type JiraResolutionField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraResolutionField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The resolution selected on the Issue or default resolution configured for the field. */
        resolution?: Maybe<JiraResolution>;
        /**
         * Paginated list of resolution options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        resolutions?: Maybe<JiraResolutionConnection>;
        /**
         * Paginated list of resolution options available for the field or the Issue For Transition.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraResolutionsForTransition")' query directive to the 'resolutionsForTransition' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        resolutionsForTransition?: Maybe<JiraResolutionConnection>;
        /**
         * The resolution value available for the field for Transition
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraSelectedResolutionForTransition")' query directive to the 'selectedResolutionForTransition' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        selectedResolutionForTransition?: Maybe<JiraResolution>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents a resolution field on a Jira Issue. */
export type JiraResolutionFieldResolutionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents a resolution field on a Jira Issue. */
export type JiraResolutionFieldResolutionsForTransitionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
    transitionId: Scalars["String"]["input"];
};

/** Represents a resolution field on a Jira Issue. */
export type JiraResolutionFieldSelectedResolutionForTransitionArgs = {
    transitionId: Scalars["String"]["input"];
};

/** Input type for defining the operation on the Resolution field of a Jira issue. */
export type JiraResolutionFieldOperationInput = {
    /** Accepts ARI(s): resolution */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The operation to perform on the Resolution field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating the Resolution field of a Jira issue. */
export type JiraResolutionFieldPayload = Payload & {
    __typename?: "JiraResolutionFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Resolution field. */
    field?: Maybe<JiraResolutionField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input type for resolution field */
export type JiraResolutionInput = {
    /** An identifier for the resolution field */
    resolutionId: Scalars["ID"]["input"];
};

/** Custom field recommendation. */
export type JiraResourceUsageCustomFieldRecommendation = {
    __typename?: "JiraResourceUsageCustomFieldRecommendation";
    /** Recommendation action for the custom field. */
    customFieldAction: JiraResourceUsageCustomFieldRecommendationAction;
    /**
     * Custom field description
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Eventually use custom field type
     */
    customFieldDescription?: Maybe<Scalars["String"]["output"]>;
    /**
     * Untranslated custom field name e.g. Story points
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Eventually use custom field type
     */
    customFieldName?: Maybe<Scalars["String"]["output"]>;
    /**
     * Custom field unique ID e.g. customfield_10001
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Eventually use custom field type
     */
    customFieldTarget?: Maybe<Scalars["String"]["output"]>;
    /**
     * Custom field type e.g. com.atlassian.jira.plugin.system.customfieldtypes:textfield
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Eventually use custom field type
     */
    customFieldType?: Maybe<Scalars["String"]["output"]>;
    /** Global unique identifier. ATI: resource-usage-recommendation */
    id: Scalars["ID"]["output"];
    /** Performance impact of the recommendation. Zero means no impact. One means maximum impact. */
    impact: Scalars["Float"]["output"];
    /** Id of the recommendation. Only unique per Jira instance. */
    recommendationId: Scalars["Long"]["output"];
    /** Recommendation status. */
    status: JiraResourceUsageRecommendationStatus;
};

/** Recommendation action for a custom field. */
export enum JiraResourceUsageCustomFieldRecommendationAction {
    /** This custom field can be trashed. */
    Trash = "TRASH"
}

/** Connection type for JiraResourceUsageCustomFieldRecommendation. */
export type JiraResourceUsageCustomFieldRecommendationConnection = {
    __typename?: "JiraResourceUsageCustomFieldRecommendationConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraResourceUsageCustomFieldRecommendationEdge>>>;
    /** A list of nodes in the current page. Same as edges but does not have cursors. */
    nodes?: Maybe<Array<Maybe<JiraResourceUsageCustomFieldRecommendation>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraResourceUsageCustomFieldRecommendation connection. */
export type JiraResourceUsageCustomFieldRecommendationEdge = {
    __typename?: "JiraResourceUsageCustomFieldRecommendationEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraResourceUsageCustomFieldRecommendation>;
};

/**
 * A resource usage metric is a measurement of a resource that may cause
 * performance degradation.
 */
export type JiraResourceUsageMetric = Node & {
    __typename?: "JiraResourceUsageMetric";
    /** Usage value recommended to be deleted. */
    cleanupValue?: Maybe<Scalars["Long"]["output"]>;
    /** Current value of the metric. */
    currentValue?: Maybe<Scalars["Long"]["output"]>;
    /** Globally unique identifier */
    id: Scalars["ID"]["output"];
    /** Metric key. */
    key: Scalars["String"]["output"];
    /**
     * Usage value at which this resource when exceeded may cause possible
     * performance degradation.
     */
    thresholdValue?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Retrieves the values for this metric for date range.
     *
     * If fromDate is null, it defaults to today - 365 days.
     * If toDate is null, it defaults to today.
     * If fromDate is after toDate, then an error is returned.
     */
    values?: Maybe<JiraResourceUsageMetricValueConnection>;
    /**
     * Usage value at which this resource is close to causing possible
     * performance degradation.
     */
    warningValue?: Maybe<Scalars["Long"]["output"]>;
};

/**
 * A resource usage metric is a measurement of a resource that may cause
 * performance degradation.
 */
export type JiraResourceUsageMetricValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    fromDate?: InputMaybe<Scalars["Date"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    toDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** The connection type of JiraResourceUsageMetric. */
export type JiraResourceUsageMetricConnection = {
    __typename?: "JiraResourceUsageMetricConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraResourceUsageMetricEdge>>>;
    /** A list of nodes in the current page. Same as edges but does not have cursors. */
    nodes?: Maybe<Array<Maybe<JiraResourceUsageMetric>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraResourceUsageMetric connection. */
export type JiraResourceUsageMetricEdge = {
    __typename?: "JiraResourceUsageMetricEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraResourceUsageMetric>;
};

/** The value of the metric collected at a particular date. */
export type JiraResourceUsageMetricValue = {
    __typename?: "JiraResourceUsageMetricValue";
    /** Date the value was collected. */
    date?: Maybe<Scalars["Date"]["output"]>;
    /** Collected value. */
    value?: Maybe<Scalars["Long"]["output"]>;
};

/** The connection type of JiraResourceUsageMetricValue. */
export type JiraResourceUsageMetricValueConnection = {
    __typename?: "JiraResourceUsageMetricValueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraResourceUsageMetricValueEdge>>>;
    /** A list of nodes in the current page. Same as edges but does not have cursors. */
    nodes?: Maybe<Array<Maybe<JiraResourceUsageMetricValue>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraResourceUsageMetricValue connection. */
export type JiraResourceUsageMetricValueEdge = {
    __typename?: "JiraResourceUsageMetricValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraResourceUsageMetricValue>;
};

/** Stats about the recommendations for a specific type */
export type JiraResourceUsageRecommendationStats = {
    __typename?: "JiraResourceUsageRecommendationStats";
    /** When the most recent recommendation was created */
    lastCreated?: Maybe<Scalars["DateTime"]["output"]>;
    /** When the last recommendation was executed */
    lastExecuted?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Status of the recommendation. */
export enum JiraResourceUsageRecommendationStatus {
    /** The recommendation has been archived */
    Archived = "ARCHIVED",
    /** The recommendation has been executed */
    Executed = "EXECUTED",
    /** The recommendation has been created, user hasn't been notified about it or acted on it */
    New = "NEW",
    /** The recommendation is not relevant anymore */
    Obsolete = "OBSOLETE",
    /** The recommendation has been trashed */
    Trashed = "TRASHED"
}

/** Possible states for Reviews */
export enum JiraReviewState {
    /** Review is in Require Approval state */
    Approval = "APPROVAL",
    /** Review has been closed */
    Closed = "CLOSED",
    /** Review is in Dead state */
    Dead = "DEAD",
    /** Review is in Draft state */
    Draft = "DRAFT",
    /** Review has been rejected */
    Rejected = "REJECTED",
    /** Review is in Review state */
    Review = "REVIEW",
    /** Review is in Summarize state */
    Summarize = "SUMMARIZE",
    /** Review state is unknown */
    Unknown = "UNKNOWN"
}

/** Represents the rich text format of a rich text field. */
export type JiraRichText = {
    __typename?: "JiraRichText";
    /** Text in Atlassian Document Format. */
    adfValue?: Maybe<JiraAdf>;
    /**
     * Plain text version of the text.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated `plainText` is deprecated. Please use `adfValue` for all rich text in Jira.
     */
    plainText?: Maybe<Scalars["String"]["output"]>;
    /**
     * Text in wiki format.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated `wikiValue` is deprecated. Please use `adfValue` for all rich text in Jira.
     */
    wikiValue?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a rich text field on a Jira Issue. E.g. description, environment. */
export type JiraRichTextField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraRichTextField";
        /** Configuration for richText field from user and product level config */
        adminRichTextConfig?: Maybe<JiraAdminRichTextFieldConfig>;
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Contains the information needed to add media content to the field. */
        mediaContext?: Maybe<JiraMediaContext>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Determines what editor to render.
         * E.g. default text rendering or wiki text rendering.
         */
        renderer?: Maybe<Scalars["String"]["output"]>;
        /** The rich text selected on the Issue or default rich text configured for the field. */
        richText?: Maybe<JiraRichText>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input type for rich text fields. Supports both text area and wiki text fields */
export type JiraRichTextFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Rich text input on which the action will be performed */
    richText: JiraRichTextInput;
};

export type JiraRichTextFieldOperationInput = {
    /** Accept ADF ( Atlassian Document Format) of paragraph */
    document: JiraAdfInput;
    operation: JiraSingleValueFieldOperations;
};

export type JiraRichTextFieldPayload = Payload & {
    __typename?: "JiraRichTextFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraRichTextField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type for rich text field */
export type JiraRichTextInput = {
    /** ADF based input for rich text field */
    adfValue?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Plain text input */
    wikiText?: InputMaybe<Scalars["String"]["input"]>;
};

/** The state information for a Jira right panel */
export type JiraRightPanelState = {
    __typename?: "JiraRightPanelState";
    /** A boolean which is true if the right panel is collapsed, false otherwise */
    isCollapsed?: Maybe<Scalars["Boolean"]["output"]>;
    /** A boolean which is true if the right panel is minimised, false otherwise */
    isMinimised?: Maybe<Scalars["Boolean"]["output"]>;
    /** The id of this right panel */
    panelId?: Maybe<Scalars["ID"]["output"]>;
    /** The width of the right panel */
    width?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for JiraRightPanelState. */
export type JiraRightPanelStateConnection = {
    __typename?: "JiraRightPanelStateConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraRightPanelStateEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraRightPanelState connection. */
export type JiraRightPanelStateEdge = {
    __typename?: "JiraRightPanelStateEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraRightPanelState>;
};

/** Represents a Jira ProjectRole. */
export type JiraRole = Node & {
    __typename?: "JiraRole";
    /** Description of the ProjectRole. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier of the ProjectRole. */
    id: Scalars["ID"]["output"];
    /**
     * Is true when the ProjectRole is system managed.
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraManagedPermissionScheme")' query directive to the 'isManaged' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    isManaged?: Maybe<Scalars["Boolean"]["output"]>;
    /** Name of the ProjectRole. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Id of the ProjectRole. */
    roleId: Scalars["String"]["output"];
};

/** The connection type for JiraRole. */
export type JiraRoleConnection = {
    __typename?: "JiraRoleConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraRoleEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The page infor of the current page of results. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraRoleConnection connection. */
export type JiraRoleEdge = {
    __typename?: "JiraRoleEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraRole>;
};

/** Represents a Jira Scenario */
export type JiraScenario = Node & {
    __typename?: "JiraScenario";
    /** The the scenario color */
    color?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the scenario */
    id: Scalars["ID"]["output"];
    /** The scenario id of the scenario. e.g. 1. Temporarily needed to support interoperability with REST. */
    scenarioId?: Maybe<Scalars["Long"]["output"]>;
    /** The URL string associated with a scenario within the plan in Jira. */
    scenarioUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The title of the scenario */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraScenario. */
export type JiraScenarioConnection = {
    __typename?: "JiraScenarioConnection";
    /** The data for Edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraScenarioEdge>>>;
    /** The page info of the current page of results. */
    pageInfo?: Maybe<PageInfo>;
    /** The total number of JiraScenario matching the criteria. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The edge for JiraScenario */
export type JiraScenarioEdge = {
    __typename?: "JiraScenarioEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraScenario>;
};

/** Jira Plan ScenarioIssue node. */
export type JiraScenarioIssue = JiraScenarioIssueLike &
    Node & {
        __typename?: "JiraScenarioIssue";
        /**
         * Unique identifier associated with this Issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Plan scenario data for the issue
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        planScenarioValues?: Maybe<JiraScenarioIssueValues>;
    };

/** Jira Plan ScenarioIssue node. */
export type JiraScenarioIssuePlanScenarioValuesArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraScenarioIssueLike = {
    id: Scalars["ID"]["output"];
    planScenarioValues?: Maybe<JiraScenarioIssueValues>;
};

export type JiraScenarioIssueLikePlanScenarioValuesArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The connection type for JiraScenarioIssueLike. */
export type JiraScenarioIssueLikeConnection = {
    __typename?: "JiraScenarioIssueLikeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraScenarioIssueLikeEdge>>>;
    /** Returns whether or not there were more issues available for a given issue search. */
    isCappingIssueSearchResult?: Maybe<Scalars["Boolean"]["output"]>;
    /** Extra page information for the issue navigator. */
    issueNavigatorPageInfo?: Maybe<JiraIssueNavigatorPageInfo>;
    /** Cursors to help with random access pagination. */
    pageCursors?: Maybe<JiraPageCursors>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The total number of issues for a given JQL search.
     * This number will be capped based on the server's configured limit.
     */
    totalIssueSearchResultCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for JiraScenarioIssueLike. */
export type JiraScenarioIssueLikeConnectionPageCursorsArgs = {
    maxCursors: Scalars["Int"]["input"];
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An edge in a JiraScenarioIssueLike connection. */
export type JiraScenarioIssueLikeEdge = {
    __typename?: "JiraScenarioIssueLikeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The node at the edge. */
    node?: Maybe<JiraScenarioIssueLike>;
};

/** Plan scenario data for the issue. */
export type JiraScenarioIssueValues = {
    __typename?: "JiraScenarioIssueValues";
    /** The summary for an issue */
    assigneeField?: Maybe<JiraSingleSelectUserPickerField>;
    /** The description for an issue */
    descriptionField?: Maybe<JiraRichTextField>;
    /** End Date field configured for the view. */
    endDateViewField?: Maybe<JiraIssueField>;
    /** Staged Field value for a scenario. This is currently only available in the context of a Jira Plan. */
    fieldByIdOrAlias?: Maybe<JiraIssueField>;
    /** The flag for an issue */
    flagField?: Maybe<JiraFlagField>;
    /** The goals for an issue */
    goalsField?: Maybe<JiraGoalsField>;
    /** The issueType for an issue */
    issueTypeField?: Maybe<JiraIssueTypeField>;
    /** The project for an issue */
    projectField?: Maybe<JiraProjectField>;
    /** Scenario Issue Key in the form SCEN-uuid or issueId. This is provided for backward compatibility and usage should be avoided. */
    scenarioKey?: Maybe<Scalars["ID"]["output"]>;
    /** The type of the scenario, an issue may be added, updated or deleted. */
    scenarioType?: Maybe<JiraScenarioType>;
    /** Start Date field configured for the view. */
    startDateViewField?: Maybe<JiraIssueField>;
    /** The status for an issue */
    statusField?: Maybe<JiraStatusField>;
    /** The summary for an issue */
    summaryField?: Maybe<JiraSingleLineTextField>;
};

/** Plan scenario data for the issue. */
export type JiraScenarioIssueValuesFieldByIdOrAliasArgs = {
    idOrAlias: Scalars["String"]["input"];
};

/** Types of scenarios that can be an issue. */
export enum JiraScenarioType {
    Added = "ADDED",
    Deleted = "DELETED",
    Deletedfromjira = "DELETEDFROMJIRA",
    Updated = "UPDATED"
}

export type JiraScenarioVersion = JiraScenarioVersionLike &
    Node & {
        __typename?: "JiraScenarioVersion";
        /**
         * Cross project version if the version is part of one
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        crossProjectVersion?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Plan scenario values that override the original values
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        planScenarioValues?: Maybe<JiraVersionPlanScenarioValues>;
    };

export type JiraScenarioVersionCrossProjectVersionArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraScenarioVersionPlanScenarioValuesArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraScenarioVersionLike = {
    /** Cross project version if the version is part of one */
    crossProjectVersion?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    /** Plan scenario values that override the original values */
    planScenarioValues?: Maybe<JiraVersionPlanScenarioValues>;
};

export type JiraScenarioVersionLikeCrossProjectVersionArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraScenarioVersionLikePlanScenarioValuesArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The connection type for JiraScenarioVersionLike. */
export type JiraScenarioVersionLikeConnection = {
    __typename?: "JiraScenarioVersionLikeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraScenarioVersionLikeEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraScenarioVersionLike connection. */
export type JiraScenarioVersionLikeEdge = {
    __typename?: "JiraScenarioVersionLikeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraScenarioVersionLike>;
};

/** Response for ScheduleCalendarIssue mutation. */
export type JiraScheduleCalendarIssuePayload = Payload & {
    __typename?: "JiraScheduleCalendarIssuePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated issue */
    issue?: Maybe<JiraIssue>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Response for ScheduleCalendarIssueV2 mutation. */
export type JiraScheduleCalendarIssueWithScenarioPayload = Payload & {
    __typename?: "JiraScheduleCalendarIssueWithScenarioPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated issue */
    issue?: Maybe<JiraScenarioIssueLike>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Repository information provided by data-providers. */
export type JiraScmRepository = {
    __typename?: "JiraScmRepository";
    /** URL link to the repository in scm provider. */
    entityUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Repository name. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the abstraction over list of tabs shown on the Transition modal */
export type JiraScreenTabLayout = {
    __typename?: "JiraScreenTabLayout";
    /** Fetches list of tabs using pagination params */
    items?: Maybe<JiraScreenTabLayoutItemConnection>;
};

/** Represents the abstraction over list of tabs shown on the Transition modal */
export type JiraScreenTabLayoutItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the field level details or error received */
export type JiraScreenTabLayoutField = {
    __typename?: "JiraScreenTabLayoutField";
    /**
     * Error while fetching the field.
     * Apart from any configuration or execution error, this error message will also be used if we do not support any field
     * for the transition screen yet.
     */
    error?: Maybe<QueryError>;
    /** Details of the field */
    field?: Maybe<JiraIssueField>;
};

/** Represents the contents of the tab */
export type JiraScreenTabLayoutFieldsConnection = {
    __typename?: "JiraScreenTabLayoutFieldsConnection";
    /** Ordered list of the fields for the tab */
    edges?: Maybe<Array<Maybe<JiraScreenTabLayoutFieldsEdge>>>;
    /** Metadata for the page loaded for this connection */
    pageInfo: PageInfo;
};

/** Represent the field in context of the tabs in Issue Transition modal */
export type JiraScreenTabLayoutFieldsEdge = {
    __typename?: "JiraScreenTabLayoutFieldsEdge";
    /** Pagination argument shows position of the field */
    cursor: Scalars["String"]["output"];
    /** Contains details of the field */
    node?: Maybe<JiraScreenTabLayoutField>;
};

/** Represents tab of an Issue Transition Screen */
export type JiraScreenTabLayoutItem = {
    __typename?: "JiraScreenTabLayoutItem";
    /** Represents the contents of the tab */
    fields?: Maybe<JiraScreenTabLayoutFieldsConnection>;
    /** Unique identifier for the layout item */
    id: Scalars["ID"]["output"];
    /** Represents the optional backend tab identifier */
    tabId?: Maybe<Scalars["String"]["output"]>;
    /** Title for the tab */
    title: Scalars["String"]["output"];
};

/** Represents tab of an Issue Transition Screen */
export type JiraScreenTabLayoutItemFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents list of tabs for transition modal */
export type JiraScreenTabLayoutItemConnection = {
    __typename?: "JiraScreenTabLayoutItemConnection";
    /** List of tabs */
    edges?: Maybe<Array<Maybe<JiraScreenTabLayoutItemEdge>>>;
    /** Metadata for the page */
    pageInfo: PageInfo;
};

/** Type contains information about the tab and its position */
export type JiraScreenTabLayoutItemEdge = {
    __typename?: "JiraScreenTabLayoutItemEdge";
    /** Contains the position at which the tab is present. */
    cursor: Scalars["String"]["output"];
    /** Contains information of a tab */
    node?: Maybe<JiraScreenTabLayoutItem>;
};

/** The input used to specify the search scope for the natural language to JQL conversion */
export type JiraSearchContextInput = {
    projectKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** Currently supported searchable entities in Jira. */
export type JiraSearchableEntity =
    | JiraBoard
    | JiraCustomFilter
    | JiraDashboard
    | JiraIssue
    | JiraPlan
    | JiraProject
    | JiraServiceManagementQueue
    | JiraSystemFilter;

/** The connection type for JiraSearchableEntity. */
export type JiraSearchableEntityConnection = {
    __typename?: "JiraSearchableEntityConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraSearchableEntityEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraSearchableEntityConnection connection. */
export type JiraSearchableEntityEdge = {
    __typename?: "JiraSearchableEntityEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraSearchableEntity>;
};

/** The entity types of searchable items. */
export enum JiraSearchableEntityType {
    /** A searchable board item. */
    Board = "BOARD",
    /** A searchable dashboard item. */
    Dashboard = "DASHBOARD",
    /** A searchable filter item. */
    Filter = "FILTER",
    /** An searchable issue item. */
    Issue = "ISSUE",
    /** A searchable plan item. */
    Plan = "PLAN",
    /** A searchable project item. */
    Project = "PROJECT",
    /** A searchable queue item. */
    Queue = "QUEUE"
}

/** Represents the security levels on an Issue. */
export type JiraSecurityLevel = Node & {
    __typename?: "JiraSecurityLevel";
    /** Description of the security level. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the security level. */
    id: Scalars["ID"]["output"];
    /** Name of the security level. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** identifier for the security level. */
    securityId: Scalars["String"]["output"];
};

/** The connection type for JiraSecurityLevel. */
export type JiraSecurityLevelConnection = {
    __typename?: "JiraSecurityLevelConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraSecurityLevelEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraSecurityLevel connection. */
export type JiraSecurityLevelEdge = {
    __typename?: "JiraSecurityLevelEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraSecurityLevel>;
};

/** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */
export type JiraSecurityLevelField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSecurityLevelField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Attribute for reason behind the Security level field being non editable for any issue */
        nonEditableReason?: Maybe<JiraFieldNonEditableReason>;
        /** The security level selected on the Issue or default security level configured for the field. */
        securityLevel?: Maybe<JiraSecurityLevel>;
        /**
         * Paginated list of security level options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        securityLevels?: Maybe<JiraSecurityLevelConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */
export type JiraSecurityLevelFieldSecurityLevelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for defining the operation on the Security Level field of a Jira issue. */
export type JiraSecurityLevelFieldOperationInput = {
    /** Accepts ARI(s): SecurityLevel ARI */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * The operation to perform on the Security Level field.
     * Only SET operation is supported.
     */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating the Security Level field of a Jira issue. */
export type JiraSecurityLevelFieldPayload = Payload & {
    __typename?: "JiraSecurityLevelFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Security Level field. */
    field?: Maybe<JiraSecurityLevelField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input type for security level field */
export type JiraSecurityLevelInput = {
    /** An identifier for the security level */
    securityLevelId: Scalars["ID"]["input"];
};

export type JiraSelectableValue = {
    /** Global identifier for the selectable value. */
    id: Scalars["ID"]["output"];
    /** Represents a group key where the option belongs to. */
    selectableGroupKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * Supportive visual information for the value.
     * When implemented by a user, this would be the user's avatar.
     * When implemented by a project, this would be the project avatar.
     * Priorities would use the priority icon.
     * And so on.
     */
    selectableIconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * Textual description of the value.
     * Renders either in dropdowns so users can discern between options
     * or in a form field when used as an active value for a field.
     */
    selectableLabel?: Maybe<Scalars["String"]["output"]>;
    /** Represents a group key where the option belongs to. */
    selectableUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** The connection type for JiraHasSelectableValue. */
export type JiraSelectableValueConnection = {
    __typename?: "JiraSelectableValueConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraSelectableValueEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraHasSelectableValueOptions connection. */
export type JiraSelectableValueEdge = {
    __typename?: "JiraSelectableValueEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraSelectableValue>;
};

/** Input type for selected option */
export type JiraSelectedOptionInput = {
    /** An identifier for the field */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** An identifier for the option */
    optionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JiraServer = {
    __typename?: "JiraServer";
    authUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isCurrentUserAuthenticated: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

/**
 * The representation for a server error
 * E.g. database connection exception.
 */
export type JiraServerError = {
    __typename?: "JiraServerError";
    /** Exception message. */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type JiraServersResult = {
    __typename?: "JiraServersResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<JiraServer>;
};

/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApproval = Node & {
    __typename?: "JiraServiceManagementActiveApproval";
    /**
     * Active Approval state, can it be achieved or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    approvalState?: Maybe<JiraServiceManagementApprovalState>;
    /**
     * Showing the approved transition status details
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    approvedStatus?: Maybe<JiraServiceManagementApprovalStatus>;
    /**
     * Approver principals can be a connection of users or groups that may decide on an approval.
     * The list includes undecided members.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    approverPrincipals?: Maybe<JiraServiceManagementApproverPrincipalConnection>;
    /**
     * Detailed list of the users who responded to the approval with a decision.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    approvers?: Maybe<JiraServiceManagementApproverConnection>;
    /**
     * Indicates whether the user making the request is one of the approvers and can respond to the approval (true) or not (false).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canAnswerApproval?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Configurations of the approval including the approval condition and approvers configuration.
     * There is a maximum limit of how many configurations an active approval can have.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    configurations?: Maybe<
        Array<Maybe<JiraServiceManagementApprovalConfiguration>>
    >;
    /**
     * Date the approval was created.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdDate?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * List of the users' decisions. Does not include undecided users.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    decisions?: Maybe<JiraServiceManagementDecisionConnection>;
    /**
     * Detailed list of the users who are excluded to approve the approval.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    excludedApprovers?: Maybe<JiraUserConnection>;
    /**
     * Outcome of the approval, based on the approvals provided by all approvers.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    finalDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
    /**
     * ID of the active approval.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Name of the approval being sought.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The number of approvals needed to complete.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pendingApprovalCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Status details of the approval.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<JiraServiceManagementApprovalStatus>;
};

/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalApproverPrincipalsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalApproversArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalDecisionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents an approval that is still active. */
export type JiraServiceManagementActiveApprovalExcludedApproversArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the details of an approval condition. */
export type JiraServiceManagementApprovalCondition = {
    __typename?: "JiraServiceManagementApprovalCondition";
    /** Condition type for approval. */
    type?: Maybe<Scalars["String"]["output"]>;
    /** Condition value for approval. */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the configuration details of an approval. */
export type JiraServiceManagementApprovalConfiguration = {
    __typename?: "JiraServiceManagementApprovalConfiguration";
    /**
     * Contains information about approvers configuration.
     * There is a maximum number of fields that can be set for the approvers configuration.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    approversConfigurations?: Maybe<
        Array<Maybe<JiraServiceManagementApproversConfiguration>>
    >;
    /**
     * Contains information about approval condition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    condition?: Maybe<JiraServiceManagementApprovalCondition>;
};

/** Represents the possible decisions that can be made by an approver. */
export enum JiraServiceManagementApprovalDecisionResponseType {
    /** Indicates that the decision is approved by the approver. */
    Approved = "approved",
    /** Indicates that the decision is declined by the approver. */
    Declined = "declined",
    /** Indicates that the decision is pending by the approver. */
    Pending = "pending"
}

/** Represents the Approval custom field on an Issue in a JSM project. */
export type JiraServiceManagementApprovalField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementApprovalField";
        /**
         * The active approval is used to render the approval panel that the users can interact with to approve/decline the request or update approvers.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        activeApproval?: Maybe<JiraServiceManagementActiveApproval>;
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The completed approvals are used to render the approval history section and contains records for all previous approvals for that issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use completedApprovalsConnection instead.
         */
        completedApprovals?: Maybe<
            Array<Maybe<JiraServiceManagementCompletedApproval>>
        >;
        /**
         * The completed approvals are used to render the approval history section and contains records for all previous approvals for that issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated This is no longer used in issue view hence removing to improve performance.
         */
        completedApprovalsConnection?: Maybe<JiraServiceManagementCompletedApprovalConnection>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. customfield_10001 or description.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the Approval custom field on an Issue in a JSM project. */
export type JiraServiceManagementApprovalFieldCompletedApprovalsConnectionArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        before?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        last?: InputMaybe<Scalars["Int"]["input"]>;
    };

/** Represent whether approval can be achieved or not. */
export enum JiraServiceManagementApprovalState {
    /** Indicates that approval can not be completed due to lack of approvers. */
    InsufficientApprovers = "INSUFFICIENT_APPROVERS",
    /** Indicates that approval has sufficient user to complete. */
    Ok = "OK"
}

/** Represents details of the approval status. */
export type JiraServiceManagementApprovalStatus = {
    __typename?: "JiraServiceManagementApprovalStatus";
    /**
     * Status category Id of approval.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    categoryId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Please use statusId instead.
     */
    id?: Maybe<Scalars["String"]["output"]>;
    /**
     * Status name of approval. E.g. Waiting for approval.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Status id of approval.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusId?: Maybe<Scalars["String"]["output"]>;
};

/** The user and decision that approved the approval. */
export type JiraServiceManagementApprover = {
    __typename?: "JiraServiceManagementApprover";
    /** Details of the User who is providing approval. */
    approver?: Maybe<User>;
    /** Decision made by the approver. */
    approverDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
};

/** The connection type for JiraServiceManagementApprover. */
export type JiraServiceManagementApproverConnection = {
    __typename?: "JiraServiceManagementApproverConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraServiceManagementApproverEdge>>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementApprover connection. */
export type JiraServiceManagementApproverEdge = {
    __typename?: "JiraServiceManagementApproverEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraServiceManagementApprover>;
};

/** Approver principals are either users or groups that may decide on an approval. */
export type JiraServiceManagementApproverPrincipal =
    | JiraServiceManagementGroupApproverPrincipal
    | JiraServiceManagementUserApproverPrincipal;

/** The connection type for JiraServiceManagementApproverPrincipal. */
export type JiraServiceManagementApproverPrincipalConnection = {
    __typename?: "JiraServiceManagementApproverPrincipalConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraServiceManagementApproverPrincipalEdge>>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementApproverPrincipal connection. */
export type JiraServiceManagementApproverPrincipalEdge = {
    __typename?: "JiraServiceManagementApproverPrincipalEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraServiceManagementApproverPrincipal>;
};

/** Represents the configuration details of the users providing approval. */
export type JiraServiceManagementApproversConfiguration = {
    __typename?: "JiraServiceManagementApproversConfiguration";
    /** The field's id configured for the approvers. */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /** The field's name configured for the approvers. Only set for type "field". */
    fieldName?: Maybe<Scalars["String"]["output"]>;
    /** Approvers configuration type. E.g. custom_field. */
    type?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Represents an attachment within a JiraServiceManagement project.
 * @deprecated: This type is unused as JSM Attachments has no distinct field attributes from the common type JiraAttachment
 */
export type JiraServiceManagementAttachment = JiraAttachment &
    Node & {
        __typename?: "JiraServiceManagementAttachment";
        /**
         * Identifier for the attachment.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        attachmentId: Scalars["String"]["output"];
        /**
         * User profile of the attachment author.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        author?: Maybe<User>;
        /**
         * Date the attachment was created in seconds since the epoch.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        created: Scalars["DateTime"]["output"];
        /**
         * Filename of the attachment.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fileName?: Maybe<Scalars["String"]["output"]>;
        /**
         * Size of the attachment in bytes.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fileSize?: Maybe<Scalars["Long"]["output"]>;
        /**
         * Indicates if an attachment is within a restricted parent comment.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        hasRestrictedParent?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Global identifier for the attachment
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Enclosing issue object of the current attachment.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Media Services file id of this Attachment, May be absent if the attachment has not yet been migrated to Media Services.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mediaApiFileId?: Maybe<Scalars["String"]["output"]>;
        /**
         * Contains the information needed for reading uploaded media content in jira.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraAttachmentMediaReadToken")' query directive to the 'mediaReadToken' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        mediaReadToken?: Maybe<Scalars["String"]["output"]>;
        /**
         * The mimetype (also called content type) of the attachment. This may be {@code null}.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mimeType?: Maybe<Scalars["String"]["output"]>;
        /**
         * Parent name that this attachment is contained in either issue, environment, description, comment, worklog or form
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        parent?: Maybe<JiraAttachmentParentName>;
        /**
         * If the parent for the JSM attachment is a comment, this represents the JSM visibility property associated with this comment.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated replaced by hasRestrictedParent as it supports all products
         */
        parentCommentVisibility?: Maybe<JiraServiceManagementCommentVisibility>;
        /**
         * Parent id that this attachment is contained in.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        parentId?: Maybe<Scalars["String"]["output"]>;
        /**
         * Parent name that this attachment is contained in e.g Issue, Field, Comment, Worklog.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use parent instead
         */
        parentName?: Maybe<Scalars["String"]["output"]>;
    };

/**
 * Represents an attachment within a JiraServiceManagement project.
 * @deprecated: This type is unused as JSM Attachments has no distinct field attributes from the common type JiraAttachment
 */
export type JiraServiceManagementAttachmentMediaReadTokenArgs = {
    durationInSeconds: Scalars["Int"]["input"];
    maxTokenLength: Scalars["Int"]["input"];
};

/**
 * Attachment Preview Field
 * Allows users to upload multiple file attachments.
 */
export type JiraServiceManagementAttachmentPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementAttachmentPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

export type JiraServiceManagementBulkCreateRequestTypeFromTemplateInput = {
    /** Collection of create request type input configuration */
    createRequestTypeFromTemplateInputItems: Array<JiraServiceManagementCreateRequestTypeFromTemplateInput>;
    /** Project ARI where request types will be created */
    projectId: Scalars["ID"]["input"];
};

/** Represents a comment within a JiraServiceManagement project. */
export type JiraServiceManagementComment = JiraComment &
    Node & {
        __typename?: "JiraServiceManagementComment";
        /** User profile of the original comment author. */
        author?: Maybe<User>;
        /** Indicates whether the comment author can see the request or not. */
        authorCanSeeRequest?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Paginated list of child comments on this comment.
         * Order will always be based on creation time (ascending).
         * Note - No support for focused child comments or sorting order on child comments is provided.
         */
        childComments?: Maybe<JiraCommentConnection>;
        /** Identifier for the comment. */
        commentId: Scalars["ID"]["output"];
        /** Time of comment creation. */
        created: Scalars["DateTime"]["output"];
        /** Timestamp at which the event corresponding to the comment occurred. */
        eventOccurredAt?: Maybe<Scalars["DateTime"]["output"]>;
        /** Global identifier for the comment */
        id: Scalars["ID"]["output"];
        /**
         * Property to denote if the comment is a deleted root comment. Default value is False.
         * When true, all other attributes will be null except for id, commentId, childComments and created.
         */
        isDeleted?: Maybe<Scalars["Boolean"]["output"]>;
        /** The issue to which this comment is belonged. */
        issue?: Maybe<JiraIssue>;
        /** Indicates whether the comment is hidden from Incident activity timeline or not. */
        jsdIncidentActivityViewHidden?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Either the group or the project role associated with this comment, but not both.
         * Null means the permission level is unspecified, i.e. the comment is public.
         */
        permissionLevel?: Maybe<JiraPermissionLevel>;
        /** Comment body rich text. */
        richText?: Maybe<JiraRichText>;
        /**
         * Parent ID of the child for which data is requested. This should be non-null if a child comment is requested and
         * null if a root comment is requested.
         */
        threadParentId?: Maybe<Scalars["ID"]["output"]>;
        /** User profile of the author performing the comment update. */
        updateAuthor?: Maybe<User>;
        /** Time of last comment update. */
        updated?: Maybe<Scalars["DateTime"]["output"]>;
        /** The JSM visibility property associated with this comment. */
        visibility?: Maybe<JiraServiceManagementCommentVisibility>;
        /** The browser clickable link of this comment. */
        webUrl?: Maybe<Scalars["URL"]["output"]>;
    };

/** Represents a comment within a JiraServiceManagement project. */
export type JiraServiceManagementCommentChildCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    afterTarget?: InputMaybe<Scalars["Int"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    beforeTarget?: InputMaybe<Scalars["Int"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    targetId?: InputMaybe<Scalars["String"]["input"]>;
};

/** The visibility property of a comment within a JSM project type. */
export enum JiraServiceManagementCommentVisibility {
    /** This comment will only appear in JIRA's issue view. Also called private. */
    Internal = "INTERNAL",
    /** This comment will appear in the portal, visible to all customers. Also called public. */
    VisibleToHelpseeker = "VISIBLE_TO_HELPSEEKER"
}

/** Represents an approval that is completed. */
export type JiraServiceManagementCompletedApproval = Node & {
    __typename?: "JiraServiceManagementCompletedApproval";
    /**
     * Detailed list of the users who responded to the approval.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    approvers?: Maybe<JiraServiceManagementApproverConnection>;
    /**
     * Date the approval was completed.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    completedDate?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Date the approval was created.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdDate?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * Outcome of the approval, based on the approvals provided by all approvers.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    finalDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
    /**
     * ID of the completed approval.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Name of the approval that has been provided.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Status details in which the approval is applicable.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<JiraServiceManagementApprovalStatus>;
};

/** Represents an approval that is completed. */
export type JiraServiceManagementCompletedApprovalApproversArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for JiraServiceManagementCompletedApproval. */
export type JiraServiceManagementCompletedApprovalConnection = {
    __typename?: "JiraServiceManagementCompletedApprovalConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraServiceManagementCompletedApprovalEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementCompletedApproval connection. */
export type JiraServiceManagementCompletedApprovalEdge = {
    __typename?: "JiraServiceManagementCompletedApprovalEdge";
    /**
     * The cursor to this edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     * The node at the edge.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<JiraServiceManagementCompletedApproval>;
};

/** Represent the input data for create workflow and associate it to the issue type. */
export type JiraServiceManagementCreateAndAssociateWorkflowFromTemplateInput = {
    /** The avatar id for the issue type icon. */
    avatarId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The name of the created new issue type. */
    issueTypeName?: InputMaybe<Scalars["String"]["input"]>;
    /** The project ARI workflow is created in. */
    projectId: Scalars["ID"]["input"];
    /** Template id to be used to create workflow. */
    templateId: Scalars["String"]["input"];
    /** The name of create new workflow, which should be a unique name. */
    workflowName?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents payload of create and associate workflow mutation. */
export type JiraServiceManagementCreateAndAssociateWorkflowFromTemplatePayload =
    Payload & {
        __typename?: "JiraServiceManagementCreateAndAssociateWorkflowFromTemplatePayload";
        errors?: Maybe<Array<MutationError>>;
        success: Scalars["Boolean"]["output"];
        /** Summary of the created workflow and issueType. */
        workflowAndIssueSummary?: Maybe<JiraServiceManagementWorkflowAndIssueSummary>;
    };

/**
 * #########################
 *  Input types
 * #########################
 */
export type JiraServiceManagementCreateRequestTypeCategoryInput = {
    /** Name of the Request Type Category. */
    name: Scalars["String"]["input"];
    /** Owner of the Request Type Category. */
    owner?: InputMaybe<Scalars["String"]["input"]>;
    /** Project id of the Request Type Category. */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Request types to be associated with the Request Type Category. */
    requestTypes?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Restriction of the Request Type Category. */
    restriction?: InputMaybe<JiraServiceManagementRequestTypeCategoryRestriction>;
    /** Status of the Request Type Category. */
    status?: InputMaybe<JiraServiceManagementRequestTypeCategoryStatus>;
};

export type JiraServiceManagementCreateRequestTypeFromTemplateInput = {
    /**
     * Id of the creation request/attempt, to track which requests were created and which were not, to retry only failed ones
     * Format: UUID
     */
    clientMutationId: Scalars["String"]["input"];
    /** Description of the new request type */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** Name of the new request type (that's going to be created) */
    name: Scalars["String"]["input"];
    /** Portal instructions of the new request type */
    portalInstructions?: InputMaybe<Scalars["String"]["input"]>;
    /** Practice (work category) which will be associated with the new request type */
    practice?: InputMaybe<JiraServiceManagementPractice>;
    /** Request form content of the new request type */
    requestForm: JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInput;
    /** Request type groups which will be associated with the new request type */
    requestTypeGroup?: InputMaybe<JiraServiceManagementCreateRequestTypeFromTemplateRequestTypeGroupInput>;
    /** Icon of the new request type */
    requestTypeIconInternalId?: InputMaybe<Scalars["String"]["input"]>;
    /** Workflow which will be associated with the new request type */
    workflow?: InputMaybe<JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInput>;
};

export type JiraServiceManagementCreateRequestTypeFromTemplatePayload =
    Payload & {
        __typename?: "JiraServiceManagementCreateRequestTypeFromTemplatePayload";
        /** Result per each request type */
        createRequestTypeResults: Array<JiraServiceManagementCreateRequestTypeFromTemplateResult>;
        /** The list of errors that happened before or after creation of individual request types. */
        errors?: Maybe<Array<MutationError>>;
        /** The result of whether the request is executed successfully or not. Will be false if any of request types failed to be created. */
        success: Scalars["Boolean"]["output"];
    };

/** Input for FORM_TEMPLATE_REFERENCE or REQUEST_TYPE_TEMPLATE_REFERENCE JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType. */
export type JiraServiceManagementCreateRequestTypeFromTemplateReferenceInput = {
    /** Reference of the request type template id, not ARI format */
    formTemplateInternalId: Scalars["String"]["input"];
};

export type JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInput =
    {
        /** Request form input type. */
        inputType: JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType;
        /** Input for CreateRequestTypeFromTemplateRequestFormInputType.FORM_TEMPLATE_REFERENCE . */
        templateFormReferenceInput: JiraServiceManagementCreateRequestTypeFromTemplateReferenceInput;
    };

/** This enum represents different input variation for the "request form" part of the new request type to be created. */
export enum JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType {
    /** This means the reference of the proforma form template will be sent as input. */
    FormTemplateReference = "FORM_TEMPLATE_REFERENCE",
    /** This means the reference of the jira request type template will be sent as input. */
    RequestTypeTemplateReference = "REQUEST_TYPE_TEMPLATE_REFERENCE"
}

export type JiraServiceManagementCreateRequestTypeFromTemplateRequestTypeGroupInput =
    {
        /** Collection of request type group reference */
        requestTypeGroupInternalIds: Array<Scalars["String"]["input"]>;
    };

export type JiraServiceManagementCreateRequestTypeFromTemplateResult =
    Payload & {
        __typename?: "JiraServiceManagementCreateRequestTypeFromTemplateResult";
        /**
         * Id of the creation attempt, to track which requests were created and which were not, to retry only failed ones.
         * Format: UUID
         * formTemplateInternalId is not suitable, as multiple request types can be wished to be created with the same formTemplateInternalId (especially if we add Edit form functionality). Tracking index is problematic for async tasks.
         */
        clientMutationId: Scalars["String"]["output"];
        /** The list of errors occurred during creation of a single request type */
        errors?: Maybe<Array<MutationError>>;
        /** The freshly created request type. Will be null in case of an error. */
        result?: Maybe<JiraServiceManagementRequestType>;
        /** The result of whether the request was created successfully or not. */
        success: Scalars["Boolean"]["output"];
    };

/** This enum represent different action variation for workflow. */
export enum JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction {
    /** This mean workflow will be shared with going to created request type. */
    Share = "SHARE"
}

export type JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInput = {
    /** Action to perform with input workflow. */
    action: JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction;
    /** Workflow input type. */
    inputType: JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType;
    /** Input for CreateRequestTypeFromTemplateWorkflowInputType.REFERENCE_THROUGH_ISSUE_TYPE . */
    workflowIssueTypeReferenceInput: JiraServiceManagementCreateRequestTypeFromTemplateWorkflowIssueTypeReferenceInput;
};

/** This enum represent different input variation for workflow which will be associated with the new request type to be created. */
export enum JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType {
    /** This mean use workflow that associated with given issue type */
    ReferenceThroughIssueType = "REFERENCE_THROUGH_ISSUE_TYPE"
}

/** Input for CreateRequestTypeFromTemplateWorkflowInputType.REFERENCE_THROUGH_ISSUE_TYPE . */
export type JiraServiceManagementCreateRequestTypeFromTemplateWorkflowIssueTypeReferenceInput =
    {
        /** Issue type ARI */
        workflowIssueTypeId: Scalars["ID"]["input"];
    };

/** Date Preview Field */
export type JiraServiceManagementDatePreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementDatePreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/**
 * Represents a datetime field on an Issue in a JSM project.
 * Deprecated: Please use `JiraDateTimePickerField`.
 */
export type JiraServiceManagementDateTimeField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementDateTimeField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * The datetime selected on the Issue or default datetime configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        dateTime?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Datetime Preview Field */
export type JiraServiceManagementDateTimePreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementDateTimePreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Represents the user and decision details. */
export type JiraServiceManagementDecision = {
    __typename?: "JiraServiceManagementDecision";
    /** The user providing a decision. */
    approver?: Maybe<User>;
    /** The decision made by the approver. */
    approverDecision?: Maybe<JiraServiceManagementApprovalDecisionResponseType>;
};

/** The connection type for JiraServiceManagementDecision. */
export type JiraServiceManagementDecisionConnection = {
    __typename?: "JiraServiceManagementDecisionConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraServiceManagementDecisionEdge>>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementDecision connection. */
export type JiraServiceManagementDecisionEdge = {
    __typename?: "JiraServiceManagementDecisionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraServiceManagementDecision>;
};

/** Due Date Preview Field */
export type JiraServiceManagementDueDatePreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementDueDatePreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Represents the customer or organization an entitlement belongs to. */
export type JiraServiceManagementEntitledEntity =
    | JiraServiceManagementEntitlementCustomer
    | JiraServiceManagementEntitlementOrganization;

/** Represents the entitlement on an Issue in a JSM project with CSM features enabled. */
export type JiraServiceManagementEntitlement = Node & {
    __typename?: "JiraServiceManagementEntitlement";
    /** The entity that this entitlement is for */
    entity?: Maybe<JiraServiceManagementEntitledEntity>;
    /** The ID of the entitlement */
    id: Scalars["ID"]["output"];
    /** The product that the entitlement is for */
    product?: Maybe<JiraServiceManagementProduct>;
};

/** Represents the customer an entitlement belongs to. */
export type JiraServiceManagementEntitlementCustomer = {
    __typename?: "JiraServiceManagementEntitlementCustomer";
    /** The ID of the customer */
    id: Scalars["ID"]["output"];
};

/** Represents the Entitlement field on an Issue in a JSM project with CSM features enabled */
export type JiraServiceManagementEntitlementField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementEntitlementField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The entitlement selected on the Issue */
        selectedEntitlement?: Maybe<JiraServiceManagementEntitlement>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** The payload type returned after updating the Entitlement field of a Jira issue. */
export type JiraServiceManagementEntitlementFieldPayload = Payload & {
    __typename?: "JiraServiceManagementEntitlementFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Entitlement field. */
    field?: Maybe<JiraServiceManagementEntitlementField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents the customer an entitlement belongs to. */
export type JiraServiceManagementEntitlementOrganization = {
    __typename?: "JiraServiceManagementEntitlementOrganization";
    /** The ID of the organization */
    id: Scalars["ID"]["output"];
};

/** Represents the JSM feedback rating. */
export type JiraServiceManagementFeedback = {
    __typename?: "JiraServiceManagementFeedback";
    /**
     * Represents the integer rating value available on the issue.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    rating?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains information about the approvers when approver is a group. */
export type JiraServiceManagementGroupApproverPrincipal = {
    __typename?: "JiraServiceManagementGroupApproverPrincipal";
    /** This contains the number of members that have approved a decision. */
    approvedCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A group identifier.
     * Note: Group identifiers are nullable.
     */
    groupId?: Maybe<Scalars["String"]["output"]>;
    /** This contains the number of members. */
    memberCount?: Maybe<Scalars["Int"]["output"]>;
    /** Display name for a group. */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the JSM incident. */
export type JiraServiceManagementIncident = {
    __typename?: "JiraServiceManagementIncident";
    /**
     * Indicates whether any incident is linked to the issue or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasLinkedIncidents?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Represents the Incident Linking custom field on an Issue in a JSM project.
 * Deprecated: please use `JiraBooleanField` instead.
 */
export type JiraServiceManagementIncidentLinkingField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementIncidentLinkingField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Represents the JSM incident linked to the issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        incident?: Maybe<JiraServiceManagementIncident>;
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

/** Represents the language that can be used for fields such as JSM Requested Language. */
export type JiraServiceManagementLanguage = {
    __typename?: "JiraServiceManagementLanguage";
    /**
     * A readable common name for this language.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     * A unique language code that represents the language.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    languageCode?: Maybe<Scalars["String"]["output"]>;
};

/** An enum representing possible values for Major Incident JSM field. */
export enum JiraServiceManagementMajorIncident {
    MajorIncident = "MAJOR_INCIDENT"
}

/** Represents the major incident field for an Issue in a JSM project. */
export type JiraServiceManagementMajorIncidentField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementMajorIncidentField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * The major incident selected on the Issue or default major incident configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        majorIncident?: Maybe<JiraServiceManagementMajorIncident>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** MultiCheckboxes Field */
export type JiraServiceManagementMultiCheckboxesPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementMultiCheckboxesPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        options?: Maybe<Array<Maybe<JiraServiceManagementPreviewOption>>>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/**
 * Multiselect Preview Field
 * Allows users to select more than one option from a list.
 */
export type JiraServiceManagementMultiSelectPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementMultiSelectPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        options?: Maybe<Array<Maybe<JiraServiceManagementPreviewOption>>>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Multi-service Preview Picker Field */
export type JiraServiceManagementMultiServicePickerPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementMultiServicePickerPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Multiuser Picker Field */
export type JiraServiceManagementMultiUserPickerPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementMultiUserPickerPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Deprecated type. Please use `JiraMultipleSelectUserPickerField` instead. */
export type JiraServiceManagementMultipleSelectUserPickerField =
    JiraIssueField &
        JiraIssueFieldConfiguration &
        JiraUserIssueFieldConfiguration &
        Node & {
            __typename?: "JiraServiceManagementMultipleSelectUserPickerField";
            /**
             * The field ID alias (if applicable).
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
            /**
             * Description for the field (if present).
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            description?: Maybe<Scalars["String"]["output"]>;
            /**
             * Attributes of an issue field's configuration info.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            fieldConfig?: Maybe<JiraFieldConfig>;
            /**
             * The identifier of the field. E.g. summary, customfield_10001, etc.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            fieldId: Scalars["String"]["output"];
            /**
             * available field operations for the issue field
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            fieldOperations?: Maybe<JiraFieldOperation>;
            /**
             * Unique identifier for the field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            id: Scalars["ID"]["output"];
            /**
             * Whether or not the field is editable in the issue view.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
            /**
             * Backlink to the parent issue, to aid in simple fragment design
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            issue?: Maybe<JiraIssue>;
            /**
             * Translated name for the field (if applicable).
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            name: Scalars["String"]["output"];
            /**
             * Search url to fetch all available users options for the field or the Issue.
             *
             *
             * This field is **deprecated** and will be removed in the future
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             * @deprecated Search URLs are planned to be replaced by Connections.
             */
            searchUrl?: Maybe<Scalars["String"]["output"]>;
            /**
             * The users selected on the Issue or default users configured for the field.
             *
             *
             * This field is **deprecated** and will be removed in the future
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             * @deprecated Please use selectedUsersConnection instead.
             */
            selectedUsers?: Maybe<Array<Maybe<User>>>;
            /**
             * The users selected on the Issue or default users configured for the field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            selectedUsersConnection?: Maybe<JiraUserConnection>;
            /**
             * Field type key.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            type: Scalars["String"]["output"];
            /**
             * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            userFieldConfig?: Maybe<JiraUserFieldConfig>;
            /**
             * Paginated list of user options available for the field or the Issue.
             * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
             *
             * |Authentication Category    |Callable      |
             * |:--------------------------|:-------------|
             * | SESSION | ✅ Yes |
             * | API_TOKEN | ✅ Yes |
             * | CONTAINER_TOKEN | ❌ No |
             * | FIRST_PARTY_OAUTH | ✅ Yes |
             * | THIRD_PARTY_OAUTH | ❌ No |
             * | UNAUTHENTICATED | ✅ Yes |
             *
             */
            users?: Maybe<JiraUserConnection>;
        };

/** Deprecated type. Please use `JiraMultipleSelectUserPickerField` instead. */
export type JiraServiceManagementMultipleSelectUserPickerFieldSelectedUsersConnectionArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        before?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        last?: InputMaybe<Scalars["Int"]["input"]>;
    };

/** Deprecated type. Please use `JiraMultipleSelectUserPickerField` instead. */
export type JiraServiceManagementMultipleSelectUserPickerFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents the customer organization on an Issue in a JiraServiceManagement project. */
export type JiraServiceManagementOrganization = JiraSelectableValue & {
    __typename?: "JiraServiceManagementOrganization";
    /** The organization's domain. */
    domain?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the JSM Organization. */
    id: Scalars["ID"]["output"];
    /** Globally unique id within this schema. */
    organizationId?: Maybe<Scalars["ID"]["output"]>;
    /** The organization's name. */
    organizationName?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represents a group key where the option belongs to.
     * This will return null because the option does not belong to any group.
     */
    selectableGroupKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represent a url of the icon for the option.
     * This will return null because the option does not have an icon associated with it.
     */
    selectableIconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * Textual description of the value.
     * Renders either in dropdowns so users can discern between options
     * or in a form field when used as an active value for a field.
     */
    selectableLabel?: Maybe<Scalars["String"]["output"]>;
    /**
     * Represents a url to make the option clickable.
     * This will return null since the option does not contain a URL.
     */
    selectableUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** The connection type for JiraServiceManagementOrganization. */
export type JiraServiceManagementOrganizationConnection = {
    __typename?: "JiraServiceManagementOrganizationConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraServiceManagementOrganizationEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementOrganization connection. */
export type JiraServiceManagementOrganizationEdge = {
    __typename?: "JiraServiceManagementOrganizationEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraServiceManagementOrganization>;
};

/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationField =
    JiraHasMultipleSelectedValues &
        JiraHasSelectableValueOptions &
        JiraIssueField &
        JiraIssueFieldConfiguration &
        JiraUserIssueFieldConfiguration &
        Node & {
            __typename?: "JiraServiceManagementOrganizationField";
            /** The field ID alias (if applicable). */
            aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
            /** Description for the field (if present). */
            description?: Maybe<Scalars["String"]["output"]>;
            /** Attributes of an issue field's configuration info. */
            fieldConfig?: Maybe<JiraFieldConfig>;
            /** The identifier of the field. E.g. summary, customfield_10001, etc. */
            fieldId: Scalars["String"]["output"];
            /** available field operations for the issue field */
            fieldOperations?: Maybe<JiraFieldOperation>;
            /** Unique identifier for the field. */
            id: Scalars["ID"]["output"];
            /** Whether or not the field is editable in the issue view. */
            isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
            /** Backlink to the parent issue, to aid in simple fragment design */
            issue?: Maybe<JiraIssue>;
            /** Translated name for the field (if applicable). */
            name: Scalars["String"]["output"];
            /**
             * Paginated list of organization options available for the field or the Issue.
             * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
             */
            organizations?: Maybe<JiraServiceManagementOrganizationConnection>;
            /**
             * Search url to query for all Customer orgs when user interact with field.
             *
             *
             * This field is **deprecated** and will be removed in the future
             *
             *
             * @deprecated Search URLs are planned to be replaced by Connections.
             */
            searchUrl?: Maybe<Scalars["String"]["output"]>;
            /**
             * Paginated list of JiraServiceManagementOrganizationField organizations for the field or on an Issue.
             * The server may throw an error if both a forward page (specified with `first`)
             * and a backward page (specified with `last`) are requested simultaneously.
             */
            selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
            /**
             * The organizations selected on the Issue or default organizations configured for the field.
             *
             *
             * This field is **deprecated** and will be removed in the future
             *
             *
             * @deprecated Please use selectedOrganizationsConnection instead.
             */
            selectedOrganizations?: Maybe<
                Array<Maybe<JiraServiceManagementOrganization>>
            >;
            /** The organizations selected on the Issue or default organizations configured for the field. */
            selectedOrganizationsConnection?: Maybe<JiraServiceManagementOrganizationConnection>;
            /** The JiraServiceManagementOrganizationField selected organizations on the Issue. */
            selectedValues?: Maybe<JiraSelectableValueConnection>;
            /** Field type key. */
            type: Scalars["String"]["output"];
            /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
            userFieldConfig?: Maybe<JiraUserFieldConfig>;
        };

/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationFieldOrganizationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationFieldSelectedOrganizationsConnectionArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        before?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        last?: InputMaybe<Scalars["Int"]["input"]>;
    };

/** Represents the Customer Organization field on an Issue in a JSM project. */
export type JiraServiceManagementOrganizationFieldSelectedValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * Input type for defining the operation on Jira Service Management Organization field of a Jira issue.
 * Renamed to JsmOrganizationFieldOperationInput to compatible with jira/gira prefix validation
 */
export type JiraServiceManagementOrganizationFieldOperationInput = {
    /** Accepts ARI(s): organization */
    ids: Array<Scalars["ID"]["input"]>;
    /**
     * The operations to perform on Jira Service Management Organization field.
     * SET, ADD, REMOVE operations are supported.
     */
    operation: JiraMultiValueFieldOperations;
};

/**
 * The payload type returned after updating Jira Service Management Organization field of a Jira issue.
 * Renamed to JsmOrganizationFieldPayload to compatible with jira/gira prefix validation
 */
export type JiraServiceManagementOrganizationFieldPayload = Payload & {
    __typename?: "JiraServiceManagementOrganizationFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Jira Service Management Organization field. */
    field?: Maybe<JiraServiceManagementOrganizationField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Deprecated type. Please use `JiraPeopleField` instead. */
export type JiraServiceManagementPeopleField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementPeopleField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Whether the field is configured to act as single/multi select user(s) field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isMulti?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available users options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The people selected on the Issue or default people configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use selectedUsersConnection instead.
         */
        selectedUsers?: Maybe<Array<Maybe<User>>>;
        /**
         * The users selected on the Issue or default users configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        selectedUsersConnection?: Maybe<JiraUserConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of user options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        users?: Maybe<JiraUserConnection>;
    };

/** Deprecated type. Please use `JiraPeopleField` instead. */
export type JiraServiceManagementPeopleFieldSelectedUsersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Deprecated type. Please use `JiraPeopleField` instead. */
export type JiraServiceManagementPeopleFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** People Field */
export type JiraServiceManagementPeoplePreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementPeoplePreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** ITSM project practice categorization. */
export enum JiraServiceManagementPractice {
    /** Empower the IT operations teams with richer contextual information around changes from software development tools so they can make better decisions and minimize risk. */
    ChangeManagement = "CHANGE_MANAGEMENT",
    /** Provide customer support teams with the tools they need to escalate requests to software development teams. */
    DeveloperEscalation = "DEVELOPER_ESCALATION",
    /** Bring the development and IT operations teams together to rapidly respond to, resolve, and continuously learn from incidents. */
    IncidentManagement = "INCIDENT_MANAGEMENT",
    /** Bring people and teams together to discuss the details of an incident: why it happened, what impact it had, what actions were taken to resolve it, and how the team can prevent it from happening again. */
    PostIncidentReview = "POST_INCIDENT_REVIEW",
    /** Group incidents to problems, fast-track root cause analysis, and record workarounds to minimize the impact of incidents. */
    ProblemManagement = "PROBLEM_MANAGEMENT",
    /** Manage work across teams with one platform so the employees and customers quickly get the help they need. */
    ServiceRequest = "SERVICE_REQUEST"
}

/**
 * Preview Option
 * Represents a single option in a drop-down list
 */
export type JiraServiceManagementPreviewOption = {
    __typename?: "JiraServiceManagementPreviewOption";
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the product that an entitlement is for. */
export type JiraServiceManagementProduct = Node & {
    __typename?: "JiraServiceManagementProduct";
    /** The ID of the product */
    id: Scalars["ID"]["output"];
    /** The name of the product */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JiraServiceManagementProjectNavigationMetadata = {
    __typename?: "JiraServiceManagementProjectNavigationMetadata";
    queueId: Scalars["ID"]["output"];
    queueName: Scalars["String"]["output"];
};

export type JiraServiceManagementProjectTeamType = {
    __typename?: "JiraServiceManagementProjectTeamType";
    /** Project's team type */
    teamType?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a JSM queue */
export type JiraServiceManagementQueue = Node & {
    __typename?: "JiraServiceManagementQueue";
    /** A favourite value which contains the boolean of if it is favourited and a unique ID */
    favouriteValue?: Maybe<JiraFavouriteValue>;
    /** Global identifier for the queue */
    id: Scalars["ID"]["output"];
    /** The timestamp of this queue was last viewed by the current user (reference to Unix Epoch time in ms). */
    lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
    /** The queue id of the queue. e.g. 10000. Temporarily needed to support interoperability with REST. */
    queueId?: Maybe<Scalars["Long"]["output"]>;
    /** The URL string associated with a user's queue in Jira. */
    queueUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The title of the queue */
    title?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Renderer Preview Type
 * Represents the type of editing experience to load for a multi-line text field.
 */
export enum JiraServiceManagementRendererType {
    AtlassianWikiRendererType = "ATLASSIAN_WIKI_RENDERER_TYPE",
    JiraTextRendererType = "JIRA_TEXT_RENDERER_TYPE"
}

/** Represents the Request Feedback custom field on an Issue in a JSM project. */
export type JiraServiceManagementRequestFeedbackField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementRequestFeedbackField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represents the JSM feedback rating value selected on the Issue.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        feedback?: Maybe<JiraServiceManagementFeedback>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the Request Language field on an Issue in a JSM project. */
export type JiraServiceManagementRequestLanguageField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementRequestLanguageField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * The language selected on the Issue or default language configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        language?: Maybe<JiraServiceManagementLanguage>;
        /**
         * List of languages available.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        languages?: Maybe<Array<Maybe<JiraServiceManagementLanguage>>>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Requests the request type structure on an Issue. */
export type JiraServiceManagementRequestType = Node & {
    __typename?: "JiraServiceManagementRequestType";
    /** Avatar for the request type. */
    avatar?: Maybe<JiraAvatar>;
    /** Description of the request type if applicable. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Help text for the request type. */
    helpText?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier representing the request type id. */
    id: Scalars["ID"]["output"];
    /** Issue type to which request type belongs to. */
    issueType?: Maybe<JiraIssueType>;
    /**
     * A deprecated unique identifier string for Request Types.
     * It is still necessary due to the lack of request-type-id in critical parts of JiraServiceManagement backend.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated The `key` field is deprecated. Please use the `requestTypeId` instead.
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Name of the request type. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Id of the portal that this request type belongs to. */
    portalId?: Maybe<Scalars["String"]["output"]>;
    /** Request type practice. E.g. incidents, service_request. */
    practices?: Maybe<Array<Maybe<JiraServiceManagementRequestTypePractice>>>;
    /** Identifier for the request type. */
    requestTypeId: Scalars["String"]["output"];
};

/**
 * #########################
 *  Types
 * #########################
 */
export type JiraServiceManagementRequestTypeCategory = {
    __typename?: "JiraServiceManagementRequestTypeCategory";
    /** Date and time when the Request Type Category was created. */
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Id of the Request Type Category. */
    id: Scalars["ID"]["output"];
    /** Name of the Request Type Category. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Owner of the Request Type Category. */
    owner?: Maybe<Scalars["String"]["output"]>;
    /** Project id of the Request Type Category. */
    projectId?: Maybe<Scalars["ID"]["output"]>;
    /** Request Type Category connection. */
    requestTypes?: Maybe<JiraServiceManagementRequestTypeConnection>;
    /** Restriction of the Request Type Category. */
    restriction?: Maybe<JiraServiceManagementRequestTypeCategoryRestriction>;
    /** Status of the Request Type Category. */
    status?: Maybe<JiraServiceManagementRequestTypeCategoryStatus>;
    /** Date and time when the Request Type Category was last updated. */
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/**
 * #########################
 *  Types
 * #########################
 */
export type JiraServiceManagementRequestTypeCategoryRequestTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraServiceManagementRequestTypeCategoryConnection = {
    __typename?: "JiraServiceManagementRequestTypeCategoryConnection";
    /** A list of edges in the current page containing the Request Type category and the cursor. */
    edges?: Maybe<Array<Maybe<JiraServiceManagementRequestTypeCategoryEdge>>>;
    /** A list of Request Type Categories. */
    nodes?: Maybe<Array<Maybe<JiraServiceManagementRequestTypeCategory>>>;
    /** Information to aid in pagination. */
    pageInfo: PageInfo;
};

export type JiraServiceManagementRequestTypeCategoryDefaultPayload = Payload & {
    __typename?: "JiraServiceManagementRequestTypeCategoryDefaultPayload";
    /** List of errors while performing the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Mutated Request Type Category ID. */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Indicates if the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraServiceManagementRequestTypeCategoryEdge = {
    __typename?: "JiraServiceManagementRequestTypeCategoryEdge";
    /** The cursor to the Request Type Category. */
    cursor: Scalars["String"]["output"];
    /** The node of type Request Type Category. */
    node?: Maybe<JiraServiceManagementRequestTypeCategory>;
};

/**
 * #########################
 *  Mutation responses
 * #########################
 */
export type JiraServiceManagementRequestTypeCategoryPayload = Payload & {
    __typename?: "JiraServiceManagementRequestTypeCategoryPayload";
    /** List of errors while performing the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Mutated Request Type Category. */
    requestTypeCategory?: Maybe<JiraServiceManagementRequestTypeCategoryEdge>;
    /** Indicates if the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export enum JiraServiceManagementRequestTypeCategoryRestriction {
    Open = "OPEN",
    Restricted = "RESTRICTED"
}

export enum JiraServiceManagementRequestTypeCategoryStatus {
    Active = "ACTIVE",
    Draft = "DRAFT",
    Inactive = "INACTIVE"
}

/** The connection type for JiraServiceManagementRequestType. */
export type JiraServiceManagementRequestTypeConnection = {
    __typename?: "JiraServiceManagementRequestTypeConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraServiceManagementRequestTypeEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementIssueType connection. */
export type JiraServiceManagementRequestTypeEdge = {
    __typename?: "JiraServiceManagementRequestTypeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraServiceManagementRequestType>;
};

/** Represents the request type field for an Issue in a JSM project. */
export type JiraServiceManagementRequestTypeField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementRequestTypeField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The request type selected on the Issue or default request type configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        requestType?: Maybe<JiraServiceManagementRequestType>;
        /**
         * Paginated list of request type options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        requestTypes?: Maybe<JiraServiceManagementRequestTypeConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

/** Represents the request type field for an Issue in a JSM project. */
export type JiraServiceManagementRequestTypeFieldRequestTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * Request Type Field Common
 * These are properties common to each request form field.
 */
export type JiraServiceManagementRequestTypeFieldCommon = {
    description?: Maybe<Scalars["String"]["output"]>;
    displayed?: Maybe<Scalars["Boolean"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    required?: Maybe<Scalars["Boolean"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a Jira Service Management request type created from template. */
export type JiraServiceManagementRequestTypeFromTemplate = {
    __typename?: "JiraServiceManagementRequestTypeFromTemplate";
    /** Description of the request type. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Identifier of the request type, */
    id: Scalars["ID"]["output"];
    /** Name of the request type. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Identifier of the request type template used to create the request type */
    templateId: Scalars["String"]["output"];
};

/** Defines grouping of the request types,currently only applicable for JiraServiceManagement ITSM projects. */
export type JiraServiceManagementRequestTypePractice = {
    __typename?: "JiraServiceManagementRequestTypePractice";
    /** Practice in which the request type is categorized. */
    key?: Maybe<JiraServiceManagementPractice>;
};

/**
 * Preview Request Type Field
 * A union of all the fields that might be used in a request type. Because GraphQL and
 * Typescript types are a little different, we can't use the `type` property as a
 * discriminator. Instead, we can map between the GraphQL type (__typename) and the
 * Typescript `type` property by lowercasing __typename and removing the 'PreviewField' suffix.
 * We add 'PreviewField' as a suffix to each of the field types because otherwise we end up with
 * field types called 'Date', 'Text' or 'DateTime' and 'Field' would result in existing name clashes.
 */
export type JiraServiceManagementRequestTypePreviewField =
    | JiraServiceManagementAttachmentPreviewField
    | JiraServiceManagementDatePreviewField
    | JiraServiceManagementDateTimePreviewField
    | JiraServiceManagementDueDatePreviewField
    | JiraServiceManagementMultiCheckboxesPreviewField
    | JiraServiceManagementMultiSelectPreviewField
    | JiraServiceManagementMultiServicePickerPreviewField
    | JiraServiceManagementMultiUserPickerPreviewField
    | JiraServiceManagementPeoplePreviewField
    | JiraServiceManagementSelectPreviewField
    | JiraServiceManagementTextAreaPreviewField
    | JiraServiceManagementTextPreviewField
    | JiraServiceManagementUnknownPreviewField;

/** Represents a Jira Service Management request type template structure. */
export type JiraServiceManagementRequestTypeTemplate = {
    __typename?: "JiraServiceManagementRequestTypeTemplate";
    /** OOTB Request type category/group e.g. Employee onboarding. */
    category?: Maybe<JiraServiceManagementRequestTypeTemplateOotbCategory>;
    /** Description of the request type template. E.g. Asset record. */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * Identifier representing the request type template,
     * UUID not ARI format. E.g. 9d3b11dc-530f-46f7-b0e2-8767a01c3230
     */
    formTemplateInternalId: Scalars["String"]["output"];
    /** Grouping of request type template. E.g. Human resources. */
    groups?: Maybe<Array<JiraServiceManagementRequestTypeTemplateGroup>>;
    /**
     * Human-readable identifier of the request type template.
     * It's recommended to use the formTemplateInternalId for filtering, and the key only as a reporting field to facilitate template identification.
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Name of the request type template. E.g. Asset record. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Data for rendering previews of the fields of the request type form */
    previewFieldData?: Maybe<
        Array<JiraServiceManagementRequestTypePreviewField>
    >;
    /** The url pointing to the preview image of the request type form */
    previewImageUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Default request type icon that can be used with the request type template. */
    requestTypeIcon?: Maybe<JiraServiceManagementRequestTypeTemplateRequestTypeIcon>;
    /** Default request type description to be used on the portal. */
    requestTypePortalDescription?: Maybe<Scalars["String"]["output"]>;
    /** Project styles that the request type template supports. */
    supportedProjectStyles?: Maybe<Array<JiraProjectStyle>>;
};

export type JiraServiceManagementRequestTypeTemplateDefaultConfigurationDependencies =
    {
        __typename?: "JiraServiceManagementRequestTypeTemplateDefaultConfigurationDependencies";
        /** Default request type group that can be used with the request type template. */
        requestTypeGroup?: Maybe<JiraServiceManagementRequestTypeTemplateRequestTypeGroup>;
        /** Default workflow that can be used with the request type template. */
        workflow?: Maybe<JiraServiceManagementRequestTypeTemplateWorkflow>;
    };

/** Grouping of request type template. E.g. Human resources. */
export type JiraServiceManagementRequestTypeTemplateGroup = {
    __typename?: "JiraServiceManagementRequestTypeTemplateGroup";
    /** Unique identifier of the group */
    groupKey: Scalars["String"]["output"];
    /** Name of the group */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** OOTB Request type category/group. E.g. Employee onboarding. */
export type JiraServiceManagementRequestTypeTemplateOotbCategory = {
    __typename?: "JiraServiceManagementRequestTypeTemplateOOTBCategory";
    /** Unique identifier of the RT category */
    categoryKey: Scalars["String"]["output"];
    /** Name of the group */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Represent a default request type group that can be used with the request type template. */
export type JiraServiceManagementRequestTypeTemplateRequestTypeGroup = {
    __typename?: "JiraServiceManagementRequestTypeTemplateRequestTypeGroup";
    /** Default request type group Id, not ARI format */
    requestTypeGroupInternalId: Scalars["String"]["output"];
    /** Default request type group name */
    requestTypeGroupName?: Maybe<Scalars["String"]["output"]>;
};

/** Represent a default request type icon that can be used with the request type template. */
export type JiraServiceManagementRequestTypeTemplateRequestTypeIcon = {
    __typename?: "JiraServiceManagementRequestTypeTemplateRequestTypeIcon";
    /** Default request type icon Id, not ARI format */
    requestTypeIconInternalId: Scalars["String"]["output"];
};

/** Represent a default workflow and it's target issue type that can be used with the request type template. */
export type JiraServiceManagementRequestTypeTemplateWorkflow = {
    __typename?: "JiraServiceManagementRequestTypeTemplateWorkflow";
    /** Default workflow ARI */
    workflowId: Scalars["ID"]["output"];
    /** Default workflow's associated issue type ARI */
    workflowIssueTypeId?: Maybe<Scalars["ID"]["output"]>;
    /** Default workflow's associated issue type ARI */
    workflowIssueTypeName?: Maybe<Scalars["String"]["output"]>;
    /** Default workflow name */
    workflowName?: Maybe<Scalars["String"]["output"]>;
};

/** Responder field of a JSM issue, can be either a user or a team. */
export type JiraServiceManagementResponder =
    | JiraServiceManagementTeamResponder
    | JiraServiceManagementUserResponder;

/** The connection type for JiraServiceManagementResponder. */
export type JiraServiceManagementResponderConnection = {
    __typename?: "JiraServiceManagementResponderConnection";
    /**
     * A list of edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraServiceManagementResponderEdge>>>;
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<QueryError>>;
    /**
     * Information about the current page. Used to aid in pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total count of items in the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraServiceManagementResponder connection. */
export type JiraServiceManagementResponderEdge = {
    __typename?: "JiraServiceManagementResponderEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraServiceManagementResponder>;
};

/** Represents the responders entity custom field on an Issue in a JSM project. */
export type JiraServiceManagementRespondersField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementRespondersField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Represents the list of responders.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use respondersConnection instead.
         */
        responders?: Maybe<Array<Maybe<JiraServiceManagementResponder>>>;
        /**
         * Represents the list of responders.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        respondersConnection?: Maybe<JiraServiceManagementResponderConnection>;
        /**
         * Search URL to query for all responders available for the user to choose from when interacting with the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

/** Represents the responders entity custom field on an Issue in a JSM project. */
export type JiraServiceManagementRespondersFieldRespondersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Select Preview Field */
export type JiraServiceManagementSelectPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementSelectPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        options?: Maybe<Array<Maybe<JiraServiceManagementPreviewOption>>>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Represents the sentiment of an Issue in JSM. */
export type JiraServiceManagementSentiment = {
    __typename?: "JiraServiceManagementSentiment";
    /** The name of the sentiment */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the sentiment */
    sentimentId?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the Sentiment field on an Issue in a JSM project */
export type JiraServiceManagementSentimentField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraServiceManagementSentimentField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The sentiment of the Issue */
        sentiment?: Maybe<JiraServiceManagementSentiment>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** The payload type returned after updating the Sentiment field of a Jira issue. */
export type JiraServiceManagementSentimentFieldPayload = Payload & {
    __typename?: "JiraServiceManagementSentimentFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Sentiment field. */
    field?: Maybe<JiraServiceManagementSentimentField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** An Opsgenie team as a responder */
export type JiraServiceManagementTeamResponder = {
    __typename?: "JiraServiceManagementTeamResponder";
    /**
     * Opsgenie team id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    teamId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Opsgenie team name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    teamName?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Textarea Preview Field
 *
 * rendererType should be one of the following: 'atlassian-wiki-renderer' or 'jira-text-renderer'
 */
export type JiraServiceManagementTextAreaPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementTextAreaPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        rendererType?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Text Preview Field */
export type JiraServiceManagementTextPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementTextPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Unknown Preview Field */
export type JiraServiceManagementUnknownPreviewField =
    JiraServiceManagementRequestTypeFieldCommon & {
        __typename?: "JiraServiceManagementUnknownPreviewField";
        description?: Maybe<Scalars["String"]["output"]>;
        displayed?: Maybe<Scalars["Boolean"]["output"]>;
        label?: Maybe<Scalars["String"]["output"]>;
        required?: Maybe<Scalars["Boolean"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Input type for updating the Entitlement field of the Jira issue. */
export type JiraServiceManagementUpdateEntitlementFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Entitlement field. */
    operation?: InputMaybe<JiraServiceManagementUpdateEntitlementOperationInput>;
};

/** Input type for defining the operation on the Entitlement field of a Jira issue. */
export type JiraServiceManagementUpdateEntitlementOperationInput = {
    /** UUID value of the selected entitlement. */
    entitlementId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Only SET operation is supported. */
    operation: JiraSingleValueFieldOperations;
};

/**
 * Input type for updating the Jira Service Management Organization field of a Jira issue.
 * Renamed to JsmUpdateOrganizationFieldInput to compatible with jira/gira prefix validation
 */
export type JiraServiceManagementUpdateOrganizationFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on Jira Service Management Organization field. */
    operations: Array<JiraServiceManagementOrganizationFieldOperationInput>;
};

export type JiraServiceManagementUpdateRequestTypeCategoryInput = {
    /** Id of the Request Type Category. */
    id: Scalars["ID"]["input"];
    /** Name of the Request Type Category. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Owner of the Request Type Category. */
    owner?: InputMaybe<Scalars["String"]["input"]>;
    /** Restriction of the Request Type Category. */
    restriction?: InputMaybe<JiraServiceManagementRequestTypeCategoryRestriction>;
    /** Status of the Request Type Category. */
    status?: InputMaybe<JiraServiceManagementRequestTypeCategoryStatus>;
};

/** Input type for updating the Sentiment field of the Jira issue. */
export type JiraServiceManagementUpdateSentimentFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Sentiment field. */
    operation?: InputMaybe<JiraServiceManagementUpdateSentimentOperationInput>;
};

/** Input type for defining the operation on the Sentiment field of a Jira issue. */
export type JiraServiceManagementUpdateSentimentOperationInput = {
    /** Only SET operation is supported. */
    operation: JiraSingleValueFieldOperations;
    /** ID value of the selected sentiment. */
    sentimentId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Contains information about the approvers when approver is a user. */
export type JiraServiceManagementUserApproverPrincipal = {
    __typename?: "JiraServiceManagementUserApproverPrincipal";
    /** URL for the principal. */
    jiraRest?: Maybe<Scalars["URL"]["output"]>;
    /** A approver principal who's a user type */
    user?: Maybe<User>;
};

/** A user as a responder */
export type JiraServiceManagementUserResponder = {
    __typename?: "JiraServiceManagementUserResponder";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    user?: Maybe<User>;
};

/** Represents payload field of workflow and issue type summary for create and associate workflow mutation. */
export type JiraServiceManagementWorkflowAndIssueSummary = {
    __typename?: "JiraServiceManagementWorkflowAndIssueSummary";
    /** The id of the created issue type. */
    issueTypeId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the created issue type. */
    issueTypeName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the created workflow. */
    workflowId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the created workflow. */
    workflowName?: Maybe<Scalars["String"]["output"]>;
};

/** Grouping of workflow template. E.g. Human resources. */
export type JiraServiceManagementWorkflowTemplateGroup = {
    __typename?: "JiraServiceManagementWorkflowTemplateGroup";
    /** Unique identifier of the group */
    groupKey: Scalars["String"]["output"];
    /** Name of the group */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Represents all the metadata about a Workflow Template. */
export type JiraServiceManagementWorkflowTemplateMetadata = {
    __typename?: "JiraServiceManagementWorkflowTemplateMetadata";
    /** Name to be used as default name while creating the issueType */
    defaultIssueTypeName?: Maybe<Scalars["String"]["output"]>;
    /** Name to be used as default name while creating the workflow */
    defaultWorkflowName?: Maybe<Scalars["String"]["output"]>;
    /** Description of the template. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** List of categories to group and search the templates */
    groups?: Maybe<Array<Maybe<JiraServiceManagementWorkflowTemplateGroup>>>;
    /** Name of the template. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Array of tags used to group and search the templates */
    tags?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Identifier for the template - this will later be replaced by just `id` field, with ARI format value. */
    templateId?: Maybe<Scalars["String"]["output"]>;
    /** URL to the image to be used as thumbnail for previewing this workflow template. */
    thumbnail?: Maybe<Scalars["String"]["output"]>;
    /** Workflow template data in json form for workflow preview generation. */
    workflowTemplateJsonData?: Maybe<Scalars["JSON"]["output"]>;
};

/** Connection type containing Workflow Templates Metadata. */
export type JiraServiceManagementWorkflowTemplatesMetadataConnection = {
    __typename?: "JiraServiceManagementWorkflowTemplatesMetadataConnection";
    /**
     * List of objects, each containing a workflow template metadata object and
     * a String cursor pointing to that workflow template metadata object.
     */
    edges?: Maybe<
        Array<Maybe<JiraServiceManagementWorkflowTemplatesMetadataEdge>>
    >;
    /** A list of workflow template metdata objects returned in this response. */
    nodes?: Maybe<Array<Maybe<JiraServiceManagementWorkflowTemplateMetadata>>>;
    /**
     * The PageInfo object per Graphql Connections specification.
     * Has the non-null boolean fields `hasPreviousPage` and `hasNextPage`,
     * and nullable String fields `startCursor` and `endCursor`.
     */
    pageInfo: PageInfo;
};

/**
 * Represents metadata for a workflow template,
 * along with the String cursor for that entry in paginated response.
 */
export type JiraServiceManagementWorkflowTemplatesMetadataEdge = {
    __typename?: "JiraServiceManagementWorkflowTemplatesMetadataEdge";
    /** A pointer to this particular workflow template metadata object in the edges list. */
    cursor: Scalars["String"]["output"];
    /** Contains all the metadata about a Workflow Template. */
    node?: Maybe<JiraServiceManagementWorkflowTemplateMetadata>;
};

export type JiraSetApplicationPropertiesPayload = Payload & {
    __typename?: "JiraSetApplicationPropertiesPayload";
    /** A list of application properties which were successfully updated */
    applicationProperties: Array<JiraApplicationProperty>;
    /** A list of errors which encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /**
     * True if the mutation was successfully applied. False if the mutation was either partially successful or if the
     * mutation failed completely.
     */
    success: Scalars["Boolean"]["output"];
};

/** The key of the property you want to update, and the new value you want to set it to */
export type JiraSetApplicationPropertyInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

/** Input to select or deselect a card field within the board view. */
export type JiraSetBoardViewCardFieldSelectedInput = {
    /** FieldId of the card field within the board view to select or deselect. */
    fieldId: Scalars["String"]["input"];
    /** Whether the board view card field is selected. */
    selected: Scalars["Boolean"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to manipulate. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set board view card field selected mutation. */
export type JiraSetBoardViewCardFieldSelectedPayload = Payload & {
    __typename?: "JiraSetBoardViewCardFieldSelectedPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while selecting or deselecting the board view card field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input to enable or disable a card option within a board view. */
export type JiraSetBoardViewCardOptionStateInput = {
    /** Whether the board view card option is enabled or not. */
    enabled: Scalars["Boolean"]["input"];
    /** ID of the card option to enable or disable within a board view. */
    id: Scalars["ID"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to set the card option state for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set board view card option state mutation. */
export type JiraSetBoardViewCardOptionStatePayload = Payload & {
    __typename?: "JiraSetBoardViewCardOptionStatePayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors for when the mutation is not successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input to collapse or expand a column within the board view. */
export type JiraSetBoardViewColumnStateInput = {
    /** Whether the board view column is collapsed. */
    collapsed: Scalars["Boolean"]["input"];
    /** Id of the column within the board view to collapse or expand. */
    columnId: Scalars["ID"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to manipulate. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set board view column state mutation. */
export type JiraSetBoardViewColumnStatePayload = Payload & {
    __typename?: "JiraSetBoardViewColumnStatePayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while expanding or collapsing the board view column.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input to set the order of columns on the board view. */
export type JiraSetBoardViewColumnsOrderInput = {
    /**
     * Ordered list of column IDs. Column IDs is the value returned by `JiraBoardViewColumn.id`.
     * Up to a max of 100 IDs will be accepted. Beyond that, the list will be truncated.
     */
    columnIds: Array<Scalars["ID"]["input"]>;
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to set the columns order for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set column order mutation. */
export type JiraSetBoardViewColumnsOrderPayload = Payload & {
    __typename?: "JiraSetBoardViewColumnsOrderPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while setting the columns order.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input to set the number of days after which completed issues are removed from the board view. */
export type JiraSetBoardViewCompletedIssueSearchCutOffInput = {
    /** The number of days after which completed issues are to be removed from the board view. */
    completedIssueSearchCutOffInDays: Scalars["Int"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to set the completed issue search cut off for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set completed issue search cut off mutation. */
export type JiraSetBoardViewCompletedIssueSearchCutOffPayload = Payload & {
    __typename?: "JiraSetBoardViewCompletedIssueSearchCutOffPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while setting the completed issue search cut off.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input to set the filter of a board view. */
export type JiraSetBoardViewFilterInput = {
    /** The JQL query to filter work items on the view by. */
    jql: Scalars["String"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the view to set the filter for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set filter mutation. */
export type JiraSetBoardViewFilterPayload = Payload & {
    __typename?: "JiraSetBoardViewFilterPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while setting the filter.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field 'boardView' instead.
     */
    view?: Maybe<JiraBoardView>;
};

/** Input to set the group by field of a board view. */
export type JiraSetBoardViewGroupByInput = {
    /** The field id to group work items on the view by. */
    fieldId: Scalars["String"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the view to set the group by field for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set group by field mutation. */
export type JiraSetBoardViewGroupByPayload = Payload & {
    __typename?: "JiraSetBoardViewGroupByPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while setting the group by field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use field 'boardView' instead.
     */
    view?: Maybe<JiraBoardView>;
};

/** Input to set the selected workflow for the board view. */
export type JiraSetBoardViewWorkflowSelectedInput = {
    /** The selected workflow ID. This is the workflow entity ID, not an ARI. */
    selectedWorkflowId: Scalars["ID"]["input"];
    /** Input for settings applied to the board view. */
    settings?: InputMaybe<JiraBoardViewSettings>;
    /** ARI of the board view to set the selected workflow for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set board view workflow selected mutation. */
export type JiraSetBoardViewWorkflowSelectedPayload = Payload & {
    __typename?: "JiraSetBoardViewWorkflowSelectedPayload";
    /**
     * The current board view, regardless of whether the mutation succeeds or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardView?: Maybe<JiraBoardView>;
    /**
     * List of errors while setting the selected workflow.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input for setting a navigation item as default. */
export type JiraSetDefaultNavigationItemInput = {
    /** Global identifier (ARI) for the navigation item to set as default. */
    id: Scalars["ID"]["input"];
    /** ARI of the scope to set the navigation item as default. */
    scopeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Response for the set default navigation item mutation. */
export type JiraSetDefaultNavigationItemPayload = Payload & {
    __typename?: "JiraSetDefaultNavigationItemPayload";
    /** List of errors while performing the set default mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The new default navigation item. Null if the mutation was not successful. */
    newDefault?: Maybe<JiraNavigationItem>;
    /** The previous default navigation item. Null if the mutation was not successful. */
    previousDefault?: Maybe<JiraNavigationItem>;
    /** Denotes whether the set default mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

export type JiraSetFieldAssociationWithIssueTypesInput = {
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId: Scalars["ID"]["input"];
    /** Unique identifier of the field. */
    fieldId: Scalars["ID"]["input"];
    /** List of issue type ids to be removed from the field */
    issueTypeIdsToRemove: Array<Scalars["ID"]["input"]>;
    /** List of issue type ids to be associated with the field */
    issueTypeIdsToUpsert: Array<Scalars["ID"]["input"]>;
    /** Unique identifier of the project. */
    projectId: Scalars["ID"]["input"];
};

export type JiraSetFieldAssociationWithIssueTypesPayload = Payload & {
    __typename?: "JiraSetFieldAssociationWithIssueTypesPayload";
    /** Unused - a list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** This is to fetch the field association based on the given field */
    fieldAssociationWithIssueTypes?: Maybe<JiraFieldAssociationWithIssueTypes>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** The isFavourite of the entityId of type entityType you want to update, and the new value you want to set it to */
export type JiraSetIsFavouriteInput = {
    /**
     * ARI of the entity the ordered before the position the selectedEntity is being moved to. beforeEntity can be null when
     * there is no before entity (i.e. favourite is ordered at the end of the list) or the favourite is being removed.
     */
    beforeEntityId?: InputMaybe<Scalars["ID"]["input"]>;
    /** ARI of the Atlassian entity to be modified */
    entityId: Scalars["ID"]["input"];
    /** The new value to set */
    isFavourite: Scalars["Boolean"]["input"];
};

/** Response for the set entity isFavourite mutation. */
export type JiraSetIsFavouritePayload = Payload & {
    __typename?: "JiraSetIsFavouritePayload";
    /** A list of errors which encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** Details of the entity which has been modified. */
    favouriteValue?: Maybe<JiraFavouriteValue>;
    /** True if the mutation was successfully applied. False if the mutation failed completely. */
    success: Scalars["Boolean"]["output"];
};

/** Payload returned when updating the most recent board */
export type JiraSetMostRecentlyViewedBoardPayload = Payload & {
    __typename?: "JiraSetMostRecentlyViewedBoardPayload";
    /** The jira board marked as most recently viewed. Null if mutation was not successful. */
    board?: Maybe<JiraBoard>;
    /** List of errors while performing the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** The input type for settings deployment apps property of a JSW project. */
export type JiraSetProjectSelectedDeploymentAppsPropertyInput = {
    /** Deployment apps to set */
    deploymentApps?: InputMaybe<Array<JiraDeploymentAppInput>>;
    /** ARI of the project to set the property on */
    projectId: Scalars["ID"]["input"];
};

/** The response payload for settings deployment apps property of a JSW project. */
export type JiraSetProjectSelectedDeploymentAppsPropertyPayload = Payload & {
    __typename?: "JiraSetProjectSelectedDeploymentAppsPropertyPayload";
    /** Deployment apps has been stored successfully. */
    deploymentApps?: Maybe<Array<JiraDeploymentApp>>;
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input to set the filter for a Jira View. */
export type JiraSetViewFilterInput = {
    /** The JQL query to filter work items on the view by. */
    jql: Scalars["String"]["input"];
    /** ARI of the view to set the filter for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set filter mutation. */
export type JiraSetViewFilterPayload = Payload & {
    __typename?: "JiraSetViewFilterPayload";
    /**
     * List of errors while setting the filter.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     * The mutated view if the mutation was successful, otherwise null.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    view?: Maybe<JiraView>;
};

/** Input to set the group by field for a Jira View. */
export type JiraSetViewGroupByInput = {
    /** The field id to group work items on the view by. */
    fieldId: Scalars["String"]["input"];
    /** ARI of the view to set the group by field for. */
    viewId: Scalars["ID"]["input"];
};

/** Response for the set group by field mutation. */
export type JiraSetViewGroupByPayload = Payload & {
    __typename?: "JiraSetViewGroupByPayload";
    /**
     * List of errors while setting the group by field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Denotes whether the mutation was successful.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     * The mutated view if the mutation was successful, otherwise null.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    view?: Maybe<JiraView>;
};

/** ANONYMOUS_ACCESS grant type. */
export type JiraShareableEntityAnonymousAccessGrant = {
    __typename?: "JiraShareableEntityAnonymousAccessGrant";
    /** 'ANONYMOUS_ACCESS' type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
};

/**
 * Input for when the shareable entity is intended to be shared with all users on a Jira instance
 * and anonymous users.
 */
export type JiraShareableEntityAnonymousAccessGrantInput = {
    /** JiraShareableEntityGrant ARI. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** ANY_LOGGEDIN_USER_APPLICATION_ROLE grant type. */
export type JiraShareableEntityAnyLoggedInUserGrant = {
    __typename?: "JiraShareableEntityAnyLoggedInUserGrant";
    /** 'ANY_LOGGEDIN_USER_APPLICATION_ROLE' type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
};

/**
 * Input for when the shareable entity is intended to be shared with all users on a Jira instance
 * and NOT anonymous users.
 */
export type JiraShareableEntityAnyLoggedInUserGrantInput = {
    /** JiraShareableEntityGrant ARI. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Union of grant types to edit entities. */
export type JiraShareableEntityEditGrant =
    | JiraShareableEntityGroupGrant
    | JiraShareableEntityProjectGrant
    | JiraShareableEntityProjectRoleGrant
    | JiraShareableEntityUnknownProjectGrant
    | JiraShareableEntityUserGrant;

/** Represents a connection of edit permissions for a shared entity. */
export type JiraShareableEntityEditGrantConnection = {
    __typename?: "JiraShareableEntityEditGrantConnection";
    /**
     * The data for the edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraShareableEntityEditGrantEdge>>>;
    /**
     * The page info of the current page of results.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

/** Represents an edit permission edge for a shared entity. */
export type JiraShareableEntityEditGrantEdge = {
    __typename?: "JiraShareableEntityEditGrantEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the the edge. */
    node?: Maybe<JiraShareableEntityEditGrant>;
};

/** Input type for JiraShareableEntityEditGrants. */
export type JiraShareableEntityEditGrantInput = {
    /** User group that will be granted permission. */
    group?: InputMaybe<JiraShareableEntityGroupGrantInput>;
    /** Members of the specifid project will be granted permission. */
    project?: InputMaybe<JiraShareableEntityProjectGrantInput>;
    /** Users with the specified role in the project will be granted permission. */
    projectRole?: InputMaybe<JiraShareableEntityProjectRoleGrantInput>;
    /** User that will be granted permission. */
    user?: InputMaybe<JiraShareableEntityUserGrantInput>;
};

/** The grant types to share or edit ShareableEntities. */
export enum JiraShareableEntityGrant {
    /** The anonymous access represents the public access without logging in. */
    AnonymousAccess = "ANONYMOUS_ACCESS",
    /** Any user who has the product access. */
    AnyLoggedinUserApplicationRole = "ANY_LOGGEDIN_USER_APPLICATION_ROLE",
    /**
     * A group is a collection of users who can be given access together.
     * It represents group in the organization's user base.
     */
    Group = "GROUP",
    /** A project or a role that user can play in a project. */
    Project = "PROJECT",
    /** A project or a role that user can play in a project. */
    ProjectRole = "PROJECT_ROLE",
    /**
     * Indicates that the user does not have access to the project
     * the members of which have been granted permission.
     */
    ProjectUnknown = "PROJECT_UNKNOWN",
    /** An individual user who can be given the access to work on one or more projects. */
    User = "USER"
}

/** GROUP grant type. */
export type JiraShareableEntityGroupGrant = {
    __typename?: "JiraShareableEntityGroupGrant";
    /** Jira Group, members of which will be granted permission. */
    group?: Maybe<JiraGroup>;
    /** 'GROUP' type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
};

/** Input for the group that will be granted permission. */
export type JiraShareableEntityGroupGrantInput = {
    /** ID of the user group */
    groupId: Scalars["ID"]["input"];
    /** JiraShareableEntityGrant ARI. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** PROJECT grant type. */
export type JiraShareableEntityProjectGrant = {
    __typename?: "JiraShareableEntityProjectGrant";
    /** Jira Project, members of which will have the permission. */
    project?: Maybe<JiraProject>;
    /** 'PROJECT_ROLE' type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
};

/** Input for the project ID, members of which will be granted permission. */
export type JiraShareableEntityProjectGrantInput = {
    /** JiraShareableEntityGrant ARI. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** ARI of the project in the format `ari:cloud:jira:{siteId}:project/{projectId}`. */
    projectId: Scalars["ID"]["input"];
};

/** PROJECT_ROLE grant type. */
export type JiraShareableEntityProjectRoleGrant = {
    __typename?: "JiraShareableEntityProjectRoleGrant";
    /** Jira Project, members of which will have the permission. */
    project?: Maybe<JiraProject>;
    /**
     * Users with the specified Jira Project Role in the Jira Project will have have the permission.
     * If no role is specified then all members of the project have the permisison.
     */
    role?: Maybe<JiraRole>;
    /** 'PROJECT_ROLE' type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
};

/**
 * Input for the id of the role.
 * Users with the specified role will be granted permission.
 */
export type JiraShareableEntityProjectRoleGrantInput = {
    /** JiraShareableEntityGrant ARI. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** ARI of the project in the format `ari:cloud:jira:{siteId}:project/{projectId}`. */
    projectId: Scalars["ID"]["input"];
    /** Tenant local roleId. */
    projectRoleId: Scalars["Int"]["input"];
};

/** Union of grant types to share entities. */
export type JiraShareableEntityShareGrant =
    | JiraShareableEntityAnonymousAccessGrant
    | JiraShareableEntityAnyLoggedInUserGrant
    | JiraShareableEntityGroupGrant
    | JiraShareableEntityProjectGrant
    | JiraShareableEntityProjectRoleGrant
    | JiraShareableEntityUnknownProjectGrant
    | JiraShareableEntityUserGrant;

/** Represents a connection of share permissions for a shared entity. */
export type JiraShareableEntityShareGrantConnection = {
    __typename?: "JiraShareableEntityShareGrantConnection";
    /**
     * The data for the edges in the current page.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<JiraShareableEntityShareGrantEdge>>>;
    /**
     * The page info of the current page of results.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

/** Represents a share permission edge for a shared entity. */
export type JiraShareableEntityShareGrantEdge = {
    __typename?: "JiraShareableEntityShareGrantEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the the edge. */
    node?: Maybe<JiraShareableEntityShareGrant>;
};

/** Input type for JiraShareableEntityShareGrants. */
export type JiraShareableEntityShareGrantInput = {
    /** All users with access to the instance and anonymous users will be granted permission. */
    anonymousAccess?: InputMaybe<JiraShareableEntityAnonymousAccessGrantInput>;
    /** All users with access to the instance will be granted permission. */
    anyLoggedInUser?: InputMaybe<JiraShareableEntityAnyLoggedInUserGrantInput>;
    /** User group that will be granted permission. */
    group?: InputMaybe<JiraShareableEntityGroupGrantInput>;
    /** Members of the specified project will be granted permission. */
    project?: InputMaybe<JiraShareableEntityProjectGrantInput>;
    /** Users with the specified role in the project will be granted permission. */
    projectRole?: InputMaybe<JiraShareableEntityProjectRoleGrantInput>;
    /** User that will be granted permission. */
    user?: InputMaybe<JiraShareableEntityUserGrantInput>;
};

/** PROJECT_UNKNOWN grant type */
export type JiraShareableEntityUnknownProjectGrant = {
    __typename?: "JiraShareableEntityUnknownProjectGrant";
    /** PROJECT_UNKNOWN grant type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
};

/** USER grant type */
export type JiraShareableEntityUserGrant = {
    __typename?: "JiraShareableEntityUserGrant";
    /** 'USER' grant type of Jira ShareableEntity Grant Types. */
    type?: Maybe<JiraShareableEntityGrant>;
    /** User that is granted the permission */
    user?: Maybe<User>;
};

/** Input for user that will be granted permission. */
export type JiraShareableEntityUserGrantInput = {
    /** JiraShareableEntityGrant ARI. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** ARI of the user in the form of ARI: ari:cloud:identity::user/{userId}. */
    userId: Scalars["ID"]["input"];
};

export type JiraShortcutDataInput = {
    /** The name identifying this shortcut. */
    name: Scalars["String"]["input"];
    /** The url link of this shortcut. */
    url: Scalars["String"]["input"];
};

/** Represent a shortcut navigation item */
export type JiraShortcutNavigationItem = JiraNavigationItem &
    Node & {
        __typename?: "JiraShortcutNavigationItem";
        /** Whether this item can be removed from its scope, based on the authenticated user. */
        canRemove?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be renamed to have a custom user-provided label. */
        canRename?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be set as the default within its scope, based on the authenticated user. */
        canSetAsDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /** Global identifier (ARI) for the navigation item. */
        id: Scalars["ID"]["output"];
        /** Whether this is the default navigation item within the requested scope. Only one may be the default. */
        isDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The label for this item, for display purposes. This can either be the default label based on the
         * item type, or a user-provided value.
         */
        label?: Maybe<Scalars["String"]["output"]>;
        /** Identifies the type of this navigation item. */
        typeKey?: Maybe<JiraNavigationItemTypeKey>;
        /** The URL for the shortcut */
        url?: Maybe<Scalars["String"]["output"]>;
    };

/** The content to display in the sidebar menu. */
export enum JiraSidebarMenuDisplayMode {
    MostRecentOnly = "MOST_RECENT_ONLY",
    Starred = "STARRED",
    StarredAndRecent = "STARRED_AND_RECENT"
}

/** Represents the SimilarIssues feature associated with a JiraProject. */
export type JiraSimilarIssues = {
    __typename?: "JiraSimilarIssues";
    /** Indicates whether the SimilarIssues feature is enabled or not. */
    featureEnabled: Scalars["Boolean"]["output"];
};

/** Represents a simple type of navigation item that is only identified by its `JiraNavigationItemTypeKey`. */
export type JiraSimpleNavigationItemType = JiraNavigationItemType &
    Node & {
        __typename?: "JiraSimpleNavigationItemType";
        /**
         * Opaque ID uniquely identifying this system item type node.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * The localized label for this item type, for display purposes.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        label?: Maybe<Scalars["String"]["output"]>;
        /**
         * The key identifying this item type, represented as an enum.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        typeKey?: Maybe<JiraNavigationItemTypeKey>;
    };

/** Represents single group picker field. Allows you to select single Jira group to be associated with an issue. */
export type JiraSingleGroupPickerField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSingleGroupPickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Paginated list of group options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        groups?: Maybe<JiraGroupConnection>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch group picker field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** The group selected on the Issue or default group configured for the field. */
        selectedGroup?: Maybe<JiraGroup>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents single group picker field. Allows you to select single Jira group to be associated with an issue. */
export type JiraSingleGroupPickerFieldGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for single group picker field */
export type JiraSingleGroupPickerFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Group value for the field */
    group: JiraGroupInput;
};

/** Input type for defining the operation on the SingleGroupPicker field of a Jira issue. */
export type JiraSingleGroupPickerFieldOperationInput = {
    /**
     * Group Id for field update.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'id' param
     */
    groupId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Group Id for field update.
     * Accepts ARI: group
     */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** Operation supported: SET. */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating the SingleGroupPicker field of a Jira issue. */
export type JiraSingleGroupPickerFieldPayload = Payload & {
    __typename?: "JiraSingleGroupPickerFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Single Group Picker field. */
    field?: Maybe<JiraSingleGroupPickerField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Represents single line text field on a Jira Issue. E.g. summary, epic name, custom text field. */
export type JiraSingleLineTextField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSingleLineTextField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The text selected on the Issue or default text configured for the field. */
        text?: Maybe<Scalars["String"]["output"]>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input for single line text fields like summary */
export type JiraSingleLineTextFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Single line text input on which the action will be performed */
    text?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraSingleLineTextFieldOperationInput = {
    operation: JiraSingleValueFieldOperations;
    text?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraSingleLineTextFieldPayload = Payload & {
    __typename?: "JiraSingleLineTextFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraSingleLineTextField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type for a single organization field */
export type JiraSingleOrganizationFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Organization */
    organization: JiraOrganizationsInput;
};

/** Represents single select field on a Jira Issue. */
export type JiraSingleSelectField = JiraHasSelectableValueOptions &
    JiraHasSingleSelectedValue &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSingleSelectField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** The option selected on the Issue or default option configured for the field. */
        fieldOption?: Maybe<JiraOption>;
        /**
         * Paginated list of options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        fieldOptions?: Maybe<JiraOptionConnection>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch the select option for the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * Paginated list of JiraMultipleSelectField options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /** The JiraSingleSelectField selected option on the Issue or default option configured for the field. */
        selectedValue?: Maybe<JiraSelectableValue>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents single select field on a Jira Issue. */
export type JiraSingleSelectFieldFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents single select field on a Jira Issue. */
export type JiraSingleSelectFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for single select field */
export type JiraSingleSelectFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Option on which the action will be performed */
    option: JiraSelectedOptionInput;
};

export type JiraSingleSelectFieldPayload = Payload & {
    __typename?: "JiraSingleSelectFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraSingleSelectField>;
    success: Scalars["Boolean"]["output"];
};

export type JiraSingleSelectOperationInput = {
    /**
     * Accepts ARI(s): issue-field-option
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'id' param
     */
    fieldOption?: InputMaybe<Scalars["ID"]["input"]>;
    /** Accepts ARI(s): issue-field-option */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

/** Represents a single select user field on a Jira Issue. E.g. assignee, reporter, custom user picker. */
export type JiraSingleSelectUserPickerField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSingleSelectUserPickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search url to fetch all available users options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** The user selected on the Issue or default user configured for the field. */
        user?: Maybe<User>;
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Paginated list of user options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        users?: Maybe<JiraUserConnection>;
    };

/** Represents a single select user field on a Jira Issue. E.g. assignee, reporter, custom user picker. */
export type JiraSingleSelectUserPickerFieldUsersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    sessionId?: InputMaybe<Scalars["ID"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for single select user picker fields */
export type JiraSingleSelectUserPickerFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Input data for user being selected */
    user: JiraUserInput;
};

export type JiraSingleSelectUserPickerFieldOperationInput = {
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'id' param
     */
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Accepts ARI(s): user */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraSingleSelectUserPickerFieldPayload = Payload & {
    __typename?: "JiraSingleSelectUserPickerFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraSingleSelectUserPickerField>;
    success: Scalars["Boolean"]["output"];
};

/** Operations that can be performed on single value fields like date, date time, etc. */
export enum JiraSingleValueFieldOperations {
    /** Overrides single value field. */
    Set = "SET"
}

/** Represents a version field on a Jira Issue. E.g. custom version picker field. */
export type JiraSingleVersionPickerField = JiraHasSelectableValueOptions &
    JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSingleVersionPickerField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Paginated list of JiraSingleVersionPickerField options for the field or on an Issue.
         * The server may throw an error if both a forward page (specified with `first`)
         * and a backward page (specified with `last`) are requested simultaneously.
         */
        selectableValueOptions?: Maybe<JiraSelectableValueConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /** The version selected on the Issue or default version configured for the field. */
        version?: Maybe<JiraVersion>;
        /**
         * Paginated list of versions options for the field or on a Jira Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        versions?: Maybe<JiraVersionConnection>;
    };

/** Represents a version field on a Jira Issue. E.g. custom version picker field. */
export type JiraSingleVersionPickerFieldSelectableValueOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a version field on a Jira Issue. E.g. custom version picker field. */
export type JiraSingleVersionPickerFieldVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    suggested?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Input type for single select version picker fields */
export type JiraSingleVersionPickerFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Version field on which the action will be performed */
    version: JiraVersionInput;
};

/** Input type for defining the operation on the SingleVersionPicker field of a Jira issue. */
export type JiraSingleVersionPickerFieldOperationInput = {
    /** Accepts ARI(s): version */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** Operation supported: SET. */
    operation: JiraSingleValueFieldOperations;
};

/** The payload type returned after updating the SingleVersionPicker field of a Jira issue. */
export type JiraSingleVersionPickerFieldPayload = Payload & {
    __typename?: "JiraSingleVersionPickerFieldPayload";
    /** Specifies the errors that occurred during the update operation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Single Version Picker field. */
    field?: Maybe<JiraSingleVersionPickerField>;
    /** Indicates whether the update operation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Board and project scope navigation items in JSW. */
export type JiraSoftwareBuiltInNavigationItem = JiraNavigationItem &
    Node & {
        __typename?: "JiraSoftwareBuiltInNavigationItem";
        /** Whether this item can be removed from its scope, based on the authenticated user. */
        canRemove?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be renamed to have a custom user-provided label. */
        canRename?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be set as the default within its scope, based on the authenticated user. */
        canSetAsDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /** Global identifier (ARI) for the navigation item. */
        id: Scalars["ID"]["output"];
        /** Whether this is the default navigation item within the requested scope. Only one may be the default. */
        isDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The label for this item, for display purposes. This can either be the default label based on the
         * item type, or a user-provided value.
         */
        label?: Maybe<Scalars["String"]["output"]>;
        /** Identifies the type of this navigation item. */
        typeKey?: Maybe<JiraNavigationItemTypeKey>;
        /** The URL to navigate to when this item is selected. */
        url?: Maybe<Scalars["String"]["output"]>;
    };

/** Custom input definition for Jira Software issue search. */
export type JiraSoftwareIssueSearchCustomInput = {
    /** Additional JQL clause that can be added to the search (e.g. 'AND <additionalJql>') */
    additionalJql?: InputMaybe<Scalars["String"]["input"]>;
    /** Additional context for issue search, optionally constraining the returned issues */
    context?: InputMaybe<JiraSoftwareIssueSearchCustomInputContext>;
    /**
     * The Jira entity ARI of the object to constrain search to.
     * Currently only supports board ARI.
     */
    jiraEntityId: Scalars["ID"]["input"];
};

/**
 * Additional context for Jira Software custom issue search, optionally constraining the search
 * by adding additional clauses to the search query.
 */
export enum JiraSoftwareIssueSearchCustomInputContext {
    /** Search is constrained to issues visible on backlogs */
    Backlog = "BACKLOG",
    /** Search is constrained to issues visible on boards */
    Board = "BOARD",
    /** No additional visibility constraints are applied to the search */
    None = "NONE"
}

export type JiraSoftwareProjectNavigationMetadata = {
    __typename?: "JiraSoftwareProjectNavigationMetadata";
    boardId: Scalars["ID"]["output"];
    boardName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    /** Used to tell the difference between classic and next generation boards (agility, simple, nextgen, CMP) */
    isSimpleBoard: Scalars["Boolean"]["output"];
    totalBoardsInProject: Scalars["Long"]["output"];
};

/** Group Field value node. Includes the field id and the issue field value */
export type JiraSpreadsheetGroup = {
    __typename?: "JiraSpreadsheetGroup";
    /** Used to decide the position of this group in the list of groups. The group id of the group before which this group should be placed. */
    afterGroupId?: Maybe<Scalars["String"]["output"]>;
    /** Used to decide the position of this group in the list of groups. The group id of the group after which this group should be placed. */
    beforeGroupId?: Maybe<Scalars["String"]["output"]>;
    /** The fieldId of the group by field */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /** The jira field type of the group by field */
    fieldType?: Maybe<Scalars["String"]["output"]>;
    /** Represents the actual value of the group by field */
    fieldValue?: Maybe<JiraJqlFieldValue>;
    /** The id of the jira field value */
    id: Scalars["ID"]["output"];
    /** The total number of issues in the group */
    issueCount?: Maybe<Scalars["Int"]["output"]>;
    /** Connection of JiraIssue in this group */
    issues?: Maybe<JiraIssueConnection>;
    /** JQL string, that will be used to fetch the issues for the group */
    jql?: Maybe<Scalars["String"]["output"]>;
    /**
     * Union type, that represents the actual value of the group by field
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use fieldValue instead
     */
    value?: Maybe<JiraSpreadsheetGroupFieldValue>;
};

/** Group Field value node. Includes the field id and the issue field value */
export type JiraSpreadsheetGroupIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    fieldSetsInput?: InputMaybe<JiraIssueSearchFieldSetsInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    viewConfigInput?: InputMaybe<JiraIssueSearchViewConfigInput>;
};

/** Represents the available field supported for grouping */
export type JiraSpreadsheetGroupByConfig = {
    __typename?: "JiraSpreadsheetGroupByConfig";
    availableGroupByFieldOptions?: Maybe<JiraSpreadsheetGroupByFieldOptionConnection>;
    groupByField?: Maybe<JiraField>;
};

/** Represents the available field supported for grouping */
export type JiraSpreadsheetGroupByConfigAvailableGroupByFieldOptionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for JiraField that are supported for grouping. */
export type JiraSpreadsheetGroupByFieldOptionConnection = {
    __typename?: "JiraSpreadsheetGroupByFieldOptionConnection";
    edges?: Maybe<Array<Maybe<JiraSpreadsheetGroupByFieldOptionEdge>>>;
};

/** An edge in JiraSpreadsheetGroupByFieldOptionConnection. */
export type JiraSpreadsheetGroupByFieldOptionEdge = {
    __typename?: "JiraSpreadsheetGroupByFieldOptionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JiraField>;
};

/** The connection type for JiraGroupFieldValue. */
export type JiraSpreadsheetGroupConnection = {
    __typename?: "JiraSpreadsheetGroupConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraSpreadsheetGroupEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** This represents the first group in the connection. This is added to expand the first group during the initial page load */
    firstGroup?: Maybe<JiraSpreadsheetGroup>;
    /** the fieldId used for grouping */
    groupByField?: Maybe<Scalars["String"]["output"]>;
    /** JQL string, that was used in the initial search */
    jql?: Maybe<Scalars["String"]["output"]>;
    /** The page info of the current page of results */
    pageInfo: PageInfo;
    /** The total number of group values matching the search criteria */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in JiraGroupFieldValueConnection. */
export type JiraSpreadsheetGroupEdge = {
    __typename?: "JiraSpreadsheetGroupEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** Represents the field value for the group by field. */
    node?: Maybe<JiraSpreadsheetGroup>;
};

/** Union type representing the supported fields for grouping in NIN */
export type JiraSpreadsheetGroupFieldValue =
    | JiraGoal
    | JiraOption
    | JiraPriority
    | JiraStatus
    | JiraStoryPoint;

export type JiraSpreadsheetView = {
    /**
     * Errors which were encountered while fetching the connection.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    error?: Maybe<QueryError>;
    /**
     * A connection of included fields' configurations, grouped where logical (e.g. collapsed fields).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fieldSets?: Maybe<JiraIssueSearchFieldSetConnection>;
    /**
     * The tenant specific id of the filter that will be used to get the JiraIssueSearchView
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filterId?: Maybe<Scalars["String"]["output"]>;
    /**
     * A nullable boolean indicating if the IssueSearchView is using default fieldSets
     * true -> Issue search view is using default fieldSets
     * false -> Issue search view has custom fieldSets
     * null -> Not applicable for requested issue search view
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasDefaultFieldSets?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * An ARI-format value that encodes both namespace and viewId.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * JQL built from provided search parameters
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jql?: Maybe<Scalars["String"]["output"]>;
    /**
     * A subscoping that affects where this view's last used data is stored and grouped by. If null, this view is in the global namespace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    namespace?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use viewSettings instead
     */
    settings?: Maybe<JiraSpreadsheetViewSettings>;
    /**
     * A unique identifier for this view within its namespace, or the global namespace if no namespace is defined.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Jira view setting for the user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    viewSettings?: Maybe<JiraIssueSearchViewConfigSettings>;
};

export type JiraSpreadsheetViewFieldSetsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraIssueSearchFieldSetsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraSpreadsheetViewViewSettingsArgs = {
    groupBy?: InputMaybe<Scalars["String"]["input"]>;
    issueSearchInput?: InputMaybe<JiraIssueSearchInput>;
    staticViewInput?: InputMaybe<JiraIssueSearchStaticViewInput>;
};

/** The payload returned when a JiraSpreadsheetView has been updated. */
export type JiraSpreadsheetViewPayload = Payload & {
    __typename?: "JiraSpreadsheetViewPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    view?: Maybe<JiraSpreadsheetView>;
};

/** User preferences for Jira issue search view */
export type JiraSpreadsheetViewSettings = {
    __typename?: "JiraSpreadsheetViewSettings";
    groupByConfig?: Maybe<JiraSpreadsheetGroupByConfig>;
    /** Indicates whether completed tasks should be hidden */
    hideDone?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether the issues should be grouped by a field */
    isGroupingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates whether issue hierarchy is enabled */
    isHierarchyEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents the sprint field of an issue. */
export type JiraSprint = Node & {
    __typename?: "JiraSprint";
    /** The ID of the board that the sprint belongs to. */
    boardId?: Maybe<Scalars["Long"]["output"]>;
    /** The board name that the sprint belongs to. */
    boardName?: Maybe<Scalars["String"]["output"]>;
    /** Completion date of the sprint. */
    completionDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** End date of the sprint. */
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The goal of the sprint. */
    goal?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the sprint. */
    id: Scalars["ID"]["output"];
    /** Sprint name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** List of projects associated with the sprint. */
    projects?: Maybe<JiraProjectConnection>;
    /** Sprint id in the digital format. */
    sprintId: Scalars["String"]["output"];
    /** The progress of the sprint. */
    sprintProgress?: Maybe<JiraSprintProgress>;
    /** Start date of the sprint. */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** Current state of the sprint. */
    state?: Maybe<JiraSprintState>;
};

/** Represents the sprint field of an issue. */
export type JiraSprintProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for JiraSprint. */
export type JiraSprintConnection = {
    __typename?: "JiraSprintConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraSprintEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraSprint connection. */
export type JiraSprintEdge = {
    __typename?: "JiraSprintEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraSprint>;
};

/** Represents sprint field on a Jira Issue. */
export type JiraSprintField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSprintField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Attribute for reason behind the Sprint field being non editable for any issue */
        nonEditableReason?: Maybe<JiraFieldNonEditableReason>;
        /**
         * Search url to fetch all available sprints options for the field or the Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * The sprints selected on the Issue or default sprints configured for the field.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use selectedSprintsConnection instead.
         */
        selectedSprints?: Maybe<Array<Maybe<JiraSprint>>>;
        /** The sprints selected on the Issue or default sprints configured for the field. */
        selectedSprintsConnection?: Maybe<JiraSprintConnection>;
        /**
         * Paginated list of sprint options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        sprints?: Maybe<JiraSprintConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents sprint field on a Jira Issue. */
export type JiraSprintFieldSelectedSprintsConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents sprint field on a Jira Issue. */
export type JiraSprintFieldSprintsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    currentProjectOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<JiraSprintState>;
};

/** Input type for sprint field */
export type JiraSprintFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** List of sprints on which the action will be performed */
    sprints: Array<JiraSprintInput>;
};

export type JiraSprintFieldOperationInput = {
    /** Accepts ARI(s): sprint */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Accepts operation type and sprintId.
     * The sprintId is optional, in case of a missing sprintId the sprint field will be cleared.
     */
    operation: JiraSingleValueFieldOperations;
};

export type JiraSprintFieldPayload = Payload & {
    __typename?: "JiraSprintFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraSprintField>;
    success: Scalars["Boolean"]["output"];
};

export type JiraSprintFilterInput = {
    /**
     * The active window to filter the Sprints to.
     * The window bounds are equivalent to filtering Sprints where (startDate > start AND startDate < end)
     * OR if sprint is completed (completionDate > start AND completionDate < end),
     * otherwise if sprint isn't completed (endDate > start AND < endDate < end).
     * If no start or end is provided, the window is considered unbounded in that direction.
     */
    activeWithin?: InputMaybe<JiraDateTimeWindow>;
    /**
     * The Board ids to filter Sprints to.
     * A Sprint is considered to be in a Board if it is associated with that board directly
     * or if it is associated with an Issue that is part of the Board's saved filter.
     */
    boardIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * The Project ids to filter Sprints to.
     * A Sprint is considered to be in a Project if it is associated with a board that is associated with the Project
     * or if it is associated with an Issue that is associated with the Project.
     */
    projectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * The raw Project keys to filter Sprints to.
     * A Sprint is considered to be in a Project if it is associated with a board that is associated with the Project
     * or if it is associated with an Issue that is associated with the Project.
     */
    projectKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The state of the Sprints to filter to. */
    states?: InputMaybe<Array<JiraSprintState>>;
};

/** Input type for sprints */
export type JiraSprintInput = {
    /** An identifier for the sprint */
    sprintId: Scalars["ID"]["input"];
};

export type JiraSprintMutationPayload = Payload & {
    __typename?: "JiraSprintMutationPayload";
    /** A list of errors that were encountered during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Sprint field returned post update operation
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jiraSprint?: Maybe<JiraSprint>;
    /** Denotes whether the update sprint mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** Represents progress of a sprint */
export type JiraSprintProgress = {
    __typename?: "JiraSprintProgress";
    /** Estimation unit of the sprint */
    estimationType?: Maybe<Scalars["String"]["output"]>;
    /** progress of the sprint by status category */
    statusCategoryProgress?: Maybe<JiraStatusCategoryProgressConnection>;
};

/** Represents progress of a sprint */
export type JiraSprintProgressStatusCategoryProgressArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the state of the sprint. */
export enum JiraSprintState {
    /** The sprint is in progress. */
    Active = "ACTIVE",
    /** The sprint has been completed. */
    Closed = "CLOSED",
    /** The sprint hasn't been started yet. */
    Future = "FUTURE"
}

export type JiraSprintUpdateInput = {
    /** End date of the sprint */
    endDate?: InputMaybe<Scalars["String"]["input"]>;
    /** The id of the sprint that needs to be updated */
    sprintId: Scalars["ID"]["input"];
    /** Start date of the sprint */
    startDate?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents the status field of an issue. */
export type JiraStatus = Node & {
    __typename?: "JiraStatus";
    /** Optional description of the status. E.g. "This issue is actively being worked on by the assignee". */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier for the Status. */
    id: Scalars["ID"]["output"];
    /** Name of status. E.g. Backlog, Selected for Development, In Progress, Done. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Represents a group of Jira statuses. */
    statusCategory?: Maybe<JiraStatusCategory>;
    /** Status id in the digital format. */
    statusId: Scalars["String"]["output"];
};

/** Represents the category of a status. */
export type JiraStatusCategory = MercuryProjectStatus &
    Node & {
        __typename?: "JiraStatusCategory";
        /** Color of status category. */
        colorName?: Maybe<JiraStatusCategoryColor>;
        /** Global identifier for the Status Category. */
        id: Scalars["ID"]["output"];
        /** A unique key to identify this status category. E.g. new, indeterminate, done. */
        key?: Maybe<Scalars["String"]["output"]>;
        /** Color of status category. */
        mercuryColor?: Maybe<MercuryProjectStatusColor>;
        /** Name of status category. E.g. New, In Progress, Complete. */
        mercuryName?: Maybe<Scalars["String"]["output"]>;
        /** Name of status category. E.g. New, In Progress, Complete. */
        name?: Maybe<Scalars["String"]["output"]>;
        /** Status category id in the digital format. */
        statusCategoryId: Scalars["String"]["output"];
    };

/** Color of the status category. */
export enum JiraStatusCategoryColor {
    /** #4a6785 */
    BlueGray = "BLUE_GRAY",
    /** #815b3a */
    Brown = "BROWN",
    /** #14892c */
    Green = "GREEN",
    /** #707070 */
    MediumGray = "MEDIUM_GRAY",
    /** #d04437 */
    WarmRed = "WARM_RED",
    /** #f6c342 */
    Yellow = "YELLOW"
}

/** Represents Status Category field. */
export type JiraStatusCategoryField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraStatusCategoryField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * The status category for the issue or default status category configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCategory: JiraStatusCategory;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the status category wise estimate counts */
export type JiraStatusCategoryProgress = {
    __typename?: "JiraStatusCategoryProgress";
    /** The status category */
    statusCategory?: Maybe<JiraStatusCategory>;
    /** the total estimates for this status category */
    value?: Maybe<Scalars["Float"]["output"]>;
};

/** The connection type for JiraStatusCategoryProgress. */
export type JiraStatusCategoryProgressConnection = {
    __typename?: "JiraStatusCategoryProgressConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraStatusCategoryProgressEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraStatusCategoryProgress connection. */
export type JiraStatusCategoryProgressEdge = {
    __typename?: "JiraStatusCategoryProgressEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraStatusCategoryProgress>;
};

/** Represents Status field. */
export type JiraStatusField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraStatusField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The status selected on the Issue or default status configured for the field. */
        status: JiraStatus;
        /**
         * All valid transitions for the current status.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraStatusFieldOptions")' query directive to the 'transitions' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        transitions?: Maybe<JiraTransitionConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents Status field. */
export type JiraStatusFieldTransitionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeRemoteOnlyTransitions?: InputMaybe<Scalars["Boolean"]["input"]>;
    includeUnavailableTransitions?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    sortingOption?: InputMaybe<JiraTransitionSortOption>;
    transitionId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraStatusFieldPayload = Payload & {
    __typename?: "JiraStatusFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraStatusField>;
    success: Scalars["Boolean"]["output"];
};

export type JiraStoryPoint = {
    __typename?: "JiraStoryPoint";
    value: Scalars["Float"]["output"];
};

export type JiraStoryPointEstimateFieldOperationInput = {
    operation: JiraSingleValueFieldOperations;
    /** Only positive storypoint and null are allowed */
    storyPoint?: InputMaybe<Scalars["Float"]["input"]>;
};

export type JiraStoryPointEstimateFieldPayload = Payload & {
    __typename?: "JiraStoryPointEstimateFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraNumberField>;
    success: Scalars["Boolean"]["output"];
};

export type JiraStreamHubResourceIdentifier = {
    __typename?: "JiraStreamHubResourceIdentifier";
    resource?: Maybe<Scalars["ID"]["output"]>;
};

/** This is an input argument client will have to give in order to perform bulk edit submit */
export type JiraSubmitBulkOperationInput = {
    /** Payload provided to perform the bulk operation */
    bulkOperationInput: JiraBulkOperationInput;
    /** Represents the type of bulk operation */
    bulkOperationType: JiraBulkOperationType;
};

/** Response returned by the backend to client after performing bulk operation */
export type JiraSubmitBulkOperationPayload = Payload & {
    __typename?: "JiraSubmitBulkOperationPayload";
    /** Any errors faced during the submit operation */
    errors?: Maybe<Array<MutationError>>;
    /** Used for tracking the progress of a submit operation */
    progress?: Maybe<JiraSubmitBulkOperationProgress>;
    /** Represents whether the submit operation is successful or not */
    success: Scalars["Boolean"]["output"];
};

/** Progress object containing taskId for the submitted bulk operation */
export type JiraSubmitBulkOperationProgress = Node & {
    __typename?: "JiraSubmitBulkOperationProgress";
    /** ID for the submit operation being subscribed */
    id: Scalars["ID"]["output"];
    /** Submitting time of the submit operation */
    submittedTime: Scalars["DateTime"]["output"];
    /** Task ID which represents the submit operation. Used for checking the progress of the submit operation */
    taskId: Scalars["String"]["output"];
};

export type JiraSubscription = {
    __typename?: "JiraSubscription";
    /**
     * Retrieves subscription for progress of a bulk operation on Jira Issues by task ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueBulkOperationProgressSubscription")' query directive to the 'bulkOperationProgressSubscription' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    bulkOperationProgressSubscription?: Maybe<JiraIssueBulkOperationProgress>;
    /**
     * Subscribe to creation of attachments for specific projects in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onAttachmentCreatedByProjects?: Maybe<JiraPlatformAttachment>;
    /**
     * Subscribe to creation of attachments for specific projects in a given site. This is a variation of
     * `onAttachmentCreatedByProjects` which returns any errors occurred during event processing in the payload.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onAttachmentCreatedByProjectsV2?: Maybe<JiraAttachmentByAriResult>;
    /**
     * Subscribe to deletion of attachment events for specific projects in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onAttachmentDeletedByProjects?: Maybe<JiraAttachmentDeletedStreamHubPayload>;
    /**
     * Subscription to get updates to an autodev job.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Jira-autodev-jobs")' query directive to the 'onAutodevJobUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onAutodevJobUpdated?: Maybe<JiraAutodevJobConnection>;
    /**
     * Jira Calendar View subscription for issue creation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onCalendarIssueCreated?: Maybe<JiraIssueWithScenario>;
    /**
     * Subscribe to deletion of issue events for given projects within a given instance
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onCalendarIssueDeleted?: Maybe<JiraStreamHubResourceIdentifier>;
    /**
     * Jira Calendar View subscription for issue mutation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onCalendarIssueUpdated?: Maybe<JiraIssueWithScenario>;
    /**
     * Subscribe to creation of issue events for a specific project in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onIssueCreatedByProject?: Maybe<JiraIssue>;
    /**
     * Subscribe to creation of issue events for a specific project in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onIssueDeletedByProject?: Maybe<JiraIssueDeletedStreamHubPayload>;
    /**
     * This subscription manages the real-time updates for export issues, tracking both progress and results.
     * A unique subscription is created for each client-service interaction, and it streams the following events to the client:
     * - **Initial Event**:
     *   - `JiraIssueExportTaskSubmitted`
     *   - This event is dispatched once to indicate the success of the export task submission.
     * - **Progress Events**:
     *   - `JiraIssueExportTaskProgress`
     *   - These events provide ongoing updates on the export task's progress.
     * - **Terminal Event**:
     *   - `JiraIssueExportTaskCompleted` or `JiraIssueExportTaskTerminated`
     *   - This event signifies the final state of the export task.
     *   - It is the last event in the sequence, after which no further events will be sent.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraAsyncExportIssues")' query directive to the 'onIssueExported' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onIssueExported?: Maybe<JiraIssueExportEvent>;
    /**
     * Subscribe to creation of issue update for a specific project in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onIssueUpdatedByProject?: Maybe<JiraIssue>;
    /**
     * JWM specific subscription to subscribe to a custom field mutation and return the mutated field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onJwmFieldMutation?: Maybe<JiraJwmField>;
    /**
     * Subscribe to issue created events for a specific project in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkManagementJirtDeprecation")' query directive to the 'onJwmIssueCreatedByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onJwmIssueCreatedByProject?: Maybe<JiraIssueCreatedStreamHubPayload>;
    /**
     * Subscribe to issue deleted events for a specific project in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkManagementJirtDeprecation")' query directive to the 'onJwmIssueDeletedByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onJwmIssueDeletedByProject?: Maybe<JiraIssueDeletedStreamHubPayload>;
    /**
     * Subscribe to issue updated events for a specific project in a given site
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraWorkManagementJirtDeprecation")' query directive to the 'onJwmIssueUpdatedByProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onJwmIssueUpdatedByProject?: Maybe<JiraIssueUpdatedStreamHubPayload>;
    /**
     * Subscribes to project cleanup async task status changes.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIsIntelligentWorkBreakdownEnabled")' query directive to the 'onProjectCleanupTaskStatusChange' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onProjectCleanupTaskStatusChange?: Maybe<JiraProjectCleanupTaskStatus>;
    /**
     * Short lived subscription used to stream suggest child issues for a given source issue. A separate subscription
     * is generated for each interaction between the client and the service. Events streamed to the client will be:
     *
     * - Status events (JiraSuggestedChildIssueStatus) which indicate what the service is currently doing. A 'COMPLETE'
     * event will be sent at the end of the stream.
     * - Suggested issue events (JiraSuggestedIssue) which contain a single suggested child issue
     * - Error events (JiraSuggestedChildIssueError) which indicate that the feature has encountered an error. These
     * events are terminal and no events will follow.
     *
     * Takes a mandatory sourceIssueId identifying the source issue for which child issues are being suggested.
     * Optionally takes channelId which is used if this is a subsequent refinement request. The value should be the
     * value published in a status event during the streaming of the previous query response.
     * Optionally takes additionalContext which is used to provide additional context to the feature to help it refine the
     * results.
     * Optionally takes a list of issue type IDs which are used to limit the types of issues that are suggested.
     * Optionally takes a list of similar issues which are used to indicate to the feature that issues semantically similar
     * to those provided should be excluded from the results.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIsIntelligentWorkBreakdownEnabled")' query directive to the 'onSuggestedChildIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onSuggestedChildIssue?: Maybe<JiraOnSuggestedChildIssueResult>;
};

export type JiraSubscriptionBulkOperationProgressSubscriptionArgs = {
    cloudId: Scalars["ID"]["input"];
    subscriptionId: Scalars["ID"]["input"];
};

export type JiraSubscriptionOnAttachmentCreatedByProjectsArgs = {
    cloudId: Scalars["ID"]["input"];
    projectIds: Array<Scalars["String"]["input"]>;
};

export type JiraSubscriptionOnAttachmentCreatedByProjectsV2Args = {
    cloudId: Scalars["ID"]["input"];
    projectIds: Array<Scalars["String"]["input"]>;
};

export type JiraSubscriptionOnAttachmentDeletedByProjectsArgs = {
    cloudId: Scalars["ID"]["input"];
    projectIds: Array<Scalars["String"]["input"]>;
};

export type JiraSubscriptionOnAutodevJobUpdatedArgs = {
    issueAri: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type JiraSubscriptionOnCalendarIssueCreatedArgs = {
    cloudId: Scalars["ID"]["input"];
    configuration?: InputMaybe<JiraCalendarViewConfigurationInput>;
    issuesInput?: InputMaybe<JiraCalendarIssuesInput>;
    projectIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    scope?: InputMaybe<JiraViewScopeInput>;
    unscheduledIssuesInput?: InputMaybe<JiraCalendarIssuesInput>;
};

export type JiraSubscriptionOnCalendarIssueDeletedArgs = {
    cloudId: Scalars["ID"]["input"];
    projectIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type JiraSubscriptionOnCalendarIssueUpdatedArgs = {
    cloudId: Scalars["ID"]["input"];
    configuration?: InputMaybe<JiraCalendarViewConfigurationInput>;
    issuesInput?: InputMaybe<JiraCalendarIssuesInput>;
    projectIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    scope?: InputMaybe<JiraViewScopeInput>;
    unscheduledIssuesInput?: InputMaybe<JiraCalendarIssuesInput>;
};

export type JiraSubscriptionOnIssueCreatedByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraSubscriptionOnIssueDeletedByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraSubscriptionOnIssueExportedArgs = {
    input: JiraIssueExportInput;
};

export type JiraSubscriptionOnIssueUpdatedByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraSubscriptionOnJwmFieldMutationArgs = {
    siteId: Scalars["ID"]["input"];
};

export type JiraSubscriptionOnJwmIssueCreatedByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraSubscriptionOnJwmIssueDeletedByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraSubscriptionOnJwmIssueUpdatedByProjectArgs = {
    cloudId: Scalars["ID"]["input"];
    projectId: Scalars["String"]["input"];
};

export type JiraSubscriptionOnProjectCleanupTaskStatusChangeArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JiraSubscriptionOnSuggestedChildIssueArgs = {
    additionalContext?: InputMaybe<Scalars["String"]["input"]>;
    channelId?: InputMaybe<Scalars["String"]["input"]>;
    excludeSimilarIssues?: InputMaybe<Array<JiraSuggestedIssueInput>>;
    issueTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    sourceIssueId: Scalars["ID"]["input"];
};

/** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */
export type JiraSubtasksField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraSubtasksField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Paginated list of subtasks on the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        subtasks?: Maybe<JiraIssueConnection>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
    };

/** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */
export type JiraSubtasksFieldSubtasksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents an error that occurred during the suggest child issues feature */
export type JiraSuggestedChildIssueError = {
    __typename?: "JiraSuggestedChildIssueError";
    /** The type of error that occurred */
    error?: Maybe<JiraSuggestedIssueErrorType>;
    /** The message if present for error */
    errorMessage?: Maybe<Scalars["String"]["output"]>;
    /** The status code when this error occurred */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents the status of the suggest child issues feature */
export type JiraSuggestedChildIssueStatus = {
    __typename?: "JiraSuggestedChildIssueStatus";
    /** The channelId that should be used in subsequent refinement requests */
    channelId?: Maybe<Scalars["String"]["output"]>;
    /** The status of the event */
    status?: Maybe<JiraSuggestedChildIssueStatusType>;
};

/** The type representing the status of the suggest child issues feature */
export enum JiraSuggestedChildIssueStatusType {
    /** The feature has completed its work and the stream is finished */
    Complete = "COMPLETE",
    /** The service is refining suggested issues based on the user's additional context prompt */
    RefiningSuggestedIssues = "REFINING_SUGGESTED_ISSUES",
    /** The service is reformatting the suggested issues to the standard format for their issue type */
    ReformattingIssues = "REFORMATTING_ISSUES",
    /**
     * The service is removing issues that are semantically similar to existing child issues or issues provided in
     * excludeSimilarIssues argument
     */
    RemovingDuplicateIssues = "REMOVING_DUPLICATE_ISSUES",
    /** The service is retrieving context for the source issue from the DB */
    RetrievingSourceContext = "RETRIEVING_SOURCE_CONTEXT",
    /** The service is generating suggestions for child issues based on the source issue context */
    SuggestingInitialIssues = "SUGGESTING_INITIAL_ISSUES"
}

/** Represents a suggested child issue */
export type JiraSuggestedIssue = {
    __typename?: "JiraSuggestedIssue";
    /** The description of the suggested child issue */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The issue type ID of the suggested child issue */
    issueTypeId?: Maybe<Scalars["ID"]["output"]>;
    /** The summary of the suggested child issue */
    summary?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the different types of errors that will be returned by the suggest child issues feature */
export enum JiraSuggestedIssueErrorType {
    /** There are communication problems with downstream services used by the feature. */
    CommunicationsError = "COMMUNICATIONS_ERROR",
    /** The source issue did not contain enough information to suggest any quality child issues */
    NotEnoughInformation = "NOT_ENOUGH_INFORMATION",
    /**
     * All quality child issues have already been suggested by the issues.  Generally this indicates that all viable child
     * issues have already been added to the issue
     */
    NoFurtherSuggestions = "NO_FURTHER_SUGGESTIONS",
    /** A general catch all for other types of errors encountered while suggesting child issues. */
    Unclassified = "UNCLASSIFIED",
    /** The feature has deemed the content in the source issue to be unethical and will not suggest child issues. */
    UnethicalContent = "UNETHICAL_CONTENT"
}

/** Represents the common structure across Issue fields value suggestion. */
export type JiraSuggestedIssueFieldValue = Node & {
    __typename?: "JiraSuggestedIssueFieldValue";
    /** The current request type */
    from?: Maybe<JiraIssueField>;
    /** Unique identifier for the entity. */
    id: Scalars["ID"]["output"];
    /** Translated name for the field (if applicable). */
    name: Scalars["String"]["output"];
    /** The suggested request type */
    to?: Maybe<JiraIssueField>;
    /** Field type key. E.g. project, issuetype, com.pyxis.greenhopper.Jira:gh-epic-link. */
    type: Scalars["String"]["output"];
};

export enum JiraSuggestedIssueFieldValueError {
    /** We don't support issue which has required field yet */
    HaveRequiredField = "HAVE_REQUIRED_FIELD",
    /** We don't support issue which is sub-task */
    IsSubTask = "IS_SUB_TASK",
    /** The LLM responded that it does not have enough information to suggest any issues */
    NotEnoughInformation = "NOT_ENOUGH_INFORMATION",
    /**
     * The LLM response that it has no further suggestions, generally this indicates that all viable child issues
     * have already been added to the issue
     */
    NoFurtherSuggestions = "NO_FURTHER_SUGGESTIONS",
    /** We don't support suggestion if feature is not enabled (ie not opt-in to ai, etc) */
    SuggestionIsNotEnabled = "SUGGESTION_IS_NOT_ENABLED",
    /**
     * A general catch all for other types of errors. This will not be generated by the LLM, but used for invalid LLM
     * responses
     */
    Unclassified = "UNCLASSIFIED"
}

/** The result of a suggested issue field value query */
export type JiraSuggestedIssueFieldValuesResult = {
    __typename?: "JiraSuggestedIssueFieldValuesResult";
    /** The additional applicable field values for the issue */
    additionalFieldSuggestions?: Maybe<JiraAdditionalIssueFieldsConnection>;
    /** Error encountered during execution. Only present in error case */
    error?: Maybe<JiraSuggestedIssueFieldValueError>;
    /** The suggested field values */
    suggestedFieldValues?: Maybe<Array<JiraSuggestedIssueFieldValue>>;
};

/**
 * Represents an issue supplied to the suggest child issues feature to prevent semantically similar issues from being
 * suggested
 */
export type JiraSuggestedIssueInput = {
    /** The description of the issue */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The summary of the issue */
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

/** List of values identifying the different synthetic field types. */
export enum JiraSyntheticFieldCardOptionType {
    CardCover = "CARD_COVER",
    Pages = "PAGES"
}

/** Represents a pre-defined filter in Jira. */
export type JiraSystemFilter = JiraFilter &
    Node & {
        __typename?: "JiraSystemFilter";
        /**
         * A tenant local filterId. For system filters the ID is in the range from -9 to -1. This value is used for interoperability with REST APIs (eg vendors).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterId: Scalars["String"]["output"];
        /**
         * The URL string associated with a specific user filter in Jira.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        filterUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * An ARI value in the format `ari:cloud:jira:{siteId}:filter/activation/{activationId}/{filterId}`that encodes the filterId.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Determines whether the filter is currently starred by the user viewing the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * JQL associated with the filter.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        jql: Scalars["String"]["output"];
        /**
         * The timestamp of this filter was last viewed by the current user (reference to Unix Epoch time in ms).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastViewedTimestamp?: Maybe<Scalars["Long"]["output"]>;
        /**
         * A string representing the filter name.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
    };

/** Represents connection of JiraSystemFilters */
export type JiraSystemFilterConnection = {
    __typename?: "JiraSystemFilterConnection";
    /** The data for the edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraSystemFilterEdge>>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
};

/** Represents a system filter edge */
export type JiraSystemFilterEdge = {
    __typename?: "JiraSystemFilterEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The node at the edge */
    node?: Maybe<JiraSystemFilter>;
};

/** Represents a single team in Jira */
export type JiraTeam = Node & {
    __typename?: "JiraTeam";
    /** Avatar of the team. */
    avatar?: Maybe<JiraAvatar>;
    /**
     * Description of the team.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated JPO Team does not have a description field.
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Global identifier of team. */
    id: Scalars["ID"]["output"];
    /** Indicates whether the team is publicly shared or not. */
    isShared?: Maybe<Scalars["Boolean"]["output"]>;
    /** Members available in the team. */
    members?: Maybe<JiraUserConnection>;
    /** Name of the team. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Team id in the digital format. */
    teamId: Scalars["String"]["output"];
};

/** The connection type for JiraTeam. */
export type JiraTeamConnection = {
    __typename?: "JiraTeamConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraTeamEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraTeam connection. */
export type JiraTeamEdge = {
    __typename?: "JiraTeamEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraTeam>;
};

/** Deprecated type. Please use `JiraTeamViewField` instead. */
export type JiraTeamField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraTeamField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /**
         * Search URL to fetch all the teams options for the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** The team selected on the Issue or default team configured for the field. */
        selectedTeam?: Maybe<JiraTeam>;
        /**
         * Paginated list of team options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         */
        teams?: Maybe<JiraTeamConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Deprecated type. Please use `JiraTeamViewField` instead. */
export type JiraTeamFieldTeamsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input type for team field */
export type JiraTeamFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Represents a team field */
    team: JiraTeamInput;
};

export type JiraTeamFieldOperationInput = {
    /** Accept ARI(s): team */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraSingleValueFieldOperations;
};

export type JiraTeamFieldPayload = Payload & {
    __typename?: "JiraTeamFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraTeamViewField>;
    success: Scalars["Boolean"]["output"];
};

/** Input type for team data */
export type JiraTeamInput = {
    /** An identifier for the team */
    teamId: Scalars["ID"]["input"];
};

/** Represents a view on a Team in Jira. */
export type JiraTeamView = {
    __typename?: "JiraTeamView";
    /** The full team entity. */
    fullTeam?: Maybe<TeamV2>;
    /** Whether the team includes the user. */
    jiraIncludesYou?: Maybe<Scalars["Boolean"]["output"]>;
    /** The total count of member in the team. */
    jiraMemberCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The avatar of the team.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated in future, team avatar will no longer be exposed
     */
    jiraSuppliedAvatar?: Maybe<JiraAvatar>;
    /** The ARI of the team. */
    jiraSuppliedId: Scalars["ID"]["output"];
    /** Whether team is marked as verified or not */
    jiraSuppliedIsVerified?: Maybe<Scalars["Boolean"]["output"]>;
    /** The name of the team. */
    jiraSuppliedName?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier of the team. */
    jiraSuppliedTeamId: Scalars["String"]["output"];
    /** If this is false, team data is no longer available. For example, a deleted team. */
    jiraSuppliedVisibility?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents a view on a Team in Jira. */
export type JiraTeamViewFullTeamArgs = {
    siteId?: Scalars["String"]["input"];
};

/** The connection type for JiraTeamView. */
export type JiraTeamViewConnection = {
    __typename?: "JiraTeamViewConnection";
    /** The data for Edges in the current page */
    edges?: Maybe<Array<Maybe<JiraTeamViewEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraTeamView connection. */
export type JiraTeamViewEdge = {
    __typename?: "JiraTeamViewEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraTeamView>;
};

/** Represents the Team field on a Jira Issue. Allows you to select a team to be associated with an Issue. */
export type JiraTeamViewField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraTeamViewField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Attribute for reason behind the Team field being non editable for any issue */
        nonEditableReason?: Maybe<JiraFieldNonEditableReason>;
        /**
         * Search URL to fetch all the teams options for the field on a Jira Issue.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Search URLs are planned to be replaced by Connections.
         */
        searchUrl?: Maybe<Scalars["String"]["output"]>;
        /** The team selected on the Issue or default team configured for the field. */
        selectedTeam?: Maybe<JiraTeamView>;
        /**
         * Paginated list of team options available for the field or the Issue.
         * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'BETA' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraTeamViewFieldOptions")' query directive to the 'teams' field, or to any of its parents.
         *
         * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
         *
         */
        teams?: Maybe<JiraTeamViewConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Represents the Team field on a Jira Issue. Allows you to select a team to be associated with an Issue. */
export type JiraTeamViewFieldTeamsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filterById?: InputMaybe<JiraFieldOptionIdsFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    organisationId: Scalars["ID"]["input"];
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
    sessionId: Scalars["ID"]["input"];
};

/** Different time formats supported for entering & displaying time tracking related data. */
export enum JiraTimeFormat {
    /** E.g. 2d 4.5h */
    Days = "DAYS",
    /** E.g. 52.5h */
    Hours = "HOURS",
    /** E.g. 2 days, 4 hours, 30 minutes */
    Pretty = "PRETTY"
}

/** Represents the time tracking field on Jira issue screens. */
export type JiraTimeTrackingField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraTimeTrackingField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Original Estimate displays the amount of time originally anticipated to resolve the issue. */
        originalEstimate?: Maybe<JiraEstimate>;
        /** Time Remaining displays the amount of time currently anticipated to resolve the issue. */
        remainingEstimate?: Maybe<JiraEstimate>;
        /** Time Spent displays the amount of time that has been spent on resolving the issue. */
        timeSpent?: Maybe<JiraEstimate>;
        /** This represents the global time tracking settings configuration like working hours and days. */
        timeTrackingSettings?: Maybe<JiraTimeTrackingSettings>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input for TimeTracking field */
export type JiraTimeTrackingFieldInput = {
    /** Represents the original time tracking estimate */
    originalEstimate?: InputMaybe<Scalars["String"]["input"]>;
    /** Represents the remaining time tracking estimate */
    timeRemaining?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraTimeTrackingFieldPayload = Payload & {
    __typename?: "JiraTimeTrackingFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraTimeTrackingField>;
    success: Scalars["Boolean"]["output"];
};

/** Represents the type for representing global time tracking settings. */
export type JiraTimeTrackingSettings = {
    __typename?: "JiraTimeTrackingSettings";
    /** Format in which the time tracking details are presented to the user. */
    defaultFormat?: Maybe<JiraTimeFormat>;
    /** Default unit for time tracking wherever not specified. */
    defaultUnit?: Maybe<JiraTimeUnit>;
    /** Returns whether time tracking implementation is provided by Jira or some external providers. */
    isJiraConfiguredTimeTrackingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Number of days in a working week. */
    workingDaysPerWeek?: Maybe<Scalars["Float"]["output"]>;
    /** Number of hours in a working day. */
    workingHoursPerDay?: Maybe<Scalars["Float"]["output"]>;
};

/**
 * Different time units supported for entering & displaying time tracking related data.
 * Get the currently configured default duration to use when parsing duration string for time tracking.
 */
export enum JiraTimeUnit {
    /** When the current duration is in days. */
    Day = "DAY",
    /** When the current duration is in hours. */
    Hour = "HOUR",
    /** When the current duration is in minutes. */
    Minute = "MINUTE",
    /** When the current duration is in weeks. */
    Week = "WEEK"
}

export type JiraToolchain = {
    __typename?: "JiraToolchain";
    /** If the current has VIEW_DEV_TOOLS project premission */
    hasViewDevToolsPermission?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JiraToolchainHasViewDevToolsPermissionArgs = {
    projectKey: Scalars["String"]["input"];
};

export type JiraTransition = Node & {
    __typename?: "JiraTransition";
    /** Whether the issue has to meet criteria before the issue transition is applied. */
    hasPreConditions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether there is a screen associated with the issue transition. */
    hasScreen?: Maybe<Scalars["Boolean"]["output"]>;
    /** Unique identifier for the entity. */
    id: Scalars["ID"]["output"];
    /** Whether the transition is available. */
    isAvailable?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Whether the issue transition is global, that is, the transition is applied
     * to issues regardless of their status.
     */
    isGlobal?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this is the initial issue transition for the workflow. */
    isInitial?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether this is a looped transition. */
    isLooped?: Maybe<Scalars["Boolean"]["output"]>;
    /** The name of the issue transition. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Details of the issue status after the transition. */
    to?: Maybe<JiraStatus>;
    /** The relative id of the status transition. Required when specifying a transition to undertake. */
    transitionId?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for JiraTransition. */
export type JiraTransitionConnection = {
    __typename?: "JiraTransitionConnection";
    /** The data for Edges in the current page */
    edges?: Maybe<Array<Maybe<JiraTransitionEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in a JiraTransition connection. */
export type JiraTransitionEdge = {
    __typename?: "JiraTransitionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraTransition>;
};

/** Input type for transition screen when fields have to be edited */
export type JiraTransitionScreenInput = {
    /** Info of the fields which are edited on transition screen */
    editedFieldsInput: JiraIssueFieldsInput;
    /** Set of fields edited on the transition screen. */
    selectedActions?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** Enum representing different sort options for transitions. */
export enum JiraTransitionSortOption {
    OpsBar = "OPS_BAR",
    OpsBarThenStatusCategory = "OPS_BAR_THEN_STATUS_CATEGORY"
}

/** The representation for an error message that can be exposed to the UI. */
export type JiraUiExposedError = {
    __typename?: "JiraUIExposedError";
    /** Exception message. */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type JiraUiModification = {
    __typename?: "JiraUiModification";
    data?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
};

export type JiraUiModificationsContextInput = {
    issueKey?: InputMaybe<Scalars["String"]["input"]>;
    issueTypeId?: InputMaybe<Scalars["ID"]["input"]>;
    portalId?: InputMaybe<Scalars["ID"]["input"]>;
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    requestTypeId?: InputMaybe<Scalars["ID"]["input"]>;
    viewType: JiraUiModificationsViewType;
};

export enum JiraUiModificationsViewType {
    Gic = "GIC",
    IssueTransition = "IssueTransition",
    IssueView = "IssueView",
    JsmRequestCreate = "JSMRequestCreate"
}

export type JiraUnlinkIssuesFromIncidentMutationInput = {
    /** The id of the JSM incident to have issues linked to it. */
    incidentId: Scalars["ID"]["input"];
    /**
     * The ids of the issues to unlink from an incident. This can be a JSW issue as an
     * action item or a JSM issues as a post incident review.
     */
    issueIds: Array<Scalars["ID"]["input"]>;
};

export type JiraUnlinkIssuesFromIncidentMutationPayload = Payload & {
    __typename?: "JiraUnlinkIssuesFromIncidentMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Input for attributing Unsplash images */
export type JiraUnsplashAttributionInput = {
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /**
     * The list of unsplash image filepaths to attribute. Returned by the sourceId field of JiraCustomBackground.
     * A maximum of 50 images can be attributed at once.
     */
    filePaths: Array<Scalars["ID"]["input"]>;
};

/** The response for the attributeUnsplashImage mutation */
export type JiraUnsplashAttributionPayload = Payload & {
    __typename?: "JiraUnsplashAttributionPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraUnsplashImage = {
    __typename?: "JiraUnsplashImage";
    /** The author of the photo */
    author?: Maybe<Scalars["String"]["output"]>;
    /** The file name of the photo */
    fileName?: Maybe<Scalars["String"]["output"]>;
    /** The file path of the photo, used to construct the download URL */
    filePath?: Maybe<Scalars["String"]["output"]>;
    /** The base64 representation of the Unsplash thumbnail image */
    thumbnailImage?: Maybe<Scalars["String"]["output"]>;
    /** The Unsplash ID of the photo */
    unsplashId?: Maybe<Scalars["String"]["output"]>;
};

/** The result of an Unsplash image search */
export type JiraUnsplashImageSearchPage = {
    __typename?: "JiraUnsplashImageSearchPage";
    /** The list of photos on returned from the search */
    results?: Maybe<Array<Maybe<JiraUnsplashImage>>>;
    /** The total number of images found from the search */
    totalCount?: Maybe<Scalars["Long"]["output"]>;
    /** The total number of pages of search results */
    totalPages?: Maybe<Scalars["Long"]["output"]>;
};

export type JiraUnsplashImageSearchPageResult =
    | JiraUnsplashImageSearchPage
    | QueryError;

/**
 * The input for searching Unsplash images. Uses Unsplash's API definition for pagination
 * https://unsplash.com/documentation#parameters-16
 */
export type JiraUnsplashSearchInput = {
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** The page number, defaults to 1 */
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    /** The page size, defaults to 10 */
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
    /** The search query */
    query: Scalars["String"]["input"];
    /** The requested width in pixels of the thumbnail image, default is 200px */
    width?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The representation for an error when Non-English inputs that are not officially supported at the moment lead to errors */
export type JiraUnsupportedLanguageError = {
    __typename?: "JiraUnsupportedLanguageError";
    /** Error message. */
    message?: Maybe<Scalars["String"]["output"]>;
};

/** The response for the updateActiveBackground mutation */
export type JiraUpdateActiveBackgroundPayload = Payload & {
    __typename?: "JiraUpdateActiveBackgroundPayload";
    /** Background updated by the mutation */
    background?: Maybe<JiraBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraUpdateActivityConfigurationInput = {
    /** Id of the activity configuration */
    activityId: Scalars["ID"]["input"];
    /** Field value mapping. It contains list of object which is like a map entry including a string key and array of string value */
    fieldValues?: InputMaybe<
        Array<InputMaybe<JiraActivityFieldValueKeyValuePairInput>>
    >;
    /** Name of the activity */
    issueTypeId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Id of the journey configuration */
    journeyId: Scalars["ID"]["input"];
    /** The version number of the journey configuration. */
    journeyVersion: Scalars["Long"]["input"];
    /** Name of the activity */
    name: Scalars["String"]["input"];
    /** Name of the activity */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Name of the activity */
    requestTypeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input type for updating the Affected Services(Service Entity) field of a Jira issue. */
export type JiraUpdateAffectedServicesFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on Affected Services field. */
    operation: JiraAffectedServicesFieldOperationInput;
};

/**
 * Input type for updating the Attachment field of a Jira issue.
 * Note: This schema is intended for GraphQL submit API only. It might not work with other Inline mutations
 */
export type JiraUpdateAttachmentFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on the Attachment field. */
    operation: JiraAttachmentFieldOperationInput;
};

/** The input for updating a Jira Background */
export type JiraUpdateBackgroundInput = {
    /** The type of background to update to */
    backgroundType: JiraBackgroundType;
    /**
     * The gradient/color if the background is a gradient/color type,
     * the customBackgroundId if the background is a custom (user uploaded) type, or
     * the image filePath if the background is from Unsplash
     */
    backgroundValue: Scalars["String"]["input"];
    /** The entityId (ARI) of the entity to be updated */
    entityId: Scalars["ID"]["input"];
};

export type JiraUpdateCascadingSelectFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraCascadingSelectFieldOperationInput;
};

/** Input type for updating the Checkboxes field of a Jira issue. */
export type JiraUpdateCheckboxesFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Checkboxes field. */
    operations: Array<JiraCheckboxesFieldOperationInput>;
};

/** Input type for updating the Cmdb field of a Jira issue. */
export type JiraUpdateCmdbFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on Cmdb field. */
    operation: JiraCmdbFieldOperationInput;
};

export type JiraUpdateColorFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraColorFieldOperationInput;
};

export type JiraUpdateComponentsFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operations: Array<JiraComponentFieldOperationInput>;
};

/** The input for updating a custom background */
export type JiraUpdateCustomBackgroundInput = {
    /** The new alt text */
    altText: Scalars["String"]["input"];
    /** CloudID is required for AGG routing. */
    cloudId: Scalars["ID"]["input"];
    /** The customBackgroundId of the custom background to update */
    customBackgroundId: Scalars["ID"]["input"];
};

/** The returned payload when updating a custom background */
export type JiraUpdateCustomBackgroundPayload = Payload & {
    __typename?: "JiraUpdateCustomBackgroundPayload";
    /** Custom background updated by the mutation */
    background?: Maybe<JiraCustomBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input for updating a JiraCustomFilter. */
export type JiraUpdateCustomFilterDetailsInput = {
    /** A string containing filter description */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The list of edit grants for the filter. Edit Grants represent different ways that users have been granted access to edit the filter.
     * Empty array represents private edit grant.
     */
    editGrants: Array<InputMaybe<JiraShareableEntityEditGrantInput>>;
    /** ARI of the filter */
    id: Scalars["ID"]["input"];
    /** A string representing the name of the filter */
    name: Scalars["String"]["input"];
    /**
     * The list of share grants for the filter. Share Grants represent different ways that users have been granted access to the filter.
     * Empty array represents private share grant.
     */
    shareGrants: Array<InputMaybe<JiraShareableEntityShareGrantInput>>;
};

/** Input for updating the JQL of a JiraCustomFilter. */
export type JiraUpdateCustomFilterJqlInput = {
    /** An ARI-format value that encodes the filterId. */
    id: Scalars["ID"]["input"];
    /** JQL associated with the filter */
    jql: Scalars["String"]["input"];
};

/** The payload returned after updating a JiraCustomFilter's JQL. */
export type JiraUpdateCustomFilterJqlPayload = Payload & {
    __typename?: "JiraUpdateCustomFilterJqlPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** JiraFilter updated by the mutation */
    filter?: Maybe<JiraCustomFilter>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** The payload returned after updating a JiraCustomFilter. */
export type JiraUpdateCustomFilterPayload = Payload & {
    __typename?: "JiraUpdateCustomFilterPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** JiraFilter created or updated by the mutation */
    filter?: Maybe<JiraCustomFilter>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraUpdateDataClassificationFieldInput = {
    /** Accepts ARI: issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Data Classification field. */
    operation: JiraDataClassificationFieldOperationInput;
};

export type JiraUpdateDateFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraDateFieldOperationInput;
};

export type JiraUpdateDateTimeFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraDateTimeFieldOperationInput;
};

export type JiraUpdateFieldSetPreferencesInput = {
    fieldSetId: Scalars["String"]["input"];
    width?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for updating the ForgeMultipleGroupPicker field of a Jira issue. */
export type JiraUpdateForgeMultipleGroupPickerFieldInput = {
    /** Accepts ARI: issuefieldvalue. */
    id: Scalars["ID"]["input"];
    /** The operation to be performed on ForgeMultipleGroupPicker field. */
    operations: Array<JiraForgeMultipleGroupPickerFieldOperationInput>;
};

export type JiraUpdateForgeObjectFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraForgeObjectFieldOperationInput;
};

/** Input type for updating the ForgeSingleGroupPicker field of a Jira issue. */
export type JiraUpdateForgeSingleGroupPickerFieldInput = {
    /** Accepts ARI: issuefieldvalue. */
    id: Scalars["ID"]["input"];
    /** The operation to be performed on ForgeSingleGroupPicker field. */
    operation: JiraForgeSingleGroupPickerFieldOperationInput;
};

/** Input for update a formatting rule. */
export type JiraUpdateFormattingRuleInput = {
    /**
     * The identifier that indicates that cloud instance this search to be executed for.
     * This value is used by AGG to route requests and ignored in Jira.
     */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Color to be applied if condition matches.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use formattingColor instead
     */
    color?: InputMaybe<JiraFormattingColor>;
    /** Content of this rule. */
    expression?: InputMaybe<JiraFormattingRuleExpressionInput>;
    /** Format type of this rule. */
    formatType?: InputMaybe<JiraFormattingArea>;
    /** Color to be applied if condition matches. */
    formattingColor?: InputMaybe<JiraColorInput>;
    /**
     * Deprecated, this field will be ignored.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Deprecated, this field will be ignored
     */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The rule to update. */
    ruleId: Scalars["ID"]["input"];
};

/** Response for the update formatting rule mutation. */
export type JiraUpdateFormattingRulePayload = Payload & {
    __typename?: "JiraUpdateFormattingRulePayload";
    /** List of errors while performing the update formatting rule mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the update formatting rule mutation was successful. */
    success: Scalars["Boolean"]["output"];
    /** The updated rule. Null if update fails. */
    updatedRule?: Maybe<JiraFormattingRule>;
};

/** This is an input argument for updating the global notification preferences. */
export type JiraUpdateGlobalNotificationPreferencesInput = {
    /** A list of notification preferences to update. */
    preferences: Array<JiraNotificationPreferenceInput>;
};

/** The response for the mutation to update the global notification preferences. */
export type JiraUpdateGlobalPreferencesPayload = Payload & {
    __typename?: "JiraUpdateGlobalPreferencesPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The user preferences that have been updated.
     * This doesn't include preferences that were in the request but did not need updating.
     */
    preferences?: Maybe<JiraNotificationPreferences>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

/**
 * Input type for updating the IssueLink field of a Jira issue.
 * Note: This schema is intended for GraphQL submit API only. It might not work with other Inline mutations
 */
export type JiraUpdateIssueLinkFieldInputForIssueTransitions = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on the IssueLink field. */
    operation: JiraIssueLinkFieldOperationInputForIssueTransitions;
};

/** Input type for performing a transition for the issue */
export type JiraUpdateIssueTransitionInput = {
    /** Jira Comment for Issue Transition */
    comment?: InputMaybe<JiraIssueTransitionCommentInput>;
    /** This contains list of all field level inputs, that may be required for mutation */
    fieldInputs?: InputMaybe<JiraIssueTransitionFieldLevelInput>;
    /**
     * Unique identifier for the issue
     * Accepts ARI(s): issue
     */
    issueId: Scalars["ID"]["input"];
    /** Identifier for the transition to be performed */
    transitionId: Scalars["Int"]["input"];
};

/** Input type for updating the IssueType field of a Jira issue. */
export type JiraUpdateIssueTypeFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the IssueType field. */
    operation: JiraIssueTypeFieldOperationInput;
};

export type JiraUpdateJourneyActivityConfigurationInput = {
    /** List of new activity configuration */
    createActivityConfigurations?: InputMaybe<
        Array<InputMaybe<JiraCreateActivityConfigurationInput>>
    >;
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

export type JiraUpdateJourneyConfigurationInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** Name of the journey configuration */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Parent issue of the journey configuration */
    parentIssue?: InputMaybe<JiraJourneyParentIssueInput>;
    /** The trigger of this journey */
    trigger?: InputMaybe<JiraJourneyTriggerInput>;
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

export type JiraUpdateJourneyConfigurationPayload = Payload & {
    __typename?: "JiraUpdateJourneyConfigurationPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The created/updated journey configuration
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use edge instead
     */
    jiraJourneyConfiguration?: Maybe<JiraJourneyConfiguration>;
    /** The created/updated journey configuration edge */
    jiraJourneyConfigurationEdge?: Maybe<JiraJourneyConfigurationEdge>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraUpdateJourneyNameInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The name of this journey */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

export type JiraUpdateJourneyParentIssueConfigurationInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The parent issue of this journey */
    parentIssue?: InputMaybe<JiraJourneyParentIssueInput>;
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

export type JiraUpdateJourneyTriggerConfigurationInput = {
    /** Id of the journey configuration */
    id: Scalars["ID"]["input"];
    /** The trigger configuration of this journey */
    triggerConfiguration?: InputMaybe<JiraJourneyTriggerConfigurationInput>;
    /** The version number of the entity. */
    version: Scalars["Long"]["input"];
};

export type JiraUpdateJourneyWorkItemAssociatedAutomationRuleInput = {
    /** Automation Rule UUID to be added to/removed from the Journey Work Item */
    associatedRuleId: Scalars["ID"]["input"];
    /** ID of the journey configuration */
    journeyId: Scalars["ID"]["input"];
    /** ID of the journey work item */
    journeyItemId: Scalars["ID"]["input"];
    /** The version number of the journey configuration. */
    journeyVersion: Scalars["Long"]["input"];
};

export type JiraUpdateLabelsFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operations: Array<JiraLabelsFieldOperationInput>;
};

/** Input type for updating the Team field of a Jira issue. */
export type JiraUpdateLegacyTeamFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Team field. */
    operation: JiraLegacyTeamFieldOperationInput;
};

/** Input type for updating the MultipleGroupPicker field of a Jira issue. */
export type JiraUpdateMultipleGroupPickerFieldInput = {
    /** Accepts ARI: issuefieldvalue. */
    id: Scalars["ID"]["input"];
    /** The operation to be performed on MultipleGroupPicker field. */
    operations: Array<JiraMultipleGroupPickerFieldOperationInput>;
};

export type JiraUpdateMultipleSelectFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operations: Array<JiraMultipleSelectFieldOperationInput>;
};

/** Input type for updating the MultipleSelectUserPicker field of a Jira issue. */
export type JiraUpdateMultipleSelectUserPickerFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on MultipleSelectUserPicker field. */
    operations: Array<JiraMultipleSelectUserPickerFieldOperationInput>;
};

/** Input type for updating the Multiple Version Picker field of a Jira issue. */
export type JiraUpdateMultipleVersionPickerFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on Multiple Version Picker field. */
    operations: Array<JiraMultipleVersionPickerFieldOperationInput>;
};

/** This is an input argument for updating the notification options */
export type JiraUpdateNotificationOptionsInput = {
    /** Indicates the idle time for emails awaiting changes per issue, multiple emails within this time are consolidated and sent together in a single batched email */
    batchWindow?: InputMaybe<JiraBatchWindowPreference>;
    /** Indicates the local time to receive email notifications if user has chosen once-per-day email batching */
    dailyBatchLocalTime?: InputMaybe<Scalars["String"]["input"]>;
    /** The updated email MIME type preference that we wish to persist. */
    emailMimeType?: InputMaybe<JiraEmailMimeType>;
    /** Whether or not email notifications are enabled for this user. */
    isEmailNotificationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether or not to notify user for there own actions. */
    notifyOwnChangesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether or not notify when user is assignee on issue. */
    notifyWhenRoleAssigneeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Whether or not notify when user is reporter on issue. */
    notifyWhenRoleReporterEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The response for the mutation to update the notification options. */
export type JiraUpdateNotificationOptionsPayload = Payload & {
    __typename?: "JiraUpdateNotificationOptionsPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Jira notification options. */
    options?: Maybe<JiraNotificationOptions>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraUpdateNumberFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraNumberFieldOperationInput;
};

/**
 * Mutation input used to update the changeboarding status of the current user in the context of the overview-plan
 * migration.
 */
export type JiraUpdateOverviewPlanMigrationChangeboardingInput = {
    /** Status of the changeboarding to be updated. */
    changeboardingStatus: JiraOverviewPlanMigrationChangeboardingStatus;
    /** ID of the tenant this mutation input is for. Only used for AGG tenant routing, ignored otherwise. */
    cloudId: Scalars["ID"]["input"];
};

/** Outcome of updating the changeboarding state of the user. */
export type JiraUpdateOverviewPlanMigrationChangeboardingPayload = Payload & {
    __typename?: "JiraUpdateOverviewPlanMigrationChangeboardingPayload";
    /** List of errors relating to the mutation. Only present if `success` is `false`. */
    errors?: Maybe<Array<MutationError>>;
    /** Indicate if the changeboarding mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input type for updating the Parent field of a Jira issue. */
export type JiraUpdateParentFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Parent field. */
    operation: JiraParentFieldOperationInput;
};

/** Input type for updating the People field of a Jira issue. */
export type JiraUpdatePeopleFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on People field. */
    operations: Array<JiraPeopleFieldOperationInput>;
};

export type JiraUpdatePriorityFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraPriorityFieldOperationInput;
};

export type JiraUpdateProjectFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraProjectFieldOperationInput;
};

/** This is the input argument for updating project notification preferences. */
export type JiraUpdateProjectNotificationPreferencesInput = {
    /** A list of notification preferences to update. */
    preferences: Array<JiraNotificationPreferenceInput>;
    /** The ARI of the project for which the notification preferences are to be updated. */
    projectId: Scalars["ID"]["input"];
};

/** The response for the mutation to update the project notification preferences. */
export type JiraUpdateProjectNotificationPreferencesPayload = Payload & {
    __typename?: "JiraUpdateProjectNotificationPreferencesPayload";
    /** The errors field represents additional mutation error information if exists. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The user preferences that have been updated.
     * This doesn't include preferences that were in the request but did not need updating.
     */
    preferences?: Maybe<JiraNotificationPreferences>;
    /** The success indicator saying whether mutation operation was successful as a whole or not. */
    success: Scalars["Boolean"]["output"];
};

export type JiraUpdateRadioSelectFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraRadioSelectFieldOperationInput;
};

/** The input for updating the release notes configuration options for a version */
export type JiraUpdateReleaseNotesConfigurationInput = {
    /** The ARI of the version to update the release notes configuration for */
    id: Scalars["ID"]["input"];
    /** The ARIs of issue fields(issue-field-meta ARI) to include when generating release notes */
    issueFieldIds: Array<Scalars["ID"]["input"]>;
    /** The issue key config to include when generating release notes */
    issueKeyConfig: JiraReleaseNotesIssueKeyConfig;
    /** The ARIs of issue types(issue-type ARI) to include when generating release notes */
    issueTypeIds: Array<Scalars["ID"]["input"]>;
};

/** The return payload of updating the release notes configuration options for a version */
export type JiraUpdateReleaseNotesConfigurationPayload = Payload & {
    __typename?: "JiraUpdateReleaseNotesConfigurationPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated native release notes configuration options
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Deprecated in favour of using `version: JiraVersion!`. releaseNotesConfiguration is still available under `JiraVersion`
     */
    releaseNotesConfiguration?: Maybe<JiraReleaseNotesConfiguration>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The jira version with updated release note configuration */
    version?: Maybe<JiraVersion>;
};

/** Input type for updating the Resolution field of a Jira issue. */
export type JiraUpdateResolutionFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Resolution field. */
    operation: JiraResolutionFieldOperationInput;
};

export type JiraUpdateRichTextFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraRichTextFieldOperationInput;
};

/** Input type for updating the Security Level field of a Jira issue. */
export type JiraUpdateSecurityLevelFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to perform on the Security Level field. */
    operation: JiraSecurityLevelFieldOperationInput;
};

export type JiraUpdateShortcutInput = {
    /** ARI of the project the shortcut is belongs to. */
    projectId: Scalars["ID"]["input"];
    /** Data of shortcut being updated */
    shortcutData: JiraShortcutDataInput;
    /** ARI of the shortcut */
    shortcutId: Scalars["ID"]["input"];
};

export type JiraUpdateSidebarMenuDisplaySettingInput = {
    /** The identifier of the cloud instance to update the sidebar menu settings for. */
    cloudId: Scalars["ID"]["input"];
    /** The content to display in the sidebar menu. */
    displayMode?: InputMaybe<JiraSidebarMenuDisplayMode>;
    /** The upper limit of favourite projects to display. */
    favouriteLimit?: InputMaybe<Scalars["Int"]["input"]>;
    /** The upper limit of recent projects to display. */
    recentLimit?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input type for updating the SingleGroupPicker field of a Jira issue. */
export type JiraUpdateSingleGroupPickerFieldInput = {
    /** Accepts ARI: issuefieldvalue. */
    id: Scalars["ID"]["input"];
    /** The operation to be performed on SingleGroupPicker field. */
    operation: JiraSingleGroupPickerFieldOperationInput;
};

export type JiraUpdateSingleLineTextFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraSingleLineTextFieldOperationInput;
};

export type JiraUpdateSingleSelectFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraSingleSelectOperationInput;
};

export type JiraUpdateSingleSelectUserPickerFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraSingleSelectUserPickerFieldOperationInput;
};

/** Input type for updating the SingleVersionPicker field of a Jira issue. */
export type JiraUpdateSingleVersionPickerFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operation to be performed on SingleVersionPicker field. */
    operation: JiraSingleVersionPickerFieldOperationInput;
};

export type JiraUpdateSprintFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraSprintFieldOperationInput;
};

export type JiraUpdateStatusFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** Accepts Transition actionId as input */
    statusTransitionId: Scalars["Int"]["input"];
};

export type JiraUpdateStoryPointEstimateFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraStoryPointEstimateFieldOperationInput;
};

export type JiraUpdateTeamFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraTeamFieldOperationInput;
};

export type JiraUpdateTimeTrackingFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /**
     * Provide `null` to keep originalEstimate unchanged.
     *
     * Note: Setting originalEstimate when both originalEstimate & remainingEstimate are null, will also set
     * remainingEstimate to the value provided for originalEstimate.
     */
    originalEstimate?: InputMaybe<JiraEstimateInput>;
    /** Provide `null` to keep remainingEstimate unchanged. */
    remainingEstimate?: InputMaybe<JiraEstimateInput>;
};

export type JiraUpdateUrlFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraUrlFieldOperationInput;
};

export type JiraUpdateUserNavigationConfigurationInput = {
    /** The identifier that indicates that cloud instance this data is to be fetched for */
    cloudID: Scalars["ID"]["input"];
    /**
     * A list of all the navigation items that the user has configured for this navigation section.
     * The order of the items in this list is the order in which they will be stored in the database.
     */
    navItems: Array<JiraConfigurableNavigationItemInput>;
    /** The uniques key describing the particular navigation section. */
    navKey: Scalars["String"]["input"];
};

/** Input to update whether a version is archived or not. */
export type JiraUpdateVersionArchivedStatusInput = {
    /** The identifier for the Jira version. */
    id: Scalars["ID"]["input"];
    /** Boolean that indicates if the version is archived. */
    isArchived: Scalars["Boolean"]["input"];
};

/** Input to update the version description. */
export type JiraUpdateVersionDescriptionInput = {
    /** Version description. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The identifier of the Jira version. */
    id: Scalars["ID"]["input"];
};

/** Input shape to update(set/unset) Driver of a Jira Version */
export type JiraUpdateVersionDriverInput = {
    /** Atlassian Account ID (AAID) of the driver of the version. */
    driver?: InputMaybe<Scalars["ID"]["input"]>;
    /** Version ARI */
    id: Scalars["ID"]["input"];
};

/** Input to update the version name. */
export type JiraUpdateVersionNameInput = {
    /** The identifier of the Jira version. */
    id: Scalars["ID"]["input"];
    /** Version name. */
    name: Scalars["String"]["input"];
};

/** The return payload of updating a version. */
export type JiraUpdateVersionPayload = Payload & {
    __typename?: "JiraUpdateVersionPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated version. */
    version?: Maybe<JiraVersion>;
};

/**
 * Input to update the version's sequence, which affects the version's
 * position and display order relative to other versions in the project.
 */
export type JiraUpdateVersionPositionInput = {
    /** The ID of the version preceding the version being updated. */
    afterVersionId: Scalars["ID"]["input"];
    /** The identifier of the Jira version being updated. */
    id: Scalars["ID"]["input"];
};

/**
 * Input to update/edit a related work item's title/URL/category.
 *
 * Only applicable for "generic link" work items.
 */
export type JiraUpdateVersionRelatedWorkGenericLinkInput = {
    /** The new related work item category. */
    category: Scalars["String"]["input"];
    /** The identifier for the related work item. */
    relatedWorkId: Scalars["ID"]["input"];
    /** The new related work title (can be null only if a `url` was given). */
    title?: InputMaybe<Scalars["String"]["input"]>;
    /** The new URL for the related work item (pass `null` to make the item a placeholder). */
    url?: InputMaybe<Scalars["URL"]["input"]>;
    /** The identifier for the Jira version the work item lives in. */
    versionId: Scalars["ID"]["input"];
};

/** The return payload of updating the work item's title/URL/category. */
export type JiraUpdateVersionRelatedWorkGenericLinkPayload = Payload & {
    __typename?: "JiraUpdateVersionRelatedWorkGenericLinkPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated related work item. */
    relatedWork?: Maybe<JiraVersionRelatedWorkV2>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Input to update the version release date. */
export type JiraUpdateVersionReleaseDateInput = {
    /** The identifier of the Jira version. */
    id: Scalars["ID"]["input"];
    /** The date at which the version was released to customers. Must occur after startDate. */
    releaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** Input to update whether a version is released or not. */
export type JiraUpdateVersionReleasedStatusInput = {
    /** The identifier for the Jira version. */
    id: Scalars["ID"]["input"];
    /** Boolean that indicates if the version is released. */
    isReleased: Scalars["Boolean"]["input"];
};

/** Input to update the rich text section's title for a given version */
export type JiraUpdateVersionRichTextSectionContentInput = {
    /** The rich text section's content in ADF */
    content?: InputMaybe<Scalars["JSON"]["input"]>;
    /** The identifier of the Jira version. */
    id: Scalars["ID"]["input"];
};

/** Input to update the rich text section's title for a given version */
export type JiraUpdateVersionRichTextSectionTitleInput = {
    /** The identifier of the Jira version. */
    id: Scalars["ID"]["input"];
    /** The rich text section's title. */
    title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input to update the version start date. */
export type JiraUpdateVersionStartDateInput = {
    /** The identifier of the Jira version. */
    id: Scalars["ID"]["input"];
    /** The date at which work on the version began. */
    startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/** The input to update the version details page warning report. */
export type JiraUpdateVersionWarningConfigInput = {
    /** The ARI of the Jira project. */
    jiraProjectId: Scalars["ID"]["input"];
    /** The version configuration options to be updated. */
    updatedVersionWarningConfig: JiraVersionUpdatedWarningConfigInput;
};

export type JiraUpdateVersionWarningConfigPayload = Payload & {
    __typename?: "JiraUpdateVersionWarningConfigPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The version for a given ARI. */
    version?: Maybe<JiraVersionResult>;
};

export type JiraUpdateVersionWarningConfigPayloadVersionArgs = {
    id: Scalars["ID"]["input"];
};

export type JiraUpdateViewConfigInput = {
    /** The field id for the end date field */
    endDateFieldId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * viewId is the unique identifier for the view: ari:cloud:jira:{siteId}:view/activation/{activationId}/{scopeType}/{scopeId}
     * https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aview
     */
    id: Scalars["ID"]["input"];
    /** The field id for the start date field */
    startDateFieldId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraUpdateViewConfigPayload = Payload & {
    __typename?: "JiraUpdateViewConfigPayload";
    /** The list of errors. */
    errors?: Maybe<Array<MutationError>>;
    /** The result of whether the request is executed successfully or not. Will be false if the update failed. */
    success: Scalars["Boolean"]["output"];
};

export type JiraUpdateVotesFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraVotesFieldOperationInput;
};

export type JiraUpdateWatchesFieldInput = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    operation: JiraWatchesFieldOperationInput;
};

/**
 * Input type for updating the Worklog field of a Jira issue.
 * Note: This schema is intended for GraphQL submit API only. It will not work with other Inline mutations
 */
export type JiraUpdateWorklogFieldInputForIssueTransitions = {
    /** Accepts ARI(s): issuefieldvalue */
    id: Scalars["ID"]["input"];
    /** The operations to perform on the Worklog field. */
    operation: JiraWorklogFieldOperationInputForIssueTransitions;
};

/** Represents url field on a Jira Issue. */
export type JiraUrlField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraUrlField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** The url selected on the Issue or default url configured for the field. */
        uri?: Maybe<Scalars["String"]["output"]>;
        /**
         * The url selected on the Issue or default url configured for the field. (deprecated)
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Please use uri; replaced Url with String to accommodate values that are URI but not URL
         */
        url?: Maybe<Scalars["URL"]["output"]>;
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

/** Input type for url field */
export type JiraUrlFieldInput = {
    /** An identifier for the field */
    fieldId: Scalars["ID"]["input"];
    /** Represents a url on which the action will be performed */
    url: Scalars["String"]["input"];
};

export type JiraUrlFieldOperationInput = {
    operation: JiraSingleValueFieldOperations;
    uri?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraUrlFieldPayload = Payload & {
    __typename?: "JiraUrlFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraUrlField>;
    success: Scalars["Boolean"]["output"];
};

/** The representation for an error when a usage limit has been exceeded. */
export type JiraUsageLimitExceededError = {
    __typename?: "JiraUsageLimitExceededError";
    /** Error message. */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type JiraUser = {
    __typename?: "JiraUser";
    accountId?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
};

export type JiraUserAppAccess = {
    __typename?: "JiraUserAppAccess";
    hasAccess: Scalars["Boolean"]["output"];
};

/** All information of a broadcast message that applied to a certain user */
export type JiraUserBroadcastMessage = Node & {
    __typename?: "JiraUserBroadcastMessage";
    /** Global identifier for the JiraUserBroadcastMessage. */
    id: Scalars["ID"]["output"];
    /** The actions done on this message by the current user */
    isDismissed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the user is in the targeting cohort based on the trait pertain to the message */
    isUserTargeted?: Maybe<Scalars["Boolean"]["output"]>;
    /** Configurations regarding displaying of the message */
    shouldDisplay?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JiraUserBroadcastMessageActionPayload = Payload & {
    __typename?: "JiraUserBroadcastMessageActionPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Details of the entity which has been modified. */
    userBroadcastMessage?: Maybe<JiraUserBroadcastMessage>;
};

export type JiraUserBroadcastMessageConnection = HasPageInfo &
    HasTotal & {
        __typename?: "JiraUserBroadcastMessageConnection";
        /** A list of edges in the current page. */
        edges?: Maybe<Array<Maybe<JiraUserBroadcastMessageEdge>>>;
        /** Information about the current page. Used to aid in pagination. */
        pageInfo: PageInfo;
        /** The total count of items in the connection. */
        totalCount?: Maybe<Scalars["Int"]["output"]>;
    };

/** An edge in a JiraUserBroadcastMessage connection. */
export type JiraUserBroadcastMessageEdge = {
    __typename?: "JiraUserBroadcastMessageEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraUserBroadcastMessage>;
};

/** A connection to a list of users. */
export type JiraUserConnection = {
    __typename?: "JiraUserConnection";
    /** A list of User edges. */
    edges?: Maybe<Array<Maybe<JiraUserEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
    /** A count of filtered result set across all pages. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An edge in an User connection object. */
export type JiraUserEdge = {
    __typename?: "JiraUserEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at this edge. */
    node?: Maybe<User>;
};

/** Attributes of user made field configurations. */
export type JiraUserFieldConfig = {
    __typename?: "JiraUserFieldConfig";
    /** Defines whether a field has been pinned by the user. */
    isPinned?: Maybe<Scalars["Boolean"]["output"]>;
    /** Defines if the user has preferred to check a field on Issue creation. */
    isSelected?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Input type for user field input */
export type JiraUserFieldInput = {
    fieldId: Scalars["ID"]["input"];
    user?: InputMaybe<JiraUserInput>;
};

/** The USER grant type value where user data is provided by identity service. */
export type JiraUserGrantTypeValue = Node & {
    __typename?: "JiraUserGrantTypeValue";
    /**
     * The ARI to represent the grant user type value.
     * For example: ari:cloud:identity::user/123
     */
    id: Scalars["ID"]["output"];
    /** The GDPR compliant user profile information. */
    user?: Maybe<User>;
};

export type JiraUserGroup = {
    __typename?: "JiraUserGroup";
    accountId?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
};

/** Input type for user information */
export type JiraUserInfoInput = {
    /** ARI of the user. */
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input type for user field */
export type JiraUserInput = {
    /** ARI representing the user */
    accountId: Scalars["ID"]["input"];
};

/** Represents user made configurations associated with an Issue field. */
export type JiraUserIssueFieldConfiguration = {
    /** Attributes of an Issue field configuration info from a user's customisation. */
    userFieldConfig?: Maybe<JiraUserFieldConfig>;
};

/** User metadata for a project role actor. */
export type JiraUserMetadata = {
    __typename?: "JiraUserMetadata";
    /** User info. */
    info?: Maybe<User>;
    /** The status of the user. Inactive or Deleted. */
    status?: Maybe<JiraProjectRoleActorUserStatus>;
};

/** The user's configuration for the navigation at a specific location. */
export type JiraUserNavigationConfiguration = Node & {
    __typename?: "JiraUserNavigationConfiguration";
    /** ARI for the Jira User Navigation Configuration */
    id: Scalars["ID"]["output"];
    /**
     * A list of all the navigation items that the user has configured for this navigation section.
     * The order of the items in this list is the order in which they will be displayed on the page.
     */
    navItems: Array<JiraConfigurableNavigationItem>;
    /** The uniques key describing the particular navigation section. */
    navKey: Scalars["String"]["output"];
};

/** The payload returned after updating the navigation configuration. */
export type JiraUserNavigationConfigurationPayload = Payload & {
    __typename?: "JiraUserNavigationConfigurationPayload";
    /** A list of errors which were encountered while updating the navigation configuration. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated user navigation configuration. */
    userNavigationConfiguration?: Maybe<JiraUserNavigationConfiguration>;
};

export type JiraUserPreferences = {
    __typename?: "JiraUserPreferences";
    /** Gets the Jira color scheme theme setting. */
    colorSchemeThemeSetting?: Maybe<JiraColorSchemeThemeSetting>;
    /** Gets the view type for the global issue create modal. */
    globalIssueCreateView?: Maybe<JiraGlobalIssueCreateView>;
    /** Gets whether the new advanced roadmaps layout sidebar layout has been enabled for the logged in user. */
    isAdvancedRoadmapsSidebarLayoutEnabled?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Whether the current user has dismissed the custom nav bar theme flag. */
    isCustomNavBarThemeFlagDismissed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the current user has dismissed the custom nav bar theme section message. */
    isCustomNavBarThemeSectionMessageDismissed?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Whether the current user has dismissed the attachment reference flag. */
    isIssueViewAttachmentReferenceFlagDismissed?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Whether the current user has dismissed the child issues limit best practice flag. */
    isIssueViewChildIssuesLimitBestPracticeFlagDismissed?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Whether the current user has dismissed CrossFlow Ads in Issue view quick actions */
    isIssueViewCrossFlowBannerDismissed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the current user has chosen to hide done subtasks and child issues. */
    isIssueViewHideDoneChildIssuesFilterEnabled?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Whether the current user has chosen to dismiss the issue view pinned fields banner. */
    isIssueViewPinnedFieldsBannerDismissed?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Gets if smart replies are enabled in the user's preferences. */
    isIssueViewSmartRepliesUserEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Gets whether the logged in user has been already viewed the global issue create mini modal discoverability push. */
    isMiniModalGlobalIssueCreateDiscoverabilityPushComplete?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /**
     * Gets whether the spotlight tour has been enabled for the logged in user.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is a temporary field that will not be needed in the future.
     */
    isNaturalLanguageSpotlightTourEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Gets the search layout to be used in issue navigator. */
    issueNavigatorSearchLayout?: Maybe<JiraIssueNavigatorSearchLayout>;
    /** Gets the selected activity feed sort order for the logged in user. */
    issueViewActivityFeedSortOrder?: Maybe<JiraIssueViewActivityFeedSortOrder>;
    /**
     * Gets the issue view type for the activity layout.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraIssueViewActivityLayout")' query directive to the 'issueViewActivityLayout' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueViewActivityLayout?: Maybe<JiraIssueViewActivityLayout>;
    /** Gets the selected attachment view for the logged in user. */
    issueViewAttachmentPanelViewMode?: Maybe<JiraIssueViewAttachmentPanelViewMode>;
    /**
     * Returns the Project Key when for the first time the loggedin user dismiss the pinned fields banner.
     * If the current Banner Project Key is not set, resolver updates with passed project Key and returns.
     */
    issueViewDefaultPinnedFieldsBannerProject?: Maybe<
        Scalars["String"]["output"]
    >;
    /** The fields for the specified project that the current user has decided to pin. */
    issueViewPinnedFields?: Maybe<Scalars["String"]["output"]>;
    /** The last time the logged in user has interacted with the issue view pinned fields banner. */
    issueViewPinnedFieldsBannerLastInteracted?: Maybe<
        Scalars["DateTime"]["output"]
    >;
    /** The current users size of the issue-view sidebar. */
    issueViewSidebarResizeRatio?: Maybe<Scalars["String"]["output"]>;
    /** The selected format for displaying timestamps for the logged in user. */
    issueViewTimestampDisplayMode?: Maybe<JiraIssueViewTimestampDisplayMode>;
    /** Gets the jql builders preferred search mode for the logged in user. */
    jqlBuilderSearchMode?: Maybe<JiraJqlBuilderSearchMode>;
    /**
     * Gets the project list sidebar state for the logged in user.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectListRightPanelState")' query directive to the 'projectListRightPanelState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    projectListRightPanelState?: Maybe<JiraProjectListRightPanelState>;
    /** Returns request type table view settings for the given project, saved as user preference. */
    requestTypeTableViewSettings?: Maybe<Scalars["String"]["output"]>;
    /** Returns whether to show start / end date field association message for a given Issue key. */
    showDateFieldAssociationMessageByIssueKey?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Returns whether to show redaction change boarding on action menu. */
    showRedactionChangeBoardingOnActionMenu?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Returns whether to show redaction change boarding on issue view as editor. */
    showRedactionChangeBoardingOnIssueViewAsEditor?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Returns whether to show redaction change boarding on issue view as viewer. */
    showRedactionChangeBoardingOnIssueViewAsViewer?: Maybe<
        Scalars["Boolean"]["output"]
    >;
};

export type JiraUserPreferencesIssueViewDefaultPinnedFieldsBannerProjectArgs = {
    projectKey: Scalars["String"]["input"];
};

export type JiraUserPreferencesIssueViewPinnedFieldsArgs = {
    projectKey: Scalars["String"]["input"];
};

export type JiraUserPreferencesRequestTypeTableViewSettingsArgs = {
    projectKey: Scalars["String"]["input"];
};

export type JiraUserPreferencesShowDateFieldAssociationMessageByIssueKeyArgs = {
    issueKey: Scalars["String"]["input"];
};

export type JiraUserPreferencesMutation = {
    __typename?: "JiraUserPreferencesMutation";
    /** Updates date field association message user preference for a given Issue key. */
    dismissDateFieldAssociationMessageByIssueKey?: Maybe<JiraDateFieldAssociationMessageMutationPayload>;
    /** Saves and returns request type table view settings for the given project, as a user preference. */
    saveRequestTypeTableViewSettings?: Maybe<Scalars["String"]["output"]>;
    /** Sets the preferred search layout for the logged in user. */
    setIssueNavigatorSearchLayout?: Maybe<JiraIssueNavigatorSearchLayoutMutationPayload>;
    /** Sets the user search mode for the logged in user. */
    setJQLBuilderSearchMode?: Maybe<JiraJqlBuilderSearchModeMutationPayload>;
    /**
     * Sets the new enabled/ disabled value for the natural language spotlight tour.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is a temporary field that will not be needed in the future.
     */
    setNaturalLanguageSpotlightTourEnabled?: Maybe<JiraNaturalLanguageSearchSpotlightTourEnabledMutationPayload>;
    /**
     * Sets the Jira project list right panel state
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraProjectListRightPanelState")' query directive to the 'setProjectListRightPanelState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setProjectListRightPanelState?: Maybe<JiraProjectListRightPanelStateMutationPayload>;
    /** Sets whether to show redaction change boarding on action menu. */
    setShowRedactionChangeBoardingOnActionMenu?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Sets whether to show redaction change boarding on issue view as editor. */
    setShowRedactionChangeBoardingOnIssueViewAsEditor?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Sets whether to show redaction change boarding on issue view as viewer. */
    setShowRedactionChangeBoardingOnIssueViewAsViewer?: Maybe<
        Scalars["Boolean"]["output"]
    >;
};

export type JiraUserPreferencesMutationDismissDateFieldAssociationMessageByIssueKeyArgs =
    {
        issueKey: Scalars["String"]["input"];
    };

export type JiraUserPreferencesMutationSaveRequestTypeTableViewSettingsArgs = {
    projectKey: Scalars["String"]["input"];
    viewSettings: Scalars["String"]["input"];
};

export type JiraUserPreferencesMutationSetIssueNavigatorSearchLayoutArgs = {
    searchLayout?: InputMaybe<JiraIssueNavigatorSearchLayout>;
};

export type JiraUserPreferencesMutationSetJqlBuilderSearchModeArgs = {
    searchMode?: InputMaybe<JiraJqlBuilderSearchMode>;
};

export type JiraUserPreferencesMutationSetNaturalLanguageSpotlightTourEnabledArgs =
    {
        isEnabled: Scalars["Boolean"]["input"];
    };

export type JiraUserPreferencesMutationSetProjectListRightPanelStateArgs = {
    state?: InputMaybe<JiraProjectListRightPanelState>;
};

export type JiraUserPreferencesMutationSetShowRedactionChangeBoardingOnActionMenuArgs =
    {
        show: Scalars["Boolean"]["input"];
    };

export type JiraUserPreferencesMutationSetShowRedactionChangeBoardingOnIssueViewAsEditorArgs =
    {
        show: Scalars["Boolean"]["input"];
    };

export type JiraUserPreferencesMutationSetShowRedactionChangeBoardingOnIssueViewAsViewerArgs =
    {
        show: Scalars["Boolean"]["input"];
    };

/** User's role and team's type */
export type JiraUserSegmentation = {
    __typename?: "JiraUserSegmentation";
    /** User's role */
    role?: Maybe<Scalars["String"]["output"]>;
    /** User's team's type */
    teamType?: Maybe<Scalars["String"]["output"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersion = JiraScenarioVersionLike &
    JiraSelectableValue &
    Node & {
        __typename?: "JiraVersion";
        /** List of approvers for a version. */
        approvers?: Maybe<JiraVersionApproverConnection>;
        /** The Confluence sites available to the Jira instance (via Applinks). */
        availableSites?: Maybe<JiraReleaseNotesInConfluenceAvailableSitesConnection>;
        /** Indicates whether the user has permission to add and remove issues to the version. */
        canAddAndRemoveIssues?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Indicates whether the user has permission to edit the version such as releasing it or
         * associating related work to it.
         */
        canEdit?: Maybe<Scalars["Boolean"]["output"]>;
        /** Indicates whether the user has permission to edit the related work version feature such as creating, editing or deleting related work items */
        canEditRelatedWork?: Maybe<Scalars["Boolean"]["output"]>;
        /** Indicates whether the user has permission to view development information related to the version */
        canViewDevTools?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Returns true if the user can view the version details page for this version.
         *
         * This means all of the following are true:
         * - They have a Jira Software license.
         * - The version is in a Jira Software project.
         * - The Releases feature is enabled for the project.
         */
        canViewVersionDetailsPage?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * A list of collapsed UIs in Version details page. This works per user per version. It will return empty array if nothing is collapsed. Should not be null unless something went wrong.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraVersionCollapsedUis")' query directive to the 'collapsedUis' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        collapsedUis?: Maybe<Array<Maybe<JiraVersionDetailsCollapsedUi>>>;
        /**
         * Marketplace connect app iframe data for Version details page's top right corner extension
         * point(location: atl.jira.releasereport.top.right.panels)
         * An empty array will be returned in case there isn't any marketplace apps installed.
         */
        connectAddonIframeData?: Maybe<
            Array<Maybe<JiraVersionConnectAddonIframeData>>
        >;
        /** List of contributors for a version. */
        contributors?: Maybe<JiraVersionContributorConnection>;
        /**
         * Cross project version if the version is part of one
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'crossProjectVersion' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        crossProjectVersion?: Maybe<Scalars["String"]["output"]>;
        /**
         * Version description.
         * This is a beta field and has not been implemented yet.
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Contains summary information for DevOps entities. Currently supports deployments and feature flags. */
        devOpsSummarisedEntities?: Maybe<DevOpsSummarisedEntities>;
        /**
         * Deprecated: use driverData field
         * The user who is the driver for the version. This will be null when the version
         * doesn't have a driver.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Use driverData field
         */
        driver?: Maybe<User>;
        /**
         *
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraVersionDriverResult")' query directive to the 'driverData' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        driverData?: Maybe<JiraVersionDriverResult>;
        /**
         * Epics for the version(project) to list epics for epic filter. The number of result is limited to 10 with only first page.
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraVersionEpicsForFilter")' query directive to the 'epicsForFilter' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        epicsForFilter?: Maybe<JiraIssueConnection>;
        /** If a release note currently exists for the version */
        hasReleaseNote?: Maybe<Scalars["Boolean"]["output"]>;
        /** Version icon URL. */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        id: Scalars["ID"]["output"];
        /**
         * List of related work items linked to the version.
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraVersionIssueAssociatedDesigns")' query directive to the 'issueAssociatedDesigns' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        issueAssociatedDesigns?: Maybe<GraphStoreSimplifiedVersionAssociatedDesignConnection>;
        /** List of issues with the version. */
        issues?: Maybe<JiraIssueConnection>;
        /** Version name. */
        name?: Maybe<Scalars["String"]["output"]>;
        /**
         * The selected issue fields to use when generating native release notes
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: ReleaseNotesOptions` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        nativeReleaseNotesOptionsIssueFields?: Maybe<JiraIssueFieldConnection>;
        /** Indicates that the version is overdue. */
        overdue?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Plan scenario values that override the original values
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraPlansSupport")' query directive to the 'planScenarioValues' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        planScenarioValues?: Maybe<JiraVersionPlanScenarioValues>;
        /** The project the version resides in */
        project?: Maybe<JiraProject>;
        /**
         * List of related work items linked to the version.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: RelatedWork` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Use relatedWorkV2 instead - it has support for native release notes
         */
        relatedWork?: Maybe<JiraVersionRelatedWorkConnection>;
        /**
         * List of related work items linked to the version.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: RelatedWork` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: RelatedWork` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        relatedWorkV2?: Maybe<JiraVersionRelatedWorkV2Connection>;
        /**
         * The date at which the version was released to customers. Must occur after startDate.
         * This is a beta field and has not been implemented yet.
         */
        releaseDate?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The generated release notes ADF for this version
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: ReleaseNotes` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        releaseNotes?: Maybe<JiraAdf>;
        /**
         * The release notes configuration for the version
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: JiraReleaseNotesConfiguration` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        releaseNotesConfiguration?: Maybe<JiraReleaseNotesConfiguration>;
        /**
         * The selected issue fields to use when generating release notes
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: ReleaseNotesOptions` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        releaseNotesOptionsIssueFields?: Maybe<JiraIssueFieldConnection>;
        /**
         * The selected issue types to use when generating release notes
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: ReleaseNotesOptions` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        releaseNotesOptionsIssueTypes?: Maybe<JiraIssueTypeConnection>;
        /** The type of release note that was last generated/saved */
        releasesNotesPreferenceType?: Maybe<JiraVersionReleaseNotesType>;
        /**
         * Rich text section
         * This is not production ready
         *
         * ### OAuth Scopes
         *
         * One of the following scopes will need to be present on OAuth requests to get data from this field
         *
         * * __jira:atlassian-external__
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "JiraVersionRichTextSection")' query directive to the 'richTextSection' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        richTextSection?: Maybe<JiraVersionRichTextSection>;
        /**
         * Represents a group key where the option belongs to.
         * This will return null because the option does not belong to any group.
         */
        selectableGroupKey?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represent a url of the icon for the option.
         * This will return null because the option does not have an icon associated with it.
         */
        selectableIconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * Textual description of the value.
         * Renders either in dropdowns so users can discern between options
         * or in a form field when used as an active value for a field.
         */
        selectableLabel?: Maybe<Scalars["String"]["output"]>;
        /**
         * Represents a url to make the option clickable.
         * This will return null since the option does not contain a URL.
         */
        selectableUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         * The date at which work on the version began.
         * This is a beta field and has not been implemented yet.
         */
        startDate?: Maybe<Scalars["DateTime"]["output"]>;
        statistics?: Maybe<JiraVersionStatistics>;
        /** Status to which version belongs to. */
        status?: Maybe<JiraVersionStatus>;
        /**
         * List of suggested categories to be displayed when creating a new related work item for a given
         * version.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: SuggestedRelatedWorkCategories` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        suggestedRelatedWorkCategories?: Maybe<
            Array<Maybe<Scalars["String"]["output"]>>
        >;
        /** Version Id. */
        versionId: Scalars["String"]["output"];
        /** The table column visibility states of version details page. If included in the given array, it means the column is hidden. This is stored in user property. */
        versionIssueTableHiddenColumns?: Maybe<
            Array<Maybe<JiraVersionIssueTableColumn>>
        >;
        /**
         * Warning config of the version. This is per project setting.
         *
         * ### Beta Field
         *
         * This field is currently in a beta phase and may change without notice.
         *
         * To use this field you must set a `X-ExperimentalApi: JiraVersionWarningConfig` HTTP header.
         *
         * Use of this header indicates that they are opting into the experimental preview of this field.
         *
         * If you do not set this header then the request will be rejected outright.
         *
         * Once the field moves out of the beta phase, then the header will no longer be required or checked.
         *
         *
         */
        warningConfig?: Maybe<JiraVersionWarningConfig>;
        /** The total count of issues with warnings in the version based on the warnings configuration set by the user. */
        warningsCount?: Maybe<Scalars["Long"]["output"]>;
    };

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionApproversArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionAvailableSitesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionContributorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionCrossProjectVersionArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionEpicsForFilterArgs = {
    searchStr?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionIssueAssociatedDesignsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<GraphStoreVersionAssociatedDesignSortInput>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<JiraVersionIssuesFilter>;
    filters?: InputMaybe<JiraVersionIssuesFiltersInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    sortBy?: InputMaybe<JiraVersionIssuesSortInput>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionNativeReleaseNotesOptionsIssueFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionPlanScenarioValuesArgs = {
    viewId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionRelatedWorkArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionRelatedWorkV2Args = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionReleaseNotesArgs = {
    releaseNoteConfiguration?: InputMaybe<JiraVersionReleaseNotesConfigurationInput>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionReleaseNotesOptionsIssueFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionReleaseNotesOptionsIssueTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Jira Version type that can be either Versions system fields or Versions Custom fields. */
export type JiraVersionStatisticsArgs = {
    boardId: Scalars["ID"]["input"];
};

export type JiraVersionAddApproverInput = {
    /** Atlassian Account ID (AAID) of approver. */
    approverAccountId: Scalars["ID"]["input"];
    /** Version ARI */
    versionId: Scalars["ID"]["input"];
};

export type JiraVersionAddApproverPayload = Payload & {
    __typename?: "JiraVersionAddApproverPayload";
    approverEdge?: Maybe<JiraVersionApproverEdge>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Type for a Jira version approver. */
export type JiraVersionApprover = Node & {
    __typename?: "JiraVersionApprover";
    /** The explanation of why a task has been DECLINED, can be null if a reason isn't given by the approver, or if the task is PENDING or approved */
    declineReason?: Maybe<Scalars["String"]["output"]>;
    /** The description of the task to be approved, can be null if a description isn't given */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Approver ARI. */
    id: Scalars["ID"]["output"];
    /** The status of the task to be approved */
    status?: Maybe<JiraVersionApproverStatus>;
    /** Approver */
    user?: Maybe<User>;
};

/** The connection type for JiraVersionApprover. */
export type JiraVersionApproverConnection = {
    __typename?: "JiraVersionApproverConnection";
    /** The data for edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionApproverEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraVersionApprover connection. */
export type JiraVersionApproverEdge = {
    __typename?: "JiraVersionApproverEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. Contains user details for the version approver. */
    node?: Maybe<JiraVersionApprover>;
};

/** The status of an Approver task in the version */
export enum JiraVersionApproverStatus {
    /** Indicates the task has been approved */
    Approved = "APPROVED",
    /** Indicates the task has been declined */
    Declined = "DECLINED",
    /** Indicates the task is yet to be approved or rejected */
    Pending = "PENDING"
}

/**
 * Marketplace connect app iframe data for Version details page's top right corner extension
 * point(location: atl.jira.releasereport.top.right.panels)
 * If options is null, parsing string json into json object failed while mapping.
 */
export type JiraVersionConnectAddonIframeData = {
    __typename?: "JiraVersionConnectAddonIframeData";
    appKey?: Maybe<Scalars["String"]["output"]>;
    appName?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<Scalars["String"]["output"]>;
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Scalars["JSON"]["output"]>;
};

/** The connection type for JiraVersion. */
export type JiraVersionConnection = {
    __typename?: "JiraVersionConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Contains either the successful result of project versions or an error. */
export type JiraVersionConnectionResult = JiraVersionConnection | QueryError;

export type JiraVersionConnectionResultQueryErrorExtension =
    QueryErrorExtension & {
        __typename?: "JiraVersionConnectionResultQueryErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

/** The connection type for JiraVersionContributor. */
export type JiraVersionContributorConnection = {
    __typename?: "JiraVersionContributorConnection";
    /** The data for edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionContributorEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraIssueType connection. */
export type JiraVersionContributorEdge = {
    __typename?: "JiraVersionContributorEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. Contains user details for the version contributor. */
    node?: Maybe<User>;
};

/** GraphQL input shape for creating new version */
export type JiraVersionCreateMutationInput = {
    /** Description of the version */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** Atlassian Account ID (AAID) of the user who is the driver for the version */
    driver?: InputMaybe<Scalars["ID"]["input"]>;
    /** Name of the version. */
    name: Scalars["String"]["input"];
    /** Project ID of the version */
    projectId: Scalars["ID"]["input"];
    /** Release Date of the version */
    releaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Start Date of the version */
    startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type JiraVersionDeleteApproverPayload = Payload & {
    __typename?: "JiraVersionDeleteApproverPayload";
    deletedApproverId?: Maybe<Scalars["ID"]["output"]>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** This type holds specific information for version details page holding warning config for the version and issues for each category. */
export type JiraVersionDetailPage = {
    __typename?: "JiraVersionDetailPage";
    /**
     * List of issues and its JQL, that have the given version as its fixed version.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    allIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * List of issues and its JQL, that are done issue status category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    doneIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * List of issues and its JQL, that have failing build, and its status is in done issue status category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    failingBuildIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * List of issues and its JQL, that are in-progress issue status category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    inProgressIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * List of issues and its JQL, that have open pull request, and its status is in done issue status category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    openPullRequestIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * List of issues and its JQL, that are in to-do issue status category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    toDoIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * List of issues and its JQL, that have commits that are not a part of pull request, and its status is in done issue status category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unreviewedCodeIssues?: Maybe<JiraVersionDetailPageIssues>;
    /**
     * Warning config of the version. This is per project setting.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    warningConfig?: Maybe<JiraVersionWarningConfig>;
};

/** A list of issues and JQL that results the list of issues. */
export type JiraVersionDetailPageIssues = {
    __typename?: "JiraVersionDetailPageIssues";
    /**
     * Issues returned by the provided JQL query
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issues?: Maybe<JiraIssueConnection>;
    /**
     * JQL that is used to list issues
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jql?: Maybe<Scalars["String"]["output"]>;
};

/** A list of issues and JQL that results the list of issues. */
export type JiraVersionDetailPageIssuesIssuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The section UI in version details page that are collapsed */
export enum JiraVersionDetailsCollapsedUi {
    Description = "DESCRIPTION",
    Issues = "ISSUES",
    IssueAssociatedDesigns = "ISSUE_ASSOCIATED_DESIGNS",
    ProgressCard = "PROGRESS_CARD",
    RelatedWork = "RELATED_WORK",
    RichTextSection = "RICH_TEXT_SECTION",
    RightSidebar = "RIGHT_SIDEBAR"
}

export type JiraVersionDetailsCollapsedUisInput = {
    collapsedUis: Array<JiraVersionDetailsCollapsedUi>;
    versionId: Scalars["ID"]["input"];
};

export type JiraVersionDetailsCollapsedUisPayload = Payload & {
    __typename?: "JiraVersionDetailsCollapsedUisPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    version?: Maybe<JiraVersion>;
};

/** The connection type for JiraVersionDriver. */
export type JiraVersionDriverConnection = {
    __typename?: "JiraVersionDriverConnection";
    /** The data for edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionDriverEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraVersionDriver connection. */
export type JiraVersionDriverEdge = {
    __typename?: "JiraVersionDriverEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. */
    node?: Maybe<User>;
};

export type JiraVersionDriverResult = {
    __typename?: "JiraVersionDriverResult";
    /** Atlassian Account ID (AAID) of the user who is the driver for the version */
    driver?: Maybe<User>;
    queryError?: Maybe<QueryError>;
};

/** An edge in a JiraVersion connection. */
export type JiraVersionEdge = {
    __typename?: "JiraVersionEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the edge. */
    node?: Maybe<JiraVersion>;
};

export type JiraVersionFilterInput = {
    /**
     * The active window to filter the Versions to.
     * The window bounds are equivalent to filtering Versions where (startDate > start AND startDate < end)
     * OR (releasedate > start AND releasedate < end)
     * If no start or end is provided, the window is considered unbounded in that direction.
     */
    activeWithin?: InputMaybe<JiraDateTimeWindow>;
    /** The Project ids to filter Versions to. */
    projectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The raw Project keys to filter Versions to. */
    projectKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Versions that have name match this search string will be returned. */
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    /** The statuses of the Versions to filter to. */
    statuses?: InputMaybe<Array<InputMaybe<JiraVersionStatus>>>;
};

/** Input for Versions values on fields */
export type JiraVersionInput = {
    /** Unique identifier for version field */
    versionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The table column enum of version details page. */
export enum JiraVersionIssueTableColumn {
    /** build status column */
    BuildStatus = "BUILD_STATUS",
    /** deployment status column (either from Bamboo or other providers) */
    DeploymentStatus = "DEPLOYMENT_STATUS",
    /** development status column */
    DevelopmentStatus = "DEVELOPMENT_STATUS",
    /** feature flag status column */
    FeatureFlagStatus = "FEATURE_FLAG_STATUS",
    /** Issue assignee column */
    IssueAssignee = "ISSUE_ASSIGNEE",
    /** Priority column */
    IssuePriority = "ISSUE_PRIORITY",
    /** Issue status column */
    IssueStatus = "ISSUE_STATUS",
    /** More action meat ball menu column */
    MoreAction = "MORE_ACTION",
    /** Warnings column */
    Warnings = "WARNINGS"
}

export type JiraVersionIssueTableColumnHiddenStateInput = {
    /** The columns to hide */
    hiddenColumns: Array<JiraVersionIssueTableColumn>;
    /** Version ARI */
    versionId: Scalars["ID"]["input"];
};

export type JiraVersionIssueTableColumnHiddenStatePayload = Payload & {
    __typename?: "JiraVersionIssueTableColumnHiddenStatePayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** Updated version */
    version?: Maybe<JiraVersion>;
};

/** Type for the result of an update operation to an issue in a version */
export type JiraVersionIssueUpdateResult = {
    __typename?: "JiraVersionIssueUpdateResult";
    /** Issue ID */
    issueId: Scalars["String"]["output"];
    /** Whether it was successfully updated */
    updated: Scalars["Boolean"]["output"];
};

/** The filter for a version's issues */
export enum JiraVersionIssuesFilter {
    All = "ALL",
    Done = "DONE",
    FailingBuild = "FAILING_BUILD",
    InProgress = "IN_PROGRESS",
    OpenPullRequest = "OPEN_PULL_REQUEST",
    OpenReview = "OPEN_REVIEW",
    Todo = "TODO",
    UnreviewedCode = "UNREVIEWED_CODE"
}

export type JiraVersionIssuesFiltersInput = {
    /** Assignee field account ARIs to filter by. Null means, don't apply assignee filter. Null inside array means unassigned issues. */
    assigneeAccountIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    /** Epic ARIs to filter by */
    epicIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Search string to filter by. This will search issue title, description, id and key. */
    searchStr?: InputMaybe<Scalars["String"]["input"]>;
    /** Status categories to filter by */
    statusCategories?: InputMaybe<Array<JiraVersionIssuesStatusCategories>>;
    /** Warning categories to filter by */
    warningCategories?: InputMaybe<Array<JiraVersionWarningCategories>>;
};

/** Fields that can be used to sort issues returned on the version. */
export enum JiraVersionIssuesSortField {
    /** Sort by assignee */
    Assignee = "ASSIGNEE",
    /** Sort by date issue was created */
    Created = "CREATED",
    /** Sort by issue key */
    Key = "KEY",
    /** Sort by priority */
    Priority = "PRIORITY",
    /** Sort by status */
    Status = "STATUS",
    /** Sort by type */
    Type = "TYPE"
}

/** The sort criteria used for a version's issues */
export type JiraVersionIssuesSortInput = {
    order?: InputMaybe<SortDirection>;
    sortByField?: InputMaybe<JiraVersionIssuesSortField>;
};

export enum JiraVersionIssuesStatusCategories {
    /** Issue status done category */
    Done = "DONE",
    /** Issue status in-progress category */
    InProgress = "IN_PROGRESS",
    /** Issue status todo category */
    Todo = "TODO"
}

/** Type for the version plan scenario values */
export type JiraVersionPlanScenarioValues = {
    __typename?: "JiraVersionPlanScenarioValues";
    /** Cross project version if the version is part of one */
    crossProjectVersion?: Maybe<Scalars["String"]["output"]>;
    /** Version description. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Version name. */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The date at which the version was released to customers. Must occur after startDate.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated please use releaseDateValue instead
     */
    releaseDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The date at which the version was released to customers. Must occur after startDate, null if no scenario value change */
    releaseDateValue?: Maybe<JiraDateScenarioValueField>;
    /** The type of the scenario, an issue may be added, updated or deleted. */
    scenarioType?: Maybe<JiraScenarioType>;
    /**
     * The date at which work on the version began.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated please use startDateValue instead
     */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The date at which work on the version began, null if no scenario value change */
    startDateValue?: Maybe<JiraDateScenarioValueField>;
};

/** Jira version related work type, which is used to associate "smart links" with a given Jira version. */
export type JiraVersionRelatedWork = {
    __typename?: "JiraVersionRelatedWork";
    /**
     * User who created the related work item. This field is hydrated via the "identity" service using
     * the "addedById" field provided by the Gira response payload.
     */
    addedBy?: Maybe<User>;
    /** Creation date. */
    addedOn?: Maybe<Scalars["DateTime"]["output"]>;
    /** Category for the related work item. */
    category?: Maybe<Scalars["String"]["output"]>;
    /** Client-generated ID for the related work item. */
    relatedWorkId?: Maybe<Scalars["ID"]["output"]>;
    /** Related work title; can be null if user didn't enter a title when adding the link. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** Related work URL. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type JiraVersionRelatedWorkConfluenceReleaseNotes =
    JiraVersionRelatedWorkV2 & {
        __typename?: "JiraVersionRelatedWorkConfluenceReleaseNotes";
        /**
         * User who created the related work item. This field is hydrated via the "identity" service using
         * the "addedById" field provided by the Gira response payload.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        addedBy?: Maybe<User>;
        /**
         * Creation date.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        addedOn?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The user the related work item has been assigned to. Will be `null` if the work item
         * is not assigned to anyone.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated superseded by issue linking
         */
        assignee?: Maybe<User>;
        /**
         * Category for the related work item.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        category?: Maybe<Scalars["String"]["output"]>;
        /**
         * The Jira issue linked to the related work item.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Client-generated ID for the related work item.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        relatedWorkId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Related work title; can be null if user didn't enter a title when adding the link.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title?: Maybe<Scalars["String"]["output"]>;
        /**
         * Related work URL.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url?: Maybe<Scalars["URL"]["output"]>;
    };

/** The connection type for JiraVersionRelatedWork. */
export type JiraVersionRelatedWorkConnection = {
    __typename?: "JiraVersionRelatedWorkConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionRelatedWorkEdge>>>;
    /** Information about the current page; used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraVersionRelatedWork connection. */
export type JiraVersionRelatedWorkEdge = {
    __typename?: "JiraVersionRelatedWorkEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at this edge. */
    node?: Maybe<JiraVersionRelatedWork>;
};

/** Jira version related work type, which is used to associate "smart links" with a given Jira version. */
export type JiraVersionRelatedWorkGenericLink = JiraVersionRelatedWorkV2 & {
    __typename?: "JiraVersionRelatedWorkGenericLink";
    /**
     * User who created the related work item. This field is hydrated via the "identity" service using
     * the "addedById" field provided by the Gira response payload.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addedBy?: Maybe<User>;
    /**
     * Creation date.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addedOn?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The user the related work item has been assigned to. Will be `null` if the work item
     * is not assigned to anyone.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated superseded by issue linking
     */
    assignee?: Maybe<User>;
    /**
     * Category for the related work item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    category?: Maybe<Scalars["String"]["output"]>;
    /**
     * The Jira issue linked to the related work item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issue?: Maybe<JiraIssue>;
    /**
     * Client-generated ID for the related work item.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relatedWorkId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Related work title; can be null if user didn't enter a title when adding the link.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     * Related work URL.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Jira version related work type, which is used to associate "smart links" with a given Jira version. */
export type JiraVersionRelatedWorkNativeReleaseNotes =
    JiraVersionRelatedWorkV2 & {
        __typename?: "JiraVersionRelatedWorkNativeReleaseNotes";
        /**
         * Creation date.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        addedOn?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         * The user the related work item has been assigned to. Will be `null` if the work item
         * is not assigned to anyone.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated superseded by issue linking
         */
        assignee?: Maybe<User>;
        /**
         * Category for the related work item.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        category?: Maybe<Scalars["String"]["output"]>;
        /**
         * The Jira issue linked to the related work item.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Title for the related work item.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title?: Maybe<Scalars["String"]["output"]>;
    };

/** Enumeration of the kinds of Jira version related work items. */
export enum JiraVersionRelatedWorkType {
    /** A related work item that links to the version's release notes in a Confluence page. */
    ConfluenceReleaseNotes = "CONFLUENCE_RELEASE_NOTES",
    /** The most general kind of related work item - an arbitrary link/URL. */
    GenericLink = "GENERIC_LINK",
    /**
     * A related work item that represents the "native" release notes for the version. These release notes are
     * generated dynamically, and there is at most one per version.
     */
    NativeReleaseNotes = "NATIVE_RELEASE_NOTES"
}

/** Jira version related work type, which is used to associate "smart links" with a given Jira version. */
export type JiraVersionRelatedWorkV2 = {
    /**
     * The user the related work item has been assigned to. Will be `null` if the work item
     * is not assigned to anyone.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated superseded by issue linking
     */
    assignee?: Maybe<User>;
    /** Category for the related work item. */
    category?: Maybe<Scalars["String"]["output"]>;
    /** The Jira issue linked to the related work item. */
    issue?: Maybe<JiraIssue>;
    /** Title for the related work item. */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** The connection type for JiraVersionRelatedWork. */
export type JiraVersionRelatedWorkV2Connection = {
    __typename?: "JiraVersionRelatedWorkV2Connection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionRelatedWorkV2Edge>>>;
    /** Information about the current page; used to aid in pagination. */
    pageInfo: PageInfo;
};

/** An edge in a JiraVersionRelatedWork connection. */
export type JiraVersionRelatedWorkV2Edge = {
    __typename?: "JiraVersionRelatedWorkV2Edge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. */
    node?: Maybe<JiraVersionRelatedWorkV2>;
};

/** The input for fetching a preview of the release notes */
export type JiraVersionReleaseNotesConfigurationInput = {
    /** The ids of issue fields to include when generating release notes */
    issueFieldIds: Array<Scalars["ID"]["input"]>;
    /** The issue key config to include when generating release notes */
    issueKeyConfig: JiraReleaseNotesIssueKeyConfig;
    /** The ids of issue types to include when generating release notes */
    issueTypeIds: Array<Scalars["ID"]["input"]>;
};

/** Types of Release Notes that are available */
export enum JiraVersionReleaseNotesType {
    /** Represents a Release Note generated in Confluence */
    ConfluenceReleaseNote = "CONFLUENCE_RELEASE_NOTE",
    /** Represents the standard html/markdown Release Note Type */
    NativeReleaseNote = "NATIVE_RELEASE_NOTE"
}

/** Contains either the successful fetched version information or an error. */
export type JiraVersionResult = JiraVersion | QueryError;

/** Version rich text section */
export type JiraVersionRichTextSection = {
    __typename?: "JiraVersionRichTextSection";
    /** The content of the section */
    content?: Maybe<JiraAdf>;
    /** The title of the section */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** The argument for sorting project versions. */
export enum JiraVersionSortField {
    Description = "DESCRIPTION",
    Name = "NAME",
    ReleaseDate = "RELEASE_DATE",
    Sequence = "SEQUENCE",
    StartDate = "START_DATE"
}

export type JiraVersionSortInput = {
    order: SortDirection;
    sortByField: JiraVersionSortField;
};

export type JiraVersionStatistics = {
    __typename?: "JiraVersionStatistics";
    done?: Maybe<Scalars["Int"]["output"]>;
    doneEstimate?: Maybe<Scalars["Float"]["output"]>;
    estimated?: Maybe<Scalars["Int"]["output"]>;
    inProgress?: Maybe<Scalars["Int"]["output"]>;
    notDoneEstimate?: Maybe<Scalars["Float"]["output"]>;
    notEstimated?: Maybe<Scalars["Int"]["output"]>;
    percentageCompleted?: Maybe<Scalars["Float"]["output"]>;
    percentageEstimated?: Maybe<Scalars["Float"]["output"]>;
    percentageUnestimated?: Maybe<Scalars["Float"]["output"]>;
    toDo?: Maybe<Scalars["Int"]["output"]>;
    totalEstimate?: Maybe<Scalars["Float"]["output"]>;
    totalIssueCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The status of a version field. */
export enum JiraVersionStatus {
    /** Indicates the version is archived, no further changes can be made to this version unless it is un-archived */
    Archived = "ARCHIVED",
    /** Indicates the version is available to public */
    Released = "RELEASED",
    /** Indicates the version is not launched yet */
    Unreleased = "UNRELEASED"
}

/** The connection type for Jira Version approver suggestion */
export type JiraVersionSuggestedApproverConnection = {
    __typename?: "JiraVersionSuggestedApproverConnection";
    /** The data for edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraVersionSuggestedApproverEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
};

/** The edge type for Jira Version approver suggestion */
export type JiraVersionSuggestedApproverEdge = {
    __typename?: "JiraVersionSuggestedApproverEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at this edge. */
    node?: Maybe<User>;
};

export type JiraVersionUpdateApproverDeclineReasonInput = {
    /** Approver ARI to update decline reason */
    approverId: Scalars["ID"]["input"];
    /** The new decline reason. Null means no reason saved, that is identical to empty string */
    reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraVersionUpdateApproverDeclineReasonPayload = Payload & {
    __typename?: "JiraVersionUpdateApproverDeclineReasonPayload";
    /** The approver result after updating the decline reason */
    approver?: Maybe<JiraVersionApprover>;
    /** Error collection of the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** Success state of the mutation */
    success: Scalars["Boolean"]["output"];
};

/** The input to update approval description */
export type JiraVersionUpdateApproverDescriptionInput = {
    /** Approver ARI. */
    approverId: Scalars["ID"]["input"];
    /** The description of the task to be approved. Null means empty description. */
    description?: InputMaybe<Scalars["String"]["input"]>;
};

/** The return payload of updating an approval description */
export type JiraVersionUpdateApproverDescriptionPayload = Payload & {
    __typename?: "JiraVersionUpdateApproverDescriptionPayload";
    /** The updated approver */
    approver?: Maybe<JiraVersionApprover>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The input to update approval status */
export type JiraVersionUpdateApproverStatusInput = {
    /** Approver ARI. */
    approverId: Scalars["ID"]["input"];
    /** The status of the task */
    status?: InputMaybe<JiraVersionApproverStatus>;
};

/** The return payload of updating an approval description */
export type JiraVersionUpdateApproverStatusPayload = Payload & {
    __typename?: "JiraVersionUpdateApproverStatusPayload";
    /** The updated approver */
    approver?: Maybe<JiraVersionApprover>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** GraphQL input shape for updating an entire(all fields) version object */
export type JiraVersionUpdateMutationInput = {
    /** Description of the version */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** Atlassian Account ID (AAID) of the user who is the driver for the version */
    driver?: InputMaybe<Scalars["ID"]["input"]>;
    /** JiraVersion ARI. */
    id: Scalars["ID"]["input"];
    /** Name of the version. */
    name: Scalars["String"]["input"];
    /** Release Date of the version */
    releaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** Start Date of the version */
    startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

/**
 * The warning configuration to be updated for version details page warning report.
 * Applicable values will have their value updated. Null values will default to true.
 */
export type JiraVersionUpdatedWarningConfigInput = {
    /** The warnings for issues that has failing build and in done issue status category. */
    isFailingBuildEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The warnings for issues that has open pull request and in done issue status category. */
    isOpenPullRequestEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The warnings for issues that has open review(FishEye/Crucible integration) and in done issue status category. */
    isOpenReviewEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The warnings for issues that has unreviewed code and in done issue status category. */
    isUnreviewedCodeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum JiraVersionWarningCategories {
    /** Category to list issues with failing build in the version */
    FailingBuild = "FAILING_BUILD",
    /** Category to list issues with pull request still open in the version */
    OpenPullRequest = "OPEN_PULL_REQUEST",
    /** Category to list issues with review(FishEye/Crucible specific entity) still open in the version */
    OpenReview = "OPEN_REVIEW",
    /** Category to list issues with some code linked that is not reviewed in the version */
    UnreviewedCode = "UNREVIEWED_CODE"
}

/** The warning configuration to generate version details page warning report. */
export type JiraVersionWarningConfig = {
    __typename?: "JiraVersionWarningConfig";
    /** Whether the user requesting the warning config has edit permissions. */
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    /** The warnings for issues that has failing build and in done issue status category. */
    failingBuild?: Maybe<JiraVersionWarningConfigState>;
    /** The warnings for issues that has open pull request and in done issue status category. */
    openPullRequest?: Maybe<JiraVersionWarningConfigState>;
    /** The warnings for issues that has open review and in done issue status category (only applicable for FishEye/Crucible integration to Jira). */
    openReview?: Maybe<JiraVersionWarningConfigState>;
    /** The warnings for issues that has unreviewed code and in done issue status category. */
    unreviewedCode?: Maybe<JiraVersionWarningConfigState>;
};

/** The warning config for version details page to generate warning report. Depending on tenant settings and providers installed, some warning config could be in NOT_APPLICABLE state. */
export enum JiraVersionWarningConfigState {
    Disabled = "DISABLED",
    Enabled = "ENABLED",
    NotApplicable = "NOT_APPLICABLE"
}

export type JiraView = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    error?: Maybe<QueryError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

/**
 * "
 * Configuration regarding the filters being applied on the board view.
 */
export type JiraViewFilterConfig = {
    __typename?: "JiraViewFilterConfig";
    /** JQL of the filters applied to the board view. */
    jql?: Maybe<Scalars["String"]["output"]>;
};

/** Configuration regarding the field to group the board view by. */
export type JiraViewGroupByConfig = {
    __typename?: "JiraViewGroupByConfig";
    /** The fieldId of the field to group the board view by. */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the field to group the board view by. */
    fieldName?: Maybe<Scalars["String"]["output"]>;
};

/** Input for the view that can be shared across multiple products, i.e., Jira Calendar */
export type JiraViewScopeInput = {
    /** Combination of ARIs to fetch data from different entities. Supported ARIs now are project and board. */
    ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Project keys provided as a way to fetch data relating to projects. */
    projectKeys?: InputMaybe<JiraProjectKeysInput>;
};

/** The reason why an extension shouldn't be visible in the given context. */
export enum JiraVisibilityControlMechanism {
    /** A Jira admin blocked the app from accessing the data in the given context using [App Access Rules](https://support.atlassian.com/security-and-access-policies/docs/block-app-access/). */
    AppAccessRules = "AppAccessRules",
    /** The extension specified [Display Conditions](https://developer.atlassian.com/platform/forge/manifest-reference/display-conditions/) that evaluated to `false`. The app doesn't want the extension to be visible in the given context. */
    DisplayConditions = "DisplayConditions"
}

/** Represents the votes information of an Issue. */
export type JiraVote = {
    __typename?: "JiraVote";
    /** Count of users who have voted for this Issue. */
    count?: Maybe<Scalars["Long"]["output"]>;
    /** Indicates whether the current user has voted for this Issue. */
    hasVoted?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents a votes field on a Jira Issue. */
export type JiraVotesField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraVotesField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        selectedUsersConnection?: Maybe<JiraUserConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Represents the vote value selected on the Issue.
         * Can be null when voting is disabled.
         */
        vote?: Maybe<JiraVote>;
    };

/** Represents a votes field on a Jira Issue. */
export type JiraVotesFieldSelectedUsersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraVotesFieldOperationInput = {
    operation: JiraVotesOperations;
};

export type JiraVotesFieldPayload = Payload & {
    __typename?: "JiraVotesFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraVotesField>;
    success: Scalars["Boolean"]["output"];
};

/** Operations that can be performed on vote field. */
export enum JiraVotesOperations {
    /** Adds voter to an issue. */
    Add = "ADD",
    /** Removes voter from an issue. */
    Remove = "REMOVE"
}

/** Represents the watches information. */
export type JiraWatch = {
    __typename?: "JiraWatch";
    /** Count of users who are watching this issue. */
    count?: Maybe<Scalars["Long"]["output"]>;
    /** Indicates whether the current user is watching this issue. */
    isWatching?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents the Watches system field. */
export type JiraWatchesField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraWatchesField";
        /** The field ID alias (if applicable). */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /** Description for the field (if present). */
        description?: Maybe<Scalars["String"]["output"]>;
        /** Attributes of an issue field's configuration info. */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /** The identifier of the field. E.g. summary, customfield_10001, etc. */
        fieldId: Scalars["String"]["output"];
        /** available field operations for the issue field */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /** Unique identifier for the field. */
        id: Scalars["ID"]["output"];
        /** Whether or not the field is editable in the issue view. */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /** Backlink to the parent issue, to aid in simple fragment design */
        issue?: Maybe<JiraIssue>;
        /** Translated name for the field (if applicable). */
        name: Scalars["String"]["output"];
        /** The current users watching on the Issue. */
        selectedUsersConnection?: Maybe<JiraUserConnection>;
        /** Users who can be added as watchers to the issue. */
        suggestedWatchers?: Maybe<JiraUserConnection>;
        /** Field type key. */
        type: Scalars["String"]["output"];
        /** Configuration changes which a user can apply to a field. E.g. pin or hide the field. */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
        /**
         * Represents the watch value selected on the Issue.
         * Can be null when watching is disabled.
         */
        watch?: Maybe<JiraWatch>;
    };

/** Represents the Watches system field. */
export type JiraWatchesFieldSelectedUsersConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents the Watches system field. */
export type JiraWatchesFieldSuggestedWatchersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    searchBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type JiraWatchesFieldOperationInput = {
    /**
     * The accountId is optional, in case of missing accountId the logged in user will be added/removed as a watcher.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This is no longer supported and will be ignored in favour of 'id' param
     */
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * Accepts ARI(s): user
     * The user is optional, in case of missing user the logged in user will be added/removed as a watcher.
     */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    operation: JiraWatchesOperations;
};

export type JiraWatchesFieldPayload = Payload & {
    __typename?: "JiraWatchesFieldPayload";
    errors?: Maybe<Array<MutationError>>;
    field?: Maybe<JiraWatchesField>;
    success: Scalars["Boolean"]["output"];
};

/** Operations that can be performed on watches field. */
export enum JiraWatchesOperations {
    /** Adds watcher to an issue. */
    Add = "ADD",
    /** Removes watcher from an issue. */
    Remove = "REMOVE"
}

export type JiraWebRemoteIssueLink = {
    __typename?: "JiraWebRemoteIssueLink";
    /** The URL of the item. */
    href?: Maybe<Scalars["String"]["output"]>;
    /** The URL of an icon. */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The Remote Link ARI. */
    id: Scalars["ID"]["output"];
    /** The summary details of the item. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The title of the item. */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a WorkCategory. */
export type JiraWorkCategory = {
    __typename?: "JiraWorkCategory";
    /**
     * The value of the WorkCategory.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Represents the WorkCategory field on an Issue. */
export type JiraWorkCategoryField = JiraIssueField &
    JiraIssueFieldConfiguration &
    Node & {
        __typename?: "JiraWorkCategoryField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * The WorkCategory selected on the Issue or default WorkCategory configured for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        workCategory?: Maybe<JiraWorkCategory>;
    };

/** The connection type for JiraWorklog. */
export type JiraWorkLogConnection = {
    __typename?: "JiraWorkLogConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraWorkLogEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** The approximate count of items in the connection. */
    indicativeCount?: Maybe<Scalars["Int"]["output"]>;
    /** The page info of the current page of results. */
    pageInfo: PageInfo;
};

/** An edge in a JiraWorkLog connection. */
export type JiraWorkLogEdge = {
    __typename?: "JiraWorkLogEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The node at the the edge. */
    node?: Maybe<JiraWorklog>;
};

/** Represents the log work field on jira issue screens. Used to log time while working on issues */
export type JiraWorkLogField = JiraIssueField &
    JiraIssueFieldConfiguration &
    JiraUserIssueFieldConfiguration &
    Node & {
        __typename?: "JiraWorkLogField";
        /**
         * The field ID alias (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        aliasFieldId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Description for the field (if present).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Attributes of an issue field's configuration info.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldConfig?: Maybe<JiraFieldConfig>;
        /**
         * The identifier of the field. E.g. summary, customfield_10001, etc.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldId: Scalars["String"]["output"];
        /**
         * available field operations for the issue field
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        fieldOperations?: Maybe<JiraFieldOperation>;
        /**
         * Unique identifier for the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         * Whether or not the field is editable in the issue view.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isEditableInIssueView?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * Backlink to the parent issue, to aid in simple fragment design
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        issue?: Maybe<JiraIssue>;
        /**
         * Contains the information needed to add a media content to this field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mediaContext?: Maybe<JiraMediaContext>;
        /**
         * Translated name for the field (if applicable).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        name: Scalars["String"]["output"];
        /**
         * This represents the global time tracking settings configuration like working hours and days.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        timeTrackingSettings?: Maybe<JiraTimeTrackingSettings>;
        /**
         * Field type key.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: Scalars["String"]["output"];
        /**
         * Configuration changes which a user can apply to a field. E.g. pin or hide the field.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        userFieldConfig?: Maybe<JiraUserFieldConfig>;
    };

export type JiraWorkManagementActiveBackgroundDetailsResult =
    | JiraWorkManagementAttachmentBackground
    | JiraWorkManagementColorBackground
    | JiraWorkManagementGradientBackground
    | JiraWorkManagementMediaBackground
    | QueryError;

export type JiraWorkManagementAssociateFieldInput = {
    /** The ID of the field to associate. */
    fieldId: Scalars["String"]["input"];
    /** Optional list of issue type IDs to associate the fields to. */
    issueTypeIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    /** The Jira Project ID. */
    projectId: Scalars["Long"]["input"];
};

export type JiraWorkManagementAssociateFieldPayload = Payload & {
    __typename?: "JiraWorkManagementAssociateFieldPayload";
    /** A list of issue type IDs that the field is associated to. */
    associatedIssueTypeIds?: Maybe<Array<Maybe<Scalars["Long"]["output"]>>>;
    /** A list of errors that occurred when trying to associate the field. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the field was associated successfully. */
    success: Scalars["Boolean"]["output"];
};

/** A Jira Work Management Attachment Background, used only when the entity is of Issue type */
export type JiraWorkManagementAttachmentBackground =
    JiraWorkManagementBackground & {
        __typename?: "JiraWorkManagementAttachmentBackground";
        /** the attachment if the background is an attachment (issue) type */
        attachment?: Maybe<JiraAttachment>;
        /** The entityId (ARI) of the issue the background belongs to */
        entityId?: Maybe<Scalars["ID"]["output"]>;
    };

/** Interface for backgrounds in JWM */
export type JiraWorkManagementBackground = {
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

/** The supported background types */
export enum JiraWorkManagementBackgroundType {
    Attachment = "ATTACHMENT",
    Color = "COLOR",
    Custom = "CUSTOM",
    Gradient = "GRADIENT"
}

/** Type to hold Jira Work Management Background upload token auth details */
export type JiraWorkManagementBackgroundUploadToken = {
    __typename?: "JiraWorkManagementBackgroundUploadToken";
    /** The target collection the token grants access to */
    targetCollection?: Maybe<Scalars["String"]["output"]>;
    /** The token to access the MediaAPI */
    token?: Maybe<Scalars["String"]["output"]>;
    /** The duration the token is valid */
    tokenDurationInSeconds?: Maybe<Scalars["Long"]["output"]>;
};

export type JiraWorkManagementBackgroundUploadTokenResult =
    | JiraWorkManagementBackgroundUploadToken
    | QueryError;

/** Represents the input data required for JWM board settings . */
export type JiraWorkManagementBoardSettingsInput = {
    /**
     * Number of days to use as the cutoff for completed issues search.
     * Must be between 1 and 90 days.
     */
    completedIssueSearchCutOffInDays: Scalars["Int"]["input"];
    /** Project to create issue within, encoded as an ARI */
    projectId: Scalars["ID"]["input"];
};

/** Represents the payload of the JWM board settings mutation. */
export type JiraWorkManagementBoardSettingsPayload = Payload & {
    __typename?: "JiraWorkManagementBoardSettingsPayload";
    /** A list of errors that occurred when trying to persist board settings. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the board settings was stored successfully. */
    success: Scalars["Boolean"]["output"];
};

export type JiraWorkManagementChildSummary = {
    __typename?: "JiraWorkManagementChildSummary";
    /** True if there any children issues returned or when there are too many to return */
    hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
    /** The number of child issues associated with the issue */
    totalCount?: Maybe<Scalars["Long"]["output"]>;
};

/** A Jira Work Management Background which is a solid color type */
export type JiraWorkManagementColorBackground = JiraWorkManagementBackground & {
    __typename?: "JiraWorkManagementColorBackground";
    /** The color if the background is a color type */
    colorValue?: Maybe<Scalars["String"]["output"]>;
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

export type JiraWorkManagementCommentSummary = {
    __typename?: "JiraWorkManagementCommentSummary";
    /** Number of comments on this item */
    totalCount?: Maybe<Scalars["Long"]["output"]>;
};

/** Input for creating a Jira Work Management Custom Background */
export type JiraWorkManagementCreateCustomBackgroundInput = {
    /** The alt text associated with the custom background */
    altText: Scalars["String"]["input"];
    /** The entityId (ARI) of the entity to be updated with the created background */
    entityId: Scalars["ID"]["input"];
    /** The created mediaApiFileId of the background to create */
    mediaApiFileId: Scalars["String"]["input"];
};

/** The response for the jwmCreateCustomBackground mutation */
export type JiraWorkManagementCreateCustomBackgroundPayload = Payload & {
    __typename?: "JiraWorkManagementCreateCustomBackgroundPayload";
    /** Custom background created by the mutation */
    background?: Maybe<JiraWorkManagementMediaBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraWorkManagementCreateFilterInput = {
    /** ARI that encodes the ID of the project or project overview the filter was created on */
    contextId: Scalars["ID"]["input"];
    /** JQL of filter to store */
    jql: Scalars["String"]["input"];
    /** Name of filter to create */
    name: Scalars["String"]["input"];
};

export type JiraWorkManagementCreateFilterPayload = Payload & {
    __typename?: "JiraWorkManagementCreateFilterPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** JiraWorkManagementFilter created by the mutation */
    filter?: Maybe<JiraWorkManagementFilter>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Represents the input data required for JWM issue creation. */
export type JiraWorkManagementCreateIssueInput = {
    /** Field data to populate the created issue with. Mandatory due to required fields such as Summary. */
    fields: JiraIssueFieldsInput;
    /** Issue type of issue to create in numeric format. E.g. 10000 */
    issueTypeId: Scalars["ID"]["input"];
    /** Project to create issue within, encoded as an ARI */
    projectId: Scalars["ID"]["input"];
    /** Rank Issue following creation */
    rank?: InputMaybe<JiraWorkManagementRankInput>;
    /** Transition Issue following creation in numeric format. E.g. 10000 */
    transitionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Represents the payload of the JWM Create Issue mutation. */
export type JiraWorkManagementCreateIssuePayload = {
    __typename?: "JiraWorkManagementCreateIssuePayload";
    /** A list of errors that occurred when trying to create the issue. */
    errors?: Maybe<Array<MutationError>>;
    /** The issue after it has been created, this will be null if create failed */
    issue?: Maybe<JiraIssue>;
    /** Whether the issue was updated successfully. */
    success: Scalars["Boolean"]["output"];
};

/** Input for creating a Jira Work Management Overview. */
export type JiraWorkManagementCreateOverviewInput = {
    /** Name of the Jira Work Management Overview. */
    name: Scalars["String"]["input"];
    /** Project IDs (ARIs) to include in the created Jira Work Management Overview. */
    projectIds: Array<Scalars["ID"]["input"]>;
    /** Theme to set for the created Jira Work Management Overview. */
    theme?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for creating a saved view. */
export type JiraWorkManagementCreateSavedViewInput = {
    /** The label for the saved view, for display purposes. */
    label?: InputMaybe<Scalars["String"]["input"]>;
    /** ARI of the project to create a saved view for. */
    projectId: Scalars["ID"]["input"];
    /** The key of the type of the saved view. */
    typeKey: Scalars["String"]["input"];
};

/** Response for the create saved view mutation. */
export type JiraWorkManagementCreateSavedViewPayload = Payload & {
    __typename?: "JiraWorkManagementCreateSavedViewPayload";
    /** List of errors while performing the create saved view mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The created saved view. Null if creation was not successful. */
    savedView?: Maybe<JiraWorkManagementSavedView>;
    /** Denotes whether the create saved view mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** The type for a Jira Work Management Custom Background, which is associated with a Media API file */
export type JiraWorkManagementCustomBackground = {
    __typename?: "JiraWorkManagementCustomBackground";
    /** Number of entities for which this background is currently active */
    activeCount?: Maybe<Scalars["Long"]["output"]>;
    /** The alt text associated with the custom background */
    altText?: Maybe<Scalars["String"]["output"]>;
    /** The id of the custom background */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The mediaApiFileId of the custom background */
    mediaApiFileId?: Maybe<Scalars["String"]["output"]>;
    /** Contains the information needed for reading uploaded media content in jira. */
    mediaReadToken?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier of the image in the external source, if applicable */
    sourceIdentifier?: Maybe<Scalars["String"]["output"]>;
    /** The external source of the image, if applicable. ex. Unsplash */
    sourceType?: Maybe<Scalars["String"]["output"]>;
};

/** The type for a Jira Work Management Custom Background, which is associated with a Media API file */
export type JiraWorkManagementCustomBackgroundMediaReadTokenArgs = {
    durationInSeconds: Scalars["Int"]["input"];
};

/** The connection type for Jira Work Management Custom Background. */
export type JiraWorkManagementCustomBackgroundConnection = {
    __typename?: "JiraWorkManagementCustomBackgroundConnection";
    /** A list of nodes in the current page. */
    edges?: Maybe<Array<Maybe<JiraWorkManagementCustomBackgroundEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The edge type for Jira Work Management Custom Background. */
export type JiraWorkManagementCustomBackgroundEdge = {
    __typename?: "JiraWorkManagementCustomBackgroundEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraWorkManagementCustomBackground>;
};

/** Represents the input data required for Jwm Delete Attachment mutation. */
export type JiraWorkManagementDeleteAttachmentInput = {
    /** The ARI of the attachment to be deleted */
    id: Scalars["ID"]["input"];
};

/** Represents the payload of the Jwm Delete Attachment mutation. */
export type JiraWorkManagementDeleteAttachmentPayload = Payload & {
    __typename?: "JiraWorkManagementDeleteAttachmentPayload";
    /** The ID of the deleted attachment or null if the attachment was not deleted. */
    deletedAttachmentId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors that occurred when trying to delete the attachment. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the attachment was deleted successfully. */
    success: Scalars["Boolean"]["output"];
};

/** The input for deleting a custom background */
export type JiraWorkManagementDeleteCustomBackgroundInput = {
    /** The identifier which indicates the cloud instance this data is to be fetched for */
    cloudId: Scalars["ID"]["input"];
    /** The customBackgroundId of the custom background to delete */
    customBackgroundId: Scalars["ID"]["input"];
};

/** The response for the jwmDeleteCustomBackground mutation */
export type JiraWorkManagementDeleteCustomBackgroundPayload = Payload & {
    __typename?: "JiraWorkManagementDeleteCustomBackgroundPayload";
    /** The customBackgroundId of the deleted custom background */
    customBackgroundId?: Maybe<Scalars["ID"]["output"]>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input for deleting a Jira Work Management Overview. */
export type JiraWorkManagementDeleteOverviewInput = {
    /** Global identifier (ARI) of the Jira Work Management Overview to delete. */
    id: Scalars["ID"]["input"];
};

export type JiraWorkManagementFilter = Node & {
    __typename?: "JiraWorkManagementFilter";
    /**
     * The JiraCustomFilter being returned
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use fields on JiraWorkManagementFilter instead
     */
    filter?: Maybe<JiraCustomFilter>;
    /** An ARI-format value that encodes the filterId. */
    id: Scalars["ID"]["output"];
    /** Determines if the filter is editable by user */
    isEditable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Determines whether the filter is currently starred by the user viewing the filter. */
    isFavorite?: Maybe<Scalars["Boolean"]["output"]>;
    /** JQL associated with the filter. */
    jql?: Maybe<Scalars["String"]["output"]>;
    /** A string representing the filter name. */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JiraWorkManagementFilterConnection = {
    __typename?: "JiraWorkManagementFilterConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraWorkManagementFilterEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraWorkManagementFilterConnectionResult =
    | JiraWorkManagementFilterConnection
    | QueryError;

export type JiraWorkManagementFilterEdge = {
    __typename?: "JiraWorkManagementFilterEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraWorkManagementFilter>;
};

export type JiraWorkManagementFilterSearchInput = {
    /** An ARI of the context to search for filters by */
    contextId: Scalars["ID"]["input"];
    /** Search for only favorite filters */
    favoritesOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    /**
     * Search by filter name. The string is broken into white-space delimited words and each word is
     * used as a OR'ed partial match for the filter name.  If this is null, the filters returned will not be filtered by name
     */
    keyword?: InputMaybe<Scalars["String"]["input"]>;
};

/** A node that represents a Jira Work Management form and all the configuration associated with it. */
export type JiraWorkManagementFormConfiguration = Node & {
    __typename?: "JiraWorkManagementFormConfiguration";
    /** The access level of the form */
    accessLevel?: Maybe<Scalars["String"]["output"]>;
    /** The colour of the banner */
    bannerColor?: Maybe<Scalars["String"]["output"]>;
    /** The form description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** True if the form is enabled */
    enabled: Scalars["Boolean"]["output"];
    /** Any errors when fetching the form */
    errors?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** The fields configured on the form */
    fields?: Maybe<Array<Maybe<JiraWorkManagementFormField>>>;
    /** The ID of the form entity */
    formId: Scalars["ID"]["output"];
    /** The unique identifier of this form configuration */
    id: Scalars["ID"]["output"];
    /** True if and only if the CREATE_ISSUES permission is granted to Application Role (Any logged in user) */
    isSubmittableByAllLoggedInUsers: Scalars["Boolean"]["output"];
    /**
     * The issue type is either:
     * * The issue type stored on the form
     * * If an issue type is not stored on the form, returns the configured Default issue type for the project
     * * If no default is configured, returns first non-subtask issue type in the schema,
     * * If issue type is deleted from the instance, but its ID still saved on the form, the value here will be null
     */
    issueType?: Maybe<JiraIssueType>;
    /** The Jira Project ID */
    projectId: Scalars["Long"]["output"];
    /** The form title */
    title: Scalars["String"]["output"];
    /** The user who last updated the form */
    updateAuthor?: Maybe<User>;
    /** The date and time the form was last updated */
    updated: Scalars["DateTime"]["output"];
};

/** Represents a Jira Issue Field and its alias within the form. */
export type JiraWorkManagementFormField = {
    __typename?: "JiraWorkManagementFormField";
    /** The field alias as defined in the form configuration by the user */
    alias?: Maybe<Scalars["String"]["output"]>;
    /** The field as defined in the form configuration */
    field: JiraIssueField;
    /** The field ID */
    fieldId: Scalars["ID"]["output"];
    /** The unique identifier of this field within the form */
    id: Scalars["ID"]["output"];
};

/** Response for the create Jira Work Management Overview mutation. */
export type JiraWorkManagementGiraCreateOverviewPayload = Payload & {
    __typename?: "JiraWorkManagementGiraCreateOverviewPayload";
    /** List of errors while performing the create overview mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Newly created Jira Work Management Overview if the create mutation was successful. */
    jwmOverview?: Maybe<JiraWorkManagementGiraOverview>;
    /** Denotes whether the create overview mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** Response for the delete Jira Work Management Overview mutation. */
export type JiraWorkManagementGiraDeleteOverviewPayload = Payload & {
    __typename?: "JiraWorkManagementGiraDeleteOverviewPayload";
    /** List of errors while performing the delete overview mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the delete overview mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */
export type JiraWorkManagementGiraOverview = Node & {
    __typename?: "JiraWorkManagementGiraOverview";
    /** The creator of the overview. */
    author?: Maybe<User>;
    /** A connection of fields for the overview. */
    fields?: Maybe<JiraJqlFieldConnection>;
    /** Global identifier (ARI) for the overview. */
    id: Scalars["ID"]["output"];
    /** The name of the overview. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** A connection of project IDs contained within the overview. */
    projects?: Maybe<JiraProjectConnection>;
    /** The theme name (i.e. background colour) for the overview. */
    theme?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */
export type JiraWorkManagementGiraOverviewFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */
export type JiraWorkManagementGiraOverviewProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for Jira Work Management Overview. */
export type JiraWorkManagementGiraOverviewConnection = {
    __typename?: "JiraWorkManagementGiraOverviewConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraWorkManagementGiraOverviewEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo: PageInfo;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The edge type for Jira Work Management Overview. */
export type JiraWorkManagementGiraOverviewEdge = {
    __typename?: "JiraWorkManagementGiraOverviewEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The Jira Overview node. */
    node?: Maybe<JiraWorkManagementGiraOverview>;
};

export type JiraWorkManagementGiraOverviewResult =
    | JiraWorkManagementGiraOverview
    | QueryError;

/** Response for the update Jira Work Management Overview mutation. */
export type JiraWorkManagementGiraUpdateOverviewPayload = Payload & {
    __typename?: "JiraWorkManagementGiraUpdateOverviewPayload";
    /** List of errors while performing the update overview mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated Jira Work Management Overview if the update mutation was successful. */
    jwmOverview?: Maybe<JiraWorkManagementGiraOverview>;
    /** Denotes whether the update overview mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** A Jira Work Management Background which is a gradient type */
export type JiraWorkManagementGradientBackground =
    JiraWorkManagementBackground & {
        __typename?: "JiraWorkManagementGradientBackground";
        /** The entityId (ARI) of the entity the background belongs to */
        entityId?: Maybe<Scalars["ID"]["output"]>;
        /** The gradient if the background is a gradient type */
        gradientValue?: Maybe<Scalars["String"]["output"]>;
    };

export type JiraWorkManagementLicensing = {
    __typename?: "JiraWorkManagementLicensing";
    currentUserSeatEdition?: Maybe<JiraWorkManagementUserLicenseSeatEdition>;
};

/** A Jira Work Management Media Background Media, containing a reference to a custom background */
export type JiraWorkManagementMediaBackground = JiraWorkManagementBackground & {
    __typename?: "JiraWorkManagementMediaBackground";
    /** The customBackground that the background is set to */
    customBackground?: Maybe<JiraWorkManagementCustomBackground>;
    /** The entityId (ARI) of the entity the background belongs to */
    entityId?: Maybe<Scalars["ID"]["output"]>;
};

export type JiraWorkManagementNavigation = {
    __typename?: "JiraWorkManagementNavigation";
    /** Return a connection to show user's favorited JWM projects */
    favoriteProjects?: Maybe<JiraProjectConnection>;
    /** Return the user's JWM licensing information */
    jwmLicensing?: Maybe<JiraWorkManagementLicensing>;
    /**
     * Field returning the state of the overview-plan migration for the logged in user.
     * This overview-plan migration process is part of the Ploverview project in the context of the Spork initiative.
     * See https://hello.atlassian.net/wiki/spaces/Spork/pages/3401604606/Migrate+overviews+to+plans
     */
    jwmOverviewPlanMigrationState?: Maybe<JiraOverviewPlanMigrationStateResult>;
    /**
     * Returns a connection of Jira Work Management overviews that belong to the requesting user.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jwmOverviews?: Maybe<JiraWorkManagementGiraOverviewConnection>;
    /** Return a connection to show recently visited JWM projects for the user */
    recentProjects?: Maybe<JiraProjectConnection>;
};

export type JiraWorkManagementNavigationFavoriteProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraWorkManagementNavigationJwmOverviewsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraWorkManagementNavigationRecentProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraWorkManagementProjectNavigationMetadata = {
    __typename?: "JiraWorkManagementProjectNavigationMetadata";
    boardName: Scalars["String"]["output"];
};

/** Represents the input data to rank an issue upon creation. */
export type JiraWorkManagementRankInput = {
    /**
     * ID of Issue after which the created issue should be ranked. Encoded as an ARI. Cannot be sent alongside before.
     * Accepts ARI(s): issue
     */
    after?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * ID of Issue before which the created issue should be ranked. Encoded as an ARI. Cannot be sent alongside after.
     * Accepts ARI(s): issue
     */
    before?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The input for deleting an active background */
export type JiraWorkManagementRemoveActiveBackgroundInput = {
    /** The entityId (ARI) of the entity to remove the active background for */
    entityId: Scalars["ID"]["input"];
};

/** The response for the jwmRemoveActiveBackground mutation */
export type JiraWorkManagementRemoveActiveBackgroundPayload = Payload & {
    __typename?: "JiraWorkManagementRemoveActiveBackgroundPayload";
    /** List of errors while performing the remove background mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Denotes whether the remove active background mutation was successful. */
    success: Scalars["Boolean"]["output"];
};

/** The general concrete type for navigation items in JWM. Represents a saved view in the horizontal navigation. */
export type JiraWorkManagementSavedView = JiraNavigationItem &
    Node & {
        __typename?: "JiraWorkManagementSavedView";
        /** Whether this saved view can be removed from its scope, based on the authenticated user. */
        canRemove?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this item can be renamed to have a custom user-provided label. */
        canRename?: Maybe<Scalars["Boolean"]["output"]>;
        /** Whether this saved view can be set as the default within its scope, based on the authenticated user. */
        canSetAsDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /** Global identifier (ARI) for the saved view. */
        id: Scalars["ID"]["output"];
        /** Whether this is the default saved view within the requested scope. Only one may be the default. */
        isDefault?: Maybe<Scalars["Boolean"]["output"]>;
        /**
         * The label for this saved view, for display purposes. This can either be the default label based on the
         * type, or a user-provided value.
         */
        label?: Maybe<Scalars["String"]["output"]>;
        /**
         * The type of the saved view.
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Use the field 'typeKey' to identify the type of this saved view.
         */
        type?: Maybe<JiraWorkManagementSavedViewType>;
        /** Identifies the type of this saved view. */
        typeKey?: Maybe<JiraNavigationItemTypeKey>;
        /** The URL to navigate to when this saved view is selected. */
        url?: Maybe<Scalars["String"]["output"]>;
    };

export type JiraWorkManagementSavedViewResult =
    | JiraWorkManagementSavedView
    | QueryError;

/** Represents a type of saved view, identified by its `JiraNavigationItemTypeKey`. */
export type JiraWorkManagementSavedViewType = Node & {
    __typename?: "JiraWorkManagementSavedViewType";
    /** Opaque ID uniquely identifying this view type. */
    id: Scalars["ID"]["output"];
    /**
     * The saved view type's identifying key. e.g. "board", "list".
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced by the enum-based 'typeKey' field
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /** The localized label for this saved view type, for display purposes. */
    label?: Maybe<Scalars["String"]["output"]>;
    /** The key identifying this saved view type, represented as an enum. */
    typeKey?: Maybe<JiraNavigationItemTypeKey>;
};

/** The connection type for saved view types. */
export type JiraWorkManagementSavedViewTypeConnection = HasPageInfo & {
    __typename?: "JiraWorkManagementSavedViewTypeConnection";
    /** A list of edges. */
    edges?: Maybe<Array<Maybe<JiraWorkManagementSavedViewTypeEdge>>>;
    /** Errors which were encountered while fetching the connection. */
    errors?: Maybe<Array<QueryError>>;
    /** Information about the current page. Used for pagination. */
    pageInfo: PageInfo;
};

/** The edge type for saved view types. */
export type JiraWorkManagementSavedViewTypeEdge = {
    __typename?: "JiraWorkManagementSavedViewTypeEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The saved view type node at the edge. */
    node?: Maybe<JiraWorkManagementSavedViewType>;
};

/** The response for the jwmUpdateActiveBackground mutation */
export type JiraWorkManagementUpdateActiveBackgroundPayload = Payload & {
    __typename?: "JiraWorkManagementUpdateActiveBackgroundPayload";
    /** Background updated by the mutation */
    background?: Maybe<JiraWorkManagementBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** The input for updating a Jira Work Management Background */
export type JiraWorkManagementUpdateBackgroundInput = {
    /** The type of background to update to */
    backgroundType: JiraWorkManagementBackgroundType;
    /**
     * The gradient/color if the background is a gradient/color type or
     * a customBackgroundId if the background is a custom (user uploaded) type
     */
    backgroundValue: Scalars["String"]["input"];
    /** The entityId (ARI) of the entity to be updated */
    entityId: Scalars["ID"]["input"];
};

/** The input for updating a custom background */
export type JiraWorkManagementUpdateCustomBackgroundInput = {
    /** The new alt text */
    altText: Scalars["String"]["input"];
    /** The identifier which indicates the cloud instance this data is to be fetched for */
    cloudId: Scalars["ID"]["input"];
    /** The customBackgroundId of the custom background to update */
    customBackgroundId: Scalars["ID"]["input"];
};

/** The returned payload when updating a custom background */
export type JiraWorkManagementUpdateCustomBackgroundPayload = Payload & {
    __typename?: "JiraWorkManagementUpdateCustomBackgroundPayload";
    /** Custom background updated by the mutation */
    background?: Maybe<JiraWorkManagementCustomBackground>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type JiraWorkManagementUpdateFilterInput = {
    /** An ARI-format value that encodes the filterId. */
    id: Scalars["ID"]["input"];
    /** New filter name */
    name: Scalars["String"]["input"];
};

export type JiraWorkManagementUpdateFilterPayload = Payload & {
    __typename?: "JiraWorkManagementUpdateFilterPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** JiraWorkManagementFilter updated by the mutation */
    filter?: Maybe<JiraWorkManagementFilter>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

/** Input for updating a Jira Work Management Overview. */
export type JiraWorkManagementUpdateOverviewInput = {
    /** Global identifier (ARI) of the Jira Work Management Overview to update. */
    id: Scalars["ID"]["input"];
    /** New name of the Jira Work Management Overview. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** New project IDs to replace the existing project IDs for the Jira Work Management Overview. */
    projectIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** New theme to set for the Jira Work Management Overview. */
    theme?: InputMaybe<Scalars["String"]["input"]>;
};

export enum JiraWorkManagementUserLicenseSeatEdition {
    Free = "FREE",
    Premium = "PREMIUM",
    Standard = "STANDARD"
}

export type JiraWorkManagementViewItem = Node & {
    __typename?: "JiraWorkManagementViewItem";
    /**
     * Paginated list of attachments available on this issue.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    attachments?: Maybe<JiraAttachmentConnection>;
    /** Retrieves the child summary for the item. */
    childSummary?: Maybe<JiraWorkManagementChildSummary>;
    commentSummary?: Maybe<JiraWorkManagementCommentSummary>;
    /**
     * Retrieves a list of JiraIssueFields
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use fieldsByIdOrAlias
     */
    fields?: Maybe<Array<JiraIssueField>>;
    /** Retrieves a list of JiraIssueFields. Maximum 100 fields can be requested at once. */
    fieldsByIdOrAlias?: Maybe<Array<Maybe<JiraIssueField>>>;
    /** Unique identifier associated with this Issue. */
    id: Scalars["ID"]["output"];
    /** Issue ID in numeric format. E.g. 10000 */
    issueId?: Maybe<Scalars["Long"]["output"]>;
    /**
     * Paginated list of issue links available on this item.
     * The server may throw an error if both a forward page (specified with `first`) and a backward page (specified with `last`) are requested simultaneously.
     */
    issueLinks?: Maybe<JiraIssueLinkConnection>;
};

export type JiraWorkManagementViewItemAttachmentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraWorkManagementViewItemChildSummaryArgs = {
    includeDone?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JiraWorkManagementViewItemFieldsArgs = {
    fieldIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type JiraWorkManagementViewItemFieldsByIdOrAliasArgs = {
    idsOrAliases: Array<InputMaybe<Scalars["String"]["input"]>>;
    ignoreMissingFields?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JiraWorkManagementViewItemIssueLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JiraWorkManagementViewItemConnection = {
    __typename?: "JiraWorkManagementViewItemConnection";
    /** A list of edges in the current page. */
    edges?: Maybe<Array<Maybe<JiraWorkManagementViewItemEdge>>>;
    /** Information about the current page. Used to aid in pagination. */
    pageInfo?: Maybe<PageInfo>;
    /** The total count of items in the connection. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JiraWorkManagementViewItemConnectionResult =
    | JiraWorkManagementViewItemConnection
    | QueryError;

export type JiraWorkManagementViewItemEdge = {
    __typename?: "JiraWorkManagementViewItemEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node at the edge. */
    node?: Maybe<JiraWorkManagementViewItem>;
};

/** Represents a Jira worklog. */
export type JiraWorklog = Node & {
    __typename?: "JiraWorklog";
    /** User profile of the original worklog author. */
    author?: Maybe<User>;
    /** Time of worklog creation. */
    created: Scalars["DateTime"]["output"];
    /** Global identifier for the worklog. */
    id: Scalars["ID"]["output"];
    /**
     * Either the group or the project role associated with this worklog, but not both.
     * Null means the permission level is unspecified, i.e. the worklog is public.
     */
    permissionLevel?: Maybe<JiraPermissionLevel>;
    /** Date and time when this unit of work was started. */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** Time spent displays the amount of time logged working on the issue so far. */
    timeSpent?: Maybe<JiraEstimate>;
    /** User profile of the author performing the worklog update. */
    updateAuthor?: Maybe<User>;
    /** Time of last worklog update. */
    updated?: Maybe<Scalars["DateTime"]["output"]>;
    /** Description related to the achieved work. */
    workDescription?: Maybe<JiraRichText>;
    /** Identifier for the worklog. */
    worklogId: Scalars["ID"]["output"];
};

/** Accepted Worklog adjustments */
export enum JiraWorklogAdjustmentEstimateOperation {
    /** To adjust estimate automatically whatever time spent mentioned. */
    Auto = "AUTO",
    /** To leave time tracking without auto adjusting based on time spent */
    Leave = "LEAVE",
    /** To reduce the time remaining manually. */
    Manual = "MANUAL",
    /** To specifiy new time remaining. */
    New = "NEW"
}

/** Input type for defining the operation on the Worklog field of a Jira issue. */
export type JiraWorklogFieldOperationInputForIssueTransitions = {
    /** provide a way to adjust the Estimate */
    adjustEstimateInput: JiraAdjustmentEstimate;
    /** Only ADD operation is supported for worklog field in purview of Issue Transition Modernisation flow. */
    operation: JiraAddValueFieldOperations;
    /** If user didn't provide this field or if it is `null` then startedTime will be logged as current time. */
    startedTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** If user didn't provide this field or if it is `null` then work will be logged with 0 minites. */
    timeSpentInMinutes?: InputMaybe<Scalars["Long"]["input"]>;
};

export type JsmChatAppendixActionItem = {
    __typename?: "JsmChatAppendixActionItem";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    label: Scalars["String"]["output"];
};

export type JsmChatAssistConfig = {
    __typename?: "JsmChatAssistConfig";
    /** The accountId of the Assist Bot */
    accountId: Scalars["String"]["output"];
};

export enum JsmChatChannelExperienceId {
    Helpcenter = "HELPCENTER",
    Widget = "WIDGET"
}

export type JsmChatChannelRequestTypeMapping = {
    __typename?: "JsmChatChannelRequestTypeMapping";
    channelId: Scalars["ID"]["output"];
    channelName?: Maybe<Scalars["String"]["output"]>;
    channelType?: Maybe<Scalars["String"]["output"]>;
    channelUrl?: Maybe<Scalars["String"]["output"]>;
    isPrivate?: Maybe<Scalars["Boolean"]["output"]>;
    projectId?: Maybe<Scalars["String"]["output"]>;
    requestTypes?: Maybe<Array<Maybe<JsmChatRequestTypesMappedResponse>>>;
    settings?: Maybe<JsmChatChannelSettings>;
    teamName?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatChannelSettings = {
    __typename?: "JsmChatChannelSettings";
    isDeflectionChannel?: Maybe<Scalars["Boolean"]["output"]>;
    isVirtualAgentChannel?: Maybe<Scalars["Boolean"]["output"]>;
    isVirtualAgentTestChannel?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum JsmChatChannelType {
    Agent = "AGENT",
    Request = "REQUEST"
}

export enum JsmChatConnectedApps {
    Slack = "SLACK",
    Teams = "TEAMS"
}

export enum JsmChatConversationAnalyticsEvent {
    UserClearedChat = "USER_CLEARED_CHAT",
    UserMarkedAsNotResolved = "USER_MARKED_AS_NOT_RESOLVED",
    UserMarkedAsResolved = "USER_MARKED_AS_RESOLVED",
    UserSharedCsat = "USER_SHARED_CSAT",
    VaRespondedWithKnowledgeAnswer = "VA_RESPONDED_WITH_KNOWLEDGE_ANSWER",
    VaRespondedWithNonKnowledgeAnswer = "VA_RESPONDED_WITH_NON_KNOWLEDGE_ANSWER"
}

export type JsmChatConversationAnalyticsMetadataInput = {
    channelType?: InputMaybe<JsmChatConversationChannelType>;
    csatScore?: InputMaybe<Scalars["Int"]["input"]>;
    helpCenterId?: InputMaybe<Scalars["String"]["input"]>;
    projectId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JsmChatConversationAppendixAction =
    | JsmChatDropdownAppendix
    | JsmChatJiraFieldAppendix
    | JsmChatOptionAppendix;

export enum JsmChatConversationChannelType {
    Email = "EMAIL",
    HelpCenter = "HELP_CENTER",
    Portal = "PORTAL",
    Slack = "SLACK",
    Widget = "WIDGET"
}

export type JsmChatCreateChannelInput = {
    channelName: Scalars["String"]["input"];
    channelType: JsmChatChannelType;
    isVirtualAgentChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
    isVirtualAgentTestChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
    requestTypeIds: Array<Scalars["String"]["input"]>;
};

export type JsmChatCreateChannelOutput = {
    __typename?: "JsmChatCreateChannelOutput";
    channelName?: Maybe<Scalars["String"]["output"]>;
    channelType?: Maybe<Scalars["String"]["output"]>;
    isPrivate?: Maybe<Scalars["Boolean"]["output"]>;
    message: Scalars["String"]["output"];
    requestTypes?: Maybe<Array<Maybe<JsmChatRequestTypeData>>>;
    settings?: Maybe<JsmChatChannelSettings>;
    slackChannelId?: Maybe<Scalars["String"]["output"]>;
    slackTeamId?: Maybe<Scalars["String"]["output"]>;
    status: Scalars["Boolean"]["output"];
};

export type JsmChatCreateCommentInput = {
    message: Scalars["JSON"]["input"];
    messageSource: JsmChatMessageSource;
    messageType: JsmChatMessageType;
};

export type JsmChatCreateCommentOutput = {
    __typename?: "JsmChatCreateCommentOutput";
    message: Scalars["String"]["output"];
    status: Scalars["Boolean"]["output"];
};

export type JsmChatCreateConversationAnalyticsInput = {
    conversationAnalyticsEvent: JsmChatConversationAnalyticsEvent;
    conversationAnalyticsMetadata?: InputMaybe<JsmChatConversationAnalyticsMetadataInput>;
    conversationId: Scalars["String"]["input"];
    messageId?: InputMaybe<Scalars["String"]["input"]>;
};

export type JsmChatCreateConversationAnalyticsOutput = {
    __typename?: "JsmChatCreateConversationAnalyticsOutput";
    status?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatCreateConversationInput = {
    channelExperienceId: JsmChatChannelExperienceId;
    conversationContextAri: Scalars["ID"]["input"];
    isTestChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type JsmChatCreateConversationPayload = Payload & {
    __typename?: "JsmChatCreateConversationPayload";
    createConversationResponse?: Maybe<JsmChatCreateConversationResponse>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type JsmChatCreateConversationResponse = {
    __typename?: "JsmChatCreateConversationResponse";
    id: Scalars["ID"]["output"];
    message?: Maybe<JsmChatCreateWebConversationMessage>;
};

export type JsmChatCreateWebConversationMessage = {
    __typename?: "JsmChatCreateWebConversationMessage";
    appendices?: Maybe<Array<Maybe<JsmChatConversationAppendixAction>>>;
    authorType: JsmChatCreateWebConversationUserRole;
    content: Scalars["JSON"]["output"];
    contentType: JsmChatCreateWebConversationMessageContentType;
    id: Scalars["ID"]["output"];
};

export enum JsmChatCreateWebConversationMessageContentType {
    Adf = "ADF"
}

export type JsmChatCreateWebConversationMessageInput = {
    /** The text content of the message */
    message: Scalars["String"]["input"];
};

export type JsmChatCreateWebConversationMessagePayload = Payload & {
    __typename?: "JsmChatCreateWebConversationMessagePayload";
    conversation?: Maybe<JsmChatMessageEdge>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum JsmChatCreateWebConversationUserRole {
    Acknowledgment = "Acknowledgment",
    Init = "Init",
    JsmAgent = "JSM_Agent",
    Participant = "Participant",
    Reporter = "Reporter",
    VirtualAgent = "VirtualAgent"
}

export type JsmChatDeleteSlackChannelMappingOutput = {
    __typename?: "JsmChatDeleteSlackChannelMappingOutput";
    message?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatDisconnectJiraProjectInput = {
    activationId: Scalars["ID"]["input"];
    projectId: Scalars["ID"]["input"];
    siteId: Scalars["ID"]["input"];
    teamId: Scalars["ID"]["input"];
};

export type JsmChatDisconnectJiraProjectResponse = {
    __typename?: "JsmChatDisconnectJiraProjectResponse";
    message: Scalars["String"]["output"];
    status: Scalars["Boolean"]["output"];
};

export type JsmChatDisconnectMsTeamsJiraProjectInput = {
    tenantId: Scalars["String"]["input"];
};

export type JsmChatDropdownAppendix = {
    __typename?: "JsmChatDropdownAppendix";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    options: Array<Maybe<JsmChatAppendixActionItem>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    placeholder?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatInitializeAndSendMessageInput = {
    channelExperienceId: JsmChatWebChannelExperienceId;
    conversationContextAri: Scalars["ID"]["input"];
    isTestChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
    message: Scalars["String"]["input"];
    subscriptionId: Scalars["String"]["input"];
};

export type JsmChatInitializeAndSendMessagePayload = Payload & {
    __typename?: "JsmChatInitializeAndSendMessagePayload";
    errors?: Maybe<Array<MutationError>>;
    initializeAndSendMessageResponse?: Maybe<JsmChatInitializeAndSendMessageResponse>;
    success: Scalars["Boolean"]["output"];
};

export type JsmChatInitializeAndSendMessageResponse = {
    __typename?: "JsmChatInitializeAndSendMessageResponse";
    conversation?: Maybe<JsmChatMessageEdge>;
    conversationId: Scalars["ID"]["output"];
};

export type JsmChatInitializeConfigRequest = {
    activationId: Scalars["ID"]["input"];
    projectId: Scalars["ID"]["input"];
    siteId: Scalars["ID"]["input"];
};

export type JsmChatInitializeConfigResponse = {
    __typename?: "JsmChatInitializeConfigResponse";
    nativeConfigEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatInitializeNativeConfigResponse = {
    __typename?: "JsmChatInitializeNativeConfigResponse";
    connectedApp?: Maybe<JsmChatConnectedApps>;
    nativeConfigEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatJiraFieldAppendix = {
    __typename?: "JsmChatJiraFieldAppendix";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    field?: Maybe<JsmChatRequestTypeField>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fieldId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jiraProjectId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    requestTypeId: Scalars["String"]["output"];
};

export type JsmChatJiraFieldOption = {
    __typename?: "JsmChatJiraFieldOption";
    children?: Maybe<Array<Maybe<JsmChatJiraFieldOption>>>;
    label?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatJiraSchema = {
    __typename?: "JsmChatJiraSchema";
    custom?: Maybe<Scalars["String"]["output"]>;
    customId?: Maybe<Scalars["String"]["output"]>;
    items?: Maybe<Scalars["String"]["output"]>;
    system?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatMessageConnection = {
    __typename?: "JsmChatMessageConnection";
    edges?: Maybe<Array<Maybe<JsmChatMessageEdge>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type JsmChatMessageEdge = {
    __typename?: "JsmChatMessageEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<JsmChatCreateWebConversationMessage>;
};

export enum JsmChatMessageSource {
    Email = "EMAIL"
}

export enum JsmChatMessageType {
    Adf = "ADF"
}

export type JsmChatMsTeamsChannelRequestTypeMapping = {
    __typename?: "JsmChatMsTeamsChannelRequestTypeMapping";
    channels?: Maybe<Array<Maybe<JsmChatMsTeamsChannels>>>;
    teamId: Scalars["ID"]["output"];
    teamName?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatMsTeamsChannels = {
    __typename?: "JsmChatMsTeamsChannels";
    channelId: Scalars["ID"]["output"];
    channelName?: Maybe<Scalars["String"]["output"]>;
    channelType?: Maybe<Scalars["String"]["output"]>;
    channelUrl?: Maybe<Scalars["String"]["output"]>;
    requestTypes?: Maybe<Array<Maybe<JsmChatRequestTypesMappedResponse>>>;
};

export type JsmChatMsTeamsConfig = {
    __typename?: "JsmChatMsTeamsConfig";
    channelRequestTypeMapping: Array<JsmChatMsTeamsChannelRequestTypeMapping>;
    hasMoreChannels?: Maybe<Scalars["Boolean"]["output"]>;
    projectKey?: Maybe<Scalars["String"]["output"]>;
    projectSettings?: Maybe<JsmChatMsTeamsProjectSettings>;
    siteId?: Maybe<Scalars["String"]["output"]>;
    tenantId?: Maybe<Scalars["String"]["output"]>;
    tenantTeamName?: Maybe<Scalars["String"]["output"]>;
    tenantTeamUrl?: Maybe<Scalars["String"]["output"]>;
    uninstalled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatMsTeamsProjectSettings = {
    __typename?: "JsmChatMsTeamsProjectSettings";
    jsmApproversEnabled: Scalars["Boolean"]["output"];
};

export type JsmChatMsTeamsUpdatedProjectSettings = {
    jsmApproversEnabled: Scalars["Boolean"]["input"];
};

export type JsmChatMutation = {
    __typename?: "JsmChatMutation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChatVAConversationAPI")' query directive to the 'addWebConversationInteraction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addWebConversationInteraction?: Maybe<JsmChatWebAddConversationInteractionPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createChannel: JsmChatCreateChannelOutput;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createComment?: Maybe<JsmChatCreateCommentOutput>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChatVAConversationAPI")' query directive to the 'createConversation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createConversation?: Maybe<JsmChatCreateConversationPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createConversationAnalyticsEvent?: Maybe<JsmChatCreateConversationAnalyticsOutput>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChatVAConversationAPI")' query directive to the 'createWebConversationMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createWebConversationMessage?: Maybe<JsmChatCreateWebConversationMessagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteSlackChannelMapping: JsmChatDeleteSlackChannelMappingOutput;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:request:jira-service-management__
     * * __write:request:jira-service-management__
     *
     *
     */
    disconnectJiraProject?: Maybe<JsmChatDisconnectJiraProjectResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    disconnectMsTeamsJiraProject?: Maybe<JsmChatDisconnectJiraProjectResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChatVAConversationAPI")' query directive to the 'initializeAndSendMessage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    initializeAndSendMessage?: Maybe<JsmChatInitializeAndSendMessagePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateChannelSettings: JsmChatUpdateChannelSettingsOutput;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateMsTeamsChannelSettings: JsmChatUpdateMsTeamsChannelSettingsOutput;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateMsTeamsProjectSettings: JsmChatUpdateMsTeamsProjectSettingsOutput;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateProjectSettings?: Maybe<JsmChatUpdateProjectSettingsOutput>;
};

export type JsmChatMutationAddWebConversationInteractionArgs = {
    conversationId: Scalars["ID"]["input"];
    conversationMessageId: Scalars["ID"]["input"];
    input: JsmChatWebAddConversationInteractionInput;
    workspaceAri: Scalars["ID"]["input"];
};

export type JsmChatMutationCreateChannelArgs = {
    input?: InputMaybe<JsmChatCreateChannelInput>;
    jiraProjectAri: Scalars["ID"]["input"];
};

export type JsmChatMutationCreateCommentArgs = {
    input: JsmChatCreateCommentInput;
    jiraIssueAri: Scalars["ID"]["input"];
    workspaceAri: Scalars["ID"]["input"];
};

export type JsmChatMutationCreateConversationArgs = {
    input: JsmChatCreateConversationInput;
    workspaceAri: Scalars["ID"]["input"];
};

export type JsmChatMutationCreateConversationAnalyticsEventArgs = {
    input: JsmChatCreateConversationAnalyticsInput;
    workspaceAri: Scalars["ID"]["input"];
};

export type JsmChatMutationCreateWebConversationMessageArgs = {
    conversationId: Scalars["ID"]["input"];
    input: JsmChatCreateWebConversationMessageInput;
    workspaceAri: Scalars["ID"]["input"];
};

export type JsmChatMutationDeleteSlackChannelMappingArgs = {
    jiraProjectAri: Scalars["ID"]["input"];
    slackChannelAri: Scalars["ID"]["input"];
};

export type JsmChatMutationDisconnectJiraProjectArgs = {
    input: JsmChatDisconnectJiraProjectInput;
};

export type JsmChatMutationDisconnectMsTeamsJiraProjectArgs = {
    input?: InputMaybe<JsmChatDisconnectMsTeamsJiraProjectInput>;
    jiraProjectAri: Scalars["ID"]["input"];
};

export type JsmChatMutationInitializeAndSendMessageArgs = {
    input: JsmChatInitializeAndSendMessageInput;
    workspaceAri: Scalars["ID"]["input"];
};

export type JsmChatMutationUpdateChannelSettingsArgs = {
    input: JsmChatUpdateChannelSettingsInput;
    jiraProjectAri: Scalars["ID"]["input"];
    slackChannelAri?: InputMaybe<Scalars["ID"]["input"]>;
};

export type JsmChatMutationUpdateMsTeamsChannelSettingsArgs = {
    input: JsmChatUpdateMsTeamsChannelSettingsInput;
    jiraProjectAri: Scalars["ID"]["input"];
    msTeamsAri: Scalars["ID"]["input"];
};

export type JsmChatMutationUpdateMsTeamsProjectSettingsArgs = {
    input: JsmChatUpdateMsTeamsProjectSettingsInput;
    jiraProjectAri: Scalars["ID"]["input"];
};

export type JsmChatMutationUpdateProjectSettingsArgs = {
    input: JsmChatUpdateProjectSettingsInput;
};

export type JsmChatOptionAppendix = {
    __typename?: "JsmChatOptionAppendix";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    options: Array<Maybe<JsmChatAppendixActionItem>>;
};

export type JsmChatPaginationConfig = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset: Scalars["Int"]["input"];
};

export type JsmChatProjectSettings = {
    __typename?: "JsmChatProjectSettings";
    agentAssignedMessageDisabled?: Maybe<Scalars["Boolean"]["output"]>;
    agentIssueClosedMessageDisabled?: Maybe<Scalars["Boolean"]["output"]>;
    agentThreadMessageDisabled?: Maybe<Scalars["Boolean"]["output"]>;
    areRequesterThreadRepliesPrivate?: Maybe<Scalars["Boolean"]["output"]>;
    hideQueueDuringTicketCreation?: Maybe<Scalars["Boolean"]["output"]>;
    jsmApproversEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    requesterIssueClosedMessageDisabled?: Maybe<Scalars["Boolean"]["output"]>;
    requesterThreadMessageDisabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatProjectSettingsSlack = {
    __typename?: "JsmChatProjectSettingsSlack";
    activationId?: Maybe<Scalars["String"]["output"]>;
    projectId: Scalars["ID"]["output"];
    settings?: Maybe<JsmChatProjectSettings>;
    siteId?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatQuery = {
    __typename?: "JsmChatQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getAssistConfig: JsmChatAssistConfig;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getMsTeamsChatConfig?: Maybe<JsmChatMsTeamsConfig>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getSlackChatConfig?: Maybe<JsmChatSlackConfig>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChatVAConversationAPI")' query directive to the 'getWebConversation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    getWebConversation: JsmChatMessageConnection;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    initializeConfig: JsmChatInitializeConfigResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    initializeNativeConfig: JsmChatInitializeNativeConfigResponse;
};

export type JsmChatQueryGetAssistConfigArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type JsmChatQueryGetMsTeamsChatConfigArgs = {
    jiraProjectAri: Scalars["ID"]["input"];
    paginationConfig?: InputMaybe<JsmChatPaginationConfig>;
};

export type JsmChatQueryGetSlackChatConfigArgs = {
    jiraProjectAri: Scalars["ID"]["input"];
    paginationConfig?: InputMaybe<JsmChatPaginationConfig>;
};

export type JsmChatQueryGetWebConversationArgs = {
    conversationId: Scalars["ID"]["input"];
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JsmChatQueryInitializeConfigArgs = {
    input: JsmChatInitializeConfigRequest;
};

export type JsmChatQueryInitializeNativeConfigArgs = {
    jiraProjectAri: Scalars["ID"]["input"];
};

export type JsmChatRequestTypeData = {
    __typename?: "JsmChatRequestTypeData";
    requestTypeId?: Maybe<Scalars["String"]["output"]>;
    requestTypeName?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatRequestTypeField = {
    __typename?: "JsmChatRequestTypeField";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    defaultValues?: Maybe<Array<Maybe<JsmChatJiraFieldOption>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fieldId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jiraSchema?: Maybe<JsmChatJiraSchema>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    required?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    validValues?: Maybe<Array<Maybe<JsmChatJiraFieldOption>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    visible?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatRequestTypesMappedResponse = {
    __typename?: "JsmChatRequestTypesMappedResponse";
    requestTypeId?: Maybe<Scalars["String"]["output"]>;
    requestTypeName?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatSlackConfig = {
    __typename?: "JsmChatSlackConfig";
    botUserId?: Maybe<Scalars["String"]["output"]>;
    channelRequestTypeMapping: Array<JsmChatChannelRequestTypeMapping>;
    hasMoreChannels?: Maybe<Scalars["Boolean"]["output"]>;
    projectKey?: Maybe<Scalars["String"]["output"]>;
    projectSettings?: Maybe<JsmChatProjectSettingsSlack>;
    siteId: Scalars["ID"]["output"];
    slackTeamDomain?: Maybe<Scalars["String"]["output"]>;
    slackTeamId?: Maybe<Scalars["String"]["output"]>;
    slackTeamName?: Maybe<Scalars["String"]["output"]>;
    slackTeamUrl?: Maybe<Scalars["String"]["output"]>;
    uninstalled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JsmChatSubscription = {
    __typename?: "JsmChatSubscription";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JsmChatVAConversationAPI")' query directive to the 'updateConversation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateConversation?: Maybe<JsmChatWebSubscriptionResponse>;
};

export type JsmChatSubscriptionUpdateConversationArgs = {
    conversationId: Scalars["ID"]["input"];
};

export type JsmChatUpdateChannelSettingsInput = {
    isDeflectionChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
    isVirtualAgentChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
    requestTypeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type JsmChatUpdateChannelSettingsOutput = {
    __typename?: "JsmChatUpdateChannelSettingsOutput";
    channelName?: Maybe<Scalars["String"]["output"]>;
    channelType?: Maybe<Scalars["String"]["output"]>;
    isPrivate?: Maybe<Scalars["Boolean"]["output"]>;
    message: Scalars["String"]["output"];
    requestTypes?: Maybe<Array<Maybe<JsmChatRequestTypeData>>>;
    settings?: Maybe<JsmChatChannelSettings>;
    slackChannelId?: Maybe<Scalars["String"]["output"]>;
    slackTeamId?: Maybe<Scalars["String"]["output"]>;
    status: Scalars["Boolean"]["output"];
};

export type JsmChatUpdateMsTeamsChannelSettingsInput = {
    requestTypeIds: Array<Scalars["String"]["input"]>;
};

export type JsmChatUpdateMsTeamsChannelSettingsOutput = {
    __typename?: "JsmChatUpdateMsTeamsChannelSettingsOutput";
    channelId?: Maybe<Scalars["String"]["output"]>;
    channelName?: Maybe<Scalars["String"]["output"]>;
    channelType?: Maybe<Scalars["String"]["output"]>;
    message: Scalars["String"]["output"];
    requestTypes?: Maybe<Array<Maybe<JsmChatRequestTypesMappedResponse>>>;
    status: Scalars["Boolean"]["output"];
};

export type JsmChatUpdateMsTeamsProjectSettingsInput = {
    settings?: InputMaybe<JsmChatMsTeamsUpdatedProjectSettings>;
};

export type JsmChatUpdateMsTeamsProjectSettingsOutput = {
    __typename?: "JsmChatUpdateMsTeamsProjectSettingsOutput";
    message: Scalars["String"]["output"];
    projectId?: Maybe<Scalars["String"]["output"]>;
    settings?: Maybe<JsmChatMsTeamsProjectSettings>;
    siteId?: Maybe<Scalars["String"]["output"]>;
    status: Scalars["Boolean"]["output"];
};

export type JsmChatUpdateProjectSettingsInput = {
    activationId: Scalars["String"]["input"];
    projectId: Scalars["String"]["input"];
    settings?: InputMaybe<JsmChatUpdatedProjectSettings>;
    siteId: Scalars["String"]["input"];
};

export type JsmChatUpdateProjectSettingsOutput = {
    __typename?: "JsmChatUpdateProjectSettingsOutput";
    message: Scalars["String"]["output"];
    status: Scalars["Boolean"]["output"];
};

export type JsmChatUpdatedProjectSettings = {
    agentAssignedMessageDisabled: Scalars["Boolean"]["input"];
    agentIssueClosedMessageDisabled: Scalars["Boolean"]["input"];
    agentThreadMessageDisabled: Scalars["Boolean"]["input"];
    areRequesterThreadRepliesPrivate: Scalars["Boolean"]["input"];
    hideQueueDuringTicketCreation: Scalars["Boolean"]["input"];
    jsmApproversEnabled: Scalars["Boolean"]["input"];
    requesterIssueClosedMessageDisabled: Scalars["Boolean"]["input"];
    requesterThreadMessageDisabled: Scalars["Boolean"]["input"];
};

export type JsmChatWebAddConversationInteractionInput = {
    interactionType: JsmChatWebInteractionType;
    jiraFieldId?: InputMaybe<Scalars["String"]["input"]>;
    selectedValue: Scalars["String"]["input"];
};

export type JsmChatWebAddConversationInteractionPayload = Payload & {
    __typename?: "JsmChatWebAddConversationInteractionPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum JsmChatWebChannelExperienceId {
    Helpcenter = "HELPCENTER"
}

export enum JsmChatWebConversationActions {
    CloseConversation = "CLOSE_CONVERSATION",
    DisableInput = "DISABLE_INPUT",
    GreetingMessage = "GREETING_MESSAGE",
    RedirectToSearch = "REDIRECT_TO_SEARCH"
}

export type JsmChatWebConversationAppendixAction =
    | JsmChatDropdownAppendix
    | JsmChatJiraFieldAppendix
    | JsmChatOptionAppendix;

export enum JsmChatWebConversationMessageContentType {
    Adf = "ADF"
}

export type JsmChatWebConversationUpdateQueryError = {
    __typename?: "JsmChatWebConversationUpdateQueryError";
    /** Contains extra data describing the error. */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /** The ID of the object that would have otherwise been returned, if not for the query error. */
    identifier?: Maybe<Scalars["ID"]["output"]>;
    /** A message describing the error. */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type JsmChatWebConversationUpdateSubscriptionPayload =
    | JsmChatWebConversationUpdateQueryError
    | JsmChatWebSubscriptionEstablishedPayload;

export enum JsmChatWebConversationUserRole {
    JsmAgent = "JSM_Agent",
    Participant = "Participant",
    Reporter = "Reporter",
    VirtualAgent = "VirtualAgent"
}

export enum JsmChatWebInteractionType {
    Buttons = "BUTTONS",
    Dropdown = "DROPDOWN",
    JiraField = "JIRA_FIELD"
}

/** The response when a subscription is established. */
export type JsmChatWebSubscriptionEstablishedPayload = {
    __typename?: "JsmChatWebSubscriptionEstablishedPayload";
    /** The ID of the conversation that the subscription is established for. */
    id: Scalars["ID"]["output"];
};

export type JsmChatWebSubscriptionResponse = {
    __typename?: "JsmChatWebSubscriptionResponse";
    action?: Maybe<JsmChatWebConversationActions>;
    conversation?: Maybe<JsmChatMessageEdge>;
    result?: Maybe<JsmChatWebConversationUpdateSubscriptionPayload>;
};

export type JsonContentProperty = {
    __typename?: "JsonContentProperty";
    content?: Maybe<Content>;
    id?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextSelfBase>;
    value?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<Version>;
};

export type JsonContentPropertyEdge = {
    __typename?: "JsonContentPropertyEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<JsonContentProperty>;
};

export type JswAvailableCardLayoutField = Node & {
    __typename?: "JswAvailableCardLayoutField";
    fieldId: Scalars["ID"]["output"];
    id: Scalars["ID"]["output"];
    isValid?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JswAvailableCardLayoutFieldConnection = {
    __typename?: "JswAvailableCardLayoutFieldConnection";
    edges?: Maybe<Array<Maybe<JswAvailableCardLayoutFieldEdge>>>;
    pageInfo: PageInfo;
};

export type JswAvailableCardLayoutFieldEdge = {
    __typename?: "JswAvailableCardLayoutFieldEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JswAvailableCardLayoutField>;
};

export type JswBoardAdmin = {
    __typename?: "JswBoardAdmin";
    displayName?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
};

export type JswBoardAdmins = {
    __typename?: "JswBoardAdmins";
    groupKeys?: Maybe<Array<Maybe<JswBoardAdmin>>>;
    userKeys?: Maybe<Array<Maybe<JswBoardAdmin>>>;
};

export type JswBoardLocationModel = {
    __typename?: "JswBoardLocationModel";
    avatarURI?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    projectId?: Maybe<Scalars["ID"]["output"]>;
    projectTypeKey?: Maybe<Scalars["String"]["output"]>;
    userLocationId?: Maybe<Scalars["ID"]["output"]>;
};

export type JswBoardScopeRoadmapConfig = {
    __typename?: "JswBoardScopeRoadmapConfig";
    isChildIssuePlanningEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    isRoadmapEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    prefersChildIssueDatePlanning?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JswCardColor = Node & {
    __typename?: "JswCardColor";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Check for EDIT_BOARD_CONFIG in the permissions under currentUser node instead
     */
    canEdit: Scalars["Boolean"]["output"];
    color: Scalars["String"]["output"];
    displayValue?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isGlobalColor?: Maybe<Scalars["Boolean"]["output"]>;
    isUsed?: Maybe<Scalars["Boolean"]["output"]>;
    strategy?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type JswCardColorConfig = {
    __typename?: "JswCardColorConfig";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Check for EDIT_BOARD_CONFIG in the permissions under currentUser node instead
     */
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    cardColorStrategies?: Maybe<Array<Maybe<JswCardColorStrategy>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use the current field instead
     */
    cardColorStrategy?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'current' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    current?: Maybe<JswCardColorStrategy>;
};

export type JswCardColorConfigCardColorStrategiesArgs = {
    strategies?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type JswCardColorConnection = {
    __typename?: "JswCardColorConnection";
    edges?: Maybe<Array<Maybe<JswCardColorEdge>>>;
    pageInfo: PageInfo;
};

export type JswCardColorEdge = {
    __typename?: "JswCardColorEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JswCardColor>;
};

export type JswCardColorStrategy = {
    __typename?: "JswCardColorStrategy";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Check for EDIT_BOARD_CONFIG in the permissions under currentUser node instead
     */
    canEdit: Scalars["Boolean"]["output"];
    cardColors?: Maybe<JswCardColorConnection>;
    id: Scalars["String"]["output"];
};

export type JswCardColorStrategyCardColorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type JswCardLayoutConfig = {
    __typename?: "JswCardLayoutConfig";
    backlog?: Maybe<JswCardLayoutContainer>;
    board?: Maybe<JswCardLayoutContainer>;
};

export type JswCardLayoutContainer = {
    __typename?: "JswCardLayoutContainer";
    availableFields?: Maybe<JswAvailableCardLayoutFieldConnection>;
    fields?: Maybe<Array<Maybe<JswCurrentCardLayoutField>>>;
};

export type JswCardStatusIssueMetaData = {
    __typename?: "JswCardStatusIssueMetaData";
    /** The number issues associated with a status */
    issueCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JswCurrentCardLayoutField = Node & {
    __typename?: "JswCurrentCardLayoutField";
    cardLayoutId: Scalars["ID"]["output"];
    fieldId: Scalars["ID"]["output"];
    id: Scalars["ID"]["output"];
    isValid?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JswCustomSwimlane = Node & {
    __typename?: "JswCustomSwimlane";
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isDefault?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    query?: Maybe<Scalars["String"]["output"]>;
};

export type JswCustomSwimlaneConnection = {
    __typename?: "JswCustomSwimlaneConnection";
    edges?: Maybe<Array<Maybe<JswCustomSwimlaneEdge>>>;
    pageInfo: PageInfo;
};

export type JswCustomSwimlaneEdge = {
    __typename?: "JswCustomSwimlaneEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JswCustomSwimlane>;
};

export type JswMapOfStringToString = {
    __typename?: "JswMapOfStringToString";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type JswMutation = {
    __typename?: "JswMutation";
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: deleteCard` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteCard?: Maybe<DeleteCardOutput>;
};

export type JswMutationDeleteCardArgs = {
    input?: InputMaybe<DeleteCardInput>;
};

export type JswNonWorkingDayConfig = {
    __typename?: "JswNonWorkingDayConfig";
    date?: Maybe<Scalars["Date"]["output"]>;
};

export type JswOldDoneIssuesCutOffConfig = {
    __typename?: "JswOldDoneIssuesCutOffConfig";
    oldDoneIssuesCutoff?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<Maybe<JswOldDoneIssuesCutoffOption>>>;
};

export type JswOldDoneIssuesCutoffOption = {
    __typename?: "JswOldDoneIssuesCutoffOption";
    label?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type JswQuery = {
    __typename?: "JswQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
};

export type JswQueryBoardScopeArgs = {
    boardId: Scalars["ID"]["input"];
};

export type JswRegion = Node & {
    __typename?: "JswRegion";
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
};

export type JswRegionConnection = {
    __typename?: "JswRegionConnection";
    edges?: Maybe<Array<Maybe<JswRegionEdge>>>;
    pageInfo: PageInfo;
};

export type JswRegionEdge = {
    __typename?: "JswRegionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JswRegion>;
};

export type JswSavedFilterConfig = {
    __typename?: "JswSavedFilterConfig";
    canBeFixed?: Maybe<Scalars["Boolean"]["output"]>;
    canEdit?: Maybe<Scalars["Boolean"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    editPermissionEntries?: Maybe<
        Array<Maybe<JswSavedFilterSharePermissionEntry>>
    >;
    editPermissions?: Maybe<Array<Maybe<JswSavedFilterPermissionEntry>>>;
    id: Scalars["ID"]["output"];
    isOrderedByRank?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    orderByWarnings?: Maybe<JswSavedFilterWarnings>;
    owner?: Maybe<JswSavedFilterOwner>;
    permissionEntries?: Maybe<Array<Maybe<JswSavedFilterPermissionEntry>>>;
    query?: Maybe<Scalars["String"]["output"]>;
    queryProjects?: Maybe<JswSavedFilterQueryProjects>;
    sharePermissionEntries?: Maybe<
        Array<Maybe<JswSavedFilterSharePermissionEntry>>
    >;
};

export type JswSavedFilterOwner = {
    __typename?: "JswSavedFilterOwner";
    accountId?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    renderedLink?: Maybe<Scalars["String"]["output"]>;
    userName?: Maybe<Scalars["String"]["output"]>;
};

export type JswSavedFilterPermissionEntry = {
    __typename?: "JswSavedFilterPermissionEntry";
    values?: Maybe<Array<Maybe<JswSavedFilterPermissionValue>>>;
};

export type JswSavedFilterPermissionValue = {
    __typename?: "JswSavedFilterPermissionValue";
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type JswSavedFilterQueryProjectEntry = {
    __typename?: "JswSavedFilterQueryProjectEntry";
    canEditProject?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["Long"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JswSavedFilterQueryProjects = {
    __typename?: "JswSavedFilterQueryProjects";
    displayMessage?: Maybe<Scalars["String"]["output"]>;
    isMaxSupportShowingProjectsReached?: Maybe<Scalars["Boolean"]["output"]>;
    isProjectsUnboundedInFilter?: Maybe<Scalars["Boolean"]["output"]>;
    projects?: Maybe<Array<Maybe<JswSavedFilterQueryProjectEntry>>>;
    projectsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type JswSavedFilterSharePermissionEntry = {
    __typename?: "JswSavedFilterSharePermissionEntry";
    group?: Maybe<JswSavedFilterSharePermissionValue>;
    project?: Maybe<JswSavedFilterSharePermissionProjectValue>;
    role?: Maybe<JswSavedFilterSharePermissionValue>;
    type?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<JswSavedFilterSharePermissionUserValue>;
};

export type JswSavedFilterSharePermissionProjectValue = {
    __typename?: "JswSavedFilterSharePermissionProjectValue";
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["Long"]["output"]>;
    isSimple?: Maybe<Scalars["Boolean"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JswSavedFilterSharePermissionUserValue = {
    __typename?: "JswSavedFilterSharePermissionUserValue";
    accountId?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
};

export type JswSavedFilterSharePermissionValue = {
    __typename?: "JswSavedFilterSharePermissionValue";
    id?: Maybe<Scalars["Long"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type JswSavedFilterWarnings = {
    __typename?: "JswSavedFilterWarnings";
    errorMessages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    errors?: Maybe<Array<Maybe<JswMapOfStringToString>>>;
};

export type JswSubqueryConfig = {
    __typename?: "JswSubqueryConfig";
    subqueries?: Maybe<Array<Maybe<JswSubqueryEntry>>>;
};

export type JswSubqueryEntry = {
    __typename?: "JswSubqueryEntry";
    id?: Maybe<Scalars["Long"]["output"]>;
    query?: Maybe<Scalars["String"]["output"]>;
};

export type JswTimeZone = Node & {
    __typename?: "JswTimeZone";
    city?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    gmtOffset?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    regionKey?: Maybe<Scalars["String"]["output"]>;
};

export type JswTimeZoneConnection = {
    __typename?: "JswTimeZoneConnection";
    edges?: Maybe<Array<Maybe<JswTimeZoneEdge>>>;
    pageInfo: PageInfo;
};

export type JswTimeZoneEdge = {
    __typename?: "JswTimeZoneEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<JswTimeZone>;
};

export type JswTimeZoneEditModel = {
    __typename?: "JswTimeZoneEditModel";
    currentTimeZoneId?: Maybe<Scalars["String"]["output"]>;
    regions?: Maybe<JswRegionConnection>;
    timeZones?: Maybe<JswTimeZoneConnection>;
};

export type JswTrackingStatistic = {
    __typename?: "JswTrackingStatistic";
    customFieldId?: Maybe<Scalars["String"]["output"]>;
    isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    statisticFieldId?: Maybe<Scalars["String"]["output"]>;
};

export type JswWeekDaysConfig = {
    __typename?: "JswWeekDaysConfig";
    friday?: Maybe<Scalars["Boolean"]["output"]>;
    monday?: Maybe<Scalars["Boolean"]["output"]>;
    saturday?: Maybe<Scalars["Boolean"]["output"]>;
    sunday?: Maybe<Scalars["Boolean"]["output"]>;
    thursday?: Maybe<Scalars["Boolean"]["output"]>;
    tuesday?: Maybe<Scalars["Boolean"]["output"]>;
    wednesday?: Maybe<Scalars["Boolean"]["output"]>;
};

export type JswWorkingDaysConfig = {
    __typename?: "JswWorkingDaysConfig";
    nonWorkingDays?: Maybe<Array<Maybe<JswNonWorkingDayConfig>>>;
    timeZoneEditModel?: Maybe<JswTimeZoneEditModel>;
    weekDays?: Maybe<JswWeekDaysConfig>;
};

export type KeyValueHierarchyMap = {
    __typename?: "KeyValueHierarchyMap";
    fields?: Maybe<Array<Maybe<KeyValueHierarchyMap>>>;
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type KnowledgeBaseArticleCountError = {
    __typename?: "KnowledgeBaseArticleCountError";
    /** The knowledge sources */
    container: Scalars["ID"]["output"];
    /** The error extensions */
    extensions: Array<QueryErrorExtension>;
    /** The error message */
    message: Scalars["String"]["output"];
};

export type KnowledgeBaseArticleCountResponse =
    | KnowledgeBaseArticleCountError
    | KnowledgeBaseArticleCountSource;

export type KnowledgeBaseArticleCountSource = {
    __typename?: "KnowledgeBaseArticleCountSource";
    /** The knowledge sources */
    container: Scalars["ID"]["output"];
    /** The count of knowledge articles */
    count: Scalars["Int"]["output"];
};

export type KnowledgeBaseArticleSearchInput = {
    /** containers to search articles from. For eg. Confluence space, gdrive folder, etc. */
    articleContainers?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** cloud ID of the tenant */
    cloudId: Scalars["ID"]["input"];
    /** cursor for pagination */
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    /** how many results to return */
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    /** project ID to scope the search */
    projectId?: InputMaybe<Scalars["ID"]["input"]>;
    /** search query term */
    searchQuery?: InputMaybe<Scalars["String"]["input"]>;
    /** field / key based on which the search results are sorted */
    sortByKey?: InputMaybe<KnowledgeBaseArticleSearchSortByKey>;
    /** ASC or DESC */
    sortOrder?: InputMaybe<KnowledgeBaseArticleSearchSortOrder>;
};

export type KnowledgeBaseArticleSearchResponse =
    | KnowledgeBaseCrossSiteSearchConnection
    | QueryError;

export enum KnowledgeBaseArticleSearchSortByKey {
    LastModified = "LAST_MODIFIED",
    Title = "TITLE"
}

export enum KnowledgeBaseArticleSearchSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type KnowledgeBaseCrossSiteArticle = {
    __typename?: "KnowledgeBaseCrossSiteArticle";
    /** human readable last modified timestamp */
    friendlyLastModified?: Maybe<Scalars["String"]["output"]>;
    /** id of the article */
    id: Scalars["ID"]["output"];
    /** last modified timestamp of the article in ISO 8601 format */
    lastModified?: Maybe<Scalars["String"]["output"]>;
    /** ari of the space the article belongs to */
    spaceAri?: Maybe<Scalars["ID"]["output"]>;
    /** name of the space the article belongs to */
    spaceName?: Maybe<Scalars["String"]["output"]>;
    /** url of the space the article belongs to */
    spaceUrl?: Maybe<Scalars["String"]["output"]>;
    /** title of the article */
    title?: Maybe<Scalars["String"]["output"]>;
    /** confluence view url of the article */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type KnowledgeBaseCrossSiteArticleEdge = {
    __typename?: "KnowledgeBaseCrossSiteArticleEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<KnowledgeBaseCrossSiteArticle>;
};

export type KnowledgeBaseCrossSiteSearchConnection = {
    __typename?: "KnowledgeBaseCrossSiteSearchConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<KnowledgeBaseCrossSiteArticleEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<KnowledgeBaseCrossSiteArticle>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
};

export type KnowledgeBaseLinkResponse = {
    __typename?: "KnowledgeBaseLinkResponse";
    /** The knowledge base source that was linked */
    knowledgeBaseSource?: Maybe<KnowledgeBaseSource>;
    /** The mutation error */
    mutationError?: Maybe<MutationError>;
    /** The status of the mutation */
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeBaseMutationApi = {
    __typename?: "KnowledgeBaseMutationApi";
    /**
     *  Link a knowledge base source to a container
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    linkKnowledgeBaseSource?: Maybe<KnowledgeBaseLinkResponse>;
    /**
     *  Unlink a knowledge base source from a container
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unlinkKnowledgeBaseSource?: Maybe<KnowledgeBaseUnlinkResponse>;
};

export type KnowledgeBaseMutationApiLinkKnowledgeBaseSourceArgs = {
    container: Scalars["ID"]["input"];
    sourceARI?: InputMaybe<Scalars["ID"]["input"]>;
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeBaseMutationApiUnlinkKnowledgeBaseSourceArgs = {
    container?: InputMaybe<Scalars["ID"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    linkedSourceARI?: InputMaybe<Scalars["ID"]["input"]>;
};

export type KnowledgeBaseQueryApi = {
    __typename?: "KnowledgeBaseQueryApi";
    /**
     *  Fetch knowledge sources
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    knowledgeBase?: Maybe<KnowledgeBaseResponse>;
};

export type KnowledgeBaseQueryApiKnowledgeBaseArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    container: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KnowledgeBaseResponse = KnowledgeBaseSources | QueryError;

export type KnowledgeBaseSource = {
    __typename?: "KnowledgeBaseSource";
    /** The container identifier */
    containerAri: Scalars["ID"]["output"];
    /** The entityReference */
    entityReference: Scalars["String"]["output"];
    /** Identifier for the knowledge base source */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The name of the source being referenced */
    name: Scalars["String"]["output"];
    /** Permissions */
    permissions?: Maybe<KnowledgeBaseSourcePermissions>;
    /** type of the KB source */
    sourceType?: Maybe<Scalars["String"]["output"]>;
    /** The url of the source being referenced */
    url: Scalars["String"]["output"];
};

export type KnowledgeBaseSourcePermissionsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type KnowledgeBaseSourceEdge = {
    __typename?: "KnowledgeBaseSourceEdge";
    /** The cursor */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The node */
    node: KnowledgeBaseSource;
};

export type KnowledgeBaseSourcePermissions =
    | KnowledgeBaseSpacePermissionQueryError
    | KnowledgeBaseSpacePermissionResponse;

export type KnowledgeBaseSources = {
    __typename?: "KnowledgeBaseSources";
    /** Edges */
    edge: Array<Maybe<KnowledgeBaseSourceEdge>>;
    /** page info */
    totalCount: Scalars["Int"]["output"];
};

export type KnowledgeBaseSpacePermission = {
    __typename?: "KnowledgeBaseSpacePermission";
    /** Edit permission detail */
    editPermission: KnowledgeBaseSpacePermissionDetail;
    /** View permission detail */
    viewPermission: KnowledgeBaseSpacePermissionDetail;
};

export type KnowledgeBaseSpacePermissionDetail = {
    __typename?: "KnowledgeBaseSpacePermissionDetail";
    /** The current permission type */
    currentPermission: KnowledgeBaseSpacePermissionType;
    /** A list of invalid permissions */
    invalidPermissions: Array<Maybe<KnowledgeBaseSpacePermissionType>>;
    /** A list of valid permissions */
    validPermissions: Array<KnowledgeBaseSpacePermissionType>;
};

export type KnowledgeBaseSpacePermissionMutationResponse = {
    __typename?: "KnowledgeBaseSpacePermissionMutationResponse";
    /**
     *  Mutation error in case of failure
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    error?: Maybe<MutationError>;
    /**
     *  Permission in case of success
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permission?: Maybe<KnowledgeBaseSpacePermission>;
    /**
     *  Success status
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeBaseSpacePermissionQueryError = {
    __typename?: "KnowledgeBaseSpacePermissionQueryError";
    /** The error extensions */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /** The error message */
    message: Scalars["String"]["output"];
    /** The ID of the requested object, or null when the ID is not available. */
    spaceAri: Scalars["ID"]["output"];
};

export type KnowledgeBaseSpacePermissionQueryResponse =
    | KnowledgeBaseSpacePermissionQueryError
    | KnowledgeBaseSpacePermissionResponse;

export type KnowledgeBaseSpacePermissionResponse = {
    __typename?: "KnowledgeBaseSpacePermissionResponse";
    /** The permission */
    permission: KnowledgeBaseSpacePermission;
    /** The spaceAri */
    spaceAri: Scalars["ID"]["output"];
};

export enum KnowledgeBaseSpacePermissionType {
    /** Permission for anonymous users (view only) */
    AnonymousUsers = "ANONYMOUS_USERS",
    /** Permission for Confluence licensed users */
    ConfluenceLicensedUsers = "CONFLUENCE_LICENSED_USERS",
    /** Permission for Confluence unlicensed users */
    ConfluenceUnlicensedUsers = "CONFLUENCE_UNLICENSED_USERS"
}

export type KnowledgeBaseSpacePermissionUpdateViewInput = {
    /** The space ARI */
    spaceAri: Scalars["ID"]["input"];
    /** The new view permission */
    viewPermission?: InputMaybe<KnowledgeBaseSpacePermissionType>;
};

export type KnowledgeBaseUnlinkResponse = {
    __typename?: "KnowledgeBaseUnlinkResponse";
    /** The mutation error */
    mutationError?: Maybe<MutationError>;
    /** The status of the mutation */
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeDiscoveryAdminhubBookmark = {
    __typename?: "KnowledgeDiscoveryAdminhubBookmark";
    id: Scalars["ID"]["output"];
    properties: KnowledgeDiscoveryAdminhubBookmarkProperties;
};

export type KnowledgeDiscoveryAdminhubBookmarkConnection = {
    __typename?: "KnowledgeDiscoveryAdminhubBookmarkConnection";
    nodes?: Maybe<Array<KnowledgeDiscoveryAdminhubBookmark>>;
    pageInfo: KnowledgeDiscoveryPageInfo;
};

export type KnowledgeDiscoveryAdminhubBookmarkFailureMetadata = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
};

export type KnowledgeDiscoveryAdminhubBookmarkProperties = {
    __typename?: "KnowledgeDiscoveryAdminhubBookmarkProperties";
    bookmarkState?: Maybe<KnowledgeDiscoveryBookmarkState>;
    cloudId: Scalars["String"]["output"];
    createdTimestamp: Scalars["String"]["output"];
    creator?: Maybe<User>;
    creatorAccountId: Scalars["String"]["output"];
    description?: Maybe<Scalars["String"]["output"]>;
    keyPhrases?: Maybe<Array<Scalars["String"]["output"]>>;
    lastModifiedTimestamp: Scalars["String"]["output"];
    lastModifier?: Maybe<User>;
    lastModifierAccountId: Scalars["String"]["output"];
    orgId: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export type KnowledgeDiscoveryAdminhubBookmarkResult =
    | KnowledgeDiscoveryAdminhubBookmark
    | QueryError;

export type KnowledgeDiscoveryAdminhubBookmarksResult =
    | KnowledgeDiscoveryAdminhubBookmarkConnection
    | QueryError;

export type KnowledgeDiscoveryApproveAdminhubBookmarkSuggestionInput = {
    bookmarkAdminhubId: Scalars["ID"]["input"];
    cloudId: Scalars["ID"]["input"];
    orgId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryApproveAdminhubBookmarkSuggestionPayload =
    Payload & {
        __typename?: "KnowledgeDiscoveryApproveAdminhubBookmarkSuggestionPayload";
        adminhubBookmark?: Maybe<KnowledgeDiscoveryAdminhubBookmark>;
        errors?: Maybe<Array<MutationError>>;
        success: Scalars["Boolean"]["output"];
    };

export type KnowledgeDiscoveryAutoDefinition = {
    __typename?: "KnowledgeDiscoveryAutoDefinition";
    confluenceEntity?: Maybe<KnowledgeDiscoveryConfluenceEntity>;
    createdAt: Scalars["String"]["output"];
    definition: Scalars["String"]["output"];
};

export type KnowledgeDiscoveryAutoDefinitionResult =
    | KnowledgeDiscoveryAutoDefinition
    | QueryError;

export type KnowledgeDiscoveryBookmark = {
    __typename?: "KnowledgeDiscoveryBookmark";
    id: Scalars["ID"]["output"];
    properties?: Maybe<KnowledgeDiscoveryBookmarkProperties>;
};

export type KnowledgeDiscoveryBookmarkCollisionFailureMetadata =
    KnowledgeDiscoveryAdminhubBookmarkFailureMetadata & {
        __typename?: "KnowledgeDiscoveryBookmarkCollisionFailureMetadata";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        conflictingAdminhubBookmarkId?: Maybe<Scalars["ID"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        keyPhrase?: Maybe<Scalars["String"]["output"]>;
    };

export type KnowledgeDiscoveryBookmarkMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "KnowledgeDiscoveryBookmarkMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        bookmarkFailureMetadata?: Maybe<KnowledgeDiscoveryAdminhubBookmarkFailureMetadata>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type KnowledgeDiscoveryBookmarkProperties = {
    __typename?: "KnowledgeDiscoveryBookmarkProperties";
    bookmarkState?: Maybe<KnowledgeDiscoveryBookmarkState>;
    description?: Maybe<Scalars["String"]["output"]>;
    keyPhrase: Scalars["String"]["output"];
    lastModifiedTimestamp: Scalars["String"]["output"];
    lastModifierAccountId: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export type KnowledgeDiscoveryBookmarkResult =
    | KnowledgeDiscoveryBookmark
    | QueryError;

export enum KnowledgeDiscoveryBookmarkState {
    Active = "ACTIVE",
    Suggested = "SUGGESTED"
}

export type KnowledgeDiscoveryBookmarkValidationFailureMetadata =
    KnowledgeDiscoveryAdminhubBookmarkFailureMetadata & {
        __typename?: "KnowledgeDiscoveryBookmarkValidationFailureMetadata";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        keyPhrase?: Maybe<Scalars["String"]["output"]>;
    };

export type KnowledgeDiscoveryConfluenceBlogpost = KnowledgeDiscoveryEntity & {
    __typename?: "KnowledgeDiscoveryConfluenceBlogpost";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    confluenceBlogpost?: Maybe<ConfluenceBlogPost>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
};

export type KnowledgeDiscoveryConfluenceEntity =
    | ConfluenceBlogPost
    | ConfluencePage;

export type KnowledgeDiscoveryConfluencePage = KnowledgeDiscoveryEntity & {
    __typename?: "KnowledgeDiscoveryConfluencePage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    confluencePage?: Maybe<ConfluencePage>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
};

export type KnowledgeDiscoveryConfluenceSpace = KnowledgeDiscoveryEntity & {
    __typename?: "KnowledgeDiscoveryConfluenceSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    confluenceSpace?: Maybe<ConfluenceSpace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
};

export type KnowledgeDiscoveryCreateAdminhubBookmarkInput = {
    cloudId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    keyPhrases?: InputMaybe<Array<Scalars["String"]["input"]>>;
    orgId: Scalars["String"]["input"];
    title: Scalars["String"]["input"];
    url: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryCreateAdminhubBookmarkPayload = Payload & {
    __typename?: "KnowledgeDiscoveryCreateAdminhubBookmarkPayload";
    adminhubBookmark?: Maybe<KnowledgeDiscoveryAdminhubBookmark>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeDiscoveryCreateAdminhubBookmarksInput = {
    bookmarks?: InputMaybe<
        Array<KnowledgeDiscoveryCreateAdminhubBookmarkInput>
    >;
    cloudId: Scalars["ID"]["input"];
    orgId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryCreateAdminhubBookmarksPayload = Payload & {
    __typename?: "KnowledgeDiscoveryCreateAdminhubBookmarksPayload";
    adminhubBookmark?: Maybe<Array<Maybe<KnowledgeDiscoveryAdminhubBookmark>>>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeDiscoveryCreateDefinitionInput = {
    definition: Scalars["String"]["input"];
    entityIdInScope: Scalars["String"]["input"];
    keyPhrase: Scalars["String"]["input"];
    referenceContentId?: InputMaybe<Scalars["String"]["input"]>;
    referenceUrl?: InputMaybe<Scalars["String"]["input"]>;
    scope: KnowledgeDiscoveryDefinitionScope;
    workspaceId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryCreateDefinitionPayload = Payload & {
    __typename?: "KnowledgeDiscoveryCreateDefinitionPayload";
    definitionDetails?: Maybe<KnowledgeDiscoveryDefinition>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeDiscoveryDefinition = {
    __typename?: "KnowledgeDiscoveryDefinition";
    accountId: Scalars["String"]["output"];
    confluenceEntity?: Maybe<KnowledgeDiscoveryConfluenceEntity>;
    createdAt: Scalars["String"]["output"];
    definition: Scalars["String"]["output"];
    editor?: Maybe<User>;
    entityIdInScope: Scalars["String"]["output"];
    keyPhrase: Scalars["String"]["output"];
    referenceUrl?: Maybe<Scalars["String"]["output"]>;
    scope: KnowledgeDiscoveryDefinitionScope;
};

export type KnowledgeDiscoveryDefinitionHistoryResult =
    | KnowledgeDiscoveryDefinitionList
    | QueryError;

export type KnowledgeDiscoveryDefinitionList = {
    __typename?: "KnowledgeDiscoveryDefinitionList";
    definitions?: Maybe<Array<Maybe<KnowledgeDiscoveryDefinition>>>;
};

export type KnowledgeDiscoveryDefinitionResult =
    | KnowledgeDiscoveryDefinition
    | QueryError;

export enum KnowledgeDiscoveryDefinitionScope {
    Blogpost = "BLOGPOST",
    Organization = "ORGANIZATION",
    Page = "PAGE",
    Project = "PROJECT",
    Space = "SPACE"
}

export type KnowledgeDiscoveryDefinitionScopeIdConfluence = {
    contentId?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryDefinitionScopeIdJira = {
    projectId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryDeleteBookmarkInput = {
    bookmarkAdminhubId: Scalars["ID"]["input"];
    keyPhrases?: InputMaybe<Array<Scalars["String"]["input"]>>;
    url: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryDeleteBookmarksInput = {
    cloudId: Scalars["ID"]["input"];
    deleteRequests?: InputMaybe<Array<KnowledgeDiscoveryDeleteBookmarkInput>>;
    orgId: Scalars["ID"]["input"];
};

export type KnowledgeDiscoveryDeleteBookmarksPayload = Payload & {
    __typename?: "KnowledgeDiscoveryDeleteBookmarksPayload";
    errors?: Maybe<Array<MutationError>>;
    retriableIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    success: Scalars["Boolean"]["output"];
    successCount?: Maybe<Scalars["Int"]["output"]>;
};

export type KnowledgeDiscoveryEntity = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
};

export type KnowledgeDiscoveryEntityGroup = {
    __typename?: "KnowledgeDiscoveryEntityGroup";
    entities?: Maybe<Array<Maybe<KnowledgeDiscoveryEntity>>>;
    entityType: KnowledgeDiscoveryEntityType;
};

export enum KnowledgeDiscoveryEntityType {
    ConfluenceBlogpost = "CONFLUENCE_BLOGPOST",
    ConfluenceDocument = "CONFLUENCE_DOCUMENT",
    ConfluencePage = "CONFLUENCE_PAGE",
    ConfluenceSpace = "CONFLUENCE_SPACE",
    JiraProject = "JIRA_PROJECT",
    KeyPhrase = "KEY_PHRASE",
    Topic = "TOPIC",
    User = "USER"
}

export type KnowledgeDiscoveryJiraProject = KnowledgeDiscoveryEntity & {
    __typename?: "KnowledgeDiscoveryJiraProject";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jiraProject?: Maybe<JiraProject>;
};

export type KnowledgeDiscoveryKeyPhrase = {
    __typename?: "KnowledgeDiscoveryKeyPhrase";
    category: KnowledgeDiscoveryKeyPhraseCategory;
    keyPhrase: Scalars["String"]["output"];
};

export enum KnowledgeDiscoveryKeyPhraseCategory {
    Acronym = "ACRONYM",
    Auto = "AUTO",
    Other = "OTHER",
    Project = "PROJECT",
    Team = "TEAM"
}

export type KnowledgeDiscoveryKeyPhraseConnection = {
    __typename?: "KnowledgeDiscoveryKeyPhraseConnection";
    nodes?: Maybe<Array<Maybe<KnowledgeDiscoveryKeyPhrase>>>;
    pageInfo: PageInfo;
};

export type KnowledgeDiscoveryKeyPhraseInputText = {
    format: KnowledgeDiscoveryKeyPhraseInputTextFormat;
    text: Scalars["String"]["input"];
};

export enum KnowledgeDiscoveryKeyPhraseInputTextFormat {
    Adf = "ADF",
    Plain = "PLAIN"
}

export type KnowledgeDiscoveryKeyPhrasesResult =
    | KnowledgeDiscoveryKeyPhraseConnection
    | QueryError;

export type KnowledgeDiscoveryMutationApi = {
    __typename?: "KnowledgeDiscoveryMutationApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Approve bookmark suggestions in AdminHub")' query directive to the 'approveBookmarkSuggestion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    approveBookmarkSuggestion?: Maybe<KnowledgeDiscoveryApproveAdminhubBookmarkSuggestionPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Create bookmarks in AdminHub")' query directive to the 'createBookmark' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createBookmark?: Maybe<KnowledgeDiscoveryCreateAdminhubBookmarkPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Create bookmarks in AdminHub")' query directive to the 'createBookmarks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createBookmarks?: Maybe<KnowledgeDiscoveryCreateAdminhubBookmarksPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Create definition")' query directive to the 'createDefinition' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createDefinition?: Maybe<KnowledgeDiscoveryCreateDefinitionPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Delete bookmarks in AdminHub")' query directive to the 'deleteBookmarks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteBookmarks?: Maybe<KnowledgeDiscoveryDeleteBookmarksPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Update bookmarks in AdminHub")' query directive to the 'updateBookmark' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateBookmark?: Maybe<KnowledgeDiscoveryUpdateAdminhubBookmarkPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Update Related Entity")' query directive to the 'updateRelatedEntities' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateRelatedEntities?: Maybe<KnowledgeDiscoveryUpdateRelatedEntitiesPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Update User KeyPhrase Interaction")' query directive to the 'updateUserKeyPhraseInteraction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateUserKeyPhraseInteraction?: Maybe<KnowledgeDiscoveryUpdateUserKeyPhraseInteractionPayload>;
};

export type KnowledgeDiscoveryMutationApiApproveBookmarkSuggestionArgs = {
    input: KnowledgeDiscoveryApproveAdminhubBookmarkSuggestionInput;
};

export type KnowledgeDiscoveryMutationApiCreateBookmarkArgs = {
    input: KnowledgeDiscoveryCreateAdminhubBookmarkInput;
};

export type KnowledgeDiscoveryMutationApiCreateBookmarksArgs = {
    input: KnowledgeDiscoveryCreateAdminhubBookmarksInput;
};

export type KnowledgeDiscoveryMutationApiCreateDefinitionArgs = {
    input: KnowledgeDiscoveryCreateDefinitionInput;
};

export type KnowledgeDiscoveryMutationApiDeleteBookmarksArgs = {
    input: KnowledgeDiscoveryDeleteBookmarksInput;
};

export type KnowledgeDiscoveryMutationApiUpdateBookmarkArgs = {
    input: KnowledgeDiscoveryUpdateAdminhubBookmarkInput;
};

export type KnowledgeDiscoveryMutationApiUpdateRelatedEntitiesArgs = {
    input: KnowledgeDiscoveryUpdateRelatedEntitiesInput;
};

export type KnowledgeDiscoveryMutationApiUpdateUserKeyPhraseInteractionArgs = {
    input: KnowledgeDiscoveryUpdateUserKeyPhraseInteractionInput;
};

export type KnowledgeDiscoveryPageInfo = {
    __typename?: "KnowledgeDiscoveryPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type KnowledgeDiscoveryQueryApi = {
    __typename?: "KnowledgeDiscoveryQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get bookmark in AdminHub")' query directive to the 'adminhubBookmark' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    adminhubBookmark?: Maybe<KnowledgeDiscoveryAdminhubBookmarkResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get bookmarks in AdminHub")' query directive to the 'adminhubBookmarks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    adminhubBookmarks?: Maybe<KnowledgeDiscoveryAdminhubBookmarksResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get auto definition")' query directive to the 'autoDefinition' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    autoDefinition?: Maybe<KnowledgeDiscoveryAutoDefinitionResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    bookmark?: Maybe<KnowledgeDiscoveryBookmarkResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get definition")' query directive to the 'definition' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    definition?: Maybe<KnowledgeDiscoveryDefinitionResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get definition history")' query directive to the 'definitionHistory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    definitionHistory?: Maybe<KnowledgeDiscoveryDefinitionHistoryResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get Key Phrases")' query directive to the 'keyPhrases' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    keyPhrases?: Maybe<KnowledgeDiscoveryKeyPhrasesResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Get Related Entities")' query directive to the 'relatedEntities' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    relatedEntities?: Maybe<KnowledgeDiscoveryRelatedEntitiesResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Search Related Entities")' query directive to the 'searchRelatedEntities' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    searchRelatedEntities?: Maybe<KnowledgeDiscoverySearchRelatedEntitiesResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Search Team")' query directive to the 'searchTeam' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    searchTeam?: Maybe<KnowledgeDiscoveryTeamSearchResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "KnowledgeDiscovery Search User")' query directive to the 'searchUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    searchUser?: Maybe<KnowledgeDiscoveryUserSearchResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    smartAnswersRoute?: Maybe<KnowledgeDiscoverySmartAnswersRouteResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    topic?: Maybe<KnowledgeDiscoveryTopicResult>;
};

export type KnowledgeDiscoveryQueryApiAdminhubBookmarkArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    orgId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiAdminhubBookmarksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    orgId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiAutoDefinitionArgs = {
    contentId: Scalars["String"]["input"];
    keyPhrase: Scalars["String"]["input"];
    workspaceId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiBookmarkArgs = {
    cloudId: Scalars["String"]["input"];
    keyPhrase: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiDefinitionArgs = {
    confluenceScopeId?: InputMaybe<KnowledgeDiscoveryDefinitionScopeIdConfluence>;
    contentId?: InputMaybe<Scalars["String"]["input"]>;
    jiraScopeId?: InputMaybe<KnowledgeDiscoveryDefinitionScopeIdJira>;
    keyPhrase: Scalars["String"]["input"];
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiDefinitionHistoryArgs = {
    confluenceScopeId?: InputMaybe<KnowledgeDiscoveryDefinitionScopeIdConfluence>;
    contentId?: InputMaybe<Scalars["String"]["input"]>;
    jiraScopeId?: InputMaybe<KnowledgeDiscoveryDefinitionScopeIdJira>;
    keyPhrase: Scalars["String"]["input"];
    spaceId?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiKeyPhrasesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    entityAri?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    inputText?: InputMaybe<KnowledgeDiscoveryKeyPhraseInputText>;
    jiraAssigneeAccountId?: InputMaybe<Scalars["String"]["input"]>;
    jiraReporterAccountId?: InputMaybe<Scalars["String"]["input"]>;
    limited?: InputMaybe<Scalars["Boolean"]["input"]>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryQueryApiRelatedEntitiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    entityId: Scalars["String"]["input"];
    entityType: KnowledgeDiscoveryEntityType;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    relatedEntityType: KnowledgeDiscoveryEntityType;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryQueryApiSearchRelatedEntitiesArgs = {
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    query: Scalars["String"]["input"];
    relatedEntityRequests?: InputMaybe<KnowledgeDiscoveryRelatedEntityRequests>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryQueryApiSearchTeamArgs = {
    orgId: Scalars["String"]["input"];
    siteId: Scalars["String"]["input"];
    teamName: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiSearchUserArgs = {
    siteId: Scalars["String"]["input"];
    userQuery: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiSmartAnswersRouteArgs = {
    locale: Scalars["String"]["input"];
    metadata?: InputMaybe<Scalars["String"]["input"]>;
    orgId?: InputMaybe<Scalars["String"]["input"]>;
    query: Scalars["String"]["input"];
    siteId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryQueryApiTopicArgs = {
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["String"]["input"];
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryRelatedEntitiesResult =
    | KnowledgeDiscoveryRelatedEntityConnection
    | QueryError;

export type KnowledgeDiscoveryRelatedEntityAction = {
    action?: InputMaybe<KnowledgeDiscoveryRelatedEntityActionType>;
    relatedEntityId: Scalars["ID"]["input"];
};

export enum KnowledgeDiscoveryRelatedEntityActionType {
    Delete = "DELETE",
    Persist = "PERSIST"
}

export type KnowledgeDiscoveryRelatedEntityConnection = {
    __typename?: "KnowledgeDiscoveryRelatedEntityConnection";
    nodes?: Maybe<Array<Maybe<KnowledgeDiscoveryEntity>>>;
    pageInfo: KnowledgeDiscoveryPageInfo;
};

export type KnowledgeDiscoveryRelatedEntityRequest = {
    count: Scalars["Int"]["input"];
    entityType: KnowledgeDiscoveryEntityType;
};

export type KnowledgeDiscoveryRelatedEntityRequests = {
    requests?: InputMaybe<Array<KnowledgeDiscoveryRelatedEntityRequest>>;
};

export enum KnowledgeDiscoverySearchQueryClassification {
    KeywordOrAcronym = "KEYWORD_OR_ACRONYM",
    NaturalLanguageQuery = "NATURAL_LANGUAGE_QUERY",
    Navigational = "NAVIGATIONAL",
    None = "NONE",
    Person = "PERSON",
    Team = "TEAM"
}

export enum KnowledgeDiscoverySearchQueryClassificationSubtype {
    Command = "COMMAND",
    Confluence = "CONFLUENCE",
    Evaluate = "EVALUATE",
    Jira = "JIRA",
    JobTitle = "JOB_TITLE",
    Llm = "LLM",
    Question = "QUESTION"
}

export type KnowledgeDiscoverySearchRelatedEntities = {
    __typename?: "KnowledgeDiscoverySearchRelatedEntities";
    entityGroups?: Maybe<Array<Maybe<KnowledgeDiscoveryEntityGroup>>>;
};

export type KnowledgeDiscoverySearchRelatedEntitiesResult =
    | KnowledgeDiscoverySearchRelatedEntities
    | QueryError;

export type KnowledgeDiscoverySearchUser = {
    __typename?: "KnowledgeDiscoverySearchUser";
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
};

export type KnowledgeDiscoverySmartAnswersRoute = {
    __typename?: "KnowledgeDiscoverySmartAnswersRoute";
    route: KnowledgeDiscoverySearchQueryClassification;
    subTypes?: Maybe<
        Array<Maybe<KnowledgeDiscoverySearchQueryClassificationSubtype>>
    >;
    transformedQuery: Scalars["String"]["output"];
};

export type KnowledgeDiscoverySmartAnswersRouteResult =
    | KnowledgeDiscoverySmartAnswersRoute
    | QueryError;

export type KnowledgeDiscoveryTeam = {
    __typename?: "KnowledgeDiscoveryTeam";
    id: Scalars["String"]["output"];
};

export type KnowledgeDiscoveryTeamSearchResult =
    | KnowledgeDiscoveryTeam
    | QueryError;

export type KnowledgeDiscoveryTopic = KnowledgeDiscoveryEntity & {
    __typename?: "KnowledgeDiscoveryTopic";
    description: Scalars["String"]["output"];
    documentCount?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    type?: Maybe<KnowledgeDiscoveryTopicType>;
    updatedAt: Scalars["String"]["output"];
};

export type KnowledgeDiscoveryTopicResult =
    | KnowledgeDiscoveryTopic
    | QueryError;

export enum KnowledgeDiscoveryTopicType {
    Area = "AREA",
    Company = "COMPANY",
    Event = "EVENT",
    Process = "PROCESS",
    Program = "PROGRAM",
    Team = "TEAM"
}

export type KnowledgeDiscoveryUpdateAdminhubBookmarkInput = {
    bookmarkAdminhubId: Scalars["ID"]["input"];
    cloudId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    keyPhrases?: InputMaybe<Array<Scalars["String"]["input"]>>;
    orgId: Scalars["String"]["input"];
    title: Scalars["String"]["input"];
    url: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryUpdateAdminhubBookmarkPayload = Payload & {
    __typename?: "KnowledgeDiscoveryUpdateAdminhubBookmarkPayload";
    adminhubBookmark?: Maybe<KnowledgeDiscoveryAdminhubBookmark>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeDiscoveryUpdateRelatedEntitiesInput = {
    actions?: InputMaybe<
        Array<InputMaybe<KnowledgeDiscoveryRelatedEntityAction>>
    >;
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    entity: Scalars["ID"]["input"];
    entityType: KnowledgeDiscoveryEntityType;
    relatedEntityType: KnowledgeDiscoveryEntityType;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type KnowledgeDiscoveryUpdateRelatedEntitiesPayload = Payload & {
    __typename?: "KnowledgeDiscoveryUpdateRelatedEntitiesPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type KnowledgeDiscoveryUpdateUserKeyPhraseInteractionInput = {
    isDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    keyPhrase: Scalars["String"]["input"];
    workspaceId: Scalars["String"]["input"];
};

export type KnowledgeDiscoveryUpdateUserKeyPhraseInteractionPayload =
    Payload & {
        __typename?: "KnowledgeDiscoveryUpdateUserKeyPhraseInteractionPayload";
        errors?: Maybe<Array<MutationError>>;
        success: Scalars["Boolean"]["output"];
    };

export type KnowledgeDiscoveryUser = KnowledgeDiscoveryEntity & {
    __typename?: "KnowledgeDiscoveryUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    user?: Maybe<User>;
};

export type KnowledgeDiscoveryUserSearchResult =
    | KnowledgeDiscoveryUsers
    | QueryError;

export type KnowledgeDiscoveryUsers = {
    __typename?: "KnowledgeDiscoveryUsers";
    users?: Maybe<Array<Maybe<KnowledgeDiscoverySearchUser>>>;
};

export type KnownUser = Person & {
    __typename?: "KnownUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextSelfBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissionType?: Maybe<SitePermissionType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    personalSpace?: Maybe<Space>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profilePicture?: Maybe<Icon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timeZone?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    username?: Maybe<Scalars["String"]["output"]>;
};

export type Label = {
    __typename?: "Label";
    id?: Maybe<Scalars["ID"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    prefix?: Maybe<Scalars["String"]["output"]>;
};

export type LabelEdge = {
    __typename?: "LabelEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Label>;
};

export type LabelInput = {
    name: Scalars["String"]["input"];
    prefix: Scalars["String"]["input"];
};

export type LabelSearchResults = {
    __typename?: "LabelSearchResults";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    otherLabels: Array<Maybe<Label>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suggestedLabels: Array<Maybe<Label>>;
};

export type LabelSort = {
    direction: GraphQlLabelSortDirection;
    sortField: GraphQlLabelSortField;
};

export type LabelUsage = {
    __typename?: "LabelUsage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    count: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    label: Scalars["String"]["output"];
};

export type LastModifiedSummary = {
    __typename?: "LastModifiedSummary";
    friendlyLastModified?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<Version>;
};

export type LayerScreenLookAndFeel = {
    __typename?: "LayerScreenLookAndFeel";
    background?: Maybe<Scalars["String"]["output"]>;
    backgroundAttachment?: Maybe<Scalars["String"]["output"]>;
    backgroundBlendMode?: Maybe<Scalars["String"]["output"]>;
    backgroundClip?: Maybe<Scalars["String"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<Scalars["String"]["output"]>;
    backgroundOrigin?: Maybe<Scalars["String"]["output"]>;
    backgroundPosition?: Maybe<Scalars["String"]["output"]>;
    backgroundRepeat?: Maybe<Scalars["String"]["output"]>;
    backgroundSize?: Maybe<Scalars["String"]["output"]>;
    height?: Maybe<Scalars["String"]["output"]>;
    width?: Maybe<Scalars["String"]["output"]>;
};

export type License = {
    __typename?: "License";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    billingPeriod?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    billingSourceSystem?: Maybe<BillingSourceSystem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licenseConsumingUserCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    licenseStatus: LicenseStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    trialEndDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userLimit?: Maybe<Scalars["Long"]["output"]>;
};

export enum LicenseOverrideState {
    Active = "ACTIVE",
    Advanced = "ADVANCED",
    Inactive = "INACTIVE",
    Standard = "STANDARD",
    Trial = "TRIAL"
}

export type LicenseState = {
    __typename?: "LicenseState";
    billingPeriod?: Maybe<Scalars["String"]["output"]>;
    billingSourceSystem: BillingSourceSystem;
    ccpEntitlementId?: Maybe<Scalars["String"]["output"]>;
    isUgcUalEnabled: Scalars["Boolean"]["output"];
    licenseStatus: LicenseStatus;
    productKey: Scalars["String"]["output"];
    trialEndDate?: Maybe<Scalars["String"]["output"]>;
    trialEndTime?: Maybe<Scalars["Long"]["output"]>;
    unitCount?: Maybe<Scalars["Long"]["output"]>;
};

export type LicenseStates = {
    __typename?: "LicenseStates";
    confluence?: Maybe<LicenseState>;
};

export enum LicenseStatus {
    Active = "ACTIVE",
    Suspended = "SUSPENDED",
    Unlicensed = "UNLICENSED"
}

export type LicensedProduct = {
    __typename?: "LicensedProduct";
    licenseStatus: LicenseStatus;
    productKey: Scalars["String"]["output"];
};

/**
 * See https://developer.atlassian.com/platform/graphql-gateway/schemas/lifecycle-support/#lifecycle-stages for more
 * information on how to use these stages and what they mean in detail.
 * | Lifecycle            | Visible in Prod | Needs `@optIn` directive |                     Allow third parties                       |
 * |----------------------|:---------------:|:------------------------:|:-------------------------------------------------------------:|
 * | STAGING              |       No        |            No            | By default no. Can enable via `allowThirdParties` directive   |
 * | EXPERIMENTAL         |       Yes       |           Yes            | By default no. Can enable via `allowThirdParties` directive   |
 * | BETA                 |       Yes       |           Yes            |                       Always                                  |
 * | PRODUCTION (default) |       Yes       |            No            |                       Always                                  |
 */
export enum LifecycleStage {
    Beta = "BETA",
    Experimental = "EXPERIMENTAL",
    Production = "PRODUCTION",
    Staging = "STAGING"
}

export type LikeContentInput = {
    contentId: Scalars["ID"]["input"];
};

export type LikeContentPayload = {
    __typename?: "LikeContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Content;
};

export type LikeEntity = {
    __typename?: "LikeEntity";
    confluencePerson?: Maybe<ConfluencePerson>;
    creationDate?: Maybe<Scalars["String"]["output"]>;
    currentUserIsFollowing?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LikeEntityEdge = {
    __typename?: "LikeEntityEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<LikeEntity>;
};

export type LikesModelMetadataDto = {
    __typename?: "LikesModelMetadataDto";
    count: Scalars["Int"]["output"];
    currentUser: Scalars["Boolean"]["output"];
    links?: Maybe<LinksContextBase>;
    summary?: Maybe<Scalars["String"]["output"]>;
    users: Array<Maybe<Person>>;
};

export type LikesResponse = {
    __typename?: "LikesResponse";
    count?: Maybe<Scalars["Int"]["output"]>;
    currentUserLikes?: Maybe<Scalars["Boolean"]["output"]>;
    edges?: Maybe<Array<Maybe<LikeEntityEdge>>>;
    /** The current user's followeePersons who like the content. Only the first ones up to the limit are returned. */
    followeePersons: Array<Maybe<ConfluencePerson>>;
    nodes?: Maybe<Array<Maybe<LikeEntity>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type LikesResponseFolloweePersonsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LinksContextBase = {
    __typename?: "LinksContextBase";
    base?: Maybe<Scalars["String"]["output"]>;
    context?: Maybe<Scalars["String"]["output"]>;
};

export type LinksContextSelfBase = {
    __typename?: "LinksContextSelfBase";
    base?: Maybe<Scalars["String"]["output"]>;
    context?: Maybe<Scalars["String"]["output"]>;
    self?: Maybe<Scalars["String"]["output"]>;
};

export type LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase = {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    base?: Maybe<Scalars["String"]["output"]>;
    collection?: Maybe<Scalars["String"]["output"]>;
    context?: Maybe<Scalars["String"]["output"]>;
    download?: Maybe<Scalars["String"]["output"]>;
    editui?: Maybe<Scalars["String"]["output"]>;
    self?: Maybe<Scalars["String"]["output"]>;
    tinyui?: Maybe<Scalars["String"]["output"]>;
    webui?: Maybe<Scalars["String"]["output"]>;
};

export type LinksSelf = {
    __typename?: "LinksSelf";
    self?: Maybe<Scalars["String"]["output"]>;
};

export type ListStorageInput = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contextAri: Scalars["ID"]["input"];
    environmentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type LocalStorage = {
    __typename?: "LocalStorage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    booleanValues: Array<Maybe<LocalStorageBooleanPair>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    stringValues: Array<Maybe<LocalStorageStringPair>>;
};

export type LocalStorageBooleanValuesArgs = {
    keys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type LocalStorageStringValuesArgs = {
    keys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type LocalStorageBooleanPair = {
    __typename?: "LocalStorageBooleanPair";
    key: Scalars["String"]["output"];
    value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LocalStorageBooleanPairInput = {
    key: Scalars["String"]["input"];
    value?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LocalStorageInput = {
    booleanValues?: InputMaybe<Array<InputMaybe<LocalStorageBooleanPairInput>>>;
    stringValues?: InputMaybe<Array<InputMaybe<LocalStorageStringPairInput>>>;
};

export type LocalStorageStringPair = {
    __typename?: "LocalStorageStringPair";
    key: Scalars["String"]["output"];
    value?: Maybe<Scalars["String"]["output"]>;
};

export type LocalStorageStringPairInput = {
    key: Scalars["String"]["input"];
    value?: InputMaybe<Scalars["String"]["input"]>;
};

export type LocalisedString = {
    __typename?: "LocalisedString";
    /** The locale code in RFC 5646 format */
    locale?: Maybe<Scalars["String"]["output"]>;
    /** The localised field value */
    value?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 *
 *
 */
export type LocalizationContext = {
    /** The locale of user in RFC5646 format. */
    locale?: Maybe<Scalars["String"]["output"]>;
    /** The timezone of the user as defined in the tz database https://www.iana.org/time-zones. */
    zoneinfo?: Maybe<Scalars["String"]["output"]>;
};

export type LogDetails = {
    __typename?: "LogDetails";
    /** Does the app share logs that include End-User Data with any third party entities? */
    logEUDShareWithThirdParty?: Maybe<Scalars["Boolean"]["output"]>;
    /** Does the app log End-User Data? */
    logEndUserData?: Maybe<Scalars["Boolean"]["output"]>;
    /** Does the app process and/or store End-User Data in logs outside of Atlassian products and services? */
    logProcessAndOrStoreEUDOutsideAtlassian?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /** Is sharing of logs that include End-User Data with any third party entities integral for app functionality? */
    logsIntegralForAppFunctionality?: Maybe<Scalars["Boolean"]["output"]>;
};

/** The input for choosing invocations of interest. */
export type LogQueryInput = {
    /**
     * Limits the search to a particular version of the app.
     * Optional: if empty will search all versions of the app
     */
    appVersion?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Limits the search to a list of versions of the app.
     * Optional: if empty will search all versions of the app
     */
    appVersions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /**
     * Limits the search to a particular date range.
     *
     * Note: Logs may have a TTL on them so older logs may not be available
     * despite search parameters.
     */
    dates?: InputMaybe<DateSearchInput>;
    /**
     * Limits the search to a particular function in the app.
     * Optional: if empty will search all functions.
     */
    functionKey?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Limits the search to a particular functionKeys of the app.
     * Optional: if empty will search all functionKeys of the app
     */
    functionKeys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /**
     * Specify which installations you want to search.
     * Optional: if empty will search all installations user has access to.
     */
    installationContexts?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /**
     * Filters logs by a specific invocation ID.
     * Optional: if empty will search all invocation IDs.
     */
    invocationId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Limits the search to a particular log level type of message.
     * Optional: if empty will search all log levels
     */
    lvl?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /**
     * Filters logs by module type.
     * Optional: if empty will search all module types.
     */
    moduleType?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Searches all logs matching the search input from user.
     * Optional: if empty will search all logs
     */
    msg?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Filters logs by a specific trace ID.
     * Optional: if empty will search all trace IDs.
     */
    traceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type LookAndFeel = {
    __typename?: "LookAndFeel";
    bordersAndDividers?: Maybe<BordersAndDividersLookAndFeel>;
    content?: Maybe<ContentLookAndFeel>;
    header?: Maybe<HeaderLookAndFeel>;
    headings: Array<Maybe<MapOfStringToString>>;
    horizontalHeader?: Maybe<HeaderLookAndFeel>;
    links?: Maybe<LinksContextBase>;
    menus?: Maybe<MenusLookAndFeel>;
};

export type LookAndFeelSettings = {
    __typename?: "LookAndFeelSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    custom?: Maybe<LookAndFeel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    global?: Maybe<LookAndFeel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    selected?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    theme?: Maybe<LookAndFeel>;
};

export type LoomComment = Node & {
    __typename?: "LoomComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    content?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    editedAt?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    user?: Maybe<User>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    videoId: Scalars["ID"]["output"];
};

export type LoomMeeting = Node & {
    __typename?: "LoomMeeting";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    endsAt?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    external?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recorder?: Maybe<User>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recorderId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recurring?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    source?: Maybe<LoomMeetingSource>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    startsAt?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    video?: Maybe<LoomVideo>;
};

export type LoomMeetingRecurrence = Node & {
    __typename?: "LoomMeetingRecurrence";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    meetings?: Maybe<Array<Maybe<LoomMeeting>>>;
};

export type LoomMeetingRecurrenceMeetingsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    meetingIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export enum LoomMeetingSource {
    GoogleCalendar = "GOOGLE_CALENDAR",
    MicrosoftOutlook = "MICROSOFT_OUTLOOK",
    Zoom = "ZOOM"
}

export type LoomSettings = {
    __typename?: "LoomSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    meetingNotesAvailable?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    meetingNotesEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type LoomSpace = Node & {
    __typename?: "LoomSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

export type LoomToken = {
    __typename?: "LoomToken";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    token: Scalars["String"]["output"];
};

export enum LoomUserStatus {
    Linked = "LINKED",
    LinkedEnterprise = "LINKED_ENTERPRISE",
    Mastered = "MASTERED",
    NotFound = "NOT_FOUND"
}

export type LoomVideo = Node & {
    __typename?: "LoomVideo";
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isArchived: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
    owner?: Maybe<User>;
    ownerId?: Maybe<Scalars["String"]["output"]>;
    url: Scalars["String"]["output"];
};

export type LpCertSort = {
    sortDirection?: InputMaybe<SortDirection>;
    sortField?: InputMaybe<LpCertSortField>;
};

export enum LpCertSortField {
    ActiveDate = "ACTIVE_DATE",
    ExpireDate = "EXPIRE_DATE",
    Id = "ID",
    ImageUrl = "IMAGE_URL",
    Name = "NAME",
    NameAbbr = "NAME_ABBR",
    PublicUrl = "PUBLIC_URL",
    Status = "STATUS",
    Type = "TYPE"
}

export enum LpCertStatus {
    Active = "ACTIVE",
    Expired = "EXPIRED"
}

export enum LpCertType {
    Badge = "BADGE",
    Certification = "CERTIFICATION",
    Standing = "STANDING"
}

/** Certmetrics credentials: certifications/badges/standings */
export type LpCertmetricsCertificate = {
    __typename?: "LpCertmetricsCertificate";
    activeDate?: Maybe<Scalars["String"]["output"]>;
    expireDate?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    imageUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    nameAbbr?: Maybe<Scalars["String"]["output"]>;
    publicUrl?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<LpCertStatus>;
    type?: Maybe<LpCertType>;
};

export type LpCertmetricsCertificateConnection = {
    __typename?: "LpCertmetricsCertificateConnection";
    edges?: Maybe<Array<LpCertmetricsCertificateEdge>>;
    pageInfo?: Maybe<LpPageInfo>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type LpCertmetricsCertificateEdge = {
    __typename?: "LpCertmetricsCertificateEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<LpCertmetricsCertificate>;
};

export type LpCertmetricsCertificateResult =
    | LpCertmetricsCertificateConnection
    | QueryError;

export type LpConnectionQueryErrorExtension = QueryErrorExtension & {
    __typename?: "LpConnectionQueryErrorExtension";
    /**
     * Application specific error type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (such as a HTTP status code) representing the error category
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Course progress: Information of courses progress */
export type LpCourseProgress = {
    __typename?: "LpCourseProgress";
    completedDate?: Maybe<Scalars["String"]["output"]>;
    courseId?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    isFromIntellum: Scalars["Boolean"]["output"];
    lessons?: Maybe<Array<Maybe<LpLessonProgress>>>;
    status?: Maybe<LpCourseStatus>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type LpCourseProgressConnection = {
    __typename?: "LpCourseProgressConnection";
    edges?: Maybe<Array<LpCourseProgressEdge>>;
    pageInfo?: Maybe<LpPageInfo>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type LpCourseProgressEdge = {
    __typename?: "LpCourseProgressEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<LpCourseProgress>;
};

export type LpCourseProgressResult = LpCourseProgressConnection | QueryError;

export type LpCourseSort = {
    sortDirection?: InputMaybe<SortDirection>;
    sortField?: InputMaybe<LpCourseSortField>;
};

export enum LpCourseSortField {
    CompletedDate = "COMPLETED_DATE",
    CourseId = "COURSE_ID",
    Id = "ID",
    Status = "STATUS",
    Title = "TITLE",
    Url = "URL"
}

export enum LpCourseStatus {
    Completed = "COMPLETED",
    InProgress = "IN_PROGRESS"
}

/** Learner/atlassian user */
export type LpLearner = Node & {
    __typename?: "LpLearner";
    atlassianId: Scalars["String"]["output"];
    certmetricsCertificates?: Maybe<LpCertmetricsCertificateResult>;
    courses?: Maybe<LpCourseProgressResult>;
    id: Scalars["ID"]["output"];
};

/** Learner/atlassian user */
export type LpLearnerCertmetricsCertificatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    sorting?: InputMaybe<LpCertSort>;
    status?: InputMaybe<LpCertStatus>;
    type?: InputMaybe<Array<InputMaybe<LpCertType>>>;
};

/** Learner/atlassian user */
export type LpLearnerCoursesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    sorting?: InputMaybe<LpCourseSort>;
    status?: InputMaybe<LpCourseStatus>;
};

export type LpLearnerData = {
    __typename?: "LpLearnerData";
    /**
     * Get Learner's (atlassian user) data, like Certmetrics certifications by atlassianId
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    learnerByAtlassianId?: Maybe<LpLearner>;
    /**
     * Generic relay node query
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<Node>;
};

export type LpLearnerDataLearnerByAtlassianIdArgs = {
    atlassianId: Scalars["String"]["input"];
};

export type LpLearnerDataNodeArgs = {
    id: Scalars["ID"]["input"];
};

/** Lesson progress: Information of lessons progress */
export type LpLessonProgress = {
    __typename?: "LpLessonProgress";
    lessonId?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export type LpPageInfo = {
    __typename?: "LpPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type LpQueryError = Node & {
    __typename?: "LpQueryError";
    /**
     * Contains extra data describing the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The ID of the requested object, or null when the ID is not available.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    identifier?: Maybe<Scalars["ID"]["output"]>;
    /**
     * A message describing the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export enum LpSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type MacroBody = {
    __typename?: "MacroBody";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaToken?: Maybe<EmbeddedMediaToken>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    representation?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webResourceDependencies?: Maybe<WebResourceDependencies>;
};

export type MapOfStringToBoolean = {
    __typename?: "MapOfStringToBoolean";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MapOfStringToFormattedBody = {
    __typename?: "MapOfStringToFormattedBody";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<FormattedBody>;
};

export type MapOfStringToInteger = {
    __typename?: "MapOfStringToInteger";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["Int"]["output"]>;
};

export type MapOfStringToString = {
    __typename?: "MapOfStringToString";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type Map_LinkType_String = {
    __typename?: "Map_LinkType_String";
    download?: Maybe<Scalars["String"]["output"]>;
    editui?: Maybe<Scalars["String"]["output"]>;
    tinyui?: Maybe<Scalars["String"]["output"]>;
    webui?: Maybe<Scalars["String"]["output"]>;
};

export type Mark = {
    attrs?: InputMaybe<MarkAttribute>;
    type: Scalars["String"]["input"];
};

export type MarkAttribute = {
    annotationType: Scalars["String"]["input"];
    id: Scalars["String"]["input"];
};

export type MarkCommentsAsReadInput = {
    commentIds: Array<Scalars["ID"]["input"]>;
};

export type MarkCommentsAsReadPayload = {
    __typename?: "MarkCommentsAsReadPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** A piece of code that modifies the functionality or look and feel of Atlassian products */
export type MarketplaceApp = {
    __typename?: "MarketplaceApp";
    /**
     * A numeric identifier for an app in marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     * A human-readable identifier for an app in marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    appKey: Scalars["String"]["output"];
    /**
     * List of categories associated with an app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    categories: Array<MarketplaceAppCategory>;
    /**
     * Timestamp when the app was created, in ISO time format `yyyy-MM-dd'T'HH:mm:ss.SSS'Z'` e.g, 2013-10-02T22:05:56.767Z
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createdAt: Scalars["DateTime"]["output"];
    /**
     * Distribution information about the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    distribution?: Maybe<MarketplaceAppDistribution>;
    /**
     * Status of the app entity in Marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityStatus: MarketplaceEntityStatus;
    /**
     * A URL where users can find Community Support resources for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    forumsUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * Google analytics Ga4 id used for tracking visitors to the app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    googleAnalytics4Id?: Maybe<Scalars["String"]["output"]>;
    /**
     * Google analytics id used for tracking visitors to the app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    googleAnalyticsId?: Maybe<Scalars["String"]["output"]>;
    /**
     * When enabled providing customers with a place to ask questions or browse answers about the app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isAtlassianCommunityEnabled: Scalars["Boolean"]["output"];
    /**
     * Link to the issue tracker for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issueTrackerUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * JSD widget key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    jsdWidgetKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * Status of app’s listing in Marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    listingStatus: MarketplaceListingStatus;
    /**
     * App's logo
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    logo?: Maybe<MarketplaceListingImage>;
    /**
     * Marketing Labels for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    marketingLabels: Array<Scalars["String"]["output"]>;
    /**
     * App's name in Marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
    /**
     * Marketplace Partner that provided this app in Marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    partner?: Maybe<MarketplacePartner>;
    /**
     * Unique id of the Marketplace Partner that provided this app in Marketplace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    partnerId: Scalars["ID"]["output"];
    /**
     * Link to a statement explaining how the app uses and secures user data.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    privacyPolicyUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * Options of Atlassian product instance hosting types for which app versions are available.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    productHostingOptions: Array<AtlassianProductHostingType>;
    /**
     * Marketplace App Programs that this App has enrolled in.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    programs?: Maybe<MarketplaceAppPrograms>;
    /**
     * Summary of the reviews for an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reviewSummary?: Maybe<MarketplaceAppReviewSummary>;
    /**
     * Segment write key for capturing user journey funnel for the app.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    segmentWriteKey?: Maybe<Scalars["String"]["output"]>;
    /**
     * An SEO-friendly URL pathname for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    slug: Scalars["String"]["output"];
    /**
     * Link to the status page for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusPageUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * A summary describing the app functionality.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary?: Maybe<Scalars["String"]["output"]>;
    /**
     * Link to the support ticket system for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    supportTicketSystemUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     * A short phrase that summarizes what the app does.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tagline?: Maybe<Scalars["String"]["output"]>;
    /**
     * Tags associated with an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tags?: Maybe<MarketplaceAppTags>;
    /**
     * App's versions in Marketplace system.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    versions: MarketplaceAppVersionConnection;
    /**
     * Information of watchers of a Marketplace app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    watchersInfo?: Maybe<MarketplaceAppWatchersInfo>;
    /**
     * A URL where users can find documentation platform hosted by the partner
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    wikiUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** A piece of code that modifies the functionality or look and feel of Atlassian products */
export type MarketplaceAppProductHostingOptionsArgs = {
    excludeHiddenIn?: InputMaybe<MarketplaceLocation>;
};

/** A piece of code that modifies the functionality or look and feel of Atlassian products */
export type MarketplaceAppVersionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<MarketplaceAppVersionFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Category associated with an app */
export type MarketplaceAppCategory = {
    __typename?: "MarketplaceAppCategory";
    /** Name of the category */
    name: Scalars["String"]["output"];
};

/** A connection providing cursor-based pagination for a list of apps. */
export type MarketplaceAppConnection = {
    __typename?: "MarketplaceAppConnection";
    /**
     * A list of edges in the current page, each containing an app and its cursor.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<MarketplaceAppConnectionEdge>>>;
    /**
     * Information about the current page in the list, to enable pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageInfo;
    /**
     * The total number of apps in the list.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    totalCount: Scalars["Int"]["output"];
};

/** An entry in a paginated list of apps. */
export type MarketplaceAppConnectionEdge = {
    __typename?: "MarketplaceAppConnectionEdge";
    /** An opaque string to be used in cursor-based pagination. */
    cursor: Scalars["String"]["output"];
    /** The app from the list. */
    node?: Maybe<MarketplaceApp>;
};

/** All deployment related properties for an app version */
export type MarketplaceAppDeployment = {
    /** All Atlassian Products this app version is compatible with */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
};

/** Step for installing the instructional app */
export type MarketplaceAppDeploymentStep = {
    __typename?: "MarketplaceAppDeploymentStep";
    /**
     * Text/html to explain the step
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    instruction: Scalars["String"]["output"];
    /**
     * Screenshot of the step
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    screenshot?: Maybe<MarketplaceListingImage>;
};

/** Marketplace app's distribution information */
export type MarketplaceAppDistribution = {
    __typename?: "MarketplaceAppDistribution";
    /** Number of app downloads */
    downloadCount?: Maybe<Scalars["Int"]["output"]>;
    /** Number of app installations */
    installationCount?: Maybe<Scalars["Int"]["output"]>;
    /** Tells whether the app is preinstalled on Cloud */
    isPreinstalledInCloud: Scalars["Boolean"]["output"];
    /** Tells whether the app is preinstalled on Server and Data Center */
    isPreinstalledInServerDC: Scalars["Boolean"]["output"];
};

/** Payment model for integrating an app with an Atlassian product. */
export enum MarketplaceAppPaymentModel {
    Free = "FREE",
    PaidViaAtlassian = "PAID_VIA_ATLASSIAN",
    PaidViaPartner = "PAID_VIA_PARTNER"
}

/** Marketplace App Programs that this Marketplace App has enrolled into. */
export type MarketplaceAppPrograms = {
    __typename?: "MarketplaceAppPrograms";
    bugBountyParticipant?: Maybe<MarketplaceBugBountyParticipant>;
    cloudFortified?: Maybe<MarketplaceCloudFortified>;
};

/** Summary of the reviews for an app */
export type MarketplaceAppReviewSummary = {
    __typename?: "MarketplaceAppReviewSummary";
    /** Number of reviews for app */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Rating of the app */
    rating?: Maybe<Scalars["Float"]["output"]>;
    /**
     * Review score of the app
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use field `rating`
     */
    score?: Maybe<Scalars["Float"]["output"]>;
};

/** Tag associated with a MarketplaceApp */
export type MarketplaceAppTag = {
    __typename?: "MarketplaceAppTag";
    /** Id of the tag */
    id: Scalars["ID"]["output"];
    /** Name of the tag */
    name: Scalars["String"]["output"];
};

/** Tags associated with a MarketplaceApp */
export type MarketplaceAppTags = {
    __typename?: "MarketplaceAppTags";
    /** Category tags */
    categoryTags?: Maybe<Array<MarketplaceAppTag>>;
    /** Category tags */
    keywordTags?: Maybe<Array<MarketplaceAppTag>>;
    /** Marketing tags */
    marketingTags?: Maybe<Array<MarketplaceAppTag>>;
};

/** App trust information for a marketplace entity */
export type MarketplaceAppTrustInformation = {
    __typename?: "MarketplaceAppTrustInformation";
    /**
     * Data Access And Storage information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dataAccessAndStorage?: Maybe<DataAccessAndStorage>;
    /**
     * Data residency information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dataResidency?: Maybe<DataResidency>;
    /**
     * Data retention information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dataRetention?: Maybe<DataRetention>;
    /**
     * Log details information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    logDetails?: Maybe<LogDetails>;
    /**
     * Privacy information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    privacy?: Maybe<Privacy>;
    /**
     * Properties of the Trust information stored for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    properties?: Maybe<Properties>;
    /**
     * Security information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    security?: Maybe<Security>;
    /**
     * Third Party sharing information for the app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    thirdPartyInformation?: Maybe<ThirdPartyInformation>;
};

/** App trust information or associated error in querying */
export type MarketplaceAppTrustInformationResult =
    | MarketplaceAppTrustInformation
    | QueryError;

/** Version of App in Marketplace system */
export type MarketplaceAppVersion = {
    __typename?: "MarketplaceAppVersion";
    /** A unique number for each version, higher value indicates more recent version of the app. */
    buildNumber: Scalars["ID"]["output"];
    /** All deployment related properties for this app version */
    deployment: MarketplaceAppDeployment;
    /** A URL where users can find version-specific or general documentation about the app. */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Flag to determine Edition enabled or not */
    editionsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Link to the terms that give end users the right to use the app. */
    endUserLicenseAgreementUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Hero image to be displayed on this app's listing */
    heroImage?: Maybe<MarketplaceListingImage>;
    /** Feature highlights to be displayed on this app's listing */
    highlights?: Maybe<Array<MarketplaceListingHighlight>>;
    /** Tells whether this version has official support. */
    isSupported: Scalars["Boolean"]["output"];
    /** A URL where customers can access more information about this app. */
    learnMoreUrl?: Maybe<Scalars["URL"]["output"]>;
    /** License type for this version of Marketplace app. */
    licenseType?: Maybe<MarketplaceAppVersionLicenseType>;
    /** Awards, customer testimonials, accolades, language support, or other details about this app. */
    moreDetails?: Maybe<Scalars["String"]["output"]>;
    /** Payment model for integrating an app with an Atlassian product. */
    paymentModel: MarketplaceAppPaymentModel;
    /** List of Hosting types where compatible Atlassian product instances are installed. */
    productHostingOptions: Array<AtlassianProductHostingType>;
    /** A URL where customers can purchase this app. */
    purchaseUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Version release date */
    releaseDate: Scalars["DateTime"]["output"];
    /** Version release notes */
    releaseNotes?: Maybe<Scalars["String"]["output"]>;
    /** URL with further details about this version release (link available for versions listed before October 2013) */
    releaseNotesUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Version release summary */
    releaseSummary?: Maybe<Scalars["String"]["output"]>;
    /** Feature screenshots to be displayed on this app's listing */
    screenshots?: Maybe<Array<MarketplaceListingScreenshot>>;
    /** A URL to access the app's source code license agreement. This agreement governs how the app's source code is used. */
    sourceCodeLicenseUrl?: Maybe<Scalars["URL"]["output"]>;
    /** This version identifier is for end users, more than one app versions can have same version value. */
    version: Scalars["String"]["output"];
    /** Visibility of this version of Marketplace app. */
    visibility: MarketplaceAppVersionVisibility;
    /** The ID of a YouTube video explaining the features of this app version. */
    youtubeId?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceAppVersionConnection = {
    __typename?: "MarketplaceAppVersionConnection";
    edges?: Maybe<Array<Maybe<MarketplaceAppVersionEdge>>>;
    pageInfo: PageInfo;
    totalCount: Scalars["Int"]["output"];
};

export type MarketplaceAppVersionEdge = {
    __typename?: "MarketplaceAppVersionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MarketplaceAppVersion>;
};

export type MarketplaceAppVersionFilter = {
    /** Unique id of Cloud App's version */
    cloudAppVersionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Excludes hidden versions as per Marketplace */
    excludeHiddenIn?: InputMaybe<MarketplaceLocation>;
    /** Options of Atlassian product instance hosting types for which app versions are available. */
    productHostingOptions?: InputMaybe<Array<AtlassianProductHostingType>>;
    /** Visibility of the version. */
    visibility?: InputMaybe<MarketplaceAppVersionVisibility>;
};

/** License type for an app version */
export type MarketplaceAppVersionLicenseType = {
    __typename?: "MarketplaceAppVersionLicenseType";
    /** Unique ID for the license type. */
    id: Scalars["ID"]["output"];
    /** A URL where customers can see the license terms. */
    link?: Maybe<Scalars["URL"]["output"]>;
    /** Display name for the license type. */
    name: Scalars["String"]["output"];
};

/** Visibility of the Marketplace app's version */
export enum MarketplaceAppVersionVisibility {
    Private = "PRIVATE",
    Public = "PUBLIC"
}

/** Information of watchers of a Marketplace app */
export type MarketplaceAppWatchersInfo = {
    __typename?: "MarketplaceAppWatchersInfo";
    /** Tells if the user is subscribed to the app updates */
    isUserWatchingApp: Scalars["Boolean"]["output"];
    /** Number of users watching the app */
    watchersCount: Scalars["Int"]["output"];
};

/** Filters to apply when querying for my apps. */
export type MarketplaceAppsFilter = {
    /** The apps' status in the Cloud Fortified program */
    cloudFortifiedStatus?: InputMaybe<Array<MarketplaceProgramStatus>>;
    /** Includes private apps or versions if you are authorized to see them */
    includePrivate?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Options of Atlassian product instance hosting types for which app versions are available. */
    productHostingOptions?: InputMaybe<Array<AtlassianProductHostingType>>;
};

/** Billing cycle for which pricing plan applies */
export enum MarketplaceBillingCycle {
    Annual = "ANNUAL",
    Monthly = "MONTHLY"
}

/** Details of Bug bounty program */
export type MarketplaceBugBountyParticipant = {
    __typename?: "MarketplaceBugBountyParticipant";
    /** Indicates that Bug bounty program applicable on cloud hosting version of addon */
    cloud?: Maybe<MarketplaceBugBountyProgramHostingStatus>;
    /** Indicates that Bug bounty program applicable on dataCenter hosting version of addon */
    dataCenter?: Maybe<MarketplaceBugBountyProgramHostingStatus>;
    /** Indicates that Bug bounty program applicable on server hosting version of addon */
    server?: Maybe<MarketplaceBugBountyProgramHostingStatus>;
};

export type MarketplaceBugBountyProgramHostingStatus = {
    __typename?: "MarketplaceBugBountyProgramHostingStatus";
    /** Indicates status for Bug bounty program */
    status?: Maybe<MarketplaceProgramStatus>;
};

/** Cloud app deployment properties */
export type MarketplaceCloudAppDeployment = MarketplaceAppDeployment & {
    __typename?: "MarketplaceCloudAppDeployment";
    /**
     * Unique identifier for the Cloud app's production environment
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cloudAppEnvironmentId: Scalars["ID"]["output"];
    /**
     * Cloud App’s unique identifier
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cloudAppId: Scalars["ID"]["output"];
    /**
     * Unique identifier of Cloud App’s version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cloudAppVersionId: Scalars["ID"]["output"];
    /**
     * All Atlassian Products this app version is compatible with
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
    /**
     * Level of access to an Atlassian product that this app can request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scopes: Array<CloudAppScope>;
};

/** Details of Cloud fortified program. */
export type MarketplaceCloudFortified = {
    __typename?: "MarketplaceCloudFortified";
    /** Indicates status for Cloud fortified program */
    programStatus?: Maybe<MarketplaceProgramStatus>;
    /** Indicates status for Cloud fortified program (Deprecated field: Use field `programStatus`) */
    status?: Maybe<MarketplaceCloudFortifiedStatus>;
};

export enum MarketplaceCloudFortifiedStatus {
    Applied = "APPLIED",
    Approved = "APPROVED",
    NotAParticipant = "NOT_A_PARTICIPANT",
    Rejected = "REJECTED"
}

/** Connect app deployment properties */
export type MarketplaceConnectAppDeployment = MarketplaceAppDeployment & {
    __typename?: "MarketplaceConnectAppDeployment";
    /**
     * All Atlassian Products this app version is compatible with
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
    /**
     * Tells whether there Atlassian Connect app's descriptor file is available
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDescriptorFileAvailable: Scalars["Boolean"]["output"];
    /**
     * Level of access to an Atlassian product that this app can request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scopes: Array<ConnectAppScope>;
};

export enum MarketplaceConsoleAsvlLegacyVersionApprovalStatus {
    Approved = "APPROVED",
    Archived = "ARCHIVED",
    Deleted = "DELETED",
    Rejected = "REJECTED",
    Submitted = "SUBMITTED",
    Uninitiated = "UNINITIATED"
}

export enum MarketplaceConsoleAsvlLegacyVersionStatus {
    Private = "PRIVATE",
    Public = "PUBLIC"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppPrivateListingsPageInfo = {
    __typename?: "MarketplaceConsoleAppPrivateListingsPageInfo";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleAppSoftwareShort = {
    __typename?: "MarketplaceConsoleAppSoftwareShort";
    appKey: Scalars["ID"]["output"];
    appSoftwareId: Scalars["ID"]["output"];
    editionsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    hasConnectVersion?: Maybe<Scalars["Boolean"]["output"]>;
    hasPublicVersion?: Maybe<Scalars["Boolean"]["output"]>;
    hosting: MarketplaceConsoleHosting;
    isLatestActiveVersionPaidViaAtlassian?: Maybe<Scalars["Boolean"]["output"]>;
    isLatestVersionPaidViaAtlassian?: Maybe<Scalars["Boolean"]["output"]>;
    latestForgeVersion?: Maybe<MarketplaceConsoleAppSoftwareVersion>;
    latestVersion?: Maybe<MarketplaceConsoleAppSoftwareVersion>;
    pricingParentSoftware?: Maybe<MarketplaceConsolePricingParentSoftware>;
    storesPersonalData?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MarketplaceConsoleAppSoftwareVersion = {
    __typename?: "MarketplaceConsoleAppSoftwareVersion";
    appSoftware?: Maybe<MarketplaceConsoleAppSoftwareShort>;
    appSoftwareId: Scalars["ID"]["output"];
    buildNumber: Scalars["ID"]["output"];
    changelog?: Maybe<MarketplaceConsoleAppSoftwareVersionChangelog>;
    compatibilities: Array<MarketplaceConsoleAppSoftwareVersionCompatibility>;
    editionsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    frameworkDetails: MarketplaceConsoleAppSoftwareVersionFrameworkDetails;
    isBeta: Scalars["Boolean"]["output"];
    isLatest?: Maybe<Scalars["Boolean"]["output"]>;
    isSupported: Scalars["Boolean"]["output"];
    licenseType?: Maybe<MarketplaceConsoleAppSoftwareVersionLicenseType>;
    sourceCodeLicense?: Maybe<MarketplaceConsoleSourceCodeLicense>;
    state: MarketplaceConsoleAppSoftwareVersionState;
    supportedPaymentModel: MarketplaceConsolePaymentModel;
    /** This field captures all the listing information for the app software version */
    versionListing?: Maybe<MarketplaceConsoleAppSoftwareVersionListing>;
    versionNumber: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppSoftwareVersionChangelog = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionChangelog";
    releaseNotes?: Maybe<Scalars["String"]["output"]>;
    releaseSummary: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppSoftwareVersionCompatibility = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionCompatibility";
    maxBuildNumber?: Maybe<Scalars["String"]["output"]>;
    minBuildNumber?: Maybe<Scalars["String"]["output"]>;
    parentSoftware?: Maybe<MarketplaceConsoleParentSoftware>;
    parentSoftwareId: Scalars["ID"]["output"];
};

export type MarketplaceConsoleAppSoftwareVersionCompatibilityInput = {
    hosting: MarketplaceConsoleHosting;
    maxBuildNumber?: InputMaybe<Scalars["String"]["input"]>;
    minBuildNumber?: InputMaybe<Scalars["String"]["input"]>;
    parentSoftwareId: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppSoftwareVersionFrameworkDetails = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionFrameworkDetails";
    attributes: MarketplaceConsoleFrameworkAttributes;
    frameworkId: Scalars["ID"]["output"];
};

export type MarketplaceConsoleAppSoftwareVersionFrameworkDetailsInput = {
    attributes: MarketplaceConsoleFrameworkAttributesInput;
    frameworkId: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppSoftwareVersionLicenseType = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionLicenseType";
    id: MarketplaceConsoleAppSoftwareVersionLicenseTypeId;
    link?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
};

export enum MarketplaceConsoleAppSoftwareVersionLicenseTypeId {
    Asl = "ASL",
    AtlassianClosedSource = "ATLASSIAN_CLOSED_SOURCE",
    Bsd = "BSD",
    Commercial = "COMMERCIAL",
    CommercialFree = "COMMERCIAL_FREE",
    Epl = "EPL",
    Gpl = "GPL",
    Lgpl = "LGPL"
}

/** This file defines the GQL type definition for the AppSoftwareVersionListing used in the marketplace console */
export type MarketplaceConsoleAppSoftwareVersionListing = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionListing";
    appSoftwareId: Scalars["String"]["output"];
    approvalStatus: Scalars["String"]["output"];
    buildNumber: Scalars["String"]["output"];
    createdAt: Scalars["String"]["output"];
    createdBy: Scalars["String"]["output"];
    deploymentInstructions?: Maybe<
        Array<Maybe<MarketplaceConsoleDeploymentInstruction>>
    >;
    heroImage?: Maybe<Scalars["String"]["output"]>;
    highlights?: Maybe<Array<Maybe<MarketplaceConsoleListingHighLight>>>;
    moreDetails?: Maybe<Scalars["String"]["output"]>;
    screenshots?: Maybe<Array<MarketplaceConsoleListingScreenshot>>;
    status: Scalars["String"]["output"];
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    updatedBy?: Maybe<Scalars["String"]["output"]>;
    vendorLinks?: Maybe<MarketplaceConsoleAppSoftwareVersionListingLinks>;
    version?: Maybe<Scalars["String"]["output"]>;
    youtubeId?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppSoftwareVersionListingLinks = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionListingLinks";
    documentation?: Maybe<Scalars["String"]["output"]>;
    eula?: Maybe<Scalars["String"]["output"]>;
    learnMore?: Maybe<Scalars["String"]["output"]>;
    legacyVendorLinks?: Maybe<MarketplaceConsoleLegacyVendorLinks>;
    purchase?: Maybe<Scalars["String"]["output"]>;
};

export enum MarketplaceConsoleAppSoftwareVersionState {
    Active = "ACTIVE",
    Approved = "APPROVED",
    Archived = "ARCHIVED",
    AutoApproved = "AUTO_APPROVED",
    Draft = "DRAFT",
    Rejected = "REJECTED",
    Submitted = "SUBMITTED"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is composite type and not named as `id` */
export type MarketplaceConsoleAppSoftwareVersionsListItem = {
    __typename?: "MarketplaceConsoleAppSoftwareVersionsListItem";
    appSoftwareId: Scalars["String"]["output"];
    buildNumber: Scalars["String"]["output"];
    legacyAppVersionApprovalStatus?: Maybe<MarketplaceConsoleAsvlLegacyVersionApprovalStatus>;
    legacyAppVersionStatus?: Maybe<MarketplaceConsoleAsvlLegacyVersionStatus>;
    releaseDate?: Maybe<Scalars["String"]["output"]>;
    releaseSummary?: Maybe<Scalars["String"]["output"]>;
    releasedByUserName?: Maybe<Scalars["String"]["output"]>;
    versionNumber?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppSoftwares = {
    __typename?: "MarketplaceConsoleAppSoftwares";
    appSoftwares: Array<MarketplaceConsoleAppSoftwareShort>;
};

export type MarketplaceConsoleAppVersionCreateRequestInput = {
    assets?: InputMaybe<MarketplaceConsoleCreateVersionAssetsInput>;
    buildNumber?: InputMaybe<Scalars["String"]["input"]>;
    compatibilities: Array<MarketplaceConsoleAppSoftwareVersionCompatibilityInput>;
    dcBuildNumber?: InputMaybe<Scalars["String"]["input"]>;
    editionDetails?: InputMaybe<MarketplaceConsoleEditionDetailsInput>;
    frameworkDetails: MarketplaceConsoleAppSoftwareVersionFrameworkDetailsInput;
    paymentModel?: InputMaybe<MarketplaceConsolePaymentModel>;
    versionNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarketplaceConsoleAppVersionDeleteRequestInput = {
    appKey?: InputMaybe<Scalars["ID"]["input"]>;
    appSoftwareId?: InputMaybe<Scalars["ID"]["input"]>;
    buildNumber: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleAppVersionsList = {
    __typename?: "MarketplaceConsoleAppVersionsList";
    hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
    nextCursor?: Maybe<Scalars["String"]["output"]>;
    versions: Array<MarketplaceConsoleAppSoftwareVersionsListItem>;
};

/** Represents an artifact which was uploaded from local file system or remote URL */
export type MarketplaceConsoleArtifactFileInfo = {
    __typename?: "MarketplaceConsoleArtifactFileInfo";
    checksum: Scalars["String"]["output"];
    logicalFileName: Scalars["String"]["output"];
    size: Scalars["Int"]["output"];
};

export type MarketplaceConsoleCanMakeServerVersionPublicInput = {
    dcAppSoftwareId?: InputMaybe<Scalars["ID"]["input"]>;
    serverAppSoftwareId: Scalars["ID"]["input"];
    userKey?: InputMaybe<Scalars["ID"]["input"]>;
    versionNumber: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleConnectFrameworkAttributes = {
    __typename?: "MarketplaceConsoleConnectFrameworkAttributes";
    artifact?: Maybe<MarketplaceConsoleSoftwareArtifact>;
    descriptorId: Scalars["ID"]["output"];
    descriptorUrl: Scalars["String"]["output"];
    scopes: Array<Scalars["String"]["output"]>;
};

export type MarketplaceConsoleConnectFrameworkAttributesInput = {
    href: Scalars["String"]["input"];
};

export type MarketplaceConsoleCreatePrivateAppVersionError =
    MarketplaceConsoleError & {
        __typename?: "MarketplaceConsoleCreatePrivateAppVersionError";
        id: Scalars["ID"]["output"];
        message: Scalars["String"]["output"];
        path?: Maybe<Scalars["String"]["output"]>;
        subCode?: Maybe<Scalars["String"]["output"]>;
    };

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleCreatePrivateAppVersionKnownError = {
    __typename?: "MarketplaceConsoleCreatePrivateAppVersionKnownError";
    errors?: Maybe<
        Array<Maybe<MarketplaceConsoleCreatePrivateAppVersionError>>
    >;
};

export type MarketplaceConsoleCreatePrivateAppVersionMutationOutput =
    | MarketplaceConsoleCreatePrivateAppVersionKnownError
    | MarketplaceConsoleCreatePrivateAppVersionMutationResponse;

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleCreatePrivateAppVersionMutationResponse = {
    __typename?: "MarketplaceConsoleCreatePrivateAppVersionMutationResponse";
    /** URL to the resource created if the mutation was successful */
    resourceUrl?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type MarketplaceConsoleCreateVersionAssetsInput = {
    highlights?: InputMaybe<Array<MarketplaceConsoleHighlightAssetInput>>;
    screenshots?: InputMaybe<Array<MarketplaceConsoleImageAssetInput>>;
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleDeleteAppVersionResponse =
    | MarketplaceConsoleKnownError
    | MarketplaceConsoleMutationVoidResponse;

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleDeploymentInstruction = {
    __typename?: "MarketplaceConsoleDeploymentInstruction";
    body: Scalars["String"]["output"];
    screenshot?: Maybe<MarketplaceConsoleListingScreenshot>;
};

export type MarketplaceConsoleDeploymentInstructionInput = {
    body?: InputMaybe<Scalars["String"]["input"]>;
    screenshotImageUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarketplaceConsoleDevSpace = {
    __typename?: "MarketplaceConsoleDevSpace";
    id: Scalars["ID"]["output"];
    isAtlassian: Scalars["Boolean"]["output"];
    listing: MarketplaceConsoleDevSpaceListing;
    name: Scalars["String"]["output"];
    programEnrollments?: Maybe<
        Array<Maybe<MarketplaceConsoleDevSpaceProgramEnrollment>>
    >;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleDevSpaceContact = {
    __typename?: "MarketplaceConsoleDevSpaceContact";
    addressLine1?: Maybe<Scalars["String"]["output"]>;
    addressLine2?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    country?: Maybe<Scalars["String"]["output"]>;
    email: Scalars["String"]["output"];
    homePageUrl?: Maybe<Scalars["String"]["output"]>;
    otherContactDetails?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["String"]["output"]>;
    postCode?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleDevSpaceListing = {
    __typename?: "MarketplaceConsoleDevSpaceListing";
    contactDetails: MarketplaceConsoleDevSpaceContact;
    description?: Maybe<Scalars["String"]["output"]>;
    displayLogoUrl?: Maybe<Scalars["String"]["output"]>;
    supportDetails?: Maybe<MarketplaceConsoleDevSpaceSupportDetails>;
    trustCenterUrl?: Maybe<Scalars["String"]["output"]>;
};

export enum MarketplaceConsoleDevSpaceProgram {
    AtlassianParter = "ATLASSIAN_PARTER",
    FreeLicense = "FREE_LICENSE",
    MarketplacePartner = "MARKETPLACE_PARTNER",
    SolutionPartner = "SOLUTION_PARTNER"
}

export type MarketplaceConsoleDevSpaceProgramEnrollment = {
    __typename?: "MarketplaceConsoleDevSpaceProgramEnrollment";
    baseUri?: Maybe<Scalars["String"]["output"]>;
    partnerTier?: Maybe<MarketplaceConsoleDevSpaceTier>;
    program?: Maybe<MarketplaceConsoleDevSpaceProgram>;
    programId: Scalars["ID"]["output"];
    solutionPartnerBenefit?: Maybe<Scalars["Boolean"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleDevSpaceSupportAvailability = {
    __typename?: "MarketplaceConsoleDevSpaceSupportAvailability";
    availableFrom: Scalars["String"]["output"];
    availableTo: Scalars["String"]["output"];
    days?: Maybe<Array<Scalars["String"]["output"]>>;
    holidays?: Maybe<Array<MarketplaceConsoleDevSpaceSupportContactHoliday>>;
    timezone: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleDevSpaceSupportContactHoliday = {
    __typename?: "MarketplaceConsoleDevSpaceSupportContactHoliday";
    date: Scalars["String"]["output"];
    repeatAnnually: Scalars["Boolean"]["output"];
    title: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleDevSpaceSupportDetails = {
    __typename?: "MarketplaceConsoleDevSpaceSupportDetails";
    availability?: Maybe<MarketplaceConsoleDevSpaceSupportAvailability>;
    contactEmail?: Maybe<Scalars["String"]["output"]>;
    contactName?: Maybe<Scalars["String"]["output"]>;
    contactPhone?: Maybe<Scalars["String"]["output"]>;
    emergencyContact?: Maybe<Scalars["String"]["output"]>;
    slaUrl?: Maybe<Scalars["String"]["output"]>;
    targetResponseTimeInHrs?: Maybe<Scalars["Int"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum MarketplaceConsoleDevSpaceTier {
    Gold = "GOLD",
    Platinum = "PLATINUM",
    Silver = "SILVER"
}

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleEdition = {
    __typename?: "MarketplaceConsoleEdition";
    features: Array<MarketplaceConsoleFeature>;
    id: Scalars["ID"]["output"];
    isDefault: Scalars["Boolean"]["output"];
    pricingPlan: MarketplaceConsolePricingPlan;
    type: MarketplaceConsoleEditionType;
};

export type MarketplaceConsoleEditionDetailsInput = {
    enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MarketplaceConsoleEditionInput = {
    features: Array<MarketplaceConsoleFeatureInput>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    isDefault: Scalars["Boolean"]["input"];
    pricingPlan: MarketplaceConsolePricingPlanInput;
    type: MarketplaceConsoleEditionType;
};

export type MarketplaceConsoleEditionPricingKnownError =
    MarketplaceConsoleError & {
        __typename?: "MarketplaceConsoleEditionPricingKnownError";
        id: Scalars["ID"]["output"];
        message: Scalars["String"]["output"];
        subCode?: Maybe<Scalars["String"]["output"]>;
        type: MarketplaceConsoleEditionType;
    };

export type MarketplaceConsoleEditionResponse =
    | MarketplaceConsoleEdition
    | MarketplaceConsoleEditionPricingKnownError;

export enum MarketplaceConsoleEditionType {
    Advanced = "ADVANCED",
    AdvancedMultiInstance = "ADVANCED_MULTI_INSTANCE",
    Standard = "STANDARD",
    StandardMultiInstance = "STANDARD_MULTI_INSTANCE"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleEditionsActivation = {
    __typename?: "MarketplaceConsoleEditionsActivation";
    lastUpdated: Scalars["String"]["output"];
    rejectionReason?: Maybe<Scalars["String"]["output"]>;
    status: MarketplaceConsoleEditionsActivationStatus;
    ticketUrl: Scalars["String"]["output"];
};

export type MarketplaceConsoleEditionsActivationRequest = {
    rejectionReason?: InputMaybe<Scalars["String"]["input"]>;
    status: MarketplaceConsoleEditionsActivationStatus;
};

export type MarketplaceConsoleEditionsActivationResponse =
    | MarketplaceConsoleEditionsActivation
    | MarketplaceConsoleKnownError;

/** --------------------------------------------------------------------------------------------- */
export enum MarketplaceConsoleEditionsActivationStatus {
    Approved = "APPROVED",
    Pending = "PENDING",
    Rejected = "REJECTED"
}

export type MarketplaceConsoleEditionsInput = {
    appKey?: InputMaybe<Scalars["String"]["input"]>;
    productId?: InputMaybe<Scalars["String"]["input"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleError = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleExtensibilityFramework = {
    __typename?: "MarketplaceConsoleExtensibilityFramework";
    frameworkId: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleExternalFrameworkAttributes = {
    __typename?: "MarketplaceConsoleExternalFrameworkAttributes";
    authorization: Scalars["Boolean"]["output"];
    binaryUrl?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceConsoleExternalFrameworkAttributesInput = {
    authorization: Scalars["Boolean"]["input"];
    binaryUrl?: InputMaybe<Scalars["String"]["input"]>;
    learnMoreUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarketplaceConsoleFeature = {
    __typename?: "MarketplaceConsoleFeature";
    description: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    position: Scalars["Int"]["output"];
};

export type MarketplaceConsoleFeatureInput = {
    description: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    name: Scalars["String"]["input"];
    position: Scalars["Int"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleForgeFrameworkAttributes = {
    __typename?: "MarketplaceConsoleForgeFrameworkAttributes";
    appId: Scalars["ID"]["output"];
    envId: Scalars["ID"]["output"];
    scopes: Array<Scalars["String"]["output"]>;
    versionId: Scalars["String"]["output"];
};

export type MarketplaceConsoleForgeFrameworkAttributesInput = {
    appId: Scalars["String"]["input"];
    envId: Scalars["String"]["input"];
    scopes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    versionId: Scalars["String"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleFrameworkAttributes = {
    __typename?: "MarketplaceConsoleFrameworkAttributes";
    connect?: Maybe<MarketplaceConsoleConnectFrameworkAttributes>;
    external?: Maybe<MarketplaceConsoleExternalFrameworkAttributes>;
    forge?: Maybe<MarketplaceConsoleForgeFrameworkAttributes>;
    plugin?: Maybe<MarketplaceConsolePluginFrameworkAttributes>;
    workflow?: Maybe<MarketplaceConsoleWorkflowFrameworkAttributes>;
};

export type MarketplaceConsoleFrameworkAttributesInput = {
    connect?: InputMaybe<MarketplaceConsoleConnectFrameworkAttributesInput>;
    external?: InputMaybe<MarketplaceConsoleExternalFrameworkAttributesInput>;
    forge?: InputMaybe<MarketplaceConsoleForgeFrameworkAttributesInput>;
    plugin?: InputMaybe<MarketplaceConsolePluginFrameworkAttributesInput>;
    workflow?: InputMaybe<MarketplaceConsoleWorkflowFrameworkAttributesInput>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleGenericError = MarketplaceConsoleError & {
    __typename?: "MarketplaceConsoleGenericError";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
};

export type MarketplaceConsoleGetVersionsListInput = {
    appSoftwareIds: Array<Scalars["ID"]["input"]>;
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    legacyAppVersionApprovalStatus?: InputMaybe<
        Array<MarketplaceConsoleAsvlLegacyVersionApprovalStatus>
    >;
    legacyAppVersionStatus?: InputMaybe<
        Array<MarketplaceConsoleAsvlLegacyVersionStatus>
    >;
};

export type MarketplaceConsoleHighlightAssetInput = {
    screenshotUrl: Scalars["String"]["input"];
    thumbnailUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * The file contains the common types that are used across
 * different parts of the Marketplace Console BFF GQL schema.
 */
export enum MarketplaceConsoleHosting {
    Cloud = "CLOUD",
    DataCenter = "DATA_CENTER",
    Server = "SERVER"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleHostingOption = {
    __typename?: "MarketplaceConsoleHostingOption";
    hosting: MarketplaceConsoleHosting;
};

export type MarketplaceConsoleImageAssetInput = {
    url: Scalars["String"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleImageMediaAsset = {
    __typename?: "MarketplaceConsoleImageMediaAsset";
    altText?: Maybe<Scalars["String"]["output"]>;
    fileName: Scalars["String"]["output"];
    height: Scalars["Int"]["output"];
    imageType: Scalars["String"]["output"];
    uri: Scalars["String"]["output"];
    width: Scalars["Int"]["output"];
};

/** Ref: https://hello.atlassian.net/wiki/spaces/~549868828/pages/2204917928/Rollout+Plan+Blocking+RuBy+partners+access+to+Marketplace */
export type MarketplaceConsoleKnownError = MarketplaceConsoleError & {
    __typename?: "MarketplaceConsoleKnownError";
    id: Scalars["ID"]["output"];
    message: Scalars["String"]["output"];
    subCode?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceConsoleLegacyCategory = {
    __typename?: "MarketplaceConsoleLegacyCategory";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleLegacyListingDetails = {
    __typename?: "MarketplaceConsoleLegacyListingDetails";
    buildsLink?: Maybe<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    sourceLink?: Maybe<Scalars["String"]["output"]>;
    wikiLink?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleLegacyMongoAppDetails = {
    __typename?: "MarketplaceConsoleLegacyMongoAppDetails";
    hiddenIn?: Maybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
    hostingVisibility?: Maybe<MarketplaceConsoleLegacyMongoHostingVisibility>;
    issueKey?: Maybe<Scalars["String"]["output"]>;
    rejectionReason?: Maybe<Scalars["String"]["output"]>;
    status: MarketplaceConsoleLegacyMongoStatus;
    statusAfterApproval?: Maybe<MarketplaceConsoleLegacyMongoStatus>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleLegacyMongoHostingVisibility = {
    __typename?: "MarketplaceConsoleLegacyMongoHostingVisibility";
    cloud?: Maybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
    dataCenter?: Maybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
    server?: Maybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
};

export enum MarketplaceConsoleLegacyMongoPluginHiddenIn {
    HiddenInSiteAndAppMarketplace = "HIDDEN_IN_SITE_AND_APP_MARKETPLACE",
    HiddenInSiteOnly = "HIDDEN_IN_SITE_ONLY"
}

export enum MarketplaceConsoleLegacyMongoStatus {
    Notassigned = "NOTASSIGNED",
    Private = "PRIVATE",
    Public = "PUBLIC",
    Readytolaunch = "READYTOLAUNCH",
    Rejected = "REJECTED",
    Submitted = "SUBMITTED"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleLegacyVendorLinks = {
    __typename?: "MarketplaceConsoleLegacyVendorLinks";
    donate?: Maybe<Scalars["String"]["output"]>;
    evaluationLicense?: Maybe<Scalars["String"]["output"]>;
};

/** Represents details of a link */
export type MarketplaceConsoleLink = {
    __typename?: "MarketplaceConsoleLink";
    href: Scalars["String"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleListingHighLight = {
    __typename?: "MarketplaceConsoleListingHighLight";
    caption?: Maybe<Scalars["String"]["output"]>;
    screenshot: MarketplaceConsoleListingScreenshot;
    summary?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceConsoleListingHighLightInput = {
    caption?: InputMaybe<Scalars["String"]["input"]>;
    screenshotUrl: Scalars["String"]["input"];
    summary: Scalars["String"]["input"];
    thumbnailUrl: Scalars["String"]["input"];
    title: Scalars["String"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleListingScreenshot = {
    __typename?: "MarketplaceConsoleListingScreenshot";
    caption?: Maybe<Scalars["String"]["output"]>;
    imageUrl?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceConsoleListingScreenshotInput = {
    caption?: InputMaybe<Scalars["String"]["input"]>;
    imageUrl: Scalars["String"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleMakeAppPublicError = MarketplaceConsoleError & {
    __typename?: "MarketplaceConsoleMakeAppPublicError";
    id: Scalars["ID"]["output"];
    message: Scalars["String"]["output"];
    path?: Maybe<Scalars["String"]["output"]>;
    subCode?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleMakeAppPublicKnownError = {
    __typename?: "MarketplaceConsoleMakeAppPublicKnownError";
    errors?: Maybe<Array<Maybe<MarketplaceConsoleMakeAppPublicError>>>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleMakeAppVersionPublicChecks = {
    __typename?: "MarketplaceConsoleMakeAppVersionPublicChecks";
    canBeMadePublic?: Maybe<Scalars["Boolean"]["output"]>;
    redirectToVersionsPage?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MarketplaceConsoleMakeAppVersionPublicMutationOutput =
    | MarketplaceConsoleMakeAppPublicKnownError
    | MarketplaceConsoleMutationVoidResponse;

/** For the nullable fields in request, null value means that the input was not provided and therefore would not be updated */
export type MarketplaceConsoleMakeAppVersionPublicRequest = {
    appKey: Scalars["ID"]["input"];
    appStatusPageUrl?: InputMaybe<Scalars["String"]["input"]>;
    binaryUrl?: InputMaybe<Scalars["String"]["input"]>;
    buildNumber: Scalars["ID"]["input"];
    categories?: InputMaybe<Array<Scalars["String"]["input"]>>;
    communityEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    compatibilities?: InputMaybe<
        Array<MarketplaceConsoleAppSoftwareVersionCompatibilityInput>
    >;
    dataCenterReviewIssueKey?: InputMaybe<Scalars["String"]["input"]>;
    deploymentInstructions?: InputMaybe<
        Array<MarketplaceConsoleDeploymentInstructionInput>
    >;
    documentationUrl?: InputMaybe<Scalars["String"]["input"]>;
    eulaUrl?: InputMaybe<Scalars["String"]["input"]>;
    forumsUrl?: InputMaybe<Scalars["String"]["input"]>;
    googleAnalytics4Id?: InputMaybe<Scalars["String"]["input"]>;
    googleAnalyticsId?: InputMaybe<Scalars["String"]["input"]>;
    heroImageUrl?: InputMaybe<Scalars["String"]["input"]>;
    highlights?: InputMaybe<Array<MarketplaceConsoleListingHighLightInput>>;
    isBeta?: InputMaybe<Scalars["Boolean"]["input"]>;
    isSupported?: InputMaybe<Scalars["Boolean"]["input"]>;
    issueTrackerUrl?: InputMaybe<Scalars["String"]["input"]>;
    keywords?: InputMaybe<Array<Scalars["String"]["input"]>>;
    learnMoreUrl?: InputMaybe<Scalars["String"]["input"]>;
    licenseType?: InputMaybe<MarketplaceConsoleAppSoftwareVersionLicenseTypeId>;
    logoUrl?: InputMaybe<Scalars["String"]["input"]>;
    marketingLabels?: InputMaybe<Array<Scalars["String"]["input"]>>;
    moreDetails?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    paymentModel?: InputMaybe<MarketplaceConsolePaymentModel>;
    privacyUrl?: InputMaybe<Scalars["String"]["input"]>;
    productId: Scalars["ID"]["input"];
    purchaseUrl?: InputMaybe<Scalars["String"]["input"]>;
    releaseNotes?: InputMaybe<Scalars["String"]["input"]>;
    releaseSummary?: InputMaybe<Scalars["String"]["input"]>;
    screenshots?: InputMaybe<Array<MarketplaceConsoleListingScreenshotInput>>;
    segmentWriteKey?: InputMaybe<Scalars["String"]["input"]>;
    sourceCodeLicenseUrl?: InputMaybe<Scalars["String"]["input"]>;
    statusAfterApproval?: InputMaybe<MarketplaceConsoleLegacyMongoStatus>;
    storesPersonalData?: InputMaybe<Scalars["Boolean"]["input"]>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
    supportTicketSystemUrl?: InputMaybe<Scalars["String"]["input"]>;
    tagLine?: InputMaybe<Scalars["String"]["input"]>;
    youtubeId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApi = {
    __typename?: "MarketplaceConsoleMutationApi";
    /**
     * Sets Activation Status of a product's edition(s).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleEditionsActivation")' query directive to the 'activateEditions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    activateEditions?: Maybe<MarketplaceConsoleEditionsActivation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsolePrivateListings")' query directive to the 'createAppSoftwareToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createAppSoftwareToken?: Maybe<MarketplaceConsoleTokenDetails>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleEdition")' query directive to the 'createEcoHelpTicket' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createEcoHelpTicket?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwareVersionCreate")' query directive to the 'createPrivateAppSoftwareVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createPrivateAppSoftwareVersion?: Maybe<MarketplaceConsoleCreatePrivateAppVersionMutationOutput>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsolePrivateListings")' query directive to the 'deleteAppSoftwareToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteAppSoftwareToken?: Maybe<MarketplaceConsoleMutationVoidResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwareVersionDelete")' query directive to the 'deleteAppVersion' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteAppVersion?: Maybe<MarketplaceConsoleDeleteAppVersionResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleEdition")' query directive to the 'editions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editions?: Maybe<Array<Maybe<MarketplaceConsoleEditionResponse>>>;
    /**
     * Make the app version public, given the updatable fields in the request.
     * The fields are across the domains - app software version, app software version listing, and product listing.
     * The fields that are not provided in the request will not be updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleMakeAppVersionPublic")' query directive to the 'makeAppVersionPublic' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    makeAppVersionPublic?: Maybe<MarketplaceConsoleMakeAppVersionPublicMutationOutput>;
    /**
     * Update app details, given the updatable fields in the request.
     * The fields that are not provided in the request will not be updated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleUpdateAppDetails")' query directive to the 'updateAppDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateAppDetails?: Maybe<MarketplaceConsoleUpdateAppDetailsResponse>;
    /**
     *   Validate the remote artifact URL for an app software version
     *
     * # Arguments
     *   - url: The URL of the remote artifact
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleValidateArtifactUrl")' query directive to the 'validateArtifactUrl' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    validateArtifactUrl?: Maybe<MarketplaceConsoleSoftwareArtifact>;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiActivateEditionsArgs = {
    activationRequest: MarketplaceConsoleEditionsActivationRequest;
    product: MarketplaceConsoleEditionsInput;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiCreateAppSoftwareTokenArgs = {
    appSoftwareId: Scalars["String"]["input"];
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiCreateEcoHelpTicketArgs = {
    product: MarketplaceConsoleEditionsInput;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiCreatePrivateAppSoftwareVersionArgs = {
    appKey: Scalars["ID"]["input"];
    version: MarketplaceConsoleAppVersionCreateRequestInput;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiDeleteAppSoftwareTokenArgs = {
    appSoftwareId: Scalars["String"]["input"];
    token: Scalars["String"]["input"];
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiDeleteAppVersionArgs = {
    deleteVersion: MarketplaceConsoleAppVersionDeleteRequestInput;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiEditionsArgs = {
    editions: Array<MarketplaceConsoleEditionInput>;
    product: MarketplaceConsoleEditionsInput;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiMakeAppVersionPublicArgs = {
    makeAppVersionPublicRequest: MarketplaceConsoleMakeAppVersionPublicRequest;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiUpdateAppDetailsArgs = {
    updateAppDetailsRequest: MarketplaceConsoleUpdateAppDetailsRequest;
};

/** Namespace for Console related mutations */
export type MarketplaceConsoleMutationApiValidateArtifactUrlArgs = {
    url: Scalars["String"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleMutationVoidResponse = {
    __typename?: "MarketplaceConsoleMutationVoidResponse";
    success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleParentSoftware = {
    __typename?: "MarketplaceConsoleParentSoftware";
    extensibilityFrameworks: Array<MarketplaceConsoleExtensibilityFramework>;
    hostingOptions: Array<MarketplaceConsoleHostingOption>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    state: MarketplaceConsoleParentSoftwareState;
    versions: Array<MarketplaceConsoleParentSoftwareVersion>;
};

export type MarketplaceConsoleParentSoftwareEdition = {
    __typename?: "MarketplaceConsoleParentSoftwareEdition";
    pricingPlan: MarketplaceConsoleParentSoftwarePricingPlans;
    slug: Scalars["String"]["output"];
    type: MarketplaceConsoleEditionType;
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleParentSoftwarePricing = {
    __typename?: "MarketplaceConsoleParentSoftwarePricing";
    editions: Array<MarketplaceConsoleParentSoftwareEdition>;
    id: Scalars["String"]["output"];
};

export type MarketplaceConsoleParentSoftwarePricingPlan = {
    __typename?: "MarketplaceConsoleParentSoftwarePricingPlan";
    tieredPricing: Array<Maybe<MarketplaceConsoleParentSoftwareTieredPricing>>;
};

export type MarketplaceConsoleParentSoftwarePricingPlans = {
    __typename?: "MarketplaceConsoleParentSoftwarePricingPlans";
    annualPricingPlan: MarketplaceConsoleParentSoftwarePricingPlan;
    currency: MarketplaceConsolePricingCurrency;
    monthlyPricingPlan: MarketplaceConsoleParentSoftwarePricingPlan;
};

export type MarketplaceConsoleParentSoftwarePricingQueryInput = {
    parentProductId: Scalars["String"]["input"];
};

export enum MarketplaceConsoleParentSoftwareState {
    Active = "ACTIVE",
    Archived = "ARCHIVED",
    Draft = "DRAFT"
}

export type MarketplaceConsoleParentSoftwareTieredPricing = {
    __typename?: "MarketplaceConsoleParentSoftwareTieredPricing";
    ceiling: Scalars["Float"]["output"];
    flatAmount?: Maybe<Scalars["Float"]["output"]>;
    floor: Scalars["Float"]["output"];
    unitAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleParentSoftwareVersion = {
    __typename?: "MarketplaceConsoleParentSoftwareVersion";
    buildNumber: Scalars["ID"]["output"];
    hosting: Array<MarketplaceConsoleHosting>;
    state: MarketplaceConsoleParentSoftwareState;
    versionNumber: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsolePartnerContact = {
    __typename?: "MarketplaceConsolePartnerContact";
    atlassianAccountId: Scalars["ID"]["output"];
    partnerId: Scalars["ID"]["output"];
    permissions: MarketplaceConsolePartnerContactPermissions;
};

export type MarketplaceConsolePartnerContactPermissions = {
    __typename?: "MarketplaceConsolePartnerContactPermissions";
    atlassianAccountId: Scalars["ID"]["output"];
    canManageAppDetails: Scalars["Boolean"]["output"];
    canManageAppPricing: Scalars["Boolean"]["output"];
    canManageMarketing: Scalars["Boolean"]["output"];
    canManagePartnerDetails: Scalars["Boolean"]["output"];
    canManagePartnerPaymentDetails: Scalars["Boolean"]["output"];
    canManagePartnerSecurity: Scalars["Boolean"]["output"];
    canManagePromotions: Scalars["Boolean"]["output"];
    canViewAnyReports: Scalars["Boolean"]["output"];
    canViewCloudTrendReports: Scalars["Boolean"]["output"];
    canViewManagedApps: Scalars["Boolean"]["output"];
    canViewPartnerContacts: Scalars["Boolean"]["output"];
    canViewPartnerPaymentDetails: Scalars["Boolean"]["output"];
    canViewSalesReport: Scalars["Boolean"]["output"];
    canViewUsageReports: Scalars["Boolean"]["output"];
    isPartnerAdmin: Scalars["Boolean"]["output"];
    isSiteAdmin: Scalars["Boolean"]["output"];
    partnerId: Scalars["ID"]["output"];
};

export enum MarketplaceConsolePaymentModel {
    Free = "FREE",
    PaidViaAtlassian = "PAID_VIA_ATLASSIAN",
    PaidViaVendor = "PAID_VIA_VENDOR"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsolePluginFrameworkAttributes = {
    __typename?: "MarketplaceConsolePluginFrameworkAttributes";
    artifact?: Maybe<MarketplaceConsoleSoftwareArtifact>;
    artifactId: Scalars["ID"]["output"];
    descriptorId?: Maybe<Scalars["String"]["output"]>;
    pluginFrameworkType: MarketplaceConsolePluginFrameworkType;
};

export type MarketplaceConsolePluginFrameworkAttributesInput = {
    href: Scalars["String"]["input"];
};

export enum MarketplaceConsolePluginFrameworkType {
    P1 = "P1",
    P2 = "P2"
}

export enum MarketplaceConsolePricingCurrency {
    Jpy = "JPY",
    Usd = "USD"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsolePricingItem = {
    __typename?: "MarketplaceConsolePricingItem";
    amount: Scalars["Float"]["output"];
    ceiling: Scalars["Float"]["output"];
    floor: Scalars["Float"]["output"];
};

export type MarketplaceConsolePricingItemInput = {
    amount: Scalars["Float"]["input"];
    ceiling: Scalars["Float"]["input"];
    floor: Scalars["Float"]["input"];
};

export type MarketplaceConsolePricingParentSoftware = {
    __typename?: "MarketplaceConsolePricingParentSoftware";
    parentSoftwareId: Scalars["ID"]["output"];
    parentSoftwareName?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsolePricingPlan = {
    __typename?: "MarketplaceConsolePricingPlan";
    currency: MarketplaceConsolePricingCurrency;
    expertDiscountOptOut: Scalars["Boolean"]["output"];
    isDefaultPricing?: Maybe<Scalars["Boolean"]["output"]>;
    status: MarketplaceConsolePricingPlanStatus;
    tieredPricing: Array<MarketplaceConsolePricingItem>;
};

export type MarketplaceConsolePricingPlanInput = {
    currency: MarketplaceConsolePricingCurrency;
    expertDiscountOptOut: Scalars["Boolean"]["input"];
    isDefaultPricing?: InputMaybe<Scalars["Boolean"]["input"]>;
    status: MarketplaceConsolePricingPlanStatus;
    tieredPricing: Array<MarketplaceConsolePricingItemInput>;
};

export enum MarketplaceConsolePricingPlanStatus {
    Draft = "DRAFT",
    Live = "LIVE",
    Pending = "PENDING"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsolePrivateListings = {
    __typename?: "MarketplaceConsolePrivateListings";
    appSoftwareId: Scalars["ID"]["output"];
    edges: Array<MarketplaceConsolePrivateListingsTokenDetails>;
    pageInfo: MarketplaceConsoleAppPrivateListingsPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsolePrivateListingsLink = {
    __typename?: "MarketplaceConsolePrivateListingsLink";
    buildNumber: Scalars["String"]["output"];
    versionNumber: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsolePrivateListingsTokenDetails = {
    __typename?: "MarketplaceConsolePrivateListingsTokenDetails";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: MarketplaceConsoleTokenDetails;
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleProduct = {
    __typename?: "MarketplaceConsoleProduct";
    appKey: Scalars["ID"]["output"];
    isEditionDetailsMissing?: Maybe<Scalars["Boolean"]["output"]>;
    isPricingPlanMissing?: Maybe<Scalars["Boolean"]["output"]>;
    productId: Scalars["ID"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleProductListing = {
    __typename?: "MarketplaceConsoleProductListing";
    banner?: Maybe<MarketplaceConsoleImageMediaAsset>;
    communityEnabled: Scalars["String"]["output"];
    dataCenterReviewIssueKey?: Maybe<Scalars["String"]["output"]>;
    developerId: Scalars["ID"]["output"];
    googleAnalytics4Id?: Maybe<Scalars["String"]["output"]>;
    googleAnalyticsId?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<MarketplaceConsoleImageMediaAsset>;
    jsdEmbeddedDataKey?: Maybe<Scalars["String"]["output"]>;
    legacyCategories?: Maybe<Array<MarketplaceConsoleLegacyCategory>>;
    legacyListingDetails?: Maybe<MarketplaceConsoleLegacyListingDetails>;
    legacyMongoAppDetails?: Maybe<MarketplaceConsoleLegacyMongoAppDetails>;
    logicalCategories?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    marketingLabels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    marketplaceAppName: Scalars["String"]["output"];
    productId: Scalars["ID"]["output"];
    segmentWriteKey?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    tagLine?: Maybe<Scalars["String"]["output"]>;
    tags?: Maybe<MarketplaceConsoleProductListingTags>;
    titleLogo?: Maybe<MarketplaceConsoleImageMediaAsset>;
    vendorId: Scalars["String"]["output"];
    vendorLinks?: Maybe<MarketplaceConsoleVendorLinks>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleProductListingAdditionalChecks = {
    __typename?: "MarketplaceConsoleProductListingAdditionalChecks";
    canProductBeDelisted?: Maybe<Scalars["Boolean"]["output"]>;
    isProductJiraCompatible?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MarketplaceConsoleProductListingAdditionalChecksInput = {
    cloudAppSoftwareId?: InputMaybe<Scalars["ID"]["input"]>;
    dataCenterAppSoftwareId?: InputMaybe<Scalars["ID"]["input"]>;
    productId: Scalars["ID"]["input"];
    serverAppSoftwareId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleProductListingTags = {
    __typename?: "MarketplaceConsoleProductListingTags";
    category?: Maybe<Array<Maybe<MarketplaceConsoleTagsContent>>>;
    keywords?: Maybe<Array<Maybe<MarketplaceConsoleTagsContent>>>;
    marketing?: Maybe<Array<Maybe<MarketplaceConsoleTagsContent>>>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleProductMetadata = {
    __typename?: "MarketplaceConsoleProductMetadata";
    developerId: Scalars["ID"]["output"];
    marketplaceAppId: Scalars["ID"]["output"];
    marketplaceAppKey: Scalars["String"]["output"];
    productId: Scalars["ID"]["output"];
    vendorId: Scalars["ID"]["output"];
};

export type MarketplaceConsoleProductTag = {
    __typename?: "MarketplaceConsoleProductTag";
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleProductTags = {
    __typename?: "MarketplaceConsoleProductTags";
    category: Array<MarketplaceConsoleProductTag>;
    keywords: Array<MarketplaceConsoleProductTag>;
    marketing: Array<MarketplaceConsoleProductTag>;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApi = {
    __typename?: "MarketplaceConsoleQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsolePrivateListings")' query directive to the 'appPrivateListings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appPrivateListings?: Maybe<MarketplaceConsolePrivateListings>;
    /**
     *   Get app software version information for the marketplace console
     *
     * # Arguments
     *   - appId: The legacy ID of the app
     *   - buildNumber: The build number of the app version
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwareVersion")' query directive to the 'appSoftwareVersionByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use the `appSoftwareVersionsByAppId` field instead
     */
    appSoftwareVersionByAppId?: Maybe<MarketplaceConsoleAppSoftwareVersion>;
    /**
     *   Get app software version listing information for the marketplace console
     *
     * # Arguments
     *   - appId: The legacy ID of the app
     *   - buildNumber: The build number of the app version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwareVersionListing")' query directive to the 'appSoftwareVersionListing' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appSoftwareVersionListing?: Maybe<MarketplaceConsoleAppSoftwareVersionListing>;
    /**
     *   Get all app software versions for the marketplace console.
     *   The response array will contain 1 entry when the build number corresponds to software version with frameworks other than external.
     *   For build number associated with version of external(instructional) framework, the response array will can contain upto 3 entries, one software version for each hosting
     *
     * # Arguments
     *   - appId: The legacy ID of the app
     *   - buildNumber: The build number of the app version
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwareVersion")' query directive to the 'appSoftwareVersionsByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appSoftwareVersionsByAppId?: Maybe<
        Array<MarketplaceConsoleAppSoftwareVersion>
    >;
    /**
     *   Get app software versions list for display in marketplace console
     *
     * # Arguments
     *   - versionsListInput:
     *     - appSoftwares: app-sw-id
     *     - legacyVersionApprovalState: legacy approval state values to filter versions on
     *     - legacyVersionState: legacy state values to filter versions on
     *     - cursor: cursor to fetch next page
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwareVersionsList")' query directive to the 'appSoftwareVersionsList' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appSoftwareVersionsList: MarketplaceConsoleAppVersionsList;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleAppSoftwares")' query directive to the 'appSoftwaresByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appSoftwaresByAppId?: Maybe<MarketplaceConsoleAppSoftwares>;
    /**
     *   Get checks required to make server version public for the marketplace console
     *
     * # Arguments
     *   - appSoftwares: app-sw-id + hosting
     *   - versionNumber: The version number of the app version
     *   - userKey: The user LD key of the user making the request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleServerVersionPublicChecks")' query directive to the 'canMakeServerVersionPublic' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    canMakeServerVersionPublic?: Maybe<MarketplaceConsoleServerVersionPublicChecks>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsolePartnerContact")' query directive to the 'currentPartnerContact' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    currentPartnerContact?: Maybe<MarketplaceConsolePartnerContact>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsolePartnerContact")' query directive to the 'currentPartnerContactByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    currentPartnerContactByAppId?: Maybe<MarketplaceConsolePartnerContact>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleUserPreferences")' query directive to the 'currentUserPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    currentUserPreferences?: Maybe<MarketplaceConsoleUserPreferences>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    currentUserProfile?: Maybe<MarketplaceConsoleUser>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleDeveloperSpace")' query directive to the 'developerSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    developerSpace?: Maybe<MarketplaceConsoleDevSpace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleDeveloperSpace")' query directive to the 'developerSpaceByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    developerSpaceByAppId?: Maybe<MarketplaceConsoleDevSpace>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleEdition")' query directive to the 'editions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editions?: Maybe<Array<Maybe<MarketplaceConsoleEdition>>>;
    /**
     * Gets Activation Status of a product's edition(s).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleEditionsActivation")' query directive to the 'editionsActivationStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editionsActivationStatus?: Maybe<MarketplaceConsoleEditionsActivationResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleMakeAppVersionPublicChecks")' query directive to the 'makeAppVersionPublicChecks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    makeAppVersionPublicChecks?: Maybe<MarketplaceConsoleMakeAppVersionPublicChecks>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleParentSoftwarePricing")' query directive to the 'parentProductPricing' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentProductPricing?: Maybe<MarketplaceConsoleParentSoftwarePricing>;
    /**
     * Get parent products for the marketplace console
     * The list provided is not paginated and contains all the parent product and their versions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleParentSoftware")' query directive to the 'parentSoftwares' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    parentSoftwares: Array<MarketplaceConsoleParentSoftware>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleProduct")' query directive to the 'product' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    product?: Maybe<MarketplaceConsoleProduct>;
    /**
     * Fetches the additional checks around product listing.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleProductListingAdditionalChecks")' query directive to the 'productListingAdditionalChecks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    productListingAdditionalChecks?: Maybe<MarketplaceConsoleProductListingAdditionalChecks>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleProductListing")' query directive to the 'productListingByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    productListingByAppId?: Maybe<MarketplaceConsoleProductListing>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleProductMetadata")' query directive to the 'productMetadataByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    productMetadataByAppId?: Maybe<MarketplaceConsoleProductMetadata>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceConsoleProductTags")' query directive to the 'productTags' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    productTags?: Maybe<MarketplaceConsoleProductTags>;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiAppPrivateListingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    appSoftwareId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiAppSoftwareVersionByAppIdArgs = {
    appId: Scalars["ID"]["input"];
    buildNumber: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiAppSoftwareVersionListingArgs = {
    appId: Scalars["ID"]["input"];
    buildNumber: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiAppSoftwareVersionsByAppIdArgs = {
    appId: Scalars["ID"]["input"];
    buildNumber: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiAppSoftwareVersionsListArgs = {
    versionsListInput: MarketplaceConsoleGetVersionsListInput;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiAppSoftwaresByAppIdArgs = {
    appId: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiCanMakeServerVersionPublicArgs = {
    canMakeServerVersionPublicInput: MarketplaceConsoleCanMakeServerVersionPublicInput;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiCurrentPartnerContactArgs = {
    partnerId: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiCurrentPartnerContactByAppIdArgs = {
    appId: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiDeveloperSpaceArgs = {
    vendorId: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiDeveloperSpaceByAppIdArgs = {
    appId: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiEditionsArgs = {
    product: MarketplaceConsoleEditionsInput;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiEditionsActivationStatusArgs = {
    product: MarketplaceConsoleEditionsInput;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiMakeAppVersionPublicChecksArgs = {
    appId: Scalars["ID"]["input"];
    buildNumber: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiParentProductPricingArgs = {
    product: MarketplaceConsoleParentSoftwarePricingQueryInput;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiProductArgs = {
    appKey: Scalars["ID"]["input"];
    productId: Scalars["ID"]["input"];
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiProductListingAdditionalChecksArgs = {
    productListingAdditionalChecksInput: MarketplaceConsoleProductListingAdditionalChecksInput;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiProductListingByAppIdArgs = {
    appId: Scalars["ID"]["input"];
    productId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Namespace for Console related fields */
export type MarketplaceConsoleQueryApiProductMetadataByAppIdArgs = {
    appId: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleRemoteArtifactDetails = {
    __typename?: "MarketplaceConsoleRemoteArtifactDetails";
    dataCenterStatus?: Maybe<Scalars["String"]["output"]>;
    licensingEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    version?: Maybe<Scalars["String"]["output"]>;
};

/** Represents links pertaining to a remotely fetched artifact */
export type MarketplaceConsoleRemoteArtifactLinks = {
    __typename?: "MarketplaceConsoleRemoteArtifactLinks";
    binary?: Maybe<MarketplaceConsoleLink>;
    remote?: Maybe<MarketplaceConsoleLink>;
    self: MarketplaceConsoleLink;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleServerVersionPublicChecks = {
    __typename?: "MarketplaceConsoleServerVersionPublicChecks";
    isCompatibleWithFeCruOnly: Scalars["Boolean"]["output"];
    publicServerVersionExists: Scalars["Boolean"]["output"];
    serverVersionHasDCCounterpart: Scalars["Boolean"]["output"];
    shouldStopNewPublicServerVersions: Scalars["Boolean"]["output"];
};

/** Represents an artifact which was fetched from a remote URL */
export type MarketplaceConsoleSoftwareArtifact = {
    __typename?: "MarketplaceConsoleSoftwareArtifact";
    details?: Maybe<MarketplaceConsoleRemoteArtifactDetails>;
    fileInfo: MarketplaceConsoleArtifactFileInfo;
    links: MarketplaceConsoleRemoteArtifactLinks;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleSourceCodeLicense = {
    __typename?: "MarketplaceConsoleSourceCodeLicense";
    url: Scalars["String"]["output"];
};

export type MarketplaceConsoleTagsContent = {
    __typename?: "MarketplaceConsoleTagsContent";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleTokenDetails = {
    __typename?: "MarketplaceConsoleTokenDetails";
    cloudId?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<Array<Maybe<MarketplaceConsolePrivateListingsLink>>>;
    token: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleUpdateAppDetailsRequest = {
    appKey: Scalars["ID"]["input"];
    appStatusPageUrl?: InputMaybe<Scalars["String"]["input"]>;
    bannerForUPMUrl?: InputMaybe<Scalars["String"]["input"]>;
    buildsUrl?: InputMaybe<Scalars["String"]["input"]>;
    categories?: InputMaybe<Array<Scalars["String"]["input"]>>;
    cloudHostingVisibility?: InputMaybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
    communityEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    currentCategories?: InputMaybe<Array<Scalars["String"]["input"]>>;
    dataCenterHostingVisibility?: InputMaybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
    dataCenterReviewIssueKey?: InputMaybe<Scalars["String"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    forumsUrl?: InputMaybe<Scalars["String"]["input"]>;
    googleAnalytics4Id?: InputMaybe<Scalars["String"]["input"]>;
    googleAnalyticsId?: InputMaybe<Scalars["String"]["input"]>;
    issueTrackerUrl?: InputMaybe<Scalars["String"]["input"]>;
    jsdEmbeddedDataKey?: InputMaybe<Scalars["String"]["input"]>;
    keywords?: InputMaybe<Array<Scalars["String"]["input"]>>;
    logoUrl?: InputMaybe<Scalars["String"]["input"]>;
    marketingLabels?: InputMaybe<Array<Scalars["String"]["input"]>>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    privacyUrl?: InputMaybe<Scalars["String"]["input"]>;
    productId: Scalars["ID"]["input"];
    segmentWriteKey?: InputMaybe<Scalars["String"]["input"]>;
    serverHostingVisibility?: InputMaybe<MarketplaceConsoleLegacyMongoPluginHiddenIn>;
    sourceUrl?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<MarketplaceConsoleLegacyMongoStatus>;
    statusAfterApproval?: InputMaybe<MarketplaceConsoleLegacyMongoStatus>;
    storesPersonalData?: InputMaybe<Scalars["Boolean"]["input"]>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
    supportTicketSystemUrl?: InputMaybe<Scalars["String"]["input"]>;
    tagLine?: InputMaybe<Scalars["String"]["input"]>;
    wikiUrl?: InputMaybe<Scalars["String"]["input"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleUpdateAppDetailsRequestError =
    MarketplaceConsoleError & {
        __typename?: "MarketplaceConsoleUpdateAppDetailsRequestError";
        id: Scalars["ID"]["output"];
        message: Scalars["String"]["output"];
        path?: Maybe<Scalars["String"]["output"]>;
        subCode?: Maybe<Scalars["String"]["output"]>;
    };

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleUpdateAppDetailsRequestKnownError = {
    __typename?: "MarketplaceConsoleUpdateAppDetailsRequestKnownError";
    errors?: Maybe<
        Array<Maybe<MarketplaceConsoleUpdateAppDetailsRequestError>>
    >;
};

export type MarketplaceConsoleUpdateAppDetailsResponse =
    | MarketplaceConsoleMutationVoidResponse
    | MarketplaceConsoleUpdateAppDetailsRequestKnownError;

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleUser = {
    __typename?: "MarketplaceConsoleUser";
    atlassianAccountId: Scalars["ID"]["output"];
    email?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
    picture: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceConsoleUserPreferences = {
    __typename?: "MarketplaceConsoleUserPreferences";
    atlassianAccountId: Scalars["ID"]["output"];
    isNewReportsView: Scalars["Boolean"]["output"];
    isPatternedChart?: Maybe<Scalars["Boolean"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleVendorLinks = {
    __typename?: "MarketplaceConsoleVendorLinks";
    appStatusPage?: Maybe<Scalars["String"]["output"]>;
    forums?: Maybe<Scalars["String"]["output"]>;
    issueTracker?: Maybe<Scalars["String"]["output"]>;
    privacy?: Maybe<Scalars["String"]["output"]>;
    supportTicketSystem?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceConsoleWorkflowFrameworkAttributes = {
    __typename?: "MarketplaceConsoleWorkflowFrameworkAttributes";
    artifact?: Maybe<MarketplaceConsoleSoftwareArtifact>;
    artifactId: Scalars["ID"]["output"];
};

export type MarketplaceConsoleWorkflowFrameworkAttributesInput = {
    href: Scalars["String"]["input"];
};

/** Status of an entity in Marketplace system */
export enum MarketplaceEntityStatus {
    Active = "ACTIVE",
    Archived = "ARCHIVED"
}

/** An image file in Atlassian Marketplace system */
export type MarketplaceImageFile = {
    __typename?: "MarketplaceImageFile";
    /** Height of the image */
    height: Scalars["Int"]["output"];
    /** Unique id of the file in Atlassian Marketplace system */
    id: Scalars["String"]["output"];
    /** Link for the Image */
    imageUrl?: Maybe<Scalars["String"]["output"]>;
    /** Width of the image */
    width: Scalars["Int"]["output"];
};

/** Instructional app deployment properties */
export type MarketplaceInstructionalAppDeployment = MarketplaceAppDeployment & {
    __typename?: "MarketplaceInstructionalAppDeployment";
    /**
     * All Atlassian Products this app version is compatible with
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
    /**
     * Steps for installing the instructional app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    instructions?: Maybe<Array<MarketplaceAppDeploymentStep>>;
    /**
     * Tells whether this instructional app has a url for its binary
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isBinaryUrlAvailable: Scalars["Boolean"]["output"];
};

export type MarketplaceListingHighlight = {
    __typename?: "MarketplaceListingHighlight";
    /** Screenshot's explaination */
    caption?: Maybe<Scalars["String"]["output"]>;
    /** Highlight's cropped screenshot */
    croppedScreenshot: MarketplaceListingImage;
    /** Highlight's screenshot */
    screenshot: MarketplaceListingScreenshot;
    /** Key feature summary. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** A short action-oriented highlight title. */
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Image to be displayed on a listing in Marketplace */
export type MarketplaceListingImage = {
    __typename?: "MarketplaceListingImage";
    /** High resolution image file */
    highResolution?: Maybe<MarketplaceImageFile>;
    /** Original image file uploaded */
    original: MarketplaceImageFile;
    /** Image scaled to get required size */
    scaled: MarketplaceImageFile;
};

export type MarketplaceListingScreenshot = {
    __typename?: "MarketplaceListingScreenshot";
    /** Screenshot's explaination */
    caption?: Maybe<Scalars["String"]["output"]>;
    /** Screenshot's image file */
    image: MarketplaceListingImage;
};

/** Status of app’s listing in Marketplace. */
export enum MarketplaceListingStatus {
    Private = "PRIVATE",
    Public = "PUBLIC",
    ReadyToLaunch = "READY_TO_LAUNCH",
    Rejected = "REJECTED",
    Submitted = "SUBMITTED"
}

/** Marketplace location */
export enum MarketplaceLocation {
    InProduct = "IN_PRODUCT",
    Website = "WEBSITE"
}

/** Marketplace Partners provide apps and integrations available for purchase on the Atlassian Marketplace that extend the power of Atlassian products. */
export type MarketplacePartner = {
    __typename?: "MarketplacePartner";
    /** Marketplace Partner’s address */
    address?: Maybe<MarketplacePartnerAddress>;
    /** Marketplace Partner's contact details */
    contactDetails?: Maybe<MarketplacePartnerContactDetails>;
    /** Unique id of a Marketplace Partner. */
    id: Scalars["ID"]["output"];
    /** Tells whether the current user is a contact for the partner. */
    isUserContact?: Maybe<Scalars["Boolean"]["output"]>;
    /** Partner's logo */
    logo?: Maybe<MarketplaceListingImage>;
    /** Name of Marketplace Partner */
    name: Scalars["String"]["output"];
    /** Marketplace Partner's tier */
    partnerTier?: Maybe<MarketplacePartnerTier>;
    /** Tells if the Marketplace partner is an Atlassian’s internal one. */
    partnerType?: Maybe<MarketplacePartnerType>;
    /** Marketplace Programs that this Marketplace Partner has participated in. */
    programs?: Maybe<MarketplacePartnerPrograms>;
    /** An SEO-friendly URL pathname for this Marketplace Partner */
    slug: Scalars["String"]["output"];
    /** Marketplace Partner support information */
    support?: Maybe<MarketplacePartnerSupport>;
};

/** Marketplace Partner's address */
export type MarketplacePartnerAddress = {
    __typename?: "MarketplacePartnerAddress";
    /** City of Marketplace Partner’s address */
    city?: Maybe<Scalars["String"]["output"]>;
    /** Country of Marketplace Partner’s address */
    country?: Maybe<Scalars["String"]["output"]>;
    /** Line 1 of Marketplace Partner’s address */
    line1?: Maybe<Scalars["String"]["output"]>;
    /** Line 2 of Marketplace Partner’s address */
    line2?: Maybe<Scalars["String"]["output"]>;
    /** Postal code of Marketplace Partner’s address */
    postalCode?: Maybe<Scalars["String"]["output"]>;
    /** State of Marketplace Partner’s address */
    state?: Maybe<Scalars["String"]["output"]>;
};

/** Marketplace Partner's contact information */
export type MarketplacePartnerContactDetails = {
    __typename?: "MarketplacePartnerContactDetails";
    /** Marketplace Partner’s contact email id */
    emailId?: Maybe<Scalars["String"]["output"]>;
    /** Marketplace Partner’s homepage URL */
    homepageUrl?: Maybe<Scalars["String"]["output"]>;
    /** Marketplace Partner's other contact details */
    otherContactDetails?: Maybe<Scalars["String"]["output"]>;
    /** Marketplace Partner’s contact phone number */
    phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

/** Marketplace Programs that this Marketplace Partner has participated in. */
export type MarketplacePartnerPrograms = {
    __typename?: "MarketplacePartnerPrograms";
    isCloudAppSecuritySelfAssessmentDone?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Marketplace Partner's support information. */
export type MarketplacePartnerSupport = {
    __typename?: "MarketplacePartnerSupport";
    /** Marketplace Partner’s support availability details */
    availability?: Maybe<MarketplacePartnerSupportAvailability>;
    /** Marketplace Partner’s support contact details */
    contactDetails?: Maybe<MarketplacePartnerSupportContact>;
};

/** Marketplace Partner's support availability information */
export type MarketplacePartnerSupportAvailability = {
    __typename?: "MarketplacePartnerSupportAvailability";
    /** Days of week when Marketplace Partner support is available, as per ISO 8601 format for weekday, i.e. `1-7` for Monday - Sunday */
    daysOfWeek: Array<Scalars["Int"]["output"]>;
    /** Support availability end time, in ISO time format `hh:mm` e.g, 23:25 */
    endTime?: Maybe<Scalars["String"]["output"]>;
    /** Dates on which MarketplacePartner’s support is not available due to holiday */
    holidays: Array<MarketplacePartnerSupportHoliday>;
    /** Tells if the support is available for all 24 hours */
    isAvailable24Hours: Scalars["Boolean"]["output"];
    /** Support availability start time, in ISO time format `hh:mm` e.g, 23:25 */
    startTime?: Maybe<Scalars["String"]["output"]>;
    /** Support availability timezone for startTime and endTime values. e.g, `America/Los_Angeles` */
    timezone: Scalars["String"]["output"];
    /** Support availability timezone in ISO 8601 format e.g. `+00:00`, `+05:30`, etc */
    timezoneOffset: Scalars["String"]["output"];
};

/** Marketplace Partner's support contact information */
export type MarketplacePartnerSupportContact = {
    __typename?: "MarketplacePartnerSupportContact";
    /** Marketplace Partner’s support contact email id */
    emailId?: Maybe<Scalars["String"]["output"]>;
    /** Marketplace Partner’s support contact phone number */
    phoneNumber?: Maybe<Scalars["String"]["output"]>;
    /** Marketplace Partner’s support website URL */
    websiteUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** Marketplace Partner's support holiday */
export type MarketplacePartnerSupportHoliday = {
    __typename?: "MarketplacePartnerSupportHoliday";
    /** Support holiday date, follows ISO date format `YYYY-MM-DD` e.g, 2020-08-12 */
    date: Scalars["String"]["output"];
    /** Tells whether it occurs one time or is annual. */
    holidayFrequency: MarketplacePartnerSupportHolidayFrequency;
    /** Holiday’s title */
    title: Scalars["String"]["output"];
};

/** Tells whether support is on holiday only one time or if it repeats annually. */
export enum MarketplacePartnerSupportHolidayFrequency {
    Annual = "ANNUAL",
    OneTime = "ONE_TIME"
}

/** Marketplace Partner's tier */
export type MarketplacePartnerTier = {
    __typename?: "MarketplacePartnerTier";
    /** Partner tier type */
    type: MarketplacePartnerTierType;
    /** Partner tier updated date */
    updatedDate?: Maybe<Scalars["String"]["output"]>;
};

export enum MarketplacePartnerTierType {
    Gold = "GOLD",
    Platinum = "PLATINUM",
    Silver = "SILVER"
}

/** Tells if the Marketplace partner is an Atlassian’s internal one. */
export enum MarketplacePartnerType {
    AtlassianInternal = "ATLASSIAN_INTERNAL"
}

/** Plugins1 app deployment properties */
export type MarketplacePlugins1AppDeployment = MarketplaceAppDeployment & {
    __typename?: "MarketplacePlugins1AppDeployment";
    /**
     * All Atlassian Products this app version is compatible with
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
    /**
     * Tells whether there is a deployment artifact
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDeploymentArtifactAvailable: Scalars["Boolean"]["output"];
};

/** Plugins2 app deployment properties */
export type MarketplacePlugins2AppDeployment = MarketplaceAppDeployment & {
    __typename?: "MarketplacePlugins2AppDeployment";
    /**
     * All Atlassian Products this app version is compatible with
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
    /**
     * Tells whether there is a deployment artifact
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isDeploymentArtifactAvailable: Scalars["Boolean"]["output"];
};

/** Pricing items based on tiers */
export type MarketplacePricingItem = {
    __typename?: "MarketplacePricingItem";
    /** The amount that a customer pays for a license at this tier */
    amount: Scalars["Float"]["output"];
    /** The upper limit for unit count (number of users of Jira, remote agents in Bamboo) defining this pricing tier. Null in case of highest tier */
    ceiling?: Maybe<Scalars["Int"]["output"]>;
    /** The lower limit for unit count (number of users of Jira, remote agents in Bamboo) defining this pricing tier */
    floor: Scalars["Int"]["output"];
    /** Policy of the tier : BLOCK (FLAT) or PER_UNIT (PUP) */
    policy: MarketplacePricingTierPolicy;
};

/** Pricing plan for a marketplace entity */
export type MarketplacePricingPlan = {
    __typename?: "MarketplacePricingPlan";
    /**
     * Billing cycle of the marketplace entity
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    billingCycle: MarketplaceBillingCycle;
    /**
     * Currency code for all items in the pricing plan. Defaults to USD
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    currency: Scalars["String"]["output"];
    /**
     * Status of the plan : LIVE, PENDING or DRAFT
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: MarketplacePricingPlanStatus;
    /**
     * Tiered Pricing for the plan
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tieredPricing: MarketplaceTieredPricing;
};

/** Option parameters to fetch pricing plan for a marketplace entity */
export type MarketplacePricingPlanOptions = {
    /** Period for which Pricing Plan is to be fetched. Defaults to MONTHLY */
    billingCycle?: InputMaybe<MarketplaceBillingCycle>;
    /** Country code (ISO 3166-1 alpha-2) of the client. Either of currencyCode and countryCode is needed. If both are not present, fallback to default currency - USD */
    countryCode?: InputMaybe<Scalars["String"]["input"]>;
    /** Currency code (ISO 4217) to return the amount in pricing items. Either of currencyCode and countryCode is needed. If currency code is not present, fallback to country code to fetch currency */
    currencyCode?: InputMaybe<Scalars["String"]["input"]>;
    /** Fetch pricing plan with status: LIVE, PENDING, DRAFT. Unless, pricing plan will be fetched based on user access */
    planStatus?: InputMaybe<MarketplacePricingPlanStatus>;
};

/** Status of the plan : LIVE, PENDING or DRAFT */
export enum MarketplacePricingPlanStatus {
    Draft = "DRAFT",
    Live = "LIVE",
    Pending = "PENDING"
}

/** Mode of the tier : GRADUATED (progressive PUP), VOLUME (constant for all users) */
export enum MarketplacePricingTierMode {
    Graduated = "GRADUATED",
    Volume = "VOLUME"
}

/** Policy of the tier : BLOCK (FLAT) or PER_UNIT (PUP) */
export enum MarketplacePricingTierPolicy {
    Block = "BLOCK",
    PerUnit = "PER_UNIT"
}

/** Type of the tier */
export enum MarketplacePricingTierType {
    RemoteAgentTiered = "REMOTE_AGENT_TIERED",
    UserTiered = "USER_TIERED"
}

export enum MarketplaceProgramStatus {
    Applied = "APPLIED",
    Approved = "APPROVED",
    NotAParticipant = "NOT_A_PARTICIPANT",
    Rejected = "REJECTED"
}

export type MarketplaceStoreAlgoliaFilter = {
    __typename?: "MarketplaceStoreAlgoliaFilter";
    key: Scalars["String"]["output"];
    value: Array<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreAlgoliaQueryFilter = {
    __typename?: "MarketplaceStoreAlgoliaQueryFilter";
    marketingLabels: Array<Scalars["String"]["output"]>;
};

/**
 * Metadata for algolia which can be used by the UI to fetch
 * app tiles data corresponding to a collection, category etc.
 *
 * Will be deprecated when search service starts providing app tiles data
 * in which case, BFF should integrate with search service to return the app tiles
 * data directly
 */
export type MarketplaceStoreAlgoliaQueryMetadata = {
    __typename?: "MarketplaceStoreAlgoliaQueryMetadata";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filter: MarketplaceStoreAlgoliaQueryFilter;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filters: Array<MarketplaceStoreAlgoliaFilter>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    searchIndex: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sort?: Maybe<MarketplaceStoreAlgoliaQuerySort>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreAlgoliaQuerySort = {
    __typename?: "MarketplaceStoreAlgoliaQuerySort";
    criteria?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreAnonymousUser = {
    __typename?: "MarketplaceStoreAnonymousUser";
    links: MarketplaceStoreAnonymousUserLinks;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreAnonymousUserLinks = {
    __typename?: "MarketplaceStoreAnonymousUserLinks";
    login: Scalars["String"]["output"];
};

export type MarketplaceStoreAppDetails =
    MarketplaceStoreMultiInstanceDetails & {
        __typename?: "MarketplaceStoreAppDetails";
        id: Scalars["ID"]["output"];
        isMultiInstance: Scalars["Boolean"]["output"];
        multiInstanceEntitlementEditionType: Scalars["String"]["output"];
        multiInstanceEntitlementId?: Maybe<Scalars["String"]["output"]>;
        status?: Maybe<Scalars["String"]["output"]>;
    };

/** Hosting type where Atlassian product instance is installed. */
export enum MarketplaceStoreAtlassianProductHostingType {
    Cloud = "CLOUD",
    Datacenter = "DATACENTER",
    Server = "SERVER"
}

export enum MarketplaceStoreBillingSystem {
    Ccp = "CCP",
    Hams = "HAMS"
}

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceStoreBillingSystemInput = {
    cloudId: Scalars["String"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreBillingSystemResponse = {
    __typename?: "MarketplaceStoreBillingSystemResponse";
    billingSystem: MarketplaceStoreBillingSystem;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCategoryHeroSection = {
    __typename?: "MarketplaceStoreCategoryHeroSection";
    backgroundColor: Scalars["String"]["output"];
    description: Scalars["String"]["output"];
    image: MarketplaceStoreCategoryHeroSectionImage;
    title: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCategoryHeroSectionImage = {
    __typename?: "MarketplaceStoreCategoryHeroSectionImage";
    altText: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceStoreCategoryResponse = {
    __typename?: "MarketplaceStoreCategoryResponse";
    algoliaQueryMetadata: MarketplaceStoreAlgoliaQueryMetadata;
    heroSection: MarketplaceStoreCategoryHeroSection;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    slug: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCmtAvailabilityResponse = {
    __typename?: "MarketplaceStoreCmtAvailabilityResponse";
    allowed: Scalars["Boolean"]["output"];
    btfAddOnAccountId?: Maybe<Scalars["String"]["output"]>;
    maintenanceEndDate?: Maybe<Scalars["String"]["output"]>;
    migrationSourceUuid?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCollectionHeroSection = {
    __typename?: "MarketplaceStoreCollectionHeroSection";
    backgroundColor: Scalars["String"]["output"];
    description: Scalars["String"]["output"];
    image: MarketplaceStoreCollectionHeroSectionImage;
    title: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCollectionHeroSectionImage = {
    __typename?: "MarketplaceStoreCollectionHeroSectionImage";
    altText: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceStoreCollectionResponse = {
    __typename?: "MarketplaceStoreCollectionResponse";
    algoliaQueryMetadata: MarketplaceStoreAlgoliaQueryMetadata;
    heroSection: MarketplaceStoreCollectionHeroSection;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    slug: Scalars["String"]["output"];
    useCases?: Maybe<MarketplaceStoreCollectionUsecases>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCollectionUsecases = {
    __typename?: "MarketplaceStoreCollectionUsecases";
    heading: Scalars["String"]["output"];
    values: Array<MarketplaceStoreCollectionUsecasesValues>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreCollectionUsecasesValues = {
    __typename?: "MarketplaceStoreCollectionUsecasesValues";
    description: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceStoreCurrentUserResponse =
    | MarketplaceStoreAnonymousUser
    | MarketplaceStoreLoggedInUser;

export type MarketplaceStoreCurrentUserReviewResponse = {
    __typename?: "MarketplaceStoreCurrentUserReviewResponse";
    author?: Maybe<MarketplaceStoreReviewAuthor>;
    date?: Maybe<Scalars["String"]["output"]>;
    helpfulVotes?: Maybe<Scalars["Int"]["output"]>;
    hosting?: Maybe<MarketplaceStoreAtlassianProductHostingType>;
    id: Scalars["ID"]["output"];
    response?: Maybe<Scalars["String"]["output"]>;
    review?: Maybe<Scalars["String"]["output"]>;
    stars?: Maybe<Scalars["Int"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
    totalVotes?: Maybe<Scalars["Int"]["output"]>;
    userHasComplianceConsent?: Maybe<Scalars["Boolean"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreDeveloperSpace = {
    __typename?: "MarketplaceStoreDeveloperSpace";
    name: Scalars["String"]["output"];
    status: MarketplaceStoreDeveloperSpaceStatus;
};

export enum MarketplaceStoreDeveloperSpaceStatus {
    Active = "ACTIVE",
    Archived = "ARCHIVED",
    Inactive = "INACTIVE"
}

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceStoreEdition = {
    __typename?: "MarketplaceStoreEdition";
    features: Array<MarketplaceStoreEditionFeature>;
    id: Scalars["ID"]["output"];
    isDefault: Scalars["Boolean"]["output"];
    pricingPlan: MarketplaceStorePricingPlan;
    type: MarketplaceStoreEditionType;
};

export type MarketplaceStoreEditionFeature = {
    __typename?: "MarketplaceStoreEditionFeature";
    description: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    position: Scalars["Int"]["output"];
};

export enum MarketplaceStoreEditionType {
    Advanced = "ADVANCED",
    Standard = "STANDARD"
}

export type MarketplaceStoreEditionsByAppKeyInput = {
    appKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type MarketplaceStoreEditionsInput = {
    appId?: InputMaybe<Scalars["String"]["input"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreEligibleAppOfferingsInput = {
    cloudId: Scalars["String"]["input"];
    product: MarketplaceStoreProduct;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreEligibleAppOfferingsResponse = {
    __typename?: "MarketplaceStoreEligibleAppOfferingsResponse";
    eligibleOfferings?: Maybe<Array<Maybe<MarketplaceStoreOfferingDetails>>>;
};

/** Products onto which an app can be installed */
export enum MarketplaceStoreEnterpriseProduct {
    Confluence = "CONFLUENCE",
    Jira = "JIRA"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreGeoIpResponse = {
    __typename?: "MarketplaceStoreGeoIPResponse";
    countryCode: Scalars["String"]["output"];
};

export type MarketplaceStoreHomePageFeaturedSection =
    MarketplaceStoreHomePageSection & {
        __typename?: "MarketplaceStoreHomePageFeaturedSection";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
    };

export type MarketplaceStoreHomePageHighlightedSection =
    MarketplaceStoreHomePageSection & {
        __typename?: "MarketplaceStoreHomePageHighlightedSection";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        algoliaQueryMetadata: MarketplaceStoreAlgoliaQueryMetadata;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        appsFetchCount: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        highlightVariation: MarketplaceStoreHomePageHighlightedSectionVariation;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        navigationUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        screenSpecificProperties: MarketplaceStoreHomePageSectionScreenSpecificProperties;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
    };

/** --------------------------------------------------------------------------------------------- */
export enum MarketplaceStoreHomePageHighlightedSectionVariation {
    Prominent = "PROMINENT"
}

export type MarketplaceStoreHomePageRegularSection =
    MarketplaceStoreHomePageSection & {
        __typename?: "MarketplaceStoreHomePageRegularSection";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        algoliaQueryMetadata: MarketplaceStoreAlgoliaQueryMetadata;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        appsFetchCount: Scalars["Int"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        navigationUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        screenSpecificProperties: MarketplaceStoreHomePageSectionScreenSpecificProperties;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ❌ No |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
    };

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreHomePageResponse = {
    __typename?: "MarketplaceStoreHomePageResponse";
    sections: Array<MarketplaceStoreHomePageSection>;
};

export type MarketplaceStoreHomePageSection = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreHomePageSectionScreenConfig = {
    __typename?: "MarketplaceStoreHomePageSectionScreenConfig";
    appsCount: Scalars["Int"]["output"];
    hideDescription?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * These breakpoints map to the breakpoints on the client
 * eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required
 */
export type MarketplaceStoreHomePageSectionScreenSpecificProperties = {
    __typename?: "MarketplaceStoreHomePageSectionScreenSpecificProperties";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lg: MarketplaceStoreHomePageSectionScreenConfig;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    md: MarketplaceStoreHomePageSectionScreenConfig;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sm: MarketplaceStoreHomePageSectionScreenConfig;
};

/** --------------------------------------------------------------------------------------------- */
export enum MarketplaceStoreHostInstanceType {
    Production = "PRODUCTION",
    Sandbox = "SANDBOX"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreHostLicense = {
    __typename?: "MarketplaceStoreHostLicense";
    autoRenewal: Scalars["Boolean"]["output"];
    evaluation: Scalars["Boolean"]["output"];
    licenseType: Scalars["String"]["output"];
    maximumNumberOfUsers: Scalars["Int"]["output"];
    subscriptionAnnual?: Maybe<Scalars["Boolean"]["output"]>;
    valid: Scalars["Boolean"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreHostStatusResponse = {
    __typename?: "MarketplaceStoreHostStatusResponse";
    billingCurrency: Scalars["String"]["output"];
    billingSystem: MarketplaceStoreBillingSystem;
    hostCmtEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    hostLicense: MarketplaceStoreHostLicense;
    instanceType: MarketplaceStoreHostInstanceType;
    pacUnavailable: Scalars["Boolean"]["output"];
    upmLicensedHostUsers: Scalars["Int"]["output"];
};

export type MarketplaceStoreInstallAppInput = {
    appKey: Scalars["String"]["input"];
    offeringId?: InputMaybe<Scalars["String"]["input"]>;
    target: MarketplaceStoreInstallAppTargetInput;
};

export type MarketplaceStoreInstallAppResponse = {
    __typename?: "MarketplaceStoreInstallAppResponse";
    id: Scalars["ID"]["output"];
    status: MarketplaceStoreInstallAppStatus;
};

/** Status of an app installation request */
export enum MarketplaceStoreInstallAppStatus {
    InProgress = "IN_PROGRESS",
    Pending = "PENDING",
    ProvisioningFailure = "PROVISIONING_FAILURE",
    ProvisioningSuccessInstallPending = "PROVISIONING_SUCCESS_INSTALL_PENDING",
    Success = "SUCCESS",
    TimedOut = "TIMED_OUT"
}

/** Input for specifying the target or "site" of an app installation. */
export type MarketplaceStoreInstallAppTargetInput = {
    cloudId: Scalars["ID"]["input"];
    product: MarketplaceStoreInstallationTargetProduct;
};

/** Products onto which an app can be installed */
export enum MarketplaceStoreInstallationTargetProduct {
    Compass = "COMPASS",
    Confluence = "CONFLUENCE",
    Jira = "JIRA"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreInstalledAppDetailsResponse = {
    __typename?: "MarketplaceStoreInstalledAppDetailsResponse";
    edition?: Maybe<Scalars["String"]["output"]>;
    installed: Scalars["Boolean"]["output"];
    licenseActive: Scalars["Boolean"]["output"];
    licenseExpiryDate?: Maybe<Scalars["String"]["output"]>;
    paidLicenseActiveOnParent: Scalars["Boolean"]["output"];
};

export type MarketplaceStoreLoggedInUser = {
    __typename?: "MarketplaceStoreLoggedInUser";
    email: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    /**
     * The active developer space associated with vendorId or developerId provided by user
     * or the first active developer space from the list of all developer spaces that user is member of
     */
    lastVisitedDeveloperSpace?: Maybe<MarketplaceStoreLoggedInUserDeveloperSpace>;
    links: MarketplaceStoreLoggedInUserLinks;
    name: Scalars["String"]["output"];
    picture: Scalars["String"]["output"];
};

export type MarketplaceStoreLoggedInUserLastVisitedDeveloperSpaceArgs = {
    developerId?: InputMaybe<Scalars["ID"]["input"]>;
    vendorId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MarketplaceStoreLoggedInUserDeveloperSpace = {
    __typename?: "MarketplaceStoreLoggedInUserDeveloperSpace";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    vendorId: Scalars["ID"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreLoggedInUserLinks = {
    __typename?: "MarketplaceStoreLoggedInUserLinks";
    addons: Scalars["String"]["output"];
    admin?: Maybe<Scalars["String"]["output"]>;
    createAddon: Scalars["String"]["output"];
    logout: Scalars["String"]["output"];
    manageAccount: Scalars["String"]["output"];
    /**
     * Link to manage the developer space given that logged in user
     * has necessary permissions for the provided vendorId/developerId
     */
    manageDeveloperSpace?: Maybe<Scalars["String"]["output"]>;
    profile: Scalars["String"]["output"];
    switchAccount: Scalars["String"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreLoggedInUserLinksManageDeveloperSpaceArgs = {
    developerId?: InputMaybe<Scalars["ID"]["input"]>;
    vendorId: Scalars["ID"]["input"];
};

export type MarketplaceStoreMultiInstanceDetails = {
    isMultiInstance: Scalars["Boolean"]["output"];
    multiInstanceEntitlementId?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceStoreMultiInstanceEntitlementForAppInput = {
    cloudId: Scalars["String"]["input"];
    product: MarketplaceStoreProduct;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreMultiInstanceEntitlementForAppResponse = {
    __typename?: "MarketplaceStoreMultiInstanceEntitlementForAppResponse";
    appDetails?: Maybe<MarketplaceStoreAppDetails>;
    cloudId: Scalars["String"]["output"];
};

export type MarketplaceStoreMultiInstanceEntitlementsForUserInput = {
    cloudIds: Array<Scalars["String"]["input"]>;
    product: MarketplaceStoreEnterpriseProduct;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreMultiInstanceEntitlementsForUserResponse = {
    __typename?: "MarketplaceStoreMultiInstanceEntitlementsForUserResponse";
    orgMultiInstanceEntitlements?: Maybe<
        Array<MarketplaceStoreOrgMultiInstanceEntitlement>
    >;
};

/**
 * This is a top level mutation type under which all of Marketplace Store's supported mutations
 * will reside. It is namespaced to avoid conflicts with other Atlassian mutations.
 */
export type MarketplaceStoreMutationApi = {
    __typename?: "MarketplaceStoreMutationApi";
    /**
     * Install an app
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreInstallAppM1")' query directive to the 'installApp' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    installApp: MarketplaceStoreInstallAppResponse;
};

/**
 * This is a top level mutation type under which all of Marketplace Store's supported mutations
 * will reside. It is namespaced to avoid conflicts with other Atlassian mutations.
 */
export type MarketplaceStoreMutationApiInstallAppArgs = {
    input: MarketplaceStoreInstallAppInput;
};

/** --------------------------------------------------------------------------------------------- */
export type MarketplaceStoreOfferingDetails = {
    __typename?: "MarketplaceStoreOfferingDetails";
    id: Scalars["ID"]["output"];
    isInstance?: Maybe<Scalars["Boolean"]["output"]>;
    isSandbox?: Maybe<Scalars["Boolean"]["output"]>;
    name: Scalars["String"]["output"];
};

export type MarketplaceStoreOrgDetails =
    MarketplaceStoreMultiInstanceDetails & {
        __typename?: "MarketplaceStoreOrgDetails";
        id: Scalars["ID"]["output"];
        isMultiInstance: Scalars["Boolean"]["output"];
        multiInstanceEntitlementId?: Maybe<Scalars["String"]["output"]>;
        status?: Maybe<Scalars["String"]["output"]>;
    };

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStoreOrgMultiInstanceEntitlement = {
    __typename?: "MarketplaceStoreOrgMultiInstanceEntitlement";
    cloudId: Scalars["String"]["output"];
    orgDetails?: Maybe<MarketplaceStoreOrgDetails>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerAddress = {
    __typename?: "MarketplaceStorePartnerAddress";
    city?: Maybe<Scalars["String"]["output"]>;
    country?: Maybe<Scalars["String"]["output"]>;
    line1?: Maybe<Scalars["String"]["output"]>;
    line2?: Maybe<Scalars["String"]["output"]>;
    postcode?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerContactDetails = {
    __typename?: "MarketplaceStorePartnerContactDetails";
    email: Scalars["String"]["output"];
    homepageUrl?: Maybe<Scalars["String"]["output"]>;
    otherContactDetails?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerEnrollment = {
    __typename?: "MarketplaceStorePartnerEnrollment";
    program?: Maybe<MarketplaceStorePartnerEnrollmentProgram>;
    value?: Maybe<MarketplaceStorePartnerEnrollmentProgramValue>;
};

/** --------------------------------------------------------------------------------------------- */
export enum MarketplaceStorePartnerEnrollmentProgram {
    MarketplacePartner = "MARKETPLACE_PARTNER",
    SolutionPartner = "SOLUTION_PARTNER"
}

export enum MarketplaceStorePartnerEnrollmentProgramValue {
    Gold = "GOLD",
    Platinum = "PLATINUM",
    Silver = "SILVER"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerListing = {
    __typename?: "MarketplaceStorePartnerListing";
    address?: Maybe<MarketplaceStorePartnerAddress>;
    contactDetails?: Maybe<MarketplaceStorePartnerContactDetails>;
    description?: Maybe<Scalars["String"]["output"]>;
    logoUrl?: Maybe<Scalars["String"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
    supportAvailability?: Maybe<MarketplaceStorePartnerSupportAvailability>;
    supportContact?: Maybe<MarketplaceStorePartnerSupportContact>;
    trustCenterUrl?: Maybe<Scalars["String"]["output"]>;
};

export type MarketplaceStorePartnerResponse = {
    __typename?: "MarketplaceStorePartnerResponse";
    developerSpace: MarketplaceStoreDeveloperSpace;
    enrollments: Array<Maybe<MarketplaceStorePartnerEnrollment>>;
    id: Scalars["ID"]["output"];
    listing?: Maybe<MarketplaceStorePartnerListing>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerSupportAvailability = {
    __typename?: "MarketplaceStorePartnerSupportAvailability";
    days: Array<MarketplaceStorePartnerSupportAvailabilityDay>;
    holidays: Array<Maybe<MarketplaceStorePartnerSupportHoliday>>;
    range?: Maybe<MarketplaceStorePartnerSupportAvailabilityRange>;
    timezone: Scalars["String"]["output"];
};

export enum MarketplaceStorePartnerSupportAvailabilityDay {
    Friday = "FRIDAY",
    Monday = "MONDAY",
    Saturday = "SATURDAY",
    Sunday = "SUNDAY",
    Thursday = "THURSDAY",
    Tuesday = "TUESDAY",
    Wednesday = "WEDNESDAY"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerSupportAvailabilityRange = {
    __typename?: "MarketplaceStorePartnerSupportAvailabilityRange";
    from?: Maybe<Scalars["String"]["output"]>;
    to?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerSupportContact = {
    __typename?: "MarketplaceStorePartnerSupportContact";
    email?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
    phone?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePartnerSupportHoliday = {
    __typename?: "MarketplaceStorePartnerSupportHoliday";
    date: Scalars["String"]["output"];
    repeatAnnually: Scalars["Boolean"]["output"];
    title: Scalars["String"]["output"];
};

export enum MarketplaceStorePricingCurrency {
    Jpy = "JPY",
    Usd = "USD"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePricingPlan = {
    __typename?: "MarketplaceStorePricingPlan";
    annualPricingPlan?: Maybe<MarketplaceStorePricingPlanItem>;
    currency: MarketplaceStorePricingCurrency;
    monthlyPricingPlan?: Maybe<MarketplaceStorePricingPlanItem>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePricingPlanItem = {
    __typename?: "MarketplaceStorePricingPlanItem";
    tieredPricing: Array<MarketplaceStorePricingTier>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePricingTier = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ceiling: Scalars["Float"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    floor: Scalars["Float"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePricingTierAnnual = MarketplaceStorePricingTier & {
    __typename?: "MarketplaceStorePricingTierAnnual";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ceiling: Scalars["Float"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    flatAmount?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    floor: Scalars["Float"]["output"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */
export type MarketplaceStorePricingTierMonthly = MarketplaceStorePricingTier & {
    __typename?: "MarketplaceStorePricingTierMonthly";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ceiling: Scalars["Float"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    flatAmount?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    floor: Scalars["Float"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unitAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type MarketplaceStoreProduct = {
    appKey?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApi = {
    __typename?: "MarketplaceStoreQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreAppReviewsById")' query directive to the 'appReviewsByAppId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appReviewsByAppId: MarketplaceStoreReviewsResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreAppReviewsByAppKey")' query directive to the 'appReviewsByAppKey' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    appReviewsByAppKey: MarketplaceStoreReviewsResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreBillingSystem")' query directive to the 'billingSystem' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    billingSystem: MarketplaceStoreBillingSystemResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreCategory")' query directive to the 'category' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    category: MarketplaceStoreCategoryResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreCmtAvailability")' query directive to the 'cmtAvailability' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    cmtAvailability: MarketplaceStoreCmtAvailabilityResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreCollection")' query directive to the 'collection' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    collection: MarketplaceStoreCollectionResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreCurrentUser")' query directive to the 'currentUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    currentUser: MarketplaceStoreCurrentUserResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreEditions")' query directive to the 'editions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editions: Array<MarketplaceStoreEdition>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreEditionsByAppKey")' query directive to the 'editionsByAppKey' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editionsByAppKey: Array<MarketplaceStoreEdition>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreEligibleOfferingsForApp")' query directive to the 'eligibleOfferingsForApp' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    eligibleOfferingsForApp: MarketplaceStoreEligibleAppOfferingsResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreGeoIP")' query directive to the 'geoip' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    geoip: MarketplaceStoreGeoIpResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreHomePage")' query directive to the 'homePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    homePage: MarketplaceStoreHomePageResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreHostStatus")' query directive to the 'hostStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    hostStatus: MarketplaceStoreHostStatusResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreInstallAppM1")' query directive to the 'installAppStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    installAppStatus: MarketplaceStoreInstallAppResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreInstalledAppDetails")' query directive to the 'installedAppDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    installedAppDetails: MarketplaceStoreInstalledAppDetailsResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreMultiInstanceEntitlementForApp")' query directive to the 'multiInstanceEntitlementForApp' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    multiInstanceEntitlementForApp: MarketplaceStoreMultiInstanceEntitlementForAppResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreMultiInstanceEntitlementsForUser")' query directive to the 'multiInstanceEntitlementsForUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    multiInstanceEntitlementsForUser: MarketplaceStoreMultiInstanceEntitlementsForUserResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStoreMyReview")' query directive to the 'myReview' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    myReview: MarketplaceStoreCurrentUserReviewResponse;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MarketplaceStorePartner")' query directive to the 'partner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    partner: MarketplaceStorePartnerResponse;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiAppReviewsByAppIdArgs = {
    appId: Scalars["ID"]["input"];
    filter?: InputMaybe<MarketplaceStoreReviewFilterInput>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiAppReviewsByAppKeyArgs = {
    appKey: Scalars["String"]["input"];
    filter?: InputMaybe<MarketplaceStoreReviewFilterInput>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiBillingSystemArgs = {
    billingSystemInput: MarketplaceStoreBillingSystemInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiCategoryArgs = {
    slug: Scalars["String"]["input"];
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiCmtAvailabilityArgs = {
    input: MarketplaceStoreInstallAppInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiCollectionArgs = {
    slug: Scalars["String"]["input"];
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiEditionsArgs = {
    product: MarketplaceStoreEditionsInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiEditionsByAppKeyArgs = {
    product: MarketplaceStoreEditionsByAppKeyInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiEligibleOfferingsForAppArgs = {
    input: MarketplaceStoreEligibleAppOfferingsInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiHomePageArgs = {
    productId?: InputMaybe<Scalars["String"]["input"]>;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiHostStatusArgs = {
    input: MarketplaceStoreInstallAppTargetInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiInstallAppStatusArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiInstalledAppDetailsArgs = {
    input: MarketplaceStoreInstallAppInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiMultiInstanceEntitlementForAppArgs = {
    input: MarketplaceStoreMultiInstanceEntitlementForAppInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiMultiInstanceEntitlementsForUserArgs = {
    input: MarketplaceStoreMultiInstanceEntitlementsForUserInput;
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiMyReviewArgs = {
    appKey: Scalars["String"]["input"];
};

/**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */
export type MarketplaceStoreQueryApiPartnerArgs = {
    developerId?: InputMaybe<Scalars["ID"]["input"]>;
    vendorId: Scalars["ID"]["input"];
};

export type MarketplaceStoreReviewAuthor = {
    __typename?: "MarketplaceStoreReviewAuthor";
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    profileImage?: Maybe<Scalars["URL"]["output"]>;
    profileLink?: Maybe<Scalars["URL"]["output"]>;
};

export type MarketplaceStoreReviewFilterInput = {
    hosting?: InputMaybe<MarketplaceStoreAtlassianProductHostingType>;
    sort?: InputMaybe<MarketplaceStoreReviewsSorting>;
};

export type MarketplaceStoreReviewNode = {
    __typename?: "MarketplaceStoreReviewNode";
    author?: Maybe<MarketplaceStoreReviewAuthor>;
    date?: Maybe<Scalars["String"]["output"]>;
    helpfulVotes?: Maybe<Scalars["Int"]["output"]>;
    hosting?: Maybe<MarketplaceStoreAtlassianProductHostingType>;
    id: Scalars["ID"]["output"];
    response?: Maybe<Scalars["String"]["output"]>;
    review?: Maybe<Scalars["String"]["output"]>;
    stars?: Maybe<Scalars["Int"]["output"]>;
    totalVotes?: Maybe<Scalars["Int"]["output"]>;
};

export type MarketplaceStoreReviewsResponse = {
    __typename?: "MarketplaceStoreReviewsResponse";
    averageStars: Scalars["Float"]["output"];
    id: Scalars["ID"]["output"];
    reviews: Array<Maybe<MarketplaceStoreReviewNode>>;
    totalCount: Scalars["Int"]["output"];
};

export enum MarketplaceStoreReviewsSorting {
    Helpful = "HELPFUL",
    Recent = "RECENT"
}

/** Atlassian Product for which apps are available in Marketplace */
export type MarketplaceSupportedAtlassianProduct = {
    __typename?: "MarketplaceSupportedAtlassianProduct";
    /** Hosting options where the product is available */
    hostingOptions: Array<AtlassianProductHostingType>;
    /** Unique id of Atlassian product entity in marketplace system */
    id: Scalars["ID"]["output"];
    /** Name of Atlassian product */
    name: Scalars["String"]["output"];
};

/** Tiered pricing object for pricing plan */
export type MarketplaceTieredPricing = {
    __typename?: "MarketplaceTieredPricing";
    /** List of pricing items */
    items: Array<MarketplacePricingItem>;
    /** Type of the tier */
    tierType: MarketplacePricingTierType;
    /** Mode of the tier : GRADUATED (progressive PUP), VOLUME (constant for all users) */
    tiersMode: MarketplacePricingTierMode;
};

/** Workflow app deployment properties */
export type MarketplaceWorkflowAppDeployment = MarketplaceAppDeployment & {
    __typename?: "MarketplaceWorkflowAppDeployment";
    /**
     * All Atlassian Products this app version is compatible with
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    compatibleProducts: Array<CompatibleAtlassianProduct>;
    /**
     * Tells whether this workflow app has a JWB file
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isWorkflowDataFileAvailable: Scalars["Boolean"]["output"];
};

export type MediaAccessTokens = {
    __typename?: "MediaAccessTokens";
    /** Returns a read only token. `null` will be returned if user does not have appropriate permissions */
    readOnlyToken?: Maybe<MediaToken>;
    /** Returns a read+write token. `null` will be returned if user does not have appropriate permissions */
    readWriteToken?: Maybe<MediaToken>;
};

export type MediaAttachment = {
    __typename?: "MediaAttachment";
    html: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
};

export type MediaAttachmentError = {
    __typename?: "MediaAttachmentError";
    error: Error;
};

export type MediaAttachmentInput = {
    file: MediaFile;
    minorEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MediaAttachmentOrError = MediaAttachment | MediaAttachmentError;

export type MediaConfiguration = {
    __typename?: "MediaConfiguration";
    clientId: Scalars["String"]["output"];
    fileStoreUrl: Scalars["String"]["output"];
    maxFileSize?: Maybe<Scalars["Long"]["output"]>;
};

export type MediaFile = {
    /** this is the media store ID */
    id: Scalars["ID"]["input"];
    /** optional mime type of the file */
    mimeType?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    /** size of the file in bytes */
    size: Scalars["Int"]["input"];
};

export type MediaPickerUserToken = {
    __typename?: "MediaPickerUserToken";
    id?: Maybe<Scalars["String"]["output"]>;
    token?: Maybe<Scalars["String"]["output"]>;
};

export type MediaToken = {
    __typename?: "MediaToken";
    duration: Scalars["Int"]["output"];
    expiryDateTime: Scalars["Long"]["output"];
    value: Scalars["String"]["output"];
};

/** The roles that a member can have within a team */
export enum MembershipRole {
    /** A team member with administrative permissions */
    Admin = "ADMIN",
    /** A regular team member */
    Regular = "REGULAR"
}

/** The settings which a team can have describing how members are added to the team */
export enum MembershipSetting {
    /** Members may invite others to join the team */
    MemberInvite = "MEMBER_INVITE",
    /** Anyone may join */
    Open = "OPEN"
}

/** The states that a member can have within a team */
export enum MembershipState {
    /** A member who was previously a full member of the team, but has been removed or has left the team */
    Alumni = "ALUMNI",
    /** A full member of the team */
    FullMember = "FULL_MEMBER",
    /** A member who has been invited to the team but has not yet joined */
    Invited = "INVITED",
    /** A member who has requested to join the team and is pending approval */
    RequestingToJoin = "REQUESTING_TO_JOIN"
}

export type MentionData = {
    mentionLocalIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    mentionedUserAccountId: Scalars["ID"]["input"];
};

export type MenusLookAndFeel = {
    __typename?: "MenusLookAndFeel";
    color?: Maybe<Scalars["String"]["output"]>;
    hoverOrFocus?: Maybe<Array<Maybe<MapOfStringToString>>>;
};

export type MercuryActivityHistoryData =
    | AppUser
    | AtlassianAccountUser
    | CustomerUser
    | JiraIssue
    | TownsquareGoal
    | TownsquareProject;

/**
 *  ------------------------------------------------------
 *   Watch/Unwatch Focus Area mutations
 *  ------------------------------------------------------
 */
export type MercuryAddWatcherToFocusAreaInput = {
    cloudId: Scalars["ID"]["input"];
    focusAreaId: Scalars["ID"]["input"];
    userId: Scalars["ID"]["input"];
};

export type MercuryAddWatcherToFocusAreaPayload = Payload & {
    __typename?: "MercuryAddWatcherToFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Counts by Focus Area Status for a Node */
export type MercuryAggregatedFocusAreaStatusCount = {
    __typename?: "MercuryAggregatedFocusAreaStatusCount";
    /** Status count aggregations for children */
    children: MercuryFocusAreaStatusCount;
    /** Status count aggregations for current node */
    current: MercuryFocusAreaStatusCount;
    /** Status count aggregations for current node and children */
    subtree: MercuryFocusAreaStatusCount;
};

export type MercuryAggregatedHeadcountConnection = {
    __typename?: "MercuryAggregatedHeadcountConnection";
    edges?: Maybe<Array<Maybe<MercuryAggregatedHeadcountEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryAggregatedHeadcountEdge = {
    __typename?: "MercuryAggregatedHeadcountEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryHeadcountAggregation>;
};

export type MercuryAggregatedHeadcountSort = {
    field?: InputMaybe<MercuryAggregatedHeadcountSortField>;
    order: SortOrder;
};

export enum MercuryAggregatedHeadcountSortField {
    FilledPositions = "FILLED_POSITIONS",
    OpenPositions = "OPEN_POSITIONS",
    TotalHeadcount = "TOTAL_HEADCOUNT"
}

/** Counts by Focus Area Status at the level of a Portfolio */
export type MercuryAggregatedPortfolioStatusCount = {
    __typename?: "MercuryAggregatedPortfolioStatusCount";
    /** Status count aggregations for current node and children */
    children: MercuryFocusAreaStatusCount;
};

export type MercuryBudgetAggregation = {
    __typename?: "MercuryBudgetAggregation";
    /** Aggregated of all budgets from linked focus areas */
    aggregatedBudget?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Assigned + aggregated budgets for a focus area */
    totalAssignedBudget?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryChangeProposal = Node & {
    __typename?: "MercuryChangeProposal";
    /** The description of the Change Proposal. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the Change Proposal. */
    id: Scalars["ID"]["output"];
    /** The name of the Change Proposal. */
    name: Scalars["String"]["output"];
    /** The status of the Change Proposal. */
    status?: Maybe<MercuryChangeProposalStatus>;
    /** The status transitions available to the current user. */
    statusTransitions?: Maybe<MercuryChangeProposalStatusTransitions>;
    /** The Strategic Event that the proposal is associated with. */
    strategicEvent?: Maybe<MercuryStrategicEvent>;
};

export type MercuryChangeProposalConnection = {
    __typename?: "MercuryChangeProposalConnection";
    edges?: Maybe<Array<Maybe<MercuryChangeProposalEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryChangeProposalEdge = {
    __typename?: "MercuryChangeProposalEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryChangeProposal>;
};

export type MercuryChangeProposalSort = {
    field: MercuryChangeProposalSortField;
    order: SortOrder;
};

export enum MercuryChangeProposalSortField {
    Name = "NAME"
}

export type MercuryChangeProposalStatus = {
    __typename?: "MercuryChangeProposalStatus";
    color: Scalars["String"]["output"];
    displayName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
};

export type MercuryChangeProposalStatusTransition = {
    __typename?: "MercuryChangeProposalStatusTransition";
    id: Scalars["ID"]["output"];
    to: MercuryChangeProposalStatus;
};

export type MercuryChangeProposalStatusTransitions = {
    __typename?: "MercuryChangeProposalStatusTransitions";
    available: Array<MercuryChangeProposalStatusTransition>;
};

export type MercuryComment = Node & {
    __typename?: "MercuryComment";
    ari: Scalars["String"]["output"];
    commentText?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<User>;
    createdDate: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    updatedDate: Scalars["String"]["output"];
};

export type MercuryCommentConnection = {
    __typename?: "MercuryCommentConnection";
    edges?: Maybe<Array<Maybe<MercuryCommentEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryCommentEdge = {
    __typename?: "MercuryCommentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryComment>;
};

export type MercuryCreateChangeProposalInput = {
    /** The site ID. */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The name of the Change Proposal. */
    name: Scalars["String"]["input"];
    /** The ID of the Strategic Event the Change Proposal is associated with. */
    strategicEventId: Scalars["String"]["input"];
};

export type MercuryCreateChangeProposalPayload = Payload & {
    __typename?: "MercuryCreateChangeProposalPayload";
    createdChangeProposal?: Maybe<MercuryChangeProposal>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryCreateCommentInput = {
    cloudId: Scalars["ID"]["input"];
    commentText: Scalars["MercuryJSONString"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: MercuryEntityType;
};

export type MercuryCreateCommentPayload = Payload & {
    __typename?: "MercuryCreateCommentPayload";
    createdComment?: Maybe<MercuryComment>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ------------------------------------------------------
 *   Focus Area
 *  ------------------------------------------------------
 */
export type MercuryCreateFocusAreaInput = {
    cloudId: Scalars["ID"]["input"];
    /** Optional unique identifier for correlating a Focus Area with external systems or records. */
    externalId?: InputMaybe<Scalars["String"]["input"]>;
    focusAreaTypeId: Scalars["ID"]["input"];
    name: Scalars["String"]["input"];
    /** Optional ID of the parent Focus Area in the hierarchy. If not provided the Focus Area has no parent. */
    parentFocusAreaId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MercuryCreateFocusAreaPayload = Payload & {
    __typename?: "MercuryCreateFocusAreaPayload";
    createdFocusArea?: Maybe<MercuryFocusArea>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ----------------------------------------
 *   Focus Area status update mutations
 *  ----------------------------------------
 */
export type MercuryCreateFocusAreaStatusUpdateInput = {
    cloudId: Scalars["ID"]["input"];
    /** ID of the Focus Area for which an update is posted. */
    focusAreaId: Scalars["ID"]["input"];
    /** The new target date for the Focus Area. */
    newTargetDate?: InputMaybe<MercuryFocusAreaTargetDateInput>;
    /** The ID of the status to transition the Focus Area to as part of the update. */
    statusTransitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The summary text (ADF) for the update. */
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type MercuryCreateFocusAreaStatusUpdatePayload = Payload & {
    __typename?: "MercuryCreateFocusAreaStatusUpdatePayload";
    createdFocusAreaUpdateStatus?: Maybe<MercuryFocusAreaStatusUpdate>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryCreatePortfolioFocusAreasInput = {
    cloudId: Scalars["ID"]["input"];
    focusAreaIds: Array<Scalars["ID"]["input"]>;
    name: Scalars["String"]["input"];
};

export type MercuryCreatePortfolioPayload = Payload & {
    __typename?: "MercuryCreatePortfolioPayload";
    createdPortfolio?: Maybe<MercuryPortfolio>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryCreateStrategicEventInput = {
    /** The site ID. */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The name of the Strategic Event. */
    name: Scalars["String"]["input"];
    /** The target date of the Strategic Event. */
    targetDate: Scalars["String"]["input"];
};

export type MercuryCreateStrategicEventPayload = Payload & {
    __typename?: "MercuryCreateStrategicEventPayload";
    createdStrategicEvent?: Maybe<MercuryStrategicEvent>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteAllPreferenceInput = {
    cloudId: Scalars["ID"]["input"];
};

export type MercuryDeleteAllPreferencesByUserPayload = Payload & {
    __typename?: "MercuryDeleteAllPreferencesByUserPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteCommentInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryDeleteCommentPayload = Payload & {
    __typename?: "MercuryDeleteCommentPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaGoalLinkInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryDeleteFocusAreaGoalLinkPayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaGoalLinkPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaGoalLinksInput = {
    atlasGoalAris: Array<Scalars["String"]["input"]>;
    focusAreaAri: Scalars["String"]["input"];
};

export type MercuryDeleteFocusAreaGoalLinksPayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaGoalLinksPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryDeleteFocusAreaLinkInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryDeleteFocusAreaLinkPayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaLinkPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaPayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaStatusUpdateInput = {
    cloudId: Scalars["ID"]["input"];
    /** The ID of the Focus Area status update entry. */
    id: Scalars["ID"]["input"];
};

export type MercuryDeleteFocusAreaStatusUpdatePayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaStatusUpdatePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaWorkLinkInput = {
    cloudId: Scalars["ID"]["input"];
    /** The ID of the link to delete. */
    id: Scalars["ID"]["input"];
};

export type MercuryDeleteFocusAreaWorkLinkPayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaWorkLinkPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeleteFocusAreaWorkLinksInput = {
    focusAreaAri: Scalars["String"]["input"];
    workAris: Array<Scalars["String"]["input"]>;
};

export type MercuryDeleteFocusAreaWorkLinksPayload = Payload & {
    __typename?: "MercuryDeleteFocusAreaWorkLinksPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeletePortfolioFocusAreaLinkInput = {
    cloudId: Scalars["ID"]["input"];
    focusAreaIds: Array<Scalars["ID"]["input"]>;
    portfolioId: Scalars["ID"]["input"];
};

export type MercuryDeletePortfolioFocusAreaLinkPayload = Payload & {
    __typename?: "MercuryDeletePortfolioFocusAreaLinkPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeletePortfolioInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryDeletePortfolioPayload = Payload & {
    __typename?: "MercuryDeletePortfolioPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type MercuryDeletePreferenceInput = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

export type MercuryDeletePreferencePayload = Payload & {
    __typename?: "MercuryDeletePreferencePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum MercuryEntityType {
    Comment = "COMMENT",
    FocusArea = "FOCUS_AREA",
    FocusAreaStatusUpdate = "FOCUS_AREA_STATUS_UPDATE",
    Program = "PROGRAM",
    ProgramStatusUpdate = "PROGRAM_STATUS_UPDATE"
}

export enum MercuryEventType {
    Create = "CREATE",
    CreateUpdate = "CREATE_UPDATE",
    Delete = "DELETE",
    DeleteUpdate = "DELETE_UPDATE",
    EditUpdate = "EDIT_UPDATE",
    Export = "EXPORT",
    Import = "IMPORT",
    Link = "LINK",
    Unlink = "UNLINK",
    Update = "UPDATE"
}

export type MercuryFocusArea = Node & {
    __typename?: "MercuryFocusArea";
    /** Content describing what a Focus Area is about */
    aboutContent: MercuryFocusAreaAbout;
    /** Get aggregated Focus Area status counts */
    aggregatedFocusAreaStatusCount?: Maybe<MercuryAggregatedFocusAreaStatusCount>;
    /** The resource allocations for the Focus Area. */
    allocations?: Maybe<MercuryFocusAreaAllocations>;
    /** The ARI of the Focus Area */
    ari: Scalars["String"]["output"];
    /** The date the Focus Area was created. */
    createdDate: Scalars["String"]["output"];
    /** Unique identifier for correlating a Focus Area with external systems or records. */
    externalId?: Maybe<Scalars["String"]["output"]>;
    /** A list of linked Focus Areas contributing to the Focus Area. */
    focusAreaLinks?: Maybe<MercuryFocusAreaLinks>;
    /** A paginated list of updates to a Focus Area. */
    focusAreaStatusUpdates?: Maybe<MercuryFocusAreaStatusUpdateConnection>;
    /** The Focus Area type indicating the Focus Area level in the hierarchy. */
    focusAreaType: MercuryFocusAreaType;
    /** Funding details for the Focus Area */
    funding?: Maybe<MercuryFunding>;
    /**
     * A list of linked goals contributing to the Focus Area.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Query AGS via AGG for goal links
     */
    goalLinks?: Maybe<MercuryFocusAreaGoalLinks>;
    /** Aggregation of headcount and positions for a focus area and its children. */
    headcountAggregation?: Maybe<MercuryHeadcountAggregation>;
    /** The health of the Focus Area, e.g. on_track, off_track, at_risk. */
    health?: Maybe<MercuryFocusAreaHealth>;
    /** The ID of the Focus Area. */
    id: Scalars["ID"]["output"];
    /** A summary of linked goals contributing to the Focus Area. */
    linkedGoalSummary?: Maybe<MercuryFocusAreaLinkedGoalSummary>;
    /**
     * A summary of linked work contributing to the Focus Area.
     * `null` is returned if no work is linked.
     */
    linkedWorkSummary?: Maybe<MercuryFocusAreaLinkedWorkSummary>;
    /** The name of the Focus Area. */
    name: Scalars["String"]["output"];
    /** The owner responsible for the Focus Area. */
    owner?: Maybe<User>;
    /** The parent of the current Focus Area. */
    parent?: Maybe<MercuryFocusArea>;
    /** The status of the Focus Area, e.g. pending, in_progress, completed. */
    status: MercuryFocusAreaStatus;
    /** The list of status transitions that can be performed on the Focus Area. */
    statusTransitions: MercuryFocusAreaStatusTransitions;
    /** The sub Focus Areas directly linked to the current Focus Area. */
    subFocusAreas?: Maybe<MercuryFocusAreaConnection>;
    /** The target delivery date of the Focus Area. */
    targetDate?: Maybe<MercuryTargetDate>;
    /** The allocations of teams to a focus area and its children. */
    teamAllocations?: Maybe<MercuryFocusAreaTeamAllocationAggregationConnection>;
    /** The date the any field on the Focus Area was last updated. */
    updatedDate: Scalars["String"]["output"];
    /** URL to the Focus Area */
    url?: Maybe<Scalars["String"]["output"]>;
    /** The UUID of the Focus Area, preserved for backwards compatibility. */
    uuid: Scalars["UUID"]["output"];
    /** A list of the users watching the Focus Area. */
    watchers?: Maybe<MercuryUserConnection>;
    /** Indicates if the current user is watching the Focus Area. */
    watching: Scalars["Boolean"]["output"];
};

export type MercuryFocusAreaFocusAreaStatusUpdatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    createdAtOrAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
    createdAtOrBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MercuryFocusAreaSubFocusAreasArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryFocusAreaSort>>>;
};

export type MercuryFocusAreaTeamAllocationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<
        Array<InputMaybe<MercuryFocusAreaTeamAllocationAggregationSort>>
    >;
};

export type MercuryFocusAreaWatchersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** ADF holding the about content within the editor */
export type MercuryFocusAreaAbout = {
    __typename?: "MercuryFocusAreaAbout";
    editorAdfContent?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryFocusAreaActivityConnection = {
    __typename?: "MercuryFocusAreaActivityConnection";
    edges?: Maybe<Array<Maybe<MercuryFocusAreaActivityEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaActivityEdge = {
    __typename?: "MercuryFocusAreaActivityEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryFocusAreaActivityHistory>;
};

export type MercuryFocusAreaActivityHistory = Node & {
    __typename?: "MercuryFocusAreaActivityHistory";
    /** The ARI for the entity associated with this action Eg. Focus Area Update ARI */
    associatedEntityAri?: Maybe<Scalars["String"]["output"]>;
    /** The date of the event */
    eventDate?: Maybe<Scalars["String"]["output"]>;
    /** The type of event that occurred */
    eventType?: Maybe<MercuryEventType>;
    /** The history of the fields that were changed in the event */
    fields?: Maybe<Array<Maybe<MercuryUpdatedField>>>;
    /** The fields that were changed in the event */
    fieldsChanged?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** The ID of the Focus Area for this event */
    focusAreaId?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the Focus Area event. */
    id: Scalars["ID"]["output"];
    /** The user who performed the event */
    user?: Maybe<User>;
};

/**
 *  ----------------------------------------
 *   Focus Area Activity
 *  ----------------------------------------
 */
export type MercuryFocusAreaActivitySort = {
    order: SortOrder;
};

export type MercuryFocusAreaAllocations = {
    __typename?: "MercuryFocusAreaAllocations";
    human?: Maybe<MercuryHumanResourcesAllocation>;
};

export type MercuryFocusAreaConnection = {
    __typename?: "MercuryFocusAreaConnection";
    edges?: Maybe<Array<Maybe<MercuryFocusAreaEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaEdge = {
    __typename?: "MercuryFocusAreaEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryFocusArea>;
};

export type MercuryFocusAreaGoalLink = Node & {
    __typename?: "MercuryFocusAreaGoalLink";
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: Townsquare` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    atlasGoal?: Maybe<TownsquareGoal>;
    atlasGoalAri: Scalars["String"]["output"];
    atlasGoalId: Scalars["String"]["output"];
    createdBy: Scalars["String"]["output"];
    createdDate: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    parentFocusAreaId: Scalars["String"]["output"];
};

export type MercuryFocusAreaGoalLinks = {
    __typename?: "MercuryFocusAreaGoalLinks";
    links: Array<MercuryFocusAreaGoalLink>;
};

export type MercuryFocusAreaHealth = {
    __typename?: "MercuryFocusAreaHealth";
    color: MercuryFocusAreaHealthColor;
    displayName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
};

export enum MercuryFocusAreaHealthColor {
    Green = "GREEN",
    Red = "RED",
    Yellow = "YELLOW"
}

export type MercuryFocusAreaHierarchyNode = {
    __typename?: "MercuryFocusAreaHierarchyNode";
    children?: Maybe<Array<Maybe<MercuryFocusAreaHierarchyNode>>>;
    focusArea?: Maybe<MercuryFocusArea>;
};

export type MercuryFocusAreaHierarchyNodeChildrenArgs = {
    sort?: InputMaybe<Array<InputMaybe<MercuryFocusAreaHierarchySort>>>;
};

export type MercuryFocusAreaHierarchySort = {
    field?: InputMaybe<MercuryFocusAreaHierarchySortField>;
    order: SortOrder;
};

export enum MercuryFocusAreaHierarchySortField {
    HierarchyLevel = "HIERARCHY_LEVEL",
    Name = "NAME"
}

export type MercuryFocusAreaLink = Node & {
    __typename?: "MercuryFocusAreaLink";
    childFocusAreaId: Scalars["String"]["output"];
    createdBy: Scalars["String"]["output"];
    createdDate: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    parentFocusAreaId: Scalars["String"]["output"];
};

export type MercuryFocusAreaLinkedGoalSummary = {
    __typename?: "MercuryFocusAreaLinkedGoalSummary";
    /** Count of number of goals directly linked to the Focus Area. */
    count: Scalars["Int"]["output"];
    /**
     * Count of number of goals linked to the Focus Area and its Sub-Focus Areas.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MercuryFocusAreaLinkedGoalSummary")' query directive to the 'countIncludingSubFocusAreas' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    countIncludingSubFocusAreas?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaLinkedWorkSummary = {
    __typename?: "MercuryFocusAreaLinkedWorkSummary";
    /** Count of number of work directly linked work items. */
    count: Scalars["Int"]["output"];
    /**
     * Count of number of work items linked to the Focus Area and its Sub-Focus Areas.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "MercuryFocusAreaLinkedWorkSummary")' query directive to the 'countIncludingSubFocusAreas' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    countIncludingSubFocusAreas?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaLinks = {
    __typename?: "MercuryFocusAreaLinks";
    links: Array<MercuryFocusAreaLink>;
};

export type MercuryFocusAreaSort = {
    field?: InputMaybe<MercuryFocusAreaSortField>;
    order: SortOrder;
};

export enum MercuryFocusAreaSortField {
    Budget = "BUDGET",
    FocusAreaType = "FOCUS_AREA_TYPE",
    HasParent = "HAS_PARENT",
    HierarchyLevel = "HIERARCHY_LEVEL",
    LastUpdated = "LAST_UPDATED",
    Name = "NAME",
    Spend = "SPEND",
    Status = "STATUS",
    TargetDate = "TARGET_DATE",
    Watching = "WATCHING"
}

export type MercuryFocusAreaStatus = {
    __typename?: "MercuryFocusAreaStatus";
    displayName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
};

/** Counts by different Focus Area status */
export type MercuryFocusAreaStatusCount = {
    __typename?: "MercuryFocusAreaStatusCount";
    /** Count of at-risk status */
    atRisk?: Maybe<Scalars["Int"]["output"]>;
    /** Count with completed status */
    completed?: Maybe<Scalars["Int"]["output"]>;
    /** Count of in-progress status */
    inProgress?: Maybe<Scalars["Int"]["output"]>;
    /** Count of off-track status */
    offTrack?: Maybe<Scalars["Int"]["output"]>;
    /** Count of on-track status */
    onTrack?: Maybe<Scalars["Int"]["output"]>;
    /** Count with paused status */
    paused?: Maybe<Scalars["Int"]["output"]>;
    /** Count with pending status */
    pending?: Maybe<Scalars["Int"]["output"]>;
    /** Total count of nodes */
    total?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaStatusTransition = {
    __typename?: "MercuryFocusAreaStatusTransition";
    health?: Maybe<MercuryFocusAreaHealth>;
    id: Scalars["ID"]["output"];
    status: MercuryFocusAreaStatus;
};

export type MercuryFocusAreaStatusTransitions = {
    __typename?: "MercuryFocusAreaStatusTransitions";
    available: Array<MercuryFocusAreaStatusTransition>;
};

export type MercuryFocusAreaStatusUpdate = {
    __typename?: "MercuryFocusAreaStatusUpdate";
    /** The ARI of the Focus Area status update. Used for platform components, e.g. reactions. */
    ari?: Maybe<Scalars["String"]["output"]>;
    /** A paginated list of comments for the update. */
    comments?: Maybe<MercuryCommentConnection>;
    /** The user who created the update. */
    createdBy?: Maybe<User>;
    /** The date the update was created. */
    createdDate: Scalars["String"]["output"];
    /** The id of the Focus Area that is updated */
    focusAreaId: Scalars["ID"]["output"];
    /** The ID of the Focus Area status update. */
    id: Scalars["ID"]["output"];
    /** The new Focus Area health if the Focus Area status was transitioned as part of the update. */
    newHealth?: Maybe<MercuryFocusAreaHealth>;
    /** The new Focus Area status if the Focus Area status was transitioned as part of the update. */
    newStatus?: Maybe<MercuryFocusAreaStatus>;
    /** The new target date if the date was changed as part of the update. */
    newTargetDate?: Maybe<MercuryTargetDate>;
    /** The previous Focus Area health if the Focus Area status was transitioned as part of the update. */
    previousHealth?: Maybe<MercuryFocusAreaHealth>;
    /** The previous Focus Area status if the Focus Area status was transitioned as part of the update. */
    previousStatus?: Maybe<MercuryFocusAreaStatus>;
    /** The previous target date if the date was changed as part of the update. */
    previousTargetDate?: Maybe<MercuryTargetDate>;
    /** The summary text (ADF) for the update. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The user who last updated the issue. Defaults to `createdBy` on create. */
    updatedBy?: Maybe<User>;
    /** The date the update was last updated (edited). Defaults to `createdDate` on create. */
    updatedDate: Scalars["String"]["output"];
};

export type MercuryFocusAreaStatusUpdateCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MercuryFocusAreaStatusUpdateConnection = {
    __typename?: "MercuryFocusAreaStatusUpdateConnection";
    edges?: Maybe<Array<Maybe<MercuryFocusAreaStatusUpdateEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaStatusUpdateEdge = {
    __typename?: "MercuryFocusAreaStatusUpdateEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryFocusAreaStatusUpdate>;
};

/**
 *  ------------------------------------------------------
 *   Atlassian Intelligence
 *  ------------------------------------------------------
 */
export type MercuryFocusAreaSummary = {
    __typename?: "MercuryFocusAreaSummary";
    /** The ID of the Focus Area. */
    id: Scalars["ID"]["output"];
    /** The generated Focus Area summary. */
    summary?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryFocusAreaTargetDateInput = {
    targetDate?: InputMaybe<Scalars["String"]["input"]>;
    targetDateType?: InputMaybe<MercuryTargetDateType>;
};

/** Aggregation of a team's allocations for a focus area and its children. */
export type MercuryFocusAreaTeamAllocationAggregation = Node & {
    __typename?: "MercuryFocusAreaTeamAllocationAggregation";
    /** Aggregate of the number of filled positions for a team's allocation to a focus area and its children. */
    filledPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The ID of the allocation. */
    id: Scalars["ID"]["output"];
    /** Aggregate of the number of open positions for a team's allocation to a focus area and its children. */
    openPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The team that is being allocated. */
    team: MercuryTeam;
    /** Aggregate of the total number of positions for a team's allocation to a focus area and its children. */
    totalPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryFocusAreaTeamAllocationAggregationConnection = {
    __typename?: "MercuryFocusAreaTeamAllocationAggregationConnection";
    edges?: Maybe<Array<Maybe<MercuryFocusAreaTeamAllocationAggregationEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryFocusAreaTeamAllocationAggregationEdge = {
    __typename?: "MercuryFocusAreaTeamAllocationAggregationEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryFocusAreaTeamAllocationAggregation>;
};

export type MercuryFocusAreaTeamAllocationAggregationSort = {
    field?: InputMaybe<MercuryFocusAreaTeamAllocationAggregationSortField>;
    order: SortOrder;
};

export enum MercuryFocusAreaTeamAllocationAggregationSortField {
    FilledPositions = "FILLED_POSITIONS",
    OpenPositions = "OPEN_POSITIONS",
    TeamName = "TEAM_NAME",
    TotalPositions = "TOTAL_POSITIONS"
}

export type MercuryFocusAreaType = {
    __typename?: "MercuryFocusAreaType";
    hierarchyLevel: Scalars["Int"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

export type MercuryForYouFocusAreaActivityHistory = {
    __typename?: "MercuryForYouFocusAreaActivityHistory";
    activityHistory?: Maybe<MercuryFocusAreaActivityConnection>;
    focusAreas?: Maybe<MercuryFocusAreaConnection>;
};

export type MercuryFunding = {
    __typename?: "MercuryFunding";
    aggregation?: Maybe<MercuryFundingAggregation>;
    assigned?: Maybe<MercuryFundingAssigned>;
};

export type MercuryFundingAggregation = {
    __typename?: "MercuryFundingAggregation";
    budgetAggregation?: Maybe<MercuryBudgetAggregation>;
    spendAggregation?: Maybe<MercurySpendAggregation>;
};

export type MercuryFundingAssigned = {
    __typename?: "MercuryFundingAssigned";
    /** The financial budget for the focus area */
    budget?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The financial spend for the focus area */
    spend?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryGoalAggregatedStatusCount = {
    __typename?: "MercuryGoalAggregatedStatusCount";
    /**
     * Current key-results goal count
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    krAggregatedStatusCount?: Maybe<MercuryGoalsAggregatedStatusCount>;
    /**
     * latest goal status updated date
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    latestGoalStatusUpdateDate?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * aggregated sub-goals status goal count
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    subGoalsAggregatedStatusCount?: Maybe<MercuryGoalsAggregatedStatusCount>;
};

export type MercuryGoalStatusCount = {
    __typename?: "MercuryGoalStatusCount";
    atRisk?: Maybe<Scalars["Int"]["output"]>;
    cancelled?: Maybe<Scalars["Int"]["output"]>;
    done?: Maybe<Scalars["Int"]["output"]>;
    offTrack?: Maybe<Scalars["Int"]["output"]>;
    onTrack?: Maybe<Scalars["Int"]["output"]>;
    paused?: Maybe<Scalars["Int"]["output"]>;
    pending?: Maybe<Scalars["Int"]["output"]>;
    total?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryGoalsAggregatedStatusCount = {
    __typename?: "MercuryGoalsAggregatedStatusCount";
    /**
     * Current aggregated status goal count
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    current?: Maybe<MercuryGoalStatusCount>;
    /**
     * Aggregated status goal count for past week
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    previous?: Maybe<MercuryGoalStatusCount>;
};

/** Aggregation of headcount and positions for a focus area and its children. */
export type MercuryHeadcountAggregation = {
    __typename?: "MercuryHeadcountAggregation";
    /** Aggregate of all filled positions for linked focus areas. */
    filledPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The Focus Area that the headcount is aggregated for. */
    focusArea: MercuryFocusArea;
    /** Aggregate of all open positions for linked focus areas. */
    openPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Aggregate of all headcount for linked focus areas. */
    totalHeadcount?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryHumanResourcesAllocation = {
    __typename?: "MercuryHumanResourcesAllocation";
    /** The budgeted positions is the total number of positions (or headcount) allotted to the focus area. */
    budgetedPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Actual amount of full-time equivalent positions contributing to a focus area. Can be fractional. */
    filledPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Unfilled or open positions, e.g. # of positions planned to hire. */
    openPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The total positions as a % of the budgeted positions. */
    totalAsPercentageOfBudget?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** `totalPositions = filledPositions + openPositions`. This can be above, equal to, or below the budgeted positions. */
    totalPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryLinkAtlassianWorkToFocusAreaInput = {
    /** The focus area ARI the work is linked to. */
    focusAreaAri: Scalars["String"]["input"];
    /** The external ARIs as they are in the 1P provider of the work to link. */
    workAris: Array<Scalars["String"]["input"]>;
};

export type MercuryLinkAtlassianWorkToFocusAreaPayload = Payload & {
    __typename?: "MercuryLinkAtlassianWorkToFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ------------------------------------------------------
 *   Focus Area links
 *  ------------------------------------------------------
 */
export type MercuryLinkFocusAreasToFocusAreaInput = {
    childFocusAreaIds: Array<Scalars["ID"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    parentFocusAreaId: Scalars["ID"]["input"];
};

export type MercuryLinkFocusAreasToFocusAreaPayload = Payload & {
    __typename?: "MercuryLinkFocusAreasToFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ------------------------------------------------------
 *   Portfolio
 *  ------------------------------------------------------
 */
export type MercuryLinkFocusAreasToPortfolioInput = {
    cloudId: Scalars["ID"]["input"];
    focusAreaIds: Array<Scalars["ID"]["input"]>;
    portfolioId: Scalars["ID"]["input"];
};

export type MercuryLinkFocusAreasToPortfolioPayload = Payload & {
    __typename?: "MercuryLinkFocusAreasToPortfolioPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ------------------------------------------------------
 *   Goal links
 *  ------------------------------------------------------
 */
export type MercuryLinkGoalsToFocusAreaInput = {
    atlasGoalAris: Array<Scalars["String"]["input"]>;
    focusAreaAri: Scalars["String"]["input"];
};

export type MercuryLinkGoalsToFocusAreaPayload = Payload & {
    __typename?: "MercuryLinkGoalsToFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ------------------------------------------------------
 *   Work links
 *  ------------------------------------------------------
 */
export type MercuryLinkWorkToFocusAreaInput = {
    cloudId: Scalars["ID"]["input"];
    /** The external IDs as they are in the 1P/3P provider of the work to link. */
    externalChildWorkIds: Array<Scalars["ID"]["input"]>;
    /** The focus area the work is linked to. */
    parentFocusAreaId: Scalars["ID"]["input"];
    /** The provider of the work. */
    providerKey: Scalars["String"]["input"];
    /** The provider container of the work(site ari for jira) */
    workContainerAri?: InputMaybe<Scalars["String"]["input"]>;
};

export type MercuryLinkWorkToFocusAreaPayload = Payload & {
    __typename?: "MercuryLinkWorkToFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ------------------------------------------------------
 *   Media
 *  ------------------------------------------------------
 */
export type MercuryMediaToken = {
    __typename?: "MercuryMediaToken";
    token: Scalars["String"]["output"];
};

export type MercuryMutationApi = {
    __typename?: "MercuryMutationApi";
    /**
     * Adds a new watcher to a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'addWatcherToFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    addWatcherToFocusArea?: Maybe<MercuryAddWatcherToFocusAreaPayload>;
    /**
     * Creates a new comment on a given entity.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'createComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createComment?: Maybe<MercuryCreateCommentPayload>;
    /**
     * Creates a new Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'createFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createFocusArea?: Maybe<MercuryCreateFocusAreaPayload>;
    /**
     * Creates a new Focus Area Status Update. A status update represents an
     * update to a collection of fields that impact the status of the
     * focus area, e.g. changes to target date, status or health.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'createFocusAreaStatusUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createFocusAreaStatusUpdate?: Maybe<MercuryCreateFocusAreaStatusUpdatePayload>;
    /**
     * Create a new Portfolio.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'createPortfolioWithFocusAreas' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createPortfolioWithFocusAreas?: Maybe<MercuryCreatePortfolioPayload>;
    /**
     * Delete all of a user's preferences.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteAllPreferencesByUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteAllPreferencesByUser?: Maybe<MercuryDeleteAllPreferencesByUserPayload>;
    /**
     * Deletes a given comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteComment?: Maybe<MercuryDeleteCommentPayload>;
    /**
     * Deletes a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteFocusArea?: Maybe<MercuryDeleteFocusAreaPayload>;
    /**
     * Delete a link between a goal and a Focus Area.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusAreaGoalLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Migration to use deleteFocusAreaGoalLinks instead
     */
    deleteFocusAreaGoalLink?: Maybe<MercuryDeleteFocusAreaGoalLinkPayload>;
    /**
     * Delete links between goals and a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusAreaGoalLinks' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    deleteFocusAreaGoalLinks?: Maybe<MercuryDeleteFocusAreaGoalLinksPayload>;
    /**
     * Delete a link between two Focus Areas.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusAreaLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteFocusAreaLink?: Maybe<MercuryDeleteFocusAreaLinkPayload>;
    /**
     * Deletes a focus area status update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusAreaStatusUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deleteFocusAreaStatusUpdate?: Maybe<MercuryDeleteFocusAreaStatusUpdatePayload>;
    /**
     * Delete a Portfolio.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deletePortfolio' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deletePortfolio?: Maybe<MercuryDeletePortfolioPayload>;
    /**
     * Unlink Focus Areas from a Portfolio
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deletePortfolioFocusAreaLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deletePortfolioFocusAreaLink?: Maybe<MercuryDeletePortfolioFocusAreaLinkPayload>;
    /**
     * Delete a user's preference for a key.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deletePreference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deletePreference?: Maybe<MercuryDeletePreferencePayload>;
    /**
     * Links a list of contributing Focus Areas that are lower in the hierarchy to a Focus Area higher up in the hierarchy.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'linkFocusAreasToFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkFocusAreasToFocusArea?: Maybe<MercuryLinkFocusAreasToFocusAreaPayload>;
    /**
     * Link Focus Areas to a Portfolio
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'linkFocusAreasToPortfolio' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    linkFocusAreasToPortfolio?: Maybe<MercuryLinkFocusAreasToPortfolioPayload>;
    /**
     * Links a list of contributing goals to a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'linkGoalsToFocusArea' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    linkGoalsToFocusArea?: Maybe<MercuryLinkGoalsToFocusAreaPayload>;
    /**
     * Recreate portfolio's linked Focus Areas.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'recreatePortfolioFocusAreas' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    recreatePortfolioFocusAreas?: Maybe<MercuryUpdatePortfolioPayload>;
    /**
     * Removes a watcher from a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'removeWatcherFromFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeWatcherFromFocusArea?: Maybe<MercuryRemoveWatcherFromFocusAreaPayload>;
    /**
     * Set a preference for a user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'setPreference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setPreference?: Maybe<MercurySetPreferencePayload>;
    /**
     * Applies a Focus Area status transition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'transitionFocusAreaStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    transitionFocusAreaStatus?: Maybe<MercuryUpdateFocusAreaPayload>;
    /**
     * Updates a given comment's text.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updateComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateComment?: Maybe<MercuryUpdateCommentPayload>;
    /**
     * Updates the about content of a Focus Area in the editor.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updateFocusAreaAboutContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateFocusAreaAboutContent?: Maybe<MercuryUpdateFocusAreaPayload>;
    /**
     * Updates the name of a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updateFocusAreaName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateFocusAreaName?: Maybe<MercuryUpdateFocusAreaPayload>;
    /**
     * Updates the owner of a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updateFocusAreaOwner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateFocusAreaOwner?: Maybe<MercuryUpdateFocusAreaPayload>;
    /**
     * Updates an existing Focus Area Status Update.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updateFocusAreaStatusUpdate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateFocusAreaStatusUpdate?: Maybe<MercuryUpdateFocusAreaStatusUpdatePayload>;
    /**
     * Updates the target date of a Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updateFocusAreaTargetDate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateFocusAreaTargetDate?: Maybe<MercuryUpdateFocusAreaPayload>;
    /**
     * Update a portfolio's name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'updatePortfolioName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updatePortfolioName?: Maybe<MercuryUpdatePortfolioPayload>;
};

export type MercuryMutationApiAddWatcherToFocusAreaArgs = {
    input: MercuryAddWatcherToFocusAreaInput;
};

export type MercuryMutationApiCreateCommentArgs = {
    input: MercuryCreateCommentInput;
};

export type MercuryMutationApiCreateFocusAreaArgs = {
    input: MercuryCreateFocusAreaInput;
};

export type MercuryMutationApiCreateFocusAreaStatusUpdateArgs = {
    input: MercuryCreateFocusAreaStatusUpdateInput;
};

export type MercuryMutationApiCreatePortfolioWithFocusAreasArgs = {
    input: MercuryCreatePortfolioFocusAreasInput;
};

export type MercuryMutationApiDeleteAllPreferencesByUserArgs = {
    input: MercuryDeleteAllPreferenceInput;
};

export type MercuryMutationApiDeleteCommentArgs = {
    input: MercuryDeleteCommentInput;
};

export type MercuryMutationApiDeleteFocusAreaArgs = {
    input: MercuryDeleteFocusAreaInput;
};

export type MercuryMutationApiDeleteFocusAreaGoalLinkArgs = {
    input: MercuryDeleteFocusAreaGoalLinkInput;
};

export type MercuryMutationApiDeleteFocusAreaGoalLinksArgs = {
    input: MercuryDeleteFocusAreaGoalLinksInput;
};

export type MercuryMutationApiDeleteFocusAreaLinkArgs = {
    input: MercuryDeleteFocusAreaLinkInput;
};

export type MercuryMutationApiDeleteFocusAreaStatusUpdateArgs = {
    input: MercuryDeleteFocusAreaStatusUpdateInput;
};

export type MercuryMutationApiDeletePortfolioArgs = {
    input: MercuryDeletePortfolioInput;
};

export type MercuryMutationApiDeletePortfolioFocusAreaLinkArgs = {
    input: MercuryDeletePortfolioFocusAreaLinkInput;
};

export type MercuryMutationApiDeletePreferenceArgs = {
    input: MercuryDeletePreferenceInput;
};

export type MercuryMutationApiLinkFocusAreasToFocusAreaArgs = {
    input: MercuryLinkFocusAreasToFocusAreaInput;
};

export type MercuryMutationApiLinkFocusAreasToPortfolioArgs = {
    input: MercuryLinkFocusAreasToPortfolioInput;
};

export type MercuryMutationApiLinkGoalsToFocusAreaArgs = {
    input: MercuryLinkGoalsToFocusAreaInput;
};

export type MercuryMutationApiRecreatePortfolioFocusAreasArgs = {
    input: MercuryRecreatePortfolioFocusAreasInput;
};

export type MercuryMutationApiRemoveWatcherFromFocusAreaArgs = {
    input: MercuryRemoveWatcherFromFocusAreaInput;
};

export type MercuryMutationApiSetPreferenceArgs = {
    input: MercurySetPreferenceInput;
};

export type MercuryMutationApiTransitionFocusAreaStatusArgs = {
    input: MercuryTransitionFocusAreaStatusInput;
};

export type MercuryMutationApiUpdateCommentArgs = {
    input: MercuryUpdateCommentInput;
};

export type MercuryMutationApiUpdateFocusAreaAboutContentArgs = {
    input: MercuryUpdateFocusAreaAboutContentInput;
};

export type MercuryMutationApiUpdateFocusAreaNameArgs = {
    input: MercuryUpdateFocusAreaNameInput;
};

export type MercuryMutationApiUpdateFocusAreaOwnerArgs = {
    input: MercuryUpdateFocusAreaOwnerInput;
};

export type MercuryMutationApiUpdateFocusAreaStatusUpdateArgs = {
    input: MercuryUpdateFocusAreaStatusUpdateInput;
};

export type MercuryMutationApiUpdateFocusAreaTargetDateArgs = {
    input: MercuryUpdateFocusAreaTargetDateInput;
};

export type MercuryMutationApiUpdatePortfolioNameArgs = {
    input: MercuryUpdatePortfolioNameInput;
};

export type MercuryPortfolio = Node & {
    __typename?: "MercuryPortfolio";
    /** Get aggregated Focus Area status counts for Focus Areas linked to a Portfolio */
    aggregatedFocusAreaStatusCount?: Maybe<MercuryAggregatedPortfolioStatusCount>;
    /** The resource allocations for a portfolio */
    allocations?: Maybe<MercuryPortfolioAllocations>;
    /** The ARI of the portfolio */
    ari: Scalars["String"]["output"];
    funding?: Maybe<MercuryPortfolioFunding>;
    /** The ID of the portfolio */
    id: Scalars["ID"]["output"];
    /** Portfolio label for recent activity */
    label?: Maybe<Scalars["String"]["output"]>;
    /** The total number of goals linked directly on the top level Focus Areas linked to a portfolio */
    linkedFocusAreaGoalCount: Scalars["Int"]["output"];
    /** The status breakdown for a portfolio */
    linkedFocusAreaSummary?: Maybe<MercuryPortfolioFocusAreaSummary>;
    /** The name of the portfolio */
    name: Scalars["String"]["output"];
    /** The owner of the portfolio */
    owner?: Maybe<User>;
    /** URL to the Portfolio */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryPortfolioAllocations = {
    __typename?: "MercuryPortfolioAllocations";
    human?: Maybe<MercuryPortfolioHumanResourceAllocations>;
};

export type MercuryPortfolioBudgetAggregation = {
    __typename?: "MercuryPortfolioBudgetAggregation";
    /** Aggregated of all budgets from linked focus areas */
    aggregatedBudget?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryPortfolioFocusAreaSummary = {
    __typename?: "MercuryPortfolioFocusAreaSummary";
    /** The count of the children focusArea types of a portfolio */
    focusAreaTypeBreakdown?: Maybe<
        Array<Maybe<MercuryPortfolioFocusAreaTypeBreakdown>>
    >;
};

export type MercuryPortfolioFocusAreaTypeBreakdown = {
    __typename?: "MercuryPortfolioFocusAreaTypeBreakdown";
    count: Scalars["Int"]["output"];
    focusAreaType: MercuryFocusAreaType;
};

export type MercuryPortfolioFunding = {
    __typename?: "MercuryPortfolioFunding";
    aggregation?: Maybe<MercuryPortfolioFundingAggregation>;
};

export type MercuryPortfolioFundingAggregation = {
    __typename?: "MercuryPortfolioFundingAggregation";
    budgetAggregation?: Maybe<MercuryPortfolioBudgetAggregation>;
    spendAggregation?: Maybe<MercuryPortfolioSpendAggregation>;
};

export type MercuryPortfolioHumanResourceAllocations = {
    __typename?: "MercuryPortfolioHumanResourceAllocations";
    /** The budgeted positions is the total number of positions (or headcount) allotted to all the focus areas in a portfolio. */
    budgetedPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Actual amount of full-time equivalent positions contributing to all the focus areas in a portfolio. Can be fractional. */
    filledPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Unfilled or open positions, e.g. # of positions planned to hire. of all the focus areas in a portfolio. */
    openPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The total positions as a % of the budgeted positions. */
    totalAsPercentageOfBudget?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** `totalPositions = filledPositions + openPositions`. This can be above, equal to, or below the budgeted positions. */
    totalPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryPortfolioSpendAggregation = {
    __typename?: "MercuryPortfolioSpendAggregation";
    /** Aggregated of all spend from linked focus areas */
    aggregatedSpend?: Maybe<Scalars["BigDecimal"]["output"]>;
};

/**
 *  ------------------------------------------------------
 *   Preference
 *  ------------------------------------------------------
 */
export type MercuryPreference = Node & {
    __typename?: "MercuryPreference";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type MercuryProjectStatus = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mercuryColor?: Maybe<MercuryProjectStatusColor>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mercuryName?: Maybe<Scalars["String"]["output"]>;
};

export enum MercuryProjectStatusColor {
    Blue = "BLUE",
    Gray = "GRAY",
    Green = "GREEN",
    /** @deprecated Mercury does not require this colour */
    Red = "RED",
    /** @deprecated Mercury does not require this colour */
    Yellow = "YELLOW"
}

export enum MercuryProjectTargetDateType {
    Day = "DAY",
    Month = "MONTH",
    Quarter = "QUARTER"
}

/**
 *  ----------------------------------------
 *   Provider
 *  ----------------------------------------
 */
export type MercuryProvider = Node & {
    __typename?: "MercuryProvider";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    configurationState: MercuryProviderConfigurationState;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    documentationUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    logo: MercuryProviderMultiResolutionIcon;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

export type MercuryProviderAtlassianUser = {
    __typename?: "MercuryProviderAtlassianUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    accountStatus: AccountStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    picture?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryProviderConfigurationState = {
    __typename?: "MercuryProviderConfigurationState";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    actionUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status: MercuryProviderConfigurationStatus;
};

export enum MercuryProviderConfigurationStatus {
    Connected = "CONNECTED",
    SignUp = "SIGN_UP"
}

export type MercuryProviderConnection = {
    __typename?: "MercuryProviderConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<MercuryProviderEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryProviderDetails = {
    __typename?: "MercuryProviderDetails";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    logo: MercuryProviderMultiResolutionIcon;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

/**
 *  ----------------------------------------
 *   Provider Pagination
 *  ----------------------------------------
 */
export type MercuryProviderEdge = {
    __typename?: "MercuryProviderEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<MercuryProvider>;
};

export type MercuryProviderExternalOwner = {
    __typename?: "MercuryProviderExternalOwner";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryProviderExternalUser = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryProviderMultiResolutionIcon = {
    __typename?: "MercuryProviderMultiResolutionIcon";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    defaultUrl: Scalars["URL"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    large?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    medium?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    small?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    xlarge?: Maybe<Scalars["URL"]["output"]>;
};

export type MercuryProviderOrchestrationMutationApi = {
    __typename?: "MercuryProviderOrchestrationMutationApi";
    /**
     * Delete a link between a project and a focus area.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusAreaWorkLink' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Migration to use deleteFocusAreaWorkLinks instead
     */
    deleteFocusAreaWorkLink?: Maybe<MercuryDeleteFocusAreaWorkLinkPayload>;
    /**
     * Delete links between projects and a focus area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'deleteFocusAreaWorkLinks' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    deleteFocusAreaWorkLinks?: Maybe<MercuryDeleteFocusAreaWorkLinksPayload>;
    /**
     * Links a list of contributing 1p projects to a focus area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'linkAtlassianWorkToFocusArea' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    linkAtlassianWorkToFocusArea?: Maybe<MercuryLinkAtlassianWorkToFocusAreaPayload>;
    /**
     * Links a list of contributing projects to a focus area.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'linkWorkToFocusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Migration to use linkAtlassianWorkToFocusArea instead
     */
    linkWorkToFocusArea?: Maybe<MercuryLinkWorkToFocusAreaPayload>;
};

export type MercuryProviderOrchestrationMutationApiDeleteFocusAreaWorkLinkArgs =
    {
        input: MercuryDeleteFocusAreaWorkLinkInput;
    };

export type MercuryProviderOrchestrationMutationApiDeleteFocusAreaWorkLinksArgs =
    {
        input: MercuryDeleteFocusAreaWorkLinksInput;
    };

export type MercuryProviderOrchestrationMutationApiLinkAtlassianWorkToFocusAreaArgs =
    {
        input: MercuryLinkAtlassianWorkToFocusAreaInput;
    };

export type MercuryProviderOrchestrationMutationApiLinkWorkToFocusAreaArgs = {
    input: MercuryLinkWorkToFocusAreaInput;
};

export type MercuryProviderOrchestrationQueryApi = {
    __typename?: "MercuryProviderOrchestrationQueryApi";
    /**
     * Checks if the given provider workspaces are connected to Focus.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isWorkspaceConnected: Array<MercuryWorkspaceConnectionStatus>;
};

export type MercuryProviderOrchestrationQueryApiIsWorkspaceConnectedArgs = {
    cloudId: Scalars["ID"]["input"];
    workspaceAris: Array<Scalars["String"]["input"]>;
};

export type MercuryProviderUser = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    picture?: Maybe<Scalars["String"]["output"]>;
};

/**
 *  ----------------------------------------
 *   Provider Work
 *  ----------------------------------------
 */
export type MercuryProviderWork = {
    __typename?: "MercuryProviderWork";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    externalOwner?: Maybe<MercuryProviderExternalOwner>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    icon?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    owner?: Maybe<MercuryProviderAtlassianUser>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    providerDetails?: Maybe<MercuryProviderDetails>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status?: Maybe<MercuryProviderWorkStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    targetDate?: Maybe<MercuryProviderWorkTargetDate>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type MercuryProviderWorkConnection = {
    __typename?: "MercuryProviderWorkConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<MercuryProviderWorkEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/**
 *  ----------------------------------------
 *   Provider Work Pagination
 *  ----------------------------------------
 */
export type MercuryProviderWorkEdge = {
    __typename?: "MercuryProviderWorkEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<MercuryWorkResult>;
};

export type MercuryProviderWorkError = Node & {
    __typename?: "MercuryProviderWorkError";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType: MercuryProviderWorkErrorType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    providerDetails?: Maybe<MercuryProviderDetails>;
};

export enum MercuryProviderWorkErrorType {
    Invalid = "INVALID",
    NotFound = "NOT_FOUND",
    NoPermissions = "NO_PERMISSIONS"
}

export type MercuryProviderWorkStatus = {
    __typename?: "MercuryProviderWorkStatus";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    color: MercuryProviderWorkStatusColor;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

export enum MercuryProviderWorkStatusColor {
    Blue = "BLUE",
    Gray = "GRAY",
    Green = "GREEN",
    Red = "RED",
    Yellow = "YELLOW"
}

export type MercuryProviderWorkTargetDate = {
    __typename?: "MercuryProviderWorkTargetDate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    targetDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    targetDateType?: Maybe<MercuryProviderWorkTargetDateType>;
};

export enum MercuryProviderWorkTargetDateType {
    Day = "DAY",
    Month = "MONTH",
    Quarter = "QUARTER"
}

export type MercuryQueryApi = {
    __typename?: "MercuryQueryApi";
    /**
     * Get a list of Focus Area Total Allocation Aggregations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'aggregatedHeadcounts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    aggregatedHeadcounts?: Maybe<MercuryAggregatedHeadcountConnection>;
    /**
     * Provides an AI generated summary of the Focus Area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'aiFocusAreaSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    aiFocusAreaSummary?: Maybe<MercuryFocusAreaSummary>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'comments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    comments?: Maybe<MercuryCommentConnection>;
    /**
     * Get a Focus Area by ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusArea' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusArea?: Maybe<MercuryFocusArea>;
    /**
     * Get activity history for a focus area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusAreaActivityHistory' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    focusAreaActivityHistory?: Maybe<MercuryFocusAreaActivityConnection>;
    /**
     * Get a hierarchical view of a focus area and the focus areas linked to it.
     * Will return the entire org view if the optional parameter is not supplied.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusAreaHierarchy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaHierarchy?: Maybe<Array<Maybe<MercuryFocusAreaHierarchyNode>>>;
    /**
     * Get a list of Focus Area status transition. A status transition represents
     * the combination of status, e.g. `pending` and health, e.g. `on_track`.
     *
     * This API should be used by e.g. list/search pages to build filter lists.
     * For individual transitions available to a Focus Area use the `statusTransitions`
     * field on the Focus Area instead.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusAreaStatusTransitions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaStatusTransitions?: Maybe<Array<MercuryFocusAreaStatusTransition>>;
    /**
     * Get all team allocation aggregations for a focus area.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusAreaTeamAllocations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaTeamAllocations?: Maybe<MercuryFocusAreaTeamAllocationAggregationConnection>;
    /**
     * Get a list of all configured Focus Area types, e.g. 'Portfolio', 'Initiative'.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusAreaTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    focusAreaTypes?: Maybe<Array<MercuryFocusAreaType>>;
    /**
     * Get a list of Focus Area Types by ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    focusAreaTypesByAris?: Maybe<Array<Maybe<MercuryFocusAreaType>>>;
    /**
     * Filter a list of Focus Areas based on query and sort criteria
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'focusAreas' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    focusAreas?: Maybe<MercuryFocusAreaConnection>;
    /**
     * Get a list of Focus Area's by ARI's
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    focusAreasByAris?: Maybe<Array<MercuryFocusArea>>;
    /**
     * Get a list of Focus Areas by external IDs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    focusAreasByExternalIds?: Maybe<Array<Maybe<MercuryFocusArea>>>;
    /**
     * Get Activity History for Focus Areas owned and watched by the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'forYouFocusAreaActivityHistory' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    forYouFocusAreaActivityHistory?: Maybe<MercuryForYouFocusAreaActivityHistory>;
    /**
     * Returns status aggregations for all top level goals linked to focus areas
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'goalStatusAggregationsForAllFocusAreas' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    goalStatusAggregationsForAllFocusAreas?: Maybe<MercuryGoalStatusCount>;
    /**
     * Provides a media ASAP bearer token with read permissions.
     * Entity Id represents the media collection Id where the media is stored. The entity type
     * should match the entity Id provided.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'mediaReadToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mediaReadToken?: Maybe<MercuryMediaToken>;
    /**
     * Provides a media ASAP bearer token with read and write permissions.
     * Entity Id represents the collection Id where the media will be stored or read from. The entity
     * type should match the entity Id provided.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'mediaUploadToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mediaUploadToken?: Maybe<MercuryMediaToken>;
    /**
     * Get a user's preferences for a key.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'myPreference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    myPreference?: Maybe<MercuryPreference>;
    /**
     * Get all of a user's preferences.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'myPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    myPreferences?: Maybe<Array<MercuryPreference>>;
    /**
     * Get a list of Portfolios by ARIs
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    portfoliosByAris?: Maybe<Array<MercuryPortfolio>>;
    /**
     * Get team by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'team' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    team?: Maybe<MercuryTeam>;
    /**
     * Searches teams by name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'teams' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    teams?: Maybe<MercuryTeamConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'workspaceContext' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    workspaceContext: MercuryWorkspaceContext;
};

export type MercuryQueryApiAggregatedHeadcountsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryAggregatedHeadcountSort>>>;
};

export type MercuryQueryApiAiFocusAreaSummaryArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryQueryApiCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: MercuryEntityType;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MercuryQueryApiFocusAreaArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryQueryApiFocusAreaActivityHistoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    focusAreaId: Scalars["ID"]["input"];
    sort?: InputMaybe<Array<InputMaybe<MercuryFocusAreaActivitySort>>>;
};

export type MercuryQueryApiFocusAreaHierarchyArgs = {
    cloudId: Scalars["ID"]["input"];
    id?: InputMaybe<Scalars["ID"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryFocusAreaHierarchySort>>>;
};

export type MercuryQueryApiFocusAreaStatusTransitionsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MercuryQueryApiFocusAreaTeamAllocationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    focusAreaId: Scalars["ID"]["input"];
    sort?: InputMaybe<
        Array<InputMaybe<MercuryFocusAreaTeamAllocationAggregationSort>>
    >;
};

export type MercuryQueryApiFocusAreaTypesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MercuryQueryApiFocusAreaTypesByArisArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type MercuryQueryApiFocusAreasArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryFocusAreaSort>>>;
};

export type MercuryQueryApiFocusAreasByArisArgs = {
    aris?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MercuryQueryApiFocusAreasByExternalIdsArgs = {
    cloudId: Scalars["ID"]["input"];
    ids: Array<Scalars["String"]["input"]>;
};

export type MercuryQueryApiForYouFocusAreaActivityHistoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    focusAreaFirst?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryFocusAreaActivitySort>>>;
};

export type MercuryQueryApiGoalStatusAggregationsForAllFocusAreasArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MercuryQueryApiMediaReadTokenArgs = {
    cloudId: Scalars["ID"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: MercuryEntityType;
};

export type MercuryQueryApiMediaUploadTokenArgs = {
    cloudId: Scalars["ID"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: MercuryEntityType;
};

export type MercuryQueryApiMyPreferenceArgs = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
};

export type MercuryQueryApiMyPreferencesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MercuryQueryApiPortfoliosByArisArgs = {
    aris?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MercuryQueryApiTeamArgs = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryQueryApiTeamsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryTeamSort>>>;
};

export type MercuryQueryApiWorkspaceContextArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MercuryRecreatePortfolioFocusAreasInput = {
    cloudId: Scalars["ID"]["input"];
    focusAreaIds: Array<Scalars["ID"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type MercuryRemoveWatcherFromFocusAreaInput = {
    cloudId: Scalars["ID"]["input"];
    focusAreaId: Scalars["ID"]["input"];
    userId: Scalars["ID"]["input"];
};

export type MercuryRemoveWatcherFromFocusAreaPayload = Payload & {
    __typename?: "MercuryRemoveWatcherFromFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/**
 *  ----------------------------------------
 *   Preference Mutations
 *  ----------------------------------------
 */
export type MercurySetPreferenceInput = {
    cloudId: Scalars["ID"]["input"];
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type MercurySetPreferencePayload = Payload & {
    __typename?: "MercurySetPreferencePayload";
    errors?: Maybe<Array<MutationError>>;
    preference?: Maybe<MercuryPreference>;
    success: Scalars["Boolean"]["output"];
};

export type MercurySpendAggregation = {
    __typename?: "MercurySpendAggregation";
    /** Aggregated of all spend from linked focus areas */
    aggregatedSpend?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Assigned + aggregated spend for a focus area */
    totalAssignedSpend?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryStrategicEvent = Node & {
    __typename?: "MercuryStrategicEvent";
    /** The ARI of the Strategic Event. */
    id: Scalars["ID"]["output"];
    /** The name of the Strategic Event. */
    name: Scalars["String"]["output"];
    /** The status of the Strategic Event. */
    status?: Maybe<MercuryStrategicEventStatus>;
    /** The status transitions available to the current user. */
    statusTransitions?: Maybe<MercuryStrategicEventStatusTransitions>;
    /** The target date of the Strategic Event. */
    targetDate?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryStrategicEventConnection = {
    __typename?: "MercuryStrategicEventConnection";
    edges?: Maybe<Array<Maybe<MercuryStrategicEventEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryStrategicEventEdge = {
    __typename?: "MercuryStrategicEventEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryStrategicEvent>;
};

export type MercuryStrategicEventSort = {
    field: MercuryStrategicEventSortField;
    order: SortOrder;
};

export enum MercuryStrategicEventSortField {
    Name = "NAME",
    Status = "STATUS",
    TargetDate = "TARGET_DATE"
}

export type MercuryStrategicEventStatus = {
    __typename?: "MercuryStrategicEventStatus";
    color: Scalars["String"]["output"];
    displayName: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
};

export type MercuryStrategicEventStatusTransition = {
    __typename?: "MercuryStrategicEventStatusTransition";
    id: Scalars["ID"]["output"];
    to: MercuryStrategicEventStatus;
};

export type MercuryStrategicEventStatusTransitions = {
    __typename?: "MercuryStrategicEventStatusTransitions";
    available: Array<MercuryStrategicEventStatusTransition>;
};

export type MercuryStrategicEventsMutationApi = {
    __typename?: "MercuryStrategicEventsMutationApi";
    /**
     * Creates a new Change Proposal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createChangeProposal?: Maybe<MercuryCreateChangeProposalPayload>;
    /**
     * Creates a new Strategic Event.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createStrategicEvent?: Maybe<MercuryCreateStrategicEventPayload>;
};

export type MercuryStrategicEventsMutationApiCreateChangeProposalArgs = {
    input: MercuryCreateChangeProposalInput;
};

export type MercuryStrategicEventsMutationApiCreateStrategicEventArgs = {
    input: MercuryCreateStrategicEventInput;
};

export type MercuryStrategicEventsQueryApi = {
    __typename?: "MercuryStrategicEventsQueryApi";
    /**
     * Get a Change Proposal by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'changeProposal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    changeProposal?: Maybe<MercuryChangeProposal>;
    /**
     * Get a list of Change Proposal statuses.
     *
     * This API should be used by e.g. list/search pages to build filter lists.
     * For status transitions available to a Change Proposal for the current
     * user, use the `statusTransitions` field on the Change Proposal instead.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'changeProposalStatuses' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    changeProposalStatuses: Array<MercuryChangeProposalStatus>;
    /**
     * Get Change Proposals by ARI's
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'changeProposals' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    changeProposals?: Maybe<Array<Maybe<MercuryChangeProposal>>>;
    /**
     * Filter a list of Change Proposals based on query and sort criteria.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'changeProposalsSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    changeProposalsSearch?: Maybe<MercuryChangeProposalConnection>;
    /**
     * Get a Strategic Event by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'strategicEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    strategicEvent?: Maybe<MercuryStrategicEvent>;
    /**
     * Get a list of Strategic Event statuses.
     *
     * This API should be used by e.g. list/search pages to build filter lists.
     * For status transitions available to a Strategic Event for the current
     * user, use the `statusTransitions` field on the Strategic Event instead.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'strategicEventStatuses' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    strategicEventStatuses: Array<MercuryStrategicEventStatus>;
    /**
     * Get Strategic Events by ARI's.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'strategicEvents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    strategicEvents?: Maybe<Array<Maybe<MercuryStrategicEvent>>>;
    /**
     * Filter a list of Strategic Events based on query and sort criteria.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'strategicEventsSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    strategicEventsSearch?: Maybe<MercuryStrategicEventConnection>;
    /**
     * Applies a Strategic Event status transition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'transitionChangeProposalStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    transitionChangeProposalStatus?: Maybe<MercuryTransitionChangeProposalPayload>;
    /**
     * Applies a Strategic Event status transition.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Mercury")' query directive to the 'transitionStrategicEventStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    transitionStrategicEventStatus?: Maybe<MercuryTransitionStrategicEventPayload>;
};

export type MercuryStrategicEventsQueryApiChangeProposalArgs = {
    id: Scalars["ID"]["input"];
};

export type MercuryStrategicEventsQueryApiChangeProposalStatusesArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MercuryStrategicEventsQueryApiChangeProposalsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type MercuryStrategicEventsQueryApiChangeProposalsSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryChangeProposalSort>>>;
};

export type MercuryStrategicEventsQueryApiStrategicEventArgs = {
    id: Scalars["ID"]["input"];
};

export type MercuryStrategicEventsQueryApiStrategicEventStatusesArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MercuryStrategicEventsQueryApiStrategicEventsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type MercuryStrategicEventsQueryApiStrategicEventsSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryStrategicEventSort>>>;
};

export type MercuryStrategicEventsQueryApiTransitionChangeProposalStatusArgs = {
    input: MercuryTransitionChangeProposalStatusInput;
};

export type MercuryStrategicEventsQueryApiTransitionStrategicEventStatusArgs = {
    input: MercuryTransitionStrategicEventStatusInput;
};

export type MercuryTargetDate = {
    __typename?: "MercuryTargetDate";
    targetDate?: Maybe<Scalars["String"]["output"]>;
    targetDateType?: Maybe<MercuryTargetDateType>;
};

export enum MercuryTargetDateType {
    Day = "DAY",
    Month = "MONTH",
    Quarter = "QUARTER"
}

export type MercuryTeam = Node & {
    __typename?: "MercuryTeam";
    /** The number of filled positions for the team. */
    filledPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The ID of the team. */
    id: Scalars["ID"]["output"];
    /** The name of the team. */
    name: Scalars["String"]["output"];
    /** The number of open positions for the team. */
    openPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** Allocation of a team's capacity to focus areas. */
    teamFocusAreaAllocations: MercuryTeamFocusAreaAllocationConnection;
};

export type MercuryTeamTeamFocusAreaAllocationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<MercuryTeamFocusAreaAllocationsSort>>>;
};

export type MercuryTeamConnection = {
    __typename?: "MercuryTeamConnection";
    edges?: Maybe<Array<Maybe<MercuryTeamEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryTeamEdge = {
    __typename?: "MercuryTeamEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryTeam>;
};

/** Team's capacity for allocation to a focus area. */
export type MercuryTeamFocusAreaAllocation = Node & {
    __typename?: "MercuryTeamFocusAreaAllocation";
    /** The number of filled positions for a team's allocation to a focus area. */
    filledPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
    /** The focus area that the team is allocated to. */
    focusArea: MercuryFocusArea;
    /** The ID of the allocation. */
    id: Scalars["ID"]["output"];
    /** The number of unfilled or open positions for a team's allocation to a focus area. */
    openPositions?: Maybe<Scalars["BigDecimal"]["output"]>;
};

export type MercuryTeamFocusAreaAllocationConnection = {
    __typename?: "MercuryTeamFocusAreaAllocationConnection";
    edges?: Maybe<Array<Maybe<MercuryTeamFocusAreaAllocationEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryTeamFocusAreaAllocationEdge = {
    __typename?: "MercuryTeamFocusAreaAllocationEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<MercuryTeamFocusAreaAllocation>;
};

export enum MercuryTeamFocusAreaAllocationSortField {
    FilledPositions = "FILLED_POSITIONS",
    OpenPositions = "OPEN_POSITIONS"
}

export type MercuryTeamFocusAreaAllocationsSort = {
    field?: InputMaybe<MercuryTeamFocusAreaAllocationSortField>;
    order: SortOrder;
};

export type MercuryTeamSort = {
    field?: InputMaybe<MercuryTeamSortField>;
    order: SortOrder;
};

/**
 *  ------------------------------------------------------
 *   Team
 *  ------------------------------------------------------
 */
export enum MercuryTeamSortField {
    Name = "NAME"
}

export type MercuryTransitionChangeProposalPayload = Payload & {
    __typename?: "MercuryTransitionChangeProposalPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedChangeProposal?: Maybe<MercuryChangeProposal>;
};

export type MercuryTransitionChangeProposalStatusInput = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the Change Proposal to transition. */
    id: Scalars["ID"]["input"];
    /** The ID of the status transition to apply. */
    statusTransitionId: Scalars["ID"]["input"];
};

/**
 *  ----------------------------------------
 *   Focus Area workflow mutations
 *  ----------------------------------------
 */
export type MercuryTransitionFocusAreaStatusInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    statusTransitionId: Scalars["ID"]["input"];
};

export type MercuryTransitionStrategicEventPayload = Payload & {
    __typename?: "MercuryTransitionStrategicEventPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedStrategicEvent?: Maybe<MercuryStrategicEvent>;
};

export type MercuryTransitionStrategicEventStatusInput = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The ID of the Strategic Event to transition. */
    id: Scalars["ID"]["input"];
    /** The ID of the status transition to apply. */
    statusTransitionId: Scalars["ID"]["input"];
};

export type MercuryUpdateCommentInput = {
    cloudId: Scalars["ID"]["input"];
    commentText: Scalars["MercuryJSONString"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryUpdateCommentPayload = Payload & {
    __typename?: "MercuryUpdateCommentPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedComment?: Maybe<MercuryComment>;
};

export type MercuryUpdateFocusAreaAboutContentInput = {
    aboutContent: Scalars["String"]["input"];
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryUpdateFocusAreaNameInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    name: Scalars["String"]["input"];
};

export type MercuryUpdateFocusAreaOwnerInput = {
    aaid: Scalars["String"]["input"];
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
};

export type MercuryUpdateFocusAreaPayload = Payload & {
    __typename?: "MercuryUpdateFocusAreaPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedFocusArea?: Maybe<MercuryFocusArea>;
};

export type MercuryUpdateFocusAreaStatusUpdateInput = {
    cloudId: Scalars["ID"]["input"];
    /** The ID of the Focus Area status update entry. */
    id: Scalars["ID"]["input"];
    /** The new target date for the Focus Area. */
    newTargetDate?: InputMaybe<MercuryFocusAreaTargetDateInput>;
    /** The ID of the status to transition the Focus Area to as part of the update. */
    statusTransitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Summary text (ADF) for the update. */
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type MercuryUpdateFocusAreaStatusUpdatePayload = Payload & {
    __typename?: "MercuryUpdateFocusAreaStatusUpdatePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedFocusAreaStatusUpdate?: Maybe<MercuryFocusAreaStatusUpdate>;
};

export type MercuryUpdateFocusAreaTargetDateInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    targetDate?: InputMaybe<Scalars["String"]["input"]>;
    targetDateType?: InputMaybe<MercuryTargetDateType>;
};

export type MercuryUpdatePortfolioNameInput = {
    cloudId: Scalars["ID"]["input"];
    id: Scalars["ID"]["input"];
    name: Scalars["String"]["input"];
};

export type MercuryUpdatePortfolioPayload = Payload & {
    __typename?: "MercuryUpdatePortfolioPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
    updatedPortfolio?: Maybe<MercuryPortfolio>;
};

export type MercuryUpdatedField = {
    __typename?: "MercuryUpdatedField";
    /** The field that was changed */
    field?: Maybe<Scalars["String"]["output"]>;
    /** The type of the field that was changed */
    fieldType?: Maybe<Scalars["String"]["output"]>;
    /** Optional union field that contains data hydrated through AGG from other services */
    newData?: Maybe<MercuryActivityHistoryData>;
    /** A user-facing representation of the new value */
    newString?: Maybe<Scalars["String"]["output"]>;
    /** The system identifier for the new value */
    newValue?: Maybe<Scalars["String"]["output"]>;
    /** Optional union field that contains data hydrated through AGG from other services */
    oldData?: Maybe<MercuryActivityHistoryData>;
    /** A user-facing representation of the old value */
    oldString?: Maybe<Scalars["String"]["output"]>;
    /** The system identifier for the old value */
    oldValue?: Maybe<Scalars["String"]["output"]>;
};

export type MercuryUserConnection = {
    __typename?: "MercuryUserConnection";
    edges?: Maybe<Array<Maybe<MercuryUserEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type MercuryUserEdge = {
    __typename?: "MercuryUserEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<User>;
};

export type MercuryWorkResult = MercuryProviderWork | MercuryProviderWorkError;

export type MercuryWorkspaceConnectionStatus = {
    __typename?: "MercuryWorkspaceConnectionStatus";
    /** Whether the workspace is connected to Focus. */
    isConnected: Scalars["Boolean"]["output"];
    /** The workspace ARI. */
    workspaceAri: Scalars["String"]["output"];
};

export type MercuryWorkspaceContext = {
    __typename?: "MercuryWorkspaceContext";
    activationId: Scalars["String"]["output"];
    aiEnabled: Scalars["Boolean"]["output"];
    cloudId: Scalars["String"]["output"];
};

export type MigrateComponentTypeInput = {
    /** The ID of the component type to which components will be migrated. */
    destinationTypeId: Scalars["ID"]["input"];
    /** The ID of the component type from which components will be migrated. */
    sourceTypeId: Scalars["ID"]["input"];
};

export type MigrateComponentTypePayload = Payload & {
    __typename?: "MigrateComponentTypePayload";
    /** The number of components affected by the mutation. */
    affectedComponentsCount?: Maybe<Scalars["Int"]["output"]>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The number of components failed. */
    failedComponentsCount?: Maybe<Scalars["Int"]["output"]>;
    /** Whether there are more components to migrate. Call migrateComponentType again to continue until hasMore is false. */
    hasMore?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type MigrateSpaceShortcutsPayload = {
    __typename?: "MigrateSpaceShortcutsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    parentPageId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    smartLinksContentList: Array<Maybe<GraphQlSmartLinkContent>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** A type that represents a migration. */
export type Migration = {
    __typename?: "Migration";
    /** The estimation of how long a migration should take. */
    estimation?: Maybe<MigrationEstimation>;
    /** The ID of the migration. */
    id: Scalars["ID"]["output"];
};

export type MigrationCatalogueQuery = {
    __typename?: "MigrationCatalogueQuery";
    /**
     * The migration ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    migrationId: Scalars["ID"]["output"];
};

/** A type that represents the estimation of a migration. */
export type MigrationEstimation = {
    __typename?: "MigrationEstimation";
    /** The lower bound of the estimation. */
    lower: Scalars["Float"]["output"];
    /** The middle bound of the estimation. */
    middle: Scalars["Float"]["output"];
    /** The upper bound of the estimation. */
    upper: Scalars["Float"]["output"];
};

/** A type that represents a migration event. */
export type MigrationEvent = {
    __typename?: "MigrationEvent";
    /** The created time of the event in the ISO 8601 format. */
    createdAtISO8601: Scalars["String"]["output"];
    /** The unique identifier of the event. */
    eventId: Scalars["ID"]["output"];
    /**
     * The source of the event.
     * Possible values include, but are not limited to
     *   * MO
     *   * AMS
     *   * UNKNOWN
     */
    eventSource: Scalars["String"]["output"];
    /** The event type. */
    eventType: MigrationEventType;
    /** The ID of the associated migration. */
    migrationId: Scalars["ID"]["output"];
    /** The event status. */
    status: MigrationEventStatus;
    /** The optional status message. */
    statusMessage?: Maybe<Scalars["String"]["output"]>;
};

/** An enum of the possible statuses of a migration event. */
export enum MigrationEventStatus {
    Cancelled = "CANCELLED",
    Cancelling = "CANCELLING",
    Failed = "FAILED",
    Incomplete = "INCOMPLETE",
    InProgress = "IN_PROGRESS",
    Paused = "PAUSED",
    Ready = "READY",
    Skipped = "SKIPPED",
    Success = "SUCCESS",
    TimedOut = "TIMED_OUT"
}

/** An enum of the possible types of a migration event. */
export enum MigrationEventType {
    Container = "CONTAINER",
    Migration = "MIGRATION",
    Transfer = "TRANSFER"
}

export type MigrationKeys = {
    __typename?: "MigrationKeys";
    confluence: Scalars["String"]["output"];
    jira: Scalars["String"]["output"];
};

/** A type that represents a migrationPlanningService event. */
export type MigrationPlanningServiceDataScopeChangedEvent = {
    __typename?: "MigrationPlanningServiceDataScopeChangedEvent";
    /** The ID of the data scope which defines the scope for a migration plan */
    dataScopeId: Scalars["ID"]["output"];
    /** The ID of the organization the data scope belongs to. */
    orgId: Scalars["ID"]["output"];
    /** Type of change the event refers to (e.g. dataScope.created, dataScope.updated, dataScope.deleted) */
    type?: Maybe<Scalars["String"]["output"]>;
};

export type MigrationPlanningServiceQuery = {
    __typename?: "MigrationPlanningServiceQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    dummy?: Maybe<Scalars["String"]["output"]>;
};

/** The top-level migrationPlanningService subscription type. */
export type MigrationPlanningServiceSubscription = {
    __typename?: "MigrationPlanningServiceSubscription";
    /**
     * A subscription field that subscribes to the creation of migrationPlanningService events.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onDataScopeChanged: MigrationPlanningServiceDataScopeChangedEvent;
};

/** The top-level migrationPlanningService subscription type. */
export type MigrationPlanningServiceSubscriptionOnDataScopeChangedArgs = {
    orgId: Scalars["ID"]["input"];
};

/** A type that represents a migration progress event. */
export type MigrationProgressEvent = {
    __typename?: "MigrationProgressEvent";
    /** The business status of the event. */
    businessStatus?: Maybe<MigrationEventStatus>;
    /** The created time of the event in the ISO 8601 format. */
    createdAtISO8601: Scalars["String"]["output"];
    /** The custom business status of the event. */
    customBusinessStatus?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier of the event. */
    eventId: Scalars["ID"]["output"];
    /**
     * The source of the event.
     * Possible values include, but are not limited to
     *   * MO
     *   * AMS
     *   * UNKNOWN
     */
    eventSource: Scalars["String"]["output"];
    /** The event type. */
    eventType?: Maybe<MigrationEventType>;
    /** The execution status of the event. */
    executionStatus?: Maybe<MigrationEventStatus>;
    /** The ID of the associated migration. */
    migrationId: Scalars["ID"]["output"];
    /** The optional status message. */
    statusMessage?: Maybe<Scalars["String"]["output"]>;
};

/** The top-level migration query type. */
export type MigrationQuery = {
    __typename?: "MigrationQuery";
    /**
     * Fetch a migration by ID.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    migration?: Maybe<Migration>;
};

/** The top-level migration query type. */
export type MigrationQueryMigrationArgs = {
    migrationId: Scalars["ID"]["input"];
};

/** The top-level migration subscription type. */
export type MigrationSubscription = {
    __typename?: "MigrationSubscription";
    /**
     * A subscription field that subscribes to the creation of migration events.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onMigrationEventCreated: MigrationEvent;
    /**
     * A subscription field that subscribes to the creation of migration progress events.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onMigrationProgressEventCreated: MigrationProgressEvent;
};

/** The top-level migration subscription type. */
export type MigrationSubscriptionOnMigrationEventCreatedArgs = {
    migrationId: Scalars["ID"]["input"];
};

/** The top-level migration subscription type. */
export type MigrationSubscriptionOnMigrationProgressEventCreatedArgs = {
    migrationId: Scalars["ID"]["input"];
};

export enum MissionControlFeatureDiscoverySuggestion {
    SpaceManager = "SPACE_MANAGER",
    SpaceReports = "SPACE_REPORTS",
    UserAccess = "USER_ACCESS"
}

export type MissionControlFeatureDiscoverySuggestionInput = {
    /** Date & time of dismissal in mm/dd/yyyy hh:mm:ss */
    dismissalDateTime?: InputMaybe<Scalars["String"]["input"]>;
    suggestion: MissionControlFeatureDiscoverySuggestion;
    /** Timezone for dismissalDateTime. If null, timezone will default to UTC */
    timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type MissionControlFeatureDiscoverySuggestionState = {
    __typename?: "MissionControlFeatureDiscoverySuggestionState";
    dismissalDateTime?: Maybe<Scalars["String"]["output"]>;
    suggestion: MissionControlFeatureDiscoverySuggestion;
};

export enum MissionControlMetricSuggestion {
    DeactivatedPageOwners = "DEACTIVATED_PAGE_OWNERS",
    InactivePages = "INACTIVE_PAGES",
    UnassignedGuests = "UNASSIGNED_GUESTS"
}

export type MissionControlMetricSuggestionInput = {
    /** Date & time of dismissal in mm/dd/yyyy hh:mm:ss */
    dismissalDateTime?: InputMaybe<Scalars["String"]["input"]>;
    /** spaceId of suggestion, should be set to null if suggestion applies to site-wide Mission Control */
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
    suggestion: MissionControlMetricSuggestion;
    /** Timezone for dismissalDateTime. If null, timezone will default to UTC */
    timezone?: InputMaybe<Scalars["String"]["input"]>;
    /** Value of metric-based suggestion, either percentage or count */
    value: Scalars["Int"]["input"];
};

export type MissionControlMetricSuggestionState = {
    __typename?: "MissionControlMetricSuggestionState";
    dismissalDateTime?: Maybe<Scalars["String"]["output"]>;
    spaceId?: Maybe<Scalars["Long"]["output"]>;
    suggestion: MissionControlMetricSuggestion;
    value?: Maybe<Scalars["Int"]["output"]>;
};

export type MissionControlOverview = {
    metricOrder: Array<InputMaybe<Scalars["String"]["input"]>>;
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
};

export enum MobilePlatform {
    Android = "ANDROID",
    Ios = "IOS"
}

export type ModuleCompleteKey = {
    __typename?: "ModuleCompleteKey";
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    pluginKey?: Maybe<Scalars["String"]["output"]>;
};

export type MoveBlogInput = {
    blogPostId: Scalars["Long"]["input"];
    targetSpaceId: Scalars["Long"]["input"];
};

export type MoveBlogPayload = {
    __typename?: "MoveBlogPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content?: Maybe<Content>;
};

/** Card mutations response */
export type MoveCardOutput = {
    __typename?: "MoveCardOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issuesWereTransitioned?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MovePageAsChildInput = {
    pageId: Scalars["ID"]["input"];
    parentId: Scalars["ID"]["input"];
};

export type MovePageAsSiblingInput = {
    pageId: Scalars["ID"]["input"];
    siblingId: Scalars["ID"]["input"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type MovePagePayload = {
    __typename?: "MovePagePayload";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    movedPage: Scalars["ID"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    page?: Maybe<Page>;
};

export type MovePageTopLevelInput = {
    pageId: Scalars["ID"]["input"];
    targetSpaceKey: Scalars["String"]["input"];
};

/** Move sprint down */
export type MoveSprintDownInput = {
    boardId: Scalars["ID"]["input"];
    sprintId: Scalars["ID"]["input"];
};

export type MoveSprintDownResponse = MutationResponse & {
    __typename?: "MoveSprintDownResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Move sprint up */
export type MoveSprintUpInput = {
    boardId: Scalars["ID"]["input"];
    sprintId: Scalars["ID"]["input"];
};

export type MoveSprintUpResponse = MutationResponse & {
    __typename?: "MoveSprintUpResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type Mutation = {
    __typename?: "Mutation";
    /**
     * Mutation actions on an actionable app
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __pullrequest:write__
     *
     *
     */
    actions?: Maybe<ActionsMutation>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'activatePaywallContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    activatePaywallContent?: Maybe<ActivatePaywallContentPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "polaris-v0")' query directive to the 'addBetaUserAsSiteCreator' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    addBetaUserAsSiteCreator?: Maybe<AddBetaUserAsSiteCreatorPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'addDefaultExCoSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    addDefaultExCoSpacePermissions?: Maybe<AddDefaultExCoSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'addLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    addLabels?: Maybe<AddLabelsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'addPublicLinkPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    addPublicLinkPermissions?: Maybe<AddPublicLinkPermissionsPayload>;
    addReaction?: Maybe<SaveReactionResponse>;
    /**
     * Mutation to create a new agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_createAgent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_createAgent?: Maybe<AgentStudioCreateAgentPayload>;
    /**
     * Mutation to configure agent actions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_updateAgentActions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_updateAgentActions?: Maybe<AgentStudioUpdateAgentActionsPayload>;
    /**
     * Mutation to update basic details of an agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_updateAgentDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_updateAgentDetails?: Maybe<AgentStudioUpdateAgentDetailsPayload>;
    /**
     * Mutation to update knowledge sources for an agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_updateAgentKnowledgeSources' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_updateAgentKnowledgeSources?: Maybe<AgentStudioUpdateAgentKnowledgeSourcesPayload>;
    /**
     * Mutation to update conversation starters of an agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_updateConversationStarters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_updateConversationStarters?: Maybe<AgentStudioUpdateConversationStartersPayload>;
    /**
     * Untyped entity storage mutations
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __storage:app__
     *
     *
     */
    appStorage?: Maybe<AppStorageMutation>;
    /**
     * Custom entity storage mutations
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __storage:app__
     *
     *
     */
    appStorageCustomEntity?: Maybe<AppStorageCustomEntityMutation>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    applyPolarisProjectTemplate?: Maybe<ApplyPolarisProjectTemplatePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'archivePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    archivePages?: Maybe<BulkArchivePagePayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    archivePolarisInsights?: Maybe<ArchivePolarisInsightsPayload>;
    /**
     * Allows to archive a space
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'archiveSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    archiveSpace?: Maybe<ArchiveSpacePayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    assignIssueParent?: Maybe<AssignIssueParentOutput>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'attachDanglingComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    attachDanglingComment?: Maybe<Comment>;
    /**
     * This mutation is currently in BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: boardCardMove` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    boardCardMove?: Maybe<MoveCardOutput>;
    /**
     * GraphQL mutation to delete classification level for content with multiple content statuses.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkDeleteContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkDeleteContentDataClassificationLevel?: Maybe<BulkDeleteContentDataClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkRemoveRoleAssignmentFromSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkRemoveRoleAssignmentFromSpaces?: Maybe<BulkRemoveRoleAssignmentFromSpacesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkSetRoleAssignmentToSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkSetRoleAssignmentToSpaces?: Maybe<BulkSetRoleAssignmentToSpacesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkSetSpacePermission' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkSetSpacePermission?: Maybe<BulkSetSpacePermissionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkSetSpacePermissionAsync' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkSetSpacePermissionAsync?: Maybe<BulkSetSpacePermissionAsyncPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkUnarchivePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkUnarchivePages?: Maybe<BulkArchivePagePayload>;
    /**
     * GraphQL mutation to set classification level for content for multiple content statuses.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkUpdateContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkUpdateContentDataClassificationLevel?: Maybe<BulkUpdateContentDataClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'bulkUpdateMainSpaceSidebarLinks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    bulkUpdateMainSpaceSidebarLinks?: Maybe<Array<Maybe<SpaceSidebarLink>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'clearRestrictionsForFree' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    clearRestrictionsForFree?: Maybe<ContentRestrictionsPageResponse>;
    compass?: Maybe<CompassCatalogMutationApi>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    completeSprint?: Maybe<CompleteSprintResponse>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    configurePolarisRefresh?: Maybe<ConfigurePolarisRefreshPayload>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: confluence-agg-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    confluence?: Maybe<ConfluenceMutationApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_activatePaywallContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_activatePaywallContent?: Maybe<ConfluenceLegacyActivatePaywallContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_addDefaultExCoSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_addDefaultExCoSpacePermissions?: Maybe<ConfluenceLegacyAddDefaultExCoSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_addLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_addLabels?: Maybe<ConfluenceLegacyAddLabelsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_addPublicLinkPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_addPublicLinkPermissions?: Maybe<ConfluenceLegacyAddPublicLinkPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_addReaction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_addReaction?: Maybe<ConfluenceLegacySaveReactionResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_archivePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_archivePages?: Maybe<ConfluenceLegacyBulkArchivePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_attachDanglingComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_attachDanglingComment?: Maybe<ConfluenceLegacyComment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkArchivePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use archivePages mutation instead
     */
    confluenceLegacy_bulkArchivePages?: Maybe<ConfluenceLegacyBulkArchivePagePayload>;
    /**
     * GraphQL mutation to delete classification level for content with multiple content statuses.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkDeleteContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_bulkDeleteContentDataClassificationLevel?: Maybe<ConfluenceLegacyBulkDeleteContentDataClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkSetSpacePermission' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_bulkSetSpacePermission?: Maybe<ConfluenceLegacyBulkSetSpacePermissionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkSetSpacePermissionAsync' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_bulkSetSpacePermissionAsync?: Maybe<ConfluenceLegacyBulkSetSpacePermissionAsyncPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkUnarchivePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_bulkUnarchivePages?: Maybe<ConfluenceLegacyBulkArchivePagePayload>;
    /**
     * GraphQL mutation to set classification level for content for multiple content statuses.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkUpdateContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_bulkUpdateContentDataClassificationLevel?: Maybe<ConfluenceLegacyBulkUpdateContentDataClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_bulkUpdateMainSpaceSidebarLinks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_bulkUpdateMainSpaceSidebarLinks?: Maybe<
        Array<Maybe<ConfluenceLegacySpaceSidebarLink>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_clearRestrictionsForFree' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_clearRestrictionsForFree?: Maybe<ConfluenceLegacyContentRestrictionsPageResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contactAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contactAdmin?: Maybe<ConfluenceLegacyContactAdminStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_convertPageToLiveEditAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_convertPageToLiveEditAction?: Maybe<ConfluenceLegacyConvertPageToLiveEditActionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_copyDefaultSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_copyDefaultSpacePermissions?: Maybe<ConfluenceLegacyCopySpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_copySpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_copySpacePermissions?: Maybe<ConfluenceLegacyCopySpacePermissionsPayload>;
    /**
     * Create a new banner
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createAdminAnnouncementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createAdminAnnouncementBanner?: Maybe<ConfluenceLegacyAdminAnnouncementBannerPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createContentContextual' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createContentContextual?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createContentGlobal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createContentGlobal?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createContentInline' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createContentInline?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createContentTemplateLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createContentTemplateLabels?: Maybe<ConfluenceLegacyPaginatedLabelList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createFaviconFiles' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createFaviconFiles?: Maybe<ConfluenceLegacyCreateFaviconFilesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createFooterComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createFooterComment?: Maybe<ConfluenceLegacyComment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createInlineComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createInlineComment?: Maybe<ConfluenceLegacyComment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createInlineTaskNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createInlineTaskNotification?: Maybe<ConfluenceLegacyCreateInlineTaskNotificationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createLivePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createLivePage?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createMentionNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createMentionNotification?: Maybe<ConfluenceLegacyCreateMentionNotificationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createMentionReminderNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createMentionReminderNotification?: Maybe<ConfluenceLegacyCreateMentionReminderNotificationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createOnboardingSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createOnboardingSpace?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createOrUpdateArchivePageNote' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use updateArchiveNotes mutation instead
     */
    confluenceLegacy_createOrUpdateArchivePageNote?: Maybe<
        Scalars["String"]["output"]
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createPersonalSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createPersonalSpace?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createSpace?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createSpaceContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createSpaceContentState?: Maybe<ConfluenceLegacyContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createSystemSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createSystemSpace?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_createTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_createTemplate?: Maybe<ConfluenceLegacyContentTemplate>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deactivatePaywallContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deactivatePaywallContent?: Maybe<ConfluenceLegacyDeactivatePaywallContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteComment?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteContent?: Maybe<ConfluenceLegacyDeleteContentResponsePayload>;
    /**
     * GraphQL mutation to delete classification level for content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteContentDataClassificationLevel?: Maybe<ConfluenceLegacyDeleteContentDataClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteContentState?: Maybe<ConfluenceLegacyContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteContentTemplateLabel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteContentTemplateLabel?: Maybe<ConfluenceLegacyDeleteContentTemplateLabelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteDefaultSpaceRoles' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteDefaultSpaceRoles?: Maybe<ConfluenceLegacyDeleteDefaultSpaceRolesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteExCoSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteExCoSpacePermissions?: Maybe<
        Array<Maybe<ConfluenceLegacyDeleteExCoSpacePermissionsPayload>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteExternalCollaboratorDefaultSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteExternalCollaboratorDefaultSpace?: Maybe<ConfluenceLegacyDeleteExternalCollaboratorDefaultSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteInlineComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteInlineComment?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteLabel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteLabel?: Maybe<ConfluenceLegacyDeleteLabelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deletePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deletePages?: Maybe<ConfluenceLegacyDeletePagesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteReaction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteReaction?: Maybe<ConfluenceLegacySaveReactionResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteRelation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteRelation?: Maybe<ConfluenceLegacyDeleteRelationPayload>;
    /**
     * GraphQL mutation to delete default classification level for content in a space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteSpaceDefaultClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteSpaceDefaultClassificationLevel?: Maybe<ConfluenceLegacyDeleteSpaceDefaultClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteSpaceRoles' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteSpaceRoles?: Maybe<ConfluenceLegacyDeleteSpaceRolesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deleteTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deleteTemplate?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_disableExperiment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_disableExperiment?: Maybe<ConfluenceLegacyTapExperiment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_disablePublicLinkForPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_disablePublicLinkForPage?: Maybe<ConfluenceLegacyDisablePublicLinkForPagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_disablePublicLinkForSite' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_disablePublicLinkForSite?: Maybe<ConfluenceLegacyPublicLinkSitePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_disableSuperAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_disableSuperAdmin?: Maybe<ConfluenceLegacySuperAdminPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_enableExperiment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_enableExperiment?: Maybe<ConfluenceLegacyTapExperiment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_enablePublicLinkForPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_enablePublicLinkForPage?: Maybe<ConfluenceLegacyEnablePublicLinkForPagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_enablePublicLinkForSite' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_enablePublicLinkForSite?: Maybe<ConfluenceLegacyPublicLinkSitePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_enableSuperAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_enableSuperAdmin?: Maybe<ConfluenceLegacySuperAdminPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_favouritePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_favouritePage?: Maybe<ConfluenceLegacyFavouritePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_favouriteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_favouriteSpace?: Maybe<ConfluenceLegacyFavouriteSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_followUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_followUser?: Maybe<ConfluenceLegacyFollowUserPayload>;
    /**
     * Generates an admin report.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_generateAdminReport' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_generateAdminReport?: Maybe<ConfluenceLegacyAdminReportPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_grantContentAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_grantContentAccess?: Maybe<ConfluenceLegacyGrantContentAccessPayload>;
    /**
     * Permanently purges a space of any status
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_hardDeleteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_hardDeleteSpace?: Maybe<ConfluenceLegacyHardDeleteSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_likeContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_likeContent?: Maybe<ConfluenceLegacyLikeContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_markCommentsAsRead' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_markCommentsAsRead?: Maybe<ConfluenceLegacyMarkCommentsAsReadPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_markFeatureDiscovered' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_markFeatureDiscovered?: Maybe<ConfluenceLegacyFeatureDiscoveryPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_migrateSpaceShortcuts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_migrateSpaceShortcuts?: Maybe<ConfluenceLegacyMigrateSpaceShortcutsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_moveBlog' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_moveBlog?: Maybe<ConfluenceLegacyMoveBlogPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_movePageAfter' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_movePageAfter?: Maybe<ConfluenceLegacyMovePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_movePageAppend' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_movePageAppend?: Maybe<ConfluenceLegacyMovePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_movePageBefore' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_movePageBefore?: Maybe<ConfluenceLegacyMovePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_movePageTopLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_movePageTopLevel?: Maybe<ConfluenceLegacyMovePagePayload>;
    /**
     *  @Experimental   you can use it but the API may change and we will make a best effort to not break it.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_newPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_newPage?: Maybe<ConfluenceLegacyNewPagePayload>;
    /**
     * GraphQL mutation to set classification level for content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_notifyUsersOnFirstView' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_notifyUsersOnFirstView?: Maybe<ConfluenceLegacyNotificationResponsePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_openUpSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_openUpSpacePermissions?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_patchCommentsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_patchCommentsSummary?: Maybe<ConfluenceLegacyPatchCommentsSummaryPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkPagesAdminAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkPagesAdminAction?: Maybe<ConfluenceLegacyPublicLinkPagesAdminActionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkSpacesAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkSpacesAction?: Maybe<ConfluenceLegacyPublicLinkSpacesActionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_refreshTeamCalendar' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_refreshTeamCalendar?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_removeAllDirectUserSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_removeAllDirectUserSpacePermissions?: Maybe<ConfluenceLegacyRemoveSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_removeContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_removeContentState?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_removeGroupSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_removeGroupSpacePermissions?: Maybe<ConfluenceLegacyRemoveSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_removePublicLinkPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_removePublicLinkPermissions?: Maybe<ConfluenceLegacyRemovePublicLinkPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_removeUserSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_removeUserSpacePermissions?: Maybe<ConfluenceLegacyRemoveSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_replyInlineComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_replyInlineComment?: Maybe<ConfluenceLegacyComment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_requestAccessExco' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_requestAccessExco?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_requestPageAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_requestPageAccess?: Maybe<ConfluenceLegacyRequestPageAccessPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_resetExCoSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_resetExCoSpacePermissions?: Maybe<ConfluenceLegacyResetExCoSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_resetSpaceContentStates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_resetSpaceContentStates?: Maybe<ConfluenceLegacyContentStateSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_resetSpaceRolesFromAnotherSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_resetSpaceRolesFromAnotherSpace?: Maybe<ConfluenceLegacyResetSpaceRolesFromAnotherSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_resetSystemSpaceHomepage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_resetSystemSpaceHomepage?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_resolveInlineComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_resolveInlineComment?: Maybe<ConfluenceLegacyResolveInlineCommentPayload>;
    /**
     * Restores a soft deleted space. This will only succeed if the feature flag for space soft-deletion is enabled.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_restoreSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_restoreSpace?: Maybe<ConfluenceLegacyRestoreSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_revertToLegacyEditor' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_revertToLegacyEditor?: Maybe<ConfluenceLegacyRevertToLegacyEditorResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setBatchedTaskStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setBatchedTaskStatus?: Maybe<ConfluenceLegacyMutationResponse>;
    /**
     * Update content access level for given content. Only Page and BlogPost contents are supported.Known issue with the API - https://hello.atlassian.net/wiki/spaces/~70121df94c0251be4486aa10462457a7d9db1/pages/1774486949/New+Shared+Dialog+-+Issues+Potential+Resolutions+Backend
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setContentAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setContentAccess?: Maybe<ConfluenceLegacyContentPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setContentState?: Maybe<ConfluenceLegacyContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setContentStateAndPublish' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setContentStateAndPublish?: Maybe<ConfluenceLegacyContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setContentStateSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setContentStateSettings?: Maybe<ConfluenceLegacyContentStateSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setDefaultSpaceRoles' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setDefaultSpaceRoles?: Maybe<ConfluenceLegacySetDefaultSpaceRolesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setEditorConversionSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setEditorConversionSettings?: Maybe<ConfluenceLegacyEditorConversionSetting>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setFeedUserConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setFeedUserConfig?: Maybe<ConfluenceLegacySetFeedUserConfigPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setOnboardingState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setOnboardingState?: Maybe<
        Array<ConfluenceLegacyOnboardingState>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setOnboardingStateToComplete' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setOnboardingStateToComplete?: Maybe<
        Array<ConfluenceLegacyOnboardingState>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setPublicLinkDefaultSpaceStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setPublicLinkDefaultSpaceStatus?: Maybe<ConfluenceLegacyGlobalSpaceConfiguration>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setRecommendedPagesSpaceStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setRecommendedPagesSpaceStatus?: Maybe<ConfluenceLegacySetRecommendedPagesSpaceStatusPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setRecommendedPagesStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setRecommendedPagesStatus?: Maybe<ConfluenceLegacySetRecommendedPagesStatusPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setRelevantFeedFilters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setRelevantFeedFilters?: Maybe<ConfluenceLegacyHomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setShowActivityFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use updateHomeUserSettings
     */
    confluenceLegacy_setShowActivityFeed?: Maybe<ConfluenceLegacyHomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setSpaceRoles' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setSpaceRoles?: Maybe<ConfluenceLegacySetSpaceRolesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_setTaskStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_setTaskStatus?: Maybe<ConfluenceLegacyMutationResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_shareResource' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_shareResource?: Maybe<ConfluenceLegacyShareResourcePayload>;
    /**
     * Revertibly deletes a space. This will only succeed if the feature flag for space soft-deletion is enabled.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_softDeleteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_softDeleteSpace?: Maybe<ConfluenceLegacySoftDeleteSpacePayload>;
    /**
     * Migrate all templates in space from TINYMCE to FABRIC editor.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templateMigration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templateMigration?: Maybe<ConfluenceLegacyTemplateMigration>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templatize' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templatize?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unfavouritePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unfavouritePage?: Maybe<ConfluenceLegacyFavouritePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unfavouriteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unfavouriteSpace?: Maybe<ConfluenceLegacyFavouriteSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unfollowUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unfollowUser?: Maybe<ConfluenceLegacyFollowUserPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unlikeContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unlikeContent?: Maybe<ConfluenceLegacyLikeContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unwatchBlogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unwatchBlogs?: Maybe<ConfluenceLegacyWatchSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unwatchContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unwatchContent?: Maybe<ConfluenceLegacyWatchContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_unwatchSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_unwatchSpace?: Maybe<ConfluenceLegacyWatchSpacePayload>;
    /**
     * Update an existing banner.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateAdminAnnouncementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateAdminAnnouncementBanner?: Maybe<ConfluenceLegacyAdminAnnouncementBannerPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateArchiveNotes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateArchiveNotes?: Maybe<ConfluenceLegacyUpdateArchiveNotesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateComment?: Maybe<ConfluenceLegacyComment>;
    /**
     * GraphQL mutation to set classification level for content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateContentDataClassificationLevel?: Maybe<ConfluenceLegacyUpdateContentDataClassificationLevelPayload>;
    /**
     * Update direct content restrictions for user by specifying the intention VIEWER/EDITOR/DEFAULT and user/group for the content identified by contentId parameter.
     * Throws subclasses of ServiceException in case of various problems (cannot find content, cannot find user or group, not enough permissions to change content permissions, etc...)
     * Known issue with the API - https://hello.atlassian.net/wiki/spaces/~70121df94c0251be4486aa10462457a7d9db1/pages/1774486949/New+Shared+Dialog+-+Issues+Potential+Resolutions+Backend
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateContentPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateContentPermissions?: Maybe<ConfluenceLegacyContentPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateEmbed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateEmbed?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateExCoSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateExCoSpacePermissions?: Maybe<
        Array<Maybe<ConfluenceLegacyUpdateExCoSpacePermissionsPayload>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateExternalCollaboratorDefaultSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateExternalCollaboratorDefaultSpace?: Maybe<ConfluenceLegacyUpdateExternalCollaboratorDefaultSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateHomeUserSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateHomeUserSettings?: Maybe<ConfluenceLegacyHomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateLocalStorage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateLocalStorage?: Maybe<ConfluenceLegacyLocalStorage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateNestedPageOwners' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateNestedPageOwners?: Maybe<ConfluenceLegacyUpdateNestedPageOwnersPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateOwner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateOwner?: Maybe<ConfluenceLegacyUpdateOwnerPayload>;
    /**
     *  @Experimental   you can use it but the API may change and we will make a best effort to not break it.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updatePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updatePage?: Maybe<ConfluenceLegacyUpdatePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updatePageOwners' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updatePageOwners?: Maybe<ConfluenceLegacyUpdatePageOwnersPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updatePageStatuses' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updatePageStatuses?: Maybe<ConfluenceLegacyUpdatePageStatusesPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updatePushNotificationCustomSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updatePushNotificationCustomSettings?: Maybe<ConfluenceLegacyPushNotificationSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updatePushNotificationGroupSetting' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updatePushNotificationGroupSetting?: Maybe<ConfluenceLegacyPushNotificationSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateRelation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateRelation?: Maybe<ConfluenceLegacyUpdateRelationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateSiteLookAndFeel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateSiteLookAndFeel?: Maybe<ConfluenceLegacyUpdateSiteLookAndFeelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateSitePermission' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateSitePermission?: Maybe<ConfluenceLegacySitePermission>;
    /**
     * GraphQL mutation to set default classification level for content in a space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateSpaceDefaultClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateSpaceDefaultClassificationLevel?: Maybe<ConfluenceLegacyUpdateSpaceDefaultClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateSpacePermissionDefaults' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateSpacePermissionDefaults?: Maybe<ConfluenceLegacyUpdateDefaultSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateSpacePermissions?: Maybe<ConfluenceLegacyUpdateSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateSpaceTypeSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateSpaceTypeSettings?: Maybe<ConfluenceLegacyUpdateSpaceTypeSettingsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateTemplate?: Maybe<ConfluenceLegacyContentTemplate>;
    /**
     * Create or update a template property
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateTemplatePropertySet' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateTemplatePropertySet?: Maybe<ConfluenceLegacyUpdateTemplatePropertySetPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateTitle' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateTitle?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_updateUserPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_updateUserPreferences?: Maybe<ConfluenceLegacyUserPreferences>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_watchBlogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_watchBlogs?: Maybe<ConfluenceLegacyWatchSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_watchContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_watchContent?: Maybe<ConfluenceLegacyWatchContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_watchSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_watchSpace?: Maybe<ConfluenceLegacyWatchSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_deleteCalendarCustomEventType' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_deleteCalendarCustomEventType?: Maybe<ConfluenceDeleteCalendarCustomEventTypePayload>;
    /**
     * Delete all future events of a recurring event
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_deleteSubCalendarAllFutureEvents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_deleteSubCalendarAllFutureEvents?: Maybe<ConfluenceDeleteSubCalendarAllFutureEventsPayload>;
    /**
     * Deletes a non-recurring event
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_deleteSubCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_deleteSubCalendarEvent?: Maybe<ConfluenceDeleteSubCalendarEventPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_deleteSubCalendarHiddenEvents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_deleteSubCalendarHiddenEvents?: Maybe<ConfluenceDeleteSubCalendarHiddenEventsPayload>;
    /**
     * Deletes a single instance of a recurring event
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_deleteSubCalendarPrivateUrl' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_deleteSubCalendarPrivateUrl?: Maybe<ConfluenceDeleteSubCalendarPrivateUrlPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_deleteSubCalendarSingleEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_deleteSubCalendarSingleEvent?: Maybe<ConfluenceDeleteSubCalendarSingleEventPayload>;
    /**
     * Invite users by atlassian user ids
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_inviteUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_inviteUsers?: Maybe<ConfluenceInviteUserPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_makeSubCalendarPrivateUrl' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_makeSubCalendarPrivateUrl?: Maybe<ConfluenceMakeSubCalendarPrivateUrlPayload>;
    /**
     * Updates the status of a comment from `RESOLVED` to `REOPENED`.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_reopenComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_reopenComment?: Maybe<ConfluenceReopenCommentPayload>;
    /**
     * Updates the status of footer (page) comment(s) or inline comment(s) to resolved.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_resolveComments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_resolveComments?: Maybe<ConfluenceResolveCommentsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_unwatchSubCalendar' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_unwatchSubCalendar?: Maybe<ConfluenceUnwatchSubCalendarPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_updateSubCalendarHiddenEvents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_updateSubCalendarHiddenEvents?: Maybe<ConfluenceUpdateSubCalendarHiddenEventsPayload>;
    /**
     * Update the confluence team presence settings for a space
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_updateTeamPresenceSpaceSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_updateTeamPresenceSpaceSettings?: Maybe<ConfluenceUpdateTeamPresenceSpaceSettingsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_watchSubCalendar' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_watchSubCalendar?: Maybe<ConfluenceWatchSubCalendarPayload>;
    /**
     * Create a Connection for the provided API Token and configuration
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    connectionManager_createApiTokenConnectionForJiraProject?: Maybe<ConnectionManagerCreateApiTokenConnectionForJiraProjectPayload>;
    /**
     * Create a Connection for the provided OAuth details and connection configuration
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    connectionManager_createOAuthConnectionForJiraProject?: Maybe<ConnectionManagerCreateOAuthConnectionForJiraProjectPayload>;
    /**
     * Delete a Connection for a project as per the integration key
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    connectionManager_deleteApiTokenConnectionForJiraProject?: Maybe<ConnectionManagerDeleteApiTokenConnectionForJiraProjectPayload>;
    /**
     * Delete a Connection for a project as per the integration key
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    connectionManager_deleteConnectionForJiraProject?: Maybe<ConnectionManagerDeleteConnectionForJiraProjectPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contactAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contactAdmin?: Maybe<GraphQlContactAdminStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'convertPageToLiveEditAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    convertPageToLiveEditAction?: Maybe<ConvertPageToLiveEditActionPayload>;
    /**
     * Convert content to folder, pages are only supported at this time.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'convertToFolder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    convertToFolder?: Maybe<ConfluenceConvertContentToFolderPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'copyDefaultSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    copyDefaultSpacePermissions?: Maybe<CopySpacePermissionsPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    copyPolarisInsights?: Maybe<CopyPolarisInsightsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'copySpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    copySpacePermissions?: Maybe<CopySpacePermissionsPayload>;
    /**
     * Create a new banner
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createAdminAnnouncementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createAdminAnnouncementBanner?: Maybe<ConfluenceAdminAnnouncementBannerPayload>;
    /**
     * Creates an application in Xen
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createApp?: Maybe<CreateAppResponse>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createAppDeployment?: Maybe<CreateAppDeploymentResponse>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createAppDeploymentUrl?: Maybe<CreateAppDeploymentUrlResponse>;
    /**
     * Create multiple tunnels for an app
     *
     * This will allow api calls for this app to be tunnelled to a locally running
     * server to help with writing and debugging functions.
     *
     * This call covers both the FaaS tunnel as well as registering multiple Custom UI tunnels
     * that can then be used in the products instead of serving the usual CDN url.
     *
     * This call will fail if a tunnel already exists, unless the 'force' flag is set.
     *
     * Tunnels automatically expire after 30 minutes
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createAppTunnels?: Maybe<CreateAppTunnelResponse>;
    /**
     * This mutation is in BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: BacklogEpicPanel` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createCardParent?: Maybe<CardParentCreateOutput>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createColumn?: Maybe<CreateColumnOutput>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createContentContextual' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createContentContextual?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createContentGlobal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createContentGlobal?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createContentInline' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createContentInline?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createContentMentionNotificationAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createContentMentionNotificationAction?: Maybe<CreateContentMentionNotificationActionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createContentTemplateLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createContentTemplateLabels?: Maybe<PaginatedLabelList>;
    /**
     * Creates a new custom filter
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createCustomFilter?: Maybe<CustomFilterCreateOutput>;
    /**
     * Creates a new custom filter
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'createCustomFilterV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createCustomFilterV2?: Maybe<CustomFilterCreateOutputV2>;
    /** Create a DevOps Service */
    createDevOpsService?: Maybe<CreateDevOpsServicePayload>;
    /**
     * Creates a relationships between a DevOps Service and a Jira project
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createDevOpsServiceAndJiraProjectRelationship?: Maybe<CreateDevOpsServiceAndJiraProjectRelationshipPayload>;
    /**
     * Create a relationship between a DevOps Service and an Opsgenie team.
     *
     * A DevOps Service can be related to no more than one team. If you attempt to relate more than one team
     * with a DevOps Service, this mutation will fail with a SERVICE_AND_OPSGENIE_TEAM_RELATIONSHIP_TOO_MANY_TEAMS error.
     *
     * A team can be related to no more than 1,000 DevOps Services. If you attempt to relate too many services
     * with a team, this mutation will fail with a SERVICE_AND_OPSGENIE_TEAM_RELATIONSHIP_TOO_MANY_SERVICES error.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createDevOpsServiceAndOpsgenieTeamRelationship?: Maybe<CreateDevOpsServiceAndOpsgenieTeamRelationshipPayload>;
    /**
     * Create a relationship between a DevOps Service and a Repository.
     *
     * A single service may be associated with at most 300 repositories. If too many repositories are associated with a
     * DevOps Service, this mutation will fail with a SERVICE_AND_REPOSITORY_RELATIONSHIP_TOO_MANY_REPOSITORIES error.
     *
     * A single Repository may be associated with at most 300 DevOps Services. If too many DevOps Services are associated with a
     * Repository, this mutation will fail with a SERVICE_AND_REPOSITORY_RELATIONSHIP_TOO_MANY_SERVICES error.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createDevOpsServiceAndRepositoryRelationship?: Maybe<CreateDevOpsServiceAndRepositoryRelationshipPayload>;
    /** Create a DevOps Service Relationship */
    createDevOpsServiceRelationship?: Maybe<CreateDevOpsServiceRelationshipPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createFaviconFiles' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createFaviconFiles?: Maybe<CreateFaviconFilesPayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    createFooterComment?: Maybe<Comment>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createHostedResourceUploadUrl?: Maybe<CreateHostedResourceUploadUrlPayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    createInlineComment?: Maybe<Comment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createInlineTaskNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createInlineTaskNotification?: Maybe<CreateInlineTaskNotificationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createLivePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createLivePage?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createMentionNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createMentionNotification?: Maybe<CreateMentionNotificationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createMentionReminderNotification' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createMentionReminderNotification?: Maybe<CreateMentionReminderNotificationPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createOnboardingSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createOnboardingSpace?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createOrUpdateArchivePageNote' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use updateArchiveNotes mutation instead
     */
    createOrUpdateArchivePageNote?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createPersonalSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createPersonalSpace?: Maybe<Space>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createPolarisComment?: Maybe<CreatePolarisCommentPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createPolarisIdeaTemplate?: Maybe<CreatePolarisIdeaTemplatePayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:jira-work__
     *
     *
     */
    createPolarisInsight?: Maybe<CreatePolarisInsightPayload>;
    /**
     * Creates a new play.  A play will manifest as a field, and play
     * contributions will manifest as insights (data points) with
     * snippets associated with the play.
     *
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createPolarisPlay?: Maybe<CreatePolarisPlayPayload>;
    /**
     * Creates or updates a contribution to a play.  The contribution
     * will manifest as an insight.  Returns an error if the contribution
     * is not acceptable to the parameters of the play, such as spending
     * more than the max amount in a BudgetAllocation ("$10 Game") play
     *
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createPolarisPlayContribution?: Maybe<CreatePolarisPlayContributionPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createPolarisView?: Maybe<CreatePolarisViewPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createPolarisViewSet?: Maybe<CreatePolarisViewSetPayload>;
    createReleaseNote: ContentPlatformReleaseNote;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createSpace?: Maybe<Space>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createSpaceContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createSpaceContentState?: Maybe<ContentState>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    createSprint?: Maybe<CreateSprintResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createSystemSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createSystemSpace?: Maybe<Space>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'createTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    createTemplate?: Maybe<ContentTemplate>;
    /**
     * Creates a webtrigger URL. If webtrigger url is already created for given `input` the old url will be returned
     * unless `forceCreate` flag is set to true - in that case new url will be always created.
     */
    createWebTriggerUrl?: Maybe<CreateWebTriggerUrlResponse>;
    /** Customer Service Mutation API namespaced to customerService */
    customerService?: Maybe<CustomerServiceMutationApi>;
    /** This API is a wrapper for all CSP support Request mutations */
    customerSupport?: Maybe<SupportRequestCatalogMutationApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deactivatePaywallContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deactivatePaywallContent?: Maybe<DeactivatePaywallContentPayload>;
    /**
     * Deletes an application from Xen
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteApp?: Maybe<DeleteAppResponse>;
    /**
     * Deletes a key-value pair for a given environment.
     *
     * This operation is idempotent.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteAppEnvironmentVariable?: Maybe<DeleteAppEnvironmentVariablePayload>;
    /**
     * Delete tunnels for an app
     *
     * All FaaS traffic for this app will return to invoking the deployed function
     * instead of the tunnel url.
     *
     * Same will be done for the Custom UI tunnels, where the normal CDN url will be
     * used instead of the tunnel url.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteAppTunnels?: Maybe<GenericMutationResponse>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteColumn?: Maybe<DeleteColumnOutput>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteComment?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteContent?: Maybe<DeleteContentResponsePayload>;
    /**
     * GraphQL mutation to delete classification level for content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteContentDataClassificationLevel?: Maybe<DeleteContentDataClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteContentState?: Maybe<ContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteContentTemplateLabel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteContentTemplateLabel?: Maybe<DeleteContentTemplateLabelPayload>;
    /**
     * Delete the custom filter with the specified custom filter ID
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteCustomFilter?: Maybe<GenericMutationResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteDefaultSpaceRoleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteDefaultSpaceRoleAssignments?: Maybe<DeleteDefaultSpaceRoleAssignmentsPayload>;
    /**
     * Remove arbitrary property keys associated with an entity (service or relationship)
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteDevOpsContainerRelationshipEntityProperties?: Maybe<DeleteDevOpsContainerRelationshipEntityPropertiesPayload>;
    /** Delete a DevOps Service */
    deleteDevOpsService?: Maybe<DeleteDevOpsServicePayload>;
    /**
     * Deletes the relationship between a DevOps Service and a Jira project
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteDevOpsServiceAndJiraProjectRelationship?: Maybe<DeleteDevOpsServiceAndJiraProjectRelationshipPayload>;
    /**
     * Delete a relationship between a DevOps Service and an Opsgenie team
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteDevOpsServiceAndOpsgenieTeamRelationship?: Maybe<DeleteDevOpsServiceAndOpsgenieTeamRelationshipPayload>;
    /**
     * Delete a relationship between a DevOps Service and a Repository
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteDevOpsServiceAndRepositoryRelationship?: Maybe<DeleteDevOpsServiceAndRepositoryRelationshipPayload>;
    /** Remove arbitrary property keys associated with a DevOpsService */
    deleteDevOpsServiceEntityProperties?: Maybe<DeleteDevOpsServiceEntityPropertiesPayload>;
    /** Delete a DevOps Service Relationship */
    deleteDevOpsServiceRelationship?: Maybe<DeleteDevOpsServiceRelationshipPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteInlineComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteInlineComment?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteLabel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteLabel?: Maybe<DeleteLabelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deletePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deletePages?: Maybe<DeletePagesPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deletePolarisIdeaTemplate?: Maybe<DeletePolarisIdeaTemplatePayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deletePolarisInsight?: Maybe<DeletePolarisInsightPayload>;
    /**
     * Deletes an existing contribution to a play.
     *
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deletePolarisPlayContribution?: Maybe<DeletePolarisPlayContributionPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deletePolarisView?: Maybe<DeletePolarisViewPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deletePolarisViewSet?: Maybe<DeletePolarisViewSetPayload>;
    deleteReaction?: Maybe<SaveReactionResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteRelation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteRelation?: Maybe<DeleteRelationPayload>;
    /**
     * GraphQL mutation to delete default classification level for content in a space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteSpaceDefaultClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteSpaceDefaultClassificationLevel?: Maybe<DeleteSpaceDefaultClassificationLevelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteSpaceRoleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteSpaceRoleAssignments?: Maybe<DeleteSpaceRoleAssignmentsPayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    deleteSprint?: Maybe<MutationResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deleteTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deleteTemplate?: Maybe<Scalars["ID"]["output"]>;
    /** Deletes a webtrigger URL. */
    deleteWebTriggerUrl?: Maybe<DeleteWebTriggerUrlResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAi")' query directive to the 'devAi' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Unused legacy field
     */
    devAi?: Maybe<DevAiMutations>;
    devOps?: Maybe<DevOpsMutation>;
    /**
     * Used when the autodev job paused from issue scoping result.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'devai_continueJobWithPrompt' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_continueJobWithPrompt?: Maybe<DevAiAutodevContinueJobWithPromptPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiTechnicalPlanner")' query directive to the 'devai_createTechnicalPlannerJob' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_createTechnicalPlannerJob?: Maybe<DevAiCreateTechnicalPlannerJobPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'devai_invokeAutodevRovoAgent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_invokeAutodevRovoAgent?: Maybe<DevAiInvokeAutodevRovoAgentPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'devai_invokeAutodevRovoAgentInBulk' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_invokeAutodevRovoAgentInBulk?: Maybe<DevAiInvokeAutodevRovoAgentInBulkPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'disableExperiment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    disableExperiment?: Maybe<TapExperiment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'disablePublicLinkForPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    disablePublicLinkForPage?: Maybe<DisablePublicLinkForPagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'disablePublicLinkForSite' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    disablePublicLinkForSite?: Maybe<PublicLinkSitePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'disableSuperAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    disableSuperAdmin?: Maybe<SuperAdminPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    ecosystem?: Maybe<EcosystemMutation>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    editSprint?: Maybe<SprintResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'editorDraftSyncAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    editorDraftSyncAction?: Maybe<EditorDraftSyncPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'enableExperiment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    enableExperiment?: Maybe<TapExperiment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'enablePublicLinkForPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    enablePublicLinkForPage?: Maybe<EnablePublicLinkForPagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'enablePublicLinkForSite' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    enablePublicLinkForSite?: Maybe<PublicLinkSitePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'enableSuperAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    enableSuperAdmin?: Maybe<SuperAdminPayload>;
    /** ERS lifecycle operations */
    ersLifecycle?: Maybe<ErsLifecycleMutation>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'favouritePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    favouritePage?: Maybe<FavouritePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'favouriteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    favouriteSpace?: Maybe<FavouriteSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'favouriteSpaceBulk' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    favouriteSpaceBulk?: Maybe<FavouriteSpaceBulkPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'followUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    followUser?: Maybe<FollowUserPayload>;
    /**
     * Generates a perms report.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'generatePermsReport' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    generatePermsReport?: Maybe<ConfluenceAdminReportPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'grantContentAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    grantContentAccess?: Maybe<GrantContentAccessPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStoreMutation")' query directive to the 'graphStore' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    graphStore?: Maybe<GraphStoreMutation>;
    /** Operation to create a unified profile for the user based on account id or the tenant id */
    growthUnifiedProfile_createUnifiedProfile?: Maybe<GrowthUnifiedProfileResult>;
    /**
     * Permanently purges a space of any status
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'hardDeleteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    hardDeleteSpace?: Maybe<HardDeleteSpacePayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpCenter?: Maybe<HelpCenterMutationApi>;
    helpExternalResource?: Maybe<HelpExternalResourceMutationApi>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpLayoutExperimentalSchema")' query directive to the 'helpLayout' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpLayout?: Maybe<HelpLayoutMutationApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpObjectStore?: Maybe<HelpObjectStoreMutationApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "InsightsMutation")' query directive to the 'insightsMutation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    insightsMutation?: Maybe<InsightsMutation>;
    /**
     * Installs a given app + environment pair into a given installation context.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    installApp?: Maybe<AppInstallationResponse>;
    /**
     * Invoke a function using the aux effects handling pipeline
     *
     * This includes some additional processing over normal invocations, including
     * validation and transformation, and expects functions to return payloads that
     * match the AUX effects spec.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     *
     *
     */
    invokeAuxEffects?: Maybe<InvokeAuxEffectsResponse>;
    /**
     * Invoke a function associated with a specific extension.
     *
     * This is intended to be the main way to interact with extension functions
     * created for apps
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    invokeExtension?: Maybe<InvokeExtensionResponse>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    invokePolarisObject?: Maybe<InvokePolarisObjectPayload>;
    /**
     * this field is added to enable self governed onboarding of Jira GraphQL types to AGG
     * see https://hello.atlassian.net/wiki/spaces/PSRV/pages/1010287708/Announcing+self+governed+APIs for more details
     */
    jira?: Maybe<JiraMutation>;
    /** Namespace for the canned response mutation APIs */
    jiraCannedResponse?: Maybe<JiraCannedResponseMutationApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jiraOAuthApps?: Maybe<JiraOAuthAppsMutation>;
    /**
     * Bulk set the collapsed/expanded state of all columns within the board view. This will override the state of all
     * visible columns as dictated by the group by field setting.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_bulkSetBoardViewColumnState?: Maybe<JiraBulkSetBoardViewColumnStatePayload>;
    /**
     * Create a custom background for a project.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_createCustomBackground?: Maybe<JiraProjectCreateCustomBackgroundMutationPayload>;
    /**
     * Delete a custom background for a project.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_deleteCustomBackground?: Maybe<JiraProjectDeleteCustomBackgroundMutationPayload>;
    /**
     * Revert the config of a board view to its globally published or default settings, discarding any user-specific settings.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_discardUserBoardViewConfig?: Maybe<JiraDiscardUserBoardViewConfigPayload>;
    /**
     * Publish the customized config of a board view for all users.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_publishBoardViewConfig?: Maybe<JiraPublishBoardViewConfigPayload>;
    /**
     * Reorder a column on the board view.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Not used and not implemented. Replaced by jira_setBoardViewColumnsOrder.
     */
    jira_reorderBoardViewColumn?: Maybe<JiraReorderBoardViewColumnPayload>;
    /**
     * Set the selected/deselected state of a card field within the board view.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Not used and not implemented. Replaced by jira_setBoardViewCardOptionState.
     */
    jira_setBoardViewCardFieldSelected?: Maybe<JiraSetBoardViewCardFieldSelectedPayload>;
    /**
     * Set the state of a card option within the board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewCardOptionState?: Maybe<JiraSetBoardViewCardOptionStatePayload>;
    /**
     * Set the collapsed/expanded state of a column within the board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewColumnState?: Maybe<JiraSetBoardViewColumnStatePayload>;
    /**
     * Set the ordering of columns for a particular type of column on the board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewColumnsOrder?: Maybe<JiraSetBoardViewColumnsOrderPayload>;
    /**
     * Set the number of days after which completed issues are removed from the board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewCompletedIssueSearchCutOff?: Maybe<JiraSetBoardViewCompletedIssueSearchCutOffPayload>;
    /**
     * Set the filter for a board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewFilter?: Maybe<JiraSetBoardViewFilterPayload>;
    /**
     * Set the group by field for a board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewGroupBy?: Maybe<JiraSetBoardViewGroupByPayload>;
    /**
     * Set the selected workflow for the board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_setBoardViewWorkflowSelected?: Maybe<JiraSetBoardViewWorkflowSelectedPayload>;
    /**
     * Set the filter for a Jira View.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Not currently used or implemented. Duplicated as jira_setBoardViewFilter
     */
    jira_setViewFilter?: Maybe<JiraSetViewFilterPayload>;
    /**
     * Set the group by field for a Jira View.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Not currently used or implemented. Duplicated as jira_setBoardViewGroupBy
     */
    jira_setViewGroupBy?: Maybe<JiraSetViewGroupByPayload>;
    /**
     * Update the background of a project.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_updateProjectBackground?: Maybe<JiraProjectUpdateBackgroundMutationPayload>;
    /**
     * Updates the sidebar menu settings for the current user.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSidebarMenu")' query directive to the 'jira_updateProjectsSidebarMenu' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jira_updateProjectsSidebarMenu?: Maybe<JiraProjectsSidebarMenu>;
    /**
     * this field is added to enable self governed onboarding of Jira GraphQL types to AGG
     * see https://hello.atlassian.net/wiki/spaces/PSRV/pages/1010287708/Announcing+self+governed+APIs for more details
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jsmChat?: Maybe<JsmChatMutation>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jsw?: Maybe<JswMutation>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    knowledgeBase?: Maybe<KnowledgeBaseMutationApi>;
    /**
     *  Update edit and view permissions for a space linked to a container
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    knowledgeBaseSpacePermission_updateView: KnowledgeBaseSpacePermissionMutationResponse;
    knowledgeDiscovery?: Maybe<KnowledgeDiscoveryMutationApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'likeContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    likeContent?: Maybe<LikeContentPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'markCommentsAsRead' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    markCommentsAsRead?: Maybe<MarkCommentsAsReadPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'markFeatureDiscovered' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    markFeatureDiscovered?: Maybe<FeatureDiscoveryPayload>;
    marketplaceConsole: MarketplaceConsoleMutationApi;
    marketplaceStore?: Maybe<MarketplaceStoreMutationApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    mercury?: Maybe<MercuryMutationApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    mercury_providerOrchestration?: Maybe<MercuryProviderOrchestrationMutationApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    mercury_strategicEvents?: Maybe<MercuryStrategicEventsMutationApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'migrateSpaceShortcuts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    migrateSpaceShortcuts?: Maybe<MigrateSpaceShortcutsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'moveBlog' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    moveBlog?: Maybe<MoveBlogPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'movePageAfter' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    movePageAfter?: Maybe<MovePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'movePageAppend' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    movePageAppend?: Maybe<MovePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'movePageBefore' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    movePageBefore?: Maybe<MovePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'movePageTopLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    movePageTopLevel?: Maybe<MovePagePayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    moveSprintDown?: Maybe<MoveSprintDownResponse>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    moveSprintUp?: Maybe<MoveSprintUpResponse>;
    /**
     *  @Experimental   you can use it but the API may change and we will make a best effort to not break it.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'newPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    newPage?: Maybe<NewPagePayload>;
    /**
     * Mutation object for Notification Experience
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     * * __read:jira-work__
     * * __read:blogpost:confluence__
     * * __read:comment:confluence__
     * * __read:page:confluence__
     * * __read:space:confluence__
     *
     *
     */
    notifications?: Maybe<InfluentsNotificationMutation>;
    /**
     * GraphQL mutation to set classification level for content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'notifyUsersOnFirstView' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    notifyUsersOnFirstView?: Maybe<NotificationResponsePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'openUpSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    openUpSpacePermissions?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PEAP")' query directive to the 'partnerEarlyAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    partnerEarlyAccess?: Maybe<PeapMutationApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'patchCommentsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    patchCommentsSummary?: Maybe<PatchCommentsSummaryPayload>;
    /**
     * Creates a card in a card list on the Backlog page
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "planModeCardCreate")' query directive to the 'planModeCardCreate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    planModeCardCreate?: Maybe<CreateCardsOutput>;
    /**
     * Moves a card or a list of cards in the backlog
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "planModeCardMove")' query directive to the 'planModeCardMove' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    planModeCardMove?: Maybe<MoveCardOutput>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_createJiraPlaybook' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_createJiraPlaybook?: Maybe<CreateJiraPlaybookPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_createJiraPlaybookStepRun' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_createJiraPlaybookStepRun?: Maybe<CreateJiraPlaybookStepRunPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_deleteJiraPlaybook' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_deleteJiraPlaybook?: Maybe<DeleteJiraPlaybookPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_updateJiraPlaybook' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_updateJiraPlaybook?: Maybe<UpdateJiraPlaybookPayload>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_updateJiraPlaybookState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_updateJiraPlaybookState?: Maybe<UpdateJiraPlaybookStatePayload>;
    polaris?: Maybe<PolarisMutationNamespace>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "polaris-v0")' query directive to the 'polarisAddReaction' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    polarisAddReaction?: Maybe<PolarisAddReactionPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "polaris-v0")' query directive to the 'polarisDeleteReaction' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    polarisDeleteReaction?: Maybe<PolarisDeleteReactionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkPagesAdminAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkPagesAdminAction?: Maybe<PublicLinkPagesAdminActionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkSpacesAction' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkSpacesAction?: Maybe<PublicLinkSpacesActionPayload>;
    publishReleaseNote: ContentPlatformReleaseNote;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarUpdateFocusAreaMappings")' query directive to the 'radar_updateFocusAreaMappings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_updateFocusAreaMappings?: Maybe<RadarMutationResponse>;
    /**
     * This mutation is in BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: BacklogEpicPanel` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rankCardParent?: Maybe<GenericMutationResponse>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rankColumn?: Maybe<RankColumnOutput>;
    /**
     * Moves the custom filter with the specified custom filter ID
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    rankCustomFilter?: Maybe<GenericMutationResponse>;
    /**
     * Recover admin permissions of a certain space for the current user.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'recoverSpaceAdminPermission' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    recoverSpaceAdminPermission?: Maybe<RecoverSpaceAdminPermissionPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'recoverSpaceWithAdminRoleAssignment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    recoverSpaceWithAdminRoleAssignment?: Maybe<RecoverSpaceWithAdminRoleAssignmentPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    refreshPolarisSnippets?: Maybe<RefreshPolarisSnippetsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'refreshTeamCalendar' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    refreshTeamCalendar?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Create tunnels for an app developer
     *
     * This will allow api calls for an app to be tunnelled to a locally running
     * server to help with writing and debugging functions using cloudflare tunnel.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    registerTunnel?: Maybe<RegisterTunnelResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'removeAllDirectUserSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    removeAllDirectUserSpacePermissions?: Maybe<RemoveSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'removeContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    removeContentState?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'removeGroupSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    removeGroupSpacePermissions?: Maybe<RemoveSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'removePublicLinkPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    removePublicLinkPermissions?: Maybe<RemovePublicLinkPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'removeUserSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    removeUserSpacePermissions?: Maybe<RemoveSpacePermissionsPayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    replyInlineComment?: Maybe<Comment>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'requestAccessExco' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    requestAccessExco?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'requestPageAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    requestPageAccess?: Maybe<RequestPageAccessPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resetExCoSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resetExCoSpacePermissions?: Maybe<ResetExCoSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resetSpaceContentStates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resetSpaceContentStates?: Maybe<ContentStateSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resetSpaceRolesFromAnotherSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resetSpaceRolesFromAnotherSpace?: Maybe<ResetSpaceRolesFromAnotherSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resetSystemSpaceHomepage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resetSystemSpaceHomepage?: Maybe<Space>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resetToDefaultSpaceRoleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resetToDefaultSpaceRoleAssignments?: Maybe<ResetToDefaultSpaceRoleAssignmentsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resolveInlineComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resolveInlineComment?: Maybe<ResolveInlineCommentPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    resolvePolarisObject?: Maybe<ResolvePolarisObjectPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resolveRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resolveRestrictions?: Maybe<ResolveRestrictionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'resolveRestrictionsForSubjects' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    resolveRestrictionsForSubjects?: Maybe<ResolveRestrictionsPayload>;
    /**
     * Restores a soft deleted space. This will only succeed if the feature flag for space soft-deletion is enabled.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'restoreSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    restoreSpace?: Maybe<RestoreSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'revertToLegacyEditor' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    revertToLegacyEditor?: Maybe<RevertToLegacyEditorResult>;
    /**
     * Field for grouping the roadmap mutations
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    roadmaps?: Maybe<RoadmapsMutation>;
    /**
     * Sets a key-value pair for a given environment.
     *
     * It will optionally support encryption of the provided pair for sensitive variables.
     * This operation is an upsert.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    setAppEnvironmentVariable?: Maybe<SetAppEnvironmentVariablePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setBatchedTaskStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setBatchedTaskStatus?: Maybe<GraphQlMutationResponse>;
    /**
     * Sets the estimation type tied to a board associated via the specified board feature id
     * This mutation is currently in BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: setBoardEstimationType` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setBoardEstimationType?: Maybe<ToggleBoardFeatureOutput>;
    /**
     * Set card color strategy for the board
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'setCardColorStrategy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    setCardColorStrategy?: Maybe<SetCardColorStrategyOutput>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setColumnLimit?: Maybe<SetColumnLimitOutput>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setColumnName?: Maybe<SetColumnNameOutput>;
    /**
     * Update content access level for given content. Only Page and BlogPost contents are supported.Known issue with the API - https://hello.atlassian.net/wiki/spaces/~70121df94c0251be4486aa10462457a7d9db1/pages/1774486949/New+Shared+Dialog+-+Issues+Potential+Resolutions+Backend
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setContentAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setContentAccess?: Maybe<ContentPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setContentState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setContentState?: Maybe<ContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setContentStateAndPublish' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setContentStateAndPublish?: Maybe<ContentState>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setContentStateSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setContentStateSettings?: Maybe<ContentStateSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setDefaultSpaceRoleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setDefaultSpaceRoleAssignments?: Maybe<SetDefaultSpaceRoleAssignmentsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setEditorConversionSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setEditorConversionSettings?: Maybe<EditorConversionSetting>;
    /**
     * Sets the estimation type for the board. Supported estimationTypes are STORY_POINTS and ORIGINAL_ESTIMATE
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setEstimationType?: Maybe<GenericMutationResponse>;
    /**
     * Sets the outbound-auth service credentials in a specific environment for a given app.
     *
     * This makes the assumption that the environment (and hence container) was already created,
     * and the deploy containing the relevant outbound-auth service definition was already deployed.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    setExternalAuthCredentials?: Maybe<SetExternalAuthCredentialsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setFeedUserConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setFeedUserConfig?: Maybe<SetFeedUserConfigPayload>;
    /**
     * Set visibility of card cover images of the specified board
     * This mutation is currently in BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: setIssueMediaVisibility` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setIssueMediaVisibility?: Maybe<SetIssueMediaVisibilityOutput>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setOnboardingState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setOnboardingState?: Maybe<Array<OnboardingState>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setOnboardingStateToComplete' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setOnboardingStateToComplete?: Maybe<Array<OnboardingState>>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    setPolarisSelectedDeliveryProject?: Maybe<SetPolarisSelectedDeliveryProjectPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    setPolarisSnippetPropertiesConfig?: Maybe<SetPolarisSnippetPropertiesConfigPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setPublicLinkDefaultSpaceStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setPublicLinkDefaultSpaceStatus?: Maybe<GlobalSpaceConfiguration>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setRecommendedPagesSpaceStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setRecommendedPagesSpaceStatus?: Maybe<SetRecommendedPagesSpaceStatusPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setRecommendedPagesStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setRecommendedPagesStatus?: Maybe<SetRecommendedPagesStatusPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setRelevantFeedFilters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setRelevantFeedFilters?: Maybe<HomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setSpaceRoleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setSpaceRoleAssignments?: Maybe<SetSpaceRoleAssignmentsPayload>;
    /**
     * Sets the admin swimlane strategy for the board.  Use NONE is not using swimlanes.
     * Strategy effects everyone who views the board.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setSwimlaneStrategy?: Maybe<SetSwimlaneStrategyResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'setTaskStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    setTaskStatus?: Maybe<GraphQlMutationResponse>;
    /**
     * Sets the user swimlane strategy for the board.  Use NONE if not using swimlanes.
     * Strategy affects the current user alone.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    setUserSwimlaneStrategy?: Maybe<SetSwimlaneStrategyResponse>;
    /**
     * For updating navigation customisation settings
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     * * __confluence:atlassian-external__
     *
     *
     */
    settings_updateNavigationCustomisation?: Maybe<SettingsNavigationCustomisation>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'shareResource' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    shareResource?: Maybe<ShareResourcePayload>;
    shepherd?: Maybe<ShepherdMutation>;
    /**
     * Revertibly deletes a space. This will only succeed if the feature flag for space soft-deletion is enabled.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'softDeleteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    softDeleteSpace?: Maybe<SoftDeleteSpacePayload>;
    /**
     * Split issue into separate items
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "splitIssue")' query directive to the 'splitIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    splitIssue?: Maybe<SplitIssueOutput>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    startSprint?: Maybe<SprintResponse>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    subscribeToApp?: Maybe<AppSubscribePayload>;
    /** Team-related mutations */
    team?: Maybe<TeamMutation>;
    /**
     * Migrate all templates in space from TINYMCE to FABRIC editor.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'templateMigration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    templateMigration?: Maybe<TemplateMigration>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'templatize' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    templatize?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Toggles the feature of the specified board feature id
     * This mutation is currently in BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: toggleBoardFeature` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    toggleBoardFeature?: Maybe<ToggleBoardFeatureOutput>;
    townsquare?: Maybe<TownsquareMutationApi>;
    trello: TrelloMutationApi;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    unarchivePolarisInsights?: Maybe<UnarchivePolarisInsightsPayload>;
    /**
     * Allows to remove a space from archive
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unarchiveSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unarchiveSpace?: Maybe<UnarchiveSpacePayload>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    unassignIssueParent?: Maybe<UnassignIssueParentOutput>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unfavouritePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unfavouritePage?: Maybe<FavouritePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unfavouriteSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unfavouriteSpace?: Maybe<FavouriteSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unfollowUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unfollowUser?: Maybe<FollowUserPayload>;
    unified?: Maybe<UnifiedMutation>;
    /**
     * Uninstalls a given app + environment pair into a given installation context.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    uninstallApp?: Maybe<AppUninstallationResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unlikeContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unlikeContent?: Maybe<LikeContentPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    unsubscribeFromApp?: Maybe<AppUnsubscribePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unwatchBlogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unwatchBlogs?: Maybe<WatchSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unwatchContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unwatchContent?: Maybe<WatchContentPayload>;
    /**
     * Stop watching Marketplace App for updates
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    unwatchMarketplaceApp?: Maybe<UnwatchMarketplaceAppPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'unwatchSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    unwatchSpace?: Maybe<WatchSpacePayload>;
    /**
     * Update an existing banner.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateAdminAnnouncementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateAdminAnnouncementBanner?: Maybe<ConfluenceAdminAnnouncementBannerPayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateAppDetails?: Maybe<UpdateAppDetailsResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateArchiveNotes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateArchiveNotes?: Maybe<UpdateArchiveNotesPayload>;
    /**
     * Update Atlassian OAuth Client details
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateAtlassianOAuthClient?: Maybe<UpdateAtlassianOAuthClientResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateComment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateComment?: Maybe<Comment>;
    /**
     * GraphQL mutation to set classification level for content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateContentDataClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateContentDataClassificationLevel?: Maybe<UpdateContentDataClassificationLevelPayload>;
    /**
     * Update direct content restrictions for user by specifying the intention VIEWER/EDITOR/DEFAULT and user/group for the content identified by contentId parameter.
     * Throws subclasses of ServiceException in case of various problems (cannot find content, cannot find user or group, not enough permissions to change content permissions, etc...)Known issue with the API - https://hello.atlassian.net/wiki/spaces/~70121df94c0251be4486aa10462457a7d9db1/pages/1774486949/New+Shared+Dialog+-+Issues+Potential+Resolutions+Backend
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateContentPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateContentPermissions?: Maybe<ContentPermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateCoverPictureWidth' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateCoverPictureWidth?: Maybe<UpdateCoverPictureWidthPayload>;
    /**
     * Update the custom filter with the specified custom filter ID
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    updateCustomFilter?: Maybe<CustomFilterCreateOutput>;
    /**
     * Update the custom filter with the specified custom filter ID
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'updateCustomFilterV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateCustomFilterV2?: Maybe<CustomFilterCreateOutputV2>;
    /**
     * Add or change arbitrary (key, value) properties associated with an entity (service or relationship)
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateDevOpsContainerRelationshipEntityProperties?: Maybe<UpdateDevOpsContainerRelationshipEntityPropertiesPayload>;
    /** Update a DevOps Service */
    updateDevOpsService?: Maybe<UpdateDevOpsServicePayload>;
    /**
     * Updates a relationship between a DevOps Service and a Jira project.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateDevOpsServiceAndJiraProjectRelationship?: Maybe<UpdateDevOpsServiceAndJiraProjectRelationshipPayload>;
    /**
     * Update description for a relationship between a DevOps Service and an Opsgenie team.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateDevOpsServiceAndOpsgenieTeamRelationship?: Maybe<UpdateDevOpsServiceAndOpsgenieTeamRelationshipPayload>;
    /**
     * Update a relationship between a DevOps Service and a repository
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateDevOpsServiceAndRepositoryRelationship?: Maybe<UpdateDevOpsServiceAndRepositoryRelationshipPayload>;
    /** Add or change arbitrary (key, value) properties associated with a DevOpsService */
    updateDevOpsServiceEntityProperties?: Maybe<UpdateDevOpsServiceEntityPropertiesPayload>;
    /** Update an DevOps Service Relationship */
    updateDevOpsServiceRelationship?: Maybe<UpdateDevOpsServiceRelationshipPayload>;
    /**
     * Allows site admins to grant Forge log access to the app developer
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updateDeveloperLogAccess?: Maybe<UpdateDeveloperLogAccessPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateEmbed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateEmbed?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateExternalCollaboratorDefaultSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateExternalCollaboratorDefaultSpace?: Maybe<UpdateExternalCollaboratorDefaultSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateHomeUserSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateHomeUserSettings?: Maybe<HomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateLocalStorage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateLocalStorage?: Maybe<LocalStorage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateNestedPageOwners' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateNestedPageOwners?: Maybe<UpdateNestedPageOwnersPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateOwner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateOwner?: Maybe<UpdateOwnerPayload>;
    /**
     *  @Experimental   you can use it but the API may change and we will make a best effort to not break it.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updatePage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updatePage?: Maybe<UpdatePagePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updatePageOwners' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updatePageOwners?: Maybe<UpdatePageOwnersPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updatePageStatuses' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updatePageStatuses?: Maybe<UpdatePageStatusesPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisComment?: Maybe<UpdatePolarisCommentPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisIdea?: Maybe<UpdatePolarisIdeaPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisIdeaTemplate?: Maybe<UpdatePolarisIdeaTemplatePayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:jira-work__
     *
     *
     */
    updatePolarisInsight?: Maybe<UpdatePolarisInsightPayload>;
    /**
     * Updates play.
     *
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisPlay?: Maybe<UpdatePolarisPlayPayload>;
    /**
     * Updates an existing contribution to a play.
     *
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisPlayContribution?: Maybe<UpdatePolarisPlayContributionPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisView?: Maybe<UpdatePolarisViewPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisViewArrangementInfo?: Maybe<UpdatePolarisViewArrangementInfoPayload>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisViewLastViewedTimestamp?: Maybe<UpdatePolarisViewTimestampPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisViewRankV2?: Maybe<UpdatePolarisViewRankV2Payload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    updatePolarisViewSet?: Maybe<UpdatePolarisViewSetPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updatePushNotificationCustomSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updatePushNotificationCustomSettings?: Maybe<ConfluencePushNotificationSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updatePushNotificationGroupSetting' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updatePushNotificationGroupSetting?: Maybe<ConfluencePushNotificationSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateRelation' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateRelation?: Maybe<UpdateRelationPayload>;
    updateReleaseNote: ContentPlatformReleaseNote;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSiteLookAndFeel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSiteLookAndFeel?: Maybe<UpdateSiteLookAndFeelPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSitePermission' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSitePermission?: Maybe<SitePermission>;
    /**
     * GraphQL mutation to set default classification level for content in a space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSpaceDefaultClassificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSpaceDefaultClassificationLevel?: Maybe<UpdateSpaceDefaultClassificationLevelPayload>;
    /**
     * Updates the space details for a provided space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSpaceDetails' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSpaceDetails?: Maybe<UpdateSpaceDetailsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSpacePermissionDefaults' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSpacePermissionDefaults?: Maybe<UpdateDefaultSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSpacePermissions?: Maybe<UpdateSpacePermissionsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateSpaceTypeSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateSpaceTypeSettings?: Maybe<UpdateSpaceTypeSettingsPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateTemplate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateTemplate?: Maybe<ContentTemplate>;
    /**
     * Create or update a template property
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateTemplatePropertySet' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateTemplatePropertySet?: Maybe<UpdateTemplatePropertySetPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateTitle' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateTitle?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'updateUserPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    updateUserPreferences?: Maybe<UserPreferences>;
    /**
     * Upgrades a given app + environment pair into a given installation context.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    upgradeApp?: Maybe<AppInstallationUpgradeResponse>;
    /**
     * Retrieves the current user's auth token for the specified extension.
     *
     * When you provide contextIds, it will return an oauth token with a claim
     * for the primary context provided.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    userAuthTokenForExtension?: Maybe<UserAuthTokenForExtensionResponse>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    virtualAgent?: Maybe<VirtualAgentMutationApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'watchBlogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    watchBlogs?: Maybe<WatchSpacePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'watchContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    watchContent?: Maybe<WatchContentPayload>;
    /**
     * Start watching Marketplace App for updates
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    watchMarketplaceApp?: Maybe<WatchMarketplaceAppPayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'watchSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    watchSpace?: Maybe<WatchSpacePayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsMutation")' query directive to the 'workSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    workSuggestions?: Maybe<WorkSuggestionsMutation>;
};

export type MutationActivatePaywallContentArgs = {
    input: ActivatePaywallContentInput;
};

export type MutationAddBetaUserAsSiteCreatorArgs = {
    input: AddBetaUserAsSiteCreatorInput;
};

export type MutationAddDefaultExCoSpacePermissionsArgs = {
    spacePermissionsInput: AddDefaultExCoSpacePermissionsInput;
};

export type MutationAddLabelsArgs = {
    input: AddLabelsInput;
};

export type MutationAddPublicLinkPermissionsArgs = {
    input: AddPublicLinkPermissionsInput;
};

export type MutationAddReactionArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    containerId: Scalars["String"]["input"];
    containerType: ContainerType;
    contentId: Scalars["String"]["input"];
    contentType: GraphQlReactionContentType;
    emojiId: Scalars["String"]["input"];
};

export type MutationAgentStudio_CreateAgentArgs = {
    cloudId: Scalars["String"]["input"];
    input: AgentStudioCreateAgentInput;
};

export type MutationAgentStudio_UpdateAgentActionsArgs = {
    id: Scalars["ID"]["input"];
    input: AgentStudioActionConfigurationInput;
};

export type MutationAgentStudio_UpdateAgentDetailsArgs = {
    id: Scalars["ID"]["input"];
    input: AgentStudioUpdateAgentDetailsInput;
};

export type MutationAgentStudio_UpdateAgentKnowledgeSourcesArgs = {
    id: Scalars["ID"]["input"];
    input: AgentStudioKnowledgeConfigurationInput;
};

export type MutationAgentStudio_UpdateConversationStartersArgs = {
    id: Scalars["ID"]["input"];
    input: AgentStudioUpdateConversationStartersInput;
};

export type MutationApplyPolarisProjectTemplateArgs = {
    input: ApplyPolarisProjectTemplateInput;
};

export type MutationArchivePagesArgs = {
    input: Array<InputMaybe<BulkArchivePagesInput>>;
};

export type MutationArchivePolarisInsightsArgs = {
    containers?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    project: Scalars["ID"]["input"];
};

export type MutationArchiveSpaceArgs = {
    input: ArchiveSpaceInput;
};

export type MutationAssignIssueParentArgs = {
    input?: InputMaybe<AssignIssueParentInput>;
};

export type MutationAttachDanglingCommentArgs = {
    input: ReattachInlineCommentInput;
};

export type MutationBoardCardMoveArgs = {
    input?: InputMaybe<BoardCardMoveInput>;
};

export type MutationBulkDeleteContentDataClassificationLevelArgs = {
    input: BulkDeleteContentDataClassificationLevelInput;
};

export type MutationBulkRemoveRoleAssignmentFromSpacesArgs = {
    input: BulkRemoveRoleAssignmentFromSpacesInput;
};

export type MutationBulkSetRoleAssignmentToSpacesArgs = {
    input: BulkSetRoleAssignmentToSpacesInput;
};

export type MutationBulkSetSpacePermissionArgs = {
    input: BulkSetSpacePermissionInput;
};

export type MutationBulkSetSpacePermissionAsyncArgs = {
    input: BulkSetSpacePermissionInput;
};

export type MutationBulkUnarchivePagesArgs = {
    includeChildren?: InputMaybe<
        Array<InputMaybe<Scalars["Boolean"]["input"]>>
    >;
    pageIDs?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    parentPageId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type MutationBulkUpdateContentDataClassificationLevelArgs = {
    input: BulkUpdateContentDataClassificationLevelInput;
};

export type MutationBulkUpdateMainSpaceSidebarLinksArgs = {
    input: Array<InputMaybe<BulkUpdateMainSpaceSidebarLinksInput>>;
    spaceKey: Scalars["String"]["input"];
};

export type MutationClearRestrictionsForFreeArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationCompleteSprintArgs = {
    input?: InputMaybe<CompleteSprintInput>;
};

export type MutationConfigurePolarisRefreshArgs = {
    input: ConfigurePolarisRefreshInput;
};

export type MutationConfluenceLegacy_ActivatePaywallContentArgs = {
    input: ConfluenceLegacyActivatePaywallContentInput;
};

export type MutationConfluenceLegacy_AddDefaultExCoSpacePermissionsArgs = {
    spacePermissionsInput: ConfluenceLegacyAddDefaultExCoSpacePermissionsInput;
};

export type MutationConfluenceLegacy_AddLabelsArgs = {
    input: ConfluenceLegacyAddLabelsInput;
};

export type MutationConfluenceLegacy_AddPublicLinkPermissionsArgs = {
    input: ConfluenceLegacyAddPublicLinkPermissionsInput;
};

export type MutationConfluenceLegacy_AddReactionArgs = {
    containerId: Scalars["String"]["input"];
    containerType: ConfluenceLegacyContainerType;
    contentId: Scalars["String"]["input"];
    contentType: ConfluenceLegacyReactionContentType;
    emojiId: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_ArchivePagesArgs = {
    input: Array<InputMaybe<ConfluenceLegacyBulkArchivePagesInput>>;
};

export type MutationConfluenceLegacy_AttachDanglingCommentArgs = {
    input: ConfluenceLegacyReattachInlineCommentInput;
};

export type MutationConfluenceLegacy_BulkArchivePagesArgs = {
    archiveNote?: InputMaybe<Scalars["String"]["input"]>;
    includeChildren?: InputMaybe<
        Array<InputMaybe<Scalars["Boolean"]["input"]>>
    >;
    pageIDs?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
};

export type MutationConfluenceLegacy_BulkDeleteContentDataClassificationLevelArgs =
    {
        input: ConfluenceLegacyBulkDeleteContentDataClassificationLevelInput;
    };

export type MutationConfluenceLegacy_BulkSetSpacePermissionArgs = {
    input: ConfluenceLegacyBulkSetSpacePermissionInput;
};

export type MutationConfluenceLegacy_BulkSetSpacePermissionAsyncArgs = {
    input: ConfluenceLegacyBulkSetSpacePermissionInput;
};

export type MutationConfluenceLegacy_BulkUnarchivePagesArgs = {
    includeChildren?: InputMaybe<
        Array<InputMaybe<Scalars["Boolean"]["input"]>>
    >;
    pageIDs?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    parentPageId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type MutationConfluenceLegacy_BulkUpdateContentDataClassificationLevelArgs =
    {
        input: ConfluenceLegacyBulkUpdateContentDataClassificationLevelInput;
    };

export type MutationConfluenceLegacy_BulkUpdateMainSpaceSidebarLinksArgs = {
    input: Array<
        InputMaybe<ConfluenceLegacyBulkUpdateMainSpaceSidebarLinksInput>
    >;
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_ClearRestrictionsForFreeArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_ContactAdminArgs = {
    input: ConfluenceLegacyContactAdminMutationInput;
};

export type MutationConfluenceLegacy_ConvertPageToLiveEditActionArgs = {
    input: ConfluenceLegacyConvertPageToLiveEditActionInput;
};

export type MutationConfluenceLegacy_CopyDefaultSpacePermissionsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_CopySpacePermissionsArgs = {
    shouldIncludeExCo?: InputMaybe<Scalars["Boolean"]["input"]>;
    sourceSpaceKey: Scalars["String"]["input"];
    targetSpaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_CreateAdminAnnouncementBannerArgs = {
    announcementBanner: ConfluenceLegacyCreateAdminAnnouncementBannerInput;
};

export type MutationConfluenceLegacy_CreateContentContextualArgs = {
    input: ConfluenceLegacyCreateContentInput;
};

export type MutationConfluenceLegacy_CreateContentGlobalArgs = {
    input: ConfluenceLegacyCreateContentInput;
};

export type MutationConfluenceLegacy_CreateContentInlineArgs = {
    input: ConfluenceLegacyCreateInlineContentInput;
};

export type MutationConfluenceLegacy_CreateContentTemplateLabelsArgs = {
    input: ConfluenceLegacyCreateContentTemplateLabelsInput;
};

export type MutationConfluenceLegacy_CreateFaviconFilesArgs = {
    input: ConfluenceLegacyCreateFaviconFilesInput;
};

export type MutationConfluenceLegacy_CreateFooterCommentArgs = {
    input: ConfluenceLegacyCreateCommentInput;
};

export type MutationConfluenceLegacy_CreateInlineCommentArgs = {
    input: ConfluenceLegacyCreateInlineCommentInput;
};

export type MutationConfluenceLegacy_CreateInlineTaskNotificationArgs = {
    input: ConfluenceLegacyCreateInlineTaskNotificationInput;
};

export type MutationConfluenceLegacy_CreateLivePageArgs = {
    input: ConfluenceLegacyCreateLivePageInput;
};

export type MutationConfluenceLegacy_CreateMentionNotificationArgs = {
    input: ConfluenceLegacyCreateMentionNotificationInput;
};

export type MutationConfluenceLegacy_CreateMentionReminderNotificationArgs = {
    input: ConfluenceLegacyCreateMentionReminderNotificationInput;
};

export type MutationConfluenceLegacy_CreateOnboardingSpaceArgs = {
    spaceType: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_CreateOrUpdateArchivePageNoteArgs = {
    archiveNote: Scalars["String"]["input"];
    pageId: Scalars["Long"]["input"];
};

export type MutationConfluenceLegacy_CreatePersonalSpaceArgs = {
    input: ConfluenceLegacyCreatePersonalSpaceInput;
};

export type MutationConfluenceLegacy_CreateSpaceArgs = {
    input: ConfluenceLegacyCreateSpaceInput;
};

export type MutationConfluenceLegacy_CreateSpaceContentStateArgs = {
    contentState: ConfluenceLegacyContentStateInput;
};

export type MutationConfluenceLegacy_CreateSystemSpaceArgs = {
    input: ConfluenceLegacySystemSpaceHomepageInput;
};

export type MutationConfluenceLegacy_CreateTemplateArgs = {
    contentTemplate: ConfluenceLegacyCreateContentTemplateInput;
};

export type MutationConfluenceLegacy_DeactivatePaywallContentArgs = {
    input: ConfluenceLegacyDeactivatePaywallContentInput;
};

export type MutationConfluenceLegacy_DeleteCommentArgs = {
    commentIdToDelete: Scalars["ID"]["input"];
    deleteFrom?: InputMaybe<ConfluenceLegacyCommentDeletionLocation>;
};

export type MutationConfluenceLegacy_DeleteContentArgs = {
    action: ConfluenceLegacyContentDeleteActionType;
    contentId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_DeleteContentDataClassificationLevelArgs =
    {
        input: ConfluenceLegacyDeleteContentDataClassificationLevelInput;
    };

export type MutationConfluenceLegacy_DeleteContentStateArgs = {
    stateInput: ConfluenceLegacyContentStateInput;
};

export type MutationConfluenceLegacy_DeleteContentTemplateLabelArgs = {
    input: ConfluenceLegacyDeleteContentTemplateLabelInput;
};

export type MutationConfluenceLegacy_DeleteDefaultSpaceRolesArgs = {
    input: ConfluenceLegacyDeleteDefaultSpaceRolesInput;
};

export type MutationConfluenceLegacy_DeleteExCoSpacePermissionsArgs = {
    input: Array<InputMaybe<ConfluenceLegacyDeleteExCoSpacePermissionsInput>>;
};

export type MutationConfluenceLegacy_DeleteInlineCommentArgs = {
    input: ConfluenceLegacyDeleteInlineCommentInput;
};

export type MutationConfluenceLegacy_DeleteLabelArgs = {
    input: ConfluenceLegacyDeleteLabelInput;
};

export type MutationConfluenceLegacy_DeletePagesArgs = {
    input: Array<InputMaybe<ConfluenceLegacyDeletePagesInput>>;
};

export type MutationConfluenceLegacy_DeleteReactionArgs = {
    containerId: Scalars["String"]["input"];
    containerType: ConfluenceLegacyContainerType;
    contentId: Scalars["String"]["input"];
    contentType: ConfluenceLegacyReactionContentType;
    emojiId: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_DeleteRelationArgs = {
    input: ConfluenceLegacyDeleteRelationInput;
};

export type MutationConfluenceLegacy_DeleteSpaceDefaultClassificationLevelArgs =
    {
        input: ConfluenceLegacyDeleteSpaceDefaultClassificationLevelInput;
    };

export type MutationConfluenceLegacy_DeleteSpaceRolesArgs = {
    input: ConfluenceLegacyDeleteSpaceRolesInput;
};

export type MutationConfluenceLegacy_DeleteTemplateArgs = {
    contentTemplateId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_DisableExperimentArgs = {
    experimentKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_DisablePublicLinkForPageArgs = {
    pageId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_EnableExperimentArgs = {
    experimentKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_EnablePublicLinkForPageArgs = {
    pageId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_FavouritePageArgs = {
    favouritePageInput: ConfluenceLegacyFavouritePageInput;
};

export type MutationConfluenceLegacy_FavouriteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_FollowUserArgs = {
    followUserInput: ConfluenceLegacyFollowUserInput;
};

export type MutationConfluenceLegacy_GrantContentAccessArgs = {
    grantContentAccessInput: ConfluenceLegacyGrantContentAccessInput;
};

export type MutationConfluenceLegacy_HardDeleteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_LikeContentArgs = {
    input: ConfluenceLegacyLikeContentInput;
};

export type MutationConfluenceLegacy_MarkCommentsAsReadArgs = {
    input: ConfluenceLegacyMarkCommentsAsReadInput;
};

export type MutationConfluenceLegacy_MarkFeatureDiscoveredArgs = {
    featureKey: Scalars["String"]["input"];
    pluginKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_MigrateSpaceShortcutsArgs = {
    shortcutsList: Array<InputMaybe<ConfluenceLegacySpaceShortcutsInput>>;
    spaceId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_MoveBlogArgs = {
    input: ConfluenceLegacyMoveBlogInput;
};

export type MutationConfluenceLegacy_MovePageAfterArgs = {
    input: ConfluenceLegacyMovePageAsSiblingInput;
};

export type MutationConfluenceLegacy_MovePageAppendArgs = {
    input: ConfluenceLegacyMovePageAsChildInput;
};

export type MutationConfluenceLegacy_MovePageBeforeArgs = {
    input: ConfluenceLegacyMovePageAsSiblingInput;
};

export type MutationConfluenceLegacy_MovePageTopLevelArgs = {
    input: ConfluenceLegacyMovePageTopLevelInput;
};

export type MutationConfluenceLegacy_NewPageArgs = {
    input: ConfluenceLegacyNewPageInput;
};

export type MutationConfluenceLegacy_NotifyUsersOnFirstViewArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_OpenUpSpacePermissionsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_PatchCommentsSummaryArgs = {
    input: ConfluenceLegacyPatchCommentsSummaryInput;
};

export type MutationConfluenceLegacy_PublicLinkPagesAdminActionArgs = {
    action: ConfluenceLegacyPublicLinkAdminAction;
    pageIds: Array<Scalars["ID"]["input"]>;
};

export type MutationConfluenceLegacy_PublicLinkSpacesActionArgs = {
    action: ConfluenceLegacyPublicLinkAdminAction;
    spaceIds: Array<Scalars["ID"]["input"]>;
};

export type MutationConfluenceLegacy_RefreshTeamCalendarArgs = {
    subCalendarId: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_RemoveAllDirectUserSpacePermissionsArgs = {
    accountId: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_RemoveContentStateArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_RemoveGroupSpacePermissionsArgs = {
    spacePermissionsInput: ConfluenceLegacyRemoveGroupSpacePermissionsInput;
};

export type MutationConfluenceLegacy_RemovePublicLinkPermissionsArgs = {
    input: ConfluenceLegacyRemovePublicLinkPermissionsInput;
};

export type MutationConfluenceLegacy_RemoveUserSpacePermissionsArgs = {
    spacePermissionsInput: ConfluenceLegacyRemoveUserSpacePermissionsInput;
};

export type MutationConfluenceLegacy_ReplyInlineCommentArgs = {
    input: ConfluenceLegacyReplyInlineCommentInput;
};

export type MutationConfluenceLegacy_RequestPageAccessArgs = {
    requestPageAccessInput: ConfluenceLegacyRequestPageAccessInput;
};

export type MutationConfluenceLegacy_ResetExCoSpacePermissionsArgs = {
    input: ConfluenceLegacyResetExCoSpacePermissionsInput;
};

export type MutationConfluenceLegacy_ResetSpaceContentStatesArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_ResetSpaceRolesFromAnotherSpaceArgs = {
    input: ConfluenceLegacyResetSpaceRolesFromAnotherSpaceInput;
};

export type MutationConfluenceLegacy_ResetSystemSpaceHomepageArgs = {
    input: ConfluenceLegacySystemSpaceHomepageInput;
};

export type MutationConfluenceLegacy_ResolveInlineCommentArgs = {
    commentId: Scalars["ID"]["input"];
    dangling: Scalars["Boolean"]["input"];
    resolved: Scalars["Boolean"]["input"];
};

export type MutationConfluenceLegacy_RestoreSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_RevertToLegacyEditorArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_SetBatchedTaskStatusArgs = {
    batchedInlineTasksInput: ConfluenceLegacyBatchedInlineTasksInput;
};

export type MutationConfluenceLegacy_SetContentAccessArgs = {
    accessType: ConfluenceLegacyContentAccessInputType;
    contentId: Scalars["ID"]["input"];
};

export type MutationConfluenceLegacy_SetContentStateArgs = {
    contentId: Scalars["ID"]["input"];
    contentState: ConfluenceLegacyContentStateInput;
};

export type MutationConfluenceLegacy_SetContentStateAndPublishArgs = {
    contentId: Scalars["ID"]["input"];
    contentState: ConfluenceLegacyContentStateInput;
};

export type MutationConfluenceLegacy_SetContentStateSettingsArgs = {
    contentStatesSetting: Scalars["Boolean"]["input"];
    customStatesSetting: Scalars["Boolean"]["input"];
    spaceKey: Scalars["String"]["input"];
    spaceStatesSetting: Scalars["Boolean"]["input"];
};

export type MutationConfluenceLegacy_SetDefaultSpaceRolesArgs = {
    input: ConfluenceLegacySetDefaultSpaceRolesInput;
};

export type MutationConfluenceLegacy_SetEditorConversionSettingsArgs = {
    spaceKey: Scalars["String"]["input"];
    value: ConfluenceLegacyEditorConversionSetting;
};

export type MutationConfluenceLegacy_SetFeedUserConfigArgs = {
    input: ConfluenceLegacySetFeedUserConfigInput;
};

export type MutationConfluenceLegacy_SetOnboardingStateArgs = {
    states?: InputMaybe<Array<ConfluenceLegacyOnboardingStateInput>>;
};

export type MutationConfluenceLegacy_SetOnboardingStateToCompleteArgs = {
    key?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationConfluenceLegacy_SetPublicLinkDefaultSpaceStatusArgs = {
    status: ConfluenceLegacyPublicLinkDefaultSpaceStatus;
};

export type MutationConfluenceLegacy_SetRecommendedPagesSpaceStatusArgs = {
    input: ConfluenceLegacySetRecommendedPagesSpaceStatusInput;
};

export type MutationConfluenceLegacy_SetRecommendedPagesStatusArgs = {
    input: ConfluenceLegacySetRecommendedPagesStatusInput;
};

export type MutationConfluenceLegacy_SetRelevantFeedFiltersArgs = {
    relevantFeedSpacesFilter: Array<InputMaybe<Scalars["Long"]["input"]>>;
    relevantFeedUsersFilter: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type MutationConfluenceLegacy_SetShowActivityFeedArgs = {
    showActivityFeed: Scalars["Boolean"]["input"];
};

export type MutationConfluenceLegacy_SetSpaceRolesArgs = {
    input: ConfluenceLegacySetSpaceRolesInput;
};

export type MutationConfluenceLegacy_SetTaskStatusArgs = {
    inlineTasksInput: ConfluenceLegacyInlineTasksInput;
};

export type MutationConfluenceLegacy_ShareResourceArgs = {
    shareResourceInput: ConfluenceLegacyShareResourceInput;
};

export type MutationConfluenceLegacy_SoftDeleteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_TemplateMigrationArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_TemplatizeArgs = {
    input: ConfluenceLegacyTemplatizeInput;
};

export type MutationConfluenceLegacy_UnfavouritePageArgs = {
    favouritePageInput: ConfluenceLegacyFavouritePageInput;
};

export type MutationConfluenceLegacy_UnfavouriteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationConfluenceLegacy_UnfollowUserArgs = {
    followUserInput: ConfluenceLegacyFollowUserInput;
};

export type MutationConfluenceLegacy_UnlikeContentArgs = {
    input: ConfluenceLegacyLikeContentInput;
};

export type MutationConfluenceLegacy_UnwatchBlogsArgs = {
    watchSpaceInput: ConfluenceLegacyWatchSpaceInput;
};

export type MutationConfluenceLegacy_UnwatchContentArgs = {
    watchContentInput: ConfluenceLegacyWatchContentInput;
};

export type MutationConfluenceLegacy_UnwatchSpaceArgs = {
    watchSpaceInput: ConfluenceLegacyWatchSpaceInput;
};

export type MutationConfluenceLegacy_UpdateAdminAnnouncementBannerArgs = {
    announcementBanner: ConfluenceLegacyUpdateAdminAnnouncementBannerInput;
};

export type MutationConfluenceLegacy_UpdateArchiveNotesArgs = {
    input: Array<InputMaybe<ConfluenceLegacyUpdateArchiveNotesInput>>;
};

export type MutationConfluenceLegacy_UpdateCommentArgs = {
    input: ConfluenceLegacyUpdateCommentInput;
};

export type MutationConfluenceLegacy_UpdateContentDataClassificationLevelArgs =
    {
        input: ConfluenceLegacyUpdateContentDataClassificationLevelInput;
    };

export type MutationConfluenceLegacy_UpdateContentPermissionsArgs = {
    contentId: Scalars["ID"]["input"];
    input: Array<InputMaybe<ConfluenceLegacyUpdateContentPermissionsInput>>;
};

export type MutationConfluenceLegacy_UpdateEmbedArgs = {
    input: ConfluenceLegacyUpdateEmbedInput;
};

export type MutationConfluenceLegacy_UpdateExCoSpacePermissionsArgs = {
    input: Array<InputMaybe<ConfluenceLegacyUpdateExCoSpacePermissionsInput>>;
};

export type MutationConfluenceLegacy_UpdateExternalCollaboratorDefaultSpaceArgs =
    {
        input: ConfluenceLegacyUpdateExternalCollaboratorDefaultSpaceInput;
    };

export type MutationConfluenceLegacy_UpdateHomeUserSettingsArgs = {
    homeUserSettings: ConfluenceLegacyHomeUserSettingsInput;
};

export type MutationConfluenceLegacy_UpdateLocalStorageArgs = {
    localStorage: ConfluenceLegacyLocalStorageInput;
};

export type MutationConfluenceLegacy_UpdateNestedPageOwnersArgs = {
    input: ConfluenceLegacyUpdatedNestedPageOwnersInput;
};

export type MutationConfluenceLegacy_UpdateOwnerArgs = {
    input: ConfluenceLegacyUpdateOwnerInput;
};

export type MutationConfluenceLegacy_UpdatePageArgs = {
    input: ConfluenceLegacyUpdatePageInput;
};

export type MutationConfluenceLegacy_UpdatePageOwnersArgs = {
    input: ConfluenceLegacyUpdatePageOwnersInput;
};

export type MutationConfluenceLegacy_UpdatePageStatusesArgs = {
    input: ConfluenceLegacyUpdatePageStatusesInput;
};

export type MutationConfluenceLegacy_UpdatePushNotificationCustomSettingsArgs =
    {
        customSettings: ConfluenceLegacyPushNotificationCustomSettingsInput;
    };

export type MutationConfluenceLegacy_UpdatePushNotificationGroupSettingArgs = {
    group: ConfluenceLegacyPushNotificationGroupInputType;
};

export type MutationConfluenceLegacy_UpdateRelationArgs = {
    input: ConfluenceLegacyUpdateRelationInput;
};

export type MutationConfluenceLegacy_UpdateSiteLookAndFeelArgs = {
    input: ConfluenceLegacyUpdateSiteLookAndFeelInput;
};

export type MutationConfluenceLegacy_UpdateSitePermissionArgs = {
    input: ConfluenceLegacySitePermissionInput;
};

export type MutationConfluenceLegacy_UpdateSpaceDefaultClassificationLevelArgs =
    {
        input: ConfluenceLegacyUpdateSpaceDefaultClassificationLevelInput;
    };

export type MutationConfluenceLegacy_UpdateSpacePermissionDefaultsArgs = {
    input: Array<ConfluenceLegacyUpdateDefaultSpacePermissionsInput>;
};

export type MutationConfluenceLegacy_UpdateSpacePermissionsArgs = {
    input: ConfluenceLegacyUpdateSpacePermissionsInput;
};

export type MutationConfluenceLegacy_UpdateSpaceTypeSettingsArgs = {
    input: ConfluenceLegacyUpdateSpaceTypeSettingsInput;
};

export type MutationConfluenceLegacy_UpdateTemplateArgs = {
    contentTemplate: ConfluenceLegacyUpdateContentTemplateInput;
};

export type MutationConfluenceLegacy_UpdateTemplatePropertySetArgs = {
    input: ConfluenceLegacyUpdateTemplatePropertySetInput;
};

export type MutationConfluenceLegacy_UpdateTitleArgs = {
    contentId: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationConfluenceLegacy_UpdateUserPreferencesArgs = {
    userPreferences: ConfluenceLegacyUserPreferencesInput;
};

export type MutationConfluenceLegacy_WatchBlogsArgs = {
    watchSpaceInput: ConfluenceLegacyWatchSpaceInput;
};

export type MutationConfluenceLegacy_WatchContentArgs = {
    watchContentInput: ConfluenceLegacyWatchContentInput;
};

export type MutationConfluenceLegacy_WatchSpaceArgs = {
    watchSpaceInput: ConfluenceLegacyWatchSpaceInput;
};

export type MutationConfluence_DeleteCalendarCustomEventTypeArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceDeleteCalendarCustomEventTypeInput;
};

export type MutationConfluence_DeleteSubCalendarAllFutureEventsArgs = {
    cloudId: Scalars["ID"]["input"];
    input?: InputMaybe<ConfluenceDeleteSubCalendarAllFutureEventsInput>;
};

export type MutationConfluence_DeleteSubCalendarEventArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceDeleteSubCalendarEventInput;
};

export type MutationConfluence_DeleteSubCalendarHiddenEventsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: Array<ConfluenceDeleteSubCalendarHiddenEventsInput>;
};

export type MutationConfluence_DeleteSubCalendarPrivateUrlArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceDeleteSubCalendarPrivateUrlInput;
};

export type MutationConfluence_DeleteSubCalendarSingleEventArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceDeleteSubCalendarSingleEventInput;
};

export type MutationConfluence_InviteUsersArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceInviteUserInput;
};

export type MutationConfluence_MakeSubCalendarPrivateUrlArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceMakeSubCalendarPrivateUrlInput;
};

export type MutationConfluence_ReopenCommentArgs = {
    cloudId: Scalars["ID"]["input"];
    commentId: Scalars["ID"]["input"];
};

export type MutationConfluence_ResolveCommentsArgs = {
    cloudId: Scalars["ID"]["input"];
    commentIds: Array<InputMaybe<Scalars["ID"]["input"]>>;
};

export type MutationConfluence_UnwatchSubCalendarArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceUnwatchSubCalendarInput;
};

export type MutationConfluence_UpdateSubCalendarHiddenEventsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: Array<ConfluenceUpdateSubCalendarHiddenEventsInput>;
};

export type MutationConfluence_UpdateTeamPresenceSpaceSettingsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceUpdateTeamPresenceSpaceSettingsInput;
};

export type MutationConfluence_WatchSubCalendarArgs = {
    cloudId: Scalars["ID"]["input"];
    input: ConfluenceWatchSubCalendarInput;
};

export type MutationConnectionManager_CreateApiTokenConnectionForJiraProjectArgs =
    {
        createApiTokenConnectionInput?: InputMaybe<ConnectionManagerCreateApiTokenConnectionInput>;
        jiraProjectARI?: InputMaybe<Scalars["String"]["input"]>;
    };

export type MutationConnectionManager_CreateOAuthConnectionForJiraProjectArgs =
    {
        createOAuthConnectionInput: ConnectionManagerCreateOAuthConnectionInput;
        jiraProjectARI: Scalars["ID"]["input"];
    };

export type MutationConnectionManager_DeleteApiTokenConnectionForJiraProjectArgs =
    {
        integrationKey?: InputMaybe<Scalars["String"]["input"]>;
        jiraProjectARI?: InputMaybe<Scalars["String"]["input"]>;
    };

export type MutationConnectionManager_DeleteConnectionForJiraProjectArgs = {
    integrationKey: Scalars["String"]["input"];
    jiraProjectARI: Scalars["ID"]["input"];
};

export type MutationContactAdminArgs = {
    input: ContactAdminMutationInput;
};

export type MutationConvertPageToLiveEditActionArgs = {
    input: ConvertPageToLiveEditActionInput;
};

export type MutationConvertToFolderArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationCopyDefaultSpacePermissionsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationCopyPolarisInsightsArgs = {
    input: CopyPolarisInsightsInput;
};

export type MutationCopySpacePermissionsArgs = {
    shouldIncludeExCo?: InputMaybe<Scalars["Boolean"]["input"]>;
    sourceSpaceKey: Scalars["String"]["input"];
    targetSpaceKey: Scalars["String"]["input"];
};

export type MutationCreateAdminAnnouncementBannerArgs = {
    announcementBanner: ConfluenceCreateAdminAnnouncementBannerInput;
};

export type MutationCreateAppArgs = {
    input: CreateAppInput;
};

export type MutationCreateAppDeploymentArgs = {
    input: CreateAppDeploymentInput;
};

export type MutationCreateAppDeploymentUrlArgs = {
    input: CreateAppDeploymentUrlInput;
};

export type MutationCreateAppTunnelsArgs = {
    input: CreateAppTunnelsInput;
};

export type MutationCreateCardParentArgs = {
    input: CardParentCreateInput;
};

export type MutationCreateColumnArgs = {
    input?: InputMaybe<CreateColumnInput>;
};

export type MutationCreateContentContextualArgs = {
    input: CreateContentInput;
};

export type MutationCreateContentGlobalArgs = {
    input: CreateContentInput;
};

export type MutationCreateContentInlineArgs = {
    input: CreateInlineContentInput;
};

export type MutationCreateContentMentionNotificationActionArgs = {
    input: CreateContentMentionNotificationActionInput;
};

export type MutationCreateContentTemplateLabelsArgs = {
    input: CreateContentTemplateLabelsInput;
};

export type MutationCreateCustomFilterArgs = {
    input?: InputMaybe<CreateCustomFilterInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateCustomFilterV2Args = {
    input?: InputMaybe<CreateCustomFilterInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateDevOpsServiceArgs = {
    input: CreateDevOpsServiceInput;
};

export type MutationCreateDevOpsServiceAndJiraProjectRelationshipArgs = {
    input: CreateDevOpsServiceAndJiraProjectRelationshipInput;
};

export type MutationCreateDevOpsServiceAndOpsgenieTeamRelationshipArgs = {
    input: CreateDevOpsServiceAndOpsgenieTeamRelationshipInput;
};

export type MutationCreateDevOpsServiceAndRepositoryRelationshipArgs = {
    input: CreateDevOpsServiceAndRepositoryRelationshipInput;
};

export type MutationCreateDevOpsServiceRelationshipArgs = {
    input: CreateDevOpsServiceRelationshipInput;
};

export type MutationCreateFaviconFilesArgs = {
    input: CreateFaviconFilesInput;
};

export type MutationCreateFooterCommentArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    input: CreateCommentInput;
};

export type MutationCreateHostedResourceUploadUrlArgs = {
    input: CreateHostedResourceUploadUrlInput;
};

export type MutationCreateInlineCommentArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    input: CreateInlineCommentInput;
};

export type MutationCreateInlineTaskNotificationArgs = {
    input: CreateInlineTaskNotificationInput;
};

export type MutationCreateLivePageArgs = {
    input: CreateLivePageInput;
};

export type MutationCreateMentionNotificationArgs = {
    input: CreateMentionNotificationInput;
};

export type MutationCreateMentionReminderNotificationArgs = {
    input: CreateMentionReminderNotificationInput;
};

export type MutationCreateOnboardingSpaceArgs = {
    spaceType: Scalars["String"]["input"];
};

export type MutationCreateOrUpdateArchivePageNoteArgs = {
    archiveNote: Scalars["String"]["input"];
    pageId: Scalars["Long"]["input"];
};

export type MutationCreatePersonalSpaceArgs = {
    input: CreatePersonalSpaceInput;
};

export type MutationCreatePolarisCommentArgs = {
    input: CreatePolarisCommentInput;
};

export type MutationCreatePolarisIdeaTemplateArgs = {
    input: CreatePolarisIdeaTemplateInput;
};

export type MutationCreatePolarisInsightArgs = {
    input: CreatePolarisInsightInput;
};

export type MutationCreatePolarisPlayArgs = {
    input: CreatePolarisPlayInput;
};

export type MutationCreatePolarisPlayContributionArgs = {
    input: CreatePolarisPlayContribution;
};

export type MutationCreatePolarisViewArgs = {
    input: CreatePolarisViewInput;
};

export type MutationCreatePolarisViewSetArgs = {
    input: CreatePolarisViewSetInput;
};

export type MutationCreateReleaseNoteArgs = {
    announcementPlan?: InputMaybe<Scalars["String"]["input"]>;
    changeCategory?: InputMaybe<Scalars["String"]["input"]>;
    changeStatus?: Scalars["String"]["input"];
    changeType?: Scalars["String"]["input"];
    description: Scalars["JSON"]["input"];
    fdIssueKey?: InputMaybe<Scalars["String"]["input"]>;
    fdIssueLink?: InputMaybe<Scalars["String"]["input"]>;
    featureRolloutDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    featureRolloutEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    fedRAMPProductionReleaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    fedRAMPStagingReleaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    productIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    productNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    releaseNoteFlag?: InputMaybe<Scalars["String"]["input"]>;
    releaseNoteFlagEnvironment?: InputMaybe<Scalars["String"]["input"]>;
    releaseNoteFlagOffValue?: InputMaybe<Scalars["String"]["input"]>;
    releaseNoteFlagProject?: InputMaybe<Scalars["String"]["input"]>;
    title?: Scalars["String"]["input"];
    visibleInFedRAMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationCreateSpaceArgs = {
    input: CreateSpaceInput;
};

export type MutationCreateSpaceContentStateArgs = {
    contentState: ContentStateInput;
};

export type MutationCreateSprintArgs = {
    input?: InputMaybe<CreateSprintInput>;
};

export type MutationCreateSystemSpaceArgs = {
    input: SystemSpaceHomepageInput;
};

export type MutationCreateTemplateArgs = {
    contentTemplate: CreateContentTemplateInput;
};

export type MutationCreateWebTriggerUrlArgs = {
    forceCreate?: InputMaybe<Scalars["Boolean"]["input"]>;
    input: WebTriggerUrlInput;
};

export type MutationCustomerServiceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MutationDeactivatePaywallContentArgs = {
    input: DeactivatePaywallContentInput;
};

export type MutationDeleteAppArgs = {
    input: DeleteAppInput;
};

export type MutationDeleteAppEnvironmentVariableArgs = {
    input: DeleteAppEnvironmentVariableInput;
};

export type MutationDeleteAppTunnelsArgs = {
    input: DeleteAppTunnelInput;
};

export type MutationDeleteColumnArgs = {
    input?: InputMaybe<DeleteColumnInput>;
};

export type MutationDeleteCommentArgs = {
    commentIdToDelete: Scalars["ID"]["input"];
    deleteFrom?: InputMaybe<CommentDeletionLocation>;
};

export type MutationDeleteContentArgs = {
    action: ContentDeleteActionType;
    contentId: Scalars["ID"]["input"];
};

export type MutationDeleteContentDataClassificationLevelArgs = {
    input: DeleteContentDataClassificationLevelInput;
};

export type MutationDeleteContentStateArgs = {
    stateInput: ContentStateInput;
};

export type MutationDeleteContentTemplateLabelArgs = {
    input: DeleteContentTemplateLabelInput;
};

export type MutationDeleteCustomFilterArgs = {
    input?: InputMaybe<DeleteCustomFilterInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationDeleteDefaultSpaceRoleAssignmentsArgs = {
    input: DeleteDefaultSpaceRoleAssignmentsInput;
};

export type MutationDeleteDevOpsContainerRelationshipEntityPropertiesArgs = {
    input: DeleteDevOpsContainerRelationshipEntityPropertiesInput;
};

export type MutationDeleteDevOpsServiceArgs = {
    input: DeleteDevOpsServiceInput;
};

export type MutationDeleteDevOpsServiceAndJiraProjectRelationshipArgs = {
    input: DeleteDevOpsServiceAndJiraProjectRelationshipInput;
};

export type MutationDeleteDevOpsServiceAndOpsgenieTeamRelationshipArgs = {
    input: DeleteDevOpsServiceAndOpsgenieTeamRelationshipInput;
};

export type MutationDeleteDevOpsServiceAndRepositoryRelationshipArgs = {
    input: DeleteDevOpsServiceAndRepositoryRelationshipInput;
};

export type MutationDeleteDevOpsServiceEntityPropertiesArgs = {
    input: DeleteDevOpsServiceEntityPropertiesInput;
};

export type MutationDeleteDevOpsServiceRelationshipArgs = {
    input: DeleteDevOpsServiceRelationshipInput;
};

export type MutationDeleteInlineCommentArgs = {
    input: DeleteInlineCommentInput;
};

export type MutationDeleteLabelArgs = {
    input: DeleteLabelInput;
};

export type MutationDeletePagesArgs = {
    input: Array<InputMaybe<DeletePagesInput>>;
};

export type MutationDeletePolarisIdeaTemplateArgs = {
    input: DeletePolarisIdeaTemplateInput;
};

export type MutationDeletePolarisInsightArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationDeletePolarisPlayContributionArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationDeletePolarisViewArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationDeletePolarisViewSetArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationDeleteReactionArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    containerId: Scalars["String"]["input"];
    containerType: ContainerType;
    contentId: Scalars["String"]["input"];
    contentType: GraphQlReactionContentType;
    emojiId: Scalars["String"]["input"];
};

export type MutationDeleteRelationArgs = {
    input: DeleteRelationInput;
};

export type MutationDeleteSpaceDefaultClassificationLevelArgs = {
    input: DeleteSpaceDefaultClassificationLevelInput;
};

export type MutationDeleteSpaceRoleAssignmentsArgs = {
    input: DeleteSpaceRoleAssignmentsInput;
};

export type MutationDeleteSprintArgs = {
    input?: InputMaybe<DeleteSprintInput>;
};

export type MutationDeleteTemplateArgs = {
    contentTemplateId: Scalars["ID"]["input"];
};

export type MutationDeleteWebTriggerUrlArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationDevai_ContinueJobWithPromptArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
    prompt?: InputMaybe<Scalars["String"]["input"]>;
    repoUrl: Scalars["String"]["input"];
};

export type MutationDevai_CreateTechnicalPlannerJobArgs = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    issueAri: Scalars["ID"]["input"];
    repoUrl: Scalars["URL"]["input"];
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationDevai_InvokeAutodevRovoAgentArgs = {
    agentId: Scalars["ID"]["input"];
    issueId: Scalars["ID"]["input"];
};

export type MutationDevai_InvokeAutodevRovoAgentInBulkArgs = {
    agentId: Scalars["ID"]["input"];
    issueIds: Array<Scalars["ID"]["input"]>;
};

export type MutationDisableExperimentArgs = {
    experimentKey: Scalars["String"]["input"];
};

export type MutationDisablePublicLinkForPageArgs = {
    pageId: Scalars["ID"]["input"];
};

export type MutationEditSprintArgs = {
    input?: InputMaybe<EditSprintInput>;
};

export type MutationEditorDraftSyncActionArgs = {
    input: EditorDraftSyncInput;
};

export type MutationEnableExperimentArgs = {
    experimentKey: Scalars["String"]["input"];
};

export type MutationEnablePublicLinkForPageArgs = {
    pageId: Scalars["ID"]["input"];
};

export type MutationFavouritePageArgs = {
    favouritePageInput: FavouritePageInput;
};

export type MutationFavouriteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationFavouriteSpaceBulkArgs = {
    spaceKeys: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type MutationFollowUserArgs = {
    followUserInput: FollowUserInput;
};

export type MutationGeneratePermsReportArgs = {
    id: Scalars["ID"]["input"];
    targetType: PermsReportTargetType;
};

export type MutationGrantContentAccessArgs = {
    grantContentAccessInput: GrantContentAccessInput;
};

export type MutationGrowthUnifiedProfile_CreateUnifiedProfileArgs = {
    profile: GrowthUnifiedProfileCreateProfileInput;
};

export type MutationHardDeleteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationHelpCenterArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MutationHelpExternalResourceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MutationHelpLayoutArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type MutationHelpObjectStoreArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MutationInstallAppArgs = {
    input: AppInstallationInput;
};

export type MutationInvokeAuxEffectsArgs = {
    input: InvokeAuxEffectsInput;
};

export type MutationInvokeExtensionArgs = {
    input: InvokeExtensionInput;
};

export type MutationInvokePolarisObjectArgs = {
    input: InvokePolarisObjectInput;
};

export type MutationJira_BulkSetBoardViewColumnStateArgs = {
    input: JiraBulkSetBoardViewColumnStateInput;
};

export type MutationJira_CreateCustomBackgroundArgs = {
    input: JiraCreateCustomBackgroundInput;
};

export type MutationJira_DeleteCustomBackgroundArgs = {
    input: JiraProjectDeleteCustomBackgroundInput;
};

export type MutationJira_DiscardUserBoardViewConfigArgs = {
    input: JiraDiscardUserBoardViewConfigInput;
};

export type MutationJira_PublishBoardViewConfigArgs = {
    input: JiraPublishBoardViewConfigInput;
};

export type MutationJira_ReorderBoardViewColumnArgs = {
    input: JiraReorderBoardViewColumnInput;
};

export type MutationJira_SetBoardViewCardFieldSelectedArgs = {
    input: JiraSetBoardViewCardFieldSelectedInput;
};

export type MutationJira_SetBoardViewCardOptionStateArgs = {
    input: JiraSetBoardViewCardOptionStateInput;
};

export type MutationJira_SetBoardViewColumnStateArgs = {
    input: JiraSetBoardViewColumnStateInput;
};

export type MutationJira_SetBoardViewColumnsOrderArgs = {
    input: JiraSetBoardViewColumnsOrderInput;
};

export type MutationJira_SetBoardViewCompletedIssueSearchCutOffArgs = {
    input: JiraSetBoardViewCompletedIssueSearchCutOffInput;
};

export type MutationJira_SetBoardViewFilterArgs = {
    input: JiraSetBoardViewFilterInput;
};

export type MutationJira_SetBoardViewGroupByArgs = {
    input: JiraSetBoardViewGroupByInput;
};

export type MutationJira_SetBoardViewWorkflowSelectedArgs = {
    input: JiraSetBoardViewWorkflowSelectedInput;
};

export type MutationJira_SetViewFilterArgs = {
    input: JiraSetViewFilterInput;
};

export type MutationJira_SetViewGroupByArgs = {
    input: JiraSetViewGroupByInput;
};

export type MutationJira_UpdateProjectBackgroundArgs = {
    input: JiraUpdateBackgroundInput;
};

export type MutationJira_UpdateProjectsSidebarMenuArgs = {
    input: JiraUpdateSidebarMenuDisplaySettingInput;
};

export type MutationKnowledgeBaseArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type MutationKnowledgeBaseSpacePermission_UpdateViewArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    input: KnowledgeBaseSpacePermissionUpdateViewInput;
};

export type MutationLikeContentArgs = {
    input: LikeContentInput;
};

export type MutationMarkCommentsAsReadArgs = {
    input: MarkCommentsAsReadInput;
};

export type MutationMarkFeatureDiscoveredArgs = {
    featureKey: Scalars["String"]["input"];
    pluginKey: Scalars["String"]["input"];
};

export type MutationMigrateSpaceShortcutsArgs = {
    shortcutsList: Array<InputMaybe<GraphQlSpaceShortcutsInput>>;
    spaceId: Scalars["ID"]["input"];
};

export type MutationMoveBlogArgs = {
    input: MoveBlogInput;
};

export type MutationMovePageAfterArgs = {
    input: MovePageAsSiblingInput;
};

export type MutationMovePageAppendArgs = {
    input: MovePageAsChildInput;
};

export type MutationMovePageBeforeArgs = {
    input: MovePageAsSiblingInput;
};

export type MutationMovePageTopLevelArgs = {
    input: MovePageTopLevelInput;
};

export type MutationMoveSprintDownArgs = {
    input?: InputMaybe<MoveSprintDownInput>;
};

export type MutationMoveSprintUpArgs = {
    input?: InputMaybe<MoveSprintUpInput>;
};

export type MutationNewPageArgs = {
    input: NewPageInput;
};

export type MutationNotifyUsersOnFirstViewArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationOpenUpSpacePermissionsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationPatchCommentsSummaryArgs = {
    input: PatchCommentsSummaryInput;
};

export type MutationPlanModeCardCreateArgs = {
    input?: InputMaybe<PlanModeCardCreateInput>;
};

export type MutationPlanModeCardMoveArgs = {
    input?: InputMaybe<PlanModeCardMoveInput>;
};

export type MutationPlaybook_CreateJiraPlaybookArgs = {
    input: CreateJiraPlaybookInput;
};

export type MutationPlaybook_CreateJiraPlaybookStepRunArgs = {
    input: CreateJiraPlaybookStepRunInput;
};

export type MutationPlaybook_DeleteJiraPlaybookArgs = {
    input: DeleteJiraPlaybookInput;
};

export type MutationPlaybook_UpdateJiraPlaybookArgs = {
    input: UpdateJiraPlaybookInput;
};

export type MutationPlaybook_UpdateJiraPlaybookStateArgs = {
    input: UpdateJiraPlaybookStateInput;
};

export type MutationPolarisAddReactionArgs = {
    input: PolarisAddReactionInput;
};

export type MutationPolarisDeleteReactionArgs = {
    input: PolarisDeleteReactionInput;
};

export type MutationPublicLinkPagesAdminActionArgs = {
    action: PublicLinkAdminAction;
    pageIds: Array<Scalars["ID"]["input"]>;
};

export type MutationPublicLinkSpacesActionArgs = {
    action: PublicLinkAdminAction;
    spaceIds: Array<Scalars["ID"]["input"]>;
};

export type MutationPublishReleaseNoteArgs = {
    id: Scalars["String"]["input"];
};

export type MutationRadar_UpdateFocusAreaMappingsArgs = {
    cloudId: Scalars["ID"]["input"];
    input: Array<RadarFocusAreaMappingsInput>;
};

export type MutationRankCardParentArgs = {
    input: CardParentRankInput;
};

export type MutationRankColumnArgs = {
    input?: InputMaybe<RankColumnInput>;
};

export type MutationRankCustomFilterArgs = {
    input?: InputMaybe<RankCustomFilterInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationRecoverSpaceAdminPermissionArgs = {
    input: RecoverSpaceAdminPermissionInput;
};

export type MutationRecoverSpaceWithAdminRoleAssignmentArgs = {
    input: RecoverSpaceWithAdminRoleAssignmentInput;
};

export type MutationRefreshPolarisSnippetsArgs = {
    input: RefreshPolarisSnippetsInput;
};

export type MutationRefreshTeamCalendarArgs = {
    subCalendarId: Scalars["String"]["input"];
};

export type MutationRegisterTunnelArgs = {
    input: RegisterTunnelInput;
};

export type MutationRemoveAllDirectUserSpacePermissionsArgs = {
    accountId: Scalars["String"]["input"];
};

export type MutationRemoveContentStateArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationRemoveGroupSpacePermissionsArgs = {
    spacePermissionsInput: RemoveGroupSpacePermissionsInput;
};

export type MutationRemovePublicLinkPermissionsArgs = {
    input: RemovePublicLinkPermissionsInput;
};

export type MutationRemoveUserSpacePermissionsArgs = {
    spacePermissionsInput: RemoveUserSpacePermissionsInput;
};

export type MutationReplyInlineCommentArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    input: ReplyInlineCommentInput;
};

export type MutationRequestPageAccessArgs = {
    requestPageAccessInput: RequestPageAccessInput;
};

export type MutationResetExCoSpacePermissionsArgs = {
    input: ResetExCoSpacePermissionsInput;
};

export type MutationResetSpaceContentStatesArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationResetSpaceRolesFromAnotherSpaceArgs = {
    input: ResetSpaceRolesFromAnotherSpaceInput;
};

export type MutationResetSystemSpaceHomepageArgs = {
    input: SystemSpaceHomepageInput;
};

export type MutationResetToDefaultSpaceRoleAssignmentsArgs = {
    input: ResetToDefaultSpaceRoleAssignmentsInput;
};

export type MutationResolveInlineCommentArgs = {
    commentId: Scalars["ID"]["input"];
    dangling: Scalars["Boolean"]["input"];
    resolved: Scalars["Boolean"]["input"];
};

export type MutationResolvePolarisObjectArgs = {
    input: ResolvePolarisObjectInput;
};

export type MutationResolveRestrictionsArgs = {
    input: Array<InputMaybe<ResolveRestrictionsInput>>;
};

export type MutationResolveRestrictionsForSubjectsArgs = {
    input: ResolveRestrictionsForSubjectsInput;
};

export type MutationRestoreSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationRevertToLegacyEditorArgs = {
    contentId: Scalars["ID"]["input"];
};

export type MutationSetAppEnvironmentVariableArgs = {
    input: SetAppEnvironmentVariableInput;
};

export type MutationSetBatchedTaskStatusArgs = {
    batchedInlineTasksInput: BatchedInlineTasksInput;
};

export type MutationSetBoardEstimationTypeArgs = {
    input?: InputMaybe<SetBoardEstimationTypeInput>;
};

export type MutationSetCardColorStrategyArgs = {
    input?: InputMaybe<SetCardColorStrategyInput>;
};

export type MutationSetColumnLimitArgs = {
    input?: InputMaybe<SetColumnLimitInput>;
};

export type MutationSetColumnNameArgs = {
    input?: InputMaybe<SetColumnNameInput>;
};

export type MutationSetContentAccessArgs = {
    accessType: ContentAccessInputType;
    contentId: Scalars["ID"]["input"];
};

export type MutationSetContentStateArgs = {
    contentId: Scalars["ID"]["input"];
    contentState: ContentStateInput;
};

export type MutationSetContentStateAndPublishArgs = {
    contentId: Scalars["ID"]["input"];
    contentState: ContentStateInput;
};

export type MutationSetContentStateSettingsArgs = {
    contentStatesSetting: Scalars["Boolean"]["input"];
    customStatesSetting: Scalars["Boolean"]["input"];
    spaceKey: Scalars["String"]["input"];
    spaceStatesSetting: Scalars["Boolean"]["input"];
};

export type MutationSetDefaultSpaceRoleAssignmentsArgs = {
    input: SetDefaultSpaceRoleAssignmentsInput;
};

export type MutationSetEditorConversionSettingsArgs = {
    spaceKey: Scalars["String"]["input"];
    value: EditorConversionSetting;
};

export type MutationSetEstimationTypeArgs = {
    input?: InputMaybe<SetEstimationTypeInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationSetExternalAuthCredentialsArgs = {
    input: SetExternalAuthCredentialsInput;
};

export type MutationSetFeedUserConfigArgs = {
    input: SetFeedUserConfigInput;
};

export type MutationSetIssueMediaVisibilityArgs = {
    input?: InputMaybe<SetIssueMediaVisibilityInput>;
};

export type MutationSetOnboardingStateArgs = {
    states?: InputMaybe<Array<OnboardingStateInput>>;
};

export type MutationSetOnboardingStateToCompleteArgs = {
    key?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type MutationSetPolarisSelectedDeliveryProjectArgs = {
    input: SetPolarisSelectedDeliveryProjectInput;
};

export type MutationSetPolarisSnippetPropertiesConfigArgs = {
    input: SetPolarisSnippetPropertiesConfigInput;
};

export type MutationSetPublicLinkDefaultSpaceStatusArgs = {
    status: PublicLinkDefaultSpaceStatus;
};

export type MutationSetRecommendedPagesSpaceStatusArgs = {
    input: SetRecommendedPagesSpaceStatusInput;
};

export type MutationSetRecommendedPagesStatusArgs = {
    input: SetRecommendedPagesStatusInput;
};

export type MutationSetRelevantFeedFiltersArgs = {
    relevantFeedSpacesFilter: Array<InputMaybe<Scalars["Long"]["input"]>>;
    relevantFeedUsersFilter: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type MutationSetSpaceRoleAssignmentsArgs = {
    input: SetSpaceRoleAssignmentsInput;
};

export type MutationSetSwimlaneStrategyArgs = {
    input?: InputMaybe<SetSwimlaneStrategyInput>;
};

export type MutationSetTaskStatusArgs = {
    inlineTasksInput: InlineTasksInput;
};

export type MutationSetUserSwimlaneStrategyArgs = {
    input?: InputMaybe<SetSwimlaneStrategyInput>;
};

export type MutationSettings_UpdateNavigationCustomisationArgs = {
    input: SettingsNavigationCustomisationInput;
};

export type MutationShareResourceArgs = {
    shareResourceInput: ShareResourceInput;
};

export type MutationSoftDeleteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationSplitIssueArgs = {
    input?: InputMaybe<SplitIssueInput>;
};

export type MutationStartSprintArgs = {
    input?: InputMaybe<StartSprintInput>;
};

export type MutationSubscribeToAppArgs = {
    input: AppSubscribeInput;
};

export type MutationTemplateMigrationArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationTemplatizeArgs = {
    input: TemplatizeInput;
};

export type MutationToggleBoardFeatureArgs = {
    input?: InputMaybe<ToggleBoardFeatureInput>;
};

export type MutationUnarchivePolarisInsightsArgs = {
    containers?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    project: Scalars["ID"]["input"];
};

export type MutationUnarchiveSpaceArgs = {
    input: UnarchiveSpaceInput;
};

export type MutationUnassignIssueParentArgs = {
    input?: InputMaybe<UnassignIssueParentInput>;
};

export type MutationUnfavouritePageArgs = {
    favouritePageInput: FavouritePageInput;
};

export type MutationUnfavouriteSpaceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type MutationUnfollowUserArgs = {
    followUserInput: FollowUserInput;
};

export type MutationUninstallAppArgs = {
    input: AppUninstallationInput;
};

export type MutationUnlikeContentArgs = {
    input: LikeContentInput;
};

export type MutationUnsubscribeFromAppArgs = {
    input: AppUnsubscribeInput;
};

export type MutationUnwatchBlogsArgs = {
    watchSpaceInput: WatchSpaceInput;
};

export type MutationUnwatchContentArgs = {
    watchContentInput: WatchContentInput;
};

export type MutationUnwatchMarketplaceAppArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationUnwatchSpaceArgs = {
    watchSpaceInput: WatchSpaceInput;
};

export type MutationUpdateAdminAnnouncementBannerArgs = {
    announcementBanner: ConfluenceUpdateAdminAnnouncementBannerInput;
};

export type MutationUpdateAppDetailsArgs = {
    input: UpdateAppDetailsInput;
};

export type MutationUpdateArchiveNotesArgs = {
    input: Array<InputMaybe<UpdateArchiveNotesInput>>;
};

export type MutationUpdateAtlassianOAuthClientArgs = {
    input: UpdateAtlassianOAuthClientInput;
};

export type MutationUpdateCommentArgs = {
    input: UpdateCommentInput;
};

export type MutationUpdateContentDataClassificationLevelArgs = {
    input: UpdateContentDataClassificationLevelInput;
};

export type MutationUpdateContentPermissionsArgs = {
    contentId: Scalars["ID"]["input"];
    input: Array<InputMaybe<UpdateContentPermissionsInput>>;
};

export type MutationUpdateCoverPictureWidthArgs = {
    input: UpdateCoverPictureWidthInput;
};

export type MutationUpdateCustomFilterArgs = {
    input?: InputMaybe<UpdateCustomFilterInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateCustomFilterV2Args = {
    input?: InputMaybe<UpdateCustomFilterInput>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateDevOpsContainerRelationshipEntityPropertiesArgs = {
    input: UpdateDevOpsContainerRelationshipEntityPropertiesInput;
};

export type MutationUpdateDevOpsServiceArgs = {
    input: UpdateDevOpsServiceInput;
};

export type MutationUpdateDevOpsServiceAndJiraProjectRelationshipArgs = {
    input: UpdateDevOpsServiceAndJiraProjectRelationshipInput;
};

export type MutationUpdateDevOpsServiceAndOpsgenieTeamRelationshipArgs = {
    input: UpdateDevOpsServiceAndOpsgenieTeamRelationshipInput;
};

export type MutationUpdateDevOpsServiceAndRepositoryRelationshipArgs = {
    input: UpdateDevOpsServiceAndRepositoryRelationshipInput;
};

export type MutationUpdateDevOpsServiceEntityPropertiesArgs = {
    input: UpdateDevOpsServiceEntityPropertiesInput;
};

export type MutationUpdateDevOpsServiceRelationshipArgs = {
    input: UpdateDevOpsServiceRelationshipInput;
};

export type MutationUpdateDeveloperLogAccessArgs = {
    input: UpdateDeveloperLogAccessInput;
};

export type MutationUpdateEmbedArgs = {
    input: UpdateEmbedInput;
};

export type MutationUpdateExternalCollaboratorDefaultSpaceArgs = {
    input: UpdateExternalCollaboratorDefaultSpaceInput;
};

export type MutationUpdateHomeUserSettingsArgs = {
    homeUserSettings: HomeUserSettingsInput;
};

export type MutationUpdateLocalStorageArgs = {
    localStorage: LocalStorageInput;
};

export type MutationUpdateNestedPageOwnersArgs = {
    input: UpdatedNestedPageOwnersInput;
};

export type MutationUpdateOwnerArgs = {
    input: UpdateOwnerInput;
};

export type MutationUpdatePageArgs = {
    input: UpdatePageInput;
};

export type MutationUpdatePageOwnersArgs = {
    input: UpdatePageOwnersInput;
};

export type MutationUpdatePageStatusesArgs = {
    input: UpdatePageStatusesInput;
};

export type MutationUpdatePolarisCommentArgs = {
    input: UpdatePolarisCommentInput;
};

export type MutationUpdatePolarisIdeaArgs = {
    idea: Scalars["ID"]["input"];
    project: Scalars["ID"]["input"];
    update: UpdatePolarisIdeaInput;
};

export type MutationUpdatePolarisIdeaTemplateArgs = {
    input: UpdatePolarisIdeaTemplateInput;
};

export type MutationUpdatePolarisInsightArgs = {
    id: Scalars["ID"]["input"];
    update: UpdatePolarisInsightInput;
};

export type MutationUpdatePolarisPlayArgs = {
    input: UpdatePolarisPlayInput;
};

export type MutationUpdatePolarisPlayContributionArgs = {
    id: Scalars["ID"]["input"];
    input: UpdatePolarisPlayContribution;
};

export type MutationUpdatePolarisViewArgs = {
    id: Scalars["ID"]["input"];
    input: UpdatePolarisViewInput;
};

export type MutationUpdatePolarisViewArrangementInfoArgs = {
    id: Scalars["ID"]["input"];
    input?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type MutationUpdatePolarisViewLastViewedTimestampArgs = {
    timestampInput?: InputMaybe<Scalars["String"]["input"]>;
    viewId: Scalars["ID"]["input"];
};

export type MutationUpdatePolarisViewRankV2Args = {
    id: Scalars["ID"]["input"];
    input: UpdatePolarisViewRankInput;
};

export type MutationUpdatePolarisViewSetArgs = {
    input: UpdatePolarisViewSetInput;
};

export type MutationUpdatePushNotificationCustomSettingsArgs = {
    customSettings: PushNotificationCustomSettingsInput;
};

export type MutationUpdatePushNotificationGroupSettingArgs = {
    group: PushNotificationGroupInputType;
};

export type MutationUpdateRelationArgs = {
    input: UpdateRelationInput;
};

export type MutationUpdateReleaseNoteArgs = {
    announcementPlan?: InputMaybe<Scalars["String"]["input"]>;
    changeCategory?: InputMaybe<Scalars["String"]["input"]>;
    changeStatus?: Scalars["String"]["input"];
    changeType?: Scalars["String"]["input"];
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    fdIssueKey?: InputMaybe<Scalars["String"]["input"]>;
    fdIssueLink?: InputMaybe<Scalars["String"]["input"]>;
    featureRolloutDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    featureRolloutEndDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    fedRAMPProductionReleaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    fedRAMPStagingReleaseDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    id: Scalars["String"]["input"];
    relatedContextIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    relatedContexts?: InputMaybe<Array<Scalars["String"]["input"]>>;
    releaseNoteFlag?: InputMaybe<Scalars["String"]["input"]>;
    releaseNoteFlagEnvironment?: InputMaybe<Scalars["String"]["input"]>;
    releaseNoteFlagOffValue?: InputMaybe<Scalars["String"]["input"]>;
    releaseNoteFlagProject?: InputMaybe<Scalars["String"]["input"]>;
    title?: Scalars["String"]["input"];
    visibleInFedRAMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUpdateSiteLookAndFeelArgs = {
    input: UpdateSiteLookAndFeelInput;
};

export type MutationUpdateSitePermissionArgs = {
    input: SitePermissionInput;
};

export type MutationUpdateSpaceDefaultClassificationLevelArgs = {
    input: UpdateSpaceDefaultClassificationLevelInput;
};

export type MutationUpdateSpaceDetailsArgs = {
    input: UpdateSpaceDetailsInput;
};

export type MutationUpdateSpacePermissionDefaultsArgs = {
    input: Array<UpdateDefaultSpacePermissionsInput>;
};

export type MutationUpdateSpacePermissionsArgs = {
    input: UpdateSpacePermissionsInput;
};

export type MutationUpdateSpaceTypeSettingsArgs = {
    input: UpdateSpaceTypeSettingsInput;
};

export type MutationUpdateTemplateArgs = {
    contentTemplate: UpdateContentTemplateInput;
};

export type MutationUpdateTemplatePropertySetArgs = {
    input: UpdateTemplatePropertySetInput;
};

export type MutationUpdateTitleArgs = {
    contentId: Scalars["ID"]["input"];
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateUserPreferencesArgs = {
    userPreferences: UserPreferencesInput;
};

export type MutationUpgradeAppArgs = {
    input: AppInstallationUpgradeInput;
};

export type MutationUserAuthTokenForExtensionArgs = {
    input: UserAuthTokenForExtensionInput;
};

export type MutationWatchBlogsArgs = {
    watchSpaceInput: WatchSpaceInput;
};

export type MutationWatchContentArgs = {
    watchContentInput: WatchContentInput;
};

export type MutationWatchMarketplaceAppArgs = {
    id: Scalars["ID"]["input"];
};

export type MutationWatchSpaceArgs = {
    watchSpaceInput: WatchSpaceInput;
};

/** An error that has occurred in response to a mutation */
export type MutationError = {
    __typename?: "MutationError";
    /** A list of extension properties to the error */
    extensions?: Maybe<MutationErrorExtension>;
    /** A human readable error message */
    message?: Maybe<Scalars["String"]["output"]>;
};

/**
 * A error type that can be returned in response to a failed mutation
 *
 * This extension carries additional categorisation information about the error
 */
export type MutationErrorExtension = {
    /**
     * Application specific error type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (such as a HTTP status code) representing the error category
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/**
 * A mutation response interface.
 *
 * According to the Atlassian standards, all mutations should return a type which implements this interface.
 *
 * [Apollo GraphQL Documentation](https://www.apollographql.com/docs/apollo-server/essentials/schema#mutation-responses)
 */
export type MutationResponse = {
    /** A message for this mutation */
    message: Scalars["String"]["output"];
    /** A numerical code (such as a HTTP status code) representing the status of the mutation */
    statusCode: Scalars["Int"]["output"];
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type MyActivities = {
    __typename?: "MyActivities";
    /**
     * get all activity for the currently logged in user
     * - filters - query filters for the activity stream
     * - first - show 1st <N> items of the response
     */
    all?: Maybe<ActivitiesConnection>;
    /**
     * get "viewed" activity for the currently logged in user
     * - filters - query filters for the activity stream
     * - first - show 1st <N> items of the response
     */
    viewed?: Maybe<ActivitiesConnection>;
    /**
     * get "worked on" activity for the currently logged in user
     * - filters - query filters for the activity stream
     * - first - show 1st <N> items of the response
     */
    workedOn?: Maybe<ActivitiesConnection>;
};

export type MyActivitiesAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filters?: InputMaybe<Array<ActivitiesFilter>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MyActivitiesViewedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filters?: InputMaybe<Array<ActivitiesFilter>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MyActivitiesWorkedOnArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filters?: InputMaybe<Array<ActivitiesFilter>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MyActivity = {
    __typename?: "MyActivity";
    all: ActivityConnection;
    viewed: ActivityConnection;
    workedOn: ActivityConnection;
};

export type MyActivityAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<MyActivityFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MyActivityViewedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<MyActivityFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MyActivityWorkedOnArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<MyActivityFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MyActivityFilter = {
    arguments?: InputMaybe<ActivityFilterArgs>;
    /** set of top-level container ARIs (ex: Cloud ID, workspace ID) */
    rootContainerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Defines relationship between the filter arguments. Default: AND */
    type?: InputMaybe<ActivitiesFilterType>;
};

export type MyVisitedPages = {
    __typename?: "MyVisitedPages";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: MyVisitedPagesItems;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: MyVisitedPagesInfo;
};

export type MyVisitedPagesInfo = {
    __typename?: "MyVisitedPagesInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
};

export type MyVisitedPagesItems = {
    __typename?: "MyVisitedPagesItems";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Array<Maybe<Content>>>;
};

export type MyVisitedSpaces = {
    __typename?: "MyVisitedSpaces";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: MyVisitedSpacesItems;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: MyVisitedSpacesInfo;
};

export type MyVisitedSpacesInfo = {
    __typename?: "MyVisitedSpacesInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
};

export type MyVisitedSpacesItems = {
    __typename?: "MyVisitedSpacesItems";
    spaces?: Maybe<Array<Maybe<Space>>>;
};

export type MyVisitedSpacesItemsSpacesArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** =========================== */
export type NadelBatchObjectIdentifiedBy = {
    resultId: Scalars["String"]["input"];
    sourceId: Scalars["String"]["input"];
};

/** This allows you to hydrate new values into fields */
export type NadelHydrationArgument = {
    name: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

/** Specify a condition for the hydration to activate */
export type NadelHydrationCondition = {
    result: NadelHydrationResultCondition;
};

/** This allows you to hydrate new values into fields with the @hydratedFrom directive */
export type NadelHydrationFromArgument = {
    name: Scalars["String"]["input"];
    valueFromArg?: InputMaybe<Scalars["String"]["input"]>;
    valueFromField?: InputMaybe<Scalars["String"]["input"]>;
};

/** Specify a condition for the hydration to activate based on the result */
export type NadelHydrationResultCondition = {
    predicate: NadelHydrationResultFieldPredicate;
    /** The exact name of the field to use, do not prefix with $source */
    sourceField: Scalars["String"]["input"];
};

export type NadelHydrationResultFieldPredicate = {
    /** Can be Int, Boolean or String */
    equals?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Supply a regex that the resulting String should match */
    matches?: InputMaybe<Scalars["String"]["input"]>;
    startsWith?: InputMaybe<Scalars["String"]["input"]>;
};

/** This can be extended with new enums which are templates */
export enum NadelHydrationTemplate {
    NadelPlaceholder = "NADEL_PLACEHOLDER"
}

export type NavigationLookAndFeel = {
    __typename?: "NavigationLookAndFeel";
    color?: Maybe<Scalars["String"]["output"]>;
    highlightColor?: Maybe<Scalars["String"]["output"]>;
    hoverOrFocus?: Maybe<Array<Maybe<MapOfStringToString>>>;
};

export type NestedActionsFeature = {
    __typename?: "NestedActionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type NestedPageInput = {
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

/** Minimal details required to create a new card (as opposed to Card which is everything). */
export type NewCard = {
    assigneeId?: InputMaybe<Scalars["ID"]["input"]>;
    fixVersions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    issueTypeId: Scalars["ID"]["input"];
    labels?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    summary: Scalars["String"]["input"];
};

export type NewCardParent = {
    issueTypeId: Scalars["ID"]["input"];
    summary: Scalars["String"]["input"];
};

export type NewPageInput = {
    page: PageInput;
    space: SpaceInput;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type NewPagePayload = {
    __typename?: "NewPagePayload";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    page?: Maybe<Page>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictions?: Maybe<PageRestrictions>;
};

export type NewSplitIssueRequest = {
    destinationId?: InputMaybe<Scalars["ID"]["input"]>;
    estimate?: InputMaybe<Scalars["String"]["input"]>;
    estimateFieldId?: InputMaybe<Scalars["String"]["input"]>;
    summary: Scalars["String"]["input"];
};

export type NewSplitIssueResponse = {
    __typename?: "NewSplitIssueResponse";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
};

export enum NlpDisclaimer {
    WhoQuestion = "WHO_QUESTION"
}

export enum NlpErrorState {
    AcceptableUseViolations = "ACCEPTABLE_USE_VIOLATIONS",
    AiDisabled = "AI_DISABLED",
    NoAnswer = "NO_ANSWER",
    NoAnswerHydration = "NO_ANSWER_HYDRATION",
    NoAnswerKeywords = "NO_ANSWER_KEYWORDS",
    NoAnswerOpenAiResponseErr = "NO_ANSWER_OPEN_AI_RESPONSE_ERR",
    NoAnswerRelevantContent = "NO_ANSWER_RELEVANT_CONTENT",
    NoAnswerSearchResults = "NO_ANSWER_SEARCH_RESULTS",
    NoAnswerWhoQuestion = "NO_ANSWER_WHO_QUESTION",
    OpenaiRateLimitUserAbuse = "OPENAI_RATE_LIMIT_USER_ABUSE",
    SubjectiveQuery = "SUBJECTIVE_QUERY"
}

export type NlpFollowUpResponse = {
    __typename?: "NlpFollowUpResponse";
    followUps?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type NlpFollowUpResult = {
    __typename?: "NlpFollowUpResult";
    followUp?: Maybe<Scalars["String"]["output"]>;
    followUpAnswers?: Maybe<Array<NlpSearchResult>>;
};

/** For Reading Aids */
export enum NlpGetKeywordsTextFormat {
    Adf = "ADF",
    PlainText = "PLAIN_TEXT"
}

export type NlpGetKeywordsTextInput = {
    format: NlpGetKeywordsTextFormat;
    text: Scalars["String"]["input"];
};

/** Result for Q&A Searches */
export type NlpSearchResponse = {
    __typename?: "NlpSearchResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    disclaimer?: Maybe<NlpDisclaimer>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorState?: Maybe<NlpErrorState>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    format?: Maybe<NlpSearchResultFormat>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nlpFollowResults?: Maybe<Array<NlpFollowUpResult>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nlpFollowUpResults?: Maybe<NlpFollowUpResponse>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nlpResults?: Maybe<Array<NlpSearchResult>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    uniqueSources?: Maybe<Array<NlpSource>>;
};

export type NlpSearchResult = {
    __typename?: "NlpSearchResult";
    nlpResult?: Maybe<Scalars["String"]["output"]>;
    sources?: Maybe<Array<NlpSource>>;
};

export enum NlpSearchResultFormat {
    Adf = "ADF",
    Json = "JSON",
    Markdown = "MARKDOWN",
    PlainText = "PLAIN_TEXT"
}

export enum NlpSearchResultType {
    Blogpost = "blogpost",
    Page = "page",
    User = "user"
}

export type NlpSource = {
    __typename?: "NlpSource";
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    id: Scalars["ID"]["output"];
    lastModified?: Maybe<Scalars["String"]["output"]>;
    spaceName?: Maybe<Scalars["String"]["output"]>;
    spaceUrl?: Maybe<Scalars["String"]["output"]>;
    title: Scalars["String"]["output"];
    type: NlpSearchResultType;
    url: Scalars["URL"]["output"];
};

/**
 * From the [relay Node specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface)
 *
 * The server must provide an interface called `Node`. That interface must include exactly one field, called `id` that returns a non-null `ID`.
 *
 * This `id` should be a globally unique identifier for this object, and given just this `id`, the server should be able to refetch the object.
 */
export type Node = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export enum NotificationAction {
    DontNotify = "DONT_NOTIFY",
    Notify = "NOTIFY"
}

export type NotificationResponsePayload = Payload & {
    __typename?: "NotificationResponsePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type NumberUserInput = {
    type: NumberUserInputType;
    value?: InputMaybe<Scalars["Float"]["input"]>;
    variableName: Scalars["String"]["input"];
};

export enum NumberUserInputType {
    Number = "NUMBER"
}

export type OAuthClientsAccountGrant = {
    __typename?: "OAuthClientsAccountGrant";
    accountId?: Maybe<Scalars["String"]["output"]>;
    appEnvironment?: Maybe<AppEnvironment>;
    clientId?: Maybe<Scalars["String"]["output"]>;
    scopeDetails?: Maybe<Array<Maybe<OAuthClientsScopeDetails>>>;
    scopes?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type OAuthClientsAccountGrantConnection = {
    __typename?: "OAuthClientsAccountGrantConnection";
    edges?: Maybe<Array<Maybe<OAuthClientsAccountGrantEdge>>>;
    nodes?: Maybe<Array<Maybe<OAuthClientsAccountGrant>>>;
    pageInfo: OAuthClientsAccountGrantPageInfo;
};

export type OAuthClientsAccountGrantEdge = {
    __typename?: "OAuthClientsAccountGrantEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<OAuthClientsAccountGrant>;
};

export type OAuthClientsAccountGrantPageInfo = {
    __typename?: "OAuthClientsAccountGrantPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type OAuthClientsQuery = {
    __typename?: "OAuthClientsQuery";
    /**
     * Retrieve all account-wide user grants for the logged in user
     * This API supports forward pagination using `pageInfo.hasNextPage` and `pageInfo.endCursor`. Please use those instead of `edges.cursor`
     * The `first` argument (page size limit) should only be set on the initial call and subsequent calls to retrieve further results will use the same limit
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    allAccountGrantsForUser?: Maybe<OAuthClientsAccountGrantConnection>;
};

export type OAuthClientsQueryAllAccountGrantsForUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OAuthClientsScopeDetails = {
    __typename?: "OAuthClientsScopeDetails";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key: Scalars["String"]["output"];
};

export type OnboardingState = {
    __typename?: "OnboardingState";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

export type OnboardingStateInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export enum Operation {
    Assigned = "ASSIGNED",
    Complete = "COMPLETE",
    Deleted = "DELETED",
    InComplete = "IN_COMPLETE",
    Reworded = "REWORDED",
    Unassigned = "UNASSIGNED"
}

export type OperationCheckResult = {
    __typename?: "OperationCheckResult";
    links?: Maybe<LinksContextBase>;
    operation?: Maybe<Scalars["String"]["output"]>;
    targetType?: Maybe<Scalars["String"]["output"]>;
};

export type OperationCheckResultInput = {
    operation: Scalars["String"]["input"];
    targetType: Scalars["String"]["input"];
};

export type OpsgenieAlertCountByPriority = {
    __typename?: "OpsgenieAlertCountByPriority";
    countPerDay?: Maybe<Array<Maybe<OpsgenieAlertCountPerDay>>>;
    priority?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieAlertCountPerDay = {
    __typename?: "OpsgenieAlertCountPerDay";
    count?: Maybe<Scalars["Int"]["output"]>;
    day?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieQuery = {
    __typename?: "OpsgenieQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    allOpsgenieTeams?: Maybe<OpsgenieTeamConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    myOpsgenieSchedules?: Maybe<Array<Maybe<OpsgenieSchedule>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    opsgenieSchedule?: Maybe<OpsgenieSchedule>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    opsgenieTeam?: Maybe<OpsgenieTeam>;
    /**
     * for hydration batching, restricted to 25.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    opsgenieTeams?: Maybe<Array<Maybe<OpsgenieTeam>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    opsgenieTeamsWithServiceModificationPermissions?: Maybe<OpsgenieTeamConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "opsgenie-beta")' query directive to the 'savedSearches' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    savedSearches?: Maybe<OpsgenieSavedSearches>;
};

export type OpsgenieQueryAllOpsgenieTeamsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OpsgenieQueryMyOpsgenieSchedulesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type OpsgenieQueryOpsgenieScheduleArgs = {
    id: Scalars["ID"]["input"];
};

export type OpsgenieQueryOpsgenieTeamArgs = {
    id: Scalars["ID"]["input"];
};

export type OpsgenieQueryOpsgenieTeamsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type OpsgenieQueryOpsgenieTeamsWithServiceModificationPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OpsgenieQuerySavedSearchesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type OpsgenieSavedSearch = Node & {
    __typename?: "OpsgenieSavedSearch";
    alertSearchQuery?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieSavedSearches = {
    __typename?: "OpsgenieSavedSearches";
    createdByMe?: Maybe<Array<OpsgenieSavedSearch>>;
    sharedWithMe?: Maybe<Array<OpsgenieSavedSearch>>;
    starred?: Maybe<Array<OpsgenieSavedSearch>>;
};

export type OpsgenieSchedule = {
    __typename?: "OpsgenieSchedule";
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    finalTimeline?: Maybe<OpsgenieScheduleTimeline>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    onCallRecipients?: Maybe<Array<Maybe<OpsgenieScheduleOnCallRecipient>>>;
    timezone?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieScheduleFinalTimelineArgs = {
    endTime: Scalars["DateTime"]["input"];
    startTime: Scalars["DateTime"]["input"];
};

export type OpsgenieScheduleOnCallRecipient = {
    __typename?: "OpsgenieScheduleOnCallRecipient";
    accountId?: Maybe<Scalars["ID"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieSchedulePeriod = {
    __typename?: "OpsgenieSchedulePeriod";
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** Enum? */
    recipient?: Maybe<OpsgenieSchedulePeriodRecipient>;
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieSchedulePeriodRecipient = {
    __typename?: "OpsgenieSchedulePeriodRecipient";
    id?: Maybe<Scalars["ID"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<User>;
};

export type OpsgenieScheduleRotation = {
    __typename?: "OpsgenieScheduleRotation";
    id?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    order?: Maybe<Scalars["Int"]["output"]>;
    periods?: Maybe<Array<Maybe<OpsgenieSchedulePeriod>>>;
};

export type OpsgenieScheduleTimeline = {
    __typename?: "OpsgenieScheduleTimeline";
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    rotations?: Maybe<Array<Maybe<OpsgenieScheduleRotation>>>;
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

export type OpsgenieTeam = Node & {
    __typename?: "OpsgenieTeam";
    alertCounts?: Maybe<Array<Maybe<OpsgenieAlertCountByPriority>>>;
    baseUrl?: Maybe<Scalars["String"]["output"]>;
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    /** The connection entity for DevOps Service relationships for this Opsgenie team. */
    devOpsServiceRelationships?: Maybe<DevOpsServiceAndOpsgenieTeamRelationshipConnection>;
    id: Scalars["ID"]["output"];
    members?: Maybe<OpsgenieTeamMemberConnection>;
    name?: Maybe<Scalars["String"]["output"]>;
    schedules?: Maybe<Array<Maybe<OpsgenieSchedule>>>;
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type OpsgenieTeamAlertCountsArgs = {
    endTime: Scalars["DateTime"]["input"];
    startTime: Scalars["DateTime"]["input"];
    tags?: InputMaybe<Array<Scalars["String"]["input"]>>;
    timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type OpsgenieTeamDevOpsServiceRelationshipsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OpsgenieTeamMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type OpsgenieTeamConnection = {
    __typename?: "OpsgenieTeamConnection";
    edges?: Maybe<Array<Maybe<OpsgenieTeamEdge>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type OpsgenieTeamEdge = {
    __typename?: "OpsgenieTeamEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<OpsgenieTeam>;
};

export type OpsgenieTeamMember = {
    __typename?: "OpsgenieTeamMember";
    user?: Maybe<User>;
};

export type OpsgenieTeamMemberConnection = {
    __typename?: "OpsgenieTeamMemberConnection";
    edges?: Maybe<Array<Maybe<OpsgenieTeamMemberEdge>>>;
    pageInfo: PageInfo;
};

export type OpsgenieTeamMemberEdge = {
    __typename?: "OpsgenieTeamMemberEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<OpsgenieTeamMember>;
};

export type OrganizationContext = {
    __typename?: "OrganizationContext";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasPaidProduct?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OriginalEstimate = {
    __typename?: "OriginalEstimate";
    value?: Maybe<Scalars["Float"]["output"]>;
    valueAsText?: Maybe<Scalars["String"]["output"]>;
};

export type OriginalSplitIssue = {
    destinationId?: InputMaybe<Scalars["ID"]["input"]>;
    estimate?: InputMaybe<Scalars["String"]["input"]>;
    estimateFieldId?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    summary: Scalars["String"]["input"];
};

export type OutgoingLinks = {
    __typename?: "OutgoingLinks";
    internalOutgoingLinks?: Maybe<PaginatedContentList>;
};

export type OutgoingLinksInternalOutgoingLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum OutputDeviceType {
    Desktop = "DESKTOP",
    Email = "EMAIL",
    Mobile = "MOBILE"
}

export type PeapConfluenceSiteEnrollmentMutationInput = {
    cloudId: Scalars["ID"]["input"];
    desiredStatus: Scalars["Boolean"]["input"];
    programId: Scalars["ID"]["input"];
};

export type PeapConfluenceSiteEnrollmentQueryInput = {
    cloudId: Scalars["ID"]["input"];
    programId: Scalars["ID"]["input"];
};

export type PeapInternalMutationApi = {
    __typename?: "PEAPInternalMutationApi";
    /**
     * This type will be extended by other modules in the codebase.
     * GraphQL does not allow empty types so we need this _module hack.
     */
    _module?: Maybe<Scalars["String"]["output"]>;
    /** Create a new EAP Entry */
    createProgram?: Maybe<PeapProgramMutationResponse>;
    /** Update details of an existing EAP */
    updateProgram?: Maybe<PeapProgramMutationResponse>;
    /** Change the status of an existing EAP */
    updateProgramStatus?: Maybe<PeapProgramMutationResponse>;
};

export type PeapInternalMutationApiCreateProgramArgs = {
    program: PeapNewProgramInput;
};

export type PeapInternalMutationApiUpdateProgramArgs = {
    id: Scalars["ID"]["input"];
    program: PeapUpdateProgramInput;
};

export type PeapInternalMutationApiUpdateProgramStatusArgs = {
    id: Scalars["ID"]["input"];
    status: PeapProgramStatus;
};

export type PeapInternalQueryApi = {
    __typename?: "PEAPInternalQueryApi";
    version?: Maybe<Scalars["String"]["output"]>;
};

/**
 * input PEAPSiteEnrollmentQueryInput {
 *   programId: ID!
 *   cloudId: ID! #@ARI(....)
 * }
 *  input PEAPUserSiteEnrollmentQueryInput {
 *    programId: ID!
 *    cloudId: ID! #@ARI(....)
 *  }
 *  input PEAPOrgEnrollmentQueryInput {
 *    programId: ID!
 *    orgId: ID! @ARI(type: "org", owner: "platform")
 *  }
 *  input PEAPOrgUserEnrollmentQueryInput {
 *    programId: ID!
 *    orgId: ID! @ARI(type: "org", owner: "platform")
 *  }
 */
export type PeapJiraSiteEnrollmentMutationInput = {
    cloudId: Scalars["ID"]["input"];
    desiredStatus: Scalars["Boolean"]["input"];
    programId: Scalars["ID"]["input"];
};

export type PeapJiraSiteEnrollmentQueryInput = {
    cloudId: Scalars["ID"]["input"];
    programId: Scalars["ID"]["input"];
};

export type PeapMutationApi = {
    __typename?: "PEAPMutationApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    internal: PeapInternalMutationApi;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    programEnrollment: PeapProgramEnrollmentMutation;
};

/** Parameters that can be used to create new EAPs */
export type PeapNewProgramInput = {
    /** A short name that provides a crisp summary of the EAP */
    name: Scalars["String"]["input"];
    /** Optionally specify the staffID of the EAP owner. If not specified, you will be the owner */
    owner?: InputMaybe<Scalars["String"]["input"]>;
};

/** EAP object data */
export type PeapProgram = {
    __typename?: "PEAPProgram";
    /** Date when the EAP was activated */
    activatedAt?: Maybe<Scalars["Date"]["output"]>;
    /** The CDAC Category ID for the EAP */
    cdacCategory?: Maybe<Scalars["Int"]["output"]>;
    /** The CDAC Category URL for the EAP */
    cdacCategoryURL?: Maybe<Scalars["String"]["output"]>;
    /** The CHANGE ticket used to Announce the EAP in Changelogs */
    changeTicket?: Maybe<Scalars["String"]["output"]>;
    /** Date when the EAP was completed */
    completedAt?: Maybe<Scalars["Date"]["output"]>;
    /** Date when the EAP was created */
    createdAt: Scalars["Date"]["output"];
    /** The unique ID of an EAP */
    id: Scalars["ID"]["output"];
    /** Internal (Atlassian only) information of the EAP */
    internal?: Maybe<PeapProgramInternalData>;
    /** The short name that provides a crisp summary of the EAP */
    name: Scalars["String"]["output"];
    /** Current status of the EAP */
    status: PeapProgramStatus;
    /** Date when the EAP was last updated */
    updatedAt: Scalars["Date"]["output"];
};

/** A Connection object for EAP pagination */
export type PeapProgramConnection = HasPageInfo &
    HasTotal & {
        __typename?: "PEAPProgramConnection";
        /** A list of edges in the current page */
        edges?: Maybe<Array<Maybe<PeapProgramEdge>>>;
        /** Information about the current page. Used to aid in pagination */
        pageInfo: PageInfo;
        /** Total count of items to be returned. */
        totalCount: Scalars["Int"]["output"];
    };

/** The Edge object for EAPs listing */
export type PeapProgramEdge = {
    __typename?: "PEAPProgramEdge";
    /** The cursor that points to an EAP */
    cursor: Scalars["String"]["output"];
    /** A Node that represents an EAP */
    node: PeapProgram;
};

export type PeapProgramEnrollmentMutation = {
    __typename?: "PEAPProgramEnrollmentMutation";
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:configuration:confluence__
     *
     *
     */
    confluence?: Maybe<PeapSiteEnrollmentStatus>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:jira-configuration__
     * * __write:instance-configuration:jira__
     *
     *
     */
    jira?: Maybe<PeapSiteEnrollmentStatus>;
};

export type PeapProgramEnrollmentMutationConfluenceArgs = {
    input: PeapConfluenceSiteEnrollmentMutationInput;
};

export type PeapProgramEnrollmentMutationJiraArgs = {
    input: PeapJiraSiteEnrollmentMutationInput;
};

/** --------------------------------------------------------------------------------------------- */
export type PeapProgramEnrollmentQuery = {
    __typename?: "PEAPProgramEnrollmentQuery";
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:configuration:confluence__
     *
     *
     */
    confluence?: Maybe<PeapSiteEnrollmentStatus>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:jira-configuration__
     * * __read:instance-configuration:jira__
     *
     *
     */
    jira?: Maybe<PeapSiteEnrollmentStatus>;
};

/** --------------------------------------------------------------------------------------------- */
export type PeapProgramEnrollmentQueryConfluenceArgs = {
    input: PeapConfluenceSiteEnrollmentQueryInput;
};

/** --------------------------------------------------------------------------------------------- */
export type PeapProgramEnrollmentQueryJiraArgs = {
    input: PeapJiraSiteEnrollmentQueryInput;
};

/** Internal (Atlassian only) information of the EAP */
export type PeapProgramInternalData = {
    __typename?: "PEAPProgramInternalData";
    /** All statuses this EAP can be transitioned to */
    availableStatusTransitions: Array<PeapProgramStatus>;
    /** The CDAC group that participants of this EAP must belong to */
    cdacGroup?: Maybe<Scalars["String"]["output"]>;
    /** The CDAC group URL that participants of this EAP must belong to */
    cdacGroupURL?: Maybe<Scalars["String"]["output"]>;
    /** The CHANGE ticket URL used to Announce the EAP in Changelogs */
    changeTicketURL?: Maybe<Scalars["String"]["output"]>;
    /** The owner (creator) of the EAP */
    owner?: Maybe<User>;
};

/** A Response type used for EAP Mutations */
export type PeapProgramMutationResponse = Payload & {
    __typename?: "PEAPProgramMutationResponse";
    /** The list of errors in case something went wrong on the Mutation */
    errors?: Maybe<Array<MutationError>>;
    /** The Mutated EAP */
    program?: Maybe<PeapProgram>;
    /** True if the Mutation was a success */
    success: Scalars["Boolean"]["output"];
};

/** All status values for EAPs */
export enum PeapProgramStatus {
    Abandoned = "ABANDONED",
    Active = "ACTIVE",
    Ended = "ENDED",
    New = "NEW"
}

export type PeapQueryApi = {
    __typename?: "PEAPQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    internal: PeapInternalQueryApi;
    /**
     * Get an EAP by its ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    program?: Maybe<PeapProgram>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    programEnrollment: PeapProgramEnrollmentQuery;
    /**
     *   Lists EAPs, optionally filtering them using the given parameters.
     *   - first specifies the number of elements per page.
     *   - after is the cursor for pagination, representing the number of skipped rows.
     *
     * Returns a Connection object for pagination.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    programs?: Maybe<PeapProgramConnection>;
};

export type PeapQueryApiProgramArgs = {
    id: Scalars["ID"]["input"];
};

export type PeapQueryApiProgramsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    params?: InputMaybe<PeapQueryParams>;
};

/** Query Parameters when looking for EAPs */
export type PeapQueryParams = {
    /** Any term that should be used to lookup EAPs by name */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** An array of statuses, to lookup EAPs that are only in any of the given statuses */
    status?: InputMaybe<Array<PeapProgramStatus>>;
};

/**
 * input PEAPUserSiteEnrollmentMutationInput {
 *   programId: ID!
 *   cloudId: ID! #@ARI(....)
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgUserEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 */
export type PeapSiteEnrollmentStatus = {
    __typename?: "PEAPSiteEnrollmentStatus";
    cloudId: Scalars["ID"]["output"];
    enrollmentStatus?: Maybe<Scalars["Boolean"]["output"]>;
    error?: Maybe<Array<Scalars["String"]["output"]>>;
    program?: Maybe<PeapProgram>;
    success: Scalars["Boolean"]["output"];
};

/** Parameters that can be used to update existing EAPs */
export type PeapUpdateProgramInput = {
    /** A short name that provides a crisp summary of the EAP */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Optionally specify the staffID of the EAP owner. If not specified, you will be the owner */
    owner?: InputMaybe<Scalars["String"]["input"]>;
};

export enum PtGraphQlPageStatus {
    Current = "CURRENT",
    Draft = "DRAFT",
    Historical = "HISTORICAL",
    Trashed = "TRASHED"
}

/** --------------------------------------------------------------------------------------------- */
export type PtPage = {
    __typename?: "PTPage";
    ancestors?: Maybe<Array<Maybe<PtPage>>>;
    blank?: Maybe<Scalars["Boolean"]["output"]>;
    children?: Maybe<PtPaginatedPageList>;
    emojiTitleDraft?: Maybe<Scalars["String"]["output"]>;
    emojiTitlePublished?: Maybe<Scalars["String"]["output"]>;
    followingSiblings?: Maybe<PtPaginatedPageList>;
    hasChildren: Scalars["Boolean"]["output"];
    hasInheritedRestrictions: Scalars["Boolean"]["output"];
    hasRestrictions: Scalars["Boolean"]["output"];
    id: Scalars["ID"]["output"];
    links?: Maybe<Map_LinkType_String>;
    nearestAncestors?: Maybe<PtPaginatedPageList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    page?: Maybe<Page>;
    previousSiblings?: Maybe<PtPaginatedPageList>;
    properties?: Maybe<PaginatedJsonContentPropertyList>;
    status?: Maybe<PtGraphQlPageStatus>;
    subType?: Maybe<Scalars["String"]["output"]>;
    /** hydrated properties */
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type PtPageChildrenArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type PtPageFollowingSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type PtPageNearestAncestorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type PtPagePreviousSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type PtPagePropertiesArgs = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PtPageEdge = {
    __typename?: "PTPageEdge";
    cursor: Scalars["String"]["output"];
    node: PtPage;
};

export type PtPageInfo = {
    __typename?: "PTPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    /** This will be false at all times until backwards pagination is supported */
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PtPaginatedPageList = {
    __typename?: "PTPaginatedPageList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<PtPageEdge>>>;
    nodes?: Maybe<Array<Maybe<PtPage>>>;
    pageInfo?: Maybe<PtPageInfo>;
};

export type Page = {
    __typename?: "Page";
    ancestors: Array<Maybe<Page>>;
    blank?: Maybe<Scalars["Boolean"]["output"]>;
    children?: Maybe<PaginatedPageList>;
    emojiTitleDraft?: Maybe<Scalars["String"]["output"]>;
    emojiTitlePublished?: Maybe<Scalars["String"]["output"]>;
    followingSiblings?: Maybe<PaginatedPageList>;
    hasChildren?: Maybe<Scalars["Boolean"]["output"]>;
    hasInheritedRestrictions: Scalars["Boolean"]["output"];
    hasRestrictions: Scalars["Boolean"]["output"];
    id?: Maybe<Scalars["ID"]["output"]>;
    links?: Maybe<Map_LinkType_String>;
    nearestAncestors?: Maybe<PaginatedPageList>;
    previousSiblings?: Maybe<PaginatedPageList>;
    properties?: Maybe<PaginatedJsonContentPropertyList>;
    status?: Maybe<GraphQlPageStatus>;
    subType?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type PageChildrenArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PageFollowingSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PageNearestAncestorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PagePreviousSiblingsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PagePropertiesArgs = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum PageActivityAction {
    Created = "created",
    Published = "published",
    Snapshotted = "snapshotted",
    Started = "started",
    Updated = "updated"
}

export enum PageActivityActionSubject {
    Comment = "comment",
    Page = "page"
}

export type PageActivityEvent = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityEventCreatedComment = PageActivityEvent & {
    __typename?: "PageActivityEventCreatedComment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'comment' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    comment?: Maybe<Comment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentType: AnalyticsCommentType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityEventCreatedPage = PageActivityEvent & {
    __typename?: "PageActivityEventCreatedPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageVersion: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityEventPublishedPage = PageActivityEvent & {
    __typename?: "PageActivityEventPublishedPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageVersion: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityEventSnapshottedPage = PageActivityEvent & {
    __typename?: "PageActivityEventSnapshottedPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageVersion: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityEventStartedPage = PageActivityEvent & {
    __typename?: "PageActivityEventStartedPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageVersion: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityEventUpdatedPage = PageActivityEvent & {
    __typename?: "PageActivityEventUpdatedPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    action: PageActivityAction;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    actionSubject: PageActivityActionSubject;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupSize: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageVersion: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timestamp: Scalars["String"]["output"];
};

export type PageActivityPageInfo = {
    __typename?: "PageActivityPageInfo";
    endCursor: Scalars["String"]["output"];
    hasNextPage: Scalars["Boolean"]["output"];
};

export type PageAnalyticsCount = {
    __typename?: "PageAnalyticsCount";
    /**
     * Analytics count
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count: Scalars["Int"]["output"];
};

/** Type of metric to group by */
export enum PageAnalyticsCountType {
    All = "ALL",
    User = "USER"
}

export type PageAnalyticsTimeseriesCount = {
    __typename?: "PageAnalyticsTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<PageAnalyticsTimeseriesCountItem>;
};

export type PageAnalyticsTimeseriesCountItem = {
    __typename?: "PageAnalyticsTimeseriesCountItem";
    /** Analytics count */
    count: Scalars["Int"]["output"];
    /** Grouping date in ISO format */
    date: Scalars["String"]["output"];
};

/** Type of metric to group by */
export enum PageAnalyticsTimeseriesCountType {
    All = "ALL"
}

export type PageBodyInput = {
    representation?: InputMaybe<BodyFormatType>;
    value: Scalars["String"]["input"];
};

export enum PageCardInPageTreeHoverPreference {
    NoOptionSelected = "NO_OPTION_SELECTED",
    NoShowPagecard = "NO_SHOW_PAGECARD",
    ShowPagecard = "SHOW_PAGECARD"
}

export enum PageCopyRestrictionValidationStatus {
    InvalidMultiple = "INVALID_MULTIPLE",
    InvalidSingle = "INVALID_SINGLE",
    Valid = "VALID"
}

export type PageEdge = {
    __typename?: "PageEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Page>;
};

export type PageGroupRestriction = {
    __typename?: "PageGroupRestriction";
    name: Scalars["String"]["output"];
};

export type PageGroupRestrictionInput = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    name: Scalars["String"]["input"];
};

/**
 * Relay-style PageInfo type.
 *
 * See [PageInfo specification](https://relay.dev/assets/files/connections-932f4f2cdffd79724ac76373deb30dc8.htm#sec-undefined.PageInfo)
 */
export type PageInfo = {
    __typename?: "PageInfo";
    /** endCursor must be the cursor corresponding to the last node in `edges`. */
    endCursor?: Maybe<Scalars["String"]["output"]>;
    /**
     * `hasNextPage` is used to indicate whether more edges exist following the set defined by the clients arguments. If the client is paginating
     * with `first` / `after`, then the server must return true if further edges exist, otherwise false. If the client is paginating with `last` / `before`,
     * then the client may return true if edges further from before exist, if it can do so efficiently, otherwise may return false.
     */
    hasNextPage: Scalars["Boolean"]["output"];
    /**
     * `hasPreviousPage` is used to indicate whether more edges exist prior to the set defined by the clients arguments. If the client is paginating
     * with `last` / `before`, then the server must return true if prior edges exist, otherwise false. If the client is paginating with `first` / `after`,
     * then the client may return true if edges prior to after exist, if it can do so efficiently, otherwise may return false.
     */
    hasPreviousPage: Scalars["Boolean"]["output"];
    /** startCursor must be the cursor corresponding to the first node in `edges`. */
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PageInput = {
    /** the parent page ID, default is no parent page (i.e. root page in the space) */
    body?: InputMaybe<PageBodyInput>;
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    restrictions?: InputMaybe<PageRestrictionsInput>;
    status?: InputMaybe<PageStatusInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PageRestriction = {
    __typename?: "PageRestriction";
    group?: Maybe<Array<PageGroupRestriction>>;
    user?: Maybe<Array<PageUserRestriction>>;
};

export type PageRestrictionInput = {
    group?: InputMaybe<Array<PageGroupRestrictionInput>>;
    user?: InputMaybe<Array<PageUserRestrictionInput>>;
};

export type PageRestrictions = {
    __typename?: "PageRestrictions";
    read?: Maybe<PageRestriction>;
    update?: Maybe<PageRestriction>;
};

export type PageRestrictionsInput = {
    read?: InputMaybe<PageRestrictionInput>;
    update?: InputMaybe<PageRestrictionInput>;
};

export enum PageStatusInput {
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum PageUpdateTrigger {
    CreatePage = "CREATE_PAGE",
    DiscardChanges = "DISCARD_CHANGES",
    EditPage = "EDIT_PAGE",
    LinkRefactoring = "LINK_REFACTORING",
    MigratePageCollab = "MIGRATE_PAGE_COLLAB",
    OwnerChange = "OWNER_CHANGE",
    PageRename = "PAGE_RENAME",
    PersonalTasklist = "PERSONAL_TASKLIST",
    Revert = "REVERT",
    SpaceCreate = "SPACE_CREATE",
    Unknown = "UNKNOWN",
    ViewPage = "VIEW_PAGE"
}

export type PageUserRestriction = {
    __typename?: "PageUserRestriction";
    id: Scalars["ID"]["output"];
};

export type PageUserRestrictionInput = {
    id: Scalars["ID"]["input"];
};

export type PageValidationResult = {
    __typename?: "PageValidationResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export enum PagesDisplayPersistenceOption {
    Cards = "CARDS",
    CompactList = "COMPACT_LIST",
    List = "LIST"
}

export enum PagesSortField {
    LastModifiedDate = "LAST_MODIFIED_DATE",
    Relevant = "RELEVANT",
    Title = "TITLE"
}

export enum PagesSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type PagesSortPersistenceOption = {
    __typename?: "PagesSortPersistenceOption";
    field: PagesSortField;
    order: PagesSortOrder;
};

export type PagesSortPersistenceOptionInput = {
    field: PagesSortField;
    order: PagesSortOrder;
};

export type PaginatedAllUpdatesFeed = {
    __typename?: "PaginatedAllUpdatesFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<AllUpdatesFeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: FeedPageInfo;
};

export type PaginatedCommentList = {
    __typename?: "PaginatedCommentList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<CommentEdge>>>;
    nodes?: Maybe<Array<Maybe<Comment>>>;
    pageInfo?: Maybe<PageInfo>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type PaginatedContentHistoryList = {
    __typename?: "PaginatedContentHistoryList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ContentHistoryEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<ContentHistory>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedContentList = {
    __typename?: "PaginatedContentList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<ContentEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<Content>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedContentListWithChild = {
    __typename?: "PaginatedContentListWithChild";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    child?: Maybe<ConfluenceChildContent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<ContentEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<Content>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedDeactivatedUserPageCountEntityList = {
    __typename?: "PaginatedDeactivatedUserPageCountEntityList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<DeactivatedUserPageCountEntityEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<DeactivatedUserPageCountEntity>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedFeed = {
    __typename?: "PaginatedFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<FeedItemEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<FeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: FeedPageInformation;
};

export type PaginatedGroupList = {
    __typename?: "PaginatedGroupList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<GroupEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<Group>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedGroupWithPermissions = {
    __typename?: "PaginatedGroupWithPermissions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<GroupWithPermissionsEdge>>>;
    nodes?: Maybe<Array<Maybe<GroupWithPermissions>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedGroupWithRestrictions = {
    __typename?: "PaginatedGroupWithRestrictions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<GroupWithRestrictionsEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<GroupWithRestrictions>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedJsonContentPropertyList = {
    __typename?: "PaginatedJsonContentPropertyList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<JsonContentPropertyEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<JsonContentProperty>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedLabelList = {
    __typename?: "PaginatedLabelList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<LabelEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<Label>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedPageActivity = {
    __typename?: "PaginatedPageActivity";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<PageActivityEvent>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PageActivityPageInfo;
};

export type PaginatedPageList = {
    __typename?: "PaginatedPageList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<PageEdge>>>;
    nodes?: Maybe<Array<Maybe<Page>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedPersonList = {
    __typename?: "PaginatedPersonList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<PersonEdge>>>;
    nodes?: Maybe<Array<Maybe<Person>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedPopularFeed = {
    __typename?: "PaginatedPopularFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<PopularFeedItemEdge>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<PopularFeedItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: FeedPageInfo;
};

export type PaginatedPopularSpaceFeed = {
    __typename?: "PaginatedPopularSpaceFeed";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    data: PopularSpaceFeedPage;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: FeedPageInfo;
};

export type PaginatedSmartLinkList = {
    __typename?: "PaginatedSmartLinkList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SmartLinkEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<SmartLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedSnippetList = {
    __typename?: "PaginatedSnippetList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SnippetEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<Snippet>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedSpaceList = {
    __typename?: "PaginatedSpaceList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SpaceEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<Space>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedSpacePermissionSubjectList = {
    __typename?: "PaginatedSpacePermissionSubjectList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<SpacePermissionSubjectEdge>>>;
    /** GraphQL query to get total number of groups which have space permissions */
    groupCount: Scalars["Int"]["output"];
    nodes?: Maybe<Array<Maybe<SpacePermissionSubject>>>;
    pageInfo?: Maybe<PageInfo>;
    /** GraphQL query to get total number of users and groups which have space permissions */
    totalCount: Scalars["Int"]["output"];
    /** GraphQL query to get total number of users which have space permissions */
    userCount: Scalars["Int"]["output"];
};

export type PaginatedStalePagePayloadList = {
    __typename?: "PaginatedStalePagePayloadList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<StalePagePayloadEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<StalePagePayload>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedSubjectUserOrGroupList = {
    __typename?: "PaginatedSubjectUserOrGroupList";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<SubjectUserOrGroupEdge>>>;
    /** GraphQL query to get total number of groups which have content permissions */
    groupCount: Scalars["Int"]["output"];
    nodes?: Maybe<Array<Maybe<SubjectUserOrGroup>>>;
    pageInfo?: Maybe<PageInfo>;
    /** GraphQL query to get total number of users and groups which have content permissions */
    totalCount: Scalars["Int"]["output"];
    /** GraphQL query to get total number of users which have content permissions */
    userCount: Scalars["Int"]["output"];
};

export type PaginatedTemplateBodyList = {
    __typename?: "PaginatedTemplateBodyList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<TemplateBodyEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<TemplateBody>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedTemplateCategoryList = {
    __typename?: "PaginatedTemplateCategoryList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<TemplateCategoryEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<TemplateCategory>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedTemplateInfoList = {
    __typename?: "PaginatedTemplateInfoList";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<TemplateInfoEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    links?: Maybe<LinksContextBase>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<TemplateInfo>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo?: Maybe<PageInfo>;
};

export type PaginatedUserWithRestrictions = {
    __typename?: "PaginatedUserWithRestrictions";
    count?: Maybe<Scalars["Int"]["output"]>;
    edges?: Maybe<Array<Maybe<UserWithRestrictionsEdge>>>;
    links?: Maybe<LinksContextBase>;
    nodes?: Maybe<Array<Maybe<UserWithRestrictions>>>;
    pageInfo?: Maybe<PageInfo>;
};

/** --------------------------------------------------------------------------------------------- */
export type Partner = {
    __typename?: "Partner";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    invoiceJson?: Maybe<PartnerInvoiceJson>;
    /**
     * Get all cloud and BTF product offerings and pricing information
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    offeringCatalog?: Maybe<PartnerOfferingListResponse>;
    /**
     * Get offering and pricing details for a given product, including related apps
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    offeringDetails?: Maybe<PartnerOfferingDetailsResponse>;
};

/** --------------------------------------------------------------------------------------------- */
export type PartnerInvoiceJsonArgs = {
    where?: InputMaybe<PartnerInvoiceJsonFilter>;
};

/** --------------------------------------------------------------------------------------------- */
export type PartnerOfferingDetailsArgs = {
    where?: InputMaybe<PartnerOfferingFilter>;
};

export type PartnerBillingCycle = {
    __typename?: "PartnerBillingCycle";
    count?: Maybe<Scalars["Int"]["output"]>;
    interval?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerBillingSpecificTier = {
    __typename?: "PartnerBillingSpecificTier";
    currency?: Maybe<Scalars["String"]["output"]>;
    editionType?: Maybe<Scalars["String"]["output"]>;
    entitionTypeIsDepercated?: Maybe<Scalars["Boolean"]["output"]>;
    price?: Maybe<Scalars["Float"]["output"]>;
    unitBlockSize?: Maybe<Scalars["Int"]["output"]>;
    unitLabel?: Maybe<Scalars["String"]["output"]>;
    unitLimit?: Maybe<Scalars["Int"]["output"]>;
    unitStart?: Maybe<Scalars["Int"]["output"]>;
};

export enum PartnerBtfLicenseType {
    Academic = "ACADEMIC",
    Commercial = "COMMERCIAL",
    Evaluation = "EVALUATION",
    Starter = "STARTER"
}

export type PartnerBtfProduct = PartnerBtfProductNode & {
    __typename?: "PartnerBtfProduct";
    annual?: Maybe<Array<Maybe<PartnerBillingSpecificTier>>>;
    billingType?: Maybe<Scalars["String"]["output"]>;
    contactSalesForAdditionalPricing?: Maybe<Scalars["Boolean"]["output"]>;
    dataCenter?: Maybe<Scalars["Boolean"]["output"]>;
    discountOptOut?: Maybe<Scalars["Boolean"]["output"]>;
    lastModified?: Maybe<Scalars["String"]["output"]>;
    marketplaceAddon?: Maybe<Scalars["Boolean"]["output"]>;
    monthly?: Maybe<Array<Maybe<PartnerBillingSpecificTier>>>;
    orderableItems?: Maybe<Array<Maybe<PartnerOrderableItem>>>;
    parentDescription?: Maybe<Scalars["String"]["output"]>;
    parentKey?: Maybe<Scalars["String"]["output"]>;
    productDescription?: Maybe<Scalars["String"]["output"]>;
    productKey: Scalars["ID"]["output"];
    productType?: Maybe<Scalars["String"]["output"]>;
    userCountEnforced?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PartnerBtfProductItem = PartnerBtfProductNode & {
    __typename?: "PartnerBtfProductItem";
    productDescription?: Maybe<Scalars["String"]["output"]>;
    productKey: Scalars["ID"]["output"];
};

export type PartnerBtfProductNode = {
    productDescription?: Maybe<Scalars["String"]["output"]>;
    productKey: Scalars["ID"]["output"];
};

export type PartnerCloudApp = PartnerOfferingNode & {
    __typename?: "PartnerCloudApp";
    billingType?: Maybe<Scalars["String"]["output"]>;
    hostingType?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    level?: Maybe<Scalars["Int"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    parent?: Maybe<Scalars["String"]["output"]>;
    pricingType?: Maybe<Scalars["String"]["output"]>;
    sku?: Maybe<Scalars["String"]["output"]>;
    supportedBillingSystems?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export enum PartnerCloudLicenseType {
    Academic = "ACADEMIC",
    Commercial = "COMMERCIAL",
    Community = "COMMUNITY",
    Demonstration = "DEMONSTRATION",
    Developer = "DEVELOPER",
    Evaluation = "EVALUATION",
    Free = "FREE",
    OpenSource = "OPEN_SOURCE",
    Starter = "STARTER"
}

export type PartnerCloudProduct = PartnerCloudProductNode & {
    __typename?: "PartnerCloudProduct";
    chargeElements?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    offerings?: Maybe<Array<Maybe<PartnerOfferingItem>>>;
    uncollectibleAction?: Maybe<PartnerUncollectibleAction>;
};

export type PartnerCloudProductItem = PartnerCloudProductNode & {
    __typename?: "PartnerCloudProductItem";
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerCloudProductNode = {
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export enum PartnerCurrency {
    Jpy = "JPY",
    Usd = "USD"
}

export type PartnerInvoiceJson = {
    __typename?: "PartnerInvoiceJson";
    billTo?: Maybe<PartnerInvoiceJsonBillToParty>;
    createdDate?: Maybe<Scalars["Long"]["output"]>;
    currency?: Maybe<PartnerInvoiceJsonCurrency>;
    dueDate?: Maybe<Scalars["Long"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    items?: Maybe<Array<Maybe<PartnerInvoiceJsonInvoiceItem>>>;
    number?: Maybe<Scalars["ID"]["output"]>;
    purchaseOrderNumber?: Maybe<Scalars["String"]["output"]>;
    shipTo?: Maybe<PartnerInvoiceJsonShipToParty>;
    status?: Maybe<Scalars["String"]["output"]>;
    totalExTax?: Maybe<Scalars["Float"]["output"]>;
    totalIncTax?: Maybe<Scalars["Float"]["output"]>;
    totalTax?: Maybe<Scalars["Float"]["output"]>;
    version?: Maybe<Scalars["Long"]["output"]>;
};

export type PartnerInvoiceJsonBillToParty = {
    __typename?: "PartnerInvoiceJsonBillToParty";
    name?: Maybe<Scalars["String"]["output"]>;
    postalAddress?: Maybe<PartnerInvoiceJsonPostalAddress>;
    priceEligibility?: Maybe<Scalars["JSON"]["output"]>;
    taxId?: Maybe<Scalars["String"]["output"]>;
    taxIds?: Maybe<Array<Maybe<PartnerInvoiceJsonTaxId>>>;
};

export enum PartnerInvoiceJsonCurrency {
    Aud = "AUD",
    Eur = "EUR",
    Gbp = "GBP",
    Jpy = "JPY",
    Usd = "USD"
}

/** --------------------------------------------------------------------------------------------- */
export type PartnerInvoiceJsonFilter = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    number?: InputMaybe<Scalars["ID"]["input"]>;
};

export type PartnerInvoiceJsonInvoiceItem = {
    __typename?: "PartnerInvoiceJsonInvoiceItem";
    adjustments?: Maybe<Array<Maybe<PartnerInvoiceJsonInvoiceItemAdjustments>>>;
    description?: Maybe<Scalars["String"]["output"]>;
    entitlementNumber?: Maybe<Scalars["String"]["output"]>;
    hostingType?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    isTrailPeriod?: Maybe<Scalars["Boolean"]["output"]>;
    licenseType?: Maybe<Scalars["String"]["output"]>;
    licensedTo?: Maybe<Scalars["String"]["output"]>;
    period?: Maybe<PartnerInvoiceJsonInvoiceItemPeriod>;
    productName?: Maybe<Scalars["String"]["output"]>;
    quantity: Scalars["Int"]["output"];
    saleType?: Maybe<Scalars["String"]["output"]>;
    total: Scalars["Float"]["output"];
    unitAmount?: Maybe<Scalars["Float"]["output"]>;
    upgradeCredit?: Maybe<Scalars["Float"]["output"]>;
};

export type PartnerInvoiceJsonInvoiceItemAdjustments = {
    __typename?: "PartnerInvoiceJsonInvoiceItemAdjustments";
    amount?: Maybe<Scalars["Float"]["output"]>;
    percent?: Maybe<Scalars["Float"]["output"]>;
    promotionId?: Maybe<Scalars["String"]["output"]>;
    reason?: Maybe<Scalars["String"]["output"]>;
    reasonCode?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerInvoiceJsonInvoiceItemPeriod = {
    __typename?: "PartnerInvoiceJsonInvoiceItemPeriod";
    endAt: Scalars["Long"]["output"];
    startAt: Scalars["Long"]["output"];
};

export type PartnerInvoiceJsonPostalAddress = {
    __typename?: "PartnerInvoiceJsonPostalAddress";
    city?: Maybe<Scalars["String"]["output"]>;
    country?: Maybe<Scalars["String"]["output"]>;
    line1?: Maybe<Scalars["String"]["output"]>;
    line2?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["String"]["output"]>;
    postcode?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerInvoiceJsonShipToParty = {
    __typename?: "PartnerInvoiceJsonShipToParty";
    createdAt?: Maybe<Scalars["Long"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    postalAddress?: Maybe<PartnerInvoiceJsonPostalAddress>;
    priceEligibility?: Maybe<Scalars["JSON"]["output"]>;
    taxId?: Maybe<Scalars["String"]["output"]>;
    taxIds?: Maybe<Array<Maybe<PartnerInvoiceJsonTaxId>>>;
    transactionAccountId?: Maybe<Scalars["String"]["output"]>;
    updatedAt?: Maybe<Scalars["Long"]["output"]>;
    version?: Maybe<Scalars["Long"]["output"]>;
};

export type PartnerInvoiceJsonTaxId = {
    __typename?: "PartnerInvoiceJsonTaxId";
    id?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    metadata?: Maybe<Scalars["JSON"]["output"]>;
    taxIdDescription?: Maybe<Scalars["String"]["output"]>;
    taxIdLabel?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerOfferingBtfInput = {
    /** Available currencies for a BTF product or app */
    currency?: InputMaybe<Array<InputMaybe<PartnerCurrency>>>;
    /** Available license types for a BTF offering */
    licenseType?: InputMaybe<Array<InputMaybe<PartnerBtfLicenseType>>>;
    /** Unique identifier for a BTF product */
    productKey: Scalars["ID"]["input"];
};

export type PartnerOfferingCloudInput = {
    /** Available currencies for a cloud product or app */
    currency?: InputMaybe<Array<InputMaybe<PartnerCurrency>>>;
    /** Unique identifier for a cloud product */
    id: Scalars["ID"]["input"];
    /** Available license types for a cloud offering */
    pricingPlanType?: InputMaybe<Array<InputMaybe<PartnerCloudLicenseType>>>;
};

export type PartnerOfferingDetailsResponse = {
    __typename?: "PartnerOfferingDetailsResponse";
    btfApps?: Maybe<Array<Maybe<PartnerBtfProduct>>>;
    btfProducts?: Maybe<Array<Maybe<PartnerBtfProduct>>>;
    cloudApps?: Maybe<Array<Maybe<PartnerCloudApp>>>;
    cloudProducts?: Maybe<Array<Maybe<PartnerCloudProduct>>>;
};

/** Search for available product offerings */
export type PartnerOfferingFilter = {
    /** Search BTF offerings by product key */
    btfProduct?: InputMaybe<PartnerOfferingBtfInput>;
    /** Search cloud offerings by product key */
    cloudProduct?: InputMaybe<PartnerOfferingCloudInput>;
};

export type PartnerOfferingItem = PartnerOfferingNode & {
    __typename?: "PartnerOfferingItem";
    billingType?: Maybe<Scalars["String"]["output"]>;
    hostingType?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    level?: Maybe<Scalars["Int"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    parent?: Maybe<Scalars["String"]["output"]>;
    pricingPlans?: Maybe<Array<Maybe<PartnerPricingPlan>>>;
    pricingType?: Maybe<Scalars["String"]["output"]>;
    sku?: Maybe<Scalars["String"]["output"]>;
    supportedBillingSystems?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type PartnerOfferingListResponse = {
    __typename?: "PartnerOfferingListResponse";
    btfProducts?: Maybe<Array<Maybe<PartnerBtfProductItem>>>;
    cloudProducts?: Maybe<Array<Maybe<PartnerCloudProductItem>>>;
};

export type PartnerOfferingNode = {
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerOrderableItem = PartnerOrderableItemNode & {
    __typename?: "PartnerOrderableItem";
    amount?: Maybe<Scalars["Float"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    edition?: Maybe<Scalars["String"]["output"]>;
    editionDescription?: Maybe<Scalars["String"]["output"]>;
    editionId?: Maybe<Scalars["String"]["output"]>;
    editionType?: Maybe<Scalars["String"]["output"]>;
    editionTypeIsDeprecated?: Maybe<Scalars["Boolean"]["output"]>;
    enterprise?: Maybe<Scalars["Boolean"]["output"]>;
    licenseType?: Maybe<Scalars["String"]["output"]>;
    monthsValid?: Maybe<Scalars["Int"]["output"]>;
    newPricingPlanItem?: Maybe<Scalars["String"]["output"]>;
    orderableItemId: Scalars["ID"]["output"];
    publiclyAvailable?: Maybe<Scalars["Boolean"]["output"]>;
    renewalAmount?: Maybe<Scalars["Float"]["output"]>;
    renewalFrequency?: Maybe<Scalars["String"]["output"]>;
    saleType?: Maybe<Scalars["String"]["output"]>;
    sku?: Maybe<Scalars["String"]["output"]>;
    starter?: Maybe<Scalars["Boolean"]["output"]>;
    unitCount?: Maybe<Scalars["Int"]["output"]>;
    unitLabel?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerOrderableItemNode = {
    currency?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    licenseType?: Maybe<Scalars["String"]["output"]>;
    orderableItemId: Scalars["ID"]["output"];
};

export type PartnerPricingPlan = PartnerPricingPlanNode & {
    __typename?: "PartnerPricingPlan";
    currency?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    items?: Maybe<Array<Maybe<PartnerPricingPlanItem>>>;
    primaryCycle?: Maybe<PartnerBillingCycle>;
    sku?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerPricingPlanItem = {
    __typename?: "PartnerPricingPlanItem";
    chargeElement?: Maybe<Scalars["String"]["output"]>;
    chargeType?: Maybe<Scalars["String"]["output"]>;
    cycle?: Maybe<PartnerBillingCycle>;
    tiers?: Maybe<Array<Maybe<PartnerPricingTier>>>;
    tiersMode?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerPricingPlanNode = {
    currency?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    type?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerPricingTier = {
    __typename?: "PartnerPricingTier";
    amount?: Maybe<Scalars["Float"]["output"]>;
    ceiling?: Maybe<Scalars["Float"]["output"]>;
    flatAmount?: Maybe<Scalars["Float"]["output"]>;
    floor?: Maybe<Scalars["Float"]["output"]>;
    policy?: Maybe<Scalars["String"]["output"]>;
    unitAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type PartnerUncollectibleAction = {
    __typename?: "PartnerUncollectibleAction";
    destination?: Maybe<PartnerUncollectibleDestination>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type PartnerUncollectibleDestination = {
    __typename?: "PartnerUncollectibleDestination";
    offeringKey: Scalars["ID"]["output"];
};

export type PatchCommentsSummaryInput = {
    commentsType: CommentsType;
    contentId: Scalars["ID"]["input"];
    contentType: SummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchCommentsSummaryPayload = {
    __typename?: "PatchCommentsSummaryPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["ID"]["output"];
};

export enum PathType {
    Absolute = "ABSOLUTE",
    Relative = "RELATIVE",
    RelativeNoContext = "RELATIVE_NO_CONTEXT"
}

/** The general shape of a mutation response. */
export type Payload = {
    /**
     * A list of errors if the mutation was not successful
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Was this mutation successful
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type PaywallContentSingle = {
    __typename?: "PaywallContentSingle";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    deactivationIdentifier: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    link?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
};

export enum PaywallStatus {
    Active = "ACTIVE",
    Deactivated = "DEACTIVATED",
    Unset = "UNSET"
}

export type PermissibleEstimationType = {
    __typename?: "PermissibleEstimationType";
    description?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    /** Possible estimation type values: STORY_POINTS, ORIGINAL_ESTIMATE, ISSUE_COUNT (Issue count is not supported yet) */
    value?: Maybe<Scalars["String"]["output"]>;
};

export enum PermissionDisplayType {
    Anonymous = "ANONYMOUS",
    Group = "GROUP",
    GuestUser = "GUEST_USER",
    LicensedUser = "LICENSED_USER"
}

export type PermissionMetadata = {
    __typename?: "PermissionMetadata";
    setPermission: Scalars["Boolean"]["output"];
};

export type PermissionToConsentByOauthId = {
    __typename?: "PermissionToConsentByOauthId";
    isAllowed: Scalars["Boolean"]["output"];
    isSiteAdmin: Scalars["Boolean"]["output"];
};

export type PermissionsViaGroups = {
    __typename?: "PermissionsViaGroups";
    edit: Array<Maybe<Group>>;
    view: Array<Maybe<Group>>;
};

export type PermsReportDownloadLink = {
    __typename?: "PermsReportDownloadLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
};

export enum PermsReportTargetType {
    Group = "GROUP",
    User = "USER"
}

export type Person = {
    displayName?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    permissionType?: Maybe<SitePermissionType>;
    profilePicture?: Maybe<Icon>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type PersonEdge = {
    __typename?: "PersonEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Person>;
};

/** ## Plan mode create cards ### */
export type PlanModeCardCreateInput = {
    boardId: Scalars["ID"]["input"];
    destination: PlanModeDestination;
    destinationId?: InputMaybe<Scalars["ID"]["input"]>;
    newCards: Array<InputMaybe<NewCard>>;
    rankBeforeCardId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type PlanModeCardMoveInput = {
    boardId: Scalars["ID"]["input"];
    cardIds: Array<Scalars["ID"]["input"]>;
    destination: PlanModeDestination;
    rankAfterCardId?: InputMaybe<Scalars["Long"]["input"]>;
    rankBeforeCardId?: InputMaybe<Scalars["Long"]["input"]>;
    sprintId?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum PlanModeDestination {
    Backlog = "BACKLOG",
    Board = "BOARD",
    Sprint = "SPRINT"
}

export enum Platform {
    Android = "ANDROID",
    Ios = "IOS",
    Web = "WEB"
}

export type PolarisAddReactionInput = {
    ari: Scalars["String"]["input"];
    containerAri: Scalars["String"]["input"];
    emojiId: Scalars["String"]["input"];
    metadata?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type PolarisAddReactionPayload = Payload & {
    __typename?: "PolarisAddReactionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node: Array<PolarisReactionSummary>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type PolarisComment = {
    __typename?: "PolarisComment";
    aaid: Scalars["String"]["output"];
    account?: Maybe<User>;
    content: Scalars["JSON"]["output"];
    created: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    kind: PolarisCommentKind;
    subject: Scalars["ID"]["output"];
    updated: Scalars["String"]["output"];
};

/** # Types */
export enum PolarisCommentKind {
    PlayContribution = "PLAY_CONTRIBUTION",
    View = "VIEW"
}

export type PolarisConnectApp = {
    __typename?: "PolarisConnectApp";
    /**
     * appId is the CaaS app id.  Note that a single app may have
     * multiple oauth client ids, notably when deployed in different
     * environments such as staging and production
     */
    appId?: Maybe<Scalars["String"]["output"]>;
    /** avatarUrl of CaaS app */
    avatarUrl: Scalars["String"]["output"];
    /**
     * the oauthClientId, which functions as the unique identifier id of CaaS app
     * for our purposes
     */
    id: Scalars["ID"]["output"];
    /** name of CaaS app */
    name: Scalars["String"]["output"];
    /** oauthClientId of CaaS app */
    oauthClientId: Scalars["String"]["output"];
    play?: Maybe<PolarisPlay>;
};

export type PolarisDecoration = {
    __typename?: "PolarisDecoration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The decoration to apply to a matched value.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    valueDecoration: PolarisValueDecoration;
    /**
     * The decoration can be applied when a value matches all rules in this array.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    valueRules: Array<PolarisValueRule>;
};

export type PolarisDelegationToken = {
    __typename?: "PolarisDelegationToken";
    expires: Scalars["String"]["output"];
    token: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export type PolarisDeleteReactionInput = {
    ari: Scalars["String"]["input"];
    containerAri: Scalars["String"]["input"];
    emojiId: Scalars["String"]["input"];
    metadata?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type PolarisDeleteReactionPayload = Payload & {
    __typename?: "PolarisDeleteReactionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node: Array<PolarisReactionSummary>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** # Types */
export enum PolarisFieldType {
    PolarisIdeaPlayField = "PolarisIdeaPlayField",
    PolarisJiraField = "PolarisJiraField"
}

export enum PolarisFilterEnumType {
    BoardColumn = "BOARD_COLUMN",
    ViewGroup = "VIEW_GROUP"
}

export type PolarisFilterInput = {
    jql?: InputMaybe<Scalars["String"]["input"]>;
};

export type PolarisGetDetailedReactionInput = {
    ari: Scalars["String"]["input"];
    containerAri: Scalars["String"]["input"];
    emojiId: Scalars["String"]["input"];
};

export type PolarisGetReactionsInput = {
    aris?: InputMaybe<Array<Scalars["String"]["input"]>>;
    containerAri: Scalars["String"]["input"];
};

export type PolarisGroupValue = {
    __typename?: "PolarisGroupValue";
    /** a label value (which has no identity besides its string value) */
    id?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
};

export type PolarisGroupValueInput = {
    /** a label value (which has no identity besides its string value) */
    id?: InputMaybe<Scalars["String"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
};

/** # Types */
export type PolarisIdea = {
    __typename?: "PolarisIdea";
    archived?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    lastCommentsViewedTimestamp?: Maybe<Scalars["String"]["output"]>;
    lastInsightsViewedTimestamp?: Maybe<Scalars["String"]["output"]>;
};

/**
 * An PolarisIdeaField is a unit of information that can be instantiated
 * for an PolarisIdea.
 */
export type PolarisIdeaField = {
    /**
     * Same as jiraFieldKey, only exists for legacy reasons.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The key of this field in the `fields` structure if it is a Jira
     * field.  Not set for things that don't appear in the fields section
     * of a Jira issue object, such as "key"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jiraFieldKey?: Maybe<Scalars["String"]["output"]>;
};

export type PolarisIdeaPlayField = PolarisIdeaField & {
    __typename?: "PolarisIdeaPlayField";
    id: Scalars["ID"]["output"];
    jiraFieldKey?: Maybe<Scalars["String"]["output"]>;
};

/** # Types */
export type PolarisIdeaTemplate = {
    __typename?: "PolarisIdeaTemplate";
    aaid?: Maybe<Scalars["String"]["output"]>;
    color?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    emoji?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    project?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Template in ADF format.  See
     * https://developer.atlassian.com/platform/atlassian-document-format/
     */
    template?: Maybe<Scalars["JSON"]["output"]>;
    title: Scalars["String"]["output"];
};

export type PolarisIdeaType = {
    __typename?: "PolarisIdeaType";
    description?: Maybe<Scalars["String"]["output"]>;
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

export type PolarisIdeas = {
    __typename?: "PolarisIdeas";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    ideas?: Maybe<Array<PolarisRestIdea>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    total: Scalars["Int"]["output"];
};

/** # Types */
export type PolarisInsight = {
    __typename?: "PolarisInsight";
    /** AAID of the user who owns the insight */
    aaid: Scalars["String"]["output"];
    account?: Maybe<User>;
    /**
     * The ID of the object within the project which contains this data
     * point (nee insight), if any.  In the usual case, if not null, this
     * is an idea (issue) ARI
     */
    container?: Maybe<Scalars["ID"]["output"]>;
    /** if an insight is from a play, a link to the play */
    contribs?: Maybe<Array<PolarisPlayContribution>>;
    /** Creation time of data point in RFC3339 format */
    created: Scalars["String"]["output"];
    /**
     * Description in ADF format.  See
     * https://developer.atlassian.com/platform/atlassian-document-format/
     */
    description?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * ARI of the insight, for example:
     *
     *    `ari:cloud:cebeacbd-f85e-483c-96ac-fd432a12ad1c:polaris-insight/10004`
     */
    id: Scalars["ID"]["output"];
    play?: Maybe<PolarisPlay>;
    /** Array of snippets attached to this data point. */
    snippets: Array<PolarisSnippet>;
    /** Updated time of data point in RFC3339 format */
    updated: Scalars["String"]["output"];
};

export type PolarisIssueLinkType = {
    __typename?: "PolarisIssueLinkType";
    datapoint: Scalars["Int"]["output"];
    delivery: Scalars["Int"]["output"];
    merge: Scalars["Int"]["output"];
};

/**
 *  This is a type to denote that the field does NOT exist in polaris, but instead in Jira.
 *  no value should be used apart from jiraFieldKey (and ID which is equal to jiraFieldKey)
 */
export type PolarisJiraField = PolarisIdeaField & {
    __typename?: "PolarisJiraField";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    jiraFieldKey?: Maybe<Scalars["String"]["output"]>;
};

export type PolarisMatrixAxis = {
    __typename?: "PolarisMatrixAxis";
    dimension: Scalars["String"]["output"];
    field: PolarisIdeaField;
    fieldOptions?: Maybe<Array<PolarisGroupValue>>;
    reversed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PolarisMatrixConfig = {
    __typename?: "PolarisMatrixConfig";
    axes?: Maybe<Array<PolarisMatrixAxis>>;
};

export type PolarisMutationNamespace = {
    __typename?: "PolarisMutationNamespace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    ranking?: Maybe<PolarisRankingMutationNamespace>;
};

export type PolarisPlay = {
    __typename?: "PolarisPlay";
    contribution?: Maybe<PolarisPlayContribution>;
    /** the parameters used to define the play */
    contributions?: Maybe<Array<PolarisPlayContribution>>;
    contributionsBySubject?: Maybe<Array<PolarisPlayContribution>>;
    /** if there is a specific view for this play */
    fields?: Maybe<Array<PolarisIdeaPlayField>>;
    id: Scalars["ID"]["output"];
    /** the label for the play */
    kind: PolarisPlayKind;
    label: Scalars["String"]["output"];
    /** if there are fields for this play */
    parameters?: Maybe<Scalars["JSON"]["output"]>;
    /** the kind of play this is */
    view?: Maybe<PolarisView>;
};

export type PolarisPlayContributionArgs = {
    id: Scalars["ID"]["input"];
};

export type PolarisPlayContributionsBySubjectArgs = {
    subject: Scalars["ID"]["input"];
};

export type PolarisPlayContribution = {
    __typename?: "PolarisPlayContribution";
    /** the item to which the contribution applies (the idea) */
    aaid: Scalars["String"]["output"];
    /** the author of the contribution */
    account?: Maybe<User>;
    amount?: Maybe<Scalars["Int"]["output"]>;
    /** when this contribution was last updated */
    appearsIn?: Maybe<PolarisInsight>;
    comment?: Maybe<PolarisComment>;
    created: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    play: PolarisPlay;
    /** the play that contains the contribution */
    subject: Scalars["ID"]["output"];
    /** when this contribution was created */
    updated: Scalars["String"]["output"];
};

export enum PolarisPlayKind {
    PolarisBudgetAllocationPlay = "PolarisBudgetAllocationPlay"
}

export type PolarisPresentation = {
    __typename?: "PolarisPresentation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    parameters?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The type of presentation.  Intended to select the UI control for this
     * field.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: Scalars["String"]["output"];
};

export type PolarisProject = {
    __typename?: "PolarisProject";
    /**
     * Jira activation ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    activationId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    arjConfiguration: ArjConfiguration;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    arjHierarchyConfiguration?: Maybe<Array<ArjHierarchyConfigurationLevel>>;
    /**
     * Project avatar URL
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    avatarUrls: ProjectAvatars;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fields: Array<PolarisIdeaField>;
    /**
     * ARI of the project which is a polaris project, for example:
     *
     *    `ari:cloud:cebeacbd-f85e-483c-96ac-fd432a12ad1c:project/10004`
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Initially only expect to have one idea type per project.  Defining
     * as a list here for future expandability.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    ideaTypes: Array<PolarisIdeaType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    ideas: Array<PolarisIdea>;
    /**
     * The insights associated with this project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    insights?: Maybe<Array<PolarisInsight>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueLinkType: PolarisIssueLinkType;
    /**
     * Every Jira project has a key
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
    /**
     * Every Jira project has a name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onboardTemplate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onboarded: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onboardedAt?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    play?: Maybe<PolarisPlay>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    plays?: Maybe<Array<PolarisPlay>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    rankField?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    refreshing: PolarisRefreshStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    selectedDeliveryProject?: Maybe<Scalars["ID"]["output"]>;
    /**
     * OAuth clients (and potentially other data providers) that have access
     * to this project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    snippetProviders?: Maybe<Array<PolarisSnippetProvider>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCategories?: Maybe<Array<PolarisStatusCategory>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    template?: Maybe<PolarisProjectTemplate>;
    /**
     * The views associated with this project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    views: Array<PolarisView>;
    /**
     * The view sets associated with this project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    viewsets?: Maybe<Array<PolarisViewSet>>;
};

export type PolarisProjectInsightsArgs = {
    archivedMode?: InputMaybe<ArchivedMode>;
};

export type PolarisProjectPlayArgs = {
    id: Scalars["ID"]["input"];
};

export type PolarisProjectSnippetProvidersArgs = {
    archivedMode?: InputMaybe<ArchivedMode>;
};

export type PolarisProjectTemplate = {
    __typename?: "PolarisProjectTemplate";
    ideas?: Maybe<Scalars["JSON"]["output"]>;
};

export type PolarisQueryNamespace = {
    __typename?: "PolarisQueryNamespace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    ranking?: Maybe<PolarisRankingQueryNamespace>;
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespace = {
    __typename?: "PolarisRankingMutationNamespace";
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    createList?: Maybe<RankingDiffPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    deleteList?: Maybe<RankingDiffPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    makeAfter?: Maybe<RankingDiffPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    makeBefore?: Maybe<RankingDiffPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    makeFirst?: Maybe<RankingDiffPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    makeLast?: Maybe<RankingDiffPayload>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    makeUnranked?: Maybe<RankingDiffPayload>;
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceCreateListArgs = {
    input: CreateRankingListInput;
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceDeleteListArgs = {
    listId: Scalars["ID"]["input"];
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceMakeAfterArgs = {
    items?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    listId: Scalars["ID"]["input"];
    refId: Scalars["ID"]["input"];
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceMakeBeforeArgs = {
    items?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    listId: Scalars["ID"]["input"];
    refId: Scalars["ID"]["input"];
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceMakeFirstArgs = {
    items?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    listId: Scalars["ID"]["input"];
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceMakeLastArgs = {
    items?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    listId: Scalars["ID"]["input"];
};

/**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */
export type PolarisRankingMutationNamespaceMakeUnrankedArgs = {
    items?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    listId: Scalars["ID"]["input"];
};

/** Query */
export type PolarisRankingQueryNamespace = {
    __typename?: "PolarisRankingQueryNamespace";
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    list?: Maybe<Array<Maybe<RankItem>>>;
};

/** Query */
export type PolarisRankingQueryNamespaceListArgs = {
    listId: Scalars["ID"]["input"];
};

export type PolarisReaction = {
    __typename?: "PolarisReaction";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value: Array<PolarisReactionSummary>;
};

export type PolarisReactionSummary = {
    __typename?: "PolarisReactionSummary";
    ari: Scalars["String"]["output"];
    containerAri: Scalars["String"]["output"];
    count: Scalars["Int"]["output"];
    emojiId: Scalars["String"]["output"];
    reacted: Scalars["Boolean"]["output"];
    users?: Maybe<Array<PolarisReactionUser>>;
};

export type PolarisReactionUser = {
    __typename?: "PolarisReactionUser";
    displayName: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
};

export enum PolarisRefreshError {
    InternalError = "INTERNAL_ERROR",
    InvalidSnippet = "INVALID_SNIPPET",
    NeedAuth = "NEED_AUTH",
    NotFound = "NOT_FOUND"
}

export type PolarisRefreshInfo = {
    __typename?: "PolarisRefreshInfo";
    /** (timestamp) when will next be refreshed */
    autoSeconds?: Maybe<Scalars["Int"]["output"]>;
    error?: Maybe<Scalars["String"]["output"]>;
    /** an error message */
    errorCode?: Maybe<Scalars["Int"]["output"]>;
    /** an error code */
    errorType?: Maybe<PolarisRefreshError>;
    /** (timestamp) when it was queued */
    last?: Maybe<Scalars["String"]["output"]>;
    /** (timestamp) when was last refreshed */
    next?: Maybe<Scalars["String"]["output"]>;
    /** enum version of errorCode */
    queued?: Maybe<Scalars["String"]["output"]>;
    /** auto refresh interval in seconds */
    timeToLiveSeconds?: Maybe<Scalars["Int"]["output"]>;
};

export type PolarisRefreshJob = {
    __typename?: "PolarisRefreshJob";
    progress?: Maybe<PolarisRefreshJobProgress>;
    /**
     * If this is a synchronous refresh, we can return the newly refreshed snippets
     * directly.
     */
    refreshedSnippets?: Maybe<Array<PolarisSnippet>>;
};

export type PolarisRefreshJobProgress = {
    __typename?: "PolarisRefreshJobProgress";
    errorCount: Scalars["Int"]["output"];
    pendingCount: Scalars["Int"]["output"];
};

export type PolarisRefreshStatus = {
    __typename?: "PolarisRefreshStatus";
    count: Scalars["Int"]["output"];
    errors: Scalars["Int"]["output"];
    last?: Maybe<Scalars["String"]["output"]>;
    pending: Scalars["Int"]["output"];
};

/** # Types */
export enum PolarisResolvedObjectAuthType {
    ApiKey = "API_KEY",
    Oauth2 = "OAUTH2"
}

export type PolarisRestIdea = {
    __typename?: "PolarisRestIdea";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    fields: Scalars["JSON"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key: Scalars["String"]["output"];
};

/** # Types */
export type PolarisSnippet = {
    __typename?: "PolarisSnippet";
    appInfo?: Maybe<PolarisConnectApp>;
    /** Data in JSON format */
    data?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * ARI of the snippet, for example:
     *
     *    `ari:cloud:cebeacbd-f85e-483c-96ac-fd432a12ad1c:polaris-snippet/10004`
     */
    id: Scalars["ID"]["output"];
    /** OauthClientId of CaaS app */
    oauthClientId: Scalars["String"]["output"];
    /** Snippet-level properties in JSON format. */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * Information about the refreshing of this snippet.  Null if the snippet
     * is not refreshable.
     */
    refresh?: Maybe<PolarisRefreshInfo>;
    /** Timestamp of when the snippet was last updated */
    updated: Scalars["String"]["output"];
    /** Snippet url that is source of data */
    url?: Maybe<Scalars["String"]["output"]>;
};

export type PolarisSnippetGroupDecl = {
    __typename?: "PolarisSnippetGroupDecl";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    /** must be unique per PolarisSnippetProvider */
    label?: Maybe<Scalars["String"]["output"]>;
    properties?: Maybe<Array<PolarisSnippetPropertyDecl>>;
};

export type PolarisSnippetPropertiesConfig = {
    __typename?: "PolarisSnippetPropertiesConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    config: Scalars["JSON"]["output"];
};

export type PolarisSnippetPropertyDecl = {
    __typename?: "PolarisSnippetPropertyDecl";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    kind?: Maybe<PolarisSnippetPropertyKind>;
    /** must be unique per PolarisSnippetProvider */
    label?: Maybe<Scalars["String"]["output"]>;
};

export enum PolarisSnippetPropertyKind {
    /** 1-5 integer rating */
    Labels = "LABELS",
    Number = "NUMBER",
    /** generic number */
    Rating = "RATING"
}

export type PolarisSnippetProvider = {
    __typename?: "PolarisSnippetProvider";
    app?: Maybe<PolarisConnectApp>;
    groups?: Maybe<Array<PolarisSnippetGroupDecl>>;
    id: Scalars["ID"]["output"];
    properties?: Maybe<Array<PolarisSnippetPropertyDecl>>;
};

export type PolarisSortField = {
    __typename?: "PolarisSortField";
    field: PolarisIdeaField;
    order?: Maybe<PolarisSortOrder>;
};

export type PolarisSortFieldInput = {
    field: Scalars["ID"]["input"];
    order?: InputMaybe<PolarisSortOrder>;
};

export enum PolarisSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type PolarisStatusCategory = {
    __typename?: "PolarisStatusCategory";
    colorName: Scalars["String"]["output"];
    id: Scalars["Int"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type PolarisTimelineConfig = {
    __typename?: "PolarisTimelineConfig";
    dueDateField?: Maybe<PolarisIdeaField>;
    endTimestamp?: Maybe<Scalars["String"]["output"]>;
    mode: PolarisTimelineMode;
    startDateField?: Maybe<PolarisIdeaField>;
    startTimestamp?: Maybe<Scalars["String"]["output"]>;
    summaryCardField?: Maybe<PolarisIdeaField>;
};

export enum PolarisTimelineMode {
    Months = "MONTHS",
    Quarters = "QUARTERS",
    Years = "YEARS"
}

export type PolarisValueDecoration = {
    __typename?: "PolarisValueDecoration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    emoji?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    highlightContainer?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum PolarisValueOperator {
    Eq = "EQ",
    Gt = "GT",
    Gte = "GTE",
    Lt = "LT",
    Lte = "LTE"
}

export type PolarisValueRule = {
    __typename?: "PolarisValueRule";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    operator: PolarisValueOperator;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value: Scalars["String"]["output"];
};

export type PolarisView = {
    __typename?: "PolarisView";
    /** DEPRECATED: A token for talking to pf-collab-service */
    collabServiceDelegation?: Maybe<PolarisDelegationToken>;
    /** The comment stream */
    comments?: Maybe<Array<PolarisComment>>;
    /** View contains archived ideas */
    containsArchived: Scalars["Boolean"]["output"];
    /** View creation timestamp */
    createdAt?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["JSON"]["output"]>;
    emoji?: Maybe<Scalars["String"]["output"]>;
    /** Indicates if automatic saving is enabled on this view */
    enabledAutoSave?: Maybe<Scalars["Boolean"]["output"]>;
    /** table column sizes per field */
    fieldRollups?: Maybe<Array<PolarisViewFieldRollup>>;
    /** rollup type per field */
    fields: Array<PolarisIdeaField>;
    filter?: Maybe<Array<PolarisViewFilter>>;
    groupBy?: Maybe<PolarisIdeaField>;
    groupValues?: Maybe<Array<PolarisGroupValue>>;
    hidden?: Maybe<Array<PolarisIdeaField>>;
    /** Indicates if empty columns should be hidden in board view */
    hideEmptyColumns?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates if empty views should be collapsed when grouped */
    hideEmptyGroups?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * ARI of the polaris view itself.  For example,
     *
     *    `ari:cloud:cebeacbd-f85e-483c-96ac-fd432a12ad1c:polaris-view/10003`
     */
    id: Scalars["ID"]["output"];
    /**
     * Can the view be changed in-place?  Immutable views can be the
     * source of a clone operation, but it is an error to try to update
     * one.
     */
    immutable?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The JQL that would produce the same set of issues as are returned by
     * the ideas connection
     */
    jql?: Maybe<Scalars["String"]["output"]>;
    lastCommentsViewedTimestamp?: Maybe<Scalars["String"]["output"]>;
    lastViewed?: Maybe<Array<Maybe<PolarisViewLastViewed>>>;
    /** View layout type */
    layoutType?: Maybe<PolarisViewLayoutType>;
    matrixConfig?: Maybe<PolarisMatrixConfig>;
    /** The user's name (label) for the view */
    name: Scalars["String"]["output"];
    projectId: Scalars["Int"]["output"];
    /** view rank / position */
    rank: Scalars["Int"]["output"];
    sort?: Maybe<Array<PolarisSortField>>;
    /** View sort mode */
    sortMode: PolarisViewSortMode;
    tableColumnSizes?: Maybe<Array<PolarisViewTableColumnSize>>;
    timelineConfig?: Maybe<PolarisTimelineConfig>;
    /** View update timestamp */
    updatedAt?: Maybe<Scalars["String"]["output"]>;
    /** The user-supplied part of a JQL filter */
    userJql?: Maybe<Scalars["String"]["output"]>;
    /** Unique uuid of view */
    uuid: Scalars["ID"]["output"];
    verticalGroupBy?: Maybe<PolarisIdeaField>;
    verticalGroupValues?: Maybe<Array<PolarisGroupValue>>;
    viewSetId: Scalars["ID"]["output"];
    /**
     *  this is being flattened out from the visualization substructure;
     *  these view attributes are all modelled as optional, and their
     *  significance depends on the selected visualizationType
     */
    visualizationType: PolarisVisualizationType;
    whiteboardConfig?: Maybe<PolarisWhiteboardConfig>;
    /**
     * Legacy external id.  For old-style ARIs, this is the last segment
     * of the ARI.
     */
    xid?: Maybe<Scalars["Int"]["output"]>;
};

export type PolarisViewCommentsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PolarisViewJqlArgs = {
    filter?: InputMaybe<PolarisFilterInput>;
};

export type PolarisViewFieldRollup = {
    __typename?: "PolarisViewFieldRollup";
    field: PolarisIdeaField;
    /** polaris field */
    rollup: PolarisViewFieldRollupType;
};

export type PolarisViewFieldRollupInput = {
    field: Scalars["ID"]["input"];
    /** polaris field ID */
    rollup: PolarisViewFieldRollupType;
};

export enum PolarisViewFieldRollupType {
    Avg = "AVG",
    Count = "COUNT",
    Empty = "EMPTY",
    Filled = "FILLED",
    Max = "MAX",
    Median = "MEDIAN",
    Min = "MIN",
    Range = "RANGE",
    Sum = "SUM"
}

export type PolarisViewFilter = {
    __typename?: "PolarisViewFilter";
    field?: Maybe<PolarisIdeaField>;
    kind: PolarisViewFilterKind;
    values: Array<PolarisViewFilterValue>;
};

export type PolarisViewFilterInput = {
    field?: InputMaybe<Scalars["ID"]["input"]>;
    kind: PolarisViewFilterKind;
    values: Array<PolarisViewFilterValueInput>;
};

/** # Types */
export enum PolarisViewFilterKind {
    ConnectionFieldIdentity = "CONNECTION_FIELD_IDENTITY",
    FieldIdentity = "FIELD_IDENTITY",
    /** a field being matched by identity */
    FieldNumeric = "FIELD_NUMERIC",
    Interval = "INTERVAL",
    /** a field being matched by numeric comparison */
    Text = "TEXT"
}

export enum PolarisViewFilterOperator {
    EndAfterNow = "END_AFTER_NOW",
    EndBeforeNow = "END_BEFORE_NOW",
    Eq = "EQ",
    Gt = "GT",
    Gte = "GTE",
    Lt = "LT",
    Lte = "LTE",
    Neq = "NEQ",
    StartAfterNow = "START_AFTER_NOW",
    StartBeforeNow = "START_BEFORE_NOW"
}

export type PolarisViewFilterValue = {
    __typename?: "PolarisViewFilterValue";
    enumValue?: Maybe<PolarisFilterEnumType>;
    numericValue?: Maybe<Scalars["Float"]["output"]>;
    operator?: Maybe<PolarisViewFilterOperator>;
    stringValue?: Maybe<Scalars["String"]["output"]>;
};

export type PolarisViewFilterValueInput = {
    enumValue?: InputMaybe<PolarisFilterEnumType>;
    operator?: InputMaybe<PolarisViewFilterOperator>;
    text?: InputMaybe<Scalars["String"]["input"]>;
    value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type PolarisViewLastViewed = {
    __typename?: "PolarisViewLastViewed";
    aaid: Scalars["String"]["output"];
    account?: Maybe<User>;
    timestamp: Scalars["String"]["output"];
};

export enum PolarisViewLayoutType {
    Compact = "COMPACT",
    Detailed = "DETAILED",
    Summary = "SUMMARY"
}

export type PolarisViewSet = {
    __typename?: "PolarisViewSet";
    /**
     * ARI of the polaris viewSet itself.  For example,
     *
     *    `ari:cloud:cebeacbd-f85e-483c-96ac-fd432a12ad1c:viewset/10001`
     */
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    /** view rank / position */
    rank: Scalars["Int"]["output"];
    type?: Maybe<PolarisViewSetType>;
    /** Unique uuid of viewset */
    uuid: Scalars["ID"]["output"];
    views: Array<PolarisView>;
    viewsets: Array<PolarisViewSet>;
};

/** # Types */
export enum PolarisViewSetType {
    Capture = "CAPTURE",
    Custom = "CUSTOM",
    Deliver = "DELIVER",
    Prioritize = "PRIORITIZE",
    /** for views that are used to manage the display of single ideas (e.g., Idea views) */
    Section = "SECTION",
    Single = "SINGLE",
    System = "SYSTEM"
}

export enum PolarisViewSortMode {
    FieldsSort = "FIELDS_SORT",
    ProjectRank = "PROJECT_RANK",
    ViewRank = "VIEW_RANK"
}

export type PolarisViewTableColumnSize = {
    __typename?: "PolarisViewTableColumnSize";
    field: PolarisIdeaField;
    /** polaris field */
    size: Scalars["Int"]["output"];
};

export type PolarisViewTableColumnSizeInput = {
    field: Scalars["ID"]["input"];
    /** polaris field ID */
    size: Scalars["Int"]["input"];
};

export enum PolarisVisualizationType {
    Board = "BOARD",
    Collection = "COLLECTION",
    Matrix = "MATRIX",
    Section = "SECTION",
    Table = "TABLE",
    Timeline = "TIMELINE",
    Twoxtwo = "TWOXTWO"
}

export type PolarisWhiteboardConfig = {
    __typename?: "PolarisWhiteboardConfig";
    id: Scalars["ID"]["output"];
};

export type PopularFeedItem = {
    __typename?: "PopularFeedItem";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
};

export type PopularFeedItemEdge = {
    __typename?: "PopularFeedItemEdge";
    /** Edge cursor pagination is not supported. This will always be null! Use the endCursor in pageInfo for forward pagination. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: PopularFeedItem;
};

export type PopularSpaceFeedPage = {
    __typename?: "PopularSpaceFeedPage";
    page: Array<PopularFeedItem>;
};

export type PremiumExtensionsFeature = {
    __typename?: "PremiumExtensionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export enum PrincipalFilterType {
    Group = "GROUP",
    Guest = "GUEST",
    Team = "TEAM",
    User = "USER"
}

/**
 * Principals types that App can allow for unlicensed access. This maps to different type of users in product.
 * For example - in case of JSM users can be UNLICENSED, CUSTOMER and ANONYMOUS.
 * UNLICENSED is Atlassian Account users who do not have a license on the underlying product where the extension is rendering
 * CUSTOMER - A site-specific Customer Account (accountId in format qm:{uuid}:{uuid} see https://developer.atlassian.com/platform/identity/rest/v1/))
 * ANONYMOUS - An invocation by a user that is not authenticated i.e. a Public JSM Portal/Confluence Space/Jira Project etc
 */
export enum PrincipalType {
    Anonymous = "ANONYMOUS",
    Customer = "CUSTOMER",
    Unlicensed = "UNLICENSED"
}

export type PrioritizedOpenComments = {
    __typename?: "PrioritizedOpenComments";
    actionNeeded: Scalars["String"]["output"];
    recap: Scalars["String"]["output"];
    referenceCommentIds: Array<Scalars["ID"]["output"]>;
    title: Scalars["String"]["output"];
    why: Scalars["String"]["output"];
};

export type Privacy = {
    __typename?: "Privacy";
    ccpa?: Maybe<CcpaDetails>;
    dataProcessingAgreement?: Maybe<DataProcessingAgreement>;
    gdpr?: Maybe<GdprDetails>;
    privacyEnhancingTechniques?: Maybe<PrivacyEnhancingTechniques>;
};

export type PrivacyEnhancingTechniques = {
    __typename?: "PrivacyEnhancingTechniques";
    /** Does the app use any privacy enhancing technologies (PETs) to protect End-User Data? */
    arePrivacyEnhancingTechniquesSupported: Scalars["Boolean"]["output"];
    /** If arePrivacyEnhancingTechniquesSupported is True, list of privacy enhancing technologies(PETs) used */
    privacyEnhancingTechniquesSupported?: Maybe<
        Array<Maybe<Scalars["String"]["output"]>>
    >;
};

export enum Product {
    Confluence = "CONFLUENCE"
}

/** Listing data for a product */
export type ProductListing = {
    __typename?: "ProductListing";
    /** Additional identifiers associated with the product */
    additionalIds: ProductListingAdditionalIds;
    /** The icon URL for a product */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** Links associated with the product */
    links: ProductListingLinks;
    /** The localised short description value for all requested locales */
    localisedShortDescription?: Maybe<Array<LocalisedString>>;
    /** The localised tagline value for all requested locales */
    localisedTagLine?: Maybe<Array<LocalisedString>>;
    /** The logo (lockup) URL for a product */
    logoUrl?: Maybe<Scalars["String"]["output"]>;
    /** Name of the product */
    name: Scalars["String"]["output"];
    /** CCP product ID for the product */
    productId: Scalars["ID"]["output"];
    /** A short description of the product */
    shortDescription: Scalars["String"]["output"];
    /** Tagline of the product */
    tagLine: Scalars["String"]["output"];
};

/** Listing data for a product */
export type ProductListingIconUrlArgs = {
    strict?: InputMaybe<Scalars["Boolean"]["input"]>;
    theme?: InputMaybe<Scalars["String"]["input"]>;
};

/** Listing data for a product */
export type ProductListingLogoUrlArgs = {
    strict?: InputMaybe<Scalars["Boolean"]["input"]>;
    theme?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductListingAdditionalIds = {
    __typename?: "ProductListingAdditionalIds";
    /** The Marketplace appKey for Connect and Forge apps */
    mpacAppKey?: Maybe<Scalars["String"]["output"]>;
};

export type ProductListingLinks = {
    __typename?: "ProductListingLinks";
    /** Link to the "try" experience of a product */
    tryUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Product Listing Information or associated error in querying */
export type ProductListingResult = ProductListing | QueryError;

export type ProjectAvatars = {
    __typename?: "ProjectAvatars";
    x16: Scalars["URL"]["output"];
    x24: Scalars["URL"]["output"];
    x32: Scalars["URL"]["output"];
    x48: Scalars["URL"]["output"];
};

export type Properties = {
    __typename?: "Properties";
    /** Status of the form */
    formStatus: FormStatus;
    /** URL of jira tickets. */
    jiraIssueLinks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** TimeStamp at which form was updated */
    updatedAt?: Maybe<Scalars["Float"]["output"]>;
    /** Form updated-by information */
    updatedBy?: Maybe<Scalars["String"]["output"]>;
    updatedValues?: Maybe<Scalars["String"]["output"]>;
};

export type PublicLink = {
    __typename?: "PublicLink";
    id: Scalars["ID"]["output"];
    lastEnabledBy?: Maybe<Scalars["String"]["output"]>;
    lastEnabledDate?: Maybe<Scalars["String"]["output"]>;
    publicLinkUrlPath?: Maybe<Scalars["String"]["output"]>;
    status: PublicLinkStatus;
    title?: Maybe<Scalars["String"]["output"]>;
    type: Scalars["String"]["output"];
};

export enum PublicLinkAdminAction {
    Block = "BLOCK",
    Off = "OFF",
    On = "ON",
    Unblock = "UNBLOCK"
}

export type PublicLinkConnection = {
    __typename?: "PublicLinkConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<PublicLink>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PublicLinkPageInfo;
};

export enum PublicLinkDefaultSpaceStatus {
    Off = "OFF",
    On = "ON"
}

export type PublicLinkOnboardingReference = {
    __typename?: "PublicLinkOnboardingReference";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkId?: Maybe<Scalars["ID"]["output"]>;
};

export type PublicLinkPage = {
    __typename?: "PublicLinkPage";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastEnabledBy?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastEnabledDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageStatus: PublicLinkPageStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicLinkUrlPath?: Maybe<Scalars["String"]["output"]>;
};

export type PublicLinkPageInfo = {
    __typename?: "PublicLinkPageInfo";
    endPage?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    startPage?: Maybe<Scalars["String"]["output"]>;
};

export enum PublicLinkPageStatus {
    BlockedByClassificationLevel = "BLOCKED_BY_CLASSIFICATION_LEVEL",
    BlockedByContainerPolicy = "BLOCKED_BY_CONTAINER_POLICY",
    BlockedByOrg = "BLOCKED_BY_ORG",
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    BlockedBySpace = "BLOCKED_BY_SPACE",
    Off = "OFF",
    On = "ON",
    SiteBlocked = "SITE_BLOCKED",
    SiteDisabled = "SITE_DISABLED",
    SpaceBlocked = "SPACE_BLOCKED",
    SpaceDisabled = "SPACE_DISABLED"
}

export type PublicLinkPagesAdminActionPayload = {
    __typename?: "PublicLinkPagesAdminActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type PublicLinkPermissions = {
    __typename?: "PublicLinkPermissions";
    permissions: Array<PublicLinkPermissionsType>;
};

export enum PublicLinkPermissionsObjectType {
    Content = "CONTENT"
}

export enum PublicLinkPermissionsType {
    Edit = "EDIT"
}

export type PublicLinkSitePayload = {
    __typename?: "PublicLinkSitePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: PublicLinkSiteStatus;
};

export enum PublicLinkSiteStatus {
    BlockedByOrg = "BLOCKED_BY_ORG",
    Off = "OFF",
    On = "ON"
}

export type PublicLinkSpace = {
    __typename?: "PublicLinkSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<ConfluenceSpaceIcon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isPolicySetForClassificationLevel?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    previousStatus?: Maybe<PublicLinkSpaceStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceAlias?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    stats: PublicLinkSpaceStats;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: PublicLinkSpaceStatus;
};

export type PublicLinkSpaceConnection = {
    __typename?: "PublicLinkSpaceConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<PublicLinkSpace>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: PublicLinkPageInfo;
};

export type PublicLinkSpaceStats = {
    __typename?: "PublicLinkSpaceStats";
    publicLinks: PublicLinkStats;
};

export enum PublicLinkSpaceStatus {
    BlockedByContainerPolicy = "BLOCKED_BY_CONTAINER_POLICY",
    BlockedByOrg = "BLOCKED_BY_ORG",
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    Off = "OFF",
    On = "ON"
}

export type PublicLinkSpacesActionPayload = {
    __typename?: "PublicLinkSpacesActionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    newStatus: PublicLinkSpaceStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updatedSpaceIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export enum PublicLinkSpacesByCriteriaOrder {
    ActiveLinks = "ACTIVE_LINKS",
    Name = "NAME",
    Status = "STATUS"
}

export type PublicLinkStats = {
    __typename?: "PublicLinkStats";
    active?: Maybe<Scalars["Int"]["output"]>;
};

export enum PublicLinkStatus {
    BlockedByClassificationLevel = "BLOCKED_BY_CLASSIFICATION_LEVEL",
    BlockedByContainerPolicy = "BLOCKED_BY_CONTAINER_POLICY",
    BlockedByOrg = "BLOCKED_BY_ORG",
    BlockedByProduct = "BLOCKED_BY_PRODUCT",
    BlockedBySpace = "BLOCKED_BY_SPACE",
    Off = "OFF",
    On = "ON",
    SiteBlocked = "SITE_BLOCKED",
    SiteDisabled = "SITE_DISABLED",
    SpaceBlocked = "SPACE_BLOCKED",
    SpaceDisabled = "SPACE_DISABLED"
}

export enum PublicLinksByCriteriaOrder {
    DateEnabled = "DATE_ENABLED",
    Status = "STATUS",
    Title = "TITLE"
}

export type PublishConditions = {
    __typename?: "PublishConditions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    addonKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    context: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    dialog?: Maybe<PublishConditionsDialog>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorMessage: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    moduleKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
};

export type PublishConditionsDialog = {
    __typename?: "PublishConditionsDialog";
    header?: Maybe<Scalars["String"]["output"]>;
    height?: Maybe<Scalars["String"]["output"]>;
    url: Scalars["String"]["output"];
    width?: Maybe<Scalars["String"]["output"]>;
};

export type PublishedContentProperties = {
    __typename?: "PublishedContentProperties";
    coverPictureWidth?: Maybe<Scalars["String"]["output"]>;
    externalVersionId?: Maybe<Scalars["String"]["output"]>;
};

/** Accepts input to find pull requests based on the status and time range. */
export type PullRequestStatusInTimeRangeQueryFilter = {
    /** Returns the pull requests with this status. */
    status: CompassPullRequestStatusForStatusInTimeRangeFilter;
    /** The time range of the query. */
    timeRange: CompassQueryTimeRange;
};

export type PushNotificationCustomSettings = {
    __typename?: "PushNotificationCustomSettings";
    comment: Scalars["Boolean"]["output"];
    commentContentCreator: Scalars["Boolean"]["output"];
    commentReply: Scalars["Boolean"]["output"];
    createBlogPost: Scalars["Boolean"]["output"];
    createPage: Scalars["Boolean"]["output"];
    dailyDigest?: Maybe<Scalars["Boolean"]["output"]>;
    editBlogPost: Scalars["Boolean"]["output"];
    editPage: Scalars["Boolean"]["output"];
    grantContentAccessEdit?: Maybe<Scalars["Boolean"]["output"]>;
    grantContentAccessView?: Maybe<Scalars["Boolean"]["output"]>;
    likeBlogPost: Scalars["Boolean"]["output"];
    likeComment: Scalars["Boolean"]["output"];
    likePage: Scalars["Boolean"]["output"];
    mentionBlogPost: Scalars["Boolean"]["output"];
    mentionComment: Scalars["Boolean"]["output"];
    mentionPage: Scalars["Boolean"]["output"];
    reactionBlogPost?: Maybe<Scalars["Boolean"]["output"]>;
    reactionComment?: Maybe<Scalars["Boolean"]["output"]>;
    reactionPage?: Maybe<Scalars["Boolean"]["output"]>;
    requestContentAccess?: Maybe<Scalars["Boolean"]["output"]>;
    share: Scalars["Boolean"]["output"];
    shareGroup: Scalars["Boolean"]["output"];
    taskAssign: Scalars["Boolean"]["output"];
};

export type PushNotificationCustomSettingsInput = {
    comment: Scalars["Boolean"]["input"];
    commentContentCreator: Scalars["Boolean"]["input"];
    commentReply: Scalars["Boolean"]["input"];
    createBlogPost: Scalars["Boolean"]["input"];
    createPage: Scalars["Boolean"]["input"];
    dailyDigest?: InputMaybe<Scalars["Boolean"]["input"]>;
    editBlogPost: Scalars["Boolean"]["input"];
    editPage: Scalars["Boolean"]["input"];
    grantContentAccessEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
    grantContentAccessView?: InputMaybe<Scalars["Boolean"]["input"]>;
    likeBlogPost: Scalars["Boolean"]["input"];
    likeComment: Scalars["Boolean"]["input"];
    likePage: Scalars["Boolean"]["input"];
    mentionBlogPost: Scalars["Boolean"]["input"];
    mentionComment: Scalars["Boolean"]["input"];
    mentionPage: Scalars["Boolean"]["input"];
    reactionBlogPost?: InputMaybe<Scalars["Boolean"]["input"]>;
    reactionComment?: InputMaybe<Scalars["Boolean"]["input"]>;
    reactionPage?: InputMaybe<Scalars["Boolean"]["input"]>;
    requestContentAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
    share: Scalars["Boolean"]["input"];
    shareGroup: Scalars["Boolean"]["input"];
    taskAssign: Scalars["Boolean"]["input"];
};

export enum PushNotificationGroupInputType {
    None = "NONE",
    Quiet = "QUIET",
    Standard = "STANDARD"
}

export enum PushNotificationSettingGroup {
    Custom = "CUSTOM",
    None = "NONE",
    Quiet = "QUIET",
    Standard = "STANDARD"
}

export type Query = {
    __typename?: "Query";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'abTestCohorts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    abTestCohorts?: Maybe<Scalars["String"]["output"]>;
    /**
     * Discover actions that can be executed in certain contexts
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __pullrequest:write__
     *
     *
     */
    actions?: Maybe<Actions>;
    /**
     * API v2
     * Get user activities.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     *
     *
     * @deprecated Use activity instead
     */
    activities?: Maybe<Activities>;
    /**
     * API v3
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     * * __read:jira-work__
     * * __read:blogpost:confluence__
     * * __read:comment:confluence__
     * * __read:page:confluence__
     * * __read:space:confluence__
     *
     *
     */
    activity?: Maybe<Activity>;
    /**
     * Fetches the banner for normal user
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'adminAnnouncementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    adminAnnouncementBanner?: Maybe<ConfluenceAdminAnnouncementBanner>;
    /**
     * Fetches a particular banner's details for admin user when editing banner settings.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'adminAnnouncementBannerSetting' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    adminAnnouncementBannerSetting?: Maybe<ConfluenceAdminAnnouncementBannerSetting>;
    /**
     * Fetches the banner details for admin user when editing banner settings.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'adminAnnouncementBannerSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    adminAnnouncementBannerSettings?: Maybe<
        Array<Maybe<ConfluenceAdminAnnouncementBannerSetting>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'adminAnnouncementBannerSettingsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    adminAnnouncementBannerSettingsByCriteria?: Maybe<AdminAnnouncementBannerSettingConnection>;
    /**
     * List of report statuses.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'adminReportStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    adminReportStatus?: Maybe<ConfluenceAdminReportStatus>;
    agentAI_contextPanel?: Maybe<AgentAiContextPanelResult>;
    agentAI_summarizeIssue?: Maybe<AgentAiIssueSummaryResult>;
    /**
     * Query an agent by id
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_agentById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_agentById?: Maybe<AgentStudioAgentResult>;
    /**
     * Suggest conversation starters for an agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AgentStudio")' query directive to the 'agentStudio_suggestConversationStarters' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    agentStudio_suggestConversationStarters?: Maybe<AgentStudioSuggestConversationStartersResult>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    aiCoreApi_vsaReportingByProject?: Maybe<AiCoreApiVsaReportingResult>;
    /**
     * For product admins to fetch all the Confluence Spaces via permission bypassing on the current tenant. The result is paginated.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'allIndividualSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    allIndividualSpaces?: Maybe<SpaceInfoConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'allTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    allTemplates?: Maybe<PaginatedTemplateInfoList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'allUpdatesFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    allUpdatesFeed?: Maybe<PaginatedAllUpdatesFeed>;
    anchor?: Maybe<ContentPlatformAnchor>;
    anchors: ContentPlatformAnchorContentSearchConnection;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    app?: Maybe<App>;
    /**
     * Returns the list of active tunnels for a given app-id and environment-key.
     *
     * The tunnels are active for 30min by default, if not requested to be terminated.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appActiveTunnels?: Maybe<AppTunnelDefinitions>;
    /** App admin operations */
    appAdmin?: Maybe<AppAdminQuery>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appContributors: Array<AppContributor>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appDeployment?: Maybe<AppDeployment>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appHostServiceScopes: Array<Maybe<AppHostServiceScope>>;
    /**
     * Returns information about all the scopes from different Atlassian products
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appHostServices?: Maybe<Array<AppHostService>>;
    /**
     *  cs-installations Query
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appInstallationTask?: Maybe<AppInstallationTask>;
    /**
     * `appLogLines()` returns an object for paging over the contents of a single
     * invocation's log lines, given by the `invocation` parameter (an ID
     * returned from a `appLogs()` query).
     *
     * Each `AppLogLine` consists of a `timestamp`, an optional `message`,
     * an optional `level`, and an `other` field that contains any
     * additional JSON fields included in the log line.  (Since
     * the app itself can control the schema of this JSON, we can't
     * use native GraphQL capabilities to describe the fields here.)
     *
     * The returned objects use the Relay naming/nesting style of
     * `AppLogLineConnection` &rarr; `[AppLogLineEdge]` &rarr;  `AppLogLine`.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appLogLines?: Maybe<AppLogLineConnection>;
    /**
     * `appLogs()` returns an object for paging over AppLog objects, each of which
     * represents one invocation of a function.
     *
     * The returned objects use the Relay naming/nesting style of
     * `AppLogConnection` &rarr; `[AppLogEdge]` &rarr;  `AppLog`.
     *
     * It takes parameters (`query: LogQueryInput`) to narrow down the invocations
     * being searched, requiring at least an app and environment.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appLogs?: Maybe<AppLogConnection>;
    /**
     * Returns the list of app logs with define filter with logs searching capability.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    appLogsWithMetaData?: Maybe<AppLogsWithMetaDataResponse>;
    appStorage_sqlDatabase?: Maybe<AppStorageSqlDatabasePayload>;
    /**
     * Get an list of custom entity in a specific context
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __storage:app__
     *
     *
     */
    appStoredCustomEntities?: Maybe<AppStoredCustomEntityConnection>;
    /**
     * Get an entity in a specific context given an entity name and entity key
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __storage:app__
     *
     *
     */
    appStoredCustomEntity?: Maybe<AppStoredCustomEntity>;
    /**
     * Get an list of untyped entity in a specific context, optional query parameters where condition, first and after
     *
     * where condition to filter
     * returns the first N entities when queried. Should not exceed 20
     * this is a cursor after which (exclusive) the data should be fetched from
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __storage:app__
     *
     *
     */
    appStoredEntities?: Maybe<AppStoredEntityConnection>;
    /**
     * Get an untyped entity in a specific context given a key
     *
     * Keys must be between 1-100 characters long and must match the following pattern /^[a-zA-Z0-9:._\s-]+$/
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __storage:app__
     *
     *
     */
    appStoredEntity?: Maybe<AppStoredEntity>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    apps?: Maybe<AppConnection>;
    aquaOutgoingEmailLogs?: Maybe<AquaOutgoingEmailLogsQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'availableContentStates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    availableContentStates?: Maybe<AvailableContentStates>;
    bitbucket?: Maybe<BitbucketQuery>;
    /**
     * For the specified cloudId, retrieve the available Bitbucket repositories to link with a (new) service that has not been created yet.
     * If nameFilter is provided, only repositories with names containing this case-insensitive string will be returned.
     * With an existing service, the caller should use `devOpsService.bitbucketRepositoriesAvailableToLinkWith` field.
     */
    bitbucketRepositoriesAvailableToLinkWithNewDevOpsService?: Maybe<BitbucketRepositoryIdConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'blockedAccessRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    blockedAccessRestrictions?: Maybe<BlockedAccessRestrictions>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     * Given principalIds, resourceIds and permissionIds, this will return whether the principals have the permissions on the resources.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated This is used only for backward compatibility
     */
    bulkPermitted?: Maybe<Array<Maybe<BulkPermittedResponse>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "splitIssue")' query directive to the 'canSplitIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use `canSplitIssue` field in Card type instead
     */
    canSplitIssue?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'canvasToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    canvasToken?: Maybe<CanvasToken>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'catchupEditMetadataForContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    catchupEditMetadataForContent?: Maybe<CatchupEditMetadataForContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'catchupGetLastViewedTime' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    catchupGetLastViewedTime?: Maybe<CatchupLastViewedTimeResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'catchupVersionDiffMetadataForContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    catchupVersionDiffMetadataForContent?: Maybe<CatchupVersionDiffMetadataResponse>;
    ccp?: Maybe<CcpQueryApi>;
    /**
     * GraphQL query to get a hydrated classification level object using level ID.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'classificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    classificationLevel?: Maybe<ContentDataClassificationLevel>;
    /**
     * GraphQL query to get list of classification levels.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'classificationLevels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    classificationLevels?: Maybe<Array<ContentDataClassificationLevel>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    codeInJira?: Maybe<CodeInJira>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'collabDraft' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    collabDraft?: Maybe<CollabDraft>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'collabToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    collabToken?: Maybe<CollabTokenResponse>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    comments?: Maybe<PaginatedCommentList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'commentsDigest' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    commentsDigest?: Maybe<CommentsDigestResponse>;
    compass?: Maybe<CompassCatalogQueryApi>;
    confluence?: Maybe<ConfluenceQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_abTestCohorts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_abTestCohorts?: Maybe<Scalars["String"]["output"]>;
    /**
     * Fetches the banner for normal user
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_adminAnnouncementBanner' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_adminAnnouncementBanner?: Maybe<ConfluenceLegacyAdminAnnouncementBanner>;
    /**
     * Fetches a particular banner's details for admin user when editing banner settings.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_adminAnnouncementBannerSetting' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_adminAnnouncementBannerSetting?: Maybe<ConfluenceLegacyAdminAnnouncementBannerSetting>;
    /**
     * Fetches the banner details for admin user when editing banner settings.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_adminAnnouncementBannerSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_adminAnnouncementBannerSettings?: Maybe<
        Array<Maybe<ConfluenceLegacyAdminAnnouncementBannerSetting>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_adminAnnouncementBannerSettingsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_adminAnnouncementBannerSettingsByCriteria?: Maybe<ConfluenceLegacyAdminAnnouncementBannerSettingConnection>;
    /**
     * List of report statuses.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_adminReportStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_adminReportStatus?: Maybe<ConfluenceLegacyAdminReportStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_allTemplates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_allTemplates?: Maybe<ConfluenceLegacyPaginatedTemplateInfoList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_allUpdatesFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_allUpdatesFeed?: Maybe<ConfluenceLegacyPaginatedAllUpdatesFeed>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_atlassianUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_atlassianUser?: Maybe<ConfluenceLegacyAtlassianUser>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_availableContentStates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_availableContentStates?: Maybe<ConfluenceLegacyAvailableContentStates>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_canvasToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_canvasToken?: Maybe<ConfluenceLegacyCanvasToken>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_catchupEditMetadataForContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_catchupEditMetadataForContent?: Maybe<ConfluenceLegacyCatchupEditMetadataForContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_catchupVersionSummaryMetadataForContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_catchupVersionSummaryMetadataForContent?: Maybe<ConfluenceLegacyCatchupVersionSummaryMetadataForContent>;
    /**
     * GraphQL query to get a hydrated classification level object using level ID.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_classificationLevel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_classificationLevel?: Maybe<ConfluenceLegacyContentDataClassificationLevel>;
    /**
     * GraphQL query to get list of classification levels.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_classificationLevels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_classificationLevels?: Maybe<
        Array<ConfluenceLegacyContentDataClassificationLevel>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_collabToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_collabToken?: Maybe<ConfluenceLegacyCollabTokenResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_comments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_comments?: Maybe<ConfluenceLegacyPaginatedCommentList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_confluenceUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_confluenceUsers?: Maybe<ConfluenceLegacyPaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contactAdminPageConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contactAdminPageConfig?: Maybe<ConfluenceLegacycontactAdminPageConfig>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_content?: Maybe<ConfluenceLegacyPaginatedContentListWithChild>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentAnalyticsLastViewedAtByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentAnalyticsLastViewedAtByPage?: Maybe<ConfluenceLegacyContentAnalyticsLastViewedAtByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentAnalyticsTotalViewsByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentAnalyticsTotalViewsByPage?: Maybe<ConfluenceLegacyContentAnalyticsTotalViewsByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentAnalyticsViewedComments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentAnalyticsViewedComments?: Maybe<ConfluenceLegacyViewedComments>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentAnalyticsViewers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentAnalyticsViewers?: Maybe<ConfluenceLegacyContentAnalyticsViewers>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentAnalyticsViews' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentAnalyticsViews?: Maybe<ConfluenceLegacyContentAnalyticsViews>;
    /**
     * Fetches content body for a page/blog
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentBody' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentBody?: Maybe<ConfluenceLegacyContentBodyPerRepresentation>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentByState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentByState?: Maybe<ConfluenceLegacyPaginatedContentList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentContributors' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentContributors?: Maybe<ConfluenceLegacyContentContributors>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentConverter' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentConverter?: Maybe<ConfluenceBody>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentHistory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentHistory?: Maybe<ConfluenceLegacyPaginatedContentHistoryList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentIdByReferenceId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentIdByReferenceId?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentLabelSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentLabelSearch?: Maybe<ConfluenceLegacyLabelSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentMediaSession?: Maybe<ConfluenceLegacyContentMediaSession>;
    /**
     * GraphQL query to get content permissions by content id. Only Page/BlogPost/Whiteboard contents are supported.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentPermissions?: Maybe<ConfluenceLegacyContentPermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentRenderer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentRenderer?: Maybe<ConfluenceLegacyHtmlDocument>;
    /**
     * Fetches all smart-links on a page/blog and returns a paginated list of results
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentSmartLinks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentSmartLinks?: Maybe<ConfluenceLegacyPaginatedSmartLinkList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentTemplateLabelsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentTemplateLabelsByCriteria?: Maybe<ConfluenceLegacyPaginatedLabelList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_contentWatchers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_contentWatchers?: Maybe<ConfluenceLegacyPaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_countGroupByEventName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_countGroupByEventName?: Maybe<ConfluenceLegacyCountGroupByEventName>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_countGroupByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_countGroupByPage?: Maybe<ConfluenceLegacyCountGroupByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_countGroupBySpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_countGroupBySpace?: Maybe<ConfluenceLegacyCountGroupBySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_countGroupByUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_countGroupByUser?: Maybe<ConfluenceLegacyCountGroupByUser>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_cqlMetaData' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_cqlMetaData?: Maybe<ConfluenceLegacyCqlMetaData>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_dataSecurityPolicy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_dataSecurityPolicy?: Maybe<ConfluenceLegacyDataSecurityPolicy>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deactivatedOwnerPages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deactivatedOwnerPages?: Maybe<ConfluenceLegacyPaginatedPageList>;
    /**
     * The list of deactivated users who own pages in the space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_deactivatedPageOwnerUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_deactivatedPageOwnerUsers?: Maybe<ConfluenceLegacyPaginatedDeactivatedUserPageCountEntityList>;
    /**
     * GraphQL query to get default space permissions
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_defaultSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_defaultSpacePermissions?: Maybe<ConfluenceLegacySpacePermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_detailsLines' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_detailsLines?: Maybe<ConfluenceLegacyDetailsSummaryLines>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_editorConversionSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_editorConversionSettings?: Maybe<ConfluenceLegacyEditorConversionSetting>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_editorConversionSiteSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_editorConversionSiteSettings?: Maybe<ConfluenceLegacyEditorConversionSetting>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_entitlements' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_entitlements?: Maybe<ConfluenceLegacyEntitlements>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_entityCountBySpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_entityCountBySpace?: Maybe<ConfluenceLegacyEntityCountBySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_entityTimeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_entityTimeseriesCount?: Maybe<ConfluenceLegacyEntityTimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_experimentFeatures' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_experimentFeatures?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_externalCanvasToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_externalCanvasToken?: Maybe<ConfluenceLegacyCanvasToken>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_externalCollaboratorDefaultSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_externalCollaboratorDefaultSpace?: Maybe<ConfluenceLegacyExternalCollaboratorDefaultSpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_externalCollaboratorsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_externalCollaboratorsByCriteria?: Maybe<ConfluenceLegacyPaginatedUserList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_externalContentMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_externalContentMediaSession?: Maybe<ConfluenceLegacyContentMediaSession>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_favoriteContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_favoriteContent?: Maybe<ConfluenceLegacyPaginatedContentList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_featureDiscovery' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_featureDiscovery?: Maybe<
        Array<Maybe<ConfluenceLegacyDiscoveredFeature>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_feed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_feed?: Maybe<ConfluenceLegacyPaginatedFeed>;
    /**
     * Check if the specific content type is supported now by the latest mobile app in iOS/android app stores.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_futureContentTypeMobileSupport' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_futureContentTypeMobileSupport?: Maybe<ConfluenceLegacyFutureContentTypeMobileSupport>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getAIConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getAIConfig?: Maybe<ConfluenceLegacyAiConfigResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getCommentReplySuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getCommentReplySuggestions?: Maybe<ConfluenceLegacyCommentReplySuggestions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getCommentsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getCommentsSummary?: Maybe<ConfluenceLegacySmartFeaturesCommentsSummary>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getFeedUserConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getFeedUserConfig?: Maybe<ConfluenceLegacyFollowingFeedGetUserConfig>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getRecommendedFeedUserConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getRecommendedFeedUserConfig?: Maybe<ConfluenceLegacyRecommendedFeedUserConfig>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getRecommendedLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getRecommendedLabels?: Maybe<ConfluenceLegacyRecommendedLabels>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getRecommendedPages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getRecommendedPages?: Maybe<ConfluenceLegacyRecommendedPages>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getRecommendedPagesSpaceStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getRecommendedPagesSpaceStatus?: Maybe<ConfluenceLegacyRecommendedPagesSpaceStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getSmartContentFeature' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getSmartContentFeature?: Maybe<ConfluenceLegacySmartPageFeatures>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getSmartFeatures' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getSmartFeatures?: Maybe<ConfluenceLegacySmartFeaturesResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_getSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_getSummary?: Maybe<ConfluenceLegacySmartFeaturesContentSummary>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_globalContextContentCreationMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_globalContextContentCreationMetadata?: Maybe<ConfluenceLegacyContentCreationMetadata>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_globalDescription' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_globalDescription?: Maybe<ConfluenceLegacyGlobalDescription>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_globalOperations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_globalOperations?: Maybe<
        Array<Maybe<ConfluenceLegacyOperationCheckResult>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_globalSpaceConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_globalSpaceConfiguration?: Maybe<ConfluenceLegacyGlobalSpaceConfiguration>;
    /**
     * Fetches a group by group ID or name. Group ID will be used if both are present.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_group' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_group?: Maybe<ConfluenceLegacyGroup>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_groupCounts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_groupCounts?: Maybe<ConfluenceLegacyGroupCountsResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_groupMembers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_groupMembers?: Maybe<ConfluenceLegacyPaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_groups' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_groups?: Maybe<ConfluenceLegacyPaginatedGroupList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_groupsUserSpaceAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_groupsUserSpaceAccess?: Maybe<ConfluenceLegacyPaginatedGroupList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_groupsWithContentRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_groupsWithContentRestrictions?: Maybe<
        Array<Maybe<ConfluenceLegacyGroupWithRestrictions>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_hasUserAccessAdminRole' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_hasUserAccessAdminRole?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_hasUserCommented' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_hasUserCommented?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_homeUserSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_homeUserSettings?: Maybe<ConfluenceLegacyHomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_incomingLinksCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_incomingLinksCount?: Maybe<ConfluenceLegacyIncomingLinksCount>;
    /**
     * Fetch all Tasks matching a given set of Task metadata filters, such as : completion status, due date, assignee, creator, created date, etc.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_inlineTasks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_inlineTasks?: Maybe<ConfluenceLegacyInlineTasksQueryResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_instanceAnalyticsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_instanceAnalyticsCount?: Maybe<ConfluenceLegacyInstanceAnalyticsCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_internalFrontendResource' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_internalFrontendResource?: Maybe<ConfluenceLegacyFrontendResourceRenderResponse>;
    /**
     * GraphQL query to check if data classification feature is enabled for a tenant
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_isDataClassificationEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_isDataClassificationEnabled?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /**
     * Determines whether the current user's email domain is public
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_isMoveContentStatesSupported' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_isMoveContentStatesSupported?: Maybe<
        Scalars["Boolean"]["output"]
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_isNewUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_isNewUser?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_isSiteAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_isSiteAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_jiraProjects' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_jiraProjects?: Maybe<ConfluenceLegacyJiraProjectsResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_jiraServers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_jiraServers?: Maybe<ConfluenceLegacyJiraServersResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_labelSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_labelSearch?: Maybe<ConfluenceLegacyLabelSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_license' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_license?: Maybe<ConfluenceLegacyLicense>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_localStorage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_localStorage?: Maybe<ConfluenceLegacyLocalStorage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_lookAndFeel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_lookAndFeel?: Maybe<ConfluenceLegacyLookAndFeelSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_loomToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_loomToken?: Maybe<ConfluenceLegacyLoomToken>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_loomUserStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_loomUserStatus?: Maybe<ConfluenceLegacyLoomUserStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_macroBodyRenderer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_macroBodyRenderer?: Maybe<ConfluenceLegacyMacroBody>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_mutationsPlaceholder' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_mutationsPlaceholder?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_myVisitedPages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_myVisitedPages?: Maybe<ConfluenceLegacyMyVisitedPages>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_myVisitedSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_myVisitedSpaces?: Maybe<ConfluenceLegacyMyVisitedSpaces>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_onboardingState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_onboardingState?: Maybe<
        Array<ConfluenceLegacyOnboardingState>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_organizationContext' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_organizationContext?: Maybe<ConfluenceLegacyOrganizationContext>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_page?: Maybe<ConfluenceLegacyPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_pageActivity' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_pageActivity?: Maybe<ConfluenceLegacyPaginatedPageActivity>;
    /**
     * Returns the count of the all the events, filtered by eventName, grouped by uniqueBy for page
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_pageAnalyticsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_pageAnalyticsCount?: Maybe<ConfluenceLegacyPageAnalyticsCount>;
    /**
     * Returns the count of the all the events, filtered by eventName, grouped by granularity and uniqueBy for page
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_pageAnalyticsTimeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_pageAnalyticsTimeseriesCount?: Maybe<ConfluenceLegacyPageAnalyticsTimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_pageContextContentCreationMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_pageContextContentCreationMetadata?: Maybe<ConfluenceLegacyContentCreationMetadata>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_pages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_pages?: Maybe<ConfluenceLegacyPaginatedPageList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_paywallContentToDisable' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_paywallContentToDisable?: Maybe<ConfluenceLegacyPaywallContentSingle>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_paywallStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_paywallStatus?: Maybe<ConfluenceLegacyPaywallStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_popularFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_popularFeed?: Maybe<ConfluenceLegacyPaginatedPopularFeed>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_ptpage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_ptpage?: Maybe<ConfluenceLegacyPtPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkOnboardingReference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkOnboardingReference?: Maybe<ConfluenceLegacyPublicLinkOnboardingReference>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkPage?: Maybe<ConfluenceLegacyPublicLinkPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkPagesByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated use publicLinksByCriteria
     */
    confluenceLegacy_publicLinkPagesByCriteria?: Maybe<ConfluenceLegacyPublicLinkPageConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkPermissionsForObject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkPermissionsForObject?: Maybe<ConfluenceLegacyPublicLinkPermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkSiteStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkSiteStatus?: Maybe<ConfluenceLegacyPublicLinkSitePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkSpace?: Maybe<ConfluenceLegacyPublicLinkSpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinkSpacesByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinkSpacesByCriteria?: Maybe<ConfluenceLegacyPublicLinkSpaceConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publicLinksByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publicLinksByCriteria?: Maybe<ConfluenceLegacyPublicLinkConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_publishConditions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_publishConditions?: Maybe<
        Array<Maybe<ConfluenceLegacyPublishConditions>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_pushNotificationSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_pushNotificationSettings?: Maybe<ConfluenceLegacyPushNotificationSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_quickReload' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_quickReload?: Maybe<ConfluenceLegacyQuickReload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_reactedUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_reactedUsers?: Maybe<ConfluenceLegacyReactedUsersResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_reactionsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_reactionsSummary?: Maybe<ConfluenceLegacyReactionsSummaryResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_reactionsSummaryList' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_reactionsSummaryList?: Maybe<
        Array<Maybe<ConfluenceLegacyReactionsSummaryResponse>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_recentlyViewedSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated recentlyViewedSpaces will no longer be supported after June 30 2023, consider using GraphQL myVisitedSpaces
     */
    confluenceLegacy_recentlyViewedSpaces?: Maybe<
        Array<Maybe<ConfluenceLegacySpace>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_renderedContentDump' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_renderedContentDump?: Maybe<ConfluenceLegacyHtmlDocument>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_search' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_search?: Maybe<ConfluenceLegacyPaginatedSearchResultList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_searchTimeseriesCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_searchTimeseriesCTR?: Maybe<ConfluenceLegacySearchTimeseriesCtr>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_searchTimeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_searchTimeseriesCount?: Maybe<ConfluenceLegacySearchTimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_searchUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_searchUser?: Maybe<ConfluenceLegacyPaginatedSearchResultList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_searchesByTerm' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_searchesByTerm?: Maybe<ConfluenceLegacySearchesByTerm>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_searchesWithZeroCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_searchesWithZeroCTR?: Maybe<ConfluenceLegacySearchesWithZeroCtr>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_signUpProperties' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_signUpProperties?: Maybe<ConfluenceLegacySignUpProperties>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_singleContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_singleContent?: Maybe<ConfluenceLegacyContent>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_siteConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_siteConfiguration?: Maybe<ConfluenceLegacySiteConfiguration>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_sitePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_sitePermissions?: Maybe<ConfluenceLegacySitePermission>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_snippets' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_snippets?: Maybe<ConfluenceLegacyPaginatedSnippetList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaViewContext' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaViewContext?: Maybe<ConfluenceLegacySpaViewModel>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaViewModel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use spaViewContext query
     */
    confluenceLegacy_spaViewModel?: Maybe<ConfluenceLegacySpaViewModel>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_space' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_space?: Maybe<ConfluenceLegacySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaceContextContentCreationMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaceContextContentCreationMetadata?: Maybe<ConfluenceLegacyContentCreationMetadata>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaceHomepage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaceHomepage?: Maybe<ConfluenceLegacyContent>;
    /**
     * GraphQL query to get space permissions by space key
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spacePermissions?: Maybe<ConfluenceLegacySpacePermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spacePermissionsAll' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spacePermissionsAll?: Maybe<ConfluenceLegacySpacePermissionConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spacePopularFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spacePopularFeed?: Maybe<ConfluenceLegacyPaginatedPopularSpaceFeed>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaceRoleAssignmentsByPrincipal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaceRoleAssignmentsByPrincipal?: Maybe<ConfluenceLegacySpaceRoleAssignmentConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaceSidebarLinks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaceSidebarLinks?: Maybe<ConfluenceLegacySpaceSidebarLinks>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaceTheme' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaceTheme?: Maybe<ConfluenceLegacyTheme>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaceWatchers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaceWatchers?: Maybe<ConfluenceLegacyPaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spaces?: Maybe<ConfluenceLegacyPaginatedSpaceList>;
    /**
     * Fetches spaces regardless of space admin status and returns limited info. Must be site/Confluence admin to use.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_spacesWithExemptions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_spacesWithExemptions?: Maybe<
        Array<Maybe<ConfluenceLegacySpaceWithExemption>>
    >;
    /**
     * Calls the cc-analytics stale pages API. lastActivityEarlierThan expects an ISO 8061 date string. Ex: 2023-12-08T20:55:25.000Z
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_stalePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_stalePages?: Maybe<ConfluenceLegacyPaginatedStalePagePayloadList>;
    /**
     * Fetches storage data for a tenant
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_storage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_storage?: Maybe<ConfluenceLegacyStorage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_suggestedSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_suggestedSpaces?: Maybe<ConfluenceLegacyPaginatedSpaceList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_teamCalendarSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_teamCalendarSettings?: Maybe<ConfluenceLegacyTeamCalendarSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_teamLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_teamLabels?: Maybe<ConfluenceLegacyPaginatedLabelList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_template' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_template?: Maybe<ConfluenceLegacyContentTemplate>;
    /**
     * Provides blueprint/template content body in ADF (atlas_doc_format) or HTML (view) format depending on Fabric editor compatibility.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templateBodies' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templateBodies?: Maybe<ConfluenceLegacyPaginatedTemplateBodyList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templateCategories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templateCategories?: Maybe<ConfluenceLegacyPaginatedTemplateCategoryList>;
    /**
     * Returns a single template for a specified id (includes both space level and global templates). The id for the requested template can be a UUID, Content Complete Module Key, or a Template Id.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templateInfo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templateInfo?: Maybe<ConfluenceLegacyTemplateInfo>;
    /**
     * Provide Media API tokens for uploading and downloading template files/images.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templateMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templateMediaSession?: Maybe<ConfluenceLegacyTemplateMediaSession>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_templates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_templates?: Maybe<ConfluenceLegacyPaginatedContentTemplateList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_tenant' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_tenant?: Maybe<ConfluenceLegacyTenant>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_tenantContext' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_tenantContext?: Maybe<ConfluenceLegacyTenantContext>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_timeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_timeseriesCount?: Maybe<ConfluenceLegacyTimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_timeseriesPageBlogCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_timeseriesPageBlogCount?: Maybe<ConfluenceLegacyTimeseriesPageBlogCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_topRelevantUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_topRelevantUsers?: Maybe<ConfluenceLegacyTopRelevantUsers>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_totalSearchCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_totalSearchCTR?: Maybe<ConfluenceLegacyTotalSearchCtr>;
    /**
     * Get trace timing data for this request
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_traceTiming' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_traceTiming?: Maybe<ConfluenceLegacyTraceTiming>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_userGroupSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_userGroupSearch?: Maybe<ConfluenceLegacyUserAndGroupSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_userPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_userPreferences?: Maybe<ConfluenceLegacyUserPreferences>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_userWithContentRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_userWithContentRestrictions?: Maybe<ConfluenceLegacyUserWithRestrictions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_usersWithContentRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_usersWithContentRestrictions?: Maybe<
        Array<Maybe<ConfluenceLegacyUserWithRestrictions>>
    >;
    /**
     * Validate a page can be converted to a live page
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_validateConvertPageToLiveEdit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_validateConvertPageToLiveEdit?: Maybe<ConfluenceLegacyConvertPageToLiveEditValidationResult>;
    /**
     * Validate a page can be copied. Currently, we only check validity related to copying of page restrictions.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_validatePageCopy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_validatePageCopy?: Maybe<ConfluenceLegacyValidatePageCopyPayload>;
    /**
     * Validate a page can be published. Currently, we only check the page's title.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_validatePagePublish' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_validatePagePublish?: Maybe<ConfluenceLegacyPageValidationResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_validateSpaceKey' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_validateSpaceKey?: Maybe<ConfluenceLegacyValidateSpaceKeyResponse>;
    /**
     * Validate a title before creating content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_validateTitleForCreate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_validateTitleForCreate?: Maybe<ConfluenceLegacyValidateTitleForCreatePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_webItemSections' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_webItemSections?: Maybe<
        Array<Maybe<ConfluenceLegacyWebSection>>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_webItems' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_webItems?: Maybe<Array<Maybe<ConfluenceLegacyWebItem>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ConfluenceLegacyRN")' query directive to the 'confluenceLegacy_webPanels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Confluence prefixed APIs are a prototype that will be removed soon
     */
    confluenceLegacy_webPanels?: Maybe<Array<Maybe<ConfluenceLegacyWebPanel>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluenceUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluenceUsers?: Maybe<PaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_atlassianUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_atlassianUser?: Maybe<AtlassianUser>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_calendarPreference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_calendarPreference?: Maybe<ConfluenceCalendarPreference>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_calendarTimezones' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_calendarTimezones?: Maybe<ConfluenceCalendarTimezones>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    confluence_empty?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_externalCollaboratorsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_externalCollaboratorsByCriteria?: Maybe<ConfluencePersonConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Placeholder API only. Do not use.")' query directive to the 'confluence_mutationsPlaceholderQuery' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated This is not a real API but it must exist to satisfy validation rules.
     */
    confluence_mutationsPlaceholderQuery?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_refreshMigrationMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_refreshMigrationMediaSession?: Maybe<ContentMediaSession>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_search' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_search?: Maybe<ConfluenceSearchConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_searchTeamLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_searchTeamLabels?: Maybe<LabelSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_searchUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_searchUser?: Maybe<ConfluenceSearchConnection>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    confluence_storage?: Maybe<ConfluenceStorage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_subCalendarSubscribersCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_subCalendarSubscribersCount?: Maybe<ConfluenceSubCalendarSubscribersCount>;
    /**
     * Get the confluence team presence settings
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_teamPresence' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_teamPresence?: Maybe<ConfluenceTeamPresence>;
    /**
     * Get the confluence team presence settings for a space
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_teamPresenceSpaceSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_teamPresenceSpaceSettings?: Maybe<ConfluenceTeamPresenceSpaceSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_template' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_template?: Maybe<ContentTemplate>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    confluence_tenantContext?: Maybe<ConfluenceTenantContext>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_userContentAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_userContentAccess?: Maybe<ConfluenceUserContentAccessResult>;
    /**
     * Validate if jql for application link is valid
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'confluence_validateCalendarJql' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    confluence_validateCalendarJql?: Maybe<ConfluenceCalendarJqlValidationResult>;
    /**
     * Retrieve all connections for this Jira Project
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    connectionManager_connectionsByJiraProject?: Maybe<ConnectionManagerConnectionsByJiraProjectResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contactAdminPageConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contactAdminPageConfig?: Maybe<ContactAdminPageConfig>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    content?: Maybe<PaginatedContentListWithChild>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsLastViewedAtByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsLastViewedAtByPage?: Maybe<ContentAnalyticsLastViewedAtByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsTotalViewsByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsTotalViewsByPage?: Maybe<ContentAnalyticsTotalViewsByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsUnreadComments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsUnreadComments?: Maybe<ContentAnalyticsUnreadComments>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViewedComments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViewedComments?: Maybe<ViewedComments>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViewers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViewers?: Maybe<ContentAnalyticsViewers>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViews' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViews?: Maybe<ContentAnalyticsViews>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentAnalyticsViewsByDate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentAnalyticsViewsByDate?: Maybe<ContentAnalyticsViewsByDate>;
    /**
     * Fetches content body for a page/blog
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentBody' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentBody?: Maybe<ContentBodyPerRepresentation>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentByState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentByState?: Maybe<PaginatedContentList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentContributors' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentContributors?: Maybe<ContentContributors>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentConverter' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentConverter?: Maybe<ConfluenceBody>;
    contentFacet: ContentPlatformContentFacetConnection;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentHistory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentHistory?: Maybe<PaginatedContentHistoryList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentIdByReferenceId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentIdByReferenceId?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentLabelSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentLabelSearch?: Maybe<LabelSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentMediaSession?: Maybe<ContentMediaSession>;
    /**
     * GraphQL query to get content permissions by content id. Only Page/BlogPost/Whiteboard contents are supported.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentPermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentPermissions?: Maybe<ContentPermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentReactionsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentReactionsSummary?: Maybe<ReactionsSummaryResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentRenderer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentRenderer?: Maybe<HtmlDocument>;
    /**
     * Fetches all smart-links on a page/blog and returns a paginated list of results
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentSmartLinks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentSmartLinks?: Maybe<PaginatedSmartLinkList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentTemplateLabelsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentTemplateLabelsByCriteria?: Maybe<PaginatedLabelList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentVersionHistory' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentVersionHistory?: Maybe<ContentVersionHistoryConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'contentWatchers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    contentWatchers?: Maybe<PaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'countGroupByEventName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    countGroupByEventName?: Maybe<CountGroupByEventName>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'countGroupByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    countGroupByPage?: Maybe<CountGroupByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'countGroupBySpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    countGroupBySpace?: Maybe<CountGroupBySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'countGroupByUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    countGroupByUser?: Maybe<CountGroupByUser>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'countUsersGroupByPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    countUsersGroupByPage?: Maybe<CountUsersGroupByPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'cqlMetaData' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    cqlMetaData?: Maybe<Confluence_CqlMetaData>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'currentConfluenceUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    currentConfluenceUser?: Maybe<CurrentConfluenceUser>;
    /** Customer Service Query API namespaced to customerService */
    customerService?: Maybe<CustomerServiceQueryApi>;
    customerStories: ContentPlatformCustomerStorySearchConnection;
    customerStory?: Maybe<ContentPlatformCustomerStory>;
    /** This API is a wrapper for all CSP support Request queries */
    customerSupport?: Maybe<SupportRequestCatalogQueryApi>;
    dataScope?: Maybe<MigrationPlanningServiceQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'dataSecurityPolicy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    dataSecurityPolicy?: Maybe<Confluence_DataSecurityPolicy>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deactivatedOwnerPages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deactivatedOwnerPages?: Maybe<PaginatedPageList>;
    /**
     * The list of deactivated users who own pages in the space.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'deactivatedPageOwnerUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    deactivatedPageOwnerUsers?: Maybe<PaginatedDeactivatedUserPageCountEntityList>;
    /**
     * GraphQL query to get default space permissions
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'defaultSpacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    defaultSpacePermissions?: Maybe<SpacePermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'defaultSpaceRoleAssignmentsAll' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    defaultSpaceRoleAssignmentsAll?: Maybe<DefaultSpaceRoleAssignmentsConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'detailsLines' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    detailsLines?: Maybe<DetailsSummaryLines>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAi")' query directive to the 'devAi' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Unused legacy field
     */
    devAi?: Maybe<DevAi>;
    /** Namespace for fields relating to DevOps data */
    devOps?: Maybe<DevOps>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsMetrics?: Maybe<DevOpsMetrics>;
    /** The DevOps Service with the specified ARI */
    devOpsService?: Maybe<DevOpsService>;
    /**
     * Return the relationship between DevOps Service and Jira Project
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsServiceAndJiraProjectRelationship?: Maybe<DevOpsServiceAndJiraProjectRelationship>;
    /**
     * Returns the relationship between DevOps Service and Opsgenie team with the specified id (graph service_and_opsgenie_team ARI)
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsServiceAndOpsgenieTeamRelationship?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
    /**
     * Returns the relationship between DevOps Service and Repository
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsServiceAndRepositoryRelationship?: Maybe<DevOpsServiceAndRepositoryRelationship>;
    /** The DevOps Service Relationship with the specified ARI */
    devOpsServiceRelationship?: Maybe<DevOpsServiceRelationship>;
    /**
     * Return the connection entity for DevOps Service relationships for the specified Jira project, according to the specified
     * pagination, filtering and sorting.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsServiceRelationshipsForJiraProject?: Maybe<DevOpsServiceAndJiraProjectRelationshipConnection>;
    /**
     * Returns the service relationships linked to the Opsgenie team with the specified id (Opsgenie team ARI).
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsServiceRelationshipsForOpsgenieTeam?: Maybe<DevOpsServiceAndOpsgenieTeamRelationshipConnection>;
    /**
     * Returns the service relationships linked to the repository with the specified id.
     * The ID is either a Bitbucket repository ARI, or the ID of a third-party repository.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsServiceRelationshipsForRepository?: Maybe<DevOpsServiceAndRepositoryRelationshipConnection>;
    /** Retrieve the list of DevOps Service Tiers for the specified site */
    devOpsServiceTiers?: Maybe<Array<DevOpsServiceTier>>;
    /** Retrieve the list of DevOps Service Types */
    devOpsServiceTypes?: Maybe<Array<DevOpsServiceType>>;
    /** Retrieve all services for the site specified by cloudId. */
    devOpsServices?: Maybe<DevOpsServiceConnection>;
    /**
     * Retrieve DevOps Services for the specified ids, the ids can belong to different sites.
     * Services not found are simply not returned.
     * The maximum lookup limit is 100.
     */
    devOpsServicesById?: Maybe<Array<DevOpsService>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOpsTools?: Maybe<DevOpsTools>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'devai_autodevAgentForJob' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevAgentForJob?: Maybe<DevAiRovoAgent>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiIssueScopingResult")' query directive to the 'devai_autodevIssueScoping' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevIssueScoping?: Maybe<DevAiIssueScopingResult>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'devai_autodevIssueScopingScoreForJob' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevIssueScopingScoreForJob?: Maybe<DevAiIssueScopingResult>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLoadFile")' query directive to the 'devai_autodevJobFileContents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevJobFileContents?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogGroups")' query directive to the 'devai_autodevJobLogGroups' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use the 'logs' field instead
     */
    devai_autodevJobLogGroups?: Maybe<DevAiAutodevLogGroupConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogs")' query directive to the 'devai_autodevJobLogs' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevJobLogs?: Maybe<DevAiAutodevLogConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiAutodevJobs")' query directive to the 'devai_autodevJobsForIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevJobsForIssue?: Maybe<JiraAutodevJobConnection>;
    /**
     * List Rovo agents that can execute Autodev.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiVerticalAutodev")' query directive to the 'devai_autodevRovoAgents' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_autodevRovoAgents?: Maybe<DevAiRovoAgentConnection>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiUsers")' query directive to the 'devai_rovoDevAgentsUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_rovoDevAgentsUser?: Maybe<DevAiUser>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiTechnicalPlanner")' query directive to the 'devai_technicalPlannerJobById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_technicalPlannerJobById?: Maybe<DevAiTechnicalPlannerJob>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiTechnicalPlanner")' query directive to the 'devai_technicalPlannerJobsForIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_technicalPlannerJobsForIssue?: Maybe<DevAiTechnicalPlannerJobConnection>;
    /**
     * Check if developer has access to logs
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    developerLogAccess?: Maybe<Array<Maybe<DeveloperLogAccessResult>>>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: IssueDevelopmentInformation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    developmentInformation?: Maybe<IssueDevOpsDevelopmentInformation>;
    /**
     * This field will dump diagnostics information about currently executing graphql request.
     *
     * It is inspired in part by [https://httpbin.org/anything](https://httpbin.org/anything/)
     */
    diagnostics?: Maybe<Scalars["JSON"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'discoverFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    discoverFeed?: Maybe<PaginatedFeed>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    dvcs?: Maybe<DvcsQuery>;
    /** This field will echo back the word `echo`.  Its only useful for testing */
    echo?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    ecosystem?: Maybe<EcosystemQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'editorConversionSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    editorConversionSettings?: Maybe<EditorConversionSetting>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'editorConversionSiteSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    editorConversionSiteSettings?: Maybe<EditorConversionSetting>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'entitlements' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    entitlements?: Maybe<Entitlements>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'entityCountBySpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    entityCountBySpace?: Maybe<EntityCountBySpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'entityTimeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    entityTimeseriesCount?: Maybe<EntityTimeseriesCount>;
    /** ERS lifecycle operations */
    ersLifecycle?: Maybe<ErsLifecycleQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'eventCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    eventCTR?: Maybe<EventCtr>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'eventTimeseriesCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    eventTimeseriesCTR?: Maybe<EventTimeseriesCtr>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'experimentFeatures' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    experimentFeatures?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    extensionByKey?: Maybe<Extension>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     *
     *
     */
    extensionContext?: Maybe<ExtensionContext>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     *
     *
     */
    extensionContexts?: Maybe<Array<ExtensionContext>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    extensionsEcho?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'externalCanvasToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    externalCanvasToken?: Maybe<CanvasToken>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'externalCollaboratorDefaultSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    externalCollaboratorDefaultSpace?: Maybe<ExternalCollaboratorDefaultSpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'externalContentMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    externalContentMediaSession?: Maybe<ContentMediaSession>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'external_entities' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    external_entities?: Maybe<ExternalEntities>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ExternalDataDepotQueryV2")' query directive to the 'external_entitiesV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    external_entitiesV2?: Maybe<ExternalEntities>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'favoriteContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    favoriteContent?: Maybe<PaginatedContentList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'featureDiscovery' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    featureDiscovery?: Maybe<Array<Maybe<DiscoveredFeature>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'feed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    feed?: Maybe<PaginatedFeed>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'forYouFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    forYouFeed?: Maybe<ForYouPaginatedFeed>;
    fullHubArticle?: Maybe<ContentPlatformFullHubArticle>;
    fullHubArticles: ContentPlatformHubArticleSearchConnection;
    fullTutorial?: Maybe<ContentPlatformFullTutorial>;
    fullTutorials: ContentPlatformTutorialSearchConnection;
    /**
     * Check if the specific content type is supported now by the latest mobile app in iOS/android app stores.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'futureContentTypeMobileSupport' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    futureContentTypeMobileSupport?: Maybe<FutureContentTypeMobileSupport>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getAIConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getAIConfig?: Maybe<AiConfigResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getCommentReplySuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getCommentReplySuggestions?: Maybe<CommentReplySuggestions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getCommentsSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getCommentsSummary?: Maybe<SmartFeaturesCommentsSummary>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getFeedUserConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getFeedUserConfig?: Maybe<FollowingFeedGetUserConfig>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getGlobalDescription' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getGlobalDescription?: Maybe<GraphQlGlobalDescription>;
    /**
     * This query is for the Reading Aids experience.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    getKeywords?: Maybe<Array<Scalars["String"]["output"]>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getRecommendedFeedUserConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getRecommendedFeedUserConfig?: Maybe<RecommendedFeedUserConfig>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getRecommendedLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getRecommendedLabels?: Maybe<RecommendedLabels>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getRecommendedPages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getRecommendedPages?: Maybe<RecommendedPages>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getRecommendedPagesSpaceStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getRecommendedPagesSpaceStatus?: Maybe<RecommendedPagesSpaceStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getSmartContentFeature' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getSmartContentFeature?: Maybe<SmartPageFeatures>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getSmartFeatures' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getSmartFeatures?: Maybe<SmartFeaturesResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'getSummary' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    getSummary?: Maybe<SmartFeaturesContentSummary>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'globalContextContentCreationMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    globalContextContentCreationMetadata?: Maybe<ContentCreationMetadata>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'globalSpaceConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    globalSpaceConfiguration?: Maybe<GlobalSpaceConfiguration>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "GraphStore")' query directive to the 'graphStore' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    graphStore?: Maybe<GraphStore>;
    /**
     * Fetches a group by group ID or name. Group ID will be used if both are present.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'group' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    group?: Maybe<Group>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'groupCounts' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    groupCounts?: Maybe<GraphQlGroupCountsResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'groupMembers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    groupMembers?: Maybe<PaginatedPersonList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'groups' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    groups?: Maybe<PaginatedGroupList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'groupsUserSpaceAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    groupsUserSpaceAccess?: Maybe<PaginatedGroupList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'groupsWithContentRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    groupsWithContentRestrictions?: Maybe<Array<Maybe<GroupWithRestrictions>>>;
    /**
     * Retrieve recommendations of entities (i.e. Products, Templates and Messages etc.).
     * OAuth scope READ_ME required for the current logged-in user. Anonymous users can still access the API without OAuth scopes.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:me__
     *
     *
     */
    growthRecommendations?: Maybe<GrowthRecQuery>;
    growthUnifiedProfile_getUnifiedProfile?: Maybe<GrowthUnifiedProfileResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'hasUserAccessAdminRole' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    hasUserAccessAdminRole?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'hasUserCommented' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    hasUserCommented?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpCenter?: Maybe<HelpCenterQueryApi>;
    helpExternalResource?: Maybe<HelpExternalResourceQueryApi>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "HelpLayoutExperimentalSchema")' query directive to the 'helpLayout' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    helpLayout?: Maybe<HelpLayoutQueryApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpObjectStore?: Maybe<HelpObjectStoreQueryApi>;
    /**
     *  To search for Knowledge Base articles including External resources. Should not be used for paginating through articles.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpObjectStore_searchArticles?: Maybe<HelpObjectStoreArticleSearchResponse>;
    /**
     *  To search for Portals including External resources.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpObjectStore_searchPortals?: Maybe<HelpObjectStorePortalSearchResponse>;
    /**
     *  To search for Request types including External resources.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    helpObjectStore_searchRequestTypes?: Maybe<HelpObjectStoreRequestTypeSearchResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'homeUserSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    homeUserSettings?: Maybe<HomeUserSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'incomingLinksCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    incomingLinksCount?: Maybe<IncomingLinksCount>;
    /**
     * Fetch all Tasks matching a given set of Task metadata filters, such as: completion status, due date, assignee, creator, created date, etc.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'inlineTasks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    inlineTasks?: Maybe<InlineTasksQueryResult>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Insights")' query directive to the 'insights' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    insights?: Maybe<Insights>;
    /**
     * Return all the installation contexts
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    installationContexts?: Maybe<Array<InstallationContext>>;
    /**
     * Return a list of installation contexts with forge logs access
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    installationContextsWithLogAccess?: Maybe<
        Array<InstallationContextWithLogAccess>
    >;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'instanceAnalyticsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    instanceAnalyticsCount?: Maybe<InstanceAnalyticsCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'internalFrontendResource' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    internalFrontendResource?: Maybe<FrontendResourceRenderResponse>;
    ipmFlag?: Maybe<ContentPlatformIpmFlag>;
    ipmFlags: ContentPlatformIpmFlagSearchConnection;
    ipmImageModal?: Maybe<ContentPlatformIpmImageModal>;
    ipmImageModals: ContentPlatformIpmImageModalSearchConnection;
    ipmInlineDialog?: Maybe<ContentPlatformIpmInlineDialog>;
    ipmInlineDialogs: ContentPlatformIpmInlineDialogSearchConnection;
    ipmMultiStep?: Maybe<ContentPlatformIpmMultiStep>;
    ipmMultiSteps: ContentPlatformIpmMultiStepSearchConnection;
    /**
     * GraphQL query to check if data classification feature is enabled for a tenant
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'isDataClassificationEnabled' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    isDataClassificationEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'isMoveContentStatesSupported' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    isMoveContentStatesSupported?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'isNewUser' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use userPreferences.onboarded
     */
    isNewUser?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * This query is for Confluence Search's Q&A Search (Generative AI) experience.
     * It is expected to live alongside the standard search query.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    isSainSearchEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'isSiteAdmin' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    isSiteAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * this field is added to enable self governed onboarding of Jira GraphQL types to AGG
     * see https://hello.atlassian.net/wiki/spaces/PSRV/pages/1010287708/Announcing+self+governed+APIs for more details
     */
    jira?: Maybe<JiraQuery>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jiraAlignAgg_projectsByAris?: Maybe<Array<Maybe<JiraAlignAggProject>>>;
    /** Namespace for the canned response query APIs */
    jiraCannedResponse?: Maybe<JiraCannedResponseQueryApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jiraOAuthApps?: Maybe<JiraOAuthAppsApps>;
    /**
     * Return the connection entity for Jira Project relationships for the specified DevOps Service, according to the specified
     * pagination, filtering and sorting.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jiraProjectRelationshipsForService?: Maybe<DevOpsServiceAndJiraProjectRelationshipConnection>;
    /**
     * Namespace for fields relating to issue releases in Jira.
     *
     * A "release" in this context can refer to a code deployment or a feature flag change.
     *
     * This field is currently in BETA.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jiraReleases?: Maybe<JiraReleases>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'jiraServers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    jiraServers?: Maybe<JiraServersResult>;
    /**
     * Returns the data for a Jira board view.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_boardView?: Maybe<JiraBoardView>;
    /**
     * Retrieves issueSearchViewResult list from 'ari:cloud:jira:{siteId}:issue-search-view/activation/{activationId}/{namespaceId}/{viewId}' ARI list provided.
     * The ARI contains cloudId, namespace and viewId
     * This query will error if the ids parameter is not in ARI format, does not pass validation or does not correspond to a JiraIssueSearchView.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_issueSearchViewsByIds?: Maybe<Array<Maybe<JiraIssueSearchView>>>;
    /**
     * Retrieves a `JiraProject` given either its project ID (Long) or key.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira_projectByIdOrKey?: Maybe<JiraProject>;
    /**
     * Fetches the sidebar menu settings for the current user.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "JiraSidebarMenu")' query directive to the 'jira_projectsSidebarMenu' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    jira_projectsSidebarMenu?: Maybe<JiraProjectsSidebarMenu>;
    /**
     * this field is added to enable self governed onboarding of Jira GraphQL types to AGG
     * see https://hello.atlassian.net/wiki/spaces/PSRV/pages/1010287708/Announcing+self+governed+APIs for more details
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jsmChat?: Maybe<JsmChatQuery>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jsw?: Maybe<JswQuery>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    knowledgeBase?: Maybe<KnowledgeBaseQueryApi>;
    /**
     *  Fetch permissions for multiple spaces
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    knowledgeBaseSpacePermission_bulkQuery: Array<
        Maybe<KnowledgeBaseSpacePermissionQueryResponse>
    >;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    knowledgeBase_searchArticles?: Maybe<KnowledgeBaseArticleSearchResponse>;
    knowledgeDiscovery?: Maybe<KnowledgeDiscoveryQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'labelSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    labelSearch?: Maybe<LabelSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'license' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    license?: Maybe<License>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'localStorage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    localStorage?: Maybe<LocalStorage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'lookAndFeel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    lookAndFeel?: Maybe<LookAndFeelSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'loomToken' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    loomToken?: Maybe<LoomToken>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'loomUserStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    loomUserStatus?: Maybe<LoomUserStatus>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_comment?: Maybe<LoomComment>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_comments?: Maybe<Array<Maybe<LoomComment>>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_meeting?: Maybe<LoomMeeting>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_meetingRecurrence?: Maybe<LoomMeetingRecurrence>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_meetingRecurrences?: Maybe<Array<Maybe<LoomMeetingRecurrence>>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_meetings?: Maybe<Array<Maybe<LoomMeeting>>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_settings?: Maybe<LoomSettings>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_space?: Maybe<LoomSpace>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_spaces?: Maybe<Array<Maybe<LoomSpace>>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_spacesSearch: Array<Maybe<LoomSpace>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_video?: Maybe<LoomVideo>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    loom_videos?: Maybe<Array<Maybe<LoomVideo>>>;
    lpLearnerData?: Maybe<LpLearnerData>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'macroBodyRenderer' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    macroBodyRenderer?: Maybe<MacroBody>;
    /**
     * Get MarketplaceApp by appId.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    marketplaceApp?: Maybe<MarketplaceApp>;
    /**
     * Get MarketplaceApp by cloud app's Id.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    marketplaceAppByCloudAppId?: Maybe<MarketplaceApp>;
    /**
     * Get MarketplaceApp by appKey
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    marketplaceAppByKey?: Maybe<MarketplaceApp>;
    /**
     * Get App Privacy and Security data by appKey and state
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    marketplaceAppTrustInformation?: Maybe<MarketplaceAppTrustInformationResult>;
    marketplaceConsole: MarketplaceConsoleQueryApi;
    /**
     * Get MarketplacePartner by id.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    marketplacePartner?: Maybe<MarketplacePartner>;
    /**
     * Get Pricing Plan for a marketplace entity
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    marketplacePricingPlan?: Maybe<MarketplacePricingPlan>;
    marketplaceStore: MarketplaceStoreQueryApi;
    /**
     * This returns information about the currently logged in user.  If there is no logged in user
     * then there really wont be much information to show.
     */
    me: AuthenticationContext;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    mercury?: Maybe<MercuryQueryApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    mercury_providerOrchestration?: Maybe<MercuryProviderOrchestrationQueryApi>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    mercury_strategicEvents?: Maybe<MercuryStrategicEventsQueryApi>;
    /** Queries under namespace `migration`. */
    migration: MigrationQuery;
    /** Queries under namespace `migrationCatalogue`. */
    migrationCatalogue: MigrationCatalogueQuery;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'migrationMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    migrationMediaSession?: Maybe<ContentMediaSession>;
    /**
     * Get a list of MarketplaceApp from partners associated with the current user.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use Marketplace domain services' REST APIs instead
     */
    myMarketplaceApps?: Maybe<MarketplaceAppConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'myVisitedPages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    myVisitedPages?: Maybe<MyVisitedPages>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    myVisitedSpaces?: Maybe<MyVisitedSpaces>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Nlp Search")' query directive to the 'nlpSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    nlpSearch?: Maybe<NlpSearchResponse>;
    /** Lookup an Atlassian entity by a global id - the value of `id` has to be an Atlassan Resource Identifier (ARI). */
    node?: Maybe<Node>;
    /**
     * Query object for Notification Experience
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     * * __jira:atlassian-external__
     * * __read:jira-work__
     * * __read:blogpost:confluence__
     * * __read:comment:confluence__
     * * __read:page:confluence__
     * * __read:space:confluence__
     *
     *
     */
    notifications?: Maybe<InfluentsNotificationQuery>;
    oauthClients?: Maybe<OAuthClientsQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'onboardingState' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use userPreferences.onboardingState(key: $key)
     */
    onboardingState?: Maybe<Array<OnboardingState>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    opsgenie?: Maybe<OpsgenieQuery>;
    /**
     * Returns the Opsgenie Team relationship linked to the DevOps Service with the specified id (service ARI).
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    opsgenieTeamRelationshipForDevOpsService?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
    /**
     * GraphQL query to get default classification level id for organization
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'orgDefaultClassificationLevelId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    orgDefaultClassificationLevelId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'organizationContext' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    organizationContext?: Maybe<OrganizationContext>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    page?: Maybe<Page>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'pageActivity' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    pageActivity?: Maybe<PaginatedPageActivity>;
    /**
     * Returns the count of the all the events, filtered by eventName, grouped by uniqueBy for page
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'pageAnalyticsCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    pageAnalyticsCount?: Maybe<PageAnalyticsCount>;
    /**
     * Returns the count of the all the events, filtered by eventName, grouped by granularity and uniqueBy for page
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'pageAnalyticsTimeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    pageAnalyticsTimeseriesCount?: Maybe<PageAnalyticsTimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'pageContextContentCreationMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    pageContextContentCreationMetadata?: Maybe<ContentCreationMetadata>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'pages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    pages?: Maybe<PaginatedPageList>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __api_access__
     *
     *
     */
    partner?: Maybe<Partner>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PEAP")' query directive to the 'partnerEarlyAccess' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    partnerEarlyAccess?: Maybe<PeapQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'paywallContentToDisable' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    paywallContentToDisable?: Maybe<PaywallContentSingle>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'paywallStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    paywallStatus?: Maybe<PaywallStatus>;
    /**
     * Given principalId, resourceId and permissionId, this will return whether the principal has the permission on the resource.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated This is used only for backward compatibility
     */
    permitted?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Fetch a download link for the admin's perms report using the taskId
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'permsReportDownloadLinkForTask' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    permsReportDownloadLinkForTask?: Maybe<PermsReportDownloadLink>;
    /**
     * This will be used to fetch playbook by playbook Ari
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_jiraPlaybook' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_jiraPlaybook?: Maybe<JiraPlaybookQueryPayload>;
    /**
     * This query will be used once the user clicks the "Playbooks" expandable section in the issue view.
     * This will be also used for Show output/Refresh/View Output/Browser reload
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_jiraPlaybookInstancesForIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_jiraPlaybookInstancesForIssue?: Maybe<JiraPlaybookInstanceConnection>;
    /**
     * This query will be used once the user clicks the "Execution Output" tab in playbook itself.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_jiraPlaybookStepRunsForPlaybookInstance' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_jiraPlaybookStepRunsForPlaybookInstance?: Maybe<JiraPlaybookStepRunConnection>;
    /**
     * This will be used in "Execution Log" tab in Admin View
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_jiraPlaybookStepRunsForProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_jiraPlaybookStepRunsForProject?: Maybe<JiraPlaybookStepRunConnection>;
    /**
     * This will be used in List Playbook in Admin View
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "PlaybooksInJSM")' query directive to the 'playbook_jiraPlaybooksForProject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    playbook_jiraPlaybooksForProject?: Maybe<JiraPlaybookConnection>;
    polaris?: Maybe<PolarisQueryNamespace>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisCollabToken?: Maybe<PolarisDelegationToken>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "polaris-v0")' query directive to the 'polarisGetDetailedReaction' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    polarisGetDetailedReaction?: Maybe<PolarisReactionSummary>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisGetEarliestOnboardedProjectForCloudId?: Maybe<EarliestOnboardedProjectForCloudId>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisGetEarliestViewViewedForUser?: Maybe<EarliestViewViewedForUser>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "polaris-v0")' query directive to the 'polarisGetReactions' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    polarisGetReactions?: Maybe<Array<Maybe<PolarisReaction>>>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisIdeaTemplates?: Maybe<Array<PolarisIdeaTemplate>>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisInsight?: Maybe<PolarisInsight>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:jira-work__
     *
     *
     */
    polarisInsights?: Maybe<Array<PolarisInsight>>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:jira-work__
     *
     *
     */
    polarisInsightsWithErrors?: Maybe<Array<PolarisInsight>>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisLabels?: Maybe<Array<LabelUsage>>;
    /**
     * THIS QUERY IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisProject?: Maybe<PolarisProject>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisSnippetPropertiesConfig?: Maybe<PolarisSnippetPropertiesConfig>;
    /**
     * THIS QUERY IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:jira-work__
     *
     *
     */
    polarisView?: Maybe<PolarisView>;
    /**
     * THIS OPERATION IS IN BETA
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: polaris-v0` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    polarisViewArrangementInfo?: Maybe<Scalars["JSON"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'popularFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    popularFeed?: Maybe<PaginatedPopularFeed>;
    pricing?: Maybe<ContentPlatformPricing>;
    pricings: ContentPlatformPricingSearchConnection;
    /**
     * Get App Listing by reference ID and locales, if the provided locale is not supported it will default to english (en-US) values.
     * For all fields with the type [LocalisedString] a value will be returned for each requested locale.
     * Locale codes must be in the RFC 5646 format, supported values are:
     * 'en-GB','en-US','cs','da','de','es','fi','fr','hu','it','ja','ko','nb','nl','pl','pt-BR','ru','sv','th','tr','uk','vi','zh-TW','zh-CN'
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     * @deprecated Use productListings query instead
     */
    productListing?: Maybe<ProductListingResult>;
    /**
     * Get List of App Listings by reference ID and locale. For all fields with the type [LocalisedString] a value will be returned for each requested locale. If no locales are provided it will default to english (en-US). If a provided locale is not supported it will default to english (en-US).
     * Locale codes must be in the RFC 5646 format, supported values are:
     * 'en-GB','en-US','cs','da','de','es','fi','fr','hu','it','ja','ko','nb','nl','pl','pt-BR','ru','sv','th','tr','uk','vi','zh-TW','zh-CN'
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    productListings: Array<ProductListingResult>;
    /**
     *  Get a page and its paginated children and ancestors
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'ptpage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    ptpage?: Maybe<PtPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkOnboardingReference' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkOnboardingReference?: Maybe<PublicLinkOnboardingReference>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkPage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkPage?: Maybe<PublicLinkPage>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkPermissionsForObject' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkPermissionsForObject?: Maybe<PublicLinkPermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkSiteStatus' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkSiteStatus?: Maybe<PublicLinkSitePayload>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkSpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkSpace?: Maybe<PublicLinkSpace>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinkSpacesByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinkSpacesByCriteria?: Maybe<PublicLinkSpaceConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publicLinksByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publicLinksByCriteria?: Maybe<PublicLinkConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'publishConditions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    publishConditions?: Maybe<Array<Maybe<PublishConditions>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'pushNotificationSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    pushNotificationSettings?: Maybe<ConfluencePushNotificationSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'quickReload' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    quickReload?: Maybe<QuickReload>;
    /**
     * A list of values for this field that allow row filtering (rql), sorting (rql), and cursor pagination
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarFieldValues")' query directive to the 'radar_fieldValues' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_fieldValues?: Maybe<RadarFieldValuesConnection>;
    /**
     * A list of groupings of entities by fields and their stats that allow row filtering (rql), and cursor pagination
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarGroupMetrics")' query directive to the 'radar_groupMetrics' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_groupMetrics?: Maybe<RadarGroupMetricsConnection>;
    /**
     * Get position by ARI
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarPositionByAri")' query directive to the 'radar_positionByAri' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_positionByAri?: Maybe<RadarPosition>;
    /**
     * Get positions by ARI; maximum list of 100
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    radar_positionsByAris?: Maybe<Array<RadarPosition>>;
    /**
     * Search for a list of positions providing cursor pagination, row filtering (rql), sorting (rql), and column filtering (fields)
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarPositionsSearch")' query directive to the 'radar_positionsSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_positionsSearch?: Maybe<RadarPositionConnection>;
    /**
     * Get worker by ARI
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarWorkerByAri")' query directive to the 'radar_workerByAri' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_workerByAri?: Maybe<RadarWorker>;
    /**
     * Get workers by ARI; maximum list of 100
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarWorkersByAris")' query directive to the 'radar_workersByAris' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_workersByAris?: Maybe<Array<RadarWorker>>;
    /**
     * Data about this workspace
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarWorkspace")' query directive to the 'radar_workspace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    radar_workspace: RadarWorkspace;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'reactedUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    reactedUsers?: Maybe<ReactedUsersResponse>;
    reactionsSummary?: Maybe<ReactionsSummaryResponse>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'reactionsSummaryList' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    reactionsSummaryList?: Maybe<Array<Maybe<ReactionsSummaryResponse>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'recentlyViewedSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated recentlyViewedSpaces will no longer be supported after June 30 2023, consider using GraphQL myVisitedSpaces
     */
    recentlyViewedSpaces?: Maybe<Array<Maybe<Space>>>;
    releaseNote?: Maybe<ContentPlatformReleaseNote>;
    releaseNotes: ContentPlatformReleaseNotesConnection;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'renderedContentDump' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    renderedContentDump?: Maybe<HtmlDocument>;
    /**
     * Returns the repository relationships linked to the service with the specified id (service ARI).
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    repositoryRelationshipsForDevOpsService?: Maybe<DevOpsServiceAndRepositoryRelationshipConnection>;
    /**
     * Query for grouping the roadmap queries
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsQuery` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    roadmaps?: Maybe<RoadmapsQuery>;
    /** Queries under namespace `sandbox`. */
    sandbox: SandboxQuery;
    /**
     * The search method serves as an entry point to the various results across multiple Atlassian products.
     * This method proxy to Search Platform's API xpsearch-aggregator.
     * It supports multi tenant search with product specific filtering.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     * * __confluence:atlassian-external__
     *
     *
     */
    search?: Maybe<SearchQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'searchTimeseriesCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    searchTimeseriesCTR?: Maybe<SearchTimeseriesCtr>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'searchTimeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    searchTimeseriesCount?: Maybe<SearchTimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'searchesByTerm' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    searchesByTerm?: Maybe<SearchesByTerm>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'searchesWithZeroCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    searchesWithZeroCTR?: Maybe<SearchesWithZeroCtr>;
    /**
     * For fetching navigation customisation settings by entityAri and ownerAri
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     * * __confluence:atlassian-external__
     *
     *
     */
    settings_navigationCustomisation?: Maybe<SettingsNavigationCustomisation>;
    shepherd?: Maybe<ShepherdQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'signUpProperties' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    signUpProperties?: Maybe<SignUpProperties>;
    signup?: Maybe<SignupQueryApi>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    singleContent?: Maybe<Content>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'singleRestrictedResource' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    singleRestrictedResource?: Maybe<RestrictedResourceInfo>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'siteConfiguration' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    siteConfiguration?: Maybe<SiteConfiguration>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'siteDescription' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    siteDescription?: Maybe<SiteDescription>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'siteOperations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    siteOperations?: Maybe<SiteOperations>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'sitePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    sitePermissions?: Maybe<SitePermission>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    siteSettings?: Maybe<SiteSettings>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:space:confluence__
     * * __read:page:confluence__
     * * __read:blogpost:confluence__
     * * __confluence:atlassian-external__
     * * __read:account__
     * * __identity:atlassian-external__
     *
     *
     */
    smarts?: Maybe<SmartsQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'snippets' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    snippets?: Maybe<PaginatedSnippetList>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     * * __confluence:atlassian-external__
     *
     *
     */
    socialSignals?: Maybe<SocialSignalsApi>;
    /**
     *
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: softwareBoards` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    softwareBoards?: Maybe<BoardScopeConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaViewContext' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaViewContext?: Maybe<SpaViewModel>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    space?: Maybe<Space>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceContextContentCreationMetadata' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceContextContentCreationMetadata?: Maybe<ContentCreationMetadata>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceHomepage' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceHomepage?: Maybe<Content>;
    /**
     * Allows to get data for space manager
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceManager' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceManager?: Maybe<SpaceManagerRecordConnection>;
    /**
     * GraphQL query to get space permissions by space key
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spacePermissions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spacePermissions?: Maybe<SpacePermissions>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spacePermissionsAll' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spacePermissionsAll?: Maybe<SpacePermissionConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spacePopularFeed' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spacePopularFeed?: Maybe<PaginatedPopularSpaceFeed>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceRoleAssignmentsByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceRoleAssignmentsByCriteria?: Maybe<SpaceRoleAssignmentConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceRoleAssignmentsByPrincipal' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceRoleAssignmentsByPrincipal?: Maybe<SpaceRoleAssignmentConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceRolesByCriteria' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceRolesByCriteria?: Maybe<SpaceRoleConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceRolesBySpace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceRolesBySpace?: Maybe<SpaceRoleConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceSidebarLinks' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceSidebarLinks?: Maybe<SpaceSidebarLinks>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceTheme' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceTheme?: Maybe<Theme>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaceWatchers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaceWatchers?: Maybe<PaginatedPersonList>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    spaces?: Maybe<PaginatedSpaceList>;
    /**
     * Fetches spaces regardless of space admin status and returns limited info. Must be site/Confluence admin to use.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spacesWithExemptions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spacesWithExemptions?: Maybe<Array<Maybe<SpaceWithExemption>>>;
    /**
     * Returns the database size from the schema size table for an installation of a forge app.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sqlSchemaSizeLog: SqlSchemaSizeLogResponse;
    /**
     * Returns the list of slow queries from a forge app.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    sqlSlowQueryLogs: Array<SqlSlowQueryLogsResponse>;
    /**
     * Calls the cc-analytics stale pages API. lastActivityEarlierThan expects an ISO 8061 date string. Ex: 2023-12-08T20:55:25.000Z
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'stalePages' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    stalePages?: Maybe<PaginatedStalePagePayloadList>;
    /**
     * The search method serves as an entry point to the various results across multiple Atlassian products.
     * This method proxy to Search Platform's API xpsearch-aggregator.
     * It supports multi tenant search with product specific filtering.
     */
    suggest?: Maybe<QuerySuggestionApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'suggestedSpaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    suggestedSpaces?: Maybe<PaginatedSpaceList>;
    suggestions?: Maybe<AutoSuggestionApi>;
    /** Team-related queries */
    team?: Maybe<TeamQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'teamCalendarSettings' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    teamCalendarSettings?: Maybe<TeamCalendarSettings>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'teamLabels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    teamLabels?: Maybe<PaginatedLabelList>;
    template?: Maybe<ContentPlatformTemplate>;
    /**
     * Provides blueprint/template content body in ADF (atlas_doc_format) or HTML (view) format depending on Fabric editor compatibility.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'templateBodies' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    templateBodies?: Maybe<PaginatedTemplateBodyList>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'templateCategories' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    templateCategories?: Maybe<PaginatedTemplateCategoryList>;
    templateCollection?: Maybe<ContentPlatformTemplateCollection>;
    templateCollections: ContentPlatformTemplateCollectionContentSearchConnection;
    /**
     * Returns a single template for a specified id (includes both space level and global templates). The id for the requested template can be a UUID, Content Complete Module Key, or a Template Id.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'templateInfo' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    templateInfo?: Maybe<TemplateInfo>;
    /**
     * Provide Media API tokens for uploading and downloading template files/images.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'templateMediaSession' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    templateMediaSession?: Maybe<TemplateMediaSession>;
    templates: ContentPlatformTemplateContentSearchConnection;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'tenant' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    tenant?: Maybe<Tenant>;
    /**
     * A Jira or Confluence cloud instance, such as `hello.atlassian.net` has a backing
     * cloud ID such as `0ee6b491-5425-4f19-a71e-2486784ad694`
     *
     * This field allows you to look up the cloud IDs or host names of tenanted applications
     * such as Jira or Confluence.
     *
     * You MUST provide a list of either cloud ids or base urls or activation ids to look up
     * but only single argument is allowed. If you provide more than one argument, an error will be returned.
     */
    tenantContexts?: Maybe<Array<Maybe<TenantContext>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'timeseriesCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    timeseriesCount?: Maybe<TimeseriesCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'timeseriesPageBlogCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    timeseriesPageBlogCount?: Maybe<TimeseriesPageBlogCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'timeseriesUniqueUserCount' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    timeseriesUniqueUserCount?: Maybe<TimeseriesUniqueUserCount>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'topRelevantUsers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    topRelevantUsers?: Maybe<TopRelevantUsers>;
    topicOverview?: Maybe<ContentPlatformTopicOverview>;
    topicOverviews: ContentPlatformTopicOverviewContentSearchConnection;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'totalSearchCTR' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    totalSearchCTR?: Maybe<TotalSearchCtr>;
    townsquare?: Maybe<TownsquareQueryApi>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:workspace:townsquare__
     *
     *
     */
    townsquareUnsharded_allWorkspaceSummariesForOrg?: Maybe<TownsquareUnshardedWorkspaceSummaryConnection>;
    /**
     * Get trace timing data for this request
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'traceTiming' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    traceTiming?: Maybe<TraceTiming>;
    trello: TrelloQueryApi;
    unified?: Maybe<UnifiedQuery>;
    /**
     * Given an account id this will return user profile information with applied privacy controls of the caller.
     *
     * Its important to remember that privacy controls are applied in terms of the caller.  A user with
     * a certain accountId may exist but the current caller may not have the right to view their details.
     */
    user?: Maybe<User>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    userAccessStatus?: Maybe<AccessStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'userCanCreateContent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    userCanCreateContent?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Fetches the requested user fingerprint data. If true, uses the identity-graph.
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    userDna?: Maybe<UserFingerprintQuery>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'userGroupSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    userGroupSearch?: Maybe<GraphQlUserAndGroupSearchResults>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'userLocale' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    userLocale?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'userPreferences' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    userPreferences?: Maybe<UserPreferences>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'userWithContentRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    userWithContentRestrictions?: Maybe<UserWithRestrictions>;
    /**
     * Given a list of account ids this will return user profile information with applied privacy controls of the caller.
     *
     * Its important to remember that privacy controls are applied in terms of the caller.  A user with
     * a certain accountId may exist but the current caller may not have the right to view their details.
     *
     * A maximum of 90 `accountIds` can be asked for at the one time.
     */
    users?: Maybe<Array<User>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'usersWithContentRestrictions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    usersWithContentRestrictions?: Maybe<Array<Maybe<UserWithRestrictions>>>;
    /**
     * Validate a page can be converted to a live page
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'validateConvertPageToLiveEdit' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    validateConvertPageToLiveEdit?: Maybe<ConvertPageToLiveEditValidationResult>;
    /**
     * Validate a page can be copied. Currently, we only check validity related to copying of page restrictions.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'validatePageCopy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    validatePageCopy?: Maybe<ValidatePageCopyPayload>;
    /**
     * Validate a page can be published. Currently, we only check the page's title.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'validatePagePublish' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    validatePagePublish?: Maybe<PageValidationResult>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'validateSpaceKey' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    validateSpaceKey?: Maybe<ValidateSpaceKeyResponse>;
    /**
     * Validate a title before creating content.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'validateTitleForCreate' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    validateTitleForCreate?: Maybe<ValidateTitleForCreatePayload>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    virtualAgent?: Maybe<VirtualAgentQueryApi>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'webItemSections' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    webItemSections?: Maybe<Array<Maybe<WebSection>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'webItems' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    webItems?: Maybe<Array<Maybe<WebItem>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'webPanels' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    webPanels?: Maybe<Array<Maybe<WebPanel>>>;
    /** Gets all webtrigger URLs for an application in a specified context. */
    webTriggerUrlsByAppContext?: Maybe<Array<WebTriggerUrl>>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestions")' query directive to the 'workSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    workSuggestions?: Maybe<WorkSuggestions>;
    xflow?: Maybe<Scalars["String"]["output"]>;
};

export type QueryAdminAnnouncementBannerSettingArgs = {
    id: Scalars["String"]["input"];
};

export type QueryAdminAnnouncementBannerSettingsByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
    orderBy?: InputMaybe<AdminAnnouncementBannerSettingsByCriteriaOrder>;
};

export type QueryAgentAi_ContextPanelArgs = {
    cloudId: Scalars["ID"]["input"];
    issueId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAgentAi_SummarizeIssueArgs = {
    cloudId: Scalars["ID"]["input"];
    issueId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAgentStudio_AgentByIdArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryAgentStudio_SuggestConversationStartersArgs = {
    cloudId: Scalars["String"]["input"];
    input: AgentStudioSuggestConversationStartersInput;
};

export type QueryAiCoreApi_VsaReportingByProjectArgs = {
    projectAri: Scalars["ID"]["input"];
};

export type QueryAllIndividualSpacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllTemplatesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortingScheme?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
    teamType?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryAllUpdatesFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupBy?: InputMaybe<Array<AllUpdatesFeedEventType>>;
    spaceKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    users?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type QueryAnchorArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryAnchorsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryAppArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryAppActiveTunnelsArgs = {
    appId: Scalars["ID"]["input"];
    environmentId: Scalars["ID"]["input"];
};

export type QueryAppAdminArgs = {
    appId: Scalars["ID"]["input"];
};

export type QueryAppContributorsArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryAppDeploymentArgs = {
    appId: Scalars["ID"]["input"];
    environmentKey: Scalars["String"]["input"];
    id: Scalars["ID"]["input"];
};

export type QueryAppHostServiceScopesArgs = {
    keys: Array<Scalars["ID"]["input"]>;
};

export type QueryAppHostServicesArgs = {
    filter?: InputMaybe<AppServicesFilter>;
};

export type QueryAppInstallationTaskArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryAppLogLinesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    appId?: InputMaybe<Scalars["String"]["input"]>;
    environmentId?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    invocation: Scalars["ID"]["input"];
    query?: InputMaybe<LogQueryInput>;
};

export type QueryAppLogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    appId: Scalars["ID"]["input"];
    before?: InputMaybe<Scalars["String"]["input"]>;
    environmentId: Array<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<LogQueryInput>;
};

export type QueryAppLogsWithMetaDataArgs = {
    appId: Scalars["String"]["input"];
    environmentId: Scalars["String"]["input"];
    limit: Scalars["Int"]["input"];
    offset: Scalars["Int"]["input"];
    query?: InputMaybe<LogQueryInput>;
    queryStartTime: Scalars["String"]["input"];
};

export type QueryAppStorage_SqlDatabaseArgs = {
    input: AppStorageSqlDatabaseInput;
};

export type QueryAppStoredCustomEntitiesArgs = {
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    entityName: Scalars["String"]["input"];
    filters?: InputMaybe<AppStoredCustomEntityFilters>;
    indexName: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    partition?: InputMaybe<
        Array<Scalars["AppStoredCustomEntityFieldValue"]["input"]>
    >;
    range?: InputMaybe<AppStoredCustomEntityRange>;
    sort?: InputMaybe<SortOrder>;
};

export type QueryAppStoredCustomEntityArgs = {
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    entityName: Scalars["String"]["input"];
    key: Scalars["ID"]["input"];
};

export type QueryAppStoredEntitiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    where?: InputMaybe<Array<AppStoredEntityFilter>>;
};

export type QueryAppStoredEntityArgs = {
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    encrypted?: InputMaybe<Scalars["Boolean"]["input"]>;
    key: Scalars["ID"]["input"];
};

export type QueryAppsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<AppsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAquaOutgoingEmailLogsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryAvailableContentStatesArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryBitbucketRepositoriesAvailableToLinkWithNewDevOpsServiceArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        cloudId: Scalars["ID"]["input"];
        first?: InputMaybe<Scalars["Int"]["input"]>;
        nameFilter?: InputMaybe<Scalars["String"]["input"]>;
    };

export type QueryBlockedAccessRestrictionsArgs = {
    accessType: ResourceAccessType;
    contentId: Scalars["Long"]["input"];
    subjects: Array<InputMaybe<BlockedAccessSubjectInput>>;
};

export type QueryBoardScopeArgs = {
    boardId: Scalars["ID"]["input"];
    customFilterIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    filterJql?: InputMaybe<Scalars["String"]["input"]>;
    isCMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryBulkPermittedArgs = {
    dontRequirePrincipalsInSite?: InputMaybe<
        Array<InputMaybe<Scalars["Boolean"]["input"]>>
    >;
    permissionIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    principalIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    resourceIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryCanSplitIssueArgs = {
    boardId: Scalars["ID"]["input"];
    cardId: Scalars["ID"]["input"];
};

export type QueryCanvasTokenArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryCatchupEditMetadataForContentArgs = {
    contentId: Scalars["ID"]["input"];
    contentType: CatchupContentType;
    endTimeMs: Scalars["Long"]["input"];
    updateType?: InputMaybe<CatchupOverviewUpdateType>;
};

export type QueryCatchupGetLastViewedTimeArgs = {
    contentId: Scalars["ID"]["input"];
    contentType: CatchupContentType;
};

export type QueryCatchupVersionDiffMetadataForContentArgs = {
    contentId: Scalars["ID"]["input"];
    contentType: CatchupContentType;
    originalContentVersion: Scalars["Int"]["input"];
    revisedContentVersion: Scalars["Int"]["input"];
};

export type QueryClassificationLevelArgs = {
    id: Scalars["String"]["input"];
};

export type QueryClassificationLevelsArgs = {
    reclassificationFilterScope?: InputMaybe<ReclassificationFilterScope>;
};

export type QueryCodeInJiraArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryCollabDraftArgs = {
    format?: CollabFormat;
    hydrateAdf?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryCollabTokenArgs = {
    draftShareId?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    commentId?: InputMaybe<Scalars["ID"]["input"]>;
    confluenceCommentFilter?: InputMaybe<ConfluenceCommentFilter>;
    contentStatus?: InputMaybe<Array<InputMaybe<GraphQlContentStatus>>>;
    depth?: InputMaybe<Depth>;
    first?: InputMaybe<Scalars["Long"]["input"]>;
    inlineMarkerRef?: InputMaybe<Scalars["String"]["input"]>;
    inlineMarkerRefList?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    last?: InputMaybe<Scalars["Long"]["input"]>;
    location?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    pageId?: InputMaybe<Scalars["ID"]["input"]>;
    recentFirst?: InputMaybe<Scalars["Boolean"]["input"]>;
    singleThreaded?: InputMaybe<Scalars["Boolean"]["input"]>;
    type?: InputMaybe<Array<InputMaybe<CommentType>>>;
};

export type QueryCommentsDigestArgs = {
    contentId: Scalars["ID"]["input"];
    contentType: SummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
    responseType?: InputMaybe<CommentsDigestResponseType>;
};

export type QueryConfluenceLegacy_AdminAnnouncementBannerSettingArgs = {
    id: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_AdminAnnouncementBannerSettingsByCriteriaArgs =
    {
        after?: InputMaybe<Scalars["String"]["input"]>;
        first?: InputMaybe<Scalars["Int"]["input"]>;
        isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
        orderBy?: InputMaybe<ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder>;
    };

export type QueryConfluenceLegacy_AllTemplatesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortingScheme?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
    teamType?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_AllUpdatesFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupBy?: InputMaybe<Array<ConfluenceLegacyAllUpdatesFeedEventType>>;
    spaceKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
    users?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type QueryConfluenceLegacy_AtlassianUserArgs = {
    current?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluenceLegacy_AvailableContentStatesArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_CanvasTokenArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_CatchupEditMetadataForContentArgs = {
    contentId: Scalars["ID"]["input"];
    contentType: ConfluenceLegacyCatchupContentType;
    endTimeMs: Scalars["Long"]["input"];
};

export type QueryConfluenceLegacy_CatchupVersionSummaryMetadataForContentArgs =
    {
        contentId: Scalars["ID"]["input"];
        contentType: ConfluenceLegacyCatchupContentType;
        endTimeMs: Scalars["Long"]["input"];
        updateType: ConfluenceLegacyCatchupUpdateType;
    };

export type QueryConfluenceLegacy_ClassificationLevelArgs = {
    id: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_CollabTokenArgs = {
    draftShareId?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_CommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    commentId?: InputMaybe<Scalars["ID"]["input"]>;
    contentStatus?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyContentStatus>>
    >;
    depth?: InputMaybe<ConfluenceLegacyDepth>;
    first?: InputMaybe<Scalars["Long"]["input"]>;
    inlineMarkerRef?: InputMaybe<Scalars["String"]["input"]>;
    inlineMarkerRefList?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    last?: InputMaybe<Scalars["Long"]["input"]>;
    location?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    pageId?: InputMaybe<Scalars["ID"]["input"]>;
    recentFirst?: InputMaybe<Scalars["Boolean"]["input"]>;
    type?: InputMaybe<Array<InputMaybe<ConfluenceLegacyCommentType>>>;
};

export type QueryConfluenceLegacy_ConfluenceUsersArgs = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_ContentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    draftShareId?: InputMaybe<Scalars["String"]["input"]>;
    embeddedContentRender?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    navigationType?: InputMaybe<Scalars["String"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderby?: InputMaybe<Scalars["String"]["input"]>;
    postingDay?: InputMaybe<Scalars["String"]["input"]>;
    shareToken?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    trigger?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_ContentAnalyticsLastViewedAtByPageArgs = {
    contentIds: Array<Scalars["ID"]["input"]>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ContentAnalyticsTotalViewsByPageArgs = {
    contentIds: Array<Scalars["ID"]["input"]>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ContentAnalyticsViewedCommentsArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_ContentAnalyticsViewersArgs = {
    contentId: Scalars["ID"]["input"];
    fromDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_ContentAnalyticsViewsArgs = {
    contentId: Scalars["ID"]["input"];
    fromDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_ContentBodyArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_ContentByStateArgs = {
    contentStateId: Scalars["Long"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ContentContributorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_ContentConverterArgs = {
    content: Scalars["String"]["input"];
    contentIdContext?: InputMaybe<Scalars["ID"]["input"]>;
    embeddedContentRender?: InputMaybe<Scalars["String"]["input"]>;
    expand?: InputMaybe<Scalars["String"]["input"]>;
    from: Scalars["String"]["input"];
    spaceKeyContext?: InputMaybe<Scalars["String"]["input"]>;
    to: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ContentHistoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Long"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_ContentIdByReferenceIdArgs = {
    referenceId: Scalars["String"]["input"];
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_ContentLabelSearchArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    ignoreRelated?: InputMaybe<Scalars["Boolean"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    searchText: Scalars["String"]["input"];
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_ContentMediaSessionArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_ContentPermissionsArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_ContentRendererArgs = {
    adf: Scalars["String"]["input"];
    containedRender?: InputMaybe<Scalars["Boolean"]["input"]>;
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    mode?: InputMaybe<ConfluenceLegacyContentRendererMode>;
    outputDeviceType?: InputMaybe<ConfluenceLegacyOutputDeviceType>;
};

export type QueryConfluenceLegacy_ContentSmartLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_ContentTemplateLabelsByCriteriaArgs = {
    contentTemplateId: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    prefixes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_ContentWatchersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_CountGroupByEventNameArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_CountGroupByPageArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_CountGroupBySpaceArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_CountGroupByUserArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_DeactivatedOwnerPagesArgs = {
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_DeactivatedPageOwnerUsersArgs = {
    batchSize?: InputMaybe<Scalars["Int"]["input"]>;
    offset: Scalars["Int"]["input"];
    sortByPageCount?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    userType?: InputMaybe<ConfluenceLegacyDeactivatedPageOwnerUserType>;
};

export type QueryConfluenceLegacy_DetailsLinesArgs = {
    contentId: Scalars["ID"]["input"];
    contentRepresentation: Scalars["String"]["input"];
    countComments?: InputMaybe<Scalars["Boolean"]["input"]>;
    countLikes?: InputMaybe<Scalars["Boolean"]["input"]>;
    countUnresolvedComments?: InputMaybe<Scalars["Boolean"]["input"]>;
    cql?: InputMaybe<Scalars["String"]["input"]>;
    detailsId?: InputMaybe<Scalars["String"]["input"]>;
    headings?: InputMaybe<Scalars["String"]["input"]>;
    macroId?: InputMaybe<Scalars["String"]["input"]>;
    pageIndex?: InputMaybe<Scalars["Int"]["input"]>;
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
    reverseSort?: InputMaybe<Scalars["Boolean"]["input"]>;
    showCreator?: InputMaybe<Scalars["Boolean"]["input"]>;
    showLastModified?: InputMaybe<Scalars["Boolean"]["input"]>;
    showPageLabels?: InputMaybe<Scalars["Boolean"]["input"]>;
    sortBy?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_EditorConversionSettingsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_EntityCountBySpaceArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsMeasuresSpaceEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_EntityTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsMeasuresEventName>;
    granularity: ConfluenceLegacyAnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ExternalCanvasTokenArgs = {
    shareToken: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ExternalCollaboratorsByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    sorts?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyExternalCollaboratorsSortType>>
    >;
    spaceAssignmentType?: InputMaybe<ConfluenceLegacySpaceAssignmentType>;
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type QueryConfluenceLegacy_ExternalContentMediaSessionArgs = {
    shareToken: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_FavoriteContentArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_FeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_FutureContentTypeMobileSupportArgs = {
    contentType: Scalars["String"]["input"];
    locale: Scalars["String"]["input"];
    mobilePlatform: ConfluenceLegacyMobilePlatform;
};

export type QueryConfluenceLegacy_GetAiConfigArgs = {
    product: ConfluenceLegacyProduct;
};

export type QueryConfluenceLegacy_GetCommentReplySuggestionsArgs = {
    commentId: Scalars["ID"]["input"];
    language?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_GetCommentsSummaryArgs = {
    commentsType: ConfluenceLegacyCommentsType;
    contentId: Scalars["ID"]["input"];
    contentType: ConfluenceLegacySummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_GetRecommendedLabelsArgs = {
    entityId: Scalars["ID"]["input"];
    entityType: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_GetRecommendedPagesArgs = {
    entityId: Scalars["ID"]["input"];
    entityType: Scalars["String"]["input"];
    experience: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_GetRecommendedPagesSpaceStatusArgs = {
    entityId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_GetSmartContentFeatureArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_GetSmartFeaturesArgs = {
    input: Array<ConfluenceLegacySmartFeaturesInput>;
};

export type QueryConfluenceLegacy_GetSummaryArgs = {
    backendExperiment?: InputMaybe<ConfluenceLegacyBackendExperiment>;
    contentId: Scalars["ID"]["input"];
    contentType: ConfluenceLegacySummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
    lastUpdatedTimeSeconds: Scalars["Long"]["input"];
    responseType?: InputMaybe<ConfluenceLegacyResponseType>;
};

export type QueryConfluenceLegacy_GroupArgs = {
    groupId?: InputMaybe<Scalars["String"]["input"]>;
    groupName?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_GroupCountsArgs = {
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryConfluenceLegacy_GroupMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_GroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_GroupsUserSpaceAccessArgs = {
    accountId: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_GroupsWithContentRestrictionsArgs = {
    contentId: Scalars["ID"]["input"];
    groupIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryConfluenceLegacy_HasUserCommentedArgs = {
    accountId: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_IncomingLinksCountArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_InlineTasksArgs = {
    tasksQuery: ConfluenceLegacyInlineTasksByMetadata;
};

export type QueryConfluenceLegacy_InstanceAnalyticsCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    startTime: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_IsMoveContentStatesSupportedArgs = {
    contentId: Scalars["ID"]["input"];
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_JiraProjectsArgs = {
    jiraServerId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_LabelSearchArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    ignoreRelated?: InputMaybe<Scalars["Boolean"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    searchText: Scalars["String"]["input"];
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_LookAndFeelArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_MacroBodyRendererArgs = {
    adf: Scalars["String"]["input"];
    containedRender?: InputMaybe<Scalars["Boolean"]["input"]>;
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    mode?: InputMaybe<ConfluenceLegacyContentRendererMode>;
    outputDeviceType?: InputMaybe<ConfluenceLegacyOutputDeviceType>;
};

export type QueryConfluenceLegacy_MyVisitedPagesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_MyVisitedSpacesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_OnboardingStateArgs = {
    key?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryConfluenceLegacy_PageArgs = {
    enablePaging?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["ID"]["input"];
    pageTree?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_PageActivityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    fromDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_PageAnalyticsCountArgs = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    pageId: Scalars["ID"]["input"];
    startTime: Scalars["String"]["input"];
    uniqueBy?: InputMaybe<ConfluenceLegacyPageAnalyticsCountType>;
};

export type QueryConfluenceLegacy_PageAnalyticsTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    granularity: ConfluenceLegacyAnalyticsTimeseriesGranularity;
    pageId: Scalars["ID"]["input"];
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
    uniqueBy?: InputMaybe<ConfluenceLegacyPageAnalyticsTimeseriesCountType>;
};

export type QueryConfluenceLegacy_PageContextContentCreationMetadataArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_PagesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Scalars["ID"]["input"]>;
    parentPageId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<ConfluenceLegacyPageStatus>>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_PaywallContentToDisableArgs = {
    contentType: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_PaywallStatusArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_PopularFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_PtpageArgs = {
    enablePaging?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["ID"]["input"];
    pageTree?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<ConfluenceLegacyPtGraphQlPageStatus>>>;
};

export type QueryConfluenceLegacy_PublicLinkPageArgs = {
    pageId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_PublicLinkPagesByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
    orderBy?: InputMaybe<ConfluenceLegacyPublicLinkPagesByCriteriaOrder>;
    pageTitlePattern?: InputMaybe<Scalars["String"]["input"]>;
    spaceId: Scalars["ID"]["input"];
    status?: InputMaybe<Array<ConfluenceLegacyPublicLinkPageStatusFilter>>;
};

export type QueryConfluenceLegacy_PublicLinkPermissionsForObjectArgs = {
    objectId: Scalars["ID"]["input"];
    objectType: ConfluenceLegacyPublicLinkPermissionsObjectType;
};

export type QueryConfluenceLegacy_PublicLinkSpaceArgs = {
    spaceId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_PublicLinkSpacesByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
    orderBy?: InputMaybe<ConfluenceLegacyPublicLinkSpacesByCriteriaOrder>;
    spaceNamePattern?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<ConfluenceLegacyPublicLinkSpaceStatus>>;
};

export type QueryConfluenceLegacy_PublicLinksByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
    orderBy?: InputMaybe<ConfluenceLegacyPublicLinksByCriteriaOrder>;
    spaceId: Scalars["ID"]["input"];
    status?: InputMaybe<Array<InputMaybe<ConfluenceLegacyPublicLinkStatus>>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryConfluenceLegacy_PublishConditionsArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_QuickReloadArgs = {
    pageId: Scalars["Long"]["input"];
    since: Scalars["Long"]["input"];
};

export type QueryConfluenceLegacy_ReactedUsersArgs = {
    containerId: Scalars["String"]["input"];
    containerType: ConfluenceLegacyContainerType;
    contentId: Scalars["String"]["input"];
    contentType: ConfluenceLegacyReactionContentType;
    emojiId: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ReactionsSummaryArgs = {
    containerId: Scalars["ID"]["input"];
    containerType?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    contentType: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_ReactionsSummaryListArgs = {
    ids: Array<InputMaybe<ConfluenceLegacyReactionsId>>;
};

export type QueryConfluenceLegacy_RecentlyViewedSpacesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_RenderedContentDumpArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_SearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cql: Scalars["String"]["input"];
    cqlcontext?: InputMaybe<Scalars["String"]["input"]>;
    disableArchivedSpaceFallback?: InputMaybe<Scalars["Boolean"]["input"]>;
    excerpt?: InputMaybe<Scalars["String"]["input"]>;
    excludeCurrentSpaces?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeArchivedSpaces?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_SearchTimeseriesCtrArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsSearchEventName>;
    granularity: ConfluenceLegacyAnalyticsTimeseriesGranularity;
    searchTerm?: InputMaybe<Scalars["String"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_SearchTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsSearchEventName>;
    granularity: ConfluenceLegacyAnalyticsTimeseriesGranularity;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_SearchUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cql: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    sitePermissionTypeFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_SearchesByTermArgs = {
    fromDate: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    period: ConfluenceLegacySearchesByTermPeriod;
    searchFilter?: InputMaybe<Scalars["String"]["input"]>;
    sortDirection: Scalars["String"]["input"];
    sorting: ConfluenceLegacySearchesByTermColumns;
    timezone: Scalars["String"]["input"];
    toDate: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_SearchesWithZeroCtrArgs = {
    fromDate: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortDirection?: InputMaybe<Scalars["String"]["input"]>;
    timezone: Scalars["String"]["input"];
    toDate: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_SingleContentArgs = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    shareToken?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    validatedShareToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_SitePermissionsArgs = {
    operations?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacySitePermissionOperationType>>
    >;
    permissionTypes?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacySitePermissionType>>
    >;
};

export type QueryConfluenceLegacy_SnippetsArgs = {
    accountId: Scalars["String"]["input"];
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    scope?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_SpaceArgs = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
    identifier?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    pageId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluenceLegacy_SpaceContextContentCreationMetadataArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_SpaceHomepageArgs = {
    spaceKey: Scalars["String"]["input"];
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_SpacePermissionsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_SpacePermissionsAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_SpacePopularFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_SpaceRoleAssignmentsByPrincipalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    principal: ConfluenceLegacyRoleAssignmentPrincipalInput;
    spaceId: Scalars["Long"]["input"];
};

export type QueryConfluenceLegacy_SpaceSidebarLinksArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_SpaceThemeArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_SpaceWatchersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_SpacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    assignedToGroupId?: InputMaybe<Scalars["String"]["input"]>;
    assignedToGroupName?: InputMaybe<Scalars["String"]["input"]>;
    assignedToUser?: InputMaybe<Scalars["String"]["input"]>;
    creatorAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    favourite?: InputMaybe<Scalars["Boolean"]["input"]>;
    favouriteUserAccountId?: InputMaybe<Scalars["String"]["input"]>;
    favouriteUserKey?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    spaceKeys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    spaceNamePattern?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    watchedByAccountId?: InputMaybe<Scalars["String"]["input"]>;
    watchedSpacesOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryConfluenceLegacy_SpacesWithExemptionsArgs = {
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
};

export type QueryConfluenceLegacy_StalePagesArgs = {
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    lastActivityEarlierThan: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageStatus?: InputMaybe<ConfluenceLegacyStalePageStatus>;
    sort?: InputMaybe<ConfluenceLegacyStalePagesSortingType>;
    spaceId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_StorageArgs = {
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluenceLegacy_SuggestedSpacesArgs = {
    connections?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_TeamLabelsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_TemplateArgs = {
    contentTemplateId: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_TemplateBodiesArgs = {
    ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_TemplateCategoriesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_TemplateInfoArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_TemplateMediaSessionArgs = {
    collectionId?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    templateIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryConfluenceLegacy_TemplatesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_TenantArgs = {
    current?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryConfluenceLegacy_TimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<ConfluenceLegacyAnalyticsEventName>;
    granularity: ConfluenceLegacyAnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_TimeseriesPageBlogCountArgs = {
    contentAction: ConfluenceLegacyContentAction;
    contentType: ConfluenceLegacyAnalyticsContentType;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    granularity: ConfluenceLegacyAnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_TopRelevantUsersArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName?: InputMaybe<
        Array<InputMaybe<ConfluenceLegacyAnalyticsEventName>>
    >;
    sortOrder?: InputMaybe<ConfluenceLegacyRelevantUsersSortOrder>;
    spaceId: Array<Scalars["String"]["input"]>;
    startTime?: InputMaybe<Scalars["String"]["input"]>;
    userFilter?: InputMaybe<ConfluenceLegacyRelevantUserFilter>;
};

export type QueryConfluenceLegacy_TotalSearchCtrArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_UserGroupSearchArgs = {
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
    sitePermissionTypeFilter?: InputMaybe<ConfluenceLegacySitePermissionTypeFilter>;
};

export type QueryConfluenceLegacy_UserWithContentRestrictionsArgs = {
    accountId?: InputMaybe<Scalars["String"]["input"]>;
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluenceLegacy_UsersWithContentRestrictionsArgs = {
    accountIds: Array<InputMaybe<Scalars["String"]["input"]>>;
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluenceLegacy_ValidateConvertPageToLiveEditArgs = {
    input: ConfluenceLegacyValidateConvertPageToLiveEditInput;
};

export type QueryConfluenceLegacy_ValidatePageCopyArgs = {
    input: ConfluenceLegacyValidatePageCopyInput;
};

export type QueryConfluenceLegacy_ValidatePagePublishArgs = {
    id: Scalars["ID"]["input"];
    status?: InputMaybe<Scalars["String"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluenceLegacy_ValidateSpaceKeyArgs = {
    generateUniqueKey?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    validateUniqueness?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryConfluenceLegacy_ValidateTitleForCreateArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    title: Scalars["String"]["input"];
};

export type QueryConfluenceLegacy_WebItemSectionsArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    locations?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_WebItemsArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    section?: InputMaybe<Scalars["String"]["input"]>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceLegacy_WebPanelsArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    locations?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluenceUsersArgs = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluence_AtlassianUserArgs = {
    current?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluence_CalendarPreferenceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryConfluence_CalendarTimezonesArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryConfluence_EmptyArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryConfluence_ExternalCollaboratorsByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    sorts?: InputMaybe<Array<InputMaybe<ExternalCollaboratorsSortType>>>;
    spaceAssignmentType?: InputMaybe<SpaceAssignmentType>;
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
};

export type QueryConfluence_RefreshMigrationMediaSessionArgs = {
    cloudId: Scalars["ID"]["input"];
    migrationId: Scalars["String"]["input"];
};

export type QueryConfluence_SearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    cql: Scalars["String"]["input"];
    cqlcontext?: InputMaybe<Scalars["String"]["input"]>;
    disableArchivedSpaceFallback?: InputMaybe<Scalars["Boolean"]["input"]>;
    excerpt?: InputMaybe<Scalars["String"]["input"]>;
    excludeCurrentSpaces?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeArchivedSpaces?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryConfluence_SearchTeamLabelsArgs = {
    cloudId: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    searchText: Scalars["String"]["input"];
};

export type QueryConfluence_SearchUserArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    cql: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    sitePermissionTypeFilter?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryConfluence_StorageArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluence_SubCalendarSubscribersCountArgs = {
    cloudId: Scalars["ID"]["input"];
    subCalendarId: Scalars["ID"]["input"];
};

export type QueryConfluence_TeamPresenceArgs = {
    cloudId: Scalars["ID"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type QueryConfluence_TeamPresenceSpaceSettingsArgs = {
    cloudId: Scalars["ID"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type QueryConfluence_TemplateArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    contentTemplateId: Scalars["String"]["input"];
};

export type QueryConfluence_TenantContextArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryConfluence_UserContentAccessArgs = {
    accessType: ResourceAccessType;
    accountIds: Array<InputMaybe<Scalars["String"]["input"]>>;
    cloudId: Scalars["ID"]["input"];
    contentId: Scalars["ID"]["input"];
};

export type QueryConfluence_ValidateCalendarJqlArgs = {
    applicationId: Scalars["ID"]["input"];
    cloudId: Scalars["ID"]["input"];
    jql: Scalars["String"]["input"];
};

export type QueryConnectionManager_ConnectionsByJiraProjectArgs = {
    filter?: InputMaybe<ConnectionManagerConnectionsFilter>;
    jiraProjectARI?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryContentArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    draftShareId?: InputMaybe<Scalars["String"]["input"]>;
    embeddedContentRender?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    navigationType?: InputMaybe<Scalars["String"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderby?: InputMaybe<Scalars["String"]["input"]>;
    postingDay?: InputMaybe<Scalars["String"]["input"]>;
    shareToken?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    trigger?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryContentAnalyticsLastViewedAtByPageArgs = {
    contentIds: Array<Scalars["ID"]["input"]>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryContentAnalyticsTotalViewsByPageArgs = {
    contentIds: Array<Scalars["ID"]["input"]>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryContentAnalyticsUnreadCommentsArgs = {
    commentType?: InputMaybe<AnalyticsCommentType>;
    contentId: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryContentAnalyticsViewedCommentsArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryContentAnalyticsViewersArgs = {
    contentId: Scalars["ID"]["input"];
    fromDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryContentAnalyticsViewsArgs = {
    contentId: Scalars["ID"]["input"];
    fromDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryContentAnalyticsViewsByDateArgs = {
    contentId: Scalars["ID"]["input"];
    contentType: Scalars["String"]["input"];
    fromDate: Scalars["String"]["input"];
    period: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
    toDate: Scalars["String"]["input"];
    type: Scalars["String"]["input"];
};

export type QueryContentBodyArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryContentByStateArgs = {
    contentStateId: Scalars["Long"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey: Scalars["String"]["input"];
};

export type QueryContentContributorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryContentConverterArgs = {
    content: Scalars["String"]["input"];
    contentIdContext?: InputMaybe<Scalars["ID"]["input"]>;
    embeddedContentRender?: InputMaybe<Scalars["String"]["input"]>;
    expand?: InputMaybe<Scalars["String"]["input"]>;
    from: Scalars["String"]["input"];
    spaceKeyContext?: InputMaybe<Scalars["String"]["input"]>;
    to: Scalars["String"]["input"];
};

export type QueryContentFacetArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: Scalars["Int"]["input"];
    forContentType: Scalars["String"]["input"];
    forFields: Array<Scalars["String"]["input"]>;
    withFallback?: Scalars["String"]["input"];
    withLocales?: Array<Scalars["String"]["input"]>;
};

export type QueryContentHistoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Long"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryContentIdByReferenceIdArgs = {
    referenceId: Scalars["String"]["input"];
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryContentLabelSearchArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    ignoreRelated?: InputMaybe<Scalars["Boolean"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    searchText: Scalars["String"]["input"];
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryContentMediaSessionArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryContentPermissionsArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryContentReactionsSummaryArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    contentId: Scalars["ID"]["input"];
    contentType: Scalars["String"]["input"];
};

export type QueryContentRendererArgs = {
    adf: Scalars["String"]["input"];
    containedRender?: InputMaybe<Scalars["Boolean"]["input"]>;
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    mode?: InputMaybe<ContentRendererMode>;
    outputDeviceType?: InputMaybe<OutputDeviceType>;
};

export type QueryContentSmartLinksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryContentTemplateLabelsByCriteriaArgs = {
    contentTemplateId: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    prefixes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryContentVersionHistoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: ContentVersionHistoryFilter;
    first?: Scalars["Int"]["input"];
    id: Scalars["ID"]["input"];
};

export type QueryContentWatchersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryCountGroupByEventNameArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryCountGroupByPageArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    startTime: Scalars["String"]["input"];
};

export type QueryCountGroupBySpaceArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    startTime: Scalars["String"]["input"];
};

export type QueryCountGroupByUserArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryCountUsersGroupByPageArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryCustomerServiceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryCustomerStoriesArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryCustomerStoryArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryDeactivatedOwnerPagesArgs = {
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey: Scalars["String"]["input"];
};

export type QueryDeactivatedPageOwnerUsersArgs = {
    batchSize?: InputMaybe<Scalars["Int"]["input"]>;
    offset: Scalars["Int"]["input"];
    sortByPageCount?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    userType?: InputMaybe<DeactivatedPageOwnerUserType>;
};

export type QueryDefaultSpaceRoleAssignmentsAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryDetailsLinesArgs = {
    contentId: Scalars["ID"]["input"];
    contentRepresentation: Scalars["String"]["input"];
    countComments?: InputMaybe<Scalars["Boolean"]["input"]>;
    countLikes?: InputMaybe<Scalars["Boolean"]["input"]>;
    countUnresolvedComments?: InputMaybe<Scalars["Boolean"]["input"]>;
    cql?: InputMaybe<Scalars["String"]["input"]>;
    detailsId?: InputMaybe<Scalars["String"]["input"]>;
    headings?: InputMaybe<Scalars["String"]["input"]>;
    macroId?: InputMaybe<Scalars["String"]["input"]>;
    pageIndex?: InputMaybe<Scalars["Int"]["input"]>;
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
    reverseSort?: InputMaybe<Scalars["Boolean"]["input"]>;
    showCreator?: InputMaybe<Scalars["Boolean"]["input"]>;
    showLastModified?: InputMaybe<Scalars["Boolean"]["input"]>;
    showPageLabels?: InputMaybe<Scalars["Boolean"]["input"]>;
    sortBy?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey: Scalars["String"]["input"];
};

export type QueryDevOpsServiceArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceAndJiraProjectRelationshipArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceAndOpsgenieTeamRelationshipArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceAndRepositoryRelationshipArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceRelationshipArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceRelationshipsForJiraProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndJiraProjectRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceRelationshipsForOpsgenieTeamArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryDevOpsServiceRelationshipsForRepositoryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndRepositoryRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<DevOpsServiceAndRepositoryRelationshipSort>;
};

export type QueryDevOpsServiceTiersArgs = {
    cloudId: Scalars["String"]["input"];
};

export type QueryDevOpsServiceTypesArgs = {
    cloudId: Scalars["String"]["input"];
};

export type QueryDevOpsServicesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["String"]["input"];
    filter?: InputMaybe<DevOpsServicesFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryDevOpsServicesByIdArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryDevai_AutodevAgentForJobArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type QueryDevai_AutodevIssueScopingArgs = {
    issueDescription?: InputMaybe<Scalars["String"]["input"]>;
    issueId: Scalars["ID"]["input"];
    issueSummary: Scalars["String"]["input"];
};

export type QueryDevai_AutodevIssueScopingScoreForJobArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type QueryDevai_AutodevJobFileContentsArgs = {
    cloudId: Scalars["ID"]["input"];
    endLine?: InputMaybe<Scalars["Int"]["input"]>;
    fileName: Scalars["String"]["input"];
    jobId: Scalars["ID"]["input"];
    startLine?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryDevai_AutodevJobLogGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jobId: Scalars["ID"]["input"];
};

export type QueryDevai_AutodevJobLogsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    excludePriorities?: InputMaybe<Array<InputMaybe<DevAiAutodevLogPriority>>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    jobId: Scalars["ID"]["input"];
    minPriority?: InputMaybe<DevAiAutodevLogPriority>;
};

export type QueryDevai_AutodevJobsForIssueArgs = {
    issueAri: Scalars["ID"]["input"];
    jobIdFilter?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryDevai_AutodevRovoAgentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
    templatesFilter?: InputMaybe<DevAiRovoAgentTemplateFilter>;
};

export type QueryDevai_RovoDevAgentsUserArgs = {
    atlassianAccountId: Scalars["ID"]["input"];
    cloudId: Scalars["ID"]["input"];
};

export type QueryDevai_TechnicalPlannerJobByIdArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type QueryDevai_TechnicalPlannerJobsForIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueAri: Scalars["ID"]["input"];
};

export type QueryDeveloperLogAccessArgs = {
    appId: Scalars["ID"]["input"];
    contextIds: Array<Scalars["ID"]["input"]>;
    environmentType: AppEnvironmentType;
};

export type QueryDevelopmentInformationArgs = {
    issueId: Scalars["ID"]["input"];
};

export type QueryDiscoverFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryEditorConversionSettingsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type QueryEntityCountBySpaceArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsMeasuresSpaceEventName>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    spaceId?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    startTime: Scalars["String"]["input"];
};

export type QueryEntityTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsMeasuresEventName>;
    granularity: AnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryEventCtrArgs = {
    clickEventName: AnalyticsClickEventName;
    discoverEventName: AnalyticsDiscoverEventName;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
};

export type QueryEventTimeseriesCtrArgs = {
    clickEventName: AnalyticsClickEventName;
    discoverEventName: AnalyticsDiscoverEventName;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    granularity: AnalyticsTimeseriesGranularity;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryExtensionByKeyArgs = {
    contextId: Scalars["ID"]["input"];
    definitionId: Scalars["ID"]["input"];
    extensionKey: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryExtensionContextArgs = {
    contextId: Scalars["ID"]["input"];
};

export type QueryExtensionContextsArgs = {
    contextIds: Array<Scalars["ID"]["input"]>;
};

export type QueryExtensionsEchoArgs = {
    text: Scalars["String"]["input"];
};

export type QueryExternalCanvasTokenArgs = {
    shareToken: Scalars["String"]["input"];
};

export type QueryExternalContentMediaSessionArgs = {
    shareToken: Scalars["String"]["input"];
};

export type QueryExternal_EntitiesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryExternal_EntitiesV2Args = {
    graphWorkspaceAri: Scalars["ID"]["input"];
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryFavoriteContentArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sortBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryForYouFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryFullHubArticleArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryFullHubArticlesArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryFullTutorialArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryFullTutorialsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryFutureContentTypeMobileSupportArgs = {
    contentType: Scalars["String"]["input"];
    locale: Scalars["String"]["input"];
    mobilePlatform: MobilePlatform;
};

export type QueryGetAiConfigArgs = {
    product: Product;
};

export type QueryGetCommentReplySuggestionsArgs = {
    commentId: Scalars["ID"]["input"];
    language?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetCommentsSummaryArgs = {
    commentsType: CommentsType;
    contentId: Scalars["ID"]["input"];
    contentType: SummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetKeywordsArgs = {
    entityAri?: InputMaybe<Scalars["String"]["input"]>;
    textInput?: InputMaybe<NlpGetKeywordsTextInput>;
};

export type QueryGetRecommendedLabelsArgs = {
    entityId: Scalars["ID"]["input"];
    entityType: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId: Scalars["ID"]["input"];
};

export type QueryGetRecommendedPagesArgs = {
    entityId: Scalars["ID"]["input"];
    entityType: Scalars["String"]["input"];
    experience: Scalars["String"]["input"];
};

export type QueryGetRecommendedPagesSpaceStatusArgs = {
    entityId: Scalars["ID"]["input"];
};

export type QueryGetSmartContentFeatureArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryGetSmartFeaturesArgs = {
    input: Array<SmartFeaturesInput>;
};

export type QueryGetSummaryArgs = {
    backendExperiment?: InputMaybe<BackendExperiment>;
    contentId: Scalars["ID"]["input"];
    contentType: SummaryType;
    language?: InputMaybe<Scalars["String"]["input"]>;
    lastUpdatedTimeSeconds: Scalars["Long"]["input"];
    responseType?: InputMaybe<ResponseType>;
};

export type QueryGroupArgs = {
    groupId?: InputMaybe<Scalars["String"]["input"]>;
    groupName?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGroupCountsArgs = {
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryGroupMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["String"]["input"];
};

export type QueryGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGroupsUserSpaceAccessArgs = {
    accountId: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGroupsWithContentRestrictionsArgs = {
    contentId: Scalars["ID"]["input"];
    groupIds: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type QueryGrowthUnifiedProfile_GetUnifiedProfileArgs = {
    accountId?: InputMaybe<Scalars["ID"]["input"]>;
    anonymousId?: InputMaybe<Scalars["ID"]["input"]>;
    tenantId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryHasUserCommentedArgs = {
    accountId: Scalars["String"]["input"];
};

export type QueryHelpCenterArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryHelpExternalResourceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryHelpLayoutArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryHelpObjectStoreArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryHelpObjectStore_SearchArticlesArgs = {
    categoryIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    cloudId: Scalars["ID"]["input"];
    helpCenterAri?: InputMaybe<Scalars["ID"]["input"]>;
    highlight?: InputMaybe<Scalars["Boolean"]["input"]>;
    limit: Scalars["Int"]["input"];
    portalIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    queryTerm: Scalars["String"]["input"];
    skipRestrictedPages?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryHelpObjectStore_SearchPortalsArgs = {
    cloudId: Scalars["ID"]["input"];
    helpCenterAri?: InputMaybe<Scalars["ID"]["input"]>;
    limit: Scalars["Int"]["input"];
    queryTerm: Scalars["String"]["input"];
};

export type QueryHelpObjectStore_SearchRequestTypesArgs = {
    cloudId: Scalars["ID"]["input"];
    helpCenterAri?: InputMaybe<Scalars["ID"]["input"]>;
    limit: Scalars["Int"]["input"];
    portalId?: InputMaybe<Scalars["String"]["input"]>;
    queryTerm: Scalars["String"]["input"];
};

export type QueryIncomingLinksCountArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryInlineTasksArgs = {
    tasksQuery: InlineTasksByMetadata;
};

export type QueryInstallationContextsArgs = {
    appId: Scalars["ID"]["input"];
};

export type QueryInstallationContextsWithLogAccessArgs = {
    appId: Scalars["ID"]["input"];
};

export type QueryInstanceAnalyticsCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    startTime: Scalars["String"]["input"];
};

export type QueryIpmFlagArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryIpmFlagsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryIpmImageModalArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryIpmImageModalsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryIpmInlineDialogArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryIpmInlineDialogsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryIpmMultiStepArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryIpmMultiStepsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryIsMoveContentStatesSupportedArgs = {
    contentId: Scalars["ID"]["input"];
    spaceKey: Scalars["String"]["input"];
};

export type QueryIsSainSearchEnabledArgs = {
    cloudId: Scalars["String"]["input"];
};

export type QueryJiraAlignAgg_ProjectsByArisArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryJiraProjectRelationshipsForServiceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndJiraProjectRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
};

export type QueryJira_BoardViewArgs = {
    input: JiraBoardViewInput;
};

export type QueryJira_IssueSearchViewsByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryJira_ProjectByIdOrKeyArgs = {
    cloudId: Scalars["ID"]["input"];
    idOrKey: Scalars["String"]["input"];
};

export type QueryJira_ProjectsSidebarMenuArgs = {
    cloudId: Scalars["ID"]["input"];
    currentURL?: InputMaybe<Scalars["URL"]["input"]>;
};

export type QueryKnowledgeBaseArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryKnowledgeBaseSpacePermission_BulkQueryArgs = {
    cloudId: Scalars["ID"]["input"];
    spaceAris: Array<Scalars["ID"]["input"]>;
};

export type QueryKnowledgeBase_SearchArticlesArgs = {
    searchInput?: InputMaybe<KnowledgeBaseArticleSearchInput>;
};

export type QueryLabelSearchArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    ignoreRelated?: InputMaybe<Scalars["Boolean"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    searchText: Scalars["String"]["input"];
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLookAndFeelArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryLoom_CommentArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryLoom_CommentsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryLoom_MeetingArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryLoom_MeetingRecurrenceArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryLoom_MeetingRecurrencesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryLoom_MeetingsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryLoom_SettingsArgs = {
    siteId: Scalars["ID"]["input"];
};

export type QueryLoom_SpaceArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryLoom_SpacesArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryLoom_SpacesSearchArgs = {
    query?: InputMaybe<Scalars["String"]["input"]>;
    siteId: Scalars["ID"]["input"];
};

export type QueryLoom_VideoArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryLoom_VideosArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryMacroBodyRendererArgs = {
    adf: Scalars["String"]["input"];
    containedRender?: InputMaybe<Scalars["Boolean"]["input"]>;
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    mode?: InputMaybe<ContentRendererMode>;
    outputDeviceType?: InputMaybe<OutputDeviceType>;
};

export type QueryMarketplaceAppArgs = {
    appId: Scalars["ID"]["input"];
};

export type QueryMarketplaceAppByCloudAppIdArgs = {
    cloudAppId: Scalars["ID"]["input"];
};

export type QueryMarketplaceAppByKeyArgs = {
    appKey: Scalars["String"]["input"];
};

export type QueryMarketplaceAppTrustInformationArgs = {
    appKey: Scalars["String"]["input"];
    state: AppTrustInformationState;
};

export type QueryMarketplacePartnerArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryMarketplacePricingPlanArgs = {
    appId: Scalars["ID"]["input"];
    hostingType: AtlassianProductHostingType;
    pricingPlanOptions?: InputMaybe<MarketplacePricingPlanOptions>;
};

export type QueryMyMarketplaceAppsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<MarketplaceAppsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMyVisitedPagesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryMyVisitedSpacesArgs = {
    accountId?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName?: InputMaybe<Array<InputMaybe<AnalyticsEventName>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortOrder?: InputMaybe<RelevantUsersSortOrder>;
    startTime?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryNlpSearchArgs = {
    additionalContext?: InputMaybe<Scalars["String"]["input"]>;
    experience?: InputMaybe<Scalars["String"]["input"]>;
    followups_enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    locale?: InputMaybe<Scalars["String"]["input"]>;
    locations: Array<Scalars["String"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryNodeArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryOnboardingStateArgs = {
    key?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryOpsgenieTeamRelationshipForDevOpsServiceArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPageArgs = {
    enablePaging?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["ID"]["input"];
    pageTree?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryPageActivityArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    fromDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPageAnalyticsCountArgs = {
    accountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    pageId: Scalars["ID"]["input"];
    startTime: Scalars["String"]["input"];
    uniqueBy?: InputMaybe<PageAnalyticsCountType>;
};

export type QueryPageAnalyticsTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    granularity: AnalyticsTimeseriesGranularity;
    pageId: Scalars["ID"]["input"];
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
    uniqueBy?: InputMaybe<PageAnalyticsTimeseriesCountType>;
};

export type QueryPageContextContentCreationMetadataArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryPagesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageId?: InputMaybe<Scalars["ID"]["input"]>;
    parentPageId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<GraphQlPageStatus>>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPaywallContentToDisableArgs = {
    contentType: Scalars["String"]["input"];
};

export type QueryPaywallStatusArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPermittedArgs = {
    dontRequirePrincipalInSite?: InputMaybe<Scalars["Boolean"]["input"]>;
    permissionId?: InputMaybe<Scalars["String"]["input"]>;
    principalId?: InputMaybe<Scalars["String"]["input"]>;
    resourceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPermsReportDownloadLinkForTaskArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPlaybook_JiraPlaybookArgs = {
    playbookAri: Scalars["ID"]["input"];
};

export type QueryPlaybook_JiraPlaybookInstancesForIssueArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    issueId: Scalars["String"]["input"];
    projectKey: Scalars["String"]["input"];
};

export type QueryPlaybook_JiraPlaybookStepRunsForPlaybookInstanceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    playbookInstanceAri: Scalars["ID"]["input"];
};

export type QueryPlaybook_JiraPlaybookStepRunsForProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filter?: InputMaybe<JiraPlaybookFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectKey: Scalars["String"]["input"];
};

export type QueryPlaybook_JiraPlaybooksForProjectArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    filter?: InputMaybe<JiraPlaybookFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectKey: Scalars["String"]["input"];
    sort?: InputMaybe<Array<JiraPlaybooksSortInput>>;
};

export type QueryPolarisCollabTokenArgs = {
    viewID: Scalars["ID"]["input"];
};

export type QueryPolarisGetDetailedReactionArgs = {
    input: PolarisGetDetailedReactionInput;
};

export type QueryPolarisGetEarliestOnboardedProjectForCloudIdArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPolarisGetEarliestViewViewedForUserArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPolarisGetReactionsArgs = {
    input: PolarisGetReactionsInput;
};

export type QueryPolarisIdeaTemplatesArgs = {
    project: Scalars["ID"]["input"];
};

export type QueryPolarisInsightArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPolarisInsightsArgs = {
    container?: InputMaybe<Scalars["ID"]["input"]>;
    project: Scalars["ID"]["input"];
};

export type QueryPolarisInsightsWithErrorsArgs = {
    project: Scalars["ID"]["input"];
};

export type QueryPolarisLabelsArgs = {
    projectID: Scalars["ID"]["input"];
};

export type QueryPolarisProjectArgs = {
    id: Scalars["ID"]["input"];
    skipRefresh?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPolarisSnippetPropertiesConfigArgs = {
    groupId: Scalars["String"]["input"];
    oauthClientId: Scalars["String"]["input"];
    project: Scalars["ID"]["input"];
};

export type QueryPolarisViewArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPolarisViewArrangementInfoArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryPopularFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    timeGranularity?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPricingArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryPricingsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryProductListingArgs = {
    id: Scalars["ID"]["input"];
    locales?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryProductListingsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
    locales?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryPtpageArgs = {
    enablePaging?: InputMaybe<Scalars["Boolean"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    pageTree?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<PtGraphQlPageStatus>>>;
};

export type QueryPublicLinkPageArgs = {
    pageId: Scalars["ID"]["input"];
};

export type QueryPublicLinkPermissionsForObjectArgs = {
    objectId: Scalars["ID"]["input"];
    objectType: PublicLinkPermissionsObjectType;
};

export type QueryPublicLinkSpaceArgs = {
    spaceId: Scalars["ID"]["input"];
};

export type QueryPublicLinkSpacesByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
    orderBy?: InputMaybe<PublicLinkSpacesByCriteriaOrder>;
    spaceNamePattern?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<PublicLinkSpaceStatus>>;
};

export type QueryPublicLinksByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isAscending?: InputMaybe<Scalars["Boolean"]["input"]>;
    orderBy?: InputMaybe<PublicLinksByCriteriaOrder>;
    spaceId: Scalars["ID"]["input"];
    status?: InputMaybe<Array<InputMaybe<PublicLinkStatus>>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryPublishConditionsArgs = {
    contentId: Scalars["ID"]["input"];
};

export type QueryQuickReloadArgs = {
    pageId: Scalars["Long"]["input"];
    since: Scalars["Long"]["input"];
};

export type QueryRadar_FieldValuesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    rql?: InputMaybe<Scalars["String"]["input"]>;
    uniqueFieldId: Scalars["ID"]["input"];
};

export type QueryRadar_GroupMetricsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    rql?: InputMaybe<Scalars["String"]["input"]>;
    uniqueFieldIdIsIn: Array<Scalars["ID"]["input"]>;
};

export type QueryRadar_PositionByAriArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryRadar_PositionsByArisArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryRadar_PositionsSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    fieldIdIsIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    rql?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryRadar_WorkerByAriArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryRadar_WorkersByArisArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

export type QueryRadar_WorkspaceArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type QueryReactedUsersArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    containerId: Scalars["String"]["input"];
    containerType: ContainerType;
    contentId: Scalars["String"]["input"];
    contentType: GraphQlReactionContentType;
    emojiId: Scalars["String"]["input"];
};

export type QueryReactionsSummaryArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    containerId: Scalars["ID"]["input"];
    containerType?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    contentType: Scalars["String"]["input"];
};

export type QueryReactionsSummaryListArgs = {
    ids: Array<InputMaybe<ReactionsId>>;
};

export type QueryRecentlyViewedSpacesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryReleaseNoteArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryReleaseNotesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    featureFlagEnvironment?: InputMaybe<Scalars["String"]["input"]>;
    featureFlagProject?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<ContentPlatformReleaseNoteFilterOptions>;
    filterByAnnouncementPlan?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: Scalars["Int"]["input"];
    orderBy?: InputMaybe<Scalars["String"]["input"]>;
    productFeatureFlags?: InputMaybe<Scalars["JSON"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    search?: InputMaybe<ContentPlatformSearchOptions>;
    visibleInFedRAMP?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryRenderedContentDumpArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryRepositoryRelationshipsForDevOpsServiceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<DevOpsServiceAndRepositoryRelationshipFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    sort?: InputMaybe<DevOpsServiceAndRepositoryRelationshipSort>;
};

export type QuerySearchTimeseriesCtrArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsSearchEventName>;
    granularity: AnalyticsTimeseriesGranularity;
    searchTerm?: InputMaybe<Scalars["String"]["input"]>;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QuerySearchTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsSearchEventName>;
    granularity: AnalyticsTimeseriesGranularity;
    sortOrder?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QuerySearchesByTermArgs = {
    fromDate: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    period: SearchesByTermPeriod;
    searchFilter?: InputMaybe<Scalars["String"]["input"]>;
    sortDirection: Scalars["String"]["input"];
    sorting: SearchesByTermColumns;
    timezone: Scalars["String"]["input"];
    toDate: Scalars["String"]["input"];
};

export type QuerySearchesWithZeroCtrArgs = {
    fromDate: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    sortDirection?: InputMaybe<Scalars["String"]["input"]>;
    timezone: Scalars["String"]["input"];
    toDate: Scalars["String"]["input"];
};

export type QuerySettings_NavigationCustomisationArgs = {
    entityAri?: InputMaybe<Scalars["ID"]["input"]>;
    ownerAri?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QuerySingleContentArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    shareToken?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    validatedShareToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySingleRestrictedResourceArgs = {
    accessType: ResourceAccessType;
    accountId: Scalars["ID"]["input"];
    resourceId: Scalars["Long"]["input"];
};

export type QuerySitePermissionsArgs = {
    operations?: InputMaybe<Array<InputMaybe<SitePermissionOperationType>>>;
    permissionTypes?: InputMaybe<Array<InputMaybe<SitePermissionType>>>;
};

export type QuerySiteSettingsArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QuerySnippetsArgs = {
    accountId: Scalars["String"]["input"];
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    scope?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySoftwareBoardsArgs = {
    projectAri: Scalars["ID"]["input"];
};

export type QuerySpaceArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    identifier?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    pageId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QuerySpaceContextContentCreationMetadataArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type QuerySpaceHomepageArgs = {
    spaceKey: Scalars["String"]["input"];
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySpaceManagerArgs = {
    input: SpaceManagerQueryInput;
};

export type QuerySpacePermissionsArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type QuerySpacePermissionsAllArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySpacePopularFeedArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId: Scalars["ID"]["input"];
};

export type QuerySpaceRoleAssignmentsByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    principalTypes?: InputMaybe<Array<InputMaybe<PrincipalFilterType>>>;
    spaceId: Scalars["Long"]["input"];
    spaceRoleIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QuerySpaceRoleAssignmentsByPrincipalArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    principal: RoleAssignmentPrincipalInput;
    spaceId: Scalars["Long"]["input"];
};

export type QuerySpaceRolesByCriteriaArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    principal?: InputMaybe<RoleAssignmentPrincipalInput>;
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type QuerySpaceRolesBySpaceArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId: Scalars["Long"]["input"];
};

export type QuerySpaceSidebarLinksArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpaceThemeArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpaceWatchersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type QuerySpacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    assignedToGroupId?: InputMaybe<Scalars["String"]["input"]>;
    assignedToGroupName?: InputMaybe<Scalars["String"]["input"]>;
    assignedToUser?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    creatorAccountIds?: InputMaybe<
        Array<InputMaybe<Scalars["String"]["input"]>>
    >;
    excludeTypes?: InputMaybe<Scalars["String"]["input"]>;
    favourite?: InputMaybe<Scalars["Boolean"]["input"]>;
    favouriteUserAccountId?: InputMaybe<Scalars["String"]["input"]>;
    favouriteUserKey?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    label?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    spaceKeys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    spaceNamePattern?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    watchedByAccountId?: InputMaybe<Scalars["String"]["input"]>;
    watchedSpacesOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QuerySpacesWithExemptionsArgs = {
    spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
};

export type QuerySqlSchemaSizeLogArgs = {
    appId: Scalars["ID"]["input"];
    installationId: Scalars["ID"]["input"];
};

export type QuerySqlSlowQueryLogsArgs = {
    appId: Scalars["ID"]["input"];
    installationId: Scalars["ID"]["input"];
    interval: QueryInterval;
    queryType: Array<QueryType>;
};

export type QueryStalePagesArgs = {
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    includePagesWithChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastActivityEarlierThan: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    pageStatus?: InputMaybe<StalePageStatus>;
    sort?: InputMaybe<StalePagesSortingType>;
    spaceId: Scalars["ID"]["input"];
};

export type QuerySuggestedSpacesArgs = {
    connections?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryTeamLabelsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryTemplateArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTemplateBodiesArgs = {
    ids?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryTemplateCategoriesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryTemplateCollectionArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTemplateCollectionsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryTemplateInfoArgs = {
    id: Scalars["ID"]["input"];
};

export type QueryTemplateMediaSessionArgs = {
    collectionId?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    templateIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryTemplatesArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryTenantArgs = {
    current?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTenantContextsArgs = {
    activationIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    cloudIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    hostNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type QueryTimeseriesCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    granularity: AnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryTimeseriesPageBlogCountArgs = {
    contentAction: ContentAction;
    contentType: AnalyticsContentType;
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    granularity: AnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryTimeseriesUniqueUserCountArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName: Array<AnalyticsEventName>;
    granularity: AnalyticsTimeseriesGranularity;
    spaceId?: InputMaybe<Array<Scalars["String"]["input"]>>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryTopRelevantUsersArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    eventName?: InputMaybe<Array<InputMaybe<AnalyticsEventName>>>;
    sortOrder?: InputMaybe<RelevantUsersSortOrder>;
    spaceId: Array<Scalars["String"]["input"]>;
    startTime?: InputMaybe<Scalars["String"]["input"]>;
    userFilter?: InputMaybe<RelevantUserFilter>;
};

export type QueryTopicOverviewArgs = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    publishedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryTopicOverviewsArgs = {
    search: ContentPlatformSearchApIv2Query;
};

export type QueryTotalSearchCtrArgs = {
    endTime?: InputMaybe<Scalars["String"]["input"]>;
    startTime: Scalars["String"]["input"];
    timezone: Scalars["String"]["input"];
};

export type QueryTownsquareUnsharded_AllWorkspaceSummariesForOrgArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryUserArgs = {
    accountId: Scalars["ID"]["input"];
};

export type QueryUserAccessStatusArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryUserGroupSearchArgs = {
    maxResults?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
    sitePermissionTypeFilter?: InputMaybe<SitePermissionTypeFilter>;
};

export type QueryUserWithContentRestrictionsArgs = {
    accountId?: InputMaybe<Scalars["String"]["input"]>;
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryUsersArgs = {
    accountIds: Array<Scalars["ID"]["input"]>;
};

export type QueryUsersWithContentRestrictionsArgs = {
    accountIds: Array<InputMaybe<Scalars["String"]["input"]>>;
    contentId: Scalars["ID"]["input"];
};

export type QueryValidateConvertPageToLiveEditArgs = {
    input: ValidateConvertPageToLiveEditInput;
};

export type QueryValidatePageCopyArgs = {
    input: ValidatePageCopyInput;
};

export type QueryValidatePagePublishArgs = {
    id: Scalars["ID"]["input"];
    status?: InputMaybe<Scalars["String"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryValidateSpaceKeyArgs = {
    generateUniqueKey?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceKey: Scalars["String"]["input"];
    validateUniqueness?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryValidateTitleForCreateArgs = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    title: Scalars["String"]["input"];
};

export type QueryWebItemSectionsArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    locations?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWebItemsArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    section?: InputMaybe<Scalars["String"]["input"]>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWebPanelsArgs = {
    contentId?: InputMaybe<Scalars["ID"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    locations?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWebTriggerUrlsByAppContextArgs = {
    appId: Scalars["ID"]["input"];
    contextId: Scalars["ID"]["input"];
    envId: Scalars["ID"]["input"];
};

export type QueryError = {
    __typename?: "QueryError";
    /**
     * Contains extra data describing the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /**
     * The ID of the requested object, or null when the ID is not available.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    identifier?: Maybe<Scalars["ID"]["output"]>;
    /**
     * A message describing the error.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type QueryErrorExtension = {
    /**
     * A code representing the type of error. See the CompassErrorType enum for possible values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (such as an HTTP status code) representing the error category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** #################### INPUT SQLSlowQuery ##################### */
export type QueryInterval = {
    /** The end time of the interval */
    endTime: Scalars["String"]["input"];
    /** The start time of the interval */
    startTime: Scalars["String"]["input"];
};

/** --------------------------------------------------------------------------------------------- */
export type QueryPayload = {
    /** A list of errors if the query was not successful */
    errors?: Maybe<Array<QueryError>>;
    /** Was this query successful */
    success: Scalars["Boolean"]["output"];
};

/** Entry point for query suggestion */
export type QuerySuggestionApi = {
    __typename?: "QuerySuggestionAPI";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    suggest?: Maybe<QuerySuggestionItemConnection>;
};

/** Entry point for query suggestion */
export type QuerySuggestionApiSuggestArgs = {
    analytics?: InputMaybe<QuerySuggestionAnalyticsInput>;
    experience?: InputMaybe<Scalars["String"]["input"]>;
    filters: QuerySuggestionFilterInput;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
};

/** Metadata on any analytics related fields, these do not affect the search */
export type QuerySuggestionAnalyticsInput = {
    queryVersion?: InputMaybe<Scalars["Int"]["input"]>;
    searchReferrerId?: InputMaybe<Scalars["String"]["input"]>;
    searchSessionId?: InputMaybe<Scalars["String"]["input"]>;
    /** The product which is running the experience e.g. confluence. */
    sourceProduct?: InputMaybe<Scalars["String"]["input"]>;
};

/** Filters to apply to query suggestions */
export type QuerySuggestionFilterInput = {
    /**
     * ATI strings of which entities to search for. In this context, these entities correspond to the 'product.indexType'.
     * For our specific use case, they should be represented as 'query-suggestion.query-suggestion-item'.
     * These inputs are sent to the 'xpsearch-aggregator' to perform a search in the content index."
     */
    entities: Array<Scalars["String"]["input"]>;
    /** ARIs of which cloudIds or orgs to search in */
    locations: Array<Scalars["String"]["input"]>;
};

export type QuerySuggestionItemConnection = {
    __typename?: "QuerySuggestionItemConnection";
    /** The list of suggested queries and its type. */
    nodes?: Maybe<Array<Maybe<QuerySuggestionResultNode>>>;
    /** The total number of suggested queries. */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type QuerySuggestionResultNode = {
    __typename?: "QuerySuggestionResultNode";
    /** The title of the suggested queris. */
    title?: Maybe<Scalars["String"]["output"]>;
    /** The type of the suggested queris. */
    type?: Maybe<Scalars["String"]["output"]>;
};

export enum QueryType {
    All = "ALL",
    Delete = "DELETE",
    Insert = "INSERT",
    Other = "OTHER",
    Select = "SELECT",
    Update = "UPDATE"
}

export type QuickReload = {
    __typename?: "QuickReload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    comments: Array<QuickReloadComment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editorPersonForPage?: Maybe<ConfluencePerson>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    time: Scalars["Long"]["output"];
};

export type QuickReloadComment = {
    __typename?: "QuickReloadComment";
    asyncRenderSafe: Scalars["Boolean"]["output"];
    comment: Comment;
    primaryActions: Array<Maybe<CommentUserAction>>;
    secondaryActions: Array<Maybe<CommentUserAction>>;
};

export type QuotaInfo = {
    __typename?: "QuotaInfo";
    contextAri: Scalars["ID"]["output"];
    encrypted: Scalars["Boolean"]["output"];
    quotaUsage: Scalars["Int"]["output"];
};

export type RadarAriFieldValue = {
    __typename?: "RadarAriFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<RadarAriObject>;
};

export type RadarAriObject = MercuryFocusArea | RadarPosition | RadarWorker;

export type RadarBooleanFieldValue = {
    __typename?: "RadarBooleanFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RadarConnection = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount: Scalars["Int"]["output"];
};

export type RadarDateFieldValue = {
    __typename?: "RadarDateFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["DateTime"]["output"]>;
};

/** A filter where the possible values will be loaded at runtime */
export type RadarDynamicFilterOptions = RadarFilterOptions & {
    __typename?: "RadarDynamicFilterOptions";
    /**
     * The supported functions for the filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    functions: Array<RadarFunctionId>;
    /**
     * Denotes whether the filter options should be shown or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The supported operators for the filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    operators: Array<RadarFilterOperators>;
    /**
     * Whether the filter supports multiple values, or how those values are joined
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    plurality: RadarFilterPlurality;
    /**
     * The type of input the for the filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: RadarFilterInputType;
};

/**
 *  ===========================================================
 *  Common Schema, keep this independent from Radar terminology.
 *  ===========================================================
 */
export type RadarEdge = {
    cursor: Scalars["String"]["output"];
};

export type RadarEntity = {
    /** An internal uuid for the entity, this is not an ARI */
    entityId: Scalars["ID"]["output"];
    /** A list of fieldId, fieldValue pairs for this Radar entity */
    fieldValues: Array<RadarFieldValueIdPair>;
    /** The unique ID of this node. This is an ARI for some entities and an entityId for others */
    id: Scalars["ID"]["output"];
    /** The type of entity */
    type?: Maybe<RadarEntityType>;
};

/**
 *  ========================================
 *                 Entity
 *  ========================================
 */
export enum RadarEntityType {
    FocusArea = "focusArea",
    Position = "position",
    Worker = "worker"
}

export type RadarFieldDefinition = {
    /**
     * Denotes the default position of the field in the column order
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    defaultOrder?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The displayName for the this field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The entity this field is on
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    entity: RadarEntityType;
    /**
     * Options for what values this field allows for filtering
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    filterOptions: RadarFilterOptions;
    /**
     * A id that is unique across all fields across all entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Denotes whether the field is a custom or system field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isCustom: Scalars["Boolean"]["output"];
    /**
     * Denotes where the field can be used to group entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isGroupable: Scalars["Boolean"]["output"];
    /**
     * Denotes whether the field should be shown or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A id that is unique across this entity but not necessarily other entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    relativeId: Scalars["String"]["output"];
    /**
     * The type of field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: RadarFieldType;
};

/** We may include USER or OBJECT at a later time. Until then they're just UrlFields */
export enum RadarFieldType {
    Ari = "ARI",
    Boolean = "BOOLEAN",
    Datetime = "DATETIME",
    Number = "NUMBER",
    Status = "STATUS",
    String = "STRING",
    Url = "URL"
}

export type RadarFieldValue =
    | RadarAriFieldValue
    | RadarBooleanFieldValue
    | RadarDateFieldValue
    | RadarNumericFieldValue
    | RadarStatusFieldValue
    | RadarStringFieldValue
    | RadarUrlFieldValue;

export type RadarFieldValueIdPair = {
    __typename?: "RadarFieldValueIdPair";
    /** The unique ID of this field */
    fieldId: Scalars["ID"]["output"];
    /** The value for this field */
    fieldValue: RadarFieldValue;
};

export type RadarFieldValuesConnection = RadarConnection & {
    __typename?: "RadarFieldValuesConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<RadarFieldValuesEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<RadarFieldValue>>;
    /**
     * Pagination information
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     * Total # values
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount: Scalars["Int"]["output"];
};

export type RadarFieldValuesEdge = RadarEdge & {
    __typename?: "RadarFieldValuesEdge";
    cursor: Scalars["String"]["output"];
    node: RadarFieldValue;
};

export enum RadarFilterInputType {
    Checkbox = "CHECKBOX",
    Radio = "RADIO",
    Range = "RANGE",
    Textfield = "TEXTFIELD"
}

export enum RadarFilterOperators {
    Equals = "EQUALS",
    GreaterThan = "GREATER_THAN",
    GreaterThanOrEqual = "GREATER_THAN_OR_EQUAL",
    LessThan = "LESS_THAN",
    LessThanOrEqual = "LESS_THAN_OR_EQUAL",
    Like = "LIKE",
    NotEquals = "NOT_EQUALS",
    NotLike = "NOT_LIKE"
}

export type RadarFilterOptions = {
    /** The supported functions for the filter */
    functions: Array<RadarFunctionId>;
    /** Denotes whether the filter options should be shown or not */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /** The supported operators for the filter */
    operators: Array<RadarFilterOperators>;
    /** Whether the filter supports multiple values, or how those values are joined */
    plurality: RadarFilterPlurality;
    /** The type of input for the filter */
    type: RadarFilterInputType;
};

export enum RadarFilterPlurality {
    And = "AND",
    /** Tenure in (3, 4, 5) */
    None = "NONE",
    /** Tenure > 3 and Tenure < 5 */
    Or = "OR"
}

export type RadarFocusAreaMappingsInput = {
    /** Focus Area ARI mapping */
    focusAreaAri?: InputMaybe<Scalars["ID"]["input"]>;
    /** Position ARI */
    positionAri: Scalars["ID"]["input"];
};

/**
 *  ========================================
 *                 Functions
 *  ========================================
 */
export type RadarFunction = {
    __typename?: "RadarFunction";
    /** The type of arguments supported */
    argType: RadarFieldType;
    /** A id that is unique across all functions */
    id: RadarFunctionId;
    /** The maximum number of args required for the function, undefined if no maximum */
    maxArgs?: Maybe<Scalars["Int"]["output"]>;
    /** The minimum number of args required for the function, undefined if no minimum */
    minArgs?: Maybe<Scalars["Int"]["output"]>;
    /** The list of operators this function can be used with */
    operators: Array<RadarFilterOperators>;
};

export enum RadarFunctionId {
    Haschild = "HASCHILD",
    Under = "UNDER"
}

/** Group of entities with the same field value */
export type RadarGroupMetrics = {
    __typename?: "RadarGroupMetrics";
    /** The total number of rows in a group */
    count: Scalars["Int"]["output"];
    /** The id and value of the field we're grouping by */
    field: RadarFieldValueIdPair;
    /**
     * The metrics for the sub groups
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RadarGroupMetricsSubGroups")' query directive to the 'subGroups' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    subGroups?: Maybe<RadarGroupMetricsConnection>;
};

/** Group of entities with the same field value */
export type RadarGroupMetricsSubGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *  ========================================
 *              Group Metrics
 *  ========================================
 */
export type RadarGroupMetricsConnection = RadarConnection & {
    __typename?: "RadarGroupMetricsConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<RadarGroupMetricsEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<RadarGroupMetrics>>;
    /**
     * Pagination information
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     * Total # rows across all groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    rowCount: Scalars["Int"]["output"];
    /**
     * Total # of groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount: Scalars["Int"]["output"];
};

export type RadarGroupMetricsEdge = RadarEdge & {
    __typename?: "RadarGroupMetricsEdge";
    cursor: Scalars["String"]["output"];
    node: RadarGroupMetrics;
};

/**
 *  ========================================
 *           Mutation Return Types
 *  ========================================
 */
export type RadarMutationResponse = {
    __typename?: "RadarMutationResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RadarNonNumericFieldDefinition = RadarFieldDefinition & {
    __typename?: "RadarNonNumericFieldDefinition";
    /**
     * Denotes the default position of the field in the column order
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    defaultOrder?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The displayName for the this field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The entity this field is on
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    entity: RadarEntityType;
    /**
     * Options for what values this field allows for filtering
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    filterOptions: RadarFilterOptions;
    /**
     * A id that is unique across all fields across all entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Denotes whether the field is a custom or system field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isCustom: Scalars["Boolean"]["output"];
    /**
     * Denotes where the field can be used to group entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isGroupable: Scalars["Boolean"]["output"];
    /**
     * Denotes whether the field should be shown or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A id that is unique across this entity but not necessarily other entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    relativeId: Scalars["String"]["output"];
    /**
     * The type of field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: RadarFieldType;
};

export enum RadarNumericAppearance {
    Duration = "DURATION",
    Number = "NUMBER"
}

export type RadarNumericFieldDefinition = RadarFieldDefinition & {
    __typename?: "RadarNumericFieldDefinition";
    /**
     * The appearance of the field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appearance: RadarNumericAppearance;
    /**
     * Denotes the default position of the field in the column order
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    defaultOrder?: Maybe<Scalars["Int"]["output"]>;
    /**
     * The displayName for the this field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     * The entity this field is on
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    entity: RadarEntityType;
    /**
     * Options for what values this field allows for filtering
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    filterOptions: RadarFilterOptions;
    /**
     * A id that is unique across all fields across all entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Denotes whether the field is a custom or system field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isCustom: Scalars["Boolean"]["output"];
    /**
     * Denotes where the field can be used to group entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isGroupable: Scalars["Boolean"]["output"];
    /**
     * Denotes whether the field should be shown or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * A id that is unique across this entity but not necessarily other entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    relativeId: Scalars["String"]["output"];
    /**
     * The type of field
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: RadarFieldType;
};

export type RadarNumericFieldValue = {
    __typename?: "RadarNumericFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayValue?: Maybe<Scalars["Int"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["Int"]["output"]>;
};

/**
 *  ========================================
 *                 Position
 *  ========================================
 *  The Atlassian Resource Identifier of this Radar position
 */
export type RadarPosition = Node &
    RadarEntity & {
        __typename?: "RadarPosition";
        /**
         * Get position's directly reporting to this position, this can be null if the position is not a manager, or empty if the position is a manager without any reports.
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "RadarPositionsByAris")' query directive to the 'directReports' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        directReports?: Maybe<Array<RadarPosition>>;
        /** An internal uuid for the entity, this is not an ARI */
        entityId: Scalars["ID"]["output"];
        /** A list of fieldId, fieldValue pairs for this Position entity */
        fieldValues: Array<RadarFieldValueIdPair>;
        /** The unique ID of this Radar position */
        id: Scalars["ID"]["output"];
        /** Indicates if the position has direct reports */
        isManager: Scalars["Boolean"]["output"];
        /**
         * Get a position's manager, this can be null if the position does not have a manager
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "RadarPositionByAri")' query directive to the 'manager' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        manager?: Maybe<RadarPosition>;
        /**
         * Get a position's manager hierarchy starting from their direct manager to their top level manager
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "RadarPositionsByAris")' query directive to the 'reportingLine' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        reportingLine?: Maybe<Array<RadarPosition>>;
        /** The type of entity */
        type?: Maybe<RadarEntityType>;
        /**
         * When the position is filled, represents the worker currently filling the position
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "RadarWorkersByAris")' query directive to the 'worker' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        worker?: Maybe<RadarWorker>;
    };

/** A connection to a paginated list of positions. */
export type RadarPositionConnection = RadarConnection & {
    __typename?: "RadarPositionConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<RadarPositionEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<RadarPosition>>;
    /**
     * Pagination information
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     * Total # positions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount: Scalars["Int"]["output"];
};

export type RadarPositionEdge = RadarEdge & {
    __typename?: "RadarPositionEdge";
    cursor: Scalars["String"]["output"];
    node: RadarPosition;
};

/** A filter where the possible values are a constant */
export type RadarStaticStringFilterOptions = RadarFilterOptions & {
    __typename?: "RadarStaticStringFilterOptions";
    /**
     * The supported functions for the filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    functions: Array<RadarFunctionId>;
    /**
     * Denotes whether the filter options should be shown or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The supported operators for the filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    operators: Array<RadarFilterOperators>;
    /**
     * Whether the filter supports multiple values, or how those values are joined
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    plurality: RadarFilterPlurality;
    /**
     * The type of input the for the filter
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type: RadarFilterInputType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    values?: Maybe<Array<Maybe<RadarFieldValue>>>;
};

export enum RadarStatusAppearance {
    Default = "default",
    Inprogress = "inprogress",
    Moved = "moved",
    New = "new",
    Removed = "removed",
    Success = "success"
}

export type RadarStatusFieldValue = {
    __typename?: "RadarStatusFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appearance?: Maybe<RadarStatusAppearance>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayValue?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

/**
 *  ========================================
 *                 Fields
 *  ========================================
 *  GA - FieldValues will include an additional property to denote when a value has been omitted due to row level security
 */
export type RadarStringFieldValue = {
    __typename?: "RadarStringFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

export type RadarUrlFieldValue = {
    __typename?: "RadarUrlFieldValue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    displayValue?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    icon?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Data related to the currently logged in user (position data, etc.) */
export type RadarUserContext = {
    __typename?: "RadarUserContext";
    /** Position of the currently logged in user */
    position?: Maybe<RadarPosition>;
};

/**
 *  ========================================
 *                 Worker
 *  ========================================
 */
export type RadarWorker = Node &
    RadarEntity & {
        __typename?: "RadarWorker";
        /** An internal uuid for the entity, this is not an ARI */
        entityId: Scalars["ID"]["output"];
        /** A list of fieldId, fieldValue pairs for this Worker entity */
        fieldValues: Array<RadarFieldValueIdPair>;
        /** The Atlassian Resource Identifier of this Radar worker */
        id: Scalars["ID"]["output"];
        /** Preferred name of the worker */
        preferredName?: Maybe<Scalars["String"]["output"]>;
        /** The type of entity */
        type: RadarEntityType;
    };

/** A connection to a paginated list of positions. */
export type RadarWorkerConnection = RadarConnection & {
    __typename?: "RadarWorkerConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<RadarWorkerEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    nodes?: Maybe<Array<RadarWorker>>;
    /**
     * Pagination information
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
    /**
     * Total # workers
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    totalCount: Scalars["Int"]["output"];
};

export type RadarWorkerEdge = RadarEdge & {
    __typename?: "RadarWorkerEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node: RadarWorker;
};

/**
 *  ========================================
 *                 Other
 *  ========================================
 *  Data about this workspace. This will expose what fields each Entity has available as well as any other additional metadata
 */
export type RadarWorkspace = {
    __typename?: "RadarWorkspace";
    /**
     * The activation ID for the workspace
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    entityId: Scalars["ID"]["output"];
    /**
     * A list of fields the focus area entity supports
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    focusAreaFields: Array<RadarFieldDefinition>;
    /**
     * A list of fields the focus area type entity supports
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    focusAreaTypeFields: Array<RadarFieldDefinition>;
    /**
     * A list of functions the workspace supports
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    functions: Array<RadarFunction>;
    /**
     * The unique id for the workspace. This is an ARI
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * A list of fields the position entity supports
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    positionFields: Array<RadarFieldDefinition>;
    /**
     * context of the currently logged in user - if applicable
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userContext?: Maybe<RadarUserContext>;
};

export type RankColumnInput = {
    boardId: Scalars["ID"]["input"];
    columnId: Scalars["ID"]["input"];
    position: Scalars["Int"]["input"];
};

export type RankColumnOutput = MutationResponse & {
    __typename?: "RankColumnOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    columns?: Maybe<Array<Maybe<Column>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type RankCustomFilterInput = {
    afterFilterId?: InputMaybe<Scalars["String"]["input"]>;
    boardId: Scalars["ID"]["input"];
    id: Scalars["String"]["input"];
};

export type RankItem = {
    __typename?: "RankItem";
    id: Scalars["ID"]["output"];
    rank: Scalars["Float"]["output"];
};

export type RankingDiffPayload = {
    __typename?: "RankingDiffPayload";
    added?: Maybe<Array<RankItem>>;
    changed?: Maybe<Array<RankItem>>;
    deleted?: Maybe<Array<RankItem>>;
};

export type RateLimitPolicyProperty = {
    argumentPath: Scalars["String"]["input"];
    useCloudIdFromARI?: Scalars["Boolean"]["input"];
};

export enum RateLimitingCurrency {
    CannedResponseMutationCurrency = "CANNED_RESPONSE_MUTATION_CURRENCY",
    CannedResponseQueryCurrency = "CANNED_RESPONSE_QUERY_CURRENCY",
    CompassSynchronizeLinkAssociationsCurrency = "COMPASS_SYNCHRONIZE_LINK_ASSOCIATIONS_CURRENCY",
    DevopsContainerRelationshipsReadCurrency = "DEVOPS_CONTAINER_RELATIONSHIPS_READ_CURRENCY",
    DevopsContainerRelationshipsWriteCurrency = "DEVOPS_CONTAINER_RELATIONSHIPS_WRITE_CURRENCY",
    DevopsServiceReadCurrency = "DEVOPS_SERVICE_READ_CURRENCY",
    DevopsServiceWriteCurrency = "DEVOPS_SERVICE_WRITE_CURRENCY",
    ExportMetricsCurrency = "EXPORT_METRICS_CURRENCY",
    ForgeAlertsCurrency = "FORGE_ALERTS_CURRENCY",
    ForgeAppContributorCurrency = "FORGE_APP_CONTRIBUTOR_CURRENCY",
    ForgeAuditLogsCurrency = "FORGE_AUDIT_LOGS_CURRENCY",
    ForgeMetricsCurrency = "FORGE_METRICS_CURRENCY",
    HelpCenterCurrency = "HELP_CENTER_CURRENCY",
    HelpLayoutCurrency = "HELP_LAYOUT_CURRENCY",
    HelpObjectStoreCurrency = "HELP_OBJECT_STORE_CURRENCY",
    KnowledgeBaseCurrency = "KNOWLEDGE_BASE_CURRENCY",
    PolarisBetaUserCurrency = "POLARIS_BETA_USER_CURRENCY",
    PolarisCollabTokenQueryCurrency = "POLARIS_COLLAB_TOKEN_QUERY_CURRENCY",
    PolarisCommentCurrency = "POLARIS_COMMENT_CURRENCY",
    PolarisCurrency = "POLARIS_CURRENCY",
    PolarisFieldCurrency = "POLARIS_FIELD_CURRENCY",
    PolarisIdeaCurrency = "POLARIS_IDEA_CURRENCY",
    PolarisIdeaTemplatesQueryCurrency = "POLARIS_IDEA_TEMPLATES_QUERY_CURRENCY",
    PolarisIdeaTemplateCurrency = "POLARIS_IDEA_TEMPLATE_CURRENCY",
    PolarisInsightsQueryCurrency = "POLARIS_INSIGHTS_QUERY_CURRENCY",
    PolarisInsightsWithErrorsQueryCurrency = "POLARIS_INSIGHTS_WITH_ERRORS_QUERY_CURRENCY",
    PolarisInsightCurrency = "POLARIS_INSIGHT_CURRENCY",
    PolarisInsightQueryCurrency = "POLARIS_INSIGHT_QUERY_CURRENCY",
    PolarisLabelsQueryCurrency = "POLARIS_LABELS_QUERY_CURRENCY",
    PolarisOnboardingCurrency = "POLARIS_ONBOARDING_CURRENCY",
    PolarisPlayCurrency = "POLARIS_PLAY_CURRENCY",
    PolarisProjectConfigCurrency = "POLARIS_PROJECT_CONFIG_CURRENCY",
    PolarisProjectQueryCurrency = "POLARIS_PROJECT_QUERY_CURRENCY",
    PolarisRankingCurrency = "POLARIS_RANKING_CURRENCY",
    PolarisReactionCurrency = "POLARIS_REACTION_CURRENCY",
    PolarisSnippetCurrency = "POLARIS_SNIPPET_CURRENCY",
    PolarisSnippetPropertiesConfigQueryCurrency = "POLARIS_SNIPPET_PROPERTIES_CONFIG_QUERY_CURRENCY",
    PolarisUnfurlCurrency = "POLARIS_UNFURL_CURRENCY",
    PolarisViewsetCurrency = "POLARIS_VIEWSET_CURRENCY",
    /** Depraecated currency */
    PolarisViewArrangementInfoQueryCurrency = "POLARIS_VIEW_ARRANGEMENT_INFO_QUERY_CURRENCY",
    PolarisViewCurrency = "POLARIS_VIEW_CURRENCY",
    PolarisViewQueryCurrency = "POLARIS_VIEW_QUERY_CURRENCY",
    PolarisWriteCurrency = "POLARIS_WRITE_CURRENCY",
    TeamsCurrency = "TEAMS_CURRENCY",
    TeamMembersCurrency = "TEAM_MEMBERS_CURRENCY",
    TeamMembersV2Currency = "TEAM_MEMBERS_V2_CURRENCY",
    TeamRoleGrantsMutatePrincipalsCurrency = "TEAM_ROLE_GRANTS_MUTATE_PRINCIPALS_CURRENCY",
    TeamRoleGrantsQueryPrincipalsCurrency = "TEAM_ROLE_GRANTS_QUERY_PRINCIPALS_CURRENCY",
    TeamSearchCurrency = "TEAM_SEARCH_CURRENCY",
    /** This isn't used anywhere but we're keeping it around so pipelines don't break */
    TeamSearchV2Currency = "TEAM_SEARCH_V2_CURRENCY",
    TeamV2Currency = "TEAM_V2_CURRENCY",
    TestingService = "TESTING_SERVICE",
    TrelloCurrency = "TRELLO_CURRENCY",
    TrelloMutationCurrency = "TRELLO_MUTATION_CURRENCY"
}

/** Represents a status object from a workflow in Jira without any calculcated fields */
export type RawStatus = {
    __typename?: "RawStatus";
    /** Which status category this statue belongs to */
    category?: Maybe<Scalars["String"]["output"]>;
    /** Unique identifier of the status, in UUID type */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Jira's Id of the status */
    jiraId?: Maybe<Scalars["ID"]["output"]>;
    /** Name of the status */
    name?: Maybe<Scalars["String"]["output"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ReactedUsersResponse = {
    __typename?: "ReactedUsersResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    confluencePerson: Array<Maybe<ConfluencePerson>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    containerAri: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    count: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    emojiId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reacted: Scalars["Boolean"]["output"];
};

export type ReactionsId = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    containerId: Scalars["ID"]["input"];
    containerType: Scalars["String"]["input"];
    contentId: Scalars["ID"]["input"];
    contentType: Scalars["String"]["input"];
};

export type ReactionsSummaryForEmoji = {
    __typename?: "ReactionsSummaryForEmoji";
    count: Scalars["Int"]["output"];
    emojiId: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    reacted: Scalars["Boolean"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type ReactionsSummaryResponse = {
    __typename?: "ReactionsSummaryResponse";
    ari: Scalars["String"]["output"];
    containerAri: Scalars["String"]["output"];
    reactionsCount: Scalars["Int"]["output"];
    reactionsSummaryForEmoji: Array<Maybe<ReactionsSummaryForEmoji>>;
};

export type ReattachInlineCommentInput = {
    commentId: Scalars["ID"]["input"];
    containerId: Scalars["ID"]["input"];
    lastFetchTimeMillis: Scalars["Long"]["input"];
    /** matchIndex must be greater than or equal to 0. */
    matchIndex: Scalars["Int"]["input"];
    /** numMatches must be positive and greater than matchIndex. */
    numMatches: Scalars["Int"]["input"];
    originalSelection: Scalars["String"]["input"];
    publishedVersion?: InputMaybe<Scalars["Int"]["input"]>;
    step?: InputMaybe<Step>;
};

export enum RecentFilter {
    All = "ALL",
    Created = "CREATED",
    WorkedOn = "WORKED_ON"
}

export type RecentlyViewedSummary = {
    __typename?: "RecentlyViewedSummary";
    friendlyLastSeen?: Maybe<Scalars["String"]["output"]>;
    lastSeen?: Maybe<Scalars["String"]["output"]>;
};

export enum ReclassificationFilterScope {
    Content = "CONTENT",
    Space = "SPACE",
    Workspace = "WORKSPACE"
}

export type RecommendedFeedUserConfig = {
    __typename?: "RecommendedFeedUserConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPeople: Array<RecommendedPeopleItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedSpaces: Array<RecommendedSpaceItem>;
};

export type RecommendedLabelItem = {
    __typename?: "RecommendedLabelItem";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    namespace: Scalars["String"]["output"];
    strategy: Array<Scalars["String"]["output"]>;
};

export type RecommendedLabels = {
    __typename?: "RecommendedLabels";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedLabels: Array<Maybe<RecommendedLabelItem>>;
};

export type RecommendedPages = {
    __typename?: "RecommendedPages";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPages: Array<RecommendedPagesItem>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: RecommendedPagesStatus;
};

export type RecommendedPagesItem = {
    __typename?: "RecommendedPagesItem";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
    contentId: Scalars["ID"]["output"];
    strategy: Array<Scalars["String"]["output"]>;
};

export enum RecommendedPagesSpaceBehavior {
    Hidden = "HIDDEN",
    Shown = "SHOWN"
}

export type RecommendedPagesSpaceStatus = {
    __typename?: "RecommendedPagesSpaceStatus";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    defaultBehavior: RecommendedPagesSpaceBehavior;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSpaceAdmin: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recommendedPagesEnabled: Scalars["Boolean"]["output"];
};

export type RecommendedPagesStatus = {
    __typename?: "RecommendedPagesStatus";
    isEnabled: Scalars["Boolean"]["output"];
    userCanToggle: Scalars["Boolean"]["output"];
};

export type RecommendedPeopleItem = {
    __typename?: "RecommendedPeopleItem";
    accountId: Scalars["String"]["output"];
    score: Scalars["Float"]["output"];
};

export type RecommendedSpaceItem = {
    __typename?: "RecommendedSpaceItem";
    score: Scalars["Float"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'space' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    space?: Maybe<Space>;
    spaceId: Scalars["Long"]["output"];
};

export type RecoverSpaceAdminPermissionInput = {
    spaceKey: Scalars["String"]["input"];
};

export type RecoverSpaceAdminPermissionPayload = Payload & {
    __typename?: "RecoverSpaceAdminPermissionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type RecoverSpaceWithAdminRoleAssignmentInput = {
    spaceId: Scalars["Long"]["input"];
};

export type RecoverSpaceWithAdminRoleAssignmentPayload = Payload & {
    __typename?: "RecoverSpaceWithAdminRoleAssignmentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type RefreshPolarisSnippetsInput = {
    project: Scalars["ID"]["input"];
    /**
     * Specifies a set of snippets to be refreshed for finer-grain control than
     * at the project level (a required property for this API).  This field
     * is optional, and if specified must refer to either an issue, an
     * insight, or a snippet.
     */
    subject?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     * An optional flag indicating whether or not the refresh should be performed
     * synchronously.  By default (if this flag is not included, or if its value
     * is false), the refresh is performed asynchronously.
     */
    synchronous?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RefreshPolarisSnippetsPayload = Payload & {
    __typename?: "RefreshPolarisSnippetsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisRefreshJob>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type RefreshToken = {
    __typename?: "RefreshToken";
    refreshTokenRotation: Scalars["Boolean"]["output"];
};

export type RefreshTokenInput = {
    refreshTokenRotation: Scalars["Boolean"]["input"];
};

/**
 * Establish tunnels for a specific environment of an app.
 *
 * This will create a cloudflare tunnel for forge app debugging
 */
export type RegisterTunnelInput = {
    /** The app to setup a tunnel for */
    appId: Scalars["ID"]["input"];
    /** The environment key */
    environmentKey: Scalars["String"]["input"];
};

/** A response to a cloudflare tunnel creation request */
export type RegisterTunnelResponse = Payload & {
    __typename?: "RegisterTunnelResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tunnelId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tunnelToken?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tunnelUrl?: Maybe<Scalars["String"]["output"]>;
};

export enum RelationSourceType {
    User = "user"
}

export enum RelationTargetType {
    Content = "content",
    Space = "space"
}

export enum RelationType {
    Collaborator = "collaborator",
    Favourite = "favourite",
    Touched = "touched"
}

export type RelevantSpaceUsersWrapper = {
    __typename?: "RelevantSpaceUsersWrapper";
    id?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    users?: Maybe<Array<Maybe<Person>>>;
};

export type RelevantSpacesWrapper = {
    __typename?: "RelevantSpacesWrapper";
    space?: Maybe<RelevantSpaceUsersWrapper>;
};

export enum RelevantUserFilter {
    Collaborators = "collaborators"
}

export enum RelevantUsersSortOrder {
    Asc = "asc",
    Desc = "desc"
}

export type Remote = {
    __typename?: "Remote";
    baseUrl: Scalars["String"]["output"];
    classifications?: Maybe<Array<Classification>>;
    key: Scalars["String"]["output"];
    locations?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type RemoveAppContributorsInput = {
    accountIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    appId: Scalars["ID"]["input"];
    emails?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type RemoveAppContributorsResponsePayload = Payload & {
    __typename?: "RemoveAppContributorsResponsePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for removing labels from a component. */
export type RemoveCompassComponentLabelsInput = {
    /** The ID of the component to remove the labels from. */
    componentId: Scalars["ID"]["input"];
    /** The collection of labels to remove from the component. */
    labelNames: Array<Scalars["String"]["input"]>;
};

/** The payload returned after removing labels from a component. */
export type RemoveCompassComponentLabelsPayload = Payload & {
    __typename?: "RemoveCompassComponentLabelsPayload";
    /** The details of the component that was mutated. */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** The collection of labels that were removed from the component. */
    removedLabelNames?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** The payload returned from removing a scorecard from a component. */
export type RemoveCompassScorecardFromComponentPayload = Payload & {
    __typename?: "RemoveCompassScorecardFromComponentPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type RemoveGroupSpacePermissionsInput = {
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groupNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    spaceKey: Scalars["String"]["input"];
};

export type RemovePublicLinkPermissionsInput = {
    objectId: Scalars["ID"]["input"];
    objectType: PublicLinkPermissionsObjectType;
    permissions: Array<PublicLinkPermissionsType>;
};

export type RemovePublicLinkPermissionsPayload = Payload & {
    __typename?: "RemovePublicLinkPermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type RemoveSpacePermissionsPayload = {
    __typename?: "RemoveSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type RemoveUserSpacePermissionsInput = {
    accountId: Scalars["String"]["input"];
    spaceKey: Scalars["String"]["input"];
};

export type ReopenCommentsMutationErrorExtension = MutationErrorExtension & {
    __typename?: "ReopenCommentsMutationErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type ReplyInlineCommentInput = {
    commentBody: CommentBody;
    commentSource?: InputMaybe<Platform>;
    containerId: Scalars["ID"]["input"];
    createdFrom?: InputMaybe<CommentCreationLocation>;
    parentCommentId: Scalars["ID"]["input"];
};

/** Data for the reports overview page */
export type ReportsOverview = {
    __typename?: "ReportsOverview";
    metadata: Array<Maybe<SoftwareReport>>;
};

export type RequestPageAccessInput = {
    accessType: AccessType;
    pageId: Scalars["String"]["input"];
};

export type RequestPageAccessPayload = {
    __typename?: "RequestPageAccessPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
};

export type ResetExCoSpacePermissionsInput = {
    accountId: Scalars["String"]["input"];
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type ResetExCoSpacePermissionsPayload = {
    __typename?: "ResetExCoSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type ResetSpaceRolesFromAnotherSpaceInput = {
    sourceSpaceId: Scalars["Long"]["input"];
    targetSpaceId: Scalars["Long"]["input"];
};

export type ResetSpaceRolesFromAnotherSpacePayload = Payload & {
    __typename?: "ResetSpaceRolesFromAnotherSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ResetToDefaultSpaceRoleAssignmentsInput = {
    spaceId: Scalars["Long"]["input"];
};

export type ResetToDefaultSpaceRoleAssignmentsPayload = Payload & {
    __typename?: "ResetToDefaultSpaceRoleAssignmentsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ResolveCommentsMutationErrorExtension = MutationErrorExtension & {
    __typename?: "ResolveCommentsMutationErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type ResolveInlineCommentPayload = {
    __typename?: "ResolveInlineCommentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resolveProperties?: Maybe<InlineCommentResolveProperties>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
};

export type ResolvePolarisObjectInput = {
    /** Custom auth token that will be used in unfurl request and saved if request was successful */
    authToken?: InputMaybe<Scalars["String"]["input"]>;
    /** Issue ARI */
    issue: Scalars["ID"]["input"];
    /** Project ARI */
    project: Scalars["ID"]["input"];
    /** Resource url that will be used to unfurl data */
    resourceUrl: Scalars["String"]["input"];
};

export type ResolvePolarisObjectPayload = Payload & {
    __typename?: "ResolvePolarisObjectPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    response?: Maybe<ResolvedPolarisObject>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ResolveRestrictionsForSubjectMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "ResolveRestrictionsForSubjectMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        resourceId: Scalars["Long"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        resourceType: ResourceType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        subject: BlockedAccessSubject;
    };

export type ResolveRestrictionsForSubjectsInput = {
    accessType: ResourceAccessType;
    contentId: Scalars["Long"]["input"];
    subjects: Array<InputMaybe<BlockedAccessSubjectInput>>;
};

export type ResolveRestrictionsInput = {
    accessType: ResourceAccessType;
    accountId: Scalars["ID"]["input"];
    resourceId: Scalars["Long"]["input"];
    resourceType: ResourceType;
};

export type ResolveRestrictionsPayload = Payload & {
    __typename?: "ResolveRestrictionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors: Array<MutationError>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ResolvedPolarisObject = {
    __typename?: "ResolvedPolarisObject";
    auth?: Maybe<ResolvedPolarisObjectAuth>;
    body?: Maybe<Scalars["JSON"]["output"]>;
    externalAuth?: Maybe<Array<ResolvedPolarisObjectExternalAuth>>;
    oauthClientId?: Maybe<Scalars["String"]["output"]>;
    statusCode: Scalars["Int"]["output"];
};

export type ResolvedPolarisObjectAuth = {
    __typename?: "ResolvedPolarisObjectAuth";
    hint?: Maybe<Scalars["String"]["output"]>;
    type: PolarisResolvedObjectAuthType;
};

export type ResolvedPolarisObjectExternalAuth = {
    __typename?: "ResolvedPolarisObjectExternalAuth";
    displayName: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export enum ResourceAccessType {
    Edit = "EDIT",
    View = "VIEW"
}

export enum ResourceType {
    Database = "DATABASE",
    Folder = "FOLDER",
    Page = "PAGE",
    Space = "SPACE",
    Whiteboard = "WHITEBOARD"
}

export enum ResponseType {
    BulletListAdf = "BULLET_LIST_ADF",
    BulletListMarkdown = "BULLET_LIST_MARKDOWN",
    ParagraphPlaintext = "PARAGRAPH_PLAINTEXT"
}

export type RestoreSpacePayload = Payload & {
    __typename?: "RestoreSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type RestrictedResource = {
    __typename?: "RestrictedResource";
    requiredAccessType?: Maybe<ResourceAccessType>;
    resourceId: Scalars["Long"]["output"];
    resourceLink: RestrictedResourceLinks;
    resourceTitle: Scalars["String"]["output"];
    resourceType: ResourceType;
};

export type RestrictedResourceInfo = {
    __typename?: "RestrictedResourceInfo";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canSetPermission?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hasMultipleRestriction?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictedResourceList?: Maybe<Array<Maybe<RestrictedResource>>>;
};

export type RestrictedResourceLinks = {
    __typename?: "RestrictedResourceLinks";
    /** The base URL of the site. */
    base?: Maybe<Scalars["String"]["output"]>;
    webUi?: Maybe<Scalars["String"]["output"]>;
};

export type RetentionDurationInDays = {
    __typename?: "RetentionDurationInDays";
    /** Maximum number of days End-User Data will be stored */
    max: Scalars["Float"]["output"];
    /** Minimum number of days End-User Data will be stored */
    min: Scalars["Float"]["output"];
};

export enum ReverseTrialCohort {
    Control = "CONTROL",
    Enrolled = "ENROLLED",
    NotEnrolled = "NOT_ENROLLED",
    Unassigned = "UNASSIGNED",
    Unknown = "UNKNOWN",
    Variant = "VARIANT"
}

export enum RevertToLegacyEditorResult {
    NotReverted = "NOT_REVERTED",
    Reverted = "REVERTED"
}

/** Input of a roadmap add item mutation. */
export type RoadmapAddItemInput = {
    /** AccountId of the assignee. */
    assignee?: InputMaybe<Scalars["String"]["input"]>;
    /** What color should be shown for this item */
    color?: InputMaybe<RoadmapPaletteColor>;
    /** List of ids of the components on this item */
    componentIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** When this item is due; date in RFC3339 DateTime format */
    dueDate?: InputMaybe<Scalars["Date"]["input"]>;
    /** The type of this item */
    itemTypeId: Scalars["ID"]["input"];
    /** Jql of the board the issue is being created for */
    jql?: InputMaybe<Scalars["String"]["input"]>;
    /** A list of Jql of the board the issue is being created for */
    jqlContexts?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** List of labels to be added to the newly created issue. */
    labels?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The ID of the parent */
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Roadmap project ID; used only to fetch custom fields and won't have any impact on the item itself */
    projectId: Scalars["ID"]["input"];
    /** Item rank request */
    rank?: InputMaybe<RoadmapAddItemRank>;
    /** When this item is set to start; date in RFC3339 DateTime format */
    startDate?: InputMaybe<Scalars["Date"]["input"]>;
    /** The summary of this item */
    summary: Scalars["String"]["input"];
    /** List of ids of the versions on this item */
    versionIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type RoadmapAddItemPayload = Payload & {
    __typename?: "RoadmapAddItemPayload";
    /** provides details about the errors */
    errors?: Maybe<Array<MutationError>>;
    /** Output upon successful mutation */
    output?: Maybe<RoadmapAddItemResponse>;
    /** indicates if the mutation was successful */
    success: Scalars["Boolean"]["output"];
};

export type RoadmapAddItemRank = {
    /** Rank before ID; used only to rank the item before the input item ID */
    beforeId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type RoadmapAddItemResponse = {
    __typename?: "RoadmapAddItemResponse";
    /** The ID of the created item */
    id: Scalars["ID"]["output"];
    /** Roadmap item */
    item?: Maybe<RoadmapItem>;
    /** The key of this item */
    key: Scalars["String"]["output"];
    /** Determines if the created issue matches the jql of the applied quick or custom filters */
    matchesJqlFilters: Scalars["Boolean"]["output"];
    /** Determines if the created issue matches the jql of the current board */
    matchesSource: Scalars["Boolean"]["output"];
};

export type RoadmapAddLevelOneIssueTypeHealthcheckResolution = {
    /** Information required to create a new level one issue type */
    create?: InputMaybe<RoadmapCreateLevelOneIssueType>;
    /** Information required to promote an existing issue type to a level one issue type */
    promote?: InputMaybe<RoadmapPromoteLevelOneIssueType>;
};

/** Goal details */
export type RoadmapAriGoalDetails = {
    __typename?: "RoadmapAriGoalDetails";
    /** Goal ari */
    ari: Scalars["String"]["output"];
    /** Goal hydrated from Atlas. */
    goal?: Maybe<TownsquareGoal>;
    /** Issue Ids related to this goal */
    issueIds: Array<Scalars["Long"]["output"]>;
};

/** Details about goal configuration for roadmaps */
export type RoadmapAriGoals = {
    __typename?: "RoadmapAriGoals";
    /** list of goals for roadmaps items */
    goals?: Maybe<Array<RoadmapAriGoalDetails>>;
};

/** Board specific configuration for a Roadmap */
export type RoadmapBoardConfiguration = {
    __typename?: "RoadmapBoardConfiguration";
    /** The child issue planning mode */
    childIssuePlanningMode?: Maybe<RoadmapChildIssuePlanningMode>;
    /** Fields with values derived from board jql */
    derivedFields?: Maybe<Array<RoadmapField>>;
    /** Is the board's jql filtering out epics */
    isBoardJqlFilteringOutEpics?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is child issue planning enabled for the roadmap */
    isChildIssuePlanningEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is the sprints feature enabled on the board */
    isSprintsFeatureEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Is the current user a board admin */
    isUserBoardAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /** The board's JQL */
    jql?: Maybe<Scalars["String"]["output"]>;
    /** Sprints owned by the board associated to the roadmap */
    sprints?: Maybe<Array<RoadmapSprint>>;
};

/** Child Issue Planning Mode */
export enum RoadmapChildIssuePlanningMode {
    /** Use Date based planning */
    Date = "DATE",
    /** Disabled child issue planning */
    Disabled = "DISABLED",
    /** Use Sprint based planning */
    Sprint = "SPRINT"
}

export type RoadmapChildItem = {
    __typename?: "RoadmapChildItem";
    /** The assignee of this item */
    assignee?: Maybe<User>;
    /** The assignee id of this item */
    assigneeId?: Maybe<Scalars["ID"]["output"]>;
    /** What color should be shown for this item */
    color?: Maybe<RoadmapPaletteColor>;
    /** List of ids of the components on this item */
    componentIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** IDs of RoadmapItem dependencies for this item */
    dependencies?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** When this item is due, note this is a Date with no TZ */
    dueDateRFC3339?: Maybe<Scalars["Date"]["output"]>;
    /** The ID of this item */
    id: Scalars["ID"]["output"];
    /** The due date inferred from any child items, note this is a Date with no TZ */
    inferredDueDate?: Maybe<Scalars["Date"]["output"]>;
    /** The start date inferred from any child items, note this is a Date with no TZ */
    inferredStartDate?: Maybe<Scalars["Date"]["output"]>;
    /** The identifier of this item type */
    itemTypeId: Scalars["ID"]["output"];
    /** The key of this item */
    key: Scalars["String"]["output"];
    /** List of labels on this item */
    labels?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The ID of the parent */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /** The id of the project for this item */
    projectId: Scalars["ID"]["output"];
    /** Lexorank value for the issue (used to determine issues ranking when receiving update events) */
    rank?: Maybe<Scalars["String"]["output"]>;
    /** If the item is resolved */
    resolved?: Maybe<Scalars["Boolean"]["output"]>;
    /** List of sprint ids that exist on the item */
    sprintIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** When this item is set to start, note this is a Date with no TZ */
    startDateRFC3339?: Maybe<Scalars["Date"]["output"]>;
    /** The status of this item */
    status?: Maybe<RoadmapItemStatus>;
    /** The status id of this item */
    statusId?: Maybe<Scalars["ID"]["output"]>;
    /** The summary of this item */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** List of ids of the versions on this item */
    versionIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

/** Relay connection definition for a roadmap item */
export type RoadmapChildItemConnection = {
    __typename?: "RoadmapChildItemConnection";
    /** The edges for this connection */
    edges: Array<Maybe<RoadmapChildItemEdge>>;
    /** The nodes for this connection */
    nodes: Array<Maybe<RoadmapChildItem>>;
    /** Details about this page */
    pageInfo: PageInfo;
    /** Total item count for the connection */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Relay edge definition for a roadmap item */
export type RoadmapChildItemEdge = {
    __typename?: "RoadmapChildItemEdge";
    /** Cursor position for this edge */
    cursor: Scalars["String"]["output"];
    /** The roadmap item for this edge */
    node?: Maybe<RoadmapChildItem>;
};

/** Details of a component */
export type RoadmapComponent = {
    __typename?: "RoadmapComponent";
    /** A unique identifier for the component */
    id: Scalars["ID"]["output"];
    /** The name of the component */
    name: Scalars["String"]["output"];
};

export type RoadmapConfiguration = {
    __typename?: "RoadmapConfiguration";
    /** Configuration specific to a board */
    boardConfiguration?: Maybe<RoadmapBoardConfiguration>;
    /** Dependency configuration for this roadmap */
    dependencies?: Maybe<RoadmapDependencyConfiguration>;
    /** External configuration details */
    externalConfiguration?: Maybe<RoadmapExternalConfiguration>;
    /** Configuration specific to the hierarchy of the roadmap */
    hierarchyConfiguration?: Maybe<RoadmapHierarchyConfiguration>;
    /** Is this roadmap cross project */
    isCrossProject: Scalars["Boolean"]["output"];
    /** Is this roadmap cross project with permission agnostic check */
    isCrossProjectInconsistent: Scalars["Boolean"]["output"];
    /** Project information */
    projectConfiguration?: Maybe<RoadmapProjectConfiguration>;
    /**
     * Project information
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated use projectConfiguration instead
     */
    projectConfigurations: Array<RoadmapProjectConfiguration>;
    /** Is the board backed with jql with Rank ASC in order by clause */
    rankIssuesSupported: Scalars["Boolean"]["output"];
    /** Is the roadmap feature enabled for this roadmap */
    roadmapFeatureEnabled: Scalars["Boolean"]["output"];
    /** Details of status categories */
    statusCategories: Array<RoadmapStatusCategory>;
    /** Configuration specific to the current user */
    userConfiguration?: Maybe<RoadmapUserConfiguration>;
};

/** Content of a valid roadmap */
export type RoadmapContent = {
    __typename?: "RoadmapContent";
    /**
     *  Children items of issues in the roadmap
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RoadmapsPaginationExperiment")' query directive to the 'childItems' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    childItems: RoadmapChildItemConnection;
    /** The configuration for this roadmap */
    configuration: RoadmapConfiguration;
    /** The items in the roadmap */
    items: RoadmapItemConnection;
    /**
     *  Level One issues in the roadmap
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RoadmapsPaginationExperiment")' query directive to the 'levelOneItems' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    levelOneItems: RoadmapLevelOneItemConnection;
};

/** Content of a valid roadmap */
export type RoadmapContentChildItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    parentIds: Array<Scalars["ID"]["input"]>;
};

/** Content of a valid roadmap */
export type RoadmapContentLevelOneItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RoadmapCreateLevelOneIssueType = {
    /** The description of the epic type */
    epicTypeDescription: Scalars["String"]["input"];
    /** The name of the epic type */
    epicTypeName: Scalars["String"]["input"];
};

export type RoadmapCreationPreferences = {
    __typename?: "RoadmapCreationPreferences";
    itemTypes: Scalars["JSON"]["output"];
    projectId?: Maybe<Scalars["Long"]["output"]>;
};

/** Details of a custom filter */
export type RoadmapCustomFilter = {
    __typename?: "RoadmapCustomFilter";
    /** UUID of the custom filter */
    id: Scalars["ID"]["output"];
    /** Name of the custom filter */
    name: Scalars["String"]["output"];
};

/** Details about dependency configuration for roadmaps */
export type RoadmapDependencyConfiguration = {
    __typename?: "RoadmapDependencyConfiguration";
    /** The description to apply for inbound dependencies */
    inwardDependencyDescription?: Maybe<Scalars["String"]["output"]>;
    /** Are dependencies enabled */
    isDependenciesEnabled: Scalars["Boolean"]["output"];
    /** The description to apply for outbound dependencies */
    outwardDependencyDescription?: Maybe<Scalars["String"]["output"]>;
};

/** Details of a roadmap */
export type RoadmapDetails = {
    __typename?: "RoadmapDetails";
    /** content of the roadmap, provided only if all healthchecks passed. */
    content?: Maybe<RoadmapContent>;
    /** If this field has a value, roadmap cannot be displayed until the healthcheck is resolved. */
    healthcheck?: Maybe<RoadmapHealthCheck>;
    /** Indicates whether this roadmap is enabled or not. */
    isRoadmapFeatureEnabled: Scalars["Boolean"]["output"];
    /**
     *  meta information surrounding the roadmap, such as issue limit breaches
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated consider consuming healthchecks
     */
    metadata?: Maybe<RoadmapMetadata>;
    /**
     *  The configuration for this roadmap
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated consider consuming content/configuration
     */
    roadmapConfiguration?: Maybe<RoadmapConfiguration>;
    /**
     *  The items in the roadmap
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated consider consuming content/items
     */
    roadmapItems?: Maybe<RoadmapItemConnection>;
};

/** View settings for epics on the roadmap */
export enum RoadmapEpicView {
    /** All epics regardless of status */
    All = "ALL",
    /** Epics with status complete */
    Completed = "COMPLETED",
    /** Epics with status incomplete */
    Incomplete = "INCOMPLETE"
}

/** Configuration values for the external system(s) behind the roadmap data */
export type RoadmapExternalConfiguration = {
    __typename?: "RoadmapExternalConfiguration";
    /** The identifier for the 'field' that represents issue color in the external system */
    colorField?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The identifier for the 'field' that represents epic color in the external system
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use colorField instead of colorFields due to epic fields deprecation
     */
    colorFields?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** The identifier for the 'field' that represents due date in the external system */
    dueDateField?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The identifier for the 'field' that represents epic link in the external system
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use parent instead of epicLink
     */
    epicLinkField?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The identifier for the 'field' that represents epic name in the external system
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use parent summary instead of epicName
     */
    epicNameField?: Maybe<Scalars["ID"]["output"]>;
    /** ID of external system */
    externalSystem: Scalars["ID"]["output"];
    /** The list of fields exportable on roadmaps */
    fields: Array<RoadmapFieldConfiguration>;
    /** The identifier for the 'field' that represents flagged in the external system */
    flaggedField?: Maybe<Scalars["ID"]["output"]>;
    /** The identifier for the 'field' that represents rank in the external system */
    rankField?: Maybe<Scalars["ID"]["output"]>;
    /** The identifier for the 'field' that represents sprint in the external system */
    sprintField?: Maybe<Scalars["ID"]["output"]>;
    /** The identifier for the 'field' that represents start date in the external system */
    startDateField?: Maybe<Scalars["ID"]["output"]>;
};

/** Details of a field derived from JQL */
export type RoadmapField = {
    __typename?: "RoadmapField";
    /** Id of the field */
    id: Scalars["String"]["output"];
    /** Values derived from JQL for the field */
    values: Array<Scalars["String"]["output"]>;
};

/** Field configuration */
export type RoadmapFieldConfiguration = {
    __typename?: "RoadmapFieldConfiguration";
    /** The unique id of the field */
    id: Scalars["ID"]["output"];
    /** The translated field name */
    name: Scalars["String"]["output"];
};

/** Details about filter configuration for roadmaps */
export type RoadmapFilterConfiguration = {
    __typename?: "RoadmapFilterConfiguration";
    /** List of custom filters for the TMP roadmap */
    customFilters?: Maybe<Array<RoadmapCustomFilter>>;
    /** List of quick filters for the CMP roadmap */
    quickFilters?: Maybe<Array<RoadmapQuickFilter>>;
};

/** Describes a problem with the roadmaps that needs to be resolved in order to successfully fetch the content */
export type RoadmapHealthCheck = {
    __typename?: "RoadmapHealthCheck";
    /** detailed explanation about the identified problem */
    explanation: Scalars["String"]["output"];
    /** Id of the healthcheck type (nullable for Fast5 purpose) */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Link to a documentation page */
    learnMore: RoadmapHealthCheckLink;
    /** Resolution action */
    resolution?: Maybe<RoadmapHealthCheckResolution>;
    /** Title of the healthcheck */
    title: Scalars["String"]["output"];
};

/** Link to a documentation page relevant to the healthcheck */
export type RoadmapHealthCheckLink = {
    __typename?: "RoadmapHealthCheckLink";
    /** Description of the link */
    text: Scalars["String"]["output"];
    /** Url of the help page */
    url: Scalars["String"]["output"];
};

/** Healthcheck resolution action */
export type RoadmapHealthCheckResolution = {
    __typename?: "RoadmapHealthCheckResolution";
    /** Identifier for the resolution action type */
    actionId: Scalars["ID"]["output"];
    /** If the action is not supported this message can be displayed instead. */
    fallbackMessage: Scalars["String"]["output"];
    /** Description of the resolution button */
    label: Scalars["String"]["output"];
};

/** Details about hierarchy configuration for roadmaps */
export type RoadmapHierarchyConfiguration = {
    __typename?: "RoadmapHierarchyConfiguration";
    /** The name of the level one hierarchy */
    levelOneName: Scalars["String"]["output"];
};

/** The roadmap item data */
export type RoadmapItem = {
    __typename?: "RoadmapItem";
    /** The assignee of this item */
    assignee?: Maybe<User>;
    /** The assignee id of this item */
    assigneeId?: Maybe<Scalars["ID"]["output"]>;
    /** What color should be shown for this item */
    color?: Maybe<RoadmapPaletteColor>;
    /** List of ids of the components on this item */
    componentIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** When this item was created */
    createdDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** IDs of RoadmapItem dependencies for this item */
    dependencies?: Maybe<Array<Scalars["ID"]["output"]>>;
    /**
     * When this item is due, note this is a Date with no TZ
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated incorrect type, use dueDateRFC3339 instead
     */
    dueDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** When this item is due, note this is a Date with no TZ */
    dueDateRFC3339?: Maybe<Scalars["Date"]["output"]>;
    /** If the item is flagged */
    flagged?: Maybe<Scalars["Boolean"]["output"]>;
    /** The ID of this item */
    id: Scalars["ID"]["output"];
    /** The due date inferred from any child items, note this is a Date with no TZ */
    inferredDueDate?: Maybe<Scalars["Date"]["output"]>;
    /** The start date inferred from any child items, note this is a Date with no TZ */
    inferredStartDate?: Maybe<Scalars["Date"]["output"]>;
    /**
     * The type of this item
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use itemTypeId and types from configuration instead
     */
    itemType: RoadmapItemType;
    /** The type id of this item */
    itemTypeId: Scalars["Long"]["output"];
    /** The key of this item */
    key: Scalars["String"]["output"];
    /** List of labels on this item */
    labels?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The ID of the parent */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /** The id of the project for this item */
    projectId: Scalars["ID"]["output"];
    /** Lexorank value for the issue (used to determine issues ranking when receiving update events) */
    rank?: Maybe<Scalars["String"]["output"]>;
    /** When this item was resolved */
    resolutionDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** If the item is resolved */
    resolved?: Maybe<Scalars["Boolean"]["output"]>;
    /** List of sprint ids that exist on the item */
    sprintIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /**
     * When this item is set to start, note this is a Date with no TZ
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated incorrect type, use startDateRFC3339 instead
     */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** When this item is set to start, note this is a Date with no TZ */
    startDateRFC3339?: Maybe<Scalars["Date"]["output"]>;
    /** The status of this item */
    status?: Maybe<RoadmapItemStatus>;
    /** The status category of this item */
    statusCategory?: Maybe<RoadmapItemStatusCategory>;
    /** The status id of this item */
    statusId?: Maybe<Scalars["ID"]["output"]>;
    /** The summary of this item */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** List of ids of the versions on this item */
    versionIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

/** Relay connection definition for a roadmap item */
export type RoadmapItemConnection = {
    __typename?: "RoadmapItemConnection";
    /** The edges for this connection */
    edges?: Maybe<Array<Maybe<RoadmapItemEdge>>>;
    /** The nodes for this connection */
    nodes: Array<Maybe<RoadmapItem>>;
    /** Details about this page */
    pageInfo: PageInfo;
};

/** Relay edge definition for a roadmap item */
export type RoadmapItemEdge = {
    __typename?: "RoadmapItemEdge";
    /** Cursor position for this edge */
    cursor: Scalars["String"]["output"];
    /** The roadmap item for this edge */
    node?: Maybe<RoadmapItem>;
};

export type RoadmapItemRankInput = {
    /** The existing item to rank the updated or created item before/after */
    id: Scalars["ID"]["input"];
    /** The position relative to id to rank the item */
    position: RoadmapRankPosition;
};

/** Details of the status an item has */
export type RoadmapItemStatus = {
    __typename?: "RoadmapItemStatus";
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    statusCategory?: Maybe<RoadmapItemStatusCategory>;
};

/** Details of the category that a status belongs to */
export type RoadmapItemStatusCategory = {
    __typename?: "RoadmapItemStatusCategory";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

/** Information about the type of a roadmap Item */
export type RoadmapItemType = {
    __typename?: "RoadmapItemType";
    /**
     * The avatar for this item type
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated This is unused in roadmap and may not be provided in the future
     */
    avatarId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * A description of this item type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The url for the icon of the item type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The identifier of this item type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The display name of the item type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Fields that are required for this item type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    requiredFieldIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /**
     * Whether this item type represents a subtask
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    subtask: Scalars["Boolean"]["output"];
};

export type RoadmapLevelOneItem = {
    __typename?: "RoadmapLevelOneItem";
    /** The assignee of this item */
    assignee?: Maybe<User>;
    /** The assignee id of this item */
    assigneeId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * ## Aggregate fields
     *  Child issue count
     */
    childIssueCount: Scalars["Int"]["output"];
    /** What color should be shown for this item */
    color?: Maybe<RoadmapPaletteColor>;
    /** List of ids of the components on this item */
    componentIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** IDs of RoadmapItem dependencies for this item */
    dependencies?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** When this item is due, note this is a Date with no TZ */
    dueDateRFC3339?: Maybe<Scalars["Date"]["output"]>;
    /** The ID of this item */
    id: Scalars["ID"]["output"];
    /** The due date inferred from any child items, note this is a Date with no TZ */
    inferredDueDate?: Maybe<Scalars["Date"]["output"]>;
    /** The start date inferred from any child items, note this is a Date with no TZ */
    inferredStartDate?: Maybe<Scalars["Date"]["output"]>;
    /** The identifier of this item type */
    itemTypeId: Scalars["ID"]["output"];
    /** The key of this item */
    key: Scalars["String"]["output"];
    /** List of labels on this item */
    labels?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The ID of the parent */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /** Aggregated progress of child issues */
    progress: Array<RoadmapProgressEntry>;
    /** The id of the project for this item */
    projectId: Scalars["ID"]["output"];
    /** Lexorank value for the issue (used to determine issues ranking when receiving update events) */
    rank?: Maybe<Scalars["String"]["output"]>;
    /** If the item is resolved */
    resolved?: Maybe<Scalars["Boolean"]["output"]>;
    /** List of sprint ids that exist on the item */
    sprintIds?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** When this item is set to start, note this is a Date with no TZ */
    startDateRFC3339?: Maybe<Scalars["Date"]["output"]>;
    /** The status of this item */
    status?: Maybe<RoadmapItemStatus>;
    /** The status id of this item */
    statusId?: Maybe<Scalars["ID"]["output"]>;
    /** The summary of this item */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** List of ids of the versions on this item */
    versionIds?: Maybe<Array<Scalars["ID"]["output"]>>;
};

/** Relay connection definition for a roadmap item */
export type RoadmapLevelOneItemConnection = {
    __typename?: "RoadmapLevelOneItemConnection";
    /** The edges for this connection */
    edges: Array<Maybe<RoadmapLevelOneItemEdge>>;
    /** The nodes for this connection */
    nodes: Array<Maybe<RoadmapLevelOneItem>>;
    /** Details about this page */
    pageInfo: PageInfo;
    /** Total item count for the connection */
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Relay edge definition for a roadmap item */
export type RoadmapLevelOneItemEdge = {
    __typename?: "RoadmapLevelOneItemEdge";
    /** Cursor position for this edge */
    cursor: Scalars["String"]["output"];
    /** The roadmap item for this edge */
    node?: Maybe<RoadmapLevelOneItem>;
};

/** View settings for hierarchy level one items on the roadmap */
export enum RoadmapLevelOneView {
    /** Show level one items completed within last 1 month */
    Complete1M = "COMPLETE1M",
    /** Show level one items completed within last 3 months */
    Complete3M = "COMPLETE3M",
    /** Show level one items completed within last 6 months */
    Complete6M = "COMPLETE6M",
    /** Show level one items completed within last 9 months */
    Complete9M = "COMPLETE9M",
    /** Show level one items completed within last 12 months */
    Complete12M = "COMPLETE12M",
    /** Do not show completed level one items */
    Incomplete = "INCOMPLETE"
}

export type RoadmapMetadata = {
    __typename?: "RoadmapMetadata";
    /** how many corrupted issues have we found while loading the roadmap */
    corruptedIssueCount: Scalars["Int"]["output"];
    /** has the roadmap exceeded the epic limit */
    hasExceededEpicLimit: Scalars["Boolean"]["output"];
    /** has the roadmap exceeded the overall limit of issues (epic + issues) */
    hasExceededIssueLimit: Scalars["Boolean"]["output"];
};

/**
 * ###########################################################################
 * ####################### END ROADMAP QUERIES TYPES #########################
 * ###########################################################################
 * ###########################################################################
 * ######### BELOW HERE ARE THE TYPES SUPPORTING ROADMAPS MUTATIONS ##########
 * ###########################################################################
 */
export type RoadmapMutationErrorExtension = MutationErrorExtension & {
    __typename?: "RoadmapMutationErrorExtension";
    /**
     *  Application specific error trace
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *  A numerical code (as a HTTP status code) representing the error category
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Supported colors in the Palette */
export enum RoadmapPaletteColor {
    Blue = "BLUE",
    DarkBlue = "DARK_BLUE",
    DarkGreen = "DARK_GREEN",
    DarkGrey = "DARK_GREY",
    DarkOrange = "DARK_ORANGE",
    DarkPurple = "DARK_PURPLE",
    DarkTeal = "DARK_TEAL",
    DarkYellow = "DARK_YELLOW",
    Green = "GREEN",
    Grey = "GREY",
    Orange = "ORANGE",
    Purple = "PURPLE",
    Teal = "TEAL",
    Yellow = "YELLOW"
}

/** Aggregated progress of child issues */
export type RoadmapProgressEntry = {
    __typename?: "RoadmapProgressEntry";
    count: Scalars["Int"]["output"];
    statusCategoryId: Scalars["ID"]["output"];
};

/** Details of a project for a roadmap */
export type RoadmapProject = {
    __typename?: "RoadmapProject";
    /**
     * Does this project support dependencies between issues
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    areDependenciesSupported: Scalars["Boolean"]["output"];
    /**
     * Color custom field ID; used to resolve raw fields data in Bento optimistic updates
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    colorCustomFieldId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The description of the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     * The issue type for epic, in future this will be replaced by using the hierarchy structures directly
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    epicIssueTypeId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Has the current user completed onboarding
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasCompletedOnboarding: Scalars["Boolean"]["output"];
    /**
     * The identifier of the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The description for inward dependency links
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    inwardDependencyDescription?: Maybe<Scalars["String"]["output"]>;
    /**
     * The types of items that this project has
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    itemTypes?: Maybe<Array<RoadmapItemType>>;
    /**
     * The short key of the project i.e. ABC
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     * The user who is leading the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lead?: Maybe<User>;
    /**
     * Lexo rank custom field ID; used in all ranking operations, in future should be replaced by mutations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lexoRankCustomFieldId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * The display name of the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * The description for outward dependency links
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    outwardDependencyDescription?: Maybe<Scalars["String"]["output"]>;
    /**
     * Permissions for the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    permissions?: Maybe<RoadmapProjectPermissions>;
    /**
     * Start date custom field ID; used to resolve raw fields data in Bento optimistic updates
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    startDateCustomFieldId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Validation details for the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    validation?: Maybe<RoadmapProjectValidation>;
};

/** Configuration details specific to a project */
export type RoadmapProjectConfiguration = {
    __typename?: "RoadmapProjectConfiguration";
    /** The item types at the child level */
    childItemTypes: Array<RoadmapItemType>;
    /** List of components for this project */
    components?: Maybe<Array<RoadmapComponent>>;
    /** The id of the default item type */
    defaultItemTypeId?: Maybe<Scalars["String"]["output"]>;
    /** Flag indicating if atlas goals feature is enabled */
    isGoalsFeatureEnabled: Scalars["Boolean"]["output"];
    /** Whether the releases feature has been enabled for this project. Works for both CMP and TMP. */
    isReleasesFeatureEnabled: Scalars["Boolean"]["output"];
    /** The item types at the parent level */
    parentItemTypes: Array<RoadmapItemType>;
    /** Permission details for this project */
    permissions?: Maybe<RoadmapProjectPermissions>;
    /** The identifier of the project */
    projectId: Scalars["ID"]["output"];
    /** The short key of the project i.e. ABC */
    projectKey?: Maybe<Scalars["String"]["output"]>;
    /** The name of the project i.e. ABC project */
    projectName?: Maybe<Scalars["String"]["output"]>;
    /** Validation information for this project */
    validation?: Maybe<RoadmapProjectValidation>;
    /** List of versions for this project */
    versions?: Maybe<Array<RoadmapVersion>>;
};

/** Information about the permissions available for the roadmap project for the current user */
export type RoadmapProjectPermissions = {
    __typename?: "RoadmapProjectPermissions";
    /**
     * can the project be administered
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canAdministerProjects: Scalars["Boolean"]["output"];
    /**
     * can issues be created
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canCreateIssues: Scalars["Boolean"]["output"];
    /**
     * can issues be edited
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canEditIssues: Scalars["Boolean"]["output"];
    /**
     * can issues be scheduled
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    canScheduleIssues: Scalars["Boolean"]["output"];
};

/** Details about how valid the roadmap project is */
export type RoadmapProjectValidation = {
    __typename?: "RoadmapProjectValidation";
    /**
     * Are all the field associations correct for the project
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasAllFieldAssociations: Scalars["Boolean"]["output"];
    /**
     * Has the epic issue type been setup
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasEpicIssueType: Scalars["Boolean"]["output"];
    /**
     * Is the hierarchy for the project in a valid state
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    hasValidHierarchy: Scalars["Boolean"]["output"];
    /**
     * Is roadmap feature enabled in the project
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use the value from RoadmapDetails if possible
     */
    isRoadmapFeatureEnabled: Scalars["Boolean"]["output"];
};

export type RoadmapPromoteLevelOneIssueType = {
    /** The numeric id of the item type that will be promoted to level one */
    promoteItemTypeId: Scalars["ID"]["input"];
};

/** Details of a quick filter */
export type RoadmapQuickFilter = {
    __typename?: "RoadmapQuickFilter";
    /** Id of the quick filter */
    id: Scalars["ID"]["output"];
    /** Name of the quick filter */
    name: Scalars["String"]["output"];
    /** JQL query of the quick filter */
    query: Scalars["String"]["output"];
};

export enum RoadmapRankPosition {
    /** Rank the item after the provided id */
    After = "AFTER",
    /** Rank the item before the provided id */
    Before = "BEFORE"
}

/** Input for setting up a project with a roadmap */
export type RoadmapResolveHealthcheckInput = {
    /** The healthcheck action id */
    actionId: Scalars["ID"]["input"];
    /** Required to fix add-level-one-issue-type healthcheck */
    addLevelOneIssueType?: InputMaybe<RoadmapAddLevelOneIssueTypeHealthcheckResolution>;
};

export type RoadmapResolveHealthcheckPayload = Payload & {
    __typename?: "RoadmapResolveHealthcheckPayload";
    /** provides details about the errors */
    errors?: Maybe<Array<MutationError>>;
    /** indicates if the mutation was successful */
    success: Scalars["Boolean"]["output"];
};

/** Input for a single roadmap schedule item. */
export type RoadmapScheduleItemInput = {
    /** When this item is due; date in RFC3339 DateTime format */
    dueDate?: InputMaybe<Scalars["Date"]["input"]>;
    /** Roadmap item ID */
    itemId: Scalars["ID"]["input"];
    /** When this item is set to start; date in RFC3339 DateTime format */
    startDate?: InputMaybe<Scalars["Date"]["input"]>;
};

/** Input of a roadmap schedule items mutation. */
export type RoadmapScheduleItemsInput = {
    /** List of schedule requests */
    scheduleRequests: Array<InputMaybe<RoadmapScheduleItemInput>>;
};

export type RoadmapScheduleItemsPayload = Payload & {
    __typename?: "RoadmapScheduleItemsPayload";
    /** provides details about the errors */
    errors?: Maybe<Array<MutationError>>;
    /** indicates if the mutation was successful */
    success: Scalars["Boolean"]["output"];
};

/** Details of a roadmap sprint */
export type RoadmapSprint = {
    __typename?: "RoadmapSprint";
    /**
     * The end date of the sprint, note this is a Date with no TZ
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated incorrect type, use endDateRFC3339 instead
     */
    endDate: Scalars["String"]["output"];
    /** The end date of the sprint, note this is a Date with no TZ */
    endDateRFC3339: Scalars["Date"]["output"];
    /** A unique identifier for the sprint */
    id: Scalars["ID"]["output"];
    /** The name of the sprint */
    name: Scalars["String"]["output"];
    /**
     * The start date of the sprint, note this is a Date with no TZ
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated incorrect type, use startDateRFC3339 instead
     */
    startDate: Scalars["String"]["output"];
    /** The start date of the sprint, note this is a Date with no TZ */
    startDateRFC3339: Scalars["Date"]["output"];
    /** The state of the sprint */
    state: RoadmapSprintState;
};

/** States that a sprint can be in */
export enum RoadmapSprintState {
    /** A current sprint */
    Active = "ACTIVE",
    /** A sprint that was completed in the past */
    Closed = "CLOSED",
    /** A sprint that is planned for the future */
    Future = "FUTURE"
}

/** Details of the roadmap status category */
export type RoadmapStatusCategory = {
    __typename?: "RoadmapStatusCategory";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

/** Subtask issues */
export type RoadmapSubtasks = {
    __typename?: "RoadmapSubtasks";
    /** The ID of this item */
    id: Scalars["ID"]["output"];
    /** The key of this item */
    key: Scalars["String"]["output"];
    /** The parent issue ID of this item */
    parentId: Scalars["ID"]["output"];
    /** Status category id of this item */
    statusCategoryId: Scalars["String"]["output"];
};

/** Subtask issues and its status category details */
export type RoadmapSubtasksWithStatusCategories = {
    __typename?: "RoadmapSubtasksWithStatusCategories";
    /** Details of status categories */
    statusCategories: Array<RoadmapStatusCategory>;
    /** List of subtask issue */
    subtasks: Array<RoadmapSubtasks>;
};

/** Defines the available timeline modes */
export enum RoadmapTimelineMode {
    /** Months */
    Months = "MONTHS",
    /** Quarters */
    Quarters = "QUARTERS",
    /** Weeks */
    Weeks = "WEEKS"
}

export type RoadmapToggleDependencyInput = {
    /** "dependee" requires/depends on "dependency" */
    dependee: Scalars["ID"]["input"];
    /** "dependency" is required/depended on by "dependee" */
    dependency: Scalars["ID"]["input"];
};

export type RoadmapToggleDependencyPayload = Payload & {
    __typename?: "RoadmapToggleDependencyPayload";
    /** provides details about the errors */
    errors?: Maybe<Array<MutationError>>;
    /** Output upon successful mutation */
    output?: Maybe<RoadmapToggleDependencyResponse>;
    /** indicates if the mutation was successful */
    success: Scalars["Boolean"]["output"];
};

export type RoadmapToggleDependencyResponse = {
    __typename?: "RoadmapToggleDependencyResponse";
    /** "dependee" requires/depends on "dependency" */
    dependee: Scalars["ID"]["output"];
    /** "dependency" is required/depended on by "dependee" */
    dependency: Scalars["ID"]["output"];
};

/** Input of a roadmap update item mutation. */
export type RoadmapUpdateItemInput = {
    /** Field to be cleared; clearFields take precedence over other field input */
    clearFields?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** What color should be shown for this item */
    color?: InputMaybe<RoadmapPaletteColor>;
    /** When this item is due; date in RFC3339 DateTime format */
    dueDate?: InputMaybe<Scalars["Date"]["input"]>;
    /** Roadmap item ID */
    itemId: Scalars["ID"]["input"];
    /** The id of the parent of the issue */
    parentId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Roadmap project ID; used only to fetch custom fields and won't have any impact on the item itself */
    projectId: Scalars["ID"]["input"];
    /** Item rank request */
    rank?: InputMaybe<RoadmapItemRankInput>;
    /** Sprint id of the roadmap item */
    sprintId?: InputMaybe<Scalars["ID"]["input"]>;
    /** When this item is set to start; date in RFC3339 DateTime format */
    startDate?: InputMaybe<Scalars["Date"]["input"]>;
    /** The summary of this item */
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type RoadmapUpdateItemPayload = Payload & {
    __typename?: "RoadmapUpdateItemPayload";
    /** provides details about the errors */
    errors?: Maybe<Array<MutationError>>;
    /** Output upon successful mutation */
    output?: Maybe<RoadmapUpdateItemResponse>;
    /** indicates if the mutation was successful */
    success: Scalars["Boolean"]["output"];
};

export type RoadmapUpdateItemResponse = {
    __typename?: "RoadmapUpdateItemResponse";
    /**
     *  Updated item hydrated from Gira
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "RoadmapsUpdateItemId")' query directive to the 'issue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issue?: Maybe<JiraIssue>;
    /** Roadmap item */
    item?: Maybe<RoadmapItem>;
    /** The ID of the updated item */
    itemId?: Maybe<Scalars["ID"]["output"]>;
};

/** Input for updating roadmap settings */
export type RoadmapUpdateSettingsInput = {
    /** indicates to enable or disable child issue planning on the roadmap */
    childIssuePlanningEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The child issue planning mode */
    childIssuePlanningMode?: InputMaybe<RoadmapChildIssuePlanningMode>;
    /** indicates to enable or disable the roadmap */
    roadmapEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RoadmapUpdateSettingsOutput = {
    __typename?: "RoadmapUpdateSettingsOutput";
    /** indicates if child issue planning on the roadmap is enabled */
    childIssuePlanningEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The child issue planning mode */
    childIssuePlanningMode?: Maybe<RoadmapChildIssuePlanningMode>;
    /** indicates if the roadmap is enabled */
    roadmapEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RoadmapUpdateSettingsPayload = Payload & {
    __typename?: "RoadmapUpdateSettingsPayload";
    /** provides details about the errors */
    errors?: Maybe<Array<MutationError>>;
    /** Output upon successful mutation */
    output?: Maybe<RoadmapUpdateSettingsOutput>;
    /** indicates if the mutation was successful */
    success: Scalars["Boolean"]["output"];
};

/** Any user specific configuration for the roadmap */
export type RoadmapUserConfiguration = {
    __typename?: "RoadmapUserConfiguration";
    /** Issue Creation Preferences */
    creationPreferences: RoadmapCreationPreferences;
    /**
     * Epic View - ALL, COMPLETED, INCOMPLETE
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced by levelOneViewSettings
     */
    epicView: RoadmapEpicView;
    /** Has the current user completed onboarding */
    hasCompletedOnboarding: Scalars["Boolean"]["output"];
    /** List of version ids to be highlighted on the timeline */
    highlightedVersions: Array<Scalars["ID"]["output"]>;
    /** Should dependencies be visible in Roadmaps UI */
    isDependenciesVisible: Scalars["Boolean"]["output"];
    /** Should progress be visible in Roadmaps UI */
    isProgressVisible: Scalars["Boolean"]["output"];
    /** Whether releases / versions should be visible on the timeline */
    isReleasesVisible: Scalars["Boolean"]["output"];
    /** Should warnings be visible in Roadmaps UI */
    isWarningsVisible: Scalars["Boolean"]["output"];
    /** Issue details panel ratio for width */
    issuePanelRatio?: Maybe<Scalars["Float"]["output"]>;
    /**
     * View settings for hierarchy level one items on the roadmap
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced by levelOneViewSettings
     */
    levelOneView: RoadmapLevelOneView;
    /** View settings for hierarchy level one items on the roadmap */
    levelOneViewSettings: RoadmapViewSettings;
    /** List Component width in UI */
    listWidth: Scalars["Long"]["output"];
    /** Timeline View - WEEKS, MONTHS or QUARTERS */
    timelineMode: RoadmapTimelineMode;
};

/** Details of a version */
export type RoadmapVersion = {
    __typename?: "RoadmapVersion";
    /** A unique identifier for the version */
    id: Scalars["ID"]["output"];
    /** The name of the version */
    name: Scalars["String"]["output"];
    /** The planned release date of the version, note this is a Date with no TZ */
    releaseDate?: Maybe<Scalars["Date"]["output"]>;
    /** The status of the version */
    status: RoadmapVersionStatus;
};

/** Avaliable version statuses */
export enum RoadmapVersionStatus {
    /** version has been archived */
    Archived = "ARCHIVED",
    /** version has been released */
    Released = "RELEASED",
    /** version has not been released */
    Unreleased = "UNRELEASED"
}

/** View settings for items on the roadmap */
export type RoadmapViewSettings = {
    __typename?: "RoadmapViewSettings";
    /** The length of time to show completed issues */
    period: Scalars["Int"]["output"];
    /** Are completed issues shown on the roadmap */
    showCompleted: Scalars["Boolean"]["output"];
};

export type RoadmapsMutation = {
    __typename?: "RoadmapsMutation";
    /**
     *  Add a roadmap dependency
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    addRoadmapDependency?: Maybe<RoadmapToggleDependencyPayload>;
    /**
     *  Add an item to a roadmap
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    addRoadmapItem?: Maybe<RoadmapAddItemPayload>;
    /**
     *  Remove a roadmap dependency
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    removeRoadmapDependency?: Maybe<RoadmapToggleDependencyPayload>;
    /**
     *  Resolve a roadmap healthcheck
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    resolveRoadmapHealthcheck?: Maybe<RoadmapResolveHealthcheckPayload>;
    /**
     *  Schedule multiple issues
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    scheduleRoadmapItems?: Maybe<RoadmapScheduleItemsPayload>;
    /**
     *  Update a roadmap item
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: RoadmapsMutation` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateRoadmapItem?: Maybe<RoadmapUpdateItemPayload>;
    /**
     *  Update roadmap settings
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateRoadmapSettings?: Maybe<RoadmapUpdateSettingsPayload>;
};

export type RoadmapsMutationAddRoadmapDependencyArgs = {
    input: RoadmapToggleDependencyInput;
    sourceARI: Scalars["ID"]["input"];
};

export type RoadmapsMutationAddRoadmapItemArgs = {
    input: RoadmapAddItemInput;
    sourceARI: Scalars["ID"]["input"];
};

export type RoadmapsMutationRemoveRoadmapDependencyArgs = {
    input: RoadmapToggleDependencyInput;
    sourceARI: Scalars["ID"]["input"];
};

export type RoadmapsMutationResolveRoadmapHealthcheckArgs = {
    input: RoadmapResolveHealthcheckInput;
    sourceARI: Scalars["ID"]["input"];
};

export type RoadmapsMutationScheduleRoadmapItemsArgs = {
    input: RoadmapScheduleItemsInput;
    sourceARI: Scalars["ID"]["input"];
};

export type RoadmapsMutationUpdateRoadmapItemArgs = {
    input: RoadmapUpdateItemInput;
    sourceARI: Scalars["ID"]["input"];
};

export type RoadmapsMutationUpdateRoadmapSettingsArgs = {
    input: RoadmapUpdateSettingsInput;
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQuery = {
    __typename?: "RoadmapsQuery";
    /**
     * Get goal configuration for the roadmap
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapAriGoals?: Maybe<RoadmapAriGoals>;
    /**
     * Get fields derived from applied filters
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapDeriveFields: Array<Maybe<RoadmapField>>;
    /**
     * Get filter configuration for the roadmap
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapFilterConfiguration?: Maybe<RoadmapFilterConfiguration>;
    /**
     * Get the ids of items that match the quick filters or custom filters
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapFilterItems: Array<Scalars["ID"]["output"]>;
    /**
     * Lookup details of a roadmap.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapForSource?: Maybe<RoadmapDetails>;
    /**
     * Get multiple items.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapItemByIds?: Maybe<Array<Maybe<RoadmapItem>>>;
    /**
     * Get subtasks of the items
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    roadmapSubtasksByIds?: Maybe<RoadmapSubtasksWithStatusCategories>;
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapAriGoalsArgs = {
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapDeriveFieldsArgs = {
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    jqlContexts?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapFilterConfigurationArgs = {
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapFilterItemsArgs = {
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    quickFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapForSourceArgs = {
    locationARI?: InputMaybe<Scalars["ID"]["input"]>;
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapItemByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
    sourceARI: Scalars["ID"]["input"];
};

/** Top level grouping of potential roadmap queries */
export type RoadmapsQueryRoadmapSubtasksByIdsArgs = {
    itemIds: Array<Scalars["ID"]["input"]>;
    sourceARI: Scalars["ID"]["input"];
};

export type RoleAssignment = {
    principal: RoleAssignmentPrincipalInput;
    roleId: Scalars["ID"]["input"];
};

export type RoleAssignmentPrincipalInput = {
    principalId: Scalars["ID"]["input"];
    principalType: RoleAssignmentPrincipalType;
};

export enum RoleAssignmentPrincipalType {
    AccessClass = "ACCESS_CLASS",
    Group = "GROUP",
    Team = "TEAM",
    User = "USER"
}

/**
 * #################### RESULTS: SQLSlowQuery #####################
 * #################### RESULTS: SQLSchemaSize  #####################
 */
export type SqlSchemaSizeLogResponse = {
    __typename?: "SQLSchemaSizeLogResponse";
    /**
     * The database size
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    databaseSize: Scalars["String"]["output"];
};

/**
 * #################### INPUT SQLSlowQuery #####################
 * #################### RESULTS: SQLSlowQuery  #####################
 */
export type SqlSlowQueryLogsResponse = {
    __typename?: "SQLSlowQueryLogsResponse";
    /**
     * Average query execution time in milliseconds
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    avgQueryExecutionTime: Scalars["Float"]["output"];
    /**
     * p95 query execution time in milliseconds
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    percentileQueryExecutionTime: Scalars["Float"]["output"];
    /**
     * The SQL statement
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    query: Scalars["String"]["output"];
    /**
     * Number of times the SQL statement was called
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    queryCount: Scalars["Int"]["output"];
    /**
     * Average number of rows returned
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    rowsReturned: Scalars["Int"]["output"];
    /**
     * Average number of rows scanned
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    rowsScanned: Scalars["Int"]["output"];
};

/** A type that represents a sandbox product. */
export type Sandbox = {
    __typename?: "Sandbox";
    /** The event history of the sandbox product. */
    events: Array<SandboxEvent>;
    /** The offline status of the sandbox product. */
    ifOffline: Scalars["Boolean"]["output"];
    /** The ID of the organization the sandbox cloud belongs to. */
    orgId: Scalars["ID"]["output"];
    /** The ID of the sandbox's parent cloud. */
    parentCloudId: Scalars["ID"]["output"];
    /**
     * The key of the sandbox product.
     * Possible values are
     *   * jira-core.ondemand
     *   * jira-software.ondemand
     *   * jira-servicedesk.ondemand
     *   * jira-product-discovery
     *   * confluence.ondemand
     */
    productKey: Scalars["String"]["output"];
    /** The ID of the sandbox cloud. */
    sandboxCloudId: Scalars["ID"]["output"];
};

/** A type that represents a sandbox event. */
export type SandboxEvent = {
    __typename?: "SandboxEvent";
    /** The sandbox event type. */
    event: SandboxEventType;
    /** The sandbox event group ID. */
    groupId: Scalars["String"]["output"];
    /** The ID of the organization the sandbox cloud belongs to. */
    orgId: Scalars["ID"]["output"];
    /**
     * The key of the sandbox product.
     * Possible values are
     *   * jira-core.ondemand
     *   * jira-software.ondemand
     *   * jira-servicedesk.ondemand
     *   * jira-product-discovery
     *   * confluence.ondemand
     */
    productKey: Scalars["String"]["output"];
    /** The sandbox event result. */
    result: SandboxEventResult;
    /** The ID of the sandbox cloud. */
    sandboxCloudId: Scalars["ID"]["output"];
    /** The sandbox event source. */
    source: SandboxEventSource;
    /** The sandbox event status. */
    status: SandboxEventStatus;
    /** The sandbox event timestamp. */
    timestamp: Scalars["Float"]["output"];
};

/** An enum of the possible values of a sandbox event result. */
export enum SandboxEventResult {
    Failed = "failed",
    Incomplete = "incomplete",
    Successful = "successful",
    Unknown = "unknown"
}

/** An enum of the possible values of a sandbox event source. */
export enum SandboxEventSource {
    Admin = "admin",
    System = "system",
    User = "user"
}

/** An enum of the possible values of a sandbox event status. */
export enum SandboxEventStatus {
    AwaitingReplay = "awaiting_replay",
    Cancelled = "cancelled",
    Completed = "completed",
    Started = "started"
}

/** An enum of the possible values of a sandbox event type. */
export enum SandboxEventType {
    Create = "create",
    DataClone = "data_clone",
    DataCloneSelective = "data_clone_selective",
    HardDelete = "hard_delete",
    Reset = "reset",
    Reshard = "reshard",
    Rollback = "rollback",
    SoftDelete = "soft_delete"
}

/** The top-level sandbox query type. */
export type SandboxQuery = {
    __typename?: "SandboxQuery";
    /**
     * Fetch all sandbox products of a given organization.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    sandboxes: Array<Sandbox>;
};

/** The top-level sandbox query type. */
export type SandboxQuerySandboxesArgs = {
    orgId: Scalars["ID"]["input"];
};

/** The top-level sandbox subscription type. */
export type SandboxSubscription = {
    __typename?: "SandboxSubscription";
    /**
     * A subscription field that subscribes to the creation of sandbox events.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    onSandboxEventCreated: SandboxEvent;
};

/** The top-level sandbox subscription type. */
export type SandboxSubscriptionOnSandboxEventCreatedArgs = {
    orgId: Scalars["ID"]["input"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type SaveReactionResponse = {
    __typename?: "SaveReactionResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ari: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    containerAri: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    emojiId: Scalars["String"]["output"];
};

export type ScanPolarisProjectInput = {
    project: Scalars["ID"]["input"];
    refresh?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SchedulePublishInfo = {
    __typename?: "SchedulePublishInfo";
    date?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
    minorEdit?: Maybe<Scalars["Boolean"]["output"]>;
    restrictions?: Maybe<ScheduledRestrictions>;
    targetLocation?: Maybe<TargetLocation>;
    targetType?: Maybe<Scalars["String"]["output"]>;
    versionComment?: Maybe<Scalars["String"]["output"]>;
};

export type ScheduledPublishSummary = {
    __typename?: "ScheduledPublishSummary";
    isScheduled?: Maybe<Scalars["Boolean"]["output"]>;
    when?: Maybe<Scalars["String"]["output"]>;
};

export type ScheduledRestriction = {
    __typename?: "ScheduledRestriction";
    group?: Maybe<PaginatedGroupList>;
    personConnection?: Maybe<ConfluencePersonConnection>;
};

export type ScheduledRestrictions = {
    __typename?: "ScheduledRestrictions";
    read?: Maybe<ScheduledRestriction>;
    update?: Maybe<ScheduledRestriction>;
};

export enum Scope {
    /** outbound-auth */
    AdminContainer = "ADMIN_CONTAINER",
    ApiAccess = "API_ACCESS",
    /**
     * jira - granular scopes.
     * Each Jira Mutation and Query should have one or more of these in an `@scope` tag and one of the non-granular scopes above
     */
    ApplicationRoleRead = "APPLICATION_ROLE_READ",
    AsyncTaskDelete = "ASYNC_TASK_DELETE",
    AttachmentDelete = "ATTACHMENT_DELETE",
    AttachmentRead = "ATTACHMENT_READ",
    AttachmentWrite = "ATTACHMENT_WRITE",
    AuditLogRead = "AUDIT_LOG_READ",
    AuthConfluenceUser = "AUTH_CONFLUENCE_USER",
    AvatarDelete = "AVATAR_DELETE",
    AvatarRead = "AVATAR_READ",
    AvatarWrite = "AVATAR_WRITE",
    /** papi */
    CatalogRead = "CATALOG_READ",
    CommentDelete = "COMMENT_DELETE",
    CommentPropertyDelete = "COMMENT_PROPERTY_DELETE",
    CommentPropertyRead = "COMMENT_PROPERTY_READ",
    CommentPropertyWrite = "COMMENT_PROPERTY_WRITE",
    CommentRead = "COMMENT_READ",
    CommentWrite = "COMMENT_WRITE",
    /** compass */
    CompassAtlassianExternal = "COMPASS_ATLASSIAN_EXTERNAL",
    /** confluence */
    ConfluenceAtlassianExternal = "CONFLUENCE_ATLASSIAN_EXTERNAL",
    CustomFieldContextualConfigurationRead = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_READ",
    CustomFieldContextualConfigurationWrite = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_WRITE",
    DashboardDelete = "DASHBOARD_DELETE",
    DashboardPropertyDelete = "DASHBOARD_PROPERTY_DELETE",
    DashboardPropertyRead = "DASHBOARD_PROPERTY_READ",
    DashboardPropertyWrite = "DASHBOARD_PROPERTY_WRITE",
    DashboardRead = "DASHBOARD_READ",
    DashboardWrite = "DASHBOARD_WRITE",
    DeleteConfluenceAttachment = "DELETE_CONFLUENCE_ATTACHMENT",
    DeleteConfluenceBlogpost = "DELETE_CONFLUENCE_BLOGPOST",
    DeleteConfluenceComment = "DELETE_CONFLUENCE_COMMENT",
    DeleteConfluenceCustomContent = "DELETE_CONFLUENCE_CUSTOM_CONTENT",
    DeleteConfluencePage = "DELETE_CONFLUENCE_PAGE",
    DeleteConfluenceSpace = "DELETE_CONFLUENCE_SPACE",
    DeleteJswBoardScopeAdmin = "DELETE_JSW_BOARD_SCOPE_ADMIN",
    DeleteJswSprint = "DELETE_JSW_SPRINT",
    DeleteOrganization = "DELETE_ORGANIZATION",
    DeleteOrganizationProperty = "DELETE_ORGANIZATION_PROPERTY",
    DeleteOrganizationUser = "DELETE_ORGANIZATION_USER",
    DeleteRequesttypeProperty = "DELETE_REQUESTTYPE_PROPERTY",
    DeleteRequestFeedback = "DELETE_REQUEST_FEEDBACK",
    DeleteRequestNotification = "DELETE_REQUEST_NOTIFICATION",
    DeleteRequestParticipant = "DELETE_REQUEST_PARTICIPANT",
    DeleteServicedeskCustomer = "DELETE_SERVICEDESK_CUSTOMER",
    DeleteServicedeskOrganization = "DELETE_SERVICEDESK_ORGANIZATION",
    DeleteServicedeskProperty = "DELETE_SERVICEDESK_PROPERTY",
    FieldConfigurationDelete = "FIELD_CONFIGURATION_DELETE",
    FieldConfigurationRead = "FIELD_CONFIGURATION_READ",
    FieldConfigurationSchemeDelete = "FIELD_CONFIGURATION_SCHEME_DELETE",
    FieldConfigurationSchemeRead = "FIELD_CONFIGURATION_SCHEME_READ",
    FieldConfigurationSchemeWrite = "FIELD_CONFIGURATION_SCHEME_WRITE",
    FieldConfigurationWrite = "FIELD_CONFIGURATION_WRITE",
    FieldDefaultValueRead = "FIELD_DEFAULT_VALUE_READ",
    FieldDefaultValueWrite = "FIELD_DEFAULT_VALUE_WRITE",
    FieldDelete = "FIELD_DELETE",
    FieldOptionsRead = "FIELD_OPTIONS_READ",
    FieldOptionDelete = "FIELD_OPTION_DELETE",
    FieldOptionRead = "FIELD_OPTION_READ",
    FieldOptionWrite = "FIELD_OPTION_WRITE",
    FieldRead = "FIELD_READ",
    FieldWrite = "FIELD_WRITE",
    FilterColumnDelete = "FILTER_COLUMN_DELETE",
    FilterColumnRead = "FILTER_COLUMN_READ",
    FilterColumnWrite = "FILTER_COLUMN_WRITE",
    FilterDefaultShareScopeRead = "FILTER_DEFAULT_SHARE_SCOPE_READ",
    FilterDefaultShareScopeWrite = "FILTER_DEFAULT_SHARE_SCOPE_WRITE",
    FilterDelete = "FILTER_DELETE",
    FilterRead = "FILTER_READ",
    FilterWrite = "FILTER_WRITE",
    GroupDelete = "GROUP_DELETE",
    GroupRead = "GROUP_READ",
    GroupWrite = "GROUP_WRITE",
    IdentityAtlassianExternal = "IDENTITY_ATLASSIAN_EXTERNAL",
    InstanceConfigurationRead = "INSTANCE_CONFIGURATION_READ",
    InstanceConfigurationWrite = "INSTANCE_CONFIGURATION_WRITE",
    IssueAdjustmentsDelete = "ISSUE_ADJUSTMENTS_DELETE",
    IssueAdjustmentsRead = "ISSUE_ADJUSTMENTS_READ",
    IssueAdjustmentsWrite = "ISSUE_ADJUSTMENTS_WRITE",
    IssueChangelogRead = "ISSUE_CHANGELOG_READ",
    IssueDelete = "ISSUE_DELETE",
    IssueDetailsRead = "ISSUE_DETAILS_READ",
    IssueEventRead = "ISSUE_EVENT_READ",
    IssueFieldValuesRead = "ISSUE_FIELD_VALUES_READ",
    IssueLinkDelete = "ISSUE_LINK_DELETE",
    IssueLinkRead = "ISSUE_LINK_READ",
    IssueLinkTypeDelete = "ISSUE_LINK_TYPE_DELETE",
    IssueLinkTypeRead = "ISSUE_LINK_TYPE_READ",
    IssueLinkTypeWrite = "ISSUE_LINK_TYPE_WRITE",
    IssueLinkWrite = "ISSUE_LINK_WRITE",
    IssueMetaRead = "ISSUE_META_READ",
    IssuePropertyDelete = "ISSUE_PROPERTY_DELETE",
    IssuePropertyRead = "ISSUE_PROPERTY_READ",
    IssuePropertyWrite = "ISSUE_PROPERTY_WRITE",
    IssueRead = "ISSUE_READ",
    IssueRemoteLinkDelete = "ISSUE_REMOTE_LINK_DELETE",
    IssueRemoteLinkRead = "ISSUE_REMOTE_LINK_READ",
    IssueRemoteLinkWrite = "ISSUE_REMOTE_LINK_WRITE",
    IssueSecurityLevelRead = "ISSUE_SECURITY_LEVEL_READ",
    IssueSecuritySchemeRead = "ISSUE_SECURITY_SCHEME_READ",
    IssueStatusRead = "ISSUE_STATUS_READ",
    IssueTimeTrackingRead = "ISSUE_TIME_TRACKING_READ",
    IssueTimeTrackingWrite = "ISSUE_TIME_TRACKING_WRITE",
    IssueTransitionRead = "ISSUE_TRANSITION_READ",
    IssueTypeDelete = "ISSUE_TYPE_DELETE",
    IssueTypeHierarchyRead = "ISSUE_TYPE_HIERARCHY_READ",
    IssueTypePropertyDelete = "ISSUE_TYPE_PROPERTY_DELETE",
    IssueTypePropertyRead = "ISSUE_TYPE_PROPERTY_READ",
    IssueTypePropertyWrite = "ISSUE_TYPE_PROPERTY_WRITE",
    IssueTypeRead = "ISSUE_TYPE_READ",
    IssueTypeSchemeDelete = "ISSUE_TYPE_SCHEME_DELETE",
    IssueTypeSchemeRead = "ISSUE_TYPE_SCHEME_READ",
    IssueTypeSchemeWrite = "ISSUE_TYPE_SCHEME_WRITE",
    IssueTypeScreenSchemeDelete = "ISSUE_TYPE_SCREEN_SCHEME_DELETE",
    IssueTypeScreenSchemeRead = "ISSUE_TYPE_SCREEN_SCHEME_READ",
    IssueTypeScreenSchemeWrite = "ISSUE_TYPE_SCREEN_SCHEME_WRITE",
    IssueTypeWrite = "ISSUE_TYPE_WRITE",
    IssueVotesRead = "ISSUE_VOTES_READ",
    IssueVoteRead = "ISSUE_VOTE_READ",
    IssueVoteWrite = "ISSUE_VOTE_WRITE",
    IssueWatcherRead = "ISSUE_WATCHER_READ",
    IssueWatcherWrite = "ISSUE_WATCHER_WRITE",
    IssueWorklogDelete = "ISSUE_WORKLOG_DELETE",
    IssueWorklogPropertyDelete = "ISSUE_WORKLOG_PROPERTY_DELETE",
    IssueWorklogPropertyRead = "ISSUE_WORKLOG_PROPERTY_READ",
    IssueWorklogPropertyWrite = "ISSUE_WORKLOG_PROPERTY_WRITE",
    IssueWorklogRead = "ISSUE_WORKLOG_READ",
    IssueWorklogWrite = "ISSUE_WORKLOG_WRITE",
    IssueWrite = "ISSUE_WRITE",
    JiraAtlassianExternal = "JIRA_ATLASSIAN_EXTERNAL",
    JiraExpressionsRead = "JIRA_EXPRESSIONS_READ",
    JqlRead = "JQL_READ",
    JqlValidate = "JQL_VALIDATE",
    LabelRead = "LABEL_READ",
    LicenseRead = "LICENSE_READ",
    /** ecosystem */
    ManageApp = "MANAGE_APP",
    ManageDirectory = "MANAGE_DIRECTORY",
    ManageJiraConfiguration = "MANAGE_JIRA_CONFIGURATION",
    ManageJiraDataProvider = "MANAGE_JIRA_DATA_PROVIDER",
    ManageJiraProject = "MANAGE_JIRA_PROJECT",
    ManageJiraWebhook = "MANAGE_JIRA_WEBHOOK",
    /** identity */
    ManageOrg = "MANAGE_ORG",
    ManageOrgPublicApis = "MANAGE_ORG_PUBLIC_APIS",
    ManageServicedeskCustomer = "MANAGE_SERVICEDESK_CUSTOMER",
    /** platform */
    MigrateConfluence = "MIGRATE_CONFLUENCE",
    NotificationSchemeRead = "NOTIFICATION_SCHEME_READ",
    NotificationSend = "NOTIFICATION_SEND",
    PermissionDelete = "PERMISSION_DELETE",
    PermissionRead = "PERMISSION_READ",
    PermissionSchemeDelete = "PERMISSION_SCHEME_DELETE",
    PermissionSchemeRead = "PERMISSION_SCHEME_READ",
    PermissionSchemeWrite = "PERMISSION_SCHEME_WRITE",
    PermissionWrite = "PERMISSION_WRITE",
    PriorityRead = "PRIORITY_READ",
    ProjectAvatarDelete = "PROJECT_AVATAR_DELETE",
    ProjectAvatarRead = "PROJECT_AVATAR_READ",
    ProjectAvatarWrite = "PROJECT_AVATAR_WRITE",
    ProjectCategoryDelete = "PROJECT_CATEGORY_DELETE",
    ProjectCategoryRead = "PROJECT_CATEGORY_READ",
    ProjectCategoryWrite = "PROJECT_CATEGORY_WRITE",
    ProjectComponentDelete = "PROJECT_COMPONENT_DELETE",
    ProjectComponentRead = "PROJECT_COMPONENT_READ",
    ProjectComponentWrite = "PROJECT_COMPONENT_WRITE",
    ProjectDelete = "PROJECT_DELETE",
    ProjectEmailRead = "PROJECT_EMAIL_READ",
    ProjectEmailWrite = "PROJECT_EMAIL_WRITE",
    ProjectFeatureRead = "PROJECT_FEATURE_READ",
    ProjectFeatureWrite = "PROJECT_FEATURE_WRITE",
    ProjectPropertyDelete = "PROJECT_PROPERTY_DELETE",
    ProjectPropertyRead = "PROJECT_PROPERTY_READ",
    ProjectPropertyWrite = "PROJECT_PROPERTY_WRITE",
    ProjectRead = "PROJECT_READ",
    ProjectRoleDelete = "PROJECT_ROLE_DELETE",
    ProjectRoleRead = "PROJECT_ROLE_READ",
    ProjectRoleWrite = "PROJECT_ROLE_WRITE",
    ProjectTypeRead = "PROJECT_TYPE_READ",
    ProjectVersionDelete = "PROJECT_VERSION_DELETE",
    ProjectVersionRead = "PROJECT_VERSION_READ",
    ProjectVersionWrite = "PROJECT_VERSION_WRITE",
    ProjectWrite = "PROJECT_WRITE",
    /** bitbucket_repository_access_token */
    PullRequest = "PULL_REQUEST",
    PullRequestWrite = "PULL_REQUEST_WRITE",
    ReadAccount = "READ_ACCOUNT",
    ReadCompassAttentionItem = "READ_COMPASS_ATTENTION_ITEM",
    ReadCompassComponent = "READ_COMPASS_COMPONENT",
    ReadCompassEvent = "READ_COMPASS_EVENT",
    ReadCompassMetric = "READ_COMPASS_METRIC",
    ReadCompassScorecard = "READ_COMPASS_SCORECARD",
    ReadConfluenceAttachment = "READ_CONFLUENCE_ATTACHMENT",
    ReadConfluenceAuditLog = "READ_CONFLUENCE_AUDIT_LOG",
    ReadConfluenceBlogpost = "READ_CONFLUENCE_BLOGPOST",
    ReadConfluenceComment = "READ_CONFLUENCE_COMMENT",
    ReadConfluenceConfiguration = "READ_CONFLUENCE_CONFIGURATION",
    ReadConfluenceContentAnalytics = "READ_CONFLUENCE_CONTENT_ANALYTICS",
    ReadConfluenceContentMetadata = "READ_CONFLUENCE_CONTENT_METADATA",
    ReadConfluenceContentPermission = "READ_CONFLUENCE_CONTENT_PERMISSION",
    ReadConfluenceContentProperty = "READ_CONFLUENCE_CONTENT_PROPERTY",
    ReadConfluenceContentRestriction = "READ_CONFLUENCE_CONTENT_RESTRICTION",
    ReadConfluenceCustomContent = "READ_CONFLUENCE_CUSTOM_CONTENT",
    ReadConfluenceGroup = "READ_CONFLUENCE_GROUP",
    ReadConfluenceInlineTask = "READ_CONFLUENCE_INLINE_TASK",
    ReadConfluenceLabel = "READ_CONFLUENCE_LABEL",
    ReadConfluencePage = "READ_CONFLUENCE_PAGE",
    ReadConfluenceRelation = "READ_CONFLUENCE_RELATION",
    ReadConfluenceSpace = "READ_CONFLUENCE_SPACE",
    ReadConfluenceSpacePermission = "READ_CONFLUENCE_SPACE_PERMISSION",
    ReadConfluenceSpaceProperty = "READ_CONFLUENCE_SPACE_PROPERTY",
    ReadConfluenceSpaceSetting = "READ_CONFLUENCE_SPACE_SETTING",
    ReadConfluenceTemplate = "READ_CONFLUENCE_TEMPLATE",
    ReadConfluenceUser = "READ_CONFLUENCE_USER",
    ReadConfluenceUserProperty = "READ_CONFLUENCE_USER_PROPERTY",
    ReadConfluenceWatcher = "READ_CONFLUENCE_WATCHER",
    ReadContainer = "READ_CONTAINER",
    /**
     * jira-servicedesk - granular
     * Each JSM Mutation and Query should have one or more of these in an `@scope` tag and one of the non-granular scopes above.
     * You can mix them with Jira scopes if needed.
     */
    ReadCustomer = "READ_CUSTOMER",
    ReadDesign = "READ_DESIGN",
    /**
     * jira - non granular
     * Please add a granular scope as well.
     */
    ReadJiraUser = "READ_JIRA_USER",
    ReadJiraWork = "READ_JIRA_WORK",
    /**
     * jsw scopes
     * Note - JSW does not have non granular scopes so it does not need two scope tags like JSM/Jira
     */
    ReadJswBoardScope = "READ_JSW_BOARD_SCOPE",
    ReadJswBoardScopeAdmin = "READ_JSW_BOARD_SCOPE_ADMIN",
    ReadJswBuild = "READ_JSW_BUILD",
    ReadJswDeployment = "READ_JSW_DEPLOYMENT",
    ReadJswEpic = "READ_JSW_EPIC",
    ReadJswFeatureFlag = "READ_JSW_FEATURE_FLAG",
    ReadJswIssue = "READ_JSW_ISSUE",
    ReadJswRemoteLink = "READ_JSW_REMOTE_LINK",
    ReadJswSourceCode = "READ_JSW_SOURCE_CODE",
    ReadJswSprint = "READ_JSW_SPRINT",
    ReadKnowledgebase = "READ_KNOWLEDGEBASE",
    ReadMe = "READ_ME",
    /** notification-log */
    ReadNotifications = "READ_NOTIFICATIONS",
    ReadOrganization = "READ_ORGANIZATION",
    ReadOrganizationProperty = "READ_ORGANIZATION_PROPERTY",
    ReadOrganizationUser = "READ_ORGANIZATION_USER",
    ReadQueue = "READ_QUEUE",
    ReadRequest = "READ_REQUEST",
    ReadRequesttype = "READ_REQUESTTYPE",
    ReadRequesttypeProperty = "READ_REQUESTTYPE_PROPERTY",
    ReadRequestAction = "READ_REQUEST_ACTION",
    ReadRequestApproval = "READ_REQUEST_APPROVAL",
    ReadRequestAttachment = "READ_REQUEST_ATTACHMENT",
    ReadRequestComment = "READ_REQUEST_COMMENT",
    ReadRequestFeedback = "READ_REQUEST_FEEDBACK",
    ReadRequestNotification = "READ_REQUEST_NOTIFICATION",
    ReadRequestParticipant = "READ_REQUEST_PARTICIPANT",
    ReadRequestSla = "READ_REQUEST_SLA",
    ReadRequestStatus = "READ_REQUEST_STATUS",
    ReadServicedesk = "READ_SERVICEDESK",
    ReadServicedeskCustomer = "READ_SERVICEDESK_CUSTOMER",
    ReadServicedeskOrganization = "READ_SERVICEDESK_ORGANIZATION",
    ReadServicedeskProperty = "READ_SERVICEDESK_PROPERTY",
    /**
     * jira-servicedesk - non-granular
     * Please add a granular scope as well.
     */
    ReadServicedeskRequest = "READ_SERVICEDESK_REQUEST",
    /** teams */
    ReadTeam = "READ_TEAM",
    ReadTeamMembers = "READ_TEAM_MEMBERS",
    ReadTownsquareComment = "READ_TOWNSQUARE_COMMENT",
    ReadTownsquareGoal = "READ_TOWNSQUARE_GOAL",
    /** townsquare (Atlas) */
    ReadTownsquareProject = "READ_TOWNSQUARE_PROJECT",
    ReadTownsquareWorkspace = "READ_TOWNSQUARE_WORKSPACE",
    ResolutionRead = "RESOLUTION_READ",
    ScreenableFieldDelete = "SCREENABLE_FIELD_DELETE",
    ScreenableFieldRead = "SCREENABLE_FIELD_READ",
    ScreenableFieldWrite = "SCREENABLE_FIELD_WRITE",
    ScreenDelete = "SCREEN_DELETE",
    ScreenFieldRead = "SCREEN_FIELD_READ",
    ScreenRead = "SCREEN_READ",
    ScreenSchemeDelete = "SCREEN_SCHEME_DELETE",
    ScreenSchemeRead = "SCREEN_SCHEME_READ",
    ScreenSchemeWrite = "SCREEN_SCHEME_WRITE",
    ScreenTabDelete = "SCREEN_TAB_DELETE",
    ScreenTabRead = "SCREEN_TAB_READ",
    ScreenTabWrite = "SCREEN_TAB_WRITE",
    ScreenWrite = "SCREEN_WRITE",
    StatusRead = "STATUS_READ",
    StorageApp = "STORAGE_APP",
    /** trello */
    TrelloAtlassianExternal = "TRELLO_ATLASSIAN_EXTERNAL",
    UserColumnsRead = "USER_COLUMNS_READ",
    UserConfigurationDelete = "USER_CONFIGURATION_DELETE",
    UserConfigurationRead = "USER_CONFIGURATION_READ",
    UserConfigurationWrite = "USER_CONFIGURATION_WRITE",
    UserPropertyDelete = "USER_PROPERTY_DELETE",
    UserPropertyRead = "USER_PROPERTY_READ",
    UserPropertyWrite = "USER_PROPERTY_WRITE",
    UserRead = "USER_READ",
    ViewUserprofile = "VIEW_USERPROFILE",
    WebhookDelete = "WEBHOOK_DELETE",
    WebhookRead = "WEBHOOK_READ",
    WebhookWrite = "WEBHOOK_WRITE",
    WorkflowDelete = "WORKFLOW_DELETE",
    WorkflowPropertyDelete = "WORKFLOW_PROPERTY_DELETE",
    WorkflowPropertyRead = "WORKFLOW_PROPERTY_READ",
    WorkflowPropertyWrite = "WORKFLOW_PROPERTY_WRITE",
    WorkflowRead = "WORKFLOW_READ",
    WorkflowSchemeDelete = "WORKFLOW_SCHEME_DELETE",
    WorkflowSchemeRead = "WORKFLOW_SCHEME_READ",
    WorkflowSchemeWrite = "WORKFLOW_SCHEME_WRITE",
    WorkflowWrite = "WORKFLOW_WRITE",
    WriteCompassComponent = "WRITE_COMPASS_COMPONENT",
    WriteCompassEvent = "WRITE_COMPASS_EVENT",
    WriteCompassMetric = "WRITE_COMPASS_METRIC",
    WriteCompassScorecard = "WRITE_COMPASS_SCORECARD",
    WriteConfluenceAttachment = "WRITE_CONFLUENCE_ATTACHMENT",
    WriteConfluenceAuditLog = "WRITE_CONFLUENCE_AUDIT_LOG",
    WriteConfluenceBlogpost = "WRITE_CONFLUENCE_BLOGPOST",
    WriteConfluenceComment = "WRITE_CONFLUENCE_COMMENT",
    WriteConfluenceConfiguration = "WRITE_CONFLUENCE_CONFIGURATION",
    WriteConfluenceContentProperty = "WRITE_CONFLUENCE_CONTENT_PROPERTY",
    WriteConfluenceContentRestriction = "WRITE_CONFLUENCE_CONTENT_RESTRICTION",
    WriteConfluenceCustomContent = "WRITE_CONFLUENCE_CUSTOM_CONTENT",
    WriteConfluenceGroup = "WRITE_CONFLUENCE_GROUP",
    WriteConfluenceInlineTask = "WRITE_CONFLUENCE_INLINE_TASK",
    WriteConfluenceLabel = "WRITE_CONFLUENCE_LABEL",
    WriteConfluencePage = "WRITE_CONFLUENCE_PAGE",
    WriteConfluenceRelation = "WRITE_CONFLUENCE_RELATION",
    WriteConfluenceSpace = "WRITE_CONFLUENCE_SPACE",
    WriteConfluenceSpacePermission = "WRITE_CONFLUENCE_SPACE_PERMISSION",
    WriteConfluenceSpaceProperty = "WRITE_CONFLUENCE_SPACE_PROPERTY",
    WriteConfluenceSpaceSetting = "WRITE_CONFLUENCE_SPACE_SETTING",
    WriteConfluenceTemplate = "WRITE_CONFLUENCE_TEMPLATE",
    WriteConfluenceUserProperty = "WRITE_CONFLUENCE_USER_PROPERTY",
    WriteConfluenceWatcher = "WRITE_CONFLUENCE_WATCHER",
    WriteContainer = "WRITE_CONTAINER",
    WriteCustomer = "WRITE_CUSTOMER",
    WriteDesign = "WRITE_DESIGN",
    WriteJiraWork = "WRITE_JIRA_WORK",
    WriteJswBoardScope = "WRITE_JSW_BOARD_SCOPE",
    WriteJswBoardScopeAdmin = "WRITE_JSW_BOARD_SCOPE_ADMIN",
    WriteJswBuild = "WRITE_JSW_BUILD",
    WriteJswDeployment = "WRITE_JSW_DEPLOYMENT",
    WriteJswEpic = "WRITE_JSW_EPIC",
    WriteJswFeatureFlag = "WRITE_JSW_FEATURE_FLAG",
    WriteJswIssue = "WRITE_JSW_ISSUE",
    WriteJswRemoteLink = "WRITE_JSW_REMOTE_LINK",
    WriteJswSourceCode = "WRITE_JSW_SOURCE_CODE",
    WriteJswSprint = "WRITE_JSW_SPRINT",
    WriteNotifications = "WRITE_NOTIFICATIONS",
    WriteOrganization = "WRITE_ORGANIZATION",
    WriteOrganizationProperty = "WRITE_ORGANIZATION_PROPERTY",
    WriteOrganizationUser = "WRITE_ORGANIZATION_USER",
    WriteRequest = "WRITE_REQUEST",
    WriteRequesttype = "WRITE_REQUESTTYPE",
    WriteRequesttypeProperty = "WRITE_REQUESTTYPE_PROPERTY",
    WriteRequestApproval = "WRITE_REQUEST_APPROVAL",
    WriteRequestAttachment = "WRITE_REQUEST_ATTACHMENT",
    WriteRequestComment = "WRITE_REQUEST_COMMENT",
    WriteRequestFeedback = "WRITE_REQUEST_FEEDBACK",
    WriteRequestNotification = "WRITE_REQUEST_NOTIFICATION",
    WriteRequestParticipant = "WRITE_REQUEST_PARTICIPANT",
    WriteRequestStatus = "WRITE_REQUEST_STATUS",
    WriteServicedesk = "WRITE_SERVICEDESK",
    WriteServicedeskCustomer = "WRITE_SERVICEDESK_CUSTOMER",
    WriteServicedeskOrganization = "WRITE_SERVICEDESK_ORGANIZATION",
    WriteServicedeskProperty = "WRITE_SERVICEDESK_PROPERTY",
    WriteServicedeskRequest = "WRITE_SERVICEDESK_REQUEST",
    WriteTownsquareGoal = "WRITE_TOWNSQUARE_GOAL",
    WriteTownsquareProject = "WRITE_TOWNSQUARE_PROJECT",
    WriteTownsquareRelationship = "WRITE_TOWNSQUARE_RELATIONSHIP"
}

export type ScopeSprintIssue = {
    __typename?: "ScopeSprintIssue";
    /** the estimate on the issue */
    estimate: Scalars["Float"]["output"];
    /** issue key */
    issueKey: Scalars["String"]["output"];
    /** issue description */
    issueSummary: Scalars["String"]["output"];
};

export type ScreenLookAndFeel = {
    __typename?: "ScreenLookAndFeel";
    background?: Maybe<Scalars["String"]["output"]>;
    backgroundAttachment?: Maybe<Scalars["String"]["output"]>;
    backgroundBlendMode?: Maybe<Scalars["String"]["output"]>;
    backgroundClip?: Maybe<Scalars["String"]["output"]>;
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    backgroundImage?: Maybe<Scalars["String"]["output"]>;
    backgroundOrigin?: Maybe<Scalars["String"]["output"]>;
    backgroundPosition?: Maybe<Scalars["String"]["output"]>;
    backgroundRepeat?: Maybe<Scalars["String"]["output"]>;
    backgroundSize?: Maybe<Scalars["String"]["output"]>;
    gutterBottom?: Maybe<Scalars["String"]["output"]>;
    gutterLeft?: Maybe<Scalars["String"]["output"]>;
    gutterRight?: Maybe<Scalars["String"]["output"]>;
    gutterTop?: Maybe<Scalars["String"]["output"]>;
    layer?: Maybe<LayerScreenLookAndFeel>;
};

/** The AB test context that can be associated to a specific principal/scope. */
export type SearchAbTest = {
    __typename?: "SearchAbTest";
    abTestId?: Maybe<Scalars["String"]["output"]>;
    controlId?: Maybe<Scalars["String"]["output"]>;
    experimentId?: Maybe<Scalars["String"]["output"]>;
};

/** Metadata on any analytics related fields, these do not affect the search */
export type SearchAnalyticsInput = {
    queryVersion?: InputMaybe<Scalars["Int"]["input"]>;
    searchReferrerId?: InputMaybe<Scalars["String"]["input"]>;
    searchSessionId?: InputMaybe<Scalars["String"]["input"]>;
    /** The product which is running the experience e.g. confluence. */
    sourceProduct?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchBoardFilter = {
    negateProjectFilter?: InputMaybe<Scalars["Boolean"]["input"]>;
    projectARI?: InputMaybe<Scalars["ID"]["input"]>;
    userARI?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum SearchBoardProductType {
    Business = "BUSINESS",
    Software = "SOFTWARE"
}

export type SearchCommonFilter = {
    /** 1P AccountIds of the users. */
    contributorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for only entities that have match the date range for the specified field */
    range?: InputMaybe<SearchCommonRangeFilter>;
};

export type SearchCommonRangeFilter = {
    /** Created date filter */
    created?: InputMaybe<SearchCommonRangeFilterFields>;
    /** Last modified date filter */
    lastModified?: InputMaybe<SearchCommonRangeFilterFields>;
};

export type SearchCommonRangeFilterFields = {
    /** Specify the timestamp that the field should be greater than */
    gt?: InputMaybe<Scalars["String"]["input"]>;
    /** Specify the timestamp that the field should be less than */
    lt?: InputMaybe<Scalars["String"]["input"]>;
};

export enum SearchConfluenceDocumentStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export type SearchConfluenceEntity =
    | ConfluenceBlogPost
    | ConfluenceDatabase
    | ConfluenceEmbed
    | ConfluenceFolder
    | ConfluencePage
    | ConfluenceWhiteboard;

export type SearchConfluenceFilter = {
    /** Id of the pages which must be parent of the result. */
    ancestorIdsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Space or Page ARI under which the search will have to be made. Includes the space or page itself. Maps to Containers filter. */
    containerARIs?: InputMaybe<Array<Scalars["String"]["input"]>>;
    containerStatus?: InputMaybe<Array<InputMaybe<SearchContainerStatus>>>;
    /** Confluence document status */
    contentStatuses?: InputMaybe<Array<SearchConfluenceDocumentStatus>>;
    /** AccountIds of the users. */
    contributorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** AccountIds of the users. */
    creatorsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for Verified pages or blogposts */
    isVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Labels which must be present on the page or blogpost. */
    labelsFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for pages owned by particular users. The values should be Atlassian Account IDs. */
    owners?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for pages or blogposts with a specific page status */
    pageStatus?: InputMaybe<Array<Scalars["String"]["input"]>>;
    range?: InputMaybe<Array<InputMaybe<SearchConfluenceRangeFilter>>>;
    /** Space keys from which the results are desired. */
    spacesFilter?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for only entities that have a title that contains the given query */
    titleMatchOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * Add only product specific properties below. Generic properties must be in the SearchResult
 *
 * CONFLUENCE
 */
export type SearchConfluencePageBlogAttachment = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchConfluencePageBlogAttachment";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        confluenceEntity?: Maybe<SearchConfluenceEntity>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        createdDate?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        excerpt?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconCssClass?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        isVerified: Scalars["Boolean"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModified?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use `confluenceEntity` instead
         */
        pageEntity?: Maybe<ConfluencePage>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        socialSignal?: Maybe<SocialSignalSearch>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        space?: Maybe<SearchConfluenceResultSpace>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         * @deprecated Please use `space` instead
         */
        spaceEntity?: Maybe<ConfluenceSpace>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

/**
 * Add only product specific properties below. Generic properties must be in the SearchResult
 *
 * CONFLUENCE
 */
export type SearchConfluencePageBlogAttachmentSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

export enum SearchConfluenceRangeField {
    Created = "CREATED",
    Lastmodified = "LASTMODIFIED"
}

export type SearchConfluenceRangeFilter = {
    /** The field to use to calculate the range */
    field: SearchConfluenceRangeField;
    /** Specify the timestamp that the field should be greater than */
    gt?: InputMaybe<Scalars["String"]["input"]>;
    /** Specify the timestamp that the field should be less than */
    lt?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchConfluenceResultSpace = {
    __typename?: "SearchConfluenceResultSpace";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    alias?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webUiLink?: Maybe<Scalars["String"]["output"]>;
};

export type SearchConfluenceSpace = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchConfluenceSpace";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        alias?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entityId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconPath?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        key?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModified?: Maybe<Scalars["DateTime"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        socialSignal?: Maybe<SocialSignalSearch>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        spaceEntity?: Maybe<ConfluenceSpace>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        webUiLink?: Maybe<Scalars["String"]["output"]>;
    };

export type SearchConfluenceSpaceSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

export enum SearchContainerStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT"
}

export type SearchDefaultResult = SearchResult & {
    __typename?: "SearchDefaultResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

/** Context for the search experiment */
export type SearchExperimentContextInput = {
    /** experimentId to override the default experimentId for scraping purposes */
    experimentId?: InputMaybe<Scalars["String"]["input"]>;
    /** Context for Aggregator's experimentation, including L3 and pre-query phase */
    experimentLayers?: InputMaybe<Array<InputMaybe<SearchExperimentLayer>>>;
    /**
     * shadowExperimentId to shadow experimentId.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated This input is deprecated, use SearchExperimentLayer.shadowId
     */
    shadowExperimentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchExperimentLayer = {
    /** List of layers defined for each 1P and 3P product */
    definitions?: InputMaybe<Array<InputMaybe<SearchLayerDefinition>>>;
    /**
     * ID for the ranking layer's variant, e.g. cherry for L1.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Moving to productLayers/integrationLayers
     */
    layerId?: InputMaybe<Scalars["String"]["input"]>;
    /** ID for the Statsig layer */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Experiment ID for shadowing - currently used for Searcher-based layers.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Moving to productLayers/integrationLayers
     */
    shadowId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchExternalContainerFilter = {
    /** The container type */
    type: Scalars["String"]["input"];
    /** The list of containers */
    values: Array<Scalars["String"]["input"]>;
};

export type SearchExternalContentFormatFilter = {
    /** The content format type */
    type: Scalars["String"]["input"];
    /** The content formats */
    values: Array<Scalars["String"]["input"]>;
};

export type SearchExternalDepthFilter = {
    /** The depth values */
    depth: Scalars["Int"]["input"];
    /** The depth type */
    type: Scalars["String"]["input"];
};

export type SearchExternalFilter = {
    /** The list of containers */
    containers?: InputMaybe<Array<InputMaybe<SearchExternalContainerFilter>>>;
    /** The external content format filters */
    contentFormats?: InputMaybe<
        Array<InputMaybe<SearchExternalContentFormatFilter>>
    >;
    /** The depth of search */
    depth?: InputMaybe<Array<InputMaybe<SearchExternalDepthFilter>>>;
};

export type SearchFederatedEmailEntity = {
    __typename?: "SearchFederatedEmailEntity";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sender?: Maybe<SearchFederatedEmailUser>;
};

export type SearchFederatedEmailUser = {
    __typename?: "SearchFederatedEmailUser";
    email?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type SearchFederatedEntity = SearchFederatedEmailEntity;

export type SearchFieldLookAndFeel = {
    __typename?: "SearchFieldLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    color?: Maybe<Scalars["String"]["output"]>;
};

/** Filters to apply to a search */
export type SearchFilterInput = {
    /** Common filters that apply to all products */
    commonFilters?: InputMaybe<SearchCommonFilter>;
    /** Confluence specific filters */
    confluenceFilters?: InputMaybe<SearchConfluenceFilter>;
    /** ATI strings of which entities to search for */
    entities: Array<Scalars["String"]["input"]>;
    /** External filters */
    externalFilters?: InputMaybe<SearchExternalFilter>;
    /** Jira Board filters */
    jiraFilters?: InputMaybe<SearchJiraFilter>;
    /** ARIs of which workspaces, cloudIds or orgs to search in */
    locations: Array<Scalars["String"]["input"]>;
    /** Mercury filters */
    mercuryFilters?: InputMaybe<SearchMercuryFilter>;
    /** Third party search filters */
    thirdPartyFilters?: InputMaybe<SearchThirdPartyFilter>;
};

export type SearchInterleaverScrapingResult = {
    __typename?: "SearchInterleaverScrapingResult";
    rerankerRequestInJSON: Scalars["String"]["output"];
};

export enum SearchIssueStatusCategory {
    Done = "DONE",
    Open = "OPEN"
}

export type SearchItemConnection = {
    __typename?: "SearchItemConnection";
    /** AbTest details. Strictly used by the Confluence Search Team to run and identify experiments. */
    abTest?: Maybe<SearchAbTest>;
    /** The search results that are deferred (if any). The deferred edges enable a faster render of the initial page */
    deferredEdges?: Maybe<Array<SearchResultItemEdge>>;
    /** The search result items as per pagination specs */
    edges: Array<SearchResultItemEdge>;
    /** Scraping result for interleaving reranker. This is only returned if experience is for scraping. */
    interleaverScrapingResult?: Maybe<SearchInterleaverScrapingResult>;
    /** The page info as per pagination specs */
    pageInfo: PageInfo;
    /** Query info for the search */
    queryInfo?: Maybe<SearchQueryInfo>;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * totalCounts of search results for every product.
     *
     * Note - the entities are all rolled up to one product.
     * For example - Jira-project, issue, board etc are all rolled up to Jira.
     */
    totalCounts: Array<SearchProductCount>;
};

export type SearchJiraFilter = {
    /** boardFilter can have at most one element only - multiple project ARI's to filter by are not supported */
    boardFilter?: InputMaybe<SearchBoardFilter>;
    issueFilter?: InputMaybe<SearchJiraIssueFilter>;
    projectFilter?: InputMaybe<SearchJiraProjectFilter>;
};

export type SearchJiraIssueFilter = {
    /** Account ARIs of the issue assignees. */
    assigneeARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Account ARI of the issue commenter. */
    commenterARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Issue type IDs */
    issueTypeIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Project ARIs the issues reside in. */
    projectARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Account ARIs of the issue reporters. */
    reporterARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The status category the issue is currently in. */
    statusCategories?: InputMaybe<Array<SearchIssueStatusCategory>>;
    /** Account ARI of the issue watcher. */
    watcherARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SearchJiraProjectFilter = {
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Replaced with projectTypes to allow filtering for multiple Jira project types.
     */
    projectType?: InputMaybe<SearchProjectType>;
    projectTypes?: InputMaybe<Array<SearchProjectType>>;
};

export type SearchL2Feature = {
    __typename?: "SearchL2Feature";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    value?: Maybe<Scalars["Float"]["output"]>;
};

/** L2 Feature Provider */
export type SearchL2FeatureProvider = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
};

export type SearchLayerDefinition = {
    /** ari or product - eg "ari:cloud:platform::integration/google" "confluence" */
    entity?: InputMaybe<Scalars["String"]["input"]>;
    /** Layer Id - eg "L1-optimus" */
    layerId?: InputMaybe<Scalars["String"]["input"]>;
    /** Experiment ID for shadowing - currently used for Searcher-based layers. */
    shadowId?: InputMaybe<Scalars["String"]["input"]>;
    /** Sub Entity - eg "document" */
    subEntity?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchMercuryFilter = {
    /** Ids of the ancestors of the result. */
    ancestorIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Ids of the focus area types of the result. */
    focusAreaTypeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for focus areas owned by particular users. The values should be Atlassian Account IDs. */
    owners?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SearchProductCount = {
    __typename?: "SearchProductCount";
    count: Scalars["Int"]["output"];
    /**
     * Product is not an enum because we need the ability to expose new connected 3P source without
     * any code changes in Backend Aggregator API. The BYO 3P products can change at the runtime and the expectation is
     * for Aggregator to expose them with no code changes. Hence we are loosening the types.
     *
     * Decision taken on this thread - https://atlassian.slack.com/archives/C0729HFJ264/p1722815729382299
     */
    product: Scalars["String"]["output"];
};

export enum SearchProjectType {
    Business = "business",
    ProductDiscovery = "product_discovery",
    ServiceDesk = "service_desk",
    Software = "software"
}

/** Entry point for all searches */
export type SearchQueryApi = {
    __typename?: "SearchQueryAPI";
    /**
     * Get recently viewed items
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recent?: Maybe<Array<SearchResult>>;
    /**
     * Searches for some entities
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    search?: Maybe<SearchItemConnection>;
};

/** Entry point for all searches */
export type SearchQueryApiRecentArgs = {
    analytics?: InputMaybe<SearchAnalyticsInput>;
    experience: Scalars["String"]["input"];
    filters: SearchRecentFilterInput;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Entry point for all searches */
export type SearchQueryApiSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    analytics?: InputMaybe<SearchAnalyticsInput>;
    before?: InputMaybe<Scalars["String"]["input"]>;
    disableQueryReplacement?: InputMaybe<Scalars["Boolean"]["input"]>;
    disableWildcardMatching?: InputMaybe<Scalars["Boolean"]["input"]>;
    enableHighlighting?: InputMaybe<Scalars["Boolean"]["input"]>;
    enableRelevanceDebugging?: InputMaybe<Scalars["Boolean"]["input"]>;
    experience: Scalars["String"]["input"];
    experimentContext?: InputMaybe<SearchExperimentContextInput>;
    filters: SearchFilterInput;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    interleaveResults?: InputMaybe<Scalars["Boolean"]["input"]>;
    last?: InputMaybe<Scalars["Int"]["input"]>;
    query?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<SearchSortInput>>>;
};

export type SearchQueryInfo = {
    __typename?: "SearchQueryInfo";
    /** The confidence score of the replacement query */
    confidenceScore?: Maybe<Scalars["Float"]["output"]>;
    /** The original query string */
    originalQuery?: Maybe<Scalars["String"]["output"]>;
    /** The query type of the original query */
    originalQueryType?: Maybe<Scalars["String"]["output"]>;
    /** The replacement query string used for the search. This should not be populated if suggestedQuery is not empty. */
    replacementQuery?: Maybe<Scalars["String"]["output"]>;
    /** Indicates if the query replacement/suggestion should be shown to the user in the UI. */
    shouldTriggerAutocorrectionExperience?: Maybe<Scalars["Boolean"]["output"]>;
    /** The suggested replacement query string. This should not be populated if replacementQuery is not empty. */
    suggestedQuery?: Maybe<Scalars["String"]["output"]>;
};

/** Filters to apply to recent query */
export type SearchRecentFilterInput = {
    /** ATI strings of which entities to search for */
    entities: Array<Scalars["String"]["input"]>;
    /** ARIs of which workspaces, cloudIds or orgs to search in */
    locations: Array<Scalars["String"]["input"]>;
};

/** Search Result type */
export type SearchResult = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultAtlasGoal = SearchResult & {
    __typename?: "SearchResultAtlasGoal";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    goal?: Maybe<TownsquareGoal>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultAtlasGoalUpdate = SearchResult & {
    __typename?: "SearchResultAtlasGoalUpdate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L1 score is internal only field, do not use in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    score?: Maybe<Scalars["Float"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

/** Atlas */
export type SearchResultAtlasProject = SearchResult & {
    __typename?: "SearchResultAtlasProject";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    project?: Maybe<TownsquareProject>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultAtlasProjectUpdate = SearchResult & {
    __typename?: "SearchResultAtlasProjectUpdate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L1 score is internal only field, do not use in the UI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    score?: Maybe<Scalars["Float"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

/** Bitbucket */
export type SearchResultBitbucketRepository = SearchResult & {
    __typename?: "SearchResultBitbucketRepository";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    fullRepoName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

/** Compass */
export type SearchResultCompassComponent = SearchResult & {
    __typename?: "SearchResultCompassComponent";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    component?: Maybe<CompassComponent>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    componentType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    ownerId?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tier?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultEntity =
    | ConfluencePage
    | ConfluenceSpace
    | DevOpsService
    | ExternalBranch
    | ExternalCalendarEvent
    | ExternalComment
    | ExternalCommit
    | ExternalConversation
    | ExternalDeployment
    | ExternalDesign
    | ExternalDocument
    | ExternalFeatureFlag
    | ExternalMessage
    | ExternalPullRequest
    | ExternalRemoteLink
    | ExternalRepository
    | ExternalSpace
    | ExternalVideo
    | ExternalVulnerability
    | ExternalWorkItem
    | JiraIssue
    | JiraPostIncidentReviewLink
    | JiraProject
    | JiraVersion
    | OpsgenieTeam
    | ThirdPartySecurityContainer
    | ThirdPartySecurityWorkspace
    | TownsquareComment
    | TownsquareGoal
    | TownsquareProject;

/** Federated Email Entity */
export type SearchResultFederated = SearchResult & {
    __typename?: "SearchResultFederated";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entity?: Maybe<SearchFederatedEntity>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    score?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

/** Google */
export type SearchResultGoogleDocument = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchResultGoogleDocument";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        bodyText: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        excerpt?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        permissionLevel?: Maybe<Scalars["String"]["output"]>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

export type SearchResultGooglePresentation = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchResultGooglePresentation";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        bodyText: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        excerpt?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        permissionLevel?: Maybe<Scalars["String"]["output"]>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

export type SearchResultGoogleSpreadsheet = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchResultGoogleSpreadsheet";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        bodyText: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        excerpt?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        permissionLevel?: Maybe<Scalars["String"]["output"]>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

/** TeamworkGraph type search results */
export type SearchResultGraphDocument = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchResultGraphDocument";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        bodyText?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        entity?: Maybe<SearchResultEntity>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        excerpt?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        initialContributors?: Maybe<Array<ThirdPartyUser>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        integrationId?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        linkedEntities?: Maybe<Array<SearchResultGraphDocument>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        owner?: Maybe<ThirdPartyUser>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        permissionLevel?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        providerId?: Maybe<Scalars["String"]["output"]>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        subtype?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

export type SearchResultItemEdge = {
    __typename?: "SearchResultItemEdge";
    /** Opaque string containing the cursor for this edge */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /**
     * The search result object, this is a union type of all possible search result types.
     * A different definition will be provided for all entities supported by Atlassian
     */
    node?: Maybe<SearchResult>;
};

export type SearchResultJiraBoard = SearchResult & {
    __typename?: "SearchResultJiraBoard";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    container?: Maybe<SearchResultJiraBoardContainer>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favourite: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isSimpleBoard: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    product: SearchBoardProductType;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    socialSignal?: Maybe<SocialSignalSearch>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultJiraBoardSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

export type SearchResultJiraBoardContainer =
    | SearchResultJiraBoardProjectContainer
    | SearchResultJiraBoardUserContainer;

export type SearchResultJiraBoardProjectContainer = {
    __typename?: "SearchResultJiraBoardProjectContainer";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectTypeKey: SearchProjectType;
};

export type SearchResultJiraBoardUserContainer = {
    __typename?: "SearchResultJiraBoardUserContainer";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userAccountId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userName: Scalars["String"]["output"];
};

export type SearchResultJiraDashboard = SearchResult & {
    __typename?: "SearchResultJiraDashboard";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    socialSignal?: Maybe<SocialSignalSearch>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultJiraDashboardSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

export type SearchResultJiraFilter = SearchResult & {
    __typename?: "SearchResultJiraFilter";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filter?: Maybe<JiraFilter>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    socialSignal?: Maybe<SocialSignalSearch>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultJiraFilterSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

export type SearchResultJiraIssue = SearchResult & {
    __typename?: "SearchResultJiraIssue";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issue?: Maybe<JiraIssue>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    issueTypeId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    socialSignal?: Maybe<SocialSignalSearch>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<SearchResultJiraIssueStatus>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    useHydratedFields?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SearchResultJiraIssueSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

export type SearchResultJiraIssueStatus = {
    __typename?: "SearchResultJiraIssueStatus";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    statusCategory?: Maybe<SearchResultJiraIssueStatusCategory>;
};

export type SearchResultJiraIssueStatusCategory = {
    __typename?: "SearchResultJiraIssueStatusCategory";
    colorName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

/** Jira */
export type SearchResultJiraProject = SearchResult & {
    __typename?: "SearchResultJiraProject";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canView: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favourite: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    project?: Maybe<JiraProject>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectId: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    projectType: SearchProjectType;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    simplified: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    socialSignal?: Maybe<SocialSignalSearch>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    useHydratedFields?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Jira */
export type SearchResultJiraProjectSocialSignalArgs = {
    tenantId: Scalars["ID"]["input"];
};

/** Mercury (Focus) */
export type SearchResultMercuryFocusArea = SearchResult & {
    __typename?: "SearchResultMercuryFocusArea";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    focusArea?: Maybe<MercuryFocusArea>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultMercuryFocusAreaStatusUpdate = SearchResult & {
    __typename?: "SearchResultMercuryFocusAreaStatusUpdate";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    focusArea?: Maybe<MercuryFocusArea>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

/** Microsoft Document */
export type SearchResultMicrosoftDocument = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchResultMicrosoftDocument";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        bodyText: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        excerpt?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        permissionLevel?: Maybe<Scalars["String"]["output"]>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

/** Slack */
export type SearchResultSlackMessage = SearchL2FeatureProvider &
    SearchResult & {
        __typename?: "SearchResultSlackMessage";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        channelName?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        description: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        iconUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        initialContributors?: Maybe<Array<ThirdPartyUser>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        l2Features?: Maybe<Array<Maybe<SearchL2Feature>>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        linkedEntities?: Maybe<Array<SearchResultSlackMessage>>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        mentions?: Maybe<Array<ThirdPartyUser>>;
        /**
         * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        subtype?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        title: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        type: SearchResultType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ✅ Yes |
         *
         */
        url: Scalars["URL"]["output"];
    };

/** Trello */
export type SearchResultTrelloBoard = SearchResult & {
    __typename?: "SearchResultTrelloBoard";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export type SearchResultTrelloCard = SearchResult & {
    __typename?: "SearchResultTrelloCard";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    boardName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentsCount: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    description: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconUrl?: Maybe<Scalars["URL"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    /**
     * L2 fields are internal only fields, do not use in the UI. We should introduce another model layer to bridge content searcher response to aggregator query response.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    scoreL2Ranker?: Maybe<Scalars["Float"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SearchResultType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["URL"]["output"];
};

export enum SearchResultType {
    Attachment = "attachment",
    Blogpost = "blogpost",
    Board = "board",
    Comment = "comment",
    Component = "component",
    Dashboard = "dashboard",
    Database = "database",
    Document = "document",
    Embed = "embed",
    Filter = "filter",
    FocusArea = "focus_area",
    FocusAreaStatusUpdate = "focus_area_status_update",
    Folder = "folder",
    Goal = "goal",
    GoalUpdate = "goal_update",
    Issue = "issue",
    Learning = "learning",
    Message = "message",
    Page = "page",
    Plan = "plan",
    Presentation = "presentation",
    Project = "project",
    ProjectUpdate = "project_update",
    Question = "question",
    Repository = "repository",
    Space = "space",
    Spreadsheet = "spreadsheet",
    Tag = "tag",
    Unrecognised = "unrecognised",
    Whiteboard = "whiteboard"
}

/** Fields used to sort the query */
export type SearchSortInput = {
    /** Name of the document field on which to sort. May be a computed field such as "_score". */
    field: Scalars["String"]["input"];
    /**
     * Field to sort by if a content property was specified in the field section. This is ignored if the field is not
     * a content property.
     */
    key?: InputMaybe<Scalars["String"]["input"]>;
    /** Order to sort the result by. */
    order: SearchSortOrder;
};

/** SearchSortOrder describes the sorting order of the query. */
export enum SearchSortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type SearchThirdPartyFilter = {
    /** Restrict search only to the given ancestors represented by ARIs */
    ancestorAris?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for only entities that have assignee ids specified */
    assignees?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for only entities that have the containerNames specified */
    containerNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Exclude the entities that have the subtypes specified */
    excludeSubtypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for only entities that have the integration ids specified */
    integrations?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Search for only entities that have match the date range for the specified field */
    range?: InputMaybe<Array<InputMaybe<SearchThirdPartyRangeFilter>>>;
    /** Search for only entities that have the subtypes specified */
    subtypes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /** Mapping of each third party product and its subtypes, providerId and integrationId */
    thirdPartyProducts?: InputMaybe<Array<SearchThirdPartyProduct>>;
    /** Search for only entities that have the types specified */
    thirdPartyTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Search for only entities that have a title that contains the given query */
    titleMatchOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SearchThirdPartyProduct = {
    /** Indicates if the product is a smartlink connector, full connector, or both */
    connectorSources?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The given product's integration ari */
    integrationId?: InputMaybe<Scalars["String"]["input"]>;
    /** ProductKey from frontend code to identify the product for feature gate purposes */
    product?: InputMaybe<Scalars["String"]["input"]>;
    /** The given product's provider id from twg */
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    /** Subtypes mapped to this product for the given query */
    subtypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum SearchThirdPartyRangeField {
    Created = "CREATED",
    Lastmodified = "LASTMODIFIED"
}

export type SearchThirdPartyRangeFilter = {
    /** The field to use to calculate the range */
    field: SearchThirdPartyRangeField;
    /** Specify the timestamp that the field should be greater than */
    gt?: InputMaybe<Scalars["String"]["input"]>;
    /** Specify the timestamp that the field should be less than */
    lt?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchTimeseriesCtr = {
    __typename?: "SearchTimeseriesCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<SearchTimeseriesCtrItem>;
};

export type SearchTimeseriesCtrItem = {
    __typename?: "SearchTimeseriesCTRItem";
    ctr: Scalars["Float"]["output"];
    /** Grouping date in ISO format */
    timestamp: Scalars["String"]["output"];
};

export type SearchTimeseriesCount = {
    __typename?: "SearchTimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<TimeseriesCountItem>;
};

export type SearchesByTerm = {
    __typename?: "SearchesByTerm";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<SearchesByTermItems>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SearchesPageInfo;
};

export enum SearchesByTermColumns {
    PageViewedPercentage = "pageViewedPercentage",
    SearchClickCount = "searchClickCount",
    SearchSessionCount = "searchSessionCount",
    SearchTerm = "searchTerm",
    Total = "total",
    UniqueUsers = "uniqueUsers"
}

export type SearchesByTermItems = {
    __typename?: "SearchesByTermItems";
    pageViewedPercentage: Scalars["Float"]["output"];
    searchClickCount: Scalars["Int"]["output"];
    searchSessionCount: Scalars["Int"]["output"];
    searchTerm: Scalars["String"]["output"];
    total: Scalars["Int"]["output"];
    uniqueUsers: Scalars["Int"]["output"];
};

export enum SearchesByTermPeriod {
    Day = "day",
    Month = "month",
    Week = "week"
}

export type SearchesPageInfo = {
    __typename?: "SearchesPageInfo";
    next?: Maybe<Scalars["String"]["output"]>;
    prev?: Maybe<Scalars["String"]["output"]>;
};

export type SearchesWithZeroCtr = {
    __typename?: "SearchesWithZeroCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<SearchesWithZeroCtrItem>>;
};

export type SearchesWithZeroCtrItem = {
    __typename?: "SearchesWithZeroCTRItem";
    count: Scalars["Int"]["output"];
    searchTerm: Scalars["String"]["output"];
};

export type Security = {
    __typename?: "Security";
    caiq?: Maybe<Caiq>;
    /** List of compliance certificates for the app */
    compliantCertifications?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Does the app have any compliance certifications? */
    hasCompliantCertifications?: Maybe<Scalars["Boolean"]["output"]>;
    /** Does the app use full disk encryption at-rest for End-User Data stored outside of Atlassian or the users’s browser? */
    isDiskEncryptionSupported?: Maybe<Scalars["Boolean"]["output"]>;
    /** Security policy for the app */
    publicSecurityPoliciesLink?: Maybe<Scalars["String"]["output"]>;
    /** Contact for the app security issues */
    securityContact: Scalars["String"]["output"];
};

export type SecurityContainer = {
    /** The URL for the security container icon. */
    icon?: Maybe<Scalars["URL"]["output"]>;
    /** The last updated timestamp of the security container. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The name of the security container. */
    name: Scalars["String"]["output"];
    /** The id of the provider of the security container. */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the provider of the security container. */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The web URL to the security container page. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type SecurityWorkspace = {
    /** The URL for the security workspace icon. */
    icon?: Maybe<Scalars["URL"]["output"]>;
    /** The last updated timestamp of the security workspace. */
    lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    /** The name of the security workspace. */
    name: Scalars["String"]["output"];
    /** The id of the provider of the security workspace. */
    providerId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the provider of the security workspace. */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The web URL to the security workspace page. */
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type ServiceProvider = {
    __typename?: "ServiceProvider";
    /** List of End-User Data type with respect to which the app is a "service provider" */
    endUserDataTypes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Is the app a "service provider" under the California Consumer Privacy Act of 2018 (CCPA)? */
    isAppServiceProvider: AcceptableResponse;
};

export type SetAppEnvironmentVariableInput = {
    environment: AppEnvironmentInput;
    /** The input identifying the environment variable to insert */
    environmentVariable: AppEnvironmentVariableInput;
};

export type SetAppEnvironmentVariablePayload = Payload & {
    __typename?: "SetAppEnvironmentVariablePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetAppStoredCustomEntityMutationInput = {
    /** The ARI to store this entity within */
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    /** Specify the entity name for custom schema */
    entityName: Scalars["String"]["input"];
    /** The identifier for the entity */
    key: Scalars["ID"]["input"];
    /**
     * Entities may be up to ${maxValidContentLength} bytes long. Note that size within ESS may differ from
     * the size of the entity sent to this service. The entity size is counted within this service.
     */
    value: Scalars["JSON"]["input"];
};

/** Generic implementation of MutationResponse for responses that don't need any extra data */
export type SetAppStoredCustomEntityPayload = Payload & {
    __typename?: "SetAppStoredCustomEntityPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type SetAppStoredEntityMutationInput = {
    /** The ARI to store this entity within */
    contextAri?: InputMaybe<Scalars["ID"]["input"]>;
    /** Specify whether value should be encrypted */
    encrypted?: InputMaybe<Scalars["Boolean"]["input"]>;
    /**
     * The identifier for the entity
     *
     * Keys must be between 1-100 characters long and must match the following pattern /^[a-zA-Z0-9:._\s-]+$/
     */
    key: Scalars["ID"]["input"];
    /**
     * Entities may be up to 2000 bytes long. Note that size within ESS may differ from
     * the size of the entity sent to this service. The entity size is counted within this service.
     */
    value: Scalars["JSON"]["input"];
};

/** Generic implementation of MutationResponse for responses that don't need any extra data */
export type SetAppStoredEntityPayload = Payload & {
    __typename?: "SetAppStoredEntityPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type SetBoardEstimationTypeInput = {
    estimationType: Scalars["String"]["input"];
    featureId: Scalars["String"]["input"];
};

export type SetCardColorStrategyInput = {
    boardId: Scalars["ID"]["input"];
    strategy: Scalars["String"]["input"];
};

export type SetCardColorStrategyOutput = MutationResponse & {
    __typename?: "SetCardColorStrategyOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    newCardColorStrategy?: Maybe<JswCardColorStrategy>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetColumnLimitInput = {
    boardId: Scalars["ID"]["input"];
    columnId: Scalars["ID"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SetColumnLimitOutput = MutationResponse & {
    __typename?: "SetColumnLimitOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    columns?: Maybe<Array<Maybe<Column>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetColumnNameInput = {
    boardId: Scalars["ID"]["input"];
    columnId: Scalars["ID"]["input"];
    columnName: Scalars["String"]["input"];
};

export type SetColumnNameOutput = MutationResponse & {
    __typename?: "SetColumnNameOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    column?: Maybe<Column>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetDefaultSpaceRoleAssignmentsInput = {
    spaceRoleAssignmentList: Array<RoleAssignment>;
};

export type SetDefaultSpaceRoleAssignmentsPayload = Payload & {
    __typename?: "SetDefaultSpaceRoleAssignmentsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Estimation Mutation */
export type SetEstimationTypeInput = {
    boardId: Scalars["ID"]["input"];
    estimationType: Scalars["String"]["input"];
};

export type SetExternalAuthCredentialsInput = {
    /** An object representing the credentials to set */
    credentials: ExternalAuthCredentialsInput;
    /** The input identifying what environment to set credentials for */
    environment: AppEnvironmentInput;
    /** The key for the service we're setting the credentials for (must already exist via previous deployment) */
    serviceKey: Scalars["String"]["input"];
};

export type SetExternalAuthCredentialsPayload = Payload & {
    __typename?: "SetExternalAuthCredentialsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetFeedUserConfigInput = {
    followSpaces?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    followUsers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    unfollowSpaces?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
    unfollowUsers?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

export type SetFeedUserConfigPayload = {
    __typename?: "SetFeedUserConfigPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountIds: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<SetFeedUserConfigPayloadError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceIds: Array<Maybe<Scalars["Long"]["output"]>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'spaces' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    spaces?: Maybe<Array<Maybe<Space>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'users' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    users?: Maybe<Array<Maybe<Person>>>;
};

export type SetFeedUserConfigPayloadError = {
    __typename?: "SetFeedUserConfigPayloadError";
    extensions?: Maybe<SetFeedUserConfigPayloadErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type SetFeedUserConfigPayloadErrorExtension = {
    __typename?: "SetFeedUserConfigPayloadErrorExtension";
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type SetIssueMediaVisibilityInput = {
    boardId: Scalars["ID"]["input"];
    isVisible?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SetIssueMediaVisibilityOutput = MutationResponse & {
    __typename?: "SetIssueMediaVisibilityOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetPolarisSelectedDeliveryProjectInput = {
    projectId: Scalars["ID"]["input"];
    selectedDeliveryProjectId: Scalars["ID"]["input"];
};

export type SetPolarisSelectedDeliveryProjectPayload = Payload & {
    __typename?: "SetPolarisSelectedDeliveryProjectPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetPolarisSnippetPropertiesConfigInput = {
    /** Config */
    config?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Snippet group id */
    groupId: Scalars["String"]["input"];
    /** OauthClientId of CaaS app */
    oauthClientId: Scalars["String"]["input"];
    /** project ARI */
    project: Scalars["ID"]["input"];
};

export type SetPolarisSnippetPropertiesConfigPayload = Payload & {
    __typename?: "SetPolarisSnippetPropertiesConfigPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetRecommendedPagesSpaceStatusInput = {
    defaultBehavior?: InputMaybe<RecommendedPagesSpaceBehavior>;
    enableRecommendedPages?: InputMaybe<Scalars["Boolean"]["input"]>;
    entityId: Scalars["ID"]["input"];
};

export type SetRecommendedPagesSpaceStatusPayload = {
    __typename?: "SetRecommendedPagesSpaceStatusPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<SetRecommendedPagesSpaceStatusPayloadError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetRecommendedPagesSpaceStatusPayloadError = {
    __typename?: "SetRecommendedPagesSpaceStatusPayloadError";
    extensions?: Maybe<SetRecommendedPagesStatusPayloadErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type SetRecommendedPagesStatusInput = {
    enableRecommendedPages: Scalars["Boolean"]["input"];
    entityId: Scalars["ID"]["input"];
    entityType: Scalars["String"]["input"];
};

export type SetRecommendedPagesStatusPayload = {
    __typename?: "SetRecommendedPagesStatusPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<SetRecommendedPagesStatusPayloadError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SetRecommendedPagesStatusPayloadError = {
    __typename?: "SetRecommendedPagesStatusPayloadError";
    extensions?: Maybe<SetRecommendedPagesStatusPayloadErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type SetRecommendedPagesStatusPayloadErrorExtension = {
    __typename?: "SetRecommendedPagesStatusPayloadErrorExtension";
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type SetSpaceRoleAssignmentsInput = {
    spaceId: Scalars["Long"]["input"];
    spaceRoleAssignmentList: Array<RoleAssignment>;
};

export type SetSpaceRoleAssignmentsPayload = Payload & {
    __typename?: "SetSpaceRoleAssignmentsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Swimlane Mutations */
export type SetSwimlaneStrategyInput = {
    boardId: Scalars["ID"]["input"];
    strategy: SwimlaneStrategy;
};

export type SetSwimlaneStrategyResponse = MutationResponse & {
    __typename?: "SetSwimlaneStrategyResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    strategy: SwimlaneStrategy;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Represents a navigation menu item */
export type SettingsDisplayProperty = {
    __typename?: "SettingsDisplayProperty";
    key?: Maybe<Scalars["ID"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

/** Represents a connection of navigation menu items for pagination */
export type SettingsDisplayPropertyConnection = {
    __typename?: "SettingsDisplayPropertyConnection";
    edges?: Maybe<Array<SettingsDisplayPropertyEdge>>;
    nodes?: Maybe<Array<Maybe<SettingsDisplayProperty>>>;
    pageInfo: PageInfo;
};

/** Represents a navigation menu item edge */
export type SettingsDisplayPropertyEdge = {
    __typename?: "SettingsDisplayPropertyEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<SettingsDisplayProperty>;
};

/** Represents a navigation property with key and value */
export type SettingsDisplayPropertyInput = {
    key: Scalars["ID"]["input"];
    value: Scalars["String"]["input"];
};

/** Represents a navigation menu item */
export type SettingsMenuItem = {
    __typename?: "SettingsMenuItem";
    menuId?: Maybe<Scalars["ID"]["output"]>;
    visible?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Represents a connection of navigation menu items for pagination */
export type SettingsMenuItemConnection = {
    __typename?: "SettingsMenuItemConnection";
    edges?: Maybe<Array<SettingsMenuItemEdge>>;
    nodes?: Maybe<Array<Maybe<SettingsMenuItem>>>;
    pageInfo: PageInfo;
};

/** Represents a navigation menu item edge */
export type SettingsMenuItemEdge = {
    __typename?: "SettingsMenuItemEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<SettingsMenuItem>;
};

/** Represents a navigation menu item with customisable attributes (e.g. visible) */
export type SettingsMenuItemInput = {
    menuId: Scalars["ID"]["input"];
    visible: Scalars["Boolean"]["input"];
};

/** Represents navigation customisation settings by navigation container types (e.g. sidebar) */
export type SettingsNavigationCustomisation = {
    __typename?: "SettingsNavigationCustomisation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    properties?: Maybe<SettingsDisplayPropertyConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    sidebar?: Maybe<SettingsMenuItemConnection>;
};

/** Represents navigation customisation settings by navigation container types (e.g. sidebar) */
export type SettingsNavigationCustomisationPropertiesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Represents navigation customisation settings by navigation container types (e.g. sidebar) */
export type SettingsNavigationCustomisationSidebarArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Input for mutation to update navigation customisation settings */
export type SettingsNavigationCustomisationInput = {
    entityAri: Scalars["ID"]["input"];
    ownerAri?: InputMaybe<Scalars["ID"]["input"]>;
    properties?: InputMaybe<Array<InputMaybe<SettingsDisplayPropertyInput>>>;
    sidebar?: InputMaybe<Array<InputMaybe<SettingsMenuItemInput>>>;
};

export type ShareResourceInput = {
    atlOrigin: Scalars["String"]["input"];
    contextualPageId: Scalars["String"]["input"];
    emails: Array<InputMaybe<Scalars["String"]["input"]>>;
    entityId: Scalars["String"]["input"];
    entityType: Scalars["String"]["input"];
    groupIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    groups: Array<InputMaybe<Scalars["String"]["input"]>>;
    isShareEmailExperiment: Scalars["Boolean"]["input"];
    note: Scalars["String"]["input"];
    shareType: ShareType;
    users: Array<InputMaybe<Scalars["String"]["input"]>>;
};

export type ShareResourcePayload = {
    __typename?: "ShareResourcePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export enum ShareType {
    InviteToEdit = "INVITE_TO_EDIT",
    SharePage = "SHARE_PAGE"
}

/** The kind of action that was performed and caused or contributed to an alert */
export enum ShepherdActionType {
    Activate = "ACTIVATE",
    Archive = "ARCHIVE",
    Crawl = "CRAWL",
    Create = "CREATE",
    Deactivate = "DEACTIVATE",
    Delete = "DELETE",
    Download = "DOWNLOAD",
    Export = "EXPORT",
    Grant = "GRANT",
    Install = "INSTALL",
    Login = "LOGIN",
    LoginAs = "LOGIN_AS",
    Publish = "PUBLISH",
    Read = "READ",
    Revoke = "REVOKE",
    Search = "SEARCH",
    Uninstall = "UNINSTALL",
    Update = "UPDATE"
}

/** Represents the pertinent fields of specific events (from the Audit Log, for example) matching given search criteria. */
export type ShepherdActivity =
    | ShepherdActorActivity
    | ShepherdLoginActivity
    | ShepherdResourceActivity;

export type ShepherdActivityConnection = {
    __typename?: "ShepherdActivityConnection";
    /** A list of activity edges */
    edges?: Maybe<Array<Maybe<ShepherdActivityEdge>>>;
    pageInfo: PageInfo;
};

export type ShepherdActivityEdge = {
    __typename?: "ShepherdActivityEdge";
    node?: Maybe<ShepherdActivity>;
};

/** ShepherdActivityHighlight captures a pointer to some user activity that is relevant for an alert. */
export type ShepherdActivityHighlight = {
    __typename?: "ShepherdActivityHighlight";
    /** What kind of action is relevant */
    action?: Maybe<ShepherdActionType>;
    /** Who has done it */
    actor?: Maybe<ShepherdActor>;
    /** SessionInfo contains contextual information for geo/IP related alerts, such as actor IP address and user agent */
    actorSessionInfo?: Maybe<ShepherdActorSessionInfo>;
    /** List of ARIs that are affected by the alert. Typically used for applicable sites and spaces affected by an org policy update. */
    affectedResources?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Any additional metadata that is relevant to the alert and can be grouped by category (e.g. suspicious search terms) */
    categorizedMetadata?: Maybe<Array<ShepherdCategorizedAlertMetadata>>;
    /** The Streamhub event id's of the events corresponding to the alert. In some cases, these are the same as the audit log event id's */
    eventIds?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Representation of numerical data distribution about the alert. */
    histogram?: Maybe<Array<ShepherdActivityHistogramBucket>>;
    /** Any additional metadata that adds context to the alert */
    metadata?: Maybe<ShepherdAlertMetaData>;
    /**
     * The resources that were acted upon to trigger the alert along with the time of action corresponding to each ARI.
     * Typically used when Streamhub or Audit Log eventIds are not available (e.g, analytics based detections).
     */
    resourceEvents?: Maybe<Array<ShepherdResourceEvent>>;
    /** What resource was acted on */
    subject?: Maybe<ShepherdSubject>;
    /** When did this occur (instant or interval)? */
    time?: Maybe<ShepherdTime>;
};

/** Contextual information about the activity that originated the alert. */
export type ShepherdActivityHighlightInput = {
    /** What kind of action is relevant */
    action?: InputMaybe<ShepherdActionType>;
    /** Who has done it (AAID) */
    actor?: InputMaybe<Scalars["ID"]["input"]>;
    /** Information about a user's session when they login. */
    actorSessionInfo?: InputMaybe<ShepherdActorSessionInfoInput>;
    /** The Streamhub event id's of the events corresponding to the alert. In some cases, these are the same as the audit log event id's */
    eventIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Representation of numerical data distribution about the alert. */
    histogram?: InputMaybe<Array<InputMaybe<ShepherdHistogramBucketInput>>>;
    /**
     * The resources that were acted upon to trigger the alert along with the time of action corresponding to each ARI.
     * Typically used when Streamhub or Audit Log eventIds are not available (e.g, analytics based detections).
     */
    resourceEvents?: InputMaybe<Array<ShepherdResourceEventInput>>;
    /** What resource was acted on */
    subject?: InputMaybe<ShepherdSubjectInput>;
    /** When did this occur (instant or interval)? */
    time: ShepherdTimeInput;
};

/** Single data point about distribution of numerical data related to the activity */
export type ShepherdActivityHistogramBucket = {
    __typename?: "ShepherdActivityHistogramBucket";
    /** Name of the bucket that contributes to the signal histogram */
    name: Scalars["String"]["output"];
    /** Numerical representation of the bucket value */
    value: Scalars["Int"]["output"];
};

export type ShepherdActivityResult = QueryError | ShepherdActivityConnection;

/** Represents an actor in the Shepherd system. */
export type ShepherdActor = {
    __typename?: "ShepherdActor";
    aaid: Scalars["ID"]["output"];
    /** Timestamp of when the user's account was created */
    createdOn?: Maybe<Scalars["DateTime"]["output"]>;
    /** Multi-factor authentication status of the user */
    mfaEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    orgId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Information relevant to the ShepherdActor in the specified org.
     * If no orgId is provided, the orgId will be inferred from context. If it cannot be inferred, null is returned.
     */
    orgInfo?: Maybe<ShepherdActorOrgInfo>;
    /** Products relevant to a workspace that the actor has access to */
    productAccess?: Maybe<Array<Maybe<ShepherdActorProductAccess>>>;
    /** User's currently active sessions */
    sessions?: Maybe<Array<Maybe<ShepherdActorSession>>>;
    user?: Maybe<User>;
};

/** Represents an actor in the Shepherd system. */
export type ShepherdActorOrgInfoArgs = {
    orgId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ShepherdActorActivity = {
    __typename?: "ShepherdActorActivity";
    /** The user performing the action named in a specific activity. */
    actor: ShepherdActor;
    /** Optional context on Audit Log events. */
    context: Array<ShepherdAuditLogContext>;
    /** The audit log event type (ex: jira_issue_viewed, user_created) */
    eventType: Scalars["String"]["output"];
    /** The id of the activity, as provided by wherever we're getting these activities from */
    id: Scalars["String"]["output"];
    /** The audit log message that describes the event action in ADF format */
    message?: Maybe<Scalars["JSON"]["output"]>;
    /** The time the activity occurred. */
    time: Scalars["DateTime"]["output"];
};

/**
 * Defines the actor of the alert when creating an alert.
 * Requires one and only one of the fields as each one represent a type of actor.
 */
export type ShepherdActorInput = {
    /** An Atlassian Account ID that represents an Atlassian cloud user. */
    aaid?: InputMaybe<Scalars["ID"]["input"]>;
    /** Represents an anonymous user that performed an action on a public resource. */
    anonymous?: InputMaybe<ShepherdAnonymousActorInput>;
    /**
     * If true, it means the user is unknown. Use this field when its impossible to determine who performed the action
     * that triggered the alert.
     */
    unknown?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ShepherdActorMutationPayload = Payload & {
    __typename?: "ShepherdActorMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdActor>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdActorMutations = {
    __typename?: "ShepherdActorMutations";
    /** Suspend the actor in the specified org. */
    suspend?: Maybe<ShepherdActorMutationPayload>;
    /** Unsuspend the actor in the specified org. */
    unsuspend?: Maybe<ShepherdActorMutationPayload>;
};

export type ShepherdActorMutationsSuspendArgs = {
    aaid: Scalars["ID"]["input"];
    orgId: Scalars["ID"]["input"];
};

export type ShepherdActorMutationsUnsuspendArgs = {
    aaid: Scalars["ID"]["input"];
    orgId: Scalars["ID"]["input"];
};

export type ShepherdActorOrgInfo = {
    __typename?: "ShepherdActorOrgInfo";
    actorOrgStatus?: Maybe<ShepherdActorOrgStatus>;
    isOrgAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    orgId: Scalars["ID"]["output"];
};

export enum ShepherdActorOrgStatus {
    Active = "ACTIVE",
    Deactivated = "DEACTIVATED",
    Suspended = "SUSPENDED"
}

/** Represents access to a product for an actor in the Shepherd system. */
export type ShepherdActorProductAccess = {
    __typename?: "ShepherdActorProductAccess";
    /** Cloud ID (aka site ID) */
    cloudId: Scalars["ID"]["output"];
    /** Cloud hostName */
    cloudUrl: Scalars["String"]["output"];
    /** Timestamp when actor was active in product */
    lastActiveTimestamp?: Maybe<Scalars["String"]["output"]>;
    /** Organization ID */
    orgId?: Maybe<Scalars["ID"]["output"]>;
    /** Product display Name */
    product: Scalars["String"]["output"];
    /** Role of actor in product */
    productRole?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type ShepherdActorResult = QueryError | ShepherdActor;

export type ShepherdActorSession = {
    __typename?: "ShepherdActorSession";
    /** The auth factors used to log in */
    authFactors?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The user's device and browser information */
    device?: Maybe<ShepherdLoginDevice>;
    /**
     * Last time the user renewed a session token for this session.
     * The time is updated if a user makes a request and 10 minutes have passed since the last session token was issued
     */
    lastActiveTime?: Maybe<Scalars["DateTime"]["output"]>;
    /** Location where the user logged in from for this session */
    loginLocation?: Maybe<ShepherdLoginLocation>;
    /** The user's login timestamp for the session */
    loginTime: Scalars["DateTime"]["output"];
    /** The user's session identifier */
    sessionId: Scalars["String"]["output"];
};

export type ShepherdActorSessionInfo = {
    __typename?: "ShepherdActorSessionInfo";
    authFactors: Array<Scalars["String"]["output"]>;
    ipAddress: Scalars["String"]["output"];
    loginLocation?: Maybe<ShepherdLoginLocation>;
    sessionId: Scalars["String"]["output"];
    userAgent: Scalars["String"]["output"];
};

export type ShepherdActorSessionInfoInput = {
    /** Which authentication factors were used to login (SAML, password, social, etc.) */
    authFactors: Array<Scalars["String"]["input"]>;
    /** IP address from which the user created the session */
    ipAddress: Scalars["String"]["input"];
    /** ID of the unique session */
    sessionId: Scalars["String"]["input"];
    /** User agent of the session (browser, OS, etc.) */
    userAgent: Scalars["String"]["input"];
};

/** #### Types: Alert ##### */
export type ShepherdAlert = Node & {
    __typename?: "ShepherdAlert";
    /** Actor (user or system) that triggered the event(s) that generated this alert. */
    actor: ShepherdAlertActor;
    /**
     * Site(s) that are related to the alert, if any. It's used to inform whether the alert affects one or more sites.
     * Alerts that do not have applicable sites are considered scoped to the org, e.g. admin API key created.
     * Some alerts will always have one applicable site because the underlying event happens within a site, e.g. confluence
     * space made public.
     * Other alerts may be a result of changes that affect multiple sites, e.g. data security policy changes.
     */
    applicableSites?: Maybe<Array<Scalars["ID"]["output"]>>;
    assignee?: Maybe<ShepherdUser>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use workspaceId instead
     */
    cloudId?: Maybe<Scalars["ID"]["output"]>;
    createdOn: Scalars["DateTime"]["output"];
    /**
     * Custom values that are particular to this alert. The data structure varies per alert type, according to the JSON
     * schema definitions available at https://detect.stg.atlassian.com/gateway/api/detect/schema/alertFields
     * It's recommended generating the types based on the JSON schema in order to safely access custom field values.
     */
    customFields?: Maybe<Scalars["JSON"]["output"]>;
    description?: Maybe<ShepherdDescriptionTemplate>;
    id: Scalars["ID"]["output"];
    /**
     * Other Atlassian resources associated with the alert.
     * For instance: issues created from alerts will be linked to the alert.
     */
    linkedResources?: Maybe<Array<Maybe<ShepherdLinkedResource>>>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use workspaceId instead
     */
    orgId?: Maybe<Scalars["ID"]["output"]>;
    /** Product related to the alert type. Note this is not a property of the alert records but derived from the alert type. */
    product: ShepherdAtlassianProduct;
    status: ShepherdAlertStatus;
    statusUpdatedOn?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use customFields instead
     */
    supportingData?: Maybe<ShepherdAlertSupportingData>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use type instead
     */
    template?: Maybe<ShepherdAlertTemplateType>;
    time: ShepherdTime;
    title: Scalars["String"]["output"];
    /**
     * The type of this alert. The field supersedes 'template' and can be used to know the underlying data structure of the
     * 'customFields' field and to uniquely identify the type of this alert.
     */
    type: Scalars["String"]["output"];
    updatedBy?: Maybe<ShepherdUser>;
    updatedOn?: Maybe<Scalars["DateTime"]["output"]>;
    /** Workspace where the alert is stored. */
    workspaceId?: Maybe<Scalars["ID"]["output"]>;
};

export enum ShepherdAlertAction {
    AddLabel = "ADD_LABEL",
    Redact = "REDACT",
    Restrict = "RESTRICT",
    UpdateDataClassification = "UPDATE_DATA_CLASSIFICATION"
}

export type ShepherdAlertActor =
    | ShepherdActor
    | ShepherdAnonymousActor
    | ShepherdAtlassianSystemActor;

export type ShepherdAlertAuthorizedActions = {
    __typename?: "ShepherdAlertAuthorizedActions";
    actions?: Maybe<Array<ShepherdAlertAction>>;
};

export type ShepherdAlertAuthorizedActionsResult =
    | QueryError
    | ShepherdAlertAuthorizedActions;

export enum ShepherdAlertDetectionCategory {
    Data = "DATA",
    Threat = "THREAT"
}

export type ShepherdAlertEdge = {
    __typename?: "ShepherdAlertEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The item at the end of the edge */
    node?: Maybe<ShepherdAlert>;
};

export type ShepherdAlertExports = {
    __typename?: "ShepherdAlertExports";
    data?: Maybe<Array<Maybe<Array<Scalars["String"]["output"]>>>>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdAlertExportsResult = QueryError | ShepherdAlertExports;

/** Represents metadata that adds context to the alert */
export type ShepherdAlertMetaData = {
    __typename?: "ShepherdAlertMetaData";
    dspList?: Maybe<ShepherdDspListMetadata>;
    /** The number of spaces in a Confluence site or projects in a Jira site */
    siteContainerResourceCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ShepherdAlertQueries = {
    __typename?: "ShepherdAlertQueries";
    alertExports?: Maybe<ShepherdAlertExportsResult>;
    /**
     * Returns the snippets of detected content for a content scanning alert.
     * "id" is the alert ARI
     */
    alertSnippets?: Maybe<ShepherdAlertSnippetResult>;
    /**
     * Returns the authorized actions the current user can perform on a given resource in the context of an alert.
     * "id" is the alert ARI
     * "resource" is the ARI of the resource
     */
    authorizedActions?: Maybe<ShepherdAlertAuthorizedActionsResult>;
    /** THIS QUERY IS IN BETA */
    byAri?: Maybe<ShepherdAlertResult>;
    /**
     * THIS QUERY IS IN BETA
     *
     * "workspaceId" can be either a workspaceId or a BeaconWorkspaceAri
     */
    byWorkspace?: Maybe<ShepherdAlertsResult>;
};

export type ShepherdAlertQueriesAlertExportsArgs = {
    id: Scalars["ID"]["input"];
};

export type ShepherdAlertQueriesAlertSnippetsArgs = {
    id: Scalars["ID"]["input"];
};

export type ShepherdAlertQueriesAuthorizedActionsArgs = {
    id: Scalars["ID"]["input"];
    resource: Scalars["ID"]["input"];
};

export type ShepherdAlertQueriesByAriArgs = {
    id: Scalars["ID"]["input"];
};

export type ShepherdAlertQueriesByWorkspaceArgs = {
    aaid?: InputMaybe<Scalars["ID"]["input"]>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdAlertResult = QueryError | ShepherdAlert;

export type ShepherdAlertSnippet = {
    __typename?: "ShepherdAlertSnippet";
    adf?: Maybe<Scalars["JSON"]["output"]>;
    contentId: Scalars["ID"]["output"];
    field: Scalars["String"]["output"];
    redactable: Scalars["Boolean"]["output"];
    redactedOn?: Maybe<Scalars["DateTime"]["output"]>;
    redactionStatus: ShepherdAlertSnippetRedactionStatus;
    snippetTextBlocks?: Maybe<Array<ShepherdAlertSnippetTextBlock>>;
};

export enum ShepherdAlertSnippetRedactionStatus {
    Redacted = "REDACTED",
    RedactionFailed = "REDACTION_FAILED",
    RedactionPending = "REDACTION_PENDING",
    Unredacted = "UNREDACTED"
}

export type ShepherdAlertSnippetResult = QueryError | ShepherdAlertSnippets;

export type ShepherdAlertSnippetTextBlock = {
    __typename?: "ShepherdAlertSnippetTextBlock";
    isSensitive?: Maybe<Scalars["Boolean"]["output"]>;
    styles?: Maybe<ShepherdAlertSnippetTextBlockStyles>;
    text: Scalars["String"]["output"];
};

/** Styles mapped from ADF marks -> https://developer.atlassian.com/cloud/jira/platform/apis/document/marks/backgroundColor/ */
export type ShepherdAlertSnippetTextBlockStyles = {
    __typename?: "ShepherdAlertSnippetTextBlockStyles";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    isBold?: Maybe<Scalars["Boolean"]["output"]>;
    isCode?: Maybe<Scalars["Boolean"]["output"]>;
    isItalic?: Maybe<Scalars["Boolean"]["output"]>;
    isStrike?: Maybe<Scalars["Boolean"]["output"]>;
    isSubSup?: Maybe<Scalars["Boolean"]["output"]>;
    isUnderline?: Maybe<Scalars["Boolean"]["output"]>;
    link?: Maybe<Scalars["String"]["output"]>;
    textColor?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdAlertSnippets = {
    __typename?: "ShepherdAlertSnippets";
    snippets?: Maybe<Array<ShepherdAlertSnippet>>;
    timestamp?: Maybe<Scalars["String"]["output"]>;
    versionMismatch?: Maybe<Scalars["Boolean"]["output"]>;
};

export enum ShepherdAlertStatus {
    InProgress = "IN_PROGRESS",
    Triaged = "TRIAGED",
    TriagedExpectedActivity = "TRIAGED_EXPECTED_ACTIVITY",
    TriagedTruePositive = "TRIAGED_TRUE_POSITIVE",
    Untriaged = "UNTRIAGED"
}

/**
 * Contains supporting information useful for evaluating an alert.
 * Today it attaches the concept of a "highlight" to alerts. It can be extended to hold additional highlights or
 * other types of information.
 */
export type ShepherdAlertSupportingData = {
    __typename?: "ShepherdAlertSupportingData";
    bitbucketDetectionHighlight?: Maybe<ShepherdBitbucketDetectionHighlight>;
    customDetectionHighlight?: Maybe<ShepherdCustomDetectionHighlight>;
    /** A highlight contains contextual information produced by the detection that created the alert. */
    highlight: ShepherdHighlight;
    marketplaceAppHighlight?: Maybe<ShepherdMarketplaceAppHighlight>;
    searchDetectionHighlight?: Maybe<ShepherdSearchDetectionHighlight>;
};

export enum ShepherdAlertTemplateType {
    AddedConfluenceGlobalPermission = "ADDED_CONFLUENCE_GLOBAL_PERMISSION",
    AddedConfluenceSpacePermission = "ADDED_CONFLUENCE_SPACE_PERMISSION",
    AddedDomain = "ADDED_DOMAIN",
    AddedJiraGlobalPermission = "ADDED_JIRA_GLOBAL_PERMISSION",
    AddedOrgadmin = "ADDED_ORGADMIN",
    BitbucketRepositoryPrivacy = "BITBUCKET_REPOSITORY_PRIVACY",
    BitbucketWorkspacePrivacy = "BITBUCKET_WORKSPACE_PRIVACY",
    ClassificationLevelArchived = "CLASSIFICATION_LEVEL_ARCHIVED",
    ClassificationLevelPublished = "CLASSIFICATION_LEVEL_PUBLISHED",
    CompromisedMobileDevice = "COMPROMISED_MOBILE_DEVICE",
    ConfluenceCustomDetection = "CONFLUENCE_CUSTOM_DETECTION",
    ConfluenceDataDiscovery = "CONFLUENCE_DATA_DISCOVERY",
    ConfluenceDataDiscoveryAtlassianToken = "CONFLUENCE_DATA_DISCOVERY_ATLASSIAN_TOKEN",
    ConfluenceDataDiscoveryAuTfn = "CONFLUENCE_DATA_DISCOVERY_AU_TFN",
    ConfluenceDataDiscoveryAwsKeys = "CONFLUENCE_DATA_DISCOVERY_AWS_KEYS",
    ConfluenceDataDiscoveryCreditCard = "CONFLUENCE_DATA_DISCOVERY_CREDIT_CARD",
    ConfluenceDataDiscoveryCrypto = "CONFLUENCE_DATA_DISCOVERY_CRYPTO",
    ConfluenceDataDiscoveryIban = "CONFLUENCE_DATA_DISCOVERY_IBAN",
    ConfluenceDataDiscoveryJwtKey = "CONFLUENCE_DATA_DISCOVERY_JWT_KEY",
    ConfluenceDataDiscoveryPassword = "CONFLUENCE_DATA_DISCOVERY_PASSWORD",
    ConfluenceDataDiscoveryPrivateKey = "CONFLUENCE_DATA_DISCOVERY_PRIVATE_KEY",
    ConfluenceDataDiscoveryUsSsn = "CONFLUENCE_DATA_DISCOVERY_US_SSN",
    ConfluencePageCrawling = "CONFLUENCE_PAGE_CRAWLING",
    ConfluencePageExports = "CONFLUENCE_PAGE_EXPORTS",
    ConfluenceSiteBackupDownloaded = "CONFLUENCE_SITE_BACKUP_DOWNLOADED",
    ConfluenceSpaceExports = "CONFLUENCE_SPACE_EXPORTS",
    ConfluenceSuspiciousSearch = "CONFLUENCE_SUSPICIOUS_SEARCH",
    CreatedAuthPolicy = "CREATED_AUTH_POLICY",
    CreatedMobileAppPolicy = "CREATED_MOBILE_APP_POLICY",
    CreatedPolicy = "CREATED_POLICY",
    CreatedSamlConfig = "CREATED_SAML_CONFIG",
    CreatedTunnel = "CREATED_TUNNEL",
    CreatedUserProvisioning = "CREATED_USER_PROVISIONING",
    DataSecurityPolicyActivated = "DATA_SECURITY_POLICY_ACTIVATED",
    DataSecurityPolicyDeactivated = "DATA_SECURITY_POLICY_DEACTIVATED",
    DataSecurityPolicyDeleted = "DATA_SECURITY_POLICY_DELETED",
    DataSecurityPolicyUpdated = "DATA_SECURITY_POLICY_UPDATED",
    Default = "DEFAULT",
    DeletedAuthPolicy = "DELETED_AUTH_POLICY",
    DeletedDomain = "DELETED_DOMAIN",
    DeletedMobileAppPolicy = "DELETED_MOBILE_APP_POLICY",
    DeletedPolicy = "DELETED_POLICY",
    DeletedTunnel = "DELETED_TUNNEL",
    EcosystemAuditLogInstallationCreated = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_CREATED",
    EcosystemAuditLogInstallationDeleted = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_DELETED",
    EcosystemAuditLogUserGrantCreated = "ECOSYSTEM_AUDIT_LOG_USER_GRANT_CREATED",
    EducationalAlert = "EDUCATIONAL_ALERT",
    EnableScimSync = "ENABLE_SCIM_SYNC",
    ExportedOrgeventscsv = "EXPORTED_ORGEVENTSCSV",
    GrantAssignedJiraPermissionScheme = "GRANT_ASSIGNED_JIRA_PERMISSION_SCHEME",
    IdentityPasswordResetCompletedUser = "IDENTITY_PASSWORD_RESET_COMPLETED_USER",
    ImpossibleTravel = "IMPOSSIBLE_TRAVEL",
    InitiatedGsyncConnection = "INITIATED_GSYNC_CONNECTION",
    JiraCustomDetection = "JIRA_CUSTOM_DETECTION",
    JiraDataDiscoveryAtlassianToken = "JIRA_DATA_DISCOVERY_ATLASSIAN_TOKEN",
    JiraDataDiscoveryAuTfn = "JIRA_DATA_DISCOVERY_AU_TFN",
    JiraDataDiscoveryAwsKeys = "JIRA_DATA_DISCOVERY_AWS_KEYS",
    JiraDataDiscoveryCreditCard = "JIRA_DATA_DISCOVERY_CREDIT_CARD",
    JiraDataDiscoveryCrypto = "JIRA_DATA_DISCOVERY_CRYPTO",
    JiraDataDiscoveryIban = "JIRA_DATA_DISCOVERY_IBAN",
    JiraDataDiscoveryJwtKey = "JIRA_DATA_DISCOVERY_JWT_KEY",
    JiraDataDiscoveryPassword = "JIRA_DATA_DISCOVERY_PASSWORD",
    JiraDataDiscoveryPrivateKey = "JIRA_DATA_DISCOVERY_PRIVATE_KEY",
    JiraDataDiscoveryUsSsn = "JIRA_DATA_DISCOVERY_US_SSN",
    JiraIssueCrawling = "JIRA_ISSUE_CRAWLING",
    LoginFromMaliciousIpAddress = "LOGIN_FROM_MALICIOUS_IP_ADDRESS",
    LoginFromTorExitNode = "LOGIN_FROM_TOR_EXIT_NODE",
    MobileScreenLock = "MOBILE_SCREEN_LOCK",
    OrgLoggedInAsUser = "ORG_LOGGED_IN_AS_USER",
    ProjectClassificationLevelDecreased = "PROJECT_CLASSIFICATION_LEVEL_DECREASED",
    ProjectClassificationLevelIncreased = "PROJECT_CLASSIFICATION_LEVEL_INCREASED",
    RotateScimDirectoryToken = "ROTATE_SCIM_DIRECTORY_TOKEN",
    SpaceClassificationLevelDecreased = "SPACE_CLASSIFICATION_LEVEL_DECREASED",
    SpaceClassificationLevelIncreased = "SPACE_CLASSIFICATION_LEVEL_INCREASED",
    TestAlert = "TEST_ALERT",
    TokenCreated = "TOKEN_CREATED",
    TokenRevoked = "TOKEN_REVOKED",
    UpdatedAuthPolicy = "UPDATED_AUTH_POLICY",
    UpdatedMobileAppPolicy = "UPDATED_MOBILE_APP_POLICY",
    UpdatedPolicy = "UPDATED_POLICY",
    UpdatedSamlConfig = "UPDATED_SAML_CONFIG",
    UserAddedToBeacon = "USER_ADDED_TO_BEACON",
    UserGrantedRole = "USER_GRANTED_ROLE",
    UserRemovedFromBeacon = "USER_REMOVED_FROM_BEACON",
    UserRevokedRole = "USER_REVOKED_ROLE",
    UserTokenCreated = "USER_TOKEN_CREATED",
    UserTokenRevoked = "USER_TOKEN_REVOKED",
    VerifiedDomainVerification = "VERIFIED_DOMAIN_VERIFICATION"
}

export type ShepherdAlertTitle = {
    __typename?: "ShepherdAlertTitle";
    default: Scalars["String"]["output"];
};

/** Placeholder type to enable eventually adding pagination via the relay connection pattern (https://relay.dev/graphql/connections.htm). */
export type ShepherdAlertsConnection = {
    __typename?: "ShepherdAlertsConnection";
    edges?: Maybe<Array<Maybe<ShepherdAlertEdge>>>;
    pageInfo: PageInfo;
};

/** #### Types: Query Results ##### */
export type ShepherdAlertsResult = QueryError | ShepherdAlertsConnection;

/** Represents an anonymous actor that has performed an action in the system. */
export type ShepherdAnonymousActor = {
    __typename?: "ShepherdAnonymousActor";
    ipAddress?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdAnonymousActorInput = {
    /** An optional IP address */
    ipAddress?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShepherdAppInfo = {
    __typename?: "ShepherdAppInfo";
    apiVersion: Scalars["Int"]["output"];
    commitHash?: Maybe<Scalars["String"]["output"]>;
    env: Scalars["String"]["output"];
    loginUrl: Scalars["String"]["output"];
};

export enum ShepherdAtlassianProduct {
    AdminHub = "ADMIN_HUB",
    Bitbucket = "BITBUCKET",
    Confluence = "CONFLUENCE",
    ConfluenceDc = "CONFLUENCE_DC",
    GuardDetect = "GUARD_DETECT",
    JiraDc = "JIRA_DC",
    JiraSoftware = "JIRA_SOFTWARE",
    Marketplace = "MARKETPLACE"
}

/** Represents an actor that is an Internal Atlassian System. */
export type ShepherdAtlassianSystemActor = {
    __typename?: "ShepherdAtlassianSystemActor";
    /** Name of the system. Likely 'Internal Service'. */
    name: Scalars["String"]["output"];
};

export type ShepherdAuditLogAttribute = {
    __typename?: "ShepherdAuditLogAttribute";
    name: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type ShepherdAuditLogContext = {
    __typename?: "ShepherdAuditLogContext";
    attributes: Array<ShepherdAuditLogAttribute>;
    id: Scalars["String"]["output"];
};

export type ShepherdBitbucketDetectionHighlight = {
    __typename?: "ShepherdBitbucketDetectionHighlight";
    repository?: Maybe<ShepherdBitbucketRepositoryInfo>;
    workspace?: Maybe<ShepherdBitbucketWorkspaceInfo>;
};

export type ShepherdBitbucketRepositoryInfo = {
    __typename?: "ShepherdBitbucketRepositoryInfo";
    name: Scalars["String"]["output"];
    url: Scalars["URL"]["output"];
};

export type ShepherdBitbucketWorkspace = {
    __typename?: "ShepherdBitbucketWorkspace";
    ari: Scalars["ID"]["output"];
    slug?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdBitbucketWorkspaceInfo = {
    __typename?: "ShepherdBitbucketWorkspaceInfo";
    name: Scalars["String"]["output"];
    url: Scalars["URL"]["output"];
};

/** Represent metadata for the alert grouped by category */
export type ShepherdCategorizedAlertMetadata = {
    __typename?: "ShepherdCategorizedAlertMetadata";
    /** Name of the category for the alert metadata */
    category: Scalars["String"]["output"];
    /** Actual metadata for the alert that belong to the category */
    values: Array<Scalars["String"]["output"]>;
};

export type ShepherdClassification = {
    __typename?: "ShepherdClassification";
    changedBy?: Maybe<ShepherdClassificationUser>;
    changedOn?: Maybe<Scalars["DateTime"]["output"]>;
    color?: Maybe<ShepherdClassificationLevelColor>;
    createdBy?: Maybe<ShepherdClassificationUser>;
    createdOn?: Maybe<Scalars["DateTime"]["output"]>;
    definition?: Maybe<Scalars["String"]["output"]>;
    guideline?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    orgId: Scalars["ID"]["output"];
    sensitivity: Scalars["Int"]["output"];
    status: ShepherdClassificationStatus;
};

export type ShepherdClassificationEdge = {
    __typename?: "ShepherdClassificationEdge";
    ari?: Maybe<Scalars["ID"]["output"]>;
    node?: Maybe<ShepherdClassification>;
};

export enum ShepherdClassificationLevelColor {
    Blue = "BLUE",
    BlueBold = "BLUE_BOLD",
    Green = "GREEN",
    Grey = "GREY",
    Lime = "LIME",
    Navy = "NAVY",
    None = "NONE",
    Orange = "ORANGE",
    Purple = "PURPLE",
    Red = "RED",
    RedBold = "RED_BOLD",
    Teal = "TEAL",
    Yellow = "YELLOW"
}

export enum ShepherdClassificationStatus {
    Archived = "ARCHIVED",
    Draft = "DRAFT",
    Published = "PUBLISHED"
}

export type ShepherdClassificationUser = {
    __typename?: "ShepherdClassificationUser";
    accountId: Scalars["String"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdClassificationsConnection = {
    __typename?: "ShepherdClassificationsConnection";
    /** A list of classification edges */
    edges?: Maybe<Array<Maybe<ShepherdClassificationEdge>>>;
};

export type ShepherdClassificationsQueries = {
    __typename?: "ShepherdClassificationsQueries";
    /**
     * THIS QUERY IS IN BETA
     *
     * "workspaceId" can be either a workspaceId or a BeaconWorkspaceAri
     */
    byResource?: Maybe<ShepherdClassificationsResult>;
};

export type ShepherdClassificationsQueriesByResourceArgs = {
    aris: Array<Scalars["ID"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdClassificationsResult =
    | QueryError
    | ShepherdClassificationsConnection;

/** ##### Input ###### */
export type ShepherdCreateAlertInput = {
    actor?: InputMaybe<ShepherdActorInput>;
    assignee?: InputMaybe<Scalars["ID"]["input"]>;
    /** Cloud ID (aka site ID). Required if neither orgId nor workspaceId are provided. */
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use customFields instead
     */
    customDetectionHighlight?: InputMaybe<ShepherdCustomDetectionHighlightInput>;
    customFields?: InputMaybe<Scalars["JSON"]["input"]>;
    /**
     * An optional key that is intended to prevent creating duplicate alerts via the API. It can help in cases such as the
     * consumer retries a request after a timeout or wants to sync alerts after an issue where it's clear which alerts
     * have been created.
     */
    deduplicationKey?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * A highlight contains contextual information produced by the detection that created the alert.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use customFields instead
     */
    highlight?: InputMaybe<ShepherdHighlightInput>;
    /** Organization ID. Required if neither orgId nor cloudId are provided. */
    orgId?: InputMaybe<Scalars["ID"]["input"]>;
    status?: InputMaybe<ShepherdAlertStatus>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use type instead
     */
    template?: InputMaybe<ShepherdAlertTemplateType>;
    time?: InputMaybe<ShepherdTimeInput>;
    title: Scalars["String"]["input"];
    /** Type of the alert */
    type?: InputMaybe<Scalars["String"]["input"]>;
    /** Beacon workspace ID. Required if neither orgId nor cloudId are provided. */
    workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** #### Payload ##### */
export type ShepherdCreateAlertPayload = Payload & {
    __typename?: "ShepherdCreateAlertPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdAlert>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdCreateAlertsPayload = Payload & {
    __typename?: "ShepherdCreateAlertsPayload";
    errors?: Maybe<Array<MutationError>>;
    nodes?: Maybe<Array<Maybe<ShepherdAlert>>>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdCreateSlackInput = {
    authToken: Scalars["String"]["input"];
    callbackURL: Scalars["URL"]["input"];
    channelId: Scalars["String"]["input"];
    status: ShepherdSubscriptionStatus;
    teamId: Scalars["String"]["input"];
};

export type ShepherdCreateSubscriptionPayload = Payload & {
    __typename?: "ShepherdCreateSubscriptionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<ShepherdSubscription>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ShepherdCreateTestAlertPayload = Payload & {
    __typename?: "ShepherdCreateTestAlertPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdAlert>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdCreateWebhookInput = {
    authHeader?: InputMaybe<Scalars["String"]["input"]>;
    callbackURL: Scalars["URL"]["input"];
    destinationType?: InputMaybe<ShepherdWebhookDestinationType>;
    status?: InputMaybe<ShepherdSubscriptionStatus>;
    /** DEPRECATED: Use destinationType instead. */
    type?: InputMaybe<ShepherdWebhookType>;
};

/** Represents the current user in the Shepherd system. */
export type ShepherdCurrentUser = {
    __typename?: "ShepherdCurrentUser";
    isOrgAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    user?: Maybe<ShepherdUser>;
};

/** Configuration for a custom content scanning detection. A list of rules that will be matched against content. */
export type ShepherdCustomContentScanningDetection = {
    __typename?: "ShepherdCustomContentScanningDetection";
    rules: Array<Maybe<ShepherdCustomScanningRule>>;
};

/** A user created detection. Currently only custom content scanning is supported. */
export type ShepherdCustomDetection = {
    __typename?: "ShepherdCustomDetection";
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    products: Array<Maybe<ShepherdAtlassianProduct>>;
    settings?: Maybe<Array<ShepherdDetectionSetting>>;
    title: Scalars["String"]["output"];
    value: ShepherdCustomDetectionValueType;
};

export type ShepherdCustomDetectionHighlight = {
    __typename?: "ShepherdCustomDetectionHighlight";
    customDetectionId: Scalars["ID"]["output"];
    matchedRules?: Maybe<Array<Maybe<ShepherdCustomScanningRule>>>;
};

export type ShepherdCustomDetectionHighlightInput = {
    customDetectionId: Scalars["ID"]["input"];
    matchedRules?: InputMaybe<
        Array<InputMaybe<ShepherdCustomScanningStringMatchRuleInput>>
    >;
};

export type ShepherdCustomDetectionMutationPayload = Payload & {
    __typename?: "ShepherdCustomDetectionMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdCustomDetection>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdCustomDetectionValueType =
    ShepherdCustomContentScanningDetection;

export enum ShepherdCustomScanningMatchType {
    Regex = "REGEX",
    String = "STRING",
    Word = "WORD"
}

export type ShepherdCustomScanningRule = ShepherdCustomScanningStringMatchRule;

/** GraphQL doesn't allow unions in input types so this is to allow for different rule types in the future. */
export type ShepherdCustomScanningRuleInput = {
    stringMatch?: InputMaybe<ShepherdCustomScanningStringMatchRuleInput>;
};

/** A rule to match against content. Contains a term an whether it's a string match or word match. */
export type ShepherdCustomScanningStringMatchRule = {
    __typename?: "ShepherdCustomScanningStringMatchRule";
    matchType: ShepherdCustomScanningMatchType;
    term: Scalars["String"]["output"];
};

/** Input type for a rule to match against content. Contains a term an whether it's a string match or word match. */
export type ShepherdCustomScanningStringMatchRuleInput = {
    matchType: ShepherdCustomScanningMatchType;
    term: Scalars["String"]["input"];
};

export type ShepherdDescriptionTemplate = {
    __typename?: "ShepherdDescriptionTemplate";
    extendedText?: Maybe<Scalars["JSON"]["output"]>;
    investigationText?: Maybe<Scalars["JSON"]["output"]>;
    remediationActions?: Maybe<Array<ShepherdRemediationAction>>;
    remediationText?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * Description text in ADF format.  See
     * https://developer.atlassian.com/platform/atlassian-document-format/
     */
    text?: Maybe<Scalars["JSON"]["output"]>;
    type?: Maybe<ShepherdAlertTemplateType>;
};

/** This would represent a detection in beacon, each detection possibly containing a set of settings */
export type ShepherdDetection = {
    __typename?: "ShepherdDetection";
    /** Business sectors to which a detection is most relevant (i.e. Finance, Healthcare) */
    businessTypes?: Maybe<Array<Scalars["String"]["output"]>>;
    category: ShepherdAlertDetectionCategory;
    /** A description of the detection's logic to the users (just the part we want to reveal, we don't have to expose all of the logic) */
    description?: Maybe<Scalars["JSON"]["output"]>;
    id: Scalars["ID"]["output"];
    products: Array<Maybe<ShepherdAtlassianProduct>>;
    /** Regions to which a detection is most relevant (i.e. EU, EMEA, Americas) */
    regions?: Maybe<Array<Scalars["String"]["output"]>>;
    relatedAlertTypes?: Maybe<Array<Maybe<ShepherdRelatedAlertType>>>;
    scanningInfo: ShepherdDetectionScanningInfo;
    /**
     * `settings` fetch the list of possible settings per detection, each setting with their default values (if they were never adjusted by a user)
     * Simple detections don't have to have a settings object set, while complex ones most likely would.
     */
    settings?: Maybe<Array<ShepherdDetectionSetting>>;
    title: Scalars["String"]["output"];
};

/** THIS TYPE IS IN BETA, DO NOT USE */
export type ShepherdDetectionConfluenceEnabledSetting = {
    __typename?: "ShepherdDetectionConfluenceEnabledSetting";
    booleanDefault: Scalars["Boolean"]["output"];
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ShepherdDetectionContentExclusion = {
    __typename?: "ShepherdDetectionContentExclusion";
    /** Identifier of the exclusion group within the detection. */
    key: Scalars["String"]["output"];
    /** Rules to exclude the content. */
    rules: Array<ShepherdDetectionContentExclusionRule>;
};

export type ShepherdDetectionContentExclusionRule =
    ShepherdCustomScanningStringMatchRule;

/** Represents an individual exclusion. */
export type ShepherdDetectionExclusion =
    | ShepherdDetectionContentExclusion
    | ShepherdDetectionResourceExclusion;

/** Setting that contains exclusion configuration so that a detection can filter out unwanted alerts for customers. */
export type ShepherdDetectionExclusionsSetting = {
    __typename?: "ShepherdDetectionExclusionsSetting";
    /**
     * Set of types of exclusions that are allowed in the detection setting, represented by ATIs such as
     * ati:cloud:confluence:page and ati:cloud:identity:user.
     */
    allowedExclusions: Array<Scalars["String"]["output"]>;
    /** Set of the actual exclusions configured by the customer. Items are stored together but managed individually. */
    exclusions: Array<ShepherdDetectionExclusion>;
};

export type ShepherdDetectionJiraEnabledSetting = {
    __typename?: "ShepherdDetectionJiraEnabledSetting";
    booleanDefault: Scalars["Boolean"]["output"];
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ShepherdDetectionRemoveSettingValuePayload = Payload & {
    __typename?: "ShepherdDetectionRemoveSettingValuePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** An individual resource exclusion */
export type ShepherdDetectionResourceExclusion = {
    __typename?: "ShepherdDetectionResourceExclusion";
    /** ARI of the actor, group, page, classification, etc. */
    ari: Scalars["ID"]["output"];
    /** classification ID */
    classificationId?: Maybe<Scalars["ID"]["output"]>;
    /** Title of the container, e.g. space name. */
    containerTitle?: Maybe<Scalars["String"]["output"]>;
    /** The AAID of the Shepherd User who created the exclusion. */
    createdBy?: Maybe<Scalars["ID"]["output"]>;
    createdByUser?: Maybe<User>;
    /** The time the exclusion was created. */
    createdOn?: Maybe<Scalars["DateTime"]["output"]>;
    /** Title of the resource, e.g. page title. */
    resourceTitle?: Maybe<Scalars["String"]["output"]>;
    /** Optional URL for the resource. Used in case the resource is excluded and we can't hydrate a fresh URL. */
    resourceUrl?: Maybe<Scalars["String"]["output"]>;
};

export enum ShepherdDetectionScanningFrequency {
    RealTime = "REAL_TIME",
    Scheduled = "SCHEDULED"
}

export type ShepherdDetectionScanningInfo = {
    __typename?: "ShepherdDetectionScanningInfo";
    scanningFrequency: ShepherdDetectionScanningFrequency;
};

export type ShepherdDetectionSetting = {
    __typename?: "ShepherdDetectionSetting";
    /**
     * Description text in ADF format. See
     * https://developer.atlassian.com/platform/atlassian-document-format/
     */
    description?: Maybe<Scalars["JSON"]["output"]>;
    id: Scalars["ID"]["output"];
    title: Scalars["String"]["output"];
    value: ShepherdDetectionSettingValueType;
};

export type ShepherdDetectionSettingMutations = {
    __typename?: "ShepherdDetectionSettingMutations";
    /**
     * Remove detection setting value(s).
     * "id" is the setting ARI.
     * "keys" contains individual entries to be removed from multi-valued settings. If "keys" is  null, the entire setting record will be deleted.
     */
    removeValue?: Maybe<ShepherdDetectionRemoveSettingValuePayload>;
    /**
     * Update a detection setting with a new value (or values).
     * "id" is the setting ARI.
     * "input" will vary according to the setting:
     *   - Single-valued settings (jiraEnabled, confluenceEnabled, sensitivity) will just have their values replaced.
     *   - Multi-valued settings (exclusions) will allow updating individual entries.
     */
    setValue?: Maybe<ShepherdDetectionUpdateSettingValuePayload>;
};

export type ShepherdDetectionSettingMutationsRemoveValueArgs = {
    id: Scalars["ID"]["input"];
    keys?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ShepherdDetectionSettingMutationsSetValueArgs = {
    id: Scalars["ID"]["input"];
    input: ShepherdDetectionSettingSetValueInput;
};

export type ShepherdDetectionSettingSetValueEntryInput = {
    key: Scalars["String"]["input"];
    scanningRules?: InputMaybe<Array<ShepherdCustomScanningRuleInput>>;
};

export type ShepherdDetectionSettingSetValueInput = {
    /**
     * A list of mapped entries.
     * For exclusions: add all scanningRules items to the setting.
     */
    entries?: InputMaybe<Array<ShepherdDetectionSettingSetValueEntryInput>>;
    /**
     * A list of string values.
     * For exclusions: add all ARIs to the setting.
     */
    stringValues?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** Update the threshold value for the setting. */
    thresholdValue?: InputMaybe<ShepherdRateThresholdValue>;
};

/** Describes the data the setting can hold. */
export type ShepherdDetectionSettingValueType =
    | ShepherdDetectionConfluenceEnabledSetting
    | ShepherdDetectionExclusionsSetting
    | ShepherdDetectionJiraEnabledSetting
    | ShepherdRateThresholdSetting;

export type ShepherdDetectionUpdateSettingValuePayload = Payload & {
    __typename?: "ShepherdDetectionUpdateSettingValuePayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdDetectionSetting>;
    success: Scalars["Boolean"]["output"];
};

/** Represents specific metadata that adds context to DSP list changes */
export type ShepherdDspListMetadata = {
    __typename?: "ShepherdDspListMetadata";
    /** Indicates type of list has switched during current update */
    isSwitched?: Maybe<Scalars["Boolean"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdExclusionContentInfo = {
    __typename?: "ShepherdExclusionContentInfo";
    ari?: Maybe<Scalars["String"]["output"]>;
    classification?: Maybe<Scalars["String"]["output"]>;
    owner?: Maybe<Scalars["ID"]["output"]>;
    product?: Maybe<ShepherdAtlassianProduct>;
    site?: Maybe<ShepherdSite>;
    space?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["URL"]["output"]>;
};

export type ShepherdExclusionContentInfoResult =
    | QueryError
    | ShepherdExclusionContentInfo;

export type ShepherdExclusionUserSearchConnection = {
    __typename?: "ShepherdExclusionUserSearchConnection";
    edges?: Maybe<Array<Maybe<ShepherdExclusionUserSearchEdge>>>;
    pageInfo: PageInfo;
};

export type ShepherdExclusionUserSearchEdge = {
    __typename?: "ShepherdExclusionUserSearchEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<ShepherdExclusionUserSearchNode>;
};

export type ShepherdExclusionUserSearchNode = {
    __typename?: "ShepherdExclusionUserSearchNode";
    aaid: Scalars["ID"]["output"];
    accountType?: Maybe<Scalars["String"]["output"]>;
    createdOn?: Maybe<Scalars["DateTime"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdExclusionUserSearchResult =
    | QueryError
    | ShepherdExclusionUserSearchConnection;

export type ShepherdExclusionsQueries = {
    __typename?: "ShepherdExclusionsQueries";
    /** THIS QUERY IS IN BETA */
    contentInfo?: Maybe<ShepherdExclusionContentInfoResult>;
    /**
     * THIS QUERY IS IN BETA
     *
     * Search users to be excluded by name or email
     */
    userSearch?: Maybe<ShepherdExclusionUserSearchResult>;
};

export type ShepherdExclusionsQueriesContentInfoArgs = {
    contentUrlOrAri: Scalars["String"]["input"];
    productAti: Scalars["String"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdExclusionsQueriesUserSearchArgs = {
    searchQuery?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdExternalResource = JiraIssue;

export type ShepherdGenericMutationErrorExtension = MutationErrorExtension & {
    __typename?: "ShepherdGenericMutationErrorExtension";
    /**
     * A code representing the type of error. String form of ShepherdMutationErrorType.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * Specify an input field given by the consumer that is the source of the error
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    inputField?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A code representing the type of error. See the ShepherdMutationErrorType enum for possible values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type?: Maybe<ShepherdMutationErrorType>;
};

export type ShepherdGenericQueryErrorExtension = QueryErrorExtension & {
    __typename?: "ShepherdGenericQueryErrorExtension";
    /**
     * A code representing the type of error. String form of ShepherdQueryErrorType.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
    /**
     * A code representing the type of error. See the ShepherdQueryErrorType enum for possible values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    type?: Maybe<ShepherdQueryErrorType>;
};

/** A highlight contains contextual information produced by the detection that created the alert. */
export type ShepherdHighlight = ShepherdActivityHighlight;

/**
 * A highlight contains contextual information produced by the detection that created the alert.
 * One field is required and only one can be informed at a time.
 */
export type ShepherdHighlightInput = {
    /** Information about the activity that originated the alert */
    activityHighlight?: InputMaybe<ShepherdActivityHighlightInput>;
    customDetectionHighlight?: InputMaybe<ShepherdCustomDetectionHighlightInput>;
};

export type ShepherdHistogramBucketInput = {
    /** Name of the bucket that contributes to the signal histogram */
    name: Scalars["String"]["input"];
    /** Numerical representation of the bucket value */
    value: Scalars["Int"]["input"];
};

export type ShepherdLinkedResource = {
    __typename?: "ShepherdLinkedResource";
    id: Scalars["ID"]["output"];
    resource?: Maybe<ShepherdExternalResource>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdLinkedResourceInput = {
    id: Scalars["ID"]["input"];
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShepherdLoginActivity = {
    __typename?: "ShepherdLoginActivity";
    /** The user performing the login activity. */
    actor: ShepherdActor;
    /** The city where the login activity occurred. */
    city?: Maybe<Scalars["String"]["output"]>;
    /** The country where the login activity occurred. */
    country?: Maybe<Scalars["String"]["output"]>;
    /** The ip where the login activity occurred. */
    ip?: Maybe<Scalars["String"]["output"]>;
    /** The region where the login activity occurred. */
    region?: Maybe<Scalars["String"]["output"]>;
    /** The time the login activity occurred. */
    time: Scalars["DateTime"]["output"];
};

export type ShepherdLoginDevice = {
    __typename?: "ShepherdLoginDevice";
    browserName?: Maybe<Scalars["String"]["output"]>;
    browserVersion?: Maybe<Scalars["String"]["output"]>;
    model?: Maybe<Scalars["String"]["output"]>;
    osName?: Maybe<Scalars["String"]["output"]>;
    osVersion?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<ShepherdLoginDeviceType>;
    userAgent?: Maybe<Scalars["String"]["output"]>;
    vendor?: Maybe<Scalars["String"]["output"]>;
};

export enum ShepherdLoginDeviceType {
    Computer = "COMPUTER",
    Console = "CONSOLE",
    Embedded = "EMBEDDED",
    Mobile = "MOBILE",
    SmartTv = "SMART_TV",
    Tablet = "TABLET",
    Wearable = "WEARABLE"
}

export type ShepherdLoginLocation = {
    __typename?: "ShepherdLoginLocation";
    /** City where the user logged in */
    city?: Maybe<Scalars["String"]["output"]>;
    /** Country ISO code (e.g., US or FR) where the user logged in */
    countryIsoCode?: Maybe<Scalars["String"]["output"]>;
    /** Country name where the user logged in */
    countryName?: Maybe<Scalars["String"]["output"]>;
    /** IP address of the user */
    ipAddress?: Maybe<Scalars["String"]["output"]>;
    /** Internet service provider where the user is connected */
    isp?: Maybe<Scalars["String"]["output"]>;
    /** Latitude where the user logged in */
    latitude?: Maybe<Scalars["Float"]["output"]>;
    /** Longitude where the user logged in */
    longitude?: Maybe<Scalars["Float"]["output"]>;
    /** Region ISO code (e.g, TX) where the user logged in */
    regionIsoCode?: Maybe<Scalars["String"]["output"]>;
    /** Region name (e.g., Texas) where the user logged in */
    regionName?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdMarketplaceAppHighlight = {
    __typename?: "ShepherdMarketplaceAppHighlight";
    appId?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<Scalars["String"]["output"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutation = {
    __typename?: "ShepherdMutation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    actor?: Maybe<ShepherdActorMutations>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createAlert?: Maybe<ShepherdCreateAlertPayload>;
    /**
     * Creates multiple alerts.
     * All alerts need to point to the same exact container: workspace, org or site.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createAlerts?: Maybe<ShepherdCreateAlertsPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createTestAlert?: Maybe<ShepherdCreateTestAlertPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    redaction?: Maybe<ShepherdRedactionMutations>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    subscription?: Maybe<ShepherdSubscriptionMutations>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    unlinkAlertResources?: Maybe<ShepherdUpdateAlertPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateAlert?: Maybe<ShepherdUpdateAlertPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateAlerts?: Maybe<ShepherdUpdateAlertsPayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workspace?: Maybe<ShepherdWorkspaceMutations>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutationCreateAlertArgs = {
    input: ShepherdCreateAlertInput;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutationCreateAlertsArgs = {
    input: Array<ShepherdCreateAlertInput>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutationCreateTestAlertArgs = {
    workspaceId: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutationUnlinkAlertResourcesArgs = {
    id: Scalars["ID"]["input"];
    input: ShepherdUnlinkAlertResourcesInput;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutationUpdateAlertArgs = {
    id: Scalars["ID"]["input"];
    input: ShepherdUpdateAlertInput;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdMutationUpdateAlertsArgs = {
    ids: Array<InputMaybe<Scalars["ID"]["input"]>>;
    input: ShepherdUpdateAlertInput;
};

/** #### Types: Mutation ##### */
export enum ShepherdMutationErrorType {
    BadRequest = "BAD_REQUEST",
    InternalServerError = "INTERNAL_SERVER_ERROR",
    NoProductAccess = "NO_PRODUCT_ACCESS",
    Unauthorized = "UNAUTHORIZED"
}

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdQuery = {
    __typename?: "ShepherdQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    alert?: Maybe<ShepherdAlertQueries>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    classifications?: Maybe<ShepherdClassificationsQueries>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    exclusions?: Maybe<ShepherdExclusionsQueries>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    shepherdActivity?: Maybe<ShepherdActivityResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    shepherdActor?: Maybe<ShepherdActorResult>;
    /**
     * THIS QUERY IS IN BETA
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated Use alertByAri instead.
     */
    shepherdAlert?: Maybe<ShepherdAlertResult>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    shepherdAppInfo: ShepherdAppInfo;
    /**
     * THIS QUERY IS IN BETA
     *
     * Returns the Beacon subscriptions for a given workspace.
     * "workspaceId" can be either a workspaceId or a BeaconWorkspaceAri
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    subscriptions?: Maybe<ShepherdSubscriptionsResult>;
    /**
     * THIS QUERY IS IN BETA
     * Only a single one of the possible inputs is needed (and will be used) to return a workspace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workspace?: Maybe<ShepherdWorkspaceResult>;
    /**
     * THIS QUERY IS IN BETA
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workspacesByUserContext?: Maybe<ShepherdWorkspaceResult>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdQueryShepherdActivityArgs = {
    actions?: InputMaybe<Array<InputMaybe<ShepherdActionType>>>;
    actor?: InputMaybe<Scalars["ID"]["input"]>;
    after?: InputMaybe<Scalars["String"]["input"]>;
    alertType?: InputMaybe<Scalars["String"]["input"]>;
    endTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    eventId?: InputMaybe<Scalars["ID"]["input"]>;
    first: Scalars["Int"]["input"];
    orgId?: InputMaybe<Scalars["String"]["input"]>;
    startTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    subject?: InputMaybe<ShepherdSubjectInput>;
    workspaceId?: InputMaybe<Scalars["String"]["input"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdQueryShepherdActorArgs = {
    aaid: Scalars["ID"]["input"];
    orgId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdQueryShepherdAlertArgs = {
    id: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdQuerySubscriptionsArgs = {
    workspaceId: Scalars["ID"]["input"];
};

/** eslint-disable-next-line @graphql-eslint/strict-id-in-types */
export type ShepherdQueryWorkspaceArgs = {
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    hostname?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    orgId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** #### Types: Query ##### */
export enum ShepherdQueryErrorType {
    BadRequest = "BAD_REQUEST",
    InternalServerError = "INTERNAL_SERVER_ERROR",
    NoProductAccess = "NO_PRODUCT_ACCESS",
    Unauthorized = "UNAUTHORIZED"
}

export type ShepherdRateThresholdSetting = {
    __typename?: "ShepherdRateThresholdSetting";
    /** This contains the actual custom values set by the user for the setting. */
    currentValue?: Maybe<ShepherdRateThresholdValue>;
    /** In case the user did not manually set a threshold, this would indicate what the default value is */
    defaultValue: ShepherdRateThresholdValue;
    values?: Maybe<Array<Maybe<ShepherdRateThresholdValue>>>;
};

/** A rate type detection has 3 modes, LOW will produce the most alerts, HIGH will product the least alerts */
export enum ShepherdRateThresholdValue {
    High = "HIGH",
    Low = "LOW",
    Medium = "MEDIUM"
}

export type ShepherdRedactedContent = {
    __typename?: "ShepherdRedactedContent";
    contentId: Scalars["ID"]["output"];
    status: ShepherdRedactedContentStatus;
};

export enum ShepherdRedactedContentStatus {
    Redacted = "REDACTED",
    RedactionFailed = "REDACTION_FAILED",
    RedactionPending = "REDACTION_PENDING"
}

/** Represents a requested redaction. The redaction might not be completed and might have failed */
export type ShepherdRedaction = Node & {
    __typename?: "ShepherdRedaction";
    createdOn: Scalars["DateTime"]["output"];
    id: Scalars["ID"]["output"];
    redactedContent: Array<ShepherdRedactedContent>;
    resource: Scalars["ID"]["output"];
    status: ShepherdRedactionStatus;
    updatedOn?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Input used when redacting content */
export type ShepherdRedactionInput = {
    /** The alert ARI that the redaction is associated with */
    alertId: Scalars["ID"]["input"];
    /** The list of `contentId`s to redact. `contentId`s should be taken from `ShepherdAlertSnippet` objects. */
    redactions: Array<Scalars["ID"]["input"]>;
    /** Whether or not to delete previous versions that contain the redacted content */
    removeHistory: Scalars["Boolean"]["input"];
    /** The creation timestamp for the version of the document that is intended to be redacted */
    timestamp: Scalars["String"]["input"];
};

export type ShepherdRedactionMutations = {
    __typename?: "ShepherdRedactionMutations";
    /**
     * THIS OPERATION IS IN BETA
     *
     * Redact content for an alert.
     * "input" contains the alert ARI, timestamp of the scanned document, and the list of content ids to redact.
     */
    redact?: Maybe<ShepherdRedactionPayload>;
};

export type ShepherdRedactionMutationsRedactArgs = {
    input: ShepherdRedactionInput;
};

export type ShepherdRedactionPayload = Payload & {
    __typename?: "ShepherdRedactionPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdRedaction>;
    success: Scalars["Boolean"]["output"];
};

export enum ShepherdRedactionStatus {
    Failed = "FAILED",
    PartiallyRedacted = "PARTIALLY_REDACTED",
    Pending = "PENDING",
    Redacted = "REDACTED"
}

export type ShepherdRelatedAlertType = {
    __typename?: "ShepherdRelatedAlertType";
    product?: Maybe<ShepherdAtlassianProduct>;
    /** eslint-disable-line @graphql-eslint/naming-convention */
    template?: Maybe<ShepherdAlertTemplateType>;
    title?: Maybe<ShepherdAlertTitle>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ShepherdRemediationAction = {
    __typename?: "ShepherdRemediationAction";
    description?: Maybe<Scalars["String"]["output"]>;
    linkHref?: Maybe<Scalars["String"]["output"]>;
    linkText?: Maybe<Scalars["String"]["output"]>;
    type: ShepherdRemediationActionType;
};

export enum ShepherdRemediationActionType {
    AnonAccessDspRemediation = "ANON_ACCESS_DSP_REMEDIATION",
    ApplyClassificationRemediation = "APPLY_CLASSIFICATION_REMEDIATION",
    AppsAccessDspRemediation = "APPS_ACCESS_DSP_REMEDIATION",
    ArchiveRestoreClassificationRemediation = "ARCHIVE_RESTORE_CLASSIFICATION_REMEDIATION",
    BlockchainExplorerRemediation = "BLOCKCHAIN_EXPLORER_REMEDIATION",
    BlockIpAllowlistRemediation = "BLOCK_IP_ALLOWLIST_REMEDIATION",
    CheckAutomationsRemediation = "CHECK_AUTOMATIONS_REMEDIATION",
    ClassificationLevelChangeRemediation = "CLASSIFICATION_LEVEL_CHANGE_REMEDIATION",
    CompromisedDeviceRemediation = "COMPROMISED_DEVICE_REMEDIATION",
    ConfluenceAnonAccessRemediation = "CONFLUENCE_ANON_ACCESS_REMEDIATION",
    DeleteDataRemediation = "DELETE_DATA_REMEDIATION",
    DeleteFilesRemediation = "DELETE_FILES_REMEDIATION",
    EditCustomDetectionRemediation = "EDIT_CUSTOM_DETECTION_REMEDIATION",
    ExcludePageRemediation = "EXCLUDE_PAGE_REMEDIATION",
    ExcludeUserRemediation = "EXCLUDE_USER_REMEDIATION",
    ExportsDspRemediation = "EXPORTS_DSP_REMEDIATION",
    ExportDspRemediation = "EXPORT_DSP_REMEDIATION",
    ExportSpacePermissionsRemediation = "EXPORT_SPACE_PERMISSIONS_REMEDIATION",
    JiraGlobalPermissionsRemediation = "JIRA_GLOBAL_PERMISSIONS_REMEDIATION",
    KeyOwnerRemediation = "KEY_OWNER_REMEDIATION",
    LimitJiraPermissionsRemediation = "LIMIT_JIRA_PERMISSIONS_REMEDIATION",
    ManageAppsRemediation = "MANAGE_APPS_REMEDIATION",
    ManageDomainRemediation = "MANAGE_DOMAIN_REMEDIATION",
    ManageDspRemediation = "MANAGE_DSP_REMEDIATION",
    PublicAccessDspRemediation = "PUBLIC_ACCESS_DSP_REMEDIATION",
    ResetAccountPasswordRemediation = "RESET_ACCOUNT_PASSWORD_REMEDIATION",
    RestoreAccessRemediation = "RESTORE_ACCESS_REMEDIATION",
    RestrictPageAutomationRemediation = "RESTRICT_PAGE_AUTOMATION_REMEDIATION",
    ReviewAccessRemediation = "REVIEW_ACCESS_REMEDIATION",
    ReviewApiKeysRemediation = "REVIEW_API_KEYS_REMEDIATION",
    ReviewApiTokensRemediation = "REVIEW_API_TOKENS_REMEDIATION",
    ReviewAuditLogRemediation = "REVIEW_AUDIT_LOG_REMEDIATION",
    ReviewAuthPolicyRemediation = "REVIEW_AUTH_POLICY_REMEDIATION",
    ReviewGsyncRemediation = "REVIEW_GSYNC_REMEDIATION",
    ReviewIpAllowlistRemediation = "REVIEW_IP_ALLOWLIST_REMEDIATION",
    ReviewIssueRemediation = "REVIEW_ISSUE_REMEDIATION",
    ReviewMobileAppPolicyRemediation = "REVIEW_MOBILE_APP_POLICY_REMEDIATION",
    ReviewOtherAuthPoliciesRemediation = "REVIEW_OTHER_AUTH_POLICIES_REMEDIATION",
    ReviewOtherIpAllowlistRemediation = "REVIEW_OTHER_IP_ALLOWLIST_REMEDIATION",
    ReviewPageRemediation = "REVIEW_PAGE_REMEDIATION",
    ReviewSamlRemediation = "REVIEW_SAML_REMEDIATION",
    ReviewScimRemediation = "REVIEW_SCIM_REMEDIATION",
    ReviewTunnelsConfigurationRemediation = "REVIEW_TUNNELS_CONFIGURATION_REMEDIATION",
    ReviewTunnelsRemediation = "REVIEW_TUNNELS_REMEDIATION",
    RevokeAccessRemediation = "REVOKE_ACCESS_REMEDIATION",
    RevokeApiKeyRemediation = "REVOKE_API_KEY_REMEDIATION",
    RevokeApiTokensRemediation = "REVOKE_API_TOKENS_REMEDIATION",
    RevokeUserApiTokenRemediation = "REVOKE_USER_API_TOKEN_REMEDIATION",
    SpacePermissionsRemediation = "SPACE_PERMISSIONS_REMEDIATION",
    SuspendActorRemediation = "SUSPEND_ACTOR_REMEDIATION",
    SuspendSubjectRemediation = "SUSPEND_SUBJECT_REMEDIATION",
    TurnOffJiraPermissionsRemediation = "TURN_OFF_JIRA_PERMISSIONS_REMEDIATION",
    TwoStepPolicyRemediation = "TWO_STEP_POLICY_REMEDIATION",
    UseAuthPolicyRemediation = "USE_AUTH_POLICY_REMEDIATION",
    ViewSpacePermissionsRemediation = "VIEW_SPACE_PERMISSIONS_REMEDIATION"
}

export type ShepherdResourceActivity = {
    __typename?: "ShepherdResourceActivity";
    /** The action being performed in the activity, already converted into our own ShepherdActionType from what was originally retrieved. */
    action: ShepherdActionType;
    /** The user performing the action named in a specific activity. */
    actor: ShepherdActor;
    /** Optional context on Audit Log events. */
    context: Array<ShepherdAuditLogContext>;
    /** The id of the activity, as provided by wherever we're getting these activities from (likely Audit Log). */
    id: Scalars["String"]["output"];
    /** The audit log message that describes the event action in ADF format */
    message?: Maybe<Scalars["JSON"]["output"]>;
    /** The ari corresponding to the resource being acted on in the activity. */
    resourceAri: Scalars["String"]["output"];
    /** The name of the resource as it was in the audit log entry. */
    resourceTitle?: Maybe<Scalars["String"]["output"]>;
    /** The URL to view the resource. */
    resourceUrl?: Maybe<Scalars["String"]["output"]>;
    /** The time the activity occurred. */
    time: Scalars["DateTime"]["output"];
};

/** Represents a resource that was acted upon at a specific time */
export type ShepherdResourceEvent = {
    __typename?: "ShepherdResourceEvent";
    ari: Scalars["String"]["output"];
    time: Scalars["DateTime"]["output"];
};

export type ShepherdResourceEventInput = {
    /** Name resource ARI of the event */
    ari: Scalars["String"]["input"];
    /** The DateTime of the event */
    time: Scalars["DateTime"]["input"];
};

export type ShepherdSearchDetectionHighlight = {
    __typename?: "ShepherdSearchDetectionHighlight";
    /** Contains all search queries that are related to the alert */
    searchQueries: Array<ShepherdSearchQuery>;
};

export enum ShepherdSearchOrigin {
    AdvancedSearch = "ADVANCED_SEARCH",
    Ai = "AI",
    QuickSearch = "QUICK_SEARCH"
}

/** Provides all necessary metadata about a search query */
export type ShepherdSearchQuery = {
    __typename?: "ShepherdSearchQuery";
    datetime: Scalars["DateTime"]["output"];
    query: Scalars["String"]["output"];
    searchOrigin?: Maybe<ShepherdSearchOrigin>;
    /**
     * Provides information about all suspicious search terms detected in the search query.
     * If the array is empty - then the query does not contain suspicious searches.
     */
    suspiciousSearchTerms?: Maybe<Array<ShepherdSuspiciousSearchTerm>>;
};

export type ShepherdSite = {
    __typename?: "ShepherdSite";
    cloudId: Scalars["ID"]["output"];
    tenantContext?: Maybe<TenantContext>;
};

export type ShepherdSlackEdge = ShepherdSubscriptionEdge & {
    __typename?: "ShepherdSlackEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /**
     * The item at the end of the edge
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<ShepherdSlackSubscription>;
};

/** Represents a slack subscription in the Shepherd system. */
export type ShepherdSlackSubscription = Node &
    ShepherdSubscription & {
        __typename?: "ShepherdSlackSubscription";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        callbackURL: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        channelId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        createdBy: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        createdOn: Scalars["DateTime"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        status: ShepherdSubscriptionStatus;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        teamId: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        updatedBy?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        updatedOn?: Maybe<Scalars["DateTime"]["output"]>;
    };

/** The resource was acted on */
export type ShepherdSubject = {
    __typename?: "ShepherdSubject";
    /** ARI of the resource acted on */
    ari?: Maybe<Scalars["String"]["output"]>;
    /** ATI with type of resource or group of resources, when a specific resource cannot be referenced directly. */
    ati?: Maybe<Scalars["String"]["output"]>;
    /** ARI of where it happened. An ARI pointing to an org, site, or other type of container. */
    containerAri: Scalars["String"]["output"];
    /** Name of the resource acted on */
    resourceName?: Maybe<Scalars["String"]["output"]>;
};

/** The resource was acted on */
export type ShepherdSubjectInput = {
    /** ARI of the resource acted on */
    ari?: InputMaybe<Scalars["String"]["input"]>;
    /** ATI with type of resource or group of resources, when a specific resource cannot be referenced directly. */
    ati?: InputMaybe<Scalars["String"]["input"]>;
    /** ARI of where it happened. An ARI pointing to an org, site, or other type of container. */
    containerAri: Scalars["String"]["input"];
};

/** Common interface for all subscriptions. */
export type ShepherdSubscription = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdBy: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdOn: Scalars["DateTime"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status: ShepherdSubscriptionStatus;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updatedBy?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updatedOn?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ShepherdSubscriptionConnection = {
    __typename?: "ShepherdSubscriptionConnection";
    /** A list of subscription edges */
    edges?: Maybe<Array<Maybe<ShepherdSubscriptionEdge>>>;
};

export type ShepherdSubscriptionCreateInput = {
    slack?: InputMaybe<ShepherdCreateSlackInput>;
    webhook?: InputMaybe<ShepherdCreateWebhookInput>;
};

export type ShepherdSubscriptionDeleteInput = {
    hardDelete?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/**
 * Use a type instead of an interface.
 *
 * "Edge type must be an Object type."
 * See: https://github.com/B2o5T/graphql-eslint/blob/master/docs/rules/relay-edge-types.md
 */
export type ShepherdSubscriptionEdge = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<ShepherdSubscription>;
};

export type ShepherdSubscriptionMutationPayload = Payload & {
    __typename?: "ShepherdSubscriptionMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdSubscription>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdSubscriptionMutations = {
    __typename?: "ShepherdSubscriptionMutations";
    /**
     * THIS QUERY IS IN BETA
     *
     * Creates a Beacon subscription.
     * "workspaceId" can be either a workspaceId or a BeaconWorkspaceAri
     */
    create?: Maybe<ShepherdSubscriptionMutationPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * Deletes a Beacon subscription.
     */
    delete?: Maybe<ShepherdSubscriptionMutationPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * Triggers a test alert for a given Beacon subscription.
     */
    test?: Maybe<ShepherdSubscriptionMutationPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * Updates an existing Beacon subscription.
     */
    update?: Maybe<ShepherdSubscriptionMutationPayload>;
};

export type ShepherdSubscriptionMutationsCreateArgs = {
    input: ShepherdSubscriptionCreateInput;
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdSubscriptionMutationsDeleteArgs = {
    id: Scalars["ID"]["input"];
    input?: InputMaybe<ShepherdSubscriptionDeleteInput>;
};

export type ShepherdSubscriptionMutationsTestArgs = {
    id: Scalars["ID"]["input"];
};

export type ShepherdSubscriptionMutationsUpdateArgs = {
    id: Scalars["ID"]["input"];
    input: ShepherdSubscriptionUpdateInput;
};

/** Represents Subscriptions in the Shepherd system. */
export enum ShepherdSubscriptionStatus {
    Active = "ACTIVE",
    Error = "ERROR",
    Inactive = "INACTIVE"
}

export type ShepherdSubscriptionUpdateInput = {
    slack?: InputMaybe<ShepherdUpdateSlackInput>;
    webhook?: InputMaybe<ShepherdUpdateWebhookInput>;
};

export type ShepherdSubscriptionsResult =
    | QueryError
    | ShepherdSubscriptionConnection;

export type ShepherdSuspiciousSearchTerm = {
    __typename?: "ShepherdSuspiciousSearchTerm";
    category: Scalars["String"]["output"];
    endPosition: Scalars["Int"]["output"];
    startPosition: Scalars["Int"]["output"];
};

/** Represents a point in time or an interval (when `end` is present) */
export type ShepherdTime = {
    __typename?: "ShepherdTime";
    end?: Maybe<Scalars["DateTime"]["output"]>;
    start: Scalars["DateTime"]["output"];
};

/** Time or interval */
export type ShepherdTimeInput = {
    /** When present, indicates a ShepherdInterval should be created, otherwise ShepherdInstant will be created. */
    end?: InputMaybe<Scalars["DateTime"]["input"]>;
    /** The DateTime for the ShepherdInstant (when only `start` is specified) or ShepherdInterval (when `end` is also specified) */
    start: Scalars["DateTime"]["input"];
};

export type ShepherdUnlinkAlertResourcesInput = {
    unlinkResources?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type ShepherdUpdateAlertInput = {
    assignee?: InputMaybe<Scalars["ID"]["input"]>;
    linkedResources?: InputMaybe<Array<ShepherdLinkedResourceInput>>;
    status?: InputMaybe<ShepherdAlertStatus>;
};

export type ShepherdUpdateAlertPayload = Payload & {
    __typename?: "ShepherdUpdateAlertPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdAlert>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdUpdateAlertsPayload = Payload & {
    __typename?: "ShepherdUpdateAlertsPayload";
    errors?: Maybe<Array<MutationError>>;
    nodes?: Maybe<Array<Maybe<ShepherdAlert>>>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdUpdateSlackInput = {
    status: ShepherdSubscriptionStatus;
};

export type ShepherdUpdateSubscriptionPayload = Payload & {
    __typename?: "ShepherdUpdateSubscriptionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<ShepherdSubscription>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type ShepherdUpdateWebhookInput = {
    authHeader?: InputMaybe<Scalars["String"]["input"]>;
    callbackURL?: InputMaybe<Scalars["URL"]["input"]>;
    destinationType?: InputMaybe<ShepherdWebhookDestinationType>;
    status?: InputMaybe<ShepherdSubscriptionStatus>;
    /** DEPRECATED: Use destinationType instead. */
    type?: InputMaybe<ShepherdWebhookType>;
};

/** Represents a user in the Shepherd system. */
export type ShepherdUser = {
    __typename?: "ShepherdUser";
    aaid: Scalars["ID"]["output"];
    /**
     * Timestamp of when the user's account was created
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use createdOn from ShepherdActor instead.
     */
    createdOn?: Maybe<Scalars["DateTime"]["output"]>;
    user?: Maybe<User>;
};

/** Represents the possible vortexMode values for a workspace. */
export enum ShepherdVortexModeStatus {
    Disabled = "DISABLED",
    Enabled = "ENABLED"
}

/** Represents type of Webhook payload */
export enum ShepherdWebhookDestinationType {
    Default = "DEFAULT",
    MicrosoftTeams = "MICROSOFT_TEAMS"
}

export type ShepherdWebhookEdge = ShepherdSubscriptionEdge & {
    __typename?: "ShepherdWebhookEdge";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /**
     * The item at the end of the edge
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ✅ Yes |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<ShepherdWebhookSubscription>;
};

/** Represents a webhook subscription in the Shepherd system. */
export type ShepherdWebhookSubscription = Node &
    ShepherdSubscription & {
        __typename?: "ShepherdWebhookSubscription";
        /**
         * This will have a partial authHeader value, so we don't leak information.
         * Do not use this value for anything other than display.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        authHeaderTruncated?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        callbackURL: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        createdBy: Scalars["String"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        createdOn: Scalars["DateTime"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        destinationType: ShepherdWebhookDestinationType;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["ID"]["output"];
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        status: ShepherdSubscriptionStatus;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         * @deprecated Use destinationType instead.
         */
        type?: Maybe<ShepherdWebhookType>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        updatedBy?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ✅ Yes |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        updatedOn?: Maybe<Scalars["DateTime"]["output"]>;
    };

/**
 * Represents type of Webhook
 * DEPRECATED: Use destinationType instead.
 */
export enum ShepherdWebhookType {
    Custom = "CUSTOM",
    MicrosoftTeams = "MICROSOFT_TEAMS",
    Slack = "SLACK"
}

/** Represents a workspace in the Shepherd system. */
export type ShepherdWorkspace = {
    __typename?: "ShepherdWorkspace";
    /** The list of Bitbucket workspaces that are linked in AdminHub and are monitored by Beacon */
    bitbucketWorkspaces?: Maybe<Array<ShepherdBitbucketWorkspace>>;
    cloudId: Scalars["ID"]["output"];
    cloudName?: Maybe<Scalars["String"]["output"]>;
    createdOn: Scalars["DateTime"]["output"];
    /** Current user is the atlassian user that is currently logged in and using Beacon. */
    currentUser?: Maybe<ShepherdCurrentUser>;
    /**
     * The list of custom detections that have been created for this workspace.
     * if `customDetectionId` is passed, only the custom detection with that id will be returned. If that id doesn't exist
     * an empty array will be returned.
     */
    customDetections: Array<ShepherdCustomDetection>;
    /**
     * The list of detections that are enabled on this workspace.
     * `detectionId` will be passed when we want to get the settings for a single detection,
     * for ex, shep-streams will pass an id to fetch one detection for signal filtering
     */
    detections: Array<ShepherdDetection>;
    /** Boolean whether the workspace has data center alerts */
    hasDataCenterAlert?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    orgId: Scalars["ID"]["output"];
    shouldOnboard?: Maybe<Scalars["Boolean"]["output"]>;
    /** The list of sites that the Beacon workspace monitors */
    sites?: Maybe<Array<Maybe<ShepherdSite>>>;
    /**
     * Boolean whether the org has undergone vortex or not.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "ShepherdVortexMode")' query directive to the 'vortexMode' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    vortexMode?: Maybe<ShepherdVortexModeStatus>;
};

/** Represents a workspace in the Shepherd system. */
export type ShepherdWorkspaceCustomDetectionsArgs = {
    customDetectionId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Represents a workspace in the Shepherd system. */
export type ShepherdWorkspaceDetectionsArgs = {
    detectionId?: InputMaybe<Scalars["ID"]["input"]>;
    settingId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ShepherdWorkspaceConnection = {
    __typename?: "ShepherdWorkspaceConnection";
    /** A list of workspace edges */
    edges?: Maybe<Array<Maybe<ShepherdWorkspaceEdge>>>;
};

export type ShepherdWorkspaceCreateCustomDetectionInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    products: Array<ShepherdAtlassianProduct>;
    rules: Array<ShepherdCustomScanningRuleInput>;
    title: Scalars["String"]["input"];
};

export type ShepherdWorkspaceEdge = {
    __typename?: "ShepherdWorkspaceEdge";
    node?: Maybe<ShepherdWorkspace>;
};

export type ShepherdWorkspaceMutationPayload = Payload & {
    __typename?: "ShepherdWorkspaceMutationPayload";
    errors?: Maybe<Array<MutationError>>;
    node?: Maybe<ShepherdWorkspace>;
    success: Scalars["Boolean"]["output"];
};

export type ShepherdWorkspaceMutations = {
    __typename?: "ShepherdWorkspaceMutations";
    /**
     * THIS QUERY IS IN BETA
     *
     * Create a new custom detection type for this workspace.
     */
    createCustomDetection?: Maybe<ShepherdCustomDetectionMutationPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * Delete an existing custom detection type for this workspace. This is a hard delete and cannot be undone.
     */
    deleteCustomDetection?: Maybe<ShepherdCustomDetectionMutationPayload>;
    detectionSetting?: Maybe<ShepherdDetectionSettingMutations>;
    /**
     * THIS QUERY IS IN BETA
     * "id" can be either a workspaceId or a BeaconWorkspaceAri
     */
    onboard?: Maybe<ShepherdWorkspaceMutationPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * "id" can be either a workspaceId or a BeaconWorkspaceAri
     */
    update?: Maybe<ShepherdWorkspaceMutationPayload>;
    /**
     * THIS QUERY IS IN BETA
     *
     * Update an existing custom detection type for this workspace.
     */
    updateCustomDetection?: Maybe<ShepherdCustomDetectionMutationPayload>;
    updateDetectionSetting?: Maybe<ShepherdWorkspaceMutationPayload>;
};

export type ShepherdWorkspaceMutationsCreateCustomDetectionArgs = {
    input: ShepherdWorkspaceCreateCustomDetectionInput;
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdWorkspaceMutationsDeleteCustomDetectionArgs = {
    customDetectionId: Scalars["ID"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdWorkspaceMutationsOnboardArgs = {
    id: Scalars["ID"]["input"];
};

export type ShepherdWorkspaceMutationsUpdateArgs = {
    id: Scalars["ID"]["input"];
    input: ShepherdWorkspaceUpdateInput;
};

export type ShepherdWorkspaceMutationsUpdateCustomDetectionArgs = {
    input: ShepherdWorkspaceUpdateCustomDetectionInput;
    workspaceId: Scalars["ID"]["input"];
};

export type ShepherdWorkspaceMutationsUpdateDetectionSettingArgs = {
    id: Scalars["ID"]["input"];
    input: ShepherdWorkspaceSettingUpdateInput;
};

export type ShepherdWorkspaceResult = QueryError | ShepherdWorkspaceConnection;

export type ShepherdWorkspaceSettingUpdateInput = {
    detectionId: Scalars["ID"]["input"];
    settingId: Scalars["ID"]["input"];
    value: ShepherdWorkspaceSettingValueInput;
};

/**
 * Contains the setting value for a detection
 * While we currently only have one detection type (threshold), if we add more in the future there would be more fields
 * on this type, only one of which should be populated at a time.
 */
export type ShepherdWorkspaceSettingValueInput = {
    confluenceEnabledValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    jiraEnabledValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    thresholdValue?: InputMaybe<ShepherdRateThresholdValue>;
};

/**
 * Input used to update a custom detection. Any optional field that is left empty (i.e. null or undefined) will leave the
 * previous value unchanged.
 */
export type ShepherdWorkspaceUpdateCustomDetectionInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    products?: InputMaybe<Array<ShepherdAtlassianProduct>>;
    rules?: InputMaybe<Array<ShepherdCustomScanningRuleInput>>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type ShepherdWorkspaceUpdateInput = {
    shouldOnboard: Scalars["Boolean"]["input"];
};

export type SignUpProperties = {
    __typename?: "SignUpProperties";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    reverseTrial?: Maybe<ReverseTrialCohort>;
};

/**
 * orchestrationId is unique for every user and is created after provisioning has been successfuly sent to CCP and COFs
 * if provisionComplete is true, that means provisioning was a success. Otherwise, it was not successfuly provisioned.
 */
export type SignupProvisioningStatus = {
    __typename?: "SignupProvisioningStatus";
    cloudId?: Maybe<Scalars["String"]["output"]>;
    orchestrationId: Scalars["String"]["output"];
    provisionComplete: Scalars["Boolean"]["output"];
};

/**
 * This is the mandatory query needed by nestjs and graphql.
 * The backend app will not boot otherwise.
 */
export type SignupQueryApi = {
    __typename?: "SignupQueryApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    getSample: SignupProvisioningStatus;
};

/**
 * This is the subscription that connects users to signup confirmation page.
 * When the product is provisioned, an event containing SignupProvisioningStatus is published to frontend client.
 */
export type SignupSubscriptionApi = {
    __typename?: "SignupSubscriptionApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    signupProvisioningStatus?: Maybe<SignupProvisioningStatus>;
};

/**
 * This is the subscription that connects users to signup confirmation page.
 * When the product is provisioned, an event containing SignupProvisioningStatus is published to frontend client.
 */
export type SignupSubscriptionApiSignupProvisioningStatusArgs = {
    orchestrationId: Scalars["String"]["input"];
};

export type SiteConfiguration = {
    __typename?: "SiteConfiguration";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use tenantContext.licenseStates.confluence.ccpEntitlementId
     */
    ccpEntitlementId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.companyHubName
     */
    companyHubName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    customSiteLogo: Scalars["Boolean"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.frontCover.frontCoverState
     */
    frontCoverState: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    newCustomer: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    productAdmins: PaginatedPersonList;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.frontCover.showFrontCover
     */
    showFrontCover: Scalars["Boolean"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.showApplicationTitle
     */
    showSiteTitle: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteFaviconUrl: Scalars["String"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteDescription.logoUrl
     */
    siteLogoUrl: Scalars["String"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.siteTitle
     */
    siteTitle: Scalars["String"]["output"];
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use tenant.cloudId
     */
    tenantId?: Maybe<Scalars["ID"]["output"]>;
};

export type SiteConfigurationProductAdminsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    excludeAddOns?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SiteDescription = {
    __typename?: "SiteDescription";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    logoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type SiteLookAndFeel = {
    __typename?: "SiteLookAndFeel";
    backgroundColor?: Maybe<Scalars["String"]["output"]>;
    faviconFiles: Array<FaviconFile>;
    frontCoverState?: Maybe<Scalars["String"]["output"]>;
    highlightColor?: Maybe<Scalars["String"]["output"]>;
    showFrontCover?: Maybe<Scalars["Boolean"]["output"]>;
    showSiteName?: Maybe<Scalars["Boolean"]["output"]>;
    siteLogoFileStoreId?: Maybe<Scalars["ID"]["output"]>;
    siteName?: Maybe<Scalars["String"]["output"]>;
};

export type SiteOperations = {
    __typename?: "SiteOperations";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    allOperations: Array<Maybe<OperationCheckResult>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    application: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userProfile: Array<Maybe<Scalars["String"]["output"]>>;
};

export type SitePermission = {
    __typename?: "SitePermission";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    anonymous?: Maybe<Anonymous>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    anonymousAccessDSPBlocked: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groups?: Maybe<PaginatedGroupWithPermissions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    personConnection?: Maybe<ConfluencePersonWithPermissionsConnection>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unlicensedUserWithPermissions?: Maybe<UnlicensedUserWithPermissions>;
};

export type SitePermissionGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SitePermissionPersonConnectionArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SitePermissionInput = {
    permissionsToAdd?: InputMaybe<UpdateSitePermissionInput>;
    permissionsToRemove?: InputMaybe<UpdateSitePermissionInput>;
};

export enum SitePermissionOperationType {
    AdministerConfluence = "ADMINISTER_CONFLUENCE",
    AdministerSystem = "ADMINISTER_SYSTEM",
    CreateProfileattachment = "CREATE_PROFILEATTACHMENT",
    CreateSpace = "CREATE_SPACE",
    ExternalCollaborator = "EXTERNAL_COLLABORATOR",
    LimitedUseConfluence = "LIMITED_USE_CONFLUENCE",
    ReadUserprofile = "READ_USERPROFILE",
    UpdateUserstatus = "UPDATE_USERSTATUS",
    UseConfluence = "USE_CONFLUENCE",
    UsePersonalspace = "USE_PERSONALSPACE"
}

export enum SitePermissionType {
    Anonymous = "ANONYMOUS",
    App = "APP",
    External = "EXTERNAL",
    Internal = "INTERNAL",
    Jsd = "JSD"
}

export enum SitePermissionTypeFilter {
    All = "ALL",
    Externalcollaborator = "EXTERNALCOLLABORATOR",
    None = "NONE"
}

export type SiteSettings = {
    __typename?: "SiteSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    companyHubName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    frontCover?: Maybe<FrontCover>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homepage?: Maybe<Homepage>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isNav4OptedIn: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showApplicationTitle: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteTitle: Scalars["String"]["output"];
};

export type SmartConnectorsFeature = {
    __typename?: "SmartConnectorsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type SmartFeaturesCommentsSummary = {
    __typename?: "SmartFeaturesCommentsSummary";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["ID"]["output"];
};

export type SmartFeaturesContentSummary = {
    __typename?: "SmartFeaturesContentSummary";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contentId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    language: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    lastUpdatedTimeSeconds: Scalars["Long"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summary: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    summaryId: Scalars["String"]["output"];
};

export type SmartFeaturesError = {
    __typename?: "SmartFeaturesError";
    errorCode: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    message: Scalars["String"]["output"];
};

export type SmartFeaturesErrorResponse = {
    __typename?: "SmartFeaturesErrorResponse";
    entityType: Scalars["String"]["output"];
    error?: Maybe<Array<Maybe<SmartFeaturesError>>>;
};

export type SmartFeaturesInput = {
    entityIds: Array<Scalars["String"]["input"]>;
    entityType: Scalars["String"]["input"];
    features?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SmartFeaturesPageResult = {
    __typename?: "SmartFeaturesPageResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    features: SmartPageFeatures;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["String"]["output"];
};

export type SmartFeaturesPageResultResponse = SmartFeaturesResultResponse & {
    __typename?: "SmartFeaturesPageResultResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityType: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    result?: Maybe<Array<Maybe<SmartFeaturesPageResult>>>;
};

export type SmartFeaturesResponse = {
    __typename?: "SmartFeaturesResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<Maybe<SmartFeaturesErrorResponse>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    results?: Maybe<Array<Maybe<SmartFeaturesResultResponse>>>;
};

export type SmartFeaturesResultResponse = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityType: Scalars["String"]["output"];
};

export type SmartFeaturesSpaceResult = {
    __typename?: "SmartFeaturesSpaceResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    features: SmartSpaceFeatures;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["String"]["output"];
};

export type SmartFeaturesSpaceResultResponse = SmartFeaturesResultResponse & {
    __typename?: "SmartFeaturesSpaceResultResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityType: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    result?: Maybe<Array<Maybe<SmartFeaturesSpaceResult>>>;
};

export type SmartFeaturesUserResult = {
    __typename?: "SmartFeaturesUserResult";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    features: SmartUserFeatures;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["String"]["output"];
};

export type SmartFeaturesUserResultResponse = SmartFeaturesResultResponse & {
    __typename?: "SmartFeaturesUserResultResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    entityType: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    result?: Maybe<Array<Maybe<SmartFeaturesUserResult>>>;
};

/** Represents a smart-link on a page */
export type SmartLink = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type SmartLinkEdge = {
    __typename?: "SmartLinkEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<SmartLink>;
};

export type SmartPageFeatures = {
    __typename?: "SmartPageFeatures";
    commentsDaily?: Maybe<Scalars["Float"]["output"]>;
    commentsMonthly?: Maybe<Scalars["Float"]["output"]>;
    commentsWeekly?: Maybe<Scalars["Float"]["output"]>;
    commentsYearly?: Maybe<Scalars["Float"]["output"]>;
    likesDaily?: Maybe<Scalars["Float"]["output"]>;
    likesMonthly?: Maybe<Scalars["Float"]["output"]>;
    likesWeekly?: Maybe<Scalars["Float"]["output"]>;
    likesYearly?: Maybe<Scalars["Float"]["output"]>;
    readTime?: Maybe<Scalars["Int"]["output"]>;
    viewsDaily?: Maybe<Scalars["Float"]["output"]>;
    viewsMonthly?: Maybe<Scalars["Float"]["output"]>;
    viewsWeekly?: Maybe<Scalars["Float"]["output"]>;
    viewsYearly?: Maybe<Scalars["Float"]["output"]>;
};

export type SmartSectionsFeature = {
    __typename?: "SmartSectionsFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type SmartSpaceFeatures = {
    __typename?: "SmartSpaceFeatures";
    top_templates?: Maybe<Array<Maybe<TopTemplateItem>>>;
};

export type SmartUserFeatures = {
    __typename?: "SmartUserFeatures";
    recommendedPeople?: Maybe<Array<Maybe<RecommendedPeopleItem>>>;
    recommendedSpaces?: Maybe<Array<Maybe<RecommendedSpaceItem>>>;
};

/**
 * Provides context about who and where the recommendation or request is being made. The context determines:
 *   1. The search space (e.g. the set of users that are eligible to be recommended).
 *   2. The model that will be applied to the search results.
 *   3. The input feature values that are piped into the prediction model to generate the ranking score. The model used
 *      determines which context fields are used for prediction (see
 *      [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model)).
 */
export type SmartsContext = {
    /** Any additional context to be passed to the model. */
    additionalContextList?: InputMaybe<Array<SmartsKeyValue>>;
    /**
     * The ID of the container for which the recommendation is being made.
     *
     * A container is analogous to entities such as a Jira Project or Confluence Space. Depending on the model, it is either
     * optional or can be used as an input to provide more specific recommendations.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    containerId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The ID of the object for which the recommendation is being made.
     *
     * An object is analogous to entities such as a Jira Issue or Confluence Page.
     */
    objectId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The product for which the recommendation is being made.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    product?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The ID of the tenant for which the recommendation is being made. Analogous to siteId/cloudId optional context fields.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    tenantId: Scalars["String"]["input"];
    /**
     * The ID (AAID) of the user for whom the recommendation is being made. Can be set to 'context', upon which it will use
     * the requesting user's ID.
     */
    userId: Scalars["String"]["input"];
};

export type SmartsFieldContext = {
    /**
     * List of field keys and values to be passed for prediction.
     * e.g. [{"key": "15615", "value": "xpsearch-aggregator"}]
     */
    additionalContextList?: InputMaybe<Array<SmartsKeyValue>>;
    /**
     * The ID of the container for which the recommendation is being made.
     *
     * A container is analogous to entities such as a Jira Project. Depending on the model, it is either
     * optional or can be used as an input to provide more specific recommendations.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    containerId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * This is the identifier for the field that recommendations are to be provided for.
     * Valid values are: labels, components, versions and fixVersions
     */
    fieldId: Scalars["String"]["input"];
    /**
     * The ID of the object for which the recommendation is being made.
     *
     * An object is analogous to entities such as a Jira Issue.
     */
    objectId?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The product for which the recommendation is being made.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    product?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * The ID of the tenant for which the recommendation is being made. Analogous to siteId/cloudId optional context fields.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    tenantId: Scalars["String"]["input"];
    /**
     * The UserId (AAID) for which the recommendation is being made. Can be set to 'context'
     * if calling from Stargate, upon which it will use the requesting user's ID. Can be set to an empty
     * string '' for anonymous use cases.
     */
    userId: Scalars["String"]["input"];
};

export type SmartsKeyValue = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

/** Provides information about the requester, for model selection and monitoring. */
export type SmartsModelRequestParams = {
    /**
     * This is some identifying information about the caller. It can be the microservice ID, AK package, etc.
     *
     * We use this internally for metrics and analytics. Please use a descriptive caller so we can easily locate your
     * consumer.
     */
    caller: Scalars["String"]["input"];
    /**
     * The experience being used; used for selecting a model.
     *
     * See [Choosing a model](https://developer.atlassian.com/platform/collaboration-graph/guides/choosing-a-model) for a
     * guide on choosing an experience and configuring the context.
     */
    experience: Scalars["String"]["input"];
};

export type SmartsQueryApi = {
    __typename?: "SmartsQueryApi";
    /**
     * Returns a list of recommended containers for a given context
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recommendedContainer?: Maybe<Array<Maybe<SmartsRecommendedContainer>>>;
    /**
     * Returns a list of recommended field objects for a given context
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recommendedField?: Maybe<Array<Maybe<SmartsRecommendedFieldObject>>>;
    /**
     * Returns a list of recommended objects for a given context
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recommendedObject?: Maybe<Array<Maybe<SmartsRecommendedObject>>>;
    /**
     * Returns a list of recommended users for a given context
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    recommendedUser?: Maybe<Array<Maybe<SmartsRecommendedUser>>>;
};

export type SmartsQueryApiRecommendedContainerArgs = {
    recommendationsQuery: SmartsRecommendationsQuery;
};

export type SmartsQueryApiRecommendedFieldArgs = {
    recommendationsQuery: SmartsRecommendationsFieldQuery;
};

export type SmartsQueryApiRecommendedObjectArgs = {
    recommendationsQuery: SmartsRecommendationsQuery;
};

export type SmartsQueryApiRecommendedUserArgs = {
    recommendationsQuery: SmartsRecommendationsQuery;
};

export type SmartsRecommendationsFieldQuery = {
    /**
     * Provides context about who and where the recommendation or collaboration graph request is
     * being made. The context determines: 1. The search space (e.g. the set of users that are eligible
     * to be recommended; 2. The model that will be applied to the search results. 3. the input feature values that are
     * piped into the prediction model to generate the ranking score. The model used determines which context fields
     * are used for prediction (see DAC: Choosing a model).
     */
    context: SmartsFieldContext;
    /**
     * The maximum number of nearby entities that should be returned.
     *
     * Defaults to 100. If provided, must be in the range [1,500].
     */
    maxNumberOfResults?: InputMaybe<Scalars["Int"]["input"]>;
    /**
     * Provides information about the requester, for model selection and monitoring.
     * Valid values for the experience field are: JiraFields, JiraLabels and JiraComponents
     */
    modelRequestParams: SmartsModelRequestParams;
    /**
     * The ID (AtlassianID) of the user who is making the request. Used to perform permission checks and hydration.
     *
     * If the `requestingUserId` is set to the string 'context', Collaboration Graph will use the `requestingUserId` from
     * headers.
     */
    requestingUserId: Scalars["String"]["input"];
    /** The unique identifier for the session. */
    sessionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SmartsRecommendationsQuery = {
    /**
     * Provides context about who and where the recommendation or collaboration graph request is
     * being made. The context determines: 1. The search space (e.g. the set of users that are eligible
     * to be recommended; 2. The model that will be applied to the search results. 3. the input feature values that are
     * piped into the prediction model to generate the ranking score. The model used determines which context fields
     * are used for prediction (see DAC: Choosing a model).
     */
    context: SmartsContext;
    /**
     * The maximum number of nearby entities that should be returned.
     *
     * Defaults to 100. If provided, must be in the range [1,500].
     */
    maxNumberOfResults?: InputMaybe<Scalars["Int"]["input"]>;
    /** Provides information about the requester, for model selection and monitoring. */
    modelRequestParams: SmartsModelRequestParams;
    /**
     * The ID (AtlassianID) of the user who is making the request. Used to perform permission checks and hydration.
     *
     * If the `requestingUserId` is set to the string 'context', Collaboration Graph will use the `requestingUserId` from
     * headers.
     */
    requestingUserId: Scalars["String"]["input"];
    /** The unique identifier for the session. */
    sessionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SmartsRecommendedContainer = {
    __typename?: "SmartsRecommendedContainer";
    /** Hydrated information on the container */
    container?: Maybe<ConfluenceSpace>;
    /** The ID of the recommended container. */
    id: Scalars["ID"]["output"];
    /** A double value representing the score of the ML model. */
    score?: Maybe<Scalars["Float"]["output"]>;
};

export type SmartsRecommendedFieldObject = {
    __typename?: "SmartsRecommendedFieldObject";
    /** The ID of the recommended field. */
    id: Scalars["ID"]["output"];
    /** A double value representing the score of the ML model. */
    score?: Maybe<Scalars["Float"]["output"]>;
    /** This is the value object for the field object instance (e.g. the label UCC, or a component object) */
    value?: Maybe<Scalars["String"]["output"]>;
};

/**
 * union SmartsRecommendedContainerData = ConfluenceSpace
 *     | JiraProject
 */
export type SmartsRecommendedObject = {
    __typename?: "SmartsRecommendedObject";
    /** The ID of the recommended object. */
    id: Scalars["ID"]["output"];
    /** Hydrated information on the object */
    object?: Maybe<SmartsRecommendedObjectData>;
    /** A double value representing the score of the ML model. */
    score?: Maybe<Scalars["Float"]["output"]>;
};

export type SmartsRecommendedObjectData = ConfluenceBlogPost | ConfluencePage;

/** | JiraIssue */
export type SmartsRecommendedUser = {
    __typename?: "SmartsRecommendedUser";
    /** The ID of the recommended user. */
    id: Scalars["ID"]["output"];
    /** A double value representing the score of the ML model. */
    score?: Maybe<Scalars["Float"]["output"]>;
    /** Hydrated information on the user */
    user?: Maybe<User>;
};

export type Snippet = {
    __typename?: "Snippet";
    body?: Maybe<Scalars["String"]["output"]>;
    creator?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    position?: Maybe<Scalars["Float"]["output"]>;
    scope?: Maybe<Scalars["String"]["output"]>;
    spaceKey?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type SnippetEdge = {
    __typename?: "SnippetEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Snippet>;
};

export type SocialSignalSearch = {
    __typename?: "SocialSignalSearch";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    objectARI: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    signal?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    timestamp?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    user?: Maybe<User>;
};

export type SocialSignalsApi = {
    __typename?: "SocialSignalsAPI";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    socialSignalsSearch?: Maybe<Array<SocialSignalSearch>>;
};

export type SocialSignalsApiSocialSignalsSearchArgs = {
    objectARIs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    tenantId: Scalars["ID"]["input"];
};

export type SoftDeleteSpacePayload = Payload & {
    __typename?: "SoftDeleteSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SoftwareBoard = {
    __typename?: "SoftwareBoard";
    /** List of the assignees of all cards currently displayed on the board */
    assignees?: Maybe<Array<Maybe<User>>>;
    /**
     * Current board swimlane strategy
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'boardSwimlaneStrategy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    boardSwimlaneStrategy?: Maybe<BoardSwimlaneStrategy>;
    /** All issue children which are linked to the cards on the board */
    cardChildren?: Maybe<Array<Maybe<SoftwareCard>>>;
    /** Configuration for showing media previews on cards */
    cardMedia?: Maybe<CardMediaConfig>;
    /** [CardType]s which can be created in this column _outside of a swimlane_ (if any) */
    cardTypes: Array<Maybe<CardType>>;
    /** All cards on the board, optionally filtered by ID */
    cards?: Maybe<Array<Maybe<SoftwareCard>>>;
    /**
     *  Column status mapping
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: columnConfigs` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     */
    columnConfigs?: Maybe<ColumnsConfig>;
    /** The list of columns on the board */
    columns?: Maybe<Array<Maybe<Column>>>;
    /**
     *  Swimlane configuration data
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'customSwimlaneConfig' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    customSwimlaneConfig?: Maybe<JswCustomSwimlaneConnection>;
    /** Board edit config. Contains properties which dictate how to mutate the board data, e.g support for inline issue or column creation */
    editConfig?: Maybe<BoardEditConfig>;
    /**
     * All cards on the board, optionally filtered by custom filter IDs or Jql string, returning all possible cards in the board that match the filters
     * The returned list will contain all card IDs that match the filters, including those not currently displayed on the board (e.g. subtasks shown/hidden based on swimlane strategy)
     */
    filteredCardIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** Whether any cards on the board are hidden due to board clearing logic (e.g. old cards in the done column are hidden) */
    hasClearedCards?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Configuration for showing inline card create */
    inlineCardCreate?: Maybe<InlineCardCreateConfig>;
    /** List of all labels on all cards current displayed on the board */
    labels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Name of the board */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Temporarily needed to support legacy write API */
    rankCustomFieldId?: Maybe<Scalars["String"]["output"]>;
    /** Whether or not to show the number of days an issue has been in a particular column on the board. */
    showDaysInColumn?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *  Epic panel configuration for CMP boards
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'showEpicAsPanel' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    showEpicAsPanel?: Maybe<Scalars["Boolean"]["output"]>;
    /** The user's swimlane strategy for the board */
    swimlaneStrategy?: Maybe<SwimlaneStrategy>;
    /**
     * Swimlanes on the board.  If swimlanes are set to "NONE" then this there will be a single swimlane object containing
     * all cards on the board.
     */
    swimlanes: Array<Maybe<Swimlane>>;
    /**
     *  List of Jira statuses that are not mapped to any column
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'unmappedStatuses' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    unmappedStatuses?: Maybe<Array<Maybe<CardStatus>>>;
    /**
     * User Swimlanes on the board.  If swimlanes are set to "NONE" then this there will be a single swimlane object containing
     * all cards on the board.
     */
    userSwimlanes: Array<Maybe<Swimlane>>;
};

export type SoftwareBoardCardsArgs = {
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SoftwareBoardCustomSwimlaneConfigArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card on the board */
export type SoftwareCard = {
    __typename?: "SoftwareCard";
    activeSprint?: Maybe<Sprint>;
    assignee?: Maybe<User>;
    /**
     *  the user is allowed to split the issue
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "canSplitIssue")' query directive to the 'canSplitIssue' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    canSplitIssue: Scalars["Boolean"]["output"];
    /** Child cards metadata */
    childCardsMetadata?: Maybe<ChildCardsMetadata>;
    /** List of children IDs for a card */
    childrenIds?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** Details of the media to show on this card, null if the card has no media */
    coverMedia?: Maybe<CardCoverMedia>;
    /** Dev Status information for the card */
    devStatus?: Maybe<DevStatus>;
    /** Whether or not this card is considered done */
    done?: Maybe<Scalars["Boolean"]["output"]>;
    /** Due date */
    dueDate?: Maybe<Scalars["String"]["output"]>;
    /** Estimate of size of a card */
    estimate?: Maybe<Estimate>;
    /** IDs of the fix versions that this issue is related to */
    fixVersionsIds: Array<Scalars["ID"]["output"]>;
    /** Whether or not this card is flagged */
    flagged?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    labels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** ID of parent card */
    parentId?: Maybe<Scalars["ID"]["output"]>;
    /** Card priority */
    priority?: Maybe<CardPriority>;
    status?: Maybe<CardStatus>;
    summary?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<CardType>;
};

export type SoftwareCardChildrenInfo = {
    __typename?: "SoftwareCardChildrenInfo";
    doneStats?: Maybe<SoftwareCardChildrenInfoStats>;
    inProgressStats?: Maybe<SoftwareCardChildrenInfoStats>;
    lastColumnIssueStats?: Maybe<SoftwareCardChildrenInfoStats>;
    todoStats?: Maybe<SoftwareCardChildrenInfoStats>;
};

export type SoftwareCardChildrenInfoStats = {
    __typename?: "SoftwareCardChildrenInfoStats";
    cardCount?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a specific transition between statuses that a card can make. */
export type SoftwareCardTransition = {
    __typename?: "SoftwareCardTransition";
    /** Card type that this transition applies to */
    cardType: CardType;
    /** true if the transition has conditions */
    hasConditions?: Maybe<Scalars["Boolean"]["output"]>;
    /** Identifier for the card's column in swimlane position, to be used as a target for card transitions */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** true if global transition (anything status can move to this location). */
    isGlobal?: Maybe<Scalars["Boolean"]["output"]>;
    /** true if the transition is initial */
    isInitial?: Maybe<Scalars["Boolean"]["output"]>;
    /** Name of the transition, as set in the workflow editor */
    name: Scalars["String"]["output"];
    /** statuses which can move to this location, null if global transition. */
    originStatus?: Maybe<CardStatus>;
    /** The status the card's issue will end up in after executing this CardTransition */
    status?: Maybe<CardStatus>;
};

export type SoftwareCardTypeTransition = {
    __typename?: "SoftwareCardTypeTransition";
    /** Card type that this transition applies to */
    cardType: CardType;
    /** true if the transition has conditions */
    hasConditions?: Maybe<Scalars["Boolean"]["output"]>;
    /** true if global transition (anything status can move to this location). */
    isGlobal?: Maybe<Scalars["Boolean"]["output"]>;
    /** true if the transition is initial */
    isInitial?: Maybe<Scalars["Boolean"]["output"]>;
    /** Name of the transition, as set in the workflow editor */
    name: Scalars["String"]["output"];
    /** statuses which can move to this location, null if global transition. */
    originStatus?: Maybe<CardStatus>;
    /** The status the card's issue will end up in after executing this SoftwareCardTypeTransition */
    status?: Maybe<CardStatus>;
    /** Non unique ID of the transition used as a target for card transitions */
    transitionId?: Maybe<Scalars["ID"]["output"]>;
};

export type SoftwareCardsDestination = {
    destination?: InputMaybe<SoftwareCardsDestinationEnum>;
    sprintId?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum SoftwareCardsDestinationEnum {
    Backlog = "BACKLOG",
    ExistingSprint = "EXISTING_SPRINT",
    NewSprint = "NEW_SPRINT"
}

export type SoftwareOperation = {
    __typename?: "SoftwareOperation";
    icon?: Maybe<Icon>;
    name?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
    tooltip?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

export type SoftwareProject = {
    __typename?: "SoftwareProject";
    /**
     * List of card types available in the project
     * When on the board, these will NOT include Epics or Subtasks, but when in boardScope they will
     */
    cardTypes?: Maybe<Array<Maybe<CardType>>>;
    /** Project id */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** Project key */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Project name */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type SoftwareProjectCardTypesArgs = {
    hierarchyLevelType?: InputMaybe<CardHierarchyLevelEnumType>;
};

export type SoftwareReport = {
    __typename?: "SoftwareReport";
    /** Which group this report should be shown in */
    group: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    /** uri of the report's icon */
    imageUri: Scalars["String"]["output"];
    /** if not applicable - localised text as to why */
    inapplicableDescription?: Maybe<Scalars["String"]["output"]>;
    /** if not applicable - localised text as to why */
    inapplicableReason?: Maybe<Scalars["String"]["output"]>;
    /** whether or not this report is applicable (is enabled for) this board */
    isApplicable: Scalars["Boolean"]["output"];
    /** unique key identifying the report */
    key: Scalars["String"]["output"];
    /** the name of the report in the user's language */
    localisedDescription: Scalars["String"]["output"];
    /** the name of the report in the user's language */
    localisedName: Scalars["String"]["output"];
    /**
     * suffix to apply to the reports url to load this report.
     * e.g. https://tenant.com/secure/RapidBoard.jspa?rapidView=*boardId*&view=reports&report=*urlName*
     */
    urlName: Scalars["String"]["output"];
};

/** Node for querying any report page's data */
export type SoftwareReports = {
    __typename?: "SoftwareReports";
    /** Data for the burndown chart report */
    burndownChart: BurndownChart;
    /** Data for the cumulative flow diagram report */
    cumulativeFlowDiagram?: Maybe<CumulativeFlowDiagram>;
    /** Data for the reports list overview */
    overview?: Maybe<ReportsOverview>;
};

export type SoftwareSprintMetadata = {
    __typename?: "SoftwareSprintMetadata";
    /** Number of Completed Issues in Sprint */
    numCompletedIssues?: Maybe<Scalars["Int"]["output"]>;
    /** Number of Open Issues in Sprint */
    numOpenIssues?: Maybe<Scalars["Int"]["output"]>;
    /** Keys of Unresolved Cards */
    top100CompletedCardKeysWithIncompleteChildren?: Maybe<
        Array<Maybe<Scalars["String"]["output"]>>
    >;
    /** Number of Unestimated Issues */
    unestimatedIssueCount?: Maybe<Scalars["Int"]["output"]>;
    /** Keys of Unestimated Issues */
    unestimatedIssueKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

/** The sort direction of the collection */
export enum SortDirection {
    /** Sort in ascending order */
    Asc = "ASC",
    /** Sort in descending order */
    Desc = "DESC"
}

export enum SortOrder {
    Asc = "ASC",
    Desc = "DESC"
}

export type SpaUnfriendlyMacro = {
    __typename?: "SpaUnfriendlyMacro";
    links?: Maybe<LinksContextBase>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type SpaViewModel = {
    __typename?: "SpaViewModel";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use abTestCohorts top level query
     */
    abTestCohorts?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use experimentFeatures top level query
     */
    experimentFeatures?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.homepage.title
     */
    homepageTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use siteSettings.homepage.uri
     */
    homepageUri?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use currentConfluenceUser.isAnonymous
     */
    isAnonymous?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use userPreferences.onboarded
     */
    isNewUser?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use isSiteAdmin top level query
     */
    isSiteAdmin?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceContexts?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    resourceKeys?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showEditButton?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.showSiteTitle
     */
    showSiteTitle?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    showWelcomeMessageEditHint?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.siteLogoUrl
     */
    siteLogoUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.siteTitle
     */
    siteTitle?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use SiteConfiguration.tenantId
     */
    tenantId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated Use userCanCreateContent top level query
     */
    userCanCreateContent?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    welcomeMessageEditUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    welcomeMessageHtml?: Maybe<Scalars["String"]["output"]>;
};

export type Space = {
    __typename?: "Space";
    admins: Array<Maybe<Person>>;
    alias?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use contentRoots
     */
    archivedContentRoots: PaginatedContentList;
    containsExternalCollaborators: Scalars["Boolean"]["output"];
    contentRoots: PaginatedContentList;
    creatorAccountId?: Maybe<Scalars["String"]["output"]>;
    currentUser: SpaceUserMetadata;
    dataClassificationTags: Array<Maybe<Scalars["String"]["output"]>>;
    /** GraphQL query to get default classification level ID for content in a space. */
    defaultClassificationLevelId?: Maybe<Scalars["ID"]["output"]>;
    description?: Maybe<SpaceDescriptions>;
    /** Whether the space has ever contained user content. NOTE: Returns true for ALL spaces created before approximately 2024-08-19, regardless of contents. (Exact date depends on when this PR is deployed) */
    didContainUserContent: Scalars["Boolean"]["output"];
    directAccessExternalCollaborators?: Maybe<PaginatedPersonList>;
    externalCollaboratorAndGroupCount: Scalars["Int"]["output"];
    externalCollaboratorCount: Scalars["Int"]["output"];
    externalGroupsWithAccess?: Maybe<PaginatedGroupList>;
    /** GraphQL query to check whether space has default classification level set. */
    hasDefaultClassificationLevel: Scalars["Boolean"]["output"];
    hasGroupRestriction: Scalars["Boolean"]["output"];
    hasRestriction: Scalars["Boolean"]["output"];
    history?: Maybe<SpaceHistory>;
    homepage?: Maybe<Content>;
    homepageId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'homepageV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    homepageV2?: Maybe<Content>;
    icon?: Maybe<Icon>;
    id?: Maybe<Scalars["ID"]["output"]>;
    identifiers?: Maybe<GlobalSpaceIdentifier>;
    isBlogToggledOffByPTL: Scalars["Boolean"]["output"];
    /** GraphQL query to determine whether export is enabled for space. */
    isExportEnabled: Scalars["Boolean"]["output"];
    key?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
    lookAndFeel?: Maybe<LookAndFeel>;
    metadata: SpaceMetadata;
    name?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    permissions?: Maybe<Array<Maybe<SpacePermission>>>;
    settings?: Maybe<SpaceSettings>;
    spaceAdmins: PaginatedPersonList;
    spaceOwner?: Maybe<ConfluenceSpaceDetailsSpaceOwner>;
    spaceTypeSettings: SpaceTypeSettings;
    status?: Maybe<Scalars["String"]["output"]>;
    theme?: Maybe<Theme>;
    /** Get total count of blogposts without override classifications */
    totalBlogpostsWithoutClassificationLevelOverride: Scalars["Long"]["output"];
    /** Get total count of content items without classification level overrides */
    totalContentWithoutClassificationLevelOverride: Scalars["Int"]["output"];
    /** Get total count of pages without override classifications */
    totalPagesWithoutClassificationLevelOverride: Scalars["Long"]["output"];
    type?: Maybe<Scalars["String"]["output"]>;
};

export type SpaceAdminsArgs = {
    accountType?: InputMaybe<AccountType>;
};

export type SpaceArchivedContentRootsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpaceContentRootsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    orderBy?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["String"]["input"]>;
};

export type SpaceDirectAccessExternalCollaboratorsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SpaceExternalGroupsWithAccessArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SpaceHasGroupRestrictionArgs = {
    groupID: Scalars["String"]["input"];
    permission: InspectPermissions;
};

export type SpaceHasRestrictionArgs = {
    accountID: Scalars["String"]["input"];
    permission: InspectPermissions;
};

export type SpaceSpaceAdminsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    excludeAddOns?: InputMaybe<Scalars["Boolean"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum SpaceAssignmentType {
    Assigned = "ASSIGNED",
    Unassigned = "UNASSIGNED"
}

export type SpaceDescriptions = {
    __typename?: "SpaceDescriptions";
    atlas_doc_format?: Maybe<FormattedBody>;
    dynamic?: Maybe<FormattedBody>;
    editor?: Maybe<FormattedBody>;
    editor2?: Maybe<FormattedBody>;
    export_view?: Maybe<FormattedBody>;
    plain?: Maybe<FormattedBody>;
    raw?: Maybe<FormattedBody>;
    storage?: Maybe<FormattedBody>;
    styled_view?: Maybe<FormattedBody>;
    view?: Maybe<FormattedBody>;
    wiki?: Maybe<FormattedBody>;
};

export type SpaceEdge = {
    __typename?: "SpaceEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<Space>;
};

export type SpaceHistory = {
    __typename?: "SpaceHistory";
    createdBy?: Maybe<Person>;
    createdDate?: Maybe<Scalars["String"]["output"]>;
    lastModifiedBy?: Maybe<Person>;
    lastModifiedDate?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
};

export type SpaceInfo = {
    __typename?: "SpaceInfo";
    id: Scalars["ID"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    spaceAdminAccess: Scalars["Boolean"]["output"];
};

export type SpaceInfoConnection = {
    __typename?: "SpaceInfoConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SpaceInfoEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<SpaceInfo>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SpaceInfoPageInfo;
};

export type SpaceInfoEdge = {
    __typename?: "SpaceInfoEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: SpaceInfo;
};

export type SpaceInfoPageInfo = {
    __typename?: "SpaceInfoPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type SpaceInput = {
    key: Scalars["ID"]["input"];
};

export enum SpaceManagerFilterType {
    Personal = "PERSONAL",
    TeamAndProject = "TEAM_AND_PROJECT"
}

export type SpaceManagerFilters = {
    /** Allows to find spaces based on the search query. */
    searchQuery?: InputMaybe<Scalars["String"]["input"]>;
    /** Allows to filter spaces by their status. */
    status?: InputMaybe<ConfluenceSpaceStatus>;
    /** Allows to filter spaces by their type. */
    types?: InputMaybe<Array<InputMaybe<SpaceManagerFilterType>>>;
};

export enum SpaceManagerOrderColumn {
    Key = "KEY",
    Title = "TITLE"
}

export enum SpaceManagerOrderDirection {
    Asc = "ASC",
    Desc = "DESC"
}

export type SpaceManagerOrdering = {
    /** Allows to order spaces by their column name. */
    column?: InputMaybe<SpaceManagerOrderColumn>;
    /** Specifies ordering direction. */
    direction?: InputMaybe<SpaceManagerOrderDirection>;
};

export type SpaceManagerOwner = {
    __typename?: "SpaceManagerOwner";
    /** Contains the name that is displayed to the user. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** Specifies the space owner ID. */
    ownerId?: Maybe<Scalars["ID"]["output"]>;
    /** Specifies the space owner type. */
    ownerType?: Maybe<SpaceManagerOwnerType>;
    /** The path for the profile picture. */
    profilePicturePath?: Maybe<Scalars["String"]["output"]>;
};

export enum SpaceManagerOwnerType {
    Group = "GROUP",
    User = "USER"
}

export type SpaceManagerQueryInput = {
    /** Contains inclusive cursor value after which items should be retrieved */
    after?: InputMaybe<Scalars["String"]["input"]>;
    /** Space manager filters */
    filters?: InputMaybe<SpaceManagerFilters>;
    /** Specifies max amount of items to return */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** Space manager order info */
    orderInfo?: InputMaybe<SpaceManagerOrdering>;
};

export type SpaceManagerRecord = {
    __typename?: "SpaceManagerRecord";
    /** Space alias */
    alias?: Maybe<Scalars["String"]["output"]>;
    /** Specifies if the user can manage the current space */
    canManage?: Maybe<Scalars["Boolean"]["output"]>;
    /** Specifies if the user can view the current space */
    canView?: Maybe<Scalars["Boolean"]["output"]>;
    /** Creator user info */
    createdBy?: Maybe<GraphQlUserInfo>;
    /** Space icon */
    icon?: Maybe<ConfluenceSpaceIcon>;
    /** Space key */
    key?: Maybe<Scalars["String"]["output"]>;
    /** Last modified space date */
    lastModifiedAt?: Maybe<Scalars["String"]["output"]>;
    /** Last modified user info */
    lastModifiedBy?: Maybe<GraphQlUserInfo>;
    /** Last viewed space date */
    lastViewedAt?: Maybe<Scalars["String"]["output"]>;
    /** Contains the owner info of the space */
    owner?: Maybe<SpaceManagerOwner>;
    /** Space ID */
    spaceId: Scalars["ID"]["output"];
    /** Space type */
    spaceType?: Maybe<Scalars["String"]["output"]>;
    /** Space title */
    title?: Maybe<Scalars["String"]["output"]>;
};

export type SpaceManagerRecordConnection = {
    __typename?: "SpaceManagerRecordConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges: Array<Maybe<SpaceManagerRecordEdge>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<SpaceManagerRecord>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SpaceManagerRecordPageInfo;
};

export type SpaceManagerRecordEdge = {
    __typename?: "SpaceManagerRecordEdge";
    cursor: Scalars["String"]["output"];
    node: SpaceManagerRecord;
};

export type SpaceManagerRecordPageInfo = {
    __typename?: "SpaceManagerRecordPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type SpaceMetadata = {
    __typename?: "SpaceMetadata";
    labels?: Maybe<PaginatedLabelList>;
    recentCommenterConnection?: Maybe<ConfluencePersonConnection>;
    recentWatcherConnection?: Maybe<ConfluencePersonConnection>;
    totalCommenters: Scalars["Long"]["output"];
    totalCurrentBlogPosts: Scalars["Long"]["output"];
    totalCurrentPages: Scalars["Long"]["output"];
    totalPageUpdatesSinceLast7Days: Scalars["Long"]["output"];
    totalWatchers: Scalars["Long"]["output"];
};

export type SpaceOrContent = {
    __typename?: "SpaceOrContent";
    alias?: Maybe<Scalars["String"]["output"]>;
    ancestors?: Maybe<Array<Maybe<Content>>>;
    body?: Maybe<ContentBodyPerRepresentation>;
    childTypes?: Maybe<ChildContentTypesAvailable>;
    container?: Maybe<SpaceOrContent>;
    creatorAccountId?: Maybe<Scalars["String"]["output"]>;
    dataClassificationTags: Array<Maybe<Scalars["String"]["output"]>>;
    description?: Maybe<SpaceDescriptions>;
    extensions?: Maybe<Array<Maybe<KeyValueHierarchyMap>>>;
    history?: Maybe<History>;
    homepage?: Maybe<Content>;
    homepageId?: Maybe<Scalars["ID"]["output"]>;
    icon?: Maybe<Icon>;
    id?: Maybe<Scalars["ID"]["output"]>;
    identifiers?: Maybe<GlobalSpaceIdentifier>;
    key?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
    lookAndFeel?: Maybe<LookAndFeel>;
    macroRenderedOutput?: Maybe<Array<Maybe<MapOfStringToFormattedBody>>>;
    metadata: ContentMetadata;
    name?: Maybe<Scalars["String"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    permissions?: Maybe<Array<Maybe<SpacePermission>>>;
    referenceId?: Maybe<Scalars["String"]["output"]>;
    restrictions?: Maybe<ContentRestrictions>;
    schedulePublishDate?: Maybe<Scalars["String"]["output"]>;
    schedulePublishInfo?: Maybe<SchedulePublishInfo>;
    settings?: Maybe<SpaceSettings>;
    space?: Maybe<Space>;
    status?: Maybe<Scalars["String"]["output"]>;
    subType?: Maybe<Scalars["String"]["output"]>;
    theme?: Maybe<Theme>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    version?: Maybe<Version>;
};

export type SpacePagesDisplayView = {
    spaceKey: Scalars["String"]["input"];
    spacePagesPersistenceOption: PagesDisplayPersistenceOption;
};

export type SpacePagesSortView = {
    spaceKey: Scalars["String"]["input"];
    spacePagesSortPersistenceOption: PagesSortPersistenceOptionInput;
};

export type SpacePermission = {
    __typename?: "SpacePermission";
    anonymousAccess?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    links?: Maybe<LinksContextBase>;
    operation?: Maybe<OperationCheckResult>;
    subjects?: Maybe<SubjectsByType>;
    unlicensedAccess?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SpacePermissionConnection = {
    __typename?: "SpacePermissionConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SpacePermissionEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<SpacePermissionInfo>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SpacePermissionPageInfo;
};

export type SpacePermissionEdge = {
    __typename?: "SpacePermissionEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: SpacePermissionInfo;
};

export type SpacePermissionGroup = {
    __typename?: "SpacePermissionGroup";
    displayName: Scalars["String"]["output"];
    priority: Scalars["Int"]["output"];
};

export type SpacePermissionInfo = {
    __typename?: "SpacePermissionInfo";
    description?: Maybe<Scalars["String"]["output"]>;
    displayName: Scalars["String"]["output"];
    group: SpacePermissionGroup;
    id: Scalars["String"]["output"];
    priority: Scalars["Int"]["output"];
    requiredSpacePermissions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type SpacePermissionPageInfo = {
    __typename?: "SpacePermissionPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type SpacePermissionSubject = {
    __typename?: "SpacePermissionSubject";
    filteredPrincipalSubjectKey?: Maybe<FilteredPrincipalSubjectKey>;
    permissions?: Maybe<Array<Maybe<SpacePermissionType>>>;
    subjectKey?: Maybe<SubjectKey>;
};

export type SpacePermissionSubjectEdge = {
    __typename?: "SpacePermissionSubjectEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<SpacePermissionSubject>;
};

export enum SpacePermissionType {
    AdministerSpace = "ADMINISTER_SPACE",
    ArchivePage = "ARCHIVE_PAGE",
    ArchiveSpace = "ARCHIVE_SPACE",
    Comment = "COMMENT",
    CreateAttachment = "CREATE_ATTACHMENT",
    CreateBlog = "CREATE_BLOG",
    CreateEditPage = "CREATE_EDIT_PAGE",
    DeleteSpace = "DELETE_SPACE",
    EditBlog = "EDIT_BLOG",
    EditNativeContent = "EDIT_NATIVE_CONTENT",
    ExportContent = "EXPORT_CONTENT",
    ExportPage = "EXPORT_PAGE",
    ExportSpace = "EXPORT_SPACE",
    ManageGuestUsers = "MANAGE_GUEST_USERS",
    ManageNonlicensedUsers = "MANAGE_NONLICENSED_USERS",
    ManagePublicLinks = "MANAGE_PUBLIC_LINKS",
    ManageUsers = "MANAGE_USERS",
    RemoveAttachment = "REMOVE_ATTACHMENT",
    RemoveBlog = "REMOVE_BLOG",
    RemoveComment = "REMOVE_COMMENT",
    RemoveMail = "REMOVE_MAIL",
    RemoveOwnContent = "REMOVE_OWN_CONTENT",
    RemovePage = "REMOVE_PAGE",
    SetPagePermissions = "SET_PAGE_PERMISSIONS",
    ViewSpace = "VIEW_SPACE"
}

export type SpacePermissions = {
    __typename?: "SpacePermissions";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    anonymousAccessDSPBlocked: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editable: Scalars["Boolean"]["output"];
    /**
     * GraphQL query to get a paged list of subjects which have space permissions on given space, excluding single space guest groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    filteredSubjectsWithPermissions: PaginatedSpacePermissionSubjectList;
    /**
     * GraphQL query to get a paged list of groups with default space permissions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    groupsWithDefaultSpacePermissions: PaginatedSpacePermissionSubjectList;
    /**
     * GraphQL query to get a paged list of subjects with default space permissions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithDefaultSpacePermissions: PaginatedSpacePermissionSubjectList;
    /**
     * GraphQL query to get a paged list of subjects which have space permissions on given space, excluding single space guest groups
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    subjectsWithPermissions: PaginatedSpacePermissionSubjectList;
};

export type SpacePermissionsFilteredSubjectsWithPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    permissionDisplayType?: InputMaybe<PermissionDisplayType>;
};

export type SpacePermissionsGroupsWithDefaultSpacePermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SpacePermissionsSubjectsWithDefaultSpacePermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SpacePermissionsSubjectsWithPermissionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filterText?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SpaceRole = {
    __typename?: "SpaceRole";
    roleDescription: Scalars["String"]["output"];
    roleDisplayName: Scalars["String"]["output"];
    roleId: Scalars["ID"]["output"];
    roleType: SpaceRoleType;
    spacePermissionList: Array<SpacePermissionInfo>;
};

export type SpaceRoleAccessClassPrincipal = SpaceRolePrincipal & {
    __typename?: "SpaceRoleAccessClassPrincipal";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId: Scalars["ID"]["output"];
};

export type SpaceRoleAssignment = {
    __typename?: "SpaceRoleAssignment";
    permissions?: Maybe<Array<SpacePermissionInfo>>;
    principal: SpaceRolePrincipal;
    role?: Maybe<SpaceRole>;
    spaceId: Scalars["Long"]["output"];
};

export type SpaceRoleAssignmentConnection = {
    __typename?: "SpaceRoleAssignmentConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SpaceRoleAssignmentEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<SpaceRoleAssignment>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SpacePermissionPageInfo;
};

export type SpaceRoleAssignmentEdge = {
    __typename?: "SpaceRoleAssignmentEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: SpaceRoleAssignment;
};

export type SpaceRoleConnection = {
    __typename?: "SpaceRoleConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    edges?: Maybe<Array<Maybe<SpaceRoleEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<Maybe<SpaceRole>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageInfo: SpaceRolePageInfo;
};

export type SpaceRoleEdge = {
    __typename?: "SpaceRoleEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node: SpaceRole;
};

export type SpaceRoleGroupPrincipal = SpaceRolePrincipal & {
    __typename?: "SpaceRoleGroupPrincipal";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId: Scalars["ID"]["output"];
};

export type SpaceRoleGuestPrincipal = SpaceRolePrincipal & {
    __typename?: "SpaceRoleGuestPrincipal";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profilePicture?: Maybe<Icon>;
};

export type SpaceRolePageInfo = {
    __typename?: "SpaceRolePageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type SpaceRolePrincipal = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId: Scalars["ID"]["output"];
};

export enum SpaceRoleType {
    Custom = "CUSTOM",
    System = "SYSTEM"
}

export type SpaceRoleUserPrincipal = SpaceRolePrincipal & {
    __typename?: "SpaceRoleUserPrincipal";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    principalId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profilePicture?: Maybe<Icon>;
};

export type SpaceSettings = {
    __typename?: "SpaceSettings";
    contentStateSettings: ContentStateSettings;
    customHeaderAndFooter: SpaceSettingsMetadata;
    editor?: Maybe<EditorVersionsMetadataDto>;
    links?: Maybe<LinksContextSelfBase>;
    routeOverrideEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SpaceSettingsMetadata = {
    __typename?: "SpaceSettingsMetadata";
    footer: HtmlMeta;
    header: HtmlMeta;
};

export type SpaceSidebarLink = {
    __typename?: "SpaceSidebarLink";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    canHide?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    hidden: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<Icon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    iconClass?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    linkIdentifier?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    position: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    styleClass?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    title?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    tooltip?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type: SpaceSidebarLinkType;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    urlWithoutContextPath?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webItemCompleteKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    webItemKey?: Maybe<Scalars["String"]["output"]>;
};

export enum SpaceSidebarLinkType {
    ExternalLink = "EXTERNAL_LINK",
    Forge = "FORGE",
    PinnedAttachment = "PINNED_ATTACHMENT",
    PinnedBlogPost = "PINNED_BLOG_POST",
    PinnedPage = "PINNED_PAGE",
    PinnedSpace = "PINNED_SPACE",
    PinnedUserInfo = "PINNED_USER_INFO",
    WebItem = "WEB_ITEM"
}

export type SpaceSidebarLinks = {
    __typename?: "SpaceSidebarLinks";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    advanced?: Maybe<Array<Maybe<SpaceSidebarLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    main?: Maybe<Array<Maybe<SpaceSidebarLink>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    quick?: Maybe<Array<Maybe<SpaceSidebarLink>>>;
};

export type SpaceSidebarLinksMainArgs = {
    includeHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SpaceTypeSettings = {
    __typename?: "SpaceTypeSettings";
    enabledContentTypes: EnabledContentTypes;
    enabledFeatures: EnabledFeatures;
};

export type SpaceTypeSettingsInput = {
    enabledContentTypes?: InputMaybe<EnabledContentTypesInput>;
    enabledFeatures?: InputMaybe<EnabledFeaturesInput>;
};

export type SpaceUserMetadata = {
    __typename?: "SpaceUserMetadata";
    isAdmin: Scalars["Boolean"]["output"];
    isAnonymouslyAuthorized: Scalars["Boolean"]["output"];
    isFavourited: Scalars["Boolean"]["output"];
    isWatched: Scalars["Boolean"]["output"];
    isWatchingBlogs: Scalars["Boolean"]["output"];
};

export type SpaceViewsPersistence = {
    persistenceOption: SpaceViewsPersistenceOption;
    spaceKey: Scalars["String"]["input"];
};

export enum SpaceViewsPersistenceOption {
    Popularity = "POPULARITY",
    RecentlyModified = "RECENTLY_MODIFIED",
    RecentlyViewed = "RECENTLY_VIEWED",
    TitleAz = "TITLE_AZ",
    Tree = "TREE"
}

export type SpaceWithExemption = {
    __typename?: "SpaceWithExemption";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    alias?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    icon?: Maybe<Icon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["Long"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    key?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

export type SplitIssueInput = {
    newIssues: Array<InputMaybe<NewSplitIssueRequest>>;
    originalIssue: OriginalSplitIssue;
};

export type SplitIssueOutput = MutationResponse & {
    __typename?: "SplitIssueOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    newIssues?: Maybe<Array<Maybe<NewSplitIssueResponse>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type Sprint = BaseSprint & {
    __typename?: "Sprint";
    /** All issue children which are linked to the cards on the sprint */
    cardChildren: Array<SoftwareCard>;
    cards: Array<Maybe<SoftwareCard>>;
    /** The number of days remaining */
    daysRemaining?: Maybe<Scalars["Int"]["output"]>;
    /** The end date of the sprint, in ISO 8601 format */
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The sprint's goal, null if no goal is set */
    goal?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The sprint's name */
    name?: Maybe<Scalars["String"]["output"]>;
    sprintMetadata?: Maybe<SoftwareSprintMetadata>;
    sprintState: SprintState;
    /** The start date of the sprint, in ISO 8601 format */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SprintCardsArgs = {
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    customFilterIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SprintEndData = {
    __typename?: "SprintEndData";
    /** list of all issues that are in the sprint with their estimates */
    issueList: Array<Maybe<ScopeSprintIssue>>;
    /** scope remaining at the end of the sprint */
    remainingEstimate: Scalars["Float"]["output"];
    /** timestamp of when sprint was completed */
    timestamp: Scalars["DateTime"]["output"];
};

export enum SprintReportsEstimationStatisticType {
    IssueCount = "ISSUE_COUNT",
    OriginalEstimate = "ORIGINAL_ESTIMATE",
    StoryPoints = "STORY_POINTS"
}

export type SprintReportsFilters = {
    __typename?: "SprintReportsFilters";
    /** Possible statistic that we want to track */
    estimationStatistic: Array<Maybe<SprintReportsEstimationStatisticType>>;
    /** List of sprints to select from */
    sprints: Array<Maybe<Sprint>>;
};

export type SprintResponse = MutationResponse & {
    __typename?: "SprintResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    sprint?: Maybe<Sprint>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type SprintScopeChangeData = {
    __typename?: "SprintScopeChangeData";
    /** amount completed of the esimtation statistic */
    completion: Scalars["Float"]["output"];
    /** estimation of the issue after this change */
    estimate?: Maybe<Scalars["Float"]["output"]>;
    /** type of event */
    eventType: Scalars["SprintScopeChangeEventType"]["output"];
    /** the issue involved in the change */
    issueKey: Scalars["String"]["output"];
    /** the issue description */
    issueSummary: Scalars["String"]["output"];
    /** the previous completed amount before this change */
    prevCompletion: Scalars["Float"]["output"];
    /** the previous estimation before this change */
    prevEstimate?: Maybe<Scalars["Float"]["output"]>;
    /** the previous remaining amount before this change */
    prevRemaining: Scalars["Float"]["output"];
    /** the sprint scope before the change */
    prevScope: Scalars["Float"]["output"];
    /** amount remaining of the estimation statistic */
    remaining: Scalars["Float"]["output"];
    /** sprint scope after this change */
    scope: Scalars["Float"]["output"];
    /** timestamp of change */
    timestamp: Scalars["DateTime"]["output"];
};

export type SprintStartData = {
    __typename?: "SprintStartData";
    /** list of all issues that are in the sprint with their estimates */
    issueList: Array<Maybe<ScopeSprintIssue>>;
    /** scope estimate for start of sprint */
    scopeEstimate: Scalars["Float"]["output"];
    timestamp: Scalars["DateTime"]["output"];
};

export enum SprintState {
    Active = "ACTIVE",
    Closed = "CLOSED",
    Future = "FUTURE"
}

export type SprintWithStatistics = BaseSprint & {
    __typename?: "SprintWithStatistics";
    /** The default end date of the sprint when the sprint is started, in ISO 8601 format */
    defaultEndDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The default start date of the sprint when the sprint is started, in ISO 8601 format */
    defaultStartDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** The actual end date of the sprint after the sprint has started, in ISO 8601 format */
    endDate?: Maybe<Scalars["DateTime"]["output"]>;
    goal?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    incompleteCardsDestinations?: Maybe<
        Array<Maybe<InCompleteCardsDestination>>
    >;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "CSSReductionIncompleteSprints")' query directive to the 'lastColumnName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    lastColumnName?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    sprintMetadata?: Maybe<SoftwareSprintMetadata>;
    sprintState: SprintState;
    /** The actual start date of the sprint after the sprint has started, in ISO 8601 format */
    startDate?: Maybe<Scalars["DateTime"]["output"]>;
};

export type StalePagePayload = {
    __typename?: "StalePagePayload";
    lastActivityDate: Scalars["String"]["output"];
    lastViewedDate?: Maybe<Scalars["String"]["output"]>;
    pageId: Scalars["String"]["output"];
    pageStatus: StalePageStatus;
    spaceId: Scalars["String"]["output"];
};

export type StalePagePayloadEdge = {
    __typename?: "StalePagePayloadEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<StalePagePayload>;
};

export enum StalePageStatus {
    Archived = "ARCHIVED",
    Current = "CURRENT",
    Draft = "DRAFT"
}

export enum StalePagesSortingType {
    Asc = "ASC",
    Desc = "DESC"
}

/** Start sprint */
export type StartSprintInput = {
    boardId: Scalars["ID"]["input"];
    endDate: Scalars["String"]["input"];
    goal?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    sprintId: Scalars["ID"]["input"];
    startDate: Scalars["String"]["input"];
};

/** Status data for CMP board settings */
export type StatusV2 = {
    __typename?: "StatusV2";
    category?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    isPresentInWorkflow?: Maybe<Scalars["Boolean"]["output"]>;
    isResolutionDone?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "modularBoardSettings")' query directive to the 'issueMetaData' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMetaData?: Maybe<JswCardStatusIssueMetaData>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type Step = {
    from?: InputMaybe<Scalars["Long"]["input"]>;
    mark: Mark;
    pos?: InputMaybe<Scalars["Long"]["input"]>;
    to?: InputMaybe<Scalars["Long"]["input"]>;
};

export type Storage = {
    __typename?: "Storage";
    hosted?: Maybe<HostedStorage>;
    remotes?: Maybe<Array<Remote>>;
};

export type StringUserInput = {
    type: StringUserInputType;
    value?: InputMaybe<Scalars["String"]["input"]>;
    variableName: Scalars["String"]["input"];
};

export enum StringUserInputType {
    Dropdown = "DROPDOWN",
    Paragraph = "PARAGRAPH",
    Text = "TEXT"
}

export type SubjectKey = {
    __typename?: "SubjectKey";
    /** If subject type is not USER, then this query will return null */
    confluencePerson?: Maybe<ConfluencePerson>;
    /** Principal type */
    confluencePrincipalType: ConfluencePrincipalType;
    /** User display name for a user, or group name for a group */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** If subject type is not GROUP, then this query will return null */
    group?: Maybe<Group>;
    /** User account id for a user, or group external id for a group */
    id?: Maybe<Scalars["String"]["output"]>;
};

export type SubjectPermissionDeltas = {
    permissionsToAdd: Array<InputMaybe<SpacePermissionType>>;
    permissionsToRemove: Array<InputMaybe<SpacePermissionType>>;
    subjectKeyInput: UpdatePermissionSubjectKeyInput;
};

export type SubjectRestrictionHierarchySummary = {
    __typename?: "SubjectRestrictionHierarchySummary";
    restrictedResources?: Maybe<Array<Maybe<RestrictedResource>>>;
    subject?: Maybe<BlockedAccessSubject>;
};

export type SubjectUserOrGroup = {
    __typename?: "SubjectUserOrGroup";
    displayName?: Maybe<Scalars["String"]["output"]>;
    group?: Maybe<GroupWithRestrictions>;
    id?: Maybe<Scalars["String"]["output"]>;
    permissions: Array<Maybe<ContentPermissionType>>;
    type?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<UserWithRestrictions>;
};

export type SubjectUserOrGroupEdge = {
    __typename?: "SubjectUserOrGroupEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<SubjectUserOrGroup>;
};

export type SubjectsByType = {
    __typename?: "SubjectsByType";
    group?: Maybe<PaginatedGroupList>;
    groupWithRestrictions?: Maybe<PaginatedGroupWithRestrictions>;
    links?: Maybe<LinksContextBase>;
    personConnection?: Maybe<ConfluencePersonConnection>;
    userWithRestrictions?: Maybe<PaginatedUserWithRestrictions>;
};

export type SubjectsByTypeGroupArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SubjectsByTypeGroupWithRestrictionsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SubjectsByTypePersonConnectionArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SubjectsByTypeUserWithRestrictionsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    start?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Subscription = {
    __typename?: "Subscription";
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __confluence:atlassian-external__
     *
     *
     */
    confluence_onContentUpdated?: Maybe<ConfluenceContent>;
    /**
     * name space field
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    devOps?: Maybe<AriGraphSubscriptions>;
    /**
     * Subscription to get updates to Autodev job logs.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogGroups")' query directive to the 'devai_onAutodevJobLogGroupsUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use the 'devai_onAutodevJobLogsUpdated' field instead
     */
    devai_onAutodevJobLogGroupsUpdated?: Maybe<DevAiAutodevLogGroupConnection>;
    /**
     * Subscription to get updates to Autodev job logs (full list returned).
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogs")' query directive to the 'devai_onAutodevJobLogsListUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_onAutodevJobLogsListUpdated?: Maybe<DevAiAutodevLogConnection>;
    /**
     * Subscription to get updates to Autodev job logs.
     * Note: not yet implemented, as we'd first need a field for fetching a specific job by ID
     * for use in an enrichment query. See:
     * https://hello.atlassian.net/wiki/spaces/AIDO/pages/4408833907/Logs+subscription+approach
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiLogs")' query directive to the 'devai_onAutodevJobLogsUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_onAutodevJobLogsUpdated?: Maybe<DevAiAutodevLogEdge>;
    /**
     * Subscription to get updates to Technical Planner job
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "DevAiTechnicalPlanner")' query directive to the 'devai_onTechnicalPlannerJobUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    devai_onTechnicalPlannerJobUpdated?: Maybe<DevAiTechnicalPlannerJob>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __jira:atlassian-external__
     *
     *
     */
    jira?: Maybe<JiraSubscription>;
    /**
     *
     *
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    jsmChat?: Maybe<JsmChatSubscription>;
    /** Subscriptions under namespace `migration`. */
    migration: MigrationSubscription;
    /** Subscriptions under namespace `migrationPlanningService`. */
    migrationPlanningService: MigrationPlanningServiceSubscription;
    /** Subscriptions under namespace `sandbox`. */
    sandbox: SandboxSubscription;
    signup: SignupSubscriptionApi;
    trello: TrelloSubscriptionApi;
};

export type SubscriptionConfluence_OnContentUpdatedArgs = {
    id: Scalars["ID"]["input"];
};

export type SubscriptionDevai_OnAutodevJobLogGroupsUpdatedArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type SubscriptionDevai_OnAutodevJobLogsListUpdatedArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type SubscriptionDevai_OnAutodevJobLogsUpdatedArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export type SubscriptionDevai_OnTechnicalPlannerJobUpdatedArgs = {
    cloudId: Scalars["ID"]["input"];
    jobId: Scalars["ID"]["input"];
};

export enum SummaryType {
    Blogpost = "BLOGPOST",
    Page = "PAGE"
}

export type SuperAdminPayload = {
    __typename?: "SuperAdminPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id?: Maybe<Scalars["ID"]["output"]>;
};

export type SuperBatchWebResources = {
    __typename?: "SuperBatchWebResources";
    links?: Maybe<LinksContextBase>;
    metatags?: Maybe<Scalars["String"]["output"]>;
    tags?: Maybe<WebResourceTags>;
    uris?: Maybe<WebResourceUris>;
};

export type SupportRequest = {
    __typename?: "SupportRequest";
    /** Set of activities ordered in desc order */
    activities: SupportRequestActivities;
    /** This list logged in user's capabilities */
    capabilities?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The comments that should be obtained for this request. */
    comments?: Maybe<SupportRequestComments>;
    /** The date that the request was created in the format 'yyyy-MM-dd'T'HH:mm:ss.SSSX', for example 2019-10-10T10:10:10.1000Z. */
    createdDate: SupportRequestDisplayableDateTime;
    /** The public facing fields that are relevant to this request. There may be other fields internally that are not being exposed here. */
    defaultFields: Array<SupportRequestField>;
    /** The full description for this request in wiki markup format (Jira format). */
    description: Scalars["String"]["output"];
    /** Experience fields might vary for personas. */
    experienceFields?: Maybe<Array<SupportRequestField>>;
    /** The public facing fields that are relevant to this request. There may be other fields internally that are not being exposed here */
    fields: Array<SupportRequestField>;
    /** The unique identifier for this request. It will make it unique across multiple systems, for example 'GSAC-CA-1000' for GSAC requests. */
    id: Scalars["ID"]["output"];
    /** The last comment that should be obtained for this request. */
    lastComment: SupportRequestComments;
    /** The users that are participants for this request */
    participants: Array<SupportRequestUser>;
    /** The public facing name for the project that this request is in, for example Customer Advocates. */
    projectName: Scalars["String"]["output"];
    /** This list open related Migration tickets. */
    relatedRequests?: Maybe<Array<Maybe<SupportRequest>>>;
    /** The user that reported this request. This value can be null if the reporter has been removed from the request. */
    reporter: SupportRequestUser;
    /** The public facing name for this request type, for example Support Request. */
    requestTypeName: Scalars["String"]["output"];
    /** This contains the source system id */
    sourceId?: Maybe<Scalars["String"]["output"]>;
    /** The current status of the request, for example open. */
    status: SupportRequestStatus;
    /** Gets the status transitioned on the request ID. */
    statuses: SupportRequestStatuses;
    /** The short general description of the request. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The flag to route to either CSP Read/Write view or JSM view */
    targetScreen: Scalars["String"]["output"];
    /** Gets ticket SLA by GSAC issueKey */
    ticketSla?: Maybe<SupportRequestSla>;
    /**
     * The flag to switch attachment uploading between trac and own component
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated tracAttachmentComponentsEnabled ff cleanup
     */
    tracAttachmentComponentsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Gets the possible transitions on the request ID. */
    transitions?: Maybe<SupportRequestTransitions>;
};

export type SupportRequestActivitiesArgs = {
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SupportRequestCommentsArgs = {
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SupportRequestLastCommentArgs = {
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SupportRequestStatusesArgs = {
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SupportRequestTransitionsArgs = {
    offset?: InputMaybe<Scalars["Int"]["input"]>;
    size?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SupportRequestActivities = {
    __typename?: "SupportRequestActivities";
    /** Total number of items to return, subject to server enforced limits. */
    limit: Scalars["Int"]["output"];
    /** The item used as the first item in the page of results */
    offset: Scalars["Int"]["output"];
    /** Number of items to return per page */
    total: Scalars["Int"]["output"];
    /** List of comment. */
    values?: Maybe<Array<SupportRequestActivity>>;
};

export type SupportRequestActivity = {
    __typename?: "SupportRequestActivity";
    comment?: Maybe<SupportRequestComment>;
    status?: Maybe<SupportRequestActivityStatus>;
};

export type SupportRequestActivityStatus = {
    __typename?: "SupportRequestActivityStatus";
    /** The date at which the status change was done. */
    createdDate?: Maybe<SupportRequestDisplayableDateTime>;
    /** Resolution reason in case status is of resolution kind */
    resolution?: Maybe<Scalars["String"]["output"]>;
    /** The descriptive, public-facing text shown to customers for this request */
    text: Scalars["String"]["output"];
};

export type SupportRequestAddCommentInput = {
    /** unique key/id of the request ticket */
    issueKey: Scalars["String"]["input"];
    /** The comment message in wiki markup format (Jira format). */
    message: Scalars["String"]["input"];
};

export type SupportRequestAdditionalTicketData = {
    /** operation that should be done for the new ticket example: PROBLEM_TICKET_CREATION */
    operationType?: InputMaybe<Scalars["String"]["input"]>;
    /** parent issue id or key of the ticket that should be newly created */
    parentIssueIdOrKey?: InputMaybe<Scalars["String"]["input"]>;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApi = {
    __typename?: "SupportRequestCatalogMutationApi";
    /**
     * Add customer comment on a support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    addComment?: Maybe<SupportRequestComment>;
    /**
     * Add Request participants to support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    addRequestParticipants?: Maybe<SupportRequestParticipants>;
    /**
     * Add Request participants organizations to support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    addSupportRequestOrganizations?: Maybe<Array<SupportRequestOrganization>>;
    /**
     * Create named contact operation request to add or remove named contact
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createNamedContactOperationRequest?: Maybe<SupportRequestTicket>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createTicket?: Maybe<SupportRequestCreateTicketResponse>;
    /**
     * Remove Request participants from support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    removeRequestParticipants?: Maybe<SupportRequestParticipants>;
    /**
     * Remove Request participants organizations from support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    removeSupportRequestOrganizations?: Maybe<
        Array<SupportRequestOrganization>
    >;
    /**
     * Perform status transition of support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusTransition?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * This API is a wrapper for all CSP Support Request Context mutations
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    supportRequestContext?: Maybe<SupportRequestContextMutationApi>;
    /**
     * Update migration task entity props
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateMigrationTask?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>;
    /**
     * Update support request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateSupportRequest?: Maybe<SupportRequest>;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiAddCommentArgs = {
    input?: InputMaybe<SupportRequestAddCommentInput>;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiAddRequestParticipantsArgs = {
    input: SupportRequestParticipantsInput;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiAddSupportRequestOrganizationsArgs =
    {
        input: SupportRequestOrganizationsInput;
    };

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiCreateNamedContactOperationRequestArgs =
    {
        emails: Array<Scalars["String"]["input"]>;
        operation: SupportRequestNamedContactOperation;
        organizationId?: InputMaybe<Scalars["String"]["input"]>;
        sen?: InputMaybe<Scalars["String"]["input"]>;
    };

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiCreateTicketArgs = {
    additionalData?: InputMaybe<SupportRequestAdditionalTicketData>;
    description: Scalars["String"]["input"];
    fields?: InputMaybe<Array<InputMaybe<SupportRequestTicketFields>>>;
    summary: Scalars["String"]["input"];
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiRemoveRequestParticipantsArgs = {
    input: SupportRequestParticipantsInput;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiRemoveSupportRequestOrganizationsArgs =
    {
        input: SupportRequestOrganizationsInput;
    };

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiStatusTransitionArgs = {
    input?: InputMaybe<SupportRequestTransitionInput>;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiUpdateMigrationTaskArgs = {
    input?: InputMaybe<SupportRequestMigrationTaskInput>;
};

/** The top level wrapper for the CSP Support Request Mutations API. */
export type SupportRequestCatalogMutationApiUpdateSupportRequestArgs = {
    input: SupportRequestUpdateInput;
};

/** Top level wrapper for CSP Support Request queries API */
export type SupportRequestCatalogQueryApi = {
    __typename?: "SupportRequestCatalogQueryApi";
    /**
     * Get information about the current logged in user. This can be used to get the requests for the current user.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    me?: Maybe<SupportRequestPage>;
    /**
     * Obtain an individual request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    supportRequest?: Maybe<SupportRequest>;
    /**
     * This API is a wrapper for all CSP Support Request Context queries
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    supportRequestContext?: Maybe<SupportRequestContextQueryApi>;
    /**
     * Search or get information about users.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    users?: Maybe<SupportRequestUsers>;
};

/** Top level wrapper for CSP Support Request queries API */
export type SupportRequestCatalogQueryApiSupportRequestArgs = {
    key: Scalars["ID"]["input"];
};

/** A comment for the request. These are non-hierarchical comments and are only linked to a single request. */
export type SupportRequestComment = {
    __typename?: "SupportRequestComment";
    /**
     * The user that created this comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    author: SupportRequestUser;
    /**
     * The date that this comment was originally created
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createdDate: SupportRequestDisplayableDateTime;
    /**
     * The users that mentioned in this comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    mentionedUsers: Array<SupportRequestUser>;
    /**
     * The comment message in wiki markup format (Jira format).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
};

export type SupportRequestComments = {
    __typename?: "SupportRequestComments";
    /** Indicates whether the current page returned is the last page of results. */
    lastPage: Scalars["Boolean"]["output"];
    /** Total number of items to return, subject to server enforced limits. */
    limit: Scalars["Int"]["output"];
    /** The item used as the first item in the page of results */
    offset: Scalars["Int"]["output"];
    /** Number of items to return per page */
    size: Scalars["Int"]["output"];
    /** List of comment. */
    values: Array<SupportRequestComment>;
};

export type SupportRequestContactRelation = {
    __typename?: "SupportRequestContactRelation";
    /** contact details of a user */
    contact?: Maybe<SupportRequestUser>;
    /** Open request tickets for a user */
    openRequest?: Maybe<SupportRequestTicket>;
};

export type SupportRequestContextMutationApi = {
    __typename?: "SupportRequestContextMutationApi";
    /** Add Request participants to support request */
    setNotifications: SupportRequestNotification;
};

export type SupportRequestContextMutationApiSetNotificationsArgs = {
    input: SupportRequestContextSetNotificationInput;
};

export type SupportRequestContextQueryApi = {
    __typename?: "SupportRequestContextQueryApi";
    /** Get notifications status */
    getNotificationStatus?: Maybe<SupportRequestNotification>;
};

export type SupportRequestContextQueryApiGetNotificationStatusArgs = {
    key: Scalars["ID"]["input"];
};

export type SupportRequestContextSetNotificationInput = {
    /** unique key/id of the request ticket */
    requestKey: Scalars["String"]["input"];
    status: Scalars["Boolean"]["input"];
};

export type SupportRequestCreateTicketResponse = {
    __typename?: "SupportRequestCreateTicketResponse";
    /** message in case ticket creation is unsuccessful */
    message?: Maybe<Scalars["String"]["output"]>;
    /** status of ticket creation, true if ticket is created successfully */
    success?: Maybe<Scalars["Boolean"]["output"]>;
    /** key of the newly created ticket */
    ticketKey?: Maybe<Scalars["String"]["output"]>;
};

/** A DateTime type for the request, this contains multiple formats of datetime */
export type SupportRequestDisplayableDateTime = {
    __typename?: "SupportRequestDisplayableDateTime";
    /** Offset friendly date time */
    dateTime: Scalars["String"]["output"];
    /** Epoch milliseconds */
    epochMillis: Scalars["Long"]["output"];
    /** Display friendly date time. */
    friendly: Scalars["String"]["output"];
};

export type SupportRequestField = {
    __typename?: "SupportRequestField";
    /** Specifies the datatype of field */
    dataType?: Maybe<SupportRequestFieldDataType>;
    /** Specifies whether the field is editable */
    editable?: Maybe<Scalars["Boolean"]["output"]>;
    /** Unique Id of the field, for example description, custom_field_1234 */
    id: Scalars["String"]["output"];
    /** The public facing name of the field, for example Priority, Customer Timezone */
    label: Scalars["String"]["output"];
    /** The public facing value of the field. */
    value?: Maybe<SupportRequestFieldValue>;
};

/** Enum that specify the data type of the field. */
export enum SupportRequestFieldDataType {
    Boolean = "BOOLEAN",
    Date = "DATE",
    Number = "NUMBER",
    String = "STRING"
}

/** The value of the field. This has been kept as a seperate type for extensibility, such as including icons. */
export type SupportRequestFieldValue = {
    __typename?: "SupportRequestFieldValue";
    /** The value of the field, e.g. Priority 4. */
    value?: Maybe<Scalars["String"]["output"]>;
};

export type SupportRequestHierarchyRequest = {
    __typename?: "SupportRequestHierarchyRequest";
    /** child ticket(s) to this request */
    children?: Maybe<Array<SupportRequestHierarchyRequest>>;
    /** The date that the request was created in the format 'yyyy-MM-dd'T'HH:mm:ss.SSSX', for example 2019-10-10T10:10:10.1000Z. */
    createdDate: SupportRequestDisplayableDateTime;
    /** The full description for this request in wiki markup format (Jira format). */
    description: Scalars["String"]["output"];
    /** The unique identifier for this request. It will make it unique across multiple systems, for example 'GSAC-CA-1000' for GSAC requests. */
    id: Scalars["ID"]["output"];
    /** Parent ticket to this Request */
    parent?: Maybe<SupportRequestHierarchyRequest>;
    /** The users that are participants for this request */
    participants: Array<SupportRequestUser>;
    /** The user that reported this request. This value can be null if the reporter has been removed from the request. */
    reporter: SupportRequestUser;
    /** The public facing name for this request type, for example Support Request. */
    requestTypeName: Scalars["String"]["output"];
    /** The current status of the request, for example open. */
    status: SupportRequestStatus;
    /** The short general description of the request. */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The flag whether request view should be routed to the customer support portal read/write view or gsac customer view. */
    targetScreen: Scalars["String"]["output"];
};

export type SupportRequestHierarchyRequests = {
    __typename?: "SupportRequestHierarchyRequests";
    page: Array<SupportRequestHierarchyRequest>;
    total: Scalars["Int"]["output"];
};

export type SupportRequestIdentityUser = {
    __typename?: "SupportRequestIdentityUser";
    /** User's atlassian id */
    accountId?: Maybe<Scalars["ID"]["output"]>;
    /** The public facing display name for this user. */
    name: Scalars["String"]["output"];
    /** The URL of the avatar for this user. */
    picture?: Maybe<Scalars["String"]["output"]>;
};

export type SupportRequestLastComment = {
    __typename?: "SupportRequestLastComment";
    /**
     * The item used as the first item in the page of results
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    offset: Scalars["Int"]["output"];
    /**
     * List of comment.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    values: Array<SupportRequestComment>;
};

export type SupportRequestMigrationTaskInput = {
    /** comment to be added on task. This can be null when completed is false i.e marking a task incomplete from complete */
    comment?: InputMaybe<Scalars["String"]["input"]>;
    /** task status */
    completedByPartner: Scalars["Boolean"]["input"];
    /** unique key/id of the request ticket */
    requestKey: Scalars["String"]["input"];
    /** task name to be updated */
    taskName: Scalars["String"]["input"];
};

/** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */
export enum SupportRequestNamedContactOperation {
    Add = "ADD",
    Remove = "REMOVE"
}

export type SupportRequestNamedContactRelation = {
    __typename?: "SupportRequestNamedContactRelation";
    /** List of named contacts relations for a user */
    contactRelations?: Maybe<Array<Maybe<SupportRequestContactRelation>>>;
    /** The unique id of the org in case of cloud enterprise */
    orgId?: Maybe<Scalars["String"]["output"]>;
    /** Name of the org in case of cloud enterprise */
    orgName?: Maybe<Scalars["String"]["output"]>;
    /** Support Entitlement Number. This is relevant only for premier support server business */
    sen?: Maybe<Scalars["String"]["output"]>;
};

export type SupportRequestNamedContactRelations = {
    __typename?: "SupportRequestNamedContactRelations";
    cloudEnterpriseRelations?: Maybe<
        Array<Maybe<SupportRequestNamedContactRelation>>
    >;
    premierSupportRelations?: Maybe<
        Array<Maybe<SupportRequestNamedContactRelation>>
    >;
};

export type SupportRequestNotification = {
    __typename?: "SupportRequestNotification";
    /** This flag provides current notification status */
    status?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SupportRequestOrganization = {
    __typename?: "SupportRequestOrganization";
    /** ORGANISATION id */
    id: Scalars["Int"]["output"];
    /** The source system display name of ORGANISATION */
    name: Scalars["String"]["output"];
};

export type SupportRequestOrganizationsInput = {
    /** List of request participants. */
    orgIds?: InputMaybe<Array<Scalars["Int"]["input"]>>;
    /** unique key/id of the request ticket */
    requestKey: Scalars["String"]["input"];
};

/** A user (customer or agent) of the support system. */
export type SupportRequestPage = {
    __typename?: "SupportRequestPage";
    /** Search for the migration requests that the user reported and/or participated in */
    migrationRequests?: Maybe<SupportRequestHierarchyRequests>;
    /** Search for the named contacts of the orgs/sens that user belongs to */
    namedContactRelations?: Maybe<SupportRequestNamedContactRelations>;
    profile?: Maybe<SupportRequestUser>;
    /** Search for the requests that the user reported and/or participated in */
    requests?: Maybe<SupportRequests>;
};

/** A user (customer or agent) of the support system. */
export type SupportRequestPageMigrationRequestsArgs = {
    offset?: Scalars["Int"]["input"];
    ownership?: InputMaybe<SupportRequestQueryOwnership>;
    size?: Scalars["Int"]["input"];
    status?: InputMaybe<SupportRequestQueryStatusCategory>;
};

/** A user (customer or agent) of the support system. */
export type SupportRequestPageRequestsArgs = {
    backend?: InputMaybe<Array<Scalars["String"]["input"]>>;
    offset?: Scalars["Int"]["input"];
    ownership?: InputMaybe<SupportRequestQueryOwnership>;
    project?: InputMaybe<Scalars["String"]["input"]>;
    requestType?: InputMaybe<Scalars["String"]["input"]>;
    searchTerm?: InputMaybe<Scalars["String"]["input"]>;
    size?: Scalars["Int"]["input"];
    status?: InputMaybe<SupportRequestQueryStatusCategory>;
};

export type SupportRequestParticipants = {
    __typename?: "SupportRequestParticipants";
    /** Indicates whether the current page returned is the last page of results. */
    lastPage: Scalars["Boolean"]["output"];
    /** Total number of items to return, subject to server enforced limits. */
    limit: Scalars["Int"]["output"];
    /** The item used as the first item in the page of results */
    offset: Scalars["Int"]["output"];
    /** Number of items to return per page */
    size: Scalars["Int"]["output"];
    /** List of request participants. */
    values: Array<SupportRequestUser>;
};

export type SupportRequestParticipantsInput = {
    aaids?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** list of request participants username */
    gsacUsernames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** unique key/id of the request ticket */
    requestKey: Scalars["String"]["input"];
};

/** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */
export enum SupportRequestQueryOwnership {
    Participant = "PARTICIPANT",
    Reporter = "REPORTER"
}

/** The general category for the status of the ticket. */
export enum SupportRequestQueryStatusCategory {
    Done = "DONE",
    Open = "OPEN"
}

export type SupportRequestSla = {
    __typename?: "SupportRequestSla";
    /** Indicates if the user can administer the project */
    canAdministerProject?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicates if the ticket has previous cycles */
    hasPreviousCycles?: Maybe<Scalars["Boolean"]["output"]>;
    /** The key of the project */
    projectKey?: Maybe<Scalars["String"]["output"]>;
    /** List of SLA goals associated with the ticket */
    slaGoals?: Maybe<Array<SupportRequestSlaGoal>>;
};

export type SupportRequestSlaGoal = {
    __typename?: "SupportRequestSlaGoal";
    /** Indicates if the SLA goal is active */
    active?: Maybe<Scalars["Boolean"]["output"]>;
    /** The breach time of the SLA goal */
    breachTime?: Maybe<Scalars["String"]["output"]>;
    /** The name of the calendar associated with the SLA goal */
    calendarName?: Maybe<Scalars["String"]["output"]>;
    /** Indicates if the SLA goal is closed */
    closed?: Maybe<Scalars["Boolean"]["output"]>;
    /** The duration time in long format */
    durationTimeLong?: Maybe<Scalars["String"]["output"]>;
    /** Indicates if the SLA goal has failed */
    failed?: Maybe<Scalars["Boolean"]["output"]>;
    /** The goal time for the SLA goal */
    goalTime?: Maybe<Scalars["String"]["output"]>;
    /** The goal time in a human-readable format */
    goalTimeHumanReadable?: Maybe<Scalars["String"]["output"]>;
    /** The goal time in long format */
    goalTimeLong?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the metric */
    metricId?: Maybe<Scalars["String"]["output"]>;
    /** The name of the metric */
    metricName?: Maybe<Scalars["String"]["output"]>;
    /** Indicates if the SLA goal is paused */
    paused?: Maybe<Scalars["Boolean"]["output"]>;
    /** The remaining time for the SLA goal */
    remainingTime?: Maybe<Scalars["String"]["output"]>;
    /** The remaining time in a human-readable format */
    remainingTimeHumanReadable?: Maybe<Scalars["String"]["output"]>;
    /** The remaining time in long format */
    remainingTimeLong?: Maybe<Scalars["String"]["output"]>;
    /** The start time of the SLA goal */
    startTime?: Maybe<Scalars["String"]["output"]>;
    /** The stop time of the SLA goal */
    stopTime?: Maybe<Scalars["String"]["output"]>;
};

export type SupportRequestStatus = {
    __typename?: "SupportRequestStatus";
    /** General category of request's status. */
    category: SupportRequestStatusCategory;
    /** The date at which the status change was done. */
    createdDate?: Maybe<SupportRequestDisplayableDateTime>;
    /** The descriptive, publically-facing text shown to customers for this request */
    text: Scalars["String"]["output"];
};

/** The general category for the status of the ticket. */
export enum SupportRequestStatusCategory {
    Done = "DONE",
    InProgress = "IN_PROGRESS",
    Open = "OPEN"
}

export type SupportRequestStatuses = {
    __typename?: "SupportRequestStatuses";
    /** Indicates whether the current page returned is the last page of results. */
    lastPage: Scalars["Boolean"]["output"];
    /** Total number of items to return, subject to server enforced limits. */
    limit: Scalars["Int"]["output"];
    /** The item used as the first item in the page of results */
    offset: Scalars["Int"]["output"];
    /** Number of items to return per page */
    size: Scalars["Int"]["output"];
    /** List of status transitions. */
    values: Array<SupportRequestStatus>;
};

export type SupportRequestTicket = {
    __typename?: "SupportRequestTicket";
    /** status category Key */
    categoryKey?: Maybe<Scalars["String"]["output"]>;
    /** unique key/id of the request ticket */
    issueKey?: Maybe<Scalars["String"]["output"]>;
    /** status name for a Support ticket */
    statusName?: Maybe<Scalars["String"]["output"]>;
};

export type SupportRequestTicketFields = {
    /** Specifies the datatype of field */
    dataType: SupportRequestFieldDataType;
    /** custom field id */
    fieldId: Scalars["Long"]["input"];
    /** value of the field */
    fieldValue: Scalars["String"]["input"];
};

export type SupportRequestTransition = {
    __typename?: "SupportRequestTransition";
    /** Unique transition Id of the field. */
    id: Scalars["String"]["output"];
    /** The transition name, publically-facing text shown to customers for this request */
    name: Scalars["String"]["output"];
};

export type SupportRequestTransitionInput = {
    /** The comment message in wiki markup format (Jira format). */
    comment?: InputMaybe<Scalars["String"]["input"]>;
    /** unique key/id of the request ticket */
    requestKey: Scalars["String"]["input"];
    /** transition Id of from workflow */
    transitionId: Scalars["ID"]["input"];
};

export type SupportRequestTransitions = {
    __typename?: "SupportRequestTransitions";
    /** Indicates whether the current page returned is the last page of results. */
    lastPage: Scalars["Boolean"]["output"];
    /** Total number of items to return, subject to server enforced limits. */
    limit: Scalars["Int"]["output"];
    /** The item used as the first item in the page of results */
    offset: Scalars["Int"]["output"];
    /** Number of items to return per page */
    size: Scalars["Int"]["output"];
    /** List of status transitions. */
    values: Array<SupportRequestTransition>;
};

export type SupportRequestUpdateFieldInput = {
    /** Unique Id of the field, for example description, custom_field_1234 */
    id: Scalars["String"]["input"];
    /** The public facing value of the field. */
    value: Scalars["String"]["input"];
};

export type SupportRequestUpdateInput = {
    /** Experience fields might vary for personas. */
    experienceFields?: InputMaybe<Array<SupportRequestUpdateFieldInput>>;
    /** The unique identifier for this request. It will make it unique across multiple systems, for example 'GSAC-CA-1000' for GSAC requests. */
    requestKey: Scalars["ID"]["input"];
};

export type SupportRequestUser = {
    __typename?: "SupportRequestUser";
    /** The GSAC display name of user */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The GSAC email for this user */
    email?: Maybe<Scalars["String"]["output"]>;
    /** Identity User */
    user?: Maybe<SupportRequestIdentityUser>;
    /** This determines the user type OR Type of user eg - PARTNER/CUSTOMER */
    userType?: Maybe<SupportRequestUserType>;
    /** The GSAC username for this user. */
    username?: Maybe<Scalars["String"]["output"]>;
};

/** The supported usertype of user in system */
export enum SupportRequestUserType {
    Customer = "CUSTOMER",
    Partner = "PARTNER"
}

export type SupportRequestUsers = {
    __typename?: "SupportRequestUsers";
    searchOrganizations: Array<SupportRequestOrganization>;
    /** Search users base on query string. */
    searchUsers: Array<SupportRequestUser>;
};

export type SupportRequestUsersSearchOrganizationsArgs = {
    query?: InputMaybe<Scalars["String"]["input"]>;
    requestKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type SupportRequestUsersSearchUsersArgs = {
    query?: InputMaybe<Scalars["String"]["input"]>;
    requestKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type SupportRequests = {
    __typename?: "SupportRequests";
    page: Array<SupportRequest>;
    total: Scalars["Int"]["output"];
};

export type Swimlane = {
    __typename?: "Swimlane";
    /** The set of card types allowed in the swimlane */
    allowedCardTypes?: Maybe<Array<CardType>>;
    /** The column data */
    columnsInSwimlane?: Maybe<Array<Maybe<ColumnInSwimlane>>>;
    /** The icon to show for the swimlane */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The swimlane ID.  This will match the id of the object the swimlane is grouping by.  e.g. Epic's it will be the
     * epic's issue Id.  For assignees it will be the assignee's atlassian account id.   For swimlanes which do not
     * represent a object (e.g. "Issues without assignee's" swimlane) the value will be "0".
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The name of the swimlane */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** How to group cards on the board into swimlanes */
export enum SwimlaneStrategy {
    Assignee = "ASSIGNEE",
    Issuechildren = "ISSUECHILDREN",
    Issueparent = "ISSUEPARENT",
    None = "NONE"
}

export type SystemSpaceHomepageInput = {
    systemSpaceHomepageTemplate: SystemSpaceHomepageTemplate;
};

export enum SystemSpaceHomepageTemplate {
    Eap = "EAP",
    Minimal = "MINIMAL",
    Visual = "VISUAL"
}

export type SystemUser = {
    __typename?: "SystemUser";
    accountId: Scalars["ID"]["output"];
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    isMentionable?: Maybe<Scalars["Boolean"]["output"]>;
    nickName?: Maybe<Scalars["String"]["output"]>;
};

export type TapExperiment = {
    __typename?: "TapExperiment";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experimentKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    experimentValue: Scalars["String"]["output"];
};

export type TargetLocation = {
    __typename?: "TargetLocation";
    destinationSpace?: Maybe<Space>;
    links?: Maybe<LinksContextBase>;
    parentId?: Maybe<Scalars["ID"]["output"]>;
};

export enum TaskStatus {
    Checked = "CHECKED",
    Unchecked = "UNCHECKED"
}

/** Team returned in a team query */
export type Team = Node & {
    __typename?: "Team";
    /** The user details of the member who created the team */
    creator?: Maybe<User>;
    /** Description of the team */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Display name of the team */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** ID of the team */
    id: Scalars["ID"]["output"];
    /** URL to the large size image of the team avatar image */
    largeAvatarImageUrl?: Maybe<Scalars["String"]["output"]>;
    /** URL to the large size image of the team header image */
    largeHeaderImageUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns member data for the 'first' number of members after a cursor denoted by 'after' with membership state 'state'
     * If 'after' is null, member data will return from the top of the list of members.
     * 'first' must be greater than 0 and not null.
     * 'state' must take at least one membership state value and will include all members with those membership states
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: team-members-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __view:membership:teams__
     *
     *
     */
    members?: Maybe<TeamMemberConnection>;
    /** How members are able to be added to the team, enum of one of the following: OPEN, MEMBER_INVITE */
    membershipSetting?: Maybe<MembershipSetting>;
    /** Organisation ID of the team */
    organizationId?: Maybe<Scalars["String"]["output"]>;
    /** URL to the small size image of the team avatar image */
    smallAvatarImageUrl?: Maybe<Scalars["String"]["output"]>;
    /** URL to the small size image of the team header image */
    smallHeaderImageUrl?: Maybe<Scalars["String"]["output"]>;
    /** The state of the team, enum of one of the following: ACTIVE, DISBANDED, PURGED */
    state?: Maybe<TeamState>;
};

/** Team returned in a team query */
export type TeamMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: Scalars["Int"]["input"];
    state?: Array<MembershipState>;
};

export enum TeamCalendarDayOfWeek {
    Friday = "FRIDAY",
    Monday = "MONDAY",
    Saturday = "SATURDAY",
    Sunday = "SUNDAY",
    Thursday = "THURSDAY",
    Tuesday = "TUESDAY",
    Wednesday = "WEDNESDAY"
}

export type TeamCalendarFeature = {
    __typename?: "TeamCalendarFeature";
    isEntitled: Scalars["Boolean"]["output"];
};

export type TeamCalendarSettings = {
    __typename?: "TeamCalendarSettings";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    startDayOfWeek: TeamCalendarDayOfWeek;
};

/** Returns the details of the team member and details about their membership within a team */
export type TeamMember = {
    __typename?: "TeamMember";
    /** The user details of the team member */
    member?: Maybe<User>;
    /** Member's role in the team, enum of one of the following: REGULAR, ADMIN */
    role?: Maybe<MembershipRole>;
    /** Membership state, enum of one of the following: FULL_MEMBER, ALUMNI, INVITED, REQUESTING_TO_JOIN */
    state?: Maybe<MembershipState>;
};

/** The connection entity for the members of a team for pagination */
export type TeamMemberConnection = {
    __typename?: "TeamMemberConnection";
    edges?: Maybe<Array<Maybe<TeamMemberEdge>>>;
    nodes?: Maybe<Array<Maybe<TeamMember>>>;
    pageInfo: PageInfo;
};

/** The connection entity for the members of a team for pagination */
export type TeamMemberConnectionV2 = {
    __typename?: "TeamMemberConnectionV2";
    /** Team members matching the search */
    edges?: Maybe<Array<Maybe<TeamMemberEdgeV2>>>;
    /** Team members matching the search */
    nodes?: Maybe<Array<Maybe<TeamMemberV2>>>;
    /** Cursor for the next page of results */
    pageInfo: PageInfo;
};

export type TeamMemberEdge = {
    __typename?: "TeamMemberEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TeamMember>;
};

export type TeamMemberEdgeV2 = {
    __typename?: "TeamMemberEdgeV2";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TeamMemberV2>;
};

/** Returns the details of the team member and details about their membership within a team */
export type TeamMemberV2 = {
    __typename?: "TeamMemberV2";
    /** The user details of the team member */
    member?: Maybe<User>;
    /** Member's role in the team */
    role?: Maybe<TeamMembershipRole>;
    /** Membership state */
    state?: Maybe<TeamMembershipState>;
};

/** Member filter used as input on team search filter */
export type TeamMembershipFilter = {
    /** List of members AccountIDs */
    memberIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
};

/** The roles that a member can have within a team */
export enum TeamMembershipRole {
    /** A team member with administrative permissions */
    Admin = "ADMIN",
    /** A regular team member */
    Regular = "REGULAR"
}

/** The settings which a team can have describing how members are added to the team */
export enum TeamMembershipSettings {
    /** Membership is externally defined (not yet supported) */
    External = "EXTERNAL",
    /** Members may invite others to join the team */
    MemberInvite = "MEMBER_INVITE",
    /** Anyone may join */
    Open = "OPEN"
}

/** The states that a member can have within a team */
export enum TeamMembershipState {
    /** A member who was previously a full member of the team, but has been removed or has left the team */
    Alumni = "ALUMNI",
    /** A full member of the team */
    FullMember = "FULL_MEMBER",
    /** A member who has requested to join the team and is pending approval */
    RequestingToJoin = "REQUESTING_TO_JOIN"
}

export type TeamMutation = {
    __typename?: "TeamMutation";
    /**
     * Add and removes the principal for the given role and organizationId.
     *
     * Principals are removed before they are added.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Team-rbac")' query directive to the 'updateRoleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateRoleAssignments?: Maybe<TeamUpdateRoleAssignmentsResponse>;
};

export type TeamMutationUpdateRoleAssignmentsArgs = {
    organizationId: Scalars["ID"]["input"];
    principalsToAdd: Array<InputMaybe<Scalars["ID"]["input"]>>;
    principalsToRemove: Array<InputMaybe<Scalars["ID"]["input"]>>;
    role: TeamRole;
};

export type TeamPrincipal = {
    __typename?: "TeamPrincipal";
    /** Principal ARI */
    principalId?: Maybe<Scalars["ID"]["output"]>;
};

export type TeamPrincipalEdge = {
    __typename?: "TeamPrincipalEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TeamPrincipal>;
};

export type TeamQuery = {
    __typename?: "TeamQuery";
    /**
     * Returns all permitted principals for the given organizationId and role.
     * Optionally a limit and a cursor can be supplied.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __manage:org__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Team-rbac")' query directive to the 'roleAssignments' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    roleAssignments?: Maybe<TeamRoleAssignmentsConnection>;
    /**
     * Returns the team with the given ARI
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: teams-beta` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __view:team:teams__
     *
     *
     * @deprecated This is deprecated in favour of teamV2
     */
    team?: Maybe<Team>;
    /**
     * Returns the search result for teams matching the given query in the specified organization.
     * Query can be empty.
     * Optionally a limit, sort and a cursor can be supplied.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __view:team:teams__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "team-search")' query directive to the 'teamSearch' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated This is deprecated in favour of teamSearchV2
     */
    teamSearch?: Maybe<TeamSearchResultConnection>;
    /**
     * Returns the search result for teams matching the given query in the specified site and organization. Please provide
     * siteId if present, in its raw id form (i.e. not ARI). If siteId is not present, please provide "None" string.
     * Query can be empty.
     * Optionally a limit (max 100), sort and a cursor can be supplied.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __view:team:teams__
     *
     *
     */
    teamSearchV2?: Maybe<TeamSearchResultConnectionV2>;
    /**
     * Returns the team with the given ARI in the specified site.
     * Please provide the siteId if present, in its raw id form (i.e. not ARI).
     * If siteId is not present, please provide "None" string.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __view:team:teams__
     *
     *
     */
    teamV2?: Maybe<TeamV2>;
};

export type TeamQueryRoleAssignmentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    organizationId: Scalars["ID"]["input"];
    role: TeamRole;
};

export type TeamQueryTeamArgs = {
    id: Scalars["ID"]["input"];
};

export type TeamQueryTeamSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TeamSearchFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    organizationId: Scalars["ID"]["input"];
    sortBy?: InputMaybe<Array<InputMaybe<TeamSort>>>;
};

export type TeamQueryTeamSearchV2Args = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TeamSearchFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    organizationId: Scalars["ID"]["input"];
    searchFields?: InputMaybe<Array<InputMaybe<TeamSearchField>>>;
    showEmptyTeams?: InputMaybe<Scalars["Boolean"]["input"]>;
    siteId: Scalars["String"]["input"];
    sortBy?: InputMaybe<Array<InputMaybe<TeamSort>>>;
};

export type TeamQueryTeamV2Args = {
    id: Scalars["ID"]["input"];
    siteId: Scalars["String"]["input"];
};

export enum TeamRole {
    TeamsAdmin = "TEAMS_ADMIN",
    TeamsObserver = "TEAMS_OBSERVER",
    TeamsUser = "TEAMS_USER"
}

export type TeamRoleAssignmentsConnection = {
    __typename?: "TeamRoleAssignmentsConnection";
    edges?: Maybe<Array<Maybe<TeamPrincipalEdge>>>;
    nodes?: Maybe<Array<Maybe<TeamPrincipal>>>;
    pageInfo: PageInfo;
};

/** Enum representing the search fields for teams. */
export enum TeamSearchField {
    /** Search by team description */
    Description = "DESCRIPTION",
    /** Search by team name */
    Name = "NAME"
}

/** Team filter used as input on team search */
export type TeamSearchFilter = {
    /** Team Membership Filter, optional */
    membership?: InputMaybe<TeamMembershipFilter>;
    /** String query to search, optional */
    query?: InputMaybe<Scalars["String"]["input"]>;
};

/** Team returned in search */
export type TeamSearchResult = {
    __typename?: "TeamSearchResult";
    /** Whether the requesting user is a member of the team. */
    includesYou?: Maybe<Scalars["Boolean"]["output"]>;
    /** Number of members in the team. */
    memberCount?: Maybe<Scalars["Int"]["output"]>;
    /** The Team */
    team?: Maybe<Team>;
};

/** The result of the search for teams. */
export type TeamSearchResultConnection = {
    __typename?: "TeamSearchResultConnection";
    /** Teams matching the search */
    edges?: Maybe<Array<Maybe<TeamSearchResultEdge>>>;
    /** Teams matching the search */
    nodes?: Maybe<Array<Maybe<TeamSearchResult>>>;
    /** Cursor for the next page of results */
    pageInfo?: Maybe<PageInfo>;
};

/** The result of the search for teams. */
export type TeamSearchResultConnectionV2 = {
    __typename?: "TeamSearchResultConnectionV2";
    /** Teams matching the search */
    edges?: Maybe<Array<Maybe<TeamSearchResultEdgeV2>>>;
    /** Teams matching the search */
    nodes?: Maybe<Array<Maybe<TeamSearchResultV2>>>;
    /** Cursor for the next page of results */
    pageInfo?: Maybe<PageInfo>;
};

/** An edge from a team search */
export type TeamSearchResultEdge = {
    __typename?: "TeamSearchResultEdge";
    /** The cursor for this team search result */
    cursor: Scalars["String"]["output"];
    /** A team search result */
    node?: Maybe<TeamSearchResult>;
};

/** An edge from a team search */
export type TeamSearchResultEdgeV2 = {
    __typename?: "TeamSearchResultEdgeV2";
    /** The cursor for this team search result */
    cursor: Scalars["String"]["output"];
    /** A team search result */
    node?: Maybe<TeamSearchResultV2>;
};

/** Team returned in search */
export type TeamSearchResultV2 = {
    __typename?: "TeamSearchResultV2";
    /** Whether the requesting user is a member of the team. */
    includesYou?: Maybe<Scalars["Boolean"]["output"]>;
    /** Number of members in the team. */
    memberCount?: Maybe<Scalars["Int"]["output"]>;
    /** The Team matching the search. */
    team?: Maybe<TeamV2>;
};

/** Team sort used as input on team search */
export type TeamSort = {
    /** Team sort field */
    field: TeamSortField;
    /** Team sort order */
    order?: InputMaybe<TeamSortOrder>;
};

/** Team sort fields */
export enum TeamSortField {
    /** Team name field */
    DisplayName = "DISPLAY_NAME",
    /** Identifier Team field */
    Id = "ID",
    /** Team state field */
    State = "STATE"
}

/** Team Sort Order */
export enum TeamSortOrder {
    /** Ascendant order */
    Asc = "ASC",
    /** Descendent order */
    Desc = "DESC"
}

/** The states that a team can have */
export enum TeamState {
    /** The team is currently active */
    Active = "ACTIVE",
    /** The team has been disbanded and is currently inactive */
    Disbanded = "DISBANDED",
    /** All members of the team have been deleted */
    Purged = "PURGED"
}

/** The states that a team can have */
export enum TeamStateV2 {
    /** The team is currently active */
    Active = "ACTIVE",
    /** All members of the team have been deleted */
    Purged = "PURGED"
}

export type TeamUpdateRoleAssignmentsResponse = {
    __typename?: "TeamUpdateRoleAssignmentsResponse";
    /** Principal ARIs that were successfully added */
    successfullyAddedPrincipals?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    /** Principal ARIs that were successfully removed */
    successfullyRemovedPrincipals?: Maybe<
        Array<Maybe<Scalars["ID"]["output"]>>
    >;
};

/** Team returned in a team query */
export type TeamV2 = Node & {
    __typename?: "TeamV2";
    /** The user details of the member who created the team */
    creator?: Maybe<User>;
    /** Description of the team */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Display name of the team */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** ID of the team */
    id: Scalars["ID"]["output"];
    /** The verified status of the team */
    isVerified?: Maybe<Scalars["Boolean"]["output"]>;
    /** URL to the large size image of the team avatar image */
    largeAvatarImageUrl?: Maybe<Scalars["String"]["output"]>;
    /** URL to the large size image of the team header image */
    largeHeaderImageUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * Returns member data for the 'first' number of members after a cursor denoted by 'after' with membership state 'state'
     * If 'after' is null, member data will return from the top of the list of members.
     * 'first' must be greater than 0, less than or equal to 100, and not null.
     * 'state' must take at least one membership state value and will include all members with those membership states
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __view:membership:teams__
     *
     *
     */
    members?: Maybe<TeamMemberConnectionV2>;
    /** How members are able to be added to the team */
    membershipSettings?: Maybe<TeamMembershipSettings>;
    /** Organisation ID of the team */
    organizationId?: Maybe<Scalars["ID"]["output"]>;
    /** URL to the small size image of the team avatar image */
    smallAvatarImageUrl?: Maybe<Scalars["String"]["output"]>;
    /** URL to the small size image of the team header image */
    smallHeaderImageUrl?: Maybe<Scalars["String"]["output"]>;
    /** The state of the team */
    state?: Maybe<TeamStateV2>;
};

/** Team returned in a team query */
export type TeamV2MembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: Scalars["Int"]["input"];
    state?: Array<TeamMembershipState>;
};

export type TemplateBody = {
    __typename?: "TemplateBody";
    body: ContentBody;
    id: Scalars["String"]["output"];
};

export type TemplateBodyEdge = {
    __typename?: "TemplateBodyEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<TemplateBody>;
};

export type TemplateCategory = {
    __typename?: "TemplateCategory";
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type TemplateCategoryEdge = {
    __typename?: "TemplateCategoryEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<TemplateCategory>;
};

export type TemplateEntityFavouriteStatus = {
    isFavourite: Scalars["Boolean"]["input"];
    templateEntityId: Scalars["String"]["input"];
};

/** Provides template information. Useful for in - editor template gallery and more in the future. */
export type TemplateInfo = {
    __typename?: "TemplateInfo";
    author?: Maybe<Scalars["String"]["output"]>;
    blueprintModuleCompleteKey?: Maybe<Scalars["String"]["output"]>;
    categoryIds: Array<Maybe<Scalars["String"]["output"]>>;
    contentBlueprintId?: Maybe<Scalars["String"]["output"]>;
    darkModeIconURL?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    hasGlobalBlueprintContent: Scalars["Boolean"]["output"];
    hasWizard?: Maybe<Scalars["Boolean"]["output"]>;
    iconURL?: Maybe<Scalars["String"]["output"]>;
    isConvertible?: Maybe<Scalars["Boolean"]["output"]>;
    isFavourite?: Maybe<Scalars["Boolean"]["output"]>;
    isLegacyTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    isNew?: Maybe<Scalars["Boolean"]["output"]>;
    isPromoted?: Maybe<Scalars["Boolean"]["output"]>;
    itemModuleCompleteKey?: Maybe<Scalars["String"]["output"]>;
    keywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    link?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextBase>;
    name?: Maybe<Scalars["String"]["output"]>;
    recommendationRank?: Maybe<Scalars["Int"]["output"]>;
    spaceKey?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
    templateId?: Maybe<Scalars["String"]["output"]>;
    templateType?: Maybe<Scalars["String"]["output"]>;
};

export type TemplateInfoEdge = {
    __typename?: "TemplateInfoEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<TemplateInfo>;
};

export type TemplateMediaSession = {
    __typename?: "TemplateMediaSession";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    collections: Array<Maybe<MapOfStringToString>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    configuration: MediaConfiguration;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    downloadToken: TemplateMediaToken;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    uploadToken: TemplateMediaToken;
};

export type TemplateMediaToken = {
    __typename?: "TemplateMediaToken";
    duration?: Maybe<Scalars["Int"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type TemplateMigration = {
    __typename?: "TemplateMigration";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unsupportedTemplatesNames: Array<Maybe<Scalars["String"]["output"]>>;
};

export type TemplatePropertySetInput = {
    /** appearance of the template */
    contentAppearance?: InputMaybe<GraphQlTemplateContentAppearance>;
};

export type TemplatePropertySetPayload = {
    __typename?: "TemplatePropertySetPayload";
    /** appearance of the template */
    contentAppearance?: Maybe<GraphQlTemplateContentAppearance>;
};

export type TemplatizeInput = {
    contentId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type Tenant = {
    __typename?: "Tenant";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    activationId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    cloudId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    editions?: Maybe<ConfluenceEditions>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    environment: Environment;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shard: Scalars["String"]["output"];
};

export type TenantContext = {
    __typename?: "TenantContext";
    /** The activation id associated with this tenant for a specific product */
    activationIdByProduct?: Maybe<TenantContextActivationId>;
    /** The list of activation ids associated with this tenant for all products */
    activationIds?: Maybe<Array<TenantContextActivationId>>;
    /** The cloud id of a tenanted Jira or Confluence instance */
    cloudId?: Maybe<Scalars["ID"]["output"]>;
    /** The host URL of a tenanted Jira or Confluence instance */
    cloudUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The list of custom domains associated with  this tenant */
    customDomains?: Maybe<Array<TenantContextCustomDomain>>;
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __identity:atlassian-external__
     *
     *
     */
    entitlementInfo?: Maybe<CommerceEntitlementInfo>;
    /** The host name of a tenanted Jira or Confluence instance */
    hostName?: Maybe<Scalars["String"]["output"]>;
    /** The organization id for this tenant */
    orgId?: Maybe<Scalars["ID"]["output"]>;
};

export type TenantContextActivationIdByProductArgs = {
    product: Scalars["String"]["input"];
};

export type TenantContextEntitlementInfoArgs = {
    hamsProductKey: Scalars["String"]["input"];
};

export type TenantContextActivationId = {
    __typename?: "TenantContextActivationId";
    /** The activation id of the product */
    active?: Maybe<Scalars["String"]["output"]>;
    /** The name of a product associated with activation id */
    product?: Maybe<Scalars["String"]["output"]>;
};

export type TenantContextCustomDomain = {
    __typename?: "TenantContextCustomDomain";
    /** The custom host name of the product */
    hostName?: Maybe<Scalars["String"]["output"]>;
    /** The name of a product associated with a custom domain */
    product?: Maybe<Scalars["String"]["output"]>;
};

export type Theme = {
    __typename?: "Theme";
    description?: Maybe<Scalars["String"]["output"]>;
    icon?: Maybe<Icon>;
    links?: Maybe<LinksContextBase>;
    name?: Maybe<Scalars["String"]["output"]>;
    themeKey?: Maybe<Scalars["String"]["output"]>;
};

export type ThirdPartyDetails = {
    __typename?: "ThirdPartyDetails";
    /** Domain URL of third party */
    link: Scalars["String"]["output"];
    /** Name of third party */
    name: Scalars["String"]["output"];
    /** Purpose of sharing End-User Data with third party */
    purpose: Scalars["String"]["output"];
    /** Countries where third party stores End-User Data */
    thirdPartyCountries: Array<Maybe<Scalars["String"]["output"]>>;
};

export type ThirdPartyInformation = {
    __typename?: "ThirdPartyInformation";
    /** If End-User Data is shared with third-party entities, Link to sub-processor list */
    dataSubProcessors?: Maybe<Scalars["String"]["output"]>;
    /** Does the app share End-User Data with any third party entities (e.g. sub-processors)? */
    isEndUserDataShared: Scalars["Boolean"]["output"];
    /** If End-User Data is shared with third-party entities, Third-party details */
    thirdPartyDetails?: Maybe<Array<Maybe<ThirdPartyDetails>>>;
};

/** The input for a Third Party Repository */
export type ThirdPartyRepositoryInput = {
    /** Avatar details for the third party repository. */
    avatar?: InputMaybe<AvatarInput>;
    /** The ID of the third party repository. */
    id: Scalars["ID"]["input"];
    /** The name of the third party repository. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The URL of the third party repository. */
    webUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type ThirdPartySecurityContainer = Node &
    SecurityContainer & {
        __typename?: "ThirdPartySecurityContainer";
        icon?: Maybe<Scalars["URL"]["output"]>;
        id: Scalars["ID"]["output"];
        lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
        name: Scalars["String"]["output"];
        providerId?: Maybe<Scalars["String"]["output"]>;
        providerName?: Maybe<Scalars["String"]["output"]>;
        url?: Maybe<Scalars["URL"]["output"]>;
    };

export type ThirdPartySecurityWorkspace = Node &
    SecurityWorkspace & {
        __typename?: "ThirdPartySecurityWorkspace";
        icon?: Maybe<Scalars["URL"]["output"]>;
        id: Scalars["ID"]["output"];
        lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
        name: Scalars["String"]["output"];
        providerId?: Maybe<Scalars["String"]["output"]>;
        providerName?: Maybe<Scalars["String"]["output"]>;
        url?: Maybe<Scalars["URL"]["output"]>;
    };

/**
 * This represent a third party user
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 *
 *
 */
export type ThirdPartyUser = LocalizationContext & {
    __typename?: "ThirdPartyUser";
    accountId: Scalars["ID"]["output"];
    accountStatus: AccountStatus;
    canonicalAccountId: Scalars["ID"]["output"];
    createdAt: Scalars["DateTime"]["output"];
    email?: Maybe<Scalars["String"]["output"]>;
    extendedProfile?: Maybe<ThirdPartyUserExtendedProfile>;
    externalId: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    locale?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    nickname?: Maybe<Scalars["String"]["output"]>;
    picture?: Maybe<Scalars["URL"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    zoneinfo?: Maybe<Scalars["String"]["output"]>;
};

export type ThirdPartyUserExtendedProfile = {
    __typename?: "ThirdPartyUserExtendedProfile";
    department?: Maybe<Scalars["String"]["output"]>;
    jobTitle?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<Scalars["String"]["output"]>;
    organization?: Maybe<Scalars["String"]["output"]>;
    phoneNumbers?: Maybe<Array<Maybe<ThirdPartyUserPhoneNumber>>>;
};

export type ThirdPartyUserPhoneNumber = {
    __typename?: "ThirdPartyUserPhoneNumber";
    type?: Maybe<Scalars["String"]["output"]>;
    value: Scalars["String"]["output"];
};

/**
 * General Report Types
 * ====================
 */
export type TimeSeriesPoint = {
    __typename?: "TimeSeriesPoint";
    id: Scalars["ID"]["output"];
    x: Scalars["DateTime"]["output"];
    y: Scalars["Int"]["output"];
};

export type TimeseriesCount = {
    __typename?: "TimeseriesCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<TimeseriesCountItem>;
};

export type TimeseriesCountItem = {
    __typename?: "TimeseriesCountItem";
    /** Analytics count */
    count: Scalars["Int"]["output"];
    /** Grouping date in ISO format */
    date: Scalars["String"]["output"];
};

export type TimeseriesPageBlogCount = {
    __typename?: "TimeseriesPageBlogCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<TimeseriesCountItem>;
};

export type TimeseriesUniqueUserCount = {
    __typename?: "TimeseriesUniqueUserCount";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<TimeseriesCountItem>;
};

export type ToggleBoardFeatureInput = {
    enabled: Scalars["Boolean"]["input"];
    featureId: Scalars["String"]["input"];
};

export type ToggleBoardFeatureOutput = MutationResponse & {
    __typename?: "ToggleBoardFeatureOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    featureGroups: BoardFeatureGroupConnection;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** For all queries and mutations the `providerType` parameter is required when providers may implement more than one DevOps module. Therefore in most contexts the providerType is required. */
export type Toolchain = {
    __typename?: "Toolchain";
    /**
     * Returns the authorized status for the current user.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Toolchain")' query directive to the 'checkAuth' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    checkAuth?: Maybe<ToolchainCheckAuth>;
    /**
     * Returns an authorization status for the current user and information for granting authorization if it can be performed.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Toolchain")' query directive to the 'checkAuthV2' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    checkAuthV2?: Maybe<ToolchainCheckAuthResult>;
    /**
     * Returns the containers for a given provider or workspace.
     *
     * Either both `cloudId` and 'providerId', or 'workspaceId' must be specified.
     */
    containers?: Maybe<ToolchainContainerConnection>;
    /** Returns the workspaces for a given provider. */
    workspaces?: Maybe<ToolchainWorkspaceConnection>;
};

/** For all queries and mutations the `providerType` parameter is required when providers may implement more than one DevOps module. Therefore in most contexts the providerType is required. */
export type ToolchainCheckAuthArgs = {
    cloudId: Scalars["ID"]["input"];
    providerId: Scalars["String"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
};

/** For all queries and mutations the `providerType` parameter is required when providers may implement more than one DevOps module. Therefore in most contexts the providerType is required. */
export type ToolchainCheckAuthV2Args = {
    cloudId: Scalars["ID"]["input"];
    providerId: Scalars["String"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
};

/** For all queries and mutations the `providerType` parameter is required when providers may implement more than one DevOps module. Therefore in most contexts the providerType is required. */
export type ToolchainContainersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["ID"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    providerId?: InputMaybe<Scalars["String"]["input"]>;
    providerType?: InputMaybe<ToolchainProviderType>;
    query?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** For all queries and mutations the `providerType` parameter is required when providers may implement more than one DevOps module. Therefore in most contexts the providerType is required. */
export type ToolchainWorkspacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    providerId: Scalars["String"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
    query?: InputMaybe<Scalars["String"]["input"]>;
};

export type ToolchainAssociateContainerInput = {
    containerId: Scalars["ID"]["input"];
    jiraProjectId: Scalars["ID"]["input"];
    workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * #########################
 *  Mutation Inputs
 * #########################
 */
export type ToolchainAssociateContainersInput = {
    associations: Array<ToolchainAssociateContainerInput>;
    cloudId: Scalars["ID"]["input"];
    providerId: Scalars["ID"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
};

export type ToolchainAssociateContainersPayload = Payload & {
    __typename?: "ToolchainAssociateContainersPayload";
    associatedContainers?: Maybe<Array<ToolchainAssociatedContainer>>;
    containers?: Maybe<Array<ToolchainAssociatedContainer>>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum ToolchainAssociateEntitiesErrorCode {
    /** The entity identified by the given URL was rejected */
    EntityRejected = "ENTITY_REJECTED",
    /** The given URL is invalid */
    EntityUrlInvalid = "ENTITY_URL_INVALID",
    /** You do not have permission to fetch the Entity */
    ProviderEntityFetchForbidden = "PROVIDER_ENTITY_FETCH_FORBIDDEN",
    /** The entity identified by the given URL does not exist */
    ProviderEntityNotFound = "PROVIDER_ENTITY_NOT_FOUND",
    /** An unexpected provider error occurred */
    ProviderError = "PROVIDER_ERROR",
    /** The given URL is not supported by the provider */
    ProviderInputInvalid = "PROVIDER_INPUT_INVALID"
}

export type ToolchainAssociateEntitiesErrorExtension =
    MutationErrorExtension & {
        __typename?: "ToolchainAssociateEntitiesErrorExtension";
        /**
         * The URL of the entity that returned the error
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        entityUrl?: Maybe<Scalars["String"]["output"]>;
        /**
         * A code representing the type of error. See the ToolchainAssociateEntitiesErrorCode enum for possible values.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorCode?: Maybe<ToolchainAssociateEntitiesErrorCode>;
        /**
         * A code representing the type of error. String form of ToolchainAssociateEntitiesErrorCode.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type ToolchainAssociateEntitiesInput = {
    associations: Array<ToolchainAssociateEntityInput>;
    cloudId: Scalars["ID"]["input"];
    providerId: Scalars["ID"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
};

export type ToolchainAssociateEntitiesPayload = Payload & {
    __typename?: "ToolchainAssociateEntitiesPayload";
    associatedEntities?: Maybe<Array<ToolchainAssociatedEntity>>;
    entities?: Maybe<Array<ToolchainAssociatedEntity>>;
    errors?: Maybe<Array<MutationError>>;
    fromEntities?: Maybe<Array<Maybe<JiraIssue>>>;
    success: Scalars["Boolean"]["output"];
};

export type ToolchainAssociateEntityInput = {
    fromId: Scalars["ID"]["input"];
    toEntityUrl: Scalars["URL"]["input"];
};

/** This is a union of all the consumer schemas supported by the associate container API */
export type ToolchainAssociatedContainer =
    | DevOpsDocument
    | DevOpsOperationsComponentDetails
    | DevOpsRepository
    | DevOpsService
    | ThirdPartySecurityContainer;

/** This is a union of all the consumer schemas supported by the associate entity API */
export type ToolchainAssociatedEntity = DevOpsDesign;

export type ToolchainCheck3LoAuth = ToolchainCheckAuth & {
    __typename?: "ToolchainCheck3LOAuth";
    authorized: Scalars["Boolean"]["output"];
    grant?: Maybe<ToolchainCheck3LoAuthGrant>;
};

export type ToolchainCheck3LoAuthGrant = {
    __typename?: "ToolchainCheck3LOAuthGrant";
    authorizationEndpoint: Scalars["String"]["output"];
};

export type ToolchainCheckAuth = {
    authorized: Scalars["Boolean"]["output"];
};

export enum ToolchainCheckAuthErrorCode {
    /** An unexpected provider error occurred or authentication type is not implemented */
    ProviderError = "PROVIDER_ERROR"
}

export type ToolchainCheckAuthErrorExtension = QueryErrorExtension & {
    __typename?: "ToolchainCheckAuthErrorExtension";
    /**
     * A code representing the type of error. See the ToolchainCheckAuthErrorCode enum for possible values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorCode?: Maybe<ToolchainCheckAuthErrorCode>;
    /**
     * A code representing the type of error. String form of ToolchainCheckAuthErrorCode.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (such as a HTTP status code) representing the error category.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** This is a union of all the auth types supported by the check auth API and query error if check auth is unsuccessful */
export type ToolchainCheckAuthResult = QueryError | ToolchainCheck3LoAuth;

export type ToolchainContainer = Node & {
    __typename?: "ToolchainContainer";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    workspace?: Maybe<ToolchainContainerWorkspaceDetails>;
};

export type ToolchainContainerConnection = {
    __typename?: "ToolchainContainerConnection";
    edges?: Maybe<Array<Maybe<ToolchainContainerEdge>>>;
    error?: Maybe<ToolchainContainerConnectionError>;
    nodes?: Maybe<Array<Maybe<ToolchainContainer>>>;
    pageInfo: PageInfo;
};

export type ToolchainContainerConnectionError = {
    __typename?: "ToolchainContainerConnectionError";
    extensions?: Maybe<Array<ToolchainContainerConnectionErrorExtension>>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export enum ToolchainContainerConnectionErrorCode {
    ProviderActionForbidden = "PROVIDER_ACTION_FORBIDDEN"
}

export type ToolchainContainerConnectionErrorExtension = QueryErrorExtension & {
    __typename?: "ToolchainContainerConnectionErrorExtension";
    errorCode?: Maybe<ToolchainContainerConnectionErrorCode>;
    errorType?: Maybe<Scalars["String"]["output"]>;
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type ToolchainContainerEdge = {
    __typename?: "ToolchainContainerEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ToolchainContainer>;
};

export type ToolchainContainerWorkspaceDetails = {
    __typename?: "ToolchainContainerWorkspaceDetails";
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

export enum ToolchainCreateContainerErrorCode {
    /** The container already exists */
    ProviderContainerAlreadyExists = "PROVIDER_CONTAINER_ALREADY_EXISTS",
    /** You do not have permission to create the container */
    ProviderContainerCreateForbidden = "PROVIDER_CONTAINER_CREATE_FORBIDDEN",
    /** An unexpected provider error occurred */
    ProviderError = "PROVIDER_ERROR",
    /** The input provided is invalid */
    ProviderInputInvalid = "PROVIDER_INPUT_INVALID",
    /** The given workspace doesn't exist */
    ProviderWorkspaceNotFound = "PROVIDER_WORKSPACE_NOT_FOUND"
}

export type ToolchainCreateContainerErrorExtension = MutationErrorExtension & {
    __typename?: "ToolchainCreateContainerErrorExtension";
    /**
     * A code representing the type of error. See the ToolchainCreateContainerErrorCode enum for possible values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorCode?: Maybe<ToolchainCreateContainerErrorCode>;
    /**
     * A code representing the type of error. String form of ToolchainCreateContainerErrorCode.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Either both `cloudId` and 'providerId', or 'workspaceId' must be specified. */
export type ToolchainCreateContainerInput = {
    cloudId: Scalars["ID"]["input"];
    name: Scalars["String"]["input"];
    providerId?: InputMaybe<Scalars["ID"]["input"]>;
    providerType?: InputMaybe<ToolchainProviderType>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ToolchainCreateContainerPayload = Payload & {
    __typename?: "ToolchainCreateContainerPayload";
    createdContainer?: Maybe<ToolchainContainer>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type ToolchainDisassociateContainerInput = {
    containerId: Scalars["ID"]["input"];
    jiraProjectId: Scalars["ID"]["input"];
};

export type ToolchainDisassociateContainersInput = {
    cloudId: Scalars["ID"]["input"];
    disassociations: Array<ToolchainDisassociateContainerInput>;
    providerId: Scalars["ID"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
};

export type ToolchainDisassociateContainersPayload = Payload & {
    __typename?: "ToolchainDisassociateContainersPayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export enum ToolchainDisassociateEntitiesErrorCode {
    /** The association is unknown */
    UnknownAssociation = "UNKNOWN_ASSOCIATION"
}

export type ToolchainDisassociateEntitiesErrorExtension =
    MutationErrorExtension & {
        __typename?: "ToolchainDisassociateEntitiesErrorExtension";
        /**
         * Entity id of the disassociated entity.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        entityId?: Maybe<Scalars["ID"]["output"]>;
        /**
         * A code representing the type of error. See the ToolchainDisassociateEntitiesErrorCode enum for possible values.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorCode?: Maybe<ToolchainDisassociateEntitiesErrorCode>;
        /**
         * A code representing the type of error. String form of ToolchainDisassociateEntitiesErrorCode.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         * A numerical code (such as a HTTP status code) representing the error category.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type ToolchainDisassociateEntitiesInput = {
    cloudId: Scalars["ID"]["input"];
    disassociations: Array<ToolchainDisassociateEntityInput>;
    providerId: Scalars["ID"]["input"];
    providerType?: InputMaybe<ToolchainProviderType>;
};

export type ToolchainDisassociateEntitiesPayload = Payload & {
    __typename?: "ToolchainDisassociateEntitiesPayload";
    entities?: Maybe<Array<Maybe<Scalars["ID"]["output"]>>>;
    errors?: Maybe<Array<MutationError>>;
    fromEntities?: Maybe<Array<Maybe<JiraIssue>>>;
    success: Scalars["Boolean"]["output"];
};

export type ToolchainDisassociateEntityInput = {
    fromId: Scalars["ID"]["input"];
    toEntityId: Scalars["ID"]["input"];
};

export type ToolchainMutation = {
    __typename?: "ToolchainMutation";
    /**
     * Associate provider containers with Jira projects.
     *
     * This will call the provider to start syncing the container with Jira and create the AGS relationship.
     */
    associateContainers?: Maybe<ToolchainAssociateContainersPayload>;
    /** Associate provider entities with Jira issues. */
    associateEntities?: Maybe<ToolchainAssociateEntitiesPayload>;
    /** Create a container for a given provider or workspace. */
    createContainer?: Maybe<ToolchainCreateContainerPayload>;
    /**
     * Disassociate provider containers from Jira projects.
     *
     * This will delete the AGS relationship and call the provider to stop syncing the container with Jira.
     */
    disassociateContainers?: Maybe<ToolchainDisassociateContainersPayload>;
    /** Disassociate provider entities from Jira issues. */
    disassociateEntities?: Maybe<ToolchainDisassociateEntitiesPayload>;
};

export type ToolchainMutationAssociateContainersArgs = {
    input: ToolchainAssociateContainersInput;
};

export type ToolchainMutationAssociateEntitiesArgs = {
    input: ToolchainAssociateEntitiesInput;
};

export type ToolchainMutationCreateContainerArgs = {
    input: ToolchainCreateContainerInput;
};

export type ToolchainMutationDisassociateContainersArgs = {
    input: ToolchainDisassociateContainersInput;
};

export type ToolchainMutationDisassociateEntitiesArgs = {
    input: ToolchainDisassociateEntitiesInput;
};

/**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */
export enum ToolchainProviderType {
    Build = "BUILD",
    Deployment = "DEPLOYMENT",
    Design = "DESIGN",
    DevopsComponents = "DEVOPS_COMPONENTS",
    DevInfo = "DEV_INFO",
    Documentation = "DOCUMENTATION",
    FeatureFlag = "FEATURE_FLAG",
    Operations = "OPERATIONS",
    RemoteLinks = "REMOTE_LINKS",
    Security = "SECURITY"
}

export type ToolchainWorkspace = Node & {
    __typename?: "ToolchainWorkspace";
    canCreateContainer: Scalars["Boolean"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

export type ToolchainWorkspaceConnection = {
    __typename?: "ToolchainWorkspaceConnection";
    edges?: Maybe<Array<Maybe<ToolchainWorkspaceEdge>>>;
    error?: Maybe<QueryError>;
    nodes?: Maybe<Array<Maybe<ToolchainWorkspace>>>;
    pageInfo: PageInfo;
};

export enum ToolchainWorkspaceConnectionErrorCode {
    ProviderActionError = "PROVIDER_ACTION_ERROR",
    ProviderNotSupported = "PROVIDER_NOT_SUPPORTED"
}

export type ToolchainWorkspaceConnectionErrorExtension = QueryErrorExtension & {
    __typename?: "ToolchainWorkspaceConnectionErrorExtension";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorCode?: Maybe<ToolchainWorkspaceConnectionErrorCode>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type ToolchainWorkspaceEdge = {
    __typename?: "ToolchainWorkspaceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<ToolchainWorkspace>;
};

export type TopRelevantUsers = {
    __typename?: "TopRelevantUsers";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes?: Maybe<Array<Maybe<RelevantSpacesWrapper>>>;
};

export type TopTemplateItem = {
    __typename?: "TopTemplateItem";
    rank: Scalars["Int"]["output"];
    templateId: Scalars["String"]["output"];
};

export type TotalSearchCtr = {
    __typename?: "TotalSearchCTR";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nodes: Array<TotalSearchCtrItems>;
};

export type TotalSearchCtrItems = {
    __typename?: "TotalSearchCTRItems";
    clicks: Scalars["Long"]["output"];
    ctr: Scalars["Float"]["output"];
    searches: Scalars["Long"]["output"];
};

export enum TownsquareAccessControlCapability {
    Access = "ACCESS",
    Administer = "ADMINISTER",
    Create = "CREATE"
}

export type TownsquareArchiveGoalInput = {
    id: Scalars["String"]["input"];
};

export type TownsquareArchiveGoalPayload = {
    __typename?: "TownsquareArchiveGoalPayload";
    goal?: Maybe<TownsquareGoal>;
};

export type TownsquareCapability = {
    __typename?: "TownsquareCapability";
    capability?: Maybe<TownsquareAccessControlCapability>;
    capabilityContainer?: Maybe<TownsquareCapabilityContainer>;
};

export enum TownsquareCapabilityContainer {
    GoalsApp = "GOALS_APP",
    ProjectsApp = "PROJECTS_APP"
}

export type TownsquareComment = Node & {
    __typename?: "TownsquareComment";
    container?: Maybe<TownsquareCommentContainer>;
    creator?: Maybe<User>;
    id: Scalars["ID"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
    uuid?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareCommentConnection = {
    __typename?: "TownsquareCommentConnection";
    edges?: Maybe<Array<Maybe<TownsquareCommentEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareCommentContainer = TownsquareGoal | TownsquareProject;

export type TownsquareCommentEdge = {
    __typename?: "TownsquareCommentEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareComment>;
};

export type TownsquareCreateGoalInput = {
    /** Site ARI in the form of `ari:cloud:townsquare::site/{siteId}` */
    containerId: Scalars["String"]["input"];
    goalTypeAri?: InputMaybe<Scalars["String"]["input"]>;
    name: Scalars["String"]["input"];
    owner?: InputMaybe<Scalars["String"]["input"]>;
    parentGoalAri?: InputMaybe<Scalars["String"]["input"]>;
    targetDate?: InputMaybe<TownsquareTargetDateInput>;
};

export type TownsquareCreateGoalPayload = {
    __typename?: "TownsquareCreateGoalPayload";
    goal?: Maybe<TownsquareGoal>;
};

export type TownsquareCreateGoalTypeInput = {
    containerId: Scalars["String"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    iconKey?: InputMaybe<TownsquareGoalIconKey>;
    name: Scalars["String"]["input"];
    state?: InputMaybe<TownsquareGoalTypeState>;
};

export type TownsquareCreateGoalTypePayload = {
    __typename?: "TownsquareCreateGoalTypePayload";
    goalTypeEdge?: Maybe<TownsquareGoalTypeEdge>;
};

export type TownsquareCreateRelationshipsInput = {
    relationships: Array<TownsquareRelationshipInput>;
};

export type TownsquareCreateRelationshipsMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "TownsquareCreateRelationshipsMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        relationship: TownsquareRelationship;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type TownsquareCreateRelationshipsPayload = {
    __typename?: "TownsquareCreateRelationshipsPayload";
    errors?: Maybe<Array<MutationError>>;
    relationships?: Maybe<Array<TownsquareRelationship>>;
    success: Scalars["Boolean"]["output"];
};

export type TownsquareDeleteRelationshipsInput = {
    relationships: Array<TownsquareRelationshipInput>;
};

export type TownsquareDeleteRelationshipsMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "TownsquareDeleteRelationshipsMutationErrorExtension";
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        relationship: TownsquareRelationship;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ✅ Yes |
         * | THIRD_PARTY_OAUTH | ✅ Yes |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type TownsquareDeleteRelationshipsPayload = {
    __typename?: "TownsquareDeleteRelationshipsPayload";
    errors?: Maybe<Array<MutationError>>;
    relationships?: Maybe<Array<TownsquareRelationship>>;
    success: Scalars["Boolean"]["output"];
};

export type TownsquareEditGoalInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["String"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    owner?: InputMaybe<Scalars["String"]["input"]>;
    targetDate?: InputMaybe<TownsquareTargetDateInput>;
};

export type TownsquareEditGoalPayload = {
    __typename?: "TownsquareEditGoalPayload";
    goal?: Maybe<TownsquareGoal>;
};

export type TownsquareEditGoalTypeInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    goalTypeAri: Scalars["String"]["input"];
    iconKey?: InputMaybe<TownsquareGoalIconKey>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<TownsquareGoalTypeState>;
};

export type TownsquareEditGoalTypePayload = {
    __typename?: "TownsquareEditGoalTypePayload";
    goalType?: Maybe<TownsquareGoalType>;
};

export type TownsquareGoal = Node & {
    __typename?: "TownsquareGoal";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use isArchived instead
     */
    archived: Scalars["Boolean"]["output"];
    creationDate: Scalars["DateTime"]["output"];
    description?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use targetDate instead
     */
    dueDate?: Maybe<TownsquareTargetDate>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'goalType' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    goalType?: Maybe<TownsquareGoalType>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'icon' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    icon?: Maybe<TownsquareGoalIcon>;
    iconData?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    isArchived: Scalars["Boolean"]["output"];
    isWatching?: Maybe<Scalars["Boolean"]["output"]>;
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    owner?: Maybe<User>;
    parentGoal?: Maybe<TownsquareGoal>;
    parentGoalSuggestions?: Maybe<TownsquareGoalConnection>;
    risks?: Maybe<TownsquareRiskConnection>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use status instead
     */
    state?: Maybe<TownsquareGoalState>;
    status?: Maybe<TownsquareStatus>;
    subGoalSuggestions?: Maybe<TownsquareGoalConnection>;
    subGoals?: Maybe<TownsquareGoalConnection>;
    tags?: Maybe<TownsquareTagConnection>;
    targetDate?: Maybe<TownsquareTargetDate>;
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'updates' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updates?: Maybe<TownsquareGoalUpdateConnection>;
    url?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated Use id (ari) instead
     */
    uuid: Scalars["String"]["output"];
    watchers?: Maybe<TownsquareUserConnection>;
};

export type TownsquareGoalParentGoalSuggestionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type TownsquareGoalRisksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
    createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    noUpdateAttached?: InputMaybe<Scalars["Boolean"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<TownsquareRiskSortEnum>>>;
};

export type TownsquareGoalSubGoalSuggestionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
};

export type TownsquareGoalSubGoalsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareGoalTagsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareGoalUpdatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareGoalConnection = {
    __typename?: "TownsquareGoalConnection";
    edges?: Maybe<Array<Maybe<TownsquareGoalEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareGoalEdge = {
    __typename?: "TownsquareGoalEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareGoal>;
};

export type TownsquareGoalIcon = {
    __typename?: "TownsquareGoalIcon";
    appearance?: Maybe<TownsquareGoalIconAppearance>;
    key?: Maybe<TownsquareGoalIconKey>;
};

export enum TownsquareGoalIconAppearance {
    AtRisk = "AT_RISK",
    Default = "DEFAULT",
    OffTrack = "OFF_TRACK",
    OnTrack = "ON_TRACK"
}

export enum TownsquareGoalIconKey {
    Goal = "GOAL",
    KeyResult = "KEY_RESULT",
    Objective = "OBJECTIVE"
}

export enum TownsquareGoalSortEnum {
    CreationDateAsc = "CREATION_DATE_ASC",
    CreationDateDesc = "CREATION_DATE_DESC",
    HierarchyAsc = "HIERARCHY_ASC",
    HierarchyDesc = "HIERARCHY_DESC",
    HierarchyLevelAsc = "HIERARCHY_LEVEL_ASC",
    HierarchyLevelDesc = "HIERARCHY_LEVEL_DESC",
    IdAsc = "ID_ASC",
    IdDesc = "ID_DESC",
    LatestUpdateDateAsc = "LATEST_UPDATE_DATE_ASC",
    LatestUpdateDateDesc = "LATEST_UPDATE_DATE_DESC",
    NameAsc = "NAME_ASC",
    NameDesc = "NAME_DESC",
    ProjectCountAsc = "PROJECT_COUNT_ASC",
    ProjectCountDesc = "PROJECT_COUNT_DESC",
    ScoreAsc = "SCORE_ASC",
    ScoreDesc = "SCORE_DESC",
    TargetDateAsc = "TARGET_DATE_ASC",
    TargetDateDesc = "TARGET_DATE_DESC",
    WatchingAsc = "WATCHING_ASC",
    WatchingDesc = "WATCHING_DESC"
}

export type TownsquareGoalState = {
    __typename?: "TownsquareGoalState";
    label?: Maybe<Scalars["String"]["output"]>;
    score?: Maybe<Scalars["Float"]["output"]>;
    value?: Maybe<TownsquareGoalStateValue>;
};

export enum TownsquareGoalStateValue {
    Archived = "archived",
    AtRisk = "at_risk",
    Cancelled = "cancelled",
    Done = "done",
    OffTrack = "off_track",
    OnTrack = "on_track",
    Paused = "paused",
    Pending = "pending"
}

export type TownsquareGoalType = Node & {
    __typename?: "TownsquareGoalType";
    allowedChildTypes?: Maybe<TownsquareGoalTypeConnection>;
    allowedParentTypes?: Maybe<TownsquareGoalTypeConnection>;
    description?: Maybe<TownsquareGoalTypeDescription>;
    icon?: Maybe<TownsquareGoalTypeIcon>;
    id: Scalars["ID"]["output"];
    name?: Maybe<TownsquareGoalTypeName>;
    requiresParentGoal?: Maybe<Scalars["Boolean"]["output"]>;
    state?: Maybe<TownsquareGoalTypeState>;
};

export type TownsquareGoalTypeAllowedChildTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TownsquareGoalTypeAllowedParentTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TownsquareGoalTypeConnection = {
    __typename?: "TownsquareGoalTypeConnection";
    edges?: Maybe<Array<Maybe<TownsquareGoalTypeEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareGoalTypeCustomDescription = {
    __typename?: "TownsquareGoalTypeCustomDescription";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareGoalTypeCustomName = {
    __typename?: "TownsquareGoalTypeCustomName";
    value?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareGoalTypeDescription =
    | TownsquareGoalTypeCustomDescription
    | TownsquareLocalizationField;

export type TownsquareGoalTypeEdge = {
    __typename?: "TownsquareGoalTypeEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareGoalType>;
};

export type TownsquareGoalTypeIcon = {
    __typename?: "TownsquareGoalTypeIcon";
    key?: Maybe<TownsquareGoalIconKey>;
};

export type TownsquareGoalTypeName =
    | TownsquareGoalTypeCustomName
    | TownsquareLocalizationField;

export enum TownsquareGoalTypeState {
    Disabled = "DISABLED",
    Enabled = "ENABLED"
}

export type TownsquareGoalUpdate = Node & {
    __typename?: "TownsquareGoalUpdate";
    ari: Scalars["String"]["output"];
    comments?: Maybe<TownsquareCommentConnection>;
    creationDate?: Maybe<Scalars["DateTime"]["output"]>;
    creator?: Maybe<User>;
    editDate?: Maybe<Scalars["DateTime"]["output"]>;
    goal?: Maybe<TownsquareGoal>;
    /** Please use ari instead of id. This id is an internal format and cannot be used by mutations */
    id: Scalars["ID"]["output"];
    lastEditedBy?: Maybe<User>;
    missedUpdate: Scalars["Boolean"]["output"];
    newDueDate?: Maybe<TownsquareTargetDate>;
    newScore: Scalars["Int"]["output"];
    newState?: Maybe<TownsquareGoalState>;
    newTargetDate?: Maybe<Scalars["Date"]["output"]>;
    newTargetDateConfidence: Scalars["Int"]["output"];
    oldDueDate?: Maybe<TownsquareTargetDate>;
    oldScore?: Maybe<Scalars["Int"]["output"]>;
    oldState?: Maybe<TownsquareGoalState>;
    oldTargetDate?: Maybe<Scalars["Date"]["output"]>;
    oldTargetDateConfidence?: Maybe<Scalars["Int"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    updateType?: Maybe<TownsquareUpdateType>;
    url?: Maybe<Scalars["String"]["output"]>;
    uuid?: Maybe<Scalars["UUID"]["output"]>;
};

export type TownsquareGoalUpdateCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareGoalUpdateConnection = {
    __typename?: "TownsquareGoalUpdateConnection";
    edges?: Maybe<Array<Maybe<TownsquareGoalUpdateEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareGoalUpdateEdge = {
    __typename?: "TownsquareGoalUpdateEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareGoalUpdate>;
};

export type TownsquareHighlight = {
    creationDate?: Maybe<Scalars["DateTime"]["output"]>;
    creator?: Maybe<User>;
    description?: Maybe<Scalars["String"]["output"]>;
    goal?: Maybe<TownsquareGoal>;
    id: Scalars["ID"]["output"];
    lastEditedBy?: Maybe<User>;
    lastEditedDate?: Maybe<Scalars["DateTime"]["output"]>;
    project?: Maybe<TownsquareProject>;
    summary?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareLocalizationField = {
    __typename?: "TownsquareLocalizationField";
    defaultValue?: Maybe<Scalars["String"]["output"]>;
    messageId?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareMercuryProjectStatusDto = MercuryProjectStatus & {
    __typename?: "TownsquareMercuryProjectStatusDto";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    mercuryColor?: Maybe<MercuryProjectStatusColor>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    mercuryName?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareMutationApi = {
    __typename?: "TownsquareMutationApi";
    /**
     * Archive a goal in Townsquare.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:goal:townsquare__
     *
     *
     */
    archiveGoal?: Maybe<TownsquareArchiveGoalPayload>;
    /**
     * Create a goal in Townsquare.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:goal:townsquare__
     *
     *
     */
    createGoal?: Maybe<TownsquareCreateGoalPayload>;
    /**
     * Create a goal type in Townsquare.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:goal:townsquare__
     *
     *
     */
    createGoalType?: Maybe<TownsquareCreateGoalTypePayload>;
    /**
     * Connect an entity in Townsquare to something in another product. This API is backed by the ARI Graph store. You can retrieve relationships with queries under the `graphStore` namespace. You can create at most 50 relationships per request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:relationship:townsquare__
     *
     *
     */
    createRelationships?: Maybe<TownsquareCreateRelationshipsPayload>;
    /**
     * Disconnect an entity in Townsquare to something in another product. This API is backed by the ARI Graph store. You can delete at most 50 relationships per request.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:relationship:townsquare__
     *
     *
     */
    deleteRelationships?: Maybe<TownsquareDeleteRelationshipsPayload>;
    /**
     * Edit a goal in Townsquare.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:goal:townsquare__
     *
     *
     */
    editGoal?: Maybe<TownsquareEditGoalPayload>;
    /**
     * Edit a goal type in Townsquare
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'editGoalType' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editGoalType?: Maybe<TownsquareEditGoalTypePayload>;
    /**
     * Set a Parent Goal for a Goal. If Parent Goal is null, then unset the Parent for a Goal.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:relationship:townsquare__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'setParentGoal' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    setParentGoal?: Maybe<TownsquareSetParentGoalPayload>;
    /**
     * Unarchive a goal in Townsquare.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __write:goal:townsquare__
     *
     *
     */
    unarchiveGoal?: Maybe<TownsquareArchiveGoalPayload>;
    /**
     * Watch a goal in Townsquare.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     */
    watchGoal?: Maybe<TownsquareWatchGoalPayload>;
};

export type TownsquareMutationApiArchiveGoalArgs = {
    input: TownsquareArchiveGoalInput;
};

export type TownsquareMutationApiCreateGoalArgs = {
    input: TownsquareCreateGoalInput;
};

export type TownsquareMutationApiCreateGoalTypeArgs = {
    input: TownsquareCreateGoalTypeInput;
};

export type TownsquareMutationApiCreateRelationshipsArgs = {
    input: TownsquareCreateRelationshipsInput;
};

export type TownsquareMutationApiDeleteRelationshipsArgs = {
    input: TownsquareDeleteRelationshipsInput;
};

export type TownsquareMutationApiEditGoalArgs = {
    input: TownsquareEditGoalInput;
};

export type TownsquareMutationApiEditGoalTypeArgs = {
    input: TownsquareEditGoalTypeInput;
};

export type TownsquareMutationApiSetParentGoalArgs = {
    input?: InputMaybe<TownsquareSetParentGoalInput>;
};

export type TownsquareMutationApiUnarchiveGoalArgs = {
    input: TownsquareArchiveGoalInput;
};

export type TownsquareMutationApiWatchGoalArgs = {
    input: TownsquareWatchGoalInput;
};

export type TownsquareProject = HasMercuryProjectFields &
    Node & {
        __typename?: "TownsquareProject";
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Use isArchived instead
         */
        archived: Scalars["Boolean"]["output"];
        description?: Maybe<TownsquareProjectDescription>;
        dueDate?: Maybe<TownsquareTargetDate>;
        iconData?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        isArchived: Scalars["Boolean"]["output"];
        isPrivate: Scalars["Boolean"]["output"];
        key: Scalars["String"]["output"];
        mercuryProjectIcon?: Maybe<Scalars["URL"]["output"]>;
        mercuryProjectKey?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectName?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectOwner?: Maybe<User>;
        mercuryProjectProviderName?: Maybe<Scalars["String"]["output"]>;
        mercuryProjectStatus?: Maybe<MercuryProjectStatus>;
        mercuryProjectUrl?: Maybe<Scalars["URL"]["output"]>;
        /**
         *
         *
         *
         * This field is **deprecated** and will be removed in the future
         *
         *
         * @deprecated Use mercuryTargetDateStart and mercuryTargetDateEnd instead
         */
        mercuryTargetDate?: Maybe<Scalars["String"]["output"]>;
        mercuryTargetDateEnd?: Maybe<Scalars["DateTime"]["output"]>;
        mercuryTargetDateStart?: Maybe<Scalars["DateTime"]["output"]>;
        mercuryTargetDateType?: Maybe<MercuryProjectTargetDateType>;
        name: Scalars["String"]["output"];
        owner?: Maybe<User>;
        risks?: Maybe<TownsquareRiskConnection>;
        startDate?: Maybe<Scalars["DateTime"]["output"]>;
        state?: Maybe<TownsquareProjectState>;
        tags?: Maybe<TownsquareTagConnection>;
        /**
         *
         *
         * ### Field lifecycle
         *
         * This field is in the 'EXPERIMENTAL' lifecycle stage
         *
         * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'updates' field, or to any of its parents.
         *
         * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
         *
         */
        updates?: Maybe<TownsquareProjectUpdateConnection>;
        url?: Maybe<Scalars["String"]["output"]>;
        uuid: Scalars["String"]["output"];
    };

export type TownsquareProjectRisksArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    createdAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
    createdBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    isResolved?: InputMaybe<Scalars["Boolean"]["input"]>;
    noUpdateAttached?: InputMaybe<Scalars["Boolean"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<TownsquareRiskSortEnum>>>;
};

export type TownsquareProjectTagsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareProjectUpdatesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    createdAtOrAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
    createdAtOrBefore?: InputMaybe<Scalars["DateTime"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareProjectConnection = {
    __typename?: "TownsquareProjectConnection";
    edges?: Maybe<Array<Maybe<TownsquareProjectEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareProjectDescription = {
    __typename?: "TownsquareProjectDescription";
    measurement?: Maybe<Scalars["String"]["output"]>;
    what?: Maybe<Scalars["String"]["output"]>;
    why?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareProjectEdge = {
    __typename?: "TownsquareProjectEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareProject>;
};

export enum TownsquareProjectPhase {
    Done = "done",
    InProgress = "in_progress",
    Paused = "paused",
    Pending = "pending"
}

export type TownsquareProjectPhaseDetails = {
    __typename?: "TownsquareProjectPhaseDetails";
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["Int"]["output"];
    name?: Maybe<TownsquareProjectPhase>;
};

export enum TownsquareProjectSortEnum {
    CreationDateAsc = "CREATION_DATE_ASC",
    CreationDateDesc = "CREATION_DATE_DESC",
    IdAsc = "ID_ASC",
    IdDesc = "ID_DESC",
    LatestUpdateDateAsc = "LATEST_UPDATE_DATE_ASC",
    LatestUpdateDateDesc = "LATEST_UPDATE_DATE_DESC",
    NameAsc = "NAME_ASC",
    NameDesc = "NAME_DESC",
    StartDateAsc = "START_DATE_ASC",
    StartDateDesc = "START_DATE_DESC",
    StatusAsc = "STATUS_ASC",
    StatusDesc = "STATUS_DESC",
    TargetDateAsc = "TARGET_DATE_ASC",
    TargetDateDesc = "TARGET_DATE_DESC",
    WatchingAsc = "WATCHING_ASC",
    WatchingDesc = "WATCHING_DESC"
}

export type TownsquareProjectState = {
    __typename?: "TownsquareProjectState";
    label?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<TownsquareProjectStateValue>;
};

export enum TownsquareProjectStateValue {
    Archived = "archived",
    AtRisk = "at_risk",
    Cancelled = "cancelled",
    Done = "done",
    OffTrack = "off_track",
    OnTrack = "on_track",
    Paused = "paused",
    Pending = "pending"
}

export type TownsquareProjectUpdate = Node & {
    __typename?: "TownsquareProjectUpdate";
    ari: Scalars["String"]["output"];
    comments?: Maybe<TownsquareCommentConnection>;
    creationDate?: Maybe<Scalars["DateTime"]["output"]>;
    creator?: Maybe<User>;
    editDate?: Maybe<Scalars["DateTime"]["output"]>;
    /** Please use ari instead of id. This id is an internal format and cannot be used by mutations */
    id: Scalars["ID"]["output"];
    lastEditedBy?: Maybe<User>;
    missedUpdate: Scalars["Boolean"]["output"];
    newDueDate?: Maybe<TownsquareTargetDate>;
    newPhase?: Maybe<TownsquareProjectPhaseDetails>;
    newPhaseNew?: Maybe<TownsquareProjectPhaseDetails>;
    newState?: Maybe<TownsquareProjectState>;
    newTargetDate?: Maybe<Scalars["Date"]["output"]>;
    newTargetDateConfidence: Scalars["Int"]["output"];
    oldDueDate?: Maybe<TownsquareTargetDate>;
    oldPhase?: Maybe<TownsquareProjectPhaseDetails>;
    oldPhaseNew?: Maybe<TownsquareProjectPhaseDetails>;
    oldState?: Maybe<TownsquareProjectState>;
    oldTargetDate?: Maybe<Scalars["Date"]["output"]>;
    oldTargetDateConfidence?: Maybe<Scalars["Int"]["output"]>;
    project?: Maybe<TownsquareProject>;
    summary?: Maybe<Scalars["String"]["output"]>;
    updateType?: Maybe<TownsquareUpdateType>;
    url?: Maybe<Scalars["String"]["output"]>;
    uuid?: Maybe<Scalars["UUID"]["output"]>;
};

export type TownsquareProjectUpdateCommentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareProjectUpdateConnection = {
    __typename?: "TownsquareProjectUpdateConnection";
    count: Scalars["Int"]["output"];
    edges?: Maybe<Array<Maybe<TownsquareProjectUpdateEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareProjectUpdateEdge = {
    __typename?: "TownsquareProjectUpdateEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareProjectUpdate>;
};

export type TownsquareQueryApi = {
    __typename?: "TownsquareQueryApi";
    /**
     * Get all Atlas workspaces belonging to the same organisation
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:workspace:townsquare__
     *
     *
     */
    allWorkspaceSummariesForOrg?: Maybe<TownsquareWorkspaceSummaryConnection>;
    /**
     * Get all Atlas workspaces belonging to the same organisation
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:workspace:townsquare__
     *
     *
     * @deprecated Use allWorkspaceSummariesForOrg instead. This query is not multi-region compatible and will only return workspaces from a single shard
     */
    allWorkspacesForOrg?: Maybe<TownsquareWorkspaceConnection>;
    /**
     * Get comments by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:comment:townsquare__
     *
     *
     */
    commentsByAri?: Maybe<Array<Maybe<TownsquareComment>>>;
    /**
     * Get goal by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     */
    goal?: Maybe<TownsquareGoal>;
    /**
     * Search for goals.  (deprecated, use goalTql)
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: Townsquare` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     * @deprecated Use goalTql instead
     */
    goalSearch?: Maybe<TownsquareGoalConnection>;
    /**
     * Search for goals.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     */
    goalTql?: Maybe<TownsquareGoalConnection>;
    /**
     * Search for goals with full hierarchy. @deprecated(reason: "Use goalTql instead")
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'goalTqlFullHierarchy' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Use goalTql instead
     */
    goalTqlFullHierarchy?: Maybe<TownsquareGoalConnection>;
    /**
     * Get Goal Types for a workspace.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### The field is not available for OAuth authenticated requests
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "Townsquare")' query directive to the 'goalTypes' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    goalTypes?: Maybe<TownsquareGoalTypeConnection>;
    /**
     * Search for goal types
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     */
    goalTypesByAri?: Maybe<Array<Maybe<TownsquareGoalType>>>;
    /**
     * Get goal updates by ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     */
    goalUpdatesByAris?: Maybe<Array<Maybe<TownsquareGoalUpdate>>>;
    /**
     * Get goals by ARI.
     *
     * Limit queries to 200 goals per request. Requests exceeding this will fail in the future.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:goal:townsquare__
     *
     *
     */
    goalsByAri?: Maybe<Array<Maybe<TownsquareGoal>>>;
    /**
     * Get project by ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:project:townsquare__
     *
     *
     */
    project?: Maybe<TownsquareProject>;
    /**
     * Search for projects. (deprecated, use projectTql)
     *
     * ### Beta Field
     *
     * This field is currently in a beta phase and may change without notice.
     *
     * To use this field you must set a `X-ExperimentalApi: Townsquare` HTTP header.
     *
     * Use of this header indicates that they are opting into the experimental preview of this field.
     *
     * If you do not set this header then the request will be rejected outright.
     *
     * Once the field moves out of the beta phase, then the header will no longer be required or checked.
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:project:townsquare__
     *
     *
     * @deprecated Use projectTql instead
     */
    projectSearch?: Maybe<TownsquareProjectConnection>;
    /**
     * Search for projects.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:project:townsquare__
     *
     *
     */
    projectTql?: Maybe<TownsquareProjectConnection>;
    /**
     * Get project updates by ARIs.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:project:townsquare__
     *
     *
     */
    projectUpdatesByAris?: Maybe<Array<Maybe<TownsquareProjectUpdate>>>;
    /**
     * Get projects by ARI.
     *
     * Limit queries to 200 projects per request. Requests exceeding this will fail in the future.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:project:townsquare__
     *
     *
     */
    projectsByAri?: Maybe<Array<Maybe<TownsquareProject>>>;
    /**
     * Get tags by ARI.
     *
     * Limit queries to 200 goals per request. Requests exceeding this will fail in the future.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### The field is not available for OAuth authenticated requests
     *
     *
     */
    tagsByAri?: Maybe<Array<Maybe<TownsquareTag>>>;
};

export type TownsquareQueryApiAllWorkspaceSummariesForOrgArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type TownsquareQueryApiAllWorkspacesForOrgArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    organisationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type TownsquareQueryApiCommentsByAriArgs = {
    aris?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TownsquareQueryApiGoalArgs = {
    ari: Scalars["String"]["input"];
};

export type TownsquareQueryApiGoalSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<TownsquareGoalSortEnum>>>;
};

export type TownsquareQueryApiGoalTqlArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    containerId?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q: Scalars["String"]["input"];
    sort?: InputMaybe<Array<InputMaybe<TownsquareGoalSortEnum>>>;
};

export type TownsquareQueryApiGoalTqlFullHierarchyArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    childrenOf?: InputMaybe<Scalars["String"]["input"]>;
    containerId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sorts?: InputMaybe<Array<InputMaybe<TownsquareGoalSortEnum>>>;
};

export type TownsquareQueryApiGoalTypesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    containerId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    includeDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TownsquareQueryApiGoalTypesByAriArgs = {
    aris: Array<Scalars["String"]["input"]>;
};

export type TownsquareQueryApiGoalUpdatesByArisArgs = {
    aris: Array<Scalars["ID"]["input"]>;
};

export type TownsquareQueryApiGoalsByAriArgs = {
    aris?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TownsquareQueryApiProjectArgs = {
    ari: Scalars["String"]["input"];
};

export type TownsquareQueryApiProjectSearchArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["String"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    phase?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    q?: InputMaybe<Scalars["String"]["input"]>;
    sort?: InputMaybe<Array<InputMaybe<TownsquareProjectSortEnum>>>;
};

export type TownsquareQueryApiProjectTqlArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId?: InputMaybe<Scalars["String"]["input"]>;
    containerId?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    q: Scalars["String"]["input"];
    sort?: InputMaybe<Array<InputMaybe<TownsquareProjectSortEnum>>>;
};

export type TownsquareQueryApiProjectUpdatesByArisArgs = {
    aris: Array<Scalars["ID"]["input"]>;
};

export type TownsquareQueryApiProjectsByAriArgs = {
    aris?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TownsquareQueryApiTagsByAriArgs = {
    aris?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/**
 * These are the currently supported relationships. The relationships are directional in the ARI Graph Store, so the order of "from" and "to" does matter.
 *
 *
 * | From           |   | To         |
 * |----------------|---|------------|
 * | Atlas Project  | → | Jira Issue |
 * | Jira Issue     | → | Atlas Goal |
 */
export type TownsquareRelationship = {
    __typename?: "TownsquareRelationship";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    from: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    to: Scalars["String"]["output"];
};

/**
 * These are the currently supported relationships. The relationships are directional in the ARI Graph Store, so the order of "from" and "to" does matter.
 *
 *
 * | From           |   | To         |
 * |----------------|---|------------|
 * | Atlas Project  | → | Jira Issue |
 * | Jira Issue     | → | Atlas Goal |
 */
export type TownsquareRelationshipInput = {
    from: Scalars["String"]["input"];
    to: Scalars["String"]["input"];
};

export type TownsquareRisk = TownsquareHighlight & {
    __typename?: "TownsquareRisk";
    creationDate?: Maybe<Scalars["DateTime"]["output"]>;
    creator?: Maybe<User>;
    description?: Maybe<Scalars["String"]["output"]>;
    goal?: Maybe<TownsquareGoal>;
    id: Scalars["ID"]["output"];
    lastEditedBy?: Maybe<User>;
    lastEditedDate?: Maybe<Scalars["DateTime"]["output"]>;
    project?: Maybe<TownsquareProject>;
    resolvedDate?: Maybe<Scalars["DateTime"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareRiskConnection = {
    __typename?: "TownsquareRiskConnection";
    count: Scalars["Int"]["output"];
    /** a list of edges */
    edges?: Maybe<Array<Maybe<TownsquareRiskEdge>>>;
    /** details about this specific page */
    pageInfo: PageInfo;
};

export type TownsquareRiskEdge = {
    __typename?: "TownsquareRiskEdge";
    /** cursor marks a unique position or index into the connection */
    cursor: Scalars["String"]["output"];
    /** The item at the end of the edge */
    node?: Maybe<TownsquareRisk>;
};

export enum TownsquareRiskSortEnum {
    CreationDateAsc = "CREATION_DATE_ASC",
    CreationDateDesc = "CREATION_DATE_DESC",
    IdAsc = "ID_ASC",
    IdDesc = "ID_DESC",
    SummaryAsc = "SUMMARY_ASC",
    SummaryDesc = "SUMMARY_DESC"
}

export type TownsquareSetParentGoalInput = {
    goalAri: Scalars["String"]["input"];
    parentGoalAri?: InputMaybe<Scalars["String"]["input"]>;
};

export type TownsquareSetParentGoalPayload = {
    __typename?: "TownsquareSetParentGoalPayload";
    goal?: Maybe<TownsquareGoal>;
    parentGoal?: Maybe<TownsquareGoal>;
};

export type TownsquareStatus = {
    __typename?: "TownsquareStatus";
    localizedLabel?: Maybe<TownsquareLocalizationField>;
    score?: Maybe<Scalars["Float"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareTag = Node & {
    __typename?: "TownsquareTag";
    creationDate?: Maybe<Scalars["DateTime"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    iconData?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareTagConnection = {
    __typename?: "TownsquareTagConnection";
    count: Scalars["Int"]["output"];
    /** a list of edges */
    edges?: Maybe<Array<Maybe<TownsquareTagEdge>>>;
    /** details about this specific page */
    pageInfo: PageInfo;
};

/** An edge in a connection */
export type TownsquareTagEdge = {
    __typename?: "TownsquareTagEdge";
    /** cursor marks a unique position or index into the connection */
    cursor: Scalars["String"]["output"];
    /** The item at the end of the edge */
    node?: Maybe<TownsquareTag>;
};

export type TownsquareTargetDate = {
    __typename?: "TownsquareTargetDate";
    confidence?: Maybe<TownsquareTargetDateType>;
    dateRange?: Maybe<TownsquareTargetDateRange>;
    label?: Maybe<Scalars["String"]["output"]>;
};

export type TownsquareTargetDateInput = {
    confidence?: InputMaybe<TownsquareTargetDateType>;
    date?: InputMaybe<Scalars["Date"]["input"]>;
};

export type TownsquareTargetDateRange = {
    __typename?: "TownsquareTargetDateRange";
    end?: Maybe<Scalars["DateTime"]["output"]>;
    start?: Maybe<Scalars["DateTime"]["output"]>;
};

export enum TownsquareTargetDateType {
    Day = "DAY",
    Month = "MONTH",
    Quarter = "QUARTER"
}

export type TownsquareTeam = Node & {
    __typename?: "TownsquareTeam";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
};

export enum TownsquareUnshardedAccessControlCapability {
    Access = "ACCESS",
    Administer = "ADMINISTER",
    Create = "CREATE"
}

export type TownsquareUnshardedCapability = {
    __typename?: "TownsquareUnshardedCapability";
    capability?: Maybe<TownsquareUnshardedAccessControlCapability>;
    capabilityContainer?: Maybe<TownsquareUnshardedCapabilityContainer>;
};

export enum TownsquareUnshardedCapabilityContainer {
    GoalsApp = "GOALS_APP",
    ProjectsApp = "PROJECTS_APP"
}

export type TownsquareUnshardedUserCapabilities = {
    __typename?: "TownsquareUnshardedUserCapabilities";
    capabilities?: Maybe<Array<Maybe<TownsquareUnshardedCapability>>>;
};

export type TownsquareUnshardedWorkspaceSummary = {
    __typename?: "TownsquareUnshardedWorkspaceSummary";
    cloudId: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    userCapabilities?: Maybe<TownsquareUnshardedUserCapabilities>;
    uuid: Scalars["String"]["output"];
};

export type TownsquareUnshardedWorkspaceSummaryConnection = {
    __typename?: "TownsquareUnshardedWorkspaceSummaryConnection";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    edges?: Maybe<Array<Maybe<TownsquareUnshardedWorkspaceSummaryEdge>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pageInfo: PageInfo;
};

export type TownsquareUnshardedWorkspaceSummaryEdge = {
    __typename?: "TownsquareUnshardedWorkspaceSummaryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareUnshardedWorkspaceSummary>;
};

export enum TownsquareUpdateType {
    System = "SYSTEM",
    User = "USER"
}

export type TownsquareUserCapabilities = {
    __typename?: "TownsquareUserCapabilities";
    capabilities?: Maybe<Array<Maybe<TownsquareCapability>>>;
};

export type TownsquareUserConnection = {
    __typename?: "TownsquareUserConnection";
    count: Scalars["Int"]["output"];
};

export type TownsquareWatchGoalInput = {
    ari: Scalars["String"]["input"];
};

export type TownsquareWatchGoalPayload = {
    __typename?: "TownsquareWatchGoalPayload";
    goal?: Maybe<TownsquareGoal>;
};

export type TownsquareWorkspace = Node & {
    __typename?: "TownsquareWorkspace";
    cloudId: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
};

export type TownsquareWorkspaceConnection = {
    __typename?: "TownsquareWorkspaceConnection";
    edges?: Maybe<Array<Maybe<TownsquareWorkspaceEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareWorkspaceEdge = {
    __typename?: "TownsquareWorkspaceEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareWorkspace>;
};

export type TownsquareWorkspaceSummary = {
    __typename?: "TownsquareWorkspaceSummary";
    cloudId: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    userCapabilities?: Maybe<TownsquareUserCapabilities>;
    uuid: Scalars["String"]["output"];
};

export type TownsquareWorkspaceSummaryConnection = {
    __typename?: "TownsquareWorkspaceSummaryConnection";
    edges?: Maybe<Array<Maybe<TownsquareWorkspaceSummaryEdge>>>;
    pageInfo: PageInfo;
};

export type TownsquareWorkspaceSummaryEdge = {
    __typename?: "TownsquareWorkspaceSummaryEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TownsquareWorkspaceSummary>;
};

/** Start and end time of this request on the server */
export type TraceTiming = {
    __typename?: "TraceTiming";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    end?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    start?: Maybe<Scalars["String"]["output"]>;
};

export type TransitionFilter = {
    from: Scalars["String"]["input"];
    to: Scalars["String"]["input"];
};

/**
 * Actions are generated whenever an action occurs in Trello. For instance, when a user deletes a card, a
 * `deleteCard` action is generated and includes information about the deleted card.
 */
export type TrelloAction = {
    /** The app that caused the Action */
    appCreator?: Maybe<TrelloAppCreator>;
    /** The Member who caused the Action */
    creator?: Maybe<TrelloMember>;
    /** When the Action occurred */
    date?: Maybe<Scalars["DateTime"]["output"]>;
    /** Relevant information for displaying the Action */
    displayKey?: Maybe<Scalars["String"]["output"]>;
    /** The ID of the Action */
    id: Scalars["ID"]["output"];
    /** Any limits affected by the action */
    limits?: Maybe<TrelloActionLimits>;
    /** The Reactions on the Action */
    reactions?: Maybe<Array<TrelloReaction>>;
    /** The type of the Action, from Trello Server.  May not match action __typename */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Attachment Entity */
export type TrelloActionAttachmentEntity = {
    __typename?: "TrelloActionAttachmentEntity";
    id?: Maybe<Scalars["ID"]["output"]>;
    link?: Maybe<Scalars["Boolean"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    previewUrl?: Maybe<Scalars["String"]["output"]>;
    previewUrl2x?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
};

/** Attachment Preview Entity */
export type TrelloActionAttachmentPreviewEntity = {
    __typename?: "TrelloActionAttachmentPreviewEntity";
    id?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    originalUrl?: Maybe<Scalars["URL"]["output"]>;
    previewUrl?: Maybe<Scalars["URL"]["output"]>;
    previewUrl2x?: Maybe<Scalars["URL"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Card Entity */
export type TrelloActionCardEntity = {
    __typename?: "TrelloActionCardEntity";
    closed?: Maybe<Scalars["Boolean"]["output"]>;
    creationMethod?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    due?: Maybe<Scalars["DateTime"]["output"]>;
    dueComplete?: Maybe<Scalars["Boolean"]["output"]>;
    hideIfContext?: Maybe<Scalars["Boolean"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    listId?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    position?: Maybe<Scalars["Float"]["output"]>;
    shortId?: Maybe<Scalars["Int"]["output"]>;
    shortLink?: Maybe<Scalars["TrelloShortLink"]["output"]>;
    start?: Maybe<Scalars["DateTime"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Checklist Entity */
export type TrelloActionChecklistEntity = {
    __typename?: "TrelloActionChecklistEntity";
    creationMethod?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Comment Entity */
export type TrelloActionCommentEntity = {
    __typename?: "TrelloActionCommentEntity";
    text?: Maybe<Scalars["String"]["output"]>;
    textHtml?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Limit information that comes with actions */
export type TrelloActionLimits = {
    __typename?: "TrelloActionLimits";
    reactions?: Maybe<TrelloReactionLimits>;
};

/** List Entity */
export type TrelloActionListEntity = {
    __typename?: "TrelloActionListEntity";
    id?: Maybe<Scalars["ID"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Member Entity */
export type TrelloActionMemberEntity = {
    __typename?: "TrelloActionMemberEntity";
    avatarHash?: Maybe<Scalars["String"]["output"]>;
    avatarUrl?: Maybe<Scalars["URL"]["output"]>;
    fullName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    initials?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    username?: Maybe<Scalars["String"]["output"]>;
};

/** Translatable Entity */
export type TrelloActionTranslatableEntity = {
    __typename?: "TrelloActionTranslatableEntity";
    contextId?: Maybe<Scalars["String"]["output"]>;
    hideIfContext?: Maybe<Scalars["Boolean"]["output"]>;
    translationKey?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Action triggered by adding an attachment to a card */
export type TrelloAddAttachmentToCardAction = TrelloAction &
    TrelloCardActionData & {
        __typename?: "TrelloAddAttachmentToCardAction";
        /** The app that caused the Action */
        appCreator?: Maybe<TrelloAppCreator>;
        /** The attachment added to the card */
        attachment?: Maybe<TrelloAttachment>;
        /** The card's board */
        board?: Maybe<TrelloBoard>;
        /** The card the action took place on */
        card?: Maybe<TrelloCard>;
        /** The Member who caused the Action */
        creator?: Maybe<TrelloMember>;
        /** When the Action occurred */
        date?: Maybe<Scalars["DateTime"]["output"]>;
        /** Information about any Entities involved in the Action */
        displayEntities?: Maybe<TrelloAddAttachmentToCardActionDisplayEntities>;
        /** Relevant information for displaying the Action */
        displayKey?: Maybe<Scalars["String"]["output"]>;
        /** The ID of the Action */
        id: Scalars["ID"]["output"];
        /** Any limits affected by the action */
        limits?: Maybe<TrelloActionLimits>;
        /** The Reactions on the Action */
        reactions?: Maybe<Array<TrelloReaction>>;
        /** The type of the Action, from Trello Server.  May not match action __typename */
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Display entities for add attachment actions */
export type TrelloAddAttachmentToCardActionDisplayEntities = {
    __typename?: "TrelloAddAttachmentToCardActionDisplayEntities";
    attachment?: Maybe<TrelloActionAttachmentEntity>;
    attachmentPreview?: Maybe<TrelloActionAttachmentPreviewEntity>;
    card?: Maybe<TrelloActionCardEntity>;
    memberCreator?: Maybe<TrelloActionMemberEntity>;
};

/** Action triggered by adding an checklist to a card */
export type TrelloAddChecklistToCardAction = TrelloAction &
    TrelloCardActionData & {
        __typename?: "TrelloAddChecklistToCardAction";
        /** The app that caused the Action */
        appCreator?: Maybe<TrelloAppCreator>;
        /** The card's board */
        board?: Maybe<TrelloBoard>;
        /** The card the action took place on */
        card?: Maybe<TrelloCard>;
        /** The checklist added to the card */
        checklist?: Maybe<TrelloChecklist>;
        /** The Member who caused the Action */
        creator?: Maybe<TrelloMember>;
        /** When the Action occurred */
        date?: Maybe<Scalars["DateTime"]["output"]>;
        /** Information about any Entities involved in the Action */
        displayEntities?: Maybe<TrelloAddChecklistToCardDisplayEntities>;
        /** Relevant information for displaying the Action */
        displayKey?: Maybe<Scalars["String"]["output"]>;
        /** The ID of the Action */
        id: Scalars["ID"]["output"];
        /** Any limits affected by the action */
        limits?: Maybe<TrelloActionLimits>;
        /** The Reactions on the Action */
        reactions?: Maybe<Array<TrelloReaction>>;
        /** The type of the Action, from Trello Server.  May not match action __typename */
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Display entities for checklist add actions */
export type TrelloAddChecklistToCardDisplayEntities = {
    __typename?: "TrelloAddChecklistToCardDisplayEntities";
    card?: Maybe<TrelloActionCardEntity>;
    checklist?: Maybe<TrelloActionChecklistEntity>;
    memberCreator?: Maybe<TrelloActionMemberEntity>;
};

/** Action triggered by adding a member to a card */
export type TrelloAddMemberToCardAction = TrelloAction &
    TrelloCardActionData & {
        __typename?: "TrelloAddMemberToCardAction";
        /** The app that caused the Action */
        appCreator?: Maybe<TrelloAppCreator>;
        /** The card's board */
        board?: Maybe<TrelloBoard>;
        /** The card the action took place on */
        card?: Maybe<TrelloCard>;
        /** The Member who caused the Action */
        creator?: Maybe<TrelloMember>;
        /** When the Action occurred */
        date?: Maybe<Scalars["DateTime"]["output"]>;
        /** Information about any Entities involved in the Action */
        displayEntities?: Maybe<TrelloAddRemoveMemberActionDisplayEntities>;
        /** Relevant information for displaying the Action */
        displayKey?: Maybe<Scalars["String"]["output"]>;
        /** The ID of the Action */
        id: Scalars["ID"]["output"];
        /** Any limits affected by the action */
        limits?: Maybe<TrelloActionLimits>;
        /** The member added to the action */
        member?: Maybe<TrelloMember>;
        /** The Reactions on the Action */
        reactions?: Maybe<Array<TrelloReaction>>;
        /** The type of the Action, from Trello Server.  May not match action __typename */
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Display entities for add/remove member actions */
export type TrelloAddRemoveMemberActionDisplayEntities = {
    __typename?: "TrelloAddRemoveMemberActionDisplayEntities";
    card?: Maybe<TrelloActionCardEntity>;
    member?: Maybe<TrelloActionMemberEntity>;
    membercreator?: Maybe<TrelloActionMemberEntity>;
};

/** Represents the application that created an action */
export type TrelloAppCreator = {
    __typename?: "TrelloAppCreator";
    icon?: Maybe<TrelloApplicationIcon>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

/** The icon of an application */
export type TrelloApplicationIcon = {
    __typename?: "TrelloApplicationIcon";
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Arguments passed into assignCardToPlannerCalendarEvent mutation */
export type TrelloAssignCardToPlannerCalendarEventInput = {
    cardId: Scalars["ID"]["input"];
    plannerCalendarId: Scalars["ID"]["input"];
    position?: InputMaybe<Scalars["Float"]["input"]>;
    providerAccountId: Scalars["ID"]["input"];
    providerEventId: Scalars["ID"]["input"];
};

/** Returned response from assignCardToPlannerCalendarEvent mutation */
export type TrelloAssignCardToPlannerCalendarEventPayload = Payload & {
    __typename?: "TrelloAssignCardToPlannerCalendarEventPayload";
    errors?: Maybe<Array<MutationError>>;
    event?: Maybe<TrelloPlannerCalendarEvent>;
    success: Scalars["Boolean"]["output"];
};

/** Collection of AI preferences */
export type TrelloAtlassianIntelligence = {
    __typename?: "TrelloAtlassianIntelligence";
    /** Setting for enabling AI */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
};

/** An Attachment on a Trello Card */
export type TrelloAttachment = Node & {
    __typename?: "TrelloAttachment";
    /** Size of the attachment in bytes */
    bytes?: Maybe<Scalars["Float"]["output"]>;
    /** ID of the member who created the attachment */
    creatorId?: Maybe<Scalars["ID"]["output"]>;
    /** Date the attachment was added to card */
    date?: Maybe<Scalars["DateTime"]["output"]>;
    /** The hex code for the edge color */
    edgeColor?: Maybe<Scalars["String"]["output"]>;
    /** The file name of the attachment */
    fileName?: Maybe<Scalars["String"]["output"]>;
    /** The attachment's primary identifier. */
    id: Scalars["ID"]["output"];
    /** Boolean value to indicate if attachment is an upload */
    isUpload?: Maybe<Scalars["Boolean"]["output"]>;
    /** Mime type of the attachment */
    mimeType?: Maybe<Scalars["String"]["output"]>;
    /** Attachment Name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the attachment. */
    objectId: Scalars["ID"]["output"];
    /** Attachment position */
    position?: Maybe<Scalars["Float"]["output"]>;
    /** Url for the attachment */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** Trello attachment connection */
export type TrelloAttachmentConnection = {
    __typename?: "TrelloAttachmentConnection";
    /** The list of edges between the container and the attachments. */
    edges?: Maybe<Array<TrelloAttachmentEdge>>;
    /** The list of attachments */
    nodes?: Maybe<Array<TrelloAttachment>>;
    /** Contains information related to the current page of information */
    pageInfo: PageInfo;
};

/** Updates to an attachment connection */
export type TrelloAttachmentConnectionUpdated = {
    __typename?: "TrelloAttachmentConnectionUpdated";
    /** The list of new or updated attachment edges */
    edges?: Maybe<Array<TrelloAttachmentEdgeUpdated>>;
};

/** Trello attachment edge */
export type TrelloAttachmentEdge = {
    __typename?: "TrelloAttachmentEdge";
    /** The cursor to this edge */
    cursor: Scalars["String"]["output"];
    /** The attachment */
    node: TrelloAttachment;
};

/** Updates to an attachment edge */
export type TrelloAttachmentEdgeUpdated = {
    __typename?: "TrelloAttachmentEdgeUpdated";
    /** The new or updated attachment */
    node: TrelloAttachment;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoard = Node & {
    __typename?: "TrelloBoard";
    /** True if the board has been closed. False otherwise. */
    closed: Scalars["Boolean"]["output"];
    /** The board's creation method */
    creationMethod?: Maybe<Scalars["String"]["output"]>;
    /** The creator of the board */
    creator?: Maybe<TrelloMember>;
    /** Custom fields on the board. */
    customFields?: Maybe<TrelloCustomFieldConnection>;
    /** Board description */
    description?: Maybe<TrelloUserGeneratedText>;
    /** The board's enterprise */
    enterprise?: Maybe<TrelloEnterprise>;
    /** True if the board is owned by an enterprise. False otherwise. */
    enterpriseOwned: Scalars["Boolean"]["output"];
    /**
     * Template gallery info.
     *
     * This is only populated if the board is a template and is in the template
     * gallery.
     */
    galleryInfo?: Maybe<TrelloTemplateGalleryItemInfo>;
    /** The board's primary identifier. */
    id: Scalars["ID"]["output"];
    /** The labels on the board. */
    labels?: Maybe<TrelloLabelConnection>;
    /**
     * Last time a change was made to the board. Note: this can be null when board
     * is first created.
     */
    lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Limits for this board */
    limits?: Maybe<TrelloBoardLimits>;
    /** Lists on the board. */
    lists?: Maybe<TrelloListConnection>;
    /** Board Memberships */
    members?: Maybe<TrelloBoardMembershipsConnection>;
    /** The name of the board. */
    name: Scalars["String"]["output"];
    /** Id used for (legacy) interaction with the REST API. */
    objectId: Scalars["ID"]["output"];
    /** The powerUpData on the board. */
    powerUpData?: Maybe<TrelloPowerUpDataConnection>;
    /** The board's powerUps. */
    powerUps?: Maybe<TrelloBoardPowerUpConnection>;
    /** The date powerUps will be disabled for a board */
    powerUpsDisableAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Preferences for the board. */
    prefs: TrelloBoardPrefs;
    /** Premium features available for the board. */
    premiumFeatures?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** The board's unique shortened link id (not a complete URL). */
    shortLink: Scalars["TrelloShortLink"]["output"];
    /** The URL to the card without the name slug */
    shortUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The tags associated with the board. */
    tags?: Maybe<TrelloTagConnection>;
    /** The board's unique url */
    url?: Maybe<Scalars["URL"]["output"]>;
    /**
     * State on the board that is dependent on the currently
     * authenticated user.
     */
    viewer?: Maybe<TrelloBoardViewer>;
    /** The workspace this board belongs to. */
    workspace?: Maybe<TrelloWorkspace>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardCustomFieldsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardLabelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardListsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloListFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloBoardMembershipFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardPowerUpDataArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloPowerUpDataFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardPowerUpsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloBoardPowerUpFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The primary board component which contains lists and cards. */
export type TrelloBoardTagsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Attachment limits for the board */
export type TrelloBoardAttachmentsLimits = {
    __typename?: "TrelloBoardAttachmentsLimits";
    perBoard?: Maybe<TrelloLimitProps>;
    perCard?: Maybe<TrelloLimitProps>;
};

/** Collection of attributes representing the board background. */
export type TrelloBoardBackground = {
    __typename?: "TrelloBoardBackground";
    /** Background bottom color in hex */
    bottomColor?: Maybe<Scalars["String"]["output"]>;
    /** Background brightness setting: dark, light, unknown */
    brightness?: Maybe<Scalars["String"]["output"]>;
    /** The background color or null if there's an image background. */
    color?: Maybe<Scalars["String"]["output"]>;
    /** The url of the background image or null if there's a color. */
    image?: Maybe<Scalars["String"]["output"]>;
    /** A list of scaled images and their dimensions */
    imageScaled?: Maybe<Array<TrelloScaleProps>>;
    /** True if the image is tiled. */
    tile?: Maybe<Scalars["Boolean"]["output"]>;
    /** Background top color in hex */
    topColor?: Maybe<Scalars["String"]["output"]>;
};

/** Limits that apply to the board itself */
export type TrelloBoardBoardsLimits = {
    __typename?: "TrelloBoardBoardsLimits";
    totalAccessRequestsPerBoard?: Maybe<TrelloLimitProps>;
    totalMembersPerBoard?: Maybe<TrelloLimitProps>;
};

/** Card limits for the board */
export type TrelloBoardCardsLimits = {
    __typename?: "TrelloBoardCardsLimits";
    openPerBoard?: Maybe<TrelloLimitProps>;
    openPerList?: Maybe<TrelloLimitProps>;
    totalPerBoard?: Maybe<TrelloLimitProps>;
    totalPerList?: Maybe<TrelloLimitProps>;
};

/** CheckItem limits for the board */
export type TrelloBoardCheckItemsLimits = {
    __typename?: "TrelloBoardCheckItemsLimits";
    perChecklist?: Maybe<TrelloLimitProps>;
};

/** Checklist limits for the board */
export type TrelloBoardChecklistsLimits = {
    __typename?: "TrelloBoardChecklistsLimits";
    perBoard?: Maybe<TrelloLimitProps>;
    perCard?: Maybe<TrelloLimitProps>;
};

/**
 * Connection type emulating relay-style paging for boards
 * Updates are only published on edges, not on nodes
 */
export type TrelloBoardConnectionUpdated = {
    __typename?: "TrelloBoardConnectionUpdated";
    /** The list of new or updated edges between the container and boards. */
    edges?: Maybe<Array<TrelloBoardUpdatedEdge>>;
};

/** CustomFieldOption limits for the board */
export type TrelloBoardCustomFieldOptionsLimits = {
    __typename?: "TrelloBoardCustomFieldOptionsLimits";
    perField?: Maybe<TrelloLimitProps>;
};

/** CustomField limits for the board */
export type TrelloBoardCustomFieldsLimits = {
    __typename?: "TrelloBoardCustomFieldsLimits";
    perBoard?: Maybe<TrelloLimitProps>;
};

/** Represents a basic relationship between a node and a TrelloBoard. */
export type TrelloBoardEdge = {
    __typename?: "TrelloBoardEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** TrelloTemplate item. */
    node: TrelloBoard;
};

/** Label limits for the board */
export type TrelloBoardLabelsLimits = {
    __typename?: "TrelloBoardLabelsLimits";
    perBoard?: Maybe<TrelloLimitProps>;
};

/** Collection of limits that apply to a TrelloBoard */
export type TrelloBoardLimits = {
    __typename?: "TrelloBoardLimits";
    attachments?: Maybe<TrelloBoardAttachmentsLimits>;
    boards?: Maybe<TrelloBoardBoardsLimits>;
    cards?: Maybe<TrelloBoardCardsLimits>;
    checkItems?: Maybe<TrelloBoardCheckItemsLimits>;
    checklists?: Maybe<TrelloBoardChecklistsLimits>;
    customFieldOptions?: Maybe<TrelloBoardCustomFieldOptionsLimits>;
    customFields?: Maybe<TrelloBoardCustomFieldsLimits>;
    labels?: Maybe<TrelloBoardLabelsLimits>;
    lists?: Maybe<TrelloBoardListsLimits>;
    reactions?: Maybe<TrelloBoardReactionsLimits>;
    stickers?: Maybe<TrelloBoardStickersLimits>;
};

/** List limits for the board */
export type TrelloBoardListsLimits = {
    __typename?: "TrelloBoardListsLimits";
    openPerBoard?: Maybe<TrelloLimitProps>;
    totalPerBoard?: Maybe<TrelloLimitProps>;
};

/** Represents a relationship between a board and a member */
export type TrelloBoardMembershipEdge = {
    __typename?: "TrelloBoardMembershipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    membership?: Maybe<TrelloBoardMembershipInfo>;
    node?: Maybe<TrelloMember>;
};

/** Filter input for TrelloBoard.members */
export type TrelloBoardMembershipFilterInput = {
    /** Returns the board membership that matches this member ID, if any. */
    memberId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Returned board memberships will have only this type */
    type?: InputMaybe<TrelloBoardMembershipType>;
};

/** Metadata about a relationship between a member and a board */
export type TrelloBoardMembershipInfo = {
    __typename?: "TrelloBoardMembershipInfo";
    deactivated?: Maybe<Scalars["Boolean"]["output"]>;
    lastActive?: Maybe<Scalars["DateTime"]["output"]>;
    objectId: Scalars["ID"]["output"];
    type?: Maybe<TrelloBoardMembershipType>;
    unconfirmed?: Maybe<Scalars["Boolean"]["output"]>;
    workspaceMemberType?: Maybe<TrelloWorkspaceMembershipType>;
};

/** Membership types for a TrelloBoard */
export enum TrelloBoardMembershipType {
    /**
     * Privileged membership type. Can edit board settings,
     * and add/remove board members.
     */
    Admin = "ADMIN",
    /** Standard membership type.  Can view as well as edit board content. */
    Normal = "NORMAL",
    /**
     * This membership type is either view-only, or view + comment and react
     * depending on board settings.
     */
    Observer = "OBSERVER"
}

/** Connection type to represent board memberships */
export type TrelloBoardMembershipsConnection = {
    __typename?: "TrelloBoardMembershipsConnection";
    edges?: Maybe<Array<TrelloBoardMembershipEdge>>;
    nodes?: Maybe<Array<TrelloMember>>;
    pageInfo: PageInfo;
};

/** Connection type between a board and its powerUps */
export type TrelloBoardPowerUpConnection = {
    __typename?: "TrelloBoardPowerUpConnection";
    /** The list of edges between the board and powerUp entries. */
    edges?: Maybe<Array<TrelloBoardPowerUpEdge>>;
    /** The list of powerUps. */
    nodes?: Maybe<Array<TrelloPowerUp>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/**
 * Represents a basic relationship between a node and a TrelloPowerUp.
 * The fields promotional, objectId, and memberId are null if the
 * powerUp is not enabled on the board
 */
export type TrelloBoardPowerUpEdge = {
    __typename?: "TrelloBoardPowerUpEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The id of the member who enabled the powerUp */
    memberId?: Maybe<Scalars["ID"]["output"]>;
    /** The powerUp entry */
    node: TrelloPowerUp;
    /** The id of this board powerUp edge entry */
    objectId?: Maybe<Scalars["ID"]["output"]>;
    /**
     * If true, powerUp is promotional. Promotional powerUps
     * do not count against the powerUp limit
     */
    promotional?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Filters to apply when querying board powerUps. */
export type TrelloBoardPowerUpFilterInput = {
    /**
     * Only powerUps of the specified access visibility will be returned.
     * If not included, it'll return all powerUps.
     *
     * Use 'all' to return both private and shared powerUps.
     */
    access?: InputMaybe<Scalars["String"]["input"]>;
};

/** Collection of preferences for the board. */
export type TrelloBoardPrefs = {
    __typename?: "TrelloBoardPrefs";
    /** Attributes relating to the board background. */
    background?: Maybe<TrelloBoardBackground>;
    /** If true, the calendar feed is enabled for this board. */
    calendarFeedEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** If true, invites are enabled for this board */
    canInvite?: Maybe<Scalars["Boolean"]["output"]>;
    /** Determines the card aging mode. */
    cardAging?: Maybe<Scalars["String"]["output"]>;
    /** If true, card counts are enabled for this board. */
    cardCounts?: Maybe<Scalars["Boolean"]["output"]>;
    /** If true, card covers are enabled for this board. */
    cardCovers?: Maybe<Scalars["Boolean"]["output"]>;
    /** Determines which permission group level can comment. */
    comments?: Maybe<Scalars["String"]["output"]>;
    /** List of PowerUps whose buttons have been hidden on the board. */
    hiddenPowerUpBoardButtons?: Maybe<Array<TrelloPowerUp>>;
    /** If true, votes from other members on this board are hidden */
    hideVotes?: Maybe<Scalars["Boolean"]["output"]>;
    /** Determines whether admins or members of the board can send invitations. */
    invitations?: Maybe<Scalars["String"]["output"]>;
    /** If true, indicates this is a board template or false if it's a typical board. */
    isTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    /** Determines a board's visibility. */
    permissionLevel?: Maybe<Scalars["String"]["output"]>;
    /** If true, allows a workspace member to add themselves to the board. */
    selfJoin?: Maybe<Scalars["Boolean"]["output"]>;
    /** If true, show the new 'done state' UI on the board. */
    showCompleteStatus?: Maybe<Scalars["Boolean"]["output"]>;
    /** Describes which switcher view options are available for the board. */
    switcherViews?: Maybe<Array<Maybe<TrelloSwitcherViewsInfo>>>;
    /** Determines which permissions group level can vote on cards. */
    voting?: Maybe<Scalars["String"]["output"]>;
};

/** Reaction limits for the board */
export type TrelloBoardReactionsLimits = {
    __typename?: "TrelloBoardReactionsLimits";
    perAction?: Maybe<TrelloLimitProps>;
    uniquePerAction?: Maybe<TrelloLimitProps>;
};

/** Board restriction settings */
export type TrelloBoardRestrictions = {
    __typename?: "TrelloBoardRestrictions";
    enterprise?: Maybe<Scalars["String"]["output"]>;
    org?: Maybe<Scalars["String"]["output"]>;
    private?: Maybe<Scalars["String"]["output"]>;
    public?: Maybe<Scalars["String"]["output"]>;
};

/** Sticker limits for the board */
export type TrelloBoardStickersLimits = {
    __typename?: "TrelloBoardStickersLimits";
    perCard?: Maybe<TrelloLimitProps>;
};

/** TrelloBoard update subscription. */
export type TrelloBoardUpdated = {
    __typename?: "TrelloBoardUpdated";
    /** Delta information for this event */
    _deltas?: Maybe<Array<Scalars["String"]["output"]>>;
    /** True if the board has been closed. False otherwise. */
    closed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Custom fields on the board. */
    customFields?: Maybe<TrelloCustomFieldConnectionUpdated>;
    /** Board description */
    description?: Maybe<TrelloUserGeneratedText>;
    /** The board's enterprise. Only includes id and object id. */
    enterprise?: Maybe<TrelloEnterprise>;
    /** Board ARI */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The new or updated labels on the board. */
    labels?: Maybe<TrelloLabelConnectionUpdated>;
    /** Lists for the board.  Always null on subscribe. */
    lists?: Maybe<TrelloListUpdatedConnection>;
    /** Members for the board; only returns edges[].node.id and edges[].node.objectId on update */
    members?: Maybe<TrelloBoardMembershipsConnection>;
    /** Board name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Board's objectId */
    objectId?: Maybe<Scalars["ID"]["output"]>;
    /** Deleted custom fields */
    onCustomFieldDeleted?: Maybe<Array<TrelloCustomFieldDeleted>>;
    /** Deleted labels */
    onLabelDeleted?: Maybe<Array<TrelloLabelDeleted>>;
    /** Preferences for the board. */
    prefs?: Maybe<TrelloBoardPrefs>;
    /** Premium features available for the board */
    premiumFeatures?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The board's unique url */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** Board viewer-specific properties */
    viewer?: Maybe<TrelloBoardViewerUpdated>;
    /** ID of the board's new workspace */
    workspace?: Maybe<TrelloBoardWorkspaceUpdated>;
};

/**
 * Edge type emulating relay-style paging
 * Board edge for new or updated board
 */
export type TrelloBoardUpdatedEdge = {
    __typename?: "TrelloBoardUpdatedEdge";
    /** The new or updated board */
    node: TrelloBoardUpdated;
};

/**
 * Information about the board that is dependent on the
 * currently authenticated user "viewing" a board.
 */
export type TrelloBoardViewer = {
    __typename?: "TrelloBoardViewer";
    /** True if the viewer has enabled using AI to create cards via email. */
    aiEmailEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** True if the viewer has enabled using AI to create cards via MSTeams message. */
    aiMSTeamsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** True if the viewer has enabled using AI to create cards via slack message. */
    aiSlackEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Key for syncing iCalendar feed */
    calendarKey?: Maybe<Scalars["String"]["output"]>;
    /** Fields for creating cards via email */
    email?: Maybe<TrelloBoardViewerEmail>;
    /** The last time the viewer visited the board. */
    lastSeenAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** True if the user has opted for compact mirror cards over expanded mirror cards. */
    showCompactMirrorCards?: Maybe<Scalars["Boolean"]["output"]>;
    /** Fields for sidebar display settings */
    sidebar?: Maybe<TrelloBoardViewerSidebar>;
    /** True if the board is starred. */
    starred: Scalars["Boolean"]["output"];
    /** True if the viewer is subscribed to the board. */
    subscribed?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Settings for creating new cards via email */
export type TrelloBoardViewerEmail = {
    __typename?: "TrelloBoardViewerEmail";
    /** Board email address */
    address?: Maybe<Scalars["String"]["output"]>;
    /** True if AI is enabled for emails to this board, false otherwise */
    aiEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Key for generated email address */
    key?: Maybe<Scalars["String"]["output"]>;
    /** List where new cards are created via email */
    list?: Maybe<TrelloList>;
    /** Position of new cards created in the list */
    position?: Maybe<Scalars["String"]["output"]>;
};

/** Settings for board sidebar display */
export type TrelloBoardViewerSidebar = {
    __typename?: "TrelloBoardViewerSidebar";
    /** True if the sidebar opens when viewing a board */
    show?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * This type represents board properties that are unique to a particular
 * viewer
 */
export type TrelloBoardViewerUpdated = {
    __typename?: "TrelloBoardViewerUpdated";
    /** True if the current viewer is subscribed to the board */
    subscribed?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * This type represents the Board's new workspace. Updated immediately before
 * socket close
 */
export type TrelloBoardWorkspaceUpdated = {
    __typename?: "TrelloBoardWorkspaceUpdated";
    /** New board workspace ARI */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** New board workspace objectid */
    objectId?: Maybe<Scalars["ID"]["output"]>;
};

/** A card within a Trello Board */
export type TrelloCard = Node & {
    __typename?: "TrelloCard";
    /** Actions taken on this card (comment, add/remove members, etc) */
    actions?: Maybe<TrelloCardActionConnection>;
    /** The attachments on the card. */
    attachments?: Maybe<TrelloAttachmentConnection>;
    /** Badges for a card */
    badges?: Maybe<TrelloCardBadges>;
    /** The checklists on the card. */
    checklists?: Maybe<TrelloChecklistConnection>;
    /** True if the card has been closed. False otherwise. */
    closed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the card has been marked complete. */
    complete?: Maybe<Scalars["Boolean"]["output"]>;
    /** The card cover */
    cover?: Maybe<TrelloCardCover>;
    /** Details about the creation of the card */
    creation?: Maybe<TrelloCardCreationInfo>;
    /** The Custom Field items on the card. */
    customFieldItems?: Maybe<TrelloCustomFieldItemConnection>;
    /** Card description */
    description?: Maybe<TrelloUserGeneratedText>;
    /** Information about the due property of the card. Null if due date is not set on the card. */
    due?: Maybe<TrelloCardDueInfo>;
    /** The card's primary identifier */
    id: Scalars["ID"]["output"];
    /** If true, indicates this is a card template or false if it's a typical card. */
    isTemplate?: Maybe<Scalars["Boolean"]["output"]>;
    /** The labels on the card. */
    labels?: Maybe<TrelloLabelConnection>;
    /**
     * Last time a change was made to the card. Note: this can be null when card
     * is first created.
     */
    lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Limits set on a Card */
    limits?: Maybe<TrelloCardLimits>;
    /** List in which the card is present */
    list?: Maybe<TrelloList>;
    /** Location of the card. Note: this can be null if location is not set. */
    location?: Maybe<TrelloCardLocation>;
    /** The members on the card. */
    members?: Maybe<TrelloMemberConnection>;
    /** For mirror cards, the id of the source card. */
    mirrorSourceId?: Maybe<Scalars["ID"]["output"]>;
    /** For mirror cards, the ARI of the source card. */
    mirrorSourceNodeId?: Maybe<Scalars["String"]["output"]>;
    /** Card name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Id used for (legacy) interaction with the REST API. */
    objectId: Scalars["ID"]["output"];
    /** Whether or not the card is pinned to the list */
    pinned?: Maybe<Scalars["Boolean"]["output"]>;
    /** Card position within a TrelloList */
    position?: Maybe<Scalars["Float"]["output"]>;
    /** The powerUpData on the card. */
    powerUpData?: Maybe<TrelloPowerUpDataConnection>;
    /** Role of the card. Null if the card does not have a special role. */
    role?: Maybe<TrelloCardRole>;
    /** Index of the card on its board that is only unique to the board and subject to change as the card moves */
    shortId?: Maybe<Scalars["Int"]["output"]>;
    /** The card's unique shortened link id (not a complete URL). */
    shortLink?: Maybe<Scalars["TrelloShortLink"]["output"]>;
    /** The URL to the card without the name slug */
    shortUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The start date on the card, if one exists. Null otherwise. */
    startedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The stickers on the card. */
    stickers?: Maybe<TrelloStickerConnection>;
    /** Url of the card */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** A card within a Trello Board */
export type TrelloCardActionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    type?: InputMaybe<Array<TrelloCardActionType>>;
};

/** A card within a Trello Board */
export type TrelloCardAttachmentsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card within a Trello Board */
export type TrelloCardChecklistsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card within a Trello Board */
export type TrelloCardCustomFieldItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card within a Trello Board */
export type TrelloCardLabelsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card within a Trello Board */
export type TrelloCardMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card within a Trello Board */
export type TrelloCardPowerUpDataArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloPowerUpDataFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A card within a Trello Board */
export type TrelloCardStickersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Trello card actions connection */
export type TrelloCardActionConnection = {
    __typename?: "TrelloCardActionConnection";
    /** The list of edges between the card and the actions. */
    edges?: Maybe<Array<TrelloCardActionEdge>>;
    /** The list of card actions */
    nodes?: Maybe<Array<TrelloCardActions>>;
    /** Contains information related to the current page of information */
    pageInfo: PageInfo;
};

/** Interface representing common data for Trello Card Actions */
export type TrelloCardActionData = {
    /** The card's board */
    board?: Maybe<TrelloBoard>;
    /** The card the action took place on */
    card?: Maybe<TrelloCard>;
};

/** Trello card action edge */
export type TrelloCardActionEdge = {
    __typename?: "TrelloCardActionEdge";
    /** The cursor to this edge */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The attachment */
    node?: Maybe<TrelloCardActions>;
};

/** Selectable action types for a card */
export enum TrelloCardActionType {
    AddAttachment = "ADD_ATTACHMENT",
    AddChecklist = "ADD_CHECKLIST",
    AddMember = "ADD_MEMBER",
    Comment = "COMMENT",
    MoveCard = "MOVE_CARD",
    RemoveMember = "REMOVE_MEMBER"
}

/** Union representing all card actions */
export type TrelloCardActions =
    | TrelloAddAttachmentToCardAction
    | TrelloAddChecklistToCardAction
    | TrelloAddMemberToCardAction
    | TrelloCommentCardAction
    | TrelloMoveCardAction
    | TrelloRemoveMemberFromCardAction;

/** Card attachment counts grouped by type */
export type TrelloCardAttachmentsByType = {
    __typename?: "TrelloCardAttachmentsByType";
    /** Attachment counts for trello */
    trello?: Maybe<TrelloCardAttachmentsCount>;
};

/** Count of a trello attachments for card front badges */
export type TrelloCardAttachmentsCount = {
    __typename?: "TrelloCardAttachmentsCount";
    /** Count of boards attached to the card */
    board?: Maybe<Scalars["Int"]["output"]>;
    /** Count of other cards attached to the current card */
    card?: Maybe<Scalars["Int"]["output"]>;
};

/** Due information used in trello card badge */
export type TrelloCardBadgeDueInfo = {
    __typename?: "TrelloCardBadgeDueInfo";
    /** The due date on the card. */
    at?: Maybe<Scalars["DateTime"]["output"]>;
    /** Whether the due date has been marked complete. */
    complete?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Trello card badges */
export type TrelloCardBadges = {
    __typename?: "TrelloCardBadges";
    /** Total number of attachments on the card */
    attachments?: Maybe<Scalars["Int"]["output"]>;
    /** Count of attachments grouped by type */
    attachmentsByType?: Maybe<TrelloCardAttachmentsByType>;
    /** Total number of checklist items in the card */
    checkItems?: Maybe<Scalars["Int"]["output"]>;
    /** Count of the number of checklist items checked off */
    checkItemsChecked?: Maybe<Scalars["Int"]["output"]>;
    /** Due date of the earliest due checklist item */
    checkItemsEarliestDue?: Maybe<Scalars["DateTime"]["output"]>;
    /** Number of comments in the card */
    comments?: Maybe<Scalars["Int"]["output"]>;
    /** Boolean to indicate if the card has description or not */
    description?: Maybe<Scalars["Boolean"]["output"]>;
    /** Information about the due property of the card. Null if due date is not set on the card. */
    due?: Maybe<TrelloCardBadgeDueInfo>;
    /** The external source from which the card was created */
    externalSource?: Maybe<TrelloCardExternalSource>;
    /** Boolean to indicate whether the card content was last updated by AI */
    lastUpdatedByAi?: Maybe<Scalars["Boolean"]["output"]>;
    /** Boolean to indicate whether the card has a location or not */
    location?: Maybe<Scalars["Boolean"]["output"]>;
    /** The start date on the card, if one exists. Null otherwise. */
    startedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Subcription and voting status of the current member */
    viewer?: Maybe<TrelloCardViewer>;
    /** Total number of votes on the card */
    votes?: Maybe<Scalars["Int"]["output"]>;
};

/** Connection type to represent cards. */
export type TrelloCardConnection = {
    __typename?: "TrelloCardConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloCardEdge>>;
    /** The list of TrelloCards. */
    nodes?: Maybe<Array<TrelloCard>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** TrelloCardCoordinates latitude, longitude for the location */
export type TrelloCardCoordinates = {
    __typename?: "TrelloCardCoordinates";
    /** Latitude of the location */
    latitude: Scalars["Float"]["output"];
    /** Longitude of the location */
    longitude: Scalars["Float"]["output"];
};

/** The cover of a Trello Card */
export type TrelloCardCover = {
    __typename?: "TrelloCardCover";
    /** The image attachment used as the card cover */
    attachment?: Maybe<TrelloAttachment>;
    /** The cover brightness */
    brightness?: Maybe<TrelloCardCoverBrightness>;
    /** The cover color */
    color?: Maybe<TrelloCardCoverColor>;
    /** The hex code for the edge color */
    edgeColor?: Maybe<Scalars["String"]["output"]>;
    /** The powerUp that set the card cover */
    powerUp?: Maybe<TrelloPowerUp>;
    /** The connection to scaled cover image previews set by an attachment, source shared by Trello, or a powerUp. */
    previews?: Maybe<TrelloImagePreviewConnection>;
    /** The url of the cover image, if it is from a source shared by Trello */
    sharedSourceUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The cover size */
    size?: Maybe<TrelloCardCoverSize>;
    /** The uploaded background image from a source provided by Trello */
    uploadedBackground?: Maybe<TrelloUploadedBackground>;
};

/** The cover of a Trello Card */
export type TrelloCardCoverPreviewsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** TrelloCardCover brightness */
export enum TrelloCardCoverBrightness {
    Dark = "DARK",
    Light = "LIGHT"
}

/** TrelloCardCover color */
export enum TrelloCardCoverColor {
    Black = "BLACK",
    Blue = "BLUE",
    Green = "GREEN",
    Lime = "LIME",
    Orange = "ORANGE",
    Pink = "PINK",
    Purple = "PURPLE",
    Red = "RED",
    Sky = "SKY",
    Yellow = "YELLOW"
}

/** TrelloCardCover size */
export enum TrelloCardCoverSize {
    Full = "FULL",
    Normal = "NORMAL"
}

/** The cover of a trello card. */
export type TrelloCardCoverUpdated = {
    __typename?: "TrelloCardCoverUpdated";
    /** The cover brightness */
    brightness?: Maybe<TrelloCardCoverBrightness>;
    /** The cover color */
    color?: Maybe<TrelloCardCoverColor>;
    /** The hex code for the edge color */
    edgeColor?: Maybe<Scalars["String"]["output"]>;
    /** The powerUp that set the card cover */
    powerUp?: Maybe<TrelloPowerUpUpdated>;
    /** The connection to scaled cover image previews set by an attachment, source shared by Trello, or a powerUp. */
    previews?: Maybe<TrelloImagePreviewUpdatedConnection>;
    /** The url of the cover image, if it is from a source shared by Trello */
    sharedSourceUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The cover size */
    size?: Maybe<TrelloCardCoverSize>;
};

/** Information about the creation of a TrelloCard */
export type TrelloCardCreationInfo = {
    __typename?: "TrelloCardCreationInfo";
    /** Any errors raised during the creation of the card (only applicable for AI-generated cards) */
    error?: Maybe<Scalars["String"]["output"]>;
    /** The time the card started loading (only applicable for AI-generated cards) */
    loadingStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The method used to create the card */
    method?: Maybe<Scalars["String"]["output"]>;
};

/** Information about the due property of a TrelloCard */
export type TrelloCardDueInfo = {
    __typename?: "TrelloCardDueInfo";
    /** The due date on the card. */
    at?: Maybe<Scalars["DateTime"]["output"]>;
    /** Whether the due date has been marked complete. */
    complete?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * The number of minutes before the due date that all members and followers of the card will be notified.
     * Can be negative if reminder is unset or null if a due date was never set on the card.
     */
    reminder?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a basic relationship between a node and a TrelloCard. */
export type TrelloCardEdge = {
    __typename?: "TrelloCardEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The Trello Card. */
    node?: Maybe<TrelloCard>;
};

/** TrelloCard external sources, from which cards can be generated */
export enum TrelloCardExternalSource {
    Email = "EMAIL",
    Msteams = "MSTEAMS",
    Siri = "SIRI",
    Slack = "SLACK"
}

/** Trello Card Limit */
export type TrelloCardLimit = {
    __typename?: "TrelloCardLimit";
    /** Limit per card */
    perCard?: Maybe<TrelloLimitProps>;
};

/** Limits for a card */
export type TrelloCardLimits = {
    __typename?: "TrelloCardLimits";
    attachments?: Maybe<TrelloCardLimit>;
    checklists?: Maybe<TrelloCardLimit>;
    stickers?: Maybe<TrelloCardLimit>;
};

/** TrelloCard location information */
export type TrelloCardLocation = {
    __typename?: "TrelloCardLocation";
    /** Address of the card location. */
    address?: Maybe<Scalars["String"]["output"]>;
    /** Coordinates for the location */
    coordinates?: Maybe<TrelloCardCoordinates>;
    /** Name of the card location. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** URL of the static map. */
    staticMapUrl?: Maybe<Scalars["URL"]["output"]>;
};

/** Special TrelloCard roles */
export enum TrelloCardRole {
    Board = "BOARD",
    Link = "LINK",
    Mirror = "MIRROR",
    Separator = "SEPARATOR"
}

/** The updated card fields within a TrelloBoardUpdated event. */
export type TrelloCardUpdated = {
    __typename?: "TrelloCardUpdated";
    /** The attachments on the card */
    attachments?: Maybe<TrelloAttachmentConnectionUpdated>;
    /** Badges for a card */
    badges?: Maybe<TrelloCardBadges>;
    /** The checklists on the card */
    checklists?: Maybe<TrelloChecklistConnectionUpdated>;
    /** True if the card has been closed. False otherwise. */
    closed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether the card has been marked complete. */
    complete?: Maybe<Scalars["Boolean"]["output"]>;
    /** The card cover */
    cover?: Maybe<TrelloCardCoverUpdated>;
    /** Information about the card's creation. */
    creation?: Maybe<TrelloCardCreationInfo>;
    /** The Custom Field items on the card. */
    customFieldItems?: Maybe<TrelloCustomFieldItemUpdatedConnection>;
    /** Card description */
    description?: Maybe<Scalars["String"]["output"]>;
    /** Information about the due property of the card. */
    due?: Maybe<TrelloCardDueInfo>;
    /** The card's primary identifier */
    id: Scalars["ID"]["output"];
    /** The labels on the card. This is the current label state */
    labels?: Maybe<TrelloLabelUpdatedConnection>;
    /**
     * Last time a change was made to the card. Note: this can be null when card
     * is first created.
     */
    lastActivityAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** Location of the card */
    location?: Maybe<TrelloCardLocation>;
    /** Members for a card */
    members?: Maybe<TrelloMemberUpdatedConnection>;
    /** Card name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Card's objectId */
    objectId?: Maybe<Scalars["ID"]["output"]>;
    /** The checklists that were deleted from the card */
    onChecklistDeleted?: Maybe<Array<TrelloChecklistDeleted>>;
    /** Card position within a TrelloList */
    position?: Maybe<Scalars["Float"]["output"]>;
    /** Stickers for a card */
    stickers?: Maybe<TrelloStickerUpdatedConnection>;
};

/** Connection type emulating relay-style paging for list data on TrelloBoardUpdated events */
export type TrelloCardUpdatedConnection = {
    __typename?: "TrelloCardUpdatedConnection";
    nodes?: Maybe<Array<TrelloCardUpdated>>;
};

/** Trello card viewer for card front badges */
export type TrelloCardViewer = {
    __typename?: "TrelloCardViewer";
    /** Boolean to indicate if current member is subscribed to card */
    subscribed?: Maybe<Scalars["Boolean"]["output"]>;
    /** Boolean to indicate if current member has voted on card */
    voted?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A Trello check item from a checklist */
export type TrelloCheckItem = {
    __typename?: "TrelloCheckItem";
    /** Information about the due property of the check item. Null if check item has no due date. */
    due?: Maybe<TrelloCheckItemDueInfo>;
    /** The Trello member assigned to the check item */
    member?: Maybe<TrelloMember>;
    /** The check item's name/text */
    name?: Maybe<TrelloUserGeneratedText>;
    /** The objectId of the check item. */
    objectId: Scalars["ID"]["output"];
    /** The check item position */
    position?: Maybe<Scalars["Float"]["output"]>;
    /** Enum indicating the state of the check item */
    state?: Maybe<TrelloCheckItemState>;
};

/** Connection type between a container and its check items. */
export type TrelloCheckItemConnection = {
    __typename?: "TrelloCheckItemConnection";
    /** The list of edges between the container and check items. */
    edges?: Maybe<Array<TrelloCheckItemEdge>>;
    /** The list of check items (for non-relay clients). */
    nodes?: Maybe<Array<TrelloCheckItem>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Updates to a check item connection */
export type TrelloCheckItemConnectionUpdated = {
    __typename?: "TrelloCheckItemConnectionUpdated";
    /** The list of new or updated check item edges */
    edges?: Maybe<Array<TrelloCheckItemEdgeUpdated>>;
};

/** Information about the due property of a TrelloCheckItem */
export type TrelloCheckItemDueInfo = {
    __typename?: "TrelloCheckItemDueInfo";
    /** The due date of the check item. */
    at?: Maybe<Scalars["DateTime"]["output"]>;
    /**
     * The number of minutes before the due date that all members and followers of the card will be notified.
     * Will be null if the due date was never set or if a reminder was never set.
     */
    reminder?: Maybe<Scalars["Int"]["output"]>;
};

/** Represents a basic relationship between a node and a TrelloCheckItem. */
export type TrelloCheckItemEdge = {
    __typename?: "TrelloCheckItemEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The check item */
    node: TrelloCheckItem;
};

/** Updates to a check item edge */
export type TrelloCheckItemEdgeUpdated = {
    __typename?: "TrelloCheckItemEdgeUpdated";
    /** The new or updated check item */
    node: TrelloCheckItem;
};

/** The state of a TrelloCheckItem */
export enum TrelloCheckItemState {
    Complete = "COMPLETE",
    Incomplete = "INCOMPLETE"
}

/** A Trello checklist */
export type TrelloChecklist = {
    __typename?: "TrelloChecklist";
    /** The trello board which the checklist belongs to */
    board?: Maybe<TrelloBoard>;
    /** The trello card which the checklist belongs to */
    card?: Maybe<TrelloCard>;
    /** The Trello check items in this checklist */
    checkItems?: Maybe<TrelloCheckItemConnection>;
    /** The checklist's name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the checklist. */
    objectId: Scalars["ID"]["output"];
    /** The checklist position */
    position?: Maybe<Scalars["Float"]["output"]>;
};

/** A Trello checklist */
export type TrelloChecklistCheckItemsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Connection type between a container and its checklists. */
export type TrelloChecklistConnection = {
    __typename?: "TrelloChecklistConnection";
    /** The list of edges between the container and checklists. */
    edges?: Maybe<Array<TrelloChecklistEdge>>;
    /** The list of Checklists. */
    nodes?: Maybe<Array<TrelloChecklist>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Updates to a checklist connection */
export type TrelloChecklistConnectionUpdated = {
    __typename?: "TrelloChecklistConnectionUpdated";
    /** The list of new or updated Checklist edges */
    edges?: Maybe<Array<TrelloChecklistEdgeUpdated>>;
};

/** Information about checklists deleted from a card */
export type TrelloChecklistDeleted = {
    __typename?: "TrelloChecklistDeleted";
    /** The checklist ID */
    objectId: Scalars["ID"]["output"];
};

/** Represents a basic relationship between a node and a TrelloChecklist. */
export type TrelloChecklistEdge = {
    __typename?: "TrelloChecklistEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The Checklist */
    node: TrelloChecklist;
};

/** Updates to a checklist edge */
export type TrelloChecklistEdgeUpdated = {
    __typename?: "TrelloChecklistEdgeUpdated";
    /** The new or updated checklist */
    node: TrelloChecklistUpdated;
};

/** A new or updated checklist */
export type TrelloChecklistUpdated = {
    __typename?: "TrelloChecklistUpdated";
    /** The new or updated check items in the checklist */
    checkItems?: Maybe<TrelloCheckItemConnectionUpdated>;
    /** The checklist's name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the new/updated checklist. */
    objectId: Scalars["ID"]["output"];
    /** The checklist position */
    position?: Maybe<Scalars["Float"]["output"]>;
};

/** Action triggered by commenting on a card */
export type TrelloCommentCardAction = TrelloAction &
    TrelloCardActionData & {
        __typename?: "TrelloCommentCardAction";
        /** The app that caused the Action */
        appCreator?: Maybe<TrelloAppCreator>;
        /** The card's board */
        board?: Maybe<TrelloBoard>;
        /** The card the action took place on */
        card?: Maybe<TrelloCard>;
        /** The Member who caused the Action */
        creator?: Maybe<TrelloMember>;
        /** When the Action occurred */
        date?: Maybe<Scalars["DateTime"]["output"]>;
        /** Information about any Entities involved in the Action */
        displayEntities?: Maybe<TrelloCommentCardActionDisplayEntities>;
        /** Relevant information for displaying the Action */
        displayKey?: Maybe<Scalars["String"]["output"]>;
        /** The ID of the Action */
        id: Scalars["ID"]["output"];
        /** Any limits affected by the action */
        limits?: Maybe<TrelloActionLimits>;
        /** The Reactions on the Action */
        reactions?: Maybe<Array<TrelloReaction>>;
        /** The type of the Action, from Trello Server.  May not match action __typename */
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Display entities for card comment actions */
export type TrelloCommentCardActionDisplayEntities = {
    __typename?: "TrelloCommentCardActionDisplayEntities";
    card?: Maybe<TrelloActionCardEntity>;
    comment?: Maybe<TrelloActionCommentEntity>;
    contextOn?: Maybe<TrelloActionTranslatableEntity>;
    memberCreator?: Maybe<TrelloActionMemberEntity>;
};

/** Arguments passed into createOrUpdatePlannerCalendar mutation */
export type TrelloCreateOrUpdatePlannerCalendarInput = {
    enabled: Scalars["Boolean"]["input"];
    /** The account ID from the underlying calendar provider */
    providerAccountId?: InputMaybe<Scalars["ID"]["input"]>;
    providerCalendarId: Scalars["ID"]["input"];
    type: TrelloSupportedPlannerProviders;
    workspaceId: Scalars["ID"]["input"];
};

/** Returned response from createOrUpdatePlannerCalendar mutation */
export type TrelloCreateOrUpdatePlannerCalendarPayload = Payload & {
    __typename?: "TrelloCreateOrUpdatePlannerCalendarPayload";
    errors?: Maybe<Array<MutationError>>;
    plannerCalendarMutated?: Maybe<TrelloPlannerCalendarMutated>;
    success: Scalars["Boolean"]["output"];
};

/** Arguments passed into createPlannerCalendarEvent mutation */
export type TrelloCreatePlannerCalendarEventInput = {
    event: TrelloCreatePlannerCalendarEventOptions;
    plannerCalendarId: Scalars["ID"]["input"];
    providerAccountId: Scalars["ID"]["input"];
};

/**
 * Arguments passed into createPlannerCalendarEvent mutation
 * specific to the event being created
 */
export type TrelloCreatePlannerCalendarEventOptions = {
    cardId?: InputMaybe<Scalars["ID"]["input"]>;
    end: Scalars["DateTime"]["input"];
    start: Scalars["DateTime"]["input"];
    title: Scalars["String"]["input"];
};

/** Returned response from createPlannerCalendarEvent mutation */
export type TrelloCreatePlannerCalendarEventPayload = Payload & {
    __typename?: "TrelloCreatePlannerCalendarEventPayload";
    errors?: Maybe<Array<MutationError>>;
    plannerCalendarUpdated?: Maybe<TrelloPlannerCalendar>;
    success: Scalars["Boolean"]["output"];
};

/** A Trello Custom Field */
export type TrelloCustomField = {
    __typename?: "TrelloCustomField";
    /** Display options for the custom field. */
    display?: Maybe<TrelloCustomFieldDisplay>;
    /** The name of the custom field */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the Custom Field */
    objectId: Scalars["ID"]["output"];
    /** Options (values for example) for a custom field. */
    options?: Maybe<Array<TrelloCustomFieldOption>>;
    /** The display position of the custom field (for example on the cardback) */
    position?: Maybe<Scalars["Float"]["output"]>;
    /**
     * The type of the custom field
     * ('checkbox' | 'date' | 'list' | 'number' | 'text')
     */
    type?: Maybe<Scalars["String"]["output"]>;
};

/** Custom field connection */
export type TrelloCustomFieldConnection = {
    __typename?: "TrelloCustomFieldConnection";
    /** The list of edges between the container and custom fields. */
    edges?: Maybe<Array<TrelloCustomFieldEdge>>;
    /** The list of custom fields. */
    nodes?: Maybe<Array<TrelloCustomField>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/**
 * Connection type emulating relay-style paging for custom fields
 * Updates are only published on edges, not on nodes
 */
export type TrelloCustomFieldConnectionUpdated = {
    __typename?: "TrelloCustomFieldConnectionUpdated";
    /** The list of new or updated edges between the container and labels. */
    edges?: Maybe<Array<TrelloCustomFieldEdgeUpdated>>;
};

/** Information about custom fields deleted from a board */
export type TrelloCustomFieldDeleted = {
    __typename?: "TrelloCustomFieldDeleted";
    /** Custom field ID */
    objectId?: Maybe<Scalars["ID"]["output"]>;
};

/** Display options for the custom field. */
export type TrelloCustomFieldDisplay = {
    __typename?: "TrelloCustomFieldDisplay";
    /** If true, the custom field is shown on the card front. */
    cardFront?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Custom field edge. */
export type TrelloCustomFieldEdge = {
    __typename?: "TrelloCustomFieldEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The custom field. */
    node?: Maybe<TrelloCustomField>;
};

/**
 * Edge type emulating relay-style paging
 * Custom field edge for new or updated Custom field
 */
export type TrelloCustomFieldEdgeUpdated = {
    __typename?: "TrelloCustomFieldEdgeUpdated";
    /** The new or updated custm field */
    node: TrelloCustomField;
};

/** A Trello Custom Field item */
export type TrelloCustomFieldItem = {
    __typename?: "TrelloCustomFieldItem";
    /** The Trello Custom field of which this is an item. */
    customField?: Maybe<TrelloCustomField>;
    /** The entity that the Custom Field item is set within. */
    model?: Maybe<TrelloCard>;
    /** The objectId of the Custom Field item. */
    objectId: Scalars["ID"]["output"];
    /** The value of the Custom Field item. */
    value?: Maybe<TrelloCustomFieldItemValueInfo>;
};

/** Connection type between an entity and its Custom Field items. */
export type TrelloCustomFieldItemConnection = {
    __typename?: "TrelloCustomFieldItemConnection";
    /** The list of edges between the object and Custom Field items. */
    edges?: Maybe<Array<TrelloCustomFieldItemEdge>>;
    /** The list of Custom Field items. */
    nodes?: Maybe<Array<TrelloCustomFieldItem>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Represents a basic relationship between a node and a TrelloCustomFieldItem. */
export type TrelloCustomFieldItemEdge = {
    __typename?: "TrelloCustomFieldItemEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The Custom Field item */
    node: TrelloCustomFieldItem;
};

/** Trello custom field item updated connection type */
export type TrelloCustomFieldItemUpdatedConnection = {
    __typename?: "TrelloCustomFieldItemUpdatedConnection";
    /** The list of Custom Field items. */
    nodes?: Maybe<Array<TrelloCustomFieldItem>>;
};

/** Information describing the value of a Custom Field item. */
export type TrelloCustomFieldItemValueInfo = {
    __typename?: "TrelloCustomFieldItemValueInfo";
    /** True if the Custom Field type is a checkbox and it is checked. Null otherwise. */
    checked?: Maybe<Scalars["Boolean"]["output"]>;
    /** The value of the Custom Field if the field type is a date. Null otherwise. */
    date?: Maybe<Scalars["String"]["output"]>;
    /**
     * The id of the Custom Field item option if the field type is one that has a set of
     * options, e.g. a dropdown. Null otherwise.
     */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The value of the Custom Field if the field type is a number. Null otherwise. */
    number?: Maybe<Scalars["Float"]["output"]>;
    /** The value of the Custom Field if the field type is text. Null otherwise. */
    text?: Maybe<Scalars["String"]["output"]>;
};

/** An option for a custom field (e.g. a dropdown option) */
export type TrelloCustomFieldOption = {
    __typename?: "TrelloCustomFieldOption";
    /** The color of the custom field option */
    color?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the custom field option */
    objectId: Scalars["ID"]["output"];
    /** The position of the custom field option */
    position?: Maybe<Scalars["Float"]["output"]>;
    /** The value of the custom field option. */
    value?: Maybe<TrelloCustomFieldOptionValue>;
};

/** The value of the custom field option. */
export type TrelloCustomFieldOptionValue = {
    __typename?: "TrelloCustomFieldOptionValue";
    /** The text value of the custom field option. */
    text?: Maybe<Scalars["String"]["output"]>;
};

/** Manages how the data is processed */
export enum TrelloDataSourceHandler {
    LinkingPlatform = "LINKING_PLATFORM"
}

/** Arguments passed into deletePlannerCalendarEvent mutation */
export type TrelloDeletePlannerCalendarEventInput = {
    /** The ID of the event to delete */
    plannerCalendarEventId: Scalars["ID"]["input"];
    /** The ID of the planner calendar containing the event */
    plannerCalendarId: Scalars["ID"]["input"];
    /** The ID of the provider account to use for the deletion */
    providerAccountId: Scalars["ID"]["input"];
};

/** Returned response from deletePlannerCalendarEvent mutation */
export type TrelloDeletePlannerCalendarEventPayload = Payload & {
    __typename?: "TrelloDeletePlannerCalendarEventPayload";
    /** Any errors that occurred during the operation */
    errors?: Maybe<Array<MutationError>>;
    /** The deleted event */
    event?: Maybe<TrelloPlannerCalendarEventDeleted>;
    /** Whether the operation was successful */
    success: Scalars["Boolean"]["output"];
};

/** Arguments passed into editPlannerCalendarEvent mutation */
export type TrelloEditPlannerCalendarEventInput = {
    event: TrelloEditPlannerCalendarEventOptions;
    plannerCalendarId: Scalars["ID"]["input"];
    providerAccountId: Scalars["ID"]["input"];
};

/**
 * Arguments passed into editPlannerCalendarEvent mutation
 * specific to the event being created
 */
export type TrelloEditPlannerCalendarEventOptions = {
    end?: InputMaybe<Scalars["DateTime"]["input"]>;
    id: Scalars["ID"]["input"];
    start?: InputMaybe<Scalars["DateTime"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Returned response from editPlannerCalendarEvent mutation */
export type TrelloEditPlannerCalendarEventPayload = Payload & {
    __typename?: "TrelloEditPlannerCalendarEventPayload";
    errors?: Maybe<Array<MutationError>>;
    plannerCalendarUpdated?: Maybe<TrelloPlannerCalendar>;
    success: Scalars["Boolean"]["output"];
};

/** Represents an emoji in trello (like in a comment reaction) */
export type TrelloEmoji = {
    __typename?: "TrelloEmoji";
    /** Emoji name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Interpreted emoji string derived from unifide code */
    native?: Maybe<Scalars["String"]["output"]>;
    /** Emoji abbreviated name */
    shortName?: Maybe<Scalars["String"]["output"]>;
    /** Unicode code point representing the emoji skin variation */
    skinVariation?: Maybe<Scalars["String"]["output"]>;
    /** Hexadecimal Unicode code point representing the emoji */
    unified?: Maybe<Scalars["String"]["output"]>;
};

/** A Trello Enterprise. */
export type TrelloEnterprise = {
    __typename?: "TrelloEnterprise";
    /** The display name of the enterprise. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the enterprise. */
    id: Scalars["ID"]["output"];
    /** The objectId of the enterprise. */
    objectId: Scalars["ID"]["output"];
    /** Preferences for the enterprise. */
    prefs: TrelloEnterprisePrefs;
};

/** Collection of preferences for the enterprise */
export type TrelloEnterprisePrefs = {
    __typename?: "TrelloEnterprisePrefs";
    /** Collection of AI preferences for the enterprise */
    atlassianIntelligence?: Maybe<TrelloAtlassianIntelligence>;
};

/** A Trello Image Preview */
export type TrelloImagePreview = {
    __typename?: "TrelloImagePreview";
    /** The size of the image in bytes */
    bytes?: Maybe<Scalars["Float"]["output"]>;
    /** The height of the preview image */
    height?: Maybe<Scalars["Float"]["output"]>;
    /** The objectId of the image preview. */
    objectId?: Maybe<Scalars["String"]["output"]>;
    /** Whether the image is scaled. True if the dimensions match the original aspect ratio */
    scaled?: Maybe<Scalars["Boolean"]["output"]>;
    /** URL of the image */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** The width of the preview image */
    width?: Maybe<Scalars["Float"]["output"]>;
};

/** Connection type between an object that contains an image and its previews. */
export type TrelloImagePreviewConnection = {
    __typename?: "TrelloImagePreviewConnection";
    /** The list of edges between the object and image previews. */
    edges?: Maybe<Array<TrelloImagePreviewEdge>>;
    /** The list of image previews. */
    nodes?: Maybe<Array<TrelloImagePreview>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Represents a basic relationship between a node and a TrelloImagePreview. */
export type TrelloImagePreviewEdge = {
    __typename?: "TrelloImagePreviewEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The image preview */
    node: TrelloImagePreview;
};

/**
 * Connection type between an object that contains an image and its previews, modified
 * for subscriptions
 */
export type TrelloImagePreviewUpdatedConnection = {
    __typename?: "TrelloImagePreviewUpdatedConnection";
    nodes?: Maybe<Array<TrelloImagePreview>>;
};

/** A Trello Inbox */
export type TrelloInbox = {
    __typename?: "TrelloInbox";
    board: TrelloBoard;
};

/** Link between Trello workspace and Jwm instance */
export type TrelloJwmWorkspaceLink = {
    __typename?: "TrelloJwmWorkspaceLink";
    /** Cloud ID for the site */
    cloudId?: Maybe<Scalars["String"]["output"]>;
    /** Trello UI touch-point which initiated cross-flow */
    crossflowTouchpoint?: Maybe<Scalars["String"]["output"]>;
    /** cloudUrl for site */
    entityUrl?: Maybe<Scalars["URL"]["output"]>;
    /** Whether the JWM is inaccessible */
    inaccessible?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A Trello label */
export type TrelloLabel = Node & {
    __typename?: "TrelloLabel";
    /** Label color */
    color?: Maybe<Scalars["String"]["output"]>;
    /** Label's primary identifier */
    id: Scalars["ID"]["output"];
    /** User generated name for the label */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the label */
    objectId: Scalars["ID"]["output"];
    /** Number of times the label is used in a board */
    uses?: Maybe<Scalars["Int"]["output"]>;
};

/** Trello label connection */
export type TrelloLabelConnection = {
    __typename?: "TrelloLabelConnection";
    /** The list of edges between the container and labels. */
    edges?: Maybe<Array<TrelloLabelEdge>>;
    /** The list of labels. */
    nodes?: Maybe<Array<TrelloLabel>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/**
 * Connection type emulating relay-style paging for labels
 * Updates are only published on edges, not on nodes
 */
export type TrelloLabelConnectionUpdated = {
    __typename?: "TrelloLabelConnectionUpdated";
    /** The list of new or updated edges between the container and labels. */
    edges?: Maybe<Array<TrelloLabelEdgeUpdated>>;
};

/** Information about labels deleted from a board */
export type TrelloLabelDeleted = {
    __typename?: "TrelloLabelDeleted";
    /** label ID */
    id?: Maybe<Scalars["ID"]["output"]>;
};

/** Trello label edge */
export type TrelloLabelEdge = {
    __typename?: "TrelloLabelEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The label */
    node: TrelloLabel;
};

/**
 * Edge type emulating relay-style paging
 * Label edge for new or updated label
 */
export type TrelloLabelEdgeUpdated = {
    __typename?: "TrelloLabelEdgeUpdated";
    /** The new or updated label */
    node: TrelloLabelUpdated;
};

/** Updated label fields, a subset of the fields on TrelloLabel */
export type TrelloLabelUpdated = {
    __typename?: "TrelloLabelUpdated";
    /** Label color */
    color?: Maybe<Scalars["String"]["output"]>;
    /** Label ARI */
    id: Scalars["ID"]["output"];
    /** User generated name for the label */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the label */
    objectId: Scalars["ID"]["output"];
    /** Number of times the label is used in a board */
    uses?: Maybe<Scalars["Int"]["output"]>;
};

/** Trello label updated connection type */
export type TrelloLabelUpdatedConnection = {
    __typename?: "TrelloLabelUpdatedConnection";
    /** The list of labels for the card */
    nodes: Array<TrelloLabel>;
};

/** Thresholds and status of a particular limit */
export type TrelloLimitProps = {
    __typename?: "TrelloLimitProps";
    /** Current count for that limit. Only returned when the count hits a particular value */
    count?: Maybe<Scalars["Int"]["output"]>;
    /** Disable threshold */
    disableAt: Scalars["Int"]["output"];
    /** Status of this limit */
    status: Scalars["String"]["output"];
    /** Warning threshold */
    warnAt: Scalars["Int"]["output"];
};

/** A list within a Trello Board */
export type TrelloList = Node & {
    __typename?: "TrelloList";
    /**
     * The board the list belongs to
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloListBoard")' query directive to the 'board' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    board?: Maybe<TrelloBoard>;
    /**
     * The cards in the list, ordered by position ascending.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloListCards")' query directive to the 'cards' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    cards?: Maybe<TrelloCardConnection>;
    /** True if the list has been closed. False otherwise. */
    closed: Scalars["Boolean"]["output"];
    /** Background color of the list */
    color?: Maybe<Scalars["String"]["output"]>;
    /** How the list was created */
    creationMethod: Scalars["String"]["output"];
    /** Which datasource is populating the List */
    datasource?: Maybe<TrelloListDataSource>;
    /** The list's primary identifier */
    id: Scalars["ID"]["output"];
    /** Hard limits for card counts in this list */
    limits?: Maybe<TrelloListLimits>;
    /** List name */
    name: Scalars["String"]["output"];
    /** Id used for (legacy) interaction with the REST API. */
    objectId: Scalars["ID"]["output"];
    /** List position within a TrelloBoard */
    position: Scalars["Float"]["output"];
    /**
     * Number of cards the list will hold before changing color
     * to indicate over-capacity
     */
    softLimit?: Maybe<Scalars["Int"]["output"]>;
    /** Whether the List is a normal list (null) or has a datasource (string) */
    type?: Maybe<TrelloListType>;
    /**
     * State on the list that is dependent on the currently
     * authenticated user.
     */
    viewer?: Maybe<TrelloListViewer>;
};

/** A list within a Trello Board */
export type TrelloListCardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloListCardFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Specifies which cards to return in a list. */
export type TrelloListCardFilterInput = {
    /**
     * If true, returns only closed cards in the list.
     * If false , it'll return only open cards in the list.
     * If ommitted, it'll return all cards in the list.
     */
    closed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Card limits for a Trello List */
export type TrelloListCardLimits = {
    __typename?: "TrelloListCardLimits";
    /** Maximum open cards for a list */
    openPerList?: Maybe<TrelloLimitProps>;
    /** Maxium cards for a list */
    totalPerList?: Maybe<TrelloLimitProps>;
};

/** Connection type to represent lists. */
export type TrelloListConnection = {
    __typename?: "TrelloListConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloListEdge>>;
    /** The list of TrelloList. */
    nodes?: Maybe<Array<TrelloList>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** The data from the datasource of the list. */
export type TrelloListDataSource = {
    __typename?: "TrelloListDataSource";
    /** Boolean for datasource filter */
    filter: Scalars["Boolean"]["output"];
    /** Manages how the data is processed */
    handler: TrelloDataSourceHandler;
    /** Reference to datasource */
    link: Scalars["URL"]["output"];
};

/** Represents a basic relationship between a node and a TrelloList. */
export type TrelloListEdge = {
    __typename?: "TrelloListEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** TrelloList item. */
    node?: Maybe<TrelloList>;
};

/** Filters to apply when querying lists. */
export type TrelloListFilterInput = {
    /** Only lists that have this closed property will be included */
    closed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Overall limits for a Trello List */
export type TrelloListLimits = {
    __typename?: "TrelloListLimits";
    /** Card limits for a list */
    cards?: Maybe<TrelloListCardLimits>;
};

/** If a list has a datasource. */
export enum TrelloListType {
    Datasource = "DATASOURCE"
}

/** The updated list fields within a TrelloBoardUpdated event. */
export type TrelloListUpdated = {
    __typename?: "TrelloListUpdated";
    /** Cards for the this list.  Always null on subscribe.  One card event at a time */
    cards?: Maybe<TrelloCardUpdatedConnection>;
    /** True if the list has been closed. False otherwise. */
    closed?: Maybe<Scalars["Boolean"]["output"]>;
    /** The lists's primary identifier */
    id: Scalars["ID"]["output"];
    /** List name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** List's objectId */
    objectId?: Maybe<Scalars["ID"]["output"]>;
    /** List position within a TrelloBoard */
    position?: Maybe<Scalars["Float"]["output"]>;
    /**
     * Number of cards the list will hold before changing color
     * to indicate over-capacity
     */
    softLimit?: Maybe<Scalars["Int"]["output"]>;
};

/** Connection type emulating relay-style paging for list data on TrelloBoardUpdated events */
export type TrelloListUpdatedConnection = {
    __typename?: "TrelloListUpdatedConnection";
    nodes?: Maybe<Array<TrelloListUpdated>>;
};

/**
 * Information about the board that is dependent on the
 * currently authenticated user "viewing" a board.
 */
export type TrelloListViewer = {
    __typename?: "TrelloListViewer";
    /** Determines if a user is subscribed to a board list */
    subscribed?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A Trello member. */
export type TrelloMember = Node & {
    __typename?: "TrelloMember";
    /** If true, the user's activity is blocked/limited. */
    activityBlocked?: Maybe<Scalars["Boolean"]["output"]>;
    /** Source of the avatar (e.g. gravatar, upload, trello, etc.) */
    avatarSource?: Maybe<Scalars["String"]["output"]>;
    /**
     * Url of the avatar. If the user's avatar isn't public or does not have one, it
     * may be null.
     */
    avatarUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The Trello member bio. */
    bio?: Maybe<Scalars["String"]["output"]>;
    /** Metadata for rendering bio. */
    bioData?: Maybe<Scalars["JSON"]["output"]>;
    /** True if the member is confirmed. */
    confirmed?: Maybe<Scalars["Boolean"]["output"]>;
    /** The enterprise the Member is a part of or null. */
    enterprise?: Maybe<TrelloEnterprise>;
    /** The Trello member's full name or null if not publicly available. */
    fullName?: Maybe<Scalars["String"]["output"]>;
    /** The Trello member primary identifier. */
    id: Scalars["ID"]["output"];
    /**
     * The inbox associated with the Trello member's personal workspace
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloInbox")' query directive to the 'inbox' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    inbox?: Maybe<TrelloInbox>;
    /** The Trello member's initials. */
    initials?: Maybe<Scalars["String"]["output"]>;
    /** The Trello member's job function. This field can only be retrieved for your own member. */
    jobFunction?: Maybe<Scalars["String"]["output"]>;
    /** Additional user data that's not public. */
    nonPublicData?: Maybe<TrelloMemberNonPublicData>;
    /** Id used for (legacy) interaction with the REST API. */
    objectId: Scalars["ID"]["output"];
    /** The Planner associated with the Trello member's personal workspace */
    planner?: Maybe<TrelloPlanner>;
    /** The member that referred this member to Trello */
    referrer?: Maybe<TrelloMember>;
    /** The url to the Trello member's profile. */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** The Atlassian user associated with the Trello member. */
    user?: Maybe<User>;
    /** The Trello member username. */
    username?: Maybe<Scalars["String"]["output"]>;
    /** The Trello member's workspaces. */
    workspaces?: Maybe<TrelloMemberWorkspaceConnection>;
};

/** A Trello member. */
export type TrelloMemberWorkspacesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: TrelloMemberWorkspaceFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A generic connection type of containers and related members. */
export type TrelloMemberConnection = {
    __typename?: "TrelloMemberConnection";
    edges?: Maybe<Array<Maybe<TrelloMemberEdge>>>;
    nodes?: Maybe<Array<Maybe<TrelloMember>>>;
    pageInfo: PageInfo;
};

/** A generic edge between a container and a related member. */
export type TrelloMemberEdge = {
    __typename?: "TrelloMemberEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<TrelloMember>;
};

/** Member information that isn't public. */
export type TrelloMemberNonPublicData = {
    __typename?: "TrelloMemberNonPublicData";
    /**
     * Url of the avatar. If the user's avatar isn't public or does not have one, it
     * may be null.
     */
    avatarUrl?: Maybe<Scalars["URL"]["output"]>;
    /** The Trello member's full name or null if not publicly available. */
    fullName?: Maybe<Scalars["String"]["output"]>;
    /** The Trello member's initials. */
    initials?: Maybe<Scalars["String"]["output"]>;
};

/** TrelloMember update subscription. */
export type TrelloMemberUpdated = {
    __typename?: "TrelloMemberUpdated";
    /** Delta information for this event */
    _deltas?: Maybe<Array<Scalars["String"]["output"]>>;
    /** Boards */
    boards?: Maybe<TrelloBoardConnectionUpdated>;
    /** Member ARI */
    id?: Maybe<Scalars["ID"]["output"]>;
};

/** Trello member updated connection type */
export type TrelloMemberUpdatedConnection = {
    __typename?: "TrelloMemberUpdatedConnection";
    /** The list of members for the card */
    nodes?: Maybe<Array<TrelloMember>>;
};

/**
 * Connection type to represent the connection between a member and their
 * workspaces
 */
export type TrelloMemberWorkspaceConnection = {
    __typename?: "TrelloMemberWorkspaceConnection";
    /** The list of edges between a member and their workspaces. */
    edges?: Maybe<Array<TrelloMemberWorkspaceEdge>>;
    /** Workspaces associated with the member. */
    nodes?: Maybe<Array<TrelloWorkspace>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Represents a relationship between a member and a workspace */
export type TrelloMemberWorkspaceEdge = {
    __typename?: "TrelloMemberWorkspaceEdge";
    /** The cursor to this edge. */
    cursor?: Maybe<Scalars["String"]["output"]>;
    /** The workspace associated with the member. */
    node?: Maybe<TrelloWorkspace>;
};

/** Filter to apply to a member's workspaces. */
export type TrelloMemberWorkspaceFilter = {
    /** The workspace membership type to filter by. */
    membershipType: TrelloWorkspaceMembershipType;
    /** The workspace's tier to filter by. */
    tier: TrelloWorkspaceTier;
};

/** Action triggered by moving a card from one list to another */
export type TrelloMoveCardAction = TrelloAction &
    TrelloCardActionData & {
        __typename?: "TrelloMoveCardAction";
        /** The app that caused the Action */
        appCreator?: Maybe<TrelloAppCreator>;
        /** The card's board */
        board?: Maybe<TrelloBoard>;
        /** The card the action took place on */
        card?: Maybe<TrelloCard>;
        /** The Member who caused the Action */
        creator?: Maybe<TrelloMember>;
        /** When the Action occurred */
        date?: Maybe<Scalars["DateTime"]["output"]>;
        /** Information about any Entities involved in the Action */
        displayEntities?: Maybe<TrelloMoveCardActionDisplayEntities>;
        /** Relevant information for displaying the Action */
        displayKey?: Maybe<Scalars["String"]["output"]>;
        /** The ID of the Action */
        id: Scalars["ID"]["output"];
        /** Any limits affected by the action */
        limits?: Maybe<TrelloActionLimits>;
        /** The list after the move */
        listAfter?: Maybe<TrelloList>;
        /** The list before the move */
        listBefore?: Maybe<TrelloList>;
        /** The Reactions on the Action */
        reactions?: Maybe<Array<TrelloReaction>>;
        /** The type of the Action, from Trello Server.  May not match action __typename */
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Display entities for card move actions */
export type TrelloMoveCardActionDisplayEntities = {
    __typename?: "TrelloMoveCardActionDisplayEntities";
    card?: Maybe<TrelloActionCardEntity>;
    listAfter?: Maybe<TrelloActionListEntity>;
    listBefore?: Maybe<TrelloActionListEntity>;
    memberCreator?: Maybe<TrelloActionMemberEntity>;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApi = {
    __typename?: "TrelloMutationApi";
    /**
     * Mutation to assign a Trello card to a Trello Planner Calendar event
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'assignCardToPlannerCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    assignCardToPlannerCalendarEvent?: Maybe<TrelloAssignCardToPlannerCalendarEventPayload>;
    /**
     * Mutation to create or update a Trello Planner Calendar
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'createOrUpdatePlannerCalendar' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createOrUpdatePlannerCalendar?: Maybe<TrelloCreateOrUpdatePlannerCalendarPayload>;
    /**
     * Mutation to create an event on a Trello Planner Calendar
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'createPlannerCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    createPlannerCalendarEvent?: Maybe<TrelloCreatePlannerCalendarEventPayload>;
    /**
     * Mutation to delete a Trello Planner Calendar event
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'deletePlannerCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    deletePlannerCalendarEvent?: Maybe<TrelloDeletePlannerCalendarEventPayload>;
    /**
     * Mutation to edit an event on a Trello Planner Calendar
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'editPlannerCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    editPlannerCalendarEvent?: Maybe<TrelloEditPlannerCalendarEventPayload>;
    /**
     * Mutation to remove a Trello card from a Trello Planner Calendar event
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'removeCardFromPlannerCalendarEvent' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    removeCardFromPlannerCalendarEvent?: Maybe<TrelloRemoveCardFromPlannerCalendarEventPayload>;
    /**
     * Mutation to remove member from Workspace
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloRemoveMemberFromWorkspace")' query directive to the 'removeMemberFromWorkspace' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    removeMemberFromWorkspace?: Maybe<TrelloRemoveMemberFromWorkspacePayload>;
    /**
     * Mutation to update board name
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloUpdateBoardName")' query directive to the 'updateBoardName' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateBoardName?: Maybe<TrelloUpdateBoardNamePayload>;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiAssignCardToPlannerCalendarEventArgs = {
    input: TrelloAssignCardToPlannerCalendarEventInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiCreateOrUpdatePlannerCalendarArgs = {
    input: TrelloCreateOrUpdatePlannerCalendarInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiCreatePlannerCalendarEventArgs = {
    input: TrelloCreatePlannerCalendarEventInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiDeletePlannerCalendarEventArgs = {
    input: TrelloDeletePlannerCalendarEventInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiEditPlannerCalendarEventArgs = {
    input: TrelloEditPlannerCalendarEventInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiRemoveCardFromPlannerCalendarEventArgs = {
    input: TrelloRemoveCardFromPlannerCalendarEventInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiRemoveMemberFromWorkspaceArgs = {
    input: TrelloRemoveMemberFromWorkspaceInput;
};

/**
 * This is a top level mutation type under which all of Trello's supported mutations
 * are under. It is used to group Trello's GraphQL mutations from other Atlassian
 * mutations.
 */
export type TrelloMutationApiUpdateBoardNameArgs = {
    input: TrelloUpdateBoardNameInput;
};

/** A Trello planner. */
export type TrelloPlanner = {
    __typename?: "TrelloPlanner";
    accounts?: Maybe<TrelloPlannerCalendarAccountConnection>;
    id: Scalars["ID"]["output"];
    workspace?: Maybe<TrelloWorkspace>;
};

/** A Trello planner. */
export type TrelloPlannerAccountsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * An enabled Trello planner calendar (e.g a linked google calendar).
 * This will be exactly like a TrelloPlannerProviderCalendar model but with the additional
 * enabled field and objectId field representing the underlying PlannerCalendar model
 */
export type TrelloPlannerCalendar = Node &
    TrelloProviderCalendarInterface & {
        __typename?: "TrelloPlannerCalendar";
        color?: Maybe<TrelloPlannerCalendarColor>;
        enabled?: Maybe<Scalars["Boolean"]["output"]>;
        events?: Maybe<TrelloPlannerCalendarEventConnection>;
        /** Trello Planner Calendar ARI */
        id: Scalars["ID"]["output"];
        /** Whether this is the primary calendar for the account */
        isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
        objectId?: Maybe<Scalars["ID"]["output"]>;
        /** The Calendar id from the underlying provider */
        providerCalendarId?: Maybe<Scalars["ID"]["output"]>;
        readOnly?: Maybe<Scalars["Boolean"]["output"]>;
        timezone?: Maybe<Scalars["String"]["output"]>;
        title?: Maybe<Scalars["String"]["output"]>;
        type?: Maybe<TrelloSupportedPlannerProviders>;
    };

/**
 * An enabled Trello planner calendar (e.g a linked google calendar).
 * This will be exactly like a TrelloPlannerProviderCalendar model but with the additional
 * enabled field and objectId field representing the underlying PlannerCalendar model
 */
export type TrelloPlannerCalendarEventsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: TrelloPlannerCalendarEventsFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A Trello planner account (e.g a linked google calendar account) */
export type TrelloPlannerCalendarAccount = Node & {
    __typename?: "TrelloPlannerCalendarAccount";
    accountType?: Maybe<TrelloSupportedPlannerProviders>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    enabledCalendars?: Maybe<TrelloPlannerCalendarConnection>;
    googleAccountAri?: Maybe<Scalars["ID"]["output"]>;
    hasRequiredScopes?: Maybe<Scalars["Boolean"]["output"]>;
    /** The account ID from the underlying provider */
    id: Scalars["ID"]["output"];
    outboundAuthId?: Maybe<Scalars["ID"]["output"]>;
    providerCalendars?: Maybe<TrelloPlannerProviderCalendarConnection>;
};

/** A Trello planner account (e.g a linked google calendar account) */
export type TrelloPlannerCalendarAccountEnabledCalendarsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloPlannerCalendarEnabledCalendarsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A Trello planner account (e.g a linked google calendar account) */
export type TrelloPlannerCalendarAccountProviderCalendarsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloPlannerCalendarProviderCalendarsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Connection type to represent the connection between a member and their
 * Planner accounts
 */
export type TrelloPlannerCalendarAccountConnection = {
    __typename?: "TrelloPlannerCalendarAccountConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloPlannerCalendarAccountEdge>>;
    /** The list of TrelloPlannerAccount. */
    nodes?: Maybe<Array<TrelloPlannerCalendarAccount>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/**
 * Connection type emulating relay-style paging for planner accounts
 * Updates are only published on edges, not on nodes
 */
export type TrelloPlannerCalendarAccountConnectionUpdated = {
    __typename?: "TrelloPlannerCalendarAccountConnectionUpdated";
    /** The list of new or updated TrelloPlannerAccounts. */
    edges?: Maybe<Array<TrelloPlannerCalendarAccountEdgeUpdated>>;
};

/** A generic edge between a container and a related member. */
export type TrelloPlannerCalendarAccountEdge = {
    __typename?: "TrelloPlannerCalendarAccountEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<TrelloPlannerCalendarAccount>;
};

/**
 * Edge type emulating relay-style paging
 * Account edge for new or updated planner account
 */
export type TrelloPlannerCalendarAccountEdgeUpdated = {
    __typename?: "TrelloPlannerCalendarAccountEdgeUpdated";
    /** The new or updated planner account */
    node: TrelloPlannerCalendarAccountUpdated;
};

/** Updated planner account fields, a subset of the fields on TrelloPlannerCalendarAccount */
export type TrelloPlannerCalendarAccountUpdated = {
    __typename?: "TrelloPlannerCalendarAccountUpdated";
    enabledCalendars?: Maybe<TrelloPlannerCalendarConnectionUpdated>;
    /** The account ID from the underlying provider */
    id: Scalars["ID"]["output"];
};

/** ADS color options for planner calendars */
export enum TrelloPlannerCalendarColor {
    BlueSubtler = "BLUE_SUBTLER",
    BlueSubtlest = "BLUE_SUBTLEST",
    GraySubtler = "GRAY_SUBTLER",
    GreenSubtler = "GREEN_SUBTLER",
    GreenSubtlest = "GREEN_SUBTLEST",
    LimeSubtler = "LIME_SUBTLER",
    LimeSubtlest = "LIME_SUBTLEST",
    MagentaSubtler = "MAGENTA_SUBTLER",
    MagentaSubtlest = "MAGENTA_SUBTLEST",
    OrangeSubtler = "ORANGE_SUBTLER",
    OrangeSubtlest = "ORANGE_SUBTLEST",
    PurpleSubtlest = "PURPLE_SUBTLEST",
    RedSubtler = "RED_SUBTLER",
    RedSubtlest = "RED_SUBTLEST",
    YellowBolder = "YELLOW_BOLDER",
    YellowSubtler = "YELLOW_SUBTLER",
    YellowSubtlest = "YELLOW_SUBTLEST"
}

/**
 * Connection type to represent the connection between a Planner account and their
 * calendars
 */
export type TrelloPlannerCalendarConnection = {
    __typename?: "TrelloPlannerCalendarConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloPlannerCalendarEdge>>;
    /** The list of TrelloPlannerCalendar. */
    nodes?: Maybe<Array<TrelloPlannerCalendar>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
    updateCursor?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Connection type emulating relay-style paging for planner calendars
 * Updates are only published on edges, not on nodes
 */
export type TrelloPlannerCalendarConnectionUpdated = {
    __typename?: "TrelloPlannerCalendarConnectionUpdated";
    /** The list of new or updated TrelloPlannerCalendars */
    edges?: Maybe<Array<TrelloPlannerCalendarEdgeUpdated>>;
};

/** Information about a disabled planner calendar */
export type TrelloPlannerCalendarDeleted = {
    __typename?: "TrelloPlannerCalendarDeleted";
    /** Trello Planner Calendar ARI */
    id: Scalars["ID"]["output"];
};

/** A generic edge between a container and a related member. */
export type TrelloPlannerCalendarEdge = {
    __typename?: "TrelloPlannerCalendarEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    deletedCalendar?: Maybe<TrelloPlannerCalendarDeleted>;
    node?: Maybe<TrelloPlannerCalendar>;
};

/**
 * Edge type emulating relay-style paging
 * Calendar edge for new or updated planner calendar
 */
export type TrelloPlannerCalendarEdgeUpdated = {
    __typename?: "TrelloPlannerCalendarEdgeUpdated";
    /** The new or updated planner calendar */
    node: TrelloPlannerCalendarUpdated;
};

/** The input filters for fetching enabled calendars */
export type TrelloPlannerCalendarEnabledCalendarsFilter = {
    updateCursor?: InputMaybe<Scalars["String"]["input"]>;
};

/** The Calendar event from the underlying provider */
export type TrelloPlannerCalendarEvent = Node & {
    __typename?: "TrelloPlannerCalendarEvent";
    /** Is this an all day event */
    allDay?: Maybe<Scalars["Boolean"]["output"]>;
    /** Shows as busy on shared / public calendars */
    busy?: Maybe<Scalars["Boolean"]["output"]>;
    /** The list of cards associated to the calendar event */
    cards?: Maybe<TrelloPlannerCalendarEventCardConnection>;
    color?: Maybe<TrelloPlannerCalendarColor>;
    conferencing?: Maybe<TrelloPlannerCalendarEventConferencing>;
    createdByTrello?: Maybe<Scalars["Boolean"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    endAt?: Maybe<Scalars["DateTime"]["output"]>;
    eventType?: Maybe<TrelloPlannerCalendarEventType>;
    id: Scalars["ID"]["output"];
    link?: Maybe<Scalars["String"]["output"]>;
    parentEventId?: Maybe<Scalars["ID"]["output"]>;
    /** Whether or not you can modify the event */
    readOnly?: Maybe<Scalars["Boolean"]["output"]>;
    startAt?: Maybe<Scalars["DateTime"]["output"]>;
    status?: Maybe<TrelloPlannerCalendarEventStatus>;
    title?: Maybe<Scalars["String"]["output"]>;
    /** Whether the event is public or private */
    visibility?: Maybe<TrelloPlannerCalendarEventVisibility>;
};

/** The Calendar event from the underlying provider */
export type TrelloPlannerCalendarEventCardsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The association of a card to a calendar event */
export type TrelloPlannerCalendarEventCard = Node & {
    __typename?: "TrelloPlannerCalendarEventCard";
    card?: Maybe<TrelloCard>;
    cardId?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    position?: Maybe<Scalars["Float"]["output"]>;
};

/** Connection type to represent cards associated to planner calendar events. */
export type TrelloPlannerCalendarEventCardConnection = {
    __typename?: "TrelloPlannerCalendarEventCardConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloPlannerCalendarEventCardEdge>>;
    /** The list of EventCards. */
    nodes?: Maybe<Array<TrelloPlannerCalendarEventCard>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/**
 * Connection type emulating relay-style paging for planner calendar event cards
 * Updates are only published on edges, not on nodes
 */
export type TrelloPlannerCalendarEventCardConnectionUpdated = {
    __typename?: "TrelloPlannerCalendarEventCardConnectionUpdated";
    /** The list of new or updated TrelloPlannerCalendarEventCards */
    edges?: Maybe<Array<TrelloPlannerCalendarEventCardEdgeUpdated>>;
};

/** Information about a removed planner calendar event card */
export type TrelloPlannerCalendarEventCardDeleted = {
    __typename?: "TrelloPlannerCalendarEventCardDeleted";
    id: Scalars["ID"]["output"];
};

/** A generic edge between an event and an event card. */
export type TrelloPlannerCalendarEventCardEdge = {
    __typename?: "TrelloPlannerCalendarEventCardEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<TrelloPlannerCalendarEventCard>;
};

/**
 * Edge type emulating relay-style paging
 * Edge for new or updated planner calendar event card
 */
export type TrelloPlannerCalendarEventCardEdgeUpdated = {
    __typename?: "TrelloPlannerCalendarEventCardEdgeUpdated";
    node?: Maybe<TrelloPlannerCalendarEventCardUpdated>;
};

/** New or updated event card fields */
export type TrelloPlannerCalendarEventCardUpdated = {
    __typename?: "TrelloPlannerCalendarEventCardUpdated";
    boardId?: Maybe<Scalars["ID"]["output"]>;
    cardId?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    position?: Maybe<Scalars["Float"]["output"]>;
};

/** Conferencing details for the event */
export type TrelloPlannerCalendarEventConferencing = {
    __typename?: "TrelloPlannerCalendarEventConferencing";
    url?: Maybe<Scalars["URL"]["output"]>;
};

/**
 * Connection type to represent the connection between a Planner calendar and their
 * events
 */
export type TrelloPlannerCalendarEventConnection = {
    __typename?: "TrelloPlannerCalendarEventConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloPlannerCalendarEventEdge>>;
    /** The list of TrelloPlannerCalendarEvent. */
    nodes?: Maybe<Array<TrelloPlannerCalendarEvent>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
    updateCursor?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Connection type emulating relay-style paging for planner calendar events
 * Updates are only published on edges, not on nodes
 */
export type TrelloPlannerCalendarEventConnectionUpdated = {
    __typename?: "TrelloPlannerCalendarEventConnectionUpdated";
    /** The list of new or updated TrelloPlannerCalendarEvents */
    edges?: Maybe<Array<TrelloPlannerCalendarEventEdgeUpdated>>;
};

/** Information about a deleted planner calendar event */
export type TrelloPlannerCalendarEventDeleted = {
    __typename?: "TrelloPlannerCalendarEventDeleted";
    id: Scalars["ID"]["output"];
};

/** A generic edge between a calendar and an event. */
export type TrelloPlannerCalendarEventEdge = {
    __typename?: "TrelloPlannerCalendarEventEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    deletedEvent?: Maybe<TrelloPlannerCalendarEventDeleted>;
    node?: Maybe<TrelloPlannerCalendarEvent>;
};

/**
 * Edge type emulating relay-style paging
 * Edge for new or updated planner calendar event
 */
export type TrelloPlannerCalendarEventEdgeUpdated = {
    __typename?: "TrelloPlannerCalendarEventEdgeUpdated";
    node?: Maybe<TrelloPlannerCalendarEventUpdated>;
};

/** Status of the event (confirmed/tentative/cancelled) */
export enum TrelloPlannerCalendarEventStatus {
    Accepted = "ACCEPTED",
    Cancelled = "CANCELLED",
    Declined = "DECLINED",
    NeedsAction = "NEEDS_ACTION",
    Tentative = "TENTATIVE"
}

/** Event types (default/focusTime/outOfOffice) */
export enum TrelloPlannerCalendarEventType {
    Default = "DEFAULT",
    OutOfOffice = "OUT_OF_OFFICE",
    PlannerEvent = "PLANNER_EVENT"
}

/** Updated event fields, a subset of the fields on TrelloPlannerCalendarEvent */
export type TrelloPlannerCalendarEventUpdated = {
    __typename?: "TrelloPlannerCalendarEventUpdated";
    cards?: Maybe<TrelloPlannerCalendarEventCardConnectionUpdated>;
    id: Scalars["ID"]["output"];
    onPlannerCalendarEventCardDeleted?: Maybe<
        Array<TrelloPlannerCalendarEventCardDeleted>
    >;
};

/** Visibility of the event (public/private) */
export enum TrelloPlannerCalendarEventVisibility {
    Default = "DEFAULT",
    Private = "PRIVATE",
    Public = "PUBLIC"
}

/** The input filters for fetching events */
export type TrelloPlannerCalendarEventsFilter = {
    end?: InputMaybe<Scalars["DateTime"]["input"]>;
    start?: InputMaybe<Scalars["DateTime"]["input"]>;
    updateCursor?: InputMaybe<Scalars["String"]["input"]>;
};

/** A union type representing either a planner calendar or a deleted planner calendar */
export type TrelloPlannerCalendarMutated =
    | TrelloPlannerCalendarAccount
    | TrelloPlannerCalendarDeleted;

/** The input filters for fetching provider calendars */
export type TrelloPlannerCalendarProviderCalendarsFilter = {
    updateCursor?: InputMaybe<Scalars["String"]["input"]>;
};

/** Updated calendar fields, a subset of the fields on TrelloPlannerCalendar */
export type TrelloPlannerCalendarUpdated = {
    __typename?: "TrelloPlannerCalendarUpdated";
    events?: Maybe<TrelloPlannerCalendarEventConnectionUpdated>;
    id: Scalars["ID"]["output"];
};

/** A calendar from an underlying provider */
export type TrelloPlannerProviderCalendar = Node &
    TrelloProviderCalendarInterface & {
        __typename?: "TrelloPlannerProviderCalendar";
        color?: Maybe<TrelloPlannerCalendarColor>;
        /** The Calendar id from the underlying provider */
        id: Scalars["ID"]["output"];
        /** Whether this is the primary calendar for the account */
        isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
        readOnly?: Maybe<Scalars["Boolean"]["output"]>;
        timezone?: Maybe<Scalars["String"]["output"]>;
        title?: Maybe<Scalars["String"]["output"]>;
        type?: Maybe<TrelloSupportedPlannerProviders>;
    };

/**
 * Connection type to represent the connection between a Planner account and their
 * calendars
 */
export type TrelloPlannerProviderCalendarConnection = {
    __typename?: "TrelloPlannerProviderCalendarConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloPlannerProviderCalendarEdge>>;
    /** The list of TrelloPlannerCalendar. */
    nodes?: Maybe<Array<TrelloPlannerProviderCalendar>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
    updateCursor?: Maybe<Scalars["String"]["output"]>;
};

/** A generic edge between a container and a related member. */
export type TrelloPlannerProviderCalendarEdge = {
    __typename?: "TrelloPlannerProviderCalendarEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    deletedCalendar?: Maybe<TrelloProviderCalendarDeleted>;
    node?: Maybe<TrelloPlannerProviderCalendar>;
};

/** A Trello planner update */
export type TrelloPlannerUpdated = {
    __typename?: "TrelloPlannerUpdated";
    accounts?: Maybe<TrelloPlannerCalendarAccountConnectionUpdated>;
    id: Scalars["ID"]["output"];
};

/** A Trello PowerUp */
export type TrelloPowerUp = {
    __typename?: "TrelloPowerUp";
    /** PowerUp author */
    author?: Maybe<Scalars["String"]["output"]>;
    /** PowerUp author email */
    email?: Maybe<Scalars["String"]["output"]>;
    /** Icon URL */
    icon?: Maybe<TrelloPowerUpIcon>;
    /** PowerUp name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the powerUp. */
    objectId?: Maybe<Scalars["ID"]["output"]>;
    /** This powerUp's public status */
    public?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A Trello PowerUp Data */
export type TrelloPowerUpData = {
    __typename?: "TrelloPowerUpData";
    /** Access is the visibility control for who is able to read the data. */
    access?: Maybe<TrelloPowerUpDataAccess>;
    /**
     * The ID of the entity that the Trello Powerup Data is set within. This can be
     * the ID of a TrelloCard, TrelloBoard, TrelloMember, or TrelloWorkspace
     */
    modelId?: Maybe<Scalars["ID"]["output"]>;
    /** The objectId of the powerUpData */
    objectId: Scalars["ID"]["output"];
    /** The powerUp for which this data is set */
    powerUp?: Maybe<TrelloPowerUp>;
    /** Scope represents the Trello entity that the data is stored against. */
    scope?: Maybe<TrelloPowerUpDataScope>;
    /** Serializable data value */
    value?: Maybe<Scalars["String"]["output"]>;
};

/** TrelloPowerUpData visibility */
export enum TrelloPowerUpDataAccess {
    Private = "PRIVATE",
    Shared = "SHARED"
}

/** Connection type between an entity and its powerUpData entries. */
export type TrelloPowerUpDataConnection = {
    __typename?: "TrelloPowerUpDataConnection";
    /** The list of edges between the object and powerUpData entries. */
    edges?: Maybe<Array<TrelloPowerUpDataEdge>>;
    /** The list of powerUpData. */
    nodes?: Maybe<Array<TrelloPowerUpData>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Represents a basic relationship between a node and a TrelloPowerUpData. */
export type TrelloPowerUpDataEdge = {
    __typename?: "TrelloPowerUpDataEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The powerUpData entry */
    node: TrelloPowerUpData;
};

/** Filters to apply when querying powerUpData. */
export type TrelloPowerUpDataFilterInput = {
    /**
     * Only powerUpData of the specified access visibility will be returned.
     * If not included, it'll return all powerUpData.
     *
     * Use 'all' to return both private and shared powerUpData.
     *
     * See TrelloPowerUpDataAccess for enumeration of valid values for access.
     */
    access?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Filter powerUpData on specified powerUps.
     *
     * - powerUpData will be excluded if they are from a powerUp not in the provided list.
     * - A missing list means powerUpData for all powerUps will be returned.
     */
    powerUps?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** TrelloPowerUpData scope */
export enum TrelloPowerUpDataScope {
    Board = "BOARD",
    Card = "CARD",
    Member = "MEMBER",
    Organization = "ORGANIZATION"
}

/** Represents the icon for this powerUp */
export type TrelloPowerUpIcon = {
    __typename?: "TrelloPowerUpIcon";
    /** URL to fetch this TrelloPowerUpIcon */
    url?: Maybe<Scalars["URL"]["output"]>;
};

/** The updated powerUp ID on the card */
export type TrelloPowerUpUpdated = {
    __typename?: "TrelloPowerUpUpdated";
    /** PowerUp object id */
    objectId?: Maybe<Scalars["ID"]["output"]>;
};

/** Information about a deleted provider calendar */
export type TrelloProviderCalendarDeleted = {
    __typename?: "TrelloProviderCalendarDeleted";
    /** The Calendar id from the underlying provider */
    id: Scalars["ID"]["output"];
};

/** An interface to represent calendar entities from underlying providers */
export type TrelloProviderCalendarInterface = {
    color?: Maybe<TrelloPlannerCalendarColor>;
    /**
     * The Calendar id from the underlying provider
     * This would be inherited from the Node interface however
     */
    id: Scalars["ID"]["output"];
    isPrimary?: Maybe<Scalars["Boolean"]["output"]>;
    readOnly?: Maybe<Scalars["Boolean"]["output"]>;
    timezone?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<TrelloSupportedPlannerProviders>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApi = {
    __typename?: "TrelloQueryApi";
    /**
     * Fetch attachments information for the passed ids. A maximum of 50 attachments can be
     * fetched at a time.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloAttachmentsById")' query directive to the 'attachmentsById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    attachmentsById?: Maybe<Array<Maybe<TrelloAttachment>>>;
    /**
     * Get a Trello board by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloBoard")' query directive to the 'board' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    board?: Maybe<TrelloBoard>;
    /**
     * Get a Trello board by shortlink.  Cost is higher due to non-routable nature
     * of shortLink vs Id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloBoard")' query directive to the 'boardByShortLink' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    boardByShortLink?: Maybe<TrelloBoard>;
    /**
     * Get a Trello card by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloCard")' query directive to the 'card' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    card?: Maybe<TrelloCard>;
    /**
     * This field will echo back the word echo.
     * It's only useful for testing.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloHelloAGG")' query directive to the 'echo' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    echo?: Maybe<Scalars["String"]["output"]>;
    /**
     * This field will echo back the words echo.
     * It's only useful for testing.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloHelloAGG")' query directive to the 'echos' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    echos?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     * Get enabled plannerCalendars for the specified account
     * Account here corresponds to the account for the underlying provider (i.e google calendar)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'enabledPlannerCalendarsByAccountId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    enabledPlannerCalendarsByAccountId?: Maybe<TrelloPlannerCalendarConnection>;
    /**
     * Get a Trello Enterprise by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloEnterprise")' query directive to the 'enterprise' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    enterprise?: Maybe<TrelloEnterprise>;
    /**
     * Fetch label information for the passed ids. A maximum of 50 labels can be
     * fetched at a time.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloLabelsById")' query directive to the 'labelsById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    labelsById?: Maybe<Array<Maybe<TrelloLabel>>>;
    /**
     * Get a Trello list by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloList")' query directive to the 'list' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    list?: Maybe<TrelloList>;
    /**
     * Fetch list information for the passed ids. A maximum of 50 lists can be
     * fetched at a time.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloListsById")' query directive to the 'listsById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    listsById?: Maybe<Array<Maybe<TrelloList>>>;
    /**
     * Get a member by id.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloMember")' query directive to the 'member' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    member?: Maybe<TrelloMember>;
    /**
     * Get plannerAccounts for the specified member
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'plannerAccountsByMemberId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    plannerAccountsByMemberId?: Maybe<TrelloPlannerCalendarAccountConnection>;
    /**
     * Get a planner for the specified workspace
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'plannerByWorkspaceId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    plannerByWorkspaceId?: Maybe<TrelloPlanner>;
    /**
     * Get a planner calendar account for the specified provider account
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'plannerCalendarAccountById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    plannerCalendarAccountById?: Maybe<TrelloPlannerCalendarAccount>;
    /**
     * Get a planner calendar for the specified id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'plannerCalendarById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    plannerCalendarById?: Maybe<TrelloPlannerCalendar>;
    /**
     * Get a planner calendar event for the specified provider event id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'plannerCalendarEventById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    plannerCalendarEventById?: Maybe<TrelloPlannerCalendarEvent>;
    /**
     * Get events for the specified planner calendar and account
     * Account here corresponds to the account for the underlying provider (i.e google calendar)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'plannerCalendarEventsByCalendarId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    plannerCalendarEventsByCalendarId?: Maybe<TrelloPlannerCalendarEventConnection>;
    /**
     * Get all provider calendars for the specified account
     * Account here corresponds to the account for the underlying provider (i.e google calendar)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloPlanner")' query directive to the 'providerPlannerCalendarsByAccountId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    providerPlannerCalendarsByAccountId?: Maybe<TrelloPlannerProviderCalendarConnection>;
    /**
     * Fetch board information for the passed ids. A maximum of 10 boards can be
     * fetched at a time.
     *
     * This is to be used in the context of fetching recent boards.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloRecentBoards")' query directive to the 'recentBoardsByIds' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    recentBoardsByIds?: Maybe<Array<Maybe<TrelloBoard>>>;
    /**
     * The list of template gallery categories.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloTemplates")' query directive to the 'templateCategories' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    templateCategories?: Maybe<Array<TrelloTemplateGalleryCategory>>;
    /**
     * Gallery of templates for Board inspiration.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloTemplateGallery")' query directive to the 'templateGallery' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    templateGallery?: Maybe<TrelloTemplateGalleryConnection>;
    /**
     * The list of languages available in the template gallery.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'BETA' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloTemplates")' query directive to the 'templateLanguages' field, or to any of its parents.
     *
     * The field is somewhat stable, but it can still go through changes without having to undergo the official deprecation policy. Clients should use it with care and at their own risk!
     *
     */
    templateLanguages?: Maybe<Array<TrelloTemplateGalleryLanguage>>;
    /**
     * Fetch user information for the passed ids. A maximum of 50 users can be
     * fetched at a time.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloUsersById")' query directive to the 'usersById' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    usersById?: Maybe<Array<Maybe<TrelloMember>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloWorkspace")' query directive to the 'workspace' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    workspace?: Maybe<TrelloWorkspace>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiAttachmentsByIdArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiBoardArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiBoardByShortLinkArgs = {
    shortLink: Scalars["TrelloShortLink"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiCardArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiEchosArgs = {
    echo: Array<Scalars["String"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiEnabledPlannerCalendarsByAccountIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiEnterpriseArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiLabelsByIdArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiListArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiListsByIdArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiMemberArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiPlannerAccountsByMemberIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiPlannerByWorkspaceIdArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiPlannerCalendarAccountByIdArgs = {
    id: Scalars["ID"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiPlannerCalendarByIdArgs = {
    id: Scalars["ID"]["input"];
    providerAccountId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiPlannerCalendarEventByIdArgs = {
    id: Scalars["ID"]["input"];
    plannerCalendarId: Scalars["ID"]["input"];
    providerAccountId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiPlannerCalendarEventsByCalendarIdArgs = {
    accountId: Scalars["ID"]["input"];
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloPlannerCalendarEventsFilter>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    plannerCalendarId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiProviderPlannerCalendarsByAccountIdArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["ID"]["input"];
    syncToken?: InputMaybe<Scalars["String"]["input"]>;
    workspaceId: Scalars["ID"]["input"];
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiRecentBoardsByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiTemplateGalleryArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter?: InputMaybe<TrelloTemplateGalleryFilterInput>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiUsersByIdArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */
export type TrelloQueryApiWorkspaceArgs = {
    id: Scalars["ID"]["input"];
};

/** Represents a comment reaction in Trello */
export type TrelloReaction = {
    __typename?: "TrelloReaction";
    emoji?: Maybe<TrelloEmoji>;
    member?: Maybe<TrelloMember>;
};

/** Limits specific to reactions */
export type TrelloReactionLimits = {
    __typename?: "TrelloReactionLimits";
    perAction?: Maybe<TrelloLimitProps>;
    uniquePerAction?: Maybe<TrelloLimitProps>;
};

/** Arguments passed into removeCardFromPlannerCalendarEvent mutation */
export type TrelloRemoveCardFromPlannerCalendarEventInput = {
    plannerCalendarEventCardId: Scalars["ID"]["input"];
    plannerCalendarId: Scalars["ID"]["input"];
    providerAccountId: Scalars["ID"]["input"];
};

/** Returned response from removeCardFromPlannerCalendarEvent mutation */
export type TrelloRemoveCardFromPlannerCalendarEventPayload = Payload & {
    __typename?: "TrelloRemoveCardFromPlannerCalendarEventPayload";
    errors?: Maybe<Array<MutationError>>;
    eventCard?: Maybe<TrelloPlannerCalendarEventCardDeleted>;
    success: Scalars["Boolean"]["output"];
};

/** Action triggered by removing a member from a card */
export type TrelloRemoveMemberFromCardAction = TrelloAction &
    TrelloCardActionData & {
        __typename?: "TrelloRemoveMemberFromCardAction";
        /** The app that caused the Action */
        appCreator?: Maybe<TrelloAppCreator>;
        /** The card's board */
        board?: Maybe<TrelloBoard>;
        /** The card the action took place on */
        card?: Maybe<TrelloCard>;
        /** The Member who caused the Action */
        creator?: Maybe<TrelloMember>;
        /** When the Action occurred */
        date?: Maybe<Scalars["DateTime"]["output"]>;
        /** Information about any Entities involved in the Action */
        displayEntities?: Maybe<TrelloAddRemoveMemberActionDisplayEntities>;
        /** Relevant information for displaying the Action */
        displayKey?: Maybe<Scalars["String"]["output"]>;
        /** The ID of the Action */
        id: Scalars["ID"]["output"];
        /** Any limits affected by the action */
        limits?: Maybe<TrelloActionLimits>;
        /** The member added to the action */
        member?: Maybe<TrelloMember>;
        /** The Reactions on the Action */
        reactions?: Maybe<Array<TrelloReaction>>;
        /** The type of the Action, from Trello Server.  May not match action __typename */
        type?: Maybe<Scalars["String"]["output"]>;
    };

/** Arguments passed into removeMemberFromWorkspace mutation */
export type TrelloRemoveMemberFromWorkspaceInput = {
    userId: Scalars["ID"]["input"];
    workspaceId: Scalars["ID"]["input"];
};

/** Returned response to removeMemberFromWorkspace mutation */
export type TrelloRemoveMemberFromWorkspacePayload = Payload & {
    __typename?: "TrelloRemoveMemberFromWorkspacePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** Grouping of image scale properties. */
export type TrelloScaleProps = {
    __typename?: "TrelloScaleProps";
    /** height in pixels */
    height?: Maybe<Scalars["Int"]["output"]>;
    /** Url of the image */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** width in pixels */
    width?: Maybe<Scalars["Int"]["output"]>;
};

/** A Trello Sticker */
export type TrelloSticker = {
    __typename?: "TrelloSticker";
    /**
     * Identifier of the sticker image. It is the objectId of the custom sticker if it is an uploaded sticker.
     * It is the name of the sticker if it is a standard Trello sticker.
     */
    image?: Maybe<Scalars["String"]["output"]>;
    /** A list of scaled sticker images and their dimensions */
    imageScaled?: Maybe<Array<TrelloImagePreview>>;
    /** Left position of the sticker */
    left?: Maybe<Scalars["Float"]["output"]>;
    /** The objectId of the sticker. */
    objectId: Scalars["ID"]["output"];
    /** Rotations of the sticker */
    rotate?: Maybe<Scalars["Float"]["output"]>;
    /** Top position of the sticker */
    top?: Maybe<Scalars["Float"]["output"]>;
    /** URL of the image used for the sticker */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** z-index of the sticker */
    zIndex?: Maybe<Scalars["Int"]["output"]>;
};

/** Connection type between a container and its stickers. */
export type TrelloStickerConnection = {
    __typename?: "TrelloStickerConnection";
    /** The list of edges between the container and stickers. */
    edges?: Maybe<Array<TrelloStickerEdge>>;
    /** The list of stickers. */
    nodes?: Maybe<Array<TrelloSticker>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Represents a basic relationship between a node and a TrelloSticker. */
export type TrelloStickerEdge = {
    __typename?: "TrelloStickerEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The sticker */
    node: TrelloSticker;
};

/** Trello sticker updated connection type */
export type TrelloStickerUpdatedConnection = {
    __typename?: "TrelloStickerUpdatedConnection";
    /** The list of edges between the container and stickers. */
    nodes?: Maybe<Array<TrelloStickerEdge>>;
};

/**
 * This is a top level subscription type under which all of Trello's supported subscriptions
 * are under. It is used to group Trello's GraphQL subscriptions from other Atlassian
 * subscriptions.
 */
export type TrelloSubscriptionApi = {
    __typename?: "TrelloSubscriptionApi";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloOnBoardUpdated")' query directive to the 'onBoardUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onBoardUpdated?: Maybe<TrelloBoardUpdated>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloOnBoardUpdated")' query directive to the 'onCardsUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onCardsUpdated?: Maybe<TrelloBoardUpdated>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloOnMemberUpdated")' query directive to the 'onMemberUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onMemberUpdated?: Maybe<TrelloMemberUpdated>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __trello:atlassian-external__
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "TrelloOnWorkspaceUpdated")' query directive to the 'onWorkspaceUpdated' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    onWorkspaceUpdated?: Maybe<TrelloWorkspaceUpdated>;
};

/**
 * This is a top level subscription type under which all of Trello's supported subscriptions
 * are under. It is used to group Trello's GraphQL subscriptions from other Atlassian
 * subscriptions.
 */
export type TrelloSubscriptionApiOnBoardUpdatedArgs = {
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level subscription type under which all of Trello's supported subscriptions
 * are under. It is used to group Trello's GraphQL subscriptions from other Atlassian
 * subscriptions.
 */
export type TrelloSubscriptionApiOnCardsUpdatedArgs = {
    cardIds?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>;
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level subscription type under which all of Trello's supported subscriptions
 * are under. It is used to group Trello's GraphQL subscriptions from other Atlassian
 * subscriptions.
 */
export type TrelloSubscriptionApiOnMemberUpdatedArgs = {
    id: Scalars["ID"]["input"];
};

/**
 * This is a top level subscription type under which all of Trello's supported subscriptions
 * are under. It is used to group Trello's GraphQL subscriptions from other Atlassian
 * subscriptions.
 */
export type TrelloSubscriptionApiOnWorkspaceUpdatedArgs = {
    id: Scalars["ID"]["input"];
};

/** The underlying Calendar providers that Planner supports */
export enum TrelloSupportedPlannerProviders {
    Google = "GOOGLE"
}

/** Information for which switcher views are enabled for this board. */
export type TrelloSwitcherViewsInfo = {
    __typename?: "TrelloSwitcherViewsInfo";
    /** True if the switcher view type is enabled. */
    enabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Name of the switcher view type. */
    viewType?: Maybe<Scalars["String"]["output"]>;
};

/** Tag (or Collection). Used to group related entities in a workspace. */
export type TrelloTag = {
    __typename?: "TrelloTag";
    /** Name of the tag (collection). */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Id used for (legacy) interaction with the REST API. */
    objectId: Scalars["ID"]["output"];
};

/** A generic connection type to related Tags. */
export type TrelloTagConnection = {
    __typename?: "TrelloTagConnection";
    /** The list of edges. */
    edges?: Maybe<Array<TrelloTagEdge>>;
    /** The list of TrelloTags. */
    nodes?: Maybe<Array<TrelloTag>>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** A generic edge between an entity and a related Tag. */
export type TrelloTagEdge = {
    __typename?: "TrelloTagEdge";
    /** The cursor to this edge. */
    cursor: Scalars["String"]["output"];
    /** The tag. */
    node?: Maybe<TrelloTag>;
};

/** The categories for the Trello template gallery. */
export type TrelloTemplateGalleryCategory = {
    __typename?: "TrelloTemplateGalleryCategory";
    /** The key maps to the respective templateCategories element. */
    key: Scalars["String"]["output"];
};

/** Connection type between the Template Gallery and the related Board Templates. */
export type TrelloTemplateGalleryConnection = {
    __typename?: "TrelloTemplateGalleryConnection";
    /** The list of edges between the gallery and Board Templates. */
    edges: Array<TrelloBoardEdge>;
    /** The list of related Board Templates. */
    nodes: Array<TrelloBoard>;
    /** Contains information related to the current page of information. */
    pageInfo: PageInfo;
};

/** Filters to apply when querying the Template Gallery. */
export type TrelloTemplateGalleryFilterInput = {
    /**
     * Only templates of this category will be included. If not included, it'll
     * return all categories.
     *
     * See TrelloTemplateGalleryCategory.key for valid categories.
     */
    category?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Desired language of the Template Gallery.
     *
     * See TrelloTemplateGalleryLanguage.language for valid and enabled languages.
     */
    language: Scalars["String"]["input"];
    /**
     * Filter templates based on supported Power-Ups.
     *
     * - Templates will be excluded if they use a Power-Up not in the provided list.
     * - A missing or empty list means include all templates.
     */
    supportedPowerUps?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Information about a Template Gallery Item. */
export type TrelloTemplateGalleryItemInfo = {
    __typename?: "TrelloTemplateGalleryItemInfo";
    /** The shape of the avatar image which can either be 'circle' or 'square'. */
    avatarShape?: Maybe<Scalars["String"]["output"]>;
    /** The author's avatar. */
    avatarUrl?: Maybe<Scalars["URL"]["output"]>;
    /** A short description. */
    blurb?: Maybe<Scalars["String"]["output"]>;
    /** The item's author. */
    byline?: Maybe<Scalars["String"]["output"]>;
    /** The item's category. */
    category: TrelloTemplateGalleryCategory;
    /** Determines if the template is in the featured section */
    featured?: Maybe<Scalars["Boolean"]["output"]>;
    /** The template gallery item identifier. */
    id?: Maybe<Scalars["ID"]["output"]>;
    /** The supported language. */
    language: TrelloTemplateGalleryLanguage;
    /** The order templates are displayed */
    precedence?: Maybe<Scalars["Int"]["output"]>;
    /** The view and copy counts. */
    stats?: Maybe<TrelloTemplateGalleryItemStats>;
};

/**
 * Statistics of the template gallery item such as view count and number of times
 * it's been copied.
 */
export type TrelloTemplateGalleryItemStats = {
    __typename?: "TrelloTemplateGalleryItemStats";
    /** The number of times the template has been copied. */
    copyCount: Scalars["Int"]["output"];
    /** The number of times the template has been viewed. */
    viewCount: Scalars["Int"]["output"];
};

/**
 * The language metadata to describe each language that the Trello template
 * gallery has been translated to.
 */
export type TrelloTemplateGalleryLanguage = {
    __typename?: "TrelloTemplateGalleryLanguage";
    /**
     * The language the template gallery will be translated to. Unabbreviated in
     * English.
     * Example: "German"
     */
    description: Scalars["String"]["output"];
    /** True if the target template language is enabled. */
    enabled: Scalars["Boolean"]["output"];
    /**
     * The language string determines which language the template gallery will be
     * translated to.
     */
    language: Scalars["String"]["output"];
    /** The locale code determines the regional specification for the language. */
    locale: Scalars["String"]["output"];
    /**
     * The language the template gallery will be translated to. Unabbreviated in the
     * target language.
     * Example: "Deutsch"
     */
    localizedDescription: Scalars["String"]["output"];
};

/** Arguments passed into the update board name mutation */
export type TrelloUpdateBoardNameInput = {
    boardId: Scalars["ID"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Returned response to update board name mutation */
export type TrelloUpdateBoardNamePayload = Payload & {
    __typename?: "TrelloUpdateBoardNamePayload";
    board?: Maybe<TrelloBoard>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

/** An uploaded background from the user or image service provided by Trello */
export type TrelloUploadedBackground = {
    __typename?: "TrelloUploadedBackground";
    /** The objectId of the uploaded background data */
    objectId: Scalars["ID"]["output"];
};

/**
 * Rich text generated by a Trello user. Used in card descriptions, comments,
 * checklist items, etc.
 */
export type TrelloUserGeneratedText = {
    __typename?: "TrelloUserGeneratedText";
    /** The user-generated text (in markdown format) */
    text?: Maybe<Scalars["String"]["output"]>;
};

/**
 * A workspace is a primary way to group content and collaborate with other Trello
 * users.
 */
export type TrelloWorkspace = Node & {
    __typename?: "TrelloWorkspace";
    /** Indicates if the workspace is eligible for AI features. */
    aiEligible?: Maybe<Scalars["Boolean"]["output"]>;
    /** The workspace creation method. */
    creationMethod?: Maybe<Scalars["String"]["output"]>;
    /** The description of the workspace. */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The name of the workspace as it is displayed to users. */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /** The enterprise the workspace is a part of. */
    enterprise?: Maybe<TrelloEnterprise>;
    /** The workspace identifier. */
    id: Scalars["ID"]["output"];
    /** The linked Jwm site data. */
    jwmLink?: Maybe<TrelloJwmWorkspaceLink>;
    /** Limits for this workspace */
    limits?: Maybe<TrelloWorkspaceLimits>;
    /** The workspace logoHash based on the logo data. */
    logoHash?: Maybe<Scalars["String"]["output"]>;
    /** The workspace logo url. */
    logoUrl?: Maybe<Scalars["String"]["output"]>;
    /** Workspace Memberships */
    members?: Maybe<TrelloWorkspaceMembershipsConnection>;
    /** The name of the workspace. */
    name?: Maybe<Scalars["String"]["output"]>;
    /** The objectId of the workspace. */
    objectId?: Maybe<Scalars["ID"]["output"]>;
    /** The product offering of this workspace. Will be either "trello.free", "trello.premium", "trello.standard", "trello.enterprise", "trello.personal_free", "trello.personal_standard" or "trello.personal_premium". */
    offering?: Maybe<Scalars["String"]["output"]>;
    /** Preferences for the workspace. */
    prefs?: Maybe<TrelloWorkspacePrefs>;
    /** The premium features this workspace has. */
    premiumFeatures?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The tags associated with the workspace. */
    tags?: Maybe<TrelloTagConnection>;
    /** The workspace url. */
    url?: Maybe<Scalars["URL"]["output"]>;
    /** The workspace website. */
    website?: Maybe<Scalars["String"]["output"]>;
};

/**
 * A workspace is a primary way to group content and collaborate with other Trello
 * users.
 */
export type TrelloWorkspaceMembersArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * A workspace is a primary way to group content and collaborate with other Trello
 * users.
 */
export type TrelloWorkspaceTagsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Collection of limits that apply to a TrelloWorkspace */
export type TrelloWorkspaceLimits = {
    __typename?: "TrelloWorkspaceLimits";
    /** The max number of boards a free workspace can have */
    freeBoards?: Maybe<TrelloLimitProps>;
    /** The max number of collaborators (members + guests) a free workspace can have */
    freeCollaborators?: Maybe<TrelloLimitProps>;
    /** The max number of members a workspace can have */
    totalMembers?: Maybe<TrelloLimitProps>;
};

/** Represents a relationship between a workspace and a member */
export type TrelloWorkspaceMembershipEdge = {
    __typename?: "TrelloWorkspaceMembershipEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    membership?: Maybe<TrelloWorkspaceMembershipInfo>;
    node?: Maybe<TrelloMember>;
};

/** Metadata about a relationship between a member and a workspace */
export type TrelloWorkspaceMembershipInfo = {
    __typename?: "TrelloWorkspaceMembershipInfo";
    deactivated?: Maybe<Scalars["Boolean"]["output"]>;
    lastActive?: Maybe<Scalars["DateTime"]["output"]>;
    objectId: Scalars["ID"]["output"];
    type?: Maybe<TrelloWorkspaceMembershipType>;
    unconfirmed?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Membership types for a TrelloWorkspace */
export enum TrelloWorkspaceMembershipType {
    /**
     * Privileged membership type. Can edit workspace settings,
     * add and remove members
     */
    Admin = "ADMIN",
    /** Standard membership type */
    Normal = "NORMAL"
}

/** Connection type to represent workspace memberships */
export type TrelloWorkspaceMembershipsConnection = {
    __typename?: "TrelloWorkspaceMembershipsConnection";
    edges?: Maybe<Array<TrelloWorkspaceMembershipEdge>>;
    nodes?: Maybe<Array<TrelloMember>>;
    pageInfo: PageInfo;
};

/** Collection of preferences for the workspace. */
export type TrelloWorkspacePrefs = {
    __typename?: "TrelloWorkspacePrefs";
    /** Workspace domain restrictions for invites */
    associatedDomain?: Maybe<Scalars["String"]["output"]>;
    /** Collection of AI preferences for the workspace */
    atlassianIntelligence?: Maybe<TrelloAtlassianIntelligence>;
    /** Workspace attachment restrictions */
    attachmentRestrictions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Workspace level setting for board delete restrictions */
    boardDeleteRestrict?: Maybe<TrelloBoardRestrictions>;
    /** Workspace level setting for board invite restrictions */
    boardInviteRestrict?: Maybe<Scalars["String"]["output"]>;
    /** Workspace level setting for board visibility restrictions */
    boardVisibilityRestrict?: Maybe<TrelloBoardRestrictions>;
    /** Workspace level setting for disabling external members */
    externalMembersDisabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** Workspace level setting for disabling external members */
    orgInviteRestrict?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** Workspace level setting for permission level */
    permissionLevel?: Maybe<Scalars["String"]["output"]>;
};

/** Product tiers for a TrelloWorkspace */
export enum TrelloWorkspaceTier {
    /** Includes all non-free workspaces (i.e. Standard, Premium, Enterprise) */
    Paid = "PAID"
}

/** TrelloWorkspace update subscription. */
export type TrelloWorkspaceUpdated = {
    __typename?: "TrelloWorkspaceUpdated";
    /** Delta information for this event */
    _deltas?: Maybe<Array<Scalars["String"]["output"]>>;
    /** The workspace identifier. */
    id: Scalars["ID"]["output"];
    /** The updated planner */
    planner?: Maybe<TrelloPlannerUpdated>;
};

export type TrustSignal = {
    __typename?: "TrustSignal";
    key: Scalars["ID"]["output"];
    result: Scalars["Boolean"]["output"];
    /** The constituent conditions (e.g. HAS_REMOTES, HAS_CONNECT_MODULES) that are used to evaluate the trust signal result (e.g. RUNS_ON_ATLASSIAN) */
    rules?: Maybe<Array<TrustSignalRule>>;
};

export type TrustSignalRule = {
    __typename?: "TrustSignalRule";
    name: Scalars["String"]["output"];
    value: Scalars["Boolean"]["output"];
};

export type TunnelDefinitionsInput = {
    customUI?: InputMaybe<Array<InputMaybe<CustomUiTunnelDefinitionInput>>>;
    /** The URL to tunnel FaaS calls to */
    faasTunnelUrl?: InputMaybe<Scalars["URL"]["input"]>;
};

export type UnarchivePolarisInsightsPayload = Payload & {
    __typename?: "UnarchivePolarisInsightsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UnarchiveSpaceInput = {
    /** The alias of the unarchived space */
    alias: Scalars["String"]["input"];
};

export type UnarchiveSpacePayload = Payload & {
    __typename?: "UnarchiveSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UnassignIssueParentInput = {
    boardId: Scalars["ID"]["input"];
    issueIds: Array<Scalars["ID"]["input"]>;
};

export type UnassignIssueParentOutput = MutationResponse & {
    __typename?: "UnassignIssueParentOutput";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    boardScope?: Maybe<BoardScope>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    clientMutationId?: Maybe<Scalars["ID"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    message: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode: Scalars["Int"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UnifiedAccessStatus = UnifiedINode & {
    __typename?: "UnifiedAccessStatus";
    id: Scalars["ID"]["output"];
    status?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UnifiedAccount = UnifiedINode & {
    __typename?: "UnifiedAccount";
    aaid: Scalars["String"]["output"];
    emailId: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    internalId: Scalars["String"]["output"];
    isForumsAccountBanned: Scalars["Boolean"]["output"];
    isForumsModerator: Scalars["Boolean"]["output"];
    isLinked: Scalars["Boolean"]["output"];
    isManaged: Scalars["Boolean"]["output"];
    isPrimary: Scalars["Boolean"]["output"];
    khorosUserId: Scalars["Int"]["output"];
    linkedAccounts?: Maybe<UnifiedULinkedAccountResult>;
    nickname: Scalars["String"]["output"];
    picture: Scalars["String"]["output"];
};

export type UnifiedAccountBasics = UnifiedINode & {
    __typename?: "UnifiedAccountBasics";
    aaid: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    isLinked: Scalars["Boolean"]["output"];
    isManaged: Scalars["Boolean"]["output"];
    isPrimary: Scalars["Boolean"]["output"];
    khorosUserId: Scalars["Int"]["output"];
    linkedAccountsBasics?: Maybe<UnifiedULinkedAccountBasicsResult>;
    nickname: Scalars["String"]["output"];
    picture: Scalars["String"]["output"];
};

export type UnifiedAccountDetails = UnifiedINode & {
    __typename?: "UnifiedAccountDetails";
    aaid?: Maybe<Scalars["String"]["output"]>;
    emailId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    nickname?: Maybe<Scalars["String"]["output"]>;
    orgId?: Maybe<Scalars["String"]["output"]>;
    picture?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedAccountMutation = {
    __typename?: "UnifiedAccountMutation";
    setPrimaryAccount?: Maybe<UnifiedLinkingStatusPayload>;
    unlinkAccount?: Maybe<UnifiedLinkingStatusPayload>;
};

export type UnifiedAccountMutationSetPrimaryAccountArgs = {
    aaid: Scalars["String"]["input"];
};

export type UnifiedAccountMutationUnlinkAccountArgs = {
    aaid: Scalars["String"]["input"];
};

export type UnifiedAdmins = UnifiedINode & {
    __typename?: "UnifiedAdmins";
    admins?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    id: Scalars["ID"]["output"];
};

export type UnifiedAllowList = UnifiedINode & {
    __typename?: "UnifiedAllowList";
    allowList?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    id: Scalars["ID"]["output"];
};

export type UnifiedAtlassianProduct = UnifiedINode & {
    __typename?: "UnifiedAtlassianProduct";
    id: Scalars["ID"]["output"];
    productId: Scalars["String"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    viewHref?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedAtlassianProductConnection = UnifiedIConnection & {
    __typename?: "UnifiedAtlassianProductConnection";
    edges?: Maybe<Array<Maybe<UnifiedAtlassianProductEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedAtlassianProductEdge = UnifiedIEdge & {
    __typename?: "UnifiedAtlassianProductEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedAtlassianProduct>;
};

export type UnifiedCacheInvalidationResult = {
    __typename?: "UnifiedCacheInvalidationResult";
    errors?: Maybe<Array<UnifiedMutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type UnifiedCachingMutation = {
    __typename?: "UnifiedCachingMutation";
    invalidateCache?: Maybe<UnifiedCacheInvalidationResult>;
};

export type UnifiedCachingMutationInvalidateCacheArgs = {
    aaid: Scalars["String"]["input"];
    dataPoint: Scalars["String"]["input"];
};

export type UnifiedCommunityMutation = {
    __typename?: "UnifiedCommunityMutation";
    initializeCommunity?: Maybe<UnifiedCommunityPayload>;
};

export type UnifiedCommunityMutationInitializeCommunityArgs = {
    aaid?: InputMaybe<Scalars["String"]["input"]>;
    emailId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedCommunityPayload = UnifiedPayload & {
    __typename?: "UnifiedCommunityPayload";
    errors?: Maybe<Array<UnifiedMutationError>>;
    forumsProfile?: Maybe<UnifiedForumsAccount>;
    gamificationProfile?: Maybe<UnifiedGamificationProfile>;
    success: Scalars["Boolean"]["output"];
    unifiedProfile?: Maybe<UnifiedProfile>;
};

export type UnifiedConsentMutation = {
    __typename?: "UnifiedConsentMutation";
    deleteConsent?: Maybe<UnifiedConsentPayload>;
    removeConsent?: Maybe<UnifiedConsentPayload>;
    setConsent?: Maybe<UnifiedConsentPayload>;
    updateConsent?: Maybe<UnifiedConsentPayload>;
};

export type UnifiedConsentMutationDeleteConsentArgs = {
    consentObj: Array<UnifiedConsentObjInput>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    value: Scalars["String"]["input"];
};

export type UnifiedConsentMutationRemoveConsentArgs = {
    type?: InputMaybe<Scalars["String"]["input"]>;
    value: Scalars["String"]["input"];
};

export type UnifiedConsentMutationSetConsentArgs = {
    consentObj: Array<UnifiedConsentObjInput>;
    type: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type UnifiedConsentMutationUpdateConsentArgs = {
    consentObj: Array<UnifiedConsentObjInput>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    value: Scalars["String"]["input"];
};

export type UnifiedConsentObj = {
    __typename?: "UnifiedConsentObj";
    consentKey: Scalars["String"]["output"];
    consentStatus: Scalars["String"]["output"];
    consenthubStatus: Scalars["Boolean"]["output"];
    createdAt: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
    uppConsentStatus: Scalars["Boolean"]["output"];
};

export type UnifiedConsentObjInput = {
    consentKey: Scalars["String"]["input"];
    consentStatus: Scalars["String"]["input"];
    displayedText?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedConsentPayload = UnifiedPayload & {
    __typename?: "UnifiedConsentPayload";
    errors?: Maybe<Array<UnifiedMutationError>>;
    message?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type UnifiedConsentQuery = {
    __typename?: "UnifiedConsentQuery";
    getConsent?: Maybe<UnifiedUConsentStatusResult>;
};

export type UnifiedConsentQueryGetConsentArgs = {
    type?: InputMaybe<Scalars["String"]["input"]>;
    value: Scalars["String"]["input"];
};

export type UnifiedConsentStatus = UnifiedINode & {
    __typename?: "UnifiedConsentStatus";
    consentObj: Array<UnifiedConsentObj>;
    createdAt: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    type: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type UnifiedForums = UnifiedINode & {
    __typename?: "UnifiedForums";
    badges?: Maybe<UnifiedUForumsBadgesResult>;
    groups?: Maybe<UnifiedUForumsGroupsResult>;
    id: Scalars["ID"]["output"];
    khorosUserId: Scalars["Int"]["output"];
    snapshot?: Maybe<UnifiedUForumsSnapshotResult>;
};

export type UnifiedForumsBadgesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedForumsGroupsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedForumsAccount = UnifiedINode & {
    __typename?: "UnifiedForumsAccount";
    email?: Maybe<Scalars["String"]["output"]>;
    firstName?: Maybe<Scalars["String"]["output"]>;
    href?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    lastName?: Maybe<Scalars["String"]["output"]>;
    lastVisitTime?: Maybe<Scalars["String"]["output"]>;
    login?: Maybe<Scalars["String"]["output"]>;
    onlineStatus?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    viewHref?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedForumsAccountDetails = UnifiedINode & {
    __typename?: "UnifiedForumsAccountDetails";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    aaid?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    emailId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nickname?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    orgId?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedForumsBadge = UnifiedIBadge &
    UnifiedINode & {
        __typename?: "UnifiedForumsBadge";
        actionUrl?: Maybe<Scalars["String"]["output"]>;
        description?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        imageUrl?: Maybe<Scalars["String"]["output"]>;
        lastCompletedDate?: Maybe<Scalars["String"]["output"]>;
        name?: Maybe<Scalars["String"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

export type UnifiedForumsBadgeEdge = UnifiedIEdge & {
    __typename?: "UnifiedForumsBadgeEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedForumsBadge>;
};

export type UnifiedForumsBadgesConnection = UnifiedIConnection & {
    __typename?: "UnifiedForumsBadgesConnection";
    edges?: Maybe<Array<Maybe<UnifiedForumsBadgeEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedForumsGroup = UnifiedINode & {
    __typename?: "UnifiedForumsGroup";
    aaid?: Maybe<Scalars["String"]["output"]>;
    avatar?: Maybe<UnifiedForumsGroupAvatar>;
    description?: Maybe<Scalars["String"]["output"]>;
    groupMemberCount?: Maybe<Scalars["Int"]["output"]>;
    hasHiddenAncestor?: Maybe<Scalars["Boolean"]["output"]>;
    id: Scalars["ID"]["output"];
    joinDate?: Maybe<Scalars["String"]["output"]>;
    membershipType?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    topicsCount?: Maybe<Scalars["Int"]["output"]>;
    viewHref?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedForumsGroupAvatar = {
    __typename?: "UnifiedForumsGroupAvatar";
    largeHref?: Maybe<Scalars["String"]["output"]>;
    mediumHref?: Maybe<Scalars["String"]["output"]>;
    smallHref?: Maybe<Scalars["String"]["output"]>;
    tinyHref?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedForumsGroupEdge = UnifiedIEdge & {
    __typename?: "UnifiedForumsGroupEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedForumsGroup>;
};

export type UnifiedForumsGroupsConnection = UnifiedIConnection & {
    __typename?: "UnifiedForumsGroupsConnection";
    edges?: Maybe<Array<Maybe<UnifiedForumsGroupEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedForumsSnapshot = UnifiedINode & {
    __typename?: "UnifiedForumsSnapshot";
    acceptedAnswersCreated?: Maybe<Scalars["Int"]["output"]>;
    answersCreated?: Maybe<Scalars["Int"]["output"]>;
    articlesCreated?: Maybe<Scalars["Int"]["output"]>;
    badgesEarned?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["ID"]["output"];
    kudosGiven?: Maybe<Scalars["Int"]["output"]>;
    kudosReceived?: Maybe<Scalars["Int"]["output"]>;
    lastPostTime?: Maybe<Scalars["String"]["output"]>;
    lastVisitTime?: Maybe<Scalars["String"]["output"]>;
    minutesOnline?: Maybe<Scalars["Int"]["output"]>;
    rank?: Maybe<Scalars["String"]["output"]>;
    rankPosition?: Maybe<Scalars["Int"]["output"]>;
    repliesCreated?: Maybe<Scalars["Int"]["output"]>;
    roles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    status?: Maybe<Scalars["String"]["output"]>;
    topicsCreated?: Maybe<Scalars["Int"]["output"]>;
    totalLoginsRecorded?: Maybe<Scalars["String"]["output"]>;
    totalPosts?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedGamification = UnifiedINode & {
    __typename?: "UnifiedGamification";
    badges?: Maybe<UnifiedUGamificationBadgesResult>;
    id: Scalars["ID"]["output"];
    levels?: Maybe<UnifiedUGamificationLevelsResult>;
    recognitionsSummary?: Maybe<UnifiedUGamificationRecognitionsSummaryResult>;
};

export type UnifiedGamificationBadgesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedGamificationBadge = UnifiedIBadge &
    UnifiedINode & {
        __typename?: "UnifiedGamificationBadge";
        actionUrl?: Maybe<Scalars["String"]["output"]>;
        description?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        imageUrl?: Maybe<Scalars["String"]["output"]>;
        lastCompletedDate?: Maybe<Scalars["String"]["output"]>;
        name?: Maybe<Scalars["String"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

export type UnifiedGamificationBadgeEdge = UnifiedIEdge & {
    __typename?: "UnifiedGamificationBadgeEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedGamificationBadge>;
};

export type UnifiedGamificationBadgesConnection = UnifiedIConnection & {
    __typename?: "UnifiedGamificationBadgesConnection";
    edges?: Maybe<Array<Maybe<UnifiedGamificationBadgeEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedGamificationLevel = UnifiedINode & {
    __typename?: "UnifiedGamificationLevel";
    currentLevelArt?: Maybe<Scalars["String"]["output"]>;
    currentLevelDescription?: Maybe<Scalars["String"]["output"]>;
    currentLevelName?: Maybe<Scalars["String"]["output"]>;
    currentPoints?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["ID"]["output"];
    maxPoints?: Maybe<Scalars["Int"]["output"]>;
    nextLevelName?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedGamificationProfile = {
    __typename?: "UnifiedGamificationProfile";
    firstName?: Maybe<Scalars["String"]["output"]>;
    userId?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedGamificationRecognitionsSummary = UnifiedINode & {
    __typename?: "UnifiedGamificationRecognitionsSummary";
    id: Scalars["ID"]["output"];
    totals?: Maybe<Array<Maybe<UnifiedGamificationRecognitionsTotal>>>;
};

export type UnifiedGamificationRecognitionsTotal = {
    __typename?: "UnifiedGamificationRecognitionsTotal";
    comment?: Maybe<Scalars["String"]["output"]>;
    count?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedGatingMutation = {
    __typename?: "UnifiedGatingMutation";
    addAdmins?: Maybe<UnifiedGatingPayload>;
    addToAllowList?: Maybe<UnifiedGatingPayload>;
    removeAdmins?: Maybe<UnifiedGatingPayload>;
    removeFromAllowList?: Maybe<UnifiedGatingPayload>;
};

export type UnifiedGatingMutationAddAdminsArgs = {
    aaids: Array<Scalars["String"]["input"]>;
};

export type UnifiedGatingMutationAddToAllowListArgs = {
    emailIds: Array<Scalars["String"]["input"]>;
};

export type UnifiedGatingMutationRemoveAdminsArgs = {
    aaids: Array<Scalars["String"]["input"]>;
};

export type UnifiedGatingMutationRemoveFromAllowListArgs = {
    emailIds: Array<Scalars["String"]["input"]>;
};

export type UnifiedGatingPayload = UnifiedPayload & {
    __typename?: "UnifiedGatingPayload";
    errors?: Maybe<Array<UnifiedMutationError>>;
    message?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type UnifiedGatingQuery = {
    __typename?: "UnifiedGatingQuery";
    getAdmins?: Maybe<UnifiedUAdminsResult>;
    getAllowList?: Maybe<UnifiedUAllowListResult>;
    isAaidAdmin?: Maybe<UnifiedUGatingStatusResult>;
    isEmailIdAllowed?: Maybe<UnifiedUGatingStatusResult>;
};

export type UnifiedGatingQueryIsAaidAdminArgs = {
    aaid: Scalars["String"]["input"];
};

export type UnifiedGatingQueryIsEmailIdAllowedArgs = {
    emailId: Scalars["String"]["input"];
};

export type UnifiedIBadge = {
    actionUrl?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    imageUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedIConnection = {
    edges?: Maybe<Array<Maybe<UnifiedIEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedIEdge = {
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedINode>;
};

export type UnifiedINode = {
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    id: Scalars["ID"]["output"];
};

export type UnifiedIQueryError = {
    extensions?: Maybe<Array<UnifiedQueryErrorExtension>>;
    identifier?: Maybe<Scalars["ID"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedLearning = UnifiedINode & {
    __typename?: "UnifiedLearning";
    certifications?: Maybe<UnifiedULearningCertificationResult>;
    id: Scalars["ID"]["output"];
    recentCourses?: Maybe<UnifiedURecentCourseResult>;
    recentCoursesBadges?: Maybe<UnifiedUProfileBadgesResult>;
};

export type UnifiedLearningCertificationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
    sortDirection?: InputMaybe<UnifiedSortDirection>;
    sortField?: InputMaybe<UnifiedLearningCertificationSortField>;
    status?: InputMaybe<UnifiedLearningCertificationStatus>;
    type?: InputMaybe<Array<UnifiedLearningCertificationType>>;
};

export type UnifiedLearningRecentCoursesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedLearningRecentCoursesBadgesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedLearningCertification = UnifiedINode & {
    __typename?: "UnifiedLearningCertification";
    activeDate?: Maybe<Scalars["String"]["output"]>;
    expireDate?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    imageUrl?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    nameAbbr?: Maybe<Scalars["String"]["output"]>;
    publicUrl?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedLearningCertificationConnection = UnifiedIConnection & {
    __typename?: "UnifiedLearningCertificationConnection";
    edges?: Maybe<Array<Maybe<UnifiedLearningCertificationEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedLearningCertificationEdge = UnifiedIEdge & {
    __typename?: "UnifiedLearningCertificationEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedLearningCertification>;
};

export enum UnifiedLearningCertificationSortField {
    ActiveDate = "ACTIVE_DATE",
    ExpireDate = "EXPIRE_DATE",
    Id = "ID",
    ImageUrl = "IMAGE_URL",
    Name = "NAME",
    NameAbbr = "NAME_ABBR",
    PublicUrl = "PUBLIC_URL",
    Status = "STATUS",
    Type = "TYPE"
}

export enum UnifiedLearningCertificationStatus {
    Active = "ACTIVE",
    Expired = "EXPIRED"
}

export enum UnifiedLearningCertificationType {
    Badge = "BADGE",
    Certification = "CERTIFICATION",
    Standing = "STANDING"
}

export type UnifiedLinkAuthenticationPayload = {
    __typename?: "UnifiedLinkAuthenticationPayload";
    account1?: Maybe<UnifiedAccountDetails>;
    account2?: Maybe<UnifiedAccountDetails>;
    id: Scalars["ID"]["output"];
    primaryAccountIndex?: Maybe<Scalars["Int"]["output"]>;
    token: Scalars["String"]["output"];
};

export type UnifiedLinkInitiationPayload = {
    __typename?: "UnifiedLinkInitiationPayload";
    id: Scalars["ID"]["output"];
    token: Scalars["String"]["output"];
};

export type UnifiedLinkedAccountBasicsConnection = UnifiedIConnection & {
    __typename?: "UnifiedLinkedAccountBasicsConnection";
    edges?: Maybe<Array<Maybe<UnifiedLinkedAccountBasicsEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedLinkedAccountBasicsEdge = UnifiedIEdge & {
    __typename?: "UnifiedLinkedAccountBasicsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedAccountBasics>;
};

export type UnifiedLinkedAccountConnection = UnifiedIConnection & {
    __typename?: "UnifiedLinkedAccountConnection";
    edges?: Maybe<Array<Maybe<UnifiedLinkedAccountEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedLinkedAccountEdge = UnifiedIEdge & {
    __typename?: "UnifiedLinkedAccountEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedAccount>;
};

export type UnifiedLinkingMutation = {
    __typename?: "UnifiedLinkingMutation";
    authenticateLinkingWithLoggedInAccount?: Maybe<UnifiedULinkAuthenticationPayload>;
    completeTransaction?: Maybe<UnifiedLinkingStatusPayload>;
    initializeLinkingWithLoggedInAccount?: Maybe<UnifiedULinkInitiationPayload>;
    updateLinkingWithPrimaryAccountAaid?: Maybe<UnifiedLinkingStatusPayload>;
};

export type UnifiedLinkingMutationAuthenticateLinkingWithLoggedInAccountArgs = {
    token: Scalars["String"]["input"];
};

export type UnifiedLinkingMutationCompleteTransactionArgs = {
    token: Scalars["String"]["input"];
};

export type UnifiedLinkingMutationUpdateLinkingWithPrimaryAccountAaidArgs = {
    aaid: Scalars["String"]["input"];
    token: Scalars["String"]["input"];
};

export type UnifiedLinkingStatusPayload = UnifiedPayload & {
    __typename?: "UnifiedLinkingStatusPayload";
    errors?: Maybe<Array<UnifiedMutationError>>;
    message?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type UnifiedMutation = {
    __typename?: "UnifiedMutation";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    account?: Maybe<UnifiedAccountMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    caching?: Maybe<UnifiedCachingMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    community?: Maybe<UnifiedCommunityMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    consent?: Maybe<UnifiedConsentMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    createUnifiedSystem?: Maybe<UnifiedProfilePayload>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    gating?: Maybe<UnifiedGatingMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    linking?: Maybe<UnifiedLinkingMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profile?: Maybe<UnifiedProfileMutation>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    updateUnifiedProfile?: Maybe<UnifiedProfilePayload>;
};

export type UnifiedMutationCreateUnifiedSystemArgs = {
    aaid: Scalars["String"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    unifiedProfileUsername?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedMutationUpdateUnifiedProfileArgs = {
    unifiedProfileInput?: InputMaybe<UnifiedProfileInput>;
};

export type UnifiedMutationError = {
    __typename?: "UnifiedMutationError";
    code?: Maybe<Scalars["String"]["output"]>;
    extensions?: Maybe<UnifiedMutationErrorExtension>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedMutationErrorExtension = {
    __typename?: "UnifiedMutationErrorExtension";
    errorType?: Maybe<Scalars["String"]["output"]>;
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedPageInfo = {
    __typename?: "UnifiedPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage?: Maybe<Scalars["Boolean"]["output"]>;
    hasPreviousPage?: Maybe<Scalars["Boolean"]["output"]>;
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedPayload = {
    errors?: Maybe<Array<UnifiedMutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type UnifiedProfile = UnifiedINode & {
    __typename?: "UnifiedProfile";
    aaid?: Maybe<Scalars["String"]["output"]>;
    accountInternalId?: Maybe<Scalars["String"]["output"]>;
    badges?: Maybe<UnifiedUProfileBadgesResult>;
    bio?: Maybe<Scalars["String"]["output"]>;
    company?: Maybe<Scalars["String"]["output"]>;
    forums?: Maybe<UnifiedUForumsResult>;
    gamification?: Maybe<UnifiedUGamificationResult>;
    id: Scalars["ID"]["output"];
    internalId?: Maybe<Scalars["ID"]["output"]>;
    isLinkedView?: Maybe<Scalars["Boolean"]["output"]>;
    isPersonalView?: Maybe<Scalars["Boolean"]["output"]>;
    isPrivate: Scalars["Boolean"]["output"];
    isProfileBanned?: Maybe<Scalars["Boolean"]["output"]>;
    learning?: Maybe<UnifiedULearningResult>;
    linkedinUrl?: Maybe<Scalars["String"]["output"]>;
    location?: Maybe<Scalars["String"]["output"]>;
    products?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<Scalars["String"]["output"]>;
    username?: Maybe<Scalars["String"]["output"]>;
    websiteUrl?: Maybe<Scalars["String"]["output"]>;
    xUrl?: Maybe<Scalars["String"]["output"]>;
    youtubeUrl?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedProfileBadgesArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedProfileBadge = UnifiedIBadge &
    UnifiedINode & {
        __typename?: "UnifiedProfileBadge";
        actionUrl?: Maybe<Scalars["String"]["output"]>;
        description?: Maybe<Scalars["String"]["output"]>;
        id: Scalars["ID"]["output"];
        imageUrl?: Maybe<Scalars["String"]["output"]>;
        lastCompletedDate?: Maybe<Scalars["String"]["output"]>;
        name?: Maybe<Scalars["String"]["output"]>;
        type?: Maybe<Scalars["String"]["output"]>;
    };

export type UnifiedProfileBadgeEdge = UnifiedIEdge & {
    __typename?: "UnifiedProfileBadgeEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedProfileBadge>;
};

export type UnifiedProfileBadgesConnection = UnifiedIConnection & {
    __typename?: "UnifiedProfileBadgesConnection";
    edges?: Maybe<Array<Maybe<UnifiedProfileBadgeEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedProfileInput = {
    aaid?: InputMaybe<Scalars["String"]["input"]>;
    accountInternalId?: InputMaybe<Scalars["String"]["input"]>;
    bio?: InputMaybe<Scalars["String"]["input"]>;
    company?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    internalId?: InputMaybe<Scalars["String"]["input"]>;
    isPrivate: Scalars["Boolean"]["input"];
    linkedinUrl?: InputMaybe<Scalars["String"]["input"]>;
    location?: InputMaybe<Scalars["String"]["input"]>;
    products?: InputMaybe<Scalars["String"]["input"]>;
    role?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["String"]["input"]>;
    username?: InputMaybe<Scalars["String"]["input"]>;
    websiteUrl?: InputMaybe<Scalars["String"]["input"]>;
    xUrl?: InputMaybe<Scalars["String"]["input"]>;
    youtubeUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedProfileMutation = {
    __typename?: "UnifiedProfileMutation";
    getExistingOrNewProfileFromKhorosUserId?: Maybe<UnifiedProfilePayload>;
};

export type UnifiedProfileMutationGetExistingOrNewProfileFromKhorosUserIdArgs =
    {
        khorosUserId: Scalars["String"]["input"];
    };

export type UnifiedProfilePayload = UnifiedPayload & {
    __typename?: "UnifiedProfilePayload";
    errors?: Maybe<Array<UnifiedMutationError>>;
    success: Scalars["Boolean"]["output"];
    unifiedProfile?: Maybe<UnifiedProfile>;
};

export type UnifiedQuery = {
    __typename?: "UnifiedQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    account?: Maybe<UnifiedUAccountResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountBasics?: Maybe<UnifiedUAccountBasicsResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountDetails?: Maybe<UnifiedUAccountDetailsResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    atlassianProducts?: Maybe<UnifiedUAtlassianProductResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    consent?: Maybe<UnifiedConsentQuery>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    gating?: Maybe<UnifiedGatingQuery>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    node?: Maybe<UnifiedINode>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unifiedProfile?: Maybe<UnifiedUProfileResult>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    unifiedProfiles?: Maybe<Array<Maybe<UnifiedUProfileResult>>>;
};

export type UnifiedQueryAccountArgs = {
    aaid?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedQueryAccountBasicsArgs = {
    aaid?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedQueryAccountDetailsArgs = {
    aaid?: InputMaybe<Scalars["String"]["input"]>;
    emailId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedQueryAtlassianProductsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type UnifiedQueryNodeArgs = {
    id: Scalars["ID"]["input"];
};

export type UnifiedQueryUnifiedProfileArgs = {
    aaid?: InputMaybe<Scalars["String"]["input"]>;
    internalId?: InputMaybe<Scalars["String"]["input"]>;
    unifiedProfileUsername?: InputMaybe<Scalars["String"]["input"]>;
};

export type UnifiedQueryError = UnifiedIQueryError & {
    __typename?: "UnifiedQueryError";
    code?: Maybe<Scalars["String"]["output"]>;
    extensions?: Maybe<Array<UnifiedQueryErrorExtension>>;
    identifier?: Maybe<Scalars["ID"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedQueryErrorExtension = {
    __typename?: "UnifiedQueryErrorExtension";
    errorType?: Maybe<Scalars["String"]["output"]>;
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedRecentCourse = UnifiedINode & {
    __typename?: "UnifiedRecentCourse";
    activeDate?: Maybe<Scalars["String"]["output"]>;
    courseName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    src?: Maybe<Scalars["String"]["output"]>;
};

export type UnifiedRecentCourseConnection = UnifiedIConnection & {
    __typename?: "UnifiedRecentCourseConnection";
    edges?: Maybe<Array<Maybe<UnifiedRecentCourseEdge>>>;
    pageInfo: UnifiedPageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type UnifiedRecentCourseEdge = UnifiedIEdge & {
    __typename?: "UnifiedRecentCourseEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UnifiedRecentCourse>;
};

export enum UnifiedSortDirection {
    Asc = "ASC",
    Desc = "DESC"
}

export type UnifiedUAccountBasicsResult =
    | UnifiedAccountBasics
    | UnifiedQueryError;

export type UnifiedUAccountDetailsResult =
    | UnifiedAccountDetails
    | UnifiedQueryError;

export type UnifiedUAccountResult = UnifiedAccount | UnifiedQueryError;

export type UnifiedUAdminsResult = UnifiedAdmins | UnifiedQueryError;

export type UnifiedUAllowListResult = UnifiedAllowList | UnifiedQueryError;

export type UnifiedUAtlassianProductResult =
    | UnifiedAtlassianProductConnection
    | UnifiedQueryError;

export type UnifiedUConsentStatusResult =
    | UnifiedConsentStatus
    | UnifiedQueryError;

export type UnifiedUForumsBadgesResult =
    | UnifiedForumsBadgesConnection
    | UnifiedQueryError;

export type UnifiedUForumsGroupsResult =
    | UnifiedForumsGroupsConnection
    | UnifiedQueryError;

export type UnifiedUForumsResult = UnifiedForums | UnifiedQueryError;

export type UnifiedUForumsSnapshotResult =
    | UnifiedForumsSnapshot
    | UnifiedQueryError;

export type UnifiedUGamificationBadgesResult =
    | UnifiedGamificationBadgesConnection
    | UnifiedQueryError;

export type UnifiedUGamificationLevelsResult =
    | UnifiedGamificationLevel
    | UnifiedQueryError;

export type UnifiedUGamificationRecognitionsSummaryResult =
    | UnifiedGamificationRecognitionsSummary
    | UnifiedQueryError;

export type UnifiedUGamificationResult =
    | UnifiedGamification
    | UnifiedQueryError;

export type UnifiedUGatingStatusResult =
    | UnifiedAccessStatus
    | UnifiedQueryError;

export type UnifiedULearningCertificationResult =
    | UnifiedLearningCertificationConnection
    | UnifiedQueryError;

export type UnifiedULearningResult = UnifiedLearning | UnifiedQueryError;

export type UnifiedULinkAuthenticationPayload =
    | UnifiedLinkAuthenticationPayload
    | UnifiedLinkingStatusPayload;

export type UnifiedULinkInitiationPayload =
    | UnifiedLinkInitiationPayload
    | UnifiedLinkingStatusPayload;

export type UnifiedULinkedAccountBasicsResult =
    | UnifiedLinkedAccountBasicsConnection
    | UnifiedQueryError;

export type UnifiedULinkedAccountResult =
    | UnifiedLinkedAccountConnection
    | UnifiedQueryError;

export type UnifiedUProfileBadgesResult =
    | UnifiedProfileBadgesConnection
    | UnifiedQueryError;

export type UnifiedUProfileResult = UnifiedProfile | UnifiedQueryError;

export type UnifiedURecentCourseResult =
    | UnifiedQueryError
    | UnifiedRecentCourseConnection;

export type UnknownUser = Person & {
    __typename?: "UnknownUser";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountId?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    accountType?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    displayName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    email?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    permissionType?: Maybe<SitePermissionType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    profilePicture?: Maybe<Icon>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    publicName?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    timeZone?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    type?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    username?: Maybe<Scalars["String"]["output"]>;
};

export type UnlicensedUserWithPermissions = {
    __typename?: "UnlicensedUserWithPermissions";
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
};

export type UnlicensedUserWithPermissionsInput = {
    operations: Array<InputMaybe<OperationCheckResultInput>>;
};

/** Handles detaching a dataManager from a Component */
export type UnlinkExternalSourceInput = {
    cloudId: Scalars["ID"]["input"];
    /** The ID of the Forge App being uninstalled */
    ecosystemAppId: Scalars["ID"]["input"];
    /** The external source name of any ExternalAliases to be removed */
    externalSource: Scalars["String"]["input"];
};

export type UnlinkExternalSourcePayload = Payload & {
    __typename?: "UnlinkExternalSourcePayload";
    /** A list of errors that occurred during the mutation */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation succeeded or not */
    success: Scalars["Boolean"]["output"];
};

export type UnwatchMarketplaceAppPayload = Payload & {
    __typename?: "UnwatchMarketplaceAppPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateAppContributorRoleInput = {
    appId: Scalars["ID"]["input"];
    updates: Array<UpdateAppContributorRolePayload>;
};

export type UpdateAppContributorRolePayload = {
    accountId: Scalars["ID"]["input"];
    add: Array<InputMaybe<AppContributorRole>>;
    remove: Array<InputMaybe<AppContributorRole>>;
};

/** Response from editing an app contributor role */
export type UpdateAppContributorRoleResponsePayload = Payload & {
    __typename?: "UpdateAppContributorRoleResponsePayload";
    errors?: Maybe<Array<MutationError>>;
    rolesFailed: Array<Maybe<ContributorRolesFailed>>;
    success: Scalars["Boolean"]["output"];
};

export type UpdateAppDetailsInput = {
    appId: Scalars["ID"]["input"];
    avatarFileId?: InputMaybe<Scalars["String"]["input"]>;
    contactLink?: InputMaybe<Scalars["String"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    /**
     * Distribution status determines the sharing status of the app.
     * If you stop sharing your app this may affect exising app users.
     * If not supplied defaults to DEVELOPMENT (not sharing).
     */
    distributionStatus?: InputMaybe<DistributionStatus>;
    hasPDReportingApiImplemented?: InputMaybe<Scalars["Boolean"]["input"]>;
    name: Scalars["String"]["input"];
    privacyPolicy?: InputMaybe<Scalars["String"]["input"]>;
    storesPersonalData?: InputMaybe<Scalars["Boolean"]["input"]>;
    termsOfService?: InputMaybe<Scalars["String"]["input"]>;
    vendorName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAppDetailsResponse = Payload & {
    __typename?: "UpdateAppDetailsResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    app?: Maybe<App>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Input payload for enrolling scopes to an app environment */
export type UpdateAppHostServiceScopesInput = {
    /** A unique Id representing the app */
    appId: Scalars["ID"]["input"];
    /** The key of the app's environment to enrol the scopes */
    environmentKey: Scalars["String"]["input"];
    /** The scopes this app will be enrolled to after the request succeeds */
    scopes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** The Id of the service for which the scopes belong to */
    serviceId: Scalars["ID"]["input"];
};

/** Response from enrolling scopes into an app environment */
export type UpdateAppHostServiceScopesResponsePayload = Payload & {
    __typename?: "UpdateAppHostServiceScopesResponsePayload";
    /** Details about the app */
    app?: Maybe<App>;
    /** Details about the version of the app */
    appEnvironmentVersion?: Maybe<AppEnvironmentVersion>;
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type UpdateAppOwnershipInput = {
    appAri: Scalars["String"]["input"];
    newOwner: Scalars["String"]["input"];
};

export type UpdateAppOwnershipResponsePayload = Payload & {
    __typename?: "UpdateAppOwnershipResponsePayload";
    errors?: Maybe<Array<MutationError>>;
    success: Scalars["Boolean"]["output"];
};

export type UpdateArchiveNotesInput = {
    archiveNote?: InputMaybe<Scalars["String"]["input"]>;
    areChildrenIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
    excludedBranchRootPageIDs?: InputMaybe<
        Array<InputMaybe<Scalars["Long"]["input"]>>
    >;
    isSelected?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageID: Scalars["Long"]["input"];
};

export type UpdateArchiveNotesPayload = {
    __typename?: "UpdateArchiveNotesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    status: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId?: Maybe<Scalars["String"]["output"]>;
};

/** Input payload for updating an Atlassian OAuth Client mutation */
export type UpdateAtlassianOAuthClientInput = {
    callbacks?: InputMaybe<Array<Scalars["String"]["input"]>>;
    clientID: Scalars["ID"]["input"];
    refreshToken?: InputMaybe<RefreshTokenInput>;
};

/** Response from updating an oauth client */
export type UpdateAtlassianOAuthClientResponse = Payload & {
    __typename?: "UpdateAtlassianOAuthClientResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateCommentInput = {
    commentBody: CommentBody;
    commentId: Scalars["ID"]["input"];
    /** This field is being deprecated, you do not need to provide this value if the update.comment.mutations.optional.version FF is on */
    version?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a data manager on a component. */
export type UpdateCompassComponentDataManagerMetadataInput = {
    /** The ID of the component to update a data manager on. */
    componentId: Scalars["ID"]["input"];
    /** A URL of the external source of the component's data. */
    externalSourceURL?: InputMaybe<Scalars["URL"]["input"]>;
    /** Details about the last sync event to this component. */
    lastSyncEvent?: InputMaybe<ComponentSyncEventInput>;
};

/** The payload returned from updating a data manager of a component. */
export type UpdateCompassComponentDataManagerMetadataPayload = Payload & {
    __typename?: "UpdateCompassComponentDataManagerMetadataPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating an existing component. */
export type UpdateCompassComponentInput = {
    /** The extended description details associated to the component. */
    componentDescriptionDetails?: InputMaybe<CompassComponentDescriptionDetailsInput>;
    /** A collection of custom fields for storing data about the component. */
    customFields?: InputMaybe<Array<CompassCustomFieldInput>>;
    /** The description of the component. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** A collection of fields for storing data about the component. */
    fields?: InputMaybe<Array<UpdateCompassFieldInput>>;
    /** The ID of the component being updated. */
    id: Scalars["ID"]["input"];
    /** The name of the component. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The unique identifier (ID) of the team that owns the component. */
    ownerId?: InputMaybe<Scalars["ID"]["input"]>;
    /** A unique identifier for the component. */
    slug?: InputMaybe<Scalars["String"]["input"]>;
    /** The state of the component. */
    state?: InputMaybe<Scalars["String"]["input"]>;
};

/** Accepts input for updating a component link. */
export type UpdateCompassComponentLinkInput = {
    /** The ID for the component to update the link. */
    componentId: Scalars["ID"]["input"];
    /** The link to be updated for the component. */
    link: UpdateCompassLinkInput;
};

/** The payload returned after updating a component link. */
export type UpdateCompassComponentLinkPayload = Payload & {
    __typename?: "UpdateCompassComponentLinkPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The newly updated component link. */
    updatedComponentLink?: Maybe<CompassLink>;
};

/** The payload returned from updating an existing component. */
export type UpdateCompassComponentPayload = Payload & {
    __typename?: "UpdateCompassComponentPayload";
    /**
     * The details of the component that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:component:compass__
     *
     *
     */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating an existing component's type. */
export type UpdateCompassComponentTypeInput = {
    id: Scalars["ID"]["input"];
    type?: InputMaybe<CompassComponentType>;
    typeId?: InputMaybe<Scalars["ID"]["input"]>;
};

/** Input to update the metadata for a component type. */
export type UpdateCompassComponentTypeMetadataInput = {
    /** The description of the component type. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The icon key of the component type. */
    iconKey?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID((ARI) of the component type being updated. */
    id: Scalars["ID"]["input"];
    /** The name of the component type. */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

/** The result from updating the metadata for a component type. */
export type UpdateCompassComponentTypeMetadataPayload = {
    __typename?: "UpdateCompassComponentTypeMetadataPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The updated component type. */
    updatedComponentType?: Maybe<CompassComponentTypeObject>;
};

/** The payload returned from updating a component's type. */
export type UpdateCompassComponentTypePayload = Payload & {
    __typename?: "UpdateCompassComponentTypePayload";
    /** The details of the component that was mutated. */
    componentDetails?: Maybe<CompassComponent>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input to update a field. */
export type UpdateCompassFieldInput = {
    /** The ID of the field definition. */
    definition: Scalars["ID"]["input"];
    /** The value of the field. */
    value: CompassFieldValueInput;
};

export type UpdateCompassFreeformUserDefinedParameterInput = {
    /** The value that will be used if the user does not provide a value. */
    defaultValue?: InputMaybe<Scalars["String"]["input"]>;
    /** The description of the parameter. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The id of the parameter to update */
    id: Scalars["ID"]["input"];
    /** The name of the parameter. */
    name: Scalars["String"]["input"];
};

/** Accepts input to a update a scorecard criterion representing the presence of a description. */
export type UpdateCompassHasDescriptionScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */
export type UpdateCompassHasFieldScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID for the field definition which is the target of a relationship. */
    fieldDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** ID of the scorecard criteria to update */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a scorecard criterion representing the presence of a link, for example, 'Has Repository' or 'Has Documentation'. */
export type UpdateCompassHasLinkScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** ID of the scorecard criteria to update */
    id: Scalars["ID"]["input"];
    /** The type of link, for example, 'Repository' if 'Has Repository'. */
    linkType?: InputMaybe<CompassLinkType>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The comparison operation to be performed. */
    textComparator?: InputMaybe<CompassCriteriaTextComparatorOptions>;
    /** The value that the field is compared to. */
    textComparatorValue?: InputMaybe<Scalars["String"]["input"]>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to update a scorecard criterion checking the value of a specified metric ID. */
export type UpdateCompassHasMetricValueCriteriaInput = {
    /** Automatically create metric sources for the custom metric definition associated with this criterion */
    automaticallyCreateMetricSources?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The comparison operation to be performed between the metric and comparator value. */
    comparator?: InputMaybe<CompassCriteriaNumberComparatorOptions>;
    /** The threshold value that the metric is compared to. */
    comparatorValue?: InputMaybe<Scalars["Float"]["input"]>;
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** ID of the scorecard criteria to update */
    id: Scalars["ID"]["input"];
    /** The ID of the component metric to check the value of. */
    metricDefinitionId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts input to a update a scorecard criterion representing the presence of an owner. */
export type UpdateCompassHasOwnerScorecardCriteriaInput = {
    /** The optional, user provided description of the scorecard criterion */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ID of the scorecard criterion to update. */
    id: Scalars["ID"]["input"];
    /** The optional, user provided name of the scorecard criterion */
    name?: InputMaybe<Scalars["String"]["input"]>;
    scoringStrategyRules?: InputMaybe<CompassUpdateScorecardCriteriaScoringStrategyRulesInput>;
    /** The weight that will be used in determining the aggregate score. */
    weight?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Accepts details of the link to be updated. */
export type UpdateCompassLinkInput = {
    /** The unique identifier (ID) of the link. */
    id: Scalars["ID"]["input"];
    /** The name of the link. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The type of the link. */
    type?: InputMaybe<CompassLinkType>;
    /** The URL of the link. */
    url?: InputMaybe<Scalars["URL"]["input"]>;
};

export type UpdateCompassScorecardCriteriaInput = {
    dynamic?: InputMaybe<CompassUpdateDynamicScorecardCriteriaInput>;
    hasCustomBooleanValue?: InputMaybe<CompassUpdateHasCustomBooleanFieldScorecardCriteriaInput>;
    hasCustomMultiSelectValue?: InputMaybe<CompassUpdateHasCustomMultiSelectFieldScorecardCriteriaInput>;
    hasCustomNumberValue?: InputMaybe<CompassUpdateHasCustomNumberFieldScorecardCriteriaInput>;
    hasCustomSingleSelectValue?: InputMaybe<CompassUpdateHasCustomSingleSelectFieldScorecardCriteriaInput>;
    hasCustomTextValue?: InputMaybe<CompassUpdateHasCustomTextFieldScorecardCriteriaInput>;
    hasDescription?: InputMaybe<UpdateCompassHasDescriptionScorecardCriteriaInput>;
    hasField?: InputMaybe<UpdateCompassHasFieldScorecardCriteriaInput>;
    hasLink?: InputMaybe<UpdateCompassHasLinkScorecardCriteriaInput>;
    hasMetricValue?: InputMaybe<UpdateCompassHasMetricValueCriteriaInput>;
    hasOwner?: InputMaybe<UpdateCompassHasOwnerScorecardCriteriaInput>;
};

export type UpdateCompassScorecardInput = {
    componentCreationTimeFilter?: InputMaybe<CompassComponentCreationTimeFilterInput>;
    componentCustomFieldFilters?: InputMaybe<
        Array<CompassCustomFieldFilterInput>
    >;
    componentLabelNames?: InputMaybe<Array<Scalars["String"]["input"]>>;
    componentLifecycleStages?: InputMaybe<CompassLifecycleFilterInput>;
    componentOwnerIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    componentTierValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
    componentTypeIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    createCriteria?: InputMaybe<Array<CreateCompassScorecardCriteriaInput>>;
    deleteCriteria?: InputMaybe<Array<DeleteCompassScorecardCriteriaInput>>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    importance?: InputMaybe<CompassScorecardImportance>;
    isDeactivationEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    ownerId?: InputMaybe<Scalars["ID"]["input"]>;
    repositoryValues?: InputMaybe<CompassRepositoryValueInput>;
    scoringStrategyType?: InputMaybe<CompassScorecardScoringStrategyType>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    statusConfig?: InputMaybe<CompassScorecardStatusConfigInput>;
    updateCriteria?: InputMaybe<Array<UpdateCompassScorecardCriteriaInput>>;
};

/** The payload returned from updating a scorecard criterion. */
export type UpdateCompassScorecardPayload = Payload & {
    __typename?: "UpdateCompassScorecardPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The scorecard that was mutated.
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __read:scorecard:compass__
     *
     *
     */
    scorecardDetails?: Maybe<CompassScorecard>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type UpdateCompassUserDefinedParameterInput = {
    /** Input to update a freeform parameter. */
    freeformField?: InputMaybe<UpdateCompassFreeformUserDefinedParameterInput>;
};

/** The input sent when updating user defined parameters. */
export type UpdateCompassUserDefinedParametersInput = {
    /** The component id associated with the parameters. */
    componentId: Scalars["ID"]["input"];
    /** The new parameter definitions to create for the component. */
    createParameters?: InputMaybe<
        Array<CreateCompassUserDefinedParameterInput>
    >;
    /** The existing parameter definitions to delete for the component. */
    deleteParameters?: InputMaybe<
        Array<DeleteCompassUserDefinedParameterInput>
    >;
    /** The existing parameter definitions to update for the component. */
    updateParameters?: InputMaybe<
        Array<UpdateCompassUserDefinedParameterInput>
    >;
};

/** The payload returned from updating user defined parameters. */
export type UpdateCompassUserDefinedParametersPayload = Payload & {
    __typename?: "UpdateCompassUserDefinedParametersPayload";
    /** A list of errors that occurred during parameter updates. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether parameters were updated successfully. */
    success: Scalars["Boolean"]["output"];
    /** The associated component and created list of parameters. */
    userParameterDetails?: Maybe<CompassUserDefinedParameters>;
};

/**
 * ###################################################################################################################
 *  COMPASS API SPEC
 * ###################################################################################################################
 */
export type UpdateComponentApiInput = {
    componentId: Scalars["String"]["input"];
    defaultTag?: InputMaybe<Scalars["String"]["input"]>;
    path?: InputMaybe<Scalars["String"]["input"]>;
    repo?: InputMaybe<CompassComponentApiRepoUpdate>;
    status?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateComponentApiPayload = {
    __typename?: "UpdateComponentApiPayload";
    /**
     *
     *
     * ### OAuth Scopes
     *
     * One of the following scopes will need to be present on OAuth requests to get data from this field
     *
     * * __compass:atlassian-external__
     *
     *
     */
    api?: Maybe<CompassComponentApi>;
    errors?: Maybe<Array<Scalars["String"]["output"]>>;
    success: Scalars["Boolean"]["output"];
};

export type UpdateComponentApiUploadInput = {
    componentId: Scalars["ID"]["input"];
    effectiveAt: Scalars["String"]["input"];
    shouldDereference?: InputMaybe<Scalars["Boolean"]["input"]>;
    tags: Array<Scalars["String"]["input"]>;
    uploadId: Scalars["ID"]["input"];
};

export type UpdateComponentApiUploadPayload = {
    __typename?: "UpdateComponentApiUploadPayload";
    errors?: Maybe<Array<Scalars["String"]["output"]>>;
    success: Scalars["Boolean"]["output"];
};

export type UpdateContentDataClassificationLevelInput = {
    classificationLevelId: Scalars["ID"]["input"];
    contentStatus: ContentDataClassificationMutationContentStatus;
    id: Scalars["Long"]["input"];
};

export type UpdateContentDataClassificationLevelPayload = Payload & {
    __typename?: "UpdateContentDataClassificationLevelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateContentPermissionsInput = {
    confluencePrincipalType?: InputMaybe<ConfluencePrincipalType>;
    contentRole: ContentRole;
    principalId: Scalars["ID"]["input"];
};

export type UpdateContentTemplateInput = {
    body: ContentTemplateBodyInput;
    description?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["ID"]["input"]>;
    labels?: InputMaybe<Array<InputMaybe<ContentTemplateLabelInput>>>;
    name: Scalars["String"]["input"];
    space?: InputMaybe<ContentTemplateSpaceInput>;
    templateId: Scalars["ID"]["input"];
    templateType: GraphQlContentTemplateType;
};

export type UpdateCoverPictureWidthInput = {
    contentId: Scalars["ID"]["input"];
    /** Determines whether mutation updates CURRENT vs. DRAFT page entity. Defaults to CURRENT status. */
    contentStatus?: InputMaybe<ConfluenceMutationContentStatus>;
    coverPictureWidth: GraphQlCoverPictureWidth;
};

export type UpdateCoverPictureWidthPayload = Payload & {
    __typename?: "UpdateCoverPictureWidthPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Content;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/**
 * Updates a custom filter with the given id in the board with the given boardId.
 * The update will update the entire filter (ie. not a partial update)
 */
export type UpdateCustomFilterInput = {
    boardId: Scalars["ID"]["input"];
    description?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    jql: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
};

export type UpdateDefaultSpacePermissionsInput = {
    permissionsToAdd: Array<InputMaybe<SpacePermissionType>>;
    permissionsToRemove: Array<InputMaybe<SpacePermissionType>>;
    subjectKeyInput: UpdatePermissionSubjectKeyInput;
};

export type UpdateDefaultSpacePermissionsPayload = {
    __typename?: "UpdateDefaultSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for updating relationship properties */
export type UpdateDevOpsContainerRelationshipEntityPropertiesInput = {
    /** The ARI of the relationship entity */
    id: Scalars["ID"]["input"];
    properties: Array<DevOpsContainerRelationshipEntityPropertyInput>;
};

/** The response payload of updating relationship properties */
export type UpdateDevOpsContainerRelationshipEntityPropertiesPayload =
    Payload & {
        __typename?: "UpdateDevOpsContainerRelationshipEntityPropertiesPayload";
        /**
         * The errors occurred during relationship properties update
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errors?: Maybe<Array<MutationError>>;
        /**
         * Look up JSON properties of the service by keys
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        properties?: Maybe<Scalars["JSON"]["output"]>;
        /**
         * The result of whether relationship properties have been successfully updated or not
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        success: Scalars["Boolean"]["output"];
    };

/** The response payload of updating relationship properties */
export type UpdateDevOpsContainerRelationshipEntityPropertiesPayloadPropertiesArgs =
    {
        keys: Array<Scalars["String"]["input"]>;
    };

/** The request input for updating a relationship between a DevOps Service and Jira Project */
export type UpdateDevOpsServiceAndJiraProjectRelationshipInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The DevOps Graph Service_And_Jira_Project relationship ARI */
    id: Scalars["ID"]["input"];
    /**
     * The revision that must be provided when updating a relationship between DevOps Service and Jira Project to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["input"];
};

export type UpdateDevOpsServiceAndJiraProjectRelationshipPayload = Payload & {
    __typename?: "UpdateDevOpsServiceAndJiraProjectRelationshipPayload";
    /**
     * The list of errors occurred during create relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceAndJiraProjectRelationship?: Maybe<DevOpsServiceAndJiraProjectRelationship>;
    /**
     * The result of whether the relationship is created successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for updating a relationship between a DevOps Service and an Opsgenie Team */
export type UpdateDevOpsServiceAndOpsgenieTeamRelationshipInput = {
    /** The new description assigned to the relationship. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The DevOps Graph Service_And_Opsgenie_Team relationship ARI */
    id: Scalars["ID"]["input"];
    /**
     * The revision that must be provided when updating a relationship between DevOps Service and Opsgenie Team to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["input"];
};

/** The response payload of updating a relationship between a DevOps Service and an Opsgenie Team */
export type UpdateDevOpsServiceAndOpsgenieTeamRelationshipPayload = Payload & {
    __typename?: "UpdateDevOpsServiceAndOpsgenieTeamRelationshipPayload";
    /**
     * The list of errors occurred during update relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated relationship between DevOps Service and Opsgenie Team
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceAndOpsgenieTeamRelationship?: Maybe<DevOpsServiceAndOpsgenieTeamRelationship>;
    /**
     * The result of whether the relationship is updated successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for updating a relationship between a DevOps Service and a Repository */
export type UpdateDevOpsServiceAndRepositoryRelationshipInput = {
    /** The description of the relationship */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The ARI of the relationship */
    id: Scalars["ID"]["input"];
    /**
     * The revision that must be provided when updating a relationship between DevOps Service and a Repository to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["input"];
};

export type UpdateDevOpsServiceAndRepositoryRelationshipPayload = Payload & {
    __typename?: "UpdateDevOpsServiceAndRepositoryRelationshipPayload";
    /**
     * The list of errors occurred during update of the relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceAndRepositoryRelationship?: Maybe<DevOpsServiceAndRepositoryRelationship>;
    /**
     * The result of whether the relationship is updated successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for updating DevOps Service Entity Properties */
export type UpdateDevOpsServiceEntityPropertiesInput = {
    /** The ARI of the DevOps Service */
    id: Scalars["ID"]["input"];
    properties: Array<DevOpsServiceEntityPropertyInput>;
};

/** The response payload of updating DevOps Service Entity Properties */
export type UpdateDevOpsServiceEntityPropertiesPayload = Payload & {
    __typename?: "UpdateDevOpsServiceEntityPropertiesPayload";
    /**
     * The errors occurred during DevOps Service Entity Properties update
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * Look up JSON properties of the service by keys
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    properties?: Maybe<Scalars["JSON"]["output"]>;
    /**
     * The result of whether DevOps Service Entity Properties have been successfully updated or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The response payload of updating DevOps Service Entity Properties */
export type UpdateDevOpsServiceEntityPropertiesPayloadPropertiesArgs = {
    keys: Array<Scalars["String"]["input"]>;
};

/** The request input for updating a DevOps Service */
export type UpdateDevOpsServiceInput = {
    /** The ID of the DevOps Service in Compass */
    compassId?: InputMaybe<Scalars["ID"]["input"]>;
    /** The revision of the DevOps Service in Compass */
    compassRevision?: InputMaybe<Scalars["Int"]["input"]>;
    /** The new description assigned to the DevOps Service */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The DevOps Service ARI */
    id: Scalars["ID"]["input"];
    /** The new name assigned to the DevOps Service */
    name: Scalars["String"]["input"];
    /** The properties of the DevOps Service to be updated */
    properties?: InputMaybe<Array<DevOpsServiceEntityPropertyInput>>;
    /**
     * The revision that must be provided when updating a DevOps Service to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["input"];
    /** The id of the Tier assigned to the Service */
    serviceTier: Scalars["ID"]["input"];
    /** The id of the Service Type assigned to the Service */
    serviceType?: InputMaybe<Scalars["ID"]["input"]>;
};

/** The response payload of updating a DevOps Service */
export type UpdateDevOpsServicePayload = Payload & {
    __typename?: "UpdateDevOpsServicePayload";
    /**
     * The list of errors occurred during DevOps Service update
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated DevOps Service
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    service?: Maybe<DevOpsService>;
    /**
     * The result of whether the DevOps Service is updated successfully or not
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** The request input for updating a DevOps Service Relationship */
export type UpdateDevOpsServiceRelationshipInput = {
    /** The description of the DevOps Service Relationship */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The DevOps Service Relationship ARI */
    id: Scalars["ID"]["input"];
    /**
     * The revision that must be provided when updating a DevOps Service Relationship to prevent
     * simultaneous updates from overwriting each other.
     */
    revision: Scalars["ID"]["input"];
};

/** The response payload for updating a inter DevOps Service Relationship */
export type UpdateDevOpsServiceRelationshipPayload = Payload & {
    __typename?: "UpdateDevOpsServiceRelationshipPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     * The updated inter-service relationship
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    serviceRelationship?: Maybe<DevOpsServiceRelationship>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateDeveloperLogAccessInput = {
    /** AppId as ARI */
    appId: Scalars["ID"]["input"];
    /** An array of context ARIs */
    contextIds: Array<Scalars["ID"]["input"]>;
    /** App environment */
    environmentType: AppEnvironmentType;
    /** Boolean representing whether access should be granted or not */
    shouldHaveAccess: Scalars["Boolean"]["input"];
};

export type UpdateDeveloperLogAccessPayload = Payload & {
    __typename?: "UpdateDeveloperLogAccessPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateEmbedInput = {
    embedIconUrl?: InputMaybe<Scalars["String"]["input"]>;
    embedUrl?: InputMaybe<Scalars["String"]["input"]>;
    extensionKey?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    product?: InputMaybe<Scalars["String"]["input"]>;
    resourceType?: InputMaybe<Scalars["String"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateExternalCollaboratorDefaultSpaceInput = {
    enabled: Scalars["Boolean"]["input"];
    spaceId: Scalars["Long"]["input"];
};

export type UpdateExternalCollaboratorDefaultSpacePayload = Payload & {
    __typename?: "UpdateExternalCollaboratorDefaultSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateInstallationDetailsResponse = {
    __typename?: "UpdateInstallationDetailsResponse";
    errors?: Maybe<Array<MutationError>>;
    installation?: Maybe<AppInstallation>;
    success: Scalars["Boolean"]["output"];
};

/** Update: Mutation (PUT) */
export type UpdateJiraPlaybookInput = {
    filters?: InputMaybe<Array<JiraPlaybookIssueFilterInput>>;
    id: Scalars["ID"]["input"];
    name: Scalars["String"]["input"];
    /** scopeId is projectId */
    scopeId?: InputMaybe<Scalars["String"]["input"]>;
    scopeType: JiraPlaybookScopeType;
    state?: InputMaybe<JiraPlaybookStateField>;
    steps: Array<UpdateJiraPlaybookStepInput>;
};

/** Update: Mutation Response */
export type UpdateJiraPlaybookPayload = Payload & {
    __typename?: "UpdateJiraPlaybookPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    playbook?: Maybe<JiraPlaybook>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

/** Update: Mutation */
export type UpdateJiraPlaybookStateInput = {
    id: Scalars["ID"]["input"];
    state: JiraPlaybookStateField;
};

/** Update playbook state: Mutation */
export type UpdateJiraPlaybookStatePayload = Payload & {
    __typename?: "UpdateJiraPlaybookStatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    playbook?: Maybe<JiraPlaybook>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ❌ No |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateJiraPlaybookStepInput = {
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    name: Scalars["String"]["input"];
    ruleId?: InputMaybe<Scalars["String"]["input"]>;
    type: JiraPlaybookStepType;
};

export type UpdateNestedPageOwnersPayload = Payload & {
    __typename?: "UpdateNestedPageOwnersPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    warnings?: Maybe<Array<Maybe<ChangeOwnerWarning>>>;
};

export type UpdateOwnerInput = {
    contentId: Scalars["ID"]["input"];
    ownerId: Scalars["String"]["input"];
};

export type UpdateOwnerPayload = {
    __typename?: "UpdateOwnerPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Content;
};

export type UpdatePageExtensionInput = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type UpdatePageInput = {
    body?: InputMaybe<PageBodyInput>;
    extensions?: InputMaybe<Array<InputMaybe<UpdatePageExtensionInput>>>;
    mediaAttachments?: InputMaybe<Array<MediaAttachmentInput>>;
    minorEdit?: InputMaybe<Scalars["Boolean"]["input"]>;
    pageId: Scalars["ID"]["input"];
    restrictions?: InputMaybe<PageRestrictionsInput>;
    status?: InputMaybe<PageStatusInput>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePageOwnersInput = {
    ownerId: Scalars["ID"]["input"];
    pageIDs: Array<InputMaybe<Scalars["Long"]["input"]>>;
};

export type UpdatePageOwnersPayload = Payload & {
    __typename?: "UpdatePageOwnersPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId: Scalars["ID"]["output"];
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type UpdatePagePayload = {
    __typename?: "UpdatePagePayload";
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'content' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    content?: Maybe<Content>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    mediaAttached: Array<MediaAttachmentOrError>;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "AskInCcApiPlatformBeforeUsing")' query directive to the 'page' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated Please ask in #cc-api-platform before using.
     */
    page?: Maybe<Page>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    pageId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    restrictions?: Maybe<PageRestrictions>;
};

export type UpdatePageStatusesInput = {
    pages: Array<InputMaybe<NestedPageInput>>;
    spaceKey: Scalars["String"]["input"];
    targetContentState: ContentStateInput;
};

export type UpdatePageStatusesPayload = Payload & {
    __typename?: "UpdatePageStatusesPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    taskId: Scalars["ID"]["output"];
};

export type UpdatePermissionSubjectKeyInput = {
    permissionDisplayType: PermissionDisplayType;
    subjectId: Scalars["String"]["input"];
};

export type UpdatePolarisCommentInput = {
    content?: InputMaybe<Scalars["JSON"]["input"]>;
    delete?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["ID"]["input"];
};

/** #### Payload ##### */
export type UpdatePolarisCommentPayload = Payload & {
    __typename?: "UpdatePolarisCommentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisComment>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisIdeaInput = {
    archived?: InputMaybe<Scalars["Boolean"]["input"]>;
    lastCommentsViewedTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    lastInsightsViewedTimestamp?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePolarisIdeaPayload = Payload & {
    __typename?: "UpdatePolarisIdeaPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisIdea>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisIdeaTemplateInput = {
    color?: InputMaybe<Scalars["String"]["input"]>;
    description?: InputMaybe<Scalars["String"]["input"]>;
    emoji?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ID"]["input"];
    project: Scalars["ID"]["input"];
    /**
     * Template in ADF format.  See
     * https://developer.atlassian.com/platform/atlassian-document-format/
     */
    template?: InputMaybe<Scalars["JSON"]["input"]>;
    title: Scalars["String"]["input"];
};

export type UpdatePolarisIdeaTemplatePayload = Payload & {
    __typename?: "UpdatePolarisIdeaTemplatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisInsightInput = {
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    snippets?: InputMaybe<Array<UpdatePolarisSnippetInput>>;
};

export type UpdatePolarisInsightPayload = Payload & {
    __typename?: "UpdatePolarisInsightPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisInsight>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisMatrixAxis = {
    dimension: Scalars["String"]["input"];
    field: Scalars["ID"]["input"];
    fieldOptions?: InputMaybe<Array<PolarisGroupValueInput>>;
    reversed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdatePolarisMatrixConfig = {
    axes?: InputMaybe<Array<UpdatePolarisMatrixAxis>>;
};

export type UpdatePolarisPlayContribution = {
    amount?: InputMaybe<Scalars["Int"]["input"]>;
    /** the extent of the contribution (null=drop value) */
    comment?: InputMaybe<Scalars["ID"]["input"]>;
    /** the comment (null=drop value, which is not permitted; delete the contribution if needed) */
    content?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type UpdatePolarisPlayContributionPayload = {
    __typename?: "UpdatePolarisPlayContributionPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisPlayContribution>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisPlayInput = {
    id: Scalars["ID"]["input"];
    parameters?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type UpdatePolarisPlayPayload = {
    __typename?: "UpdatePolarisPlayPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisPlay>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisSnippetInput = {
    /** Data in JSON format. It will be validated with JSON schema of Polaris Insights Data format. */
    data?: InputMaybe<Scalars["JSON"]["input"]>;
    deleteProperties?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /**
     * The client can specify either a specific snippet id, or an
     * oauthClientId.  In the latter case, we will create a snippet on
     * this data point (nee insight) if one doesn't exist already, and it
     * is an error for there to be more than one snippet with the same
     * oauthClientId.
     */
    id?: InputMaybe<Scalars["ID"]["input"]>;
    /** OauthClientId of CaaS app */
    oauthClientId?: InputMaybe<Scalars["String"]["input"]>;
    setProperties?: InputMaybe<Scalars["JSON"]["input"]>;
    /** Snippet url that is source of data */
    url?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePolarisTimelineConfig = {
    dueDateField?: InputMaybe<Scalars["ID"]["input"]>;
    endTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    mode?: InputMaybe<PolarisTimelineMode>;
    startDateField?: InputMaybe<Scalars["ID"]["input"]>;
    startTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    summaryCardField?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdatePolarisViewArrangementInfoPayload = Payload & {
    __typename?: "UpdatePolarisViewArrangementInfoPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisViewInput = {
    /** view emoji */
    description?: InputMaybe<Scalars["JSON"]["input"]>;
    /** the name of the view */
    emoji?: InputMaybe<Scalars["String"]["input"]>;
    enabledAutoSave?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** table column sizes per field */
    fieldRollups?: InputMaybe<Array<PolarisViewFieldRollupInput>>;
    /** rollup type per field */
    fields?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** a field to sort by */
    filter?: InputMaybe<Array<PolarisViewFilterInput>>;
    /** the table columns list of fields (table viz) or fields to show */
    groupBy?: InputMaybe<Scalars["ID"]["input"]>;
    /** what field to group by (board viz) */
    groupValues?: InputMaybe<Array<PolarisGroupValueInput>>;
    /** view filter congfiguration */
    hidden?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    hideEmptyColumns?: InputMaybe<Scalars["Boolean"]["input"]>;
    hideEmptyGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** description of the view */
    jql?: InputMaybe<Scalars["String"]["input"]>;
    lastCommentsViewedTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    /** fields that are included in view but hidden */
    lastViewedTimestamp?: InputMaybe<Scalars["String"]["input"]>;
    layoutType?: InputMaybe<PolarisViewLayoutType>;
    matrixConfig?: InputMaybe<UpdatePolarisMatrixConfig>;
    /** view to update, if this is an UPDATE operation */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** what are the (ordered) vertical grouping values */
    sort?: InputMaybe<Array<PolarisSortFieldInput>>;
    sortMode?: InputMaybe<PolarisViewSortMode>;
    /** just the user filtering part of the JQL */
    tableColumnSizes?: InputMaybe<Array<PolarisViewTableColumnSizeInput>>;
    timelineConfig?: InputMaybe<UpdatePolarisTimelineConfig>;
    /** the JQL (sets filter and sorting) */
    userJql?: InputMaybe<Scalars["String"]["input"]>;
    /** what are the (ordered) grouping values */
    verticalGroupBy?: InputMaybe<Scalars["ID"]["input"]>;
    /** what field to vertical group by (board viz) */
    verticalGroupValues?: InputMaybe<Array<PolarisGroupValueInput>>;
    view?: InputMaybe<Scalars["ID"]["input"]>;
    whiteboardConfig?: InputMaybe<UpdatePolarisWhiteboardConfig>;
};

export type UpdatePolarisViewPayload = Payload & {
    __typename?: "UpdatePolarisViewPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisView>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisViewRankInput = {
    container?: InputMaybe<Scalars["ID"]["input"]>;
    /** new container if needed */
    rank: Scalars["Int"]["input"];
};

export type UpdatePolarisViewRankV2Payload = Payload & {
    __typename?: "UpdatePolarisViewRankV2Payload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisViewSet>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisViewSetInput = {
    name?: InputMaybe<Scalars["String"]["input"]>;
    viewSet: Scalars["ID"]["input"];
};

export type UpdatePolarisViewSetPayload = Payload & {
    __typename?: "UpdatePolarisViewSetPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    node?: Maybe<PolarisViewSet>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisViewTimestampPayload = Payload & {
    __typename?: "UpdatePolarisViewTimestampPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdatePolarisWhiteboardConfig = {
    id: Scalars["ID"]["input"];
};

export type UpdateRelationInput = {
    relationName: RelationType;
    sourceKey: Scalars["String"]["input"];
    sourceStatus?: InputMaybe<Scalars["String"]["input"]>;
    sourceType: RelationSourceType;
    sourceVersion?: InputMaybe<Scalars["Int"]["input"]>;
    targetKey: Scalars["String"]["input"];
    targetStatus?: InputMaybe<Scalars["String"]["input"]>;
    targetType: RelationTargetType;
    targetVersion?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 *
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 *
 *
 */
export type UpdateRelationPayload = {
    __typename?: "UpdateRelationPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    relationName: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    sourceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    targetKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    url: Scalars["String"]["output"];
};

export type UpdateSiteLookAndFeelInput = {
    backgroundColor?: InputMaybe<Scalars["String"]["input"]>;
    faviconFiles: Array<FaviconFileInput>;
    frontCoverState?: InputMaybe<GraphQlFrontCoverState>;
    highlightColor?: InputMaybe<Scalars["String"]["input"]>;
    resetFavicon?: InputMaybe<Scalars["Boolean"]["input"]>;
    resetSiteLogo?: InputMaybe<Scalars["Boolean"]["input"]>;
    showFrontCover?: InputMaybe<Scalars["Boolean"]["input"]>;
    showSiteName?: InputMaybe<Scalars["Boolean"]["input"]>;
    siteLogoFileStoreId?: InputMaybe<Scalars["ID"]["input"]>;
    siteName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSiteLookAndFeelPayload = Payload & {
    __typename?: "UpdateSiteLookAndFeelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    siteLookAndFeel?: Maybe<SiteLookAndFeel>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateSitePermissionInput = {
    anonymous?: InputMaybe<AnonymousWithPermissionsInput>;
    groups?: InputMaybe<Array<InputMaybe<GroupWithPermissionsInput>>>;
    unlicensedUser?: InputMaybe<UnlicensedUserWithPermissionsInput>;
    users?: InputMaybe<Array<InputMaybe<UserWithPermissionsInput>>>;
};

export type UpdateSpaceDefaultClassificationLevelInput = {
    classificationLevelId: Scalars["ID"]["input"];
    id: Scalars["Long"]["input"];
};

export type UpdateSpaceDefaultClassificationLevelPayload = Payload & {
    __typename?: "UpdateSpaceDefaultClassificationLevelPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateSpaceDetailsInput = {
    /** The new alias for the space. */
    alias?: InputMaybe<Scalars["String"]["input"]>;
    /** The full set of categories belonging to the space. */
    categories?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
    /** The new description as a string for the space. */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The new content id as a string for the space's homepage. */
    homepagePageId?: InputMaybe<Scalars["Long"]["input"]>;
    /** The id of the target space to update. */
    id: Scalars["Long"]["input"];
    /** The new name for the space. */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** The new owner for the space. Can be either a group or user. */
    owner?: InputMaybe<ConfluenceSpaceDetailsSpaceOwnerInput>;
    /** The new status as a string for the space. */
    status?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateSpaceDetailsPayload = Payload & {
    __typename?: "UpdateSpaceDetailsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateSpacePermissionsInput = {
    spaceKey: Scalars["String"]["input"];
    subjectPermissionDeltasList: Array<SubjectPermissionDeltas>;
};

export type UpdateSpacePermissionsPayload = {
    __typename?: "UpdateSpacePermissionsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateSpaceTypeSettingsInput = {
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
    spaceTypeSettings?: InputMaybe<SpaceTypeSettingsInput>;
};

export type UpdateSpaceTypeSettingsPayload = Payload & {
    __typename?: "UpdateSpaceTypeSettingsPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spaceTypeSettings?: Maybe<SpaceTypeSettings>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UpdateTemplatePropertySetInput = {
    /** ID of template to create property for */
    templateId: Scalars["Long"]["input"];
    /** Template properties */
    templatePropertySet: TemplatePropertySetInput;
};

export type UpdateTemplatePropertySetPayload = {
    __typename?: "UpdateTemplatePropertySetPayload";
    /**
     * ID of template to create property for
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templateId: Scalars["ID"]["output"];
    /**
     * Template properties
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    templatePropertySet: TemplatePropertySetPayload;
};

export type UpdateUserInstallationRulesInput = {
    cloudId: Scalars["ID"]["input"];
    rule: UserInstallationRuleValue;
};

export type UpdatedNestedPageOwnersInput = {
    ownerId: Scalars["ID"]["input"];
    pages: Array<InputMaybe<NestedPageInput>>;
};

/**
 * There are 3 types of accounts:
 *
 * * AtlassianAccountUser
 * * this represents a real person that has an account in a wide range of Atlassian products
 *
 * * CustomerUser
 * * This represents a real person who is a customer of an organisation who uses an Atlassian product to provide service to their customers.
 * Currently, this is used within Jira Service Desk for external service desks.
 *
 * * AppUser
 * * this does not represent a real person but rather the identity that backs an installed application
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 *
 *
 */
export type User = {
    /** The account ID for the user. */
    accountId: Scalars["ID"]["output"];
    /** The lifecycle status of the account */
    accountStatus: AccountStatus;
    /** The canonical account ID for the user. */
    canonicalAccountId: Scalars["ID"]["output"];
    /** The account ID for the user.  This is an alias for `canonicalAccountId` */
    id: Scalars["ID"]["output"];
    /**
     * The display name of the user. This should be used when rendering a user textually within content.
     * If the user has restricted visibility of their name, their nickname will be
     * displayed as a substitute value.
     */
    name: Scalars["String"]["output"];
    /**
     * The absolute URI (RFC3986) to the avatar name of the user. This should be used when rendering a user graphically within content.
     * If the user has restricted visibility of their avatar or has not set
     * an avatar, an alternative URI will be provided as a substitute value.
     */
    picture: Scalars["URL"]["output"];
};

export type UserAccess = {
    __typename?: "UserAccess";
    hasAccess: Scalars["Boolean"]["output"];
};

export type UserAuthTokenForExtensionInput = {
    /**
     * List of ARI's, this should be the same as passed to `InvokeExtensionInput`.
     * The most specific context is extracted and passed to outbound-auth to support
     * access narrowing (Tenant Isolation)
     *
     * *Important:* this should start with the most specific context as the
     * most specific extension will be the selected extension.
     */
    contextIds: Array<Scalars["ID"]["input"]>;
    extensionId: Scalars["ID"]["input"];
};

export type UserAuthTokenForExtensionResponse = Payload & {
    __typename?: "UserAuthTokenForExtensionResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    authToken?: Maybe<AuthToken>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type UserConsent = {
    __typename?: "UserConsent";
    appId: Scalars["ID"]["output"];
    environmentId: Scalars["ID"]["output"];
    oauthClientId: Scalars["ID"]["output"];
    versionId: Scalars["ID"]["output"];
};

export type UserConsentExtension = {
    __typename?: "UserConsentExtension";
    appEnvironmentVersion: UserConsentExtensionAppEnvironmentVersion;
    consentedAt: Scalars["DateTime"]["output"];
    user: UserConsentExtensionUser;
};

export type UserConsentExtensionAppEnvironmentVersion = {
    __typename?: "UserConsentExtensionAppEnvironmentVersion";
    id: Scalars["ID"]["output"];
};

export type UserConsentExtensionUser = {
    __typename?: "UserConsentExtensionUser";
    aaid: Scalars["ID"]["output"];
};

export type UserFingerprint = {
    __typename?: "UserFingerprint";
    /** The most recent anonymous ID based on the available data. */
    anonymousId?: Maybe<Scalars["String"]["output"]>;
    /** A list of all known anonymous IDs. */
    anonymousIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** The most recent Atlassian account ID based on the available data. */
    atlassianAccountId?: Maybe<Scalars["String"]["output"]>;
    /** A list of all known Atlassian account IDs. */
    atlassianAccountIds?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /** The user's persona, which provides information on their primary role or behavior. */
    persona?: Maybe<Scalars["String"]["output"]>;
    /** A list of personas associated with the user. */
    personas?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type UserFingerprintQuery = {
    __typename?: "UserFingerprintQuery";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    userFingerprint?: Maybe<UserFingerprint>;
};

export type UserFingerprintQueryUserFingerprintArgs = {
    anonymousId?: InputMaybe<Scalars["String"]["input"]>;
    atlassianAccountId?: InputMaybe<Scalars["String"]["input"]>;
    expandIdentity?: InputMaybe<Scalars["Boolean"]["input"]>;
    identityRecencyHrs?: InputMaybe<Scalars["Int"]["input"]>;
    identityResolution?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UserGrant = {
    __typename?: "UserGrant";
    accountId: Scalars["ID"]["output"];
    appDetails?: Maybe<UserGrantAppDetails>;
    appId?: Maybe<Scalars["ID"]["output"]>;
    id: Scalars["ID"]["output"];
    oauthClientId: Scalars["ID"]["output"];
    scopes?: Maybe<Array<Maybe<AppHostServiceScope>>>;
};

export type UserGrantAppDetails = {
    __typename?: "UserGrantAppDetails";
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    contactLink?: Maybe<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    privacyPolicyLink?: Maybe<Scalars["String"]["output"]>;
    termsOfServiceLink?: Maybe<Scalars["String"]["output"]>;
    vendorName?: Maybe<Scalars["String"]["output"]>;
};

export type UserGrantConnection = {
    __typename?: "UserGrantConnection";
    edges?: Maybe<Array<Maybe<UserGrantEdge>>>;
    nodes?: Maybe<Array<Maybe<UserGrant>>>;
    pageInfo: UserGrantPageInfo;
};

export type UserGrantEdge = {
    __typename?: "UserGrantEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<UserGrant>;
};

export type UserGrantPageInfo = {
    __typename?: "UserGrantPageInfo";
    endCursor?: Maybe<Scalars["String"]["output"]>;
    hasNextPage: Scalars["Boolean"]["output"];
    hasPreviousPage: Scalars["Boolean"]["output"];
    startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** --------------------------------------------------------------------------------------------- */
export type UserInput = {
    booleanUserInput?: InputMaybe<BooleanUserInput>;
    numberUserInput?: InputMaybe<NumberUserInput>;
    stringUserInput?: InputMaybe<StringUserInput>;
};

export enum UserInstallationRuleValue {
    Allow = "allow",
    Deny = "deny"
}

export type UserInstallationRules = {
    __typename?: "UserInstallationRules";
    rule: UserInstallationRuleValue;
};

export type UserInstallationRulesPayload = Payload & {
    __typename?: "UserInstallationRulesPayload";
    errors?: Maybe<Array<MutationError>>;
    rule?: Maybe<UserInstallationRuleValue>;
    success: Scalars["Boolean"]["output"];
};

export type UserOnboardingState = {
    __typename?: "UserOnboardingState";
    key: Scalars["String"]["output"];
    value?: Maybe<Scalars["String"]["output"]>;
};

export type UserPreferences = {
    __typename?: "UserPreferences";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    endOfPageRecommendationsOptInStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    favouriteTemplateEntityIds: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    feedRecommendedUserSettingsDismissTimestamp: Scalars["String"]["output"];
    /**
     * The user's AI-generated feed tab preference. Returns null if a preference hasn't been set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    feedTab?: Maybe<Scalars["String"]["output"]>;
    /**
     * The user's feed type (feed tab) preference. Returns null if a preference hasn't been set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    feedType?: Maybe<FeedType>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    globalPageCardAppearancePreference: PagesDisplayPersistenceOption;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homePagesDisplayView: PagesDisplayPersistenceOption;
    /**
     * The user's preference for whether Home right panel widgets are collapsed/expanded. Returns empty list if user hasn't collapsed/expanded a widget yet.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    homeWidgets: Array<HomeWidget>;
    /**
     * The user's preference for whether the home onboarding banner is dismissed or not.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isHomeOnboardingDismissed: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    keyboardShortcutDisabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    missionControlFeatureDiscoverySuggestions: Array<
        Maybe<MissionControlFeatureDiscoverySuggestionState>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    missionControlMetricSuggestions: Array<
        Maybe<MissionControlMetricSuggestionState>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    missionControlOverview: Array<Maybe<Scalars["String"]["output"]>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nav4OptOut?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    nextGenFeedOptInStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onboarded: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    onboardingState: Array<UserOnboardingState>;
    /**
     * The user's preference for filtering Recent pages. Set to ALL by default.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recentFilter: RecentFilter;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    searchExperimentOptInStatus: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    shouldShowCardOnPageTreeHover: PageCardInPageTreeHoverPreference;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    spacePagesDisplayView: PagesDisplayPersistenceOption;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated No longer used in FE
     */
    spacePagesSortView: PagesSortPersistenceOption;
    /**
     *
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     * @deprecated No longer used in FE
     */
    spaceViewsPersistence: SpaceViewsPersistenceOption;
    /**
     * The user's theme preference (color mode). Returns null if a preference hasn't been set.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    theme: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userSpacesNotifiedChangeBoardingOfExternalCollab: Array<
        Maybe<Scalars["String"]["output"]>
    >;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    userSpacesNotifiedOfExternalCollab: Array<
        Maybe<Scalars["String"]["output"]>
    >;
    /**
     * User's email preferences for content they created themselves
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    watchMyOwnContent?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserPreferencesMissionControlMetricSuggestionsArgs = {
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type UserPreferencesMissionControlOverviewArgs = {
    spaceId?: InputMaybe<Scalars["Long"]["input"]>;
};

export type UserPreferencesOnboardingStateArgs = {
    key?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type UserPreferencesSpacePagesDisplayViewArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type UserPreferencesSpacePagesSortViewArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type UserPreferencesSpaceViewsPersistenceArgs = {
    spaceKey: Scalars["String"]["input"];
};

export type UserPreferencesInput = {
    addUserSpaceNotifiedChangeBoardingOfExternalCollab?: InputMaybe<
        Scalars["String"]["input"]
    >;
    addUserSpaceNotifiedOfExternalCollab?: InputMaybe<
        Scalars["String"]["input"]
    >;
    endOfPageRecommendationsOptInStatus?: InputMaybe<
        Scalars["String"]["input"]
    >;
    feedRecommendedUserSettingsDismissTimestamp?: InputMaybe<
        Scalars["String"]["input"]
    >;
    feedTab?: InputMaybe<Scalars["String"]["input"]>;
    feedType?: InputMaybe<FeedType>;
    globalPageCardAppearancePreference?: InputMaybe<PagesDisplayPersistenceOption>;
    homePagesDisplayView?: InputMaybe<PagesDisplayPersistenceOption>;
    homeWidget?: InputMaybe<HomeWidgetInput>;
    isHomeOnboardingDismissed?: InputMaybe<Scalars["Boolean"]["input"]>;
    keyboardShortcutDisabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    missionControlFeatureDiscoverySuggestion?: InputMaybe<MissionControlFeatureDiscoverySuggestionInput>;
    missionControlMetricSuggestion?: InputMaybe<MissionControlMetricSuggestionInput>;
    missionControlOverview?: InputMaybe<MissionControlOverview>;
    nav4OptOut?: InputMaybe<Scalars["Boolean"]["input"]>;
    nextGenFeedOptInStatus?: InputMaybe<Scalars["String"]["input"]>;
    recentFilter?: InputMaybe<RecentFilter>;
    searchExperimentOptInStatus?: InputMaybe<Scalars["String"]["input"]>;
    shouldShowCardOnPageTreeHover?: InputMaybe<PageCardInPageTreeHoverPreference>;
    spacePagesDisplayView?: InputMaybe<SpacePagesDisplayView>;
    spacePagesSortView?: InputMaybe<SpacePagesSortView>;
    spaceViewsPersistence?: InputMaybe<SpaceViewsPersistence>;
    templateEntityFavouriteStatus?: InputMaybe<TemplateEntityFavouriteStatus>;
    theme?: InputMaybe<Scalars["String"]["input"]>;
    topNavigationOptedOut?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UserWithPermissionsInput = {
    accountId: Scalars["ID"]["input"];
    operations: Array<InputMaybe<OperationCheckResultInput>>;
};

export type UserWithRestrictions = {
    __typename?: "UserWithRestrictions";
    accountId?: Maybe<Scalars["String"]["output"]>;
    accountType?: Maybe<Scalars["String"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    hasSpaceEditPermission?: Maybe<Scalars["Boolean"]["output"]>;
    hasSpaceViewPermission?: Maybe<Scalars["Boolean"]["output"]>;
    operations?: Maybe<Array<Maybe<OperationCheckResult>>>;
    permissionType?: Maybe<SitePermissionType>;
    profilePicture?: Maybe<Icon>;
    publicName?: Maybe<Scalars["String"]["output"]>;
    restrictingContent?: Maybe<Content>;
    timeZone?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    userKey?: Maybe<Scalars["String"]["output"]>;
    username?: Maybe<Scalars["String"]["output"]>;
};

export type UserWithRestrictionsEdge = {
    __typename?: "UserWithRestrictionsEdge";
    cursor?: Maybe<Scalars["String"]["output"]>;
    node?: Maybe<UserWithRestrictions>;
};

export type UsersWithEffectiveRestrictions = {
    __typename?: "UsersWithEffectiveRestrictions";
    directPermissions: Array<Maybe<ContentPermissionType>>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    permissionsViaGroups: PermissionsViaGroups;
    user?: Maybe<UserWithRestrictions>;
};

export type ValidateConvertPageToLiveEditInput = {
    adf: Scalars["String"]["input"];
    contentId: Scalars["ID"]["input"];
};

export type ValidatePageCopyInput = {
    /** ID of destination space */
    destinationSpaceId: Scalars["ID"]["input"];
    /** ID of page being copied */
    pageId: Scalars["ID"]["input"];
    /** Input params for validation of copying page restrictions */
    validatePageRestrictionsCopyInput?: InputMaybe<ValidatePageRestrictionsCopyInput>;
};

export type ValidatePageCopyPayload = {
    __typename?: "ValidatePageCopyPayload";
    /**
     * Validation result for copying of page restrictions
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    validatePageRestrictionsCopyPayload?: Maybe<ValidatePageRestrictionsCopyPayload>;
};

export type ValidatePageRestrictionsCopyInput = {
    includeChildren: Scalars["Boolean"]["input"];
};

export type ValidatePageRestrictionsCopyPayload = {
    __typename?: "ValidatePageRestrictionsCopyPayload";
    isValid: Scalars["Boolean"]["output"];
    message: PageCopyRestrictionValidationStatus;
};

export type ValidateSpaceKeyResponse = {
    __typename?: "ValidateSpaceKeyResponse";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    generatedUniqueKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
};

export type ValidateTitleForCreatePayload = {
    __typename?: "ValidateTitleForCreatePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isValid: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    message?: Maybe<Scalars["String"]["output"]>;
};

export enum VendorType {
    Internal = "INTERNAL",
    ThirdParty = "THIRD_PARTY"
}

export type Version = {
    __typename?: "Version";
    by?: Maybe<Person>;
    collaborators?: Maybe<ContributorUsers>;
    confRev?: Maybe<Scalars["String"]["output"]>;
    content?: Maybe<Content>;
    contentTypeModified?: Maybe<Scalars["Boolean"]["output"]>;
    friendlyWhen?: Maybe<Scalars["String"]["output"]>;
    links?: Maybe<LinksContextSelfBase>;
    message?: Maybe<Scalars["String"]["output"]>;
    minorEdit?: Maybe<Scalars["Boolean"]["output"]>;
    ncsStepVersion?: Maybe<Scalars["String"]["output"]>;
    ncsStepVersionSource?: Maybe<Scalars["String"]["output"]>;
    number?: Maybe<Scalars["Int"]["output"]>;
    syncRev?: Maybe<Scalars["String"]["output"]>;
    syncRevSource?: Maybe<Scalars["String"]["output"]>;
    when?: Maybe<Scalars["String"]["output"]>;
};

export type ViewedComments = {
    __typename?: "ViewedComments";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    commentIds: Array<Maybe<Scalars["ID"]["output"]>>;
};

export type VirtualAgentAiAnswerStatusForChannel = {
    __typename?: "VirtualAgentAiAnswerStatusForChannel";
    /** Status of AI Answer for the channel */
    isAiResponsesChannel?: Maybe<Scalars["Boolean"]["output"]>;
    /** The ID of the slack channel */
    slackChannelId: Scalars["String"]["output"];
};

export type VirtualAgentChannelConfig = {
    __typename?: "VirtualAgentChannelConfig";
    /**
     * AI Answer status for a jira project
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated per-channel configuration of AI Answers is no longer possible, and this field now always returns null
     */
    aiAnswersProductionStatus?: Maybe<
        Array<Maybe<VirtualAgentAiAnswerStatusForChannel>>
    >;
    /**
     * An object that explains the current JSM Chat install state
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated available through JSM Chat APIs instead
     */
    jsmChatContext?: Maybe<VirtualAgentJsmChatContext>;
    /**
     * Get the virtual agent production channels
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated available through JSM Chat APIs instead
     */
    production?: Maybe<Array<Maybe<VirtualAgentSlackChannel>>>;
    /**
     * Get the virtual agent test channel
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated available through JSM Chat APIs instead
     */
    test?: Maybe<VirtualAgentSlackChannel>;
    /**
     * Get the virtual agent triage channel
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated available through JSM Chat APIs instead
     */
    triage?: Maybe<VirtualAgentSlackChannel>;
};

export type VirtualAgentConfiguration = Node & {
    __typename?: "VirtualAgentConfiguration";
    /**
     *
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgentConversation")' query directive to the 'conversations' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    conversations?: Maybe<VirtualAgentConversationsConnection>;
    /** The ID of the default request type used when the virtual agent escalates and creates a Jira Service Management request */
    defaultJiraRequestTypeId?: Maybe<Scalars["String"]["output"]>;
    /**
     * Get a FlowEditorFlow based on the flowRevisionId which is a uuid.
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'flowEditorFlow' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    flowEditorFlow?: Maybe<VirtualAgentFlowEditor>;
    /** The unique identifier (ID) of the component, will be an ARI */
    id: Scalars["ID"]["output"];
    /** This returns a particular IntentRuleProjection against a given intentId which is a Uuid. */
    intentRuleProjection?: Maybe<VirtualAgentIntentRuleProjectionResult>;
    /** These rules determine how Virtual Agent executes/infers Intents when responding to Queries */
    intentRuleProjections?: Maybe<VirtualAgentIntentRuleProjectionsConnection>;
    /** Whether AI answers is enabled */
    isAiResponsesEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The total number of live intents for a given virtual agent */
    liveIntentsCount?: Maybe<Scalars["Int"]["output"]>;
    /** Virtual Agent uses this flag to determine if it will respond to Help Seeker queries */
    respondToQueries: Scalars["Boolean"]["output"];
    /**
     * StandardFlowEditors are the standard flows available for a virtual agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgentFlow")' query directive to the 'standardFlowEditors' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    standardFlowEditors?: Maybe<VirtualAgentFlowEditorsConnection>;
    /**
     * This returns the virtual agent slack channels
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     *
     * @deprecated replaced by JSM Chat APIs available on the VA's container
     */
    virtualAgentChannelConfig?: Maybe<VirtualAgentChannelConfig>;
    /**
     * This returns the global statistics for the virtual agent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'virtualAgentStatisticsProjection' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    virtualAgentStatisticsProjection?: Maybe<VirtualAgentStatisticsProjection>;
};

export type VirtualAgentConfigurationConversationsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    filter: VirtualAgentConversationsFilter;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type VirtualAgentConfigurationFlowEditorFlowArgs = {
    flowRevisionId: Scalars["String"]["input"];
};

export type VirtualAgentConfigurationIntentRuleProjectionArgs = {
    intentId: Scalars["String"]["input"];
};

export type VirtualAgentConfigurationIntentRuleProjectionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type VirtualAgentConfigurationStandardFlowEditorsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type VirtualAgentConfigurationVirtualAgentStatisticsProjectionArgs = {
    endDate?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type VirtualAgentConfigurationResult =
    | VirtualAgentConfiguration
    | VirtualAgentQueryError;

export type VirtualAgentConversation = Node & {
    __typename?: "VirtualAgentConversation";
    /** How a conversation was actioned */
    action?: Maybe<VirtualAgentConversationActionType>;
    /** Conversation channel */
    channel?: Maybe<VirtualAgentConversationChannel>;
    /** The CSAT score, if any, provided by the user at the end of a conversation */
    csat?: Maybe<Scalars["Int"]["output"]>;
    /** The first message content of the conversation */
    firstMessageContent?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier (ID) of a conversation, will be an ARI */
    id: Scalars["ID"]["output"];
    /**
     * The intent projection of the intent of the conversation, if matched
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgentIntentProjection")' query directive to the 'intentProjectionTmp' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     * @deprecated VirtualAgentIntentProjection will be migrated properly and replace this soon
     */
    intentProjectionTmp?: Maybe<VirtualAgentIntentProjectionTmp>;
    /** Deep link to the external source of this conversation, if applicable */
    linkToSource?: Maybe<Scalars["String"]["output"]>;
    /** When the conversation started */
    startedAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** The state of a conversation */
    state?: Maybe<VirtualAgentConversationState>;
};

export enum VirtualAgentConversationActionType {
    AiAnswered = "AI_ANSWERED",
    Matched = "MATCHED",
    Unhandled = "UNHANDLED"
}

export enum VirtualAgentConversationChannel {
    HelpCenter = "HELP_CENTER",
    JsmPortal = "JSM_PORTAL",
    JsmWidget = "JSM_WIDGET",
    MsTeams = "MS_TEAMS",
    Slack = "SLACK"
}

export enum VirtualAgentConversationCsatOptionType {
    CsatOption_1 = "CSAT_OPTION_1",
    CsatOption_2 = "CSAT_OPTION_2",
    CsatOption_3 = "CSAT_OPTION_3",
    CsatOption_4 = "CSAT_OPTION_4",
    CsatOption_5 = "CSAT_OPTION_5"
}

export type VirtualAgentConversationEdge = {
    __typename?: "VirtualAgentConversationEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<VirtualAgentConversation>;
};

export enum VirtualAgentConversationState {
    Closed = "CLOSED",
    Escalated = "ESCALATED",
    Open = "OPEN",
    Resolved = "RESOLVED"
}

export type VirtualAgentConversationsConnection = {
    __typename?: "VirtualAgentConversationsConnection";
    edges?: Maybe<Array<Maybe<VirtualAgentConversationEdge>>>;
    nodes?: Maybe<Array<Maybe<VirtualAgentConversation>>>;
    pageInfo: PageInfo;
};

export type VirtualAgentConversationsFilter = {
    /** Filter by action type(s) */
    actions?: InputMaybe<Array<VirtualAgentConversationActionType>>;
    /** Filter by channel */
    channels?: InputMaybe<Array<VirtualAgentConversationChannel>>;
    /** Filter by csat score(s) */
    csatOptions?: InputMaybe<Array<VirtualAgentConversationCsatOptionType>>;
    /** The end date of a period to filter conversations */
    endDate: Scalars["DateTime"]["input"];
    /** The start date of a period to filter conversations */
    startDate: Scalars["DateTime"]["input"];
    /** Filter by state(s) */
    states?: InputMaybe<Array<VirtualAgentConversationState>>;
};

export type VirtualAgentCreateChatChannelInput = {
    /** Specify whether the channel is triage channel or not */
    isTriageChannel: Scalars["Boolean"]["input"];
    /** Specify whether the channel is virtual agent test channel or not */
    isVirtualAgentTestChannel: Scalars["Boolean"]["input"];
};

export type VirtualAgentCreateChatChannelPayload = Payload & {
    __typename?: "VirtualAgentCreateChatChannelPayload";
    /** The newly created virtual agent chat channel */
    channel?: Maybe<VirtualAgentSlackChannel>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for creating a VirtualAgent Configuration. */
export type VirtualAgentCreateConfigurationInput = {
    /** Get the Virtual Agent's default request type id. */
    defaultJiraRequestTypeId?: InputMaybe<Scalars["String"]["input"]>;
    /** Whether AI answers is enabled */
    isAiResponsesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** A configuration on the Virtual Agent which indicates if the Bot will reply to help seeker messages or not. */
    respondToQueries?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VirtualAgentCreateConfigurationPayload = Payload & {
    __typename?: "VirtualAgentCreateConfigurationPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The newly created virtual agent configuration */
    virtualAgentConfiguration?: Maybe<VirtualAgentConfiguration>;
};

export type VirtualAgentCreateIntentRuleProjectionInput = {
    /** Message that helpseekers use to confirm that this intent rule should be executed */
    confirmationMessage?: InputMaybe<Scalars["String"]["input"]>;
    /** The description of the intent */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the intent */
    name: Scalars["String"]["input"];
    /** A list of question text to be created along with the intent */
    questions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Short message used by helpseekers to select this intent rule from a list of other intent rules */
    suggestionButtonText?: InputMaybe<Scalars["String"]["input"]>;
    /** Intent template id from which this intent is based on */
    templateId?: InputMaybe<Scalars["String"]["input"]>;
    /** The type of intent template from which this intent is based on */
    templateType?: InputMaybe<VirtualAgentIntentTemplateType>;
};

export type VirtualAgentCreateIntentRuleProjectionPayload = Payload & {
    __typename?: "VirtualAgentCreateIntentRuleProjectionPayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** The newly created intent rule */
    intentRuleProjection?: Maybe<VirtualAgentIntentRuleProjection>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type VirtualAgentDeleteIntentRuleProjectionPayload = Payload & {
    __typename?: "VirtualAgentDeleteIntentRuleProjectionPayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** ID of the deleted intent rule projection */
    id: Scalars["ID"]["output"];
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type VirtualAgentFeatures = {
    __typename?: "VirtualAgentFeatures";
    /** If Ai features were enabled for JSM by admins in Atlassian Administration */
    isAiEnabledInAdminHub?: Maybe<Scalars["Boolean"]["output"]>;
    /** If the JSM subscription plan allows using the virtual agent */
    isVirtualAgentAvailable?: Maybe<Scalars["Boolean"]["output"]>;
};

export type VirtualAgentFlowEditor = Node & {
    __typename?: "VirtualAgentFlowEditor";
    /** The group that the flow belongs to */
    group?: Maybe<Scalars["String"]["output"]>;
    /** The ARI for the flow editor */
    id: Scalars["ID"]["output"];
    /** Json representation of the flow editor */
    jsonRepresentation?: Maybe<Scalars["String"]["output"]>;
    /** Display name of the flow editor */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAgentFlowEditorAction = {
    /** type of the action */
    actionType: Scalars["String"]["input"];
    /** payload of the action */
    payload: Scalars["JSON"]["input"];
};

export type VirtualAgentFlowEditorActionInput = {
    /** stream of actions that need to performed on the flow editor */
    actions: Array<VirtualAgentFlowEditorAction>;
    /** Json representation of the flow editor */
    jsonRepresentation: Scalars["String"]["input"];
};

export type VirtualAgentFlowEditorActionPayload = Payload & {
    __typename?: "VirtualAgentFlowEditorActionPayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** Json representation of the flow editor after applying all the input actions */
    jsonRepresentation?: Maybe<Scalars["String"]["output"]>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type VirtualAgentFlowEditorEdge = {
    __typename?: "VirtualAgentFlowEditorEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<VirtualAgentFlowEditor>;
};

export type VirtualAgentFlowEditorInput = {
    /** The group that the flow belongs to */
    group?: InputMaybe<Scalars["String"]["input"]>;
    /** Json representation of the flow editor */
    jsonRepresentation: Scalars["String"]["input"];
    /** Display name of the flow editor */
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type VirtualAgentFlowEditorPayload = Payload & {
    __typename?: "VirtualAgentFlowEditorPayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
    /** The newly updated flow editor */
    virtualAgentFlowEditor?: Maybe<VirtualAgentFlowEditor>;
};

export type VirtualAgentFlowEditorResult =
    | VirtualAgentFlowEditor
    | VirtualAgentQueryError;

export type VirtualAgentFlowEditorsConnection = {
    __typename?: "VirtualAgentFlowEditorsConnection";
    edges?: Maybe<Array<VirtualAgentFlowEditorEdge>>;
    nodes?: Maybe<Array<Maybe<VirtualAgentFlowEditor>>>;
    pageInfo?: Maybe<PageInfo>;
};

export type VirtualAgentGlobalStatisticsProjection = {
    __typename?: "VirtualAgentGlobalStatisticsProjection";
    assistanceRate?: Maybe<Scalars["Float"]["output"]>;
    averageCsat?: Maybe<Scalars["Float"]["output"]>;
    resolutionRate?: Maybe<Scalars["Float"]["output"]>;
    totalAiResolved?: Maybe<Scalars["Float"]["output"]>;
    totalMatched?: Maybe<Scalars["Float"]["output"]>;
    totalTraffic?: Maybe<Scalars["Int"]["output"]>;
};

/** A class of questions asked by help-seekers, that can be associated with a flow of actions to execute */
export type VirtualAgentIntent = Node & {
    __typename?: "VirtualAgentIntent";
    /** Message that help-seekers use to confirm that this intent should be executed */
    confirmationMessage?: Maybe<Scalars["String"]["output"]>;
    /** Description of the intent */
    description?: Maybe<Scalars["String"]["output"]>;
    /** ARI of this intent */
    id: Scalars["ID"]["output"];
    /** Name/title of the Intent */
    name: Scalars["String"]["output"];
    /** Configured status of this intent */
    status: VirtualAgentIntentStatus;
    /** Short message used by help-seekers to select this intent from a list of other intents */
    suggestionButtonText?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAgentIntentProjection = Node & {
    __typename?: "VirtualAgentIntentProjection";
    /** The description of the intent */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ARI for Intent Projection */
    id: Scalars["ID"]["output"];
    /** Name/title of the Intent */
    name: Scalars["String"]["output"];
    /** Represents training/sample Questions defined on an Intent */
    questionProjections?: Maybe<VirtualAgentIntentQuestionProjectionsConnection>;
    /** The type of intent template that this intent is based on */
    templateType?: Maybe<VirtualAgentIntentTemplateType>;
};

export type VirtualAgentIntentProjectionQuestionProjectionsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type VirtualAgentIntentProjectionResult =
    | VirtualAgentIntentProjection
    | VirtualAgentQueryError;

/**
 * A temporary type for VirtualAgentIntentProjection until it's properly migrated over to Verbena
 * Do not diverge it from the original
 */
export type VirtualAgentIntentProjectionTmp = Node & {
    __typename?: "VirtualAgentIntentProjectionTmp";
    /** The description of the intent */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The ARI for Intent Projection */
    id: Scalars["ID"]["output"];
    /** Name/title of the Intent */
    name: Scalars["String"]["output"];
};

/** A training phrase / sample question associated with an intent to allow training the virtual agent to recognise that intent */
export type VirtualAgentIntentQuestion = Node & {
    __typename?: "VirtualAgentIntentQuestion";
    /** ARI of this intent question */
    id: Scalars["ID"]["output"];
    /** Text of this intent question */
    text: Scalars["String"]["output"];
};

export type VirtualAgentIntentQuestionProjection = Node & {
    __typename?: "VirtualAgentIntentQuestionProjection";
    /** The ARI for IntentQuestion Projection */
    id: Scalars["ID"]["output"];
    text: Scalars["String"]["output"];
};

export type VirtualAgentIntentQuestionProjectionEdge = {
    __typename?: "VirtualAgentIntentQuestionProjectionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<VirtualAgentIntentQuestionProjection>;
};

export type VirtualAgentIntentQuestionProjectionsConnection = {
    __typename?: "VirtualAgentIntentQuestionProjectionsConnection";
    edges?: Maybe<Array<VirtualAgentIntentQuestionProjectionEdge>>;
    nodes?: Maybe<Array<Maybe<VirtualAgentIntentQuestionProjection>>>;
    pageInfo: PageInfo;
};

export type VirtualAgentIntentRuleProjection = Node & {
    __typename?: "VirtualAgentIntentRuleProjection";
    /** Message that helpseekers use to confirm that this intent rule should be executed */
    confirmationMessage?: Maybe<Scalars["String"]["output"]>;
    /** the flow editor flow associated to the intent */
    flowEditor?: Maybe<VirtualAgentFlowEditorResult>;
    /** The ARI for IntentRule Projection */
    id: Scalars["ID"]["output"];
    intentProjection?: Maybe<VirtualAgentIntentProjectionResult>;
    /**
     * Statistics for an intent
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'intentStatisticsProjection' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    intentStatisticsProjection?: Maybe<VirtualAgentIntentStatisticsProjection>;
    /** A boolean flag which defines if an underlying Intent is enabled for this VirtualAgent or not */
    isEnabled: Scalars["Boolean"]["output"];
    /** Short message used to represent this intent rule to helpseekers among a list of other intent rules */
    suggestionButtonText?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAgentIntentRuleProjectionIntentStatisticsProjectionArgs = {
    endDate?: InputMaybe<Scalars["String"]["input"]>;
    startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type VirtualAgentIntentRuleProjectionEdge = {
    __typename?: "VirtualAgentIntentRuleProjectionEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<VirtualAgentIntentRuleProjection>;
};

export type VirtualAgentIntentRuleProjectionResult =
    | VirtualAgentIntentRuleProjection
    | VirtualAgentQueryError;

export type VirtualAgentIntentRuleProjectionsConnection = {
    __typename?: "VirtualAgentIntentRuleProjectionsConnection";
    edges?: Maybe<Array<VirtualAgentIntentRuleProjectionEdge>>;
    nodes?: Maybe<Array<Maybe<VirtualAgentIntentRuleProjection>>>;
    pageInfo: PageInfo;
};

/** Accepts input query to fetch Intent Rules */
export type VirtualAgentIntentRuleProjectionsFilter = {
    /** The Virtual Agent Configuration that should be used to filter Intent Rules */
    virtualAgentConfigurationId: Scalars["ID"]["input"];
};

export type VirtualAgentIntentStatisticsProjection = {
    __typename?: "VirtualAgentIntentStatisticsProjection";
    averageCsat?: Maybe<Scalars["Float"]["output"]>;
    resolutionRate?: Maybe<Scalars["Float"]["output"]>;
    totalTraffic?: Maybe<Scalars["Int"]["output"]>;
    trafficPercentageOfAllAssisted?: Maybe<Scalars["Float"]["output"]>;
};

/** Statuses that an intent can be configured to have, affecting where it is surfaced to help-seekers */
export enum VirtualAgentIntentStatus {
    /** Surfaced to help-seekers in conversation channels, as well as visible to virtual agent admins in test mode */
    Live = "LIVE",
    /** Not visible to help-seekers, but visible to virtual agent admins using test mode */
    TestOnly = "TEST_ONLY"
}

export type VirtualAgentIntentTemplate = Node & {
    __typename?: "VirtualAgentIntentTemplate";
    /** The description of the intent */
    description?: Maybe<Scalars["String"]["output"]>;
    /** The unique identifier (ID) of the component, will be an ARI */
    id: Scalars["ID"]["output"];
    /** Name/title of the Intent */
    name: Scalars["String"]["output"];
    /** The number of questions in the intent */
    noOfQuestions?: Maybe<Scalars["Int"]["output"]>;
    /** Represents training/sample Questions defined on an Intent */
    questions?: Maybe<Array<Scalars["String"]["output"]>>;
    type: VirtualAgentIntentTemplateType;
};

export type VirtualAgentIntentTemplateEdge = {
    __typename?: "VirtualAgentIntentTemplateEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<VirtualAgentIntentTemplate>;
};

export enum VirtualAgentIntentTemplateType {
    Discovered = "DISCOVERED",
    Shared = "SHARED",
    Standard = "STANDARD"
}

export type VirtualAgentIntentTemplatesConnection = {
    __typename?: "VirtualAgentIntentTemplatesConnection";
    edges?: Maybe<Array<VirtualAgentIntentTemplateEdge>>;
    /** A boolean indicating if discovered templates have been generated */
    hasDiscoveredTemplates?: Maybe<Scalars["Boolean"]["output"]>;
    /** The timestamp of when discovered templates were created */
    lastDiscoveredTemplatesGenerationTime?: Maybe<
        Scalars["DateTime"]["output"]
    >;
    nodes?: Maybe<Array<VirtualAgentIntentTemplate>>;
    pageInfo: PageInfo;
};

export type VirtualAgentJsmChatContext = {
    __typename?: "VirtualAgentJSMChatContext";
    /** This returns the install state of a chat application. Right now it's one of CONNECT | LOGIN | READY | ERROR */
    connectivityState: Scalars["String"]["output"];
    /** The more specific error message explaining what's wrong. Only present when connectivityState is ERROR */
    errorMessage?: Maybe<Scalars["String"]["output"]>;
    /** The link to install the Assist slack app. Only present when connectivityState is CONNECT or LOGIN */
    slackSetupLink?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAgentLiveIntentCountResponse = {
    __typename?: "VirtualAgentLiveIntentCountResponse";
    /** The ID of the container */
    containerId: Scalars["ID"]["output"];
    /** The count of live intents */
    liveIntentsCount: Scalars["Int"]["output"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApi = {
    __typename?: "VirtualAgentMutationApi";
    /**
     * Create JSM Chat channels for virtual agent
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated use JSM Chat APIs instead
     */
    createChatChannel?: Maybe<VirtualAgentCreateChatChannelPayload>;
    /**
     * Create an Intent for a Virtual Agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createIntentRuleProjection?: Maybe<VirtualAgentCreateIntentRuleProjectionPayload>;
    /**
     * Creates a single Virtual Agent against a given project.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    createVirtualAgentConfiguration?: Maybe<VirtualAgentCreateConfigurationPayload>;
    /**
     * Delete the intent rule for a Virtual Agent
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    deleteIntentRuleProjection?: Maybe<VirtualAgentDeleteIntentRuleProjectionPayload>;
    /**
     * Handle the actions user selected on the current flow editor
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'handleFlowEditorActions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    handleFlowEditorActions?: Maybe<VirtualAgentFlowEditorActionPayload>;
    /**
     * Update JSM Chat (VA) channel
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated per-channel configuration of AI Answers is no longer possible
     */
    updateAiAnswerForSlackChannel?: Maybe<VirtualAgentUpdateAiAnswerForSlackChannelPayload>;
    /**
     * Update JSM Chat (VA) channel
     *
     *
     * This field is **deprecated** and will be removed in the future
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     * @deprecated use JSM Chat APIs instead
     */
    updateChatChannel?: Maybe<VirtualAgentUpdateChatChannelPayload>;
    /**
     * Update flow editor given flow editor id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'updateFlowEditorFlow' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    updateFlowEditorFlow?: Maybe<VirtualAgentFlowEditorPayload>;
    /**
     * Update the intent rule for a Virtual Agent. This updates the configuration around the intent, excluding the questions.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateIntentRuleProjection?: Maybe<VirtualAgentUpdateIntentRuleProjectionPayload>;
    /**
     * Update the questions for an intent rule for a Virtual Agent.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateIntentRuleProjectionQuestions?: Maybe<VirtualAgentUpdateIntentRuleProjectionQuestionsPayload>;
    /**
     * Updates an existing Virtual Agent Configuration.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    updateVirtualAgentConfiguration?: Maybe<VirtualAgentUpdateConfigurationPayload>;
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiCreateChatChannelArgs = {
    input: VirtualAgentCreateChatChannelInput;
    virtualAgentConfigurationId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiCreateIntentRuleProjectionArgs = {
    input: VirtualAgentCreateIntentRuleProjectionInput;
    virtualAgentConfigurationId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiCreateVirtualAgentConfigurationArgs = {
    input?: InputMaybe<VirtualAgentCreateConfigurationInput>;
    jiraProjectId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiDeleteIntentRuleProjectionArgs = {
    virtualAgentIntentRuleProjectionId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiHandleFlowEditorActionsArgs = {
    input: VirtualAgentFlowEditorActionInput;
    virtualAgentFlowEditorId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiUpdateAiAnswerForSlackChannelArgs = {
    input: VirtualAgentUpdateAiAnswerForSlackChannelInput;
    virtualAgentConfigurationId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiUpdateChatChannelArgs = {
    input: VirtualAgentUpdateChatChannelInput;
    virtualAgentConfigurationId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiUpdateFlowEditorFlowArgs = {
    input: VirtualAgentFlowEditorInput;
    virtualAgentFlowEditorId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiUpdateIntentRuleProjectionArgs = {
    input: VirtualAgentUpdateIntentRuleProjectionInput;
    virtualAgentIntentRuleProjectionId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiUpdateIntentRuleProjectionQuestionsArgs = {
    input: VirtualAgentUpdateIntentRuleProjectionQuestionsInput;
    virtualAgentIntentRuleProjectionId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Mutation API. */
export type VirtualAgentMutationApiUpdateVirtualAgentConfigurationArgs = {
    input: VirtualAgentUpdateConfigurationInput;
    virtualAgentConfigurationId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApi = {
    __typename?: "VirtualAgentQueryApi";
    /**
     * Can toggle on Virtual Agent on Help Center
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    availableToHelpCenter?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Retrieve conversations in bulk by ID. The returned list is 1:1 with the input, with non-existent entities or invalid IDs having null values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    conversationsByIds?: Maybe<Array<Maybe<VirtualAgentConversation>>>;
    /**
     * Retrieve intent questions in bulk by ID. The returned list is 1:1 with the input, with non-existent entities or invalid IDs having null values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    intentQuestionsByIds?: Maybe<Array<Maybe<VirtualAgentIntentQuestion>>>;
    /**
     * Retrieve intent templates in bulk by ID. The returned list is 1:1 with the input, with non-existent entities or invalid IDs having null values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    intentTemplatesByIds?: Maybe<Array<Maybe<VirtualAgentIntentTemplate>>>;
    /**
     * Retrieve intents in bulk by ID. The returned list is 1:1 with the input, with non-existent entities or invalid IDs having null values.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    intentsByIds?: Maybe<Array<Maybe<VirtualAgentIntent>>>;
    /**
     * Validate if it's allowed to use the selected request type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    validateRequestType?: Maybe<VirtualAgentRequestTypeConnectionStatus>;
    /**
     * Validate whether VA is available to help seeker
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    virtualAgentAvailability?: Maybe<Scalars["Boolean"]["output"]>;
    /**
     * Virtual agent-related entitlements for a given cloud ID
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "VirtualAgent")' query directive to the 'virtualAgentEntitlements' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    virtualAgentEntitlements?: Maybe<VirtualAgentFeatures>;
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiAvailableToHelpCenterArgs = {
    helpCenterId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiConversationsByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiIntentQuestionsByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiIntentTemplatesByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiIntentsByIdsArgs = {
    ids: Array<Scalars["ID"]["input"]>;
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiValidateRequestTypeArgs = {
    jiraProjectId: Scalars["ID"]["input"];
    requestTypeId: Scalars["String"]["input"];
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiVirtualAgentAvailabilityArgs = {
    containerId: Scalars["ID"]["input"];
};

/** The top level wrapper for the Virtual Agent Query API. */
export type VirtualAgentQueryApiVirtualAgentEntitlementsArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type VirtualAgentQueryError = {
    __typename?: "VirtualAgentQueryError";
    /** Use this to put extra data on the error if required */
    extensions?: Maybe<Array<QueryErrorExtension>>;
    /** The ARI of the object that would have otherwise been returned if not for the query error */
    id: Scalars["ID"]["output"];
    /** The ARI of the object that would have otherwise been returned if not for the query error */
    identifier?: Maybe<Scalars["ID"]["output"]>;
    /** A message describing the error */
    message?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAgentRequestTypeConnectionStatus = {
    __typename?: "VirtualAgentRequestTypeConnectionStatus";
    /** Status of request type connection */
    connectionStatus?: Maybe<Scalars["String"]["output"]>;
    /** Indicate if there are required fields of the request type */
    hasRequiredFields?: Maybe<Scalars["Boolean"]["output"]>;
    /** Indicate if there are unsupported fields of the request type */
    hasUnsupportedFields?: Maybe<Scalars["Boolean"]["output"]>;
    /** True, if the Request Type is not part of any Request Groups */
    isHiddenRequestType?: Maybe<Scalars["Boolean"]["output"]>;
};

export type VirtualAgentSlackChannel = {
    __typename?: "VirtualAgentSlackChannel";
    channelLink?: Maybe<Scalars["String"]["output"]>;
    channelName?: Maybe<Scalars["String"]["output"]>;
    /** Halp Id of the channel document */
    id?: Maybe<Scalars["String"]["output"]>;
    /** Whether smart answer is enabled on the channel */
    isAiResponsesChannel?: Maybe<Scalars["Boolean"]["output"]>;
    /** Whether virtual agent is enabled on the channel */
    isVirtualAgentChannel?: Maybe<Scalars["Boolean"]["output"]>;
    /** If the channel is a test channel */
    isVirtualAgentTestChannel?: Maybe<Scalars["Boolean"]["output"]>;
    /** Slack Id of the channel given by Slack */
    slackChannelId?: Maybe<Scalars["String"]["output"]>;
};

export type VirtualAgentStatisticsPercentageChangeProjection = {
    __typename?: "VirtualAgentStatisticsPercentageChangeProjection";
    aiResolution?: Maybe<Scalars["Float"]["output"]>;
    assistance?: Maybe<Scalars["Float"]["output"]>;
    csat?: Maybe<Scalars["Float"]["output"]>;
    match?: Maybe<Scalars["Float"]["output"]>;
    resolution?: Maybe<Scalars["Float"]["output"]>;
    traffic?: Maybe<Scalars["Float"]["output"]>;
};

export type VirtualAgentStatisticsProjection = {
    __typename?: "VirtualAgentStatisticsProjection";
    globalStatistics?: Maybe<VirtualAgentGlobalStatisticsProjection>;
    statisticsPercentageChange?: Maybe<VirtualAgentStatisticsPercentageChangeProjection>;
};

export type VirtualAgentUpdateAiAnswerForSlackChannelInput = {
    /** Specify whether ai answers is enabled on the channel */
    isAiResponsesChannel: Scalars["Boolean"]["input"];
    /** Halp Id of the channel document */
    slackChannelId: Scalars["String"]["input"];
};

export type VirtualAgentUpdateAiAnswerForSlackChannelPayload = Payload & {
    __typename?: "VirtualAgentUpdateAiAnswerForSlackChannelPayload";
    /** The updated chat channel */
    channel?: Maybe<VirtualAgentAiAnswerStatusForChannel>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

export type VirtualAgentUpdateChatChannelInput = {
    /** Halp Id of the channel document */
    halpChannelId: Scalars["String"]["input"];
    /** Specify whether smart answer is enabled on the channel */
    isAiResponsesChannel?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Specify whether the channel is connected to virtual agent or not */
    isVirtualAgentChannel: Scalars["Boolean"]["input"];
};

export type VirtualAgentUpdateChatChannelPayload = Payload & {
    __typename?: "VirtualAgentUpdateChatChannelPayload";
    /** The updated chat channel */
    channel?: Maybe<VirtualAgentSlackChannel>;
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
};

/** Accepts input for updating an existing VirtualAgent Configuration. */
export type VirtualAgentUpdateConfigurationInput = {
    /** The ID of the default request type used when the virtual agent escalates and creates a Jira Service Management request */
    defaultJiraRequestTypeId?: InputMaybe<Scalars["String"]["input"]>;
    /** Whether AI answers is enabled */
    isAiResponsesEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The configuration which determines if Virtual Agent will respond to Help Seeker queries. */
    respondToQueries?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type VirtualAgentUpdateConfigurationPayload = Payload & {
    __typename?: "VirtualAgentUpdateConfigurationPayload";
    /** A list of errors that occurred during the mutation. */
    errors?: Maybe<Array<MutationError>>;
    /** Whether the mutation was successful or not. */
    success: Scalars["Boolean"]["output"];
    /** The details of the component that was mutated. */
    virtualAgentConfiguration?: Maybe<VirtualAgentConfiguration>;
};

export type VirtualAgentUpdateIntentRuleProjectionInput = {
    /** Message that helpseekers use to confirm that this intent rule should be executed */
    confirmationMessage?: InputMaybe<Scalars["String"]["input"]>;
    /** A new description for the intent */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** A boolean flag which defines if an underlying Intent is enabled for this VirtualAgent or not */
    isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The name of the intent */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Short message used to represent this intent rule to helpseekers among a list of other intent rules */
    suggestionButtonText?: InputMaybe<Scalars["String"]["input"]>;
};

export type VirtualAgentUpdateIntentRuleProjectionPayload = Payload & {
    __typename?: "VirtualAgentUpdateIntentRuleProjectionPayload";
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated intent rule */
    intentRuleProjection?: Maybe<VirtualAgentIntentRuleProjection>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type VirtualAgentUpdateIntentRuleProjectionQuestionsInput = {
    /** Questions to be added to the intent rule */
    addedQuestions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Message that helpseekers use to confirm that this intent rule should be executed */
    confirmationMessage?: InputMaybe<Scalars["String"]["input"]>;
    /** Questions to be deleted */
    deletedQuestions?: InputMaybe<Array<Scalars["ID"]["input"]>>;
    /** The description for an intent */
    description?: InputMaybe<Scalars["String"]["input"]>;
    /** The name of the intent */
    name?: InputMaybe<Scalars["String"]["input"]>;
    /** Short message used by helpseekers to select this intent rule from a list of other intent rules */
    suggestionButtonText?: InputMaybe<Scalars["String"]["input"]>;
    /** Questions to be updated */
    updatedQuestions?: InputMaybe<Array<VirtualAgentUpdatedQuestionInput>>;
};

export type VirtualAgentUpdateIntentRuleProjectionQuestionsPayload = Payload & {
    __typename?: "VirtualAgentUpdateIntentRuleProjectionQuestionsPayload";
    /** A list of questions that were successfully created or updated */
    createdAndUpdatedQuestions?: Maybe<
        Array<VirtualAgentIntentQuestionProjection>
    >;
    /** A list of IDs of questions that were successfully deleted */
    deletedQuestions?: Maybe<Array<Scalars["ID"]["output"]>>;
    /** A list of errors if the mutation is not successful. */
    errors?: Maybe<Array<MutationError>>;
    /** The updated intent rule projection */
    intentRuleProjection?: Maybe<VirtualAgentIntentRuleProjection>;
    /** Whether the mutation is successful. */
    success: Scalars["Boolean"]["output"];
};

export type VirtualAgentUpdatedQuestionInput = {
    /** Id of the question to be updated */
    id: Scalars["ID"]["input"];
    /** Text of the question to be updated */
    question: Scalars["String"]["input"];
};

/** User facing validation error. On the FE this mutation error will not go to Sentry */
export type VirtualAgentValidationMutationErrorExtension =
    MutationErrorExtension & {
        __typename?: "VirtualAgentValidationMutationErrorExtension";
        /**
         * A code representing the type of error
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        errorType?: Maybe<Scalars["String"]["output"]>;
        /**
         *
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        statusCode?: Maybe<Scalars["Int"]["output"]>;
    };

export type WatchContentInput = {
    accountId?: InputMaybe<Scalars["String"]["input"]>;
    contentId: Scalars["ID"]["input"];
    currentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
    includeChildren?: InputMaybe<Scalars["Boolean"]["input"]>;
    shouldUnwatchAncestorWatchingChildren?: InputMaybe<
        Scalars["Boolean"]["input"]
    >;
};

export type WatchContentPayload = {
    __typename?: "WatchContentPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    content: Content;
};

export type WatchMarketplaceAppPayload = Payload & {
    __typename?: "WatchMarketplaceAppPayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    errors?: Maybe<Array<MutationError>>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    success: Scalars["Boolean"]["output"];
};

export type WatchSpaceInput = {
    accountId?: InputMaybe<Scalars["String"]["input"]>;
    currentUser?: InputMaybe<Scalars["Boolean"]["input"]>;
    spaceId?: InputMaybe<Scalars["ID"]["input"]>;
    spaceKey?: InputMaybe<Scalars["String"]["input"]>;
};

export type WatchSpacePayload = {
    __typename?: "WatchSpacePayload";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    space: Space;
};

export type WebItem = {
    __typename?: "WebItem";
    accessKey?: Maybe<Scalars["String"]["output"]>;
    completeKey?: Maybe<Scalars["String"]["output"]>;
    hasCondition?: Maybe<Scalars["Boolean"]["output"]>;
    icon?: Maybe<Icon>;
    id?: Maybe<Scalars["String"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    params?: Maybe<Array<Maybe<MapOfStringToString>>>;
    section?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
    tooltip?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    urlWithoutContextPath?: Maybe<Scalars["String"]["output"]>;
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type WebPanel = {
    __typename?: "WebPanel";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    completeKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    html?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    label?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    location?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    moduleKey?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    weight?: Maybe<Scalars["Int"]["output"]>;
};

export type WebResourceDependencies = {
    __typename?: "WebResourceDependencies";
    contexts: Array<Maybe<Scalars["String"]["output"]>>;
    keys: Array<Maybe<Scalars["String"]["output"]>>;
    links?: Maybe<LinksContextBase>;
    superbatch?: Maybe<SuperBatchWebResources>;
    tags?: Maybe<WebResourceTags>;
    uris?: Maybe<WebResourceUris>;
};

export type WebResourceTags = {
    __typename?: "WebResourceTags";
    css?: Maybe<Scalars["String"]["output"]>;
    data?: Maybe<Scalars["String"]["output"]>;
    js?: Maybe<Scalars["String"]["output"]>;
};

export type WebResourceUris = {
    __typename?: "WebResourceUris";
    css?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    data?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    js?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type WebSection = {
    __typename?: "WebSection";
    cacheKey?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["ID"]["output"]>;
    items: Array<Maybe<WebItem>>;
    label?: Maybe<Scalars["String"]["output"]>;
    styleClass?: Maybe<Scalars["String"]["output"]>;
};

export type WebTriggerUrl = Node & {
    __typename?: "WebTriggerUrl";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    appId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    contextId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    envId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    extensionId: Scalars["ID"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * Product extracted from the context id (e.g. jira, confulence). Only populated if context id is a valid cloud context.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    product?: Maybe<Scalars["String"]["output"]>;
    /**
     * The tenant context for the cloud id. Only populated if context id is a valid cloud context.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    tenantContext?: Maybe<TenantContext>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    triggerKey: Scalars["String"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ❌ No |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ✅ Yes |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["URL"]["output"];
};

export type WebTriggerUrlInput = {
    /** Id of the application */
    appId: Scalars["ID"]["input"];
    /**
     * context in which function should run, usually a site context.
     * E.g.: ari:cloud:jira::site/{siteId}
     */
    contextId: Scalars["ID"]["input"];
    /** Environment id of the application */
    envId: Scalars["ID"]["input"];
    /** Web trigger module key */
    triggerKey: Scalars["String"]["input"];
};

export type WhiteboardFeatures = {
    __typename?: "WhiteboardFeatures";
    smartConnectors?: Maybe<SmartConnectorsFeature>;
    smartSections?: Maybe<SmartSectionsFeature>;
};

export type WorkSuggestions = {
    __typename?: "WorkSuggestions";
    /**
     * GET the work suggestions for given cloud id and issue ids
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsByIssues")' query directive to the 'suggestionsByIssues' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    suggestionsByIssues?: Maybe<WorkSuggestionsByIssuesResponse>;
    /**
     * Get the work suggestions for the current user with the given cloud id and a list of project ARIs
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsByProjects")' query directive to the 'suggestionsByProjects' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    suggestionsByProjects?: Maybe<WorkSuggestionsByProjectsResponse>;
    /**
     * Get the user profile for the current user with the given cloud id
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsUserProfile")' query directive to the 'userProfileByCloudId' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    userProfileByCloudId?: Maybe<WorkSuggestionsUserProfile>;
    /**
     * Get work suggestions based on contextAri, it is the subject of a relation. The response is paginated.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    workSuggestionsByContextAri: WorkSuggestionsConnection;
};

export type WorkSuggestionsSuggestionsByIssuesArgs = {
    cloudId: Scalars["ID"]["input"];
    issueIds: Array<Scalars["ID"]["input"]>;
};

export type WorkSuggestionsSuggestionsByProjectsArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    cloudId: Scalars["ID"]["input"];
    first?: InputMaybe<Scalars["Int"]["input"]>;
    projectAris: Array<Scalars["ID"]["input"]>;
    sprintAutoDiscoveryLimit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkSuggestionsUserProfileByCloudIdArgs = {
    cloudId: Scalars["ID"]["input"];
};

export type WorkSuggestionsWorkSuggestionsByContextAriArgs = {
    after?: InputMaybe<Scalars["String"]["input"]>;
    contextAri: WorkSuggestionsContextAri;
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum WorkSuggestionsAction {
    Remove = "REMOVE",
    Snooze = "SNOOZE"
}

/** Input for the mutation operations (snooze and remove). */
export type WorkSuggestionsActionInput = {
    /** Cloud id */
    cloudId: Scalars["ID"]["input"];
    /** Work Suggestion id */
    taskId: Scalars["String"]["input"];
};

export type WorkSuggestionsActionPayload = Payload & {
    __typename?: "WorkSuggestionsActionPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** Action object stored in the database */
    userActionState?: Maybe<WorkSuggestionsUserActionState>;
};

export enum WorkSuggestionsApprovalStatus {
    Approved = "APPROVED",
    Needswork = "NEEDSWORK",
    Unapproved = "UNAPPROVED",
    Unknown = "UNKNOWN"
}

export type WorkSuggestionsAutoDevJobJiraIssue = {
    __typename?: "WorkSuggestionsAutoDevJobJiraIssue";
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The Jira issue ID, ARI */
    id: Scalars["String"]["output"];
    /** The issue key of the Jira Issue that this AutoDevJobTask is related to */
    key: Scalars["String"]["output"];
    /** The summary of the Jira Issue that this AutoDevJobTask is related to */
    summary?: Maybe<Scalars["String"]["output"]>;
    /** The Jira issue web URL that navigates to the issue */
    webUrl?: Maybe<Scalars["String"]["output"]>;
};

export enum WorkSuggestionsAutoDevJobState {
    Cancelled = "CANCELLED",
    CodeGenerating = "CODE_GENERATING",
    CodeGenerationFail = "CODE_GENERATION_FAIL",
    CodeGenerationReady = "CODE_GENERATION_READY",
    CodeGenerationSuccess = "CODE_GENERATION_SUCCESS",
    Created = "CREATED",
    PlanGenerating = "PLAN_GENERATING",
    PlanGenerationFail = "PLAN_GENERATION_FAIL",
    PlanGenerationSuccess = "PLAN_GENERATION_SUCCESS",
    PullrequestCreating = "PULLREQUEST_CREATING",
    PullrequestCreationFail = "PULLREQUEST_CREATION_FAIL",
    PullrequestCreationSuccess = "PULLREQUEST_CREATION_SUCCESS",
    Unknown = "UNKNOWN"
}

export type WorkSuggestionsAutoDevJobTask = {
    /**
     * The id of the AutoDevJob
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    autoDevJobId: Scalars["String"]["output"];
    /**
     * The state of the AutoDevJob
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    autoDevState?: Maybe<WorkSuggestionsAutoDevJobState>;
    /**
     * The id of the Work Suggestion for AutoDevJobTask.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The jira issue that this AutoDevJobTask is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issue: WorkSuggestionsAutoDevJobJiraIssue;
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The repository URL of the AutoDevJob
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    repoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type WorkSuggestionsAutoDevJobsPlanSuccessTask =
    WorkSuggestionsAutoDevJobTask & {
        __typename?: "WorkSuggestionsAutoDevJobsPlanSuccessTask";
        /**
         * The id of the AutoDevJob
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        autoDevJobId: Scalars["String"]["output"];
        /**
         * The AutoDev planning state
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        autoDevPlanState?: Maybe<Scalars["String"]["output"]>;
        /**
         * The state of the AutoDevJob
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        autoDevState?: Maybe<WorkSuggestionsAutoDevJobState>;
        /**
         * The id of the Work Suggestion for AutoDevJobTask.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["String"]["output"];
        /**
         * The jira issue that this AutoDevJobTask is related to
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        issue: WorkSuggestionsAutoDevJobJiraIssue;
        /**
         * The orderScore for a position of task in result.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        orderScore?: Maybe<WorkSuggestionsOrderScore>;
        /**
         * The repository URL of the AutoDevJob
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        repoUrl?: Maybe<Scalars["String"]["output"]>;
    };

export type WorkSuggestionsBlockedIssue = {
    __typename?: "WorkSuggestionsBlockedIssue";
    /** Issue assignee */
    assignee?: Maybe<WorkSuggestionsJiraAssignee>;
    /** Issue type icon URL */
    issueIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** Issue key */
    issueKey: Scalars["String"]["output"];
    /** Issue priority */
    priority?: Maybe<WorkSuggestionsJiraPriority>;
    /** Issue story points */
    storyPoints?: Maybe<Scalars["Float"]["output"]>;
    /** Issue title */
    title: Scalars["String"]["output"];
};

export type WorkSuggestionsBlockingIssueTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsBlockingIssueTask";
    /** Issues blocked by the current blocking issue */
    blockedIssues?: Maybe<Array<WorkSuggestionsBlockedIssue>>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** Icon url for the icon */
    issueIconUrl: Scalars["String"]["output"];
    /** The id of the Jira Blocking Issue */
    issueId: Scalars["String"]["output"];
    /** The issue key of the Jira Blocking Issue */
    issueKey: Scalars["String"]["output"];
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** The title of the task. */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsBuildTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsBuildTask";
    /**
     * Identifies the Build within the sequence of Builds
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    buildNumber: Scalars["Int"]["output"];
    /**
     * The id of the Work Suggestion in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The id of the Jira Issue that this Build is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueId: Scalars["String"]["output"];
    /**
     * The issue key of the Jira Issue that this Build is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueKey: Scalars["String"]["output"];
    /**
     * The display name of the Jira Issue that this Build is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueName: Scalars["String"]["output"];
    /**
     * The last time this Build information surfaced by the Work Suggestions feature was updated
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["String"]["output"];
    /**
     * The number of failed Builds in the pipeline that this Build is in
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    numberOfFailedBuilds: Scalars["Int"]["output"];
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The title of the task. This will be the display name of the Build
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The URL that navigates to the task
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsByIssuesResponse = {
    __typename?: "WorkSuggestionsByIssuesResponse";
    /**
     * draft pr suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsDraftPrSuggestions")' query directive to the 'draftPRSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    draftPRSuggestions?: Maybe<Array<WorkSuggestionsPullRequestDraftTask>>;
    /**
     * inactive pr suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsPullRequestInactiveTask")' query directive to the 'inactivePRSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    inactivePRSuggestions?: Maybe<
        Array<WorkSuggestionsPullRequestInactiveTask>
    >;
    /**
     * Pull Requests Related suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsRecentPullRequestsSuggestions")' query directive to the 'recentPullRequests' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    recentPullRequests?: Maybe<WorkSuggestionsPullRequestSuggestionsResponse>;
};

export type WorkSuggestionsByProjectsResponse = {
    __typename?: "WorkSuggestionsByProjectsResponse";
    /**
     * AutoDev jobs suggestions which will contain the suggestions for the WorkSuggestionsAutoDevJobTask types
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsAutoDevJobs")' query directive to the 'autoDevJobsSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    autoDevJobsSuggestions?: Maybe<Array<WorkSuggestionsAutoDevJobTask>>;
    /**
     * Blocking issue suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsBlockingIssueTask")' query directive to the 'blockingIssueSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    blockingIssueSuggestions?: Maybe<Array<WorkSuggestionsBlockingIssueTask>>;
    /**
     * Suggestions from Compass Components
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsCompassTask")' query directive to the 'compassSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    compassSuggestions?: Maybe<Array<WorkSuggestionsCompassTask>>;
    /**
     * Draft pull requests suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsDraftPrSuggestions")' query directive to the 'draftPRSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    draftPRSuggestions?: Maybe<Array<WorkSuggestionsPullRequestDraftTask>>;
    /**
     * Inactive pr suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsPullRequestInactiveTask")' query directive to the 'inactivePRSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    inactivePRSuggestions?: Maybe<
        Array<WorkSuggestionsPullRequestInactiveTask>
    >;
    /**
     * Issue due soon suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsIssueDueSoonTask")' query directive to the 'issueDueSoonSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueDueSoonSuggestions?: Maybe<Array<WorkSuggestionsIssueDueSoonTask>>;
    /**
     * Issue missing details suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsIssueMissingDetailsTask")' query directive to the 'issueMissingDetailsSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    issueMissingDetailsSuggestions?: Maybe<
        Array<WorkSuggestionsIssueMissingDetailsTask>
    >;
    /**
     * Pull Requests Related suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsRecentPullRequestsSuggestions")' query directive to the 'recentPullRequests' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    recentPullRequests?: Maybe<WorkSuggestionsPullRequestSuggestionsResponse>;
    /**
     * Stuck issue suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsStuckIssueTask")' query directive to the 'stuckIssueSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    stuckIssueSuggestions?: Maybe<Array<WorkSuggestionsStuckIssueTask>>;
};

export type WorkSuggestionsByProjectsResponseAutoDevJobsSuggestionsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkSuggestionsByProjectsResponseBlockingIssueSuggestionsArgs = {
    input?: InputMaybe<WorkSuggestionsInput>;
};

export type WorkSuggestionsByProjectsResponseCompassSuggestionsArgs = {
    first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type WorkSuggestionsByProjectsResponseInactivePrSuggestionsArgs = {
    input?: InputMaybe<WorkSuggestionsInput>;
};

export type WorkSuggestionsByProjectsResponseIssueDueSoonSuggestionsArgs = {
    input?: InputMaybe<WorkSuggestionsInput>;
};

export type WorkSuggestionsByProjectsResponseIssueMissingDetailsSuggestionsArgs =
    {
        input?: InputMaybe<WorkSuggestionsInput>;
    };

export type WorkSuggestionsByProjectsResponseStuckIssueSuggestionsArgs = {
    input?: InputMaybe<WorkSuggestionsInput>;
};

export type WorkSuggestionsCommon = {
    /**
     * The id of the WorkSuggestion, which is the id of the underlying task represented by 'task' (of type 'TaskType',
     * e.g. PR_REVIEW, DEPLOYMENT_FAILED, BUILD_FAILED) in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The title of the underlying task. If the underlying task is PR_REVIEW, then the title of this WorkSuggestion
     * will be the title of the Pull Request. If the underlying task is BUILD_FAILED, then the title will be the
     * display name of the Build.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The URL that navigates to the underlying task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsCompassAnnouncementTask =
    WorkSuggestionsCompassTask & {
        __typename?: "WorkSuggestionsCompassAnnouncementTask";
        /**
         * Compass component ARI.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentAri?: Maybe<Scalars["ID"]["output"]>;
        /**
         * Compass component name.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentName?: Maybe<Scalars["String"]["output"]>;
        /**
         * Compass component type (e.g. SERVICE, APPLICATION, etc.).
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        componentType?: Maybe<Scalars["String"]["output"]>;
        /**
         * Compass announcement's description.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        description?: Maybe<Scalars["String"]["output"]>;
        /**
         * Task id
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        id: Scalars["String"]["output"];
        /**
         * The orderScore for a position of the task in the result.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        orderScore?: Maybe<WorkSuggestionsOrderScore>;
        /**
         * Name of the Component that sent the announcement.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        senderComponentName?: Maybe<Scalars["String"]["output"]>;
        /**
         * Type of the Component that sent the announcement.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        senderComponentType?: Maybe<Scalars["String"]["output"]>;
        /**
         * Target date for the announcement.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        targetDate?: Maybe<Scalars["String"]["output"]>;
        /**
         * The title of the Compass announcement task.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        title: Scalars["String"]["output"];
        /**
         * The url for the Compass component's announcements.
         *
         * |Authentication Category    |Callable      |
         * |:--------------------------|:-------------|
         * | SESSION | ✅ Yes |
         * | API_TOKEN | ✅ Yes |
         * | CONTAINER_TOKEN | ❌ No |
         * | FIRST_PARTY_OAUTH | ❌ No |
         * | THIRD_PARTY_OAUTH | ❌ No |
         * | UNAUTHENTICATED | ❌ No |
         *
         */
        url: Scalars["String"]["output"];
    };

export type WorkSuggestionsCompassTask = {
    /**
     * Compass component ARI.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    componentAri?: Maybe<Scalars["ID"]["output"]>;
    /**
     * Compass component name.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    componentName?: Maybe<Scalars["String"]["output"]>;
    /**
     * Compass component type (e.g. SERVICE, APPLICATION, etc.).
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    componentType?: Maybe<Scalars["String"]["output"]>;
    /**
     * Task id for compass task
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The title of the Compass task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The URL that navigates to the compass task
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsConnection = {
    __typename?: "WorkSuggestionsConnection";
    edges?: Maybe<Array<WorkSuggestionsEdge>>;
    nodes?: Maybe<Array<Maybe<WorkSuggestionsCommon>>>;
    pageInfo: PageInfo;
    totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** projectAri is always required, but sprintAri can also be specified */
export type WorkSuggestionsContextAri = {
    projectAri: Scalars["ID"]["input"];
    sprintAri?: InputMaybe<Scalars["ID"]["input"]>;
};

export type WorkSuggestionsCriticalVulnerabilityTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsCriticalVulnerabilityTask";
    /**
     * The id of the Work Suggestion in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The introduction date of the vulnerability
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    introducedDate: Scalars["String"]["output"];
    /**
     * The id of the Jira Issue that this vulnerability is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueId: Scalars["String"]["output"];
    /**
     * The issue key of the Jira Issue that this vulnerability is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueKey: Scalars["String"]["output"];
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The security container name of the vulnerability
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    securityContainerName: Scalars["String"]["output"];
    /**
     * The vulnerability status
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    status: WorkSuggestionsVulnerabilityStatus;
    /**
     * The title of the task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The URL that navigates to the task
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsDeploymentTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsDeploymentTask";
    /**
     * The list of display names that the Deployment is present in
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    environmentNames: Array<Scalars["String"]["output"]>;
    /**
     * The environment that the Deployment is present in (e.g. staging, production)
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    environmentType: WorkSuggestionsEnvironmentType;
    /**
     * The id of the Work Suggestion in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The id of the Jira Issue that this Deployment is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueId: Scalars["String"]["output"];
    /**
     * The issue key of the Jira Issue that this Deployment is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueKey: Scalars["String"]["output"];
    /**
     * The display name of the Jira Issue that this Deployment is related to
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    issueName: Scalars["String"]["output"];
    /**
     * The last time this Deployment information surfaced by the Work Suggestions feature was updated
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["String"]["output"];
    /**
     * The number of failed Deployments in the environment that this Deployment is in
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    numberOfFailedDeployments: Scalars["Int"]["output"];
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The display name of the pipeline that ran the Deployment
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    pipelineName: Scalars["String"]["output"];
    /**
     * The title of the task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The URL that navigates to the task
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsEdge = {
    __typename?: "WorkSuggestionsEdge";
    cursor: Scalars["String"]["output"];
    node?: Maybe<WorkSuggestionsCommon>;
};

export enum WorkSuggestionsEnvironmentType {
    Development = "DEVELOPMENT",
    Production = "PRODUCTION",
    Staging = "STAGING",
    Testing = "TESTING",
    Unmapped = "UNMAPPED"
}

export type WorkSuggestionsInput = {
    /** Limit to return the first X suggestions */
    first?: InputMaybe<Scalars["Int"]["input"]>;
    /** The target audience for the suggestions */
    targetAudience?: InputMaybe<WorkSuggestionsTargetAudience>;
};

export type WorkSuggestionsIssueDueSoonTask = WorkSuggestionsPeriscopeTask & {
    __typename?: "WorkSuggestionsIssueDueSoonTask";
    /** Issue assignee */
    assigneeProfile?: Maybe<WorkSuggestionsJiraAssignee>;
    /** Issue due date */
    dueDate?: Maybe<Scalars["String"]["output"]>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** Issue key of the issue */
    issueKey?: Maybe<Scalars["String"]["output"]>;
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** Issue priority */
    priority?: Maybe<WorkSuggestionsPriority>;
    /** Issue status */
    status?: Maybe<WorkSuggestionsIssueStatus>;
    /** The title of the task. */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsIssueMissingDetailsTask =
    WorkSuggestionsPeriscopeTask & {
        __typename?: "WorkSuggestionsIssueMissingDetailsTask";
        /** The id of the Work Suggestion in ARI format. */
        id: Scalars["String"]["output"];
        /** Issue key of the issue */
        issueKey?: Maybe<Scalars["String"]["output"]>;
        /** The orderScore for a position of task in result. */
        orderScore?: Maybe<WorkSuggestionsOrderScore>;
        /** Issue priority */
        priority?: Maybe<WorkSuggestionsPriority>;
        /** Issue reporter */
        reporter?: Maybe<WorkSuggestionsJiraReporter>;
        /** Issue status */
        status?: Maybe<WorkSuggestionsIssueStatus>;
        /** The title of the task. */
        title: Scalars["String"]["output"];
        /** The URL that navigates to the task */
        url: Scalars["String"]["output"];
    };

export type WorkSuggestionsIssueStatus = {
    __typename?: "WorkSuggestionsIssueStatus";
    /** Issue status category */
    category?: Maybe<Scalars["String"]["output"]>;
    /** Issue status name */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type WorkSuggestionsJiraAssignee = {
    __typename?: "WorkSuggestionsJiraAssignee";
    /** Current assigned user's name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Current assigned user's avatar URL */
    pictureUrl?: Maybe<Scalars["String"]["output"]>;
};

export type WorkSuggestionsJiraPriority = {
    __typename?: "WorkSuggestionsJiraPriority";
    /** Priority Icon URL */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** Priority name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Priority sequence number */
    sequence?: Maybe<Scalars["Int"]["output"]>;
};

export type WorkSuggestionsJiraReporter = {
    __typename?: "WorkSuggestionsJiraReporter";
    /** Current reporter user's name */
    name?: Maybe<Scalars["String"]["output"]>;
    /** Current reporter user's avatar URL */
    pictureUrl?: Maybe<Scalars["String"]["output"]>;
};

/** Input for the mutation operation mergePullRequest. */
export type WorkSuggestionsMergePrActionInput = {
    /** Cloud id */
    cloudId: Scalars["ID"]["input"];
    /** work suggestions id */
    taskId: Scalars["String"]["input"];
};

export type WorkSuggestionsMergePrActionPayload = Payload & {
    __typename?: "WorkSuggestionsMergePRActionPayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type WorkSuggestionsMutation = {
    __typename?: "WorkSuggestionsMutation";
    /**
     * Execute action to merge a target PR
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsMergePRMutation")' query directive to the 'mergePullRequest' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    mergePullRequest?: Maybe<WorkSuggestionsMergePrActionPayload>;
    /**
     * Execute action to nudge reviewers on inactive PR
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsNudgePRMutation")' query directive to the 'nudgePullRequestReviewers' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    nudgePullRequestReviewers?: Maybe<WorkSuggestionsNudgePrActionPayload>;
    /**
     * Execute action to remove a task from the work suggestions panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    removeTask?: Maybe<WorkSuggestionsActionPayload>;
    /**
     * Execute action to save the user profile
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsSaveUserProfile")' query directive to the 'saveUserProfile' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    saveUserProfile?: Maybe<WorkSuggestionsSaveUserProfilePayload>;
    /**
     * Execute action to snooze a task from the work suggestions panel
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    snoozeTask?: Maybe<WorkSuggestionsActionPayload>;
};

export type WorkSuggestionsMutationMergePullRequestArgs = {
    input: WorkSuggestionsMergePrActionInput;
};

export type WorkSuggestionsMutationNudgePullRequestReviewersArgs = {
    input: WorkSuggestionsNudgePrActionInput;
};

export type WorkSuggestionsMutationRemoveTaskArgs = {
    input: WorkSuggestionsActionInput;
};

export type WorkSuggestionsMutationSaveUserProfileArgs = {
    input: WorkSuggestionsSaveUserProfileInput;
};

export type WorkSuggestionsMutationSnoozeTaskArgs = {
    input: WorkSuggestionsActionInput;
};

export type WorkSuggestionsMutationErrorExtension = MutationErrorExtension & {
    __typename?: "WorkSuggestionsMutationErrorExtension";
    /**
     * Application specific error type
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    errorType?: Maybe<Scalars["String"]["output"]>;
    /**
     * A numerical code (such as a HTTP status code) representing the error category
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    statusCode?: Maybe<Scalars["Int"]["output"]>;
};

/** Input for the mutation operation nudgePullRequestReviewers. */
export type WorkSuggestionsNudgePrActionInput = {
    /** Cloud id */
    cloudId: Scalars["ID"]["input"];
    /** work suggestions id */
    taskId: Scalars["String"]["input"];
};

export type WorkSuggestionsNudgePrActionPayload = Payload & {
    __typename?: "WorkSuggestionsNudgePRActionPayload";
    /** The id outputted */
    commentId?: Maybe<Scalars["Int"]["output"]>;
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
};

export type WorkSuggestionsOrderScore = {
    __typename?: "WorkSuggestionsOrderScore";
    /** Return scores that is ranked by task Type, minor will be based on nature order. */
    byTaskType?: Maybe<WorkSuggestionsOrderScores>;
};

export type WorkSuggestionsOrderScores = {
    __typename?: "WorkSuggestionsOrderScores";
    /** Major order score used to order suggestion */
    major: Scalars["Int"]["output"];
    /** Minor order score used to sub order suggestion under a major order. For example for ordering PR suggestions under the same PR suggestion type. */
    minor?: Maybe<Scalars["Long"]["output"]>;
};

export type WorkSuggestionsPrComment = {
    __typename?: "WorkSuggestionsPRComment";
    /** Commenter avatar */
    avatar?: Maybe<Scalars["String"]["output"]>;
    /** Commenter name */
    commenterName: Scalars["String"]["output"];
    /** Comment created on date time in UTC string */
    createdOn: Scalars["String"]["output"];
    /** Comment text */
    text: Scalars["String"]["output"];
    /** Link to comment in SCM system */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsPrCommentsTask = WorkSuggestionsPeriscopeTask & {
    __typename?: "WorkSuggestionsPRCommentsTask";
    /** The number of reviewers that have approved this Pull Request */
    approvalsCount: Scalars["Int"]["output"];
    /** The number of comments on this Pull Request */
    commentCount: Scalars["Int"]["output"];
    /** Recent comments, for MVP only latest one comment is returned. */
    comments?: Maybe<Array<WorkSuggestionsPrComment>>;
    /** The destination branch names of the Pull Request */
    destinationBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** The provider icon URL for the Pull Request */
    providerIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The provider name for the Pull Request */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the repository this Pull Request was raised in */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /** The source branch names of the Pull Request */
    sourceBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The title of the task. This will be the title of the Pull Request */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsPrMergeableTask = WorkSuggestionsPeriscopeTask & {
    __typename?: "WorkSuggestionsPRMergeableTask";
    /** The number of reviewers that have approved this Pull Request */
    approvalsCount: Scalars["Int"]["output"];
    /** The number of comments on this Pull Request */
    commentCount: Scalars["Int"]["output"];
    /** The destination branch names of the Pull Request */
    destinationBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** Whether the merge action is enabled for this Pull Request */
    isMergeActionEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** The provider icon URL for the Pull Request */
    providerIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The provider name for the Pull Request */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The ARI of the Pull Request */
    pullRequestAri?: Maybe<Scalars["String"]["output"]>;
    /** The internal ID of the Pull Request */
    pullRequestInternalId?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the repository this Pull Request was raised in */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /** The source branch names of the Pull Request */
    sourceBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The title of the task. This will be the title of the Pull Request */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

/** An interface for all suggestion types supported by Periscope page */
export type WorkSuggestionsPeriscopeTask = {
    /** Task Id */
    id: Scalars["String"]["output"];
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** Task Title */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the underlying task */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsPriority = {
    __typename?: "WorkSuggestionsPriority";
    /** Priority icon URL */
    iconUrl?: Maybe<Scalars["String"]["output"]>;
    /** Priority name */
    name?: Maybe<Scalars["String"]["output"]>;
};

export type WorkSuggestionsPullRequestDraftTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsPullRequestDraftTask";
    /** The number of reviewers that have approved this Pull Request */
    approvalsCount: Scalars["Int"]["output"];
    /** The author of the Pull Request */
    author?: Maybe<WorkSuggestionsUserDetail>;
    /** The number of comments on this Pull Request */
    commentCount: Scalars["Int"]["output"];
    /** The destination branch names of the Pull Request */
    destinationBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** The last time this Pull Request information surfaced by the Work Suggestions feature was updated */
    lastUpdated: Scalars["String"]["output"];
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** The provider icon URL for the Pull Request */
    providerIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The provider name for the Pull Request */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the repository this Pull Request was raised in */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /** The source branch names of the Pull Request */
    sourceBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The title of the task. This will be the title of the Pull Request */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsPullRequestInactiveTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsPullRequestInactiveTask";
    /** The number of reviewers that have approved this Pull Request */
    approvalsCount: Scalars["Int"]["output"];
    /** The author of the Pull Request */
    author?: Maybe<WorkSuggestionsUserDetail>;
    /** If this task is able to be nudged. */
    canNudgeReviewers?: Maybe<Scalars["Boolean"]["output"]>;
    /** The number of comments on this Pull Request */
    commentCount: Scalars["Int"]["output"];
    /** The destination branch names of the Pull Request */
    destinationBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** The last time this Pull Request information surfaced by the Work Suggestions feature was updated */
    lastUpdated: Scalars["String"]["output"];
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** The provider icon URL for the Pull Request */
    providerIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The provider name for the Pull Request */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the repository this Pull Request was raised in */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /** The source branch names of the Pull Request */
    sourceBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The title of the task. */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsPullRequestNeedsWorkTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsPullRequestNeedsWorkTask";
    /**
     * The number of comments on this Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    commentCount: Scalars["Int"]["output"];
    /**
     * The destination branch names of the Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    destinationBranchName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The id of the Work Suggestion in ARI format.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["String"]["output"];
    /**
     * The last time this Pull Request information surfaced by the Work Suggestions feature was updated
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    lastUpdated: Scalars["String"]["output"];
    /**
     * The number of reviewers that have marked this Pull Request as "Needs Work" or "Changes Requested"
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    needsWorkCount: Scalars["Int"]["output"];
    /**
     * The orderScore for a position of task in result.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /**
     * The provider icon URL for the Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    providerIconUrl?: Maybe<Scalars["String"]["output"]>;
    /**
     * The provider name for the Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The display name of the repository this Pull Request was raised in
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The list of reviewers of the Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    reviewers?: Maybe<Array<Maybe<WorkSuggestionsUserDetail>>>;
    /**
     * The source branch names of the Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    sourceBranchName?: Maybe<Scalars["String"]["output"]>;
    /**
     * The title of the task.
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    title: Scalars["String"]["output"];
    /**
     * The URL that navigates to the task
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    url: Scalars["String"]["output"];
};

export type WorkSuggestionsPullRequestReviewTask = WorkSuggestionsCommon & {
    __typename?: "WorkSuggestionsPullRequestReviewTask";
    /** The number of reviewers that have approved this Pull Request */
    approvalsCount: Scalars["Int"]["output"];
    /** The author of the Pull Request */
    author?: Maybe<WorkSuggestionsUserDetail>;
    /** The number of comments on this Pull Request */
    commentCount: Scalars["Int"]["output"];
    /** The destination branch names of the Pull Request */
    destinationBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** The last time this Pull Request information surfaced by the Work Suggestions feature was updated */
    lastUpdated: Scalars["String"]["output"];
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** The provider icon URL for the Pull Request */
    providerIconUrl?: Maybe<Scalars["String"]["output"]>;
    /** The provider name for the Pull Request */
    providerName?: Maybe<Scalars["String"]["output"]>;
    /** The display name of the repository this Pull Request was raised in */
    repositoryName?: Maybe<Scalars["String"]["output"]>;
    /** The source branch names of the Pull Request */
    sourceBranchName?: Maybe<Scalars["String"]["output"]>;
    /** The title of the task. This will be the title of the Pull Request */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

/** Response for the recent pull requests suggestions */
export type WorkSuggestionsPullRequestSuggestionsResponse = {
    __typename?: "WorkSuggestionsPullRequestSuggestionsResponse";
    /** Mergeable Pull Requests suggestions */
    mergeableSuggestions?: Maybe<Array<WorkSuggestionsPrMergeableTask>>;
    /** Pull Requests New Comments suggestions */
    newCommentsSuggestions?: Maybe<Array<WorkSuggestionsPrCommentsTask>>;
    /**
     * Pull Requests Review suggestions
     *
     * ### Field lifecycle
     *
     * This field is in the 'EXPERIMENTAL' lifecycle stage
     *
     * To query this field a client will need to add the '@optIn(to: "WorkSuggestionsPullRequestReviewTask")' query directive to the 'pullRequestReviewSuggestions' field, or to any of its parents.
     *
     * The field is extremely unstable. It can go through changes at any moment, and its execution can be slow and/or unreliable. Clients should use it with care and at their own risk!
     *
     */
    pullRequestReviewSuggestions?: Maybe<
        Array<WorkSuggestionsPullRequestReviewTask>
    >;
};

/** Input for the mutation operations (save user profile). */
export type WorkSuggestionsSaveUserProfileInput = {
    /** Cloud id */
    cloudId: Scalars["ID"]["input"];
    /** isUpdate */
    isUpdate: Scalars["Boolean"]["input"];
    /** Persona */
    persona?: InputMaybe<WorkSuggestionsUserPersona>;
    /** Project ARIs */
    projectAris: Array<Scalars["ID"]["input"]>;
};

export type WorkSuggestionsSaveUserProfilePayload = Payload & {
    __typename?: "WorkSuggestionsSaveUserProfilePayload";
    /** A list of errors if the mutation was not successful */
    errors?: Maybe<Array<MutationError>>;
    /** Was this mutation successful */
    success: Scalars["Boolean"]["output"];
    /** User profile object stored in the database */
    userProfile?: Maybe<WorkSuggestionsUserProfile>;
};

export type WorkSuggestionsStuckData = {
    __typename?: "WorkSuggestionsStuckData";
    /** Time in seconds of the threshold for the issue to be considered stuck */
    thresholdInSeconds?: Maybe<Scalars["Long"]["output"]>;
    /** Time in seconds since the issue was last updated */
    timeInSeconds?: Maybe<Scalars["Long"]["output"]>;
};

export type WorkSuggestionsStuckIssueTask = WorkSuggestionsPeriscopeTask & {
    __typename?: "WorkSuggestionsStuckIssueTask";
    /** Issue assignee */
    assignee?: Maybe<WorkSuggestionsJiraAssignee>;
    /** The id of the Work Suggestion in ARI format. */
    id: Scalars["String"]["output"];
    /** Issue key of the issue */
    issueKey?: Maybe<Scalars["String"]["output"]>;
    /** The orderScore for a position of task in result. */
    orderScore?: Maybe<WorkSuggestionsOrderScore>;
    /** Issue priority */
    priority?: Maybe<WorkSuggestionsPriority>;
    /** Issue status */
    status?: Maybe<WorkSuggestionsIssueStatus>;
    /** Issue stuck data */
    stuckData?: Maybe<WorkSuggestionsStuckData>;
    /** The title of the task. */
    title: Scalars["String"]["output"];
    /** The URL that navigates to the task */
    url: Scalars["String"]["output"];
};

export enum WorkSuggestionsTargetAudience {
    /** The target audience for individual suggestions */
    Me = "ME",
    /** The target audience for team suggestions */
    Team = "TEAM"
}

/** Action object stored in the database for the actions snooze/remove task. */
export type WorkSuggestionsUserActionState = {
    __typename?: "WorkSuggestionsUserActionState";
    /** Date when the action expires */
    expireAt: Scalars["String"]["output"];
    /** Reason for the action (snooze or remove) */
    reason: WorkSuggestionsAction;
    stateId: Scalars["String"]["output"];
    /** Work Suggestion id */
    taskId: Scalars["String"]["output"];
};

export type WorkSuggestionsUserDetail = {
    __typename?: "WorkSuggestionsUserDetail";
    /**
     * The approval status of the user on a Pull Request
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    approvalStatus?: Maybe<WorkSuggestionsApprovalStatus>;
    /**
     * The avatar URL of the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    avatarUrl: Scalars["String"]["output"];
    /**
     * The account ID of the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    id: Scalars["ID"]["output"];
    /**
     * The display name of the user
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ❌ No |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ❌ No |
     *
     */
    name: Scalars["String"]["output"];
};

/**
 * Persona for the user profile.
 * For example: DEVELOPER
 */
export enum WorkSuggestionsUserPersona {
    Developer = "DEVELOPER"
}

/** User profile type for the user */
export type WorkSuggestionsUserProfile = {
    __typename?: "WorkSuggestionsUserProfile";
    /** aaid Atlassian account ID */
    aaid: Scalars["String"]["output"];
    /** The date when the user profile was created */
    createdOn: Scalars["String"]["output"];
    /** ERS record id */
    id: Scalars["String"]["output"];
    /**
     * Persona for the user
     * For example: DEVELOPER
     */
    persona?: Maybe<WorkSuggestionsUserPersona>;
    /** Favourite project ARIs */
    projectAris?: Maybe<Array<Scalars["ID"]["output"]>>;
};

export enum WorkSuggestionsVulnerabilityStatus {
    Closed = "CLOSED",
    Ignored = "IGNORED",
    Open = "OPEN",
    Unknown = "UNKNOWN"
}

/** An Applied Directive is an instances of a directive as applied to a schema element. This type is NOT specified by the graphql specification presently. */
export type _AppliedDirective = {
    __typename?: "_AppliedDirective";
    args: Array<_DirectiveArgument>;
    name: Scalars["String"]["output"];
};

/** Directive arguments can have names and values.  The values are in graphql SDL syntax printed as a string. This type is NOT specified by the graphql specification presently. */
export type _DirectiveArgument = {
    __typename?: "_DirectiveArgument";
    name: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type ContactAdminPageConfig = {
    __typename?: "contactAdminPageConfig";
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    contactAdministratorsMessage?: Maybe<Scalars["String"]["output"]>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    disabledReason?: Maybe<ContactAdminPageDisabledReason>;
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    isEnabled: Scalars["Boolean"]["output"];
    /**
     *
     *
     * |Authentication Category    |Callable      |
     * |:--------------------------|:-------------|
     * | SESSION | ✅ Yes |
     * | API_TOKEN | ✅ Yes |
     * | CONTAINER_TOKEN | ❌ No |
     * | FIRST_PARTY_OAUTH | ✅ Yes |
     * | THIRD_PARTY_OAUTH | ❌ No |
     * | UNAUTHENTICATED | ✅ Yes |
     *
     */
    recaptchaSharedKey?: Maybe<Scalars["String"]["output"]>;
};

export enum SourceBillingType {
    Ccp = "CCP",
    Hams = "HAMS"
}

export type PricingsResponseFragment = {
    __typename?: "ContentPlatformPricingSearchConnection";
    edges: Array<{
        __typename?: "ContentPlatformPricingResultEdge";
        node: {
            __typename?: "ContentPlatformPricing";
            pricingTitleInternal: string;
            pricingTitleExternal?: string | null;
            pageDescription?: string | null;
            headline?: string | null;
            compareFeaturesTitle?: string | null;
            getMoreDetailsTitle?: string | null;
            comparePlans?: Array<{
                __typename?: "ContentPlatformPlan";
                planTitleExternal?: string | null;
                planOneLiner?: string | null;
                highlightedFeaturesTitle?: string | null;
                microCta?: Array<
                    | { __typename?: "ContentPlatformCallToAction" }
                    | {
                          __typename?: "ContentPlatformCallToActionMicrocopy";
                          ctaMicrocopyTitle?: string | null;
                          ctaButtonText?: string | null;
                          ctaUrl?: string | null;
                      }
                > | null;
                highlightedFeaturesContainer?: Array<{
                    __typename?: "ContentPlatformHighlightedFeature";
                    highlightedFeatureDetails?: string | null;
                    highlightedFeatureTitleExternal?: string | null;
                    callOut?: string | null;
                }> | null;
            }> | null;
            compareFeatures?: Array<{
                __typename?: "ContentPlatformFeatureGroup";
                featureGroupTitleExternal?: string | null;
                features?: Array<{
                    __typename?: "ContentPlatformFeature";
                    callOut?: string | null;
                    featureNameExternal?: string | null;
                    description?: string | null;
                    relevantUrl?: string | null;
                    relevantPlan?: Array<{
                        __typename?: "ContentPlatformPlan";
                        planTitleExternal?: string | null;
                    }> | null;
                    featureAdditionalInformation?: Array<{
                        __typename?: "ContentPlatformFeatureAdditionalInformation";
                        featureAdditionalInformation?: string | null;
                        relevantPlan?: Array<{
                            __typename?: "ContentPlatformPlan";
                            planTitleExternal?: string | null;
                        }> | null;
                    }> | null;
                }> | null;
            }> | null;
            additionalDetails?: Array<{
                __typename?: "ContentPlatformPlanDetails";
                planAdditionalDetailsTitleExternal?: string | null;
                planAdditionalDetails?: string | null;
            }> | null;
            relatedProduct?: Array<{
                __typename?: "ContentPlatformPricingProductName";
                productName: string;
                productNameId: string;
            }> | null;
            callToActionContainer?: Array<
                | {
                      __typename?: "ContentPlatformCallToAction";
                      title?: string | null;
                      valueProposition?: string | null;
                      text?: string | null;
                      url?: string | null;
                      asset?: {
                          __typename?: "ContentPlatformTemplateImageAsset";
                          title?: string | null;
                          description?: string | null;
                          url: string;
                      } | null;
                  }
                | {
                      __typename?: "ContentPlatformCallToActionMicrocopy";
                      ctaMicrocopyTitle?: string | null;
                      ctaButtonText?: string | null;
                      ctaUrl?: string | null;
                  }
            > | null;
            datacenterPlans?: Array<{
                __typename?: "ContentPlatformPlan";
                planTitleExternal?: string | null;
                planOneLiner?: string | null;
                highlightedFeaturesTitle?: string | null;
                microCta?: Array<
                    | { __typename?: "ContentPlatformCallToAction" }
                    | {
                          __typename?: "ContentPlatformCallToActionMicrocopy";
                          ctaMicrocopyTitle?: string | null;
                          ctaButtonText?: string | null;
                          ctaUrl?: string | null;
                      }
                > | null;
                highlightedFeaturesContainer?: Array<{
                    __typename?: "ContentPlatformHighlightedFeature";
                    highlightedFeatureDetails?: string | null;
                    highlightedFeatureTitleExternal?: string | null;
                    callOut?: string | null;
                }> | null;
            }> | null;
        };
    }>;
};

export type PricingPlanFragment = {
    __typename?: "ContentPlatformPricing";
    pricingTitleInternal: string;
    pricingTitleExternal?: string | null;
    pageDescription?: string | null;
    headline?: string | null;
    compareFeaturesTitle?: string | null;
    getMoreDetailsTitle?: string | null;
    comparePlans?: Array<{
        __typename?: "ContentPlatformPlan";
        planTitleExternal?: string | null;
        planOneLiner?: string | null;
        highlightedFeaturesTitle?: string | null;
        microCta?: Array<
            | { __typename?: "ContentPlatformCallToAction" }
            | {
                  __typename?: "ContentPlatformCallToActionMicrocopy";
                  ctaMicrocopyTitle?: string | null;
                  ctaButtonText?: string | null;
                  ctaUrl?: string | null;
              }
        > | null;
        highlightedFeaturesContainer?: Array<{
            __typename?: "ContentPlatformHighlightedFeature";
            highlightedFeatureDetails?: string | null;
            highlightedFeatureTitleExternal?: string | null;
            callOut?: string | null;
        }> | null;
    }> | null;
    compareFeatures?: Array<{
        __typename?: "ContentPlatformFeatureGroup";
        featureGroupTitleExternal?: string | null;
        features?: Array<{
            __typename?: "ContentPlatformFeature";
            callOut?: string | null;
            featureNameExternal?: string | null;
            description?: string | null;
            relevantUrl?: string | null;
            relevantPlan?: Array<{
                __typename?: "ContentPlatformPlan";
                planTitleExternal?: string | null;
            }> | null;
            featureAdditionalInformation?: Array<{
                __typename?: "ContentPlatformFeatureAdditionalInformation";
                featureAdditionalInformation?: string | null;
                relevantPlan?: Array<{
                    __typename?: "ContentPlatformPlan";
                    planTitleExternal?: string | null;
                }> | null;
            }> | null;
        }> | null;
    }> | null;
    additionalDetails?: Array<{
        __typename?: "ContentPlatformPlanDetails";
        planAdditionalDetailsTitleExternal?: string | null;
        planAdditionalDetails?: string | null;
    }> | null;
    relatedProduct?: Array<{
        __typename?: "ContentPlatformPricingProductName";
        productName: string;
        productNameId: string;
    }> | null;
    callToActionContainer?: Array<
        | {
              __typename?: "ContentPlatformCallToAction";
              title?: string | null;
              valueProposition?: string | null;
              text?: string | null;
              url?: string | null;
              asset?: {
                  __typename?: "ContentPlatformTemplateImageAsset";
                  title?: string | null;
                  description?: string | null;
                  url: string;
              } | null;
          }
        | {
              __typename?: "ContentPlatformCallToActionMicrocopy";
              ctaMicrocopyTitle?: string | null;
              ctaButtonText?: string | null;
              ctaUrl?: string | null;
          }
    > | null;
    datacenterPlans?: Array<{
        __typename?: "ContentPlatformPlan";
        planTitleExternal?: string | null;
        planOneLiner?: string | null;
        highlightedFeaturesTitle?: string | null;
        microCta?: Array<
            | { __typename?: "ContentPlatformCallToAction" }
            | {
                  __typename?: "ContentPlatformCallToActionMicrocopy";
                  ctaMicrocopyTitle?: string | null;
                  ctaButtonText?: string | null;
                  ctaUrl?: string | null;
              }
        > | null;
        highlightedFeaturesContainer?: Array<{
            __typename?: "ContentPlatformHighlightedFeature";
            highlightedFeatureDetails?: string | null;
            highlightedFeatureTitleExternal?: string | null;
            callOut?: string | null;
        }> | null;
    }> | null;
};

export type PricingPlanComparePlansItemFragment = {
    __typename?: "ContentPlatformPlan";
    planTitleExternal?: string | null;
    planOneLiner?: string | null;
    highlightedFeaturesTitle?: string | null;
    microCta?: Array<
        | { __typename?: "ContentPlatformCallToAction" }
        | {
              __typename?: "ContentPlatformCallToActionMicrocopy";
              ctaMicrocopyTitle?: string | null;
              ctaButtonText?: string | null;
              ctaUrl?: string | null;
          }
    > | null;
    highlightedFeaturesContainer?: Array<{
        __typename?: "ContentPlatformHighlightedFeature";
        highlightedFeatureDetails?: string | null;
        highlightedFeatureTitleExternal?: string | null;
        callOut?: string | null;
    }> | null;
};

export type PricingPlanMicroCtaFragment = {
    __typename?: "ContentPlatformCallToActionMicrocopy";
    ctaMicrocopyTitle?: string | null;
    ctaButtonText?: string | null;
    ctaUrl?: string | null;
};

export type PricingPlanCompareFeaturesItemFragment = {
    __typename?: "ContentPlatformFeatureGroup";
    featureGroupTitleExternal?: string | null;
    features?: Array<{
        __typename?: "ContentPlatformFeature";
        callOut?: string | null;
        featureNameExternal?: string | null;
        description?: string | null;
        relevantUrl?: string | null;
        relevantPlan?: Array<{
            __typename?: "ContentPlatformPlan";
            planTitleExternal?: string | null;
        }> | null;
        featureAdditionalInformation?: Array<{
            __typename?: "ContentPlatformFeatureAdditionalInformation";
            featureAdditionalInformation?: string | null;
            relevantPlan?: Array<{
                __typename?: "ContentPlatformPlan";
                planTitleExternal?: string | null;
            }> | null;
        }> | null;
    }> | null;
};

export type RelevantPlanFragment = {
    __typename?: "ContentPlatformPlan";
    planTitleExternal?: string | null;
};

export type FeatureAdditionalInformationFragment = {
    __typename?: "ContentPlatformFeatureAdditionalInformation";
    featureAdditionalInformation?: string | null;
    relevantPlan?: Array<{
        __typename?: "ContentPlatformPlan";
        planTitleExternal?: string | null;
    }> | null;
};

export type PricingPlanAdditionalFeaturesItemFragment = {
    __typename?: "ContentPlatformPlanDetails";
    planAdditionalDetailsTitleExternal?: string | null;
    planAdditionalDetails?: string | null;
};

export type PricingPlanCallToActionItemFragment = {
    __typename?: "ContentPlatformCallToAction";
    title?: string | null;
    valueProposition?: string | null;
    text?: string | null;
    url?: string | null;
    asset?: {
        __typename?: "ContentPlatformTemplateImageAsset";
        title?: string | null;
        description?: string | null;
        url: string;
    } | null;
};

export type PricingPlanCallToActionMicrocopyItemFragment = {
    __typename?: "ContentPlatformCallToActionMicrocopy";
    ctaMicrocopyTitle?: string | null;
    ctaButtonText?: string | null;
    ctaUrl?: string | null;
};

export type PricingPlanHighlightedFeatureItemFragment = {
    __typename?: "ContentPlatformHighlightedFeature";
    highlightedFeatureDetails?: string | null;
    highlightedFeatureTitleExternal?: string | null;
    callOut?: string | null;
};

export type PricingsQueryVariables = Exact<{
    search: ContentPlatformSearchApIv2Query;
}>;

export type PricingsQuery = {
    __typename?: "Query";
    pricings: {
        __typename?: "ContentPlatformPricingSearchConnection";
        edges: Array<{
            __typename?: "ContentPlatformPricingResultEdge";
            node: {
                __typename?: "ContentPlatformPricing";
                pricingTitleInternal: string;
                pricingTitleExternal?: string | null;
                pageDescription?: string | null;
                headline?: string | null;
                compareFeaturesTitle?: string | null;
                getMoreDetailsTitle?: string | null;
                comparePlans?: Array<{
                    __typename?: "ContentPlatformPlan";
                    planTitleExternal?: string | null;
                    planOneLiner?: string | null;
                    highlightedFeaturesTitle?: string | null;
                    microCta?: Array<
                        | { __typename?: "ContentPlatformCallToAction" }
                        | {
                              __typename?: "ContentPlatformCallToActionMicrocopy";
                              ctaMicrocopyTitle?: string | null;
                              ctaButtonText?: string | null;
                              ctaUrl?: string | null;
                          }
                    > | null;
                    highlightedFeaturesContainer?: Array<{
                        __typename?: "ContentPlatformHighlightedFeature";
                        highlightedFeatureDetails?: string | null;
                        highlightedFeatureTitleExternal?: string | null;
                        callOut?: string | null;
                    }> | null;
                }> | null;
                compareFeatures?: Array<{
                    __typename?: "ContentPlatformFeatureGroup";
                    featureGroupTitleExternal?: string | null;
                    features?: Array<{
                        __typename?: "ContentPlatformFeature";
                        callOut?: string | null;
                        featureNameExternal?: string | null;
                        description?: string | null;
                        relevantUrl?: string | null;
                        relevantPlan?: Array<{
                            __typename?: "ContentPlatformPlan";
                            planTitleExternal?: string | null;
                        }> | null;
                        featureAdditionalInformation?: Array<{
                            __typename?: "ContentPlatformFeatureAdditionalInformation";
                            featureAdditionalInformation?: string | null;
                            relevantPlan?: Array<{
                                __typename?: "ContentPlatformPlan";
                                planTitleExternal?: string | null;
                            }> | null;
                        }> | null;
                    }> | null;
                }> | null;
                additionalDetails?: Array<{
                    __typename?: "ContentPlatformPlanDetails";
                    planAdditionalDetailsTitleExternal?: string | null;
                    planAdditionalDetails?: string | null;
                }> | null;
                relatedProduct?: Array<{
                    __typename?: "ContentPlatformPricingProductName";
                    productName: string;
                    productNameId: string;
                }> | null;
                callToActionContainer?: Array<
                    | {
                          __typename?: "ContentPlatformCallToAction";
                          title?: string | null;
                          valueProposition?: string | null;
                          text?: string | null;
                          url?: string | null;
                          asset?: {
                              __typename?: "ContentPlatformTemplateImageAsset";
                              title?: string | null;
                              description?: string | null;
                              url: string;
                          } | null;
                      }
                    | {
                          __typename?: "ContentPlatformCallToActionMicrocopy";
                          ctaMicrocopyTitle?: string | null;
                          ctaButtonText?: string | null;
                          ctaUrl?: string | null;
                      }
                > | null;
                datacenterPlans?: Array<{
                    __typename?: "ContentPlatformPlan";
                    planTitleExternal?: string | null;
                    planOneLiner?: string | null;
                    highlightedFeaturesTitle?: string | null;
                    microCta?: Array<
                        | { __typename?: "ContentPlatformCallToAction" }
                        | {
                              __typename?: "ContentPlatformCallToActionMicrocopy";
                              ctaMicrocopyTitle?: string | null;
                              ctaButtonText?: string | null;
                              ctaUrl?: string | null;
                          }
                    > | null;
                    highlightedFeaturesContainer?: Array<{
                        __typename?: "ContentPlatformHighlightedFeature";
                        highlightedFeatureDetails?: string | null;
                        highlightedFeatureTitleExternal?: string | null;
                        callOut?: string | null;
                    }> | null;
                }> | null;
            };
        }>;
    };
};

export const PricingPlanMicroCta = gql`
    fragment PricingPlanMicroCta on ContentPlatformCallToActionMicrocopy {
        ctaMicrocopyTitle
        ctaButtonText
        ctaUrl
    }
`;
export const PricingPlanHighlightedFeatureItem = gql`
    fragment PricingPlanHighlightedFeatureItem on ContentPlatformHighlightedFeature {
        highlightedFeatureDetails
        highlightedFeatureTitleExternal
        callOut
    }
`;
export const PricingPlanComparePlansItem = gql`
    fragment PricingPlanComparePlansItem on ContentPlatformPlan {
        planTitleExternal
        planOneLiner
        microCta {
            ...PricingPlanMicroCta
        }
        highlightedFeaturesTitle
        highlightedFeaturesContainer {
            ...PricingPlanHighlightedFeatureItem
        }
    }
    ${PricingPlanMicroCta}
    ${PricingPlanHighlightedFeatureItem}
`;
export const RelevantPlan = gql`
    fragment RelevantPlan on ContentPlatformPlan {
        planTitleExternal
    }
`;
export const FeatureAdditionalInformation = gql`
    fragment FeatureAdditionalInformation on ContentPlatformFeatureAdditionalInformation {
        featureAdditionalInformation
        relevantPlan {
            ...RelevantPlan
        }
    }
    ${RelevantPlan}
`;
export const PricingPlanCompareFeaturesItem = gql`
    fragment PricingPlanCompareFeaturesItem on ContentPlatformFeatureGroup {
        featureGroupTitleExternal
        features {
            callOut
            featureNameExternal
            description
            relevantPlan {
                ...RelevantPlan
            }
            relevantUrl
            featureAdditionalInformation {
                ...FeatureAdditionalInformation
            }
        }
    }
    ${RelevantPlan}
    ${FeatureAdditionalInformation}
`;
export const PricingPlanAdditionalFeaturesItem = gql`
    fragment PricingPlanAdditionalFeaturesItem on ContentPlatformPlanDetails {
        planAdditionalDetailsTitleExternal
        planAdditionalDetails
    }
`;
export const PricingPlanCallToActionItem = gql`
    fragment PricingPlanCallToActionItem on ContentPlatformCallToAction {
        title
        valueProposition
        text
        url
        asset {
            title
            description
            url
        }
    }
`;
export const PricingPlanCallToActionMicrocopyItem = gql`
    fragment PricingPlanCallToActionMicrocopyItem on ContentPlatformCallToActionMicrocopy {
        ctaMicrocopyTitle
        ctaButtonText
        ctaUrl
    }
`;
export const PricingPlan = gql`
    fragment PricingPlan on ContentPlatformPricing {
        pricingTitleInternal
        pricingTitleExternal
        pageDescription
        headline
        comparePlans {
            ...PricingPlanComparePlansItem
        }
        compareFeaturesTitle
        compareFeatures {
            ...PricingPlanCompareFeaturesItem
        }
        getMoreDetailsTitle
        additionalDetails {
            ...PricingPlanAdditionalFeaturesItem
        }
        relatedProduct {
            productName
            productNameId
        }
        callToActionContainer {
            ...PricingPlanCallToActionItem
            ...PricingPlanCallToActionMicrocopyItem
        }
        datacenterPlans {
            ...PricingPlanComparePlansItem
        }
    }
    ${PricingPlanComparePlansItem}
    ${PricingPlanCompareFeaturesItem}
    ${PricingPlanAdditionalFeaturesItem}
    ${PricingPlanCallToActionItem}
    ${PricingPlanCallToActionMicrocopyItem}
`;
export const PricingsResponse = gql`
    fragment PricingsResponse on ContentPlatformPricingSearchConnection {
        edges {
            node {
                ...PricingPlan
            }
        }
    }
    ${PricingPlan}
`;
export const Pricings = gql`
    query Pricings($search: ContentPlatformSearchAPIv2Query!) {
        pricings(search: $search) {
            ...PricingsResponse
        }
    }
    ${PricingsResponse}
`;
